
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1315"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1315"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hqDLR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cb03b711053a4297$export$2e2bcd8739ae039);
/**
 * @license
 * Video.js 8.23.4 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */ 
var $eDick = parcelRequire("eDick");

var $7pNCM = parcelRequire("7pNCM");

var $hPwoy = parcelRequire("hPwoy");

var $a4Nb0 = parcelRequire("a4Nb0");

var $3p9rK = parcelRequire("3p9rK");

var $5JQY5 = parcelRequire("5JQY5");

var $2306U = parcelRequire("2306U");

var $jv51Y = parcelRequire("jv51Y");

var $9Odq1 = parcelRequire("9Odq1");

var $6vzZz = parcelRequire("6vzZz");

var $1n4fv = parcelRequire("1n4fv");

var $aMGaR = parcelRequire("aMGaR");

var $bweXN = parcelRequire("bweXN");

var $bChVV = parcelRequire("bChVV");

var $3CkWK = parcelRequire("3CkWK");
var $cb03b711053a4297$var$version$6 = "8.23.4";
/**
 * An Object that contains lifecycle hooks as keys which point to an array
 * of functions that are run when a lifecycle is triggered
 *
 * @private
 */ const $cb03b711053a4297$var$hooks_ = {};
/**
 * Get a list of hooks for a specific lifecycle
 *
 * @param  {string} type
 *         the lifecycle to get hooks from
 *
 * @param  {Function|Function[]} [fn]
 *         Optionally add a hook (or hooks) to the lifecycle that your are getting.
 *
 * @return {Array}
 *         an array of hooks, or an empty array if there are none.
 */ const $cb03b711053a4297$var$hooks = function(type, fn) {
    $cb03b711053a4297$var$hooks_[type] = $cb03b711053a4297$var$hooks_[type] || [];
    if (fn) $cb03b711053a4297$var$hooks_[type] = $cb03b711053a4297$var$hooks_[type].concat(fn);
    return $cb03b711053a4297$var$hooks_[type];
};
/**
 * Add a function hook to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */ const $cb03b711053a4297$var$hook = function(type, fn) {
    $cb03b711053a4297$var$hooks(type, fn);
};
/**
 * Remove a hook from a specific videojs lifecycle.
 *
 * @param  {string} type
 *         the lifecycle that the function hooked to
 *
 * @param  {Function} fn
 *         The hooked function to remove
 *
 * @return {boolean}
 *         The function that was removed or undef
 */ const $cb03b711053a4297$var$removeHook = function(type, fn) {
    const index = $cb03b711053a4297$var$hooks(type).indexOf(fn);
    if (index <= -1) return false;
    $cb03b711053a4297$var$hooks_[type] = $cb03b711053a4297$var$hooks_[type].slice();
    $cb03b711053a4297$var$hooks_[type].splice(index, 1);
    return true;
};
/**
 * Add a function hook that will only run once to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */ const $cb03b711053a4297$var$hookOnce = function(type, fn) {
    $cb03b711053a4297$var$hooks(type, [].concat(fn).map((original)=>{
        const wrapper = (...args)=>{
            $cb03b711053a4297$var$removeHook(type, wrapper);
            return original(...args);
        };
        return wrapper;
    }));
};
/**
 * @file fullscreen-api.js
 * @module fullscreen-api
 */ /**
 * Store the browser-specific methods for the fullscreen API.
 *
 * @type {Object}
 * @see [Specification]{@link https://fullscreen.spec.whatwg.org}
 * @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
 */ const $cb03b711053a4297$var$FullscreenApi = {
    prefixed: true
};
// browser API methods
const $cb03b711053a4297$var$apiMap = [
    [
        'requestFullscreen',
        'exitFullscreen',
        'fullscreenElement',
        'fullscreenEnabled',
        'fullscreenchange',
        'fullscreenerror',
        'fullscreen'
    ],
    // WebKit
    [
        'webkitRequestFullscreen',
        'webkitExitFullscreen',
        'webkitFullscreenElement',
        'webkitFullscreenEnabled',
        'webkitfullscreenchange',
        'webkitfullscreenerror',
        '-webkit-full-screen'
    ]
];
const $cb03b711053a4297$var$specApi = $cb03b711053a4297$var$apiMap[0];
let $cb03b711053a4297$var$browserApi;
// determine the supported set of functions
for(let i = 0; i < $cb03b711053a4297$var$apiMap.length; i++)// check for exitFullscreen function
if ($cb03b711053a4297$var$apiMap[i][1] in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))) {
    $cb03b711053a4297$var$browserApi = $cb03b711053a4297$var$apiMap[i];
    break;
}
// map the browser API names to the spec API names
if ($cb03b711053a4297$var$browserApi) {
    for(let i = 0; i < $cb03b711053a4297$var$browserApi.length; i++)$cb03b711053a4297$var$FullscreenApi[$cb03b711053a4297$var$specApi[i]] = $cb03b711053a4297$var$browserApi[i];
    $cb03b711053a4297$var$FullscreenApi.prefixed = $cb03b711053a4297$var$browserApi[0] !== $cb03b711053a4297$var$specApi[0];
}
/**
 * @file create-logger.js
 * @module create-logger
 */ // This is the private tracking variable for the logging history.
let $cb03b711053a4297$var$history = [];
/**
 * Log messages to the console and history based on the type of message
 *
 * @private
 * @param  {string} name
 *         The name of the console method to use.
 *
 * @param  {Object} log
 *         The arguments to be passed to the matching console method.
 *
 * @param {string} [styles]
 *        styles for name
 */ const $cb03b711053a4297$var$LogByTypeFactory = (name, log, styles)=>(type, level, args)=>{
        const lvl = log.levels[level];
        const lvlRegExp = new RegExp(`^(${lvl})$`);
        let resultName = name;
        if (type !== 'log') // Add the type to the front of the message when it's not "log".
        args.unshift(type.toUpperCase() + ':');
        if (styles) {
            resultName = `%c${name}`;
            args.unshift(styles);
        }
        // Add console prefix after adding to history.
        args.unshift(resultName + ':');
        // Add a clone of the args at this point to history.
        if ($cb03b711053a4297$var$history) {
            $cb03b711053a4297$var$history.push([].concat(args));
            // only store 1000 history entries
            const splice = $cb03b711053a4297$var$history.length - 1000;
            $cb03b711053a4297$var$history.splice(0, splice > 0 ? splice : 0);
        }
        // If there's no console then don't try to output messages, but they will
        // still be stored in history.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console) return;
        // Was setting these once outside of this function, but containing them
        // in the function makes it easier to test cases where console doesn't exist
        // when the module is executed.
        let fn = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console[type];
        if (!fn && type === 'debug') // Certain browsers don't have support for console.debug. For those, we
        // should default to the closest comparable log.
        fn = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.info || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.log;
        // Bail out if there's no console or if this type is not allowed by the
        // current logging level.
        if (!fn || !lvl || !lvlRegExp.test(type)) return;
        fn[Array.isArray(args) ? 'apply' : 'call']((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console, args);
    };
function $cb03b711053a4297$var$createLogger$1(name, delimiter = ':', styles = '') {
    // This is the private tracking variable for logging level.
    let level = 'info';
    // the curried logByType bound to the specific log and history
    let logByType;
    /**
   * Logs plain debug messages. Similar to `console.log`.
   *
   * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
   * of our JSDoc template, we cannot properly document this as both a function
   * and a namespace, so its function signature is documented here.
   *
   * #### Arguments
   * ##### *args
   * *[]
   *
   * Any combination of values that could be passed to `console.log()`.
   *
   * #### Return Value
   *
   * `undefined`
   *
   * @namespace
   * @param    {...*} args
   *           One or more messages or objects that should be logged.
   */ function log(...args) {
        logByType('log', level, args);
    }
    // This is the logByType helper that the logging methods below use
    logByType = $cb03b711053a4297$var$LogByTypeFactory(name, log, styles);
    /**
   * Create a new subLogger which chains the old name to the new name.
   *
   * For example, doing `mylogger = videojs.log.createLogger('player')` and then using that logger will log the following:
   * ```js
   *  mylogger('foo');
   *  // > VIDEOJS: player: foo
   * ```
   *
   * @param {string} subName
   *        The name to add call the new logger
   * @param {string} [subDelimiter]
   *        Optional delimiter
   * @param {string} [subStyles]
   *        Optional styles
   * @return {Object}
   */ log.createLogger = (subName, subDelimiter, subStyles)=>{
        const resultDelimiter = subDelimiter !== undefined ? subDelimiter : delimiter;
        const resultStyles = subStyles !== undefined ? subStyles : styles;
        const resultName = `${name} ${resultDelimiter} ${subName}`;
        return $cb03b711053a4297$var$createLogger$1(resultName, resultDelimiter, resultStyles);
    };
    /**
   * Create a new logger.
   *
   * @param {string} newName
   *        The name for the new logger
   * @param {string} [newDelimiter]
   *        Optional delimiter
   * @param {string} [newStyles]
   *        Optional styles
   * @return {Object}
   */ log.createNewLogger = (newName, newDelimiter, newStyles)=>{
        return $cb03b711053a4297$var$createLogger$1(newName, newDelimiter, newStyles);
    };
    /**
   * Enumeration of available logging levels, where the keys are the level names
   * and the values are `|`-separated strings containing logging methods allowed
   * in that logging level. These strings are used to create a regular expression
   * matching the function name being called.
   *
   * Levels provided by Video.js are:
   *
   * - `off`: Matches no calls. Any value that can be cast to `false` will have
   *   this effect. The most restrictive.
   * - `all`: Matches only Video.js-provided functions (`debug`, `log`,
   *   `log.warn`, and `log.error`).
   * - `debug`: Matches `log.debug`, `log`, `log.warn`, and `log.error` calls.
   * - `info` (default): Matches `log`, `log.warn`, and `log.error` calls.
   * - `warn`: Matches `log.warn` and `log.error` calls.
   * - `error`: Matches only `log.error` calls.
   *
   * @type {Object}
   */ log.levels = {
        all: 'debug|log|warn|error',
        off: '',
        debug: 'debug|log|warn|error',
        info: 'log|warn|error',
        warn: 'warn|error',
        error: 'error',
        DEFAULT: level
    };
    /**
   * Get or set the current logging level.
   *
   * If a string matching a key from {@link module:log.levels} is provided, acts
   * as a setter.
   *
   * @param  {'all'|'debug'|'info'|'warn'|'error'|'off'} [lvl]
   *         Pass a valid level to set a new logging level.
   *
   * @return {string}
   *         The current logging level.
   */ log.level = (lvl)=>{
        if (typeof lvl === 'string') {
            if (!log.levels.hasOwnProperty(lvl)) throw new Error(`"${lvl}" in not a valid log level`);
            level = lvl;
        }
        return level;
    };
    /**
   * Returns an array containing everything that has been logged to the history.
   *
   * This array is a shallow clone of the internal history record. However, its
   * contents are _not_ cloned; so, mutating objects inside this array will
   * mutate them in history.
   *
   * @return {Array}
   */ log.history = ()=>$cb03b711053a4297$var$history ? [].concat($cb03b711053a4297$var$history) : [];
    /**
   * Allows you to filter the history by the given logger name
   *
   * @param {string} fname
   *        The name to filter by
   *
   * @return {Array}
   *         The filtered list to return
   */ log.history.filter = (fname)=>{
        return ($cb03b711053a4297$var$history || []).filter((historyItem)=>{
            // if the first item in each historyItem includes `fname`, then it's a match
            return new RegExp(`.*${fname}.*`).test(historyItem[0]);
        });
    };
    /**
   * Clears the internal history tracking, but does not prevent further history
   * tracking.
   */ log.history.clear = ()=>{
        if ($cb03b711053a4297$var$history) $cb03b711053a4297$var$history.length = 0;
    };
    /**
   * Disable history tracking if it is currently enabled.
   */ log.history.disable = ()=>{
        if ($cb03b711053a4297$var$history !== null) {
            $cb03b711053a4297$var$history.length = 0;
            $cb03b711053a4297$var$history = null;
        }
    };
    /**
   * Enable history tracking if it is currently disabled.
   */ log.history.enable = ()=>{
        if ($cb03b711053a4297$var$history === null) $cb03b711053a4297$var$history = [];
    };
    /**
   * Logs error messages. Similar to `console.error`.
   *
   * @param {...*} args
   *        One or more messages or objects that should be logged as an error
   */ log.error = (...args)=>logByType('error', level, args);
    /**
   * Logs warning messages. Similar to `console.warn`.
   *
   * @param {...*} args
   *        One or more messages or objects that should be logged as a warning.
   */ log.warn = (...args)=>logByType('warn', level, args);
    /**
   * Logs debug messages. Similar to `console.debug`, but may also act as a comparable
   * log if `console.debug` is not available
   *
   * @param {...*} args
   *        One or more messages or objects that should be logged as debug.
   */ log.debug = (...args)=>logByType('debug', level, args);
    return log;
}
/**
 * @file log.js
 * @module log
 */ const $cb03b711053a4297$var$log$1 = $cb03b711053a4297$var$createLogger$1('VIDEOJS');
const $cb03b711053a4297$var$createLogger = $cb03b711053a4297$var$log$1.createLogger;
/**
 * @file obj.js
 * @module obj
 */ /**
 * @callback obj:EachCallback
 *
 * @param {*} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 */ /**
 * @callback obj:ReduceCallback
 *
 * @param {*} accum
 *        The value that is accumulating over the reduce loop.
 *
 * @param {*} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 *
 * @return {*}
 *         The new accumulated value.
 */ const $cb03b711053a4297$var$toString = Object.prototype.toString;
/**
 * Get the keys of an Object
 *
 * @param {Object}
 *        The Object to get the keys from
 *
 * @return {string[]}
 *         An array of the keys from the object. Returns an empty array if the
 *         object passed in was invalid or had no keys.
 *
 * @private
 */ const $cb03b711053a4297$var$keys = function(object) {
    return $cb03b711053a4297$var$isObject(object) ? Object.keys(object) : [];
};
/**
 * Array-like iteration for objects.
 *
 * @param {Object} object
 *        The object to iterate over
 *
 * @param {obj:EachCallback} fn
 *        The callback function which is called for each key in the object.
 */ function $cb03b711053a4297$var$each(object, fn) {
    $cb03b711053a4297$var$keys(object).forEach((key)=>fn(object[key], key));
}
/**
 * Array-like reduce for objects.
 *
 * @param {Object} object
 *        The Object that you want to reduce.
 *
 * @param {Function} fn
 *         A callback function which is called for each key in the object. It
 *         receives the accumulated value and the per-iteration value and key
 *         as arguments.
 *
 * @param {*} [initial = 0]
 *        Starting value
 *
 * @return {*}
 *         The final accumulated value.
 */ function $cb03b711053a4297$var$reduce(object, fn, initial = 0) {
    return $cb03b711053a4297$var$keys(object).reduce((accum, key)=>fn(accum, object[key], key), initial);
}
/**
 * Returns whether a value is an object of any kind - including DOM nodes,
 * arrays, regular expressions, etc. Not functions, though.
 *
 * This avoids the gotcha where using `typeof` on a `null` value
 * results in `'object'`.
 *
 * @param  {Object} value
 * @return {boolean}
 */ function $cb03b711053a4297$var$isObject(value) {
    return !!value && typeof value === 'object';
}
/**
 * Returns whether an object appears to be a "plain" object - that is, a
 * direct instance of `Object`.
 *
 * @param  {Object} value
 * @return {boolean}
 */ function $cb03b711053a4297$var$isPlain(value) {
    return $cb03b711053a4297$var$isObject(value) && $cb03b711053a4297$var$toString.call(value) === '[object Object]' && value.constructor === Object;
}
/**
 * Merge two objects recursively.
 *
 * Performs a deep merge like
 * {@link https://lodash.com/docs/4.17.10#merge|lodash.merge}, but only merges
 * plain objects (not arrays, elements, or anything else).
 *
 * Non-plain object values will be copied directly from the right-most
 * argument.
 *
 * @param   {Object[]} sources
 *          One or more objects to merge into a new object.
 *
 * @return {Object}
 *          A new object that is the merged result of all sources.
 */ function $cb03b711053a4297$var$merge$1(...sources) {
    const result = {};
    sources.forEach((source)=>{
        if (!source) return;
        $cb03b711053a4297$var$each(source, (value, key)=>{
            if (!$cb03b711053a4297$var$isPlain(value)) {
                result[key] = value;
                return;
            }
            if (!$cb03b711053a4297$var$isPlain(result[key])) result[key] = {};
            result[key] = $cb03b711053a4297$var$merge$1(result[key], value);
        });
    });
    return result;
}
/**
 * Returns an array of values for a given object
 *
 * @param  {Object} source - target object
 * @return {Array<unknown>} - object values
 */ function $cb03b711053a4297$var$values(source = {}) {
    const result = [];
    for(const key in source)if (source.hasOwnProperty(key)) {
        const value = source[key];
        result.push(value);
    }
    return result;
}
/**
 * Object.defineProperty but "lazy", which means that the value is only set after
 * it is retrieved the first time, rather than being set right away.
 *
 * @param {Object} obj the object to set the property on
 * @param {string} key the key for the property to set
 * @param {Function} getValue the function used to get the value when it is needed.
 * @param {boolean} setter whether a setter should be allowed or not
 */ function $cb03b711053a4297$var$defineLazyProperty(obj, key, getValue, setter = true) {
    const set = (value)=>Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            writable: true
        });
    const options = {
        configurable: true,
        enumerable: true,
        get () {
            const value = getValue();
            set(value);
            return value;
        }
    };
    if (setter) options.set = set;
    return Object.defineProperty(obj, key, options);
}
var $cb03b711053a4297$var$Obj = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    each: $cb03b711053a4297$var$each,
    reduce: $cb03b711053a4297$var$reduce,
    isObject: $cb03b711053a4297$var$isObject,
    isPlain: $cb03b711053a4297$var$isPlain,
    merge: $cb03b711053a4297$var$merge$1,
    values: $cb03b711053a4297$var$values,
    defineLazyProperty: $cb03b711053a4297$var$defineLazyProperty
});
/**
 * @file browser.js
 * @module browser
 */ /**
 * Whether or not this device is an iPod.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_IPOD = false;
/**
 * The detected iOS version - or `null`.
 *
 * @static
 * @type {string|null}
 */ let $cb03b711053a4297$var$IOS_VERSION = null;
/**
 * Whether or not this is an Android device.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_ANDROID = false;
/**
 * The detected Android version - or `null` if not Android or indeterminable.
 *
 * @static
 * @type {number|string|null}
 */ let $cb03b711053a4297$var$ANDROID_VERSION;
/**
 * Whether or not this is Mozilla Firefox.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_FIREFOX = false;
/**
 * Whether or not this is Microsoft Edge.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_EDGE = false;
/**
 * Whether or not this is any Chromium Browser
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_CHROMIUM = false;
/**
 * Whether or not this is any Chromium browser that is not Edge.
 *
 * This will also be `true` for Chrome on iOS, which will have different support
 * as it is actually Safari under the hood.
 *
 * Deprecated, as the behaviour to not match Edge was to prevent Legacy Edge's UA matching.
 * IS_CHROMIUM should be used instead.
 * "Chromium but not Edge" could be explicitly tested with IS_CHROMIUM && !IS_EDGE
 *
 * @static
 * @deprecated
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_CHROME = false;
/**
 * The detected Chromium version - or `null`.
 *
 * @static
 * @type {number|null}
 */ let $cb03b711053a4297$var$CHROMIUM_VERSION = null;
/**
 * The detected Google Chrome version - or `null`.
 * This has always been the _Chromium_ version, i.e. would return on Chromium Edge.
 * Deprecated, use CHROMIUM_VERSION instead.
 *
 * @static
 * @deprecated
 * @type {number|null}
 */ let $cb03b711053a4297$var$CHROME_VERSION = null;
/**
 * Whether or not this is a Chromecast receiver application.
 *
 * @static
 * @type {Boolean}
 */ const $cb03b711053a4297$var$IS_CHROMECAST_RECEIVER = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).cast && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).cast.framework && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).cast.framework.CastReceiverContext);
/**
 * The detected Internet Explorer version - or `null`.
 *
 * @static
 * @deprecated
 * @type {number|null}
 */ let $cb03b711053a4297$var$IE_VERSION = null;
/**
 * Whether or not this is desktop Safari.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_SAFARI = false;
/**
 * Whether or not this is a Windows machine.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_WINDOWS = false;
/**
 * Whether or not this device is an iPad.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_IPAD = false;
/**
 * Whether or not this device is an iPhone.
 *
 * @static
 * @type {Boolean}
 */ // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
let $cb03b711053a4297$var$IS_IPHONE = false;
/**
 * Whether or not this is a Tizen device.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_TIZEN = false;
/**
 * Whether or not this is a WebOS device.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_WEBOS = false;
/**
 * Whether or not this is a Smart TV (Tizen or WebOS) device.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_SMART_TV = false;
/**
 * Whether or not this device is touch-enabled.
 *
 * @static
 * @const
 * @type {Boolean}
 */ const $cb03b711053a4297$var$TOUCH_ENABLED = Boolean($cb03b711053a4297$var$isReal() && ('ontouchstart' in (0, (/*@__PURE__*/$parcel$interopDefault($eDick))) || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.maxTouchPoints || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).DocumentTouch && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).document instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).DocumentTouch));
const $cb03b711053a4297$var$UAD = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.userAgentData;
if ($cb03b711053a4297$var$UAD && $cb03b711053a4297$var$UAD.platform && $cb03b711053a4297$var$UAD.brands) {
    // If userAgentData is present, use it instead of userAgent to avoid warnings
    // Currently only implemented on Chromium
    // userAgentData does not expose Android version, so ANDROID_VERSION remains `null`
    $cb03b711053a4297$var$IS_ANDROID = $cb03b711053a4297$var$UAD.platform === 'Android';
    $cb03b711053a4297$var$IS_EDGE = Boolean($cb03b711053a4297$var$UAD.brands.find((b)=>b.brand === 'Microsoft Edge'));
    $cb03b711053a4297$var$IS_CHROMIUM = Boolean($cb03b711053a4297$var$UAD.brands.find((b)=>b.brand === 'Chromium'));
    $cb03b711053a4297$var$IS_CHROME = !$cb03b711053a4297$var$IS_EDGE && $cb03b711053a4297$var$IS_CHROMIUM;
    $cb03b711053a4297$var$CHROMIUM_VERSION = $cb03b711053a4297$var$CHROME_VERSION = ($cb03b711053a4297$var$UAD.brands.find((b)=>b.brand === 'Chromium') || {}).version || null;
    $cb03b711053a4297$var$IS_WINDOWS = $cb03b711053a4297$var$UAD.platform === 'Windows';
}
// If the browser is not Chromium, either userAgentData is not present which could be an old Chromium browser,
//  or it's a browser that has added userAgentData since that we don't have tests for yet. In either case,
// the checks need to be made agiainst the regular userAgent string.
if (!$cb03b711053a4297$var$IS_CHROMIUM) {
    const USER_AGENT = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.userAgent || '';
    $cb03b711053a4297$var$IS_IPOD = /iPod/i.test(USER_AGENT);
    $cb03b711053a4297$var$IOS_VERSION = function() {
        const match = USER_AGENT.match(/OS (\d+)_/i);
        if (match && match[1]) return match[1];
        return null;
    }();
    $cb03b711053a4297$var$IS_ANDROID = /Android/i.test(USER_AGENT);
    $cb03b711053a4297$var$ANDROID_VERSION = function() {
        // This matches Android Major.Minor.Patch versions
        // ANDROID_VERSION is Major.Minor as a Number, if Minor isn't available, then only Major is returned
        const match = USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
        if (!match) return null;
        const major = match[1] && parseFloat(match[1]);
        const minor = match[2] && parseFloat(match[2]);
        if (major && minor) return parseFloat(match[1] + '.' + match[2]);
        else if (major) return major;
        return null;
    }();
    $cb03b711053a4297$var$IS_FIREFOX = /Firefox/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_EDGE = /Edg/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_CHROMIUM = /Chrome/i.test(USER_AGENT) || /CriOS/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_CHROME = !$cb03b711053a4297$var$IS_EDGE && $cb03b711053a4297$var$IS_CHROMIUM;
    $cb03b711053a4297$var$CHROMIUM_VERSION = $cb03b711053a4297$var$CHROME_VERSION = function() {
        const match = USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);
        if (match && match[2]) return parseFloat(match[2]);
        return null;
    }();
    $cb03b711053a4297$var$IE_VERSION = function() {
        const result = /MSIE\s(\d+)\.\d/.exec(USER_AGENT);
        let version = result && parseFloat(result[1]);
        if (!version && /Trident\/7.0/i.test(USER_AGENT) && /rv:11.0/.test(USER_AGENT)) // IE 11 has a different user agent string than other IE versions
        version = 11.0;
        return version;
    }();
    $cb03b711053a4297$var$IS_TIZEN = /Tizen/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_WEBOS = /Web0S/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_SMART_TV = $cb03b711053a4297$var$IS_TIZEN || $cb03b711053a4297$var$IS_WEBOS;
    $cb03b711053a4297$var$IS_SAFARI = /Safari/i.test(USER_AGENT) && !$cb03b711053a4297$var$IS_CHROME && !$cb03b711053a4297$var$IS_ANDROID && !$cb03b711053a4297$var$IS_EDGE && !$cb03b711053a4297$var$IS_SMART_TV;
    $cb03b711053a4297$var$IS_WINDOWS = /Windows/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_IPAD = /iPad/i.test(USER_AGENT) || $cb03b711053a4297$var$IS_SAFARI && $cb03b711053a4297$var$TOUCH_ENABLED && !/iPhone/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_IPHONE = /iPhone/i.test(USER_AGENT) && !$cb03b711053a4297$var$IS_IPAD;
}
/**
 * Whether or not this is an iOS device.
 *
 * @static
 * @const
 * @type {Boolean}
 */ const $cb03b711053a4297$var$IS_IOS = $cb03b711053a4297$var$IS_IPHONE || $cb03b711053a4297$var$IS_IPAD || $cb03b711053a4297$var$IS_IPOD;
/**
 * Whether or not this is any flavor of Safari - including iOS.
 *
 * @static
 * @const
 * @type {Boolean}
 */ const $cb03b711053a4297$var$IS_ANY_SAFARI = ($cb03b711053a4297$var$IS_SAFARI || $cb03b711053a4297$var$IS_IOS) && !$cb03b711053a4297$var$IS_CHROME;
var $cb03b711053a4297$var$browser = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    get IS_IPOD () {
        return $cb03b711053a4297$var$IS_IPOD;
    },
    get IOS_VERSION () {
        return $cb03b711053a4297$var$IOS_VERSION;
    },
    get IS_ANDROID () {
        return $cb03b711053a4297$var$IS_ANDROID;
    },
    get ANDROID_VERSION () {
        return $cb03b711053a4297$var$ANDROID_VERSION;
    },
    get IS_FIREFOX () {
        return $cb03b711053a4297$var$IS_FIREFOX;
    },
    get IS_EDGE () {
        return $cb03b711053a4297$var$IS_EDGE;
    },
    get IS_CHROMIUM () {
        return $cb03b711053a4297$var$IS_CHROMIUM;
    },
    get IS_CHROME () {
        return $cb03b711053a4297$var$IS_CHROME;
    },
    get CHROMIUM_VERSION () {
        return $cb03b711053a4297$var$CHROMIUM_VERSION;
    },
    get CHROME_VERSION () {
        return $cb03b711053a4297$var$CHROME_VERSION;
    },
    IS_CHROMECAST_RECEIVER: $cb03b711053a4297$var$IS_CHROMECAST_RECEIVER,
    get IE_VERSION () {
        return $cb03b711053a4297$var$IE_VERSION;
    },
    get IS_SAFARI () {
        return $cb03b711053a4297$var$IS_SAFARI;
    },
    get IS_WINDOWS () {
        return $cb03b711053a4297$var$IS_WINDOWS;
    },
    get IS_IPAD () {
        return $cb03b711053a4297$var$IS_IPAD;
    },
    get IS_IPHONE () {
        return $cb03b711053a4297$var$IS_IPHONE;
    },
    get IS_TIZEN () {
        return $cb03b711053a4297$var$IS_TIZEN;
    },
    get IS_WEBOS () {
        return $cb03b711053a4297$var$IS_WEBOS;
    },
    get IS_SMART_TV () {
        return $cb03b711053a4297$var$IS_SMART_TV;
    },
    TOUCH_ENABLED: $cb03b711053a4297$var$TOUCH_ENABLED,
    IS_IOS: $cb03b711053a4297$var$IS_IOS,
    IS_ANY_SAFARI: $cb03b711053a4297$var$IS_ANY_SAFARI
});
/**
 * @file dom.js
 * @module dom
 */ /**
 * Detect if a value is a string with any non-whitespace characters.
 *
 * @private
 * @param  {string} str
 *         The string to check
 *
 * @return {boolean}
 *         Will be `true` if the string is non-blank, `false` otherwise.
 *
 */ function $cb03b711053a4297$var$isNonBlankString(str) {
    // we use str.trim as it will trim any whitespace characters
    // from the front or back of non-whitespace characters. aka
    // Any string that contains non-whitespace characters will
    // still contain them after `trim` but whitespace only strings
    // will have a length of 0, failing this check.
    return typeof str === 'string' && Boolean(str.trim());
}
/**
 * Throws an error if the passed string has whitespace. This is used by
 * class methods to be relatively consistent with the classList API.
 *
 * @private
 * @param  {string} str
 *         The string to check for whitespace.
 *
 * @throws {Error}
 *         Throws an error if there is whitespace in the string.
 */ function $cb03b711053a4297$var$throwIfWhitespace(str) {
    // str.indexOf instead of regex because str.indexOf is faster performance wise.
    if (str.indexOf(' ') >= 0) throw new Error('class has illegal whitespace characters');
}
/**
 * Whether the current DOM interface appears to be real (i.e. not simulated).
 *
 * @return {boolean}
 *         Will be `true` if the DOM appears to be real, `false` otherwise.
 */ function $cb03b711053a4297$var$isReal() {
    // Both document and window will never be undefined thanks to `global`.
    return (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) === (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).document;
}
/**
 * Determines, via duck typing, whether or not a value is a DOM element.
 *
 * @param  {*} value
 *         The value to check.
 *
 * @return {boolean}
 *         Will be `true` if the value is a DOM element, `false` otherwise.
 */ function $cb03b711053a4297$var$isEl(value) {
    return $cb03b711053a4297$var$isObject(value) && value.nodeType === 1;
}
/**
 * Determines if the current DOM is embedded in an iframe.
 *
 * @return {boolean}
 *         Will be `true` if the DOM is embedded in an iframe, `false`
 *         otherwise.
 */ function $cb03b711053a4297$var$isInFrame() {
    // We need a try/catch here because Safari will throw errors when attempting
    // to get either `parent` or `self`
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).parent !== (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).self;
    } catch (x) {
        return true;
    }
}
/**
 * Creates functions to query the DOM using a given method.
 *
 * @private
 * @param   {string} method
 *          The method to create the query with.
 *
 * @return  {Function}
 *          The query method
 */ function $cb03b711053a4297$var$createQuerier(method) {
    return function(selector, context) {
        if (!$cb03b711053a4297$var$isNonBlankString(selector)) return (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[method](null);
        if ($cb03b711053a4297$var$isNonBlankString(context)) context = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).querySelector(context);
        const ctx = $cb03b711053a4297$var$isEl(context) ? context : (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)));
        return ctx[method] && ctx[method](selector);
    };
}
/**
 * Creates an element and applies properties, attributes, and inserts content.
 *
 * @param  {string} [tagName='div']
 *         Name of tag to be created.
 *
 * @param  {Object} [properties={}]
 *         Element properties to be applied.
 *
 * @param  {Object} [attributes={}]
 *         Element attributes to be applied.
 *
 * @param {ContentDescriptor} [content]
 *        A content descriptor object.
 *
 * @return {Element}
 *         The element that was created.
 */ function $cb03b711053a4297$var$createEl(tagName = 'div', properties = {}, attributes = {}, content) {
    const el = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement(tagName);
    Object.getOwnPropertyNames(properties).forEach(function(propName) {
        const val = properties[propName];
        // Handle textContent since it's not supported everywhere and we have a
        // method for it.
        if (propName === 'textContent') $cb03b711053a4297$var$textContent(el, val);
        else if (el[propName] !== val || propName === 'tabIndex') el[propName] = val;
    });
    Object.getOwnPropertyNames(attributes).forEach(function(attrName) {
        el.setAttribute(attrName, attributes[attrName]);
    });
    if (content) $cb03b711053a4297$var$appendContent(el, content);
    return el;
}
/**
 * Injects text into an element, replacing any existing contents entirely.
 *
 * @param  {HTMLElement} el
 *         The element to add text content into
 *
 * @param  {string} text
 *         The text content to add.
 *
 * @return {Element}
 *         The element with added text content.
 */ function $cb03b711053a4297$var$textContent(el, text) {
    if (typeof el.textContent === 'undefined') el.innerText = text;
    else el.textContent = text;
    return el;
}
/**
 * Insert an element as the first child node of another
 *
 * @param {Element} child
 *        Element to insert
 *
 * @param {Element} parent
 *        Element to insert child into
 */ function $cb03b711053a4297$var$prependTo(child, parent) {
    if (parent.firstChild) parent.insertBefore(child, parent.firstChild);
    else parent.appendChild(child);
}
/**
 * Check if an element has a class name.
 *
 * @param  {Element} element
 *         Element to check
 *
 * @param  {string} classToCheck
 *         Class name to check for
 *
 * @return {boolean}
 *         Will be `true` if the element has a class, `false` otherwise.
 *
 * @throws {Error}
 *         Throws an error if `classToCheck` has white space.
 */ function $cb03b711053a4297$var$hasClass(element, classToCheck) {
    $cb03b711053a4297$var$throwIfWhitespace(classToCheck);
    return element.classList.contains(classToCheck);
}
/**
 * Add a class name to an element.
 *
 * @param  {Element} element
 *         Element to add class name to.
 *
 * @param  {...string} classesToAdd
 *         One or more class name to add.
 *
 * @return {Element}
 *         The DOM element with the added class name.
 */ function $cb03b711053a4297$var$addClass(element, ...classesToAdd) {
    element.classList.add(...classesToAdd.reduce((prev, current)=>prev.concat(current.split(/\s+/)), []));
    return element;
}
/**
 * Remove a class name from an element.
 *
 * @param  {Element} element
 *         Element to remove a class name from.
 *
 * @param  {...string} classesToRemove
 *         One or more class name to remove.
 *
 * @return {Element}
 *         The DOM element with class name removed.
 */ function $cb03b711053a4297$var$removeClass(element, ...classesToRemove) {
    // Protect in case the player gets disposed
    if (!element) {
        $cb03b711053a4297$var$log$1.warn("removeClass was called with an element that doesn't exist");
        return null;
    }
    element.classList.remove(...classesToRemove.reduce((prev, current)=>prev.concat(current.split(/\s+/)), []));
    return element;
}
/**
 * The callback definition for toggleClass.
 *
 * @callback PredicateCallback
 * @param    {Element} element
 *           The DOM element of the Component.
 *
 * @param    {string} classToToggle
 *           The `className` that wants to be toggled
 *
 * @return   {boolean|undefined}
 *           If `true` is returned, the `classToToggle` will be added to the
 *           `element`, but not removed. If `false`, the `classToToggle` will be removed from
 *           the `element`, but not added. If `undefined`, the callback will be ignored.
 *
 */ /**
 * Adds or removes a class name to/from an element depending on an optional
 * condition or the presence/absence of the class name.
 *
 * @param  {Element} element
 *         The element to toggle a class name on.
 *
 * @param  {string} classToToggle
 *         The class that should be toggled.
 *
 * @param  {boolean|PredicateCallback} [predicate]
 *         See the return value for {@link module:dom~PredicateCallback}
 *
 * @return {Element}
 *         The element with a class that has been toggled.
 */ function $cb03b711053a4297$var$toggleClass(element, classToToggle, predicate) {
    if (typeof predicate === 'function') predicate = predicate(element, classToToggle);
    if (typeof predicate !== 'boolean') predicate = undefined;
    classToToggle.split(/\s+/).forEach((className)=>element.classList.toggle(className, predicate));
    return element;
}
/**
 * Apply attributes to an HTML element.
 *
 * @param {Element} el
 *        Element to add attributes to.
 *
 * @param {Object} [attributes]
 *        Attributes to be applied.
 */ function $cb03b711053a4297$var$setAttributes(el, attributes) {
    Object.getOwnPropertyNames(attributes).forEach(function(attrName) {
        const attrValue = attributes[attrName];
        if (attrValue === null || typeof attrValue === 'undefined' || attrValue === false) el.removeAttribute(attrName);
        else el.setAttribute(attrName, attrValue === true ? '' : attrValue);
    });
}
/**
 * Get an element's attribute values, as defined on the HTML tag.
 *
 * Attributes are not the same as properties. They're defined on the tag
 * or with setAttribute.
 *
 * @param  {Element} tag
 *         Element from which to get tag attributes.
 *
 * @return {Object}
 *         All attributes of the element. Boolean attributes will be `true` or
 *         `false`, others will be strings.
 */ function $cb03b711053a4297$var$getAttributes(tag) {
    const obj = {};
    // known boolean attributes
    // we can check for matching boolean properties, but not all browsers
    // and not all tags know about these attributes, so, we still want to check them manually
    const knownBooleans = [
        'autoplay',
        'controls',
        'playsinline',
        'loop',
        'muted',
        'default',
        'defaultMuted'
    ];
    if (tag && tag.attributes && tag.attributes.length > 0) {
        const attrs = tag.attributes;
        for(let i = attrs.length - 1; i >= 0; i--){
            const attrName = attrs[i].name;
            /** @type {boolean|string} */ let attrVal = attrs[i].value;
            // check for known booleans
            // the matching element property will return a value for typeof
            if (knownBooleans.includes(attrName)) // the value of an included boolean attribute is typically an empty
            // string ('') which would equal false if we just check for a false value.
            // we also don't want support bad code like autoplay='false'
            attrVal = attrVal !== null ? true : false;
            obj[attrName] = attrVal;
        }
    }
    return obj;
}
/**
 * Get the value of an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to get the value of.
 *
 * @return {string}
 *         The value of the attribute.
 */ function $cb03b711053a4297$var$getAttribute(el, attribute) {
    return el.getAttribute(attribute);
}
/**
 * Set the value of an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to set.
 *
 * @param {string} value
 *        Value to set the attribute to.
 */ function $cb03b711053a4297$var$setAttribute(el, attribute, value) {
    el.setAttribute(attribute, value);
}
/**
 * Remove an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to remove.
 */ function $cb03b711053a4297$var$removeAttribute(el, attribute) {
    el.removeAttribute(attribute);
}
/**
 * Attempt to block the ability to select text.
 */ function $cb03b711053a4297$var$blockTextSelection() {
    (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).body.focus();
    (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).onselectstart = function() {
        return false;
    };
}
/**
 * Turn off text selection blocking.
 */ function $cb03b711053a4297$var$unblockTextSelection() {
    (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).onselectstart = function() {
        return true;
    };
}
/**
 * Identical to the native `getBoundingClientRect` function, but ensures that
 * the method is supported at all (it is in all browsers we claim to support)
 * and that the element is in the DOM before continuing.
 *
 * This wrapper function also shims properties which are not provided by some
 * older browsers (namely, IE8).
 *
 * Additionally, some browsers do not support adding properties to a
 * `ClientRect`/`DOMRect` object; so, we shallow-copy it with the standard
 * properties (except `x` and `y` which are not widely supported). This helps
 * avoid implementations where keys are non-enumerable.
 *
 * @param  {Element} el
 *         Element whose `ClientRect` we want to calculate.
 *
 * @return {Object|undefined}
 *         Always returns a plain object - or `undefined` if it cannot.
 */ function $cb03b711053a4297$var$getBoundingClientRect(el) {
    if (el && el.getBoundingClientRect && el.parentNode) {
        const rect = el.getBoundingClientRect();
        const result = {};
        [
            'bottom',
            'height',
            'left',
            'right',
            'top',
            'width'
        ].forEach((k)=>{
            if (rect[k] !== undefined) result[k] = rect[k];
        });
        if (!result.height) result.height = parseFloat($cb03b711053a4297$var$computedStyle(el, 'height'));
        if (!result.width) result.width = parseFloat($cb03b711053a4297$var$computedStyle(el, 'width'));
        return result;
    }
}
/**
 * Represents the position of a DOM element on the page.
 *
 * @typedef  {Object} module:dom~Position
 *
 * @property {number} left
 *           Pixels to the left.
 *
 * @property {number} top
 *           Pixels from the top.
 */ /**
 * Get the position of an element in the DOM.
 *
 * Uses `getBoundingClientRect` technique from John Resig.
 *
 * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @param  {Element} el
 *         Element from which to get offset.
 *
 * @return {module:dom~Position}
 *         The position of the element that was passed in.
 */ function $cb03b711053a4297$var$findPosition(el) {
    if (!el || el && !el.offsetParent) return {
        left: 0,
        top: 0,
        width: 0,
        height: 0
    };
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    let left = 0;
    let top = 0;
    while(el.offsetParent && el !== (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[$cb03b711053a4297$var$FullscreenApi.fullscreenElement]){
        left += el.offsetLeft;
        top += el.offsetTop;
        el = el.offsetParent;
    }
    return {
        left: left,
        top: top,
        width: width,
        height: height
    };
}
/**
 * Represents x and y coordinates for a DOM element or mouse pointer.
 *
 * @typedef  {Object} module:dom~Coordinates
 *
 * @property {number} x
 *           x coordinate in pixels
 *
 * @property {number} y
 *           y coordinate in pixels
 */ /**
 * Get the pointer position within an element.
 *
 * The base on the coordinates are the bottom left of the element.
 *
 * @param  {Element} el
 *         Element on which to get the pointer position on.
 *
 * @param  {Event} event
 *         Event object.
 *
 * @return {module:dom~Coordinates}
 *         A coordinates object corresponding to the mouse position.
 *
 */ function $cb03b711053a4297$var$getPointerPosition(el, event) {
    const translated = {
        x: 0,
        y: 0
    };
    if ($cb03b711053a4297$var$IS_IOS) {
        let item = el;
        while(item && item.nodeName.toLowerCase() !== 'html'){
            const transform = $cb03b711053a4297$var$computedStyle(item, 'transform');
            if (/^matrix/.test(transform)) {
                const values = transform.slice(7, -1).split(/,\s/).map(Number);
                translated.x += values[4];
                translated.y += values[5];
            } else if (/^matrix3d/.test(transform)) {
                const values = transform.slice(9, -1).split(/,\s/).map(Number);
                translated.x += values[12];
                translated.y += values[13];
            }
            if (item.assignedSlot && item.assignedSlot.parentElement && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebKitCSSMatrix) {
                const transformValue = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).getComputedStyle(item.assignedSlot.parentElement).transform;
                const matrix = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebKitCSSMatrix(transformValue);
                translated.x += matrix.m41;
                translated.y += matrix.m42;
            }
            item = item.parentNode || item.host;
        }
    }
    const position = {};
    const boxTarget = $cb03b711053a4297$var$findPosition(event.target);
    const box = $cb03b711053a4297$var$findPosition(el);
    const boxW = box.width;
    const boxH = box.height;
    let offsetY = event.offsetY - (box.top - boxTarget.top);
    let offsetX = event.offsetX - (box.left - boxTarget.left);
    if (event.changedTouches) {
        offsetX = event.changedTouches[0].pageX - box.left;
        offsetY = event.changedTouches[0].pageY + box.top;
        if ($cb03b711053a4297$var$IS_IOS) {
            offsetX -= translated.x;
            offsetY -= translated.y;
        }
    }
    position.y = 1 - Math.max(0, Math.min(1, offsetY / boxH));
    position.x = Math.max(0, Math.min(1, offsetX / boxW));
    return position;
}
/**
 * Determines, via duck typing, whether or not a value is a text node.
 *
 * @param  {*} value
 *         Check if this value is a text node.
 *
 * @return {boolean}
 *         Will be `true` if the value is a text node, `false` otherwise.
 */ function $cb03b711053a4297$var$isTextNode(value) {
    return $cb03b711053a4297$var$isObject(value) && value.nodeType === 3;
}
/**
 * Empties the contents of an element.
 *
 * @param  {Element} el
 *         The element to empty children from
 *
 * @return {Element}
 *         The element with no children
 */ function $cb03b711053a4297$var$emptyEl(el) {
    while(el.firstChild)el.removeChild(el.firstChild);
    return el;
}
/**
 * This is a mixed value that describes content to be injected into the DOM
 * via some method. It can be of the following types:
 *
 * Type       | Description
 * -----------|-------------
 * `string`   | The value will be normalized into a text node.
 * `Element`  | The value will be accepted as-is.
 * `Text`     | A TextNode. The value will be accepted as-is.
 * `Array`    | A one-dimensional array of strings, elements, text nodes, or functions. These functions should return a string, element, or text node (any other return value, like an array, will be ignored).
 * `Function` | A function, which is expected to return a string, element, text node, or array - any of the other possible values described above. This means that a content descriptor could be a function that returns an array of functions, but those second-level functions must return strings, elements, or text nodes.
 *
 * @typedef {string|Element|Text|Array|Function} ContentDescriptor
 */ /**
 * Normalizes content for eventual insertion into the DOM.
 *
 * This allows a wide range of content definition methods, but helps protect
 * from falling into the trap of simply writing to `innerHTML`, which could
 * be an XSS concern.
 *
 * The content for an element can be passed in multiple types and
 * combinations, whose behavior is as follows:
 *
 * @param {ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Array}
 *         All of the content that was passed in, normalized to an array of
 *         elements or text nodes.
 */ function $cb03b711053a4297$var$normalizeContent(content) {
    // First, invoke content if it is a function. If it produces an array,
    // that needs to happen before normalization.
    if (typeof content === 'function') content = content();
    // Next up, normalize to an array, so one or many items can be normalized,
    // filtered, and returned.
    return (Array.isArray(content) ? content : [
        content
    ]).map((value)=>{
        // First, invoke value if it is a function to produce a new value,
        // which will be subsequently normalized to a Node of some kind.
        if (typeof value === 'function') value = value();
        if ($cb03b711053a4297$var$isEl(value) || $cb03b711053a4297$var$isTextNode(value)) return value;
        if (typeof value === 'string' && /\S/.test(value)) return (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createTextNode(value);
    }).filter((value)=>value);
}
/**
 * Normalizes and appends content to an element.
 *
 * @param  {Element} el
 *         Element to append normalized content to.
 *
 * @param {ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Element}
 *         The element with appended normalized content.
 */ function $cb03b711053a4297$var$appendContent(el, content) {
    $cb03b711053a4297$var$normalizeContent(content).forEach((node)=>el.appendChild(node));
    return el;
}
/**
 * Normalizes and inserts content into an element; this is identical to
 * `appendContent()`, except it empties the element first.
 *
 * @param {Element} el
 *        Element to insert normalized content into.
 *
 * @param {ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Element}
 *         The element with inserted normalized content.
 */ function $cb03b711053a4297$var$insertContent(el, content) {
    return $cb03b711053a4297$var$appendContent($cb03b711053a4297$var$emptyEl(el), content);
}
/**
 * Check if an event was a single left click.
 *
 * @param  {MouseEvent} event
 *         Event object.
 *
 * @return {boolean}
 *         Will be `true` if a single left click, `false` otherwise.
 */ function $cb03b711053a4297$var$isSingleLeftClick(event) {
    // Note: if you create something draggable, be sure to
    // call it on both `mousedown` and `mousemove` event,
    // otherwise `mousedown` should be enough for a button
    if (event.button === undefined && event.buttons === undefined) // Why do we need `buttons` ?
    // Because, middle mouse sometimes have this:
    // e.button === 0 and e.buttons === 4
    // Furthermore, we want to prevent combination click, something like
    // HOLD middlemouse then left click, that would be
    // e.button === 0, e.buttons === 5
    // just `button` is not gonna work
    // Alright, then what this block does ?
    // this is for chrome `simulate mobile devices`
    // I want to support this as well
    return true;
    if (event.button === 0 && event.buttons === undefined) // Touch screen, sometimes on some specific device, `buttons`
    // doesn't have anything (safari on ios, blackberry...)
    return true;
    // `mouseup` event on a single left click has
    // `button` and `buttons` equal to 0
    if (event.type === 'mouseup' && event.button === 0 && event.buttons === 0) return true;
    // MacOS Sonoma trackpad when "tap to click enabled"
    if (event.type === 'mousedown' && event.button === 0 && event.buttons === 0) return true;
    if (event.button !== 0 || event.buttons !== 1) // This is the reason we have those if else block above
    // if any special case we can catch and let it slide
    // we do it above, when get to here, this definitely
    // is-not-left-click
    return false;
    return true;
}
/**
 * Finds a single DOM element matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param  {string} selector
 *         A valid CSS selector, which will be passed to `querySelector`.
 *
 * @param  {Element|String} [context=document]
 *         A DOM element within which to query. Can also be a selector
 *         string in which case the first matching element will be used
 *         as context. If missing (or no element matches selector), falls
 *         back to `document`.
 *
 * @return {Element|null}
 *         The element that was found or null.
 */ const $cb03b711053a4297$var$$ = $cb03b711053a4297$var$createQuerier('querySelector');
/**
 * Finds a all DOM elements matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param  {string} selector
 *         A valid CSS selector, which will be passed to `querySelectorAll`.
 *
 * @param  {Element|String} [context=document]
 *         A DOM element within which to query. Can also be a selector
 *         string in which case the first matching element will be used
 *         as context. If missing (or no element matches selector), falls
 *         back to `document`.
 *
 * @return {NodeList}
 *         A element list of elements that were found. Will be empty if none
 *         were found.
 *
 */ const $cb03b711053a4297$var$$$ = $cb03b711053a4297$var$createQuerier('querySelectorAll');
/**
 * A safe getComputedStyle.
 *
 * This is needed because in Firefox, if the player is loaded in an iframe with
 * `display:none`, then `getComputedStyle` returns `null`, so, we do a
 * null-check to make sure that the player doesn't break in these cases.
 *
 * @param    {Element} el
 *           The element you want the computed style of
 *
 * @param    {string} prop
 *           The property name you want
 *
 * @see      https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */ function $cb03b711053a4297$var$computedStyle(el, prop) {
    if (!el || !prop) return '';
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).getComputedStyle === 'function') {
        let computedStyleValue;
        try {
            computedStyleValue = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).getComputedStyle(el);
        } catch (e) {
            return '';
        }
        return computedStyleValue ? computedStyleValue.getPropertyValue(prop) || computedStyleValue[prop] : '';
    }
    return '';
}
/**
 * Copy document style sheets to another window.
 *
 * @param    {Window} win
 *           The window element you want to copy the document style sheets to.
 *
 */ function $cb03b711053a4297$var$copyStyleSheetsToWindow(win) {
    [
        ...(0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).styleSheets
    ].forEach((styleSheet)=>{
        try {
            const cssRules = [
                ...styleSheet.cssRules
            ].map((rule)=>rule.cssText).join('');
            const style = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('style');
            style.textContent = cssRules;
            win.document.head.appendChild(style);
        } catch (e) {
            const link = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('link');
            link.rel = 'stylesheet';
            link.type = styleSheet.type;
            // For older Safari this has to be the string; on other browsers setting the MediaList works
            link.media = styleSheet.media.mediaText;
            link.href = styleSheet.href;
            win.document.head.appendChild(link);
        }
    });
}
var $cb03b711053a4297$var$Dom = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    isReal: $cb03b711053a4297$var$isReal,
    isEl: $cb03b711053a4297$var$isEl,
    isInFrame: $cb03b711053a4297$var$isInFrame,
    createEl: $cb03b711053a4297$var$createEl,
    textContent: $cb03b711053a4297$var$textContent,
    prependTo: $cb03b711053a4297$var$prependTo,
    hasClass: $cb03b711053a4297$var$hasClass,
    addClass: $cb03b711053a4297$var$addClass,
    removeClass: $cb03b711053a4297$var$removeClass,
    toggleClass: $cb03b711053a4297$var$toggleClass,
    setAttributes: $cb03b711053a4297$var$setAttributes,
    getAttributes: $cb03b711053a4297$var$getAttributes,
    getAttribute: $cb03b711053a4297$var$getAttribute,
    setAttribute: $cb03b711053a4297$var$setAttribute,
    removeAttribute: $cb03b711053a4297$var$removeAttribute,
    blockTextSelection: $cb03b711053a4297$var$blockTextSelection,
    unblockTextSelection: $cb03b711053a4297$var$unblockTextSelection,
    getBoundingClientRect: $cb03b711053a4297$var$getBoundingClientRect,
    findPosition: $cb03b711053a4297$var$findPosition,
    getPointerPosition: $cb03b711053a4297$var$getPointerPosition,
    isTextNode: $cb03b711053a4297$var$isTextNode,
    emptyEl: $cb03b711053a4297$var$emptyEl,
    normalizeContent: $cb03b711053a4297$var$normalizeContent,
    appendContent: $cb03b711053a4297$var$appendContent,
    insertContent: $cb03b711053a4297$var$insertContent,
    isSingleLeftClick: $cb03b711053a4297$var$isSingleLeftClick,
    $: $cb03b711053a4297$var$$,
    $$: $cb03b711053a4297$var$$$,
    computedStyle: $cb03b711053a4297$var$computedStyle,
    copyStyleSheetsToWindow: $cb03b711053a4297$var$copyStyleSheetsToWindow
});
/**
 * @file setup.js - Functions for setting up a player without
 * user interaction based on the data-setup `attribute` of the video tag.
 *
 * @module setup
 */ let $cb03b711053a4297$var$_windowLoaded = false;
let $cb03b711053a4297$var$videojs$1;
/**
 * Set up any tags that have a data-setup `attribute` when the player is started.
 */ const $cb03b711053a4297$var$autoSetup = function() {
    if ($cb03b711053a4297$var$videojs$1.options.autoSetup === false) return;
    const vids = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).getElementsByTagName('video'));
    const audios = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).getElementsByTagName('audio'));
    const divs = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).getElementsByTagName('video-js'));
    const mediaEls = vids.concat(audios, divs);
    // Check if any media elements exist
    if (mediaEls && mediaEls.length > 0) for(let i = 0, e = mediaEls.length; i < e; i++){
        const mediaEl = mediaEls[i];
        // Check if element exists, has getAttribute func.
        if (mediaEl && mediaEl.getAttribute) // Make sure this player hasn't already been set up.
        {
            if (mediaEl.player === undefined) {
                const options = mediaEl.getAttribute('data-setup');
                // Check if data-setup attr exists.
                // We only auto-setup if they've added the data-setup attr.
                if (options !== null) // Create new video.js instance.
                $cb03b711053a4297$var$videojs$1(mediaEl);
            }
        } else {
            $cb03b711053a4297$var$autoSetupTimeout(1);
            break;
        }
    }
    else if (!$cb03b711053a4297$var$_windowLoaded) $cb03b711053a4297$var$autoSetupTimeout(1);
};
/**
 * Wait until the page is loaded before running autoSetup. This will be called in
 * autoSetup if `hasLoaded` returns false.
 *
 * @param {number} wait
 *        How long to wait in ms
 *
 * @param {module:videojs} [vjs]
 *        The videojs library function
 */ function $cb03b711053a4297$var$autoSetupTimeout(wait, vjs) {
    // Protect against breakage in non-browser environments
    if (!$cb03b711053a4297$var$isReal()) return;
    if (vjs) $cb03b711053a4297$var$videojs$1 = vjs;
    (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout($cb03b711053a4297$var$autoSetup, wait);
}
/**
 * Used to set the internal tracking of window loaded state to true.
 *
 * @private
 */ function $cb03b711053a4297$var$setWindowLoaded() {
    $cb03b711053a4297$var$_windowLoaded = true;
    (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).removeEventListener('load', $cb03b711053a4297$var$setWindowLoaded);
}
if ($cb03b711053a4297$var$isReal()) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).readyState === 'complete') $cb03b711053a4297$var$setWindowLoaded();
    else /**
     * Listen for the load event on window, and set _windowLoaded to true.
     *
     * We use a standard event listener here to avoid incrementing the GUID
     * before any players are created.
     *
     * @listens load
     */ (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).addEventListener('load', $cb03b711053a4297$var$setWindowLoaded);
}
/**
 * @file stylesheet.js
 * @module stylesheet
 */ /**
 * Create a DOM style element given a className for it.
 *
 * @param {string} className
 *        The className to add to the created style element.
 *
 * @return {Element}
 *         The element that was created.
 */ const $cb03b711053a4297$var$createStyleElement = function(className) {
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('style');
    style.className = className;
    return style;
};
/**
 * Add text to a DOM element.
 *
 * @param {Element} el
 *        The Element to add text content to.
 *
 * @param {string} content
 *        The text to add to the element.
 */ const $cb03b711053a4297$var$setTextContent = function(el, content) {
    if (el.styleSheet) el.styleSheet.cssText = content;
    else el.textContent = content;
};
/**
 * @file dom-data.js
 * @module dom-data
 */ /**
 * Element Data Store.
 *
 * Allows for binding data to an element without putting it directly on the
 * element. Ex. Event listeners are stored here.
 * (also from jsninja.com, slightly modified and updated for closure compiler)
 *
 * @type {Object}
 * @private
 */ var $cb03b711053a4297$var$DomData = new WeakMap();
/**
 * @file guid.js
 * @module guid
 */ // Default value for GUIDs. This allows us to reset the GUID counter in tests.
//
// The initial GUID is 3 because some users have come to rely on the first
// default player ID ending up as `vjs_video_3`.
//
// See: https://github.com/videojs/video.js/pull/6216
const $cb03b711053a4297$var$_initialGuid = 3;
/**
 * Unique ID for an element or function
 *
 * @type {Number}
 */ let $cb03b711053a4297$var$_guid = $cb03b711053a4297$var$_initialGuid;
/**
 * Get a unique auto-incrementing ID by number that has not been returned before.
 *
 * @return {number}
 *         A new unique ID.
 */ function $cb03b711053a4297$var$newGUID() {
    return $cb03b711053a4297$var$_guid++;
}
/**
 * @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
 * (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
 * This should work very similarly to jQuery's events, however it's based off the book version which isn't as
 * robust as jquery's, so there's probably some differences.
 *
 * @file events.js
 * @module events
 */ /**
 * Clean up the listener cache and dispatchers
 *
 * @param {Element|Object} elem
 *        Element to clean up
 *
 * @param {string} type
 *        Type of event to clean up
 */ function $cb03b711053a4297$var$_cleanUpEvents(elem, type) {
    if (!$cb03b711053a4297$var$DomData.has(elem)) return;
    const data = $cb03b711053a4297$var$DomData.get(elem);
    // Remove the events of a particular type if there are none left
    if (data.handlers[type].length === 0) {
        delete data.handlers[type];
        // data.handlers[type] = null;
        // Setting to null was causing an error with data.handlers
        // Remove the meta-handler from the element
        if (elem.removeEventListener) elem.removeEventListener(type, data.dispatcher, false);
        else if (elem.detachEvent) elem.detachEvent('on' + type, data.dispatcher);
    }
    // Remove the events object if there are no types left
    if (Object.getOwnPropertyNames(data.handlers).length <= 0) {
        delete data.handlers;
        delete data.dispatcher;
        delete data.disabled;
    }
    // Finally remove the element data if there is no data left
    if (Object.getOwnPropertyNames(data).length === 0) $cb03b711053a4297$var$DomData.delete(elem);
}
/**
 * Loops through an array of event types and calls the requested method for each type.
 *
 * @param {Function} fn
 *        The event method we want to use.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string[]} types
 *        Type of event to bind to.
 *
 * @param {Function} callback
 *        Event listener.
 */ function $cb03b711053a4297$var$_handleMultipleEvents(fn, elem, types, callback) {
    types.forEach(function(type) {
        // Call the event method for each one of the types
        fn(elem, type, callback);
    });
}
/**
 * Fix a native event to have standard property values
 *
 * @param {Object} event
 *        Event object to fix.
 *
 * @return {Object}
 *         Fixed event object.
 */ function $cb03b711053a4297$var$fixEvent(event) {
    if (event.fixed_) return event;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Test if fixing up is needed
    // Used to check if !event.stopPropagation instead of isPropagationStopped
    // But native events return true for stopPropagation, but don't have
    // other expected methods like isPropagationStopped. Seems to be a problem
    // with the Javascript Ninja code. So we're just overriding all events now.
    if (!event || !event.isPropagationStopped || !event.isImmediatePropagationStopped) {
        const old = event || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).event;
        event = {};
        // Clone the old object so that we can modify the values event = {};
        // IE8 Doesn't like when you mess with native event properties
        // Firefox returns false for event.hasOwnProperty('type') and other props
        //  which makes copying more difficult.
        // TODO: Probably best to create an allowlist of event props
        const deprecatedProps = [
            'layerX',
            'layerY',
            'keyLocation',
            'path',
            'webkitMovementX',
            'webkitMovementY',
            'mozPressure',
            'mozInputSource'
        ];
        for(const key in old){
            // Safari 6.0.3 warns you if you try to copy deprecated layerX/Y
            // Chrome warns you if you try to copy deprecated keyboardEvent.keyLocation
            // and webkitMovementX/Y
            // Lighthouse complains if Event.path is copied
            if (!deprecatedProps.includes(key)) // Chrome 32+ warns if you try to copy deprecated returnValue, but
            // we still want to if preventDefault isn't supported (IE8).
            {
                if (!(key === 'returnValue' && old.preventDefault)) event[key] = old[key];
            }
        }
        // The event occurred on this element
        if (!event.target) event.target = event.srcElement || (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)));
        // Handle which other element the event is related to
        if (!event.relatedTarget) event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
        // Stop the default browser action
        event.preventDefault = function() {
            if (old.preventDefault) old.preventDefault();
            event.returnValue = false;
            old.returnValue = false;
            event.defaultPrevented = true;
        };
        event.defaultPrevented = false;
        // Stop the event from bubbling
        event.stopPropagation = function() {
            if (old.stopPropagation) old.stopPropagation();
            event.cancelBubble = true;
            old.cancelBubble = true;
            event.isPropagationStopped = returnTrue;
        };
        event.isPropagationStopped = returnFalse;
        // Stop the event from bubbling and executing other handlers
        event.stopImmediatePropagation = function() {
            if (old.stopImmediatePropagation) old.stopImmediatePropagation();
            event.isImmediatePropagationStopped = returnTrue;
            event.stopPropagation();
        };
        event.isImmediatePropagationStopped = returnFalse;
        // Handle mouse position
        if (event.clientX !== null && event.clientX !== undefined) {
            const doc = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).documentElement;
            const body = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).body;
            event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
            event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
        }
        // Handle key presses
        event.which = event.charCode || event.keyCode;
        // Fix button for mouse clicks:
        // 0 == left; 1 == middle; 2 == right
        if (event.button !== null && event.button !== undefined) // The following is disabled because it does not pass videojs-standard
        // and... yikes.
        /* eslint-disable */ event.button = event.button & 1 ? 0 : event.button & 4 ? 1 : event.button & 2 ? 2 : 0;
    }
    event.fixed_ = true;
    // Returns fixed-up instance
    return event;
}
/**
 * Whether passive event listeners are supported
 */ let $cb03b711053a4297$var$_supportsPassive;
const $cb03b711053a4297$var$supportsPassive = function() {
    if (typeof $cb03b711053a4297$var$_supportsPassive !== 'boolean') {
        $cb03b711053a4297$var$_supportsPassive = false;
        try {
            const opts = Object.defineProperty({}, 'passive', {
                get () {
                    $cb03b711053a4297$var$_supportsPassive = true;
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).addEventListener('test', null, opts);
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).removeEventListener('test', null, opts);
        } catch (e) {
        // disregard
        }
    }
    return $cb03b711053a4297$var$_supportsPassive;
};
/**
 * Touch events Chrome expects to be passive
 */ const $cb03b711053a4297$var$passiveEvents = [
    'touchstart',
    'touchmove'
];
/**
 * Add an event listener to element
 * It stores the handler function in a separate cache object
 * and adds a generic handler to the element's event,
 * along with a unique id (guid) to the element.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string|string[]} type
 *        Type of event to bind to.
 *
 * @param {Function} fn
 *        Event listener.
 */ function $cb03b711053a4297$var$on(elem, type, fn) {
    if (Array.isArray(type)) return $cb03b711053a4297$var$_handleMultipleEvents($cb03b711053a4297$var$on, elem, type, fn);
    if (!$cb03b711053a4297$var$DomData.has(elem)) $cb03b711053a4297$var$DomData.set(elem, {});
    const data = $cb03b711053a4297$var$DomData.get(elem);
    // We need a place to store all our handler data
    if (!data.handlers) data.handlers = {};
    if (!data.handlers[type]) data.handlers[type] = [];
    if (!fn.guid) fn.guid = $cb03b711053a4297$var$newGUID();
    data.handlers[type].push(fn);
    if (!data.dispatcher) {
        data.disabled = false;
        data.dispatcher = function(event, hash) {
            if (data.disabled) return;
            event = $cb03b711053a4297$var$fixEvent(event);
            const handlers = data.handlers[event.type];
            if (handlers) {
                // Copy handlers so if handlers are added/removed during the process it doesn't throw everything off.
                const handlersCopy = handlers.slice(0);
                for(let m = 0, n = handlersCopy.length; m < n; m++){
                    if (event.isImmediatePropagationStopped()) break;
                    else try {
                        handlersCopy[m].call(elem, event, hash);
                    } catch (e) {
                        $cb03b711053a4297$var$log$1.error(e);
                    }
                }
            }
        };
    }
    if (data.handlers[type].length === 1) {
        if (elem.addEventListener) {
            let options = false;
            if ($cb03b711053a4297$var$supportsPassive() && $cb03b711053a4297$var$passiveEvents.indexOf(type) > -1) options = {
                passive: true
            };
            elem.addEventListener(type, data.dispatcher, options);
        } else if (elem.attachEvent) elem.attachEvent('on' + type, data.dispatcher);
    }
}
/**
 * Removes event listeners from an element
 *
 * @param {Element|Object} elem
 *        Object to remove listeners from.
 *
 * @param {string|string[]} [type]
 *        Type of listener to remove. Don't include to remove all events from element.
 *
 * @param {Function} [fn]
 *        Specific listener to remove. Don't include to remove listeners for an event
 *        type.
 */ function $cb03b711053a4297$var$off(elem, type, fn) {
    // Don't want to add a cache object through getElData if not needed
    if (!$cb03b711053a4297$var$DomData.has(elem)) return;
    const data = $cb03b711053a4297$var$DomData.get(elem);
    // If no events exist, nothing to unbind
    if (!data.handlers) return;
    if (Array.isArray(type)) return $cb03b711053a4297$var$_handleMultipleEvents($cb03b711053a4297$var$off, elem, type, fn);
    // Utility function
    const removeType = function(el, t) {
        data.handlers[t] = [];
        $cb03b711053a4297$var$_cleanUpEvents(el, t);
    };
    // Are we removing all bound events?
    if (type === undefined) {
        for(const t in data.handlers)if (Object.prototype.hasOwnProperty.call(data.handlers || {}, t)) removeType(elem, t);
        return;
    }
    const handlers = data.handlers[type];
    // If no handlers exist, nothing to unbind
    if (!handlers) return;
    // If no listener was provided, remove all listeners for type
    if (!fn) {
        removeType(elem, type);
        return;
    }
    // We're only removing a single handler
    if (fn.guid) {
        for(let n = 0; n < handlers.length; n++)if (handlers[n].guid === fn.guid) handlers.splice(n--, 1);
    }
    $cb03b711053a4297$var$_cleanUpEvents(elem, type);
}
/**
 * Trigger an event for an element
 *
 * @param {Element|Object} elem
 *        Element to trigger an event on
 *
 * @param {EventTarget~Event|string} event
 *        A string (the type) or an event object with a type attribute
 *
 * @param {Object} [hash]
 *        data hash to pass along with the event
 *
 * @return {boolean|undefined}
 *         Returns the opposite of `defaultPrevented` if default was
 *         prevented. Otherwise, returns `undefined`
 */ function $cb03b711053a4297$var$trigger(elem, event, hash) {
    // Fetches element data and a reference to the parent (for bubbling).
    // Don't want to add a data object to cache for every parent,
    // so checking hasElData first.
    const elemData = $cb03b711053a4297$var$DomData.has(elem) ? $cb03b711053a4297$var$DomData.get(elem) : {};
    const parent = elem.parentNode || elem.ownerDocument;
    // type = event.type || event,
    // handler;
    // If an event name was passed as a string, creates an event out of it
    if (typeof event === 'string') event = {
        type: event,
        target: elem
    };
    else if (!event.target) event.target = elem;
    // Normalizes the event properties.
    event = $cb03b711053a4297$var$fixEvent(event);
    // If the passed element has a dispatcher, executes the established handlers.
    if (elemData.dispatcher) elemData.dispatcher.call(elem, event, hash);
    // Unless explicitly stopped or the event does not bubble (e.g. media events)
    // recursively calls this function to bubble the event up the DOM.
    if (parent && !event.isPropagationStopped() && event.bubbles === true) $cb03b711053a4297$var$trigger.call(null, parent, event, hash);
    else if (!parent && !event.defaultPrevented && event.target && event.target[event.type]) {
        if (!$cb03b711053a4297$var$DomData.has(event.target)) $cb03b711053a4297$var$DomData.set(event.target, {});
        const targetData = $cb03b711053a4297$var$DomData.get(event.target);
        // Checks if the target has a default action for this event.
        if (event.target[event.type]) {
            // Temporarily disables event dispatching on the target as we have already executed the handler.
            targetData.disabled = true;
            // Executes the default action.
            if (typeof event.target[event.type] === 'function') event.target[event.type]();
            // Re-enables event dispatching.
            targetData.disabled = false;
        }
    }
    // Inform the triggerer if the default was prevented by returning false
    return !event.defaultPrevented;
}
/**
 * Trigger a listener only once for an event.
 *
 * @param {Element|Object} elem
 *        Element or object to bind to.
 *
 * @param {string|string[]} type
 *        Name/type of event
 *
 * @param {Event~EventListener} fn
 *        Event listener function
 */ function $cb03b711053a4297$var$one(elem, type, fn) {
    if (Array.isArray(type)) return $cb03b711053a4297$var$_handleMultipleEvents($cb03b711053a4297$var$one, elem, type, fn);
    const func = function() {
        $cb03b711053a4297$var$off(elem, type, func);
        fn.apply(this, arguments);
    };
    // copy the guid to the new function so it can removed using the original function's ID
    func.guid = fn.guid = fn.guid || $cb03b711053a4297$var$newGUID();
    $cb03b711053a4297$var$on(elem, type, func);
}
/**
 * Trigger a listener only once and then turn if off for all
 * configured events
 *
 * @param {Element|Object} elem
 *        Element or object to bind to.
 *
 * @param {string|string[]} type
 *        Name/type of event
 *
 * @param {Event~EventListener} fn
 *        Event listener function
 */ function $cb03b711053a4297$var$any(elem, type, fn) {
    const func = function() {
        $cb03b711053a4297$var$off(elem, type, func);
        fn.apply(this, arguments);
    };
    // copy the guid to the new function so it can removed using the original function's ID
    func.guid = fn.guid = fn.guid || $cb03b711053a4297$var$newGUID();
    // multiple ons, but one off for everything
    $cb03b711053a4297$var$on(elem, type, func);
}
var $cb03b711053a4297$var$Events = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    fixEvent: $cb03b711053a4297$var$fixEvent,
    on: $cb03b711053a4297$var$on,
    off: $cb03b711053a4297$var$off,
    trigger: $cb03b711053a4297$var$trigger,
    one: $cb03b711053a4297$var$one,
    any: $cb03b711053a4297$var$any
});
/**
 * @file fn.js
 * @module fn
 */ const $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL = 30;
/**
 * A private, internal-only function for changing the context of a function.
 *
 * It also stores a unique id on the function so it can be easily removed from
 * events.
 *
 * @private
 * @function
 * @param    {*} context
 *           The object to bind as scope.
 *
 * @param    {Function} fn
 *           The function to be bound to a scope.
 *
 * @param    {number} [uid]
 *           An optional unique ID for the function to be set
 *
 * @return   {Function}
 *           The new function that will be bound into the context given
 */ const $cb03b711053a4297$var$bind_ = function(context, fn, uid) {
    // Make sure the function has a unique ID
    if (!fn.guid) fn.guid = $cb03b711053a4297$var$newGUID();
    // Create the new function that changes the context
    const bound = fn.bind(context);
    // Allow for the ability to individualize this function
    // Needed in the case where multiple objects might share the same prototype
    // IF both items add an event listener with the same function, then you try to remove just one
    // it will remove both because they both have the same guid.
    // when using this, you need to use the bind method when you remove the listener as well.
    // currently used in text tracks
    bound.guid = uid ? uid + '_' + fn.guid : fn.guid;
    return bound;
};
/**
 * Wraps the given function, `fn`, with a new function that only invokes `fn`
 * at most once per every `wait` milliseconds.
 *
 * @function
 * @param    {Function} fn
 *           The function to be throttled.
 *
 * @param    {number}   wait
 *           The number of milliseconds by which to throttle.
 *
 * @return   {Function}
 */ const $cb03b711053a4297$var$throttle = function(fn, wait) {
    let last = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now();
    const throttled = function(...args) {
        const now = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now();
        if (now - last >= wait) {
            fn(...args);
            last = now;
        }
    };
    return throttled;
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked.
 *
 * Inspired by lodash and underscore implementations.
 *
 * @function
 * @param    {Function} func
 *           The function to wrap with debounce behavior.
 *
 * @param    {number} wait
 *           The number of milliseconds to wait after the last invocation.
 *
 * @param    {boolean} [immediate]
 *           Whether or not to invoke the function immediately upon creation.
 *
 * @param    {Object} [context=window]
 *           The "context" in which the debounced function should debounce. For
 *           example, if this function should be tied to a Video.js player,
 *           the player can be passed here. Alternatively, defaults to the
 *           global `window` object.
 *
 * @return   {Function}
 *           A debounced function.
 */ const $cb03b711053a4297$var$debounce$1 = function(func, wait, immediate, context = (0, (/*@__PURE__*/$parcel$interopDefault($eDick)))) {
    let timeout;
    const cancel = ()=>{
        context.clearTimeout(timeout);
        timeout = null;
    };
    /* eslint-disable consistent-this */ const debounced = function() {
        const self1 = this;
        const args = arguments;
        let later = function() {
            timeout = null;
            later = null;
            if (!immediate) func.apply(self1, args);
        };
        if (!timeout && immediate) func.apply(self1, args);
        context.clearTimeout(timeout);
        timeout = context.setTimeout(later, wait);
    };
    /* eslint-enable consistent-this */ debounced.cancel = cancel;
    return debounced;
};
var $cb03b711053a4297$var$Fn = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    UPDATE_REFRESH_INTERVAL: $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL,
    bind_: $cb03b711053a4297$var$bind_,
    throttle: $cb03b711053a4297$var$throttle,
    debounce: $cb03b711053a4297$var$debounce$1
});
/**
 * @file src/js/event-target.js
 */ let $cb03b711053a4297$var$EVENT_MAP;
/**
 * `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
 * adds shorthand functions that wrap around lengthy functions. For example:
 * the `on` function is a wrapper around `addEventListener`.
 *
 * @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
 * @class EventTarget
 */ class $cb03b711053a4297$var$EventTarget$2 {
    /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */ on(type, fn) {
        // Remove the addEventListener alias before calling Events.on
        // so we don't get into an infinite type loop
        const ael = this.addEventListener;
        this.addEventListener = ()=>{};
        $cb03b711053a4297$var$on(this, type, fn);
        this.addEventListener = ael;
    }
    /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to remove.
   */ off(type, fn) {
        $cb03b711053a4297$var$off(this, type, fn);
    }
    /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ one(type, fn) {
        // Remove the addEventListener aliasing Events.on
        // so we don't get into an infinite type loop
        const ael = this.addEventListener;
        this.addEventListener = ()=>{};
        $cb03b711053a4297$var$one(this, type, fn);
        this.addEventListener = ael;
    }
    /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ any(type, fn) {
        // Remove the addEventListener aliasing Events.on
        // so we don't get into an infinite type loop
        const ael = this.addEventListener;
        this.addEventListener = ()=>{};
        $cb03b711053a4297$var$any(this, type, fn);
        this.addEventListener = ael;
    }
    /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|EventTarget~Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   */ trigger(event) {
        const type = event.type || event;
        // deprecation
        // In a future version we should default target to `this`
        // similar to how we default the target to `elem` in
        // `Events.trigger`. Right now the default `target` will be
        // `document` due to the `Event.fixEvent` call.
        if (typeof event === 'string') event = {
            type: type
        };
        event = $cb03b711053a4297$var$fixEvent(event);
        if (this.allowedEvents_[type] && this['on' + type]) this['on' + type](event);
        $cb03b711053a4297$var$trigger(this, event);
    }
    queueTrigger(event) {
        // only set up EVENT_MAP if it'll be used
        if (!$cb03b711053a4297$var$EVENT_MAP) $cb03b711053a4297$var$EVENT_MAP = new Map();
        const type = event.type || event;
        let map = $cb03b711053a4297$var$EVENT_MAP.get(this);
        if (!map) {
            map = new Map();
            $cb03b711053a4297$var$EVENT_MAP.set(this, map);
        }
        const oldTimeout = map.get(type);
        map.delete(type);
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(oldTimeout);
        const timeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            map.delete(type);
            // if we cleared out all timeouts for the current target, delete its map
            if (map.size === 0) {
                map = null;
                $cb03b711053a4297$var$EVENT_MAP.delete(this);
            }
            this.trigger(event);
        }, 0);
        map.set(type, timeout);
    }
}
/**
 * A Custom DOM event.
 *
 * @typedef {CustomEvent} Event
 * @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
 */ /**
 * All event listeners should follow the following format.
 *
 * @callback EventListener
 * @this {EventTarget}
 *
 * @param {Event} event
 *        the event that triggered this function
 *
 * @param {Object} [hash]
 *        hash of data sent during the event
 */ /**
 * An object containing event names as keys and booleans as values.
 *
 * > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
 *         will have extra functionality. See that function for more information.
 *
 * @property EventTarget.prototype.allowedEvents_
 * @protected
 */ $cb03b711053a4297$var$EventTarget$2.prototype.allowedEvents_ = {};
/**
 * An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#on}
 */ $cb03b711053a4297$var$EventTarget$2.prototype.addEventListener = $cb03b711053a4297$var$EventTarget$2.prototype.on;
/**
 * An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#off}
 */ $cb03b711053a4297$var$EventTarget$2.prototype.removeEventListener = $cb03b711053a4297$var$EventTarget$2.prototype.off;
/**
 * An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#trigger}
 */ $cb03b711053a4297$var$EventTarget$2.prototype.dispatchEvent = $cb03b711053a4297$var$EventTarget$2.prototype.trigger;
/**
 * @file mixins/evented.js
 * @module evented
 */ const $cb03b711053a4297$var$objName = (obj)=>{
    if (typeof obj.name === 'function') return obj.name();
    if (typeof obj.name === 'string') return obj.name;
    if (obj.name_) return obj.name_;
    if (obj.constructor && obj.constructor.name) return obj.constructor.name;
    return typeof obj;
};
/**
 * Returns whether or not an object has had the evented mixin applied.
 *
 * @param  {Object} object
 *         An object to test.
 *
 * @return {boolean}
 *         Whether or not the object appears to be evented.
 */ const $cb03b711053a4297$var$isEvented = (object)=>object instanceof $cb03b711053a4297$var$EventTarget$2 || !!object.eventBusEl_ && [
        'on',
        'one',
        'off',
        'trigger'
    ].every((k)=>typeof object[k] === 'function');
/**
 * Adds a callback to run after the evented mixin applied.
 *
 * @param  {Object} target
 *         An object to Add
 * @param  {Function} callback
 *         The callback to run.
 */ const $cb03b711053a4297$var$addEventedCallback = (target, callback)=>{
    if ($cb03b711053a4297$var$isEvented(target)) callback();
    else {
        if (!target.eventedCallbacks) target.eventedCallbacks = [];
        target.eventedCallbacks.push(callback);
    }
};
/**
 * Whether a value is a valid event type - non-empty string or array.
 *
 * @private
 * @param  {string|Array} type
 *         The type value to test.
 *
 * @return {boolean}
 *         Whether or not the type is a valid event type.
 */ const $cb03b711053a4297$var$isValidEventType = (type)=>// The regex here verifies that the `type` contains at least one non-
    // whitespace character.
    typeof type === 'string' && /\S/.test(type) || Array.isArray(type) && !!type.length;
/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the target does not appear to be a valid event target.
 *
 * @param  {Object} target
 *         The object to test.
 *
 * @param  {Object} obj
 *         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */ const $cb03b711053a4297$var$validateTarget = (target, obj, fnName)=>{
    if (!target || !target.nodeName && !$cb03b711053a4297$var$isEvented(target)) throw new Error(`Invalid target for ${$cb03b711053a4297$var$objName(obj)}#${fnName}; must be a DOM node or evented object.`);
};
/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the type does not appear to be a valid event type.
 *
 * @param  {string|Array} type
 *         The type to test.
 *
 * @param  {Object} obj
*         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */ const $cb03b711053a4297$var$validateEventType = (type, obj, fnName)=>{
    if (!$cb03b711053a4297$var$isValidEventType(type)) throw new Error(`Invalid event type for ${$cb03b711053a4297$var$objName(obj)}#${fnName}; must be a non-empty string or array.`);
};
/**
 * Validates a value to determine if it is a valid listener. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the listener is not a function.
 *
 * @param  {Function} listener
 *         The listener to test.
 *
 * @param  {Object} obj
 *         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */ const $cb03b711053a4297$var$validateListener = (listener, obj, fnName)=>{
    if (typeof listener !== 'function') throw new Error(`Invalid listener for ${$cb03b711053a4297$var$objName(obj)}#${fnName}; must be a function.`);
};
/**
 * Takes an array of arguments given to `on()` or `one()`, validates them, and
 * normalizes them into an object.
 *
 * @private
 * @param  {Object} self
 *         The evented object on which `on()` or `one()` was called. This
 *         object will be bound as the `this` value for the listener.
 *
 * @param  {Array} args
 *         An array of arguments passed to `on()` or `one()`.
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 *
 * @return {Object}
 *         An object containing useful values for `on()` or `one()` calls.
 */ const $cb03b711053a4297$var$normalizeListenArgs = (self1, args, fnName)=>{
    // If the number of arguments is less than 3, the target is always the
    // evented object itself.
    const isTargetingSelf = args.length < 3 || args[0] === self1 || args[0] === self1.eventBusEl_;
    let target;
    let type;
    let listener;
    if (isTargetingSelf) {
        target = self1.eventBusEl_;
        // Deal with cases where we got 3 arguments, but we are still listening to
        // the evented object itself.
        if (args.length >= 3) args.shift();
        [type, listener] = args;
    } else {
        // This was `[target, type, listener] = args;` but this block needs more than
        // one statement to produce minified output compatible with Chrome 53.
        // See https://github.com/videojs/video.js/pull/8810
        target = args[0];
        type = args[1];
        listener = args[2];
    }
    $cb03b711053a4297$var$validateTarget(target, self1, fnName);
    $cb03b711053a4297$var$validateEventType(type, self1, fnName);
    $cb03b711053a4297$var$validateListener(listener, self1, fnName);
    listener = $cb03b711053a4297$var$bind_(self1, listener);
    return {
        isTargetingSelf: isTargetingSelf,
        target: target,
        type: type,
        listener: listener
    };
};
/**
 * Adds the listener to the event type(s) on the target, normalizing for
 * the type of target.
 *
 * @private
 * @param  {Element|Object} target
 *         A DOM node or evented object.
 *
 * @param  {string} method
 *         The event binding method to use ("on" or "one").
 *
 * @param  {string|Array} type
 *         One or more event type(s).
 *
 * @param  {Function} listener
 *         A listener function.
 */ const $cb03b711053a4297$var$listen = (target, method, type, listener)=>{
    $cb03b711053a4297$var$validateTarget(target, target, method);
    if (target.nodeName) $cb03b711053a4297$var$Events[method](target, type, listener);
    else target[method](type, listener);
};
/**
 * Contains methods that provide event capabilities to an object which is passed
 * to {@link module:evented|evented}.
 *
 * @mixin EventedMixin
 */ const $cb03b711053a4297$var$EventedMixin = {
    /**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */ on (...args) {
        const { isTargetingSelf: isTargetingSelf, target: target, type: type, listener: listener } = $cb03b711053a4297$var$normalizeListenArgs(this, args, 'on');
        $cb03b711053a4297$var$listen(target, 'on', type, listener);
        // If this object is listening to another evented object.
        if (!isTargetingSelf) {
            // If this object is disposed, remove the listener.
            const removeListenerOnDispose = ()=>this.off(target, type, listener);
            // Use the same function ID as the listener so we can remove it later it
            // using the ID of the original listener.
            removeListenerOnDispose.guid = listener.guid;
            // Add a listener to the target's dispose event as well. This ensures
            // that if the target is disposed BEFORE this object, we remove the
            // removal listener that was just added. Otherwise, we create a memory leak.
            const removeRemoverOnTargetDispose = ()=>this.off('dispose', removeListenerOnDispose);
            // Use the same function ID as the listener so we can remove it later
            // it using the ID of the original listener.
            removeRemoverOnTargetDispose.guid = listener.guid;
            $cb03b711053a4297$var$listen(this, 'on', 'dispose', removeListenerOnDispose);
            $cb03b711053a4297$var$listen(target, 'on', 'dispose', removeRemoverOnTargetDispose);
        }
    },
    /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will be called once per event and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */ one (...args) {
        const { isTargetingSelf: isTargetingSelf, target: target, type: type, listener: listener } = $cb03b711053a4297$var$normalizeListenArgs(this, args, 'one');
        // Targeting this evented object.
        if (isTargetingSelf) $cb03b711053a4297$var$listen(target, 'one', type, listener);
        else {
            // TODO: This wrapper is incorrect! It should only
            //       remove the wrapper for the event type that called it.
            //       Instead all listeners are removed on the first trigger!
            //       see https://github.com/videojs/video.js/issues/5962
            const wrapper = (...largs)=>{
                this.off(target, type, wrapper);
                listener.apply(null, largs);
            };
            // Use the same function ID as the listener so we can remove it later
            // it using the ID of the original listener.
            wrapper.guid = listener.guid;
            $cb03b711053a4297$var$listen(target, 'one', type, wrapper);
        }
    },
    /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once for the first event that is triggered
   * then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */ any (...args) {
        const { isTargetingSelf: isTargetingSelf, target: target, type: type, listener: listener } = $cb03b711053a4297$var$normalizeListenArgs(this, args, 'any');
        // Targeting this evented object.
        if (isTargetingSelf) $cb03b711053a4297$var$listen(target, 'any', type, listener);
        else {
            const wrapper = (...largs)=>{
                this.off(target, type, wrapper);
                listener.apply(null, largs);
            };
            // Use the same function ID as the listener so we can remove it later
            // it using the ID of the original listener.
            wrapper.guid = listener.guid;
            $cb03b711053a4297$var$listen(target, 'any', type, wrapper);
        }
    },
    /**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */ off (targetOrType, typeOrListener, listener) {
        // Targeting this evented object.
        if (!targetOrType || $cb03b711053a4297$var$isValidEventType(targetOrType)) $cb03b711053a4297$var$off(this.eventBusEl_, targetOrType, typeOrListener);
        else {
            const target = targetOrType;
            const type = typeOrListener;
            // Fail fast and in a meaningful way!
            $cb03b711053a4297$var$validateTarget(target, this, 'off');
            $cb03b711053a4297$var$validateEventType(type, this, 'off');
            $cb03b711053a4297$var$validateListener(listener, this, 'off');
            // Ensure there's at least a guid, even if the function hasn't been used
            listener = $cb03b711053a4297$var$bind_(this, listener);
            // Remove the dispose listener on this evented object, which was given
            // the same guid as the event listener in on().
            this.off('dispose', listener);
            if (target.nodeName) {
                $cb03b711053a4297$var$off(target, type, listener);
                $cb03b711053a4297$var$off(target, 'dispose', listener);
            } else if ($cb03b711053a4297$var$isEvented(target)) {
                target.off(type, listener);
                target.off('dispose', listener);
            }
        }
    },
    /**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @return {boolean}
   *          Whether or not the default behavior was prevented.
   */ trigger (event, hash) {
        $cb03b711053a4297$var$validateTarget(this.eventBusEl_, this, 'trigger');
        const type = event && typeof event !== 'string' ? event.type : event;
        if (!$cb03b711053a4297$var$isValidEventType(type)) throw new Error(`Invalid event type for ${$cb03b711053a4297$var$objName(this)}#trigger; ` + 'must be a non-empty string or object with a type key that has a non-empty value.');
        return $cb03b711053a4297$var$trigger(this.eventBusEl_, event, hash);
    }
};
/**
 * Applies {@link module:evented~EventedMixin|EventedMixin} to a target object.
 *
 * @param  {Object} target
 *         The object to which to add event methods.
 *
 * @param  {Object} [options={}]
 *         Options for customizing the mixin behavior.
 *
 * @param  {string} [options.eventBusKey]
 *         By default, adds a `eventBusEl_` DOM element to the target object,
 *         which is used as an event bus. If the target object already has a
 *         DOM element that should be used, pass its key here.
 *
 * @return {Object}
 *         The target object.
 */ function $cb03b711053a4297$var$evented(target, options = {}) {
    const { eventBusKey: eventBusKey } = options;
    // Set or create the eventBusEl_.
    if (eventBusKey) {
        if (!target[eventBusKey].nodeName) throw new Error(`The eventBusKey "${eventBusKey}" does not refer to an element.`);
        target.eventBusEl_ = target[eventBusKey];
    } else target.eventBusEl_ = $cb03b711053a4297$var$createEl('span', {
        className: 'vjs-event-bus'
    });
    Object.assign(target, $cb03b711053a4297$var$EventedMixin);
    if (target.eventedCallbacks) target.eventedCallbacks.forEach((callback)=>{
        callback();
    });
    // When any evented object is disposed, it removes all its listeners.
    target.on('dispose', ()=>{
        target.off();
        [
            target,
            target.el_,
            target.eventBusEl_
        ].forEach(function(val) {
            if (val && $cb03b711053a4297$var$DomData.has(val)) $cb03b711053a4297$var$DomData.delete(val);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            target.eventBusEl_ = null;
        }, 0);
    });
    return target;
}
/**
 * @file mixins/stateful.js
 * @module stateful
 */ /**
 * Contains methods that provide statefulness to an object which is passed
 * to {@link module:stateful}.
 *
 * @mixin StatefulMixin
 */ const $cb03b711053a4297$var$StatefulMixin = {
    /**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */ state: {},
    /**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @return {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */ setState (stateUpdates) {
        // Support providing the `stateUpdates` state as a function.
        if (typeof stateUpdates === 'function') stateUpdates = stateUpdates();
        let changes;
        $cb03b711053a4297$var$each(stateUpdates, (value, key)=>{
            // Record the change if the value is different from what's in the
            // current state.
            if (this.state[key] !== value) {
                changes = changes || {};
                changes[key] = {
                    from: this.state[key],
                    to: value
                };
            }
            this.state[key] = value;
        });
        // Only trigger "statechange" if there were changes AND we have a trigger
        // function. This allows us to not require that the target object be an
        // evented object.
        if (changes && $cb03b711053a4297$var$isEvented(this)) /**
       * An event triggered on an object that is both
       * {@link module:stateful|stateful} and {@link module:evented|evented}
       * indicating that its state has changed.
       *
       * @event    module:stateful~StatefulMixin#statechanged
       * @type     {Object}
       * @property {Object} changes
       *           A hash containing the properties that were changed and
       *           the values they were changed `from` and `to`.
       */ this.trigger({
            changes: changes,
            type: 'statechanged'
        });
        return changes;
    }
};
/**
 * Applies {@link module:stateful~StatefulMixin|StatefulMixin} to a target
 * object.
 *
 * If the target object is {@link module:evented|evented} and has a
 * `handleStateChanged` method, that method will be automatically bound to the
 * `statechanged` event on itself.
 *
 * @param   {Object} target
 *          The object to be made stateful.
 *
 * @param   {Object} [defaultState]
 *          A default set of properties to populate the newly-stateful object's
 *          `state` property.
 *
 * @return {Object}
 *          Returns the `target`.
 */ function $cb03b711053a4297$var$stateful(target, defaultState) {
    Object.assign(target, $cb03b711053a4297$var$StatefulMixin);
    // This happens after the mixing-in because we need to replace the `state`
    // added in that step.
    target.state = Object.assign({}, target.state, defaultState);
    // Auto-bind the `handleStateChanged` method of the target object if it exists.
    if (typeof target.handleStateChanged === 'function' && $cb03b711053a4297$var$isEvented(target)) target.on('statechanged', target.handleStateChanged);
    return target;
}
/**
 * @file str.js
 * @module to-lower-case
 */ /**
 * Lowercase the first letter of a string.
 *
 * @param {string} string
 *        String to be lowercased
 *
 * @return {string}
 *         The string with a lowercased first letter
 */ const $cb03b711053a4297$var$toLowerCase = function(string) {
    if (typeof string !== 'string') return string;
    return string.replace(/./, (w)=>w.toLowerCase());
};
/**
 * Uppercase the first letter of a string.
 *
 * @param {string} string
 *        String to be uppercased
 *
 * @return {string}
 *         The string with an uppercased first letter
 */ const $cb03b711053a4297$var$toTitleCase$1 = function(string) {
    if (typeof string !== 'string') return string;
    return string.replace(/./, (w)=>w.toUpperCase());
};
/**
 * Compares the TitleCase versions of the two strings for equality.
 *
 * @param {string} str1
 *        The first string to compare
 *
 * @param {string} str2
 *        The second string to compare
 *
 * @return {boolean}
 *         Whether the TitleCase versions of the strings are equal
 */ const $cb03b711053a4297$var$titleCaseEquals = function(str1, str2) {
    return $cb03b711053a4297$var$toTitleCase$1(str1) === $cb03b711053a4297$var$toTitleCase$1(str2);
};
var $cb03b711053a4297$var$Str = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    toLowerCase: $cb03b711053a4297$var$toLowerCase,
    toTitleCase: $cb03b711053a4297$var$toTitleCase$1,
    titleCaseEquals: $cb03b711053a4297$var$titleCaseEquals
});
/**
 * Player Component - Base class for all UI objects
 *
 * @file component.js
 */ /** @import Player from './player' */ /**
 * A callback to be called if and when the component is ready.
 * `this` will be the Component instance.
 *
 * @callback ReadyCallback
 * @returns  {void}
 */ /**
 * Base class for all UI Components.
 * Components are UI objects which represent both a javascript object and an element
 * in the DOM. They can be children of other components, and can have
 * children themselves.
 *
 * Components can also use methods from {@link EventTarget}
 */ class $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of component options.
   *
   * @param {Object[]} [options.children]
   *        An array of children objects to initialize this component with. Children objects have
   *        a name property that will be used if more than one component of the same type needs to be
   *        added.
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   * @param {ReadyCallback} [ready]
   *        Function that gets called when the `Component` is ready.
   */ constructor(player, options, ready){
        // The component might be the player itself and we can't pass `this` to super
        if (!player && this.play) this.player_ = player = this; // eslint-disable-line
        else this.player_ = player;
        this.isDisposed_ = false;
        // Hold the reference to the parent component via `addChild` method
        this.parentComponent_ = null;
        // Make a copy of prototype.options_ to protect against overriding defaults
        this.options_ = $cb03b711053a4297$var$merge$1({}, this.options_);
        // Updated options with supplied options
        options = this.options_ = $cb03b711053a4297$var$merge$1(this.options_, options);
        // Get ID from options or options element if one is supplied
        this.id_ = options.id || options.el && options.el.id;
        // If there was no ID from the options, generate one
        if (!this.id_) {
            // Don't require the player ID function in the case of mock players
            const id = player && player.id && player.id() || 'no_player';
            this.id_ = `${id}_component_${$cb03b711053a4297$var$newGUID()}`;
        }
        this.name_ = options.name || null;
        // Create element if one wasn't provided in options
        if (options.el) this.el_ = options.el;
        else if (options.createEl !== false) this.el_ = this.createEl();
        if (options.className && this.el_) options.className.split(' ').forEach((c)=>this.addClass(c));
        // Remove the placeholder event methods. If the component is evented, the
        // real methods are added next
        [
            'on',
            'off',
            'one',
            'any',
            'trigger'
        ].forEach((fn)=>{
            this[fn] = undefined;
        });
        // if evented is anything except false, we want to mixin in evented
        if (options.evented !== false) {
            // Make this an evented object and use `el_`, if available, as its event bus
            $cb03b711053a4297$var$evented(this, {
                eventBusKey: this.el_ ? 'el_' : null
            });
            this.handleLanguagechange = this.handleLanguagechange.bind(this);
            this.on(this.player_, 'languagechange', this.handleLanguagechange);
        }
        $cb03b711053a4297$var$stateful(this, this.constructor.defaultState);
        this.children_ = [];
        this.childIndex_ = {};
        this.childNameIndex_ = {};
        this.setTimeoutIds_ = new Set();
        this.setIntervalIds_ = new Set();
        this.rafIds_ = new Set();
        this.namedRafs_ = new Map();
        this.clearingTimersOnDispose_ = false;
        // Add any child components in options
        if (options.initChildren !== false) this.initChildren();
        // Don't want to trigger ready here or it will go before init is actually
        // finished for all children that run this constructor
        this.ready(ready);
        if (options.reportTouchActivity !== false) this.enableTouchActivity();
    }
    // `on`, `off`, `one`, `any` and `trigger` are here so tsc includes them in definitions.
    // They are replaced or removed in the constructor
    /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */ /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} [fn]
   *        The function to remove. If not specified, all listeners managed by Video.js will be removed.
   */ /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * @param {Object} [hash]
   *        Optionally extra argument to pass through to an event listener
   */ /**
   * Dispose of the `Component` and all child components.
   *
   * @fires Component#dispose
   *
   * @param {Object} options
   * @param {Element} options.originalEl element with which to replace player element
   */ dispose(options = {}) {
        // Bail out if the component has already been disposed.
        if (this.isDisposed_) return;
        if (this.readyQueue_) this.readyQueue_.length = 0;
        /**
     * Triggered when a `Component` is disposed.
     *
     * @event Component#dispose
     * @type {Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the dispose event does not
     *           bubble up
     */ this.trigger({
            type: 'dispose',
            bubbles: false
        });
        this.isDisposed_ = true;
        // Dispose all children.
        if (this.children_) {
            for(let i = this.children_.length - 1; i >= 0; i--)if (this.children_[i].dispose) this.children_[i].dispose();
        }
        // Delete child references
        this.children_ = null;
        this.childIndex_ = null;
        this.childNameIndex_ = null;
        this.parentComponent_ = null;
        if (this.el_) {
            // Remove element from DOM
            if (this.el_.parentNode) {
                if (options.restoreEl) this.el_.parentNode.replaceChild(options.restoreEl, this.el_);
                else this.el_.parentNode.removeChild(this.el_);
            }
            this.el_ = null;
        }
        // remove reference to the player after disposing of the element
        this.player_ = null;
    }
    /**
   * Determine whether or not this component has been disposed.
   *
   * @return {boolean}
   *         If the component has been disposed, will be `true`. Otherwise, `false`.
   */ isDisposed() {
        return Boolean(this.isDisposed_);
    }
    /**
   * Return the {@link Player} that the `Component` has attached to.
   *
   * @return {Player}
   *         The player that this `Component` has attached to.
   */ player() {
        return this.player_;
    }
    /**
   * Deep merge of options objects with new options.
   * > Note: When both `obj` and `options` contain properties whose values are objects.
   *         The two properties get merged using {@link module:obj.merge}
   *
   * @param {Object} obj
   *        The object that contains new options.
   *
   * @return {Object}
   *         A new object of `this.options_` and `obj` merged together.
   */ options(obj) {
        if (!obj) return this.options_;
        this.options_ = $cb03b711053a4297$var$merge$1(this.options_, obj);
        return this.options_;
    }
    /**
   * Get the `Component`s DOM element
   *
   * @return {Element}
   *         The DOM element for this `Component`.
   */ el() {
        return this.el_;
    }
    /**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tagName]
   *        Element's DOM node type. e.g. 'div'
   *
   * @param {Object} [properties]
   *        An object of properties that should be set.
   *
   * @param {Object} [attributes]
   *        An object of attributes that should be set.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(tagName, properties, attributes) {
        return $cb03b711053a4297$var$createEl(tagName, properties, attributes);
    }
    /**
   * Localize a string given the string in english.
   *
   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
   *
   * If a `defaultValue` is provided, it'll use that over `string`,
   * if a value isn't found in provided language files.
   * This is useful if you want to have a descriptive key for token replacement
   * but have a succinct localized string and not require `en.json` to be included.
   *
   * Currently, it is used for the progress bar timing.
   * ```js
   * {
   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
   * }
   * ```
   * It is then used like so:
   * ```js
   * this.localize('progress bar timing: currentTime={1} duration{2}',
   *               [this.player_.currentTime(), this.player_.duration()],
   *               '{1} of {2}');
   * ```
   *
   * Which outputs something like: `01:23 of 24:56`.
   *
   *
   * @param {string} string
   *        The string to localize and the key to lookup in the language files.
   * @param {string[]} [tokens]
   *        If the current item has token replacements, provide the tokens here.
   * @param {string} [defaultValue]
   *        Defaults to `string`. Can be a default value to use for token replacement
   *        if the lookup key is needed to be separate.
   *
   * @return {string}
   *         The localized string or if no localization exists the english string.
   */ localize(string, tokens, defaultValue = string) {
        const code = this.player_.language && this.player_.language();
        const languages = this.player_.languages && this.player_.languages();
        const language = languages && languages[code];
        const primaryCode = code && code.split('-')[0];
        const primaryLang = languages && languages[primaryCode];
        let localizedString = defaultValue;
        if (language && language[string]) localizedString = language[string];
        else if (primaryLang && primaryLang[string]) localizedString = primaryLang[string];
        if (tokens) localizedString = localizedString.replace(/\{(\d+)\}/g, function(match, index) {
            const value = tokens[index - 1];
            let ret = value;
            if (typeof value === 'undefined') ret = match;
            return ret;
        });
        return localizedString;
    }
    /**
   * Handles language change for the player in components. Should be overridden by sub-components.
   *
   * @abstract
   */ handleLanguagechange() {}
    /**
   * Return the `Component`s DOM element. This is where children get inserted.
   * This will usually be the the same as the element returned in {@link Component#el}.
   *
   * @return {Element}
   *         The content element for this `Component`.
   */ contentEl() {
        return this.contentEl_ || this.el_;
    }
    /**
   * Get this `Component`s ID
   *
   * @return {string}
   *         The id of this `Component`
   */ id() {
        return this.id_;
    }
    /**
   * Get the `Component`s name. The name gets used to reference the `Component`
   * and is set during registration.
   *
   * @return {string}
   *         The name of this `Component`.
   */ name() {
        return this.name_;
    }
    /**
   * Get an array of all child components
   *
   * @return {Array}
   *         The children
   */ children() {
        return this.children_;
    }
    /**
   * Returns the child `Component` with the given `id`.
   *
   * @param {string} id
   *        The id of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `id` or undefined.
   */ getChildById(id) {
        return this.childIndex_[id];
    }
    /**
   * Returns the child `Component` with the given `name`.
   *
   * @param {string} name
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `name` or undefined.
   */ getChild(name) {
        if (!name) return;
        return this.childNameIndex_[name];
    }
    /**
   * Returns the descendant `Component` following the givent
   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
   * try to get 'foo' on the current component, 'bar' on the 'foo'
   * component and 'baz' on the 'bar' component and return undefined
   * if any of those don't exist.
   *
   * @param {...string[]|...string} names
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The descendant `Component` following the given descendant
   *         `names` or undefined.
   */ getDescendant(...names) {
        // flatten array argument into the main array
        names = names.reduce((acc, n)=>acc.concat(n), []);
        let currentChild = this;
        for(let i = 0; i < names.length; i++){
            currentChild = currentChild.getChild(names[i]);
            if (!currentChild || !currentChild.getChild) return;
        }
        return currentChild;
    }
    /**
   * Adds an SVG icon element to another element or component.
   *
   * @param {string} iconName
   *        The name of icon. A list of all the icon names can be found at 'sandbox/svg-icons.html'
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on. Defaults to the current Component's element.
   *
   * @return {Element}
   *        The newly created icon element.
   */ setIcon(iconName, el = this.el()) {
        // TODO: In v9 of video.js, we will want to remove font icons entirely.
        // This means this check, as well as the others throughout the code, and
        // the unecessary CSS for font icons, will need to be removed.
        // See https://github.com/videojs/video.js/pull/8260 as to which components
        // need updating.
        if (!this.player_.options_.experimentalSvgIcons) return;
        const xmlnsURL = 'http://www.w3.org/2000/svg';
        // The below creates an element in the format of:
        // <span><svg><use>....</use></svg></span>
        const iconContainer = $cb03b711053a4297$var$createEl('span', {
            className: 'vjs-icon-placeholder vjs-svg-icon'
        }, {
            'aria-hidden': 'true'
        });
        const svgEl = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElementNS(xmlnsURL, 'svg');
        svgEl.setAttributeNS(null, 'viewBox', '0 0 512 512');
        const useEl = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElementNS(xmlnsURL, 'use');
        svgEl.appendChild(useEl);
        useEl.setAttributeNS(null, 'href', `#vjs-icon-${iconName}`);
        iconContainer.appendChild(svgEl);
        // Replace a pre-existing icon if one exists.
        if (this.iconIsSet_) el.replaceChild(iconContainer, el.querySelector('.vjs-icon-placeholder'));
        else el.appendChild(iconContainer);
        this.iconIsSet_ = true;
        return iconContainer;
    }
    /**
   * Add a child `Component` inside the current `Component`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @param {number} [index=this.children_.length]
   *        The index to attempt to add a child into.
   *
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   */ addChild(child, options = {}, index = this.children_.length) {
        let component;
        let componentName;
        // If child is a string, create component with options
        if (typeof child === 'string') {
            componentName = $cb03b711053a4297$var$toTitleCase$1(child);
            const componentClassName = options.componentClass || componentName;
            // Set name through options
            options.name = componentName;
            // Create a new object & element for this controls set
            // If there's no .player_, this is a player
            const ComponentClass = $cb03b711053a4297$var$Component$1.getComponent(componentClassName);
            if (!ComponentClass) throw new Error(`Component ${componentClassName} does not exist`);
            // data stored directly on the videojs object may be
            // misidentified as a component to retain
            // backwards-compatibility with 4.x. check to make sure the
            // component class can be instantiated.
            if (typeof ComponentClass !== 'function') return null;
            component = new ComponentClass(this.player_ || this, options);
        // child is a component instance
        } else component = child;
        if (component.parentComponent_) component.parentComponent_.removeChild(component);
        this.children_.splice(index, 0, component);
        component.parentComponent_ = this;
        if (typeof component.id === 'function') this.childIndex_[component.id()] = component;
        // If a name wasn't used to create the component, check if we can use the
        // name function of the component
        componentName = componentName || component.name && $cb03b711053a4297$var$toTitleCase$1(component.name());
        if (componentName) {
            this.childNameIndex_[componentName] = component;
            this.childNameIndex_[$cb03b711053a4297$var$toLowerCase(componentName)] = component;
        }
        // Add the UI object's element to the container div (box)
        // Having an element is not required
        if (typeof component.el === 'function' && component.el()) {
            // If inserting before a component, insert before that component's element
            let refNode = null;
            if (this.children_[index + 1]) {
                // Most children are components, but the video tech is an HTML element
                if (this.children_[index + 1].el_) refNode = this.children_[index + 1].el_;
                else if ($cb03b711053a4297$var$isEl(this.children_[index + 1])) refNode = this.children_[index + 1];
            }
            this.contentEl().insertBefore(component.el(), refNode);
        }
        // Return so it can stored on parent object if desired.
        return component;
    }
    /**
   * Remove a child `Component` from this `Component`s list of children. Also removes
   * the child `Component`s element from this `Component`s element.
   *
   * @param {string|Component} component
   *       The name or instance of a child to remove.
   */ removeChild(component) {
        if (typeof component === 'string') component = this.getChild(component);
        if (!component || !this.children_) return;
        let childFound = false;
        for(let i = this.children_.length - 1; i >= 0; i--)if (this.children_[i] === component) {
            childFound = true;
            this.children_.splice(i, 1);
            break;
        }
        if (!childFound) return;
        component.parentComponent_ = null;
        this.childIndex_[component.id()] = null;
        this.childNameIndex_[$cb03b711053a4297$var$toTitleCase$1(component.name())] = null;
        this.childNameIndex_[$cb03b711053a4297$var$toLowerCase(component.name())] = null;
        const compEl = component.el();
        if (compEl && compEl.parentNode === this.contentEl()) this.contentEl().removeChild(component.el());
    }
    /**
   * Add and initialize default child `Component`s based upon options.
   */ initChildren() {
        const children = this.options_.children;
        if (children) {
            // `this` is `parent`
            const parentOptions = this.options_;
            const handleAdd = (child)=>{
                const name = child.name;
                let opts = child.opts;
                // Allow options for children to be set at the parent options
                // e.g. videojs(id, { controlBar: false });
                // instead of videojs(id, { children: { controlBar: false });
                if (parentOptions[name] !== undefined) opts = parentOptions[name];
                // Allow for disabling default components
                // e.g. options['children']['posterImage'] = false
                if (opts === false) return;
                // Allow options to be passed as a simple boolean if no configuration
                // is necessary.
                if (opts === true) opts = {};
                // We also want to pass the original player options
                // to each component as well so they don't need to
                // reach back into the player for options later.
                opts.playerOptions = this.options_.playerOptions;
                // Create and add the child component.
                // Add a direct reference to the child by name on the parent instance.
                // If two of the same component are used, different names should be supplied
                // for each
                const newChild = this.addChild(name, opts);
                if (newChild) this[name] = newChild;
            };
            // Allow for an array of children details to passed in the options
            let workingChildren;
            const Tech = $cb03b711053a4297$var$Component$1.getComponent('Tech');
            if (Array.isArray(children)) workingChildren = children;
            else workingChildren = Object.keys(children);
            workingChildren// children that are in this.options_ but also in workingChildren  would
            // give us extra children we do not want. So, we want to filter them out.
            .concat(Object.keys(this.options_).filter(function(child) {
                return !workingChildren.some(function(wchild) {
                    if (typeof wchild === 'string') return child === wchild;
                    return child === wchild.name;
                });
            })).map((child)=>{
                let name;
                let opts;
                if (typeof child === 'string') {
                    name = child;
                    opts = children[name] || this.options_[name] || {};
                } else {
                    name = child.name;
                    opts = child;
                }
                return {
                    name: name,
                    opts: opts
                };
            }).filter((child)=>{
                // we have to make sure that child.name isn't in the techOrder since
                // techs are registered as Components but can't aren't compatible
                // See https://github.com/videojs/video.js/issues/2772
                const c = $cb03b711053a4297$var$Component$1.getComponent(child.opts.componentClass || $cb03b711053a4297$var$toTitleCase$1(child.name));
                return c && !Tech.isTech(c);
            }).forEach(handleAdd);
        }
    }
    /**
   * Builds the default DOM class name. Should be overridden by sub-components.
   *
   * @return {string}
   *         The DOM class name for this object.
   *
   * @abstract
   */ buildCSSClass() {
        // Child classes can include a function that does:
        // return 'CLASS NAME' + this._super();
        return '';
    }
    /**
   * Bind a listener to the component's ready state.
   * Different from event listeners in that if the ready event has already happened
   * it will trigger the function immediately.
   *
   * @param {ReadyCallback} fn
   *        Function that gets called when the `Component` is ready.
   */ ready(fn, sync = false) {
        if (!fn) return;
        if (!this.isReady_) {
            this.readyQueue_ = this.readyQueue_ || [];
            this.readyQueue_.push(fn);
            return;
        }
        if (sync) fn.call(this);
        else // Call the function asynchronously by default for consistency
        this.setTimeout(fn, 1);
    }
    /**
   * Trigger all the ready listeners for this `Component`.
   *
   * @fires Component#ready
   */ triggerReady() {
        this.isReady_ = true;
        // Ensure ready is triggered asynchronously
        this.setTimeout(function() {
            const readyQueue = this.readyQueue_;
            // Reset Ready Queue
            this.readyQueue_ = [];
            if (readyQueue && readyQueue.length > 0) readyQueue.forEach(function(fn) {
                fn.call(this);
            }, this);
            // Allow for using event listeners also
            /**
       * Triggered when a `Component` is ready.
       *
       * @event Component#ready
       * @type {Event}
       */ this.trigger('ready');
        }, 1);
    }
    /**
   * Find a single DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelector`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {Element|null}
   *         the dom element that was found, or null
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */ $(selector, context) {
        return $cb03b711053a4297$var$$(selector, context || this.contentEl());
    }
    /**
   * Finds all DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelectorAll`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {NodeList}
   *         a list of dom elements that were found
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */ $$(selector, context) {
        return $cb03b711053a4297$var$$$(selector, context || this.contentEl());
    }
    /**
   * Check if a component's element has a CSS class name.
   *
   * @param {string} classToCheck
   *        CSS class name to check.
   *
   * @return {boolean}
   *         - True if the `Component` has the class.
   *         - False if the `Component` does not have the class`
   */ hasClass(classToCheck) {
        return $cb03b711053a4297$var$hasClass(this.el_, classToCheck);
    }
    /**
   * Add a CSS class name to the `Component`s element.
   *
   * @param {...string} classesToAdd
   *        One or more CSS class name to add.
   */ addClass(...classesToAdd) {
        $cb03b711053a4297$var$addClass(this.el_, ...classesToAdd);
    }
    /**
   * Remove a CSS class name from the `Component`s element.
   *
   * @param {...string} classesToRemove
   *        One or more CSS class name to remove.
   */ removeClass(...classesToRemove) {
        $cb03b711053a4297$var$removeClass(this.el_, ...classesToRemove);
    }
    /**
   * Add or remove a CSS class name from the component's element.
   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
   *
   * @param  {string} classToToggle
   *         The class to add or remove. Passed to DOMTokenList's toggle()
   *
   * @param  {boolean|Dom.PredicateCallback} [predicate]
   *         A boolean or function that returns a boolean. Passed to DOMTokenList's toggle().
   */ toggleClass(classToToggle, predicate) {
        $cb03b711053a4297$var$toggleClass(this.el_, classToToggle, predicate);
    }
    /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */ show() {
        this.removeClass('vjs-hidden');
    }
    /**
   * Hide the `Component`s element if it is currently showing by adding the
   * 'vjs-hidden` class name to it.
   */ hide() {
        this.addClass('vjs-hidden');
    }
    /**
   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
   * class name to it. Used during fadeIn/fadeOut.
   *
   * @private
   */ lockShowing() {
        this.addClass('vjs-lock-showing');
    }
    /**
   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
   * class name from it. Used during fadeIn/fadeOut.
   *
   * @private
   */ unlockShowing() {
        this.removeClass('vjs-lock-showing');
    }
    /**
   * Get the value of an attribute on the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to get the value from.
   *
   * @return {string|null}
   *         - The value of the attribute that was asked for.
   *         - Can be an empty string on some browsers if the attribute does not exist
   *           or has no value
   *         - Most browsers will return null if the attribute does not exist or has
   *           no value.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
   */ getAttribute(attribute) {
        return $cb03b711053a4297$var$getAttribute(this.el_, attribute);
    }
    /**
   * Set the value of an attribute on the `Component`'s element
   *
   * @param {string} attribute
   *        Name of the attribute to set.
   *
   * @param {string} value
   *        Value to set the attribute to.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
   */ setAttribute(attribute, value) {
        $cb03b711053a4297$var$setAttribute(this.el_, attribute, value);
    }
    /**
   * Remove an attribute from the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to remove.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
   */ removeAttribute(attribute) {
        $cb03b711053a4297$var$removeAttribute(this.el_, attribute);
    }
    /**
   * Get or set the width of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The width that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The width when getting, zero if there is no width
   */ width(num, skipListeners) {
        return this.dimension('width', num, skipListeners);
    }
    /**
   * Get or set the height of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The height that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The height when getting, zero if there is no height
   */ height(num, skipListeners) {
        return this.dimension('height', num, skipListeners);
    }
    /**
   * Set both the width and height of the `Component` element at the same time.
   *
   * @param  {number|string} width
   *         Width to set the `Component`s element to.
   *
   * @param  {number|string} height
   *         Height to set the `Component`s element to.
   */ dimensions(width, height) {
        // Skip componentresize listeners on width for optimization
        this.width(width, true);
        this.height(height);
    }
    /**
   * Get or set width or height of the `Component` element. This is the shared code
   * for the {@link Component#width} and {@link Component#height}.
   *
   * Things to know:
   * - If the width or height in an number this will return the number postfixed with 'px'.
   * - If the width/height is a percent this will return the percent postfixed with '%'
   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
   *   for more information
   * - If you want the computed style of the component, use {@link Component#currentWidth}
   *   and {@link {Component#currentHeight}
   *
   * @fires Component#componentresize
   *
   * @param {string} widthOrHeight
   8        'width' or 'height'
   *
   * @param  {number|string} [num]
   8         New dimension
   *
   * @param  {boolean} [skipListeners]
   *         Skip componentresize event trigger
   *
   * @return {number|undefined}
   *         The dimension when getting or 0 if unset
   */ dimension(widthOrHeight, num, skipListeners) {
        if (num !== undefined) {
            // Set to zero if null or literally NaN (NaN !== NaN)
            if (num === null || num !== num) num = 0;
            // Check if using css width/height (% or px) and adjust
            if (('' + num).indexOf('%') !== -1 || ('' + num).indexOf('px') !== -1) this.el_.style[widthOrHeight] = num;
            else if (num === 'auto') this.el_.style[widthOrHeight] = '';
            else this.el_.style[widthOrHeight] = num + 'px';
            // skipListeners allows us to avoid triggering the resize event when setting both width and height
            if (!skipListeners) /**
         * Triggered when a component is resized.
         *
         * @event Component#componentresize
         * @type {Event}
         */ this.trigger('componentresize');
            return;
        }
        // Not setting a value, so getting it
        // Make sure element exists
        if (!this.el_) return 0;
        // Get dimension value from style
        const val = this.el_.style[widthOrHeight];
        const pxIndex = val.indexOf('px');
        if (pxIndex !== -1) // Return the pixel value with no 'px'
        return parseInt(val.slice(0, pxIndex), 10);
        // No px so using % or no style was set, so falling back to offsetWidth/height
        // If component has display:none, offset will return 0
        // TODO: handle display:none and no dimension style using px
        return parseInt(this.el_['offset' + $cb03b711053a4297$var$toTitleCase$1(widthOrHeight)], 10);
    }
    /**
   * Get the computed width or the height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @param {string} widthOrHeight
   *        A string containing 'width' or 'height'. Whichever one you want to get.
   *
   * @return {number}
   *         The dimension that gets asked for or 0 if nothing was set
   *         for that dimension.
   */ currentDimension(widthOrHeight) {
        let computedWidthOrHeight = 0;
        if (widthOrHeight !== 'width' && widthOrHeight !== 'height') throw new Error('currentDimension only accepts width or height value');
        computedWidthOrHeight = $cb03b711053a4297$var$computedStyle(this.el_, widthOrHeight);
        // remove 'px' from variable and parse as integer
        computedWidthOrHeight = parseFloat(computedWidthOrHeight);
        // if the computed value is still 0, it's possible that the browser is lying
        // and we want to check the offset values.
        // This code also runs wherever getComputedStyle doesn't exist.
        if (computedWidthOrHeight === 0 || isNaN(computedWidthOrHeight)) {
            const rule = `offset${$cb03b711053a4297$var$toTitleCase$1(widthOrHeight)}`;
            computedWidthOrHeight = this.el_[rule];
        }
        return computedWidthOrHeight;
    }
    /**
   * An object that contains width and height values of the `Component`s
   * computed style. Uses `window.getComputedStyle`.
   *
   * @typedef {Object} Component~DimensionObject
   *
   * @property {number} width
   *           The width of the `Component`s computed style.
   *
   * @property {number} height
   *           The height of the `Component`s computed style.
   */ /**
   * Get an object that contains computed width and height values of the
   * component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {Component~DimensionObject}
   *         The computed dimensions of the component's element.
   */ currentDimensions() {
        return {
            width: this.currentDimension('width'),
            height: this.currentDimension('height')
        };
    }
    /**
   * Get the computed width of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed width of the component's element.
   */ currentWidth() {
        return this.currentDimension('width');
    }
    /**
   * Get the computed height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed height of the component's element.
   */ currentHeight() {
        return this.currentDimension('height');
    }
    /**
   * Retrieves the position and size information of the component's element.
   *
   * @return {Object} An object with `boundingClientRect` and `center` properties.
   *         - `boundingClientRect`: An object with properties `x`, `y`, `width`,
   *           `height`, `top`, `right`, `bottom`, and `left`, representing
   *           the bounding rectangle of the element.
   *         - `center`: An object with properties `x` and `y`, representing
   *           the center point of the element. `width` and `height` are set to 0.
   */ getPositions() {
        const rect = this.el_.getBoundingClientRect();
        // Creating objects that mirror DOMRectReadOnly for boundingClientRect and center
        const boundingClientRect = {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left
        };
        // Calculating the center position
        const center = {
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2,
            width: 0,
            height: 0,
            top: rect.top + rect.height / 2,
            right: rect.left + rect.width / 2,
            bottom: rect.top + rect.height / 2,
            left: rect.left + rect.width / 2
        };
        return {
            boundingClientRect: boundingClientRect,
            center: center
        };
    }
    /**
   * Set the focus to this component
   */ focus() {
        this.el_.focus();
    }
    /**
   * Remove the focus from this component
   */ blur() {
        this.el_.blur();
    }
    /**
   * When this Component receives a `keydown` event which it does not process,
   *  it passes the event to the Player for handling.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   */ handleKeyDown(event) {
        if (this.player_) {
            // We only stop propagation here because we want unhandled events to fall
            // back to the browser. Exclude Tab for focus trapping, exclude also when spatialNavigation is enabled.
            if (event.key !== 'Tab' && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) event.stopPropagation();
            this.player_.handleKeyDown(event);
        }
    }
    /**
   * Many components used to have a `handleKeyPress` method, which was poorly
   * named because it listened to a `keydown` event. This method name now
   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
   * will not see their method calls stop working.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to be called.
   */ handleKeyPress(event) {
        this.handleKeyDown(event);
    }
    /**
   * Emit a 'tap' events when touch event support gets detected. This gets used to
   * support toggling the controls through a tap on the video. They get enabled
   * because every sub-component would have extra overhead otherwise.
   *
   * @protected
   * @fires Component#tap
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchleave
   * @listens Component#touchcancel
   * @listens Component#touchend
    */ emitTapEvents() {
        // Track the start time so we can determine how long the touch lasted
        let touchStart = 0;
        let firstTouch = null;
        // Maximum movement allowed during a touch event to still be considered a tap
        // Other popular libs use anywhere from 2 (hammer.js) to 15,
        // so 10 seems like a nice, round number.
        const tapMovementThreshold = 10;
        // The maximum length a touch can be while still being considered a tap
        const touchTimeThreshold = 200;
        let couldBeTap;
        this.on('touchstart', function(event) {
            // If more than one finger, don't consider treating this as a click
            if (event.touches.length === 1) {
                // Copy pageX/pageY from the object
                firstTouch = {
                    pageX: event.touches[0].pageX,
                    pageY: event.touches[0].pageY
                };
                // Record start time so we can detect a tap vs. "touch and hold"
                touchStart = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now();
                // Reset couldBeTap tracking
                couldBeTap = true;
            }
        });
        this.on('touchmove', function(event) {
            // If more than one finger, don't consider treating this as a click
            if (event.touches.length > 1) couldBeTap = false;
            else if (firstTouch) {
                // Some devices will throw touchmoves for all but the slightest of taps.
                // So, if we moved only a small distance, this could still be a tap
                const xdiff = event.touches[0].pageX - firstTouch.pageX;
                const ydiff = event.touches[0].pageY - firstTouch.pageY;
                const touchDistance = Math.sqrt(xdiff * xdiff + ydiff * ydiff);
                if (touchDistance > tapMovementThreshold) couldBeTap = false;
            }
        });
        const noTap = function() {
            couldBeTap = false;
        };
        // TODO: Listen to the original target. http://youtu.be/DujfpXOKUp8?t=13m8s
        this.on('touchleave', noTap);
        this.on('touchcancel', noTap);
        // When the touch ends, measure how long it took and trigger the appropriate
        // event
        this.on('touchend', function(event) {
            firstTouch = null;
            // Proceed only if the touchmove/leave/cancel event didn't happen
            if (couldBeTap === true) {
                // Measure how long the touch lasted
                const touchTime = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now() - touchStart;
                // Make sure the touch was less than the threshold to be considered a tap
                if (touchTime < touchTimeThreshold) {
                    // Don't let browser turn this into a click
                    event.preventDefault();
                    /**
           * Triggered when a `Component` is tapped.
           *
           * @event Component#tap
           * @type {MouseEvent}
           */ this.trigger('tap');
                // It may be good to copy the touchend event object and change the
                // type to tap, if the other event properties aren't exact after
                // Events.fixEvent runs (e.g. event.target)
                }
            }
        });
    }
    /**
   * This function reports user activity whenever touch events happen. This can get
   * turned off by any sub-components that wants touch events to act another way.
   *
   * Report user touch activity when touch events occur. User activity gets used to
   * determine when controls should show/hide. It is simple when it comes to mouse
   * events, because any mouse event should show the controls. So we capture mouse
   * events that bubble up to the player and report activity when that happens.
   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
   * controls. So touch events can't help us at the player level either.
   *
   * User activity gets checked asynchronously. So what could happen is a tap event
   * on the video turns the controls off. Then the `touchend` event bubbles up to
   * the player. Which, if it reported user activity, would turn the controls right
   * back on. We also don't want to completely block touch events from bubbling up.
   * Furthermore a `touchmove` event and anything other than a tap, should not turn
   * controls back on.
   *
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchend
   * @listens Component#touchcancel
   */ enableTouchActivity() {
        // Don't continue if the root player doesn't support reporting user activity
        if (!this.player() || !this.player().reportUserActivity) return;
        // listener for reporting that the user is active
        const report = $cb03b711053a4297$var$bind_(this.player(), this.player().reportUserActivity);
        let touchHolding;
        this.on('touchstart', function() {
            report();
            // For as long as the they are touching the device or have their mouse down,
            // we consider them active even if they're not moving their finger or mouse.
            // So we want to continue to update that they are active
            this.clearInterval(touchHolding);
            // report at the same interval as activityCheck
            touchHolding = this.setInterval(report, 250);
        });
        const touchEnd = function(event) {
            report();
            // stop the interval that maintains activity if the touch is holding
            this.clearInterval(touchHolding);
        };
        this.on('touchmove', report);
        this.on('touchend', touchEnd);
        this.on('touchcancel', touchEnd);
    }
    /**
   * A callback that has no parameters and is bound into `Component`s context.
   *
   * @callback Component~GenericCallback
   * @this Component
   */ /**
   * Creates a function that runs after an `x` millisecond timeout. This function is a
   * wrapper around `window.setTimeout`. There are a few reasons to use this one
   * instead though:
   * 1. It gets cleared via  {@link Component#clearTimeout} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
   *
   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
   *         will cause its dispose listener not to get cleaned up! Please use
   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
   *
   * @param {Component~GenericCallback} fn
   *        The function that will be run after `timeout`.
   *
   * @param {number} timeout
   *        Timeout in milliseconds to delay before executing the specified function.
   *
   * @return {number}
   *         Returns a timeout ID that gets used to identify the timeout. It can also
   *         get used in {@link Component#clearTimeout} to clear the timeout that
   *         was set.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
   */ setTimeout(fn, timeout) {
        // declare as variables so they are properly available in timeout function
        // eslint-disable-next-line
        var timeoutId;
        fn = $cb03b711053a4297$var$bind_(this, fn);
        this.clearTimersOnDispose_();
        timeoutId = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            if (this.setTimeoutIds_.has(timeoutId)) this.setTimeoutIds_.delete(timeoutId);
            fn();
        }, timeout);
        this.setTimeoutIds_.add(timeoutId);
        return timeoutId;
    }
    /**
   * Clears a timeout that gets created via `window.setTimeout` or
   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
   * use this function instead of `window.clearTimout`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} timeoutId
   *        The id of the timeout to clear. The return value of
   *        {@link Component#setTimeout} or `window.setTimeout`.
   *
   * @return {number}
   *         Returns the timeout id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
   */ clearTimeout(timeoutId) {
        if (this.setTimeoutIds_.has(timeoutId)) {
            this.setTimeoutIds_.delete(timeoutId);
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(timeoutId);
        }
        return timeoutId;
    }
    /**
   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
   * around `window.setInterval`. There are a few reasons to use this one instead though.
   * 1. It gets cleared via  {@link Component#clearInterval} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will be a {@link Component~GenericCallback}
   *
   * @param {Component~GenericCallback} fn
   *        The function to run every `x` seconds.
   *
   * @param {number} interval
   *        Execute the specified function every `x` milliseconds.
   *
   * @return {number}
   *         Returns an id that can be used to identify the interval. It can also be be used in
   *         {@link Component#clearInterval} to clear the interval.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
   */ setInterval(fn, interval) {
        fn = $cb03b711053a4297$var$bind_(this, fn);
        this.clearTimersOnDispose_();
        const intervalId = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setInterval(fn, interval);
        this.setIntervalIds_.add(intervalId);
        return intervalId;
    }
    /**
   * Clears an interval that gets created via `window.setInterval` or
   * {@link Component#setInterval}. If you set an interval via {@link Component#setInterval}
   * use this function instead of `window.clearInterval`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} intervalId
   *        The id of the interval to clear. The return value of
   *        {@link Component#setInterval} or `window.setInterval`.
   *
   * @return {number}
   *         Returns the interval id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
   */ clearInterval(intervalId) {
        if (this.setIntervalIds_.has(intervalId)) {
            this.setIntervalIds_.delete(intervalId);
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearInterval(intervalId);
        }
        return intervalId;
    }
    /**
   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
   * with a few extra bonuses:
   *
   * - Supports browsers that do not support rAF by falling back to
   *   {@link Component#setTimeout}.
   *
   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
   *   bound to the component).
   *
   * - Automatic cancellation of the rAF callback is handled if the component
   *   is disposed before it is called.
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   *
   * @return {number}
   *         Returns an rAF ID that gets used to identify the timeout. It can
   *         also be used in {@link Component#cancelAnimationFrame} to cancel
   *         the animation frame callback.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
   */ requestAnimationFrame(fn) {
        this.clearTimersOnDispose_();
        // declare as variables so they are properly available in rAF function
        // eslint-disable-next-line
        var id;
        fn = $cb03b711053a4297$var$bind_(this, fn);
        id = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).requestAnimationFrame(()=>{
            if (this.rafIds_.has(id)) this.rafIds_.delete(id);
            fn();
        });
        this.rafIds_.add(id);
        return id;
    }
    /**
   * Request an animation frame, but only one named animation
   * frame will be queued. Another will never be added until
   * the previous one finishes.
   *
   * @param {string} name
   *        The name to give this requestAnimationFrame
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   */ requestNamedAnimationFrame(name, fn) {
        if (this.namedRafs_.has(name)) this.cancelNamedAnimationFrame(name);
        this.clearTimersOnDispose_();
        fn = $cb03b711053a4297$var$bind_(this, fn);
        const id = this.requestAnimationFrame(()=>{
            fn();
            if (this.namedRafs_.has(name)) this.namedRafs_.delete(name);
        });
        this.namedRafs_.set(name, id);
        return name;
    }
    /**
   * Cancels a current named animation frame if it exists.
   *
   * @param {string} name
   *        The name of the requestAnimationFrame to cancel.
   */ cancelNamedAnimationFrame(name) {
        if (!this.namedRafs_.has(name)) return;
        this.cancelAnimationFrame(this.namedRafs_.get(name));
        this.namedRafs_.delete(name);
    }
    /**
   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
   * (rAF).
   *
   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
   * use this function instead of `window.cancelAnimationFrame`. If you don't,
   * your dispose listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} id
   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
   *
   * @return {number}
   *         Returns the rAF ID that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
   */ cancelAnimationFrame(id) {
        if (this.rafIds_.has(id)) {
            this.rafIds_.delete(id);
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).cancelAnimationFrame(id);
        }
        return id;
    }
    /**
   * A function to setup `requestAnimationFrame`, `setTimeout`,
   * and `setInterval`, clearing on dispose.
   *
   * > Previously each timer added and removed dispose listeners on it's own.
   * For better performance it was decided to batch them all, and use `Set`s
   * to track outstanding timer ids.
   *
   * @private
   */ clearTimersOnDispose_() {
        if (this.clearingTimersOnDispose_) return;
        this.clearingTimersOnDispose_ = true;
        this.one('dispose', ()=>{
            [
                [
                    'namedRafs_',
                    'cancelNamedAnimationFrame'
                ],
                [
                    'rafIds_',
                    'cancelAnimationFrame'
                ],
                [
                    'setTimeoutIds_',
                    'clearTimeout'
                ],
                [
                    'setIntervalIds_',
                    'clearInterval'
                ]
            ].forEach(([idName, cancelName])=>{
                // for a `Set` key will actually be the value again
                // so forEach((val, val) =>` but for maps we want to use
                // the key.
                this[idName].forEach((val, key)=>this[cancelName](key));
            });
            this.clearingTimersOnDispose_ = false;
        });
    }
    /**
    * Decide whether an element is actually disabled or not.
    *
    * @function isActuallyDisabled
    * @param element {Node}
    * @return {boolean}
    *
    * @see {@link https://html.spec.whatwg.org/multipage/semantics-other.html#concept-element-disabled}
    */ getIsDisabled() {
        return Boolean(this.el_.disabled);
    }
    /**
    * Decide whether the element is expressly inert or not.
    *
    * @see {@link https://html.spec.whatwg.org/multipage/interaction.html#expressly-inert}
    * @function isExpresslyInert
    * @param element {Node}
    * @return {boolean}
    */ getIsExpresslyInert() {
        return this.el_.inert && !this.el_.ownerDocument.documentElement.inert;
    }
    /**
   * Determine whether or not this component can be considered as focusable component.
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can be focused, will be `true`. Otherwise, `false`.
   */ getIsFocusable(el) {
        const element = el || this.el_;
        return element.tabIndex >= 0 && !(this.getIsDisabled() || this.getIsExpresslyInert());
    }
    /**
   * Determine whether or not this component is currently visible/enabled/etc...
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can is currently visible & enabled, will be `true`. Otherwise, `false`.
   */ getIsAvailableToBeFocused(el) {
        /**
     * Decide the style property of this element is specified whether it's visible or not.
     *
     * @function isVisibleStyleProperty
     * @param element {CSSStyleDeclaration}
     * @return {boolean}
     */ function isVisibleStyleProperty(element) {
            const elementStyle = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).getComputedStyle(element, null);
            const thisVisibility = elementStyle.getPropertyValue('visibility');
            const thisDisplay = elementStyle.getPropertyValue('display');
            const invisibleStyle = [
                'hidden',
                'collapse'
            ];
            return thisDisplay !== 'none' && !invisibleStyle.includes(thisVisibility);
        }
        /**
     * Decide whether the element is being rendered or not.
     * 1. If an element has the style as "visibility: hidden | collapse" or "display: none", it is not being rendered.
     * 2. If an element has the style as "opacity: 0", it is not being rendered.(that is, invisible).
     * 3. If width and height of an element are explicitly set to 0, it is not being rendered.
     * 4. If a parent element is hidden, an element itself is not being rendered.
     * (CSS visibility property and display property are inherited.)
     *
     * @see {@link https://html.spec.whatwg.org/multipage/rendering.html#being-rendered}
     * @function isBeingRendered
     * @param element {Node}
     * @return {boolean}
     */ function isBeingRendered(element) {
            if (!isVisibleStyleProperty(element.parentElement)) return false;
            if (!isVisibleStyleProperty(element) || element.style.opacity === '0' || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).getComputedStyle(element).height === '0px' || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).getComputedStyle(element).width === '0px') return false;
            return true;
        }
        /**
     * Determine if the element is visible for the user or not.
     * 1. If an element sum of its offsetWidth, offsetHeight, height and width is less than 1 is not visible.
     * 2. If elementCenter.x is less than is not visible.
     * 3. If elementCenter.x is more than the document's width is not visible.
     * 4. If elementCenter.y is less than 0 is not visible.
     * 5. If elementCenter.y is the document's height is not visible.
     *
     * @function isVisible
     * @param element {Node}
     * @return {boolean}
     */ function isVisible(element) {
            if (element.offsetWidth + element.offsetHeight + element.getBoundingClientRect().height + element.getBoundingClientRect().width === 0) return false;
            // Define elementCenter object with props of x and y
            // x: Left position relative to the viewport plus element's width (no margin) divided between 2.
            // y: Top position relative to the viewport plus element's height (no margin) divided between 2.
            const elementCenter = {
                x: element.getBoundingClientRect().left + element.offsetWidth / 2,
                y: element.getBoundingClientRect().top + element.offsetHeight / 2
            };
            if (elementCenter.x < 0) return false;
            if (elementCenter.x > ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).documentElement.clientWidth || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).innerWidth)) return false;
            if (elementCenter.y < 0) return false;
            if (elementCenter.y > ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).documentElement.clientHeight || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).innerHeight)) return false;
            let pointContainer = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).elementFromPoint(elementCenter.x, elementCenter.y);
            while(pointContainer){
                if (pointContainer === element) return true;
                if (pointContainer.parentNode) pointContainer = pointContainer.parentNode;
                else return false;
            }
        }
        // If no DOM element was passed as argument use this component's element.
        if (!el) el = this.el();
        // If element is visible, is being rendered & either does not have a parent element or its tabIndex is not negative.
        if (isVisible(el) && isBeingRendered(el) && (!el.parentElement || el.tabIndex >= 0)) return true;
        return false;
    }
    /**
   * Register a `Component` with `videojs` given the name and the component.
   *
   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
   *         should be registered using {@link Tech.registerTech} or
   *         {@link videojs:videojs.registerTech}.
   *
   * > NOTE: This function can also be seen on videojs as
   *         {@link videojs:videojs.registerComponent}.
   *
   * @param {string} name
   *        The name of the `Component` to register.
   *
   * @param {Component} ComponentToRegister
   *        The `Component` class to register.
   *
   * @return {Component}
   *         The `Component` that was registered.
   */ static registerComponent(name, ComponentToRegister) {
        if (typeof name !== 'string' || !name) throw new Error(`Illegal component name, "${name}"; must be a non-empty string.`);
        const Tech = $cb03b711053a4297$var$Component$1.getComponent('Tech');
        // We need to make sure this check is only done if Tech has been registered.
        const isTech = Tech && Tech.isTech(ComponentToRegister);
        const isComp = $cb03b711053a4297$var$Component$1 === ComponentToRegister || $cb03b711053a4297$var$Component$1.prototype.isPrototypeOf(ComponentToRegister.prototype);
        if (isTech || !isComp) {
            let reason;
            if (isTech) reason = 'techs must be registered using Tech.registerTech()';
            else reason = 'must be a Component subclass';
            throw new Error(`Illegal component, "${name}"; ${reason}.`);
        }
        name = $cb03b711053a4297$var$toTitleCase$1(name);
        if (!$cb03b711053a4297$var$Component$1.components_) $cb03b711053a4297$var$Component$1.components_ = {};
        const Player = $cb03b711053a4297$var$Component$1.getComponent('Player');
        if (name === 'Player' && Player && Player.players) {
            const players = Player.players;
            const playerNames = Object.keys(players);
            // If we have players that were disposed, then their name will still be
            // in Players.players. So, we must loop through and verify that the value
            // for each item is null. This allows registration of the Player component
            // after all players have been disposed or before any were created.
            if (players && playerNames.length > 0) for(let i = 0; i < playerNames.length; i++){
                if (players[playerNames[i]] !== null) throw new Error('Can not register Player component after player has been created.');
            }
        }
        $cb03b711053a4297$var$Component$1.components_[name] = ComponentToRegister;
        $cb03b711053a4297$var$Component$1.components_[$cb03b711053a4297$var$toLowerCase(name)] = ComponentToRegister;
        return ComponentToRegister;
    }
    /**
   * Get a `Component` based on the name it was registered with.
   *
   * @param {string} name
   *        The Name of the component to get.
   *
   * @return {typeof Component}
   *         The `Component` that got registered under the given name.
   */ static getComponent(name) {
        if (!name || !$cb03b711053a4297$var$Component$1.components_) return;
        return $cb03b711053a4297$var$Component$1.components_[name];
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('Component', $cb03b711053a4297$var$Component$1);
/**
 * @file time.js
 * @module time
 */ /**
 * Returns the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @typedef    {Function} TimeRangeIndex
 *
 * @param      {number} [index=0]
 *             The range number to return the time for.
 *
 * @return     {number}
 *             The time offset at the specified index.
 *
 * @deprecated The index argument must be provided.
 *             In the future, leaving it out will throw an error.
 */ /**
 * An object that contains ranges of time, which mimics {@link TimeRanges}.
 *
 * @typedef  {Object} TimeRange
 *
 * @property {number} length
 *           The number of time ranges represented by this object.
 *
 * @property {module:time~TimeRangeIndex} start
 *           Returns the time offset at which a specified time range begins.
 *
 * @property {module:time~TimeRangeIndex} end
 *           Returns the time offset at which a specified time range ends.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
 */ /**
 * Check if any of the time ranges are over the maximum index.
 *
 * @private
 * @param   {string} fnName
 *          The function name to use for logging
 *
 * @param   {number} index
 *          The index to check
 *
 * @param   {number} maxIndex
 *          The maximum possible index
 *
 * @throws  {Error} if the timeRanges provided are over the maxIndex
 */ function $cb03b711053a4297$var$rangeCheck(fnName, index, maxIndex) {
    if (typeof index !== 'number' || index < 0 || index > maxIndex) throw new Error(`Failed to execute '${fnName}' on 'TimeRanges': The index provided (${index}) is non-numeric or out of bounds (0-${maxIndex}).`);
}
/**
 * Get the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @private
 * @param      {string} fnName
 *             The function name to use for logging
 *
 * @param      {string} valueIndex
 *             The property that should be used to get the time. should be
 *             'start' or 'end'
 *
 * @param      {Array} ranges
 *             An array of time ranges
 *
 * @param      {Array} [rangeIndex=0]
 *             The index to start the search at
 *
 * @return     {number}
 *             The time that offset at the specified index.
 *
 * @deprecated rangeIndex must be set to a value, in the future this will throw an error.
 * @throws     {Error} if rangeIndex is more than the length of ranges
 */ function $cb03b711053a4297$var$getRange(fnName, valueIndex, ranges, rangeIndex) {
    $cb03b711053a4297$var$rangeCheck(fnName, rangeIndex, ranges.length - 1);
    return ranges[rangeIndex][valueIndex];
}
/**
 * Create a time range object given ranges of time.
 *
 * @private
 * @param   {Array} [ranges]
 *          An array of time ranges.
 *
 * @return  {TimeRange}
 */ function $cb03b711053a4297$var$createTimeRangesObj(ranges) {
    let timeRangesObj;
    if (ranges === undefined || ranges.length === 0) timeRangesObj = {
        length: 0,
        start () {
            throw new Error('This TimeRanges object is empty');
        },
        end () {
            throw new Error('This TimeRanges object is empty');
        }
    };
    else timeRangesObj = {
        length: ranges.length,
        start: $cb03b711053a4297$var$getRange.bind(null, 'start', 0, ranges),
        end: $cb03b711053a4297$var$getRange.bind(null, 'end', 1, ranges)
    };
    if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Symbol && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Symbol.iterator) timeRangesObj[(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Symbol.iterator] = ()=>(ranges || []).values();
    return timeRangesObj;
}
/**
 * Create a `TimeRange` object which mimics an
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges|HTML5 TimeRanges instance}.
 *
 * @param {number|Array[]} start
 *        The start of a single range (a number) or an array of ranges (an
 *        array of arrays of two numbers each).
 *
 * @param {number} end
 *        The end of a single range. Cannot be used with the array form of
 *        the `start` argument.
 *
 * @return {TimeRange}
 */ function $cb03b711053a4297$var$createTimeRanges$1(start, end) {
    if (Array.isArray(start)) return $cb03b711053a4297$var$createTimeRangesObj(start);
    else if (start === undefined || end === undefined) return $cb03b711053a4297$var$createTimeRangesObj();
    return $cb03b711053a4297$var$createTimeRangesObj([
        [
            start,
            end
        ]
    ]);
}
/**
 * Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in
 * seconds) will force a number of leading zeros to cover the length of the
 * guide.
 *
 * @private
 * @param  {number} seconds
 *         Number of seconds to be turned into a string
 *
 * @param  {number} guide
 *         Number (in seconds) to model the string after
 *
 * @return {string}
 *         Time formatted as H:MM:SS or M:SS
 */ const $cb03b711053a4297$var$defaultImplementation = function(seconds, guide) {
    seconds = seconds < 0 ? 0 : seconds;
    let s = Math.floor(seconds % 60);
    let m = Math.floor(seconds / 60 % 60);
    let h = Math.floor(seconds / 3600);
    const gm = Math.floor(guide / 60 % 60);
    const gh = Math.floor(guide / 3600);
    // handle invalid times
    if (isNaN(seconds) || seconds === Infinity) // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = m = s = '-';
    // Check if we need to show hours
    h = h > 0 || gh > 0 ? h + ':' : '';
    // If hours are showing, we may need to add a leading zero.
    // Always show at least one digit of minutes.
    m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':';
    // Check if leading zero is need for seconds
    s = s < 10 ? '0' + s : s;
    return h + m + s;
};
// Internal pointer to the current implementation.
let $cb03b711053a4297$var$implementation = $cb03b711053a4297$var$defaultImplementation;
/**
 * Replaces the default formatTime implementation with a custom implementation.
 *
 * @param {Function} customImplementation
 *        A function which will be used in place of the default formatTime
 *        implementation. Will receive the current time in seconds and the
 *        guide (in seconds) as arguments.
 */ function $cb03b711053a4297$var$setFormatTime(customImplementation) {
    $cb03b711053a4297$var$implementation = customImplementation;
}
/**
 * Resets formatTime to the default implementation.
 */ function $cb03b711053a4297$var$resetFormatTime() {
    $cb03b711053a4297$var$implementation = $cb03b711053a4297$var$defaultImplementation;
}
/**
 * Delegates to either the default time formatting function or a custom
 * function supplied via `setFormatTime`.
 *
 * Formats seconds as a time string (H:MM:SS or M:SS). Supplying a
 * guide (in seconds) will force a number of leading zeros to cover the
 * length of the guide.
 *
 * @example  formatTime(125, 600) === "02:05"
 * @param    {number} seconds
 *           Number of seconds to be turned into a string
 *
 * @param    {number} guide
 *           Number (in seconds) to model the string after
 *
 * @return   {string}
 *           Time formatted as H:MM:SS or M:SS
 */ function $cb03b711053a4297$var$formatTime(seconds, guide = seconds) {
    return $cb03b711053a4297$var$implementation(seconds, guide);
}
var $cb03b711053a4297$var$Time = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createTimeRanges: $cb03b711053a4297$var$createTimeRanges$1,
    createTimeRange: $cb03b711053a4297$var$createTimeRanges$1,
    setFormatTime: $cb03b711053a4297$var$setFormatTime,
    resetFormatTime: $cb03b711053a4297$var$resetFormatTime,
    formatTime: $cb03b711053a4297$var$formatTime
});
/**
 * @file buffer.js
 * @module buffer
 */ /** @import { TimeRange } from './time' */ /**
 * Compute the percentage of the media that has been buffered.
 *
 * @param {TimeRange} buffered
 *        The current `TimeRanges` object representing buffered time ranges
 *
 * @param {number} duration
 *        Total duration of the media
 *
 * @return {number}
 *         Percent buffered of the total duration in decimal form.
 */ function $cb03b711053a4297$var$bufferedPercent(buffered, duration) {
    let bufferedDuration = 0;
    let start;
    let end;
    if (!duration) return 0;
    if (!buffered || !buffered.length) buffered = $cb03b711053a4297$var$createTimeRanges$1(0, 0);
    for(let i = 0; i < buffered.length; i++){
        start = buffered.start(i);
        end = buffered.end(i);
        // buffered end can be bigger than duration by a very small fraction
        if (end > duration) end = duration;
        bufferedDuration += end - start;
    }
    return bufferedDuration / duration;
}
/**
 * @file media-error.js
 */ /**
 * A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
 *
 * @param {number|string|Object|MediaError} value
 *        This can be of multiple types:
 *        - number: should be a standard error code
 *        - string: an error message (the code will be 0)
 *        - Object: arbitrary properties
 *        - `MediaError` (native): used to populate a video.js `MediaError` object
 *        - `MediaError` (video.js): will return itself if it's already a
 *          video.js `MediaError` object.
 *
 * @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
 * @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
 *
 * @class MediaError
 */ function $cb03b711053a4297$var$MediaError(value) {
    // Allow redundant calls to this constructor to avoid having `instanceof`
    // checks peppered around the code.
    if (value instanceof $cb03b711053a4297$var$MediaError) return value;
    if (typeof value === 'number') this.code = value;
    else if (typeof value === 'string') // default code is zero, so this is a custom error
    this.message = value;
    else if ($cb03b711053a4297$var$isObject(value)) {
        // We assign the `code` property manually because native `MediaError` objects
        // do not expose it as an own/enumerable property of the object.
        if (typeof value.code === 'number') this.code = value.code;
        Object.assign(this, value);
    }
    if (!this.message) this.message = $cb03b711053a4297$var$MediaError.defaultMessages[this.code] || '';
}
/**
 * The error code that refers two one of the defined `MediaError` types
 *
 * @type {Number}
 */ $cb03b711053a4297$var$MediaError.prototype.code = 0;
/**
 * An optional message that to show with the error. Message is not part of the HTML5
 * video spec but allows for more informative custom errors.
 *
 * @type {String}
 */ $cb03b711053a4297$var$MediaError.prototype.message = '';
/**
 * An optional status code that can be set by plugins to allow even more detail about
 * the error. For example a plugin might provide a specific HTTP status code and an
 * error message for that code. Then when the plugin gets that error this class will
 * know how to display an error message for it. This allows a custom message to show
 * up on the `Player` error overlay.
 *
 * @type {Array}
 */ $cb03b711053a4297$var$MediaError.prototype.status = null;
/**
 * An object containing an error type, as well as other information regarding the error.
 *
 * @typedef {{errorType: string, [key: string]: any}} ErrorMetadata
 */ /**
 * An optional object to give more detail about the error. This can be used to give
 * a higher level of specificity to an error versus the more generic MediaError codes.
 * `metadata` expects an `errorType` string that should align with the values from videojs.Error.
 *
 * @type {ErrorMetadata}
 */ $cb03b711053a4297$var$MediaError.prototype.metadata = null;
/**
 * Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
 * specification listed under {@link MediaError} for more information.
 *
 * @enum {array}
 * @readonly
 * @property {string} 0 - MEDIA_ERR_CUSTOM
 * @property {string} 1 - MEDIA_ERR_ABORTED
 * @property {string} 2 - MEDIA_ERR_NETWORK
 * @property {string} 3 - MEDIA_ERR_DECODE
 * @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
 * @property {string} 5 - MEDIA_ERR_ENCRYPTED
 */ $cb03b711053a4297$var$MediaError.errorTypes = [
    'MEDIA_ERR_CUSTOM',
    'MEDIA_ERR_ABORTED',
    'MEDIA_ERR_NETWORK',
    'MEDIA_ERR_DECODE',
    'MEDIA_ERR_SRC_NOT_SUPPORTED',
    'MEDIA_ERR_ENCRYPTED'
];
/**
 * The default `MediaError` messages based on the {@link MediaError.errorTypes}.
 *
 * @type {Array}
 * @constant
 */ $cb03b711053a4297$var$MediaError.defaultMessages = {
    1: 'You aborted the media playback',
    2: 'A network error caused the media download to fail part-way.',
    3: 'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.',
    4: 'The media could not be loaded, either because the server or network failed or because the format is not supported.',
    5: 'The media is encrypted and we do not have the keys to decrypt it.'
};
/**
 * W3C error code for any custom error.
 *
 * @member MediaError#MEDIA_ERR_CUSTOM
 * @constant {number}
 * @default 0
 */ $cb03b711053a4297$var$MediaError.MEDIA_ERR_CUSTOM = 0;
/**
 * W3C error code for any custom error.
 *
 * @member MediaError.MEDIA_ERR_CUSTOM
 * @constant {number}
 * @default 0
 */ $cb03b711053a4297$var$MediaError.prototype.MEDIA_ERR_CUSTOM = 0;
/**
 * W3C error code for media error aborted.
 *
 * @member MediaError#MEDIA_ERR_ABORTED
 * @constant {number}
 * @default 1
 */ $cb03b711053a4297$var$MediaError.MEDIA_ERR_ABORTED = 1;
/**
 * W3C error code for media error aborted.
 *
 * @member MediaError.MEDIA_ERR_ABORTED
 * @constant {number}
 * @default 1
 */ $cb03b711053a4297$var$MediaError.prototype.MEDIA_ERR_ABORTED = 1;
/**
 * W3C error code for any network error.
 *
 * @member MediaError#MEDIA_ERR_NETWORK
 * @constant {number}
 * @default 2
 */ $cb03b711053a4297$var$MediaError.MEDIA_ERR_NETWORK = 2;
/**
 * W3C error code for any network error.
 *
 * @member MediaError.MEDIA_ERR_NETWORK
 * @constant {number}
 * @default 2
 */ $cb03b711053a4297$var$MediaError.prototype.MEDIA_ERR_NETWORK = 2;
/**
 * W3C error code for any decoding error.
 *
 * @member MediaError#MEDIA_ERR_DECODE
 * @constant {number}
 * @default 3
 */ $cb03b711053a4297$var$MediaError.MEDIA_ERR_DECODE = 3;
/**
 * W3C error code for any decoding error.
 *
 * @member MediaError.MEDIA_ERR_DECODE
 * @constant {number}
 * @default 3
 */ $cb03b711053a4297$var$MediaError.prototype.MEDIA_ERR_DECODE = 3;
/**
 * W3C error code for any time that a source is not supported.
 *
 * @member MediaError#MEDIA_ERR_SRC_NOT_SUPPORTED
 * @constant {number}
 * @default 4
 */ $cb03b711053a4297$var$MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
/**
 * W3C error code for any time that a source is not supported.
 *
 * @member MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED
 * @constant {number}
 * @default 4
 */ $cb03b711053a4297$var$MediaError.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
/**
 * W3C error code for any time that a source is encrypted.
 *
 * @member MediaError#MEDIA_ERR_ENCRYPTED
 * @constant {number}
 * @default 5
 */ $cb03b711053a4297$var$MediaError.MEDIA_ERR_ENCRYPTED = 5;
/**
 * W3C error code for any time that a source is encrypted.
 *
 * @member MediaError.MEDIA_ERR_ENCRYPTED
 * @constant {number}
 * @default 5
 */ $cb03b711053a4297$var$MediaError.prototype.MEDIA_ERR_ENCRYPTED = 5;
/**
 * Returns whether an object is `Promise`-like (i.e. has a `then` method).
 *
 * @param  {Object}  value
 *         An object that may or may not be `Promise`-like.
 *
 * @return {boolean}
 *         Whether or not the object is `Promise`-like.
 */ function $cb03b711053a4297$var$isPromise(value) {
    return value !== undefined && value !== null && typeof value.then === 'function';
}
/**
 * Silence a Promise-like object.
 *
 * This is useful for avoiding non-harmful, but potentially confusing "uncaught
 * play promise" rejection error messages.
 *
 * @param  {Object} value
 *         An object that may or may not be `Promise`-like.
 */ function $cb03b711053a4297$var$silencePromise(value) {
    if ($cb03b711053a4297$var$isPromise(value)) value.then(null, (e)=>{});
}
/**
 * @file text-track-list-converter.js Utilities for capturing text track state and
 * re-creating tracks based on a capture.
 *
 * @module text-track-list-converter
 */ /** @import Tech from '../tech/tech' */ /**
 * Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
 * represents the {@link TextTrack}'s state.
 *
 * @param {TextTrack} track
 *        The text track to query.
 *
 * @return {Object}
 *         A serializable javascript representation of the TextTrack.
 * @private
 */ const $cb03b711053a4297$var$trackToJson = function(track) {
    const ret = [
        'kind',
        'label',
        'language',
        'id',
        'inBandMetadataTrackDispatchType',
        'mode',
        'src'
    ].reduce((acc, prop, i)=>{
        if (track[prop]) acc[prop] = track[prop];
        return acc;
    }, {
        cues: track.cues && Array.prototype.map.call(track.cues, function(cue) {
            return {
                startTime: cue.startTime,
                endTime: cue.endTime,
                text: cue.text,
                id: cue.id
            };
        })
    });
    return ret;
};
/**
 * Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
 * state of all {@link TextTrack}s currently configured. The return array is compatible with
 * {@link text-track-list-converter:jsonToTextTracks}.
 *
 * @param {Tech} tech
 *        The tech object to query
 *
 * @return {Array}
 *         A serializable javascript representation of the {@link Tech}s
 *         {@link TextTrackList}.
 */ const $cb03b711053a4297$var$textTracksToJson = function(tech) {
    const trackEls = tech.$$('track');
    const trackObjs = Array.prototype.map.call(trackEls, (t)=>t.track);
    const tracks = Array.prototype.map.call(trackEls, function(trackEl) {
        const json = $cb03b711053a4297$var$trackToJson(trackEl.track);
        if (trackEl.src) json.src = trackEl.src;
        return json;
    });
    return tracks.concat(Array.prototype.filter.call(tech.textTracks(), function(track) {
        return trackObjs.indexOf(track) === -1;
    }).map($cb03b711053a4297$var$trackToJson));
};
/**
 * Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
 * object {@link TextTrack} representations.
 *
 * @param {Array} json
 *        An array of `TextTrack` representation objects, like those that would be
 *        produced by `textTracksToJson`.
 *
 * @param {Tech} tech
 *        The `Tech` to create the `TextTrack`s on.
 */ const $cb03b711053a4297$var$jsonToTextTracks = function(json, tech) {
    json.forEach(function(track) {
        const addedTrack = tech.addRemoteTextTrack(track).track;
        if (!track.src && track.cues) track.cues.forEach((cue)=>addedTrack.addCue(cue));
    });
    return tech.textTracks();
};
var $cb03b711053a4297$var$textTrackConverter = {
    textTracksToJson: $cb03b711053a4297$var$textTracksToJson,
    jsonToTextTracks: $cb03b711053a4297$var$jsonToTextTracks,
    trackToJson: $cb03b711053a4297$var$trackToJson
};
/**
 * @file modal-dialog.js
 */ /** @import Player from './player' */ /** @import { ContentDescriptor } from './utils/dom' */ const $cb03b711053a4297$var$MODAL_CLASS_NAME = 'vjs-modal-dialog';
/**
 * The `ModalDialog` displays over the video and its controls, which blocks
 * interaction with the player until it is closed.
 *
 * Modal dialogs include a "Close" button and will close when that button
 * is activated - or when ESC is pressed anywhere.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$ModalDialog extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.description]
   *        A text description for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.fillAlways=false]
   *        Normally, modals are automatically filled only the first time
   *        they open. This tells the modal to refresh its content
   *        every time it opens.
   *
   * @param {string} [options.label]
   *        A text label for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.pauseOnOpen=true]
   *        If `true`, playback will will be paused if playing when
   *        the modal opens, and resumed when it closes.
   *
   * @param {boolean} [options.temporary=true]
   *        If `true`, the modal can only be opened once; it will be
   *        disposed as soon as it's closed.
   *
   * @param {boolean} [options.uncloseable=false]
   *        If `true`, the user will not be able to close the modal
   *        through the UI in the normal ways. Programmatic closing is
   *        still possible.
   */ constructor(player, options){
        super(player, options);
        this.handleKeyDown_ = (e)=>this.handleKeyDown(e);
        this.close_ = (e)=>this.close(e);
        this.opened_ = this.hasBeenOpened_ = this.hasBeenFilled_ = false;
        this.closeable(!this.options_.uncloseable);
        this.content(this.options_.content);
        // Make sure the contentEl is defined AFTER any children are initialized
        // because we only want the contents of the modal in the contentEl
        // (not the UI elements like the close button).
        this.contentEl_ = $cb03b711053a4297$var$createEl('div', {
            className: `${$cb03b711053a4297$var$MODAL_CLASS_NAME}-content`
        }, {
            role: 'document'
        });
        this.descEl_ = $cb03b711053a4297$var$createEl('p', {
            className: `${$cb03b711053a4297$var$MODAL_CLASS_NAME}-description vjs-control-text`,
            id: this.el().getAttribute('aria-describedby')
        });
        $cb03b711053a4297$var$textContent(this.descEl_, this.description());
        this.el_.appendChild(this.descEl_);
        this.el_.appendChild(this.contentEl_);
    }
    /**
   * Create the `ModalDialog`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        return super.createEl('div', {
            className: this.buildCSSClass(),
            tabIndex: -1
        }, {
            'aria-describedby': `${this.id()}_description`,
            'aria-hidden': 'true',
            'aria-label': this.label(),
            'role': 'dialog',
            'aria-live': 'polite'
        });
    }
    dispose() {
        this.contentEl_ = null;
        this.descEl_ = null;
        this.previouslyActiveEl_ = null;
        super.dispose();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `${$cb03b711053a4297$var$MODAL_CLASS_NAME} vjs-hidden ${super.buildCSSClass()}`;
    }
    /**
   * Returns the label string for this modal. Primarily used for accessibility.
   *
   * @return {string}
   *         the localized or raw label of this modal.
   */ label() {
        return this.localize(this.options_.label || 'Modal Window');
    }
    /**
   * Returns the description string for this modal. Primarily used for
   * accessibility.
   *
   * @return {string}
   *         The localized or raw description of this modal.
   */ description() {
        let desc = this.options_.description || this.localize('This is a modal window.');
        // Append a universal closeability message if the modal is closeable.
        if (this.closeable()) desc += ' ' + this.localize('This modal can be closed by pressing the Escape key or activating the close button.');
        return desc;
    }
    /**
   * Opens the modal.
   *
   * @fires ModalDialog#beforemodalopen
   * @fires ModalDialog#modalopen
   */ open() {
        if (this.opened_) {
            if (this.options_.fillAlways) this.fill();
            return;
        }
        const player = this.player();
        /**
      * Fired just before a `ModalDialog` is opened.
      *
      * @event ModalDialog#beforemodalopen
      * @type {Event}
      */ this.trigger('beforemodalopen');
        this.opened_ = true;
        // Fill content if the modal has never opened before and
        // never been filled.
        if (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) this.fill();
        // If the player was playing, pause it and take note of its previously
        // playing state.
        this.wasPlaying_ = !player.paused();
        if (this.options_.pauseOnOpen && this.wasPlaying_) player.pause();
        this.on('keydown', this.handleKeyDown_);
        // Hide controls and note if they were enabled.
        this.hadControls_ = player.controls();
        player.controls(false);
        this.show();
        this.conditionalFocus_();
        this.el().setAttribute('aria-hidden', 'false');
        /**
      * Fired just after a `ModalDialog` is opened.
      *
      * @event ModalDialog#modalopen
      * @type {Event}
      */ this.trigger('modalopen');
        this.hasBeenOpened_ = true;
    }
    /**
   * If the `ModalDialog` is currently open or closed.
   *
   * @param  {boolean} [value]
   *         If given, it will open (`true`) or close (`false`) the modal.
   *
   * @return {boolean}
   *         the current open state of the modaldialog
   */ opened(value) {
        if (typeof value === 'boolean') this[value ? 'open' : 'close']();
        return this.opened_;
    }
    /**
   * Closes the modal, does nothing if the `ModalDialog` is
   * not open.
   *
   * @fires ModalDialog#beforemodalclose
   * @fires ModalDialog#modalclose
   */ close() {
        if (!this.opened_) return;
        const player = this.player();
        /**
      * Fired just before a `ModalDialog` is closed.
      *
      * @event ModalDialog#beforemodalclose
      * @type {Event}
      */ this.trigger('beforemodalclose');
        this.opened_ = false;
        if (this.wasPlaying_ && this.options_.pauseOnOpen) player.play();
        this.off('keydown', this.handleKeyDown_);
        if (this.hadControls_) player.controls(true);
        this.hide();
        this.el().setAttribute('aria-hidden', 'true');
        /**
      * Fired just after a `ModalDialog` is closed.
      *
      * @event ModalDialog#modalclose
      * @type {Event}
      *
      * @property {boolean} [bubbles=true]
      */ this.trigger({
            type: 'modalclose',
            bubbles: true
        });
        this.conditionalBlur_();
        if (this.options_.temporary) this.dispose();
    }
    /**
   * Check to see if the `ModalDialog` is closeable via the UI.
   *
   * @param  {boolean} [value]
   *         If given as a boolean, it will set the `closeable` option.
   *
   * @return {boolean}
   *         Returns the final value of the closable option.
   */ closeable(value) {
        if (typeof value === 'boolean') {
            const closeable = this.closeable_ = !!value;
            let close = this.getChild('closeButton');
            // If this is being made closeable and has no close button, add one.
            if (closeable && !close) {
                // The close button should be a child of the modal - not its
                // content element, so temporarily change the content element.
                const temp = this.contentEl_;
                this.contentEl_ = this.el_;
                close = this.addChild('closeButton', {
                    controlText: 'Close Modal Dialog'
                });
                this.contentEl_ = temp;
                this.on(close, 'close', this.close_);
            }
            // If this is being made uncloseable and has a close button, remove it.
            if (!closeable && close) {
                this.off(close, 'close', this.close_);
                this.removeChild(close);
                close.dispose();
            }
        }
        return this.closeable_;
    }
    /**
   * Fill the modal's content element with the modal's "content" option.
   * The content element will be emptied before this change takes place.
   */ fill() {
        this.fillWith(this.content());
    }
    /**
   * Fill the modal's content element with arbitrary content.
   * The content element will be emptied before this change takes place.
   *
   * @fires ModalDialog#beforemodalfill
   * @fires ModalDialog#modalfill
   *
   * @param {ContentDescriptor} [content]
   *        The same rules apply to this as apply to the `content` option.
   */ fillWith(content) {
        const contentEl = this.contentEl();
        const parentEl = contentEl.parentNode;
        const nextSiblingEl = contentEl.nextSibling;
        /**
      * Fired just before a `ModalDialog` is filled with content.
      *
      * @event ModalDialog#beforemodalfill
      * @type {Event}
      */ this.trigger('beforemodalfill');
        this.hasBeenFilled_ = true;
        // Detach the content element from the DOM before performing
        // manipulation to avoid modifying the live DOM multiple times.
        parentEl.removeChild(contentEl);
        this.empty();
        $cb03b711053a4297$var$insertContent(contentEl, content);
        /**
     * Fired just after a `ModalDialog` is filled with content.
     *
     * @event ModalDialog#modalfill
     * @type {Event}
     */ this.trigger('modalfill');
        // Re-inject the re-filled content element.
        if (nextSiblingEl) parentEl.insertBefore(contentEl, nextSiblingEl);
        else parentEl.appendChild(contentEl);
        // make sure that the close button is last in the dialog DOM
        const closeButton = this.getChild('closeButton');
        if (closeButton) parentEl.appendChild(closeButton.el_);
        /**
     * Fired after `ModalDialog` is re-filled with content & close button is appended.
     *
     * @event ModalDialog#aftermodalfill
     * @type {Event}
     */ this.trigger('aftermodalfill');
    }
    /**
   * Empties the content element. This happens anytime the modal is filled.
   *
   * @fires ModalDialog#beforemodalempty
   * @fires ModalDialog#modalempty
   */ empty() {
        /**
    * Fired just before a `ModalDialog` is emptied.
    *
    * @event ModalDialog#beforemodalempty
    * @type {Event}
    */ this.trigger('beforemodalempty');
        $cb03b711053a4297$var$emptyEl(this.contentEl());
        /**
    * Fired just after a `ModalDialog` is emptied.
    *
    * @event ModalDialog#modalempty
    * @type {Event}
    */ this.trigger('modalempty');
    }
    /**
   * Gets or sets the modal content, which gets normalized before being
   * rendered into the DOM.
   *
   * This does not update the DOM or fill the modal, but it is called during
   * that process.
   *
   * @param  {ContentDescriptor} [value]
   *         If defined, sets the internal content value to be used on the
   *         next call(s) to `fill`. This value is normalized before being
   *         inserted. To "clear" the internal content value, pass `null`.
   *
   * @return {ContentDescriptor}
   *         The current content of the modal dialog
   */ content(value) {
        if (typeof value !== 'undefined') this.content_ = value;
        return this.content_;
    }
    /**
   * conditionally focus the modal dialog if focus was previously on the player.
   *
   * @private
   */ conditionalFocus_() {
        const activeEl = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).activeElement;
        const playerEl = this.player_.el_;
        this.previouslyActiveEl_ = null;
        if (playerEl.contains(activeEl) || playerEl === activeEl) {
            this.previouslyActiveEl_ = activeEl;
            this.focus();
        }
    }
    /**
   * conditionally blur the element and refocus the last focused element
   *
   * @private
   */ conditionalBlur_() {
        if (this.previouslyActiveEl_) {
            this.previouslyActiveEl_.focus();
            this.previouslyActiveEl_ = null;
        }
    }
    /**
   * Keydown handler. Attached when modal is focused.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        /**
     * Fired a custom keyDown event that bubbles.
     *
     * @event ModalDialog#modalKeydown
     * @type {Event}
     */ this.trigger({
            type: 'modalKeydown',
            originalEvent: event,
            target: this,
            bubbles: true
        });
        // Do not allow keydowns to reach out of the modal dialog.
        event.stopPropagation();
        if (event.key === 'Escape' && this.closeable()) {
            event.preventDefault();
            this.close();
            return;
        }
        // exit early if it isn't a tab key
        if (event.key !== 'Tab') return;
        const focusableEls = this.focusableEls_();
        const activeEl = this.el_.querySelector(':focus');
        let focusIndex;
        for(let i = 0; i < focusableEls.length; i++)if (activeEl === focusableEls[i]) {
            focusIndex = i;
            break;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).activeElement === this.el_) focusIndex = 0;
        if (event.shiftKey && focusIndex === 0) {
            focusableEls[focusableEls.length - 1].focus();
            event.preventDefault();
        } else if (!event.shiftKey && focusIndex === focusableEls.length - 1) {
            focusableEls[0].focus();
            event.preventDefault();
        }
    }
    /**
   * get all focusable elements
   *
   * @private
   */ focusableEls_() {
        const allChildren = this.el_.querySelectorAll('*');
        return Array.prototype.filter.call(allChildren, (child)=>{
            return (child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLAnchorElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLAreaElement) && child.hasAttribute('href') || (child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLInputElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLSelectElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLTextAreaElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLButtonElement) && !child.hasAttribute('disabled') || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLIFrameElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLObjectElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLEmbedElement || child.hasAttribute('tabindex') && child.getAttribute('tabindex') !== -1 || child.hasAttribute('contenteditable');
        });
    }
}
/**
 * Default options for `ModalDialog` default options.
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$ModalDialog.prototype.options_ = {
    pauseOnOpen: true,
    temporary: true
};
$cb03b711053a4297$var$Component$1.registerComponent('ModalDialog', $cb03b711053a4297$var$ModalDialog);
/**
 * @file track-list.js
 */ /** @import Track from './track' */ /**
 * Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
 * {@link VideoTrackList}
 *
 * @extends EventTarget
 */ class $cb03b711053a4297$var$TrackList extends $cb03b711053a4297$var$EventTarget$2 {
    /**
   * Create an instance of this class
   *
   * @param { Track[] } tracks
   *        A list of tracks to initialize the list with.
   *
   * @abstract
   */ constructor(tracks = []){
        super();
        this.tracks_ = [];
        /**
     * @memberof TrackList
     * @member {number} length
     *         The current number of `Track`s in the this Trackist.
     * @instance
     */ Object.defineProperty(this, 'length', {
            get () {
                return this.tracks_.length;
            }
        });
        for(let i = 0; i < tracks.length; i++)this.addTrack(tracks[i]);
    }
    /**
   * Add a {@link Track} to the `TrackList`
   *
   * @param {Track} track
   *        The audio, video, or text track to add to the list.
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        const index = this.tracks_.length;
        if (!('' + index in this)) Object.defineProperty(this, index, {
            get () {
                return this.tracks_[index];
            }
        });
        // Do not add duplicate tracks
        if (this.tracks_.indexOf(track) === -1) {
            this.tracks_.push(track);
            /**
       * Triggered when a track is added to a track list.
       *
       * @event TrackList#addtrack
       * @type {Event}
       * @property {Track} track
       *           A reference to track that was added.
       */ this.trigger({
                track: track,
                type: 'addtrack',
                target: this
            });
        }
        /**
     * Triggered when a track label is changed.
     *
     * @event TrackList#addtrack
     * @type {Event}
     * @property {Track} track
     *           A reference to track that was added.
     */ track.labelchange_ = ()=>{
            this.trigger({
                track: track,
                type: 'labelchange',
                target: this
            });
        };
        if ($cb03b711053a4297$var$isEvented(track)) track.addEventListener('labelchange', track.labelchange_);
    }
    /**
   * Remove a {@link Track} from the `TrackList`
   *
   * @param {Track} rtrack
   *        The audio, video, or text track to remove from the list.
   *
   * @fires TrackList#removetrack
   */ removeTrack(rtrack) {
        let track;
        for(let i = 0, l = this.length; i < l; i++)if (this[i] === rtrack) {
            track = this[i];
            if (track.off) track.off();
            this.tracks_.splice(i, 1);
            break;
        }
        if (!track) return;
        /**
     * Triggered when a track is removed from track list.
     *
     * @event TrackList#removetrack
     * @type {Event}
     * @property {Track} track
     *           A reference to track that was removed.
     */ this.trigger({
            track: track,
            type: 'removetrack',
            target: this
        });
    }
    /**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {string} id - the id of the track to get
   * @method getTrackById
   * @return {Track}
   * @private
   */ getTrackById(id) {
        let result = null;
        for(let i = 0, l = this.length; i < l; i++){
            const track = this[i];
            if (track.id === id) {
                result = track;
                break;
            }
        }
        return result;
    }
}
/**
 * Triggered when a different track is selected/enabled.
 *
 * @event TrackList#change
 * @type {Event}
 */ /**
 * Events that can be called with on + eventName. See {@link EventHandler}.
 *
 * @property {Object} TrackList#allowedEvents_
 * @protected
 */ $cb03b711053a4297$var$TrackList.prototype.allowedEvents_ = {
    change: 'change',
    addtrack: 'addtrack',
    removetrack: 'removetrack',
    labelchange: 'labelchange'
};
// emulate attribute EventHandler support to allow for feature detection
for(const event in $cb03b711053a4297$var$TrackList.prototype.allowedEvents_)$cb03b711053a4297$var$TrackList.prototype['on' + event] = null;
/**
 * @file audio-track-list.js
 */ /** @import AudioTrack from './audio-track' */ /**
 * Anywhere we call this function we diverge from the spec
 * as we only support one enabled audiotrack at a time
 *
 * @param {AudioTrackList} list
 *        list to work on
 *
 * @param {AudioTrack} track
 *        The track to skip
 *
 * @private
 */ const $cb03b711053a4297$var$disableOthers$1 = function(list, track) {
    for(let i = 0; i < list.length; i++){
        if (!Object.keys(list[i]).length || track.id === list[i].id) continue;
        // another audio track is enabled, disable it
        list[i].enabled = false;
    }
};
/**
 * The current list of {@link AudioTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
 * @extends TrackList
 */ class $cb03b711053a4297$var$AudioTrackList extends $cb03b711053a4297$var$TrackList {
    /**
   * Create an instance of this class.
   *
   * @param {AudioTrack[]} [tracks=[]]
   *        A list of `AudioTrack` to instantiate the list with.
   */ constructor(tracks = []){
        // make sure only 1 track is enabled
        // sorted from last index to first index
        for(let i = tracks.length - 1; i >= 0; i--)if (tracks[i].enabled) {
            $cb03b711053a4297$var$disableOthers$1(tracks, tracks[i]);
            break;
        }
        super(tracks);
        this.changing_ = false;
    }
    /**
   * Add an {@link AudioTrack} to the `AudioTrackList`.
   *
   * @param {AudioTrack} track
   *        The AudioTrack to add to the list
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        if (track.enabled) $cb03b711053a4297$var$disableOthers$1(this, track);
        super.addTrack(track);
        // native tracks don't have this
        if (!track.addEventListener) return;
        track.enabledChange_ = ()=>{
            // when we are disabling other tracks (since we don't support
            // more than one track at a time) we will set changing_
            // to true so that we don't trigger additional change events
            if (this.changing_) return;
            this.changing_ = true;
            $cb03b711053a4297$var$disableOthers$1(this, track);
            this.changing_ = false;
            this.trigger('change');
        };
        /**
     * @listens AudioTrack#enabledchange
     * @fires TrackList#change
     */ track.addEventListener('enabledchange', track.enabledChange_);
    }
    removeTrack(rtrack) {
        super.removeTrack(rtrack);
        if (rtrack.removeEventListener && rtrack.enabledChange_) {
            rtrack.removeEventListener('enabledchange', rtrack.enabledChange_);
            rtrack.enabledChange_ = null;
        }
    }
}
/**
 * @file video-track-list.js
 */ /** @import VideoTrack from './video-track' */ /**
 * Un-select all other {@link VideoTrack}s that are selected.
 *
 * @param {VideoTrackList} list
 *        list to work on
 *
 * @param {VideoTrack} track
 *        The track to skip
 *
 * @private
 */ const $cb03b711053a4297$var$disableOthers = function(list, track) {
    for(let i = 0; i < list.length; i++){
        if (!Object.keys(list[i]).length || track.id === list[i].id) continue;
        // another video track is enabled, disable it
        list[i].selected = false;
    }
};
/**
 * The current list of {@link VideoTrack} for a video.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
 * @extends TrackList
 */ class $cb03b711053a4297$var$VideoTrackList extends $cb03b711053a4297$var$TrackList {
    /**
   * Create an instance of this class.
   *
   * @param {VideoTrack[]} [tracks=[]]
   *        A list of `VideoTrack` to instantiate the list with.
   */ constructor(tracks = []){
        // make sure only 1 track is enabled
        // sorted from last index to first index
        for(let i = tracks.length - 1; i >= 0; i--)if (tracks[i].selected) {
            $cb03b711053a4297$var$disableOthers(tracks, tracks[i]);
            break;
        }
        super(tracks);
        this.changing_ = false;
        /**
     * @member {number} VideoTrackList#selectedIndex
     *         The current index of the selected {@link VideoTrack`}.
     */ Object.defineProperty(this, 'selectedIndex', {
            get () {
                for(let i = 0; i < this.length; i++){
                    if (this[i].selected) return i;
                }
                return -1;
            },
            set () {}
        });
    }
    /**
   * Add a {@link VideoTrack} to the `VideoTrackList`.
   *
   * @param {VideoTrack} track
   *        The VideoTrack to add to the list
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        if (track.selected) $cb03b711053a4297$var$disableOthers(this, track);
        super.addTrack(track);
        // native tracks don't have this
        if (!track.addEventListener) return;
        track.selectedChange_ = ()=>{
            if (this.changing_) return;
            this.changing_ = true;
            $cb03b711053a4297$var$disableOthers(this, track);
            this.changing_ = false;
            this.trigger('change');
        };
        /**
     * @listens VideoTrack#selectedchange
     * @fires TrackList#change
     */ track.addEventListener('selectedchange', track.selectedChange_);
    }
    removeTrack(rtrack) {
        super.removeTrack(rtrack);
        if (rtrack.removeEventListener && rtrack.selectedChange_) {
            rtrack.removeEventListener('selectedchange', rtrack.selectedChange_);
            rtrack.selectedChange_ = null;
        }
    }
}
/**
 * @file text-track-list.js
 */ /** @import TextTrack from './text-track' */ /**
 * The current list of {@link TextTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
 * @extends TrackList
 */ class $cb03b711053a4297$var$TextTrackList extends $cb03b711053a4297$var$TrackList {
    /**
   * Add a {@link TextTrack} to the `TextTrackList`
   *
   * @param {TextTrack} track
   *        The text track to add to the list.
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        super.addTrack(track);
        if (!this.queueChange_) this.queueChange_ = ()=>this.queueTrigger('change');
        if (!this.triggerSelectedlanguagechange) this.triggerSelectedlanguagechange_ = ()=>this.trigger('selectedlanguagechange');
        /**
     * @listens TextTrack#modechange
     * @fires TrackList#change
     */ track.addEventListener('modechange', this.queueChange_);
        const nonLanguageTextTrackKind = [
            'metadata',
            'chapters'
        ];
        if (nonLanguageTextTrackKind.indexOf(track.kind) === -1) track.addEventListener('modechange', this.triggerSelectedlanguagechange_);
    }
    removeTrack(rtrack) {
        super.removeTrack(rtrack);
        // manually remove the event handlers we added
        if (rtrack.removeEventListener) {
            if (this.queueChange_) rtrack.removeEventListener('modechange', this.queueChange_);
            if (this.selectedlanguagechange_) rtrack.removeEventListener('modechange', this.triggerSelectedlanguagechange_);
        }
    }
    /**
   * Creates a serializable array of objects that contains serialized copies
   * of each text track.
   *
   * @return {Object[]} A serializable list of objects for the text track list
   */ toJSON() {
        return this.tracks_.map((track)=>track.toJSON());
    }
}
/**
 * @file html-track-element-list.js
 */ /**
 * The current list of {@link HtmlTrackElement}s.
 */ class $cb03b711053a4297$var$HtmlTrackElementList {
    /**
   * Create an instance of this class.
   *
   * @param {HtmlTrackElement[]} [tracks=[]]
   *        A list of `HtmlTrackElement` to instantiate the list with.
   */ constructor(trackElements = []){
        this.trackElements_ = [];
        /**
     * @memberof HtmlTrackElementList
     * @member {number} length
     *         The current number of `Track`s in the this Trackist.
     * @instance
     */ Object.defineProperty(this, 'length', {
            get () {
                return this.trackElements_.length;
            }
        });
        for(let i = 0, length = trackElements.length; i < length; i++)this.addTrackElement_(trackElements[i]);
    }
    /**
   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to add to the list.
   *
   * @private
   */ addTrackElement_(trackElement) {
        const index = this.trackElements_.length;
        if (!('' + index in this)) Object.defineProperty(this, index, {
            get () {
                return this.trackElements_[index];
            }
        });
        // Do not add duplicate elements
        if (this.trackElements_.indexOf(trackElement) === -1) this.trackElements_.push(trackElement);
    }
    /**
   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
   * {@link TextTrack}.
   *
   * @param {TextTrack} track
   *        The track associated with a track element.
   *
   * @return {HtmlTrackElement|undefined}
   *         The track element that was found or undefined.
   *
   * @private
   */ getTrackElementByTrack_(track) {
        let trackElement_;
        for(let i = 0, length = this.trackElements_.length; i < length; i++)if (track === this.trackElements_[i].track) {
            trackElement_ = this.trackElements_[i];
            break;
        }
        return trackElement_;
    }
    /**
   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to remove from the list.
   *
   * @private
   */ removeTrackElement_(trackElement) {
        for(let i = 0, length = this.trackElements_.length; i < length; i++)if (trackElement === this.trackElements_[i]) {
            if (this.trackElements_[i].track && typeof this.trackElements_[i].track.off === 'function') this.trackElements_[i].track.off();
            if (typeof this.trackElements_[i].off === 'function') this.trackElements_[i].off();
            this.trackElements_.splice(i, 1);
            break;
        }
    }
}
/**
 * @file text-track-cue-list.js
 */ /**
 * @typedef {Object} TextTrackCueList~TextTrackCue
 *
 * @property {string} id
 *           The unique id for this text track cue
 *
 * @property {number} startTime
 *           The start time for this text track cue
 *
 * @property {number} endTime
 *           The end time for this text track cue
 *
 * @property {boolean} pauseOnExit
 *           Pause when the end time is reached if true.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
 */ /**
 * A List of TextTrackCues.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
 */ class $cb03b711053a4297$var$TextTrackCueList {
    /**
   * Create an instance of this class..
   *
   * @param {Array} cues
   *        A list of cues to be initialized with
   */ constructor(cues){
        $cb03b711053a4297$var$TextTrackCueList.prototype.setCues_.call(this, cues);
        /**
     * @memberof TextTrackCueList
     * @member {number} length
     *         The current number of `TextTrackCue`s in the TextTrackCueList.
     * @instance
     */ Object.defineProperty(this, 'length', {
            get () {
                return this.length_;
            }
        });
    }
    /**
   * A setter for cues in this list. Creates getters
   * an an index for the cues.
   *
   * @param {Array} cues
   *        An array of cues to set
   *
   * @private
   */ setCues_(cues) {
        const oldLength = this.length || 0;
        let i = 0;
        const l = cues.length;
        this.cues_ = cues;
        this.length_ = cues.length;
        const defineProp = function(index) {
            if (!('' + index in this)) Object.defineProperty(this, '' + index, {
                get () {
                    return this.cues_[index];
                }
            });
        };
        if (oldLength < l) {
            i = oldLength;
            for(; i < l; i++)defineProp.call(this, i);
        }
    }
    /**
   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
   *
   * @param {string} id
   *        The id of the cue that should be searched for.
   *
   * @return {TextTrackCueList~TextTrackCue|null}
   *         A single cue or null if none was found.
   */ getCueById(id) {
        let result = null;
        for(let i = 0, l = this.length; i < l; i++){
            const cue = this[i];
            if (cue.id === id) {
                result = cue;
                break;
            }
        }
        return result;
    }
}
/**
 * @file track-kinds.js
 */ /**
 * All possible `VideoTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
 * @typedef VideoTrack~Kind
 * @enum
 */ const $cb03b711053a4297$var$VideoTrackKind = {
    alternative: 'alternative',
    captions: 'captions',
    main: 'main',
    sign: 'sign',
    subtitles: 'subtitles',
    commentary: 'commentary'
};
/**
 * All possible `AudioTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
 * @typedef AudioTrack~Kind
 * @enum
 */ const $cb03b711053a4297$var$AudioTrackKind = {
    'alternative': 'alternative',
    'descriptions': 'descriptions',
    'main': 'main',
    'main-desc': 'main-desc',
    'translation': 'translation',
    'commentary': 'commentary'
};
/**
 * All possible `TextTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
 * @typedef TextTrack~Kind
 * @enum
 */ const $cb03b711053a4297$var$TextTrackKind = {
    subtitles: 'subtitles',
    captions: 'captions',
    descriptions: 'descriptions',
    chapters: 'chapters',
    metadata: 'metadata'
};
/**
 * All possible `TextTrackMode`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
 * @typedef TextTrack~Mode
 * @enum
 */ const $cb03b711053a4297$var$TextTrackMode = {
    disabled: 'disabled',
    hidden: 'hidden',
    showing: 'showing'
};
/**
 * @file track.js
 */ /**
 * A Track class that contains all of the common functionality for {@link AudioTrack},
 * {@link VideoTrack}, and {@link TextTrack}.
 *
 * > Note: This class should not be used directly
 *
 * @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
 * @extends EventTarget
 * @abstract
 */ class $cb03b711053a4297$var$Track extends $cb03b711053a4297$var$EventTarget$2 {
    /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid kind for the track type you are creating.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @abstract
   */ constructor(options = {}){
        super();
        const trackProps = {
            id: options.id || 'vjs_track_' + $cb03b711053a4297$var$newGUID(),
            kind: options.kind || '',
            language: options.language || ''
        };
        let label = options.label || '';
        /**
     * @memberof Track
     * @member {string} id
     *         The id of this track. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */ /**
     * @memberof Track
     * @member {string} kind
     *         The kind of track that this is. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */ /**
     * @memberof Track
     * @member {string} language
     *         The two letter language code for this track. Cannot be changed after
     *         creation.
     * @instance
     *
     * @readonly
     */ for(const key in trackProps)Object.defineProperty(this, key, {
            get () {
                return trackProps[key];
            },
            set () {}
        });
        /**
     * @memberof Track
     * @member {string} label
     *         The label of this track. Cannot be changed after creation.
     * @instance
     *
     * @fires Track#labelchange
     */ Object.defineProperty(this, 'label', {
            get () {
                return label;
            },
            set (newLabel) {
                if (newLabel !== label) {
                    label = newLabel;
                    /**
           * An event that fires when label changes on this track.
           *
           * > Note: This is not part of the spec!
           *
           * @event Track#labelchange
           * @type {Event}
           */ this.trigger('labelchange');
                }
            }
        });
    }
}
/**
 * @file url.js
 * @module url
 */ /**
 * Resolve and parse the elements of a URL.
 *
 * @function
 * @param    {string} url
 *           The url to parse
 *
 * @return   {URL}
 *           An object of url details
 */ const $cb03b711053a4297$var$parseUrl = function(url) {
    return new URL(url, (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).baseURI);
};
/**
 * Get absolute version of relative URL.
 *
 * @function
 * @param    {string} url
 *           URL to make absolute
 *
 * @return   {string}
 *           Absolute URL
 */ const $cb03b711053a4297$var$getAbsoluteURL = function(url) {
    return new URL(url, (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).baseURI).href;
};
/**
 * Returns the extension of the passed file name. It will return an empty string
 * if passed an invalid path.
 *
 * @function
 * @param    {string} path
 *           The fileName path like '/path/to/file.mp4'
 *
 * @return  {string}
 *           The extension in lower case or an empty string if no
 *           extension could be found.
 */ const $cb03b711053a4297$var$getFileExtension = function(path) {
    if (typeof path === 'string') {
        const cleanPath = path.split('?')[0].replace(/\/+$/, '');
        const match = cleanPath.match(/\.([^.\/]+)$/);
        return match ? match[1].toLowerCase() : '';
    }
    return '';
};
/**
 * Returns whether the url passed is a cross domain request or not.
 *
 * @function
 * @param    {string} url
 *           The url to check.
 *
 * @param    {URL} [winLoc]
 *           the domain to check the url against, defaults to window.location
 *
 * @return   {boolean}
 *           Whether it is a cross domain request or not.
 */ const $cb03b711053a4297$var$isCrossOrigin = function(url, winLoc = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location) {
    return $cb03b711053a4297$var$parseUrl(url).origin !== winLoc.origin;
};
var $cb03b711053a4297$var$Url = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    parseUrl: $cb03b711053a4297$var$parseUrl,
    getAbsoluteURL: $cb03b711053a4297$var$getAbsoluteURL,
    getFileExtension: $cb03b711053a4297$var$getFileExtension,
    isCrossOrigin: $cb03b711053a4297$var$isCrossOrigin
});
/**
 * @file text-track.js
 */ /** @import Tech from '../tech/tech' */ /**
 * Takes a webvtt file contents and parses it into cues
 *
 * @param {string} srcContent
 *        webVTT file contents
 *
 * @param {TextTrack} track
 *        TextTrack to add cues to. Cues come from the srcContent.
 *
 * @private
 */ const $cb03b711053a4297$var$parseCues = function(srcContent, track) {
    const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.Parser((0, (/*@__PURE__*/$parcel$interopDefault($eDick))), (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).vttjs, (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.StringDecoder());
    const errors = [];
    parser.oncue = function(cue) {
        track.addCue(cue);
    };
    parser.onparsingerror = function(error) {
        errors.push(error);
    };
    parser.onflush = function() {
        track.trigger({
            type: 'loadeddata',
            target: track
        });
    };
    parser.parse(srcContent);
    if (errors.length > 0) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.groupCollapsed) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.groupCollapsed(`Text Track parsing errors for ${track.src}`);
        errors.forEach((error)=>$cb03b711053a4297$var$log$1.error(error));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.groupEnd) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.groupEnd();
    }
    parser.flush();
};
/**
 * Load a `TextTrack` from a specified url.
 *
 * @param {string} src
 *        Url to load track from.
 *
 * @param {TextTrack} track
 *        Track to add cues to. Comes from the content at the end of `url`.
 *
 * @private
 */ const $cb03b711053a4297$var$loadTrack = function(src, track) {
    const opts = {
        uri: src
    };
    const crossOrigin = $cb03b711053a4297$var$isCrossOrigin(src);
    if (crossOrigin) opts.cors = crossOrigin;
    const withCredentials = track.tech_.crossOrigin() === 'use-credentials';
    if (withCredentials) opts.withCredentials = withCredentials;
    (0, (/*@__PURE__*/$parcel$interopDefault($hPwoy)))(opts, $cb03b711053a4297$var$bind_(this, function(err, response, responseBody) {
        if (err) return $cb03b711053a4297$var$log$1.error(err, response);
        track.loaded_ = true;
        // Make sure that vttjs has loaded, otherwise, wait till it finished loading
        // NOTE: this is only used for the alt/video.novtt.js build
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT !== 'function') {
            if (track.tech_) // to prevent use before define eslint error, we define loadHandler
            // as a let here
            track.tech_.any([
                'vttjsloaded',
                'vttjserror'
            ], (event)=>{
                if (event.type === 'vttjserror') {
                    $cb03b711053a4297$var$log$1.error(`vttjs failed to load, stopping trying to process ${track.src}`);
                    return;
                }
                return $cb03b711053a4297$var$parseCues(responseBody, track);
            });
        } else $cb03b711053a4297$var$parseCues(responseBody, track);
    }));
};
/**
 * A representation of a single `TextTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
 * @extends Track
 */ class $cb03b711053a4297$var$TextTrack extends $cb03b711053a4297$var$Track {
    /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this TextTrack.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */ constructor(options = {}){
        if (!options.tech) throw new Error('A tech was not provided.');
        const settings = $cb03b711053a4297$var$merge$1(options, {
            kind: $cb03b711053a4297$var$TextTrackKind[options.kind] || 'subtitles',
            language: options.language || options.srclang || ''
        });
        let mode = $cb03b711053a4297$var$TextTrackMode[settings.mode] || 'disabled';
        const default_ = settings.default;
        if (settings.kind === 'metadata' || settings.kind === 'chapters') mode = 'hidden';
        super(settings);
        this.tech_ = settings.tech;
        this.cues_ = [];
        this.activeCues_ = [];
        this.preload_ = this.tech_.preloadTextTracks !== false;
        const cues = new $cb03b711053a4297$var$TextTrackCueList(this.cues_);
        const activeCues = new $cb03b711053a4297$var$TextTrackCueList(this.activeCues_);
        let changed = false;
        this.timeupdateHandler = $cb03b711053a4297$var$bind_(this, function(event = {}) {
            if (this.tech_.isDisposed()) return;
            if (!this.tech_.isReady_) {
                if (event.type !== 'timeupdate') this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
                return;
            }
            // Accessing this.activeCues for the side-effects of updating itself
            // due to its nature as a getter function. Do not remove or cues will
            // stop updating!
            // Use the setter to prevent deletion from uglify (pure_getters rule)
            this.activeCues = this.activeCues;
            if (changed) {
                this.trigger('cuechange');
                changed = false;
            }
            if (event.type !== 'timeupdate') this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
        });
        const disposeHandler = ()=>{
            this.stopTracking();
        };
        this.tech_.one('dispose', disposeHandler);
        if (mode !== 'disabled') this.startTracking();
        Object.defineProperties(this, {
            /**
       * @memberof TextTrack
       * @member {boolean} default
       *         If this track was set to be on or off by default. Cannot be changed after
       *         creation.
       * @instance
       *
       * @readonly
       */ default: {
                get () {
                    return default_;
                },
                set () {}
            },
            /**
       * @memberof TextTrack
       * @member {string} mode
       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
       *         not be set if setting to an invalid mode.
       * @instance
       *
       * @fires TextTrack#modechange
       */ mode: {
                get () {
                    return mode;
                },
                set (newMode) {
                    if (!$cb03b711053a4297$var$TextTrackMode[newMode]) return;
                    if (mode === newMode) return;
                    mode = newMode;
                    if (!this.preload_ && mode !== 'disabled' && this.cues.length === 0) // On-demand load.
                    $cb03b711053a4297$var$loadTrack(this.src, this);
                    this.stopTracking();
                    if (mode !== 'disabled') this.startTracking();
                    /**
           * An event that fires when mode changes on this track. This allows
           * the TextTrackList that holds this track to act accordingly.
           *
           * > Note: This is not part of the spec!
           *
           * @event TextTrack#modechange
           * @type {Event}
           */ this.trigger('modechange');
                }
            },
            /**
       * @memberof TextTrack
       * @member {TextTrackCueList} cues
       *         The text track cue list for this TextTrack.
       * @instance
       */ cues: {
                get () {
                    if (!this.loaded_) return null;
                    return cues;
                },
                set () {}
            },
            /**
       * @memberof TextTrack
       * @member {TextTrackCueList} activeCues
       *         The list text track cues that are currently active for this TextTrack.
       * @instance
       */ activeCues: {
                get () {
                    if (!this.loaded_) return null;
                    // nothing to do
                    if (this.cues.length === 0) return activeCues;
                    const ct = this.tech_.currentTime();
                    const active = [];
                    for(let i = 0, l = this.cues.length; i < l; i++){
                        const cue = this.cues[i];
                        if (cue.startTime <= ct && cue.endTime >= ct) active.push(cue);
                    }
                    changed = false;
                    if (active.length !== this.activeCues_.length) changed = true;
                    else {
                        for(let i = 0; i < active.length; i++)if (this.activeCues_.indexOf(active[i]) === -1) changed = true;
                    }
                    this.activeCues_ = active;
                    activeCues.setCues_(this.activeCues_);
                    return activeCues;
                },
                // /!\ Keep this setter empty (see the timeupdate handler above)
                set () {}
            }
        });
        if (settings.src) {
            this.src = settings.src;
            if (!this.preload_) // Tracks will load on-demand.
            // Act like we're loaded for other purposes.
            this.loaded_ = true;
            if (this.preload_ || settings.kind !== 'subtitles' && settings.kind !== 'captions') $cb03b711053a4297$var$loadTrack(this.src, this);
        } else this.loaded_ = true;
    }
    startTracking() {
        // More precise cues based on requestVideoFrameCallback with a requestAnimationFram fallback
        this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
        // Also listen to timeupdate in case rVFC/rAF stops (window in background, audio in video el)
        this.tech_.on('timeupdate', this.timeupdateHandler);
    }
    stopTracking() {
        if (this.rvf_) {
            this.tech_.cancelVideoFrameCallback(this.rvf_);
            this.rvf_ = undefined;
        }
        this.tech_.off('timeupdate', this.timeupdateHandler);
    }
    /**
   * Add a cue to the internal list of cues.
   *
   * @param {TextTrack~Cue} cue
   *        The cue to add to our internal list
   */ addCue(originalCue) {
        let cue = originalCue;
        // Testing if the cue is a VTTCue in a way that survives minification
        if (!('getCueAsHTML' in cue)) {
            cue = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);
            for(const prop in originalCue)if (!(prop in cue)) cue[prop] = originalCue[prop];
            // make sure that `id` is copied over
            cue.id = originalCue.id;
            cue.originalCue_ = originalCue;
        }
        const tracks = this.tech_.textTracks();
        for(let i = 0; i < tracks.length; i++)if (tracks[i] !== this) tracks[i].removeCue(cue);
        this.cues_.push(cue);
        this.cues.setCues_(this.cues_);
    }
    /**
   * Creates a copy of the text track and makes it serializable
   * by removing circular dependencies.
   *
   * @return {Object} The track information as a serializable object
   */ toJSON() {
        return $cb03b711053a4297$var$textTrackConverter.trackToJson(this);
    }
    /**
   * Remove a cue from our internal list
   *
   * @param {TextTrack~Cue} removeCue
   *        The cue to remove from our internal list
   */ removeCue(removeCue) {
        let i = this.cues_.length;
        while(i--){
            const cue = this.cues_[i];
            if (cue === removeCue || cue.originalCue_ && cue.originalCue_ === removeCue) {
                this.cues_.splice(i, 1);
                this.cues.setCues_(this.cues_);
                break;
            }
        }
    }
}
/**
 * cuechange - One or more cues in the track have become active or stopped being active.
 *
 * @protected
 */ $cb03b711053a4297$var$TextTrack.prototype.allowedEvents_ = {
    cuechange: 'cuechange'
};
/**
 * A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
 * only one `AudioTrack` in the list will be enabled at a time.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
 * @extends Track
 */ class $cb03b711053a4297$var$AudioTrack extends $cb03b711053a4297$var$Track {
    /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {AudioTrack~Kind} [options.kind='']
   *        A valid audio track kind
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.enabled]
   *        If this track is the one that is currently playing. If this track is part of
   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
   */ constructor(options = {}){
        const settings = $cb03b711053a4297$var$merge$1(options, {
            kind: $cb03b711053a4297$var$AudioTrackKind[options.kind] || ''
        });
        super(settings);
        let enabled = false;
        /**
     * @memberof AudioTrack
     * @member {boolean} enabled
     *         If this `AudioTrack` is enabled or not. When setting this will
     *         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */ Object.defineProperty(this, 'enabled', {
            get () {
                return enabled;
            },
            set (newEnabled) {
                // an invalid or unchanged value
                if (typeof newEnabled !== 'boolean' || newEnabled === enabled) return;
                enabled = newEnabled;
                /**
         * An event that fires when enabled changes on this track. This allows
         * the AudioTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event AudioTrack#enabledchange
         * @type {Event}
         */ this.trigger('enabledchange');
            }
        });
        // if the user sets this track to selected then
        // set selected to that true value otherwise
        // we keep it false
        if (settings.enabled) this.enabled = settings.enabled;
        this.loaded_ = true;
    }
}
/**
 * A representation of a single `VideoTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
 * @extends Track
 */ class $cb03b711053a4297$var$VideoTrack extends $cb03b711053a4297$var$Track {
    /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid {@link VideoTrack~Kind}
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.selected]
   *        If this track is the one that is currently playing.
   */ constructor(options = {}){
        const settings = $cb03b711053a4297$var$merge$1(options, {
            kind: $cb03b711053a4297$var$VideoTrackKind[options.kind] || ''
        });
        super(settings);
        let selected = false;
        /**
     * @memberof VideoTrack
     * @member {boolean} selected
     *         If this `VideoTrack` is selected or not. When setting this will
     *         fire {@link VideoTrack#selectedchange} if the state of selected changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */ Object.defineProperty(this, 'selected', {
            get () {
                return selected;
            },
            set (newSelected) {
                // an invalid or unchanged value
                if (typeof newSelected !== 'boolean' || newSelected === selected) return;
                selected = newSelected;
                /**
         * An event that fires when selected changes on this track. This allows
         * the VideoTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event VideoTrack#selectedchange
         * @type {Event}
         */ this.trigger('selectedchange');
            }
        });
        // if the user sets this track to selected then
        // set selected to that true value otherwise
        // we keep it false
        if (settings.selected) this.selected = settings.selected;
    }
}
/**
 * @file html-track-element.js
 */ /** @import Tech from '../tech/tech' */ /**
 * A single track represented in the DOM.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
 * @extends EventTarget
 */ class $cb03b711053a4297$var$HTMLTrackElement extends $cb03b711053a4297$var$EventTarget$2 {
    /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this HTMLTrackElement.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */ constructor(options = {}){
        super();
        let readyState;
        const track = new $cb03b711053a4297$var$TextTrack(options);
        this.kind = track.kind;
        this.src = track.src;
        this.srclang = track.language;
        this.label = track.label;
        this.default = track.default;
        Object.defineProperties(this, {
            /**
       * @memberof HTMLTrackElement
       * @member {HTMLTrackElement~ReadyState} readyState
       *         The current ready state of the track element.
       * @instance
       */ readyState: {
                get () {
                    return readyState;
                }
            },
            /**
       * @memberof HTMLTrackElement
       * @member {TextTrack} track
       *         The underlying TextTrack object.
       * @instance
       *
       */ track: {
                get () {
                    return track;
                }
            }
        });
        readyState = $cb03b711053a4297$var$HTMLTrackElement.NONE;
        /**
     * @listens TextTrack#loadeddata
     * @fires HTMLTrackElement#load
     */ track.addEventListener('loadeddata', ()=>{
            readyState = $cb03b711053a4297$var$HTMLTrackElement.LOADED;
            this.trigger({
                type: 'load',
                target: this
            });
        });
    }
}
/**
 * @protected
 */ $cb03b711053a4297$var$HTMLTrackElement.prototype.allowedEvents_ = {
    load: 'load'
};
/**
 * The text track not loaded state.
 *
 * @type {number}
 * @static
 */ $cb03b711053a4297$var$HTMLTrackElement.NONE = 0;
/**
 * The text track loading state.
 *
 * @type {number}
 * @static
 */ $cb03b711053a4297$var$HTMLTrackElement.LOADING = 1;
/**
 * The text track loaded state.
 *
 * @type {number}
 * @static
 */ $cb03b711053a4297$var$HTMLTrackElement.LOADED = 2;
/**
 * The text track failed to load state.
 *
 * @type {number}
 * @static
 */ $cb03b711053a4297$var$HTMLTrackElement.ERROR = 3;
/*
 * This file contains all track properties that are used in
 * player.js, tech.js, html5.js and possibly other techs in the future.
 */ const $cb03b711053a4297$var$NORMAL = {
    audio: {
        ListClass: $cb03b711053a4297$var$AudioTrackList,
        TrackClass: $cb03b711053a4297$var$AudioTrack,
        capitalName: 'Audio'
    },
    video: {
        ListClass: $cb03b711053a4297$var$VideoTrackList,
        TrackClass: $cb03b711053a4297$var$VideoTrack,
        capitalName: 'Video'
    },
    text: {
        ListClass: $cb03b711053a4297$var$TextTrackList,
        TrackClass: $cb03b711053a4297$var$TextTrack,
        capitalName: 'Text'
    }
};
Object.keys($cb03b711053a4297$var$NORMAL).forEach(function(type) {
    $cb03b711053a4297$var$NORMAL[type].getterName = `${type}Tracks`;
    $cb03b711053a4297$var$NORMAL[type].privateName = `${type}Tracks_`;
});
const $cb03b711053a4297$var$REMOTE = {
    remoteText: {
        ListClass: $cb03b711053a4297$var$TextTrackList,
        TrackClass: $cb03b711053a4297$var$TextTrack,
        capitalName: 'RemoteText',
        getterName: 'remoteTextTracks',
        privateName: 'remoteTextTracks_'
    },
    remoteTextEl: {
        ListClass: $cb03b711053a4297$var$HtmlTrackElementList,
        TrackClass: $cb03b711053a4297$var$HTMLTrackElement,
        capitalName: 'RemoteTextTrackEls',
        getterName: 'remoteTextTrackEls',
        privateName: 'remoteTextTrackEls_'
    }
};
const $cb03b711053a4297$var$ALL = Object.assign({}, $cb03b711053a4297$var$NORMAL, $cb03b711053a4297$var$REMOTE);
$cb03b711053a4297$var$REMOTE.names = Object.keys($cb03b711053a4297$var$REMOTE);
$cb03b711053a4297$var$NORMAL.names = Object.keys($cb03b711053a4297$var$NORMAL);
$cb03b711053a4297$var$ALL.names = [].concat($cb03b711053a4297$var$REMOTE.names).concat($cb03b711053a4297$var$NORMAL.names);
/**
 * @file tech.js
 */ /** @import { TimeRange } from '../utils/time' */ /**
 * An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
 * that just contains the src url alone.
 * * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
   * `var SourceString = 'http://example.com/some-video.mp4';`
 *
 * @typedef {Object|string} SourceObject
 *
 * @property {string} src
 *           The url to the source
 *
 * @property {string} type
 *           The mime type of the source
 */ /**
 * A function used by {@link Tech} to create a new {@link TextTrack}.
 *
 * @private
 *
 * @param {Tech} self
 *        An instance of the Tech class.
 *
 * @param {string} kind
 *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
 *
 * @param {string} [label]
 *        Label to identify the text track
 *
 * @param {string} [language]
 *        Two letter language abbreviation
 *
 * @param {Object} [options={}]
 *        An object with additional text track options
 *
 * @return {TextTrack}
 *          The text track that was created.
 */ function $cb03b711053a4297$var$createTrackHelper(self1, kind, label, language, options = {}) {
    const tracks = self1.textTracks();
    options.kind = kind;
    if (label) options.label = label;
    if (language) options.language = language;
    options.tech = self1;
    const track = new $cb03b711053a4297$var$ALL.text.TrackClass(options);
    tracks.addTrack(track);
    return track;
}
/**
 * This is the base class for media playback technology controllers, such as
 * {@link HTML5}
 *
 * @extends Component
 */ class $cb03b711053a4297$var$Tech extends $cb03b711053a4297$var$Component$1 {
    /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */ constructor(options = {}, ready = function() {}){
        // we don't want the tech to report user activity automatically.
        // This is done manually in addControlsListeners
        options.reportTouchActivity = false;
        super(null, options, ready);
        this.onDurationChange_ = (e)=>this.onDurationChange(e);
        this.trackProgress_ = (e)=>this.trackProgress(e);
        this.trackCurrentTime_ = (e)=>this.trackCurrentTime(e);
        this.stopTrackingCurrentTime_ = (e)=>this.stopTrackingCurrentTime(e);
        this.disposeSourceHandler_ = (e)=>this.disposeSourceHandler(e);
        this.queuedHanders_ = new Set();
        // keep track of whether the current source has played at all to
        // implement a very limited played()
        this.hasStarted_ = false;
        this.on('playing', function() {
            this.hasStarted_ = true;
        });
        this.on('loadstart', function() {
            this.hasStarted_ = false;
        });
        $cb03b711053a4297$var$ALL.names.forEach((name)=>{
            const props = $cb03b711053a4297$var$ALL[name];
            if (options && options[props.getterName]) this[props.privateName] = options[props.getterName];
        });
        // Manually track progress in cases where the browser/tech doesn't report it.
        if (!this.featuresProgressEvents) this.manualProgressOn();
        // Manually track timeupdates in cases where the browser/tech doesn't report it.
        if (!this.featuresTimeupdateEvents) this.manualTimeUpdatesOn();
        [
            'Text',
            'Audio',
            'Video'
        ].forEach((track)=>{
            if (options[`native${track}Tracks`] === false) this[`featuresNative${track}Tracks`] = false;
        });
        if (options.nativeCaptions === false || options.nativeTextTracks === false) this.featuresNativeTextTracks = false;
        else if (options.nativeCaptions === true || options.nativeTextTracks === true) this.featuresNativeTextTracks = true;
        if (!this.featuresNativeTextTracks) this.emulateTextTracks();
        this.preloadTextTracks = options.preloadTextTracks !== false;
        this.autoRemoteTextTracks_ = new $cb03b711053a4297$var$ALL.text.ListClass();
        this.initTrackListeners();
        // Turn on component tap events only if not using native controls
        if (!options.nativeControlsForTouch) this.emitTapEvents();
        if (this.constructor) this.name_ = this.constructor.name || 'Unknown Tech';
    }
    /**
   * A special function to trigger source set in a way that will allow player
   * to re-trigger if the player or tech are not ready yet.
   *
   * @fires Tech#sourceset
   * @param {string} src The source string at the time of the source changing.
   */ triggerSourceset(src) {
        if (!this.isReady_) // on initial ready we have to trigger source set
        // 1ms after ready so that player can watch for it.
        this.one('ready', ()=>this.setTimeout(()=>this.triggerSourceset(src), 1));
        /**
     * Fired when the source is set on the tech causing the media element
     * to reload.
     *
     * @see {@link Player#event:sourceset}
     * @event Tech#sourceset
     * @type {Event}
     */ this.trigger({
            src: src,
            type: 'sourceset'
        });
    }
    /* Fallbacks for unsupported event types
  ================================================================================ */ /**
   * Polyfill the `progress` event for browsers that don't support it natively.
   *
   * @see {@link Tech#trackProgress}
   */ manualProgressOn() {
        this.on('durationchange', this.onDurationChange_);
        this.manualProgress = true;
        // Trigger progress watching when a source begins loading
        this.one('ready', this.trackProgress_);
    }
    /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   */ manualProgressOff() {
        this.manualProgress = false;
        this.stopTrackingProgress();
        this.off('durationchange', this.onDurationChange_);
    }
    /**
   * This is used to trigger a `progress` event when the buffered percent changes. It
   * sets an interval function that will be called every 500 milliseconds to check if the
   * buffer end percent has changed.
   *
   * > This function is called by {@link Tech#manualProgressOn}
   *
   * @param {Event} event
   *        The `ready` event that caused this to run.
   *
   * @listens Tech#ready
   * @fires Tech#progress
   */ trackProgress(event) {
        this.stopTrackingProgress();
        this.progressInterval = this.setInterval($cb03b711053a4297$var$bind_(this, function() {
            // Don't trigger unless buffered amount is greater than last time
            const numBufferedPercent = this.bufferedPercent();
            if (this.bufferedPercent_ !== numBufferedPercent) /**
         * See {@link Player#progress}
         *
         * @event Tech#progress
         * @type {Event}
         */ this.trigger('progress');
            this.bufferedPercent_ = numBufferedPercent;
            if (numBufferedPercent === 1) this.stopTrackingProgress();
        }), 500);
    }
    /**
   * Update our internal duration on a `durationchange` event by calling
   * {@link Tech#duration}.
   *
   * @param {Event} event
   *        The `durationchange` event that caused this to run.
   *
   * @listens Tech#durationchange
   */ onDurationChange(event) {
        this.duration_ = this.duration();
    }
    /**
   * Get and create a `TimeRange` object for buffering.
   *
   * @return {TimeRange}
   *         The time range object that was created.
   */ buffered() {
        return $cb03b711053a4297$var$createTimeRanges$1(0, 0);
    }
    /**
   * Get the percentage of the current video that is currently buffered.
   *
   * @return {number}
   *         A number from 0 to 1 that represents the decimal percentage of the
   *         video that is buffered.
   *
   */ bufferedPercent() {
        return $cb03b711053a4297$var$bufferedPercent(this.buffered(), this.duration_);
    }
    /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   * Stop manually tracking progress events by clearing the interval that was set in
   * {@link Tech#trackProgress}.
   */ stopTrackingProgress() {
        this.clearInterval(this.progressInterval);
    }
    /**
   * Polyfill the `timeupdate` event for browsers that don't support it.
   *
   * @see {@link Tech#trackCurrentTime}
   */ manualTimeUpdatesOn() {
        this.manualTimeUpdates = true;
        this.on('play', this.trackCurrentTime_);
        this.on('pause', this.stopTrackingCurrentTime_);
    }
    /**
   * Turn off the polyfill for `timeupdate` events that was created in
   * {@link Tech#manualTimeUpdatesOn}
   */ manualTimeUpdatesOff() {
        this.manualTimeUpdates = false;
        this.stopTrackingCurrentTime();
        this.off('play', this.trackCurrentTime_);
        this.off('pause', this.stopTrackingCurrentTime_);
    }
    /**
   * Sets up an interval function to track current time and trigger `timeupdate` every
   * 250 milliseconds.
   *
   * @listens Tech#play
   * @triggers Tech#timeupdate
   */ trackCurrentTime() {
        if (this.currentTimeInterval) this.stopTrackingCurrentTime();
        this.currentTimeInterval = this.setInterval(function() {
            /**
       * Triggered at an interval of 250ms to indicated that time is passing in the video.
       *
       * @event Tech#timeupdate
       * @type {Event}
       */ this.trigger({
                type: 'timeupdate',
                target: this,
                manuallyTriggered: true
            });
        // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
        }, 250);
    }
    /**
   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
   * `timeupdate` event is no longer triggered.
   *
   * @listens {Tech#pause}
   */ stopTrackingCurrentTime() {
        this.clearInterval(this.currentTimeInterval);
        // #1002 - if the video ends right before the next timeupdate would happen,
        // the progress bar won't make it all the way to the end
        this.trigger({
            type: 'timeupdate',
            target: this,
            manuallyTriggered: true
        });
    }
    /**
   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
   *
   * @fires Component#dispose
   */ dispose() {
        // clear out all tracks because we can't reuse them between techs
        this.clearTracks($cb03b711053a4297$var$NORMAL.names);
        // Turn off any manual progress or timeupdate tracking
        if (this.manualProgress) this.manualProgressOff();
        if (this.manualTimeUpdates) this.manualTimeUpdatesOff();
        super.dispose();
    }
    /**
   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
   *
   * > Note: Techs without source handlers should call this between sources for `video`
   *         & `audio` tracks. You don't want to use them between tracks!
   *
   * @param {string[]|string} types
   *        TrackList names to clear, valid names are `video`, `audio`, and
   *        `text`.
   */ clearTracks(types) {
        types = [].concat(types);
        // clear out all tracks because we can't reuse them between techs
        types.forEach((type)=>{
            const list = this[`${type}Tracks`]() || [];
            let i = list.length;
            while(i--){
                const track = list[i];
                if (type === 'text') this.removeRemoteTextTrack(track);
                list.removeTrack(track);
            }
        });
    }
    /**
   * Remove any TextTracks added via addRemoteTextTrack that are
   * flagged for automatic garbage collection
   */ cleanupAutoTextTracks() {
        const list = this.autoRemoteTextTracks_ || [];
        let i = list.length;
        while(i--){
            const track = list[i];
            this.removeRemoteTextTrack(track);
        }
    }
    /**
   * Reset the tech, which will removes all sources and reset the internal readyState.
   *
   * @abstract
   */ reset() {}
    /**
   * Get the value of `crossOrigin` from the tech.
   *
   * @abstract
   *
   * @see {Html5#crossOrigin}
   */ crossOrigin() {}
    /**
   * Set the value of `crossOrigin` on the tech.
   *
   * @abstract
   *
   * @param {string} crossOrigin the crossOrigin value
   * @see {Html5#setCrossOrigin}
   */ setCrossOrigin() {}
    /**
   * Get or set an error on the Tech.
   *
   * @param {MediaError} [err]
   *        Error to set on the Tech
   *
   * @return {MediaError|null}
   *         The current error object on the tech, or null if there isn't one.
   */ error(err) {
        if (err !== undefined) {
            this.error_ = new $cb03b711053a4297$var$MediaError(err);
            this.trigger('error');
        }
        return this.error_;
    }
    /**
   * Returns the `TimeRange`s that have been played through for the current source.
   *
   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
   *         It only checks whether the source has played at all or not.
   *
   * @return {TimeRange}
   *         - A single time range if this video has played
   *         - An empty set of ranges if not.
   */ played() {
        if (this.hasStarted_) return $cb03b711053a4297$var$createTimeRanges$1(0, 0);
        return $cb03b711053a4297$var$createTimeRanges$1();
    }
    /**
   * Start playback
   *
   * @abstract
   *
   * @see {Html5#play}
   */ play() {}
    /**
   * Set whether we are scrubbing or not
   *
   * @abstract
   * @param {boolean} _isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   *
   * @see {Html5#setScrubbing}
   */ setScrubbing(_isScrubbing) {}
    /**
   * Get whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#scrubbing}
   */ scrubbing() {}
    /**
   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
   * previously called.
   *
   * @param {number} _seconds
   *        Set the current time of the media to this.
   * @fires Tech#timeupdate
   */ setCurrentTime(_seconds) {
        // improve the accuracy of manual timeupdates
        if (this.manualTimeUpdates) /**
       * A manual `timeupdate` event.
       *
       * @event Tech#timeupdate
       * @type {Event}
       */ this.trigger({
            type: 'timeupdate',
            target: this,
            manuallyTriggered: true
        });
    }
    /**
   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
   * {@link TextTrackList} events.
   *
   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
   *
   * @fires Tech#audiotrackchange
   * @fires Tech#videotrackchange
   * @fires Tech#texttrackchange
   */ initTrackListeners() {
        /**
      * Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
      *
      * @event Tech#audiotrackchange
      * @type {Event}
      */ /**
      * Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
      *
      * @event Tech#videotrackchange
      * @type {Event}
      */ /**
      * Triggered when tracks are added or removed on the Tech {@link TextTrackList}
      *
      * @event Tech#texttrackchange
      * @type {Event}
      */ $cb03b711053a4297$var$NORMAL.names.forEach((name)=>{
            const props = $cb03b711053a4297$var$NORMAL[name];
            const trackListChanges = ()=>{
                this.trigger(`${name}trackchange`);
            };
            const tracks = this[props.getterName]();
            tracks.addEventListener('removetrack', trackListChanges);
            tracks.addEventListener('addtrack', trackListChanges);
            this.on('dispose', ()=>{
                tracks.removeEventListener('removetrack', trackListChanges);
                tracks.removeEventListener('addtrack', trackListChanges);
            });
        });
    }
    /**
   * Emulate TextTracks using vtt.js if necessary
   *
   * @fires Tech#vttjsloaded
   * @fires Tech#vttjserror
   */ addWebVttScript_() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT) return;
        // Initially, Tech.el_ is a child of a dummy-div wait until the Component system
        // signals that the Tech is ready at which point Tech.el_ is part of the DOM
        // before inserting the WebVTT script
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).body.contains(this.el())) {
            // load via require if available and vtt.js script location was not passed in
            // as an option. novtt builds will turn the above require call into an empty object
            // which will cause this if check to always fail.
            if (!this.options_['vtt.js'] && $cb03b711053a4297$var$isPlain((0, (/*@__PURE__*/$parcel$interopDefault($a4Nb0)))) && Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($a4Nb0)))).length > 0) {
                this.trigger('vttjsloaded');
                return;
            }
            // load vtt.js via the script location option or the cdn of no location was
            // passed in
            const script = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('script');
            script.src = this.options_['vtt.js'] || 'https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js';
            script.onload = ()=>{
                /**
         * Fired when vtt.js is loaded.
         *
         * @event Tech#vttjsloaded
         * @type {Event}
         */ this.trigger('vttjsloaded');
            };
            script.onerror = ()=>{
                /**
         * Fired when vtt.js was not loaded due to an error
         *
         * @event Tech#vttjsloaded
         * @type {Event}
         */ this.trigger('vttjserror');
            };
            this.on('dispose', ()=>{
                script.onload = null;
                script.onerror = null;
            });
            // but have not loaded yet and we set it to true before the inject so that
            // we don't overwrite the injected window.WebVTT if it loads right away
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT = true;
            this.el().parentNode.appendChild(script);
        } else this.ready(this.addWebVttScript_);
    }
    /**
   * Emulate texttracks
   *
   */ emulateTextTracks() {
        const tracks = this.textTracks();
        const remoteTracks = this.remoteTextTracks();
        const handleAddTrack = (e)=>tracks.addTrack(e.track);
        const handleRemoveTrack = (e)=>tracks.removeTrack(e.track);
        remoteTracks.on('addtrack', handleAddTrack);
        remoteTracks.on('removetrack', handleRemoveTrack);
        this.addWebVttScript_();
        const updateDisplay = ()=>this.trigger('texttrackchange');
        const textTracksChanges = ()=>{
            updateDisplay();
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                track.removeEventListener('cuechange', updateDisplay);
                if (track.mode === 'showing') track.addEventListener('cuechange', updateDisplay);
            }
        };
        textTracksChanges();
        tracks.addEventListener('change', textTracksChanges);
        tracks.addEventListener('addtrack', textTracksChanges);
        tracks.addEventListener('removetrack', textTracksChanges);
        this.on('dispose', function() {
            remoteTracks.off('addtrack', handleAddTrack);
            remoteTracks.off('removetrack', handleRemoveTrack);
            tracks.removeEventListener('change', textTracksChanges);
            tracks.removeEventListener('addtrack', textTracksChanges);
            tracks.removeEventListener('removetrack', textTracksChanges);
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                track.removeEventListener('cuechange', updateDisplay);
            }
        });
    }
    /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */ addTextTrack(kind, label, language) {
        if (!kind) throw new Error('TextTrack kind is required but was not provided');
        return $cb03b711053a4297$var$createTrackHelper(this, kind, label, language);
    }
    /**
   * Create an emulated TextTrack for use by addRemoteTextTrack
   *
   * This is intended to be overridden by classes that inherit from
   * Tech in order to create native or custom TextTracks.
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */ createRemoteTextTrack(options) {
        const track = $cb03b711053a4297$var$merge$1(options, {
            tech: this
        });
        return new $cb03b711053a4297$var$REMOTE.remoteTextEl.TrackClass(track);
    }
    /**
   * Creates a remote text track object and returns an html track element.
   *
   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   * @param {Object} options
   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
   *
   * @param {boolean} [manualCleanup=false]
   *        - When false: the TextTrack will be automatically removed from the video
   *          element whenever the source changes
   *        - When True: The TextTrack will have to be cleaned up manually
   *
   * @return {HTMLTrackElement}
   *         An Html Track Element.
   *
   */ addRemoteTextTrack(options = {}, manualCleanup) {
        const htmlTrackElement = this.createRemoteTextTrack(options);
        if (typeof manualCleanup !== 'boolean') manualCleanup = false;
        // store HTMLTrackElement and TextTrack to remote list
        this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
        this.remoteTextTracks().addTrack(htmlTrackElement.track);
        if (manualCleanup === false) // create the TextTrackList if it doesn't exist
        this.ready(()=>this.autoRemoteTextTracks_.addTrack(htmlTrackElement.track));
        return htmlTrackElement;
    }
    /**
   * Remove a remote text track from the remote `TextTrackList`.
   *
   * @param {TextTrack} track
   *        `TextTrack` to remove from the `TextTrackList`
   */ removeRemoteTextTrack(track) {
        const trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track);
        // remove HTMLTrackElement and TextTrack from remote list
        this.remoteTextTrackEls().removeTrackElement_(trackElement);
        this.remoteTextTracks().removeTrack(track);
        this.autoRemoteTextTracks_.removeTrack(track);
    }
    /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   *
   * @abstract
   */ getVideoPlaybackQuality() {
        return {};
    }
    /**
   * Attempt to create a floating video window always on top of other windows
   * so that users may continue consuming media while they interact with other
   * content sites, or applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise|undefined}
   *         A promise with a Picture-in-Picture window if the browser supports
   *         Promises (or one was passed in as an option). It returns undefined
   *         otherwise.
   *
   * @abstract
   */ requestPictureInPicture() {
        return Promise.reject();
    }
    /**
   * A method to check for the value of the 'disablePictureInPicture' <video> property.
   * Defaults to true, as it should be considered disabled if the tech does not support pip
   *
   * @abstract
   */ disablePictureInPicture() {
        return true;
    }
    /**
   * A method to set or unset the 'disablePictureInPicture' <video> property.
   *
   * @abstract
   */ setDisablePictureInPicture() {}
    /**
   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
   *
   * @param {function} cb
   * @return {number} request id
   */ requestVideoFrameCallback(cb) {
        const id = $cb03b711053a4297$var$newGUID();
        if (!this.isReady_ || this.paused()) {
            this.queuedHanders_.add(id);
            this.one('playing', ()=>{
                if (this.queuedHanders_.has(id)) {
                    this.queuedHanders_.delete(id);
                    cb();
                }
            });
        } else this.requestNamedAnimationFrame(id, cb);
        return id;
    }
    /**
   * A fallback implementation of cancelVideoFrameCallback
   *
   * @param {number} id id of callback to be cancelled
   */ cancelVideoFrameCallback(id) {
        if (this.queuedHanders_.has(id)) this.queuedHanders_.delete(id);
        else this.cancelNamedAnimationFrame(id);
    }
    /**
   * A method to set a poster from a `Tech`.
   *
   * @abstract
   */ setPoster() {}
    /**
   * A method to check for the presence of the 'playsinline' <video> attribute.
   *
   * @abstract
   */ playsinline() {}
    /**
   * A method to set or unset the 'playsinline' <video> attribute.
   *
   * @abstract
   */ setPlaysinline() {}
    /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   *
   * @abstract
   */ overrideNativeAudioTracks(override) {}
    /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   *
   * @abstract
   */ overrideNativeVideoTracks(override) {}
    /**
   * Check if the tech can support the given mime-type.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param  {string} _type
   *         The mimetype to check for support
   *
   * @return {string}
   *         'probably', 'maybe', or empty string
   *
   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   *
   * @abstract
   */ canPlayType(_type) {
        return '';
    }
    /**
   * Check if the type is supported by this tech.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param {string} _type
   *        The media type to check
   * @return {string} Returns the native video element's response
   */ static canPlayType(_type) {
        return '';
    }
    /**
   * Check if the tech can support the given source
   *
   * @param {Object} srcObj
   *        The source object
   * @param {Object} options
   *        The options passed to the tech
   * @return {string} 'probably', 'maybe', or '' (empty string)
   */ static canPlaySource(srcObj, options) {
        return $cb03b711053a4297$var$Tech.canPlayType(srcObj.type);
    }
    /*
   * Return whether the argument is a Tech or not.
   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
   *
   * @param {Object} component
   *        The item to check
   *
   * @return {boolean}
   *         Whether it is a tech or not
   *         - True if it is a tech
   *         - False if it is not
   */ static isTech(component) {
        return component.prototype instanceof $cb03b711053a4297$var$Tech || component instanceof $cb03b711053a4297$var$Tech || component === $cb03b711053a4297$var$Tech;
    }
    /**
   * Registers a `Tech` into a shared list for videojs.
   *
   * @param {string} name
   *        Name of the `Tech` to register.
   *
   * @param {Object} tech
   *        The `Tech` class to register.
   */ static registerTech(name, tech) {
        if (!$cb03b711053a4297$var$Tech.techs_) $cb03b711053a4297$var$Tech.techs_ = {};
        if (!$cb03b711053a4297$var$Tech.isTech(tech)) throw new Error(`Tech ${name} must be a Tech`);
        if (!$cb03b711053a4297$var$Tech.canPlayType) throw new Error('Techs must have a static canPlayType method on them');
        if (!$cb03b711053a4297$var$Tech.canPlaySource) throw new Error('Techs must have a static canPlaySource method on them');
        name = $cb03b711053a4297$var$toTitleCase$1(name);
        $cb03b711053a4297$var$Tech.techs_[name] = tech;
        $cb03b711053a4297$var$Tech.techs_[$cb03b711053a4297$var$toLowerCase(name)] = tech;
        if (name !== 'Tech') // camel case the techName for use in techOrder
        $cb03b711053a4297$var$Tech.defaultTechOrder_.push(name);
        return tech;
    }
    /**
   * Get a `Tech` from the shared list by name.
   *
   * @param {string} name
   *        `camelCase` or `TitleCase` name of the Tech to get
   *
   * @return {Tech|undefined}
   *         The `Tech` or undefined if there was no tech with the name requested.
   */ static getTech(name) {
        if (!name) return;
        if ($cb03b711053a4297$var$Tech.techs_ && $cb03b711053a4297$var$Tech.techs_[name]) return $cb03b711053a4297$var$Tech.techs_[name];
        name = $cb03b711053a4297$var$toTitleCase$1(name);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))) && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).videojs && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).videojs[name]) {
            $cb03b711053a4297$var$log$1.warn(`The ${name} tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)`);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).videojs[name];
        }
    }
}
/**
 * Get the {@link VideoTrackList}
 *
 * @returns {VideoTrackList}
 * @method Tech.prototype.videoTracks
 */ /**
 * Get the {@link AudioTrackList}
 *
 * @returns {AudioTrackList}
 * @method Tech.prototype.audioTracks
 */ /**
 * Get the {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.textTracks
 */ /**
 * Get the remote element {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.remoteTextTracks
 */ /**
 * Get the remote element {@link HtmlTrackElementList}
 *
 * @returns {HtmlTrackElementList}
 * @method Tech.prototype.remoteTextTrackEls
 */ $cb03b711053a4297$var$ALL.names.forEach(function(name) {
    const props = $cb03b711053a4297$var$ALL[name];
    $cb03b711053a4297$var$Tech.prototype[props.getterName] = function() {
        this[props.privateName] = this[props.privateName] || new props.ListClass();
        return this[props.privateName];
    };
});
/**
 * List of associated text tracks
 *
 * @type {TextTrackList}
 * @private
 * @property Tech#textTracks_
 */ /**
 * List of associated audio tracks.
 *
 * @type {AudioTrackList}
 * @private
 * @property Tech#audioTracks_
 */ /**
 * List of associated video tracks.
 *
 * @type {VideoTrackList}
 * @private
 * @property Tech#videoTracks_
 */ /**
 * Boolean indicating whether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresVolumeControl = true;
/**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresMuteControl = true;
/**
 * Boolean indicating whether the `Tech` supports fullscreen resize control.
 * Resizing plugins using request fullscreen reloads the plugin
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresFullscreenResize = false;
/**
 * Boolean indicating whether the `Tech` supports changing the speed at which the video
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresPlaybackRate = false;
/**
 * Boolean indicating whether the `Tech` supports the `progress` event.
 * This will be used to determine if {@link Tech#manualProgressOn} should be called.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresProgressEvents = false;
/**
 * Boolean indicating whether the `Tech` supports the `sourceset` event.
 *
 * A tech should set this to `true` and then use {@link Tech#triggerSourceset}
 * to trigger a {@link Tech#event:sourceset} at the earliest time after getting
 * a new source.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresSourceset = false;
/**
 * Boolean indicating whether the `Tech` supports the `timeupdate` event.
 * This will be used to determine if {@link Tech#manualTimeUpdates} should be called.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresTimeupdateEvents = false;
/**
 * Boolean indicating whether the `Tech` supports the native `TextTrack`s.
 * This will help us integrate with native `TextTrack`s if the browser supports them.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresNativeTextTracks = false;
/**
 * Boolean indicating whether the `Tech` supports `requestVideoFrameCallback`.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresVideoFrameCallback = false;
/**
 * A functional mixin for techs that want to use the Source Handler pattern.
 * Source handlers are scripts for handling specific formats.
 * The source handler pattern is used for adaptive formats (HLS, DASH) that
 * manually load video data and feed it into a Source Buffer (Media Source Extensions)
 * Example: `Tech.withSourceHandlers.call(MyTech);`
 *
 * @param {Tech} _Tech
 *        The tech to add source handler functions to.
 *
 * @mixes Tech~SourceHandlerAdditions
 */ $cb03b711053a4297$var$Tech.withSourceHandlers = function(_Tech) {
    /**
   * Register a source handler
   *
   * @param {Function} handler
   *        The source handler class
   *
   * @param {number} [index]
   *        Register it at the following index
   */ _Tech.registerSourceHandler = function(handler, index) {
        let handlers = _Tech.sourceHandlers;
        if (!handlers) handlers = _Tech.sourceHandlers = [];
        if (index === undefined) // add to the end of the list
        index = handlers.length;
        handlers.splice(index, 0, handler);
    };
    /**
   * Check if the tech can support the given type. Also checks the
   * Techs sourceHandlers.
   *
   * @param {string} type
   *         The mimetype to check.
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */ _Tech.canPlayType = function(type) {
        const handlers = _Tech.sourceHandlers || [];
        let can;
        for(let i = 0; i < handlers.length; i++){
            can = handlers[i].canPlayType(type);
            if (can) return can;
        }
        return '';
    };
    /**
   * Returns the first source handler that supports the source.
   *
   * TODO: Answer question: should 'probably' be prioritized over 'maybe'
   *
   * @param {SourceObject} source
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {SourceHandler|null}
   *          The first source handler that supports the source or null if
   *          no SourceHandler supports the source
   */ _Tech.selectSourceHandler = function(source, options) {
        const handlers = _Tech.sourceHandlers || [];
        let can;
        for(let i = 0; i < handlers.length; i++){
            can = handlers[i].canHandleSource(source, options);
            if (can) return handlers[i];
        }
        return null;
    };
    /**
   * Check if the tech can support the given source.
   *
   * @param {SourceObject} srcObj
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */ _Tech.canPlaySource = function(srcObj, options) {
        const sh = _Tech.selectSourceHandler(srcObj, options);
        if (sh) return sh.canHandleSource(srcObj, options);
        return '';
    };
    /**
   * When using a source handler, prefer its implementation of
   * any function normally provided by the tech.
   */ const deferrable = [
        'seekable',
        'seeking',
        'duration'
    ];
    /**
   * A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
   * function if it exists, with a fallback to the Techs seekable function.
   *
   * @method _Tech.seekable
   */ /**
   * A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
   * function if it exists, otherwise it will fallback to the techs duration function.
   *
   * @method _Tech.duration
   */ deferrable.forEach(function(fnName) {
        const originalFn = this[fnName];
        if (typeof originalFn !== 'function') return;
        this[fnName] = function() {
            if (this.sourceHandler_ && this.sourceHandler_[fnName]) return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
            return originalFn.apply(this, arguments);
        };
    }, _Tech.prototype);
    /**
   * Create a function for setting the source using a source object
   * and source handlers.
   * Should never be called unless a source handler was found.
   *
   * @param {SourceObject} source
   *        A source object with src and type keys
   */ _Tech.prototype.setSource = function(source) {
        let sh = _Tech.selectSourceHandler(source, this.options_);
        if (!sh) {
            // Fall back to a native source handler when unsupported sources are
            // deliberately set
            if (_Tech.nativeSourceHandler) sh = _Tech.nativeSourceHandler;
            else $cb03b711053a4297$var$log$1.error('No source handler found for the current source.');
        }
        // Dispose any existing source handler
        this.disposeSourceHandler();
        this.off('dispose', this.disposeSourceHandler_);
        if (sh !== _Tech.nativeSourceHandler) this.currentSource_ = source;
        this.sourceHandler_ = sh.handleSource(source, this, this.options_);
        this.one('dispose', this.disposeSourceHandler_);
    };
    /**
   * Clean up any existing SourceHandlers and listeners when the Tech is disposed.
   *
   * @listens Tech#dispose
   */ _Tech.prototype.disposeSourceHandler = function() {
        // if we have a source and get another one
        // then we are loading something new
        // than clear all of our current tracks
        if (this.currentSource_) {
            this.clearTracks([
                'audio',
                'video'
            ]);
            this.currentSource_ = null;
        }
        // always clean up auto-text tracks
        this.cleanupAutoTextTracks();
        if (this.sourceHandler_) {
            if (this.sourceHandler_.dispose) this.sourceHandler_.dispose();
            this.sourceHandler_ = null;
        }
    };
};
// The base Tech class needs to be registered as a Component. It is the only
// Tech that can be registered as a Component.
$cb03b711053a4297$var$Component$1.registerComponent('Tech', $cb03b711053a4297$var$Tech);
$cb03b711053a4297$var$Tech.registerTech('Tech', $cb03b711053a4297$var$Tech);
/**
 * A list of techs that should be added to techOrder on Players
 *
 * @private
 */ $cb03b711053a4297$var$Tech.defaultTechOrder_ = [];
/**
 * @file middleware.js
 * @module middleware
 */ /** @import Player from '../player' */ /** @import Tech from '../tech/tech' */ const $cb03b711053a4297$var$middlewares = {};
const $cb03b711053a4297$var$middlewareInstances = {};
const $cb03b711053a4297$var$TERMINATOR = {};
/**
 * A middleware object is a plain JavaScript object that has methods that
 * match the {@link Tech} methods found in the lists of allowed
 * {@link module:middleware.allowedGetters|getters},
 * {@link module:middleware.allowedSetters|setters}, and
 * {@link module:middleware.allowedMediators|mediators}.
 *
 * @typedef {Object} MiddlewareObject
 */ /**
 * A middleware factory function that should return a
 * {@link module:middleware~MiddlewareObject|MiddlewareObject}.
 *
 * This factory will be called for each player when needed, with the player
 * passed in as an argument.
 *
 * @callback MiddlewareFactory
 * @param {Player} player
 *        A Video.js player.
 */ /**
 * Define a middleware that the player should use by way of a factory function
 * that returns a middleware object.
 *
 * @param  {string} type
 *         The MIME type to match or `"*"` for all MIME types.
 *
 * @param  {MiddlewareFactory} middleware
 *         A middleware factory function that will be executed for
 *         matching types.
 */ function $cb03b711053a4297$var$use(type, middleware) {
    $cb03b711053a4297$var$middlewares[type] = $cb03b711053a4297$var$middlewares[type] || [];
    $cb03b711053a4297$var$middlewares[type].push(middleware);
}
/**
 * Asynchronously sets a source using middleware by recursing through any
 * matching middlewares and calling `setSource` on each, passing along the
 * previous returned value each time.
 *
 * @param  {Player} player
 *         A {@link Player} instance.
 *
 * @param  {Tech~SourceObject} src
 *         A source object.
 *
 * @param  {Function}
 *         The next middleware to run.
 */ function $cb03b711053a4297$var$setSource(player, src, next) {
    player.setTimeout(()=>$cb03b711053a4297$var$setSourceHelper(src, $cb03b711053a4297$var$middlewares[src.type], next, player), 1);
}
/**
 * When the tech is set, passes the tech to each middleware's `setTech` method.
 *
 * @param {Object[]} middleware
 *        An array of middleware instances.
 *
 * @param {Tech} tech
 *        A Video.js tech.
 */ function $cb03b711053a4297$var$setTech(middleware, tech) {
    middleware.forEach((mw)=>mw.setTech && mw.setTech(tech));
}
/**
 * Calls a getter on the tech first, through each middleware
 * from right to left to the player.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @return {*}
 *         The final value from the tech after middleware has intercepted it.
 */ function $cb03b711053a4297$var$get(middleware, tech, method) {
    return middleware.reduceRight($cb03b711053a4297$var$middlewareIterator(method), tech[method]());
}
/**
 * Takes the argument given to the player and calls the setter method on each
 * middleware from left to right to the tech.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @param  {*} arg
 *         The value to set on the tech.
 *
 * @return {*}
 *         The return value of the `method` of the `tech`.
 */ function $cb03b711053a4297$var$set(middleware, tech, method, arg) {
    return tech[method](middleware.reduce($cb03b711053a4297$var$middlewareIterator(method), arg));
}
/**
 * Takes the argument given to the player and calls the `call` version of the
 * method on each middleware from left to right.
 *
 * Then, call the passed in method on the tech and return the result unchanged
 * back to the player, through middleware, this time from right to left.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @param  {*} arg
 *         The value to set on the tech.
 *
 * @return {*}
 *         The return value of the `method` of the `tech`, regardless of the
 *         return values of middlewares.
 */ function $cb03b711053a4297$var$mediate(middleware, tech, method, arg = null) {
    const callMethod = 'call' + $cb03b711053a4297$var$toTitleCase$1(method);
    const middlewareValue = middleware.reduce($cb03b711053a4297$var$middlewareIterator(callMethod), arg);
    const terminated = middlewareValue === $cb03b711053a4297$var$TERMINATOR;
    // deprecated. The `null` return value should instead return TERMINATOR to
    // prevent confusion if a techs method actually returns null.
    const returnValue = terminated ? null : tech[method](middlewareValue);
    $cb03b711053a4297$var$executeRight(middleware, method, returnValue, terminated);
    return returnValue;
}
/**
 * Enumeration of allowed getters where the keys are method names.
 *
 * @type {Object}
 */ const $cb03b711053a4297$var$allowedGetters = {
    buffered: 1,
    currentTime: 1,
    duration: 1,
    muted: 1,
    played: 1,
    paused: 1,
    seekable: 1,
    volume: 1,
    ended: 1
};
/**
 * Enumeration of allowed setters where the keys are method names.
 *
 * @type {Object}
 */ const $cb03b711053a4297$var$allowedSetters = {
    setCurrentTime: 1,
    setMuted: 1,
    setVolume: 1
};
/**
 * Enumeration of allowed mediators where the keys are method names.
 *
 * @type {Object}
 */ const $cb03b711053a4297$var$allowedMediators = {
    play: 1,
    pause: 1
};
function $cb03b711053a4297$var$middlewareIterator(method) {
    return (value, mw)=>{
        // if the previous middleware terminated, pass along the termination
        if (value === $cb03b711053a4297$var$TERMINATOR) return $cb03b711053a4297$var$TERMINATOR;
        if (mw[method]) return mw[method](value);
        return value;
    };
}
function $cb03b711053a4297$var$executeRight(mws, method, value, terminated) {
    for(let i = mws.length - 1; i >= 0; i--){
        const mw = mws[i];
        if (mw[method]) mw[method](terminated, value);
    }
}
/**
 * Clear the middleware cache for a player.
 *
 * @param  {Player} player
 *         A {@link Player} instance.
 */ function $cb03b711053a4297$var$clearCacheForPlayer(player) {
    if ($cb03b711053a4297$var$middlewareInstances.hasOwnProperty(player.id())) delete $cb03b711053a4297$var$middlewareInstances[player.id()];
}
/**
 * {
 *  [playerId]: [[mwFactory, mwInstance], ...]
 * }
 *
 * @private
 */ function $cb03b711053a4297$var$getOrCreateFactory(player, mwFactory) {
    const mws = $cb03b711053a4297$var$middlewareInstances[player.id()];
    let mw = null;
    if (mws === undefined || mws === null) {
        mw = mwFactory(player);
        $cb03b711053a4297$var$middlewareInstances[player.id()] = [
            [
                mwFactory,
                mw
            ]
        ];
        return mw;
    }
    for(let i = 0; i < mws.length; i++){
        const [mwf, mwi] = mws[i];
        if (mwf !== mwFactory) continue;
        mw = mwi;
    }
    if (mw === null) {
        mw = mwFactory(player);
        mws.push([
            mwFactory,
            mw
        ]);
    }
    return mw;
}
function $cb03b711053a4297$var$setSourceHelper(src = {}, middleware = [], next, player, acc = [], lastRun = false) {
    const [mwFactory, ...mwrest] = middleware;
    // if mwFactory is a string, then we're at a fork in the road
    if (typeof mwFactory === 'string') $cb03b711053a4297$var$setSourceHelper(src, $cb03b711053a4297$var$middlewares[mwFactory], next, player, acc, lastRun);
    else if (mwFactory) {
        const mw = $cb03b711053a4297$var$getOrCreateFactory(player, mwFactory);
        // if setSource isn't present, implicitly select this middleware
        if (!mw.setSource) {
            acc.push(mw);
            return $cb03b711053a4297$var$setSourceHelper(src, mwrest, next, player, acc, lastRun);
        }
        mw.setSource(Object.assign({}, src), function(err, _src) {
            // something happened, try the next middleware on the current level
            // make sure to use the old src
            if (err) return $cb03b711053a4297$var$setSourceHelper(src, mwrest, next, player, acc, lastRun);
            // we've succeeded, now we need to go deeper
            acc.push(mw);
            // if it's the same type, continue down the current chain
            // otherwise, we want to go down the new chain
            $cb03b711053a4297$var$setSourceHelper(_src, src.type === _src.type ? mwrest : $cb03b711053a4297$var$middlewares[_src.type], next, player, acc, lastRun);
        });
    } else if (mwrest.length) $cb03b711053a4297$var$setSourceHelper(src, mwrest, next, player, acc, lastRun);
    else if (lastRun) next(src, acc);
    else $cb03b711053a4297$var$setSourceHelper(src, $cb03b711053a4297$var$middlewares['*'], next, player, acc, true);
}
/** @import Player from '../player' */ /**
 * Mimetypes
 *
 * @see https://www.iana.org/assignments/media-types/media-types.xhtml
 * @typedef Mimetypes~Kind
 * @enum
 */ const $cb03b711053a4297$var$MimetypesKind = {
    opus: 'video/ogg',
    ogv: 'video/ogg',
    mp4: 'video/mp4',
    mov: 'video/mp4',
    m4v: 'video/mp4',
    mkv: 'video/x-matroska',
    m4a: 'audio/mp4',
    mp3: 'audio/mpeg',
    aac: 'audio/aac',
    caf: 'audio/x-caf',
    flac: 'audio/flac',
    oga: 'audio/ogg',
    wav: 'audio/wav',
    m3u8: 'application/x-mpegURL',
    mpd: 'application/dash+xml',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    png: 'image/png',
    svg: 'image/svg+xml',
    webp: 'image/webp'
};
/**
 * Get the mimetype of a given src url if possible
 *
 * @param {string} src
 *        The url to the src
 *
 * @return {string}
 *         return the mimetype if it was known or empty string otherwise
 */ const $cb03b711053a4297$var$getMimetype = function(src = '') {
    const ext = $cb03b711053a4297$var$getFileExtension(src);
    const mimetype = $cb03b711053a4297$var$MimetypesKind[ext.toLowerCase()];
    return mimetype || '';
};
/**
 * Find the mime type of a given source string if possible. Uses the player
 * source cache.
 *
 * @param {Player} player
 *        The player object
 *
 * @param {string} src
 *        The source string
 *
 * @return {string}
 *         The type that was found
 */ const $cb03b711053a4297$var$findMimetype = (player, src)=>{
    if (!src) return '';
    // 1. check for the type in the `source` cache
    if (player.cache_.source.src === src && player.cache_.source.type) return player.cache_.source.type;
    // 2. see if we have this source in our `currentSources` cache
    const matchingSources = player.cache_.sources.filter((s)=>s.src === src);
    if (matchingSources.length) return matchingSources[0].type;
    // 3. look for the src url in source elements and use the type there
    const sources = player.$$('source');
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        if (s.type && s.src && s.src === src) return s.type;
    }
    // 4. finally fallback to our list of mime types based on src url extension
    return $cb03b711053a4297$var$getMimetype(src);
};
/**
 * @module filter-source
 */ /**
 * Filter out single bad source objects or multiple source objects in an
 * array. Also flattens nested source object arrays into a 1 dimensional
 * array of source objects.
 *
 * @param {Tech~SourceObject|Tech~SourceObject[]} src
 *        The src object to filter
 *
 * @return {Tech~SourceObject[]}
 *         An array of sourceobjects containing only valid sources
 *
 * @private
 */ const $cb03b711053a4297$var$filterSource = function(src) {
    // traverse array
    if (Array.isArray(src)) {
        let newsrc = [];
        src.forEach(function(srcobj) {
            srcobj = $cb03b711053a4297$var$filterSource(srcobj);
            if (Array.isArray(srcobj)) newsrc = newsrc.concat(srcobj);
            else if ($cb03b711053a4297$var$isObject(srcobj)) newsrc.push(srcobj);
        });
        src = newsrc;
    } else if (typeof src === 'string' && src.trim()) // convert string into object
    src = [
        $cb03b711053a4297$var$fixSource({
            src: src
        })
    ];
    else if ($cb03b711053a4297$var$isObject(src) && typeof src.src === 'string' && src.src && src.src.trim()) // src is already valid
    src = [
        $cb03b711053a4297$var$fixSource(src)
    ];
    else // invalid source, turn it into an empty array
    src = [];
    return src;
};
/**
 * Checks src mimetype, adding it when possible
 *
 * @param {Tech~SourceObject} src
 *        The src object to check
 * @return {Tech~SourceObject}
 *        src Object with known type
 */ function $cb03b711053a4297$var$fixSource(src) {
    if (!src.type) {
        const mimetype = $cb03b711053a4297$var$getMimetype(src.src);
        if (mimetype) src.type = mimetype;
    }
    return src;
}
var $cb03b711053a4297$var$icons = "<svg xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-play\">\n      <path d=\"M16 10v28l22-14z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-pause\">\n      <path d=\"M12 38h8V10h-8v28zm16-28v28h8V10h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-audio\">\n      <path d=\"M24 2C14.06 2 6 10.06 6 20v14c0 3.31 2.69 6 6 6h6V24h-8v-4c0-7.73 6.27-14 14-14s14 6.27 14 14v4h-8v16h6c3.31 0 6-2.69 6-6V20c0-9.94-8.06-18-18-18z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-captions\">\n      <path d=\"M38 8H10c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM22 22h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm14 0h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-subtitles\">\n      <path d=\"M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-fullscreen-enter\">\n      <path d=\"M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-fullscreen-exit\">\n      <path d=\"M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-play-circle\">\n      <path d=\"M20 33l12-9-12-9v18zm4-29C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-mute\">\n      <path d=\"M33 24c0-3.53-2.04-6.58-5-8.05v4.42l4.91 4.91c.06-.42.09-.85.09-1.28zm5 0c0 1.88-.41 3.65-1.08 5.28l3.03 3.03C41.25 29.82 42 27 42 24c0-8.56-5.99-15.72-14-17.54v4.13c5.78 1.72 10 7.07 10 13.41zM8.55 6L6 8.55 15.45 18H6v12h8l10 10V26.55l8.51 8.51c-1.34 1.03-2.85 1.86-4.51 2.36v4.13a17.94 17.94 0 0 0 7.37-3.62L39.45 42 42 39.45l-18-18L8.55 6zM24 8l-4.18 4.18L24 16.36V8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-low\">\n      <path d=\"M14 18v12h8l10 10V8L22 18h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-medium\">\n      <path d=\"M37 24c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zm-27-6v12h8l10 10V8L18 18h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-high\">\n      <path d=\"M6 18v12h8l10 10V8L14 18H6zm27 6c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zM28 6.46v4.13c5.78 1.72 10 7.07 10 13.41s-4.22 11.69-10 13.41v4.13c8.01-1.82 14-8.97 14-17.54S36.01 8.28 28 6.46z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-spinner\">\n      <path d=\"M18.8 21l9.53-16.51C26.94 4.18 25.49 4 24 4c-4.8 0-9.19 1.69-12.64 4.51l7.33 12.69.11-.2zm24.28-3c-1.84-5.85-6.3-10.52-11.99-12.68L23.77 18h19.31zm.52 2H28.62l.58 1 9.53 16.5C41.99 33.94 44 29.21 44 24c0-1.37-.14-2.71-.4-4zm-26.53 4l-7.8-13.5C6.01 14.06 4 18.79 4 24c0 1.37.14 2.71.4 4h14.98l-2.31-4zM4.92 30c1.84 5.85 6.3 10.52 11.99 12.68L24.23 30H4.92zm22.54 0l-7.8 13.51c1.4.31 2.85.49 4.34.49 4.8 0 9.19-1.69 12.64-4.51L29.31 26.8 27.46 30z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 24 24\" id=\"vjs-icon-hd\">\n      <path d=\"M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-chapters\">\n      <path d=\"M6 26h4v-4H6v4zm0 8h4v-4H6v4zm0-16h4v-4H6v4zm8 8h28v-4H14v4zm0 8h28v-4H14v4zm0-20v4h28v-4H14z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 40 40\" id=\"vjs-icon-downloading\">\n      <path d=\"M18.208 36.875q-3.208-.292-5.979-1.729-2.771-1.438-4.812-3.729-2.042-2.292-3.188-5.229-1.146-2.938-1.146-6.23 0-6.583 4.334-11.416 4.333-4.834 10.833-5.5v3.166q-5.167.75-8.583 4.646Q6.25 14.75 6.25 19.958q0 5.209 3.396 9.104 3.396 3.896 8.562 4.646zM20 28.417L11.542 20l2.083-2.083 4.917 4.916v-11.25h2.916v11.25l4.875-4.916L28.417 20zm1.792 8.458v-3.167q1.833-.25 3.541-.958 1.709-.708 3.167-1.875l2.333 2.292q-1.958 1.583-4.25 2.541-2.291.959-4.791 1.167zm6.791-27.792q-1.541-1.125-3.25-1.854-1.708-.729-3.541-1.021V3.042q2.5.25 4.77 1.208 2.271.958 4.271 2.5zm4.584 21.584l-2.25-2.25q1.166-1.5 1.854-3.209.687-1.708.937-3.541h3.209q-.292 2.5-1.229 4.791-.938 2.292-2.521 4.209zm.541-12.417q-.291-1.833-.958-3.562-.667-1.73-1.833-3.188l2.375-2.208q1.541 1.916 2.458 4.208.917 2.292 1.167 4.75z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download\">\n      <path d=\"M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1zM24 32.1L13.9 22.05l2.45-2.45 5.95 5.95V7.15h3.4v18.4l5.95-5.95 2.45 2.45z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download-done\">\n      <path d=\"M9.8 40.5v-3.45h28.4v3.45zm9.2-9.05L7.4 19.85l2.45-2.35L19 26.65l19.2-19.2 2.4 2.4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download-off\">\n      <path d=\"M4.9 4.75L43.25 43.1 41 45.3l-4.75-4.75q-.05.05-.075.025-.025-.025-.075-.025H10.8q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h22.05l-7-7-1.85 1.8L13.9 21.9l1.85-1.85L2.7 7zm26.75 14.7l2.45 2.45-3.75 3.8-2.45-2.5zM25.7 7.15V21.1l-3.4-3.45V7.15z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-share\">\n      <path d=\"M36 32.17c-1.52 0-2.89.59-3.93 1.54L17.82 25.4c.11-.45.18-.92.18-1.4s-.07-.95-.18-1.4l14.1-8.23c1.07 1 2.5 1.62 4.08 1.62 3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6c0 .48.07.95.18 1.4l-14.1 8.23c-1.07-1-2.5-1.62-4.08-1.62-3.31 0-6 2.69-6 6s2.69 6 6 6c1.58 0 3.01-.62 4.08-1.62l14.25 8.31c-.1.42-.16.86-.16 1.31A5.83 5.83 0 1 0 36 32.17z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cog\">\n      <path d=\"M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97L29 4.84c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3a14.8 14.8 0 0 0-3.38 1.97L9.9 10.1a1 1 0 0 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31C9.06 22.69 9 23.34 9 24s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3a14.8 14.8 0 0 0 3.38-1.97l4.98 2.01a1 1 0 0 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zM24 31c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-square\">\n      <path d=\"M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle\">\n      <circle cx=\"24\" cy=\"24\" r=\"20\"></circle>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle-outline\">\n      <path d=\"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle-inner-circle\">\n      <path d=\"M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm6-16c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cancel\">\n      <path d=\"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-replay\">\n      <path d=\"M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-repeat\">\n      <path d=\"M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-5\">\n      <path d=\"M17.689 98l-8.697 8.696 8.697 8.697 2.486-2.485-4.32-4.319h1.302c4.93 0 9.071 1.722 12.424 5.165 3.352 3.443 5.029 7.638 5.029 12.584h3.55c0-2.958-.553-5.73-1.658-8.313-1.104-2.583-2.622-4.841-4.555-6.774-1.932-1.932-4.19-3.45-6.773-4.555-2.584-1.104-5.355-1.657-8.313-1.657H15.5l4.615-4.615zm-8.08 21.659v13.861h11.357v5.008H9.609V143h12.7c.834 0 1.55-.298 2.146-.894.596-.597.895-1.31.895-2.145v-7.781c0-.835-.299-1.55-.895-2.147a2.929 2.929 0 0 0-2.147-.894h-8.227v-5.096H25.35v-4.384z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-10\">\n      <path d=\"M42.315 125.63c0-4.997-1.694-9.235-5.08-12.713-3.388-3.479-7.571-5.218-12.552-5.218h-1.315l4.363 4.363-2.51 2.51-8.787-8.786L25.221 97l2.45 2.45-4.662 4.663h1.375c2.988 0 5.788.557 8.397 1.673 2.61 1.116 4.892 2.65 6.844 4.602 1.953 1.953 3.487 4.234 4.602 6.844 1.116 2.61 1.674 5.41 1.674 8.398zM8.183 142v-19.657H3.176V117.8h9.643V142zm13.63 0c-1.156 0-2.127-.393-2.912-1.178-.778-.778-1.168-1.746-1.168-2.902v-16.04c0-1.156.393-2.127 1.178-2.912.779-.779 1.746-1.168 2.902-1.168h7.696c1.156 0 2.126.392 2.911 1.177.779.78 1.168 1.747 1.168 2.903v16.04c0 1.156-.392 2.127-1.177 2.912-.779.779-1.746 1.168-2.902 1.168zm.556-4.636h6.583v-15.02H22.37z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-30\">\n      <path d=\"M26.047 97l-8.733 8.732 8.733 8.733 2.496-2.494-4.336-4.338h1.307c4.95 0 9.108 1.73 12.474 5.187 3.367 3.458 5.051 7.668 5.051 12.635h3.565c0-2.97-.556-5.751-1.665-8.346-1.109-2.594-2.633-4.862-4.574-6.802-1.94-1.941-4.208-3.466-6.803-4.575-2.594-1.109-5.375-1.664-8.345-1.664H23.85l4.634-4.634zM2.555 117.531v4.688h10.297v5.25H5.873v4.687h6.979v5.156H2.555V142H13.36c1.061 0 1.95-.395 2.668-1.186.718-.79 1.076-1.772 1.076-2.94v-16.218c0-1.168-.358-2.149-1.076-2.94-.717-.79-1.607-1.185-2.668-1.185zm22.482.14c-1.149 0-2.11.39-2.885 1.165-.78.78-1.172 1.744-1.172 2.893v15.943c0 1.149.388 2.11 1.163 2.885.78.78 1.745 1.172 2.894 1.172h7.649c1.148 0 2.11-.388 2.884-1.163.78-.78 1.17-1.745 1.17-2.894v-15.943c0-1.15-.386-2.111-1.16-2.885-.78-.78-1.746-1.172-2.894-1.172zm.553 4.518h6.545v14.93H25.59z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-5\">\n      <path d=\"M29.508 97l-2.431 2.43 4.625 4.625h-1.364c-2.965 0-5.742.554-8.332 1.66-2.589 1.107-4.851 2.629-6.788 4.566-1.937 1.937-3.458 4.2-4.565 6.788-1.107 2.59-1.66 5.367-1.66 8.331h3.557c0-4.957 1.68-9.16 5.04-12.611 3.36-3.45 7.51-5.177 12.451-5.177h1.304l-4.326 4.33 2.49 2.49 8.715-8.716zm-9.783 21.61v13.89h11.382v5.018H19.725V142h12.727a2.93 2.93 0 0 0 2.15-.896 2.93 2.93 0 0 0 .896-2.15v-7.798c0-.837-.299-1.554-.896-2.152a2.93 2.93 0 0 0-2.15-.896h-8.245V123h11.29v-4.392z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-10\">\n      <path d=\"M23.119 97l-2.386 2.383 4.538 4.538h-1.339c-2.908 0-5.633.543-8.173 1.63-2.54 1.085-4.76 2.577-6.66 4.478-1.9 1.9-3.392 4.12-4.478 6.66-1.085 2.54-1.629 5.264-1.629 8.172h3.49c0-4.863 1.648-8.986 4.944-12.372 3.297-3.385 7.368-5.078 12.216-5.078h1.279l-4.245 4.247 2.443 2.442 8.55-8.55zm-9.52 21.45v4.42h4.871V142h4.513v-23.55zm18.136 0c-1.125 0-2.066.377-2.824 1.135-.764.764-1.148 1.709-1.148 2.834v15.612c0 1.124.38 2.066 1.139 2.824.764.764 1.708 1.145 2.833 1.145h7.489c1.125 0 2.066-.378 2.824-1.136.764-.764 1.145-1.709 1.145-2.833v-15.612c0-1.125-.378-2.067-1.136-2.825-.764-.764-1.708-1.145-2.833-1.145zm.54 4.42h6.408v14.617h-6.407z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-30\">\n      <path d=\"M25.549 97l-2.437 2.434 4.634 4.635H26.38c-2.97 0-5.753.555-8.347 1.664-2.594 1.109-4.861 2.633-6.802 4.574-1.94 1.94-3.465 4.207-4.574 6.802-1.109 2.594-1.664 5.377-1.664 8.347h3.565c0-4.967 1.683-9.178 5.05-12.636 3.366-3.458 7.525-5.187 12.475-5.187h1.307l-4.335 4.338 2.495 2.494 8.732-8.732zm-11.553 20.53v4.689h10.297v5.249h-6.978v4.688h6.978v5.156H13.996V142h10.808c1.06 0 1.948-.395 2.666-1.186.718-.79 1.077-1.771 1.077-2.94v-16.217c0-1.169-.36-2.15-1.077-2.94-.718-.79-1.605-1.186-2.666-1.186zm21.174.168c-1.149 0-2.11.389-2.884 1.163-.78.78-1.172 1.745-1.172 2.894v15.942c0 1.15.388 2.11 1.162 2.885.78.78 1.745 1.17 2.894 1.17h7.649c1.149 0 2.11-.386 2.885-1.16.78-.78 1.17-1.746 1.17-2.895v-15.942c0-1.15-.387-2.11-1.161-2.885-.78-.78-1.745-1.172-2.894-1.172zm.552 4.516h6.542v14.931h-6.542z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 512 512\" id=\"vjs-icon-audio-description\">\n      <g fill-rule=\"evenodd\"><path d=\"M227.29 381.351V162.993c50.38-1.017 89.108-3.028 117.631 17.126 27.374 19.342 48.734 56.965 44.89 105.325-4.067 51.155-41.335 94.139-89.776 98.475-24.085 2.155-71.972 0-71.972 0s-.84-1.352-.773-2.568m48.755-54.804c31.43 1.26 53.208-16.633 56.495-45.386 4.403-38.51-21.188-63.552-58.041-60.796v103.612c-.036 1.466.575 2.22 1.546 2.57\"></path><path d=\"M383.78 381.328c13.336 3.71 17.387-11.06 23.215-21.408 12.722-22.571 22.294-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.226 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894\"></path><path d=\"M425.154 381.328c13.336 3.71 17.384-11.061 23.215-21.408 12.721-22.571 22.291-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.511c-.586 3.874 2.226 7.315 3.866 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894\"></path><path d=\"M466.26 381.328c13.337 3.71 17.385-11.061 23.216-21.408 12.722-22.571 22.292-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.225 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894M4.477 383.005H72.58l18.573-28.484 64.169-.135s.065 19.413.065 28.62h48.756V160.307h-58.816c-5.653 9.537-140.85 222.697-140.85 222.697zm152.667-145.282v71.158l-40.453-.27 40.453-70.888z\"></path></g>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-next-item\">\n      <path d=\"M12 36l17-12-17-12v24zm20-24v24h4V12h-4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-previous-item\">\n      <path d=\"M12 12h4v24h-4zm7 12l17 12V12z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-shuffle\">\n      <path d=\"M21.17 18.34L10.83 8 8 10.83l10.34 10.34 2.83-2.83zM29 8l4.09 4.09L8 37.17 10.83 40l25.09-25.09L40 19V8H29zm.66 18.83l-2.83 2.83 6.26 6.26L29 40h11V29l-4.09 4.09-6.25-6.26z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cast\">\n      <path d=\"M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-picture-in-picture-enter\">\n      <path d=\"M38 22H22v11.99h16V22zm8 16V9.96C46 7.76 44.2 6 42 6H6C3.8 6 2 7.76 2 9.96V38c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4zm-4 .04H6V9.94h36v28.1z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 22 18\" id=\"vjs-icon-picture-in-picture-exit\">\n      <path d=\"M18 4H4v10h14V4zm4 12V1.98C22 .88 21.1 0 20 0H2C.9 0 0 .88 0 1.98V16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H2V1.97h18v14.05z\"></path>\n      <path fill=\"none\" d=\"M-1-3h24v24H-1z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-facebook\">\n      <path d=\"M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-linkedin\">\n      <path d=\"M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1200 1227\" id=\"vjs-icon-twitter\">\n      <path d=\"M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z\"/>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-tumblr\">\n      <path d=\"M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26T787 1564t-95-106-55.5-120-16.5-118V676H452V461q72-26 129-69.5t91-90 58-102 34-99T779 12q1-5 4.5-8.5T791 0h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-pinterest\">\n      <path d=\"M1664 896q0 209-103 385.5T1281.5 1561 896 1664q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214T1180 449t-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5T377 866q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5T904 517q151 0 235.5 82t84.5 213q0 170-68.5 289T980 1220q-61 0-98-43.5T859 1072q8-35 26.5-93.5t30-103T927 800q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281T128 896q0-209 103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z\"></path>\n    </symbol>\n  </defs>\n</svg>";
// /**
// Determine the keycode for the 'back' key based on the platform
const $cb03b711053a4297$var$backKeyCode = $cb03b711053a4297$var$IS_TIZEN ? 10009 : $cb03b711053a4297$var$IS_WEBOS ? 461 : 8;
const $cb03b711053a4297$var$SpatialNavKeyCodes = {
    codes: {
        play: 415,
        pause: 19,
        ff: 417,
        rw: 412,
        back: $cb03b711053a4297$var$backKeyCode
    },
    names: {
        415: 'play',
        19: 'pause',
        417: 'ff',
        412: 'rw',
        [$cb03b711053a4297$var$backKeyCode]: 'back'
    },
    isEventKey (event, keyName) {
        keyName = keyName.toLowerCase();
        if (this.names[event.keyCode] && this.names[event.keyCode] === keyName) return true;
        return false;
    },
    getEventName (event) {
        if (this.names[event.keyCode]) return this.names[event.keyCode];
        else if (this.codes[event.code]) {
            const code = this.codes[event.code];
            return this.names[code];
        }
        return null;
    }
};
/**
 * @file spatial-navigation.js
 */ /** @import Component from './component' */ /** @import Player from './player' */ // The number of seconds the `step*` functions move the timeline.
const $cb03b711053a4297$var$STEP_SECONDS = 5;
/**
 * Spatial Navigation in Video.js enhances user experience and accessibility on smartTV devices,
 * enabling seamless navigation through interactive elements within the player using remote control arrow keys.
 * This functionality allows users to effortlessly navigate through focusable components.
 *
 * @extends EventTarget
 */ class $cb03b711053a4297$var$SpatialNavigation extends $cb03b711053a4297$var$EventTarget$2 {
    /**
   * Constructs a SpatialNavigation instance with initial settings.
   * Sets up the player instance, and prepares the spatial navigation system.
   *
   * @class
   * @param {Player} player - The Video.js player instance to which the spatial navigation is attached.
   */ constructor(player){
        super();
        this.player_ = player;
        this.focusableComponents = [];
        this.isListening_ = false;
        this.isPaused_ = false;
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.lastFocusedComponent_ = null;
    }
    /**
   * Starts the spatial navigation by adding a keydown event listener to the video container.
   * This method ensures that the event listener is added only once.
   */ start() {
        // If the listener is already active, exit early.
        if (this.isListening_) return;
        // Add the event listener since the listener is not yet active.
        this.player_.on('keydown', this.onKeyDown_);
        this.player_.on('modalKeydown', this.onKeyDown_);
        // Listen for source change events
        this.player_.on('loadedmetadata', ()=>{
            this.focus(this.updateFocusableComponents()[0]);
        });
        this.player_.on('modalclose', ()=>{
            this.refocusComponent();
        });
        this.player_.on('focusin', this.handlePlayerFocus_.bind(this));
        this.player_.on('focusout', this.handlePlayerBlur_.bind(this));
        this.isListening_ = true;
        if (this.player_.errorDisplay) this.player_.errorDisplay.on('aftermodalfill', ()=>{
            this.updateFocusableComponents();
            if (this.focusableComponents.length) {
                // The modal has focusable components:
                if (this.focusableComponents.length > 1) // The modal has close button + some additional buttons.
                // Focusing first additional button:
                this.focusableComponents[1].focus();
                else // The modal has only close button,
                // Focusing it:
                this.focusableComponents[0].focus();
            }
        });
    }
    /**
   * Stops the spatial navigation by removing the keydown event listener from the video container.
   * Also sets the `isListening_` flag to false.
   */ stop() {
        this.player_.off('keydown', this.onKeyDown_);
        this.isListening_ = false;
    }
    /**
   * Responds to keydown events for spatial navigation and media control.
   *
   * Determines if spatial navigation or media control is active and handles key inputs accordingly.
   *
   * @param {KeyboardEvent} event - The keydown event to be handled.
   */ onKeyDown_(event) {
        // Determine if the event is a custom modalKeydown event
        const actualEvent = event.originalEvent ? event.originalEvent : event;
        if ([
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'ArrowDown'
        ].includes(actualEvent.key)) {
            // Handle directional navigation
            if (this.isPaused_) return;
            actualEvent.preventDefault();
            // "ArrowLeft" => "left" etc
            const direction = actualEvent.key.substring(5).toLowerCase();
            this.move(direction);
        } else if ($cb03b711053a4297$var$SpatialNavKeyCodes.isEventKey(actualEvent, 'play') || $cb03b711053a4297$var$SpatialNavKeyCodes.isEventKey(actualEvent, 'pause') || $cb03b711053a4297$var$SpatialNavKeyCodes.isEventKey(actualEvent, 'ff') || $cb03b711053a4297$var$SpatialNavKeyCodes.isEventKey(actualEvent, 'rw')) {
            // Handle media actions
            actualEvent.preventDefault();
            const action = $cb03b711053a4297$var$SpatialNavKeyCodes.getEventName(actualEvent);
            this.performMediaAction_(action);
        } else if ($cb03b711053a4297$var$SpatialNavKeyCodes.isEventKey(actualEvent, 'Back') && event.target && typeof event.target.closeable === 'function' && event.target.closeable()) {
            actualEvent.preventDefault();
            event.target.close();
        }
    }
    /**
   * Performs media control actions based on the given key input.
   *
   * Controls the playback and seeking functionalities of the media player.
   *
   * @param {string} key - The key representing the media action to be performed.
   *   Accepted keys: 'play', 'pause', 'ff' (fast-forward), 'rw' (rewind).
   */ performMediaAction_(key) {
        if (this.player_) switch(key){
            case 'play':
                if (this.player_.paused()) this.player_.play();
                break;
            case 'pause':
                if (!this.player_.paused()) this.player_.pause();
                break;
            case 'ff':
                this.userSeek_(this.player_.currentTime() + $cb03b711053a4297$var$STEP_SECONDS);
                break;
            case 'rw':
                this.userSeek_(this.player_.currentTime() - $cb03b711053a4297$var$STEP_SECONDS);
                break;
        }
    }
    /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */ userSeek_(ct) {
        if (this.player_.liveTracker && this.player_.liveTracker.isLive()) this.player_.liveTracker.nextSeekedFromUser();
        this.player_.currentTime(ct);
    }
    /**
   * Pauses the spatial navigation functionality.
   * This method sets a flag that can be used to temporarily disable the navigation logic.
   */ pause() {
        this.isPaused_ = true;
    }
    /**
   * Resumes the spatial navigation functionality if it has been paused.
   * This method resets the pause flag, re-enabling the navigation logic.
   */ resume() {
        this.isPaused_ = false;
    }
    /**
   * Handles Player Blur.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * Calls for handling of the Player Blur if:
   * *The next focused element is not a child of current focused element &
   * The next focused element is not a child of the Player.
   * *There is no next focused element
   */ handlePlayerBlur_(event) {
        const nextFocusedElement = event.relatedTarget;
        let isChildrenOfPlayer = null;
        const currentComponent = this.getCurrentComponent(event.target);
        if (nextFocusedElement) {
            isChildrenOfPlayer = Boolean(nextFocusedElement.closest('.video-js'));
            // If nextFocusedElement is the 'TextTrackSettings' component
            if (nextFocusedElement.classList.contains('vjs-text-track-settings') && !this.isPaused_) this.searchForTrackSelect_();
        }
        if (!event.currentTarget.contains(event.relatedTarget) && !isChildrenOfPlayer || !nextFocusedElement) {
            if (currentComponent && currentComponent.name() === 'CloseButton') this.refocusComponent();
            else {
                this.pause();
                if (currentComponent && currentComponent.el()) // Store last focused component
                this.lastFocusedComponent_ = currentComponent;
            }
        }
    }
    /**
   * Handles the Player focus event.
   *
   * Calls for handling of the Player Focus if current element is focusable.
   */ handlePlayerFocus_() {
        if (this.getCurrentComponent() && this.getCurrentComponent().getIsFocusable()) this.resume();
    }
    /**
   * Gets a set of focusable components.
   *
   * @return {Array}
   *         Returns an array of focusable components.
   */ updateFocusableComponents() {
        const player = this.player_;
        const focusableComponents = [];
        /**
     * Searches for children candidates.
     *
     * Pushes Components to array of 'focusableComponents'.
     * Calls itself if there is children elements inside iterated component.
     *
     * @param {Array} componentsArray - The array of components to search for focusable children.
     */ function searchForChildrenCandidates(componentsArray) {
            for (const i of componentsArray){
                if (i.hasOwnProperty('el_') && i.getIsFocusable() && i.getIsAvailableToBeFocused(i.el())) focusableComponents.push(i);
                if (i.hasOwnProperty('children_') && i.children_.length > 0) searchForChildrenCandidates(i.children_);
            }
        }
        // Iterate inside all children components of the player.
        player.children_.forEach((value)=>{
            if (value.hasOwnProperty('el_')) {
                // If component has required functions 'getIsFocusable' & 'getIsAvailableToBeFocused', is focusable & available to be focused.
                if (value.getIsFocusable && value.getIsAvailableToBeFocused && value.getIsFocusable() && value.getIsAvailableToBeFocused(value.el())) {
                    focusableComponents.push(value);
                    return;
                // If component has posible children components as candidates.
                } else if (value.hasOwnProperty('children_') && value.children_.length > 0) searchForChildrenCandidates(value.children_);
                else if (value.hasOwnProperty('items') && value.items.length > 0) searchForChildrenCandidates(value.items);
                else if (this.findSuitableDOMChild(value)) focusableComponents.push(value);
            }
            // TODO - Refactor the following logic after refactor of videojs-errors elements to be components is done.
            if (value.name_ === 'ErrorDisplay' && value.opened_) {
                const buttonContainer = value.el_.querySelector('.vjs-errors-ok-button-container');
                if (buttonContainer) {
                    const modalButtons = buttonContainer.querySelectorAll('button');
                    modalButtons.forEach((element, index)=>{
                        // Add elements as objects to be handled by the spatial navigation
                        focusableComponents.push({
                            name: ()=>{
                                return 'ModalButton' + (index + 1);
                            },
                            el: ()=>element,
                            getPositions: ()=>{
                                const rect = element.getBoundingClientRect();
                                // Creating objects that mirror DOMRectReadOnly for boundingClientRect and center
                                const boundingClientRect = {
                                    x: rect.x,
                                    y: rect.y,
                                    width: rect.width,
                                    height: rect.height,
                                    top: rect.top,
                                    right: rect.right,
                                    bottom: rect.bottom,
                                    left: rect.left
                                };
                                // Calculating the center position
                                const center = {
                                    x: rect.left + rect.width / 2,
                                    y: rect.top + rect.height / 2,
                                    width: 0,
                                    height: 0,
                                    top: rect.top + rect.height / 2,
                                    right: rect.left + rect.width / 2,
                                    bottom: rect.top + rect.height / 2,
                                    left: rect.left + rect.width / 2
                                };
                                return {
                                    boundingClientRect: boundingClientRect,
                                    center: center
                                };
                            },
                            // Asume that the following are always focusable
                            getIsAvailableToBeFocused: ()=>true,
                            getIsFocusable: (el)=>true,
                            focus: ()=>element.focus()
                        });
                    });
                }
            }
        });
        this.focusableComponents = focusableComponents;
        return this.focusableComponents;
    }
    /**
   * Finds a suitable child element within the provided component's DOM element.
   *
   * @param {Object} component - The component containing the DOM element to search within.
   * @return {HTMLElement|null} Returns the suitable child element if found, or null if not found.
   */ findSuitableDOMChild(component) {
        /**
     * Recursively searches for a suitable child node that can be focused within a given component.
     * It first checks if the provided node itself can be focused according to the component's
     * `getIsFocusable` and `getIsAvailableToBeFocused` methods. If not, it recursively searches
     * through the node's children to find a suitable child node that meets the focusability criteria.
     *
     * @param {HTMLElement} node - The DOM node to start the search from.
     * @return {HTMLElement|null} The first child node that is focusable and available to be focused,
     * or `null` if no suitable child is found.
     */ function searchForSuitableChild(node) {
            if (component.getIsFocusable(node) && component.getIsAvailableToBeFocused(node)) return node;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                const suitableChild = searchForSuitableChild(child);
                if (suitableChild) return suitableChild;
            }
            return null;
        }
        if (component.el()) return searchForSuitableChild(component.el());
        return null;
    }
    /**
   * Gets the currently focused component from the list of focusable components.
   * If a target element is provided, it uses that element to find the corresponding
   * component. If no target is provided, it defaults to using the document's currently
   * active element.
   *
   * @param {HTMLElement} [target] - The DOM element to check against the focusable components.
   *                                 If not provided, `document.activeElement` is used.
   * @return {Component|null} - Returns the focused component if found among the focusable components,
   *                            otherwise returns null if no matching component is found.
   */ getCurrentComponent(target) {
        this.updateFocusableComponents();
        // eslint-disable-next-line
        const curComp = target || document.activeElement;
        if (this.focusableComponents.length) for (const i of this.focusableComponents){
            // If component Node is equal to the current active element.
            if (i.el() === curComp) return i;
        }
    }
    /**
   * Adds a component to the array of focusable components.
   *
   * @param {Component} component
   *        The `Component` to be added.
   */ add(component) {
        const focusableComponents = [
            ...this.focusableComponents
        ];
        if (component.hasOwnProperty('el_') && component.getIsFocusable() && component.getIsAvailableToBeFocused(component.el())) focusableComponents.push(component);
        this.focusableComponents = focusableComponents;
        // Trigger the notification manually
        this.trigger({
            type: 'focusableComponentsChanged',
            focusableComponents: this.focusableComponents
        });
    }
    /**
   * Removes component from the array of focusable components.
   *
   * @param {Component} component - The component to be removed from the focusable components array.
   */ remove(component) {
        for(let i = 0; i < this.focusableComponents.length; i++)if (this.focusableComponents[i].name() === component.name()) {
            this.focusableComponents.splice(i, 1);
            // Trigger the notification manually
            this.trigger({
                type: 'focusableComponentsChanged',
                focusableComponents: this.focusableComponents
            });
            return;
        }
    }
    /**
   * Clears array of focusable components.
   */ clear() {
        // Check if the array is already empty to avoid unnecessary event triggering
        if (this.focusableComponents.length > 0) {
            // Clear the array
            this.focusableComponents = [];
            // Trigger the notification manually
            this.trigger({
                type: 'focusableComponentsChanged',
                focusableComponents: this.focusableComponents
            });
        }
    }
    /**
   * Navigates to the next focusable component based on the specified direction.
   *
   * @param {string} direction 'up', 'down', 'left', 'right'
   */ move(direction) {
        const currentFocusedComponent = this.getCurrentComponent();
        if (!currentFocusedComponent) return;
        const currentPositions = currentFocusedComponent.getPositions();
        const candidates = this.focusableComponents.filter((component)=>component !== currentFocusedComponent && this.isInDirection_(currentPositions.boundingClientRect, component.getPositions().boundingClientRect, direction));
        const bestCandidate = this.findBestCandidate_(currentPositions.center, candidates, direction);
        if (bestCandidate) this.focus(bestCandidate);
        else this.trigger({
            type: 'endOfFocusableComponents',
            direction: direction,
            focusedComponent: currentFocusedComponent
        });
    }
    /**
   * Finds the best candidate on the current center position,
   * the list of candidates, and the specified navigation direction.
   *
   * @param {Object} currentCenter The center position of the current focused component element.
   * @param {Array} candidates An array of candidate components to receive focus.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {Object|null} The component that is the best candidate for receiving focus.
   */ findBestCandidate_(currentCenter, candidates, direction) {
        let minDistance = Infinity;
        let bestCandidate = null;
        for (const candidate of candidates){
            const candidateCenter = candidate.getPositions().center;
            const distance = this.calculateDistance_(currentCenter, candidateCenter, direction);
            if (distance < minDistance) {
                minDistance = distance;
                bestCandidate = candidate;
            }
        }
        return bestCandidate;
    }
    /**
   * Determines if a target rectangle is in the specified navigation direction
   * relative to a source rectangle.
   *
   * @param {Object} srcRect The bounding rectangle of the source element.
   * @param {Object} targetRect The bounding rectangle of the target element.
   * @param {string} direction The navigation direction ('up', 'down', 'left', 'right').
   * @return {boolean} True if the target is in the specified direction relative to the source.
   */ isInDirection_(srcRect, targetRect, direction) {
        switch(direction){
            case 'right':
                return targetRect.left >= srcRect.right;
            case 'left':
                return targetRect.right <= srcRect.left;
            case 'down':
                return targetRect.top >= srcRect.bottom;
            case 'up':
                return targetRect.bottom <= srcRect.top;
            default:
                return false;
        }
    }
    /**
   * Focus the last focused component saved before blur on player.
   */ refocusComponent() {
        if (this.lastFocusedComponent_) {
            // If user is not active, set it to active.
            if (!this.player_.userActive()) this.player_.userActive(true);
            this.updateFocusableComponents();
            // Search inside array of 'focusableComponents' for a match of name of
            // the last focused component.
            for(let i = 0; i < this.focusableComponents.length; i++)if (this.focusableComponents[i].name() === this.lastFocusedComponent_.name()) {
                this.focus(this.focusableComponents[i]);
                return;
            }
        } else this.focus(this.updateFocusableComponents()[0]);
    }
    /**
   * Focuses on a given component.
   * If the component is available to be focused, it focuses on the component.
   * If not, it attempts to find a suitable DOM child within the component and focuses on it.
   *
   * @param {Component} component - The component to be focused.
   */ focus(component) {
        if (typeof component !== 'object') return;
        if (component.getIsAvailableToBeFocused(component.el())) component.focus();
        else if (this.findSuitableDOMChild(component)) this.findSuitableDOMChild(component).focus();
    }
    /**
   * Calculates the distance between two points, adjusting the calculation based on
   * the specified navigation direction.
   *
   * @param {Object} center1 The center point of the first element.
   * @param {Object} center2 The center point of the second element.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {number} The calculated distance between the two centers.
   */ calculateDistance_(center1, center2, direction) {
        const dx = Math.abs(center1.x - center2.x);
        const dy = Math.abs(center1.y - center2.y);
        let distance;
        switch(direction){
            case 'right':
            case 'left':
                // Higher weight for vertical distance in horizontal navigation.
                distance = dx + dy * 100;
                break;
            case 'up':
                // Strongly prioritize vertical proximity for UP navigation.
                // Adjust the weight to ensure that elements directly above are favored.
                distance = dy * 2 + dx * 0.5;
                break;
            case 'down':
                // More balanced weight for vertical and horizontal distances.
                // Adjust the weights here to find the best balance.
                distance = dy * 5 + dx;
                break;
            default:
                distance = dx + dy;
        }
        return distance;
    }
    /**
   * This gets called by 'handlePlayerBlur_' if 'spatialNavigation' is enabled.
   * Searches for the first 'TextTrackSelect' inside of modal to focus.
   *
   * @private
   */ searchForTrackSelect_() {
        const spatialNavigation = this;
        for (const component of spatialNavigation.updateFocusableComponents())if (component.constructor.name === 'TextTrackSelect') {
            spatialNavigation.focus(component);
            break;
        }
    }
}
/**
 * @file loader.js
 */ /** @import Player from '../player' */ /**
 * The `MediaLoader` is the `Component` that decides which playback technology to load
 * when a player is initialized.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$MediaLoader extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function that is run when this component is ready.
   */ constructor(player, options, ready){
        // MediaLoader has no element
        const options_ = $cb03b711053a4297$var$merge$1({
            createEl: false
        }, options);
        super(player, options_, ready);
        // If there are no sources when the player is initialized,
        // load the first supported playback technology.
        if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) for(let i = 0, j = options.playerOptions.techOrder; i < j.length; i++){
            const techName = $cb03b711053a4297$var$toTitleCase$1(j[i]);
            let tech = $cb03b711053a4297$var$Tech.getTech(techName);
            // Support old behavior of techs being registered as components.
            // Remove once that deprecated behavior is removed.
            if (!techName) tech = $cb03b711053a4297$var$Component$1.getComponent(techName);
            // Check if the browser supports this technology
            if (tech && tech.isSupported()) {
                player.loadTech_(techName);
                break;
            }
        }
        else // Loop through playback technologies (e.g. HTML5) and check for support.
        // Then load the best source.
        // A few assumptions here:
        //   All playback technologies respect preload false.
        player.src(options.playerOptions.sources);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('MediaLoader', $cb03b711053a4297$var$MediaLoader);
/**
 * @file clickable-component.js
 */ /** @import Player from './player' */ /**
 * Component which is clickable or keyboard actionable, but is not a
 * native HTML button.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$ClickableComponent extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of component options.
   *
   * @param  {function} [options.clickHandler]
   *         The function to call when the button is clicked / activated
   *
   * @param  {string} [options.controlText]
   *         The text to set on the button
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   */ constructor(player, options){
        super(player, options);
        if (this.options_.controlText) this.controlText(this.options_.controlText);
        this.handleMouseOver_ = (e)=>this.handleMouseOver(e);
        this.handleMouseOut_ = (e)=>this.handleMouseOut(e);
        this.handleClick_ = (e)=>this.handleClick(e);
        this.handleKeyDown_ = (e)=>this.handleKeyDown(e);
        this.emitTapEvents();
        this.enable();
    }
    /**
   * Create the `ClickableComponent`s DOM element.
   *
   * @param {string} [tag=div]
   *        The element's node type.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(tag = 'div', props = {}, attributes = {}) {
        props = Object.assign({
            className: this.buildCSSClass(),
            tabIndex: 0
        }, props);
        if (tag === 'button') $cb03b711053a4297$var$log$1.error(`Creating a ClickableComponent with an HTML element of ${tag} is not supported; use a Button instead.`);
        // Add ARIA attributes for clickable element which is not a native HTML button
        attributes = Object.assign({
            role: 'button'
        }, attributes);
        this.tabIndex_ = props.tabIndex;
        const el = $cb03b711053a4297$var$createEl(tag, props, attributes);
        if (!this.player_.options_.experimentalSvgIcons) el.appendChild($cb03b711053a4297$var$createEl('span', {
            className: 'vjs-icon-placeholder'
        }, {
            'aria-hidden': true
        }));
        this.createControlTextEl(el);
        return el;
    }
    dispose() {
        // remove controlTextEl_ on dispose
        this.controlTextEl_ = null;
        super.dispose();
    }
    /**
   * Create a control text element on this `ClickableComponent`
   *
   * @param {Element} [el]
   *        Parent element for the control text.
   *
   * @return {Element}
   *         The control text element that gets created.
   */ createControlTextEl(el) {
        this.controlTextEl_ = $cb03b711053a4297$var$createEl('span', {
            className: 'vjs-control-text'
        }, {
            // let the screen reader user know that the text of the element may change
            'aria-live': 'polite'
        });
        if (el) el.appendChild(this.controlTextEl_);
        this.controlText(this.controlText_, el);
        return this.controlTextEl_;
    }
    /**
   * Get or set the localize text to use for the controls on the `ClickableComponent`.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */ controlText(text, el = this.el()) {
        if (text === undefined) return this.controlText_ || 'Need Text';
        const localizedText = this.localize(text);
        /** @protected */ this.controlText_ = text;
        $cb03b711053a4297$var$textContent(this.controlTextEl_, localizedText);
        if (!this.nonIconControl && !this.player_.options_.noUITitleAttributes) // Set title attribute if only an icon is shown
        el.setAttribute('title', localizedText);
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-control vjs-button ${super.buildCSSClass()}`;
    }
    /**
   * Enable this `ClickableComponent`
   */ enable() {
        if (!this.enabled_) {
            this.enabled_ = true;
            this.removeClass('vjs-disabled');
            this.el_.setAttribute('aria-disabled', 'false');
            if (typeof this.tabIndex_ !== 'undefined') this.el_.setAttribute('tabIndex', this.tabIndex_);
            this.on([
                'tap',
                'click'
            ], this.handleClick_);
            this.on('keydown', this.handleKeyDown_);
        }
    }
    /**
   * Disable this `ClickableComponent`
   */ disable() {
        this.enabled_ = false;
        this.addClass('vjs-disabled');
        this.el_.setAttribute('aria-disabled', 'true');
        if (typeof this.tabIndex_ !== 'undefined') this.el_.removeAttribute('tabIndex');
        this.off('mouseover', this.handleMouseOver_);
        this.off('mouseout', this.handleMouseOut_);
        this.off([
            'tap',
            'click'
        ], this.handleClick_);
        this.off('keydown', this.handleKeyDown_);
    }
    /**
   * Handles language change in ClickableComponent for the player in components
   *
   *
   */ handleLanguagechange() {
        this.controlText(this.controlText_);
    }
    /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `click` or `tap` event.
   *
   * @param {Event} event
   *        The `tap` or `click` event that caused this function to be called.
   *
   * @listens tap
   * @listens click
   * @abstract
   */ handleClick(event) {
        if (this.options_.clickHandler) this.options_.clickHandler.call(this, arguments);
    }
    /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `keydown` event.
   *
   * By default, if the key is Space or Enter, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Support Space or Enter key operation to fire a click event. Also,
        // prevent the event from propagating through the DOM and triggering
        // Player hotkeys.
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.trigger('click');
        } else // Pass keypress handling up for unsupported keys
        super.handleKeyDown(event);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('ClickableComponent', $cb03b711053a4297$var$ClickableComponent);
/**
 * @file poster-image.js
 */ /** @import Player from './player' */ /**
 * A `ClickableComponent` that handles showing the poster image for the player.
 *
 * @extends ClickableComponent
 */ class $cb03b711053a4297$var$PosterImage extends $cb03b711053a4297$var$ClickableComponent {
    /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update();
        this.update_ = (e)=>this.update(e);
        player.on('posterchange', this.update_);
    }
    /**
   * Clean up and dispose of the `PosterImage`.
   */ dispose() {
        this.player().off('posterchange', this.update_);
        super.dispose();
    }
    /**
   * Create the `PosterImage`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl() {
        // The el is an empty div to keep position in the DOM
        // A picture and img el will be inserted when a source is set
        return $cb03b711053a4297$var$createEl('div', {
            className: 'vjs-poster'
        });
    }
    /**
   * Get or set the `PosterImage`'s crossOrigin option.
   *
   * @param {string|null} [value]
   *        The value to set the crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */ crossOrigin(value) {
        // `null` can be set to unset a value
        if (typeof value === 'undefined') {
            if (this.$('img')) // If the poster's element exists, give its value
            return this.$('img').crossOrigin;
            else if (this.player_.tech_ && this.player_.tech_.isReady_) // If not but the tech is ready, query the tech
            return this.player_.crossOrigin();
            // Otherwise check options as the  poster is usually set before the state of crossorigin
            // can be retrieved by the getter
            return this.player_.options_.crossOrigin || this.player_.options_.crossorigin || null;
        }
        if (value !== null && value !== 'anonymous' && value !== 'use-credentials') {
            this.player_.log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${value}"`);
            return;
        }
        if (this.$('img')) this.$('img').crossOrigin = value;
        return;
    }
    /**
   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
   *
   * @listens Player#posterchange
   *
   * @param {Event} [event]
   *        The `Player#posterchange` event that triggered this function.
   */ update(event) {
        const url = this.player().poster();
        this.setSrc(url);
        // If there's no poster source we should display:none on this component
        // so it's not still clickable or right-clickable
        if (url) this.show();
        else this.hide();
    }
    /**
   * Set the source of the `PosterImage` depending on the display method. (Re)creates
   * the inner picture and img elementss when needed.
   *
   * @param {string} [url]
   *        The URL to the source for the `PosterImage`. If not specified or falsy,
   *        any source and ant inner picture/img are removed.
   */ setSrc(url) {
        if (!url) {
            this.el_.textContent = '';
            return;
        }
        if (!this.$('img')) this.el_.appendChild($cb03b711053a4297$var$createEl('picture', {
            className: 'vjs-poster',
            // Don't want poster to be tabbable.
            tabIndex: -1
        }, {}, $cb03b711053a4297$var$createEl('img', {
            loading: 'lazy',
            crossOrigin: this.crossOrigin()
        }, {
            alt: ''
        })));
        this.$('img').src = url;
    }
    /**
   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
   *
   * @listens tap
   * @listens click
   * @listens keydown
   *
   * @param {Event} event
   +        The `click`, `tap` or `keydown` event that caused this function to be called.
   */ handleClick(event) {
        // We don't want a click to trigger playback when controls are disabled
        if (!this.player_.controls()) return;
        if (this.player_.tech(true)) this.player_.tech(true).focus();
        if (this.player_.paused()) $cb03b711053a4297$var$silencePromise(this.player_.play());
        else this.player_.pause();
    }
}
/**
 * Get or set the `PosterImage`'s crossorigin option. For the HTML5 player, this
 * sets the `crossOrigin` property on the `<img>` tag to control the CORS
 * behavior.
 *
 * @param {string|null} [value]
 *        The value to set the `PosterImages`'s crossorigin to. If an argument is
 *        given, must be one of `anonymous` or `use-credentials`.
 *
 * @return {string|null|undefined}
 *         - The current crossorigin value of the `Player` when getting.
 *         - undefined when setting
 */ $cb03b711053a4297$var$PosterImage.prototype.crossorigin = $cb03b711053a4297$var$PosterImage.prototype.crossOrigin;
$cb03b711053a4297$var$Component$1.registerComponent('PosterImage', $cb03b711053a4297$var$PosterImage);
/**
 * @file text-track-display.js
 */ /** @import Player from '../player' */ const $cb03b711053a4297$var$darkGray = '#222';
const $cb03b711053a4297$var$lightGray = '#ccc';
const $cb03b711053a4297$var$fontMap = {
    monospace: 'monospace',
    sansSerif: 'sans-serif',
    serif: 'serif',
    monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
    monospaceSerif: '"Courier New", monospace',
    proportionalSansSerif: 'sans-serif',
    proportionalSerif: 'serif',
    casual: '"Comic Sans MS", Impact, fantasy',
    script: '"Monotype Corsiva", cursive',
    smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
/**
 * Construct an rgba color from a given hex color code.
 *
 * @param {number} color
 *        Hex number for color, like #f0e or #f604e2.
 *
 * @param {number} opacity
 *        Value for opacity, 0.0 - 1.0.
 *
 * @return {string}
 *         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
 */ function $cb03b711053a4297$var$constructColor(color, opacity) {
    let hex;
    if (color.length === 4) // color looks like "#f0e"
    hex = color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
    else if (color.length === 7) // color looks like "#f604e2"
    hex = color.slice(1);
    else throw new Error('Invalid color code provided, ' + color + '; must be formatted as e.g. #f0e or #f604e2.');
    return 'rgba(' + parseInt(hex.slice(0, 2), 16) + ',' + parseInt(hex.slice(2, 4), 16) + ',' + parseInt(hex.slice(4, 6), 16) + ',' + opacity + ')';
}
/**
 * Try to update the style of a DOM element. Some style changes will throw an error,
 * particularly in IE8. Those should be noops.
 *
 * @param {Element} el
 *        The DOM element to be styled.
 *
 * @param {string} style
 *        The CSS property on the element that should be styled.
 *
 * @param {string} rule
 *        The style rule that should be applied to the property.
 *
 * @private
 */ function $cb03b711053a4297$var$tryUpdateStyle(el, style, rule) {
    try {
        el.style[style] = rule;
    } catch (e) {
        // Satisfies linter.
        return;
    }
}
/**
 * Converts the CSS top/right/bottom/left property numeric value to string in pixels.
 *
 * @param {number} position
 *        The CSS top/right/bottom/left property value.
 *
 * @return {string}
 *          The CSS property value that was created, like '10px'.
 *
 * @private
 */ function $cb03b711053a4297$var$getCSSPositionValue(position) {
    return position ? `${position}px` : '';
}
/**
 * The component for displaying text track cues.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TextTrackDisplay extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when `TextTrackDisplay` is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        const updateDisplayTextHandler = (e)=>this.updateDisplay(e);
        const updateDisplayHandler = (e)=>{
            this.updateDisplayOverlay();
            this.updateDisplay(e);
        };
        player.on('loadstart', (e)=>this.toggleDisplay(e));
        player.on('useractive', updateDisplayTextHandler);
        player.on('userinactive', updateDisplayTextHandler);
        player.on('texttrackchange', updateDisplayTextHandler);
        player.on('loadedmetadata', (e)=>{
            this.updateDisplayOverlay();
            this.preselectTrack(e);
        });
        // This used to be called during player init, but was causing an error
        // if a track should show by default and the display hadn't loaded yet.
        // Should probably be moved to an external track loader when we support
        // tracks that don't need a display.
        player.ready($cb03b711053a4297$var$bind_(this, function() {
            if (player.tech_ && player.tech_.featuresNativeTextTracks) {
                this.hide();
                return;
            }
            player.on('fullscreenchange', updateDisplayHandler);
            player.on('playerresize', updateDisplayHandler);
            const screenOrientation = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).screen.orientation || (0, (/*@__PURE__*/$parcel$interopDefault($eDick)));
            const changeOrientationEvent = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).screen.orientation ? 'change' : 'orientationchange';
            screenOrientation.addEventListener(changeOrientationEvent, updateDisplayHandler);
            player.on('dispose', ()=>screenOrientation.removeEventListener(changeOrientationEvent, updateDisplayHandler));
            const tracks = this.options_.playerOptions.tracks || [];
            for(let i = 0; i < tracks.length; i++)this.player_.addRemoteTextTrack(tracks[i], true);
            this.preselectTrack();
        }));
    }
    /**
  * Preselect a track following this precedence:
  * - matches the previously selected {@link TextTrack}'s language and kind
  * - matches the previously selected {@link TextTrack}'s language only
  * - is the first default captions track
  * - is the first default descriptions track
  *
  * @listens Player#loadstart
  */ preselectTrack() {
        const modes = {
            captions: 1,
            subtitles: 1
        };
        const trackList = this.player_.textTracks();
        const userPref = this.player_.cache_.selectedLanguage;
        let firstDesc;
        let firstCaptions;
        let preferredTrack;
        for(let i = 0; i < trackList.length; i++){
            const track = trackList[i];
            if (userPref && userPref.enabled && userPref.language && userPref.language === track.language && track.kind in modes) {
                // Always choose the track that matches both language and kind
                if (track.kind === userPref.kind) preferredTrack = track;
                else if (!preferredTrack) preferredTrack = track;
            // clear everything if offTextTrackMenuItem was clicked
            } else if (userPref && !userPref.enabled) {
                preferredTrack = null;
                firstDesc = null;
                firstCaptions = null;
            } else if (track.default) {
                if (track.kind === 'descriptions' && !firstDesc) firstDesc = track;
                else if (track.kind in modes && !firstCaptions) firstCaptions = track;
            }
        }
        // The preferredTrack matches the user preference and takes
        // precedence over all the other tracks.
        // So, display the preferredTrack before the first default track
        // and the subtitles/captions track before the descriptions track
        if (preferredTrack) preferredTrack.mode = 'showing';
        else if (firstCaptions) firstCaptions.mode = 'showing';
        else if (firstDesc) firstDesc.mode = 'showing';
    }
    /**
   * Turn display of {@link TextTrack}'s from the current state into the other state.
   * There are only two states:
   * - 'shown'
   * - 'hidden'
   *
   * @listens Player#loadstart
   */ toggleDisplay() {
        if (this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks) this.hide();
        else this.show();
    }
    /**
   * Create the {@link Component}'s DOM element.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-text-track-display'
        }, {
            'translate': 'yes',
            'aria-live': 'off',
            'aria-atomic': 'true'
        });
    }
    /**
   * Clear all displayed {@link TextTrack}s.
   */ clearDisplay() {
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT === 'function') (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.processCues((0, (/*@__PURE__*/$parcel$interopDefault($eDick))), [], this.el_);
    }
    /**
   * Update the displayed {@link TextTrack} when either a {@link Player#texttrackchange},
   * a {@link Player#fullscreenchange}, a {@link Player#useractive}, or a
   * {@link Player#userinactive} is fired.
   *
   * @listens Player#texttrackchange
   * @listens Player#fullscreenchange
   * @listens Player#useractive
   * @listens Player#userinactive
   */ updateDisplay() {
        const tracks = this.player_.textTracks();
        const allowMultipleShowingTracks = this.options_.allowMultipleShowingTracks;
        this.clearDisplay();
        if (allowMultipleShowingTracks) {
            const showingTracks = [];
            for(let i = 0; i < tracks.length; ++i){
                const track = tracks[i];
                if (track.mode !== 'showing') continue;
                showingTracks.push(track);
            }
            this.updateForTrack(showingTracks);
            return;
        }
        //  Track display prioritization model: if multiple tracks are 'showing',
        //  display the first 'subtitles' or 'captions' track which is 'showing',
        //  otherwise display the first 'descriptions' track which is 'showing'
        let descriptionsTrack = null;
        let captionsSubtitlesTrack = null;
        let i = tracks.length;
        while(i--){
            const track = tracks[i];
            if (track.mode === 'showing') {
                if (track.kind === 'descriptions') descriptionsTrack = track;
                else captionsSubtitlesTrack = track;
            }
        }
        if (captionsSubtitlesTrack) {
            if (this.getAttribute('aria-live') !== 'off') this.setAttribute('aria-live', 'off');
            this.updateForTrack(captionsSubtitlesTrack);
        } else if (descriptionsTrack) {
            if (this.getAttribute('aria-live') !== 'assertive') this.setAttribute('aria-live', 'assertive');
            this.updateForTrack(descriptionsTrack);
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).CSS.supports('inset', '10px')) {
            const textTrackDisplay = this.el_;
            const vjsTextTrackCues = textTrackDisplay.querySelectorAll('.vjs-text-track-cue');
            const controlBarHeight = this.player_.controlBar.el_.getBoundingClientRect().height;
            const playerHeight = this.player_.el_.getBoundingClientRect().height;
            // Clear inline style before getting actual height of textTrackDisplay
            textTrackDisplay.style = '';
            // textrack style updates, this styles are required to be inline
            $cb03b711053a4297$var$tryUpdateStyle(textTrackDisplay, 'position', 'relative');
            $cb03b711053a4297$var$tryUpdateStyle(textTrackDisplay, 'height', playerHeight - controlBarHeight + 'px');
            $cb03b711053a4297$var$tryUpdateStyle(textTrackDisplay, 'top', 'unset');
            if ($cb03b711053a4297$var$IS_SMART_TV) $cb03b711053a4297$var$tryUpdateStyle(textTrackDisplay, 'bottom', playerHeight + 'px');
            else $cb03b711053a4297$var$tryUpdateStyle(textTrackDisplay, 'bottom', '0px');
            // vjsTextTrackCue style updates
            if (vjsTextTrackCues.length > 0) vjsTextTrackCues.forEach((vjsTextTrackCue)=>{
                // verify if inset styles are inline
                if (vjsTextTrackCue.style.inset) {
                    const insetStyles = vjsTextTrackCue.style.inset.split(' ');
                    // expected value is always 3
                    if (insetStyles.length === 3) Object.assign(vjsTextTrackCue.style, {
                        top: insetStyles[0],
                        right: insetStyles[1],
                        bottom: insetStyles[2],
                        left: 'unset'
                    });
                }
            });
        }
    }
    /**
   * Updates the displayed TextTrack to be sure it overlays the video when a either
   * a {@link Player#texttrackchange} or a {@link Player#fullscreenchange} is fired.
   */ updateDisplayOverlay() {
        // inset-inline and inset-block are not supprted on old chrome, but these are
        // only likely to be used on TV devices
        if (!this.player_.videoHeight() || !(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).CSS.supports('inset-inline: 10px')) return;
        const playerWidth = this.player_.currentWidth();
        const playerHeight = this.player_.currentHeight();
        const playerAspectRatio = playerWidth / playerHeight;
        const videoAspectRatio = this.player_.videoWidth() / this.player_.videoHeight();
        let insetInlineMatch = 0;
        let insetBlockMatch = 0;
        if (Math.abs(playerAspectRatio - videoAspectRatio) > 0.1) {
            if (playerAspectRatio > videoAspectRatio) insetInlineMatch = Math.round((playerWidth - playerHeight * videoAspectRatio) / 2);
            else insetBlockMatch = Math.round((playerHeight - playerWidth / videoAspectRatio) / 2);
        }
        $cb03b711053a4297$var$tryUpdateStyle(this.el_, 'insetInline', $cb03b711053a4297$var$getCSSPositionValue(insetInlineMatch));
        $cb03b711053a4297$var$tryUpdateStyle(this.el_, 'insetBlock', $cb03b711053a4297$var$getCSSPositionValue(insetBlockMatch));
    }
    /**
   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
   *
   * @param {TextTrack} track
   *        Text track object containing active cues to style.
   */ updateDisplayState(track) {
        const overrides = this.player_.textTrackSettings.getValues();
        const cues = track.activeCues;
        let i = cues.length;
        while(i--){
            const cue = cues[i];
            if (!cue) continue;
            const cueDiv = cue.displayState;
            if (overrides.color) cueDiv.firstChild.style.color = overrides.color;
            if (overrides.textOpacity) $cb03b711053a4297$var$tryUpdateStyle(cueDiv.firstChild, 'color', $cb03b711053a4297$var$constructColor(overrides.color || '#fff', overrides.textOpacity));
            if (overrides.backgroundColor) cueDiv.firstChild.style.backgroundColor = overrides.backgroundColor;
            if (overrides.backgroundOpacity) $cb03b711053a4297$var$tryUpdateStyle(cueDiv.firstChild, 'backgroundColor', $cb03b711053a4297$var$constructColor(overrides.backgroundColor || '#000', overrides.backgroundOpacity));
            if (overrides.windowColor) {
                if (overrides.windowOpacity) $cb03b711053a4297$var$tryUpdateStyle(cueDiv, 'backgroundColor', $cb03b711053a4297$var$constructColor(overrides.windowColor, overrides.windowOpacity));
                else cueDiv.style.backgroundColor = overrides.windowColor;
            }
            if (overrides.edgeStyle) {
                if (overrides.edgeStyle === 'dropshadow') cueDiv.firstChild.style.textShadow = `2px 2px 3px ${$cb03b711053a4297$var$darkGray}, 2px 2px 4px ${$cb03b711053a4297$var$darkGray}, 2px 2px 5px ${$cb03b711053a4297$var$darkGray}`;
                else if (overrides.edgeStyle === 'raised') cueDiv.firstChild.style.textShadow = `1px 1px ${$cb03b711053a4297$var$darkGray}, 2px 2px ${$cb03b711053a4297$var$darkGray}, 3px 3px ${$cb03b711053a4297$var$darkGray}`;
                else if (overrides.edgeStyle === 'depressed') cueDiv.firstChild.style.textShadow = `1px 1px ${$cb03b711053a4297$var$lightGray}, 0 1px ${$cb03b711053a4297$var$lightGray}, -1px -1px ${$cb03b711053a4297$var$darkGray}, 0 -1px ${$cb03b711053a4297$var$darkGray}`;
                else if (overrides.edgeStyle === 'uniform') cueDiv.firstChild.style.textShadow = `0 0 4px ${$cb03b711053a4297$var$darkGray}, 0 0 4px ${$cb03b711053a4297$var$darkGray}, 0 0 4px ${$cb03b711053a4297$var$darkGray}, 0 0 4px ${$cb03b711053a4297$var$darkGray}`;
            }
            if (overrides.fontPercent && overrides.fontPercent !== 1) {
                const fontSize = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).parseFloat(cueDiv.style.fontSize);
                cueDiv.style.fontSize = fontSize * overrides.fontPercent + 'px';
                cueDiv.style.height = 'auto';
                cueDiv.style.top = 'auto';
            }
            if (overrides.fontFamily && overrides.fontFamily !== 'default') {
                if (overrides.fontFamily === 'small-caps') cueDiv.firstChild.style.fontVariant = 'small-caps';
                else cueDiv.firstChild.style.fontFamily = $cb03b711053a4297$var$fontMap[overrides.fontFamily];
            }
        }
    }
    /**
   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
   *
   * @param {TextTrack|TextTrack[]} tracks
   *        Text track object or text track array to be added to the list.
   */ updateForTrack(tracks) {
        if (!Array.isArray(tracks)) tracks = [
            tracks
        ];
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT !== 'function' || tracks.every((track)=>{
            return !track.activeCues;
        })) return;
        const cues = [];
        // push all active track cues
        for(let i = 0; i < tracks.length; ++i){
            const track = tracks[i];
            for(let j = 0; j < track.activeCues.length; ++j)cues.push(track.activeCues[j]);
        }
        // removes all cues before it processes new ones
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.processCues((0, (/*@__PURE__*/$parcel$interopDefault($eDick))), cues, this.el_);
        // add unique class to each language text track & add settings styling if necessary
        for(let i = 0; i < tracks.length; ++i){
            const track = tracks[i];
            for(let j = 0; j < track.activeCues.length; ++j){
                const cueEl = track.activeCues[j].displayState;
                $cb03b711053a4297$var$addClass(cueEl, 'vjs-text-track-cue', 'vjs-text-track-cue-' + (track.language ? track.language : i));
                if (track.language) $cb03b711053a4297$var$setAttribute(cueEl, 'lang', track.language);
            }
            if (this.player_.textTrackSettings) this.updateDisplayState(track);
        }
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TextTrackDisplay', $cb03b711053a4297$var$TextTrackDisplay);
/**
 * @file loading-spinner.js
 */ /**
 * A loading spinner for use during waiting/loading events.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$LoadingSpinner extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create the `LoadingSpinner`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */ createEl() {
        const isAudio = this.player_.isAudio();
        const playerType = this.localize(isAudio ? 'Audio Player' : 'Video Player');
        const controlText = $cb03b711053a4297$var$createEl('span', {
            className: 'vjs-control-text',
            textContent: this.localize('{1} is loading.', [
                playerType
            ])
        });
        const el = super.createEl('div', {
            className: 'vjs-loading-spinner',
            dir: 'ltr'
        });
        el.appendChild(controlText);
        return el;
    }
    /**
   * Update control text on languagechange
   */ handleLanguagechange() {
        this.$('.vjs-control-text').textContent = this.localize('{1} is loading.', [
            this.player_.isAudio() ? 'Audio Player' : 'Video Player'
        ]);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('LoadingSpinner', $cb03b711053a4297$var$LoadingSpinner);
/**
 * @file button.js
 */ /**
 * Base class for all buttons.
 *
 * @extends ClickableComponent
 */ class $cb03b711053a4297$var$Button extends $cb03b711053a4297$var$ClickableComponent {
    /**
   * Create the `Button`s DOM element.
   *
   * @param {string} [tag="button"]
   *        The element's node type. This argument is IGNORED: no matter what
   *        is passed, it will always create a `button` element.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(tag, props = {}, attributes = {}) {
        tag = 'button';
        props = Object.assign({
            className: this.buildCSSClass()
        }, props);
        // Add attributes for button element
        attributes = Object.assign({
            // Necessary since the default button type is "submit"
            type: 'button'
        }, attributes);
        const el = $cb03b711053a4297$var$createEl(tag, props, attributes);
        if (!this.player_.options_.experimentalSvgIcons) el.appendChild($cb03b711053a4297$var$createEl('span', {
            className: 'vjs-icon-placeholder'
        }, {
            'aria-hidden': true
        }));
        this.createControlTextEl(el);
        return el;
    }
    /**
   * Add a child `Component` inside of this `Button`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   *
   * @deprecated since version 5
   */ addChild(child, options = {}) {
        const className = this.constructor.name;
        $cb03b711053a4297$var$log$1.warn(`Adding an actionable (user controllable) child to a Button (${className}) is not supported; use a ClickableComponent instead.`);
        // Avoid the error message generated by ClickableComponent's addChild method
        return $cb03b711053a4297$var$Component$1.prototype.addChild.call(this, child, options);
    }
    /**
   * Enable the `Button` element so that it can be activated or clicked. Use this with
   * {@link Button#disable}.
   */ enable() {
        super.enable();
        this.el_.removeAttribute('disabled');
    }
    /**
   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
   * {@link Button#enable}.
   */ disable() {
        super.disable();
        this.el_.setAttribute('disabled', 'disabled');
    }
    /**
   * This gets called when a `Button` has focus and `keydown` is triggered via a key
   * press.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to get called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Ignore Space or Enter key operation, which is handled by the browser for
        // a button - though not for its super class, ClickableComponent. Also,
        // prevent the event from propagating through the DOM and triggering Player
        // hotkeys. We do not preventDefault here because we _want_ the browser to
        // handle it.
        if (event.key === ' ' || event.key === 'Enter') {
            event.stopPropagation();
            return;
        }
        // Pass keypress handling up for unsupported keys
        super.handleKeyDown(event);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('Button', $cb03b711053a4297$var$Button);
/**
 * @file big-play-button.js
 */ /**
 * The initial play button that shows before the video has played. The hiding of the
 * `BigPlayButton` get done via CSS and `Player` states.
 *
 * @extends Button
 */ class $cb03b711053a4297$var$BigPlayButton extends $cb03b711053a4297$var$Button {
    constructor(player, options){
        super(player, options);
        this.mouseused_ = false;
        this.setIcon('play');
        this.on('mousedown', (e)=>this.handleMouseDown(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
   */ buildCSSClass() {
        return 'vjs-big-play-button';
    }
    /**
   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {KeyboardEvent|MouseEvent|TouchEvent} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        const playPromise = this.player_.play();
        // exit early if tapped or clicked via the mouse
        if (event.type === 'tap' || this.mouseused_ && 'clientX' in event && 'clientY' in event) {
            $cb03b711053a4297$var$silencePromise(playPromise);
            if (this.player_.tech(true)) this.player_.tech(true).focus();
            return;
        }
        const cb = this.player_.getChild('controlBar');
        const playToggle = cb && cb.getChild('playToggle');
        if (!playToggle) {
            this.player_.tech(true).focus();
            return;
        }
        const playFocus = ()=>playToggle.focus();
        if ($cb03b711053a4297$var$isPromise(playPromise)) playPromise.then(playFocus, ()=>{});
        else this.setTimeout(playFocus, 1);
    }
    /**
   * Event handler that is called when a `BigPlayButton` receives a
   * `keydown` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        this.mouseused_ = false;
        super.handleKeyDown(event);
    }
    /**
   * Handle `mousedown` events on the `BigPlayButton`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   */ handleMouseDown(event) {
        this.mouseused_ = true;
    }
}
/**
 * The text that should display over the `BigPlayButton`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$BigPlayButton.prototype.controlText_ = 'Play Video';
$cb03b711053a4297$var$Component$1.registerComponent('BigPlayButton', $cb03b711053a4297$var$BigPlayButton);
/**
 * @file close-button.js
 */ /** @import Player from './player' */ /**
 * The `CloseButton` is a `{@link Button}` that fires a `close` event when
 * it gets clicked.
 *
 * @extends Button
 */ class $cb03b711053a4297$var$CloseButton extends $cb03b711053a4297$var$Button {
    /**
  * Creates an instance of the this class.
  *
  * @param  {Player} player
  *         The `Player` that this class should be attached to.
  *
  * @param  {Object} [options]
  *         The key/value store of player options.
  */ constructor(player, options){
        super(player, options);
        this.setIcon('cancel');
        this.controlText(options && options.controlText || this.localize('Close'));
    }
    /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */ buildCSSClass() {
        return `vjs-close-button ${super.buildCSSClass()}`;
    }
    /**
   * This gets called when a `CloseButton` gets clicked. See
   * {@link ClickableComponent#handleClick} for more information on when
   * this will be triggered
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @fires CloseButton#close
   */ handleClick(event) {
        /**
     * Triggered when the a `CloseButton` is clicked.
     *
     * @event CloseButton#close
     * @type {Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the close event does not
     *           bubble up to parents if there is no listener
     */ this.trigger({
            type: 'close',
            bubbles: false
        });
    }
    /**
   * Event handler that is called when a `CloseButton` receives a
   * `keydown` event.
   *
   * By default, if the key is Esc, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Esc button will trigger `click` event
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.trigger('click');
        } else // Pass keypress handling up for unsupported keys
        super.handleKeyDown(event);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('CloseButton', $cb03b711053a4297$var$CloseButton);
/**
 * @file play-toggle.js
 */ /** @import Player from './player' */ /**
 * Button to toggle between play and pause.
 *
 * @extends Button
 */ class $cb03b711053a4297$var$PlayToggle extends $cb03b711053a4297$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        super(player, options);
        // show or hide replay icon
        options.replay = options.replay === undefined || options.replay;
        this.setIcon('play');
        this.on(player, 'play', (e)=>this.handlePlay(e));
        this.on(player, 'pause', (e)=>this.handlePause(e));
        if (options.replay) this.on(player, 'ended', (e)=>this.handleEnded(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-play-control ${super.buildCSSClass()}`;
    }
    /**
   * This gets called when an `PlayToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (this.player_.paused()) $cb03b711053a4297$var$silencePromise(this.player_.play());
        else this.player_.pause();
    }
    /**
   * This gets called once after the video has ended and the user seeks so that
   * we can change the replay button back to a play button.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#seeked
   */ handleSeeked(event) {
        this.removeClass('vjs-ended');
        if (this.player_.paused()) this.handlePause(event);
        else this.handlePlay(event);
    }
    /**
   * Add the vjs-playing class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#play
   */ handlePlay(event) {
        this.removeClass('vjs-ended', 'vjs-paused');
        this.addClass('vjs-playing');
        // change the button text to "Pause"
        this.setIcon('pause');
        this.controlText('Pause');
    }
    /**
   * Add the vjs-paused class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#pause
   */ handlePause(event) {
        this.removeClass('vjs-playing');
        this.addClass('vjs-paused');
        // change the button text to "Play"
        this.setIcon('play');
        this.controlText('Play');
    }
    /**
   * Add the vjs-ended class to the element so it can change appearance
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ended
   */ handleEnded(event) {
        this.removeClass('vjs-playing');
        this.addClass('vjs-ended');
        // change the button text to "Replay"
        this.setIcon('replay');
        this.controlText('Replay');
        // on the next seek remove the replay button
        this.one(this.player_, 'seeked', (e)=>this.handleSeeked(e));
    }
}
/**
 * The text that should display over the `PlayToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$PlayToggle.prototype.controlText_ = 'Play';
$cb03b711053a4297$var$Component$1.registerComponent('PlayToggle', $cb03b711053a4297$var$PlayToggle);
/**
 * @file time-display.js
 */ /** @import Player from '../../player' */ /**
 * Displays time information about the video
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TimeDisplay extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on(player, [
            'timeupdate',
            'ended',
            'seeking'
        ], (e)=>this.update(e));
        this.updateTextNode_();
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const className = this.buildCSSClass();
        const el = super.createEl('div', {
            className: `${className} vjs-time-control vjs-control`
        });
        const span = $cb03b711053a4297$var$createEl('span', {
            className: 'vjs-control-text',
            textContent: `${this.localize(this.labelText_)}\u00a0`
        }, {
            role: 'presentation'
        });
        el.appendChild(span);
        this.contentEl_ = $cb03b711053a4297$var$createEl('span', {
            className: `${className}-display`
        }, {
            // span elements have no implicit role, but some screen readers (notably VoiceOver)
            // treat them as a break between items in the DOM when using arrow keys
            // (or left-to-right swipes on iOS) to read contents of a page. Using
            // role='presentation' causes VoiceOver to NOT treat this span as a break.
            role: 'presentation'
        });
        el.appendChild(this.contentEl_);
        return el;
    }
    dispose() {
        this.contentEl_ = null;
        this.textNode_ = null;
        super.dispose();
    }
    /**
   * Updates the displayed time according to the `updateContent` function which is defined in the child class.
   *
   * @param {Event} [event]
   *          The `timeupdate`, `ended` or `seeking` (if enableSmoothSeeking is true) event that caused this function to be called.
   */ update(event) {
        if (!this.player_.options_.enableSmoothSeeking && event.type === 'seeking') return;
        this.updateContent(event);
    }
    /**
   * Updates the time display text node with a new time
   *
   * @param {number} [time=0] the time to update to
   *
   * @private
   */ updateTextNode_(time = 0) {
        time = $cb03b711053a4297$var$formatTime(time);
        if (this.formattedTime_ === time) return;
        this.formattedTime_ = time;
        this.requestNamedAnimationFrame('TimeDisplay#updateTextNode_', ()=>{
            if (!this.contentEl_) return;
            let oldNode = this.textNode_;
            if (oldNode && this.contentEl_.firstChild !== oldNode) {
                oldNode = null;
                $cb03b711053a4297$var$log$1.warn('TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.');
            }
            this.textNode_ = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createTextNode(this.formattedTime_);
            if (!this.textNode_) return;
            if (oldNode) this.contentEl_.replaceChild(this.textNode_, oldNode);
            else this.contentEl_.appendChild(this.textNode_);
        });
    }
    /**
   * To be filled out in the child class, should update the displayed time
   * in accordance with the fact that the current time has changed.
   *
   * @param {Event} [event]
   *        The `timeupdate`  event that caused this to run.
   *
   * @listens Player#timeupdate
   */ updateContent(event) {}
}
/**
 * The text that is added to the `TimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$TimeDisplay.prototype.labelText_ = 'Time';
/**
 * The text that should display over the `TimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $cb03b711053a4297$var$TimeDisplay.prototype.controlText_ = 'Time';
$cb03b711053a4297$var$Component$1.registerComponent('TimeDisplay', $cb03b711053a4297$var$TimeDisplay);
/**
 * @file current-time-display.js
 */ /**
 * Displays the current time
 *
 * @extends Component
 */ class $cb03b711053a4297$var$CurrentTimeDisplay extends $cb03b711053a4297$var$TimeDisplay {
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return 'vjs-current-time';
    }
    /**
   * Update current time display
   *
   * @param {Event} [event]
   *        The `timeupdate` event that caused this function to run.
   *
   * @listens Player#timeupdate
   */ updateContent(event) {
        // Allows for smooth scrubbing, when player can't keep up.
        let time;
        if (this.player_.ended()) time = this.player_.duration();
        else if (event && event.target && typeof event.target.pendingSeekTime === 'function') time = event.target.pendingSeekTime();
        else time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
        this.updateTextNode_(time);
    }
}
/**
 * The text that is added to the `CurrentTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$CurrentTimeDisplay.prototype.labelText_ = 'Current Time';
/**
 * The text that should display over the `CurrentTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $cb03b711053a4297$var$CurrentTimeDisplay.prototype.controlText_ = 'Current Time';
$cb03b711053a4297$var$Component$1.registerComponent('CurrentTimeDisplay', $cb03b711053a4297$var$CurrentTimeDisplay);
/**
 * @file duration-display.js
 */ /** @import Player from '../../player' */ /**
 * Displays the duration
 *
 * @extends Component
 */ class $cb03b711053a4297$var$DurationDisplay extends $cb03b711053a4297$var$TimeDisplay {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        const updateContent = (e)=>this.updateContent(e);
        // we do not want to/need to throttle duration changes,
        // as they should always display the changed duration as
        // it has changed
        this.on(player, 'durationchange', updateContent);
        // Listen to loadstart because the player duration is reset when a new media element is loaded,
        // but the durationchange on the user agent will not fire.
        // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
        this.on(player, 'loadstart', updateContent);
        // Also listen for timeupdate (in the parent) and loadedmetadata because removing those
        // listeners could have broken dependent applications/libraries. These
        // can likely be removed for 7.0.
        this.on(player, 'loadedmetadata', updateContent);
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return 'vjs-duration';
    }
    /**
   * Update duration time display.
   *
   * @param {Event} [event]
   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
   *        this function to be called.
   *
   * @listens Player#durationchange
   * @listens Player#timeupdate
   * @listens Player#loadedmetadata
   */ updateContent(event) {
        const duration = this.player_.duration();
        this.updateTextNode_(duration);
    }
}
/**
 * The text that is added to the `DurationDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$DurationDisplay.prototype.labelText_ = 'Duration';
/**
 * The text that should display over the `DurationDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $cb03b711053a4297$var$DurationDisplay.prototype.controlText_ = 'Duration';
$cb03b711053a4297$var$Component$1.registerComponent('DurationDisplay', $cb03b711053a4297$var$DurationDisplay);
/**
 * @file time-divider.js
 */ /**
 * The separator between the current time and duration.
 * Can be hidden if it's not needed in the design.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TimeDivider extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create the component's DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl('div', {
            className: 'vjs-time-control vjs-time-divider'
        }, {
            // this element and its contents can be hidden from assistive techs since
            // it is made extraneous by the announcement of the control text
            // for the current time and duration displays
            'aria-hidden': true
        });
        const div = super.createEl('div');
        const span = super.createEl('span', {
            textContent: '/'
        });
        div.appendChild(span);
        el.appendChild(div);
        return el;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TimeDivider', $cb03b711053a4297$var$TimeDivider);
/**
 * @file remaining-time-display.js
 */ /** @import Player from '../../player' */ /**
 * Displays the time left in the video
 *
 * @extends Component
 */ class $cb03b711053a4297$var$RemainingTimeDisplay extends $cb03b711053a4297$var$TimeDisplay {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on(player, 'durationchange', (e)=>this.updateContent(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return 'vjs-remaining-time';
    }
    /**
   * Create the `Component`'s DOM element with the "minus" character prepend to the time
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl();
        if (this.options_.displayNegative !== false) el.insertBefore($cb03b711053a4297$var$createEl('span', {}, {
            'aria-hidden': true
        }, '-'), this.contentEl_);
        return el;
    }
    /**
   * Update remaining time display.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `durationchange` event that caused this to run.
   *
   * @listens Player#timeupdate
   * @listens Player#durationchange
   */ updateContent(event) {
        if (typeof this.player_.duration() !== 'number') return;
        let time;
        // @deprecated We should only use remainingTimeDisplay
        // as of video.js 7
        if (this.player_.ended()) time = 0;
        else if (this.player_.remainingTimeDisplay) time = this.player_.remainingTimeDisplay();
        else time = this.player_.remainingTime();
        this.updateTextNode_(time);
    }
}
/**
 * The text that is added to the `RemainingTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$RemainingTimeDisplay.prototype.labelText_ = 'Remaining Time';
/**
 * The text that should display over the `RemainingTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $cb03b711053a4297$var$RemainingTimeDisplay.prototype.controlText_ = 'Remaining Time';
$cb03b711053a4297$var$Component$1.registerComponent('RemainingTimeDisplay', $cb03b711053a4297$var$RemainingTimeDisplay);
/**
 * @file live-display.js
 */ /** @import Player from './player' */ // TODO - Future make it click to snap to live
/**
 * Displays the live indicator when duration is Infinity.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$LiveDisplay extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.updateShowing();
        this.on(this.player(), 'durationchange', (e)=>this.updateShowing(e));
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl('div', {
            className: 'vjs-live-control vjs-control'
        });
        this.contentEl_ = $cb03b711053a4297$var$createEl('div', {
            className: 'vjs-live-display'
        }, {
            'aria-live': 'off'
        });
        this.contentEl_.appendChild($cb03b711053a4297$var$createEl('span', {
            className: 'vjs-control-text',
            textContent: `${this.localize('Stream Type')}\u00a0`
        }));
        this.contentEl_.appendChild((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createTextNode(this.localize('LIVE')));
        el.appendChild(this.contentEl_);
        return el;
    }
    dispose() {
        this.contentEl_ = null;
        super.dispose();
    }
    /**
   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
   * it accordingly
   *
   * @param {Event} [event]
   *        The {@link Player#durationchange} event that caused this function to run.
   *
   * @listens Player#durationchange
   */ updateShowing(event) {
        if (this.player().duration() === Infinity) this.show();
        else this.hide();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('LiveDisplay', $cb03b711053a4297$var$LiveDisplay);
/**
 * @file seek-to-live.js
 */ /** @import Player from './player' */ /**
 * Displays the live indicator when duration is Infinity.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$SeekToLive extends $cb03b711053a4297$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.updateLiveEdgeStatus();
        if (this.player_.liveTracker) {
            this.updateLiveEdgeStatusHandler_ = (e)=>this.updateLiveEdgeStatus(e);
            this.on(this.player_.liveTracker, 'liveedgechange', this.updateLiveEdgeStatusHandler_);
        }
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl('button', {
            className: 'vjs-seek-to-live-control vjs-control'
        });
        this.setIcon('circle', el);
        this.textEl_ = $cb03b711053a4297$var$createEl('span', {
            className: 'vjs-seek-to-live-text',
            textContent: this.localize('LIVE')
        }, {
            'aria-hidden': 'true'
        });
        el.appendChild(this.textEl_);
        return el;
    }
    /**
   * Update the state of this button if we are at the live edge
   * or not
   */ updateLiveEdgeStatus() {
        // default to live edge
        if (!this.player_.liveTracker || this.player_.liveTracker.atLiveEdge()) {
            this.setAttribute('aria-disabled', true);
            this.addClass('vjs-at-live-edge');
            this.controlText('Seek to live, currently playing live');
        } else {
            this.setAttribute('aria-disabled', false);
            this.removeClass('vjs-at-live-edge');
            this.controlText('Seek to live, currently behind live');
        }
    }
    /**
   * On click bring us as near to the live point as possible.
   * This requires that we wait for the next `live-seekable-change`
   * event which will happen every segment length seconds.
   */ handleClick() {
        this.player_.liveTracker.seekToLiveEdge();
    }
    /**
   * Dispose of the element and stop tracking
   */ dispose() {
        if (this.player_.liveTracker) this.off(this.player_.liveTracker, 'liveedgechange', this.updateLiveEdgeStatusHandler_);
        this.textEl_ = null;
        super.dispose();
    }
}
/**
 * The text that should display over the `SeekToLive`s control. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$SeekToLive.prototype.controlText_ = 'Seek to live, currently playing live';
$cb03b711053a4297$var$Component$1.registerComponent('SeekToLive', $cb03b711053a4297$var$SeekToLive);
/**
 * @file num.js
 * @module num
 */ /**
 * Keep a number between a min and a max value
 *
 * @param {number} number
 *        The number to clamp
 *
 * @param {number} min
 *        The minimum value
 * @param {number} max
 *        The maximum value
 *
 * @return {number}
 *         the clamped number
 */ function $cb03b711053a4297$var$clamp(number, min, max) {
    number = Number(number);
    return Math.min(max, Math.max(min, isNaN(number) ? min : number));
}
var $cb03b711053a4297$var$Num = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    clamp: $cb03b711053a4297$var$clamp
});
/**
 * @file slider.js
 */ /** @import Player from '../player' */ /**
 * The base functionality for a slider. Can be vertical or horizontal.
 * For instance the volume bar or the seek bar on a video is a slider.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$Slider extends $cb03b711053a4297$var$Component$1 {
    /**
  * Create an instance of this class
  *
  * @param {Player} player
  *        The `Player` that this class should be attached to.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  */ constructor(player, options){
        super(player, options);
        this.handleMouseDown_ = (e)=>this.handleMouseDown(e);
        this.handleMouseUp_ = (e)=>this.handleMouseUp(e);
        this.handleKeyDown_ = (e)=>this.handleKeyDown(e);
        this.handleClick_ = (e)=>this.handleClick(e);
        this.handleMouseMove_ = (e)=>this.handleMouseMove(e);
        this.update_ = (e)=>this.update(e);
        // Set property names to bar to match with the child Slider class is looking for
        this.bar = this.getChild(this.options_.barName);
        // Set a horizontal or vertical class on the slider depending on the slider type
        this.vertical(!!this.options_.vertical);
        this.enable();
    }
    /**
   * Are controls are currently enabled for this slider or not.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */ enabled() {
        return this.enabled_;
    }
    /**
   * Enable controls for this slider if they are disabled
   */ enable() {
        if (this.enabled()) return;
        this.on('mousedown', this.handleMouseDown_);
        this.on('touchstart', this.handleMouseDown_);
        this.on('keydown', this.handleKeyDown_);
        this.on('click', this.handleClick_);
        // TODO: deprecated, controlsvisible does not seem to be fired
        this.on(this.player_, 'controlsvisible', this.update);
        if (this.playerEvent) this.on(this.player_, this.playerEvent, this.update);
        this.removeClass('disabled');
        this.setAttribute('tabindex', 0);
        this.enabled_ = true;
    }
    /**
   * Disable controls for this slider if they are enabled
   */ disable() {
        if (!this.enabled()) return;
        const doc = this.bar.el_.ownerDocument;
        this.off('mousedown', this.handleMouseDown_);
        this.off('touchstart', this.handleMouseDown_);
        this.off('keydown', this.handleKeyDown_);
        this.off('click', this.handleClick_);
        this.off(this.player_, 'controlsvisible', this.update_);
        this.off(doc, 'mousemove', this.handleMouseMove_);
        this.off(doc, 'mouseup', this.handleMouseUp_);
        this.off(doc, 'touchmove', this.handleMouseMove_);
        this.off(doc, 'touchend', this.handleMouseUp_);
        this.removeAttribute('tabindex');
        this.addClass('disabled');
        if (this.playerEvent) this.off(this.player_, this.playerEvent, this.update);
        this.enabled_ = false;
    }
    /**
   * Create the `Slider`s DOM element.
   *
   * @param {string} type
   *        Type of element to create.
   *
   * @param {Object} [props={}]
   *        List of properties in Object form.
   *
   * @param {Object} [attributes={}]
   *        list of attributes in Object form.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(type, props = {}, attributes = {}) {
        // Add the slider element class to all sub classes
        props.className = props.className + ' vjs-slider';
        props = Object.assign({
            tabIndex: 0
        }, props);
        attributes = Object.assign({
            'role': 'slider',
            'aria-valuenow': 0,
            'aria-valuemin': 0,
            'aria-valuemax': 100
        }, attributes);
        return super.createEl(type, props, attributes);
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   * @fires Slider#slideractive
   */ handleMouseDown(event) {
        const doc = this.bar.el_.ownerDocument;
        if (event.type === 'mousedown') event.preventDefault();
        // Do not call preventDefault() on touchstart in Chrome
        // to avoid console warnings. Use a 'touch-action: none' style
        // instead to prevent unintended scrolling.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        if (event.type === 'touchstart' && !$cb03b711053a4297$var$IS_CHROME) event.preventDefault();
        $cb03b711053a4297$var$blockTextSelection();
        this.addClass('vjs-sliding');
        /**
     * Triggered when the slider is in an active state
     *
     * @event Slider#slideractive
     * @type {MouseEvent}
     */ this.trigger('slideractive');
        this.on(doc, 'mousemove', this.handleMouseMove_);
        this.on(doc, 'mouseup', this.handleMouseUp_);
        this.on(doc, 'touchmove', this.handleMouseMove_);
        this.on(doc, 'touchend', this.handleMouseUp_);
        this.handleMouseMove(event, true);
    }
    /**
   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
   * The `mousemove` and `touchmove` events will only only trigger this function during
   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
   * {@link Slider#handleMouseUp}.
   *
   * @param {MouseEvent} event
   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
   *        this function
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
   *
   * @listens mousemove
   * @listens touchmove
   */ handleMouseMove(event) {}
    /**
   * Handle `mouseup` or `touchend` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   * @fires Slider#sliderinactive
   */ handleMouseUp(event) {
        const doc = this.bar.el_.ownerDocument;
        $cb03b711053a4297$var$unblockTextSelection();
        this.removeClass('vjs-sliding');
        /**
     * Triggered when the slider is no longer in an active state.
     *
     * @event Slider#sliderinactive
     * @type {Event}
     */ this.trigger('sliderinactive');
        this.off(doc, 'mousemove', this.handleMouseMove_);
        this.off(doc, 'mouseup', this.handleMouseUp_);
        this.off(doc, 'touchmove', this.handleMouseMove_);
        this.off(doc, 'touchend', this.handleMouseUp_);
        this.update();
    }
    /**
   * Update the progress bar of the `Slider`.
   *
   * @return {number}
   *          The percentage of progress the progress bar represents as a
   *          number from 0 to 1.
   */ update() {
        // In VolumeBar init we have a setTimeout for update that pops and update
        // to the end of the execution stack. The player is destroyed before then
        // update will cause an error
        // If there's no bar...
        if (!this.el_ || !this.bar) return;
        // clamp progress between 0 and 1
        // and only round to four decimal places, as we round to two below
        const progress = this.getProgress();
        if (progress === this.progress_) return progress;
        this.progress_ = progress;
        this.requestNamedAnimationFrame('Slider#update', ()=>{
            // Set the new bar width or height
            const sizeKey = this.vertical() ? 'height' : 'width';
            // Convert to a percentage for css value
            this.bar.el().style[sizeKey] = (progress * 100).toFixed(2) + '%';
        });
        return progress;
    }
    /**
   * Get the percentage of the bar that should be filled
   * but clamped and rounded.
   *
   * @return {number}
   *         percentage filled that the slider is
   */ getProgress() {
        return Number($cb03b711053a4297$var$clamp(this.getPercent(), 0, 1).toFixed(4));
    }
    /**
   * Calculate distance for slider
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @return {number}
   *         The current position of the Slider.
   *         - position.x for vertical `Slider`s
   *         - position.y for horizontal `Slider`s
   */ calculateDistance(event) {
        const position = $cb03b711053a4297$var$getPointerPosition(this.el_, event);
        if (this.vertical()) return position.y;
        return position.x;
    }
    /**
   * Handle a `keydown` event on the `Slider`. Watches for left, right, up, and down
   * arrow keys. This function will only be called when the slider has focus. See
   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
   *
   * @param {KeyboardEvent} event
   *        the `keydown` event that caused this function to run.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        const spatialNavOptions = this.options_.playerOptions.spatialNavigation;
        const spatialNavEnabled = spatialNavOptions && spatialNavOptions.enabled;
        const horizontalSeek = spatialNavOptions && spatialNavOptions.horizontalSeek;
        if (spatialNavEnabled) {
            if (horizontalSeek && event.key === 'ArrowLeft' || !horizontalSeek && event.key === 'ArrowDown') {
                event.preventDefault();
                event.stopPropagation();
                this.stepBack();
            } else if (horizontalSeek && event.key === 'ArrowRight' || !horizontalSeek && event.key === 'ArrowUp') {
                event.preventDefault();
                event.stopPropagation();
                this.stepForward();
            } else {
                if (this.pendingSeekTime()) {
                    this.pendingSeekTime(null);
                    this.userSeek_(this.player_.currentTime());
                }
                super.handleKeyDown(event);
            }
        // Left and Down Arrows
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
            event.preventDefault();
            event.stopPropagation();
            this.stepBack();
        // Up and Right Arrows
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowRight') {
            event.preventDefault();
            event.stopPropagation();
            this.stepForward();
        } else // Pass keydown handling up for unsupported keys
        super.handleKeyDown(event);
    }
    /**
   * Listener for click events on slider, used to prevent clicks
   *   from bubbling up to parent elements like button menus.
   *
   * @param {Object} event
   *        Event that caused this object to run
   */ handleClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    /**
   * Get/set if slider is horizontal for vertical
   *
   * @param {boolean} [bool]
   *        - true if slider is vertical,
   *        - false is horizontal
   *
   * @return {boolean}
   *         - true if slider is vertical, and getting
   *         - false if the slider is horizontal, and getting
   */ vertical(bool) {
        if (bool === undefined) return this.vertical_ || false;
        this.vertical_ = !!bool;
        if (this.vertical_) this.addClass('vjs-slider-vertical');
        else this.addClass('vjs-slider-horizontal');
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('Slider', $cb03b711053a4297$var$Slider);
/**
 * @file load-progress-bar.js
 */ /** @import Player from '../../player' */ // get the percent width of a time compared to the total end
const $cb03b711053a4297$var$percentify = (time, end)=>$cb03b711053a4297$var$clamp(time / end * 100, 0, 100).toFixed(2) + '%';
/**
 * Shows loading progress
 *
 * @extends Component
 */ class $cb03b711053a4297$var$LoadProgressBar extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.partEls_ = [];
        this.on(player, 'progress', (e)=>this.update(e));
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl('div', {
            className: 'vjs-load-progress'
        });
        const wrapper = $cb03b711053a4297$var$createEl('span', {
            className: 'vjs-control-text'
        });
        const loadedText = $cb03b711053a4297$var$createEl('span', {
            textContent: this.localize('Loaded')
        });
        const separator = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createTextNode(': ');
        this.percentageEl_ = $cb03b711053a4297$var$createEl('span', {
            className: 'vjs-control-text-loaded-percentage',
            textContent: '0%'
        });
        el.appendChild(wrapper);
        wrapper.appendChild(loadedText);
        wrapper.appendChild(separator);
        wrapper.appendChild(this.percentageEl_);
        return el;
    }
    dispose() {
        this.partEls_ = null;
        this.percentageEl_ = null;
        super.dispose();
    }
    /**
   * Update progress bar
   *
   * @param {Event} [event]
   *        The `progress` event that caused this function to run.
   *
   * @listens Player#progress
   */ update(event) {
        this.requestNamedAnimationFrame('LoadProgressBar#update', ()=>{
            const liveTracker = this.player_.liveTracker;
            const buffered = this.player_.buffered();
            const duration = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : this.player_.duration();
            const bufferedEnd = this.player_.bufferedEnd();
            const children = this.partEls_;
            const percent = $cb03b711053a4297$var$percentify(bufferedEnd, duration);
            if (this.percent_ !== percent) {
                // update the width of the progress bar
                this.el_.style.width = percent;
                // update the control-text
                $cb03b711053a4297$var$textContent(this.percentageEl_, percent);
                this.percent_ = percent;
            }
            // add child elements to represent the individual buffered time ranges
            for(let i = 0; i < buffered.length; i++){
                const start = buffered.start(i);
                const end = buffered.end(i);
                let part = children[i];
                if (!part) {
                    part = this.el_.appendChild($cb03b711053a4297$var$createEl());
                    children[i] = part;
                }
                //  only update if changed
                if (part.dataset.start === start && part.dataset.end === end) continue;
                part.dataset.start = start;
                part.dataset.end = end;
                // set the percent based on the width of the progress bar (bufferedEnd)
                part.style.left = $cb03b711053a4297$var$percentify(start, bufferedEnd);
                part.style.width = $cb03b711053a4297$var$percentify(end - start, bufferedEnd);
            }
            // remove unused buffered range elements
            for(let i = children.length; i > buffered.length; i--)this.el_.removeChild(children[i - 1]);
            children.length = buffered.length;
        });
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('LoadProgressBar', $cb03b711053a4297$var$LoadProgressBar);
/**
 * @file time-tooltip.js
 */ /** @import Player from '../../player' */ /**
 * Time tooltips display a time above the progress bar.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TimeTooltip extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.update), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the time tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-time-tooltip'
        }, {
            'aria-hidden': 'true'
        });
    }
    /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */ update(seekBarRect, seekBarPoint, content) {
        const tooltipRect = $cb03b711053a4297$var$findPosition(this.el_);
        const playerRect = $cb03b711053a4297$var$getBoundingClientRect(this.player_.el());
        const seekBarPointPx = seekBarRect.width * seekBarPoint;
        // do nothing if either rect isn't available
        // for example, if the player isn't in the DOM for testing
        if (!playerRect || !tooltipRect) return;
        // This is the space left of the `seekBarPoint` available within the bounds
        // of the player. We calculate any gap between the left edge of the player
        // and the left edge of the `SeekBar` and add the number of pixels in the
        // `SeekBar` before hitting the `seekBarPoint`
        let spaceLeftOfPoint = seekBarRect.left - playerRect.left + seekBarPointPx;
        // This is the space right of the `seekBarPoint` available within the bounds
        // of the player. We calculate the number of pixels from the `seekBarPoint`
        // to the right edge of the `SeekBar` and add to that any gap between the
        // right edge of the `SeekBar` and the player.
        let spaceRightOfPoint = seekBarRect.width - seekBarPointPx + (playerRect.right - seekBarRect.right);
        // spaceRightOfPoint is always NaN for mouse time display
        // because the seekbarRect does not have a right property. This causes
        // the mouse tool tip to be truncated when it's close to the right edge of the player.
        // In such cases, we ignore the `playerRect.right - seekBarRect.right` value when calculating.
        // For the sake of consistency, we ignore seekBarRect.left - playerRect.left for the left edge.
        if (!spaceRightOfPoint) {
            spaceRightOfPoint = seekBarRect.width - seekBarPointPx;
            spaceLeftOfPoint = seekBarPointPx;
        }
        // This is the number of pixels by which the tooltip will need to be pulled
        // further to the right to center it over the `seekBarPoint`.
        let pullTooltipBy = tooltipRect.width / 2;
        // Adjust the `pullTooltipBy` distance to the left or right depending on
        // the results of the space calculations above.
        if (spaceLeftOfPoint < pullTooltipBy) pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
        else if (spaceRightOfPoint < pullTooltipBy) pullTooltipBy = spaceRightOfPoint;
        // Due to the imprecision of decimal/ratio based calculations and varying
        // rounding behaviors, there are cases where the spacing adjustment is off
        // by a pixel or two. This adds insurance to these calculations.
        if (pullTooltipBy < 0) pullTooltipBy = 0;
        else if (pullTooltipBy > tooltipRect.width) pullTooltipBy = tooltipRect.width;
        // prevent small width fluctuations within 0.4px from
        // changing the value below.
        // This really helps for live to prevent the play
        // progress time tooltip from jittering
        pullTooltipBy = Math.round(pullTooltipBy);
        this.el_.style.right = `-${pullTooltipBy}px`;
        this.write(content);
    }
    /**
   * Write the time to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted time for the tooltip.
   */ write(content) {
        $cb03b711053a4297$var$textContent(this.el_, content);
    }
    /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {number} time
   *        The time to update the tooltip to, not used during live playback
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */ updateTime(seekBarRect, seekBarPoint, time, cb) {
        this.requestNamedAnimationFrame('TimeTooltip#updateTime', ()=>{
            let content;
            const duration = this.player_.duration();
            if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
                const liveWindow = this.player_.liveTracker.liveWindow();
                const secondsBehind = liveWindow - seekBarPoint * liveWindow;
                content = (secondsBehind < 1 ? '' : '-') + $cb03b711053a4297$var$formatTime(secondsBehind, liveWindow);
            } else content = $cb03b711053a4297$var$formatTime(time, duration);
            this.update(seekBarRect, seekBarPoint, content);
            if (cb) cb();
        });
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TimeTooltip', $cb03b711053a4297$var$TimeTooltip);
/**
 * @file play-progress-bar.js
 */ /**
 * Used by {@link SeekBar} to display media playback progress as part of the
 * {@link ProgressControl}.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$PlayProgressBar extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.setIcon('circle');
        this.update = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.update), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-play-progress vjs-slider-bar'
        }, {
            'aria-hidden': 'true'
        });
    }
    /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {Event} [event]
   *        The `timeupdate` event that caused this function to run.
   */ update(seekBarRect, seekBarPoint, event) {
        const timeTooltip = this.getChild('timeTooltip');
        if (!timeTooltip) return;
        // Combined logic: if an event with a valid pendingSeekTime getter exists, use it.
        const time = event && event.target && typeof event.target.pendingSeekTime === 'function' ? event.target.pendingSeekTime() : this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
        timeTooltip.updateTime(seekBarRect, seekBarPoint, time);
    }
}
/**
 * Default options for {@link PlayProgressBar}.
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$PlayProgressBar.prototype.options_ = {
    children: []
};
// Time tooltips should not be added to a player on mobile devices
if (!$cb03b711053a4297$var$IS_IOS && !$cb03b711053a4297$var$IS_ANDROID) $cb03b711053a4297$var$PlayProgressBar.prototype.options_.children.push('timeTooltip');
$cb03b711053a4297$var$Component$1.registerComponent('PlayProgressBar', $cb03b711053a4297$var$PlayProgressBar);
/**
 * @file mouse-time-display.js
 */ /**
 * The {@link MouseTimeDisplay} component tracks mouse movement over the
 * {@link ProgressControl}. It displays an indicator and a {@link TimeTooltip}
 * indicating the time which is represented by a given point in the
 * {@link ProgressControl}.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$MouseTimeDisplay extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.update), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-mouse-display'
        });
    }
    /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */ update(seekBarRect, seekBarPoint) {
        const time = seekBarPoint * this.player_.duration();
        this.getChild('timeTooltip').updateTime(seekBarRect, seekBarPoint, time, ()=>{
            this.el_.style.left = `${seekBarRect.width * seekBarPoint}px`;
        });
    }
}
/**
 * Default options for `MouseTimeDisplay`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$MouseTimeDisplay.prototype.options_ = {
    children: [
        'timeTooltip'
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent('MouseTimeDisplay', $cb03b711053a4297$var$MouseTimeDisplay);
/**
 * @file seek-bar.js
 */ /**
 * Seek bar and container for the progress bars. Uses {@link PlayProgressBar}
 * as its `bar`.
 *
 * @extends Slider
 */ class $cb03b711053a4297$var$SeekBar extends $cb03b711053a4297$var$Slider {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   * @param {number} [options.stepSeconds=5]
   *        The number of seconds to increment on keyboard control
   * @param {number} [options.pageMultiplier=12]
   *        The multiplier of stepSeconds that PgUp/PgDown move the timeline.
   */ constructor(player, options){
        options = $cb03b711053a4297$var$merge$1($cb03b711053a4297$var$SeekBar.prototype.options_, options);
        // Avoid mutating the prototype's `children` array by creating a copy
        options.children = [
            ...options.children
        ];
        const shouldDisableSeekWhileScrubbing = player.options_.disableSeekWhileScrubbingOnMobile && ($cb03b711053a4297$var$IS_IOS || $cb03b711053a4297$var$IS_ANDROID) || player.options_.disableSeekWhileScrubbingOnSTV;
        // Add the TimeTooltip as a child if we are on desktop, or on mobile with `disableSeekWhileScrubbingOnMobile: true`
        if (!$cb03b711053a4297$var$IS_IOS && !$cb03b711053a4297$var$IS_ANDROID || shouldDisableSeekWhileScrubbing) options.children.splice(1, 0, 'mouseTimeDisplay');
        super(player, options);
        this.shouldDisableSeekWhileScrubbing_ = shouldDisableSeekWhileScrubbing;
        this.pendingSeekTime_ = null;
        this.setEventHandlers_();
    }
    /**
   * Sets the event handlers
   *
   * @private
   */ setEventHandlers_() {
        this.update_ = $cb03b711053a4297$var$bind_(this, this.update);
        this.update = $cb03b711053a4297$var$throttle(this.update_, $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
        this.on(this.player_, [
            'durationchange',
            'timeupdate'
        ], this.update);
        this.on(this.player_, [
            'ended'
        ], this.update_);
        if (this.player_.liveTracker) this.on(this.player_.liveTracker, 'liveedgechange', this.update);
        // when playing, let's ensure we smoothly update the play progress bar
        // via an interval
        this.updateInterval = null;
        this.enableIntervalHandler_ = (e)=>this.enableInterval_(e);
        this.disableIntervalHandler_ = (e)=>this.disableInterval_(e);
        this.on(this.player_, [
            'playing'
        ], this.enableIntervalHandler_);
        this.on(this.player_, [
            'ended',
            'pause',
            'waiting'
        ], this.disableIntervalHandler_);
        // we don't need to update the play progress if the document is hidden,
        // also, this causes the CPU to spike and eventually crash the page on IE11.
        if ('hidden' in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) && 'visibilityState' in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))) this.on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), 'visibilitychange', this.toggleVisibility_);
    }
    toggleVisibility_(e) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).visibilityState === 'hidden') {
            this.cancelNamedAnimationFrame('SeekBar#update');
            this.cancelNamedAnimationFrame('Slider#update');
            this.disableInterval_(e);
        } else {
            if (!this.player_.ended() && !this.player_.paused()) this.enableInterval_();
            // we just switched back to the page and someone may be looking, so, update ASAP
            this.update();
        }
    }
    enableInterval_() {
        if (this.updateInterval) return;
        this.updateInterval = this.setInterval(this.update, $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    disableInterval_(e) {
        if (this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== 'ended') return;
        if (!this.updateInterval) return;
        this.clearInterval(this.updateInterval);
        this.updateInterval = null;
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-progress-holder'
        }, {
            'aria-label': this.localize('Progress Bar')
        });
    }
    /**
   * This function updates the play progress bar and accessibility
   * attributes to whatever is passed in.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#timeupdate
   *
   * @return {number}
   *          The current percent at a number from 0-1
   */ update(event) {
        // ignore updates while the tab is hidden
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).visibilityState === 'hidden') return;
        const percent = super.update();
        this.requestNamedAnimationFrame('SeekBar#update', ()=>{
            const currentTime = this.player_.ended() ? this.player_.duration() : this.getCurrentTime_();
            const liveTracker = this.player_.liveTracker;
            let duration = this.player_.duration();
            if (liveTracker && liveTracker.isLive()) duration = this.player_.liveTracker.liveCurrentTime();
            if (this.percent_ !== percent) {
                // machine readable value of progress bar (percentage complete)
                this.el_.setAttribute('aria-valuenow', (percent * 100).toFixed(2));
                this.percent_ = percent;
            }
            if (this.currentTime_ !== currentTime || this.duration_ !== duration) {
                // human readable value of progress bar (time complete)
                this.el_.setAttribute('aria-valuetext', this.localize('progress bar timing: currentTime={1} duration={2}', [
                    $cb03b711053a4297$var$formatTime(currentTime, duration),
                    $cb03b711053a4297$var$formatTime(duration, duration)
                ], '{1} of {2}'));
                this.currentTime_ = currentTime;
                this.duration_ = duration;
            }
            // update the progress bar time tooltip with the current time
            if (this.bar) this.bar.update($cb03b711053a4297$var$getBoundingClientRect(this.el()), this.getProgress(), event);
        });
        return percent;
    }
    /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */ userSeek_(ct) {
        if (this.player_.liveTracker && this.player_.liveTracker.isLive()) this.player_.liveTracker.nextSeekedFromUser();
        this.player_.currentTime(ct);
    }
    /**
   * Get the value of current time but allows for smooth scrubbing,
   * when player can't keep up.
   *
   * @return {number}
   *         The current time value to display
   *
   * @private
   */ getCurrentTime_() {
        return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
    }
    /**
   * Getter and setter for pendingSeekTime.
   * Ensures the value is clamped between 0 and duration.
   *
   * @param {number|null} [time] - Optional. The new pending seek time, can be a number or null.
   * @return {number|null} - The current pending seek time.
   */ pendingSeekTime(time) {
        if (time !== undefined) {
            if (time !== null) {
                const duration = this.player_.duration();
                this.pendingSeekTime_ = Math.max(0, Math.min(time, duration));
            } else this.pendingSeekTime_ = null;
        }
        return this.pendingSeekTime_;
    }
    /**
   * Get the percentage of media played so far.
   *
   * @return {number}
   *         The percentage of media played so far (0 to 1).
   */ getPercent() {
        // If we have a pending seek time, we are scrubbing on mobile and should set the slider percent
        // to reflect the current scrub location.
        if (this.pendingSeekTime() !== null) return this.pendingSeekTime() / this.player_.duration();
        const currentTime = this.getCurrentTime_();
        let percent;
        const liveTracker = this.player_.liveTracker;
        if (liveTracker && liveTracker.isLive()) {
            percent = (currentTime - liveTracker.seekableStart()) / liveTracker.liveWindow();
            // prevent the percent from changing at the live edge
            if (liveTracker.atLiveEdge()) percent = 1;
        } else percent = currentTime / this.player_.duration();
        return percent;
    }
    /**
   * Handle mouse down on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */ handleMouseDown(event) {
        if (!$cb03b711053a4297$var$isSingleLeftClick(event)) return;
        // Stop event propagation to prevent double fire in progress-control.js
        event.stopPropagation();
        this.videoWasPlaying = !this.player_.paused();
        // Don't pause if we are on mobile and `disableSeekWhileScrubbingOnMobile: true`.
        // In that case, playback should continue while the player scrubs to a new location.
        if (!this.shouldDisableSeekWhileScrubbing_) this.player_.pause();
        super.handleMouseDown(event);
    }
    /**
   * Handle mouse move on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousemove` event that caused this to run.
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
   *
   * @listens mousemove
   */ handleMouseMove(event, mouseDown = false) {
        if (!$cb03b711053a4297$var$isSingleLeftClick(event) || isNaN(this.player_.duration())) return;
        if (!mouseDown && !this.player_.scrubbing()) this.player_.scrubbing(true);
        let newTime;
        const distance = this.calculateDistance(event);
        const liveTracker = this.player_.liveTracker;
        if (!liveTracker || !liveTracker.isLive()) {
            newTime = distance * this.player_.duration();
            // Don't let video end while scrubbing.
            if (newTime === this.player_.duration()) newTime = newTime - 0.1;
        } else {
            if (distance >= 0.99) {
                liveTracker.seekToLiveEdge();
                return;
            }
            const seekableStart = liveTracker.seekableStart();
            const seekableEnd = liveTracker.liveCurrentTime();
            newTime = seekableStart + distance * liveTracker.liveWindow();
            // Don't let video end while scrubbing.
            if (newTime >= seekableEnd) newTime = seekableEnd;
            // Compensate for precision differences so that currentTime is not less
            // than seekable start
            if (newTime <= seekableStart) newTime = seekableStart + 0.1;
            // On android seekableEnd can be Infinity sometimes,
            // this will cause newTime to be Infinity, which is
            // not a valid currentTime.
            if (newTime === Infinity) return;
        }
        // if on mobile and `disableSeekWhileScrubbingOnMobile: true`, keep track of the desired seek point but we won't initiate the seek until 'touchend'
        if (this.shouldDisableSeekWhileScrubbing_) this.pendingSeekTime(newTime);
        else this.userSeek_(newTime);
        if (this.player_.options_.enableSmoothSeeking) this.update();
    }
    enable() {
        super.enable();
        const mouseTimeDisplay = this.getChild('mouseTimeDisplay');
        if (!mouseTimeDisplay) return;
        mouseTimeDisplay.show();
    }
    disable() {
        super.disable();
        const mouseTimeDisplay = this.getChild('mouseTimeDisplay');
        if (!mouseTimeDisplay) return;
        mouseTimeDisplay.hide();
    }
    /**
   * Handle mouse up on seek bar
   *
   * @param {MouseEvent} event
   *        The `mouseup` event that caused this to run.
   *
   * @listens mouseup
   */ handleMouseUp(event) {
        super.handleMouseUp(event);
        // Stop event propagation to prevent double fire in progress-control.js
        if (event) event.stopPropagation();
        this.player_.scrubbing(false);
        // If we have a pending seek time, then we have finished scrubbing on mobile and should initiate a seek.
        if (this.pendingSeekTime() !== null) {
            this.userSeek_(this.pendingSeekTime());
            this.pendingSeekTime(null);
        }
        /**
     * Trigger timeupdate because we're done seeking and the time has changed.
     * This is particularly useful for if the player is paused to time the time displays.
     *
     * @event Tech#timeupdate
     * @type {Event}
     */ this.player_.trigger({
            type: 'timeupdate',
            target: this,
            manuallyTriggered: true
        });
        if (this.videoWasPlaying) $cb03b711053a4297$var$silencePromise(this.player_.play());
        else // We're done seeking and the time has changed.
        // If the player is paused, make sure we display the correct time on the seek bar.
        this.update_();
    }
    /**
   * Handles pending seek time when `disableSeekWhileScrubbingOnSTV` is enabled.
   *
   * @param {number} stepAmount - The number of seconds to step (positive for forward, negative for backward).
   */ handlePendingSeek_(stepAmount) {
        if (!this.player_.paused()) this.player_.pause();
        const currentPos = this.pendingSeekTime() !== null ? this.pendingSeekTime() : this.player_.currentTime();
        this.pendingSeekTime(currentPos + stepAmount);
        this.player_.trigger({
            type: 'timeupdate',
            target: this,
            manuallyTriggered: true
        });
    }
    /**
   * Move more quickly fast forward for keyboard-only users
   */ stepForward() {
        // if `disableSeekWhileScrubbingOnSTV: true`, keep track of the desired seek point but we won't initiate the seek
        if (this.shouldDisableSeekWhileScrubbing_) this.handlePendingSeek_(this.options().stepSeconds);
        else this.userSeek_(this.player_.currentTime() + this.options().stepSeconds);
    }
    /**
   * Move more quickly rewind for keyboard-only users
   */ stepBack() {
        // if `disableSeekWhileScrubbingOnSTV: true`, keep track of the desired seek point but we won't initiate the seek
        if (this.shouldDisableSeekWhileScrubbing_) this.handlePendingSeek_(-this.options().stepSeconds);
        else this.userSeek_(this.player_.currentTime() - this.options().stepSeconds);
    }
    /**
   * Toggles the playback state of the player
   * This gets called when enter or space is used on the seekbar
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called
   *
   */ handleAction(event) {
        if (this.pendingSeekTime() !== null) {
            this.userSeek_(this.pendingSeekTime());
            this.pendingSeekTime(null);
        }
        if (this.player_.paused()) this.player_.play();
        else this.player_.pause();
    }
    /**
   * Called when this SeekBar has focus and a key gets pressed down.
   * Supports the following keys:
   *
   *   Space or Enter key fire a click event
   *   Home key moves to start of the timeline
   *   End key moves to end of the timeline
   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
   *   PageDown key moves back a larger step than ArrowDown
   *   PageUp key moves forward a large step
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        const liveTracker = this.player_.liveTracker;
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.handleAction(event);
        } else if (event.key === 'Home') {
            event.preventDefault();
            event.stopPropagation();
            this.userSeek_(0);
        } else if (event.key === 'End') {
            event.preventDefault();
            event.stopPropagation();
            if (liveTracker && liveTracker.isLive()) this.userSeek_(liveTracker.liveCurrentTime());
            else this.userSeek_(this.player_.duration());
        } else if (/^[0-9]$/.test(event.key)) {
            event.preventDefault();
            event.stopPropagation();
            const gotoFraction = parseInt(event.key, 10) * 0.1;
            if (liveTracker && liveTracker.isLive()) this.userSeek_(liveTracker.seekableStart() + liveTracker.liveWindow() * gotoFraction);
            else this.userSeek_(this.player_.duration() * gotoFraction);
        } else if (event.key === 'PageDown') {
            event.preventDefault();
            event.stopPropagation();
            this.userSeek_(this.player_.currentTime() - this.options().stepSeconds * this.options().pageMultiplier);
        } else if (event.key === 'PageUp') {
            event.preventDefault();
            event.stopPropagation();
            this.userSeek_(this.player_.currentTime() + this.options().stepSeconds * this.options().pageMultiplier);
        } else // Pass keydown handling up for unsupported keys
        super.handleKeyDown(event);
    }
    dispose() {
        this.disableInterval_();
        this.off(this.player_, [
            'durationchange',
            'timeupdate'
        ], this.update);
        this.off(this.player_, [
            'ended'
        ], this.update_);
        if (this.player_.liveTracker) this.off(this.player_.liveTracker, 'liveedgechange', this.update);
        this.off(this.player_, [
            'playing'
        ], this.enableIntervalHandler_);
        this.off(this.player_, [
            'ended',
            'pause',
            'waiting'
        ], this.disableIntervalHandler_);
        // we don't need to update the play progress if the document is hidden,
        // also, this causes the CPU to spike and eventually crash the page on IE11.
        if ('hidden' in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) && 'visibilityState' in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))) this.off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), 'visibilitychange', this.toggleVisibility_);
        super.dispose();
    }
}
/**
 * Default options for the `SeekBar`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$SeekBar.prototype.options_ = {
    children: [
        'loadProgressBar',
        'playProgressBar'
    ],
    barName: 'playProgressBar',
    stepSeconds: 5,
    pageMultiplier: 12
};
$cb03b711053a4297$var$Component$1.registerComponent('SeekBar', $cb03b711053a4297$var$SeekBar);
/**
 * @file progress-control.js
 */ /**
 * The Progress Control component contains the seek bar, load progress,
 * and play progress.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$ProgressControl extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.handleMouseMove = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.handleMouseMove), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
        this.throttledHandleMouseSeek = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.handleMouseSeek), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
        this.handleMouseUpHandler_ = (e)=>this.handleMouseUp(e);
        this.handleMouseDownHandler_ = (e)=>this.handleMouseDown(e);
        this.enable();
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-progress-control vjs-control'
        });
    }
    /**
   * When the mouse moves over the `ProgressControl`, the pointer position
   * gets passed down to the `MouseTimeDisplay` component.
   *
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   */ handleMouseMove(event) {
        const seekBar = this.getChild('seekBar');
        if (!seekBar) return;
        const playProgressBar = seekBar.getChild('playProgressBar');
        const mouseTimeDisplay = seekBar.getChild('mouseTimeDisplay');
        if (!playProgressBar && !mouseTimeDisplay) return;
        const seekBarEl = seekBar.el();
        const seekBarRect = $cb03b711053a4297$var$findPosition(seekBarEl);
        let seekBarPoint = $cb03b711053a4297$var$getPointerPosition(seekBarEl, event).x;
        // The default skin has a gap on either side of the `SeekBar`. This means
        // that it's possible to trigger this behavior outside the boundaries of
        // the `SeekBar`. This ensures we stay within it at all times.
        seekBarPoint = $cb03b711053a4297$var$clamp(seekBarPoint, 0, 1);
        if (mouseTimeDisplay) mouseTimeDisplay.update(seekBarRect, seekBarPoint);
        if (playProgressBar) playProgressBar.update(seekBarRect, seekBar.getProgress());
    }
    /**
   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
   *
   * @method ProgressControl#throttledHandleMouseSeek
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   * @listen touchmove
   */ /**
   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousemove
   * @listens touchmove
   */ handleMouseSeek(event) {
        const seekBar = this.getChild('seekBar');
        if (seekBar) seekBar.handleMouseMove(event);
    }
    /**
   * Are controls are currently enabled for this progress control.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */ enabled() {
        return this.enabled_;
    }
    /**
   * Disable all controls on the progress control and its children
   */ disable() {
        this.children().forEach((child)=>child.disable && child.disable());
        if (!this.enabled()) return;
        this.off([
            'mousedown',
            'touchstart'
        ], this.handleMouseDownHandler_);
        this.off(this.el_, [
            'mousemove',
            'touchmove'
        ], this.handleMouseMove);
        this.removeListenersAddedOnMousedownAndTouchstart();
        this.addClass('disabled');
        this.enabled_ = false;
        // Restore normal playback state if controls are disabled while scrubbing
        if (this.player_.scrubbing()) {
            const seekBar = this.getChild('seekBar');
            this.player_.scrubbing(false);
            if (seekBar.videoWasPlaying) $cb03b711053a4297$var$silencePromise(this.player_.play());
        }
    }
    /**
   * Enable all controls on the progress control and its children
   */ enable() {
        this.children().forEach((child)=>child.enable && child.enable());
        if (this.enabled()) return;
        this.on([
            'mousedown',
            'touchstart'
        ], this.handleMouseDownHandler_);
        this.on(this.el_, [
            'mousemove',
            'touchmove'
        ], this.handleMouseMove);
        this.removeClass('disabled');
        this.enabled_ = true;
    }
    /**
   * Cleanup listeners after the user finishes interacting with the progress controls
   */ removeListenersAddedOnMousedownAndTouchstart() {
        const doc = this.el_.ownerDocument;
        this.off(doc, 'mousemove', this.throttledHandleMouseSeek);
        this.off(doc, 'touchmove', this.throttledHandleMouseSeek);
        this.off(doc, 'mouseup', this.handleMouseUpHandler_);
        this.off(doc, 'touchend', this.handleMouseUpHandler_);
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */ handleMouseDown(event) {
        const doc = this.el_.ownerDocument;
        const seekBar = this.getChild('seekBar');
        if (seekBar) seekBar.handleMouseDown(event);
        this.on(doc, 'mousemove', this.throttledHandleMouseSeek);
        this.on(doc, 'touchmove', this.throttledHandleMouseSeek);
        this.on(doc, 'mouseup', this.handleMouseUpHandler_);
        this.on(doc, 'touchend', this.handleMouseUpHandler_);
    }
    /**
   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */ handleMouseUp(event) {
        const seekBar = this.getChild('seekBar');
        if (seekBar) seekBar.handleMouseUp(event);
        this.removeListenersAddedOnMousedownAndTouchstart();
    }
}
/**
 * Default options for `ProgressControl`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$ProgressControl.prototype.options_ = {
    children: [
        'seekBar'
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent('ProgressControl', $cb03b711053a4297$var$ProgressControl);
/**
 * @file picture-in-picture-toggle.js
 */ /** @import Player from './player' */ /**
 * Toggle Picture-in-Picture mode
 *
 * @extends Button
 */ class $cb03b711053a4297$var$PictureInPictureToggle extends $cb03b711053a4297$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */ constructor(player, options){
        super(player, options);
        this.setIcon('picture-in-picture-enter');
        this.on(player, [
            'enterpictureinpicture',
            'leavepictureinpicture'
        ], (e)=>this.handlePictureInPictureChange(e));
        this.on(player, [
            'disablepictureinpicturechanged',
            'loadedmetadata'
        ], (e)=>this.handlePictureInPictureEnabledChange(e));
        this.on(player, [
            'loadedmetadata',
            'audioonlymodechange',
            'audiopostermodechange'
        ], ()=>this.handlePictureInPictureAudioModeChange());
        // TODO: Deactivate button on player emptied event.
        this.disable();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-picture-in-picture-control vjs-hidden ${super.buildCSSClass()}`;
    }
    /**
   * Displays or hides the button depending on the audio mode detection.
   * Exits picture-in-picture if it is enabled when switching to audio mode.
   */ handlePictureInPictureAudioModeChange() {
        // This audio detection will not detect HLS or DASH audio-only streams because there was no reliable way to detect them at the time
        const isSourceAudio = this.player_.currentType().substring(0, 5) === 'audio';
        const isAudioMode = isSourceAudio || this.player_.audioPosterMode() || this.player_.audioOnlyMode();
        if (!isAudioMode) {
            this.show();
            return;
        }
        if (this.player_.isInPictureInPicture()) this.player_.exitPictureInPicture();
        this.hide();
    }
    /**
   * Enables or disables button based on availability of a Picture-In-Picture mode.
   *
   * Enabled if
   * - `player.options().enableDocumentPictureInPicture` is true and
   *   window.documentPictureInPicture is available; or
   * - `player.disablePictureInPicture()` is false and
   *   element.requestPictureInPicture is available
   */ handlePictureInPictureEnabledChange() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).pictureInPictureEnabled && this.player_.disablePictureInPicture() === false || this.player_.options_.enableDocumentPictureInPicture && 'documentPictureInPicture' in (0, (/*@__PURE__*/$parcel$interopDefault($eDick)))) this.enable();
        else this.disable();
    }
    /**
   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
   *        called.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */ handlePictureInPictureChange(event) {
        if (this.player_.isInPictureInPicture()) {
            this.setIcon('picture-in-picture-exit');
            this.controlText('Exit Picture-in-Picture');
        } else {
            this.setIcon('picture-in-picture-enter');
            this.controlText('Picture-in-Picture');
        }
        this.handlePictureInPictureEnabledChange();
    }
    /**
   * This gets called when an `PictureInPictureToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (!this.player_.isInPictureInPicture()) this.player_.requestPictureInPicture();
        else this.player_.exitPictureInPicture();
    }
    /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it only in browsers that support the Picture-in-Picture API.
   */ show() {
        // Does not allow to display the pictureInPictureToggle in browsers that do not support the Picture-in-Picture API, e.g. Firefox.
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).exitPictureInPicture !== 'function') return;
        super.show();
    }
}
/**
 * The text that should display over the `PictureInPictureToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$PictureInPictureToggle.prototype.controlText_ = 'Picture-in-Picture';
$cb03b711053a4297$var$Component$1.registerComponent('PictureInPictureToggle', $cb03b711053a4297$var$PictureInPictureToggle);
/**
 * @file fullscreen-toggle.js
 */ /** @import Player from './player' */ /**
 * Toggle fullscreen video
 *
 * @extends Button
 */ class $cb03b711053a4297$var$FullscreenToggle extends $cb03b711053a4297$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.setIcon('fullscreen-enter');
        this.on(player, 'fullscreenchange', (e)=>this.handleFullscreenChange(e));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[player.fsApi_.fullscreenEnabled] === false) this.disable();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-fullscreen-control ${super.buildCSSClass()}`;
    }
    /**
   * Handles fullscreenchange on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#fullscreenchange} event that caused this function to be
   *        called.
   *
   * @listens Player#fullscreenchange
   */ handleFullscreenChange(event) {
        if (this.player_.isFullscreen()) {
            this.controlText('Exit Fullscreen');
            this.setIcon('fullscreen-exit');
        } else {
            this.controlText('Fullscreen');
            this.setIcon('fullscreen-enter');
        }
    }
    /**
   * This gets called when an `FullscreenToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (!this.player_.isFullscreen()) this.player_.requestFullscreen();
        else this.player_.exitFullscreen();
    }
}
/**
 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$FullscreenToggle.prototype.controlText_ = 'Fullscreen';
$cb03b711053a4297$var$Component$1.registerComponent('FullscreenToggle', $cb03b711053a4297$var$FullscreenToggle);
/** @import Component from '../../component' */ /** @import Player from '../../player' */ /**
 * Check if volume control is supported and if it isn't hide the
 * `Component` that was passed  using the `vjs-hidden` class.
 *
 * @param {Component} self
 *        The component that should be hidden if volume is unsupported
 *
 * @param {Player} player
 *        A reference to the player
 *
 * @private
 */ const $cb03b711053a4297$var$checkVolumeSupport = function(self1, player) {
    // hide volume controls when they're not supported by the current tech
    if (player.tech_ && !player.tech_.featuresVolumeControl) self1.addClass('vjs-hidden');
    self1.on(player, 'loadstart', function() {
        if (!player.tech_.featuresVolumeControl) self1.addClass('vjs-hidden');
        else self1.removeClass('vjs-hidden');
    });
};
/**
 * @file volume-level.js
 */ /**
 * Shows volume level
 *
 * @extends Component
 */ class $cb03b711053a4297$var$VolumeLevel extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl('div', {
            className: 'vjs-volume-level'
        });
        this.setIcon('circle', el);
        el.appendChild(super.createEl('span', {
            className: 'vjs-control-text'
        }));
        return el;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('VolumeLevel', $cb03b711053a4297$var$VolumeLevel);
/**
 * @file volume-level-tooltip.js
 */ /** @import Player from '../../player' */ /**
 * Volume level tooltips display a volume above or side by side the volume bar.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$VolumeLevelTooltip extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.update), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the volume tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-volume-tooltip'
        }, {
            'aria-hidden': 'true'
        });
    }
    /**
   * Updates the position of the tooltip relative to the `VolumeBar` and
   * its content text.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */ update(rangeBarRect, rangeBarPoint, vertical, content) {
        if (!vertical) {
            const tooltipRect = $cb03b711053a4297$var$getBoundingClientRect(this.el_);
            const playerRect = $cb03b711053a4297$var$getBoundingClientRect(this.player_.el());
            const volumeBarPointPx = rangeBarRect.width * rangeBarPoint;
            if (!playerRect || !tooltipRect) return;
            const spaceLeftOfPoint = rangeBarRect.left - playerRect.left + volumeBarPointPx;
            const spaceRightOfPoint = rangeBarRect.width - volumeBarPointPx + (playerRect.right - rangeBarRect.right);
            let pullTooltipBy = tooltipRect.width / 2;
            if (spaceLeftOfPoint < pullTooltipBy) pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
            else if (spaceRightOfPoint < pullTooltipBy) pullTooltipBy = spaceRightOfPoint;
            if (pullTooltipBy < 0) pullTooltipBy = 0;
            else if (pullTooltipBy > tooltipRect.width) pullTooltipBy = tooltipRect.width;
            this.el_.style.right = `-${pullTooltipBy}px`;
        }
        this.write(`${content}%`);
    }
    /**
   * Write the volume to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted volume for the tooltip.
   */ write(content) {
        $cb03b711053a4297$var$textContent(this.el_, content);
    }
    /**
   * Updates the position of the volume tooltip relative to the `VolumeBar`.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   * @param {number} volume
   *        The volume level to update the tooltip to
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */ updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, cb) {
        this.requestNamedAnimationFrame('VolumeLevelTooltip#updateVolume', ()=>{
            this.update(rangeBarRect, rangeBarPoint, vertical, volume.toFixed(0));
            if (cb) cb();
        });
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('VolumeLevelTooltip', $cb03b711053a4297$var$VolumeLevelTooltip);
/**
 * @file mouse-volume-level-display.js
 */ /**
 * The {@link MouseVolumeLevelDisplay} component tracks mouse movement over the
 * {@link VolumeControl}. It displays an indicator and a {@link VolumeLevelTooltip}
 * indicating the volume level which is represented by a given point in the
 * {@link VolumeBar}.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$MouseVolumeLevelDisplay extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.update), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-mouse-display'
        });
    }
    /**
   * Enquires updates to its own DOM as well as the DOM of its
   * {@link VolumeLevelTooltip} child.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */ update(rangeBarRect, rangeBarPoint, vertical) {
        const volume = 100 * rangeBarPoint;
        this.getChild('volumeLevelTooltip').updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, ()=>{
            if (vertical) this.el_.style.bottom = `${rangeBarRect.height * rangeBarPoint}px`;
            else this.el_.style.left = `${rangeBarRect.width * rangeBarPoint}px`;
        });
    }
}
/**
 * Default options for `MouseVolumeLevelDisplay`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$MouseVolumeLevelDisplay.prototype.options_ = {
    children: [
        'volumeLevelTooltip'
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent('MouseVolumeLevelDisplay', $cb03b711053a4297$var$MouseVolumeLevelDisplay);
/**
 * @file volume-bar.js
 */ /**
 * The bar that contains the volume level and can be clicked on to adjust the level
 *
 * @extends Slider
 */ class $cb03b711053a4297$var$VolumeBar extends $cb03b711053a4297$var$Slider {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on('slideractive', (e)=>this.updateLastVolume_(e));
        this.on(player, 'volumechange', (e)=>this.updateARIAAttributes(e));
        player.ready(()=>this.updateARIAAttributes());
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-volume-bar vjs-slider-bar'
        }, {
            'aria-label': this.localize('Volume Level'),
            'aria-live': 'polite'
        });
    }
    /**
   * Handle mouse down on volume bar
   *
   * @param {Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */ handleMouseDown(event) {
        if (!$cb03b711053a4297$var$isSingleLeftClick(event)) return;
        super.handleMouseDown(event);
    }
    /**
   * Handle movement events on the {@link VolumeMenuButton}.
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @listens mousemove
   */ handleMouseMove(event) {
        const mouseVolumeLevelDisplay = this.getChild('mouseVolumeLevelDisplay');
        if (mouseVolumeLevelDisplay) {
            const volumeBarEl = this.el();
            const volumeBarRect = $cb03b711053a4297$var$getBoundingClientRect(volumeBarEl);
            const vertical = this.vertical();
            let volumeBarPoint = $cb03b711053a4297$var$getPointerPosition(volumeBarEl, event);
            volumeBarPoint = vertical ? volumeBarPoint.y : volumeBarPoint.x;
            // The default skin has a gap on either side of the `VolumeBar`. This means
            // that it's possible to trigger this behavior outside the boundaries of
            // the `VolumeBar`. This ensures we stay within it at all times.
            volumeBarPoint = $cb03b711053a4297$var$clamp(volumeBarPoint, 0, 1);
            mouseVolumeLevelDisplay.update(volumeBarRect, volumeBarPoint, vertical);
        }
        if (!$cb03b711053a4297$var$isSingleLeftClick(event)) return;
        this.checkMuted();
        this.player_.volume(this.calculateDistance(event));
    }
    /**
   * If the player is muted unmute it.
   */ checkMuted() {
        if (this.player_.muted()) this.player_.muted(false);
    }
    /**
   * Get percent of volume level
   *
   * @return {number}
   *         Volume level percent as a decimal number.
   */ getPercent() {
        if (this.player_.muted()) return 0;
        return this.player_.volume();
    }
    /**
   * Increase volume level for keyboard users
   */ stepForward() {
        this.checkMuted();
        this.player_.volume(this.player_.volume() + 0.1);
    }
    /**
   * Decrease volume level for keyboard users
   */ stepBack() {
        this.checkMuted();
        this.player_.volume(this.player_.volume() - 0.1);
    }
    /**
   * Update ARIA accessibility attributes
   *
   * @param {Event} [event]
   *        The `volumechange` event that caused this function to run.
   *
   * @listens Player#volumechange
   */ updateARIAAttributes(event) {
        const ariaValue = this.player_.muted() ? 0 : this.volumeAsPercentage_();
        this.el_.setAttribute('aria-valuenow', ariaValue);
        this.el_.setAttribute('aria-valuetext', ariaValue + '%');
    }
    /**
   * Returns the current value of the player volume as a percentage
   *
   * @private
   */ volumeAsPercentage_() {
        return Math.round(this.player_.volume() * 100);
    }
    /**
   * When user starts dragging the VolumeBar, store the volume and listen for
   * the end of the drag. When the drag ends, if the volume was set to zero,
   * set lastVolume to the stored volume.
   *
   * @listens slideractive
   * @private
   */ updateLastVolume_() {
        const volumeBeforeDrag = this.player_.volume();
        this.one('sliderinactive', ()=>{
            if (this.player_.volume() === 0) this.player_.lastVolume_(volumeBeforeDrag);
        });
    }
}
/**
 * Default options for the `VolumeBar`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$VolumeBar.prototype.options_ = {
    children: [
        'volumeLevel'
    ],
    barName: 'volumeLevel'
};
// MouseVolumeLevelDisplay tooltip should not be added to a player on mobile devices
if (!$cb03b711053a4297$var$IS_IOS && !$cb03b711053a4297$var$IS_ANDROID) $cb03b711053a4297$var$VolumeBar.prototype.options_.children.splice(0, 0, 'mouseVolumeLevelDisplay');
/**
 * Call the update event for this Slider when this event happens on the player.
 *
 * @type {string}
 */ $cb03b711053a4297$var$VolumeBar.prototype.playerEvent = 'volumechange';
$cb03b711053a4297$var$Component$1.registerComponent('VolumeBar', $cb03b711053a4297$var$VolumeBar);
/**
 * @file volume-control.js
 */ /**
 * The component for controlling the volume level
 *
 * @extends Component
 */ class $cb03b711053a4297$var$VolumeControl extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        options.vertical = options.vertical || false;
        // Pass the vertical option down to the VolumeBar if
        // the VolumeBar is turned on.
        if (typeof options.volumeBar === 'undefined' || $cb03b711053a4297$var$isPlain(options.volumeBar)) {
            options.volumeBar = options.volumeBar || {};
            options.volumeBar.vertical = options.vertical;
        }
        super(player, options);
        // hide this control if volume support is missing
        $cb03b711053a4297$var$checkVolumeSupport(this, player);
        this.throttledHandleMouseMove = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.handleMouseMove), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
        this.handleMouseUpHandler_ = (e)=>this.handleMouseUp(e);
        this.on('mousedown', (e)=>this.handleMouseDown(e));
        this.on('touchstart', (e)=>this.handleMouseDown(e));
        this.on('mousemove', (e)=>this.handleMouseMove(e));
        // while the slider is active (the mouse has been pressed down and
        // is dragging) or in focus we do not want to hide the VolumeBar
        this.on(this.volumeBar, [
            'focus',
            'slideractive'
        ], ()=>{
            this.volumeBar.addClass('vjs-slider-active');
            this.addClass('vjs-slider-active');
            this.trigger('slideractive');
        });
        this.on(this.volumeBar, [
            'blur',
            'sliderinactive'
        ], ()=>{
            this.volumeBar.removeClass('vjs-slider-active');
            this.removeClass('vjs-slider-active');
            this.trigger('sliderinactive');
        });
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        let orientationClass = 'vjs-volume-horizontal';
        if (this.options_.vertical) orientationClass = 'vjs-volume-vertical';
        return super.createEl('div', {
            className: `vjs-volume-control vjs-control ${orientationClass}`
        });
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */ handleMouseDown(event) {
        const doc = this.el_.ownerDocument;
        this.on(doc, 'mousemove', this.throttledHandleMouseMove);
        this.on(doc, 'touchmove', this.throttledHandleMouseMove);
        this.on(doc, 'mouseup', this.handleMouseUpHandler_);
        this.on(doc, 'touchend', this.handleMouseUpHandler_);
    }
    /**
   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */ handleMouseUp(event) {
        const doc = this.el_.ownerDocument;
        this.off(doc, 'mousemove', this.throttledHandleMouseMove);
        this.off(doc, 'touchmove', this.throttledHandleMouseMove);
        this.off(doc, 'mouseup', this.handleMouseUpHandler_);
        this.off(doc, 'touchend', this.handleMouseUpHandler_);
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */ handleMouseMove(event) {
        this.volumeBar.handleMouseMove(event);
    }
}
/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$VolumeControl.prototype.options_ = {
    children: [
        'volumeBar'
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent('VolumeControl', $cb03b711053a4297$var$VolumeControl);
/** @import Component from '../../component' */ /** @import Player from '../../player' */ /**
 * Check if muting volume is supported and if it isn't hide the mute toggle
 * button.
 *
 * @param {Component} self
 *        A reference to the mute toggle button
 *
 * @param {Player} player
 *        A reference to the player
 *
 * @private
 */ const $cb03b711053a4297$var$checkMuteSupport = function(self1, player) {
    // hide mute toggle button if it's not supported by the current tech
    if (player.tech_ && !player.tech_.featuresMuteControl) self1.addClass('vjs-hidden');
    self1.on(player, 'loadstart', function() {
        if (!player.tech_.featuresMuteControl) self1.addClass('vjs-hidden');
        else self1.removeClass('vjs-hidden');
    });
};
/**
 * @file mute-toggle.js
 */ /** @import Player from './player' */ /**
 * A button component for muting the audio.
 *
 * @extends Button
 */ class $cb03b711053a4297$var$MuteToggle extends $cb03b711053a4297$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        // hide this control if volume support is missing
        $cb03b711053a4297$var$checkMuteSupport(this, player);
        this.on(player, [
            'loadstart',
            'volumechange'
        ], (e)=>this.update(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-mute-control ${super.buildCSSClass()}`;
    }
    /**
   * This gets called when an `MuteToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        const vol = this.player_.volume();
        const lastVolume = this.player_.lastVolume_();
        if (vol === 0) {
            const volumeToSet = lastVolume < 0.1 ? 0.1 : lastVolume;
            this.player_.volume(volumeToSet);
            this.player_.muted(false);
        } else this.player_.muted(this.player_.muted() ? false : true);
    }
    /**
   * Update the `MuteToggle` button based on the state of `volume` and `muted`
   * on the player.
   *
   * @param {Event} [event]
   *        The {@link Player#loadstart} event if this function was called
   *        through an event.
   *
   * @listens Player#loadstart
   * @listens Player#volumechange
   */ update(event) {
        this.updateIcon_();
        this.updateControlText_();
    }
    /**
   * Update the appearance of the `MuteToggle` icon.
   *
   * Possible states (given `level` variable below):
   * - 0: crossed out
   * - 1: zero bars of volume
   * - 2: one bar of volume
   * - 3: two bars of volume
   *
   * @private
   */ updateIcon_() {
        const vol = this.player_.volume();
        let level = 3;
        this.setIcon('volume-high');
        // in iOS when a player is loaded with muted attribute
        // and volume is changed with a native mute button
        // we want to make sure muted state is updated
        if ($cb03b711053a4297$var$IS_IOS && this.player_.tech_ && this.player_.tech_.el_) this.player_.muted(this.player_.tech_.el_.muted);
        if (vol === 0 || this.player_.muted()) {
            this.setIcon('volume-mute');
            level = 0;
        } else if (vol < 0.33) {
            this.setIcon('volume-low');
            level = 1;
        } else if (vol < 0.67) {
            this.setIcon('volume-medium');
            level = 2;
        }
        $cb03b711053a4297$var$removeClass(this.el_, [
            0,
            1,
            2,
            3
        ].reduce((str, i)=>str + `${i ? ' ' : ''}vjs-vol-${i}`, ''));
        $cb03b711053a4297$var$addClass(this.el_, `vjs-vol-${level}`);
    }
    /**
   * If `muted` has changed on the player, update the control text
   * (`title` attribute on `vjs-mute-control` element and content of
   * `vjs-control-text` element).
   *
   * @private
   */ updateControlText_() {
        const soundOff = this.player_.muted() || this.player_.volume() === 0;
        const text = soundOff ? 'Unmute' : 'Mute';
        if (this.controlText() !== text) this.controlText(text);
    }
}
/**
 * The text that should display over the `MuteToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$MuteToggle.prototype.controlText_ = 'Mute';
$cb03b711053a4297$var$Component$1.registerComponent('MuteToggle', $cb03b711053a4297$var$MuteToggle);
/**
 * @file volume-control.js
 */ /**
 * A Component to contain the MuteToggle and VolumeControl so that
 * they can work together.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$VolumePanel extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        if (typeof options.inline !== 'undefined') options.inline = options.inline;
        else options.inline = true;
        // pass the inline option down to the VolumeControl as vertical if
        // the VolumeControl is on.
        if (typeof options.volumeControl === 'undefined' || $cb03b711053a4297$var$isPlain(options.volumeControl)) {
            options.volumeControl = options.volumeControl || {};
            options.volumeControl.vertical = !options.inline;
        }
        super(player, options);
        // this handler is used by mouse handler methods below
        this.handleKeyPressHandler_ = (e)=>this.handleKeyPress(e);
        this.on(player, [
            'loadstart'
        ], (e)=>this.volumePanelState_(e));
        this.on(this.muteToggle, 'keyup', (e)=>this.handleKeyPress(e));
        this.on(this.volumeControl, 'keyup', (e)=>this.handleVolumeControlKeyUp(e));
        this.on('keydown', (e)=>this.handleKeyPress(e));
        this.on('mouseover', (e)=>this.handleMouseOver(e));
        this.on('mouseout', (e)=>this.handleMouseOut(e));
        // while the slider is active (the mouse has been pressed down and
        // is dragging) we do not want to hide the VolumeBar
        this.on(this.volumeControl, [
            'slideractive'
        ], this.sliderActive_);
        this.on(this.volumeControl, [
            'sliderinactive'
        ], this.sliderInactive_);
    }
    /**
   * Add vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#slideractive
   * @private
   */ sliderActive_() {
        this.addClass('vjs-slider-active');
    }
    /**
   * Removes vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#sliderinactive
   * @private
   */ sliderInactive_() {
        this.removeClass('vjs-slider-active');
    }
    /**
   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
   * depending on MuteToggle and VolumeControl state
   *
   * @listens Player#loadstart
   * @private
   */ volumePanelState_() {
        // hide volume panel if neither volume control or mute toggle
        // are displayed
        if (this.volumeControl.hasClass('vjs-hidden') && this.muteToggle.hasClass('vjs-hidden')) this.addClass('vjs-hidden');
        // if only mute toggle is visible we don't want
        // volume panel expanding when hovered or active
        if (this.volumeControl.hasClass('vjs-hidden') && !this.muteToggle.hasClass('vjs-hidden')) this.addClass('vjs-mute-toggle-only');
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        let orientationClass = 'vjs-volume-panel-horizontal';
        if (!this.options_.inline) orientationClass = 'vjs-volume-panel-vertical';
        return super.createEl('div', {
            className: `vjs-volume-panel vjs-control ${orientationClass}`
        });
    }
    /**
   * Dispose of the `volume-panel` and all child components.
   */ dispose() {
        this.handleMouseOut();
        super.dispose();
    }
    /**
   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
   * the volume panel and sets focus on `MuteToggle`.
   *
   * @param {Event} event
   *        The `keyup` event that caused this function to be called.
   *
   * @listens keyup
   */ handleVolumeControlKeyUp(event) {
        if (event.key === 'Escape') this.muteToggle.focus();
    }
    /**
   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
   * Turns on listening for `mouseover` event. When they happen it
   * calls `this.handleMouseOver`.
   *
   * @param {Event} event
   *        The `mouseover` event that caused this function to be called.
   *
   * @listens mouseover
   */ handleMouseOver(event) {
        this.addClass('vjs-hover');
        $cb03b711053a4297$var$on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), 'keyup', this.handleKeyPressHandler_);
    }
    /**
   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
   * Turns on listening for `mouseout` event. When they happen it
   * calls `this.handleMouseOut`.
   *
   * @param {Event} event
   *        The `mouseout` event that caused this function to be called.
   *
   * @listens mouseout
   */ handleMouseOut(event) {
        this.removeClass('vjs-hover');
        $cb03b711053a4297$var$off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), 'keyup', this.handleKeyPressHandler_);
    }
    /**
   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
   * looking for ESC, which hides the `VolumeControl`.
   *
   * @param {Event} event
   *        The keypress that triggered this event.
   *
   * @listens keydown | keyup
   */ handleKeyPress(event) {
        if (event.key === 'Escape') this.handleMouseOut();
    }
}
/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$VolumePanel.prototype.options_ = {
    children: [
        'muteToggle',
        'volumeControl'
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent('VolumePanel', $cb03b711053a4297$var$VolumePanel);
/**
 * Button to skip forward a configurable amount of time
 * through a video. Renders in the control bar.
 *
 * e.g. options: {controlBar: {skipButtons: forward: 5}}
 *
 * @extends Button
 */ class $cb03b711053a4297$var$SkipForward extends $cb03b711053a4297$var$Button {
    constructor(player, options){
        super(player, options);
        this.validOptions = [
            5,
            10,
            30
        ];
        this.skipTime = this.getSkipForwardTime();
        if (this.skipTime && this.validOptions.includes(this.skipTime)) {
            this.setIcon(`forward-${this.skipTime}`);
            this.controlText(this.localize('Skip forward {1} seconds', [
                this.skipTime.toLocaleString(player.language())
            ]));
            this.show();
        } else this.hide();
    }
    getSkipForwardTime() {
        const playerOptions = this.options_.playerOptions;
        return playerOptions.controlBar && playerOptions.controlBar.skipButtons && playerOptions.controlBar.skipButtons.forward;
    }
    buildCSSClass() {
        return `vjs-skip-forward-${this.getSkipForwardTime()} ${super.buildCSSClass()}`;
    }
    /**
   * On click, skips forward in the duration/seekable range by a configurable amount of seconds.
   * If the time left in the duration/seekable range is less than the configured 'skip forward' time,
   * skips to end of duration/seekable range.
   *
   * Handle a click on a `SkipForward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */ handleClick(event) {
        if (isNaN(this.player_.duration())) return;
        const currentVideoTime = this.player_.currentTime();
        const liveTracker = this.player_.liveTracker;
        const duration = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : this.player_.duration();
        let newTime;
        if (currentVideoTime + this.skipTime <= duration) newTime = currentVideoTime + this.skipTime;
        else newTime = duration;
        this.player_.currentTime(newTime);
    }
    /**
   * Update control text on languagechange
   */ handleLanguagechange() {
        this.controlText(this.localize('Skip forward {1} seconds', [
            this.skipTime
        ]));
    }
}
$cb03b711053a4297$var$SkipForward.prototype.controlText_ = 'Skip Forward';
$cb03b711053a4297$var$Component$1.registerComponent('SkipForward', $cb03b711053a4297$var$SkipForward);
/**
 * Button to skip backward a configurable amount of time
 * through a video. Renders in the control bar.
 *
 *  * e.g. options: {controlBar: {skipButtons: backward: 5}}
 *
 * @extends Button
 */ class $cb03b711053a4297$var$SkipBackward extends $cb03b711053a4297$var$Button {
    constructor(player, options){
        super(player, options);
        this.validOptions = [
            5,
            10,
            30
        ];
        this.skipTime = this.getSkipBackwardTime();
        if (this.skipTime && this.validOptions.includes(this.skipTime)) {
            this.setIcon(`replay-${this.skipTime}`);
            this.controlText(this.localize('Skip backward {1} seconds', [
                this.skipTime.toLocaleString(player.language())
            ]));
            this.show();
        } else this.hide();
    }
    getSkipBackwardTime() {
        const playerOptions = this.options_.playerOptions;
        return playerOptions.controlBar && playerOptions.controlBar.skipButtons && playerOptions.controlBar.skipButtons.backward;
    }
    buildCSSClass() {
        return `vjs-skip-backward-${this.getSkipBackwardTime()} ${super.buildCSSClass()}`;
    }
    /**
   * On click, skips backward in the video by a configurable amount of seconds.
   * If the current time in the video is less than the configured 'skip backward' time,
   * skips to beginning of video or seekable range.
   *
   * Handle a click on a `SkipBackward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */ handleClick(event) {
        const currentVideoTime = this.player_.currentTime();
        const liveTracker = this.player_.liveTracker;
        const seekableStart = liveTracker && liveTracker.isLive() && liveTracker.seekableStart();
        let newTime;
        if (seekableStart && currentVideoTime - this.skipTime <= seekableStart) newTime = seekableStart;
        else if (currentVideoTime >= this.skipTime) newTime = currentVideoTime - this.skipTime;
        else newTime = 0;
        this.player_.currentTime(newTime);
    }
    /**
   * Update control text on languagechange
   */ handleLanguagechange() {
        this.controlText(this.localize('Skip backward {1} seconds', [
            this.skipTime
        ]));
    }
}
$cb03b711053a4297$var$SkipBackward.prototype.controlText_ = 'Skip Backward';
$cb03b711053a4297$var$Component$1.registerComponent('SkipBackward', $cb03b711053a4297$var$SkipBackward);
/**
 * @file menu.js
 */ /** @import Player from '../player' */ /**
 * The Menu component is used to build popup menus, including subtitle and
 * captions selection menus.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$Menu extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        the player that this component should attach to
   *
   * @param {Object} [options]
   *        Object of option names and values
   *
   */ constructor(player, options){
        super(player, options);
        if (options) this.menuButton_ = options.menuButton;
        this.focusedChild_ = -1;
        this.on('keydown', (e)=>this.handleKeyDown(e));
        // All the menu item instances share the same blur handler provided by the menu container.
        this.boundHandleBlur_ = (e)=>this.handleBlur(e);
        this.boundHandleTapClick_ = (e)=>this.handleTapClick(e);
    }
    /**
   * Add event listeners to the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to add listeners to.
   *
   */ addEventListenerForItem(component) {
        if (!(component instanceof $cb03b711053a4297$var$Component$1)) return;
        this.on(component, 'blur', this.boundHandleBlur_);
        this.on(component, [
            'tap',
            'click'
        ], this.boundHandleTapClick_);
    }
    /**
   * Remove event listeners from the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to remove listeners.
   *
   */ removeEventListenerForItem(component) {
        if (!(component instanceof $cb03b711053a4297$var$Component$1)) return;
        this.off(component, 'blur', this.boundHandleBlur_);
        this.off(component, [
            'tap',
            'click'
        ], this.boundHandleTapClick_);
    }
    /**
   * This method will be called indirectly when the component has been added
   * before the component adds to the new menu instance by `addItem`.
   * In this case, the original menu instance will remove the component
   * by calling `removeChild`.
   *
   * @param {Object} component
   *        The instance of the `MenuItem`
   */ removeChild(component) {
        if (typeof component === 'string') component = this.getChild(component);
        this.removeEventListenerForItem(component);
        super.removeChild(component);
    }
    /**
   * Add a {@link MenuItem} to the menu.
   *
   * @param {Object|string} component
   *        The name or instance of the `MenuItem` to add.
   *
   */ addItem(component) {
        const childComponent = this.addChild(component);
        if (childComponent) this.addEventListenerForItem(childComponent);
    }
    /**
   * Create the `Menu`s DOM element.
   *
   * @return {Element}
   *         the element that was created
   */ createEl() {
        const contentElType = this.options_.contentElType || 'ul';
        this.contentEl_ = $cb03b711053a4297$var$createEl(contentElType, {
            className: 'vjs-menu-content'
        });
        this.contentEl_.setAttribute('role', 'menu');
        const el = super.createEl('div', {
            append: this.contentEl_,
            className: 'vjs-menu'
        });
        el.appendChild(this.contentEl_);
        // Prevent clicks from bubbling up. Needed for Menu Buttons,
        // where a click on the parent is significant
        $cb03b711053a4297$var$on(el, 'click', function(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        });
        return el;
    }
    dispose() {
        this.contentEl_ = null;
        this.boundHandleBlur_ = null;
        this.boundHandleTapClick_ = null;
        super.dispose();
    }
    /**
   * Called when a `MenuItem` loses focus.
   *
   * @param {Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */ handleBlur(event) {
        const relatedTarget = event.relatedTarget || (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).activeElement;
        // Close menu popup when a user clicks outside the menu
        if (!this.children().some((element)=>{
            return element.el() === relatedTarget;
        })) {
            const btn = this.menuButton_;
            if (btn && btn.buttonPressed_ && relatedTarget !== btn.el().firstChild) btn.unpressButton();
        }
    }
    /**
   * Called when a `MenuItem` gets clicked or tapped.
   *
   * @param {Event} event
   *        The `click` or `tap` event that caused this function to be called.
   *
   * @listens click,tap
   */ handleTapClick(event) {
        // Unpress the associated MenuButton, and move focus back to it
        if (this.menuButton_) {
            this.menuButton_.unpressButton();
            const childComponents = this.children();
            if (!Array.isArray(childComponents)) return;
            const foundComponent = childComponents.filter((component)=>component.el() === event.target)[0];
            if (!foundComponent) return;
            // don't focus menu button if item is a caption settings item
            // because focus will move elsewhere
            if (foundComponent.name() !== 'CaptionSettingsMenuItem') this.menuButton_.focus();
        }
    }
    /**
   * Handle a `keydown` event on this menu. This listener is added in the constructor.
   *
   * @param {KeyboardEvent} event
   *        A `keydown` event that happened on the menu.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Left and Down Arrows
        if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
            event.preventDefault();
            event.stopPropagation();
            this.stepForward();
        // Up and Right Arrows
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
            event.preventDefault();
            event.stopPropagation();
            this.stepBack();
        }
    }
    /**
   * Move to next (lower) menu item for keyboard users.
   */ stepForward() {
        let stepChild = 0;
        if (this.focusedChild_ !== undefined) stepChild = this.focusedChild_ + 1;
        this.focus(stepChild);
    }
    /**
   * Move to previous (higher) menu item for keyboard users.
   */ stepBack() {
        let stepChild = 0;
        if (this.focusedChild_ !== undefined) stepChild = this.focusedChild_ - 1;
        this.focus(stepChild);
    }
    /**
   * Set focus on a {@link MenuItem} in the `Menu`.
   *
   * @param {Object|string} [item=0]
   *        Index of child item set focus on.
   */ focus(item = 0) {
        const children = this.children().slice();
        const haveTitle = children.length && children[0].hasClass('vjs-menu-title');
        if (haveTitle) children.shift();
        if (children.length > 0) {
            if (item < 0) item = 0;
            else if (item >= children.length) item = children.length - 1;
            this.focusedChild_ = item;
            children[item].el_.focus();
        }
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('Menu', $cb03b711053a4297$var$Menu);
/**
 * @file menu-button.js
 */ /** @import Player from '../player' */ /**
 * A `MenuButton` class for any popup {@link Menu}.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$MenuButton extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        super(player, options);
        this.menuButton_ = new $cb03b711053a4297$var$Button(player, options);
        this.menuButton_.controlText(this.controlText_);
        this.menuButton_.el_.setAttribute('aria-haspopup', 'true');
        // Add buildCSSClass values to the button, not the wrapper
        const buttonClass = $cb03b711053a4297$var$Button.prototype.buildCSSClass();
        this.menuButton_.el_.className = this.buildCSSClass() + ' ' + buttonClass;
        this.menuButton_.removeClass('vjs-control');
        this.addChild(this.menuButton_);
        this.update();
        this.enabled_ = true;
        const handleClick = (e)=>this.handleClick(e);
        this.handleMenuKeyUp_ = (e)=>this.handleMenuKeyUp(e);
        this.on(this.menuButton_, 'tap', handleClick);
        this.on(this.menuButton_, 'click', handleClick);
        this.on(this.menuButton_, 'keydown', (e)=>this.handleKeyDown(e));
        this.on(this.menuButton_, 'mouseenter', ()=>{
            this.addClass('vjs-hover');
            this.menu.show();
            $cb03b711053a4297$var$on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), 'keyup', this.handleMenuKeyUp_);
        });
        this.on('mouseleave', (e)=>this.handleMouseLeave(e));
        this.on('keydown', (e)=>this.handleSubmenuKeyDown(e));
    }
    /**
   * Update the menu based on the current state of its items.
   */ update() {
        const menu = this.createMenu();
        if (this.menu) {
            this.menu.dispose();
            this.removeChild(this.menu);
        }
        this.menu = menu;
        this.addChild(menu);
        /**
     * Track the state of the menu button
     *
     * @type {Boolean}
     * @private
     */ this.buttonPressed_ = false;
        this.menuButton_.el_.setAttribute('aria-expanded', 'false');
        if (this.items && this.items.length <= this.hideThreshold_) {
            this.hide();
            this.menu.contentEl_.removeAttribute('role');
        } else {
            this.show();
            this.menu.contentEl_.setAttribute('role', 'menu');
        }
    }
    /**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */ createMenu() {
        const menu = new $cb03b711053a4297$var$Menu(this.player_, {
            menuButton: this
        });
        /**
     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
     * it here because every time we run `createMenu` we need to reset the value.
     *
     * @protected
     * @type {Number}
     */ this.hideThreshold_ = 0;
        // Add a title list item to the top
        if (this.options_.title) {
            const titleEl = $cb03b711053a4297$var$createEl('li', {
                className: 'vjs-menu-title',
                textContent: $cb03b711053a4297$var$toTitleCase$1(this.options_.title),
                tabIndex: -1
            });
            const titleComponent = new $cb03b711053a4297$var$Component$1(this.player_, {
                el: titleEl
            });
            menu.addItem(titleComponent);
        }
        this.items = this.createItems();
        if (this.items) // Add menu items to the menu
        for(let i = 0; i < this.items.length; i++)menu.addItem(this.items[i]);
        return menu;
    }
    /**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */ createItems() {}
    /**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl() {
        return super.createEl('div', {
            className: this.buildWrapperCSSClass()
        }, {});
    }
    /**
   * Overwrites the `setIcon` method from `Component`.
   * In this case, we want the icon to be appended to the menuButton.
   *
   * @param {string} name
   *         The icon name to be added.
   */ setIcon(name) {
        super.setIcon(name, this.menuButton_.el_);
    }
    /**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */ buildWrapperCSSClass() {
        let menuButtonClass = 'vjs-menu-button';
        // If the inline option is passed, we want to use different styles altogether.
        if (this.options_.inline === true) menuButtonClass += '-inline';
        else menuButtonClass += '-popup';
        // TODO: Fix the CSS so that this isn't necessary
        const buttonClass = $cb03b711053a4297$var$Button.prototype.buildCSSClass();
        return `vjs-menu-button ${menuButtonClass} ${buttonClass} ${super.buildCSSClass()}`;
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        let menuButtonClass = 'vjs-menu-button';
        // If the inline option is passed, we want to use different styles altogether.
        if (this.options_.inline === true) menuButtonClass += '-inline';
        else menuButtonClass += '-popup';
        return `vjs-menu-button ${menuButtonClass} ${super.buildCSSClass()}`;
    }
    /**
   * Get or set the localized control text that will be used for accessibility.
   *
   * > NOTE: This will come from the internal `menuButton_` element.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.menuButton_.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */ controlText(text, el = this.menuButton_.el()) {
        return this.menuButton_.controlText(text, el);
    }
    /**
   * Dispose of the `menu-button` and all child components.
   */ dispose() {
        this.handleMouseLeave();
        super.dispose();
    }
    /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (this.buttonPressed_) this.unpressButton();
        else this.pressButton();
    }
    /**
   * Handle `mouseleave` for `MenuButton`.
   *
   * @param {Event} event
   *        The `mouseleave` event that caused this function to be called.
   *
   * @listens mouseleave
   */ handleMouseLeave(event) {
        this.removeClass('vjs-hover');
        $cb03b711053a4297$var$off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), 'keyup', this.handleMenuKeyUp_);
    }
    /**
   * Set the focus to the actual button, not to this element
   */ focus() {
        this.menuButton_.focus();
    }
    /**
   * Remove the focus from the actual button, not this element
   */ blur() {
        this.menuButton_.blur();
    }
    /**
   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Escape or Tab unpress the 'button'
        if (event.key === 'Escape' || event.key === 'Tab') {
            if (this.buttonPressed_) this.unpressButton();
            // Don't preventDefault for Tab key - we still want to lose focus
            event.key;
        // Up Arrow or Down Arrow also 'press' the button to open the menu
        } else if (event.key === 'Up' || event.key === 'Down' && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) {
            if (!this.buttonPressed_) {
                event.preventDefault();
                this.pressButton();
            }
        }
    }
    /**
   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keyup
   */ handleMenuKeyUp(event) {
        // Escape hides popup menu
        if (event.key === 'Escape' || event.key === 'Tab') this.removeClass('vjs-hover');
    }
    /**
   * This method name now delegates to `handleSubmenuKeyDown`. This means
   * anyone calling `handleSubmenuKeyPress` will not see their method calls
   * stop working.
   *
   * @param {Event} event
   *        The event that caused this function to be called.
   */ handleSubmenuKeyPress(event) {
        this.handleSubmenuKeyDown(event);
    }
    /**
   * Handle a `keydown` event on a sub-menu. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keydown
   */ handleSubmenuKeyDown(event) {
        // Escape or Tab unpress the 'button'
        if (event.key === 'Escape' || event.key === 'Tab') {
            if (this.buttonPressed_) this.unpressButton();
            // Don't preventDefault for Tab key - we still want to lose focus
            event.key;
        }
    }
    /**
   * Put the current `MenuButton` into a pressed state.
   */ pressButton() {
        if (this.enabled_) {
            this.buttonPressed_ = true;
            this.menu.show();
            this.menu.lockShowing();
            this.menuButton_.el_.setAttribute('aria-expanded', 'true');
            // set the focus into the submenu, except on iOS where it is resulting in
            // undesired scrolling behavior when the player is in an iframe
            if ($cb03b711053a4297$var$IS_IOS && $cb03b711053a4297$var$isInFrame()) // Return early so that the menu isn't focused
            return;
            this.menu.focus();
        }
    }
    /**
   * Take the current `MenuButton` out of a pressed state.
   */ unpressButton() {
        if (this.enabled_) {
            this.buttonPressed_ = false;
            this.menu.unlockShowing();
            this.menu.hide();
            this.menuButton_.el_.setAttribute('aria-expanded', 'false');
        }
    }
    /**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */ disable() {
        this.unpressButton();
        this.enabled_ = false;
        this.addClass('vjs-disabled');
        this.menuButton_.disable();
    }
    /**
   * Enable the `MenuButton`. Allow it to be clicked.
   */ enable() {
        this.enabled_ = true;
        this.removeClass('vjs-disabled');
        this.menuButton_.enable();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('MenuButton', $cb03b711053a4297$var$MenuButton);
/**
 * @file track-button.js
 */ /** @import Player from './player' */ /**
 * The base class for buttons that toggle specific  track types (e.g. subtitles).
 *
 * @extends MenuButton
 */ class $cb03b711053a4297$var$TrackButton extends $cb03b711053a4297$var$MenuButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const tracks = options.tracks;
        super(player, options);
        if (this.items.length <= 1) this.hide();
        if (!tracks) return;
        const updateHandler = $cb03b711053a4297$var$bind_(this, this.update);
        tracks.addEventListener('removetrack', updateHandler);
        tracks.addEventListener('addtrack', updateHandler);
        tracks.addEventListener('labelchange', updateHandler);
        this.player_.on('ready', updateHandler);
        this.player_.on('dispose', function() {
            tracks.removeEventListener('removetrack', updateHandler);
            tracks.removeEventListener('addtrack', updateHandler);
            tracks.removeEventListener('labelchange', updateHandler);
        });
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TrackButton', $cb03b711053a4297$var$TrackButton);
/**
 * @file menu-item.js
 */ /** @import Player from '../player' */ /**
 * The component for a menu item. `<li>`
 *
 * @extends ClickableComponent
 */ class $cb03b711053a4297$var$MenuItem extends $cb03b711053a4297$var$ClickableComponent {
    /**
   * Creates an instance of the this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   *
   */ constructor(player, options){
        super(player, options);
        this.selectable = options.selectable;
        this.isSelected_ = options.selected || false;
        this.multiSelectable = options.multiSelectable;
        this.selected(this.isSelected_);
        if (this.selectable) {
            if (this.multiSelectable) this.el_.setAttribute('role', 'menuitemcheckbox');
            else this.el_.setAttribute('role', 'menuitemradio');
        } else this.el_.setAttribute('role', 'menuitem');
    }
    /**
   * Create the `MenuItem's DOM element
   *
   * @param {string} [type=li]
   *        Element's node type, not actually used, always set to `li`.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element
   *
   * @param {Object} [attrs={}]
   *        An object of attributes that should be set on the element
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(type, props, attrs) {
        // The control is textual, not just an icon
        this.nonIconControl = true;
        const el = super.createEl('li', Object.assign({
            className: 'vjs-menu-item',
            tabIndex: -1
        }, props), attrs);
        // swap icon with menu item text.
        const menuItemEl = $cb03b711053a4297$var$createEl('span', {
            className: 'vjs-menu-item-text',
            textContent: this.localize(this.options_.label)
        });
        // If using SVG icons, the element with vjs-icon-placeholder will be added separately.
        if (this.player_.options_.experimentalSvgIcons) el.appendChild(menuItemEl);
        else el.replaceChild(menuItemEl, el.querySelector('.vjs-icon-placeholder'));
        return el;
    }
    /**
   * Ignore keys which are used by the menu, but pass any other ones up. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        if (![
            'Tab',
            'Escape',
            'ArrowUp',
            'ArrowLeft',
            'ArrowRight',
            'ArrowDown'
        ].includes(event.key)) // Pass keydown handling up for unused keys
        super.handleKeyDown(event);
    }
    /**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        this.selected(true);
    }
    /**
   * Set the state for this menu item as selected or not.
   *
   * @param {boolean} selected
   *        if the menu item is selected or not
   */ selected(selected) {
        if (this.selectable) {
            if (selected) {
                this.addClass('vjs-selected');
                this.el_.setAttribute('aria-checked', 'true');
                // aria-checked isn't fully supported by browsers/screen readers,
                // so indicate selected state to screen reader in the control text.
                this.controlText(', selected');
                this.isSelected_ = true;
            } else {
                this.removeClass('vjs-selected');
                this.el_.setAttribute('aria-checked', 'false');
                // Indicate un-selected state to screen reader
                this.controlText('');
                this.isSelected_ = false;
            }
        }
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('MenuItem', $cb03b711053a4297$var$MenuItem);
/**
 * @file text-track-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * The specific menu item type for selecting a language within a text track kind
 *
 * @extends MenuItem
 */ class $cb03b711053a4297$var$TextTrackMenuItem extends $cb03b711053a4297$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const track = options.track;
        const tracks = player.textTracks();
        // Modify options for parent MenuItem class's init.
        options.label = track.label || track.language || 'Unknown';
        options.selected = track.mode === 'showing';
        super(player, options);
        this.track = track;
        // Determine the relevant kind(s) of tracks for this component and filter
        // out empty kinds.
        this.kinds = (options.kinds || [
            options.kind || this.track.kind
        ]).filter(Boolean);
        const changeHandler = (...args)=>{
            this.handleTracksChange.apply(this, args);
        };
        const selectedLanguageChangeHandler = (...args)=>{
            this.handleSelectedLanguageChange.apply(this, args);
        };
        player.on([
            'loadstart',
            'texttrackchange'
        ], changeHandler);
        tracks.addEventListener('change', changeHandler);
        tracks.addEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
        this.on('dispose', function() {
            player.off([
                'loadstart',
                'texttrackchange'
            ], changeHandler);
            tracks.removeEventListener('change', changeHandler);
            tracks.removeEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
        });
        // iOS7 doesn't dispatch change events to TextTrackLists when an
        // associated track's mode changes. Without something like
        // Object.observe() (also not present on iOS7), it's not
        // possible to detect changes to the mode attribute and polyfill
        // the change event. As a poor substitute, we manually dispatch
        // change events whenever the controls modify the mode.
        if (tracks.onchange === undefined) {
            let event;
            this.on([
                'tap',
                'click'
            ], function() {
                if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Event !== 'object') // Android 2.3 throws an Illegal Constructor error for window.Event
                try {
                    event = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Event('change');
                } catch (err) {
                // continue regardless of error
                }
                if (!event) {
                    event = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createEvent('Event');
                    event.initEvent('change', true, true);
                }
                tracks.dispatchEvent(event);
            });
        }
        // set the default state based on current tracks
        this.handleTracksChange();
    }
    /**
   * This gets called when an `TextTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        const referenceTrack = this.track;
        const tracks = this.player_.textTracks();
        super.handleClick(event);
        if (!tracks) return;
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            // If the track from the text tracks list is not of the right kind,
            // skip it. We do not want to affect tracks of incompatible kind(s).
            if (this.kinds.indexOf(track.kind) === -1) continue;
            // If this text track is the component's track and it is not showing,
            // set it to showing.
            if (track === referenceTrack) {
                if (track.mode !== 'showing') track.mode = 'showing';
            } else if (track.mode !== 'disabled') track.mode = 'disabled';
        }
    }
    /**
   * Handle text track list change
   *
   * @param {Event} event
   *        The `change` event that caused this function to be called.
   *
   * @listens TextTrackList#change
   */ handleTracksChange(event) {
        const shouldBeSelected = this.track.mode === 'showing';
        // Prevent redundant selected() calls because they may cause
        // screen readers to read the appended control text unnecessarily
        if (shouldBeSelected !== this.isSelected_) this.selected(shouldBeSelected);
    }
    handleSelectedLanguageChange(event) {
        if (this.track.mode === 'showing') {
            const selectedLanguage = this.player_.cache_.selectedLanguage;
            // Don't replace the kind of track across the same language
            if (selectedLanguage && selectedLanguage.enabled && selectedLanguage.language === this.track.language && selectedLanguage.kind !== this.track.kind) return;
            this.player_.cache_.selectedLanguage = {
                enabled: true,
                language: this.track.language,
                kind: this.track.kind
            };
        }
    }
    dispose() {
        // remove reference to track object on dispose
        this.track = null;
        super.dispose();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TextTrackMenuItem', $cb03b711053a4297$var$TextTrackMenuItem);
/**
 * @file off-text-track-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * A special menu item for turning off a specific type of text track
 *
 * @extends TextTrackMenuItem
 */ class $cb03b711053a4297$var$OffTextTrackMenuItem extends $cb03b711053a4297$var$TextTrackMenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        // Create pseudo track info
        // Requires options['kind']
        options.track = {
            player: player,
            // it is no longer necessary to store `kind` or `kinds` on the track itself
            // since they are now stored in the `kinds` property of all instances of
            // TextTrackMenuItem, but this will remain for backwards compatibility
            kind: options.kind,
            kinds: options.kinds,
            default: false,
            mode: 'disabled'
        };
        if (!options.kinds) options.kinds = [
            options.kind
        ];
        if (options.label) options.track.label = options.label;
        else options.track.label = options.kinds.join(' and ') + ' off';
        // MenuItem is selectable
        options.selectable = true;
        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
        options.multiSelectable = false;
        super(player, options);
    }
    /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   */ handleTracksChange(event) {
        const tracks = this.player().textTracks();
        let shouldBeSelected = true;
        for(let i = 0, l = tracks.length; i < l; i++){
            const track = tracks[i];
            if (this.options_.kinds.indexOf(track.kind) > -1 && track.mode === 'showing') {
                shouldBeSelected = false;
                break;
            }
        }
        // Prevent redundant selected() calls because they may cause
        // screen readers to read the appended control text unnecessarily
        if (shouldBeSelected !== this.isSelected_) this.selected(shouldBeSelected);
    }
    handleSelectedLanguageChange(event) {
        const tracks = this.player().textTracks();
        let allHidden = true;
        for(let i = 0, l = tracks.length; i < l; i++){
            const track = tracks[i];
            if ([
                'captions',
                'descriptions',
                'subtitles'
            ].indexOf(track.kind) > -1 && track.mode === 'showing') {
                allHidden = false;
                break;
            }
        }
        if (allHidden) this.player_.cache_.selectedLanguage = {
            enabled: false
        };
    }
    /**
   * Update control text and label on languagechange
   */ handleLanguagechange() {
        this.$('.vjs-menu-item-text').textContent = this.player_.localize(this.options_.label);
        super.handleLanguagechange();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('OffTextTrackMenuItem', $cb03b711053a4297$var$OffTextTrackMenuItem);
/**
 * @file text-track-button.js
 */ /** @import Player from '../../player' */ /**
 * The base class for buttons that toggle specific text track types (e.g. subtitles)
 *
 * @extends MenuButton
 */ class $cb03b711053a4297$var$TextTrackButton extends $cb03b711053a4297$var$TrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        options.tracks = player.textTracks();
        super(player, options);
    }
    /**
   * Create a menu item for each text track
   *
   * @param {TextTrackMenuItem[]} [items=[]]
   *        Existing array of items to use during creation
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items that were created
   */ createItems(items = [], TrackMenuItem = $cb03b711053a4297$var$TextTrackMenuItem) {
        // Label is an override for the [track] off label
        // USed to localise captions/subtitles
        let label;
        if (this.label_) label = `${this.label_} off`;
        // Add an OFF menu item to turn all tracks off
        items.push(new $cb03b711053a4297$var$OffTextTrackMenuItem(this.player_, {
            kinds: this.kinds_,
            kind: this.kind_,
            label: label
        }));
        this.hideThreshold_ += 1;
        const tracks = this.player_.textTracks();
        if (!Array.isArray(this.kinds_)) this.kinds_ = [
            this.kind_
        ];
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            // only add tracks that are of an appropriate kind and have a label
            if (this.kinds_.indexOf(track.kind) > -1) {
                const item = new TrackMenuItem(this.player_, {
                    track: track,
                    kinds: this.kinds_,
                    kind: this.kind_,
                    // MenuItem is selectable
                    selectable: true,
                    // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
                    multiSelectable: false
                });
                item.addClass(`vjs-${track.kind}-menu-item`);
                items.push(item);
            }
        }
        return items;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TextTrackButton', $cb03b711053a4297$var$TextTrackButton);
/**
 * @file chapters-track-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * The chapter track menu item
 *
 * @extends MenuItem
 */ class $cb03b711053a4297$var$ChaptersTrackMenuItem extends $cb03b711053a4297$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const track = options.track;
        const cue = options.cue;
        const currentTime = player.currentTime();
        // Modify options for parent MenuItem class's init.
        options.selectable = true;
        options.multiSelectable = false;
        options.label = cue.text;
        options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;
        super(player, options);
        this.track = track;
        this.cue = cue;
    }
    /**
   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        super.handleClick();
        this.player_.currentTime(this.cue.startTime);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('ChaptersTrackMenuItem', $cb03b711053a4297$var$ChaptersTrackMenuItem);
/**
 * @file chapters-button.js
 */ /** @import Player from '../../player' */ /** @import Menu from '../../menu/menu' */ /** @import TextTrack from '../../tracks/text-track' */ /** @import TextTrackMenuItem from '../text-track-controls/text-track-menu-item' */ /**
 * The button component for toggling and selecting chapters
 * Chapters act much differently than other text tracks
 * Cues are navigation vs. other tracks of alternative languages
 *
 * @extends TextTrackButton
 */ class $cb03b711053a4297$var$ChaptersButton extends $cb03b711053a4297$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this function is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon('chapters');
        this.selectCurrentItem_ = ()=>{
            this.items.forEach((item)=>{
                item.selected(this.track_.activeCues[0] === item.cue);
            });
        };
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-chapters-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-chapters-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Update the menu based on the current state of its items.
   *
   * @param {Event} [event]
   *        An event that triggered this function to run.
   *
   * @listens TextTrackList#addtrack
   * @listens TextTrackList#removetrack
   * @listens TextTrackList#change
   */ update(event) {
        if (event && event.track && event.track.kind !== 'chapters') return;
        const track = this.findChaptersTrack();
        if (track !== this.track_) {
            this.setTrack(track);
            super.update();
        } else if (!this.items || track && track.cues && track.cues.length !== this.items.length) // Update the menu initially or if the number of cues has changed since set
        super.update();
    }
    /**
   * Set the currently selected track for the chapters button.
   *
   * @param {TextTrack} track
   *        The new track to select. Nothing will change if this is the currently selected
   *        track.
   */ setTrack(track) {
        if (this.track_ === track) return;
        if (!this.updateHandler_) this.updateHandler_ = this.update.bind(this);
        // here this.track_ refers to the old track instance
        if (this.track_) {
            const remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
            if (remoteTextTrackEl) remoteTextTrackEl.removeEventListener('load', this.updateHandler_);
            this.track_.removeEventListener('cuechange', this.selectCurrentItem_);
            this.track_ = null;
        }
        this.track_ = track;
        // here this.track_ refers to the new track instance
        if (this.track_) {
            this.track_.mode = 'hidden';
            const remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
            if (remoteTextTrackEl) remoteTextTrackEl.addEventListener('load', this.updateHandler_);
            this.track_.addEventListener('cuechange', this.selectCurrentItem_);
        }
    }
    /**
   * Find the track object that is currently in use by this ChaptersButton
   *
   * @return {TextTrack|undefined}
   *         The current track or undefined if none was found.
   */ findChaptersTrack() {
        const tracks = this.player_.textTracks() || [];
        for(let i = tracks.length - 1; i >= 0; i--){
            // We will always choose the last track as our chaptersTrack
            const track = tracks[i];
            if (track.kind === this.kind_) return track;
        }
    }
    /**
   * Get the caption for the ChaptersButton based on the track label. This will also
   * use the current tracks localized kind as a fallback if a label does not exist.
   *
   * @return {string}
   *         The tracks current label or the localized track kind.
   */ getMenuCaption() {
        if (this.track_ && this.track_.label) return this.track_.label;
        return this.localize($cb03b711053a4297$var$toTitleCase$1(this.kind_));
    }
    /**
   * Create menu from chapter track
   *
   * @return {Menu}
   *         New menu for the chapter buttons
   */ createMenu() {
        this.options_.title = this.getMenuCaption();
        return super.createMenu();
    }
    /**
   * Create a menu item for each text track
   *
   * @return  {TextTrackMenuItem[]}
   *         Array of menu items
   */ createItems() {
        const items = [];
        if (!this.track_) return items;
        const cues = this.track_.cues;
        if (!cues) return items;
        for(let i = 0, l = cues.length; i < l; i++){
            const cue = cues[i];
            const mi = new $cb03b711053a4297$var$ChaptersTrackMenuItem(this.player_, {
                track: this.track_,
                cue: cue
            });
            items.push(mi);
        }
        return items;
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$ChaptersButton.prototype.kind_ = 'chapters';
/**
 * The text that should display over the `ChaptersButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$ChaptersButton.prototype.controlText_ = 'Chapters';
$cb03b711053a4297$var$Component$1.registerComponent('ChaptersButton', $cb03b711053a4297$var$ChaptersButton);
/**
 * @file descriptions-button.js
 */ /** @import Player from '../../player' */ /**
 * The button component for toggling and selecting descriptions
 *
 * @extends TextTrackButton
 */ class $cb03b711053a4297$var$DescriptionsButton extends $cb03b711053a4297$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon('audio-description');
        const tracks = player.textTracks();
        const changeHandler = $cb03b711053a4297$var$bind_(this, this.handleTracksChange);
        tracks.addEventListener('change', changeHandler);
        this.on('dispose', function() {
            tracks.removeEventListener('change', changeHandler);
        });
    }
    /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   *
   * @listens TextTrackList#change
   */ handleTracksChange(event) {
        const tracks = this.player().textTracks();
        let disabled = false;
        // Check whether a track of a different kind is showing
        for(let i = 0, l = tracks.length; i < l; i++){
            const track = tracks[i];
            if (track.kind !== this.kind_ && track.mode === 'showing') {
                disabled = true;
                break;
            }
        }
        // If another track is showing, disable this menu button
        if (disabled) this.disable();
        else this.enable();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-descriptions-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-descriptions-button ${super.buildWrapperCSSClass()}`;
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$DescriptionsButton.prototype.kind_ = 'descriptions';
/**
 * The text that should display over the `DescriptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$DescriptionsButton.prototype.controlText_ = 'Descriptions';
$cb03b711053a4297$var$Component$1.registerComponent('DescriptionsButton', $cb03b711053a4297$var$DescriptionsButton);
/**
 * @file subtitles-button.js
 */ /** @import Player from '../../player' */ /**
 * The button component for toggling and selecting subtitles
 *
 * @extends TextTrackButton
 */ class $cb03b711053a4297$var$SubtitlesButton extends $cb03b711053a4297$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon('subtitles');
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-subtitles-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-subtitles-button ${super.buildWrapperCSSClass()}`;
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$SubtitlesButton.prototype.kind_ = 'subtitles';
/**
 * The text that should display over the `SubtitlesButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$SubtitlesButton.prototype.controlText_ = 'Subtitles';
$cb03b711053a4297$var$Component$1.registerComponent('SubtitlesButton', $cb03b711053a4297$var$SubtitlesButton);
/**
 * @file caption-settings-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * The menu item for caption track settings menu
 *
 * @extends TextTrackMenuItem
 */ class $cb03b711053a4297$var$CaptionSettingsMenuItem extends $cb03b711053a4297$var$TextTrackMenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        options.track = {
            player: player,
            kind: options.kind,
            label: options.kind + ' settings',
            selectable: false,
            default: false,
            mode: 'disabled'
        };
        // CaptionSettingsMenuItem has no concept of 'selected'
        options.selectable = false;
        options.name = 'CaptionSettingsMenuItem';
        super(player, options);
        this.addClass('vjs-texttrack-settings');
        this.controlText(', opens ' + options.kind + ' settings dialog');
    }
    /**
   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        this.player().getChild('textTrackSettings').open();
    }
    /**
   * Update control text and label on languagechange
   */ handleLanguagechange() {
        this.$('.vjs-menu-item-text').textContent = this.player_.localize(this.options_.kind + ' settings');
        super.handleLanguagechange();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('CaptionSettingsMenuItem', $cb03b711053a4297$var$CaptionSettingsMenuItem);
/**
 * @file captions-button.js
 */ /** @import Player from '../../player' */ /**
 * The button component for toggling and selecting captions
 *
 * @extends TextTrackButton
 */ class $cb03b711053a4297$var$CaptionsButton extends $cb03b711053a4297$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon('captions');
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-captions-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-captions-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create caption menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */ createItems() {
        const items = [];
        if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
            items.push(new $cb03b711053a4297$var$CaptionSettingsMenuItem(this.player_, {
                kind: this.kind_
            }));
            this.hideThreshold_ += 1;
        }
        return super.createItems(items);
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$CaptionsButton.prototype.kind_ = 'captions';
/**
 * The text that should display over the `CaptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$CaptionsButton.prototype.controlText_ = 'Captions';
$cb03b711053a4297$var$Component$1.registerComponent('CaptionsButton', $cb03b711053a4297$var$CaptionsButton);
/**
 * @file subs-caps-menu-item.js
 */ /**
 * SubsCapsMenuItem has an [cc] icon to distinguish captions from subtitles
 * in the SubsCapsMenu.
 *
 * @extends TextTrackMenuItem
 */ class $cb03b711053a4297$var$SubsCapsMenuItem extends $cb03b711053a4297$var$TextTrackMenuItem {
    createEl(type, props, attrs) {
        const el = super.createEl(type, props, attrs);
        const parentSpan = el.querySelector('.vjs-menu-item-text');
        if (this.options_.track.kind === 'captions') {
            if (this.player_.options_.experimentalSvgIcons) this.setIcon('captions', el);
            else parentSpan.appendChild($cb03b711053a4297$var$createEl('span', {
                className: 'vjs-icon-placeholder'
            }, {
                'aria-hidden': true
            }));
            parentSpan.appendChild($cb03b711053a4297$var$createEl('span', {
                className: 'vjs-control-text',
                // space added as the text will visually flow with the
                // label
                textContent: ` ${this.localize('Captions')}`
            }));
        }
        return el;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('SubsCapsMenuItem', $cb03b711053a4297$var$SubsCapsMenuItem);
/**
 * @file sub-caps-button.js
 */ /** @import Player from '../../player' */ /**
 * The button component for toggling and selecting captions and/or subtitles
 *
 * @extends TextTrackButton
 */ class $cb03b711053a4297$var$SubsCapsButton extends $cb03b711053a4297$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options = {}){
        super(player, options);
        // Although North America uses "captions" in most cases for
        // "captions and subtitles" other locales use "subtitles"
        this.label_ = 'subtitles';
        this.setIcon('subtitles');
        if ([
            'en',
            'en-us',
            'en-ca',
            'fr-ca'
        ].indexOf(this.player_.language_) > -1) {
            this.label_ = 'captions';
            this.setIcon('captions');
        }
        this.menuButton_.controlText($cb03b711053a4297$var$toTitleCase$1(this.label_));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-subs-caps-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-subs-caps-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */ createItems() {
        let items = [];
        if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
            items.push(new $cb03b711053a4297$var$CaptionSettingsMenuItem(this.player_, {
                kind: this.label_
            }));
            this.hideThreshold_ += 1;
        }
        items = super.createItems(items, $cb03b711053a4297$var$SubsCapsMenuItem);
        return items;
    }
}
/**
 * `kind`s of TextTrack to look for to associate it with this menu.
 *
 * @type {array}
 * @private
 */ $cb03b711053a4297$var$SubsCapsButton.prototype.kinds_ = [
    'captions',
    'subtitles'
];
/**
 * The text that should display over the `SubsCapsButton`s controls.
 *
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$SubsCapsButton.prototype.controlText_ = 'Subtitles';
$cb03b711053a4297$var$Component$1.registerComponent('SubsCapsButton', $cb03b711053a4297$var$SubsCapsButton);
/**
 * @file audio-track-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * An {@link AudioTrack} {@link MenuItem}
 *
 * @extends MenuItem
 */ class $cb03b711053a4297$var$AudioTrackMenuItem extends $cb03b711053a4297$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const track = options.track;
        const tracks = player.audioTracks();
        // Modify options for parent MenuItem class's init.
        options.label = track.label || track.language || 'Unknown';
        options.selected = track.enabled;
        super(player, options);
        this.track = track;
        this.addClass(`vjs-${track.kind}-menu-item`);
        const changeHandler = (...args)=>{
            this.handleTracksChange.apply(this, args);
        };
        tracks.addEventListener('change', changeHandler);
        this.on('dispose', ()=>{
            tracks.removeEventListener('change', changeHandler);
        });
    }
    createEl(type, props, attrs) {
        const el = super.createEl(type, props, attrs);
        const parentSpan = el.querySelector('.vjs-menu-item-text');
        if ([
            'main-desc',
            'descriptions'
        ].indexOf(this.options_.track.kind) >= 0) {
            parentSpan.appendChild($cb03b711053a4297$var$createEl('span', {
                className: 'vjs-icon-placeholder'
            }, {
                'aria-hidden': true
            }));
            parentSpan.appendChild($cb03b711053a4297$var$createEl('span', {
                className: 'vjs-control-text',
                textContent: ' ' + this.localize('Descriptions')
            }));
        }
        return el;
    }
    /**
   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        super.handleClick(event);
        // the audio track list will automatically toggle other tracks
        // off for us.
        this.track.enabled = true;
        // when native audio tracks are used, we want to make sure that other tracks are turned off
        if (this.player_.tech_.featuresNativeAudioTracks) {
            const tracks = this.player_.audioTracks();
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                // skip the current track since we enabled it above
                if (track === this.track) continue;
                track.enabled = track === this.track;
            }
        }
    }
    /**
   * Handle any {@link AudioTrack} change.
   *
   * @param {Event} [event]
   *        The {@link AudioTrackList#change} event that caused this to run.
   *
   * @listens AudioTrackList#change
   */ handleTracksChange(event) {
        this.selected(this.track.enabled);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('AudioTrackMenuItem', $cb03b711053a4297$var$AudioTrackMenuItem);
/**
 * @file audio-track-button.js
 */ /**
 * The base class for buttons that toggle specific {@link AudioTrack} types.
 *
 * @extends TrackButton
 */ class $cb03b711053a4297$var$AudioTrackButton extends $cb03b711053a4297$var$TrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        options.tracks = player.audioTracks();
        super(player, options);
        this.setIcon('audio');
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-audio-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-audio-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create a menu item for each audio track
   *
   * @param {AudioTrackMenuItem[]} [items=[]]
   *        An array of existing menu items to use.
   *
   * @return {AudioTrackMenuItem[]}
   *         An array of menu items
   */ createItems(items = []) {
        // if there's only one audio track, there no point in showing it
        this.hideThreshold_ = 1;
        const tracks = this.player_.audioTracks();
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            items.push(new $cb03b711053a4297$var$AudioTrackMenuItem(this.player_, {
                track: track,
                // MenuItem is selectable
                selectable: true,
                // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
                multiSelectable: false
            }));
        }
        return items;
    }
}
/**
 * The text that should display over the `AudioTrackButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$AudioTrackButton.prototype.controlText_ = 'Audio Track';
$cb03b711053a4297$var$Component$1.registerComponent('AudioTrackButton', $cb03b711053a4297$var$AudioTrackButton);
/**
 * @file playback-rate-menu-item.js
 */ /** @import Player from '../../player' */ /**
 * The specific menu item type for selecting a playback rate.
 *
 * @extends MenuItem
 */ class $cb03b711053a4297$var$PlaybackRateMenuItem extends $cb03b711053a4297$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const label = options.rate;
        const rate = parseFloat(label, 10);
        // Modify options for parent MenuItem class's init.
        options.label = label;
        options.selected = rate === player.playbackRate();
        options.selectable = true;
        options.multiSelectable = false;
        super(player, options);
        this.label = label;
        this.rate = rate;
        this.on(player, 'ratechange', (e)=>this.update(e));
    }
    /**
   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        super.handleClick();
        this.player().playbackRate(this.rate);
    }
    /**
   * Update the PlaybackRateMenuItem when the playbackrate changes.
   *
   * @param {Event} [event]
   *        The `ratechange` event that caused this function to run.
   *
   * @listens Player#ratechange
   */ update(event) {
        this.selected(this.player().playbackRate() === this.rate);
    }
}
/**
 * The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$PlaybackRateMenuItem.prototype.contentElType = 'button';
$cb03b711053a4297$var$Component$1.registerComponent('PlaybackRateMenuItem', $cb03b711053a4297$var$PlaybackRateMenuItem);
/**
 * @file playback-rate-menu-button.js
 */ /** @import Player from '../../player' */ /**
 * The component for controlling the playback rate.
 *
 * @extends MenuButton
 */ class $cb03b711053a4297$var$PlaybackRateMenuButton extends $cb03b711053a4297$var$MenuButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.menuButton_.el_.setAttribute('aria-describedby', this.labelElId_);
        this.updateVisibility();
        this.updateLabel();
        this.on(player, 'loadstart', (e)=>this.updateVisibility(e));
        this.on(player, 'ratechange', (e)=>this.updateLabel(e));
        this.on(player, 'playbackrateschange', (e)=>this.handlePlaybackRateschange(e));
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl();
        this.labelElId_ = 'vjs-playback-rate-value-label-' + this.id_;
        this.labelEl_ = $cb03b711053a4297$var$createEl('div', {
            className: 'vjs-playback-rate-value',
            id: this.labelElId_,
            textContent: '1x'
        });
        el.appendChild(this.labelEl_);
        return el;
    }
    dispose() {
        this.labelEl_ = null;
        super.dispose();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-playback-rate ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-playback-rate ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create the list of menu items. Specific to each subclass.
   *
   */ createItems() {
        const rates = this.playbackRates();
        const items = [];
        for(let i = rates.length - 1; i >= 0; i--)items.push(new $cb03b711053a4297$var$PlaybackRateMenuItem(this.player(), {
            rate: rates[i] + 'x'
        }));
        return items;
    }
    /**
   * On playbackrateschange, update the menu to account for the new items.
   *
   * @listens Player#playbackrateschange
   */ handlePlaybackRateschange(event) {
        this.update();
    }
    /**
   * Get possible playback rates
   *
   * @return {Array}
   *         All possible playback rates
   */ playbackRates() {
        const player = this.player();
        return player.playbackRates && player.playbackRates() || [];
    }
    /**
   * Get whether playback rates is supported by the tech
   * and an array of playback rates exists
   *
   * @return {boolean}
   *         Whether changing playback rate is supported
   */ playbackRateSupported() {
        return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
    }
    /**
   * Hide playback rate controls when they're no playback rate options to select
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#loadstart
   */ updateVisibility(event) {
        if (this.playbackRateSupported()) this.removeClass('vjs-hidden');
        else this.addClass('vjs-hidden');
    }
    /**
   * Update button label when rate changed
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ratechange
   */ updateLabel(event) {
        if (this.playbackRateSupported()) this.labelEl_.textContent = this.player().playbackRate() + 'x';
    }
}
/**
 * The text that should display over the `PlaybackRateMenuButton`s controls.
 *
 * Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$PlaybackRateMenuButton.prototype.controlText_ = 'Playback Rate';
$cb03b711053a4297$var$Component$1.registerComponent('PlaybackRateMenuButton', $cb03b711053a4297$var$PlaybackRateMenuButton);
/**
 * @file spacer.js
 */ /**
 * Just an empty spacer element that can be used as an append point for plugins, etc.
 * Also can be used to create space between elements when necessary.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$Spacer extends $cb03b711053a4297$var$Component$1 {
    /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */ buildCSSClass() {
        return `vjs-spacer ${super.buildCSSClass()}`;
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl(tag = 'div', props = {}, attributes = {}) {
        if (!props.className) props.className = this.buildCSSClass();
        return super.createEl(tag, props, attributes);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('Spacer', $cb03b711053a4297$var$Spacer);
/**
 * @file custom-control-spacer.js
 */ /**
 * Spacer specifically meant to be used as an insertion point for new plugins, etc.
 *
 * @extends Spacer
 */ class $cb03b711053a4297$var$CustomControlSpacer extends $cb03b711053a4297$var$Spacer {
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-custom-control-spacer ${super.buildCSSClass()}`;
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: this.buildCSSClass(),
            // No-flex/table-cell mode requires there be some content
            // in the cell to fill the remaining space of the table.
            textContent: '\u00a0'
        });
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('CustomControlSpacer', $cb03b711053a4297$var$CustomControlSpacer);
/**
 * @file control-bar.js
 */ /**
 * Container of main controls.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$ControlBar extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl('div', {
            className: 'vjs-control-bar',
            dir: 'ltr'
        });
    }
}
/**
 * Default options for `ControlBar`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$ControlBar.prototype.options_ = {
    children: [
        'playToggle',
        'skipBackward',
        'skipForward',
        'volumePanel',
        'currentTimeDisplay',
        'timeDivider',
        'durationDisplay',
        'progressControl',
        'liveDisplay',
        'seekToLive',
        'remainingTimeDisplay',
        'customControlSpacer',
        'playbackRateMenuButton',
        'chaptersButton',
        'descriptionsButton',
        'subsCapsButton',
        'audioTrackButton',
        'pictureInPictureToggle',
        'fullscreenToggle'
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent('ControlBar', $cb03b711053a4297$var$ControlBar);
/**
 * @file error-display.js
 */ /** @import Player from './player' */ /**
 * A display that indicates an error has occurred. This means that the video
 * is unplayable.
 *
 * @extends ModalDialog
 */ class $cb03b711053a4297$var$ErrorDisplay extends $cb03b711053a4297$var$ModalDialog {
    /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on(player, 'error', (e)=>{
            this.open(e);
        });
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   *
   * @deprecated Since version 5.
   */ buildCSSClass() {
        return `vjs-error-display ${super.buildCSSClass()}`;
    }
    /**
   * Gets the localized error message based on the `Player`s error.
   *
   * @return {string}
   *         The `Player`s error message localized or an empty string.
   */ content() {
        const error = this.player().error();
        return error ? this.localize(error.message) : '';
    }
}
/**
 * The default options for an `ErrorDisplay`.
 *
 * @private
 */ $cb03b711053a4297$var$ErrorDisplay.prototype.options_ = Object.assign({}, $cb03b711053a4297$var$ModalDialog.prototype.options_, {
    pauseOnOpen: false,
    fillAlways: true,
    temporary: false,
    uncloseable: true
});
$cb03b711053a4297$var$Component$1.registerComponent('ErrorDisplay', $cb03b711053a4297$var$ErrorDisplay);
/** @import Player from './player' */ /** @import { ContentDescriptor } from  '../utils/dom' */ /**
 * Creates DOM element of 'select' & its options.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TextTrackSelect extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements.
   */ constructor(player, options = {}){
        super(player, options);
        this.el_.setAttribute('aria-labelledby', this.selectLabelledbyIds);
    }
    /**
   * Create the `TextTrackSelect`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        this.selectLabelledbyIds = [
            this.options_.legendId,
            this.options_.labelId
        ].join(' ').trim();
        // Create select & inner options
        const selectoptions = $cb03b711053a4297$var$createEl('select', {
            id: this.options_.id
        }, {}, this.options_.SelectOptions.map((optionText)=>{
            // Constructs an id for the <option>.
            // For the colour settings that have two <selects> with a <label> each, generates an id based off the label value
            // For font size/family and edge style with one <select> and no <label>, generates an id with a guid
            const optionId = (this.options_.labelId ? this.options_.labelId : `vjs-track-option-${$cb03b711053a4297$var$newGUID()}`) + '-' + optionText[1].replace(/\W+/g, '');
            const option = $cb03b711053a4297$var$createEl('option', {
                id: optionId,
                value: this.localize(optionText[0]),
                textContent: this.localize(optionText[1])
            });
            option.setAttribute('aria-labelledby', `${this.selectLabelledbyIds} ${optionId}`);
            return option;
        }));
        return selectoptions;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TextTrackSelect', $cb03b711053a4297$var$TextTrackSelect);
/** @import Player from './player' */ /** @import { ContentDescriptor } from '../utils/dom' */ /**
 * Creates fieldset section of 'TextTrackSettings'.
 * Manganes two versions of fieldsets, one for type of 'colors'
 * & the other for 'font', Component adds diferent DOM elements
 * to that fieldset  depending on the type.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TextTrackFieldset extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.legendText]
   *        A text to use as the text content of the legend element.
   *
   * @param {Array} [options.selects]
   *        Array that contains the selects that are use to create 'selects'
   *        components.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements, it passes to 'TextTrackSelect'.
   *
   * @param {string} [options.type]
   *        Conditions if some DOM elements will be added to the fieldset
   *        component.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the selects configurations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        These properties are use to configure the 'TextTrackSelect' Component.
   */ constructor(player, options = {}){
        super(player, options);
        // Add Components & DOM Elements
        const legendElement = $cb03b711053a4297$var$createEl('legend', {
            textContent: this.localize(this.options_.legendText),
            id: this.options_.legendId
        });
        this.el().appendChild(legendElement);
        const selects = this.options_.selects;
        // Iterate array of selects to create 'selects' components
        for (const i of selects){
            const selectConfig = this.options_.selectConfigs[i];
            const selectClassName = selectConfig.className;
            const id = selectConfig.id.replace('%s', this.options_.id_);
            let span = null;
            const guid = `vjs_select_${$cb03b711053a4297$var$newGUID()}`;
            // Conditionally create span to add on the component
            if (this.options_.type === 'colors') {
                span = $cb03b711053a4297$var$createEl('span', {
                    className: selectClassName
                });
                const label = $cb03b711053a4297$var$createEl('label', {
                    id: id,
                    className: 'vjs-label',
                    textContent: this.localize(selectConfig.label)
                });
                label.setAttribute('for', guid);
                span.appendChild(label);
            }
            const textTrackSelect = new $cb03b711053a4297$var$TextTrackSelect(player, {
                SelectOptions: selectConfig.options,
                legendId: this.options_.legendId,
                id: guid,
                labelId: id
            });
            this.addChild(textTrackSelect);
            // Conditionally append to 'select' component to conditionally created span
            if (this.options_.type === 'colors') {
                span.appendChild(textTrackSelect.el());
                this.el().appendChild(span);
            }
        }
    }
    /**
   * Create the `TextTrackFieldset`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        const el = $cb03b711053a4297$var$createEl('fieldset', {
            // Prefixing classes of elements within a player with "vjs-"
            // is a convention used in Video.js.
            className: this.options_.className
        });
        return el;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TextTrackFieldset', $cb03b711053a4297$var$TextTrackFieldset);
/** @import Player from './player' */ /** @import { ContentDescriptor } from  '../utils/dom' */ /**
 * The component 'TextTrackSettingsColors' displays a set of 'fieldsets'
 * using the component 'TextTrackFieldset'.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TextTrackSettingsColors extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */ constructor(player, options = {}){
        super(player, options);
        const id_ = this.options_.textTrackComponentid;
        // createElFgColor_
        const ElFgColorFieldset = new $cb03b711053a4297$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-text-legend-${id_}`,
            legendText: this.localize('Text'),
            className: 'vjs-fg vjs-track-setting',
            selects: this.options_.fieldSets[0],
            selectConfigs: this.options_.selectConfigs,
            type: 'colors'
        });
        this.addChild(ElFgColorFieldset);
        // createElBgColor_
        const ElBgColorFieldset = new $cb03b711053a4297$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-background-${id_}`,
            legendText: this.localize('Text Background'),
            className: 'vjs-bg vjs-track-setting',
            selects: this.options_.fieldSets[1],
            selectConfigs: this.options_.selectConfigs,
            type: 'colors'
        });
        this.addChild(ElBgColorFieldset);
        // createElWinColor_
        const ElWinColorFieldset = new $cb03b711053a4297$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-window-${id_}`,
            legendText: this.localize('Caption Area Background'),
            className: 'vjs-window vjs-track-setting',
            selects: this.options_.fieldSets[2],
            selectConfigs: this.options_.selectConfigs,
            type: 'colors'
        });
        this.addChild(ElWinColorFieldset);
    }
    /**
   * Create the `TextTrackSettingsColors`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        const el = $cb03b711053a4297$var$createEl('div', {
            className: 'vjs-track-settings-colors'
        });
        return el;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TextTrackSettingsColors', $cb03b711053a4297$var$TextTrackSettingsColors);
/** @import Player from './player' */ /** @import { ContentDescriptor } from  '../utils/dom' */ /**
 * The component 'TextTrackSettingsFont' displays a set of 'fieldsets'
 * using the component 'TextTrackFieldset'.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TextTrackSettingsFont extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */ constructor(player, options = {}){
        super(player, options);
        const id_ = this.options_.textTrackComponentid;
        const ElFgColorFieldset = new $cb03b711053a4297$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-font-size-${id_}`,
            legendText: 'Font Size',
            className: 'vjs-font-percent vjs-track-setting',
            selects: this.options_.fieldSets[0],
            selectConfigs: this.options_.selectConfigs,
            type: 'font'
        });
        this.addChild(ElFgColorFieldset);
        const ElBgColorFieldset = new $cb03b711053a4297$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-edge-style-${id_}`,
            legendText: this.localize('Text Edge Style'),
            className: 'vjs-edge-style vjs-track-setting',
            selects: this.options_.fieldSets[1],
            selectConfigs: this.options_.selectConfigs,
            type: 'font'
        });
        this.addChild(ElBgColorFieldset);
        const ElWinColorFieldset = new $cb03b711053a4297$var$TextTrackFieldset(player, {
            id_: id_,
            legendId: `captions-font-family-${id_}`,
            legendText: this.localize('Font Family'),
            className: 'vjs-font-family vjs-track-setting',
            selects: this.options_.fieldSets[2],
            selectConfigs: this.options_.selectConfigs,
            type: 'font'
        });
        this.addChild(ElWinColorFieldset);
    }
    /**
   * Create the `TextTrackSettingsFont`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        const el = $cb03b711053a4297$var$createEl('div', {
            className: 'vjs-track-settings-font'
        });
        return el;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TextTrackSettingsFont', $cb03b711053a4297$var$TextTrackSettingsFont);
/**
 * Buttons of reset & done that modal 'TextTrackSettings'
 * uses as part of its content.
 *
 * 'Reset': Resets all settings on 'TextTrackSettings'.
 * 'Done': Closes 'TextTrackSettings' modal.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TrackSettingsControls extends $cb03b711053a4297$var$Component$1 {
    constructor(player, options = {}){
        super(player, options);
        // Create DOM elements
        const resetButton = new $cb03b711053a4297$var$Button(player, {
            controlText: this.localize('restore all settings to the default values'),
            className: 'vjs-default-button'
        });
        resetButton.el().classList.remove('vjs-control', 'vjs-button');
        resetButton.el().textContent = this.localize('Reset');
        this.addChild(resetButton);
        const doneText = this.localize('Done');
        const doneButton = new $cb03b711053a4297$var$Button(player, {
            controlText: doneText,
            className: 'vjs-done-button'
        });
        // Remove unrequired style classes
        doneButton.el().classList.remove('vjs-control', 'vjs-button');
        doneButton.el().textContent = doneText;
        this.addChild(doneButton);
    }
    /**
   * Create the `TrackSettingsControls`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        const el = $cb03b711053a4297$var$createEl('div', {
            className: 'vjs-track-settings-controls'
        });
        return el;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TrackSettingsControls', $cb03b711053a4297$var$TrackSettingsControls);
/**
 * @file text-track-settings.js
 */ /** @import Player from '../player' */ const $cb03b711053a4297$var$LOCAL_STORAGE_KEY$1 = 'vjs-text-track-settings';
const $cb03b711053a4297$var$COLOR_BLACK = [
    '#000',
    'Black'
];
const $cb03b711053a4297$var$COLOR_BLUE = [
    '#00F',
    'Blue'
];
const $cb03b711053a4297$var$COLOR_CYAN = [
    '#0FF',
    'Cyan'
];
const $cb03b711053a4297$var$COLOR_GREEN = [
    '#0F0',
    'Green'
];
const $cb03b711053a4297$var$COLOR_MAGENTA = [
    '#F0F',
    'Magenta'
];
const $cb03b711053a4297$var$COLOR_RED = [
    '#F00',
    'Red'
];
const $cb03b711053a4297$var$COLOR_WHITE = [
    '#FFF',
    'White'
];
const $cb03b711053a4297$var$COLOR_YELLOW = [
    '#FF0',
    'Yellow'
];
const $cb03b711053a4297$var$OPACITY_OPAQUE = [
    '1',
    'Opaque'
];
const $cb03b711053a4297$var$OPACITY_SEMI = [
    '0.5',
    'Semi-Transparent'
];
const $cb03b711053a4297$var$OPACITY_TRANS = [
    '0',
    'Transparent'
];
// Configuration for the various <select> elements in the DOM of this component.
//
// Possible keys include:
//
// `default`:
//   The default option index. Only needs to be provided if not zero.
// `parser`:
//   A function which is used to parse the value from the selected option in
//   a customized way.
// `selector`:
//   The selector used to find the associated <select> element.
const $cb03b711053a4297$var$selectConfigs = {
    backgroundColor: {
        selector: '.vjs-bg-color > select',
        id: 'captions-background-color-%s',
        label: 'Color',
        options: [
            $cb03b711053a4297$var$COLOR_BLACK,
            $cb03b711053a4297$var$COLOR_WHITE,
            $cb03b711053a4297$var$COLOR_RED,
            $cb03b711053a4297$var$COLOR_GREEN,
            $cb03b711053a4297$var$COLOR_BLUE,
            $cb03b711053a4297$var$COLOR_YELLOW,
            $cb03b711053a4297$var$COLOR_MAGENTA,
            $cb03b711053a4297$var$COLOR_CYAN
        ],
        className: 'vjs-bg-color'
    },
    backgroundOpacity: {
        selector: '.vjs-bg-opacity > select',
        id: 'captions-background-opacity-%s',
        label: 'Opacity',
        options: [
            $cb03b711053a4297$var$OPACITY_OPAQUE,
            $cb03b711053a4297$var$OPACITY_SEMI,
            $cb03b711053a4297$var$OPACITY_TRANS
        ],
        className: 'vjs-bg-opacity vjs-opacity'
    },
    color: {
        selector: '.vjs-text-color > select',
        id: 'captions-foreground-color-%s',
        label: 'Color',
        options: [
            $cb03b711053a4297$var$COLOR_WHITE,
            $cb03b711053a4297$var$COLOR_BLACK,
            $cb03b711053a4297$var$COLOR_RED,
            $cb03b711053a4297$var$COLOR_GREEN,
            $cb03b711053a4297$var$COLOR_BLUE,
            $cb03b711053a4297$var$COLOR_YELLOW,
            $cb03b711053a4297$var$COLOR_MAGENTA,
            $cb03b711053a4297$var$COLOR_CYAN
        ],
        className: 'vjs-text-color'
    },
    edgeStyle: {
        selector: '.vjs-edge-style > select',
        id: '',
        label: 'Text Edge Style',
        options: [
            [
                'none',
                'None'
            ],
            [
                'raised',
                'Raised'
            ],
            [
                'depressed',
                'Depressed'
            ],
            [
                'uniform',
                'Uniform'
            ],
            [
                'dropshadow',
                'Drop shadow'
            ]
        ]
    },
    fontFamily: {
        selector: '.vjs-font-family > select',
        id: '',
        label: 'Font Family',
        options: [
            [
                'proportionalSansSerif',
                'Proportional Sans-Serif'
            ],
            [
                'monospaceSansSerif',
                'Monospace Sans-Serif'
            ],
            [
                'proportionalSerif',
                'Proportional Serif'
            ],
            [
                'monospaceSerif',
                'Monospace Serif'
            ],
            [
                'casual',
                'Casual'
            ],
            [
                'script',
                'Script'
            ],
            [
                'small-caps',
                'Small Caps'
            ]
        ]
    },
    fontPercent: {
        selector: '.vjs-font-percent > select',
        id: '',
        label: 'Font Size',
        options: [
            [
                '0.50',
                '50%'
            ],
            [
                '0.75',
                '75%'
            ],
            [
                '1.00',
                '100%'
            ],
            [
                '1.25',
                '125%'
            ],
            [
                '1.50',
                '150%'
            ],
            [
                '1.75',
                '175%'
            ],
            [
                '2.00',
                '200%'
            ],
            [
                '3.00',
                '300%'
            ],
            [
                '4.00',
                '400%'
            ]
        ],
        default: 2,
        parser: (v)=>v === '1.00' ? null : Number(v)
    },
    textOpacity: {
        selector: '.vjs-text-opacity > select',
        id: 'captions-foreground-opacity-%s',
        label: 'Opacity',
        options: [
            $cb03b711053a4297$var$OPACITY_OPAQUE,
            $cb03b711053a4297$var$OPACITY_SEMI
        ],
        className: 'vjs-text-opacity vjs-opacity'
    },
    // Options for this object are defined below.
    windowColor: {
        selector: '.vjs-window-color > select',
        id: 'captions-window-color-%s',
        label: 'Color',
        className: 'vjs-window-color'
    },
    // Options for this object are defined below.
    windowOpacity: {
        selector: '.vjs-window-opacity > select',
        id: 'captions-window-opacity-%s',
        label: 'Opacity',
        options: [
            $cb03b711053a4297$var$OPACITY_TRANS,
            $cb03b711053a4297$var$OPACITY_SEMI,
            $cb03b711053a4297$var$OPACITY_OPAQUE
        ],
        className: 'vjs-window-opacity vjs-opacity'
    }
};
$cb03b711053a4297$var$selectConfigs.windowColor.options = $cb03b711053a4297$var$selectConfigs.backgroundColor.options;
/**
 * Get the actual value of an option.
 *
 * @param  {string} value
 *         The value to get
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {*}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */ function $cb03b711053a4297$var$parseOptionValue(value, parser) {
    if (parser) value = parser(value);
    if (value && value !== 'none') return value;
}
/**
 * Gets the value of the selected <option> element within a <select> element.
 *
 * @param  {Element} el
 *         the element to look in
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {*}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */ function $cb03b711053a4297$var$getSelectedOptionValue(el, parser) {
    const value = el.options[el.options.selectedIndex].value;
    return $cb03b711053a4297$var$parseOptionValue(value, parser);
}
/**
 * Sets the selected <option> element within a <select> element based on a
 * given value.
 *
 * @param {Element} el
 *        The element to look in.
 *
 * @param {string} value
 *        the property to look on.
 *
 * @param {Function} [parser]
 *        Optional function to adjust the value before comparing.
 *
 * @private
 */ function $cb03b711053a4297$var$setSelectedOption(el, value, parser) {
    if (!value) return;
    for(let i = 0; i < el.options.length; i++)if ($cb03b711053a4297$var$parseOptionValue(el.options[i].value, parser) === value) {
        el.selectedIndex = i;
        break;
    }
}
/**
 * Manipulate Text Tracks settings.
 *
 * @extends ModalDialog
 */ class $cb03b711053a4297$var$TextTrackSettings extends $cb03b711053a4297$var$ModalDialog {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *         The key/value store of player options.
   */ constructor(player, options){
        options.temporary = false;
        super(player, options);
        this.updateDisplay = this.updateDisplay.bind(this);
        // fill the modal and pretend we have opened it
        this.fill();
        this.hasBeenOpened_ = this.hasBeenFilled_ = true;
        this.renderModalComponents(player);
        this.endDialog = $cb03b711053a4297$var$createEl('p', {
            className: 'vjs-control-text',
            textContent: this.localize('End of dialog window.')
        });
        this.el().appendChild(this.endDialog);
        this.setDefaults();
        // Grab `persistTextTrackSettings` from the player options if not passed in child options
        if (options.persistTextTrackSettings === undefined) this.options_.persistTextTrackSettings = this.options_.playerOptions.persistTextTrackSettings;
        this.bindFunctionsToSelectsAndButtons();
        if (this.options_.persistTextTrackSettings) this.restoreSettings();
    }
    renderModalComponents(player) {
        const textTrackSettingsColors = new $cb03b711053a4297$var$TextTrackSettingsColors(player, {
            textTrackComponentid: this.id_,
            selectConfigs: $cb03b711053a4297$var$selectConfigs,
            fieldSets: [
                [
                    'color',
                    'textOpacity'
                ],
                [
                    'backgroundColor',
                    'backgroundOpacity'
                ],
                [
                    'windowColor',
                    'windowOpacity'
                ]
            ]
        });
        this.addChild(textTrackSettingsColors);
        const textTrackSettingsFont = new $cb03b711053a4297$var$TextTrackSettingsFont(player, {
            textTrackComponentid: this.id_,
            selectConfigs: $cb03b711053a4297$var$selectConfigs,
            fieldSets: [
                [
                    'fontPercent'
                ],
                [
                    'edgeStyle'
                ],
                [
                    'fontFamily'
                ]
            ]
        });
        this.addChild(textTrackSettingsFont);
        const trackSettingsControls = new $cb03b711053a4297$var$TrackSettingsControls(player);
        this.addChild(trackSettingsControls);
    }
    bindFunctionsToSelectsAndButtons() {
        this.on(this.$('.vjs-done-button'), [
            'click',
            'tap'
        ], ()=>{
            this.saveSettings();
            this.close();
        });
        this.on(this.$('.vjs-default-button'), [
            'click',
            'tap'
        ], ()=>{
            this.setDefaults();
            this.updateDisplay();
        });
        $cb03b711053a4297$var$each($cb03b711053a4297$var$selectConfigs, (config)=>{
            this.on(this.$(config.selector), 'change', this.updateDisplay);
        });
    }
    dispose() {
        this.endDialog = null;
        super.dispose();
    }
    label() {
        return this.localize('Caption Settings Dialog');
    }
    description() {
        return this.localize('Beginning of dialog window. Escape will cancel and close the window.');
    }
    buildCSSClass() {
        return super.buildCSSClass() + ' vjs-text-track-settings';
    }
    /**
   * Gets an object of text track settings (or null).
   *
   * @return {Object}
   *         An object with config values parsed from the DOM or localStorage.
   */ getValues() {
        return $cb03b711053a4297$var$reduce($cb03b711053a4297$var$selectConfigs, (accum, config, key)=>{
            const value = $cb03b711053a4297$var$getSelectedOptionValue(this.$(config.selector), config.parser);
            if (value !== undefined) accum[key] = value;
            return accum;
        }, {});
    }
    /**
   * Sets text track settings from an object of values.
   *
   * @param {Object} values
   *        An object with config values parsed from the DOM or localStorage.
   */ setValues(values) {
        $cb03b711053a4297$var$each($cb03b711053a4297$var$selectConfigs, (config, key)=>{
            $cb03b711053a4297$var$setSelectedOption(this.$(config.selector), values[key], config.parser);
        });
    }
    /**
   * Sets all `<select>` elements to their default values.
   */ setDefaults() {
        $cb03b711053a4297$var$each($cb03b711053a4297$var$selectConfigs, (config)=>{
            const index = config.hasOwnProperty('default') ? config.default : 0;
            this.$(config.selector).selectedIndex = index;
        });
    }
    /**
   * Restore texttrack settings from localStorage
   */ restoreSettings() {
        let values;
        try {
            values = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage.getItem($cb03b711053a4297$var$LOCAL_STORAGE_KEY$1));
        } catch (err) {
            $cb03b711053a4297$var$log$1.warn(err);
        }
        if (values) this.setValues(values);
    }
    /**
   * Save text track settings to localStorage
   */ saveSettings() {
        if (!this.options_.persistTextTrackSettings) return;
        const values = this.getValues();
        try {
            if (Object.keys(values).length) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage.setItem($cb03b711053a4297$var$LOCAL_STORAGE_KEY$1, JSON.stringify(values));
            else (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage.removeItem($cb03b711053a4297$var$LOCAL_STORAGE_KEY$1);
        } catch (err) {
            $cb03b711053a4297$var$log$1.warn(err);
        }
    }
    /**
   * Update display of text track settings
   */ updateDisplay() {
        const ttDisplay = this.player_.getChild('textTrackDisplay');
        if (ttDisplay) ttDisplay.updateDisplay();
    }
    /**
   * Repopulate dialog with new localizations on languagechange
   */ handleLanguagechange() {
        this.fill();
        this.renderModalComponents(this.player_);
        this.bindFunctionsToSelectsAndButtons();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TextTrackSettings', $cb03b711053a4297$var$TextTrackSettings);
/**
 * @file resize-manager.js
 */ /**
 * A Resize Manager. It is in charge of triggering `playerresize` on the player in the right conditions.
 *
 * It'll either create an iframe and use a debounced resize handler on it or use the new {@link https://wicg.github.io/ResizeObserver/|ResizeObserver}.
 *
 * If the ResizeObserver is available natively, it will be used. A polyfill can be passed in as an option.
 * If a `playerresize` event is not needed, the ResizeManager component can be removed from the player, see the example below.
 *
 * @example <caption>How to disable the resize manager</caption>
 * const player = videojs('#vid', {
 *   resizeManager: false
 * });
 *
 * @see {@link https://wicg.github.io/ResizeObserver/|ResizeObserver specification}
 *
 * @extends Component
 */ class $cb03b711053a4297$var$ResizeManager extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create the ResizeManager.
   *
   * @param {Object} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of ResizeManager options.
   *
   * @param {Object} [options.ResizeObserver]
   *        A polyfill for ResizeObserver can be passed in here.
   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
   */ constructor(player, options){
        let RESIZE_OBSERVER_AVAILABLE = options.ResizeObserver || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).ResizeObserver;
        // if `null` was passed, we want to disable the ResizeObserver
        if (options.ResizeObserver === null) RESIZE_OBSERVER_AVAILABLE = false;
        // Only create an element when ResizeObserver isn't available
        const options_ = $cb03b711053a4297$var$merge$1({
            createEl: !RESIZE_OBSERVER_AVAILABLE,
            reportTouchActivity: false
        }, options);
        super(player, options_);
        this.ResizeObserver = options.ResizeObserver || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).ResizeObserver;
        this.loadListener_ = null;
        this.resizeObserver_ = null;
        this.debouncedHandler_ = $cb03b711053a4297$var$debounce$1(()=>{
            this.resizeHandler();
        }, 100, false, this);
        if (RESIZE_OBSERVER_AVAILABLE) {
            this.resizeObserver_ = new this.ResizeObserver(this.debouncedHandler_);
            this.resizeObserver_.observe(player.el());
        } else {
            this.loadListener_ = ()=>{
                if (!this.el_ || !this.el_.contentWindow) return;
                const debouncedHandler_ = this.debouncedHandler_;
                let unloadListener_ = this.unloadListener_ = function() {
                    $cb03b711053a4297$var$off(this, 'resize', debouncedHandler_);
                    $cb03b711053a4297$var$off(this, 'unload', unloadListener_);
                    unloadListener_ = null;
                };
                // safari and edge can unload the iframe before resizemanager dispose
                // we have to dispose of event handlers correctly before that happens
                $cb03b711053a4297$var$on(this.el_.contentWindow, 'unload', unloadListener_);
                $cb03b711053a4297$var$on(this.el_.contentWindow, 'resize', debouncedHandler_);
            };
            this.one('load', this.loadListener_);
        }
    }
    createEl() {
        return super.createEl('iframe', {
            className: 'vjs-resize-manager',
            tabIndex: -1,
            title: this.localize('No content')
        }, {
            'aria-hidden': 'true'
        });
    }
    /**
   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
   *
   * @fires Player#playerresize
   */ resizeHandler() {
        /**
     * Called when the player size has changed
     *
     * @event Player#playerresize
     * @type {Event}
     */ // make sure player is still around to trigger
        // prevents this from causing an error after dispose
        if (!this.player_ || !this.player_.trigger) return;
        this.player_.trigger('playerresize');
    }
    dispose() {
        if (this.debouncedHandler_) this.debouncedHandler_.cancel();
        if (this.resizeObserver_) {
            if (this.player_.el()) this.resizeObserver_.unobserve(this.player_.el());
            this.resizeObserver_.disconnect();
        }
        if (this.loadListener_) this.off('load', this.loadListener_);
        if (this.el_ && this.el_.contentWindow && this.unloadListener_) this.unloadListener_.call(this.el_.contentWindow);
        this.ResizeObserver = null;
        this.resizeObserver = null;
        this.debouncedHandler_ = null;
        this.loadListener_ = null;
        super.dispose();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('ResizeManager', $cb03b711053a4297$var$ResizeManager);
/** @import Player from './player' */ const $cb03b711053a4297$var$defaults$1 = {
    trackingThreshold: 20,
    liveTolerance: 15
};
/*
  track when we are at the live edge, and other helpers for live playback */ /**
 * A class for checking live current time and determining when the player
 * is at or behind the live edge.
 */ class $cb03b711053a4297$var$LiveTracker extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {number} [options.trackingThreshold=20]
   *        Number of seconds of live window (seekableEnd - seekableStart) that
   *        media needs to have before the liveui will be shown.
   *
   * @param {number} [options.liveTolerance=15]
   *        Number of seconds behind live that we have to be
   *        before we will be considered non-live. Note that this will only
   *        be used when playing at the live edge. This allows large seekable end
   *        changes to not effect whether we are live or not.
   */ constructor(player, options){
        // LiveTracker does not need an element
        const options_ = $cb03b711053a4297$var$merge$1($cb03b711053a4297$var$defaults$1, options, {
            createEl: false
        });
        super(player, options_);
        this.trackLiveHandler_ = ()=>this.trackLive_();
        this.handlePlay_ = (e)=>this.handlePlay(e);
        this.handleFirstTimeupdate_ = (e)=>this.handleFirstTimeupdate(e);
        this.handleSeeked_ = (e)=>this.handleSeeked(e);
        this.seekToLiveEdge_ = (e)=>this.seekToLiveEdge(e);
        this.reset_();
        this.on(this.player_, 'durationchange', (e)=>this.handleDurationchange(e));
        // we should try to toggle tracking on canplay as native playback engines, like Safari
        // may not have the proper values for things like seekableEnd until then
        this.on(this.player_, 'canplay', ()=>this.toggleTracking());
    }
    /**
   * all the functionality for tracking when seek end changes
   * and for tracking how far past seek end we should be
   */ trackLive_() {
        const seekable = this.player_.seekable();
        // skip undefined seekable
        if (!seekable || !seekable.length) return;
        const newTime = Number((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now().toFixed(4));
        const deltaTime = this.lastTime_ === -1 ? 0 : (newTime - this.lastTime_) / 1000;
        this.lastTime_ = newTime;
        this.pastSeekEnd_ = this.pastSeekEnd() + deltaTime;
        const liveCurrentTime = this.liveCurrentTime();
        const currentTime = this.player_.currentTime();
        // we are behind live if any are true
        // 1. the player is paused
        // 2. the user seeked to a location 2 seconds away from live
        // 3. the difference between live and current time is greater
        //    liveTolerance which defaults to 15s
        let isBehind = this.player_.paused() || this.seekedBehindLive_ || Math.abs(liveCurrentTime - currentTime) > this.options_.liveTolerance;
        // we cannot be behind if
        // 1. until we have not seen a timeupdate yet
        // 2. liveCurrentTime is Infinity, which happens on Android and Native Safari
        if (!this.timeupdateSeen_ || liveCurrentTime === Infinity) isBehind = false;
        if (isBehind !== this.behindLiveEdge_) {
            this.behindLiveEdge_ = isBehind;
            this.trigger('liveedgechange');
        }
    }
    /**
   * handle a durationchange event on the player
   * and start/stop tracking accordingly.
   */ handleDurationchange() {
        this.toggleTracking();
    }
    /**
   * start/stop tracking
   */ toggleTracking() {
        if (this.player_.duration() === Infinity && this.liveWindow() >= this.options_.trackingThreshold) {
            if (this.player_.options_.liveui) this.player_.addClass('vjs-liveui');
            this.startTracking();
        } else {
            this.player_.removeClass('vjs-liveui');
            this.stopTracking();
        }
    }
    /**
   * start tracking live playback
   */ startTracking() {
        if (this.isTracking()) return;
        // If we haven't seen a timeupdate, we need to check whether playback
        // began before this component started tracking. This can happen commonly
        // when using autoplay.
        if (!this.timeupdateSeen_) this.timeupdateSeen_ = this.player_.hasStarted();
        this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
        this.trackLive_();
        this.on(this.player_, [
            'play',
            'pause'
        ], this.trackLiveHandler_);
        if (!this.timeupdateSeen_) {
            this.one(this.player_, 'play', this.handlePlay_);
            this.one(this.player_, 'timeupdate', this.handleFirstTimeupdate_);
        } else this.on(this.player_, 'seeked', this.handleSeeked_);
    }
    /**
   * handle the first timeupdate on the player if it wasn't already playing
   * when live tracker started tracking.
   */ handleFirstTimeupdate() {
        this.timeupdateSeen_ = true;
        this.on(this.player_, 'seeked', this.handleSeeked_);
    }
    /**
   * Keep track of what time a seek starts, and listen for seeked
   * to find where a seek ends.
   */ handleSeeked() {
        const timeDiff = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
        this.seekedBehindLive_ = this.nextSeekedFromUser_ && timeDiff > 2;
        this.nextSeekedFromUser_ = false;
        this.trackLive_();
    }
    /**
   * handle the first play on the player, and make sure that we seek
   * right to the live edge.
   */ handlePlay() {
        this.one(this.player_, 'timeupdate', this.seekToLiveEdge_);
    }
    /**
   * Stop tracking, and set all internal variables to
   * their initial value.
   */ reset_() {
        this.lastTime_ = -1;
        this.pastSeekEnd_ = 0;
        this.lastSeekEnd_ = -1;
        this.behindLiveEdge_ = true;
        this.timeupdateSeen_ = false;
        this.seekedBehindLive_ = false;
        this.nextSeekedFromUser_ = false;
        this.clearInterval(this.trackingInterval_);
        this.trackingInterval_ = null;
        this.off(this.player_, [
            'play',
            'pause'
        ], this.trackLiveHandler_);
        this.off(this.player_, 'seeked', this.handleSeeked_);
        this.off(this.player_, 'play', this.handlePlay_);
        this.off(this.player_, 'timeupdate', this.handleFirstTimeupdate_);
        this.off(this.player_, 'timeupdate', this.seekToLiveEdge_);
    }
    /**
   * The next seeked event is from the user. Meaning that any seek
   * > 2s behind live will be considered behind live for real and
   * liveTolerance will be ignored.
   */ nextSeekedFromUser() {
        this.nextSeekedFromUser_ = true;
    }
    /**
   * stop tracking live playback
   */ stopTracking() {
        if (!this.isTracking()) return;
        this.reset_();
        this.trigger('liveedgechange');
    }
    /**
   * A helper to get the player seekable end
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The furthest seekable end or Infinity.
   */ seekableEnd() {
        const seekable = this.player_.seekable();
        const seekableEnds = [];
        let i = seekable ? seekable.length : 0;
        while(i--)seekableEnds.push(seekable.end(i));
        // grab the furthest seekable end after sorting, or if there are none
        // default to Infinity
        return seekableEnds.length ? seekableEnds.sort()[seekableEnds.length - 1] : Infinity;
    }
    /**
   * A helper to get the player seekable start
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The earliest seekable start or 0.
   */ seekableStart() {
        const seekable = this.player_.seekable();
        const seekableStarts = [];
        let i = seekable ? seekable.length : 0;
        while(i--)seekableStarts.push(seekable.start(i));
        // grab the first seekable start after sorting, or if there are none
        // default to 0
        return seekableStarts.length ? seekableStarts.sort()[0] : 0;
    }
    /**
   * Get the live time window aka
   * the amount of time between seekable start and
   * live current time.
   *
   * @return {number}
   *         The amount of seconds that are seekable in
   *         the live video.
   */ liveWindow() {
        const liveCurrentTime = this.liveCurrentTime();
        // if liveCurrenTime is Infinity then we don't have a liveWindow at all
        if (liveCurrentTime === Infinity) return 0;
        return liveCurrentTime - this.seekableStart();
    }
    /**
   * Determines if the player is live, only checks if this component
   * is tracking live playback or not
   *
   * @return {boolean}
   *         Whether liveTracker is tracking
   */ isLive() {
        return this.isTracking();
    }
    /**
   * Determines if currentTime is at the live edge and won't fall behind
   * on each seekableendchange
   *
   * @return {boolean}
   *         Whether playback is at the live edge
   */ atLiveEdge() {
        return !this.behindLiveEdge();
    }
    /**
   * get what we expect the live current time to be
   *
   * @return {number}
   *         The expected live current time
   */ liveCurrentTime() {
        return this.pastSeekEnd() + this.seekableEnd();
    }
    /**
   * The number of seconds that have occurred after seekable end
   * changed. This will be reset to 0 once seekable end changes.
   *
   * @return {number}
   *         Seconds past the current seekable end
   */ pastSeekEnd() {
        const seekableEnd = this.seekableEnd();
        if (this.lastSeekEnd_ !== -1 && seekableEnd !== this.lastSeekEnd_) this.pastSeekEnd_ = 0;
        this.lastSeekEnd_ = seekableEnd;
        return this.pastSeekEnd_;
    }
    /**
   * If we are currently behind the live edge, aka currentTime will be
   * behind on a seekableendchange
   *
   * @return {boolean}
   *         If we are behind the live edge
   */ behindLiveEdge() {
        return this.behindLiveEdge_;
    }
    /**
   * Whether live tracker is currently tracking or not.
   */ isTracking() {
        return typeof this.trackingInterval_ === 'number';
    }
    /**
   * Seek to the live edge if we are behind the live edge
   */ seekToLiveEdge() {
        this.seekedBehindLive_ = false;
        if (this.atLiveEdge()) return;
        this.nextSeekedFromUser_ = false;
        this.player_.currentTime(this.liveCurrentTime());
    }
    /**
   * Dispose of liveTracker
   */ dispose() {
        this.stopTracking();
        super.dispose();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('LiveTracker', $cb03b711053a4297$var$LiveTracker);
/**
 * Displays an element over the player which contains an optional title and
 * description for the current content.
 *
 * Much of the code for this component originated in the now obsolete
 * videojs-dock plugin: https://github.com/brightcove/videojs-dock/
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TitleBar extends $cb03b711053a4297$var$Component$1 {
    constructor(player, options){
        super(player, options);
        this.on('statechanged', (e)=>this.updateDom_());
        this.updateDom_();
    }
    /**
   * Create the `TitleBar`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        this.els = {
            title: $cb03b711053a4297$var$createEl('div', {
                className: 'vjs-title-bar-title',
                id: `vjs-title-bar-title-${$cb03b711053a4297$var$newGUID()}`
            }),
            description: $cb03b711053a4297$var$createEl('div', {
                className: 'vjs-title-bar-description',
                id: `vjs-title-bar-description-${$cb03b711053a4297$var$newGUID()}`
            })
        };
        return $cb03b711053a4297$var$createEl('div', {
            className: 'vjs-title-bar'
        }, {}, $cb03b711053a4297$var$values(this.els));
    }
    /**
   * Updates the DOM based on the component's state object.
   */ updateDom_() {
        const tech = this.player_.tech_;
        const techEl = tech && tech.el_;
        const techAriaAttrs = {
            title: 'aria-labelledby',
            description: 'aria-describedby'
        };
        [
            'title',
            'description'
        ].forEach((k)=>{
            const value = this.state[k];
            const el = this.els[k];
            const techAriaAttr = techAriaAttrs[k];
            $cb03b711053a4297$var$emptyEl(el);
            if (value) $cb03b711053a4297$var$textContent(el, value);
            // If there is a tech element available, update its ARIA attributes
            // according to whether a title and/or description have been provided.
            if (techEl) {
                techEl.removeAttribute(techAriaAttr);
                if (value) techEl.setAttribute(techAriaAttr, el.id);
            }
        });
        if (this.state.title || this.state.description) this.show();
        else this.hide();
    }
    /**
   * Update the contents of the title bar component with new title and
   * description text.
   *
   * If both title and description are missing, the title bar will be hidden.
   *
   * If either title or description are present, the title bar will be visible.
   *
   * NOTE: Any previously set value will be preserved. To unset a previously
   * set value, you must pass an empty string or null.
   *
   * For example:
   *
   * ```
   * update({title: 'foo', description: 'bar'}) // title: 'foo', description: 'bar'
   * update({description: 'bar2'}) // title: 'foo', description: 'bar2'
   * update({title: ''}) // title: '', description: 'bar2'
   * update({title: 'foo', description: null}) // title: 'foo', description: null
   * ```
   *
   * @param  {Object} [options={}]
   *         An options object. When empty, the title bar will be hidden.
   *
   * @param  {string} [options.title]
   *         A title to display in the title bar.
   *
   * @param  {string} [options.description]
   *         A description to display in the title bar.
   */ update(options) {
        this.setState(options);
    }
    /**
   * Dispose the component.
   */ dispose() {
        const tech = this.player_.tech_;
        const techEl = tech && tech.el_;
        if (techEl) {
            techEl.removeAttribute('aria-labelledby');
            techEl.removeAttribute('aria-describedby');
        }
        super.dispose();
        this.els = null;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TitleBar', $cb03b711053a4297$var$TitleBar);
/** @import Player from './player' */ /**
 * @typedef {object} TransientButtonOptions
 * @property {string} [controlText] Control text, usually visible for these buttons
 * @property {number} [initialDisplay=4000] Time in ms that button should initially remain visible
 * @property {Array<'top'|'neartop'|'bottom'|'left'|'right'>} [position] Array of position strings to add basic styles for positioning
 * @property {string} [className] Class(es) to add
 * @property {boolean} [takeFocus=false] Whether element sohuld take focus when shown
 * @property {Function} [clickHandler] Function called on button activation
 */ /** @type {TransientButtonOptions} */ const $cb03b711053a4297$var$defaults = {
    initialDisplay: 4000,
    position: [],
    takeFocus: false
};
/**
 * A floating transient button.
 * It's recommended to insert these buttons _before_ the control bar with the this argument to `addChild`
 * for a logical tab order.
 *
 * @example
 * ```
 * player.addChild(
 *   'TransientButton',
 *   options,
 *   player.children().indexOf(player.getChild("ControlBar"))
 * )
 * ```
 *
 * @extends Button
 */ class $cb03b711053a4297$var$TransientButton extends $cb03b711053a4297$var$Button {
    /**
   * TransientButton constructor
   *
   * @param {Player} player The button's player
   * @param {TransientButtonOptions} options Options for the transient button
   */ constructor(player, options){
        options = $cb03b711053a4297$var$merge$1($cb03b711053a4297$var$defaults, options);
        super(player, options);
        this.controlText(options.controlText);
        this.hide();
        // When shown, the float button will be visible even if the user is inactive.
        // Clear this if there is any interaction.
        this.on(this.player_, [
            'useractive',
            'userinactive'
        ], (e)=>{
            this.removeClass('force-display');
        });
    }
    /**
   * Return CSS class including position classes
   *
   * @return {string} CSS class list
   */ buildCSSClass() {
        return `vjs-transient-button focus-visible ${this.options_.position.map((c)=>`vjs-${c}`).join(' ')}`;
    }
    /**
   * Create the button element
   *
   * @return {HTMLButtonElement} The button element
   */ createEl() {
        /** @type HTMLButtonElement */ const el = $cb03b711053a4297$var$createEl('button', {}, {
            type: 'button',
            class: this.buildCSSClass()
        }, $cb03b711053a4297$var$createEl('span'));
        this.controlTextEl_ = el.querySelector('span');
        return el;
    }
    /**
   * Show the button. The button will remain visible for the `initialDisplay` time, default 4s,
   * and when there is user activity.
   */ show() {
        super.show();
        this.addClass('force-display');
        if (this.options_.takeFocus) this.el().focus({
            preventScroll: true
        });
        this.forceDisplayTimeout = this.player_.setTimeout(()=>{
            this.removeClass('force-display');
        }, this.options_.initialDisplay);
    }
    /**
   * Hide the display, even if during the `initialDisplay` time.
   */ hide() {
        this.removeClass('force-display');
        super.hide();
    }
    /**
   * Dispose the component
   */ dispose() {
        this.player_.clearTimeout(this.forceDisplayTimeout);
        super.dispose();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent('TransientButton', $cb03b711053a4297$var$TransientButton);
/** @import Html5 from './html5' */ /**
 * This function is used to fire a sourceset when there is something
 * similar to `mediaEl.load()` being called. It will try to find the source via
 * the `src` attribute and then the `<source>` elements. It will then fire `sourceset`
 * with the source that was found or empty string if we cannot know. If it cannot
 * find a source then `sourceset` will not be fired.
 *
 * @param {Html5} tech
 *        The tech object that sourceset was setup on
 *
 * @return {boolean}
 *         returns false if the sourceset was not fired and true otherwise.
 */ const $cb03b711053a4297$var$sourcesetLoad = (tech)=>{
    const el = tech.el();
    // if `el.src` is set, that source will be loaded.
    if (el.hasAttribute('src')) {
        tech.triggerSourceset(el.src);
        return true;
    }
    /**
   * Since there isn't a src property on the media element, source elements will be used for
   * implementing the source selection algorithm. This happens asynchronously and
   * for most cases were there is more than one source we cannot tell what source will
   * be loaded, without re-implementing the source selection algorithm. At this time we are not
   * going to do that. There are three special cases that we do handle here though:
   *
   * 1. If there are no sources, do not fire `sourceset`.
   * 2. If there is only one `<source>` with a `src` property/attribute that is our `src`
   * 3. If there is more than one `<source>` but all of them have the same `src` url.
   *    That will be our src.
   */ const sources = tech.$$('source');
    const srcUrls = [];
    let src = '';
    // if there are no sources, do not fire sourceset
    if (!sources.length) return false;
    // only count valid/non-duplicate source elements
    for(let i = 0; i < sources.length; i++){
        const url = sources[i].src;
        if (url && srcUrls.indexOf(url) === -1) srcUrls.push(url);
    }
    // there were no valid sources
    if (!srcUrls.length) return false;
    // there is only one valid source element url
    // use that
    if (srcUrls.length === 1) src = srcUrls[0];
    tech.triggerSourceset(src);
    return true;
};
/**
 * our implementation of an `innerHTML` descriptor for browsers
 * that do not have one.
 */ const $cb03b711053a4297$var$innerHTMLDescriptorPolyfill = Object.defineProperty({}, 'innerHTML', {
    get () {
        return this.cloneNode(true).innerHTML;
    },
    set (v) {
        // make a dummy node to use innerHTML on
        const dummy = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement(this.nodeName.toLowerCase());
        // set innerHTML to the value provided
        dummy.innerHTML = v;
        // make a document fragment to hold the nodes from dummy
        const docFrag = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createDocumentFragment();
        // copy all of the nodes created by the innerHTML on dummy
        // to the document fragment
        while(dummy.childNodes.length)docFrag.appendChild(dummy.childNodes[0]);
        // remove content
        this.innerText = '';
        // now we add all of that html in one by appending the
        // document fragment. This is how innerHTML does it.
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Element.prototype.appendChild.call(this, docFrag);
        // then return the result that innerHTML's setter would
        return this.innerHTML;
    }
});
/**
 * Get a property descriptor given a list of priorities and the
 * property to get.
 */ const $cb03b711053a4297$var$getDescriptor = (priority, prop)=>{
    let descriptor = {};
    for(let i = 0; i < priority.length; i++){
        descriptor = Object.getOwnPropertyDescriptor(priority[i], prop);
        if (descriptor && descriptor.set && descriptor.get) break;
    }
    descriptor.enumerable = true;
    descriptor.configurable = true;
    return descriptor;
};
const $cb03b711053a4297$var$getInnerHTMLDescriptor = (tech)=>$cb03b711053a4297$var$getDescriptor([
        tech.el(),
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLMediaElement.prototype,
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Element.prototype,
        $cb03b711053a4297$var$innerHTMLDescriptorPolyfill
    ], 'innerHTML');
/**
 * Patches browser internal functions so that we can tell synchronously
 * if a `<source>` was appended to the media element. For some reason this
 * causes a `sourceset` if the the media element is ready and has no source.
 * This happens when:
 * - The page has just loaded and the media element does not have a source.
 * - The media element was emptied of all sources, then `load()` was called.
 *
 * It does this by patching the following functions/properties when they are supported:
 *
 * - `append()` - can be used to add a `<source>` element to the media element
 * - `appendChild()` - can be used to add a `<source>` element to the media element
 * - `insertAdjacentHTML()` -  can be used to add a `<source>` element to the media element
 * - `innerHTML` -  can be used to add a `<source>` element to the media element
 *
 * @param {Html5} tech
 *        The tech object that sourceset is being setup on.
 */ const $cb03b711053a4297$var$firstSourceWatch = function(tech) {
    const el = tech.el();
    // make sure firstSourceWatch isn't setup twice.
    if (el.resetSourceWatch_) return;
    const old = {};
    const innerDescriptor = $cb03b711053a4297$var$getInnerHTMLDescriptor(tech);
    const appendWrapper = (appendFn)=>(...args)=>{
            const retval = appendFn.apply(el, args);
            $cb03b711053a4297$var$sourcesetLoad(tech);
            return retval;
        };
    [
        'append',
        'appendChild',
        'insertAdjacentHTML'
    ].forEach((k)=>{
        if (!el[k]) return;
        // store the old function
        old[k] = el[k];
        // call the old function with a sourceset if a source
        // was loaded
        el[k] = appendWrapper(old[k]);
    });
    Object.defineProperty(el, 'innerHTML', $cb03b711053a4297$var$merge$1(innerDescriptor, {
        set: appendWrapper(innerDescriptor.set)
    }));
    el.resetSourceWatch_ = ()=>{
        el.resetSourceWatch_ = null;
        Object.keys(old).forEach((k)=>{
            el[k] = old[k];
        });
        Object.defineProperty(el, 'innerHTML', innerDescriptor);
    };
    // on the first sourceset, we need to revert our changes
    tech.one('sourceset', el.resetSourceWatch_);
};
/**
 * our implementation of a `src` descriptor for browsers
 * that do not have one
 */ const $cb03b711053a4297$var$srcDescriptorPolyfill = Object.defineProperty({}, 'src', {
    get () {
        if (this.hasAttribute('src')) return $cb03b711053a4297$var$getAbsoluteURL((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Element.prototype.getAttribute.call(this, 'src'));
        return '';
    },
    set (v) {
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Element.prototype.setAttribute.call(this, 'src', v);
        return v;
    }
});
const $cb03b711053a4297$var$getSrcDescriptor = (tech)=>$cb03b711053a4297$var$getDescriptor([
        tech.el(),
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLMediaElement.prototype,
        $cb03b711053a4297$var$srcDescriptorPolyfill
    ], 'src');
/**
 * setup `sourceset` handling on the `Html5` tech. This function
 * patches the following element properties/functions:
 *
 * - `src` - to determine when `src` is set
 * - `setAttribute()` - to determine when `src` is set
 * - `load()` - this re-triggers the source selection algorithm, and can
 *              cause a sourceset.
 *
 * If there is no source when we are adding `sourceset` support or during a `load()`
 * we also patch the functions listed in `firstSourceWatch`.
 *
 * @param {Html5} tech
 *        The tech to patch
 */ const $cb03b711053a4297$var$setupSourceset = function(tech) {
    if (!tech.featuresSourceset) return;
    const el = tech.el();
    // make sure sourceset isn't setup twice.
    if (el.resetSourceset_) return;
    const srcDescriptor = $cb03b711053a4297$var$getSrcDescriptor(tech);
    const oldSetAttribute = el.setAttribute;
    const oldLoad = el.load;
    Object.defineProperty(el, 'src', $cb03b711053a4297$var$merge$1(srcDescriptor, {
        set: (v)=>{
            const retval = srcDescriptor.set.call(el, v);
            // we use the getter here to get the actual value set on src
            tech.triggerSourceset(el.src);
            return retval;
        }
    }));
    el.setAttribute = (n, v)=>{
        const retval = oldSetAttribute.call(el, n, v);
        if (/src/i.test(n)) tech.triggerSourceset(el.src);
        return retval;
    };
    el.load = ()=>{
        const retval = oldLoad.call(el);
        // if load was called, but there was no source to fire
        // sourceset on. We have to watch for a source append
        // as that can trigger a `sourceset` when the media element
        // has no source
        if (!$cb03b711053a4297$var$sourcesetLoad(tech)) {
            tech.triggerSourceset('');
            $cb03b711053a4297$var$firstSourceWatch(tech);
        }
        return retval;
    };
    if (el.currentSrc) tech.triggerSourceset(el.currentSrc);
    else if (!$cb03b711053a4297$var$sourcesetLoad(tech)) $cb03b711053a4297$var$firstSourceWatch(tech);
    el.resetSourceset_ = ()=>{
        el.resetSourceset_ = null;
        el.load = oldLoad;
        el.setAttribute = oldSetAttribute;
        Object.defineProperty(el, 'src', srcDescriptor);
        if (el.resetSourceWatch_) el.resetSourceWatch_();
    };
};
/**
 * @file html5.js
 */ /**
 * HTML5 Media Controller - Wrapper for HTML5 Media API
 *
 * @mixes Tech~SourceHandlerAdditions
 * @extends Tech
 */ class $cb03b711053a4297$var$Html5 extends $cb03b711053a4297$var$Tech {
    /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */ constructor(options, ready){
        super(options, ready);
        const source = options.source;
        let crossoriginTracks = false;
        this.featuresVideoFrameCallback = this.featuresVideoFrameCallback && this.el_.tagName === 'VIDEO';
        // Set the source if one is provided
        // 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
        // 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
        // anyway so the error gets fired.
        if (source && (this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) this.setSource(source);
        else this.handleLateInit_(this.el_);
        // setup sourceset after late sourceset/init
        if (options.enableSourceset) this.setupSourcesetHandling_();
        this.isScrubbing_ = false;
        if (this.el_.hasChildNodes()) {
            const nodes = this.el_.childNodes;
            let nodesLength = nodes.length;
            const removeNodes = [];
            while(nodesLength--){
                const node = nodes[nodesLength];
                const nodeName = node.nodeName.toLowerCase();
                if (nodeName === 'track') {
                    if (!this.featuresNativeTextTracks) // Empty video tag tracks so the built-in player doesn't use them also.
                    // This may not be fast enough to stop HTML5 browsers from reading the tags
                    // so we'll need to turn off any default tracks if we're manually doing
                    // captions and subtitles. videoElement.textTracks
                    removeNodes.push(node);
                    else {
                        // store HTMLTrackElement and TextTrack to remote list
                        this.remoteTextTrackEls().addTrackElement_(node);
                        this.remoteTextTracks().addTrack(node.track);
                        this.textTracks().addTrack(node.track);
                        if (!crossoriginTracks && !this.el_.hasAttribute('crossorigin') && $cb03b711053a4297$var$isCrossOrigin(node.src)) crossoriginTracks = true;
                    }
                }
            }
            for(let i = 0; i < removeNodes.length; i++)this.el_.removeChild(removeNodes[i]);
        }
        this.proxyNativeTracks_();
        if (this.featuresNativeTextTracks && crossoriginTracks) $cb03b711053a4297$var$log$1.warn("Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.\nThis may prevent text tracks from loading.");
        // prevent iOS Safari from disabling metadata text tracks during native playback
        this.restoreMetadataTracksInIOSNativePlayer_();
        // Determine if native controls should be used
        // Our goal should be to get the custom controls on mobile solid everywhere
        // so we can remove this all together. Right now this will block custom
        // controls on touch enabled laptops like the Chrome Pixel
        if (($cb03b711053a4297$var$TOUCH_ENABLED || $cb03b711053a4297$var$IS_IPHONE) && options.nativeControlsForTouch === true) this.setControls(true);
        // on iOS, we want to proxy `webkitbeginfullscreen` and `webkitendfullscreen`
        // into a `fullscreenchange` event
        this.proxyWebkitFullscreen_();
        this.triggerReady();
    }
    /**
   * Dispose of `HTML5` media element and remove all tracks.
   */ dispose() {
        if (this.el_ && this.el_.resetSourceset_) this.el_.resetSourceset_();
        $cb03b711053a4297$var$Html5.disposeMediaElement(this.el_);
        this.options_ = null;
        // tech will handle clearing of the emulated track list
        super.dispose();
    }
    /**
   * Modify the media element so that we can detect when
   * the source is changed. Fires `sourceset` just after the source has changed
   */ setupSourcesetHandling_() {
        $cb03b711053a4297$var$setupSourceset(this);
    }
    /**
   * When a captions track is enabled in the iOS Safari native player, all other
   * tracks are disabled (including metadata tracks), which nulls all of their
   * associated cue points. This will restore metadata tracks to their pre-fullscreen
   * state in those cases so that cue points are not needlessly lost.
   *
   * @private
   */ restoreMetadataTracksInIOSNativePlayer_() {
        const textTracks = this.textTracks();
        let metadataTracksPreFullscreenState;
        // captures a snapshot of every metadata track's current state
        const takeMetadataTrackSnapshot = ()=>{
            metadataTracksPreFullscreenState = [];
            for(let i = 0; i < textTracks.length; i++){
                const track = textTracks[i];
                if (track.kind === 'metadata') metadataTracksPreFullscreenState.push({
                    track: track,
                    storedMode: track.mode
                });
            }
        };
        // snapshot each metadata track's initial state, and update the snapshot
        // each time there is a track 'change' event
        takeMetadataTrackSnapshot();
        textTracks.addEventListener('change', takeMetadataTrackSnapshot);
        this.on('dispose', ()=>textTracks.removeEventListener('change', takeMetadataTrackSnapshot));
        const restoreTrackMode = ()=>{
            for(let i = 0; i < metadataTracksPreFullscreenState.length; i++){
                const storedTrack = metadataTracksPreFullscreenState[i];
                if (storedTrack.track.mode === 'disabled' && storedTrack.track.mode !== storedTrack.storedMode) storedTrack.track.mode = storedTrack.storedMode;
            }
            // we only want this handler to be executed on the first 'change' event
            textTracks.removeEventListener('change', restoreTrackMode);
        };
        // when we enter fullscreen playback, stop updating the snapshot and
        // restore all track modes to their pre-fullscreen state
        this.on('webkitbeginfullscreen', ()=>{
            textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
            // remove the listener before adding it just in case it wasn't previously removed
            textTracks.removeEventListener('change', restoreTrackMode);
            textTracks.addEventListener('change', restoreTrackMode);
        });
        // start updating the snapshot again after leaving fullscreen
        this.on('webkitendfullscreen', ()=>{
            // remove the listener before adding it just in case it wasn't previously removed
            textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
            textTracks.addEventListener('change', takeMetadataTrackSnapshot);
            // remove the restoreTrackMode handler in case it wasn't triggered during fullscreen playback
            textTracks.removeEventListener('change', restoreTrackMode);
        });
    }
    /**
   * Attempt to force override of tracks for the given type
   *
   * @param {string} type - Track type to override, possible values include 'Audio',
   * 'Video', and 'Text'.
   * @param {boolean} override - If set to true native audio/video will be overridden,
   * otherwise native audio/video will potentially be used.
   * @private
   */ overrideNative_(type, override) {
        // If there is no behavioral change don't add/remove listeners
        if (override !== this[`featuresNative${type}Tracks`]) return;
        const lowerCaseType = type.toLowerCase();
        if (this[`${lowerCaseType}TracksListeners_`]) Object.keys(this[`${lowerCaseType}TracksListeners_`]).forEach((eventName)=>{
            const elTracks = this.el()[`${lowerCaseType}Tracks`];
            elTracks.removeEventListener(eventName, this[`${lowerCaseType}TracksListeners_`][eventName]);
        });
        this[`featuresNative${type}Tracks`] = !override;
        this[`${lowerCaseType}TracksListeners_`] = null;
        this.proxyNativeTracksForType_(lowerCaseType);
    }
    /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   */ overrideNativeAudioTracks(override) {
        this.overrideNative_('Audio', override);
    }
    /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   */ overrideNativeVideoTracks(override) {
        this.overrideNative_('Video', override);
    }
    /**
   * Proxy native track list events for the given type to our track
   * lists if the browser we are playing in supports that type of track list.
   *
   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
   * @private
   */ proxyNativeTracksForType_(name) {
        const props = $cb03b711053a4297$var$NORMAL[name];
        const elTracks = this.el()[props.getterName];
        const techTracks = this[props.getterName]();
        if (!this[`featuresNative${props.capitalName}Tracks`] || !elTracks || !elTracks.addEventListener) return;
        const listeners = {
            change: (e)=>{
                const event = {
                    type: 'change',
                    target: techTracks,
                    currentTarget: techTracks,
                    srcElement: techTracks
                };
                techTracks.trigger(event);
                // if we are a text track change event, we should also notify the
                // remote text track list. This can potentially cause a false positive
                // if we were to get a change event on a non-remote track and
                // we triggered the event on the remote text track list which doesn't
                // contain that track. However, best practices mean looping through the
                // list of tracks and searching for the appropriate mode value, so,
                // this shouldn't pose an issue
                if (name === 'text') this[$cb03b711053a4297$var$REMOTE.remoteText.getterName]().trigger(event);
            },
            addtrack (e) {
                techTracks.addTrack(e.track);
            },
            removetrack (e) {
                techTracks.removeTrack(e.track);
            }
        };
        const removeOldTracks = function() {
            const removeTracks = [];
            for(let i = 0; i < techTracks.length; i++){
                let found = false;
                for(let j = 0; j < elTracks.length; j++)if (elTracks[j] === techTracks[i]) {
                    found = true;
                    break;
                }
                if (!found) removeTracks.push(techTracks[i]);
            }
            while(removeTracks.length)techTracks.removeTrack(removeTracks.shift());
        };
        this[props.getterName + 'Listeners_'] = listeners;
        Object.keys(listeners).forEach((eventName)=>{
            const listener = listeners[eventName];
            elTracks.addEventListener(eventName, listener);
            this.on('dispose', (e)=>elTracks.removeEventListener(eventName, listener));
        });
        // Remove (native) tracks that are not used anymore
        this.on('loadstart', removeOldTracks);
        this.on('dispose', (e)=>this.off('loadstart', removeOldTracks));
    }
    /**
   * Proxy all native track list events to our track lists if the browser we are playing
   * in supports that type of track list.
   *
   * @private
   */ proxyNativeTracks_() {
        $cb03b711053a4297$var$NORMAL.names.forEach((name)=>{
            this.proxyNativeTracksForType_(name);
        });
    }
    /**
   * Create the `Html5` Tech's DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl() {
        let el = this.options_.tag;
        // Check if this browser supports moving the element into the box.
        // On the iPhone video will break if you move the element,
        // So we have to create a brand new element.
        // If we ingested the player div, we do not need to move the media element.
        if (!el || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
            // If the original tag is still there, clone and remove it.
            if (el) {
                const clone = el.cloneNode(true);
                if (el.parentNode) el.parentNode.insertBefore(clone, el);
                $cb03b711053a4297$var$Html5.disposeMediaElement(el);
                el = clone;
            } else {
                el = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('video');
                // determine if native controls should be used
                const tagAttributes = this.options_.tag && $cb03b711053a4297$var$getAttributes(this.options_.tag);
                const attributes = $cb03b711053a4297$var$merge$1({}, tagAttributes);
                if (!$cb03b711053a4297$var$TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) delete attributes.controls;
                $cb03b711053a4297$var$setAttributes(el, Object.assign(attributes, {
                    id: this.options_.techId,
                    class: 'vjs-tech'
                }));
            }
            el.playerId = this.options_.playerId;
        }
        if (typeof this.options_.preload !== 'undefined') $cb03b711053a4297$var$setAttribute(el, 'preload', this.options_.preload);
        if (this.options_.disablePictureInPicture !== undefined) el.disablePictureInPicture = this.options_.disablePictureInPicture;
        // Update specific tag settings, in case they were overridden
        // `autoplay` has to be *last* so that `muted` and `playsinline` are present
        // when iOS/Safari or other browsers attempt to autoplay.
        const settingsAttrs = [
            'loop',
            'muted',
            'playsinline',
            'autoplay'
        ];
        for(let i = 0; i < settingsAttrs.length; i++){
            const attr = settingsAttrs[i];
            const value = this.options_[attr];
            if (typeof value !== 'undefined') {
                if (value) $cb03b711053a4297$var$setAttribute(el, attr, attr);
                else $cb03b711053a4297$var$removeAttribute(el, attr);
                el[attr] = value;
            }
        }
        return el;
    }
    /**
   * This will be triggered if the loadstart event has already fired, before videojs was
   * ready. Two known examples of when this can happen are:
   * 1. If we're loading the playback object after it has started loading
   * 2. The media is already playing the (often with autoplay on) then
   *
   * This function will fire another loadstart so that videojs can catchup.
   *
   * @fires Tech#loadstart
   *
   * @return {undefined}
   *         returns nothing.
   */ handleLateInit_(el) {
        if (el.networkState === 0 || el.networkState === 3) // The video element hasn't started loading the source yet
        // or didn't find a source
        return;
        if (el.readyState === 0) {
            // NetworkState is set synchronously BUT loadstart is fired at the
            // end of the current stack, usually before setInterval(fn, 0).
            // So at this point we know loadstart may have already fired or is
            // about to fire, and either way the player hasn't seen it yet.
            // We don't want to fire loadstart prematurely here and cause a
            // double loadstart so we'll wait and see if it happens between now
            // and the next loop, and fire it if not.
            // HOWEVER, we also want to make sure it fires before loadedmetadata
            // which could also happen between now and the next loop, so we'll
            // watch for that also.
            let loadstartFired = false;
            const setLoadstartFired = function() {
                loadstartFired = true;
            };
            this.on('loadstart', setLoadstartFired);
            const triggerLoadstart = function() {
                // We did miss the original loadstart. Make sure the player
                // sees loadstart before loadedmetadata
                if (!loadstartFired) this.trigger('loadstart');
            };
            this.on('loadedmetadata', triggerLoadstart);
            this.ready(function() {
                this.off('loadstart', setLoadstartFired);
                this.off('loadedmetadata', triggerLoadstart);
                if (!loadstartFired) // We did miss the original native loadstart. Fire it now.
                this.trigger('loadstart');
            });
            return;
        }
        // From here on we know that loadstart already fired and we missed it.
        // The other readyState events aren't as much of a problem if we double
        // them, so not going to go to as much trouble as loadstart to prevent
        // that unless we find reason to.
        const eventsToTrigger = [
            'loadstart'
        ];
        // loadedmetadata: newly equal to HAVE_METADATA (1) or greater
        eventsToTrigger.push('loadedmetadata');
        // loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
        if (el.readyState >= 2) eventsToTrigger.push('loadeddata');
        // canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
        if (el.readyState >= 3) eventsToTrigger.push('canplay');
        // canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
        if (el.readyState >= 4) eventsToTrigger.push('canplaythrough');
        // We still need to give the player time to add event listeners
        this.ready(function() {
            eventsToTrigger.forEach(function(type) {
                this.trigger(type);
            }, this);
        });
    }
    /**
   * Set whether we are scrubbing or not.
   * This is used to decide whether we should use `fastSeek` or not.
   * `fastSeek` is used to provide trick play on Safari browsers.
   *
   * @param {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */ setScrubbing(isScrubbing) {
        this.isScrubbing_ = isScrubbing;
    }
    /**
   * Get whether we are scrubbing or not.
   *
   * @return {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */ scrubbing() {
        return this.isScrubbing_;
    }
    /**
   * Set current time for the `HTML5` tech.
   *
   * @param {number} seconds
   *        Set the current time of the media to this.
   */ setCurrentTime(seconds) {
        try {
            if (this.isScrubbing_ && this.el_.fastSeek && $cb03b711053a4297$var$IS_ANY_SAFARI) this.el_.fastSeek(seconds);
            else this.el_.currentTime = seconds;
        } catch (e) {
            $cb03b711053a4297$var$log$1(e, 'Video is not ready. (Video.js)');
        // this.warning(VideoJS.warnings.videoNotReady);
        }
    }
    /**
   * Get the current duration of the HTML5 media element.
   *
   * @return {number}
   *         The duration of the media or 0 if there is no duration.
   */ duration() {
        // Android Chrome will report duration as Infinity for VOD HLS until after
        // playback has started, which triggers the live display erroneously.
        // Return NaN if playback has not started and trigger a durationupdate once
        // the duration can be reliably known.
        if (this.el_.duration === Infinity && $cb03b711053a4297$var$IS_ANDROID && $cb03b711053a4297$var$IS_CHROME && this.el_.currentTime === 0) {
            // Wait for the first `timeupdate` with currentTime > 0 - there may be
            // several with 0
            const checkProgress = ()=>{
                if (this.el_.currentTime > 0) {
                    // Trigger durationchange for genuinely live video
                    if (this.el_.duration === Infinity) this.trigger('durationchange');
                    this.off('timeupdate', checkProgress);
                }
            };
            this.on('timeupdate', checkProgress);
            return NaN;
        }
        return this.el_.duration || NaN;
    }
    /**
   * Get the current width of the HTML5 media element.
   *
   * @return {number}
   *         The width of the HTML5 media element.
   */ width() {
        return this.el_.offsetWidth;
    }
    /**
   * Get the current height of the HTML5 media element.
   *
   * @return {number}
   *         The height of the HTML5 media element.
   */ height() {
        return this.el_.offsetHeight;
    }
    /**
   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
   * `fullscreenchange` event.
   *
   * @private
   * @fires fullscreenchange
   * @listens webkitendfullscreen
   * @listens webkitbeginfullscreen
   * @listens webkitbeginfullscreen
   */ proxyWebkitFullscreen_() {
        if (!('webkitDisplayingFullscreen' in this.el_)) return;
        const endFn = function() {
            this.trigger('fullscreenchange', {
                isFullscreen: false
            });
            // Safari will sometimes set controls on the videoelement when existing fullscreen.
            if (this.el_.controls && !this.options_.nativeControlsForTouch && this.controls()) this.el_.controls = false;
        };
        const beginFn = function() {
            if ('webkitPresentationMode' in this.el_ && this.el_.webkitPresentationMode !== 'picture-in-picture') {
                this.one('webkitendfullscreen', endFn);
                this.trigger('fullscreenchange', {
                    isFullscreen: true,
                    // set a flag in case another tech triggers fullscreenchange
                    nativeIOSFullscreen: true
                });
            }
        };
        this.on('webkitbeginfullscreen', beginFn);
        this.on('dispose', ()=>{
            this.off('webkitbeginfullscreen', beginFn);
            this.off('webkitendfullscreen', endFn);
        });
    }
    /**
   * Check if fullscreen is supported on the video el.
   *
   * @return {boolean}
   *         - True if fullscreen is supported.
   *         - False if fullscreen is not supported.
   */ supportsFullScreen() {
        return typeof this.el_.webkitEnterFullScreen === 'function';
    }
    /**
   * Request that the `HTML5` Tech enter fullscreen.
   */ enterFullScreen() {
        const video = this.el_;
        if (video.paused && video.networkState <= video.HAVE_METADATA) {
            // attempt to prime the video element for programmatic access
            // this isn't necessary on the desktop but shouldn't hurt
            $cb03b711053a4297$var$silencePromise(this.el_.play());
            // playing and pausing synchronously during the transition to fullscreen
            // can get iOS ~6.1 devices into a play/pause loop
            this.setTimeout(function() {
                video.pause();
                try {
                    video.webkitEnterFullScreen();
                } catch (e) {
                    this.trigger('fullscreenerror', e);
                }
            }, 0);
        } else try {
            video.webkitEnterFullScreen();
        } catch (e) {
            this.trigger('fullscreenerror', e);
        }
    }
    /**
   * Request that the `HTML5` Tech exit fullscreen.
   */ exitFullScreen() {
        if (!this.el_.webkitDisplayingFullscreen) {
            this.trigger('fullscreenerror', new Error('The video is not fullscreen'));
            return;
        }
        this.el_.webkitExitFullScreen();
    }
    /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */ requestPictureInPicture() {
        return this.el_.requestPictureInPicture();
    }
    /**
   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
   * Needs to be checked later than the constructor
   * This will be a false positive for clear sources loaded after a Fairplay source
   *
   * @param {function} cb function to call
   * @return {number} id of request
   */ requestVideoFrameCallback(cb) {
        if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) return this.el_.requestVideoFrameCallback(cb);
        return super.requestVideoFrameCallback(cb);
    }
    /**
   * Native or fallback requestVideoFrameCallback
   *
   * @param {number} id request id to cancel
   */ cancelVideoFrameCallback(id) {
        if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) this.el_.cancelVideoFrameCallback(id);
        else super.cancelVideoFrameCallback(id);
    }
    /**
   * A getter/setter for the `Html5` Tech's source object.
   * > Note: Please use {@link Html5#setSource}
   *
   * @param {Tech~SourceObject} [src]
   *        The source object you want to set on the `HTML5` techs element.
   *
   * @return {Tech~SourceObject|undefined}
   *         - The current source object when a source is not passed in.
   *         - undefined when setting
   *
   * @deprecated Since version 5.
   */ src(src) {
        if (src === undefined) return this.el_.src;
        // Setting src through `src` instead of `setSrc` will be deprecated
        this.setSrc(src);
    }
    /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */ addSourceElement(srcUrl, mimeType) {
        if (!srcUrl) {
            $cb03b711053a4297$var$log$1.error('Invalid source URL.');
            return false;
        }
        const sourceAttributes = {
            src: srcUrl
        };
        if (mimeType) sourceAttributes.type = mimeType;
        const sourceElement = $cb03b711053a4297$var$createEl('source', {}, sourceAttributes);
        this.el_.appendChild(sourceElement);
        return true;
    }
    /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */ removeSourceElement(srcUrl) {
        if (!srcUrl) {
            $cb03b711053a4297$var$log$1.error('Source URL is required to remove the source element.');
            return false;
        }
        const sourceElements = this.el_.querySelectorAll('source');
        for (const sourceElement of sourceElements)if (sourceElement.src === srcUrl) {
            this.el_.removeChild(sourceElement);
            return true;
        }
        $cb03b711053a4297$var$log$1.warn(`No matching source element found with src: ${srcUrl}`);
        return false;
    }
    /**
   * Reset the tech by removing all sources and then calling
   * {@link Html5.resetMediaElement}.
   */ reset() {
        $cb03b711053a4297$var$Html5.resetMediaElement(this.el_);
    }
    /**
   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
   * the HTML5 media element.
   *
   * @return {Tech~SourceObject}
   *         The current source object from the HTML5 tech. With a fallback to the
   *         elements source.
   */ currentSrc() {
        if (this.currentSource_) return this.currentSource_.src;
        return this.el_.currentSrc;
    }
    /**
   * Set controls attribute for the HTML5 media Element.
   *
   * @param {string} val
   *        Value to set the controls attribute to
   */ setControls(val) {
        this.el_.controls = !!val;
    }
    /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */ addTextTrack(kind, label, language) {
        if (!this.featuresNativeTextTracks) return super.addTextTrack(kind, label, language);
        return this.el_.addTextTrack(kind, label, language);
    }
    /**
   * Creates either native TextTrack or an emulated TextTrack depending
   * on the value of `featuresNativeTextTracks`
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label]
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @param {boolean} [options.default]
   *        Default this track to on.
   *
   * @param {string} [options.id]
   *        The internal id to assign this track.
   *
   * @param {string} [options.src]
   *        A source url for the track.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */ createRemoteTextTrack(options) {
        if (!this.featuresNativeTextTracks) return super.createRemoteTextTrack(options);
        const htmlTrackElement = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('track');
        if (options.kind) htmlTrackElement.kind = options.kind;
        if (options.label) htmlTrackElement.label = options.label;
        if (options.language || options.srclang) htmlTrackElement.srclang = options.language || options.srclang;
        if (options.default) htmlTrackElement.default = options.default;
        if (options.id) htmlTrackElement.id = options.id;
        if (options.src) htmlTrackElement.src = options.src;
        return htmlTrackElement;
    }
    /**
   * Creates a remote text track object and returns an html track element.
   *
   * @param {Object} options The object should contain values for
   * kind, language, label, and src (location of the WebVTT file)
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack
   * will not be removed from the TextTrackList and HtmlTrackElementList
   * after a source change
   * @return {HTMLTrackElement} An Html Track Element.
   * This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   */ addRemoteTextTrack(options, manualCleanup) {
        const htmlTrackElement = super.addRemoteTextTrack(options, manualCleanup);
        if (this.featuresNativeTextTracks) this.el().appendChild(htmlTrackElement);
        return htmlTrackElement;
    }
    /**
   * Remove remote `TextTrack` from `TextTrackList` object
   *
   * @param {TextTrack} track
   *        `TextTrack` object to remove
   */ removeRemoteTextTrack(track) {
        super.removeRemoteTextTrack(track);
        if (this.featuresNativeTextTracks) {
            const tracks = this.$$('track');
            let i = tracks.length;
            while(i--)if (track === tracks[i] || track === tracks[i].track) this.el().removeChild(tracks[i]);
        }
    }
    /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   */ getVideoPlaybackQuality() {
        if (typeof this.el().getVideoPlaybackQuality === 'function') return this.el().getVideoPlaybackQuality();
        const videoPlaybackQuality = {};
        if (typeof this.el().webkitDroppedFrameCount !== 'undefined' && typeof this.el().webkitDecodedFrameCount !== 'undefined') {
            videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
            videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance) videoPlaybackQuality.creationTime = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now();
        return videoPlaybackQuality;
    }
}
/* HTML5 Support Testing ---------------------------------------------------- */ /**
 * Element for testing browser HTML5 media capabilities
 *
 * @type {Element}
 * @constant
 * @private
 */ $cb03b711053a4297$var$defineLazyProperty($cb03b711053a4297$var$Html5, 'TEST_VID', function() {
    if (!$cb03b711053a4297$var$isReal()) return;
    const video = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('video');
    const track = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('track');
    track.kind = 'captions';
    track.srclang = 'en';
    track.label = 'English';
    video.appendChild(track);
    return video;
});
/**
 * Check if HTML5 media is supported by this browser/device.
 *
 * @return {boolean}
 *         - True if HTML5 media is supported.
 *         - False if HTML5 media is not supported.
 */ $cb03b711053a4297$var$Html5.isSupported = function() {
    // IE with no Media Player is a LIAR! (#984)
    try {
        $cb03b711053a4297$var$Html5.TEST_VID.volume = 0.5;
    } catch (e) {
        return false;
    }
    return !!($cb03b711053a4297$var$Html5.TEST_VID && $cb03b711053a4297$var$Html5.TEST_VID.canPlayType);
};
/**
 * Check if the tech can support the given type
 *
 * @param {string} type
 *        The mimetype to check
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */ $cb03b711053a4297$var$Html5.canPlayType = function(type) {
    return $cb03b711053a4297$var$Html5.TEST_VID.canPlayType(type);
};
/**
 * Check if the tech can support the given source
 *
 * @param {Object} srcObj
 *        The source object
 * @param {Object} options
 *        The options passed to the tech
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */ $cb03b711053a4297$var$Html5.canPlaySource = function(srcObj, options) {
    return $cb03b711053a4297$var$Html5.canPlayType(srcObj.type);
};
/**
 * Check if the volume can be changed in this browser/device.
 * Volume cannot be changed in a lot of mobile devices.
 * Specifically, it can't be changed from 1 on iOS.
 *
 * @return {boolean}
 *         - True if volume can be controlled
 *         - False otherwise
 */ $cb03b711053a4297$var$Html5.canControlVolume = function() {
    // IE will error if Windows Media Player not installed #3315
    try {
        const volume = $cb03b711053a4297$var$Html5.TEST_VID.volume;
        $cb03b711053a4297$var$Html5.TEST_VID.volume = volume / 2 + 0.1;
        const canControl = volume !== $cb03b711053a4297$var$Html5.TEST_VID.volume;
        // With the introduction of iOS 15, there are cases where the volume is read as
        // changed but reverts back to its original state at the start of the next tick.
        // To determine whether volume can be controlled on iOS,
        // a timeout is set and the volume is checked asynchronously.
        // Since `features` doesn't currently work asynchronously, the value is manually set.
        if (canControl && $cb03b711053a4297$var$IS_IOS) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
                if ($cb03b711053a4297$var$Html5 && $cb03b711053a4297$var$Html5.prototype) $cb03b711053a4297$var$Html5.prototype.featuresVolumeControl = volume !== $cb03b711053a4297$var$Html5.TEST_VID.volume;
            });
            // default iOS to false, which will be updated in the timeout above.
            return false;
        }
        return canControl;
    } catch (e) {
        return false;
    }
};
/**
 * Check if the volume can be muted in this browser/device.
 * Some devices, e.g. iOS, don't allow changing volume
 * but permits muting/unmuting.
 *
 * @return {boolean}
 *      - True if volume can be muted
 *      - False otherwise
 */ $cb03b711053a4297$var$Html5.canMuteVolume = function() {
    try {
        const muted = $cb03b711053a4297$var$Html5.TEST_VID.muted;
        // in some versions of iOS muted property doesn't always
        // work, so we want to set both property and attribute
        $cb03b711053a4297$var$Html5.TEST_VID.muted = !muted;
        if ($cb03b711053a4297$var$Html5.TEST_VID.muted) $cb03b711053a4297$var$setAttribute($cb03b711053a4297$var$Html5.TEST_VID, 'muted', 'muted');
        else $cb03b711053a4297$var$removeAttribute($cb03b711053a4297$var$Html5.TEST_VID, 'muted', 'muted');
        return muted !== $cb03b711053a4297$var$Html5.TEST_VID.muted;
    } catch (e) {
        return false;
    }
};
/**
 * Check if the playback rate can be changed in this browser/device.
 *
 * @return {boolean}
 *         - True if playback rate can be controlled
 *         - False otherwise
 */ $cb03b711053a4297$var$Html5.canControlPlaybackRate = function() {
    // Playback rate API is implemented in Android Chrome, but doesn't do anything
    // https://github.com/videojs/video.js/issues/3180
    if ($cb03b711053a4297$var$IS_ANDROID && $cb03b711053a4297$var$IS_CHROME && $cb03b711053a4297$var$CHROME_VERSION < 58) return false;
    // IE will error if Windows Media Player not installed #3315
    try {
        const playbackRate = $cb03b711053a4297$var$Html5.TEST_VID.playbackRate;
        $cb03b711053a4297$var$Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
        return playbackRate !== $cb03b711053a4297$var$Html5.TEST_VID.playbackRate;
    } catch (e) {
        return false;
    }
};
/**
 * Check if we can override a video/audio elements attributes, with
 * Object.defineProperty.
 *
 * @return {boolean}
 *         - True if builtin attributes can be overridden
 *         - False otherwise
 */ $cb03b711053a4297$var$Html5.canOverrideAttributes = function() {
    // if we cannot overwrite the src/innerHTML property, there is no support
    // iOS 7 safari for instance cannot do this.
    try {
        const noop = ()=>{};
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('video'), 'src', {
            get: noop,
            set: noop
        });
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('audio'), 'src', {
            get: noop,
            set: noop
        });
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('video'), 'innerHTML', {
            get: noop,
            set: noop
        });
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('audio'), 'innerHTML', {
            get: noop,
            set: noop
        });
    } catch (e) {
        return false;
    }
    return true;
};
/**
 * Check to see if native `TextTrack`s are supported by this browser/device.
 *
 * @return {boolean}
 *         - True if native `TextTrack`s are supported.
 *         - False otherwise
 */ $cb03b711053a4297$var$Html5.supportsNativeTextTracks = function() {
    return $cb03b711053a4297$var$IS_ANY_SAFARI || $cb03b711053a4297$var$IS_IOS && $cb03b711053a4297$var$IS_CHROME;
};
/**
 * Check to see if native `VideoTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `VideoTrack`s are supported.
 *        - False otherwise
 */ $cb03b711053a4297$var$Html5.supportsNativeVideoTracks = function() {
    return !!($cb03b711053a4297$var$Html5.TEST_VID && $cb03b711053a4297$var$Html5.TEST_VID.videoTracks);
};
/**
 * Check to see if native `AudioTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `AudioTrack`s are supported.
 *        - False otherwise
 */ $cb03b711053a4297$var$Html5.supportsNativeAudioTracks = function() {
    return !!($cb03b711053a4297$var$Html5.TEST_VID && $cb03b711053a4297$var$Html5.TEST_VID.audioTracks);
};
/**
 * An array of events available on the Html5 tech.
 *
 * @private
 * @type {Array}
 */ $cb03b711053a4297$var$Html5.Events = [
    'loadstart',
    'suspend',
    'abort',
    'error',
    'emptied',
    'stalled',
    'loadedmetadata',
    'loadeddata',
    'canplay',
    'canplaythrough',
    'playing',
    'waiting',
    'seeking',
    'seeked',
    'ended',
    'durationchange',
    'timeupdate',
    'progress',
    'play',
    'pause',
    'ratechange',
    'resize',
    'volumechange'
];
/**
 * Boolean indicating whether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default {@link Html5.canControlVolume}
 */ /**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {boolean}
 * @default {@link Html5.canMuteVolume}
 */ /**
 * Boolean indicating whether the `Tech` supports changing the speed at which the media
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default {@link Html5.canControlPlaybackRate}
 */ /**
 * Boolean indicating whether the `Tech` supports the `sourceset` event.
 *
 * @type {boolean}
 * @default
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeTextTracks}
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeVideoTracks}
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeAudioTracks}
 */ [
    [
        'featuresMuteControl',
        'canMuteVolume'
    ],
    [
        'featuresPlaybackRate',
        'canControlPlaybackRate'
    ],
    [
        'featuresSourceset',
        'canOverrideAttributes'
    ],
    [
        'featuresNativeTextTracks',
        'supportsNativeTextTracks'
    ],
    [
        'featuresNativeVideoTracks',
        'supportsNativeVideoTracks'
    ],
    [
        'featuresNativeAudioTracks',
        'supportsNativeAudioTracks'
    ]
].forEach(function([key, fn]) {
    $cb03b711053a4297$var$defineLazyProperty($cb03b711053a4297$var$Html5.prototype, key, ()=>$cb03b711053a4297$var$Html5[fn](), true);
});
$cb03b711053a4297$var$Html5.prototype.featuresVolumeControl = $cb03b711053a4297$var$Html5.canControlVolume();
/**
 * Boolean indicating whether the `HTML5` tech currently supports the media element
 * moving in the DOM. iOS breaks if you move the media element, so this is set this to
 * false there. Everywhere else this should be true.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Html5.prototype.movingMediaElementInDOM = !$cb03b711053a4297$var$IS_IOS;
// TODO: Previous comment: No longer appears to be used. Can probably be removed.
//       Is this true?
/**
 * Boolean indicating whether the `HTML5` tech currently supports automatic media resize
 * when going into fullscreen.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Html5.prototype.featuresFullscreenResize = true;
/**
 * Boolean indicating whether the `HTML5` tech currently supports the progress event.
 * If this is false, manual `progress` events will be triggered instead.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Html5.prototype.featuresProgressEvents = true;
/**
 * Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
 * If this is false, manual `timeupdate` events will be triggered instead.
 *
 * @default
 */ $cb03b711053a4297$var$Html5.prototype.featuresTimeupdateEvents = true;
/**
 * Whether the HTML5 el supports `requestVideoFrameCallback`
 *
 * @type {boolean}
 */ $cb03b711053a4297$var$Html5.prototype.featuresVideoFrameCallback = !!($cb03b711053a4297$var$Html5.TEST_VID && $cb03b711053a4297$var$Html5.TEST_VID.requestVideoFrameCallback);
$cb03b711053a4297$var$Html5.disposeMediaElement = function(el) {
    if (!el) return;
    if (el.parentNode) el.parentNode.removeChild(el);
    // remove any child track or source nodes to prevent their loading
    while(el.hasChildNodes())el.removeChild(el.firstChild);
    // remove any src reference. not setting `src=''` because that causes a warning
    // in firefox
    el.removeAttribute('src');
    // force the media element to update its loading state by calling load()
    // however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
    if (typeof el.load === 'function') // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
    (function() {
        try {
            el.load();
        } catch (e) {
        // not supported
        }
    })();
};
$cb03b711053a4297$var$Html5.resetMediaElement = function(el) {
    if (!el) return;
    const sources = el.querySelectorAll('source');
    let i = sources.length;
    while(i--)el.removeChild(sources[i]);
    // remove any src reference.
    // not setting `src=''` because that throws an error
    el.removeAttribute('src');
    if (typeof el.load === 'function') // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
    (function() {
        try {
            el.load();
        } catch (e) {
        // satisfy linter
        }
    })();
};
/* Native HTML5 element property wrapping ----------------------------------- */ // Wrap native boolean attributes with getters that check both property and attribute
// The list is as followed:
// muted, defaultMuted, autoplay, controls, loop, playsinline
[
    /**
 * Get the value of `muted` from the media element. `muted` indicates
 * that the volume for the media should be set to silent. This does not actually change
 * the `volume` attribute.
 *
 * @method Html5#muted
 * @return {boolean}
 *         - True if the value of `volume` should be ignored and the audio set to silent.
 *         - False if the value of `volume` should be used.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */ 'muted',
    /**
 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
 * whether the media should start muted or not. Only changes the default state of the
 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
 * current state.
 *
 * @method Html5#defaultMuted
 * @return {boolean}
 *         - The value of `defaultMuted` from the media element.
 *         - True indicates that the media should start muted.
 *         - False indicates that the media should not start muted
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */ 'defaultMuted',
    /**
 * Get the value of `autoplay` from the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#autoplay
 * @return {boolean}
 *         - The value of `autoplay` from the media element.
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */ 'autoplay',
    /**
 * Get the value of `controls` from the media element. `controls` indicates
 * whether the native media controls should be shown or hidden.
 *
 * @method Html5#controls
 * @return {boolean}
 *         - The value of `controls` from the media element.
 *         - True indicates that native controls should be showing.
 *         - False indicates that native controls should be hidden.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
 */ 'controls',
    /**
 * Get the value of `loop` from the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#loop
 * @return {boolean}
 *         - The value of `loop` from the media element.
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */ 'loop',
    /**
 * Get the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#playsinline
 * @return {boolean}
 *         - The value of `playsinline` from the media element.
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */ 'playsinline'
].forEach(function(prop) {
    $cb03b711053a4297$var$Html5.prototype[prop] = function() {
        return this.el_[prop] || this.el_.hasAttribute(prop);
    };
});
// Wrap native boolean attributes with setters that set both property and attribute
// The list is as followed:
// setMuted, setDefaultMuted, setAutoplay, setLoop, setPlaysinline
// setControls is special-cased above
[
    /**
 * Set the value of `muted` on the media element. `muted` indicates that the current
 * audio level should be silent.
 *
 * @method Html5#setMuted
 * @param {boolean} muted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */ 'muted',
    /**
 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
 * audio level should be silent, but will only effect the muted level on initial playback..
 *
 * @method Html5.prototype.setDefaultMuted
 * @param {boolean} defaultMuted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */ 'defaultMuted',
    /**
 * Set the value of `autoplay` on the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#setAutoplay
 * @param {boolean} autoplay
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */ 'autoplay',
    /**
 * Set the value of `loop` on the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#setLoop
 * @param {boolean} loop
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */ 'loop',
    /**
 * Set the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#setPlaysinline
 * @param {boolean} playsinline
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */ 'playsinline'
].forEach(function(prop) {
    $cb03b711053a4297$var$Html5.prototype['set' + $cb03b711053a4297$var$toTitleCase$1(prop)] = function(v) {
        this.el_[prop] = v;
        if (v) this.el_.setAttribute(prop, prop);
        else this.el_.removeAttribute(prop);
    };
});
// Wrap native properties with a getter
// The list is as followed
// paused, currentTime, buffered, volume, poster, preload, error, seeking
// seekable, ended, playbackRate, defaultPlaybackRate, disablePictureInPicture
// played, networkState, readyState, videoWidth, videoHeight, crossOrigin
[
    /**
 * Get the value of `paused` from the media element. `paused` indicates whether the media element
 * is currently paused or not.
 *
 * @method Html5#paused
 * @return {boolean}
 *         The value of `paused` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
 */ 'paused',
    /**
 * Get the value of `currentTime` from the media element. `currentTime` indicates
 * the current second that the media is at in playback.
 *
 * @method Html5#currentTime
 * @return {number}
 *         The value of `currentTime` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
 */ 'currentTime',
    /**
 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
 * object that represents the parts of the media that are already downloaded and
 * available for playback.
 *
 * @method Html5#buffered
 * @return {TimeRange}
 *         The value of `buffered` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
 */ 'buffered',
    /**
 * Get the value of `volume` from the media element. `volume` indicates
 * the current playback volume of audio for a media. `volume` will be a value from 0
 * (silent) to 1 (loudest and default).
 *
 * @method Html5#volume
 * @return {number}
 *         The value of `volume` from the media element. Value will be between 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */ 'volume',
    /**
 * Get the value of `poster` from the media element. `poster` indicates
 * that the url of an image file that can/will be shown when no media data is available.
 *
 * @method Html5#poster
 * @return {string}
 *         The value of `poster` from the media element. Value will be a url to an
 *         image.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
 */ 'poster',
    /**
 * Get the value of `preload` from the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#preload
 * @return {string}
 *         The value of `preload` from the media element. Will be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */ 'preload',
    /**
 * Get the value of the `error` from the media element. `error` indicates any
 * MediaError that may have occurred during playback. If error returns null there is no
 * current error.
 *
 * @method Html5#error
 * @return {MediaError|null}
 *         The value of `error` from the media element. Will be `MediaError` if there
 *         is a current error and null otherwise.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
 */ 'error',
    /**
 * Get the value of `seeking` from the media element. `seeking` indicates whether the
 * media is currently seeking to a new position or not.
 *
 * @method Html5#seeking
 * @return {boolean}
 *         - The value of `seeking` from the media element.
 *         - True indicates that the media is currently seeking to a new position.
 *         - False indicates that the media is not seeking to a new position at this time.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
 */ 'seeking',
    /**
 * Get the value of `seekable` from the media element. `seekable` returns a
 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
 *
 * @method Html5#seekable
 * @return {TimeRange}
 *         The value of `seekable` from the media element. A `TimeRange` object
 *         indicating the current ranges of time that can be seeked to.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
 */ 'seekable',
    /**
 * Get the value of `ended` from the media element. `ended` indicates whether
 * the media has reached the end or not.
 *
 * @method Html5#ended
 * @return {boolean}
 *         - The value of `ended` from the media element.
 *         - True indicates that the media has ended.
 *         - False indicates that the media has not ended.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
 */ 'ended',
    /**
 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
 * the rate at which the media is currently playing back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#playbackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */ 'playbackRate',
    /**
 * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
 * the rate at which the media is currently playing back. This value will not indicate the current
 * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
 *
 * Examples:
 *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
 *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.defaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */ 'defaultPlaybackRate',
    /**
 * Get the value of 'disablePictureInPicture' from the video element.
 *
 * @method Html5#disablePictureInPicture
 * @return {boolean} value
 *         - The value of `disablePictureInPicture` from the video element.
 *         - True indicates that the video can't be played in Picture-In-Picture mode
 *         - False indicates that the video can be played in Picture-In-Picture mode
 *
 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
 */ 'disablePictureInPicture',
    /**
 * Get the value of `played` from the media element. `played` returns a `TimeRange`
 * object representing points in the media timeline that have been played.
 *
 * @method Html5#played
 * @return {TimeRange}
 *         The value of `played` from the media element. A `TimeRange` object indicating
 *         the ranges of time that have been played.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
 */ 'played',
    /**
 * Get the value of `networkState` from the media element. `networkState` indicates
 * the current network state. It returns an enumeration from the following list:
 * - 0: NETWORK_EMPTY
 * - 1: NETWORK_IDLE
 * - 2: NETWORK_LOADING
 * - 3: NETWORK_NO_SOURCE
 *
 * @method Html5#networkState
 * @return {number}
 *         The value of `networkState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
 */ 'networkState',
    /**
 * Get the value of `readyState` from the media element. `readyState` indicates
 * the current state of the media element. It returns an enumeration from the
 * following list:
 * - 0: HAVE_NOTHING
 * - 1: HAVE_METADATA
 * - 2: HAVE_CURRENT_DATA
 * - 3: HAVE_FUTURE_DATA
 * - 4: HAVE_ENOUGH_DATA
 *
 * @method Html5#readyState
 * @return {number}
 *         The value of `readyState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
 */ 'readyState',
    /**
 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
 * the current width of the video in css pixels.
 *
 * @method Html5#videoWidth
 * @return {number}
 *         The value of `videoWidth` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */ 'videoWidth',
    /**
 * Get the value of `videoHeight` from the video element. `videoHeight` indicates
 * the current height of the video in css pixels.
 *
 * @method Html5#videoHeight
 * @return {number}
 *         The value of `videoHeight` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */ 'videoHeight',
    /**
 * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
 * to the browser that should sent the cookies along with the requests for the
 * different assets/playlists
 *
 * @method Html5#crossOrigin
 * @return {string}
 *         - anonymous indicates that the media should not sent cookies.
 *         - use-credentials indicates that the media should sent cookies along the requests.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
 */ 'crossOrigin'
].forEach(function(prop) {
    $cb03b711053a4297$var$Html5.prototype[prop] = function() {
        return this.el_[prop];
    };
});
// Wrap native properties with a setter in this format:
// set + toTitleCase(name)
// The list is as follows:
// setVolume, setSrc, setPoster, setPreload, setPlaybackRate, setDefaultPlaybackRate,
// setDisablePictureInPicture, setCrossOrigin
[
    /**
 * Set the value of `volume` on the media element. `volume` indicates the current
 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
 * so on.
 *
 * @method Html5#setVolume
 * @param {number} percentAsDecimal
 *        The volume percent as a decimal. Valid range is from 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */ 'volume',
    /**
 * Set the value of `src` on the media element. `src` indicates the current
 * {@link Tech~SourceObject} for the media.
 *
 * @method Html5#setSrc
 * @param {Tech~SourceObject} src
 *        The source object to set as the current source.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
 */ 'src',
    /**
 * Set the value of `poster` on the media element. `poster` is the url to
 * an image file that can/will be shown when no media data is available.
 *
 * @method Html5#setPoster
 * @param {string} poster
 *        The url to an image that should be used as the `poster` for the media
 *        element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
 */ 'poster',
    /**
 * Set the value of `preload` on the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#setPreload
 * @param {string} preload
 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */ 'preload',
    /**
 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
 * the rate at which the media should play back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#setPlaybackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */ 'playbackRate',
    /**
 * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
 * the rate at which the media should play back upon initial startup. Changing this value
 * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
 *
 * Example Values:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.setDefaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
 */ 'defaultPlaybackRate',
    /**
 * Prevents the browser from suggesting a Picture-in-Picture context menu
 * or to request Picture-in-Picture automatically in some cases.
 *
 * @method Html5#setDisablePictureInPicture
 * @param {boolean} value
 *         The true value will disable Picture-in-Picture mode.
 *
 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
 */ 'disablePictureInPicture',
    /**
 * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
 * to the browser that should sent the cookies along with the requests for the
 * different assets/playlists
 *
 * @method Html5#setCrossOrigin
 * @param {string} crossOrigin
 *         - anonymous indicates that the media should not sent cookies.
 *         - use-credentials indicates that the media should sent cookies along the requests.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
 */ 'crossOrigin'
].forEach(function(prop) {
    $cb03b711053a4297$var$Html5.prototype['set' + $cb03b711053a4297$var$toTitleCase$1(prop)] = function(v) {
        this.el_[prop] = v;
    };
});
// wrap native functions with a function
// The list is as follows:
// pause, load, play
[
    /**
 * A wrapper around the media elements `pause` function. This will call the `HTML5`
 * media elements `pause` function.
 *
 * @method Html5#pause
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
 */ 'pause',
    /**
 * A wrapper around the media elements `load` function. This will call the `HTML5`s
 * media element `load` function.
 *
 * @method Html5#load
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
 */ 'load',
    /**
 * A wrapper around the media elements `play` function. This will call the `HTML5`s
 * media element `play` function.
 *
 * @method Html5#play
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
 */ 'play'
].forEach(function(prop) {
    $cb03b711053a4297$var$Html5.prototype[prop] = function() {
        return this.el_[prop]();
    };
});
$cb03b711053a4297$var$Tech.withSourceHandlers($cb03b711053a4297$var$Html5);
/**
 * Native source handler for Html5, simply passes the source to the media element.
 *
 * @property {Tech~SourceObject} source
 *        The source object
 *
 * @property {Html5} tech
 *        The instance of the HTML5 tech.
 */ $cb03b711053a4297$var$Html5.nativeSourceHandler = {};
/**
 * Check if the media element can play the given mime type.
 *
 * @param {string} type
 *        The mimetype to check
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string)
 */ $cb03b711053a4297$var$Html5.nativeSourceHandler.canPlayType = function(type) {
    // IE without MediaPlayer throws an error (#519)
    try {
        return $cb03b711053a4297$var$Html5.TEST_VID.canPlayType(type);
    } catch (e) {
        return '';
    }
};
/**
 * Check if the media element can handle a source natively.
 *
 * @param {Tech~SourceObject} source
 *         The source object
 *
 * @param {Object} [options]
 *         Options to be passed to the tech.
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string).
 */ $cb03b711053a4297$var$Html5.nativeSourceHandler.canHandleSource = function(source, options) {
    // If a type was provided we should rely on that
    if (source.type) return $cb03b711053a4297$var$Html5.nativeSourceHandler.canPlayType(source.type);
    else if (source.src) {
        const ext = $cb03b711053a4297$var$getFileExtension(source.src);
        return $cb03b711053a4297$var$Html5.nativeSourceHandler.canPlayType(`video/${ext}`);
    }
    return '';
};
/**
 * Pass the source to the native media element.
 *
 * @param {Tech~SourceObject} source
 *        The source object
 *
 * @param {Html5} tech
 *        The instance of the Html5 tech
 *
 * @param {Object} [options]
 *        The options to pass to the source
 */ $cb03b711053a4297$var$Html5.nativeSourceHandler.handleSource = function(source, tech, options) {
    tech.setSrc(source.src);
};
/**
 * A noop for the native dispose function, as cleanup is not needed.
 */ $cb03b711053a4297$var$Html5.nativeSourceHandler.dispose = function() {};
// Register the native source handler
$cb03b711053a4297$var$Html5.registerSourceHandler($cb03b711053a4297$var$Html5.nativeSourceHandler);
$cb03b711053a4297$var$Tech.registerTech('Html5', $cb03b711053a4297$var$Html5);
/**
 * @file player.js
 */ /** @import AudioTrackList from './tracks/audio-track-list' */ /** @import HtmlTrackElement from './tracks/html-track-element' */ /** @import HtmlTrackElementList from './tracks/html-track-element-list' */ /** @import TextTrackList from './tracks/text-track-list' */ /** @import { TimeRange } from './utils/time' */ /** @import VideoTrackList from './tracks/video-track-list' */ /**
 * @callback PlayerReadyCallback
 * @this     {Player}
 * @returns  {void}
 */ // The following tech events are simply re-triggered
// on the player when they happen
const $cb03b711053a4297$var$TECH_EVENTS_RETRIGGER = [
    /**
 * Fired while the user agent is downloading media data.
 *
 * @event Player#progress
 * @type {Event}
 */ /**
 * Retrigger the `progress` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechProgress_
 * @fires Player#progress
 * @listens Tech#progress
 */ 'progress',
    /**
 * Fires when the loading of an audio/video is aborted.
 *
 * @event Player#abort
 * @type {Event}
 */ /**
 * Retrigger the `abort` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechAbort_
 * @fires Player#abort
 * @listens Tech#abort
 */ 'abort',
    /**
 * Fires when the browser is intentionally not getting media data.
 *
 * @event Player#suspend
 * @type {Event}
 */ /**
 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechSuspend_
 * @fires Player#suspend
 * @listens Tech#suspend
 */ 'suspend',
    /**
 * Fires when the current playlist is empty.
 *
 * @event Player#emptied
 * @type {Event}
 */ /**
 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechEmptied_
 * @fires Player#emptied
 * @listens Tech#emptied
 */ 'emptied',
    /**
 * Fires when the browser is trying to get media data, but data is not available.
 *
 * @event Player#stalled
 * @type {Event}
 */ /**
 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechStalled_
 * @fires Player#stalled
 * @listens Tech#stalled
 */ 'stalled',
    /**
 * Fires when the browser has loaded meta data for the audio/video.
 *
 * @event Player#loadedmetadata
 * @type {Event}
 */ /**
 * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoadedmetadata_
 * @fires Player#loadedmetadata
 * @listens Tech#loadedmetadata
 */ 'loadedmetadata',
    /**
 * Fires when the browser has loaded the current frame of the audio/video.
 *
 * @event Player#loadeddata
 * @type {event}
 */ /**
 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoaddeddata_
 * @fires Player#loadeddata
 * @listens Tech#loadeddata
 */ 'loadeddata',
    /**
 * Fires when the current playback position has changed.
 *
 * @event Player#timeupdate
 * @type {event}
 */ /**
 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTimeUpdate_
 * @fires Player#timeupdate
 * @listens Tech#timeupdate
 */ 'timeupdate',
    /**
 * Fires when the video's intrinsic dimensions change
 *
 * @event Player#resize
 * @type {event}
 */ /**
 * Retrigger the `resize` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechResize_
 * @fires Player#resize
 * @listens Tech#resize
 */ 'resize',
    /**
 * Fires when the volume has been changed
 *
 * @event Player#volumechange
 * @type {event}
 */ /**
 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechVolumechange_
 * @fires Player#volumechange
 * @listens Tech#volumechange
 */ 'volumechange',
    /**
 * Fires when the text track has been changed
 *
 * @event Player#texttrackchange
 * @type {event}
 */ /**
 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTexttrackchange_
 * @fires Player#texttrackchange
 * @listens Tech#texttrackchange
 */ 'texttrackchange'
];
// events to queue when playback rate is zero
// this is a hash for the sole purpose of mapping non-camel-cased event names
// to camel-cased function names
const $cb03b711053a4297$var$TECH_EVENTS_QUEUE = {
    canplay: 'CanPlay',
    canplaythrough: 'CanPlayThrough',
    playing: 'Playing',
    seeked: 'Seeked'
};
const $cb03b711053a4297$var$BREAKPOINT_ORDER = [
    'tiny',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'huge'
];
const $cb03b711053a4297$var$BREAKPOINT_CLASSES = {};
// grep: vjs-layout-tiny
// grep: vjs-layout-x-small
// grep: vjs-layout-small
// grep: vjs-layout-medium
// grep: vjs-layout-large
// grep: vjs-layout-x-large
// grep: vjs-layout-huge
$cb03b711053a4297$var$BREAKPOINT_ORDER.forEach((k)=>{
    const v = k.charAt(0) === 'x' ? `x-${k.substring(1)}` : k;
    $cb03b711053a4297$var$BREAKPOINT_CLASSES[k] = `vjs-layout-${v}`;
});
const $cb03b711053a4297$var$DEFAULT_BREAKPOINTS = {
    tiny: 210,
    xsmall: 320,
    small: 425,
    medium: 768,
    large: 1440,
    xlarge: 2560,
    huge: Infinity
};
/**
 * An instance of the `Player` class is created when any of the Video.js setup methods
 * are used to initialize a video.
 *
 * After an instance has been created it can be accessed globally in three ways:
 * 1. By calling `videojs.getPlayer('example_video_1');`
 * 2. By calling `videojs('example_video_1');` (not recommended)
 * 2. By using it directly via `videojs.players.example_video_1;`
 *
 * @extends Component
 * @global
 */ class $cb03b711053a4297$var$Player extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create an instance of this class.
   *
   * @param {Element} tag
   *        The original video DOM element used for configuring options.
   *
   * @param {Object} [options]
   *        Object of option names and values.
   *
   * @param {PlayerReadyCallback} [ready]
   *        Ready callback function.
   */ constructor(tag, options, ready){
        // Make sure tag ID exists
        // also here.. probably better
        tag.id = tag.id || options.id || `vjs_video_${$cb03b711053a4297$var$newGUID()}`;
        // Set Options
        // The options argument overrides options set in the video tag
        // which overrides globally set options.
        // This latter part coincides with the load order
        // (tag must exist before Player)
        options = Object.assign($cb03b711053a4297$var$Player.getTagSettings(tag), options);
        // Delay the initialization of children because we need to set up
        // player properties first, and can't use `this` before `super()`
        options.initChildren = false;
        // Same with creating the element
        options.createEl = false;
        // don't auto mixin the evented mixin
        options.evented = false;
        // we don't want the player to report touch activity on itself
        // see enableTouchActivity in Component
        options.reportTouchActivity = false;
        // If language is not set, get the closest lang attribute
        if (!options.language) {
            const closest = tag.closest('[lang]');
            if (closest) options.language = closest.getAttribute('lang');
        }
        // Run base component initializing with new options
        super(null, options, ready);
        // Create bound methods for document listeners.
        this.boundDocumentFullscreenChange_ = (e)=>this.documentFullscreenChange_(e);
        this.boundFullWindowOnEscKey_ = (e)=>this.fullWindowOnEscKey(e);
        this.boundUpdateStyleEl_ = (e)=>this.updateStyleEl_(e);
        this.boundApplyInitTime_ = (e)=>this.applyInitTime_(e);
        this.boundUpdateCurrentBreakpoint_ = (e)=>this.updateCurrentBreakpoint_(e);
        this.boundHandleTechClick_ = (e)=>this.handleTechClick_(e);
        this.boundHandleTechDoubleClick_ = (e)=>this.handleTechDoubleClick_(e);
        this.boundHandleTechTouchStart_ = (e)=>this.handleTechTouchStart_(e);
        this.boundHandleTechTouchMove_ = (e)=>this.handleTechTouchMove_(e);
        this.boundHandleTechTouchEnd_ = (e)=>this.handleTechTouchEnd_(e);
        this.boundHandleTechTap_ = (e)=>this.handleTechTap_(e);
        this.boundUpdatePlayerHeightOnAudioOnlyMode_ = (e)=>this.updatePlayerHeightOnAudioOnlyMode_(e);
        // default isFullscreen_ to false
        this.isFullscreen_ = false;
        // create logger
        this.log = $cb03b711053a4297$var$createLogger(this.id_);
        // Hold our own reference to fullscreen api so it can be mocked in tests
        this.fsApi_ = $cb03b711053a4297$var$FullscreenApi;
        // Tracks when a tech changes the poster
        this.isPosterFromTech_ = false;
        // Holds callback info that gets queued when playback rate is zero
        // and a seek is happening
        this.queuedCallbacks_ = [];
        // Turn off API access because we're loading a new tech that might load asynchronously
        this.isReady_ = false;
        // Init state hasStarted_
        this.hasStarted_ = false;
        // Init state userActive_
        this.userActive_ = false;
        // Init debugEnabled_
        this.debugEnabled_ = false;
        // Init state audioOnlyMode_
        this.audioOnlyMode_ = false;
        // Init state audioPosterMode_
        this.audioPosterMode_ = false;
        // Init state audioOnlyCache_
        this.audioOnlyCache_ = {
            controlBarHeight: null,
            playerHeight: null,
            hiddenChildren: []
        };
        // if the global option object was accidentally blown away by
        // someone, bail early with an informative error
        if (!this.options_ || !this.options_.techOrder || !this.options_.techOrder.length) throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
        // Store the original tag used to set options
        this.tag = tag;
        // Store the tag attributes used to restore html5 element
        this.tagAttributes = tag && $cb03b711053a4297$var$getAttributes(tag);
        // Update current language
        this.language(this.options_.language);
        // Update Supported Languages
        if (options.languages) {
            // Normalise player option languages to lowercase
            const languagesToLower = {};
            Object.getOwnPropertyNames(options.languages).forEach(function(name) {
                languagesToLower[name.toLowerCase()] = options.languages[name];
            });
            this.languages_ = languagesToLower;
        } else this.languages_ = $cb03b711053a4297$var$Player.prototype.options_.languages;
        this.resetCache_();
        // Set poster
        /** @type string */ this.poster_ = options.poster || '';
        // Set controls
        /** @type {boolean} */ this.controls_ = !!options.controls;
        // Original tag settings stored in options
        // now remove immediately so native controls don't flash.
        // May be turned back on by HTML5 tech if nativeControlsForTouch is true
        tag.controls = false;
        tag.removeAttribute('controls');
        this.changingSrc_ = false;
        this.playCallbacks_ = [];
        this.playTerminatedQueue_ = [];
        // the attribute overrides the option
        if (tag.hasAttribute('autoplay')) this.autoplay(true);
        else // otherwise use the setter to validate and
        // set the correct value.
        this.autoplay(this.options_.autoplay);
        // check plugins
        if (options.plugins) Object.keys(options.plugins).forEach((name)=>{
            if (typeof this[name] !== 'function') throw new Error(`plugin "${name}" does not exist`);
        });
        /*
     * Store the internal state of scrubbing
     *
     * @private
     * @return {Boolean} True if the user is scrubbing
     */ this.scrubbing_ = false;
        this.el_ = this.createEl();
        // Make this an evented object and use `el_` as its event bus.
        $cb03b711053a4297$var$evented(this, {
            eventBusKey: 'el_'
        });
        // listen to document and player fullscreenchange handlers so we receive those events
        // before a user can receive them so we can update isFullscreen appropriately.
        // make sure that we listen to fullscreenchange events before everything else to make sure that
        // our isFullscreen method is updated properly for internal components as well as external.
        if (this.fsApi_.requestFullscreen) {
            $cb03b711053a4297$var$on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
            this.on(this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
        }
        if (this.fluid_) this.on([
            'playerreset',
            'resize'
        ], this.boundUpdateStyleEl_);
        // We also want to pass the original player options to each component and plugin
        // as well so they don't need to reach back into the player for options later.
        // We also need to do another copy of this.options_ so we don't end up with
        // an infinite loop.
        const playerOptionsCopy = $cb03b711053a4297$var$merge$1(this.options_);
        // Load plugins
        if (options.plugins) Object.keys(options.plugins).forEach((name)=>{
            this[name](options.plugins[name]);
        });
        // Enable debug mode to fire debugon event for all plugins.
        if (options.debug) this.debug(true);
        this.options_.playerOptions = playerOptionsCopy;
        this.middleware_ = [];
        this.playbackRates(options.playbackRates);
        if (options.experimentalSvgIcons) {
            // Add SVG Sprite to the DOM
            const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).DOMParser();
            const parsedSVG = parser.parseFromString($cb03b711053a4297$var$icons, 'image/svg+xml');
            const errorNode = parsedSVG.querySelector('parsererror');
            if (errorNode) {
                $cb03b711053a4297$var$log$1.warn('Failed to load SVG Icons. Falling back to Font Icons.');
                this.options_.experimentalSvgIcons = null;
            } else {
                const sprite = parsedSVG.documentElement;
                sprite.style.display = 'none';
                this.el_.appendChild(sprite);
                this.addClass('vjs-svg-icons-enabled');
            }
        }
        this.initChildren();
        // Set isAudio based on whether or not an audio tag was used
        this.isAudio(tag.nodeName.toLowerCase() === 'audio');
        // Update controls className. Can't do this when the controls are initially
        // set because the element doesn't exist yet.
        if (this.controls()) this.addClass('vjs-controls-enabled');
        else this.addClass('vjs-controls-disabled');
        // Set ARIA label and region role depending on player type
        this.el_.setAttribute('role', 'region');
        if (this.isAudio()) this.el_.setAttribute('aria-label', this.localize('Audio Player'));
        else this.el_.setAttribute('aria-label', this.localize('Video Player'));
        if (this.isAudio()) this.addClass('vjs-audio');
        // Check if spatial navigation is enabled in the options.
        // If enabled, instantiate the SpatialNavigation class.
        if (options.spatialNavigation && options.spatialNavigation.enabled) {
            this.spatialNavigation = new $cb03b711053a4297$var$SpatialNavigation(this);
            this.addClass('vjs-spatial-navigation-enabled');
        }
        // TODO: Make this smarter. Toggle user state between touching/mousing
        // using events, since devices can have both touch and mouse events.
        // TODO: Make this check be performed again when the window switches between monitors
        // (See https://github.com/videojs/video.js/issues/5683)
        if ($cb03b711053a4297$var$TOUCH_ENABLED) this.addClass('vjs-touch-enabled');
        // iOS Safari has broken hover handling
        if (!$cb03b711053a4297$var$IS_IOS) this.addClass('vjs-workinghover');
        // Make player easily findable by ID
        $cb03b711053a4297$var$Player.players[this.id_] = this;
        // Add a major version class to aid css in plugins
        const majorVersion = $cb03b711053a4297$var$version$6.split('.')[0];
        this.addClass(`vjs-v${majorVersion}`);
        // When the player is first initialized, trigger activity so components
        // like the control bar show themselves if needed
        this.userActive(true);
        this.reportUserActivity();
        this.one('play', (e)=>this.listenForUserActivity_(e));
        this.on('keydown', (e)=>this.handleKeyDown(e));
        this.on('languagechange', (e)=>this.handleLanguagechange(e));
        this.breakpoints(this.options_.breakpoints);
        this.responsive(this.options_.responsive);
        // Calling both the audio mode methods after the player is fully
        // setup to be able to listen to the events triggered by them
        this.on('ready', ()=>{
            // Calling the audioPosterMode method first so that
            // the audioOnlyMode can take precedence when both options are set to true
            this.audioPosterMode(this.options_.audioPosterMode);
            this.audioOnlyMode(this.options_.audioOnlyMode);
        });
    }
    /**
   * Destroys the video player and does any necessary cleanup.
   *
   * This is especially helpful if you are dynamically adding and removing videos
   * to/from the DOM.
   *
   * @fires Player#dispose
   */ dispose() {
        /**
     * Called when the player is being disposed of.
     *
     * @event Player#dispose
     * @type {Event}
     */ this.trigger('dispose');
        // prevent dispose from being called twice
        this.off('dispose');
        // Make sure all player-specific document listeners are unbound. This is
        $cb03b711053a4297$var$off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
        $cb03b711053a4297$var$off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), 'keydown', this.boundFullWindowOnEscKey_);
        if (this.styleEl_ && this.styleEl_.parentNode) {
            this.styleEl_.parentNode.removeChild(this.styleEl_);
            this.styleEl_ = null;
        }
        // Kill reference to this player
        $cb03b711053a4297$var$Player.players[this.id_] = null;
        if (this.tag && this.tag.player) this.tag.player = null;
        if (this.el_ && this.el_.player) this.el_.player = null;
        if (this.tech_) {
            this.tech_.dispose();
            this.isPosterFromTech_ = false;
            this.poster_ = '';
        }
        if (this.playerElIngest_) this.playerElIngest_ = null;
        if (this.tag) this.tag = null;
        $cb03b711053a4297$var$clearCacheForPlayer(this);
        // remove all event handlers for track lists
        // all tracks and track listeners are removed on
        // tech dispose
        $cb03b711053a4297$var$ALL.names.forEach((name)=>{
            const props = $cb03b711053a4297$var$ALL[name];
            const list = this[props.getterName]();
            // if it is not a native list
            // we have to manually remove event listeners
            if (list && list.off) list.off();
        });
        // the actual .el_ is removed here, or replaced if
        super.dispose({
            restoreEl: this.options_.restoreEl
        });
    }
    /**
   * Create the `Player`'s DOM element.
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        let tag = this.tag;
        let el;
        let playerElIngest = this.playerElIngest_ = tag.parentNode && tag.parentNode.hasAttribute && tag.parentNode.hasAttribute('data-vjs-player');
        const divEmbed = this.tag.tagName.toLowerCase() === 'video-js';
        if (playerElIngest) el = this.el_ = tag.parentNode;
        else if (!divEmbed) el = this.el_ = super.createEl('div');
        // Copy over all the attributes from the tag, including ID and class
        // ID will now reference player box, not the video tag
        const attrs = $cb03b711053a4297$var$getAttributes(tag);
        if (divEmbed) {
            el = this.el_ = tag;
            tag = this.tag = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('video');
            while(el.children.length)tag.appendChild(el.firstChild);
            if (!$cb03b711053a4297$var$hasClass(el, 'video-js')) $cb03b711053a4297$var$addClass(el, 'video-js');
            el.appendChild(tag);
            playerElIngest = this.playerElIngest_ = el;
            // move properties over from our custom `video-js` element
            // to our new `video` element. This will move things like
            // `src` or `controls` that were set via js before the player
            // was initialized.
            Object.keys(el).forEach((k)=>{
                try {
                    tag[k] = el[k];
                } catch (e) {
                // we got a a property like outerHTML which we can't actually copy, ignore it
                }
            });
        }
        // set tabindex to -1 to remove the video element from the focus order
        tag.setAttribute('tabindex', '-1');
        attrs.tabindex = '-1';
        // Workaround for #4583 on Chrome (on Windows) with JAWS.
        // See https://github.com/FreedomScientific/VFO-standards-support/issues/78
        // Note that we can't detect if JAWS is being used, but this ARIA attribute
        // doesn't change behavior of Chrome if JAWS is not being used
        if ($cb03b711053a4297$var$IS_CHROME && $cb03b711053a4297$var$IS_WINDOWS) {
            tag.setAttribute('role', 'application');
            attrs.role = 'application';
        }
        // Remove width/height attrs from tag so CSS can make it 100% width/height
        tag.removeAttribute('width');
        tag.removeAttribute('height');
        if ('width' in attrs) delete attrs.width;
        if ('height' in attrs) delete attrs.height;
        Object.getOwnPropertyNames(attrs).forEach(function(attr) {
            // don't copy over the class attribute to the player element when we're in a div embed
            // the class is already set up properly in the divEmbed case
            // and we want to make sure that the `video-js` class doesn't get lost
            if (!(divEmbed && attr === 'class')) el.setAttribute(attr, attrs[attr]);
            if (divEmbed) tag.setAttribute(attr, attrs[attr]);
        });
        // Update tag id/class for use as HTML5 playback tech
        // Might think we should do this after embedding in container so .vjs-tech class
        // doesn't flash 100% width/height, but class only applies with .video-js parent
        tag.playerId = tag.id;
        tag.id += '_html5_api';
        tag.className = 'vjs-tech';
        // Make player findable on elements
        tag.player = el.player = this;
        // Default state of video is paused
        this.addClass('vjs-paused');
        const deviceClassNames = [
            'IS_SMART_TV',
            'IS_TIZEN',
            'IS_WEBOS',
            'IS_ANDROID',
            'IS_IPAD',
            'IS_IPHONE',
            'IS_CHROMECAST_RECEIVER'
        ].filter((key)=>$cb03b711053a4297$var$browser[key]).map((key)=>{
            return 'vjs-device-' + key.substring(3).toLowerCase().replace(/\_/g, '-');
        });
        this.addClass(...deviceClassNames);
        // Add a style element in the player that we'll use to set the width/height
        // of the player in a way that's still overridable by CSS, just like the
        // video element
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VIDEOJS_NO_DYNAMIC_STYLE !== true) {
            this.styleEl_ = $cb03b711053a4297$var$createStyleElement('vjs-styles-dimensions');
            const defaultsStyleEl = $cb03b711053a4297$var$$('.vjs-styles-defaults');
            const head = $cb03b711053a4297$var$$('head');
            head.insertBefore(this.styleEl_, defaultsStyleEl ? defaultsStyleEl.nextSibling : head.firstChild);
        }
        this.fill_ = false;
        this.fluid_ = false;
        // Pass in the width/height/aspectRatio options which will update the style el
        this.width(this.options_.width);
        this.height(this.options_.height);
        this.fill(this.options_.fill);
        this.fluid(this.options_.fluid);
        this.aspectRatio(this.options_.aspectRatio);
        // support both crossOrigin and crossorigin to reduce confusion and issues around the name
        this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
        // Hide any links within the video/audio tag,
        // because IE doesn't hide them completely from screen readers.
        const links = tag.getElementsByTagName('a');
        for(let i = 0; i < links.length; i++){
            const linkEl = links.item(i);
            $cb03b711053a4297$var$addClass(linkEl, 'vjs-hidden');
            linkEl.setAttribute('hidden', 'hidden');
        }
        // insertElFirst seems to cause the networkState to flicker from 3 to 2, so
        // keep track of the original for later so we can know if the source originally failed
        tag.initNetworkState_ = tag.networkState;
        // Wrap video tag in div (el/box) container
        if (tag.parentNode && !playerElIngest) tag.parentNode.insertBefore(el, tag);
        // insert the tag as the first child of the player element
        // then manually add it to the children array so that this.addChild
        // will work properly for other components
        //
        // Breaks iPhone, fixed in HTML5 setup.
        $cb03b711053a4297$var$prependTo(tag, el);
        this.children_.unshift(tag);
        // Set lang attr on player to ensure CSS :lang() in consistent with player
        // if it's been set to something different to the doc
        this.el_.setAttribute('lang', this.language_);
        this.el_.setAttribute('translate', 'no');
        this.el_ = el;
        return el;
    }
    /**
   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
   * behavior.
   *
   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
   *
   * @param {string|null} [value]
   *        The value to set the `Player`'s crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null|undefined}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */ crossOrigin(value) {
        // `null` can be set to unset a value
        if (typeof value === 'undefined') return this.techGet_('crossOrigin');
        if (value !== null && value !== 'anonymous' && value !== 'use-credentials') {
            $cb03b711053a4297$var$log$1.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${value}"`);
            return;
        }
        this.techCall_('setCrossOrigin', value);
        if (this.posterImage) this.posterImage.crossOrigin(value);
        return;
    }
    /**
   * A getter/setter for the `Player`'s width. Returns the player's configured value.
   * To get the current width use `currentWidth()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s width to.
   *
   * @return {number|undefined}
   *         - The current width of the `Player` when getting.
   *         - Nothing when setting
   */ width(value) {
        return this.dimension('width', value);
    }
    /**
   * A getter/setter for the `Player`'s height. Returns the player's configured value.
   * To get the current height use `currentheight()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s height to.
   *
   * @return {number|undefined}
   *         - The current height of the `Player` when getting.
   *         - Nothing when setting
   */ height(value) {
        return this.dimension('height', value);
    }
    /**
   * A getter/setter for the `Player`'s width & height.
   *
   * @param {string} dimension
   *        This string can be:
   *        - 'width'
   *        - 'height'
   *
   * @param {number|string} [value]
   *        Value for dimension specified in the first argument.
   *
   * @return {number}
   *         The dimension arguments value when getting (width/height).
   */ dimension(dimension, value) {
        const privDimension = dimension + '_';
        if (value === undefined) return this[privDimension] || 0;
        if (value === '' || value === 'auto') {
            // If an empty string is given, reset the dimension to be automatic
            this[privDimension] = undefined;
            this.updateStyleEl_();
            return;
        }
        const parsedVal = parseFloat(value);
        if (isNaN(parsedVal)) {
            $cb03b711053a4297$var$log$1.error(`Improper value "${value}" supplied for for ${dimension}`);
            return;
        }
        this[privDimension] = parsedVal;
        this.updateStyleEl_();
    }
    /**
   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
   *
   * Turning this on will turn off fill mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */ fluid(bool) {
        if (bool === undefined) return !!this.fluid_;
        this.fluid_ = !!bool;
        if ($cb03b711053a4297$var$isEvented(this)) this.off([
            'playerreset',
            'resize'
        ], this.boundUpdateStyleEl_);
        if (bool) {
            this.addClass('vjs-fluid');
            this.fill(false);
            $cb03b711053a4297$var$addEventedCallback(this, ()=>{
                this.on([
                    'playerreset',
                    'resize'
                ], this.boundUpdateStyleEl_);
            });
        } else this.removeClass('vjs-fluid');
        this.updateStyleEl_();
    }
    /**
   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
   *
   * Turning this on will turn off fluid mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */ fill(bool) {
        if (bool === undefined) return !!this.fill_;
        this.fill_ = !!bool;
        if (bool) {
            this.addClass('vjs-fill');
            this.fluid(false);
        } else this.removeClass('vjs-fill');
    }
    /**
   * Get/Set the aspect ratio
   *
   * @param {string} [ratio]
   *        Aspect ratio for player
   *
   * @return {string|undefined}
   *         returns the current aspect ratio when getting
   */ /**
   * A getter/setter for the `Player`'s aspect ratio.
   *
   * @param {string} [ratio]
   *        The value to set the `Player`'s aspect ratio to.
   *
   * @return {string|undefined}
   *         - The current aspect ratio of the `Player` when getting.
   *         - undefined when setting
   */ aspectRatio(ratio) {
        if (ratio === undefined) return this.aspectRatio_;
        // Check for width:height format
        if (!/^\d+\:\d+$/.test(ratio)) throw new Error('Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.');
        this.aspectRatio_ = ratio;
        // We're assuming if you set an aspect ratio you want fluid mode,
        // because in fixed mode you could calculate width and height yourself.
        this.fluid(true);
        this.updateStyleEl_();
    }
    /**
   * Update styles of the `Player` element (height, width and aspect ratio).
   *
   * @private
   * @listens Tech#loadedmetadata
   */ updateStyleEl_() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VIDEOJS_NO_DYNAMIC_STYLE === true) {
            const width = typeof this.width_ === 'number' ? this.width_ : this.options_.width;
            const height = typeof this.height_ === 'number' ? this.height_ : this.options_.height;
            const techEl = this.tech_ && this.tech_.el();
            if (techEl) {
                if (width >= 0) techEl.width = width;
                if (height >= 0) techEl.height = height;
            }
            return;
        }
        let width;
        let height;
        let aspectRatio;
        let idClass;
        // The aspect ratio is either used directly or to calculate width and height.
        if (this.aspectRatio_ !== undefined && this.aspectRatio_ !== 'auto') // Use any aspectRatio that's been specifically set
        aspectRatio = this.aspectRatio_;
        else if (this.videoWidth() > 0) // Otherwise try to get the aspect ratio from the video metadata
        aspectRatio = this.videoWidth() + ':' + this.videoHeight();
        else // Or use a default. The video element's is 2:1, but 16:9 is more common.
        aspectRatio = '16:9';
        // Get the ratio as a decimal we can use to calculate dimensions
        const ratioParts = aspectRatio.split(':');
        const ratioMultiplier = ratioParts[1] / ratioParts[0];
        if (this.width_ !== undefined) // Use any width that's been specifically set
        width = this.width_;
        else if (this.height_ !== undefined) // Or calculate the width from the aspect ratio if a height has been set
        width = this.height_ / ratioMultiplier;
        else // Or use the video's metadata, or use the video el's default of 300
        width = this.videoWidth() || 300;
        if (this.height_ !== undefined) // Use any height that's been specifically set
        height = this.height_;
        else // Otherwise calculate the height from the ratio and the width
        height = width * ratioMultiplier;
        // Ensure the CSS class is valid by starting with an alpha character
        if (/^[^a-zA-Z]/.test(this.id())) idClass = 'dimensions-' + this.id();
        else idClass = this.id() + '-dimensions';
        // Ensure the right class is still on the player for the style element
        this.addClass(idClass);
        $cb03b711053a4297$var$setTextContent(this.styleEl_, `
      .${idClass} {
        width: ${width}px;
        height: ${height}px;
      }

      .${idClass}.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ${ratioMultiplier * 100}%;
      }
    `);
    }
    /**
   * Load/Create an instance of playback {@link Tech} including element
   * and API methods. Then append the `Tech` element in `Player` as a child.
   *
   * @param {string} techName
   *        name of the playback technology
   *
   * @param {string} source
   *        video source
   *
   * @private
   */ loadTech_(techName, source) {
        // Pause and remove current playback technology
        if (this.tech_) this.unloadTech_();
        const titleTechName = $cb03b711053a4297$var$toTitleCase$1(techName);
        const camelTechName = techName.charAt(0).toLowerCase() + techName.slice(1);
        // get rid of the HTML5 video tag as soon as we are using another tech
        if (titleTechName !== 'Html5' && this.tag) {
            $cb03b711053a4297$var$Tech.getTech('Html5').disposeMediaElement(this.tag);
            this.tag.player = null;
            this.tag = null;
        }
        this.techName_ = titleTechName;
        // Turn off API access because we're loading a new tech that might load asynchronously
        this.isReady_ = false;
        let autoplay = this.autoplay();
        // if autoplay is a string (or `true` with normalizeAutoplay: true) we pass false to the tech
        // because the player is going to handle autoplay on `loadstart`
        if (typeof this.autoplay() === 'string' || this.autoplay() === true && this.options_.normalizeAutoplay) autoplay = false;
        // Grab tech-specific options from player options and add source and parent element to use.
        const techOptions = {
            source: source,
            autoplay: autoplay,
            'nativeControlsForTouch': this.options_.nativeControlsForTouch,
            'playerId': this.id(),
            'techId': `${this.id()}_${camelTechName}_api`,
            'playsinline': this.options_.playsinline,
            'preload': this.options_.preload,
            'loop': this.options_.loop,
            'disablePictureInPicture': this.options_.disablePictureInPicture,
            'muted': this.options_.muted,
            'poster': this.poster(),
            'language': this.language(),
            'playerElIngest': this.playerElIngest_ || false,
            'vtt.js': this.options_['vtt.js'],
            'canOverridePoster': !!this.options_.techCanOverridePoster,
            'enableSourceset': this.options_.enableSourceset
        };
        $cb03b711053a4297$var$ALL.names.forEach((name)=>{
            const props = $cb03b711053a4297$var$ALL[name];
            techOptions[props.getterName] = this[props.privateName];
        });
        Object.assign(techOptions, this.options_[titleTechName]);
        Object.assign(techOptions, this.options_[camelTechName]);
        Object.assign(techOptions, this.options_[techName.toLowerCase()]);
        if (this.tag) techOptions.tag = this.tag;
        if (source && source.src === this.cache_.src && this.cache_.currentTime > 0) techOptions.startTime = this.cache_.currentTime;
        // Initialize tech instance
        const TechClass = $cb03b711053a4297$var$Tech.getTech(techName);
        if (!TechClass) throw new Error(`No Tech named '${titleTechName}' exists! '${titleTechName}' should be registered using videojs.registerTech()'`);
        this.tech_ = new TechClass(techOptions);
        // player.triggerReady is always async, so don't need this to be async
        this.tech_.ready($cb03b711053a4297$var$bind_(this, this.handleTechReady_), true);
        $cb03b711053a4297$var$textTrackConverter.jsonToTextTracks(this.textTracksJson_ || [], this.tech_);
        // Listen to all HTML5-defined events and trigger them on the player
        $cb03b711053a4297$var$TECH_EVENTS_RETRIGGER.forEach((event)=>{
            this.on(this.tech_, event, (e)=>this[`handleTech${$cb03b711053a4297$var$toTitleCase$1(event)}_`](e));
        });
        Object.keys($cb03b711053a4297$var$TECH_EVENTS_QUEUE).forEach((event)=>{
            this.on(this.tech_, event, (eventObj)=>{
                if (this.tech_.playbackRate() === 0 && this.tech_.seeking()) {
                    this.queuedCallbacks_.push({
                        callback: this[`handleTech${$cb03b711053a4297$var$TECH_EVENTS_QUEUE[event]}_`].bind(this),
                        event: eventObj
                    });
                    return;
                }
                this[`handleTech${$cb03b711053a4297$var$TECH_EVENTS_QUEUE[event]}_`](eventObj);
            });
        });
        this.on(this.tech_, 'loadstart', (e)=>this.handleTechLoadStart_(e));
        this.on(this.tech_, 'sourceset', (e)=>this.handleTechSourceset_(e));
        this.on(this.tech_, 'waiting', (e)=>this.handleTechWaiting_(e));
        this.on(this.tech_, 'ended', (e)=>this.handleTechEnded_(e));
        this.on(this.tech_, 'seeking', (e)=>this.handleTechSeeking_(e));
        this.on(this.tech_, 'play', (e)=>this.handleTechPlay_(e));
        this.on(this.tech_, 'pause', (e)=>this.handleTechPause_(e));
        this.on(this.tech_, 'durationchange', (e)=>this.handleTechDurationChange_(e));
        this.on(this.tech_, 'fullscreenchange', (e, data)=>this.handleTechFullscreenChange_(e, data));
        this.on(this.tech_, 'fullscreenerror', (e, err)=>this.handleTechFullscreenError_(e, err));
        this.on(this.tech_, 'enterpictureinpicture', (e)=>this.handleTechEnterPictureInPicture_(e));
        this.on(this.tech_, 'leavepictureinpicture', (e)=>this.handleTechLeavePictureInPicture_(e));
        this.on(this.tech_, 'error', (e)=>this.handleTechError_(e));
        this.on(this.tech_, 'posterchange', (e)=>this.handleTechPosterChange_(e));
        this.on(this.tech_, 'textdata', (e)=>this.handleTechTextData_(e));
        this.on(this.tech_, 'ratechange', (e)=>this.handleTechRateChange_(e));
        this.on(this.tech_, 'loadedmetadata', this.boundUpdateStyleEl_);
        this.usingNativeControls(this.techGet_('controls'));
        if (this.controls() && !this.usingNativeControls()) this.addTechControlsListeners_();
        // Add the tech element in the DOM if it was not already there
        // Make sure to not insert the original video element if using Html5
        if (this.tech_.el().parentNode !== this.el() && (titleTechName !== 'Html5' || !this.tag)) $cb03b711053a4297$var$prependTo(this.tech_.el(), this.el());
        // Get rid of the original video tag reference after the first tech is loaded
        if (this.tag) {
            this.tag.player = null;
            this.tag = null;
        }
    }
    /**
   * Unload and dispose of the current playback {@link Tech}.
   *
   * @private
   */ unloadTech_() {
        // Save the current text tracks so that we can reuse the same text tracks with the next tech
        $cb03b711053a4297$var$ALL.names.forEach((name)=>{
            const props = $cb03b711053a4297$var$ALL[name];
            this[props.privateName] = this[props.getterName]();
        });
        this.textTracksJson_ = $cb03b711053a4297$var$textTrackConverter.textTracksToJson(this.tech_);
        this.isReady_ = false;
        this.tech_.dispose();
        this.tech_ = false;
        if (this.isPosterFromTech_) {
            this.poster_ = '';
            this.trigger('posterchange');
        }
        this.isPosterFromTech_ = false;
    }
    /**
   * Return a reference to the current {@link Tech}.
   * It will print a warning by default about the danger of using the tech directly
   * but any argument that is passed in will silence the warning.
   *
   * @param {*} [safety]
   *        Anything passed in to silence the warning
   *
   * @return {Tech}
   *         The Tech
   */ tech(safety) {
        if (safety === undefined) $cb03b711053a4297$var$log$1.warn("Using the tech directly can be dangerous. I hope you know what you're doing.\nSee https://github.com/videojs/video.js/issues/2617 for more info.\n");
        return this.tech_;
    }
    /**
   * An object that contains Video.js version.
   *
   * @typedef {Object} PlayerVersion
   *
   * @property {string} 'video.js' - Video.js version
   */ /**
   * Returns an object with Video.js version.
   *
   * @return {PlayerVersion}
   *          An object with Video.js version.
   */ version() {
        return {
            'video.js': $cb03b711053a4297$var$version$6
        };
    }
    /**
   * Set up click and touch listeners for the playback element
   *
   * - On desktops: a click on the video itself will toggle playback
   * - On mobile devices: a click on the video toggles controls
   *   which is done by toggling the user state between active and
   *   inactive
   * - A tap can signal that a user has become active or has become inactive
   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
   *   quick tap should hide them again (signaling the user is in an inactive
   *   viewing state)
   * - In addition to this, we still want the user to be considered inactive after
   *   a few seconds of inactivity.
   *
   * > Note: the only part of iOS interaction we can't mimic with this setup
   * is a touch and hold on the video element counting as activity in order to
   * keep the controls showing, but that shouldn't be an issue. A touch and hold
   * on any controls will still keep the user active
   *
   * @private
   */ addTechControlsListeners_() {
        // Make sure to remove all the previous listeners in case we are called multiple times.
        this.removeTechControlsListeners_();
        this.on(this.tech_, 'click', this.boundHandleTechClick_);
        this.on(this.tech_, 'dblclick', this.boundHandleTechDoubleClick_);
        // If the controls were hidden we don't want that to change without a tap event
        // so we'll check if the controls were already showing before reporting user
        // activity
        this.on(this.tech_, 'touchstart', this.boundHandleTechTouchStart_);
        this.on(this.tech_, 'touchmove', this.boundHandleTechTouchMove_);
        this.on(this.tech_, 'touchend', this.boundHandleTechTouchEnd_);
        // The tap listener needs to come after the touchend listener because the tap
        // listener cancels out any reportedUserActivity when setting userActive(false)
        this.on(this.tech_, 'tap', this.boundHandleTechTap_);
    }
    /**
   * Remove the listeners used for click and tap controls. This is needed for
   * toggling to controls disabled, where a tap/touch should do nothing.
   *
   * @private
   */ removeTechControlsListeners_() {
        // We don't want to just use `this.off()` because there might be other needed
        // listeners added by techs that extend this.
        this.off(this.tech_, 'tap', this.boundHandleTechTap_);
        this.off(this.tech_, 'touchstart', this.boundHandleTechTouchStart_);
        this.off(this.tech_, 'touchmove', this.boundHandleTechTouchMove_);
        this.off(this.tech_, 'touchend', this.boundHandleTechTouchEnd_);
        this.off(this.tech_, 'click', this.boundHandleTechClick_);
        this.off(this.tech_, 'dblclick', this.boundHandleTechDoubleClick_);
    }
    /**
   * Player waits for the tech to be ready
   *
   * @private
   */ handleTechReady_() {
        this.triggerReady();
        // Keep the same volume as before
        if (this.cache_.volume) this.techCall_('setVolume', this.cache_.volume);
        // Look if the tech found a higher resolution poster while loading
        this.handleTechPosterChange_();
        // Update the duration if available
        this.handleTechDurationChange_();
    }
    /**
   * Retrigger the `loadstart` event that was triggered by the {@link Tech}.
   *
   * @fires Player#loadstart
   * @listens Tech#loadstart
   * @private
   */ handleTechLoadStart_() {
        // TODO: Update to use `emptied` event instead. See #1277.
        this.removeClass('vjs-ended', 'vjs-seeking');
        // reset the error state
        this.error(null);
        // Update the duration
        this.handleTechDurationChange_();
        if (!this.paused()) /**
       * Fired when the user agent begins looking for media data
       *
       * @event Player#loadstart
       * @type {Event}
       */ this.trigger('loadstart');
        else {
            // reset the hasStarted state
            this.hasStarted(false);
            this.trigger('loadstart');
        }
        // autoplay happens after loadstart for the browser,
        // so we mimic that behavior
        this.manualAutoplay_(this.autoplay() === true && this.options_.normalizeAutoplay ? 'play' : this.autoplay());
    }
    /**
   * Handle autoplay string values, rather than the typical boolean
   * values that should be handled by the tech. Note that this is not
   * part of any specification. Valid values and what they do can be
   * found on the autoplay getter at Player#autoplay()
   */ manualAutoplay_(type) {
        if (!this.tech_ || typeof type !== 'string') return;
        // Save original muted() value, set muted to true, and attempt to play().
        // On promise rejection, restore muted from saved value
        const resolveMuted = ()=>{
            const previouslyMuted = this.muted();
            this.muted(true);
            const restoreMuted = ()=>{
                this.muted(previouslyMuted);
            };
            // restore muted on play terminatation
            this.playTerminatedQueue_.push(restoreMuted);
            const mutedPromise = this.play();
            if (!$cb03b711053a4297$var$isPromise(mutedPromise)) return;
            return mutedPromise.catch((err)=>{
                restoreMuted();
                throw new Error(`Rejection at manualAutoplay. Restoring muted value. ${err ? err : ''}`);
            });
        };
        let promise;
        // if muted defaults to true
        // the only thing we can do is call play
        if (type === 'any' && !this.muted()) {
            promise = this.play();
            if ($cb03b711053a4297$var$isPromise(promise)) promise = promise.catch(resolveMuted);
        } else if (type === 'muted' && !this.muted()) promise = resolveMuted();
        else promise = this.play();
        if (!$cb03b711053a4297$var$isPromise(promise)) return;
        return promise.then(()=>{
            this.trigger({
                type: 'autoplay-success',
                autoplay: type
            });
        }).catch(()=>{
            this.trigger({
                type: 'autoplay-failure',
                autoplay: type
            });
        });
    }
    /**
   * Update the internal source caches so that we return the correct source from
   * `src()`, `currentSource()`, and `currentSources()`.
   *
   * > Note: `currentSources` will not be updated if the source that is passed in exists
   *         in the current `currentSources` cache.
   *
   *
   * @param {Tech~SourceObject} srcObj
   *        A string or object source to update our caches to.
   */ updateSourceCaches_(srcObj = '') {
        let src = srcObj;
        let type = '';
        if (typeof src !== 'string') {
            src = srcObj.src;
            type = srcObj.type;
        }
        // make sure all the caches are set to default values
        // to prevent null checking
        this.cache_.source = this.cache_.source || {};
        this.cache_.sources = this.cache_.sources || [];
        // try to get the type of the src that was passed in
        if (src && !type) type = $cb03b711053a4297$var$findMimetype(this, src);
        // update `currentSource` cache always
        this.cache_.source = $cb03b711053a4297$var$merge$1({}, srcObj, {
            src: src,
            type: type
        });
        const matchingSources = this.cache_.sources.filter((s)=>s.src && s.src === src);
        const sourceElSources = [];
        const sourceEls = this.$$('source');
        const matchingSourceEls = [];
        for(let i = 0; i < sourceEls.length; i++){
            const sourceObj = $cb03b711053a4297$var$getAttributes(sourceEls[i]);
            sourceElSources.push(sourceObj);
            if (sourceObj.src && sourceObj.src === src) matchingSourceEls.push(sourceObj.src);
        }
        // if we have matching source els but not matching sources
        // the current source cache is not up to date
        if (matchingSourceEls.length && !matchingSources.length) this.cache_.sources = sourceElSources;
        else if (!matchingSources.length) this.cache_.sources = [
            this.cache_.source
        ];
        // update the tech `src` cache
        this.cache_.src = src;
    }
    /**
   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
   * causing the media element to reload.
   *
   * It will fire for the initial source and each subsequent source.
   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
   *
   * The event object for this event contains a `src` property that will contain the source
   * that was available when the event was triggered. This is generally only necessary if Video.js
   * is switching techs while the source was being changed.
   *
   * It is also fired when `load` is called on the player (or media element)
   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
   * says that the resource selection algorithm needs to be aborted and restarted.
   * In this case, it is very likely that the `src` property will be set to the
   * empty string `""` to indicate we do not know what the source will be but
   * that it is changing.
   *
   * *This event is currently still experimental and may change in minor releases.*
   * __To use this, pass `enableSourceset` option to the player.__
   *
   * @event Player#sourceset
   * @type {Event}
   * @prop {string} src
   *                The source url available when the `sourceset` was triggered.
   *                It will be an empty string if we cannot know what the source is
   *                but know that the source will change.
   */ /**
   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
   *
   * @fires Player#sourceset
   * @listens Tech#sourceset
   * @private
   */ handleTechSourceset_(event) {
        // only update the source cache when the source
        // was not updated using the player api
        if (!this.changingSrc_) {
            let updateSourceCaches = (src)=>this.updateSourceCaches_(src);
            const playerSrc = this.currentSource().src;
            const eventSrc = event.src;
            // if we have a playerSrc that is not a blob, and a tech src that is a blob
            if (playerSrc && !/^blob:/.test(playerSrc) && /^blob:/.test(eventSrc)) // if both the tech source and the player source were updated we assume
            // something like @videojs/http-streaming did the sourceset and skip updating the source cache.
            {
                if (!this.lastSource_ || this.lastSource_.tech !== eventSrc && this.lastSource_.player !== playerSrc) updateSourceCaches = ()=>{};
            }
            // update the source to the initial source right away
            // in some cases this will be empty string
            updateSourceCaches(eventSrc);
            // if the `sourceset` `src` was an empty string
            // wait for a `loadstart` to update the cache to `currentSrc`.
            // If a sourceset happens before a `loadstart`, we reset the state
            if (!event.src) this.tech_.any([
                'sourceset',
                'loadstart'
            ], (e)=>{
                // if a sourceset happens before a `loadstart` there
                // is nothing to do as this `handleTechSourceset_`
                // will be called again and this will be handled there.
                if (e.type === 'sourceset') return;
                const techSrc = this.techGet_('currentSrc');
                this.lastSource_.tech = techSrc;
                this.updateSourceCaches_(techSrc);
            });
        }
        this.lastSource_ = {
            player: this.currentSource().src,
            tech: event.src
        };
        this.trigger({
            src: event.src,
            type: 'sourceset'
        });
    }
    /**
   * Add/remove the vjs-has-started class
   *
   *
   * @param {boolean} request
   *        - true: adds the class
   *        - false: remove the class
   *
   * @return {boolean}
   *         the boolean value of hasStarted_
   */ hasStarted(request) {
        if (request === undefined) // act as getter, if we have no request to change
        return this.hasStarted_;
        if (request === this.hasStarted_) return;
        this.hasStarted_ = request;
        if (this.hasStarted_) this.addClass('vjs-has-started');
        else this.removeClass('vjs-has-started');
    }
    /**
   * Fired whenever the media begins or resumes playback
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
   * @fires Player#play
   * @listens Tech#play
   * @private
   */ handleTechPlay_() {
        this.removeClass('vjs-ended', 'vjs-paused');
        this.addClass('vjs-playing');
        // hide the poster when the user hits play
        this.hasStarted(true);
        /**
     * Triggered whenever an {@link Tech#play} event happens. Indicates that
     * playback has started or resumed.
     *
     * @event Player#play
     * @type {Event}
     */ this.trigger('play');
    }
    /**
   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
   *
   * If there were any events queued while the playback rate was zero, fire
   * those events now.
   *
   * @private
   * @method Player#handleTechRateChange_
   * @fires Player#ratechange
   * @listens Tech#ratechange
   */ handleTechRateChange_() {
        if (this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0) {
            this.queuedCallbacks_.forEach((queued)=>queued.callback(queued.event));
            this.queuedCallbacks_ = [];
        }
        this.cache_.lastPlaybackRate = this.tech_.playbackRate();
        /**
     * Fires when the playing speed of the audio/video is changed
     *
     * @event Player#ratechange
     * @type {event}
     */ this.trigger('ratechange');
    }
    /**
   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
   *
   * @fires Player#waiting
   * @listens Tech#waiting
   * @private
   */ handleTechWaiting_() {
        this.addClass('vjs-waiting');
        /**
     * A readyState change on the DOM element has caused playback to stop.
     *
     * @event Player#waiting
     * @type {Event}
     */ this.trigger('waiting');
        // Browsers may emit a timeupdate event after a waiting event. In order to prevent
        // premature removal of the waiting class, wait for the time to change.
        const timeWhenWaiting = this.currentTime();
        const timeUpdateListener = ()=>{
            if (timeWhenWaiting !== this.currentTime()) {
                this.removeClass('vjs-waiting');
                this.off('timeupdate', timeUpdateListener);
            }
        };
        this.on('timeupdate', timeUpdateListener);
    }
    /**
   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
   * > Note: This is not consistent between browsers. See #1351
   *
   * @fires Player#canplay
   * @listens Tech#canplay
   * @private
   */ handleTechCanPlay_() {
        this.removeClass('vjs-waiting');
        /**
     * The media has a readyState of HAVE_FUTURE_DATA or greater.
     *
     * @event Player#canplay
     * @type {Event}
     */ this.trigger('canplay');
    }
    /**
   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
   *
   * @fires Player#canplaythrough
   * @listens Tech#canplaythrough
   * @private
   */ handleTechCanPlayThrough_() {
        this.removeClass('vjs-waiting');
        /**
     * The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
     * entire media file can be played without buffering.
     *
     * @event Player#canplaythrough
     * @type {Event}
     */ this.trigger('canplaythrough');
    }
    /**
   * Retrigger the `playing` event that was triggered by the {@link Tech}.
   *
   * @fires Player#playing
   * @listens Tech#playing
   * @private
   */ handleTechPlaying_() {
        this.removeClass('vjs-waiting');
        /**
     * The media is no longer blocked from playback, and has started playing.
     *
     * @event Player#playing
     * @type {Event}
     */ this.trigger('playing');
    }
    /**
   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeking
   * @listens Tech#seeking
   * @private
   */ handleTechSeeking_() {
        this.addClass('vjs-seeking');
        /**
     * Fired whenever the player is jumping to a new time
     *
     * @event Player#seeking
     * @type {Event}
     */ this.trigger('seeking');
    }
    /**
   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeked
   * @listens Tech#seeked
   * @private
   */ handleTechSeeked_() {
        this.removeClass('vjs-seeking', 'vjs-ended');
        /**
     * Fired when the player has finished jumping to a new time
     *
     * @event Player#seeked
     * @type {Event}
     */ this.trigger('seeked');
    }
    /**
   * Retrigger the `pause` event that was triggered by the {@link Tech}.
   *
   * @fires Player#pause
   * @listens Tech#pause
   * @private
   */ handleTechPause_() {
        this.removeClass('vjs-playing');
        this.addClass('vjs-paused');
        /**
     * Fired whenever the media has been paused
     *
     * @event Player#pause
     * @type {Event}
     */ this.trigger('pause');
    }
    /**
   * Retrigger the `ended` event that was triggered by the {@link Tech}.
   *
   * @fires Player#ended
   * @listens Tech#ended
   * @private
   */ handleTechEnded_() {
        this.addClass('vjs-ended');
        this.removeClass('vjs-waiting');
        if (this.options_.loop) {
            this.currentTime(0);
            this.play();
        } else if (!this.paused()) this.pause();
        /**
     * Fired when the end of the media resource is reached (currentTime == duration)
     *
     * @event Player#ended
     * @type {Event}
     */ this.trigger('ended');
    }
    /**
   * Fired when the duration of the media resource is first known or changed
   *
   * @listens Tech#durationchange
   * @private
   */ handleTechDurationChange_() {
        this.duration(this.techGet_('duration'));
    }
    /**
   * Handle a click on the media element to play/pause
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#click
   * @private
   */ handleTechClick_(event) {
        // When controls are disabled a click should not toggle playback because
        // the click is considered a control
        if (!this.controls_) return;
        if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.click === undefined || this.options_.userActions.click !== false) {
            if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.click === 'function') this.options_.userActions.click.call(this, event);
            else if (this.paused()) $cb03b711053a4297$var$silencePromise(this.play());
            else this.pause();
        }
    }
    /**
   * Handle a double-click on the media element to enter/exit fullscreen,
   * or exit documentPictureInPicture mode
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#dblclick
   * @private
   */ handleTechDoubleClick_(event) {
        if (!this.controls_) return;
        // we do not want to toggle fullscreen state
        // when double-clicking inside a control bar or a modal
        const inAllowedEls = Array.prototype.some.call(this.$$('.vjs-control-bar, .vjs-modal-dialog'), (el)=>el.contains(event.target));
        if (!inAllowedEls) /*
       * options.userActions.doubleClick
       *
       * If `undefined` or `true`, double-click toggles fullscreen if controls are present
       * Set to `false` to disable double-click handling
       * Set to a function to substitute an external double-click handler
       */ {
            if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.doubleClick === undefined || this.options_.userActions.doubleClick !== false) {
                if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.doubleClick === 'function') this.options_.userActions.doubleClick.call(this, event);
                else if (this.isInPictureInPicture() && !(0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).pictureInPictureElement) // Checking the presence of `window.documentPictureInPicture.window` complicates
                // tests, checking `document.pictureInPictureElement` also works. It wouldn't
                // be null in regular picture in picture.
                // Exit picture in picture mode. This gesture can't trigger pip on the main window.
                this.exitPictureInPicture();
                else if (this.isFullscreen()) this.exitFullscreen();
                else this.requestFullscreen();
            }
        }
    }
    /**
   * Handle a tap on the media element. It will toggle the user
   * activity state, which hides and shows the controls.
   *
   * @listens Tech#tap
   * @private
   */ handleTechTap_() {
        this.userActive(!this.userActive());
    }
    /**
   * Handle touch to start
   *
   * @listens Tech#touchstart
   * @private
   */ handleTechTouchStart_() {
        this.userWasActive = this.userActive();
    }
    /**
   * Handle touch to move
   *
   * @listens Tech#touchmove
   * @private
   */ handleTechTouchMove_() {
        if (this.userWasActive) this.reportUserActivity();
    }
    /**
   * Handle touch to end
   *
   * @param {Event} event
   *        the touchend event that triggered
   *        this function
   *
   * @listens Tech#touchend
   * @private
   */ handleTechTouchEnd_(event) {
        // Stop the mouse events from also happening
        if (event.cancelable) event.preventDefault();
    }
    /**
   * @private
   */ toggleFullscreenClass_() {
        if (this.isFullscreen()) this.addClass('vjs-fullscreen');
        else this.removeClass('vjs-fullscreen');
    }
    /**
   * when the document fschange event triggers it calls this
   */ documentFullscreenChange_(e) {
        const targetPlayer = e.target.player;
        // if another player was fullscreen
        // do a null check for targetPlayer because older firefox's would put document as e.target
        if (targetPlayer && targetPlayer !== this) return;
        const el = this.el();
        let isFs = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[this.fsApi_.fullscreenElement] === el;
        if (!isFs && el.matches) isFs = el.matches(':' + this.fsApi_.fullscreen);
        this.isFullscreen(isFs);
    }
    /**
   * Handle Tech Fullscreen Change
   *
   * @param {Event} event
   *        the fullscreenchange event that triggered this function
   *
   * @param {Object} data
   *        the data that was sent with the event
   *
   * @private
   * @listens Tech#fullscreenchange
   * @fires Player#fullscreenchange
   */ handleTechFullscreenChange_(event, data) {
        if (data) {
            if (data.nativeIOSFullscreen) {
                this.addClass('vjs-ios-native-fs');
                this.tech_.one('webkitendfullscreen', ()=>{
                    this.removeClass('vjs-ios-native-fs');
                });
            }
            this.isFullscreen(data.isFullscreen);
        }
    }
    handleTechFullscreenError_(event, err) {
        this.trigger('fullscreenerror', err);
    }
    /**
   * @private
   */ togglePictureInPictureClass_() {
        if (this.isInPictureInPicture()) this.addClass('vjs-picture-in-picture');
        else this.removeClass('vjs-picture-in-picture');
    }
    /**
   * Handle Tech Enter Picture-in-Picture.
   *
   * @param {Event} event
   *        the enterpictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#enterpictureinpicture
   */ handleTechEnterPictureInPicture_(event) {
        this.isInPictureInPicture(true);
    }
    /**
   * Handle Tech Leave Picture-in-Picture.
   *
   * @param {Event} event
   *        the leavepictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#leavepictureinpicture
   */ handleTechLeavePictureInPicture_(event) {
        this.isInPictureInPicture(false);
    }
    /**
   * Fires when an error occurred during the loading of an audio/video.
   *
   * @private
   * @listens Tech#error
   */ handleTechError_() {
        const error = this.tech_.error();
        if (error) this.error(error);
    }
    /**
   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
   *
   * @fires Player#textdata
   * @listens Tech#textdata
   * @private
   */ handleTechTextData_() {
        let data = null;
        if (arguments.length > 1) data = arguments[1];
        /**
     * Fires when we get a textdata event from tech
     *
     * @event Player#textdata
     * @type {Event}
     */ this.trigger('textdata', data);
    }
    /**
   * Get object for cached values.
   *
   * @return {Object}
   *         get the current object cache
   */ getCache() {
        return this.cache_;
    }
    /**
   * Resets the internal cache object.
   *
   * Using this function outside the player constructor or reset method may
   * have unintended side-effects.
   *
   * @private
   */ resetCache_() {
        this.cache_ = {
            // Right now, the currentTime is not _really_ cached because it is always
            // retrieved from the tech (see: currentTime). However, for completeness,
            // we set it to zero here to ensure that if we do start actually caching
            // it, we reset it along with everything else.
            currentTime: 0,
            initTime: 0,
            inactivityTimeout: this.options_.inactivityTimeout,
            duration: NaN,
            lastVolume: 1,
            lastPlaybackRate: this.defaultPlaybackRate(),
            media: null,
            src: '',
            source: {},
            sources: [],
            playbackRates: [],
            volume: 1
        };
    }
    /**
   * Pass values to the playback tech
   *
   * @param {string} [method]
   *        the method to call
   *
   * @param {Object} [arg]
   *        the argument to pass
   *
   * @private
   */ techCall_(method, arg) {
        // If it's not ready yet, call method when it is
        this.ready(function() {
            if (method in $cb03b711053a4297$var$allowedSetters) return $cb03b711053a4297$var$set(this.middleware_, this.tech_, method, arg);
            else if (method in $cb03b711053a4297$var$allowedMediators) return $cb03b711053a4297$var$mediate(this.middleware_, this.tech_, method, arg);
            try {
                if (this.tech_) this.tech_[method](arg);
            } catch (e) {
                $cb03b711053a4297$var$log$1(e);
                throw e;
            }
        }, true);
    }
    /**
   * Mediate attempt to call playback tech method
   * and return the value of the method called.
   *
   * @param {string} method
   *        Tech method
   *
   * @return {*}
   *         Value returned by the tech method called, undefined if tech
   *         is not ready or tech method is not present
   *
   * @private
   */ techGet_(method) {
        if (!this.tech_ || !this.tech_.isReady_) return;
        if (method in $cb03b711053a4297$var$allowedGetters) return $cb03b711053a4297$var$get(this.middleware_, this.tech_, method);
        else if (method in $cb03b711053a4297$var$allowedMediators) return $cb03b711053a4297$var$mediate(this.middleware_, this.tech_, method);
        // Log error when playback tech object is present but method
        // is undefined or unavailable
        try {
            return this.tech_[method]();
        } catch (e) {
            // When building additional tech libs, an expected method may not be defined yet
            if (this.tech_[method] === undefined) {
                $cb03b711053a4297$var$log$1(`Video.js: ${method} method not defined for ${this.techName_} playback technology.`, e);
                throw e;
            }
            // When a method isn't available on the object it throws a TypeError
            if (e.name === 'TypeError') {
                $cb03b711053a4297$var$log$1(`Video.js: ${method} unavailable on ${this.techName_} playback technology element.`, e);
                this.tech_.isReady_ = false;
                throw e;
            }
            // If error unknown, just log and throw
            $cb03b711053a4297$var$log$1(e);
            throw e;
        }
    }
    /**
   * Attempt to begin playback at the first opportunity.
   *
   * @return {Promise|undefined}
   *         Returns a promise if the browser supports Promises (or one
   *         was passed in as an option). This promise will be resolved on
   *         the return value of play. If this is undefined it will fulfill the
   *         promise chain otherwise the promise chain will be fulfilled when
   *         the promise from play is fulfilled.
   */ play() {
        return new Promise((resolve)=>{
            this.play_(resolve);
        });
    }
    /**
   * The actual logic for play, takes a callback that will be resolved on the
   * return value of play. This allows us to resolve to the play promise if there
   * is one on modern browsers.
   *
   * @private
   * @param {Function} [callback]
   *        The callback that should be called when the techs play is actually called
   */ play_(callback = $cb03b711053a4297$var$silencePromise) {
        this.playCallbacks_.push(callback);
        const isSrcReady = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));
        const isSafariOrIOS = Boolean($cb03b711053a4297$var$IS_ANY_SAFARI || $cb03b711053a4297$var$IS_IOS);
        // treat calls to play_ somewhat like the `one` event function
        if (this.waitToPlay_) {
            this.off([
                'ready',
                'loadstart'
            ], this.waitToPlay_);
            this.waitToPlay_ = null;
        }
        // if the player/tech is not ready or the src itself is not ready
        // queue up a call to play on `ready` or `loadstart`
        if (!this.isReady_ || !isSrcReady) {
            this.waitToPlay_ = (e)=>{
                this.play_();
            };
            this.one([
                'ready',
                'loadstart'
            ], this.waitToPlay_);
            // if we are in Safari, there is a high chance that loadstart will trigger after the gesture timeperiod
            // in that case, we need to prime the video element by calling load so it'll be ready in time
            if (!isSrcReady && isSafariOrIOS) this.load();
            return;
        }
        // If the player/tech is ready and we have a source, we can attempt playback.
        const val = this.techGet_('play');
        // For native playback, reset the progress bar if we get a play call from a replay.
        const isNativeReplay = isSafariOrIOS && this.hasClass('vjs-ended');
        if (isNativeReplay) this.resetProgressBar_();
        // play was terminated if the returned value is null
        if (val === null) this.runPlayTerminatedQueue_();
        else this.runPlayCallbacks_(val);
    }
    /**
   * These functions will be run when if play is terminated. If play
   * runPlayCallbacks_ is run these function will not be run. This allows us
   * to differentiate between a terminated play and an actual call to play.
   */ runPlayTerminatedQueue_() {
        const queue = this.playTerminatedQueue_.slice(0);
        this.playTerminatedQueue_ = [];
        queue.forEach(function(q) {
            q();
        });
    }
    /**
   * When a callback to play is delayed we have to run these
   * callbacks when play is actually called on the tech. This function
   * runs the callbacks that were delayed and accepts the return value
   * from the tech.
   *
   * @param {undefined|Promise} val
   *        The return value from the tech.
   */ runPlayCallbacks_(val) {
        const callbacks = this.playCallbacks_.slice(0);
        this.playCallbacks_ = [];
        // clear play terminatedQueue since we finished a real play
        this.playTerminatedQueue_ = [];
        callbacks.forEach(function(cb) {
            cb(val);
        });
    }
    /**
   * Pause the video playback
   */ pause() {
        this.techCall_('pause');
    }
    /**
   * Check if the player is paused or has yet to play
   *
   * @return {boolean}
   *         - false: if the media is currently playing
   *         - true: if media is not currently playing
   */ paused() {
        // The initial state of paused should be true (in Safari it's actually false)
        return this.techGet_('paused') === false ? false : true;
    }
    /**
   * Get a TimeRange object representing the current ranges of time that the user
   * has played.
   *
   * @return {TimeRange}
   *         A time range object that represents all the increments of time that have
   *         been played.
   */ played() {
        return this.techGet_('played') || $cb03b711053a4297$var$createTimeRanges$1(0, 0);
    }
    /**
   * Sets or returns whether or not the user is "scrubbing". Scrubbing is
   * when the user has clicked the progress bar handle and is
   * dragging it along the progress bar.
   *
   * @param {boolean} [isScrubbing]
   *        whether the user is or is not scrubbing
   *
   * @return {boolean|undefined}
   *         - The value of scrubbing when getting
   *         - Nothing when setting
   */ scrubbing(isScrubbing) {
        if (typeof isScrubbing === 'undefined') return this.scrubbing_;
        this.scrubbing_ = !!isScrubbing;
        this.techCall_('setScrubbing', this.scrubbing_);
        if (isScrubbing) this.addClass('vjs-scrubbing');
        else this.removeClass('vjs-scrubbing');
    }
    /**
   * Get or set the current time (in seconds)
   *
   * @param {number|string} [seconds]
   *        The time to seek to in seconds
   *
   * @return {number|undefined}
   *         - the current time in seconds when getting
   *         - Nothing when setting
   */ currentTime(seconds) {
        if (seconds === undefined) {
            // cache last currentTime and return. default to 0 seconds
            //
            // Caching the currentTime is meant to prevent a massive amount of reads on the tech's
            // currentTime when scrubbing, but may not provide much performance benefit after all.
            // Should be tested. Also something has to read the actual current time or the cache will
            // never get updated.
            this.cache_.currentTime = this.techGet_('currentTime') || 0;
            return this.cache_.currentTime;
        }
        if (seconds < 0) seconds = 0;
        if (!this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
            this.cache_.initTime = seconds;
            this.off('canplay', this.boundApplyInitTime_);
            this.one('canplay', this.boundApplyInitTime_);
            return;
        }
        this.techCall_('setCurrentTime', seconds);
        this.cache_.initTime = 0;
        if (isFinite(seconds)) this.cache_.currentTime = Number(seconds);
    }
    /**
   * Apply the value of initTime stored in cache as currentTime.
   *
   * @private
   */ applyInitTime_() {
        this.currentTime(this.cache_.initTime);
    }
    /**
   * Normally gets the length in time of the video in seconds;
   * in all but the rarest use cases an argument will NOT be passed to the method
   *
   * > **NOTE**: The video must have started loading before the duration can be
   * known, and depending on preload behaviour may not be known until the video starts
   * playing.
   *
   * @fires Player#durationchange
   *
   * @param {number} [seconds]
   *        The duration of the video to set in seconds
   *
   * @return {number|undefined}
   *         - The duration of the video in seconds when getting
   *         - Nothing when setting
   */ duration(seconds) {
        if (seconds === undefined) // return NaN if the duration is not known
        return this.cache_.duration !== undefined ? this.cache_.duration : NaN;
        seconds = parseFloat(seconds);
        // Standardize on Infinity for signaling video is live
        if (seconds < 0) seconds = Infinity;
        if (seconds !== this.cache_.duration) {
            // Cache the last set value for optimized scrubbing
            this.cache_.duration = seconds;
            if (seconds === Infinity) this.addClass('vjs-live');
            else this.removeClass('vjs-live');
            if (!isNaN(seconds)) // Do not fire durationchange unless the duration value is known.
            // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
            /**
         * @event Player#durationchange
         * @type {Event}
         */ this.trigger('durationchange');
        }
    }
    /**
   * Calculates how much time is left in the video. Not part
   * of the native video API.
   *
   * @return {number}
   *         The time remaining in seconds
   */ remainingTime() {
        return this.duration() - this.currentTime();
    }
    /**
   * A remaining time function that is intended to be used when
   * the time is to be displayed directly to the user.
   *
   * @return {number}
   *         The rounded time remaining in seconds
   */ remainingTimeDisplay() {
        return Math.floor(this.duration()) - Math.floor(this.currentTime());
    }
    //
    // Kind of like an array of portions of the video that have been downloaded.
    /**
   * Get a TimeRange object with an array of the times of the video
   * that have been downloaded. If you just want the percent of the
   * video that's been downloaded, use bufferedPercent.
   *
   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */ buffered() {
        let buffered = this.techGet_('buffered');
        if (!buffered || !buffered.length) buffered = $cb03b711053a4297$var$createTimeRanges$1(0, 0);
        return buffered;
    }
    /**
   * Get the TimeRanges of the media that are currently available
   * for seeking to.
   *
   * @see [Seekable Spec]{@link https://html.spec.whatwg.org/multipage/media.html#dom-media-seekable}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */ seekable() {
        let seekable = this.techGet_('seekable');
        if (!seekable || !seekable.length) seekable = $cb03b711053a4297$var$createTimeRanges$1(0, 0);
        return seekable;
    }
    /**
   * Returns whether the player is in the "seeking" state.
   *
   * @return {boolean} True if the player is in the seeking state, false if not.
   */ seeking() {
        return this.techGet_('seeking');
    }
    /**
   * Returns whether the player is in the "ended" state.
   *
   * @return {boolean} True if the player is in the ended state, false if not.
   */ ended() {
        return this.techGet_('ended');
    }
    /**
   * Returns the current state of network activity for the element, from
   * the codes in the list below.
   * - NETWORK_EMPTY (numeric value 0)
   *   The element has not yet been initialised. All attributes are in
   *   their initial states.
   * - NETWORK_IDLE (numeric value 1)
   *   The element's resource selection algorithm is active and has
   *   selected a resource, but it is not actually using the network at
   *   this time.
   * - NETWORK_LOADING (numeric value 2)
   *   The user agent is actively trying to download data.
   * - NETWORK_NO_SOURCE (numeric value 3)
   *   The element's resource selection algorithm is active, but it has
   *   not yet found a resource to use.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
   * @return {number} the current network activity state
   */ networkState() {
        return this.techGet_('networkState');
    }
    /**
   * Returns a value that expresses the current state of the element
   * with respect to rendering the current playback position, from the
   * codes in the list below.
   * - HAVE_NOTHING (numeric value 0)
   *   No information regarding the media resource is available.
   * - HAVE_METADATA (numeric value 1)
   *   Enough of the resource has been obtained that the duration of the
   *   resource is available.
   * - HAVE_CURRENT_DATA (numeric value 2)
   *   Data for the immediate current playback position is available.
   * - HAVE_FUTURE_DATA (numeric value 3)
   *   Data for the immediate current playback position is available, as
   *   well as enough data for the user agent to advance the current
   *   playback position in the direction of playback.
   * - HAVE_ENOUGH_DATA (numeric value 4)
   *   The user agent estimates that enough data is available for
   *   playback to proceed uninterrupted.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
   * @return {number} the current playback rendering state
   */ readyState() {
        return this.techGet_('readyState');
    }
    /**
   * Get the percent (as a decimal) of the video that's been downloaded.
   * This method is not a part of the native HTML video API.
   *
   * @return {number}
   *         A decimal between 0 and 1 representing the percent
   *         that is buffered 0 being 0% and 1 being 100%
   */ bufferedPercent() {
        return $cb03b711053a4297$var$bufferedPercent(this.buffered(), this.duration());
    }
    /**
   * Get the ending time of the last buffered time range
   * This is used in the progress bar to encapsulate all time ranges.
   *
   * @return {number}
   *         The end of the last buffered time range
   */ bufferedEnd() {
        const buffered = this.buffered();
        const duration = this.duration();
        let end = buffered.end(buffered.length - 1);
        if (end > duration) end = duration;
        return end;
    }
    /**
   * Get or set the current volume of the media
   *
   * @param  {number} [percentAsDecimal]
   *         The new volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         The current volume as a percent when getting
   */ volume(percentAsDecimal) {
        let vol;
        if (percentAsDecimal !== undefined) {
            // Force value to between 0 and 1
            vol = Math.max(0, Math.min(1, percentAsDecimal));
            this.cache_.volume = vol;
            this.techCall_('setVolume', vol);
            if (vol > 0) this.lastVolume_(vol);
            return;
        }
        // Default to 1 when returning current volume.
        vol = parseFloat(this.techGet_('volume'));
        return isNaN(vol) ? 1 : vol;
    }
    /**
   * Get the current muted state, or turn mute on or off
   *
   * @param {boolean} [muted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if mute is on and getting
   *         - false if mute is off and getting
   *         - nothing if setting
   */ muted(muted) {
        if (muted !== undefined) {
            this.techCall_('setMuted', muted);
            return;
        }
        return this.techGet_('muted') || false;
    }
    /**
   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
   * indicates the state of muted on initial playback.
   *
   * ```js
   *   var myPlayer = videojs('some-player-id');
   *
   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
   *
   *   // get, should be false
   *   console.log(myPlayer.defaultMuted());
   *   // set to true
   *   myPlayer.defaultMuted(true);
   *   // get should be true
   *   console.log(myPlayer.defaultMuted());
   * ```
   *
   * @param {boolean} [defaultMuted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if defaultMuted is on and getting
   *         - false if defaultMuted is off and getting
   *         - Nothing when setting
   */ defaultMuted(defaultMuted) {
        if (defaultMuted !== undefined) this.techCall_('setDefaultMuted', defaultMuted);
        return this.techGet_('defaultMuted') || false;
    }
    /**
   * Get the last volume, or set it
   *
   * @param  {number} [percentAsDecimal]
   *         The new last volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         - The current value of lastVolume as a percent when getting
   *         - Nothing when setting
   *
   * @private
   */ lastVolume_(percentAsDecimal) {
        if (percentAsDecimal !== undefined && percentAsDecimal !== 0) {
            this.cache_.lastVolume = percentAsDecimal;
            return;
        }
        return this.cache_.lastVolume;
    }
    /**
   * Check if current tech can support native fullscreen
   * (e.g. with built in controls like iOS)
   *
   * @return {boolean}
   *         if native fullscreen is supported
   */ supportsFullScreen() {
        return this.techGet_('supportsFullScreen') || false;
    }
    /**
   * Check if the player is in fullscreen mode or tell the player that it
   * is or is not in fullscreen mode.
   *
   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
   * property and instead document.fullscreenElement is used. But isFullscreen is
   * still a valuable property for internal player workings.
   *
   * @param  {boolean} [isFS]
   *         Set the players current fullscreen state
   *
   * @return {boolean|undefined}
   *         - true if fullscreen is on and getting
   *         - false if fullscreen is off and getting
   *         - Nothing when setting
   */ isFullscreen(isFS) {
        if (isFS !== undefined) {
            const oldValue = this.isFullscreen_;
            this.isFullscreen_ = Boolean(isFS);
            // if we changed fullscreen state and we're in prefixed mode, trigger fullscreenchange
            // this is the only place where we trigger fullscreenchange events for older browsers
            // fullWindow mode is treated as a prefixed event and will get a fullscreenchange event as well
            if (this.isFullscreen_ !== oldValue && this.fsApi_.prefixed) /**
           * @event Player#fullscreenchange
           * @type {Event}
           */ this.trigger('fullscreenchange');
            this.toggleFullscreenClass_();
            return;
        }
        return this.isFullscreen_;
    }
    /**
   * Increase the size of the video to full screen
   * In some browsers, full screen is not supported natively, so it enters
   * "full window mode", where the video fills the browser window.
   * In browsers and devices that support native full screen, sometimes the
   * browser's default controls will be shown, and not the Video.js custom skin.
   * This includes most mobile devices (iOS, Android) and older versions of
   * Safari.
   *
   * @param  {Object} [fullscreenOptions]
   *         Override the player fullscreen options
   *
   * @fires Player#fullscreenchange
   */ requestFullscreen(fullscreenOptions) {
        if (this.isInPictureInPicture()) this.exitPictureInPicture();
        const self1 = this;
        return new Promise((resolve, reject)=>{
            function offHandler() {
                self1.off('fullscreenerror', errorHandler);
                self1.off('fullscreenchange', changeHandler);
            }
            function changeHandler() {
                offHandler();
                resolve();
            }
            function errorHandler(e, err) {
                offHandler();
                reject(err);
            }
            self1.one('fullscreenchange', changeHandler);
            self1.one('fullscreenerror', errorHandler);
            const promise = self1.requestFullscreenHelper_(fullscreenOptions);
            if (promise) {
                promise.then(offHandler, offHandler);
                promise.then(resolve, reject);
            }
        });
    }
    requestFullscreenHelper_(fullscreenOptions) {
        let fsOptions;
        // Only pass fullscreen options to requestFullscreen in spec-compliant browsers.
        // Use defaults or player configured option unless passed directly to this method.
        if (!this.fsApi_.prefixed) {
            fsOptions = this.options_.fullscreen && this.options_.fullscreen.options || {};
            if (fullscreenOptions !== undefined) fsOptions = fullscreenOptions;
        }
        // This method works as follows:
        // 1. if a fullscreen api is available, use it
        //   1. call requestFullscreen with potential options
        //   2. if we got a promise from above, use it to update isFullscreen()
        // 2. otherwise, if the tech supports fullscreen, call `enterFullScreen` on it.
        //   This is particularly used for iPhone, older iPads, and non-safari browser on iOS.
        // 3. otherwise, use "fullWindow" mode
        if (this.fsApi_.requestFullscreen) {
            const promise = this.el_[this.fsApi_.requestFullscreen](fsOptions);
            // Even on browsers with promise support this may not return a promise
            if (promise) promise.then(()=>this.isFullscreen(true), ()=>this.isFullscreen(false));
            return promise;
        } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) // we can't take the video.js controls fullscreen but we can go fullscreen
        // with native controls
        this.techCall_('enterFullScreen');
        else // fullscreen isn't supported so we'll just stretch the video element to
        // fill the viewport
        this.enterFullWindow();
    }
    /**
   * Return the video to its normal size after having been in full screen mode
   *
   * @fires Player#fullscreenchange
   */ exitFullscreen() {
        const self1 = this;
        return new Promise((resolve, reject)=>{
            function offHandler() {
                self1.off('fullscreenerror', errorHandler);
                self1.off('fullscreenchange', changeHandler);
            }
            function changeHandler() {
                offHandler();
                resolve();
            }
            function errorHandler(e, err) {
                offHandler();
                reject(err);
            }
            self1.one('fullscreenchange', changeHandler);
            self1.one('fullscreenerror', errorHandler);
            const promise = self1.exitFullscreenHelper_();
            if (promise) {
                promise.then(offHandler, offHandler);
                // map the promise to our resolve/reject methods
                promise.then(resolve, reject);
            }
        });
    }
    exitFullscreenHelper_() {
        if (this.fsApi_.requestFullscreen) {
            const promise = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[this.fsApi_.exitFullscreen]();
            // Even on browsers with promise support this may not return a promise
            if (promise) // we're splitting the promise here, so, we want to catch the
            // potential error so that this chain doesn't have unhandled errors
            $cb03b711053a4297$var$silencePromise(promise.then(()=>this.isFullscreen(false)));
            return promise;
        } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) this.techCall_('exitFullScreen');
        else this.exitFullWindow();
    }
    /**
   * When fullscreen isn't supported we can stretch the
   * video container to as wide as the browser will let us.
   *
   * @fires Player#enterFullWindow
   */ enterFullWindow() {
        this.isFullscreen(true);
        this.isFullWindow = true;
        // Storing original doc overflow value to return to when fullscreen is off
        this.docOrigOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).documentElement.style.overflow;
        // Add listener for esc key to exit fullscreen
        $cb03b711053a4297$var$on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), 'keydown', this.boundFullWindowOnEscKey_);
        // Hide any scroll bars
        (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).documentElement.style.overflow = 'hidden';
        // Apply fullscreen styles
        $cb03b711053a4297$var$addClass((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).body, 'vjs-full-window');
        /**
     * @event Player#enterFullWindow
     * @type {Event}
     */ this.trigger('enterFullWindow');
    }
    /**
   * Check for call to either exit full window or
   * full screen on ESC key
   *
   * @param {string} event
   *        Event to check for key press
   */ fullWindowOnEscKey(event) {
        if (event.key === 'Escape') {
            if (this.isFullscreen() === true) {
                if (!this.isFullWindow) this.exitFullscreen();
                else this.exitFullWindow();
            }
        }
    }
    /**
   * Exit full window
   *
   * @fires Player#exitFullWindow
   */ exitFullWindow() {
        this.isFullscreen(false);
        this.isFullWindow = false;
        $cb03b711053a4297$var$off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), 'keydown', this.boundFullWindowOnEscKey_);
        // Unhide scroll bars.
        (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).documentElement.style.overflow = this.docOrigOverflow;
        // Remove fullscreen styles
        $cb03b711053a4297$var$removeClass((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).body, 'vjs-full-window');
        // Resize the box, controller, and poster to original sizes
        // this.positionAll();
        /**
     * @event Player#exitFullWindow
     * @type {Event}
     */ this.trigger('exitFullWindow');
    }
    /**
   * Get or set disable Picture-in-Picture mode.
   *
   * @param {boolean} [value]
   *                  - true will disable Picture-in-Picture mode
   *                  - false will enable Picture-in-Picture mode
   */ disablePictureInPicture(value) {
        if (value === undefined) return this.techGet_('disablePictureInPicture');
        this.techCall_('setDisablePictureInPicture', value);
        this.options_.disablePictureInPicture = value;
        this.trigger('disablepictureinpicturechanged');
    }
    /**
   * Check if the player is in Picture-in-Picture mode or tell the player that it
   * is or is not in Picture-in-Picture mode.
   *
   * @param  {boolean} [isPiP]
   *         Set the players current Picture-in-Picture state
   *
   * @return {boolean|undefined}
   *         - true if Picture-in-Picture is on and getting
   *         - false if Picture-in-Picture is off and getting
   *         - nothing if setting
   */ isInPictureInPicture(isPiP) {
        if (isPiP !== undefined) {
            this.isInPictureInPicture_ = !!isPiP;
            this.togglePictureInPictureClass_();
            return;
        }
        return !!this.isInPictureInPicture_;
    }
    /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * This can use document picture-in-picture or element picture in picture
   *
   * Set `enableDocumentPictureInPicture` to `true` to use docPiP on a supported browser
   * Else set `disablePictureInPicture` to `false` to disable elPiP on a supported browser
   *
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/}
   * @see [Spec]{@link https://wicg.github.io/document-picture-in-picture/}
   *
   * @fires Player#enterpictureinpicture
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */ requestPictureInPicture() {
        if (this.options_.enableDocumentPictureInPicture && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).documentPictureInPicture) {
            const pipContainer = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement(this.el().tagName);
            pipContainer.classList = this.el().classList;
            pipContainer.classList.add('vjs-pip-container');
            if (this.posterImage) pipContainer.appendChild(this.posterImage.el().cloneNode(true));
            if (this.titleBar) pipContainer.appendChild(this.titleBar.el().cloneNode(true));
            pipContainer.appendChild($cb03b711053a4297$var$createEl('p', {
                className: 'vjs-pip-text'
            }, {}, this.localize('Playing in picture-in-picture')));
            return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).documentPictureInPicture.requestWindow({
                // The aspect ratio won't be correct, Chrome bug https://crbug.com/1407629
                width: this.videoWidth(),
                height: this.videoHeight()
            }).then((pipWindow)=>{
                $cb03b711053a4297$var$copyStyleSheetsToWindow(pipWindow);
                this.el_.parentNode.insertBefore(pipContainer, this.el_);
                pipWindow.document.body.appendChild(this.el_);
                pipWindow.document.body.classList.add('vjs-pip-window');
                this.player_.isInPictureInPicture(true);
                this.player_.trigger({
                    type: 'enterpictureinpicture',
                    pipWindow: pipWindow
                });
                // Listen for the PiP closing event to move the video back.
                pipWindow.addEventListener('pagehide', (event)=>{
                    const pipVideo = event.target.querySelector('.video-js');
                    pipContainer.parentNode.replaceChild(pipVideo, pipContainer);
                    this.player_.isInPictureInPicture(false);
                    this.player_.trigger('leavepictureinpicture');
                });
                return pipWindow;
            });
        }
        if ('pictureInPictureEnabled' in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) && this.disablePictureInPicture() === false) /**
       * This event fires when the player enters picture in picture mode
       *
       * @event Player#enterpictureinpicture
       * @type {Event}
       */ return this.techGet_('requestPictureInPicture');
        return Promise.reject('No PiP mode is available');
    }
    /**
   * Exit Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#leavepictureinpicture
   *
   * @return {Promise}
   *         A promise.
   */ exitPictureInPicture() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).documentPictureInPicture && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).documentPictureInPicture.window) {
            // With documentPictureInPicture, Player#leavepictureinpicture is fired in the pagehide handler
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).documentPictureInPicture.window.close();
            return Promise.resolve();
        }
        if ('pictureInPictureEnabled' in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))) /**
       * This event fires when the player leaves picture in picture mode
       *
       * @event Player#leavepictureinpicture
       * @type {Event}
       */ return (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).exitPictureInPicture();
    }
    /**
   * Called when this Player has focus and a key gets pressed down, or when
   * any Component of this player receives a key press that it doesn't handle.
   * This allows player-wide hotkeys (either as defined below, or optionally
   * by an external function).
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        const { userActions: userActions } = this.options_;
        // Bail out if hotkeys are not configured.
        if (!userActions || !userActions.hotkeys) return;
        // Function that determines whether or not to exclude an element from
        // hotkeys handling.
        const excludeElement = (el)=>{
            const tagName = el.tagName.toLowerCase();
            // The first and easiest test is for `contenteditable` elements.
            if (el.isContentEditable) return true;
            // Inputs matching these types will still trigger hotkey handling as
            // they are not text inputs.
            const allowedInputTypes = [
                'button',
                'checkbox',
                'hidden',
                'radio',
                'reset',
                'submit'
            ];
            if (tagName === 'input') return allowedInputTypes.indexOf(el.type) === -1;
            // The final test is by tag name. These tags will be excluded entirely.
            const excludedTags = [
                'textarea'
            ];
            return excludedTags.indexOf(tagName) !== -1;
        };
        // Bail out if the user is focused on an interactive form element.
        if (excludeElement(this.el_.ownerDocument.activeElement)) return;
        if (typeof userActions.hotkeys === 'function') userActions.hotkeys.call(this, event);
        else this.handleHotkeys(event);
    }
    /**
   * Called when this Player receives a hotkey keydown event.
   * Supported player-wide hotkeys are:
   *
   *   f          - toggle fullscreen
   *   m          - toggle mute
   *   k or Space - toggle play/pause
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   */ handleHotkeys(event) {
        const hotkeys = this.options_.userActions ? this.options_.userActions.hotkeys : {};
        // set fullscreenKey, muteKey, playPauseKey from `hotkeys`, use defaults if not set
        const { fullscreenKey: fullscreenKey = (keydownEvent)=>event.key.toLowerCase() === 'f', muteKey: muteKey = (keydownEvent)=>event.key.toLowerCase() === 'm', playPauseKey: playPauseKey = (keydownEvent)=>event.key.toLowerCase() === 'k' || event.key.toLowerCase() === ' ' } = hotkeys;
        if (fullscreenKey.call(this, event)) {
            event.preventDefault();
            event.stopPropagation();
            const FSToggle = $cb03b711053a4297$var$Component$1.getComponent('FullscreenToggle');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[this.fsApi_.fullscreenEnabled] !== false) FSToggle.prototype.handleClick.call(this, event);
        } else if (muteKey.call(this, event)) {
            event.preventDefault();
            event.stopPropagation();
            const MuteToggle = $cb03b711053a4297$var$Component$1.getComponent('MuteToggle');
            MuteToggle.prototype.handleClick.call(this, event);
        } else if (playPauseKey.call(this, event)) {
            event.preventDefault();
            event.stopPropagation();
            const PlayToggle = $cb03b711053a4297$var$Component$1.getComponent('PlayToggle');
            PlayToggle.prototype.handleClick.call(this, event);
        }
    }
    /**
   * Check whether the player can play a given mimetype
   *
   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
   *
   * @param {string} type
   *        The mimetype to check
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */ canPlayType(type) {
        let can;
        // Loop through each playback technology in the options order
        for(let i = 0, j = this.options_.techOrder; i < j.length; i++){
            const techName = j[i];
            let tech = $cb03b711053a4297$var$Tech.getTech(techName);
            // Support old behavior of techs being registered as components.
            // Remove once that deprecated behavior is removed.
            if (!tech) tech = $cb03b711053a4297$var$Component$1.getComponent(techName);
            // Check if the current tech is defined before continuing
            if (!tech) {
                $cb03b711053a4297$var$log$1.error(`The "${techName}" tech is undefined. Skipped browser support check for that tech.`);
                continue;
            }
            // Check if the browser supports this technology
            if (tech.isSupported()) {
                can = tech.canPlayType(type);
                if (can) return can;
            }
        }
        return '';
    }
    /**
   * Select source based on tech-order or source-order
   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
   * defaults to tech-order selection
   *
   * @param {Array} sources
   *        The sources for a media asset
   *
   * @return {Object|boolean}
   *         Object of source and tech order or false
   */ selectSource(sources) {
        // Get only the techs specified in `techOrder` that exist and are supported by the
        // current platform
        const techs = this.options_.techOrder.map((techName)=>{
            return [
                techName,
                $cb03b711053a4297$var$Tech.getTech(techName)
            ];
        }).filter(([techName, tech])=>{
            // Check if the current tech is defined before continuing
            if (tech) // Check if the browser supports this technology
            return tech.isSupported();
            $cb03b711053a4297$var$log$1.error(`The "${techName}" tech is undefined. Skipped browser support check for that tech.`);
            return false;
        });
        // Iterate over each `innerArray` element once per `outerArray` element and execute
        // `tester` with both. If `tester` returns a non-falsy value, exit early and return
        // that value.
        const findFirstPassingTechSourcePair = function(outerArray, innerArray, tester) {
            let found;
            outerArray.some((outerChoice)=>{
                return innerArray.some((innerChoice)=>{
                    found = tester(outerChoice, innerChoice);
                    if (found) return true;
                });
            });
            return found;
        };
        let foundSourceAndTech;
        const flip = (fn)=>(a, b)=>fn(b, a);
        const finder = ([techName, tech], source)=>{
            if (tech.canPlaySource(source, this.options_[techName.toLowerCase()])) return {
                source: source,
                tech: techName
            };
        };
        // Depending on the truthiness of `options.sourceOrder`, we swap the order of techs and sources
        // to select from them based on their priority.
        if (this.options_.sourceOrder) // Source-first ordering
        foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip(finder));
        else // Tech-first ordering
        foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
        return foundSourceAndTech || false;
    }
    /**
   * Executes source setting and getting logic
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   * @param {boolean} [isRetry]
   *        Indicates whether this is being called internally as a result of a retry
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */ handleSrc_(source, isRetry) {
        // getter usage
        if (typeof source === 'undefined') return this.cache_.src || '';
        // Reset retry behavior for new source
        if (this.resetRetryOnError_) this.resetRetryOnError_();
        // filter out invalid sources and turn our source into
        // an array of source objects
        const sources = $cb03b711053a4297$var$filterSource(source);
        // if a source was passed in then it is invalid because
        // it was filtered to a zero length Array. So we have to
        // show an error
        if (!sources.length) {
            this.setTimeout(function() {
                this.error({
                    code: 4,
                    message: this.options_.notSupportedMessage
                });
            }, 0);
            return;
        }
        // initial sources
        this.changingSrc_ = true;
        // Only update the cached source list if we are not retrying a new source after error,
        // since in that case we want to include the failed source(s) in the cache
        if (!isRetry) this.cache_.sources = sources;
        this.updateSourceCaches_(sources[0]);
        // middlewareSource is the source after it has been changed by middleware
        $cb03b711053a4297$var$setSource(this, sources[0], (middlewareSource, mws)=>{
            this.middleware_ = mws;
            // since sourceSet is async we have to update the cache again after we select a source since
            // the source that is selected could be out of order from the cache update above this callback.
            if (!isRetry) this.cache_.sources = sources;
            this.updateSourceCaches_(middlewareSource);
            const err = this.src_(middlewareSource);
            if (err) {
                if (sources.length > 1) return this.handleSrc_(sources.slice(1));
                this.changingSrc_ = false;
                // We need to wrap this in a timeout to give folks a chance to add error event handlers
                this.setTimeout(function() {
                    this.error({
                        code: 4,
                        message: this.options_.notSupportedMessage
                    });
                }, 0);
                // we could not find an appropriate tech, but let's still notify the delegate that this is it
                // this needs a better comment about why this is needed
                this.triggerReady();
                return;
            }
            $cb03b711053a4297$var$setTech(mws, this.tech_);
        });
        // Try another available source if this one fails before playback.
        if (sources.length > 1) {
            const retry = ()=>{
                // Remove the error modal
                this.error(null);
                this.handleSrc_(sources.slice(1), true);
            };
            const stopListeningForErrors = ()=>{
                this.off('error', retry);
            };
            this.one('error', retry);
            this.one('playing', stopListeningForErrors);
            this.resetRetryOnError_ = ()=>{
                this.off('error', retry);
                this.off('playing', stopListeningForErrors);
            };
        }
    }
    /**
   * Get or set the video source.
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */ src(source) {
        return this.handleSrc_(source, false);
    }
    /**
   * Set the source object on the tech, returns a boolean that indicates whether
   * there is a tech that can play the source or not
   *
   * @param {Tech~SourceObject} source
   *        The source object to set on the Tech
   *
   * @return {boolean}
   *         - True if there is no Tech to playback this source
   *         - False otherwise
   *
   * @private
   */ src_(source) {
        const sourceTech = this.selectSource([
            source
        ]);
        if (!sourceTech) return true;
        if (!$cb03b711053a4297$var$titleCaseEquals(sourceTech.tech, this.techName_)) {
            this.changingSrc_ = true;
            // load this technology with the chosen source
            this.loadTech_(sourceTech.tech, sourceTech.source);
            this.tech_.ready(()=>{
                this.changingSrc_ = false;
            });
            return false;
        }
        // wait until the tech is ready to set the source
        // and set it synchronously if possible (#2326)
        this.ready(function() {
            // The setSource tech method was added with source handlers
            // so older techs won't support it
            // We need to check the direct prototype for the case where subclasses
            // of the tech do not support source handlers
            if (this.tech_.constructor.prototype.hasOwnProperty('setSource')) this.techCall_('setSource', source);
            else this.techCall_('src', source.src);
            this.changingSrc_ = false;
        }, true);
        return false;
    }
    /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */ addSourceElement(srcUrl, mimeType) {
        if (!this.tech_) return false;
        return this.tech_.addSourceElement(srcUrl, mimeType);
    }
    /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */ removeSourceElement(srcUrl) {
        if (!this.tech_) return false;
        return this.tech_.removeSourceElement(srcUrl);
    }
    /**
   * Begin loading the src data.
   */ load() {
        // Workaround to use the load method with the VHS.
        // Does not cover the case when the load method is called directly from the mediaElement.
        if (this.tech_ && this.tech_.vhs) {
            this.src(this.currentSource());
            return;
        }
        this.techCall_('load');
    }
    /**
   * Reset the player. Loads the first tech in the techOrder,
   * removes all the text tracks in the existing `tech`,
   * and calls `reset` on the `tech`.
   */ reset() {
        if (this.paused()) this.doReset_();
        else {
            const playPromise = this.play();
            $cb03b711053a4297$var$silencePromise(playPromise.then(()=>this.doReset_()));
        }
    }
    doReset_() {
        if (this.tech_) this.tech_.clearTracks('text');
        this.removeClass('vjs-playing');
        this.addClass('vjs-paused');
        this.resetCache_();
        this.poster('');
        this.loadTech_(this.options_.techOrder[0], null);
        this.techCall_('reset');
        this.resetControlBarUI_();
        this.error(null);
        if (this.titleBar) this.titleBar.update({
            title: undefined,
            description: undefined
        });
        if ($cb03b711053a4297$var$isEvented(this)) this.trigger('playerreset');
    }
    /**
   * Reset Control Bar's UI by calling sub-methods that reset
   * all of Control Bar's components
   */ resetControlBarUI_() {
        this.resetProgressBar_();
        this.resetPlaybackRate_();
        this.resetVolumeBar_();
    }
    /**
   * Reset tech's progress so progress bar is reset in the UI
   */ resetProgressBar_() {
        this.currentTime(0);
        const { currentTimeDisplay: currentTimeDisplay, durationDisplay: durationDisplay, progressControl: progressControl, remainingTimeDisplay: remainingTimeDisplay } = this.controlBar || {};
        const { seekBar: seekBar } = progressControl || {};
        if (currentTimeDisplay) currentTimeDisplay.updateContent();
        if (durationDisplay) durationDisplay.updateContent();
        if (remainingTimeDisplay) remainingTimeDisplay.updateContent();
        if (seekBar) {
            seekBar.update();
            if (seekBar.loadProgressBar) seekBar.loadProgressBar.update();
        }
    }
    /**
   * Reset Playback ratio
   */ resetPlaybackRate_() {
        this.playbackRate(this.defaultPlaybackRate());
        this.handleTechRateChange_();
    }
    /**
   * Reset Volume bar
   */ resetVolumeBar_() {
        this.volume(1.0);
        this.trigger('volumechange');
    }
    /**
   * Returns all of the current source objects.
   *
   * @return {Tech~SourceObject[]}
   *         The current source objects
   */ currentSources() {
        const source = this.currentSource();
        const sources = [];
        // assume `{}` or `{ src }`
        if (Object.keys(source).length !== 0) sources.push(source);
        return this.cache_.sources || sources;
    }
    /**
   * Returns the current source object.
   *
   * @return {Tech~SourceObject}
   *         The current source object
   */ currentSource() {
        return this.cache_.source || {};
    }
    /**
   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
   *
   * @return {string}
   *         The current source
   */ currentSrc() {
        return this.currentSource() && this.currentSource().src || '';
    }
    /**
   * Get the current source type e.g. video/mp4
   * This can allow you rebuild the current source object so that you could load the same
   * source and tech later
   *
   * @return {string}
   *         The source MIME type
   */ currentType() {
        return this.currentSource() && this.currentSource().type || '';
    }
    /**
   * Get or set the preload attribute
   *
   * @param {'none'|'auto'|'metadata'} [value]
   *        Preload mode to pass to tech
   *
   * @return {string|undefined}
   *         - The preload attribute value when getting
   *         - Nothing when setting
   */ preload(value) {
        if (value !== undefined) {
            this.techCall_('setPreload', value);
            this.options_.preload = value;
            return;
        }
        return this.techGet_('preload');
    }
    /**
   * Get or set the autoplay option. When this is a boolean it will
   * modify the attribute on the tech. When this is a string the attribute on
   * the tech will be removed and `Player` will handle autoplay on loadstarts.
   *
   * @param {boolean|'play'|'muted'|'any'} [value]
   *        - true: autoplay using the browser behavior
   *        - false: do not autoplay
   *        - 'play': call play() on every loadstart
   *        - 'muted': call muted() then play() on every loadstart
   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
   *        - *: values other than those listed here will be set `autoplay` to true
   *
   * @return {boolean|string|undefined}
   *         - The current value of autoplay when getting
   *         - Nothing when setting
   */ autoplay(value) {
        // getter usage
        if (value === undefined) return this.options_.autoplay || false;
        let techAutoplay;
        // if the value is a valid string set it to that, or normalize `true` to 'play', if need be
        if (typeof value === 'string' && /(any|play|muted)/.test(value) || value === true && this.options_.normalizeAutoplay) {
            this.options_.autoplay = value;
            this.manualAutoplay_(typeof value === 'string' ? value : 'play');
            techAutoplay = false;
        // any falsy value sets autoplay to false in the browser,
        // lets do the same
        } else if (!value) this.options_.autoplay = false;
        else this.options_.autoplay = true;
        techAutoplay = typeof techAutoplay === 'undefined' ? this.options_.autoplay : techAutoplay;
        // if we don't have a tech then we do not queue up
        // a setAutoplay call on tech ready. We do this because the
        // autoplay option will be passed in the constructor and we
        // do not need to set it twice
        if (this.tech_) this.techCall_('setAutoplay', techAutoplay);
    }
    /**
   * Set or unset the playsinline attribute.
   * Playsinline tells the browser that non-fullscreen playback is preferred.
   *
   * @param {boolean} [value]
   *        - true means that we should try to play inline by default
   *        - false means that we should use the browser's default playback mode,
   *          which in most cases is inline. iOS Safari is a notable exception
   *          and plays fullscreen by default.
   *
   * @return {string|undefined}
   *         - the current value of playsinline
   *         - Nothing when setting
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */ playsinline(value) {
        if (value !== undefined) {
            this.techCall_('setPlaysinline', value);
            this.options_.playsinline = value;
        }
        return this.techGet_('playsinline');
    }
    /**
   * Get or set the loop attribute on the video element.
   *
   * @param {boolean} [value]
   *        - true means that we should loop the video
   *        - false means that we should not loop the video
   *
   * @return {boolean|undefined}
   *         - The current value of loop when getting
   *         - Nothing when setting
   */ loop(value) {
        if (value !== undefined) {
            this.techCall_('setLoop', value);
            this.options_.loop = value;
            return;
        }
        return this.techGet_('loop');
    }
    /**
   * Get or set the poster image source url
   *
   * @fires Player#posterchange
   *
   * @param {string} [src]
   *        Poster image source URL
   *
   * @return {string|undefined}
   *         - The current value of poster when getting
   *         - Nothing when setting
   */ poster(src) {
        if (src === undefined) return this.poster_;
        // The correct way to remove a poster is to set as an empty string
        // other falsey values will throw errors
        if (!src) src = '';
        if (src === this.poster_) return;
        // update the internal poster variable
        this.poster_ = src;
        // update the tech's poster
        this.techCall_('setPoster', src);
        this.isPosterFromTech_ = false;
        // alert components that the poster has been set
        /**
     * This event fires when the poster image is changed on the player.
     *
     * @event Player#posterchange
     * @type {Event}
     */ this.trigger('posterchange');
    }
    /**
   * Some techs (e.g. YouTube) can provide a poster source in an
   * asynchronous way. We want the poster component to use this
   * poster source so that it covers up the tech's controls.
   * (YouTube's play button). However we only want to use this
   * source if the player user hasn't set a poster through
   * the normal APIs.
   *
   * @fires Player#posterchange
   * @listens Tech#posterchange
   * @private
   */ handleTechPosterChange_() {
        if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
            const newPoster = this.tech_.poster() || '';
            if (newPoster !== this.poster_) {
                this.poster_ = newPoster;
                this.isPosterFromTech_ = true;
                // Let components know the poster has changed
                this.trigger('posterchange');
            }
        }
    }
    /**
   * Get or set whether or not the controls are showing.
   *
   * @fires Player#controlsenabled
   *
   * @param {boolean} [bool]
   *        - true to turn controls on
   *        - false to turn controls off
   *
   * @return {boolean|undefined}
   *         - The current value of controls when getting
   *         - Nothing when setting
   */ controls(bool) {
        if (bool === undefined) return !!this.controls_;
        bool = !!bool;
        // Don't trigger a change event unless it actually changed
        if (this.controls_ === bool) return;
        this.controls_ = bool;
        if (this.usingNativeControls()) this.techCall_('setControls', bool);
        if (this.controls_) {
            this.removeClass('vjs-controls-disabled');
            this.addClass('vjs-controls-enabled');
            /**
       * @event Player#controlsenabled
       * @type {Event}
       */ this.trigger('controlsenabled');
            if (!this.usingNativeControls()) this.addTechControlsListeners_();
        } else {
            this.removeClass('vjs-controls-enabled');
            this.addClass('vjs-controls-disabled');
            /**
       * @event Player#controlsdisabled
       * @type {Event}
       */ this.trigger('controlsdisabled');
            if (!this.usingNativeControls()) this.removeTechControlsListeners_();
        }
    }
    /**
   * Toggle native controls on/off. Native controls are the controls built into
   * devices (e.g. default iPhone controls) or other techs
   * (e.g. Vimeo Controls)
   * **This should only be set by the current tech, because only the tech knows
   * if it can support native controls**
   *
   * @fires Player#usingnativecontrols
   * @fires Player#usingcustomcontrols
   *
   * @param {boolean} [bool]
   *        - true to turn native controls on
   *        - false to turn native controls off
   *
   * @return {boolean|undefined}
   *         - The current value of native controls when getting
   *         - Nothing when setting
   */ usingNativeControls(bool) {
        if (bool === undefined) return !!this.usingNativeControls_;
        bool = !!bool;
        // Don't trigger a change event unless it actually changed
        if (this.usingNativeControls_ === bool) return;
        this.usingNativeControls_ = bool;
        if (this.usingNativeControls_) {
            this.addClass('vjs-using-native-controls');
            /**
       * player is using the native device controls
       *
       * @event Player#usingnativecontrols
       * @type {Event}
       */ this.trigger('usingnativecontrols');
        } else {
            this.removeClass('vjs-using-native-controls');
            /**
       * player is using the custom HTML controls
       *
       * @event Player#usingcustomcontrols
       * @type {Event}
       */ this.trigger('usingcustomcontrols');
        }
    }
    /**
   * Set or get the current MediaError
   *
   * @fires Player#error
   *
   * @param  {MediaError|string|number} [err]
   *         A MediaError or a string/number to be turned
   *         into a MediaError
   *
   * @return {MediaError|null|undefined}
   *         - The current MediaError when getting (or null)
   *         - Nothing when setting
   */ error(err) {
        if (err === undefined) return this.error_ || null;
        // allow hooks to modify error object
        $cb03b711053a4297$var$hooks('beforeerror').forEach((hookFunction)=>{
            const newErr = hookFunction(this, err);
            if (!($cb03b711053a4297$var$isObject(newErr) && !Array.isArray(newErr) || typeof newErr === 'string' || typeof newErr === 'number' || newErr === null)) {
                this.log.error('please return a value that MediaError expects in beforeerror hooks');
                return;
            }
            err = newErr;
        });
        // Suppress the first error message for no compatible source until
        // user interaction
        if (this.options_.suppressNotSupportedError && err && err.code === 4) {
            const triggerSuppressedError = function() {
                this.error(err);
            };
            this.options_.suppressNotSupportedError = false;
            this.any([
                'click',
                'touchstart'
            ], triggerSuppressedError);
            this.one('loadstart', function() {
                this.off([
                    'click',
                    'touchstart'
                ], triggerSuppressedError);
            });
            return;
        }
        // restoring to default
        if (err === null) {
            this.error_ = null;
            this.removeClass('vjs-error');
            if (this.errorDisplay) this.errorDisplay.close();
            return;
        }
        this.error_ = new $cb03b711053a4297$var$MediaError(err);
        // add the vjs-error classname to the player
        this.addClass('vjs-error');
        // log the name of the error type and any message
        // IE11 logs "[object object]" and required you to expand message to see error object
        $cb03b711053a4297$var$log$1.error(`(CODE:${this.error_.code} ${$cb03b711053a4297$var$MediaError.errorTypes[this.error_.code]})`, this.error_.message, this.error_);
        /**
     * @event Player#error
     * @type {Event}
     */ this.trigger('error');
        // notify hooks of the per player error
        $cb03b711053a4297$var$hooks('error').forEach((hookFunction)=>hookFunction(this, this.error_));
        return;
    }
    /**
   * Report user activity
   *
   * @param {Object} event
   *        Event object
   */ reportUserActivity(event) {
        this.userActivity_ = true;
    }
    /**
   * Get/set if user is active
   *
   * @fires Player#useractive
   * @fires Player#userinactive
   *
   * @param {boolean} [bool]
   *        - true if the user is active
   *        - false if the user is inactive
   *
   * @return {boolean|undefined}
   *         - The current value of userActive when getting
   *         - Nothing when setting
   */ userActive(bool) {
        if (bool === undefined) return this.userActive_;
        bool = !!bool;
        if (bool === this.userActive_) return;
        this.userActive_ = bool;
        if (this.userActive_) {
            this.userActivity_ = true;
            this.removeClass('vjs-user-inactive');
            this.addClass('vjs-user-active');
            /**
       * @event Player#useractive
       * @type {Event}
       */ this.trigger('useractive');
            return;
        }
        // Chrome/Safari/IE have bugs where when you change the cursor it can
        // trigger a mousemove event. This causes an issue when you're hiding
        // the cursor when the user is inactive, and a mousemove signals user
        // activity. Making it impossible to go into inactive mode. Specifically
        // this happens in fullscreen when we really need to hide the cursor.
        //
        // When this gets resolved in ALL browsers it can be removed
        // https://code.google.com/p/chromium/issues/detail?id=103041
        if (this.tech_) this.tech_.one('mousemove', function(e) {
            e.stopPropagation();
            e.preventDefault();
        });
        this.userActivity_ = false;
        this.removeClass('vjs-user-active');
        this.addClass('vjs-user-inactive');
        /**
     * @event Player#userinactive
     * @type {Event}
     */ this.trigger('userinactive');
    }
    /**
   * Listen for user activity based on timeout value
   *
   * @private
   */ listenForUserActivity_() {
        let mouseInProgress;
        let lastMoveX;
        let lastMoveY;
        const handleActivity = $cb03b711053a4297$var$bind_(this, this.reportUserActivity);
        const handleMouseMove = function(e) {
            // #1068 - Prevent mousemove spamming
            // Chrome Bug: https://code.google.com/p/chromium/issues/detail?id=366970
            if (e.screenX !== lastMoveX || e.screenY !== lastMoveY) {
                lastMoveX = e.screenX;
                lastMoveY = e.screenY;
                handleActivity();
            }
        };
        const handleMouseDown = function() {
            handleActivity();
            // For as long as the they are touching the device or have their mouse down,
            // we consider them active even if they're not moving their finger or mouse.
            // So we want to continue to update that they are active
            this.clearInterval(mouseInProgress);
            // Setting userActivity=true now and setting the interval to the same time
            // as the activityCheck interval (250) should ensure we never miss the
            // next activityCheck
            mouseInProgress = this.setInterval(handleActivity, 250);
        };
        const handleMouseUpAndMouseLeave = function(event) {
            handleActivity();
            // Stop the interval that maintains activity if the mouse/touch is down
            this.clearInterval(mouseInProgress);
        };
        // Any mouse movement will be considered user activity
        this.on('mousedown', handleMouseDown);
        this.on('mousemove', handleMouseMove);
        this.on('mouseup', handleMouseUpAndMouseLeave);
        this.on('mouseleave', handleMouseUpAndMouseLeave);
        const controlBar = this.getChild('controlBar');
        // Fixes bug on Android & iOS where when tapping progressBar (when control bar is displayed)
        // controlBar would no longer be hidden by default timeout.
        if (controlBar && !$cb03b711053a4297$var$IS_IOS && !$cb03b711053a4297$var$IS_ANDROID) {
            controlBar.on('mouseenter', function(event) {
                if (this.player().options_.inactivityTimeout !== 0) this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout;
                this.player().options_.inactivityTimeout = 0;
            });
            controlBar.on('mouseleave', function(event) {
                this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
            });
        }
        // Listen for keyboard navigation
        // Shouldn't need to use inProgress interval because of key repeat
        this.on('keydown', handleActivity);
        this.on('keyup', handleActivity);
        // Run an interval every 250 milliseconds instead of stuffing everything into
        // the mousemove/touchmove function itself, to prevent performance degradation.
        // `this.reportUserActivity` simply sets this.userActivity_ to true, which
        // then gets picked up by this loop
        // http://ejohn.org/blog/learning-from-twitter/
        let inactivityTimeout;
        /** @this Player */ const activityCheck = function() {
            // Check to see if mouse/touch activity has happened
            if (!this.userActivity_) return;
            // Reset the activity tracker
            this.userActivity_ = false;
            // If the user state was inactive, set the state to active
            this.userActive(true);
            // Clear any existing inactivity timeout to start the timer over
            this.clearTimeout(inactivityTimeout);
            const timeout = this.options_.inactivityTimeout;
            if (timeout <= 0) return;
            // In <timeout> milliseconds, if no more activity has occurred the
            // user will be considered inactive
            inactivityTimeout = this.setTimeout(function() {
                // Protect against the case where the inactivityTimeout can trigger just
                // before the next user activity is picked up by the activity check loop
                // causing a flicker
                if (!this.userActivity_) this.userActive(false);
            }, timeout);
        };
        this.setInterval(activityCheck, 250);
    }
    /**
   * Gets or sets the current playback rate. A playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed
   * playback, for instance.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
   *
   * @param {number} [rate]
   *       New playback rate to set.
   *
   * @return {number|undefined}
   *         - The current playback rate when getting or 1.0
   *         - Nothing when setting
   */ playbackRate(rate) {
        if (rate !== undefined) {
            // NOTE: this.cache_.lastPlaybackRate is set from the tech handler
            // that is registered above
            this.techCall_('setPlaybackRate', rate);
            return;
        }
        if (this.tech_ && this.tech_.featuresPlaybackRate) return this.cache_.lastPlaybackRate || this.techGet_('playbackRate');
        return 1.0;
    }
    /**
   * Gets or sets the current default playback rate. A default playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
   * not the current playbackRate.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
   *
   * @param {number} [rate]
   *       New default playback rate to set.
   *
   * @return {number|undefined}
   *         - The default playback rate when getting or 1.0
   *         - Nothing when setting
   */ defaultPlaybackRate(rate) {
        if (rate !== undefined) return this.techCall_('setDefaultPlaybackRate', rate);
        if (this.tech_ && this.tech_.featuresPlaybackRate) return this.techGet_('defaultPlaybackRate');
        return 1.0;
    }
    /**
   * Gets or sets the audio flag
   *
   * @param {boolean} [bool]
   *        - true signals that this is an audio player
   *        - false signals that this is not an audio player
   *
   * @return {boolean|undefined}
   *         - The current value of isAudio when getting
   *         - Nothing when setting
   */ isAudio(bool) {
        if (bool !== undefined) {
            this.isAudio_ = !!bool;
            return;
        }
        return !!this.isAudio_;
    }
    updatePlayerHeightOnAudioOnlyMode_() {
        const controlBar = this.getChild('ControlBar');
        if (!controlBar || this.audioOnlyCache_.controlBarHeight === controlBar.currentHeight()) return;
        this.audioOnlyCache_.controlBarHeight = controlBar.currentHeight();
        this.height(this.audioOnlyCache_.controlBarHeight);
    }
    enableAudioOnlyUI_() {
        // Update styling immediately to show the control bar so we can get its height
        this.addClass('vjs-audio-only-mode');
        const playerChildren = this.children();
        const controlBar = this.getChild('ControlBar');
        const controlBarHeight = controlBar && controlBar.currentHeight();
        // Hide all player components except the control bar. Control bar components
        // needed only for video are hidden with CSS
        playerChildren.forEach((child)=>{
            if (child === controlBar) return;
            if (child.el_ && !child.hasClass('vjs-hidden')) {
                child.hide();
                this.audioOnlyCache_.hiddenChildren.push(child);
            }
        });
        this.audioOnlyCache_.playerHeight = this.currentHeight();
        this.audioOnlyCache_.controlBarHeight = controlBarHeight;
        this.on('playerresize', this.boundUpdatePlayerHeightOnAudioOnlyMode_);
        // Set the player height the same as the control bar
        this.height(controlBarHeight);
        this.trigger('audioonlymodechange');
    }
    disableAudioOnlyUI_() {
        this.removeClass('vjs-audio-only-mode');
        this.off('playerresize', this.boundUpdatePlayerHeightOnAudioOnlyMode_);
        // Show player components that were previously hidden
        this.audioOnlyCache_.hiddenChildren.forEach((child)=>child.show());
        // Reset player height
        this.height(this.audioOnlyCache_.playerHeight);
        this.trigger('audioonlymodechange');
    }
    /**
   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
   *
   * Setting this to `true` will hide all player components except the control bar,
   * as well as control bar components needed only for video.
   *
   * @param {boolean} [value]
   *         The value to set audioOnlyMode to.
   *
   * @return {Promise|boolean}
   *        A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */ audioOnlyMode(value) {
        if (typeof value !== 'boolean' || value === this.audioOnlyMode_) return this.audioOnlyMode_;
        this.audioOnlyMode_ = value;
        // Enable Audio Only Mode
        if (value) {
            const exitPromises = [];
            // Fullscreen and PiP are not supported in audioOnlyMode, so exit if we need to.
            if (this.isInPictureInPicture()) exitPromises.push(this.exitPictureInPicture());
            if (this.isFullscreen()) exitPromises.push(this.exitFullscreen());
            if (this.audioPosterMode()) exitPromises.push(this.audioPosterMode(false));
            return Promise.all(exitPromises).then(()=>this.enableAudioOnlyUI_());
        }
        // Disable Audio Only Mode
        return Promise.resolve().then(()=>this.disableAudioOnlyUI_());
    }
    enablePosterModeUI_() {
        // Hide the video element and show the poster image to enable posterModeUI
        const tech = this.tech_ && this.tech_;
        tech.hide();
        this.addClass('vjs-audio-poster-mode');
        this.trigger('audiopostermodechange');
    }
    disablePosterModeUI_() {
        // Show the video element and hide the poster image to disable posterModeUI
        const tech = this.tech_ && this.tech_;
        tech.show();
        this.removeClass('vjs-audio-poster-mode');
        this.trigger('audiopostermodechange');
    }
    /**
   * Get the current audioPosterMode state or set audioPosterMode to true or false
   *
   * @param {boolean} [value]
   *         The value to set audioPosterMode to.
   *
   * @return {Promise|boolean}
   *         A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */ audioPosterMode(value) {
        if (typeof value !== 'boolean' || value === this.audioPosterMode_) return this.audioPosterMode_;
        this.audioPosterMode_ = value;
        if (value) {
            if (this.audioOnlyMode()) {
                const audioOnlyModePromise = this.audioOnlyMode(false);
                return audioOnlyModePromise.then(()=>{
                    // enable audio poster mode after audio only mode is disabled
                    this.enablePosterModeUI_();
                });
            }
            return Promise.resolve().then(()=>{
                // enable audio poster mode
                this.enablePosterModeUI_();
            });
        }
        return Promise.resolve().then(()=>{
            // disable audio poster mode
            this.disablePosterModeUI_();
        });
    }
    /**
   * A helper method for adding a {@link TextTrack} to our
   * {@link TextTrackList}.
   *
   * In addition to the W3C settings we allow adding additional info through options.
   *
   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
   *
   * @param {string} [kind]
   *        the kind of TextTrack you are adding
   *
   * @param {string} [label]
   *        the label to give the TextTrack label
   *
   * @param {string} [language]
   *        the language to set on the TextTrack
   *
   * @return {TextTrack|undefined}
   *         the TextTrack that was added or undefined
   *         if there is no tech
   */ addTextTrack(kind, label, language) {
        if (this.tech_) return this.tech_.addTextTrack(kind, label, language);
    }
    /**
   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
   *
   * @param {Object} options
   *        Options to pass to {@link HTMLTrackElement} during creation. See
   *        {@link HTMLTrackElement} for object properties that you should use.
   *
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack will not be removed
   *                                        from the TextTrackList and HtmlTrackElementList
   *                                        after a source change
   *
   * @return {HtmlTrackElement}
   *         the HTMLTrackElement that was created and added
   *         to the HtmlTrackElementList and the remote
   *         TextTrackList
   *
   */ addRemoteTextTrack(options, manualCleanup) {
        if (this.tech_) return this.tech_.addRemoteTextTrack(options, manualCleanup);
    }
    /**
   * Remove a remote {@link TextTrack} from the respective
   * {@link TextTrackList} and {@link HtmlTrackElementList}.
   *
   * @param {Object} track
   *        Remote {@link TextTrack} to remove
   *
   * @return {undefined}
   *         does not return anything
   */ removeRemoteTextTrack(obj = {}) {
        let { track: track } = obj;
        if (!track) track = obj;
        // destructure the input into an object with a track argument, defaulting to arguments[0]
        // default the whole argument to an empty object if nothing was passed in
        if (this.tech_) return this.tech_.removeRemoteTextTrack(track);
    }
    /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object|undefined}
   *         An object with supported media playback quality metrics or undefined if there
   *         is no tech or the tech does not support it.
   */ getVideoPlaybackQuality() {
        return this.techGet_('getVideoPlaybackQuality');
    }
    /**
   * Get video width
   *
   * @return {number}
   *         current video width
   */ videoWidth() {
        return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
    }
    /**
   * Get video height
   *
   * @return {number}
   *         current video height
   */ videoHeight() {
        return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
    }
    /**
   * Set or get the player's language code.
   *
   * Changing the language will trigger
   * [languagechange]{@link Player#event:languagechange}
   * which Components can use to update control text.
   * ClickableComponent will update its control text by default on
   * [languagechange]{@link Player#event:languagechange}.
   *
   * @fires Player#languagechange
   *
   * @param {string} [code]
   *        the language code to set the player to
   *
   * @return {string|undefined}
   *         - The current language code when getting
   *         - Nothing when setting
   */ language(code) {
        if (code === undefined) return this.language_;
        if (this.language_ !== String(code).toLowerCase()) {
            this.language_ = String(code).toLowerCase();
            // during first init, it's possible some things won't be evented
            if ($cb03b711053a4297$var$isEvented(this)) /**
        * fires when the player language change
        *
        * @event Player#languagechange
        * @type {Event}
        */ this.trigger('languagechange');
        }
    }
    /**
   * Get the player's language dictionary
   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
   * Languages specified directly in the player options have precedence
   *
   * @return {Array}
   *         An array of of supported languages
   */ languages() {
        return $cb03b711053a4297$var$merge$1($cb03b711053a4297$var$Player.prototype.options_.languages, this.languages_);
    }
    /**
   * returns a JavaScript object representing the current track
   * information. **DOES not return it as JSON**
   *
   * @return {Object}
   *         Object representing the current of track info
   */ toJSON() {
        const options = $cb03b711053a4297$var$merge$1(this.options_);
        const tracks = options.tracks;
        options.tracks = [];
        for(let i = 0; i < tracks.length; i++){
            let track = tracks[i];
            // deep merge tracks and null out player so no circular references
            track = $cb03b711053a4297$var$merge$1(track);
            track.player = undefined;
            options.tracks[i] = track;
        }
        return options;
    }
    /**
   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
   * component) that immediately overlays the player with arbitrary
   * content and removes itself when closed.
   *
   * @param {string|Function|Element|Array|null} content
   *        Same as {@link ModalDialog#content}'s param of the same name.
   *        The most straight-forward usage is to provide a string or DOM
   *        element.
   *
   * @param {Object} [options]
   *        Extra options which will be passed on to the {@link ModalDialog}.
   *
   * @return {ModalDialog}
   *         the {@link ModalDialog} that was created
   */ createModal(content, options) {
        options = options || {};
        options.content = content || '';
        const modal = new $cb03b711053a4297$var$ModalDialog(this, options);
        this.addChild(modal);
        modal.on('dispose', ()=>{
            this.removeChild(modal);
        });
        modal.open();
        return modal;
    }
    /**
   * Change breakpoint classes when the player resizes.
   *
   * @private
   */ updateCurrentBreakpoint_() {
        if (!this.responsive()) return;
        const currentBreakpoint = this.currentBreakpoint();
        const currentWidth = this.currentWidth();
        for(let i = 0; i < $cb03b711053a4297$var$BREAKPOINT_ORDER.length; i++){
            const candidateBreakpoint = $cb03b711053a4297$var$BREAKPOINT_ORDER[i];
            const maxWidth = this.breakpoints_[candidateBreakpoint];
            if (currentWidth <= maxWidth) {
                // The current breakpoint did not change, nothing to do.
                if (currentBreakpoint === candidateBreakpoint) return;
                // Only remove a class if there is a current breakpoint.
                if (currentBreakpoint) this.removeClass($cb03b711053a4297$var$BREAKPOINT_CLASSES[currentBreakpoint]);
                this.addClass($cb03b711053a4297$var$BREAKPOINT_CLASSES[candidateBreakpoint]);
                this.breakpoint_ = candidateBreakpoint;
                break;
            }
        }
    }
    /**
   * Removes the current breakpoint.
   *
   * @private
   */ removeCurrentBreakpoint_() {
        const className = this.currentBreakpointClass();
        this.breakpoint_ = '';
        if (className) this.removeClass(className);
    }
    /**
   * Get or set breakpoints on the player.
   *
   * Calling this method with an object or `true` will remove any previous
   * custom breakpoints and start from the defaults again.
   *
   * @param  {Object|boolean} [breakpoints]
   *         If an object is given, it can be used to provide custom
   *         breakpoints. If `true` is given, will set default breakpoints.
   *         If this argument is not given, will simply return the current
   *         breakpoints.
   *
   * @param  {number} [breakpoints.tiny]
   *         The maximum width for the "vjs-layout-tiny" class.
   *
   * @param  {number} [breakpoints.xsmall]
   *         The maximum width for the "vjs-layout-x-small" class.
   *
   * @param  {number} [breakpoints.small]
   *         The maximum width for the "vjs-layout-small" class.
   *
   * @param  {number} [breakpoints.medium]
   *         The maximum width for the "vjs-layout-medium" class.
   *
   * @param  {number} [breakpoints.large]
   *         The maximum width for the "vjs-layout-large" class.
   *
   * @param  {number} [breakpoints.xlarge]
   *         The maximum width for the "vjs-layout-x-large" class.
   *
   * @param  {number} [breakpoints.huge]
   *         The maximum width for the "vjs-layout-huge" class.
   *
   * @return {Object}
   *         An object mapping breakpoint names to maximum width values.
   */ breakpoints(breakpoints) {
        // Used as a getter.
        if (breakpoints === undefined) return Object.assign(this.breakpoints_);
        this.breakpoint_ = '';
        this.breakpoints_ = Object.assign({}, $cb03b711053a4297$var$DEFAULT_BREAKPOINTS, breakpoints);
        // When breakpoint definitions change, we need to update the currently
        // selected breakpoint.
        this.updateCurrentBreakpoint_();
        // Clone the breakpoints before returning.
        return Object.assign(this.breakpoints_);
    }
    /**
   * Get or set a flag indicating whether or not this player should adjust
   * its UI based on its dimensions.
   *
   * @param  {boolean} [value]
   *         Should be `true` if the player should adjust its UI based on its
   *         dimensions; otherwise, should be `false`.
   *
   * @return {boolean|undefined}
   *         Will be `true` if this player should adjust its UI based on its
   *         dimensions; otherwise, will be `false`.
   *         Nothing if setting
   */ responsive(value) {
        // Used as a getter.
        if (value === undefined) return this.responsive_;
        value = Boolean(value);
        const current = this.responsive_;
        // Nothing changed.
        if (value === current) return;
        // The value actually changed, set it.
        this.responsive_ = value;
        // Start listening for breakpoints and set the initial breakpoint if the
        // player is now responsive.
        if (value) {
            this.on('playerresize', this.boundUpdateCurrentBreakpoint_);
            this.updateCurrentBreakpoint_();
        // Stop listening for breakpoints if the player is no longer responsive.
        } else {
            this.off('playerresize', this.boundUpdateCurrentBreakpoint_);
            this.removeCurrentBreakpoint_();
        }
        return value;
    }
    /**
   * Get current breakpoint name, if any.
   *
   * @return {string}
   *         If there is currently a breakpoint set, returns a the key from the
   *         breakpoints object matching it. Otherwise, returns an empty string.
   */ currentBreakpoint() {
        return this.breakpoint_;
    }
    /**
   * Get the current breakpoint class name.
   *
   * @return {string}
   *         The matching class name (e.g. `"vjs-layout-tiny"` or
   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
   *         there is no current breakpoint.
   */ currentBreakpointClass() {
        return $cb03b711053a4297$var$BREAKPOINT_CLASSES[this.breakpoint_] || '';
    }
    /**
   * An object that describes a single piece of media.
   *
   * Properties that are not part of this type description will be retained; so,
   * this can be viewed as a generic metadata storage mechanism as well.
   *
   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
   * @typedef  {Object} Player~MediaObject
   *
   * @property {string} [album]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {string} [artist]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [artwork]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API. If not specified, will be populated via the `poster`, if
   *           available.
   *
   * @property {string} [poster]
   *           URL to an image that will display before playback.
   *
   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
   *           A single source object, an array of source objects, or a string
   *           referencing a URL to a media source. It is _highly recommended_
   *           that an object or array of objects is used here, so that source
   *           selection algorithms can take the `type` into account.
   *
   * @property {string} [title]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [textTracks]
   *           An array of objects to be used to create text tracks, following
   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
   *           For ease of removal, these will be created as "remote" text
   *           tracks and set to automatically clean up on source changes.
   *
   *           These objects may have properties like `src`, `kind`, `label`,
   *           and `language`, see {@link Tech#createRemoteTextTrack}.
   */ /**
   * Populate the player using a {@link Player~MediaObject|MediaObject}.
   *
   * @param  {Player~MediaObject} media
   *         A media object.
   *
   * @param  {Function} ready
   *         A callback to be called when the player is ready.
   */ loadMedia(media, ready) {
        if (!media || typeof media !== 'object') return;
        const crossOrigin = this.crossOrigin();
        this.reset();
        // Clone the media object so it cannot be mutated from outside.
        this.cache_.media = $cb03b711053a4297$var$merge$1(media);
        const { artist: artist, artwork: artwork, description: description, poster: poster, src: src, textTracks: textTracks, title: title } = this.cache_.media;
        // If `artwork` is not given, create it using `poster`.
        if (!artwork && poster) this.cache_.media.artwork = [
            {
                src: poster,
                type: $cb03b711053a4297$var$getMimetype(poster)
            }
        ];
        if (crossOrigin) this.crossOrigin(crossOrigin);
        if (src) this.src(src);
        if (poster) this.poster(poster);
        if (Array.isArray(textTracks)) textTracks.forEach((tt)=>this.addRemoteTextTrack(tt, false));
        if (this.titleBar) this.titleBar.update({
            title: title,
            description: description || artist || ''
        });
        this.ready(ready);
    }
    /**
   * Get a clone of the current {@link Player~MediaObject} for this player.
   *
   * If the `loadMedia` method has not been used, will attempt to return a
   * {@link Player~MediaObject} based on the current state of the player.
   *
   * @return {Player~MediaObject}
   */ getMedia() {
        if (!this.cache_.media) {
            const poster = this.poster();
            const src = this.currentSources();
            const textTracks = Array.prototype.map.call(this.remoteTextTracks(), (tt)=>({
                    kind: tt.kind,
                    label: tt.label,
                    language: tt.language,
                    src: tt.src
                }));
            const media = {
                src: src,
                textTracks: textTracks
            };
            if (poster) {
                media.poster = poster;
                media.artwork = [
                    {
                        src: media.poster,
                        type: $cb03b711053a4297$var$getMimetype(media.poster)
                    }
                ];
            }
            return media;
        }
        return $cb03b711053a4297$var$merge$1(this.cache_.media);
    }
    /**
   * Gets tag settings
   *
   * @param {Element} tag
   *        The player tag
   *
   * @return {Object}
   *         An object containing all of the settings
   *         for a player tag
   */ static getTagSettings(tag) {
        const baseOptions = {
            sources: [],
            tracks: []
        };
        const tagOptions = $cb03b711053a4297$var$getAttributes(tag);
        const dataSetup = tagOptions['data-setup'];
        if ($cb03b711053a4297$var$hasClass(tag, 'vjs-fill')) tagOptions.fill = true;
        if ($cb03b711053a4297$var$hasClass(tag, 'vjs-fluid')) tagOptions.fluid = true;
        // Check if data-setup attr exists.
        if (dataSetup !== null) // Parse options JSON
        try {
            // If empty string, make it a parsable json object.
            Object.assign(tagOptions, JSON.parse(dataSetup || '{}'));
        } catch (e) {
            $cb03b711053a4297$var$log$1.error('data-setup', e);
        }
        Object.assign(baseOptions, tagOptions);
        // Get tag children settings
        if (tag.hasChildNodes()) {
            const children = tag.childNodes;
            for(let i = 0, j = children.length; i < j; i++){
                const child = children[i];
                // Change case needed: http://ejohn.org/blog/nodename-case-sensitivity/
                const childName = child.nodeName.toLowerCase();
                if (childName === 'source') baseOptions.sources.push($cb03b711053a4297$var$getAttributes(child));
                else if (childName === 'track') baseOptions.tracks.push($cb03b711053a4297$var$getAttributes(child));
            }
        }
        return baseOptions;
    }
    /**
   * Set debug mode to enable/disable logs at info level.
   *
   * @param {boolean} enabled
   * @fires Player#debugon
   * @fires Player#debugoff
   * @return {boolean|undefined}
   */ debug(enabled) {
        if (enabled === undefined) return this.debugEnabled_;
        if (enabled) {
            this.trigger('debugon');
            this.previousLogLevel_ = this.log.level;
            this.log.level('debug');
            this.debugEnabled_ = true;
        } else {
            this.trigger('debugoff');
            this.log.level(this.previousLogLevel_);
            this.previousLogLevel_ = undefined;
            this.debugEnabled_ = false;
        }
    }
    /**
   * Set or get current playback rates.
   * Takes an array and updates the playback rates menu with the new items.
   * Pass in an empty array to hide the menu.
   * Values other than arrays are ignored.
   *
   * @fires Player#playbackrateschange
   * @param {number[]} [newRates]
   *                   The new rates that the playback rates menu should update to.
   *                   An empty array will hide the menu
   * @return {number[]} When used as a getter will return the current playback rates
   */ playbackRates(newRates) {
        if (newRates === undefined) return this.cache_.playbackRates;
        // ignore any value that isn't an array
        if (!Array.isArray(newRates)) return;
        // ignore any arrays that don't only contain numbers
        if (!newRates.every((rate)=>typeof rate === 'number')) return;
        this.cache_.playbackRates = newRates;
        /**
    * fires when the playback rates in a player are changed
    *
    * @event Player#playbackrateschange
    * @type {Event}
    */ this.trigger('playbackrateschange');
    }
}
/**
 * Get the {@link VideoTrackList}
 *
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
 *
 * @return {VideoTrackList}
 *         the current video track list
 *
 * @method Player.prototype.videoTracks
 */ $cb03b711053a4297$var$Player.prototype.videoTracks = ()=>{};
/**
 * Get the {@link AudioTrackList}
 *
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
 *
 * @return {AudioTrackList}
 *         the current audio track list
 *
 * @method Player.prototype.audioTracks
 */ $cb03b711053a4297$var$Player.prototype.audioTracks = ()=>{};
/**
 * Get the {@link TextTrackList}
 *
 * @link http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
 *
 * @return {TextTrackList}
 *         the current text track list
 *
 * @method Player.prototype.textTracks
 */ $cb03b711053a4297$var$Player.prototype.textTracks = ()=>{};
/**
 * Get the remote {@link TextTrackList}
 *
 * @return {TextTrackList}
 *         The current remote text track list
 *
 * @method Player.prototype.remoteTextTracks
 */ $cb03b711053a4297$var$Player.prototype.remoteTextTracks = ()=>{};
/**
 * Get the remote {@link HtmlTrackElementList} tracks.
 *
 * @return {HtmlTrackElementList}
 *         The current remote text track element list
 *
 * @method Player.prototype.remoteTextTrackEls
 */ $cb03b711053a4297$var$Player.prototype.remoteTextTrackEls = ()=>{};
$cb03b711053a4297$var$ALL.names.forEach(function(name) {
    const props = $cb03b711053a4297$var$ALL[name];
    $cb03b711053a4297$var$Player.prototype[props.getterName] = function() {
        if (this.tech_) return this.tech_[props.getterName]();
        // if we have not yet loadTech_, we create {video,audio,text}Tracks_
        // these will be passed to the tech during loading
        this[props.privateName] = this[props.privateName] || new props.ListClass();
        return this[props.privateName];
    };
});
/**
 * Get or set the `Player`'s crossorigin option. For the HTML5 player, this
 * sets the `crossOrigin` property on the `<video>` tag to control the CORS
 * behavior.
 *
 * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
 *
 * @param {string} [value]
 *        The value to set the `Player`'s crossorigin to. If an argument is
 *        given, must be one of `anonymous` or `use-credentials`.
 *
 * @return {string|undefined}
 *         - The current crossorigin value of the `Player` when getting.
 *         - undefined when setting
 */ $cb03b711053a4297$var$Player.prototype.crossorigin = $cb03b711053a4297$var$Player.prototype.crossOrigin;
/**
 * Global enumeration of players.
 *
 * The keys are the player IDs and the values are either the {@link Player}
 * instance or `null` for disposed players.
 *
 * @type {Object}
 */ $cb03b711053a4297$var$Player.players = {};
const $cb03b711053a4297$var$navigator = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator;
/*
 * Player instance options, surfaced using options
 * options = Player.prototype.options_
 * Make changes in options, not here.
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$Player.prototype.options_ = {
    // Default order of fallback technology
    techOrder: $cb03b711053a4297$var$Tech.defaultTechOrder_,
    html5: {},
    // enable sourceset by default
    enableSourceset: true,
    // default inactivity timeout
    inactivityTimeout: 2000,
    // default playback rates
    playbackRates: [],
    // Add playback rate selection by adding rates
    // 'playbackRates': [0.5, 1, 1.5, 2],
    liveui: false,
    // Included control sets
    children: [
        'mediaLoader',
        'posterImage',
        'titleBar',
        'textTrackDisplay',
        'loadingSpinner',
        'bigPlayButton',
        'liveTracker',
        'controlBar',
        'errorDisplay',
        'textTrackSettings',
        'resizeManager'
    ],
    language: $cb03b711053a4297$var$navigator && ($cb03b711053a4297$var$navigator.languages && $cb03b711053a4297$var$navigator.languages[0] || $cb03b711053a4297$var$navigator.userLanguage || $cb03b711053a4297$var$navigator.language) || 'en',
    // locales and their language translations
    languages: {},
    // Default message to show when a video cannot be played.
    notSupportedMessage: 'No compatible source was found for this media.',
    normalizeAutoplay: false,
    fullscreen: {
        options: {
            navigationUI: 'hide'
        }
    },
    breakpoints: {},
    responsive: false,
    audioOnlyMode: false,
    audioPosterMode: false,
    spatialNavigation: {
        enabled: false,
        horizontalSeek: false
    },
    // Default smooth seeking to false
    enableSmoothSeeking: false,
    disableSeekWhileScrubbingOnMobile: false,
    disableSeekWhileScrubbingOnSTV: false
};
$cb03b711053a4297$var$TECH_EVENTS_RETRIGGER.forEach(function(event) {
    $cb03b711053a4297$var$Player.prototype[`handleTech${$cb03b711053a4297$var$toTitleCase$1(event)}_`] = function() {
        return this.trigger(event);
    };
});
/**
 * Fired when the player has initial duration and dimension information
 *
 * @event Player#loadedmetadata
 * @type {Event}
 */ /**
 * Fired when the player has downloaded data at the current playback position
 *
 * @event Player#loadeddata
 * @type {Event}
 */ /**
 * Fired when the current playback position has changed *
 * During playback this is fired every 15-250 milliseconds, depending on the
 * playback technology in use.
 *
 * @event Player#timeupdate
 * @type {Event}
 */ /**
 * Fired when the volume changes
 *
 * @event Player#volumechange
 * @type {Event}
 */ $cb03b711053a4297$var$Component$1.registerComponent('Player', $cb03b711053a4297$var$Player);
/**
 * @file plugin.js
 */ /**
 * The base plugin name.
 *
 * @private
 * @constant
 * @type {string}
 */ const $cb03b711053a4297$var$BASE_PLUGIN_NAME = 'plugin';
/**
 * The key on which a player's active plugins cache is stored.
 *
 * @private
 * @constant
 * @type     {string}
 */ const $cb03b711053a4297$var$PLUGIN_CACHE_KEY = 'activePlugins_';
/**
 * Stores registered plugins in a private space.
 *
 * @private
 * @type    {Object}
 */ const $cb03b711053a4297$var$pluginStorage = {};
/**
 * Reports whether or not a plugin has been registered.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @return {boolean}
 *          Whether or not the plugin has been registered.
 */ const $cb03b711053a4297$var$pluginExists = (name)=>$cb03b711053a4297$var$pluginStorage.hasOwnProperty(name);
/**
 * Get a single registered plugin by name.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @return {typeof Plugin|Function|undefined}
 *          The plugin (or undefined).
 */ const $cb03b711053a4297$var$getPlugin = (name)=>$cb03b711053a4297$var$pluginExists(name) ? $cb03b711053a4297$var$pluginStorage[name] : undefined;
/**
 * Marks a plugin as "active" on a player.
 *
 * Also, ensures that the player has an object for tracking active plugins.
 *
 * @private
 * @param   {Player} player
 *          A Video.js player instance.
 *
 * @param   {string} name
 *          The name of a plugin.
 */ const $cb03b711053a4297$var$markPluginAsActive = (player, name)=>{
    player[$cb03b711053a4297$var$PLUGIN_CACHE_KEY] = player[$cb03b711053a4297$var$PLUGIN_CACHE_KEY] || {};
    player[$cb03b711053a4297$var$PLUGIN_CACHE_KEY][name] = true;
};
/**
 * Triggers a pair of plugin setup events.
 *
 * @private
 * @param  {Player} player
 *         A Video.js player instance.
 *
 * @param  {PluginEventHash} hash
 *         A plugin event hash.
 *
 * @param  {boolean} [before]
 *         If true, prefixes the event name with "before". In other words,
 *         use this to trigger "beforepluginsetup" instead of "pluginsetup".
 */ const $cb03b711053a4297$var$triggerSetupEvent = (player, hash, before)=>{
    const eventName = (before ? 'before' : '') + 'pluginsetup';
    player.trigger(eventName, hash);
    player.trigger(eventName + ':' + hash.name, hash);
};
/**
 * Takes a basic plugin function and returns a wrapper function which marks
 * on the player that the plugin has been activated.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Function} plugin
 *          The basic plugin.
 *
 * @return {Function}
 *          A wrapper function for the given plugin.
 */ const $cb03b711053a4297$var$createBasicPlugin = function(name, plugin) {
    const basicPluginWrapper = function() {
        // We trigger the "beforepluginsetup" and "pluginsetup" events on the player
        // regardless, but we want the hash to be consistent with the hash provided
        // for advanced plugins.
        //
        // The only potentially counter-intuitive thing here is the `instance` in
        // the "pluginsetup" event is the value returned by the `plugin` function.
        $cb03b711053a4297$var$triggerSetupEvent(this, {
            name: name,
            plugin: plugin,
            instance: null
        }, true);
        const instance = plugin.apply(this, arguments);
        $cb03b711053a4297$var$markPluginAsActive(this, name);
        $cb03b711053a4297$var$triggerSetupEvent(this, {
            name: name,
            plugin: plugin,
            instance: instance
        });
        return instance;
    };
    Object.keys(plugin).forEach(function(prop) {
        basicPluginWrapper[prop] = plugin[prop];
    });
    return basicPluginWrapper;
};
/**
 * Takes a plugin sub-class and returns a factory function for generating
 * instances of it.
 *
 * This factory function will replace itself with an instance of the requested
 * sub-class of Plugin.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Plugin} PluginSubClass
 *          The advanced plugin.
 *
 * @return {Function}
 */ const $cb03b711053a4297$var$createPluginFactory = (name, PluginSubClass)=>{
    // Add a `name` property to the plugin prototype so that each plugin can
    // refer to itself by name.
    PluginSubClass.prototype.name = name;
    return function(...args) {
        $cb03b711053a4297$var$triggerSetupEvent(this, {
            name: name,
            plugin: PluginSubClass,
            instance: null
        }, true);
        const instance = new PluginSubClass(...[
            this,
            ...args
        ]);
        // The plugin is replaced by a function that returns the current instance.
        this[name] = ()=>instance;
        $cb03b711053a4297$var$triggerSetupEvent(this, instance.getEventHash());
        return instance;
    };
};
/**
 * Parent class for all advanced plugins.
 *
 * @mixes   module:evented~EventedMixin
 * @mixes   module:stateful~StatefulMixin
 * @fires   Player#beforepluginsetup
 * @fires   Player#beforepluginsetup:$name
 * @fires   Player#pluginsetup
 * @fires   Player#pluginsetup:$name
 * @listens Player#dispose
 * @throws  {Error}
 *          If attempting to instantiate the base {@link Plugin} class
 *          directly instead of via a sub-class.
 */ class $cb03b711053a4297$var$Plugin {
    /**
   * Creates an instance of this class.
   *
   * Sub-classes should call `super` to ensure plugins are properly initialized.
   *
   * @param {Player} player
   *        A Video.js player instance.
   */ constructor(player){
        if (this.constructor === $cb03b711053a4297$var$Plugin) throw new Error('Plugin must be sub-classed; not directly instantiated.');
        this.player = player;
        if (!this.log) this.log = this.player.log.createLogger(this.name);
        // Make this object evented, but remove the added `trigger` method so we
        // use the prototype version instead.
        $cb03b711053a4297$var$evented(this);
        delete this.trigger;
        $cb03b711053a4297$var$stateful(this, this.constructor.defaultState);
        $cb03b711053a4297$var$markPluginAsActive(player, this.name);
        // Auto-bind the dispose method so we can use it as a listener and unbind
        // it later easily.
        this.dispose = this.dispose.bind(this);
        // If the player is disposed, dispose the plugin.
        player.on('dispose', this.dispose);
    }
    /**
   * Get the version of the plugin that was set on <pluginName>.VERSION
   */ version() {
        return this.constructor.VERSION;
    }
    /**
   * Each event triggered by plugins includes a hash of additional data with
   * conventional properties.
   *
   * This returns that object or mutates an existing hash.
   *
   * @param   {Object} [hash={}]
   *          An object to be used as event an event hash.
   *
   * @return {PluginEventHash}
   *          An event hash object with provided properties mixed-in.
   */ getEventHash(hash = {}) {
        hash.name = this.name;
        hash.plugin = this.constructor;
        hash.instance = this;
        return hash;
    }
    /**
   * Triggers an event on the plugin object and overrides
   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash={}]
   *          Additional data hash to merge with a
   *          {@link PluginEventHash|PluginEventHash}.
   *
   * @return {boolean}
   *          Whether or not default was prevented.
   */ trigger(event, hash = {}) {
        return $cb03b711053a4297$var$trigger(this.eventBusEl_, event, this.getEventHash(hash));
    }
    /**
   * Handles "statechanged" events on the plugin. No-op by default, override by
   * subclassing.
   *
   * @abstract
   * @param    {Event} e
   *           An event object provided by a "statechanged" event.
   *
   * @param    {Object} e.changes
   *           An object describing changes that occurred with the "statechanged"
   *           event.
   */ handleStateChanged(e) {}
    /**
   * Disposes a plugin.
   *
   * Subclasses can override this if they want, but for the sake of safety,
   * it's probably best to subscribe the "dispose" event.
   *
   * @fires Plugin#dispose
   */ dispose() {
        const { name: name, player: player } = this;
        /**
     * Signals that a advanced plugin is about to be disposed.
     *
     * @event Plugin#dispose
     * @type  {Event}
     */ this.trigger('dispose');
        this.off();
        player.off('dispose', this.dispose);
        // Eliminate any possible sources of leaking memory by clearing up
        // references between the player and the plugin instance and nulling out
        // the plugin's state and replacing methods with a function that throws.
        player[$cb03b711053a4297$var$PLUGIN_CACHE_KEY][name] = false;
        this.player = this.state = null;
        // Finally, replace the plugin name on the player with a new factory
        // function, so that the plugin is ready to be set up again.
        player[name] = $cb03b711053a4297$var$createPluginFactory(name, $cb03b711053a4297$var$pluginStorage[name]);
    }
    /**
   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
   *
   * @param   {string|Function} plugin
   *          If a string, matches the name of a plugin. If a function, will be
   *          tested directly.
   *
   * @return {boolean}
   *          Whether or not a plugin is a basic plugin.
   */ static isBasic(plugin) {
        const p = typeof plugin === 'string' ? $cb03b711053a4297$var$getPlugin(plugin) : plugin;
        return typeof p === 'function' && !$cb03b711053a4297$var$Plugin.prototype.isPrototypeOf(p.prototype);
    }
    /**
   * Register a Video.js plugin.
   *
   * @param   {string} name
   *          The name of the plugin to be registered. Must be a string and
   *          must not match an existing plugin or a method on the `Player`
   *          prototype.
   *
   * @param   {typeof Plugin|Function} plugin
   *          A sub-class of `Plugin` or a function for basic plugins.
   *
   * @return {typeof Plugin|Function}
   *          For advanced plugins, a factory function for that plugin. For
   *          basic plugins, a wrapper function that initializes the plugin.
   */ static registerPlugin(name, plugin) {
        if (typeof name !== 'string') throw new Error(`Illegal plugin name, "${name}", must be a string, was ${typeof name}.`);
        if ($cb03b711053a4297$var$pluginExists(name)) $cb03b711053a4297$var$log$1.warn(`A plugin named "${name}" already exists. You may want to avoid re-registering plugins!`);
        else if ($cb03b711053a4297$var$Player.prototype.hasOwnProperty(name)) throw new Error(`Illegal plugin name, "${name}", cannot share a name with an existing player method!`);
        if (typeof plugin !== 'function') throw new Error(`Illegal plugin for "${name}", must be a function, was ${typeof plugin}.`);
        $cb03b711053a4297$var$pluginStorage[name] = plugin;
        // Add a player prototype method for all sub-classed plugins (but not for
        // the base Plugin class).
        if (name !== $cb03b711053a4297$var$BASE_PLUGIN_NAME) {
            if ($cb03b711053a4297$var$Plugin.isBasic(plugin)) $cb03b711053a4297$var$Player.prototype[name] = $cb03b711053a4297$var$createBasicPlugin(name, plugin);
            else $cb03b711053a4297$var$Player.prototype[name] = $cb03b711053a4297$var$createPluginFactory(name, plugin);
        }
        return plugin;
    }
    /**
   * De-register a Video.js plugin.
   *
   * @param  {string} name
   *         The name of the plugin to be de-registered. Must be a string that
   *         matches an existing plugin.
   *
   * @throws {Error}
   *         If an attempt is made to de-register the base plugin.
   */ static deregisterPlugin(name) {
        if (name === $cb03b711053a4297$var$BASE_PLUGIN_NAME) throw new Error('Cannot de-register base plugin.');
        if ($cb03b711053a4297$var$pluginExists(name)) {
            delete $cb03b711053a4297$var$pluginStorage[name];
            delete $cb03b711053a4297$var$Player.prototype[name];
        }
    }
    /**
   * Gets an object containing multiple Video.js plugins.
   *
   * @param   {Array} [names]
   *          If provided, should be an array of plugin names. Defaults to _all_
   *          plugin names.
   *
   * @return {Object|undefined}
   *          An object containing plugin(s) associated with their name(s) or
   *          `undefined` if no matching plugins exist).
   */ static getPlugins(names = Object.keys($cb03b711053a4297$var$pluginStorage)) {
        let result;
        names.forEach((name)=>{
            const plugin = $cb03b711053a4297$var$getPlugin(name);
            if (plugin) {
                result = result || {};
                result[name] = plugin;
            }
        });
        return result;
    }
    /**
   * Gets a plugin's version, if available
   *
   * @param   {string} name
   *          The name of a plugin.
   *
   * @return {string}
   *          The plugin's version or an empty string.
   */ static getPluginVersion(name) {
        const plugin = $cb03b711053a4297$var$getPlugin(name);
        return plugin && plugin.VERSION || '';
    }
}
/**
 * Gets a plugin by name if it exists.
 *
 * @static
 * @method   getPlugin
 * @memberOf Plugin
 * @param    {string} name
 *           The name of a plugin.
 *
 * @returns  {typeof Plugin|Function|undefined}
 *           The plugin (or `undefined`).
 */ $cb03b711053a4297$var$Plugin.getPlugin = $cb03b711053a4297$var$getPlugin;
/**
 * The name of the base plugin class as it is registered.
 *
 * @type {string}
 */ $cb03b711053a4297$var$Plugin.BASE_PLUGIN_NAME = $cb03b711053a4297$var$BASE_PLUGIN_NAME;
$cb03b711053a4297$var$Plugin.registerPlugin($cb03b711053a4297$var$BASE_PLUGIN_NAME, $cb03b711053a4297$var$Plugin);
/**
 * Documented in player.js
 *
 * @ignore
 */ $cb03b711053a4297$var$Player.prototype.usingPlugin = function(name) {
    return !!this[$cb03b711053a4297$var$PLUGIN_CACHE_KEY] && this[$cb03b711053a4297$var$PLUGIN_CACHE_KEY][name] === true;
};
/**
 * Documented in player.js
 *
 * @ignore
 */ $cb03b711053a4297$var$Player.prototype.hasPlugin = function(name) {
    return !!$cb03b711053a4297$var$pluginExists(name);
};
/**
 * Signals that a plugin is about to be set up on a player.
 *
 * @event    Player#beforepluginsetup
 * @type     {PluginEventHash}
 */ /**
 * Signals that a plugin is about to be set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#beforepluginsetup:$name
 * @type     {PluginEventHash}
 */ /**
 * Signals that a plugin has just been set up on a player.
 *
 * @event    Player#pluginsetup
 * @type     {PluginEventHash}
 */ /**
 * Signals that a plugin has just been set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#pluginsetup:$name
 * @type     {PluginEventHash}
 */ /**
 * @typedef  {Object} PluginEventHash
 *
 * @property {string} instance
 *           For basic plugins, the return value of the plugin function. For
 *           advanced plugins, the plugin instance on which the event is fired.
 *
 * @property {string} name
 *           The name of the plugin.
 *
 * @property {string} plugin
 *           For basic plugins, the plugin function. For advanced plugins, the
 *           plugin class/constructor.
 */ /**
 * @file deprecate.js
 * @module deprecate
 */ /**
 * Decorate a function with a deprecation message the first time it is called.
 *
 * @param  {string}   message
 *         A deprecation message to log the first time the returned function
 *         is called.
 *
 * @param  {Function} fn
 *         The function to be deprecated.
 *
 * @return {Function}
 *         A wrapper function that will log a deprecation warning the first
 *         time it is called. The return value will be the return value of
 *         the wrapped function.
 */ function $cb03b711053a4297$var$deprecate(message, fn) {
    let warned = false;
    return function(...args) {
        if (!warned) $cb03b711053a4297$var$log$1.warn(message);
        warned = true;
        return fn.apply(this, args);
    };
}
/**
 * Internal function used to mark a function as deprecated in the next major
 * version with consistent messaging.
 *
 * @param  {number}   major   The major version where it will be removed
 * @param  {string}   oldName The old function name
 * @param  {string}   newName The new function name
 * @param  {Function} fn      The function to deprecate
 * @return {Function}         The decorated function
 */ function $cb03b711053a4297$var$deprecateForMajor(major, oldName, newName, fn) {
    return $cb03b711053a4297$var$deprecate(`${oldName} is deprecated and will be removed in ${major}.0; please use ${newName} instead.`, fn);
}
var $cb03b711053a4297$var$VjsErrors = {
    NetworkBadStatus: 'networkbadstatus',
    NetworkRequestFailed: 'networkrequestfailed',
    NetworkRequestAborted: 'networkrequestaborted',
    NetworkRequestTimeout: 'networkrequesttimeout',
    NetworkBodyParserFailed: 'networkbodyparserfailed',
    StreamingHlsPlaylistParserError: 'streaminghlsplaylistparsererror',
    StreamingDashManifestParserError: 'streamingdashmanifestparsererror',
    StreamingContentSteeringParserError: 'streamingcontentsteeringparsererror',
    StreamingVttParserError: 'streamingvttparsererror',
    StreamingFailedToSelectNextSegment: 'streamingfailedtoselectnextsegment',
    StreamingFailedToDecryptSegment: 'streamingfailedtodecryptsegment',
    StreamingFailedToTransmuxSegment: 'streamingfailedtotransmuxsegment',
    StreamingFailedToAppendSegment: 'streamingfailedtoappendsegment',
    StreamingCodecsChangeError: 'streamingcodecschangeerror'
};
/**
 * @file video.js
 * @module videojs
 */ /** @import { PlayerReadyCallback } from './player' */ /**
 * Normalize an `id` value by trimming off a leading `#`
 *
 * @private
 * @param   {string} id
 *          A string, maybe with a leading `#`.
 *
 * @return {string}
 *          The string, without any leading `#`.
 */ const $cb03b711053a4297$var$normalizeId = (id)=>id.indexOf('#') === 0 ? id.slice(1) : id;
/**
 * The `videojs()` function doubles as the main function for users to create a
 * {@link Player} instance as well as the main library namespace.
 *
 * It can also be used as a getter for a pre-existing {@link Player} instance.
 * However, we _strongly_ recommend using `videojs.getPlayer()` for this
 * purpose because it avoids any potential for unintended initialization.
 *
 * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
 * of our JSDoc template, we cannot properly document this as both a function
 * and a namespace, so its function signature is documented here.
 *
 * #### Arguments
 * ##### id
 * string|Element, **required**
 *
 * Video element or video element ID.
 *
 * ##### options
 * Object, optional
 *
 * Options object for providing settings.
 * See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
 *
 * ##### ready
 * {@link Component~ReadyCallback}, optional
 *
 * A function to be called when the {@link Player} and {@link Tech} are ready.
 *
 * #### Return Value
 *
 * The `videojs()` function returns a {@link Player} instance.
 *
 * @namespace
 *
 * @borrows AudioTrack as AudioTrack
 * @borrows Component.getComponent as getComponent
 * @borrows module:events.on as on
 * @borrows module:events.one as one
 * @borrows module:events.off as off
 * @borrows module:events.trigger as trigger
 * @borrows EventTarget as EventTarget
 * @borrows module:middleware.use as use
 * @borrows Player.players as players
 * @borrows Plugin.registerPlugin as registerPlugin
 * @borrows Plugin.deregisterPlugin as deregisterPlugin
 * @borrows Plugin.getPlugins as getPlugins
 * @borrows Plugin.getPlugin as getPlugin
 * @borrows Plugin.getPluginVersion as getPluginVersion
 * @borrows Tech.getTech as getTech
 * @borrows Tech.registerTech as registerTech
 * @borrows TextTrack as TextTrack
 * @borrows VideoTrack as VideoTrack
 *
 * @param  {string|Element} id
 *         Video element or video element ID.
 *
 * @param  {Object} [options]
 *         Options object for providing settings.
 *         See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
 *
 * @param  {PlayerReadyCallback} [ready]
 *         A function to be called when the {@link Player} and {@link Tech} are
 *         ready.
 *
 * @return {Player}
 *         The `videojs()` function returns a {@link Player|Player} instance.
 */ function $cb03b711053a4297$export$2e2bcd8739ae039(id, options, ready) {
    let player = $cb03b711053a4297$export$2e2bcd8739ae039.getPlayer(id);
    if (player) {
        if (options) $cb03b711053a4297$var$log$1.warn(`Player "${id}" is already initialised. Options will not be applied.`);
        if (ready) player.ready(ready);
        return player;
    }
    const el = typeof id === 'string' ? $cb03b711053a4297$var$$('#' + $cb03b711053a4297$var$normalizeId(id)) : id;
    if (!$cb03b711053a4297$var$isEl(el)) throw new TypeError('The element or ID supplied is not valid. (videojs)');
    // document.body.contains(el) will only check if el is contained within that one document.
    // This causes problems for elements in iframes.
    // Instead, use the element's ownerDocument instead of the global document.
    // This will make sure that the element is indeed in the dom of that document.
    // Additionally, check that the document in question has a default view.
    // If the document is no longer attached to the dom, the defaultView of the document will be null.
    // If element is inside Shadow DOM (e.g. is part of a Custom element), ownerDocument.body
    // always returns false. Instead, use the Shadow DOM root.
    const inShadowDom = 'getRootNode' in el ? el.getRootNode() instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).ShadowRoot : false;
    const rootNode = inShadowDom ? el.getRootNode() : el.ownerDocument.body;
    if (!el.ownerDocument.defaultView || !rootNode.contains(el)) $cb03b711053a4297$var$log$1.warn('The element supplied is not included in the DOM');
    options = options || {};
    // Store a copy of the el before modification, if it is to be restored in destroy()
    // If div ingest, store the parent div
    if (options.restoreEl === true) options.restoreEl = (el.parentNode && el.parentNode.hasAttribute && el.parentNode.hasAttribute('data-vjs-player') ? el.parentNode : el).cloneNode(true);
    $cb03b711053a4297$var$hooks('beforesetup').forEach((hookFunction)=>{
        const opts = hookFunction(el, $cb03b711053a4297$var$merge$1(options));
        if (!$cb03b711053a4297$var$isObject(opts) || Array.isArray(opts)) {
            $cb03b711053a4297$var$log$1.error('please return an object in beforesetup hooks');
            return;
        }
        options = $cb03b711053a4297$var$merge$1(options, opts);
    });
    // We get the current "Player" component here in case an integration has
    // replaced it with a custom player.
    const PlayerComponent = $cb03b711053a4297$var$Component$1.getComponent('Player');
    player = new PlayerComponent(el, options, ready);
    $cb03b711053a4297$var$hooks('setup').forEach((hookFunction)=>hookFunction(player));
    return player;
}
$cb03b711053a4297$export$2e2bcd8739ae039.hooks_ = $cb03b711053a4297$var$hooks_;
$cb03b711053a4297$export$2e2bcd8739ae039.hooks = $cb03b711053a4297$var$hooks;
$cb03b711053a4297$export$2e2bcd8739ae039.hook = $cb03b711053a4297$var$hook;
$cb03b711053a4297$export$2e2bcd8739ae039.hookOnce = $cb03b711053a4297$var$hookOnce;
$cb03b711053a4297$export$2e2bcd8739ae039.removeHook = $cb03b711053a4297$var$removeHook;
// Add default styles
if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VIDEOJS_NO_DYNAMIC_STYLE !== true && $cb03b711053a4297$var$isReal()) {
    let style = $cb03b711053a4297$var$$('.vjs-styles-defaults');
    if (!style) {
        style = $cb03b711053a4297$var$createStyleElement('vjs-styles-defaults');
        const head = $cb03b711053a4297$var$$('head');
        if (head) head.insertBefore(style, head.firstChild);
        $cb03b711053a4297$var$setTextContent(style, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
    }
}
// Run Auto-load players
// You have to wait at least once in case this script is loaded after your
// video in the DOM (weird behavior only with minified version)
$cb03b711053a4297$var$autoSetupTimeout(1, $cb03b711053a4297$export$2e2bcd8739ae039);
/**
 * Current Video.js version. Follows [semantic versioning](https://semver.org/).
 *
 * @type {string}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.VERSION = $cb03b711053a4297$var$version$6;
/**
 * The global options object. These are the settings that take effect
 * if no overrides are specified when the player is created.
 *
 * @type {Object}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.options = $cb03b711053a4297$var$Player.prototype.options_;
/**
 * Get an object with the currently created players, keyed by player ID
 *
 * @return {Object}
 *         The created players
 */ $cb03b711053a4297$export$2e2bcd8739ae039.getPlayers = ()=>$cb03b711053a4297$var$Player.players;
/**
 * Get a single player based on an ID or DOM element.
 *
 * This is useful if you want to check if an element or ID has an associated
 * Video.js player, but not create one if it doesn't.
 *
 * @param   {string|Element} id
 *          An HTML element - `<video>`, `<audio>`, or `<video-js>` -
 *          or a string matching the `id` of such an element.
 *
 * @return {Player|undefined}
 *          A player instance or `undefined` if there is no player instance
 *          matching the argument.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.getPlayer = (id)=>{
    const players = $cb03b711053a4297$var$Player.players;
    let tag;
    if (typeof id === 'string') {
        const nId = $cb03b711053a4297$var$normalizeId(id);
        const player = players[nId];
        if (player) return player;
        tag = $cb03b711053a4297$var$$('#' + nId);
    } else tag = id;
    if ($cb03b711053a4297$var$isEl(tag)) {
        const { player: player, playerId: playerId } = tag;
        // Element may have a `player` property referring to an already created
        // player instance. If so, return that.
        if (player || players[playerId]) return player || players[playerId];
    }
};
/**
 * Returns an array of all current players.
 *
 * @return {Array}
 *         An array of all players. The array will be in the order that
 *         `Object.keys` provides, which could potentially vary between
 *         JavaScript engines.
 *
 */ $cb03b711053a4297$export$2e2bcd8739ae039.getAllPlayers = ()=>// Disposed players leave a key with a `null` value, so we need to make sure
    // we filter those out.
    Object.keys($cb03b711053a4297$var$Player.players).map((k)=>$cb03b711053a4297$var$Player.players[k]).filter(Boolean);
$cb03b711053a4297$export$2e2bcd8739ae039.players = $cb03b711053a4297$var$Player.players;
$cb03b711053a4297$export$2e2bcd8739ae039.getComponent = $cb03b711053a4297$var$Component$1.getComponent;
/**
 * Register a component so it can referred to by name. Used when adding to other
 * components, either through addChild `component.addChild('myComponent')` or through
 * default children options  `{ children: ['myComponent'] }`.
 *
 * > NOTE: You could also just initialize the component before adding.
 * `component.addChild(new MyComponent());`
 *
 * @param {string} name
 *        The class name of the component
 *
 * @param {typeof Component} comp
 *        The component class
 *
 * @return {typeof Component}
 *         The newly registered component
 */ $cb03b711053a4297$export$2e2bcd8739ae039.registerComponent = (name, comp)=>{
    if ($cb03b711053a4297$var$Tech.isTech(comp)) $cb03b711053a4297$var$log$1.warn(`The ${name} tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)`);
    return $cb03b711053a4297$var$Component$1.registerComponent.call($cb03b711053a4297$var$Component$1, name, comp);
};
$cb03b711053a4297$export$2e2bcd8739ae039.getTech = $cb03b711053a4297$var$Tech.getTech;
$cb03b711053a4297$export$2e2bcd8739ae039.registerTech = $cb03b711053a4297$var$Tech.registerTech;
$cb03b711053a4297$export$2e2bcd8739ae039.use = $cb03b711053a4297$var$use;
/**
 * An object that can be returned by a middleware to signify
 * that the middleware is being terminated.
 *
 * @type {object}
 * @property {object} middleware.TERMINATOR
 */ Object.defineProperty($cb03b711053a4297$export$2e2bcd8739ae039, 'middleware', {
    value: {},
    writeable: false,
    enumerable: true
});
Object.defineProperty($cb03b711053a4297$export$2e2bcd8739ae039.middleware, 'TERMINATOR', {
    value: $cb03b711053a4297$var$TERMINATOR,
    writeable: false,
    enumerable: true
});
/**
 * A reference to the {@link module:browser|browser utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:browser|browser}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.browser = $cb03b711053a4297$var$browser;
/**
 * A reference to the {@link module:obj|obj utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:obj|obj}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.obj = $cb03b711053a4297$var$Obj;
/**
 * Deprecated reference to the {@link module:obj.merge|merge function}
 *
 * @type {Function}
 * @see {@link module:obj.merge|merge}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.obj.merge instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.mergeOptions = $cb03b711053a4297$var$deprecateForMajor(9, 'videojs.mergeOptions', 'videojs.obj.merge', $cb03b711053a4297$var$merge$1);
/**
 * Deprecated reference to the {@link module:obj.defineLazyProperty|defineLazyProperty function}
 *
 * @type {Function}
 * @see {@link module:obj.defineLazyProperty|defineLazyProperty}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.obj.defineLazyProperty instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.defineLazyProperty = $cb03b711053a4297$var$deprecateForMajor(9, 'videojs.defineLazyProperty', 'videojs.obj.defineLazyProperty', $cb03b711053a4297$var$defineLazyProperty);
/**
 * Deprecated reference to the {@link module:fn.bind_|fn.bind_ function}
 *
 * @type {Function}
 * @see {@link module:fn.bind_|fn.bind_}
 * @deprecated Deprecated and will be removed in 9.0. Please use native Function.prototype.bind instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.bind = $cb03b711053a4297$var$deprecateForMajor(9, 'videojs.bind', 'native Function.prototype.bind', $cb03b711053a4297$var$bind_);
$cb03b711053a4297$export$2e2bcd8739ae039.registerPlugin = $cb03b711053a4297$var$Plugin.registerPlugin;
$cb03b711053a4297$export$2e2bcd8739ae039.deregisterPlugin = $cb03b711053a4297$var$Plugin.deregisterPlugin;
/**
 * Deprecated method to register a plugin with Video.js
 *
 * @deprecated Deprecated and will be removed in 9.0. Use videojs.registerPlugin() instead.
 *
 * @param {string} name
 *        The plugin name
*
 * @param {typeof Plugin|Function} plugin
 *         The plugin sub-class or function
 *
 * @return {typeof Plugin|Function}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.plugin = (name, plugin)=>{
    $cb03b711053a4297$var$log$1.warn('videojs.plugin() is deprecated; use videojs.registerPlugin() instead');
    return $cb03b711053a4297$var$Plugin.registerPlugin(name, plugin);
};
$cb03b711053a4297$export$2e2bcd8739ae039.getPlugins = $cb03b711053a4297$var$Plugin.getPlugins;
$cb03b711053a4297$export$2e2bcd8739ae039.getPlugin = $cb03b711053a4297$var$Plugin.getPlugin;
$cb03b711053a4297$export$2e2bcd8739ae039.getPluginVersion = $cb03b711053a4297$var$Plugin.getPluginVersion;
/**
 * Adding languages so that they're available to all players.
 * Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
 *
 * @param {string} code
 *        The language code or dictionary property
 *
 * @param {Object} data
 *        The data values to be translated
 *
 * @return {Object}
 *         The resulting language dictionary object
 */ $cb03b711053a4297$export$2e2bcd8739ae039.addLanguage = function(code, data) {
    code = ('' + code).toLowerCase();
    $cb03b711053a4297$export$2e2bcd8739ae039.options.languages = $cb03b711053a4297$var$merge$1($cb03b711053a4297$export$2e2bcd8739ae039.options.languages, {
        [code]: data
    });
    return $cb03b711053a4297$export$2e2bcd8739ae039.options.languages[code];
};
/**
 * A reference to the {@link module:log|log utility module} as an object.
 *
 * @type {Function}
 * @see  {@link module:log|log}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.log = $cb03b711053a4297$var$log$1;
$cb03b711053a4297$export$2e2bcd8739ae039.createLogger = $cb03b711053a4297$var$createLogger;
/**
 * A reference to the {@link module:time|time utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:time|time}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.time = $cb03b711053a4297$var$Time;
/**
 * Deprecated reference to the {@link module:time.createTimeRanges|createTimeRanges function}
 *
 * @type {Function}
 * @see {@link module:time.createTimeRanges|createTimeRanges}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.createTimeRanges instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.createTimeRange = $cb03b711053a4297$var$deprecateForMajor(9, 'videojs.createTimeRange', 'videojs.time.createTimeRanges', $cb03b711053a4297$var$createTimeRanges$1);
/**
 * Deprecated reference to the {@link module:time.createTimeRanges|createTimeRanges function}
 *
 * @type {Function}
 * @see {@link module:time.createTimeRanges|createTimeRanges}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.createTimeRanges instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.createTimeRanges = $cb03b711053a4297$var$deprecateForMajor(9, 'videojs.createTimeRanges', 'videojs.time.createTimeRanges', $cb03b711053a4297$var$createTimeRanges$1);
/**
 * Deprecated reference to the {@link module:time.formatTime|formatTime function}
 *
 * @type {Function}
 * @see {@link module:time.formatTime|formatTime}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.format instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.formatTime = $cb03b711053a4297$var$deprecateForMajor(9, 'videojs.formatTime', 'videojs.time.formatTime', $cb03b711053a4297$var$formatTime);
/**
 * Deprecated reference to the {@link module:time.setFormatTime|setFormatTime function}
 *
 * @type {Function}
 * @see {@link module:time.setFormatTime|setFormatTime}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.setFormat instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.setFormatTime = $cb03b711053a4297$var$deprecateForMajor(9, 'videojs.setFormatTime', 'videojs.time.setFormatTime', $cb03b711053a4297$var$setFormatTime);
/**
 * Deprecated reference to the {@link module:time.resetFormatTime|resetFormatTime function}
 *
 * @type {Function}
 * @see {@link module:time.resetFormatTime|resetFormatTime}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.resetFormat instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.resetFormatTime = $cb03b711053a4297$var$deprecateForMajor(9, 'videojs.resetFormatTime', 'videojs.time.resetFormatTime', $cb03b711053a4297$var$resetFormatTime);
/**
 * Deprecated reference to the {@link module:url.parseUrl|Url.parseUrl function}
 *
 * @type {Function}
 * @see {@link module:url.parseUrl|parseUrl}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.url.parseUrl instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.parseUrl = $cb03b711053a4297$var$deprecateForMajor(9, 'videojs.parseUrl', 'videojs.url.parseUrl', $cb03b711053a4297$var$parseUrl);
/**
 * Deprecated reference to the {@link module:url.isCrossOrigin|Url.isCrossOrigin function}
 *
 * @type {Function}
 * @see {@link module:url.isCrossOrigin|isCrossOrigin}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.url.isCrossOrigin instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.isCrossOrigin = $cb03b711053a4297$var$deprecateForMajor(9, 'videojs.isCrossOrigin', 'videojs.url.isCrossOrigin', $cb03b711053a4297$var$isCrossOrigin);
$cb03b711053a4297$export$2e2bcd8739ae039.EventTarget = $cb03b711053a4297$var$EventTarget$2;
$cb03b711053a4297$export$2e2bcd8739ae039.any = $cb03b711053a4297$var$any;
$cb03b711053a4297$export$2e2bcd8739ae039.on = $cb03b711053a4297$var$on;
$cb03b711053a4297$export$2e2bcd8739ae039.one = $cb03b711053a4297$var$one;
$cb03b711053a4297$export$2e2bcd8739ae039.off = $cb03b711053a4297$var$off;
$cb03b711053a4297$export$2e2bcd8739ae039.trigger = $cb03b711053a4297$var$trigger;
/**
 * A cross-browser XMLHttpRequest wrapper.
 *
 * @function
 * @param    {Object} options
 *           Settings for the request.
 *
 * @return   {XMLHttpRequest|XDomainRequest}
 *           The request object.
 *
 * @see      https://github.com/Raynos/xhr
 */ $cb03b711053a4297$export$2e2bcd8739ae039.xhr = (0, (/*@__PURE__*/$parcel$interopDefault($hPwoy)));
$cb03b711053a4297$export$2e2bcd8739ae039.TrackList = $cb03b711053a4297$var$TrackList;
$cb03b711053a4297$export$2e2bcd8739ae039.TextTrack = $cb03b711053a4297$var$TextTrack;
$cb03b711053a4297$export$2e2bcd8739ae039.TextTrackList = $cb03b711053a4297$var$TextTrackList;
$cb03b711053a4297$export$2e2bcd8739ae039.AudioTrack = $cb03b711053a4297$var$AudioTrack;
$cb03b711053a4297$export$2e2bcd8739ae039.AudioTrackList = $cb03b711053a4297$var$AudioTrackList;
$cb03b711053a4297$export$2e2bcd8739ae039.VideoTrack = $cb03b711053a4297$var$VideoTrack;
$cb03b711053a4297$export$2e2bcd8739ae039.VideoTrackList = $cb03b711053a4297$var$VideoTrackList;
[
    'isEl',
    'isTextNode',
    'createEl',
    'hasClass',
    'addClass',
    'removeClass',
    'toggleClass',
    'setAttributes',
    'getAttributes',
    'emptyEl',
    'appendContent',
    'insertContent'
].forEach((k)=>{
    $cb03b711053a4297$export$2e2bcd8739ae039[k] = function() {
        $cb03b711053a4297$var$log$1.warn(`videojs.${k}() is deprecated; use videojs.dom.${k}() instead`);
        return $cb03b711053a4297$var$Dom[k].apply(null, arguments);
    };
});
$cb03b711053a4297$export$2e2bcd8739ae039.computedStyle = $cb03b711053a4297$var$deprecateForMajor(9, 'videojs.computedStyle', 'videojs.dom.computedStyle', $cb03b711053a4297$var$computedStyle);
/**
 * A reference to the {@link module:dom|DOM utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:dom|dom}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.dom = $cb03b711053a4297$var$Dom;
/**
 * A reference to the {@link module:fn|fn utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:fn|fn}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.fn = $cb03b711053a4297$var$Fn;
/**
 * A reference to the {@link module:num|num utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:num|num}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.num = $cb03b711053a4297$var$Num;
/**
 * A reference to the {@link module:str|str utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:str|str}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.str = $cb03b711053a4297$var$Str;
/**
 * A reference to the {@link module:url|URL utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:url|url}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.url = $cb03b711053a4297$var$Url;
// The list of possible error types to occur in video.js
$cb03b711053a4297$export$2e2bcd8739ae039.Error = $cb03b711053a4297$var$VjsErrors;
/*! @name videojs-contrib-quality-levels @version 4.1.0 @license Apache-2.0 */ /**
 * A single QualityLevel.
 *
 * interface QualityLevel {
 *   readonly attribute DOMString id;
 *            attribute DOMString label;
 *   readonly attribute long width;
 *   readonly attribute long height;
 *   readonly attribute long bitrate;
 *            attribute boolean enabled;
 * };
 *
 * @class QualityLevel
 */ class $cb03b711053a4297$var$QualityLevel {
    /**
   * Creates a QualityLevel
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   */ constructor(representation){
        let level = this; // eslint-disable-line
        level.id = representation.id;
        level.label = level.id;
        level.width = representation.width;
        level.height = representation.height;
        level.bitrate = representation.bandwidth;
        level.frameRate = representation.frameRate;
        level.enabled_ = representation.enabled;
        Object.defineProperty(level, 'enabled', {
            /**
       * Get whether the QualityLevel is enabled.
       *
       * @return {boolean} True if the QualityLevel is enabled.
       */ get () {
                return level.enabled_();
            },
            /**
       * Enable or disable the QualityLevel.
       *
       * @param {boolean} enable true to enable QualityLevel, false to disable.
       */ set (enable) {
                level.enabled_(enable);
            }
        });
        return level;
    }
}
/**
 * A list of QualityLevels.
 *
 * interface QualityLevelList : EventTarget {
 *   getter QualityLevel (unsigned long index);
 *   readonly attribute unsigned long length;
 *   readonly attribute long selectedIndex;
 *
 *   void addQualityLevel(QualityLevel qualityLevel)
 *   void removeQualityLevel(QualityLevel remove)
 *   QualityLevel? getQualityLevelById(DOMString id);
 *
 *   attribute EventHandler onchange;
 *   attribute EventHandler onaddqualitylevel;
 *   attribute EventHandler onremovequalitylevel;
 * };
 *
 * @extends videojs.EventTarget
 * @class QualityLevelList
 */ class $cb03b711053a4297$var$QualityLevelList extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    /**
   * Creates a QualityLevelList.
   */ constructor(){
        super();
        let list = this; // eslint-disable-line
        list.levels_ = [];
        list.selectedIndex_ = -1;
        /**
     * Get the index of the currently selected QualityLevel.
     *
     * @returns {number} The index of the selected QualityLevel. -1 if none selected.
     * @readonly
     */ Object.defineProperty(list, 'selectedIndex', {
            get () {
                return list.selectedIndex_;
            }
        });
        /**
     * Get the length of the list of QualityLevels.
     *
     * @returns {number} The length of the list.
     * @readonly
     */ Object.defineProperty(list, 'length', {
            get () {
                return list.levels_.length;
            }
        });
        list[Symbol.iterator] = ()=>list.levels_.values();
        return list;
    }
    /**
   * Adds a quality level to the list.
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   * @return {QualityLevel} the QualityLevel added to the list
   * @method addQualityLevel
   */ addQualityLevel(representation) {
        let qualityLevel = this.getQualityLevelById(representation.id);
        // Do not add duplicate quality levels
        if (qualityLevel) return qualityLevel;
        const index = this.levels_.length;
        qualityLevel = new $cb03b711053a4297$var$QualityLevel(representation);
        if (!('' + index in this)) Object.defineProperty(this, index, {
            get () {
                return this.levels_[index];
            }
        });
        this.levels_.push(qualityLevel);
        this.trigger({
            qualityLevel: qualityLevel,
            type: 'addqualitylevel'
        });
        return qualityLevel;
    }
    /**
   * Removes a quality level from the list.
   *
   * @param {QualityLevel} qualityLevel The QualityLevel to remove from the list.
   * @return {QualityLevel|null} the QualityLevel removed or null if nothing removed
   * @method removeQualityLevel
   */ removeQualityLevel(qualityLevel) {
        let removed = null;
        for(let i = 0, l = this.length; i < l; i++)if (this[i] === qualityLevel) {
            removed = this.levels_.splice(i, 1)[0];
            if (this.selectedIndex_ === i) this.selectedIndex_ = -1;
            else if (this.selectedIndex_ > i) this.selectedIndex_--;
            break;
        }
        if (removed) this.trigger({
            qualityLevel: qualityLevel,
            type: 'removequalitylevel'
        });
        return removed;
    }
    /**
   * Searches for a QualityLevel with the given id.
   *
   * @param {string} id The id of the QualityLevel to find.
   * @return {QualityLevel|null} The QualityLevel with id, or null if not found.
   * @method getQualityLevelById
   */ getQualityLevelById(id) {
        for(let i = 0, l = this.length; i < l; i++){
            const level = this[i];
            if (level.id === id) return level;
        }
        return null;
    }
    /**
   * Resets the list of QualityLevels to empty
   *
   * @method dispose
   */ dispose() {
        this.selectedIndex_ = -1;
        this.levels_.length = 0;
    }
}
/**
 * change - The selected QualityLevel has changed.
 * addqualitylevel - A QualityLevel has been added to the QualityLevelList.
 * removequalitylevel - A QualityLevel has been removed from the QualityLevelList.
 */ $cb03b711053a4297$var$QualityLevelList.prototype.allowedEvents_ = {
    change: 'change',
    addqualitylevel: 'addqualitylevel',
    removequalitylevel: 'removequalitylevel'
};
// emulate attribute EventHandler support to allow for feature detection
for(const event in $cb03b711053a4297$var$QualityLevelList.prototype.allowedEvents_)$cb03b711053a4297$var$QualityLevelList.prototype['on' + event] = null;
var $cb03b711053a4297$var$version$5 = "4.1.0";
/**
 * Initialization function for the qualityLevels plugin. Sets up the QualityLevelList and
 * event handlers.
 *
 * @param {Player} player Player object.
 * @param {Object} options Plugin options object.
 * @return {QualityLevelList} a list of QualityLevels
 */ const $cb03b711053a4297$var$initPlugin$1 = function(player, options) {
    const originalPluginFn = player.qualityLevels;
    const qualityLevelList = new $cb03b711053a4297$var$QualityLevelList();
    const disposeHandler = function() {
        qualityLevelList.dispose();
        player.qualityLevels = originalPluginFn;
        player.off('dispose', disposeHandler);
    };
    player.on('dispose', disposeHandler);
    player.qualityLevels = ()=>qualityLevelList;
    player.qualityLevels.VERSION = $cb03b711053a4297$var$version$5;
    return qualityLevelList;
};
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @param {Object} options Plugin options object
 * @return {QualityLevelList} a list of QualityLevels
 */ const $cb03b711053a4297$var$qualityLevels = function(options) {
    return $cb03b711053a4297$var$initPlugin$1(this, $cb03b711053a4297$export$2e2bcd8739ae039.obj.merge({}, options));
};
// Register the plugin with video.js.
$cb03b711053a4297$export$2e2bcd8739ae039.registerPlugin('qualityLevels', $cb03b711053a4297$var$qualityLevels);
// Include the version number.
$cb03b711053a4297$var$qualityLevels.VERSION = $cb03b711053a4297$var$version$5;
/*! @name @videojs/http-streaming @version 3.17.2 @license Apache-2.0 */ /**
 * @file resolve-url.js - Handling how URLs are resolved and manipulated
 */ const $cb03b711053a4297$var$resolveUrl = (0, $5JQY5.default);
/**
 * If the xhr request was redirected, return the responseURL, otherwise,
 * return the original url.
 *
 * @api private
 *
 * @param  {string} url - an url being requested
 * @param  {XMLHttpRequest} req - xhr request result
 *
 * @return {string}
 */ const $cb03b711053a4297$var$resolveManifestRedirect = (url, req)=>{
    // To understand how the responseURL below is set and generated:
    // - https://fetch.spec.whatwg.org/#concept-response-url
    // - https://fetch.spec.whatwg.org/#atomic-http-redirect-handling
    if (req && req.responseURL && url !== req.responseURL) return req.responseURL;
    return url;
};
const $cb03b711053a4297$var$logger = (source)=>{
    if ($cb03b711053a4297$export$2e2bcd8739ae039.log.debug) return $cb03b711053a4297$export$2e2bcd8739ae039.log.debug.bind($cb03b711053a4297$export$2e2bcd8739ae039, 'VHS:', `${source} >`);
    return function() {};
};
/**
 * Provides a compatibility layer between Video.js 7 and 8 API changes for VHS.
 */ /**
 * Delegates to videojs.obj.merge (Video.js 8) or
 * videojs.mergeOptions (Video.js 7).
 */ function $cb03b711053a4297$var$merge(...args) {
    const context = $cb03b711053a4297$export$2e2bcd8739ae039.obj || $cb03b711053a4297$export$2e2bcd8739ae039;
    const fn = context.merge || context.mergeOptions;
    return fn.apply(context, args);
}
/**
 * Delegates to videojs.time.createTimeRanges (Video.js 8) or
 * videojs.createTimeRanges (Video.js 7).
 */ function $cb03b711053a4297$var$createTimeRanges(...args) {
    const context = $cb03b711053a4297$export$2e2bcd8739ae039.time || $cb03b711053a4297$export$2e2bcd8739ae039;
    const fn = context.createTimeRanges || context.createTimeRanges;
    return fn.apply(context, args);
}
/**
 * Converts provided buffered ranges to a descriptive string
 *
 * @param {TimeRanges} buffered - received buffered time ranges
 *
 * @return {string} - descriptive string
 */ function $cb03b711053a4297$var$bufferedRangesToString(buffered) {
    if (buffered.length === 0) return 'Buffered Ranges are empty';
    let bufferedRangesStr = 'Buffered Ranges: \n';
    for(let i = 0; i < buffered.length; i++){
        const start = buffered.start(i);
        const end = buffered.end(i);
        bufferedRangesStr += `${start} --> ${end}. Duration (${end - start})\n`;
    }
    return bufferedRangesStr;
}
/**
 * ranges
 *
 * Utilities for working with TimeRanges.
 *
 */ const $cb03b711053a4297$var$TIME_FUDGE_FACTOR = 1 / 30; // Comparisons between time values such as current time and the end of the buffered range
// can be misleading because of precision differences or when the current media has poorly
// aligned audio and video, which can cause values to be slightly off from what you would
// expect. This value is what we consider to be safe to use in such comparisons to account
// for these scenarios.
const $cb03b711053a4297$var$SAFE_TIME_DELTA = $cb03b711053a4297$var$TIME_FUDGE_FACTOR * 3;
const $cb03b711053a4297$var$filterRanges = function(timeRanges, predicate) {
    const results = [];
    let i;
    if (timeRanges && timeRanges.length) {
        // Search for ranges that match the predicate
        for(i = 0; i < timeRanges.length; i++)if (predicate(timeRanges.start(i), timeRanges.end(i))) results.push([
            timeRanges.start(i),
            timeRanges.end(i)
        ]);
    }
    return $cb03b711053a4297$var$createTimeRanges(results);
};
/**
 * Attempts to find the buffered TimeRange that contains the specified
 * time.
 *
 * @param {TimeRanges} buffered - the TimeRanges object to query
 * @param {number} time  - the time to filter on.
 * @return {TimeRanges} a new TimeRanges object
 */ const $cb03b711053a4297$var$findRange = function(buffered, time) {
    return $cb03b711053a4297$var$filterRanges(buffered, function(start, end) {
        return start - $cb03b711053a4297$var$SAFE_TIME_DELTA <= time && end + $cb03b711053a4297$var$SAFE_TIME_DELTA >= time;
    });
};
/**
 * Returns the TimeRanges that begin later than the specified time.
 *
 * @param {TimeRanges} timeRanges - the TimeRanges object to query
 * @param {number} time - the time to filter on.
 * @return {TimeRanges} a new TimeRanges object.
 */ const $cb03b711053a4297$var$findNextRange = function(timeRanges, time) {
    return $cb03b711053a4297$var$filterRanges(timeRanges, function(start) {
        return start - $cb03b711053a4297$var$TIME_FUDGE_FACTOR >= time;
    });
};
/**
 * Returns gaps within a list of TimeRanges
 *
 * @param {TimeRanges} buffered - the TimeRanges object
 * @return {TimeRanges} a TimeRanges object of gaps
 */ const $cb03b711053a4297$var$findGaps = function(buffered) {
    if (buffered.length < 2) return $cb03b711053a4297$var$createTimeRanges();
    const ranges = [];
    for(let i = 1; i < buffered.length; i++){
        const start = buffered.end(i - 1);
        const end = buffered.start(i);
        ranges.push([
            start,
            end
        ]);
    }
    return $cb03b711053a4297$var$createTimeRanges(ranges);
};
/**
 * Calculate the intersection of two TimeRanges
 *
 * @param {TimeRanges} bufferA
 * @param {TimeRanges} bufferB
 * @return {TimeRanges} The interesection of `bufferA` with `bufferB`
 */ const $cb03b711053a4297$var$bufferIntersection = function(bufferA, bufferB) {
    let start = null;
    let end = null;
    let arity = 0;
    const extents = [];
    const ranges = [];
    if (!bufferA || !bufferA.length || !bufferB || !bufferB.length) return $cb03b711053a4297$var$createTimeRanges();
     // Handle the case where we have both buffers and create an
    // intersection of the two
    let count = bufferA.length; // A) Gather up all start and end times
    while(count--){
        extents.push({
            time: bufferA.start(count),
            type: 'start'
        });
        extents.push({
            time: bufferA.end(count),
            type: 'end'
        });
    }
    count = bufferB.length;
    while(count--){
        extents.push({
            time: bufferB.start(count),
            type: 'start'
        });
        extents.push({
            time: bufferB.end(count),
            type: 'end'
        });
    } // B) Sort them by time
    extents.sort(function(a, b) {
        return a.time - b.time;
    }); // C) Go along one by one incrementing arity for start and decrementing
    //    arity for ends
    for(count = 0; count < extents.length; count++){
        if (extents[count].type === 'start') {
            arity++; // D) If arity is ever incremented to 2 we are entering an
            //    overlapping range
            if (arity === 2) start = extents[count].time;
        } else if (extents[count].type === 'end') {
            arity--; // E) If arity is ever decremented to 1 we leaving an
            //    overlapping range
            if (arity === 1) end = extents[count].time;
        } // F) Record overlapping ranges
        if (start !== null && end !== null) {
            ranges.push([
                start,
                end
            ]);
            start = null;
            end = null;
        }
    }
    return $cb03b711053a4297$var$createTimeRanges(ranges);
};
/**
 * Gets a human readable string for a TimeRange
 *
 * @param {TimeRange} range
 * @return {string} a human readable string
 */ const $cb03b711053a4297$var$printableRange = (range)=>{
    const strArr = [];
    if (!range || !range.length) return '';
    for(let i = 0; i < range.length; i++)strArr.push(range.start(i) + ' => ' + range.end(i));
    return strArr.join(', ');
};
/**
 * Calculates the amount of time left in seconds until the player hits the end of the
 * buffer and causes a rebuffer
 *
 * @param {TimeRange} buffered
 *        The state of the buffer
 * @param {Numnber} currentTime
 *        The current time of the player
 * @param {number} playbackRate
 *        The current playback rate of the player. Defaults to 1.
 * @return {number}
 *         Time until the player has to start rebuffering in seconds.
 * @function timeUntilRebuffer
 */ const $cb03b711053a4297$var$timeUntilRebuffer = function(buffered, currentTime, playbackRate = 1) {
    const bufferedEnd = buffered.length ? buffered.end(buffered.length - 1) : 0;
    return (bufferedEnd - currentTime) / playbackRate;
};
/**
 * Converts a TimeRanges object into an array representation
 *
 * @param {TimeRanges} timeRanges
 * @return {Array}
 */ const $cb03b711053a4297$var$timeRangesToArray = (timeRanges)=>{
    const timeRangesList = [];
    for(let i = 0; i < timeRanges.length; i++)timeRangesList.push({
        start: timeRanges.start(i),
        end: timeRanges.end(i)
    });
    return timeRangesList;
};
/**
 * Determines if two time range objects are different.
 *
 * @param {TimeRange} a
 *        the first time range object to check
 *
 * @param {TimeRange} b
 *        the second time range object to check
 *
 * @return {Boolean}
 *         Whether the time range objects differ
 */ const $cb03b711053a4297$var$isRangeDifferent = function(a, b) {
    // same object
    if (a === b) return false;
     // one or the other is undefined
    if (!a && b || !b && a) return true;
     // length is different
    if (a.length !== b.length) return true;
     // see if any start/end pair is different
    for(let i = 0; i < a.length; i++){
        if (a.start(i) !== b.start(i) || a.end(i) !== b.end(i)) return true;
    } // if the length and every pair is the same
    // this is the same time range
    return false;
};
const $cb03b711053a4297$var$lastBufferedEnd = function(a) {
    if (!a || !a.length || !a.end) return;
    return a.end(a.length - 1);
};
/**
 * A utility function to add up the amount of time in a timeRange
 * after a specified startTime.
 * ie:[[0, 10], [20, 40], [50, 60]] with a startTime 0
 *     would return 40 as there are 40s seconds after 0 in the timeRange
 *
 * @param {TimeRange} range
 *        The range to check against
 * @param {number} startTime
 *        The time in the time range that you should start counting from
 *
 * @return {number}
 *          The number of seconds in the buffer passed the specified time.
 */ const $cb03b711053a4297$var$timeAheadOf = function(range, startTime) {
    let time = 0;
    if (!range || !range.length) return time;
    for(let i = 0; i < range.length; i++){
        const start = range.start(i);
        const end = range.end(i); // startTime is after this range entirely
        if (startTime > end) continue;
         // startTime is within this range
        if (startTime > start && startTime <= end) {
            time += end - startTime;
            continue;
        } // startTime is before this range.
        time += end - start;
    }
    return time;
};
/**
 * @file playlist.js
 *
 * Playlist related utilities.
 */ /**
 * Get the duration of a segment, with special cases for
 * llhls segments that do not have a duration yet.
 *
 * @param {Object} playlist
 *        the playlist that the segment belongs to.
 * @param {Object} segment
 *        the segment to get a duration for.
 *
 * @return {number}
 *          the segment duration
 */ const $cb03b711053a4297$var$segmentDurationWithParts = (playlist, segment)=>{
    // if this isn't a preload segment
    // then we will have a segment duration that is accurate.
    if (!segment.preload) return segment.duration;
     // otherwise we have to add up parts and preload hints
    // to get an up to date duration.
    let result = 0;
    (segment.parts || []).forEach(function(p) {
        result += p.duration;
    }); // for preload hints we have to use partTargetDuration
    // as they won't even have a duration yet.
    (segment.preloadHints || []).forEach(function(p) {
        if (p.type === 'PART') result += playlist.partTargetDuration;
    });
    return result;
};
/**
 * A function to get a combined list of parts and segments with durations
 * and indexes.
 *
 * @param {Playlist} playlist the playlist to get the list for.
 *
 * @return {Array} The part/segment list.
 */ const $cb03b711053a4297$var$getPartsAndSegments = (playlist)=>(playlist.segments || []).reduce((acc, segment, si)=>{
        if (segment.parts) segment.parts.forEach(function(part, pi) {
            acc.push({
                duration: part.duration,
                segmentIndex: si,
                partIndex: pi,
                part: part,
                segment: segment
            });
        });
        else acc.push({
            duration: segment.duration,
            segmentIndex: si,
            partIndex: null,
            segment: segment,
            part: null
        });
        return acc;
    }, []);
const $cb03b711053a4297$var$getLastParts = (media)=>{
    const lastSegment = media.segments && media.segments.length && media.segments[media.segments.length - 1];
    return lastSegment && lastSegment.parts || [];
};
const $cb03b711053a4297$var$getKnownPartCount = ({ preloadSegment: preloadSegment })=>{
    if (!preloadSegment) return;
    const { parts: parts, preloadHints: preloadHints } = preloadSegment;
    let partCount = (preloadHints || []).reduce((count, hint)=>count + (hint.type === 'PART' ? 1 : 0), 0);
    partCount += parts && parts.length ? parts.length : 0;
    return partCount;
};
/**
 * Get the number of seconds to delay from the end of a
 * live playlist.
 *
 * @param {Playlist} main the main playlist
 * @param {Playlist} media the media playlist
 * @return {number} the hold back in seconds.
 */ const $cb03b711053a4297$var$liveEdgeDelay = (main, media)=>{
    if (media.endList) return 0;
     // dash suggestedPresentationDelay trumps everything
    if (main && main.suggestedPresentationDelay) return main.suggestedPresentationDelay;
    const hasParts = $cb03b711053a4297$var$getLastParts(media).length > 0; // look for "part" delays from ll-hls first
    if (hasParts && media.serverControl && media.serverControl.partHoldBack) return media.serverControl.partHoldBack;
    else if (hasParts && media.partTargetDuration) return media.partTargetDuration * 3; // finally look for full segment delays
    else if (media.serverControl && media.serverControl.holdBack) return media.serverControl.holdBack;
    else if (media.targetDuration) return media.targetDuration * 3;
    return 0;
};
/**
 * walk backward until we find a duration we can use
 * or return a failure
 *
 * @param {Playlist} playlist the playlist to walk through
 * @param {Number} endSequence the mediaSequence to stop walking on
 */ const $cb03b711053a4297$var$backwardDuration = function(playlist, endSequence) {
    let result = 0;
    let i = endSequence - playlist.mediaSequence; // if a start time is available for segment immediately following
    // the interval, use it
    let segment = playlist.segments[i]; // Walk backward until we find the latest segment with timeline
    // information that is earlier than endSequence
    if (segment) {
        if (typeof segment.start !== 'undefined') return {
            result: segment.start,
            precise: true
        };
        if (typeof segment.end !== 'undefined') return {
            result: segment.end - segment.duration,
            precise: true
        };
    }
    while(i--){
        segment = playlist.segments[i];
        if (typeof segment.end !== 'undefined') return {
            result: result + segment.end,
            precise: true
        };
        result += $cb03b711053a4297$var$segmentDurationWithParts(playlist, segment);
        if (typeof segment.start !== 'undefined') return {
            result: result + segment.start,
            precise: true
        };
    }
    return {
        result: result,
        precise: false
    };
};
/**
 * walk forward until we find a duration we can use
 * or return a failure
 *
 * @param {Playlist} playlist the playlist to walk through
 * @param {number} endSequence the mediaSequence to stop walking on
 */ const $cb03b711053a4297$var$forwardDuration = function(playlist, endSequence) {
    let result = 0;
    let segment;
    let i = endSequence - playlist.mediaSequence; // Walk forward until we find the earliest segment with timeline
    // information
    for(; i < playlist.segments.length; i++){
        segment = playlist.segments[i];
        if (typeof segment.start !== 'undefined') return {
            result: segment.start - result,
            precise: true
        };
        result += $cb03b711053a4297$var$segmentDurationWithParts(playlist, segment);
        if (typeof segment.end !== 'undefined') return {
            result: segment.end - result,
            precise: true
        };
    } // indicate we didn't find a useful duration estimate
    return {
        result: -1,
        precise: false
    };
};
/**
  * Calculate the media duration from the segments associated with a
  * playlist. The duration of a subinterval of the available segments
  * may be calculated by specifying an end index.
  *
  * @param {Object} playlist a media playlist object
  * @param {number=} endSequence an exclusive upper boundary
  * for the playlist.  Defaults to playlist length.
  * @param {number} expired the amount of time that has dropped
  * off the front of the playlist in a live scenario
  * @return {number} the duration between the first available segment
  * and end index.
  */ const $cb03b711053a4297$var$intervalDuration = function(playlist, endSequence, expired) {
    if (typeof endSequence === 'undefined') endSequence = playlist.mediaSequence + playlist.segments.length;
    if (endSequence < playlist.mediaSequence) return 0;
     // do a backward walk to estimate the duration
    const backward = $cb03b711053a4297$var$backwardDuration(playlist, endSequence);
    if (backward.precise) // if we were able to base our duration estimate on timing
    // information provided directly from the Media Source, return
    // it
    return backward.result;
     // walk forward to see if a precise duration estimate can be made
    // that way
    const forward = $cb03b711053a4297$var$forwardDuration(playlist, endSequence);
    if (forward.precise) // we found a segment that has been buffered and so it's
    // position is known precisely
    return forward.result;
     // return the less-precise, playlist-based duration estimate
    return backward.result + expired;
};
/**
  * Calculates the duration of a playlist. If a start and end index
  * are specified, the duration will be for the subset of the media
  * timeline between those two indices. The total duration for live
  * playlists is always Infinity.
  *
  * @param {Object} playlist a media playlist object
  * @param {number=} endSequence an exclusive upper
  * boundary for the playlist. Defaults to the playlist media
  * sequence number plus its length.
  * @param {number=} expired the amount of time that has
  * dropped off the front of the playlist in a live scenario
  * @return {number} the duration between the start index and end
  * index.
  */ const $cb03b711053a4297$var$duration = function(playlist, endSequence, expired) {
    if (!playlist) return 0;
    if (typeof expired !== 'number') expired = 0;
     // if a slice of the total duration is not requested, use
    // playlist-level duration indicators when they're present
    if (typeof endSequence === 'undefined') {
        // if present, use the duration specified in the playlist
        if (playlist.totalDuration) return playlist.totalDuration;
         // duration should be Infinity for live playlists
        if (!playlist.endList) return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Infinity;
    } // calculate the total duration based on the segment durations
    return $cb03b711053a4297$var$intervalDuration(playlist, endSequence, expired);
};
/**
  * Calculate the time between two indexes in the current playlist
  * neight the start- nor the end-index need to be within the current
  * playlist in which case, the targetDuration of the playlist is used
  * to approximate the durations of the segments
  *
  * @param {Array} options.durationList list to iterate over for durations.
  * @param {number} options.defaultDuration duration to use for elements before or after the durationList
  * @param {number} options.startIndex partsAndSegments index to start
  * @param {number} options.endIndex partsAndSegments index to end.
  * @return {number} the number of seconds between startIndex and endIndex
  */ const $cb03b711053a4297$var$sumDurations = function({ defaultDuration: defaultDuration, durationList: durationList, startIndex: startIndex, endIndex: endIndex }) {
    let durations = 0;
    if (startIndex > endIndex) [startIndex, endIndex] = [
        endIndex,
        startIndex
    ];
    if (startIndex < 0) {
        for(let i = startIndex; i < Math.min(0, endIndex); i++)durations += defaultDuration;
        startIndex = 0;
    }
    for(let i = startIndex; i < endIndex; i++)durations += durationList[i].duration;
    return durations;
};
/**
 * Calculates the playlist end time
 *
 * @param {Object} playlist a media playlist object
 * @param {number=} expired the amount of time that has
 *                  dropped off the front of the playlist in a live scenario
 * @param {boolean|false} useSafeLiveEnd a boolean value indicating whether or not the
 *                        playlist end calculation should consider the safe live end
 *                        (truncate the playlist end by three segments). This is normally
 *                        used for calculating the end of the playlist's seekable range.
 *                        This takes into account the value of liveEdgePadding.
 *                        Setting liveEdgePadding to 0 is equivalent to setting this to false.
 * @param {number} liveEdgePadding a number indicating how far from the end of the playlist we should be in seconds.
 *                 If this is provided, it is used in the safe live end calculation.
 *                 Setting useSafeLiveEnd=false or liveEdgePadding=0 are equivalent.
 *                 Corresponds to suggestedPresentationDelay in DASH manifests.
 * @return {number} the end time of playlist
 * @function playlistEnd
 */ const $cb03b711053a4297$var$playlistEnd = function(playlist, expired, useSafeLiveEnd, liveEdgePadding) {
    if (!playlist || !playlist.segments) return null;
    if (playlist.endList) return $cb03b711053a4297$var$duration(playlist);
    if (expired === null) return null;
    expired = expired || 0;
    let lastSegmentEndTime = $cb03b711053a4297$var$intervalDuration(playlist, playlist.mediaSequence + playlist.segments.length, expired);
    if (useSafeLiveEnd) {
        liveEdgePadding = typeof liveEdgePadding === 'number' ? liveEdgePadding : $cb03b711053a4297$var$liveEdgeDelay(null, playlist);
        lastSegmentEndTime -= liveEdgePadding;
    } // don't return a time less than zero
    return Math.max(0, lastSegmentEndTime);
};
/**
  * Calculates the interval of time that is currently seekable in a
  * playlist. The returned time ranges are relative to the earliest
  * moment in the specified playlist that is still available. A full
  * seekable implementation for live streams would need to offset
  * these values by the duration of content that has expired from the
  * stream.
  *
  * @param {Object} playlist a media playlist object
  * dropped off the front of the playlist in a live scenario
  * @param {number=} expired the amount of time that has
  * dropped off the front of the playlist in a live scenario
  * @param {number} liveEdgePadding how far from the end of the playlist we should be in seconds.
  *        Corresponds to suggestedPresentationDelay in DASH manifests.
  * @return {TimeRanges} the periods of time that are valid targets
  * for seeking
  */ const $cb03b711053a4297$var$seekable = function(playlist, expired, liveEdgePadding) {
    const useSafeLiveEnd = true;
    const seekableStart = expired || 0;
    let seekableEnd = $cb03b711053a4297$var$playlistEnd(playlist, expired, useSafeLiveEnd, liveEdgePadding);
    if (seekableEnd === null) return $cb03b711053a4297$var$createTimeRanges();
     // Clamp seekable end since it can not be less than the seekable start
    if (seekableEnd < seekableStart) seekableEnd = seekableStart;
    return $cb03b711053a4297$var$createTimeRanges(seekableStart, seekableEnd);
};
/**
 * Determine the index and estimated starting time of the segment that
 * contains a specified playback position in a media playlist.
 *
 * @param {Object} options.playlist the media playlist to query
 * @param {number} options.currentTime The number of seconds since the earliest
 * possible position to determine the containing segment for
 * @param {number} options.startTime the time when the segment/part starts
 * @param {number} options.startingSegmentIndex the segment index to start looking at.
 * @param {number?} [options.startingPartIndex] the part index to look at within the segment.
 *
 * @return {Object} an object with partIndex, segmentIndex, and startTime.
 */ const $cb03b711053a4297$var$getMediaInfoForTime = function({ playlist: playlist, currentTime: currentTime, startingSegmentIndex: startingSegmentIndex, startingPartIndex: startingPartIndex, startTime: startTime, exactManifestTimings: exactManifestTimings }) {
    let time = currentTime - startTime;
    const partsAndSegments = $cb03b711053a4297$var$getPartsAndSegments(playlist);
    let startIndex = 0;
    for(let i = 0; i < partsAndSegments.length; i++){
        const partAndSegment = partsAndSegments[i];
        if (startingSegmentIndex !== partAndSegment.segmentIndex) continue;
         // skip this if part index does not match.
        if (typeof startingPartIndex === 'number' && typeof partAndSegment.partIndex === 'number' && startingPartIndex !== partAndSegment.partIndex) continue;
        startIndex = i;
        break;
    }
    if (time < 0) {
        // Walk backward from startIndex in the playlist, adding durations
        // until we find a segment that contains `time` and return it
        if (startIndex > 0) for(let i = startIndex - 1; i >= 0; i--){
            const partAndSegment = partsAndSegments[i];
            time += partAndSegment.duration;
            if (exactManifestTimings) {
                if (time < 0) continue;
            } else if (time + $cb03b711053a4297$var$TIME_FUDGE_FACTOR <= 0) continue;
            return {
                partIndex: partAndSegment.partIndex,
                segmentIndex: partAndSegment.segmentIndex,
                startTime: startTime - $cb03b711053a4297$var$sumDurations({
                    defaultDuration: playlist.targetDuration,
                    durationList: partsAndSegments,
                    startIndex: startIndex,
                    endIndex: i
                })
            };
        }
         // We were unable to find a good segment within the playlist
        // so select the first segment
        return {
            partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
            segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
            startTime: currentTime
        };
    } // When startIndex is negative, we first walk forward to first segment
    // adding target durations. If we "run out of time" before getting to
    // the first segment, return the first segment
    if (startIndex < 0) {
        for(let i = startIndex; i < 0; i++){
            time -= playlist.targetDuration;
            if (time < 0) return {
                partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
                segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
                startTime: currentTime
            };
        }
        startIndex = 0;
    } // Walk forward from startIndex in the playlist, subtracting durations
    // until we find a segment that contains `time` and return it
    for(let i = startIndex; i < partsAndSegments.length; i++){
        const partAndSegment = partsAndSegments[i];
        time -= partAndSegment.duration;
        const canUseFudgeFactor = partAndSegment.duration > $cb03b711053a4297$var$TIME_FUDGE_FACTOR;
        const isExactlyAtTheEnd = time === 0;
        const isExtremelyCloseToTheEnd = canUseFudgeFactor && time + $cb03b711053a4297$var$TIME_FUDGE_FACTOR >= 0;
        if (isExactlyAtTheEnd || isExtremelyCloseToTheEnd) {
            // 1) We are exactly at the end of the current segment.
            // 2) We are extremely close to the end of the current segment (The difference is less than  1 / 30).
            //    We may encounter this situation when
            //    we don't have exact match between segment duration info in the manifest and the actual duration of the segment
            //    For example:
            //    We appended 3 segments 10 seconds each, meaning we should have 30 sec buffered,
            //    but we the actual buffered is 29.99999
            //
            // In both cases:
            // if we passed current time -> it means that we already played current segment
            // if we passed buffered.end -> it means that this segment is already loaded and buffered
            // we should select the next segment if we have one:
            if (i !== partsAndSegments.length - 1) continue;
        }
        if (exactManifestTimings) {
            if (time > 0) continue;
        } else if (time - $cb03b711053a4297$var$TIME_FUDGE_FACTOR >= 0) continue;
        return {
            partIndex: partAndSegment.partIndex,
            segmentIndex: partAndSegment.segmentIndex,
            startTime: startTime + $cb03b711053a4297$var$sumDurations({
                defaultDuration: playlist.targetDuration,
                durationList: partsAndSegments,
                startIndex: startIndex,
                endIndex: i
            })
        };
    } // We are out of possible candidates so load the last one...
    return {
        segmentIndex: partsAndSegments[partsAndSegments.length - 1].segmentIndex,
        partIndex: partsAndSegments[partsAndSegments.length - 1].partIndex,
        startTime: currentTime
    };
};
/**
 * Check whether the playlist is excluded or not.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is excluded or not
 * @function isExcluded
 */ const $cb03b711053a4297$var$isExcluded = function(playlist) {
    return playlist.excludeUntil && playlist.excludeUntil > Date.now();
};
/**
 * Check whether the playlist is compatible with current playback configuration or has
 * been excluded permanently for being incompatible.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is incompatible or not
 * @function isIncompatible
 */ const $cb03b711053a4297$var$isIncompatible = function(playlist) {
    return playlist.excludeUntil && playlist.excludeUntil === Infinity;
};
/**
 * Check whether the playlist is enabled or not.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is enabled or not
 * @function isEnabled
 */ const $cb03b711053a4297$var$isEnabled = function(playlist) {
    const excluded = $cb03b711053a4297$var$isExcluded(playlist);
    return !playlist.disabled && !excluded;
};
/**
 * Check whether the playlist has been manually disabled through the representations api.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is disabled manually or not
 * @function isDisabled
 */ const $cb03b711053a4297$var$isDisabled = function(playlist) {
    return playlist.disabled;
};
/**
 * Returns whether the current playlist is an AES encrypted HLS stream
 *
 * @return {boolean} true if it's an AES encrypted HLS stream
 */ const $cb03b711053a4297$var$isAes = function(media) {
    for(let i = 0; i < media.segments.length; i++){
        if (media.segments[i].key) return true;
    }
    return false;
};
/**
 * Checks if the playlist has a value for the specified attribute
 *
 * @param {string} attr
 *        Attribute to check for
 * @param {Object} playlist
 *        The media playlist object
 * @return {boolean}
 *         Whether the playlist contains a value for the attribute or not
 * @function hasAttribute
 */ const $cb03b711053a4297$var$hasAttribute = function(attr, playlist) {
    return playlist.attributes && playlist.attributes[attr];
};
/**
 * Estimates the time required to complete a segment download from the specified playlist
 *
 * @param {number} segmentDuration
 *        Duration of requested segment
 * @param {number} bandwidth
 *        Current measured bandwidth of the player
 * @param {Object} playlist
 *        The media playlist object
 * @param {number=} bytesReceived
 *        Number of bytes already received for the request. Defaults to 0
 * @return {number|NaN}
 *         The estimated time to request the segment. NaN if bandwidth information for
 *         the given playlist is unavailable
 * @function estimateSegmentRequestTime
 */ const $cb03b711053a4297$var$estimateSegmentRequestTime = function(segmentDuration, bandwidth, playlist, bytesReceived = 0) {
    if (!$cb03b711053a4297$var$hasAttribute('BANDWIDTH', playlist)) return NaN;
    const size = segmentDuration * playlist.attributes.BANDWIDTH;
    return (size - bytesReceived * 8) / bandwidth;
};
/*
 * Returns whether the current playlist is the lowest rendition
 *
 * @return {Boolean} true if on lowest rendition
 */ const $cb03b711053a4297$var$isLowestEnabledRendition = (main, media)=>{
    if (main.playlists.length === 1) return true;
    const currentBandwidth = media.attributes.BANDWIDTH || Number.MAX_VALUE;
    return main.playlists.filter((playlist)=>{
        if (!$cb03b711053a4297$var$isEnabled(playlist)) return false;
        return (playlist.attributes.BANDWIDTH || 0) < currentBandwidth;
    }).length === 0;
};
const $cb03b711053a4297$var$playlistMatch = (a, b)=>{
    // both playlits are null
    // or only one playlist is non-null
    // no match
    if (!a && !b || !a && b || a && !b) return false;
     // playlist objects are the same, match
    if (a === b) return true;
     // first try to use id as it should be the most
    // accurate
    if (a.id && b.id && a.id === b.id) return true;
     // next try to use reslovedUri as it should be the
    // second most accurate.
    if (a.resolvedUri && b.resolvedUri && a.resolvedUri === b.resolvedUri) return true;
     // finally try to use uri as it should be accurate
    // but might miss a few cases for relative uris
    if (a.uri && b.uri && a.uri === b.uri) return true;
    return false;
};
const $cb03b711053a4297$var$someAudioVariant = function(main, callback) {
    const AUDIO = main && main.mediaGroups && main.mediaGroups.AUDIO || {};
    let found = false;
    for(const groupName in AUDIO){
        for(const label in AUDIO[groupName]){
            found = callback(AUDIO[groupName][label]);
            if (found) break;
        }
        if (found) break;
    }
    return !!found;
};
const $cb03b711053a4297$var$isAudioOnly = (main)=>{
    // we are audio only if we have no main playlists but do
    // have media group playlists.
    if (!main || !main.playlists || !main.playlists.length) {
        // without audio variants or playlists this
        // is not an audio only main.
        const found = $cb03b711053a4297$var$someAudioVariant(main, (variant)=>variant.playlists && variant.playlists.length || variant.uri);
        return found;
    } // if every playlist has only an audio codec it is audio only
    for(let i = 0; i < main.playlists.length; i++){
        const playlist = main.playlists[i];
        const CODECS = playlist.attributes && playlist.attributes.CODECS; // all codecs are audio, this is an audio playlist.
        if (CODECS && CODECS.split(',').every((c)=>(0, $jv51Y.isAudioCodec)(c))) continue;
         // playlist is in an audio group it is audio only
        const found = $cb03b711053a4297$var$someAudioVariant(main, (variant)=>$cb03b711053a4297$var$playlistMatch(playlist, variant));
        if (found) continue;
         // if we make it here this playlist isn't audio and we
        // are not audio only
        return false;
    } // if we make it past every playlist without returning, then
    // this is an audio only playlist.
    return true;
}; // exports
var $cb03b711053a4297$var$Playlist = {
    liveEdgeDelay: $cb03b711053a4297$var$liveEdgeDelay,
    duration: $cb03b711053a4297$var$duration,
    seekable: $cb03b711053a4297$var$seekable,
    getMediaInfoForTime: $cb03b711053a4297$var$getMediaInfoForTime,
    isEnabled: $cb03b711053a4297$var$isEnabled,
    isDisabled: $cb03b711053a4297$var$isDisabled,
    isExcluded: $cb03b711053a4297$var$isExcluded,
    isIncompatible: $cb03b711053a4297$var$isIncompatible,
    playlistEnd: $cb03b711053a4297$var$playlistEnd,
    isAes: $cb03b711053a4297$var$isAes,
    hasAttribute: $cb03b711053a4297$var$hasAttribute,
    estimateSegmentRequestTime: $cb03b711053a4297$var$estimateSegmentRequestTime,
    isLowestEnabledRendition: $cb03b711053a4297$var$isLowestEnabledRendition,
    isAudioOnly: $cb03b711053a4297$var$isAudioOnly,
    playlistMatch: $cb03b711053a4297$var$playlistMatch,
    segmentDurationWithParts: $cb03b711053a4297$var$segmentDurationWithParts
};
const { log: $cb03b711053a4297$var$log } = $cb03b711053a4297$export$2e2bcd8739ae039;
const $cb03b711053a4297$var$createPlaylistID = (index, uri)=>{
    return `${index}-${uri}`;
}; // default function for creating a group id
const $cb03b711053a4297$var$groupID = (type, group, label)=>{
    return `placeholder-uri-${type}-${group}-${label}`;
};
/**
 * Parses a given m3u8 playlist
 *
 * @param {Function} [onwarn]
 *        a function to call when the parser triggers a warning event.
 * @param {Function} [oninfo]
 *        a function to call when the parser triggers an info event.
 * @param {string} manifestString
 *        The downloaded manifest string
 * @param {Object[]} [customTagParsers]
 *        An array of custom tag parsers for the m3u8-parser instance
 * @param {Object[]} [customTagMappers]
 *        An array of custom tag mappers for the m3u8-parser instance
 * @param {boolean} [llhls]
 *        Whether to keep ll-hls features in the manifest after parsing.
 * @return {Object}
 *         The manifest object
 */ const $cb03b711053a4297$var$parseManifest = ({ onwarn: onwarn, oninfo: oninfo, manifestString: manifestString, customTagParsers: customTagParsers = [], customTagMappers: customTagMappers = [], llhls: llhls })=>{
    const parser = new (0, $2306U.Parser)();
    if (onwarn) parser.on('warn', onwarn);
    if (oninfo) parser.on('info', oninfo);
    customTagParsers.forEach((customParser)=>parser.addParser(customParser));
    customTagMappers.forEach((mapper)=>parser.addTagMapper(mapper));
    parser.push(manifestString);
    parser.end();
    const manifest = parser.manifest; // remove llhls features from the parsed manifest
    // if we don't want llhls support.
    if (!llhls) {
        [
            'preloadSegment',
            'skip',
            'serverControl',
            'renditionReports',
            'partInf',
            'partTargetDuration'
        ].forEach(function(k) {
            if (manifest.hasOwnProperty(k)) delete manifest[k];
        });
        if (manifest.segments) manifest.segments.forEach(function(segment) {
            [
                'parts',
                'preloadHints'
            ].forEach(function(k) {
                if (segment.hasOwnProperty(k)) delete segment[k];
            });
        });
    }
    if (!manifest.targetDuration) {
        let targetDuration = 10;
        if (manifest.segments && manifest.segments.length) targetDuration = manifest.segments.reduce((acc, s)=>Math.max(acc, s.duration), 0);
        if (onwarn) onwarn({
            message: `manifest has no targetDuration defaulting to ${targetDuration}`
        });
        manifest.targetDuration = targetDuration;
    }
    const parts = $cb03b711053a4297$var$getLastParts(manifest);
    if (parts.length && !manifest.partTargetDuration) {
        const partTargetDuration = parts.reduce((acc, p)=>Math.max(acc, p.duration), 0);
        if (onwarn) {
            onwarn({
                message: `manifest has no partTargetDuration defaulting to ${partTargetDuration}`
            });
            $cb03b711053a4297$var$log.error('LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.');
        }
        manifest.partTargetDuration = partTargetDuration;
    }
    return manifest;
};
/**
 * Loops through all supported media groups in main and calls the provided
 * callback for each group
 *
 * @param {Object} main
 *        The parsed main manifest object
 * @param {Function} callback
 *        Callback to call for each media group
 */ const $cb03b711053a4297$var$forEachMediaGroup = (main, callback)=>{
    if (!main.mediaGroups) return;
    [
        'AUDIO',
        'SUBTITLES'
    ].forEach((mediaType)=>{
        if (!main.mediaGroups[mediaType]) return;
        for(const groupKey in main.mediaGroups[mediaType])for(const labelKey in main.mediaGroups[mediaType][groupKey]){
            const mediaProperties = main.mediaGroups[mediaType][groupKey][labelKey];
            callback(mediaProperties, mediaType, groupKey, labelKey);
        }
    });
};
/**
 * Adds properties and attributes to the playlist to keep consistent functionality for
 * playlists throughout VHS.
 *
 * @param {Object} config
 *        Arguments object
 * @param {Object} config.playlist
 *        The media playlist
 * @param {string} [config.uri]
 *        The uri to the media playlist (if media playlist is not from within a main
 *        playlist)
 * @param {string} id
 *        ID to use for the playlist
 */ const $cb03b711053a4297$var$setupMediaPlaylist = ({ playlist: playlist, uri: uri, id: id })=>{
    playlist.id = id;
    playlist.playlistErrors_ = 0;
    if (uri) // For media playlists, m3u8-parser does not have access to a URI, as HLS media
    // playlists do not contain their own source URI, but one is needed for consistency in
    // VHS.
    playlist.uri = uri;
     // For HLS main playlists, even though certain attributes MUST be defined, the
    // stream may still be played without them.
    // For HLS media playlists, m3u8-parser does not attach an attributes object to the
    // manifest.
    //
    // To avoid undefined reference errors through the project, and make the code easier
    // to write/read, add an empty attributes object for these cases.
    playlist.attributes = playlist.attributes || {};
};
/**
 * Adds ID, resolvedUri, and attributes properties to each playlist of the main, where
 * necessary. In addition, creates playlist IDs for each playlist and adds playlist ID to
 * playlist references to the playlists array.
 *
 * @param {Object} main
 *        The main playlist
 */ const $cb03b711053a4297$var$setupMediaPlaylists = (main)=>{
    let i = main.playlists.length;
    while(i--){
        const playlist = main.playlists[i];
        $cb03b711053a4297$var$setupMediaPlaylist({
            playlist: playlist,
            id: $cb03b711053a4297$var$createPlaylistID(i, playlist.uri)
        });
        playlist.resolvedUri = $cb03b711053a4297$var$resolveUrl(main.uri, playlist.uri);
        main.playlists[playlist.id] = playlist; // URI reference added for backwards compatibility
        main.playlists[playlist.uri] = playlist; // Although the spec states an #EXT-X-STREAM-INF tag MUST have a BANDWIDTH attribute,
        // the stream can be played without it. Although an attributes property may have been
        // added to the playlist to prevent undefined references, issue a warning to fix the
        // manifest.
        if (!playlist.attributes.BANDWIDTH) $cb03b711053a4297$var$log.warn('Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.');
    }
};
/**
 * Adds resolvedUri properties to each media group.
 *
 * @param {Object} main
 *        The main playlist
 */ const $cb03b711053a4297$var$resolveMediaGroupUris = (main)=>{
    $cb03b711053a4297$var$forEachMediaGroup(main, (properties)=>{
        if (properties.uri) properties.resolvedUri = $cb03b711053a4297$var$resolveUrl(main.uri, properties.uri);
    });
};
/**
 * Creates a main playlist wrapper to insert a sole media playlist into.
 *
 * @param {Object} media
 *        Media playlist
 * @param {string} uri
 *        The media URI
 *
 * @return {Object}
 *         main playlist
 */ const $cb03b711053a4297$var$mainForMedia = (media, uri)=>{
    const id = $cb03b711053a4297$var$createPlaylistID(0, uri);
    const main = {
        mediaGroups: {
            'AUDIO': {},
            'VIDEO': {},
            'CLOSED-CAPTIONS': {},
            'SUBTITLES': {}
        },
        uri: (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href,
        resolvedUri: (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href,
        playlists: [
            {
                uri: uri,
                id: id,
                resolvedUri: uri,
                // m3u8-parser does not attach an attributes property to media playlists so make
                // sure that the property is attached to avoid undefined reference errors
                attributes: {}
            }
        ]
    }; // set up ID reference
    main.playlists[id] = main.playlists[0]; // URI reference added for backwards compatibility
    main.playlists[uri] = main.playlists[0];
    return main;
};
/**
 * Does an in-place update of the main manifest to add updated playlist URI references
 * as well as other properties needed by VHS that aren't included by the parser.
 *
 * @param {Object} main
 *        main manifest object
 * @param {string} uri
 *        The source URI
 * @param {function} createGroupID
 *        A function to determine how to create the groupID for mediaGroups
 */ const $cb03b711053a4297$var$addPropertiesToMain = (main, uri, createGroupID = $cb03b711053a4297$var$groupID)=>{
    main.uri = uri;
    for(let i = 0; i < main.playlists.length; i++)if (!main.playlists[i].uri) {
        // Set up phony URIs for the playlists since playlists are referenced by their URIs
        // throughout VHS, but some formats (e.g., DASH) don't have external URIs
        // TODO: consider adding dummy URIs in mpd-parser
        const phonyUri = `placeholder-uri-${i}`;
        main.playlists[i].uri = phonyUri;
    }
    const audioOnlyMain = $cb03b711053a4297$var$isAudioOnly(main);
    $cb03b711053a4297$var$forEachMediaGroup(main, (properties, mediaType, groupKey, labelKey)=>{
        // add a playlist array under properties
        if (!properties.playlists || !properties.playlists.length) {
            // If the manifest is audio only and this media group does not have a uri, check
            // if the media group is located in the main list of playlists. If it is, don't add
            // placeholder properties as it shouldn't be considered an alternate audio track.
            if (audioOnlyMain && mediaType === 'AUDIO' && !properties.uri) for(let i = 0; i < main.playlists.length; i++){
                const p = main.playlists[i];
                if (p.attributes && p.attributes.AUDIO && p.attributes.AUDIO === groupKey) return;
            }
            properties.playlists = [
                (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, properties)
            ];
        }
        properties.playlists.forEach(function(p, i) {
            const groupId = createGroupID(mediaType, groupKey, labelKey, p);
            const id = $cb03b711053a4297$var$createPlaylistID(i, groupId);
            if (p.uri) p.resolvedUri = p.resolvedUri || $cb03b711053a4297$var$resolveUrl(main.uri, p.uri);
            else {
                // DEPRECATED, this has been added to prevent a breaking change.
                // previously we only ever had a single media group playlist, so
                // we mark the first playlist uri without prepending the index as we used to
                // ideally we would do all of the playlists the same way.
                p.uri = i === 0 ? groupId : id; // don't resolve a placeholder uri to an absolute url, just use
                // the placeholder again
                p.resolvedUri = p.uri;
            }
            p.id = p.id || id; // add an empty attributes object, all playlists are
            // expected to have this.
            p.attributes = p.attributes || {}; // setup ID and URI references (URI for backwards compatibility)
            main.playlists[p.id] = p;
            main.playlists[p.uri] = p;
        });
    });
    $cb03b711053a4297$var$setupMediaPlaylists(main);
    $cb03b711053a4297$var$resolveMediaGroupUris(main);
};
class $cb03b711053a4297$var$DateRangesStorage {
    constructor(){
        this.offset_ = null;
        this.pendingDateRanges_ = new Map();
        this.processedDateRanges_ = new Map();
    }
    setOffset(segments = []) {
        // already set
        if (this.offset_ !== null) return;
         // no segment to process
        if (!segments.length) return;
        const [firstSegment] = segments; // no program date time
        if (firstSegment.programDateTime === undefined) return;
         // Set offset as ProgramDateTime for the very first segment of the very first playlist load:
        this.offset_ = firstSegment.programDateTime / 1000;
    }
    setPendingDateRanges(dateRanges = []) {
        if (!dateRanges.length) return;
        const [dateRange] = dateRanges;
        const startTime = dateRange.startDate.getTime();
        this.trimProcessedDateRanges_(startTime);
        this.pendingDateRanges_ = dateRanges.reduce((map, pendingDateRange)=>{
            map.set(pendingDateRange.id, pendingDateRange);
            return map;
        }, new Map());
    }
    processDateRange(dateRange) {
        this.pendingDateRanges_.delete(dateRange.id);
        this.processedDateRanges_.set(dateRange.id, dateRange);
    }
    getDateRangesToProcess() {
        if (this.offset_ === null) return [];
        const dateRangeClasses = {};
        const dateRangesToProcess = [];
        this.pendingDateRanges_.forEach((dateRange, id)=>{
            if (this.processedDateRanges_.has(id)) return;
            dateRange.startTime = dateRange.startDate.getTime() / 1000 - this.offset_;
            dateRange.processDateRange = ()=>this.processDateRange(dateRange);
            dateRangesToProcess.push(dateRange);
            if (!dateRange.class) return;
            if (dateRangeClasses[dateRange.class]) {
                const length = dateRangeClasses[dateRange.class].push(dateRange);
                dateRange.classListIndex = length - 1;
            } else {
                dateRangeClasses[dateRange.class] = [
                    dateRange
                ];
                dateRange.classListIndex = 0;
            }
        });
        for (const dateRange of dateRangesToProcess){
            const classList = dateRangeClasses[dateRange.class] || [];
            if (dateRange.endDate) dateRange.endTime = dateRange.endDate.getTime() / 1000 - this.offset_;
            else if (dateRange.endOnNext && classList[dateRange.classListIndex + 1]) dateRange.endTime = classList[dateRange.classListIndex + 1].startTime;
            else if (dateRange.duration) dateRange.endTime = dateRange.startTime + dateRange.duration;
            else if (dateRange.plannedDuration) dateRange.endTime = dateRange.startTime + dateRange.plannedDuration;
            else dateRange.endTime = dateRange.startTime;
        }
        return dateRangesToProcess;
    }
    trimProcessedDateRanges_(startTime) {
        const copy = new Map(this.processedDateRanges_);
        copy.forEach((dateRange, id)=>{
            if (dateRange.startDate.getTime() < startTime) this.processedDateRanges_.delete(id);
        });
    }
}
const $cb03b711053a4297$var$QUOTA_EXCEEDED_ERR = 22;
const $cb03b711053a4297$var$getStreamingNetworkErrorMetadata = ({ requestType: requestType, request: request, error: error, parseFailure: parseFailure })=>{
    const isBadStatus = request.status < 200 || request.status > 299;
    const isFailure = request.status >= 400 && request.status <= 499;
    const errorMetadata = {
        uri: request.uri,
        requestType: requestType
    };
    const isBadStatusOrParseFailure = isBadStatus && !isFailure || parseFailure;
    if (error && isFailure) {
        // copy original error and add to the metadata.
        errorMetadata.error = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, error);
        errorMetadata.errorType = $cb03b711053a4297$export$2e2bcd8739ae039.Error.NetworkRequestFailed;
    } else if (request.aborted) errorMetadata.errorType = $cb03b711053a4297$export$2e2bcd8739ae039.Error.NetworkRequestAborted;
    else if (request.timedout) errorMetadata.errorType = $cb03b711053a4297$export$2e2bcd8739ae039.Error.NetworkRequestTimeout;
    else if (isBadStatusOrParseFailure) {
        const errorType = parseFailure ? $cb03b711053a4297$export$2e2bcd8739ae039.Error.NetworkBodyParserFailed : $cb03b711053a4297$export$2e2bcd8739ae039.Error.NetworkBadStatus;
        errorMetadata.errorType = errorType;
        errorMetadata.status = request.status;
        errorMetadata.headers = request.headers;
    }
    return errorMetadata;
};
/**
 * @file - codecs.js - Handles tasks regarding codec strings such as translating them to
 * codec strings, or translating codec strings into objects that can be examined.
 */ const $cb03b711053a4297$var$logFn$1 = $cb03b711053a4297$var$logger('CodecUtils');
/**
 * Returns a set of codec strings parsed from the playlist or the default
 * codec strings if no codecs were specified in the playlist
 *
 * @param {Playlist} media the current media playlist
 * @return {Object} an object with the video and audio codecs
 */ const $cb03b711053a4297$var$getCodecs = function(media) {
    // if the codecs were explicitly specified, use them instead of the
    // defaults
    const mediaAttributes = media.attributes || {};
    if (mediaAttributes.CODECS) return (0, $jv51Y.parseCodecs)(mediaAttributes.CODECS);
};
const $cb03b711053a4297$var$isMaat = (main, media)=>{
    const mediaAttributes = media.attributes || {};
    return main && main.mediaGroups && main.mediaGroups.AUDIO && mediaAttributes.AUDIO && main.mediaGroups.AUDIO[mediaAttributes.AUDIO];
};
const $cb03b711053a4297$var$isMuxed = (main, media)=>{
    if (!$cb03b711053a4297$var$isMaat(main, media)) return true;
    const mediaAttributes = media.attributes || {};
    const audioGroup = main.mediaGroups.AUDIO[mediaAttributes.AUDIO];
    for(const groupId in audioGroup){
        // If an audio group has a URI (the case for HLS, as HLS will use external playlists),
        // or there are listed playlists (the case for DASH, as the manifest will have already
        // provided all of the details necessary to generate the audio playlist, as opposed to
        // HLS' externally requested playlists), then the content is demuxed.
        if (!audioGroup[groupId].uri && !audioGroup[groupId].playlists) return true;
    }
    return false;
};
const $cb03b711053a4297$var$unwrapCodecList = function(codecList) {
    const codecs = {};
    codecList.forEach(({ mediaType: mediaType, type: type, details: details })=>{
        codecs[mediaType] = codecs[mediaType] || [];
        codecs[mediaType].push((0, $jv51Y.translateLegacyCodec)(`${type}${details}`));
    });
    Object.keys(codecs).forEach(function(mediaType) {
        if (codecs[mediaType].length > 1) {
            $cb03b711053a4297$var$logFn$1(`multiple ${mediaType} codecs found as attributes: ${codecs[mediaType].join(', ')}. Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.`);
            codecs[mediaType] = null;
            return;
        }
        codecs[mediaType] = codecs[mediaType][0];
    });
    return codecs;
};
const $cb03b711053a4297$var$codecCount = function(codecObj) {
    let count = 0;
    if (codecObj.audio) count++;
    if (codecObj.video) count++;
    return count;
};
/**
 * Calculates the codec strings for a working configuration of
 * SourceBuffers to play variant streams in a main playlist. If
 * there is no possible working configuration, an empty object will be
 * returned.
 *
 * @param main {Object} the m3u8 object for the main playlist
 * @param media {Object} the m3u8 object for the variant playlist
 * @return {Object} the codec strings.
 *
 * @private
 */ const $cb03b711053a4297$var$codecsForPlaylist = function(main, media) {
    const mediaAttributes = media.attributes || {};
    const codecInfo = $cb03b711053a4297$var$unwrapCodecList($cb03b711053a4297$var$getCodecs(media) || []); // HLS with multiple-audio tracks must always get an audio codec.
    // Put another way, there is no way to have a video-only multiple-audio HLS!
    if ($cb03b711053a4297$var$isMaat(main, media) && !codecInfo.audio) {
        if (!$cb03b711053a4297$var$isMuxed(main, media)) {
            // It is possible for codecs to be specified on the audio media group playlist but
            // not on the rendition playlist. This is mostly the case for DASH, where audio and
            // video are always separate (and separately specified).
            const defaultCodecs = $cb03b711053a4297$var$unwrapCodecList((0, $jv51Y.codecsFromDefault)(main, mediaAttributes.AUDIO) || []);
            if (defaultCodecs.audio) codecInfo.audio = defaultCodecs.audio;
        }
    }
    return codecInfo;
};
const { EventTarget: $cb03b711053a4297$var$EventTarget$1 } = $cb03b711053a4297$export$2e2bcd8739ae039;
const $cb03b711053a4297$var$addLLHLSQueryDirectives = (uri, media)=>{
    if (media.endList || !media.serverControl) return uri;
    const parameters = {};
    if (media.serverControl.canBlockReload) {
        const { preloadSegment: preloadSegment } = media; // next msn is a zero based value, length is not.
        let nextMSN = media.mediaSequence + media.segments.length; // If preload segment has parts then it is likely
        // that we are going to request a part of that preload segment.
        // the logic below is used to determine that.
        if (preloadSegment) {
            const parts = preloadSegment.parts || []; // _HLS_part is a zero based index
            const nextPart = $cb03b711053a4297$var$getKnownPartCount(media) - 1; // if nextPart is > -1 and not equal to just the
            // length of parts, then we know we had part preload hints
            // and we need to add the _HLS_part= query
            if (nextPart > -1 && nextPart !== parts.length - 1) // add existing parts to our preload hints
            // eslint-disable-next-line
            parameters._HLS_part = nextPart;
             // this if statement makes sure that we request the msn
            // of the preload segment if:
            // 1. the preload segment had parts (and was not yet a full segment)
            //    but was added to our segments array
            // 2. the preload segment had preload hints for parts that are not in
            //    the manifest yet.
            // in all other cases we want the segment after the preload segment
            // which will be given by using media.segments.length because it is 1 based
            // rather than 0 based.
            if (nextPart > -1 || parts.length) nextMSN--;
        } // add _HLS_msn= in front of any _HLS_part query
        // eslint-disable-next-line
        parameters._HLS_msn = nextMSN;
    }
    if (media.serverControl && media.serverControl.canSkipUntil) // add _HLS_skip= infront of all other queries.
    // eslint-disable-next-line
    parameters._HLS_skip = media.serverControl.canSkipDateranges ? 'v2' : 'YES';
    if (Object.keys(parameters).length) {
        const parsedUri = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL(uri);
        [
            '_HLS_skip',
            '_HLS_msn',
            '_HLS_part'
        ].forEach(function(name) {
            if (!parameters.hasOwnProperty(name)) return;
            parsedUri.searchParams.set(name, parameters[name]);
        });
        uri = parsedUri.toString();
    }
    return uri;
};
/**
 * Returns a new segment object with properties and
 * the parts array merged.
 *
 * @param {Object} a the old segment
 * @param {Object} b the new segment
 *
 * @return {Object} the merged segment
 */ const $cb03b711053a4297$var$updateSegment = (a, b)=>{
    if (!a) return b;
    const result = $cb03b711053a4297$var$merge(a, b); // if only the old segment has preload hints
    // and the new one does not, remove preload hints.
    if (a.preloadHints && !b.preloadHints) delete result.preloadHints;
     // if only the old segment has parts
    // then the parts are no longer valid
    if (a.parts && !b.parts) delete result.parts; // if both segments have parts
    else if (a.parts && b.parts) {
        for(let i = 0; i < b.parts.length; i++)if (a.parts && a.parts[i]) result.parts[i] = $cb03b711053a4297$var$merge(a.parts[i], b.parts[i]);
    } // set skipped to false for segments that have
    // have had information merged from the old segment.
    if (!a.skipped && b.skipped) result.skipped = false;
     // set preload to false for segments that have
    // had information added in the new segment.
    if (a.preload && !b.preload) result.preload = false;
    return result;
};
/**
 * Returns a new array of segments that is the result of merging
 * properties from an older list of segments onto an updated
 * list. No properties on the updated playlist will be ovewritten.
 *
 * @param {Array} original the outdated list of segments
 * @param {Array} update the updated list of segments
 * @param {number=} offset the index of the first update
 * segment in the original segment list. For non-live playlists,
 * this should always be zero and does not need to be
 * specified. For live playlists, it should be the difference
 * between the media sequence numbers in the original and updated
 * playlists.
 * @return {Array} a list of merged segment objects
 */ const $cb03b711053a4297$var$updateSegments = (original, update, offset)=>{
    const oldSegments = original.slice();
    const newSegments = update.slice();
    offset = offset || 0;
    const result = [];
    let currentMap;
    for(let newIndex = 0; newIndex < newSegments.length; newIndex++){
        const oldSegment = oldSegments[newIndex + offset];
        const newSegment = newSegments[newIndex];
        if (oldSegment) {
            currentMap = oldSegment.map || currentMap;
            result.push($cb03b711053a4297$var$updateSegment(oldSegment, newSegment));
        } else {
            // carry over map to new segment if it is missing
            if (currentMap && !newSegment.map) newSegment.map = currentMap;
            result.push(newSegment);
        }
    }
    return result;
};
const $cb03b711053a4297$var$resolveSegmentUris = (segment, baseUri)=>{
    // preloadSegment will not have a uri at all
    // as the segment isn't actually in the manifest yet, only parts
    if (!segment.resolvedUri && segment.uri) segment.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, segment.uri);
    if (segment.key && !segment.key.resolvedUri) segment.key.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, segment.key.uri);
    if (segment.map && !segment.map.resolvedUri) segment.map.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, segment.map.uri);
    if (segment.map && segment.map.key && !segment.map.key.resolvedUri) segment.map.key.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, segment.map.key.uri);
    if (segment.parts && segment.parts.length) segment.parts.forEach((p)=>{
        if (p.resolvedUri) return;
        p.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, p.uri);
    });
    if (segment.preloadHints && segment.preloadHints.length) segment.preloadHints.forEach((p)=>{
        if (p.resolvedUri) return;
        p.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, p.uri);
    });
};
const $cb03b711053a4297$var$getAllSegments = function(media) {
    const segments = media.segments || [];
    const preloadSegment = media.preloadSegment; // a preloadSegment with only preloadHints is not currently
    // a usable segment, only include a preloadSegment that has
    // parts.
    if (preloadSegment && preloadSegment.parts && preloadSegment.parts.length) {
        // if preloadHints has a MAP that means that the
        // init segment is going to change. We cannot use any of the parts
        // from this preload segment.
        if (preloadSegment.preloadHints) for(let i = 0; i < preloadSegment.preloadHints.length; i++){
            if (preloadSegment.preloadHints[i].type === 'MAP') return segments;
        }
         // set the duration for our preload segment to target duration.
        preloadSegment.duration = media.targetDuration;
        preloadSegment.preload = true;
        segments.push(preloadSegment);
    }
    return segments;
}; // consider the playlist unchanged if the playlist object is the same or
// the number of segments is equal, the media sequence number is unchanged,
// and this playlist hasn't become the end of the playlist
const $cb03b711053a4297$var$isPlaylistUnchanged = (a, b)=>a === b || a.segments && b.segments && a.segments.length === b.segments.length && a.endList === b.endList && a.mediaSequence === b.mediaSequence && a.preloadSegment === b.preloadSegment;
/**
  * Returns a new main playlist that is the result of merging an
  * updated media playlist into the original version. If the
  * updated media playlist does not match any of the playlist
  * entries in the original main playlist, null is returned.
  *
  * @param {Object} main a parsed main M3U8 object
  * @param {Object} media a parsed media M3U8 object
  * @return {Object} a new object that represents the original
  * main playlist with the updated media playlist merged in, or
  * null if the merge produced no change.
  */ const $cb03b711053a4297$var$updateMain$1 = (main, newMedia, unchangedCheck = $cb03b711053a4297$var$isPlaylistUnchanged)=>{
    const result = $cb03b711053a4297$var$merge(main, {});
    const oldMedia = result.playlists[newMedia.id];
    if (!oldMedia) return null;
    if (unchangedCheck(oldMedia, newMedia)) return null;
    newMedia.segments = $cb03b711053a4297$var$getAllSegments(newMedia);
    const mergedPlaylist = $cb03b711053a4297$var$merge(oldMedia, newMedia); // always use the new media's preload segment
    if (mergedPlaylist.preloadSegment && !newMedia.preloadSegment) delete mergedPlaylist.preloadSegment;
     // if the update could overlap existing segment information, merge the two segment lists
    if (oldMedia.segments) {
        if (newMedia.skip) {
            newMedia.segments = newMedia.segments || []; // add back in objects for skipped segments, so that we merge
            // old properties into the new segments
            for(let i = 0; i < newMedia.skip.skippedSegments; i++)newMedia.segments.unshift({
                skipped: true
            });
        }
        mergedPlaylist.segments = $cb03b711053a4297$var$updateSegments(oldMedia.segments, newMedia.segments, newMedia.mediaSequence - oldMedia.mediaSequence);
    } // resolve any segment URIs to prevent us from having to do it later
    mergedPlaylist.segments.forEach((segment)=>{
        $cb03b711053a4297$var$resolveSegmentUris(segment, mergedPlaylist.resolvedUri);
    }); // TODO Right now in the playlists array there are two references to each playlist, one
    // that is referenced by index, and one by URI. The index reference may no longer be
    // necessary.
    for(let i = 0; i < result.playlists.length; i++)if (result.playlists[i].id === newMedia.id) result.playlists[i] = mergedPlaylist;
    result.playlists[newMedia.id] = mergedPlaylist; // URI reference added for backwards compatibility
    result.playlists[newMedia.uri] = mergedPlaylist; // update media group playlist references.
    $cb03b711053a4297$var$forEachMediaGroup(main, (properties, mediaType, groupKey, labelKey)=>{
        if (!properties.playlists) return;
        for(let i = 0; i < properties.playlists.length; i++)if (newMedia.id === properties.playlists[i].id) properties.playlists[i] = mergedPlaylist;
    });
    return result;
};
/**
 * Calculates the time to wait before refreshing a live playlist
 *
 * @param {Object} media
 *        The current media
 * @param {boolean} update
 *        True if there were any updates from the last refresh, false otherwise
 * @return {number}
 *         The time in ms to wait before refreshing the live playlist
 */ const $cb03b711053a4297$var$refreshDelay = (media, update)=>{
    const segments = media.segments || [];
    const lastSegment = segments[segments.length - 1];
    const lastPart = lastSegment && lastSegment.parts && lastSegment.parts[lastSegment.parts.length - 1];
    const lastDuration = lastPart && lastPart.duration || lastSegment && lastSegment.duration;
    if (update && lastDuration) return lastDuration * 1000;
     // if the playlist is unchanged since the last reload or last segment duration
    // cannot be determined, try again after half the target duration
    return (media.partTargetDuration || media.targetDuration || 10) * 500;
};
const $cb03b711053a4297$var$playlistMetadataPayload = (playlists, type, isLive)=>{
    if (!playlists) return;
    const renditions = [];
    playlists.forEach((playlist)=>{
        // we need attributes to populate rendition data.
        if (!playlist.attributes) return;
        const { BANDWIDTH: BANDWIDTH, RESOLUTION: RESOLUTION, CODECS: CODECS } = playlist.attributes;
        renditions.push({
            id: playlist.id,
            bandwidth: BANDWIDTH,
            resolution: RESOLUTION,
            codecs: CODECS
        });
    });
    return {
        type: type,
        isLive: isLive,
        renditions: renditions
    };
};
/**
 * Load a playlist from a remote location
 *
 * @class PlaylistLoader
 * @extends Stream
 * @param {string|Object} src url or object of manifest
 * @param {boolean} withCredentials the withCredentials xhr option
 * @class
 */ class $cb03b711053a4297$var$PlaylistLoader extends $cb03b711053a4297$var$EventTarget$1 {
    constructor(src, vhs, options = {}){
        super();
        if (!src) throw new Error('A non-empty playlist URL or object is required');
        this.logger_ = $cb03b711053a4297$var$logger('PlaylistLoader');
        const { withCredentials: withCredentials = false } = options;
        this.src = src;
        this.vhs_ = vhs;
        this.withCredentials = withCredentials;
        this.addDateRangesToTextTrack_ = options.addDateRangesToTextTrack;
        const vhsOptions = vhs.options_;
        this.customTagParsers = vhsOptions && vhsOptions.customTagParsers || [];
        this.customTagMappers = vhsOptions && vhsOptions.customTagMappers || [];
        this.llhls = vhsOptions && vhsOptions.llhls;
        this.dateRangesStorage_ = new $cb03b711053a4297$var$DateRangesStorage(); // initialize the loader state
        this.state = 'HAVE_NOTHING'; // live playlist staleness timeout
        this.handleMediaupdatetimeout_ = this.handleMediaupdatetimeout_.bind(this);
        this.on('mediaupdatetimeout', this.handleMediaupdatetimeout_);
        this.on('loadedplaylist', this.handleLoadedPlaylist_.bind(this));
    }
    handleLoadedPlaylist_() {
        const mediaPlaylist = this.media();
        if (!mediaPlaylist) return;
        this.dateRangesStorage_.setOffset(mediaPlaylist.segments);
        this.dateRangesStorage_.setPendingDateRanges(mediaPlaylist.dateRanges);
        const availableDateRanges = this.dateRangesStorage_.getDateRangesToProcess();
        if (!availableDateRanges.length || !this.addDateRangesToTextTrack_) return;
        this.addDateRangesToTextTrack_(availableDateRanges);
    }
    handleMediaupdatetimeout_() {
        if (this.state !== 'HAVE_METADATA') // only refresh the media playlist if no other activity is going on
        return;
        const media = this.media();
        let uri = $cb03b711053a4297$var$resolveUrl(this.main.uri, media.uri);
        if (this.llhls) uri = $cb03b711053a4297$var$addLLHLSQueryDirectives(uri, media);
        this.state = 'HAVE_CURRENT_METADATA';
        this.request = this.vhs_.xhr({
            uri: uri,
            withCredentials: this.withCredentials,
            requestType: 'hls-playlist'
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
            if (error) return this.playlistRequestError(this.request, this.media(), 'HAVE_METADATA');
            this.haveMetadata({
                playlistString: this.request.responseText,
                url: this.media().uri,
                id: this.media().id
            });
        });
    }
    playlistRequestError(xhr, playlist, startingState) {
        const { uri: uri, id: id } = playlist; // any in-flight request is now finished
        this.request = null;
        if (startingState) this.state = startingState;
        this.error = {
            playlist: this.main.playlists[id],
            status: xhr.status,
            message: `HLS playlist request error at URL: ${uri}.`,
            responseText: xhr.responseText,
            code: xhr.status >= 500 ? 4 : 2,
            metadata: $cb03b711053a4297$var$getStreamingNetworkErrorMetadata({
                requestType: xhr.requestType,
                request: xhr,
                error: xhr.error
            })
        };
        this.trigger('error');
    }
    parseManifest_({ url: url, manifestString: manifestString }) {
        try {
            const parsed = $cb03b711053a4297$var$parseManifest({
                onwarn: ({ message: message })=>this.logger_(`m3u8-parser warn for ${url}: ${message}`),
                oninfo: ({ message: message })=>this.logger_(`m3u8-parser info for ${url}: ${message}`),
                manifestString: manifestString,
                customTagParsers: this.customTagParsers,
                customTagMappers: this.customTagMappers,
                llhls: this.llhls
            });
            /**
       * VHS does not support switching between variants with and without audio and video
       * so we want to filter out audio-only variants when variants with video and(or) audio are also detected.
       */ if (!parsed.playlists || !parsed.playlists.length) return parsed;
            this.excludeAudioOnlyVariants(parsed.playlists);
            return parsed;
        } catch (error) {
            this.error = error;
            this.error.metadata = {
                errorType: $cb03b711053a4297$export$2e2bcd8739ae039.Error.StreamingHlsPlaylistParserError,
                error: error
            };
        }
    }
    excludeAudioOnlyVariants(playlists) {
        // helper function
        const hasVideo = (playlist)=>{
            const attributes = playlist.attributes || {};
            const { width: width, height: height } = attributes.RESOLUTION || {};
            if (width && height) return true;
             // parse codecs string from playlist attributes
            const codecsList = $cb03b711053a4297$var$getCodecs(playlist) || []; // unwrap list
            const codecsInfo = $cb03b711053a4297$var$unwrapCodecList(codecsList);
            return Boolean(codecsInfo.video);
        };
        if (playlists.some(hasVideo)) playlists.forEach((playlist)=>{
            if (!hasVideo(playlist)) playlist.excludeUntil = Infinity;
        });
    }
    /**
   * Update the playlist loader's state in response to a new or updated playlist.
   *
   * @param {string} [playlistString]
   *        Playlist string (if playlistObject is not provided)
   * @param {Object} [playlistObject]
   *        Playlist object (if playlistString is not provided)
   * @param {string} url
   *        URL of playlist
   * @param {string} id
   *        ID to use for playlist
   */ haveMetadata({ playlistString: playlistString, playlistObject: playlistObject, url: url, id: id }) {
        // any in-flight request is now finished
        this.request = null;
        this.state = 'HAVE_METADATA';
        const metadata = {
            playlistInfo: {
                type: 'media',
                uri: url
            }
        };
        this.trigger({
            type: 'playlistparsestart',
            metadata: metadata
        });
        const playlist = playlistObject || this.parseManifest_({
            url: url,
            manifestString: playlistString
        });
        playlist.lastRequest = Date.now();
        $cb03b711053a4297$var$setupMediaPlaylist({
            playlist: playlist,
            uri: url,
            id: id
        }); // merge this playlist into the main manifest
        const update = $cb03b711053a4297$var$updateMain$1(this.main, playlist);
        this.targetDuration = playlist.partTargetDuration || playlist.targetDuration;
        this.pendingMedia_ = null;
        if (update) {
            this.main = update;
            this.media_ = this.main.playlists[id];
        } else this.trigger('playlistunchanged');
        this.updateMediaUpdateTimeout_($cb03b711053a4297$var$refreshDelay(this.media(), !!update));
        metadata.parsedPlaylist = $cb03b711053a4297$var$playlistMetadataPayload(this.main.playlists, metadata.playlistInfo.type, !this.media_.endList);
        this.trigger({
            type: 'playlistparsecomplete',
            metadata: metadata
        });
        this.trigger('loadedplaylist');
    }
    /**
    * Abort any outstanding work and clean up.
    */ dispose() {
        this.trigger('dispose');
        this.stopRequest();
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.finalRenditionTimeout);
        this.dateRangesStorage_ = new $cb03b711053a4297$var$DateRangesStorage();
        this.off();
    }
    stopRequest() {
        if (this.request) {
            const oldRequest = this.request;
            this.request = null;
            oldRequest.onreadystatechange = null;
            oldRequest.abort();
        }
    }
    /**
    * When called without any arguments, returns the currently
    * active media playlist. When called with a single argument,
    * triggers the playlist loader to asynchronously switch to the
    * specified media playlist. Calling this method while the
    * loader is in the HAVE_NOTHING causes an error to be emitted
    * but otherwise has no effect.
    *
    * @param {Object=} playlist the parsed media playlist
    * object to switch to
    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
    *
    * @return {Playlist} the current loaded media
    */ media(playlist, shouldDelay) {
        // getter
        if (!playlist) return this.media_;
         // setter
        if (this.state === 'HAVE_NOTHING') throw new Error('Cannot switch media playlist from ' + this.state);
         // find the playlist object if the target playlist has been
        // specified by URI
        if (typeof playlist === 'string') {
            if (!this.main.playlists[playlist]) throw new Error('Unknown playlist URI: ' + playlist);
            playlist = this.main.playlists[playlist];
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.finalRenditionTimeout);
        if (shouldDelay) {
            const delay = (playlist.partTargetDuration || playlist.targetDuration) / 2 * 1000 || 5000;
            this.finalRenditionTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(this.media.bind(this, playlist, false), delay);
            return;
        }
        const startingState = this.state;
        const mediaChange = !this.media_ || playlist.id !== this.media_.id;
        const mainPlaylistRef = this.main.playlists[playlist.id]; // switch to fully loaded playlists immediately
        if (mainPlaylistRef && mainPlaylistRef.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
        // media playlist or, for the case of demuxed audio, a resolved audio media group)
        playlist.endList && playlist.segments.length) {
            // abort outstanding playlist requests
            if (this.request) {
                this.request.onreadystatechange = null;
                this.request.abort();
                this.request = null;
            }
            this.state = 'HAVE_METADATA';
            this.media_ = playlist; // trigger media change if the active media has been updated
            if (mediaChange) {
                this.trigger('mediachanging');
                if (startingState === 'HAVE_MAIN_MANIFEST') // The initial playlist was a main manifest, and the first media selected was
                // also provided (in the form of a resolved playlist object) as part of the
                // source object (rather than just a URL). Therefore, since the media playlist
                // doesn't need to be requested, loadedmetadata won't trigger as part of the
                // normal flow, and needs an explicit trigger here.
                this.trigger('loadedmetadata');
                else this.trigger('mediachange');
            }
            return;
        } // We update/set the timeout here so that live playlists
        // that are not a media change will "start" the loader as expected.
        // We expect that this function will start the media update timeout
        // cycle again. This also prevents a playlist switch failure from
        // causing us to stall during live.
        this.updateMediaUpdateTimeout_($cb03b711053a4297$var$refreshDelay(playlist, true)); // switching to the active playlist is a no-op
        if (!mediaChange) return;
        this.state = 'SWITCHING_MEDIA'; // there is already an outstanding playlist request
        if (this.request) {
            if (playlist.resolvedUri === this.request.url) // requesting to switch to the same playlist multiple times
            // has no effect after the first
            return;
            this.request.onreadystatechange = null;
            this.request.abort();
            this.request = null;
        } // request the new playlist
        if (this.media_) this.trigger('mediachanging');
        this.pendingMedia_ = playlist;
        const metadata = {
            playlistInfo: {
                type: 'media',
                uri: playlist.uri
            }
        };
        this.trigger({
            type: 'playlistrequeststart',
            metadata: metadata
        });
        this.request = this.vhs_.xhr({
            uri: playlist.resolvedUri,
            withCredentials: this.withCredentials,
            requestType: 'hls-playlist'
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
            playlist.lastRequest = Date.now();
            playlist.resolvedUri = $cb03b711053a4297$var$resolveManifestRedirect(playlist.resolvedUri, req);
            if (error) return this.playlistRequestError(this.request, playlist, startingState);
            this.trigger({
                type: 'playlistrequestcomplete',
                metadata: metadata
            });
            this.haveMetadata({
                playlistString: req.responseText,
                url: playlist.uri,
                id: playlist.id
            }); // fire loadedmetadata the first time a media playlist is loaded
            if (startingState === 'HAVE_MAIN_MANIFEST') this.trigger('loadedmetadata');
            else this.trigger('mediachange');
        });
    }
    /**
   * pause loading of the playlist
   */ pause() {
        if (this.mediaUpdateTimeout) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
            this.mediaUpdateTimeout = null;
        }
        this.stopRequest();
        if (this.state === 'HAVE_NOTHING') // If we pause the loader before any data has been retrieved, its as if we never
        // started, so reset to an unstarted state.
        this.started = false;
         // Need to restore state now that no activity is happening
        if (this.state === 'SWITCHING_MEDIA') {
            // if the loader was in the process of switching media, it should either return to
            // HAVE_MAIN_MANIFEST or HAVE_METADATA depending on if the loader has loaded a media
            // playlist yet. This is determined by the existence of loader.media_
            if (this.media_) this.state = 'HAVE_METADATA';
            else this.state = 'HAVE_MAIN_MANIFEST';
        } else if (this.state === 'HAVE_CURRENT_METADATA') this.state = 'HAVE_METADATA';
    }
    /**
   * start loading of the playlist
   */ load(shouldDelay) {
        if (this.mediaUpdateTimeout) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
            this.mediaUpdateTimeout = null;
        }
        const media = this.media();
        if (shouldDelay) {
            const delay = media ? (media.partTargetDuration || media.targetDuration) / 2 * 1000 : 5000;
            this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
                this.mediaUpdateTimeout = null;
                this.load();
            }, delay);
            return;
        }
        if (!this.started) {
            this.start();
            return;
        }
        if (media && !media.endList) this.trigger('mediaupdatetimeout');
        else this.trigger('loadedplaylist');
    }
    updateMediaUpdateTimeout_(delay) {
        if (this.mediaUpdateTimeout) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
            this.mediaUpdateTimeout = null;
        } // we only have use mediaupdatetimeout for live playlists.
        if (!this.media() || this.media().endList) return;
        this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            this.mediaUpdateTimeout = null;
            this.trigger('mediaupdatetimeout');
            this.updateMediaUpdateTimeout_(delay);
        }, delay);
    }
    /**
   * start loading of the playlist
   */ start() {
        this.started = true;
        if (typeof this.src === 'object') {
            // in the case of an entirely constructed manifest object (meaning there's no actual
            // manifest on a server), default the uri to the page's href
            if (!this.src.uri) this.src.uri = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href;
             // resolvedUri is added on internally after the initial request. Since there's no
            // request for pre-resolved manifests, add on resolvedUri here.
            this.src.resolvedUri = this.src.uri; // Since a manifest object was passed in as the source (instead of a URL), the first
            // request can be skipped (since the top level of the manifest, at a minimum, is
            // already available as a parsed manifest object). However, if the manifest object
            // represents a main playlist, some media playlists may need to be resolved before
            // the starting segment list is available. Therefore, go directly to setup of the
            // initial playlist, and let the normal flow continue from there.
            //
            // Note that the call to setup is asynchronous, as other sections of VHS may assume
            // that the first request is asynchronous.
            setTimeout(()=>{
                this.setupInitialPlaylist(this.src);
            }, 0);
            return;
        }
        const metadata = {
            playlistInfo: {
                type: 'multivariant',
                uri: this.src
            }
        };
        this.trigger({
            type: 'playlistrequeststart',
            metadata: metadata
        }); // request the specified URL
        this.request = this.vhs_.xhr({
            uri: this.src,
            withCredentials: this.withCredentials,
            requestType: 'hls-playlist'
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
             // clear the loader's request reference
            this.request = null;
            if (error) {
                this.error = {
                    status: req.status,
                    message: `HLS playlist request error at URL: ${this.src}.`,
                    responseText: req.responseText,
                    // MEDIA_ERR_NETWORK
                    code: 2,
                    metadata: $cb03b711053a4297$var$getStreamingNetworkErrorMetadata({
                        requestType: req.requestType,
                        request: req,
                        error: error
                    })
                };
                if (this.state === 'HAVE_NOTHING') this.started = false;
                return this.trigger('error');
            }
            this.trigger({
                type: 'playlistrequestcomplete',
                metadata: metadata
            });
            this.src = $cb03b711053a4297$var$resolveManifestRedirect(this.src, req);
            this.trigger({
                type: 'playlistparsestart',
                metadata: metadata
            });
            const manifest = this.parseManifest_({
                manifestString: req.responseText,
                url: this.src
            }); // we haven't loaded any variant playlists here so we default to false for isLive.
            metadata.parsedPlaylist = $cb03b711053a4297$var$playlistMetadataPayload(manifest.playlists, metadata.playlistInfo.type, false);
            this.trigger({
                type: 'playlistparsecomplete',
                metadata: metadata
            });
            this.setupInitialPlaylist(manifest);
        });
    }
    srcUri() {
        return typeof this.src === 'string' ? this.src : this.src.uri;
    }
    /**
   * Given a manifest object that's either a main or media playlist, trigger the proper
   * events and set the state of the playlist loader.
   *
   * If the manifest object represents a main playlist, `loadedplaylist` will be
   * triggered to allow listeners to select a playlist. If none is selected, the loader
   * will default to the first one in the playlists array.
   *
   * If the manifest object represents a media playlist, `loadedplaylist` will be
   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
   *
   * In the case of a media playlist, a main playlist object wrapper with one playlist
   * will be created so that all logic can handle playlists in the same fashion (as an
   * assumed manifest object schema).
   *
   * @param {Object} manifest
   *        The parsed manifest object
   */ setupInitialPlaylist(manifest) {
        this.state = 'HAVE_MAIN_MANIFEST';
        if (manifest.playlists) {
            this.main = manifest;
            $cb03b711053a4297$var$addPropertiesToMain(this.main, this.srcUri()); // If the initial main playlist has playlists wtih segments already resolved,
            // then resolve URIs in advance, as they are usually done after a playlist request,
            // which may not happen if the playlist is resolved.
            manifest.playlists.forEach((playlist)=>{
                playlist.segments = $cb03b711053a4297$var$getAllSegments(playlist);
                playlist.segments.forEach((segment)=>{
                    $cb03b711053a4297$var$resolveSegmentUris(segment, playlist.resolvedUri);
                });
            });
            this.trigger('loadedplaylist');
            if (!this.request) // no media playlist was specifically selected so start
            // from the first listed one
            this.media(this.main.playlists[0]);
            return;
        } // In order to support media playlists passed in as vhs-json, the case where the uri
        // is not provided as part of the manifest should be considered, and an appropriate
        // default used.
        const uri = this.srcUri() || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href;
        this.main = $cb03b711053a4297$var$mainForMedia(manifest, uri);
        this.haveMetadata({
            playlistObject: manifest,
            url: uri,
            id: this.main.playlists[0].id
        });
        this.trigger('loadedmetadata');
    }
    /**
   * Updates or deletes a preexisting pathway clone.
   * Ensures that all playlists related to the old pathway clone are
   * either updated or deleted.
   *
   * @param {Object} clone On update, the pathway clone object for the newly updated pathway clone.
   *        On delete, the old pathway clone object to be deleted.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */ updateOrDeleteClone(clone, isUpdate) {
        const main = this.main;
        const pathway = clone.ID;
        let i = main.playlists.length; // Iterate backwards through the playlist so we can remove playlists if necessary.
        while(i--){
            const p = main.playlists[i];
            if (p.attributes['PATHWAY-ID'] === pathway) {
                const oldPlaylistUri = p.resolvedUri;
                const oldPlaylistId = p.id; // update the indexed playlist and add new playlists by ID and URI
                if (isUpdate) {
                    const newPlaylistUri = this.createCloneURI_(p.resolvedUri, clone);
                    const newPlaylistId = $cb03b711053a4297$var$createPlaylistID(pathway, newPlaylistUri);
                    const attributes = this.createCloneAttributes_(pathway, p.attributes);
                    const updatedPlaylist = this.createClonePlaylist_(p, newPlaylistId, clone, attributes);
                    main.playlists[i] = updatedPlaylist;
                    main.playlists[newPlaylistId] = updatedPlaylist;
                    main.playlists[newPlaylistUri] = updatedPlaylist;
                } else // Remove the indexed playlist.
                main.playlists.splice(i, 1);
                 // Remove playlists by the old ID and URI.
                delete main.playlists[oldPlaylistId];
                delete main.playlists[oldPlaylistUri];
            }
        }
        this.updateOrDeleteCloneMedia(clone, isUpdate);
    }
    /**
   * Updates or deletes media data based on the pathway clone object.
   * Due to the complexity of the media groups and playlists, in all cases
   * we remove all of the old media groups and playlists.
   * On updates, we then create new media groups and playlists based on the
   * new pathway clone object.
   *
   * @param {Object} clone The pathway clone object for the newly updated pathway clone.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */ updateOrDeleteCloneMedia(clone, isUpdate) {
        const main = this.main;
        const id = clone.ID;
        [
            'AUDIO',
            'SUBTITLES',
            'CLOSED-CAPTIONS'
        ].forEach((mediaType)=>{
            if (!main.mediaGroups[mediaType] || !main.mediaGroups[mediaType][id]) return;
            for(const groupKey in main.mediaGroups[mediaType])// Remove all media playlists for the media group for this pathway clone.
            if (groupKey === id) {
                for(const labelKey in main.mediaGroups[mediaType][groupKey]){
                    const oldMedia = main.mediaGroups[mediaType][groupKey][labelKey];
                    oldMedia.playlists.forEach((p, i)=>{
                        const oldMediaPlaylist = main.playlists[p.id];
                        const oldPlaylistId = oldMediaPlaylist.id;
                        const oldPlaylistUri = oldMediaPlaylist.resolvedUri;
                        delete main.playlists[oldPlaylistId];
                        delete main.playlists[oldPlaylistUri];
                    });
                } // Delete the old media group.
                delete main.mediaGroups[mediaType][groupKey];
            }
        }); // Create the new media groups and playlists if there is an update.
        if (isUpdate) this.createClonedMediaGroups_(clone);
    }
    /**
   * Given a pathway clone object, clones all necessary playlists.
   *
   * @param {Object} clone The pathway clone object.
   * @param {Object} basePlaylist The original playlist to clone from.
   */ addClonePathway(clone, basePlaylist = {}) {
        const main = this.main;
        const index = main.playlists.length;
        const uri = this.createCloneURI_(basePlaylist.resolvedUri, clone);
        const playlistId = $cb03b711053a4297$var$createPlaylistID(clone.ID, uri);
        const attributes = this.createCloneAttributes_(clone.ID, basePlaylist.attributes);
        const playlist = this.createClonePlaylist_(basePlaylist, playlistId, clone, attributes);
        main.playlists[index] = playlist; // add playlist by ID and URI
        main.playlists[playlistId] = playlist;
        main.playlists[uri] = playlist;
        this.createClonedMediaGroups_(clone);
    }
    /**
   * Given a pathway clone object we create clones of all media.
   * In this function, all necessary information and updated playlists
   * are added to the `mediaGroup` object.
   * Playlists are also added to the `playlists` array so the media groups
   * will be properly linked.
   *
   * @param {Object} clone The pathway clone object.
   */ createClonedMediaGroups_(clone) {
        const id = clone.ID;
        const baseID = clone['BASE-ID'];
        const main = this.main;
        [
            'AUDIO',
            'SUBTITLES',
            'CLOSED-CAPTIONS'
        ].forEach((mediaType)=>{
            // If the media type doesn't exist, or there is already a clone, skip
            // to the next media type.
            if (!main.mediaGroups[mediaType] || main.mediaGroups[mediaType][id]) return;
            for(const groupKey in main.mediaGroups[mediaType]){
                if (groupKey === baseID) // Create the group.
                main.mediaGroups[mediaType][id] = {};
                else continue;
                for(const labelKey in main.mediaGroups[mediaType][groupKey]){
                    const oldMedia = main.mediaGroups[mediaType][groupKey][labelKey];
                    main.mediaGroups[mediaType][id][labelKey] = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, oldMedia);
                    const newMedia = main.mediaGroups[mediaType][id][labelKey]; // update URIs on the media
                    const newUri = this.createCloneURI_(oldMedia.resolvedUri, clone);
                    newMedia.resolvedUri = newUri;
                    newMedia.uri = newUri; // Reset playlists in the new media group.
                    newMedia.playlists = []; // Create new playlists in the newly cloned media group.
                    oldMedia.playlists.forEach((p, i)=>{
                        const oldMediaPlaylist = main.playlists[p.id];
                        const group = $cb03b711053a4297$var$groupID(mediaType, id, labelKey);
                        const newPlaylistID = $cb03b711053a4297$var$createPlaylistID(id, group); // Check to see if it already exists
                        if (oldMediaPlaylist && !main.playlists[newPlaylistID]) {
                            const newMediaPlaylist = this.createClonePlaylist_(oldMediaPlaylist, newPlaylistID, clone);
                            const newPlaylistUri = newMediaPlaylist.resolvedUri;
                            main.playlists[newPlaylistID] = newMediaPlaylist;
                            main.playlists[newPlaylistUri] = newMediaPlaylist;
                        }
                        newMedia.playlists[i] = this.createClonePlaylist_(p, newPlaylistID, clone);
                    });
                }
            }
        });
    }
    /**
   * Using the original playlist to be cloned, and the pathway clone object
   * information, we create a new playlist.
   *
   * @param {Object} basePlaylist  The original playlist to be cloned from.
   * @param {string} id The desired id of the newly cloned playlist.
   * @param {Object} clone The pathway clone object.
   * @param {Object} attributes An optional object to populate the `attributes` property in the playlist.
   *
   * @return {Object} The combined cloned playlist.
   */ createClonePlaylist_(basePlaylist, id, clone, attributes) {
        const uri = this.createCloneURI_(basePlaylist.resolvedUri, clone);
        const newProps = {
            resolvedUri: uri,
            uri: uri,
            id: id
        }; // Remove all segments from previous playlist in the clone.
        if (basePlaylist.segments) newProps.segments = [];
        if (attributes) newProps.attributes = attributes;
        return $cb03b711053a4297$var$merge(basePlaylist, newProps);
    }
    /**
   * Generates an updated URI for a cloned pathway based on the original
   * pathway's URI and the paramaters from the pathway clone object in the
   * content steering server response.
   *
   * @param {string} baseUri URI to be updated in the cloned pathway.
   * @param {Object} clone The pathway clone object.
   *
   * @return {string} The updated URI for the cloned pathway.
   */ createCloneURI_(baseURI, clone) {
        const uri = new URL(baseURI);
        uri.hostname = clone['URI-REPLACEMENT'].HOST;
        const params = clone['URI-REPLACEMENT'].PARAMS; // Add params to the cloned URL.
        for (const key of Object.keys(params))uri.searchParams.set(key, params[key]);
        return uri.href;
    }
    /**
   * Helper function to create the attributes needed for the new clone.
   * This mainly adds the necessary media attributes.
   *
   * @param {string} id The pathway clone object ID.
   * @param {Object} oldAttributes The old attributes to compare to.
   * @return {Object} The new attributes to add to the playlist.
   */ createCloneAttributes_(id, oldAttributes) {
        const attributes = {
            ['PATHWAY-ID']: id
        };
        [
            'AUDIO',
            'SUBTITLES',
            'CLOSED-CAPTIONS'
        ].forEach((mediaType)=>{
            if (oldAttributes[mediaType]) attributes[mediaType] = id;
        });
        return attributes;
    }
    /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */ getKeyIdSet(playlist) {
        const keyIds = new Set();
        if (!playlist || !playlist.contentProtection) return keyIds;
        for(const keysystem in playlist.contentProtection)if (playlist.contentProtection[keysystem] && playlist.contentProtection[keysystem].attributes && playlist.contentProtection[keysystem].attributes.keyId) {
            const keyId = playlist.contentProtection[keysystem].attributes.keyId;
            keyIds.add(keyId.toLowerCase());
        }
        return keyIds;
    }
}
/**
 * @file xhr.js
 */ const $cb03b711053a4297$var$callbackWrapper = function(request, error, response, callback) {
    const reqResponse = request.responseType === 'arraybuffer' ? request.response : request.responseText;
    if (!error && reqResponse) {
        request.responseTime = Date.now();
        request.roundTripTime = request.responseTime - request.requestTime;
        request.bytesReceived = reqResponse.byteLength || reqResponse.length;
        if (!request.bandwidth) request.bandwidth = Math.floor(request.bytesReceived / request.roundTripTime * 8000);
    }
    if (response.headers) request.responseHeaders = response.headers;
     // videojs.xhr now uses a specific code on the error
    // object to signal that a request has timed out instead
    // of setting a boolean on the request object
    if (error && error.code === 'ETIMEDOUT') request.timedout = true;
     // videojs.xhr no longer considers status codes outside of 200 and 0
    // (for file uris) to be errors, but the old XHR did, so emulate that
    // behavior. Status 206 may be used in response to byterange requests.
    if (!error && !request.aborted && response.statusCode !== 200 && response.statusCode !== 206 && response.statusCode !== 0) error = new Error('XHR Failed with a response of: ' + (request && (reqResponse || request.responseText)));
    callback(error, request);
};
/**
 * Iterates over the request hooks Set and calls them in order
 *
 * @param {Set} hooks the hook Set to iterate over
 * @param {Object} options the request options to pass to the xhr wrapper
 * @return the callback hook function return value, the modified or new options Object.
 */ const $cb03b711053a4297$var$callAllRequestHooks = (requestSet, options)=>{
    if (!requestSet || !requestSet.size) return;
    let newOptions = options;
    requestSet.forEach((requestCallback)=>{
        newOptions = requestCallback(newOptions);
    });
    return newOptions;
};
/**
 * Iterates over the response hooks Set and calls them in order.
 *
 * @param {Set} hooks the hook Set to iterate over
 * @param {Object} request the xhr request object
 * @param {Object} error the xhr error object
 * @param {Object} response the xhr response object
 */ const $cb03b711053a4297$var$callAllResponseHooks = (responseSet, request, error, response)=>{
    if (!responseSet || !responseSet.size) return;
    responseSet.forEach((responseCallback)=>{
        responseCallback(request, error, response);
    });
};
const $cb03b711053a4297$var$xhrFactory = function() {
    const xhr = function XhrFunction(options, callback) {
        // Add a default timeout
        options = $cb03b711053a4297$var$merge({
            timeout: 45e3
        }, options); // Allow an optional user-specified function to modify the option
        // object before we construct the xhr request
        // TODO: Remove beforeRequest in the next major release.
        const beforeRequest = XhrFunction.beforeRequest || $cb03b711053a4297$export$2e2bcd8739ae039.Vhs.xhr.beforeRequest; // onRequest and onResponse hooks as a Set, at either the player or global level.
        // TODO: new Set added here for beforeRequest alias. Remove this when beforeRequest is removed.
        const _requestCallbackSet = XhrFunction._requestCallbackSet || $cb03b711053a4297$export$2e2bcd8739ae039.Vhs.xhr._requestCallbackSet || new Set();
        const _responseCallbackSet = XhrFunction._responseCallbackSet || $cb03b711053a4297$export$2e2bcd8739ae039.Vhs.xhr._responseCallbackSet;
        if (beforeRequest && typeof beforeRequest === 'function') {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn('beforeRequest is deprecated, use onRequest instead.');
            _requestCallbackSet.add(beforeRequest);
        } // Use the standard videojs.xhr() method unless `videojs.Vhs.xhr` has been overriden
        // TODO: switch back to videojs.Vhs.xhr.name === 'XhrFunction' when we drop IE11
        const xhrMethod = $cb03b711053a4297$export$2e2bcd8739ae039.Vhs.xhr.original === true ? $cb03b711053a4297$export$2e2bcd8739ae039.xhr : $cb03b711053a4297$export$2e2bcd8739ae039.Vhs.xhr; // call all registered onRequest hooks, assign new options.
        const beforeRequestOptions = $cb03b711053a4297$var$callAllRequestHooks(_requestCallbackSet, options); // Remove the beforeRequest function from the hooks set so stale beforeRequest functions are not called.
        _requestCallbackSet.delete(beforeRequest); // xhrMethod will call XMLHttpRequest.open and XMLHttpRequest.send
        const request = xhrMethod(beforeRequestOptions || options, function(error, response) {
            // call all registered onResponse hooks
            $cb03b711053a4297$var$callAllResponseHooks(_responseCallbackSet, request, error, response);
            return $cb03b711053a4297$var$callbackWrapper(request, error, response, callback);
        });
        const originalAbort = request.abort;
        request.abort = function() {
            request.aborted = true;
            return originalAbort.apply(request, arguments);
        };
        request.uri = options.uri;
        request.requestType = options.requestType;
        request.requestTime = Date.now();
        return request;
    };
    xhr.original = true;
    return xhr;
};
/**
 * Turns segment byterange into a string suitable for use in
 * HTTP Range requests
 *
 * @param {Object} byterange - an object with two values defining the start and end
 *                             of a byte-range
 */ const $cb03b711053a4297$var$byterangeStr = function(byterange) {
    // `byterangeEnd` is one less than `offset + length` because the HTTP range
    // header uses inclusive ranges
    let byterangeEnd;
    const byterangeStart = byterange.offset;
    if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') byterangeEnd = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(byterange.offset) + (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(byterange.length) - (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(1);
    else byterangeEnd = byterange.offset + byterange.length - 1;
    return 'bytes=' + byterangeStart + '-' + byterangeEnd;
};
/**
 * Defines headers for use in the xhr request for a particular segment.
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 */ const $cb03b711053a4297$var$segmentXhrHeaders = function(segment) {
    const headers = {};
    if (segment.byterange) headers.Range = $cb03b711053a4297$var$byterangeStr(segment.byterange);
    return headers;
};
/**
 * @file bin-utils.js
 */ /**
 * convert a TimeRange to text
 *
 * @param {TimeRange} range the timerange to use for conversion
 * @param {number} i the iterator on the range to convert
 * @return {string} the range in string format
 */ const $cb03b711053a4297$var$textRange = function(range, i) {
    return range.start(i) + '-' + range.end(i);
};
/**
 * format a number as hex string
 *
 * @param {number} e The number
 * @param {number} i the iterator
 * @return {string} the hex formatted number as a string
 */ const $cb03b711053a4297$var$formatHexString = function(e, i) {
    const value = e.toString(16);
    return '00'.substring(0, 2 - value.length) + value + (i % 2 ? ' ' : '');
};
const $cb03b711053a4297$var$formatAsciiString = function(e) {
    if (e >= 0x20 && e < 0x7e) return String.fromCharCode(e);
    return '.';
};
/**
 * Creates an object for sending to a web worker modifying properties that are TypedArrays
 * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
 *
 * @param {Object} message
 *        Object of properties and values to send to the web worker
 * @return {Object}
 *         Modified message with TypedArray values expanded
 * @function createTransferableMessage
 */ const $cb03b711053a4297$var$createTransferableMessage = function(message) {
    const transferable = {};
    Object.keys(message).forEach((key)=>{
        const value = message[key];
        if ((0, $6vzZz.isArrayBufferView)(value)) transferable[key] = {
            bytes: value.buffer,
            byteOffset: value.byteOffset,
            byteLength: value.byteLength
        };
        else transferable[key] = value;
    });
    return transferable;
};
/**
 * Returns a unique string identifier for a media initialization
 * segment.
 *
 * @param {Object} initSegment
 *        the init segment object.
 *
 * @return {string} the generated init segment id
 */ const $cb03b711053a4297$var$initSegmentId = function(initSegment) {
    const byterange = initSegment.byterange || {
        length: Infinity,
        offset: 0
    };
    return [
        byterange.length,
        byterange.offset,
        initSegment.resolvedUri
    ].join(',');
};
/**
 * Returns a unique string identifier for a media segment key.
 *
 * @param {Object} key the encryption key
 * @return {string} the unique id for the media segment key.
 */ const $cb03b711053a4297$var$segmentKeyId = function(key) {
    return key.resolvedUri;
};
/**
 * utils to help dump binary data to the console
 *
 * @param {Array|TypedArray} data
 *        data to dump to a string
 *
 * @return {string} the data as a hex string.
 */ const $cb03b711053a4297$var$hexDump = (data)=>{
    const bytes = Array.prototype.slice.call(data);
    const step = 16;
    let result = '';
    let hex;
    let ascii;
    for(let j = 0; j < bytes.length / step; j++){
        hex = bytes.slice(j * step, j * step + step).map($cb03b711053a4297$var$formatHexString).join('');
        ascii = bytes.slice(j * step, j * step + step).map($cb03b711053a4297$var$formatAsciiString).join('');
        result += hex + ' ' + ascii + '\n';
    }
    return result;
};
const $cb03b711053a4297$var$tagDump = ({ bytes: bytes })=>$cb03b711053a4297$var$hexDump(bytes);
const $cb03b711053a4297$var$textRanges = (ranges)=>{
    let result = '';
    let i;
    for(i = 0; i < ranges.length; i++)result += $cb03b711053a4297$var$textRange(ranges, i) + ' ';
    return result;
};
var $cb03b711053a4297$var$utils = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createTransferableMessage: $cb03b711053a4297$var$createTransferableMessage,
    initSegmentId: $cb03b711053a4297$var$initSegmentId,
    segmentKeyId: $cb03b711053a4297$var$segmentKeyId,
    hexDump: $cb03b711053a4297$var$hexDump,
    tagDump: $cb03b711053a4297$var$tagDump,
    textRanges: $cb03b711053a4297$var$textRanges
});
// TODO handle fmp4 case where the timing info is accurate and doesn't involve transmux
// 25% was arbitrarily chosen, and may need to be refined over time.
const $cb03b711053a4297$var$SEGMENT_END_FUDGE_PERCENT = 0.25;
/**
 * Converts a player time (any time that can be gotten/set from player.currentTime(),
 * e.g., any time within player.seekable().start(0) to player.seekable().end(0)) to a
 * program time (any time referencing the real world (e.g., EXT-X-PROGRAM-DATE-TIME)).
 *
 * The containing segment is required as the EXT-X-PROGRAM-DATE-TIME serves as an "anchor
 * point" (a point where we have a mapping from program time to player time, with player
 * time being the post transmux start of the segment).
 *
 * For more details, see [this doc](../../docs/program-time-from-player-time.md).
 *
 * @param {number} playerTime the player time
 * @param {Object} segment the segment which contains the player time
 * @return {Date} program time
 */ const $cb03b711053a4297$var$playerTimeToProgramTime = (playerTime, segment)=>{
    if (!segment.dateTimeObject) // Can't convert without an "anchor point" for the program time (i.e., a time that can
    // be used to map the start of a segment with a real world time).
    return null;
    const transmuxerPrependedSeconds = segment.videoTimingInfo.transmuxerPrependedSeconds;
    const transmuxedStart = segment.videoTimingInfo.transmuxedPresentationStart; // get the start of the content from before old content is prepended
    const startOfSegment = transmuxedStart + transmuxerPrependedSeconds;
    const offsetFromSegmentStart = playerTime - startOfSegment;
    return new Date(segment.dateTimeObject.getTime() + offsetFromSegmentStart * 1000);
};
const $cb03b711053a4297$var$originalSegmentVideoDuration = (videoTimingInfo)=>{
    return videoTimingInfo.transmuxedPresentationEnd - videoTimingInfo.transmuxedPresentationStart - videoTimingInfo.transmuxerPrependedSeconds;
};
/**
 * Finds a segment that contains the time requested given as an ISO-8601 string. The
 * returned segment might be an estimate or an accurate match.
 *
 * @param {string} programTime The ISO-8601 programTime to find a match for
 * @param {Object} playlist A playlist object to search within
 */ const $cb03b711053a4297$var$findSegmentForProgramTime = (programTime, playlist)=>{
    // Assumptions:
    //  - verifyProgramDateTimeTags has already been run
    //  - live streams have been started
    let dateTimeObject;
    try {
        dateTimeObject = new Date(programTime);
    } catch (e) {
        return null;
    }
    if (!playlist || !playlist.segments || playlist.segments.length === 0) return null;
    let segment = playlist.segments[0];
    if (dateTimeObject < new Date(segment.dateTimeObject)) // Requested time is before stream start.
    return null;
    for(let i = 0; i < playlist.segments.length - 1; i++){
        segment = playlist.segments[i];
        const nextSegmentStart = new Date(playlist.segments[i + 1].dateTimeObject);
        if (dateTimeObject < nextSegmentStart) break;
    }
    const lastSegment = playlist.segments[playlist.segments.length - 1];
    const lastSegmentStart = lastSegment.dateTimeObject;
    const lastSegmentDuration = lastSegment.videoTimingInfo ? $cb03b711053a4297$var$originalSegmentVideoDuration(lastSegment.videoTimingInfo) : lastSegment.duration + lastSegment.duration * $cb03b711053a4297$var$SEGMENT_END_FUDGE_PERCENT;
    const lastSegmentEnd = new Date(lastSegmentStart.getTime() + lastSegmentDuration * 1000);
    if (dateTimeObject > lastSegmentEnd) // Beyond the end of the stream, or our best guess of the end of the stream.
    return null;
    if (dateTimeObject > new Date(lastSegmentStart)) segment = lastSegment;
    return {
        segment: segment,
        estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : $cb03b711053a4297$var$Playlist.duration(playlist, playlist.mediaSequence + playlist.segments.indexOf(segment)),
        // Although, given that all segments have accurate date time objects, the segment
        // selected should be accurate, unless the video has been transmuxed at some point
        // (determined by the presence of the videoTimingInfo object), the segment's "player
        // time" (the start time in the player) can't be considered accurate.
        type: segment.videoTimingInfo ? 'accurate' : 'estimate'
    };
};
/**
 * Finds a segment that contains the given player time(in seconds).
 *
 * @param {number} time The player time to find a match for
 * @param {Object} playlist A playlist object to search within
 */ const $cb03b711053a4297$var$findSegmentForPlayerTime = (time, playlist)=>{
    // Assumptions:
    // - there will always be a segment.duration
    // - we can start from zero
    // - segments are in time order
    if (!playlist || !playlist.segments || playlist.segments.length === 0) return null;
    let segmentEnd = 0;
    let segment;
    for(let i = 0; i < playlist.segments.length; i++){
        segment = playlist.segments[i]; // videoTimingInfo is set after the segment is downloaded and transmuxed, and
        // should contain the most accurate values we have for the segment's player times.
        //
        // Use the accurate transmuxedPresentationEnd value if it is available, otherwise fall
        // back to an estimate based on the manifest derived (inaccurate) segment.duration, to
        // calculate an end value.
        segmentEnd = segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationEnd : segmentEnd + segment.duration;
        if (time <= segmentEnd) break;
    }
    const lastSegment = playlist.segments[playlist.segments.length - 1];
    if (lastSegment.videoTimingInfo && lastSegment.videoTimingInfo.transmuxedPresentationEnd < time) // The time requested is beyond the stream end.
    return null;
    if (time > segmentEnd) {
        // The time is within or beyond the last segment.
        //
        // Check to see if the time is beyond a reasonable guess of the end of the stream.
        if (time > segmentEnd + lastSegment.duration * $cb03b711053a4297$var$SEGMENT_END_FUDGE_PERCENT) // Technically, because the duration value is only an estimate, the time may still
        // exist in the last segment, however, there isn't enough information to make even
        // a reasonable estimate.
        return null;
        segment = lastSegment;
    }
    return {
        segment: segment,
        estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : segmentEnd - segment.duration,
        // Because videoTimingInfo is only set after transmux, it is the only way to get
        // accurate timing values.
        type: segment.videoTimingInfo ? 'accurate' : 'estimate'
    };
};
/**
 * Gives the offset of the comparisonTimestamp from the programTime timestamp in seconds.
 * If the offset returned is positive, the programTime occurs after the
 * comparisonTimestamp.
 * If the offset is negative, the programTime occurs before the comparisonTimestamp.
 *
 * @param {string} comparisonTimeStamp An ISO-8601 timestamp to compare against
 * @param {string} programTime The programTime as an ISO-8601 string
 * @return {number} offset
 */ const $cb03b711053a4297$var$getOffsetFromTimestamp = (comparisonTimeStamp, programTime)=>{
    let segmentDateTime;
    let programDateTime;
    try {
        segmentDateTime = new Date(comparisonTimeStamp);
        programDateTime = new Date(programTime);
    } catch (e) {}
    const segmentTimeEpoch = segmentDateTime.getTime();
    const programTimeEpoch = programDateTime.getTime();
    return (programTimeEpoch - segmentTimeEpoch) / 1000;
};
/**
 * Checks that all segments in this playlist have programDateTime tags.
 *
 * @param {Object} playlist A playlist object
 */ const $cb03b711053a4297$var$verifyProgramDateTimeTags = (playlist)=>{
    if (!playlist.segments || playlist.segments.length === 0) return false;
    for(let i = 0; i < playlist.segments.length; i++){
        const segment = playlist.segments[i];
        if (!segment.dateTimeObject) return false;
    }
    return true;
};
/**
 * Returns the programTime of the media given a playlist and a playerTime.
 * The playlist must have programDateTime tags for a programDateTime tag to be returned.
 * If the segments containing the time requested have not been buffered yet, an estimate
 * may be returned to the callback.
 *
 * @param {Object} args
 * @param {Object} args.playlist A playlist object to search within
 * @param {number} time A playerTime in seconds
 * @param {Function} callback(err, programTime)
 * @return {string} err.message A detailed error message
 * @return {Object} programTime
 * @return {number} programTime.mediaSeconds The streamTime in seconds
 * @return {string} programTime.programDateTime The programTime as an ISO-8601 String
 */ const $cb03b711053a4297$var$getProgramTime = ({ playlist: playlist, time: time, callback: callback })=>{
    if (!callback) throw new Error('getProgramTime: callback must be provided');
    if (!playlist || time === undefined) return callback({
        message: 'getProgramTime: playlist and time must be provided'
    });
    const matchedSegment = $cb03b711053a4297$var$findSegmentForPlayerTime(time, playlist);
    if (!matchedSegment) return callback({
        message: 'valid programTime was not found'
    });
    if (matchedSegment.type === 'estimate') return callback({
        message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
        seekTime: matchedSegment.estimatedStart
    });
    const programTimeObject = {
        mediaSeconds: time
    };
    const programTime = $cb03b711053a4297$var$playerTimeToProgramTime(time, matchedSegment.segment);
    if (programTime) programTimeObject.programDateTime = programTime.toISOString();
    return callback(null, programTimeObject);
};
/**
 * Seeks in the player to a time that matches the given programTime ISO-8601 string.
 *
 * @param {Object} args
 * @param {string} args.programTime A programTime to seek to as an ISO-8601 String
 * @param {Object} args.playlist A playlist to look within
 * @param {number} args.retryCount The number of times to try for an accurate seek. Default is 2.
 * @param {Function} args.seekTo A method to perform a seek
 * @param {boolean} args.pauseAfterSeek Whether to end in a paused state after seeking. Default is true.
 * @param {Object} args.tech The tech to seek on
 * @param {Function} args.callback(err, newTime) A callback to return the new time to
 * @return {string} err.message A detailed error message
 * @return {number} newTime The exact time that was seeked to in seconds
 */ const $cb03b711053a4297$var$seekToProgramTime = ({ programTime: programTime, playlist: playlist, retryCount: retryCount = 2, seekTo: seekTo, pauseAfterSeek: pauseAfterSeek = true, tech: tech, callback: callback })=>{
    if (!callback) throw new Error('seekToProgramTime: callback must be provided');
    if (typeof programTime === 'undefined' || !playlist || !seekTo) return callback({
        message: 'seekToProgramTime: programTime, seekTo and playlist must be provided'
    });
    if (!playlist.endList && !tech.hasStarted_) return callback({
        message: 'player must be playing a live stream to start buffering'
    });
    if (!$cb03b711053a4297$var$verifyProgramDateTimeTags(playlist)) return callback({
        message: 'programDateTime tags must be provided in the manifest ' + playlist.resolvedUri
    });
    const matchedSegment = $cb03b711053a4297$var$findSegmentForProgramTime(programTime, playlist); // no match
    if (!matchedSegment) return callback({
        message: `${programTime} was not found in the stream`
    });
    const segment = matchedSegment.segment;
    const mediaOffset = $cb03b711053a4297$var$getOffsetFromTimestamp(segment.dateTimeObject, programTime);
    if (matchedSegment.type === 'estimate') {
        // we've run out of retries
        if (retryCount === 0) return callback({
            message: `${programTime} is not buffered yet. Try again`
        });
        seekTo(matchedSegment.estimatedStart + mediaOffset);
        tech.one('seeked', ()=>{
            $cb03b711053a4297$var$seekToProgramTime({
                programTime: programTime,
                playlist: playlist,
                retryCount: retryCount - 1,
                seekTo: seekTo,
                pauseAfterSeek: pauseAfterSeek,
                tech: tech,
                callback: callback
            });
        });
        return;
    } // Since the segment.start value is determined from the buffered end or ending time
    // of the prior segment, the seekToTime doesn't need to account for any transmuxer
    // modifications.
    const seekToTime = segment.start + mediaOffset;
    const seekedCallback = ()=>{
        return callback(null, tech.currentTime());
    }; // listen for seeked event
    tech.one('seeked', seekedCallback); // pause before seeking as video.js will restore this state
    if (pauseAfterSeek) tech.pause();
    seekTo(seekToTime);
};
// which will only happen if the request is complete.
const $cb03b711053a4297$var$callbackOnCompleted = (request, cb)=>{
    if (request.readyState === 4) return cb();
    return;
};
const $cb03b711053a4297$var$containerRequest = (uri, xhr, cb, requestType)=>{
    let bytes = [];
    let id3Offset;
    let finished = false;
    const endRequestAndCallback = function(err, req, type, _bytes) {
        req.abort();
        finished = true;
        return cb(err, req, type, _bytes);
    };
    const progressListener = function(error, request) {
        if (finished) return;
        if (error) {
            error.metadata = $cb03b711053a4297$var$getStreamingNetworkErrorMetadata({
                requestType: requestType,
                request: request,
                error: error
            });
            return endRequestAndCallback(error, request, '', bytes);
        } // grap the new part of content that was just downloaded
        const newPart = request.responseText.substring(bytes && bytes.byteLength || 0, request.responseText.length); // add that onto bytes
        bytes = (0, $6vzZz.concatTypedArrays)(bytes, (0, $6vzZz.stringToBytes)(newPart, true));
        id3Offset = id3Offset || (0, $bweXN.getId3Offset)(bytes); // we need at least 10 bytes to determine a type
        // or we need at least two bytes after an id3Offset
        if (bytes.length < 10 || id3Offset && bytes.length < id3Offset + 2) return $cb03b711053a4297$var$callbackOnCompleted(request, ()=>endRequestAndCallback(error, request, '', bytes));
        const type = (0, $bChVV.detectContainerForBytes)(bytes); // if this looks like a ts segment but we don't have enough data
        // to see the second sync byte, wait until we have enough data
        // before declaring it ts
        if (type === 'ts' && bytes.length < 188) return $cb03b711053a4297$var$callbackOnCompleted(request, ()=>endRequestAndCallback(error, request, '', bytes));
         // this may be an unsynced ts segment
        // wait for 376 bytes before detecting no container
        if (!type && bytes.length < 376) return $cb03b711053a4297$var$callbackOnCompleted(request, ()=>endRequestAndCallback(error, request, '', bytes));
        return endRequestAndCallback(null, request, type, bytes);
    };
    const options = {
        uri: uri,
        beforeSend (request) {
            // this forces the browser to pass the bytes to us unprocessed
            request.overrideMimeType('text/plain; charset=x-user-defined');
            request.addEventListener('progress', function({ total: total, loaded: loaded }) {
                return $cb03b711053a4297$var$callbackWrapper(request, null, {
                    statusCode: request.status
                }, progressListener);
            });
        }
    };
    const request = xhr(options, function(error, response) {
        return $cb03b711053a4297$var$callbackWrapper(request, error, response, progressListener);
    });
    return request;
};
const { EventTarget: $cb03b711053a4297$var$EventTarget } = $cb03b711053a4297$export$2e2bcd8739ae039;
const $cb03b711053a4297$var$dashPlaylistUnchanged = function(a, b) {
    if (!$cb03b711053a4297$var$isPlaylistUnchanged(a, b)) return false;
     // for dash the above check will often return true in scenarios where
    // the playlist actually has changed because mediaSequence isn't a
    // dash thing, and we often set it to 1. So if the playlists have the same amount
    // of segments we return true.
    // So for dash we need to make sure that the underlying segments are different.
    // if sidx changed then the playlists are different.
    if (a.sidx && b.sidx && (a.sidx.offset !== b.sidx.offset || a.sidx.length !== b.sidx.length)) return false;
    else if (!a.sidx && b.sidx || a.sidx && !b.sidx) return false;
     // one or the other does not have segments
    // there was a change.
    if (a.segments && !b.segments || !a.segments && b.segments) return false;
     // neither has segments nothing changed
    if (!a.segments && !b.segments) return true;
     // check segments themselves
    for(let i = 0; i < a.segments.length; i++){
        const aSegment = a.segments[i];
        const bSegment = b.segments[i]; // if uris are different between segments there was a change
        if (aSegment.uri !== bSegment.uri) return false;
         // neither segment has a byterange, there will be no byterange change.
        if (!aSegment.byterange && !bSegment.byterange) continue;
        const aByterange = aSegment.byterange;
        const bByterange = bSegment.byterange; // if byterange only exists on one of the segments, there was a change.
        if (aByterange && !bByterange || !aByterange && bByterange) return false;
         // if both segments have byterange with different offsets, there was a change.
        if (aByterange.offset !== bByterange.offset || aByterange.length !== bByterange.length) return false;
    } // if everything was the same with segments, this is the same playlist.
    return true;
};
/**
 * Use the representation IDs from the mpd object to create groupIDs, the NAME is set to mandatory representation
 * ID in the parser. This allows for continuous playout across periods with the same representation IDs
 * (continuous periods as defined in DASH-IF 3.2.12). This is assumed in the mpd-parser as well. If we want to support
 * periods without continuous playback this function may need modification as well as the parser.
 */ const $cb03b711053a4297$var$dashGroupId = (type, group, label, playlist)=>{
    // If the manifest somehow does not have an ID (non-dash compliant), use the label.
    const playlistId = playlist.attributes.NAME || label;
    return `placeholder-uri-${type}-${group}-${playlistId}`;
};
/**
 * Parses the main XML string and updates playlist URI references.
 *
 * @param {Object} config
 *        Object of arguments
 * @param {string} config.mainXml
 *        The mpd XML
 * @param {string} config.srcUrl
 *        The mpd URL
 * @param {Date} config.clientOffset
 *         A time difference between server and client
 * @param {Object} config.sidxMapping
 *        SIDX mappings for moof/mdat URIs and byte ranges
 * @return {Object}
 *         The parsed mpd manifest object
 */ const $cb03b711053a4297$var$parseMainXml = ({ mainXml: mainXml, srcUrl: srcUrl, clientOffset: clientOffset, sidxMapping: sidxMapping, previousManifest: previousManifest })=>{
    const manifest = (0, $1n4fv.parse)(mainXml, {
        manifestUri: srcUrl,
        clientOffset: clientOffset,
        sidxMapping: sidxMapping,
        previousManifest: previousManifest
    });
    $cb03b711053a4297$var$addPropertiesToMain(manifest, srcUrl, $cb03b711053a4297$var$dashGroupId);
    return manifest;
};
/**
 * Removes any mediaGroup labels that no longer exist in the newMain
 *
 * @param {Object} update
 *         The previous mpd object being updated
 * @param {Object} newMain
 *         The new mpd object
 */ const $cb03b711053a4297$var$removeOldMediaGroupLabels = (update, newMain)=>{
    $cb03b711053a4297$var$forEachMediaGroup(update, (properties, type, group, label)=>{
        if (!newMain.mediaGroups[type][group] || !(label in newMain.mediaGroups[type][group])) delete update.mediaGroups[type][group][label];
    });
};
/**
 * Returns a new main manifest that is the result of merging an updated main manifest
 * into the original version.
 *
 * @param {Object} oldMain
 *        The old parsed mpd object
 * @param {Object} newMain
 *        The updated parsed mpd object
 * @return {Object}
 *         A new object representing the original main manifest with the updated media
 *         playlists merged in
 */ const $cb03b711053a4297$var$updateMain = (oldMain, newMain, sidxMapping)=>{
    let noChanges = true;
    let update = $cb03b711053a4297$var$merge(oldMain, {
        // These are top level properties that can be updated
        duration: newMain.duration,
        minimumUpdatePeriod: newMain.minimumUpdatePeriod,
        timelineStarts: newMain.timelineStarts
    }); // First update the playlists in playlist list
    for(let i = 0; i < newMain.playlists.length; i++){
        const playlist = newMain.playlists[i];
        if (playlist.sidx) {
            const sidxKey = (0, $1n4fv.generateSidxKey)(playlist.sidx); // add sidx segments to the playlist if we have all the sidx info already
            if (sidxMapping && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx) (0, $1n4fv.addSidxSegmentsToPlaylist)(playlist, sidxMapping[sidxKey].sidx, playlist.sidx.resolvedUri);
        }
        const playlistUpdate = $cb03b711053a4297$var$updateMain$1(update, playlist, $cb03b711053a4297$var$dashPlaylistUnchanged);
        if (playlistUpdate) {
            update = playlistUpdate;
            noChanges = false;
        }
    } // Then update media group playlists
    $cb03b711053a4297$var$forEachMediaGroup(newMain, (properties, type, group, label)=>{
        if (properties.playlists && properties.playlists.length) {
            const id = properties.playlists[0].id;
            const playlistUpdate = $cb03b711053a4297$var$updateMain$1(update, properties.playlists[0], $cb03b711053a4297$var$dashPlaylistUnchanged);
            if (playlistUpdate) {
                update = playlistUpdate; // add new mediaGroup label if it doesn't exist and assign the new mediaGroup.
                if (!(label in update.mediaGroups[type][group])) update.mediaGroups[type][group][label] = properties;
                 // update the playlist reference within media groups
                update.mediaGroups[type][group][label].playlists[0] = update.playlists[id];
                noChanges = false;
            }
        }
    }); // remove mediaGroup labels and references that no longer exist in the newMain
    $cb03b711053a4297$var$removeOldMediaGroupLabels(update, newMain);
    if (newMain.minimumUpdatePeriod !== oldMain.minimumUpdatePeriod) noChanges = false;
    if (noChanges) return null;
    return update;
}; // SIDX should be equivalent if the URI and byteranges of the SIDX match.
// If the SIDXs have maps, the two maps should match,
// both `a` and `b` missing SIDXs is considered matching.
// If `a` or `b` but not both have a map, they aren't matching.
const $cb03b711053a4297$var$equivalentSidx = (a, b)=>{
    const neitherMap = Boolean(!a.map && !b.map);
    const equivalentMap = neitherMap || Boolean(a.map && b.map && a.map.byterange.offset === b.map.byterange.offset && a.map.byterange.length === b.map.byterange.length);
    return equivalentMap && a.uri === b.uri && a.byterange.offset === b.byterange.offset && a.byterange.length === b.byterange.length;
}; // exported for testing
const $cb03b711053a4297$var$compareSidxEntry = (playlists, oldSidxMapping)=>{
    const newSidxMapping = {};
    for(const id in playlists){
        const playlist = playlists[id];
        const currentSidxInfo = playlist.sidx;
        if (currentSidxInfo) {
            const key = (0, $1n4fv.generateSidxKey)(currentSidxInfo);
            if (!oldSidxMapping[key]) break;
            const savedSidxInfo = oldSidxMapping[key].sidxInfo;
            if ($cb03b711053a4297$var$equivalentSidx(savedSidxInfo, currentSidxInfo)) newSidxMapping[key] = oldSidxMapping[key];
        }
    }
    return newSidxMapping;
};
/**
 *  A function that filters out changed items as they need to be requested separately.
 *
 *  The method is exported for testing
 *
 *  @param {Object} main the parsed mpd XML returned via mpd-parser
 *  @param {Object} oldSidxMapping the SIDX to compare against
 */ const $cb03b711053a4297$var$filterChangedSidxMappings = (main, oldSidxMapping)=>{
    const videoSidx = $cb03b711053a4297$var$compareSidxEntry(main.playlists, oldSidxMapping);
    let mediaGroupSidx = videoSidx;
    $cb03b711053a4297$var$forEachMediaGroup(main, (properties, mediaType, groupKey, labelKey)=>{
        if (properties.playlists && properties.playlists.length) {
            const playlists = properties.playlists;
            mediaGroupSidx = $cb03b711053a4297$var$merge(mediaGroupSidx, $cb03b711053a4297$var$compareSidxEntry(playlists, oldSidxMapping));
        }
    });
    return mediaGroupSidx;
};
class $cb03b711053a4297$var$DashPlaylistLoader extends $cb03b711053a4297$var$EventTarget {
    // DashPlaylistLoader must accept either a src url or a playlist because subsequent
    // playlist loader setups from media groups will expect to be able to pass a playlist
    // (since there aren't external URLs to media playlists with DASH)
    constructor(srcUrlOrPlaylist, vhs, options = {}, mainPlaylistLoader){
        super();
        this.isPaused_ = true;
        this.mainPlaylistLoader_ = mainPlaylistLoader || this;
        if (!mainPlaylistLoader) this.isMain_ = true;
        const { withCredentials: withCredentials = false } = options;
        this.vhs_ = vhs;
        this.withCredentials = withCredentials;
        this.addMetadataToTextTrack = options.addMetadataToTextTrack;
        if (!srcUrlOrPlaylist) throw new Error('A non-empty playlist URL or object is required');
         // event naming?
        this.on('minimumUpdatePeriod', ()=>{
            this.refreshXml_();
        }); // live playlist staleness timeout
        this.on('mediaupdatetimeout', ()=>{
            this.refreshMedia_(this.media().id);
        });
        this.state = 'HAVE_NOTHING';
        this.loadedPlaylists_ = {};
        this.logger_ = $cb03b711053a4297$var$logger('DashPlaylistLoader'); // initialize the loader state
        // The mainPlaylistLoader will be created with a string
        if (this.isMain_) {
            this.mainPlaylistLoader_.srcUrl = srcUrlOrPlaylist; // TODO: reset sidxMapping between period changes
            // once multi-period is refactored
            this.mainPlaylistLoader_.sidxMapping_ = {};
        } else this.childPlaylist_ = srcUrlOrPlaylist;
    }
    get isPaused() {
        return this.isPaused_;
    }
    requestErrored_(err, request, startingState) {
        // disposed
        if (!this.request) return true;
         // pending request is cleared
        this.request = null;
        if (err) {
            // use the provided error object or create one
            // based on the request/response
            this.error = typeof err === 'object' && !(err instanceof Error) ? err : {
                status: request.status,
                message: 'DASH request error at URL: ' + request.uri,
                response: request.response,
                // MEDIA_ERR_NETWORK
                code: 2,
                metadata: err.metadata
            };
            if (startingState) this.state = startingState;
            this.trigger('error');
            return true;
        }
    }
    /**
   * Verify that the container of the sidx segment can be parsed
   * and if it can, get and parse that segment.
   */ addSidxSegments_(playlist, startingState, cb) {
        const sidxKey = playlist.sidx && (0, $1n4fv.generateSidxKey)(playlist.sidx); // playlist lacks sidx or sidx segments were added to this playlist already.
        if (!playlist.sidx || !sidxKey || this.mainPlaylistLoader_.sidxMapping_[sidxKey]) {
            // keep this function async
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaRequest_);
            this.mediaRequest_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>cb(false), 0);
            return;
        } // resolve the segment URL relative to the playlist
        const uri = $cb03b711053a4297$var$resolveManifestRedirect(playlist.sidx.resolvedUri);
        const fin = (err, request)=>{
            if (this.requestErrored_(err, request, startingState)) return;
            const sidxMapping = this.mainPlaylistLoader_.sidxMapping_;
            const { requestType: requestType } = request;
            let sidx;
            try {
                sidx = (0, (/*@__PURE__*/$parcel$interopDefault($aMGaR)))((0, $6vzZz.toUint8)(request.response).subarray(8));
            } catch (e) {
                e.metadata = $cb03b711053a4297$var$getStreamingNetworkErrorMetadata({
                    requestType: requestType,
                    request: request,
                    parseFailure: true
                }); // sidx parsing failed.
                this.requestErrored_(e, request, startingState);
                return;
            }
            sidxMapping[sidxKey] = {
                sidxInfo: playlist.sidx,
                sidx: sidx
            };
            (0, $1n4fv.addSidxSegmentsToPlaylist)(playlist, sidx, playlist.sidx.resolvedUri);
            return cb(true);
        };
        const REQUEST_TYPE = 'dash-sidx';
        this.request = $cb03b711053a4297$var$containerRequest(uri, this.vhs_.xhr, (err, request, container, bytes)=>{
            if (err) return fin(err, request);
            if (!container || container !== 'mp4') {
                const sidxContainer = container || 'unknown';
                return fin({
                    status: request.status,
                    message: `Unsupported ${sidxContainer} container type for sidx segment at URL: ${uri}`,
                    // response is just bytes in this case
                    // but we really don't want to return that.
                    response: '',
                    playlist: playlist,
                    internal: true,
                    playlistExclusionDuration: Infinity,
                    // MEDIA_ERR_NETWORK
                    code: 2
                }, request);
            } // if we already downloaded the sidx bytes in the container request, use them
            const { offset: offset, length: length } = playlist.sidx.byterange;
            if (bytes.length >= length + offset) return fin(err, {
                response: bytes.subarray(offset, offset + length),
                status: request.status,
                uri: request.uri
            });
             // otherwise request sidx bytes
            this.request = this.vhs_.xhr({
                uri: uri,
                responseType: 'arraybuffer',
                requestType: 'dash-sidx',
                headers: $cb03b711053a4297$var$segmentXhrHeaders({
                    byterange: playlist.sidx.byterange
                })
            }, fin);
        }, REQUEST_TYPE);
    }
    dispose() {
        this.isPaused_ = true;
        this.trigger('dispose');
        this.stopRequest();
        this.loadedPlaylists_ = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.minimumUpdatePeriodTimeout_);
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaRequest_);
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
        this.mediaUpdateTimeout = null;
        this.mediaRequest_ = null;
        this.minimumUpdatePeriodTimeout_ = null;
        if (this.mainPlaylistLoader_.createMupOnMedia_) {
            this.off('loadedmetadata', this.mainPlaylistLoader_.createMupOnMedia_);
            this.mainPlaylistLoader_.createMupOnMedia_ = null;
        }
        this.off();
    }
    hasPendingRequest() {
        return this.request || this.mediaRequest_;
    }
    stopRequest() {
        if (this.request) {
            const oldRequest = this.request;
            this.request = null;
            oldRequest.onreadystatechange = null;
            oldRequest.abort();
        }
    }
    media(playlist) {
        // getter
        if (!playlist) return this.media_;
         // setter
        if (this.state === 'HAVE_NOTHING') throw new Error('Cannot switch media playlist from ' + this.state);
        const startingState = this.state; // find the playlist object if the target playlist has been specified by URI
        if (typeof playlist === 'string') {
            if (!this.mainPlaylistLoader_.main.playlists[playlist]) throw new Error('Unknown playlist URI: ' + playlist);
            playlist = this.mainPlaylistLoader_.main.playlists[playlist];
        }
        const mediaChange = !this.media_ || playlist.id !== this.media_.id; // switch to previously loaded playlists immediately
        if (mediaChange && this.loadedPlaylists_[playlist.id] && this.loadedPlaylists_[playlist.id].endList) {
            this.state = 'HAVE_METADATA';
            this.media_ = playlist; // trigger media change if the active media has been updated
            if (mediaChange) {
                this.trigger('mediachanging');
                this.trigger('mediachange');
            }
            return;
        } // switching to the active playlist is a no-op
        if (!mediaChange) return;
         // switching from an already loaded playlist
        if (this.media_) this.trigger('mediachanging');
        this.addSidxSegments_(playlist, startingState, (sidxChanged)=>{
            // everything is ready just continue to haveMetadata
            this.haveMetadata({
                startingState: startingState,
                playlist: playlist
            });
        });
    }
    haveMetadata({ startingState: startingState, playlist: playlist }) {
        this.state = 'HAVE_METADATA';
        this.loadedPlaylists_[playlist.id] = playlist;
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaRequest_);
        this.mediaRequest_ = null; // This will trigger loadedplaylist
        this.refreshMedia_(playlist.id); // fire loadedmetadata the first time a media playlist is loaded
        // to resolve setup of media groups
        if (startingState === 'HAVE_MAIN_MANIFEST') this.trigger('loadedmetadata');
        else // trigger media change if the active media has been updated
        this.trigger('mediachange');
    }
    pause() {
        this.isPaused_ = true;
        if (this.mainPlaylistLoader_.createMupOnMedia_) {
            this.off('loadedmetadata', this.mainPlaylistLoader_.createMupOnMedia_);
            this.mainPlaylistLoader_.createMupOnMedia_ = null;
        }
        this.stopRequest();
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
        this.mediaUpdateTimeout = null;
        if (this.isMain_) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_);
            this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_ = null;
        }
        if (this.state === 'HAVE_NOTHING') // If we pause the loader before any data has been retrieved, its as if we never
        // started, so reset to an unstarted state.
        this.started = false;
    }
    load(isFinalRendition) {
        this.isPaused_ = false;
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
        this.mediaUpdateTimeout = null;
        const media = this.media();
        if (isFinalRendition) {
            const delay = media ? media.targetDuration / 2 * 1000 : 5000;
            this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>this.load(), delay);
            return;
        } // because the playlists are internal to the manifest, load should either load the
        // main manifest, or do nothing but trigger an event
        if (!this.started) {
            this.start();
            return;
        }
        if (media && !media.endList) {
            // Check to see if this is the main loader and the MUP was cleared (this happens
            // when the loader was paused). `media` should be set at this point since one is always
            // set during `start()`.
            if (this.isMain_ && !this.minimumUpdatePeriodTimeout_) {
                // Trigger minimumUpdatePeriod to refresh the main manifest
                this.trigger('minimumUpdatePeriod'); // Since there was no prior minimumUpdatePeriodTimeout it should be recreated
                this.updateMinimumUpdatePeriodTimeout_();
            }
            this.trigger('mediaupdatetimeout');
        } else this.trigger('loadedplaylist');
    }
    start() {
        this.started = true; // We don't need to request the main manifest again
        // Call this asynchronously to match the xhr request behavior below
        if (!this.isMain_) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaRequest_);
            this.mediaRequest_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>this.haveMain_(), 0);
            return;
        }
        this.requestMain_((req, mainChanged)=>{
            this.haveMain_();
            if (!this.hasPendingRequest() && !this.media_) this.media(this.mainPlaylistLoader_.main.playlists[0]);
        });
    }
    requestMain_(cb) {
        const metadata = {
            manifestInfo: {
                uri: this.mainPlaylistLoader_.srcUrl
            }
        };
        this.trigger({
            type: 'manifestrequeststart',
            metadata: metadata
        });
        this.request = this.vhs_.xhr({
            uri: this.mainPlaylistLoader_.srcUrl,
            withCredentials: this.withCredentials,
            requestType: 'dash-manifest'
        }, (error, req)=>{
            if (error) {
                const { requestType: requestType } = req;
                error.metadata = $cb03b711053a4297$var$getStreamingNetworkErrorMetadata({
                    requestType: requestType,
                    request: req,
                    error: error
                });
            }
            if (this.requestErrored_(error, req)) {
                if (this.state === 'HAVE_NOTHING') this.started = false;
                return;
            }
            this.trigger({
                type: 'manifestrequestcomplete',
                metadata: metadata
            });
            const mainChanged = req.responseText !== this.mainPlaylistLoader_.mainXml_;
            this.mainPlaylistLoader_.mainXml_ = req.responseText;
            if (req.responseHeaders && req.responseHeaders.date) this.mainLoaded_ = Date.parse(req.responseHeaders.date);
            else this.mainLoaded_ = Date.now();
            this.mainPlaylistLoader_.srcUrl = $cb03b711053a4297$var$resolveManifestRedirect(this.mainPlaylistLoader_.srcUrl, req);
            if (mainChanged) {
                this.handleMain_();
                this.syncClientServerClock_(()=>{
                    return cb(req, mainChanged);
                });
                return;
            }
            return cb(req, mainChanged);
        });
    }
    /**
   * Parses the main xml for UTCTiming node to sync the client clock to the server
   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
   *
   * @param {Function} done
   *        Function to call when clock sync has completed
   */ syncClientServerClock_(done) {
        const utcTiming = (0, $1n4fv.parseUTCTiming)(this.mainPlaylistLoader_.mainXml_); // No UTCTiming element found in the mpd. Use Date header from mpd request as the
        // server clock
        if (utcTiming === null) {
            this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now();
            return done();
        }
        if (utcTiming.method === 'DIRECT') {
            this.mainPlaylistLoader_.clientOffset_ = utcTiming.value - Date.now();
            return done();
        }
        this.request = this.vhs_.xhr({
            uri: $cb03b711053a4297$var$resolveUrl(this.mainPlaylistLoader_.srcUrl, utcTiming.value),
            method: utcTiming.method,
            withCredentials: this.withCredentials,
            requestType: 'dash-clock-sync'
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
            if (error) {
                const { requestType: requestType } = req;
                this.error.metadata = $cb03b711053a4297$var$getStreamingNetworkErrorMetadata({
                    requestType: requestType,
                    request: req,
                    error: error
                }); // sync request failed, fall back to using date header from mpd
                // TODO: log warning
                this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now();
                return done();
            }
            let serverTime;
            if (utcTiming.method === 'HEAD') {
                if (!req.responseHeaders || !req.responseHeaders.date) // expected date header not preset, fall back to using date header from mpd
                // TODO: log warning
                serverTime = this.mainLoaded_;
                else serverTime = Date.parse(req.responseHeaders.date);
            } else serverTime = Date.parse(req.responseText);
            this.mainPlaylistLoader_.clientOffset_ = serverTime - Date.now();
            done();
        });
    }
    haveMain_() {
        this.state = 'HAVE_MAIN_MANIFEST';
        if (this.isMain_) // We have the main playlist at this point, so
        // trigger this to allow PlaylistController
        // to make an initial playlist selection
        this.trigger('loadedplaylist');
        else if (!this.media_) // no media playlist was specifically selected so select
        // the one the child playlist loader was created with
        this.media(this.childPlaylist_);
    }
    handleMain_() {
        // clear media request
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaRequest_);
        this.mediaRequest_ = null;
        const oldMain = this.mainPlaylistLoader_.main;
        const metadata = {
            manifestInfo: {
                uri: this.mainPlaylistLoader_.srcUrl
            }
        };
        this.trigger({
            type: 'manifestparsestart',
            metadata: metadata
        });
        let newMain;
        try {
            newMain = $cb03b711053a4297$var$parseMainXml({
                mainXml: this.mainPlaylistLoader_.mainXml_,
                srcUrl: this.mainPlaylistLoader_.srcUrl,
                clientOffset: this.mainPlaylistLoader_.clientOffset_,
                sidxMapping: this.mainPlaylistLoader_.sidxMapping_,
                previousManifest: oldMain
            });
        } catch (error) {
            this.error = error;
            this.error.metadata = {
                errorType: $cb03b711053a4297$export$2e2bcd8739ae039.Error.StreamingDashManifestParserError,
                error: error
            };
            this.trigger('error');
        } // if we have an old main to compare the new main against
        if (oldMain) newMain = $cb03b711053a4297$var$updateMain(oldMain, newMain, this.mainPlaylistLoader_.sidxMapping_);
         // only update main if we have a new main
        this.mainPlaylistLoader_.main = newMain ? newMain : oldMain;
        const location = this.mainPlaylistLoader_.main.locations && this.mainPlaylistLoader_.main.locations[0];
        if (location && location !== this.mainPlaylistLoader_.srcUrl) this.mainPlaylistLoader_.srcUrl = location;
        if (!oldMain || newMain && newMain.minimumUpdatePeriod !== oldMain.minimumUpdatePeriod) this.updateMinimumUpdatePeriodTimeout_();
        this.addEventStreamToMetadataTrack_(newMain);
        if (newMain) {
            const { duration: duration, endList: endList } = newMain;
            const renditions = [];
            newMain.playlists.forEach((playlist)=>{
                renditions.push({
                    id: playlist.id,
                    bandwidth: playlist.attributes.BANDWIDTH,
                    resolution: playlist.attributes.RESOLUTION,
                    codecs: playlist.attributes.CODECS
                });
            });
            const parsedManifest = {
                duration: duration,
                isLive: !endList,
                renditions: renditions
            };
            metadata.parsedManifest = parsedManifest;
            this.trigger({
                type: 'manifestparsecomplete',
                metadata: metadata
            });
        }
        return Boolean(newMain);
    }
    updateMinimumUpdatePeriodTimeout_() {
        const mpl = this.mainPlaylistLoader_; // cancel any pending creation of mup on media
        // a new one will be added if needed.
        if (mpl.createMupOnMedia_) {
            mpl.off('loadedmetadata', mpl.createMupOnMedia_);
            mpl.createMupOnMedia_ = null;
        } // clear any pending timeouts
        if (mpl.minimumUpdatePeriodTimeout_) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(mpl.minimumUpdatePeriodTimeout_);
            mpl.minimumUpdatePeriodTimeout_ = null;
        }
        let mup = mpl.main && mpl.main.minimumUpdatePeriod; // If the minimumUpdatePeriod has a value of 0, that indicates that the current
        // MPD has no future validity, so a new one will need to be acquired when new
        // media segments are to be made available. Thus, we use the target duration
        // in this case
        if (mup === 0) {
            if (mpl.media()) mup = mpl.media().targetDuration * 1000;
            else {
                mpl.createMupOnMedia_ = mpl.updateMinimumUpdatePeriodTimeout_;
                mpl.one('loadedmetadata', mpl.createMupOnMedia_);
            }
        } // if minimumUpdatePeriod is invalid or <= zero, which
        // can happen when a live video becomes VOD. skip timeout
        // creation.
        if (typeof mup !== 'number' || mup <= 0) {
            if (mup < 0) this.logger_(`found invalid minimumUpdatePeriod of ${mup}, not setting a timeout`);
            return;
        }
        this.createMUPTimeout_(mup);
    }
    createMUPTimeout_(mup) {
        const mpl = this.mainPlaylistLoader_;
        mpl.minimumUpdatePeriodTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            mpl.minimumUpdatePeriodTimeout_ = null;
            mpl.trigger('minimumUpdatePeriod');
            mpl.createMUPTimeout_(mup);
        }, mup);
    }
    /**
   * Sends request to refresh the main xml and updates the parsed main manifest
   */ refreshXml_() {
        this.requestMain_((req, mainChanged)=>{
            if (!mainChanged) return;
            if (this.media_) this.media_ = this.mainPlaylistLoader_.main.playlists[this.media_.id];
             // This will filter out updated sidx info from the mapping
            this.mainPlaylistLoader_.sidxMapping_ = $cb03b711053a4297$var$filterChangedSidxMappings(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.sidxMapping_);
            this.addSidxSegments_(this.media(), this.state, (sidxChanged)=>{
                // TODO: do we need to reload the current playlist?
                this.refreshMedia_(this.media().id);
            });
        });
    }
    /**
   * Refreshes the media playlist by re-parsing the main xml and updating playlist
   * references. If this is an alternate loader, the updated parsed manifest is retrieved
   * from the main loader.
   */ refreshMedia_(mediaID) {
        if (!mediaID) throw new Error('refreshMedia_ must take a media id');
         // for main we have to reparse the main xml
        // to re-create segments based on current timing values
        // which may change media. We only skip updating the main manifest
        // if this is the first time this.media_ is being set.
        // as main was just parsed in that case.
        if (this.media_ && this.isMain_) this.handleMain_();
        const playlists = this.mainPlaylistLoader_.main.playlists;
        const mediaChanged = !this.media_ || this.media_ !== playlists[mediaID];
        if (mediaChanged) this.media_ = playlists[mediaID];
        else this.trigger('playlistunchanged');
        if (!this.mediaUpdateTimeout) {
            const createMediaUpdateTimeout = ()=>{
                if (this.media().endList) return;
                this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
                    this.trigger('mediaupdatetimeout');
                    createMediaUpdateTimeout();
                }, $cb03b711053a4297$var$refreshDelay(this.media(), Boolean(mediaChanged)));
            };
            createMediaUpdateTimeout();
        }
        this.trigger('loadedplaylist');
    }
    /**
   * Takes eventstream data from a parsed DASH manifest and adds it to the metadata text track.
   *
   * @param {manifest} newMain the newly parsed manifest
   */ addEventStreamToMetadataTrack_(newMain) {
        // Only add new event stream metadata if we have a new manifest.
        if (newMain && this.mainPlaylistLoader_.main.eventStream) {
            // convert EventStream to ID3-like data.
            const metadataArray = this.mainPlaylistLoader_.main.eventStream.map((eventStreamNode)=>{
                return {
                    cueTime: eventStreamNode.start,
                    frames: [
                        {
                            data: eventStreamNode.messageData
                        }
                    ]
                };
            });
            this.addMetadataToTextTrack('EventStream', metadataArray, this.mainPlaylistLoader_.main.duration);
        }
    }
    /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */ getKeyIdSet(playlist) {
        if (playlist.contentProtection) {
            const keyIds = new Set();
            for(const keysystem in playlist.contentProtection){
                const defaultKID = playlist.contentProtection[keysystem].attributes['cenc:default_KID'];
                if (defaultKID) // DASH keyIds are separated by dashes.
                keyIds.add(defaultKID.replace(/-/g, '').toLowerCase());
            }
            return keyIds;
        }
    }
}
var $cb03b711053a4297$var$Config = {
    GOAL_BUFFER_LENGTH: 30,
    MAX_GOAL_BUFFER_LENGTH: 60,
    BACK_BUFFER_LENGTH: 30,
    GOAL_BUFFER_LENGTH_RATE: 1,
    // 0.5 MB/s
    INITIAL_BANDWIDTH: 4194304,
    // A fudge factor to apply to advertised playlist bitrates to account for
    // temporary flucations in client bandwidth
    BANDWIDTH_VARIANCE: 1.2,
    // How much of the buffer must be filled before we consider upswitching
    BUFFER_LOW_WATER_LINE: 0,
    MAX_BUFFER_LOW_WATER_LINE: 30,
    // TODO: Remove this when experimentalBufferBasedABR is removed
    EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
    BUFFER_LOW_WATER_LINE_RATE: 1,
    // If the buffer is greater than the high water line, we won't switch down
    BUFFER_HIGH_WATER_LINE: 30
};
const $cb03b711053a4297$var$stringToArrayBuffer = (string)=>{
    const view = new Uint8Array(new ArrayBuffer(string.length));
    for(let i = 0; i < string.length; i++)view[i] = string.charCodeAt(i);
    return view.buffer;
};
/* global Blob, BlobBuilder, Worker */ // unify worker interface
const $cb03b711053a4297$var$browserWorkerPolyFill = function(workerObj) {
    // node only supports on/off
    workerObj.on = workerObj.addEventListener;
    workerObj.off = workerObj.removeEventListener;
    return workerObj;
};
const $cb03b711053a4297$var$createObjectURL = function(str) {
    try {
        return URL.createObjectURL(new Blob([
            str
        ], {
            type: 'application/javascript'
        }));
    } catch (e) {
        const blob = new BlobBuilder();
        blob.append(str);
        return URL.createObjectURL(blob.getBlob());
    }
};
const $cb03b711053a4297$var$factory = function(code) {
    return function() {
        const objectUrl = $cb03b711053a4297$var$createObjectURL(code);
        const worker = $cb03b711053a4297$var$browserWorkerPolyFill(new Worker(objectUrl));
        worker.objURL = objectUrl;
        const terminate = worker.terminate;
        worker.on = worker.addEventListener;
        worker.off = worker.removeEventListener;
        worker.terminate = function() {
            URL.revokeObjectURL(objectUrl);
            return terminate.call(this);
        };
        return worker;
    };
};
const $cb03b711053a4297$var$transform = function(code) {
    return `var browserWorkerPolyFill = ${$cb03b711053a4297$var$browserWorkerPolyFill.toString()};\n` + 'browserWorkerPolyFill(self);\n' + code;
};
const $cb03b711053a4297$var$getWorkerString = function(fn) {
    return fn.toString().replace(/^function.+?{/, '').slice(0, -1);
};
/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */ const $cb03b711053a4297$var$workerCode$1 = $cb03b711053a4297$var$transform($cb03b711053a4297$var$getWorkerString(function() {
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A lightweight readable stream implemention that handles event dispatching.
   * Objects that inherit from streams should call init in their constructors.
   */ var Stream$8 = function() {
        this.init = function() {
            var listeners = {};
            /**
       * Add a listener for a specified event type.
       * @param type {string} the event name
       * @param listener {function} the callback to be invoked when an event of
       * the specified type occurs
       */ this.on = function(type, listener) {
                if (!listeners[type]) listeners[type] = [];
                listeners[type] = listeners[type].concat(listener);
            };
            /**
       * Remove a listener for a specified event type.
       * @param type {string} the event name
       * @param listener {function} a function previously registered for this
       * type of event through `on`
       */ this.off = function(type, listener) {
                var index;
                if (!listeners[type]) return false;
                index = listeners[type].indexOf(listener);
                listeners[type] = listeners[type].slice();
                listeners[type].splice(index, 1);
                return index > -1;
            };
            /**
       * Trigger an event of the specified type on this stream. Any additional
       * arguments to this function are passed as parameters to event listeners.
       * @param type {string} the event name
       */ this.trigger = function(type) {
                var callbacks, i, length, args;
                callbacks = listeners[type];
                if (!callbacks) return;
                 // Slicing the arguments on every invocation of this method
                // can add a significant amount of overhead. Avoid the
                // intermediate object creation for the common case of a
                // single callback argument
                if (arguments.length === 2) {
                    length = callbacks.length;
                    for(i = 0; i < length; ++i)callbacks[i].call(this, arguments[1]);
                } else {
                    args = [];
                    i = arguments.length;
                    for(i = 1; i < arguments.length; ++i)args.push(arguments[i]);
                    length = callbacks.length;
                    for(i = 0; i < length; ++i)callbacks[i].apply(this, args);
                }
            };
            /**
       * Destroys the stream and cleans up.
       */ this.dispose = function() {
                listeners = {};
            };
        };
    };
    /**
   * Forwards all `data` events on this stream to the destination stream. The
   * destination stream should provide a method `push` to receive the data
   * events as they arrive.
   * @param destination {stream} the stream that will receive all `data` events
   * @param autoFlush {boolean} if false, we will not call `flush` on the destination
   *                            when the current stream emits a 'done' event
   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
   */ Stream$8.prototype.pipe = function(destination) {
        this.on('data', function(data) {
            destination.push(data);
        });
        this.on('done', function(flushSource) {
            destination.flush(flushSource);
        });
        this.on('partialdone', function(flushSource) {
            destination.partialFlush(flushSource);
        });
        this.on('endedtimeline', function(flushSource) {
            destination.endTimeline(flushSource);
        });
        this.on('reset', function(flushSource) {
            destination.reset(flushSource);
        });
        return destination;
    }; // Default stream functions that are expected to be overridden to perform
    // actual work. These are provided by the prototype as a sort of no-op
    // implementation so that we don't have to check for their existence in the
    // `pipe` function above.
    Stream$8.prototype.push = function(data) {
        this.trigger('data', data);
    };
    Stream$8.prototype.flush = function(flushSource) {
        this.trigger('done', flushSource);
    };
    Stream$8.prototype.partialFlush = function(flushSource) {
        this.trigger('partialdone', flushSource);
    };
    Stream$8.prototype.endTimeline = function(flushSource) {
        this.trigger('endedtimeline', flushSource);
    };
    Stream$8.prototype.reset = function(flushSource) {
        this.trigger('reset', flushSource);
    };
    var stream = Stream$8;
    var MAX_UINT32$1 = Math.pow(2, 32);
    var getUint64$5 = function(uint8) {
        var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
        var value;
        if (dv.getBigUint64) {
            value = dv.getBigUint64(0);
            if (value < Number.MAX_SAFE_INTEGER) return Number(value);
            return value;
        }
        return dv.getUint32(0) * MAX_UINT32$1 + dv.getUint32(4);
    };
    var numbers = {
        getUint64: getUint64$5,
        MAX_UINT32: MAX_UINT32$1
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Functions that generate fragmented MP4s suitable for use with Media
   * Source Extensions.
   */ var MAX_UINT32 = numbers.MAX_UINT32;
    var box, dinf, esds, ftyp, mdat, mfhd, minf, moof, moov, mvex, mvhd, trak, tkhd, mdia, mdhd, hdlr, sdtp, stbl, stsd, traf, trex, trun$1, types, MAJOR_BRAND, MINOR_VERSION, AVC1_BRAND, VIDEO_HDLR, AUDIO_HDLR, HDLR_TYPES, VMHD, SMHD, DREF, STCO, STSC, STSZ, STTS; // pre-calculate constants
    (function() {
        var i;
        types = {
            avc1: [],
            // codingname
            avcC: [],
            btrt: [],
            dinf: [],
            dref: [],
            esds: [],
            ftyp: [],
            hdlr: [],
            mdat: [],
            mdhd: [],
            mdia: [],
            mfhd: [],
            minf: [],
            moof: [],
            moov: [],
            mp4a: [],
            // codingname
            mvex: [],
            mvhd: [],
            pasp: [],
            sdtp: [],
            smhd: [],
            stbl: [],
            stco: [],
            stsc: [],
            stsd: [],
            stsz: [],
            stts: [],
            styp: [],
            tfdt: [],
            tfhd: [],
            traf: [],
            trak: [],
            trun: [],
            trex: [],
            tkhd: [],
            vmhd: []
        }; // In environments where Uint8Array is undefined (e.g., IE8), skip set up so that we
        // don't throw an error
        if (typeof Uint8Array === 'undefined') return;
        for(i in types)if (types.hasOwnProperty(i)) types[i] = [
            i.charCodeAt(0),
            i.charCodeAt(1),
            i.charCodeAt(2),
            i.charCodeAt(3)
        ];
        MAJOR_BRAND = new Uint8Array([
            'i'.charCodeAt(0),
            's'.charCodeAt(0),
            'o'.charCodeAt(0),
            'm'.charCodeAt(0)
        ]);
        AVC1_BRAND = new Uint8Array([
            'a'.charCodeAt(0),
            'v'.charCodeAt(0),
            'c'.charCodeAt(0),
            '1'.charCodeAt(0)
        ]);
        MINOR_VERSION = new Uint8Array([
            0,
            0,
            0,
            1
        ]);
        VIDEO_HDLR = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x76,
            0x69,
            0x64,
            0x65,
            // handler_type: 'vide'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x56,
            0x69,
            0x64,
            0x65,
            0x6f,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'VideoHandler'
        ]);
        AUDIO_HDLR = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x73,
            0x6f,
            0x75,
            0x6e,
            // handler_type: 'soun'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x53,
            0x6f,
            0x75,
            0x6e,
            0x64,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'SoundHandler'
        ]);
        HDLR_TYPES = {
            video: VIDEO_HDLR,
            audio: AUDIO_HDLR
        };
        DREF = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01,
            // entry_count
            0x00,
            0x00,
            0x00,
            0x0c,
            // entry_size
            0x75,
            0x72,
            0x6c,
            0x20,
            // 'url' type
            0x00,
            // version 0
            0x00,
            0x00,
            0x01 // entry_flags
        ]);
        SMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            // balance, 0 means centered
            0x00,
            0x00 // reserved
        ]);
        STCO = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00 // entry_count
        ]);
        STSC = STCO;
        STSZ = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // sample_size
            0x00,
            0x00,
            0x00,
            0x00 // sample_count
        ]);
        STTS = STCO;
        VMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x01,
            // flags
            0x00,
            0x00,
            // graphicsmode
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00 // opcolor
        ]);
    })();
    box = function(type) {
        var payload = [], size = 0, i, result, view;
        for(i = 1; i < arguments.length; i++)payload.push(arguments[i]);
        i = payload.length; // calculate the total size we need to allocate
        while(i--)size += payload[i].byteLength;
        result = new Uint8Array(size + 8);
        view = new DataView(result.buffer, result.byteOffset, result.byteLength);
        view.setUint32(0, result.byteLength);
        result.set(type, 4); // copy the payload into the result
        for(i = 0, size = 8; i < payload.length; i++){
            result.set(payload[i], size);
            size += payload[i].byteLength;
        }
        return result;
    };
    dinf = function() {
        return box(types.dinf, box(types.dref, DREF));
    };
    esds = function(track) {
        return box(types.esds, new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            // ES_Descriptor
            0x03,
            // tag, ES_DescrTag
            0x19,
            // length
            0x00,
            0x00,
            // ES_ID
            0x00,
            // streamDependenceFlag, URL_flag, reserved, streamPriority
            // DecoderConfigDescriptor
            0x04,
            // tag, DecoderConfigDescrTag
            0x11,
            // length
            0x40,
            // object type
            0x15,
            // streamType
            0x00,
            0x06,
            0x00,
            // bufferSizeDB
            0x00,
            0x00,
            0xda,
            0xc0,
            // maxBitrate
            0x00,
            0x00,
            0xda,
            0xc0,
            // avgBitrate
            // DecoderSpecificInfo
            0x05,
            // tag, DecoderSpecificInfoTag
            0x02,
            // length
            // ISO/IEC 14496-3, AudioSpecificConfig
            // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
            track.audioobjecttype << 3 | track.samplingfrequencyindex >>> 1,
            track.samplingfrequencyindex << 7 | track.channelcount << 3,
            0x06,
            0x01,
            0x02 // GASpecificConfig
        ]));
    };
    ftyp = function() {
        return box(types.ftyp, MAJOR_BRAND, MINOR_VERSION, MAJOR_BRAND, AVC1_BRAND);
    };
    hdlr = function(type) {
        return box(types.hdlr, HDLR_TYPES[type]);
    };
    mdat = function(data) {
        return box(types.mdat, data);
    };
    mdhd = function(track) {
        var result = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            0x00,
            0x01,
            0x5f,
            0x90,
            // timescale, 90,000 "ticks" per second
            track.duration >>> 24 & 0xFF,
            track.duration >>> 16 & 0xFF,
            track.duration >>> 8 & 0xFF,
            track.duration & 0xFF,
            // duration
            0x55,
            0xc4,
            // 'und' language (undetermined)
            0x00,
            0x00
        ]); // Use the sample rate from the track metadata, when it is
        // defined. The sample rate can be parsed out of an ADTS header, for
        // instance.
        if (track.samplerate) {
            result[12] = track.samplerate >>> 24 & 0xFF;
            result[13] = track.samplerate >>> 16 & 0xFF;
            result[14] = track.samplerate >>> 8 & 0xFF;
            result[15] = track.samplerate & 0xFF;
        }
        return box(types.mdhd, result);
    };
    mdia = function(track) {
        return box(types.mdia, mdhd(track), hdlr(track.type), minf(track));
    };
    mfhd = function(sequenceNumber) {
        return box(types.mfhd, new Uint8Array([
            0x00,
            0x00,
            0x00,
            0x00,
            // flags
            (sequenceNumber & 0xFF000000) >> 24,
            (sequenceNumber & 0xFF0000) >> 16,
            (sequenceNumber & 0xFF00) >> 8,
            sequenceNumber & 0xFF // sequence_number
        ]));
    };
    minf = function(track) {
        return box(types.minf, track.type === 'video' ? box(types.vmhd, VMHD) : box(types.smhd, SMHD), dinf(), stbl(track));
    };
    moof = function(sequenceNumber, tracks) {
        var trackFragments = [], i = tracks.length; // build traf boxes for each track fragment
        while(i--)trackFragments[i] = traf(tracks[i]);
        return box.apply(null, [
            types.moof,
            mfhd(sequenceNumber)
        ].concat(trackFragments));
    };
    /**
   * Returns a movie box.
   * @param tracks {array} the tracks associated with this movie
   * @see ISO/IEC 14496-12:2012(E), section 8.2.1
   */ moov = function(tracks) {
        var i = tracks.length, boxes = [];
        while(i--)boxes[i] = trak(tracks[i]);
        return box.apply(null, [
            types.moov,
            mvhd(0xffffffff)
        ].concat(boxes).concat(mvex(tracks)));
    };
    mvex = function(tracks) {
        var i = tracks.length, boxes = [];
        while(i--)boxes[i] = trex(tracks[i]);
        return box.apply(null, [
            types.mvex
        ].concat(boxes));
    };
    mvhd = function(duration) {
        var bytes = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x02,
            // modification_time
            0x00,
            0x01,
            0x5f,
            0x90,
            // timescale, 90,000 "ticks" per second
            (duration & 0xFF000000) >> 24,
            (duration & 0xFF0000) >> 16,
            (duration & 0xFF00) >> 8,
            duration & 0xFF,
            // duration
            0x00,
            0x01,
            0x00,
            0x00,
            // 1.0 rate
            0x01,
            0x00,
            // 1.0 volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0xff,
            0xff,
            0xff,
            0xff // next_track_ID
        ]);
        return box(types.mvhd, bytes);
    };
    sdtp = function(track) {
        var samples = track.samples || [], bytes = new Uint8Array(4 + samples.length), flags, i; // leave the full box header (4 bytes) all zero
        // write the sample table
        for(i = 0; i < samples.length; i++){
            flags = samples[i].flags;
            bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
        }
        return box(types.sdtp, bytes);
    };
    stbl = function(track) {
        return box(types.stbl, stsd(track), box(types.stts, STTS), box(types.stsc, STSC), box(types.stsz, STSZ), box(types.stco, STCO));
    };
    (function() {
        var videoSample, audioSample;
        stsd = function(track) {
            return box(types.stsd, new Uint8Array([
                0x00,
                // version 0
                0x00,
                0x00,
                0x00,
                // flags
                0x00,
                0x00,
                0x00,
                0x01
            ]), track.type === 'video' ? videoSample(track) : audioSample(track));
        };
        videoSample = function(track) {
            var sps = track.sps || [], pps = track.pps || [], sequenceParameterSets = [], pictureParameterSets = [], i, avc1Box; // assemble the SPSs
            for(i = 0; i < sps.length; i++){
                sequenceParameterSets.push((sps[i].byteLength & 0xFF00) >>> 8);
                sequenceParameterSets.push(sps[i].byteLength & 0xFF); // sequenceParameterSetLength
                sequenceParameterSets = sequenceParameterSets.concat(Array.prototype.slice.call(sps[i])); // SPS
            } // assemble the PPSs
            for(i = 0; i < pps.length; i++){
                pictureParameterSets.push((pps[i].byteLength & 0xFF00) >>> 8);
                pictureParameterSets.push(pps[i].byteLength & 0xFF);
                pictureParameterSets = pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));
            }
            avc1Box = [
                types.avc1,
                new Uint8Array([
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // reserved
                    0x00,
                    0x01,
                    // data_reference_index
                    0x00,
                    0x00,
                    // pre_defined
                    0x00,
                    0x00,
                    // reserved
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // pre_defined
                    (track.width & 0xff00) >> 8,
                    track.width & 0xff,
                    // width
                    (track.height & 0xff00) >> 8,
                    track.height & 0xff,
                    // height
                    0x00,
                    0x48,
                    0x00,
                    0x00,
                    // horizresolution
                    0x00,
                    0x48,
                    0x00,
                    0x00,
                    // vertresolution
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // reserved
                    0x00,
                    0x01,
                    // frame_count
                    0x13,
                    0x76,
                    0x69,
                    0x64,
                    0x65,
                    0x6f,
                    0x6a,
                    0x73,
                    0x2d,
                    0x63,
                    0x6f,
                    0x6e,
                    0x74,
                    0x72,
                    0x69,
                    0x62,
                    0x2d,
                    0x68,
                    0x6c,
                    0x73,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // compressorname
                    0x00,
                    0x18,
                    // depth = 24
                    0x11,
                    0x11 // pre_defined = -1
                ]),
                box(types.avcC, new Uint8Array([
                    0x01,
                    // configurationVersion
                    track.profileIdc,
                    // AVCProfileIndication
                    track.profileCompatibility,
                    // profile_compatibility
                    track.levelIdc,
                    // AVCLevelIndication
                    0xff // lengthSizeMinusOne, hard-coded to 4 bytes
                ].concat([
                    sps.length
                ], // numOfSequenceParameterSets
                sequenceParameterSets, // "SPS"
                [
                    pps.length
                ], // numOfPictureParameterSets
                pictureParameterSets // "PPS"
                ))),
                box(types.btrt, new Uint8Array([
                    0x00,
                    0x1c,
                    0x9c,
                    0x80,
                    // bufferSizeDB
                    0x00,
                    0x2d,
                    0xc6,
                    0xc0,
                    // maxBitrate
                    0x00,
                    0x2d,
                    0xc6,
                    0xc0 // avgBitrate
                ]))
            ];
            if (track.sarRatio) {
                var hSpacing = track.sarRatio[0], vSpacing = track.sarRatio[1];
                avc1Box.push(box(types.pasp, new Uint8Array([
                    (hSpacing & 0xFF000000) >> 24,
                    (hSpacing & 0xFF0000) >> 16,
                    (hSpacing & 0xFF00) >> 8,
                    hSpacing & 0xFF,
                    (vSpacing & 0xFF000000) >> 24,
                    (vSpacing & 0xFF0000) >> 16,
                    (vSpacing & 0xFF00) >> 8,
                    vSpacing & 0xFF
                ])));
            }
            return box.apply(null, avc1Box);
        };
        audioSample = function(track) {
            return box(types.mp4a, new Uint8Array([
                // SampleEntry, ISO/IEC 14496-12
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                // reserved
                0x00,
                0x01,
                // data_reference_index
                // AudioSampleEntry, ISO/IEC 14496-12
                0x00,
                0x00,
                0x00,
                0x00,
                // reserved
                0x00,
                0x00,
                0x00,
                0x00,
                // reserved
                (track.channelcount & 0xff00) >> 8,
                track.channelcount & 0xff,
                // channelcount
                (track.samplesize & 0xff00) >> 8,
                track.samplesize & 0xff,
                // samplesize
                0x00,
                0x00,
                // pre_defined
                0x00,
                0x00,
                // reserved
                (track.samplerate & 0xff00) >> 8,
                track.samplerate & 0xff,
                0x00,
                0x00 // samplerate, 16.16
            ]), esds(track));
        };
    })();
    tkhd = function(track) {
        var result = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x07,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            // modification_time
            (track.id & 0xFF000000) >> 24,
            (track.id & 0xFF0000) >> 16,
            (track.id & 0xFF00) >> 8,
            track.id & 0xFF,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            (track.duration & 0xFF000000) >> 24,
            (track.duration & 0xFF0000) >> 16,
            (track.duration & 0xFF00) >> 8,
            track.duration & 0xFF,
            // duration
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            // layer
            0x00,
            0x00,
            // alternate_group
            0x01,
            0x00,
            // non-audio track volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            (track.width & 0xFF00) >> 8,
            track.width & 0xFF,
            0x00,
            0x00,
            // width
            (track.height & 0xFF00) >> 8,
            track.height & 0xFF,
            0x00,
            0x00 // height
        ]);
        return box(types.tkhd, result);
    };
    /**
   * Generate a track fragment (traf) box. A traf box collects metadata
   * about tracks in a movie fragment (moof) box.
   */ traf = function(track) {
        var trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable, dataOffset, upperWordBaseMediaDecodeTime, lowerWordBaseMediaDecodeTime;
        trackFragmentHeader = box(types.tfhd, new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x3a,
            // flags
            (track.id & 0xFF000000) >> 24,
            (track.id & 0xFF0000) >> 16,
            (track.id & 0xFF00) >> 8,
            track.id & 0xFF,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x01,
            // sample_description_index
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_duration
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_size
            0x00,
            0x00,
            0x00,
            0x00 // default_sample_flags
        ]));
        upperWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime / MAX_UINT32);
        lowerWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime % MAX_UINT32);
        trackFragmentDecodeTime = box(types.tfdt, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            // baseMediaDecodeTime
            upperWordBaseMediaDecodeTime >>> 24 & 0xFF,
            upperWordBaseMediaDecodeTime >>> 16 & 0xFF,
            upperWordBaseMediaDecodeTime >>> 8 & 0xFF,
            upperWordBaseMediaDecodeTime & 0xFF,
            lowerWordBaseMediaDecodeTime >>> 24 & 0xFF,
            lowerWordBaseMediaDecodeTime >>> 16 & 0xFF,
            lowerWordBaseMediaDecodeTime >>> 8 & 0xFF,
            lowerWordBaseMediaDecodeTime & 0xFF
        ])); // the data offset specifies the number of bytes from the start of
        // the containing moof to the first payload byte of the associated
        // mdat
        dataOffset = 92; // mdat header
        // audio tracks require less metadata
        if (track.type === 'audio') {
            trackFragmentRun = trun$1(track, dataOffset);
            return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun);
        } // video tracks should contain an independent and disposable samples
        // box (sdtp)
        // generate one and adjust offsets to match
        sampleDependencyTable = sdtp(track);
        trackFragmentRun = trun$1(track, sampleDependencyTable.length + dataOffset);
        return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable);
    };
    /**
   * Generate a track box.
   * @param track {object} a track definition
   * @return {Uint8Array} the track box
   */ trak = function(track) {
        track.duration = track.duration || 0xffffffff;
        return box(types.trak, tkhd(track), mdia(track));
    };
    trex = function(track) {
        var result = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            (track.id & 0xFF000000) >> 24,
            (track.id & 0xFF0000) >> 16,
            (track.id & 0xFF00) >> 8,
            track.id & 0xFF,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x01,
            // default_sample_description_index
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_duration
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_size
            0x00,
            0x01,
            0x00,
            0x01 // default_sample_flags
        ]); // the last two bytes of default_sample_flags is the sample
        // degradation priority, a hint about the importance of this sample
        // relative to others. Lower the degradation priority for all sample
        // types other than video.
        if (track.type !== 'video') result[result.length - 1] = 0x00;
        return box(types.trex, result);
    };
    (function() {
        var audioTrun, videoTrun, trunHeader; // This method assumes all samples are uniform. That is, if a
        // duration is present for the first sample, it will be present for
        // all subsequent samples.
        // see ISO/IEC 14496-12:2012, Section 8.8.8.1
        trunHeader = function(samples, offset) {
            var durationPresent = 0, sizePresent = 0, flagsPresent = 0, compositionTimeOffset = 0; // trun flag constants
            if (samples.length) {
                if (samples[0].duration !== undefined) durationPresent = 0x1;
                if (samples[0].size !== undefined) sizePresent = 0x2;
                if (samples[0].flags !== undefined) flagsPresent = 0x4;
                if (samples[0].compositionTimeOffset !== undefined) compositionTimeOffset = 0x8;
            }
            return [
                0x00,
                // version 0
                0x00,
                durationPresent | sizePresent | flagsPresent | compositionTimeOffset,
                0x01,
                // flags
                (samples.length & 0xFF000000) >>> 24,
                (samples.length & 0xFF0000) >>> 16,
                (samples.length & 0xFF00) >>> 8,
                samples.length & 0xFF,
                // sample_count
                (offset & 0xFF000000) >>> 24,
                (offset & 0xFF0000) >>> 16,
                (offset & 0xFF00) >>> 8,
                offset & 0xFF // data_offset
            ];
        };
        videoTrun = function(track, offset) {
            var bytesOffest, bytes, header, samples, sample, i;
            samples = track.samples || [];
            offset += 20 + 16 * samples.length;
            header = trunHeader(samples, offset);
            bytes = new Uint8Array(header.length + samples.length * 16);
            bytes.set(header);
            bytesOffest = header.length;
            for(i = 0; i < samples.length; i++){
                sample = samples[i];
                bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
                bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
                bytes[bytesOffest++] = sample.flags.isLeading << 2 | sample.flags.dependsOn;
                bytes[bytesOffest++] = sample.flags.isDependedOn << 6 | sample.flags.hasRedundancy << 4 | sample.flags.paddingValue << 1 | sample.flags.isNonSyncSample;
                bytes[bytesOffest++] = sample.flags.degradationPriority & 61440;
                bytes[bytesOffest++] = sample.flags.degradationPriority & 0x0F; // sample_flags
                bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.compositionTimeOffset & 0xFF; // sample_composition_time_offset
            }
            return box(types.trun, bytes);
        };
        audioTrun = function(track, offset) {
            var bytes, bytesOffest, header, samples, sample, i;
            samples = track.samples || [];
            offset += 20 + 8 * samples.length;
            header = trunHeader(samples, offset);
            bytes = new Uint8Array(header.length + samples.length * 8);
            bytes.set(header);
            bytesOffest = header.length;
            for(i = 0; i < samples.length; i++){
                sample = samples[i];
                bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
                bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
            }
            return box(types.trun, bytes);
        };
        trun$1 = function(track, offset) {
            if (track.type === 'audio') return audioTrun(track, offset);
            return videoTrun(track, offset);
        };
    })();
    var mp4Generator = {
        ftyp: ftyp,
        mdat: mdat,
        moof: moof,
        moov: moov,
        initSegment: function(tracks) {
            var fileType = ftyp(), movie = moov(tracks), result;
            result = new Uint8Array(fileType.byteLength + movie.byteLength);
            result.set(fileType);
            result.set(movie, fileType.byteLength);
            return result;
        }
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ // composed of the nal units that make up that frame
    // Also keep track of cummulative data about the frame from the nal units such
    // as the frame duration, starting pts, etc.
    var groupNalsIntoFrames = function(nalUnits) {
        var i, currentNal, currentFrame = [], frames = []; // TODO added for LHLS, make sure this is OK
        frames.byteLength = 0;
        frames.nalCount = 0;
        frames.duration = 0;
        currentFrame.byteLength = 0;
        for(i = 0; i < nalUnits.length; i++){
            currentNal = nalUnits[i]; // Split on 'aud'-type nal units
            if (currentNal.nalUnitType === 'access_unit_delimiter_rbsp') {
                // Since the very first nal unit is expected to be an AUD
                // only push to the frames array when currentFrame is not empty
                if (currentFrame.length) {
                    currentFrame.duration = currentNal.dts - currentFrame.dts; // TODO added for LHLS, make sure this is OK
                    frames.byteLength += currentFrame.byteLength;
                    frames.nalCount += currentFrame.length;
                    frames.duration += currentFrame.duration;
                    frames.push(currentFrame);
                }
                currentFrame = [
                    currentNal
                ];
                currentFrame.byteLength = currentNal.data.byteLength;
                currentFrame.pts = currentNal.pts;
                currentFrame.dts = currentNal.dts;
            } else {
                // Specifically flag key frames for ease of use later
                if (currentNal.nalUnitType === 'slice_layer_without_partitioning_rbsp_idr') currentFrame.keyFrame = true;
                currentFrame.duration = currentNal.dts - currentFrame.dts;
                currentFrame.byteLength += currentNal.data.byteLength;
                currentFrame.push(currentNal);
            }
        } // For the last frame, use the duration of the previous frame if we
        // have nothing better to go on
        if (frames.length && (!currentFrame.duration || currentFrame.duration <= 0)) currentFrame.duration = frames[frames.length - 1].duration;
         // Push the final frame
        // TODO added for LHLS, make sure this is OK
        frames.byteLength += currentFrame.byteLength;
        frames.nalCount += currentFrame.length;
        frames.duration += currentFrame.duration;
        frames.push(currentFrame);
        return frames;
    }; // Convert an array of frames into an array of Gop with each Gop being composed
    // of the frames that make up that Gop
    // Also keep track of cummulative data about the Gop from the frames such as the
    // Gop duration, starting pts, etc.
    var groupFramesIntoGops = function(frames) {
        var i, currentFrame, currentGop = [], gops = []; // We must pre-set some of the values on the Gop since we
        // keep running totals of these values
        currentGop.byteLength = 0;
        currentGop.nalCount = 0;
        currentGop.duration = 0;
        currentGop.pts = frames[0].pts;
        currentGop.dts = frames[0].dts; // store some metadata about all the Gops
        gops.byteLength = 0;
        gops.nalCount = 0;
        gops.duration = 0;
        gops.pts = frames[0].pts;
        gops.dts = frames[0].dts;
        for(i = 0; i < frames.length; i++){
            currentFrame = frames[i];
            if (currentFrame.keyFrame) {
                // Since the very first frame is expected to be an keyframe
                // only push to the gops array when currentGop is not empty
                if (currentGop.length) {
                    gops.push(currentGop);
                    gops.byteLength += currentGop.byteLength;
                    gops.nalCount += currentGop.nalCount;
                    gops.duration += currentGop.duration;
                }
                currentGop = [
                    currentFrame
                ];
                currentGop.nalCount = currentFrame.length;
                currentGop.byteLength = currentFrame.byteLength;
                currentGop.pts = currentFrame.pts;
                currentGop.dts = currentFrame.dts;
                currentGop.duration = currentFrame.duration;
            } else {
                currentGop.duration += currentFrame.duration;
                currentGop.nalCount += currentFrame.length;
                currentGop.byteLength += currentFrame.byteLength;
                currentGop.push(currentFrame);
            }
        }
        if (gops.length && currentGop.duration <= 0) currentGop.duration = gops[gops.length - 1].duration;
        gops.byteLength += currentGop.byteLength;
        gops.nalCount += currentGop.nalCount;
        gops.duration += currentGop.duration; // push the final Gop
        gops.push(currentGop);
        return gops;
    };
    /*
   * Search for the first keyframe in the GOPs and throw away all frames
   * until that keyframe. Then extend the duration of the pulled keyframe
   * and pull the PTS and DTS of the keyframe so that it covers the time
   * range of the frames that were disposed.
   *
   * @param {Array} gops video GOPs
   * @returns {Array} modified video GOPs
   */ var extendFirstKeyFrame = function(gops) {
        var currentGop;
        if (!gops[0][0].keyFrame && gops.length > 1) {
            // Remove the first GOP
            currentGop = gops.shift();
            gops.byteLength -= currentGop.byteLength;
            gops.nalCount -= currentGop.nalCount; // Extend the first frame of what is now the
            // first gop to cover the time period of the
            // frames we just removed
            gops[0][0].dts = currentGop.dts;
            gops[0][0].pts = currentGop.pts;
            gops[0][0].duration += currentGop.duration;
        }
        return gops;
    };
    /**
   * Default sample object
   * see ISO/IEC 14496-12:2012, section 8.6.4.3
   */ var createDefaultSample = function() {
        return {
            size: 0,
            flags: {
                isLeading: 0,
                dependsOn: 1,
                isDependedOn: 0,
                hasRedundancy: 0,
                degradationPriority: 0,
                isNonSyncSample: 1
            }
        };
    };
    /*
   * Collates information from a video frame into an object for eventual
   * entry into an MP4 sample table.
   *
   * @param {Object} frame the video frame
   * @param {Number} dataOffset the byte offset to position the sample
   * @return {Object} object containing sample table info for a frame
   */ var sampleForFrame = function(frame, dataOffset) {
        var sample = createDefaultSample();
        sample.dataOffset = dataOffset;
        sample.compositionTimeOffset = frame.pts - frame.dts;
        sample.duration = frame.duration;
        sample.size = 4 * frame.length; // Space for nal unit size
        sample.size += frame.byteLength;
        if (frame.keyFrame) {
            sample.flags.dependsOn = 2;
            sample.flags.isNonSyncSample = 0;
        }
        return sample;
    }; // generate the track's sample table from an array of gops
    var generateSampleTable$1 = function(gops, baseDataOffset) {
        var h, i, sample, currentGop, currentFrame, dataOffset = baseDataOffset || 0, samples = [];
        for(h = 0; h < gops.length; h++){
            currentGop = gops[h];
            for(i = 0; i < currentGop.length; i++){
                currentFrame = currentGop[i];
                sample = sampleForFrame(currentFrame, dataOffset);
                dataOffset += sample.size;
                samples.push(sample);
            }
        }
        return samples;
    }; // generate the track's raw mdat data from an array of gops
    var concatenateNalData = function(gops) {
        var h, i, j, currentGop, currentFrame, currentNal, dataOffset = 0, nalsByteLength = gops.byteLength, numberOfNals = gops.nalCount, totalByteLength = nalsByteLength + 4 * numberOfNals, data = new Uint8Array(totalByteLength), view = new DataView(data.buffer); // For each Gop..
        for(h = 0; h < gops.length; h++){
            currentGop = gops[h]; // For each Frame..
            for(i = 0; i < currentGop.length; i++){
                currentFrame = currentGop[i]; // For each NAL..
                for(j = 0; j < currentFrame.length; j++){
                    currentNal = currentFrame[j];
                    view.setUint32(dataOffset, currentNal.data.byteLength);
                    dataOffset += 4;
                    data.set(currentNal.data, dataOffset);
                    dataOffset += currentNal.data.byteLength;
                }
            }
        }
        return data;
    }; // generate the track's sample table from a frame
    var generateSampleTableForFrame = function(frame, baseDataOffset) {
        var sample, dataOffset = baseDataOffset || 0, samples = [];
        sample = sampleForFrame(frame, dataOffset);
        samples.push(sample);
        return samples;
    }; // generate the track's raw mdat data from a frame
    var concatenateNalDataForFrame = function(frame) {
        var i, currentNal, dataOffset = 0, nalsByteLength = frame.byteLength, numberOfNals = frame.length, totalByteLength = nalsByteLength + 4 * numberOfNals, data = new Uint8Array(totalByteLength), view = new DataView(data.buffer); // For each NAL..
        for(i = 0; i < frame.length; i++){
            currentNal = frame[i];
            view.setUint32(dataOffset, currentNal.data.byteLength);
            dataOffset += 4;
            data.set(currentNal.data, dataOffset);
            dataOffset += currentNal.data.byteLength;
        }
        return data;
    };
    var frameUtils$1 = {
        groupNalsIntoFrames: groupNalsIntoFrames,
        groupFramesIntoGops: groupFramesIntoGops,
        extendFirstKeyFrame: extendFirstKeyFrame,
        generateSampleTable: generateSampleTable$1,
        concatenateNalData: concatenateNalData,
        generateSampleTableForFrame: generateSampleTableForFrame,
        concatenateNalDataForFrame: concatenateNalDataForFrame
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var highPrefix = [
        33,
        16,
        5,
        32,
        164,
        27
    ];
    var lowPrefix = [
        33,
        65,
        108,
        84,
        1,
        2,
        4,
        8,
        168,
        2,
        4,
        8,
        17,
        191,
        252
    ];
    var zeroFill = function(count) {
        var a = [];
        while(count--)a.push(0);
        return a;
    };
    var makeTable = function(metaTable) {
        return Object.keys(metaTable).reduce(function(obj, key) {
            obj[key] = new Uint8Array(metaTable[key].reduce(function(arr, part) {
                return arr.concat(part);
            }, []));
            return obj;
        }, {});
    };
    var silence;
    var silence_1 = function() {
        if (!silence) {
            // Frames-of-silence to use for filling in missing AAC frames
            var coneOfSilence = {
                96000: [
                    highPrefix,
                    [
                        227,
                        64
                    ],
                    zeroFill(154),
                    [
                        56
                    ]
                ],
                88200: [
                    highPrefix,
                    [
                        231
                    ],
                    zeroFill(170),
                    [
                        56
                    ]
                ],
                64000: [
                    highPrefix,
                    [
                        248,
                        192
                    ],
                    zeroFill(240),
                    [
                        56
                    ]
                ],
                48000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        148,
                        128
                    ],
                    zeroFill(54),
                    [
                        112
                    ]
                ],
                44100: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        163,
                        128
                    ],
                    zeroFill(84),
                    [
                        112
                    ]
                ],
                32000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        234
                    ],
                    zeroFill(226),
                    [
                        112
                    ]
                ],
                24000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        255,
                        128
                    ],
                    zeroFill(268),
                    [
                        111,
                        112
                    ],
                    zeroFill(126),
                    [
                        224
                    ]
                ],
                16000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        255,
                        128
                    ],
                    zeroFill(268),
                    [
                        111,
                        255
                    ],
                    zeroFill(269),
                    [
                        223,
                        108
                    ],
                    zeroFill(195),
                    [
                        1,
                        192
                    ]
                ],
                12000: [
                    lowPrefix,
                    zeroFill(268),
                    [
                        3,
                        127,
                        248
                    ],
                    zeroFill(268),
                    [
                        6,
                        255,
                        240
                    ],
                    zeroFill(268),
                    [
                        13,
                        255,
                        224
                    ],
                    zeroFill(268),
                    [
                        27,
                        253,
                        128
                    ],
                    zeroFill(259),
                    [
                        56
                    ]
                ],
                11025: [
                    lowPrefix,
                    zeroFill(268),
                    [
                        3,
                        127,
                        248
                    ],
                    zeroFill(268),
                    [
                        6,
                        255,
                        240
                    ],
                    zeroFill(268),
                    [
                        13,
                        255,
                        224
                    ],
                    zeroFill(268),
                    [
                        27,
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        175,
                        128
                    ],
                    zeroFill(108),
                    [
                        112
                    ]
                ],
                8000: [
                    lowPrefix,
                    zeroFill(268),
                    [
                        3,
                        121,
                        16
                    ],
                    zeroFill(47),
                    [
                        7
                    ]
                ]
            };
            silence = makeTable(coneOfSilence);
        }
        return silence;
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var ONE_SECOND_IN_TS$4 = 90000, // 90kHz clock
    secondsToVideoTs, secondsToAudioTs, videoTsToSeconds, audioTsToSeconds, audioTsToVideoTs, videoTsToAudioTs, metadataTsToSeconds;
    secondsToVideoTs = function(seconds) {
        return seconds * ONE_SECOND_IN_TS$4;
    };
    secondsToAudioTs = function(seconds, sampleRate) {
        return seconds * sampleRate;
    };
    videoTsToSeconds = function(timestamp) {
        return timestamp / ONE_SECOND_IN_TS$4;
    };
    audioTsToSeconds = function(timestamp, sampleRate) {
        return timestamp / sampleRate;
    };
    audioTsToVideoTs = function(timestamp, sampleRate) {
        return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
    };
    videoTsToAudioTs = function(timestamp, sampleRate) {
        return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
    };
    /**
   * Adjust ID3 tag or caption timing information by the timeline pts values
   * (if keepOriginalTimestamps is false) and convert to seconds
   */ metadataTsToSeconds = function(timestamp, timelineStartPts, keepOriginalTimestamps) {
        return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
    };
    var clock$2 = {
        ONE_SECOND_IN_TS: ONE_SECOND_IN_TS$4,
        secondsToVideoTs: secondsToVideoTs,
        secondsToAudioTs: secondsToAudioTs,
        videoTsToSeconds: videoTsToSeconds,
        audioTsToSeconds: audioTsToSeconds,
        audioTsToVideoTs: audioTsToVideoTs,
        videoTsToAudioTs: videoTsToAudioTs,
        metadataTsToSeconds: metadataTsToSeconds
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var coneOfSilence = silence_1;
    var clock$1 = clock$2;
    /**
   * Sum the `byteLength` properties of the data in each AAC frame
   */ var sumFrameByteLengths = function(array) {
        var i, currentObj, sum = 0; // sum the byteLength's all each nal unit in the frame
        for(i = 0; i < array.length; i++){
            currentObj = array[i];
            sum += currentObj.data.byteLength;
        }
        return sum;
    }; // Possibly pad (prefix) the audio track with silence if appending this track
    // would lead to the introduction of a gap in the audio buffer
    var prefixWithSilence = function(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime) {
        var baseMediaDecodeTimeTs, frameDuration = 0, audioGapDuration = 0, audioFillFrameCount = 0, audioFillDuration = 0, silentFrame, i, firstFrame;
        if (!frames.length) return;
        baseMediaDecodeTimeTs = clock$1.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate); // determine frame clock duration based on sample rate, round up to avoid overfills
        frameDuration = Math.ceil(clock$1.ONE_SECOND_IN_TS / (track.samplerate / 1024));
        if (audioAppendStartTs && videoBaseMediaDecodeTime) {
            // insert the shortest possible amount (audio gap or audio to video gap)
            audioGapDuration = baseMediaDecodeTimeTs - Math.max(audioAppendStartTs, videoBaseMediaDecodeTime); // number of full frames in the audio gap
            audioFillFrameCount = Math.floor(audioGapDuration / frameDuration);
            audioFillDuration = audioFillFrameCount * frameDuration;
        } // don't attempt to fill gaps smaller than a single frame or larger
        // than a half second
        if (audioFillFrameCount < 1 || audioFillDuration > clock$1.ONE_SECOND_IN_TS / 2) return;
        silentFrame = coneOfSilence()[track.samplerate];
        if (!silentFrame) // we don't have a silent frame pregenerated for the sample rate, so use a frame
        // from the content instead
        silentFrame = frames[0].data;
        for(i = 0; i < audioFillFrameCount; i++){
            firstFrame = frames[0];
            frames.splice(0, 0, {
                data: silentFrame,
                dts: firstFrame.dts - frameDuration,
                pts: firstFrame.pts - frameDuration
            });
        }
        track.baseMediaDecodeTime -= Math.floor(clock$1.videoTsToAudioTs(audioFillDuration, track.samplerate));
        return audioFillDuration;
    }; // If the audio segment extends before the earliest allowed dts
    // value, remove AAC frames until starts at or after the earliest
    // allowed DTS so that we don't end up with a negative baseMedia-
    // DecodeTime for the audio track
    var trimAdtsFramesByEarliestDts = function(adtsFrames, track, earliestAllowedDts) {
        if (track.minSegmentDts >= earliestAllowedDts) return adtsFrames;
         // We will need to recalculate the earliest segment Dts
        track.minSegmentDts = Infinity;
        return adtsFrames.filter(function(currentFrame) {
            // If this is an allowed frame, keep it and record it's Dts
            if (currentFrame.dts >= earliestAllowedDts) {
                track.minSegmentDts = Math.min(track.minSegmentDts, currentFrame.dts);
                track.minSegmentPts = track.minSegmentDts;
                return true;
            } // Otherwise, discard it
            return false;
        });
    }; // generate the track's raw mdat data from an array of frames
    var generateSampleTable = function(frames) {
        var i, currentFrame, samples = [];
        for(i = 0; i < frames.length; i++){
            currentFrame = frames[i];
            samples.push({
                size: currentFrame.data.byteLength,
                duration: 1024 // For AAC audio, all samples contain 1024 samples
            });
        }
        return samples;
    }; // generate the track's sample table from an array of frames
    var concatenateFrameData = function(frames) {
        var i, currentFrame, dataOffset = 0, data = new Uint8Array(sumFrameByteLengths(frames));
        for(i = 0; i < frames.length; i++){
            currentFrame = frames[i];
            data.set(currentFrame.data, dataOffset);
            dataOffset += currentFrame.data.byteLength;
        }
        return data;
    };
    var audioFrameUtils$1 = {
        prefixWithSilence: prefixWithSilence,
        trimAdtsFramesByEarliestDts: trimAdtsFramesByEarliestDts,
        generateSampleTable: generateSampleTable,
        concatenateFrameData: concatenateFrameData
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var ONE_SECOND_IN_TS$3 = clock$2.ONE_SECOND_IN_TS;
    /**
   * Store information about the start and end of the track and the
   * duration for each frame/sample we process in order to calculate
   * the baseMediaDecodeTime
   */ var collectDtsInfo = function(track, data) {
        if (typeof data.pts === 'number') {
            if (track.timelineStartInfo.pts === undefined) track.timelineStartInfo.pts = data.pts;
            if (track.minSegmentPts === undefined) track.minSegmentPts = data.pts;
            else track.minSegmentPts = Math.min(track.minSegmentPts, data.pts);
            if (track.maxSegmentPts === undefined) track.maxSegmentPts = data.pts;
            else track.maxSegmentPts = Math.max(track.maxSegmentPts, data.pts);
        }
        if (typeof data.dts === 'number') {
            if (track.timelineStartInfo.dts === undefined) track.timelineStartInfo.dts = data.dts;
            if (track.minSegmentDts === undefined) track.minSegmentDts = data.dts;
            else track.minSegmentDts = Math.min(track.minSegmentDts, data.dts);
            if (track.maxSegmentDts === undefined) track.maxSegmentDts = data.dts;
            else track.maxSegmentDts = Math.max(track.maxSegmentDts, data.dts);
        }
    };
    /**
   * Clear values used to calculate the baseMediaDecodeTime between
   * tracks
   */ var clearDtsInfo = function(track) {
        delete track.minSegmentDts;
        delete track.maxSegmentDts;
        delete track.minSegmentPts;
        delete track.maxSegmentPts;
    };
    /**
   * Calculate the track's baseMediaDecodeTime based on the earliest
   * DTS the transmuxer has ever seen and the minimum DTS for the
   * current track
   * @param track {object} track metadata configuration
   * @param keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */ var calculateTrackBaseMediaDecodeTime = function(track, keepOriginalTimestamps) {
        var baseMediaDecodeTime, scale, minSegmentDts = track.minSegmentDts; // Optionally adjust the time so the first segment starts at zero.
        if (!keepOriginalTimestamps) minSegmentDts -= track.timelineStartInfo.dts;
         // track.timelineStartInfo.baseMediaDecodeTime is the location, in time, where
        // we want the start of the first segment to be placed
        baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime; // Add to that the distance this segment is from the very first
        baseMediaDecodeTime += minSegmentDts; // baseMediaDecodeTime must not become negative
        baseMediaDecodeTime = Math.max(0, baseMediaDecodeTime);
        if (track.type === 'audio') {
            // Audio has a different clock equal to the sampling_rate so we need to
            // scale the PTS values into the clock rate of the track
            scale = track.samplerate / ONE_SECOND_IN_TS$3;
            baseMediaDecodeTime *= scale;
            baseMediaDecodeTime = Math.floor(baseMediaDecodeTime);
        }
        return baseMediaDecodeTime;
    };
    var trackDecodeInfo$1 = {
        clearDtsInfo: clearDtsInfo,
        calculateTrackBaseMediaDecodeTime: calculateTrackBaseMediaDecodeTime,
        collectDtsInfo: collectDtsInfo
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Reads in-band caption information from a video elementary
   * stream. Captions must follow the CEA-708 standard for injection
   * into an MPEG-2 transport streams.
   * @see https://en.wikipedia.org/wiki/CEA-708
   * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
   */ // payload type field to indicate how they are to be
    // interpreted. CEAS-708 caption content is always transmitted with
    // payload type 0x04.
    var USER_DATA_REGISTERED_ITU_T_T35 = 4, RBSP_TRAILING_BITS = 128;
    /**
    * Parse a supplemental enhancement information (SEI) NAL unit.
    * Stops parsing once a message of type ITU T T35 has been found.
    *
    * @param bytes {Uint8Array} the bytes of a SEI NAL unit
    * @return {object} the parsed SEI payload
    * @see Rec. ITU-T H.264, 7.3.2.3.1
    */ var parseSei = function(bytes) {
        var i = 0, result = {
            payloadType: -1,
            payloadSize: 0
        }, payloadType = 0, payloadSize = 0; // go through the sei_rbsp parsing each each individual sei_message
        while(i < bytes.byteLength){
            // stop once we have hit the end of the sei_rbsp
            if (bytes[i] === RBSP_TRAILING_BITS) break;
             // Parse payload type
            while(bytes[i] === 0xFF){
                payloadType += 255;
                i++;
            }
            payloadType += bytes[i++]; // Parse payload size
            while(bytes[i] === 0xFF){
                payloadSize += 255;
                i++;
            }
            payloadSize += bytes[i++]; // this sei_message is a 608/708 caption so save it and break
            // there can only ever be one caption message in a frame's sei
            if (!result.payload && payloadType === USER_DATA_REGISTERED_ITU_T_T35) {
                var userIdentifier = String.fromCharCode(bytes[i + 3], bytes[i + 4], bytes[i + 5], bytes[i + 6]);
                if (userIdentifier === 'GA94') {
                    result.payloadType = payloadType;
                    result.payloadSize = payloadSize;
                    result.payload = bytes.subarray(i, i + payloadSize);
                    break;
                } else result.payload = void 0;
            } // skip the payload and parse the next message
            i += payloadSize;
            payloadType = 0;
            payloadSize = 0;
        }
        return result;
    }; // see ANSI/SCTE 128-1 (2013), section 8.1
    var parseUserData = function(sei) {
        // itu_t_t35_contry_code must be 181 (United States) for
        // captions
        if (sei.payload[0] !== 181) return null;
         // itu_t_t35_provider_code should be 49 (ATSC) for captions
        if ((sei.payload[1] << 8 | sei.payload[2]) !== 49) return null;
         // the user_identifier should be "GA94" to indicate ATSC1 data
        if (String.fromCharCode(sei.payload[3], sei.payload[4], sei.payload[5], sei.payload[6]) !== 'GA94') return null;
         // finally, user_data_type_code should be 0x03 for caption data
        if (sei.payload[7] !== 0x03) return null;
         // return the user_data_type_structure and strip the trailing
        // marker bits
        return sei.payload.subarray(8, sei.payload.length - 1);
    }; // see CEA-708-D, section 4.4
    var parseCaptionPackets = function(pts, userData) {
        var results = [], i, count, offset, data; // if this is just filler, return immediately
        if (!(userData[0] & 0x40)) return results;
         // parse out the cc_data_1 and cc_data_2 fields
        count = userData[0] & 0x1f;
        for(i = 0; i < count; i++){
            offset = i * 3;
            data = {
                type: userData[offset + 2] & 0x03,
                pts: pts
            }; // capture cc data when cc_valid is 1
            if (userData[offset + 2] & 0x04) {
                data.ccData = userData[offset + 3] << 8 | userData[offset + 4];
                results.push(data);
            }
        }
        return results;
    };
    var discardEmulationPreventionBytes$1 = function(data) {
        var length = data.byteLength, emulationPreventionBytesPositions = [], i = 1, newLength, newData; // Find all `Emulation Prevention Bytes`
        while(i < length - 2)if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
            emulationPreventionBytesPositions.push(i + 2);
            i += 2;
        } else i++;
         // If no Emulation Prevention Bytes were found just return the original
        // array
        if (emulationPreventionBytesPositions.length === 0) return data;
         // Create a new array to hold the NAL unit data
        newLength = length - emulationPreventionBytesPositions.length;
        newData = new Uint8Array(newLength);
        var sourceIndex = 0;
        for(i = 0; i < newLength; sourceIndex++, i++){
            if (sourceIndex === emulationPreventionBytesPositions[0]) {
                // Skip this byte
                sourceIndex++; // Remove this position index
                emulationPreventionBytesPositions.shift();
            }
            newData[i] = data[sourceIndex];
        }
        return newData;
    }; // exports
    var captionPacketParser = {
        parseSei: parseSei,
        parseUserData: parseUserData,
        parseCaptionPackets: parseCaptionPackets,
        discardEmulationPreventionBytes: discardEmulationPreventionBytes$1,
        USER_DATA_REGISTERED_ITU_T_T35: USER_DATA_REGISTERED_ITU_T_T35
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Reads in-band caption information from a video elementary
   * stream. Captions must follow the CEA-708 standard for injection
   * into an MPEG-2 transport streams.
   * @see https://en.wikipedia.org/wiki/CEA-708
   * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
   */ // Link To Transport
    // -----------------
    var Stream$7 = stream;
    var cea708Parser = captionPacketParser;
    var CaptionStream$2 = function(options) {
        options = options || {};
        CaptionStream$2.prototype.init.call(this); // parse708captions flag, default to true
        this.parse708captions_ = typeof options.parse708captions === 'boolean' ? options.parse708captions : true;
        this.captionPackets_ = [];
        this.ccStreams_ = [
            new Cea608Stream(0, 0),
            // eslint-disable-line no-use-before-define
            new Cea608Stream(0, 1),
            // eslint-disable-line no-use-before-define
            new Cea608Stream(1, 0),
            // eslint-disable-line no-use-before-define
            new Cea608Stream(1, 1) // eslint-disable-line no-use-before-define
        ];
        if (this.parse708captions_) this.cc708Stream_ = new Cea708Stream({
            captionServices: options.captionServices
        }); // eslint-disable-line no-use-before-define
        this.reset(); // forward data and done events from CCs to this CaptionStream
        this.ccStreams_.forEach(function(cc) {
            cc.on('data', this.trigger.bind(this, 'data'));
            cc.on('partialdone', this.trigger.bind(this, 'partialdone'));
            cc.on('done', this.trigger.bind(this, 'done'));
        }, this);
        if (this.parse708captions_) {
            this.cc708Stream_.on('data', this.trigger.bind(this, 'data'));
            this.cc708Stream_.on('partialdone', this.trigger.bind(this, 'partialdone'));
            this.cc708Stream_.on('done', this.trigger.bind(this, 'done'));
        }
    };
    CaptionStream$2.prototype = new Stream$7();
    CaptionStream$2.prototype.push = function(event) {
        var sei, userData, newCaptionPackets; // only examine SEI NALs
        if (event.nalUnitType !== 'sei_rbsp') return;
         // parse the sei
        sei = cea708Parser.parseSei(event.escapedRBSP); // no payload data, skip
        if (!sei.payload) return;
         // ignore everything but user_data_registered_itu_t_t35
        if (sei.payloadType !== cea708Parser.USER_DATA_REGISTERED_ITU_T_T35) return;
         // parse out the user data payload
        userData = cea708Parser.parseUserData(sei); // ignore unrecognized userData
        if (!userData) return;
         // Sometimes, the same segment # will be downloaded twice. To stop the
        // caption data from being processed twice, we track the latest dts we've
        // received and ignore everything with a dts before that. However, since
        // data for a specific dts can be split across packets on either side of
        // a segment boundary, we need to make sure we *don't* ignore the packets
        // from the *next* segment that have dts === this.latestDts_. By constantly
        // tracking the number of packets received with dts === this.latestDts_, we
        // know how many should be ignored once we start receiving duplicates.
        if (event.dts < this.latestDts_) {
            // We've started getting older data, so set the flag.
            this.ignoreNextEqualDts_ = true;
            return;
        } else if (event.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
            this.numSameDts_--;
            if (!this.numSameDts_) // We've received the last duplicate packet, time to start processing again
            this.ignoreNextEqualDts_ = false;
            return;
        } // parse out CC data packets and save them for later
        newCaptionPackets = cea708Parser.parseCaptionPackets(event.pts, userData);
        this.captionPackets_ = this.captionPackets_.concat(newCaptionPackets);
        if (this.latestDts_ !== event.dts) this.numSameDts_ = 0;
        this.numSameDts_++;
        this.latestDts_ = event.dts;
    };
    CaptionStream$2.prototype.flushCCStreams = function(flushType) {
        this.ccStreams_.forEach(function(cc) {
            return flushType === 'flush' ? cc.flush() : cc.partialFlush();
        }, this);
    };
    CaptionStream$2.prototype.flushStream = function(flushType) {
        // make sure we actually parsed captions before proceeding
        if (!this.captionPackets_.length) {
            this.flushCCStreams(flushType);
            return;
        } // In Chrome, the Array#sort function is not stable so add a
        // presortIndex that we can use to ensure we get a stable-sort
        this.captionPackets_.forEach(function(elem, idx) {
            elem.presortIndex = idx;
        }); // sort caption byte-pairs based on their PTS values
        this.captionPackets_.sort(function(a, b) {
            if (a.pts === b.pts) return a.presortIndex - b.presortIndex;
            return a.pts - b.pts;
        });
        this.captionPackets_.forEach(function(packet) {
            if (packet.type < 2) // Dispatch packet to the right Cea608Stream
            this.dispatchCea608Packet(packet);
            else // Dispatch packet to the Cea708Stream
            this.dispatchCea708Packet(packet);
        }, this);
        this.captionPackets_.length = 0;
        this.flushCCStreams(flushType);
    };
    CaptionStream$2.prototype.flush = function() {
        return this.flushStream('flush');
    }; // Only called if handling partial data
    CaptionStream$2.prototype.partialFlush = function() {
        return this.flushStream('partialFlush');
    };
    CaptionStream$2.prototype.reset = function() {
        this.latestDts_ = null;
        this.ignoreNextEqualDts_ = false;
        this.numSameDts_ = 0;
        this.activeCea608Channel_ = [
            null,
            null
        ];
        this.ccStreams_.forEach(function(ccStream) {
            ccStream.reset();
        });
    }; // From the CEA-608 spec:
    /*
   * When XDS sub-packets are interleaved with other services, the end of each sub-packet shall be followed
   * by a control pair to change to a different service. When any of the control codes from 0x10 to 0x1F is
   * used to begin a control code pair, it indicates the return to captioning or Text data. The control code pair
   * and subsequent data should then be processed according to the FCC rules. It may be necessary for the
   * line 21 data encoder to automatically insert a control code pair (i.e. RCL, RU2, RU3, RU4, RDC, or RTD)
   * to switch to captioning or Text.
  */ // With that in mind, we ignore any data between an XDS control code and a
    // subsequent closed-captioning control code.
    CaptionStream$2.prototype.dispatchCea608Packet = function(packet) {
        // NOTE: packet.type is the CEA608 field
        if (this.setsTextOrXDSActive(packet)) this.activeCea608Channel_[packet.type] = null;
        else if (this.setsChannel1Active(packet)) this.activeCea608Channel_[packet.type] = 0;
        else if (this.setsChannel2Active(packet)) this.activeCea608Channel_[packet.type] = 1;
        if (this.activeCea608Channel_[packet.type] === null) // If we haven't received anything to set the active channel, or the
        // packets are Text/XDS data, discard the data; we don't want jumbled
        // captions
        return;
        this.ccStreams_[(packet.type << 1) + this.activeCea608Channel_[packet.type]].push(packet);
    };
    CaptionStream$2.prototype.setsChannel1Active = function(packet) {
        return (packet.ccData & 0x7800) === 0x1000;
    };
    CaptionStream$2.prototype.setsChannel2Active = function(packet) {
        return (packet.ccData & 0x7800) === 0x1800;
    };
    CaptionStream$2.prototype.setsTextOrXDSActive = function(packet) {
        return (packet.ccData & 0x7100) === 0x0100 || (packet.ccData & 0x78fe) === 0x102a || (packet.ccData & 0x78fe) === 0x182a;
    };
    CaptionStream$2.prototype.dispatchCea708Packet = function(packet) {
        if (this.parse708captions_) this.cc708Stream_.push(packet);
    }; // ----------------------
    // Session to Application
    // ----------------------
    // This hash maps special and extended character codes to their
    // proper Unicode equivalent. The first one-byte key is just a
    // non-standard character code. The two-byte keys that follow are
    // the extended CEA708 character codes, along with the preceding
    // 0x10 extended character byte to distinguish these codes from
    // non-extended character codes. Every CEA708 character code that
    // is not in this object maps directly to a standard unicode
    // character code.
    // The transparent space and non-breaking transparent space are
    // technically not fully supported since there is no code to
    // make them transparent, so they have normal non-transparent
    // stand-ins.
    // The special closed caption (CC) character isn't a standard
    // unicode character, so a fairly similar unicode character was
    // chosen in it's place.
    var CHARACTER_TRANSLATION_708 = {
        0x7f: 0x266a,
        // ♪
        0x1020: 0x20,
        // Transparent Space
        0x1021: 0xa0,
        // Nob-breaking Transparent Space
        0x1025: 0x2026,
        // …
        0x102a: 0x0160,
        // Š
        0x102c: 0x0152,
        // Œ
        0x1030: 0x2588,
        // █
        0x1031: 0x2018,
        // ‘
        0x1032: 0x2019,
        // ’
        0x1033: 0x201c,
        // “
        0x1034: 0x201d,
        // ”
        0x1035: 0x2022,
        // •
        0x1039: 0x2122,
        // ™
        0x103a: 0x0161,
        // š
        0x103c: 0x0153,
        // œ
        0x103d: 0x2120,
        // ℠
        0x103f: 0x0178,
        // Ÿ
        0x1076: 0x215b,
        // ⅛
        0x1077: 0x215c,
        // ⅜
        0x1078: 0x215d,
        // ⅝
        0x1079: 0x215e,
        // ⅞
        0x107a: 0x23d0,
        // ⏐
        0x107b: 0x23a4,
        // ⎤
        0x107c: 0x23a3,
        // ⎣
        0x107d: 0x23af,
        // ⎯
        0x107e: 0x23a6,
        // ⎦
        0x107f: 0x23a1,
        // ⎡
        0x10a0: 0x3138 // ㄸ (CC char)
    };
    var get708CharFromCode = function(code) {
        var newCode = CHARACTER_TRANSLATION_708[code] || code;
        if (code & 0x1000 && code === newCode) // Invalid extended code
        return '';
        return String.fromCharCode(newCode);
    };
    var within708TextBlock = function(b) {
        return 0x20 <= b && b <= 0x7f || 0xa0 <= b && b <= 0xff;
    };
    var Cea708Window = function(windowNum) {
        this.windowNum = windowNum;
        this.reset();
    };
    Cea708Window.prototype.reset = function() {
        this.clearText();
        this.pendingNewLine = false;
        this.winAttr = {};
        this.penAttr = {};
        this.penLoc = {};
        this.penColor = {}; // These default values are arbitrary,
        // defineWindow will usually override them
        this.visible = 0;
        this.rowLock = 0;
        this.columnLock = 0;
        this.priority = 0;
        this.relativePositioning = 0;
        this.anchorVertical = 0;
        this.anchorHorizontal = 0;
        this.anchorPoint = 0;
        this.rowCount = 1;
        this.virtualRowCount = this.rowCount + 1;
        this.columnCount = 41;
        this.windowStyle = 0;
        this.penStyle = 0;
    };
    Cea708Window.prototype.getText = function() {
        return this.rows.join('\n');
    };
    Cea708Window.prototype.clearText = function() {
        this.rows = [
            ''
        ];
        this.rowIdx = 0;
    };
    Cea708Window.prototype.newLine = function(pts) {
        if (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow === 'function') this.beforeRowOverflow(pts);
        if (this.rows.length > 0) {
            this.rows.push('');
            this.rowIdx++;
        } // Show all virtual rows since there's no visible scrolling
        while(this.rows.length > this.virtualRowCount){
            this.rows.shift();
            this.rowIdx--;
        }
    };
    Cea708Window.prototype.isEmpty = function() {
        if (this.rows.length === 0) return true;
        else if (this.rows.length === 1) return this.rows[0] === '';
        return false;
    };
    Cea708Window.prototype.addText = function(text) {
        this.rows[this.rowIdx] += text;
    };
    Cea708Window.prototype.backspace = function() {
        if (!this.isEmpty()) {
            var row = this.rows[this.rowIdx];
            this.rows[this.rowIdx] = row.substr(0, row.length - 1);
        }
    };
    var Cea708Service = function(serviceNum, encoding, stream) {
        this.serviceNum = serviceNum;
        this.text = '';
        this.currentWindow = new Cea708Window(-1);
        this.windows = [];
        this.stream = stream; // Try to setup a TextDecoder if an `encoding` value was provided
        if (typeof encoding === 'string') this.createTextDecoder(encoding);
    };
    /**
   * Initialize service windows
   * Must be run before service use
   *
   * @param  {Integer}  pts               PTS value
   * @param  {Function} beforeRowOverflow Function to execute before row overflow of a window
   */ Cea708Service.prototype.init = function(pts, beforeRowOverflow) {
        this.startPts = pts;
        for(var win = 0; win < 8; win++){
            this.windows[win] = new Cea708Window(win);
            if (typeof beforeRowOverflow === 'function') this.windows[win].beforeRowOverflow = beforeRowOverflow;
        }
    };
    /**
   * Set current window of service to be affected by commands
   *
   * @param  {Integer} windowNum Window number
   */ Cea708Service.prototype.setCurrentWindow = function(windowNum) {
        this.currentWindow = this.windows[windowNum];
    };
    /**
   * Try to create a TextDecoder if it is natively supported
   */ Cea708Service.prototype.createTextDecoder = function(encoding) {
        if (typeof TextDecoder === 'undefined') this.stream.trigger('log', {
            level: 'warn',
            message: 'The `encoding` option is unsupported without TextDecoder support'
        });
        else try {
            this.textDecoder_ = new TextDecoder(encoding);
        } catch (error) {
            this.stream.trigger('log', {
                level: 'warn',
                message: 'TextDecoder could not be created with ' + encoding + ' encoding. ' + error
            });
        }
    };
    var Cea708Stream = function(options) {
        options = options || {};
        Cea708Stream.prototype.init.call(this);
        var self1 = this;
        var captionServices = options.captionServices || {};
        var captionServiceEncodings = {};
        var serviceProps; // Get service encodings from captionServices option block
        Object.keys(captionServices).forEach((serviceName)=>{
            serviceProps = captionServices[serviceName];
            if (/^SERVICE/.test(serviceName)) captionServiceEncodings[serviceName] = serviceProps.encoding;
        });
        this.serviceEncodings = captionServiceEncodings;
        this.current708Packet = null;
        this.services = {};
        this.push = function(packet) {
            if (packet.type === 3) {
                // 708 packet start
                self1.new708Packet();
                self1.add708Bytes(packet);
            } else {
                if (self1.current708Packet === null) // This should only happen at the start of a file if there's no packet start.
                self1.new708Packet();
                self1.add708Bytes(packet);
            }
        };
    };
    Cea708Stream.prototype = new Stream$7();
    /**
   * Push current 708 packet, create new 708 packet.
   */ Cea708Stream.prototype.new708Packet = function() {
        if (this.current708Packet !== null) this.push708Packet();
        this.current708Packet = {
            data: [],
            ptsVals: []
        };
    };
    /**
   * Add pts and both bytes from packet into current 708 packet.
   */ Cea708Stream.prototype.add708Bytes = function(packet) {
        var data = packet.ccData;
        var byte0 = data >>> 8;
        var byte1 = data & 0xff; // I would just keep a list of packets instead of bytes, but it isn't clear in the spec
        // that service blocks will always line up with byte pairs.
        this.current708Packet.ptsVals.push(packet.pts);
        this.current708Packet.data.push(byte0);
        this.current708Packet.data.push(byte1);
    };
    /**
   * Parse completed 708 packet into service blocks and push each service block.
   */ Cea708Stream.prototype.push708Packet = function() {
        var packet708 = this.current708Packet;
        var packetData = packet708.data;
        var serviceNum = null;
        var blockSize = null;
        var i = 0;
        var b = packetData[i++];
        packet708.seq = b >> 6;
        packet708.sizeCode = b & 0x3f; // 0b00111111;
        for(; i < packetData.length; i++){
            b = packetData[i++];
            serviceNum = b >> 5;
            blockSize = b & 0x1f; // 0b00011111
            if (serviceNum === 7 && blockSize > 0) {
                // Extended service num
                b = packetData[i++];
                serviceNum = b;
            }
            this.pushServiceBlock(serviceNum, i, blockSize);
            if (blockSize > 0) i += blockSize - 1;
        }
    };
    /**
   * Parse service block, execute commands, read text.
   *
   * Note: While many of these commands serve important purposes,
   * many others just parse out the parameters or attributes, but
   * nothing is done with them because this is not a full and complete
   * implementation of the entire 708 spec.
   *
   * @param  {Integer} serviceNum Service number
   * @param  {Integer} start      Start index of the 708 packet data
   * @param  {Integer} size       Block size
   */ Cea708Stream.prototype.pushServiceBlock = function(serviceNum, start, size) {
        var b;
        var i = start;
        var packetData = this.current708Packet.data;
        var service = this.services[serviceNum];
        if (!service) service = this.initService(serviceNum, i);
        for(; i < start + size && i < packetData.length; i++){
            b = packetData[i];
            if (within708TextBlock(b)) i = this.handleText(i, service);
            else if (b === 0x18) i = this.multiByteCharacter(i, service);
            else if (b === 0x10) i = this.extendedCommands(i, service);
            else if (0x80 <= b && b <= 0x87) i = this.setCurrentWindow(i, service);
            else if (0x98 <= b && b <= 0x9f) i = this.defineWindow(i, service);
            else if (b === 0x88) i = this.clearWindows(i, service);
            else if (b === 0x8c) i = this.deleteWindows(i, service);
            else if (b === 0x89) i = this.displayWindows(i, service);
            else if (b === 0x8a) i = this.hideWindows(i, service);
            else if (b === 0x8b) i = this.toggleWindows(i, service);
            else if (b === 0x97) i = this.setWindowAttributes(i, service);
            else if (b === 0x90) i = this.setPenAttributes(i, service);
            else if (b === 0x91) i = this.setPenColor(i, service);
            else if (b === 0x92) i = this.setPenLocation(i, service);
            else if (b === 0x8f) service = this.reset(i, service);
            else if (b === 0x08) // BS: Backspace
            service.currentWindow.backspace();
            else if (b === 0x0c) // FF: Form feed
            service.currentWindow.clearText();
            else if (b === 0x0d) // CR: Carriage return
            service.currentWindow.pendingNewLine = true;
            else if (b === 0x0e) // HCR: Horizontal carriage return
            service.currentWindow.clearText();
            else if (b === 0x8d) // DLY: Delay, nothing to do
            i++;
        }
    };
    /**
   * Execute an extended command
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.extendedCommands = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        if (within708TextBlock(b)) i = this.handleText(i, service, {
            isExtended: true
        });
        return i;
    };
    /**
   * Get PTS value of a given byte index
   *
   * @param  {Integer} byteIndex  Index of the byte
   * @return {Integer}            PTS
   */ Cea708Stream.prototype.getPts = function(byteIndex) {
        // There's 1 pts value per 2 bytes
        return this.current708Packet.ptsVals[Math.floor(byteIndex / 2)];
    };
    /**
   * Initializes a service
   *
   * @param  {Integer} serviceNum Service number
   * @return {Service}            Initialized service object
   */ Cea708Stream.prototype.initService = function(serviceNum, i) {
        var serviceName = 'SERVICE' + serviceNum;
        var self1 = this;
        var serviceName;
        var encoding;
        if (serviceName in this.serviceEncodings) encoding = this.serviceEncodings[serviceName];
        this.services[serviceNum] = new Cea708Service(serviceNum, encoding, self1);
        this.services[serviceNum].init(this.getPts(i), function(pts) {
            self1.flushDisplayed(pts, self1.services[serviceNum]);
        });
        return this.services[serviceNum];
    };
    /**
   * Execute text writing to current window
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.handleText = function(i, service, options) {
        var isExtended = options && options.isExtended;
        var isMultiByte = options && options.isMultiByte;
        var packetData = this.current708Packet.data;
        var extended = isExtended ? 0x1000 : 0x0000;
        var currentByte = packetData[i];
        var nextByte = packetData[i + 1];
        var win = service.currentWindow;
        var char;
        var charCodeArray; // Converts an array of bytes to a unicode hex string.
        function toHexString(byteArray) {
            return byteArray.map((byte)=>{
                return ('0' + (byte & 0xFF).toString(16)).slice(-2);
            }).join('');
        }
        if (isMultiByte) {
            charCodeArray = [
                currentByte,
                nextByte
            ];
            i++;
        } else charCodeArray = [
            currentByte
        ];
         // Use the TextDecoder if one was created for this service
        if (service.textDecoder_ && !isExtended) char = service.textDecoder_.decode(new Uint8Array(charCodeArray));
        else // We assume any multi-byte char without a decoder is unicode.
        if (isMultiByte) {
            const unicode = toHexString(charCodeArray); // Takes a unicode hex string and creates a single character.
            char = String.fromCharCode(parseInt(unicode, 16));
        } else char = get708CharFromCode(extended | currentByte);
        if (win.pendingNewLine && !win.isEmpty()) win.newLine(this.getPts(i));
        win.pendingNewLine = false;
        win.addText(char);
        return i;
    };
    /**
   * Handle decoding of multibyte character
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.multiByteCharacter = function(i, service) {
        var packetData = this.current708Packet.data;
        var firstByte = packetData[i + 1];
        var secondByte = packetData[i + 2];
        if (within708TextBlock(firstByte) && within708TextBlock(secondByte)) i = this.handleText(++i, service, {
            isMultiByte: true
        });
        return i;
    };
    /**
   * Parse and execute the CW# command.
   *
   * Set the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setCurrentWindow = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var windowNum = b & 0x07;
        service.setCurrentWindow(windowNum);
        return i;
    };
    /**
   * Parse and execute the DF# command.
   *
   * Define a window and set it as the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.defineWindow = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var windowNum = b & 0x07;
        service.setCurrentWindow(windowNum);
        var win = service.currentWindow;
        b = packetData[++i];
        win.visible = (b & 0x20) >> 5; // v
        win.rowLock = (b & 0x10) >> 4; // rl
        win.columnLock = (b & 0x08) >> 3; // cl
        win.priority = b & 0x07; // p
        b = packetData[++i];
        win.relativePositioning = (b & 0x80) >> 7; // rp
        win.anchorVertical = b & 0x7f; // av
        b = packetData[++i];
        win.anchorHorizontal = b; // ah
        b = packetData[++i];
        win.anchorPoint = (b & 0xf0) >> 4; // ap
        win.rowCount = b & 0x0f; // rc
        b = packetData[++i];
        win.columnCount = b & 0x3f; // cc
        b = packetData[++i];
        win.windowStyle = (b & 0x38) >> 3; // ws
        win.penStyle = b & 0x07; // ps
        // The spec says there are (rowCount+1) "virtual rows"
        win.virtualRowCount = win.rowCount + 1;
        return i;
    };
    /**
   * Parse and execute the SWA command.
   *
   * Set attributes of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setWindowAttributes = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var winAttr = service.currentWindow.winAttr;
        b = packetData[++i];
        winAttr.fillOpacity = (b & 0xc0) >> 6; // fo
        winAttr.fillRed = (b & 0x30) >> 4; // fr
        winAttr.fillGreen = (b & 0x0c) >> 2; // fg
        winAttr.fillBlue = b & 0x03; // fb
        b = packetData[++i];
        winAttr.borderType = (b & 0xc0) >> 6; // bt
        winAttr.borderRed = (b & 0x30) >> 4; // br
        winAttr.borderGreen = (b & 0x0c) >> 2; // bg
        winAttr.borderBlue = b & 0x03; // bb
        b = packetData[++i];
        winAttr.borderType += (b & 0x80) >> 5; // bt
        winAttr.wordWrap = (b & 0x40) >> 6; // ww
        winAttr.printDirection = (b & 0x30) >> 4; // pd
        winAttr.scrollDirection = (b & 0x0c) >> 2; // sd
        winAttr.justify = b & 0x03; // j
        b = packetData[++i];
        winAttr.effectSpeed = (b & 0xf0) >> 4; // es
        winAttr.effectDirection = (b & 0x0c) >> 2; // ed
        winAttr.displayEffect = b & 0x03; // de
        return i;
    };
    /**
   * Gather text from all displayed windows and push a caption to output.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   */ Cea708Stream.prototype.flushDisplayed = function(pts, service) {
        var displayedText = []; // TODO: Positioning not supported, displaying multiple windows will not necessarily
        // display text in the correct order, but sample files so far have not shown any issue.
        for(var winId = 0; winId < 8; winId++)if (service.windows[winId].visible && !service.windows[winId].isEmpty()) displayedText.push(service.windows[winId].getText());
        service.endPts = pts;
        service.text = displayedText.join('\n\n');
        this.pushCaption(service);
        service.startPts = pts;
    };
    /**
   * Push a caption to output if the caption contains text.
   *
   * @param  {Service} service  The service object to be affected
   */ Cea708Stream.prototype.pushCaption = function(service) {
        if (service.text !== '') {
            this.trigger('data', {
                startPts: service.startPts,
                endPts: service.endPts,
                text: service.text,
                stream: 'cc708_' + service.serviceNum
            });
            service.text = '';
            service.startPts = service.endPts;
        }
    };
    /**
   * Parse and execute the DSW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.displayWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].visible = 1;
        return i;
    };
    /**
   * Parse and execute the HDW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.hideWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].visible = 0;
        return i;
    };
    /**
   * Parse and execute the TGW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.toggleWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].visible ^= 1;
        return i;
    };
    /**
   * Parse and execute the CLW command.
   *
   * Clear text of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.clearWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].clearText();
        return i;
    };
    /**
   * Parse and execute the DLW command.
   *
   * Re-initialize windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.deleteWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].reset();
        return i;
    };
    /**
   * Parse and execute the SPA command.
   *
   * Set pen attributes of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setPenAttributes = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var penAttr = service.currentWindow.penAttr;
        b = packetData[++i];
        penAttr.textTag = (b & 0xf0) >> 4; // tt
        penAttr.offset = (b & 0x0c) >> 2; // o
        penAttr.penSize = b & 0x03; // s
        b = packetData[++i];
        penAttr.italics = (b & 0x80) >> 7; // i
        penAttr.underline = (b & 0x40) >> 6; // u
        penAttr.edgeType = (b & 0x38) >> 3; // et
        penAttr.fontStyle = b & 0x07; // fs
        return i;
    };
    /**
   * Parse and execute the SPC command.
   *
   * Set pen color of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setPenColor = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var penColor = service.currentWindow.penColor;
        b = packetData[++i];
        penColor.fgOpacity = (b & 0xc0) >> 6; // fo
        penColor.fgRed = (b & 0x30) >> 4; // fr
        penColor.fgGreen = (b & 0x0c) >> 2; // fg
        penColor.fgBlue = b & 0x03; // fb
        b = packetData[++i];
        penColor.bgOpacity = (b & 0xc0) >> 6; // bo
        penColor.bgRed = (b & 0x30) >> 4; // br
        penColor.bgGreen = (b & 0x0c) >> 2; // bg
        penColor.bgBlue = b & 0x03; // bb
        b = packetData[++i];
        penColor.edgeRed = (b & 0x30) >> 4; // er
        penColor.edgeGreen = (b & 0x0c) >> 2; // eg
        penColor.edgeBlue = b & 0x03; // eb
        return i;
    };
    /**
   * Parse and execute the SPL command.
   *
   * Set pen location of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setPenLocation = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var penLoc = service.currentWindow.penLoc; // Positioning isn't really supported at the moment, so this essentially just inserts a linebreak
        service.currentWindow.pendingNewLine = true;
        b = packetData[++i];
        penLoc.row = b & 0x0f; // r
        b = packetData[++i];
        penLoc.column = b & 0x3f; // c
        return i;
    };
    /**
   * Execute the RST command.
   *
   * Reset service to a clean slate. Re-initialize.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Service}          Re-initialized service
   */ Cea708Stream.prototype.reset = function(i, service) {
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        return this.initService(service.serviceNum, i);
    }; // This hash maps non-ASCII, special, and extended character codes to their
    // proper Unicode equivalent. The first keys that are only a single byte
    // are the non-standard ASCII characters, which simply map the CEA608 byte
    // to the standard ASCII/Unicode. The two-byte keys that follow are the CEA608
    // character codes, but have their MSB bitmasked with 0x03 so that a lookup
    // can be performed regardless of the field and data channel on which the
    // character code was received.
    var CHARACTER_TRANSLATION = {
        0x2a: 0xe1,
        // á
        0x5c: 0xe9,
        // é
        0x5e: 0xed,
        // í
        0x5f: 0xf3,
        // ó
        0x60: 0xfa,
        // ú
        0x7b: 0xe7,
        // ç
        0x7c: 0xf7,
        // ÷
        0x7d: 0xd1,
        // Ñ
        0x7e: 0xf1,
        // ñ
        0x7f: 0x2588,
        // █
        0x0130: 0xae,
        // ®
        0x0131: 0xb0,
        // °
        0x0132: 0xbd,
        // ½
        0x0133: 0xbf,
        // ¿
        0x0134: 0x2122,
        // ™
        0x0135: 0xa2,
        // ¢
        0x0136: 0xa3,
        // £
        0x0137: 0x266a,
        // ♪
        0x0138: 0xe0,
        // à
        0x0139: 0xa0,
        //
        0x013a: 0xe8,
        // è
        0x013b: 0xe2,
        // â
        0x013c: 0xea,
        // ê
        0x013d: 0xee,
        // î
        0x013e: 0xf4,
        // ô
        0x013f: 0xfb,
        // û
        0x0220: 0xc1,
        // Á
        0x0221: 0xc9,
        // É
        0x0222: 0xd3,
        // Ó
        0x0223: 0xda,
        // Ú
        0x0224: 0xdc,
        // Ü
        0x0225: 0xfc,
        // ü
        0x0226: 0x2018,
        // ‘
        0x0227: 0xa1,
        // ¡
        0x0228: 0x2a,
        // *
        0x0229: 0x27,
        // '
        0x022a: 0x2014,
        // —
        0x022b: 0xa9,
        // ©
        0x022c: 0x2120,
        // ℠
        0x022d: 0x2022,
        // •
        0x022e: 0x201c,
        // “
        0x022f: 0x201d,
        // ”
        0x0230: 0xc0,
        // À
        0x0231: 0xc2,
        // Â
        0x0232: 0xc7,
        // Ç
        0x0233: 0xc8,
        // È
        0x0234: 0xca,
        // Ê
        0x0235: 0xcb,
        // Ë
        0x0236: 0xeb,
        // ë
        0x0237: 0xce,
        // Î
        0x0238: 0xcf,
        // Ï
        0x0239: 0xef,
        // ï
        0x023a: 0xd4,
        // Ô
        0x023b: 0xd9,
        // Ù
        0x023c: 0xf9,
        // ù
        0x023d: 0xdb,
        // Û
        0x023e: 0xab,
        // «
        0x023f: 0xbb,
        // »
        0x0320: 0xc3,
        // Ã
        0x0321: 0xe3,
        // ã
        0x0322: 0xcd,
        // Í
        0x0323: 0xcc,
        // Ì
        0x0324: 0xec,
        // ì
        0x0325: 0xd2,
        // Ò
        0x0326: 0xf2,
        // ò
        0x0327: 0xd5,
        // Õ
        0x0328: 0xf5,
        // õ
        0x0329: 0x7b,
        // {
        0x032a: 0x7d,
        // }
        0x032b: 0x5c,
        // \
        0x032c: 0x5e,
        // ^
        0x032d: 0x5f,
        // _
        0x032e: 0x7c,
        // |
        0x032f: 0x7e,
        // ~
        0x0330: 0xc4,
        // Ä
        0x0331: 0xe4,
        // ä
        0x0332: 0xd6,
        // Ö
        0x0333: 0xf6,
        // ö
        0x0334: 0xdf,
        // ß
        0x0335: 0xa5,
        // ¥
        0x0336: 0xa4,
        // ¤
        0x0337: 0x2502,
        // │
        0x0338: 0xc5,
        // Å
        0x0339: 0xe5,
        // å
        0x033a: 0xd8,
        // Ø
        0x033b: 0xf8,
        // ø
        0x033c: 0x250c,
        // ┌
        0x033d: 0x2510,
        // ┐
        0x033e: 0x2514,
        // └
        0x033f: 0x2518 // ┘
    };
    var getCharFromCode = function(code) {
        if (code === null) return '';
        code = CHARACTER_TRANSLATION[code] || code;
        return String.fromCharCode(code);
    }; // the index of the last row in a CEA-608 display buffer
    var BOTTOM_ROW = 14; // This array is used for mapping PACs -> row #, since there's no way of
    // getting it through bit logic.
    var ROWS = [
        0x1100,
        0x1120,
        0x1200,
        0x1220,
        0x1500,
        0x1520,
        0x1600,
        0x1620,
        0x1700,
        0x1720,
        0x1000,
        0x1300,
        0x1320,
        0x1400,
        0x1420
    ]; // CEA-608 captions are rendered onto a 34x15 matrix of character
    // cells. The "bottom" row is the last element in the outer array.
    // We keep track of positioning information as we go by storing the
    // number of indentations and the tab offset in this buffer.
    var createDisplayBuffer = function() {
        var result = [], i = BOTTOM_ROW + 1;
        while(i--)result.push({
            text: '',
            indent: 0,
            offset: 0
        });
        return result;
    };
    var Cea608Stream = function(field, dataChannel) {
        Cea608Stream.prototype.init.call(this);
        this.field_ = field || 0;
        this.dataChannel_ = dataChannel || 0;
        this.name_ = 'CC' + ((this.field_ << 1 | this.dataChannel_) + 1);
        this.setConstants();
        this.reset();
        this.push = function(packet) {
            var data, swap, char0, char1, text; // remove the parity bits
            data = packet.ccData & 0x7f7f; // ignore duplicate control codes; the spec demands they're sent twice
            if (data === this.lastControlCode_) {
                this.lastControlCode_ = null;
                return;
            } // Store control codes
            if ((data & 0xf000) === 0x1000) this.lastControlCode_ = data;
            else if (data !== this.PADDING_) this.lastControlCode_ = null;
            char0 = data >>> 8;
            char1 = data & 0xff;
            if (data === this.PADDING_) return;
            else if (data === this.RESUME_CAPTION_LOADING_) this.mode_ = 'popOn';
            else if (data === this.END_OF_CAPTION_) {
                // If an EOC is received while in paint-on mode, the displayed caption
                // text should be swapped to non-displayed memory as if it was a pop-on
                // caption. Because of that, we should explicitly switch back to pop-on
                // mode
                this.mode_ = 'popOn';
                this.clearFormatting(packet.pts); // if a caption was being displayed, it's gone now
                this.flushDisplayed(packet.pts); // flip memory
                swap = this.displayed_;
                this.displayed_ = this.nonDisplayed_;
                this.nonDisplayed_ = swap; // start measuring the time to display the caption
                this.startPts_ = packet.pts;
            } else if (data === this.ROLL_UP_2_ROWS_) {
                this.rollUpRows_ = 2;
                this.setRollUp(packet.pts);
            } else if (data === this.ROLL_UP_3_ROWS_) {
                this.rollUpRows_ = 3;
                this.setRollUp(packet.pts);
            } else if (data === this.ROLL_UP_4_ROWS_) {
                this.rollUpRows_ = 4;
                this.setRollUp(packet.pts);
            } else if (data === this.CARRIAGE_RETURN_) {
                this.clearFormatting(packet.pts);
                this.flushDisplayed(packet.pts);
                this.shiftRowsUp_();
                this.startPts_ = packet.pts;
            } else if (data === this.BACKSPACE_) {
                if (this.mode_ === 'popOn') this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1);
                else this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
            } else if (data === this.ERASE_DISPLAYED_MEMORY_) {
                this.flushDisplayed(packet.pts);
                this.displayed_ = createDisplayBuffer();
            } else if (data === this.ERASE_NON_DISPLAYED_MEMORY_) this.nonDisplayed_ = createDisplayBuffer();
            else if (data === this.RESUME_DIRECT_CAPTIONING_) {
                if (this.mode_ !== 'paintOn') {
                    // NOTE: This should be removed when proper caption positioning is
                    // implemented
                    this.flushDisplayed(packet.pts);
                    this.displayed_ = createDisplayBuffer();
                }
                this.mode_ = 'paintOn';
                this.startPts_ = packet.pts; // Append special characters to caption text
            } else if (this.isSpecialCharacter(char0, char1)) {
                // Bitmask char0 so that we can apply character transformations
                // regardless of field and data channel.
                // Then byte-shift to the left and OR with char1 so we can pass the
                // entire character code to `getCharFromCode`.
                char0 = (char0 & 0x03) << 8;
                text = getCharFromCode(char0 | char1);
                this[this.mode_](packet.pts, text);
                this.column_++; // Append extended characters to caption text
            } else if (this.isExtCharacter(char0, char1)) {
                // Extended characters always follow their "non-extended" equivalents.
                // IE if a "è" is desired, you'll always receive "eè"; non-compliant
                // decoders are supposed to drop the "è", while compliant decoders
                // backspace the "e" and insert "è".
                // Delete the previous character
                if (this.mode_ === 'popOn') this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1);
                else this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
                 // Bitmask char0 so that we can apply character transformations
                // regardless of field and data channel.
                // Then byte-shift to the left and OR with char1 so we can pass the
                // entire character code to `getCharFromCode`.
                char0 = (char0 & 0x03) << 8;
                text = getCharFromCode(char0 | char1);
                this[this.mode_](packet.pts, text);
                this.column_++; // Process mid-row codes
            } else if (this.isMidRowCode(char0, char1)) {
                // Attributes are not additive, so clear all formatting
                this.clearFormatting(packet.pts); // According to the standard, mid-row codes
                // should be replaced with spaces, so add one now
                this[this.mode_](packet.pts, ' ');
                this.column_++;
                if ((char1 & 0xe) === 0xe) this.addFormatting(packet.pts, [
                    'i'
                ]);
                if ((char1 & 0x1) === 0x1) this.addFormatting(packet.pts, [
                    'u'
                ]);
                 // Detect offset control codes and adjust cursor
            } else if (this.isOffsetControlCode(char0, char1)) {
                // Cursor position is set by indent PAC (see below) in 4-column
                // increments, with an additional offset code of 1-3 to reach any
                // of the 32 columns specified by CEA-608. So all we need to do
                // here is increment the column cursor by the given offset.
                const offset = char1 & 0x03; // For an offest value 1-3, set the offset for that caption
                // in the non-displayed array.
                this.nonDisplayed_[this.row_].offset = offset;
                this.column_ += offset; // Detect PACs (Preamble Address Codes)
            } else if (this.isPAC(char0, char1)) {
                // There's no logic for PAC -> row mapping, so we have to just
                // find the row code in an array and use its index :(
                var row = ROWS.indexOf(data & 0x1f20); // Configure the caption window if we're in roll-up mode
                if (this.mode_ === 'rollUp') {
                    // This implies that the base row is incorrectly set.
                    // As per the recommendation in CEA-608(Base Row Implementation), defer to the number
                    // of roll-up rows set.
                    if (row - this.rollUpRows_ + 1 < 0) row = this.rollUpRows_ - 1;
                    this.setRollUp(packet.pts, row);
                } // Ensure the row is between 0 and 14, otherwise use the most
                // recent or default row.
                if (row !== this.row_ && row >= 0 && row <= 14) {
                    // formatting is only persistent for current row
                    this.clearFormatting(packet.pts);
                    this.row_ = row;
                } // All PACs can apply underline, so detect and apply
                // (All odd-numbered second bytes set underline)
                if (char1 & 0x1 && this.formatting_.indexOf('u') === -1) this.addFormatting(packet.pts, [
                    'u'
                ]);
                if ((data & 0x10) === 0x10) {
                    // We've got an indent level code. Each successive even number
                    // increments the column cursor by 4, so we can get the desired
                    // column position by bit-shifting to the right (to get n/2)
                    // and multiplying by 4.
                    const indentations = (data & 0xe) >> 1;
                    this.column_ = indentations * 4; // add to the number of indentations for positioning
                    this.nonDisplayed_[this.row_].indent += indentations;
                }
                if (this.isColorPAC(char1)) // it's a color code, though we only support white, which
                // can be either normal or italicized. white italics can be
                // either 0x4e or 0x6e depending on the row, so we just
                // bitwise-and with 0xe to see if italics should be turned on
                {
                    if ((char1 & 0xe) === 0xe) this.addFormatting(packet.pts, [
                        'i'
                    ]);
                } // We have a normal character in char0, and possibly one in char1
            } else if (this.isNormalChar(char0)) {
                if (char1 === 0x00) char1 = null;
                text = getCharFromCode(char0);
                text += getCharFromCode(char1);
                this[this.mode_](packet.pts, text);
                this.column_ += text.length;
            } // finish data processing
        };
    };
    Cea608Stream.prototype = new Stream$7(); // Trigger a cue point that captures the current state of the
    // display buffer
    Cea608Stream.prototype.flushDisplayed = function(pts) {
        const logWarning = (index)=>{
            this.trigger('log', {
                level: 'warn',
                message: 'Skipping a malformed 608 caption at index ' + index + '.'
            });
        };
        const content = [];
        this.displayed_.forEach((row, i)=>{
            if (row && row.text && row.text.length) {
                try {
                    // remove spaces from the start and end of the string
                    row.text = row.text.trim();
                } catch (e) {
                    // Ordinarily, this shouldn't happen. However, caption
                    // parsing errors should not throw exceptions and
                    // break playback.
                    logWarning(i);
                } // See the below link for more details on the following fields:
                // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
                if (row.text.length) content.push({
                    // The text to be displayed in the caption from this specific row, with whitespace removed.
                    text: row.text,
                    // Value between 1 and 15 representing the PAC row used to calculate line height.
                    line: i + 1,
                    // A number representing the indent position by percentage (CEA-608 PAC indent code).
                    // The value will be a number between 10 and 80. Offset is used to add an aditional
                    // value to the position if necessary.
                    position: 10 + Math.min(70, row.indent * 10) + row.offset * 2.5
                });
            } else if (row === undefined || row === null) logWarning(i);
        });
        if (content.length) this.trigger('data', {
            startPts: this.startPts_,
            endPts: pts,
            content: content,
            stream: this.name_
        });
    };
    /**
   * Zero out the data, used for startup and on seek
   */ Cea608Stream.prototype.reset = function() {
        this.mode_ = 'popOn'; // When in roll-up mode, the index of the last row that will
        // actually display captions. If a caption is shifted to a row
        // with a lower index than this, it is cleared from the display
        // buffer
        this.topRow_ = 0;
        this.startPts_ = 0;
        this.displayed_ = createDisplayBuffer();
        this.nonDisplayed_ = createDisplayBuffer();
        this.lastControlCode_ = null; // Track row and column for proper line-breaking and spacing
        this.column_ = 0;
        this.row_ = BOTTOM_ROW;
        this.rollUpRows_ = 2; // This variable holds currently-applied formatting
        this.formatting_ = [];
    };
    /**
   * Sets up control code and related constants for this instance
   */ Cea608Stream.prototype.setConstants = function() {
        // The following attributes have these uses:
        // ext_ :    char0 for mid-row codes, and the base for extended
        //           chars (ext_+0, ext_+1, and ext_+2 are char0s for
        //           extended codes)
        // control_: char0 for control codes, except byte-shifted to the
        //           left so that we can do this.control_ | CONTROL_CODE
        // offset_:  char0 for tab offset codes
        //
        // It's also worth noting that control codes, and _only_ control codes,
        // differ between field 1 and field2. Field 2 control codes are always
        // their field 1 value plus 1. That's why there's the "| field" on the
        // control value.
        if (this.dataChannel_ === 0) {
            this.BASE_ = 0x10;
            this.EXT_ = 0x11;
            this.CONTROL_ = (0x14 | this.field_) << 8;
            this.OFFSET_ = 0x17;
        } else if (this.dataChannel_ === 1) {
            this.BASE_ = 0x18;
            this.EXT_ = 0x19;
            this.CONTROL_ = (0x1c | this.field_) << 8;
            this.OFFSET_ = 0x1f;
        } // Constants for the LSByte command codes recognized by Cea608Stream. This
        // list is not exhaustive. For a more comprehensive listing and semantics see
        // http://www.gpo.gov/fdsys/pkg/CFR-2010-title47-vol1/pdf/CFR-2010-title47-vol1-sec15-119.pdf
        // Padding
        this.PADDING_ = 0x0000; // Pop-on Mode
        this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 0x20;
        this.END_OF_CAPTION_ = this.CONTROL_ | 0x2f; // Roll-up Mode
        this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 0x25;
        this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 0x26;
        this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 0x27;
        this.CARRIAGE_RETURN_ = this.CONTROL_ | 0x2d; // paint-on mode
        this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 0x29; // Erasure
        this.BACKSPACE_ = this.CONTROL_ | 0x21;
        this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2c;
        this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2e;
    };
    /**
   * Detects if the 2-byte packet data is a special character
   *
   * Special characters have a second byte in the range 0x30 to 0x3f,
   * with the first byte being 0x11 (for data channel 1) or 0x19 (for
   * data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an special character
   */ Cea608Stream.prototype.isSpecialCharacter = function(char0, char1) {
        return char0 === this.EXT_ && char1 >= 0x30 && char1 <= 0x3f;
    };
    /**
   * Detects if the 2-byte packet data is an extended character
   *
   * Extended characters have a second byte in the range 0x20 to 0x3f,
   * with the first byte being 0x12 or 0x13 (for data channel 1) or
   * 0x1a or 0x1b (for data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an extended character
   */ Cea608Stream.prototype.isExtCharacter = function(char0, char1) {
        return (char0 === this.EXT_ + 1 || char0 === this.EXT_ + 2) && char1 >= 0x20 && char1 <= 0x3f;
    };
    /**
   * Detects if the 2-byte packet is a mid-row code
   *
   * Mid-row codes have a second byte in the range 0x20 to 0x2f, with
   * the first byte being 0x11 (for data channel 1) or 0x19 (for data
   * channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are a mid-row code
   */ Cea608Stream.prototype.isMidRowCode = function(char0, char1) {
        return char0 === this.EXT_ && char1 >= 0x20 && char1 <= 0x2f;
    };
    /**
   * Detects if the 2-byte packet is an offset control code
   *
   * Offset control codes have a second byte in the range 0x21 to 0x23,
   * with the first byte being 0x17 (for data channel 1) or 0x1f (for
   * data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an offset control code
   */ Cea608Stream.prototype.isOffsetControlCode = function(char0, char1) {
        return char0 === this.OFFSET_ && char1 >= 0x21 && char1 <= 0x23;
    };
    /**
   * Detects if the 2-byte packet is a Preamble Address Code
   *
   * PACs have a first byte in the range 0x10 to 0x17 (for data channel 1)
   * or 0x18 to 0x1f (for data channel 2), with the second byte in the
   * range 0x40 to 0x7f.
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are a PAC
   */ Cea608Stream.prototype.isPAC = function(char0, char1) {
        return char0 >= this.BASE_ && char0 < this.BASE_ + 8 && char1 >= 0x40 && char1 <= 0x7f;
    };
    /**
   * Detects if a packet's second byte is in the range of a PAC color code
   *
   * PAC color codes have the second byte be in the range 0x40 to 0x4f, or
   * 0x60 to 0x6f.
   *
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the byte is a color PAC
   */ Cea608Stream.prototype.isColorPAC = function(char1) {
        return char1 >= 0x40 && char1 <= 0x4f || char1 >= 0x60 && char1 <= 0x7f;
    };
    /**
   * Detects if a single byte is in the range of a normal character
   *
   * Normal text bytes are in the range 0x20 to 0x7f.
   *
   * @param  {Integer} char  The byte
   * @return {Boolean}       Whether the byte is a normal character
   */ Cea608Stream.prototype.isNormalChar = function(char) {
        return char >= 0x20 && char <= 0x7f;
    };
    /**
   * Configures roll-up
   *
   * @param  {Integer} pts         Current PTS
   * @param  {Integer} newBaseRow  Used by PACs to slide the current window to
   *                               a new position
   */ Cea608Stream.prototype.setRollUp = function(pts, newBaseRow) {
        // Reset the base row to the bottom row when switching modes
        if (this.mode_ !== 'rollUp') {
            this.row_ = BOTTOM_ROW;
            this.mode_ = 'rollUp'; // Spec says to wipe memories when switching to roll-up
            this.flushDisplayed(pts);
            this.nonDisplayed_ = createDisplayBuffer();
            this.displayed_ = createDisplayBuffer();
        }
        if (newBaseRow !== undefined && newBaseRow !== this.row_) // move currently displayed captions (up or down) to the new base row
        for(var i = 0; i < this.rollUpRows_; i++){
            this.displayed_[newBaseRow - i] = this.displayed_[this.row_ - i];
            this.displayed_[this.row_ - i] = {
                text: '',
                indent: 0,
                offset: 0
            };
        }
        if (newBaseRow === undefined) newBaseRow = this.row_;
        this.topRow_ = newBaseRow - this.rollUpRows_ + 1;
    }; // Adds the opening HTML tag for the passed character to the caption text,
    // and keeps track of it for later closing
    Cea608Stream.prototype.addFormatting = function(pts, format) {
        this.formatting_ = this.formatting_.concat(format);
        var text = format.reduce(function(text, format) {
            return text + '<' + format + '>';
        }, '');
        this[this.mode_](pts, text);
    }; // Adds HTML closing tags for current formatting to caption text and
    // clears remembered formatting
    Cea608Stream.prototype.clearFormatting = function(pts) {
        if (!this.formatting_.length) return;
        var text = this.formatting_.reverse().reduce(function(text, format) {
            return text + '</' + format + '>';
        }, '');
        this.formatting_ = [];
        this[this.mode_](pts, text);
    }; // Mode Implementations
    Cea608Stream.prototype.popOn = function(pts, text) {
        var baseRow = this.nonDisplayed_[this.row_].text; // buffer characters
        baseRow += text;
        this.nonDisplayed_[this.row_].text = baseRow;
    };
    Cea608Stream.prototype.rollUp = function(pts, text) {
        var baseRow = this.displayed_[this.row_].text;
        baseRow += text;
        this.displayed_[this.row_].text = baseRow;
    };
    Cea608Stream.prototype.shiftRowsUp_ = function() {
        var i; // clear out inactive rows
        for(i = 0; i < this.topRow_; i++)this.displayed_[i] = {
            text: '',
            indent: 0,
            offset: 0
        };
        for(i = this.row_ + 1; i < BOTTOM_ROW + 1; i++)this.displayed_[i] = {
            text: '',
            indent: 0,
            offset: 0
        };
         // shift displayed rows up
        for(i = this.topRow_; i < this.row_; i++)this.displayed_[i] = this.displayed_[i + 1];
         // clear out the bottom row
        this.displayed_[this.row_] = {
            text: '',
            indent: 0,
            offset: 0
        };
    };
    Cea608Stream.prototype.paintOn = function(pts, text) {
        var baseRow = this.displayed_[this.row_].text;
        baseRow += text;
        this.displayed_[this.row_].text = baseRow;
    }; // exports
    var captionStream = {
        CaptionStream: CaptionStream$2,
        Cea608Stream: Cea608Stream,
        Cea708Stream: Cea708Stream
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var streamTypes = {
        H264_STREAM_TYPE: 0x1B,
        ADTS_STREAM_TYPE: 0x0F,
        METADATA_STREAM_TYPE: 0x15
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Accepts program elementary stream (PES) data events and corrects
   * decode and presentation time stamps to account for a rollover
   * of the 33 bit value.
   */ var Stream$6 = stream;
    var MAX_TS = 8589934592;
    var RO_THRESH = 4294967296;
    var TYPE_SHARED = 'shared';
    var handleRollover$1 = function(value, reference) {
        var direction = 1;
        if (value > reference) // If the current timestamp value is greater than our reference timestamp and we detect a
        // timestamp rollover, this means the roll over is happening in the opposite direction.
        // Example scenario: Enter a long stream/video just after a rollover occurred. The reference
        // point will be set to a small number, e.g. 1. The user then seeks backwards over the
        // rollover point. In loading this segment, the timestamp values will be very large,
        // e.g. 2^33 - 1. Since this comes before the data we loaded previously, we want to adjust
        // the time stamp to be `value - 2^33`.
        direction = -1;
         // Note: A seek forwards or back that is greater than the RO_THRESH (2^32, ~13 hours) will
        // cause an incorrect adjustment.
        while(Math.abs(reference - value) > RO_THRESH)value += direction * MAX_TS;
        return value;
    };
    var TimestampRolloverStream$1 = function(type) {
        var lastDTS, referenceDTS;
        TimestampRolloverStream$1.prototype.init.call(this); // The "shared" type is used in cases where a stream will contain muxed
        // video and audio. We could use `undefined` here, but having a string
        // makes debugging a little clearer.
        this.type_ = type || TYPE_SHARED;
        this.push = function(data) {
            /**
       * Rollover stream expects data from elementary stream.
       * Elementary stream can push forward 2 types of data
       * - Parsed Video/Audio/Timed-metadata PES (packetized elementary stream) packets
       * - Tracks metadata from PMT (Program Map Table)
       * Rollover stream expects pts/dts info to be available, since it stores lastDTS
       * We should ignore non-PES packets since they may override lastDTS to undefined.
       * lastDTS is important to signal the next segments
       * about rollover from the previous segments.
       */ if (data.type === 'metadata') {
                this.trigger('data', data);
                return;
            } // Any "shared" rollover streams will accept _all_ data. Otherwise,
            // streams will only accept data that matches their type.
            if (this.type_ !== TYPE_SHARED && data.type !== this.type_) return;
            if (referenceDTS === undefined) referenceDTS = data.dts;
            data.dts = handleRollover$1(data.dts, referenceDTS);
            data.pts = handleRollover$1(data.pts, referenceDTS);
            lastDTS = data.dts;
            this.trigger('data', data);
        };
        this.flush = function() {
            referenceDTS = lastDTS;
            this.trigger('done');
        };
        this.endTimeline = function() {
            this.flush();
            this.trigger('endedtimeline');
        };
        this.discontinuity = function() {
            referenceDTS = void 0;
            lastDTS = void 0;
        };
        this.reset = function() {
            this.discontinuity();
            this.trigger('reset');
        };
    };
    TimestampRolloverStream$1.prototype = new Stream$6();
    var timestampRolloverStream = {
        TimestampRolloverStream: TimestampRolloverStream$1,
        handleRollover: handleRollover$1
    }; // Once IE11 support is dropped, this function should be removed.
    var typedArrayIndexOf$1 = (typedArray, element, fromIndex)=>{
        if (!typedArray) return -1;
        var currentIndex = fromIndex;
        for(; currentIndex < typedArray.length; currentIndex++){
            if (typedArray[currentIndex] === element) return currentIndex;
        }
        return -1;
    };
    var typedArray = {
        typedArrayIndexOf: typedArrayIndexOf$1
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Tools for parsing ID3 frame data
   * @see http://id3.org/id3v2.3.0
   */ var typedArrayIndexOf = typedArray.typedArrayIndexOf, // Frames that allow different types of text encoding contain a text
    // encoding description byte [ID3v2.4.0 section 4.]
    textEncodingDescriptionByte = {
        Iso88591: 0x00,
        // ISO-8859-1, terminated with \0.
        Utf16: 0x01,
        // UTF-16 encoded Unicode BOM, terminated with \0\0
        Utf16be: 0x02,
        // UTF-16BE encoded Unicode, without BOM, terminated with \0\0
        Utf8: 0x03 // UTF-8 encoded Unicode, terminated with \0
    }, // return a percent-encoded representation of the specified byte range
    // @see http://en.wikipedia.org/wiki/Percent-encoding 
    percentEncode$1 = function(bytes, start, end) {
        var i, result = '';
        for(i = start; i < end; i++)result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
        return result;
    }, // return the string representation of the specified byte range,
    // interpreted as UTf-8.
    parseUtf8 = function(bytes, start, end) {
        return decodeURIComponent(percentEncode$1(bytes, start, end));
    }, // return the string representation of the specified byte range,
    // interpreted as ISO-8859-1.
    parseIso88591$1 = function(bytes, start, end) {
        return unescape(percentEncode$1(bytes, start, end)); // jshint ignore:line
    }, parseSyncSafeInteger$1 = function(data) {
        return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
    }, frameParsers = {
        'APIC': function(frame) {
            var i = 1, mimeTypeEndIndex, descriptionEndIndex, LINK_MIME_TYPE = '-->';
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
             // parsing fields [ID3v2.4.0 section 4.14.]
            mimeTypeEndIndex = typedArrayIndexOf(frame.data, 0, i);
            if (mimeTypeEndIndex < 0) // malformed frame
            return;
             // parsing Mime type field (terminated with \0)
            frame.mimeType = parseIso88591$1(frame.data, i, mimeTypeEndIndex);
            i = mimeTypeEndIndex + 1; // parsing 1-byte Picture Type field
            frame.pictureType = frame.data[i];
            i++;
            descriptionEndIndex = typedArrayIndexOf(frame.data, 0, i);
            if (descriptionEndIndex < 0) // malformed frame
            return;
             // parsing Description field (terminated with \0)
            frame.description = parseUtf8(frame.data, i, descriptionEndIndex);
            i = descriptionEndIndex + 1;
            if (frame.mimeType === LINK_MIME_TYPE) // parsing Picture Data field as URL (always represented as ISO-8859-1 [ID3v2.4.0 section 4.])
            frame.url = parseIso88591$1(frame.data, i, frame.data.length);
            else // parsing Picture Data field as binary data
            frame.pictureData = frame.data.subarray(i, frame.data.length);
        },
        'T*': function(frame) {
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
             // parse text field, do not include null terminator in the frame value
            // frames that allow different types of encoding contain terminated text [ID3v2.4.0 section 4.]
            frame.value = parseUtf8(frame.data, 1, frame.data.length).replace(/\0*$/, ''); // text information frames supports multiple strings, stored as a terminator separated list [ID3v2.4.0 section 4.2.]
            frame.values = frame.value.split('\0');
        },
        'TXXX': function(frame) {
            var descriptionEndIndex;
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
            descriptionEndIndex = typedArrayIndexOf(frame.data, 0, 1);
            if (descriptionEndIndex === -1) return;
             // parse the text fields
            frame.description = parseUtf8(frame.data, 1, descriptionEndIndex); // do not include the null terminator in the tag value
            // frames that allow different types of encoding contain terminated text
            // [ID3v2.4.0 section 4.]
            frame.value = parseUtf8(frame.data, descriptionEndIndex + 1, frame.data.length).replace(/\0*$/, '');
            frame.data = frame.value;
        },
        'W*': function(frame) {
            // parse URL field; URL fields are always represented as ISO-8859-1 [ID3v2.4.0 section 4.]
            // if the value is followed by a string termination all the following information should be ignored [ID3v2.4.0 section 4.3]
            frame.url = parseIso88591$1(frame.data, 0, frame.data.length).replace(/\0.*$/, '');
        },
        'WXXX': function(frame) {
            var descriptionEndIndex;
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
            descriptionEndIndex = typedArrayIndexOf(frame.data, 0, 1);
            if (descriptionEndIndex === -1) return;
             // parse the description and URL fields
            frame.description = parseUtf8(frame.data, 1, descriptionEndIndex); // URL fields are always represented as ISO-8859-1 [ID3v2.4.0 section 4.]
            // if the value is followed by a string termination all the following information
            // should be ignored [ID3v2.4.0 section 4.3]
            frame.url = parseIso88591$1(frame.data, descriptionEndIndex + 1, frame.data.length).replace(/\0.*$/, '');
        },
        'PRIV': function(frame) {
            var i;
            for(i = 0; i < frame.data.length; i++)if (frame.data[i] === 0) {
                // parse the description and URL fields
                frame.owner = parseIso88591$1(frame.data, 0, i);
                break;
            }
            frame.privateData = frame.data.subarray(i + 1);
            frame.data = frame.privateData;
        }
    };
    var parseId3Frames$1 = function(data) {
        var frameSize, frameHeader, frameStart = 10, tagSize = 0, frames = []; // If we don't have enough data for a header, 10 bytes, 
        // or 'ID3' in the first 3 bytes this is not a valid ID3 tag.
        if (data.length < 10 || data[0] !== 'I'.charCodeAt(0) || data[1] !== 'D'.charCodeAt(0) || data[2] !== '3'.charCodeAt(0)) return;
         // the frame size is transmitted as a 28-bit integer in the
        // last four bytes of the ID3 header.
        // The most significant bit of each byte is dropped and the
        // results concatenated to recover the actual value.
        tagSize = parseSyncSafeInteger$1(data.subarray(6, 10)); // ID3 reports the tag size excluding the header but it's more
        // convenient for our comparisons to include it
        tagSize += 10; // check bit 6 of byte 5 for the extended header flag.
        var hasExtendedHeader = data[5] & 0x40;
        if (hasExtendedHeader) {
            // advance the frame start past the extended header
            frameStart += 4; // header size field
            frameStart += parseSyncSafeInteger$1(data.subarray(10, 14));
            tagSize -= parseSyncSafeInteger$1(data.subarray(16, 20)); // clip any padding off the end
        } // parse one or more ID3 frames
        // http://id3.org/id3v2.3.0#ID3v2_frame_overview
        do {
            // determine the number of bytes in this frame
            frameSize = parseSyncSafeInteger$1(data.subarray(frameStart + 4, frameStart + 8));
            if (frameSize < 1) break;
            frameHeader = String.fromCharCode(data[frameStart], data[frameStart + 1], data[frameStart + 2], data[frameStart + 3]);
            var frame = {
                id: frameHeader,
                data: data.subarray(frameStart + 10, frameStart + frameSize + 10)
            };
            frame.key = frame.id; // parse frame values
            if (frameParsers[frame.id]) // use frame specific parser
            frameParsers[frame.id](frame);
            else if (frame.id[0] === 'T') // use text frame generic parser
            frameParsers['T*'](frame);
            else if (frame.id[0] === 'W') // use URL link frame generic parser
            frameParsers['W*'](frame);
            frames.push(frame);
            frameStart += 10; // advance past the frame header
            frameStart += frameSize; // advance past the frame body
        }while (frameStart < tagSize);
        return frames;
    };
    var parseId3 = {
        parseId3Frames: parseId3Frames$1,
        parseSyncSafeInteger: parseSyncSafeInteger$1,
        frameParsers: frameParsers
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Accepts program elementary stream (PES) data events and parses out
   * ID3 metadata from them, if present.
   * @see http://id3.org/id3v2.3.0
   */ var Stream$5 = stream, StreamTypes$3 = streamTypes, id3 = parseId3, MetadataStream;
    MetadataStream = function(options) {
        var settings = {
            // the bytes of the program-level descriptor field in MP2T
            // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
            // program element descriptors"
            descriptor: options && options.descriptor
        }, // the total size in bytes of the ID3 tag being parsed
        tagSize = 0, // tag data that is not complete enough to be parsed
        buffer = [], // the total number of bytes currently in the buffer
        bufferSize = 0, i;
        MetadataStream.prototype.init.call(this); // calculate the text track in-band metadata track dispatch type
        // https://html.spec.whatwg.org/multipage/embedded-content.html#steps-to-expose-a-media-resource-specific-text-track
        this.dispatchType = StreamTypes$3.METADATA_STREAM_TYPE.toString(16);
        if (settings.descriptor) for(i = 0; i < settings.descriptor.length; i++)this.dispatchType += ('00' + settings.descriptor[i].toString(16)).slice(-2);
        this.push = function(chunk) {
            var tag, frameStart, frameSize, frame, i, frameHeader;
            if (chunk.type !== 'timed-metadata') return;
             // if data_alignment_indicator is set in the PES header,
            // we must have the start of a new ID3 tag. Assume anything
            // remaining in the buffer was malformed and throw it out
            if (chunk.dataAlignmentIndicator) {
                bufferSize = 0;
                buffer.length = 0;
            } // ignore events that don't look like ID3 data
            if (buffer.length === 0 && (chunk.data.length < 10 || chunk.data[0] !== 'I'.charCodeAt(0) || chunk.data[1] !== 'D'.charCodeAt(0) || chunk.data[2] !== '3'.charCodeAt(0))) {
                this.trigger('log', {
                    level: 'warn',
                    message: 'Skipping unrecognized metadata packet'
                });
                return;
            } // add this chunk to the data we've collected so far
            buffer.push(chunk);
            bufferSize += chunk.data.byteLength; // grab the size of the entire frame from the ID3 header
            if (buffer.length === 1) {
                // the frame size is transmitted as a 28-bit integer in the
                // last four bytes of the ID3 header.
                // The most significant bit of each byte is dropped and the
                // results concatenated to recover the actual value.
                tagSize = id3.parseSyncSafeInteger(chunk.data.subarray(6, 10)); // ID3 reports the tag size excluding the header but it's more
                // convenient for our comparisons to include it
                tagSize += 10;
            } // if the entire frame has not arrived, wait for more data
            if (bufferSize < tagSize) return;
             // collect the entire frame so it can be parsed
            tag = {
                data: new Uint8Array(tagSize),
                frames: [],
                pts: buffer[0].pts,
                dts: buffer[0].dts
            };
            for(i = 0; i < tagSize;){
                tag.data.set(buffer[0].data.subarray(0, tagSize - i), i);
                i += buffer[0].data.byteLength;
                bufferSize -= buffer[0].data.byteLength;
                buffer.shift();
            } // find the start of the first frame and the end of the tag
            frameStart = 10;
            if (tag.data[5] & 0x40) {
                // advance the frame start past the extended header
                frameStart += 4; // header size field
                frameStart += id3.parseSyncSafeInteger(tag.data.subarray(10, 14)); // clip any padding off the end
                tagSize -= id3.parseSyncSafeInteger(tag.data.subarray(16, 20));
            } // parse one or more ID3 frames
            // http://id3.org/id3v2.3.0#ID3v2_frame_overview
            do {
                // determine the number of bytes in this frame
                frameSize = id3.parseSyncSafeInteger(tag.data.subarray(frameStart + 4, frameStart + 8));
                if (frameSize < 1) {
                    this.trigger('log', {
                        level: 'warn',
                        message: 'Malformed ID3 frame encountered. Skipping remaining metadata parsing.'
                    }); // If the frame is malformed, don't parse any further frames but allow previous valid parsed frames
                    break;
                }
                frameHeader = String.fromCharCode(tag.data[frameStart], tag.data[frameStart + 1], tag.data[frameStart + 2], tag.data[frameStart + 3]);
                frame = {
                    id: frameHeader,
                    data: tag.data.subarray(frameStart + 10, frameStart + frameSize + 10)
                };
                frame.key = frame.id; // parse frame values
                if (id3.frameParsers[frame.id]) // use frame specific parser
                id3.frameParsers[frame.id](frame);
                else if (frame.id[0] === 'T') // use text frame generic parser
                id3.frameParsers['T*'](frame);
                else if (frame.id[0] === 'W') // use URL link frame generic parser
                id3.frameParsers['W*'](frame);
                 // handle the special PRIV frame used to indicate the start
                // time for raw AAC data
                if (frame.owner === 'com.apple.streaming.transportStreamTimestamp') {
                    var d = frame.data, size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
                    size *= 4;
                    size += d[7] & 0x03;
                    frame.timeStamp = size; // in raw AAC, all subsequent data will be timestamped based
                    // on the value of this frame
                    // we couldn't have known the appropriate pts and dts before
                    // parsing this ID3 tag so set those values now
                    if (tag.pts === undefined && tag.dts === undefined) {
                        tag.pts = frame.timeStamp;
                        tag.dts = frame.timeStamp;
                    }
                    this.trigger('timestamp', frame);
                }
                tag.frames.push(frame);
                frameStart += 10; // advance past the frame header
                frameStart += frameSize; // advance past the frame body
            }while (frameStart < tagSize);
            this.trigger('data', tag);
        };
    };
    MetadataStream.prototype = new Stream$5();
    var metadataStream = MetadataStream;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A stream-based mp2t to mp4 converter. This utility can be used to
   * deliver mp4s to a SourceBuffer on platforms that support native
   * Media Source Extensions.
   */ var Stream$4 = stream, CaptionStream$1 = captionStream, StreamTypes$2 = streamTypes, TimestampRolloverStream = timestampRolloverStream.TimestampRolloverStream; // object types
    var TransportPacketStream, TransportParseStream, ElementaryStream; // constants
    var MP2T_PACKET_LENGTH$1 = 188, // bytes
    SYNC_BYTE$1 = 0x47;
    /**
   * Splits an incoming stream of binary data into MPEG-2 Transport
   * Stream packets.
   */ TransportPacketStream = function() {
        var buffer = new Uint8Array(MP2T_PACKET_LENGTH$1), bytesInBuffer = 0;
        TransportPacketStream.prototype.init.call(this); // Deliver new bytes to the stream.
        /**
     * Split a stream of data into M2TS packets
    **/ this.push = function(bytes) {
            var startIndex = 0, endIndex = MP2T_PACKET_LENGTH$1, everything; // If there are bytes remaining from the last segment, prepend them to the
            // bytes that were pushed in
            if (bytesInBuffer) {
                everything = new Uint8Array(bytes.byteLength + bytesInBuffer);
                everything.set(buffer.subarray(0, bytesInBuffer));
                everything.set(bytes, bytesInBuffer);
                bytesInBuffer = 0;
            } else everything = bytes;
             // While we have enough data for a packet
            while(endIndex < everything.byteLength){
                // Look for a pair of start and end sync bytes in the data..
                if (everything[startIndex] === SYNC_BYTE$1 && everything[endIndex] === SYNC_BYTE$1) {
                    // We found a packet so emit it and jump one whole packet forward in
                    // the stream
                    this.trigger('data', everything.subarray(startIndex, endIndex));
                    startIndex += MP2T_PACKET_LENGTH$1;
                    endIndex += MP2T_PACKET_LENGTH$1;
                    continue;
                } // If we get here, we have somehow become de-synchronized and we need to step
                // forward one byte at a time until we find a pair of sync bytes that denote
                // a packet
                startIndex++;
                endIndex++;
            } // If there was some data left over at the end of the segment that couldn't
            // possibly be a whole packet, keep it because it might be the start of a packet
            // that continues in the next segment
            if (startIndex < everything.byteLength) {
                buffer.set(everything.subarray(startIndex), 0);
                bytesInBuffer = everything.byteLength - startIndex;
            }
        };
        /**
     * Passes identified M2TS packets to the TransportParseStream to be parsed
    **/ this.flush = function() {
            // If the buffer contains a whole packet when we are being flushed, emit it
            // and empty the buffer. Otherwise hold onto the data because it may be
            // important for decoding the next segment
            if (bytesInBuffer === MP2T_PACKET_LENGTH$1 && buffer[0] === SYNC_BYTE$1) {
                this.trigger('data', buffer);
                bytesInBuffer = 0;
            }
            this.trigger('done');
        };
        this.endTimeline = function() {
            this.flush();
            this.trigger('endedtimeline');
        };
        this.reset = function() {
            bytesInBuffer = 0;
            this.trigger('reset');
        };
    };
    TransportPacketStream.prototype = new Stream$4();
    /**
   * Accepts an MP2T TransportPacketStream and emits data events with parsed
   * forms of the individual transport stream packets.
   */ TransportParseStream = function() {
        var parsePsi, parsePat, parsePmt, self1;
        TransportParseStream.prototype.init.call(this);
        self1 = this;
        this.packetsWaitingForPmt = [];
        this.programMapTable = undefined;
        parsePsi = function(payload, psi) {
            var offset = 0; // PSI packets may be split into multiple sections and those
            // sections may be split into multiple packets. If a PSI
            // section starts in this packet, the payload_unit_start_indicator
            // will be true and the first byte of the payload will indicate
            // the offset from the current position to the start of the
            // section.
            if (psi.payloadUnitStartIndicator) offset += payload[offset] + 1;
            if (psi.type === 'pat') parsePat(payload.subarray(offset), psi);
            else parsePmt(payload.subarray(offset), psi);
        };
        parsePat = function(payload, pat) {
            pat.section_number = payload[7]; // eslint-disable-line camelcase
            pat.last_section_number = payload[8]; // eslint-disable-line camelcase
            // skip the PSI header and parse the first PMT entry
            self1.pmtPid = (payload[10] & 0x1F) << 8 | payload[11];
            pat.pmtPid = self1.pmtPid;
        };
        /**
     * Parse out the relevant fields of a Program Map Table (PMT).
     * @param payload {Uint8Array} the PMT-specific portion of an MP2T
     * packet. The first byte in this array should be the table_id
     * field.
     * @param pmt {object} the object that should be decorated with
     * fields parsed from the PMT.
     */ parsePmt = function(payload, pmt) {
            var sectionLength, tableEnd, programInfoLength, offset; // PMTs can be sent ahead of the time when they should actually
            // take effect. We don't believe this should ever be the case
            // for HLS but we'll ignore "forward" PMT declarations if we see
            // them. Future PMT declarations have the current_next_indicator
            // set to zero.
            if (!(payload[5] & 0x01)) return;
             // overwrite any existing program map table
            self1.programMapTable = {
                video: null,
                audio: null,
                'timed-metadata': {}
            }; // the mapping table ends at the end of the current section
            sectionLength = (payload[1] & 0x0f) << 8 | payload[2];
            tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
            // long the program info descriptors are
            programInfoLength = (payload[10] & 0x0f) << 8 | payload[11]; // advance the offset to the first entry in the mapping table
            offset = 12 + programInfoLength;
            while(offset < tableEnd){
                var streamType = payload[offset];
                var pid = (payload[offset + 1] & 0x1F) << 8 | payload[offset + 2]; // only map a single elementary_pid for audio and video stream types
                // TODO: should this be done for metadata too? for now maintain behavior of
                //       multiple metadata streams
                if (streamType === StreamTypes$2.H264_STREAM_TYPE && self1.programMapTable.video === null) self1.programMapTable.video = pid;
                else if (streamType === StreamTypes$2.ADTS_STREAM_TYPE && self1.programMapTable.audio === null) self1.programMapTable.audio = pid;
                else if (streamType === StreamTypes$2.METADATA_STREAM_TYPE) // map pid to stream type for metadata streams
                self1.programMapTable['timed-metadata'][pid] = streamType;
                 // move to the next table entry
                // skip past the elementary stream descriptors, if present
                offset += ((payload[offset + 3] & 0x0F) << 8 | payload[offset + 4]) + 5;
            } // record the map on the packet as well
            pmt.programMapTable = self1.programMapTable;
        };
        /**
     * Deliver a new MP2T packet to the next stream in the pipeline.
     */ this.push = function(packet) {
            var result = {}, offset = 4;
            result.payloadUnitStartIndicator = !!(packet[1] & 0x40); // pid is a 13-bit field starting at the last bit of packet[1]
            result.pid = packet[1] & 0x1f;
            result.pid <<= 8;
            result.pid |= packet[2]; // if an adaption field is present, its length is specified by the
            // fifth byte of the TS packet header. The adaptation field is
            // used to add stuffing to PES packets that don't fill a complete
            // TS packet, and to specify some forms of timing and control data
            // that we do not currently use.
            if ((packet[3] & 0x30) >>> 4 > 0x01) offset += packet[offset] + 1;
             // parse the rest of the packet based on the type
            if (result.pid === 0) {
                result.type = 'pat';
                parsePsi(packet.subarray(offset), result);
                this.trigger('data', result);
            } else if (result.pid === this.pmtPid) {
                result.type = 'pmt';
                parsePsi(packet.subarray(offset), result);
                this.trigger('data', result); // if there are any packets waiting for a PMT to be found, process them now
                while(this.packetsWaitingForPmt.length)this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
            } else if (this.programMapTable === undefined) // When we have not seen a PMT yet, defer further processing of
            // PES packets until one has been parsed
            this.packetsWaitingForPmt.push([
                packet,
                offset,
                result
            ]);
            else this.processPes_(packet, offset, result);
        };
        this.processPes_ = function(packet, offset, result) {
            // set the appropriate stream type
            if (result.pid === this.programMapTable.video) result.streamType = StreamTypes$2.H264_STREAM_TYPE;
            else if (result.pid === this.programMapTable.audio) result.streamType = StreamTypes$2.ADTS_STREAM_TYPE;
            else // if not video or audio, it is timed-metadata or unknown
            // if unknown, streamType will be undefined
            result.streamType = this.programMapTable['timed-metadata'][result.pid];
            result.type = 'pes';
            result.data = packet.subarray(offset);
            this.trigger('data', result);
        };
    };
    TransportParseStream.prototype = new Stream$4();
    TransportParseStream.STREAM_TYPES = {
        h264: 0x1b,
        adts: 0x0f
    };
    /**
   * Reconsistutes program elementary stream (PES) packets from parsed
   * transport stream packets. That is, if you pipe an
   * mp2t.TransportParseStream into a mp2t.ElementaryStream, the output
   * events will be events which capture the bytes for individual PES
   * packets plus relevant metadata that has been extracted from the
   * container.
   */ ElementaryStream = function() {
        var self1 = this, segmentHadPmt = false, // PES packet fragments
        video = {
            data: [],
            size: 0
        }, audio = {
            data: [],
            size: 0
        }, timedMetadata = {
            data: [],
            size: 0
        }, programMapTable, parsePes = function(payload, pes) {
            var ptsDtsFlags;
            const startPrefix = payload[0] << 16 | payload[1] << 8 | payload[2]; // default to an empty array
            pes.data = new Uint8Array(); // In certain live streams, the start of a TS fragment has ts packets
            // that are frame data that is continuing from the previous fragment. This
            // is to check that the pes data is the start of a new pes payload
            if (startPrefix !== 1) return;
             // get the packet length, this will be 0 for video
            pes.packetLength = 6 + (payload[4] << 8 | payload[5]); // find out if this packets starts a new keyframe
            pes.dataAlignmentIndicator = (payload[6] & 0x04) !== 0; // PES packets may be annotated with a PTS value, or a PTS value
            // and a DTS value. Determine what combination of values is
            // available to work with.
            ptsDtsFlags = payload[7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
            // performs all bitwise operations on 32-bit integers but javascript
            // supports a much greater range (52-bits) of integer using standard
            // mathematical operations.
            // We construct a 31-bit value using bitwise operators over the 31
            // most significant bits and then multiply by 4 (equal to a left-shift
            // of 2) before we add the final 2 least significant bits of the
            // timestamp (equal to an OR.)
            if (ptsDtsFlags & 0xC0) {
                // the PTS and DTS are not written out directly. For information
                // on how they are encoded, see
                // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
                pes.pts = (payload[9] & 0x0E) << 27 | (payload[10] & 0xFF) << 20 | (payload[11] & 0xFE) << 12 | (payload[12] & 0xFF) << 5 | (payload[13] & 0xFE) >>> 3;
                pes.pts *= 4; // Left shift by 2
                pes.pts += (payload[13] & 0x06) >>> 1; // OR by the two LSBs
                pes.dts = pes.pts;
                if (ptsDtsFlags & 0x40) {
                    pes.dts = (payload[14] & 0x0E) << 27 | (payload[15] & 0xFF) << 20 | (payload[16] & 0xFE) << 12 | (payload[17] & 0xFF) << 5 | (payload[18] & 0xFE) >>> 3;
                    pes.dts *= 4; // Left shift by 2
                    pes.dts += (payload[18] & 0x06) >>> 1; // OR by the two LSBs
                }
            } // the data section starts immediately after the PES header.
            // pes_header_data_length specifies the number of header bytes
            // that follow the last byte of the field.
            pes.data = payload.subarray(9 + payload[8]);
        }, /**
        * Pass completely parsed PES packets to the next stream in the pipeline
       **/ flushStream = function(stream, type, forceFlush) {
            var packetData = new Uint8Array(stream.size), event = {
                type: type
            }, i = 0, offset = 0, packetFlushable = false, fragment; // do nothing if there is not enough buffered data for a complete
            // PES header
            if (!stream.data.length || stream.size < 9) return;
            event.trackId = stream.data[0].pid; // reassemble the packet
            for(i = 0; i < stream.data.length; i++){
                fragment = stream.data[i];
                packetData.set(fragment.data, offset);
                offset += fragment.data.byteLength;
            } // parse assembled packet's PES header
            parsePes(packetData, event); // non-video PES packets MUST have a non-zero PES_packet_length
            // check that there is enough stream data to fill the packet
            packetFlushable = type === 'video' || event.packetLength <= stream.size; // flush pending packets if the conditions are right
            if (forceFlush || packetFlushable) {
                stream.size = 0;
                stream.data.length = 0;
            } // only emit packets that are complete. this is to avoid assembling
            // incomplete PES packets due to poor segmentation
            if (packetFlushable) self1.trigger('data', event);
        };
        ElementaryStream.prototype.init.call(this);
        /**
     * Identifies M2TS packet types and parses PES packets using metadata
     * parsed from the PMT
     **/ this.push = function(data) {
            ({
                pat: function() {
                // have any meaningful metadata
                },
                pes: function() {
                    var stream, streamType;
                    switch(data.streamType){
                        case StreamTypes$2.H264_STREAM_TYPE:
                            stream = video;
                            streamType = 'video';
                            break;
                        case StreamTypes$2.ADTS_STREAM_TYPE:
                            stream = audio;
                            streamType = 'audio';
                            break;
                        case StreamTypes$2.METADATA_STREAM_TYPE:
                            stream = timedMetadata;
                            streamType = 'timed-metadata';
                            break;
                        default:
                            // ignore unknown stream types
                            return;
                    } // if a new packet is starting, we can flush the completed
                    // packet
                    if (data.payloadUnitStartIndicator) flushStream(stream, streamType, true);
                     // buffer this fragment until we are sure we've received the
                    // complete payload
                    stream.data.push(data);
                    stream.size += data.data.byteLength;
                },
                pmt: function() {
                    var event = {
                        type: 'metadata',
                        tracks: []
                    };
                    programMapTable = data.programMapTable; // translate audio and video streams to tracks
                    if (programMapTable.video !== null) event.tracks.push({
                        timelineStartInfo: {
                            baseMediaDecodeTime: 0
                        },
                        id: +programMapTable.video,
                        codec: 'avc',
                        type: 'video'
                    });
                    if (programMapTable.audio !== null) event.tracks.push({
                        timelineStartInfo: {
                            baseMediaDecodeTime: 0
                        },
                        id: +programMapTable.audio,
                        codec: 'adts',
                        type: 'audio'
                    });
                    segmentHadPmt = true;
                    self1.trigger('data', event);
                }
            })[data.type]();
        };
        this.reset = function() {
            video.size = 0;
            video.data.length = 0;
            audio.size = 0;
            audio.data.length = 0;
            this.trigger('reset');
        };
        /**
     * Flush any remaining input. Video PES packets may be of variable
     * length. Normally, the start of a new video packet can trigger the
     * finalization of the previous packet. That is not possible if no
     * more video is forthcoming, however. In that case, some other
     * mechanism (like the end of the file) has to be employed. When it is
     * clear that no additional data is forthcoming, calling this method
     * will flush the buffered packets.
     */ this.flushStreams_ = function() {
            // !!THIS ORDER IS IMPORTANT!!
            // video first then audio
            flushStream(video, 'video');
            flushStream(audio, 'audio');
            flushStream(timedMetadata, 'timed-metadata');
        };
        this.flush = function() {
            // if on flush we haven't had a pmt emitted
            // and we have a pmt to emit. emit the pmt
            // so that we trigger a trackinfo downstream.
            if (!segmentHadPmt && programMapTable) {
                var pmt = {
                    type: 'metadata',
                    tracks: []
                }; // translate audio and video streams to tracks
                if (programMapTable.video !== null) pmt.tracks.push({
                    timelineStartInfo: {
                        baseMediaDecodeTime: 0
                    },
                    id: +programMapTable.video,
                    codec: 'avc',
                    type: 'video'
                });
                if (programMapTable.audio !== null) pmt.tracks.push({
                    timelineStartInfo: {
                        baseMediaDecodeTime: 0
                    },
                    id: +programMapTable.audio,
                    codec: 'adts',
                    type: 'audio'
                });
                self1.trigger('data', pmt);
            }
            segmentHadPmt = false;
            this.flushStreams_();
            this.trigger('done');
        };
    };
    ElementaryStream.prototype = new Stream$4();
    var m2ts$1 = {
        PAT_PID: 0x0000,
        MP2T_PACKET_LENGTH: MP2T_PACKET_LENGTH$1,
        TransportPacketStream: TransportPacketStream,
        TransportParseStream: TransportParseStream,
        ElementaryStream: ElementaryStream,
        TimestampRolloverStream: TimestampRolloverStream,
        CaptionStream: CaptionStream$1.CaptionStream,
        Cea608Stream: CaptionStream$1.Cea608Stream,
        Cea708Stream: CaptionStream$1.Cea708Stream,
        MetadataStream: metadataStream
    };
    for(var type in StreamTypes$2)if (StreamTypes$2.hasOwnProperty(type)) m2ts$1[type] = StreamTypes$2[type];
    var m2ts_1 = m2ts$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var Stream$3 = stream;
    var ONE_SECOND_IN_TS$2 = clock$2.ONE_SECOND_IN_TS;
    var AdtsStream$1;
    var ADTS_SAMPLING_FREQUENCIES$1 = [
        96000,
        88200,
        64000,
        48000,
        44100,
        32000,
        24000,
        22050,
        16000,
        12000,
        11025,
        8000,
        7350
    ];
    /*
   * Accepts a ElementaryStream and emits data events with parsed
   * AAC Audio Frames of the individual packets. Input audio in ADTS
   * format is unpacked and re-emitted as AAC frames.
   *
   * @see http://wiki.multimedia.cx/index.php?title=ADTS
   * @see http://wiki.multimedia.cx/?title=Understanding_AAC
   */ AdtsStream$1 = function(handlePartialSegments) {
        var buffer, frameNum = 0;
        AdtsStream$1.prototype.init.call(this);
        this.skipWarn_ = function(start, end) {
            this.trigger('log', {
                level: 'warn',
                message: `adts skiping bytes ${start} to ${end} in frame ${frameNum} outside syncword`
            });
        };
        this.push = function(packet) {
            var i = 0, frameLength, protectionSkipBytes, oldBuffer, sampleCount, adtsFrameDuration;
            if (!handlePartialSegments) frameNum = 0;
            if (packet.type !== 'audio') // ignore non-audio data
            return;
             // Prepend any data in the buffer to the input data so that we can parse
            // aac frames the cross a PES packet boundary
            if (buffer && buffer.length) {
                oldBuffer = buffer;
                buffer = new Uint8Array(oldBuffer.byteLength + packet.data.byteLength);
                buffer.set(oldBuffer);
                buffer.set(packet.data, oldBuffer.byteLength);
            } else buffer = packet.data;
             // unpack any ADTS frames which have been fully received
            // for details on the ADTS header, see http://wiki.multimedia.cx/index.php?title=ADTS
            var skip; // We use i + 7 here because we want to be able to parse the entire header.
            // If we don't have enough bytes to do that, then we definitely won't have a full frame.
            while(i + 7 < buffer.length){
                // Look for the start of an ADTS header..
                if (buffer[i] !== 0xFF || (buffer[i + 1] & 0xF6) !== 0xF0) {
                    if (typeof skip !== 'number') skip = i;
                     // If a valid header was not found,  jump one forward and attempt to
                    // find a valid ADTS header starting at the next byte
                    i++;
                    continue;
                }
                if (typeof skip === 'number') {
                    this.skipWarn_(skip, i);
                    skip = null;
                } // The protection skip bit tells us if we have 2 bytes of CRC data at the
                // end of the ADTS header
                protectionSkipBytes = (~buffer[i + 1] & 0x01) * 2; // Frame length is a 13 bit integer starting 16 bits from the
                // end of the sync sequence
                // NOTE: frame length includes the size of the header
                frameLength = (buffer[i + 3] & 0x03) << 11 | buffer[i + 4] << 3 | (buffer[i + 5] & 0xe0) >> 5;
                sampleCount = ((buffer[i + 6] & 0x03) + 1) * 1024;
                adtsFrameDuration = sampleCount * ONE_SECOND_IN_TS$2 / ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2]; // If we don't have enough data to actually finish this ADTS frame,
                // then we have to wait for more data
                if (buffer.byteLength - i < frameLength) break;
                 // Otherwise, deliver the complete AAC frame
                this.trigger('data', {
                    pts: packet.pts + frameNum * adtsFrameDuration,
                    dts: packet.dts + frameNum * adtsFrameDuration,
                    sampleCount: sampleCount,
                    audioobjecttype: (buffer[i + 2] >>> 6 & 0x03) + 1,
                    channelcount: (buffer[i + 2] & 1) << 2 | (buffer[i + 3] & 0xc0) >>> 6,
                    samplerate: ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2],
                    samplingfrequencyindex: (buffer[i + 2] & 0x3c) >>> 2,
                    // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
                    samplesize: 16,
                    // data is the frame without it's header
                    data: buffer.subarray(i + 7 + protectionSkipBytes, i + frameLength)
                });
                frameNum++;
                i += frameLength;
            }
            if (typeof skip === 'number') {
                this.skipWarn_(skip, i);
                skip = null;
            } // remove processed bytes from the buffer.
            buffer = buffer.subarray(i);
        };
        this.flush = function() {
            frameNum = 0;
            this.trigger('done');
        };
        this.reset = function() {
            buffer = void 0;
            this.trigger('reset');
        };
        this.endTimeline = function() {
            buffer = void 0;
            this.trigger('endedtimeline');
        };
    };
    AdtsStream$1.prototype = new Stream$3();
    var adts = AdtsStream$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var ExpGolomb$1;
    /**
   * Parser for exponential Golomb codes, a variable-bitwidth number encoding
   * scheme used by h264.
   */ ExpGolomb$1 = function(workingData) {
        var // the number of bytes left to examine in workingData
        workingBytesAvailable = workingData.byteLength, // the current word being examined
        workingWord = 0, // :uint
        // the number of bits left to examine in the current word
        workingBitsAvailable = 0; // :uint;
        // ():uint
        this.length = function() {
            return 8 * workingBytesAvailable;
        }; // ():uint
        this.bitsAvailable = function() {
            return 8 * workingBytesAvailable + workingBitsAvailable;
        }; // ():void
        this.loadWord = function() {
            var position = workingData.byteLength - workingBytesAvailable, workingBytes = new Uint8Array(4), availableBytes = Math.min(4, workingBytesAvailable);
            if (availableBytes === 0) throw new Error('no bytes available');
            workingBytes.set(workingData.subarray(position, position + availableBytes));
            workingWord = new DataView(workingBytes.buffer).getUint32(0); // track the amount of workingData that has been processed
            workingBitsAvailable = availableBytes * 8;
            workingBytesAvailable -= availableBytes;
        }; // (count:int):void
        this.skipBits = function(count) {
            var skipBytes; // :int
            if (workingBitsAvailable > count) {
                workingWord <<= count;
                workingBitsAvailable -= count;
            } else {
                count -= workingBitsAvailable;
                skipBytes = Math.floor(count / 8);
                count -= skipBytes * 8;
                workingBytesAvailable -= skipBytes;
                this.loadWord();
                workingWord <<= count;
                workingBitsAvailable -= count;
            }
        }; // (size:int):uint
        this.readBits = function(size) {
            var bits = Math.min(workingBitsAvailable, size), // :uint
            valu = workingWord >>> 32 - bits; // :uint
            // if size > 31, handle error
            workingBitsAvailable -= bits;
            if (workingBitsAvailable > 0) workingWord <<= bits;
            else if (workingBytesAvailable > 0) this.loadWord();
            bits = size - bits;
            if (bits > 0) return valu << bits | this.readBits(bits);
            return valu;
        }; // ():uint
        this.skipLeadingZeros = function() {
            var leadingZeroCount; // :uint
            for(leadingZeroCount = 0; leadingZeroCount < workingBitsAvailable; ++leadingZeroCount)if ((workingWord & 0x80000000 >>> leadingZeroCount) !== 0) {
                // the first bit of working word is 1
                workingWord <<= leadingZeroCount;
                workingBitsAvailable -= leadingZeroCount;
                return leadingZeroCount;
            }
             // we exhausted workingWord and still have not found a 1
            this.loadWord();
            return leadingZeroCount + this.skipLeadingZeros();
        }; // ():void
        this.skipUnsignedExpGolomb = function() {
            this.skipBits(1 + this.skipLeadingZeros());
        }; // ():void
        this.skipExpGolomb = function() {
            this.skipBits(1 + this.skipLeadingZeros());
        }; // ():uint
        this.readUnsignedExpGolomb = function() {
            var clz = this.skipLeadingZeros(); // :uint
            return this.readBits(clz + 1) - 1;
        }; // ():int
        this.readExpGolomb = function() {
            var valu = this.readUnsignedExpGolomb(); // :int
            if (0x01 & valu) // the number is odd if the low order bit is set
            return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
            return -1 * (valu >>> 1); // divide by two then make it negative
        }; // Some convenience functions
        // :Boolean
        this.readBoolean = function() {
            return this.readBits(1) === 1;
        }; // ():int
        this.readUnsignedByte = function() {
            return this.readBits(8);
        };
        this.loadWord();
    };
    var expGolomb = ExpGolomb$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var Stream$2 = stream;
    var ExpGolomb = expGolomb;
    var H264Stream$1, NalByteStream;
    var PROFILES_WITH_OPTIONAL_SPS_DATA;
    /**
   * Accepts a NAL unit byte stream and unpacks the embedded NAL units.
   */ NalByteStream = function() {
        var syncPoint = 0, i, buffer;
        NalByteStream.prototype.init.call(this);
        /*
     * Scans a byte stream and triggers a data event with the NAL units found.
     * @param {Object} data Event received from H264Stream
     * @param {Uint8Array} data.data The h264 byte stream to be scanned
     *
     * @see H264Stream.push
     */ this.push = function(data) {
            var swapBuffer;
            if (!buffer) buffer = data.data;
            else {
                swapBuffer = new Uint8Array(buffer.byteLength + data.data.byteLength);
                swapBuffer.set(buffer);
                swapBuffer.set(data.data, buffer.byteLength);
                buffer = swapBuffer;
            }
            var len = buffer.byteLength; // Rec. ITU-T H.264, Annex B
            // scan for NAL unit boundaries
            // a match looks like this:
            // 0 0 1 .. NAL .. 0 0 1
            // ^ sync point        ^ i
            // or this:
            // 0 0 1 .. NAL .. 0 0 0
            // ^ sync point        ^ i
            // advance the sync point to a NAL start, if necessary
            for(; syncPoint < len - 3; syncPoint++)if (buffer[syncPoint + 2] === 1) {
                // the sync point is properly aligned
                i = syncPoint + 5;
                break;
            }
            while(i < len)// look at the current byte to determine if we've hit the end of
            // a NAL unit boundary
            switch(buffer[i]){
                case 0:
                    // skip past non-sync sequences
                    if (buffer[i - 1] !== 0) {
                        i += 2;
                        break;
                    } else if (buffer[i - 2] !== 0) {
                        i++;
                        break;
                    } // deliver the NAL unit if it isn't empty
                    if (syncPoint + 3 !== i - 2) this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
                     // drop trailing zeroes
                    do i++;
                    while (buffer[i] !== 1 && i < len);
                    syncPoint = i - 2;
                    i += 3;
                    break;
                case 1:
                    // skip past non-sync sequences
                    if (buffer[i - 1] !== 0 || buffer[i - 2] !== 0) {
                        i += 3;
                        break;
                    } // deliver the NAL unit
                    this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
                    syncPoint = i - 2;
                    i += 3;
                    break;
                default:
                    // the current byte isn't a one or zero, so it cannot be part
                    // of a sync sequence
                    i += 3;
                    break;
            }
             // filter out the NAL units that were delivered
            buffer = buffer.subarray(syncPoint);
            i -= syncPoint;
            syncPoint = 0;
        };
        this.reset = function() {
            buffer = null;
            syncPoint = 0;
            this.trigger('reset');
        };
        this.flush = function() {
            // deliver the last buffered NAL unit
            if (buffer && buffer.byteLength > 3) this.trigger('data', buffer.subarray(syncPoint + 3));
             // reset the stream state
            buffer = null;
            syncPoint = 0;
            this.trigger('done');
        };
        this.endTimeline = function() {
            this.flush();
            this.trigger('endedtimeline');
        };
    };
    NalByteStream.prototype = new Stream$2(); // values of profile_idc that indicate additional fields are included in the SPS
    // see Recommendation ITU-T H.264 (4/2013),
    // 7.3.2.1.1 Sequence parameter set data syntax
    PROFILES_WITH_OPTIONAL_SPS_DATA = {
        100: true,
        110: true,
        122: true,
        244: true,
        44: true,
        83: true,
        86: true,
        118: true,
        128: true,
        // TODO: the three profiles below don't
        // appear to have sps data in the specificiation anymore?
        138: true,
        139: true,
        134: true
    };
    /**
   * Accepts input from a ElementaryStream and produces H.264 NAL unit data
   * events.
   */ H264Stream$1 = function() {
        var nalByteStream = new NalByteStream(), self1, trackId, currentPts, currentDts, discardEmulationPreventionBytes, readSequenceParameterSet, skipScalingList;
        H264Stream$1.prototype.init.call(this);
        self1 = this;
        /*
     * Pushes a packet from a stream onto the NalByteStream
     *
     * @param {Object} packet - A packet received from a stream
     * @param {Uint8Array} packet.data - The raw bytes of the packet
     * @param {Number} packet.dts - Decode timestamp of the packet
     * @param {Number} packet.pts - Presentation timestamp of the packet
     * @param {Number} packet.trackId - The id of the h264 track this packet came from
     * @param {('video'|'audio')} packet.type - The type of packet
     *
     */ this.push = function(packet) {
            if (packet.type !== 'video') return;
            trackId = packet.trackId;
            currentPts = packet.pts;
            currentDts = packet.dts;
            nalByteStream.push(packet);
        };
        /*
     * Identify NAL unit types and pass on the NALU, trackId, presentation and decode timestamps
     * for the NALUs to the next stream component.
     * Also, preprocess caption and sequence parameter NALUs.
     *
     * @param {Uint8Array} data - A NAL unit identified by `NalByteStream.push`
     * @see NalByteStream.push
     */ nalByteStream.on('data', function(data) {
            var event = {
                trackId: trackId,
                pts: currentPts,
                dts: currentDts,
                data: data,
                nalUnitTypeCode: data[0] & 0x1f
            };
            switch(event.nalUnitTypeCode){
                case 0x05:
                    event.nalUnitType = 'slice_layer_without_partitioning_rbsp_idr';
                    break;
                case 0x06:
                    event.nalUnitType = 'sei_rbsp';
                    event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
                    break;
                case 0x07:
                    event.nalUnitType = 'seq_parameter_set_rbsp';
                    event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
                    event.config = readSequenceParameterSet(event.escapedRBSP);
                    break;
                case 0x08:
                    event.nalUnitType = 'pic_parameter_set_rbsp';
                    break;
                case 0x09:
                    event.nalUnitType = 'access_unit_delimiter_rbsp';
                    break;
            } // This triggers data on the H264Stream
            self1.trigger('data', event);
        });
        nalByteStream.on('done', function() {
            self1.trigger('done');
        });
        nalByteStream.on('partialdone', function() {
            self1.trigger('partialdone');
        });
        nalByteStream.on('reset', function() {
            self1.trigger('reset');
        });
        nalByteStream.on('endedtimeline', function() {
            self1.trigger('endedtimeline');
        });
        this.flush = function() {
            nalByteStream.flush();
        };
        this.partialFlush = function() {
            nalByteStream.partialFlush();
        };
        this.reset = function() {
            nalByteStream.reset();
        };
        this.endTimeline = function() {
            nalByteStream.endTimeline();
        };
        /**
     * Advance the ExpGolomb decoder past a scaling list. The scaling
     * list is optionally transmitted as part of a sequence parameter
     * set and is not relevant to transmuxing.
     * @param count {number} the number of entries in this scaling list
     * @param expGolombDecoder {object} an ExpGolomb pointed to the
     * start of a scaling list
     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
     */ skipScalingList = function(count, expGolombDecoder) {
            var lastScale = 8, nextScale = 8, j, deltaScale;
            for(j = 0; j < count; j++){
                if (nextScale !== 0) {
                    deltaScale = expGolombDecoder.readExpGolomb();
                    nextScale = (lastScale + deltaScale + 256) % 256;
                }
                lastScale = nextScale === 0 ? lastScale : nextScale;
            }
        };
        /**
     * Expunge any "Emulation Prevention" bytes from a "Raw Byte
     * Sequence Payload"
     * @param data {Uint8Array} the bytes of a RBSP from a NAL
     * unit
     * @return {Uint8Array} the RBSP without any Emulation
     * Prevention Bytes
     */ discardEmulationPreventionBytes = function(data) {
            var length = data.byteLength, emulationPreventionBytesPositions = [], i = 1, newLength, newData; // Find all `Emulation Prevention Bytes`
            while(i < length - 2)if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
                emulationPreventionBytesPositions.push(i + 2);
                i += 2;
            } else i++;
             // If no Emulation Prevention Bytes were found just return the original
            // array
            if (emulationPreventionBytesPositions.length === 0) return data;
             // Create a new array to hold the NAL unit data
            newLength = length - emulationPreventionBytesPositions.length;
            newData = new Uint8Array(newLength);
            var sourceIndex = 0;
            for(i = 0; i < newLength; sourceIndex++, i++){
                if (sourceIndex === emulationPreventionBytesPositions[0]) {
                    // Skip this byte
                    sourceIndex++; // Remove this position index
                    emulationPreventionBytesPositions.shift();
                }
                newData[i] = data[sourceIndex];
            }
            return newData;
        };
        /**
     * Read a sequence parameter set and return some interesting video
     * properties. A sequence parameter set is the H264 metadata that
     * describes the properties of upcoming video frames.
     * @param data {Uint8Array} the bytes of a sequence parameter set
     * @return {object} an object with configuration parsed from the
     * sequence parameter set, including the dimensions of the
     * associated video frames.
     */ readSequenceParameterSet = function(data) {
            var frameCropLeftOffset = 0, frameCropRightOffset = 0, frameCropTopOffset = 0, frameCropBottomOffset = 0, expGolombDecoder, profileIdc, levelIdc, profileCompatibility, chromaFormatIdc, picOrderCntType, numRefFramesInPicOrderCntCycle, picWidthInMbsMinus1, picHeightInMapUnitsMinus1, frameMbsOnlyFlag, scalingListCount, sarRatio = [
                1,
                1
            ], aspectRatioIdc, i;
            expGolombDecoder = new ExpGolomb(data);
            profileIdc = expGolombDecoder.readUnsignedByte(); // profile_idc
            profileCompatibility = expGolombDecoder.readUnsignedByte(); // constraint_set[0-5]_flag
            levelIdc = expGolombDecoder.readUnsignedByte(); // level_idc u(8)
            expGolombDecoder.skipUnsignedExpGolomb(); // seq_parameter_set_id
            // some profiles have more optional data we don't need
            if (PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]) {
                chromaFormatIdc = expGolombDecoder.readUnsignedExpGolomb();
                if (chromaFormatIdc === 3) expGolombDecoder.skipBits(1); // separate_colour_plane_flag
                expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_luma_minus8
                expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_chroma_minus8
                expGolombDecoder.skipBits(1); // qpprime_y_zero_transform_bypass_flag
                if (expGolombDecoder.readBoolean()) {
                    // seq_scaling_matrix_present_flag
                    scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
                    for(i = 0; i < scalingListCount; i++)if (expGolombDecoder.readBoolean()) {
                        // seq_scaling_list_present_flag[ i ]
                        if (i < 6) skipScalingList(16, expGolombDecoder);
                        else skipScalingList(64, expGolombDecoder);
                    }
                }
            }
            expGolombDecoder.skipUnsignedExpGolomb(); // log2_max_frame_num_minus4
            picOrderCntType = expGolombDecoder.readUnsignedExpGolomb();
            if (picOrderCntType === 0) expGolombDecoder.readUnsignedExpGolomb(); // log2_max_pic_order_cnt_lsb_minus4
            else if (picOrderCntType === 1) {
                expGolombDecoder.skipBits(1); // delta_pic_order_always_zero_flag
                expGolombDecoder.skipExpGolomb(); // offset_for_non_ref_pic
                expGolombDecoder.skipExpGolomb(); // offset_for_top_to_bottom_field
                numRefFramesInPicOrderCntCycle = expGolombDecoder.readUnsignedExpGolomb();
                for(i = 0; i < numRefFramesInPicOrderCntCycle; i++)expGolombDecoder.skipExpGolomb(); // offset_for_ref_frame[ i ]
            }
            expGolombDecoder.skipUnsignedExpGolomb(); // max_num_ref_frames
            expGolombDecoder.skipBits(1); // gaps_in_frame_num_value_allowed_flag
            picWidthInMbsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
            picHeightInMapUnitsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
            frameMbsOnlyFlag = expGolombDecoder.readBits(1);
            if (frameMbsOnlyFlag === 0) expGolombDecoder.skipBits(1); // mb_adaptive_frame_field_flag
            expGolombDecoder.skipBits(1); // direct_8x8_inference_flag
            if (expGolombDecoder.readBoolean()) {
                // frame_cropping_flag
                frameCropLeftOffset = expGolombDecoder.readUnsignedExpGolomb();
                frameCropRightOffset = expGolombDecoder.readUnsignedExpGolomb();
                frameCropTopOffset = expGolombDecoder.readUnsignedExpGolomb();
                frameCropBottomOffset = expGolombDecoder.readUnsignedExpGolomb();
            }
            if (expGolombDecoder.readBoolean()) // vui_parameters_present_flag
            {
                if (expGolombDecoder.readBoolean()) {
                    // aspect_ratio_info_present_flag
                    aspectRatioIdc = expGolombDecoder.readUnsignedByte();
                    switch(aspectRatioIdc){
                        case 1:
                            sarRatio = [
                                1,
                                1
                            ];
                            break;
                        case 2:
                            sarRatio = [
                                12,
                                11
                            ];
                            break;
                        case 3:
                            sarRatio = [
                                10,
                                11
                            ];
                            break;
                        case 4:
                            sarRatio = [
                                16,
                                11
                            ];
                            break;
                        case 5:
                            sarRatio = [
                                40,
                                33
                            ];
                            break;
                        case 6:
                            sarRatio = [
                                24,
                                11
                            ];
                            break;
                        case 7:
                            sarRatio = [
                                20,
                                11
                            ];
                            break;
                        case 8:
                            sarRatio = [
                                32,
                                11
                            ];
                            break;
                        case 9:
                            sarRatio = [
                                80,
                                33
                            ];
                            break;
                        case 10:
                            sarRatio = [
                                18,
                                11
                            ];
                            break;
                        case 11:
                            sarRatio = [
                                15,
                                11
                            ];
                            break;
                        case 12:
                            sarRatio = [
                                64,
                                33
                            ];
                            break;
                        case 13:
                            sarRatio = [
                                160,
                                99
                            ];
                            break;
                        case 14:
                            sarRatio = [
                                4,
                                3
                            ];
                            break;
                        case 15:
                            sarRatio = [
                                3,
                                2
                            ];
                            break;
                        case 16:
                            sarRatio = [
                                2,
                                1
                            ];
                            break;
                        case 255:
                            sarRatio = [
                                expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte(),
                                expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte()
                            ];
                            break;
                    }
                    if (sarRatio) sarRatio[0], sarRatio[1];
                }
            }
            return {
                profileIdc: profileIdc,
                levelIdc: levelIdc,
                profileCompatibility: profileCompatibility,
                width: (picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2,
                height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - frameCropTopOffset * 2 - frameCropBottomOffset * 2,
                // sar is sample aspect ratio
                sarRatio: sarRatio
            };
        };
    };
    H264Stream$1.prototype = new Stream$2();
    var h264 = {
        H264Stream: H264Stream$1,
        NalByteStream: NalByteStream
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Utilities to detect basic properties and metadata about Aac data.
   */ var ADTS_SAMPLING_FREQUENCIES = [
        96000,
        88200,
        64000,
        48000,
        44100,
        32000,
        24000,
        22050,
        16000,
        12000,
        11025,
        8000,
        7350
    ];
    var parseId3TagSize = function(header, byteIndex) {
        var returnSize = header[byteIndex + 6] << 21 | header[byteIndex + 7] << 14 | header[byteIndex + 8] << 7 | header[byteIndex + 9], flags = header[byteIndex + 5], footerPresent = (flags & 16) >> 4; // if we get a negative returnSize clamp it to 0
        returnSize = returnSize >= 0 ? returnSize : 0;
        if (footerPresent) return returnSize + 20;
        return returnSize + 10;
    };
    var getId3Offset = function(data, offset) {
        if (data.length - offset < 10 || data[offset] !== 'I'.charCodeAt(0) || data[offset + 1] !== 'D'.charCodeAt(0) || data[offset + 2] !== '3'.charCodeAt(0)) return offset;
        offset += parseId3TagSize(data, offset);
        return getId3Offset(data, offset);
    }; // TODO: use vhs-utils
    var isLikelyAacData$1 = function(data) {
        var offset = getId3Offset(data, 0);
        return data.length >= offset + 2 && (data[offset] & 0xFF) === 0xFF && (data[offset + 1] & 0xF0) === 0xF0 && // verify that the 2 layer bits are 0, aka this
        // is not mp3 data but aac data.
        (data[offset + 1] & 0x16) === 0x10;
    };
    var parseSyncSafeInteger = function(data) {
        return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
    }; // return a percent-encoded representation of the specified byte range
    // @see http://en.wikipedia.org/wiki/Percent-encoding
    var percentEncode = function(bytes, start, end) {
        var i, result = '';
        for(i = start; i < end; i++)result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
        return result;
    }; // return the string representation of the specified byte range,
    // interpreted as ISO-8859-1.
    var parseIso88591 = function(bytes, start, end) {
        return unescape(percentEncode(bytes, start, end)); // jshint ignore:line
    };
    var parseAdtsSize = function(header, byteIndex) {
        var lowThree = (header[byteIndex + 5] & 0xE0) >> 5, middle = header[byteIndex + 4] << 3, highTwo = header[byteIndex + 3] & 6144;
        return highTwo | middle | lowThree;
    };
    var parseType$5 = function(header, byteIndex) {
        if (header[byteIndex] === 'I'.charCodeAt(0) && header[byteIndex + 1] === 'D'.charCodeAt(0) && header[byteIndex + 2] === '3'.charCodeAt(0)) return 'timed-metadata';
        else if (header[byteIndex] & true && (header[byteIndex + 1] & 0xf0) === 0xf0) return 'audio';
        return null;
    };
    var parseSampleRate = function(packet) {
        var i = 0;
        while(i + 5 < packet.length){
            if (packet[i] !== 0xFF || (packet[i + 1] & 0xF6) !== 0xF0) {
                // If a valid header was not found,  jump one forward and attempt to
                // find a valid ADTS header starting at the next byte
                i++;
                continue;
            }
            return ADTS_SAMPLING_FREQUENCIES[(packet[i + 2] & 0x3c) >>> 2];
        }
        return null;
    };
    var parseAacTimestamp = function(packet) {
        var frameStart, frameSize, frame, frameHeader; // find the start of the first frame and the end of the tag
        frameStart = 10;
        if (packet[5] & 0x40) {
            // advance the frame start past the extended header
            frameStart += 4; // header size field
            frameStart += parseSyncSafeInteger(packet.subarray(10, 14));
        } // parse one or more ID3 frames
        // http://id3.org/id3v2.3.0#ID3v2_frame_overview
        do {
            // determine the number of bytes in this frame
            frameSize = parseSyncSafeInteger(packet.subarray(frameStart + 4, frameStart + 8));
            if (frameSize < 1) return null;
            frameHeader = String.fromCharCode(packet[frameStart], packet[frameStart + 1], packet[frameStart + 2], packet[frameStart + 3]);
            if (frameHeader === 'PRIV') {
                frame = packet.subarray(frameStart + 10, frameStart + frameSize + 10);
                for(var i = 0; i < frame.byteLength; i++)if (frame[i] === 0) {
                    var owner = parseIso88591(frame, 0, i);
                    if (owner === 'com.apple.streaming.transportStreamTimestamp') {
                        var d = frame.subarray(i + 1);
                        var size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
                        size *= 4;
                        size += d[7] & 0x03;
                        return size;
                    }
                    break;
                }
            }
            frameStart += 10; // advance past the frame header
            frameStart += frameSize; // advance past the frame body
        }while (frameStart < packet.byteLength);
        return null;
    };
    var utils = {
        isLikelyAacData: isLikelyAacData$1,
        parseId3TagSize: parseId3TagSize,
        parseAdtsSize: parseAdtsSize,
        parseType: parseType$5,
        parseSampleRate: parseSampleRate,
        parseAacTimestamp: parseAacTimestamp
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A stream-based aac to mp4 converter. This utility can be used to
   * deliver mp4s to a SourceBuffer on platforms that support native
   * Media Source Extensions.
   */ var Stream$1 = stream;
    var aacUtils = utils; // Constants
    var AacStream$1;
    /**
   * Splits an incoming stream of binary data into ADTS and ID3 Frames.
   */ AacStream$1 = function() {
        var everything = new Uint8Array(), timeStamp = 0;
        AacStream$1.prototype.init.call(this);
        this.setTimestamp = function(timestamp) {
            timeStamp = timestamp;
        };
        this.push = function(bytes) {
            var frameSize = 0, byteIndex = 0, bytesLeft, chunk, packet, tempLength; // If there are bytes remaining from the last segment, prepend them to the
            // bytes that were pushed in
            if (everything.length) {
                tempLength = everything.length;
                everything = new Uint8Array(bytes.byteLength + tempLength);
                everything.set(everything.subarray(0, tempLength));
                everything.set(bytes, tempLength);
            } else everything = bytes;
            while(everything.length - byteIndex >= 3){
                if (everything[byteIndex] === 'I'.charCodeAt(0) && everything[byteIndex + 1] === 'D'.charCodeAt(0) && everything[byteIndex + 2] === '3'.charCodeAt(0)) {
                    // Exit early because we don't have enough to parse
                    // the ID3 tag header
                    if (everything.length - byteIndex < 10) break;
                     // check framesize
                    frameSize = aacUtils.parseId3TagSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    // Add to byteIndex to support multiple ID3 tags in sequence
                    if (byteIndex + frameSize > everything.length) break;
                    chunk = {
                        type: 'timed-metadata',
                        data: everything.subarray(byteIndex, byteIndex + frameSize)
                    };
                    this.trigger('data', chunk);
                    byteIndex += frameSize;
                    continue;
                } else if ((everything[byteIndex] & 0xff) === 0xff && (everything[byteIndex + 1] & 0xf0) === 0xf0) {
                    // Exit early because we don't have enough to parse
                    // the ADTS frame header
                    if (everything.length - byteIndex < 7) break;
                    frameSize = aacUtils.parseAdtsSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    if (byteIndex + frameSize > everything.length) break;
                    packet = {
                        type: 'audio',
                        data: everything.subarray(byteIndex, byteIndex + frameSize),
                        pts: timeStamp,
                        dts: timeStamp
                    };
                    this.trigger('data', packet);
                    byteIndex += frameSize;
                    continue;
                }
                byteIndex++;
            }
            bytesLeft = everything.length - byteIndex;
            if (bytesLeft > 0) everything = everything.subarray(byteIndex);
            else everything = new Uint8Array();
        };
        this.reset = function() {
            everything = new Uint8Array();
            this.trigger('reset');
        };
        this.endTimeline = function() {
            everything = new Uint8Array();
            this.trigger('endedtimeline');
        };
    };
    AacStream$1.prototype = new Stream$1();
    var aac = AacStream$1;
    var AUDIO_PROPERTIES$1 = [
        'audioobjecttype',
        'channelcount',
        'samplerate',
        'samplingfrequencyindex',
        'samplesize'
    ];
    var audioProperties = AUDIO_PROPERTIES$1;
    var VIDEO_PROPERTIES$1 = [
        'width',
        'height',
        'profileIdc',
        'levelIdc',
        'profileCompatibility',
        'sarRatio'
    ];
    var videoProperties = VIDEO_PROPERTIES$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A stream-based mp2t to mp4 converter. This utility can be used to
   * deliver mp4s to a SourceBuffer on platforms that support native
   * Media Source Extensions.
   */ var Stream = stream;
    var mp4 = mp4Generator;
    var frameUtils = frameUtils$1;
    var audioFrameUtils = audioFrameUtils$1;
    var trackDecodeInfo = trackDecodeInfo$1;
    var m2ts = m2ts_1;
    var clock = clock$2;
    var AdtsStream = adts;
    var H264Stream = h264.H264Stream;
    var AacStream = aac;
    var isLikelyAacData = utils.isLikelyAacData;
    var ONE_SECOND_IN_TS$1 = clock$2.ONE_SECOND_IN_TS;
    var AUDIO_PROPERTIES = audioProperties;
    var VIDEO_PROPERTIES = videoProperties; // object types
    var VideoSegmentStream, AudioSegmentStream, Transmuxer, CoalesceStream;
    var retriggerForStream = function(key, event) {
        event.stream = key;
        this.trigger('log', event);
    };
    var addPipelineLogRetriggers = function(transmuxer, pipeline) {
        var keys = Object.keys(pipeline);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i]; // skip non-stream keys and headOfPipeline
            // which is just a duplicate
            if (key === 'headOfPipeline' || !pipeline[key].on) continue;
            pipeline[key].on('log', retriggerForStream.bind(transmuxer, key));
        }
    };
    /**
   * Compare two arrays (even typed) for same-ness
   */ var arrayEquals = function(a, b) {
        var i;
        if (a.length !== b.length) return false;
         // compare the value of each element in the array
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    };
    var generateSegmentTimingInfo = function(baseMediaDecodeTime, startDts, startPts, endDts, endPts, prependedContentDuration) {
        var ptsOffsetFromDts = startPts - startDts, decodeDuration = endDts - startDts, presentationDuration = endPts - startPts; // The PTS and DTS values are based on the actual stream times from the segment,
        // however, the player time values will reflect a start from the baseMediaDecodeTime.
        // In order to provide relevant values for the player times, base timing info on the
        // baseMediaDecodeTime and the DTS and PTS durations of the segment.
        return {
            start: {
                dts: baseMediaDecodeTime,
                pts: baseMediaDecodeTime + ptsOffsetFromDts
            },
            end: {
                dts: baseMediaDecodeTime + decodeDuration,
                pts: baseMediaDecodeTime + presentationDuration
            },
            prependedContentDuration: prependedContentDuration,
            baseMediaDecodeTime: baseMediaDecodeTime
        };
    };
    /**
   * Constructs a single-track, ISO BMFF media segment from AAC data
   * events. The output of this stream can be fed to a SourceBuffer
   * configured with a suitable initialization segment.
   * @param track {object} track metadata configuration
   * @param options {object} transmuxer options object
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */ AudioSegmentStream = function(track, options) {
        var adtsFrames = [], sequenceNumber, earliestAllowedDts = 0, audioAppendStartTs = 0, videoBaseMediaDecodeTime = Infinity;
        options = options || {};
        sequenceNumber = options.firstSequenceNumber || 0;
        AudioSegmentStream.prototype.init.call(this);
        this.push = function(data) {
            trackDecodeInfo.collectDtsInfo(track, data);
            if (track) AUDIO_PROPERTIES.forEach(function(prop) {
                track[prop] = data[prop];
            });
             // buffer audio data until end() is called
            adtsFrames.push(data);
        };
        this.setEarliestDts = function(earliestDts) {
            earliestAllowedDts = earliestDts;
        };
        this.setVideoBaseMediaDecodeTime = function(baseMediaDecodeTime) {
            videoBaseMediaDecodeTime = baseMediaDecodeTime;
        };
        this.setAudioAppendStart = function(timestamp) {
            audioAppendStartTs = timestamp;
        };
        this.flush = function() {
            var frames, moof, mdat, boxes, frameDuration, segmentDuration, videoClockCyclesOfSilencePrefixed; // return early if no audio data has been observed
            if (adtsFrames.length === 0) {
                this.trigger('done', 'AudioSegmentStream');
                return;
            }
            frames = audioFrameUtils.trimAdtsFramesByEarliestDts(adtsFrames, track, earliestAllowedDts);
            track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps); // amount of audio filled but the value is in video clock rather than audio clock
            videoClockCyclesOfSilencePrefixed = audioFrameUtils.prefixWithSilence(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime); // we have to build the index from byte locations to
            // samples (that is, adts frames) in the audio data
            track.samples = audioFrameUtils.generateSampleTable(frames); // concatenate the audio data to constuct the mdat
            mdat = mp4.mdat(audioFrameUtils.concatenateFrameData(frames));
            adtsFrames = [];
            moof = mp4.moof(sequenceNumber, [
                track
            ]);
            boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // bump the sequence number for next time
            sequenceNumber++;
            boxes.set(moof);
            boxes.set(mdat, moof.byteLength);
            trackDecodeInfo.clearDtsInfo(track);
            frameDuration = Math.ceil(ONE_SECOND_IN_TS$1 * 1024 / track.samplerate); // TODO this check was added to maintain backwards compatibility (particularly with
            // tests) on adding the timingInfo event. However, it seems unlikely that there's a
            // valid use-case where an init segment/data should be triggered without associated
            // frames. Leaving for now, but should be looked into.
            if (frames.length) {
                segmentDuration = frames.length * frameDuration;
                this.trigger('segmentTimingInfo', generateSegmentTimingInfo(// The audio track's baseMediaDecodeTime is in audio clock cycles, but the
                // frame info is in video clock cycles. Convert to match expectation of
                // listeners (that all timestamps will be based on video clock cycles).
                clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate), // frame times are already in video clock, as is segment duration
                frames[0].dts, frames[0].pts, frames[0].dts + segmentDuration, frames[0].pts + segmentDuration, videoClockCyclesOfSilencePrefixed || 0));
                this.trigger('timingInfo', {
                    start: frames[0].pts,
                    end: frames[0].pts + segmentDuration
                });
            }
            this.trigger('data', {
                track: track,
                boxes: boxes
            });
            this.trigger('done', 'AudioSegmentStream');
        };
        this.reset = function() {
            trackDecodeInfo.clearDtsInfo(track);
            adtsFrames = [];
            this.trigger('reset');
        };
    };
    AudioSegmentStream.prototype = new Stream();
    /**
   * Constructs a single-track, ISO BMFF media segment from H264 data
   * events. The output of this stream can be fed to a SourceBuffer
   * configured with a suitable initialization segment.
   * @param track {object} track metadata configuration
   * @param options {object} transmuxer options object
   * @param options.alignGopsAtEnd {boolean} If true, start from the end of the
   *        gopsToAlignWith list when attempting to align gop pts
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */ VideoSegmentStream = function(track, options) {
        var sequenceNumber, nalUnits = [], gopsToAlignWith = [], config, pps;
        options = options || {};
        sequenceNumber = options.firstSequenceNumber || 0;
        VideoSegmentStream.prototype.init.call(this);
        delete track.minPTS;
        this.gopCache_ = [];
        /**
      * Constructs a ISO BMFF segment given H264 nalUnits
      * @param {Object} nalUnit A data event representing a nalUnit
      * @param {String} nalUnit.nalUnitType
      * @param {Object} nalUnit.config Properties for a mp4 track
      * @param {Uint8Array} nalUnit.data The nalUnit bytes
      * @see lib/codecs/h264.js
     **/ this.push = function(nalUnit) {
            trackDecodeInfo.collectDtsInfo(track, nalUnit); // record the track config
            if (nalUnit.nalUnitType === 'seq_parameter_set_rbsp' && !config) {
                config = nalUnit.config;
                track.sps = [
                    nalUnit.data
                ];
                VIDEO_PROPERTIES.forEach(function(prop) {
                    track[prop] = config[prop];
                }, this);
            }
            if (nalUnit.nalUnitType === 'pic_parameter_set_rbsp' && !pps) {
                pps = nalUnit.data;
                track.pps = [
                    nalUnit.data
                ];
            } // buffer video until flush() is called
            nalUnits.push(nalUnit);
        };
        /**
      * Pass constructed ISO BMFF track and boxes on to the
      * next stream in the pipeline
     **/ this.flush = function() {
            var frames, gopForFusion, gops, moof, mdat, boxes, prependedContentDuration = 0, firstGop, lastGop; // Throw away nalUnits at the start of the byte stream until
            // we find the first AUD
            while(nalUnits.length){
                if (nalUnits[0].nalUnitType === 'access_unit_delimiter_rbsp') break;
                nalUnits.shift();
            } // Return early if no video data has been observed
            if (nalUnits.length === 0) {
                this.resetStream_();
                this.trigger('done', 'VideoSegmentStream');
                return;
            } // Organize the raw nal-units into arrays that represent
            // higher-level constructs such as frames and gops
            // (group-of-pictures)
            frames = frameUtils.groupNalsIntoFrames(nalUnits);
            gops = frameUtils.groupFramesIntoGops(frames); // If the first frame of this fragment is not a keyframe we have
            // a problem since MSE (on Chrome) requires a leading keyframe.
            //
            // We have two approaches to repairing this situation:
            // 1) GOP-FUSION:
            //    This is where we keep track of the GOPS (group-of-pictures)
            //    from previous fragments and attempt to find one that we can
            //    prepend to the current fragment in order to create a valid
            //    fragment.
            // 2) KEYFRAME-PULLING:
            //    Here we search for the first keyframe in the fragment and
            //    throw away all the frames between the start of the fragment
            //    and that keyframe. We then extend the duration and pull the
            //    PTS of the keyframe forward so that it covers the time range
            //    of the frames that were disposed of.
            //
            // #1 is far prefereable over #2 which can cause "stuttering" but
            // requires more things to be just right.
            if (!gops[0][0].keyFrame) {
                // Search for a gop for fusion from our gopCache
                gopForFusion = this.getGopForFusion_(nalUnits[0], track);
                if (gopForFusion) {
                    // in order to provide more accurate timing information about the segment, save
                    // the number of seconds prepended to the original segment due to GOP fusion
                    prependedContentDuration = gopForFusion.duration;
                    gops.unshift(gopForFusion); // Adjust Gops' metadata to account for the inclusion of the
                    // new gop at the beginning
                    gops.byteLength += gopForFusion.byteLength;
                    gops.nalCount += gopForFusion.nalCount;
                    gops.pts = gopForFusion.pts;
                    gops.dts = gopForFusion.dts;
                    gops.duration += gopForFusion.duration;
                } else // If we didn't find a candidate gop fall back to keyframe-pulling
                gops = frameUtils.extendFirstKeyFrame(gops);
            } // Trim gops to align with gopsToAlignWith
            if (gopsToAlignWith.length) {
                var alignedGops;
                if (options.alignGopsAtEnd) alignedGops = this.alignGopsAtEnd_(gops);
                else alignedGops = this.alignGopsAtStart_(gops);
                if (!alignedGops) {
                    // save all the nals in the last GOP into the gop cache
                    this.gopCache_.unshift({
                        gop: gops.pop(),
                        pps: track.pps,
                        sps: track.sps
                    }); // Keep a maximum of 6 GOPs in the cache
                    this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
                    nalUnits = []; // return early no gops can be aligned with desired gopsToAlignWith
                    this.resetStream_();
                    this.trigger('done', 'VideoSegmentStream');
                    return;
                } // Some gops were trimmed. clear dts info so minSegmentDts and pts are correct
                // when recalculated before sending off to CoalesceStream
                trackDecodeInfo.clearDtsInfo(track);
                gops = alignedGops;
            }
            trackDecodeInfo.collectDtsInfo(track, gops); // First, we have to build the index from byte locations to
            // samples (that is, frames) in the video data
            track.samples = frameUtils.generateSampleTable(gops); // Concatenate the video data and construct the mdat
            mdat = mp4.mdat(frameUtils.concatenateNalData(gops));
            track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps);
            this.trigger('processedGopsInfo', gops.map(function(gop) {
                return {
                    pts: gop.pts,
                    dts: gop.dts,
                    byteLength: gop.byteLength
                };
            }));
            firstGop = gops[0];
            lastGop = gops[gops.length - 1];
            this.trigger('segmentTimingInfo', generateSegmentTimingInfo(track.baseMediaDecodeTime, firstGop.dts, firstGop.pts, lastGop.dts + lastGop.duration, lastGop.pts + lastGop.duration, prependedContentDuration));
            this.trigger('timingInfo', {
                start: gops[0].pts,
                end: gops[gops.length - 1].pts + gops[gops.length - 1].duration
            }); // save all the nals in the last GOP into the gop cache
            this.gopCache_.unshift({
                gop: gops.pop(),
                pps: track.pps,
                sps: track.sps
            }); // Keep a maximum of 6 GOPs in the cache
            this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
            nalUnits = [];
            this.trigger('baseMediaDecodeTime', track.baseMediaDecodeTime);
            this.trigger('timelineStartInfo', track.timelineStartInfo);
            moof = mp4.moof(sequenceNumber, [
                track
            ]); // it would be great to allocate this array up front instead of
            // throwing away hundreds of media segment fragments
            boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // Bump the sequence number for next time
            sequenceNumber++;
            boxes.set(moof);
            boxes.set(mdat, moof.byteLength);
            this.trigger('data', {
                track: track,
                boxes: boxes
            });
            this.resetStream_(); // Continue with the flush process now
            this.trigger('done', 'VideoSegmentStream');
        };
        this.reset = function() {
            this.resetStream_();
            nalUnits = [];
            this.gopCache_.length = 0;
            gopsToAlignWith.length = 0;
            this.trigger('reset');
        };
        this.resetStream_ = function() {
            trackDecodeInfo.clearDtsInfo(track); // reset config and pps because they may differ across segments
            // for instance, when we are rendition switching
            config = undefined;
            pps = undefined;
        }; // Search for a candidate Gop for gop-fusion from the gop cache and
        // return it or return null if no good candidate was found
        this.getGopForFusion_ = function(nalUnit) {
            var halfSecond = 45000, // Half-a-second in a 90khz clock
            allowableOverlap = 10000, // About 3 frames @ 30fps
            nearestDistance = Infinity, dtsDistance, nearestGopObj, currentGop, currentGopObj, i; // Search for the GOP nearest to the beginning of this nal unit
            for(i = 0; i < this.gopCache_.length; i++){
                currentGopObj = this.gopCache_[i];
                currentGop = currentGopObj.gop; // Reject Gops with different SPS or PPS
                if (!(track.pps && arrayEquals(track.pps[0], currentGopObj.pps[0])) || !(track.sps && arrayEquals(track.sps[0], currentGopObj.sps[0]))) continue;
                 // Reject Gops that would require a negative baseMediaDecodeTime
                if (currentGop.dts < track.timelineStartInfo.dts) continue;
                 // The distance between the end of the gop and the start of the nalUnit
                dtsDistance = nalUnit.dts - currentGop.dts - currentGop.duration; // Only consider GOPS that start before the nal unit and end within
                // a half-second of the nal unit
                if (dtsDistance >= -allowableOverlap && dtsDistance <= halfSecond) // Always use the closest GOP we found if there is more than
                // one candidate
                {
                    if (!nearestGopObj || nearestDistance > dtsDistance) {
                        nearestGopObj = currentGopObj;
                        nearestDistance = dtsDistance;
                    }
                }
            }
            if (nearestGopObj) return nearestGopObj.gop;
            return null;
        }; // trim gop list to the first gop found that has a matching pts with a gop in the list
        // of gopsToAlignWith starting from the START of the list
        this.alignGopsAtStart_ = function(gops) {
            var alignIndex, gopIndex, align, gop, byteLength, nalCount, duration, alignedGops;
            byteLength = gops.byteLength;
            nalCount = gops.nalCount;
            duration = gops.duration;
            alignIndex = gopIndex = 0;
            while(alignIndex < gopsToAlignWith.length && gopIndex < gops.length){
                align = gopsToAlignWith[alignIndex];
                gop = gops[gopIndex];
                if (align.pts === gop.pts) break;
                if (gop.pts > align.pts) {
                    // this current gop starts after the current gop we want to align on, so increment
                    // align index
                    alignIndex++;
                    continue;
                } // current gop starts before the current gop we want to align on. so increment gop
                // index
                gopIndex++;
                byteLength -= gop.byteLength;
                nalCount -= gop.nalCount;
                duration -= gop.duration;
            }
            if (gopIndex === 0) // no gops to trim
            return gops;
            if (gopIndex === gops.length) // all gops trimmed, skip appending all gops
            return null;
            alignedGops = gops.slice(gopIndex);
            alignedGops.byteLength = byteLength;
            alignedGops.duration = duration;
            alignedGops.nalCount = nalCount;
            alignedGops.pts = alignedGops[0].pts;
            alignedGops.dts = alignedGops[0].dts;
            return alignedGops;
        }; // trim gop list to the first gop found that has a matching pts with a gop in the list
        // of gopsToAlignWith starting from the END of the list
        this.alignGopsAtEnd_ = function(gops) {
            var alignIndex, gopIndex, align, gop, alignEndIndex, matchFound;
            alignIndex = gopsToAlignWith.length - 1;
            gopIndex = gops.length - 1;
            alignEndIndex = null;
            matchFound = false;
            while(alignIndex >= 0 && gopIndex >= 0){
                align = gopsToAlignWith[alignIndex];
                gop = gops[gopIndex];
                if (align.pts === gop.pts) {
                    matchFound = true;
                    break;
                }
                if (align.pts > gop.pts) {
                    alignIndex--;
                    continue;
                }
                if (alignIndex === gopsToAlignWith.length - 1) // gop.pts is greater than the last alignment candidate. If no match is found
                // by the end of this loop, we still want to append gops that come after this
                // point
                alignEndIndex = gopIndex;
                gopIndex--;
            }
            if (!matchFound && alignEndIndex === null) return null;
            var trimIndex;
            if (matchFound) trimIndex = gopIndex;
            else trimIndex = alignEndIndex;
            if (trimIndex === 0) return gops;
            var alignedGops = gops.slice(trimIndex);
            var metadata = alignedGops.reduce(function(total, gop) {
                total.byteLength += gop.byteLength;
                total.duration += gop.duration;
                total.nalCount += gop.nalCount;
                return total;
            }, {
                byteLength: 0,
                duration: 0,
                nalCount: 0
            });
            alignedGops.byteLength = metadata.byteLength;
            alignedGops.duration = metadata.duration;
            alignedGops.nalCount = metadata.nalCount;
            alignedGops.pts = alignedGops[0].pts;
            alignedGops.dts = alignedGops[0].dts;
            return alignedGops;
        };
        this.alignGopsWith = function(newGopsToAlignWith) {
            gopsToAlignWith = newGopsToAlignWith;
        };
    };
    VideoSegmentStream.prototype = new Stream();
    /**
   * A Stream that can combine multiple streams (ie. audio & video)
   * into a single output segment for MSE. Also supports audio-only
   * and video-only streams.
   * @param options {object} transmuxer options object
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at media timeline start.
   */ CoalesceStream = function(options, metadataStream) {
        // Number of Tracks per output segment
        // If greater than 1, we combine multiple
        // tracks into a single segment
        this.numberOfTracks = 0;
        this.metadataStream = metadataStream;
        options = options || {};
        if (typeof options.remux !== 'undefined') this.remuxTracks = !!options.remux;
        else this.remuxTracks = true;
        if (typeof options.keepOriginalTimestamps === 'boolean') this.keepOriginalTimestamps = options.keepOriginalTimestamps;
        else this.keepOriginalTimestamps = false;
        this.pendingTracks = [];
        this.videoTrack = null;
        this.pendingBoxes = [];
        this.pendingCaptions = [];
        this.pendingMetadata = [];
        this.pendingBytes = 0;
        this.emittedTracks = 0;
        CoalesceStream.prototype.init.call(this); // Take output from multiple
        this.push = function(output) {
            // buffer incoming captions until the associated video segment
            // finishes
            if (output.content || output.text) return this.pendingCaptions.push(output);
             // buffer incoming id3 tags until the final flush
            if (output.frames) return this.pendingMetadata.push(output);
             // Add this track to the list of pending tracks and store
            // important information required for the construction of
            // the final segment
            this.pendingTracks.push(output.track);
            this.pendingBytes += output.boxes.byteLength; // TODO: is there an issue for this against chrome?
            // We unshift audio and push video because
            // as of Chrome 75 when switching from
            // one init segment to another if the video
            // mdat does not appear after the audio mdat
            // only audio will play for the duration of our transmux.
            if (output.track.type === 'video') {
                this.videoTrack = output.track;
                this.pendingBoxes.push(output.boxes);
            }
            if (output.track.type === 'audio') {
                this.audioTrack = output.track;
                this.pendingBoxes.unshift(output.boxes);
            }
        };
    };
    CoalesceStream.prototype = new Stream();
    CoalesceStream.prototype.flush = function(flushSource) {
        var offset = 0, event = {
            captions: [],
            captionStreams: {},
            metadata: [],
            info: {}
        }, caption, id3, initSegment, timelineStartPts = 0, i;
        if (this.pendingTracks.length < this.numberOfTracks) {
            if (flushSource !== 'VideoSegmentStream' && flushSource !== 'AudioSegmentStream') // Return because we haven't received a flush from a data-generating
            // portion of the segment (meaning that we have only recieved meta-data
            // or captions.)
            return;
            else if (this.remuxTracks) // Return until we have enough tracks from the pipeline to remux (if we
            // are remuxing audio and video into a single MP4)
            return;
            else if (this.pendingTracks.length === 0) {
                // In the case where we receive a flush without any data having been
                // received we consider it an emitted track for the purposes of coalescing
                // `done` events.
                // We do this for the case where there is an audio and video track in the
                // segment but no audio data. (seen in several playlists with alternate
                // audio tracks and no audio present in the main TS segments.)
                this.emittedTracks++;
                if (this.emittedTracks >= this.numberOfTracks) {
                    this.trigger('done');
                    this.emittedTracks = 0;
                }
                return;
            }
        }
        if (this.videoTrack) {
            timelineStartPts = this.videoTrack.timelineStartInfo.pts;
            VIDEO_PROPERTIES.forEach(function(prop) {
                event.info[prop] = this.videoTrack[prop];
            }, this);
        } else if (this.audioTrack) {
            timelineStartPts = this.audioTrack.timelineStartInfo.pts;
            AUDIO_PROPERTIES.forEach(function(prop) {
                event.info[prop] = this.audioTrack[prop];
            }, this);
        }
        if (this.videoTrack || this.audioTrack) {
            if (this.pendingTracks.length === 1) event.type = this.pendingTracks[0].type;
            else event.type = 'combined';
            this.emittedTracks += this.pendingTracks.length;
            initSegment = mp4.initSegment(this.pendingTracks); // Create a new typed array to hold the init segment
            event.initSegment = new Uint8Array(initSegment.byteLength); // Create an init segment containing a moov
            // and track definitions
            event.initSegment.set(initSegment); // Create a new typed array to hold the moof+mdats
            event.data = new Uint8Array(this.pendingBytes); // Append each moof+mdat (one per track) together
            for(i = 0; i < this.pendingBoxes.length; i++){
                event.data.set(this.pendingBoxes[i], offset);
                offset += this.pendingBoxes[i].byteLength;
            } // Translate caption PTS times into second offsets to match the
            // video timeline for the segment, and add track info
            for(i = 0; i < this.pendingCaptions.length; i++){
                caption = this.pendingCaptions[i];
                caption.startTime = clock.metadataTsToSeconds(caption.startPts, timelineStartPts, this.keepOriginalTimestamps);
                caption.endTime = clock.metadataTsToSeconds(caption.endPts, timelineStartPts, this.keepOriginalTimestamps);
                event.captionStreams[caption.stream] = true;
                event.captions.push(caption);
            } // Translate ID3 frame PTS times into second offsets to match the
            // video timeline for the segment
            for(i = 0; i < this.pendingMetadata.length; i++){
                id3 = this.pendingMetadata[i];
                id3.cueTime = clock.metadataTsToSeconds(id3.pts, timelineStartPts, this.keepOriginalTimestamps);
                event.metadata.push(id3);
            } // We add this to every single emitted segment even though we only need
            // it for the first
            event.metadata.dispatchType = this.metadataStream.dispatchType; // Reset stream state
            this.pendingTracks.length = 0;
            this.videoTrack = null;
            this.pendingBoxes.length = 0;
            this.pendingCaptions.length = 0;
            this.pendingBytes = 0;
            this.pendingMetadata.length = 0; // Emit the built segment
            // We include captions and ID3 tags for backwards compatibility,
            // ideally we should send only video and audio in the data event
            this.trigger('data', event); // Emit each caption to the outside world
            // Ideally, this would happen immediately on parsing captions,
            // but we need to ensure that video data is sent back first
            // so that caption timing can be adjusted to match video timing
            for(i = 0; i < event.captions.length; i++){
                caption = event.captions[i];
                this.trigger('caption', caption);
            } // Emit each id3 tag to the outside world
            // Ideally, this would happen immediately on parsing the tag,
            // but we need to ensure that video data is sent back first
            // so that ID3 frame timing can be adjusted to match video timing
            for(i = 0; i < event.metadata.length; i++){
                id3 = event.metadata[i];
                this.trigger('id3Frame', id3);
            }
        } // Only emit `done` if all tracks have been flushed and emitted
        if (this.emittedTracks >= this.numberOfTracks) {
            this.trigger('done');
            this.emittedTracks = 0;
        }
    };
    CoalesceStream.prototype.setRemux = function(val) {
        this.remuxTracks = val;
    };
    /**
   * A Stream that expects MP2T binary data as input and produces
   * corresponding media segments, suitable for use with Media Source
   * Extension (MSE) implementations that support the ISO BMFF byte
   * stream format, like Chrome.
   */ Transmuxer = function(options) {
        var self1 = this, hasFlushed = true, videoTrack, audioTrack;
        Transmuxer.prototype.init.call(this);
        options = options || {};
        this.baseMediaDecodeTime = options.baseMediaDecodeTime || 0;
        this.transmuxPipeline_ = {};
        this.setupAacPipeline = function() {
            var pipeline = {};
            this.transmuxPipeline_ = pipeline;
            pipeline.type = 'aac';
            pipeline.metadataStream = new m2ts.MetadataStream(); // set up the parsing pipeline
            pipeline.aacStream = new AacStream();
            pipeline.audioTimestampRolloverStream = new m2ts.TimestampRolloverStream('audio');
            pipeline.timedMetadataTimestampRolloverStream = new m2ts.TimestampRolloverStream('timed-metadata');
            pipeline.adtsStream = new AdtsStream();
            pipeline.coalesceStream = new CoalesceStream(options, pipeline.metadataStream);
            pipeline.headOfPipeline = pipeline.aacStream;
            pipeline.aacStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);
            pipeline.aacStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
            pipeline.metadataStream.on('timestamp', function(frame) {
                pipeline.aacStream.setTimestamp(frame.timeStamp);
            });
            pipeline.aacStream.on('data', function(data) {
                if (data.type !== 'timed-metadata' && data.type !== 'audio' || pipeline.audioSegmentStream) return;
                audioTrack = audioTrack || {
                    timelineStartInfo: {
                        baseMediaDecodeTime: self1.baseMediaDecodeTime
                    },
                    codec: 'adts',
                    type: 'audio'
                }; // hook up the audio segment stream to the first track with aac data
                pipeline.coalesceStream.numberOfTracks++;
                pipeline.audioSegmentStream = new AudioSegmentStream(audioTrack, options);
                pipeline.audioSegmentStream.on('log', self1.getLogTrigger_('audioSegmentStream'));
                pipeline.audioSegmentStream.on('timingInfo', self1.trigger.bind(self1, 'audioTimingInfo')); // Set up the final part of the audio pipeline
                pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream); // emit pmt info
                self1.trigger('trackinfo', {
                    hasAudio: !!audioTrack,
                    hasVideo: !!videoTrack
                });
            }); // Re-emit any data coming from the coalesce stream to the outside world
            pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data')); // Let the consumer know we have finished flushing the entire pipeline
            pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
            addPipelineLogRetriggers(this, pipeline);
        };
        this.setupTsPipeline = function() {
            var pipeline = {};
            this.transmuxPipeline_ = pipeline;
            pipeline.type = 'ts';
            pipeline.metadataStream = new m2ts.MetadataStream(); // set up the parsing pipeline
            pipeline.packetStream = new m2ts.TransportPacketStream();
            pipeline.parseStream = new m2ts.TransportParseStream();
            pipeline.elementaryStream = new m2ts.ElementaryStream();
            pipeline.timestampRolloverStream = new m2ts.TimestampRolloverStream();
            pipeline.adtsStream = new AdtsStream();
            pipeline.h264Stream = new H264Stream();
            pipeline.captionStream = new m2ts.CaptionStream(options);
            pipeline.coalesceStream = new CoalesceStream(options, pipeline.metadataStream);
            pipeline.headOfPipeline = pipeline.packetStream; // disassemble MPEG2-TS packets into elementary streams
            pipeline.packetStream.pipe(pipeline.parseStream).pipe(pipeline.elementaryStream).pipe(pipeline.timestampRolloverStream); // !!THIS ORDER IS IMPORTANT!!
            // demux the streams
            pipeline.timestampRolloverStream.pipe(pipeline.h264Stream);
            pipeline.timestampRolloverStream.pipe(pipeline.adtsStream);
            pipeline.timestampRolloverStream.pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream); // Hook up CEA-608/708 caption stream
            pipeline.h264Stream.pipe(pipeline.captionStream).pipe(pipeline.coalesceStream);
            pipeline.elementaryStream.on('data', function(data) {
                var i;
                if (data.type === 'metadata') {
                    i = data.tracks.length; // scan the tracks listed in the metadata
                    while(i--){
                        if (!videoTrack && data.tracks[i].type === 'video') {
                            videoTrack = data.tracks[i];
                            videoTrack.timelineStartInfo.baseMediaDecodeTime = self1.baseMediaDecodeTime;
                        } else if (!audioTrack && data.tracks[i].type === 'audio') {
                            audioTrack = data.tracks[i];
                            audioTrack.timelineStartInfo.baseMediaDecodeTime = self1.baseMediaDecodeTime;
                        }
                    } // hook up the video segment stream to the first track with h264 data
                    if (videoTrack && !pipeline.videoSegmentStream) {
                        pipeline.coalesceStream.numberOfTracks++;
                        pipeline.videoSegmentStream = new VideoSegmentStream(videoTrack, options);
                        pipeline.videoSegmentStream.on('log', self1.getLogTrigger_('videoSegmentStream'));
                        pipeline.videoSegmentStream.on('timelineStartInfo', function(timelineStartInfo) {
                            // When video emits timelineStartInfo data after a flush, we forward that
                            // info to the AudioSegmentStream, if it exists, because video timeline
                            // data takes precedence.  Do not do this if keepOriginalTimestamps is set,
                            // because this is a particularly subtle form of timestamp alteration.
                            if (audioTrack && !options.keepOriginalTimestamps) {
                                audioTrack.timelineStartInfo = timelineStartInfo; // On the first segment we trim AAC frames that exist before the
                                // very earliest DTS we have seen in video because Chrome will
                                // interpret any video track with a baseMediaDecodeTime that is
                                // non-zero as a gap.
                                pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts - self1.baseMediaDecodeTime);
                            }
                        });
                        pipeline.videoSegmentStream.on('processedGopsInfo', self1.trigger.bind(self1, 'gopInfo'));
                        pipeline.videoSegmentStream.on('segmentTimingInfo', self1.trigger.bind(self1, 'videoSegmentTimingInfo'));
                        pipeline.videoSegmentStream.on('baseMediaDecodeTime', function(baseMediaDecodeTime) {
                            if (audioTrack) pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);
                        });
                        pipeline.videoSegmentStream.on('timingInfo', self1.trigger.bind(self1, 'videoTimingInfo')); // Set up the final part of the video pipeline
                        pipeline.h264Stream.pipe(pipeline.videoSegmentStream).pipe(pipeline.coalesceStream);
                    }
                    if (audioTrack && !pipeline.audioSegmentStream) {
                        // hook up the audio segment stream to the first track with aac data
                        pipeline.coalesceStream.numberOfTracks++;
                        pipeline.audioSegmentStream = new AudioSegmentStream(audioTrack, options);
                        pipeline.audioSegmentStream.on('log', self1.getLogTrigger_('audioSegmentStream'));
                        pipeline.audioSegmentStream.on('timingInfo', self1.trigger.bind(self1, 'audioTimingInfo'));
                        pipeline.audioSegmentStream.on('segmentTimingInfo', self1.trigger.bind(self1, 'audioSegmentTimingInfo')); // Set up the final part of the audio pipeline
                        pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
                    } // emit pmt info
                    self1.trigger('trackinfo', {
                        hasAudio: !!audioTrack,
                        hasVideo: !!videoTrack
                    });
                }
            }); // Re-emit any data coming from the coalesce stream to the outside world
            pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data'));
            pipeline.coalesceStream.on('id3Frame', function(id3Frame) {
                id3Frame.dispatchType = pipeline.metadataStream.dispatchType;
                self1.trigger('id3Frame', id3Frame);
            });
            pipeline.coalesceStream.on('caption', this.trigger.bind(this, 'caption')); // Let the consumer know we have finished flushing the entire pipeline
            pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
            addPipelineLogRetriggers(this, pipeline);
        }; // hook up the segment streams once track metadata is delivered
        this.setBaseMediaDecodeTime = function(baseMediaDecodeTime) {
            var pipeline = this.transmuxPipeline_;
            if (!options.keepOriginalTimestamps) this.baseMediaDecodeTime = baseMediaDecodeTime;
            if (audioTrack) {
                audioTrack.timelineStartInfo.dts = undefined;
                audioTrack.timelineStartInfo.pts = undefined;
                trackDecodeInfo.clearDtsInfo(audioTrack);
                if (pipeline.audioTimestampRolloverStream) pipeline.audioTimestampRolloverStream.discontinuity();
            }
            if (videoTrack) {
                if (pipeline.videoSegmentStream) pipeline.videoSegmentStream.gopCache_ = [];
                videoTrack.timelineStartInfo.dts = undefined;
                videoTrack.timelineStartInfo.pts = undefined;
                trackDecodeInfo.clearDtsInfo(videoTrack);
                pipeline.captionStream.reset();
            }
            if (pipeline.timestampRolloverStream) pipeline.timestampRolloverStream.discontinuity();
        };
        this.setAudioAppendStart = function(timestamp) {
            if (audioTrack) this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);
        };
        this.setRemux = function(val) {
            var pipeline = this.transmuxPipeline_;
            options.remux = val;
            if (pipeline && pipeline.coalesceStream) pipeline.coalesceStream.setRemux(val);
        };
        this.alignGopsWith = function(gopsToAlignWith) {
            if (videoTrack && this.transmuxPipeline_.videoSegmentStream) this.transmuxPipeline_.videoSegmentStream.alignGopsWith(gopsToAlignWith);
        };
        this.getLogTrigger_ = function(key) {
            var self1 = this;
            return function(event) {
                event.stream = key;
                self1.trigger('log', event);
            };
        }; // feed incoming data to the front of the parsing pipeline
        this.push = function(data) {
            if (hasFlushed) {
                var isAac = isLikelyAacData(data);
                if (isAac && this.transmuxPipeline_.type !== 'aac') this.setupAacPipeline();
                else if (!isAac && this.transmuxPipeline_.type !== 'ts') this.setupTsPipeline();
                hasFlushed = false;
            }
            this.transmuxPipeline_.headOfPipeline.push(data);
        }; // flush any buffered data
        this.flush = function() {
            hasFlushed = true; // Start at the top of the pipeline and flush all pending work
            this.transmuxPipeline_.headOfPipeline.flush();
        };
        this.endTimeline = function() {
            this.transmuxPipeline_.headOfPipeline.endTimeline();
        };
        this.reset = function() {
            if (this.transmuxPipeline_.headOfPipeline) this.transmuxPipeline_.headOfPipeline.reset();
        }; // Caption data has to be reset when seeking outside buffered range
        this.resetCaptions = function() {
            if (this.transmuxPipeline_.captionStream) this.transmuxPipeline_.captionStream.reset();
        };
    };
    Transmuxer.prototype = new Stream();
    var transmuxer = {
        Transmuxer: Transmuxer,
        VideoSegmentStream: VideoSegmentStream,
        AudioSegmentStream: AudioSegmentStream,
        AUDIO_PROPERTIES: AUDIO_PROPERTIES,
        VIDEO_PROPERTIES: VIDEO_PROPERTIES,
        // exported for testing
        generateSegmentTimingInfo: generateSegmentTimingInfo
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var toUnsigned$3 = function(value) {
        return value >>> 0;
    };
    var toHexString$1 = function(value) {
        return ('00' + value.toString(16)).slice(-2);
    };
    var bin = {
        toUnsigned: toUnsigned$3,
        toHexString: toHexString$1
    };
    var parseType$4 = function(buffer) {
        var result = '';
        result += String.fromCharCode(buffer[0]);
        result += String.fromCharCode(buffer[1]);
        result += String.fromCharCode(buffer[2]);
        result += String.fromCharCode(buffer[3]);
        return result;
    };
    var parseType_1 = parseType$4;
    var toUnsigned$2 = bin.toUnsigned;
    var parseType$3 = parseType_1;
    var findBox$5 = function(data, path) {
        var results = [], i, size, type, end, subresults;
        if (!path.length) // short-circuit the search for empty paths
        return null;
        for(i = 0; i < data.byteLength;){
            size = toUnsigned$2(data[i] << 24 | data[i + 1] << 16 | data[i + 2] << 8 | data[i + 3]);
            type = parseType$3(data.subarray(i + 4, i + 8));
            end = size > 1 ? i + size : data.byteLength;
            if (type === path[0]) {
                if (path.length === 1) // this is the end of the path and we've found the box we were
                // looking for
                results.push(data.subarray(i + 8, end));
                else {
                    // recursively search for the next box along the path
                    subresults = findBox$5(data.subarray(i + 8, end), path.slice(1));
                    if (subresults.length) results = results.concat(subresults);
                }
            }
            i = end;
        } // we've finished searching all of data
        return results;
    };
    var findBox_1 = findBox$5;
    var toUnsigned$1 = bin.toUnsigned;
    var getUint64$4 = numbers.getUint64;
    var tfdt = function(data) {
        var result = {
            version: data[0],
            flags: new Uint8Array(data.subarray(1, 4))
        };
        if (result.version === 1) result.baseMediaDecodeTime = getUint64$4(data.subarray(4));
        else result.baseMediaDecodeTime = toUnsigned$1(data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]);
        return result;
    };
    var parseTfdt$3 = tfdt;
    var tfhd = function(data) {
        var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
            version: data[0],
            flags: new Uint8Array(data.subarray(1, 4)),
            trackId: view.getUint32(4)
        }, baseDataOffsetPresent = result.flags[2] & 0x01, sampleDescriptionIndexPresent = result.flags[2] & 0x02, defaultSampleDurationPresent = result.flags[2] & 0x08, defaultSampleSizePresent = result.flags[2] & 0x10, defaultSampleFlagsPresent = result.flags[2] & 0x20, durationIsEmpty = result.flags[0] & 0x010000, defaultBaseIsMoof = result.flags[0] & 0x020000, i;
        i = 8;
        if (baseDataOffsetPresent) {
            i += 4; // truncate top 4 bytes
            // FIXME: should we read the full 64 bits?
            result.baseDataOffset = view.getUint32(12);
            i += 4;
        }
        if (sampleDescriptionIndexPresent) {
            result.sampleDescriptionIndex = view.getUint32(i);
            i += 4;
        }
        if (defaultSampleDurationPresent) {
            result.defaultSampleDuration = view.getUint32(i);
            i += 4;
        }
        if (defaultSampleSizePresent) {
            result.defaultSampleSize = view.getUint32(i);
            i += 4;
        }
        if (defaultSampleFlagsPresent) result.defaultSampleFlags = view.getUint32(i);
        if (durationIsEmpty) result.durationIsEmpty = true;
        if (!baseDataOffsetPresent && defaultBaseIsMoof) result.baseDataOffsetIsMoof = true;
        return result;
    };
    var parseTfhd$2 = tfhd;
    var getUint64$3 = numbers.getUint64;
    var parseSidx = function(data) {
        var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
            version: data[0],
            flags: new Uint8Array(data.subarray(1, 4)),
            references: [],
            referenceId: view.getUint32(4),
            timescale: view.getUint32(8)
        }, i = 12;
        if (result.version === 0) {
            result.earliestPresentationTime = view.getUint32(i);
            result.firstOffset = view.getUint32(i + 4);
            i += 8;
        } else {
            // read 64 bits
            result.earliestPresentationTime = getUint64$3(data.subarray(i));
            result.firstOffset = getUint64$3(data.subarray(i + 8));
            i += 16;
        }
        i += 2; // reserved
        var referenceCount = view.getUint16(i);
        i += 2; // start of references
        for(; referenceCount > 0; i += 12, referenceCount--)result.references.push({
            referenceType: (data[i] & 0x80) >>> 7,
            referencedSize: view.getUint32(i) & 0x7FFFFFFF,
            subsegmentDuration: view.getUint32(i + 4),
            startsWithSap: !!(data[i + 8] & 0x80),
            sapType: (data[i + 8] & 0x70) >>> 4,
            sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
        });
        return result;
    };
    var parseSidx_1 = parseSidx;
    var parseSampleFlags$1 = function(flags) {
        return {
            isLeading: (flags[0] & 0x0c) >>> 2,
            dependsOn: flags[0] & 0x03,
            isDependedOn: (flags[1] & 0xc0) >>> 6,
            hasRedundancy: (flags[1] & 0x30) >>> 4,
            paddingValue: (flags[1] & 0x0e) >>> 1,
            isNonSyncSample: flags[1] & 0x01,
            degradationPriority: flags[2] << 8 | flags[3]
        };
    };
    var parseSampleFlags_1 = parseSampleFlags$1;
    var parseSampleFlags = parseSampleFlags_1;
    var trun = function(data) {
        var result = {
            version: data[0],
            flags: new Uint8Array(data.subarray(1, 4)),
            samples: []
        }, view = new DataView(data.buffer, data.byteOffset, data.byteLength), // Flag interpretation
        dataOffsetPresent = result.flags[2] & 0x01, // compare with 2nd byte of 0x1
        firstSampleFlagsPresent = result.flags[2] & 0x04, // compare with 2nd byte of 0x4
        sampleDurationPresent = result.flags[1] & 0x01, // compare with 2nd byte of 0x100
        sampleSizePresent = result.flags[1] & 0x02, // compare with 2nd byte of 0x200
        sampleFlagsPresent = result.flags[1] & 0x04, // compare with 2nd byte of 0x400
        sampleCompositionTimeOffsetPresent = result.flags[1] & 0x08, // compare with 2nd byte of 0x800
        sampleCount = view.getUint32(4), offset = 8, sample;
        if (dataOffsetPresent) {
            // 32 bit signed integer
            result.dataOffset = view.getInt32(offset);
            offset += 4;
        } // Overrides the flags for the first sample only. The order of
        // optional values will be: duration, size, compositionTimeOffset
        if (firstSampleFlagsPresent && sampleCount) {
            sample = {
                flags: parseSampleFlags(data.subarray(offset, offset + 4))
            };
            offset += 4;
            if (sampleDurationPresent) {
                sample.duration = view.getUint32(offset);
                offset += 4;
            }
            if (sampleSizePresent) {
                sample.size = view.getUint32(offset);
                offset += 4;
            }
            if (sampleCompositionTimeOffsetPresent) {
                if (result.version === 1) sample.compositionTimeOffset = view.getInt32(offset);
                else sample.compositionTimeOffset = view.getUint32(offset);
                offset += 4;
            }
            result.samples.push(sample);
            sampleCount--;
        }
        while(sampleCount--){
            sample = {};
            if (sampleDurationPresent) {
                sample.duration = view.getUint32(offset);
                offset += 4;
            }
            if (sampleSizePresent) {
                sample.size = view.getUint32(offset);
                offset += 4;
            }
            if (sampleFlagsPresent) {
                sample.flags = parseSampleFlags(data.subarray(offset, offset + 4));
                offset += 4;
            }
            if (sampleCompositionTimeOffsetPresent) {
                if (result.version === 1) sample.compositionTimeOffset = view.getInt32(offset);
                else sample.compositionTimeOffset = view.getUint32(offset);
                offset += 4;
            }
            result.samples.push(sample);
        }
        return result;
    };
    var parseTrun$2 = trun;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Parse the internal MP4 structure into an equivalent javascript
   * object.
   */ var numberHelpers = numbers;
    var getUint64$2 = numberHelpers.getUint64;
    var inspectMp4, textifyMp4, parseMp4Date = function(seconds) {
        return new Date(seconds * 1000 - 2082844800000);
    }, parseType$2 = parseType_1, findBox$4 = findBox_1, nalParse = function(avcStream) {
        var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength), result = [], i, length;
        for(i = 0; i + 4 < avcStream.length; i += length){
            length = avcView.getUint32(i);
            i += 4; // bail if this doesn't appear to be an H264 stream
            if (length <= 0) {
                result.push('<span style=\'color:red;\'>MALFORMED DATA</span>');
                continue;
            }
            switch(avcStream[i] & 0x1F){
                case 0x01:
                    result.push('slice_layer_without_partitioning_rbsp');
                    break;
                case 0x05:
                    result.push('slice_layer_without_partitioning_rbsp_idr');
                    break;
                case 0x06:
                    result.push('sei_rbsp');
                    break;
                case 0x07:
                    result.push('seq_parameter_set_rbsp');
                    break;
                case 0x08:
                    result.push('pic_parameter_set_rbsp');
                    break;
                case 0x09:
                    result.push('access_unit_delimiter_rbsp');
                    break;
                default:
                    result.push('UNKNOWN NAL - ' + avcStream[i] & 0x1F);
                    break;
            }
        }
        return result;
    }, // registry of handlers for individual mp4 box types
    parse = {
        // codingname, not a first-class box type. stsd entries share the
        // same format as real boxes so the parsing infrastructure can be
        // shared
        avc1: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
            return {
                dataReferenceIndex: view.getUint16(6),
                width: view.getUint16(24),
                height: view.getUint16(26),
                horizresolution: view.getUint16(28) + view.getUint16(30) / 16,
                vertresolution: view.getUint16(32) + view.getUint16(34) / 16,
                frameCount: view.getUint16(40),
                depth: view.getUint16(74),
                config: inspectMp4(data.subarray(78, data.byteLength))
            };
        },
        avcC: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                configurationVersion: data[0],
                avcProfileIndication: data[1],
                profileCompatibility: data[2],
                avcLevelIndication: data[3],
                lengthSizeMinusOne: data[4] & 0x03,
                sps: [],
                pps: []
            }, numOfSequenceParameterSets = data[5] & 0x1f, numOfPictureParameterSets, nalSize, offset, i; // iterate past any SPSs
            offset = 6;
            for(i = 0; i < numOfSequenceParameterSets; i++){
                nalSize = view.getUint16(offset);
                offset += 2;
                result.sps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));
                offset += nalSize;
            } // iterate past any PPSs
            numOfPictureParameterSets = data[offset];
            offset++;
            for(i = 0; i < numOfPictureParameterSets; i++){
                nalSize = view.getUint16(offset);
                offset += 2;
                result.pps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));
                offset += nalSize;
            }
            return result;
        },
        btrt: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
            return {
                bufferSizeDB: view.getUint32(0),
                maxBitrate: view.getUint32(4),
                avgBitrate: view.getUint32(8)
            };
        },
        edts: function edts(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        elst: function elst(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                edits: []
            }, entryCount = view.getUint32(4), i;
            for(i = 8; entryCount; entryCount--)if (result.version === 0) {
                result.edits.push({
                    segmentDuration: view.getUint32(i),
                    mediaTime: view.getInt32(i + 4),
                    mediaRate: view.getUint16(i + 8) + view.getUint16(i + 10) / 65536
                });
                i += 12;
            } else {
                result.edits.push({
                    segmentDuration: getUint64$2(data.subarray(i)),
                    mediaTime: getUint64$2(data.subarray(i + 8)),
                    mediaRate: view.getUint16(i + 16) + view.getUint16(i + 18) / 65536
                });
                i += 20;
            }
            return result;
        },
        esds: function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                esId: data[6] << 8 | data[7],
                streamPriority: data[8] & 0x1f,
                decoderConfig: {
                    objectProfileIndication: data[11],
                    streamType: data[12] >>> 2 & 0x3f,
                    bufferSize: data[13] << 16 | data[14] << 8 | data[15],
                    maxBitrate: data[16] << 24 | data[17] << 16 | data[18] << 8 | data[19],
                    avgBitrate: data[20] << 24 | data[21] << 16 | data[22] << 8 | data[23],
                    decoderConfigDescriptor: {
                        tag: data[24],
                        length: data[25],
                        audioObjectType: data[26] >>> 3 & 0x1f,
                        samplingFrequencyIndex: (data[26] & 0x07) << 1 | data[27] >>> 7 & 0x01,
                        channelConfiguration: data[27] >>> 3 & 0x0f
                    }
                }
            };
        },
        ftyp: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                majorBrand: parseType$2(data.subarray(0, 4)),
                minorVersion: view.getUint32(4),
                compatibleBrands: []
            }, i = 8;
            while(i < data.byteLength){
                result.compatibleBrands.push(parseType$2(data.subarray(i, i + 4)));
                i += 4;
            }
            return result;
        },
        dinf: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        dref: function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                dataReferences: inspectMp4(data.subarray(8))
            };
        },
        hdlr: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                handlerType: parseType$2(data.subarray(8, 12)),
                name: ''
            }, i = 8; // parse out the name field
            for(i = 24; i < data.byteLength; i++){
                if (data[i] === 0x00) {
                    // the name field is null-terminated
                    i++;
                    break;
                }
                result.name += String.fromCharCode(data[i]);
            } // decode UTF-8 to javascript's internal representation
            // see http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html
            result.name = decodeURIComponent(escape(result.name));
            return result;
        },
        mdat: function(data) {
            return {
                byteLength: data.byteLength,
                nals: nalParse(data)
            };
        },
        mdhd: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), i = 4, language, result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                language: ''
            };
            if (result.version === 1) {
                i += 4;
                result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 8;
                result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 4;
                result.timescale = view.getUint32(i);
                i += 8;
                result.duration = view.getUint32(i); // truncating top 4 bytes
            } else {
                result.creationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.modificationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.timescale = view.getUint32(i);
                i += 4;
                result.duration = view.getUint32(i);
            }
            i += 4; // language is stored as an ISO-639-2/T code in an array of three 5-bit fields
            // each field is the packed difference between its ASCII value and 0x60
            language = view.getUint16(i);
            result.language += String.fromCharCode((language >> 10) + 0x60);
            result.language += String.fromCharCode(((language & 0x03e0) >> 5) + 0x60);
            result.language += String.fromCharCode((language & 0x1f) + 0x60);
            return result;
        },
        mdia: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        mfhd: function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                sequenceNumber: data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]
            };
        },
        minf: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        // codingname, not a first-class box type. stsd entries share the
        // same format as real boxes so the parsing infrastructure can be
        // shared
        mp4a: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                // 6 bytes reserved
                dataReferenceIndex: view.getUint16(6),
                // 4 + 4 bytes reserved
                channelcount: view.getUint16(16),
                samplesize: view.getUint16(18),
                // 2 bytes pre_defined
                // 2 bytes reserved
                samplerate: view.getUint16(24) + view.getUint16(26) / 65536
            }; // if there are more bytes to process, assume this is an ISO/IEC
            // 14496-14 MP4AudioSampleEntry and parse the ESDBox
            if (data.byteLength > 28) result.streamDescriptor = inspectMp4(data.subarray(28))[0];
            return result;
        },
        moof: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        moov: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        mvex: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        mvhd: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), i = 4, result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4))
            };
            if (result.version === 1) {
                i += 4;
                result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 8;
                result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 4;
                result.timescale = view.getUint32(i);
                i += 8;
                result.duration = view.getUint32(i); // truncating top 4 bytes
            } else {
                result.creationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.modificationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.timescale = view.getUint32(i);
                i += 4;
                result.duration = view.getUint32(i);
            }
            i += 4; // convert fixed-point, base 16 back to a number
            result.rate = view.getUint16(i) + view.getUint16(i + 2) / 16;
            i += 4;
            result.volume = view.getUint8(i) + view.getUint8(i + 1) / 8;
            i += 2;
            i += 2;
            i += 8;
            result.matrix = new Uint32Array(data.subarray(i, i + 36));
            i += 36;
            i += 24;
            result.nextTrackId = view.getUint32(i);
            return result;
        },
        pdin: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
            return {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                rate: view.getUint32(4),
                initialDelay: view.getUint32(8)
            };
        },
        sdtp: function(data) {
            var result = {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                samples: []
            }, i;
            for(i = 4; i < data.byteLength; i++)result.samples.push({
                dependsOn: (data[i] & 0x30) >> 4,
                isDependedOn: (data[i] & 0x0c) >> 2,
                hasRedundancy: data[i] & 0x03
            });
            return result;
        },
        sidx: parseSidx_1,
        smhd: function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                balance: data[4] + data[5] / 256
            };
        },
        stbl: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        ctts: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                compositionOffsets: []
            }, entryCount = view.getUint32(4), i;
            for(i = 8; entryCount; i += 8, entryCount--)result.compositionOffsets.push({
                sampleCount: view.getUint32(i),
                sampleOffset: view[result.version === 0 ? 'getUint32' : 'getInt32'](i + 4)
            });
            return result;
        },
        stss: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4)),
                syncSamples: []
            }, entryCount = view.getUint32(4), i;
            for(i = 8; entryCount; i += 4, entryCount--)result.syncSamples.push(view.getUint32(i));
            return result;
        },
        stco: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                chunkOffsets: []
            }, entryCount = view.getUint32(4), i;
            for(i = 8; entryCount; i += 4, entryCount--)result.chunkOffsets.push(view.getUint32(i));
            return result;
        },
        stsc: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), entryCount = view.getUint32(4), result = {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                sampleToChunks: []
            }, i;
            for(i = 8; entryCount; i += 12, entryCount--)result.sampleToChunks.push({
                firstChunk: view.getUint32(i),
                samplesPerChunk: view.getUint32(i + 4),
                sampleDescriptionIndex: view.getUint32(i + 8)
            });
            return result;
        },
        stsd: function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                sampleDescriptions: inspectMp4(data.subarray(8))
            };
        },
        stsz: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                sampleSize: view.getUint32(4),
                entries: []
            }, i;
            for(i = 12; i < data.byteLength; i += 4)result.entries.push(view.getUint32(i));
            return result;
        },
        stts: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                timeToSamples: []
            }, entryCount = view.getUint32(4), i;
            for(i = 8; entryCount; i += 8, entryCount--)result.timeToSamples.push({
                sampleCount: view.getUint32(i),
                sampleDelta: view.getUint32(i + 4)
            });
            return result;
        },
        styp: function(data) {
            return parse.ftyp(data);
        },
        tfdt: parseTfdt$3,
        tfhd: parseTfhd$2,
        tkhd: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength), i = 4, result = {
                version: view.getUint8(0),
                flags: new Uint8Array(data.subarray(1, 4))
            };
            if (result.version === 1) {
                i += 4;
                result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 8;
                result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
                i += 4;
                result.trackId = view.getUint32(i);
                i += 4;
                i += 8;
                result.duration = view.getUint32(i); // truncating top 4 bytes
            } else {
                result.creationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.modificationTime = parseMp4Date(view.getUint32(i));
                i += 4;
                result.trackId = view.getUint32(i);
                i += 4;
                i += 4;
                result.duration = view.getUint32(i);
            }
            i += 4;
            i += 8;
            result.layer = view.getUint16(i);
            i += 2;
            result.alternateGroup = view.getUint16(i);
            i += 2; // convert fixed-point, base 16 back to a number
            result.volume = view.getUint8(i) + view.getUint8(i + 1) / 8;
            i += 2;
            i += 2;
            result.matrix = new Uint32Array(data.subarray(i, i + 36));
            i += 36;
            result.width = view.getUint16(i) + view.getUint16(i + 2) / 65536;
            i += 4;
            result.height = view.getUint16(i) + view.getUint16(i + 2) / 65536;
            return result;
        },
        traf: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        trak: function(data) {
            return {
                boxes: inspectMp4(data)
            };
        },
        trex: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                trackId: view.getUint32(4),
                defaultSampleDescriptionIndex: view.getUint32(8),
                defaultSampleDuration: view.getUint32(12),
                defaultSampleSize: view.getUint32(16),
                sampleDependsOn: data[20] & 0x03,
                sampleIsDependedOn: (data[21] & 0xc0) >> 6,
                sampleHasRedundancy: (data[21] & 0x30) >> 4,
                samplePaddingValue: (data[21] & 0x0e) >> 1,
                sampleIsDifferenceSample: !!(data[21] & 0x01),
                sampleDegradationPriority: view.getUint16(22)
            };
        },
        trun: parseTrun$2,
        'url ': function(data) {
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4))
            };
        },
        vmhd: function(data) {
            var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
            return {
                version: data[0],
                flags: new Uint8Array(data.subarray(1, 4)),
                graphicsmode: view.getUint16(4),
                opcolor: new Uint16Array([
                    view.getUint16(6),
                    view.getUint16(8),
                    view.getUint16(10)
                ])
            };
        }
    };
    /**
   * Return a javascript array of box objects parsed from an ISO base
   * media file.
   * @param data {Uint8Array} the binary data of the media to be inspected
   * @return {array} a javascript array of potentially nested box objects
   */ inspectMp4 = function(data) {
        var i = 0, result = [], view, size, type, end, box; // Convert data from Uint8Array to ArrayBuffer, to follow Dataview API
        var ab = new ArrayBuffer(data.length);
        var v = new Uint8Array(ab);
        for(var z = 0; z < data.length; ++z)v[z] = data[z];
        view = new DataView(ab);
        while(i < data.byteLength){
            // parse box data
            size = view.getUint32(i);
            type = parseType$2(data.subarray(i + 4, i + 8));
            end = size > 1 ? i + size : data.byteLength; // parse type-specific data
            box = (parse[type] || function(data) {
                return {
                    data: data
                };
            })(data.subarray(i + 8, end));
            box.size = size;
            box.type = type; // store this box and move to the next
            result.push(box);
            i = end;
        }
        return result;
    };
    /**
   * Returns a textual representation of the javascript represtentation
   * of an MP4 file. You can use it as an alternative to
   * JSON.stringify() to compare inspected MP4s.
   * @param inspectedMp4 {array} the parsed array of boxes in an MP4
   * file
   * @param depth {number} (optional) the number of ancestor boxes of
   * the elements of inspectedMp4. Assumed to be zero if unspecified.
   * @return {string} a text representation of the parsed MP4
   */ textifyMp4 = function(inspectedMp4, depth) {
        var indent;
        depth = depth || 0;
        indent = new Array(depth * 2 + 1).join(' '); // iterate over all the boxes
        return inspectedMp4.map(function(box, index) {
            // list the box type first at the current indentation level
            return indent + box.type + '\n' + // the type is already included and handle child boxes separately
            Object.keys(box).filter(function(key) {
                return key !== 'type' && key !== 'boxes'; // output all the box properties
            }).map(function(key) {
                var prefix = indent + '  ' + key + ': ', value = box[key]; // print out raw bytes as hexademical
                if (value instanceof Uint8Array || value instanceof Uint32Array) {
                    var bytes = Array.prototype.slice.call(new Uint8Array(value.buffer, value.byteOffset, value.byteLength)).map(function(byte) {
                        return ' ' + ('00' + byte.toString(16)).slice(-2);
                    }).join('').match(/.{1,24}/g);
                    if (!bytes) return prefix + '<>';
                    if (bytes.length === 1) return prefix + '<' + bytes.join('').slice(1) + '>';
                    return prefix + '<\n' + bytes.map(function(line) {
                        return indent + '  ' + line;
                    }).join('\n') + '\n' + indent + '  >';
                } // stringify generic objects
                return prefix + JSON.stringify(value, null, 2).split('\n').map(function(line, index) {
                    if (index === 0) return line;
                    return indent + '  ' + line;
                }).join('\n');
            }).join('\n') + // recursively textify the child boxes
            (box.boxes ? '\n' + textifyMp4(box.boxes, depth + 1) : '');
        }).join('\n');
    };
    var mp4Inspector = {
        inspect: inspectMp4,
        textify: textifyMp4,
        parseType: parseType$2,
        findBox: findBox$4,
        parseTraf: parse.traf,
        parseTfdt: parse.tfdt,
        parseHdlr: parse.hdlr,
        parseTfhd: parse.tfhd,
        parseTrun: parse.trun,
        parseSidx: parse.sidx
    };
    /**
   * Returns the first string in the data array ending with a null char '\0'
   * @param {UInt8} data 
   * @returns the string with the null char
   */ var uint8ToCString$1 = function(data) {
        var index = 0;
        var curChar = String.fromCharCode(data[index]);
        var retString = '';
        while(curChar !== '\0'){
            retString += curChar;
            index++;
            curChar = String.fromCharCode(data[index]);
        } // Add nullChar
        retString += curChar;
        return retString;
    };
    var string = {
        uint8ToCString: uint8ToCString$1
    };
    var uint8ToCString = string.uint8ToCString;
    var getUint64$1 = numbers.getUint64;
    /**
   * Based on: ISO/IEC 23009 Section: 5.10.3.3
   * References:
   * https://dashif-documents.azurewebsites.net/Events/master/event.html#emsg-format
   * https://aomediacodec.github.io/id3-emsg/
   * 
   * Takes emsg box data as a uint8 array and returns a emsg box object
   * @param {UInt8Array} boxData data from emsg box
   * @returns A parsed emsg box object
   */ var parseEmsgBox = function(boxData) {
        // version + flags
        var offset = 4;
        var version = boxData[0];
        var scheme_id_uri, value, timescale, presentation_time, presentation_time_delta, event_duration, id, message_data;
        if (version === 0) {
            scheme_id_uri = uint8ToCString(boxData.subarray(offset));
            offset += scheme_id_uri.length;
            value = uint8ToCString(boxData.subarray(offset));
            offset += value.length;
            var dv = new DataView(boxData.buffer);
            timescale = dv.getUint32(offset);
            offset += 4;
            presentation_time_delta = dv.getUint32(offset);
            offset += 4;
            event_duration = dv.getUint32(offset);
            offset += 4;
            id = dv.getUint32(offset);
            offset += 4;
        } else if (version === 1) {
            var dv = new DataView(boxData.buffer);
            timescale = dv.getUint32(offset);
            offset += 4;
            presentation_time = getUint64$1(boxData.subarray(offset));
            offset += 8;
            event_duration = dv.getUint32(offset);
            offset += 4;
            id = dv.getUint32(offset);
            offset += 4;
            scheme_id_uri = uint8ToCString(boxData.subarray(offset));
            offset += scheme_id_uri.length;
            value = uint8ToCString(boxData.subarray(offset));
            offset += value.length;
        }
        message_data = new Uint8Array(boxData.subarray(offset, boxData.byteLength));
        var emsgBox = {
            scheme_id_uri: scheme_id_uri,
            value: value,
            // if timescale is undefined or 0 set to 1 
            timescale: timescale ? timescale : 1,
            presentation_time: presentation_time,
            presentation_time_delta: presentation_time_delta,
            event_duration: event_duration,
            id: id,
            message_data: message_data
        };
        return isValidEmsgBox(version, emsgBox) ? emsgBox : undefined;
    };
    /**
   * Scales a presentation time or time delta with an offset with a provided timescale
   * @param {number} presentationTime 
   * @param {number} timescale 
   * @param {number} timeDelta 
   * @param {number} offset 
   * @returns the scaled time as a number
   */ var scaleTime = function(presentationTime, timescale, timeDelta, offset) {
        return presentationTime || presentationTime === 0 ? presentationTime / timescale : offset + timeDelta / timescale;
    };
    /**
   * Checks the emsg box data for validity based on the version
   * @param {number} version of the emsg box to validate
   * @param {Object} emsg the emsg data to validate
   * @returns if the box is valid as a boolean
   */ var isValidEmsgBox = function(version, emsg) {
        var hasScheme = emsg.scheme_id_uri !== '\0';
        var isValidV0Box = version === 0 && isDefined(emsg.presentation_time_delta) && hasScheme;
        var isValidV1Box = version === 1 && isDefined(emsg.presentation_time) && hasScheme; // Only valid versions of emsg are 0 and 1
        return !(version > 1) && isValidV0Box || isValidV1Box;
    }; // Utility function to check if an object is defined
    var isDefined = function(data) {
        return data !== undefined || data !== null;
    };
    var emsg$1 = {
        parseEmsgBox: parseEmsgBox,
        scaleTime: scaleTime
    };
    var win;
    if (typeof window !== "undefined") win = window;
    else if (typeof commonjsGlobal !== "undefined") win = commonjsGlobal;
    else if (typeof self !== "undefined") win = self;
    else win = {};
    var window_1 = win;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Utilities to detect basic properties and metadata about MP4s.
   */ var toUnsigned = bin.toUnsigned;
    var toHexString = bin.toHexString;
    var findBox$3 = findBox_1;
    var parseType$1 = parseType_1;
    var emsg = emsg$1;
    var parseTfhd$1 = parseTfhd$2;
    var parseTrun$1 = parseTrun$2;
    var parseTfdt$2 = parseTfdt$3;
    var getUint64 = numbers.getUint64;
    var timescale, startTime, compositionStartTime, getVideoTrackIds, getTracks, getTimescaleFromMediaHeader$1, getEmsgID3;
    var window$2 = window_1;
    var parseId3Frames = parseId3.parseId3Frames;
    /**
   * Parses an MP4 initialization segment and extracts the timescale
   * values for any declared tracks. Timescale values indicate the
   * number of clock ticks per second to assume for time-based values
   * elsewhere in the MP4.
   *
   * To determine the start time of an MP4, you need two pieces of
   * information: the timescale unit and the earliest base media decode
   * time. Multiple timescales can be specified within an MP4 but the
   * base media decode time is always expressed in the timescale from
   * the media header box for the track:
   * ```
   * moov > trak > mdia > mdhd.timescale
   * ```
   * @param init {Uint8Array} the bytes of the init segment
   * @return {object} a hash of track ids to timescale values or null if
   * the init segment is malformed.
   */ timescale = function(init) {
        var result = {}, traks = findBox$3(init, [
            'moov',
            'trak'
        ]); // mdhd timescale
        return traks.reduce(function(result, trak) {
            var tkhd, version, index, id, mdhd;
            tkhd = findBox$3(trak, [
                'tkhd'
            ])[0];
            if (!tkhd) return null;
            version = tkhd[0];
            index = version === 0 ? 12 : 20;
            id = toUnsigned(tkhd[index] << 24 | tkhd[index + 1] << 16 | tkhd[index + 2] << 8 | tkhd[index + 3]);
            mdhd = findBox$3(trak, [
                'mdia',
                'mdhd'
            ])[0];
            if (!mdhd) return null;
            version = mdhd[0];
            index = version === 0 ? 12 : 20;
            result[id] = toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
            return result;
        }, result);
    };
    /**
   * Determine the base media decode start time, in seconds, for an MP4
   * fragment. If multiple fragments are specified, the earliest time is
   * returned.
   *
   * The base media decode time can be parsed from track fragment
   * metadata:
   * ```
   * moof > traf > tfdt.baseMediaDecodeTime
   * ```
   * It requires the timescale value from the mdhd to interpret.
   *
   * @param timescale {object} a hash of track ids to timescale values.
   * @return {number} the earliest base media decode start time for the
   * fragment, in seconds
   */ startTime = function(timescale, fragment) {
        var trafs; // we need info from two childrend of each track fragment box
        trafs = findBox$3(fragment, [
            'moof',
            'traf'
        ]); // determine the start times for each track
        var lowestTime = trafs.reduce(function(acc, traf) {
            var tfhd = findBox$3(traf, [
                'tfhd'
            ])[0]; // get the track id from the tfhd
            var id = toUnsigned(tfhd[4] << 24 | tfhd[5] << 16 | tfhd[6] << 8 | tfhd[7]); // assume a 90kHz clock if no timescale was specified
            var scale = timescale[id] || 90e3; // get the base media decode time from the tfdt
            var tfdt = findBox$3(traf, [
                'tfdt'
            ])[0];
            var dv = new DataView(tfdt.buffer, tfdt.byteOffset, tfdt.byteLength);
            var baseTime; // version 1 is 64 bit
            if (tfdt[0] === 1) baseTime = getUint64(tfdt.subarray(4, 12));
            else baseTime = dv.getUint32(4);
             // convert base time to seconds if it is a valid number.
            let seconds;
            if (typeof baseTime === 'bigint') seconds = baseTime / window$2.BigInt(scale);
            else if (typeof baseTime === 'number' && !isNaN(baseTime)) seconds = baseTime / scale;
            if (seconds < Number.MAX_SAFE_INTEGER) seconds = Number(seconds);
            if (seconds < acc) acc = seconds;
            return acc;
        }, Infinity);
        return typeof lowestTime === 'bigint' || isFinite(lowestTime) ? lowestTime : 0;
    };
    /**
   * Determine the composition start, in seconds, for an MP4
   * fragment.
   *
   * The composition start time of a fragment can be calculated using the base
   * media decode time, composition time offset, and timescale, as follows:
   *
   * compositionStartTime = (baseMediaDecodeTime + compositionTimeOffset) / timescale
   *
   * All of the aforementioned information is contained within a media fragment's
   * `traf` box, except for timescale info, which comes from the initialization
   * segment, so a track id (also contained within a `traf`) is also necessary to
   * associate it with a timescale
   *
   *
   * @param timescales {object} - a hash of track ids to timescale values.
   * @param fragment {Unit8Array} - the bytes of a media segment
   * @return {number} the composition start time for the fragment, in seconds
   **/ compositionStartTime = function(timescales, fragment) {
        var trafBoxes = findBox$3(fragment, [
            'moof',
            'traf'
        ]);
        var baseMediaDecodeTime = 0;
        var compositionTimeOffset = 0;
        var trackId;
        if (trafBoxes && trafBoxes.length) {
            // The spec states that track run samples contained within a `traf` box are contiguous, but
            // it does not explicitly state whether the `traf` boxes themselves are contiguous.
            // We will assume that they are, so we only need the first to calculate start time.
            var tfhd = findBox$3(trafBoxes[0], [
                'tfhd'
            ])[0];
            var trun = findBox$3(trafBoxes[0], [
                'trun'
            ])[0];
            var tfdt = findBox$3(trafBoxes[0], [
                'tfdt'
            ])[0];
            if (tfhd) {
                var parsedTfhd = parseTfhd$1(tfhd);
                trackId = parsedTfhd.trackId;
            }
            if (tfdt) {
                var parsedTfdt = parseTfdt$2(tfdt);
                baseMediaDecodeTime = parsedTfdt.baseMediaDecodeTime;
            }
            if (trun) {
                var parsedTrun = parseTrun$1(trun);
                if (parsedTrun.samples && parsedTrun.samples.length) compositionTimeOffset = parsedTrun.samples[0].compositionTimeOffset || 0;
            }
        } // Get timescale for this specific track. Assume a 90kHz clock if no timescale was
        // specified.
        var timescale = timescales[trackId] || 90e3; // return the composition start time, in seconds
        if (typeof baseMediaDecodeTime === 'bigint') {
            compositionTimeOffset = window$2.BigInt(compositionTimeOffset);
            timescale = window$2.BigInt(timescale);
        }
        var result = (baseMediaDecodeTime + compositionTimeOffset) / timescale;
        if (typeof result === 'bigint' && result < Number.MAX_SAFE_INTEGER) result = Number(result);
        return result;
    };
    /**
    * Find the trackIds of the video tracks in this source.
    * Found by parsing the Handler Reference and Track Header Boxes:
    *   moov > trak > mdia > hdlr
    *   moov > trak > tkhd
    *
    * @param {Uint8Array} init - The bytes of the init segment for this source
    * @return {Number[]} A list of trackIds
    *
    * @see ISO-BMFF-12/2015, Section 8.4.3
   **/ getVideoTrackIds = function(init) {
        var traks = findBox$3(init, [
            'moov',
            'trak'
        ]);
        var videoTrackIds = [];
        traks.forEach(function(trak) {
            var hdlrs = findBox$3(trak, [
                'mdia',
                'hdlr'
            ]);
            var tkhds = findBox$3(trak, [
                'tkhd'
            ]);
            hdlrs.forEach(function(hdlr, index) {
                var handlerType = parseType$1(hdlr.subarray(8, 12));
                var tkhd = tkhds[index];
                var view;
                var version;
                var trackId;
                if (handlerType === 'vide') {
                    view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
                    version = view.getUint8(0);
                    trackId = version === 0 ? view.getUint32(12) : view.getUint32(20);
                    videoTrackIds.push(trackId);
                }
            });
        });
        return videoTrackIds;
    };
    getTimescaleFromMediaHeader$1 = function(mdhd) {
        // mdhd is a FullBox, meaning it will have its own version as the first byte
        var version = mdhd[0];
        var index = version === 0 ? 12 : 20;
        return toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
    };
    /**
   * Get all the video, audio, and hint tracks from a non fragmented
   * mp4 segment
   */ getTracks = function(init) {
        var traks = findBox$3(init, [
            'moov',
            'trak'
        ]);
        var tracks = [];
        traks.forEach(function(trak) {
            var track = {};
            var tkhd = findBox$3(trak, [
                'tkhd'
            ])[0];
            var view, tkhdVersion; // id
            if (tkhd) {
                view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
                tkhdVersion = view.getUint8(0);
                track.id = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
            }
            var hdlr = findBox$3(trak, [
                'mdia',
                'hdlr'
            ])[0]; // type
            if (hdlr) {
                var type = parseType$1(hdlr.subarray(8, 12));
                if (type === 'vide') track.type = 'video';
                else if (type === 'soun') track.type = 'audio';
                else track.type = type;
            } // codec
            var stsd = findBox$3(trak, [
                'mdia',
                'minf',
                'stbl',
                'stsd'
            ])[0];
            if (stsd) {
                var sampleDescriptions = stsd.subarray(8); // gives the codec type string
                track.codec = parseType$1(sampleDescriptions.subarray(4, 8));
                var codecBox = findBox$3(sampleDescriptions, [
                    track.codec
                ])[0];
                var codecConfig, codecConfigType;
                if (codecBox) {
                    // https://tools.ietf.org/html/rfc6381#section-3.3
                    if (/^[asm]vc[1-9]$/i.test(track.codec)) {
                        // we don't need anything but the "config" parameter of the
                        // avc1 codecBox
                        codecConfig = codecBox.subarray(78);
                        codecConfigType = parseType$1(codecConfig.subarray(4, 8));
                        if (codecConfigType === 'avcC' && codecConfig.length > 11) {
                            track.codec += '.'; // left padded with zeroes for single digit hex
                            // profile idc
                            track.codec += toHexString(codecConfig[9]); // the byte containing the constraint_set flags
                            track.codec += toHexString(codecConfig[10]); // level idc
                            track.codec += toHexString(codecConfig[11]);
                        } else // TODO: show a warning that we couldn't parse the codec
                        // and are using the default
                        track.codec = 'avc1.4d400d';
                    } else if (/^mp4[a,v]$/i.test(track.codec)) {
                        // we do not need anything but the streamDescriptor of the mp4a codecBox
                        codecConfig = codecBox.subarray(28);
                        codecConfigType = parseType$1(codecConfig.subarray(4, 8));
                        if (codecConfigType === 'esds' && codecConfig.length > 20 && codecConfig[19] !== 0) {
                            track.codec += '.' + toHexString(codecConfig[19]); // this value is only a single digit
                            track.codec += '.' + toHexString(codecConfig[20] >>> 2 & 0x3f).replace(/^0/, '');
                        } else // TODO: show a warning that we couldn't parse the codec
                        // and are using the default
                        track.codec = 'mp4a.40.2';
                    } else // flac, opus, etc
                    track.codec = track.codec.toLowerCase();
                }
            }
            var mdhd = findBox$3(trak, [
                'mdia',
                'mdhd'
            ])[0];
            if (mdhd) track.timescale = getTimescaleFromMediaHeader$1(mdhd);
            tracks.push(track);
        });
        return tracks;
    };
    /**
   * Returns an array of emsg ID3 data from the provided segmentData.
   * An offset can also be provided as the Latest Arrival Time to calculate 
   * the Event Start Time of v0 EMSG boxes. 
   * See: https://dashif-documents.azurewebsites.net/Events/master/event.html#Inband-event-timing
   * 
   * @param {Uint8Array} segmentData the segment byte array.
   * @param {number} offset the segment start time or Latest Arrival Time, 
   * @return {Object[]} an array of ID3 parsed from EMSG boxes
   */ getEmsgID3 = function(segmentData, offset = 0) {
        var emsgBoxes = findBox$3(segmentData, [
            'emsg'
        ]);
        return emsgBoxes.map((data)=>{
            var parsedBox = emsg.parseEmsgBox(new Uint8Array(data));
            var parsedId3Frames = parseId3Frames(parsedBox.message_data);
            return {
                cueTime: emsg.scaleTime(parsedBox.presentation_time, parsedBox.timescale, parsedBox.presentation_time_delta, offset),
                duration: emsg.scaleTime(parsedBox.event_duration, parsedBox.timescale),
                frames: parsedId3Frames
            };
        });
    };
    var probe$2 = {
        // export mp4 inspector's findBox and parseType for backwards compatibility
        findBox: findBox$3,
        parseType: parseType$1,
        timescale: timescale,
        startTime: startTime,
        compositionStartTime: compositionStartTime,
        videoTrackIds: getVideoTrackIds,
        tracks: getTracks,
        getTimescaleFromMediaHeader: getTimescaleFromMediaHeader$1,
        getEmsgID3: getEmsgID3
    };
    const { parseTrun: parseTrun } = mp4Inspector;
    const { findBox: findBox$2 } = probe$2;
    var window$1 = window_1;
    /**
   * Utility function for parsing data from mdat boxes.
   * @param {Array<Uint8Array>} segment the segment data to create mdat/traf pairs from.
   * @returns mdat and traf boxes paired up for easier parsing.
   */ var getMdatTrafPairs$2 = function(segment) {
        var trafs = findBox$2(segment, [
            'moof',
            'traf'
        ]);
        var mdats = findBox$2(segment, [
            'mdat'
        ]);
        var mdatTrafPairs = []; // Pair up each traf with a mdat as moofs and mdats are in pairs
        mdats.forEach(function(mdat, index) {
            var matchingTraf = trafs[index];
            mdatTrafPairs.push({
                mdat: mdat,
                traf: matchingTraf
            });
        });
        return mdatTrafPairs;
    };
    /**
    * Parses sample information out of Track Run Boxes and calculates
    * the absolute presentation and decode timestamps of each sample.
    *
    * @param {Array<Uint8Array>} truns - The Trun Run boxes to be parsed
    * @param {Number|BigInt} baseMediaDecodeTime - base media decode time from tfdt
        @see ISO-BMFF-12/2015, Section 8.8.12
    * @param {Object} tfhd - The parsed Track Fragment Header
    *   @see inspect.parseTfhd
    * @return {Object[]} the parsed samples
    *
    * @see ISO-BMFF-12/2015, Section 8.8.8
   **/ var parseSamples$2 = function(truns, baseMediaDecodeTime, tfhd) {
        var currentDts = baseMediaDecodeTime;
        var defaultSampleDuration = tfhd.defaultSampleDuration || 0;
        var defaultSampleSize = tfhd.defaultSampleSize || 0;
        var trackId = tfhd.trackId;
        var allSamples = [];
        truns.forEach(function(trun) {
            // Note: We currently do not parse the sample table as well
            // as the trun. It's possible some sources will require this.
            // moov > trak > mdia > minf > stbl
            var trackRun = parseTrun(trun);
            var samples = trackRun.samples;
            samples.forEach(function(sample) {
                if (sample.duration === undefined) sample.duration = defaultSampleDuration;
                if (sample.size === undefined) sample.size = defaultSampleSize;
                sample.trackId = trackId;
                sample.dts = currentDts;
                if (sample.compositionTimeOffset === undefined) sample.compositionTimeOffset = 0;
                if (typeof currentDts === 'bigint') {
                    sample.pts = currentDts + window$1.BigInt(sample.compositionTimeOffset);
                    currentDts += window$1.BigInt(sample.duration);
                } else {
                    sample.pts = currentDts + sample.compositionTimeOffset;
                    currentDts += sample.duration;
                }
            });
            allSamples = allSamples.concat(samples);
        });
        return allSamples;
    };
    var samples = {
        getMdatTrafPairs: getMdatTrafPairs$2,
        parseSamples: parseSamples$2
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Reads in-band CEA-708 captions out of FMP4 segments.
   * @see https://en.wikipedia.org/wiki/CEA-708
   */ var discardEmulationPreventionBytes = captionPacketParser.discardEmulationPreventionBytes;
    var CaptionStream = captionStream.CaptionStream;
    var findBox$1 = findBox_1;
    var parseTfdt$1 = parseTfdt$3;
    var parseTfhd = parseTfhd$2;
    var { getMdatTrafPairs: getMdatTrafPairs$1, parseSamples: parseSamples$1 } = samples;
    /**
    * Maps an offset in the mdat to a sample based on the the size of the samples.
    * Assumes that `parseSamples` has been called first.
    *
    * @param {Number} offset - The offset into the mdat
    * @param {Object[]} samples - An array of samples, parsed using `parseSamples`
    * @return {?Object} The matching sample, or null if no match was found.
    *
    * @see ISO-BMFF-12/2015, Section 8.8.8
   **/ var mapToSample = function(offset, samples) {
        var approximateOffset = offset;
        for(var i = 0; i < samples.length; i++){
            var sample = samples[i];
            if (approximateOffset < sample.size) return sample;
            approximateOffset -= sample.size;
        }
        return null;
    };
    /**
    * Finds SEI nal units contained in a Media Data Box.
    * Assumes that `parseSamples` has been called first.
    *
    * @param {Uint8Array} avcStream - The bytes of the mdat
    * @param {Object[]} samples - The samples parsed out by `parseSamples`
    * @param {Number} trackId - The trackId of this video track
    * @return {Object[]} seiNals - the parsed SEI NALUs found.
    *   The contents of the seiNal should match what is expected by
    *   CaptionStream.push (nalUnitType, size, data, escapedRBSP, pts, dts)
    *
    * @see ISO-BMFF-12/2015, Section 8.1.1
    * @see Rec. ITU-T H.264, 7.3.2.3.1
   **/ var findSeiNals = function(avcStream, samples, trackId) {
        var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength), result = {
            logs: [],
            seiNals: []
        }, seiNal, i, length, lastMatchedSample;
        for(i = 0; i + 4 < avcStream.length; i += length){
            length = avcView.getUint32(i);
            i += 4; // Bail if this doesn't appear to be an H264 stream
            if (length <= 0) continue;
            switch(avcStream[i] & 0x1F){
                case 0x06:
                    var data = avcStream.subarray(i + 1, i + 1 + length);
                    var matchingSample = mapToSample(i, samples);
                    seiNal = {
                        nalUnitType: 'sei_rbsp',
                        size: length,
                        data: data,
                        escapedRBSP: discardEmulationPreventionBytes(data),
                        trackId: trackId
                    };
                    if (matchingSample) {
                        seiNal.pts = matchingSample.pts;
                        seiNal.dts = matchingSample.dts;
                        lastMatchedSample = matchingSample;
                    } else if (lastMatchedSample) {
                        // If a matching sample cannot be found, use the last
                        // sample's values as they should be as close as possible
                        seiNal.pts = lastMatchedSample.pts;
                        seiNal.dts = lastMatchedSample.dts;
                    } else {
                        result.logs.push({
                            level: 'warn',
                            message: 'We\'ve encountered a nal unit without data at ' + i + ' for trackId ' + trackId + '. See mux.js#223.'
                        });
                        break;
                    }
                    result.seiNals.push(seiNal);
                    break;
            }
        }
        return result;
    };
    /**
    * Parses out caption nals from an FMP4 segment's video tracks.
    *
    * @param {Uint8Array} segment - The bytes of a single segment
    * @param {Number} videoTrackId - The trackId of a video track in the segment
    * @return {Object.<Number, Object[]>} A mapping of video trackId to
    *   a list of seiNals found in that track
   **/ var parseCaptionNals = function(segment, videoTrackId) {
        var captionNals = {};
        var mdatTrafPairs = getMdatTrafPairs$1(segment);
        mdatTrafPairs.forEach(function(pair) {
            var mdat = pair.mdat;
            var traf = pair.traf;
            var tfhd = findBox$1(traf, [
                'tfhd'
            ]); // Exactly 1 tfhd per traf
            var headerInfo = parseTfhd(tfhd[0]);
            var trackId = headerInfo.trackId;
            var tfdt = findBox$1(traf, [
                'tfdt'
            ]); // Either 0 or 1 tfdt per traf
            var baseMediaDecodeTime = tfdt.length > 0 ? parseTfdt$1(tfdt[0]).baseMediaDecodeTime : 0;
            var truns = findBox$1(traf, [
                'trun'
            ]);
            var samples;
            var result; // Only parse video data for the chosen video track
            if (videoTrackId === trackId && truns.length > 0) {
                samples = parseSamples$1(truns, baseMediaDecodeTime, headerInfo);
                result = findSeiNals(mdat, samples, trackId);
                if (!captionNals[trackId]) captionNals[trackId] = {
                    seiNals: [],
                    logs: []
                };
                captionNals[trackId].seiNals = captionNals[trackId].seiNals.concat(result.seiNals);
                captionNals[trackId].logs = captionNals[trackId].logs.concat(result.logs);
            }
        });
        return captionNals;
    };
    /**
    * Parses out inband captions from an MP4 container and returns
    * caption objects that can be used by WebVTT and the TextTrack API.
    * @see https://developer.mozilla.org/en-US/docs/Web/API/VTTCue
    * @see https://developer.mozilla.org/en-US/docs/Web/API/TextTrack
    * Assumes that `probe.getVideoTrackIds` and `probe.timescale` have been called first
    *
    * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
    * @param {Number} trackId - The id of the video track to parse
    * @param {Number} timescale - The timescale for the video track from the init segment
    *
    * @return {?Object[]} parsedCaptions - A list of captions or null if no video tracks
    * @return {Number} parsedCaptions[].startTime - The time to show the caption in seconds
    * @return {Number} parsedCaptions[].endTime - The time to stop showing the caption in seconds
    * @return {Object[]} parsedCaptions[].content - A list of individual caption segments
    * @return {String} parsedCaptions[].content.text - The visible content of the caption segment
    * @return {Number} parsedCaptions[].content.line - The line height from 1-15 for positioning of the caption segment
    * @return {Number} parsedCaptions[].content.position - The column indent percentage for cue positioning from 10-80
   **/ var parseEmbeddedCaptions = function(segment, trackId, timescale) {
        var captionNals; // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
        if (trackId === null) return null;
        captionNals = parseCaptionNals(segment, trackId);
        var trackNals = captionNals[trackId] || {};
        return {
            seiNals: trackNals.seiNals,
            logs: trackNals.logs,
            timescale: timescale
        };
    };
    /**
    * Converts SEI NALUs into captions that can be used by video.js
   **/ var CaptionParser = function() {
        var isInitialized = false;
        var captionStream; // Stores segments seen before trackId and timescale are set
        var segmentCache; // Stores video track ID of the track being parsed
        var trackId; // Stores the timescale of the track being parsed
        var timescale; // Stores captions parsed so far
        var parsedCaptions; // Stores whether we are receiving partial data or not
        var parsingPartial;
        /**
      * A method to indicate whether a CaptionParser has been initalized
      * @returns {Boolean}
     **/ this.isInitialized = function() {
            return isInitialized;
        };
        /**
      * Initializes the underlying CaptionStream, SEI NAL parsing
      * and management, and caption collection
     **/ this.init = function(options) {
            captionStream = new CaptionStream();
            isInitialized = true;
            parsingPartial = options ? options.isPartial : false; // Collect dispatched captions
            captionStream.on('data', function(event) {
                // Convert to seconds in the source's timescale
                event.startTime = event.startPts / timescale;
                event.endTime = event.endPts / timescale;
                parsedCaptions.captions.push(event);
                parsedCaptions.captionStreams[event.stream] = true;
            });
            captionStream.on('log', function(log) {
                parsedCaptions.logs.push(log);
            });
        };
        /**
      * Determines if a new video track will be selected
      * or if the timescale changed
      * @return {Boolean}
     **/ this.isNewInit = function(videoTrackIds, timescales) {
            if (videoTrackIds && videoTrackIds.length === 0 || timescales && typeof timescales === 'object' && Object.keys(timescales).length === 0) return false;
            return trackId !== videoTrackIds[0] || timescale !== timescales[trackId];
        };
        /**
      * Parses out SEI captions and interacts with underlying
      * CaptionStream to return dispatched captions
      *
      * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
      * @param {Number[]} videoTrackIds - A list of video tracks found in the init segment
      * @param {Object.<Number, Number>} timescales - The timescales found in the init segment
      * @see parseEmbeddedCaptions
      * @see m2ts/caption-stream.js
     **/ this.parse = function(segment, videoTrackIds, timescales) {
            var parsedData;
            if (!this.isInitialized()) return null; // This is not likely to be a video segment
            else if (!videoTrackIds || !timescales) return null;
            else if (this.isNewInit(videoTrackIds, timescales)) {
                // Use the first video track only as there is no
                // mechanism to switch to other video tracks
                trackId = videoTrackIds[0];
                timescale = timescales[trackId]; // If an init segment has not been seen yet, hold onto segment
            // data until we have one.
            // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
            } else if (trackId === null || !timescale) {
                segmentCache.push(segment);
                return null;
            } // Now that a timescale and trackId is set, parse cached segments
            while(segmentCache.length > 0){
                var cachedSegment = segmentCache.shift();
                this.parse(cachedSegment, videoTrackIds, timescales);
            }
            parsedData = parseEmbeddedCaptions(segment, trackId, timescale);
            if (parsedData && parsedData.logs) parsedCaptions.logs = parsedCaptions.logs.concat(parsedData.logs);
            if (parsedData === null || !parsedData.seiNals) {
                if (parsedCaptions.logs.length) return {
                    logs: parsedCaptions.logs,
                    captions: [],
                    captionStreams: []
                };
                return null;
            }
            this.pushNals(parsedData.seiNals); // Force the parsed captions to be dispatched
            this.flushStream();
            return parsedCaptions;
        };
        /**
      * Pushes SEI NALUs onto CaptionStream
      * @param {Object[]} nals - A list of SEI nals parsed using `parseCaptionNals`
      * Assumes that `parseCaptionNals` has been called first
      * @see m2ts/caption-stream.js
      **/ this.pushNals = function(nals) {
            if (!this.isInitialized() || !nals || nals.length === 0) return null;
            nals.forEach(function(nal) {
                captionStream.push(nal);
            });
        };
        /**
      * Flushes underlying CaptionStream to dispatch processed, displayable captions
      * @see m2ts/caption-stream.js
     **/ this.flushStream = function() {
            if (!this.isInitialized()) return null;
            if (!parsingPartial) captionStream.flush();
            else captionStream.partialFlush();
        };
        /**
      * Reset caption buckets for new data
     **/ this.clearParsedCaptions = function() {
            parsedCaptions.captions = [];
            parsedCaptions.captionStreams = {};
            parsedCaptions.logs = [];
        };
        /**
      * Resets underlying CaptionStream
      * @see m2ts/caption-stream.js
     **/ this.resetCaptionStream = function() {
            if (!this.isInitialized()) return null;
            captionStream.reset();
        };
        /**
      * Convenience method to clear all captions flushed from the
      * CaptionStream and still being parsed
      * @see m2ts/caption-stream.js
     **/ this.clearAllCaptions = function() {
            this.clearParsedCaptions();
            this.resetCaptionStream();
        };
        /**
      * Reset caption parser
     **/ this.reset = function() {
            segmentCache = [];
            trackId = null;
            timescale = null;
            if (!parsedCaptions) parsedCaptions = {
                captions: [],
                // CC1, CC2, CC3, CC4
                captionStreams: {},
                logs: []
            };
            else this.clearParsedCaptions();
            this.resetCaptionStream();
        };
        this.reset();
    };
    var captionParser = CaptionParser;
    const { parseTfdt: parseTfdt } = mp4Inspector;
    const findBox = findBox_1;
    const { getTimescaleFromMediaHeader: getTimescaleFromMediaHeader } = probe$2;
    const { parseSamples: parseSamples, getMdatTrafPairs: getMdatTrafPairs } = samples;
    /**
   * Module for parsing WebVTT text and styles from FMP4 segments.
   * Based on the ISO/IEC 14496-30.
   */ const WebVttParser = function() {
        // default timescale to 90k
        let timescale = 90e3;
        /**
     * Parses the timescale from the init segment.
     * @param {Array<Uint8Array>} segment The initialization segment to parse the timescale from.
     */ this.init = function(segment) {
            // We just need the timescale from the init segment.
            const mdhd = findBox(segment, [
                'moov',
                'trak',
                'mdia',
                'mdhd'
            ])[0];
            if (mdhd) timescale = getTimescaleFromMediaHeader(mdhd);
        };
        /**
     * Parses a WebVTT FMP4 segment.
     * @param {Array<Uint8Array>} segment The content segment to parse the WebVTT cues from.
     * @returns The WebVTT cue text, styling, and timing info as an array of cue objects.
     */ this.parseSegment = function(segment) {
            const vttCues = [];
            const mdatTrafPairs = getMdatTrafPairs(segment);
            let baseMediaDecodeTime = 0;
            mdatTrafPairs.forEach(function(pair) {
                const mdatBox = pair.mdat;
                const trafBox = pair.traf; // zero or one.
                const tfdtBox = findBox(trafBox, [
                    'tfdt'
                ])[0]; // zero or one.
                const tfhdBox = findBox(trafBox, [
                    'tfhd'
                ])[0]; // zero or more.
                const trunBoxes = findBox(trafBox, [
                    'trun'
                ]);
                if (tfdtBox) {
                    const tfdt = parseTfdt(tfdtBox);
                    baseMediaDecodeTime = tfdt.baseMediaDecodeTime;
                }
                if (trunBoxes.length && tfhdBox) {
                    const samples = parseSamples(trunBoxes, baseMediaDecodeTime, tfhdBox);
                    let mdatOffset = 0;
                    samples.forEach(function(sample) {
                        // decode utf8 payload
                        const UTF_8 = 'utf-8';
                        const textDecoder = new TextDecoder(UTF_8); // extract sample data from the mdat box.
                        // WebVTT Sample format:
                        // Exactly one VTTEmptyCueBox box
                        // OR one or more VTTCueBox boxes.
                        const sampleData = mdatBox.slice(mdatOffset, mdatOffset + sample.size); // single vtte box.
                        const vtteBox = findBox(sampleData, [
                            'vtte'
                        ])[0]; // empty box
                        if (vtteBox) {
                            mdatOffset += sample.size;
                            return;
                        } // TODO: Support 'vtta' boxes.
                        // VTTAdditionalTextBoxes can be interleaved between VTTCueBoxes.
                        const vttcBoxes = findBox(sampleData, [
                            'vttc'
                        ]);
                        vttcBoxes.forEach(function(vttcBox) {
                            // mandatory payload box.
                            const paylBox = findBox(vttcBox, [
                                'payl'
                            ])[0]; // optional settings box
                            const sttgBox = findBox(vttcBox, [
                                'sttg'
                            ])[0];
                            const start = sample.pts / timescale;
                            const end = (sample.pts + sample.duration) / timescale;
                            let cueText, settings; // contains cue text.
                            if (paylBox) try {
                                cueText = textDecoder.decode(paylBox);
                            } catch (e) {
                                console.error(e);
                            }
                             // settings box contains styling.
                            if (sttgBox) try {
                                settings = textDecoder.decode(sttgBox);
                            } catch (e) {
                                console.error(e);
                            }
                            if (sample.duration && cueText) vttCues.push({
                                cueText: cueText,
                                start: start,
                                end: end,
                                settings: settings
                            });
                        });
                        mdatOffset += sample.size;
                    });
                }
            });
            return vttCues;
        };
    };
    var webvttParser = WebVttParser;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Utilities to detect basic properties and metadata about TS Segments.
   */ var StreamTypes$1 = streamTypes;
    var parsePid = function(packet) {
        var pid = packet[1] & 0x1f;
        pid <<= 8;
        pid |= packet[2];
        return pid;
    };
    var parsePayloadUnitStartIndicator = function(packet) {
        return !!(packet[1] & 0x40);
    };
    var parseAdaptionField = function(packet) {
        var offset = 0; // if an adaption field is present, its length is specified by the
        // fifth byte of the TS packet header. The adaptation field is
        // used to add stuffing to PES packets that don't fill a complete
        // TS packet, and to specify some forms of timing and control data
        // that we do not currently use.
        if ((packet[3] & 0x30) >>> 4 > 0x01) offset += packet[4] + 1;
        return offset;
    };
    var parseType = function(packet, pmtPid) {
        var pid = parsePid(packet);
        if (pid === 0) return 'pat';
        else if (pid === pmtPid) return 'pmt';
        else if (pmtPid) return 'pes';
        return null;
    };
    var parsePat = function(packet) {
        var pusi = parsePayloadUnitStartIndicator(packet);
        var offset = 4 + parseAdaptionField(packet);
        if (pusi) offset += packet[offset] + 1;
        return (packet[offset + 10] & 0x1f) << 8 | packet[offset + 11];
    };
    var parsePmt = function(packet) {
        var programMapTable = {};
        var pusi = parsePayloadUnitStartIndicator(packet);
        var payloadOffset = 4 + parseAdaptionField(packet);
        if (pusi) payloadOffset += packet[payloadOffset] + 1;
         // PMTs can be sent ahead of the time when they should actually
        // take effect. We don't believe this should ever be the case
        // for HLS but we'll ignore "forward" PMT declarations if we see
        // them. Future PMT declarations have the current_next_indicator
        // set to zero.
        if (!(packet[payloadOffset + 5] & 0x01)) return;
        var sectionLength, tableEnd, programInfoLength; // the mapping table ends at the end of the current section
        sectionLength = (packet[payloadOffset + 1] & 0x0f) << 8 | packet[payloadOffset + 2];
        tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
        // long the program info descriptors are
        programInfoLength = (packet[payloadOffset + 10] & 0x0f) << 8 | packet[payloadOffset + 11]; // advance the offset to the first entry in the mapping table
        var offset = 12 + programInfoLength;
        while(offset < tableEnd){
            var i = payloadOffset + offset; // add an entry that maps the elementary_pid to the stream_type
            programMapTable[(packet[i + 1] & 0x1F) << 8 | packet[i + 2]] = packet[i]; // move to the next table entry
            // skip past the elementary stream descriptors, if present
            offset += ((packet[i + 3] & 0x0F) << 8 | packet[i + 4]) + 5;
        }
        return programMapTable;
    };
    var parsePesType = function(packet, programMapTable) {
        var pid = parsePid(packet);
        var type = programMapTable[pid];
        switch(type){
            case StreamTypes$1.H264_STREAM_TYPE:
                return 'video';
            case StreamTypes$1.ADTS_STREAM_TYPE:
                return 'audio';
            case StreamTypes$1.METADATA_STREAM_TYPE:
                return 'timed-metadata';
            default:
                return null;
        }
    };
    var parsePesTime = function(packet) {
        var pusi = parsePayloadUnitStartIndicator(packet);
        if (!pusi) return null;
        var offset = 4 + parseAdaptionField(packet);
        if (offset >= packet.byteLength) // From the H 222.0 MPEG-TS spec
        // "For transport stream packets carrying PES packets, stuffing is needed when there
        //  is insufficient PES packet data to completely fill the transport stream packet
        //  payload bytes. Stuffing is accomplished by defining an adaptation field longer than
        //  the sum of the lengths of the data elements in it, so that the payload bytes
        //  remaining after the adaptation field exactly accommodates the available PES packet
        //  data."
        //
        // If the offset is >= the length of the packet, then the packet contains no data
        // and instead is just adaption field stuffing bytes
        return null;
        var pes = null;
        var ptsDtsFlags; // PES packets may be annotated with a PTS value, or a PTS value
        // and a DTS value. Determine what combination of values is
        // available to work with.
        ptsDtsFlags = packet[offset + 7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
        // performs all bitwise operations on 32-bit integers but javascript
        // supports a much greater range (52-bits) of integer using standard
        // mathematical operations.
        // We construct a 31-bit value using bitwise operators over the 31
        // most significant bits and then multiply by 4 (equal to a left-shift
        // of 2) before we add the final 2 least significant bits of the
        // timestamp (equal to an OR.)
        if (ptsDtsFlags & 0xC0) {
            pes = {}; // the PTS and DTS are not written out directly. For information
            // on how they are encoded, see
            // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
            pes.pts = (packet[offset + 9] & 0x0E) << 27 | (packet[offset + 10] & 0xFF) << 20 | (packet[offset + 11] & 0xFE) << 12 | (packet[offset + 12] & 0xFF) << 5 | (packet[offset + 13] & 0xFE) >>> 3;
            pes.pts *= 4; // Left shift by 2
            pes.pts += (packet[offset + 13] & 0x06) >>> 1; // OR by the two LSBs
            pes.dts = pes.pts;
            if (ptsDtsFlags & 0x40) {
                pes.dts = (packet[offset + 14] & 0x0E) << 27 | (packet[offset + 15] & 0xFF) << 20 | (packet[offset + 16] & 0xFE) << 12 | (packet[offset + 17] & 0xFF) << 5 | (packet[offset + 18] & 0xFE) >>> 3;
                pes.dts *= 4; // Left shift by 2
                pes.dts += (packet[offset + 18] & 0x06) >>> 1; // OR by the two LSBs
            }
        }
        return pes;
    };
    var parseNalUnitType = function(type) {
        switch(type){
            case 0x05:
                return 'slice_layer_without_partitioning_rbsp_idr';
            case 0x06:
                return 'sei_rbsp';
            case 0x07:
                return 'seq_parameter_set_rbsp';
            case 0x08:
                return 'pic_parameter_set_rbsp';
            case 0x09:
                return 'access_unit_delimiter_rbsp';
            default:
                return null;
        }
    };
    var videoPacketContainsKeyFrame = function(packet) {
        var offset = 4 + parseAdaptionField(packet);
        var frameBuffer = packet.subarray(offset);
        var frameI = 0;
        var frameSyncPoint = 0;
        var foundKeyFrame = false;
        var nalType; // advance the sync point to a NAL start, if necessary
        for(; frameSyncPoint < frameBuffer.byteLength - 3; frameSyncPoint++)if (frameBuffer[frameSyncPoint + 2] === 1) {
            // the sync point is properly aligned
            frameI = frameSyncPoint + 5;
            break;
        }
        while(frameI < frameBuffer.byteLength)// look at the current byte to determine if we've hit the end of
        // a NAL unit boundary
        switch(frameBuffer[frameI]){
            case 0:
                // skip past non-sync sequences
                if (frameBuffer[frameI - 1] !== 0) {
                    frameI += 2;
                    break;
                } else if (frameBuffer[frameI - 2] !== 0) {
                    frameI++;
                    break;
                }
                if (frameSyncPoint + 3 !== frameI - 2) {
                    nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
                    if (nalType === 'slice_layer_without_partitioning_rbsp_idr') foundKeyFrame = true;
                } // drop trailing zeroes
                do frameI++;
                while (frameBuffer[frameI] !== 1 && frameI < frameBuffer.length);
                frameSyncPoint = frameI - 2;
                frameI += 3;
                break;
            case 1:
                // skip past non-sync sequences
                if (frameBuffer[frameI - 1] !== 0 || frameBuffer[frameI - 2] !== 0) {
                    frameI += 3;
                    break;
                }
                nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
                if (nalType === 'slice_layer_without_partitioning_rbsp_idr') foundKeyFrame = true;
                frameSyncPoint = frameI - 2;
                frameI += 3;
                break;
            default:
                // the current byte isn't a one or zero, so it cannot be part
                // of a sync sequence
                frameI += 3;
                break;
        }
        frameBuffer = frameBuffer.subarray(frameSyncPoint);
        frameI -= frameSyncPoint;
        frameSyncPoint = 0; // parse the final nal
        if (frameBuffer && frameBuffer.byteLength > 3) {
            nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
            if (nalType === 'slice_layer_without_partitioning_rbsp_idr') foundKeyFrame = true;
        }
        return foundKeyFrame;
    };
    var probe$1 = {
        parseType: parseType,
        parsePat: parsePat,
        parsePmt: parsePmt,
        parsePayloadUnitStartIndicator: parsePayloadUnitStartIndicator,
        parsePesType: parsePesType,
        parsePesTime: parsePesTime,
        videoPacketContainsKeyFrame: videoPacketContainsKeyFrame
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Parse mpeg2 transport stream packets to extract basic timing information
   */ var StreamTypes = streamTypes;
    var handleRollover = timestampRolloverStream.handleRollover;
    var probe = {};
    probe.ts = probe$1;
    probe.aac = utils;
    var ONE_SECOND_IN_TS = clock$2.ONE_SECOND_IN_TS;
    var MP2T_PACKET_LENGTH = 188, // bytes
    SYNC_BYTE = 0x47;
    /**
   * walks through segment data looking for pat and pmt packets to parse out
   * program map table information
   */ var parsePsi_ = function(bytes, pmt) {
        var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type;
        while(endIndex < bytes.byteLength){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case 'pat':
                        pmt.pid = probe.ts.parsePat(packet);
                        break;
                    case 'pmt':
                        var table = probe.ts.parsePmt(packet);
                        pmt.table = pmt.table || {};
                        Object.keys(table).forEach(function(key) {
                            pmt.table[key] = table[key];
                        });
                        break;
                }
                startIndex += MP2T_PACKET_LENGTH;
                endIndex += MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex++;
            endIndex++;
        }
    };
    /**
   * walks through the segment data from the start and end to get timing information
   * for the first and last audio pes packets
   */ var parseAudioPes_ = function(bytes, pmt, result) {
        var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type, pesType, pusi, parsed;
        var endLoop = false; // Start walking from start of segment to get first audio packet
        while(endIndex <= bytes.byteLength){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case 'pes':
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === 'audio' && pusi) {
                            parsed = probe.ts.parsePesTime(packet);
                            if (parsed) {
                                parsed.type = 'audio';
                                result.audio.push(parsed);
                                endLoop = true;
                            }
                        }
                        break;
                }
                if (endLoop) break;
                startIndex += MP2T_PACKET_LENGTH;
                endIndex += MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex++;
            endIndex++;
        } // Start walking from end of segment to get last audio packet
        endIndex = bytes.byteLength;
        startIndex = endIndex - MP2T_PACKET_LENGTH;
        endLoop = false;
        while(startIndex >= 0){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case 'pes':
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === 'audio' && pusi) {
                            parsed = probe.ts.parsePesTime(packet);
                            if (parsed) {
                                parsed.type = 'audio';
                                result.audio.push(parsed);
                                endLoop = true;
                            }
                        }
                        break;
                }
                if (endLoop) break;
                startIndex -= MP2T_PACKET_LENGTH;
                endIndex -= MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex--;
            endIndex--;
        }
    };
    /**
   * walks through the segment data from the start and end to get timing information
   * for the first and last video pes packets as well as timing information for the first
   * key frame.
   */ var parseVideoPes_ = function(bytes, pmt, result) {
        var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type, pesType, pusi, parsed, frame, i, pes;
        var endLoop = false;
        var currentFrame = {
            data: [],
            size: 0
        }; // Start walking from start of segment to get first video packet
        while(endIndex < bytes.byteLength){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case 'pes':
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === 'video') {
                            if (pusi && !endLoop) {
                                parsed = probe.ts.parsePesTime(packet);
                                if (parsed) {
                                    parsed.type = 'video';
                                    result.video.push(parsed);
                                    endLoop = true;
                                }
                            }
                            if (!result.firstKeyFrame) {
                                if (pusi) {
                                    if (currentFrame.size !== 0) {
                                        frame = new Uint8Array(currentFrame.size);
                                        i = 0;
                                        while(currentFrame.data.length){
                                            pes = currentFrame.data.shift();
                                            frame.set(pes, i);
                                            i += pes.byteLength;
                                        }
                                        if (probe.ts.videoPacketContainsKeyFrame(frame)) {
                                            var firstKeyFrame = probe.ts.parsePesTime(frame); // PTS/DTS may not be available. Simply *not* setting
                                            // the keyframe seems to work fine with HLS playback
                                            // and definitely preferable to a crash with TypeError...
                                            if (firstKeyFrame) {
                                                result.firstKeyFrame = firstKeyFrame;
                                                result.firstKeyFrame.type = 'video';
                                            } else // eslint-disable-next-line
                                            console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                                        }
                                        currentFrame.size = 0;
                                    }
                                }
                                currentFrame.data.push(packet);
                                currentFrame.size += packet.byteLength;
                            }
                        }
                        break;
                }
                if (endLoop && result.firstKeyFrame) break;
                startIndex += MP2T_PACKET_LENGTH;
                endIndex += MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex++;
            endIndex++;
        } // Start walking from end of segment to get last video packet
        endIndex = bytes.byteLength;
        startIndex = endIndex - MP2T_PACKET_LENGTH;
        endLoop = false;
        while(startIndex >= 0){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case 'pes':
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === 'video' && pusi) {
                            parsed = probe.ts.parsePesTime(packet);
                            if (parsed) {
                                parsed.type = 'video';
                                result.video.push(parsed);
                                endLoop = true;
                            }
                        }
                        break;
                }
                if (endLoop) break;
                startIndex -= MP2T_PACKET_LENGTH;
                endIndex -= MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex--;
            endIndex--;
        }
    };
    /**
   * Adjusts the timestamp information for the segment to account for
   * rollover and convert to seconds based on pes packet timescale (90khz clock)
   */ var adjustTimestamp_ = function(segmentInfo, baseTimestamp) {
        if (segmentInfo.audio && segmentInfo.audio.length) {
            var audioBaseTimestamp = baseTimestamp;
            if (typeof audioBaseTimestamp === 'undefined' || isNaN(audioBaseTimestamp)) audioBaseTimestamp = segmentInfo.audio[0].dts;
            segmentInfo.audio.forEach(function(info) {
                info.dts = handleRollover(info.dts, audioBaseTimestamp);
                info.pts = handleRollover(info.pts, audioBaseTimestamp); // time in seconds
                info.dtsTime = info.dts / ONE_SECOND_IN_TS;
                info.ptsTime = info.pts / ONE_SECOND_IN_TS;
            });
        }
        if (segmentInfo.video && segmentInfo.video.length) {
            var videoBaseTimestamp = baseTimestamp;
            if (typeof videoBaseTimestamp === 'undefined' || isNaN(videoBaseTimestamp)) videoBaseTimestamp = segmentInfo.video[0].dts;
            segmentInfo.video.forEach(function(info) {
                info.dts = handleRollover(info.dts, videoBaseTimestamp);
                info.pts = handleRollover(info.pts, videoBaseTimestamp); // time in seconds
                info.dtsTime = info.dts / ONE_SECOND_IN_TS;
                info.ptsTime = info.pts / ONE_SECOND_IN_TS;
            });
            if (segmentInfo.firstKeyFrame) {
                var frame = segmentInfo.firstKeyFrame;
                frame.dts = handleRollover(frame.dts, videoBaseTimestamp);
                frame.pts = handleRollover(frame.pts, videoBaseTimestamp); // time in seconds
                frame.dtsTime = frame.dts / ONE_SECOND_IN_TS;
                frame.ptsTime = frame.pts / ONE_SECOND_IN_TS;
            }
        }
    };
    /**
   * inspects the aac data stream for start and end time information
   */ var inspectAac_ = function(bytes) {
        var endLoop = false, audioCount = 0, sampleRate = null, timestamp = null, frameSize = 0, byteIndex = 0, packet;
        while(bytes.length - byteIndex >= 3){
            var type = probe.aac.parseType(bytes, byteIndex);
            switch(type){
                case 'timed-metadata':
                    // Exit early because we don't have enough to parse
                    // the ID3 tag header
                    if (bytes.length - byteIndex < 10) {
                        endLoop = true;
                        break;
                    }
                    frameSize = probe.aac.parseId3TagSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    if (frameSize > bytes.length) {
                        endLoop = true;
                        break;
                    }
                    if (timestamp === null) {
                        packet = bytes.subarray(byteIndex, byteIndex + frameSize);
                        timestamp = probe.aac.parseAacTimestamp(packet);
                    }
                    byteIndex += frameSize;
                    break;
                case 'audio':
                    // Exit early because we don't have enough to parse
                    // the ADTS frame header
                    if (bytes.length - byteIndex < 7) {
                        endLoop = true;
                        break;
                    }
                    frameSize = probe.aac.parseAdtsSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    if (frameSize > bytes.length) {
                        endLoop = true;
                        break;
                    }
                    if (sampleRate === null) {
                        packet = bytes.subarray(byteIndex, byteIndex + frameSize);
                        sampleRate = probe.aac.parseSampleRate(packet);
                    }
                    audioCount++;
                    byteIndex += frameSize;
                    break;
                default:
                    byteIndex++;
                    break;
            }
            if (endLoop) return null;
        }
        if (sampleRate === null || timestamp === null) return null;
        var audioTimescale = ONE_SECOND_IN_TS / sampleRate;
        var result = {
            audio: [
                {
                    type: 'audio',
                    dts: timestamp,
                    pts: timestamp
                },
                {
                    type: 'audio',
                    dts: timestamp + audioCount * 1024 * audioTimescale,
                    pts: timestamp + audioCount * 1024 * audioTimescale
                }
            ]
        };
        return result;
    };
    /**
   * inspects the transport stream segment data for start and end time information
   * of the audio and video tracks (when present) as well as the first key frame's
   * start time.
   */ var inspectTs_ = function(bytes) {
        var pmt = {
            pid: null,
            table: null
        };
        var result = {};
        parsePsi_(bytes, pmt);
        for(var pid in pmt.table)if (pmt.table.hasOwnProperty(pid)) {
            var type = pmt.table[pid];
            switch(type){
                case StreamTypes.H264_STREAM_TYPE:
                    result.video = [];
                    parseVideoPes_(bytes, pmt, result);
                    if (result.video.length === 0) delete result.video;
                    break;
                case StreamTypes.ADTS_STREAM_TYPE:
                    result.audio = [];
                    parseAudioPes_(bytes, pmt, result);
                    if (result.audio.length === 0) delete result.audio;
                    break;
            }
        }
        return result;
    };
    /**
   * Inspects segment byte data and returns an object with start and end timing information
   *
   * @param {Uint8Array} bytes The segment byte data
   * @param {Number} baseTimestamp Relative reference timestamp used when adjusting frame
   *  timestamps for rollover. This value must be in 90khz clock.
   * @return {Object} Object containing start and end frame timing info of segment.
   */ var inspect = function(bytes, baseTimestamp) {
        var isAacData = probe.aac.isLikelyAacData(bytes);
        var result;
        if (isAacData) result = inspectAac_(bytes);
        else result = inspectTs_(bytes);
        if (!result || !result.audio && !result.video) return null;
        adjustTimestamp_(result, baseTimestamp);
        return result;
    };
    var tsInspector = {
        inspect: inspect,
        parseAudioPes_: parseAudioPes_
    };
    /* global self */ /**
   * Re-emits transmuxer events by converting them into messages to the
   * world outside the worker.
   *
   * @param {Object} transmuxer the transmuxer to wire events on
   * @private
   */ const wireTransmuxerEvents = function(self1, transmuxer) {
        transmuxer.on('data', function(segment) {
            // transfer ownership of the underlying ArrayBuffer
            // instead of doing a copy to save memory
            // ArrayBuffers are transferable but generic TypedArrays are not
            // @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers#Passing_data_by_transferring_ownership_(transferable_objects)
            const initArray = segment.initSegment;
            segment.initSegment = {
                data: initArray.buffer,
                byteOffset: initArray.byteOffset,
                byteLength: initArray.byteLength
            };
            const typedArray = segment.data;
            segment.data = typedArray.buffer;
            self1.postMessage({
                action: 'data',
                segment: segment,
                byteOffset: typedArray.byteOffset,
                byteLength: typedArray.byteLength
            }, [
                segment.data
            ]);
        });
        transmuxer.on('done', function(data) {
            self1.postMessage({
                action: 'done'
            });
        });
        transmuxer.on('gopInfo', function(gopInfo) {
            self1.postMessage({
                action: 'gopInfo',
                gopInfo: gopInfo
            });
        });
        transmuxer.on('videoSegmentTimingInfo', function(timingInfo) {
            const videoSegmentTimingInfo = {
                start: {
                    decode: clock$2.videoTsToSeconds(timingInfo.start.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.start.pts)
                },
                end: {
                    decode: clock$2.videoTsToSeconds(timingInfo.end.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.end.pts)
                },
                baseMediaDecodeTime: clock$2.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
            };
            if (timingInfo.prependedContentDuration) videoSegmentTimingInfo.prependedContentDuration = clock$2.videoTsToSeconds(timingInfo.prependedContentDuration);
            self1.postMessage({
                action: 'videoSegmentTimingInfo',
                videoSegmentTimingInfo: videoSegmentTimingInfo
            });
        });
        transmuxer.on('audioSegmentTimingInfo', function(timingInfo) {
            // Note that all times for [audio/video]SegmentTimingInfo events are in video clock
            const audioSegmentTimingInfo = {
                start: {
                    decode: clock$2.videoTsToSeconds(timingInfo.start.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.start.pts)
                },
                end: {
                    decode: clock$2.videoTsToSeconds(timingInfo.end.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.end.pts)
                },
                baseMediaDecodeTime: clock$2.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
            };
            if (timingInfo.prependedContentDuration) audioSegmentTimingInfo.prependedContentDuration = clock$2.videoTsToSeconds(timingInfo.prependedContentDuration);
            self1.postMessage({
                action: 'audioSegmentTimingInfo',
                audioSegmentTimingInfo: audioSegmentTimingInfo
            });
        });
        transmuxer.on('id3Frame', function(id3Frame) {
            self1.postMessage({
                action: 'id3Frame',
                id3Frame: id3Frame
            });
        });
        transmuxer.on('caption', function(caption) {
            self1.postMessage({
                action: 'caption',
                caption: caption
            });
        });
        transmuxer.on('trackinfo', function(trackInfo) {
            self1.postMessage({
                action: 'trackinfo',
                trackInfo: trackInfo
            });
        });
        transmuxer.on('audioTimingInfo', function(audioTimingInfo) {
            // convert to video TS since we prioritize video time over audio
            self1.postMessage({
                action: 'audioTimingInfo',
                audioTimingInfo: {
                    start: clock$2.videoTsToSeconds(audioTimingInfo.start),
                    end: clock$2.videoTsToSeconds(audioTimingInfo.end)
                }
            });
        });
        transmuxer.on('videoTimingInfo', function(videoTimingInfo) {
            self1.postMessage({
                action: 'videoTimingInfo',
                videoTimingInfo: {
                    start: clock$2.videoTsToSeconds(videoTimingInfo.start),
                    end: clock$2.videoTsToSeconds(videoTimingInfo.end)
                }
            });
        });
        transmuxer.on('log', function(log) {
            self1.postMessage({
                action: 'log',
                log: log
            });
        });
    };
    /**
   * All incoming messages route through this hash. If no function exists
   * to handle an incoming message, then we ignore the message.
   *
   * @class MessageHandlers
   * @param {Object} options the options to initialize with
   */ class MessageHandlers {
        constructor(self1, options){
            this.options = options || {};
            this.self = self1;
            this.init();
        }
        /**
     * initialize our web worker and wire all the events.
     */ init() {
            if (this.transmuxer) this.transmuxer.dispose();
            this.transmuxer = new transmuxer.Transmuxer(this.options);
            wireTransmuxerEvents(this.self, this.transmuxer);
        }
        pushMp4Captions(data) {
            if (!this.captionParser) {
                this.captionParser = new captionParser();
                this.captionParser.init();
            }
            const segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
            const parsed = this.captionParser.parse(segment, data.trackIds, data.timescales);
            this.self.postMessage({
                action: 'mp4Captions',
                captions: parsed && parsed.captions || [],
                logs: parsed && parsed.logs || [],
                data: segment.buffer
            }, [
                segment.buffer
            ]);
        }
        /**
     * Initializes the WebVttParser and passes the init segment.
     *
     * @param {Uint8Array} data mp4 boxed WebVTT init segment data
     */ initMp4WebVttParser(data) {
            if (!this.webVttParser) this.webVttParser = new webvttParser();
            const segment = new Uint8Array(data.data, data.byteOffset, data.byteLength); // Set the timescale for the parser.
            // This can be called repeatedly in order to set and re-set the timescale.
            this.webVttParser.init(segment);
        }
        /**
     * Parse an mp4 encapsulated WebVTT segment and return an array of cues.
     *
     * @param {Uint8Array} data a text/webvtt segment
     * @return {Object[]} an array of parsed cue objects
     */ getMp4WebVttText(data) {
            if (!this.webVttParser) // timescale might not be set yet if the parser is created before an init segment is passed.
            // default timescale is 90k.
            this.webVttParser = new webvttParser();
            const segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
            const parsed = this.webVttParser.parseSegment(segment);
            this.self.postMessage({
                action: 'getMp4WebVttText',
                mp4VttCues: parsed || [],
                data: segment.buffer
            }, [
                segment.buffer
            ]);
        }
        probeMp4StartTime({ timescales: timescales, data: data }) {
            const startTime = probe$2.startTime(timescales, data);
            this.self.postMessage({
                action: 'probeMp4StartTime',
                startTime: startTime,
                data: data
            }, [
                data.buffer
            ]);
        }
        probeMp4Tracks({ data: data }) {
            const tracks = probe$2.tracks(data);
            this.self.postMessage({
                action: 'probeMp4Tracks',
                tracks: tracks,
                data: data
            }, [
                data.buffer
            ]);
        }
        /**
     * Probes an mp4 segment for EMSG boxes containing ID3 data.
     * https://aomediacodec.github.io/id3-emsg/
     *
     * @param {Uint8Array} data segment data
     * @param {number} offset segment start time
     * @return {Object[]} an array of ID3 frames
     */ probeEmsgID3({ data: data, offset: offset }) {
            const id3Frames = probe$2.getEmsgID3(data, offset);
            this.self.postMessage({
                action: 'probeEmsgID3',
                id3Frames: id3Frames,
                emsgData: data
            }, [
                data.buffer
            ]);
        }
        /**
     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
     * internal "media time," as well as whether it contains video and/or audio.
     *
     * @private
     * @param {Uint8Array} bytes - segment bytes
     * @param {number} baseStartTime
     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
     *        This value should be in seconds, as it's converted to a 90khz clock within the
     *        function body.
     * @return {Object} The start time of the current segment in "media time" as well as
     *                  whether it contains video and/or audio
     */ probeTs({ data: data, baseStartTime: baseStartTime }) {
            const tsStartTime = typeof baseStartTime === 'number' && !isNaN(baseStartTime) ? baseStartTime * clock$2.ONE_SECOND_IN_TS : void 0;
            const timeInfo = tsInspector.inspect(data, tsStartTime);
            let result = null;
            if (timeInfo) {
                result = {
                    // each type's time info comes back as an array of 2 times, start and end
                    hasVideo: timeInfo.video && timeInfo.video.length === 2 || false,
                    hasAudio: timeInfo.audio && timeInfo.audio.length === 2 || false
                };
                if (result.hasVideo) result.videoStart = timeInfo.video[0].ptsTime;
                if (result.hasAudio) result.audioStart = timeInfo.audio[0].ptsTime;
            }
            this.self.postMessage({
                action: 'probeTs',
                result: result,
                data: data
            }, [
                data.buffer
            ]);
        }
        clearAllMp4Captions() {
            if (this.captionParser) this.captionParser.clearAllCaptions();
        }
        clearParsedMp4Captions() {
            if (this.captionParser) this.captionParser.clearParsedCaptions();
        }
        /**
     * Adds data (a ts segment) to the start of the transmuxer pipeline for
     * processing.
     *
     * @param {ArrayBuffer} data data to push into the muxer
     */ push(data) {
            // Cast array buffer to correct type for transmuxer
            const segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
            this.transmuxer.push(segment);
        }
        /**
     * Recreate the transmuxer so that the next segment added via `push`
     * start with a fresh transmuxer.
     */ reset() {
            this.transmuxer.reset();
        }
        /**
     * Set the value that will be used as the `baseMediaDecodeTime` time for the
     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
     * set relative to the first based on the PTS values.
     *
     * @param {Object} data used to set the timestamp offset in the muxer
     */ setTimestampOffset(data) {
            const timestampOffset = data.timestampOffset || 0;
            this.transmuxer.setBaseMediaDecodeTime(Math.round(clock$2.secondsToVideoTs(timestampOffset)));
        }
        setAudioAppendStart(data) {
            this.transmuxer.setAudioAppendStart(Math.ceil(clock$2.secondsToVideoTs(data.appendStart)));
        }
        setRemux(data) {
            this.transmuxer.setRemux(data.remux);
        }
        /**
     * Forces the pipeline to finish processing the last segment and emit it's
     * results.
     *
     * @param {Object} data event data, not really used
     */ flush(data) {
            this.transmuxer.flush(); // transmuxed done action is fired after both audio/video pipelines are flushed
            self.postMessage({
                action: 'done',
                type: 'transmuxed'
            });
        }
        endTimeline() {
            this.transmuxer.endTimeline(); // transmuxed endedtimeline action is fired after both audio/video pipelines end their
            // timelines
            self.postMessage({
                action: 'endedtimeline',
                type: 'transmuxed'
            });
        }
        alignGopsWith(data) {
            this.transmuxer.alignGopsWith(data.gopsToAlignWith.slice());
        }
    }
    /**
   * Our web worker interface so that things can talk to mux.js
   * that will be running in a web worker. the scope is passed to this by
   * webworkify.
   *
   * @param {Object} self the scope for the web worker
   */ self.onmessage = function(event) {
        if (event.data.action === 'init' && event.data.options) {
            this.messageHandlers = new MessageHandlers(self, event.data.options);
            return;
        }
        if (!this.messageHandlers) this.messageHandlers = new MessageHandlers(self);
        if (event.data && event.data.action && event.data.action !== 'init') {
            if (this.messageHandlers[event.data.action]) this.messageHandlers[event.data.action](event.data);
        }
    };
}));
var $cb03b711053a4297$var$TransmuxWorker = $cb03b711053a4297$var$factory($cb03b711053a4297$var$workerCode$1);
/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */ const $cb03b711053a4297$var$handleData_ = (event, transmuxedData, callback)=>{
    const { type: type, initSegment: initSegment, captions: captions, captionStreams: captionStreams, metadata: metadata, videoFrameDtsTime: videoFrameDtsTime, videoFramePtsTime: videoFramePtsTime } = event.data.segment;
    transmuxedData.buffer.push({
        captions: captions,
        captionStreams: captionStreams,
        metadata: metadata
    });
    const boxes = event.data.segment.boxes || {
        data: event.data.segment.data
    };
    const result = {
        type: type,
        // cast ArrayBuffer to TypedArray
        data: new Uint8Array(boxes.data, boxes.data.byteOffset, boxes.data.byteLength),
        initSegment: new Uint8Array(initSegment.data, initSegment.byteOffset, initSegment.byteLength)
    };
    if (typeof videoFrameDtsTime !== 'undefined') result.videoFrameDtsTime = videoFrameDtsTime;
    if (typeof videoFramePtsTime !== 'undefined') result.videoFramePtsTime = videoFramePtsTime;
    callback(result);
};
const $cb03b711053a4297$var$handleDone_ = ({ transmuxedData: transmuxedData, callback: callback })=>{
    // Previously we only returned data on data events,
    // not on done events. Clear out the buffer to keep that consistent.
    transmuxedData.buffer = []; // all buffers should have been flushed from the muxer, so start processing anything we
    // have received
    callback(transmuxedData);
};
const $cb03b711053a4297$var$handleGopInfo_ = (event, transmuxedData)=>{
    transmuxedData.gopInfo = event.data.gopInfo;
};
const $cb03b711053a4297$var$processTransmux = (options)=>{
    const { transmuxer: transmuxer, bytes: bytes, audioAppendStart: audioAppendStart, gopsToAlignWith: gopsToAlignWith, remux: remux, onData: onData, onTrackInfo: onTrackInfo, onAudioTimingInfo: onAudioTimingInfo, onVideoTimingInfo: onVideoTimingInfo, onVideoSegmentTimingInfo: onVideoSegmentTimingInfo, onAudioSegmentTimingInfo: onAudioSegmentTimingInfo, onId3: onId3, onCaptions: onCaptions, onDone: onDone, onEndedTimeline: onEndedTimeline, onTransmuxerLog: onTransmuxerLog, isEndOfTimeline: isEndOfTimeline, segment: segment, triggerSegmentEventFn: triggerSegmentEventFn } = options;
    const transmuxedData = {
        buffer: []
    };
    let waitForEndedTimelineEvent = isEndOfTimeline;
    const handleMessage = (event)=>{
        if (transmuxer.currentTransmux !== options) // disposed
        return;
        if (event.data.action === 'data') $cb03b711053a4297$var$handleData_(event, transmuxedData, onData);
        if (event.data.action === 'trackinfo') onTrackInfo(event.data.trackInfo);
        if (event.data.action === 'gopInfo') $cb03b711053a4297$var$handleGopInfo_(event, transmuxedData);
        if (event.data.action === 'audioTimingInfo') onAudioTimingInfo(event.data.audioTimingInfo);
        if (event.data.action === 'videoTimingInfo') onVideoTimingInfo(event.data.videoTimingInfo);
        if (event.data.action === 'videoSegmentTimingInfo') onVideoSegmentTimingInfo(event.data.videoSegmentTimingInfo);
        if (event.data.action === 'audioSegmentTimingInfo') onAudioSegmentTimingInfo(event.data.audioSegmentTimingInfo);
        if (event.data.action === 'id3Frame') onId3([
            event.data.id3Frame
        ], event.data.id3Frame.dispatchType);
        if (event.data.action === 'caption') onCaptions(event.data.caption);
        if (event.data.action === 'endedtimeline') {
            waitForEndedTimelineEvent = false;
            onEndedTimeline();
        }
        if (event.data.action === 'log') onTransmuxerLog(event.data.log);
         // wait for the transmuxed event since we may have audio and video
        if (event.data.type !== 'transmuxed') return;
         // If the "endedtimeline" event has not yet fired, and this segment represents the end
        // of a timeline, that means there may still be data events before the segment
        // processing can be considerred complete. In that case, the final event should be
        // an "endedtimeline" event with the type "transmuxed."
        if (waitForEndedTimelineEvent) return;
        transmuxer.onmessage = null;
        $cb03b711053a4297$var$handleDone_({
            transmuxedData: transmuxedData,
            callback: onDone
        });
        /* eslint-disable no-use-before-define */ $cb03b711053a4297$var$dequeue(transmuxer);
    /* eslint-enable */ };
    const handleError = ()=>{
        const error = {
            message: 'Received an error message from the transmuxer worker',
            metadata: {
                errorType: $cb03b711053a4297$export$2e2bcd8739ae039.Error.StreamingFailedToTransmuxSegment,
                segmentInfo: $cb03b711053a4297$var$segmentInfoPayload({
                    segment: segment
                })
            }
        };
        onDone(null, error);
    };
    transmuxer.onmessage = handleMessage;
    transmuxer.onerror = handleError;
    if (audioAppendStart) transmuxer.postMessage({
        action: 'setAudioAppendStart',
        appendStart: audioAppendStart
    });
     // allow empty arrays to be passed to clear out GOPs
    if (Array.isArray(gopsToAlignWith)) transmuxer.postMessage({
        action: 'alignGopsWith',
        gopsToAlignWith: gopsToAlignWith
    });
    if (typeof remux !== 'undefined') transmuxer.postMessage({
        action: 'setRemux',
        remux: remux
    });
    if (bytes.byteLength) {
        const buffer = bytes instanceof ArrayBuffer ? bytes : bytes.buffer;
        const byteOffset = bytes instanceof ArrayBuffer ? 0 : bytes.byteOffset;
        triggerSegmentEventFn({
            type: 'segmenttransmuxingstart',
            segment: segment
        });
        transmuxer.postMessage({
            action: 'push',
            // Send the typed-array of data as an ArrayBuffer so that
            // it can be sent as a "Transferable" and avoid the costly
            // memory copy
            data: buffer,
            byteOffset: // To recreate the original typed-array, we need information
            // about what portion of the ArrayBuffer it was a view into
            byteOffset,
            byteLength: bytes.byteLength
        }, [
            buffer
        ]);
    }
    if (isEndOfTimeline) transmuxer.postMessage({
        action: 'endTimeline'
    });
     // even if we didn't push any bytes, we have to make sure we flush in case we reached
    // the end of the segment
    transmuxer.postMessage({
        action: 'flush'
    });
};
const $cb03b711053a4297$var$dequeue = (transmuxer)=>{
    transmuxer.currentTransmux = null;
    if (transmuxer.transmuxQueue.length) {
        transmuxer.currentTransmux = transmuxer.transmuxQueue.shift();
        if (typeof transmuxer.currentTransmux === 'function') transmuxer.currentTransmux();
        else $cb03b711053a4297$var$processTransmux(transmuxer.currentTransmux);
    }
};
const $cb03b711053a4297$var$processAction = (transmuxer, action)=>{
    transmuxer.postMessage({
        action: action
    });
    $cb03b711053a4297$var$dequeue(transmuxer);
};
const $cb03b711053a4297$var$enqueueAction = (action, transmuxer)=>{
    if (!transmuxer.currentTransmux) {
        transmuxer.currentTransmux = action;
        $cb03b711053a4297$var$processAction(transmuxer, action);
        return;
    }
    transmuxer.transmuxQueue.push($cb03b711053a4297$var$processAction.bind(null, transmuxer, action));
};
const $cb03b711053a4297$var$reset = (transmuxer)=>{
    $cb03b711053a4297$var$enqueueAction('reset', transmuxer);
};
const $cb03b711053a4297$var$endTimeline = (transmuxer)=>{
    $cb03b711053a4297$var$enqueueAction('endTimeline', transmuxer);
};
const $cb03b711053a4297$var$transmux = (options)=>{
    if (!options.transmuxer.currentTransmux) {
        options.transmuxer.currentTransmux = options;
        $cb03b711053a4297$var$processTransmux(options);
        return;
    }
    options.transmuxer.transmuxQueue.push(options);
};
const $cb03b711053a4297$var$createTransmuxer = (options)=>{
    const transmuxer = new $cb03b711053a4297$var$TransmuxWorker();
    transmuxer.currentTransmux = null;
    transmuxer.transmuxQueue = [];
    const term = transmuxer.terminate;
    transmuxer.terminate = ()=>{
        transmuxer.currentTransmux = null;
        transmuxer.transmuxQueue.length = 0;
        return term.call(transmuxer);
    };
    transmuxer.postMessage({
        action: 'init',
        options: options
    });
    return transmuxer;
};
var $cb03b711053a4297$var$segmentTransmuxer = {
    reset: $cb03b711053a4297$var$reset,
    endTimeline: $cb03b711053a4297$var$endTimeline,
    transmux: $cb03b711053a4297$var$transmux,
    createTransmuxer: $cb03b711053a4297$var$createTransmuxer
};
const $cb03b711053a4297$var$workerCallback = function(options) {
    const transmuxer = options.transmuxer;
    const endAction = options.endAction || options.action;
    const callback = options.callback;
    const message = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, options, {
        endAction: null,
        transmuxer: null,
        callback: null
    });
    const listenForEndEvent = (event)=>{
        if (event.data.action !== endAction) return;
        transmuxer.removeEventListener('message', listenForEndEvent); // transfer ownership of bytes back to us.
        if (event.data.data) {
            event.data.data = new Uint8Array(event.data.data, options.byteOffset || 0, options.byteLength || event.data.data.byteLength);
            if (options.data) options.data = event.data.data;
        }
        callback(event.data);
    };
    transmuxer.addEventListener('message', listenForEndEvent);
    if (options.data) {
        const isArrayBuffer = options.data instanceof ArrayBuffer;
        message.byteOffset = isArrayBuffer ? 0 : options.data.byteOffset;
        message.byteLength = options.data.byteLength;
        const transfers = [
            isArrayBuffer ? options.data : options.data.buffer
        ];
        transmuxer.postMessage(message, transfers);
    } else transmuxer.postMessage(message);
};
const $cb03b711053a4297$var$REQUEST_ERRORS = {
    FAILURE: 2,
    TIMEOUT: -101,
    ABORTED: -102
};
const $cb03b711053a4297$var$WEB_VTT_CODEC = 'wvtt';
/**
 * Abort all requests
 *
 * @param {Object} activeXhrs - an object that tracks all XHR requests
 */ const $cb03b711053a4297$var$abortAll = (activeXhrs)=>{
    activeXhrs.forEach((xhr)=>{
        xhr.abort();
    });
};
/**
 * Gather important bandwidth stats once a request has completed
 *
 * @param {Object} request - the XHR request from which to gather stats
 */ const $cb03b711053a4297$var$getRequestStats = (request)=>{
    return {
        bandwidth: request.bandwidth,
        bytesReceived: request.bytesReceived || 0,
        roundTripTime: request.roundTripTime || 0
    };
};
/**
 * If possible gather bandwidth stats as a request is in
 * progress
 *
 * @param {Event} progressEvent - an event object from an XHR's progress event
 */ const $cb03b711053a4297$var$getProgressStats = (progressEvent)=>{
    const request = progressEvent.target;
    const roundTripTime = Date.now() - request.requestTime;
    const stats = {
        bandwidth: Infinity,
        bytesReceived: 0,
        roundTripTime: roundTripTime || 0
    };
    stats.bytesReceived = progressEvent.loaded; // This can result in Infinity if stats.roundTripTime is 0 but that is ok
    // because we should only use bandwidth stats on progress to determine when
    // abort a request early due to insufficient bandwidth
    stats.bandwidth = Math.floor(stats.bytesReceived / stats.roundTripTime * 8000);
    return stats;
};
/**
 * Handle all error conditions in one place and return an object
 * with all the information
 *
 * @param {Error|null} error - if non-null signals an error occured with the XHR
 * @param {Object} request -  the XHR request that possibly generated the error
 */ const $cb03b711053a4297$var$handleErrors = (error, request)=>{
    const { requestType: requestType } = request;
    const metadata = $cb03b711053a4297$var$getStreamingNetworkErrorMetadata({
        requestType: requestType,
        request: request,
        error: error
    });
    if (request.timedout) return {
        status: request.status,
        message: 'HLS request timed-out at URL: ' + request.uri,
        code: $cb03b711053a4297$var$REQUEST_ERRORS.TIMEOUT,
        xhr: request,
        metadata: metadata
    };
    if (request.aborted) return {
        status: request.status,
        message: 'HLS request aborted at URL: ' + request.uri,
        code: $cb03b711053a4297$var$REQUEST_ERRORS.ABORTED,
        xhr: request,
        metadata: metadata
    };
    if (error) return {
        status: request.status,
        message: 'HLS request errored at URL: ' + request.uri,
        code: $cb03b711053a4297$var$REQUEST_ERRORS.FAILURE,
        xhr: request,
        metadata: metadata
    };
    if (request.responseType === 'arraybuffer' && request.response.byteLength === 0) return {
        status: request.status,
        message: 'Empty HLS response at URL: ' + request.uri,
        code: $cb03b711053a4297$var$REQUEST_ERRORS.FAILURE,
        xhr: request,
        metadata: metadata
    };
    return null;
};
/**
 * Handle responses for key data and convert the key data to the correct format
 * for the decryption step later
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Array} objects - objects to add the key bytes to.
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */ const $cb03b711053a4297$var$handleKeyResponse = (segment, objects, finishProcessingFn, triggerSegmentEventFn)=>(error, request)=>{
        const response = request.response;
        const errorObj = $cb03b711053a4297$var$handleErrors(error, request);
        if (errorObj) return finishProcessingFn(errorObj, segment);
        if (response.byteLength !== 16) return finishProcessingFn({
            status: request.status,
            message: 'Invalid HLS key at URL: ' + request.uri,
            code: $cb03b711053a4297$var$REQUEST_ERRORS.FAILURE,
            xhr: request
        }, segment);
        const view = new DataView(response);
        const bytes = new Uint32Array([
            view.getUint32(0),
            view.getUint32(4),
            view.getUint32(8),
            view.getUint32(12)
        ]);
        for(let i = 0; i < objects.length; i++)objects[i].bytes = bytes;
        const keyInfo = {
            uri: request.uri
        };
        triggerSegmentEventFn({
            type: 'segmentkeyloadcomplete',
            segment: segment,
            keyInfo: keyInfo
        });
        return finishProcessingFn(null, segment);
    };
/**
 * Processes an mp4 init segment depending on the codec through the transmuxer.
 *
 * @param {Object} segment init segment to process
 * @param {string} codec the codec of the text segments
 */ const $cb03b711053a4297$var$initMp4Text = (segment, codec)=>{
    if (codec === $cb03b711053a4297$var$WEB_VTT_CODEC) segment.transmuxer.postMessage({
        action: 'initMp4WebVttParser',
        data: segment.map.bytes
    });
};
/**
 * Parses an mp4 text segment with the transmuxer and calls the doneFn from
 * the segment loader.
 *
 * @param {Object} segment the text segment to parse
 * @param {string} codec the codec of the text segment
 * @param {Function} doneFn the doneFn passed from the segment loader
 */ const $cb03b711053a4297$var$parseMp4TextSegment = (segment, codec, doneFn)=>{
    if (codec === $cb03b711053a4297$var$WEB_VTT_CODEC) $cb03b711053a4297$var$workerCallback({
        action: 'getMp4WebVttText',
        data: segment.bytes,
        transmuxer: segment.transmuxer,
        callback: ({ data: data, mp4VttCues: mp4VttCues })=>{
            segment.bytes = data;
            doneFn(null, segment, {
                mp4VttCues: mp4VttCues
            });
        }
    });
};
const $cb03b711053a4297$var$parseInitSegment = (segment, callback)=>{
    const type = (0, $bChVV.detectContainerForBytes)(segment.map.bytes); // TODO: We should also handle ts init segments here, but we
    // only know how to parse mp4 init segments at the moment
    if (type !== 'mp4') {
        const uri = segment.map.resolvedUri || segment.map.uri;
        const mediaType = type || 'unknown';
        return callback({
            internal: true,
            message: `Found unsupported ${mediaType} container for initialization segment at URL: ${uri}`,
            code: $cb03b711053a4297$var$REQUEST_ERRORS.FAILURE,
            metadata: {
                mediaType: mediaType
            }
        });
    }
    $cb03b711053a4297$var$workerCallback({
        action: 'probeMp4Tracks',
        data: segment.map.bytes,
        transmuxer: segment.transmuxer,
        callback: ({ tracks: tracks, data: data })=>{
            // transfer bytes back to us
            segment.map.bytes = data;
            tracks.forEach(function(track) {
                segment.map.tracks = segment.map.tracks || {}; // only support one track of each type for now
                if (segment.map.tracks[track.type]) return;
                segment.map.tracks[track.type] = track;
                if (typeof track.id === 'number' && track.timescale) {
                    segment.map.timescales = segment.map.timescales || {};
                    segment.map.timescales[track.id] = track.timescale;
                }
                if (track.type === 'text') $cb03b711053a4297$var$initMp4Text(segment, track.codec);
            });
            return callback(null);
        }
    });
};
/**
 * Handle init-segment responses
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */ const $cb03b711053a4297$var$handleInitSegmentResponse = ({ segment: segment, finishProcessingFn: finishProcessingFn, triggerSegmentEventFn: triggerSegmentEventFn })=>(error, request)=>{
        const errorObj = $cb03b711053a4297$var$handleErrors(error, request);
        if (errorObj) return finishProcessingFn(errorObj, segment);
        const bytes = new Uint8Array(request.response);
        triggerSegmentEventFn({
            type: 'segmentloaded',
            segment: segment
        }); // init segment is encypted, we will have to wait
        // until the key request is done to decrypt.
        if (segment.map.key) {
            segment.map.encryptedBytes = bytes;
            return finishProcessingFn(null, segment);
        }
        segment.map.bytes = bytes;
        $cb03b711053a4297$var$parseInitSegment(segment, function(parseError) {
            if (parseError) {
                parseError.xhr = request;
                parseError.status = request.status;
                return finishProcessingFn(parseError, segment);
            }
            finishProcessingFn(null, segment);
        });
    };
/**
 * Response handler for segment-requests being sure to set the correct
 * property depending on whether the segment is encryped or not
 * Also records and keeps track of stats that are used for ABR purposes
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */ const $cb03b711053a4297$var$handleSegmentResponse = ({ segment: segment, finishProcessingFn: finishProcessingFn, responseType: responseType, triggerSegmentEventFn: triggerSegmentEventFn })=>(error, request)=>{
        const errorObj = $cb03b711053a4297$var$handleErrors(error, request);
        if (errorObj) return finishProcessingFn(errorObj, segment);
        triggerSegmentEventFn({
            type: 'segmentloaded',
            segment: segment
        });
        const newBytes = // although responseText "should" exist, this guard serves to prevent an error being
        // thrown for two primary cases:
        // 1. the mime type override stops working, or is not implemented for a specific
        //    browser
        // 2. when using mock XHR libraries like sinon that do not allow the override behavior
        responseType === 'arraybuffer' || !request.responseText ? request.response : $cb03b711053a4297$var$stringToArrayBuffer(request.responseText.substring(segment.lastReachedChar || 0));
        segment.stats = $cb03b711053a4297$var$getRequestStats(request);
        if (segment.key) segment.encryptedBytes = new Uint8Array(newBytes);
        else segment.bytes = new Uint8Array(newBytes);
        return finishProcessingFn(null, segment);
    };
const $cb03b711053a4297$var$transmuxAndNotify = ({ segment: segment, bytes: bytes, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog, triggerSegmentEventFn: triggerSegmentEventFn })=>{
    const fmp4Tracks = segment.map && segment.map.tracks || {};
    const isMuxed = Boolean(fmp4Tracks.audio && fmp4Tracks.video); // Keep references to each function so we can null them out after we're done with them.
    // One reason for this is that in the case of full segments, we want to trust start
    // times from the probe, rather than the transmuxer.
    let audioStartFn = timingInfoFn.bind(null, segment, 'audio', 'start');
    const audioEndFn = timingInfoFn.bind(null, segment, 'audio', 'end');
    let videoStartFn = timingInfoFn.bind(null, segment, 'video', 'start');
    const videoEndFn = timingInfoFn.bind(null, segment, 'video', 'end');
    const finish = ()=>$cb03b711053a4297$var$transmux({
            bytes: bytes,
            transmuxer: segment.transmuxer,
            audioAppendStart: segment.audioAppendStart,
            gopsToAlignWith: segment.gopsToAlignWith,
            remux: isMuxed,
            onData: (result)=>{
                result.type = result.type === 'combined' ? 'video' : result.type;
                dataFn(segment, result);
            },
            onTrackInfo: (trackInfo)=>{
                if (trackInfoFn) {
                    if (isMuxed) trackInfo.isMuxed = true;
                    trackInfoFn(segment, trackInfo);
                }
            },
            onAudioTimingInfo: (audioTimingInfo)=>{
                // we only want the first start value we encounter
                if (audioStartFn && typeof audioTimingInfo.start !== 'undefined') {
                    audioStartFn(audioTimingInfo.start);
                    audioStartFn = null;
                } // we want to continually update the end time
                if (audioEndFn && typeof audioTimingInfo.end !== 'undefined') audioEndFn(audioTimingInfo.end);
            },
            onVideoTimingInfo: (videoTimingInfo)=>{
                // we only want the first start value we encounter
                if (videoStartFn && typeof videoTimingInfo.start !== 'undefined') {
                    videoStartFn(videoTimingInfo.start);
                    videoStartFn = null;
                } // we want to continually update the end time
                if (videoEndFn && typeof videoTimingInfo.end !== 'undefined') videoEndFn(videoTimingInfo.end);
            },
            onVideoSegmentTimingInfo: (videoSegmentTimingInfo)=>{
                const timingInfo = {
                    pts: {
                        start: videoSegmentTimingInfo.start.presentation,
                        end: videoSegmentTimingInfo.end.presentation
                    },
                    dts: {
                        start: videoSegmentTimingInfo.start.decode,
                        end: videoSegmentTimingInfo.end.decode
                    }
                };
                triggerSegmentEventFn({
                    type: 'segmenttransmuxingtiminginfoavailable',
                    segment: segment,
                    timingInfo: timingInfo
                });
                videoSegmentTimingInfoFn(videoSegmentTimingInfo);
            },
            onAudioSegmentTimingInfo: (audioSegmentTimingInfo)=>{
                const timingInfo = {
                    pts: {
                        start: audioSegmentTimingInfo.start.pts,
                        end: audioSegmentTimingInfo.end.pts
                    },
                    dts: {
                        start: audioSegmentTimingInfo.start.dts,
                        end: audioSegmentTimingInfo.end.dts
                    }
                };
                triggerSegmentEventFn({
                    type: 'segmenttransmuxingtiminginfoavailable',
                    segment: segment,
                    timingInfo: timingInfo
                });
                audioSegmentTimingInfoFn(audioSegmentTimingInfo);
            },
            onId3: (id3Frames, dispatchType)=>{
                id3Fn(segment, id3Frames, dispatchType);
            },
            onCaptions: (captions)=>{
                captionsFn(segment, [
                    captions
                ]);
            },
            isEndOfTimeline: isEndOfTimeline,
            onEndedTimeline: ()=>{
                endedTimelineFn();
            },
            onTransmuxerLog: onTransmuxerLog,
            onDone: (result, error)=>{
                if (!doneFn) return;
                result.type = result.type === 'combined' ? 'video' : result.type;
                triggerSegmentEventFn({
                    type: 'segmenttransmuxingcomplete',
                    segment: segment
                });
                doneFn(error, segment, result);
            },
            segment: segment,
            triggerSegmentEventFn: triggerSegmentEventFn
        }); // In the transmuxer, we don't yet have the ability to extract a "proper" start time.
    // Meaning cached frame data may corrupt our notion of where this segment
    // really starts. To get around this, probe for the info needed.
    $cb03b711053a4297$var$workerCallback({
        action: 'probeTs',
        transmuxer: segment.transmuxer,
        data: bytes,
        baseStartTime: segment.baseStartTime,
        callback: (data)=>{
            segment.bytes = bytes = data.data;
            const probeResult = data.result;
            if (probeResult) {
                trackInfoFn(segment, {
                    hasAudio: probeResult.hasAudio,
                    hasVideo: probeResult.hasVideo,
                    isMuxed: isMuxed
                });
                trackInfoFn = null;
            }
            finish();
        }
    });
};
const $cb03b711053a4297$var$handleSegmentBytes = ({ segment: segment, bytes: bytes, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog, triggerSegmentEventFn: triggerSegmentEventFn })=>{
    let bytesAsUint8Array = new Uint8Array(bytes); // TODO:
    // We should have a handler that fetches the number of bytes required
    // to check if something is fmp4. This will allow us to save bandwidth
    // because we can only exclude a playlist and abort requests
    // by codec after trackinfo triggers.
    if ((0, $bChVV.isLikelyFmp4MediaSegment)(bytesAsUint8Array)) {
        segment.isFmp4 = true;
        const { tracks: tracks } = segment.map;
        const isMp4TextSegment = tracks.text && (!tracks.audio || !tracks.video);
        if (isMp4TextSegment) {
            dataFn(segment, {
                data: bytesAsUint8Array,
                type: 'text'
            });
            $cb03b711053a4297$var$parseMp4TextSegment(segment, tracks.text.codec, doneFn);
            return;
        }
        const trackInfo = {
            isFmp4: true,
            hasVideo: !!tracks.video,
            hasAudio: !!tracks.audio
        }; // if we have a audio track, with a codec that is not set to
        // encrypted audio
        if (tracks.audio && tracks.audio.codec && tracks.audio.codec !== 'enca') trackInfo.audioCodec = tracks.audio.codec;
         // if we have a video track, with a codec that is not set to
        // encrypted video
        if (tracks.video && tracks.video.codec && tracks.video.codec !== 'encv') trackInfo.videoCodec = tracks.video.codec;
        if (tracks.video && tracks.audio) trackInfo.isMuxed = true;
         // since we don't support appending fmp4 data on progress, we know we have the full
        // segment here
        trackInfoFn(segment, trackInfo); // The probe doesn't provide the segment end time, so only callback with the start
        // time. The end time can be roughly calculated by the receiver using the duration.
        //
        // Note that the start time returned by the probe reflects the baseMediaDecodeTime, as
        // that is the true start of the segment (where the playback engine should begin
        // decoding).
        const finishLoading = (captions, id3Frames)=>{
            // if the track still has audio at this point it is only possible
            // for it to be audio only. See `tracks.video && tracks.audio` if statement
            // above.
            // we make sure to use segment.bytes here as that
            dataFn(segment, {
                data: bytesAsUint8Array,
                type: trackInfo.hasAudio && !trackInfo.isMuxed ? 'audio' : 'video'
            });
            if (id3Frames && id3Frames.length) id3Fn(segment, id3Frames);
            if (captions && captions.length) captionsFn(segment, captions);
            doneFn(null, segment, {});
        };
        $cb03b711053a4297$var$workerCallback({
            action: 'probeMp4StartTime',
            timescales: segment.map.timescales,
            data: bytesAsUint8Array,
            transmuxer: segment.transmuxer,
            callback: ({ data: data, startTime: startTime })=>{
                // transfer bytes back to us
                bytes = data.buffer;
                segment.bytes = bytesAsUint8Array = data;
                if (trackInfo.hasAudio && !trackInfo.isMuxed) timingInfoFn(segment, 'audio', 'start', startTime);
                if (trackInfo.hasVideo) timingInfoFn(segment, 'video', 'start', startTime);
                $cb03b711053a4297$var$workerCallback({
                    action: 'probeEmsgID3',
                    data: bytesAsUint8Array,
                    transmuxer: segment.transmuxer,
                    offset: startTime,
                    callback: ({ emsgData: emsgData, id3Frames: id3Frames })=>{
                        // transfer bytes back to us
                        bytes = emsgData.buffer;
                        segment.bytes = bytesAsUint8Array = emsgData; // Run through the CaptionParser in case there are captions.
                        // Initialize CaptionParser if it hasn't been yet
                        if (!tracks.video || !emsgData.byteLength || !segment.transmuxer) {
                            finishLoading(undefined, id3Frames);
                            return;
                        }
                        $cb03b711053a4297$var$workerCallback({
                            action: 'pushMp4Captions',
                            endAction: 'mp4Captions',
                            transmuxer: segment.transmuxer,
                            data: bytesAsUint8Array,
                            timescales: segment.map.timescales,
                            trackIds: [
                                tracks.video.id
                            ],
                            callback: (message)=>{
                                // transfer bytes back to us
                                bytes = message.data.buffer;
                                segment.bytes = bytesAsUint8Array = message.data;
                                message.logs.forEach(function(log) {
                                    onTransmuxerLog($cb03b711053a4297$var$merge(log, {
                                        stream: 'mp4CaptionParser'
                                    }));
                                });
                                finishLoading(message.captions, id3Frames);
                            }
                        });
                    }
                });
            }
        });
        return;
    } // VTT or other segments that don't need processing
    if (!segment.transmuxer) {
        doneFn(null, segment, {});
        return;
    }
    if (typeof segment.container === 'undefined') segment.container = (0, $bChVV.detectContainerForBytes)(bytesAsUint8Array);
    if (segment.container !== 'ts' && segment.container !== 'aac') {
        trackInfoFn(segment, {
            hasAudio: false,
            hasVideo: false
        });
        doneFn(null, segment, {});
        return;
    } // ts or aac
    $cb03b711053a4297$var$transmuxAndNotify({
        segment: segment,
        bytes: bytes,
        trackInfoFn: trackInfoFn,
        timingInfoFn: timingInfoFn,
        videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
        audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
        id3Fn: id3Fn,
        captionsFn: captionsFn,
        isEndOfTimeline: isEndOfTimeline,
        endedTimelineFn: endedTimelineFn,
        dataFn: dataFn,
        doneFn: doneFn,
        onTransmuxerLog: onTransmuxerLog,
        triggerSegmentEventFn: triggerSegmentEventFn
    });
};
const $cb03b711053a4297$var$decrypt = function({ id: id, key: key, encryptedBytes: encryptedBytes, decryptionWorker: decryptionWorker, segment: segment, doneFn: doneFn }, callback) {
    const decryptionHandler = (event)=>{
        if (event.data.source === id) {
            decryptionWorker.removeEventListener('message', decryptionHandler);
            const decrypted = event.data.decrypted;
            callback(new Uint8Array(decrypted.bytes, decrypted.byteOffset, decrypted.byteLength));
        }
    };
    decryptionWorker.onerror = ()=>{
        const message = 'An error occurred in the decryption worker';
        const segmentInfo = $cb03b711053a4297$var$segmentInfoPayload({
            segment: segment
        });
        const decryptError = {
            message: message,
            metadata: {
                error: new Error(message),
                errorType: $cb03b711053a4297$export$2e2bcd8739ae039.Error.StreamingFailedToDecryptSegment,
                segmentInfo: segmentInfo,
                keyInfo: {
                    uri: segment.key.resolvedUri || segment.map.key.resolvedUri
                }
            }
        };
        doneFn(decryptError, segment);
    };
    decryptionWorker.addEventListener('message', decryptionHandler);
    let keyBytes;
    if (key.bytes.slice) keyBytes = key.bytes.slice();
    else keyBytes = new Uint32Array(Array.prototype.slice.call(key.bytes));
     // incrementally decrypt the bytes
    decryptionWorker.postMessage($cb03b711053a4297$var$createTransferableMessage({
        source: id,
        encrypted: encryptedBytes,
        key: keyBytes,
        iv: key.iv
    }), [
        encryptedBytes.buffer,
        keyBytes.buffer
    ]);
};
/**
 * Decrypt the segment via the decryption web worker
 *
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
 *                                       routines
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Function} doneFn - a callback that is executed after decryption has completed
 */ const $cb03b711053a4297$var$decryptSegment = ({ decryptionWorker: decryptionWorker, segment: segment, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog, triggerSegmentEventFn: triggerSegmentEventFn })=>{
    triggerSegmentEventFn({
        type: 'segmentdecryptionstart'
    });
    $cb03b711053a4297$var$decrypt({
        id: segment.requestId,
        key: segment.key,
        encryptedBytes: segment.encryptedBytes,
        decryptionWorker: decryptionWorker,
        segment: segment,
        doneFn: doneFn
    }, (decryptedBytes)=>{
        segment.bytes = decryptedBytes;
        triggerSegmentEventFn({
            type: 'segmentdecryptioncomplete',
            segment: segment
        });
        $cb03b711053a4297$var$handleSegmentBytes({
            segment: segment,
            bytes: segment.bytes,
            trackInfoFn: trackInfoFn,
            timingInfoFn: timingInfoFn,
            videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
            audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
            id3Fn: id3Fn,
            captionsFn: captionsFn,
            isEndOfTimeline: isEndOfTimeline,
            endedTimelineFn: endedTimelineFn,
            dataFn: dataFn,
            doneFn: doneFn,
            onTransmuxerLog: onTransmuxerLog,
            triggerSegmentEventFn: triggerSegmentEventFn
        });
    });
};
/**
 * This function waits for all XHRs to finish (with either success or failure)
 * before continueing processing via it's callback. The function gathers errors
 * from each request into a single errors array so that the error status for
 * each request can be examined later.
 *
 * @param {Object} activeXhrs - an object that tracks all XHR requests
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
 *                                       routines
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} id3Fn - a callback that receives ID3 metadata
 * @param {Function} captionsFn - a callback that receives captions
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Function} doneFn - a callback that is executed after all resources have been
 *                            downloaded and any decryption completed
 */ const $cb03b711053a4297$var$waitForCompletion = ({ activeXhrs: activeXhrs, decryptionWorker: decryptionWorker, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog, triggerSegmentEventFn: triggerSegmentEventFn })=>{
    let count = 0;
    let didError = false;
    return (error, segment)=>{
        if (didError) return;
        if (error) {
            didError = true; // If there are errors, we have to abort any outstanding requests
            $cb03b711053a4297$var$abortAll(activeXhrs); // Even though the requests above are aborted, and in theory we could wait until we
            // handle the aborted events from those requests, there are some cases where we may
            // never get an aborted event. For instance, if the network connection is lost and
            // there were two requests, the first may have triggered an error immediately, while
            // the second request remains unsent. In that case, the aborted algorithm will not
            // trigger an abort: see https://xhr.spec.whatwg.org/#the-abort()-method
            //
            // We also can't rely on the ready state of the XHR, since the request that
            // triggered the connection error may also show as a ready state of 0 (unsent).
            // Therefore, we have to finish this group of requests immediately after the first
            // seen error.
            return doneFn(error, segment);
        }
        count += 1;
        if (count === activeXhrs.length) {
            const segmentFinish = function() {
                if (segment.encryptedBytes) return $cb03b711053a4297$var$decryptSegment({
                    decryptionWorker: decryptionWorker,
                    segment: segment,
                    trackInfoFn: trackInfoFn,
                    timingInfoFn: timingInfoFn,
                    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
                    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
                    id3Fn: id3Fn,
                    captionsFn: captionsFn,
                    isEndOfTimeline: isEndOfTimeline,
                    endedTimelineFn: endedTimelineFn,
                    dataFn: dataFn,
                    doneFn: doneFn,
                    onTransmuxerLog: onTransmuxerLog,
                    triggerSegmentEventFn: triggerSegmentEventFn
                });
                 // Otherwise, everything is ready just continue
                $cb03b711053a4297$var$handleSegmentBytes({
                    segment: segment,
                    bytes: segment.bytes,
                    trackInfoFn: trackInfoFn,
                    timingInfoFn: timingInfoFn,
                    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
                    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
                    id3Fn: id3Fn,
                    captionsFn: captionsFn,
                    isEndOfTimeline: isEndOfTimeline,
                    endedTimelineFn: endedTimelineFn,
                    dataFn: dataFn,
                    doneFn: doneFn,
                    onTransmuxerLog: onTransmuxerLog,
                    triggerSegmentEventFn: triggerSegmentEventFn
                });
            }; // Keep track of when *all* of the requests have completed
            segment.endOfAllRequests = Date.now();
            if (segment.map && segment.map.encryptedBytes && !segment.map.bytes) {
                triggerSegmentEventFn({
                    type: 'segmentdecryptionstart',
                    segment: segment
                });
                return $cb03b711053a4297$var$decrypt({
                    decryptionWorker: decryptionWorker,
                    // add -init to the "id" to differentiate between segment
                    // and init segment decryption, just in case they happen
                    // at the same time at some point in the future.
                    id: segment.requestId + '-init',
                    encryptedBytes: segment.map.encryptedBytes,
                    key: segment.map.key,
                    segment: segment,
                    doneFn: doneFn
                }, (decryptedBytes)=>{
                    segment.map.bytes = decryptedBytes;
                    triggerSegmentEventFn({
                        type: 'segmentdecryptioncomplete',
                        segment: segment
                    });
                    $cb03b711053a4297$var$parseInitSegment(segment, (parseError)=>{
                        if (parseError) {
                            $cb03b711053a4297$var$abortAll(activeXhrs);
                            return doneFn(parseError, segment);
                        }
                        segmentFinish();
                    });
                });
            }
            segmentFinish();
        }
    };
};
/**
 * Calls the abort callback if any request within the batch was aborted. Will only call
 * the callback once per batch of requests, even if multiple were aborted.
 *
 * @param {Object} loadendState - state to check to see if the abort function was called
 * @param {Function} abortFn - callback to call for abort
 */ const $cb03b711053a4297$var$handleLoadEnd = ({ loadendState: loadendState, abortFn: abortFn })=>(event)=>{
        const request = event.target;
        if (request.aborted && abortFn && !loadendState.calledAbortFn) {
            abortFn();
            loadendState.calledAbortFn = true;
        }
    };
/**
 * Simple progress event callback handler that gathers some stats before
 * executing a provided callback with the `segment` object
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} progressFn - a callback that is executed each time a progress event
 *                                is received
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Event} event - the progress event object from XMLHttpRequest
 */ const $cb03b711053a4297$var$handleProgress = ({ segment: segment, progressFn: progressFn, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn })=>(event)=>{
        const request = event.target;
        if (request.aborted) return;
        segment.stats = $cb03b711053a4297$var$merge(segment.stats, $cb03b711053a4297$var$getProgressStats(event)); // record the time that we receive the first byte of data
        if (!segment.stats.firstBytesReceivedAt && segment.stats.bytesReceived) segment.stats.firstBytesReceivedAt = Date.now();
        return progressFn(event, segment);
    };
/**
 * Load all resources and does any processing necessary for a media-segment
 *
 * Features:
 *   decrypts the media-segment if it has a key uri and an iv
 *   aborts *all* requests if *any* one request fails
 *
 * The segment object, at minimum, has the following format:
 * {
 *   resolvedUri: String,
 *   [transmuxer]: Object,
 *   [byterange]: {
 *     offset: Number,
 *     length: Number
 *   },
 *   [key]: {
 *     resolvedUri: String
 *     [byterange]: {
 *       offset: Number,
 *       length: Number
 *     },
 *     iv: {
 *       bytes: Uint32Array
 *     }
 *   },
 *   [map]: {
 *     resolvedUri: String,
 *     [byterange]: {
 *       offset: Number,
 *       length: Number
 *     },
 *     [bytes]: Uint8Array
 *   }
 * }
 * ...where [name] denotes optional properties
 *
 * @param {Function} xhr - an instance of the xhr wrapper in xhr.js
 * @param {Object} xhrOptions - the base options to provide to all xhr requests
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128
 *                                       decryption routines
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} abortFn - a callback called (only once) if any piece of a request was
 *                             aborted
 * @param {Function} progressFn - a callback that receives progress events from the main
 *                                segment's xhr request
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} id3Fn - a callback that receives ID3 metadata
 * @param {Function} captionsFn - a callback that receives captions
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that receives data from the main segment's xhr
 *                            request, transmuxed if needed
 * @param {Function} doneFn - a callback that is executed only once all requests have
 *                            succeeded or failed
 * @return {Function} a function that, when invoked, immediately aborts all
 *                     outstanding requests
 */ const $cb03b711053a4297$var$mediaSegmentRequest = ({ xhr: xhr, xhrOptions: xhrOptions, decryptionWorker: decryptionWorker, segment: segment, abortFn: abortFn, progressFn: progressFn, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog, triggerSegmentEventFn: triggerSegmentEventFn })=>{
    const activeXhrs = [];
    const finishProcessingFn = $cb03b711053a4297$var$waitForCompletion({
        activeXhrs: activeXhrs,
        decryptionWorker: decryptionWorker,
        trackInfoFn: trackInfoFn,
        timingInfoFn: timingInfoFn,
        videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
        audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
        id3Fn: id3Fn,
        captionsFn: captionsFn,
        isEndOfTimeline: isEndOfTimeline,
        endedTimelineFn: endedTimelineFn,
        dataFn: dataFn,
        doneFn: doneFn,
        onTransmuxerLog: onTransmuxerLog,
        triggerSegmentEventFn: triggerSegmentEventFn
    }); // optionally, request the decryption key
    if (segment.key && !segment.key.bytes) {
        const objects = [
            segment.key
        ];
        if (segment.map && !segment.map.bytes && segment.map.key && segment.map.key.resolvedUri === segment.key.resolvedUri) objects.push(segment.map.key);
        const keyRequestOptions = $cb03b711053a4297$var$merge(xhrOptions, {
            uri: segment.key.resolvedUri,
            responseType: 'arraybuffer',
            requestType: 'segment-key'
        });
        const keyRequestCallback = $cb03b711053a4297$var$handleKeyResponse(segment, objects, finishProcessingFn, triggerSegmentEventFn);
        const keyInfo = {
            uri: segment.key.resolvedUri
        };
        triggerSegmentEventFn({
            type: 'segmentkeyloadstart',
            segment: segment,
            keyInfo: keyInfo
        });
        const keyXhr = xhr(keyRequestOptions, keyRequestCallback);
        activeXhrs.push(keyXhr);
    } // optionally, request the associated media init segment
    if (segment.map && !segment.map.bytes) {
        const differentMapKey = segment.map.key && (!segment.key || segment.key.resolvedUri !== segment.map.key.resolvedUri);
        if (differentMapKey) {
            const mapKeyRequestOptions = $cb03b711053a4297$var$merge(xhrOptions, {
                uri: segment.map.key.resolvedUri,
                responseType: 'arraybuffer',
                requestType: 'segment-key'
            });
            const mapKeyRequestCallback = $cb03b711053a4297$var$handleKeyResponse(segment, [
                segment.map.key
            ], finishProcessingFn, triggerSegmentEventFn);
            const keyInfo = {
                uri: segment.map.key.resolvedUri
            };
            triggerSegmentEventFn({
                type: 'segmentkeyloadstart',
                segment: segment,
                keyInfo: keyInfo
            });
            const mapKeyXhr = xhr(mapKeyRequestOptions, mapKeyRequestCallback);
            activeXhrs.push(mapKeyXhr);
        }
        const initSegmentOptions = $cb03b711053a4297$var$merge(xhrOptions, {
            uri: segment.map.resolvedUri,
            responseType: 'arraybuffer',
            headers: $cb03b711053a4297$var$segmentXhrHeaders(segment.map),
            requestType: 'segment-media-initialization'
        });
        const initSegmentRequestCallback = $cb03b711053a4297$var$handleInitSegmentResponse({
            segment: segment,
            finishProcessingFn: finishProcessingFn,
            triggerSegmentEventFn: triggerSegmentEventFn
        });
        triggerSegmentEventFn({
            type: 'segmentloadstart',
            segment: segment
        });
        const initSegmentXhr = xhr(initSegmentOptions, initSegmentRequestCallback);
        activeXhrs.push(initSegmentXhr);
    }
    const segmentRequestOptions = $cb03b711053a4297$var$merge(xhrOptions, {
        uri: segment.part && segment.part.resolvedUri || segment.resolvedUri,
        responseType: 'arraybuffer',
        headers: $cb03b711053a4297$var$segmentXhrHeaders(segment),
        requestType: 'segment'
    });
    const segmentRequestCallback = $cb03b711053a4297$var$handleSegmentResponse({
        segment: segment,
        finishProcessingFn: finishProcessingFn,
        responseType: segmentRequestOptions.responseType,
        triggerSegmentEventFn: triggerSegmentEventFn
    });
    triggerSegmentEventFn({
        type: 'segmentloadstart',
        segment: segment
    });
    const segmentXhr = xhr(segmentRequestOptions, segmentRequestCallback);
    segmentXhr.addEventListener('progress', $cb03b711053a4297$var$handleProgress({
        segment: segment,
        progressFn: progressFn,
        trackInfoFn: trackInfoFn,
        timingInfoFn: timingInfoFn,
        videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
        audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
        id3Fn: id3Fn,
        captionsFn: captionsFn,
        isEndOfTimeline: isEndOfTimeline,
        endedTimelineFn: endedTimelineFn,
        dataFn: dataFn
    }));
    activeXhrs.push(segmentXhr); // since all parts of the request must be considered, but should not make callbacks
    // multiple times, provide a shared state object
    const loadendState = {};
    activeXhrs.forEach((activeXhr)=>{
        activeXhr.addEventListener('loadend', $cb03b711053a4297$var$handleLoadEnd({
            loadendState: loadendState,
            abortFn: abortFn
        }));
    });
    return ()=>$cb03b711053a4297$var$abortAll(activeXhrs);
};
const $cb03b711053a4297$var$logFn = $cb03b711053a4297$var$logger('PlaylistSelector');
const $cb03b711053a4297$var$representationToString = function(representation) {
    if (!representation || !representation.playlist) return;
    const playlist = representation.playlist;
    return JSON.stringify({
        id: playlist.id,
        bandwidth: representation.bandwidth,
        width: representation.width,
        height: representation.height,
        codecs: playlist.attributes && playlist.attributes.CODECS || ''
    });
}; // Utilities
/**
 * Returns the CSS value for the specified property on an element
 * using `getComputedStyle`. Firefox has a long-standing issue where
 * getComputedStyle() may return null when running in an iframe with
 * `display: none`.
 *
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 * @param {HTMLElement} el the htmlelement to work on
 * @param {string} the proprety to get the style for
 */ const $cb03b711053a4297$var$safeGetComputedStyle = function(el, property) {
    if (!el) return '';
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).getComputedStyle(el);
    if (!result) return '';
    return result[property];
};
/**
 * Resuable stable sort function
 *
 * @param {Playlists} array
 * @param {Function} sortFn Different comparators
 * @function stableSort
 */ const $cb03b711053a4297$var$stableSort = function(array, sortFn) {
    const newArray = array.slice();
    array.sort(function(left, right) {
        const cmp = sortFn(left, right);
        if (cmp === 0) return newArray.indexOf(left) - newArray.indexOf(right);
        return cmp;
    });
};
/**
 * A comparator function to sort two playlist object by bandwidth.
 *
 * @param {Object} left a media playlist object
 * @param {Object} right a media playlist object
 * @return {number} Greater than zero if the bandwidth attribute of
 * left is greater than the corresponding attribute of right. Less
 * than zero if the bandwidth of right is greater than left and
 * exactly zero if the two are equal.
 */ const $cb03b711053a4297$var$comparePlaylistBandwidth = function(left, right) {
    let leftBandwidth;
    let rightBandwidth;
    if (left.attributes.BANDWIDTH) leftBandwidth = left.attributes.BANDWIDTH;
    leftBandwidth = leftBandwidth || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Number.MAX_VALUE;
    if (right.attributes.BANDWIDTH) rightBandwidth = right.attributes.BANDWIDTH;
    rightBandwidth = rightBandwidth || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Number.MAX_VALUE;
    return leftBandwidth - rightBandwidth;
};
/**
 * A comparator function to sort two playlist object by resolution (width).
 *
 * @param {Object} left a media playlist object
 * @param {Object} right a media playlist object
 * @return {number} Greater than zero if the resolution.width attribute of
 * left is greater than the corresponding attribute of right. Less
 * than zero if the resolution.width of right is greater than left and
 * exactly zero if the two are equal.
 */ const $cb03b711053a4297$var$comparePlaylistResolution = function(left, right) {
    let leftWidth;
    let rightWidth;
    if (left.attributes.RESOLUTION && left.attributes.RESOLUTION.width) leftWidth = left.attributes.RESOLUTION.width;
    leftWidth = leftWidth || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Number.MAX_VALUE;
    if (right.attributes.RESOLUTION && right.attributes.RESOLUTION.width) rightWidth = right.attributes.RESOLUTION.width;
    rightWidth = rightWidth || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Number.MAX_VALUE; // NOTE - Fallback to bandwidth sort as appropriate in cases where multiple renditions
    // have the same media dimensions/ resolution
    if (leftWidth === rightWidth && left.attributes.BANDWIDTH && right.attributes.BANDWIDTH) return left.attributes.BANDWIDTH - right.attributes.BANDWIDTH;
    return leftWidth - rightWidth;
};
/**
 * Chooses the appropriate media playlist based on bandwidth and player size
 *
 * @param {Object} settings
 *        Object of information required to use this selector
 * @param {Object} settings.main
 *        Object representation of the main manifest
 * @param {number} settings.bandwidth
 *        Current calculated bandwidth of the player
 * @param {number} settings.playerWidth
 *        Current width of the player element (should account for the device pixel ratio)
 * @param {number} settings.playerHeight
 *        Current height of the player element (should account for the device pixel ratio)
 * @param {number} settings.playerObjectFit
 *        Current value of the video element's object-fit CSS property. Allows taking into
 *        account that the video might be scaled up to cover the media element when selecting
 *        media playlists based on player size.
 * @param {boolean} settings.limitRenditionByPlayerDimensions
 *        True if the player width and height should be used during the selection, false otherwise
 * @param {Object} settings.playlistController
 *        the current playlistController object
 * @return {Playlist} the highest bitrate playlist less than the
 * currently detected bandwidth, accounting for some amount of
 * bandwidth variance
 */ let $cb03b711053a4297$var$simpleSelector = function(settings) {
    const { main: main, bandwidth: playerBandwidth, playerWidth: playerWidth, playerHeight: playerHeight, playerObjectFit: playerObjectFit, limitRenditionByPlayerDimensions: limitRenditionByPlayerDimensions, playlistController: playlistController } = settings; // If we end up getting called before `main` is available, exit early
    if (!main) return;
    const options = {
        bandwidth: playerBandwidth,
        width: playerWidth,
        height: playerHeight,
        limitRenditionByPlayerDimensions: limitRenditionByPlayerDimensions
    };
    let playlists = main.playlists; // if playlist is audio only, select between currently active audio group playlists.
    if ($cb03b711053a4297$var$Playlist.isAudioOnly(main)) {
        playlists = playlistController.getAudioTrackPlaylists_(); // add audioOnly to options so that we log audioOnly: true
        // at the buttom of this function for debugging.
        options.audioOnly = true;
    } // convert the playlists to an intermediary representation to make comparisons easier
    let sortedPlaylistReps = playlists.map((playlist)=>{
        let bandwidth;
        const width = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.width;
        const height = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height;
        bandwidth = playlist.attributes && playlist.attributes.BANDWIDTH;
        bandwidth = bandwidth || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Number.MAX_VALUE;
        return {
            bandwidth: bandwidth,
            width: width,
            height: height,
            playlist: playlist
        };
    });
    $cb03b711053a4297$var$stableSort(sortedPlaylistReps, (left, right)=>left.bandwidth - right.bandwidth); // filter out any playlists that have been excluded due to
    // incompatible configurations
    sortedPlaylistReps = sortedPlaylistReps.filter((rep)=>!$cb03b711053a4297$var$Playlist.isIncompatible(rep.playlist)); // filter out any playlists that have been disabled manually through the representations
    // api or excluded temporarily due to playback errors.
    let enabledPlaylistReps = sortedPlaylistReps.filter((rep)=>$cb03b711053a4297$var$Playlist.isEnabled(rep.playlist));
    if (!enabledPlaylistReps.length) // if there are no enabled playlists, then they have all been excluded or disabled
    // by the user through the representations api. In this case, ignore exclusion and
    // fallback to what the user wants by using playlists the user has not disabled.
    enabledPlaylistReps = sortedPlaylistReps.filter((rep)=>!$cb03b711053a4297$var$Playlist.isDisabled(rep.playlist));
     // filter out any variant that has greater effective bitrate
    // than the current estimated bandwidth
    const bandwidthPlaylistReps = enabledPlaylistReps.filter((rep)=>rep.bandwidth * $cb03b711053a4297$var$Config.BANDWIDTH_VARIANCE < playerBandwidth);
    let highestRemainingBandwidthRep = bandwidthPlaylistReps[bandwidthPlaylistReps.length - 1]; // get all of the renditions with the same (highest) bandwidth
    // and then taking the very first element
    const bandwidthBestRep = bandwidthPlaylistReps.filter((rep)=>rep.bandwidth === highestRemainingBandwidthRep.bandwidth)[0]; // if we're not going to limit renditions by player size, make an early decision.
    if (limitRenditionByPlayerDimensions === false) {
        const chosenRep = bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
        if (chosenRep && chosenRep.playlist) {
            let type = 'sortedPlaylistReps';
            if (bandwidthBestRep) type = 'bandwidthBestRep';
            if (enabledPlaylistReps[0]) type = 'enabledPlaylistReps';
            $cb03b711053a4297$var$logFn(`choosing ${$cb03b711053a4297$var$representationToString(chosenRep)} using ${type} with options`, options);
            return chosenRep.playlist;
        }
        $cb03b711053a4297$var$logFn('could not choose a playlist with options', options);
        return null;
    } // filter out playlists without resolution information
    const haveResolution = bandwidthPlaylistReps.filter((rep)=>rep.width && rep.height); // sort variants by resolution
    $cb03b711053a4297$var$stableSort(haveResolution, (left, right)=>left.width - right.width); // if we have the exact resolution as the player use it
    const resolutionBestRepList = haveResolution.filter((rep)=>rep.width === playerWidth && rep.height === playerHeight);
    highestRemainingBandwidthRep = resolutionBestRepList[resolutionBestRepList.length - 1]; // ensure that we pick the highest bandwidth variant that have exact resolution
    const resolutionBestRep = resolutionBestRepList.filter((rep)=>rep.bandwidth === highestRemainingBandwidthRep.bandwidth)[0];
    let resolutionPlusOneList;
    let resolutionPlusOneSmallest;
    let resolutionPlusOneRep; // find the smallest variant that is larger than the player
    // if there is no match of exact resolution
    if (!resolutionBestRep) {
        resolutionPlusOneList = haveResolution.filter((rep)=>{
            if (playerObjectFit === 'cover') // video will be scaled up to cover the player. We need to
            // make sure rendition is at least as wide and as high as the
            // player.
            return rep.width > playerWidth && rep.height > playerHeight;
             // video will be scaled down to fit inside the player soon as
            // its resolution exceeds player size in at least one dimension.
            return rep.width > playerWidth || rep.height > playerHeight;
        }); // find all the variants have the same smallest resolution
        resolutionPlusOneSmallest = resolutionPlusOneList.filter((rep)=>rep.width === resolutionPlusOneList[0].width && rep.height === resolutionPlusOneList[0].height); // ensure that we also pick the highest bandwidth variant that
        // is just-larger-than the video player
        highestRemainingBandwidthRep = resolutionPlusOneSmallest[resolutionPlusOneSmallest.length - 1];
        resolutionPlusOneRep = resolutionPlusOneSmallest.filter((rep)=>rep.bandwidth === highestRemainingBandwidthRep.bandwidth)[0];
    }
    let leastPixelDiffRep; // If this selector proves to be better than others,
    // resolutionPlusOneRep and resolutionBestRep and all
    // the code involving them should be removed.
    if (playlistController.leastPixelDiffSelector) {
        // find the variant that is closest to the player's pixel size
        const leastPixelDiffList = haveResolution.map((rep)=>{
            rep.pixelDiff = Math.abs(rep.width - playerWidth) + Math.abs(rep.height - playerHeight);
            return rep;
        }); // get the highest bandwidth, closest resolution playlist
        $cb03b711053a4297$var$stableSort(leastPixelDiffList, (left, right)=>{
            // sort by highest bandwidth if pixelDiff is the same
            if (left.pixelDiff === right.pixelDiff) return right.bandwidth - left.bandwidth;
            return left.pixelDiff - right.pixelDiff;
        });
        leastPixelDiffRep = leastPixelDiffList[0];
    } // fallback chain of variants
    const chosenRep = leastPixelDiffRep || resolutionPlusOneRep || resolutionBestRep || bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
    if (chosenRep && chosenRep.playlist) {
        let type = 'sortedPlaylistReps';
        if (leastPixelDiffRep) type = 'leastPixelDiffRep';
        else if (resolutionPlusOneRep) type = 'resolutionPlusOneRep';
        else if (resolutionBestRep) type = 'resolutionBestRep';
        else if (bandwidthBestRep) type = 'bandwidthBestRep';
        else if (enabledPlaylistReps[0]) type = 'enabledPlaylistReps';
        $cb03b711053a4297$var$logFn(`choosing ${$cb03b711053a4297$var$representationToString(chosenRep)} using ${type} with options`, options);
        return chosenRep.playlist;
    }
    $cb03b711053a4297$var$logFn('could not choose a playlist with options', options);
    return null;
};
/**
 * Chooses the appropriate media playlist based on the most recent
 * bandwidth estimate and the player size.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @return {Playlist} the highest bitrate playlist less than the
 * currently detected bandwidth, accounting for some amount of
 * bandwidth variance
 */ const $cb03b711053a4297$var$lastBandwidthSelector = function() {
    let pixelRatio = this.useDevicePixelRatio ? (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).devicePixelRatio || 1 : 1;
    if (!isNaN(this.customPixelRatio)) pixelRatio = this.customPixelRatio;
    return $cb03b711053a4297$var$simpleSelector({
        main: this.playlists.main,
        bandwidth: this.systemBandwidth,
        playerWidth: parseInt($cb03b711053a4297$var$safeGetComputedStyle(this.tech_.el(), 'width'), 10) * pixelRatio,
        playerHeight: parseInt($cb03b711053a4297$var$safeGetComputedStyle(this.tech_.el(), 'height'), 10) * pixelRatio,
        playerObjectFit: this.usePlayerObjectFit ? $cb03b711053a4297$var$safeGetComputedStyle(this.tech_.el(), 'objectFit') : '',
        limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
        playlistController: this.playlistController_
    });
};
/**
 * Chooses the appropriate media playlist based on an
 * exponential-weighted moving average of the bandwidth after
 * filtering for player size.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @param {number} decay - a number between 0 and 1. Higher values of
 * this parameter will cause previous bandwidth estimates to lose
 * significance more quickly.
 * @return {Function} a function which can be invoked to create a new
 * playlist selector function.
 * @see https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 */ const $cb03b711053a4297$var$movingAverageBandwidthSelector = function(decay) {
    let average = -1;
    let lastSystemBandwidth = -1;
    if (decay < 0 || decay > 1) throw new Error('Moving average bandwidth decay must be between 0 and 1.');
    return function() {
        let pixelRatio = this.useDevicePixelRatio ? (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).devicePixelRatio || 1 : 1;
        if (!isNaN(this.customPixelRatio)) pixelRatio = this.customPixelRatio;
        if (average < 0) {
            average = this.systemBandwidth;
            lastSystemBandwidth = this.systemBandwidth;
        } // stop the average value from decaying for every 250ms
        // when the systemBandwidth is constant
        // and
        // stop average from setting to a very low value when the
        // systemBandwidth becomes 0 in case of chunk cancellation
        if (this.systemBandwidth > 0 && this.systemBandwidth !== lastSystemBandwidth) {
            average = decay * this.systemBandwidth + (1 - decay) * average;
            lastSystemBandwidth = this.systemBandwidth;
        }
        return $cb03b711053a4297$var$simpleSelector({
            main: this.playlists.main,
            bandwidth: average,
            playerWidth: parseInt($cb03b711053a4297$var$safeGetComputedStyle(this.tech_.el(), 'width'), 10) * pixelRatio,
            playerHeight: parseInt($cb03b711053a4297$var$safeGetComputedStyle(this.tech_.el(), 'height'), 10) * pixelRatio,
            playerObjectFit: this.usePlayerObjectFit ? $cb03b711053a4297$var$safeGetComputedStyle(this.tech_.el(), 'objectFit') : '',
            limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
            playlistController: this.playlistController_
        });
    };
};
/**
 * Chooses the appropriate media playlist based on the potential to rebuffer
 *
 * @param {Object} settings
 *        Object of information required to use this selector
 * @param {Object} settings.main
 *        Object representation of the main manifest
 * @param {number} settings.currentTime
 *        The current time of the player
 * @param {number} settings.bandwidth
 *        Current measured bandwidth
 * @param {number} settings.duration
 *        Duration of the media
 * @param {number} settings.segmentDuration
 *        Segment duration to be used in round trip time calculations
 * @param {number} settings.timeUntilRebuffer
 *        Time left in seconds until the player has to rebuffer
 * @param {number} settings.currentTimeline
 *        The current timeline segments are being loaded from
 * @param {SyncController} settings.syncController
 *        SyncController for determining if we have a sync point for a given playlist
 * @return {Object|null}
 *         {Object} return.playlist
 *         The highest bandwidth playlist with the least amount of rebuffering
 *         {Number} return.rebufferingImpact
 *         The amount of time in seconds switching to this playlist will rebuffer. A
 *         negative value means that switching will cause zero rebuffering.
 */ const $cb03b711053a4297$var$minRebufferMaxBandwidthSelector = function(settings) {
    const { main: main, currentTime: currentTime, bandwidth: bandwidth, duration: duration, segmentDuration: segmentDuration, timeUntilRebuffer: timeUntilRebuffer, currentTimeline: currentTimeline, syncController: syncController } = settings; // filter out any playlists that have been excluded due to
    // incompatible configurations
    const compatiblePlaylists = main.playlists.filter((playlist)=>!$cb03b711053a4297$var$Playlist.isIncompatible(playlist)); // filter out any playlists that have been disabled manually through the representations
    // api or excluded temporarily due to playback errors.
    let enabledPlaylists = compatiblePlaylists.filter($cb03b711053a4297$var$Playlist.isEnabled);
    if (!enabledPlaylists.length) // if there are no enabled playlists, then they have all been excluded or disabled
    // by the user through the representations api. In this case, ignore exclusion and
    // fallback to what the user wants by using playlists the user has not disabled.
    enabledPlaylists = compatiblePlaylists.filter((playlist)=>!$cb03b711053a4297$var$Playlist.isDisabled(playlist));
    const bandwidthPlaylists = enabledPlaylists.filter($cb03b711053a4297$var$Playlist.hasAttribute.bind(null, 'BANDWIDTH'));
    const rebufferingEstimates = bandwidthPlaylists.map((playlist)=>{
        const syncPoint = syncController.getSyncPoint(playlist, duration, currentTimeline, currentTime); // If there is no sync point for this playlist, switching to it will require a
        // sync request first. This will double the request time
        const numRequests = syncPoint ? 1 : 2;
        const requestTimeEstimate = $cb03b711053a4297$var$Playlist.estimateSegmentRequestTime(segmentDuration, bandwidth, playlist);
        const rebufferingImpact = requestTimeEstimate * numRequests - timeUntilRebuffer;
        return {
            playlist: playlist,
            rebufferingImpact: rebufferingImpact
        };
    });
    const noRebufferingPlaylists = rebufferingEstimates.filter((estimate)=>estimate.rebufferingImpact <= 0); // Sort by bandwidth DESC
    $cb03b711053a4297$var$stableSort(noRebufferingPlaylists, (a, b)=>$cb03b711053a4297$var$comparePlaylistBandwidth(b.playlist, a.playlist));
    if (noRebufferingPlaylists.length) return noRebufferingPlaylists[0];
    $cb03b711053a4297$var$stableSort(rebufferingEstimates, (a, b)=>a.rebufferingImpact - b.rebufferingImpact);
    return rebufferingEstimates[0] || null;
};
/**
 * Chooses the appropriate media playlist, which in this case is the lowest bitrate
 * one with video.  If no renditions with video exist, return the lowest audio rendition.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @return {Object|null}
 *         {Object} return.playlist
 *         The lowest bitrate playlist that contains a video codec.  If no such rendition
 *         exists pick the lowest audio rendition.
 */ const $cb03b711053a4297$var$lowestBitrateCompatibleVariantSelector = function() {
    // filter out any playlists that have been excluded due to
    // incompatible configurations or playback errors
    const playlists = this.playlists.main.playlists.filter($cb03b711053a4297$var$Playlist.isEnabled); // Sort ascending by bitrate
    $cb03b711053a4297$var$stableSort(playlists, (a, b)=>$cb03b711053a4297$var$comparePlaylistBandwidth(a, b)); // Parse and assume that playlists with no video codec have no video
    // (this is not necessarily true, although it is generally true).
    //
    // If an entire manifest has no valid videos everything will get filtered
    // out.
    const playlistsWithVideo = playlists.filter((playlist)=>!!$cb03b711053a4297$var$codecsForPlaylist(this.playlists.main, playlist).video);
    return playlistsWithVideo[0] || null;
};
/**
 * Combine all segments into a single Uint8Array
 *
 * @param {Object} segmentObj
 * @return {Uint8Array} concatenated bytes
 * @private
 */ const $cb03b711053a4297$var$concatSegments = (segmentObj)=>{
    let offset = 0;
    let tempBuffer;
    if (segmentObj.bytes) {
        tempBuffer = new Uint8Array(segmentObj.bytes); // combine the individual segments into one large typed-array
        segmentObj.segments.forEach((segment)=>{
            tempBuffer.set(segment, offset);
            offset += segment.byteLength;
        });
    }
    return tempBuffer;
};
/**
 * Example:
 * https://host.com/path1/path2/path3/segment.ts?arg1=val1
 * -->
 * path3/segment.ts
 *
 * @param resolvedUri
 * @return {string}
 */ function $cb03b711053a4297$var$compactSegmentUrlDescription(resolvedUri) {
    try {
        return new URL(resolvedUri).pathname.split('/').slice(-2).join('/');
    } catch (e) {
        return '';
    }
}
/**
 * @file text-tracks.js
 */ /**
 * Create captions text tracks on video.js if they do not exist
 *
 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
 * @param {Object} tech the video.js tech
 * @param {Object} captionStream the caption stream to create
 * @private
 */ const $cb03b711053a4297$var$createCaptionsTrackIfNotExists = function(inbandTextTracks, tech, captionStream) {
    if (!inbandTextTracks[captionStream]) {
        tech.trigger({
            type: 'usage',
            name: 'vhs-608'
        });
        let instreamId = captionStream; // we need to translate SERVICEn for 708 to how mux.js currently labels them
        if (/^cc708_/.test(captionStream)) instreamId = 'SERVICE' + captionStream.split('_')[1];
        const track = tech.textTracks().getTrackById(instreamId);
        if (track) // Resuse an existing track with a CC# id because this was
        // very likely created by videojs-contrib-hls from information
        // in the m3u8 for us to use
        inbandTextTracks[captionStream] = track;
        else {
            // This section gets called when we have caption services that aren't specified in the manifest.
            // Manifest level caption services are handled in media-groups.js under CLOSED-CAPTIONS.
            const captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
            let label = captionStream;
            let language = captionStream;
            let def = false;
            const captionService = captionServices[instreamId];
            if (captionService) {
                label = captionService.label;
                language = captionService.language;
                def = captionService.default;
            } // Otherwise, create a track with the default `CC#` label and
            // without a language
            inbandTextTracks[captionStream] = tech.addRemoteTextTrack({
                kind: 'captions',
                id: instreamId,
                // TODO: investigate why this doesn't seem to turn the caption on by default
                default: def,
                label: label,
                language: language
            }, false).track;
        }
    }
};
/**
 * Add caption text track data to a source handler given an array of captions
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {number} timestampOffset the timestamp offset of the source buffer
 *   @param {Array} captionArray an array of caption data
 * @private
 */ const $cb03b711053a4297$var$addCaptionData = function({ inbandTextTracks: inbandTextTracks, captionArray: captionArray, timestampOffset: timestampOffset }) {
    if (!captionArray) return;
    const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue;
    captionArray.forEach((caption)=>{
        const track = caption.stream; // in CEA 608 captions, video.js/mux.js sends a content array
        // with positioning data
        if (caption.content) caption.content.forEach((value)=>{
            const cue = new Cue(caption.startTime + timestampOffset, caption.endTime + timestampOffset, value.text);
            cue.line = value.line;
            cue.align = 'left';
            cue.position = value.position;
            cue.positionAlign = 'line-left';
            inbandTextTracks[track].addCue(cue);
        });
        else // otherwise, a text value with combined captions is sent
        inbandTextTracks[track].addCue(new Cue(caption.startTime + timestampOffset, caption.endTime + timestampOffset, caption.text));
    });
};
/**
 * Define properties on a cue for backwards compatability,
 * but warn the user that the way that they are using it
 * is depricated and will be removed at a later date.
 *
 * @param {Cue} cue the cue to add the properties on
 * @private
 */ const $cb03b711053a4297$var$deprecateOldCue = function(cue) {
    Object.defineProperties(cue.frame, {
        id: {
            get () {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn('cue.frame.id is deprecated. Use cue.value.key instead.');
                return cue.value.key;
            }
        },
        value: {
            get () {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn('cue.frame.value is deprecated. Use cue.value.data instead.');
                return cue.value.data;
            }
        },
        privateData: {
            get () {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn('cue.frame.privateData is deprecated. Use cue.value.data instead.');
                return cue.value.data;
            }
        }
    });
};
/**
 * Add metadata text track data to a source handler given an array of metadata
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {Array} metadataArray an array of meta data
 *   @param {number} timestampOffset the timestamp offset of the source buffer
 *   @param {number} videoDuration the duration of the video
 * @private
 */ const $cb03b711053a4297$var$addMetadata = ({ inbandTextTracks: inbandTextTracks, metadataArray: metadataArray, timestampOffset: timestampOffset, videoDuration: videoDuration })=>{
    if (!metadataArray) return;
    const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue;
    const metadataTrack = inbandTextTracks.metadataTrack_;
    if (!metadataTrack) return;
    metadataArray.forEach((metadata)=>{
        const time = metadata.cueTime + timestampOffset; // if time isn't a finite number between 0 and Infinity, like NaN,
        // ignore this bit of metadata.
        // This likely occurs when you have an non-timed ID3 tag like TIT2,
        // which is the "Title/Songname/Content description" frame
        if (typeof time !== 'number' || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).isNaN(time) || time < 0 || !(time < Infinity)) return;
         // If we have no frames, we can't create a cue.
        if (!metadata.frames || !metadata.frames.length) return;
        metadata.frames.forEach((frame)=>{
            const cue = new Cue(time, time, frame.value || frame.url || frame.data || '');
            cue.frame = frame;
            cue.value = frame;
            $cb03b711053a4297$var$deprecateOldCue(cue);
            metadataTrack.addCue(cue);
        });
    });
    if (!metadataTrack.cues || !metadataTrack.cues.length) return;
     // Updating the metadeta cues so that
    // the endTime of each cue is the startTime of the next cue
    // the endTime of last cue is the duration of the video
    const cues = metadataTrack.cues;
    const cuesArray = []; // Create a copy of the TextTrackCueList...
    // ...disregarding cues with a falsey value
    for(let i = 0; i < cues.length; i++)if (cues[i]) cuesArray.push(cues[i]);
     // Group cues by their startTime value
    const cuesGroupedByStartTime = cuesArray.reduce((obj, cue)=>{
        const timeSlot = obj[cue.startTime] || [];
        timeSlot.push(cue);
        obj[cue.startTime] = timeSlot;
        return obj;
    }, {}); // Sort startTimes by ascending order
    const sortedStartTimes = Object.keys(cuesGroupedByStartTime).sort((a, b)=>Number(a) - Number(b)); // Map each cue group's endTime to the next group's startTime
    sortedStartTimes.forEach((startTime, idx)=>{
        const cueGroup = cuesGroupedByStartTime[startTime];
        const finiteDuration = isFinite(videoDuration) ? videoDuration : startTime;
        const nextTime = Number(sortedStartTimes[idx + 1]) || finiteDuration; // Map each cue's endTime the next group's startTime
        cueGroup.forEach((cue)=>{
            cue.endTime = nextTime;
        });
    });
}; // object for mapping daterange attributes
const $cb03b711053a4297$var$dateRangeAttr = {
    id: 'ID',
    class: 'CLASS',
    startDate: 'START-DATE',
    duration: 'DURATION',
    endDate: 'END-DATE',
    endOnNext: 'END-ON-NEXT',
    plannedDuration: 'PLANNED-DURATION',
    scte35Out: 'SCTE35-OUT',
    scte35In: 'SCTE35-IN'
};
const $cb03b711053a4297$var$dateRangeKeysToOmit = new Set([
    'id',
    'class',
    'startDate',
    'duration',
    'endDate',
    'endOnNext',
    'startTime',
    'endTime',
    'processDateRange'
]);
/**
 * Add DateRange metadata text track to a source handler given an array of metadata
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {Array} dateRanges parsed media playlist
 * @private
 */ const $cb03b711053a4297$var$addDateRangeMetadata = ({ inbandTextTracks: inbandTextTracks, dateRanges: dateRanges })=>{
    const metadataTrack = inbandTextTracks.metadataTrack_;
    if (!metadataTrack) return;
    const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue;
    dateRanges.forEach((dateRange)=>{
        // we generate multiple cues for each date range with different attributes
        for (const key of Object.keys(dateRange)){
            if ($cb03b711053a4297$var$dateRangeKeysToOmit.has(key)) continue;
            const cue = new Cue(dateRange.startTime, dateRange.endTime, '');
            cue.id = dateRange.id;
            cue.type = 'com.apple.quicktime.HLS';
            cue.value = {
                key: $cb03b711053a4297$var$dateRangeAttr[key],
                data: dateRange[key]
            };
            if (key === 'scte35Out' || key === 'scte35In') cue.value.data = new Uint8Array(cue.value.data.match(/[\da-f]{2}/gi)).buffer;
            metadataTrack.addCue(cue);
        }
        dateRange.processDateRange();
    });
};
/**
 * Create metadata text track on video.js if it does not exist
 *
 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
 * @param {string} dispatchType the inband metadata track dispatch type
 * @param {Object} tech the video.js tech
 * @private
 */ const $cb03b711053a4297$var$createMetadataTrackIfNotExists = (inbandTextTracks, dispatchType, tech)=>{
    if (inbandTextTracks.metadataTrack_) return;
    inbandTextTracks.metadataTrack_ = tech.addRemoteTextTrack({
        kind: 'metadata',
        label: 'Timed Metadata'
    }, false).track;
    if (!$cb03b711053a4297$export$2e2bcd8739ae039.browser.IS_ANY_SAFARI) inbandTextTracks.metadataTrack_.inBandMetadataTrackDispatchType = dispatchType;
};
/**
 * Remove cues from a track on video.js.
 *
 * @param {Double} start start of where we should remove the cue
 * @param {Double} end end of where the we should remove the cue
 * @param {Object} track the text track to remove the cues from
 * @private
 */ const $cb03b711053a4297$var$removeCuesFromTrack = function(start, end, track) {
    let i;
    let cue;
    if (!track) return;
    if (!track.cues) return;
    i = track.cues.length;
    while(i--){
        cue = track.cues[i]; // Remove any cue within the provided start and end time
        if (cue.startTime >= start && cue.endTime <= end) track.removeCue(cue);
    }
};
/**
 * Remove duplicate cues from a track on video.js (a cue is considered a
 * duplicate if it has the same time interval and text as another)
 *
 * @param {Object} track the text track to remove the duplicate cues from
 * @private
 */ const $cb03b711053a4297$var$removeDuplicateCuesFromTrack = function(track) {
    const cues = track.cues;
    if (!cues) return;
    const uniqueCues = {};
    for(let i = cues.length - 1; i >= 0; i--){
        const cue = cues[i];
        const cueKey = `${cue.startTime}-${cue.endTime}-${cue.text}`;
        if (uniqueCues[cueKey]) track.removeCue(cue);
        else uniqueCues[cueKey] = cue;
    }
};
/**
 * Returns a list of gops in the buffer that have a pts value of 3 seconds or more in
 * front of current time.
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {number} currentTime
 *        The current time
 * @param {Double} mapping
 *        Offset to map display time to stream presentation time
 * @return {Array}
 *         List of gops considered safe to append over
 */ const $cb03b711053a4297$var$gopsSafeToAlignWith = (buffer, currentTime, mapping)=>{
    if (typeof currentTime === 'undefined' || currentTime === null || !buffer.length) return [];
     // pts value for current time + 3 seconds to give a bit more wiggle room
    const currentTimePts = Math.ceil((currentTime - mapping + 3) * (0, $3CkWK.ONE_SECOND_IN_TS));
    let i;
    for(i = 0; i < buffer.length; i++){
        if (buffer[i].pts > currentTimePts) break;
    }
    return buffer.slice(i);
};
/**
 * Appends gop information (timing and byteLength) received by the transmuxer for the
 * gops appended in the last call to appendBuffer
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {Array} gops
 *        List of new gop information
 * @param {boolean} replace
 *        If true, replace the buffer with the new gop information. If false, append the
 *        new gop information to the buffer in the right location of time.
 * @return {Array}
 *         Updated list of gop information
 */ const $cb03b711053a4297$var$updateGopBuffer = (buffer, gops, replace)=>{
    if (!gops.length) return buffer;
    if (replace) // If we are in safe append mode, then completely overwrite the gop buffer
    // with the most recent appeneded data. This will make sure that when appending
    // future segments, we only try to align with gops that are both ahead of current
    // time and in the last segment appended.
    return gops.slice();
    const start = gops[0].pts;
    let i = 0;
    for(i; i < buffer.length; i++){
        if (buffer[i].pts >= start) break;
    }
    return buffer.slice(0, i).concat(gops);
};
/**
 * Removes gop information in buffer that overlaps with provided start and end
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {Double} start
 *        position to start the remove at
 * @param {Double} end
 *        position to end the remove at
 * @param {Double} mapping
 *        Offset to map display time to stream presentation time
 */ const $cb03b711053a4297$var$removeGopBuffer = (buffer, start, end, mapping)=>{
    const startPts = Math.ceil((start - mapping) * (0, $3CkWK.ONE_SECOND_IN_TS));
    const endPts = Math.ceil((end - mapping) * (0, $3CkWK.ONE_SECOND_IN_TS));
    const updatedBuffer = buffer.slice();
    let i = buffer.length;
    while(i--){
        if (buffer[i].pts <= endPts) break;
    }
    if (i === -1) // no removal because end of remove range is before start of buffer
    return updatedBuffer;
    let j = i + 1;
    while(j--){
        if (buffer[j].pts <= startPts) break;
    } // clamp remove range start to 0 index
    j = Math.max(j, 0);
    updatedBuffer.splice(j, i - j + 1);
    return updatedBuffer;
};
const $cb03b711053a4297$var$shallowEqual = function(a, b) {
    // if both are undefined
    // or one or the other is undefined
    // they are not equal
    if (!a && !b || !a && b || a && !b) return false;
     // they are the same object and thus, equal
    if (a === b) return true;
     // sort keys so we can make sure they have
    // all the same keys later.
    const akeys = Object.keys(a).sort();
    const bkeys = Object.keys(b).sort(); // different number of keys, not equal
    if (akeys.length !== bkeys.length) return false;
    for(let i = 0; i < akeys.length; i++){
        const key = akeys[i]; // different sorted keys, not equal
        if (key !== bkeys[i]) return false;
         // different values, not equal
        if (a[key] !== b[key]) return false;
    }
    return true;
};
/**
 * The segment loader has no recourse except to fetch a segment in the
 * current playlist and use the internal timestamps in that segment to
 * generate a syncPoint. This function returns a good candidate index
 * for that process.
 *
 * @param {Array} segments - the segments array from a playlist.
 * @return {number} An index of a segment from the playlist to load
 */ const $cb03b711053a4297$var$getSyncSegmentCandidate = function(currentTimeline, segments, targetTime) {
    segments = segments || [];
    const timelineSegments = [];
    let time = 0;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        if (currentTimeline === segment.timeline) {
            timelineSegments.push(i);
            time += segment.duration;
            if (time > targetTime) return i;
        }
    }
    if (timelineSegments.length === 0) return 0;
     // default to the last timeline segment
    return timelineSegments[timelineSegments.length - 1];
}; // In the event of a quota exceeded error, keep at least one second of back buffer. This
// number was arbitrarily chosen and may be updated in the future, but seemed reasonable
// as a start to prevent any potential issues with removing content too close to the
// playhead.
const $cb03b711053a4297$var$MIN_BACK_BUFFER = 1; // in ms
const $cb03b711053a4297$var$CHECK_BUFFER_DELAY = 500;
const $cb03b711053a4297$var$finite = (num)=>typeof num === 'number' && isFinite(num); // With most content hovering around 30fps, if a segment has a duration less than a half
// frame at 30fps or one frame at 60fps, the bandwidth and throughput calculations will
// not accurately reflect the rest of the content.
const $cb03b711053a4297$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS = 1 / 60;
const $cb03b711053a4297$var$illegalMediaSwitch = (loaderType, startingMedia, trackInfo)=>{
    // Although these checks should most likely cover non 'main' types, for now it narrows
    // the scope of our checks.
    if (loaderType !== 'main' || !startingMedia || !trackInfo) return null;
    if (!trackInfo.hasAudio && !trackInfo.hasVideo) return 'Neither audio nor video found in segment.';
    if (startingMedia.hasVideo && !trackInfo.hasVideo) return "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest.";
    if (!startingMedia.hasVideo && trackInfo.hasVideo) return "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest.";
    return null;
};
/**
 * Calculates a time value that is safe to remove from the back buffer without interrupting
 * playback.
 *
 * @param {TimeRange} seekable
 *        The current seekable range
 * @param {number} currentTime
 *        The current time of the player
 * @param {number} targetDuration
 *        The target duration of the current playlist
 * @return {number}
 *         Time that is safe to remove from the back buffer without interrupting playback
 */ const $cb03b711053a4297$var$safeBackBufferTrimTime = (seekable, currentTime, targetDuration)=>{
    // 30 seconds before the playhead provides a safe default for trimming.
    //
    // Choosing a reasonable default is particularly important for high bitrate content and
    // VOD videos/live streams with large windows, as the buffer may end up overfilled and
    // throw an APPEND_BUFFER_ERR.
    let trimTime = currentTime - $cb03b711053a4297$var$Config.BACK_BUFFER_LENGTH;
    if (seekable.length) // Some live playlists may have a shorter window of content than the full allowed back
    // buffer. For these playlists, don't save content that's no longer within the window.
    trimTime = Math.max(trimTime, seekable.start(0));
     // Don't remove within target duration of the current time to avoid the possibility of
    // removing the GOP currently being played, as removing it can cause playback stalls.
    const maxTrimTime = currentTime - targetDuration;
    return Math.min(maxTrimTime, trimTime);
};
const $cb03b711053a4297$var$segmentInfoString = (segmentInfo)=>{
    const { startOfSegment: startOfSegment, duration: duration, segment: segment, part: part, playlist: { mediaSequence: seq, id: id, segments: segments = [] }, mediaIndex: index, partIndex: partIndex, timeline: timeline } = segmentInfo;
    const segmentLen = segments.length - 1;
    let selection = 'mediaIndex/partIndex increment';
    if (segmentInfo.getMediaInfoForTime) selection = `getMediaInfoForTime (${segmentInfo.getMediaInfoForTime})`;
    else if (segmentInfo.isSyncRequest) selection = 'getSyncSegmentCandidate (isSyncRequest)';
    if (segmentInfo.independent) selection += ` with independent ${segmentInfo.independent}`;
    const hasPartIndex = typeof partIndex === 'number';
    const name = segmentInfo.segment.uri ? 'segment' : 'pre-segment';
    const zeroBasedPartCount = hasPartIndex ? $cb03b711053a4297$var$getKnownPartCount({
        preloadSegment: segment
    }) - 1 : 0;
    return `${name} [${seq + index}/${seq + segmentLen}]` + (hasPartIndex ? ` part [${partIndex}/${zeroBasedPartCount}]` : '') + ` segment start/end [${segment.start} => ${segment.end}]` + (hasPartIndex ? ` part start/end [${part.start} => ${part.end}]` : '') + ` startOfSegment [${startOfSegment}]` + ` duration [${duration}]` + ` timeline [${timeline}]` + ` selected by [${selection}]` + ` playlist [${id}]`;
};
const $cb03b711053a4297$var$timingInfoPropertyForMedia = (mediaType)=>`${mediaType}TimingInfo`;
/**
 * Returns the timestamp offset to use for the segment.
 *
 * @param {number} segmentTimeline
 *        The timeline of the segment
 * @param {number} currentTimeline
 *        The timeline currently being followed by the loader
 * @param {number} startOfSegment
 *        The estimated segment start
 * @param {TimeRange[]} buffered
 *        The loader's buffer
 * @param {boolean} overrideCheck
 *        If true, no checks are made to see if the timestamp offset value should be set,
 *        but sets it directly to a value.
 *
 * @return {number|null}
 *         Either a number representing a new timestamp offset, or null if the segment is
 *         part of the same timeline
 */ const $cb03b711053a4297$var$timestampOffsetForSegment = ({ segmentTimeline: segmentTimeline, currentTimeline: currentTimeline, startOfSegment: startOfSegment, buffered: buffered, overrideCheck: overrideCheck })=>{
    // Check to see if we are crossing a discontinuity to see if we need to set the
    // timestamp offset on the transmuxer and source buffer.
    //
    // Previously, we changed the timestampOffset if the start of this segment was less than
    // the currently set timestampOffset, but this isn't desirable as it can produce bad
    // behavior, especially around long running live streams.
    if (!overrideCheck && segmentTimeline === currentTimeline) return null;
     // When changing renditions, it's possible to request a segment on an older timeline. For
    // instance, given two renditions with the following:
    //
    // #EXTINF:10
    // segment1
    // #EXT-X-DISCONTINUITY
    // #EXTINF:10
    // segment2
    // #EXTINF:10
    // segment3
    //
    // And the current player state:
    //
    // current time: 8
    // buffer: 0 => 20
    //
    // The next segment on the current rendition would be segment3, filling the buffer from
    // 20s onwards. However, if a rendition switch happens after segment2 was requested,
    // then the next segment to be requested will be segment1 from the new rendition in
    // order to fill time 8 and onwards. Using the buffered end would result in repeated
    // content (since it would position segment1 of the new rendition starting at 20s). This
    // case can be identified when the new segment's timeline is a prior value. Instead of
    // using the buffered end, the startOfSegment can be used, which, hopefully, will be
    // more accurate to the actual start time of the segment.
    if (segmentTimeline < currentTimeline) return startOfSegment;
     // segmentInfo.startOfSegment used to be used as the timestamp offset, however, that
    // value uses the end of the last segment if it is available. While this value
    // should often be correct, it's better to rely on the buffered end, as the new
    // content post discontinuity should line up with the buffered end as if it were
    // time 0 for the new content.
    return buffered.length ? buffered.end(buffered.length - 1) : startOfSegment;
};
/**
 * Returns whether or not the loader should wait for a timeline change from the timeline
 * change controller before processing the segment.
 *
 * Primary timing in VHS goes by video. This is different from most media players, as
 * audio is more often used as the primary timing source. For the foreseeable future, VHS
 * will continue to use video as the primary timing source, due to the current logic and
 * expectations built around it.

 * Since the timing follows video, in order to maintain sync, the video loader is
 * responsible for setting both audio and video source buffer timestamp offsets.
 *
 * Setting different values for audio and video source buffers could lead to
 * desyncing. The following examples demonstrate some of the situations where this
 * distinction is important. Note that all of these cases involve demuxed content. When
 * content is muxed, the audio and video are packaged together, therefore syncing
 * separate media playlists is not an issue.
 *
 * CASE 1: Audio prepares to load a new timeline before video:
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:                     ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader              ^
 *
 * In the above example, the audio loader is preparing to load the 6th segment, the first
 * after a discontinuity, while the video loader is still loading the 5th segment, before
 * the discontinuity.
 *
 * If the audio loader goes ahead and loads and appends the 6th segment before the video
 * loader crosses the discontinuity, then when appended, the 6th audio segment will use
 * the timestamp offset from timeline 0. This will likely lead to desyncing. In addition,
 * the audio loader must provide the audioAppendStart value to trim the content in the
 * transmuxer, and that value relies on the audio timestamp offset. Since the audio
 * timestamp offset is set by the video (main) loader, the audio loader shouldn't load the
 * segment until that value is provided.
 *
 * CASE 2: Video prepares to load a new timeline before audio:
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:             ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader                      ^
 *
 * In the above example, the video loader is preparing to load the 6th segment, the first
 * after a discontinuity, while the audio loader is still loading the 5th segment, before
 * the discontinuity.
 *
 * If the video loader goes ahead and loads and appends the 6th segment, then once the
 * segment is loaded and processed, both the video and audio timestamp offsets will be
 * set, since video is used as the primary timing source. This is to ensure content lines
 * up appropriately, as any modifications to the video timing are reflected by audio when
 * the video loader sets the audio and video timestamp offsets to the same value. However,
 * setting the timestamp offset for audio before audio has had a chance to change
 * timelines will likely lead to desyncing, as the audio loader will append segment 5 with
 * a timestamp intended to apply to segments from timeline 1 rather than timeline 0.
 *
 * CASE 3: When seeking, audio prepares to load a new timeline before video
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:           ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader            ^
 *
 * In the above example, both audio and video loaders are loading segments from timeline
 * 0, but imagine that the seek originated from timeline 1.
 *
 * When seeking to a new timeline, the timestamp offset will be set based on the expected
 * segment start of the loaded video segment. In order to maintain sync, the audio loader
 * must wait for the video loader to load its segment and update both the audio and video
 * timestamp offsets before it may load and append its own segment. This is the case
 * whether the seek results in a mismatched segment request (e.g., the audio loader
 * chooses to load segment 3 and the video loader chooses to load segment 4) or the
 * loaders choose to load the same segment index from each playlist, as the segments may
 * not be aligned perfectly, even for matching segment indexes.
 *
 * @param {Object} timelinechangeController
 * @param {number} currentTimeline
 *        The timeline currently being followed by the loader
 * @param {number} segmentTimeline
 *        The timeline of the segment being loaded
 * @param {('main'|'audio')} loaderType
 *        The loader type
 * @param {boolean} audioDisabled
 *        Whether the audio is disabled for the loader. This should only be true when the
 *        loader may have muxed audio in its segment, but should not append it, e.g., for
 *        the main loader when an alternate audio playlist is active.
 *
 * @return {boolean}
 *         Whether the loader should wait for a timeline change from the timeline change
 *         controller before processing the segment
 */ const $cb03b711053a4297$var$shouldWaitForTimelineChange = ({ timelineChangeController: timelineChangeController, currentTimeline: currentTimeline, segmentTimeline: segmentTimeline, loaderType: loaderType, audioDisabled: audioDisabled })=>{
    if (currentTimeline === segmentTimeline) return false;
    if (loaderType === 'audio') {
        const lastMainTimelineChange = timelineChangeController.lastTimelineChange({
            type: 'main'
        }); // Audio loader should wait if:
        //
        // * main hasn't had a timeline change yet (thus has not loaded its first segment)
        // * main hasn't yet changed to the timeline audio is looking to load
        return !lastMainTimelineChange || lastMainTimelineChange.to !== segmentTimeline;
    } // The main loader only needs to wait for timeline changes if there's demuxed audio.
    // Otherwise, there's nothing to wait for, since audio would be muxed into the main
    // loader's segments (or the content is audio/video only and handled by the main
    // loader).
    if (loaderType === 'main' && audioDisabled) {
        const pendingAudioTimelineChange = timelineChangeController.pendingTimelineChange({
            type: 'audio'
        }); // Main loader should wait for the audio loader if audio is not pending a timeline
        // change to the current timeline.
        //
        // Since the main loader is responsible for setting the timestamp offset for both
        // audio and video, the main loader must wait for audio to be about to change to its
        // timeline before setting the offset, otherwise, if audio is behind in loading,
        // segments from the previous timeline would be adjusted by the new timestamp offset.
        //
        // This requirement means that video will not cross a timeline until the audio is
        // about to cross to it, so that way audio and video will always cross the timeline
        // together.
        //
        // In addition to normal timeline changes, these rules also apply to the start of a
        // stream (going from a non-existent timeline, -1, to timeline 0). It's important
        // that these rules apply to the first timeline change because if they did not, it's
        // possible that the main loader will cross two timelines before the audio loader has
        // crossed one. Logic may be implemented to handle the startup as a special case, but
        // it's easier to simply treat all timeline changes the same.
        if (pendingAudioTimelineChange && pendingAudioTimelineChange.to === segmentTimeline) return false;
        return true;
    }
    return false;
};
const $cb03b711053a4297$var$shouldFixBadTimelineChanges = (timelineChangeController)=>{
    if (!timelineChangeController) return false;
    const pendingAudioTimelineChange = timelineChangeController.pendingTimelineChange({
        type: 'audio'
    });
    const pendingMainTimelineChange = timelineChangeController.pendingTimelineChange({
        type: 'main'
    });
    const hasPendingTimelineChanges = pendingAudioTimelineChange && pendingMainTimelineChange;
    const differentPendingChanges = hasPendingTimelineChanges && pendingAudioTimelineChange.to !== pendingMainTimelineChange.to;
    const isNotInitialPendingTimelineChange = hasPendingTimelineChanges && pendingAudioTimelineChange.from !== -1 && pendingMainTimelineChange.from !== -1;
    if (isNotInitialPendingTimelineChange && differentPendingChanges) return true;
    return false;
};
/**
 * Check if the pending audio timeline change is behind the
 * pending main timeline change.
 *
 * @param {SegmentLoader} segmentLoader
 * @return {boolean}
 */ const $cb03b711053a4297$var$isAudioTimelineBehind = (segmentLoader)=>{
    const pendingAudioTimelineChange = segmentLoader.timelineChangeController_.pendingTimelineChange({
        type: 'audio'
    });
    const pendingMainTimelineChange = segmentLoader.timelineChangeController_.pendingTimelineChange({
        type: 'main'
    });
    const hasPendingTimelineChanges = pendingAudioTimelineChange && pendingMainTimelineChange;
    return hasPendingTimelineChanges && pendingAudioTimelineChange.to < pendingMainTimelineChange.to;
};
/**
 * A method to check if the player is waiting for a timeline change, and fixes
 * certain scenarios where the timelines need to be updated.
 *
 * @param {SegmentLoader} segmentLoader
 */ const $cb03b711053a4297$var$checkAndFixTimelines = (segmentLoader)=>{
    const segmentInfo = segmentLoader.pendingSegment_;
    if (!segmentInfo) return;
    const waitingForTimelineChange = $cb03b711053a4297$var$shouldWaitForTimelineChange({
        timelineChangeController: segmentLoader.timelineChangeController_,
        currentTimeline: segmentLoader.currentTimeline_,
        segmentTimeline: segmentInfo.timeline,
        loaderType: segmentLoader.loaderType_,
        audioDisabled: segmentLoader.audioDisabled_
    });
    if (waitingForTimelineChange && $cb03b711053a4297$var$shouldFixBadTimelineChanges(segmentLoader.timelineChangeController_)) {
        if ($cb03b711053a4297$var$isAudioTimelineBehind(segmentLoader)) {
            segmentLoader.timelineChangeController_.trigger('audioTimelineBehind');
            return;
        }
        segmentLoader.timelineChangeController_.trigger('fixBadTimelineChange');
    }
};
const $cb03b711053a4297$var$mediaDuration = (timingInfos)=>{
    let maxDuration = 0;
    [
        'video',
        'audio'
    ].forEach(function(type) {
        const typeTimingInfo = timingInfos[`${type}TimingInfo`];
        if (!typeTimingInfo) return;
        const { start: start, end: end } = typeTimingInfo;
        let duration;
        if (typeof start === 'bigint' || typeof end === 'bigint') duration = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(end) - (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(start);
        else if (typeof start === 'number' && typeof end === 'number') duration = end - start;
        if (typeof duration !== 'undefined' && duration > maxDuration) maxDuration = duration;
    }); // convert back to a number if it is lower than MAX_SAFE_INTEGER
    // as we only need BigInt when we are above that.
    if (typeof maxDuration === 'bigint' && maxDuration < Number.MAX_SAFE_INTEGER) maxDuration = Number(maxDuration);
    return maxDuration;
};
const $cb03b711053a4297$var$segmentTooLong = ({ segmentDuration: segmentDuration, maxDuration: maxDuration })=>{
    // 0 duration segments are most likely due to metadata only segments or a lack of
    // information.
    if (!segmentDuration) return false;
     // For HLS:
    //
    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1
    // The EXTINF duration of each Media Segment in the Playlist
    // file, when rounded to the nearest integer, MUST be less than or equal
    // to the target duration; longer segments can trigger playback stalls
    // or other errors.
    //
    // For DASH, the mpd-parser uses the largest reported segment duration as the target
    // duration. Although that reported duration is occasionally approximate (i.e., not
    // exact), a strict check may report that a segment is too long more often in DASH.
    return Math.round(segmentDuration) > maxDuration + $cb03b711053a4297$var$TIME_FUDGE_FACTOR;
};
const $cb03b711053a4297$var$getTroublesomeSegmentDurationMessage = (segmentInfo, sourceType)=>{
    // Right now we aren't following DASH's timing model exactly, so only perform
    // this check for HLS content.
    if (sourceType !== 'hls') return null;
    const segmentDuration = $cb03b711053a4297$var$mediaDuration({
        audioTimingInfo: segmentInfo.audioTimingInfo,
        videoTimingInfo: segmentInfo.videoTimingInfo
    }); // Don't report if we lack information.
    //
    // If the segment has a duration of 0 it is either a lack of information or a
    // metadata only segment and shouldn't be reported here.
    if (!segmentDuration) return null;
    const targetDuration = segmentInfo.playlist.targetDuration;
    const isSegmentWayTooLong = $cb03b711053a4297$var$segmentTooLong({
        segmentDuration: segmentDuration,
        maxDuration: targetDuration * 2
    });
    const isSegmentSlightlyTooLong = $cb03b711053a4297$var$segmentTooLong({
        segmentDuration: segmentDuration,
        maxDuration: targetDuration
    });
    const segmentTooLongMessage = `Segment with index ${segmentInfo.mediaIndex} ` + `from playlist ${segmentInfo.playlist.id} ` + `has a duration of ${segmentDuration} ` + `when the reported duration is ${segmentInfo.duration} ` + `and the target duration is ${targetDuration}. ` + 'For HLS content, a duration in excess of the target duration may result in ' + 'playback issues. See the HLS specification section on EXT-X-TARGETDURATION for ' + 'more details: ' + 'https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1';
    if (isSegmentWayTooLong || isSegmentSlightlyTooLong) return {
        severity: isSegmentWayTooLong ? 'warn' : 'info',
        message: segmentTooLongMessage
    };
    return null;
};
/**
 *
 * @param {Object} options type of segment loader and segment either segmentInfo or simple segment
 * @return a segmentInfo payload for events or errors.
 */ const $cb03b711053a4297$var$segmentInfoPayload = ({ type: type, segment: segment })=>{
    if (!segment) return;
    const isEncrypted = Boolean(segment.key || segment.map && segment.map.ke);
    const isMediaInitialization = Boolean(segment.map && !segment.map.bytes);
    const start = segment.startOfSegment === undefined ? segment.start : segment.startOfSegment;
    return {
        type: type || segment.type,
        uri: segment.resolvedUri || segment.uri,
        start: start,
        duration: segment.duration,
        isEncrypted: isEncrypted,
        isMediaInitialization: isMediaInitialization
    };
};
/**
 * An object that manages segment loading and appending.
 *
 * @class SegmentLoader
 * @param {Object} options required and optional options
 * @extends videojs.EventTarget
 */ class $cb03b711053a4297$var$SegmentLoader extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(settings, options = {}){
        super(); // check pre-conditions
        if (!settings) throw new TypeError('Initialization settings are required');
        if (typeof settings.currentTime !== 'function') throw new TypeError('No currentTime getter specified');
        if (!settings.mediaSource) throw new TypeError('No MediaSource specified');
         // public properties
        this.bandwidth = settings.bandwidth;
        this.throughput = {
            rate: 0,
            count: 0
        };
        this.roundTrip = NaN;
        this.resetStats_();
        this.mediaIndex = null;
        this.partIndex = null; // private settings
        this.hasPlayed_ = settings.hasPlayed;
        this.currentTime_ = settings.currentTime;
        this.seekable_ = settings.seekable;
        this.seeking_ = settings.seeking;
        this.duration_ = settings.duration;
        this.mediaSource_ = settings.mediaSource;
        this.vhs_ = settings.vhs;
        this.loaderType_ = settings.loaderType;
        this.currentMediaInfo_ = void 0;
        this.startingMediaInfo_ = void 0;
        this.segmentMetadataTrack_ = settings.segmentMetadataTrack;
        this.goalBufferLength_ = settings.goalBufferLength;
        this.sourceType_ = settings.sourceType;
        this.sourceUpdater_ = settings.sourceUpdater;
        this.inbandTextTracks_ = settings.inbandTextTracks;
        this.state_ = 'INIT';
        this.timelineChangeController_ = settings.timelineChangeController;
        this.shouldSaveSegmentTimingInfo_ = true;
        this.parse708captions_ = settings.parse708captions;
        this.useDtsForTimestampOffset_ = settings.useDtsForTimestampOffset;
        this.captionServices_ = settings.captionServices;
        this.exactManifestTimings = settings.exactManifestTimings;
        this.addMetadataToTextTrack = settings.addMetadataToTextTrack; // private instance variables
        this.checkBufferTimeout_ = null;
        this.error_ = void 0;
        this.currentTimeline_ = -1;
        this.shouldForceTimestampOffsetAfterResync_ = false;
        this.pendingSegment_ = null;
        this.xhrOptions_ = null;
        this.pendingSegments_ = [];
        this.audioDisabled_ = false;
        this.isPendingTimestampOffset_ = false; // TODO possibly move gopBuffer and timeMapping info to a separate controller
        this.gopBuffer_ = [];
        this.timeMapping_ = 0;
        this.safeAppend_ = false;
        this.appendInitSegment_ = {
            audio: true,
            video: true
        };
        this.playlistOfLastInitSegment_ = {
            audio: null,
            video: null
        };
        this.callQueue_ = []; // If the segment loader prepares to load a segment, but does not have enough
        // information yet to start the loading process (e.g., if the audio loader wants to
        // load a segment from the next timeline but the main loader hasn't yet crossed that
        // timeline), then the load call will be added to the queue until it is ready to be
        // processed.
        this.loadQueue_ = [];
        this.metadataQueue_ = {
            id3: [],
            caption: []
        };
        this.waitingOnRemove_ = false;
        this.quotaExceededErrorRetryTimeout_ = null; // Fragmented mp4 playback
        this.activeInitSegmentId_ = null;
        this.initSegments_ = {}; // HLSe playback
        this.cacheEncryptionKeys_ = settings.cacheEncryptionKeys;
        this.keyCache_ = {};
        this.decrypter_ = settings.decrypter; // Manages the tracking and generation of sync-points, mappings
        // between a time in the display time and a segment index within
        // a playlist
        this.syncController_ = settings.syncController;
        this.syncPoint_ = {
            segmentIndex: 0,
            time: 0
        };
        this.transmuxer_ = this.createTransmuxer_();
        this.triggerSyncInfoUpdate_ = ()=>this.trigger('syncinfoupdate');
        this.syncController_.on('syncinfoupdate', this.triggerSyncInfoUpdate_);
        this.mediaSource_.addEventListener('sourceopen', ()=>{
            if (!this.isEndOfStream_()) this.ended_ = false;
        }); // ...for determining the fetch location
        this.fetchAtBuffer_ = false;
        this.logger_ = $cb03b711053a4297$var$logger(`SegmentLoader[${this.loaderType_}]`);
        Object.defineProperty(this, 'state', {
            get () {
                return this.state_;
            },
            set (newState) {
                if (newState !== this.state_) {
                    this.logger_(`${this.state_} -> ${newState}`);
                    this.state_ = newState;
                    this.trigger('statechange');
                }
            }
        });
        this.sourceUpdater_.on('ready', ()=>{
            if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
            else $cb03b711053a4297$var$checkAndFixTimelines(this);
        });
        this.sourceUpdater_.on('codecschange', (metadata)=>{
            this.trigger((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                type: 'codecschange'
            }, metadata));
        }); // Only the main loader needs to listen for pending timeline changes, as the main
        // loader should wait for audio to be ready to change its timeline so that both main
        // and audio timelines change together. For more details, see the
        // shouldWaitForTimelineChange function.
        if (this.loaderType_ === 'main') this.timelineChangeController_.on('pendingtimelinechange', ()=>{
            if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
            else $cb03b711053a4297$var$checkAndFixTimelines(this);
        });
         // The main loader only listens on pending timeline changes, but the audio loader,
        // since its loads follow main, needs to listen on timeline changes. For more details,
        // see the shouldWaitForTimelineChange function.
        if (this.loaderType_ === 'audio') this.timelineChangeController_.on('timelinechange', (metadata)=>{
            this.trigger((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                type: 'timelinechange'
            }, metadata));
            if (this.hasEnoughInfoToLoad_()) this.processLoadQueue_();
            else $cb03b711053a4297$var$checkAndFixTimelines(this);
            if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
            else $cb03b711053a4297$var$checkAndFixTimelines(this);
        });
    }
    /**
   * TODO: Current sync controller consists of many hls-specific strategies
   * media sequence sync is also hls-specific, and we would like to be protocol-agnostic on this level
   * this should be a part of the sync-controller and sync controller should expect different strategy list based on the protocol.
   *
   * @return {MediaSequenceSync|null}
   * @private
   */ get mediaSequenceSync_() {
        return this.syncController_.getMediaSequenceSync(this.loaderType_);
    }
    createTransmuxer_() {
        return $cb03b711053a4297$var$segmentTransmuxer.createTransmuxer({
            remux: false,
            alignGopsAtEnd: this.safeAppend_,
            keepOriginalTimestamps: true,
            parse708captions: this.parse708captions_,
            captionServices: this.captionServices_
        });
    }
    /**
   * reset all of our media stats
   *
   * @private
   */ resetStats_() {
        this.mediaBytesTransferred = 0;
        this.mediaRequests = 0;
        this.mediaRequestsAborted = 0;
        this.mediaRequestsTimedout = 0;
        this.mediaRequestsErrored = 0;
        this.mediaTransferDuration = 0;
        this.mediaSecondsLoaded = 0;
        this.mediaAppends = 0;
    }
    /**
   * dispose of the SegmentLoader and reset to the default state
   */ dispose() {
        this.trigger('dispose');
        this.state = 'DISPOSED';
        this.pause();
        this.abort_();
        if (this.transmuxer_) this.transmuxer_.terminate();
        this.resetStats_();
        if (this.checkBufferTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkBufferTimeout_);
        if (this.syncController_ && this.triggerSyncInfoUpdate_) this.syncController_.off('syncinfoupdate', this.triggerSyncInfoUpdate_);
        this.off();
    }
    setAudio(enable) {
        this.audioDisabled_ = !enable;
        if (enable) this.appendInitSegment_.audio = true;
        else // remove current track audio if it gets disabled
        this.sourceUpdater_.removeAudio(0, this.duration_());
    }
    /**
   * abort anything that is currently doing on with the SegmentLoader
   * and reset to a default state
   */ abort() {
        if (this.state !== 'WAITING') {
            if (this.pendingSegment_) this.pendingSegment_ = null;
            this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
            return;
        }
        this.abort_(); // We aborted the requests we were waiting on, so reset the loader's state to READY
        // since we are no longer "waiting" on any requests. XHR callback is not always run
        // when the request is aborted. This will prevent the loader from being stuck in the
        // WAITING state indefinitely.
        this.state = 'READY'; // don't wait for buffer check timeouts to begin fetching the
        // next segment
        if (!this.paused()) this.monitorBuffer_();
    }
    /**
   * abort all pending xhr requests and null any pending segements
   *
   * @private
   */ abort_() {
        if (this.pendingSegment_ && this.pendingSegment_.abortRequests) this.pendingSegment_.abortRequests();
         // clear out the segment being processed
        this.pendingSegment_ = null;
        this.callQueue_ = [];
        this.loadQueue_ = [];
        this.metadataQueue_.id3 = [];
        this.metadataQueue_.caption = [];
        this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
        this.waitingOnRemove_ = false;
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.quotaExceededErrorRetryTimeout_);
        this.quotaExceededErrorRetryTimeout_ = null;
    }
    checkForAbort_(requestId) {
        // If the state is APPENDING, then aborts will not modify the state, meaning the first
        // callback that happens should reset the state to READY so that loading can continue.
        if (this.state === 'APPENDING' && !this.pendingSegment_) {
            this.state = 'READY';
            return true;
        }
        if (!this.pendingSegment_ || this.pendingSegment_.requestId !== requestId) return true;
        return false;
    }
    /**
   * set an error on the segment loader and null out any pending segements
   *
   * @param {Error} error the error to set on the SegmentLoader
   * @return {Error} the error that was set or that is currently set
   */ error(error) {
        if (typeof error !== 'undefined') {
            this.logger_('error occurred:', error);
            this.error_ = error;
        }
        this.pendingSegment_ = null;
        return this.error_;
    }
    endOfStream() {
        this.ended_ = true;
        if (this.transmuxer_) // need to clear out any cached data to prepare for the new segment
        $cb03b711053a4297$var$segmentTransmuxer.reset(this.transmuxer_);
        this.gopBuffer_.length = 0;
        this.pause();
        this.trigger('ended');
    }
    /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */ buffered_() {
        const trackInfo = this.getMediaInfo_();
        if (!this.sourceUpdater_ || !trackInfo) return $cb03b711053a4297$var$createTimeRanges();
        if (this.loaderType_ === 'main') {
            const { hasAudio: hasAudio, hasVideo: hasVideo, isMuxed: isMuxed } = trackInfo;
            if (hasVideo && hasAudio && !this.audioDisabled_ && !isMuxed) return this.sourceUpdater_.buffered();
            if (hasVideo) return this.sourceUpdater_.videoBuffered();
        } // One case that can be ignored for now is audio only with alt audio,
        // as we don't yet have proper support for that.
        return this.sourceUpdater_.audioBuffered();
    }
    /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */ initSegmentForMap(map, set = false) {
        if (!map) return null;
        const id = $cb03b711053a4297$var$initSegmentId(map);
        let storedMap = this.initSegments_[id];
        if (set && !storedMap && map.bytes) this.initSegments_[id] = storedMap = {
            resolvedUri: map.resolvedUri,
            byterange: map.byterange,
            bytes: map.bytes,
            tracks: map.tracks,
            timescales: map.timescales
        };
        return storedMap || map;
    }
    /**
   * Gets and sets key for the provided key
   *
   * @param {Object} key
   *        The key object representing the key to get or set
   * @param {boolean=} set
   *        If true, the key for the provided key should be saved
   * @return {Object}
   *         Key object for desired key
   */ segmentKey(key, set = false) {
        if (!key) return null;
        const id = $cb03b711053a4297$var$segmentKeyId(key);
        let storedKey = this.keyCache_[id]; // TODO: We should use the HTTP Expires header to invalidate our cache per
        // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-6.2.3
        if (this.cacheEncryptionKeys_ && set && !storedKey && key.bytes) this.keyCache_[id] = storedKey = {
            resolvedUri: key.resolvedUri,
            bytes: key.bytes
        };
        const result = {
            resolvedUri: (storedKey || key).resolvedUri
        };
        if (storedKey) result.bytes = storedKey.bytes;
        return result;
    }
    /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */ couldBeginLoading_() {
        return this.playlist_ && !this.paused();
    }
    /**
   * load a playlist and start to fill the buffer
   */ load() {
        // un-pause
        this.monitorBuffer_(); // if we don't have a playlist yet, keep waiting for one to be
        // specified
        if (!this.playlist_) return;
         // if all the configuration is ready, initialize and begin loading
        if (this.state === 'INIT' && this.couldBeginLoading_()) return this.init_();
         // if we're in the middle of processing a segment already, don't
        // kick off an additional segment request
        if (!this.couldBeginLoading_() || this.state !== 'READY' && this.state !== 'INIT') return;
        this.state = 'READY';
    }
    /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */ init_() {
        this.state = 'READY'; // if this is the audio segment loader, and it hasn't been inited before, then any old
        // audio data from the muxed content should be removed
        this.resetEverything();
        return this.monitorBuffer_();
    }
    /**
   * set a playlist on the segment loader
   *
   * @param {PlaylistLoader} media the playlist to set on the segment loader
   */ playlist(newPlaylist, options = {}) {
        if (!newPlaylist) return;
        if (this.playlist_ && this.playlist_.endList && newPlaylist.endList && this.playlist_.uri === newPlaylist.uri) // skip update if both prev and new are vod and have the same URI
        return;
        const oldPlaylist = this.playlist_;
        const segmentInfo = this.pendingSegment_;
        this.playlist_ = newPlaylist;
        this.xhrOptions_ = options; // when we haven't started playing yet, the start of a live playlist
        // is always our zero-time so force a sync update each time the playlist
        // is refreshed from the server
        //
        // Use the INIT state to determine if playback has started, as the playlist sync info
        // should be fixed once requests begin (as sync points are generated based on sync
        // info), but not before then.
        if (this.state === 'INIT') {
            newPlaylist.syncInfo = {
                mediaSequence: newPlaylist.mediaSequence,
                time: 0
            }; // Setting the date time mapping means mapping the program date time (if available)
            // to time 0 on the player's timeline. The playlist's syncInfo serves a similar
            // purpose, mapping the initial mediaSequence to time zero. Since the syncInfo can
            // be updated as the playlist is refreshed before the loader starts loading, the
            // program date time mapping needs to be updated as well.
            //
            // This mapping is only done for the main loader because a program date time should
            // map equivalently between playlists.
            if (this.loaderType_ === 'main') this.syncController_.setDateTimeMappingForStart(newPlaylist);
        }
        let oldId = null;
        if (oldPlaylist) {
            if (oldPlaylist.id) oldId = oldPlaylist.id;
            else if (oldPlaylist.uri) oldId = oldPlaylist.uri;
        }
        this.logger_(`playlist update [${oldId} => ${newPlaylist.id || newPlaylist.uri}]`);
        if (this.mediaSequenceSync_) {
            this.mediaSequenceSync_.update(newPlaylist, this.currentTime_());
            this.logger_(`Playlist update:
currentTime: ${this.currentTime_()}
bufferedEnd: ${$cb03b711053a4297$var$lastBufferedEnd(this.buffered_())}
`, this.mediaSequenceSync_.diagnostics);
        } // in VOD, this is always a rendition switch (or we updated our syncInfo above)
        // in LIVE, we always want to update with new playlists (including refreshes)
        this.trigger('syncinfoupdate'); // if we were unpaused but waiting for a playlist, start
        // buffering now
        if (this.state === 'INIT' && this.couldBeginLoading_()) return this.init_();
        if (!oldPlaylist || oldPlaylist.uri !== newPlaylist.uri) {
            if (this.mediaIndex !== null) {
                // we must reset/resync the segment loader when we switch renditions and
                // the segment loader is already synced to the previous rendition
                // We only want to reset the loader here for LLHLS playback, as resetLoader sets fetchAtBuffer_
                // to false, resulting in fetching segments at currentTime and causing repeated
                // same-segment requests on playlist change. This erroneously drives up the playback watcher
                // stalled segment count, as re-requesting segments at the currentTime or browser cached segments
                // will not change the buffer.
                // Reference for LLHLS fixes: https://github.com/videojs/http-streaming/pull/1201
                const isLLHLS = !newPlaylist.endList && typeof newPlaylist.partTargetDuration === 'number';
                if (isLLHLS) this.resetLoader();
                else this.resyncLoader();
            }
            this.currentMediaInfo_ = void 0;
            this.trigger('playlistupdate'); // the rest of this function depends on `oldPlaylist` being defined
            return;
        } // we reloaded the same playlist so we are in a live scenario
        // and we will likely need to adjust the mediaIndex
        const mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence;
        this.logger_(`live window shift [${mediaSequenceDiff}]`); // update the mediaIndex on the SegmentLoader
        // this is important because we can abort a request and this value must be
        // equal to the last appended mediaIndex
        if (this.mediaIndex !== null) {
            this.mediaIndex -= mediaSequenceDiff; // this can happen if we are going to load the first segment, but get a playlist
            // update during that. mediaIndex would go from 0 to -1 if mediaSequence in the
            // new playlist was incremented by 1.
            if (this.mediaIndex < 0) {
                this.mediaIndex = null;
                this.partIndex = null;
            } else {
                const segment = this.playlist_.segments[this.mediaIndex]; // partIndex should remain the same for the same segment
                // unless parts fell off of the playlist for this segment.
                // In that case we need to reset partIndex and resync
                if (this.partIndex && (!segment.parts || !segment.parts.length || !segment.parts[this.partIndex])) {
                    const mediaIndex = this.mediaIndex;
                    this.logger_(`currently processing part (index ${this.partIndex}) no longer exists.`);
                    this.resetLoader(); // We want to throw away the partIndex and the data associated with it,
                    // as the part was dropped from our current playlists segment.
                    // The mediaIndex will still be valid so keep that around.
                    this.mediaIndex = mediaIndex;
                }
            }
        } // update the mediaIndex on the SegmentInfo object
        // this is important because we will update this.mediaIndex with this value
        // in `handleAppendsDone_` after the segment has been successfully appended
        if (segmentInfo) {
            segmentInfo.mediaIndex -= mediaSequenceDiff;
            if (segmentInfo.mediaIndex < 0) {
                segmentInfo.mediaIndex = null;
                segmentInfo.partIndex = null;
            } else {
                // we need to update the referenced segment so that timing information is
                // saved for the new playlist's segment, however, if the segment fell off the
                // playlist, we can leave the old reference and just lose the timing info
                if (segmentInfo.mediaIndex >= 0) segmentInfo.segment = newPlaylist.segments[segmentInfo.mediaIndex];
                if (segmentInfo.partIndex >= 0 && segmentInfo.segment.parts) segmentInfo.part = segmentInfo.segment.parts[segmentInfo.partIndex];
            }
        }
        this.syncController_.saveExpiredSegmentInfo(oldPlaylist, newPlaylist);
    }
    /**
   * Prevent the loader from fetching additional segments. If there
   * is a segment request outstanding, it will finish processing
   * before the loader halts. A segment loader can be unpaused by
   * calling load().
   */ pause() {
        if (this.checkBufferTimeout_) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkBufferTimeout_);
            this.checkBufferTimeout_ = null;
        }
    }
    /**
   * Returns whether the segment loader is fetching additional
   * segments when given the opportunity. This property can be
   * modified through calls to pause() and load().
   */ paused() {
        return this.checkBufferTimeout_ === null;
    }
    /**
   * Delete all the buffered data and reset the SegmentLoader
   *
   * @param {Function} [done] an optional callback to be executed when the remove
   * operation is complete
   */ resetEverything(done) {
        this.ended_ = false;
        this.activeInitSegmentId_ = null;
        this.appendInitSegment_ = {
            audio: true,
            video: true
        };
        this.resetLoader(); // remove from 0, the earliest point, to Infinity, to signify removal of everything.
        // VTT Segment Loader doesn't need to do anything but in the regular SegmentLoader,
        // we then clamp the value to duration if necessary.
        this.remove(0, Infinity, done); // clears fmp4 captions
        if (this.transmuxer_) {
            this.transmuxer_.postMessage({
                action: 'clearAllMp4Captions'
            }); // reset the cache in the transmuxer
            this.transmuxer_.postMessage({
                action: 'reset'
            });
        }
    }
    /**
   * Force the SegmentLoader to resync and start loading around the currentTime instead
   * of starting at the end of the buffer
   *
   * Useful for fast quality changes
   */ resetLoader() {
        this.fetchAtBuffer_ = false;
        if (this.mediaSequenceSync_) this.mediaSequenceSync_.resetAppendedStatus();
        this.resyncLoader();
    }
    /**
   * Force the SegmentLoader to restart synchronization and make a conservative guess
   * before returning to the simple walk-forward method
   */ resyncLoader() {
        if (this.transmuxer_) // need to clear out any cached data to prepare for the new segment
        $cb03b711053a4297$var$segmentTransmuxer.reset(this.transmuxer_);
        this.mediaIndex = null;
        this.partIndex = null;
        this.syncPoint_ = null;
        this.isPendingTimestampOffset_ = false; // this is mainly to sync timing-info when switching between renditions with and without timestamp-rollover,
        // so we don't want it for DASH or fragmented mp4 segments.
        const isFmp4 = this.currentMediaInfo_ && this.currentMediaInfo_.isFmp4;
        const isHlsTs = this.sourceType_ === 'hls' && !isFmp4;
        if (isHlsTs) this.shouldForceTimestampOffsetAfterResync_ = true;
        this.callQueue_ = [];
        this.loadQueue_ = [];
        this.metadataQueue_.id3 = [];
        this.metadataQueue_.caption = [];
        this.abort();
        if (this.transmuxer_) this.transmuxer_.postMessage({
            action: 'clearParsedMp4Captions'
        });
    }
    /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   * @param {Function} [done] - an optional callback to be executed when the remove
   * @param {boolean} force - force all remove operations to happen
   * operation is complete
   */ remove(start, end, done = ()=>{}, force = false) {
        // clamp end to duration if we need to remove everything.
        // This is due to a browser bug that causes issues if we remove to Infinity.
        // videojs/videojs-contrib-hls#1225
        if (end === Infinity) end = this.duration_();
         // skip removes that would throw an error
        // commonly happens during a rendition switch at the start of a video
        // from start 0 to end 0
        if (end <= start) {
            this.logger_('skipping remove because end ${end} is <= start ${start}');
            return;
        }
        if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
            this.logger_('skipping remove because no source updater or starting media info'); // nothing to remove if we haven't processed any media
            return;
        } // set it to one to complete this function's removes
        let removesRemaining = 1;
        const removeFinished = ()=>{
            removesRemaining--;
            if (removesRemaining === 0) done();
        };
        if (force || !this.audioDisabled_) {
            removesRemaining++;
            this.sourceUpdater_.removeAudio(start, end, removeFinished);
        } // While it would be better to only remove video if the main loader has video, this
        // should be safe with audio only as removeVideo will call back even if there's no
        // video buffer.
        //
        // In theory we can check to see if there's video before calling the remove, but in
        // the event that we're switching between renditions and from video to audio only
        // (when we add support for that), we may need to clear the video contents despite
        // what the new media will contain.
        if (force || this.loaderType_ === 'main') {
            this.gopBuffer_ = $cb03b711053a4297$var$removeGopBuffer(this.gopBuffer_, start, end, this.timeMapping_);
            removesRemaining++;
            this.sourceUpdater_.removeVideo(start, end, removeFinished);
        } // remove any captions and ID3 tags
        for(const track in this.inbandTextTracks_)$cb03b711053a4297$var$removeCuesFromTrack(start, end, this.inbandTextTracks_[track]);
        $cb03b711053a4297$var$removeCuesFromTrack(start, end, this.segmentMetadataTrack_); // finished this function's removes
        removeFinished();
    }
    /**
   * (re-)schedule monitorBufferTick_ to run as soon as possible
   *
   * @private
   */ monitorBuffer_() {
        if (this.checkBufferTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkBufferTimeout_);
        this.checkBufferTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(this.monitorBufferTick_.bind(this), 1);
    }
    /**
   * As long as the SegmentLoader is in the READY state, periodically
   * invoke fillBuffer_().
   *
   * @private
   */ monitorBufferTick_() {
        if (this.state === 'READY') this.fillBuffer_();
        if (this.checkBufferTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkBufferTimeout_);
        this.checkBufferTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(this.monitorBufferTick_.bind(this), $cb03b711053a4297$var$CHECK_BUFFER_DELAY);
    }
    /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */ fillBuffer_() {
        // TODO since the source buffer maintains a queue, and we shouldn't call this function
        // except when we're ready for the next segment, this check can most likely be removed
        if (this.sourceUpdater_.updating()) return;
         // see if we need to begin loading immediately
        const segmentInfo = this.chooseNextRequest_();
        if (!segmentInfo) return;
        const metadata = {
            segmentInfo: $cb03b711053a4297$var$segmentInfoPayload({
                type: this.loaderType_,
                segment: segmentInfo
            })
        };
        this.trigger({
            type: 'segmentselected',
            metadata: metadata
        });
        if (typeof segmentInfo.timestampOffset === 'number') {
            this.isPendingTimestampOffset_ = false;
            this.timelineChangeController_.pendingTimelineChange({
                type: this.loaderType_,
                from: this.currentTimeline_,
                to: segmentInfo.timeline
            });
        }
        this.loadSegment_(segmentInfo);
    }
    /**
   * Determines if we should call endOfStream on the media source based
   * on the state of the buffer or if appened segment was the final
   * segment in the playlist.
   *
   * @param {number} [mediaIndex] the media index of segment we last appended
   * @param {Object} [playlist] a media playlist object
   * @return {boolean} do we need to call endOfStream on the MediaSource
   */ isEndOfStream_(mediaIndex = this.mediaIndex, playlist = this.playlist_, partIndex = this.partIndex) {
        if (!playlist || !this.mediaSource_) return false;
        const segment = typeof mediaIndex === 'number' && playlist.segments[mediaIndex]; // mediaIndex is zero based but length is 1 based
        const appendedLastSegment = mediaIndex + 1 === playlist.segments.length; // true if there are no parts, or this is the last part.
        const appendedLastPart = !segment || !segment.parts || partIndex + 1 === segment.parts.length; // if we've buffered to the end of the video, we need to call endOfStream
        // so that MediaSources can trigger the `ended` event when it runs out of
        // buffered data instead of waiting for me
        return playlist.endList && this.mediaSource_.readyState === 'open' && appendedLastSegment && appendedLastPart;
    }
    /**
   * Determines what request should be made given current segment loader state.
   *
   * @return {Object} a request object that describes the segment/part to load
   */ chooseNextRequest_() {
        const buffered = this.buffered_();
        const bufferedEnd = $cb03b711053a4297$var$lastBufferedEnd(buffered) || 0;
        const bufferedTime = $cb03b711053a4297$var$timeAheadOf(buffered, this.currentTime_());
        const preloaded = !this.hasPlayed_() && bufferedTime >= 1;
        const haveEnoughBuffer = bufferedTime >= this.goalBufferLength_();
        const segments = this.playlist_.segments; // return no segment if:
        // 1. we don't have segments
        // 2. The video has not yet played and we already downloaded a segment
        // 3. we already have enough buffered time
        if (!segments.length || preloaded || haveEnoughBuffer) return null;
        this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_(), this.loaderType_);
        const next = {
            partIndex: null,
            mediaIndex: null,
            startOfSegment: null,
            playlist: this.playlist_,
            isSyncRequest: Boolean(!this.syncPoint_)
        };
        if (next.isSyncRequest) {
            next.mediaIndex = $cb03b711053a4297$var$getSyncSegmentCandidate(this.currentTimeline_, segments, bufferedEnd);
            this.logger_(`choose next request. Can not find sync point. Fallback to media Index: ${next.mediaIndex}`);
        } else if (this.mediaIndex !== null) {
            const segment = segments[this.mediaIndex];
            const partIndex = typeof this.partIndex === 'number' ? this.partIndex : -1;
            next.startOfSegment = segment.end ? segment.end : bufferedEnd;
            if (segment.parts && segment.parts[partIndex + 1]) {
                next.mediaIndex = this.mediaIndex;
                next.partIndex = partIndex + 1;
            } else next.mediaIndex = this.mediaIndex + 1;
        } else {
            let segmentIndex;
            let partIndex;
            let startTime;
            const targetTime = this.fetchAtBuffer_ ? bufferedEnd : this.currentTime_();
            if (this.mediaSequenceSync_) this.logger_(`chooseNextRequest_ request after Quality Switch:
For TargetTime: ${targetTime}.
CurrentTime: ${this.currentTime_()}
BufferedEnd: ${bufferedEnd}
Fetch At Buffer: ${this.fetchAtBuffer_}
`, this.mediaSequenceSync_.diagnostics);
            if (this.mediaSequenceSync_ && this.mediaSequenceSync_.isReliable) {
                const syncInfo = this.getSyncInfoFromMediaSequenceSync_(targetTime);
                if (!syncInfo) {
                    const message = 'No sync info found while using media sequence sync';
                    this.error({
                        message: message,
                        metadata: {
                            errorType: $cb03b711053a4297$export$2e2bcd8739ae039.Error.StreamingFailedToSelectNextSegment,
                            error: new Error(message)
                        }
                    });
                    this.logger_('chooseNextRequest_ - no sync info found using media sequence sync'); // no match
                    return null;
                }
                this.logger_(`chooseNextRequest_ mediaSequence syncInfo (${syncInfo.start} --> ${syncInfo.end})`);
                segmentIndex = syncInfo.segmentIndex;
                partIndex = syncInfo.partIndex;
                startTime = syncInfo.start;
            } else {
                this.logger_('chooseNextRequest_ - fallback to a regular segment selection algorithm, based on a syncPoint.'); // fallback
                const mediaInfoForTime = $cb03b711053a4297$var$Playlist.getMediaInfoForTime({
                    exactManifestTimings: this.exactManifestTimings,
                    playlist: this.playlist_,
                    currentTime: targetTime,
                    startingPartIndex: this.syncPoint_.partIndex,
                    startingSegmentIndex: this.syncPoint_.segmentIndex,
                    startTime: this.syncPoint_.time
                });
                segmentIndex = mediaInfoForTime.segmentIndex;
                partIndex = mediaInfoForTime.partIndex;
                startTime = mediaInfoForTime.startTime;
            }
            next.getMediaInfoForTime = this.fetchAtBuffer_ ? `bufferedEnd ${targetTime}` : `currentTime ${targetTime}`;
            next.mediaIndex = segmentIndex;
            next.startOfSegment = startTime;
            next.partIndex = partIndex;
            this.logger_(`choose next request. Playlist switched and we have a sync point. Media Index: ${next.mediaIndex} `);
        }
        const nextSegment = segments[next.mediaIndex];
        let nextPart = nextSegment && typeof next.partIndex === 'number' && nextSegment.parts && nextSegment.parts[next.partIndex]; // if the next segment index is invalid or
        // the next partIndex is invalid do not choose a next segment.
        if (!nextSegment || typeof next.partIndex === 'number' && !nextPart) return null;
         // if the next segment has parts, and we don't have a partIndex.
        // Set partIndex to 0
        if (typeof next.partIndex !== 'number' && nextSegment.parts) {
            next.partIndex = 0;
            nextPart = nextSegment.parts[0];
        } // independentSegments applies to every segment in a playlist. If independentSegments appears in a main playlist,
        // it applies to each segment in each media playlist.
        // https://datatracker.ietf.org/doc/html/draft-pantos-http-live-streaming-23#section-4.3.5.1
        const hasIndependentSegments = this.vhs_.playlists && this.vhs_.playlists.main && this.vhs_.playlists.main.independentSegments || this.playlist_.independentSegments; // if we have no buffered data then we need to make sure
        // that the next part we append is "independent" if possible.
        // So we check if the previous part is independent, and request
        // it if it is.
        if (!bufferedTime && nextPart && !hasIndependentSegments && !nextPart.independent) {
            if (next.partIndex === 0) {
                const lastSegment = segments[next.mediaIndex - 1];
                const lastSegmentLastPart = lastSegment.parts && lastSegment.parts.length && lastSegment.parts[lastSegment.parts.length - 1];
                if (lastSegmentLastPart && lastSegmentLastPart.independent) {
                    next.mediaIndex -= 1;
                    next.partIndex = lastSegment.parts.length - 1;
                    next.independent = 'previous segment';
                }
            } else if (nextSegment.parts[next.partIndex - 1].independent) {
                next.partIndex -= 1;
                next.independent = 'previous part';
            }
        }
        const ended = this.mediaSource_ && this.mediaSource_.readyState === 'ended'; // do not choose a next segment if all of the following:
        // 1. this is the last segment in the playlist
        // 2. end of stream has been called on the media source already
        // 3. the player is not seeking
        if (next.mediaIndex >= segments.length - 1 && ended && !this.seeking_()) return null;
        if (this.shouldForceTimestampOffsetAfterResync_) {
            this.shouldForceTimestampOffsetAfterResync_ = false;
            next.forceTimestampOffset = true;
            this.logger_('choose next request. Force timestamp offset after loader resync');
        }
        return this.generateSegmentInfo_(next);
    }
    getSyncInfoFromMediaSequenceSync_(targetTime) {
        if (!this.mediaSequenceSync_) return null;
         // we should pull the target time to the least available time if we drop out of sync for any reason
        const finalTargetTime = Math.max(targetTime, this.mediaSequenceSync_.start);
        if (targetTime !== finalTargetTime) this.logger_(`getSyncInfoFromMediaSequenceSync_. Pulled target time from ${targetTime} to ${finalTargetTime}`);
        const mediaSequenceSyncInfo = this.mediaSequenceSync_.getSyncInfoForTime(finalTargetTime);
        if (!mediaSequenceSyncInfo) // no match at all
        return null;
        if (!mediaSequenceSyncInfo.isAppended) // has a perfect match
        return mediaSequenceSyncInfo;
         // has match, but segment was already appended.
        // attempt to auto-advance to the nearest next segment:
        const nextMediaSequenceSyncInfo = this.mediaSequenceSync_.getSyncInfoForTime(mediaSequenceSyncInfo.end);
        if (!nextMediaSequenceSyncInfo) // no match at all
        return null;
        if (nextMediaSequenceSyncInfo.isAppended) this.logger_('getSyncInfoFromMediaSequenceSync_: We encounter unexpected scenario where next media sequence sync info is also appended!');
         // got match with the nearest next segment
        return nextMediaSequenceSyncInfo;
    }
    generateSegmentInfo_(options) {
        const { independent: independent, playlist: playlist, mediaIndex: mediaIndex, startOfSegment: startOfSegment, isSyncRequest: isSyncRequest, partIndex: partIndex, forceTimestampOffset: forceTimestampOffset, getMediaInfoForTime: getMediaInfoForTime } = options;
        const segment = playlist.segments[mediaIndex];
        const part = typeof partIndex === 'number' && segment.parts[partIndex];
        const segmentInfo = {
            requestId: 'segment-loader-' + Math.random(),
            // resolve the segment URL relative to the playlist
            uri: part && part.resolvedUri || segment.resolvedUri,
            mediaIndex: // the segment's mediaIndex at the time it was requested
            mediaIndex,
            partIndex: part ? partIndex : null,
            isSyncRequest: // whether or not to update the SegmentLoader's state with this
            // segment's mediaIndex
            isSyncRequest,
            startOfSegment: startOfSegment,
            playlist: // the segment's playlist
            playlist,
            // unencrypted bytes of the segment
            bytes: null,
            // when a key is defined for this segment, the encrypted bytes
            encryptedBytes: null,
            // The target timestampOffset for this segment when we append it
            // to the source buffer
            timestampOffset: null,
            // The timeline that the segment is in
            timeline: segment.timeline,
            // The expected duration of the segment in seconds
            duration: part && part.duration || segment.duration,
            segment: // retain the segment in case the playlist updates while doing an async process
            segment,
            part: part,
            byteLength: 0,
            transmuxer: this.transmuxer_,
            getMediaInfoForTime: // type of getMediaInfoForTime that was used to get this segment
            getMediaInfoForTime,
            independent: independent
        };
        const overrideCheck = typeof forceTimestampOffset !== 'undefined' ? forceTimestampOffset : this.isPendingTimestampOffset_;
        segmentInfo.timestampOffset = this.timestampOffsetForSegment_({
            segmentTimeline: segment.timeline,
            currentTimeline: this.currentTimeline_,
            startOfSegment: startOfSegment,
            buffered: this.buffered_(),
            overrideCheck: overrideCheck
        });
        const audioBufferedEnd = $cb03b711053a4297$var$lastBufferedEnd(this.sourceUpdater_.audioBuffered());
        if (typeof audioBufferedEnd === 'number') // since the transmuxer is using the actual timing values, but the buffer is
        // adjusted by the timestamp offset, we must adjust the value here
        segmentInfo.audioAppendStart = audioBufferedEnd - this.sourceUpdater_.audioTimestampOffset();
        if (this.sourceUpdater_.videoBuffered().length) segmentInfo.gopsToAlignWith = $cb03b711053a4297$var$gopsSafeToAlignWith(this.gopBuffer_, // since the transmuxer is using the actual timing values, but the time is
        // adjusted by the timestmap offset, we must adjust the value here
        this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(), this.timeMapping_);
        return segmentInfo;
    }
    // added so that vtt segment loader can override and prevent
    // adding timestamp offsets.
    timestampOffsetForSegment_(options) {
        return $cb03b711053a4297$var$timestampOffsetForSegment(options);
    }
    /**
   * Determines if the network has enough bandwidth to complete the current segment
   * request in a timely manner. If not, the request will be aborted early and bandwidth
   * updated to trigger a playlist switch.
   *
   * @param {Object} stats
   *        Object containing stats about the request timing and size
   * @private
   */ earlyAbortWhenNeeded_(stats) {
        if (this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
        // TODO: Replace using timeout with a boolean indicating whether this playlist is
        //       the lowestEnabledRendition.
        !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
        !this.playlist_.attributes.BANDWIDTH) return;
         // Wait at least 1 second since the first byte of data has been received before
        // using the calculated bandwidth from the progress event to allow the bitrate
        // to stabilize
        if (Date.now() - (stats.firstBytesReceivedAt || Date.now()) < 1000) return;
        const currentTime = this.currentTime_();
        const measuredBandwidth = stats.bandwidth;
        const segmentDuration = this.pendingSegment_.duration;
        const requestTimeRemaining = $cb03b711053a4297$var$Playlist.estimateSegmentRequestTime(segmentDuration, measuredBandwidth, this.playlist_, stats.bytesReceived); // Subtract 1 from the timeUntilRebuffer so we still consider an early abort
        // if we are only left with less than 1 second when the request completes.
        // A negative timeUntilRebuffering indicates we are already rebuffering
        const timeUntilRebuffer$1 = $cb03b711053a4297$var$timeUntilRebuffer(this.buffered_(), currentTime, this.vhs_.tech_.playbackRate()) - 1; // Only consider aborting early if the estimated time to finish the download
        // is larger than the estimated time until the player runs out of forward buffer
        if (requestTimeRemaining <= timeUntilRebuffer$1) return;
        const switchCandidate = $cb03b711053a4297$var$minRebufferMaxBandwidthSelector({
            main: this.vhs_.playlists.main,
            currentTime: currentTime,
            bandwidth: measuredBandwidth,
            duration: this.duration_(),
            segmentDuration: segmentDuration,
            timeUntilRebuffer: timeUntilRebuffer$1,
            currentTimeline: this.currentTimeline_,
            syncController: this.syncController_
        });
        if (!switchCandidate) return;
        const rebufferingImpact = requestTimeRemaining - timeUntilRebuffer$1;
        const timeSavedBySwitching = rebufferingImpact - switchCandidate.rebufferingImpact;
        let minimumTimeSaving = 0.5; // If we are already rebuffering, increase the amount of variance we add to the
        // potential round trip time of the new request so that we are not too aggressive
        // with switching to a playlist that might save us a fraction of a second.
        if (timeUntilRebuffer$1 <= $cb03b711053a4297$var$TIME_FUDGE_FACTOR) minimumTimeSaving = 1;
        if (!switchCandidate.playlist || switchCandidate.playlist.uri === this.playlist_.uri || timeSavedBySwitching < minimumTimeSaving) return;
         // set the bandwidth to that of the desired playlist being sure to scale by
        // BANDWIDTH_VARIANCE and add one so the playlist selector does not exclude it
        // don't trigger a bandwidthupdate as the bandwidth is artifial
        this.bandwidth = switchCandidate.playlist.attributes.BANDWIDTH * $cb03b711053a4297$var$Config.BANDWIDTH_VARIANCE + 1;
        this.trigger('earlyabort');
    }
    handleAbort_(segmentInfo) {
        this.logger_(`Aborting ${$cb03b711053a4297$var$segmentInfoString(segmentInfo)}`);
        this.mediaRequestsAborted += 1;
    }
    /**
   * XHR `progress` event handler
   *
   * @param {Event}
   *        The XHR `progress` event
   * @param {Object} simpleSegment
   *        A simplified segment object copy
   * @private
   */ handleProgress_(event, simpleSegment) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        this.trigger('progress');
    }
    handleTrackInfo_(simpleSegment, trackInfo) {
        const { hasAudio: hasAudio, hasVideo: hasVideo } = trackInfo;
        const metadata = {
            segmentInfo: $cb03b711053a4297$var$segmentInfoPayload({
                type: this.loaderType_,
                segment: simpleSegment
            }),
            trackInfo: {
                hasAudio: hasAudio,
                hasVideo: hasVideo
            }
        };
        this.trigger({
            type: 'segmenttransmuxingtrackinfoavailable',
            metadata: metadata
        });
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        if (this.checkForIllegalMediaSwitch(trackInfo)) return;
        trackInfo = trackInfo || {}; // When we have track info, determine what media types this loader is dealing with.
        // Guard against cases where we're not getting track info at all until we are
        // certain that all streams will provide it.
        if (!$cb03b711053a4297$var$shallowEqual(this.currentMediaInfo_, trackInfo)) {
            this.appendInitSegment_ = {
                audio: true,
                video: true
            };
            this.startingMediaInfo_ = trackInfo;
            this.currentMediaInfo_ = trackInfo;
            this.logger_('trackinfo update', trackInfo);
            this.trigger('trackinfo');
        } // trackinfo may cause an abort if the trackinfo
        // causes a codec change to an unsupported codec.
        if (this.checkForAbort_(simpleSegment.requestId)) return;
         // set trackinfo on the pending segment so that
        // it can append.
        this.pendingSegment_.trackInfo = trackInfo; // check if any calls were waiting on the track info
        if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
        else $cb03b711053a4297$var$checkAndFixTimelines(this);
    }
    handleTimingInfo_(simpleSegment, mediaType, timeType, time) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        const segmentInfo = this.pendingSegment_;
        const timingInfoProperty = $cb03b711053a4297$var$timingInfoPropertyForMedia(mediaType);
        segmentInfo[timingInfoProperty] = segmentInfo[timingInfoProperty] || {};
        segmentInfo[timingInfoProperty][timeType] = time;
        this.logger_(`timinginfo: ${mediaType} - ${timeType} - ${time}`); // check if any calls were waiting on the timing info
        if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
        else $cb03b711053a4297$var$checkAndFixTimelines(this);
    }
    handleCaptions_(simpleSegment, captionData) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
         // This could only happen with fmp4 segments, but
        // should still not happen in general
        if (captionData.length === 0) {
            this.logger_('SegmentLoader received no captions from a caption event');
            return;
        }
        const segmentInfo = this.pendingSegment_; // Wait until we have some video data so that caption timing
        // can be adjusted by the timestamp offset
        if (!segmentInfo.hasAppendedData_) {
            this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, simpleSegment, captionData));
            return;
        }
        const timestampOffset = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
        const captionTracks = {}; // get total start/end and captions for each track/stream
        captionData.forEach((caption)=>{
            // caption.stream is actually a track name...
            // set to the existing values in tracks or default values
            captionTracks[caption.stream] = captionTracks[caption.stream] || {
                // Infinity, as any other value will be less than this
                startTime: Infinity,
                captions: [],
                // 0 as an other value will be more than this
                endTime: 0
            };
            const captionTrack = captionTracks[caption.stream];
            captionTrack.startTime = Math.min(captionTrack.startTime, caption.startTime + timestampOffset);
            captionTrack.endTime = Math.max(captionTrack.endTime, caption.endTime + timestampOffset);
            captionTrack.captions.push(caption);
        });
        Object.keys(captionTracks).forEach((trackName)=>{
            const { startTime: startTime, endTime: endTime, captions: captions } = captionTracks[trackName];
            const inbandTextTracks = this.inbandTextTracks_;
            this.logger_(`adding cues from ${startTime} -> ${endTime} for ${trackName}`);
            $cb03b711053a4297$var$createCaptionsTrackIfNotExists(inbandTextTracks, this.vhs_.tech_, trackName); // clear out any cues that start and end at the same time period for the same track.
            // We do this because a rendition change that also changes the timescale for captions
            // will result in captions being re-parsed for certain segments. If we add them again
            // without clearing we will have two of the same captions visible.
            $cb03b711053a4297$var$removeCuesFromTrack(startTime, endTime, inbandTextTracks[trackName]);
            $cb03b711053a4297$var$addCaptionData({
                captionArray: captions,
                inbandTextTracks: inbandTextTracks,
                timestampOffset: timestampOffset
            });
        }); // Reset stored captions since we added parsed
        // captions to a text track at this point
        if (this.transmuxer_) this.transmuxer_.postMessage({
            action: 'clearParsedMp4Captions'
        });
    }
    handleId3_(simpleSegment, id3Frames, dispatchType) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        const segmentInfo = this.pendingSegment_; // we need to have appended data in order for the timestamp offset to be set
        if (!segmentInfo.hasAppendedData_) {
            this.metadataQueue_.id3.push(this.handleId3_.bind(this, simpleSegment, id3Frames, dispatchType));
            return;
        }
        this.addMetadataToTextTrack(dispatchType, id3Frames, this.duration_());
    }
    processMetadataQueue_() {
        this.metadataQueue_.id3.forEach((fn)=>fn());
        this.metadataQueue_.caption.forEach((fn)=>fn());
        this.metadataQueue_.id3 = [];
        this.metadataQueue_.caption = [];
    }
    processCallQueue_() {
        const callQueue = this.callQueue_; // Clear out the queue before the queued functions are run, since some of the
        // functions may check the length of the load queue and default to pushing themselves
        // back onto the queue.
        this.callQueue_ = [];
        callQueue.forEach((fun)=>fun());
    }
    processLoadQueue_() {
        const loadQueue = this.loadQueue_; // Clear out the queue before the queued functions are run, since some of the
        // functions may check the length of the load queue and default to pushing themselves
        // back onto the queue.
        this.loadQueue_ = [];
        loadQueue.forEach((fun)=>fun());
    }
    /**
   * Determines whether the loader has enough info to load the next segment.
   *
   * @return {boolean}
   *         Whether or not the loader has enough info to load the next segment
   */ hasEnoughInfoToLoad_() {
        // Since primary timing goes by video, only the audio loader potentially needs to wait
        // to load.
        if (this.loaderType_ !== 'audio') return true;
        const segmentInfo = this.pendingSegment_; // A fill buffer must have already run to establish a pending segment before there's
        // enough info to load.
        if (!segmentInfo) return false;
         // The first segment can and should be loaded immediately so that source buffers are
        // created together (before appending). Source buffer creation uses the presence of
        // audio and video data to determine whether to create audio/video source buffers, and
        // uses processed (transmuxed or parsed) media to determine the types required.
        if (!this.getCurrentMediaInfo_()) return true;
        if (// Technically, instead of waiting to load a segment on timeline changes, a segment
        // can be requested and downloaded and only wait before it is transmuxed or parsed.
        // But in practice, there are a few reasons why it is better to wait until a loader
        // is ready to append that segment before requesting and downloading:
        //
        // 1. Because audio and main loaders cross discontinuities together, if this loader
        //    is waiting for the other to catch up, then instead of requesting another
        //    segment and using up more bandwidth, by not yet loading, more bandwidth is
        //    allotted to the loader currently behind.
        // 2. media-segment-request doesn't have to have logic to consider whether a segment
        // is ready to be processed or not, isolating the queueing behavior to the loader.
        // 3. The audio loader bases some of its segment properties on timing information
        //    provided by the main loader, meaning that, if the logic for waiting on
        //    processing was in media-segment-request, then it would also need to know how
        //    to re-generate the segment information after the main loader caught up.
        $cb03b711053a4297$var$shouldWaitForTimelineChange({
            timelineChangeController: this.timelineChangeController_,
            currentTimeline: this.currentTimeline_,
            segmentTimeline: segmentInfo.timeline,
            loaderType: this.loaderType_,
            audioDisabled: this.audioDisabled_
        })) return false;
        return true;
    }
    getCurrentMediaInfo_(segmentInfo = this.pendingSegment_) {
        return segmentInfo && segmentInfo.trackInfo || this.currentMediaInfo_;
    }
    getMediaInfo_(segmentInfo = this.pendingSegment_) {
        return this.getCurrentMediaInfo_(segmentInfo) || this.startingMediaInfo_;
    }
    getPendingSegmentPlaylist() {
        return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
    }
    hasEnoughInfoToAppend_() {
        if (!this.sourceUpdater_.ready()) return false;
         // If content needs to be removed or the loader is waiting on an append reattempt,
        // then no additional content should be appended until the prior append is resolved.
        if (this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_) return false;
        const segmentInfo = this.pendingSegment_;
        const trackInfo = this.getCurrentMediaInfo_(); // no segment to append any data for or
        // we do not have information on this specific
        // segment yet
        if (!segmentInfo || !trackInfo) return false;
        const { hasAudio: hasAudio, hasVideo: hasVideo, isMuxed: isMuxed } = trackInfo;
        if (hasVideo && !segmentInfo.videoTimingInfo) return false;
         // muxed content only relies on video timing information for now.
        if (hasAudio && !this.audioDisabled_ && !isMuxed && !segmentInfo.audioTimingInfo) return false;
         // we need to allow an append here even if we're moving to different timelines.
        if ($cb03b711053a4297$var$shouldWaitForTimelineChange({
            timelineChangeController: this.timelineChangeController_,
            currentTimeline: this.currentTimeline_,
            segmentTimeline: segmentInfo.timeline,
            loaderType: this.loaderType_,
            audioDisabled: this.audioDisabled_
        })) return false;
        return true;
    }
    handleData_(simpleSegment, result) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
         // If there's anything in the call queue, then this data came later and should be
        // executed after the calls currently queued.
        if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
            $cb03b711053a4297$var$checkAndFixTimelines(this);
            this.callQueue_.push(this.handleData_.bind(this, simpleSegment, result));
            return;
        }
        const segmentInfo = this.pendingSegment_; // update the time mapping so we can translate from display time to media time
        this.setTimeMapping_(segmentInfo.timeline); // for tracking overall stats
        this.updateMediaSecondsLoaded_(segmentInfo.part || segmentInfo.segment); // Note that the state isn't changed from loading to appending. This is because abort
        // logic may change behavior depending on the state, and changing state too early may
        // inflate our estimates of bandwidth. In the future this should be re-examined to
        // note more granular states.
        // don't process and append data if the mediaSource is closed
        if (this.mediaSource_.readyState === 'closed') return;
         // if this request included an initialization segment, save that data
        // to the initSegment cache
        if (simpleSegment.map) {
            simpleSegment.map = this.initSegmentForMap(simpleSegment.map, true); // move over init segment properties to media request
            segmentInfo.segment.map = simpleSegment.map;
        } // if this request included a segment key, save that data in the cache
        if (simpleSegment.key) this.segmentKey(simpleSegment.key, true);
        segmentInfo.isFmp4 = simpleSegment.isFmp4;
        segmentInfo.timingInfo = segmentInfo.timingInfo || {};
        if (segmentInfo.isFmp4) {
            this.trigger('fmp4');
            segmentInfo.timingInfo.start = segmentInfo[$cb03b711053a4297$var$timingInfoPropertyForMedia(result.type)].start;
        } else {
            const trackInfo = this.getCurrentMediaInfo_();
            const useVideoTimingInfo = this.loaderType_ === 'main' && trackInfo && trackInfo.hasVideo;
            let firstVideoFrameTimeForData;
            if (useVideoTimingInfo) firstVideoFrameTimeForData = segmentInfo.videoTimingInfo.start;
             // Segment loader knows more about segment timing than the transmuxer (in certain
            // aspects), so make any changes required for a more accurate start time.
            // Don't set the end time yet, as the segment may not be finished processing.
            segmentInfo.timingInfo.start = this.trueSegmentStart_({
                currentStart: segmentInfo.timingInfo.start,
                playlist: segmentInfo.playlist,
                mediaIndex: segmentInfo.mediaIndex,
                currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
                useVideoTimingInfo: useVideoTimingInfo,
                firstVideoFrameTimeForData: firstVideoFrameTimeForData,
                videoTimingInfo: segmentInfo.videoTimingInfo,
                audioTimingInfo: segmentInfo.audioTimingInfo
            });
        } // Init segments for audio and video only need to be appended in certain cases. Now
        // that data is about to be appended, we can check the final cases to determine
        // whether we should append an init segment.
        this.updateAppendInitSegmentStatus(segmentInfo, result.type); // Timestamp offset should be updated once we get new data and have its timing info,
        // as we use the start of the segment to offset the best guess (playlist provided)
        // timestamp offset.
        this.updateSourceBufferTimestampOffset_(segmentInfo); // if this is a sync request we need to determine whether it should
        // be appended or not.
        if (segmentInfo.isSyncRequest) {
            // first save/update our timing info for this segment.
            // this is what allows us to choose an accurate segment
            // and the main reason we make a sync request.
            this.updateTimingInfoEnd_(segmentInfo);
            this.syncController_.saveSegmentTimingInfo({
                segmentInfo: segmentInfo,
                shouldSaveTimelineMapping: this.loaderType_ === 'main'
            });
            const next = this.chooseNextRequest_(); // If the sync request isn't the segment that would be requested next
            // after taking into account its timing info, do not append it.
            if (next.mediaIndex !== segmentInfo.mediaIndex || next.partIndex !== segmentInfo.partIndex) {
                this.logger_('sync segment was incorrect, not appending');
                return;
            } // otherwise append it like any other segment as our guess was correct.
            this.logger_('sync segment was correct, appending');
        } // Save some state so that in the future anything waiting on first append (and/or
        // timestamp offset(s)) can process immediately. While the extra state isn't optimal,
        // we need some notion of whether the timestamp offset or other relevant information
        // has had a chance to be set.
        segmentInfo.hasAppendedData_ = true; // Now that the timestamp offset should be set, we can append any waiting ID3 tags.
        this.processMetadataQueue_();
        this.appendData_(segmentInfo, result);
    }
    updateAppendInitSegmentStatus(segmentInfo, type) {
        // alt audio doesn't manage timestamp offset
        if (this.loaderType_ === 'main' && typeof segmentInfo.timestampOffset === 'number' && // in the case that we're handling partial data, we don't want to append an init
        // segment for each chunk
        !segmentInfo.changedTimestampOffset) // if the timestamp offset changed, the timeline may have changed, so we have to re-
        // append init segments
        this.appendInitSegment_ = {
            audio: true,
            video: true
        };
        if (this.playlistOfLastInitSegment_[type] !== segmentInfo.playlist) // make sure we append init segment on playlist changes, in case the media config
        // changed
        this.appendInitSegment_[type] = true;
    }
    getInitSegmentAndUpdateState_({ type: type, initSegment: initSegment, map: map, playlist: playlist }) {
        // "The EXT-X-MAP tag specifies how to obtain the Media Initialization Section
        // (Section 3) required to parse the applicable Media Segments.  It applies to every
        // Media Segment that appears after it in the Playlist until the next EXT-X-MAP tag
        // or until the end of the playlist."
        // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.5
        if (map) {
            const id = $cb03b711053a4297$var$initSegmentId(map);
            if (this.activeInitSegmentId_ === id) // don't need to re-append the init segment if the ID matches
            return null;
             // a map-specified init segment takes priority over any transmuxed (or otherwise
            // obtained) init segment
            //
            // this also caches the init segment for later use
            initSegment = this.initSegmentForMap(map, true).bytes;
            this.activeInitSegmentId_ = id;
        } // We used to always prepend init segments for video, however, that shouldn't be
        // necessary. Instead, we should only append on changes, similar to what we've always
        // done for audio. This is more important (though may not be that important) for
        // frame-by-frame appending for LHLS, simply because of the increased quantity of
        // appends.
        if (initSegment && this.appendInitSegment_[type]) {
            // Make sure we track the playlist that we last used for the init segment, so that
            // we can re-append the init segment in the event that we get data from a new
            // playlist. Discontinuities and track changes are handled in other sections.
            this.playlistOfLastInitSegment_[type] = playlist; // Disable future init segment appends for this type. Until a change is necessary.
            this.appendInitSegment_[type] = false; // we need to clear out the fmp4 active init segment id, since
            // we are appending the muxer init segment
            this.activeInitSegmentId_ = null;
            return initSegment;
        }
        return null;
    }
    handleQuotaExceededError_({ segmentInfo: segmentInfo, type: type, bytes: bytes }, error) {
        const audioBuffered = this.sourceUpdater_.audioBuffered();
        const videoBuffered = this.sourceUpdater_.videoBuffered(); // For now we're ignoring any notion of gaps in the buffer, but they, in theory,
        // should be cleared out during the buffer removals. However, log in case it helps
        // debug.
        if (audioBuffered.length > 1) this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: ' + $cb03b711053a4297$var$timeRangesToArray(audioBuffered).join(', '));
        if (videoBuffered.length > 1) this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: ' + $cb03b711053a4297$var$timeRangesToArray(videoBuffered).join(', '));
        const audioBufferStart = audioBuffered.length ? audioBuffered.start(0) : 0;
        const audioBufferEnd = audioBuffered.length ? audioBuffered.end(audioBuffered.length - 1) : 0;
        const videoBufferStart = videoBuffered.length ? videoBuffered.start(0) : 0;
        const videoBufferEnd = videoBuffered.length ? videoBuffered.end(videoBuffered.length - 1) : 0;
        if (audioBufferEnd - audioBufferStart <= $cb03b711053a4297$var$MIN_BACK_BUFFER && videoBufferEnd - videoBufferStart <= $cb03b711053a4297$var$MIN_BACK_BUFFER) {
            // Can't remove enough buffer to make room for new segment (or the browser doesn't
            // allow for appends of segments this size). In the future, it may be possible to
            // split up the segment and append in pieces, but for now, error out this playlist
            // in an attempt to switch to a more manageable rendition.
            this.logger_("On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. " + `Appended byte length: ${bytes.byteLength}, ` + `audio buffer: ${$cb03b711053a4297$var$timeRangesToArray(audioBuffered).join(', ')}, ` + `video buffer: ${$cb03b711053a4297$var$timeRangesToArray(videoBuffered).join(', ')}, `);
            this.error({
                message: 'Quota exceeded error with append of a single segment of content',
                excludeUntil: Infinity
            });
            this.trigger('error');
            return;
        } // To try to resolve the quota exceeded error, clear back buffer and retry. This means
        // that the segment-loader should block on future events until this one is handled, so
        // that it doesn't keep moving onto further segments. Adding the call to the call
        // queue will prevent further appends until waitingOnRemove_ and
        // quotaExceededErrorRetryTimeout_ are cleared.
        //
        // Note that this will only block the current loader. In the case of demuxed content,
        // the other load may keep filling as fast as possible. In practice, this should be
        // OK, as it is a rare case when either audio has a high enough bitrate to fill up a
        // source buffer, or video fills without enough room for audio to append (and without
        // the availability of clearing out seconds of back buffer to make room for audio).
        // But it might still be good to handle this case in the future as a TODO.
        this.waitingOnRemove_ = true;
        this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
            segmentInfo: segmentInfo,
            type: type,
            bytes: bytes
        }));
        const currentTime = this.currentTime_(); // Try to remove as much audio and video as possible to make room for new content
        // before retrying.
        const timeToRemoveUntil = currentTime - $cb03b711053a4297$var$MIN_BACK_BUFFER;
        this.logger_(`On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to ${timeToRemoveUntil}`);
        this.remove(0, timeToRemoveUntil, ()=>{
            this.logger_(`On QUOTA_EXCEEDED_ERR, retrying append in ${$cb03b711053a4297$var$MIN_BACK_BUFFER}s`);
            this.waitingOnRemove_ = false; // wait the length of time alotted in the back buffer to prevent wasted
            // attempts (since we can't clear less than the minimum)
            this.quotaExceededErrorRetryTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
                this.logger_('On QUOTA_EXCEEDED_ERR, re-processing call queue');
                this.quotaExceededErrorRetryTimeout_ = null;
                this.processCallQueue_();
            }, $cb03b711053a4297$var$MIN_BACK_BUFFER * 1000);
        }, true);
    }
    handleAppendError_({ segmentInfo: segmentInfo, type: type, bytes: bytes }, error) {
        // if there's no error, nothing to do
        if (!error) return;
        if (error.code === $cb03b711053a4297$var$QUOTA_EXCEEDED_ERR) {
            this.handleQuotaExceededError_({
                segmentInfo: segmentInfo,
                type: type,
                bytes: bytes
            }); // A quota exceeded error should be recoverable with a future re-append, so no need
            // to trigger an append error.
            return;
        }
        this.logger_('Received non QUOTA_EXCEEDED_ERR on append', error); // If an append errors, we often can't recover.
        // (see https://w3c.github.io/media-source/#sourcebuffer-append-error).
        //
        // Trigger a special error so that it can be handled separately from normal,
        // recoverable errors.
        this.error({
            message: `${type} append of ${bytes.length}b failed for segment ` + `#${segmentInfo.mediaIndex} in playlist ${segmentInfo.playlist.id}`,
            metadata: {
                errorType: $cb03b711053a4297$export$2e2bcd8739ae039.Error.StreamingFailedToAppendSegment
            }
        });
        this.trigger('appenderror');
    }
    appendToSourceBuffer_({ segmentInfo: segmentInfo, type: type, initSegment: initSegment, data: data, bytes: bytes }) {
        // If this is a re-append, bytes were already created and don't need to be recreated
        if (!bytes) {
            const segments = [
                data
            ];
            let byteLength = data.byteLength;
            if (initSegment) {
                // if the media initialization segment is changing, append it before the content
                // segment
                segments.unshift(initSegment);
                byteLength += initSegment.byteLength;
            } // Technically we should be OK appending the init segment separately, however, we
            // haven't yet tested that, and prepending is how we have always done things.
            bytes = $cb03b711053a4297$var$concatSegments({
                bytes: byteLength,
                segments: segments
            });
        }
        const metadata = {
            segmentInfo: $cb03b711053a4297$var$segmentInfoPayload({
                type: this.loaderType_,
                segment: segmentInfo
            })
        };
        this.trigger({
            type: 'segmentappendstart',
            metadata: metadata
        });
        this.sourceUpdater_.appendBuffer({
            segmentInfo: segmentInfo,
            type: type,
            bytes: bytes
        }, this.handleAppendError_.bind(this, {
            segmentInfo: segmentInfo,
            type: type,
            bytes: bytes
        }));
    }
    handleSegmentTimingInfo_(type, requestId, segmentTimingInfo) {
        if (!this.pendingSegment_ || requestId !== this.pendingSegment_.requestId) return;
        const segment = this.pendingSegment_.segment;
        const timingInfoProperty = `${type}TimingInfo`;
        if (!segment[timingInfoProperty]) segment[timingInfoProperty] = {};
        segment[timingInfoProperty].transmuxerPrependedSeconds = segmentTimingInfo.prependedContentDuration || 0;
        segment[timingInfoProperty].transmuxedPresentationStart = segmentTimingInfo.start.presentation;
        segment[timingInfoProperty].transmuxedDecodeStart = segmentTimingInfo.start.decode;
        segment[timingInfoProperty].transmuxedPresentationEnd = segmentTimingInfo.end.presentation;
        segment[timingInfoProperty].transmuxedDecodeEnd = segmentTimingInfo.end.decode; // mainly used as a reference for debugging
        segment[timingInfoProperty].baseMediaDecodeTime = segmentTimingInfo.baseMediaDecodeTime;
    }
    appendData_(segmentInfo, result) {
        const { type: type, data: data } = result;
        if (!data || !data.byteLength) return;
        if (type === 'audio' && this.audioDisabled_) return;
        const initSegment = this.getInitSegmentAndUpdateState_({
            type: type,
            initSegment: result.initSegment,
            playlist: segmentInfo.playlist,
            map: segmentInfo.isFmp4 ? segmentInfo.segment.map : null
        });
        this.appendToSourceBuffer_({
            segmentInfo: segmentInfo,
            type: type,
            initSegment: initSegment,
            data: data
        });
    }
    /**
   * load a specific segment from a request into the buffer
   *
   * @private
   */ loadSegment_(segmentInfo) {
        this.state = 'WAITING';
        this.pendingSegment_ = segmentInfo;
        this.trimBackBuffer_(segmentInfo);
        if (typeof segmentInfo.timestampOffset === 'number') {
            if (this.transmuxer_) this.transmuxer_.postMessage({
                action: 'clearAllMp4Captions'
            });
        }
        if (!this.hasEnoughInfoToLoad_()) {
            $cb03b711053a4297$var$checkAndFixTimelines(this);
            this.loadQueue_.push(()=>{
                // regenerate the audioAppendStart, timestampOffset, etc as they
                // may have changed since this function was added to the queue.
                const options = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, segmentInfo, {
                    forceTimestampOffset: true
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))(segmentInfo, this.generateSegmentInfo_(options));
                this.isPendingTimestampOffset_ = false;
                this.updateTransmuxerAndRequestSegment_(segmentInfo);
            });
            return;
        }
        this.updateTransmuxerAndRequestSegment_(segmentInfo);
    }
    updateTransmuxerAndRequestSegment_(segmentInfo) {
        // We'll update the source buffer's timestamp offset once we have transmuxed data, but
        // the transmuxer still needs to be updated before then.
        //
        // Even though keepOriginalTimestamps is set to true for the transmuxer, timestamp
        // offset must be passed to the transmuxer for stream correcting adjustments.
        if (this.shouldUpdateTransmuxerTimestampOffset_(segmentInfo.timestampOffset)) {
            this.gopBuffer_.length = 0; // gopsToAlignWith was set before the GOP buffer was cleared
            segmentInfo.gopsToAlignWith = [];
            this.timeMapping_ = 0; // reset values in the transmuxer since a discontinuity should start fresh
            this.transmuxer_.postMessage({
                action: 'reset'
            });
            this.transmuxer_.postMessage({
                action: 'setTimestampOffset',
                timestampOffset: segmentInfo.timestampOffset
            });
        }
        const simpleSegment = this.createSimplifiedSegmentObj_(segmentInfo);
        const isEndOfStream = this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex);
        const isWalkingForward = this.mediaIndex !== null;
        const isDiscontinuity = segmentInfo.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
        // the first timeline
        segmentInfo.timeline > 0;
        const isEndOfTimeline = isEndOfStream || isWalkingForward && isDiscontinuity;
        this.logger_(`Requesting
${$cb03b711053a4297$var$compactSegmentUrlDescription(segmentInfo.uri)}
${$cb03b711053a4297$var$segmentInfoString(segmentInfo)}`); // If there's an init segment associated with this segment, but it is not cached (identified by a lack of bytes),
        // then this init segment has never been seen before and should be appended.
        //
        // At this point the content type (audio/video or both) is not yet known, but it should be safe to set
        // both to true and leave the decision of whether to append the init segment to append time.
        if (simpleSegment.map && !simpleSegment.map.bytes) {
            this.logger_('going to request init segment.');
            this.appendInitSegment_ = {
                video: true,
                audio: true
            };
        }
        segmentInfo.abortRequests = $cb03b711053a4297$var$mediaSegmentRequest({
            xhr: this.vhs_.xhr,
            xhrOptions: this.xhrOptions_,
            decryptionWorker: this.decrypter_,
            segment: simpleSegment,
            abortFn: this.handleAbort_.bind(this, segmentInfo),
            progressFn: this.handleProgress_.bind(this),
            trackInfoFn: this.handleTrackInfo_.bind(this),
            timingInfoFn: this.handleTimingInfo_.bind(this),
            videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, 'video', segmentInfo.requestId),
            audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, 'audio', segmentInfo.requestId),
            captionsFn: this.handleCaptions_.bind(this),
            isEndOfTimeline: isEndOfTimeline,
            endedTimelineFn: ()=>{
                this.logger_('received endedtimeline callback');
            },
            id3Fn: this.handleId3_.bind(this),
            dataFn: this.handleData_.bind(this),
            doneFn: this.segmentRequestFinished_.bind(this),
            onTransmuxerLog: ({ message: message, level: level, stream: stream })=>{
                this.logger_(`${$cb03b711053a4297$var$segmentInfoString(segmentInfo)} logged from transmuxer stream ${stream} as a ${level}: ${message}`);
            },
            triggerSegmentEventFn: ({ type: type, segment: segment, keyInfo: keyInfo, trackInfo: trackInfo, timingInfo: timingInfo })=>{
                const segInfo = $cb03b711053a4297$var$segmentInfoPayload({
                    segment: segment
                });
                const metadata = {
                    segmentInfo: segInfo
                }; // add other properties if necessary.
                if (keyInfo) metadata.keyInfo = keyInfo;
                if (trackInfo) metadata.trackInfo = trackInfo;
                if (timingInfo) metadata.timingInfo = timingInfo;
                this.trigger({
                    type: type,
                    metadata: metadata
                });
            }
        });
    }
    /**
   * trim the back buffer so that we don't have too much data
   * in the source buffer
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   */ trimBackBuffer_(segmentInfo) {
        const removeToTime = $cb03b711053a4297$var$safeBackBufferTrimTime(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10); // Chrome has a hard limit of 150MB of
        // buffer and a very conservative "garbage collector"
        // We manually clear out the old buffer to ensure
        // we don't trigger the QuotaExceeded error
        // on the source buffer during subsequent appends
        if (removeToTime > 0) this.remove(0, removeToTime);
    }
    /**
   * created a simplified copy of the segment object with just the
   * information necessary to perform the XHR and decryption
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   * @return {Object} a simplified segment object copy
   */ createSimplifiedSegmentObj_(segmentInfo) {
        const segment = segmentInfo.segment;
        const part = segmentInfo.part;
        const isEncrypted = segmentInfo.segment.key || segmentInfo.segment.map && segmentInfo.segment.map.key;
        const isMediaInitialization = segmentInfo.segment.map && !segmentInfo.segment.map.bytes;
        const simpleSegment = {
            resolvedUri: part ? part.resolvedUri : segment.resolvedUri,
            byterange: part ? part.byterange : segment.byterange,
            requestId: segmentInfo.requestId,
            transmuxer: segmentInfo.transmuxer,
            audioAppendStart: segmentInfo.audioAppendStart,
            gopsToAlignWith: segmentInfo.gopsToAlignWith,
            part: segmentInfo.part,
            type: this.loaderType_,
            start: segmentInfo.startOfSegment,
            duration: segmentInfo.duration,
            isEncrypted: isEncrypted,
            isMediaInitialization: isMediaInitialization
        };
        const previousSegment = segmentInfo.playlist.segments[segmentInfo.mediaIndex - 1];
        if (previousSegment && previousSegment.timeline === segment.timeline) {
            // The baseStartTime of a segment is used to handle rollover when probing the TS
            // segment to retrieve timing information. Since the probe only looks at the media's
            // times (e.g., PTS and DTS values of the segment), and doesn't consider the
            // player's time (e.g., player.currentTime()), baseStartTime should reflect the
            // media time as well. transmuxedDecodeEnd represents the end time of a segment, in
            // seconds of media time, so should be used here. The previous segment is used since
            // the end of the previous segment should represent the beginning of the current
            // segment, so long as they are on the same timeline.
            if (previousSegment.videoTimingInfo) simpleSegment.baseStartTime = previousSegment.videoTimingInfo.transmuxedDecodeEnd;
            else if (previousSegment.audioTimingInfo) simpleSegment.baseStartTime = previousSegment.audioTimingInfo.transmuxedDecodeEnd;
        }
        if (segment.key) {
            // if the media sequence is greater than 2^32, the IV will be incorrect
            // assuming 10s segments, that would be about 1300 years
            const iv = segment.key.iv || new Uint32Array([
                0,
                0,
                0,
                segmentInfo.mediaIndex + segmentInfo.playlist.mediaSequence
            ]);
            simpleSegment.key = this.segmentKey(segment.key);
            simpleSegment.key.iv = iv;
        }
        if (segment.map) simpleSegment.map = this.initSegmentForMap(segment.map);
        return simpleSegment;
    }
    saveTransferStats_(stats) {
        // every request counts as a media request even if it has been aborted
        // or canceled due to a timeout
        this.mediaRequests += 1;
        if (stats) {
            this.mediaBytesTransferred += stats.bytesReceived;
            this.mediaTransferDuration += stats.roundTripTime;
        }
    }
    saveBandwidthRelatedStats_(duration, stats) {
        // byteLength will be used for throughput, and should be based on bytes receieved,
        // which we only know at the end of the request and should reflect total bytes
        // downloaded rather than just bytes processed from components of the segment
        this.pendingSegment_.byteLength = stats.bytesReceived;
        if (duration < $cb03b711053a4297$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
            this.logger_(`Ignoring segment's bandwidth because its duration of ${duration}` + ` is less than the min to record ${$cb03b711053a4297$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS}`);
            return;
        }
        const metadata = {
            bandwidthInfo: {
                from: this.bandwidth,
                to: stats.bandwidth
            }
        }; // player event with payload
        this.trigger({
            type: 'bandwidthupdated',
            metadata: metadata
        });
        this.bandwidth = stats.bandwidth;
        this.roundTrip = stats.roundTripTime;
    }
    handleTimeout_() {
        // although the VTT segment loader bandwidth isn't really used, it's good to
        // maintain functinality between segment loaders
        this.mediaRequestsTimedout += 1;
        this.bandwidth = 1;
        this.roundTrip = NaN;
        this.trigger('bandwidthupdate');
        this.trigger('timeout');
    }
    /**
   * Handle the callback from the segmentRequest function and set the
   * associated SegmentLoader state and errors if necessary
   *
   * @private
   */ segmentRequestFinished_(error, simpleSegment, result) {
        // TODO handle special cases, e.g., muxed audio/video but only audio in the segment
        // check the call queue directly since this function doesn't need to deal with any
        // data, and can continue even if the source buffers are not set up and we didn't get
        // any data from the segment
        if (this.callQueue_.length) {
            this.callQueue_.push(this.segmentRequestFinished_.bind(this, error, simpleSegment, result));
            return;
        }
        this.saveTransferStats_(simpleSegment.stats); // The request was aborted and the SegmentLoader has already been reset
        if (!this.pendingSegment_) return;
         // the request was aborted and the SegmentLoader has already started
        // another request. this can happen when the timeout for an aborted
        // request triggers due to a limitation in the XHR library
        // do not count this as any sort of request or we risk double-counting
        if (simpleSegment.requestId !== this.pendingSegment_.requestId) return;
         // an error occurred from the active pendingSegment_ so reset everything
        if (error) {
            this.pendingSegment_ = null;
            this.state = 'READY'; // aborts are not a true error condition and nothing corrective needs to be done
            if (error.code === $cb03b711053a4297$var$REQUEST_ERRORS.ABORTED) return;
            this.pause(); // the error is really just that at least one of the requests timed-out
            // set the bandwidth to a very low value and trigger an ABR switch to
            // take emergency action
            if (error.code === $cb03b711053a4297$var$REQUEST_ERRORS.TIMEOUT) {
                this.handleTimeout_();
                return;
            } // if control-flow has arrived here, then the error is real
            // emit an error event to exclude the current playlist
            this.mediaRequestsErrored += 1;
            this.error(error);
            this.trigger('error');
            return;
        }
        const segmentInfo = this.pendingSegment_; // the response was a success so set any bandwidth stats the request
        // generated for ABR purposes
        this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats);
        segmentInfo.endOfAllRequests = simpleSegment.endOfAllRequests;
        if (result.gopInfo) this.gopBuffer_ = $cb03b711053a4297$var$updateGopBuffer(this.gopBuffer_, result.gopInfo, this.safeAppend_);
         // Although we may have already started appending on progress, we shouldn't switch the
        // state away from loading until we are officially done loading the segment data.
        this.state = 'APPENDING'; // used for testing
        this.trigger('appending');
        this.waitForAppendsToComplete_(segmentInfo);
    }
    setTimeMapping_(timeline) {
        const timelineMapping = this.syncController_.mappingForTimeline(timeline);
        if (timelineMapping !== null) this.timeMapping_ = timelineMapping;
    }
    updateMediaSecondsLoaded_(segment) {
        if (typeof segment.start === 'number' && typeof segment.end === 'number') this.mediaSecondsLoaded += segment.end - segment.start;
        else this.mediaSecondsLoaded += segment.duration;
    }
    shouldUpdateTransmuxerTimestampOffset_(timestampOffset) {
        if (timestampOffset === null) return false;
         // note that we're potentially using the same timestamp offset for both video and
        // audio
        if (this.loaderType_ === 'main' && timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) return true;
        if (!this.audioDisabled_ && timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) return true;
        return false;
    }
    trueSegmentStart_({ currentStart: currentStart, playlist: playlist, mediaIndex: mediaIndex, firstVideoFrameTimeForData: firstVideoFrameTimeForData, currentVideoTimestampOffset: currentVideoTimestampOffset, useVideoTimingInfo: useVideoTimingInfo, videoTimingInfo: videoTimingInfo, audioTimingInfo: audioTimingInfo }) {
        if (typeof currentStart !== 'undefined') // if start was set once, keep using it
        return currentStart;
        if (!useVideoTimingInfo) return audioTimingInfo.start;
        const previousSegment = playlist.segments[mediaIndex - 1]; // The start of a segment should be the start of the first full frame contained
        // within that segment. Since the transmuxer maintains a cache of incomplete data
        // from and/or the last frame seen, the start time may reflect a frame that starts
        // in the previous segment. Check for that case and ensure the start time is
        // accurate for the segment.
        if (mediaIndex === 0 || !previousSegment || typeof previousSegment.start === 'undefined' || previousSegment.end !== firstVideoFrameTimeForData + currentVideoTimestampOffset) return firstVideoFrameTimeForData;
        return videoTimingInfo.start;
    }
    waitForAppendsToComplete_(segmentInfo) {
        const trackInfo = this.getCurrentMediaInfo_(segmentInfo);
        if (!trackInfo) {
            this.error({
                message: 'No starting media returned, likely due to an unsupported media format.',
                playlistExclusionDuration: Infinity
            });
            this.trigger('error');
            return;
        } // Although transmuxing is done, appends may not yet be finished. Throw a marker
        // on each queue this loader is responsible for to ensure that the appends are
        // complete.
        const { hasAudio: hasAudio, hasVideo: hasVideo, isMuxed: isMuxed } = trackInfo;
        const waitForVideo = this.loaderType_ === 'main' && hasVideo;
        const waitForAudio = !this.audioDisabled_ && hasAudio && !isMuxed;
        segmentInfo.waitingOnAppends = 0; // segments with no data
        if (!segmentInfo.hasAppendedData_) {
            if (!segmentInfo.timingInfo && typeof segmentInfo.timestampOffset === 'number') // When there's no audio or video data in the segment, there's no audio or video
            // timing information.
            //
            // If there's no audio or video timing information, then the timestamp offset
            // can't be adjusted to the appropriate value for the transmuxer and source
            // buffers.
            //
            // Therefore, the next segment should be used to set the timestamp offset.
            this.isPendingTimestampOffset_ = true;
             // override settings for metadata only segments
            segmentInfo.timingInfo = {
                start: 0
            };
            segmentInfo.waitingOnAppends++;
            if (!this.isPendingTimestampOffset_) {
                // update the timestampoffset
                this.updateSourceBufferTimestampOffset_(segmentInfo); // make sure the metadata queue is processed even though we have
                // no video/audio data.
                this.processMetadataQueue_();
            } // append is "done" instantly with no data.
            this.checkAppendsDone_(segmentInfo);
            return;
        } // Since source updater could call back synchronously, do the increments first.
        if (waitForVideo) segmentInfo.waitingOnAppends++;
        if (waitForAudio) segmentInfo.waitingOnAppends++;
        if (waitForVideo) this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
        if (waitForAudio) this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
    }
    checkAppendsDone_(segmentInfo) {
        if (this.checkForAbort_(segmentInfo.requestId)) return;
        segmentInfo.waitingOnAppends--;
        if (segmentInfo.waitingOnAppends === 0) this.handleAppendsDone_();
    }
    checkForIllegalMediaSwitch(trackInfo) {
        const illegalMediaSwitchError = $cb03b711053a4297$var$illegalMediaSwitch(this.loaderType_, this.getCurrentMediaInfo_(), trackInfo);
        if (illegalMediaSwitchError) {
            this.error({
                message: illegalMediaSwitchError,
                playlistExclusionDuration: Infinity
            });
            this.trigger('error');
            return true;
        }
        return false;
    }
    updateSourceBufferTimestampOffset_(segmentInfo) {
        if (segmentInfo.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
        // priority, timing-wise, so we must wait
        typeof segmentInfo.timingInfo.start !== 'number' || // already updated the timestamp offset for this segment
        segmentInfo.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
        this.loaderType_ !== 'main') return;
        let didChange = false; // Primary timing goes by video, and audio is trimmed in the transmuxer, meaning that
        // the timing info here comes from video. In the event that the audio is longer than
        // the video, this will trim the start of the audio.
        // This also trims any offset from 0 at the beginning of the media
        segmentInfo.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
            videoTimingInfo: segmentInfo.segment.videoTimingInfo,
            audioTimingInfo: segmentInfo.segment.audioTimingInfo,
            timingInfo: segmentInfo.timingInfo
        }); // In the event that there are part segment downloads, each will try to update the
        // timestamp offset. Retaining this bit of state prevents us from updating in the
        // future (within the same segment), however, there may be a better way to handle it.
        segmentInfo.changedTimestampOffset = true;
        if (segmentInfo.timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) {
            this.sourceUpdater_.videoTimestampOffset(segmentInfo.timestampOffset);
            didChange = true;
        }
        if (segmentInfo.timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) {
            this.sourceUpdater_.audioTimestampOffset(segmentInfo.timestampOffset);
            didChange = true;
        }
        if (didChange) this.trigger('timestampoffset');
    }
    getSegmentStartTimeForTimestampOffsetCalculation_({ videoTimingInfo: videoTimingInfo, audioTimingInfo: audioTimingInfo, timingInfo: timingInfo }) {
        if (!this.useDtsForTimestampOffset_) return timingInfo.start;
        if (videoTimingInfo && typeof videoTimingInfo.transmuxedDecodeStart === 'number') return videoTimingInfo.transmuxedDecodeStart;
         // handle audio only
        if (audioTimingInfo && typeof audioTimingInfo.transmuxedDecodeStart === 'number') return audioTimingInfo.transmuxedDecodeStart;
         // handle content not transmuxed (e.g., MP4)
        return timingInfo.start;
    }
    updateTimingInfoEnd_(segmentInfo) {
        segmentInfo.timingInfo = segmentInfo.timingInfo || {};
        const trackInfo = this.getMediaInfo_();
        const useVideoTimingInfo = this.loaderType_ === 'main' && trackInfo && trackInfo.hasVideo;
        const prioritizedTimingInfo = useVideoTimingInfo && segmentInfo.videoTimingInfo ? segmentInfo.videoTimingInfo : segmentInfo.audioTimingInfo;
        if (!prioritizedTimingInfo) return;
        segmentInfo.timingInfo.end = typeof prioritizedTimingInfo.end === 'number' ? // End time may not exist in a case where we aren't parsing the full segment (one
        // current example is the case of fmp4), so use the rough duration to calculate an
        // end time.
        prioritizedTimingInfo.end : prioritizedTimingInfo.start + segmentInfo.duration;
    }
    /**
   * callback to run when appendBuffer is finished. detects if we are
   * in a good state to do things with the data we got, or if we need
   * to wait for more
   *
   * @private
   */ handleAppendsDone_() {
        // appendsdone can cause an abort
        if (this.pendingSegment_) {
            const metadata = {
                segmentInfo: $cb03b711053a4297$var$segmentInfoPayload({
                    type: this.loaderType_,
                    segment: this.pendingSegment_
                })
            };
            this.trigger({
                type: 'appendsdone',
                metadata: metadata
            });
        }
        if (!this.pendingSegment_) {
            this.state = 'READY'; // TODO should this move into this.checkForAbort to speed up requests post abort in
            // all appending cases?
            if (!this.paused()) this.monitorBuffer_();
            return;
        }
        const segmentInfo = this.pendingSegment_;
        if (segmentInfo.part && segmentInfo.part.syncInfo) // low-latency flow
        segmentInfo.part.syncInfo.markAppended();
        else if (segmentInfo.segment.syncInfo) // normal flow
        segmentInfo.segment.syncInfo.markAppended();
         // Now that the end of the segment has been reached, we can set the end time. It's
        // best to wait until all appends are done so we're sure that the primary media is
        // finished (and we have its end time).
        this.updateTimingInfoEnd_(segmentInfo);
        if (this.shouldSaveSegmentTimingInfo_) // Timeline mappings should only be saved for the main loader. This is for multiple
        // reasons:
        //
        // 1) Only one mapping is saved per timeline, meaning that if both the audio loader
        //    and the main loader try to save the timeline mapping, whichever comes later
        //    will overwrite the first. In theory this is OK, as the mappings should be the
        //    same, however, it breaks for (2)
        // 2) In the event of a live stream, the initial live point will make for a somewhat
        //    arbitrary mapping. If audio and video streams are not perfectly in-sync, then
        //    the mapping will be off for one of the streams, dependent on which one was
        //    first saved (see (1)).
        // 3) Primary timing goes by video in VHS, so the mapping should be video.
        //
        // Since the audio loader will wait for the main loader to load the first segment,
        // the main loader will save the first timeline mapping, and ensure that there won't
        // be a case where audio loads two segments without saving a mapping (thus leading
        // to missing segment timing info).
        this.syncController_.saveSegmentTimingInfo({
            segmentInfo: segmentInfo,
            shouldSaveTimelineMapping: this.loaderType_ === 'main'
        });
        const segmentDurationMessage = $cb03b711053a4297$var$getTroublesomeSegmentDurationMessage(segmentInfo, this.sourceType_);
        if (segmentDurationMessage) {
            if (segmentDurationMessage.severity === 'warn') $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(segmentDurationMessage.message);
            else this.logger_(segmentDurationMessage.message);
        }
        this.recordThroughput_(segmentInfo);
        this.pendingSegment_ = null;
        this.state = 'READY';
        if (segmentInfo.isSyncRequest) {
            this.trigger('syncinfoupdate'); // if the sync request was not appended
            // then it was not the correct segment.
            // throw it away and use the data it gave us
            // to get the correct one.
            if (!segmentInfo.hasAppendedData_) {
                this.logger_(`Throwing away un-appended sync request ${$cb03b711053a4297$var$segmentInfoString(segmentInfo)}`);
                return;
            }
        }
        this.logger_(`Appended ${$cb03b711053a4297$var$segmentInfoString(segmentInfo)}`);
        this.addSegmentMetadataCue_(segmentInfo);
        this.fetchAtBuffer_ = true;
        if (this.currentTimeline_ !== segmentInfo.timeline) {
            this.timelineChangeController_.lastTimelineChange({
                type: this.loaderType_,
                from: this.currentTimeline_,
                to: segmentInfo.timeline
            }); // If audio is not disabled, the main segment loader is responsible for updating
            // the audio timeline as well. If the content is video only, this won't have any
            // impact.
            if (this.loaderType_ === 'main' && !this.audioDisabled_) this.timelineChangeController_.lastTimelineChange({
                type: 'audio',
                from: this.currentTimeline_,
                to: segmentInfo.timeline
            });
        }
        this.currentTimeline_ = segmentInfo.timeline; // We must update the syncinfo to recalculate the seekable range before
        // the following conditional otherwise it may consider this a bad "guess"
        // and attempt to resync when the post-update seekable window and live
        // point would mean that this was the perfect segment to fetch
        this.trigger('syncinfoupdate');
        const segment = segmentInfo.segment;
        const part = segmentInfo.part;
        const badSegmentGuess = segment.end && this.currentTime_() - segment.end > segmentInfo.playlist.targetDuration * 3;
        const badPartGuess = part && part.end && this.currentTime_() - part.end > segmentInfo.playlist.partTargetDuration * 3; // If we previously appended a segment/part that ends more than 3 part/targetDurations before
        // the currentTime_ that means that our conservative guess was too conservative.
        // In that case, reset the loader state so that we try to use any information gained
        // from the previous request to create a new, more accurate, sync-point.
        if (badSegmentGuess || badPartGuess) {
            this.logger_(`bad ${badSegmentGuess ? 'segment' : 'part'} ${$cb03b711053a4297$var$segmentInfoString(segmentInfo)}`);
            this.resetEverything();
            return;
        }
        const isWalkingForward = this.mediaIndex !== null; // Don't do a rendition switch unless we have enough time to get a sync segment
        // and conservatively guess
        if (isWalkingForward) this.trigger('bandwidthupdate');
        this.trigger('progress');
        this.mediaIndex = segmentInfo.mediaIndex;
        this.partIndex = segmentInfo.partIndex; // any time an update finishes and the last segment is in the
        // buffer, end the stream. this ensures the "ended" event will
        // fire if playback reaches that point.
        if (this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex)) this.endOfStream();
         // used for testing
        this.trigger('appended');
        if (segmentInfo.hasAppendedData_) this.mediaAppends++;
        if (!this.paused()) this.monitorBuffer_();
    }
    /**
   * Records the current throughput of the decrypt, transmux, and append
   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
   * moving average of the throughput. `throughput.count` is the number of
   * data points in the average.
   *
   * @private
   * @param {Object} segmentInfo the object returned by loadSegment
   */ recordThroughput_(segmentInfo) {
        if (segmentInfo.duration < $cb03b711053a4297$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
            this.logger_(`Ignoring segment's throughput because its duration of ${segmentInfo.duration}` + ` is less than the min to record ${$cb03b711053a4297$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS}`);
            return;
        }
        const rate = this.throughput.rate; // Add one to the time to ensure that we don't accidentally attempt to divide
        // by zero in the case where the throughput is ridiculously high
        const segmentProcessingTime = Date.now() - segmentInfo.endOfAllRequests + 1; // Multiply by 8000 to convert from bytes/millisecond to bits/second
        const segmentProcessingThroughput = Math.floor(segmentInfo.byteLength / segmentProcessingTime * 8000); // This is just a cumulative moving average calculation:
        //   newAvg = oldAvg + (sample - oldAvg) / (sampleCount + 1)
        this.throughput.rate += (segmentProcessingThroughput - rate) / ++this.throughput.count;
    }
    /**
   * Adds a cue to the segment-metadata track with some metadata information about the
   * segment
   *
   * @private
   * @param {Object} segmentInfo
   *        the object returned by loadSegment
   * @method addSegmentMetadataCue_
   */ addSegmentMetadataCue_(segmentInfo) {
        if (!this.segmentMetadataTrack_) return;
        const segment = segmentInfo.segment;
        const start = segment.start;
        const end = segment.end; // Do not try adding the cue if the start and end times are invalid.
        if (!$cb03b711053a4297$var$finite(start) || !$cb03b711053a4297$var$finite(end)) return;
        $cb03b711053a4297$var$removeCuesFromTrack(start, end, this.segmentMetadataTrack_);
        const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue;
        const value = {
            custom: segment.custom,
            dateTimeObject: segment.dateTimeObject,
            dateTimeString: segment.dateTimeString,
            programDateTime: segment.programDateTime,
            bandwidth: segmentInfo.playlist.attributes.BANDWIDTH,
            resolution: segmentInfo.playlist.attributes.RESOLUTION,
            codecs: segmentInfo.playlist.attributes.CODECS,
            byteLength: segmentInfo.byteLength,
            uri: segmentInfo.uri,
            timeline: segmentInfo.timeline,
            playlist: segmentInfo.playlist.id,
            start: start,
            end: end
        };
        const data = JSON.stringify(value);
        const cue = new Cue(start, end, data); // Attach the metadata to the value property of the cue to keep consistency between
        // the differences of WebKitDataCue in safari and VTTCue in other browsers
        cue.value = value;
        this.segmentMetadataTrack_.addCue(cue);
    }
}
function $cb03b711053a4297$var$noop() {}
const $cb03b711053a4297$var$toTitleCase = function(string) {
    if (typeof string !== 'string') return string;
    return string.replace(/./, (w)=>w.toUpperCase());
};
/**
 * @file source-updater.js
 */ const $cb03b711053a4297$var$bufferTypes = [
    'video',
    'audio'
];
const $cb03b711053a4297$var$updating = (type, sourceUpdater)=>{
    const sourceBuffer = sourceUpdater[`${type}Buffer`];
    return sourceBuffer && sourceBuffer.updating || sourceUpdater.queuePending[type];
};
const $cb03b711053a4297$var$nextQueueIndexOfType = (type, queue)=>{
    for(let i = 0; i < queue.length; i++){
        const queueEntry = queue[i];
        if (queueEntry.type === 'mediaSource') // If the next entry is a media source entry (uses multiple source buffers), block
        // processing to allow it to go through first.
        return null;
        if (queueEntry.type === type) return i;
    }
    return null;
};
const $cb03b711053a4297$var$shiftQueue = (type, sourceUpdater)=>{
    if (sourceUpdater.queue.length === 0) return;
    let queueIndex = 0;
    let queueEntry = sourceUpdater.queue[queueIndex];
    if (queueEntry.type === 'mediaSource') {
        if (!sourceUpdater.updating() && sourceUpdater.mediaSource.readyState !== 'closed') {
            sourceUpdater.queue.shift();
            queueEntry.action(sourceUpdater);
            if (queueEntry.doneFn) queueEntry.doneFn();
             // Only specific source buffer actions must wait for async updateend events. Media
            // Source actions process synchronously. Therefore, both audio and video source
            // buffers are now clear to process the next queue entries.
            $cb03b711053a4297$var$shiftQueue('audio', sourceUpdater);
            $cb03b711053a4297$var$shiftQueue('video', sourceUpdater);
        } // Media Source actions require both source buffers, so if the media source action
        // couldn't process yet (because one or both source buffers are busy), block other
        // queue actions until both are available and the media source action can process.
        return;
    }
    if (type === 'mediaSource') // If the queue was shifted by a media source action (this happens when pushing a
    // media source action onto the queue), then it wasn't from an updateend event from an
    // audio or video source buffer, so there's no change from previous state, and no
    // processing should be done.
    return;
     // Media source queue entries don't need to consider whether the source updater is
    // started (i.e., source buffers are created) as they don't need the source buffers, but
    // source buffer queue entries do.
    if (!sourceUpdater.ready() || sourceUpdater.mediaSource.readyState === 'closed' || $cb03b711053a4297$var$updating(type, sourceUpdater)) return;
    if (queueEntry.type !== type) {
        queueIndex = $cb03b711053a4297$var$nextQueueIndexOfType(type, sourceUpdater.queue);
        if (queueIndex === null) // Either there's no queue entry that uses this source buffer type in the queue, or
        // there's a media source queue entry before the next entry of this type, in which
        // case wait for that action to process first.
        return;
        queueEntry = sourceUpdater.queue[queueIndex];
    }
    sourceUpdater.queue.splice(queueIndex, 1); // Keep a record that this source buffer type is in use.
    //
    // The queue pending operation must be set before the action is performed in the event
    // that the action results in a synchronous event that is acted upon. For instance, if
    // an exception is thrown that can be handled, it's possible that new actions will be
    // appended to an empty queue and immediately executed, but would not have the correct
    // pending information if this property was set after the action was performed.
    sourceUpdater.queuePending[type] = queueEntry;
    queueEntry.action(type, sourceUpdater);
    if (!queueEntry.doneFn) {
        // synchronous operation, process next entry
        sourceUpdater.queuePending[type] = null;
        $cb03b711053a4297$var$shiftQueue(type, sourceUpdater);
        return;
    }
};
const $cb03b711053a4297$var$cleanupBuffer = (type, sourceUpdater)=>{
    const buffer = sourceUpdater[`${type}Buffer`];
    const titleType = $cb03b711053a4297$var$toTitleCase(type);
    if (!buffer) return;
    buffer.removeEventListener('updateend', sourceUpdater[`on${titleType}UpdateEnd_`]);
    buffer.removeEventListener('error', sourceUpdater[`on${titleType}Error_`]);
    sourceUpdater.codecs[type] = null;
    sourceUpdater[`${type}Buffer`] = null;
};
const $cb03b711053a4297$var$inSourceBuffers = (mediaSource, sourceBuffer)=>mediaSource && sourceBuffer && Array.prototype.indexOf.call(mediaSource.sourceBuffers, sourceBuffer) !== -1;
const $cb03b711053a4297$var$actions = {
    appendBuffer: (bytes, segmentInfo, onError)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Appending segment ${segmentInfo.mediaIndex}'s ${bytes.length} bytes to ${type}Buffer`);
            try {
                sourceBuffer.appendBuffer(bytes);
            } catch (e) {
                sourceUpdater.logger_(`Error with code ${e.code} ` + (e.code === $cb03b711053a4297$var$QUOTA_EXCEEDED_ERR ? '(QUOTA_EXCEEDED_ERR) ' : '') + `when appending segment ${segmentInfo.mediaIndex} to ${type}Buffer`);
                sourceUpdater.queuePending[type] = null;
                onError(e);
            }
        },
    remove: (start, end)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Removing ${start} to ${end} from ${type}Buffer`);
            try {
                sourceBuffer.remove(start, end);
            } catch (e) {
                sourceUpdater.logger_(`Remove ${start} to ${end} from ${type}Buffer failed`);
            }
        },
    timestampOffset: (offset)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Setting ${type}timestampOffset to ${offset}`);
            sourceBuffer.timestampOffset = offset;
        },
    callback: (callback)=>(type, sourceUpdater)=>{
            callback();
        },
    endOfStream: (error)=>(sourceUpdater)=>{
            if (sourceUpdater.mediaSource.readyState !== 'open') return;
            sourceUpdater.logger_(`Calling mediaSource endOfStream(${error || ''})`);
            try {
                sourceUpdater.mediaSource.endOfStream(error);
            } catch (e) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn('Failed to call media source endOfStream', e);
            }
        },
    duration: (duration)=>(sourceUpdater)=>{
            sourceUpdater.logger_(`Setting mediaSource duration to ${duration}`);
            try {
                sourceUpdater.mediaSource.duration = duration;
            } catch (e) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn('Failed to set media source duration', e);
            }
        },
    abort: ()=>(type, sourceUpdater)=>{
            if (sourceUpdater.mediaSource.readyState !== 'open') return;
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`calling abort on ${type}Buffer`);
            try {
                sourceBuffer.abort();
            } catch (e) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`Failed to abort on ${type}Buffer`, e);
            }
        },
    addSourceBuffer: (type, codec)=>(sourceUpdater)=>{
            const titleType = $cb03b711053a4297$var$toTitleCase(type);
            const mime = (0, $jv51Y.getMimeForCodec)(codec);
            sourceUpdater.logger_(`Adding ${type}Buffer with codec ${codec} to mediaSource`);
            const sourceBuffer = sourceUpdater.mediaSource.addSourceBuffer(mime);
            sourceBuffer.addEventListener('updateend', sourceUpdater[`on${titleType}UpdateEnd_`]);
            sourceBuffer.addEventListener('error', sourceUpdater[`on${titleType}Error_`]);
            sourceUpdater.codecs[type] = codec;
            sourceUpdater[`${type}Buffer`] = sourceBuffer;
        },
    removeSourceBuffer: (type)=>(sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`];
            $cb03b711053a4297$var$cleanupBuffer(type, sourceUpdater); // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Removing ${type}Buffer with codec ${sourceUpdater.codecs[type]} from mediaSource`);
            try {
                sourceUpdater.mediaSource.removeSourceBuffer(sourceBuffer);
            } catch (e) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`Failed to removeSourceBuffer ${type}Buffer`, e);
            }
        },
    changeType: (codec)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`];
            const mime = (0, $jv51Y.getMimeForCodec)(codec); // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
             // do not update codec if we don't need to.
            // Only update if we change the codec base.
            // For example, going from avc1.640028 to avc1.64001f does not require a changeType call.
            const newCodecBase = codec.substring(0, codec.indexOf('.'));
            const oldCodec = sourceUpdater.codecs[type];
            const oldCodecBase = oldCodec.substring(0, oldCodec.indexOf('.'));
            if (oldCodecBase === newCodecBase) return;
            const metadata = {
                codecsChangeInfo: {
                    from: oldCodec,
                    to: codec
                }
            };
            sourceUpdater.trigger({
                type: 'codecschange',
                metadata: metadata
            });
            sourceUpdater.logger_(`changing ${type}Buffer codec from ${oldCodec} to ${codec}`); // check if change to the provided type is supported
            try {
                sourceBuffer.changeType(mime);
                sourceUpdater.codecs[type] = codec;
            } catch (e) {
                metadata.errorType = $cb03b711053a4297$export$2e2bcd8739ae039.Error.StreamingCodecsChangeError;
                metadata.error = e;
                e.metadata = metadata;
                sourceUpdater.error_ = e;
                sourceUpdater.trigger('error');
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`Failed to changeType on ${type}Buffer`, e);
            }
        }
};
const $cb03b711053a4297$var$pushQueue = ({ type: type, sourceUpdater: sourceUpdater, action: action, doneFn: doneFn, name: name })=>{
    sourceUpdater.queue.push({
        type: type,
        action: action,
        doneFn: doneFn,
        name: name
    });
    $cb03b711053a4297$var$shiftQueue(type, sourceUpdater);
};
const $cb03b711053a4297$var$onUpdateend = (type, sourceUpdater)=>(e)=>{
        // Although there should, in theory, be a pending action for any updateend receieved,
        // there are some actions that may trigger updateend events without set definitions in
        // the w3c spec. For instance, setting the duration on the media source may trigger
        // updateend events on source buffers. This does not appear to be in the spec. As such,
        // if we encounter an updateend without a corresponding pending action from our queue
        // for that source buffer type, process the next action.
        const bufferedRangesForType = sourceUpdater[`${type}Buffered`]();
        const descriptiveString = $cb03b711053a4297$var$bufferedRangesToString(bufferedRangesForType);
        sourceUpdater.logger_(`received "updateend" event for ${type} Source Buffer: `, descriptiveString);
        if (sourceUpdater.queuePending[type]) {
            const doneFn = sourceUpdater.queuePending[type].doneFn;
            sourceUpdater.queuePending[type] = null;
            if (doneFn) // if there's an error, report it
            doneFn(sourceUpdater[`${type}Error_`]);
        }
        $cb03b711053a4297$var$shiftQueue(type, sourceUpdater);
    };
/**
 * A queue of callbacks to be serialized and applied when a
 * MediaSource and its associated SourceBuffers are not in the
 * updating state. It is used by the segment loader to update the
 * underlying SourceBuffers when new data is loaded, for instance.
 *
 * @class SourceUpdater
 * @param {MediaSource} mediaSource the MediaSource to create the SourceBuffer from
 * @param {string} mimeType the desired MIME type of the underlying SourceBuffer
 */ class $cb03b711053a4297$var$SourceUpdater extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(mediaSource){
        super();
        this.mediaSource = mediaSource;
        this.sourceopenListener_ = ()=>$cb03b711053a4297$var$shiftQueue('mediaSource', this);
        this.mediaSource.addEventListener('sourceopen', this.sourceopenListener_);
        this.logger_ = $cb03b711053a4297$var$logger('SourceUpdater'); // initial timestamp offset is 0
        this.audioTimestampOffset_ = 0;
        this.videoTimestampOffset_ = 0;
        this.queue = [];
        this.queuePending = {
            audio: null,
            video: null
        };
        this.delayedAudioAppendQueue_ = [];
        this.videoAppendQueued_ = false;
        this.codecs = {};
        this.onVideoUpdateEnd_ = $cb03b711053a4297$var$onUpdateend('video', this);
        this.onAudioUpdateEnd_ = $cb03b711053a4297$var$onUpdateend('audio', this);
        this.onVideoError_ = (e)=>{
            // used for debugging
            this.videoError_ = e;
        };
        this.onAudioError_ = (e)=>{
            // used for debugging
            this.audioError_ = e;
        };
        this.createdSourceBuffers_ = false;
        this.initializedEme_ = false;
        this.triggeredReady_ = false;
    }
    initializedEme() {
        this.initializedEme_ = true;
        this.triggerReady();
    }
    hasCreatedSourceBuffers() {
        // if false, likely waiting on one of the segment loaders to get enough data to create
        // source buffers
        return this.createdSourceBuffers_;
    }
    hasInitializedAnyEme() {
        return this.initializedEme_;
    }
    ready() {
        return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
    }
    createSourceBuffers(codecs) {
        if (this.hasCreatedSourceBuffers()) // already created them before
        return;
         // the intial addOrChangeSourceBuffers will always be
        // two add buffers.
        this.addOrChangeSourceBuffers(codecs);
        this.createdSourceBuffers_ = true;
        this.trigger('createdsourcebuffers');
        this.triggerReady();
    }
    triggerReady() {
        // only allow ready to be triggered once, this prevents the case
        // where:
        // 1. we trigger createdsourcebuffers
        // 2. ie 11 synchronously initializates eme
        // 3. the synchronous initialization causes us to trigger ready
        // 4. We go back to the ready check in createSourceBuffers and ready is triggered again.
        if (this.ready() && !this.triggeredReady_) {
            this.triggeredReady_ = true;
            this.trigger('ready');
        }
    }
    /**
   * Add a type of source buffer to the media source.
   *
   * @param {string} type
   *        The type of source buffer to add.
   *
   * @param {string} codec
   *        The codec to add the source buffer with.
   */ addSourceBuffer(type, codec) {
        $cb03b711053a4297$var$pushQueue({
            type: 'mediaSource',
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.addSourceBuffer(type, codec),
            name: 'addSourceBuffer'
        });
    }
    /**
   * call abort on a source buffer.
   *
   * @param {string} type
   *        The type of source buffer to call abort on.
   */ abort(type) {
        $cb03b711053a4297$var$pushQueue({
            type: type,
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.abort(type),
            name: 'abort'
        });
    }
    /**
   * Call removeSourceBuffer and remove a specific type
   * of source buffer on the mediaSource.
   *
   * @param {string} type
   *        The type of source buffer to remove.
   */ removeSourceBuffer(type) {
        if (!this.canRemoveSourceBuffer()) {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.error('removeSourceBuffer is not supported!');
            return;
        }
        $cb03b711053a4297$var$pushQueue({
            type: 'mediaSource',
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.removeSourceBuffer(type),
            name: 'removeSourceBuffer'
        });
    }
    /**
   * Whether or not the removeSourceBuffer function is supported
   * on the mediaSource.
   *
   * @return {boolean}
   *          if removeSourceBuffer can be called.
   */ canRemoveSourceBuffer() {
        // As of Firefox 83 removeSourceBuffer
        // throws errors, so we report that it does not support this.
        return !$cb03b711053a4297$export$2e2bcd8739ae039.browser.IS_FIREFOX && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource.prototype && typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource.prototype.removeSourceBuffer === 'function';
    }
    /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */ static canChangeType() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).SourceBuffer && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).SourceBuffer.prototype && typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).SourceBuffer.prototype.changeType === 'function';
    }
    /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */ canChangeType() {
        return this.constructor.canChangeType();
    }
    /**
   * Call the changeType function on a source buffer, given the code and type.
   *
   * @param {string} type
   *        The type of source buffer to call changeType on.
   *
   * @param {string} codec
   *        The codec string to change type with on the source buffer.
   */ changeType(type, codec) {
        if (!this.canChangeType()) {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.error('changeType is not supported!');
            return;
        }
        $cb03b711053a4297$var$pushQueue({
            type: type,
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.changeType(codec),
            name: 'changeType'
        });
    }
    /**
   * Add source buffers with a codec or, if they are already created,
   * call changeType on source buffers using changeType.
   *
   * @param {Object} codecs
   *        Codecs to switch to
   */ addOrChangeSourceBuffers(codecs) {
        if (!codecs || typeof codecs !== 'object' || Object.keys(codecs).length === 0) throw new Error('Cannot addOrChangeSourceBuffers to undefined codecs');
        Object.keys(codecs).forEach((type)=>{
            const codec = codecs[type];
            if (!this.hasCreatedSourceBuffers()) return this.addSourceBuffer(type, codec);
            if (this.canChangeType()) this.changeType(type, codec);
        });
    }
    /**
   * Queue an update to append an ArrayBuffer.
   *
   * @param {MediaObject} object containing audioBytes and/or videoBytes
   * @param {Function} done the function to call when done
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
   */ appendBuffer(options, doneFn) {
        const { segmentInfo: segmentInfo, type: type, bytes: bytes } = options;
        this.processedAppend_ = true;
        if (type === 'audio' && this.videoBuffer && !this.videoAppendQueued_) {
            this.delayedAudioAppendQueue_.push([
                options,
                doneFn
            ]);
            this.logger_(`delayed audio append of ${bytes.length} until video append`);
            return;
        } // In the case of certain errors, for instance, QUOTA_EXCEEDED_ERR, updateend will
        // not be fired. This means that the queue will be blocked until the next action
        // taken by the segment-loader. Provide a mechanism for segment-loader to handle
        // these errors by calling the doneFn with the specific error.
        const onError = doneFn;
        $cb03b711053a4297$var$pushQueue({
            type: type,
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.appendBuffer(bytes, segmentInfo || {
                mediaIndex: -1
            }, onError),
            doneFn: doneFn,
            name: 'appendBuffer'
        });
        if (type === 'video') {
            this.videoAppendQueued_ = true;
            if (!this.delayedAudioAppendQueue_.length) return;
            const queue = this.delayedAudioAppendQueue_.slice();
            this.logger_(`queuing delayed audio ${queue.length} appendBuffers`);
            this.delayedAudioAppendQueue_.length = 0;
            queue.forEach((que)=>{
                this.appendBuffer.apply(this, que);
            });
        }
    }
    /**
   * Get the audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The audio buffer's buffered time range
   */ audioBuffered() {
        // no media source/source buffer or it isn't in the media sources
        // source buffer list
        if (!$cb03b711053a4297$var$inSourceBuffers(this.mediaSource, this.audioBuffer)) return $cb03b711053a4297$var$createTimeRanges();
        return this.audioBuffer.buffered ? this.audioBuffer.buffered : $cb03b711053a4297$var$createTimeRanges();
    }
    /**
   * Get the video buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The video buffer's buffered time range
   */ videoBuffered() {
        // no media source/source buffer or it isn't in the media sources
        // source buffer list
        if (!$cb03b711053a4297$var$inSourceBuffers(this.mediaSource, this.videoBuffer)) return $cb03b711053a4297$var$createTimeRanges();
        return this.videoBuffer.buffered ? this.videoBuffer.buffered : $cb03b711053a4297$var$createTimeRanges();
    }
    /**
   * Get a combined video/audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         the combined time range
   */ buffered() {
        const video = $cb03b711053a4297$var$inSourceBuffers(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null;
        const audio = $cb03b711053a4297$var$inSourceBuffers(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
        if (audio && !video) return this.audioBuffered();
        if (video && !audio) return this.videoBuffered();
        return $cb03b711053a4297$var$bufferIntersection(this.audioBuffered(), this.videoBuffered());
    }
    /**
   * Add a callback to the queue that will set duration on the mediaSource.
   *
   * @param {number} duration
   *        The duration to set
   *
   * @param {Function} [doneFn]
   *        function to run after duration has been set.
   */ setDuration(duration, doneFn = $cb03b711053a4297$var$noop) {
        // In order to set the duration on the media source, it's necessary to wait for all
        // source buffers to no longer be updating. "If the updating attribute equals true on
        // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
        // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
        $cb03b711053a4297$var$pushQueue({
            type: 'mediaSource',
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.duration(duration),
            name: 'duration',
            doneFn: doneFn
        });
    }
    /**
   * Add a mediaSource endOfStream call to the queue
   *
   * @param {Error} [error]
   *        Call endOfStream with an error
   *
   * @param {Function} [doneFn]
   *        A function that should be called when the
   *        endOfStream call has finished.
   */ endOfStream(error = null, doneFn = $cb03b711053a4297$var$noop) {
        if (typeof error !== 'string') error = undefined;
         // In order to set the duration on the media source, it's necessary to wait for all
        // source buffers to no longer be updating. "If the updating attribute equals true on
        // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
        // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
        $cb03b711053a4297$var$pushQueue({
            type: 'mediaSource',
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.endOfStream(error),
            name: 'endOfStream',
            doneFn: doneFn
        });
    }
    /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */ removeAudio(start, end, done = $cb03b711053a4297$var$noop) {
        if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
            done();
            return;
        }
        $cb03b711053a4297$var$pushQueue({
            type: 'audio',
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.remove(start, end),
            doneFn: done,
            name: 'remove'
        });
    }
    /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */ removeVideo(start, end, done = $cb03b711053a4297$var$noop) {
        if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
            done();
            return;
        }
        $cb03b711053a4297$var$pushQueue({
            type: 'video',
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.remove(start, end),
            doneFn: done,
            name: 'remove'
        });
    }
    /**
   * Whether the underlying sourceBuffer is updating or not
   *
   * @return {boolean} the updating status of the SourceBuffer
   */ updating() {
        // the audio/video source buffer is updating
        if ($cb03b711053a4297$var$updating('audio', this) || $cb03b711053a4297$var$updating('video', this)) return true;
        return false;
    }
    /**
   * Set/get the timestampoffset on the audio SourceBuffer
   *
   * @return {number} the timestamp offset
   */ audioTimestampOffset(offset) {
        if (typeof offset !== 'undefined' && this.audioBuffer && // no point in updating if it's the same
        this.audioTimestampOffset_ !== offset) {
            $cb03b711053a4297$var$pushQueue({
                type: 'audio',
                sourceUpdater: this,
                action: $cb03b711053a4297$var$actions.timestampOffset(offset),
                name: 'timestampOffset'
            });
            this.audioTimestampOffset_ = offset;
        }
        return this.audioTimestampOffset_;
    }
    /**
   * Set/get the timestampoffset on the video SourceBuffer
   *
   * @return {number} the timestamp offset
   */ videoTimestampOffset(offset) {
        if (typeof offset !== 'undefined' && this.videoBuffer && // no point in updating if it's the same
        this.videoTimestampOffset_ !== offset) {
            $cb03b711053a4297$var$pushQueue({
                type: 'video',
                sourceUpdater: this,
                action: $cb03b711053a4297$var$actions.timestampOffset(offset),
                name: 'timestampOffset'
            });
            this.videoTimestampOffset_ = offset;
        }
        return this.videoTimestampOffset_;
    }
    /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the audio queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */ audioQueueCallback(callback) {
        if (!this.audioBuffer) return;
        $cb03b711053a4297$var$pushQueue({
            type: 'audio',
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.callback(callback),
            name: 'callback'
        });
    }
    /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the video queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */ videoQueueCallback(callback) {
        if (!this.videoBuffer) return;
        $cb03b711053a4297$var$pushQueue({
            type: 'video',
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.callback(callback),
            name: 'callback'
        });
    }
    /**
   * dispose of the source updater and the underlying sourceBuffer
   */ dispose() {
        this.trigger('dispose');
        $cb03b711053a4297$var$bufferTypes.forEach((type)=>{
            this.abort(type);
            if (this.canRemoveSourceBuffer()) this.removeSourceBuffer(type);
            else this[`${type}QueueCallback`](()=>$cb03b711053a4297$var$cleanupBuffer(type, this));
        });
        this.videoAppendQueued_ = false;
        this.delayedAudioAppendQueue_.length = 0;
        if (this.sourceopenListener_) this.mediaSource.removeEventListener('sourceopen', this.sourceopenListener_);
        this.off();
    }
}
const $cb03b711053a4297$var$uint8ToUtf8 = (uintArray)=>decodeURIComponent(escape(String.fromCharCode.apply(null, uintArray)));
const $cb03b711053a4297$var$bufferToHexString = (buffer)=>{
    const uInt8Buffer = new Uint8Array(buffer);
    return Array.from(uInt8Buffer).map((byte)=>byte.toString(16).padStart(2, '0')).join('');
};
/**
 * @file vtt-segment-loader.js
 */ const $cb03b711053a4297$var$VTT_LINE_TERMINATORS = new Uint8Array('\n\n'.split('').map((char)=>char.charCodeAt(0)));
class $cb03b711053a4297$var$NoVttJsError extends Error {
    constructor(){
        super('Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.');
    }
}
/**
 * An object that manages segment loading and appending.
 *
 * @class VTTSegmentLoader
 * @param {Object} options required and optional options
 * @extends videojs.EventTarget
 */ class $cb03b711053a4297$var$VTTSegmentLoader extends $cb03b711053a4297$var$SegmentLoader {
    constructor(settings, options = {}){
        super(settings, options); // SegmentLoader requires a MediaSource be specified or it will throw an error;
        // however, VTTSegmentLoader has no need of a media source, so delete the reference
        this.mediaSource_ = null;
        this.subtitlesTrack_ = null;
        this.featuresNativeTextTracks_ = settings.featuresNativeTextTracks;
        this.loadVttJs = settings.loadVttJs; // The VTT segment will have its own time mappings. Saving VTT segment timing info in
        // the sync controller leads to improper behavior.
        this.shouldSaveSegmentTimingInfo_ = false;
    }
    /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */ buffered_() {
        if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length) return $cb03b711053a4297$var$createTimeRanges();
        const cues = this.subtitlesTrack_.cues;
        const start = cues[0].startTime;
        const end = cues[cues.length - 1].startTime;
        return $cb03b711053a4297$var$createTimeRanges([
            [
                start,
                end
            ]
        ]);
    }
    /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */ initSegmentForMap(map, set = false) {
        if (!map) return null;
        const id = $cb03b711053a4297$var$initSegmentId(map);
        let storedMap = this.initSegments_[id];
        if (set && !storedMap && map.bytes) {
            // append WebVTT line terminators to the media initialization segment if it exists
            // to follow the WebVTT spec (https://w3c.github.io/webvtt/#file-structure) that
            // requires two or more WebVTT line terminators between the WebVTT header and the
            // rest of the file
            const combinedByteLength = $cb03b711053a4297$var$VTT_LINE_TERMINATORS.byteLength + map.bytes.byteLength;
            const combinedSegment = new Uint8Array(combinedByteLength);
            combinedSegment.set(map.bytes);
            combinedSegment.set($cb03b711053a4297$var$VTT_LINE_TERMINATORS, map.bytes.byteLength);
            this.initSegments_[id] = storedMap = {
                resolvedUri: map.resolvedUri,
                byterange: map.byterange,
                bytes: combinedSegment
            };
        }
        return storedMap || map;
    }
    /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */ couldBeginLoading_() {
        return this.playlist_ && this.subtitlesTrack_ && !this.paused();
    }
    /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */ init_() {
        this.state = 'READY';
        this.resetEverything();
        return this.monitorBuffer_();
    }
    /**
   * Set a subtitle track on the segment loader to add subtitles to
   *
   * @param {TextTrack=} track
   *        The text track to add loaded subtitles to
   * @return {TextTrack}
   *        Returns the subtitles track
   */ track(track) {
        if (typeof track === 'undefined') return this.subtitlesTrack_;
        this.subtitlesTrack_ = track; // if we were unpaused but waiting for a sourceUpdater, start
        // buffering now
        if (this.state === 'INIT' && this.couldBeginLoading_()) this.init_();
        return this.subtitlesTrack_;
    }
    /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   */ remove(start, end) {
        $cb03b711053a4297$var$removeCuesFromTrack(start, end, this.subtitlesTrack_);
    }
    /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */ fillBuffer_() {
        // see if we need to begin loading immediately
        const segmentInfo = this.chooseNextRequest_();
        if (!segmentInfo) return;
        if (this.syncController_.timestampOffsetForTimeline(segmentInfo.timeline) === null) {
            // We don't have the timestamp offset that we need to sync subtitles.
            // Rerun on a timestamp offset or user interaction.
            const checkTimestampOffset = ()=>{
                this.state = 'READY';
                if (!this.paused()) // if not paused, queue a buffer check as soon as possible
                this.monitorBuffer_();
            };
            this.syncController_.one('timestampoffset', checkTimestampOffset);
            this.state = 'WAITING_ON_TIMELINE';
            return;
        }
        this.loadSegment_(segmentInfo);
    }
    timestampOffsetForSegment_() {
        return null;
    }
    chooseNextRequest_() {
        return this.skipEmptySegments_(super.chooseNextRequest_());
    }
    /**
   * Prevents the segment loader from requesting segments we know contain no subtitles
   * by walking forward until we find the next segment that we don't know whether it is
   * empty or not.
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @return {Object}
   *         a segment info object that describes the current segment
   */ skipEmptySegments_(segmentInfo) {
        while(segmentInfo && segmentInfo.segment.empty){
            // stop at the last possible segmentInfo
            if (segmentInfo.mediaIndex + 1 >= segmentInfo.playlist.segments.length) {
                segmentInfo = null;
                break;
            }
            segmentInfo = this.generateSegmentInfo_({
                playlist: segmentInfo.playlist,
                mediaIndex: segmentInfo.mediaIndex + 1,
                startOfSegment: segmentInfo.startOfSegment + segmentInfo.duration,
                isSyncRequest: segmentInfo.isSyncRequest
            });
        }
        return segmentInfo;
    }
    stopForError(error) {
        this.error(error);
        this.state = 'READY';
        this.pause();
        this.trigger('error');
    }
    /**
   * append a decrypted segement to the SourceBuffer through a SourceUpdater
   *
   * @private
   */ segmentRequestFinished_(error, simpleSegment, result) {
        if (!this.subtitlesTrack_) {
            this.state = 'READY';
            return;
        }
        this.saveTransferStats_(simpleSegment.stats); // the request was aborted
        if (!this.pendingSegment_) {
            this.state = 'READY';
            this.mediaRequestsAborted += 1;
            return;
        }
        if (error) {
            if (error.code === $cb03b711053a4297$var$REQUEST_ERRORS.TIMEOUT) this.handleTimeout_();
            if (error.code === $cb03b711053a4297$var$REQUEST_ERRORS.ABORTED) this.mediaRequestsAborted += 1;
            else this.mediaRequestsErrored += 1;
            this.stopForError(error);
            return;
        }
        const segmentInfo = this.pendingSegment_;
        const isMp4WebVttSegmentWithCues = result.mp4VttCues && result.mp4VttCues.length;
        if (isMp4WebVttSegmentWithCues) segmentInfo.mp4VttCues = result.mp4VttCues;
         // although the VTT segment loader bandwidth isn't really used, it's good to
        // maintain functionality between segment loaders
        this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats); // if this request included a segment key, save that data in the cache
        if (simpleSegment.key) this.segmentKey(simpleSegment.key, true);
        this.state = 'APPENDING'; // used for tests
        this.trigger('appending');
        const segment = segmentInfo.segment;
        if (segment.map) segment.map.bytes = simpleSegment.map.bytes;
        segmentInfo.bytes = simpleSegment.bytes; // Make sure that vttjs has loaded, otherwise, load it and wait till it finished loading
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT !== 'function' && typeof this.loadVttJs === 'function') {
            this.state = 'WAITING_ON_VTTJS'; // should be fine to call multiple times
            // script will be loaded once but multiple listeners will be added to the queue, which is expected.
            this.loadVttJs().then(()=>this.segmentRequestFinished_(error, simpleSegment, result), ()=>this.stopForError({
                    message: 'Error loading vtt.js'
                }));
            return;
        }
        segment.requested = true;
        try {
            this.parseVTTCues_(segmentInfo);
        } catch (e) {
            this.stopForError({
                message: e.message,
                metadata: {
                    errorType: $cb03b711053a4297$export$2e2bcd8739ae039.Error.StreamingVttParserError,
                    error: e
                }
            });
            return;
        }
        if (!isMp4WebVttSegmentWithCues) this.updateTimeMapping_(segmentInfo, this.syncController_.timelines[segmentInfo.timeline], this.playlist_);
        if (segmentInfo.cues.length) segmentInfo.timingInfo = {
            start: segmentInfo.cues[0].startTime,
            end: segmentInfo.cues[segmentInfo.cues.length - 1].endTime
        };
        else segmentInfo.timingInfo = {
            start: segmentInfo.startOfSegment,
            end: segmentInfo.startOfSegment + segmentInfo.duration
        };
        if (segmentInfo.isSyncRequest) {
            this.trigger('syncinfoupdate');
            this.pendingSegment_ = null;
            this.state = 'READY';
            return;
        }
        segmentInfo.byteLength = segmentInfo.bytes.byteLength;
        this.mediaSecondsLoaded += segment.duration; // Create VTTCue instances for each cue in the new segment and add them to
        // the subtitle track
        segmentInfo.cues.forEach((cue)=>{
            this.subtitlesTrack_.addCue(this.featuresNativeTextTracks_ ? new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue(cue.startTime, cue.endTime, cue.text) : cue);
        }); // Remove any duplicate cues from the subtitle track. The WebVTT spec allows
        // cues to have identical time-intervals, but if the text is also identical
        // we can safely assume it is a duplicate that can be removed (ex. when a cue
        // "overlaps" VTT segments)
        $cb03b711053a4297$var$removeDuplicateCuesFromTrack(this.subtitlesTrack_);
        this.handleAppendsDone_();
    }
    handleData_(simpleSegment, result) {
        const isVttType = simpleSegment && simpleSegment.type === 'vtt';
        const isTextResult = result && result.type === 'text';
        const isFmp4VttSegment = isVttType && isTextResult; // handle segment data for fmp4 encapsulated webvtt
        if (isFmp4VttSegment) super.handleData_(simpleSegment, result);
    }
    updateTimingInfoEnd_() {}
    /**
   * Utility function for converting mp4 webvtt cue objects into VTTCues.
   *
   * @param {Object} segmentInfo with mp4 webvtt cues for parsing into VTTCue objecs
   */ parseMp4VttCues_(segmentInfo) {
        const timestampOffset = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
        segmentInfo.mp4VttCues.forEach((cue)=>{
            const start = cue.start + timestampOffset;
            const end = cue.end + timestampOffset;
            const vttCue = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue(start, end, cue.cueText);
            if (cue.settings) cue.settings.split(' ').forEach((cueSetting)=>{
                const keyValString = cueSetting.split(':');
                const key = keyValString[0];
                const value = keyValString[1];
                vttCue[key] = isNaN(value) ? value : Number(value);
            });
            segmentInfo.cues.push(vttCue);
        });
    }
    /**
   * Uses the WebVTT parser to parse the segment response
   *
   * @throws NoVttJsError
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @private
   */ parseVTTCues_(segmentInfo) {
        let decoder;
        let decodeBytesToString = false;
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT !== 'function') // caller is responsible for exception handling.
        throw new $cb03b711053a4297$var$NoVttJsError();
        segmentInfo.cues = [];
        segmentInfo.timestampmap = {
            MPEGTS: 0,
            LOCAL: 0
        };
        if (segmentInfo.mp4VttCues) {
            this.parseMp4VttCues_(segmentInfo);
            return;
        }
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).TextDecoder === 'function') decoder = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).TextDecoder('utf8');
        else {
            decoder = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.StringDecoder();
            decodeBytesToString = true;
        }
        const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.Parser((0, (/*@__PURE__*/$parcel$interopDefault($eDick))), (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).vttjs, decoder);
        parser.oncue = segmentInfo.cues.push.bind(segmentInfo.cues);
        parser.ontimestampmap = (map)=>{
            segmentInfo.timestampmap = map;
        };
        parser.onparsingerror = (error)=>{
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn('Error encountered when parsing cues: ' + error.message);
        };
        if (segmentInfo.segment.map) {
            let mapData = segmentInfo.segment.map.bytes;
            if (decodeBytesToString) mapData = $cb03b711053a4297$var$uint8ToUtf8(mapData);
            parser.parse(mapData);
        }
        let segmentData = segmentInfo.bytes;
        if (decodeBytesToString) segmentData = $cb03b711053a4297$var$uint8ToUtf8(segmentData);
        parser.parse(segmentData);
        parser.flush();
    }
    /**
   * Updates the start and end times of any cues parsed by the WebVTT parser using
   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
   * from the SyncController
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @param {Object} mappingObj
   *        object containing a mapping from TS to media time
   * @param {Object} playlist
   *        the playlist object containing the segment
   * @private
   */ updateTimeMapping_(segmentInfo, mappingObj, playlist) {
        const segment = segmentInfo.segment;
        if (!mappingObj) // If the sync controller does not have a mapping of TS to Media Time for the
        // timeline, then we don't have enough information to update the cue
        // start/end times
        return;
        if (!segmentInfo.cues.length) {
            // If there are no cues, we also do not have enough information to figure out
            // segment timing. Mark that the segment contains no cues so we don't re-request
            // an empty segment.
            segment.empty = true;
            return;
        }
        const { MPEGTS: MPEGTS, LOCAL: LOCAL } = segmentInfo.timestampmap;
        /**
     * From the spec:
     * The MPEGTS media timestamp MUST use a 90KHz timescale,
     * even when non-WebVTT Media Segments use a different timescale.
     */ const mpegTsInSeconds = MPEGTS / (0, $3CkWK.ONE_SECOND_IN_TS);
        const diff = mpegTsInSeconds - LOCAL + mappingObj.mapping;
        segmentInfo.cues.forEach((cue)=>{
            const duration = cue.endTime - cue.startTime;
            const startTime = this.handleRollover_(cue.startTime + diff, mappingObj.time);
            cue.startTime = Math.max(startTime, 0);
            cue.endTime = Math.max(startTime + duration, 0);
        });
        if (!playlist.syncInfo) {
            const firstStart = segmentInfo.cues[0].startTime;
            const lastStart = segmentInfo.cues[segmentInfo.cues.length - 1].startTime;
            playlist.syncInfo = {
                mediaSequence: playlist.mediaSequence + segmentInfo.mediaIndex,
                time: Math.min(firstStart, lastStart - segment.duration)
            };
        }
    }
    /**
   * MPEG-TS PES timestamps are limited to 2^33.
   * Once they reach 2^33, they roll over to 0.
   * mux.js handles PES timestamp rollover for the following scenarios:
   * [forward rollover(right)] ->
   *    PES timestamps monotonically increase, and once they reach 2^33, they roll over to 0
   * [backward rollover(left)] -->
   *    we seek back to position before rollover.
   *
   * According to the HLS SPEC:
   * When synchronizing WebVTT with PES timestamps, clients SHOULD account
   * for cases where the 33-bit PES timestamps have wrapped and the WebVTT
   * cue times have not.  When the PES timestamp wraps, the WebVTT Segment
   * SHOULD have a X-TIMESTAMP-MAP header that maps the current WebVTT
   * time to the new (low valued) PES timestamp.
   *
   * So we want to handle rollover here and align VTT Cue start/end time to the player's time.
   */ handleRollover_(value, reference) {
        if (reference === null) return value;
        let valueIn90khz = value * (0, $3CkWK.ONE_SECOND_IN_TS);
        const referenceIn90khz = reference * (0, $3CkWK.ONE_SECOND_IN_TS);
        let offset;
        if (referenceIn90khz < valueIn90khz) // - 2^33
        offset = -8589934592;
        else // + 2^33
        offset = 8589934592;
         // distance(value - reference) > 2^32
        while(Math.abs(valueIn90khz - referenceIn90khz) > 4294967296)valueIn90khz += offset;
        return valueIn90khz / (0, $3CkWK.ONE_SECOND_IN_TS);
    }
}
/**
 * @file ad-cue-tags.js
 */ /**
 * Searches for an ad cue that overlaps with the given mediaTime
 *
 * @param {Object} track
 *        the track to find the cue for
 *
 * @param {number} mediaTime
 *        the time to find the cue at
 *
 * @return {Object|null}
 *         the found cue or null
 */ const $cb03b711053a4297$var$findAdCue = function(track, mediaTime) {
    const cues = track.cues;
    for(let i = 0; i < cues.length; i++){
        const cue = cues[i];
        if (mediaTime >= cue.adStartTime && mediaTime <= cue.adEndTime) return cue;
    }
    return null;
};
const $cb03b711053a4297$var$updateAdCues = function(media, track, offset = 0) {
    if (!media.segments) return;
    let mediaTime = offset;
    let cue;
    for(let i = 0; i < media.segments.length; i++){
        const segment = media.segments[i];
        if (!cue) // Since the cues will span for at least the segment duration, adding a fudge
        // factor of half segment duration will prevent duplicate cues from being
        // created when timing info is not exact (e.g. cue start time initialized
        // at 10.006677, but next call mediaTime is 10.003332 )
        cue = $cb03b711053a4297$var$findAdCue(track, mediaTime + segment.duration / 2);
        if (cue) {
            if ('cueIn' in segment) {
                // Found a CUE-IN so end the cue
                cue.endTime = mediaTime;
                cue.adEndTime = mediaTime;
                mediaTime += segment.duration;
                cue = null;
                continue;
            }
            if (mediaTime < cue.endTime) {
                // Already processed this mediaTime for this cue
                mediaTime += segment.duration;
                continue;
            } // otherwise extend cue until a CUE-IN is found
            cue.endTime += segment.duration;
        } else {
            if ('cueOut' in segment) {
                cue = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue(mediaTime, mediaTime + segment.duration, segment.cueOut);
                cue.adStartTime = mediaTime; // Assumes tag format to be
                // #EXT-X-CUE-OUT:30
                cue.adEndTime = mediaTime + parseFloat(segment.cueOut);
                track.addCue(cue);
            }
            if ('cueOutCont' in segment) {
                // Entered into the middle of an ad cue
                // Assumes tag formate to be
                // #EXT-X-CUE-OUT-CONT:10/30
                const [adOffset, adTotal] = segment.cueOutCont.split('/').map(parseFloat);
                cue = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue(mediaTime, mediaTime + segment.duration, '');
                cue.adStartTime = mediaTime - adOffset;
                cue.adEndTime = cue.adStartTime + adTotal;
                track.addCue(cue);
            }
        }
        mediaTime += segment.duration;
    }
};
class $cb03b711053a4297$var$SyncInfo {
    /**
   * @param {number} start - media sequence start
   * @param {number} end - media sequence end
   * @param {number} segmentIndex - index for associated segment
   * @param {number|null} [partIndex] - index for associated part
   * @param {boolean} [appended] - appended indicator
   *
   */ constructor({ start: start, end: end, segmentIndex: segmentIndex, partIndex: partIndex = null, appended: appended = false }){
        this.start_ = start;
        this.end_ = end;
        this.segmentIndex_ = segmentIndex;
        this.partIndex_ = partIndex;
        this.appended_ = appended;
    }
    isInRange(targetTime) {
        return targetTime >= this.start && targetTime < this.end;
    }
    markAppended() {
        this.appended_ = true;
    }
    resetAppendedStatus() {
        this.appended_ = false;
    }
    get isAppended() {
        return this.appended_;
    }
    get start() {
        return this.start_;
    }
    get end() {
        return this.end_;
    }
    get segmentIndex() {
        return this.segmentIndex_;
    }
    get partIndex() {
        return this.partIndex_;
    }
}
class $cb03b711053a4297$var$SyncInfoData {
    /**
   *
   * @param {SyncInfo} segmentSyncInfo - sync info for a given segment
   * @param {Array<SyncInfo>} [partsSyncInfo] - sync infos for a list of parts for a given segment
   */ constructor(segmentSyncInfo, partsSyncInfo = []){
        this.segmentSyncInfo_ = segmentSyncInfo;
        this.partsSyncInfo_ = partsSyncInfo;
    }
    get segmentSyncInfo() {
        return this.segmentSyncInfo_;
    }
    get partsSyncInfo() {
        return this.partsSyncInfo_;
    }
    get hasPartsSyncInfo() {
        return this.partsSyncInfo_.length > 0;
    }
    resetAppendStatus() {
        this.segmentSyncInfo_.resetAppendedStatus();
        this.partsSyncInfo_.forEach((partSyncInfo)=>partSyncInfo.resetAppendedStatus());
    }
}
class $cb03b711053a4297$var$MediaSequenceSync {
    constructor(){
        /**
     * @type {Map<number, SyncInfoData>}
     * @protected
     */ this.storage_ = new Map();
        this.diagnostics_ = '';
        this.isReliable_ = false;
        this.start_ = -Infinity;
        this.end_ = Infinity;
    }
    get start() {
        return this.start_;
    }
    get end() {
        return this.end_;
    }
    get diagnostics() {
        return this.diagnostics_;
    }
    get isReliable() {
        return this.isReliable_;
    }
    resetAppendedStatus() {
        this.storage_.forEach((syncInfoData)=>syncInfoData.resetAppendStatus());
    }
    /**
   * update sync storage
   *
   * @param {Object} playlist
   * @param {number} currentTime
   *
   * @return {void}
   */ update(playlist, currentTime) {
        const { mediaSequence: mediaSequence, segments: segments } = playlist;
        this.isReliable_ = this.isReliablePlaylist_(mediaSequence, segments);
        if (!this.isReliable_) return;
        return this.updateStorage_(segments, mediaSequence, this.calculateBaseTime_(mediaSequence, segments, currentTime));
    }
    /**
   * @param {number} targetTime
   * @return {SyncInfo|null}
   */ getSyncInfoForTime(targetTime) {
        for (const { segmentSyncInfo: segmentSyncInfo, partsSyncInfo: partsSyncInfo } of this.storage_.values()){
            // Normal segment flow:
            if (!partsSyncInfo.length) {
                if (segmentSyncInfo.isInRange(targetTime)) return segmentSyncInfo;
            } else // Low latency flow:
            for (const partSyncInfo of partsSyncInfo){
                if (partSyncInfo.isInRange(targetTime)) return partSyncInfo;
            }
        }
        return null;
    }
    getSyncInfoForMediaSequence(mediaSequence) {
        return this.storage_.get(mediaSequence);
    }
    updateStorage_(segments, startingMediaSequence, startingTime) {
        const newStorage = new Map();
        let newDiagnostics = '\n';
        let currentStart = startingTime;
        let currentMediaSequence = startingMediaSequence;
        this.start_ = currentStart;
        segments.forEach((segment, segmentIndex)=>{
            const prevSyncInfoData = this.storage_.get(currentMediaSequence);
            const segmentStart = currentStart;
            const segmentEnd = segmentStart + segment.duration;
            const segmentIsAppended = Boolean(prevSyncInfoData && prevSyncInfoData.segmentSyncInfo && prevSyncInfoData.segmentSyncInfo.isAppended);
            const segmentSyncInfo = new $cb03b711053a4297$var$SyncInfo({
                start: segmentStart,
                end: segmentEnd,
                appended: segmentIsAppended,
                segmentIndex: segmentIndex
            });
            segment.syncInfo = segmentSyncInfo;
            let currentPartStart = currentStart;
            const partsSyncInfo = (segment.parts || []).map((part, partIndex)=>{
                const partStart = currentPartStart;
                const partEnd = currentPartStart + part.duration;
                const partIsAppended = Boolean(prevSyncInfoData && prevSyncInfoData.partsSyncInfo && prevSyncInfoData.partsSyncInfo[partIndex] && prevSyncInfoData.partsSyncInfo[partIndex].isAppended);
                const partSyncInfo = new $cb03b711053a4297$var$SyncInfo({
                    start: partStart,
                    end: partEnd,
                    appended: partIsAppended,
                    segmentIndex: segmentIndex,
                    partIndex: partIndex
                });
                currentPartStart = partEnd;
                newDiagnostics += `Media Sequence: ${currentMediaSequence}.${partIndex} | Range: ${partStart} --> ${partEnd} | Appended: ${partIsAppended}\n`;
                part.syncInfo = partSyncInfo;
                return partSyncInfo;
            });
            newStorage.set(currentMediaSequence, new $cb03b711053a4297$var$SyncInfoData(segmentSyncInfo, partsSyncInfo));
            newDiagnostics += `${$cb03b711053a4297$var$compactSegmentUrlDescription(segment.resolvedUri)} | Media Sequence: ${currentMediaSequence} | Range: ${segmentStart} --> ${segmentEnd} | Appended: ${segmentIsAppended}\n`;
            currentMediaSequence++;
            currentStart = segmentEnd;
        });
        this.end_ = currentStart;
        this.storage_ = newStorage;
        this.diagnostics_ = newDiagnostics;
    }
    calculateBaseTime_(mediaSequence, segments, fallback) {
        if (!this.storage_.size) // Initial setup flow.
        return 0;
        if (this.storage_.has(mediaSequence)) // Normal flow.
        return this.storage_.get(mediaSequence).segmentSyncInfo.start;
        const minMediaSequenceFromStorage = Math.min(...this.storage_.keys()); // This case captures a race condition that can occur if we switch to a new media playlist that is out of date
        // and still has an older Media Sequence. If this occurs, we extrapolate backwards to get the base time.
        if (mediaSequence < minMediaSequenceFromStorage) {
            const mediaSequenceDiff = minMediaSequenceFromStorage - mediaSequence;
            let baseTime = this.storage_.get(minMediaSequenceFromStorage).segmentSyncInfo.start;
            for(let i = 0; i < mediaSequenceDiff; i++){
                const segment = segments[i];
                baseTime -= segment.duration;
            }
            return baseTime;
        } // Fallback flow.
        // There is a gap between last recorded playlist and a new one received.
        return fallback;
    }
    isReliablePlaylist_(mediaSequence, segments) {
        return mediaSequence !== undefined && mediaSequence !== null && Array.isArray(segments) && segments.length;
    }
}
class $cb03b711053a4297$var$DependantMediaSequenceSync extends $cb03b711053a4297$var$MediaSequenceSync {
    constructor(parent){
        super();
        this.parent_ = parent;
    }
    calculateBaseTime_(mediaSequence, segments, fallback) {
        if (!this.storage_.size) {
            const info = this.parent_.getSyncInfoForMediaSequence(mediaSequence);
            if (info) return info.segmentSyncInfo.start;
            return 0;
        }
        return super.calculateBaseTime_(mediaSequence, segments, fallback);
    }
}
/**
 * @file sync-controller.js
 */ // synchronize expired playlist segments.
// the max media sequence diff is 48 hours of live stream
// content with two second segments. Anything larger than that
// will likely be invalid.
const $cb03b711053a4297$var$MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC = 86400;
const $cb03b711053a4297$var$syncPointStrategies = [
    // Stategy "VOD": Handle the VOD-case where the sync-point is *always*
    //                the equivalence display-time 0 === segment-index 0
    {
        name: 'VOD',
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            if (duration !== Infinity) {
                const syncPoint = {
                    time: 0,
                    segmentIndex: 0,
                    partIndex: null
                };
                return syncPoint;
            }
            return null;
        }
    },
    {
        name: 'MediaSequence',
        /**
   * run media sequence strategy
   *
   * @param {SyncController} syncController
   * @param {Object} playlist
   * @param {number} duration
   * @param {number} currentTimeline
   * @param {number} currentTime
   * @param {string} type
   */ run: (syncController, playlist, duration, currentTimeline, currentTime, type)=>{
            const mediaSequenceSync = syncController.getMediaSequenceSync(type);
            if (!mediaSequenceSync) return null;
            if (!mediaSequenceSync.isReliable) return null;
            const syncInfo = mediaSequenceSync.getSyncInfoForTime(currentTime);
            if (!syncInfo) return null;
            return {
                time: syncInfo.start,
                partIndex: syncInfo.partIndex,
                segmentIndex: syncInfo.segmentIndex
            };
        }
    },
    // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
    {
        name: 'ProgramDateTime',
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            if (!Object.keys(syncController.timelineToDatetimeMappings).length) return null;
            let syncPoint = null;
            let lastDistance = null;
            const partsAndSegments = $cb03b711053a4297$var$getPartsAndSegments(playlist);
            currentTime = currentTime || 0;
            for(let i = 0; i < partsAndSegments.length; i++){
                // start from the end and loop backwards for live
                // or start from the front and loop forwards for non-live
                const index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
                const partAndSegment = partsAndSegments[index];
                const segment = partAndSegment.segment;
                const datetimeMapping = syncController.timelineToDatetimeMappings[segment.timeline];
                if (!datetimeMapping || !segment.dateTimeObject) continue;
                const segmentTime = segment.dateTimeObject.getTime() / 1000;
                let start = segmentTime + datetimeMapping; // take part duration into account.
                if (segment.parts && typeof partAndSegment.partIndex === 'number') for(let z = 0; z < partAndSegment.partIndex; z++)start += segment.parts[z].duration;
                const distance = Math.abs(currentTime - start); // Once the distance begins to increase, or if distance is 0, we have passed
                // currentTime and can stop looking for better candidates
                if (lastDistance !== null && (distance === 0 || lastDistance < distance)) break;
                lastDistance = distance;
                syncPoint = {
                    time: start,
                    segmentIndex: partAndSegment.segmentIndex,
                    partIndex: partAndSegment.partIndex
                };
            }
            return syncPoint;
        }
    },
    // Stategy "Segment": We have a known time mapping for a timeline and a
    //                    segment in the current timeline with timing data
    {
        name: 'Segment',
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            let syncPoint = null;
            let lastDistance = null;
            currentTime = currentTime || 0;
            const partsAndSegments = $cb03b711053a4297$var$getPartsAndSegments(playlist);
            for(let i = 0; i < partsAndSegments.length; i++){
                // start from the end and loop backwards for live
                // or start from the front and loop forwards for non-live
                const index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
                const partAndSegment = partsAndSegments[index];
                const segment = partAndSegment.segment;
                const start = partAndSegment.part && partAndSegment.part.start || segment && segment.start;
                if (segment.timeline === currentTimeline && typeof start !== 'undefined') {
                    const distance = Math.abs(currentTime - start); // Once the distance begins to increase, we have passed
                    // currentTime and can stop looking for better candidates
                    if (lastDistance !== null && lastDistance < distance) break;
                    if (!syncPoint || lastDistance === null || lastDistance >= distance) {
                        lastDistance = distance;
                        syncPoint = {
                            time: start,
                            segmentIndex: partAndSegment.segmentIndex,
                            partIndex: partAndSegment.partIndex
                        };
                    }
                }
            }
            return syncPoint;
        }
    },
    // Stategy "Discontinuity": We have a discontinuity with a known
    //                          display-time
    {
        name: 'Discontinuity',
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            let syncPoint = null;
            currentTime = currentTime || 0;
            if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
                let lastDistance = null;
                for(let i = 0; i < playlist.discontinuityStarts.length; i++){
                    const segmentIndex = playlist.discontinuityStarts[i];
                    const discontinuity = playlist.discontinuitySequence + i + 1;
                    const discontinuitySync = syncController.discontinuities[discontinuity];
                    if (discontinuitySync) {
                        const distance = Math.abs(currentTime - discontinuitySync.time); // Once the distance begins to increase, we have passed
                        // currentTime and can stop looking for better candidates
                        if (lastDistance !== null && lastDistance < distance) break;
                        if (!syncPoint || lastDistance === null || lastDistance >= distance) {
                            lastDistance = distance;
                            syncPoint = {
                                time: discontinuitySync.time,
                                segmentIndex: segmentIndex,
                                partIndex: null
                            };
                        }
                    }
                }
            }
            return syncPoint;
        }
    },
    // Stategy "Playlist": We have a playlist with a known mapping of
    //                     segment index to display time
    {
        name: 'Playlist',
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            if (playlist.syncInfo) {
                const syncPoint = {
                    time: playlist.syncInfo.time,
                    segmentIndex: playlist.syncInfo.mediaSequence - playlist.mediaSequence,
                    partIndex: null
                };
                return syncPoint;
            }
            return null;
        }
    }
];
class $cb03b711053a4297$var$SyncController extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(options = {}){
        super(); // ...for synching across variants
        this.timelines = [];
        this.discontinuities = [];
        this.timelineToDatetimeMappings = {}; // TODO: this map should be only available for HLS. Since only HLS has MediaSequence.
        //  For some reason this map helps with syncing between quality switch for MPEG-DASH as well.
        //  Moreover if we disable this map for MPEG-DASH - quality switch will be broken.
        //  MPEG-DASH should have its own separate sync strategy
        const main = new $cb03b711053a4297$var$MediaSequenceSync();
        const audio = new $cb03b711053a4297$var$DependantMediaSequenceSync(main);
        const vtt = new $cb03b711053a4297$var$DependantMediaSequenceSync(main);
        this.mediaSequenceStorage_ = {
            main: main,
            audio: audio,
            vtt: vtt
        };
        this.logger_ = $cb03b711053a4297$var$logger('SyncController');
    }
    /**
   *
   * @param {string} loaderType
   * @return {MediaSequenceSync|null}
   */ getMediaSequenceSync(loaderType) {
        return this.mediaSequenceStorage_[loaderType] || null;
    }
    /**
   * Find a sync-point for the playlist specified
   *
   * A sync-point is defined as a known mapping from display-time to
   * a segment-index in the current playlist.
   *
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinite if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Object}
   *          A sync-point object
   */ getSyncPoint(playlist, duration, currentTimeline, currentTime, type) {
        // Always use VOD sync point for VOD
        if (duration !== Infinity) {
            const vodSyncPointStrategy = $cb03b711053a4297$var$syncPointStrategies.find(({ name: name })=>name === 'VOD');
            return vodSyncPointStrategy.run(this, playlist, duration);
        }
        const syncPoints = this.runStrategies_(playlist, duration, currentTimeline, currentTime, type);
        if (!syncPoints.length) // Signal that we need to attempt to get a sync-point manually
        // by fetching a segment in the playlist and constructing
        // a sync-point from that information
        return null;
         // If we have exact match just return it instead of finding the nearest distance
        for (const syncPointInfo of syncPoints){
            const { syncPoint: syncPoint, strategy: strategy } = syncPointInfo;
            const { segmentIndex: segmentIndex, time: time } = syncPoint;
            if (segmentIndex < 0) continue;
            const selectedSegment = playlist.segments[segmentIndex];
            const start = time;
            const end = start + selectedSegment.duration;
            this.logger_(`Strategy: ${strategy}. Current time: ${currentTime}. selected segment: ${segmentIndex}. Time: [${start} -> ${end}]}`);
            if (currentTime >= start && currentTime < end) {
                this.logger_('Found sync point with exact match: ', syncPoint);
                return syncPoint;
            }
        } // Now find the sync-point that is closest to the currentTime because
        // that should result in the most accurate guess about which segment
        // to fetch
        return this.selectSyncPoint_(syncPoints, {
            key: 'time',
            value: currentTime
        });
    }
    /**
   * Calculate the amount of time that has expired off the playlist during playback
   *
   * @param {Playlist} playlist
   *        Playlist object to calculate expired from
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playling a live source)
   * @return {number|null}
   *          The amount of time that has expired off the playlist during playback. Null
   *          if no sync-points for the playlist can be found.
   */ getExpiredTime(playlist, duration) {
        if (!playlist || !playlist.segments) return null;
        const syncPoints = this.runStrategies_(playlist, duration, playlist.discontinuitySequence, 0); // Without sync-points, there is not enough information to determine the expired time
        if (!syncPoints.length) return null;
        const syncPoint = this.selectSyncPoint_(syncPoints, {
            key: 'segmentIndex',
            value: 0
        }); // If the sync-point is beyond the start of the playlist, we want to subtract the
        // duration from index 0 to syncPoint.segmentIndex instead of adding.
        if (syncPoint.segmentIndex > 0) syncPoint.time *= -1;
        return Math.abs(syncPoint.time + $cb03b711053a4297$var$sumDurations({
            defaultDuration: playlist.targetDuration,
            durationList: playlist.segments,
            startIndex: syncPoint.segmentIndex,
            endIndex: 0
        }));
    }
    /**
   * Runs each sync-point strategy and returns a list of sync-points returned by the
   * strategies
   *
   * @private
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Array}
   *          A list of sync-point objects
   */ runStrategies_(playlist, duration, currentTimeline, currentTime, type) {
        const syncPoints = []; // Try to find a sync-point in by utilizing various strategies...
        for(let i = 0; i < $cb03b711053a4297$var$syncPointStrategies.length; i++){
            const strategy = $cb03b711053a4297$var$syncPointStrategies[i];
            const syncPoint = strategy.run(this, playlist, duration, currentTimeline, currentTime, type);
            if (syncPoint) {
                syncPoint.strategy = strategy.name;
                syncPoints.push({
                    strategy: strategy.name,
                    syncPoint: syncPoint
                });
            }
        }
        return syncPoints;
    }
    /**
   * Selects the sync-point nearest the specified target
   *
   * @private
   * @param {Array} syncPoints
   *        List of sync-points to select from
   * @param {Object} target
   *        Object specifying the property and value we are targeting
   * @param {string} target.key
   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
   * @param {number} target.value
   *        The value to target for the specified key.
   * @return {Object}
   *          The sync-point nearest the target
   */ selectSyncPoint_(syncPoints, target) {
        let bestSyncPoint = syncPoints[0].syncPoint;
        let bestDistance = Math.abs(syncPoints[0].syncPoint[target.key] - target.value);
        let bestStrategy = syncPoints[0].strategy;
        for(let i = 1; i < syncPoints.length; i++){
            const newDistance = Math.abs(syncPoints[i].syncPoint[target.key] - target.value);
            if (newDistance < bestDistance) {
                bestDistance = newDistance;
                bestSyncPoint = syncPoints[i].syncPoint;
                bestStrategy = syncPoints[i].strategy;
            }
        }
        this.logger_(`syncPoint for [${target.key}: ${target.value}] chosen with strategy` + ` [${bestStrategy}]: [time:${bestSyncPoint.time},` + ` segmentIndex:${bestSyncPoint.segmentIndex}` + (typeof bestSyncPoint.partIndex === 'number' ? `,partIndex:${bestSyncPoint.partIndex}` : '') + ']');
        return bestSyncPoint;
    }
    /**
   * Save any meta-data present on the segments when segments leave
   * the live window to the playlist to allow for synchronization at the
   * playlist level later.
   *
   * @param {Playlist} oldPlaylist - The previous active playlist
   * @param {Playlist} newPlaylist - The updated and most current playlist
   */ saveExpiredSegmentInfo(oldPlaylist, newPlaylist) {
        const mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence; // Ignore large media sequence gaps
        if (mediaSequenceDiff > $cb03b711053a4297$var$MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC) {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`Not saving expired segment info. Media sequence gap ${mediaSequenceDiff} is too large.`);
            return;
        } // When a segment expires from the playlist and it has a start time
        // save that information as a possible sync-point reference in future
        for(let i = mediaSequenceDiff - 1; i >= 0; i--){
            const lastRemovedSegment = oldPlaylist.segments[i];
            if (lastRemovedSegment && typeof lastRemovedSegment.start !== 'undefined') {
                newPlaylist.syncInfo = {
                    mediaSequence: oldPlaylist.mediaSequence + i,
                    time: lastRemovedSegment.start
                };
                this.logger_(`playlist refresh sync: [time:${newPlaylist.syncInfo.time},` + ` mediaSequence: ${newPlaylist.syncInfo.mediaSequence}]`);
                this.trigger('syncinfoupdate');
                break;
            }
        }
    }
    /**
   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
   * before segments start to load.
   *
   * @param {Playlist} playlist - The currently active playlist
   */ setDateTimeMappingForStart(playlist) {
        // It's possible for the playlist to be updated before playback starts, meaning time
        // zero is not yet set. If, during these playlist refreshes, a discontinuity is
        // crossed, then the old time zero mapping (for the prior timeline) would be retained
        // unless the mappings are cleared.
        this.timelineToDatetimeMappings = {};
        if (playlist.segments && playlist.segments.length && playlist.segments[0].dateTimeObject) {
            const firstSegment = playlist.segments[0];
            const playlistTimestamp = firstSegment.dateTimeObject.getTime() / 1000;
            this.timelineToDatetimeMappings[firstSegment.timeline] = -playlistTimestamp;
        }
    }
    /**
   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
   * based on the latest timing information.
   *
   * @param {Object} options
   *        Options object
   * @param {SegmentInfo} options.segmentInfo
   *        The current active request information
   * @param {boolean} options.shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved for timeline mapping and program date time mappings.
   */ saveSegmentTimingInfo({ segmentInfo: segmentInfo, shouldSaveTimelineMapping: shouldSaveTimelineMapping }) {
        const didCalculateSegmentTimeMapping = this.calculateSegmentTimeMapping_(segmentInfo, segmentInfo.timingInfo, shouldSaveTimelineMapping);
        const segment = segmentInfo.segment;
        if (didCalculateSegmentTimeMapping) {
            this.saveDiscontinuitySyncInfo_(segmentInfo); // If the playlist does not have sync information yet, record that information
            // now with segment timing information
            if (!segmentInfo.playlist.syncInfo) segmentInfo.playlist.syncInfo = {
                mediaSequence: segmentInfo.playlist.mediaSequence + segmentInfo.mediaIndex,
                time: segment.start
            };
        }
        const dateTime = segment.dateTimeObject;
        if (segment.discontinuity && shouldSaveTimelineMapping && dateTime) this.timelineToDatetimeMappings[segment.timeline] = -(dateTime.getTime() / 1000);
    }
    timestampOffsetForTimeline(timeline) {
        if (typeof this.timelines[timeline] === 'undefined') return null;
        return this.timelines[timeline].time;
    }
    mappingForTimeline(timeline) {
        if (typeof this.timelines[timeline] === 'undefined') return null;
        return this.timelines[timeline].mapping;
    }
    /**
   * Use the "media time" for a segment to generate a mapping to "display time" and
   * save that display time to the segment.
   *
   * @private
   * @param {SegmentInfo} segmentInfo
   *        The current active request information
   * @param {Object} timingInfo
   *        The start and end time of the current segment in "media time"
   * @param {boolean} shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved in timelines.
   * @return {boolean}
   *          Returns false if segment time mapping could not be calculated
   */ calculateSegmentTimeMapping_(segmentInfo, timingInfo, shouldSaveTimelineMapping) {
        // TODO: remove side effects
        const segment = segmentInfo.segment;
        const part = segmentInfo.part;
        let mappingObj = this.timelines[segmentInfo.timeline];
        let start;
        let end;
        if (typeof segmentInfo.timestampOffset === 'number') {
            mappingObj = {
                time: segmentInfo.startOfSegment,
                mapping: segmentInfo.startOfSegment - timingInfo.start
            };
            if (shouldSaveTimelineMapping) {
                this.timelines[segmentInfo.timeline] = mappingObj;
                this.trigger('timestampoffset');
                this.logger_(`time mapping for timeline ${segmentInfo.timeline}: ` + `[time: ${mappingObj.time}] [mapping: ${mappingObj.mapping}]`);
            }
            start = segmentInfo.startOfSegment;
            end = timingInfo.end + mappingObj.mapping;
        } else if (mappingObj) {
            start = timingInfo.start + mappingObj.mapping;
            end = timingInfo.end + mappingObj.mapping;
        } else return false;
        if (part) {
            part.start = start;
            part.end = end;
        } // If we don't have a segment start yet or the start value we got
        // is less than our current segment.start value, save a new start value.
        // We have to do this because parts will have segment timing info saved
        // multiple times and we want segment start to be the earliest part start
        // value for that segment.
        if (!segment.start || start < segment.start) segment.start = start;
        segment.end = end;
        return true;
    }
    /**
   * Each time we have discontinuity in the playlist, attempt to calculate the location
   * in display of the start of the discontinuity and save that. We also save an accuracy
   * value so that we save values with the most accuracy (closest to 0.)
   *
   * @private
   * @param {SegmentInfo} segmentInfo - The current active request information
   */ saveDiscontinuitySyncInfo_(segmentInfo) {
        const playlist = segmentInfo.playlist;
        const segment = segmentInfo.segment; // If the current segment is a discontinuity then we know exactly where
        // the start of the range and it's accuracy is 0 (greater accuracy values
        // mean more approximation)
        if (segment.discontinuity) this.discontinuities[segment.timeline] = {
            time: segment.start,
            accuracy: 0
        };
        else if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) // Search for future discontinuities that we can provide better timing
        // information for and save that information for sync purposes
        for(let i = 0; i < playlist.discontinuityStarts.length; i++){
            const segmentIndex = playlist.discontinuityStarts[i];
            const discontinuity = playlist.discontinuitySequence + i + 1;
            const mediaIndexDiff = segmentIndex - segmentInfo.mediaIndex;
            const accuracy = Math.abs(mediaIndexDiff);
            if (!this.discontinuities[discontinuity] || this.discontinuities[discontinuity].accuracy > accuracy) {
                let time;
                if (mediaIndexDiff < 0) time = segment.start - $cb03b711053a4297$var$sumDurations({
                    defaultDuration: playlist.targetDuration,
                    durationList: playlist.segments,
                    startIndex: segmentInfo.mediaIndex,
                    endIndex: segmentIndex
                });
                else time = segment.end + $cb03b711053a4297$var$sumDurations({
                    defaultDuration: playlist.targetDuration,
                    durationList: playlist.segments,
                    startIndex: segmentInfo.mediaIndex + 1,
                    endIndex: segmentIndex
                });
                this.discontinuities[discontinuity] = {
                    time: time,
                    accuracy: accuracy
                };
            }
        }
    }
    dispose() {
        this.trigger('dispose');
        this.off();
    }
}
/**
 * The TimelineChangeController acts as a source for segment loaders to listen for and
 * keep track of latest and pending timeline changes. This is useful to ensure proper
 * sync, as each loader may need to make a consideration for what timeline the other
 * loader is on before making changes which could impact the other loader's media.
 *
 * @class TimelineChangeController
 * @extends videojs.EventTarget
 */ class $cb03b711053a4297$var$TimelineChangeController extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(){
        super();
        this.pendingTimelineChanges_ = {};
        this.lastTimelineChanges_ = {};
    }
    clearPendingTimelineChange(type) {
        this.pendingTimelineChanges_[type] = null;
        this.trigger('pendingtimelinechange');
    }
    pendingTimelineChange({ type: type, from: from, to: to }) {
        if (typeof from === 'number' && typeof to === 'number') {
            this.pendingTimelineChanges_[type] = {
                type: type,
                from: from,
                to: to
            };
            this.trigger('pendingtimelinechange');
        }
        return this.pendingTimelineChanges_[type];
    }
    lastTimelineChange({ type: type, from: from, to: to }) {
        if (typeof from === 'number' && typeof to === 'number') {
            this.lastTimelineChanges_[type] = {
                type: type,
                from: from,
                to: to
            };
            delete this.pendingTimelineChanges_[type];
            const metadata = {
                timelineChangeInfo: {
                    from: from,
                    to: to
                }
            };
            this.trigger({
                type: 'timelinechange',
                metadata: metadata
            });
        }
        return this.lastTimelineChanges_[type];
    }
    dispose() {
        this.trigger('dispose');
        this.pendingTimelineChanges_ = {};
        this.lastTimelineChanges_ = {};
        this.off();
    }
}
/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */ const $cb03b711053a4297$var$workerCode = $cb03b711053a4297$var$transform($cb03b711053a4297$var$getWorkerString(function() {
    /**
   * @file stream.js
   */ /**
   * A lightweight readable stream implemention that handles event dispatching.
   *
   * @class Stream
   */ var Stream = /*#__PURE__*/ function() {
        function Stream() {
            this.listeners = {};
        }
        /**
     * Add a listener for a specified event type.
     *
     * @param {string} type the event name
     * @param {Function} listener the callback to be invoked when an event of
     * the specified type occurs
     */ var _proto = Stream.prototype;
        _proto.on = function on(type, listener) {
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push(listener);
        };
        _proto.off = function off(type, listener) {
            if (!this.listeners[type]) return false;
            var index = this.listeners[type].indexOf(listener); // TODO: which is better?
            // In Video.js we slice listener functions
            // on trigger so that it does not mess up the order
            // while we loop through.
            //
            // Here we slice on off so that the loop in trigger
            // can continue using it's old reference to loop without
            // messing up the order.
            this.listeners[type] = this.listeners[type].slice(0);
            this.listeners[type].splice(index, 1);
            return index > -1;
        };
        _proto.trigger = function trigger(type) {
            var callbacks = this.listeners[type];
            if (!callbacks) return;
             // Slicing the arguments on every invocation of this method
            // can add a significant amount of overhead. Avoid the
            // intermediate object creation for the common case of a
            // single callback argument
            if (arguments.length === 2) {
                var length = callbacks.length;
                for(var i = 0; i < length; ++i)callbacks[i].call(this, arguments[1]);
            } else {
                var args = Array.prototype.slice.call(arguments, 1);
                var _length = callbacks.length;
                for(var _i = 0; _i < _length; ++_i)callbacks[_i].apply(this, args);
            }
        };
        _proto.dispose = function dispose() {
            this.listeners = {};
        };
        _proto.pipe = function pipe(destination) {
            this.on('data', function(data) {
                destination.push(data);
            });
        };
        return Stream;
    }();
    /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */ /**
   * Returns the subarray of a Uint8Array without PKCS#7 padding.
   *
   * @param padded {Uint8Array} unencrypted bytes that have been padded
   * @return {Uint8Array} the unpadded bytes
   * @see http://tools.ietf.org/html/rfc5652
   */ function unpad(padded) {
        return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
    }
    /*! @name aes-decrypter @version 4.0.2 @license Apache-2.0 */ /**
   * @file aes.js
   *
   * This file contains an adaptation of the AES decryption algorithm
   * from the Standford Javascript Cryptography Library. That work is
   * covered by the following copyright and permissions notice:
   *
   * Copyright 2009-2010 Emily Stark, Mike Hamburg, Dan Boneh.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are
   * met:
   *
   * 1. Redistributions of source code must retain the above copyright
   *    notice, this list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above
   *    copyright notice, this list of conditions and the following
   *    disclaimer in the documentation and/or other materials provided
   *    with the distribution.
   *
   * THIS SOFTWARE IS PROVIDED BY THE AUTHORS ``AS IS'' AND ANY EXPRESS OR
   * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
   * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
   * DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> OR CONTRIBUTORS BE
   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
   * BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
   * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
   * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
   * IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   *
   * The views and conclusions contained in the software and documentation
   * are those of the authors and should not be interpreted as representing
   * official policies, either expressed or implied, of the authors.
   */ /**
   * Expand the S-box tables.
   *
   * @private
   */ const precompute = function() {
        const tables = [
            [
                [],
                [],
                [],
                [],
                []
            ],
            [
                [],
                [],
                [],
                [],
                []
            ]
        ];
        const encTable = tables[0];
        const decTable = tables[1];
        const sbox = encTable[4];
        const sboxInv = decTable[4];
        let i;
        let x;
        let xInv;
        const d = [];
        const th = [];
        let x2;
        let x4;
        let x8;
        let s;
        let tEnc;
        let tDec; // Compute double and third tables
        for(i = 0; i < 256; i++)th[(d[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
        for(x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th[xInv] || 1){
            // Compute sbox
            s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
            s = s >> 8 ^ s & 255 ^ 99;
            sbox[x] = s;
            sboxInv[s] = x; // Compute MixColumns
            x8 = d[x4 = d[x2 = d[x]]];
            tDec = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
            tEnc = d[s] * 0x101 ^ s * 0x1010100;
            for(i = 0; i < 4; i++){
                encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
                decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
            }
        } // Compactify. Considerable speedup on Firefox.
        for(i = 0; i < 5; i++){
            encTable[i] = encTable[i].slice(0);
            decTable[i] = decTable[i].slice(0);
        }
        return tables;
    };
    let aesTables = null;
    /**
   * Schedule out an AES key for both encryption and decryption. This
   * is a low-level class. Use a cipher mode to do bulk encryption.
   *
   * @class AES
   * @param key {Array} The key as an array of 4, 6 or 8 words.
   */ class AES {
        constructor(key){
            /**
      * The expanded S-box and inverse S-box tables. These will be computed
      * on the client so that we don't have to send them down the wire.
      *
      * There are two tables, _tables[0] is for encryption and
      * _tables[1] is for decryption.
      *
      * The first 4 sub-tables are the expanded S-box with MixColumns. The
      * last (_tables[01][4]) is the S-box itself.
      *
      * @private
      */ // if we have yet to precompute the S-box tables
            // do so now
            if (!aesTables) aesTables = precompute();
             // then make a copy of that object for use
            this._tables = [
                [
                    aesTables[0][0].slice(),
                    aesTables[0][1].slice(),
                    aesTables[0][2].slice(),
                    aesTables[0][3].slice(),
                    aesTables[0][4].slice()
                ],
                [
                    aesTables[1][0].slice(),
                    aesTables[1][1].slice(),
                    aesTables[1][2].slice(),
                    aesTables[1][3].slice(),
                    aesTables[1][4].slice()
                ]
            ];
            let i;
            let j;
            let tmp;
            const sbox = this._tables[0][4];
            const decTable = this._tables[1];
            const keyLen = key.length;
            let rcon = 1;
            if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) throw new Error('Invalid aes key size');
            const encKey = key.slice(0);
            const decKey = [];
            this._key = [
                encKey,
                decKey
            ]; // schedule encryption keys
            for(i = keyLen; i < 4 * keyLen + 28; i++){
                tmp = encKey[i - 1]; // apply sbox
                if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
                    tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255]; // shift rows and add rcon
                    if (i % keyLen === 0) {
                        tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
                        rcon = rcon << 1 ^ (rcon >> 7) * 283;
                    }
                }
                encKey[i] = encKey[i - keyLen] ^ tmp;
            } // schedule decryption keys
            for(j = 0; i; j++, i--){
                tmp = encKey[j & 3 ? i : i - 4];
                if (i <= 4 || j < 4) decKey[j] = tmp;
                else decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
            }
        }
        /**
     * Decrypt 16 bytes, specified as four 32-bit words.
     *
     * @param {number} encrypted0 the first word to decrypt
     * @param {number} encrypted1 the second word to decrypt
     * @param {number} encrypted2 the third word to decrypt
     * @param {number} encrypted3 the fourth word to decrypt
     * @param {Int32Array} out the array to write the decrypted words
     * into
     * @param {number} offset the offset into the output array to start
     * writing results
     * @return {Array} The plaintext.
     */ decrypt(encrypted0, encrypted1, encrypted2, encrypted3, out, offset) {
            const key = this._key[1]; // state variables a,b,c,d are loaded with pre-whitened data
            let a = encrypted0 ^ key[0];
            let b = encrypted3 ^ key[1];
            let c = encrypted2 ^ key[2];
            let d = encrypted1 ^ key[3];
            let a2;
            let b2;
            let c2; // key.length === 2 ?
            const nInnerRounds = key.length / 4 - 2;
            let i;
            let kIndex = 4;
            const table = this._tables[1]; // load up the tables
            const table0 = table[0];
            const table1 = table[1];
            const table2 = table[2];
            const table3 = table[3];
            const sbox = table[4]; // Inner rounds. Cribbed from OpenSSL.
            for(i = 0; i < nInnerRounds; i++){
                a2 = table0[a >>> 24] ^ table1[b >> 16 & 255] ^ table2[c >> 8 & 255] ^ table3[d & 255] ^ key[kIndex];
                b2 = table0[b >>> 24] ^ table1[c >> 16 & 255] ^ table2[d >> 8 & 255] ^ table3[a & 255] ^ key[kIndex + 1];
                c2 = table0[c >>> 24] ^ table1[d >> 16 & 255] ^ table2[a >> 8 & 255] ^ table3[b & 255] ^ key[kIndex + 2];
                d = table0[d >>> 24] ^ table1[a >> 16 & 255] ^ table2[b >> 8 & 255] ^ table3[c & 255] ^ key[kIndex + 3];
                kIndex += 4;
                a = a2;
                b = b2;
                c = c2;
            } // Last round.
            for(i = 0; i < 4; i++){
                out[(3 & -i) + offset] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d & 255] ^ key[kIndex++];
                a2 = a;
                a = b;
                b = c;
                c = d;
                d = a2;
            }
        }
    }
    /**
   * @file async-stream.js
   */ /**
   * A wrapper around the Stream class to use setTimeout
   * and run stream "jobs" Asynchronously
   *
   * @class AsyncStream
   * @extends Stream
   */ class AsyncStream extends Stream {
        constructor(){
            super(Stream);
            this.jobs = [];
            this.delay = 1;
            this.timeout_ = null;
        }
        /**
     * process an async job
     *
     * @private
     */ processJob_() {
            this.jobs.shift()();
            if (this.jobs.length) this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
            else this.timeout_ = null;
        }
        /**
     * push a job into the stream
     *
     * @param {Function} job the job to push into the stream
     */ push(job) {
            this.jobs.push(job);
            if (!this.timeout_) this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
        }
    }
    /**
   * @file decrypter.js
   *
   * An asynchronous implementation of AES-128 CBC decryption with
   * PKCS#7 padding.
   */ /**
   * Convert network-order (big-endian) bytes into their little-endian
   * representation.
   */ const ntoh = function(word) {
        return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
    };
    /**
   * Decrypt bytes using AES-128 with CBC and PKCS#7 padding.
   *
   * @param {Uint8Array} encrypted the encrypted bytes
   * @param {Uint32Array} key the bytes of the decryption key
   * @param {Uint32Array} initVector the initialization vector (IV) to
   * use for the first round of CBC.
   * @return {Uint8Array} the decrypted bytes
   *
   * @see http://en.wikipedia.org/wiki/Advanced_Encryption_Standard
   * @see http://en.wikipedia.org/wiki/Block_cipher_mode_of_operation#Cipher_Block_Chaining_.28CBC.29
   * @see https://tools.ietf.org/html/rfc2315
   */ const decrypt = function(encrypted, key, initVector) {
        // word-level access to the encrypted bytes
        const encrypted32 = new Int32Array(encrypted.buffer, encrypted.byteOffset, encrypted.byteLength >> 2);
        const decipher = new AES(Array.prototype.slice.call(key)); // byte and word-level access for the decrypted output
        const decrypted = new Uint8Array(encrypted.byteLength);
        const decrypted32 = new Int32Array(decrypted.buffer); // temporary variables for working with the IV, encrypted, and
        // decrypted data
        let init0;
        let init1;
        let init2;
        let init3;
        let encrypted0;
        let encrypted1;
        let encrypted2;
        let encrypted3; // iteration variable
        let wordIx; // pull out the words of the IV to ensure we don't modify the
        // passed-in reference and easier access
        init0 = initVector[0];
        init1 = initVector[1];
        init2 = initVector[2];
        init3 = initVector[3]; // decrypt four word sequences, applying cipher-block chaining (CBC)
        // to each decrypted block
        for(wordIx = 0; wordIx < encrypted32.length; wordIx += 4){
            // convert big-endian (network order) words into little-endian
            // (javascript order)
            encrypted0 = ntoh(encrypted32[wordIx]);
            encrypted1 = ntoh(encrypted32[wordIx + 1]);
            encrypted2 = ntoh(encrypted32[wordIx + 2]);
            encrypted3 = ntoh(encrypted32[wordIx + 3]); // decrypt the block
            decipher.decrypt(encrypted0, encrypted1, encrypted2, encrypted3, decrypted32, wordIx); // XOR with the IV, and restore network byte-order to obtain the
            // plaintext
            decrypted32[wordIx] = ntoh(decrypted32[wordIx] ^ init0);
            decrypted32[wordIx + 1] = ntoh(decrypted32[wordIx + 1] ^ init1);
            decrypted32[wordIx + 2] = ntoh(decrypted32[wordIx + 2] ^ init2);
            decrypted32[wordIx + 3] = ntoh(decrypted32[wordIx + 3] ^ init3); // setup the IV for the next round
            init0 = encrypted0;
            init1 = encrypted1;
            init2 = encrypted2;
            init3 = encrypted3;
        }
        return decrypted;
    };
    /**
   * The `Decrypter` class that manages decryption of AES
   * data through `AsyncStream` objects and the `decrypt`
   * function
   *
   * @param {Uint8Array} encrypted the encrypted bytes
   * @param {Uint32Array} key the bytes of the decryption key
   * @param {Uint32Array} initVector the initialization vector (IV) to
   * @param {Function} done the function to run when done
   * @class Decrypter
   */ class Decrypter {
        constructor(encrypted, key, initVector, done){
            const step = Decrypter.STEP;
            const encrypted32 = new Int32Array(encrypted.buffer);
            const decrypted = new Uint8Array(encrypted.byteLength);
            let i = 0;
            this.asyncStream_ = new AsyncStream(); // split up the encryption job and do the individual chunks asynchronously
            this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
            for(i = step; i < encrypted32.length; i += step){
                initVector = new Uint32Array([
                    ntoh(encrypted32[i - 4]),
                    ntoh(encrypted32[i - 3]),
                    ntoh(encrypted32[i - 2]),
                    ntoh(encrypted32[i - 1])
                ]);
                this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
            } // invoke the done() callback when everything is finished
            this.asyncStream_.push(function() {
                // remove pkcs#7 padding from the decrypted bytes
                done(null, unpad(decrypted));
            });
        }
        /**
     * a getter for step the maximum number of bytes to process at one time
     *
     * @return {number} the value of step 32000
     */ static get STEP() {
            // 4 * 8000;
            return 32000;
        }
        /**
     * @private
     */ decryptChunk_(encrypted, key, initVector, decrypted) {
            return function() {
                const bytes = decrypt(encrypted, key, initVector);
                decrypted.set(bytes, encrypted.byteOffset);
            };
        }
    }
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    var win;
    if (typeof window !== "undefined") win = window;
    else if (typeof commonjsGlobal !== "undefined") win = commonjsGlobal;
    else if (typeof self !== "undefined") win = self;
    else win = {};
    var window_1 = win;
    var isArrayBufferView = function isArrayBufferView(obj) {
        if (ArrayBuffer.isView === 'function') return ArrayBuffer.isView(obj);
        return obj && obj.buffer instanceof ArrayBuffer;
    };
    var BigInt = window_1.BigInt || Number;
    BigInt('0x1'), BigInt('0x100'), BigInt('0x10000'), BigInt('0x1000000'), BigInt('0x100000000'), BigInt('0x10000000000'), BigInt('0x1000000000000'), BigInt('0x100000000000000'), BigInt('0x10000000000000000');
    (function() {
        var a = new Uint16Array([
            0xFFCC
        ]);
        var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
        if (b[0] === 0xFF) return 'big';
        if (b[0] === 0xCC) return 'little';
        return 'unknown';
    })();
    /**
   * Creates an object for sending to a web worker modifying properties that are TypedArrays
   * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
   *
   * @param {Object} message
   *        Object of properties and values to send to the web worker
   * @return {Object}
   *         Modified message with TypedArray values expanded
   * @function createTransferableMessage
   */ const createTransferableMessage = function(message) {
        const transferable = {};
        Object.keys(message).forEach((key)=>{
            const value = message[key];
            if (isArrayBufferView(value)) transferable[key] = {
                bytes: value.buffer,
                byteOffset: value.byteOffset,
                byteLength: value.byteLength
            };
            else transferable[key] = value;
        });
        return transferable;
    };
    /* global self */ /**
   * Our web worker interface so that things can talk to aes-decrypter
   * that will be running in a web worker. the scope is passed to this by
   * webworkify.
   */ self.onmessage = function(event) {
        const data = event.data;
        const encrypted = new Uint8Array(data.encrypted.bytes, data.encrypted.byteOffset, data.encrypted.byteLength);
        const key = new Uint32Array(data.key.bytes, data.key.byteOffset, data.key.byteLength / 4);
        const iv = new Uint32Array(data.iv.bytes, data.iv.byteOffset, data.iv.byteLength / 4);
        /* eslint-disable no-new, handle-callback-err */ new Decrypter(encrypted, key, iv, function(err, bytes) {
            self.postMessage(createTransferableMessage({
                source: data.source,
                decrypted: bytes
            }), [
                bytes.buffer
            ]);
        });
    /* eslint-enable */ };
}));
var $cb03b711053a4297$var$Decrypter = $cb03b711053a4297$var$factory($cb03b711053a4297$var$workerCode);
/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */ /**
 * Convert the properties of an HLS track into an audioTrackKind.
 *
 * @private
 */ const $cb03b711053a4297$var$audioTrackKind_ = (properties)=>{
    let kind = properties.default ? 'main' : 'alternative';
    if (properties.characteristics && properties.characteristics.indexOf('public.accessibility.describes-video') >= 0) kind = 'main-desc';
    return kind;
};
/**
 * Pause provided segment loader and playlist loader if active
 *
 * @param {SegmentLoader} segmentLoader
 *        SegmentLoader to pause
 * @param {Object} mediaType
 *        Active media type
 * @function stopLoaders
 */ const $cb03b711053a4297$var$stopLoaders = (segmentLoader, mediaType)=>{
    segmentLoader.abort();
    segmentLoader.pause();
    if (mediaType && mediaType.activePlaylistLoader) {
        mediaType.activePlaylistLoader.pause();
        mediaType.activePlaylistLoader = null;
    }
};
/**
 * Start loading provided segment loader and playlist loader
 *
 * @param {PlaylistLoader} playlistLoader
 *        PlaylistLoader to start loading
 * @param {Object} mediaType
 *        Active media type
 * @function startLoaders
 */ const $cb03b711053a4297$var$startLoaders = (playlistLoader, mediaType)=>{
    // Segment loader will be started after `loadedmetadata` or `loadedplaylist` from the
    // playlist loader
    mediaType.activePlaylistLoader = playlistLoader;
    playlistLoader.load();
};
/**
 * Returns a function to be called when the media group changes. It performs a
 * non-destructive (preserve the buffer) resync of the SegmentLoader. This is because a
 * change of group is merely a rendition switch of the same content at another encoding,
 * rather than a change of content, such as switching audio from English to Spanish.
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Handler for a non-destructive resync of SegmentLoader when the active media
 *         group changes.
 * @function onGroupChanged
 */ const $cb03b711053a4297$var$onGroupChanged = (type, settings)=>()=>{
        const { segmentLoaders: { [type]: segmentLoader, main: mainSegmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        const activeTrack = mediaType.activeTrack();
        const activeGroup = mediaType.getActiveGroup();
        const previousActiveLoader = mediaType.activePlaylistLoader;
        const lastGroup = mediaType.lastGroup_; // the group did not change do nothing
        if (activeGroup && lastGroup && activeGroup.id === lastGroup.id) return;
        mediaType.lastGroup_ = activeGroup;
        mediaType.lastTrack_ = activeTrack;
        $cb03b711053a4297$var$stopLoaders(segmentLoader, mediaType);
        if (!activeGroup || activeGroup.isMainPlaylist) // there is no group active or active group is a main playlist and won't change
        return;
        if (!activeGroup.playlistLoader) {
            if (previousActiveLoader) // The previous group had a playlist loader but the new active group does not
            // this means we are switching from demuxed to muxed audio. In this case we want to
            // do a destructive reset of the main segment loader and not restart the audio
            // loaders.
            mainSegmentLoader.resetEverything();
            return;
        } // Non-destructive resync
        segmentLoader.resyncLoader();
        $cb03b711053a4297$var$startLoaders(activeGroup.playlistLoader, mediaType);
    };
const $cb03b711053a4297$var$onGroupChanging = (type, settings)=>()=>{
        const { segmentLoaders: { [type]: segmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        mediaType.lastGroup_ = null;
        segmentLoader.abort();
        segmentLoader.pause();
    };
/**
 * Returns a function to be called when the media track changes. It performs a
 * destructive reset of the SegmentLoader to ensure we start loading as close to
 * currentTime as possible.
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Handler for a destructive reset of SegmentLoader when the active media
 *         track changes.
 * @function onTrackChanged
 */ const $cb03b711053a4297$var$onTrackChanged = (type, settings)=>()=>{
        const { mainPlaylistLoader: mainPlaylistLoader, segmentLoaders: { [type]: segmentLoader, main: mainSegmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        const activeTrack = mediaType.activeTrack();
        const activeGroup = mediaType.getActiveGroup();
        const previousActiveLoader = mediaType.activePlaylistLoader;
        const lastTrack = mediaType.lastTrack_; // track did not change, do nothing
        if (lastTrack && activeTrack && lastTrack.id === activeTrack.id) return;
        mediaType.lastGroup_ = activeGroup;
        mediaType.lastTrack_ = activeTrack;
        $cb03b711053a4297$var$stopLoaders(segmentLoader, mediaType);
        if (!activeGroup) // there is no group active so we do not want to restart loaders
        return;
        if (activeGroup.isMainPlaylist) {
            // track did not change, do nothing
            if (!activeTrack || !lastTrack || activeTrack.id === lastTrack.id) return;
            const pc = settings.vhs.playlistController_;
            const newPlaylist = pc.selectPlaylist(); // media will not change do nothing
            if (pc.media() === newPlaylist) return;
            mediaType.logger_(`track change. Switching main audio from ${lastTrack.id} to ${activeTrack.id}`);
            mainPlaylistLoader.pause();
            mainSegmentLoader.resetEverything();
            pc.fastQualityChange_(newPlaylist);
            return;
        }
        if (type === 'AUDIO') {
            if (!activeGroup.playlistLoader) {
                // when switching from demuxed audio/video to muxed audio/video (noted by no
                // playlist loader for the audio group), we want to do a destructive reset of the
                // main segment loader and not restart the audio loaders
                mainSegmentLoader.setAudio(true); // don't have to worry about disabling the audio of the audio segment loader since
                // it should be stopped
                mainSegmentLoader.resetEverything();
                return;
            } // although the segment loader is an audio segment loader, call the setAudio
            // function to ensure it is prepared to re-append the init segment (or handle other
            // config changes)
            segmentLoader.setAudio(true);
            mainSegmentLoader.setAudio(false);
        }
        if (previousActiveLoader === activeGroup.playlistLoader) {
            // Nothing has actually changed. This can happen because track change events can fire
            // multiple times for a "single" change. One for enabling the new active track, and
            // one for disabling the track that was active
            $cb03b711053a4297$var$startLoaders(activeGroup.playlistLoader, mediaType);
            return;
        }
        if (segmentLoader.track) // For WebVTT, set the new text track in the segmentloader
        segmentLoader.track(activeTrack);
         // destructive reset
        segmentLoader.resetEverything();
        $cb03b711053a4297$var$startLoaders(activeGroup.playlistLoader, mediaType);
    };
const $cb03b711053a4297$var$onError = {
    /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning (or error if the playlist is excluded) to
   *         console and switches back to default audio track.
   * @function onError.AUDIO
   */ AUDIO: (type, settings)=>()=>{
            const { mediaTypes: { [type]: mediaType }, excludePlaylist: excludePlaylist } = settings; // switch back to default audio track
            const activeTrack = mediaType.activeTrack();
            const activeGroup = mediaType.activeGroup();
            const id = (activeGroup.filter((group)=>group.default)[0] || activeGroup[0]).id;
            const defaultTrack = mediaType.tracks[id];
            if (activeTrack === defaultTrack) {
                // Default track encountered an error. All we can do now is exclude the current
                // rendition and hope another will switch audio groups
                excludePlaylist({
                    error: {
                        message: 'Problem encountered loading the default audio track.'
                    }
                });
                return;
            }
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
            for(const trackId in mediaType.tracks)mediaType.tracks[trackId].enabled = mediaType.tracks[trackId] === defaultTrack;
            mediaType.onTrackChanged();
        },
    /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning to console and disables the active subtitle track
   * @function onError.SUBTITLES
   */ SUBTITLES: (type, settings)=>()=>{
            const { mediaTypes: { [type]: mediaType } } = settings;
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track.");
            const track = mediaType.activeTrack();
            if (track) track.mode = 'disabled';
            mediaType.onTrackChanged();
        }
};
const $cb03b711053a4297$var$setupListeners = {
    /**
   * Setup event listeners for audio playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.AUDIO
   */ AUDIO: (type, playlistLoader, settings)=>{
        if (!playlistLoader) // no playlist loader means audio will be muxed with the video
        return;
        const { tech: tech, requestOptions: requestOptions, segmentLoaders: { [type]: segmentLoader } } = settings;
        playlistLoader.on('loadedmetadata', ()=>{
            const media = playlistLoader.media();
            segmentLoader.playlist(media, requestOptions); // if the video is already playing, or if this isn't a live video and preload
            // permits, start downloading segments
            if (!tech.paused() || media.endList && tech.preload() !== 'none') segmentLoader.load();
        });
        playlistLoader.on('loadedplaylist', ()=>{
            segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
            if (!tech.paused()) segmentLoader.load();
        });
        playlistLoader.on('error', $cb03b711053a4297$var$onError[type](type, settings));
    },
    /**
   * Setup event listeners for subtitle playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.SUBTITLES
   */ SUBTITLES: (type, playlistLoader, settings)=>{
        const { tech: tech, requestOptions: requestOptions, segmentLoaders: { [type]: segmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        playlistLoader.on('loadedmetadata', ()=>{
            const media = playlistLoader.media();
            segmentLoader.playlist(media, requestOptions);
            segmentLoader.track(mediaType.activeTrack()); // if the video is already playing, or if this isn't a live video and preload
            // permits, start downloading segments
            if (!tech.paused() || media.endList && tech.preload() !== 'none') segmentLoader.load();
        });
        playlistLoader.on('loadedplaylist', ()=>{
            segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
            if (!tech.paused()) segmentLoader.load();
        });
        playlistLoader.on('error', $cb03b711053a4297$var$onError[type](type, settings));
    }
};
const $cb03b711053a4297$var$initialize = {
    /**
   * Setup PlaylistLoaders and AudioTracks for the audio groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.AUDIO
   */ 'AUDIO': (type, settings)=>{
        const { vhs: vhs, sourceType: sourceType, segmentLoaders: { [type]: segmentLoader }, requestOptions: requestOptions, main: { mediaGroups: mediaGroups }, mediaTypes: { [type]: { groups: groups, tracks: tracks, logger_: logger_ } }, mainPlaylistLoader: mainPlaylistLoader } = settings;
        const audioOnlyMain = $cb03b711053a4297$var$isAudioOnly(mainPlaylistLoader.main); // force a default if we have none
        if (!mediaGroups[type] || Object.keys(mediaGroups[type]).length === 0) {
            mediaGroups[type] = {
                main: {
                    default: {
                        default: true
                    }
                }
            };
            if (audioOnlyMain) mediaGroups[type].main.default.playlists = mainPlaylistLoader.main.playlists;
        }
        for(const groupId in mediaGroups[type]){
            if (!groups[groupId]) groups[groupId] = [];
            for(const variantLabel in mediaGroups[type][groupId]){
                let properties = mediaGroups[type][groupId][variantLabel];
                let playlistLoader;
                if (audioOnlyMain) {
                    logger_(`AUDIO group '${groupId}' label '${variantLabel}' is a main playlist`);
                    properties.isMainPlaylist = true;
                    playlistLoader = null; // if vhs-json was provided as the source, and the media playlist was resolved,
                // use the resolved media playlist object
                } else if (sourceType === 'vhs-json' && properties.playlists) playlistLoader = new $cb03b711053a4297$var$PlaylistLoader(properties.playlists[0], vhs, requestOptions);
                else if (properties.resolvedUri) playlistLoader = new $cb03b711053a4297$var$PlaylistLoader(properties.resolvedUri, vhs, requestOptions); // TODO: dash isn't the only type with properties.playlists
                else if (properties.playlists && sourceType === 'dash') playlistLoader = new $cb03b711053a4297$var$DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, mainPlaylistLoader);
                else // no resolvedUri means the audio is muxed with the video when using this
                // audio track
                playlistLoader = null;
                properties = $cb03b711053a4297$var$merge({
                    id: variantLabel,
                    playlistLoader: playlistLoader
                }, properties);
                $cb03b711053a4297$var$setupListeners[type](type, properties.playlistLoader, settings);
                groups[groupId].push(properties);
                if (typeof tracks[variantLabel] === 'undefined') {
                    const track = new $cb03b711053a4297$export$2e2bcd8739ae039.AudioTrack({
                        id: variantLabel,
                        kind: $cb03b711053a4297$var$audioTrackKind_(properties),
                        enabled: false,
                        language: properties.language,
                        default: properties.default,
                        label: variantLabel
                    });
                    tracks[variantLabel] = track;
                }
            }
        } // setup single error event handler for the segment loader
        segmentLoader.on('error', $cb03b711053a4297$var$onError[type](type, settings));
    },
    /**
   * Setup PlaylistLoaders and TextTracks for the subtitle groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.SUBTITLES
   */ 'SUBTITLES': (type, settings)=>{
        const { tech: tech, vhs: vhs, sourceType: sourceType, segmentLoaders: { [type]: segmentLoader }, requestOptions: requestOptions, main: { mediaGroups: mediaGroups }, mediaTypes: { [type]: { groups: groups, tracks: tracks } }, mainPlaylistLoader: mainPlaylistLoader } = settings;
        for(const groupId in mediaGroups[type]){
            if (!groups[groupId]) groups[groupId] = [];
            for(const variantLabel in mediaGroups[type][groupId]){
                if (!vhs.options_.useForcedSubtitles && mediaGroups[type][groupId][variantLabel].forced) continue;
                let properties = mediaGroups[type][groupId][variantLabel];
                let playlistLoader;
                if (sourceType === 'hls') playlistLoader = new $cb03b711053a4297$var$PlaylistLoader(properties.resolvedUri, vhs, requestOptions);
                else if (sourceType === 'dash') {
                    const playlists = properties.playlists.filter((p)=>p.excludeUntil !== Infinity);
                    if (!playlists.length) return;
                    playlistLoader = new $cb03b711053a4297$var$DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, mainPlaylistLoader);
                } else if (sourceType === 'vhs-json') playlistLoader = new $cb03b711053a4297$var$PlaylistLoader(// if the vhs-json object included the media playlist, use the media playlist
                // as provided, otherwise use the resolved URI to load the playlist
                properties.playlists ? properties.playlists[0] : properties.resolvedUri, vhs, requestOptions);
                properties = $cb03b711053a4297$var$merge({
                    id: variantLabel,
                    playlistLoader: playlistLoader
                }, properties);
                $cb03b711053a4297$var$setupListeners[type](type, properties.playlistLoader, settings);
                groups[groupId].push(properties);
                if (typeof tracks[variantLabel] === 'undefined') {
                    const track = tech.addRemoteTextTrack({
                        id: variantLabel,
                        kind: 'subtitles',
                        default: properties.default && properties.autoselect,
                        language: properties.language,
                        label: variantLabel
                    }, false).track;
                    tracks[variantLabel] = track;
                }
            }
        } // setup single error event handler for the segment loader
        segmentLoader.on('error', $cb03b711053a4297$var$onError[type](type, settings));
    },
    /**
   * Setup TextTracks for the closed-caption groups
   *
   * @param {String} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize['CLOSED-CAPTIONS']
   */ 'CLOSED-CAPTIONS': (type, settings)=>{
        const { tech: tech, main: { mediaGroups: mediaGroups }, mediaTypes: { [type]: { groups: groups, tracks: tracks } } } = settings;
        for(const groupId in mediaGroups[type]){
            if (!groups[groupId]) groups[groupId] = [];
            for(const variantLabel in mediaGroups[type][groupId]){
                const properties = mediaGroups[type][groupId][variantLabel]; // Look for either 608 (CCn) or 708 (SERVICEn) caption services
                if (!/^(?:CC|SERVICE)/.test(properties.instreamId)) continue;
                const captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
                let newProps = {
                    label: variantLabel,
                    language: properties.language,
                    instreamId: properties.instreamId,
                    default: properties.default && properties.autoselect
                };
                if (captionServices[newProps.instreamId]) newProps = $cb03b711053a4297$var$merge(newProps, captionServices[newProps.instreamId]);
                if (newProps.default === undefined) delete newProps.default;
                 // No PlaylistLoader is required for Closed-Captions because the captions are
                // embedded within the video stream
                groups[groupId].push($cb03b711053a4297$var$merge({
                    id: variantLabel
                }, properties));
                if (typeof tracks[variantLabel] === 'undefined') {
                    const track = tech.addRemoteTextTrack({
                        id: newProps.instreamId,
                        kind: 'captions',
                        default: newProps.default,
                        language: newProps.language,
                        label: newProps.label
                    }, false).track;
                    tracks[variantLabel] = track;
                }
            }
        }
    }
};
const $cb03b711053a4297$var$groupMatch = (list, media)=>{
    for(let i = 0; i < list.length; i++){
        if ($cb03b711053a4297$var$playlistMatch(media, list[i])) return true;
        if (list[i].playlists && $cb03b711053a4297$var$groupMatch(list[i].playlists, media)) return true;
    }
    return false;
};
/**
 * Returns a function used to get the active group of the provided type
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Function that returns the active media group for the provided type. Takes an
 *         optional parameter {TextTrack} track. If no track is provided, a list of all
 *         variants in the group, otherwise the variant corresponding to the provided
 *         track is returned.
 * @function activeGroup
 */ const $cb03b711053a4297$var$activeGroup = (type, settings)=>(track)=>{
        const { mainPlaylistLoader: mainPlaylistLoader, mediaTypes: { [type]: { groups: groups } } } = settings;
        const media = mainPlaylistLoader.media();
        if (!media) return null;
        let variants = null; // set to variants to main media active group
        if (media.attributes[type]) variants = groups[media.attributes[type]];
        const groupKeys = Object.keys(groups);
        if (!variants) {
            // find the mainPlaylistLoader media
            // that is in a media group if we are dealing
            // with audio only
            if (type === 'AUDIO' && groupKeys.length > 1 && $cb03b711053a4297$var$isAudioOnly(settings.main)) for(let i = 0; i < groupKeys.length; i++){
                const groupPropertyList = groups[groupKeys[i]];
                if ($cb03b711053a4297$var$groupMatch(groupPropertyList, media)) {
                    variants = groupPropertyList;
                    break;
                }
            } // use the main group if it exists
            else if (groups.main) variants = groups.main; // only one group, use that one
            else if (groupKeys.length === 1) variants = groups[groupKeys[0]];
        }
        if (typeof track === 'undefined') return variants;
        if (track === null || !variants) // An active track was specified so a corresponding group is expected. track === null
        // means no track is currently active so there is no corresponding group
        return null;
        return variants.filter((props)=>props.id === track.id)[0] || null;
    };
const $cb03b711053a4297$var$activeTrack = {
    /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.AUDIO
   */ AUDIO: (type, settings)=>()=>{
            const { mediaTypes: { [type]: { tracks: tracks } } } = settings;
            for(const id in tracks){
                if (tracks[id].enabled) return tracks[id];
            }
            return null;
        },
    /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.SUBTITLES
   */ SUBTITLES: (type, settings)=>()=>{
            const { mediaTypes: { [type]: { tracks: tracks } } } = settings;
            for(const id in tracks){
                if (tracks[id].mode === 'showing' || tracks[id].mode === 'hidden') return tracks[id];
            }
            return null;
        }
};
const $cb03b711053a4297$var$getActiveGroup = (type, { mediaTypes: mediaTypes })=>()=>{
        const activeTrack_ = mediaTypes[type].activeTrack();
        if (!activeTrack_) return null;
        return mediaTypes[type].activeGroup(activeTrack_);
    };
/**
 * Setup PlaylistLoaders and Tracks for media groups (Audio, Subtitles,
 * Closed-Captions) specified in the main manifest.
 *
 * @param {Object} settings
 *        Object containing required information for setting up the media groups
 * @param {Tech} settings.tech
 *        The tech of the player
 * @param {Object} settings.requestOptions
 *        XHR request options used by the segment loaders
 * @param {PlaylistLoader} settings.mainPlaylistLoader
 *        PlaylistLoader for the main source
 * @param {VhsHandler} settings.vhs
 *        VHS SourceHandler
 * @param {Object} settings.main
 *        The parsed main manifest
 * @param {Object} settings.mediaTypes
 *        Object to store the loaders, tracks, and utility methods for each media type
 * @param {Function} settings.excludePlaylist
 *        Excludes the current rendition and forces a rendition switch.
 * @function setupMediaGroups
 */ const $cb03b711053a4297$var$setupMediaGroups = (settings)=>{
    [
        'AUDIO',
        'SUBTITLES',
        'CLOSED-CAPTIONS'
    ].forEach((type)=>{
        $cb03b711053a4297$var$initialize[type](type, settings);
    });
    const { mediaTypes: mediaTypes, mainPlaylistLoader: mainPlaylistLoader, tech: tech, vhs: vhs, segmentLoaders: { ['AUDIO']: audioSegmentLoader, main: mainSegmentLoader } } = settings; // setup active group and track getters and change event handlers
    [
        'AUDIO',
        'SUBTITLES'
    ].forEach((type)=>{
        mediaTypes[type].activeGroup = $cb03b711053a4297$var$activeGroup(type, settings);
        mediaTypes[type].activeTrack = $cb03b711053a4297$var$activeTrack[type](type, settings);
        mediaTypes[type].onGroupChanged = $cb03b711053a4297$var$onGroupChanged(type, settings);
        mediaTypes[type].onGroupChanging = $cb03b711053a4297$var$onGroupChanging(type, settings);
        mediaTypes[type].onTrackChanged = $cb03b711053a4297$var$onTrackChanged(type, settings);
        mediaTypes[type].getActiveGroup = $cb03b711053a4297$var$getActiveGroup(type, settings);
    }); // DO NOT enable the default subtitle or caption track.
    // DO enable the default audio track
    const audioGroup = mediaTypes.AUDIO.activeGroup();
    if (audioGroup) {
        const groupId = (audioGroup.filter((group)=>group.default)[0] || audioGroup[0]).id;
        mediaTypes.AUDIO.tracks[groupId].enabled = true;
        mediaTypes.AUDIO.onGroupChanged();
        mediaTypes.AUDIO.onTrackChanged();
        const activeAudioGroup = mediaTypes.AUDIO.getActiveGroup(); // a similar check for handling setAudio on each loader is run again each time the
        // track is changed, but needs to be handled here since the track may not be considered
        // changed on the first call to onTrackChanged
        if (!activeAudioGroup.playlistLoader) // either audio is muxed with video or the stream is audio only
        mainSegmentLoader.setAudio(true);
        else {
            // audio is demuxed
            mainSegmentLoader.setAudio(false);
            audioSegmentLoader.setAudio(true);
        }
    }
    mainPlaylistLoader.on('mediachange', ()=>{
        [
            'AUDIO',
            'SUBTITLES'
        ].forEach((type)=>mediaTypes[type].onGroupChanged());
    });
    mainPlaylistLoader.on('mediachanging', ()=>{
        [
            'AUDIO',
            'SUBTITLES'
        ].forEach((type)=>mediaTypes[type].onGroupChanging());
    }); // custom audio track change event handler for usage event
    const onAudioTrackChanged = ()=>{
        mediaTypes.AUDIO.onTrackChanged();
        tech.trigger({
            type: 'usage',
            name: 'vhs-audio-change'
        });
    };
    tech.audioTracks().addEventListener('change', onAudioTrackChanged);
    tech.remoteTextTracks().addEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
    vhs.on('dispose', ()=>{
        tech.audioTracks().removeEventListener('change', onAudioTrackChanged);
        tech.remoteTextTracks().removeEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
    }); // clear existing audio tracks and add the ones we just created
    tech.clearTracks('audio');
    for(const id in mediaTypes.AUDIO.tracks)tech.audioTracks().addTrack(mediaTypes.AUDIO.tracks[id]);
};
/**
 * Creates skeleton object used to store the loaders, tracks, and utility methods for each
 * media type
 *
 * @return {Object}
 *         Object to store the loaders, tracks, and utility methods for each media type
 * @function createMediaTypes
 */ const $cb03b711053a4297$var$createMediaTypes = ()=>{
    const mediaTypes = {};
    [
        'AUDIO',
        'SUBTITLES',
        'CLOSED-CAPTIONS'
    ].forEach((type)=>{
        mediaTypes[type] = {
            groups: {},
            tracks: {},
            activePlaylistLoader: null,
            activeGroup: $cb03b711053a4297$var$noop,
            activeTrack: $cb03b711053a4297$var$noop,
            getActiveGroup: $cb03b711053a4297$var$noop,
            onGroupChanged: $cb03b711053a4297$var$noop,
            onTrackChanged: $cb03b711053a4297$var$noop,
            lastTrack_: null,
            logger_: $cb03b711053a4297$var$logger(`MediaGroups[${type}]`)
        };
    });
    return mediaTypes;
};
/**
 * A utility class for setting properties and maintaining the state of the content steering manifest.
 *
 * Content Steering manifest format:
 * VERSION: number (required) currently only version 1 is supported.
 * TTL: number in seconds (optional) until the next content steering manifest reload.
 * RELOAD-URI: string (optional) uri to fetch the next content steering manifest.
 * SERVICE-LOCATION-PRIORITY or PATHWAY-PRIORITY a non empty array of unique string values.
 * PATHWAY-CLONES: array (optional) (HLS only) pathway clone objects to copy from other playlists.
 */ class $cb03b711053a4297$var$SteeringManifest {
    constructor(){
        this.priority_ = [];
        this.pathwayClones_ = new Map();
    }
    set version(number) {
        // Only version 1 is currently supported for both DASH and HLS.
        if (number === 1) this.version_ = number;
    }
    set ttl(seconds) {
        // TTL = time-to-live, default = 300 seconds.
        this.ttl_ = seconds || 300;
    }
    set reloadUri(uri) {
        if (uri) // reload URI can be relative to the previous reloadUri.
        this.reloadUri_ = $cb03b711053a4297$var$resolveUrl(this.reloadUri_, uri);
    }
    set priority(array) {
        // priority must be non-empty and unique values.
        if (array && array.length) this.priority_ = array;
    }
    set pathwayClones(array) {
        // pathwayClones must be non-empty.
        if (array && array.length) this.pathwayClones_ = new Map(array.map((clone)=>[
                clone.ID,
                clone
            ]));
    }
    get version() {
        return this.version_;
    }
    get ttl() {
        return this.ttl_;
    }
    get reloadUri() {
        return this.reloadUri_;
    }
    get priority() {
        return this.priority_;
    }
    get pathwayClones() {
        return this.pathwayClones_;
    }
}
/**
 * This class represents a content steering manifest and associated state. See both HLS and DASH specifications.
 * HLS: https://developer.apple.com/streaming/HLSContentSteeringSpecification.pdf and
 * https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/ section 4.4.6.6.
 * DASH: https://dashif.org/docs/DASH-IF-CTS-00XX-Content-Steering-Community-Review.pdf
 *
 * @param {function} xhr for making a network request from the browser.
 * @param {function} bandwidth for fetching the current bandwidth from the main segment loader.
 */ class $cb03b711053a4297$var$ContentSteeringController extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(xhr, bandwidth){
        super();
        this.currentPathway = null;
        this.defaultPathway = null;
        this.queryBeforeStart = false;
        this.availablePathways_ = new Set();
        this.steeringManifest = new $cb03b711053a4297$var$SteeringManifest();
        this.proxyServerUrl_ = null;
        this.manifestType_ = null;
        this.ttlTimeout_ = null;
        this.request_ = null;
        this.currentPathwayClones = new Map();
        this.nextPathwayClones = new Map();
        this.excludedSteeringManifestURLs = new Set();
        this.logger_ = $cb03b711053a4297$var$logger('Content Steering');
        this.xhr_ = xhr;
        this.getBandwidth_ = bandwidth;
    }
    /**
   * Assigns the content steering tag properties to the steering controller
   *
   * @param {string} baseUrl the baseURL from the main manifest for resolving the steering manifest url
   * @param {Object} steeringTag the content steering tag from the main manifest
   */ assignTagProperties(baseUrl, steeringTag) {
        this.manifestType_ = steeringTag.serverUri ? 'HLS' : 'DASH'; // serverUri is HLS serverURL is DASH
        const steeringUri = steeringTag.serverUri || steeringTag.serverURL;
        if (!steeringUri) {
            this.logger_(`steering manifest URL is ${steeringUri}, cannot request steering manifest.`);
            this.trigger('error');
            return;
        } // Content steering manifests can be encoded as a data URI. We can decode, parse and return early if that's the case.
        if (steeringUri.startsWith('data:')) {
            this.decodeDataUriManifest_(steeringUri.substring(steeringUri.indexOf(',') + 1));
            return;
        } // reloadUri is the resolution of the main manifest URL and steering URL.
        this.steeringManifest.reloadUri = $cb03b711053a4297$var$resolveUrl(baseUrl, steeringUri); // pathwayId is HLS defaultServiceLocation is DASH
        this.defaultPathway = steeringTag.pathwayId || steeringTag.defaultServiceLocation; // currently only DASH supports the following properties on <ContentSteering> tags.
        this.queryBeforeStart = steeringTag.queryBeforeStart;
        this.proxyServerUrl_ = steeringTag.proxyServerURL; // trigger a steering event if we have a pathway from the content steering tag.
        // this tells VHS which segment pathway to start with.
        // If queryBeforeStart is true we need to wait for the steering manifest response.
        if (this.defaultPathway && !this.queryBeforeStart) this.trigger('content-steering');
    }
    /**
   * Requests the content steering manifest and parse the response. This should only be called after
   * assignTagProperties was called with a content steering tag.
   *
   * @param {string} initialUri The optional uri to make the request with.
   *    If set, the request should be made with exactly what is passed in this variable.
   *    This scenario should only happen once on initalization.
   */ requestSteeringManifest(initial) {
        const reloadUri = this.steeringManifest.reloadUri;
        if (!reloadUri) return;
         // We currently don't support passing MPD query parameters directly to the content steering URL as this requires
        // ExtUrlQueryInfo tag support. See the DASH content steering spec section 8.1.
        // This request URI accounts for manifest URIs that have been excluded.
        const uri = initial ? reloadUri : this.getRequestURI(reloadUri); // If there are no valid manifest URIs, we should stop content steering.
        if (!uri) {
            this.logger_('No valid content steering manifest URIs. Stopping content steering.');
            this.trigger('error');
            this.dispose();
            return;
        }
        const metadata = {
            contentSteeringInfo: {
                uri: uri
            }
        };
        this.trigger({
            type: 'contentsteeringloadstart',
            metadata: metadata
        });
        this.request_ = this.xhr_({
            uri: uri,
            requestType: 'content-steering-manifest'
        }, (error, errorInfo)=>{
            if (error) {
                // If the client receives HTTP 410 Gone in response to a manifest request,
                // it MUST NOT issue another request for that URI for the remainder of the
                // playback session. It MAY continue to use the most-recently obtained set
                // of Pathways.
                if (errorInfo.status === 410) {
                    this.logger_(`manifest request 410 ${error}.`);
                    this.logger_(`There will be no more content steering requests to ${uri} this session.`);
                    this.excludedSteeringManifestURLs.add(uri);
                    return;
                } // If the client receives HTTP 429 Too Many Requests with a Retry-After
                // header in response to a manifest request, it SHOULD wait until the time
                // specified by the Retry-After header to reissue the request.
                if (errorInfo.status === 429) {
                    const retrySeconds = errorInfo.responseHeaders['retry-after'];
                    this.logger_(`manifest request 429 ${error}.`);
                    this.logger_(`content steering will retry in ${retrySeconds} seconds.`);
                    this.startTTLTimeout_(parseInt(retrySeconds, 10));
                    return;
                } // If the Steering Manifest cannot be loaded and parsed correctly, the
                // client SHOULD continue to use the previous values and attempt to reload
                // it after waiting for the previously-specified TTL (or 5 minutes if
                // none).
                this.logger_(`manifest failed to load ${error}.`);
                this.startTTLTimeout_();
                return;
            }
            this.trigger({
                type: 'contentsteeringloadcomplete',
                metadata: metadata
            });
            let steeringManifestJson;
            try {
                steeringManifestJson = JSON.parse(this.request_.responseText);
            } catch (parseError) {
                const errorMetadata = {
                    errorType: $cb03b711053a4297$export$2e2bcd8739ae039.Error.StreamingContentSteeringParserError,
                    error: parseError
                };
                this.trigger({
                    type: 'error',
                    metadata: errorMetadata
                });
            }
            this.assignSteeringProperties_(steeringManifestJson);
            const parsedMetadata = {
                contentSteeringInfo: metadata.contentSteeringInfo,
                contentSteeringManifest: {
                    version: this.steeringManifest.version,
                    reloadUri: this.steeringManifest.reloadUri,
                    priority: this.steeringManifest.priority
                }
            };
            this.trigger({
                type: 'contentsteeringparsed',
                metadata: parsedMetadata
            });
            this.startTTLTimeout_();
        });
    }
    /**
   * Set the proxy server URL and add the steering manifest url as a URI encoded parameter.
   *
   * @param {string} steeringUrl the steering manifest url
   * @return the steering manifest url to a proxy server with all parameters set
   */ setProxyServerUrl_(steeringUrl) {
        const steeringUrlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL(steeringUrl);
        const proxyServerUrlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL(this.proxyServerUrl_);
        proxyServerUrlObject.searchParams.set('url', encodeURI(steeringUrlObject.toString()));
        return this.setSteeringParams_(proxyServerUrlObject.toString());
    }
    /**
   * Decodes and parses the data uri encoded steering manifest
   *
   * @param {string} dataUri the data uri to be decoded and parsed.
   */ decodeDataUriManifest_(dataUri) {
        const steeringManifestJson = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).atob(dataUri));
        this.assignSteeringProperties_(steeringManifestJson);
    }
    /**
   * Set the HLS or DASH content steering manifest request query parameters. For example:
   * _HLS_pathway="<CURRENT-PATHWAY-ID>" and _HLS_throughput=<THROUGHPUT>
   * _DASH_pathway and _DASH_throughput
   *
   * @param {string} uri to add content steering server parameters to.
   * @return a new uri as a string with the added steering query parameters.
   */ setSteeringParams_(url) {
        const urlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL(url);
        const path = this.getPathway();
        const networkThroughput = this.getBandwidth_();
        if (path) {
            const pathwayKey = `_${this.manifestType_}_pathway`;
            urlObject.searchParams.set(pathwayKey, path);
        }
        if (networkThroughput) {
            const throughputKey = `_${this.manifestType_}_throughput`;
            urlObject.searchParams.set(throughputKey, networkThroughput);
        }
        return urlObject.toString();
    }
    /**
   * Assigns the current steering manifest properties and to the SteeringManifest object
   *
   * @param {Object} steeringJson the raw JSON steering manifest
   */ assignSteeringProperties_(steeringJson) {
        this.steeringManifest.version = steeringJson.VERSION;
        if (!this.steeringManifest.version) {
            this.logger_(`manifest version is ${steeringJson.VERSION}, which is not supported.`);
            this.trigger('error');
            return;
        }
        this.steeringManifest.ttl = steeringJson.TTL;
        this.steeringManifest.reloadUri = steeringJson['RELOAD-URI']; // HLS = PATHWAY-PRIORITY required. DASH = SERVICE-LOCATION-PRIORITY optional
        this.steeringManifest.priority = steeringJson['PATHWAY-PRIORITY'] || steeringJson['SERVICE-LOCATION-PRIORITY']; // Pathway clones to be created/updated in HLS.
        // See section 7.2 https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/
        this.steeringManifest.pathwayClones = steeringJson['PATHWAY-CLONES'];
        this.nextPathwayClones = this.steeringManifest.pathwayClones; // 1. apply first pathway from the array.
        // 2. if first pathway doesn't exist in manifest, try next pathway.
        //    a. if all pathways are exhausted, ignore the steering manifest priority.
        // 3. if segments fail from an established pathway, try all variants/renditions, then exclude the failed pathway.
        //    a. exclude a pathway for a minimum of the last TTL duration. Meaning, from the next steering response,
        //       the excluded pathway will be ignored.
        //       See excludePathway usage in excludePlaylist().
        // If there are no available pathways, we need to stop content steering.
        if (!this.availablePathways_.size) {
            this.logger_('There are no available pathways for content steering. Ending content steering.');
            this.trigger('error');
            this.dispose();
        }
        const chooseNextPathway = (pathwaysByPriority)=>{
            for (const path of pathwaysByPriority){
                if (this.availablePathways_.has(path)) return path;
            } // If no pathway matches, ignore the manifest and choose the first available.
            return [
                ...this.availablePathways_
            ][0];
        };
        const nextPathway = chooseNextPathway(this.steeringManifest.priority);
        if (this.currentPathway !== nextPathway) {
            this.currentPathway = nextPathway;
            this.trigger('content-steering');
        }
    }
    /**
   * Returns the pathway to use for steering decisions
   *
   * @return {string} returns the current pathway or the default
   */ getPathway() {
        return this.currentPathway || this.defaultPathway;
    }
    /**
   * Chooses the manifest request URI based on proxy URIs and server URLs.
   * Also accounts for exclusion on certain manifest URIs.
   *
   * @param {string} reloadUri the base uri before parameters
   *
   * @return {string} the final URI for the request to the manifest server.
   */ getRequestURI(reloadUri) {
        if (!reloadUri) return null;
        const isExcluded = (uri)=>this.excludedSteeringManifestURLs.has(uri);
        if (this.proxyServerUrl_) {
            const proxyURI = this.setProxyServerUrl_(reloadUri);
            if (!isExcluded(proxyURI)) return proxyURI;
        }
        const steeringURI = this.setSteeringParams_(reloadUri);
        if (!isExcluded(steeringURI)) return steeringURI;
         // Return nothing if all valid manifest URIs are excluded.
        return null;
    }
    /**
   * Start the timeout for re-requesting the steering manifest at the TTL interval.
   *
   * @param {number} ttl time in seconds of the timeout. Defaults to the
   *        ttl interval in the steering manifest
   */ startTTLTimeout_(ttl = this.steeringManifest.ttl) {
        // 300 (5 minutes) is the default value.
        const ttlMS = ttl * 1000;
        this.ttlTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            this.requestSteeringManifest();
        }, ttlMS);
    }
    /**
   * Clear the TTL timeout if necessary.
   */ clearTTLTimeout_() {
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.ttlTimeout_);
        this.ttlTimeout_ = null;
    }
    /**
   * aborts any current steering xhr and sets the current request object to null
   */ abort() {
        if (this.request_) this.request_.abort();
        this.request_ = null;
    }
    /**
   * aborts steering requests clears the ttl timeout and resets all properties.
   */ dispose() {
        this.off('content-steering');
        this.off('error');
        this.abort();
        this.clearTTLTimeout_();
        this.currentPathway = null;
        this.defaultPathway = null;
        this.queryBeforeStart = null;
        this.proxyServerUrl_ = null;
        this.manifestType_ = null;
        this.ttlTimeout_ = null;
        this.request_ = null;
        this.excludedSteeringManifestURLs = new Set();
        this.availablePathways_ = new Set();
        this.steeringManifest = new $cb03b711053a4297$var$SteeringManifest();
    }
    /**
   * adds a pathway to the available pathways set
   *
   * @param {string} pathway the pathway string to add
   */ addAvailablePathway(pathway) {
        if (pathway) this.availablePathways_.add(pathway);
    }
    /**
   * Clears all pathways from the available pathways set
   */ clearAvailablePathways() {
        this.availablePathways_.clear();
    }
    /**
   * Removes a pathway from the available pathways set.
   */ excludePathway(pathway) {
        return this.availablePathways_.delete(pathway);
    }
    /**
   * Checks the refreshed DASH manifest content steering tag for changes.
   *
   * @param {string} baseURL new steering tag on DASH manifest refresh
   * @param {Object} newTag the new tag to check for changes
   * @return a true or false whether the new tag has different values
   */ didDASHTagChange(baseURL, newTag) {
        return !newTag && this.steeringManifest.reloadUri || newTag && ($cb03b711053a4297$var$resolveUrl(baseURL, newTag.serverURL) !== this.steeringManifest.reloadUri || newTag.defaultServiceLocation !== this.defaultPathway || newTag.queryBeforeStart !== this.queryBeforeStart || newTag.proxyServerURL !== this.proxyServerUrl_);
    }
    getAvailablePathways() {
        return this.availablePathways_;
    }
}
const $cb03b711053a4297$var$debounce = (callback, wait)=>{
    let timeoutId = null;
    return (...args)=>{
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            callback.apply(null, args);
        }, wait);
    };
};
const $cb03b711053a4297$var$ABORT_EARLY_EXCLUSION_SECONDS = 10;
let $cb03b711053a4297$var$Vhs$1; // SegmentLoader stats that need to have each loader's
// values summed to calculate the final value
const $cb03b711053a4297$var$loaderStats = [
    'mediaRequests',
    'mediaRequestsAborted',
    'mediaRequestsTimedout',
    'mediaRequestsErrored',
    'mediaTransferDuration',
    'mediaBytesTransferred',
    'mediaAppends'
];
const $cb03b711053a4297$var$sumLoaderStat = function(stat) {
    return this.audioSegmentLoader_[stat] + this.mainSegmentLoader_[stat];
};
const $cb03b711053a4297$var$shouldSwitchToMedia = function({ currentPlaylist: currentPlaylist, buffered: buffered, currentTime: currentTime, nextPlaylist: nextPlaylist, bufferLowWaterLine: bufferLowWaterLine, bufferHighWaterLine: bufferHighWaterLine, duration: duration, bufferBasedABR: bufferBasedABR, log: log }) {
    // we have no other playlist to switch to
    if (!nextPlaylist) {
        $cb03b711053a4297$export$2e2bcd8739ae039.log.warn('We received no playlist to switch to. Please check your stream.');
        return false;
    }
    const sharedLogLine = `allowing switch ${currentPlaylist && currentPlaylist.id || 'null'} -> ${nextPlaylist.id}`;
    if (!currentPlaylist) {
        log(`${sharedLogLine} as current playlist is not set`);
        return true;
    } // no need to switch if playlist is the same
    if (nextPlaylist.id === currentPlaylist.id) return false;
     // determine if current time is in a buffered range.
    const isBuffered = Boolean($cb03b711053a4297$var$findRange(buffered, currentTime).length); // If the playlist is live, then we want to not take low water line into account.
    // This is because in LIVE, the player plays 3 segments from the end of the
    // playlist, and if `BUFFER_LOW_WATER_LINE` is greater than the duration availble
    // in those segments, a viewer will never experience a rendition upswitch.
    if (!currentPlaylist.endList) {
        // For LLHLS live streams, don't switch renditions before playback has started, as it almost
        // doubles the time to first playback.
        if (!isBuffered && typeof currentPlaylist.partTargetDuration === 'number') {
            log(`not ${sharedLogLine} as current playlist is live llhls, but currentTime isn't in buffered.`);
            return false;
        }
        log(`${sharedLogLine} as current playlist is live`);
        return true;
    }
    const forwardBuffer = $cb03b711053a4297$var$timeAheadOf(buffered, currentTime);
    const maxBufferLowWaterLine = bufferBasedABR ? $cb03b711053a4297$var$Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : $cb03b711053a4297$var$Config.MAX_BUFFER_LOW_WATER_LINE; // For the same reason as LIVE, we ignore the low water line when the VOD
    // duration is below the max potential low water line
    if (duration < maxBufferLowWaterLine) {
        log(`${sharedLogLine} as duration < max low water line (${duration} < ${maxBufferLowWaterLine})`);
        return true;
    }
    const nextBandwidth = nextPlaylist.attributes.BANDWIDTH;
    const currBandwidth = currentPlaylist.attributes.BANDWIDTH; // when switching down, if our buffer is lower than the high water line,
    // we can switch down
    if (nextBandwidth < currBandwidth && (!bufferBasedABR || forwardBuffer < bufferHighWaterLine)) {
        let logLine = `${sharedLogLine} as next bandwidth < current bandwidth (${nextBandwidth} < ${currBandwidth})`;
        if (bufferBasedABR) logLine += ` and forwardBuffer < bufferHighWaterLine (${forwardBuffer} < ${bufferHighWaterLine})`;
        log(logLine);
        return true;
    } // and if our buffer is higher than the low water line,
    // we can switch up
    if ((!bufferBasedABR || nextBandwidth > currBandwidth) && forwardBuffer >= bufferLowWaterLine) {
        let logLine = `${sharedLogLine} as forwardBuffer >= bufferLowWaterLine (${forwardBuffer} >= ${bufferLowWaterLine})`;
        if (bufferBasedABR) logLine += ` and next bandwidth > current bandwidth (${nextBandwidth} > ${currBandwidth})`;
        log(logLine);
        return true;
    }
    log(`not ${sharedLogLine} as no switching criteria met`);
    return false;
};
/**
 * the main playlist controller controller all interactons
 * between playlists and segmentloaders. At this time this mainly
 * involves a main playlist and a series of audio playlists
 * if they are available
 *
 * @class PlaylistController
 * @extends videojs.EventTarget
 */ class $cb03b711053a4297$var$PlaylistController extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(options){
        super(); // Adding a slight debounce to avoid duplicate calls during rapid quality changes, for example:
        // When selecting quality from the quality list,
        // where we may have multiple bandwidth profiles for the same vertical resolution.
        this.fastQualityChange_ = $cb03b711053a4297$var$debounce(this.fastQualityChange_.bind(this), 100);
        const { src: src, withCredentials: withCredentials, tech: tech, bandwidth: bandwidth, externVhs: externVhs, useCueTags: useCueTags, playlistExclusionDuration: playlistExclusionDuration, enableLowInitialPlaylist: enableLowInitialPlaylist, sourceType: sourceType, cacheEncryptionKeys: cacheEncryptionKeys, bufferBasedABR: bufferBasedABR, leastPixelDiffSelector: leastPixelDiffSelector, captionServices: captionServices, experimentalUseMMS: experimentalUseMMS } = options;
        if (!src) throw new Error('A non-empty playlist URL or JSON manifest string is required');
        let { maxPlaylistRetries: maxPlaylistRetries } = options;
        if (maxPlaylistRetries === null || typeof maxPlaylistRetries === 'undefined') maxPlaylistRetries = Infinity;
        $cb03b711053a4297$var$Vhs$1 = externVhs;
        this.bufferBasedABR = Boolean(bufferBasedABR);
        this.leastPixelDiffSelector = Boolean(leastPixelDiffSelector);
        this.withCredentials = withCredentials;
        this.tech_ = tech;
        this.vhs_ = tech.vhs;
        this.player_ = options.player_;
        this.sourceType_ = sourceType;
        this.useCueTags_ = useCueTags;
        this.playlistExclusionDuration = playlistExclusionDuration;
        this.maxPlaylistRetries = maxPlaylistRetries;
        this.enableLowInitialPlaylist = enableLowInitialPlaylist;
        this.usingManagedMediaSource_ = false;
        if (this.useCueTags_) {
            this.cueTagsTrack_ = this.tech_.addTextTrack('metadata', 'ad-cues');
            this.cueTagsTrack_.inBandMetadataTrackDispatchType = '';
        }
        this.requestOptions_ = {
            withCredentials: withCredentials,
            maxPlaylistRetries: maxPlaylistRetries,
            timeout: null
        };
        this.on('error', this.pauseLoading);
        this.mediaTypes_ = $cb03b711053a4297$var$createMediaTypes();
        if (experimentalUseMMS && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).ManagedMediaSource) {
            // Airplay source not yet implemented. Remote playback must be disabled.
            this.tech_.el_.disableRemotePlayback = true;
            this.mediaSource = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).ManagedMediaSource();
            this.usingManagedMediaSource_ = true;
            $cb03b711053a4297$export$2e2bcd8739ae039.log('Using ManagedMediaSource');
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource) this.mediaSource = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource();
        this.handleDurationChange_ = this.handleDurationChange_.bind(this);
        this.handleSourceOpen_ = this.handleSourceOpen_.bind(this);
        this.handleSourceEnded_ = this.handleSourceEnded_.bind(this);
        this.load = this.load.bind(this);
        this.pause = this.pause.bind(this);
        this.mediaSource.addEventListener('durationchange', this.handleDurationChange_); // load the media source into the player
        this.mediaSource.addEventListener('sourceopen', this.handleSourceOpen_);
        this.mediaSource.addEventListener('sourceended', this.handleSourceEnded_);
        this.mediaSource.addEventListener('startstreaming', this.load);
        this.mediaSource.addEventListener('endstreaming', this.pause); // we don't have to handle sourceclose since dispose will handle termination of
        // everything, and the MediaSource should not be detached without a proper disposal
        this.seekable_ = $cb03b711053a4297$var$createTimeRanges();
        this.hasPlayed_ = false;
        this.syncController_ = new $cb03b711053a4297$var$SyncController(options);
        this.segmentMetadataTrack_ = tech.addRemoteTextTrack({
            kind: 'metadata',
            label: 'segment-metadata'
        }, false).track;
        this.segmentMetadataTrack_.mode = 'hidden';
        this.decrypter_ = new $cb03b711053a4297$var$Decrypter();
        this.sourceUpdater_ = new $cb03b711053a4297$var$SourceUpdater(this.mediaSource);
        this.inbandTextTracks_ = {};
        this.timelineChangeController_ = new $cb03b711053a4297$var$TimelineChangeController();
        this.keyStatusMap_ = new Map();
        const segmentLoaderSettings = {
            vhs: this.vhs_,
            parse708captions: options.parse708captions,
            useDtsForTimestampOffset: options.useDtsForTimestampOffset,
            captionServices: captionServices,
            mediaSource: this.mediaSource,
            currentTime: this.tech_.currentTime.bind(this.tech_),
            seekable: ()=>this.seekable(),
            seeking: ()=>this.tech_.seeking(),
            duration: ()=>this.duration(),
            hasPlayed: ()=>this.hasPlayed_,
            goalBufferLength: ()=>this.goalBufferLength(),
            bandwidth: bandwidth,
            syncController: this.syncController_,
            decrypter: this.decrypter_,
            sourceType: this.sourceType_,
            inbandTextTracks: this.inbandTextTracks_,
            cacheEncryptionKeys: cacheEncryptionKeys,
            sourceUpdater: this.sourceUpdater_,
            timelineChangeController: this.timelineChangeController_,
            exactManifestTimings: options.exactManifestTimings,
            addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
        }; // The source type check not only determines whether a special DASH playlist loader
        // should be used, but also covers the case where the provided src is a vhs-json
        // manifest object (instead of a URL). In the case of vhs-json, the default
        // PlaylistLoader should be used.
        this.mainPlaylistLoader_ = this.sourceType_ === 'dash' ? new $cb03b711053a4297$var$DashPlaylistLoader(src, this.vhs_, $cb03b711053a4297$var$merge(this.requestOptions_, {
            addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
        })) : new $cb03b711053a4297$var$PlaylistLoader(src, this.vhs_, $cb03b711053a4297$var$merge(this.requestOptions_, {
            addDateRangesToTextTrack: this.addDateRangesToTextTrack_.bind(this)
        }));
        this.setupMainPlaylistLoaderListeners_(); // setup segment loaders
        // combined audio/video or just video when alternate audio track is selected
        this.mainSegmentLoader_ = new $cb03b711053a4297$var$SegmentLoader($cb03b711053a4297$var$merge(segmentLoaderSettings, {
            segmentMetadataTrack: this.segmentMetadataTrack_,
            loaderType: 'main'
        }), options); // alternate audio track
        this.audioSegmentLoader_ = new $cb03b711053a4297$var$SegmentLoader($cb03b711053a4297$var$merge(segmentLoaderSettings, {
            loaderType: 'audio'
        }), options);
        this.subtitleSegmentLoader_ = new $cb03b711053a4297$var$VTTSegmentLoader($cb03b711053a4297$var$merge(segmentLoaderSettings, {
            loaderType: 'vtt',
            featuresNativeTextTracks: this.tech_.featuresNativeTextTracks,
            loadVttJs: ()=>new Promise((resolve, reject)=>{
                    function onLoad() {
                        tech.off('vttjserror', onError);
                        resolve();
                    }
                    function onError() {
                        tech.off('vttjsloaded', onLoad);
                        reject();
                    }
                    tech.one('vttjsloaded', onLoad);
                    tech.one('vttjserror', onError); // safe to call multiple times, script will be loaded only once:
                    tech.addWebVttScript_();
                })
        }), options);
        const getBandwidth = ()=>{
            return this.mainSegmentLoader_.bandwidth;
        };
        this.contentSteeringController_ = new $cb03b711053a4297$var$ContentSteeringController(this.vhs_.xhr, getBandwidth);
        this.setupSegmentLoaderListeners_();
        if (this.bufferBasedABR) {
            this.mainPlaylistLoader_.one('loadedplaylist', ()=>this.startABRTimer_());
            this.tech_.on('pause', ()=>this.stopABRTimer_());
            this.tech_.on('play', ()=>this.startABRTimer_());
        } // Create SegmentLoader stat-getters
        // mediaRequests_
        // mediaRequestsAborted_
        // mediaRequestsTimedout_
        // mediaRequestsErrored_
        // mediaTransferDuration_
        // mediaBytesTransferred_
        // mediaAppends_
        $cb03b711053a4297$var$loaderStats.forEach((stat)=>{
            this[stat + '_'] = $cb03b711053a4297$var$sumLoaderStat.bind(this, stat);
        });
        this.logger_ = $cb03b711053a4297$var$logger('pc');
        this.triggeredFmp4Usage = false;
        if (this.tech_.preload() === 'none') {
            this.loadOnPlay_ = ()=>{
                this.loadOnPlay_ = null;
                this.mainPlaylistLoader_.load();
            };
            this.tech_.one('play', this.loadOnPlay_);
        } else this.mainPlaylistLoader_.load();
        this.timeToLoadedData__ = -1;
        this.mainAppendsToLoadedData__ = -1;
        this.audioAppendsToLoadedData__ = -1;
        const event = this.tech_.preload() === 'none' ? 'play' : 'loadstart'; // start the first frame timer on loadstart or play (for preload none)
        this.tech_.one(event, ()=>{
            const timeToLoadedDataStart = Date.now();
            this.tech_.one('loadeddata', ()=>{
                this.timeToLoadedData__ = Date.now() - timeToLoadedDataStart;
                this.mainAppendsToLoadedData__ = this.mainSegmentLoader_.mediaAppends;
                this.audioAppendsToLoadedData__ = this.audioSegmentLoader_.mediaAppends;
            });
        });
    }
    mainAppendsToLoadedData_() {
        return this.mainAppendsToLoadedData__;
    }
    audioAppendsToLoadedData_() {
        return this.audioAppendsToLoadedData__;
    }
    appendsToLoadedData_() {
        const main = this.mainAppendsToLoadedData_();
        const audio = this.audioAppendsToLoadedData_();
        if (main === -1 || audio === -1) return -1;
        return main + audio;
    }
    timeToLoadedData_() {
        return this.timeToLoadedData__;
    }
    /**
   * Run selectPlaylist and switch to the new playlist if we should
   *
   * @param {string} [reason=abr] a reason for why the ABR check is made
   * @private
   */ checkABR_(reason = 'abr') {
        const nextPlaylist = this.selectPlaylist();
        if (nextPlaylist && this.shouldSwitchToMedia_(nextPlaylist)) this.switchMedia_(nextPlaylist, reason);
    }
    switchMedia_(playlist, cause, delay) {
        const oldMedia = this.media();
        const oldId = oldMedia && (oldMedia.id || oldMedia.uri);
        const newId = playlist && (playlist.id || playlist.uri);
        if (oldId && oldId !== newId) {
            this.logger_(`switch media ${oldId} -> ${newId} from ${cause}`);
            const metadata = {
                renditionInfo: {
                    id: newId,
                    bandwidth: playlist.attributes.BANDWIDTH,
                    resolution: playlist.attributes.RESOLUTION,
                    codecs: playlist.attributes.CODECS
                },
                cause: cause
            };
            this.trigger({
                type: 'renditionselected',
                metadata: metadata
            });
            this.tech_.trigger({
                type: 'usage',
                name: `vhs-rendition-change-${cause}`
            });
        }
        this.mainPlaylistLoader_.media(playlist, delay);
    }
    /**
   * A function that ensures we switch our playlists inside of `mediaTypes`
   * to match the current `serviceLocation` provided by the contentSteering controller.
   * We want to check media types of `AUDIO`, `SUBTITLES`, and `CLOSED-CAPTIONS`.
   *
   * This should only be called on a DASH playback scenario while using content steering.
   * This is necessary due to differences in how media in HLS manifests are generally tied to
   * a video playlist, where in DASH that is not always the case.
   */ switchMediaForDASHContentSteering_() {
        [
            'AUDIO',
            'SUBTITLES',
            'CLOSED-CAPTIONS'
        ].forEach((type)=>{
            const mediaType = this.mediaTypes_[type];
            const activeGroup = mediaType ? mediaType.activeGroup() : null;
            const pathway = this.contentSteeringController_.getPathway();
            if (activeGroup && pathway) {
                // activeGroup can be an array or a single group
                const mediaPlaylists = activeGroup.length ? activeGroup[0].playlists : activeGroup.playlists;
                const dashMediaPlaylists = mediaPlaylists.filter((p)=>p.attributes.serviceLocation === pathway); // Switch the current active playlist to the correct CDN
                if (dashMediaPlaylists.length) this.mediaTypes_[type].activePlaylistLoader.media(dashMediaPlaylists[0]);
            }
        });
    }
    /**
   * Start a timer that periodically calls checkABR_
   *
   * @private
   */ startABRTimer_() {
        this.stopABRTimer_();
        this.abrTimer_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setInterval(()=>this.checkABR_(), 250);
    }
    /**
   * Stop the timer that periodically calls checkABR_
   *
   * @private
   */ stopABRTimer_() {
        // if we're scrubbing, we don't need to pause.
        // This getter will be added to Video.js in version 7.11.
        if (this.tech_.scrubbing && this.tech_.scrubbing()) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearInterval(this.abrTimer_);
        this.abrTimer_ = null;
    }
    /**
   * Get a list of playlists for the currently selected audio playlist
   *
   * @return {Array} the array of audio playlists
   */ getAudioTrackPlaylists_() {
        const main = this.main();
        const defaultPlaylists = main && main.playlists || []; // if we don't have any audio groups then we can only
        // assume that the audio tracks are contained in main
        // playlist array, use that or an empty array.
        if (!main || !main.mediaGroups || !main.mediaGroups.AUDIO) return defaultPlaylists;
        const AUDIO = main.mediaGroups.AUDIO;
        const groupKeys = Object.keys(AUDIO);
        let track; // get the current active track
        if (Object.keys(this.mediaTypes_.AUDIO.groups).length) track = this.mediaTypes_.AUDIO.activeTrack(); // or get the default track from main if mediaTypes_ isn't setup yet
        else {
            // default group is `main` or just the first group.
            const defaultGroup = AUDIO.main || groupKeys.length && AUDIO[groupKeys[0]];
            for(const label in defaultGroup)if (defaultGroup[label].default) {
                track = {
                    label: label
                };
                break;
            }
        } // no active track no playlists.
        if (!track) return defaultPlaylists;
        const playlists = []; // get all of the playlists that are possible for the
        // active track.
        for(const group in AUDIO)if (AUDIO[group][track.label]) {
            const properties = AUDIO[group][track.label];
            if (properties.playlists && properties.playlists.length) playlists.push.apply(playlists, properties.playlists);
            else if (properties.uri) playlists.push(properties);
            else if (main.playlists.length) // if an audio group does not have a uri
            // see if we have main playlists that use it as a group.
            // if we do then add those to the playlists list.
            for(let i = 0; i < main.playlists.length; i++){
                const playlist = main.playlists[i];
                if (playlist.attributes && playlist.attributes.AUDIO && playlist.attributes.AUDIO === group) playlists.push(playlist);
            }
        }
        if (!playlists.length) return defaultPlaylists;
        return playlists;
    }
    /**
   * Register event handlers on the main playlist loader. A helper
   * function for construction time.
   *
   * @private
   */ setupMainPlaylistLoaderListeners_() {
        this.mainPlaylistLoader_.on('loadedmetadata', ()=>{
            const media = this.mainPlaylistLoader_.media();
            const requestTimeout = media.targetDuration * 1500; // If we don't have any more available playlists, we don't want to
            // timeout the request.
            if ($cb03b711053a4297$var$isLowestEnabledRendition(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media())) this.requestOptions_.timeout = 0;
            else this.requestOptions_.timeout = requestTimeout;
             // if this isn't a live video and preload permits, start
            // downloading segments
            if (media.endList && this.tech_.preload() !== 'none') {
                this.mainSegmentLoader_.playlist(media, this.requestOptions_);
                this.mainSegmentLoader_.load();
            }
            $cb03b711053a4297$var$setupMediaGroups({
                sourceType: this.sourceType_,
                segmentLoaders: {
                    AUDIO: this.audioSegmentLoader_,
                    SUBTITLES: this.subtitleSegmentLoader_,
                    main: this.mainSegmentLoader_
                },
                tech: this.tech_,
                requestOptions: this.requestOptions_,
                mainPlaylistLoader: this.mainPlaylistLoader_,
                vhs: this.vhs_,
                main: this.main(),
                mediaTypes: this.mediaTypes_,
                excludePlaylist: this.excludePlaylist.bind(this)
            });
            this.triggerPresenceUsage_(this.main(), media);
            this.setupFirstPlay();
            if (!this.mediaTypes_.AUDIO.activePlaylistLoader || this.mediaTypes_.AUDIO.activePlaylistLoader.media()) this.trigger('selectedinitialmedia');
            else // We must wait for the active audio playlist loader to
            // finish setting up before triggering this event so the
            // representations API and EME setup is correct
            this.mediaTypes_.AUDIO.activePlaylistLoader.one('loadedmetadata', ()=>{
                this.trigger('selectedinitialmedia');
            });
        });
        this.mainPlaylistLoader_.on('loadedplaylist', ()=>{
            if (this.loadOnPlay_) this.tech_.off('play', this.loadOnPlay_);
            let updatedPlaylist = this.mainPlaylistLoader_.media();
            if (!updatedPlaylist) {
                // Add content steering listeners on first load and init.
                this.attachContentSteeringListeners_();
                this.initContentSteeringController_(); // exclude any variants that are not supported by the browser before selecting
                // an initial media as the playlist selectors do not consider browser support
                this.excludeUnsupportedVariants_();
                let selectedMedia;
                if (this.enableLowInitialPlaylist) selectedMedia = this.selectInitialPlaylist();
                if (!selectedMedia) selectedMedia = this.selectPlaylist();
                if (!selectedMedia || !this.shouldSwitchToMedia_(selectedMedia)) return;
                this.initialMedia_ = selectedMedia;
                this.switchMedia_(this.initialMedia_, 'initial'); // Under the standard case where a source URL is provided, loadedplaylist will
                // fire again since the playlist will be requested. In the case of vhs-json
                // (where the manifest object is provided as the source), when the media
                // playlist's `segments` list is already available, a media playlist won't be
                // requested, and loadedplaylist won't fire again, so the playlist handler must be
                // called on its own here.
                const haveJsonSource = this.sourceType_ === 'vhs-json' && this.initialMedia_.segments;
                if (!haveJsonSource) return;
                updatedPlaylist = this.initialMedia_;
            }
            this.handleUpdatedMediaPlaylist(updatedPlaylist);
        });
        this.mainPlaylistLoader_.on('error', ()=>{
            const error = this.mainPlaylistLoader_.error;
            this.excludePlaylist({
                playlistToExclude: error.playlist,
                error: error
            });
        });
        this.mainPlaylistLoader_.on('mediachanging', ()=>{
            this.mainSegmentLoader_.abort();
            this.mainSegmentLoader_.pause();
        });
        this.mainPlaylistLoader_.on('mediachange', ()=>{
            const media = this.mainPlaylistLoader_.media();
            const requestTimeout = media.targetDuration * 1500; // If we don't have any more available playlists, we don't want to
            // timeout the request.
            if ($cb03b711053a4297$var$isLowestEnabledRendition(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media())) this.requestOptions_.timeout = 0;
            else this.requestOptions_.timeout = requestTimeout;
            if (this.sourceType_ === 'dash') // we don't want to re-request the same hls playlist right after it was changed
            // Initially it was implemented as workaround to restart playlist loader for live
            // when playlist loader is paused because of playlist exclusions:
            // see: https://github.com/videojs/http-streaming/pull/1339
            // but this introduces duplicate "loadedplaylist" event.
            // Ideally we want to re-think playlist loader life-cycle events,
            // but simply checking "paused" state should help a lot
            {
                if (this.mainPlaylistLoader_.isPaused) this.mainPlaylistLoader_.load();
            } // TODO: Create a new event on the PlaylistLoader that signals
            // that the segments have changed in some way and use that to
            // update the SegmentLoader instead of doing it twice here and
            // on `loadedplaylist`
            this.mainSegmentLoader_.pause();
            this.mainSegmentLoader_.playlist(media, this.requestOptions_);
            if (this.waitingForFastQualityPlaylistReceived_) this.runFastQualitySwitch_();
            else this.mainSegmentLoader_.load();
            this.tech_.trigger({
                type: 'mediachange',
                bubbles: true
            });
        });
        this.mainPlaylistLoader_.on('playlistunchanged', ()=>{
            const updatedPlaylist = this.mainPlaylistLoader_.media(); // ignore unchanged playlists that have already been
            // excluded for not-changing. We likely just have a really slowly updating
            // playlist.
            if (updatedPlaylist.lastExcludeReason_ === 'playlist-unchanged') return;
            const playlistOutdated = this.stuckAtPlaylistEnd_(updatedPlaylist);
            if (playlistOutdated) {
                // Playlist has stopped updating and we're stuck at its end. Try to
                // exclude it and switch to another playlist in the hope that that
                // one is updating (and give the player a chance to re-adjust to the
                // safe live point).
                this.excludePlaylist({
                    error: {
                        message: 'Playlist no longer updating.',
                        reason: 'playlist-unchanged'
                    }
                }); // useful for monitoring QoS
                this.tech_.trigger('playliststuck');
            }
        });
        this.mainPlaylistLoader_.on('renditiondisabled', ()=>{
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-rendition-disabled'
            });
        });
        this.mainPlaylistLoader_.on('renditionenabled', ()=>{
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-rendition-enabled'
            });
        });
        const playlistLoaderEvents = [
            'manifestrequeststart',
            'manifestrequestcomplete',
            'manifestparsestart',
            'manifestparsecomplete',
            'playlistrequeststart',
            'playlistrequestcomplete',
            'playlistparsestart',
            'playlistparsecomplete',
            'renditiondisabled',
            'renditionenabled'
        ];
        playlistLoaderEvents.forEach((eventName)=>{
            this.mainPlaylistLoader_.on(eventName, (metadata)=>{
                // trigger directly on the player to ensure early events are fired.
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, metadata));
            });
        });
    }
    /**
   * Given an updated media playlist (whether it was loaded for the first time, or
   * refreshed for live playlists), update any relevant properties and state to reflect
   * changes in the media that should be accounted for (e.g., cues and duration).
   *
   * @param {Object} updatedPlaylist the updated media playlist object
   *
   * @private
   */ handleUpdatedMediaPlaylist(updatedPlaylist) {
        if (this.useCueTags_) this.updateAdCues_(updatedPlaylist);
         // TODO: Create a new event on the PlaylistLoader that signals
        // that the segments have changed in some way and use that to
        // update the SegmentLoader instead of doing it twice here and
        // on `mediachange`
        this.mainSegmentLoader_.pause();
        this.mainSegmentLoader_.playlist(updatedPlaylist, this.requestOptions_);
        if (this.waitingForFastQualityPlaylistReceived_) this.runFastQualitySwitch_();
        this.updateDuration(!updatedPlaylist.endList); // If the player isn't paused, ensure that the segment loader is running,
        // as it is possible that it was temporarily stopped while waiting for
        // a playlist (e.g., in case the playlist errored and we re-requested it).
        if (!this.tech_.paused()) {
            this.mainSegmentLoader_.load();
            if (this.audioSegmentLoader_) this.audioSegmentLoader_.load();
        }
    }
    /**
   * A helper function for triggerring presence usage events once per source
   *
   * @private
   */ triggerPresenceUsage_(main, media) {
        const mediaGroups = main.mediaGroups || {};
        let defaultDemuxed = true;
        const audioGroupKeys = Object.keys(mediaGroups.AUDIO);
        for(const mediaGroup in mediaGroups.AUDIO)for(const label in mediaGroups.AUDIO[mediaGroup]){
            const properties = mediaGroups.AUDIO[mediaGroup][label];
            if (!properties.uri) defaultDemuxed = false;
        }
        if (defaultDemuxed) this.tech_.trigger({
            type: 'usage',
            name: 'vhs-demuxed'
        });
        if (Object.keys(mediaGroups.SUBTITLES).length) this.tech_.trigger({
            type: 'usage',
            name: 'vhs-webvtt'
        });
        if ($cb03b711053a4297$var$Vhs$1.Playlist.isAes(media)) this.tech_.trigger({
            type: 'usage',
            name: 'vhs-aes'
        });
        if (audioGroupKeys.length && Object.keys(mediaGroups.AUDIO[audioGroupKeys[0]]).length > 1) this.tech_.trigger({
            type: 'usage',
            name: 'vhs-alternate-audio'
        });
        if (this.useCueTags_) this.tech_.trigger({
            type: 'usage',
            name: 'vhs-playlist-cue-tags'
        });
    }
    shouldSwitchToMedia_(nextPlaylist) {
        const currentPlaylist = this.mainPlaylistLoader_.media() || this.mainPlaylistLoader_.pendingMedia_;
        const currentTime = this.tech_.currentTime();
        const bufferLowWaterLine = this.bufferLowWaterLine();
        const bufferHighWaterLine = this.bufferHighWaterLine();
        const buffered = this.tech_.buffered();
        return $cb03b711053a4297$var$shouldSwitchToMedia({
            buffered: buffered,
            currentTime: currentTime,
            currentPlaylist: currentPlaylist,
            nextPlaylist: nextPlaylist,
            bufferLowWaterLine: bufferLowWaterLine,
            bufferHighWaterLine: bufferHighWaterLine,
            duration: this.duration(),
            bufferBasedABR: this.bufferBasedABR,
            log: this.logger_
        });
    }
    /**
   * Register event handlers on the segment loaders. A helper function
   * for construction time.
   *
   * @private
   */ setupSegmentLoaderListeners_() {
        this.mainSegmentLoader_.on('bandwidthupdate', ()=>{
            // Whether or not buffer based ABR or another ABR is used, on a bandwidth change it's
            // useful to check to see if a rendition switch should be made.
            this.checkABR_('bandwidthupdate');
            this.tech_.trigger('bandwidthupdate');
        });
        this.mainSegmentLoader_.on('timeout', ()=>{
            if (this.bufferBasedABR) // If a rendition change is needed, then it would've be done on `bandwidthupdate`.
            // Here the only consideration is that for buffer based ABR there's no guarantee
            // of an immediate switch (since the bandwidth is averaged with a timeout
            // bandwidth value of 1), so force a load on the segment loader to keep it going.
            this.mainSegmentLoader_.load();
        }); // `progress` events are not reliable enough of a bandwidth measure to trigger buffer
        // based ABR.
        if (!this.bufferBasedABR) this.mainSegmentLoader_.on('progress', ()=>{
            this.trigger('progress');
        });
        this.mainSegmentLoader_.on('error', ()=>{
            const error = this.mainSegmentLoader_.error();
            this.excludePlaylist({
                playlistToExclude: error.playlist,
                error: error
            });
        });
        this.mainSegmentLoader_.on('appenderror', ()=>{
            this.error = this.mainSegmentLoader_.error_;
            this.trigger('error');
        });
        this.mainSegmentLoader_.on('syncinfoupdate', ()=>{
            this.onSyncInfoUpdate_();
        });
        this.mainSegmentLoader_.on('timestampoffset', ()=>{
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-timestamp-offset'
            });
        });
        this.audioSegmentLoader_.on('syncinfoupdate', ()=>{
            this.onSyncInfoUpdate_();
        });
        this.audioSegmentLoader_.on('appenderror', ()=>{
            this.error = this.audioSegmentLoader_.error_;
            this.trigger('error');
        });
        this.mainSegmentLoader_.on('ended', ()=>{
            this.logger_('main segment loader ended');
            this.onEndOfStream();
        }); // There is the possibility of the video segment and the audio segment
        // at a current time to be on different timelines. When this occurs, the player
        // forwards playback to a point where these two segment types are back on the same
        // timeline. This time will be just after the end of the audio segment that is on
        // a previous timeline.
        this.timelineChangeController_.on('audioTimelineBehind', ()=>{
            const segmentInfo = this.audioSegmentLoader_.pendingSegment_;
            if (!segmentInfo || !segmentInfo.segment || !segmentInfo.segment.syncInfo) return;
             // Update the current time to just after the faulty audio segment.
            // This moves playback to a spot where both audio and video segments
            // are on the same timeline.
            const newTime = segmentInfo.segment.syncInfo.end + 0.01;
            this.tech_.setCurrentTime(newTime);
        });
        this.timelineChangeController_.on('fixBadTimelineChange', ()=>{
            // pause, reset-everything and load for all segment-loaders
            this.logger_('Fix bad timeline change. Restarting al segment loaders...');
            this.mainSegmentLoader_.pause();
            this.mainSegmentLoader_.resetEverything();
            if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
                this.audioSegmentLoader_.pause();
                this.audioSegmentLoader_.resetEverything();
            }
            if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
                this.subtitleSegmentLoader_.pause();
                this.subtitleSegmentLoader_.resetEverything();
            } // start segment loader loading in case they are paused
            this.load();
        });
        this.mainSegmentLoader_.on('earlyabort', (event)=>{
            // never try to early abort with the new ABR algorithm
            if (this.bufferBasedABR) return;
            this.delegateLoaders_('all', [
                'abort'
            ]);
            this.excludePlaylist({
                error: {
                    message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
                },
                playlistExclusionDuration: $cb03b711053a4297$var$ABORT_EARLY_EXCLUSION_SECONDS
            });
        });
        const updateCodecs = ()=>{
            if (!this.sourceUpdater_.hasCreatedSourceBuffers()) return this.tryToCreateSourceBuffers_();
            const codecs = this.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
            if (!codecs) return;
            this.sourceUpdater_.addOrChangeSourceBuffers(codecs);
        };
        this.mainSegmentLoader_.on('trackinfo', updateCodecs);
        this.audioSegmentLoader_.on('trackinfo', updateCodecs);
        this.mainSegmentLoader_.on('fmp4', ()=>{
            if (!this.triggeredFmp4Usage) {
                this.tech_.trigger({
                    type: 'usage',
                    name: 'vhs-fmp4'
                });
                this.triggeredFmp4Usage = true;
            }
        });
        this.audioSegmentLoader_.on('fmp4', ()=>{
            if (!this.triggeredFmp4Usage) {
                this.tech_.trigger({
                    type: 'usage',
                    name: 'vhs-fmp4'
                });
                this.triggeredFmp4Usage = true;
            }
        });
        this.audioSegmentLoader_.on('ended', ()=>{
            this.logger_('audioSegmentLoader ended');
            this.onEndOfStream();
        });
        const segmentLoaderEvents = [
            'segmentselected',
            'segmentloadstart',
            'segmentloaded',
            'segmentkeyloadstart',
            'segmentkeyloadcomplete',
            'segmentdecryptionstart',
            'segmentdecryptioncomplete',
            'segmenttransmuxingstart',
            'segmenttransmuxingcomplete',
            'segmenttransmuxingtrackinfoavailable',
            'segmenttransmuxingtiminginfoavailable',
            'segmentappendstart',
            'appendsdone',
            'bandwidthupdated',
            'timelinechange',
            'codecschange'
        ];
        segmentLoaderEvents.forEach((eventName)=>{
            this.mainSegmentLoader_.on(eventName, (metadata)=>{
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, metadata));
            });
            this.audioSegmentLoader_.on(eventName, (metadata)=>{
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, metadata));
            });
            this.subtitleSegmentLoader_.on(eventName, (metadata)=>{
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, metadata));
            });
        });
    }
    mediaSecondsLoaded_() {
        return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
    }
    /**
   * Call load on our SegmentLoaders
   */ load() {
        this.mainSegmentLoader_.load();
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) this.audioSegmentLoader_.load();
        if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) this.subtitleSegmentLoader_.load();
    }
    /**
   * Call pause on our SegmentLoaders
   */ pause() {
        this.mainSegmentLoader_.pause();
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) this.audioSegmentLoader_.pause();
        if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) this.subtitleSegmentLoader_.pause();
    }
    /**
   * Re-tune playback quality level for the current player
   * conditions. This method will perform destructive actions like removing
   * already buffered content in order to readjust the currently active
   * playlist quickly. This is good for manual quality changes
   *
   * @private
   */ fastQualityChange_(media = this.selectPlaylist()) {
        if (media && media === this.mainPlaylistLoader_.media()) {
            this.logger_('skipping fastQualityChange because new media is same as old');
            return;
        }
        this.switchMedia_(media, 'fast-quality'); // we would like to avoid race condition when we call fastQuality,
        // reset everything and start loading segments from prev segments instead of new because new playlist is not received yet
        this.waitingForFastQualityPlaylistReceived_ = true;
    }
    runFastQualitySwitch_() {
        this.waitingForFastQualityPlaylistReceived_ = false;
        this.mainSegmentLoader_.pause();
        this.mainSegmentLoader_.resetEverything();
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
            this.audioSegmentLoader_.pause();
            this.audioSegmentLoader_.resetEverything();
        }
        if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
            this.subtitleSegmentLoader_.pause();
            this.subtitleSegmentLoader_.resetEverything();
        } // start segment loader loading in case they are paused
        this.load();
    }
    /**
   * Begin playback.
   */ play() {
        if (this.setupFirstPlay()) return;
        if (this.tech_.ended()) this.tech_.setCurrentTime(0);
        if (this.hasPlayed_) this.load();
        const seekable = this.tech_.seekable(); // if the viewer has paused and we fell out of the live window,
        // seek forward to the live point
        if (this.tech_.duration() === Infinity) {
            if (this.tech_.currentTime() < seekable.start(0)) return this.tech_.setCurrentTime(seekable.end(seekable.length - 1));
        }
    }
    /**
   * Seek to the latest media position if this is a live video and the
   * player and video are loaded and initialized.
   */ setupFirstPlay() {
        const media = this.mainPlaylistLoader_.media(); // Check that everything is ready to begin buffering for the first call to play
        //  If 1) there is no active media
        //     2) the player is paused
        //     3) the first play has already been setup
        // then exit early
        if (!media || this.tech_.paused() || this.hasPlayed_) return false;
         // when the video is a live stream and/or has a start time
        if (!media.endList || media.start) {
            const seekable = this.seekable();
            if (!seekable.length) // without a seekable range, the player cannot seek to begin buffering at the
            // live or start point
            return false;
            const seekableEnd = seekable.end(0);
            let startPoint = seekableEnd;
            if (media.start) {
                const offset = media.start.timeOffset;
                if (offset < 0) startPoint = Math.max(seekableEnd + offset, seekable.start(0));
                else startPoint = Math.min(seekableEnd, offset);
            } // trigger firstplay to inform the source handler to ignore the next seek event
            this.trigger('firstplay'); // seek to the live point
            this.tech_.setCurrentTime(startPoint);
        }
        this.hasPlayed_ = true; // we can begin loading now that everything is ready
        this.load();
        return true;
    }
    /**
   * handle the sourceopen event on the MediaSource
   *
   * @private
   */ handleSourceOpen_() {
        // Only attempt to create the source buffer if none already exist.
        // handleSourceOpen is also called when we are "re-opening" a source buffer
        // after `endOfStream` has been called (in response to a seek for instance)
        this.tryToCreateSourceBuffers_(); // if autoplay is enabled, begin playback. This is duplicative of
        // code in video.js but is required because play() must be invoked
        // *after* the media source has opened.
        if (this.tech_.autoplay()) {
            const playPromise = this.tech_.play(); // Catch/silence error when a pause interrupts a play request
            // on browsers which return a promise
            if (typeof playPromise !== 'undefined' && typeof playPromise.then === 'function') playPromise.then(null, (e)=>{});
        }
        this.trigger('sourceopen');
    }
    /**
   * handle the sourceended event on the MediaSource
   *
   * @private
   */ handleSourceEnded_() {
        if (!this.inbandTextTracks_.metadataTrack_) return;
        const cues = this.inbandTextTracks_.metadataTrack_.cues;
        if (!cues || !cues.length) return;
        const duration = this.duration();
        cues[cues.length - 1].endTime = isNaN(duration) || Math.abs(duration) === Infinity ? Number.MAX_VALUE : duration;
    }
    /**
   * handle the durationchange event on the MediaSource
   *
   * @private
   */ handleDurationChange_() {
        this.tech_.trigger('durationchange');
    }
    /**
   * Calls endOfStream on the media source when all active stream types have called
   * endOfStream
   *
   * @param {string} streamType
   *        Stream type of the segment loader that called endOfStream
   * @private
   */ onEndOfStream() {
        let isEndOfStream = this.mainSegmentLoader_.ended_;
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
            const mainMediaInfo = this.mainSegmentLoader_.getCurrentMediaInfo_(); // if the audio playlist loader exists, then alternate audio is active
            if (!mainMediaInfo || mainMediaInfo.hasVideo) // if we do not know if the main segment loader contains video yet or if we
            // definitively know the main segment loader contains video, then we need to wait
            // for both main and audio segment loaders to call endOfStream
            isEndOfStream = isEndOfStream && this.audioSegmentLoader_.ended_;
            else // otherwise just rely on the audio loader
            isEndOfStream = this.audioSegmentLoader_.ended_;
        }
        if (!isEndOfStream) return;
        this.stopABRTimer_();
        this.sourceUpdater_.endOfStream();
    }
    /**
   * Check if a playlist has stopped being updated
   *
   * @param {Object} playlist the media playlist object
   * @return {boolean} whether the playlist has stopped being updated or not
   */ stuckAtPlaylistEnd_(playlist) {
        const seekable = this.seekable();
        if (!seekable.length) // playlist doesn't have enough information to determine whether we are stuck
        return false;
        const expired = this.syncController_.getExpiredTime(playlist, this.duration());
        if (expired === null) return false;
         // does not use the safe live end to calculate playlist end, since we
        // don't want to say we are stuck while there is still content
        const absolutePlaylistEnd = $cb03b711053a4297$var$Vhs$1.Playlist.playlistEnd(playlist, expired);
        const currentTime = this.tech_.currentTime();
        const buffered = this.tech_.buffered();
        if (!buffered.length) // return true if the playhead reached the absolute end of the playlist
        return absolutePlaylistEnd - currentTime <= $cb03b711053a4297$var$SAFE_TIME_DELTA;
        const bufferedEnd = buffered.end(buffered.length - 1); // return true if there is too little buffer left and buffer has reached absolute
        // end of playlist
        return bufferedEnd - currentTime <= $cb03b711053a4297$var$SAFE_TIME_DELTA && absolutePlaylistEnd - bufferedEnd <= $cb03b711053a4297$var$SAFE_TIME_DELTA;
    }
    /**
   * Exclude a playlist for a set amount of time, making it unavailable for selection by
   * the rendition selection algorithm, then force a new playlist (rendition) selection.
   *
   * @param {Object=} playlistToExclude
   *                  the playlist to exclude, defaults to the currently selected playlist
   * @param {Object=} error
   *                  an optional error
   * @param {number=} playlistExclusionDuration
   *                  an optional number of seconds to exclude the playlist
   */ excludePlaylist({ playlistToExclude: playlistToExclude = this.mainPlaylistLoader_.media(), error: error = {}, playlistExclusionDuration: playlistExclusionDuration }) {
        // If the `error` was generated by the playlist loader, it will contain
        // the playlist we were trying to load (but failed) and that should be
        // excluded instead of the currently selected playlist which is likely
        // out-of-date in this scenario
        playlistToExclude = playlistToExclude || this.mainPlaylistLoader_.media();
        playlistExclusionDuration = playlistExclusionDuration || error.playlistExclusionDuration || this.playlistExclusionDuration; // If there is no current playlist, then an error occurred while we were
        // trying to load the main OR while we were disposing of the tech
        if (!playlistToExclude) {
            this.error = error;
            if (this.mediaSource.readyState !== 'open') this.trigger('error');
            else this.sourceUpdater_.endOfStream('network');
            return;
        }
        playlistToExclude.playlistErrors_++;
        const playlists = this.mainPlaylistLoader_.main.playlists;
        const enabledPlaylists = playlists.filter($cb03b711053a4297$var$isEnabled);
        const isFinalRendition = enabledPlaylists.length === 1 && enabledPlaylists[0] === playlistToExclude; // Don't exclude the only playlist unless it was excluded
        // forever
        if (playlists.length === 1 && playlistExclusionDuration !== Infinity) {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`Problem encountered with playlist ${playlistToExclude.id}. ` + 'Trying again since it is the only playlist.');
            this.tech_.trigger('retryplaylist'); // if this is a final rendition, we should delay
            return this.mainPlaylistLoader_.load(isFinalRendition);
        }
        if (isFinalRendition) {
            // If we're content steering, try other pathways.
            if (this.main().contentSteering) {
                const pathway = this.pathwayAttribute_(playlistToExclude); // Ignore at least 1 steering manifest refresh.
                const reIncludeDelay = this.contentSteeringController_.steeringManifest.ttl * 1000;
                this.contentSteeringController_.excludePathway(pathway);
                this.excludeThenChangePathway_();
                setTimeout(()=>{
                    this.contentSteeringController_.addAvailablePathway(pathway);
                }, reIncludeDelay);
                return;
            } // Since we're on the final non-excluded playlist, and we're about to exclude
            // it, instead of erring the player or retrying this playlist, clear out the current
            // exclusion list. This allows other playlists to be attempted in case any have been
            // fixed.
            let reincluded = false;
            playlists.forEach((playlist)=>{
                // skip current playlist which is about to be excluded
                if (playlist === playlistToExclude) return;
                const excludeUntil = playlist.excludeUntil; // a playlist cannot be reincluded if it wasn't excluded to begin with.
                if (typeof excludeUntil !== 'undefined' && excludeUntil !== Infinity) {
                    reincluded = true;
                    delete playlist.excludeUntil;
                }
            });
            if (reincluded) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."); // Technically we are retrying a playlist, in that we are simply retrying a previous
                // playlist. This is needed for users relying on the retryplaylist event to catch a
                // case where the player might be stuck and looping through "dead" playlists.
                this.tech_.trigger('retryplaylist');
            }
        } // Exclude this playlist
        let excludeUntil;
        if (playlistToExclude.playlistErrors_ > this.maxPlaylistRetries) excludeUntil = Infinity;
        else excludeUntil = Date.now() + playlistExclusionDuration * 1000;
        playlistToExclude.excludeUntil = excludeUntil;
        if (error.reason) playlistToExclude.lastExcludeReason_ = error.reason;
        this.tech_.trigger('excludeplaylist');
        this.tech_.trigger({
            type: 'usage',
            name: 'vhs-rendition-excluded'
        }); // TODO: only load a new playlist if we're excluding the current playlist
        // If this function was called with a playlist that's not the current active playlist
        // (e.g., media().id !== playlistToExclude.id),
        // then a new playlist should not be selected and loaded, as there's nothing wrong with the current playlist.
        const nextPlaylist = this.selectPlaylist();
        if (!nextPlaylist) {
            this.error = 'Playback cannot continue. No available working or supported playlists.';
            this.trigger('error');
            return;
        }
        const logFn = error.internal ? this.logger_ : $cb03b711053a4297$export$2e2bcd8739ae039.log.warn;
        const errorMessage = error.message ? ' ' + error.message : '';
        logFn(`${error.internal ? 'Internal problem' : 'Problem'} encountered with playlist ${playlistToExclude.id}.` + `${errorMessage} Switching to playlist ${nextPlaylist.id}.`); // if audio group changed reset audio loaders
        if (nextPlaylist.attributes.AUDIO !== playlistToExclude.attributes.AUDIO) this.delegateLoaders_('audio', [
            'abort',
            'pause'
        ]);
         // if subtitle group changed reset subtitle loaders
        if (nextPlaylist.attributes.SUBTITLES !== playlistToExclude.attributes.SUBTITLES) this.delegateLoaders_('subtitle', [
            'abort',
            'pause'
        ]);
        this.delegateLoaders_('main', [
            'abort',
            'pause'
        ]);
        const delayDuration = nextPlaylist.targetDuration / 2 * 1000 || 5000;
        const shouldDelay = typeof nextPlaylist.lastRequest === 'number' && Date.now() - nextPlaylist.lastRequest <= delayDuration; // delay if it's a final rendition or if the last refresh is sooner than half targetDuration
        return this.switchMedia_(nextPlaylist, 'exclude', isFinalRendition || shouldDelay);
    }
    /**
   * Pause all segment/playlist loaders
   */ pauseLoading() {
        this.delegateLoaders_('all', [
            'abort',
            'pause'
        ]);
        this.stopABRTimer_();
    }
    /**
   * Call a set of functions in order on playlist loaders, segment loaders,
   * or both types of loaders.
   *
   * @param {string} filter
   *        Filter loaders that should call fnNames using a string. Can be:
   *        * all - run on all loaders
   *        * audio - run on all audio loaders
   *        * subtitle - run on all subtitle loaders
   *        * main - run on the main loaders
   *
   * @param {Array|string} fnNames
   *        A string or array of function names to call.
   */ delegateLoaders_(filter, fnNames) {
        const loaders = [];
        const dontFilterPlaylist = filter === 'all';
        if (dontFilterPlaylist || filter === 'main') loaders.push(this.mainPlaylistLoader_);
        const mediaTypes = [];
        if (dontFilterPlaylist || filter === 'audio') mediaTypes.push('AUDIO');
        if (dontFilterPlaylist || filter === 'subtitle') {
            mediaTypes.push('CLOSED-CAPTIONS');
            mediaTypes.push('SUBTITLES');
        }
        mediaTypes.forEach((mediaType)=>{
            const loader = this.mediaTypes_[mediaType] && this.mediaTypes_[mediaType].activePlaylistLoader;
            if (loader) loaders.push(loader);
        });
        [
            'main',
            'audio',
            'subtitle'
        ].forEach((name)=>{
            const loader = this[`${name}SegmentLoader_`];
            if (loader && (filter === name || filter === 'all')) loaders.push(loader);
        });
        loaders.forEach((loader)=>fnNames.forEach((fnName)=>{
                if (typeof loader[fnName] === 'function') loader[fnName]();
            }));
    }
    /**
   * set the current time on all segment loaders
   *
   * @param {TimeRange} currentTime the current time to set
   * @return {TimeRange} the current time
   */ setCurrentTime(currentTime) {
        const buffered = $cb03b711053a4297$var$findRange(this.tech_.buffered(), currentTime);
        if (!(this.mainPlaylistLoader_ && this.mainPlaylistLoader_.media())) // return immediately if the metadata is not ready yet
        return 0;
         // it's clearly an edge-case but don't thrown an error if asked to
        // seek within an empty playlist
        if (!this.mainPlaylistLoader_.media().segments) return 0;
         // if the seek location is already buffered, continue buffering as usual
        if (buffered && buffered.length) return currentTime;
         // cancel outstanding requests so we begin buffering at the new
        // location
        this.mainSegmentLoader_.pause();
        this.mainSegmentLoader_.resetEverything();
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
            this.audioSegmentLoader_.pause();
            this.audioSegmentLoader_.resetEverything();
        }
        if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
            this.subtitleSegmentLoader_.pause();
            this.subtitleSegmentLoader_.resetEverything();
        } // start segment loader loading in case they are paused
        this.load();
    }
    /**
   * get the current duration
   *
   * @return {TimeRange} the duration
   */ duration() {
        if (!this.mainPlaylistLoader_) return 0;
        const media = this.mainPlaylistLoader_.media();
        if (!media) // no playlists loaded yet, so can't determine a duration
        return 0;
         // Don't rely on the media source for duration in the case of a live playlist since
        // setting the native MediaSource's duration to infinity ends up with consequences to
        // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
        //
        // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
        // however, few browsers have support for setLiveSeekableRange()
        // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
        //
        // Until a time when the duration of the media source can be set to infinity, and a
        // seekable range specified across browsers, just return Infinity.
        if (!media.endList) return Infinity;
         // Since this is a VOD video, it is safe to rely on the media source's duration (if
        // available). If it's not available, fall back to a playlist-calculated estimate.
        if (this.mediaSource) return this.mediaSource.duration;
        return $cb03b711053a4297$var$Vhs$1.Playlist.duration(media);
    }
    /**
   * check the seekable range
   *
   * @return {TimeRange} the seekable range
   */ seekable() {
        return this.seekable_;
    }
    getSeekableRange_(playlistLoader, mediaType) {
        const media = playlistLoader.media();
        if (!media) return null;
        const mediaSequenceSync = this.syncController_.getMediaSequenceSync(mediaType);
        if (mediaSequenceSync && mediaSequenceSync.isReliable) {
            const start = mediaSequenceSync.start;
            const end = mediaSequenceSync.end;
            if (!isFinite(start) || !isFinite(end)) return null;
            const liveEdgeDelay = $cb03b711053a4297$var$Vhs$1.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, media); // Make sure our seekable end is not less than the seekable start
            const calculatedEnd = Math.max(start, end - liveEdgeDelay);
            return $cb03b711053a4297$var$createTimeRanges([
                [
                    start,
                    calculatedEnd
                ]
            ]);
        }
        const expired = this.syncController_.getExpiredTime(media, this.duration());
        if (expired === null) return null;
        const seekable = $cb03b711053a4297$var$Vhs$1.Playlist.seekable(media, expired, $cb03b711053a4297$var$Vhs$1.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, media));
        return seekable.length ? seekable : null;
    }
    computeFinalSeekable_(mainSeekable, audioSeekable) {
        if (!audioSeekable) return mainSeekable;
        const mainStart = mainSeekable.start(0);
        const mainEnd = mainSeekable.end(0);
        const audioStart = audioSeekable.start(0);
        const audioEnd = audioSeekable.end(0);
        if (audioStart > mainEnd || mainStart > audioEnd) // Seekables are far apart, rely on main
        return mainSeekable;
         // Return the overlapping seekable range
        return $cb03b711053a4297$var$createTimeRanges([
            [
                Math.max(mainStart, audioStart),
                Math.min(mainEnd, audioEnd)
            ]
        ]);
    }
    onSyncInfoUpdate_() {
        // TODO check for creation of both source buffers before updating seekable
        //
        // A fix was made to this function where a check for
        // this.sourceUpdater_.hasCreatedSourceBuffers
        // was added to ensure that both source buffers were created before seekable was
        // updated. However, it originally had a bug where it was checking for a true and
        // returning early instead of checking for false. Setting it to check for false to
        // return early though created other issues. A call to play() would check for seekable
        // end without verifying that a seekable range was present. In addition, even checking
        // for that didn't solve some issues, as handleFirstPlay is sometimes worked around
        // due to a media update calling load on the segment loaders, skipping a seek to live,
        // thereby starting live streams at the beginning of the stream rather than at the end.
        //
        // This conditional should be fixed to wait for the creation of two source buffers at
        // the same time as the other sections of code are fixed to properly seek to live and
        // not throw an error due to checking for a seekable end when no seekable range exists.
        //
        // For now, fall back to the older behavior, with the understanding that the seekable
        // range may not be completely correct, leading to a suboptimal initial live point.
        if (!this.mainPlaylistLoader_) return;
        const mainSeekable = this.getSeekableRange_(this.mainPlaylistLoader_, 'main');
        if (!mainSeekable) return;
        let audioSeekable;
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
            audioSeekable = this.getSeekableRange_(this.mediaTypes_.AUDIO.activePlaylistLoader, 'audio');
            if (!audioSeekable) return;
        }
        const oldSeekable = this.seekable_;
        this.seekable_ = this.computeFinalSeekable_(mainSeekable, audioSeekable);
        if (!this.seekable_) return;
        if (oldSeekable && oldSeekable.length && this.seekable_.length) {
            if (oldSeekable.start(0) === this.seekable_.start(0) && oldSeekable.end(0) === this.seekable_.end(0)) // Seekable range hasn't changed
            return;
        }
        this.logger_(`seekable updated [${$cb03b711053a4297$var$printableRange(this.seekable_)}]`);
        const metadata = {
            seekableRanges: this.seekable_
        };
        this.trigger({
            type: 'seekablerangeschanged',
            metadata: metadata
        });
        this.tech_.trigger('seekablechanged');
    }
    /**
   * Update the player duration
   */ updateDuration(isLive) {
        if (this.updateDuration_) {
            this.mediaSource.removeEventListener('sourceopen', this.updateDuration_);
            this.updateDuration_ = null;
        }
        if (this.mediaSource.readyState !== 'open') {
            this.updateDuration_ = this.updateDuration.bind(this, isLive);
            this.mediaSource.addEventListener('sourceopen', this.updateDuration_);
            return;
        }
        if (isLive) {
            const seekable = this.seekable();
            if (!seekable.length) return;
             // Even in the case of a live playlist, the native MediaSource's duration should not
            // be set to Infinity (even though this would be expected for a live playlist), since
            // setting the native MediaSource's duration to infinity ends up with consequences to
            // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
            //
            // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
            // however, few browsers have support for setLiveSeekableRange()
            // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
            //
            // Until a time when the duration of the media source can be set to infinity, and a
            // seekable range specified across browsers, the duration should be greater than or
            // equal to the last possible seekable value.
            // MediaSource duration starts as NaN
            // It is possible (and probable) that this case will never be reached for many
            // sources, since the MediaSource reports duration as the highest value without
            // accounting for timestamp offset. For example, if the timestamp offset is -100 and
            // we buffered times 0 to 100 with real times of 100 to 200, even though current
            // time will be between 0 and 100, the native media source may report the duration
            // as 200. However, since we report duration separate from the media source (as
            // Infinity), and as long as the native media source duration value is greater than
            // our reported seekable range, seeks will work as expected. The large number as
            // duration for live is actually a strategy used by some players to work around the
            // issue of live seekable ranges cited above.
            if (isNaN(this.mediaSource.duration) || this.mediaSource.duration < seekable.end(seekable.length - 1)) this.sourceUpdater_.setDuration(seekable.end(seekable.length - 1));
            return;
        }
        const buffered = this.tech_.buffered();
        let duration = $cb03b711053a4297$var$Vhs$1.Playlist.duration(this.mainPlaylistLoader_.media());
        if (buffered.length > 0) duration = Math.max(duration, buffered.end(buffered.length - 1));
        if (this.mediaSource.duration !== duration) this.sourceUpdater_.setDuration(duration);
    }
    /**
   * dispose of the PlaylistController and everything
   * that it controls
   */ dispose() {
        this.trigger('dispose');
        this.decrypter_.terminate();
        this.mainPlaylistLoader_.dispose();
        this.mainSegmentLoader_.dispose();
        this.contentSteeringController_.dispose();
        this.keyStatusMap_.clear();
        if (this.loadOnPlay_) this.tech_.off('play', this.loadOnPlay_);
        [
            'AUDIO',
            'SUBTITLES'
        ].forEach((type)=>{
            const groups = this.mediaTypes_[type].groups;
            for(const id in groups)groups[id].forEach((group)=>{
                if (group.playlistLoader) group.playlistLoader.dispose();
            });
        });
        this.audioSegmentLoader_.dispose();
        this.subtitleSegmentLoader_.dispose();
        this.sourceUpdater_.dispose();
        this.timelineChangeController_.dispose();
        this.stopABRTimer_();
        if (this.updateDuration_) this.mediaSource.removeEventListener('sourceopen', this.updateDuration_);
        this.mediaSource.removeEventListener('durationchange', this.handleDurationChange_); // load the media source into the player
        this.mediaSource.removeEventListener('sourceopen', this.handleSourceOpen_);
        this.mediaSource.removeEventListener('sourceended', this.handleSourceEnded_);
        this.off();
    }
    /**
   * return the main playlist object if we have one
   *
   * @return {Object} the main playlist object that we parsed
   */ main() {
        return this.mainPlaylistLoader_.main;
    }
    /**
   * return the currently selected playlist
   *
   * @return {Object} the currently selected playlist object that we parsed
   */ media() {
        // playlist loader will not return media if it has not been fully loaded
        return this.mainPlaylistLoader_.media() || this.initialMedia_;
    }
    areMediaTypesKnown_() {
        const usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
        const hasMainMediaInfo = !!this.mainSegmentLoader_.getCurrentMediaInfo_(); // if we are not using an audio loader, then we have audio media info
        // otherwise check on the segment loader.
        const hasAudioMediaInfo = !usingAudioLoader ? true : !!this.audioSegmentLoader_.getCurrentMediaInfo_(); // one or both loaders has not loaded sufficently to get codecs
        if (!hasMainMediaInfo || !hasAudioMediaInfo) return false;
        return true;
    }
    getCodecsOrExclude_() {
        const media = {
            main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
            audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
        };
        const playlist = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media(); // set "main" media equal to video
        media.video = media.main;
        const playlistCodecs = $cb03b711053a4297$var$codecsForPlaylist(this.main(), playlist);
        const codecs = {};
        const usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
        if (media.main.hasVideo) codecs.video = playlistCodecs.video || media.main.videoCodec || (0, $jv51Y.DEFAULT_VIDEO_CODEC);
        if (media.main.isMuxed) codecs.video += `,${playlistCodecs.audio || media.main.audioCodec || (0, $jv51Y.DEFAULT_AUDIO_CODEC)}`;
        if (media.main.hasAudio && !media.main.isMuxed || media.audio.hasAudio || usingAudioLoader) {
            codecs.audio = playlistCodecs.audio || media.main.audioCodec || media.audio.audioCodec || (0, $jv51Y.DEFAULT_AUDIO_CODEC); // set audio isFmp4 so we use the correct "supports" function below
            media.audio.isFmp4 = media.main.hasAudio && !media.main.isMuxed ? media.main.isFmp4 : media.audio.isFmp4;
        } // no codecs, no playback.
        if (!codecs.audio && !codecs.video) {
            this.excludePlaylist({
                playlistToExclude: playlist,
                error: {
                    message: 'Could not determine codecs for playlist.'
                },
                playlistExclusionDuration: Infinity
            });
            return;
        } // fmp4 relies on browser support, while ts relies on muxer support
        const supportFunction = (isFmp4, codec)=>isFmp4 ? (0, $jv51Y.browserSupportsCodec)(codec, this.usingManagedMediaSource_) : (0, $jv51Y.muxerSupportsCodec)(codec);
        const unsupportedCodecs = {};
        let unsupportedAudio;
        [
            'video',
            'audio'
        ].forEach(function(type) {
            if (codecs.hasOwnProperty(type) && !supportFunction(media[type].isFmp4, codecs[type])) {
                const supporter = media[type].isFmp4 ? 'browser' : 'muxer';
                unsupportedCodecs[supporter] = unsupportedCodecs[supporter] || [];
                unsupportedCodecs[supporter].push(codecs[type]);
                if (type === 'audio') unsupportedAudio = supporter;
            }
        });
        if (usingAudioLoader && unsupportedAudio && playlist.attributes.AUDIO) {
            const audioGroup = playlist.attributes.AUDIO;
            this.main().playlists.forEach((variant)=>{
                const variantAudioGroup = variant.attributes && variant.attributes.AUDIO;
                if (variantAudioGroup === audioGroup && variant !== playlist) variant.excludeUntil = Infinity;
            });
            this.logger_(`excluding audio group ${audioGroup} as ${unsupportedAudio} does not support codec(s): "${codecs.audio}"`);
        } // if we have any unsupported codecs exclude this playlist.
        if (Object.keys(unsupportedCodecs).length) {
            const message = Object.keys(unsupportedCodecs).reduce((acc, supporter)=>{
                if (acc) acc += ', ';
                acc += `${supporter} does not support codec(s): "${unsupportedCodecs[supporter].join(',')}"`;
                return acc;
            }, '') + '.';
            this.excludePlaylist({
                playlistToExclude: playlist,
                error: {
                    internal: true,
                    message: message
                },
                playlistExclusionDuration: Infinity
            });
            return;
        } // check if codec switching is happening
        if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
            const switchMessages = [];
            [
                'video',
                'audio'
            ].forEach((type)=>{
                const newCodec = ((0, $jv51Y.parseCodecs)(this.sourceUpdater_.codecs[type] || '')[0] || {}).type;
                const oldCodec = ((0, $jv51Y.parseCodecs)(codecs[type] || '')[0] || {}).type;
                if (newCodec && oldCodec && newCodec.toLowerCase() !== oldCodec.toLowerCase()) switchMessages.push(`"${this.sourceUpdater_.codecs[type]}" -> "${codecs[type]}"`);
            });
            if (switchMessages.length) {
                this.excludePlaylist({
                    playlistToExclude: playlist,
                    error: {
                        message: `Codec switching not supported: ${switchMessages.join(', ')}.`,
                        internal: true
                    },
                    playlistExclusionDuration: Infinity
                });
                return;
            }
        } // TODO: when using the muxer shouldn't we just return
        // the codecs that the muxer outputs?
        return codecs;
    }
    /**
   * Create source buffers and exlude any incompatible renditions.
   *
   * @private
   */ tryToCreateSourceBuffers_() {
        // media source is not ready yet or sourceBuffers are already
        // created.
        if (this.mediaSource.readyState !== 'open' || this.sourceUpdater_.hasCreatedSourceBuffers()) return;
        if (!this.areMediaTypesKnown_()) return;
        const codecs = this.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
        if (!codecs) return;
        this.sourceUpdater_.createSourceBuffers(codecs);
        const codecString = [
            codecs.video,
            codecs.audio
        ].filter(Boolean).join(',');
        this.excludeIncompatibleVariants_(codecString);
    }
    /**
   * Excludes playlists with codecs that are unsupported by the muxer and browser.
   */ excludeUnsupportedVariants_() {
        const playlists = this.main().playlists;
        const ids = []; // TODO: why don't we have a property to loop through all
        // playlist? Why did we ever mix indexes and keys?
        Object.keys(playlists).forEach((key)=>{
            const variant = playlists[key]; // check if we already processed this playlist.
            if (ids.indexOf(variant.id) !== -1) return;
            ids.push(variant.id);
            const codecs = $cb03b711053a4297$var$codecsForPlaylist(this.main, variant);
            const unsupported = [];
            if (codecs.audio && !(0, $jv51Y.muxerSupportsCodec)(codecs.audio) && !(0, $jv51Y.browserSupportsCodec)(codecs.audio, this.usingManagedMediaSource_)) unsupported.push(`audio codec ${codecs.audio}`);
            if (codecs.video && !(0, $jv51Y.muxerSupportsCodec)(codecs.video) && !(0, $jv51Y.browserSupportsCodec)(codecs.video, this.usingManagedMediaSource_)) unsupported.push(`video codec ${codecs.video}`);
            if (codecs.text && codecs.text === 'stpp.ttml.im1t') unsupported.push(`text codec ${codecs.text}`);
            if (unsupported.length) {
                variant.excludeUntil = Infinity;
                this.logger_(`excluding ${variant.id} for unsupported: ${unsupported.join(', ')}`);
            }
        });
    }
    /**
   * Exclude playlists that are known to be codec or
   * stream-incompatible with the SourceBuffer configuration. For
   * instance, Media Source Extensions would cause the video element to
   * stall waiting for video data if you switched from a variant with
   * video and audio to an audio-only one.
   *
   * @param {Object} media a media playlist compatible with the current
   * set of SourceBuffers. Variants in the current main playlist that
   * do not appear to have compatible codec or stream configurations
   * will be excluded from the default playlist selection algorithm
   * indefinitely.
   * @private
   */ excludeIncompatibleVariants_(codecString) {
        const ids = [];
        const playlists = this.main().playlists;
        const codecs = $cb03b711053a4297$var$unwrapCodecList((0, $jv51Y.parseCodecs)(codecString));
        const codecCount_ = $cb03b711053a4297$var$codecCount(codecs);
        const videoDetails = codecs.video && (0, $jv51Y.parseCodecs)(codecs.video)[0] || null;
        const audioDetails = codecs.audio && (0, $jv51Y.parseCodecs)(codecs.audio)[0] || null;
        Object.keys(playlists).forEach((key)=>{
            const variant = playlists[key]; // check if we already processed this playlist.
            // or it if it is already excluded forever.
            if (ids.indexOf(variant.id) !== -1 || variant.excludeUntil === Infinity) return;
            ids.push(variant.id);
            const exclusionReasons = []; // get codecs from the playlist for this variant
            const variantCodecs = $cb03b711053a4297$var$codecsForPlaylist(this.mainPlaylistLoader_.main, variant);
            const variantCodecCount = $cb03b711053a4297$var$codecCount(variantCodecs); // if no codecs are listed, we cannot determine that this
            // variant is incompatible. Wait for mux.js to probe
            if (!variantCodecs.audio && !variantCodecs.video) return;
             // TODO: we can support this by removing the
            // old media source and creating a new one, but it will take some work.
            // The number of streams cannot change
            if (variantCodecCount !== codecCount_) exclusionReasons.push(`codec count "${variantCodecCount}" !== "${codecCount_}"`);
             // only exclude playlists by codec change, if codecs cannot switch
            // during playback.
            if (!this.sourceUpdater_.canChangeType()) {
                const variantVideoDetails = variantCodecs.video && (0, $jv51Y.parseCodecs)(variantCodecs.video)[0] || null;
                const variantAudioDetails = variantCodecs.audio && (0, $jv51Y.parseCodecs)(variantCodecs.audio)[0] || null; // the video codec cannot change
                if (variantVideoDetails && videoDetails && variantVideoDetails.type.toLowerCase() !== videoDetails.type.toLowerCase()) exclusionReasons.push(`video codec "${variantVideoDetails.type}" !== "${videoDetails.type}"`);
                 // the audio codec cannot change
                if (variantAudioDetails && audioDetails && variantAudioDetails.type.toLowerCase() !== audioDetails.type.toLowerCase()) exclusionReasons.push(`audio codec "${variantAudioDetails.type}" !== "${audioDetails.type}"`);
            }
            if (exclusionReasons.length) {
                variant.excludeUntil = Infinity;
                this.logger_(`excluding ${variant.id}: ${exclusionReasons.join(' && ')}`);
            }
        });
    }
    updateAdCues_(media) {
        let offset = 0;
        const seekable = this.seekable();
        if (seekable.length) offset = seekable.start(0);
        $cb03b711053a4297$var$updateAdCues(media, this.cueTagsTrack_, offset);
    }
    /**
   * Calculates the desired forward buffer length based on current time
   *
   * @return {number} Desired forward buffer length in seconds
   */ goalBufferLength() {
        const currentTime = this.tech_.currentTime();
        const initial = $cb03b711053a4297$var$Config.GOAL_BUFFER_LENGTH;
        const rate = $cb03b711053a4297$var$Config.GOAL_BUFFER_LENGTH_RATE;
        const max = Math.max(initial, $cb03b711053a4297$var$Config.MAX_GOAL_BUFFER_LENGTH);
        return Math.min(initial + currentTime * rate, max);
    }
    /**
   * Calculates the desired buffer low water line based on current time
   *
   * @return {number} Desired buffer low water line in seconds
   */ bufferLowWaterLine() {
        const currentTime = this.tech_.currentTime();
        const initial = $cb03b711053a4297$var$Config.BUFFER_LOW_WATER_LINE;
        const rate = $cb03b711053a4297$var$Config.BUFFER_LOW_WATER_LINE_RATE;
        const max = Math.max(initial, $cb03b711053a4297$var$Config.MAX_BUFFER_LOW_WATER_LINE);
        const newMax = Math.max(initial, $cb03b711053a4297$var$Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
        return Math.min(initial + currentTime * rate, this.bufferBasedABR ? newMax : max);
    }
    bufferHighWaterLine() {
        return $cb03b711053a4297$var$Config.BUFFER_HIGH_WATER_LINE;
    }
    addDateRangesToTextTrack_(dateRanges) {
        $cb03b711053a4297$var$createMetadataTrackIfNotExists(this.inbandTextTracks_, 'com.apple.streaming', this.tech_);
        $cb03b711053a4297$var$addDateRangeMetadata({
            inbandTextTracks: this.inbandTextTracks_,
            dateRanges: dateRanges
        });
    }
    addMetadataToTextTrack(dispatchType, metadataArray, videoDuration) {
        const timestampOffset = this.sourceUpdater_.videoBuffer ? this.sourceUpdater_.videoTimestampOffset() : this.sourceUpdater_.audioTimestampOffset(); // There's potentially an issue where we could double add metadata if there's a muxed
        // audio/video source with a metadata track, and an alt audio with a metadata track.
        // However, this probably won't happen, and if it does it can be handled then.
        $cb03b711053a4297$var$createMetadataTrackIfNotExists(this.inbandTextTracks_, dispatchType, this.tech_);
        $cb03b711053a4297$var$addMetadata({
            inbandTextTracks: this.inbandTextTracks_,
            metadataArray: metadataArray,
            timestampOffset: timestampOffset,
            videoDuration: videoDuration
        });
    }
    /**
   * Utility for getting the pathway or service location from an HLS or DASH playlist.
   *
   * @param {Object} playlist for getting pathway from.
   * @return the pathway attribute of a playlist
   */ pathwayAttribute_(playlist) {
        return playlist.attributes['PATHWAY-ID'] || playlist.attributes.serviceLocation;
    }
    /**
   * Initialize available pathways and apply the tag properties.
   */ initContentSteeringController_() {
        const main = this.main();
        if (!main.contentSteering) return;
        for (const playlist of main.playlists)this.contentSteeringController_.addAvailablePathway(this.pathwayAttribute_(playlist));
        this.contentSteeringController_.assignTagProperties(main.uri, main.contentSteering); // request the steering manifest immediately if queryBeforeStart is set.
        if (this.contentSteeringController_.queryBeforeStart) {
            // When queryBeforeStart is true, initial request should omit steering parameters.
            this.contentSteeringController_.requestSteeringManifest(true);
            return;
        } // otherwise start content steering after playback starts
        this.tech_.one('canplay', ()=>{
            this.contentSteeringController_.requestSteeringManifest();
        });
    }
    /**
   * Reset the content steering controller and re-init.
   */ resetContentSteeringController_() {
        this.contentSteeringController_.clearAvailablePathways();
        this.contentSteeringController_.dispose();
        this.initContentSteeringController_();
    }
    /**
   * Attaches the listeners for content steering.
   */ attachContentSteeringListeners_() {
        this.contentSteeringController_.on('content-steering', this.excludeThenChangePathway_.bind(this));
        const contentSteeringEvents = [
            'contentsteeringloadstart',
            'contentsteeringloadcomplete',
            'contentsteeringparsed'
        ];
        contentSteeringEvents.forEach((eventName)=>{
            this.contentSteeringController_.on(eventName, (metadata)=>{
                this.trigger((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, metadata));
            });
        });
        if (this.sourceType_ === 'dash') this.mainPlaylistLoader_.on('loadedplaylist', ()=>{
            const main = this.main(); // check if steering tag or pathways changed.
            const didDashTagChange = this.contentSteeringController_.didDASHTagChange(main.uri, main.contentSteering);
            const didPathwaysChange = ()=>{
                const availablePathways = this.contentSteeringController_.getAvailablePathways();
                const newPathways = [];
                for (const playlist of main.playlists){
                    const serviceLocation = playlist.attributes.serviceLocation;
                    if (serviceLocation) {
                        newPathways.push(serviceLocation);
                        if (!availablePathways.has(serviceLocation)) return true;
                    }
                } // If we have no new serviceLocations and previously had availablePathways
                if (!newPathways.length && availablePathways.size) return true;
                return false;
            };
            if (didDashTagChange || didPathwaysChange()) this.resetContentSteeringController_();
        });
    }
    /**
   * Simple exclude and change playlist logic for content steering.
   */ excludeThenChangePathway_() {
        const currentPathway = this.contentSteeringController_.getPathway();
        if (!currentPathway) return;
        this.handlePathwayClones_();
        const main = this.main();
        const playlists = main.playlists;
        const ids = new Set();
        let didEnablePlaylists = false;
        Object.keys(playlists).forEach((key)=>{
            const variant = playlists[key];
            const pathwayId = this.pathwayAttribute_(variant);
            const differentPathwayId = pathwayId && currentPathway !== pathwayId;
            const steeringExclusion = variant.excludeUntil === Infinity && variant.lastExcludeReason_ === 'content-steering';
            if (steeringExclusion && !differentPathwayId) {
                delete variant.excludeUntil;
                delete variant.lastExcludeReason_;
                didEnablePlaylists = true;
            }
            const noExcludeUntil = !variant.excludeUntil && variant.excludeUntil !== Infinity;
            const shouldExclude = !ids.has(variant.id) && differentPathwayId && noExcludeUntil;
            if (!shouldExclude) return;
            ids.add(variant.id);
            variant.excludeUntil = Infinity;
            variant.lastExcludeReason_ = 'content-steering'; // TODO: kind of spammy, maybe move this.
            this.logger_(`excluding ${variant.id} for ${variant.lastExcludeReason_}`);
        });
        if (this.contentSteeringController_.manifestType_ === 'DASH') Object.keys(this.mediaTypes_).forEach((key)=>{
            const type = this.mediaTypes_[key];
            if (type.activePlaylistLoader) {
                const currentPlaylist = type.activePlaylistLoader.media_; // Check if the current media playlist matches the current CDN
                if (currentPlaylist && currentPlaylist.attributes.serviceLocation !== currentPathway) didEnablePlaylists = true;
            }
        });
        if (didEnablePlaylists) this.changeSegmentPathway_();
    }
    /**
   * Add, update, or delete playlists and media groups for
   * the pathway clones for HLS Content Steering.
   *
   * See https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/
   *
   * NOTE: Pathway cloning does not currently support the `PER_VARIANT_URIS` and
   * `PER_RENDITION_URIS` as we do not handle `STABLE-VARIANT-ID` or
   * `STABLE-RENDITION-ID` values.
   */ handlePathwayClones_() {
        const main = this.main();
        const playlists = main.playlists;
        const currentPathwayClones = this.contentSteeringController_.currentPathwayClones;
        const nextPathwayClones = this.contentSteeringController_.nextPathwayClones;
        const hasClones = currentPathwayClones && currentPathwayClones.size || nextPathwayClones && nextPathwayClones.size;
        if (!hasClones) return;
        for (const [id, clone] of currentPathwayClones.entries()){
            const newClone = nextPathwayClones.get(id); // Delete the old pathway clone.
            if (!newClone) {
                this.mainPlaylistLoader_.updateOrDeleteClone(clone);
                this.contentSteeringController_.excludePathway(id);
            }
        }
        for (const [id, clone] of nextPathwayClones.entries()){
            const oldClone = currentPathwayClones.get(id); // Create a new pathway if it is a new pathway clone object.
            if (!oldClone) {
                const playlistsToClone = playlists.filter((p)=>{
                    return p.attributes['PATHWAY-ID'] === clone['BASE-ID'];
                });
                playlistsToClone.forEach((p)=>{
                    this.mainPlaylistLoader_.addClonePathway(clone, p);
                });
                this.contentSteeringController_.addAvailablePathway(id);
                continue;
            } // There have not been changes to the pathway clone object, so skip.
            if (this.equalPathwayClones_(oldClone, clone)) continue;
             // Update a preexisting cloned pathway.
            // True is set for the update flag.
            this.mainPlaylistLoader_.updateOrDeleteClone(clone, true);
            this.contentSteeringController_.addAvailablePathway(id);
        } // Deep copy contents of next to current pathways.
        this.contentSteeringController_.currentPathwayClones = new Map(JSON.parse(JSON.stringify([
            ...nextPathwayClones
        ])));
    }
    /**
   * Determines whether two pathway clone objects are equivalent.
   *
   * @param {Object} a The first pathway clone object.
   * @param {Object} b The second pathway clone object.
   * @return {boolean} True if the pathway clone objects are equal, false otherwise.
   */ equalPathwayClones_(a, b) {
        if (a['BASE-ID'] !== b['BASE-ID'] || a.ID !== b.ID || a['URI-REPLACEMENT'].HOST !== b['URI-REPLACEMENT'].HOST) return false;
        const aParams = a['URI-REPLACEMENT'].PARAMS;
        const bParams = b['URI-REPLACEMENT'].PARAMS; // We need to iterate through both lists of params because one could be
        // missing a parameter that the other has.
        for(const p in aParams){
            if (aParams[p] !== bParams[p]) return false;
        }
        for(const p in bParams){
            if (aParams[p] !== bParams[p]) return false;
        }
        return true;
    }
    /**
   * Changes the current playlists for audio, video and subtitles after a new pathway
   * is chosen from content steering.
   */ changeSegmentPathway_() {
        const nextPlaylist = this.selectPlaylist();
        this.pauseLoading(); // Switch audio and text track playlists if necessary in DASH
        if (this.contentSteeringController_.manifestType_ === 'DASH') this.switchMediaForDASHContentSteering_();
        this.switchMedia_(nextPlaylist, 'content-steering');
    }
    /**
   * Iterates through playlists and check their keyId set and compare with the
   * keyStatusMap, only enable playlists that have a usable key. If the playlist
   * has no keyId leave it enabled by default.
   */ excludeNonUsablePlaylistsByKeyId_() {
        if (!this.mainPlaylistLoader_ || !this.mainPlaylistLoader_.main) return;
        let nonUsableKeyStatusCount = 0;
        const NON_USABLE = 'non-usable';
        this.mainPlaylistLoader_.main.playlists.forEach((playlist)=>{
            const keyIdSet = this.mainPlaylistLoader_.getKeyIdSet(playlist); // If the playlist doesn't have keyIDs lets not exclude it.
            if (!keyIdSet || !keyIdSet.size) return;
            keyIdSet.forEach((key)=>{
                const USABLE = 'usable';
                const hasUsableKeyStatus = this.keyStatusMap_.has(key) && this.keyStatusMap_.get(key) === USABLE;
                const nonUsableExclusion = playlist.lastExcludeReason_ === NON_USABLE && playlist.excludeUntil === Infinity;
                if (!hasUsableKeyStatus) {
                    // Only exclude playlists that haven't already been excluded as non-usable.
                    if (playlist.excludeUntil !== Infinity && playlist.lastExcludeReason_ !== NON_USABLE) {
                        playlist.excludeUntil = Infinity;
                        playlist.lastExcludeReason_ = NON_USABLE;
                        this.logger_(`excluding playlist ${playlist.id} because the key ID ${key} doesn't exist in the keyStatusMap or is not ${USABLE}`);
                    } // count all nonUsableKeyStatus
                    nonUsableKeyStatusCount++;
                } else if (hasUsableKeyStatus && nonUsableExclusion) {
                    delete playlist.excludeUntil;
                    delete playlist.lastExcludeReason_;
                    this.logger_(`enabling playlist ${playlist.id} because key ID ${key} is ${USABLE}`);
                }
            });
        }); // If for whatever reason every playlist has a non usable key status. Lets try re-including the SD renditions as a failsafe.
        if (nonUsableKeyStatusCount >= this.mainPlaylistLoader_.main.playlists.length) this.mainPlaylistLoader_.main.playlists.forEach((playlist)=>{
            const isNonHD = playlist && playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height < 720;
            const excludedForNonUsableKey = playlist.excludeUntil === Infinity && playlist.lastExcludeReason_ === NON_USABLE;
            if (isNonHD && excludedForNonUsableKey) {
                // Only delete the excludeUntil so we don't try and re-exclude these playlists.
                delete playlist.excludeUntil;
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`enabling non-HD playlist ${playlist.id} because all playlists were excluded due to ${NON_USABLE} key IDs`);
            }
        });
    }
    /**
   * Adds a keystatus to the keystatus map, tries to convert to string if necessary.
   *
   * @param {any} keyId the keyId to add a status for
   * @param {string} status the status of the keyId
   */ addKeyStatus_(keyId, status) {
        const isString = typeof keyId === 'string';
        const keyIdHexString = isString ? keyId : $cb03b711053a4297$var$bufferToHexString(keyId);
        const formattedKeyIdString = keyIdHexString.slice(0, 32).toLowerCase();
        this.logger_(`KeyStatus '${status}' with key ID ${formattedKeyIdString} added to the keyStatusMap`);
        this.keyStatusMap_.set(formattedKeyIdString, status);
    }
    /**
   * Utility function for adding key status to the keyStatusMap and filtering usable encrypted playlists.
   *
   * @param {any} keyId the keyId from the keystatuschange event
   * @param {string} status the key status string
   */ updatePlaylistByKeyStatus(keyId, status) {
        this.addKeyStatus_(keyId, status);
        if (!this.waitingForFastQualityPlaylistReceived_) this.excludeNonUsableThenChangePlaylist_();
         // Listen to loadedplaylist with a single listener and check for new contentProtection elements when a playlist is updated.
        this.mainPlaylistLoader_.off('loadedplaylist', this.excludeNonUsableThenChangePlaylist_.bind(this));
        this.mainPlaylistLoader_.on('loadedplaylist', this.excludeNonUsableThenChangePlaylist_.bind(this));
    }
    excludeNonUsableThenChangePlaylist_() {
        this.excludeNonUsablePlaylistsByKeyId_();
        this.fastQualityChange_();
    }
}
/**
 * Returns a function that acts as the Enable/disable playlist function.
 *
 * @param {PlaylistLoader} loader - The main playlist loader
 * @param {string} playlistID - id of the playlist
 * @param {Function} changePlaylistFn - A function to be called after a
 * playlist's enabled-state has been changed. Will NOT be called if a
 * playlist's enabled-state is unchanged
 * @param {boolean=} enable - Value to set the playlist enabled-state to
 * or if undefined returns the current enabled-state for the playlist
 * @return {Function} Function for setting/getting enabled
 */ const $cb03b711053a4297$var$enableFunction = (loader, playlistID, changePlaylistFn)=>(enable)=>{
        const playlist = loader.main.playlists[playlistID];
        const incompatible = $cb03b711053a4297$var$isIncompatible(playlist);
        const currentlyEnabled = $cb03b711053a4297$var$isEnabled(playlist);
        if (typeof enable === 'undefined') return currentlyEnabled;
        if (enable) delete playlist.disabled;
        else playlist.disabled = true;
        const metadata = {
            renditionInfo: {
                id: playlistID,
                bandwidth: playlist.attributes.BANDWIDTH,
                resolution: playlist.attributes.RESOLUTION,
                codecs: playlist.attributes.CODECS
            },
            cause: 'fast-quality'
        };
        if (enable !== currentlyEnabled && !incompatible) {
            // Ensure the outside world knows about our changes
            if (enable) {
                // call fast quality change only when the playlist is enabled
                changePlaylistFn(playlist);
                loader.trigger({
                    type: 'renditionenabled',
                    metadata: metadata
                });
            } else loader.trigger({
                type: 'renditiondisabled',
                metadata: metadata
            });
        }
        return enable;
    };
/**
 * The representation object encapsulates the publicly visible information
 * in a media playlist along with a setter/getter-type function (enabled)
 * for changing the enabled-state of a particular playlist entry
 *
 * @class Representation
 */ class $cb03b711053a4297$var$Representation {
    constructor(vhsHandler, playlist, id){
        const { playlistController_: pc } = vhsHandler;
        const qualityChangeFunction = pc.fastQualityChange_.bind(pc); // some playlist attributes are optional
        if (playlist.attributes) {
            const resolution = playlist.attributes.RESOLUTION;
            this.width = resolution && resolution.width;
            this.height = resolution && resolution.height;
            this.bandwidth = playlist.attributes.BANDWIDTH;
            this.frameRate = playlist.attributes['FRAME-RATE'];
        }
        this.codecs = $cb03b711053a4297$var$codecsForPlaylist(pc.main(), playlist);
        this.playlist = playlist; // The id is simply the ordinality of the media playlist
        // within the main playlist
        this.id = id; // Partially-apply the enableFunction to create a playlist-
        // specific variant
        this.enabled = $cb03b711053a4297$var$enableFunction(vhsHandler.playlists, playlist.id, qualityChangeFunction);
    }
}
/**
 * A mixin function that adds the `representations` api to an instance
 * of the VhsHandler class
 *
 * @param {VhsHandler} vhsHandler - An instance of VhsHandler to add the
 * representation API into
 */ const $cb03b711053a4297$var$renditionSelectionMixin = function(vhsHandler) {
    // Add a single API-specific function to the VhsHandler instance
    vhsHandler.representations = ()=>{
        const main = vhsHandler.playlistController_.main();
        const playlists = $cb03b711053a4297$var$isAudioOnly(main) ? vhsHandler.playlistController_.getAudioTrackPlaylists_() : main.playlists;
        if (!playlists) return [];
        return playlists.filter((media)=>!$cb03b711053a4297$var$isIncompatible(media)).map((e, i)=>new $cb03b711053a4297$var$Representation(vhsHandler, e, e.id));
    };
};
/**
 * @file playback-watcher.js
 *
 * Playback starts, and now my watch begins. It shall not end until my death. I shall
 * take no wait, hold no uncleared timeouts, father no bad seeks. I shall wear no crowns
 * and win no glory. I shall live and die at my post. I am the corrector of the underflow.
 * I am the watcher of gaps. I am the shield that guards the realms of seekable. I pledge
 * my life and honor to the Playback Watch, for this Player and all the Players to come.
 */ const $cb03b711053a4297$var$timerCancelEvents = [
    'seeking',
    'seeked',
    'pause',
    'playing',
    'error'
];
/**
 * @class PlaybackWatcher
 */ class $cb03b711053a4297$var$PlaybackWatcher extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    /**
   * Represents an PlaybackWatcher object.
   *
   * @class
   * @param {Object} options an object that includes the tech and settings
   */ constructor(options){
        super();
        this.playlistController_ = options.playlistController;
        this.tech_ = options.tech;
        this.seekable = options.seekable;
        this.allowSeeksWithinUnsafeLiveWindow = options.allowSeeksWithinUnsafeLiveWindow;
        this.liveRangeSafeTimeDelta = options.liveRangeSafeTimeDelta;
        this.media = options.media;
        this.playedRanges_ = [];
        this.consecutiveUpdates = 0;
        this.lastRecordedTime = null;
        this.checkCurrentTimeTimeout_ = null;
        this.logger_ = $cb03b711053a4297$var$logger('PlaybackWatcher');
        this.logger_('initialize');
        const playHandler = ()=>this.monitorCurrentTime_();
        const canPlayHandler = ()=>this.monitorCurrentTime_();
        const waitingHandler = ()=>this.techWaiting_();
        const cancelTimerHandler = ()=>this.resetTimeUpdate_();
        const pc = this.playlistController_;
        const loaderTypes = [
            'main',
            'subtitle',
            'audio'
        ];
        const loaderChecks = {};
        loaderTypes.forEach((type)=>{
            loaderChecks[type] = {
                reset: ()=>this.resetSegmentDownloads_(type),
                updateend: ()=>this.checkSegmentDownloads_(type)
            };
            pc[`${type}SegmentLoader_`].on('appendsdone', loaderChecks[type].updateend); // If a rendition switch happens during a playback stall where the buffer
            // isn't changing we want to reset. We cannot assume that the new rendition
            // will also be stalled, until after new appends.
            pc[`${type}SegmentLoader_`].on('playlistupdate', loaderChecks[type].reset); // Playback stalls should not be detected right after seeking.
            // This prevents one segment playlists (single vtt or single segment content)
            // from being detected as stalling. As the buffer will not change in those cases, since
            // the buffer is the entire video duration.
            this.tech_.on([
                'seeked',
                'seeking'
            ], loaderChecks[type].reset);
        });
        /**
     * We check if a seek was into a gap through the following steps:
     * 1. We get a seeking event and we do not get a seeked event. This means that
     *    a seek was attempted but not completed.
     * 2. We run `fixesBadSeeks_` on segment loader appends. This means that we already
     *    removed everything from our buffer and appended a segment, and should be ready
     *    to check for gaps.
     */ const setSeekingHandlers = (fn)=>{
            [
                'main',
                'audio'
            ].forEach((type)=>{
                pc[`${type}SegmentLoader_`][fn]('appended', this.seekingAppendCheck_);
            });
        };
        this.seekingAppendCheck_ = ()=>{
            if (this.fixesBadSeeks_()) {
                this.consecutiveUpdates = 0;
                this.lastRecordedTime = this.tech_.currentTime();
                setSeekingHandlers('off');
            }
        };
        this.clearSeekingAppendCheck_ = ()=>setSeekingHandlers('off');
        this.watchForBadSeeking_ = ()=>{
            this.clearSeekingAppendCheck_();
            setSeekingHandlers('on');
        };
        this.tech_.on('seeked', this.clearSeekingAppendCheck_);
        this.tech_.on('seeking', this.watchForBadSeeking_);
        this.tech_.on('waiting', waitingHandler);
        this.tech_.on($cb03b711053a4297$var$timerCancelEvents, cancelTimerHandler);
        this.tech_.on('canplay', canPlayHandler);
        /*
      An edge case exists that results in gaps not being skipped when they exist at the beginning of a stream. This case
      is surfaced in one of two ways:
       1)  The `waiting` event is fired before the player has buffered content, making it impossible
          to find or skip the gap. The `waiting` event is followed by a `play` event. On first play
          we can check if playback is stalled due to a gap, and skip the gap if necessary.
      2)  A source with a gap at the beginning of the stream is loaded programatically while the player
          is in a playing state. To catch this case, it's important that our one-time play listener is setup
          even if the player is in a playing state
    */ this.tech_.one('play', playHandler); // Define the dispose function to clean up our events
        this.dispose = ()=>{
            this.clearSeekingAppendCheck_();
            this.logger_('dispose');
            this.tech_.off('waiting', waitingHandler);
            this.tech_.off($cb03b711053a4297$var$timerCancelEvents, cancelTimerHandler);
            this.tech_.off('canplay', canPlayHandler);
            this.tech_.off('play', playHandler);
            this.tech_.off('seeking', this.watchForBadSeeking_);
            this.tech_.off('seeked', this.clearSeekingAppendCheck_);
            loaderTypes.forEach((type)=>{
                pc[`${type}SegmentLoader_`].off('appendsdone', loaderChecks[type].updateend);
                pc[`${type}SegmentLoader_`].off('playlistupdate', loaderChecks[type].reset);
                this.tech_.off([
                    'seeked',
                    'seeking'
                ], loaderChecks[type].reset);
            });
            if (this.checkCurrentTimeTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkCurrentTimeTimeout_);
            this.resetTimeUpdate_();
        };
    }
    /**
   * Periodically check current time to see if playback stopped
   *
   * @private
   */ monitorCurrentTime_() {
        this.checkCurrentTime_();
        if (this.checkCurrentTimeTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkCurrentTimeTimeout_);
         // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
        this.checkCurrentTimeTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(this.monitorCurrentTime_.bind(this), 250);
    }
    /**
   * Reset stalled download stats for a specific type of loader
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#playlistupdate
   * @listens Tech#seeking
   * @listens Tech#seeked
   */ resetSegmentDownloads_(type) {
        const loader = this.playlistController_[`${type}SegmentLoader_`];
        if (this[`${type}StalledDownloads_`] > 0) this.logger_(`resetting possible stalled download count for ${type} loader`);
        this[`${type}StalledDownloads_`] = 0;
        this[`${type}Buffered_`] = loader.buffered_();
    }
    /**
   * Checks on every segment `appendsdone` to see
   * if segment appends are making progress. If they are not
   * and we are still downloading bytes. We exclude the playlist.
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#appendsdone
   */ checkSegmentDownloads_(type) {
        const pc = this.playlistController_;
        const loader = pc[`${type}SegmentLoader_`];
        const buffered = loader.buffered_();
        const isBufferedDifferent = $cb03b711053a4297$var$isRangeDifferent(this[`${type}Buffered_`], buffered);
        this[`${type}Buffered_`] = buffered; // if another watcher is going to fix the issue or
        // the buffered value for this loader changed
        // appends are working
        if (isBufferedDifferent) {
            const metadata = {
                bufferedRanges: buffered
            };
            pc.trigger({
                type: 'bufferedrangeschanged',
                metadata: metadata
            });
            this.resetSegmentDownloads_(type);
            return;
        }
        this[`${type}StalledDownloads_`]++;
        this.logger_(`found #${this[`${type}StalledDownloads_`]} ${type} appends that did not increase buffer (possible stalled download)`, {
            playlistId: loader.playlist_ && loader.playlist_.id,
            buffered: $cb03b711053a4297$var$timeRangesToArray(buffered)
        }); // after 10 possibly stalled appends with no reset, exclude
        if (this[`${type}StalledDownloads_`] < 10) return;
        this.logger_(`${type} loader stalled download exclusion`);
        this.resetSegmentDownloads_(type);
        this.tech_.trigger({
            type: 'usage',
            name: `vhs-${type}-download-exclusion`
        });
        if (type === 'subtitle') return;
         // TODO: should we exclude audio tracks rather than main tracks
        // when type is audio?
        pc.excludePlaylist({
            error: {
                message: `Excessive ${type} segment downloading detected.`
            },
            playlistExclusionDuration: Infinity
        });
    }
    /**
   * The purpose of this function is to emulate the "waiting" event on
   * browsers that do not emit it when they are waiting for more
   * data to continue playback
   *
   * @private
   */ checkCurrentTime_() {
        if (this.tech_.paused() || this.tech_.seeking()) return;
        const currentTime = this.tech_.currentTime();
        const buffered = this.tech_.buffered();
        if (this.lastRecordedTime === currentTime && (!buffered.length || currentTime + $cb03b711053a4297$var$SAFE_TIME_DELTA >= buffered.end(buffered.length - 1))) // If current time is at the end of the final buffered region, then any playback
        // stall is most likely caused by buffering in a low bandwidth environment. The tech
        // should fire a `waiting` event in this scenario, but due to browser and tech
        // inconsistencies. Calling `techWaiting_` here allows us to simulate
        // responding to a native `waiting` event when the tech fails to emit one.
        return this.techWaiting_();
        if (this.consecutiveUpdates >= 5 && currentTime === this.lastRecordedTime) {
            this.consecutiveUpdates++;
            this.waiting_();
        } else if (currentTime === this.lastRecordedTime) this.consecutiveUpdates++;
        else {
            this.playedRanges_.push($cb03b711053a4297$var$createTimeRanges([
                this.lastRecordedTime,
                currentTime
            ]));
            const metadata = {
                playedRanges: this.playedRanges_
            };
            this.playlistController_.trigger({
                type: 'playedrangeschanged',
                metadata: metadata
            });
            this.consecutiveUpdates = 0;
            this.lastRecordedTime = currentTime;
        }
    }
    /**
   * Resets the 'timeupdate' mechanism designed to detect that we are stalled
   *
   * @private
   */ resetTimeUpdate_() {
        this.consecutiveUpdates = 0;
    }
    /**
   * Fixes situations where there's a bad seek
   *
   * @return {boolean} whether an action was taken to fix the seek
   * @private
   */ fixesBadSeeks_() {
        const seeking = this.tech_.seeking();
        if (!seeking) return false;
         // TODO: It's possible that these seekable checks should be moved out of this function
        // and into a function that runs on seekablechange. It's also possible that we only need
        // afterSeekableWindow as the buffered check at the bottom is good enough to handle before
        // seekable range.
        const seekable = this.seekable();
        const currentTime = this.tech_.currentTime();
        const isAfterSeekableRange = this.afterSeekableWindow_(seekable, currentTime, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
        let seekTo;
        if (isAfterSeekableRange) {
            const seekableEnd = seekable.end(seekable.length - 1); // sync to live point (if VOD, our seekable was updated and we're simply adjusting)
            seekTo = seekableEnd;
        }
        if (this.beforeSeekableWindow_(seekable, currentTime)) {
            const seekableStart = seekable.start(0); // sync to the beginning of the live window
            // provide a buffer of .1 seconds to handle rounding/imprecise numbers
            seekTo = seekableStart + // if the playlist is too short and the seekable range is an exact time (can
            // happen in live with a 3 segment playlist), then don't use a time delta
            (seekableStart === seekable.end(0) ? 0 : $cb03b711053a4297$var$SAFE_TIME_DELTA);
        }
        if (typeof seekTo !== 'undefined') {
            this.logger_(`Trying to seek outside of seekable at time ${currentTime} with ` + `seekable range ${$cb03b711053a4297$var$printableRange(seekable)}. Seeking to ` + `${seekTo}.`);
            this.tech_.setCurrentTime(seekTo);
            return true;
        }
        const sourceUpdater = this.playlistController_.sourceUpdater_;
        const buffered = this.tech_.buffered();
        const audioBuffered = sourceUpdater.audioBuffer ? sourceUpdater.audioBuffered() : null;
        const videoBuffered = sourceUpdater.videoBuffer ? sourceUpdater.videoBuffered() : null;
        const media = this.media(); // verify that at least two segment durations or one part duration have been
        // appended before checking for a gap.
        const minAppendedDuration = media.partTargetDuration ? media.partTargetDuration : (media.targetDuration - $cb03b711053a4297$var$TIME_FUDGE_FACTOR) * 2; // verify that at least two segment durations have been
        // appended before checking for a gap.
        const bufferedToCheck = [
            audioBuffered,
            videoBuffered
        ];
        for(let i = 0; i < bufferedToCheck.length; i++){
            // skip null buffered
            if (!bufferedToCheck[i]) continue;
            const timeAhead = $cb03b711053a4297$var$timeAheadOf(bufferedToCheck[i], currentTime); // if we are less than two video/audio segment durations or one part
            // duration behind we haven't appended enough to call this a bad seek.
            if (timeAhead < minAppendedDuration) return false;
        }
        const nextRange = $cb03b711053a4297$var$findNextRange(buffered, currentTime); // we have appended enough content, but we don't have anything buffered
        // to seek over the gap
        if (nextRange.length === 0) return false;
        seekTo = nextRange.start(0) + $cb03b711053a4297$var$SAFE_TIME_DELTA;
        this.logger_(`Buffered region starts (${nextRange.start(0)}) ` + ` just beyond seek point (${currentTime}). Seeking to ${seekTo}.`);
        this.tech_.setCurrentTime(seekTo);
        return true;
    }
    /**
   * Handler for situations when we determine the player is waiting.
   *
   * @private
   */ waiting_() {
        if (this.techWaiting_()) return;
         // All tech waiting checks failed. Use last resort correction
        const currentTime = this.tech_.currentTime();
        const buffered = this.tech_.buffered();
        const currentRange = $cb03b711053a4297$var$findRange(buffered, currentTime); // Sometimes the player can stall for unknown reasons within a contiguous buffered
        // region with no indication that anything is amiss (seen in Firefox). Seeking to
        // currentTime is usually enough to kickstart the player. This checks that the player
        // is currently within a buffered region before attempting a corrective seek.
        // Chrome does not appear to continue `timeupdate` events after a `waiting` event
        // until there is ~ 3 seconds of forward buffer available. PlaybackWatcher should also
        // make sure there is ~3 seconds of forward buffer before taking any corrective action
        // to avoid triggering an `unknownwaiting` event when the network is slow.
        if (currentRange.length && currentTime + 3 <= currentRange.end(0)) {
            this.resetTimeUpdate_();
            this.tech_.setCurrentTime(currentTime);
            this.logger_(`Stopped at ${currentTime} while inside a buffered region ` + `[${currentRange.start(0)} -> ${currentRange.end(0)}]. Attempting to resume ` + 'playback by seeking to the current time.'); // unknown waiting corrections may be useful for monitoring QoS
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-unknown-waiting'
            });
            return;
        }
    }
    /**
   * Handler for situations when the tech fires a `waiting` event
   *
   * @return {boolean}
   *         True if an action (or none) was needed to correct the waiting. False if no
   *         checks passed
   * @private
   */ techWaiting_() {
        const seekable = this.seekable();
        const currentTime = this.tech_.currentTime();
        if (this.tech_.seeking()) // Tech is seeking or already waiting on another action, no action needed
        return true;
        if (this.beforeSeekableWindow_(seekable, currentTime)) {
            const livePoint = seekable.end(seekable.length - 1);
            this.logger_(`Fell out of live window at time ${currentTime}. Seeking to ` + `live point (seekable end) ${livePoint}`);
            this.resetTimeUpdate_();
            this.tech_.setCurrentTime(livePoint); // live window resyncs may be useful for monitoring QoS
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-live-resync'
            });
            return true;
        }
        const sourceUpdater = this.tech_.vhs.playlistController_.sourceUpdater_;
        const buffered = this.tech_.buffered();
        const videoUnderflow = this.videoUnderflow_({
            audioBuffered: sourceUpdater.audioBuffered(),
            videoBuffered: sourceUpdater.videoBuffered(),
            currentTime: currentTime
        });
        if (videoUnderflow) {
            // Even though the video underflowed and was stuck in a gap, the audio overplayed
            // the gap, leading currentTime into a buffered range. Seeking to currentTime
            // allows the video to catch up to the audio position without losing any audio
            // (only suffering ~3 seconds of frozen video and a pause in audio playback).
            this.resetTimeUpdate_();
            this.tech_.setCurrentTime(currentTime); // video underflow may be useful for monitoring QoS
            this.tech_.trigger({
                type: 'usage',
                name: 'vhs-video-underflow'
            });
            return true;
        }
        const nextRange = $cb03b711053a4297$var$findNextRange(buffered, currentTime); // check for gap
        if (nextRange.length > 0) {
            this.logger_(`Stopped at ${currentTime} and seeking to ${nextRange.start(0)}`);
            this.resetTimeUpdate_();
            this.skipTheGap_(currentTime);
            return true;
        } // All checks failed. Returning false to indicate failure to correct waiting
        return false;
    }
    afterSeekableWindow_(seekable, currentTime, playlist, allowSeeksWithinUnsafeLiveWindow = false) {
        if (!seekable.length) // we can't make a solid case if there's no seekable, default to false
        return false;
        let allowedEnd = seekable.end(seekable.length - 1) + $cb03b711053a4297$var$SAFE_TIME_DELTA;
        const isLive = !playlist.endList;
        const isLLHLS = typeof playlist.partTargetDuration === 'number';
        if (isLive && (isLLHLS || allowSeeksWithinUnsafeLiveWindow)) allowedEnd = seekable.end(seekable.length - 1) + playlist.targetDuration * 3;
        if (currentTime > allowedEnd) return true;
        return false;
    }
    beforeSeekableWindow_(seekable, currentTime) {
        if (seekable.length && // can't fall before 0 and 0 seekable start identifies VOD stream
        seekable.start(0) > 0 && currentTime < seekable.start(0) - this.liveRangeSafeTimeDelta) return true;
        return false;
    }
    videoUnderflow_({ videoBuffered: videoBuffered, audioBuffered: audioBuffered, currentTime: currentTime }) {
        // audio only content will not have video underflow :)
        if (!videoBuffered) return;
        let gap; // find a gap in demuxed content.
        if (videoBuffered.length && audioBuffered.length) {
            // in Chrome audio will continue to play for ~3s when we run out of video
            // so we have to check that the video buffer did have some buffer in the
            // past.
            const lastVideoRange = $cb03b711053a4297$var$findRange(videoBuffered, currentTime - 3);
            const videoRange = $cb03b711053a4297$var$findRange(videoBuffered, currentTime);
            const audioRange = $cb03b711053a4297$var$findRange(audioBuffered, currentTime);
            if (audioRange.length && !videoRange.length && lastVideoRange.length) gap = {
                start: lastVideoRange.end(0),
                end: audioRange.end(0)
            };
             // find a gap in muxed content.
        } else {
            const nextRange = $cb03b711053a4297$var$findNextRange(videoBuffered, currentTime); // Even if there is no available next range, there is still a possibility we are
            // stuck in a gap due to video underflow.
            if (!nextRange.length) gap = this.gapFromVideoUnderflow_(videoBuffered, currentTime);
        }
        if (gap) {
            this.logger_(`Encountered a gap in video from ${gap.start} to ${gap.end}. ` + `Seeking to current time ${currentTime}`);
            return true;
        }
        return false;
    }
    /**
   * Timer callback. If playback still has not proceeded, then we seek
   * to the start of the next buffered region.
   *
   * @private
   */ skipTheGap_(scheduledCurrentTime) {
        const buffered = this.tech_.buffered();
        const currentTime = this.tech_.currentTime();
        const nextRange = $cb03b711053a4297$var$findNextRange(buffered, currentTime);
        this.resetTimeUpdate_();
        if (nextRange.length === 0 || currentTime !== scheduledCurrentTime) return;
        this.logger_('skipTheGap_:', 'currentTime:', currentTime, 'scheduled currentTime:', scheduledCurrentTime, 'nextRange start:', nextRange.start(0)); // only seek if we still have not played
        this.tech_.setCurrentTime(nextRange.start(0) + $cb03b711053a4297$var$TIME_FUDGE_FACTOR);
        const metadata = {
            gapInfo: {
                from: currentTime,
                to: nextRange.start(0)
            }
        };
        this.playlistController_.trigger({
            type: 'gapjumped',
            metadata: metadata
        });
        this.tech_.trigger({
            type: 'usage',
            name: 'vhs-gap-skip'
        });
    }
    gapFromVideoUnderflow_(buffered, currentTime) {
        // At least in Chrome, if there is a gap in the video buffer, the audio will continue
        // playing for ~3 seconds after the video gap starts. This is done to account for
        // video buffer underflow/underrun (note that this is not done when there is audio
        // buffer underflow/underrun -- in that case the video will stop as soon as it
        // encounters the gap, as audio stalls are more noticeable/jarring to a user than
        // video stalls). The player's time will reflect the playthrough of audio, so the
        // time will appear as if we are in a buffered region, even if we are stuck in a
        // "gap."
        //
        // Example:
        // video buffer:   0 => 10.1, 10.2 => 20
        // audio buffer:   0 => 20
        // overall buffer: 0 => 10.1, 10.2 => 20
        // current time: 13
        //
        // Chrome's video froze at 10 seconds, where the video buffer encountered the gap,
        // however, the audio continued playing until it reached ~3 seconds past the gap
        // (13 seconds), at which point it stops as well. Since current time is past the
        // gap, findNextRange will return no ranges.
        //
        // To check for this issue, we see if there is a gap that starts somewhere within
        // a 3 second range (3 seconds +/- 1 second) back from our current time.
        const gaps = $cb03b711053a4297$var$findGaps(buffered);
        for(let i = 0; i < gaps.length; i++){
            const start = gaps.start(i);
            const end = gaps.end(i); // gap is starts no more than 4 seconds back
            if (currentTime - start < 4 && currentTime - start > 2) return {
                start: start,
                end: end
            };
        }
        return null;
    }
}
const $cb03b711053a4297$var$defaultOptions = {
    errorInterval: 30,
    getSource (next) {
        const tech = this.tech({
            IWillNotUseThisInPlugins: true
        });
        const sourceObj = tech.currentSource_ || this.currentSource();
        return next(sourceObj);
    }
};
/**
 * Main entry point for the plugin
 *
 * @param {Player} player a reference to a videojs Player instance
 * @param {Object} [options] an object with plugin options
 * @private
 */ const $cb03b711053a4297$var$initPlugin = function(player, options) {
    let lastCalled = 0;
    let seekTo = 0;
    const localOptions = $cb03b711053a4297$var$merge($cb03b711053a4297$var$defaultOptions, options);
    player.ready(()=>{
        player.trigger({
            type: 'usage',
            name: 'vhs-error-reload-initialized'
        });
    });
    /**
   * Player modifications to perform that must wait until `loadedmetadata`
   * has been triggered
   *
   * @private
   */ const loadedMetadataHandler = function() {
        if (seekTo) player.currentTime(seekTo);
    };
    /**
   * Set the source on the player element, play, and seek if necessary
   *
   * @param {Object} sourceObj An object specifying the source url and mime-type to play
   * @private
   */ const setSource = function(sourceObj) {
        if (sourceObj === null || sourceObj === undefined) return;
        seekTo = player.duration() !== Infinity && player.currentTime() || 0;
        player.one('loadedmetadata', loadedMetadataHandler);
        player.src(sourceObj);
        player.trigger({
            type: 'usage',
            name: 'vhs-error-reload'
        });
        player.play();
    };
    /**
   * Attempt to get a source from either the built-in getSource function
   * or a custom function provided via the options
   *
   * @private
   */ const errorHandler = function() {
        // Do not attempt to reload the source if a source-reload occurred before
        // 'errorInterval' time has elapsed since the last source-reload
        if (Date.now() - lastCalled < localOptions.errorInterval * 1000) {
            player.trigger({
                type: 'usage',
                name: 'vhs-error-reload-canceled'
            });
            return;
        }
        if (!localOptions.getSource || typeof localOptions.getSource !== 'function') {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.error('ERROR: reloadSourceOnError - The option getSource must be a function!');
            return;
        }
        lastCalled = Date.now();
        return localOptions.getSource.call(player, setSource);
    };
    /**
   * Unbind any event handlers that were bound by the plugin
   *
   * @private
   */ const cleanupEvents = function() {
        player.off('loadedmetadata', loadedMetadataHandler);
        player.off('error', errorHandler);
        player.off('dispose', cleanupEvents);
    };
    /**
   * Cleanup before re-initializing the plugin
   *
   * @param {Object} [newOptions] an object with plugin options
   * @private
   */ const reinitPlugin = function(newOptions) {
        cleanupEvents();
        $cb03b711053a4297$var$initPlugin(player, newOptions);
    };
    player.on('error', errorHandler);
    player.on('dispose', cleanupEvents); // Overwrite the plugin function so that we can correctly cleanup before
    // initializing the plugin
    player.reloadSourceOnError = reinitPlugin;
};
/**
 * Reload the source when an error is detected as long as there
 * wasn't an error previously within the last 30 seconds
 *
 * @param {Object} [options] an object with plugin options
 */ const $cb03b711053a4297$var$reloadSourceOnError = function(options) {
    $cb03b711053a4297$var$initPlugin(this, options);
};
var $cb03b711053a4297$var$version$4 = "3.17.2";
var $cb03b711053a4297$var$version$3 = "7.1.0";
var $cb03b711053a4297$var$version$2 = "1.3.1";
var $cb03b711053a4297$var$version$1 = "7.2.0";
var $cb03b711053a4297$var$version = "4.0.2";
const $cb03b711053a4297$var$Vhs = {
    PlaylistLoader: $cb03b711053a4297$var$PlaylistLoader,
    Playlist: $cb03b711053a4297$var$Playlist,
    utils: $cb03b711053a4297$var$utils,
    STANDARD_PLAYLIST_SELECTOR: $cb03b711053a4297$var$lastBandwidthSelector,
    INITIAL_PLAYLIST_SELECTOR: $cb03b711053a4297$var$lowestBitrateCompatibleVariantSelector,
    lastBandwidthSelector: $cb03b711053a4297$var$lastBandwidthSelector,
    movingAverageBandwidthSelector: $cb03b711053a4297$var$movingAverageBandwidthSelector,
    comparePlaylistBandwidth: $cb03b711053a4297$var$comparePlaylistBandwidth,
    comparePlaylistResolution: $cb03b711053a4297$var$comparePlaylistResolution,
    xhr: $cb03b711053a4297$var$xhrFactory()
}; // Define getter/setters for config properties
Object.keys($cb03b711053a4297$var$Config).forEach((prop)=>{
    Object.defineProperty($cb03b711053a4297$var$Vhs, prop, {
        get () {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`using Vhs.${prop} is UNSAFE be sure you know what you are doing`);
            return $cb03b711053a4297$var$Config[prop];
        },
        set (value) {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`using Vhs.${prop} is UNSAFE be sure you know what you are doing`);
            if (typeof value !== 'number' || value < 0) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`value of Vhs.${prop} must be greater than or equal to 0`);
                return;
            }
            $cb03b711053a4297$var$Config[prop] = value;
        }
    });
});
const $cb03b711053a4297$var$LOCAL_STORAGE_KEY = 'videojs-vhs';
/**
 * Updates the selectedIndex of the QualityLevelList when a mediachange happens in vhs.
 *
 * @param {QualityLevelList} qualityLevels The QualityLevelList to update.
 * @param {PlaylistLoader} playlistLoader PlaylistLoader containing the new media info.
 * @function handleVhsMediaChange
 */ const $cb03b711053a4297$var$handleVhsMediaChange = function(qualityLevels, playlistLoader) {
    const newPlaylist = playlistLoader.media();
    let selectedIndex = -1;
    for(let i = 0; i < qualityLevels.length; i++)if (qualityLevels[i].id === newPlaylist.id) {
        selectedIndex = i;
        break;
    }
    qualityLevels.selectedIndex_ = selectedIndex;
    qualityLevels.trigger({
        selectedIndex: selectedIndex,
        type: 'change'
    });
};
/**
 * Adds quality levels to list once playlist metadata is available
 *
 * @param {QualityLevelList} qualityLevels The QualityLevelList to attach events to.
 * @param {Object} vhs Vhs object to listen to for media events.
 * @function handleVhsLoadedMetadata
 */ const $cb03b711053a4297$var$handleVhsLoadedMetadata = function(qualityLevels, vhs) {
    vhs.representations().forEach((rep)=>{
        qualityLevels.addQualityLevel(rep);
    });
    $cb03b711053a4297$var$handleVhsMediaChange(qualityLevels, vhs.playlists);
}; // VHS is a source handler, not a tech. Make sure attempts to use it
// as one do not cause exceptions.
$cb03b711053a4297$var$Vhs.canPlaySource = function() {
    return $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
const $cb03b711053a4297$var$emeKeySystems = (keySystemOptions, mainPlaylist, audioPlaylist)=>{
    if (!keySystemOptions) return keySystemOptions;
    let codecs = {};
    if (mainPlaylist && mainPlaylist.attributes && mainPlaylist.attributes.CODECS) codecs = $cb03b711053a4297$var$unwrapCodecList((0, $jv51Y.parseCodecs)(mainPlaylist.attributes.CODECS));
    if (audioPlaylist && audioPlaylist.attributes && audioPlaylist.attributes.CODECS) codecs.audio = audioPlaylist.attributes.CODECS;
    const videoContentType = (0, $jv51Y.getMimeForCodec)(codecs.video);
    const audioContentType = (0, $jv51Y.getMimeForCodec)(codecs.audio); // upsert the content types based on the selected playlist
    const keySystemContentTypes = {};
    for(const keySystem in keySystemOptions){
        keySystemContentTypes[keySystem] = {};
        if (audioContentType) keySystemContentTypes[keySystem].audioContentType = audioContentType;
        if (videoContentType) keySystemContentTypes[keySystem].videoContentType = videoContentType;
         // Default to using the video playlist's PSSH even though they may be different, as
        // videojs-contrib-eme will only accept one in the options.
        //
        // This shouldn't be an issue for most cases as early intialization will handle all
        // unique PSSH values, and if they aren't, then encrypted events should have the
        // specific information needed for the unique license.
        if (mainPlaylist.contentProtection && mainPlaylist.contentProtection[keySystem] && mainPlaylist.contentProtection[keySystem].pssh) keySystemContentTypes[keySystem].pssh = mainPlaylist.contentProtection[keySystem].pssh;
         // videojs-contrib-eme accepts the option of specifying: 'com.some.cdm': 'url'
        // so we need to prevent overwriting the URL entirely
        if (typeof keySystemOptions[keySystem] === 'string') keySystemContentTypes[keySystem].url = keySystemOptions[keySystem];
    }
    return $cb03b711053a4297$var$merge(keySystemOptions, keySystemContentTypes);
};
/**
 * @typedef {Object} KeySystems
 *
 * keySystems configuration for https://github.com/videojs/videojs-contrib-eme
 * Note: not all options are listed here.
 *
 * @property {Uint8Array} [pssh]
 *           Protection System Specific Header
 */ /**
 * Goes through all the playlists and collects an array of KeySystems options objects
 * containing each playlist's keySystems and their pssh values, if available.
 *
 * @param {Object[]} playlists
 *        The playlists to look through
 * @param {string[]} keySystems
 *        The keySystems to collect pssh values for
 *
 * @return {KeySystems[]}
 *         An array of KeySystems objects containing available key systems and their
 *         pssh values
 */ const $cb03b711053a4297$var$getAllPsshKeySystemsOptions = (playlists, keySystems)=>{
    return playlists.reduce((keySystemsArr, playlist)=>{
        if (!playlist.contentProtection) return keySystemsArr;
        const keySystemsOptions = keySystems.reduce((keySystemsObj, keySystem)=>{
            const keySystemOptions = playlist.contentProtection[keySystem];
            if (keySystemOptions && keySystemOptions.pssh) keySystemsObj[keySystem] = {
                pssh: keySystemOptions.pssh
            };
            return keySystemsObj;
        }, {});
        if (Object.keys(keySystemsOptions).length) keySystemsArr.push(keySystemsOptions);
        return keySystemsArr;
    }, []);
};
/**
 * Returns a promise that waits for the
 * [eme plugin](https://github.com/videojs/videojs-contrib-eme) to create a key session.
 *
 * Works around https://bugs.chromium.org/p/chromium/issues/detail?id=895449 in non-IE11
 * browsers.
 *
 * As per the above ticket, this is particularly important for Chrome, where, if
 * unencrypted content is appended before encrypted content and the key session has not
 * been created, a MEDIA_ERR_DECODE will be thrown once the encrypted content is reached
 * during playback.
 *
 * @param {Object} player
 *        The player instance
 * @param {Object[]} sourceKeySystems
 *        The key systems options from the player source
 * @param {Object} [audioMedia]
 *        The active audio media playlist (optional)
 * @param {Object[]} mainPlaylists
 *        The playlists found on the main playlist object
 *
 * @return {Object}
 *         Promise that resolves when the key session has been created
 */ const $cb03b711053a4297$var$waitForKeySessionCreation = ({ player: player, sourceKeySystems: sourceKeySystems, audioMedia: audioMedia, mainPlaylists: mainPlaylists })=>{
    if (!player.eme.initializeMediaKeys) return Promise.resolve();
     // TODO should all audio PSSH values be initialized for DRM?
    //
    // All unique video rendition pssh values are initialized for DRM, but here only
    // the initial audio playlist license is initialized. In theory, an encrypted
    // event should be fired if the user switches to an alternative audio playlist
    // where a license is required, but this case hasn't yet been tested. In addition, there
    // may be many alternate audio playlists unlikely to be used (e.g., multiple different
    // languages).
    const playlists = audioMedia ? mainPlaylists.concat([
        audioMedia
    ]) : mainPlaylists;
    const keySystemsOptionsArr = $cb03b711053a4297$var$getAllPsshKeySystemsOptions(playlists, Object.keys(sourceKeySystems));
    const initializationFinishedPromises = [];
    const keySessionCreatedPromises = []; // Since PSSH values are interpreted as initData, EME will dedupe any duplicates. The
    // only place where it should not be deduped is for ms-prefixed APIs, but
    // the existence of modern EME APIs in addition to
    // ms-prefixed APIs on Edge should prevent this from being a concern.
    // initializeMediaKeys also won't use the webkit-prefixed APIs.
    keySystemsOptionsArr.forEach((keySystemsOptions)=>{
        keySessionCreatedPromises.push(new Promise((resolve, reject)=>{
            player.tech_.one('keysessioncreated', resolve);
        }));
        initializationFinishedPromises.push(new Promise((resolve, reject)=>{
            player.eme.initializeMediaKeys({
                keySystems: keySystemsOptions
            }, (err)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve();
            });
        }));
    }); // The reasons Promise.race is chosen over Promise.any:
    //
    // * Promise.any is only available in Safari 14+.
    // * None of these promises are expected to reject. If they do reject, it might be
    //   better here for the race to surface the rejection, rather than mask it by using
    //   Promise.any.
    return Promise.race([
        // If a session was previously created, these will all finish resolving without
        // creating a new session, otherwise it will take until the end of all license
        // requests, which is why the key session check is used (to make setup much faster).
        Promise.all(initializationFinishedPromises),
        // Once a single session is created, the browser knows DRM will be used.
        Promise.race(keySessionCreatedPromises)
    ]);
};
/**
 * If the [eme](https://github.com/videojs/videojs-contrib-eme) plugin is available, and
 * there are keySystems on the source, sets up source options to prepare the source for
 * eme.
 *
 * @param {Object} player
 *        The player instance
 * @param {Object[]} sourceKeySystems
 *        The key systems options from the player source
 * @param {Object} media
 *        The active media playlist
 * @param {Object} [audioMedia]
 *        The active audio media playlist (optional)
 *
 * @return {boolean}
 *         Whether or not options were configured and EME is available
 */ const $cb03b711053a4297$var$setupEmeOptions = ({ player: player, sourceKeySystems: sourceKeySystems, media: media, audioMedia: audioMedia })=>{
    const sourceOptions = $cb03b711053a4297$var$emeKeySystems(sourceKeySystems, media, audioMedia);
    if (!sourceOptions) return false;
    player.currentSource().keySystems = sourceOptions; // eme handles the rest of the setup, so if it is missing
    // do nothing.
    if (sourceOptions && !player.eme) {
        $cb03b711053a4297$export$2e2bcd8739ae039.log.warn('DRM encrypted source cannot be decrypted without a DRM plugin');
        return false;
    }
    return true;
};
const $cb03b711053a4297$var$getVhsLocalStorage = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage) return null;
    const storedObject = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage.getItem($cb03b711053a4297$var$LOCAL_STORAGE_KEY);
    if (!storedObject) return null;
    try {
        return JSON.parse(storedObject);
    } catch (e) {
        // someone may have tampered with the value
        return null;
    }
};
const $cb03b711053a4297$var$updateVhsLocalStorage = (options)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage) return false;
    let objectToStore = $cb03b711053a4297$var$getVhsLocalStorage();
    objectToStore = objectToStore ? $cb03b711053a4297$var$merge(objectToStore, options) : options;
    try {
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage.setItem($cb03b711053a4297$var$LOCAL_STORAGE_KEY, JSON.stringify(objectToStore));
    } catch (e) {
        // Throws if storage is full (e.g., always on iOS 5+ Safari private mode, where
        // storage is set to 0).
        // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem#Exceptions
        // No need to perform any operation.
        return false;
    }
    return objectToStore;
};
/**
 * Parses VHS-supported media types from data URIs. See
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
 * for information on data URIs.
 *
 * @param {string} dataUri
 *        The data URI
 *
 * @return {string|Object}
 *         The parsed object/string, or the original string if no supported media type
 *         was found
 */ const $cb03b711053a4297$var$expandDataUri = (dataUri)=>{
    if (dataUri.toLowerCase().indexOf('data:application/vnd.videojs.vhs+json,') === 0) return JSON.parse(dataUri.substring(dataUri.indexOf(',') + 1));
     // no known case for this data URI, return the string as-is
    return dataUri;
};
/**
 * Adds a request hook to an xhr object
 *
 * @param {Object} xhr object to add the onRequest hook to
 * @param {function} callback hook function for an xhr request
 */ const $cb03b711053a4297$var$addOnRequestHook = (xhr, callback)=>{
    if (!xhr._requestCallbackSet) xhr._requestCallbackSet = new Set();
    xhr._requestCallbackSet.add(callback);
};
/**
 * Adds a response hook to an xhr object
 *
 * @param {Object} xhr object to add the onResponse hook to
 * @param {function} callback hook function for an xhr response
 */ const $cb03b711053a4297$var$addOnResponseHook = (xhr, callback)=>{
    if (!xhr._responseCallbackSet) xhr._responseCallbackSet = new Set();
    xhr._responseCallbackSet.add(callback);
};
/**
 * Removes a request hook on an xhr object, deletes the onRequest set if empty.
 *
 * @param {Object} xhr object to remove the onRequest hook from
 * @param {function} callback hook function to remove
 */ const $cb03b711053a4297$var$removeOnRequestHook = (xhr, callback)=>{
    if (!xhr._requestCallbackSet) return;
    xhr._requestCallbackSet.delete(callback);
    if (!xhr._requestCallbackSet.size) delete xhr._requestCallbackSet;
};
/**
 * Removes a response hook on an xhr object, deletes the onResponse set if empty.
 *
 * @param {Object} xhr object to remove the onResponse hook from
 * @param {function} callback hook function to remove
 */ const $cb03b711053a4297$var$removeOnResponseHook = (xhr, callback)=>{
    if (!xhr._responseCallbackSet) return;
    xhr._responseCallbackSet.delete(callback);
    if (!xhr._responseCallbackSet.size) delete xhr._responseCallbackSet;
};
/**
 * Whether the browser has built-in HLS support.
 */ $cb03b711053a4297$var$Vhs.supportsNativeHls = function() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) || !(0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement) return false;
    const video = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('video'); // native HLS is definitely not supported if HTML5 video isn't
    if (!$cb03b711053a4297$export$2e2bcd8739ae039.getTech('Html5').isSupported()) return false;
     // HLS manifests can go by many mime-types
    const canPlay = [
        // Apple santioned
        'application/vnd.apple.mpegurl',
        // Apple sanctioned for backwards compatibility
        'audio/mpegurl',
        // Very common
        'audio/x-mpegurl',
        // Very common
        'application/x-mpegurl',
        // Included for completeness
        'video/x-mpegurl',
        'video/mpegurl',
        'application/mpegurl'
    ];
    return canPlay.some(function(canItPlay) {
        return /maybe|probably/i.test(video.canPlayType(canItPlay));
    });
}();
$cb03b711053a4297$var$Vhs.supportsNativeDash = function() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) || !(0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement || !$cb03b711053a4297$export$2e2bcd8739ae039.getTech('Html5').isSupported()) return false;
    return /maybe|probably/i.test((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement('video').canPlayType('application/dash+xml'));
}();
$cb03b711053a4297$var$Vhs.supportsTypeNatively = (type)=>{
    if (type === 'hls') return $cb03b711053a4297$var$Vhs.supportsNativeHls;
    if (type === 'dash') return $cb03b711053a4297$var$Vhs.supportsNativeDash;
    return false;
};
/**
 * VHS is a source handler, not a tech. Make sure attempts to use it
 * as one do not cause exceptions.
 */ $cb03b711053a4297$var$Vhs.isSupported = function() {
    return $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
/**
 * A global function for setting an onRequest hook
 *
 * @param {function} callback for request modifiction
 */ $cb03b711053a4297$var$Vhs.xhr.onRequest = function(callback) {
    $cb03b711053a4297$var$addOnRequestHook($cb03b711053a4297$var$Vhs.xhr, callback);
};
/**
 * A global function for setting an onResponse hook
 *
 * @param {callback} callback for response data retrieval
 */ $cb03b711053a4297$var$Vhs.xhr.onResponse = function(callback) {
    $cb03b711053a4297$var$addOnResponseHook($cb03b711053a4297$var$Vhs.xhr, callback);
};
/**
 * Deletes a global onRequest callback if it exists
 *
 * @param {function} callback to delete from the global set
 */ $cb03b711053a4297$var$Vhs.xhr.offRequest = function(callback) {
    $cb03b711053a4297$var$removeOnRequestHook($cb03b711053a4297$var$Vhs.xhr, callback);
};
/**
 * Deletes a global onResponse callback if it exists
 *
 * @param {function} callback to delete from the global set
 */ $cb03b711053a4297$var$Vhs.xhr.offResponse = function(callback) {
    $cb03b711053a4297$var$removeOnResponseHook($cb03b711053a4297$var$Vhs.xhr, callback);
};
const $cb03b711053a4297$var$Component = $cb03b711053a4297$export$2e2bcd8739ae039.getComponent('Component');
/**
 * The Vhs Handler object, where we orchestrate all of the parts
 * of VHS to interact with video.js
 *
 * @class VhsHandler
 * @extends videojs.Component
 * @param {Object} source the soruce object
 * @param {Tech} tech the parent tech object
 * @param {Object} options optional and required options
 */ class $cb03b711053a4297$var$VhsHandler extends $cb03b711053a4297$var$Component {
    constructor(source, tech, options){
        super(tech, options.vhs); // if a tech level `initialBandwidth` option was passed
        // use that over the VHS level `bandwidth` option
        if (typeof options.initialBandwidth === 'number') this.options_.bandwidth = options.initialBandwidth;
        this.logger_ = $cb03b711053a4297$var$logger('VhsHandler'); // we need access to the player in some cases,
        // so, get it from Video.js via the `playerId`
        if (tech.options_ && tech.options_.playerId) {
            const _player = $cb03b711053a4297$export$2e2bcd8739ae039.getPlayer(tech.options_.playerId);
            this.player_ = _player;
        }
        this.tech_ = tech;
        this.source_ = source;
        this.stats = {};
        this.ignoreNextSeekingEvent_ = false;
        this.setOptions_();
        if (this.options_.overrideNative && tech.overrideNativeAudioTracks && tech.overrideNativeVideoTracks) {
            tech.overrideNativeAudioTracks(true);
            tech.overrideNativeVideoTracks(true);
        } else if (this.options_.overrideNative && (tech.featuresNativeVideoTracks || tech.featuresNativeAudioTracks)) // overriding native VHS only works if audio tracks have been emulated
        // error early if we're misconfigured
        throw new Error("Overriding native VHS requires emulated tracks. See https://git.io/vMpjB");
         // listen for fullscreenchange events for this player so that we
        // can adjust our quality selection quickly
        this.on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), [
            'fullscreenchange',
            'webkitfullscreenchange',
            'mozfullscreenchange',
            'MSFullscreenChange'
        ], (event)=>{
            const fullscreenElement = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).fullscreenElement || (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).webkitFullscreenElement || (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).mozFullScreenElement || (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).msFullscreenElement;
            if (fullscreenElement && fullscreenElement.contains(this.tech_.el())) this.playlistController_.fastQualityChange_();
            else // When leaving fullscreen, since the in page pixel dimensions should be smaller
            // than full screen, see if there should be a rendition switch down to preserve
            // bandwidth.
            this.playlistController_.checkABR_();
        });
        this.on(this.tech_, 'seeking', function() {
            if (this.ignoreNextSeekingEvent_) {
                this.ignoreNextSeekingEvent_ = false;
                return;
            }
            this.setCurrentTime(this.tech_.currentTime());
        });
        this.on(this.tech_, 'error', function() {
            // verify that the error was real and we are loaded
            // enough to have pc loaded.
            if (this.tech_.error() && this.playlistController_) this.playlistController_.pauseLoading();
        });
        this.on(this.tech_, 'play', this.play);
    }
    /**
   * Set VHS options based on options from configuration, as well as partial
   * options to be passed at a later time.
   *
   * @param {Object} options A partial chunk of config options
   */ setOptions_(options = {}) {
        this.options_ = $cb03b711053a4297$var$merge(this.options_, options); // defaults
        this.options_.withCredentials = this.options_.withCredentials || false;
        this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions === false ? false : true;
        this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || false;
        this.options_.usePlayerObjectFit = this.options_.usePlayerObjectFit || false;
        this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage !== 'undefined' ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || false;
        this.options_.useForcedSubtitles = this.options_.useForcedSubtitles || false;
        this.options_.useNetworkInformationApi = typeof this.options_.useNetworkInformationApi !== 'undefined' ? this.options_.useNetworkInformationApi : true;
        this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || false;
        this.options_.customTagParsers = this.options_.customTagParsers || [];
        this.options_.customTagMappers = this.options_.customTagMappers || [];
        this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || false;
        this.options_.llhls = this.options_.llhls === false ? false : true;
        this.options_.bufferBasedABR = this.options_.bufferBasedABR || false;
        if (typeof this.options_.playlistExclusionDuration !== 'number') this.options_.playlistExclusionDuration = 60;
        if (typeof this.options_.bandwidth !== 'number') {
            if (this.options_.useBandwidthFromLocalStorage) {
                const storedObject = $cb03b711053a4297$var$getVhsLocalStorage();
                if (storedObject && storedObject.bandwidth) {
                    this.options_.bandwidth = storedObject.bandwidth;
                    this.tech_.trigger({
                        type: 'usage',
                        name: 'vhs-bandwidth-from-local-storage'
                    });
                }
                if (storedObject && storedObject.throughput) {
                    this.options_.throughput = storedObject.throughput;
                    this.tech_.trigger({
                        type: 'usage',
                        name: 'vhs-throughput-from-local-storage'
                    });
                }
            }
        } // if bandwidth was not set by options or pulled from local storage, start playlist
        // selection at a reasonable bandwidth
        if (typeof this.options_.bandwidth !== 'number') this.options_.bandwidth = $cb03b711053a4297$var$Config.INITIAL_BANDWIDTH;
         // If the bandwidth number is unchanged from the initial setting
        // then this takes precedence over the enableLowInitialPlaylist option
        this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === $cb03b711053a4297$var$Config.INITIAL_BANDWIDTH; // grab options passed to player.src
        [
            'withCredentials',
            'useDevicePixelRatio',
            'usePlayerObjectFit',
            'customPixelRatio',
            'limitRenditionByPlayerDimensions',
            'bandwidth',
            'customTagParsers',
            'customTagMappers',
            'cacheEncryptionKeys',
            'playlistSelector',
            'initialPlaylistSelector',
            'bufferBasedABR',
            'liveRangeSafeTimeDelta',
            'llhls',
            'useForcedSubtitles',
            'useNetworkInformationApi',
            'useDtsForTimestampOffset',
            'exactManifestTimings',
            'leastPixelDiffSelector'
        ].forEach((option)=>{
            if (typeof this.source_[option] !== 'undefined') this.options_[option] = this.source_[option];
        });
        this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions;
        this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
        this.usePlayerObjectFit = this.options_.usePlayerObjectFit;
        const customPixelRatio = this.options_.customPixelRatio; // Ensure the custom pixel ratio is a number greater than or equal to 0
        if (typeof customPixelRatio === 'number' && customPixelRatio >= 0) this.customPixelRatio = customPixelRatio;
    }
    setOptions(options = {}) {
        this.setOptions_(options);
    }
    /**
   * called when player.src gets called, handle a new source
   *
   * @param {Object} src the source object to handle
   */ src(src, type) {
        // do nothing if the src is falsey
        if (!src) return;
        this.setOptions_(); // add main playlist controller options
        this.options_.src = $cb03b711053a4297$var$expandDataUri(this.source_.src);
        this.options_.tech = this.tech_;
        this.options_.externVhs = $cb03b711053a4297$var$Vhs;
        this.options_.sourceType = (0, $9Odq1.simpleTypeFromSourceType)(type); // Whenever we seek internally, we should update the tech
        this.options_.seekTo = (time)=>{
            this.tech_.setCurrentTime(time);
        }; // pass player to allow for player level eventing on construction.
        this.options_.player_ = this.player_;
        this.playlistController_ = new $cb03b711053a4297$var$PlaylistController(this.options_);
        const playbackWatcherOptions = $cb03b711053a4297$var$merge({
            liveRangeSafeTimeDelta: $cb03b711053a4297$var$SAFE_TIME_DELTA
        }, this.options_, {
            seekable: ()=>this.seekable(),
            media: ()=>this.playlistController_.media(),
            playlistController: this.playlistController_
        });
        this.playbackWatcher_ = new $cb03b711053a4297$var$PlaybackWatcher(playbackWatcherOptions);
        this.attachStreamingEventListeners_();
        this.playlistController_.on('error', ()=>{
            const player = $cb03b711053a4297$export$2e2bcd8739ae039.players[this.tech_.options_.playerId];
            let error = this.playlistController_.error;
            if (typeof error === 'object' && !error.code) error.code = 3;
            else if (typeof error === 'string') error = {
                message: error,
                code: 3
            };
            player.error(error);
        });
        const defaultSelector = this.options_.bufferBasedABR ? $cb03b711053a4297$var$Vhs.movingAverageBandwidthSelector(0.55) : $cb03b711053a4297$var$Vhs.STANDARD_PLAYLIST_SELECTOR; // `this` in selectPlaylist should be the VhsHandler for backwards
        // compatibility with < v2
        this.playlistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : defaultSelector.bind(this);
        this.playlistController_.selectInitialPlaylist = $cb03b711053a4297$var$Vhs.INITIAL_PLAYLIST_SELECTOR.bind(this); // re-expose some internal objects for backwards compatibility with < v2
        this.playlists = this.playlistController_.mainPlaylistLoader_;
        this.mediaSource = this.playlistController_.mediaSource; // Proxy assignment of some properties to the main playlist
        // controller. Using a custom property for backwards compatibility
        // with < v2
        Object.defineProperties(this, {
            selectPlaylist: {
                get () {
                    return this.playlistController_.selectPlaylist;
                },
                set (selectPlaylist) {
                    this.playlistController_.selectPlaylist = selectPlaylist.bind(this);
                }
            },
            throughput: {
                get () {
                    return this.playlistController_.mainSegmentLoader_.throughput.rate;
                },
                set (throughput) {
                    this.playlistController_.mainSegmentLoader_.throughput.rate = throughput; // By setting `count` to 1 the throughput value becomes the starting value
                    // for the cumulative average
                    this.playlistController_.mainSegmentLoader_.throughput.count = 1;
                }
            },
            bandwidth: {
                get () {
                    let playerBandwidthEst = this.playlistController_.mainSegmentLoader_.bandwidth;
                    const networkInformation = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.connection || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.mozConnection || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.webkitConnection;
                    const tenMbpsAsBitsPerSecond = 10e6;
                    if (this.options_.useNetworkInformationApi && networkInformation) {
                        // downlink returns Mbps
                        // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/downlink
                        const networkInfoBandwidthEstBitsPerSec = networkInformation.downlink * 1000000; // downlink maxes out at 10 Mbps. In the event that both networkInformationApi and the player
                        // estimate a bandwidth greater than 10 Mbps, use the larger of the two estimates to ensure that
                        // high quality streams are not filtered out.
                        if (networkInfoBandwidthEstBitsPerSec >= tenMbpsAsBitsPerSecond && playerBandwidthEst >= tenMbpsAsBitsPerSecond) playerBandwidthEst = Math.max(playerBandwidthEst, networkInfoBandwidthEstBitsPerSec);
                        else playerBandwidthEst = networkInfoBandwidthEstBitsPerSec;
                    }
                    return playerBandwidthEst;
                },
                set (bandwidth) {
                    this.playlistController_.mainSegmentLoader_.bandwidth = bandwidth; // setting the bandwidth manually resets the throughput counter
                    // `count` is set to zero that current value of `rate` isn't included
                    // in the cumulative average
                    this.playlistController_.mainSegmentLoader_.throughput = {
                        rate: 0,
                        count: 0
                    };
                }
            },
            /**
       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
       * the entire process after that - decryption, transmuxing, and appending - provided
       * by `throughput`.
       *
       * Since the two process are serial, the overall system bandwidth is given by:
       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
       */ systemBandwidth: {
                get () {
                    const invBandwidth = 1 / (this.bandwidth || 1);
                    let invThroughput;
                    if (this.throughput > 0) invThroughput = 1 / this.throughput;
                    else invThroughput = 0;
                    const systemBitrate = Math.floor(1 / (invBandwidth + invThroughput));
                    return systemBitrate;
                },
                set () {
                    $cb03b711053a4297$export$2e2bcd8739ae039.log.error('The "systemBandwidth" property is read-only');
                }
            }
        });
        if (this.options_.bandwidth) this.bandwidth = this.options_.bandwidth;
        if (this.options_.throughput) this.throughput = this.options_.throughput;
        Object.defineProperties(this.stats, {
            bandwidth: {
                get: ()=>this.bandwidth || 0,
                enumerable: true
            },
            mediaRequests: {
                get: ()=>this.playlistController_.mediaRequests_() || 0,
                enumerable: true
            },
            mediaRequestsAborted: {
                get: ()=>this.playlistController_.mediaRequestsAborted_() || 0,
                enumerable: true
            },
            mediaRequestsTimedout: {
                get: ()=>this.playlistController_.mediaRequestsTimedout_() || 0,
                enumerable: true
            },
            mediaRequestsErrored: {
                get: ()=>this.playlistController_.mediaRequestsErrored_() || 0,
                enumerable: true
            },
            mediaTransferDuration: {
                get: ()=>this.playlistController_.mediaTransferDuration_() || 0,
                enumerable: true
            },
            mediaBytesTransferred: {
                get: ()=>this.playlistController_.mediaBytesTransferred_() || 0,
                enumerable: true
            },
            mediaSecondsLoaded: {
                get: ()=>this.playlistController_.mediaSecondsLoaded_() || 0,
                enumerable: true
            },
            mediaAppends: {
                get: ()=>this.playlistController_.mediaAppends_() || 0,
                enumerable: true
            },
            mainAppendsToLoadedData: {
                get: ()=>this.playlistController_.mainAppendsToLoadedData_() || 0,
                enumerable: true
            },
            audioAppendsToLoadedData: {
                get: ()=>this.playlistController_.audioAppendsToLoadedData_() || 0,
                enumerable: true
            },
            appendsToLoadedData: {
                get: ()=>this.playlistController_.appendsToLoadedData_() || 0,
                enumerable: true
            },
            timeToLoadedData: {
                get: ()=>this.playlistController_.timeToLoadedData_() || 0,
                enumerable: true
            },
            buffered: {
                get: ()=>$cb03b711053a4297$var$timeRangesToArray(this.tech_.buffered()),
                enumerable: true
            },
            currentTime: {
                get: ()=>this.tech_.currentTime(),
                enumerable: true
            },
            currentSource: {
                get: ()=>this.tech_.currentSource_,
                enumerable: true
            },
            currentTech: {
                get: ()=>this.tech_.name_,
                enumerable: true
            },
            duration: {
                get: ()=>this.tech_.duration(),
                enumerable: true
            },
            main: {
                get: ()=>this.playlists.main,
                enumerable: true
            },
            playerDimensions: {
                get: ()=>this.tech_.currentDimensions(),
                enumerable: true
            },
            seekable: {
                get: ()=>$cb03b711053a4297$var$timeRangesToArray(this.tech_.seekable()),
                enumerable: true
            },
            timestamp: {
                get: ()=>Date.now(),
                enumerable: true
            },
            videoPlaybackQuality: {
                get: ()=>this.tech_.getVideoPlaybackQuality(),
                enumerable: true
            }
        });
        this.tech_.one('canplay', this.playlistController_.setupFirstPlay.bind(this.playlistController_));
        this.tech_.on('bandwidthupdate', ()=>{
            if (this.options_.useBandwidthFromLocalStorage) $cb03b711053a4297$var$updateVhsLocalStorage({
                bandwidth: this.bandwidth,
                throughput: Math.round(this.throughput)
            });
        });
        this.playlistController_.on('selectedinitialmedia', ()=>{
            // Add the manual rendition mix-in to VhsHandler
            $cb03b711053a4297$var$renditionSelectionMixin(this);
        });
        this.playlistController_.sourceUpdater_.on('createdsourcebuffers', ()=>{
            this.setupEme_();
        }); // the bandwidth of the primary segment loader is our best
        // estimate of overall bandwidth
        this.on(this.playlistController_, 'progress', function() {
            this.tech_.trigger('progress');
        }); // In the live case, we need to ignore the very first `seeking` event since
        // that will be the result of the seek-to-live behavior
        this.on(this.playlistController_, 'firstplay', function() {
            this.ignoreNextSeekingEvent_ = true;
        });
        this.setupQualityLevels_(); // do nothing if the tech has been disposed already
        // this can occur if someone sets the src in player.ready(), for instance
        if (!this.tech_.el()) return;
        this.mediaSourceUrl_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL.createObjectURL(this.playlistController_.mediaSource); // If we are playing HLS with MSE in Safari, add source elements for both the blob and manifest URLs.
        // The latter will enable Airplay playback on receiver devices.
        if (($cb03b711053a4297$export$2e2bcd8739ae039.browser.IS_ANY_SAFARI || $cb03b711053a4297$export$2e2bcd8739ae039.browser.IS_IOS) && this.options_.overrideNative && this.options_.sourceType === 'hls' && typeof this.tech_.addSourceElement === 'function') {
            this.tech_.addSourceElement(this.mediaSourceUrl_);
            this.tech_.addSourceElement(this.source_.src);
        } else this.tech_.src(this.mediaSourceUrl_);
    }
    createKeySessions_() {
        const audioPlaylistLoader = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
        this.logger_('waiting for EME key session creation');
        $cb03b711053a4297$var$waitForKeySessionCreation({
            player: this.player_,
            sourceKeySystems: this.source_.keySystems,
            audioMedia: audioPlaylistLoader && audioPlaylistLoader.media(),
            mainPlaylists: this.playlists.main.playlists
        }).then(()=>{
            this.logger_('created EME key session');
            this.playlistController_.sourceUpdater_.initializedEme();
        }).catch((err)=>{
            this.logger_('error while creating EME key session', err);
            this.player_.error({
                message: 'Failed to initialize media keys for EME',
                code: 3
            });
        });
    }
    handleWaitingForKey_() {
        // If waitingforkey is fired, it's possible that the data that's necessary to retrieve
        // the key is in the manifest. While this should've happened on initial source load, it
        // may happen again in live streams where the keys change, and the manifest info
        // reflects the update.
        //
        // Because videojs-contrib-eme compares the PSSH data we send to that of PSSH data it's
        // already requested keys for, we don't have to worry about this generating extraneous
        // requests.
        this.logger_('waitingforkey fired, attempting to create any new key sessions');
        this.createKeySessions_();
    }
    /**
   * If necessary and EME is available, sets up EME options and waits for key session
   * creation.
   *
   * This function also updates the source updater so taht it can be used, as for some
   * browsers, EME must be configured before content is appended (if appending unencrypted
   * content before encrypted content).
   */ setupEme_() {
        const audioPlaylistLoader = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
        const didSetupEmeOptions = $cb03b711053a4297$var$setupEmeOptions({
            player: this.player_,
            sourceKeySystems: this.source_.keySystems,
            media: this.playlists.media(),
            audioMedia: audioPlaylistLoader && audioPlaylistLoader.media()
        });
        this.player_.tech_.on('keystatuschange', (e)=>{
            this.playlistController_.updatePlaylistByKeyStatus(e.keyId, e.status);
        });
        this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this);
        this.player_.tech_.on('waitingforkey', this.handleWaitingForKey_);
        if (!didSetupEmeOptions) {
            // If EME options were not set up, we've done all we could to initialize EME.
            this.playlistController_.sourceUpdater_.initializedEme();
            return;
        }
        this.createKeySessions_();
    }
    /**
   * Initializes the quality levels and sets listeners to update them.
   *
   * @method setupQualityLevels_
   * @private
   */ setupQualityLevels_() {
        const player = $cb03b711053a4297$export$2e2bcd8739ae039.players[this.tech_.options_.playerId]; // if there isn't a player or there isn't a qualityLevels plugin
        // or qualityLevels_ listeners have already been setup, do nothing.
        if (!player || !player.qualityLevels || this.qualityLevels_) return;
        this.qualityLevels_ = player.qualityLevels();
        this.playlistController_.on('selectedinitialmedia', ()=>{
            $cb03b711053a4297$var$handleVhsLoadedMetadata(this.qualityLevels_, this);
        });
        this.playlists.on('mediachange', ()=>{
            $cb03b711053a4297$var$handleVhsMediaChange(this.qualityLevels_, this.playlists);
        });
    }
    /**
   * return the version
   */ static version() {
        return {
            '@videojs/http-streaming': $cb03b711053a4297$var$version$4,
            'mux.js': $cb03b711053a4297$var$version$3,
            'mpd-parser': $cb03b711053a4297$var$version$2,
            'm3u8-parser': $cb03b711053a4297$var$version$1,
            'aes-decrypter': $cb03b711053a4297$var$version
        };
    }
    /**
   * return the version
   */ version() {
        return this.constructor.version();
    }
    canChangeType() {
        return $cb03b711053a4297$var$SourceUpdater.canChangeType();
    }
    /**
   * Begin playing the video.
   */ play() {
        this.playlistController_.play();
    }
    /**
   * a wrapper around the function in PlaylistController
   */ setCurrentTime(currentTime) {
        this.playlistController_.setCurrentTime(currentTime);
    }
    /**
   * a wrapper around the function in PlaylistController
   */ duration() {
        return this.playlistController_.duration();
    }
    /**
   * a wrapper around the function in PlaylistController
   */ seekable() {
        return this.playlistController_.seekable();
    }
    /**
   * Abort all outstanding work and cleanup.
   */ dispose() {
        if (this.playbackWatcher_) this.playbackWatcher_.dispose();
        if (this.playlistController_) this.playlistController_.dispose();
        if (this.qualityLevels_) this.qualityLevels_.dispose();
        if (this.tech_ && this.tech_.vhs) delete this.tech_.vhs;
        if (this.mediaSourceUrl_ && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL.revokeObjectURL) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL.revokeObjectURL(this.mediaSourceUrl_);
            this.mediaSourceUrl_ = null;
        }
        if (this.tech_) this.tech_.off('waitingforkey', this.handleWaitingForKey_);
        super.dispose();
    }
    convertToProgramTime(time, callback) {
        return $cb03b711053a4297$var$getProgramTime({
            playlist: this.playlistController_.media(),
            time: time,
            callback: callback
        });
    }
    seekToProgramTime(programTime, callback, pauseAfterSeek = true, retryCount = 2) {
        return $cb03b711053a4297$var$seekToProgramTime({
            programTime: programTime,
            playlist: this.playlistController_.media(),
            retryCount: retryCount,
            pauseAfterSeek: pauseAfterSeek,
            seekTo: this.options_.seekTo,
            tech: this.options_.tech,
            callback: callback
        });
    }
    /**
   * Adds the onRequest, onResponse, offRequest and offResponse functions
   * to the VhsHandler xhr Object.
   */ setupXhrHooks_() {
        /**
     * A player function for setting an onRequest hook
     *
     * @param {function} callback for request modifiction
     */ this.xhr.onRequest = (callback)=>{
            $cb03b711053a4297$var$addOnRequestHook(this.xhr, callback);
        };
        /**
     * A player function for setting an onResponse hook
     *
     * @param {callback} callback for response data retrieval
     */ this.xhr.onResponse = (callback)=>{
            $cb03b711053a4297$var$addOnResponseHook(this.xhr, callback);
        };
        /**
     * Deletes a player onRequest callback if it exists
     *
     * @param {function} callback to delete from the player set
     */ this.xhr.offRequest = (callback)=>{
            $cb03b711053a4297$var$removeOnRequestHook(this.xhr, callback);
        };
        /**
     * Deletes a player onResponse callback if it exists
     *
     * @param {function} callback to delete from the player set
     */ this.xhr.offResponse = (callback)=>{
            $cb03b711053a4297$var$removeOnResponseHook(this.xhr, callback);
        }; // Trigger an event on the player to notify the user that vhs is ready to set xhr hooks.
        // This allows hooks to be set before the source is set to vhs when handleSource is called.
        this.player_.trigger('xhr-hooks-ready');
    }
    attachStreamingEventListeners_() {
        const playlistControllerEvents = [
            'seekablerangeschanged',
            'bufferedrangeschanged',
            'contentsteeringloadstart',
            'contentsteeringloadcomplete',
            'contentsteeringparsed'
        ];
        const playbackWatcher = [
            'gapjumped',
            'playedrangeschanged'
        ]; // re-emit streaming events and payloads on the player.
        playlistControllerEvents.forEach((eventName)=>{
            this.playlistController_.on(eventName, (metadata)=>{
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, metadata));
            });
        });
        playbackWatcher.forEach((eventName)=>{
            this.playbackWatcher_.on(eventName, (metadata)=>{
                this.player_.trigger((0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, metadata));
            });
        });
    }
}
/**
 * The Source Handler object, which informs video.js what additional
 * MIME types are supported and sets up playback. It is registered
 * automatically to the appropriate tech based on the capabilities of
 * the browser it is running in. It is not necessary to use or modify
 * this object in normal usage.
 */ const $cb03b711053a4297$var$VhsSourceHandler = {
    name: 'videojs-http-streaming',
    VERSION: $cb03b711053a4297$var$version$4,
    canHandleSource (srcObj, options = {}) {
        const localOptions = $cb03b711053a4297$var$merge($cb03b711053a4297$export$2e2bcd8739ae039.options, options); // If not opting to experimentalUseMMS, and playback is only supported with MediaSource, cannot handle source
        if (!localOptions.vhs.experimentalUseMMS && !(0, $jv51Y.browserSupportsCodec)('avc1.4d400d,mp4a.40.2', false)) return false;
        return $cb03b711053a4297$var$VhsSourceHandler.canPlayType(srcObj.type, localOptions);
    },
    handleSource (source, tech, options = {}) {
        const localOptions = $cb03b711053a4297$var$merge($cb03b711053a4297$export$2e2bcd8739ae039.options, options);
        tech.vhs = new $cb03b711053a4297$var$VhsHandler(source, tech, localOptions);
        tech.vhs.xhr = $cb03b711053a4297$var$xhrFactory();
        tech.vhs.setupXhrHooks_();
        tech.vhs.src(source.src, source.type);
        return tech.vhs;
    },
    canPlayType (type, options) {
        const simpleType = (0, $9Odq1.simpleTypeFromSourceType)(type);
        if (!simpleType) return '';
        const overrideNative = $cb03b711053a4297$var$VhsSourceHandler.getOverrideNative(options);
        const supportsTypeNatively = $cb03b711053a4297$var$Vhs.supportsTypeNatively(simpleType);
        const canUseMsePlayback = !supportsTypeNatively || overrideNative;
        return canUseMsePlayback ? 'maybe' : '';
    },
    getOverrideNative (options = {}) {
        const { vhs: vhs = {} } = options;
        const defaultOverrideNative = !($cb03b711053a4297$export$2e2bcd8739ae039.browser.IS_ANY_SAFARI || $cb03b711053a4297$export$2e2bcd8739ae039.browser.IS_IOS);
        const { overrideNative: overrideNative = defaultOverrideNative } = vhs;
        return overrideNative;
    }
};
/**
 * Check to see if either the native MediaSource or ManagedMediaSource
 * objectx exist and support an MP4 container with both H.264 video
 * and AAC-LC audio.
 *
 * @return {boolean} if  native media sources are supported
 */ const $cb03b711053a4297$var$supportsNativeMediaSources = ()=>{
    return (0, $jv51Y.browserSupportsCodec)('avc1.4d400d,mp4a.40.2', true);
}; // register source handlers with the appropriate techs
if ($cb03b711053a4297$var$supportsNativeMediaSources()) $cb03b711053a4297$export$2e2bcd8739ae039.getTech('Html5').registerSourceHandler($cb03b711053a4297$var$VhsSourceHandler, 0);
$cb03b711053a4297$export$2e2bcd8739ae039.VhsHandler = $cb03b711053a4297$var$VhsHandler;
$cb03b711053a4297$export$2e2bcd8739ae039.VhsSourceHandler = $cb03b711053a4297$var$VhsSourceHandler;
$cb03b711053a4297$export$2e2bcd8739ae039.Vhs = $cb03b711053a4297$var$Vhs;
if (!$cb03b711053a4297$export$2e2bcd8739ae039.use) $cb03b711053a4297$export$2e2bcd8739ae039.registerComponent('Vhs', $cb03b711053a4297$var$Vhs);
$cb03b711053a4297$export$2e2bcd8739ae039.options.vhs = $cb03b711053a4297$export$2e2bcd8739ae039.options.vhs || {};
if (!$cb03b711053a4297$export$2e2bcd8739ae039.getPlugin || !$cb03b711053a4297$export$2e2bcd8739ae039.getPlugin('reloadSourceOnError')) $cb03b711053a4297$export$2e2bcd8739ae039.registerPlugin('reloadSourceOnError', $cb03b711053a4297$var$reloadSourceOnError);

});
parcelRegister("eDick", function(module, exports) {
var $aa72d2e69fd2fe14$var$win;
if (typeof window !== "undefined") $aa72d2e69fd2fe14$var$win = window;
else if (typeof $parcel$global !== "undefined") $aa72d2e69fd2fe14$var$win = $parcel$global;
else if (typeof self !== "undefined") $aa72d2e69fd2fe14$var$win = self;
else $aa72d2e69fd2fe14$var$win = {};
module.exports = $aa72d2e69fd2fe14$var$win;

});

parcelRegister("7pNCM", function(module, exports) {
var $56615c93f45a88ca$var$topLevel = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : {};

var $kjyEk = parcelRequire("kjyEk");
var $56615c93f45a88ca$var$doccy;
if (typeof document !== 'undefined') $56615c93f45a88ca$var$doccy = document;
else {
    $56615c93f45a88ca$var$doccy = $56615c93f45a88ca$var$topLevel['__GLOBAL_DOCUMENT_CACHE@4'];
    if (!$56615c93f45a88ca$var$doccy) $56615c93f45a88ca$var$doccy = $56615c93f45a88ca$var$topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = $kjyEk;
}
module.exports = $56615c93f45a88ca$var$doccy;

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("hPwoy", function(module, exports) {
"use strict";

var $eDick = parcelRequire("eDick");

var $3p9rK = parcelRequire("3p9rK");

var $3KI1D = parcelRequire("3KI1D");

var $czfq1 = parcelRequire("czfq1");

var $a8oKv = parcelRequire("a8oKv");

$cfb0541156229cda$var$createXHR.httpHandler = (parcelRequire("1WntU"));
$cfb0541156229cda$var$createXHR.requestInterceptorsStorage = new $czfq1();
$cfb0541156229cda$var$createXHR.responseInterceptorsStorage = new $czfq1();
$cfb0541156229cda$var$createXHR.retryManager = new $a8oKv();
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */ var $cfb0541156229cda$var$parseHeaders = function parseHeaders(headers) {
    var result = {};
    if (!headers) return result;
    headers.trim().split('\n').forEach(function(row) {
        var index = row.indexOf(':');
        var key = row.slice(0, index).trim().toLowerCase();
        var value = row.slice(index + 1).trim();
        if (typeof result[key] === 'undefined') result[key] = value;
        else if (Array.isArray(result[key])) result[key].push(value);
        else result[key] = [
            result[key],
            value
        ];
    });
    return result;
};
module.exports = $cfb0541156229cda$var$createXHR; // Allow use of default import syntax in TypeScript
module.exports.default = $cfb0541156229cda$var$createXHR;
$cfb0541156229cda$var$createXHR.XMLHttpRequest = $eDick.XMLHttpRequest || $cfb0541156229cda$var$noop;
$cfb0541156229cda$var$createXHR.XDomainRequest = "withCredentials" in new $cfb0541156229cda$var$createXHR.XMLHttpRequest() ? $cfb0541156229cda$var$createXHR.XMLHttpRequest : $eDick.XDomainRequest;
$cfb0541156229cda$var$forEachArray([
    "get",
    "put",
    "post",
    "patch",
    "head",
    "delete"
], function(method) {
    $cfb0541156229cda$var$createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
        options = $cfb0541156229cda$var$initParams(uri, options, callback);
        options.method = method.toUpperCase();
        return $cfb0541156229cda$var$_createXHR(options);
    };
});
function $cfb0541156229cda$var$forEachArray(array, iterator) {
    for(var i = 0; i < array.length; i++)iterator(array[i]);
}
function $cfb0541156229cda$var$isEmpty(obj) {
    for(var i in obj){
        if (obj.hasOwnProperty(i)) return false;
    }
    return true;
}
function $cfb0541156229cda$var$initParams(uri, options, callback) {
    var params = uri;
    if ($3KI1D(options)) {
        callback = options;
        if (typeof uri === "string") params = {
            uri: uri
        };
    } else params = $3p9rK({}, options, {
        uri: uri
    });
    params.callback = callback;
    return params;
}
function $cfb0541156229cda$var$createXHR(uri, options, callback) {
    options = $cfb0541156229cda$var$initParams(uri, options, callback);
    return $cfb0541156229cda$var$_createXHR(options);
}
function $cfb0541156229cda$var$_createXHR(options) {
    if (typeof options.callback === "undefined") throw new Error("callback argument missing");
     // call all registered request interceptors for a given request type:
    if (options.requestType && $cfb0541156229cda$var$createXHR.requestInterceptorsStorage.getIsEnabled()) {
        var requestInterceptorPayload = {
            uri: options.uri || options.url,
            headers: options.headers || {},
            body: options.body,
            metadata: options.metadata || {},
            retry: options.retry,
            timeout: options.timeout
        };
        var updatedPayload = $cfb0541156229cda$var$createXHR.requestInterceptorsStorage.execute(options.requestType, requestInterceptorPayload);
        options.uri = updatedPayload.uri;
        options.headers = updatedPayload.headers;
        options.body = updatedPayload.body;
        options.metadata = updatedPayload.metadata;
        options.retry = updatedPayload.retry;
        options.timeout = updatedPayload.timeout;
    }
    var called = false;
    var callback = function cbOnce(err, response, body) {
        if (!called) {
            called = true;
            options.callback(err, response, body);
        }
    };
    function readystatechange() {
        // do not call load 2 times when response interceptors are enabled
        // why do we even need this 2nd load?
        if (xhr.readyState === 4 && !$cfb0541156229cda$var$createXHR.responseInterceptorsStorage.getIsEnabled()) setTimeout(loadFunc, 0);
    }
    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined;
        if (xhr.response) body = xhr.response;
        else body = xhr.responseText || $cfb0541156229cda$var$getXml(xhr);
        if (isJson) try {
            body = JSON.parse(body);
        } catch (e) {}
        return body;
    }
    function errorFunc(evt) {
        clearTimeout(timeoutTimer);
        clearTimeout(options.retryTimeout);
        if (!(evt instanceof Error)) evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
        evt.statusCode = 0; // we would like to retry on error:
        if (!aborted && $cfb0541156229cda$var$createXHR.retryManager.getIsEnabled() && options.retry && options.retry.shouldRetry()) {
            options.retryTimeout = setTimeout(function() {
                options.retry.moveToNextAttempt(); // we want to re-use the same options and the same xhr object:
                options.xhr = xhr;
                $cfb0541156229cda$var$_createXHR(options);
            }, options.retry.getCurrentFuzzedDelay());
            return;
        } // call all registered response interceptors for a given request type:
        if (options.requestType && $cfb0541156229cda$var$createXHR.responseInterceptorsStorage.getIsEnabled()) {
            var responseInterceptorPayload = {
                headers: failureResponse.headers || {},
                body: failureResponse.body,
                responseUrl: xhr.responseURL,
                responseType: xhr.responseType
            };
            var _updatedPayload = $cfb0541156229cda$var$createXHR.responseInterceptorsStorage.execute(options.requestType, responseInterceptorPayload);
            failureResponse.body = _updatedPayload.body;
            failureResponse.headers = _updatedPayload.headers;
        }
        return callback(evt, failureResponse);
    } // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return;
        var status;
        clearTimeout(timeoutTimer);
        clearTimeout(options.retryTimeout);
        if (options.useXDR && xhr.status === undefined) //IE8 CORS GET successful response doesn't have a status field, but body is fine
        status = 200;
        else status = xhr.status === 1223 ? 204 : xhr.status;
        var response = failureResponse;
        var err = null;
        if (status !== 0) {
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            };
            if (xhr.getAllResponseHeaders) //remember xhr can in fact be XDR for CORS in IE
            response.headers = $cfb0541156229cda$var$parseHeaders(xhr.getAllResponseHeaders());
        } else err = new Error("Internal XMLHttpRequest Error");
         // call all registered response interceptors for a given request type:
        if (options.requestType && $cfb0541156229cda$var$createXHR.responseInterceptorsStorage.getIsEnabled()) {
            var responseInterceptorPayload = {
                headers: response.headers || {},
                body: response.body,
                responseUrl: xhr.responseURL,
                responseType: xhr.responseType
            };
            var _updatedPayload2 = $cfb0541156229cda$var$createXHR.responseInterceptorsStorage.execute(options.requestType, responseInterceptorPayload);
            response.body = _updatedPayload2.body;
            response.headers = _updatedPayload2.headers;
        }
        return callback(err, response, response.body);
    }
    var xhr = options.xhr || null;
    if (!xhr) {
        if (options.cors || options.useXDR) xhr = new $cfb0541156229cda$var$createXHR.XDomainRequest();
        else xhr = new $cfb0541156229cda$var$createXHR.XMLHttpRequest();
    }
    var key;
    var aborted;
    var uri = xhr.url = options.uri || options.url;
    var method = xhr.method = options.method || "GET";
    var body = options.body || options.data;
    var headers = xhr.headers = options.headers || {};
    var sync = !!options.sync;
    var isJson = false;
    var timeoutTimer;
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    };
    if ("json" in options && options.json !== false) {
        isJson = true;
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
            body = JSON.stringify(options.json === true ? body : options.json);
        }
    }
    xhr.onreadystatechange = readystatechange;
    xhr.onload = loadFunc;
    xhr.onerror = errorFunc; // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function() {};
    xhr.onabort = function() {
        aborted = true;
        clearTimeout(options.retryTimeout);
    };
    xhr.ontimeout = errorFunc;
    xhr.open(method, uri, !sync, options.username, options.password); //has to be after open
    if (!sync) xhr.withCredentials = !!options.withCredentials;
     // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0) timeoutTimer = setTimeout(function() {
        if (aborted) return;
        aborted = true; //IE9 may still call readystatechange
        xhr.abort("timeout");
        var e = new Error("XMLHttpRequest timeout");
        e.code = "ETIMEDOUT";
        errorFunc(e);
    }, options.timeout);
    if (xhr.setRequestHeader) {
        for(key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    } else if (options.headers && !$cfb0541156229cda$var$isEmpty(options.headers)) throw new Error("Headers cannot be set on an XDomainRequest object");
    if ("responseType" in options) xhr.responseType = options.responseType;
    if ("beforeSend" in options && typeof options.beforeSend === "function") options.beforeSend(xhr);
     // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null);
    return xhr;
}
function $cfb0541156229cda$var$getXml(xhr) {
    // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
    // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
    try {
        if (xhr.responseType === "document") return xhr.responseXML;
        var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
        if (xhr.responseType === "" && !firefoxBugTakenEffect) return xhr.responseXML;
    } catch (e) {}
    return null;
}
function $cfb0541156229cda$var$noop() {}

});
parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3KI1D", function(module, exports) {
module.exports = $2bb7d1829c4e2ce1$var$isFunction;
var $2bb7d1829c4e2ce1$var$toString = Object.prototype.toString;
function $2bb7d1829c4e2ce1$var$isFunction(fn) {
    if (!fn) return false;
    var string = $2bb7d1829c4e2ce1$var$toString.call(fn);
    return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && // IE8 and below
    (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
}

});

parcelRegister("czfq1", function(module, exports) {
"use strict";
function $9264b6bbc298e42c$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $9264b6bbc298e42c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9264b6bbc298e42c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9264b6bbc298e42c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9264b6bbc298e42c$var$_arrayLikeToArray(o, minLen);
}
function $9264b6bbc298e42c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $9264b6bbc298e42c$var$InterceptorsStorage = /*#__PURE__*/ function() {
    function InterceptorsStorage() {
        this.typeToInterceptorsMap_ = new Map();
        this.enabled_ = false;
    }
    var _proto = InterceptorsStorage.prototype;
    _proto.getIsEnabled = function getIsEnabled() {
        return this.enabled_;
    };
    _proto.enable = function enable() {
        this.enabled_ = true;
    };
    _proto.disable = function disable() {
        this.enabled_ = false;
    };
    _proto.reset = function reset() {
        this.typeToInterceptorsMap_ = new Map();
        this.enabled_ = false;
    };
    _proto.addInterceptor = function addInterceptor(type, interceptor) {
        if (!this.typeToInterceptorsMap_.has(type)) this.typeToInterceptorsMap_.set(type, new Set());
        var interceptorsSet = this.typeToInterceptorsMap_.get(type);
        if (interceptorsSet.has(interceptor)) // already have this interceptor
        return false;
        interceptorsSet.add(interceptor);
        return true;
    };
    _proto.removeInterceptor = function removeInterceptor(type, interceptor) {
        var interceptorsSet = this.typeToInterceptorsMap_.get(type);
        if (interceptorsSet && interceptorsSet.has(interceptor)) {
            interceptorsSet.delete(interceptor);
            return true;
        }
        return false;
    };
    _proto.clearInterceptorsByType = function clearInterceptorsByType(type) {
        var interceptorsSet = this.typeToInterceptorsMap_.get(type);
        if (!interceptorsSet) return false;
        this.typeToInterceptorsMap_.delete(type);
        this.typeToInterceptorsMap_.set(type, new Set());
        return true;
    };
    _proto.clear = function clear() {
        if (!this.typeToInterceptorsMap_.size) return false;
        this.typeToInterceptorsMap_ = new Map();
        return true;
    };
    _proto.getForType = function getForType(type) {
        return this.typeToInterceptorsMap_.get(type) || new Set();
    };
    _proto.execute = function execute(type, payload) {
        var interceptors = this.getForType(type);
        for(var _iterator = $9264b6bbc298e42c$var$_createForOfIteratorHelperLoose(interceptors), _step; !(_step = _iterator()).done;){
            var interceptor = _step.value;
            try {
                payload = interceptor(payload);
            } catch (e) {}
        }
        return payload;
    };
    return InterceptorsStorage;
}();
module.exports = $9264b6bbc298e42c$var$InterceptorsStorage;

});

parcelRegister("a8oKv", function(module, exports) {
"use strict";
var $760dd96164b06fab$var$RetryManager = /*#__PURE__*/ function() {
    function RetryManager() {
        this.maxAttempts_ = 1;
        this.delayFactor_ = 0.1;
        this.fuzzFactor_ = 0.1;
        this.initialDelay_ = 1000;
        this.enabled_ = false;
    }
    var _proto = RetryManager.prototype;
    _proto.getIsEnabled = function getIsEnabled() {
        return this.enabled_;
    };
    _proto.enable = function enable() {
        this.enabled_ = true;
    };
    _proto.disable = function disable() {
        this.enabled_ = false;
    };
    _proto.reset = function reset() {
        this.maxAttempts_ = 1;
        this.delayFactor_ = 0.1;
        this.fuzzFactor_ = 0.1;
        this.initialDelay_ = 1000;
        this.enabled_ = false;
    };
    _proto.getMaxAttempts = function getMaxAttempts() {
        return this.maxAttempts_;
    };
    _proto.setMaxAttempts = function setMaxAttempts(maxAttempts) {
        this.maxAttempts_ = maxAttempts;
    };
    _proto.getDelayFactor = function getDelayFactor() {
        return this.delayFactor_;
    };
    _proto.setDelayFactor = function setDelayFactor(delayFactor) {
        this.delayFactor_ = delayFactor;
    };
    _proto.getFuzzFactor = function getFuzzFactor() {
        return this.fuzzFactor_;
    };
    _proto.setFuzzFactor = function setFuzzFactor(fuzzFactor) {
        this.fuzzFactor_ = fuzzFactor;
    };
    _proto.getInitialDelay = function getInitialDelay() {
        return this.initialDelay_;
    };
    _proto.setInitialDelay = function setInitialDelay(initialDelay) {
        this.initialDelay_ = initialDelay;
    };
    _proto.createRetry = function createRetry(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, maxAttempts = _ref.maxAttempts, delayFactor = _ref.delayFactor, fuzzFactor = _ref.fuzzFactor, initialDelay = _ref.initialDelay;
        return new $760dd96164b06fab$var$Retry({
            maxAttempts: maxAttempts || this.maxAttempts_,
            delayFactor: delayFactor || this.delayFactor_,
            fuzzFactor: fuzzFactor || this.fuzzFactor_,
            initialDelay: initialDelay || this.initialDelay_
        });
    };
    return RetryManager;
}();
var $760dd96164b06fab$var$Retry = /*#__PURE__*/ function() {
    function Retry(options) {
        this.maxAttempts_ = options.maxAttempts;
        this.delayFactor_ = options.delayFactor;
        this.fuzzFactor_ = options.fuzzFactor;
        this.currentDelay_ = options.initialDelay;
        this.currentAttempt_ = 1;
    }
    var _proto2 = Retry.prototype;
    _proto2.moveToNextAttempt = function moveToNextAttempt() {
        this.currentAttempt_++;
        var delayDelta = this.currentDelay_ * this.delayFactor_;
        this.currentDelay_ = this.currentDelay_ + delayDelta;
    };
    _proto2.shouldRetry = function shouldRetry() {
        return this.currentAttempt_ < this.maxAttempts_;
    };
    _proto2.getCurrentDelay = function getCurrentDelay() {
        return this.currentDelay_;
    };
    _proto2.getCurrentMinPossibleDelay = function getCurrentMinPossibleDelay() {
        return (1 - this.fuzzFactor_) * this.currentDelay_;
    };
    _proto2.getCurrentMaxPossibleDelay = function getCurrentMaxPossibleDelay() {
        return (1 + this.fuzzFactor_) * this.currentDelay_;
    };
    _proto2.getCurrentFuzzedDelay = function getCurrentFuzzedDelay() {
        var lowValue = this.getCurrentMinPossibleDelay();
        var highValue = this.getCurrentMaxPossibleDelay();
        return lowValue + Math.random() * (highValue - lowValue);
    };
    return Retry;
}();
module.exports = $760dd96164b06fab$var$RetryManager;

});

parcelRegister("1WntU", function(module, exports) {
"use strict";

var $eDick = parcelRequire("eDick");
var $169d6c2963909da7$var$httpResponseHandler = function httpResponseHandler(callback, decodeResponseBody) {
    if (decodeResponseBody === void 0) decodeResponseBody = false;
    return function(err, response, responseBody) {
        // if the XHR failed, return that error
        if (err) {
            callback(err);
            return;
        } // if the HTTP status code is 4xx or 5xx, the request also failed
        if (response.statusCode >= 400 && response.statusCode <= 599) {
            var cause = responseBody;
            if (decodeResponseBody) {
                if ($eDick.TextDecoder) {
                    var charset = $169d6c2963909da7$var$getCharset(response.headers && response.headers['content-type']);
                    try {
                        cause = new TextDecoder(charset).decode(responseBody);
                    } catch (e) {}
                } else cause = String.fromCharCode.apply(null, new Uint8Array(responseBody));
            }
            callback({
                cause: cause
            });
            return;
        } // otherwise, request succeeded
        callback(null, responseBody);
    };
};
function $169d6c2963909da7$var$getCharset(contentTypeHeader) {
    if (contentTypeHeader === void 0) contentTypeHeader = '';
    return contentTypeHeader.toLowerCase().split(';').reduce(function(charset, contentType) {
        var _contentType$split = contentType.split('='), type = _contentType$split[0], value = _contentType$split[1];
        if (type.trim() === 'charset') return value.trim();
        return charset;
    }, 'utf-8');
}
module.exports = $169d6c2963909da7$var$httpResponseHandler;

});


parcelRegister("a4Nb0", function(module, exports) {
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Default exports for Node. Export the extended versions of VTTCue and
// VTTRegion in Node since we likely want the capability to convert back and
// forth between JSON. If we don't then it's not that big of a deal since we're
// off browser.

var $eDick = parcelRequire("eDick");



var $75606c86739c45ca$var$vttjs = module.exports = {
    WebVTT: (parcelRequire("65ElS")),
    VTTCue: (parcelRequire("aWh86")),
    VTTRegion: (parcelRequire("f8lRN"))
};
$eDick.vttjs = $75606c86739c45ca$var$vttjs;
$eDick.WebVTT = $75606c86739c45ca$var$vttjs.WebVTT;
var $75606c86739c45ca$var$cueShim = $75606c86739c45ca$var$vttjs.VTTCue;
var $75606c86739c45ca$var$regionShim = $75606c86739c45ca$var$vttjs.VTTRegion;
var $75606c86739c45ca$var$nativeVTTCue = $eDick.VTTCue;
var $75606c86739c45ca$var$nativeVTTRegion = $eDick.VTTRegion;
$75606c86739c45ca$var$vttjs.shim = function() {
    $eDick.VTTCue = $75606c86739c45ca$var$cueShim;
    $eDick.VTTRegion = $75606c86739c45ca$var$regionShim;
};
$75606c86739c45ca$var$vttjs.restore = function() {
    $eDick.VTTCue = $75606c86739c45ca$var$nativeVTTCue;
    $eDick.VTTRegion = $75606c86739c45ca$var$nativeVTTRegion;
};
if (!$eDick.VTTCue) $75606c86739c45ca$var$vttjs.shim();

});
parcelRegister("65ElS", function(module, exports) {
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */ /* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */ 
var $7pNCM = parcelRequire("7pNCM");
var $46f282c1f2cd4950$var$_objCreate = Object.create || function() {
    function F() {}
    return function(o) {
        if (arguments.length !== 1) throw new Error('Object.create shim only accepts one parameter.');
        F.prototype = o;
        return new F();
    };
}();
// Creates a new ParserError object from an errorData object. The errorData
// object should have default code and message properties. The default message
// property can be overriden by passing in a message parameter.
// See ParsingError.Errors below for acceptable errors.
function $46f282c1f2cd4950$var$ParsingError(errorData, message) {
    this.name = "ParsingError";
    this.code = errorData.code;
    this.message = message || errorData.message;
}
$46f282c1f2cd4950$var$ParsingError.prototype = $46f282c1f2cd4950$var$_objCreate(Error.prototype);
$46f282c1f2cd4950$var$ParsingError.prototype.constructor = $46f282c1f2cd4950$var$ParsingError;
// ParsingError metadata for acceptable ParsingErrors.
$46f282c1f2cd4950$var$ParsingError.Errors = {
    BadSignature: {
        code: 0,
        message: "Malformed WebVTT signature."
    },
    BadTimeStamp: {
        code: 1,
        message: "Malformed time stamp."
    }
};
// Try to parse input as a time stamp.
function $46f282c1f2cd4950$var$parseTimeStamp(input) {
    function computeSeconds(h, m, s, f) {
        return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
    }
    var m = input.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
    if (!m) return null;
    if (m[3]) // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
    else if (m[1] > 59) // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[1], m[2], 0, m[4]);
    else // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
    return computeSeconds(0, m[1], m[2], m[4]);
}
// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
function $46f282c1f2cd4950$var$Settings() {
    this.values = $46f282c1f2cd4950$var$_objCreate(null);
}
$46f282c1f2cd4950$var$Settings.prototype = {
    // Only accept the first assignment to any key.
    set: function(k, v) {
        if (!this.get(k) && v !== "") this.values[k] = v;
    },
    // Return the value for a key, or a default value.
    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
    // a number of possible default values as properties where 'defaultKey' is
    // the key of the property that will be chosen; otherwise it's assumed to be
    // a single value.
    get: function(k, dflt, defaultKey) {
        if (defaultKey) return this.has(k) ? this.values[k] : dflt[defaultKey];
        return this.has(k) ? this.values[k] : dflt;
    },
    // Check whether we have a value for a key.
    has: function(k) {
        return k in this.values;
    },
    // Accept a setting if its one of the given alternatives.
    alt: function(k, v, a) {
        for(var n = 0; n < a.length; ++n)if (v === a[n]) {
            this.set(k, v);
            break;
        }
    },
    // Accept a setting if its a valid (signed) integer.
    integer: function(k, v) {
        if (/^-?\d+$/.test(v)) this.set(k, parseInt(v, 10));
    },
    // Accept a setting if its a valid percentage.
    percent: function(k, v) {
        var m;
        if (m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
            v = parseFloat(v);
            if (v >= 0 && v <= 100) {
                this.set(k, v);
                return true;
            }
        }
        return false;
    }
};
// Helper function to parse input into groups separated by 'groupDelim', and
// interprete each group as a key/value pair separated by 'keyValueDelim'.
function $46f282c1f2cd4950$var$parseOptions(input, callback, keyValueDelim, groupDelim) {
    var groups = groupDelim ? input.split(groupDelim) : [
        input
    ];
    for(var i in groups){
        if (typeof groups[i] !== "string") continue;
        var kv = groups[i].split(keyValueDelim);
        if (kv.length !== 2) continue;
        var k = kv[0].trim();
        var v = kv[1].trim();
        callback(k, v);
    }
}
function $46f282c1f2cd4950$var$parseCue(input, cue, regionList) {
    // Remember the original input if we need to throw an error.
    var oInput = input;
    // 4.1 WebVTT timestamp
    function consumeTimeStamp() {
        var ts = $46f282c1f2cd4950$var$parseTimeStamp(input);
        if (ts === null) throw new $46f282c1f2cd4950$var$ParsingError($46f282c1f2cd4950$var$ParsingError.Errors.BadTimeStamp, "Malformed timestamp: " + oInput);
        // Remove time stamp from input.
        input = input.replace(/^[^\sa-zA-Z-]+/, "");
        return ts;
    }
    // 4.4.2 WebVTT cue settings
    function consumeCueSettings(input, cue) {
        var settings = new $46f282c1f2cd4950$var$Settings();
        $46f282c1f2cd4950$var$parseOptions(input, function(k, v) {
            switch(k){
                case "region":
                    // Find the last region we parsed with the same region id.
                    for(var i = regionList.length - 1; i >= 0; i--)if (regionList[i].id === v) {
                        settings.set(k, regionList[i].region);
                        break;
                    }
                    break;
                case "vertical":
                    settings.alt(k, v, [
                        "rl",
                        "lr"
                    ]);
                    break;
                case "line":
                    var vals = v.split(","), vals0 = vals[0];
                    settings.integer(k, vals0);
                    settings.percent(k, vals0) && settings.set("snapToLines", false);
                    settings.alt(k, vals0, [
                        "auto"
                    ]);
                    if (vals.length === 2) settings.alt("lineAlign", vals[1], [
                        "start",
                        "center",
                        "end"
                    ]);
                    break;
                case "position":
                    vals = v.split(",");
                    settings.percent(k, vals[0]);
                    if (vals.length === 2) settings.alt("positionAlign", vals[1], [
                        "start",
                        "center",
                        "end"
                    ]);
                    break;
                case "size":
                    settings.percent(k, v);
                    break;
                case "align":
                    settings.alt(k, v, [
                        "start",
                        "center",
                        "end",
                        "left",
                        "right"
                    ]);
                    break;
            }
        }, /:/, /\s/);
        // Apply default values for any missing fields.
        cue.region = settings.get("region", null);
        cue.vertical = settings.get("vertical", "");
        try {
            cue.line = settings.get("line", "auto");
        } catch (e) {}
        cue.lineAlign = settings.get("lineAlign", "start");
        cue.snapToLines = settings.get("snapToLines", true);
        cue.size = settings.get("size", 100);
        // Safari still uses the old middle value and won't accept center
        try {
            cue.align = settings.get("align", "center");
        } catch (e) {
            cue.align = settings.get("align", "middle");
        }
        try {
            cue.position = settings.get("position", "auto");
        } catch (e) {
            cue.position = settings.get("position", {
                start: 0,
                left: 0,
                center: 50,
                middle: 50,
                end: 100,
                right: 100
            }, cue.align);
        }
        cue.positionAlign = settings.get("positionAlign", {
            start: "start",
            left: "start",
            center: "center",
            middle: "center",
            end: "end",
            right: "end"
        }, cue.align);
    }
    function skipWhitespace() {
        input = input.replace(/^\s+/, "");
    }
    // 4.1 WebVTT cue timings.
    skipWhitespace();
    cue.startTime = consumeTimeStamp(); // (1) collect cue start time
    skipWhitespace();
    if (input.substr(0, 3) !== "-->") throw new $46f282c1f2cd4950$var$ParsingError($46f282c1f2cd4950$var$ParsingError.Errors.BadTimeStamp, "Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
    input = input.substr(3);
    skipWhitespace();
    cue.endTime = consumeTimeStamp(); // (5) collect cue end time
    // 4.1 WebVTT cue settings list.
    skipWhitespace();
    consumeCueSettings(input, cue);
}
// When evaluating this file as part of a Webpack bundle for server
// side rendering, `document` is an empty object.
var $46f282c1f2cd4950$var$TEXTAREA_ELEMENT = $7pNCM.createElement && $7pNCM.createElement("textarea");
var $46f282c1f2cd4950$var$TAG_NAME = {
    c: "span",
    i: "i",
    b: "b",
    u: "u",
    ruby: "ruby",
    rt: "rt",
    v: "span",
    lang: "span"
};
// 5.1 default text color
// 5.2 default text background color is equivalent to text color with bg_ prefix
var $46f282c1f2cd4950$var$DEFAULT_COLOR_CLASS = {
    white: 'rgba(255,255,255,1)',
    lime: 'rgba(0,255,0,1)',
    cyan: 'rgba(0,255,255,1)',
    red: 'rgba(255,0,0,1)',
    yellow: 'rgba(255,255,0,1)',
    magenta: 'rgba(255,0,255,1)',
    blue: 'rgba(0,0,255,1)',
    black: 'rgba(0,0,0,1)'
};
var $46f282c1f2cd4950$var$TAG_ANNOTATION = {
    v: "title",
    lang: "lang"
};
var $46f282c1f2cd4950$var$NEEDS_PARENT = {
    rt: "ruby"
};
// Parse content into a document fragment.
function $46f282c1f2cd4950$var$parseContent(window, input) {
    function nextToken() {
        // Check for end-of-string.
        if (!input) return null;
        // Consume 'n' characters from the input.
        function consume(result) {
            input = input.substr(result.length);
            return result;
        }
        var m = input.match(/^([^<]*)(<[^>]*>?)?/);
        // If there is some text before the next tag, return it, otherwise return
        // the tag.
        return consume(m[1] ? m[1] : m[2]);
    }
    function unescape(s) {
        $46f282c1f2cd4950$var$TEXTAREA_ELEMENT.innerHTML = s;
        s = $46f282c1f2cd4950$var$TEXTAREA_ELEMENT.textContent;
        $46f282c1f2cd4950$var$TEXTAREA_ELEMENT.textContent = "";
        return s;
    }
    function shouldAdd(current, element) {
        return !$46f282c1f2cd4950$var$NEEDS_PARENT[element.localName] || $46f282c1f2cd4950$var$NEEDS_PARENT[element.localName] === current.localName;
    }
    // Create an element for this tag.
    function createElement(type, annotation) {
        var tagName = $46f282c1f2cd4950$var$TAG_NAME[type];
        if (!tagName) return null;
        var element = window.document.createElement(tagName);
        var name = $46f282c1f2cd4950$var$TAG_ANNOTATION[type];
        if (name && annotation) element[name] = annotation.trim();
        return element;
    }
    var rootDiv = window.document.createElement("div"), current = rootDiv, t, tagStack = [];
    while((t = nextToken()) !== null){
        if (t[0] === '<') {
            if (t[1] === "/") {
                // If the closing tag matches, move back up to the parent node.
                if (tagStack.length && tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
                    tagStack.pop();
                    current = current.parentNode;
                }
                continue;
            }
            var ts = $46f282c1f2cd4950$var$parseTimeStamp(t.substr(1, t.length - 2));
            var node;
            if (ts) {
                // Timestamps are lead nodes as well.
                node = window.document.createProcessingInstruction("timestamp", ts);
                current.appendChild(node);
                continue;
            }
            var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
            // If we can't parse the tag, skip to the next tag.
            if (!m) continue;
            // Try to construct an element, and ignore the tag if we couldn't.
            node = createElement(m[1], m[3]);
            if (!node) continue;
            // Determine if the tag should be added based on the context of where it
            // is placed in the cuetext.
            if (!shouldAdd(current, node)) continue;
            // Set the class list (as a list of classes, separated by space).
            if (m[2]) {
                var classes = m[2].split('.');
                classes.forEach(function(cl) {
                    var bgColor = /^bg_/.test(cl);
                    // slice out `bg_` if it's a background color
                    var colorName = bgColor ? cl.slice(3) : cl;
                    if ($46f282c1f2cd4950$var$DEFAULT_COLOR_CLASS.hasOwnProperty(colorName)) {
                        var propName = bgColor ? 'background-color' : 'color';
                        var propValue = $46f282c1f2cd4950$var$DEFAULT_COLOR_CLASS[colorName];
                        node.style[propName] = propValue;
                    }
                });
                node.className = classes.join(' ');
            }
            // Append the node to the current node, and enter the scope of the new
            // node.
            tagStack.push(m[1]);
            current.appendChild(node);
            current = node;
            continue;
        }
        // Text nodes are leaf nodes.
        current.appendChild(window.document.createTextNode(unescape(t)));
    }
    return rootDiv;
}
// This is a list of all the Unicode characters that have a strong
// right-to-left category. What this means is that these characters are
// written right-to-left for sure. It was generated by pulling all the strong
// right-to-left characters out of the Unicode data table. That table can
// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
var $46f282c1f2cd4950$var$strongRTLRanges = [
    [
        0x5be,
        0x5be
    ],
    [
        0x5c0,
        0x5c0
    ],
    [
        0x5c3,
        0x5c3
    ],
    [
        0x5c6,
        0x5c6
    ],
    [
        0x5d0,
        0x5ea
    ],
    [
        0x5f0,
        0x5f4
    ],
    [
        0x608,
        0x608
    ],
    [
        0x60b,
        0x60b
    ],
    [
        0x60d,
        0x60d
    ],
    [
        0x61b,
        0x61b
    ],
    [
        0x61e,
        0x64a
    ],
    [
        0x66d,
        0x66f
    ],
    [
        0x671,
        0x6d5
    ],
    [
        0x6e5,
        0x6e6
    ],
    [
        0x6ee,
        0x6ef
    ],
    [
        0x6fa,
        0x70d
    ],
    [
        0x70f,
        0x710
    ],
    [
        0x712,
        0x72f
    ],
    [
        0x74d,
        0x7a5
    ],
    [
        0x7b1,
        0x7b1
    ],
    [
        0x7c0,
        0x7ea
    ],
    [
        0x7f4,
        0x7f5
    ],
    [
        0x7fa,
        0x7fa
    ],
    [
        0x800,
        0x815
    ],
    [
        0x81a,
        0x81a
    ],
    [
        0x824,
        0x824
    ],
    [
        0x828,
        0x828
    ],
    [
        0x830,
        0x83e
    ],
    [
        0x840,
        0x858
    ],
    [
        0x85e,
        0x85e
    ],
    [
        0x8a0,
        0x8a0
    ],
    [
        0x8a2,
        0x8ac
    ],
    [
        0x200f,
        0x200f
    ],
    [
        0xfb1d,
        0xfb1d
    ],
    [
        0xfb1f,
        0xfb28
    ],
    [
        0xfb2a,
        0xfb36
    ],
    [
        0xfb38,
        0xfb3c
    ],
    [
        0xfb3e,
        0xfb3e
    ],
    [
        0xfb40,
        0xfb41
    ],
    [
        0xfb43,
        0xfb44
    ],
    [
        0xfb46,
        0xfbc1
    ],
    [
        0xfbd3,
        0xfd3d
    ],
    [
        0xfd50,
        0xfd8f
    ],
    [
        0xfd92,
        0xfdc7
    ],
    [
        0xfdf0,
        0xfdfc
    ],
    [
        0xfe70,
        0xfe74
    ],
    [
        0xfe76,
        0xfefc
    ],
    [
        0x10800,
        0x10805
    ],
    [
        0x10808,
        0x10808
    ],
    [
        0x1080a,
        0x10835
    ],
    [
        0x10837,
        0x10838
    ],
    [
        0x1083c,
        0x1083c
    ],
    [
        0x1083f,
        0x10855
    ],
    [
        0x10857,
        0x1085f
    ],
    [
        0x10900,
        0x1091b
    ],
    [
        0x10920,
        0x10939
    ],
    [
        0x1093f,
        0x1093f
    ],
    [
        0x10980,
        0x109b7
    ],
    [
        0x109be,
        0x109bf
    ],
    [
        0x10a00,
        0x10a00
    ],
    [
        0x10a10,
        0x10a13
    ],
    [
        0x10a15,
        0x10a17
    ],
    [
        0x10a19,
        0x10a33
    ],
    [
        0x10a40,
        0x10a47
    ],
    [
        0x10a50,
        0x10a58
    ],
    [
        0x10a60,
        0x10a7f
    ],
    [
        0x10b00,
        0x10b35
    ],
    [
        0x10b40,
        0x10b55
    ],
    [
        0x10b58,
        0x10b72
    ],
    [
        0x10b78,
        0x10b7f
    ],
    [
        0x10c00,
        0x10c48
    ],
    [
        0x1ee00,
        0x1ee03
    ],
    [
        0x1ee05,
        0x1ee1f
    ],
    [
        0x1ee21,
        0x1ee22
    ],
    [
        0x1ee24,
        0x1ee24
    ],
    [
        0x1ee27,
        0x1ee27
    ],
    [
        0x1ee29,
        0x1ee32
    ],
    [
        0x1ee34,
        0x1ee37
    ],
    [
        0x1ee39,
        0x1ee39
    ],
    [
        0x1ee3b,
        0x1ee3b
    ],
    [
        0x1ee42,
        0x1ee42
    ],
    [
        0x1ee47,
        0x1ee47
    ],
    [
        0x1ee49,
        0x1ee49
    ],
    [
        0x1ee4b,
        0x1ee4b
    ],
    [
        0x1ee4d,
        0x1ee4f
    ],
    [
        0x1ee51,
        0x1ee52
    ],
    [
        0x1ee54,
        0x1ee54
    ],
    [
        0x1ee57,
        0x1ee57
    ],
    [
        0x1ee59,
        0x1ee59
    ],
    [
        0x1ee5b,
        0x1ee5b
    ],
    [
        0x1ee5d,
        0x1ee5d
    ],
    [
        0x1ee5f,
        0x1ee5f
    ],
    [
        0x1ee61,
        0x1ee62
    ],
    [
        0x1ee64,
        0x1ee64
    ],
    [
        0x1ee67,
        0x1ee6a
    ],
    [
        0x1ee6c,
        0x1ee72
    ],
    [
        0x1ee74,
        0x1ee77
    ],
    [
        0x1ee79,
        0x1ee7c
    ],
    [
        0x1ee7e,
        0x1ee7e
    ],
    [
        0x1ee80,
        0x1ee89
    ],
    [
        0x1ee8b,
        0x1ee9b
    ],
    [
        0x1eea1,
        0x1eea3
    ],
    [
        0x1eea5,
        0x1eea9
    ],
    [
        0x1eeab,
        0x1eebb
    ],
    [
        0x10fffd,
        0x10fffd
    ]
];
function $46f282c1f2cd4950$var$isStrongRTLChar(charCode) {
    for(var i = 0; i < $46f282c1f2cd4950$var$strongRTLRanges.length; i++){
        var currentRange = $46f282c1f2cd4950$var$strongRTLRanges[i];
        if (charCode >= currentRange[0] && charCode <= currentRange[1]) return true;
    }
    return false;
}
function $46f282c1f2cd4950$var$determineBidi(cueDiv) {
    var nodeStack = [], text = "", charCode;
    if (!cueDiv || !cueDiv.childNodes) return "ltr";
    function pushNodes(nodeStack, node) {
        for(var i = node.childNodes.length - 1; i >= 0; i--)nodeStack.push(node.childNodes[i]);
    }
    function nextTextNode(nodeStack) {
        if (!nodeStack || !nodeStack.length) return null;
        var node = nodeStack.pop(), text = node.textContent || node.innerText;
        if (text) {
            // TODO: This should match all unicode type B characters (paragraph
            // separator characters). See issue #115.
            var m = text.match(/^.*(\n|\r)/);
            if (m) {
                nodeStack.length = 0;
                return m[0];
            }
            return text;
        }
        if (node.tagName === "ruby") return nextTextNode(nodeStack);
        if (node.childNodes) {
            pushNodes(nodeStack, node);
            return nextTextNode(nodeStack);
        }
    }
    pushNodes(nodeStack, cueDiv);
    while(text = nextTextNode(nodeStack))for(var i = 0; i < text.length; i++){
        charCode = text.charCodeAt(i);
        if ($46f282c1f2cd4950$var$isStrongRTLChar(charCode)) return "rtl";
    }
    return "ltr";
}
function $46f282c1f2cd4950$var$computeLinePos(cue) {
    if (typeof cue.line === "number" && (cue.snapToLines || cue.line >= 0 && cue.line <= 100)) return cue.line;
    if (!cue.track || !cue.track.textTrackList || !cue.track.textTrackList.mediaElement) return -1;
    var track = cue.track, trackList = track.textTrackList, count = 0;
    for(var i = 0; i < trackList.length && trackList[i] !== track; i++)if (trackList[i].mode === "showing") count++;
    return ++count * -1;
}
function $46f282c1f2cd4950$var$StyleBox() {}
// Apply styles to a div. If there is no div passed then it defaults to the
// div on 'this'.
$46f282c1f2cd4950$var$StyleBox.prototype.applyStyles = function(styles, div) {
    div = div || this.div;
    for(var prop in styles)if (styles.hasOwnProperty(prop)) div.style[prop] = styles[prop];
};
$46f282c1f2cd4950$var$StyleBox.prototype.formatStyle = function(val, unit) {
    return val === 0 ? 0 : val + unit;
};
// Constructs the computed display state of the cue (a div). Places the div
// into the overlay which should be a block level element (usually a div).
function $46f282c1f2cd4950$var$CueStyleBox(window, cue, styleOptions) {
    $46f282c1f2cd4950$var$StyleBox.call(this);
    this.cue = cue;
    // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
    // have inline positioning and will function as the cue background box.
    this.cueDiv = $46f282c1f2cd4950$var$parseContent(window, cue.text);
    var styles = {
        color: "rgba(255, 255, 255, 1)",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        position: "relative",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: "inline",
        writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
        unicodeBidi: "plaintext"
    };
    this.applyStyles(styles, this.cueDiv);
    // Create an absolutely positioned div that will be used to position the cue
    // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
    // mirrors of them except middle instead of center on Safari.
    this.div = window.document.createElement("div");
    styles = {
        direction: $46f282c1f2cd4950$var$determineBidi(this.cueDiv),
        writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
        unicodeBidi: "plaintext",
        textAlign: cue.align === "middle" ? "center" : cue.align,
        font: styleOptions.font,
        whiteSpace: "pre-line",
        position: "absolute"
    };
    this.applyStyles(styles);
    this.div.appendChild(this.cueDiv);
    // Calculate the distance from the reference edge of the viewport to the text
    // position of the cue box. The reference edge will be resolved later when
    // the box orientation styles are applied.
    var textPos = 0;
    switch(cue.positionAlign){
        case "start":
        case "line-left":
            textPos = cue.position;
            break;
        case "center":
            textPos = cue.position - cue.size / 2;
            break;
        case "end":
        case "line-right":
            textPos = cue.position - cue.size;
            break;
    }
    // Horizontal box orientation; textPos is the distance from the left edge of the
    // area to the left edge of the box and cue.size is the distance extending to
    // the right from there.
    if (cue.vertical === "") this.applyStyles({
        left: this.formatStyle(textPos, "%"),
        width: this.formatStyle(cue.size, "%")
    });
    else this.applyStyles({
        top: this.formatStyle(textPos, "%"),
        height: this.formatStyle(cue.size, "%")
    });
    this.move = function(box) {
        this.applyStyles({
            top: this.formatStyle(box.top, "px"),
            bottom: this.formatStyle(box.bottom, "px"),
            left: this.formatStyle(box.left, "px"),
            right: this.formatStyle(box.right, "px"),
            height: this.formatStyle(box.height, "px"),
            width: this.formatStyle(box.width, "px")
        });
    };
}
$46f282c1f2cd4950$var$CueStyleBox.prototype = $46f282c1f2cd4950$var$_objCreate($46f282c1f2cd4950$var$StyleBox.prototype);
$46f282c1f2cd4950$var$CueStyleBox.prototype.constructor = $46f282c1f2cd4950$var$CueStyleBox;
// Represents the co-ordinates of an Element in a way that we can easily
// compute things with such as if it overlaps or intersects with another Element.
// Can initialize it with either a StyleBox or another BoxPosition.
function $46f282c1f2cd4950$var$BoxPosition(obj) {
    // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
    // was passed in and we need to copy the results of 'getBoundingClientRect'
    // as the object returned is readonly. All co-ordinate values are in reference
    // to the viewport origin (top left).
    var lh, height, width, top;
    if (obj.div) {
        height = obj.div.offsetHeight;
        width = obj.div.offsetWidth;
        top = obj.div.offsetTop;
        var rects = (rects = obj.div.childNodes) && (rects = rects[0]) && rects.getClientRects && rects.getClientRects();
        obj = obj.div.getBoundingClientRect();
        // In certain cases the outter div will be slightly larger then the sum of
        // the inner div's lines. This could be due to bold text, etc, on some platforms.
        // In this case we should get the average line height and use that. This will
        // result in the desired behaviour.
        lh = rects ? Math.max(rects[0] && rects[0].height || 0, obj.height / rects.length) : 0;
    }
    this.left = obj.left;
    this.right = obj.right;
    this.top = obj.top || top;
    this.height = obj.height || height;
    this.bottom = obj.bottom || top + (obj.height || height);
    this.width = obj.width || width;
    this.lineHeight = lh !== undefined ? lh : obj.lineHeight;
}
// Move the box along a particular axis. Optionally pass in an amount to move
// the box. If no amount is passed then the default is the line height of the
// box.
$46f282c1f2cd4950$var$BoxPosition.prototype.move = function(axis, toMove) {
    toMove = toMove !== undefined ? toMove : this.lineHeight;
    switch(axis){
        case "+x":
            this.left += toMove;
            this.right += toMove;
            break;
        case "-x":
            this.left -= toMove;
            this.right -= toMove;
            break;
        case "+y":
            this.top += toMove;
            this.bottom += toMove;
            break;
        case "-y":
            this.top -= toMove;
            this.bottom -= toMove;
            break;
    }
};
// Check if this box overlaps another box, b2.
$46f282c1f2cd4950$var$BoxPosition.prototype.overlaps = function(b2) {
    return this.left < b2.right && this.right > b2.left && this.top < b2.bottom && this.bottom > b2.top;
};
// Check if this box overlaps any other boxes in boxes.
$46f282c1f2cd4950$var$BoxPosition.prototype.overlapsAny = function(boxes) {
    for(var i = 0; i < boxes.length; i++){
        if (this.overlaps(boxes[i])) return true;
    }
    return false;
};
// Check if this box is within another box.
$46f282c1f2cd4950$var$BoxPosition.prototype.within = function(container) {
    return this.top >= container.top && this.bottom <= container.bottom && this.left >= container.left && this.right <= container.right;
};
// Check if this box is entirely within the container or it is overlapping
// on the edge opposite of the axis direction passed. For example, if "+x" is
// passed and the box is overlapping on the left edge of the container, then
// return true.
$46f282c1f2cd4950$var$BoxPosition.prototype.overlapsOppositeAxis = function(container, axis) {
    switch(axis){
        case "+x":
            return this.left < container.left;
        case "-x":
            return this.right > container.right;
        case "+y":
            return this.top < container.top;
        case "-y":
            return this.bottom > container.bottom;
    }
};
// Find the percentage of the area that this box is overlapping with another
// box.
$46f282c1f2cd4950$var$BoxPosition.prototype.intersectPercentage = function(b2) {
    var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)), y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)), intersectArea = x * y;
    return intersectArea / (this.height * this.width);
};
// Convert the positions from this box to CSS compatible positions using
// the reference container's positions. This has to be done because this
// box's positions are in reference to the viewport origin, whereas, CSS
// values are in referecne to their respective edges.
$46f282c1f2cd4950$var$BoxPosition.prototype.toCSSCompatValues = function(reference) {
    return {
        top: this.top - reference.top,
        bottom: reference.bottom - this.bottom,
        left: this.left - reference.left,
        right: reference.right - this.right,
        height: this.height,
        width: this.width
    };
};
// Get an object that represents the box's position without anything extra.
// Can pass a StyleBox, HTMLElement, or another BoxPositon.
$46f282c1f2cd4950$var$BoxPosition.getSimpleBoxPosition = function(obj) {
    var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
    var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
    var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
    obj = obj.div ? obj.div.getBoundingClientRect() : obj.tagName ? obj.getBoundingClientRect() : obj;
    var ret = {
        left: obj.left,
        right: obj.right,
        top: obj.top || top,
        height: obj.height || height,
        bottom: obj.bottom || top + (obj.height || height),
        width: obj.width || width
    };
    return ret;
};
// Move a StyleBox to its specified, or next best, position. The containerBox
// is the box that contains the StyleBox, such as a div. boxPositions are
// a list of other boxes that the styleBox can't overlap with.
function $46f282c1f2cd4950$var$moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {
    // Find the best position for a cue box, b, on the video. The axis parameter
    // is a list of axis, the order of which, it will move the box along. For example:
    // Passing ["+x", "-x"] will move the box first along the x axis in the positive
    // direction. If it doesn't find a good position for it there it will then move
    // it along the x axis in the negative direction.
    function findBestPosition(b, axis) {
        var bestPosition, specifiedPosition = new $46f282c1f2cd4950$var$BoxPosition(b), percentage = 1; // Highest possible so the first thing we get is better.
        for(var i = 0; i < axis.length; i++){
            while(b.overlapsOppositeAxis(containerBox, axis[i]) || b.within(containerBox) && b.overlapsAny(boxPositions))b.move(axis[i]);
            // We found a spot where we aren't overlapping anything. This is our
            // best position.
            if (b.within(containerBox)) return b;
            var p = b.intersectPercentage(containerBox);
            // If we're outside the container box less then we were on our last try
            // then remember this position as the best position.
            if (percentage > p) {
                bestPosition = new $46f282c1f2cd4950$var$BoxPosition(b);
                percentage = p;
            }
            // Reset the box position to the specified position.
            b = new $46f282c1f2cd4950$var$BoxPosition(specifiedPosition);
        }
        return bestPosition || specifiedPosition;
    }
    var boxPosition = new $46f282c1f2cd4950$var$BoxPosition(styleBox), cue = styleBox.cue, linePos = $46f282c1f2cd4950$var$computeLinePos(cue), axis = [];
    // If we have a line number to align the cue to.
    if (cue.snapToLines) {
        var size;
        switch(cue.vertical){
            case "":
                axis = [
                    "+y",
                    "-y"
                ];
                size = "height";
                break;
            case "rl":
                axis = [
                    "+x",
                    "-x"
                ];
                size = "width";
                break;
            case "lr":
                axis = [
                    "-x",
                    "+x"
                ];
                size = "width";
                break;
        }
        var step = boxPosition.lineHeight, position = step * Math.round(linePos), maxPosition = containerBox[size] + step, initialAxis = axis[0];
        // If the specified intial position is greater then the max position then
        // clamp the box to the amount of steps it would take for the box to
        // reach the max position.
        if (Math.abs(position) > maxPosition) {
            position = position < 0 ? -1 : 1;
            position *= Math.ceil(maxPosition / step) * step;
        }
        // If computed line position returns negative then line numbers are
        // relative to the bottom of the video instead of the top. Therefore, we
        // need to increase our initial position by the length or width of the
        // video, depending on the writing direction, and reverse our axis directions.
        if (linePos < 0) {
            position += cue.vertical === "" ? containerBox.height : containerBox.width;
            axis = axis.reverse();
        }
        // Move the box to the specified position. This may not be its best
        // position.
        boxPosition.move(initialAxis, position);
    } else {
        // If we have a percentage line value for the cue.
        var calculatedPercentage = boxPosition.lineHeight / containerBox.height * 100;
        switch(cue.lineAlign){
            case "center":
                linePos -= calculatedPercentage / 2;
                break;
            case "end":
                linePos -= calculatedPercentage;
                break;
        }
        // Apply initial line position to the cue box.
        switch(cue.vertical){
            case "":
                styleBox.applyStyles({
                    top: styleBox.formatStyle(linePos, "%")
                });
                break;
            case "rl":
                styleBox.applyStyles({
                    left: styleBox.formatStyle(linePos, "%")
                });
                break;
            case "lr":
                styleBox.applyStyles({
                    right: styleBox.formatStyle(linePos, "%")
                });
                break;
        }
        axis = [
            "+y",
            "-x",
            "+x",
            "-y"
        ];
        // Get the box position again after we've applied the specified positioning
        // to it.
        boxPosition = new $46f282c1f2cd4950$var$BoxPosition(styleBox);
    }
    var bestPosition = findBestPosition(boxPosition, axis);
    styleBox.move(bestPosition.toCSSCompatValues(containerBox));
}
function $46f282c1f2cd4950$var$WebVTT() {
// Nothing
}
// Helper to allow strings to be decoded instead of the default binary utf8 data.
$46f282c1f2cd4950$var$WebVTT.StringDecoder = function() {
    return {
        decode: function(data) {
            if (!data) return "";
            if (typeof data !== "string") throw new Error("Error - expected string data.");
            return decodeURIComponent(encodeURIComponent(data));
        }
    };
};
$46f282c1f2cd4950$var$WebVTT.convertCueToDOMTree = function(window, cuetext) {
    if (!window || !cuetext) return null;
    return $46f282c1f2cd4950$var$parseContent(window, cuetext);
};
var $46f282c1f2cd4950$var$FONT_SIZE_PERCENT = 0.05;
var $46f282c1f2cd4950$var$FONT_STYLE = "sans-serif";
var $46f282c1f2cd4950$var$CUE_BACKGROUND_PADDING = "1.5%";
// Runs the processing model over the cues and regions passed to it.
// @param overlay A block level element (usually a div) that the computed cues
//                and regions will be placed into.
$46f282c1f2cd4950$var$WebVTT.processCues = function(window, cues, overlay) {
    if (!window || !cues || !overlay) return null;
    // Remove all previous children.
    while(overlay.firstChild)overlay.removeChild(overlay.firstChild);
    var paddedOverlay = window.document.createElement("div");
    paddedOverlay.style.position = "absolute";
    paddedOverlay.style.left = "0";
    paddedOverlay.style.right = "0";
    paddedOverlay.style.top = "0";
    paddedOverlay.style.bottom = "0";
    paddedOverlay.style.margin = $46f282c1f2cd4950$var$CUE_BACKGROUND_PADDING;
    overlay.appendChild(paddedOverlay);
    // Determine if we need to compute the display states of the cues. This could
    // be the case if a cue's state has been changed since the last computation or
    // if it has not been computed yet.
    function shouldCompute(cues) {
        for(var i = 0; i < cues.length; i++){
            if (cues[i].hasBeenReset || !cues[i].displayState) return true;
        }
        return false;
    }
    // We don't need to recompute the cues' display states. Just reuse them.
    if (!shouldCompute(cues)) {
        for(var i = 0; i < cues.length; i++)paddedOverlay.appendChild(cues[i].displayState);
        return;
    }
    var boxPositions = [], containerBox = $46f282c1f2cd4950$var$BoxPosition.getSimpleBoxPosition(paddedOverlay), fontSize = Math.round(containerBox.height * $46f282c1f2cd4950$var$FONT_SIZE_PERCENT * 100) / 100;
    var styleOptions = {
        font: fontSize + "px " + $46f282c1f2cd4950$var$FONT_STYLE
    };
    (function() {
        var styleBox, cue;
        for(var i = 0; i < cues.length; i++){
            cue = cues[i];
            // Compute the intial position and styles of the cue div.
            styleBox = new $46f282c1f2cd4950$var$CueStyleBox(window, cue, styleOptions);
            paddedOverlay.appendChild(styleBox.div);
            // Move the cue div to it's correct line position.
            $46f282c1f2cd4950$var$moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);
            // Remember the computed div so that we don't have to recompute it later
            // if we don't have too.
            cue.displayState = styleBox.div;
            boxPositions.push($46f282c1f2cd4950$var$BoxPosition.getSimpleBoxPosition(styleBox));
        }
    })();
};
$46f282c1f2cd4950$var$WebVTT.Parser = function(window, vttjs, decoder) {
    if (!decoder) {
        decoder = vttjs;
        vttjs = {};
    }
    if (!vttjs) vttjs = {};
    this.window = window;
    this.vttjs = vttjs;
    this.state = "INITIAL";
    this.buffer = "";
    this.decoder = decoder || new TextDecoder("utf8");
    this.regionList = [];
};
$46f282c1f2cd4950$var$WebVTT.Parser.prototype = {
    // If the error is a ParsingError then report it to the consumer if
    // possible. If it's not a ParsingError then throw it like normal.
    reportOrThrowError: function(e) {
        if (e instanceof $46f282c1f2cd4950$var$ParsingError) this.onparsingerror && this.onparsingerror(e);
        else throw e;
    },
    parse: function(data) {
        var self = this;
        // If there is no data then we won't decode it, but will just try to parse
        // whatever is in buffer already. This may occur in circumstances, for
        // example when flush() is called.
        if (data) // Try to decode the data that we received.
        self.buffer += self.decoder.decode(data, {
            stream: true
        });
        function collectNextLine() {
            var buffer = self.buffer;
            var pos = 0;
            while(pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n')++pos;
            var line = buffer.substr(0, pos);
            // Advance the buffer early in case we fail below.
            if (buffer[pos] === '\r') ++pos;
            if (buffer[pos] === '\n') ++pos;
            self.buffer = buffer.substr(pos);
            return line;
        }
        // 3.4 WebVTT region and WebVTT region settings syntax
        function parseRegion(input) {
            var settings = new $46f282c1f2cd4950$var$Settings();
            $46f282c1f2cd4950$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "id":
                        settings.set(k, v);
                        break;
                    case "width":
                        settings.percent(k, v);
                        break;
                    case "lines":
                        settings.integer(k, v);
                        break;
                    case "regionanchor":
                    case "viewportanchor":
                        var xy = v.split(',');
                        if (xy.length !== 2) break;
                        // We have to make sure both x and y parse, so use a temporary
                        // settings object here.
                        var anchor = new $46f282c1f2cd4950$var$Settings();
                        anchor.percent("x", xy[0]);
                        anchor.percent("y", xy[1]);
                        if (!anchor.has("x") || !anchor.has("y")) break;
                        settings.set(k + "X", anchor.get("x"));
                        settings.set(k + "Y", anchor.get("y"));
                        break;
                    case "scroll":
                        settings.alt(k, v, [
                            "up"
                        ]);
                        break;
                }
            }, /=/, /\s/);
            // Create the region, using default values for any values that were not
            // specified.
            if (settings.has("id")) {
                var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
                region.width = settings.get("width", 100);
                region.lines = settings.get("lines", 3);
                region.regionAnchorX = settings.get("regionanchorX", 0);
                region.regionAnchorY = settings.get("regionanchorY", 100);
                region.viewportAnchorX = settings.get("viewportanchorX", 0);
                region.viewportAnchorY = settings.get("viewportanchorY", 100);
                region.scroll = settings.get("scroll", "");
                // Register the region.
                self.onregion && self.onregion(region);
                // Remember the VTTRegion for later in case we parse any VTTCues that
                // reference it.
                self.regionList.push({
                    id: settings.get("id"),
                    region: region
                });
            }
        }
        // draft-pantos-http-live-streaming-20
        // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
        // 3.5 WebVTT
        function parseTimestampMap(input) {
            var settings = new $46f282c1f2cd4950$var$Settings();
            $46f282c1f2cd4950$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "MPEGT":
                        settings.integer(k + 'S', v);
                        break;
                    case "LOCA":
                        settings.set(k + 'L', $46f282c1f2cd4950$var$parseTimeStamp(v));
                        break;
                }
            }, /[^\d]:/, /,/);
            self.ontimestampmap && self.ontimestampmap({
                "MPEGTS": settings.get("MPEGTS"),
                "LOCAL": settings.get("LOCAL")
            });
        }
        // 3.2 WebVTT metadata header syntax
        function parseHeader(input) {
            if (input.match(/X-TIMESTAMP-MAP/)) // This line contains HLS X-TIMESTAMP-MAP metadata
            $46f282c1f2cd4950$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "X-TIMESTAMP-MAP":
                        parseTimestampMap(v);
                        break;
                }
            }, /=/);
            else $46f282c1f2cd4950$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "Region":
                        // 3.3 WebVTT region metadata header syntax
                        parseRegion(v);
                        break;
                }
            }, /:/);
        }
        // 5.1 WebVTT file parsing.
        try {
            var line;
            if (self.state === "INITIAL") {
                // We can't start parsing until we have the first line.
                if (!/\r\n|\n/.test(self.buffer)) return this;
                line = collectNextLine();
                var m = line.match(/^WEBVTT([ \t].*)?$/);
                if (!m || !m[0]) throw new $46f282c1f2cd4950$var$ParsingError($46f282c1f2cd4950$var$ParsingError.Errors.BadSignature);
                self.state = "HEADER";
            }
            var alreadyCollectedLine = false;
            while(self.buffer){
                // We can't parse a line until we have the full line.
                if (!/\r\n|\n/.test(self.buffer)) return this;
                if (!alreadyCollectedLine) line = collectNextLine();
                else alreadyCollectedLine = false;
                switch(self.state){
                    case "HEADER":
                        // 13-18 - Allow a header (metadata) under the WEBVTT line.
                        if (/:/.test(line)) parseHeader(line);
                        else if (!line) // An empty line terminates the header and starts the body (cues).
                        self.state = "ID";
                        continue;
                    case "NOTE":
                        // Ignore NOTE blocks.
                        if (!line) self.state = "ID";
                        continue;
                    case "ID":
                        // Check for the start of NOTE blocks.
                        if (/^NOTE($|[ \t])/.test(line)) {
                            self.state = "NOTE";
                            break;
                        }
                        // 19-29 - Allow any number of line terminators, then initialize new cue values.
                        if (!line) continue;
                        self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
                        // Safari still uses the old middle value and won't accept center
                        try {
                            self.cue.align = "center";
                        } catch (e) {
                            self.cue.align = "middle";
                        }
                        self.state = "CUE";
                        // 30-39 - Check if self line contains an optional identifier or timing data.
                        if (line.indexOf("-->") === -1) {
                            self.cue.id = line;
                            continue;
                        }
                    // Process line as start of a cue.
                    /*falls through*/ case "CUE":
                        // 40 - Collect cue timings and settings.
                        try {
                            $46f282c1f2cd4950$var$parseCue(line, self.cue, self.regionList);
                        } catch (e) {
                            self.reportOrThrowError(e);
                            // In case of an error ignore rest of the cue.
                            self.cue = null;
                            self.state = "BADCUE";
                            continue;
                        }
                        self.state = "CUETEXT";
                        continue;
                    case "CUETEXT":
                        var hasSubstring = line.indexOf("-->") !== -1;
                        // 34 - If we have an empty line then report the cue.
                        // 35 - If we have the special substring '-->' then report the cue,
                        // but do not collect the line as we need to process the current
                        // one as a new cue.
                        if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                            // We are done parsing self cue.
                            self.oncue && self.oncue(self.cue);
                            self.cue = null;
                            self.state = "ID";
                            continue;
                        }
                        if (self.cue.text) self.cue.text += "\n";
                        self.cue.text += line.replace(/\u2028/g, '\n').replace(/u2029/g, '\n');
                        continue;
                    case "BADCUE":
                        // 54-62 - Collect and discard the remaining cue.
                        if (!line) self.state = "ID";
                        continue;
                }
            }
        } catch (e) {
            self.reportOrThrowError(e);
            // If we are currently parsing a cue, report what we have.
            if (self.state === "CUETEXT" && self.cue && self.oncue) self.oncue(self.cue);
            self.cue = null;
            // Enter BADWEBVTT state if header was not parsed correctly otherwise
            // another exception occurred so enter BADCUE state.
            self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
        }
        return this;
    },
    flush: function() {
        var self = this;
        try {
            // Finish decoding the stream.
            self.buffer += self.decoder.decode();
            // Synthesize the end of the current cue or region.
            if (self.cue || self.state === "HEADER") {
                self.buffer += "\n\n";
                self.parse();
            }
            // If we've flushed, parsed, and we're still on the INITIAL state then
            // that means we don't have enough of the stream to parse the first
            // line.
            if (self.state === "INITIAL") throw new $46f282c1f2cd4950$var$ParsingError($46f282c1f2cd4950$var$ParsingError.Errors.BadSignature);
        } catch (e) {
            self.reportOrThrowError(e);
        }
        self.onflush && self.onflush();
        return this;
    }
};
module.exports = $46f282c1f2cd4950$var$WebVTT;

});

parcelRegister("aWh86", function(module, exports) {
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7f6c9bbd3c21d754$var$autoKeyword = "auto";
var $7f6c9bbd3c21d754$var$directionSetting = {
    "": 1,
    "lr": 1,
    "rl": 1
};
var $7f6c9bbd3c21d754$var$alignSetting = {
    "start": 1,
    "center": 1,
    "end": 1,
    "left": 1,
    "right": 1,
    "auto": 1,
    "line-left": 1,
    "line-right": 1
};
function $7f6c9bbd3c21d754$var$findDirectionSetting(value) {
    if (typeof value !== "string") return false;
    var dir = $7f6c9bbd3c21d754$var$directionSetting[value.toLowerCase()];
    return dir ? value.toLowerCase() : false;
}
function $7f6c9bbd3c21d754$var$findAlignSetting(value) {
    if (typeof value !== "string") return false;
    var align = $7f6c9bbd3c21d754$var$alignSetting[value.toLowerCase()];
    return align ? value.toLowerCase() : false;
}
function $7f6c9bbd3c21d754$var$VTTCue(startTime, endTime, text) {
    /**
   * Shim implementation specific properties. These properties are not in
   * the spec.
   */ // Lets us know when the VTTCue's data has changed in such a way that we need
    // to recompute its display state. This lets us compute its display state
    // lazily.
    this.hasBeenReset = false;
    /**
   * VTTCue and TextTrackCue properties
   * http://dev.w3.org/html5/webvtt/#vttcue-interface
   */ var _id = "";
    var _pauseOnExit = false;
    var _startTime = startTime;
    var _endTime = endTime;
    var _text = text;
    var _region = null;
    var _vertical = "";
    var _snapToLines = true;
    var _line = "auto";
    var _lineAlign = "start";
    var _position = "auto";
    var _positionAlign = "auto";
    var _size = 100;
    var _align = "center";
    Object.defineProperties(this, {
        "id": {
            enumerable: true,
            get: function() {
                return _id;
            },
            set: function(value) {
                _id = "" + value;
            }
        },
        "pauseOnExit": {
            enumerable: true,
            get: function() {
                return _pauseOnExit;
            },
            set: function(value) {
                _pauseOnExit = !!value;
            }
        },
        "startTime": {
            enumerable: true,
            get: function() {
                return _startTime;
            },
            set: function(value) {
                if (typeof value !== "number") throw new TypeError("Start time must be set to a number.");
                _startTime = value;
                this.hasBeenReset = true;
            }
        },
        "endTime": {
            enumerable: true,
            get: function() {
                return _endTime;
            },
            set: function(value) {
                if (typeof value !== "number") throw new TypeError("End time must be set to a number.");
                _endTime = value;
                this.hasBeenReset = true;
            }
        },
        "text": {
            enumerable: true,
            get: function() {
                return _text;
            },
            set: function(value) {
                _text = "" + value;
                this.hasBeenReset = true;
            }
        },
        "region": {
            enumerable: true,
            get: function() {
                return _region;
            },
            set: function(value) {
                _region = value;
                this.hasBeenReset = true;
            }
        },
        "vertical": {
            enumerable: true,
            get: function() {
                return _vertical;
            },
            set: function(value) {
                var setting = $7f6c9bbd3c21d754$var$findDirectionSetting(value);
                // Have to check for false because the setting an be an empty string.
                if (setting === false) throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
                _vertical = setting;
                this.hasBeenReset = true;
            }
        },
        "snapToLines": {
            enumerable: true,
            get: function() {
                return _snapToLines;
            },
            set: function(value) {
                _snapToLines = !!value;
                this.hasBeenReset = true;
            }
        },
        "line": {
            enumerable: true,
            get: function() {
                return _line;
            },
            set: function(value) {
                if (typeof value !== "number" && value !== $7f6c9bbd3c21d754$var$autoKeyword) throw new SyntaxError("Line: an invalid number or illegal string was specified.");
                _line = value;
                this.hasBeenReset = true;
            }
        },
        "lineAlign": {
            enumerable: true,
            get: function() {
                return _lineAlign;
            },
            set: function(value) {
                var setting = $7f6c9bbd3c21d754$var$findAlignSetting(value);
                if (!setting) console.warn("lineAlign: an invalid or illegal string was specified.");
                else {
                    _lineAlign = setting;
                    this.hasBeenReset = true;
                }
            }
        },
        "position": {
            enumerable: true,
            get: function() {
                return _position;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error("Position must be between 0 and 100.");
                _position = value;
                this.hasBeenReset = true;
            }
        },
        "positionAlign": {
            enumerable: true,
            get: function() {
                return _positionAlign;
            },
            set: function(value) {
                var setting = $7f6c9bbd3c21d754$var$findAlignSetting(value);
                if (!setting) console.warn("positionAlign: an invalid or illegal string was specified.");
                else {
                    _positionAlign = setting;
                    this.hasBeenReset = true;
                }
            }
        },
        "size": {
            enumerable: true,
            get: function() {
                return _size;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error("Size must be between 0 and 100.");
                _size = value;
                this.hasBeenReset = true;
            }
        },
        "align": {
            enumerable: true,
            get: function() {
                return _align;
            },
            set: function(value) {
                var setting = $7f6c9bbd3c21d754$var$findAlignSetting(value);
                if (!setting) throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
                _align = setting;
                this.hasBeenReset = true;
            }
        }
    });
    /**
   * Other <track> spec defined properties
   */ // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
    this.displayState = undefined;
}
/**
 * VTTCue methods
 */ $7f6c9bbd3c21d754$var$VTTCue.prototype.getCueAsHTML = function() {
    // Assume WebVTT.convertCueToDOMTree is on the global.
    return WebVTT.convertCueToDOMTree(window, this.text);
};
module.exports = $7f6c9bbd3c21d754$var$VTTCue;

});

parcelRegister("f8lRN", function(module, exports) {
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b04890a7ae393ca1$var$scrollSetting = {
    "": true,
    "up": true
};
function $b04890a7ae393ca1$var$findScrollSetting(value) {
    if (typeof value !== "string") return false;
    var scroll = $b04890a7ae393ca1$var$scrollSetting[value.toLowerCase()];
    return scroll ? value.toLowerCase() : false;
}
function $b04890a7ae393ca1$var$isValidPercentValue(value) {
    return typeof value === "number" && value >= 0 && value <= 100;
}
// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
function $b04890a7ae393ca1$var$VTTRegion() {
    var _width = 100;
    var _lines = 3;
    var _regionAnchorX = 0;
    var _regionAnchorY = 100;
    var _viewportAnchorX = 0;
    var _viewportAnchorY = 100;
    var _scroll = "";
    Object.defineProperties(this, {
        "width": {
            enumerable: true,
            get: function() {
                return _width;
            },
            set: function(value) {
                if (!$b04890a7ae393ca1$var$isValidPercentValue(value)) throw new Error("Width must be between 0 and 100.");
                _width = value;
            }
        },
        "lines": {
            enumerable: true,
            get: function() {
                return _lines;
            },
            set: function(value) {
                if (typeof value !== "number") throw new TypeError("Lines must be set to a number.");
                _lines = value;
            }
        },
        "regionAnchorY": {
            enumerable: true,
            get: function() {
                return _regionAnchorY;
            },
            set: function(value) {
                if (!$b04890a7ae393ca1$var$isValidPercentValue(value)) throw new Error("RegionAnchorX must be between 0 and 100.");
                _regionAnchorY = value;
            }
        },
        "regionAnchorX": {
            enumerable: true,
            get: function() {
                return _regionAnchorX;
            },
            set: function(value) {
                if (!$b04890a7ae393ca1$var$isValidPercentValue(value)) throw new Error("RegionAnchorY must be between 0 and 100.");
                _regionAnchorX = value;
            }
        },
        "viewportAnchorY": {
            enumerable: true,
            get: function() {
                return _viewportAnchorY;
            },
            set: function(value) {
                if (!$b04890a7ae393ca1$var$isValidPercentValue(value)) throw new Error("ViewportAnchorY must be between 0 and 100.");
                _viewportAnchorY = value;
            }
        },
        "viewportAnchorX": {
            enumerable: true,
            get: function() {
                return _viewportAnchorX;
            },
            set: function(value) {
                if (!$b04890a7ae393ca1$var$isValidPercentValue(value)) throw new Error("ViewportAnchorX must be between 0 and 100.");
                _viewportAnchorX = value;
            }
        },
        "scroll": {
            enumerable: true,
            get: function() {
                return _scroll;
            },
            set: function(value) {
                var setting = $b04890a7ae393ca1$var$findScrollSetting(value);
                // Have to check for false as an empty string is a legal value.
                if (setting === false) console.warn("Scroll: an invalid or illegal string was specified.");
                else _scroll = setting;
            }
        }
    });
}
module.exports = $b04890a7ae393ca1$var$VTTRegion;

});


parcelRegister("5JQY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $42da3e152bb58681$export$2e2bcd8739ae039);

var $eDick = parcelRequire("eDick");
var $42da3e152bb58681$var$DEFAULT_LOCATION = 'https://example.com';
var $42da3e152bb58681$var$resolveUrl = function resolveUrl(baseUrl, relativeUrl) {
    // return early if we don't need to resolve
    if (/^[a-z]+:/i.test(relativeUrl)) return relativeUrl;
     // if baseUrl is a data URI, ignore it and resolve everything relative to window.location
    if (/^data:/.test(baseUrl)) baseUrl = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href || '';
    var protocolLess = /^\/\//.test(baseUrl); // remove location if window.location isn't available (i.e. we're in node)
    // and if baseUrl isn't an absolute url
    var removeLocation = !(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location && !/\/\//i.test(baseUrl); // if the base URL is relative then combine with the current location
    baseUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL(baseUrl, (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location || $42da3e152bb58681$var$DEFAULT_LOCATION);
    var newUrl = new URL(relativeUrl, baseUrl); // if we're a protocol-less url, remove the protocol
    // and if we're location-less, remove the location
    // otherwise, return the url unmodified
    if (removeLocation) return newUrl.href.slice($42da3e152bb58681$var$DEFAULT_LOCATION.length);
    else if (protocolLess) return newUrl.href.slice(newUrl.protocol.length);
    return newUrl.href;
};
var $42da3e152bb58681$export$2e2bcd8739ae039 = $42da3e152bb58681$var$resolveUrl;

});

parcelRegister("2306U", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $17dbf2814389b162$export$7acfa6ed01010e37);
/*! @name m3u8-parser @version 7.2.0 @license Apache-2.0 */ 
var $11O3Q = parcelRequire("11O3Q");

var $3p9rK = parcelRequire("3p9rK");

var $ia8V9 = parcelRequire("ia8V9");
/**
 * @file m3u8/line-stream.js
 */ /**
 * A stream that buffers string input and generates a `data` event for each
 * line.
 *
 * @class LineStream
 * @extends Stream
 */ class $17dbf2814389b162$export$307ab5c52b11c33e extends (0, $11O3Q.default) {
    constructor(){
        super();
        this.buffer = '';
    }
    /**
   * Add new data to be parsed.
   *
   * @param {string} data the text to process
   */ push(data) {
        let nextNewline;
        this.buffer += data;
        nextNewline = this.buffer.indexOf('\n');
        for(; nextNewline > -1; nextNewline = this.buffer.indexOf('\n')){
            this.trigger('data', this.buffer.substring(0, nextNewline));
            this.buffer = this.buffer.substring(nextNewline + 1);
        }
    }
}
const $17dbf2814389b162$var$TAB = String.fromCharCode(0x09);
const $17dbf2814389b162$var$parseByterange = function(byterangeString) {
    // optionally match and capture 0+ digits before `@`
    // optionally match and capture 0+ digits after `@`
    const match = /([0-9.]*)?@?([0-9.]*)?/.exec(byterangeString || '');
    const result = {};
    if (match[1]) result.length = parseInt(match[1], 10);
    if (match[2]) result.offset = parseInt(match[2], 10);
    return result;
};
/**
 * "forgiving" attribute list psuedo-grammar:
 * attributes -> keyvalue (',' keyvalue)*
 * keyvalue   -> key '=' value
 * key        -> [^=]*
 * value      -> '"' [^"]* '"' | [^,]*
 */ const $17dbf2814389b162$var$attributeSeparator = function() {
    const key = '[^=]*';
    const value = '"[^"]*"|[^,]*';
    const keyvalue = '(?:' + key + ')=(?:' + value + ')';
    return new RegExp('(?:^|,)(' + keyvalue + ')');
};
/**
 * Parse attributes from a line given the separator
 *
 * @param {string} attributes the attribute line to parse
 */ const $17dbf2814389b162$var$parseAttributes = function(attributes) {
    const result = {};
    if (!attributes) return result;
     // split the string using attributes as the separator
    const attrs = attributes.split($17dbf2814389b162$var$attributeSeparator());
    let i = attrs.length;
    let attr;
    while(i--){
        // filter out unmatched portions of the string
        if (attrs[i] === '') continue;
         // split the key and value
        attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1); // trim whitespace and remove optional quotes around the value
        attr[0] = attr[0].replace(/^\s+|\s+$/g, '');
        attr[1] = attr[1].replace(/^\s+|\s+$/g, '');
        attr[1] = attr[1].replace(/^['"](.*)['"]$/g, '$1');
        result[attr[0]] = attr[1];
    }
    return result;
};
/**
 * Converts a string into a resolution object
 *
 * @param {string} resolution a string such as 3840x2160
 *
 * @return {Object} An object representing the resolution
 *
 */ const $17dbf2814389b162$var$parseResolution = (resolution)=>{
    const split = resolution.split('x');
    const result = {};
    if (split[0]) result.width = parseInt(split[0], 10);
    if (split[1]) result.height = parseInt(split[1], 10);
    return result;
};
/**
 * A line-level M3U8 parser event stream. It expects to receive input one
 * line at a time and performs a context-free parse of its contents. A stream
 * interpretation of a manifest can be useful if the manifest is expected to
 * be too large to fit comfortably into memory or the entirety of the input
 * is not immediately available. Otherwise, it's probably much easier to work
 * with a regular `Parser` object.
 *
 * Produces `data` events with an object that captures the parser's
 * interpretation of the input. That object has a property `tag` that is one
 * of `uri`, `comment`, or `tag`. URIs only have a single additional
 * property, `line`, which captures the entirety of the input without
 * interpretation. Comments similarly have a single additional property
 * `text` which is the input without the leading `#`.
 *
 * Tags always have a property `tagType` which is the lower-cased version of
 * the M3U8 directive without the `#EXT` or `#EXT-X-` prefix. For instance,
 * `#EXT-X-MEDIA-SEQUENCE` becomes `media-sequence` when parsed. Unrecognized
 * tags are given the tag type `unknown` and a single additional property
 * `data` with the remainder of the input.
 *
 * @class ParseStream
 * @extends Stream
 */ class $17dbf2814389b162$export$bc65cb5a6d9da573 extends (0, $11O3Q.default) {
    constructor(){
        super();
        this.customParsers = [];
        this.tagMappers = [];
    }
    /**
   * Parses an additional line of input.
   *
   * @param {string} line a single line of an M3U8 file to parse
   */ push(line) {
        let match;
        let event; // strip whitespace
        line = line.trim();
        if (line.length === 0) // ignore empty lines
        return;
         // URIs
        if (line[0] !== '#') {
            this.trigger('data', {
                type: 'uri',
                uri: line
            });
            return;
        } // map tags
        const newLines = this.tagMappers.reduce((acc, mapper)=>{
            const mappedLine = mapper(line); // skip if unchanged
            if (mappedLine === line) return acc;
            return acc.concat([
                mappedLine
            ]);
        }, [
            line
        ]);
        newLines.forEach((newLine)=>{
            for(let i = 0; i < this.customParsers.length; i++){
                if (this.customParsers[i].call(this, newLine)) return;
            } // Comments
            if (newLine.indexOf('#EXT') !== 0) {
                this.trigger('data', {
                    type: 'comment',
                    text: newLine.slice(1)
                });
                return;
            } // strip off any carriage returns here so the regex matching
            // doesn't have to account for them.
            newLine = newLine.replace('\r', ''); // Tags
            match = /^#EXTM3U/.exec(newLine);
            if (match) {
                this.trigger('data', {
                    type: 'tag',
                    tagType: 'm3u'
                });
                return;
            }
            match = /^#EXTINF:([0-9\.]*)?,?(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'inf'
                };
                if (match[1]) event.duration = parseFloat(match[1]);
                if (match[2]) event.title = match[2];
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-TARGETDURATION:([0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'targetduration'
                };
                if (match[1]) event.duration = parseInt(match[1], 10);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-VERSION:([0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'version'
                };
                if (match[1]) event.version = parseInt(match[1], 10);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-MEDIA-SEQUENCE:(\-?[0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'media-sequence'
                };
                if (match[1]) event.number = parseInt(match[1], 10);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-DISCONTINUITY-SEQUENCE:(\-?[0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'discontinuity-sequence'
                };
                if (match[1]) event.number = parseInt(match[1], 10);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-PLAYLIST-TYPE:(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'playlist-type'
                };
                if (match[1]) event.playlistType = match[1];
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-BYTERANGE:(.*)?$/.exec(newLine);
            if (match) {
                event = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))($17dbf2814389b162$var$parseByterange(match[1]), {
                    type: 'tag',
                    tagType: 'byterange'
                });
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-ALLOW-CACHE:(YES|NO)?/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'allow-cache'
                };
                if (match[1]) event.allowed = !/NO/.test(match[1]);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-MAP:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'map'
                };
                if (match[1]) {
                    const attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                    if (attributes.URI) event.uri = attributes.URI;
                    if (attributes.BYTERANGE) event.byterange = $17dbf2814389b162$var$parseByterange(attributes.BYTERANGE);
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-STREAM-INF:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'stream-inf'
                };
                if (match[1]) {
                    event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                    if (event.attributes.RESOLUTION) event.attributes.RESOLUTION = $17dbf2814389b162$var$parseResolution(event.attributes.RESOLUTION);
                    if (event.attributes.BANDWIDTH) event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
                    if (event.attributes['FRAME-RATE']) event.attributes['FRAME-RATE'] = parseFloat(event.attributes['FRAME-RATE']);
                    if (event.attributes['PROGRAM-ID']) event.attributes['PROGRAM-ID'] = parseInt(event.attributes['PROGRAM-ID'], 10);
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-MEDIA:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'media'
                };
                if (match[1]) event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-ENDLIST/.exec(newLine);
            if (match) {
                this.trigger('data', {
                    type: 'tag',
                    tagType: 'endlist'
                });
                return;
            }
            match = /^#EXT-X-DISCONTINUITY/.exec(newLine);
            if (match) {
                this.trigger('data', {
                    type: 'tag',
                    tagType: 'discontinuity'
                });
                return;
            }
            match = /^#EXT-X-PROGRAM-DATE-TIME:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'program-date-time'
                };
                if (match[1]) {
                    event.dateTimeString = match[1];
                    event.dateTimeObject = new Date(match[1]);
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-KEY:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'key'
                };
                if (match[1]) {
                    event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]); // parse the IV string into a Uint32Array
                    if (event.attributes.IV) {
                        if (event.attributes.IV.substring(0, 2).toLowerCase() === '0x') event.attributes.IV = event.attributes.IV.substring(2);
                        event.attributes.IV = event.attributes.IV.match(/.{8}/g);
                        event.attributes.IV[0] = parseInt(event.attributes.IV[0], 16);
                        event.attributes.IV[1] = parseInt(event.attributes.IV[1], 16);
                        event.attributes.IV[2] = parseInt(event.attributes.IV[2], 16);
                        event.attributes.IV[3] = parseInt(event.attributes.IV[3], 16);
                        event.attributes.IV = new Uint32Array(event.attributes.IV);
                    }
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-START:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'start'
                };
                if (match[1]) {
                    event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                    event.attributes['TIME-OFFSET'] = parseFloat(event.attributes['TIME-OFFSET']);
                    event.attributes.PRECISE = /YES/.test(event.attributes.PRECISE);
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-CUE-OUT-CONT:(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'cue-out-cont'
                };
                if (match[1]) event.data = match[1];
                else event.data = '';
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-CUE-OUT:(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'cue-out'
                };
                if (match[1]) event.data = match[1];
                else event.data = '';
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-CUE-IN:?(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'cue-in'
                };
                if (match[1]) event.data = match[1];
                else event.data = '';
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-SKIP:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'skip'
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                if (event.attributes.hasOwnProperty('SKIPPED-SEGMENTS')) event.attributes['SKIPPED-SEGMENTS'] = parseInt(event.attributes['SKIPPED-SEGMENTS'], 10);
                if (event.attributes.hasOwnProperty('RECENTLY-REMOVED-DATERANGES')) event.attributes['RECENTLY-REMOVED-DATERANGES'] = event.attributes['RECENTLY-REMOVED-DATERANGES'].split($17dbf2814389b162$var$TAB);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-PART:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'part'
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    'DURATION'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                [
                    'INDEPENDENT',
                    'GAP'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = /YES/.test(event.attributes[key]);
                });
                if (event.attributes.hasOwnProperty('BYTERANGE')) event.attributes.byterange = $17dbf2814389b162$var$parseByterange(event.attributes.BYTERANGE);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'server-control'
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    'CAN-SKIP-UNTIL',
                    'PART-HOLD-BACK',
                    'HOLD-BACK'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                [
                    'CAN-SKIP-DATERANGES',
                    'CAN-BLOCK-RELOAD'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = /YES/.test(event.attributes[key]);
                });
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-PART-INF:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'part-inf'
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    'PART-TARGET'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'preload-hint'
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    'BYTERANGE-START',
                    'BYTERANGE-LENGTH'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) {
                        event.attributes[key] = parseInt(event.attributes[key], 10);
                        const subkey = key === 'BYTERANGE-LENGTH' ? 'length' : 'offset';
                        event.attributes.byterange = event.attributes.byterange || {};
                        event.attributes.byterange[subkey] = event.attributes[key]; // only keep the parsed byterange object.
                        delete event.attributes[key];
                    }
                });
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'rendition-report'
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    'LAST-MSN',
                    'LAST-PART'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseInt(event.attributes[key], 10);
                });
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-DATERANGE:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: 'tag',
                    tagType: 'daterange'
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    'ID',
                    'CLASS'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = String(event.attributes[key]);
                });
                [
                    'START-DATE',
                    'END-DATE'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = new Date(event.attributes[key]);
                });
                [
                    'DURATION',
                    'PLANNED-DURATION'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                [
                    'END-ON-NEXT'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = /YES/i.test(event.attributes[key]);
                });
                [
                    'SCTE35-CMD',
                    ' SCTE35-OUT',
                    'SCTE35-IN'
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = event.attributes[key].toString(16);
                });
                const clientAttributePattern = /^X-([A-Z]+-)+[A-Z]+$/;
                for(const key in event.attributes){
                    if (!clientAttributePattern.test(key)) continue;
                    const isHexaDecimal = /[0-9A-Fa-f]{6}/g.test(event.attributes[key]);
                    const isDecimalFloating = /^\d+(\.\d+)?$/.test(event.attributes[key]);
                    event.attributes[key] = isHexaDecimal ? event.attributes[key].toString(16) : isDecimalFloating ? parseFloat(event.attributes[key]) : String(event.attributes[key]);
                }
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(newLine);
            if (match) {
                this.trigger('data', {
                    type: 'tag',
                    tagType: 'independent-segments'
                });
                return;
            }
            match = /^#EXT-X-I-FRAMES-ONLY/.exec(newLine);
            if (match) {
                this.trigger('data', {
                    type: 'tag',
                    tagType: 'i-frames-only'
                });
                return;
            }
            match = /^#EXT-X-CONTENT-STEERING:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'content-steering'
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-I-FRAME-STREAM-INF:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'i-frame-playlist'
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                if (event.attributes.URI) event.uri = event.attributes.URI;
                if (event.attributes.BANDWIDTH) event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
                if (event.attributes.RESOLUTION) event.attributes.RESOLUTION = $17dbf2814389b162$var$parseResolution(event.attributes.RESOLUTION);
                if (event.attributes['AVERAGE-BANDWIDTH']) event.attributes['AVERAGE-BANDWIDTH'] = parseInt(event.attributes['AVERAGE-BANDWIDTH'], 10);
                if (event.attributes['FRAME-RATE']) event.attributes['FRAME-RATE'] = parseFloat(event.attributes['FRAME-RATE']);
                this.trigger('data', event);
                return;
            }
            match = /^#EXT-X-DEFINE:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: 'tag',
                    tagType: 'define'
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                this.trigger('data', event);
                return;
            } // unknown tag type
            this.trigger('data', {
                type: 'tag',
                data: newLine.slice(4)
            });
        });
    }
    /**
   * Add a parser for custom headers
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */ addParser({ expression: expression, customType: customType, dataParser: dataParser, segment: segment }) {
        if (typeof dataParser !== 'function') dataParser = (line)=>line;
        this.customParsers.push((line)=>{
            const match = expression.exec(line);
            if (match) {
                this.trigger('data', {
                    type: 'custom',
                    data: dataParser(line),
                    customType: customType,
                    segment: segment
                });
                return true;
            }
        });
    }
    /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */ addTagMapper({ expression: expression, map: map }) {
        const mapFn = (line)=>{
            if (expression.test(line)) return map(line);
            return line;
        };
        this.tagMappers.push(mapFn);
    }
}
const $17dbf2814389b162$var$camelCase = (str)=>str.toLowerCase().replace(/-(\w)/g, (a)=>a[1].toUpperCase());
const $17dbf2814389b162$var$camelCaseKeys = function(attributes) {
    const result = {};
    Object.keys(attributes).forEach(function(key) {
        result[$17dbf2814389b162$var$camelCase(key)] = attributes[key];
    });
    return result;
}; // set SERVER-CONTROL hold back based upon targetDuration and partTargetDuration
// we need this helper because defaults are based upon targetDuration and
// partTargetDuration being set, but they may not be if SERVER-CONTROL appears before
// target durations are set.
const $17dbf2814389b162$var$setHoldBack = function(manifest) {
    const { serverControl: serverControl, targetDuration: targetDuration, partTargetDuration: partTargetDuration } = manifest;
    if (!serverControl) return;
    const tag = '#EXT-X-SERVER-CONTROL';
    const hb = 'holdBack';
    const phb = 'partHoldBack';
    const minTargetDuration = targetDuration && targetDuration * 3;
    const minPartDuration = partTargetDuration && partTargetDuration * 2;
    if (targetDuration && !serverControl.hasOwnProperty(hb)) {
        serverControl[hb] = minTargetDuration;
        this.trigger('info', {
            message: `${tag} defaulting HOLD-BACK to targetDuration * 3 (${minTargetDuration}).`
        });
    }
    if (minTargetDuration && serverControl[hb] < minTargetDuration) {
        this.trigger('warn', {
            message: `${tag} clamping HOLD-BACK (${serverControl[hb]}) to targetDuration * 3 (${minTargetDuration})`
        });
        serverControl[hb] = minTargetDuration;
    } // default no part hold back to part target duration * 3
    if (partTargetDuration && !serverControl.hasOwnProperty(phb)) {
        serverControl[phb] = partTargetDuration * 3;
        this.trigger('info', {
            message: `${tag} defaulting PART-HOLD-BACK to partTargetDuration * 3 (${serverControl[phb]}).`
        });
    } // if part hold back is too small default it to part target duration * 2
    if (partTargetDuration && serverControl[phb] < minPartDuration) {
        this.trigger('warn', {
            message: `${tag} clamping PART-HOLD-BACK (${serverControl[phb]}) to partTargetDuration * 2 (${minPartDuration}).`
        });
        serverControl[phb] = minPartDuration;
    }
};
/**
 * A parser for M3U8 files. The current interpretation of the input is
 * exposed as a property `manifest` on parser objects. It's just two lines to
 * create and parse a manifest once you have the contents available as a string:
 *
 * ```js
 * var parser = new m3u8.Parser();
 * parser.push(xhr.responseText);
 * ```
 *
 * New input can later be applied to update the manifest object by calling
 * `push` again.
 *
 * The parser attempts to create a usable manifest object even if the
 * underlying input is somewhat nonsensical. It emits `info` and `warning`
 * events during the parse if it encounters input that seems invalid or
 * requires some property of the manifest object to be defaulted.
 *
 * @class Parser
 * @param {Object} [opts] Options for the constructor, needed for substitutions
 * @param {string} [opts.uri] URL to check for query params
 * @param {Object} [opts.mainDefinitions] Definitions on main playlist that can be imported
 * @extends Stream
 */ class $17dbf2814389b162$export$7acfa6ed01010e37 extends (0, $11O3Q.default) {
    constructor(opts = {}){
        super();
        this.lineStream = new $17dbf2814389b162$export$307ab5c52b11c33e();
        this.parseStream = new $17dbf2814389b162$export$bc65cb5a6d9da573();
        this.lineStream.pipe(this.parseStream);
        this.mainDefinitions = opts.mainDefinitions || {};
        this.params = new URL(opts.uri, 'https://a.com').searchParams;
        this.lastProgramDateTime = null;
        /* eslint-disable consistent-this */ const self = this;
        /* eslint-enable consistent-this */ const uris = [];
        let currentUri = {}; // if specified, the active EXT-X-MAP definition
        let currentMap; // if specified, the active decryption key
        let key;
        let hasParts = false;
        const noop = function() {};
        const defaultMediaGroups = {
            'AUDIO': {},
            'VIDEO': {},
            'CLOSED-CAPTIONS': {},
            'SUBTITLES': {}
        }; // This is the Widevine UUID from DASH IF IOP. The same exact string is
        // used in MPDs with Widevine encrypted streams.
        const widevineUuid = 'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed'; // group segments into numbered timelines delineated by discontinuities
        let currentTimeline = 0; // the manifest is empty until the parse stream begins delivering data
        this.manifest = {
            allowCache: true,
            discontinuityStarts: [],
            dateRanges: [],
            iFramePlaylists: [],
            segments: []
        }; // keep track of the last seen segment's byte range end, as segments are not required
        // to provide the offset, in which case it defaults to the next byte after the
        // previous segment
        let lastByterangeEnd = 0; // keep track of the last seen part's byte range end.
        let lastPartByterangeEnd = 0;
        const dateRangeTags = {};
        this.on('end', ()=>{
            // only add preloadSegment if we don't yet have a uri for it.
            // and we actually have parts/preloadHints
            if (currentUri.uri || !currentUri.parts && !currentUri.preloadHints) return;
            if (!currentUri.map && currentMap) currentUri.map = currentMap;
            if (!currentUri.key && key) currentUri.key = key;
            if (!currentUri.timeline && typeof currentTimeline === 'number') currentUri.timeline = currentTimeline;
            this.manifest.preloadSegment = currentUri;
        }); // update the manifest with the m3u8 entry from the parse stream
        this.parseStream.on('data', function(entry) {
            let mediaGroup;
            let rendition; // Replace variables in uris and attributes as defined in #EXT-X-DEFINE tags
            if (self.manifest.definitions) for(const def in self.manifest.definitions){
                if (entry.uri) entry.uri = entry.uri.replace(`{$${def}}`, self.manifest.definitions[def]);
                if (entry.attributes) {
                    for(const attr in entry.attributes)if (typeof entry.attributes[attr] === 'string') entry.attributes[attr] = entry.attributes[attr].replace(`{$${def}}`, self.manifest.definitions[def]);
                }
            }
            ({
                tag () {
                    // switch based on the tag type
                    (({
                        version () {
                            if (entry.version) this.manifest.version = entry.version;
                        },
                        'allow-cache' () {
                            this.manifest.allowCache = entry.allowed;
                            if (!('allowed' in entry)) {
                                this.trigger('info', {
                                    message: 'defaulting allowCache to YES'
                                });
                                this.manifest.allowCache = true;
                            }
                        },
                        byterange () {
                            const byterange = {};
                            if ('length' in entry) {
                                currentUri.byterange = byterange;
                                byterange.length = entry.length;
                                if (!('offset' in entry)) /*
                   * From the latest spec (as of this writing):
                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.2
                   *
                   * Same text since EXT-X-BYTERANGE's introduction in draft 7:
                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-07#section-3.3.1)
                   *
                   * "If o [offset] is not present, the sub-range begins at the next byte
                   * following the sub-range of the previous media segment."
                   */ entry.offset = lastByterangeEnd;
                            }
                            if ('offset' in entry) {
                                currentUri.byterange = byterange;
                                byterange.offset = entry.offset;
                            }
                            lastByterangeEnd = byterange.offset + byterange.length;
                        },
                        endlist () {
                            this.manifest.endList = true;
                        },
                        inf () {
                            if (!('mediaSequence' in this.manifest)) {
                                this.manifest.mediaSequence = 0;
                                this.trigger('info', {
                                    message: 'defaulting media sequence to zero'
                                });
                            }
                            if (!('discontinuitySequence' in this.manifest)) {
                                this.manifest.discontinuitySequence = 0;
                                this.trigger('info', {
                                    message: 'defaulting discontinuity sequence to zero'
                                });
                            }
                            if (entry.title) currentUri.title = entry.title;
                            if (entry.duration > 0) currentUri.duration = entry.duration;
                            if (entry.duration === 0) {
                                currentUri.duration = 0.01;
                                this.trigger('info', {
                                    message: 'updating zero segment duration to a small value'
                                });
                            }
                            this.manifest.segments = uris;
                        },
                        key () {
                            if (!entry.attributes) {
                                this.trigger('warn', {
                                    message: 'ignoring key declaration without attribute list'
                                });
                                return;
                            } // clear the active encryption key
                            if (entry.attributes.METHOD === 'NONE') {
                                key = null;
                                return;
                            }
                            if (!entry.attributes.URI) {
                                this.trigger('warn', {
                                    message: 'ignoring key declaration without URI'
                                });
                                return;
                            }
                            if (entry.attributes.KEYFORMAT === 'com.apple.streamingkeydelivery') {
                                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
                                this.manifest.contentProtection['com.apple.fps.1_0'] = {
                                    attributes: entry.attributes
                                };
                                return;
                            }
                            if (entry.attributes.KEYFORMAT === 'com.microsoft.playready') {
                                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
                                this.manifest.contentProtection['com.microsoft.playready'] = {
                                    uri: entry.attributes.URI
                                };
                                return;
                            } // check if the content is encrypted for Widevine
                            // Widevine/HLS spec: https://storage.googleapis.com/wvdocs/Widevine_DRM_HLS.pdf
                            if (entry.attributes.KEYFORMAT === widevineUuid) {
                                const VALID_METHODS = [
                                    'SAMPLE-AES',
                                    'SAMPLE-AES-CTR',
                                    'SAMPLE-AES-CENC'
                                ];
                                if (VALID_METHODS.indexOf(entry.attributes.METHOD) === -1) {
                                    this.trigger('warn', {
                                        message: 'invalid key method provided for Widevine'
                                    });
                                    return;
                                }
                                if (entry.attributes.METHOD === 'SAMPLE-AES-CENC') this.trigger('warn', {
                                    message: 'SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead'
                                });
                                if (entry.attributes.URI.substring(0, 23) !== 'data:text/plain;base64,') {
                                    this.trigger('warn', {
                                        message: 'invalid key URI provided for Widevine'
                                    });
                                    return;
                                }
                                if (!(entry.attributes.KEYID && entry.attributes.KEYID.substring(0, 2) === '0x')) {
                                    this.trigger('warn', {
                                        message: 'invalid key ID provided for Widevine'
                                    });
                                    return;
                                } // if Widevine key attributes are valid, store them as `contentProtection`
                                // on the manifest to emulate Widevine tag structure in a DASH mpd
                                this.manifest.contentProtection = this.manifest.contentProtection || {};
                                this.manifest.contentProtection['com.widevine.alpha'] = {
                                    attributes: {
                                        schemeIdUri: entry.attributes.KEYFORMAT,
                                        // remove '0x' from the key id string
                                        keyId: entry.attributes.KEYID.substring(2)
                                    },
                                    // decode the base64-encoded PSSH box
                                    pssh: (0, $ia8V9.default)(entry.attributes.URI.split(',')[1])
                                };
                                return;
                            }
                            if (!entry.attributes.METHOD) this.trigger('warn', {
                                message: 'defaulting key method to AES-128'
                            });
                             // setup an encryption key for upcoming segments
                            key = {
                                method: entry.attributes.METHOD || 'AES-128',
                                uri: entry.attributes.URI
                            };
                            if (typeof entry.attributes.IV !== 'undefined') key.iv = entry.attributes.IV;
                        },
                        'media-sequence' () {
                            if (!isFinite(entry.number)) {
                                this.trigger('warn', {
                                    message: 'ignoring invalid media sequence: ' + entry.number
                                });
                                return;
                            }
                            this.manifest.mediaSequence = entry.number;
                        },
                        'discontinuity-sequence' () {
                            if (!isFinite(entry.number)) {
                                this.trigger('warn', {
                                    message: 'ignoring invalid discontinuity sequence: ' + entry.number
                                });
                                return;
                            }
                            this.manifest.discontinuitySequence = entry.number;
                            currentTimeline = entry.number;
                        },
                        'playlist-type' () {
                            if (!/VOD|EVENT/.test(entry.playlistType)) {
                                this.trigger('warn', {
                                    message: 'ignoring unknown playlist type: ' + entry.playlist
                                });
                                return;
                            }
                            this.manifest.playlistType = entry.playlistType;
                        },
                        map () {
                            currentMap = {};
                            if (entry.uri) currentMap.uri = entry.uri;
                            if (entry.byterange) currentMap.byterange = entry.byterange;
                            if (key) currentMap.key = key;
                        },
                        'stream-inf' () {
                            this.manifest.playlists = uris;
                            this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
                            if (!entry.attributes) {
                                this.trigger('warn', {
                                    message: 'ignoring empty stream-inf attributes'
                                });
                                return;
                            }
                            if (!currentUri.attributes) currentUri.attributes = {};
                            (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))(currentUri.attributes, entry.attributes);
                        },
                        media () {
                            this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
                            if (!(entry.attributes && entry.attributes.TYPE && entry.attributes['GROUP-ID'] && entry.attributes.NAME)) {
                                this.trigger('warn', {
                                    message: 'ignoring incomplete or missing media group'
                                });
                                return;
                            } // find the media group, creating defaults as necessary
                            const mediaGroupType = this.manifest.mediaGroups[entry.attributes.TYPE];
                            mediaGroupType[entry.attributes['GROUP-ID']] = mediaGroupType[entry.attributes['GROUP-ID']] || {};
                            mediaGroup = mediaGroupType[entry.attributes['GROUP-ID']]; // collect the rendition metadata
                            rendition = {
                                default: /yes/i.test(entry.attributes.DEFAULT)
                            };
                            if (rendition.default) rendition.autoselect = true;
                            else rendition.autoselect = /yes/i.test(entry.attributes.AUTOSELECT);
                            if (entry.attributes.LANGUAGE) rendition.language = entry.attributes.LANGUAGE;
                            if (entry.attributes.URI) rendition.uri = entry.attributes.URI;
                            if (entry.attributes['INSTREAM-ID']) rendition.instreamId = entry.attributes['INSTREAM-ID'];
                            if (entry.attributes.CHARACTERISTICS) rendition.characteristics = entry.attributes.CHARACTERISTICS;
                            if (entry.attributes.FORCED) rendition.forced = /yes/i.test(entry.attributes.FORCED);
                             // insert the new rendition
                            mediaGroup[entry.attributes.NAME] = rendition;
                        },
                        discontinuity () {
                            currentTimeline += 1;
                            currentUri.discontinuity = true;
                            this.manifest.discontinuityStarts.push(uris.length);
                        },
                        'program-date-time' () {
                            if (typeof this.manifest.dateTimeString === 'undefined') {
                                // PROGRAM-DATE-TIME is a media-segment tag, but for backwards
                                // compatibility, we add the first occurence of the PROGRAM-DATE-TIME tag
                                // to the manifest object
                                // TODO: Consider removing this in future major version
                                this.manifest.dateTimeString = entry.dateTimeString;
                                this.manifest.dateTimeObject = entry.dateTimeObject;
                            }
                            currentUri.dateTimeString = entry.dateTimeString;
                            currentUri.dateTimeObject = entry.dateTimeObject;
                            const { lastProgramDateTime: lastProgramDateTime } = this;
                            this.lastProgramDateTime = new Date(entry.dateTimeString).getTime(); // We should extrapolate Program Date Time backward only during first program date time occurrence.
                            // Once we have at least one program date time point, we can always extrapolate it forward using lastProgramDateTime reference.
                            if (lastProgramDateTime === null) // Extrapolate Program Date Time backward
                            // Since it is first program date time occurrence we're assuming that
                            // all this.manifest.segments have no program date time info
                            this.manifest.segments.reduceRight((programDateTime, segment)=>{
                                segment.programDateTime = programDateTime - segment.duration * 1000;
                                return segment.programDateTime;
                            }, this.lastProgramDateTime);
                        },
                        targetduration () {
                            if (!isFinite(entry.duration) || entry.duration < 0) {
                                this.trigger('warn', {
                                    message: 'ignoring invalid target duration: ' + entry.duration
                                });
                                return;
                            }
                            this.manifest.targetDuration = entry.duration;
                            $17dbf2814389b162$var$setHoldBack.call(this, this.manifest);
                        },
                        start () {
                            if (!entry.attributes || isNaN(entry.attributes['TIME-OFFSET'])) {
                                this.trigger('warn', {
                                    message: 'ignoring start declaration without appropriate attribute list'
                                });
                                return;
                            }
                            this.manifest.start = {
                                timeOffset: entry.attributes['TIME-OFFSET'],
                                precise: entry.attributes.PRECISE
                            };
                        },
                        'cue-out' () {
                            currentUri.cueOut = entry.data;
                        },
                        'cue-out-cont' () {
                            currentUri.cueOutCont = entry.data;
                        },
                        'cue-in' () {
                            currentUri.cueIn = entry.data;
                        },
                        'skip' () {
                            this.manifest.skip = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            this.warnOnMissingAttributes_('#EXT-X-SKIP', entry.attributes, [
                                'SKIPPED-SEGMENTS'
                            ]);
                        },
                        'part' () {
                            hasParts = true; // parts are always specifed before a segment
                            const segmentIndex = this.manifest.segments.length;
                            const part = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            currentUri.parts = currentUri.parts || [];
                            currentUri.parts.push(part);
                            if (part.byterange) {
                                if (!part.byterange.hasOwnProperty('offset')) part.byterange.offset = lastPartByterangeEnd;
                                lastPartByterangeEnd = part.byterange.offset + part.byterange.length;
                            }
                            const partIndex = currentUri.parts.length - 1;
                            this.warnOnMissingAttributes_(`#EXT-X-PART #${partIndex} for segment #${segmentIndex}`, entry.attributes, [
                                'URI',
                                'DURATION'
                            ]);
                            if (this.manifest.renditionReports) this.manifest.renditionReports.forEach((r, i)=>{
                                if (!r.hasOwnProperty('lastPart')) this.trigger('warn', {
                                    message: `#EXT-X-RENDITION-REPORT #${i} lacks required attribute(s): LAST-PART`
                                });
                            });
                        },
                        'server-control' () {
                            const attrs = this.manifest.serverControl = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            if (!attrs.hasOwnProperty('canBlockReload')) {
                                attrs.canBlockReload = false;
                                this.trigger('info', {
                                    message: '#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false'
                                });
                            }
                            $17dbf2814389b162$var$setHoldBack.call(this, this.manifest);
                            if (attrs.canSkipDateranges && !attrs.hasOwnProperty('canSkipUntil')) this.trigger('warn', {
                                message: '#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set'
                            });
                        },
                        'preload-hint' () {
                            // parts are always specifed before a segment
                            const segmentIndex = this.manifest.segments.length;
                            const hint = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            const isPart = hint.type && hint.type === 'PART';
                            currentUri.preloadHints = currentUri.preloadHints || [];
                            currentUri.preloadHints.push(hint);
                            if (hint.byterange) {
                                if (!hint.byterange.hasOwnProperty('offset')) {
                                    // use last part byterange end or zero if not a part.
                                    hint.byterange.offset = isPart ? lastPartByterangeEnd : 0;
                                    if (isPart) lastPartByterangeEnd = hint.byterange.offset + hint.byterange.length;
                                }
                            }
                            const index = currentUri.preloadHints.length - 1;
                            this.warnOnMissingAttributes_(`#EXT-X-PRELOAD-HINT #${index} for segment #${segmentIndex}`, entry.attributes, [
                                'TYPE',
                                'URI'
                            ]);
                            if (!hint.type) return;
                             // search through all preload hints except for the current one for
                            // a duplicate type.
                            for(let i = 0; i < currentUri.preloadHints.length - 1; i++){
                                const otherHint = currentUri.preloadHints[i];
                                if (!otherHint.type) continue;
                                if (otherHint.type === hint.type) this.trigger('warn', {
                                    message: `#EXT-X-PRELOAD-HINT #${index} for segment #${segmentIndex} has the same TYPE ${hint.type} as preload hint #${i}`
                                });
                            }
                        },
                        'rendition-report' () {
                            const report = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            this.manifest.renditionReports = this.manifest.renditionReports || [];
                            this.manifest.renditionReports.push(report);
                            const index = this.manifest.renditionReports.length - 1;
                            const required = [
                                'LAST-MSN',
                                'URI'
                            ];
                            if (hasParts) required.push('LAST-PART');
                            this.warnOnMissingAttributes_(`#EXT-X-RENDITION-REPORT #${index}`, entry.attributes, required);
                        },
                        'part-inf' () {
                            this.manifest.partInf = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            this.warnOnMissingAttributes_('#EXT-X-PART-INF', entry.attributes, [
                                'PART-TARGET'
                            ]);
                            if (this.manifest.partInf.partTarget) this.manifest.partTargetDuration = this.manifest.partInf.partTarget;
                            $17dbf2814389b162$var$setHoldBack.call(this, this.manifest);
                        },
                        'daterange' () {
                            this.manifest.dateRanges.push($17dbf2814389b162$var$camelCaseKeys(entry.attributes));
                            const index = this.manifest.dateRanges.length - 1;
                            this.warnOnMissingAttributes_(`#EXT-X-DATERANGE #${index}`, entry.attributes, [
                                'ID',
                                'START-DATE'
                            ]);
                            const dateRange = this.manifest.dateRanges[index];
                            if (dateRange.endDate && dateRange.startDate && new Date(dateRange.endDate) < new Date(dateRange.startDate)) this.trigger('warn', {
                                message: 'EXT-X-DATERANGE END-DATE must be equal to or later than the value of the START-DATE'
                            });
                            if (dateRange.duration && dateRange.duration < 0) this.trigger('warn', {
                                message: 'EXT-X-DATERANGE DURATION must not be negative'
                            });
                            if (dateRange.plannedDuration && dateRange.plannedDuration < 0) this.trigger('warn', {
                                message: 'EXT-X-DATERANGE PLANNED-DURATION must not be negative'
                            });
                            const endOnNextYes = !!dateRange.endOnNext;
                            if (endOnNextYes && !dateRange.class) this.trigger('warn', {
                                message: 'EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must have a CLASS attribute'
                            });
                            if (endOnNextYes && (dateRange.duration || dateRange.endDate)) this.trigger('warn', {
                                message: 'EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must not contain DURATION or END-DATE attributes'
                            });
                            if (dateRange.duration && dateRange.endDate) {
                                const startDate = dateRange.startDate;
                                const newDateInSeconds = startDate.getTime() + dateRange.duration * 1000;
                                this.manifest.dateRanges[index].endDate = new Date(newDateInSeconds);
                            }
                            if (!dateRangeTags[dateRange.id]) dateRangeTags[dateRange.id] = dateRange;
                            else {
                                for(const attribute in dateRangeTags[dateRange.id])if (!!dateRange[attribute] && JSON.stringify(dateRangeTags[dateRange.id][attribute]) !== JSON.stringify(dateRange[attribute])) {
                                    this.trigger('warn', {
                                        message: 'EXT-X-DATERANGE tags with the same ID in a playlist must have the same attributes values'
                                    });
                                    break;
                                }
                                 // if tags with the same ID do not have conflicting attributes, merge them
                                const dateRangeWithSameId = this.manifest.dateRanges.findIndex((dateRangeToFind)=>dateRangeToFind.id === dateRange.id);
                                this.manifest.dateRanges[dateRangeWithSameId] = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))(this.manifest.dateRanges[dateRangeWithSameId], dateRange);
                                dateRangeTags[dateRange.id] = (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))(dateRangeTags[dateRange.id], dateRange); // after merging, delete the duplicate dateRange that was added last
                                this.manifest.dateRanges.pop();
                            }
                        },
                        'independent-segments' () {
                            this.manifest.independentSegments = true;
                        },
                        'i-frames-only' () {
                            this.manifest.iFramesOnly = true;
                            this.requiredCompatibilityversion(this.manifest.version, 4);
                        },
                        'content-steering' () {
                            this.manifest.contentSteering = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            this.warnOnMissingAttributes_('#EXT-X-CONTENT-STEERING', entry.attributes, [
                                'SERVER-URI'
                            ]);
                        },
                        /** @this {Parser} */ define () {
                            this.manifest.definitions = this.manifest.definitions || {};
                            const addDef = (n, v)=>{
                                if (n in this.manifest.definitions) {
                                    // An EXT-X-DEFINE tag MUST NOT specify the same Variable Name as any other
                                    // EXT-X-DEFINE tag in the same Playlist.  Parsers that encounter duplicate
                                    // Variable Name declarations MUST fail to parse the Playlist.
                                    this.trigger('error', {
                                        message: `EXT-X-DEFINE: Duplicate name ${n}`
                                    });
                                    return;
                                }
                                this.manifest.definitions[n] = v;
                            };
                            if ('QUERYPARAM' in entry.attributes) {
                                if ('NAME' in entry.attributes || 'IMPORT' in entry.attributes) {
                                    // An EXT-X-DEFINE tag MUST contain either a NAME, an IMPORT, or a
                                    // QUERYPARAM attribute, but only one of the three.  Otherwise, the
                                    // client MUST fail to parse the Playlist.
                                    this.trigger('error', {
                                        message: 'EXT-X-DEFINE: Invalid attributes'
                                    });
                                    return;
                                }
                                const val = this.params.get(entry.attributes.QUERYPARAM);
                                if (!val) {
                                    // If the QUERYPARAM attribute value does not match any query parameter in
                                    // the URI or the matching parameter has no associated value, the parser
                                    // MUST fail to parse the Playlist.  If more than one parameter matches,
                                    // any of the associated values MAY be used.
                                    this.trigger('error', {
                                        message: `EXT-X-DEFINE: No query param ${entry.attributes.QUERYPARAM}`
                                    });
                                    return;
                                }
                                addDef(entry.attributes.QUERYPARAM, decodeURIComponent(val));
                                return;
                            }
                            if ('NAME' in entry.attributes) {
                                if ('IMPORT' in entry.attributes) {
                                    // An EXT-X-DEFINE tag MUST contain either a NAME, an IMPORT, or a
                                    // QUERYPARAM attribute, but only one of the three.  Otherwise, the
                                    // client MUST fail to parse the Playlist.
                                    this.trigger('error', {
                                        message: 'EXT-X-DEFINE: Invalid attributes'
                                    });
                                    return;
                                }
                                if (!('VALUE' in entry.attributes) || typeof entry.attributes.VALUE !== 'string') {
                                    // This attribute is REQUIRED if the EXT-X-DEFINE tag has a NAME attribute.
                                    // The quoted-string MAY be empty.
                                    this.trigger('error', {
                                        message: `EXT-X-DEFINE: No value for ${entry.attributes.NAME}`
                                    });
                                    return;
                                }
                                addDef(entry.attributes.NAME, entry.attributes.VALUE);
                                return;
                            }
                            if ('IMPORT' in entry.attributes) {
                                if (!this.mainDefinitions[entry.attributes.IMPORT]) {
                                    // Covers two conditions, as mainDefinitions will always be empty on main
                                    //
                                    // EXT-X-DEFINE tags containing the IMPORT attribute MUST NOT occur in
                                    // Multivariant Playlists; they are only allowed in Media Playlists.
                                    //
                                    // If the IMPORT attribute value does not match any Variable Name in the
                                    // Multivariant Playlist, or if the Media Playlist loaded from a
                                    // Multivariant Playlist, the parser MUST fail the Playlist.
                                    this.trigger('error', {
                                        message: `EXT-X-DEFINE: No value ${entry.attributes.IMPORT} to import, or IMPORT used on main playlist`
                                    });
                                    return;
                                }
                                addDef(entry.attributes.IMPORT, this.mainDefinitions[entry.attributes.IMPORT]);
                                return;
                            } // An EXT-X-DEFINE tag MUST contain either a NAME, an IMPORT, or a QUERYPARAM
                            // attribute, but only one of the three.  Otherwise, the client MUST fail to
                            // parse the Playlist.
                            this.trigger('error', {
                                message: 'EXT-X-DEFINE: No attribute'
                            });
                        },
                        'i-frame-playlist' () {
                            this.manifest.iFramePlaylists.push({
                                attributes: entry.attributes,
                                uri: entry.uri,
                                timeline: currentTimeline
                            });
                            this.warnOnMissingAttributes_('#EXT-X-I-FRAME-STREAM-INF', entry.attributes, [
                                'BANDWIDTH',
                                'URI'
                            ]);
                        }
                    })[entry.tagType] || noop).call(self);
                },
                uri () {
                    currentUri.uri = entry.uri;
                    uris.push(currentUri); // if no explicit duration was declared, use the target duration
                    if (this.manifest.targetDuration && !('duration' in currentUri)) {
                        this.trigger('warn', {
                            message: 'defaulting segment duration to the target duration'
                        });
                        currentUri.duration = this.manifest.targetDuration;
                    } // annotate with encryption information, if necessary
                    if (key) currentUri.key = key;
                    currentUri.timeline = currentTimeline; // annotate with initialization segment information, if necessary
                    if (currentMap) currentUri.map = currentMap;
                     // reset the last byterange end as it needs to be 0 between parts
                    lastPartByterangeEnd = 0; // Once we have at least one program date time we can always extrapolate it forward
                    if (this.lastProgramDateTime !== null) {
                        currentUri.programDateTime = this.lastProgramDateTime;
                        this.lastProgramDateTime += currentUri.duration * 1000;
                    } // prepare for the next URI
                    currentUri = {};
                },
                comment () {},
                custom () {
                    // if this is segment-level data attach the output to the segment
                    if (entry.segment) {
                        currentUri.custom = currentUri.custom || {};
                        currentUri.custom[entry.customType] = entry.data; // if this is manifest-level data attach to the top level manifest object
                    } else {
                        this.manifest.custom = this.manifest.custom || {};
                        this.manifest.custom[entry.customType] = entry.data;
                    }
                }
            })[entry.type].call(self);
        });
    }
    requiredCompatibilityversion(currentVersion, targetVersion) {
        if (currentVersion < targetVersion || !currentVersion) this.trigger('warn', {
            message: `manifest must be at least version ${targetVersion}`
        });
    }
    warnOnMissingAttributes_(identifier, attributes, required) {
        const missing = [];
        required.forEach(function(key) {
            if (!attributes.hasOwnProperty(key)) missing.push(key);
        });
        if (missing.length) this.trigger('warn', {
            message: `${identifier} lacks required attribute(s): ${missing.join(', ')}`
        });
    }
    /**
   * Parse the input string and update the manifest object.
   *
   * @param {string} chunk a potentially incomplete portion of the manifest
   */ push(chunk) {
        this.lineStream.push(chunk);
    }
    /**
   * Flush any remaining input. This can be handy if the last line of an M3U8
   * manifest did not contain a trailing newline but the file has been
   * completely received.
   */ end() {
        // flush any buffered input
        this.lineStream.push('\n');
        if (this.manifest.dateRanges.length && this.lastProgramDateTime === null) this.trigger('warn', {
            message: 'A playlist with EXT-X-DATERANGE tag must contain atleast one EXT-X-PROGRAM-DATE-TIME tag'
        });
        this.lastProgramDateTime = null;
        this.trigger('end');
    }
    /**
   * Add an additional parser for non-standard tags
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */ addParser(options) {
        this.parseStream.addParser(options);
    }
    /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */ addTagMapper(options) {
        this.parseStream.addTagMapper(options);
    }
}

});
parcelRegister("11O3Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bfcb789d63eefb3$export$2e2bcd8739ae039);
/**
 * @file stream.js
 */ /**
 * A lightweight readable stream implemention that handles event dispatching.
 *
 * @class Stream
 */ var $0bfcb789d63eefb3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Stream() {
        this.listeners = {};
    }
    /**
   * Add a listener for a specified event type.
   *
   * @param {string} type the event name
   * @param {Function} listener the callback to be invoked when an event of
   * the specified type occurs
   */ var _proto = Stream.prototype;
    _proto.on = function on(type, listener) {
        if (!this.listeners[type]) this.listeners[type] = [];
        this.listeners[type].push(listener);
    };
    _proto.off = function off(type, listener) {
        if (!this.listeners[type]) return false;
        var index = this.listeners[type].indexOf(listener); // TODO: which is better?
        // In Video.js we slice listener functions
        // on trigger so that it does not mess up the order
        // while we loop through.
        //
        // Here we slice on off so that the loop in trigger
        // can continue using it's old reference to loop without
        // messing up the order.
        this.listeners[type] = this.listeners[type].slice(0);
        this.listeners[type].splice(index, 1);
        return index > -1;
    };
    _proto.trigger = function trigger(type) {
        var callbacks = this.listeners[type];
        if (!callbacks) return;
         // Slicing the arguments on every invocation of this method
        // can add a significant amount of overhead. Avoid the
        // intermediate object creation for the common case of a
        // single callback argument
        if (arguments.length === 2) {
            var length = callbacks.length;
            for(var i = 0; i < length; ++i)callbacks[i].call(this, arguments[1]);
        } else {
            var args = Array.prototype.slice.call(arguments, 1);
            var _length = callbacks.length;
            for(var _i = 0; _i < _length; ++_i)callbacks[_i].apply(this, args);
        }
    };
    _proto.dispose = function dispose() {
        this.listeners = {};
    };
    _proto.pipe = function pipe(destination) {
        this.on('data', function(data) {
            destination.push(data);
        });
    };
    return Stream;
}();

});

parcelRegister("ia8V9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d39014a5f1ef9823$export$2e2bcd8739ae039);

var $eDick = parcelRequire("eDick");

var $6ZWSX = parcelRequire("6ZWSX");
var $d39014a5f1ef9823$require$Buffer = $6ZWSX.Buffer;
var $d39014a5f1ef9823$var$atob = function atob(s) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).atob ? (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).atob(s) : $d39014a5f1ef9823$require$Buffer.from(s, 'base64').toString('binary');
};
function $d39014a5f1ef9823$export$2e2bcd8739ae039(b64Text) {
    var decodedString = $d39014a5f1ef9823$var$atob(b64Text);
    var array = new Uint8Array(decodedString.length);
    for(var i = 0; i < decodedString.length; i++)array[i] = decodedString.charCodeAt(i);
    return array;
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("jv51Y", function(module, exports) {

$parcel$export(module.exports, "translateLegacyCodec", () => $e324d09415701181$export$4e61c3c458a5b005);
$parcel$export(module.exports, "parseCodecs", () => $e324d09415701181$export$56679b562aa2891c);
$parcel$export(module.exports, "codecsFromDefault", () => $e324d09415701181$export$e192782a4d0b5c5c);
$parcel$export(module.exports, "isAudioCodec", () => $e324d09415701181$export$c642d74e895e3217);
$parcel$export(module.exports, "getMimeForCodec", () => $e324d09415701181$export$4b64fc0a026b9981);
$parcel$export(module.exports, "browserSupportsCodec", () => $e324d09415701181$export$3ee949df8fbc592f);
$parcel$export(module.exports, "muxerSupportsCodec", () => $e324d09415701181$export$614fda2d02e4a9d7);
$parcel$export(module.exports, "DEFAULT_AUDIO_CODEC", () => $e324d09415701181$export$615de1d7b49571dc);
$parcel$export(module.exports, "DEFAULT_VIDEO_CODEC", () => $e324d09415701181$export$77d6196664053611);

var $eDick = parcelRequire("eDick");
var $e324d09415701181$var$regexs = {
    // to determine mime types
    mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
    webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
    ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
    // to determine if a codec is audio or video
    video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
    audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
    text: /^(stpp.ttml.im1t)/,
    // mux.js support regex
    muxerVideo: /^(avc0?1)/,
    muxerAudio: /^(mp4a)/,
    // match nothing as muxer does not support text right now.
    // there cannot never be a character before the start of a string
    // so this matches nothing.
    muxerText: /a^/
};
var $e324d09415701181$var$mediaTypes = [
    'video',
    'audio',
    'text'
];
var $e324d09415701181$var$upperMediaTypes = [
    'Video',
    'Audio',
    'Text'
];
var $e324d09415701181$export$4e61c3c458a5b005 = function translateLegacyCodec(codec) {
    if (!codec) return codec;
    return codec.replace(/avc1\.(\d+)\.(\d+)/i, function(orig, profile, avcLevel) {
        var profileHex = ('00' + Number(profile).toString(16)).slice(-2);
        var avcLevelHex = ('00' + Number(avcLevel).toString(16)).slice(-2);
        return 'avc1.' + profileHex + '00' + avcLevelHex;
    });
};
var $e324d09415701181$export$2fa1fd5760053cdc = function translateLegacyCodecs(codecs) {
    return codecs.map($e324d09415701181$export$4e61c3c458a5b005);
};
var $e324d09415701181$export$ff37541a73872ef0 = function mapLegacyAvcCodecs(codecString) {
    return codecString.replace(/avc1\.(\d+)\.(\d+)/i, function(match) {
        return $e324d09415701181$export$2fa1fd5760053cdc([
            match
        ])[0];
    });
};
var $e324d09415701181$export$56679b562aa2891c = function parseCodecs(codecString) {
    if (codecString === void 0) codecString = '';
    var codecs = codecString.split(',');
    var result = [];
    codecs.forEach(function(codec) {
        codec = codec.trim();
        var codecType;
        $e324d09415701181$var$mediaTypes.forEach(function(name) {
            var match = $e324d09415701181$var$regexs[name].exec(codec.toLowerCase());
            if (!match || match.length <= 1) return;
            codecType = name; // maintain codec case
            var type = codec.substring(0, match[1].length);
            var details = codec.replace(type, '');
            result.push({
                type: type,
                details: details,
                mediaType: name
            });
        });
        if (!codecType) result.push({
            type: codec,
            details: '',
            mediaType: 'unknown'
        });
    });
    return result;
};
var $e324d09415701181$export$e192782a4d0b5c5c = function codecsFromDefault(master, audioGroupId) {
    if (!master.mediaGroups.AUDIO || !audioGroupId) return null;
    var audioGroup = master.mediaGroups.AUDIO[audioGroupId];
    if (!audioGroup) return null;
    for(var name in audioGroup){
        var audioType = audioGroup[name];
        if (audioType.default && audioType.playlists) // codec should be the same for all playlists within the audio type
        return $e324d09415701181$export$56679b562aa2891c(audioType.playlists[0].attributes.CODECS);
    }
    return null;
};
var $e324d09415701181$export$601d10c6a66cb34c = function isVideoCodec(codec) {
    if (codec === void 0) codec = '';
    return $e324d09415701181$var$regexs.video.test(codec.trim().toLowerCase());
};
var $e324d09415701181$export$c642d74e895e3217 = function isAudioCodec(codec) {
    if (codec === void 0) codec = '';
    return $e324d09415701181$var$regexs.audio.test(codec.trim().toLowerCase());
};
var $e324d09415701181$export$256d4a55aa322b7e = function isTextCodec(codec) {
    if (codec === void 0) codec = '';
    return $e324d09415701181$var$regexs.text.test(codec.trim().toLowerCase());
};
var $e324d09415701181$export$4b64fc0a026b9981 = function getMimeForCodec(codecString) {
    if (!codecString || typeof codecString !== 'string') return;
    var codecs = codecString.toLowerCase().split(',').map(function(c) {
        return $e324d09415701181$export$4e61c3c458a5b005(c.trim());
    }); // default to video type
    var type = 'video'; // only change to audio type if the only codec we have is
    // audio
    if (codecs.length === 1 && $e324d09415701181$export$c642d74e895e3217(codecs[0])) type = 'audio';
    else if (codecs.length === 1 && $e324d09415701181$export$256d4a55aa322b7e(codecs[0])) // text uses application/<container> for now
    type = 'application';
     // default the container to mp4
    var container = 'mp4'; // every codec must be able to go into the container
    // for that container to be the correct one
    if (codecs.every(function(c) {
        return $e324d09415701181$var$regexs.mp4.test(c);
    })) container = 'mp4';
    else if (codecs.every(function(c) {
        return $e324d09415701181$var$regexs.webm.test(c);
    })) container = 'webm';
    else if (codecs.every(function(c) {
        return $e324d09415701181$var$regexs.ogg.test(c);
    })) container = 'ogg';
    return type + "/" + container + ";codecs=\"" + codecString + "\"";
};
var $e324d09415701181$export$3ee949df8fbc592f = function browserSupportsCodec(codecString, withMMS) {
    if (codecString === void 0) codecString = '';
    if (withMMS === void 0) withMMS = false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource.isTypeSupported && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource.isTypeSupported($e324d09415701181$export$4b64fc0a026b9981(codecString)) || withMMS && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).ManagedMediaSource && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).ManagedMediaSource.isTypeSupported && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).ManagedMediaSource.isTypeSupported($e324d09415701181$export$4b64fc0a026b9981(codecString)) || false;
};
var $e324d09415701181$export$614fda2d02e4a9d7 = function muxerSupportsCodec(codecString) {
    if (codecString === void 0) codecString = '';
    return codecString.toLowerCase().split(',').every(function(codec) {
        codec = codec.trim(); // any match is supported.
        for(var i = 0; i < $e324d09415701181$var$upperMediaTypes.length; i++){
            var type = $e324d09415701181$var$upperMediaTypes[i];
            if ($e324d09415701181$var$regexs["muxer" + type].test(codec)) return true;
        }
        return false;
    });
};
var $e324d09415701181$export$615de1d7b49571dc = 'mp4a.40.2';
var $e324d09415701181$export$77d6196664053611 = 'avc1.4d400d';

});

parcelRegister("9Odq1", function(module, exports) {

$parcel$export(module.exports, "simpleTypeFromSourceType", () => $72433138d4bc8325$export$c4f0bf48244d4c05);
var $72433138d4bc8325$var$MPEGURL_REGEX = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i;
var $72433138d4bc8325$var$DASH_REGEX = /^application\/dash\+xml/i;
var $72433138d4bc8325$export$c4f0bf48244d4c05 = function simpleTypeFromSourceType(type) {
    if ($72433138d4bc8325$var$MPEGURL_REGEX.test(type)) return 'hls';
    if ($72433138d4bc8325$var$DASH_REGEX.test(type)) return 'dash';
     // Denotes the special case of a manifest object passed to http-streaming instead of a
    // source URL.
    //
    // See https://en.wikipedia.org/wiki/Media_type for details on specifying media types.
    //
    // In this case, vnd stands for vendor, video.js for the organization, VHS for this
    // project, and the +json suffix identifies the structure of the media type.
    if (type === 'application/vnd.videojs.vhs+json') return 'vhs-json';
    return null;
};

});

parcelRegister("6vzZz", function(module, exports) {

$parcel$export(module.exports, "padStart", () => $4bd18e93e919945b$export$36cf564d487b5178);
$parcel$export(module.exports, "isArrayBufferView", () => $4bd18e93e919945b$export$ef047080f6507ccc);
$parcel$export(module.exports, "toUint8", () => $4bd18e93e919945b$export$63c3de442720649);
$parcel$export(module.exports, "toHexString", () => $4bd18e93e919945b$export$f4915efbb94d4d01);
$parcel$export(module.exports, "toBinaryString", () => $4bd18e93e919945b$export$9a7d75f397723250);
$parcel$export(module.exports, "bytesToNumber", () => $4bd18e93e919945b$export$c0cca17bcf674749);
$parcel$export(module.exports, "numberToBytes", () => $4bd18e93e919945b$export$49ad9be85c347998);
$parcel$export(module.exports, "bytesToString", () => $4bd18e93e919945b$export$7c746b75f47c9c7d);
$parcel$export(module.exports, "stringToBytes", () => $4bd18e93e919945b$export$c8dd6bc66a63753c);
$parcel$export(module.exports, "concatTypedArrays", () => $4bd18e93e919945b$export$229a3d5e59c9dd55);
$parcel$export(module.exports, "bytesMatch", () => $4bd18e93e919945b$export$a20f7b76e5cfd223);

var $eDick = parcelRequire("eDick");
var $4bd18e93e919945b$var$repeat = function repeat(str, len) {
    var acc = '';
    while(len--)acc += str;
    return acc;
}; // count the number of bits it would take to represent a number
var $4bd18e93e919945b$export$33de6ea056a4cdbb = function countBits(x) {
    return x.toString(2).length;
}; // count the number of whole bytes it would take to represent a number
var $4bd18e93e919945b$export$42cd407004f34122 = function countBytes(x) {
    return Math.ceil($4bd18e93e919945b$export$33de6ea056a4cdbb(x) / 8);
};
var $4bd18e93e919945b$export$36cf564d487b5178 = function padStart(b, len, str) {
    if (str === void 0) str = ' ';
    return ($4bd18e93e919945b$var$repeat(str, len) + b.toString()).slice(-len);
};
var $4bd18e93e919945b$export$ef047080f6507ccc = function isArrayBufferView(obj) {
    if (ArrayBuffer.isView === 'function') return ArrayBuffer.isView(obj);
    return obj && obj.buffer instanceof ArrayBuffer;
};
var $4bd18e93e919945b$export$b119cc7e1840e59c = function isTypedArray(obj) {
    return $4bd18e93e919945b$export$ef047080f6507ccc(obj);
};
var $4bd18e93e919945b$export$63c3de442720649 = function toUint8(bytes) {
    if (bytes instanceof Uint8Array) return bytes;
    if (!Array.isArray(bytes) && !$4bd18e93e919945b$export$b119cc7e1840e59c(bytes) && !(bytes instanceof ArrayBuffer)) {
        // any non-number or NaN leads to empty uint8array
        // eslint-disable-next-line
        if (typeof bytes !== 'number' || typeof bytes === 'number' && bytes !== bytes) bytes = 0;
        else bytes = [
            bytes
        ];
    }
    return new Uint8Array(bytes && bytes.buffer || bytes, bytes && bytes.byteOffset || 0, bytes && bytes.byteLength || 0);
};
var $4bd18e93e919945b$export$f4915efbb94d4d01 = function toHexString(bytes) {
    bytes = $4bd18e93e919945b$export$63c3de442720649(bytes);
    var str = '';
    for(var i = 0; i < bytes.length; i++)str += $4bd18e93e919945b$export$36cf564d487b5178(bytes[i].toString(16), 2, '0');
    return str;
};
var $4bd18e93e919945b$export$9a7d75f397723250 = function toBinaryString(bytes) {
    bytes = $4bd18e93e919945b$export$63c3de442720649(bytes);
    var str = '';
    for(var i = 0; i < bytes.length; i++)str += $4bd18e93e919945b$export$36cf564d487b5178(bytes[i].toString(2), 8, '0');
    return str;
};
var $4bd18e93e919945b$var$BigInt = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt || Number;
var $4bd18e93e919945b$var$BYTE_TABLE = [
    $4bd18e93e919945b$var$BigInt('0x1'),
    $4bd18e93e919945b$var$BigInt('0x100'),
    $4bd18e93e919945b$var$BigInt('0x10000'),
    $4bd18e93e919945b$var$BigInt('0x1000000'),
    $4bd18e93e919945b$var$BigInt('0x100000000'),
    $4bd18e93e919945b$var$BigInt('0x10000000000'),
    $4bd18e93e919945b$var$BigInt('0x1000000000000'),
    $4bd18e93e919945b$var$BigInt('0x100000000000000'),
    $4bd18e93e919945b$var$BigInt('0x10000000000000000')
];
var $4bd18e93e919945b$export$44623b3161268f13 = function() {
    var a = new Uint16Array([
        0xFFCC
    ]);
    var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    if (b[0] === 0xFF) return 'big';
    if (b[0] === 0xCC) return 'little';
    return 'unknown';
}();
var $4bd18e93e919945b$export$71d08edba63ee40 = $4bd18e93e919945b$export$44623b3161268f13 === 'big';
var $4bd18e93e919945b$export$c362788a4d6d6a65 = $4bd18e93e919945b$export$44623b3161268f13 === 'little';
var $4bd18e93e919945b$export$c0cca17bcf674749 = function bytesToNumber(bytes, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$signed = _ref.signed, signed = _ref$signed === void 0 ? false : _ref$signed, _ref$le = _ref.le, le = _ref$le === void 0 ? false : _ref$le;
    bytes = $4bd18e93e919945b$export$63c3de442720649(bytes);
    var fn = le ? 'reduce' : 'reduceRight';
    var obj = bytes[fn] ? bytes[fn] : Array.prototype[fn];
    var number = obj.call(bytes, function(total, byte, i) {
        var exponent = le ? i : Math.abs(i + 1 - bytes.length);
        return total + $4bd18e93e919945b$var$BigInt(byte) * $4bd18e93e919945b$var$BYTE_TABLE[exponent];
    }, $4bd18e93e919945b$var$BigInt(0));
    if (signed) {
        var max = $4bd18e93e919945b$var$BYTE_TABLE[bytes.length] / $4bd18e93e919945b$var$BigInt(2) - $4bd18e93e919945b$var$BigInt(1);
        number = $4bd18e93e919945b$var$BigInt(number);
        if (number > max) {
            number -= max;
            number -= max;
            number -= $4bd18e93e919945b$var$BigInt(2);
        }
    }
    return Number(number);
};
var $4bd18e93e919945b$export$49ad9be85c347998 = function numberToBytes(number, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$le = _ref2.le, le = _ref2$le === void 0 ? false : _ref2$le;
    // eslint-disable-next-line
    if (typeof number !== 'bigint' && typeof number !== 'number' || typeof number === 'number' && number !== number) number = 0;
    number = $4bd18e93e919945b$var$BigInt(number);
    var byteCount = $4bd18e93e919945b$export$42cd407004f34122(number);
    var bytes = new Uint8Array(new ArrayBuffer(byteCount));
    for(var i = 0; i < byteCount; i++){
        var byteIndex = le ? i : Math.abs(i + 1 - bytes.length);
        bytes[byteIndex] = Number(number / $4bd18e93e919945b$var$BYTE_TABLE[i] & $4bd18e93e919945b$var$BigInt(0xFF));
        if (number < 0) {
            bytes[byteIndex] = Math.abs(~bytes[byteIndex]);
            bytes[byteIndex] -= i === 0 ? 1 : 2;
        }
    }
    return bytes;
};
var $4bd18e93e919945b$export$7c746b75f47c9c7d = function bytesToString(bytes) {
    if (!bytes) return '';
     // TODO: should toUint8 handle cases where we only have 8 bytes
    // but report more since this is a Uint16+ Array?
    bytes = Array.prototype.slice.call(bytes);
    var string = String.fromCharCode.apply(null, $4bd18e93e919945b$export$63c3de442720649(bytes));
    try {
        return decodeURIComponent(escape(string));
    } catch (e) {
    // or full non string data. Just return the potentially garbled string.
    }
    return string;
};
var $4bd18e93e919945b$export$c8dd6bc66a63753c = function stringToBytes(string, stringIsBytes) {
    if (typeof string !== 'string' && string && typeof string.toString === 'function') string = string.toString();
    if (typeof string !== 'string') return new Uint8Array();
     // If the string already is bytes, we don't have to do this
    // otherwise we do this so that we split multi length characters
    // into individual bytes
    if (!stringIsBytes) string = unescape(encodeURIComponent(string));
    var view = new Uint8Array(string.length);
    for(var i = 0; i < string.length; i++)view[i] = string.charCodeAt(i);
    return view;
};
var $4bd18e93e919945b$export$229a3d5e59c9dd55 = function concatTypedArrays() {
    for(var _len = arguments.length, buffers = new Array(_len), _key = 0; _key < _len; _key++)buffers[_key] = arguments[_key];
    buffers = buffers.filter(function(b) {
        return b && (b.byteLength || b.length) && typeof b !== 'string';
    });
    if (buffers.length <= 1) // for 0 length we will return empty uint8
    // for 1 length we return the first uint8
    return $4bd18e93e919945b$export$63c3de442720649(buffers[0]);
    var totalLen = buffers.reduce(function(total, buf, i) {
        return total + (buf.byteLength || buf.length);
    }, 0);
    var tempBuffer = new Uint8Array(totalLen);
    var offset = 0;
    buffers.forEach(function(buf) {
        buf = $4bd18e93e919945b$export$63c3de442720649(buf);
        tempBuffer.set(buf, offset);
        offset += buf.byteLength;
    });
    return tempBuffer;
};
var $4bd18e93e919945b$export$a20f7b76e5cfd223 = function bytesMatch(a, b, _temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$offset = _ref3.offset, offset = _ref3$offset === void 0 ? 0 : _ref3$offset, _ref3$mask = _ref3.mask, mask = _ref3$mask === void 0 ? [] : _ref3$mask;
    a = $4bd18e93e919945b$export$63c3de442720649(a);
    b = $4bd18e93e919945b$export$63c3de442720649(b); // ie 11 does not support uint8 every
    var fn = b.every ? b.every : Array.prototype.every;
    return b.length && a.length - offset >= b.length && // ie 11 doesn't support every on uin8
    fn.call(b, function(bByte, i) {
        var aByte = mask[i] ? mask[i] & a[offset + i] : a[offset + i];
        return bByte === aByte;
    });
};
var $4bd18e93e919945b$export$8bac03c8c1da551 = function sliceBytes(src, start, end) {
    if (Uint8Array.prototype.slice) return Uint8Array.prototype.slice.call(src, start, end);
    return new Uint8Array(Array.prototype.slice.call(src, start, end));
};
var $4bd18e93e919945b$export$8f563933fe97d489 = function reverseBytes(src) {
    if (src.reverse) return src.reverse();
    return Array.prototype.reverse.call(src);
};

});

parcelRegister("1n4fv", function(module, exports) {

$parcel$export(module.exports, "addSidxSegmentsToPlaylist", () => $0ffb3c35bf172c1a$export$2243d5aa7d4f4800);
$parcel$export(module.exports, "generateSidxKey", () => $0ffb3c35bf172c1a$export$2d92360466eb0b01);
$parcel$export(module.exports, "parse", () => $0ffb3c35bf172c1a$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseUTCTiming", () => $0ffb3c35bf172c1a$export$734c7278b5d0068c);
/*! @name mpd-parser @version 1.3.1 @license Apache-2.0 */ 
var $5JQY5 = parcelRequire("5JQY5");

var $eDick = parcelRequire("eDick");

var $e96ds = parcelRequire("e96ds");

var $ia8V9 = parcelRequire("ia8V9");

var $6YUDA = parcelRequire("6YUDA");
var $0ffb3c35bf172c1a$var$version = "1.3.1";
const $0ffb3c35bf172c1a$var$isObject = (obj)=>{
    return !!obj && typeof obj === 'object';
};
const $0ffb3c35bf172c1a$var$merge = (...objects)=>{
    return objects.reduce((result, source)=>{
        if (typeof source !== 'object') return result;
        Object.keys(source).forEach((key)=>{
            if (Array.isArray(result[key]) && Array.isArray(source[key])) result[key] = result[key].concat(source[key]);
            else if ($0ffb3c35bf172c1a$var$isObject(result[key]) && $0ffb3c35bf172c1a$var$isObject(source[key])) result[key] = $0ffb3c35bf172c1a$var$merge(result[key], source[key]);
            else result[key] = source[key];
        });
        return result;
    }, {});
};
const $0ffb3c35bf172c1a$var$values = (o)=>Object.keys(o).map((k)=>o[k]);
const $0ffb3c35bf172c1a$var$range = (start, end)=>{
    const result = [];
    for(let i = start; i < end; i++)result.push(i);
    return result;
};
const $0ffb3c35bf172c1a$var$flatten = (lists)=>lists.reduce((x, y)=>x.concat(y), []);
const $0ffb3c35bf172c1a$var$from = (list)=>{
    if (!list.length) return [];
    const result = [];
    for(let i = 0; i < list.length; i++)result.push(list[i]);
    return result;
};
const $0ffb3c35bf172c1a$var$findIndexes = (l, key)=>l.reduce((a, e, i)=>{
        if (e[key]) a.push(i);
        return a;
    }, []);
/**
 * Returns a union of the included lists provided each element can be identified by a key.
 *
 * @param {Array} list - list of lists to get the union of
 * @param {Function} keyFunction - the function to use as a key for each element
 *
 * @return {Array} the union of the arrays
 */ const $0ffb3c35bf172c1a$var$union = (lists, keyFunction)=>{
    return $0ffb3c35bf172c1a$var$values(lists.reduce((acc, list)=>{
        list.forEach((el)=>{
            acc[keyFunction(el)] = el;
        });
        return acc;
    }, {}));
};
var $0ffb3c35bf172c1a$var$errors = {
    INVALID_NUMBER_OF_PERIOD: 'INVALID_NUMBER_OF_PERIOD',
    INVALID_NUMBER_OF_CONTENT_STEERING: 'INVALID_NUMBER_OF_CONTENT_STEERING',
    DASH_EMPTY_MANIFEST: 'DASH_EMPTY_MANIFEST',
    DASH_INVALID_XML: 'DASH_INVALID_XML',
    NO_BASE_URL: 'NO_BASE_URL',
    MISSING_SEGMENT_INFORMATION: 'MISSING_SEGMENT_INFORMATION',
    SEGMENT_TIME_UNSPECIFIED: 'SEGMENT_TIME_UNSPECIFIED',
    UNSUPPORTED_UTC_TIMING_SCHEME: 'UNSUPPORTED_UTC_TIMING_SCHEME'
};
/**
 * @typedef {Object} SingleUri
 * @property {string} uri - relative location of segment
 * @property {string} resolvedUri - resolved location of segment
 * @property {Object} byterange - Object containing information on how to make byte range
 *   requests following byte-range-spec per RFC2616.
 * @property {String} byterange.length - length of range request
 * @property {String} byterange.offset - byte offset of range request
 *
 * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.35.1
 */ /**
 * Converts a URLType node (5.3.9.2.3 Table 13) to a segment object
 * that conforms to how m3u8-parser is structured
 *
 * @see https://github.com/videojs/m3u8-parser
 *
 * @param {string} baseUrl - baseUrl provided by <BaseUrl> nodes
 * @param {string} source - source url for segment
 * @param {string} range - optional range used for range calls,
 *   follows  RFC 2616, Clause 14.35.1
 * @return {SingleUri} full segment information transformed into a format similar
 *   to m3u8-parser
 */ const $0ffb3c35bf172c1a$var$urlTypeToSegment = ({ baseUrl: baseUrl = '', source: source = '', range: range = '', indexRange: indexRange = '' })=>{
    const segment = {
        uri: source,
        resolvedUri: (0, $5JQY5.default)(baseUrl || '', source)
    };
    if (range || indexRange) {
        const rangeStr = range ? range : indexRange;
        const ranges = rangeStr.split('-'); // default to parsing this as a BigInt if possible
        let startRange = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt ? (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(ranges[0]) : parseInt(ranges[0], 10);
        let endRange = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt ? (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(ranges[1]) : parseInt(ranges[1], 10); // convert back to a number if less than MAX_SAFE_INTEGER
        if (startRange < Number.MAX_SAFE_INTEGER && typeof startRange === 'bigint') startRange = Number(startRange);
        if (endRange < Number.MAX_SAFE_INTEGER && typeof endRange === 'bigint') endRange = Number(endRange);
        let length;
        if (typeof endRange === 'bigint' || typeof startRange === 'bigint') length = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(endRange) - (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(startRange) + (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(1);
        else length = endRange - startRange + 1;
        if (typeof length === 'bigint' && length < Number.MAX_SAFE_INTEGER) length = Number(length);
         // byterange should be inclusive according to
        // RFC 2616, Clause 14.35.1
        segment.byterange = {
            length: length,
            offset: startRange
        };
    }
    return segment;
};
const $0ffb3c35bf172c1a$var$byteRangeToString = (byterange)=>{
    // `endRange` is one less than `offset + length` because the HTTP range
    // header uses inclusive ranges
    let endRange;
    if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') endRange = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(byterange.offset) + (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(byterange.length) - (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(1);
    else endRange = byterange.offset + byterange.length - 1;
    return `${byterange.offset}-${endRange}`;
};
/**
 * parse the end number attribue that can be a string
 * number, or undefined.
 *
 * @param {string|number|undefined} endNumber
 *        The end number attribute.
 *
 * @return {number|null}
 *          The result of parsing the end number.
 */ const $0ffb3c35bf172c1a$var$parseEndNumber = (endNumber)=>{
    if (endNumber && typeof endNumber !== 'number') endNumber = parseInt(endNumber, 10);
    if (isNaN(endNumber)) return null;
    return endNumber;
};
/**
 * Functions for calculating the range of available segments in static and dynamic
 * manifests.
 */ const $0ffb3c35bf172c1a$var$segmentRange = {
    /**
   * Returns the entire range of available segments for a static MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */ static (attributes) {
        const { duration: duration, timescale: timescale = 1, sourceDuration: sourceDuration, periodDuration: periodDuration } = attributes;
        const endNumber = $0ffb3c35bf172c1a$var$parseEndNumber(attributes.endNumber);
        const segmentDuration = duration / timescale;
        if (typeof endNumber === 'number') return {
            start: 0,
            end: endNumber
        };
        if (typeof periodDuration === 'number') return {
            start: 0,
            end: periodDuration / segmentDuration
        };
        return {
            start: 0,
            end: sourceDuration / segmentDuration
        };
    },
    /**
   * Returns the current live window range of available segments for a dynamic MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */ dynamic (attributes) {
        const { NOW: NOW, clientOffset: clientOffset, availabilityStartTime: availabilityStartTime, timescale: timescale = 1, duration: duration, periodStart: periodStart = 0, minimumUpdatePeriod: minimumUpdatePeriod = 0, timeShiftBufferDepth: timeShiftBufferDepth = Infinity } = attributes;
        const endNumber = $0ffb3c35bf172c1a$var$parseEndNumber(attributes.endNumber); // clientOffset is passed in at the top level of mpd-parser and is an offset calculated
        // after retrieving UTC server time.
        const now = (NOW + clientOffset) / 1000; // WC stands for Wall Clock.
        // Convert the period start time to EPOCH.
        const periodStartWC = availabilityStartTime + periodStart; // Period end in EPOCH is manifest's retrieval time + time until next update.
        const periodEndWC = now + minimumUpdatePeriod;
        const periodDuration = periodEndWC - periodStartWC;
        const segmentCount = Math.ceil(periodDuration * timescale / duration);
        const availableStart = Math.floor((now - periodStartWC - timeShiftBufferDepth) * timescale / duration);
        const availableEnd = Math.floor((now - periodStartWC) * timescale / duration);
        return {
            start: Math.max(0, availableStart),
            end: typeof endNumber === 'number' ? endNumber : Math.min(segmentCount, availableEnd)
        };
    }
};
/**
 * Maps a range of numbers to objects with information needed to build the corresponding
 * segment list
 *
 * @name toSegmentsCallback
 * @function
 * @param {number} number
 *        Number of the segment
 * @param {number} index
 *        Index of the number in the range list
 * @return {{ number: Number, duration: Number, timeline: Number, time: Number }}
 *         Object with segment timing and duration info
 */ /**
 * Returns a callback for Array.prototype.map for mapping a range of numbers to
 * information needed to build the segment list.
 *
 * @param {Object} attributes
 *        Inherited MPD attributes
 * @return {toSegmentsCallback}
 *         Callback map function
 */ const $0ffb3c35bf172c1a$var$toSegments = (attributes)=>(number)=>{
        const { duration: duration, timescale: timescale = 1, periodStart: periodStart, startNumber: startNumber = 1 } = attributes;
        return {
            number: startNumber + number,
            duration: duration / timescale,
            timeline: periodStart,
            time: number * duration
        };
    };
/**
 * Returns a list of objects containing segment timing and duration info used for
 * building the list of segments. This uses the @duration attribute specified
 * in the MPD manifest to derive the range of segments.
 *
 * @param {Object} attributes
 *        Inherited MPD attributes
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */ const $0ffb3c35bf172c1a$var$parseByDuration = (attributes)=>{
    const { type: type, duration: duration, timescale: timescale = 1, periodDuration: periodDuration, sourceDuration: sourceDuration } = attributes;
    const { start: start, end: end } = $0ffb3c35bf172c1a$var$segmentRange[type](attributes);
    const segments = $0ffb3c35bf172c1a$var$range(start, end).map($0ffb3c35bf172c1a$var$toSegments(attributes));
    if (type === 'static') {
        const index = segments.length - 1; // section is either a period or the full source
        const sectionDuration = typeof periodDuration === 'number' ? periodDuration : sourceDuration; // final segment may be less than full segment duration
        segments[index].duration = sectionDuration - duration / timescale * index;
    }
    return segments;
};
/**
 * Translates SegmentBase into a set of segments.
 * (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
 * node should be translated into segment.
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @return {Object.<Array>} list of segments
 */ const $0ffb3c35bf172c1a$var$segmentsFromBase = (attributes)=>{
    const { baseUrl: baseUrl, initialization: initialization = {}, sourceDuration: sourceDuration, indexRange: indexRange = '', periodStart: periodStart, presentationTime: presentationTime, number: number = 0, duration: duration } = attributes; // base url is required for SegmentBase to work, per spec (Section 5.3.9.2.1)
    if (!baseUrl) throw new Error($0ffb3c35bf172c1a$var$errors.NO_BASE_URL);
    const initSegment = $0ffb3c35bf172c1a$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: initialization.sourceURL,
        range: initialization.range
    });
    const segment = $0ffb3c35bf172c1a$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: baseUrl,
        indexRange: indexRange
    });
    segment.map = initSegment; // If there is a duration, use it, otherwise use the given duration of the source
    // (since SegmentBase is only for one total segment)
    if (duration) {
        const segmentTimeInfo = $0ffb3c35bf172c1a$var$parseByDuration(attributes);
        if (segmentTimeInfo.length) {
            segment.duration = segmentTimeInfo[0].duration;
            segment.timeline = segmentTimeInfo[0].timeline;
        }
    } else if (sourceDuration) {
        segment.duration = sourceDuration;
        segment.timeline = periodStart;
    } // If presentation time is provided, these segments are being generated by SIDX
    // references, and should use the time provided. For the general case of SegmentBase,
    // there should only be one segment in the period, so its presentation time is the same
    // as its period start.
    segment.presentationTime = presentationTime || periodStart;
    segment.number = number;
    return [
        segment
    ];
};
/**
 * Given a playlist, a sidx box, and a baseUrl, update the segment list of the playlist
 * according to the sidx information given.
 *
 * playlist.sidx has metadadata about the sidx where-as the sidx param
 * is the parsed sidx box itself.
 *
 * @param {Object} playlist the playlist to update the sidx information for
 * @param {Object} sidx the parsed sidx box
 * @return {Object} the playlist object with the updated sidx information
 */ const $0ffb3c35bf172c1a$export$2243d5aa7d4f4800 = (playlist, sidx, baseUrl)=>{
    // Retain init segment information
    const initSegment = playlist.sidx.map ? playlist.sidx.map : null; // Retain source duration from initial main manifest parsing
    const sourceDuration = playlist.sidx.duration; // Retain source timeline
    const timeline = playlist.timeline || 0;
    const sidxByteRange = playlist.sidx.byterange;
    const sidxEnd = sidxByteRange.offset + sidxByteRange.length; // Retain timescale of the parsed sidx
    const timescale = sidx.timescale; // referenceType 1 refers to other sidx boxes
    const mediaReferences = sidx.references.filter((r)=>r.referenceType !== 1);
    const segments = [];
    const type = playlist.endList ? 'static' : 'dynamic';
    const periodStart = playlist.sidx.timeline;
    let presentationTime = periodStart;
    let number = playlist.mediaSequence || 0; // firstOffset is the offset from the end of the sidx box
    let startIndex; // eslint-disable-next-line
    if (typeof sidx.firstOffset === 'bigint') startIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(sidxEnd) + sidx.firstOffset;
    else startIndex = sidxEnd + sidx.firstOffset;
    for(let i = 0; i < mediaReferences.length; i++){
        const reference = sidx.references[i]; // size of the referenced (sub)segment
        const size = reference.referencedSize; // duration of the referenced (sub)segment, in  the  timescale
        // this will be converted to seconds when generating segments
        const duration = reference.subsegmentDuration; // should be an inclusive range
        let endIndex; // eslint-disable-next-line
        if (typeof startIndex === 'bigint') endIndex = startIndex + (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(size) - (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(1);
        else endIndex = startIndex + size - 1;
        const indexRange = `${startIndex}-${endIndex}`;
        const attributes = {
            baseUrl: baseUrl,
            timescale: timescale,
            timeline: timeline,
            periodStart: periodStart,
            presentationTime: presentationTime,
            number: number,
            duration: duration,
            sourceDuration: sourceDuration,
            indexRange: indexRange,
            type: type
        };
        const segment = $0ffb3c35bf172c1a$var$segmentsFromBase(attributes)[0];
        if (initSegment) segment.map = initSegment;
        segments.push(segment);
        if (typeof startIndex === 'bigint') startIndex += (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(size);
        else startIndex += size;
        presentationTime += duration / timescale;
        number++;
    }
    playlist.segments = segments;
    return playlist;
};
const $0ffb3c35bf172c1a$var$SUPPORTED_MEDIA_TYPES = [
    'AUDIO',
    'SUBTITLES'
]; // allow one 60fps frame as leniency (arbitrarily chosen)
const $0ffb3c35bf172c1a$var$TIME_FUDGE = 1 / 60;
/**
 * Given a list of timelineStarts, combines, dedupes, and sorts them.
 *
 * @param {TimelineStart[]} timelineStarts - list of timeline starts
 *
 * @return {TimelineStart[]} the combined and deduped timeline starts
 */ const $0ffb3c35bf172c1a$var$getUniqueTimelineStarts = (timelineStarts)=>{
    return $0ffb3c35bf172c1a$var$union(timelineStarts, ({ timeline: timeline })=>timeline).sort((a, b)=>a.timeline > b.timeline ? 1 : -1);
};
/**
 * Finds the playlist with the matching NAME attribute.
 *
 * @param {Array} playlists - playlists to search through
 * @param {string} name - the NAME attribute to search for
 *
 * @return {Object|null} the matching playlist object, or null
 */ const $0ffb3c35bf172c1a$var$findPlaylistWithName = (playlists, name)=>{
    for(let i = 0; i < playlists.length; i++){
        if (playlists[i].attributes.NAME === name) return playlists[i];
    }
    return null;
};
/**
 * Gets a flattened array of media group playlists.
 *
 * @param {Object} manifest - the main manifest object
 *
 * @return {Array} the media group playlists
 */ const $0ffb3c35bf172c1a$var$getMediaGroupPlaylists = (manifest)=>{
    let mediaGroupPlaylists = [];
    (0, $e96ds.forEachMediaGroup)(manifest, $0ffb3c35bf172c1a$var$SUPPORTED_MEDIA_TYPES, (properties, type, group, label)=>{
        mediaGroupPlaylists = mediaGroupPlaylists.concat(properties.playlists || []);
    });
    return mediaGroupPlaylists;
};
/**
 * Updates the playlist's media sequence numbers.
 *
 * @param {Object} config - options object
 * @param {Object} config.playlist - the playlist to update
 * @param {number} config.mediaSequence - the mediaSequence number to start with
 */ const $0ffb3c35bf172c1a$var$updateMediaSequenceForPlaylist = ({ playlist: playlist, mediaSequence: mediaSequence })=>{
    playlist.mediaSequence = mediaSequence;
    playlist.segments.forEach((segment, index)=>{
        segment.number = playlist.mediaSequence + index;
    });
};
/**
 * Updates the media and discontinuity sequence numbers of newPlaylists given oldPlaylists
 * and a complete list of timeline starts.
 *
 * If no matching playlist is found, only the discontinuity sequence number of the playlist
 * will be updated.
 *
 * Since early available timelines are not supported, at least one segment must be present.
 *
 * @param {Object} config - options object
 * @param {Object[]} oldPlaylists - the old playlists to use as a reference
 * @param {Object[]} newPlaylists - the new playlists to update
 * @param {Object} timelineStarts - all timelineStarts seen in the stream to this point
 */ const $0ffb3c35bf172c1a$var$updateSequenceNumbers = ({ oldPlaylists: oldPlaylists, newPlaylists: newPlaylists, timelineStarts: timelineStarts })=>{
    newPlaylists.forEach((playlist)=>{
        playlist.discontinuitySequence = timelineStarts.findIndex(function({ timeline: timeline }) {
            return timeline === playlist.timeline;
        }); // Playlists NAMEs come from DASH Representation IDs, which are mandatory
        // (see ISO_23009-1-2012 5.3.5.2).
        //
        // If the same Representation existed in a prior Period, it will retain the same NAME.
        const oldPlaylist = $0ffb3c35bf172c1a$var$findPlaylistWithName(oldPlaylists, playlist.attributes.NAME);
        if (!oldPlaylist) // Since this is a new playlist, the media sequence values can start from 0 without
        // consequence.
        return;
         // TODO better support for live SIDX
        //
        // As of this writing, mpd-parser does not support multiperiod SIDX (in live or VOD).
        // This is evident by a playlist only having a single SIDX reference. In a multiperiod
        // playlist there would need to be multiple SIDX references. In addition, live SIDX is
        // not supported when the SIDX properties change on refreshes.
        //
        // In the future, if support needs to be added, the merging logic here can be called
        // after SIDX references are resolved. For now, exit early to prevent exceptions being
        // thrown due to undefined references.
        if (playlist.sidx) return;
         // Since we don't yet support early available timelines, we don't need to support
        // playlists with no segments.
        const firstNewSegment = playlist.segments[0];
        const oldMatchingSegmentIndex = oldPlaylist.segments.findIndex(function(oldSegment) {
            return Math.abs(oldSegment.presentationTime - firstNewSegment.presentationTime) < $0ffb3c35bf172c1a$var$TIME_FUDGE;
        }); // No matching segment from the old playlist means the entire playlist was refreshed.
        // In this case the media sequence should account for this update, and the new segments
        // should be marked as discontinuous from the prior content, since the last prior
        // timeline was removed.
        if (oldMatchingSegmentIndex === -1) {
            $0ffb3c35bf172c1a$var$updateMediaSequenceForPlaylist({
                playlist: playlist,
                mediaSequence: oldPlaylist.mediaSequence + oldPlaylist.segments.length
            });
            playlist.segments[0].discontinuity = true;
            playlist.discontinuityStarts.unshift(0); // No matching segment does not necessarily mean there's missing content.
            //
            // If the new playlist's timeline is the same as the last seen segment's timeline,
            // then a discontinuity can be added to identify that there's potentially missing
            // content. If there's no missing content, the discontinuity should still be rather
            // harmless. It's possible that if segment durations are accurate enough, that the
            // existence of a gap can be determined using the presentation times and durations,
            // but if the segment timing info is off, it may introduce more problems than simply
            // adding the discontinuity.
            //
            // If the new playlist's timeline is different from the last seen segment's timeline,
            // then a discontinuity can be added to identify that this is the first seen segment
            // of a new timeline. However, the logic at the start of this function that
            // determined the disconinuity sequence by timeline index is now off by one (the
            // discontinuity of the newest timeline hasn't yet fallen off the manifest...since
            // we added it), so the disconinuity sequence must be decremented.
            //
            // A period may also have a duration of zero, so the case of no segments is handled
            // here even though we don't yet support early available periods.
            if (!oldPlaylist.segments.length && playlist.timeline > oldPlaylist.timeline || oldPlaylist.segments.length && playlist.timeline > oldPlaylist.segments[oldPlaylist.segments.length - 1].timeline) playlist.discontinuitySequence--;
            return;
        } // If the first segment matched with a prior segment on a discontinuity (it's matching
        // on the first segment of a period), then the discontinuitySequence shouldn't be the
        // timeline's matching one, but instead should be the one prior, and the first segment
        // of the new manifest should be marked with a discontinuity.
        //
        // The reason for this special case is that discontinuity sequence shows how many
        // discontinuities have fallen off of the playlist, and discontinuities are marked on
        // the first segment of a new "timeline." Because of this, while DASH will retain that
        // Period while the "timeline" exists, HLS keeps track of it via the discontinuity
        // sequence, and that first segment is an indicator, but can be removed before that
        // timeline is gone.
        const oldMatchingSegment = oldPlaylist.segments[oldMatchingSegmentIndex];
        if (oldMatchingSegment.discontinuity && !firstNewSegment.discontinuity) {
            firstNewSegment.discontinuity = true;
            playlist.discontinuityStarts.unshift(0);
            playlist.discontinuitySequence--;
        }
        $0ffb3c35bf172c1a$var$updateMediaSequenceForPlaylist({
            playlist: playlist,
            mediaSequence: oldPlaylist.segments[oldMatchingSegmentIndex].number
        });
    });
};
/**
 * Given an old parsed manifest object and a new parsed manifest object, updates the
 * sequence and timing values within the new manifest to ensure that it lines up with the
 * old.
 *
 * @param {Array} oldManifest - the old main manifest object
 * @param {Array} newManifest - the new main manifest object
 *
 * @return {Object} the updated new manifest object
 */ const $0ffb3c35bf172c1a$var$positionManifestOnTimeline = ({ oldManifest: oldManifest, newManifest: newManifest })=>{
    // Starting from v4.1.2 of the IOP, section 4.4.3.3 states:
    //
    // "MPD@availabilityStartTime and Period@start shall not be changed over MPD updates."
    //
    // This was added from https://github.com/Dash-Industry-Forum/DASH-IF-IOP/issues/160
    //
    // Because of this change, and the difficulty of supporting periods with changing start
    // times, periods with changing start times are not supported. This makes the logic much
    // simpler, since periods with the same start time can be considerred the same period
    // across refreshes.
    //
    // To give an example as to the difficulty of handling periods where the start time may
    // change, if a single period manifest is refreshed with another manifest with a single
    // period, and both the start and end times are increased, then the only way to determine
    // if it's a new period or an old one that has changed is to look through the segments of
    // each playlist and determine the presentation time bounds to find a match. In addition,
    // if the period start changed to exceed the old period end, then there would be no
    // match, and it would not be possible to determine whether the refreshed period is a new
    // one or the old one.
    const oldPlaylists = oldManifest.playlists.concat($0ffb3c35bf172c1a$var$getMediaGroupPlaylists(oldManifest));
    const newPlaylists = newManifest.playlists.concat($0ffb3c35bf172c1a$var$getMediaGroupPlaylists(newManifest)); // Save all seen timelineStarts to the new manifest. Although this potentially means that
    // there's a "memory leak" in that it will never stop growing, in reality, only a couple
    // of properties are saved for each seen Period. Even long running live streams won't
    // generate too many Periods, unless the stream is watched for decades. In the future,
    // this can be optimized by mapping to discontinuity sequence numbers for each timeline,
    // but it may not become an issue, and the additional info can be useful for debugging.
    newManifest.timelineStarts = $0ffb3c35bf172c1a$var$getUniqueTimelineStarts([
        oldManifest.timelineStarts,
        newManifest.timelineStarts
    ]);
    $0ffb3c35bf172c1a$var$updateSequenceNumbers({
        oldPlaylists: oldPlaylists,
        newPlaylists: newPlaylists,
        timelineStarts: newManifest.timelineStarts
    });
    return newManifest;
};
const $0ffb3c35bf172c1a$export$2d92360466eb0b01 = (sidx)=>sidx && sidx.uri + '-' + $0ffb3c35bf172c1a$var$byteRangeToString(sidx.byterange);
const $0ffb3c35bf172c1a$var$mergeDiscontiguousPlaylists = (playlists)=>{
    // Break out playlists into groups based on their baseUrl
    const playlistsByBaseUrl = playlists.reduce(function(acc, cur) {
        if (!acc[cur.attributes.baseUrl]) acc[cur.attributes.baseUrl] = [];
        acc[cur.attributes.baseUrl].push(cur);
        return acc;
    }, {});
    let allPlaylists = [];
    Object.values(playlistsByBaseUrl).forEach((playlistGroup)=>{
        const mergedPlaylists = $0ffb3c35bf172c1a$var$values(playlistGroup.reduce((acc, playlist)=>{
            // assuming playlist IDs are the same across periods
            // TODO: handle multiperiod where representation sets are not the same
            // across periods
            const name = playlist.attributes.id + (playlist.attributes.lang || '');
            if (!acc[name]) {
                // First Period
                acc[name] = playlist;
                acc[name].attributes.timelineStarts = [];
            } else {
                // Subsequent Periods
                if (playlist.segments) {
                    // first segment of subsequent periods signal a discontinuity
                    if (playlist.segments[0]) playlist.segments[0].discontinuity = true;
                    acc[name].segments.push(...playlist.segments);
                } // bubble up contentProtection, this assumes all DRM content
                // has the same contentProtection
                if (playlist.attributes.contentProtection) acc[name].attributes.contentProtection = playlist.attributes.contentProtection;
            }
            acc[name].attributes.timelineStarts.push({
                // Although they represent the same number, it's important to have both to make it
                // compatible with HLS potentially having a similar attribute.
                start: playlist.attributes.periodStart,
                timeline: playlist.attributes.periodStart
            });
            return acc;
        }, {}));
        allPlaylists = allPlaylists.concat(mergedPlaylists);
    });
    return allPlaylists.map((playlist)=>{
        playlist.discontinuityStarts = $0ffb3c35bf172c1a$var$findIndexes(playlist.segments || [], 'discontinuity');
        return playlist;
    });
};
const $0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylist = (playlist, sidxMapping)=>{
    const sidxKey = $0ffb3c35bf172c1a$export$2d92360466eb0b01(playlist.sidx);
    const sidxMatch = sidxKey && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx;
    if (sidxMatch) $0ffb3c35bf172c1a$export$2243d5aa7d4f4800(playlist, sidxMatch, playlist.sidx.resolvedUri);
    return playlist;
};
const $0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylists = (playlists, sidxMapping = {})=>{
    if (!Object.keys(sidxMapping).length) return playlists;
    for(const i in playlists)playlists[i] = $0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylist(playlists[i], sidxMapping);
    return playlists;
};
const $0ffb3c35bf172c1a$var$formatAudioPlaylist = ({ attributes: attributes, segments: segments, sidx: sidx, mediaSequence: mediaSequence, discontinuitySequence: discontinuitySequence, discontinuityStarts: discontinuityStarts }, isAudioOnly)=>{
    const playlist = {
        attributes: {
            NAME: attributes.id,
            BANDWIDTH: attributes.bandwidth,
            CODECS: attributes.codecs,
            ['PROGRAM-ID']: 1
        },
        uri: '',
        endList: attributes.type === 'static',
        timeline: attributes.periodStart,
        resolvedUri: attributes.baseUrl || '',
        targetDuration: attributes.duration,
        discontinuitySequence: discontinuitySequence,
        discontinuityStarts: discontinuityStarts,
        timelineStarts: attributes.timelineStarts,
        mediaSequence: mediaSequence,
        segments: segments
    };
    if (attributes.contentProtection) playlist.contentProtection = attributes.contentProtection;
    if (attributes.serviceLocation) playlist.attributes.serviceLocation = attributes.serviceLocation;
    if (sidx) playlist.sidx = sidx;
    if (isAudioOnly) {
        playlist.attributes.AUDIO = 'audio';
        playlist.attributes.SUBTITLES = 'subs';
    }
    return playlist;
};
const $0ffb3c35bf172c1a$var$formatVttPlaylist = ({ attributes: attributes, segments: segments, mediaSequence: mediaSequence, discontinuityStarts: discontinuityStarts, discontinuitySequence: discontinuitySequence })=>{
    if (typeof segments === 'undefined') {
        // vtt tracks may use single file in BaseURL
        segments = [
            {
                uri: attributes.baseUrl,
                timeline: attributes.periodStart,
                resolvedUri: attributes.baseUrl || '',
                duration: attributes.sourceDuration,
                number: 0
            }
        ]; // targetDuration should be the same duration as the only segment
        attributes.duration = attributes.sourceDuration;
    }
    const m3u8Attributes = {
        NAME: attributes.id,
        BANDWIDTH: attributes.bandwidth,
        ['PROGRAM-ID']: 1
    };
    if (attributes.codecs) m3u8Attributes.CODECS = attributes.codecs;
    const vttPlaylist = {
        attributes: m3u8Attributes,
        uri: '',
        endList: attributes.type === 'static',
        timeline: attributes.periodStart,
        resolvedUri: attributes.baseUrl || '',
        targetDuration: attributes.duration,
        timelineStarts: attributes.timelineStarts,
        discontinuityStarts: discontinuityStarts,
        discontinuitySequence: discontinuitySequence,
        mediaSequence: mediaSequence,
        segments: segments
    };
    if (attributes.serviceLocation) vttPlaylist.attributes.serviceLocation = attributes.serviceLocation;
    return vttPlaylist;
};
const $0ffb3c35bf172c1a$var$organizeAudioPlaylists = (playlists, sidxMapping = {}, isAudioOnly = false)=>{
    let mainPlaylist;
    const formattedPlaylists = playlists.reduce((a, playlist)=>{
        const role = playlist.attributes.role && playlist.attributes.role.value || '';
        const language = playlist.attributes.lang || '';
        let label = playlist.attributes.label || 'main';
        if (language && !playlist.attributes.label) {
            const roleLabel = role ? ` (${role})` : '';
            label = `${playlist.attributes.lang}${roleLabel}`;
        }
        if (!a[label]) a[label] = {
            language: language,
            autoselect: true,
            default: role === 'main',
            playlists: [],
            uri: ''
        };
        const formatted = $0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylist($0ffb3c35bf172c1a$var$formatAudioPlaylist(playlist, isAudioOnly), sidxMapping);
        a[label].playlists.push(formatted);
        if (typeof mainPlaylist === 'undefined' && role === 'main') {
            mainPlaylist = playlist;
            mainPlaylist.default = true;
        }
        return a;
    }, {}); // if no playlists have role "main", mark the first as main
    if (!mainPlaylist) {
        const firstLabel = Object.keys(formattedPlaylists)[0];
        formattedPlaylists[firstLabel].default = true;
    }
    return formattedPlaylists;
};
const $0ffb3c35bf172c1a$var$organizeVttPlaylists = (playlists, sidxMapping = {})=>{
    return playlists.reduce((a, playlist)=>{
        const label = playlist.attributes.label || playlist.attributes.lang || 'text';
        const language = playlist.attributes.lang || 'und';
        if (!a[label]) a[label] = {
            language: language,
            default: false,
            autoselect: false,
            playlists: [],
            uri: ''
        };
        a[label].playlists.push($0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylist($0ffb3c35bf172c1a$var$formatVttPlaylist(playlist), sidxMapping));
        return a;
    }, {});
};
const $0ffb3c35bf172c1a$var$organizeCaptionServices = (captionServices)=>captionServices.reduce((svcObj, svc)=>{
        if (!svc) return svcObj;
        svc.forEach((service)=>{
            const { channel: channel, language: language } = service;
            svcObj[language] = {
                autoselect: false,
                default: false,
                instreamId: channel,
                language: language
            };
            if (service.hasOwnProperty('aspectRatio')) svcObj[language].aspectRatio = service.aspectRatio;
            if (service.hasOwnProperty('easyReader')) svcObj[language].easyReader = service.easyReader;
            if (service.hasOwnProperty('3D')) svcObj[language]['3D'] = service['3D'];
        });
        return svcObj;
    }, {});
const $0ffb3c35bf172c1a$var$formatVideoPlaylist = ({ attributes: attributes, segments: segments, sidx: sidx, discontinuityStarts: discontinuityStarts })=>{
    const playlist = {
        attributes: {
            NAME: attributes.id,
            AUDIO: 'audio',
            SUBTITLES: 'subs',
            RESOLUTION: {
                width: attributes.width,
                height: attributes.height
            },
            CODECS: attributes.codecs,
            BANDWIDTH: attributes.bandwidth,
            ['PROGRAM-ID']: 1
        },
        uri: '',
        endList: attributes.type === 'static',
        timeline: attributes.periodStart,
        resolvedUri: attributes.baseUrl || '',
        targetDuration: attributes.duration,
        discontinuityStarts: discontinuityStarts,
        timelineStarts: attributes.timelineStarts,
        segments: segments
    };
    if (attributes.frameRate) playlist.attributes['FRAME-RATE'] = attributes.frameRate;
    if (attributes.contentProtection) playlist.contentProtection = attributes.contentProtection;
    if (attributes.serviceLocation) playlist.attributes.serviceLocation = attributes.serviceLocation;
    if (sidx) playlist.sidx = sidx;
    return playlist;
};
const $0ffb3c35bf172c1a$var$videoOnly = ({ attributes: attributes })=>attributes.mimeType === 'video/mp4' || attributes.mimeType === 'video/webm' || attributes.contentType === 'video';
const $0ffb3c35bf172c1a$var$audioOnly = ({ attributes: attributes })=>attributes.mimeType === 'audio/mp4' || attributes.mimeType === 'audio/webm' || attributes.contentType === 'audio';
const $0ffb3c35bf172c1a$var$vttOnly = ({ attributes: attributes })=>attributes.mimeType === 'text/vtt' || attributes.contentType === 'text';
/**
 * Contains start and timeline properties denoting a timeline start. For DASH, these will
 * be the same number.
 *
 * @typedef {Object} TimelineStart
 * @property {number} start - the start time of the timeline
 * @property {number} timeline - the timeline number
 */ /**
 * Adds appropriate media and discontinuity sequence values to the segments and playlists.
 *
 * Throughout mpd-parser, the `number` attribute is used in relation to `startNumber`, a
 * DASH specific attribute used in constructing segment URI's from templates. However, from
 * an HLS perspective, the `number` attribute on a segment would be its `mediaSequence`
 * value, which should start at the original media sequence value (or 0) and increment by 1
 * for each segment thereafter. Since DASH's `startNumber` values are independent per
 * period, it doesn't make sense to use it for `number`. Instead, assume everything starts
 * from a 0 mediaSequence value and increment from there.
 *
 * Note that VHS currently doesn't use the `number` property, but it can be helpful for
 * debugging and making sense of the manifest.
 *
 * For live playlists, to account for values increasing in manifests when periods are
 * removed on refreshes, merging logic should be used to update the numbers to their
 * appropriate values (to ensure they're sequential and increasing).
 *
 * @param {Object[]} playlists - the playlists to update
 * @param {TimelineStart[]} timelineStarts - the timeline starts for the manifest
 */ const $0ffb3c35bf172c1a$var$addMediaSequenceValues = (playlists, timelineStarts)=>{
    // increment all segments sequentially
    playlists.forEach((playlist)=>{
        playlist.mediaSequence = 0;
        playlist.discontinuitySequence = timelineStarts.findIndex(function({ timeline: timeline }) {
            return timeline === playlist.timeline;
        });
        if (!playlist.segments) return;
        playlist.segments.forEach((segment, index)=>{
            segment.number = index;
        });
    });
};
/**
 * Given a media group object, flattens all playlists within the media group into a single
 * array.
 *
 * @param {Object} mediaGroupObject - the media group object
 *
 * @return {Object[]}
 *         The media group playlists
 */ const $0ffb3c35bf172c1a$var$flattenMediaGroupPlaylists = (mediaGroupObject)=>{
    if (!mediaGroupObject) return [];
    return Object.keys(mediaGroupObject).reduce((acc, label)=>{
        const labelContents = mediaGroupObject[label];
        return acc.concat(labelContents.playlists);
    }, []);
};
const $0ffb3c35bf172c1a$export$c90e7d9f067c8f2c = ({ dashPlaylists: dashPlaylists, locations: locations, contentSteering: contentSteering, sidxMapping: sidxMapping = {}, previousManifest: previousManifest, eventStream: eventStream })=>{
    if (!dashPlaylists.length) return {};
     // grab all main manifest attributes
    const { sourceDuration: duration, type: type, suggestedPresentationDelay: suggestedPresentationDelay, minimumUpdatePeriod: minimumUpdatePeriod } = dashPlaylists[0].attributes;
    const videoPlaylists = $0ffb3c35bf172c1a$var$mergeDiscontiguousPlaylists(dashPlaylists.filter($0ffb3c35bf172c1a$var$videoOnly)).map($0ffb3c35bf172c1a$var$formatVideoPlaylist);
    const audioPlaylists = $0ffb3c35bf172c1a$var$mergeDiscontiguousPlaylists(dashPlaylists.filter($0ffb3c35bf172c1a$var$audioOnly));
    const vttPlaylists = $0ffb3c35bf172c1a$var$mergeDiscontiguousPlaylists(dashPlaylists.filter($0ffb3c35bf172c1a$var$vttOnly));
    const captions = dashPlaylists.map((playlist)=>playlist.attributes.captionServices).filter(Boolean);
    const manifest = {
        allowCache: true,
        discontinuityStarts: [],
        segments: [],
        endList: true,
        mediaGroups: {
            AUDIO: {},
            VIDEO: {},
            ['CLOSED-CAPTIONS']: {},
            SUBTITLES: {}
        },
        uri: '',
        duration: duration,
        playlists: $0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylists(videoPlaylists, sidxMapping)
    };
    if (minimumUpdatePeriod >= 0) manifest.minimumUpdatePeriod = minimumUpdatePeriod * 1000;
    if (locations) manifest.locations = locations;
    if (contentSteering) manifest.contentSteering = contentSteering;
    if (type === 'dynamic') manifest.suggestedPresentationDelay = suggestedPresentationDelay;
    if (eventStream && eventStream.length > 0) manifest.eventStream = eventStream;
    const isAudioOnly = manifest.playlists.length === 0;
    const organizedAudioGroup = audioPlaylists.length ? $0ffb3c35bf172c1a$var$organizeAudioPlaylists(audioPlaylists, sidxMapping, isAudioOnly) : null;
    const organizedVttGroup = vttPlaylists.length ? $0ffb3c35bf172c1a$var$organizeVttPlaylists(vttPlaylists, sidxMapping) : null;
    const formattedPlaylists = videoPlaylists.concat($0ffb3c35bf172c1a$var$flattenMediaGroupPlaylists(organizedAudioGroup), $0ffb3c35bf172c1a$var$flattenMediaGroupPlaylists(organizedVttGroup));
    const playlistTimelineStarts = formattedPlaylists.map(({ timelineStarts: timelineStarts })=>timelineStarts);
    manifest.timelineStarts = $0ffb3c35bf172c1a$var$getUniqueTimelineStarts(playlistTimelineStarts);
    $0ffb3c35bf172c1a$var$addMediaSequenceValues(formattedPlaylists, manifest.timelineStarts);
    if (organizedAudioGroup) manifest.mediaGroups.AUDIO.audio = organizedAudioGroup;
    if (organizedVttGroup) manifest.mediaGroups.SUBTITLES.subs = organizedVttGroup;
    if (captions.length) manifest.mediaGroups['CLOSED-CAPTIONS'].cc = $0ffb3c35bf172c1a$var$organizeCaptionServices(captions);
    if (previousManifest) return $0ffb3c35bf172c1a$var$positionManifestOnTimeline({
        oldManifest: previousManifest,
        newManifest: manifest
    });
    return manifest;
};
/**
 * Calculates the R (repetition) value for a live stream (for the final segment
 * in a manifest where the r value is negative 1)
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {number} time
 *        current time (typically the total time up until the final segment)
 * @param {number} duration
 *        duration property for the given <S />
 *
 * @return {number}
 *        R value to reach the end of the given period
 */ const $0ffb3c35bf172c1a$var$getLiveRValue = (attributes, time, duration)=>{
    const { NOW: NOW, clientOffset: clientOffset, availabilityStartTime: availabilityStartTime, timescale: timescale = 1, periodStart: periodStart = 0, minimumUpdatePeriod: minimumUpdatePeriod = 0 } = attributes;
    const now = (NOW + clientOffset) / 1000;
    const periodStartWC = availabilityStartTime + periodStart;
    const periodEndWC = now + minimumUpdatePeriod;
    const periodDuration = periodEndWC - periodStartWC;
    return Math.ceil((periodDuration * timescale - time) / duration);
};
/**
 * Uses information provided by SegmentTemplate.SegmentTimeline to determine segment
 * timing and duration
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */ const $0ffb3c35bf172c1a$var$parseByTimeline = (attributes, segmentTimeline)=>{
    const { type: type, minimumUpdatePeriod: minimumUpdatePeriod = 0, media: media = '', sourceDuration: sourceDuration, timescale: timescale = 1, startNumber: startNumber = 1, periodStart: timeline } = attributes;
    const segments = [];
    let time = -1;
    for(let sIndex = 0; sIndex < segmentTimeline.length; sIndex++){
        const S = segmentTimeline[sIndex];
        const duration = S.d;
        const repeat = S.r || 0;
        const segmentTime = S.t || 0;
        if (time < 0) // first segment
        time = segmentTime;
        if (segmentTime && segmentTime > time) // discontinuity
        // TODO: How to handle this type of discontinuity
        // timeline++ here would treat it like HLS discontuity and content would
        // get appended without gap
        // E.G.
        //  <S t="0" d="1" />
        //  <S d="1" />
        //  <S d="1" />
        //  <S t="5" d="1" />
        // would have $Time$ values of [0, 1, 2, 5]
        // should this be appened at time positions [0, 1, 2, 3],(#EXT-X-DISCONTINUITY)
        // or [0, 1, 2, gap, gap, 5]? (#EXT-X-GAP)
        // does the value of sourceDuration consider this when calculating arbitrary
        // negative @r repeat value?
        // E.G. Same elements as above with this added at the end
        //  <S d="1" r="-1" />
        //  with a sourceDuration of 10
        // Would the 2 gaps be included in the time duration calculations resulting in
        // 8 segments with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9] or 10 segments
        // with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9, 10, 11] ?
        time = segmentTime;
        let count;
        if (repeat < 0) {
            const nextS = sIndex + 1;
            if (nextS === segmentTimeline.length) {
                // last segment
                if (type === 'dynamic' && minimumUpdatePeriod > 0 && media.indexOf('$Number$') > 0) count = $0ffb3c35bf172c1a$var$getLiveRValue(attributes, time, duration);
                else // TODO: This may be incorrect depending on conclusion of TODO above
                count = (sourceDuration * timescale - time) / duration;
            } else count = (segmentTimeline[nextS].t - time) / duration;
        } else count = repeat + 1;
        const end = startNumber + segments.length + count;
        let number = startNumber + segments.length;
        while(number < end){
            segments.push({
                number: number,
                duration: duration / timescale,
                time: time,
                timeline: timeline
            });
            time += duration;
            number++;
        }
    }
    return segments;
};
const $0ffb3c35bf172c1a$var$identifierPattern = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g;
/**
 * Replaces template identifiers with corresponding values. To be used as the callback
 * for String.prototype.replace
 *
 * @name replaceCallback
 * @function
 * @param {string} match
 *        Entire match of identifier
 * @param {string} identifier
 *        Name of matched identifier
 * @param {string} format
 *        Format tag string. Its presence indicates that padding is expected
 * @param {string} width
 *        Desired length of the replaced value. Values less than this width shall be left
 *        zero padded
 * @return {string}
 *         Replacement for the matched identifier
 */ /**
 * Returns a function to be used as a callback for String.prototype.replace to replace
 * template identifiers
 *
 * @param {Obect} values
 *        Object containing values that shall be used to replace known identifiers
 * @param {number} values.RepresentationID
 *        Value of the Representation@id attribute
 * @param {number} values.Number
 *        Number of the corresponding segment
 * @param {number} values.Bandwidth
 *        Value of the Representation@bandwidth attribute.
 * @param {number} values.Time
 *        Timestamp value of the corresponding segment
 * @return {replaceCallback}
 *         Callback to be used with String.prototype.replace to replace identifiers
 */ const $0ffb3c35bf172c1a$var$identifierReplacement = (values)=>(match, identifier, format, width)=>{
        if (match === '$$') // escape sequence
        return '$';
        if (typeof values[identifier] === 'undefined') return match;
        const value = '' + values[identifier];
        if (identifier === 'RepresentationID') // Format tag shall not be present with RepresentationID
        return value;
        if (!format) width = 1;
        else width = parseInt(width, 10);
        if (value.length >= width) return value;
        return `${new Array(width - value.length + 1).join('0')}${value}`;
    };
/**
 * Constructs a segment url from a template string
 *
 * @param {string} url
 *        Template string to construct url from
 * @param {Obect} values
 *        Object containing values that shall be used to replace known identifiers
 * @param {number} values.RepresentationID
 *        Value of the Representation@id attribute
 * @param {number} values.Number
 *        Number of the corresponding segment
 * @param {number} values.Bandwidth
 *        Value of the Representation@bandwidth attribute.
 * @param {number} values.Time
 *        Timestamp value of the corresponding segment
 * @return {string}
 *         Segment url with identifiers replaced
 */ const $0ffb3c35bf172c1a$var$constructTemplateUrl = (url, values)=>url.replace($0ffb3c35bf172c1a$var$identifierPattern, $0ffb3c35bf172c1a$var$identifierReplacement(values));
/**
 * Generates a list of objects containing timing and duration information about each
 * segment needed to generate segment uris and the complete segment object
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */ const $0ffb3c35bf172c1a$var$parseTemplateInfo = (attributes, segmentTimeline)=>{
    if (!attributes.duration && !segmentTimeline) // if neither @duration or SegmentTimeline are present, then there shall be exactly
    // one media segment
    return [
        {
            number: attributes.startNumber || 1,
            duration: attributes.sourceDuration,
            time: 0,
            timeline: attributes.periodStart
        }
    ];
    if (attributes.duration) return $0ffb3c35bf172c1a$var$parseByDuration(attributes);
    return $0ffb3c35bf172c1a$var$parseByTimeline(attributes, segmentTimeline);
};
/**
 * Generates a list of segments using information provided by the SegmentTemplate element
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {Object[]}
 *         List of segment objects
 */ const $0ffb3c35bf172c1a$var$segmentsFromTemplate = (attributes, segmentTimeline)=>{
    const templateValues = {
        RepresentationID: attributes.id,
        Bandwidth: attributes.bandwidth || 0
    };
    const { initialization: initialization = {
        sourceURL: '',
        range: ''
    } } = attributes;
    const mapSegment = $0ffb3c35bf172c1a$var$urlTypeToSegment({
        baseUrl: attributes.baseUrl,
        source: $0ffb3c35bf172c1a$var$constructTemplateUrl(initialization.sourceURL, templateValues),
        range: initialization.range
    });
    const segments = $0ffb3c35bf172c1a$var$parseTemplateInfo(attributes, segmentTimeline);
    return segments.map((segment)=>{
        templateValues.Number = segment.number;
        templateValues.Time = segment.time;
        const uri = $0ffb3c35bf172c1a$var$constructTemplateUrl(attributes.media || '', templateValues); // See DASH spec section 5.3.9.2.2
        // - if timescale isn't present on any level, default to 1.
        const timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
        const presentationTimeOffset = attributes.presentationTimeOffset || 0;
        const presentationTime = // calculated in mpd-parser prior to this, so it's assumed to be available.
        attributes.periodStart + (segment.time - presentationTimeOffset) / timescale;
        const map = {
            uri: uri,
            timeline: segment.timeline,
            duration: segment.duration,
            resolvedUri: (0, $5JQY5.default)(attributes.baseUrl || '', uri),
            map: mapSegment,
            number: segment.number,
            presentationTime: presentationTime
        };
        return map;
    });
};
/**
 * Converts a <SegmentUrl> (of type URLType from the DASH spec 5.3.9.2 Table 14)
 * to an object that matches the output of a segment in videojs/mpd-parser
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @param {Object} segmentUrl
 *   <SegmentURL> node to translate into a segment object
 * @return {Object} translated segment object
 */ const $0ffb3c35bf172c1a$var$SegmentURLToSegmentObject = (attributes, segmentUrl)=>{
    const { baseUrl: baseUrl, initialization: initialization = {} } = attributes;
    const initSegment = $0ffb3c35bf172c1a$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: initialization.sourceURL,
        range: initialization.range
    });
    const segment = $0ffb3c35bf172c1a$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: segmentUrl.media,
        range: segmentUrl.mediaRange
    });
    segment.map = initSegment;
    return segment;
};
/**
 * Generates a list of segments using information provided by the SegmentList element
 * SegmentList (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
 * node should be translated into segment.
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {Object.<Array>} list of segments
 */ const $0ffb3c35bf172c1a$var$segmentsFromList = (attributes, segmentTimeline)=>{
    const { duration: duration, segmentUrls: segmentUrls = [], periodStart: periodStart } = attributes; // Per spec (5.3.9.2.1) no way to determine segment duration OR
    // if both SegmentTimeline and @duration are defined, it is outside of spec.
    if (!duration && !segmentTimeline || duration && segmentTimeline) throw new Error($0ffb3c35bf172c1a$var$errors.SEGMENT_TIME_UNSPECIFIED);
    const segmentUrlMap = segmentUrls.map((segmentUrlObject)=>$0ffb3c35bf172c1a$var$SegmentURLToSegmentObject(attributes, segmentUrlObject));
    let segmentTimeInfo;
    if (duration) segmentTimeInfo = $0ffb3c35bf172c1a$var$parseByDuration(attributes);
    if (segmentTimeline) segmentTimeInfo = $0ffb3c35bf172c1a$var$parseByTimeline(attributes, segmentTimeline);
    const segments = segmentTimeInfo.map((segmentTime, index)=>{
        if (segmentUrlMap[index]) {
            const segment = segmentUrlMap[index]; // See DASH spec section 5.3.9.2.2
            // - if timescale isn't present on any level, default to 1.
            const timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
            const presentationTimeOffset = attributes.presentationTimeOffset || 0;
            segment.timeline = segmentTime.timeline;
            segment.duration = segmentTime.duration;
            segment.number = segmentTime.number;
            segment.presentationTime = periodStart + (segmentTime.time - presentationTimeOffset) / timescale;
            return segment;
        } // Since we're mapping we should get rid of any blank segments (in case
    // the given SegmentTimeline is handling for more elements than we have
    // SegmentURLs for).
    }).filter((segment)=>segment);
    return segments;
};
const $0ffb3c35bf172c1a$var$generateSegments = ({ attributes: attributes, segmentInfo: segmentInfo })=>{
    let segmentAttributes;
    let segmentsFn;
    if (segmentInfo.template) {
        segmentsFn = $0ffb3c35bf172c1a$var$segmentsFromTemplate;
        segmentAttributes = $0ffb3c35bf172c1a$var$merge(attributes, segmentInfo.template);
    } else if (segmentInfo.base) {
        segmentsFn = $0ffb3c35bf172c1a$var$segmentsFromBase;
        segmentAttributes = $0ffb3c35bf172c1a$var$merge(attributes, segmentInfo.base);
    } else if (segmentInfo.list) {
        segmentsFn = $0ffb3c35bf172c1a$var$segmentsFromList;
        segmentAttributes = $0ffb3c35bf172c1a$var$merge(attributes, segmentInfo.list);
    }
    const segmentsInfo = {
        attributes: attributes
    };
    if (!segmentsFn) return segmentsInfo;
    const segments = segmentsFn(segmentAttributes, segmentInfo.segmentTimeline); // The @duration attribute will be used to determin the playlist's targetDuration which
    // must be in seconds. Since we've generated the segment list, we no longer need
    // @duration to be in @timescale units, so we can convert it here.
    if (segmentAttributes.duration) {
        const { duration: duration, timescale: timescale = 1 } = segmentAttributes;
        segmentAttributes.duration = duration / timescale;
    } else if (segments.length) // if there is no @duration attribute, use the largest segment duration as
    // as target duration
    segmentAttributes.duration = segments.reduce((max, segment)=>{
        return Math.max(max, Math.ceil(segment.duration));
    }, 0);
    else segmentAttributes.duration = 0;
    segmentsInfo.attributes = segmentAttributes;
    segmentsInfo.segments = segments; // This is a sidx box without actual segment information
    if (segmentInfo.base && segmentAttributes.indexRange) {
        segmentsInfo.sidx = segments[0];
        segmentsInfo.segments = [];
    }
    return segmentsInfo;
};
const $0ffb3c35bf172c1a$export$4362d710904f703f = (representations)=>representations.map($0ffb3c35bf172c1a$var$generateSegments);
const $0ffb3c35bf172c1a$var$findChildren = (element, name)=>$0ffb3c35bf172c1a$var$from(element.childNodes).filter(({ tagName: tagName })=>tagName === name);
const $0ffb3c35bf172c1a$var$getContent = (element)=>element.textContent.trim();
/**
 * Converts the provided string that may contain a division operation to a number.
 *
 * @param {string} value - the provided string value
 *
 * @return {number} the parsed string value
 */ const $0ffb3c35bf172c1a$var$parseDivisionValue = (value)=>{
    return parseFloat(value.split('/').reduce((prev, current)=>prev / current));
};
const $0ffb3c35bf172c1a$var$parseDuration = (str)=>{
    const SECONDS_IN_YEAR = 31536000;
    const SECONDS_IN_MONTH = 2592000;
    const SECONDS_IN_DAY = 86400;
    const SECONDS_IN_HOUR = 3600;
    const SECONDS_IN_MIN = 60; // P10Y10M10DT10H10M10.1S
    const durationRegex = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/;
    const match = durationRegex.exec(str);
    if (!match) return 0;
    const [year, month, day, hour, minute, second] = match.slice(1);
    return parseFloat(year || 0) * SECONDS_IN_YEAR + parseFloat(month || 0) * SECONDS_IN_MONTH + parseFloat(day || 0) * SECONDS_IN_DAY + parseFloat(hour || 0) * SECONDS_IN_HOUR + parseFloat(minute || 0) * SECONDS_IN_MIN + parseFloat(second || 0);
};
const $0ffb3c35bf172c1a$var$parseDate = (str)=>{
    // Date format without timezone according to ISO 8601
    // YYY-MM-DDThh:mm:ss.ssssss
    const dateRegex = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/; // If the date string does not specifiy a timezone, we must specifiy UTC. This is
    // expressed by ending with 'Z'
    if (dateRegex.test(str)) str += 'Z';
    return Date.parse(str);
};
const $0ffb3c35bf172c1a$var$parsers = {
    /**
   * Specifies the duration of the entire Media Presentation. Format is a duration string
   * as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ mediaPresentationDuration (value) {
        return $0ffb3c35bf172c1a$var$parseDuration(value);
    },
    /**
   * Specifies the Segment availability start time for all Segments referred to in this
   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
   * time. Format is a date string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The date as seconds from unix epoch
   */ availabilityStartTime (value) {
        return $0ffb3c35bf172c1a$var$parseDate(value) / 1000;
    },
    /**
   * Specifies the smallest period between potential changes to the MPD. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ minimumUpdatePeriod (value) {
        return $0ffb3c35bf172c1a$var$parseDuration(value);
    },
    /**
   * Specifies the suggested presentation delay. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ suggestedPresentationDelay (value) {
        return $0ffb3c35bf172c1a$var$parseDuration(value);
    },
    /**
   * specifices the type of mpd. Can be either "static" or "dynamic"
   *
   * @param {string} value
   *        value of attribute as a string
   *
   * @return {string}
   *         The type as a string
   */ type (value) {
        return value;
    },
    /**
   * Specifies the duration of the smallest time shifting buffer for any Representation
   * in the MPD. Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ timeShiftBufferDepth (value) {
        return $0ffb3c35bf172c1a$var$parseDuration(value);
    },
    /**
   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
   * Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ start (value) {
        return $0ffb3c35bf172c1a$var$parseDuration(value);
    },
    /**
   * Specifies the width of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed width
   */ width (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the height of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed height
   */ height (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the bitrate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed bandwidth
   */ bandwidth (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the frame rate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed frame rate
   */ frameRate (value) {
        return $0ffb3c35bf172c1a$var$parseDivisionValue(value);
    },
    /**
   * Specifies the number of the first Media Segment in this Representation in the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */ startNumber (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the timescale in units per seconds
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed timescale
   */ timescale (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the presentationTimeOffset.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTimeOffset
   */ presentationTimeOffset (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the constant approximate Segment duration
   * NOTE: The <Period> element also contains an @duration attribute. This duration
   *       specifies the duration of the Period. This attribute is currently not
   *       supported by the rest of the parser, however we still check for it to prevent
   *       errors.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */ duration (value) {
        const parsedValue = parseInt(value, 10);
        if (isNaN(parsedValue)) return $0ffb3c35bf172c1a$var$parseDuration(value);
        return parsedValue;
    },
    /**
   * Specifies the Segment duration, in units of the value of the @timescale.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */ d (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the MPD start time, in @timescale units, the first Segment in the series
   * starts relative to the beginning of the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed time
   */ t (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the repeat count of the number of following contiguous Segments with the
   * same duration expressed by the value of @d
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */ r (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the presentationTime.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTime
   */ presentationTime (value) {
        return parseInt(value, 10);
    },
    /**
   * Default parser for all other attributes. Acts as a no-op and just returns the value
   * as a string
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {string}
   *         Unparsed value
   */ DEFAULT (value) {
        return value;
    }
};
/**
 * Gets all the attributes and values of the provided node, parses attributes with known
 * types, and returns an object with attribute names mapped to values.
 *
 * @param {Node} el
 *        The node to parse attributes from
 * @return {Object}
 *         Object with all attributes of el parsed
 */ const $0ffb3c35bf172c1a$var$parseAttributes = (el)=>{
    if (!(el && el.attributes)) return {};
    return $0ffb3c35bf172c1a$var$from(el.attributes).reduce((a, e)=>{
        const parseFn = $0ffb3c35bf172c1a$var$parsers[e.name] || $0ffb3c35bf172c1a$var$parsers.DEFAULT;
        a[e.name] = parseFn(e.value);
        return a;
    }, {});
};
const $0ffb3c35bf172c1a$var$keySystemsMap = {
    'urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b': 'org.w3.clearkey',
    'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed': 'com.widevine.alpha',
    'urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95': 'com.microsoft.playready',
    'urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb': 'com.adobe.primetime',
    // ISO_IEC 23009-1_2022 5.8.5.2.2 The mp4 Protection Scheme
    'urn:mpeg:dash:mp4protection:2011': 'mp4protection'
};
/**
 * Builds a list of urls that is the product of the reference urls and BaseURL values
 *
 * @param {Object[]} references
 *        List of objects containing the reference URL as well as its attributes
 * @param {Node[]} baseUrlElements
 *        List of BaseURL nodes from the mpd
 * @return {Object[]}
 *         List of objects with resolved urls and attributes
 */ const $0ffb3c35bf172c1a$var$buildBaseUrls = (references, baseUrlElements)=>{
    if (!baseUrlElements.length) return references;
    return $0ffb3c35bf172c1a$var$flatten(references.map(function(reference) {
        return baseUrlElements.map(function(baseUrlElement) {
            const initialBaseUrl = $0ffb3c35bf172c1a$var$getContent(baseUrlElement);
            const resolvedBaseUrl = (0, $5JQY5.default)(reference.baseUrl, initialBaseUrl);
            const finalBaseUrl = $0ffb3c35bf172c1a$var$merge($0ffb3c35bf172c1a$var$parseAttributes(baseUrlElement), {
                baseUrl: resolvedBaseUrl
            }); // If the URL is resolved, we want to get the serviceLocation from the reference
            // assuming there is no serviceLocation on the initialBaseUrl
            if (resolvedBaseUrl !== initialBaseUrl && !finalBaseUrl.serviceLocation && reference.serviceLocation) finalBaseUrl.serviceLocation = reference.serviceLocation;
            return finalBaseUrl;
        });
    }));
};
/**
 * Contains all Segment information for its containing AdaptationSet
 *
 * @typedef {Object} SegmentInformation
 * @property {Object|undefined} template
 *           Contains the attributes for the SegmentTemplate node
 * @property {Object[]|undefined} segmentTimeline
 *           Contains a list of atrributes for each S node within the SegmentTimeline node
 * @property {Object|undefined} list
 *           Contains the attributes for the SegmentList node
 * @property {Object|undefined} base
 *           Contains the attributes for the SegmentBase node
 */ /**
 * Returns all available Segment information contained within the AdaptationSet node
 *
 * @param {Node} adaptationSet
 *        The AdaptationSet node to get Segment information from
 * @return {SegmentInformation}
 *         The Segment information contained within the provided AdaptationSet
 */ const $0ffb3c35bf172c1a$var$getSegmentInformation = (adaptationSet)=>{
    const segmentTemplate = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, 'SegmentTemplate')[0];
    const segmentList = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, 'SegmentList')[0];
    const segmentUrls = segmentList && $0ffb3c35bf172c1a$var$findChildren(segmentList, 'SegmentURL').map((s)=>$0ffb3c35bf172c1a$var$merge({
            tag: 'SegmentURL'
        }, $0ffb3c35bf172c1a$var$parseAttributes(s)));
    const segmentBase = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, 'SegmentBase')[0];
    const segmentTimelineParentNode = segmentList || segmentTemplate;
    const segmentTimeline = segmentTimelineParentNode && $0ffb3c35bf172c1a$var$findChildren(segmentTimelineParentNode, 'SegmentTimeline')[0];
    const segmentInitializationParentNode = segmentList || segmentBase || segmentTemplate;
    const segmentInitialization = segmentInitializationParentNode && $0ffb3c35bf172c1a$var$findChildren(segmentInitializationParentNode, 'Initialization')[0]; // SegmentTemplate is handled slightly differently, since it can have both
    // @initialization and an <Initialization> node.  @initialization can be templated,
    // while the node can have a url and range specified.  If the <SegmentTemplate> has
    // both @initialization and an <Initialization> subelement we opt to override with
    // the node, as this interaction is not defined in the spec.
    const template = segmentTemplate && $0ffb3c35bf172c1a$var$parseAttributes(segmentTemplate);
    if (template && segmentInitialization) template.initialization = segmentInitialization && $0ffb3c35bf172c1a$var$parseAttributes(segmentInitialization);
    else if (template && template.initialization) // If it is @initialization we convert it to an object since this is the format that
    // later functions will rely on for the initialization segment.  This is only valid
    // for <SegmentTemplate>
    template.initialization = {
        sourceURL: template.initialization
    };
    const segmentInfo = {
        template: template,
        segmentTimeline: segmentTimeline && $0ffb3c35bf172c1a$var$findChildren(segmentTimeline, 'S').map((s)=>$0ffb3c35bf172c1a$var$parseAttributes(s)),
        list: segmentList && $0ffb3c35bf172c1a$var$merge($0ffb3c35bf172c1a$var$parseAttributes(segmentList), {
            segmentUrls: segmentUrls,
            initialization: $0ffb3c35bf172c1a$var$parseAttributes(segmentInitialization)
        }),
        base: segmentBase && $0ffb3c35bf172c1a$var$merge($0ffb3c35bf172c1a$var$parseAttributes(segmentBase), {
            initialization: $0ffb3c35bf172c1a$var$parseAttributes(segmentInitialization)
        })
    };
    Object.keys(segmentInfo).forEach((key)=>{
        if (!segmentInfo[key]) delete segmentInfo[key];
    });
    return segmentInfo;
};
/**
 * Contains Segment information and attributes needed to construct a Playlist object
 * from a Representation
 *
 * @typedef {Object} RepresentationInformation
 * @property {SegmentInformation} segmentInfo
 *           Segment information for this Representation
 * @property {Object} attributes
 *           Inherited attributes for this Representation
 */ /**
 * Maps a Representation node to an object containing Segment information and attributes
 *
 * @name inheritBaseUrlsCallback
 * @function
 * @param {Node} representation
 *        Representation node from the mpd
 * @return {RepresentationInformation}
 *         Representation information needed to construct a Playlist object
 */ /**
 * Returns a callback for Array.prototype.map for mapping Representation nodes to
 * Segment information and attributes using inherited BaseURL nodes.
 *
 * @param {Object} adaptationSetAttributes
 *        Contains attributes inherited by the AdaptationSet
 * @param {Object[]} adaptationSetBaseUrls
 *        List of objects containing resolved base URLs and attributes
 *        inherited by the AdaptationSet
 * @param {SegmentInformation} adaptationSetSegmentInfo
 *        Contains Segment information for the AdaptationSet
 * @return {inheritBaseUrlsCallback}
 *         Callback map function
 */ const $0ffb3c35bf172c1a$var$inheritBaseUrls = (adaptationSetAttributes, adaptationSetBaseUrls, adaptationSetSegmentInfo)=>(representation)=>{
        const repBaseUrlElements = $0ffb3c35bf172c1a$var$findChildren(representation, 'BaseURL');
        const repBaseUrls = $0ffb3c35bf172c1a$var$buildBaseUrls(adaptationSetBaseUrls, repBaseUrlElements);
        const attributes = $0ffb3c35bf172c1a$var$merge(adaptationSetAttributes, $0ffb3c35bf172c1a$var$parseAttributes(representation));
        const representationSegmentInfo = $0ffb3c35bf172c1a$var$getSegmentInformation(representation);
        return repBaseUrls.map((baseUrl)=>{
            return {
                segmentInfo: $0ffb3c35bf172c1a$var$merge(adaptationSetSegmentInfo, representationSegmentInfo),
                attributes: $0ffb3c35bf172c1a$var$merge(attributes, baseUrl)
            };
        });
    };
/**
 * Tranforms a series of content protection nodes to
 * an object containing pssh data by key system
 *
 * @param {Node[]} contentProtectionNodes
 *        Content protection nodes
 * @return {Object}
 *        Object containing pssh data by key system
 */ const $0ffb3c35bf172c1a$var$generateKeySystemInformation = (contentProtectionNodes)=>{
    return contentProtectionNodes.reduce((acc, node)=>{
        const attributes = $0ffb3c35bf172c1a$var$parseAttributes(node); // Although it could be argued that according to the UUID RFC spec the UUID string (a-f chars) should be generated
        // as a lowercase string it also mentions it should be treated as case-insensitive on input. Since the key system
        // UUIDs in the keySystemsMap are hardcoded as lowercase in the codebase there isn't any reason not to do
        // .toLowerCase() on the input UUID string from the manifest (at least I could not think of one).
        if (attributes.schemeIdUri) attributes.schemeIdUri = attributes.schemeIdUri.toLowerCase();
        const keySystem = $0ffb3c35bf172c1a$var$keySystemsMap[attributes.schemeIdUri];
        if (keySystem) {
            acc[keySystem] = {
                attributes: attributes
            };
            const psshNode = $0ffb3c35bf172c1a$var$findChildren(node, 'cenc:pssh')[0];
            if (psshNode) {
                const pssh = $0ffb3c35bf172c1a$var$getContent(psshNode);
                acc[keySystem].pssh = pssh && (0, $ia8V9.default)(pssh);
            }
        }
        return acc;
    }, {});
}; // defined in ANSI_SCTE 214-1 2016
const $0ffb3c35bf172c1a$var$parseCaptionServiceMetadata = (service)=>{
    // 608 captions
    if (service.schemeIdUri === 'urn:scte:dash:cc:cea-608:2015') {
        const values = typeof service.value !== 'string' ? [] : service.value.split(';');
        return values.map((value)=>{
            let channel;
            let language; // default language to value
            language = value;
            if (/^CC\d=/.test(value)) [channel, language] = value.split('=');
            else if (/^CC\d$/.test(value)) channel = value;
            return {
                channel: channel,
                language: language
            };
        });
    } else if (service.schemeIdUri === 'urn:scte:dash:cc:cea-708:2015') {
        const values = typeof service.value !== 'string' ? [] : service.value.split(';');
        return values.map((value)=>{
            const flags = {
                // service or channel number 1-63
                'channel': undefined,
                // language is a 3ALPHA per ISO 639.2/B
                // field is required
                'language': undefined,
                // BIT 1/0 or ?
                // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
                'aspectRatio': 1,
                // BIT 1/0
                // easy reader flag indicated the text is tailed to the needs of beginning readers
                // default 0, or off
                'easyReader': 0,
                // BIT 1/0
                // If 3d metadata is present (CEA-708.1) then 1
                // default 0
                '3D': 0
            };
            if (/=/.test(value)) {
                const [channel, opts = ''] = value.split('=');
                flags.channel = channel;
                flags.language = value;
                opts.split(',').forEach((opt)=>{
                    const [name, val] = opt.split(':');
                    if (name === 'lang') flags.language = val; // er for easyReadery
                    else if (name === 'er') flags.easyReader = Number(val); // war for wide aspect ratio
                    else if (name === 'war') flags.aspectRatio = Number(val);
                    else if (name === '3D') flags['3D'] = Number(val);
                });
            } else flags.language = value;
            if (flags.channel) flags.channel = 'SERVICE' + flags.channel;
            return flags;
        });
    }
};
/**
 * A map callback that will parse all event stream data for a collection of periods
 * DASH ISO_IEC_23009 5.10.2.2
 * https://dashif-documents.azurewebsites.net/Events/master/event.html#mpd-event-timing
 *
 * @param {PeriodInformation} period object containing necessary period information
 * @return a collection of parsed eventstream event objects
 */ const $0ffb3c35bf172c1a$var$toEventStream = (period)=>{
    // get and flatten all EventStreams tags and parse attributes and children
    return $0ffb3c35bf172c1a$var$flatten($0ffb3c35bf172c1a$var$findChildren(period.node, 'EventStream').map((eventStream)=>{
        const eventStreamAttributes = $0ffb3c35bf172c1a$var$parseAttributes(eventStream);
        const schemeIdUri = eventStreamAttributes.schemeIdUri; // find all Events per EventStream tag and map to return objects
        return $0ffb3c35bf172c1a$var$findChildren(eventStream, 'Event').map((event)=>{
            const eventAttributes = $0ffb3c35bf172c1a$var$parseAttributes(event);
            const presentationTime = eventAttributes.presentationTime || 0;
            const timescale = eventStreamAttributes.timescale || 1;
            const duration = eventAttributes.duration || 0;
            const start = presentationTime / timescale + period.attributes.start;
            return {
                schemeIdUri: schemeIdUri,
                value: eventStreamAttributes.value,
                id: eventAttributes.id,
                start: start,
                end: start + duration / timescale,
                messageData: $0ffb3c35bf172c1a$var$getContent(event) || eventAttributes.messageData,
                contentEncoding: eventStreamAttributes.contentEncoding,
                presentationTimeOffset: eventStreamAttributes.presentationTimeOffset || 0
            };
        });
    }));
};
/**
 * Maps an AdaptationSet node to a list of Representation information objects
 *
 * @name toRepresentationsCallback
 * @function
 * @param {Node} adaptationSet
 *        AdaptationSet node from the mpd
 * @return {RepresentationInformation[]}
 *         List of objects containing Representaion information
 */ /**
 * Returns a callback for Array.prototype.map for mapping AdaptationSet nodes to a list of
 * Representation information objects
 *
 * @param {Object} periodAttributes
 *        Contains attributes inherited by the Period
 * @param {Object[]} periodBaseUrls
 *        Contains list of objects with resolved base urls and attributes
 *        inherited by the Period
 * @param {string[]} periodSegmentInfo
 *        Contains Segment Information at the period level
 * @return {toRepresentationsCallback}
 *         Callback map function
 */ const $0ffb3c35bf172c1a$var$toRepresentations = (periodAttributes, periodBaseUrls, periodSegmentInfo)=>(adaptationSet)=>{
        const adaptationSetAttributes = $0ffb3c35bf172c1a$var$parseAttributes(adaptationSet);
        const adaptationSetBaseUrls = $0ffb3c35bf172c1a$var$buildBaseUrls(periodBaseUrls, $0ffb3c35bf172c1a$var$findChildren(adaptationSet, 'BaseURL'));
        const role = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, 'Role')[0];
        const roleAttributes = {
            role: $0ffb3c35bf172c1a$var$parseAttributes(role)
        };
        let attrs = $0ffb3c35bf172c1a$var$merge(periodAttributes, adaptationSetAttributes, roleAttributes);
        const accessibility = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, 'Accessibility')[0];
        const captionServices = $0ffb3c35bf172c1a$var$parseCaptionServiceMetadata($0ffb3c35bf172c1a$var$parseAttributes(accessibility));
        if (captionServices) attrs = $0ffb3c35bf172c1a$var$merge(attrs, {
            captionServices: captionServices
        });
        const label = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, 'Label')[0];
        if (label && label.childNodes.length) {
            const labelVal = label.childNodes[0].nodeValue.trim();
            attrs = $0ffb3c35bf172c1a$var$merge(attrs, {
                label: labelVal
            });
        }
        const contentProtection = $0ffb3c35bf172c1a$var$generateKeySystemInformation($0ffb3c35bf172c1a$var$findChildren(adaptationSet, 'ContentProtection'));
        if (Object.keys(contentProtection).length) attrs = $0ffb3c35bf172c1a$var$merge(attrs, {
            contentProtection: contentProtection
        });
        const segmentInfo = $0ffb3c35bf172c1a$var$getSegmentInformation(adaptationSet);
        const representations = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, 'Representation');
        const adaptationSetSegmentInfo = $0ffb3c35bf172c1a$var$merge(periodSegmentInfo, segmentInfo);
        return $0ffb3c35bf172c1a$var$flatten(representations.map($0ffb3c35bf172c1a$var$inheritBaseUrls(attrs, adaptationSetBaseUrls, adaptationSetSegmentInfo)));
    };
/**
 * Contains all period information for mapping nodes onto adaptation sets.
 *
 * @typedef {Object} PeriodInformation
 * @property {Node} period.node
 *           Period node from the mpd
 * @property {Object} period.attributes
 *           Parsed period attributes from node plus any added
 */ /**
 * Maps a PeriodInformation object to a list of Representation information objects for all
 * AdaptationSet nodes contained within the Period.
 *
 * @name toAdaptationSetsCallback
 * @function
 * @param {PeriodInformation} period
 *        Period object containing necessary period information
 * @param {number} periodStart
 *        Start time of the Period within the mpd
 * @return {RepresentationInformation[]}
 *         List of objects containing Representaion information
 */ /**
 * Returns a callback for Array.prototype.map for mapping Period nodes to a list of
 * Representation information objects
 *
 * @param {Object} mpdAttributes
 *        Contains attributes inherited by the mpd
  * @param {Object[]} mpdBaseUrls
 *        Contains list of objects with resolved base urls and attributes
 *        inherited by the mpd
 * @return {toAdaptationSetsCallback}
 *         Callback map function
 */ const $0ffb3c35bf172c1a$var$toAdaptationSets = (mpdAttributes, mpdBaseUrls)=>(period, index)=>{
        const periodBaseUrls = $0ffb3c35bf172c1a$var$buildBaseUrls(mpdBaseUrls, $0ffb3c35bf172c1a$var$findChildren(period.node, 'BaseURL'));
        const periodAttributes = $0ffb3c35bf172c1a$var$merge(mpdAttributes, {
            periodStart: period.attributes.start
        });
        if (typeof period.attributes.duration === 'number') periodAttributes.periodDuration = period.attributes.duration;
        const adaptationSets = $0ffb3c35bf172c1a$var$findChildren(period.node, 'AdaptationSet');
        const periodSegmentInfo = $0ffb3c35bf172c1a$var$getSegmentInformation(period.node);
        return $0ffb3c35bf172c1a$var$flatten(adaptationSets.map($0ffb3c35bf172c1a$var$toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo)));
    };
/**
 * Tranforms an array of content steering nodes into an object
 * containing CDN content steering information from the MPD manifest.
 *
 * For more information on the DASH spec for Content Steering parsing, see:
 * https://dashif.org/docs/DASH-IF-CTS-00XX-Content-Steering-Community-Review.pdf
 *
 * @param {Node[]} contentSteeringNodes
 *        Content steering nodes
 * @param {Function} eventHandler
 *        The event handler passed into the parser options to handle warnings
 * @return {Object}
 *        Object containing content steering data
 */ const $0ffb3c35bf172c1a$var$generateContentSteeringInformation = (contentSteeringNodes, eventHandler)=>{
    // If there are more than one ContentSteering tags, throw an error
    if (contentSteeringNodes.length > 1) eventHandler({
        type: 'warn',
        message: 'The MPD manifest should contain no more than one ContentSteering tag'
    });
     // Return a null value if there are no ContentSteering tags
    if (!contentSteeringNodes.length) return null;
    const infoFromContentSteeringTag = $0ffb3c35bf172c1a$var$merge({
        serverURL: $0ffb3c35bf172c1a$var$getContent(contentSteeringNodes[0])
    }, $0ffb3c35bf172c1a$var$parseAttributes(contentSteeringNodes[0])); // Converts `queryBeforeStart` to a boolean, as well as setting the default value
    // to `false` if it doesn't exist
    infoFromContentSteeringTag.queryBeforeStart = infoFromContentSteeringTag.queryBeforeStart === 'true';
    return infoFromContentSteeringTag;
};
/**
 * Gets Period@start property for a given period.
 *
 * @param {Object} options
 *        Options object
 * @param {Object} options.attributes
 *        Period attributes
 * @param {Object} [options.priorPeriodAttributes]
 *        Prior period attributes (if prior period is available)
 * @param {string} options.mpdType
 *        The MPD@type these periods came from
 * @return {number|null}
 *         The period start, or null if it's an early available period or error
 */ const $0ffb3c35bf172c1a$var$getPeriodStart = ({ attributes: attributes, priorPeriodAttributes: priorPeriodAttributes, mpdType: mpdType })=>{
    // Summary of period start time calculation from DASH spec section 5.3.2.1
    //
    // A period's start is the first period's start + time elapsed after playing all
    // prior periods to this one. Periods continue one after the other in time (without
    // gaps) until the end of the presentation.
    //
    // The value of Period@start should be:
    // 1. if Period@start is present: value of Period@start
    // 2. if previous period exists and it has @duration: previous Period@start +
    //    previous Period@duration
    // 3. if this is first period and MPD@type is 'static': 0
    // 4. in all other cases, consider the period an "early available period" (note: not
    //    currently supported)
    // (1)
    if (typeof attributes.start === 'number') return attributes.start;
     // (2)
    if (priorPeriodAttributes && typeof priorPeriodAttributes.start === 'number' && typeof priorPeriodAttributes.duration === 'number') return priorPeriodAttributes.start + priorPeriodAttributes.duration;
     // (3)
    if (!priorPeriodAttributes && mpdType === 'static') return 0;
     // (4)
    // There is currently no logic for calculating the Period@start value if there is
    // no Period@start or prior Period@start and Period@duration available. This is not made
    // explicit by the DASH interop guidelines or the DASH spec, however, since there's
    // nothing about any other resolution strategies, it's implied. Thus, this case should
    // be considered an early available period, or error, and null should suffice for both
    // of those cases.
    return null;
};
/**
 * Traverses the mpd xml tree to generate a list of Representation information objects
 * that have inherited attributes from parent nodes
 *
 * @param {Node} mpd
 *        The root node of the mpd
 * @param {Object} options
 *        Available options for inheritAttributes
 * @param {string} options.manifestUri
 *        The uri source of the mpd
 * @param {number} options.NOW
 *        Current time per DASH IOP.  Default is current time in ms since epoch
 * @param {number} options.clientOffset
 *        Client time difference from NOW (in milliseconds)
 * @return {RepresentationInformation[]}
 *         List of objects containing Representation information
 */ const $0ffb3c35bf172c1a$export$1d58e194e30f14d4 = (mpd, options = {})=>{
    const { manifestUri: manifestUri = '', NOW: NOW = Date.now(), clientOffset: clientOffset = 0, eventHandler: // TODO: For now, we are expecting an eventHandler callback function
    // to be passed into the mpd parser as an option.
    // In the future, we should enable stream parsing by using the Stream class from vhs-utils.
    // This will support new features including a standardized event handler.
    // See the m3u8 parser for examples of how stream parsing is currently used for HLS parsing.
    // https://github.com/videojs/vhs-utils/blob/88d6e10c631e57a5af02c5a62bc7376cd456b4f5/src/stream.js#L9
    eventHandler = function() {} } = options;
    const periodNodes = $0ffb3c35bf172c1a$var$findChildren(mpd, 'Period');
    if (!periodNodes.length) throw new Error($0ffb3c35bf172c1a$var$errors.INVALID_NUMBER_OF_PERIOD);
    const locations = $0ffb3c35bf172c1a$var$findChildren(mpd, 'Location');
    const mpdAttributes = $0ffb3c35bf172c1a$var$parseAttributes(mpd);
    const mpdBaseUrls = $0ffb3c35bf172c1a$var$buildBaseUrls([
        {
            baseUrl: manifestUri
        }
    ], $0ffb3c35bf172c1a$var$findChildren(mpd, 'BaseURL'));
    const contentSteeringNodes = $0ffb3c35bf172c1a$var$findChildren(mpd, 'ContentSteering'); // See DASH spec section 5.3.1.2, Semantics of MPD element. Default type to 'static'.
    mpdAttributes.type = mpdAttributes.type || 'static';
    mpdAttributes.sourceDuration = mpdAttributes.mediaPresentationDuration || 0;
    mpdAttributes.NOW = NOW;
    mpdAttributes.clientOffset = clientOffset;
    if (locations.length) mpdAttributes.locations = locations.map($0ffb3c35bf172c1a$var$getContent);
    const periods = []; // Since toAdaptationSets acts on individual periods right now, the simplest approach to
    // adding properties that require looking at prior periods is to parse attributes and add
    // missing ones before toAdaptationSets is called. If more such properties are added, it
    // may be better to refactor toAdaptationSets.
    periodNodes.forEach((node, index)=>{
        const attributes = $0ffb3c35bf172c1a$var$parseAttributes(node); // Use the last modified prior period, as it may contain added information necessary
        // for this period.
        const priorPeriod = periods[index - 1];
        attributes.start = $0ffb3c35bf172c1a$var$getPeriodStart({
            attributes: attributes,
            priorPeriodAttributes: priorPeriod ? priorPeriod.attributes : null,
            mpdType: mpdAttributes.type
        });
        periods.push({
            node: node,
            attributes: attributes
        });
    });
    return {
        locations: mpdAttributes.locations,
        contentSteeringInfo: $0ffb3c35bf172c1a$var$generateContentSteeringInformation(contentSteeringNodes, eventHandler),
        // TODO: There are occurences where this `representationInfo` array contains undesired
        // duplicates. This generally occurs when there are multiple BaseURL nodes that are
        // direct children of the MPD node. When we attempt to resolve URLs from a combination of the
        // parent BaseURL and a child BaseURL, and the value does not resolve,
        // we end up returning the child BaseURL multiple times.
        // We need to determine a way to remove these duplicates in a safe way.
        // See: https://github.com/videojs/mpd-parser/pull/17#discussion_r162750527
        representationInfo: $0ffb3c35bf172c1a$var$flatten(periods.map($0ffb3c35bf172c1a$var$toAdaptationSets(mpdAttributes, mpdBaseUrls))),
        eventStream: $0ffb3c35bf172c1a$var$flatten(periods.map($0ffb3c35bf172c1a$var$toEventStream))
    };
};
const $0ffb3c35bf172c1a$export$d9d51d4eae920a2a = (manifestString)=>{
    if (manifestString === '') throw new Error($0ffb3c35bf172c1a$var$errors.DASH_EMPTY_MANIFEST);
    const parser = new (0, $6YUDA.DOMParser)();
    let xml;
    let mpd;
    try {
        xml = parser.parseFromString(manifestString, 'application/xml');
        mpd = xml && xml.documentElement.tagName === 'MPD' ? xml.documentElement : null;
    } catch (e) {}
    if (!mpd || mpd && mpd.getElementsByTagName('parsererror').length > 0) throw new Error($0ffb3c35bf172c1a$var$errors.DASH_INVALID_XML);
    return mpd;
};
/**
 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
 *
 * @param {string} mpd
 *        XML string of the MPD manifest
 * @return {Object|null}
 *         Attributes of UTCTiming node specified in the manifest. Null if none found
 */ const $0ffb3c35bf172c1a$var$parseUTCTimingScheme = (mpd)=>{
    const UTCTimingNode = $0ffb3c35bf172c1a$var$findChildren(mpd, 'UTCTiming')[0];
    if (!UTCTimingNode) return null;
    const attributes = $0ffb3c35bf172c1a$var$parseAttributes(UTCTimingNode);
    switch(attributes.schemeIdUri){
        case 'urn:mpeg:dash:utc:http-head:2014':
        case 'urn:mpeg:dash:utc:http-head:2012':
            attributes.method = 'HEAD';
            break;
        case 'urn:mpeg:dash:utc:http-xsdate:2014':
        case 'urn:mpeg:dash:utc:http-iso:2014':
        case 'urn:mpeg:dash:utc:http-xsdate:2012':
        case 'urn:mpeg:dash:utc:http-iso:2012':
            attributes.method = 'GET';
            break;
        case 'urn:mpeg:dash:utc:direct:2014':
        case 'urn:mpeg:dash:utc:direct:2012':
            attributes.method = 'DIRECT';
            attributes.value = Date.parse(attributes.value);
            break;
        case 'urn:mpeg:dash:utc:http-ntp:2014':
        case 'urn:mpeg:dash:utc:ntp:2014':
        case 'urn:mpeg:dash:utc:sntp:2014':
        default:
            throw new Error($0ffb3c35bf172c1a$var$errors.UNSUPPORTED_UTC_TIMING_SCHEME);
    }
    return attributes;
};
const $0ffb3c35bf172c1a$export$a4ad2735b021c132 = $0ffb3c35bf172c1a$var$version;
/*
 * Given a DASH manifest string and options, parses the DASH manifest into an object in the
 * form outputed by m3u8-parser and accepted by videojs/http-streaming.
 *
 * For live DASH manifests, if `previousManifest` is provided in options, then the newly
 * parsed DASH manifest will have its media sequence and discontinuity sequence values
 * updated to reflect its position relative to the prior manifest.
 *
 * @param {string} manifestString - the DASH manifest as a string
 * @param {options} [options] - any options
 *
 * @return {Object} the manifest object
 */ const $0ffb3c35bf172c1a$export$98e6a39c04603d36 = (manifestString, options = {})=>{
    const parsedManifestInfo = $0ffb3c35bf172c1a$export$1d58e194e30f14d4($0ffb3c35bf172c1a$export$d9d51d4eae920a2a(manifestString), options);
    const playlists = $0ffb3c35bf172c1a$export$4362d710904f703f(parsedManifestInfo.representationInfo);
    return $0ffb3c35bf172c1a$export$c90e7d9f067c8f2c({
        dashPlaylists: playlists,
        locations: parsedManifestInfo.locations,
        contentSteering: parsedManifestInfo.contentSteeringInfo,
        sidxMapping: options.sidxMapping,
        previousManifest: options.previousManifest,
        eventStream: parsedManifestInfo.eventStream
    });
};
/**
 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
 *
 * @param {string} manifestString
 *        XML string of the MPD manifest
 * @return {Object|null}
 *         Attributes of UTCTiming node specified in the manifest. Null if none found
 */ const $0ffb3c35bf172c1a$export$734c7278b5d0068c = (manifestString)=>$0ffb3c35bf172c1a$var$parseUTCTimingScheme($0ffb3c35bf172c1a$export$d9d51d4eae920a2a(manifestString));

});
parcelRegister("e96ds", function(module, exports) {

$parcel$export(module.exports, "forEachMediaGroup", () => $a4c6ba5b765bba9d$export$308de5e7fb801aab);
/**
 * Loops through all supported media groups in master and calls the provided
 * callback for each group
 *
 * @param {Object} master
 *        The parsed master manifest object
 * @param {string[]} groups
 *        The media groups to call the callback for
 * @param {Function} callback
 *        Callback to call for each media group
 */ var $a4c6ba5b765bba9d$export$308de5e7fb801aab = function forEachMediaGroup(master, groups, callback) {
    groups.forEach(function(mediaType) {
        for(var groupKey in master.mediaGroups[mediaType])for(var labelKey in master.mediaGroups[mediaType][groupKey]){
            var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
            callback(mediaProperties, mediaType, groupKey, labelKey);
        }
    });
};

});

parcelRegister("6YUDA", function(module, exports) {

$parcel$export(module.exports, "DOMParser", () => $515447b9158f86cb$export$1059c6e7d2ce5669, (v) => $515447b9158f86cb$export$1059c6e7d2ce5669 = v);
var $515447b9158f86cb$export$455426655eab1d48;
var $515447b9158f86cb$export$64f0bed4ae6f0f24;
var $515447b9158f86cb$export$1059c6e7d2ce5669;

var $2YubT = parcelRequire("2YubT");
$515447b9158f86cb$export$455426655eab1d48 = $2YubT.DOMImplementation;
$515447b9158f86cb$export$64f0bed4ae6f0f24 = $2YubT.XMLSerializer;

$515447b9158f86cb$export$1059c6e7d2ce5669 = (parcelRequire("c1Wy2")).DOMParser;

});
parcelRegister("2YubT", function(module, exports) {

$parcel$export(module.exports, "DOMImplementation", () => $22a89a9d1d5ce29e$export$455426655eab1d48, (v) => $22a89a9d1d5ce29e$export$455426655eab1d48 = v);
$parcel$export(module.exports, "XMLSerializer", () => $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24, (v) => $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24 = v);
//if(typeof require == 'function'){
var $22a89a9d1d5ce29e$export$d1d99cf900472499;
var $22a89a9d1d5ce29e$export$fe58bcf938607f6a;
var $22a89a9d1d5ce29e$export$455426655eab1d48;
var $22a89a9d1d5ce29e$export$db77ccec0bb4ccac;
var $22a89a9d1d5ce29e$export$85c928794f8d04d4;
var $22a89a9d1d5ce29e$export$79b41aa5d56abdff;
var $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24;

var $hkG9E = parcelRequire("hkG9E");
var $22a89a9d1d5ce29e$var$find = $hkG9E.find;
var $22a89a9d1d5ce29e$var$NAMESPACE = $hkG9E.NAMESPACE;
/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$notEmptyString(input) {
    return input !== '';
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */ function $22a89a9d1d5ce29e$var$splitOnASCIIWhitespace(input) {
    // U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
    return input ? input.split(/[\t\n\f\r ]+/).filter($22a89a9d1d5ce29e$var$notEmptyString) : [];
}
/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */ function $22a89a9d1d5ce29e$var$orderedSetReducer(current, element) {
    if (!current.hasOwnProperty(element)) current[element] = true;
    return current;
}
/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */ function $22a89a9d1d5ce29e$var$toOrderedSet(input) {
    if (!input) return [];
    var list = $22a89a9d1d5ce29e$var$splitOnASCIIWhitespace(input);
    return Object.keys(list.reduce($22a89a9d1d5ce29e$var$orderedSetReducer, {}));
}
/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */ function $22a89a9d1d5ce29e$var$arrayIncludes(list) {
    return function(element) {
        return list && list.indexOf(element) !== -1;
    };
}
function $22a89a9d1d5ce29e$var$copy(src, dest) {
    for(var p in src)if (Object.prototype.hasOwnProperty.call(src, p)) dest[p] = src[p];
}
/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */ function $22a89a9d1d5ce29e$var$_extends(Class, Super) {
    var pt = Class.prototype;
    if (!(pt instanceof Super)) {
        function t() {}
        t.prototype = Super.prototype;
        t = new t();
        $22a89a9d1d5ce29e$var$copy(pt, t);
        Class.prototype = pt = t;
    }
    if (pt.constructor != Class) {
        if (typeof Class != 'function') console.error("unknown Class:" + Class);
        pt.constructor = Class;
    }
}
// Node Types
var $22a89a9d1d5ce29e$var$NodeType = {};
var $22a89a9d1d5ce29e$var$ELEMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.ELEMENT_NODE = 1;
var $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE = $22a89a9d1d5ce29e$var$NodeType.ATTRIBUTE_NODE = 2;
var $22a89a9d1d5ce29e$var$TEXT_NODE = $22a89a9d1d5ce29e$var$NodeType.TEXT_NODE = 3;
var $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE = $22a89a9d1d5ce29e$var$NodeType.CDATA_SECTION_NODE = 4;
var $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE = $22a89a9d1d5ce29e$var$NodeType.ENTITY_REFERENCE_NODE = 5;
var $22a89a9d1d5ce29e$var$ENTITY_NODE = $22a89a9d1d5ce29e$var$NodeType.ENTITY_NODE = 6;
var $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE = $22a89a9d1d5ce29e$var$NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var $22a89a9d1d5ce29e$var$COMMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.COMMENT_NODE = 8;
var $22a89a9d1d5ce29e$var$DOCUMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_NODE = 9;
var $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_TYPE_NODE = 10;
var $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var $22a89a9d1d5ce29e$var$NOTATION_NODE = $22a89a9d1d5ce29e$var$NodeType.NOTATION_NODE = 12;
// ExceptionCode
var $22a89a9d1d5ce29e$var$ExceptionCode = {};
var $22a89a9d1d5ce29e$var$ExceptionMessage = {};
var $22a89a9d1d5ce29e$var$INDEX_SIZE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INDEX_SIZE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[1] = "Index size error", 1);
var $22a89a9d1d5ce29e$var$DOMSTRING_SIZE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.DOMSTRING_SIZE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[2] = "DOMString size error", 2);
var $22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.HIERARCHY_REQUEST_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[3] = "Hierarchy request error", 3);
var $22a89a9d1d5ce29e$var$WRONG_DOCUMENT_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.WRONG_DOCUMENT_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[4] = "Wrong document", 4);
var $22a89a9d1d5ce29e$var$INVALID_CHARACTER_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_CHARACTER_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[5] = "Invalid character", 5);
var $22a89a9d1d5ce29e$var$NO_DATA_ALLOWED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NO_DATA_ALLOWED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[6] = "No data allowed", 6);
var $22a89a9d1d5ce29e$var$NO_MODIFICATION_ALLOWED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[7] = "No modification allowed", 7);
var $22a89a9d1d5ce29e$var$NOT_FOUND_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NOT_FOUND_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[8] = "Not found", 8);
var $22a89a9d1d5ce29e$var$NOT_SUPPORTED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NOT_SUPPORTED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[9] = "Not supported", 9);
var $22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INUSE_ATTRIBUTE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[10] = "Attribute in use", 10);
//level2
var $22a89a9d1d5ce29e$var$INVALID_STATE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_STATE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[11] = "Invalid state", 11);
var $22a89a9d1d5ce29e$var$SYNTAX_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.SYNTAX_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[12] = "Syntax error", 12);
var $22a89a9d1d5ce29e$var$INVALID_MODIFICATION_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_MODIFICATION_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[13] = "Invalid modification", 13);
var $22a89a9d1d5ce29e$var$NAMESPACE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NAMESPACE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[14] = "Invalid namespace", 14);
var $22a89a9d1d5ce29e$var$INVALID_ACCESS_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_ACCESS_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[15] = "Invalid access", 15);
/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */ function $22a89a9d1d5ce29e$var$DOMException(code, message) {
    if (message instanceof Error) var error = message;
    else {
        error = this;
        Error.call(this, $22a89a9d1d5ce29e$var$ExceptionMessage[code]);
        this.message = $22a89a9d1d5ce29e$var$ExceptionMessage[code];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $22a89a9d1d5ce29e$var$DOMException);
    }
    error.code = code;
    if (message) this.message = this.message + ": " + message;
    return error;
}
$22a89a9d1d5ce29e$var$DOMException.prototype = Error.prototype;
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$ExceptionCode, $22a89a9d1d5ce29e$var$DOMException);
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */ function $22a89a9d1d5ce29e$var$NodeList() {}
$22a89a9d1d5ce29e$var$NodeList.prototype = {
    /**
	 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
	 * @standard level1
	 */ length: 0,
    /**
	 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
	 * @standard level1
	 * @param index  unsigned long
	 *   Index into the collection.
	 * @return Node
	 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
	 */ item: function(index) {
        return index >= 0 && index < this.length ? this[index] : null;
    },
    toString: function(isHTML, nodeFilter) {
        for(var buf = [], i = 0; i < this.length; i++)$22a89a9d1d5ce29e$var$serializeToString(this[i], buf, isHTML, nodeFilter);
        return buf.join('');
    },
    /**
	 * @private
	 * @param {function (Node):boolean} predicate
	 * @returns {Node[]}
	 */ filter: function(predicate) {
        return Array.prototype.filter.call(this, predicate);
    },
    /**
	 * @private
	 * @param {Node} item
	 * @returns {number}
	 */ indexOf: function(item) {
        return Array.prototype.indexOf.call(this, item);
    }
};
function $22a89a9d1d5ce29e$var$LiveNodeList(node, refresh) {
    this._node = node;
    this._refresh = refresh;
    $22a89a9d1d5ce29e$var$_updateLiveList(this);
}
function $22a89a9d1d5ce29e$var$_updateLiveList(list) {
    var inc = list._node._inc || list._node.ownerDocument._inc;
    if (list._inc !== inc) {
        var ls = list._refresh(list._node);
        $22a89a9d1d5ce29e$var$__set__(list, 'length', ls.length);
        if (!list.$$length || ls.length < list.$$length) {
            for(var i = ls.length; i in list; i++)if (Object.prototype.hasOwnProperty.call(list, i)) delete list[i];
        }
        $22a89a9d1d5ce29e$var$copy(ls, list);
        list._inc = inc;
    }
}
$22a89a9d1d5ce29e$var$LiveNodeList.prototype.item = function(i) {
    $22a89a9d1d5ce29e$var$_updateLiveList(this);
    return this[i] || null;
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$LiveNodeList, $22a89a9d1d5ce29e$var$NodeList);
/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */ function $22a89a9d1d5ce29e$var$NamedNodeMap() {}
function $22a89a9d1d5ce29e$var$_findNodeIndex(list, node) {
    var i = list.length;
    while(i--){
        if (list[i] === node) return i;
    }
}
function $22a89a9d1d5ce29e$var$_addNamedNode(el, list, newAttr, oldAttr) {
    if (oldAttr) list[$22a89a9d1d5ce29e$var$_findNodeIndex(list, oldAttr)] = newAttr;
    else list[list.length++] = newAttr;
    if (el) {
        newAttr.ownerElement = el;
        var doc = el.ownerDocument;
        if (doc) {
            oldAttr && $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, oldAttr);
            $22a89a9d1d5ce29e$var$_onAddAttribute(doc, el, newAttr);
        }
    }
}
function $22a89a9d1d5ce29e$var$_removeNamedNode(el, list, attr) {
    //console.log('remove attr:'+attr)
    var i = $22a89a9d1d5ce29e$var$_findNodeIndex(list, attr);
    if (i >= 0) {
        var lastIndex = list.length - 1;
        while(i < lastIndex)list[i] = list[++i];
        list.length = lastIndex;
        if (el) {
            var doc = el.ownerDocument;
            if (doc) {
                $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, attr);
                attr.ownerElement = null;
            }
        }
    } else throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$NOT_FOUND_ERR, new Error(el.tagName + '@' + attr));
}
$22a89a9d1d5ce29e$var$NamedNodeMap.prototype = {
    length: 0,
    item: $22a89a9d1d5ce29e$var$NodeList.prototype.item,
    getNamedItem: function(key) {
        //		if(key.indexOf(':')>0 || key == 'xmlns'){
        //			return null;
        //		}
        //console.log()
        var i = this.length;
        while(i--){
            var attr = this[i];
            //console.log(attr.nodeName,key)
            if (attr.nodeName == key) return attr;
        }
    },
    setNamedItem: function(attr) {
        var el = attr.ownerElement;
        if (el && el != this._ownerElement) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR);
        var oldAttr = this.getNamedItem(attr.nodeName);
        $22a89a9d1d5ce29e$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ setNamedItemNS: function(attr) {
        var el = attr.ownerElement, oldAttr;
        if (el && el != this._ownerElement) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR);
        oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
        $22a89a9d1d5ce29e$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ removeNamedItem: function(key) {
        var attr = this.getNamedItem(key);
        $22a89a9d1d5ce29e$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    //for level2
    removeNamedItemNS: function(namespaceURI, localName) {
        var attr = this.getNamedItemNS(namespaceURI, localName);
        $22a89a9d1d5ce29e$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    getNamedItemNS: function(namespaceURI, localName) {
        var i = this.length;
        while(i--){
            var node = this[i];
            if (node.localName == localName && node.namespaceURI == namespaceURI) return node;
        }
        return null;
    }
};
/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */ function $22a89a9d1d5ce29e$var$DOMImplementation() {}
$22a89a9d1d5ce29e$var$DOMImplementation.prototype = {
    /**
	 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
	 * The different implementations fairly diverged in what kind of features were reported.
	 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
	 *
	 * @deprecated It is deprecated and modern browsers return true in all cases.
	 *
	 * @param {string} feature
	 * @param {string} [version]
	 * @returns {boolean} always true
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
	 */ hasFeature: function(feature, version) {
        return true;
    },
    /**
	 * Creates an XML Document object of the specified type with its document element.
	 *
	 * __It behaves slightly different from the description in the living standard__:
	 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
	 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string|null} namespaceURI
	 * @param {string} qualifiedName
	 * @param {DocumentType=null} doctype
	 * @returns {Document}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocument: function(namespaceURI, qualifiedName, doctype) {
        var doc = new $22a89a9d1d5ce29e$var$Document();
        doc.implementation = this;
        doc.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        doc.doctype = doctype || null;
        if (doctype) doc.appendChild(doctype);
        if (qualifiedName) {
            var root = doc.createElementNS(namespaceURI, qualifiedName);
            doc.appendChild(root);
        }
        return doc;
    },
    /**
	 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
	 *
	 * __This behavior is slightly different from the in the specs__:
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string} qualifiedName
	 * @param {string} [publicId]
	 * @param {string} [systemId]
	 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
	 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocumentType: function(qualifiedName, publicId, systemId) {
        var node = new $22a89a9d1d5ce29e$var$DocumentType();
        node.name = qualifiedName;
        node.nodeName = qualifiedName;
        node.publicId = publicId || '';
        node.systemId = systemId || '';
        return node;
    }
};
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */ function $22a89a9d1d5ce29e$var$Node() {}
$22a89a9d1d5ce29e$var$Node.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(newChild, refChild) {
        return $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, refChild);
    },
    replaceChild: function(newChild, oldChild) {
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, oldChild, $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument);
        if (oldChild) this.removeChild(oldChild);
    },
    removeChild: function(oldChild) {
        return $22a89a9d1d5ce29e$var$_removeChild(this, oldChild);
    },
    appendChild: function(newChild) {
        return this.insertBefore(newChild, null);
    },
    hasChildNodes: function() {
        return this.firstChild != null;
    },
    cloneNode: function(deep) {
        return $22a89a9d1d5ce29e$var$cloneNode(this.ownerDocument || this, this, deep);
    },
    // Modified in DOM Level 2:
    normalize: function() {
        var child = this.firstChild;
        while(child){
            var next = child.nextSibling;
            if (next && next.nodeType == $22a89a9d1d5ce29e$var$TEXT_NODE && child.nodeType == $22a89a9d1d5ce29e$var$TEXT_NODE) {
                this.removeChild(next);
                child.appendData(next.data);
            } else {
                child.normalize();
                child = next;
            }
        }
    },
    // Introduced in DOM Level 2:
    isSupported: function(feature, version) {
        return this.ownerDocument.implementation.hasFeature(feature, version);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
        return this.attributes.length > 0;
    },
    /**
	 * Look up the prefix associated to the given namespace URI, starting from this node.
	 * **The default namespace declarations are ignored by this method.**
	 * See Namespace Prefix Lookup for details on the algorithm used by this method.
	 *
	 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
	 *
	 * @param {string | null} namespaceURI
	 * @returns {string | null}
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
	 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
	 * @see https://github.com/xmldom/xmldom/issues/322
	 */ lookupPrefix: function(namespaceURI) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) for(var n in map){
                if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) return n;
            }
            el = el.nodeType == $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(prefix) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) {
                if (Object.prototype.hasOwnProperty.call(map, prefix)) return map[prefix];
            }
            el = el.nodeType == $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(namespaceURI) {
        var prefix = this.lookupPrefix(namespaceURI);
        return prefix == null;
    }
};
function $22a89a9d1d5ce29e$var$_xmlEncoder(c) {
    return c == '<' && '&lt;' || c == '>' && '&gt;' || c == '&' && '&amp;' || c == '"' && '&quot;' || '&#' + c.charCodeAt() + ';';
}
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$NodeType, $22a89a9d1d5ce29e$var$Node);
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$NodeType, $22a89a9d1d5ce29e$var$Node.prototype);
/**
 * @param callback return true for continue,false for break
 * @return boolean true: break visit;
 */ function $22a89a9d1d5ce29e$var$_visitNode(node, callback) {
    if (callback(node)) return true;
    if (node = node.firstChild) do {
        if ($22a89a9d1d5ce29e$var$_visitNode(node, callback)) return true;
    }while (node = node.nextSibling);
}
function $22a89a9d1d5ce29e$var$Document() {
    this.ownerDocument = this;
}
function $22a89a9d1d5ce29e$var$_onAddAttribute(doc, el, newAttr) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) //update namespace
    el._nsMap[newAttr.prefix ? newAttr.localName : ''] = newAttr.value;
}
function $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, newAttr, remove) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) //update namespace
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ''];
}
/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */ function $22a89a9d1d5ce29e$var$_onUpdateChild(doc, el, newChild) {
    if (doc && doc._inc) {
        doc._inc++;
        //update childNodes
        var cs = el.childNodes;
        if (newChild) cs[cs.length++] = newChild;
        else {
            var child = el.firstChild;
            var i = 0;
            while(child){
                cs[i++] = child;
                child = child.nextSibling;
            }
            cs.length = i;
            delete cs[cs.length];
        }
    }
}
/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */ function $22a89a9d1d5ce29e$var$_removeChild(parentNode, child) {
    var previous = child.previousSibling;
    var next = child.nextSibling;
    if (previous) previous.nextSibling = next;
    else parentNode.firstChild = next;
    if (next) next.previousSibling = previous;
    else parentNode.lastChild = previous;
    child.parentNode = null;
    child.previousSibling = null;
    child.nextSibling = null;
    $22a89a9d1d5ce29e$var$_onUpdateChild(parentNode.ownerDocument, parentNode);
    return child;
}
/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$hasValidParentNodeType(node) {
    return node && (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.ELEMENT_NODE);
}
/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$hasInsertableNodeType(node) {
    return node && ($22a89a9d1d5ce29e$var$isElementNode(node) || $22a89a9d1d5ce29e$var$isTextNode(node) || $22a89a9d1d5ce29e$var$isDocTypeNode(node) || node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.COMMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.PROCESSING_INSTRUCTION_NODE);
}
/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isDocTypeNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_TYPE_NODE;
}
/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isElementNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isTextNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.TEXT_NODE;
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$isElementInsertionPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    if ($22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode) || $22a89a9d1d5ce29e$var$isDocTypeNode(child)) return false;
    var docTypeNode = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$isElementReplacementPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    function hasElementChildThatIsNotChild(node) {
        return $22a89a9d1d5ce29e$var$isElementNode(node) && node !== child;
    }
    if ($22a89a9d1d5ce29e$var$find(parentChildNodes, hasElementChildThatIsNotChild)) return false;
    var docTypeNode = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreInsertionValidity1to5(parent, node, child) {
    // 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
    if (!$22a89a9d1d5ce29e$var$hasValidParentNodeType(parent)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
    // 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
    // not implemented!
    // 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
    if (child && child.parentNode !== parent) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$NOT_FOUND_ERR, 'child not in parent');
    if (// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !$22a89a9d1d5ce29e$var$hasInsertableNodeType(node) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    $22a89a9d1d5ce29e$var$isDocTypeNode(node) && parent.nodeType !== $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType);
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreInsertionValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($22a89a9d1d5ce29e$var$isElementNode);
        // If node has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $22a89a9d1d5ce29e$var$find(nodeChildNodes, $22a89a9d1d5ce29e$var$isTextNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child,
        // `child` is a doctype, or `child` is non-null and a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$22a89a9d1d5ce29e$var$isElementInsertionPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($22a89a9d1d5ce29e$var$isElementNode(node)) {
        // `parent` has an element child, `child` is a doctype,
        // or `child` is non-null and a doctype is following `child`.
        if (!$22a89a9d1d5ce29e$var$isElementInsertionPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($22a89a9d1d5ce29e$var$isDocTypeNode(node)) {
        // `parent` has a doctype child,
        if ($22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode);
        // `child` is non-null and an element is preceding `child`,
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
        // or `child` is null and `parent` has an element child.
        if (!child && parentElementChild) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
    }
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($22a89a9d1d5ce29e$var$isElementNode);
        // If `node` has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $22a89a9d1d5ce29e$var$find(nodeChildNodes, $22a89a9d1d5ce29e$var$isTextNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$22a89a9d1d5ce29e$var$isElementReplacementPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($22a89a9d1d5ce29e$var$isElementNode(node)) {
        // `parent` has an element child that is not `child` or a doctype is following `child`.
        if (!$22a89a9d1d5ce29e$var$isElementReplacementPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($22a89a9d1d5ce29e$var$isDocTypeNode(node)) {
        function hasDoctypeChildThatIsNotChild(node) {
            return $22a89a9d1d5ce29e$var$isDocTypeNode(node) && node !== child;
        }
        // `parent` has a doctype child that is not `child`,
        if ($22a89a9d1d5ce29e$var$find(parentChildNodes, hasDoctypeChildThatIsNotChild)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode);
        // or an element is preceding `child`.
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
    }
}
/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$_insertBefore(parent, node, child, _inDocumentAssertion) {
    // To ensure pre-insertion validity of a node into a parent before a child, run these steps:
    $22a89a9d1d5ce29e$var$assertPreInsertionValidity1to5(parent, node, child);
    // If parent is a document, and any of the statements below, switched on the interface node implements,
    // are true, then throw a "HierarchyRequestError" DOMException.
    if (parent.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE) (_inDocumentAssertion || $22a89a9d1d5ce29e$var$assertPreInsertionValidityInDocument)(parent, node, child);
    var cp = node.parentNode;
    if (cp) cp.removeChild(node); //remove and update
    if (node.nodeType === $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) {
        var newFirst = node.firstChild;
        if (newFirst == null) return node;
        var newLast = node.lastChild;
    } else newFirst = newLast = node;
    var pre = child ? child.previousSibling : parent.lastChild;
    newFirst.previousSibling = pre;
    newLast.nextSibling = child;
    if (pre) pre.nextSibling = newFirst;
    else parent.firstChild = newFirst;
    if (child == null) parent.lastChild = newLast;
    else child.previousSibling = newLast;
    do {
        newFirst.parentNode = parent;
        // Update ownerDocument for each node being inserted
        var targetDoc = parent.ownerDocument || parent;
        $22a89a9d1d5ce29e$var$_updateOwnerDocument(newFirst, targetDoc);
    }while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
    $22a89a9d1d5ce29e$var$_onUpdateChild(parent.ownerDocument || parent, parent);
    //console.log(parent.lastChild.nextSibling == null)
    if (node.nodeType == $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) node.firstChild = node.lastChild = null;
    return node;
}
/**
 * Recursively updates the ownerDocument property for a node and all its descendants
 * @param {Node} node
 * @param {Document} newOwnerDocument
 * @private
 */ function $22a89a9d1d5ce29e$var$_updateOwnerDocument(node, newOwnerDocument) {
    if (node.ownerDocument === newOwnerDocument) return;
    node.ownerDocument = newOwnerDocument;
    // Update attributes if this is an element
    if (node.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE && node.attributes) for(var i = 0; i < node.attributes.length; i++){
        var attr = node.attributes.item(i);
        if (attr) attr.ownerDocument = newOwnerDocument;
    }
    // Recursively update child nodes
    var child = node.firstChild;
    while(child){
        $22a89a9d1d5ce29e$var$_updateOwnerDocument(child, newOwnerDocument);
        child = child.nextSibling;
    }
}
/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */ function $22a89a9d1d5ce29e$var$_appendSingleChild(parentNode, newChild) {
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    newChild.parentNode = parentNode;
    newChild.previousSibling = parentNode.lastChild;
    newChild.nextSibling = null;
    if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;
    else parentNode.firstChild = newChild;
    parentNode.lastChild = newChild;
    $22a89a9d1d5ce29e$var$_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
    // Update ownerDocument for the new child and all its descendants
    var targetDoc = parentNode.ownerDocument || parentNode;
    $22a89a9d1d5ce29e$var$_updateOwnerDocument(newChild, targetDoc);
    return newChild;
}
$22a89a9d1d5ce29e$var$Document.prototype = {
    //implementation : null,
    nodeName: '#document',
    nodeType: $22a89a9d1d5ce29e$var$DOCUMENT_NODE,
    /**
	 * The DocumentType node of the document.
	 *
	 * @readonly
	 * @type DocumentType
	 */ doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(newChild, refChild) {
        if (newChild.nodeType == $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) {
            var child = newChild.firstChild;
            while(child){
                var next = child.nextSibling;
                this.insertBefore(child, refChild);
                child = next;
            }
            return newChild;
        }
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, refChild);
        $22a89a9d1d5ce29e$var$_updateOwnerDocument(newChild, this);
        if (this.documentElement === null && newChild.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE) this.documentElement = newChild;
        return newChild;
    },
    removeChild: function(oldChild) {
        if (this.documentElement == oldChild) this.documentElement = null;
        return $22a89a9d1d5ce29e$var$_removeChild(this, oldChild);
    },
    replaceChild: function(newChild, oldChild) {
        //raises
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, oldChild, $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument);
        $22a89a9d1d5ce29e$var$_updateOwnerDocument(newChild, this);
        if (oldChild) this.removeChild(oldChild);
        if ($22a89a9d1d5ce29e$var$isElementNode(newChild)) this.documentElement = newChild;
    },
    // Introduced in DOM Level 2:
    importNode: function(importedNode, deep) {
        return $22a89a9d1d5ce29e$var$importNode(this, importedNode, deep);
    },
    // Introduced in DOM Level 2:
    getElementById: function(id) {
        var rtv = null;
        $22a89a9d1d5ce29e$var$_visitNode(this.documentElement, function(node) {
            if (node.nodeType == $22a89a9d1d5ce29e$var$ELEMENT_NODE) {
                if (node.getAttribute('id') == id) {
                    rtv = node;
                    return true;
                }
            }
        });
        return rtv;
    },
    /**
	 * The `getElementsByClassName` method of `Document` interface returns an array-like object
	 * of all child elements which have **all** of the given class name(s).
	 *
	 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
	 *
	 *
	 * Warning: This is a live LiveNodeList.
	 * Changes in the DOM will reflect in the array as the changes occur.
	 * If an element selected by this array no longer qualifies for the selector,
	 * it will automatically be removed. Be aware of this for iteration purposes.
	 *
	 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
	 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
	 */ getElementsByClassName: function(classNames) {
        var classNamesSet = $22a89a9d1d5ce29e$var$toOrderedSet(classNames);
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            if (classNamesSet.length > 0) $22a89a9d1d5ce29e$var$_visitNode(base.documentElement, function(node) {
                if (node !== base && node.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE) {
                    var nodeClassNames = node.getAttribute('class');
                    // can be null if the attribute does not exist
                    if (nodeClassNames) {
                        // before splitting and iterating just compare them for the most common case
                        var matches = classNames === nodeClassNames;
                        if (!matches) {
                            var nodeClassNamesSet = $22a89a9d1d5ce29e$var$toOrderedSet(nodeClassNames);
                            matches = classNamesSet.every($22a89a9d1d5ce29e$var$arrayIncludes(nodeClassNamesSet));
                        }
                        if (matches) ls.push(node);
                    }
                }
            });
            return ls;
        });
    },
    //document factory method:
    createElement: function(tagName) {
        var node = new $22a89a9d1d5ce29e$var$Element();
        node.ownerDocument = this;
        node.nodeName = tagName;
        node.tagName = tagName;
        node.localName = tagName;
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        var attrs = node.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
        attrs._ownerElement = node;
        return node;
    },
    createDocumentFragment: function() {
        var node = new $22a89a9d1d5ce29e$var$DocumentFragment();
        node.ownerDocument = this;
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        return node;
    },
    createTextNode: function(data) {
        var node = new $22a89a9d1d5ce29e$var$Text();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createComment: function(data) {
        var node = new $22a89a9d1d5ce29e$var$Comment();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createCDATASection: function(data) {
        var node = new $22a89a9d1d5ce29e$var$CDATASection();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createProcessingInstruction: function(target, data) {
        var node = new $22a89a9d1d5ce29e$var$ProcessingInstruction();
        node.ownerDocument = this;
        node.tagName = node.nodeName = node.target = target;
        node.nodeValue = node.data = data;
        return node;
    },
    createAttribute: function(name) {
        var node = new $22a89a9d1d5ce29e$var$Attr();
        node.ownerDocument = this;
        node.name = name;
        node.nodeName = name;
        node.localName = name;
        node.specified = true;
        return node;
    },
    createEntityReference: function(name) {
        var node = new $22a89a9d1d5ce29e$var$EntityReference();
        node.ownerDocument = this;
        node.nodeName = name;
        return node;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(namespaceURI, qualifiedName) {
        var node = new $22a89a9d1d5ce29e$var$Element();
        var pl = qualifiedName.split(':');
        var attrs = node.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.tagName = qualifiedName;
        node.namespaceURI = namespaceURI;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        attrs._ownerElement = node;
        return node;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(namespaceURI, qualifiedName) {
        var node = new $22a89a9d1d5ce29e$var$Attr();
        var pl = qualifiedName.split(':');
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.name = qualifiedName;
        node.namespaceURI = namespaceURI;
        node.specified = true;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        return node;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Document, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Element() {
    this._nsMap = {};
}
$22a89a9d1d5ce29e$var$Element.prototype = {
    nodeType: $22a89a9d1d5ce29e$var$ELEMENT_NODE,
    hasAttribute: function(name) {
        return this.getAttributeNode(name) != null;
    },
    getAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        return attr && attr.value || '';
    },
    getAttributeNode: function(name) {
        return this.attributes.getNamedItem(name);
    },
    setAttribute: function(name, value) {
        var attr = this.ownerDocument.createAttribute(name);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    removeAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        attr && this.removeAttributeNode(attr);
    },
    //four real opeartion method
    appendChild: function(newChild) {
        if (newChild.nodeType === $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) return this.insertBefore(newChild, null);
        else return $22a89a9d1d5ce29e$var$_appendSingleChild(this, newChild);
    },
    setAttributeNode: function(newAttr) {
        return this.attributes.setNamedItem(newAttr);
    },
    setAttributeNodeNS: function(newAttr) {
        return this.attributes.setNamedItemNS(newAttr);
    },
    removeAttributeNode: function(oldAttr) {
        //console.log(this == oldAttr.ownerElement)
        return this.attributes.removeNamedItem(oldAttr.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(namespaceURI, localName) {
        var old = this.getAttributeNodeNS(namespaceURI, localName);
        old && this.removeAttributeNode(old);
    },
    hasAttributeNS: function(namespaceURI, localName) {
        return this.getAttributeNodeNS(namespaceURI, localName) != null;
    },
    getAttributeNS: function(namespaceURI, localName) {
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        return attr && attr.value || '';
    },
    setAttributeNS: function(namespaceURI, qualifiedName, value) {
        var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    getAttributeNodeNS: function(namespaceURI, localName) {
        return this.attributes.getNamedItemNS(namespaceURI, localName);
    },
    getElementsByTagName: function(tagName) {
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            $22a89a9d1d5ce29e$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType == $22a89a9d1d5ce29e$var$ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)) ls.push(node);
            });
            return ls;
        });
    },
    getElementsByTagNameNS: function(namespaceURI, localName) {
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            $22a89a9d1d5ce29e$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)) ls.push(node);
            });
            return ls;
        });
    }
};
$22a89a9d1d5ce29e$var$Document.prototype.getElementsByTagName = $22a89a9d1d5ce29e$var$Element.prototype.getElementsByTagName;
$22a89a9d1d5ce29e$var$Document.prototype.getElementsByTagNameNS = $22a89a9d1d5ce29e$var$Element.prototype.getElementsByTagNameNS;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Element, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Attr() {}
$22a89a9d1d5ce29e$var$Attr.prototype.nodeType = $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Attr, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$CharacterData() {}
$22a89a9d1d5ce29e$var$CharacterData.prototype = {
    data: '',
    substringData: function(offset, count) {
        return this.data.substring(offset, offset + count);
    },
    appendData: function(text) {
        text = this.data + text;
        this.nodeValue = this.data = text;
        this.length = text.length;
    },
    insertData: function(offset, text) {
        this.replaceData(offset, 0, text);
    },
    appendChild: function(newChild) {
        throw new Error($22a89a9d1d5ce29e$var$ExceptionMessage[$22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR]);
    },
    deleteData: function(offset, count) {
        this.replaceData(offset, count, "");
    },
    replaceData: function(offset, count, text) {
        var start = this.data.substring(0, offset);
        var end = this.data.substring(offset + count);
        text = start + text + end;
        this.nodeValue = this.data = text;
        this.length = text.length;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$CharacterData, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Text() {}
$22a89a9d1d5ce29e$var$Text.prototype = {
    nodeName: "#text",
    nodeType: $22a89a9d1d5ce29e$var$TEXT_NODE,
    splitText: function(offset) {
        var text = this.data;
        var newText = text.substring(offset);
        text = text.substring(0, offset);
        this.data = this.nodeValue = text;
        this.length = text.length;
        var newNode = this.ownerDocument.createTextNode(newText);
        if (this.parentNode) this.parentNode.insertBefore(newNode, this.nextSibling);
        return newNode;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Text, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$Comment() {}
$22a89a9d1d5ce29e$var$Comment.prototype = {
    nodeName: "#comment",
    nodeType: $22a89a9d1d5ce29e$var$COMMENT_NODE
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Comment, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$CDATASection() {}
$22a89a9d1d5ce29e$var$CDATASection.prototype = {
    nodeName: "#cdata-section",
    nodeType: $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$CDATASection, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$DocumentType() {}
$22a89a9d1d5ce29e$var$DocumentType.prototype.nodeType = $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$DocumentType, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Notation() {}
$22a89a9d1d5ce29e$var$Notation.prototype.nodeType = $22a89a9d1d5ce29e$var$NOTATION_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Notation, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Entity() {}
$22a89a9d1d5ce29e$var$Entity.prototype.nodeType = $22a89a9d1d5ce29e$var$ENTITY_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Entity, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$EntityReference() {}
$22a89a9d1d5ce29e$var$EntityReference.prototype.nodeType = $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$EntityReference, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$DocumentFragment() {}
$22a89a9d1d5ce29e$var$DocumentFragment.prototype.nodeName = "#document-fragment";
$22a89a9d1d5ce29e$var$DocumentFragment.prototype.nodeType = $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$DocumentFragment, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$ProcessingInstruction() {}
$22a89a9d1d5ce29e$var$ProcessingInstruction.prototype.nodeType = $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$ProcessingInstruction, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$XMLSerializer() {}
$22a89a9d1d5ce29e$var$XMLSerializer.prototype.serializeToString = function(node, isHtml, nodeFilter) {
    return $22a89a9d1d5ce29e$var$nodeSerializeToString.call(node, isHtml, nodeFilter);
};
$22a89a9d1d5ce29e$var$Node.prototype.toString = $22a89a9d1d5ce29e$var$nodeSerializeToString;
function $22a89a9d1d5ce29e$var$nodeSerializeToString(isHtml, nodeFilter) {
    var buf = [];
    var refNode = this.nodeType == 9 && this.documentElement || this;
    var prefix = refNode.prefix;
    var uri = refNode.namespaceURI;
    if (uri && prefix == null) {
        //console.log(prefix)
        var prefix = refNode.lookupPrefix(uri);
        if (prefix == null) //isHTML = true;
        var visibleNamespaces = [
            {
                namespace: uri,
                prefix: null
            }
        ];
    }
    $22a89a9d1d5ce29e$var$serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
    //console.log('###',this.nodeType,uri,prefix,buf.join(''))
    return buf.join('');
}
function $22a89a9d1d5ce29e$var$needNamespaceDefine(node, isHTML, visibleNamespaces) {
    var prefix = node.prefix || '';
    var uri = node.namespaceURI;
    // According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
    // and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
    // > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
    // in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
    // and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
    // > [...] Furthermore, the attribute value [...] must not be an empty string.
    // so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
    if (!uri) return false;
    if (prefix === "xml" && uri === $22a89a9d1d5ce29e$var$NAMESPACE.XML || uri === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) return false;
    var i = visibleNamespaces.length;
    while(i--){
        var ns = visibleNamespaces[i];
        // get namespace prefix
        if (ns.prefix === prefix) return ns.namespace !== uri;
    }
    return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */ function $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, qualifiedName, value) {
    buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, $22a89a9d1d5ce29e$var$_xmlEncoder), '"');
}
function $22a89a9d1d5ce29e$var$serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
    if (!visibleNamespaces) visibleNamespaces = [];
    if (nodeFilter) {
        node = nodeFilter(node);
        if (node) {
            if (typeof node == 'string') {
                buf.push(node);
                return;
            }
        } else return;
    //buf.sort.apply(attrs, attributeSorter);
    }
    switch(node.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            var attrs = node.attributes;
            var len = attrs.length;
            var child = node.firstChild;
            var nodeName = node.tagName;
            isHTML = $22a89a9d1d5ce29e$var$NAMESPACE.isHTML(node.namespaceURI) || isHTML;
            var prefixedNodeName = nodeName;
            if (!isHTML && !node.prefix && node.namespaceURI) {
                var defaultNS;
                // lookup current default ns from `xmlns` attribute
                for(var ai = 0; ai < attrs.length; ai++)if (attrs.item(ai).name === 'xmlns') {
                    defaultNS = attrs.item(ai).value;
                    break;
                }
                if (!defaultNS) // lookup current default ns in visibleNamespaces
                for(var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--){
                    var namespace = visibleNamespaces[nsi];
                    if (namespace.prefix === '' && namespace.namespace === node.namespaceURI) {
                        defaultNS = namespace.namespace;
                        break;
                    }
                }
                if (defaultNS !== node.namespaceURI) for(var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--){
                    var namespace = visibleNamespaces[nsi];
                    if (namespace.namespace === node.namespaceURI) {
                        if (namespace.prefix) prefixedNodeName = namespace.prefix + ':' + nodeName;
                        break;
                    }
                }
            }
            buf.push('<', prefixedNodeName);
            for(var i = 0; i < len; i++){
                // add namespaces for attributes
                var attr = attrs.item(i);
                if (attr.prefix == 'xmlns') visibleNamespaces.push({
                    prefix: attr.localName,
                    namespace: attr.value
                });
                else if (attr.nodeName == 'xmlns') visibleNamespaces.push({
                    prefix: '',
                    namespace: attr.value
                });
            }
            for(var i = 0; i < len; i++){
                var attr = attrs.item(i);
                if ($22a89a9d1d5ce29e$var$needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
                    var prefix = attr.prefix || '';
                    var uri = attr.namespaceURI;
                    $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
                    visibleNamespaces.push({
                        prefix: prefix,
                        namespace: uri
                    });
                }
                $22a89a9d1d5ce29e$var$serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
            }
            // add namespace for current node
            if (nodeName === prefixedNodeName && $22a89a9d1d5ce29e$var$needNamespaceDefine(node, isHTML, visibleNamespaces)) {
                var prefix = node.prefix || '';
                var uri = node.namespaceURI;
                $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
                visibleNamespaces.push({
                    prefix: prefix,
                    namespace: uri
                });
            }
            if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
                buf.push('>');
                //if is cdata child node
                if (isHTML && /^script$/i.test(nodeName)) while(child){
                    if (child.data) buf.push(child.data);
                    else $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                    child = child.nextSibling;
                }
                else while(child){
                    $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                    child = child.nextSibling;
                }
                buf.push('</', prefixedNodeName, '>');
            } else buf.push('/>');
            // remove added visible namespaces
            //visibleNamespaces.length = startVisibleNamespaces;
            return;
        case $22a89a9d1d5ce29e$var$DOCUMENT_NODE:
        case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
            var child = node.firstChild;
            while(child){
                $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                child = child.nextSibling;
            }
            return;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            return $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, node.name, node.value);
        case $22a89a9d1d5ce29e$var$TEXT_NODE:
            /**
		 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
		 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
		 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
		 * `&amp;` and `&lt;` respectively.
		 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
		 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
		 * when that string is not marking the end of a CDATA section.
		 *
		 * In the content of elements, character data is any string of characters
		 * which does not contain the start-delimiter of any markup
		 * and does not include the CDATA-section-close delimiter, `]]>`.
		 *
		 * @see https://www.w3.org/TR/xml/#NT-CharData
		 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
		 */ return buf.push(node.data.replace(/[<&>]/g, $22a89a9d1d5ce29e$var$_xmlEncoder));
        case $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE:
            return buf.push('<![CDATA[', node.data, ']]>');
        case $22a89a9d1d5ce29e$var$COMMENT_NODE:
            return buf.push("<!--", node.data, "-->");
        case $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE:
            var pubid = node.publicId;
            var sysid = node.systemId;
            buf.push('<!DOCTYPE ', node.name);
            if (pubid) {
                buf.push(' PUBLIC ', pubid);
                if (sysid && sysid != '.') buf.push(' ', sysid);
                buf.push('>');
            } else if (sysid && sysid != '.') buf.push(' SYSTEM ', sysid, '>');
            else {
                var sub = node.internalSubset;
                if (sub) buf.push(" [", sub, "]");
                buf.push(">");
            }
            return;
        case $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE:
            return buf.push("<?", node.target, " ", node.data, "?>");
        case $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE:
            return buf.push('&', node.nodeName, ';');
        //case ENTITY_NODE:
        //case NOTATION_NODE:
        default:
            buf.push('??', node.nodeName);
    }
}
function $22a89a9d1d5ce29e$var$importNode(doc, node, deep) {
    var node2;
    switch(node.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            node2 = node.cloneNode(false);
            node2.ownerDocument = doc;
        //var attrs = node2.attributes;
        //var len = attrs.length;
        //for(var i=0;i<len;i++){
        //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
        //}
        case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
            break;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            deep = true;
            break;
    }
    if (!node2) node2 = node.cloneNode(false); //false
    node2.ownerDocument = doc;
    node2.parentNode = null;
    if (deep) {
        var child = node.firstChild;
        while(child){
            node2.appendChild($22a89a9d1d5ce29e$var$importNode(doc, child, deep));
            child = child.nextSibling;
        }
    }
    return node2;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function $22a89a9d1d5ce29e$var$cloneNode(doc, node, deep) {
    var node2 = new node.constructor();
    for(var n in node)if (Object.prototype.hasOwnProperty.call(node, n)) {
        var v = node[n];
        if (typeof v != "object") {
            if (v != node2[n]) node2[n] = v;
        }
    }
    if (node.childNodes) node2.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
    node2.ownerDocument = doc;
    switch(node2.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            var attrs = node.attributes;
            var attrs2 = node2.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
            var len = attrs.length;
            attrs2._ownerElement = node2;
            for(var i = 0; i < len; i++)node2.setAttributeNode($22a89a9d1d5ce29e$var$cloneNode(doc, attrs.item(i), true));
            break;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            deep = true;
    }
    if (deep) {
        var child = node.firstChild;
        while(child){
            node2.appendChild($22a89a9d1d5ce29e$var$cloneNode(doc, child, deep));
            child = child.nextSibling;
        }
    }
    return node2;
}
function $22a89a9d1d5ce29e$var$__set__(object, key, value) {
    object[key] = value;
}
//do dynamic
try {
    if (Object.defineProperty) {
        Object.defineProperty($22a89a9d1d5ce29e$var$LiveNodeList.prototype, 'length', {
            get: function() {
                $22a89a9d1d5ce29e$var$_updateLiveList(this);
                return this.$$length;
            }
        });
        Object.defineProperty($22a89a9d1d5ce29e$var$Node.prototype, 'textContent', {
            get: function() {
                return getTextContent(this);
            },
            set: function(data) {
                switch(this.nodeType){
                    case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
                    case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
                        while(this.firstChild)this.removeChild(this.firstChild);
                        if (data || String(data)) this.appendChild(this.ownerDocument.createTextNode(data));
                        break;
                    default:
                        this.data = data;
                        this.value = data;
                        this.nodeValue = data;
                }
            }
        });
        function getTextContent(node) {
            switch(node.nodeType){
                case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
                case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
                    var buf = [];
                    node = node.firstChild;
                    while(node){
                        if (node.nodeType !== 7 && node.nodeType !== 8) buf.push(getTextContent(node));
                        node = node.nextSibling;
                    }
                    return buf.join('');
                default:
                    return node.nodeValue;
            }
        }
        $22a89a9d1d5ce29e$var$__set__ = function(object, key, value) {
            //console.log(value)
            object['$$' + key] = value;
        };
    }
} catch (e) {}
$22a89a9d1d5ce29e$export$d1d99cf900472499 = $22a89a9d1d5ce29e$var$DocumentType;
$22a89a9d1d5ce29e$export$fe58bcf938607f6a = $22a89a9d1d5ce29e$var$DOMException;
$22a89a9d1d5ce29e$export$455426655eab1d48 = $22a89a9d1d5ce29e$var$DOMImplementation;
$22a89a9d1d5ce29e$export$db77ccec0bb4ccac = $22a89a9d1d5ce29e$var$Element;
$22a89a9d1d5ce29e$export$85c928794f8d04d4 = $22a89a9d1d5ce29e$var$Node;
$22a89a9d1d5ce29e$export$79b41aa5d56abdff = $22a89a9d1d5ce29e$var$NodeList;
$22a89a9d1d5ce29e$export$64f0bed4ae6f0f24 = $22a89a9d1d5ce29e$var$XMLSerializer; //}

});
parcelRegister("hkG9E", function(module, exports) {

$parcel$export(module.exports, "find", () => $c9e500f3e8ddaab6$export$71aa6c912b956294, (v) => $c9e500f3e8ddaab6$export$71aa6c912b956294 = v);
$parcel$export(module.exports, "freeze", () => $c9e500f3e8ddaab6$export$792f3d81ea979f55, (v) => $c9e500f3e8ddaab6$export$792f3d81ea979f55 = v);
$parcel$export(module.exports, "NAMESPACE", () => $c9e500f3e8ddaab6$export$6aad947bda0f3f46, (v) => $c9e500f3e8ddaab6$export$6aad947bda0f3f46 = v);
var $c9e500f3e8ddaab6$export$e6e34fd1f2686227;
var $c9e500f3e8ddaab6$export$71aa6c912b956294;
var $c9e500f3e8ddaab6$export$792f3d81ea979f55;
var $c9e500f3e8ddaab6$export$c6cb9dd1e3ada1aa;
var $c9e500f3e8ddaab6$export$6aad947bda0f3f46;
'use strict';
/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */ function $c9e500f3e8ddaab6$var$find(list, predicate, ac) {
    if (ac === undefined) ac = Array.prototype;
    if (list && typeof ac.find === 'function') return ac.find.call(list, predicate);
    for(var i = 0; i < list.length; i++)if (Object.prototype.hasOwnProperty.call(list, i)) {
        var item = list[i];
        if (predicate.call(undefined, item, i, list)) return item;
    }
}
/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */ function $c9e500f3e8ddaab6$var$freeze(object, oc) {
    if (oc === undefined) oc = Object;
    return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object;
}
/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */ function $c9e500f3e8ddaab6$var$assign(target, source) {
    if (target === null || typeof target !== 'object') throw new TypeError('target is not an object');
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    return target;
}
/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */ var $c9e500f3e8ddaab6$var$MIME_TYPE = $c9e500f3e8ddaab6$var$freeze({
    /**
	 * `text/html`, the only mime type that triggers treating an XML document as HTML.
	 *
	 * @see DOMParser.SupportedType.isHTML
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
	 */ HTML: 'text/html',
    /**
	 * Helper method to check a mime type if it indicates an HTML document
	 *
	 * @param {string} [value]
	 * @returns {boolean}
	 *
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */ isHTML: function(value) {
        return value === $c9e500f3e8ddaab6$var$MIME_TYPE.HTML;
    },
    /**
	 * `application/xml`, the standard mime type for XML documents.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
	 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_APPLICATION: 'application/xml',
    /**
	 * `text/html`, an alias for `application/xml`.
	 *
	 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
	 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_TEXT: 'text/xml',
    /**
	 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
	 * but is parsed as an XML document.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
	 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
	 */ XML_XHTML_APPLICATION: 'application/xhtml+xml',
    /**
	 * `image/svg+xml`,
	 *
	 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
	 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
	 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
	 */ XML_SVG_IMAGE: 'image/svg+xml'
});
/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */ var $c9e500f3e8ddaab6$var$NAMESPACE = $c9e500f3e8ddaab6$var$freeze({
    /**
	 * The XHTML namespace.
	 *
	 * @see http://www.w3.org/1999/xhtml
	 */ HTML: 'http://www.w3.org/1999/xhtml',
    /**
	 * Checks if `uri` equals `NAMESPACE.HTML`.
	 *
	 * @param {string} [uri]
	 *
	 * @see NAMESPACE.HTML
	 */ isHTML: function(uri) {
        return uri === $c9e500f3e8ddaab6$var$NAMESPACE.HTML;
    },
    /**
	 * The SVG namespace.
	 *
	 * @see http://www.w3.org/2000/svg
	 */ SVG: 'http://www.w3.org/2000/svg',
    /**
	 * The `xml:` namespace.
	 *
	 * @see http://www.w3.org/XML/1998/namespace
	 */ XML: 'http://www.w3.org/XML/1998/namespace',
    /**
	 * The `xmlns:` namespace
	 *
	 * @see https://www.w3.org/2000/xmlns/
	 */ XMLNS: 'http://www.w3.org/2000/xmlns/'
});
$c9e500f3e8ddaab6$export$e6e34fd1f2686227 = $c9e500f3e8ddaab6$var$assign;
$c9e500f3e8ddaab6$export$71aa6c912b956294 = $c9e500f3e8ddaab6$var$find;
$c9e500f3e8ddaab6$export$792f3d81ea979f55 = $c9e500f3e8ddaab6$var$freeze;
$c9e500f3e8ddaab6$export$c6cb9dd1e3ada1aa = $c9e500f3e8ddaab6$var$MIME_TYPE;
$c9e500f3e8ddaab6$export$6aad947bda0f3f46 = $c9e500f3e8ddaab6$var$NAMESPACE;

});


parcelRegister("c1Wy2", function(module, exports) {

$parcel$export(module.exports, "DOMParser", () => $8c22fe72d8589809$export$1059c6e7d2ce5669, (v) => $8c22fe72d8589809$export$1059c6e7d2ce5669 = v);
var $8c22fe72d8589809$export$181392475aa39887;
var $8c22fe72d8589809$export$ba13e0e2f19e61a1;
var $8c22fe72d8589809$export$1059c6e7d2ce5669;

var $hkG9E = parcelRequire("hkG9E");

var $2YubT = parcelRequire("2YubT");

var $2NAtx = parcelRequire("2NAtx");

var $1fO4L = parcelRequire("1fO4L");
var $8c22fe72d8589809$var$DOMImplementation = $2YubT.DOMImplementation;
var $8c22fe72d8589809$var$NAMESPACE = $hkG9E.NAMESPACE;
var $8c22fe72d8589809$var$ParseError = $1fO4L.ParseError;
var $8c22fe72d8589809$var$XMLReader = $1fO4L.XMLReader;
/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */ function $8c22fe72d8589809$var$normalizeLineEndings(input) {
    return input.replace(/\r[\n\u0085]/g, '\n').replace(/[\r\u0085\u2028]/g, '\n');
}
/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */ /**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */ /**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */ function $8c22fe72d8589809$var$DOMParser(options) {
    this.options = options || {
        locator: {}
    };
}
$8c22fe72d8589809$var$DOMParser.prototype.parseFromString = function(source, mimeType) {
    var options = this.options;
    var sax = new $8c22fe72d8589809$var$XMLReader();
    var domBuilder = options.domBuilder || new $8c22fe72d8589809$var$DOMHandler(); //contentHandler and LexicalHandler
    var errorHandler = options.errorHandler;
    var locator = options.locator;
    var defaultNSMap = options.xmlns || {};
    var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
    var entityMap = isHTML ? $2NAtx.HTML_ENTITIES : $2NAtx.XML_ENTITIES;
    if (locator) domBuilder.setDocumentLocator(locator);
    sax.errorHandler = $8c22fe72d8589809$var$buildErrorHandler(errorHandler, domBuilder, locator);
    sax.domBuilder = options.domBuilder || domBuilder;
    if (isHTML) defaultNSMap[''] = $8c22fe72d8589809$var$NAMESPACE.HTML;
    defaultNSMap.xml = defaultNSMap.xml || $8c22fe72d8589809$var$NAMESPACE.XML;
    var normalize = options.normalizeLineEndings || $8c22fe72d8589809$var$normalizeLineEndings;
    if (source && typeof source === 'string') sax.parse(normalize(source), defaultNSMap, entityMap);
    else sax.errorHandler.error('invalid doc source');
    return domBuilder.doc;
};
function $8c22fe72d8589809$var$buildErrorHandler(errorImpl, domBuilder, locator) {
    if (!errorImpl) {
        if (domBuilder instanceof $8c22fe72d8589809$var$DOMHandler) return domBuilder;
        errorImpl = domBuilder;
    }
    var errorHandler = {};
    var isCallback = errorImpl instanceof Function;
    locator = locator || {};
    function build(key) {
        var fn = errorImpl[key];
        if (!fn && isCallback) fn = errorImpl.length == 2 ? function(msg) {
            errorImpl(key, msg);
        } : errorImpl;
        errorHandler[key] = fn && function(msg) {
            fn('[xmldom ' + key + ']\t' + msg + $8c22fe72d8589809$var$_locator(locator));
        } || function() {};
    }
    build('warning');
    build('error');
    build('fatalError');
    return errorHandler;
}
//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */ function $8c22fe72d8589809$var$DOMHandler() {
    this.cdata = false;
}
function $8c22fe72d8589809$var$position(locator, node) {
    node.lineNumber = locator.lineNumber;
    node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */ $8c22fe72d8589809$var$DOMHandler.prototype = {
    startDocument: function() {
        this.doc = new $8c22fe72d8589809$var$DOMImplementation().createDocument(null, null, null);
        if (this.locator) this.doc.documentURI = this.locator.systemId;
    },
    startElement: function(namespaceURI, localName, qName, attrs) {
        var doc = this.doc;
        var el = doc.createElementNS(namespaceURI, qName || localName);
        var len = attrs.length;
        $8c22fe72d8589809$var$appendElement(this, el);
        this.currentElement = el;
        this.locator && $8c22fe72d8589809$var$position(this.locator, el);
        for(var i = 0; i < len; i++){
            var namespaceURI = attrs.getURI(i);
            var value = attrs.getValue(i);
            var qName = attrs.getQName(i);
            var attr = doc.createAttributeNS(namespaceURI, qName);
            this.locator && $8c22fe72d8589809$var$position(attrs.getLocator(i), attr);
            attr.value = attr.nodeValue = value;
            el.setAttributeNode(attr);
        }
    },
    endElement: function(namespaceURI, localName, qName) {
        var current = this.currentElement;
        var tagName = current.tagName;
        this.currentElement = current.parentNode;
    },
    startPrefixMapping: function(prefix, uri) {},
    endPrefixMapping: function(prefix) {},
    processingInstruction: function(target, data) {
        var ins = this.doc.createProcessingInstruction(target, data);
        this.locator && $8c22fe72d8589809$var$position(this.locator, ins);
        $8c22fe72d8589809$var$appendElement(this, ins);
    },
    ignorableWhitespace: function(ch, start, length) {},
    characters: function(chars, start, length) {
        chars = $8c22fe72d8589809$var$_toString.apply(this, arguments);
        //console.log(chars)
        if (chars) {
            if (this.cdata) var charNode = this.doc.createCDATASection(chars);
            else var charNode = this.doc.createTextNode(chars);
            if (this.currentElement) this.currentElement.appendChild(charNode);
            else if (/^\s*$/.test(chars)) this.doc.appendChild(charNode);
            this.locator && $8c22fe72d8589809$var$position(this.locator, charNode);
        }
    },
    skippedEntity: function(name) {},
    endDocument: function() {
        this.doc.normalize();
    },
    setDocumentLocator: function(locator) {
        if (this.locator = locator) locator.lineNumber = 0;
    },
    //LexicalHandler
    comment: function(chars, start, length) {
        chars = $8c22fe72d8589809$var$_toString.apply(this, arguments);
        var comm = this.doc.createComment(chars);
        this.locator && $8c22fe72d8589809$var$position(this.locator, comm);
        $8c22fe72d8589809$var$appendElement(this, comm);
    },
    startCDATA: function() {
        //used in characters() methods
        this.cdata = true;
    },
    endCDATA: function() {
        this.cdata = false;
    },
    startDTD: function(name, publicId, systemId) {
        var impl = this.doc.implementation;
        if (impl && impl.createDocumentType) {
            var dt = impl.createDocumentType(name, publicId, systemId);
            this.locator && $8c22fe72d8589809$var$position(this.locator, dt);
            $8c22fe72d8589809$var$appendElement(this, dt);
            this.doc.doctype = dt;
        }
    },
    /**
	 * @see org.xml.sax.ErrorHandler
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
	 */ warning: function(error) {
        console.warn('[xmldom warning]\t' + error, $8c22fe72d8589809$var$_locator(this.locator));
    },
    error: function(error) {
        console.error('[xmldom error]\t' + error, $8c22fe72d8589809$var$_locator(this.locator));
    },
    fatalError: function(error) {
        throw new $8c22fe72d8589809$var$ParseError(error, this.locator);
    }
};
function $8c22fe72d8589809$var$_locator(l) {
    if (l) return '\n@' + (l.systemId || '') + '#[line:' + l.lineNumber + ',col:' + l.columnNumber + ']';
}
function $8c22fe72d8589809$var$_toString(chars, start, length) {
    if (typeof chars == 'string') return chars.substr(start, length);
    else {
        if (chars.length >= start + length || start) return new java.lang.String(chars, start, length) + '';
        return chars;
    }
}
/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */ "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(key) {
    $8c22fe72d8589809$var$DOMHandler.prototype[key] = function() {
        return null;
    };
});
/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */ function $8c22fe72d8589809$var$appendElement(hander, node) {
    if (!hander.currentElement) hander.doc.appendChild(node);
    else hander.currentElement.appendChild(node);
} //appendChild and setAttributeNS are preformance key
$8c22fe72d8589809$export$181392475aa39887 = $8c22fe72d8589809$var$DOMHandler;
$8c22fe72d8589809$export$ba13e0e2f19e61a1 = $8c22fe72d8589809$var$normalizeLineEndings;
$8c22fe72d8589809$export$1059c6e7d2ce5669 = $8c22fe72d8589809$var$DOMParser;

});
parcelRegister("2NAtx", function(module, exports) {

$parcel$export(module.exports, "XML_ENTITIES", () => $209c739ee170ce7f$export$91f0e5ff03dc84f, (v) => $209c739ee170ce7f$export$91f0e5ff03dc84f = v);
$parcel$export(module.exports, "HTML_ENTITIES", () => $209c739ee170ce7f$export$b7e4d4631df36afa, (v) => $209c739ee170ce7f$export$b7e4d4631df36afa = v);
/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */ var $209c739ee170ce7f$export$91f0e5ff03dc84f;
/**
 * A map of all entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://html.spec.whatwg.org/entities.json JSON
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */ var $209c739ee170ce7f$export$b7e4d4631df36afa;
/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */ var $209c739ee170ce7f$export$79451380caed3f98;
'use strict';

var $hkG9E = parcelRequire("hkG9E");
var $209c739ee170ce7f$require$freeze = $hkG9E.freeze;
$209c739ee170ce7f$export$91f0e5ff03dc84f = $209c739ee170ce7f$require$freeze({
    amp: '&',
    apos: "'",
    gt: '>',
    lt: '<',
    quot: '"'
});
$209c739ee170ce7f$export$b7e4d4631df36afa = $209c739ee170ce7f$require$freeze({
    Aacute: '\u00C1',
    aacute: '\u00E1',
    Abreve: '\u0102',
    abreve: '\u0103',
    ac: '\u223E',
    acd: '\u223F',
    acE: '\u223E\u0333',
    Acirc: '\u00C2',
    acirc: '\u00E2',
    acute: '\u00B4',
    Acy: '\u0410',
    acy: '\u0430',
    AElig: '\u00C6',
    aelig: '\u00E6',
    af: '\u2061',
    Afr: '\uD835\uDD04',
    afr: '\uD835\uDD1E',
    Agrave: '\u00C0',
    agrave: '\u00E0',
    alefsym: '\u2135',
    aleph: '\u2135',
    Alpha: '\u0391',
    alpha: '\u03B1',
    Amacr: '\u0100',
    amacr: '\u0101',
    amalg: '\u2A3F',
    AMP: '\u0026',
    amp: '\u0026',
    And: '\u2A53',
    and: '\u2227',
    andand: '\u2A55',
    andd: '\u2A5C',
    andslope: '\u2A58',
    andv: '\u2A5A',
    ang: '\u2220',
    ange: '\u29A4',
    angle: '\u2220',
    angmsd: '\u2221',
    angmsdaa: '\u29A8',
    angmsdab: '\u29A9',
    angmsdac: '\u29AA',
    angmsdad: '\u29AB',
    angmsdae: '\u29AC',
    angmsdaf: '\u29AD',
    angmsdag: '\u29AE',
    angmsdah: '\u29AF',
    angrt: '\u221F',
    angrtvb: '\u22BE',
    angrtvbd: '\u299D',
    angsph: '\u2222',
    angst: '\u00C5',
    angzarr: '\u237C',
    Aogon: '\u0104',
    aogon: '\u0105',
    Aopf: '\uD835\uDD38',
    aopf: '\uD835\uDD52',
    ap: '\u2248',
    apacir: '\u2A6F',
    apE: '\u2A70',
    ape: '\u224A',
    apid: '\u224B',
    apos: '\u0027',
    ApplyFunction: '\u2061',
    approx: '\u2248',
    approxeq: '\u224A',
    Aring: '\u00C5',
    aring: '\u00E5',
    Ascr: '\uD835\uDC9C',
    ascr: '\uD835\uDCB6',
    Assign: '\u2254',
    ast: '\u002A',
    asymp: '\u2248',
    asympeq: '\u224D',
    Atilde: '\u00C3',
    atilde: '\u00E3',
    Auml: '\u00C4',
    auml: '\u00E4',
    awconint: '\u2233',
    awint: '\u2A11',
    backcong: '\u224C',
    backepsilon: '\u03F6',
    backprime: '\u2035',
    backsim: '\u223D',
    backsimeq: '\u22CD',
    Backslash: '\u2216',
    Barv: '\u2AE7',
    barvee: '\u22BD',
    Barwed: '\u2306',
    barwed: '\u2305',
    barwedge: '\u2305',
    bbrk: '\u23B5',
    bbrktbrk: '\u23B6',
    bcong: '\u224C',
    Bcy: '\u0411',
    bcy: '\u0431',
    bdquo: '\u201E',
    becaus: '\u2235',
    Because: '\u2235',
    because: '\u2235',
    bemptyv: '\u29B0',
    bepsi: '\u03F6',
    bernou: '\u212C',
    Bernoullis: '\u212C',
    Beta: '\u0392',
    beta: '\u03B2',
    beth: '\u2136',
    between: '\u226C',
    Bfr: '\uD835\uDD05',
    bfr: '\uD835\uDD1F',
    bigcap: '\u22C2',
    bigcirc: '\u25EF',
    bigcup: '\u22C3',
    bigodot: '\u2A00',
    bigoplus: '\u2A01',
    bigotimes: '\u2A02',
    bigsqcup: '\u2A06',
    bigstar: '\u2605',
    bigtriangledown: '\u25BD',
    bigtriangleup: '\u25B3',
    biguplus: '\u2A04',
    bigvee: '\u22C1',
    bigwedge: '\u22C0',
    bkarow: '\u290D',
    blacklozenge: '\u29EB',
    blacksquare: '\u25AA',
    blacktriangle: '\u25B4',
    blacktriangledown: '\u25BE',
    blacktriangleleft: '\u25C2',
    blacktriangleright: '\u25B8',
    blank: '\u2423',
    blk12: '\u2592',
    blk14: '\u2591',
    blk34: '\u2593',
    block: '\u2588',
    bne: '\u003D\u20E5',
    bnequiv: '\u2261\u20E5',
    bNot: '\u2AED',
    bnot: '\u2310',
    Bopf: '\uD835\uDD39',
    bopf: '\uD835\uDD53',
    bot: '\u22A5',
    bottom: '\u22A5',
    bowtie: '\u22C8',
    boxbox: '\u29C9',
    boxDL: '\u2557',
    boxDl: '\u2556',
    boxdL: '\u2555',
    boxdl: '\u2510',
    boxDR: '\u2554',
    boxDr: '\u2553',
    boxdR: '\u2552',
    boxdr: '\u250C',
    boxH: '\u2550',
    boxh: '\u2500',
    boxHD: '\u2566',
    boxHd: '\u2564',
    boxhD: '\u2565',
    boxhd: '\u252C',
    boxHU: '\u2569',
    boxHu: '\u2567',
    boxhU: '\u2568',
    boxhu: '\u2534',
    boxminus: '\u229F',
    boxplus: '\u229E',
    boxtimes: '\u22A0',
    boxUL: '\u255D',
    boxUl: '\u255C',
    boxuL: '\u255B',
    boxul: '\u2518',
    boxUR: '\u255A',
    boxUr: '\u2559',
    boxuR: '\u2558',
    boxur: '\u2514',
    boxV: '\u2551',
    boxv: '\u2502',
    boxVH: '\u256C',
    boxVh: '\u256B',
    boxvH: '\u256A',
    boxvh: '\u253C',
    boxVL: '\u2563',
    boxVl: '\u2562',
    boxvL: '\u2561',
    boxvl: '\u2524',
    boxVR: '\u2560',
    boxVr: '\u255F',
    boxvR: '\u255E',
    boxvr: '\u251C',
    bprime: '\u2035',
    Breve: '\u02D8',
    breve: '\u02D8',
    brvbar: '\u00A6',
    Bscr: '\u212C',
    bscr: '\uD835\uDCB7',
    bsemi: '\u204F',
    bsim: '\u223D',
    bsime: '\u22CD',
    bsol: '\u005C',
    bsolb: '\u29C5',
    bsolhsub: '\u27C8',
    bull: '\u2022',
    bullet: '\u2022',
    bump: '\u224E',
    bumpE: '\u2AAE',
    bumpe: '\u224F',
    Bumpeq: '\u224E',
    bumpeq: '\u224F',
    Cacute: '\u0106',
    cacute: '\u0107',
    Cap: '\u22D2',
    cap: '\u2229',
    capand: '\u2A44',
    capbrcup: '\u2A49',
    capcap: '\u2A4B',
    capcup: '\u2A47',
    capdot: '\u2A40',
    CapitalDifferentialD: '\u2145',
    caps: '\u2229\uFE00',
    caret: '\u2041',
    caron: '\u02C7',
    Cayleys: '\u212D',
    ccaps: '\u2A4D',
    Ccaron: '\u010C',
    ccaron: '\u010D',
    Ccedil: '\u00C7',
    ccedil: '\u00E7',
    Ccirc: '\u0108',
    ccirc: '\u0109',
    Cconint: '\u2230',
    ccups: '\u2A4C',
    ccupssm: '\u2A50',
    Cdot: '\u010A',
    cdot: '\u010B',
    cedil: '\u00B8',
    Cedilla: '\u00B8',
    cemptyv: '\u29B2',
    cent: '\u00A2',
    CenterDot: '\u00B7',
    centerdot: '\u00B7',
    Cfr: '\u212D',
    cfr: '\uD835\uDD20',
    CHcy: '\u0427',
    chcy: '\u0447',
    check: '\u2713',
    checkmark: '\u2713',
    Chi: '\u03A7',
    chi: '\u03C7',
    cir: '\u25CB',
    circ: '\u02C6',
    circeq: '\u2257',
    circlearrowleft: '\u21BA',
    circlearrowright: '\u21BB',
    circledast: '\u229B',
    circledcirc: '\u229A',
    circleddash: '\u229D',
    CircleDot: '\u2299',
    circledR: '\u00AE',
    circledS: '\u24C8',
    CircleMinus: '\u2296',
    CirclePlus: '\u2295',
    CircleTimes: '\u2297',
    cirE: '\u29C3',
    cire: '\u2257',
    cirfnint: '\u2A10',
    cirmid: '\u2AEF',
    cirscir: '\u29C2',
    ClockwiseContourIntegral: '\u2232',
    CloseCurlyDoubleQuote: '\u201D',
    CloseCurlyQuote: '\u2019',
    clubs: '\u2663',
    clubsuit: '\u2663',
    Colon: '\u2237',
    colon: '\u003A',
    Colone: '\u2A74',
    colone: '\u2254',
    coloneq: '\u2254',
    comma: '\u002C',
    commat: '\u0040',
    comp: '\u2201',
    compfn: '\u2218',
    complement: '\u2201',
    complexes: '\u2102',
    cong: '\u2245',
    congdot: '\u2A6D',
    Congruent: '\u2261',
    Conint: '\u222F',
    conint: '\u222E',
    ContourIntegral: '\u222E',
    Copf: '\u2102',
    copf: '\uD835\uDD54',
    coprod: '\u2210',
    Coproduct: '\u2210',
    COPY: '\u00A9',
    copy: '\u00A9',
    copysr: '\u2117',
    CounterClockwiseContourIntegral: '\u2233',
    crarr: '\u21B5',
    Cross: '\u2A2F',
    cross: '\u2717',
    Cscr: '\uD835\uDC9E',
    cscr: '\uD835\uDCB8',
    csub: '\u2ACF',
    csube: '\u2AD1',
    csup: '\u2AD0',
    csupe: '\u2AD2',
    ctdot: '\u22EF',
    cudarrl: '\u2938',
    cudarrr: '\u2935',
    cuepr: '\u22DE',
    cuesc: '\u22DF',
    cularr: '\u21B6',
    cularrp: '\u293D',
    Cup: '\u22D3',
    cup: '\u222A',
    cupbrcap: '\u2A48',
    CupCap: '\u224D',
    cupcap: '\u2A46',
    cupcup: '\u2A4A',
    cupdot: '\u228D',
    cupor: '\u2A45',
    cups: '\u222A\uFE00',
    curarr: '\u21B7',
    curarrm: '\u293C',
    curlyeqprec: '\u22DE',
    curlyeqsucc: '\u22DF',
    curlyvee: '\u22CE',
    curlywedge: '\u22CF',
    curren: '\u00A4',
    curvearrowleft: '\u21B6',
    curvearrowright: '\u21B7',
    cuvee: '\u22CE',
    cuwed: '\u22CF',
    cwconint: '\u2232',
    cwint: '\u2231',
    cylcty: '\u232D',
    Dagger: '\u2021',
    dagger: '\u2020',
    daleth: '\u2138',
    Darr: '\u21A1',
    dArr: '\u21D3',
    darr: '\u2193',
    dash: '\u2010',
    Dashv: '\u2AE4',
    dashv: '\u22A3',
    dbkarow: '\u290F',
    dblac: '\u02DD',
    Dcaron: '\u010E',
    dcaron: '\u010F',
    Dcy: '\u0414',
    dcy: '\u0434',
    DD: '\u2145',
    dd: '\u2146',
    ddagger: '\u2021',
    ddarr: '\u21CA',
    DDotrahd: '\u2911',
    ddotseq: '\u2A77',
    deg: '\u00B0',
    Del: '\u2207',
    Delta: '\u0394',
    delta: '\u03B4',
    demptyv: '\u29B1',
    dfisht: '\u297F',
    Dfr: '\uD835\uDD07',
    dfr: '\uD835\uDD21',
    dHar: '\u2965',
    dharl: '\u21C3',
    dharr: '\u21C2',
    DiacriticalAcute: '\u00B4',
    DiacriticalDot: '\u02D9',
    DiacriticalDoubleAcute: '\u02DD',
    DiacriticalGrave: '\u0060',
    DiacriticalTilde: '\u02DC',
    diam: '\u22C4',
    Diamond: '\u22C4',
    diamond: '\u22C4',
    diamondsuit: '\u2666',
    diams: '\u2666',
    die: '\u00A8',
    DifferentialD: '\u2146',
    digamma: '\u03DD',
    disin: '\u22F2',
    div: '\u00F7',
    divide: '\u00F7',
    divideontimes: '\u22C7',
    divonx: '\u22C7',
    DJcy: '\u0402',
    djcy: '\u0452',
    dlcorn: '\u231E',
    dlcrop: '\u230D',
    dollar: '\u0024',
    Dopf: '\uD835\uDD3B',
    dopf: '\uD835\uDD55',
    Dot: '\u00A8',
    dot: '\u02D9',
    DotDot: '\u20DC',
    doteq: '\u2250',
    doteqdot: '\u2251',
    DotEqual: '\u2250',
    dotminus: '\u2238',
    dotplus: '\u2214',
    dotsquare: '\u22A1',
    doublebarwedge: '\u2306',
    DoubleContourIntegral: '\u222F',
    DoubleDot: '\u00A8',
    DoubleDownArrow: '\u21D3',
    DoubleLeftArrow: '\u21D0',
    DoubleLeftRightArrow: '\u21D4',
    DoubleLeftTee: '\u2AE4',
    DoubleLongLeftArrow: '\u27F8',
    DoubleLongLeftRightArrow: '\u27FA',
    DoubleLongRightArrow: '\u27F9',
    DoubleRightArrow: '\u21D2',
    DoubleRightTee: '\u22A8',
    DoubleUpArrow: '\u21D1',
    DoubleUpDownArrow: '\u21D5',
    DoubleVerticalBar: '\u2225',
    DownArrow: '\u2193',
    Downarrow: '\u21D3',
    downarrow: '\u2193',
    DownArrowBar: '\u2913',
    DownArrowUpArrow: '\u21F5',
    DownBreve: '\u0311',
    downdownarrows: '\u21CA',
    downharpoonleft: '\u21C3',
    downharpoonright: '\u21C2',
    DownLeftRightVector: '\u2950',
    DownLeftTeeVector: '\u295E',
    DownLeftVector: '\u21BD',
    DownLeftVectorBar: '\u2956',
    DownRightTeeVector: '\u295F',
    DownRightVector: '\u21C1',
    DownRightVectorBar: '\u2957',
    DownTee: '\u22A4',
    DownTeeArrow: '\u21A7',
    drbkarow: '\u2910',
    drcorn: '\u231F',
    drcrop: '\u230C',
    Dscr: '\uD835\uDC9F',
    dscr: '\uD835\uDCB9',
    DScy: '\u0405',
    dscy: '\u0455',
    dsol: '\u29F6',
    Dstrok: '\u0110',
    dstrok: '\u0111',
    dtdot: '\u22F1',
    dtri: '\u25BF',
    dtrif: '\u25BE',
    duarr: '\u21F5',
    duhar: '\u296F',
    dwangle: '\u29A6',
    DZcy: '\u040F',
    dzcy: '\u045F',
    dzigrarr: '\u27FF',
    Eacute: '\u00C9',
    eacute: '\u00E9',
    easter: '\u2A6E',
    Ecaron: '\u011A',
    ecaron: '\u011B',
    ecir: '\u2256',
    Ecirc: '\u00CA',
    ecirc: '\u00EA',
    ecolon: '\u2255',
    Ecy: '\u042D',
    ecy: '\u044D',
    eDDot: '\u2A77',
    Edot: '\u0116',
    eDot: '\u2251',
    edot: '\u0117',
    ee: '\u2147',
    efDot: '\u2252',
    Efr: '\uD835\uDD08',
    efr: '\uD835\uDD22',
    eg: '\u2A9A',
    Egrave: '\u00C8',
    egrave: '\u00E8',
    egs: '\u2A96',
    egsdot: '\u2A98',
    el: '\u2A99',
    Element: '\u2208',
    elinters: '\u23E7',
    ell: '\u2113',
    els: '\u2A95',
    elsdot: '\u2A97',
    Emacr: '\u0112',
    emacr: '\u0113',
    empty: '\u2205',
    emptyset: '\u2205',
    EmptySmallSquare: '\u25FB',
    emptyv: '\u2205',
    EmptyVerySmallSquare: '\u25AB',
    emsp: '\u2003',
    emsp13: '\u2004',
    emsp14: '\u2005',
    ENG: '\u014A',
    eng: '\u014B',
    ensp: '\u2002',
    Eogon: '\u0118',
    eogon: '\u0119',
    Eopf: '\uD835\uDD3C',
    eopf: '\uD835\uDD56',
    epar: '\u22D5',
    eparsl: '\u29E3',
    eplus: '\u2A71',
    epsi: '\u03B5',
    Epsilon: '\u0395',
    epsilon: '\u03B5',
    epsiv: '\u03F5',
    eqcirc: '\u2256',
    eqcolon: '\u2255',
    eqsim: '\u2242',
    eqslantgtr: '\u2A96',
    eqslantless: '\u2A95',
    Equal: '\u2A75',
    equals: '\u003D',
    EqualTilde: '\u2242',
    equest: '\u225F',
    Equilibrium: '\u21CC',
    equiv: '\u2261',
    equivDD: '\u2A78',
    eqvparsl: '\u29E5',
    erarr: '\u2971',
    erDot: '\u2253',
    Escr: '\u2130',
    escr: '\u212F',
    esdot: '\u2250',
    Esim: '\u2A73',
    esim: '\u2242',
    Eta: '\u0397',
    eta: '\u03B7',
    ETH: '\u00D0',
    eth: '\u00F0',
    Euml: '\u00CB',
    euml: '\u00EB',
    euro: '\u20AC',
    excl: '\u0021',
    exist: '\u2203',
    Exists: '\u2203',
    expectation: '\u2130',
    ExponentialE: '\u2147',
    exponentiale: '\u2147',
    fallingdotseq: '\u2252',
    Fcy: '\u0424',
    fcy: '\u0444',
    female: '\u2640',
    ffilig: '\uFB03',
    fflig: '\uFB00',
    ffllig: '\uFB04',
    Ffr: '\uD835\uDD09',
    ffr: '\uD835\uDD23',
    filig: '\uFB01',
    FilledSmallSquare: '\u25FC',
    FilledVerySmallSquare: '\u25AA',
    fjlig: '\u0066\u006A',
    flat: '\u266D',
    fllig: '\uFB02',
    fltns: '\u25B1',
    fnof: '\u0192',
    Fopf: '\uD835\uDD3D',
    fopf: '\uD835\uDD57',
    ForAll: '\u2200',
    forall: '\u2200',
    fork: '\u22D4',
    forkv: '\u2AD9',
    Fouriertrf: '\u2131',
    fpartint: '\u2A0D',
    frac12: '\u00BD',
    frac13: '\u2153',
    frac14: '\u00BC',
    frac15: '\u2155',
    frac16: '\u2159',
    frac18: '\u215B',
    frac23: '\u2154',
    frac25: '\u2156',
    frac34: '\u00BE',
    frac35: '\u2157',
    frac38: '\u215C',
    frac45: '\u2158',
    frac56: '\u215A',
    frac58: '\u215D',
    frac78: '\u215E',
    frasl: '\u2044',
    frown: '\u2322',
    Fscr: '\u2131',
    fscr: '\uD835\uDCBB',
    gacute: '\u01F5',
    Gamma: '\u0393',
    gamma: '\u03B3',
    Gammad: '\u03DC',
    gammad: '\u03DD',
    gap: '\u2A86',
    Gbreve: '\u011E',
    gbreve: '\u011F',
    Gcedil: '\u0122',
    Gcirc: '\u011C',
    gcirc: '\u011D',
    Gcy: '\u0413',
    gcy: '\u0433',
    Gdot: '\u0120',
    gdot: '\u0121',
    gE: '\u2267',
    ge: '\u2265',
    gEl: '\u2A8C',
    gel: '\u22DB',
    geq: '\u2265',
    geqq: '\u2267',
    geqslant: '\u2A7E',
    ges: '\u2A7E',
    gescc: '\u2AA9',
    gesdot: '\u2A80',
    gesdoto: '\u2A82',
    gesdotol: '\u2A84',
    gesl: '\u22DB\uFE00',
    gesles: '\u2A94',
    Gfr: '\uD835\uDD0A',
    gfr: '\uD835\uDD24',
    Gg: '\u22D9',
    gg: '\u226B',
    ggg: '\u22D9',
    gimel: '\u2137',
    GJcy: '\u0403',
    gjcy: '\u0453',
    gl: '\u2277',
    gla: '\u2AA5',
    glE: '\u2A92',
    glj: '\u2AA4',
    gnap: '\u2A8A',
    gnapprox: '\u2A8A',
    gnE: '\u2269',
    gne: '\u2A88',
    gneq: '\u2A88',
    gneqq: '\u2269',
    gnsim: '\u22E7',
    Gopf: '\uD835\uDD3E',
    gopf: '\uD835\uDD58',
    grave: '\u0060',
    GreaterEqual: '\u2265',
    GreaterEqualLess: '\u22DB',
    GreaterFullEqual: '\u2267',
    GreaterGreater: '\u2AA2',
    GreaterLess: '\u2277',
    GreaterSlantEqual: '\u2A7E',
    GreaterTilde: '\u2273',
    Gscr: '\uD835\uDCA2',
    gscr: '\u210A',
    gsim: '\u2273',
    gsime: '\u2A8E',
    gsiml: '\u2A90',
    Gt: '\u226B',
    GT: '\u003E',
    gt: '\u003E',
    gtcc: '\u2AA7',
    gtcir: '\u2A7A',
    gtdot: '\u22D7',
    gtlPar: '\u2995',
    gtquest: '\u2A7C',
    gtrapprox: '\u2A86',
    gtrarr: '\u2978',
    gtrdot: '\u22D7',
    gtreqless: '\u22DB',
    gtreqqless: '\u2A8C',
    gtrless: '\u2277',
    gtrsim: '\u2273',
    gvertneqq: '\u2269\uFE00',
    gvnE: '\u2269\uFE00',
    Hacek: '\u02C7',
    hairsp: '\u200A',
    half: '\u00BD',
    hamilt: '\u210B',
    HARDcy: '\u042A',
    hardcy: '\u044A',
    hArr: '\u21D4',
    harr: '\u2194',
    harrcir: '\u2948',
    harrw: '\u21AD',
    Hat: '\u005E',
    hbar: '\u210F',
    Hcirc: '\u0124',
    hcirc: '\u0125',
    hearts: '\u2665',
    heartsuit: '\u2665',
    hellip: '\u2026',
    hercon: '\u22B9',
    Hfr: '\u210C',
    hfr: '\uD835\uDD25',
    HilbertSpace: '\u210B',
    hksearow: '\u2925',
    hkswarow: '\u2926',
    hoarr: '\u21FF',
    homtht: '\u223B',
    hookleftarrow: '\u21A9',
    hookrightarrow: '\u21AA',
    Hopf: '\u210D',
    hopf: '\uD835\uDD59',
    horbar: '\u2015',
    HorizontalLine: '\u2500',
    Hscr: '\u210B',
    hscr: '\uD835\uDCBD',
    hslash: '\u210F',
    Hstrok: '\u0126',
    hstrok: '\u0127',
    HumpDownHump: '\u224E',
    HumpEqual: '\u224F',
    hybull: '\u2043',
    hyphen: '\u2010',
    Iacute: '\u00CD',
    iacute: '\u00ED',
    ic: '\u2063',
    Icirc: '\u00CE',
    icirc: '\u00EE',
    Icy: '\u0418',
    icy: '\u0438',
    Idot: '\u0130',
    IEcy: '\u0415',
    iecy: '\u0435',
    iexcl: '\u00A1',
    iff: '\u21D4',
    Ifr: '\u2111',
    ifr: '\uD835\uDD26',
    Igrave: '\u00CC',
    igrave: '\u00EC',
    ii: '\u2148',
    iiiint: '\u2A0C',
    iiint: '\u222D',
    iinfin: '\u29DC',
    iiota: '\u2129',
    IJlig: '\u0132',
    ijlig: '\u0133',
    Im: '\u2111',
    Imacr: '\u012A',
    imacr: '\u012B',
    image: '\u2111',
    ImaginaryI: '\u2148',
    imagline: '\u2110',
    imagpart: '\u2111',
    imath: '\u0131',
    imof: '\u22B7',
    imped: '\u01B5',
    Implies: '\u21D2',
    in: '\u2208',
    incare: '\u2105',
    infin: '\u221E',
    infintie: '\u29DD',
    inodot: '\u0131',
    Int: '\u222C',
    int: '\u222B',
    intcal: '\u22BA',
    integers: '\u2124',
    Integral: '\u222B',
    intercal: '\u22BA',
    Intersection: '\u22C2',
    intlarhk: '\u2A17',
    intprod: '\u2A3C',
    InvisibleComma: '\u2063',
    InvisibleTimes: '\u2062',
    IOcy: '\u0401',
    iocy: '\u0451',
    Iogon: '\u012E',
    iogon: '\u012F',
    Iopf: '\uD835\uDD40',
    iopf: '\uD835\uDD5A',
    Iota: '\u0399',
    iota: '\u03B9',
    iprod: '\u2A3C',
    iquest: '\u00BF',
    Iscr: '\u2110',
    iscr: '\uD835\uDCBE',
    isin: '\u2208',
    isindot: '\u22F5',
    isinE: '\u22F9',
    isins: '\u22F4',
    isinsv: '\u22F3',
    isinv: '\u2208',
    it: '\u2062',
    Itilde: '\u0128',
    itilde: '\u0129',
    Iukcy: '\u0406',
    iukcy: '\u0456',
    Iuml: '\u00CF',
    iuml: '\u00EF',
    Jcirc: '\u0134',
    jcirc: '\u0135',
    Jcy: '\u0419',
    jcy: '\u0439',
    Jfr: '\uD835\uDD0D',
    jfr: '\uD835\uDD27',
    jmath: '\u0237',
    Jopf: '\uD835\uDD41',
    jopf: '\uD835\uDD5B',
    Jscr: '\uD835\uDCA5',
    jscr: '\uD835\uDCBF',
    Jsercy: '\u0408',
    jsercy: '\u0458',
    Jukcy: '\u0404',
    jukcy: '\u0454',
    Kappa: '\u039A',
    kappa: '\u03BA',
    kappav: '\u03F0',
    Kcedil: '\u0136',
    kcedil: '\u0137',
    Kcy: '\u041A',
    kcy: '\u043A',
    Kfr: '\uD835\uDD0E',
    kfr: '\uD835\uDD28',
    kgreen: '\u0138',
    KHcy: '\u0425',
    khcy: '\u0445',
    KJcy: '\u040C',
    kjcy: '\u045C',
    Kopf: '\uD835\uDD42',
    kopf: '\uD835\uDD5C',
    Kscr: '\uD835\uDCA6',
    kscr: '\uD835\uDCC0',
    lAarr: '\u21DA',
    Lacute: '\u0139',
    lacute: '\u013A',
    laemptyv: '\u29B4',
    lagran: '\u2112',
    Lambda: '\u039B',
    lambda: '\u03BB',
    Lang: '\u27EA',
    lang: '\u27E8',
    langd: '\u2991',
    langle: '\u27E8',
    lap: '\u2A85',
    Laplacetrf: '\u2112',
    laquo: '\u00AB',
    Larr: '\u219E',
    lArr: '\u21D0',
    larr: '\u2190',
    larrb: '\u21E4',
    larrbfs: '\u291F',
    larrfs: '\u291D',
    larrhk: '\u21A9',
    larrlp: '\u21AB',
    larrpl: '\u2939',
    larrsim: '\u2973',
    larrtl: '\u21A2',
    lat: '\u2AAB',
    lAtail: '\u291B',
    latail: '\u2919',
    late: '\u2AAD',
    lates: '\u2AAD\uFE00',
    lBarr: '\u290E',
    lbarr: '\u290C',
    lbbrk: '\u2772',
    lbrace: '\u007B',
    lbrack: '\u005B',
    lbrke: '\u298B',
    lbrksld: '\u298F',
    lbrkslu: '\u298D',
    Lcaron: '\u013D',
    lcaron: '\u013E',
    Lcedil: '\u013B',
    lcedil: '\u013C',
    lceil: '\u2308',
    lcub: '\u007B',
    Lcy: '\u041B',
    lcy: '\u043B',
    ldca: '\u2936',
    ldquo: '\u201C',
    ldquor: '\u201E',
    ldrdhar: '\u2967',
    ldrushar: '\u294B',
    ldsh: '\u21B2',
    lE: '\u2266',
    le: '\u2264',
    LeftAngleBracket: '\u27E8',
    LeftArrow: '\u2190',
    Leftarrow: '\u21D0',
    leftarrow: '\u2190',
    LeftArrowBar: '\u21E4',
    LeftArrowRightArrow: '\u21C6',
    leftarrowtail: '\u21A2',
    LeftCeiling: '\u2308',
    LeftDoubleBracket: '\u27E6',
    LeftDownTeeVector: '\u2961',
    LeftDownVector: '\u21C3',
    LeftDownVectorBar: '\u2959',
    LeftFloor: '\u230A',
    leftharpoondown: '\u21BD',
    leftharpoonup: '\u21BC',
    leftleftarrows: '\u21C7',
    LeftRightArrow: '\u2194',
    Leftrightarrow: '\u21D4',
    leftrightarrow: '\u2194',
    leftrightarrows: '\u21C6',
    leftrightharpoons: '\u21CB',
    leftrightsquigarrow: '\u21AD',
    LeftRightVector: '\u294E',
    LeftTee: '\u22A3',
    LeftTeeArrow: '\u21A4',
    LeftTeeVector: '\u295A',
    leftthreetimes: '\u22CB',
    LeftTriangle: '\u22B2',
    LeftTriangleBar: '\u29CF',
    LeftTriangleEqual: '\u22B4',
    LeftUpDownVector: '\u2951',
    LeftUpTeeVector: '\u2960',
    LeftUpVector: '\u21BF',
    LeftUpVectorBar: '\u2958',
    LeftVector: '\u21BC',
    LeftVectorBar: '\u2952',
    lEg: '\u2A8B',
    leg: '\u22DA',
    leq: '\u2264',
    leqq: '\u2266',
    leqslant: '\u2A7D',
    les: '\u2A7D',
    lescc: '\u2AA8',
    lesdot: '\u2A7F',
    lesdoto: '\u2A81',
    lesdotor: '\u2A83',
    lesg: '\u22DA\uFE00',
    lesges: '\u2A93',
    lessapprox: '\u2A85',
    lessdot: '\u22D6',
    lesseqgtr: '\u22DA',
    lesseqqgtr: '\u2A8B',
    LessEqualGreater: '\u22DA',
    LessFullEqual: '\u2266',
    LessGreater: '\u2276',
    lessgtr: '\u2276',
    LessLess: '\u2AA1',
    lesssim: '\u2272',
    LessSlantEqual: '\u2A7D',
    LessTilde: '\u2272',
    lfisht: '\u297C',
    lfloor: '\u230A',
    Lfr: '\uD835\uDD0F',
    lfr: '\uD835\uDD29',
    lg: '\u2276',
    lgE: '\u2A91',
    lHar: '\u2962',
    lhard: '\u21BD',
    lharu: '\u21BC',
    lharul: '\u296A',
    lhblk: '\u2584',
    LJcy: '\u0409',
    ljcy: '\u0459',
    Ll: '\u22D8',
    ll: '\u226A',
    llarr: '\u21C7',
    llcorner: '\u231E',
    Lleftarrow: '\u21DA',
    llhard: '\u296B',
    lltri: '\u25FA',
    Lmidot: '\u013F',
    lmidot: '\u0140',
    lmoust: '\u23B0',
    lmoustache: '\u23B0',
    lnap: '\u2A89',
    lnapprox: '\u2A89',
    lnE: '\u2268',
    lne: '\u2A87',
    lneq: '\u2A87',
    lneqq: '\u2268',
    lnsim: '\u22E6',
    loang: '\u27EC',
    loarr: '\u21FD',
    lobrk: '\u27E6',
    LongLeftArrow: '\u27F5',
    Longleftarrow: '\u27F8',
    longleftarrow: '\u27F5',
    LongLeftRightArrow: '\u27F7',
    Longleftrightarrow: '\u27FA',
    longleftrightarrow: '\u27F7',
    longmapsto: '\u27FC',
    LongRightArrow: '\u27F6',
    Longrightarrow: '\u27F9',
    longrightarrow: '\u27F6',
    looparrowleft: '\u21AB',
    looparrowright: '\u21AC',
    lopar: '\u2985',
    Lopf: '\uD835\uDD43',
    lopf: '\uD835\uDD5D',
    loplus: '\u2A2D',
    lotimes: '\u2A34',
    lowast: '\u2217',
    lowbar: '\u005F',
    LowerLeftArrow: '\u2199',
    LowerRightArrow: '\u2198',
    loz: '\u25CA',
    lozenge: '\u25CA',
    lozf: '\u29EB',
    lpar: '\u0028',
    lparlt: '\u2993',
    lrarr: '\u21C6',
    lrcorner: '\u231F',
    lrhar: '\u21CB',
    lrhard: '\u296D',
    lrm: '\u200E',
    lrtri: '\u22BF',
    lsaquo: '\u2039',
    Lscr: '\u2112',
    lscr: '\uD835\uDCC1',
    Lsh: '\u21B0',
    lsh: '\u21B0',
    lsim: '\u2272',
    lsime: '\u2A8D',
    lsimg: '\u2A8F',
    lsqb: '\u005B',
    lsquo: '\u2018',
    lsquor: '\u201A',
    Lstrok: '\u0141',
    lstrok: '\u0142',
    Lt: '\u226A',
    LT: '\u003C',
    lt: '\u003C',
    ltcc: '\u2AA6',
    ltcir: '\u2A79',
    ltdot: '\u22D6',
    lthree: '\u22CB',
    ltimes: '\u22C9',
    ltlarr: '\u2976',
    ltquest: '\u2A7B',
    ltri: '\u25C3',
    ltrie: '\u22B4',
    ltrif: '\u25C2',
    ltrPar: '\u2996',
    lurdshar: '\u294A',
    luruhar: '\u2966',
    lvertneqq: '\u2268\uFE00',
    lvnE: '\u2268\uFE00',
    macr: '\u00AF',
    male: '\u2642',
    malt: '\u2720',
    maltese: '\u2720',
    Map: '\u2905',
    map: '\u21A6',
    mapsto: '\u21A6',
    mapstodown: '\u21A7',
    mapstoleft: '\u21A4',
    mapstoup: '\u21A5',
    marker: '\u25AE',
    mcomma: '\u2A29',
    Mcy: '\u041C',
    mcy: '\u043C',
    mdash: '\u2014',
    mDDot: '\u223A',
    measuredangle: '\u2221',
    MediumSpace: '\u205F',
    Mellintrf: '\u2133',
    Mfr: '\uD835\uDD10',
    mfr: '\uD835\uDD2A',
    mho: '\u2127',
    micro: '\u00B5',
    mid: '\u2223',
    midast: '\u002A',
    midcir: '\u2AF0',
    middot: '\u00B7',
    minus: '\u2212',
    minusb: '\u229F',
    minusd: '\u2238',
    minusdu: '\u2A2A',
    MinusPlus: '\u2213',
    mlcp: '\u2ADB',
    mldr: '\u2026',
    mnplus: '\u2213',
    models: '\u22A7',
    Mopf: '\uD835\uDD44',
    mopf: '\uD835\uDD5E',
    mp: '\u2213',
    Mscr: '\u2133',
    mscr: '\uD835\uDCC2',
    mstpos: '\u223E',
    Mu: '\u039C',
    mu: '\u03BC',
    multimap: '\u22B8',
    mumap: '\u22B8',
    nabla: '\u2207',
    Nacute: '\u0143',
    nacute: '\u0144',
    nang: '\u2220\u20D2',
    nap: '\u2249',
    napE: '\u2A70\u0338',
    napid: '\u224B\u0338',
    napos: '\u0149',
    napprox: '\u2249',
    natur: '\u266E',
    natural: '\u266E',
    naturals: '\u2115',
    nbsp: '\u00A0',
    nbump: '\u224E\u0338',
    nbumpe: '\u224F\u0338',
    ncap: '\u2A43',
    Ncaron: '\u0147',
    ncaron: '\u0148',
    Ncedil: '\u0145',
    ncedil: '\u0146',
    ncong: '\u2247',
    ncongdot: '\u2A6D\u0338',
    ncup: '\u2A42',
    Ncy: '\u041D',
    ncy: '\u043D',
    ndash: '\u2013',
    ne: '\u2260',
    nearhk: '\u2924',
    neArr: '\u21D7',
    nearr: '\u2197',
    nearrow: '\u2197',
    nedot: '\u2250\u0338',
    NegativeMediumSpace: '\u200B',
    NegativeThickSpace: '\u200B',
    NegativeThinSpace: '\u200B',
    NegativeVeryThinSpace: '\u200B',
    nequiv: '\u2262',
    nesear: '\u2928',
    nesim: '\u2242\u0338',
    NestedGreaterGreater: '\u226B',
    NestedLessLess: '\u226A',
    NewLine: '\u000A',
    nexist: '\u2204',
    nexists: '\u2204',
    Nfr: '\uD835\uDD11',
    nfr: '\uD835\uDD2B',
    ngE: '\u2267\u0338',
    nge: '\u2271',
    ngeq: '\u2271',
    ngeqq: '\u2267\u0338',
    ngeqslant: '\u2A7E\u0338',
    nges: '\u2A7E\u0338',
    nGg: '\u22D9\u0338',
    ngsim: '\u2275',
    nGt: '\u226B\u20D2',
    ngt: '\u226F',
    ngtr: '\u226F',
    nGtv: '\u226B\u0338',
    nhArr: '\u21CE',
    nharr: '\u21AE',
    nhpar: '\u2AF2',
    ni: '\u220B',
    nis: '\u22FC',
    nisd: '\u22FA',
    niv: '\u220B',
    NJcy: '\u040A',
    njcy: '\u045A',
    nlArr: '\u21CD',
    nlarr: '\u219A',
    nldr: '\u2025',
    nlE: '\u2266\u0338',
    nle: '\u2270',
    nLeftarrow: '\u21CD',
    nleftarrow: '\u219A',
    nLeftrightarrow: '\u21CE',
    nleftrightarrow: '\u21AE',
    nleq: '\u2270',
    nleqq: '\u2266\u0338',
    nleqslant: '\u2A7D\u0338',
    nles: '\u2A7D\u0338',
    nless: '\u226E',
    nLl: '\u22D8\u0338',
    nlsim: '\u2274',
    nLt: '\u226A\u20D2',
    nlt: '\u226E',
    nltri: '\u22EA',
    nltrie: '\u22EC',
    nLtv: '\u226A\u0338',
    nmid: '\u2224',
    NoBreak: '\u2060',
    NonBreakingSpace: '\u00A0',
    Nopf: '\u2115',
    nopf: '\uD835\uDD5F',
    Not: '\u2AEC',
    not: '\u00AC',
    NotCongruent: '\u2262',
    NotCupCap: '\u226D',
    NotDoubleVerticalBar: '\u2226',
    NotElement: '\u2209',
    NotEqual: '\u2260',
    NotEqualTilde: '\u2242\u0338',
    NotExists: '\u2204',
    NotGreater: '\u226F',
    NotGreaterEqual: '\u2271',
    NotGreaterFullEqual: '\u2267\u0338',
    NotGreaterGreater: '\u226B\u0338',
    NotGreaterLess: '\u2279',
    NotGreaterSlantEqual: '\u2A7E\u0338',
    NotGreaterTilde: '\u2275',
    NotHumpDownHump: '\u224E\u0338',
    NotHumpEqual: '\u224F\u0338',
    notin: '\u2209',
    notindot: '\u22F5\u0338',
    notinE: '\u22F9\u0338',
    notinva: '\u2209',
    notinvb: '\u22F7',
    notinvc: '\u22F6',
    NotLeftTriangle: '\u22EA',
    NotLeftTriangleBar: '\u29CF\u0338',
    NotLeftTriangleEqual: '\u22EC',
    NotLess: '\u226E',
    NotLessEqual: '\u2270',
    NotLessGreater: '\u2278',
    NotLessLess: '\u226A\u0338',
    NotLessSlantEqual: '\u2A7D\u0338',
    NotLessTilde: '\u2274',
    NotNestedGreaterGreater: '\u2AA2\u0338',
    NotNestedLessLess: '\u2AA1\u0338',
    notni: '\u220C',
    notniva: '\u220C',
    notnivb: '\u22FE',
    notnivc: '\u22FD',
    NotPrecedes: '\u2280',
    NotPrecedesEqual: '\u2AAF\u0338',
    NotPrecedesSlantEqual: '\u22E0',
    NotReverseElement: '\u220C',
    NotRightTriangle: '\u22EB',
    NotRightTriangleBar: '\u29D0\u0338',
    NotRightTriangleEqual: '\u22ED',
    NotSquareSubset: '\u228F\u0338',
    NotSquareSubsetEqual: '\u22E2',
    NotSquareSuperset: '\u2290\u0338',
    NotSquareSupersetEqual: '\u22E3',
    NotSubset: '\u2282\u20D2',
    NotSubsetEqual: '\u2288',
    NotSucceeds: '\u2281',
    NotSucceedsEqual: '\u2AB0\u0338',
    NotSucceedsSlantEqual: '\u22E1',
    NotSucceedsTilde: '\u227F\u0338',
    NotSuperset: '\u2283\u20D2',
    NotSupersetEqual: '\u2289',
    NotTilde: '\u2241',
    NotTildeEqual: '\u2244',
    NotTildeFullEqual: '\u2247',
    NotTildeTilde: '\u2249',
    NotVerticalBar: '\u2224',
    npar: '\u2226',
    nparallel: '\u2226',
    nparsl: '\u2AFD\u20E5',
    npart: '\u2202\u0338',
    npolint: '\u2A14',
    npr: '\u2280',
    nprcue: '\u22E0',
    npre: '\u2AAF\u0338',
    nprec: '\u2280',
    npreceq: '\u2AAF\u0338',
    nrArr: '\u21CF',
    nrarr: '\u219B',
    nrarrc: '\u2933\u0338',
    nrarrw: '\u219D\u0338',
    nRightarrow: '\u21CF',
    nrightarrow: '\u219B',
    nrtri: '\u22EB',
    nrtrie: '\u22ED',
    nsc: '\u2281',
    nsccue: '\u22E1',
    nsce: '\u2AB0\u0338',
    Nscr: '\uD835\uDCA9',
    nscr: '\uD835\uDCC3',
    nshortmid: '\u2224',
    nshortparallel: '\u2226',
    nsim: '\u2241',
    nsime: '\u2244',
    nsimeq: '\u2244',
    nsmid: '\u2224',
    nspar: '\u2226',
    nsqsube: '\u22E2',
    nsqsupe: '\u22E3',
    nsub: '\u2284',
    nsubE: '\u2AC5\u0338',
    nsube: '\u2288',
    nsubset: '\u2282\u20D2',
    nsubseteq: '\u2288',
    nsubseteqq: '\u2AC5\u0338',
    nsucc: '\u2281',
    nsucceq: '\u2AB0\u0338',
    nsup: '\u2285',
    nsupE: '\u2AC6\u0338',
    nsupe: '\u2289',
    nsupset: '\u2283\u20D2',
    nsupseteq: '\u2289',
    nsupseteqq: '\u2AC6\u0338',
    ntgl: '\u2279',
    Ntilde: '\u00D1',
    ntilde: '\u00F1',
    ntlg: '\u2278',
    ntriangleleft: '\u22EA',
    ntrianglelefteq: '\u22EC',
    ntriangleright: '\u22EB',
    ntrianglerighteq: '\u22ED',
    Nu: '\u039D',
    nu: '\u03BD',
    num: '\u0023',
    numero: '\u2116',
    numsp: '\u2007',
    nvap: '\u224D\u20D2',
    nVDash: '\u22AF',
    nVdash: '\u22AE',
    nvDash: '\u22AD',
    nvdash: '\u22AC',
    nvge: '\u2265\u20D2',
    nvgt: '\u003E\u20D2',
    nvHarr: '\u2904',
    nvinfin: '\u29DE',
    nvlArr: '\u2902',
    nvle: '\u2264\u20D2',
    nvlt: '\u003C\u20D2',
    nvltrie: '\u22B4\u20D2',
    nvrArr: '\u2903',
    nvrtrie: '\u22B5\u20D2',
    nvsim: '\u223C\u20D2',
    nwarhk: '\u2923',
    nwArr: '\u21D6',
    nwarr: '\u2196',
    nwarrow: '\u2196',
    nwnear: '\u2927',
    Oacute: '\u00D3',
    oacute: '\u00F3',
    oast: '\u229B',
    ocir: '\u229A',
    Ocirc: '\u00D4',
    ocirc: '\u00F4',
    Ocy: '\u041E',
    ocy: '\u043E',
    odash: '\u229D',
    Odblac: '\u0150',
    odblac: '\u0151',
    odiv: '\u2A38',
    odot: '\u2299',
    odsold: '\u29BC',
    OElig: '\u0152',
    oelig: '\u0153',
    ofcir: '\u29BF',
    Ofr: '\uD835\uDD12',
    ofr: '\uD835\uDD2C',
    ogon: '\u02DB',
    Ograve: '\u00D2',
    ograve: '\u00F2',
    ogt: '\u29C1',
    ohbar: '\u29B5',
    ohm: '\u03A9',
    oint: '\u222E',
    olarr: '\u21BA',
    olcir: '\u29BE',
    olcross: '\u29BB',
    oline: '\u203E',
    olt: '\u29C0',
    Omacr: '\u014C',
    omacr: '\u014D',
    Omega: '\u03A9',
    omega: '\u03C9',
    Omicron: '\u039F',
    omicron: '\u03BF',
    omid: '\u29B6',
    ominus: '\u2296',
    Oopf: '\uD835\uDD46',
    oopf: '\uD835\uDD60',
    opar: '\u29B7',
    OpenCurlyDoubleQuote: '\u201C',
    OpenCurlyQuote: '\u2018',
    operp: '\u29B9',
    oplus: '\u2295',
    Or: '\u2A54',
    or: '\u2228',
    orarr: '\u21BB',
    ord: '\u2A5D',
    order: '\u2134',
    orderof: '\u2134',
    ordf: '\u00AA',
    ordm: '\u00BA',
    origof: '\u22B6',
    oror: '\u2A56',
    orslope: '\u2A57',
    orv: '\u2A5B',
    oS: '\u24C8',
    Oscr: '\uD835\uDCAA',
    oscr: '\u2134',
    Oslash: '\u00D8',
    oslash: '\u00F8',
    osol: '\u2298',
    Otilde: '\u00D5',
    otilde: '\u00F5',
    Otimes: '\u2A37',
    otimes: '\u2297',
    otimesas: '\u2A36',
    Ouml: '\u00D6',
    ouml: '\u00F6',
    ovbar: '\u233D',
    OverBar: '\u203E',
    OverBrace: '\u23DE',
    OverBracket: '\u23B4',
    OverParenthesis: '\u23DC',
    par: '\u2225',
    para: '\u00B6',
    parallel: '\u2225',
    parsim: '\u2AF3',
    parsl: '\u2AFD',
    part: '\u2202',
    PartialD: '\u2202',
    Pcy: '\u041F',
    pcy: '\u043F',
    percnt: '\u0025',
    period: '\u002E',
    permil: '\u2030',
    perp: '\u22A5',
    pertenk: '\u2031',
    Pfr: '\uD835\uDD13',
    pfr: '\uD835\uDD2D',
    Phi: '\u03A6',
    phi: '\u03C6',
    phiv: '\u03D5',
    phmmat: '\u2133',
    phone: '\u260E',
    Pi: '\u03A0',
    pi: '\u03C0',
    pitchfork: '\u22D4',
    piv: '\u03D6',
    planck: '\u210F',
    planckh: '\u210E',
    plankv: '\u210F',
    plus: '\u002B',
    plusacir: '\u2A23',
    plusb: '\u229E',
    pluscir: '\u2A22',
    plusdo: '\u2214',
    plusdu: '\u2A25',
    pluse: '\u2A72',
    PlusMinus: '\u00B1',
    plusmn: '\u00B1',
    plussim: '\u2A26',
    plustwo: '\u2A27',
    pm: '\u00B1',
    Poincareplane: '\u210C',
    pointint: '\u2A15',
    Popf: '\u2119',
    popf: '\uD835\uDD61',
    pound: '\u00A3',
    Pr: '\u2ABB',
    pr: '\u227A',
    prap: '\u2AB7',
    prcue: '\u227C',
    prE: '\u2AB3',
    pre: '\u2AAF',
    prec: '\u227A',
    precapprox: '\u2AB7',
    preccurlyeq: '\u227C',
    Precedes: '\u227A',
    PrecedesEqual: '\u2AAF',
    PrecedesSlantEqual: '\u227C',
    PrecedesTilde: '\u227E',
    preceq: '\u2AAF',
    precnapprox: '\u2AB9',
    precneqq: '\u2AB5',
    precnsim: '\u22E8',
    precsim: '\u227E',
    Prime: '\u2033',
    prime: '\u2032',
    primes: '\u2119',
    prnap: '\u2AB9',
    prnE: '\u2AB5',
    prnsim: '\u22E8',
    prod: '\u220F',
    Product: '\u220F',
    profalar: '\u232E',
    profline: '\u2312',
    profsurf: '\u2313',
    prop: '\u221D',
    Proportion: '\u2237',
    Proportional: '\u221D',
    propto: '\u221D',
    prsim: '\u227E',
    prurel: '\u22B0',
    Pscr: '\uD835\uDCAB',
    pscr: '\uD835\uDCC5',
    Psi: '\u03A8',
    psi: '\u03C8',
    puncsp: '\u2008',
    Qfr: '\uD835\uDD14',
    qfr: '\uD835\uDD2E',
    qint: '\u2A0C',
    Qopf: '\u211A',
    qopf: '\uD835\uDD62',
    qprime: '\u2057',
    Qscr: '\uD835\uDCAC',
    qscr: '\uD835\uDCC6',
    quaternions: '\u210D',
    quatint: '\u2A16',
    quest: '\u003F',
    questeq: '\u225F',
    QUOT: '\u0022',
    quot: '\u0022',
    rAarr: '\u21DB',
    race: '\u223D\u0331',
    Racute: '\u0154',
    racute: '\u0155',
    radic: '\u221A',
    raemptyv: '\u29B3',
    Rang: '\u27EB',
    rang: '\u27E9',
    rangd: '\u2992',
    range: '\u29A5',
    rangle: '\u27E9',
    raquo: '\u00BB',
    Rarr: '\u21A0',
    rArr: '\u21D2',
    rarr: '\u2192',
    rarrap: '\u2975',
    rarrb: '\u21E5',
    rarrbfs: '\u2920',
    rarrc: '\u2933',
    rarrfs: '\u291E',
    rarrhk: '\u21AA',
    rarrlp: '\u21AC',
    rarrpl: '\u2945',
    rarrsim: '\u2974',
    Rarrtl: '\u2916',
    rarrtl: '\u21A3',
    rarrw: '\u219D',
    rAtail: '\u291C',
    ratail: '\u291A',
    ratio: '\u2236',
    rationals: '\u211A',
    RBarr: '\u2910',
    rBarr: '\u290F',
    rbarr: '\u290D',
    rbbrk: '\u2773',
    rbrace: '\u007D',
    rbrack: '\u005D',
    rbrke: '\u298C',
    rbrksld: '\u298E',
    rbrkslu: '\u2990',
    Rcaron: '\u0158',
    rcaron: '\u0159',
    Rcedil: '\u0156',
    rcedil: '\u0157',
    rceil: '\u2309',
    rcub: '\u007D',
    Rcy: '\u0420',
    rcy: '\u0440',
    rdca: '\u2937',
    rdldhar: '\u2969',
    rdquo: '\u201D',
    rdquor: '\u201D',
    rdsh: '\u21B3',
    Re: '\u211C',
    real: '\u211C',
    realine: '\u211B',
    realpart: '\u211C',
    reals: '\u211D',
    rect: '\u25AD',
    REG: '\u00AE',
    reg: '\u00AE',
    ReverseElement: '\u220B',
    ReverseEquilibrium: '\u21CB',
    ReverseUpEquilibrium: '\u296F',
    rfisht: '\u297D',
    rfloor: '\u230B',
    Rfr: '\u211C',
    rfr: '\uD835\uDD2F',
    rHar: '\u2964',
    rhard: '\u21C1',
    rharu: '\u21C0',
    rharul: '\u296C',
    Rho: '\u03A1',
    rho: '\u03C1',
    rhov: '\u03F1',
    RightAngleBracket: '\u27E9',
    RightArrow: '\u2192',
    Rightarrow: '\u21D2',
    rightarrow: '\u2192',
    RightArrowBar: '\u21E5',
    RightArrowLeftArrow: '\u21C4',
    rightarrowtail: '\u21A3',
    RightCeiling: '\u2309',
    RightDoubleBracket: '\u27E7',
    RightDownTeeVector: '\u295D',
    RightDownVector: '\u21C2',
    RightDownVectorBar: '\u2955',
    RightFloor: '\u230B',
    rightharpoondown: '\u21C1',
    rightharpoonup: '\u21C0',
    rightleftarrows: '\u21C4',
    rightleftharpoons: '\u21CC',
    rightrightarrows: '\u21C9',
    rightsquigarrow: '\u219D',
    RightTee: '\u22A2',
    RightTeeArrow: '\u21A6',
    RightTeeVector: '\u295B',
    rightthreetimes: '\u22CC',
    RightTriangle: '\u22B3',
    RightTriangleBar: '\u29D0',
    RightTriangleEqual: '\u22B5',
    RightUpDownVector: '\u294F',
    RightUpTeeVector: '\u295C',
    RightUpVector: '\u21BE',
    RightUpVectorBar: '\u2954',
    RightVector: '\u21C0',
    RightVectorBar: '\u2953',
    ring: '\u02DA',
    risingdotseq: '\u2253',
    rlarr: '\u21C4',
    rlhar: '\u21CC',
    rlm: '\u200F',
    rmoust: '\u23B1',
    rmoustache: '\u23B1',
    rnmid: '\u2AEE',
    roang: '\u27ED',
    roarr: '\u21FE',
    robrk: '\u27E7',
    ropar: '\u2986',
    Ropf: '\u211D',
    ropf: '\uD835\uDD63',
    roplus: '\u2A2E',
    rotimes: '\u2A35',
    RoundImplies: '\u2970',
    rpar: '\u0029',
    rpargt: '\u2994',
    rppolint: '\u2A12',
    rrarr: '\u21C9',
    Rrightarrow: '\u21DB',
    rsaquo: '\u203A',
    Rscr: '\u211B',
    rscr: '\uD835\uDCC7',
    Rsh: '\u21B1',
    rsh: '\u21B1',
    rsqb: '\u005D',
    rsquo: '\u2019',
    rsquor: '\u2019',
    rthree: '\u22CC',
    rtimes: '\u22CA',
    rtri: '\u25B9',
    rtrie: '\u22B5',
    rtrif: '\u25B8',
    rtriltri: '\u29CE',
    RuleDelayed: '\u29F4',
    ruluhar: '\u2968',
    rx: '\u211E',
    Sacute: '\u015A',
    sacute: '\u015B',
    sbquo: '\u201A',
    Sc: '\u2ABC',
    sc: '\u227B',
    scap: '\u2AB8',
    Scaron: '\u0160',
    scaron: '\u0161',
    sccue: '\u227D',
    scE: '\u2AB4',
    sce: '\u2AB0',
    Scedil: '\u015E',
    scedil: '\u015F',
    Scirc: '\u015C',
    scirc: '\u015D',
    scnap: '\u2ABA',
    scnE: '\u2AB6',
    scnsim: '\u22E9',
    scpolint: '\u2A13',
    scsim: '\u227F',
    Scy: '\u0421',
    scy: '\u0441',
    sdot: '\u22C5',
    sdotb: '\u22A1',
    sdote: '\u2A66',
    searhk: '\u2925',
    seArr: '\u21D8',
    searr: '\u2198',
    searrow: '\u2198',
    sect: '\u00A7',
    semi: '\u003B',
    seswar: '\u2929',
    setminus: '\u2216',
    setmn: '\u2216',
    sext: '\u2736',
    Sfr: '\uD835\uDD16',
    sfr: '\uD835\uDD30',
    sfrown: '\u2322',
    sharp: '\u266F',
    SHCHcy: '\u0429',
    shchcy: '\u0449',
    SHcy: '\u0428',
    shcy: '\u0448',
    ShortDownArrow: '\u2193',
    ShortLeftArrow: '\u2190',
    shortmid: '\u2223',
    shortparallel: '\u2225',
    ShortRightArrow: '\u2192',
    ShortUpArrow: '\u2191',
    shy: '\u00AD',
    Sigma: '\u03A3',
    sigma: '\u03C3',
    sigmaf: '\u03C2',
    sigmav: '\u03C2',
    sim: '\u223C',
    simdot: '\u2A6A',
    sime: '\u2243',
    simeq: '\u2243',
    simg: '\u2A9E',
    simgE: '\u2AA0',
    siml: '\u2A9D',
    simlE: '\u2A9F',
    simne: '\u2246',
    simplus: '\u2A24',
    simrarr: '\u2972',
    slarr: '\u2190',
    SmallCircle: '\u2218',
    smallsetminus: '\u2216',
    smashp: '\u2A33',
    smeparsl: '\u29E4',
    smid: '\u2223',
    smile: '\u2323',
    smt: '\u2AAA',
    smte: '\u2AAC',
    smtes: '\u2AAC\uFE00',
    SOFTcy: '\u042C',
    softcy: '\u044C',
    sol: '\u002F',
    solb: '\u29C4',
    solbar: '\u233F',
    Sopf: '\uD835\uDD4A',
    sopf: '\uD835\uDD64',
    spades: '\u2660',
    spadesuit: '\u2660',
    spar: '\u2225',
    sqcap: '\u2293',
    sqcaps: '\u2293\uFE00',
    sqcup: '\u2294',
    sqcups: '\u2294\uFE00',
    Sqrt: '\u221A',
    sqsub: '\u228F',
    sqsube: '\u2291',
    sqsubset: '\u228F',
    sqsubseteq: '\u2291',
    sqsup: '\u2290',
    sqsupe: '\u2292',
    sqsupset: '\u2290',
    sqsupseteq: '\u2292',
    squ: '\u25A1',
    Square: '\u25A1',
    square: '\u25A1',
    SquareIntersection: '\u2293',
    SquareSubset: '\u228F',
    SquareSubsetEqual: '\u2291',
    SquareSuperset: '\u2290',
    SquareSupersetEqual: '\u2292',
    SquareUnion: '\u2294',
    squarf: '\u25AA',
    squf: '\u25AA',
    srarr: '\u2192',
    Sscr: '\uD835\uDCAE',
    sscr: '\uD835\uDCC8',
    ssetmn: '\u2216',
    ssmile: '\u2323',
    sstarf: '\u22C6',
    Star: '\u22C6',
    star: '\u2606',
    starf: '\u2605',
    straightepsilon: '\u03F5',
    straightphi: '\u03D5',
    strns: '\u00AF',
    Sub: '\u22D0',
    sub: '\u2282',
    subdot: '\u2ABD',
    subE: '\u2AC5',
    sube: '\u2286',
    subedot: '\u2AC3',
    submult: '\u2AC1',
    subnE: '\u2ACB',
    subne: '\u228A',
    subplus: '\u2ABF',
    subrarr: '\u2979',
    Subset: '\u22D0',
    subset: '\u2282',
    subseteq: '\u2286',
    subseteqq: '\u2AC5',
    SubsetEqual: '\u2286',
    subsetneq: '\u228A',
    subsetneqq: '\u2ACB',
    subsim: '\u2AC7',
    subsub: '\u2AD5',
    subsup: '\u2AD3',
    succ: '\u227B',
    succapprox: '\u2AB8',
    succcurlyeq: '\u227D',
    Succeeds: '\u227B',
    SucceedsEqual: '\u2AB0',
    SucceedsSlantEqual: '\u227D',
    SucceedsTilde: '\u227F',
    succeq: '\u2AB0',
    succnapprox: '\u2ABA',
    succneqq: '\u2AB6',
    succnsim: '\u22E9',
    succsim: '\u227F',
    SuchThat: '\u220B',
    Sum: '\u2211',
    sum: '\u2211',
    sung: '\u266A',
    Sup: '\u22D1',
    sup: '\u2283',
    sup1: '\u00B9',
    sup2: '\u00B2',
    sup3: '\u00B3',
    supdot: '\u2ABE',
    supdsub: '\u2AD8',
    supE: '\u2AC6',
    supe: '\u2287',
    supedot: '\u2AC4',
    Superset: '\u2283',
    SupersetEqual: '\u2287',
    suphsol: '\u27C9',
    suphsub: '\u2AD7',
    suplarr: '\u297B',
    supmult: '\u2AC2',
    supnE: '\u2ACC',
    supne: '\u228B',
    supplus: '\u2AC0',
    Supset: '\u22D1',
    supset: '\u2283',
    supseteq: '\u2287',
    supseteqq: '\u2AC6',
    supsetneq: '\u228B',
    supsetneqq: '\u2ACC',
    supsim: '\u2AC8',
    supsub: '\u2AD4',
    supsup: '\u2AD6',
    swarhk: '\u2926',
    swArr: '\u21D9',
    swarr: '\u2199',
    swarrow: '\u2199',
    swnwar: '\u292A',
    szlig: '\u00DF',
    Tab: '\u0009',
    target: '\u2316',
    Tau: '\u03A4',
    tau: '\u03C4',
    tbrk: '\u23B4',
    Tcaron: '\u0164',
    tcaron: '\u0165',
    Tcedil: '\u0162',
    tcedil: '\u0163',
    Tcy: '\u0422',
    tcy: '\u0442',
    tdot: '\u20DB',
    telrec: '\u2315',
    Tfr: '\uD835\uDD17',
    tfr: '\uD835\uDD31',
    there4: '\u2234',
    Therefore: '\u2234',
    therefore: '\u2234',
    Theta: '\u0398',
    theta: '\u03B8',
    thetasym: '\u03D1',
    thetav: '\u03D1',
    thickapprox: '\u2248',
    thicksim: '\u223C',
    ThickSpace: '\u205F\u200A',
    thinsp: '\u2009',
    ThinSpace: '\u2009',
    thkap: '\u2248',
    thksim: '\u223C',
    THORN: '\u00DE',
    thorn: '\u00FE',
    Tilde: '\u223C',
    tilde: '\u02DC',
    TildeEqual: '\u2243',
    TildeFullEqual: '\u2245',
    TildeTilde: '\u2248',
    times: '\u00D7',
    timesb: '\u22A0',
    timesbar: '\u2A31',
    timesd: '\u2A30',
    tint: '\u222D',
    toea: '\u2928',
    top: '\u22A4',
    topbot: '\u2336',
    topcir: '\u2AF1',
    Topf: '\uD835\uDD4B',
    topf: '\uD835\uDD65',
    topfork: '\u2ADA',
    tosa: '\u2929',
    tprime: '\u2034',
    TRADE: '\u2122',
    trade: '\u2122',
    triangle: '\u25B5',
    triangledown: '\u25BF',
    triangleleft: '\u25C3',
    trianglelefteq: '\u22B4',
    triangleq: '\u225C',
    triangleright: '\u25B9',
    trianglerighteq: '\u22B5',
    tridot: '\u25EC',
    trie: '\u225C',
    triminus: '\u2A3A',
    TripleDot: '\u20DB',
    triplus: '\u2A39',
    trisb: '\u29CD',
    tritime: '\u2A3B',
    trpezium: '\u23E2',
    Tscr: '\uD835\uDCAF',
    tscr: '\uD835\uDCC9',
    TScy: '\u0426',
    tscy: '\u0446',
    TSHcy: '\u040B',
    tshcy: '\u045B',
    Tstrok: '\u0166',
    tstrok: '\u0167',
    twixt: '\u226C',
    twoheadleftarrow: '\u219E',
    twoheadrightarrow: '\u21A0',
    Uacute: '\u00DA',
    uacute: '\u00FA',
    Uarr: '\u219F',
    uArr: '\u21D1',
    uarr: '\u2191',
    Uarrocir: '\u2949',
    Ubrcy: '\u040E',
    ubrcy: '\u045E',
    Ubreve: '\u016C',
    ubreve: '\u016D',
    Ucirc: '\u00DB',
    ucirc: '\u00FB',
    Ucy: '\u0423',
    ucy: '\u0443',
    udarr: '\u21C5',
    Udblac: '\u0170',
    udblac: '\u0171',
    udhar: '\u296E',
    ufisht: '\u297E',
    Ufr: '\uD835\uDD18',
    ufr: '\uD835\uDD32',
    Ugrave: '\u00D9',
    ugrave: '\u00F9',
    uHar: '\u2963',
    uharl: '\u21BF',
    uharr: '\u21BE',
    uhblk: '\u2580',
    ulcorn: '\u231C',
    ulcorner: '\u231C',
    ulcrop: '\u230F',
    ultri: '\u25F8',
    Umacr: '\u016A',
    umacr: '\u016B',
    uml: '\u00A8',
    UnderBar: '\u005F',
    UnderBrace: '\u23DF',
    UnderBracket: '\u23B5',
    UnderParenthesis: '\u23DD',
    Union: '\u22C3',
    UnionPlus: '\u228E',
    Uogon: '\u0172',
    uogon: '\u0173',
    Uopf: '\uD835\uDD4C',
    uopf: '\uD835\uDD66',
    UpArrow: '\u2191',
    Uparrow: '\u21D1',
    uparrow: '\u2191',
    UpArrowBar: '\u2912',
    UpArrowDownArrow: '\u21C5',
    UpDownArrow: '\u2195',
    Updownarrow: '\u21D5',
    updownarrow: '\u2195',
    UpEquilibrium: '\u296E',
    upharpoonleft: '\u21BF',
    upharpoonright: '\u21BE',
    uplus: '\u228E',
    UpperLeftArrow: '\u2196',
    UpperRightArrow: '\u2197',
    Upsi: '\u03D2',
    upsi: '\u03C5',
    upsih: '\u03D2',
    Upsilon: '\u03A5',
    upsilon: '\u03C5',
    UpTee: '\u22A5',
    UpTeeArrow: '\u21A5',
    upuparrows: '\u21C8',
    urcorn: '\u231D',
    urcorner: '\u231D',
    urcrop: '\u230E',
    Uring: '\u016E',
    uring: '\u016F',
    urtri: '\u25F9',
    Uscr: '\uD835\uDCB0',
    uscr: '\uD835\uDCCA',
    utdot: '\u22F0',
    Utilde: '\u0168',
    utilde: '\u0169',
    utri: '\u25B5',
    utrif: '\u25B4',
    uuarr: '\u21C8',
    Uuml: '\u00DC',
    uuml: '\u00FC',
    uwangle: '\u29A7',
    vangrt: '\u299C',
    varepsilon: '\u03F5',
    varkappa: '\u03F0',
    varnothing: '\u2205',
    varphi: '\u03D5',
    varpi: '\u03D6',
    varpropto: '\u221D',
    vArr: '\u21D5',
    varr: '\u2195',
    varrho: '\u03F1',
    varsigma: '\u03C2',
    varsubsetneq: '\u228A\uFE00',
    varsubsetneqq: '\u2ACB\uFE00',
    varsupsetneq: '\u228B\uFE00',
    varsupsetneqq: '\u2ACC\uFE00',
    vartheta: '\u03D1',
    vartriangleleft: '\u22B2',
    vartriangleright: '\u22B3',
    Vbar: '\u2AEB',
    vBar: '\u2AE8',
    vBarv: '\u2AE9',
    Vcy: '\u0412',
    vcy: '\u0432',
    VDash: '\u22AB',
    Vdash: '\u22A9',
    vDash: '\u22A8',
    vdash: '\u22A2',
    Vdashl: '\u2AE6',
    Vee: '\u22C1',
    vee: '\u2228',
    veebar: '\u22BB',
    veeeq: '\u225A',
    vellip: '\u22EE',
    Verbar: '\u2016',
    verbar: '\u007C',
    Vert: '\u2016',
    vert: '\u007C',
    VerticalBar: '\u2223',
    VerticalLine: '\u007C',
    VerticalSeparator: '\u2758',
    VerticalTilde: '\u2240',
    VeryThinSpace: '\u200A',
    Vfr: '\uD835\uDD19',
    vfr: '\uD835\uDD33',
    vltri: '\u22B2',
    vnsub: '\u2282\u20D2',
    vnsup: '\u2283\u20D2',
    Vopf: '\uD835\uDD4D',
    vopf: '\uD835\uDD67',
    vprop: '\u221D',
    vrtri: '\u22B3',
    Vscr: '\uD835\uDCB1',
    vscr: '\uD835\uDCCB',
    vsubnE: '\u2ACB\uFE00',
    vsubne: '\u228A\uFE00',
    vsupnE: '\u2ACC\uFE00',
    vsupne: '\u228B\uFE00',
    Vvdash: '\u22AA',
    vzigzag: '\u299A',
    Wcirc: '\u0174',
    wcirc: '\u0175',
    wedbar: '\u2A5F',
    Wedge: '\u22C0',
    wedge: '\u2227',
    wedgeq: '\u2259',
    weierp: '\u2118',
    Wfr: '\uD835\uDD1A',
    wfr: '\uD835\uDD34',
    Wopf: '\uD835\uDD4E',
    wopf: '\uD835\uDD68',
    wp: '\u2118',
    wr: '\u2240',
    wreath: '\u2240',
    Wscr: '\uD835\uDCB2',
    wscr: '\uD835\uDCCC',
    xcap: '\u22C2',
    xcirc: '\u25EF',
    xcup: '\u22C3',
    xdtri: '\u25BD',
    Xfr: '\uD835\uDD1B',
    xfr: '\uD835\uDD35',
    xhArr: '\u27FA',
    xharr: '\u27F7',
    Xi: '\u039E',
    xi: '\u03BE',
    xlArr: '\u27F8',
    xlarr: '\u27F5',
    xmap: '\u27FC',
    xnis: '\u22FB',
    xodot: '\u2A00',
    Xopf: '\uD835\uDD4F',
    xopf: '\uD835\uDD69',
    xoplus: '\u2A01',
    xotime: '\u2A02',
    xrArr: '\u27F9',
    xrarr: '\u27F6',
    Xscr: '\uD835\uDCB3',
    xscr: '\uD835\uDCCD',
    xsqcup: '\u2A06',
    xuplus: '\u2A04',
    xutri: '\u25B3',
    xvee: '\u22C1',
    xwedge: '\u22C0',
    Yacute: '\u00DD',
    yacute: '\u00FD',
    YAcy: '\u042F',
    yacy: '\u044F',
    Ycirc: '\u0176',
    ycirc: '\u0177',
    Ycy: '\u042B',
    ycy: '\u044B',
    yen: '\u00A5',
    Yfr: '\uD835\uDD1C',
    yfr: '\uD835\uDD36',
    YIcy: '\u0407',
    yicy: '\u0457',
    Yopf: '\uD835\uDD50',
    yopf: '\uD835\uDD6A',
    Yscr: '\uD835\uDCB4',
    yscr: '\uD835\uDCCE',
    YUcy: '\u042E',
    yucy: '\u044E',
    Yuml: '\u0178',
    yuml: '\u00FF',
    Zacute: '\u0179',
    zacute: '\u017A',
    Zcaron: '\u017D',
    zcaron: '\u017E',
    Zcy: '\u0417',
    zcy: '\u0437',
    Zdot: '\u017B',
    zdot: '\u017C',
    zeetrf: '\u2128',
    ZeroWidthSpace: '\u200B',
    Zeta: '\u0396',
    zeta: '\u03B6',
    Zfr: '\u2128',
    zfr: '\uD835\uDD37',
    ZHcy: '\u0416',
    zhcy: '\u0436',
    zigrarr: '\u21DD',
    Zopf: '\u2124',
    zopf: '\uD835\uDD6B',
    Zscr: '\uD835\uDCB5',
    zscr: '\uD835\uDCCF',
    zwj: '\u200D',
    zwnj: '\u200C'
});
$209c739ee170ce7f$export$79451380caed3f98 = $209c739ee170ce7f$export$b7e4d4631df36afa;

});

parcelRegister("1fO4L", function(module, exports) {

$parcel$export(module.exports, "XMLReader", () => $0e9e0929092947dd$export$ccbc9f9f018333e9, (v) => $0e9e0929092947dd$export$ccbc9f9f018333e9 = v);
$parcel$export(module.exports, "ParseError", () => $0e9e0929092947dd$export$f9c837a54db411d, (v) => $0e9e0929092947dd$export$f9c837a54db411d = v);
var $0e9e0929092947dd$export$ccbc9f9f018333e9;
var $0e9e0929092947dd$export$f9c837a54db411d;

var $hkG9E = parcelRequire("hkG9E");
var $0e9e0929092947dd$require$NAMESPACE = $hkG9E.NAMESPACE;
//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var $0e9e0929092947dd$var$nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/ //\u10000-\uEFFFF
;
var $0e9e0929092947dd$var$nameChar = new RegExp("[\\-\\.0-9" + $0e9e0929092947dd$var$nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var $0e9e0929092947dd$var$tagNamePattern = new RegExp('^' + $0e9e0929092947dd$var$nameStartChar.source + $0e9e0929092947dd$var$nameChar.source + '*(?:\:' + $0e9e0929092947dd$var$nameStartChar.source + $0e9e0929092947dd$var$nameChar.source + '*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var $0e9e0929092947dd$var$S_TAG = 0; //tag name offerring
var $0e9e0929092947dd$var$S_ATTR = 1; //attr name offerring
var $0e9e0929092947dd$var$S_ATTR_SPACE = 2; //attr name end and space offer
var $0e9e0929092947dd$var$S_EQ = 3; //=space?
var $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var $0e9e0929092947dd$var$S_ATTR_END = 5; //attr value end and no space(quot end)
var $0e9e0929092947dd$var$S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var $0e9e0929092947dd$var$S_TAG_CLOSE = 7; //closed el<el />
/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */ function $0e9e0929092947dd$var$ParseError(message, locator) {
    this.message = message;
    this.locator = locator;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $0e9e0929092947dd$var$ParseError);
}
$0e9e0929092947dd$var$ParseError.prototype = new Error();
$0e9e0929092947dd$var$ParseError.prototype.name = $0e9e0929092947dd$var$ParseError.name;
function $0e9e0929092947dd$var$XMLReader() {}
$0e9e0929092947dd$var$XMLReader.prototype = {
    parse: function(source, defaultNSMap, entityMap) {
        var domBuilder = this.domBuilder;
        domBuilder.startDocument();
        $0e9e0929092947dd$var$_copy(defaultNSMap, defaultNSMap = {});
        $0e9e0929092947dd$var$parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
        domBuilder.endDocument();
    }
};
function $0e9e0929092947dd$var$parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
    function fixedFromCharCode(code) {
        // String.prototype.fromCharCode does not supports
        // > 2 bytes unicode chars directly
        if (code > 0xffff) {
            code -= 0x10000;
            var surrogate1 = 0xd800 + (code >> 10), surrogate2 = 0xdc00 + (code & 0x3ff);
            return String.fromCharCode(surrogate1, surrogate2);
        } else return String.fromCharCode(code);
    }
    function entityReplacer(a) {
        var k = a.slice(1, -1);
        if (Object.hasOwnProperty.call(entityMap, k)) return entityMap[k];
        else if (k.charAt(0) === '#') return fixedFromCharCode(parseInt(k.substr(1).replace('x', '0x')));
        else {
            errorHandler.error('entity not found:' + a);
            return a;
        }
    }
    function appendText(end) {
        if (end > start) {
            var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
            locator && position(start);
            domBuilder.characters(xt, 0, end - start);
            start = end;
        }
    }
    function position(p, m) {
        while(p >= lineEnd && (m = linePattern.exec(source))){
            lineStart = m.index;
            lineEnd = lineStart + m[0].length;
            locator.lineNumber++;
        //console.log('line++:',locator,startPos,endPos)
        }
        locator.columnNumber = p - lineStart + 1;
    }
    var lineStart = 0;
    var lineEnd = 0;
    var linePattern = /.*(?:\r\n?|\n)|.*$/g;
    var locator = domBuilder.locator;
    var parseStack = [
        {
            currentNSMap: defaultNSMapCopy
        }
    ];
    var closeMap = {};
    var start = 0;
    while(true){
        try {
            var tagStart = source.indexOf('<', start);
            if (tagStart < 0) {
                if (!source.substr(start).match(/^\s*$/)) {
                    var doc = domBuilder.doc;
                    var text = doc.createTextNode(source.substr(start));
                    doc.appendChild(text);
                    domBuilder.currentElement = text;
                }
                return;
            }
            if (tagStart > start) appendText(tagStart);
            switch(source.charAt(tagStart + 1)){
                case '/':
                    var end = source.indexOf('>', tagStart + 3);
                    var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
                    var config = parseStack.pop();
                    if (end < 0) {
                        tagName = source.substring(tagStart + 2).replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' is not complete:' + config.tagName);
                        end = tagStart + 1 + tagName.length;
                    } else if (tagName.match(/\s</)) {
                        tagName = tagName.replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' maybe not complete');
                        end = tagStart + 1 + tagName.length;
                    }
                    var localNSMap = config.localNSMap;
                    var endMatch = config.tagName == tagName;
                    var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
                    if (endIgnoreCaseMach) {
                        domBuilder.endElement(config.uri, config.localName, tagName);
                        if (localNSMap) {
                            for(var prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
                        }
                        if (!endMatch) errorHandler.fatalError("end tag name: " + tagName + ' is not match the current start tagName:' + config.tagName); // No known test case
                    } else parseStack.push(config);
                    end++;
                    break;
                // end elment
                case '?':
                    locator && position(tagStart);
                    end = $0e9e0929092947dd$var$parseInstruction(source, tagStart, domBuilder);
                    break;
                case '!':
                    locator && position(tagStart);
                    end = $0e9e0929092947dd$var$parseDCC(source, tagStart, domBuilder, errorHandler);
                    break;
                default:
                    locator && position(tagStart);
                    var el = new $0e9e0929092947dd$var$ElementAttributes();
                    var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
                    //elStartEnd
                    var end = $0e9e0929092947dd$var$parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
                    var len = el.length;
                    if (!el.closed && $0e9e0929092947dd$var$fixSelfClosed(source, end, el.tagName, closeMap)) {
                        el.closed = true;
                        if (!entityMap.nbsp) errorHandler.warning('unclosed xml attribute');
                    }
                    if (locator && len) {
                        var locator2 = $0e9e0929092947dd$var$copyLocator(locator, {});
                        //try{//attribute position fixed
                        for(var i = 0; i < len; i++){
                            var a = el[i];
                            position(a.offset);
                            a.locator = $0e9e0929092947dd$var$copyLocator(locator, {});
                        }
                        domBuilder.locator = locator2;
                        if ($0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                        domBuilder.locator = locator;
                    } else if ($0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                    if ($0e9e0929092947dd$require$NAMESPACE.isHTML(el.uri) && !el.closed) end = $0e9e0929092947dd$var$parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
                    else end++;
            }
        } catch (e) {
            if (e instanceof $0e9e0929092947dd$var$ParseError) throw e;
            errorHandler.error('element parse error: ' + e);
            end = -1;
        }
        if (end > start) start = end;
        else //TODO: 这里有可能sax回退，有位置错误风险
        appendText(Math.max(tagStart, start) + 1);
    }
}
function $0e9e0929092947dd$var$copyLocator(f, t) {
    t.lineNumber = f.lineNumber;
    t.columnNumber = f.columnNumber;
    return t;
}
/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */ function $0e9e0929092947dd$var$parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
    /**
	 * @param {string} qname
	 * @param {string} value
	 * @param {number} startIndex
	 */ function addAttribute(qname, value, startIndex) {
        if (el.attributeNames.hasOwnProperty(qname)) errorHandler.fatalError('Attribute ' + qname + ' redefined');
        el.addValue(qname, // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer), startIndex);
    }
    var attrName;
    var value;
    var p = ++start;
    var s = $0e9e0929092947dd$var$S_TAG; //status
    while(true){
        var c = source.charAt(p);
        switch(c){
            case '=':
                if (s === $0e9e0929092947dd$var$S_ATTR) {
                    attrName = source.slice(start, p);
                    s = $0e9e0929092947dd$var$S_EQ;
                } else if (s === $0e9e0929092947dd$var$S_ATTR_SPACE) s = $0e9e0929092947dd$var$S_EQ;
                else //fatalError: equal must after attrName or space after attrName
                throw new Error('attribute equal must after attrName'); // No known test case
                break;
            case '\'':
            case '"':
                if (s === $0e9e0929092947dd$var$S_EQ || s === $0e9e0929092947dd$var$S_ATTR //|| s == S_ATTR_SPACE
                ) {
                    if (s === $0e9e0929092947dd$var$S_ATTR) {
                        errorHandler.warning('attribute value must after "="');
                        attrName = source.slice(start, p);
                    }
                    start = p + 1;
                    p = source.indexOf(c, start);
                    if (p > 0) {
                        value = source.slice(start, p);
                        addAttribute(attrName, value, start - 1);
                        s = $0e9e0929092947dd$var$S_ATTR_END;
                    } else //fatalError: no end quot match
                    throw new Error('attribute value no end \'' + c + '\' match');
                } else if (s == $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE) {
                    value = source.slice(start, p);
                    addAttribute(attrName, value, start);
                    errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ')!!');
                    start = p + 1;
                    s = $0e9e0929092947dd$var$S_ATTR_END;
                } else //fatalError: no equal before
                throw new Error('attribute value must after "="'); // No known test case
                break;
            case '/':
                switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $0e9e0929092947dd$var$S_ATTR_END:
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        s = $0e9e0929092947dd$var$S_TAG_CLOSE;
                        el.closed = true;
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                    case $0e9e0929092947dd$var$S_ATTR:
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        el.closed = true;
                        break;
                    //case S_EQ:
                    default:
                        throw new Error("attribute invalid close char('/')") // No known test case
                        ;
                }
                break;
            case '':
                errorHandler.error('unexpected end of input');
                if (s == $0e9e0929092947dd$var$S_TAG) el.setTagName(source.slice(start, p));
                return p;
            case '>':
                switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $0e9e0929092947dd$var$S_ATTR_END:
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        break; //normal
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                    case $0e9e0929092947dd$var$S_ATTR:
                        value = source.slice(start, p);
                        if (value.slice(-1) === '/') {
                            el.closed = true;
                            value = value.slice(0, -1);
                        }
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        if (s === $0e9e0929092947dd$var$S_ATTR_SPACE) value = attrName;
                        if (s == $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE) {
                            errorHandler.warning('attribute "' + value + '" missed quot(")!');
                            addAttribute(attrName, value, start);
                        } else {
                            if (!$0e9e0929092947dd$require$NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
                            addAttribute(value, value, start);
                        }
                        break;
                    case $0e9e0929092947dd$var$S_EQ:
                        throw new Error('attribute value missed!!');
                }
                //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
                return p;
            /*xml space '\x20' | #x9 | #xD | #xA; */ case '\u0080':
                c = ' ';
            default:
                if (c <= ' ') switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p)); //tagName
                        s = $0e9e0929092947dd$var$S_TAG_SPACE;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR:
                        attrName = source.slice(start, p);
                        s = $0e9e0929092947dd$var$S_ATTR_SPACE;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                        var value = source.slice(start, p);
                        errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                        addAttribute(attrName, value, start);
                    case $0e9e0929092947dd$var$S_ATTR_END:
                        s = $0e9e0929092947dd$var$S_TAG_SPACE;
                        break;
                }
                else //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
                //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
                switch(s){
                    //case S_TAG:void();break;
                    //case S_ATTR:void();break;
                    //case S_ATTR_NOQUOT_VALUE:void();break;
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        var tagName = el.tagName;
                        if (!$0e9e0929092947dd$require$NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
                        addAttribute(attrName, attrName, start);
                        start = p;
                        s = $0e9e0929092947dd$var$S_ATTR;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_END:
                        errorHandler.warning('attribute space is required"' + attrName + '"!!');
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                        s = $0e9e0929092947dd$var$S_ATTR;
                        start = p;
                        break;
                    case $0e9e0929092947dd$var$S_EQ:
                        s = $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE;
                        start = p;
                        break;
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        throw new Error("elements closed character '/' and '>' must be connected to");
                }
        } //end outer switch
        //console.log('p++',p)
        p++;
    }
}
/**
 * @return true if has new namespace define
 */ function $0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap) {
    var tagName = el.tagName;
    var localNSMap = null;
    //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
    var i = el.length;
    while(i--){
        var a = el[i];
        var qName = a.qName;
        var value = a.value;
        var nsp = qName.indexOf(':');
        if (nsp > 0) {
            var prefix = a.prefix = qName.slice(0, nsp);
            var localName = qName.slice(nsp + 1);
            var nsPrefix = prefix === 'xmlns' && localName;
        } else {
            localName = qName;
            prefix = null;
            nsPrefix = qName === 'xmlns' && '';
        }
        //can not set prefix,because prefix !== ''
        a.localName = localName;
        //prefix == null for no ns prefix attribute
        if (nsPrefix !== false) {
            if (localNSMap == null) {
                localNSMap = {};
                //console.log(currentNSMap,0)
                $0e9e0929092947dd$var$_copy(currentNSMap, currentNSMap = {});
            //console.log(currentNSMap,1)
            }
            currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
            a.uri = $0e9e0929092947dd$require$NAMESPACE.XMLNS;
            domBuilder.startPrefixMapping(nsPrefix, value);
        }
    }
    var i = el.length;
    while(i--){
        a = el[i];
        var prefix = a.prefix;
        if (prefix) {
            if (prefix === 'xml') a.uri = $0e9e0929092947dd$require$NAMESPACE.XML;
            if (prefix !== 'xmlns') a.uri = currentNSMap[prefix || ''];
        }
    }
    var nsp = tagName.indexOf(':');
    if (nsp > 0) {
        prefix = el.prefix = tagName.slice(0, nsp);
        localName = el.localName = tagName.slice(nsp + 1);
    } else {
        prefix = null; //important!!
        localName = el.localName = tagName;
    }
    //no prefix element has default namespace
    var ns = el.uri = currentNSMap[prefix || ''];
    domBuilder.startElement(ns, localName, tagName, el);
    //endPrefixMapping and startPrefixMapping have not any help for dom builder
    //localNSMap = null
    if (el.closed) {
        domBuilder.endElement(ns, localName, tagName);
        if (localNSMap) {
            for(prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
        }
    } else {
        el.currentNSMap = currentNSMap;
        el.localNSMap = localNSMap;
        //parseStack.push(el);
        return true;
    }
}
function $0e9e0929092947dd$var$parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
    if (/^(?:script|textarea)$/i.test(tagName)) {
        var elEndStart = source.indexOf('</' + tagName + '>', elStartEnd);
        var text = source.substring(elStartEnd + 1, elEndStart);
        if (/[&<]/.test(text)) {
            if (/^script$/i.test(tagName)) {
                //if(!/\]\]>/.test(text)){
                //lexHandler.startCDATA();
                domBuilder.characters(text, 0, text.length);
                //lexHandler.endCDATA();
                return elEndStart;
            //}
            } //}else{//text area
            text = text.replace(/&#?\w+;/g, entityReplacer);
            domBuilder.characters(text, 0, text.length);
            return elEndStart;
        //}
        }
    }
    return elStartEnd + 1;
}
function $0e9e0929092947dd$var$fixSelfClosed(source, elStartEnd, tagName, closeMap) {
    //if(tagName in closeMap){
    var pos = closeMap[tagName];
    if (pos == null) {
        //console.log(tagName)
        pos = source.lastIndexOf('</' + tagName + '>');
        if (pos < elStartEnd) pos = source.lastIndexOf('</' + tagName);
        closeMap[tagName] = pos;
    }
    return pos < elStartEnd;
//}
}
function $0e9e0929092947dd$var$_copy(source, target) {
    for(var n in source)if (Object.prototype.hasOwnProperty.call(source, n)) target[n] = source[n];
}
function $0e9e0929092947dd$var$parseDCC(source, start, domBuilder, errorHandler) {
    var next = source.charAt(start + 2);
    switch(next){
        case '-':
            if (source.charAt(start + 3) === '-') {
                var end = source.indexOf('-->', start + 4);
                //append comment source.substring(4,end)//<!--
                if (end > start) {
                    domBuilder.comment(source, start + 4, end - start - 4);
                    return end + 3;
                } else {
                    errorHandler.error("Unclosed comment");
                    return -1;
                }
            } else //error
            return -1;
        default:
            if (source.substr(start + 3, 6) == 'CDATA[') {
                var end = source.indexOf(']]>', start + 9);
                domBuilder.startCDATA();
                domBuilder.characters(source, start + 9, end - start - 9);
                domBuilder.endCDATA();
                return end + 3;
            }
            //<!DOCTYPE
            //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
            var matchs = $0e9e0929092947dd$var$split(source, start);
            var len = matchs.length;
            if (len > 1 && /!doctype/i.test(matchs[0][0])) {
                var name = matchs[1][0];
                var pubid = false;
                var sysid = false;
                if (len > 3) {
                    if (/^public$/i.test(matchs[2][0])) {
                        pubid = matchs[3][0];
                        sysid = len > 4 && matchs[4][0];
                    } else if (/^system$/i.test(matchs[2][0])) sysid = matchs[3][0];
                }
                var lastMatch = matchs[len - 1];
                domBuilder.startDTD(name, pubid, sysid);
                domBuilder.endDTD();
                return lastMatch.index + lastMatch[0].length;
            }
    }
    return -1;
}
function $0e9e0929092947dd$var$parseInstruction(source, start, domBuilder) {
    var end = source.indexOf('?>', start);
    if (end) {
        var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
        if (match) {
            var len = match[0].length;
            domBuilder.processingInstruction(match[1], match[2]);
            return end + 2;
        } else return -1;
    }
    return -1;
}
function $0e9e0929092947dd$var$ElementAttributes() {
    this.attributeNames = {};
}
$0e9e0929092947dd$var$ElementAttributes.prototype = {
    setTagName: function(tagName) {
        if (!$0e9e0929092947dd$var$tagNamePattern.test(tagName)) throw new Error('invalid tagName:' + tagName);
        this.tagName = tagName;
    },
    addValue: function(qName, value, offset) {
        if (!$0e9e0929092947dd$var$tagNamePattern.test(qName)) throw new Error('invalid attribute:' + qName);
        this.attributeNames[qName] = this.length;
        this[this.length++] = {
            qName: qName,
            value: value,
            offset: offset
        };
    },
    length: 0,
    getLocalName: function(i) {
        return this[i].localName;
    },
    getLocator: function(i) {
        return this[i].locator;
    },
    getQName: function(i) {
        return this[i].qName;
    },
    getURI: function(i) {
        return this[i].uri;
    },
    getValue: function(i) {
        return this[i].value;
    }
};
function $0e9e0929092947dd$var$split(source, start) {
    var match;
    var buf = [];
    var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    reg.lastIndex = start;
    reg.exec(source); //skip <
    while(match = reg.exec(source)){
        buf.push(match);
        if (match[1]) return buf;
    }
}
$0e9e0929092947dd$export$ccbc9f9f018333e9 = $0e9e0929092947dd$var$XMLReader;
$0e9e0929092947dd$export$f9c837a54db411d = $0e9e0929092947dd$var$ParseError;

});




parcelRegister("aMGaR", function(module, exports) {

var $6yxxB = parcelRequire("6yxxB");
var $7d9f1a0178bc82dd$require$getUint64 = $6yxxB.getUint64;
var $7d9f1a0178bc82dd$var$parseSidx = function(data) {
    var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
        version: data[0],
        flags: new Uint8Array(data.subarray(1, 4)),
        references: [],
        referenceId: view.getUint32(4),
        timescale: view.getUint32(8)
    }, i = 12;
    if (result.version === 0) {
        result.earliestPresentationTime = view.getUint32(i);
        result.firstOffset = view.getUint32(i + 4);
        i += 8;
    } else {
        // read 64 bits
        result.earliestPresentationTime = $7d9f1a0178bc82dd$require$getUint64(data.subarray(i));
        result.firstOffset = $7d9f1a0178bc82dd$require$getUint64(data.subarray(i + 8));
        i += 16;
    }
    i += 2; // reserved
    var referenceCount = view.getUint16(i);
    i += 2; // start of references
    for(; referenceCount > 0; i += 12, referenceCount--)result.references.push({
        referenceType: (data[i] & 0x80) >>> 7,
        referencedSize: view.getUint32(i) & 0x7FFFFFFF,
        subsegmentDuration: view.getUint32(i + 4),
        startsWithSap: !!(data[i + 8] & 0x80),
        sapType: (data[i + 8] & 0x70) >>> 4,
        sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
    });
    return result;
};
module.exports = $7d9f1a0178bc82dd$var$parseSidx;

});
parcelRegister("6yxxB", function(module, exports) {
var $4c5fef9166c0ab70$var$MAX_UINT32 = Math.pow(2, 32);
var $4c5fef9166c0ab70$var$getUint64 = function(uint8) {
    var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
    var value;
    if (dv.getBigUint64) {
        value = dv.getBigUint64(0);
        if (value < Number.MAX_SAFE_INTEGER) return Number(value);
        return value;
    }
    return dv.getUint32(0) * $4c5fef9166c0ab70$var$MAX_UINT32 + dv.getUint32(4);
};
module.exports = {
    getUint64: $4c5fef9166c0ab70$var$getUint64,
    MAX_UINT32: $4c5fef9166c0ab70$var$MAX_UINT32
};

});


parcelRegister("bweXN", function(module, exports) {

$parcel$export(module.exports, "getId3Offset", () => $862e4a4ff1392639$export$56b6cacf09ec1126);

var $6vzZz = parcelRequire("6vzZz");
var $862e4a4ff1392639$var$ID3 = (0, $6vzZz.toUint8)([
    0x49,
    0x44,
    0x33
]);
var $862e4a4ff1392639$export$1d0ef9131773159b = function getId3Size(bytes, offset) {
    if (offset === void 0) offset = 0;
    bytes = (0, $6vzZz.toUint8)(bytes);
    var flags = bytes[offset + 5];
    var returnSize = bytes[offset + 6] << 21 | bytes[offset + 7] << 14 | bytes[offset + 8] << 7 | bytes[offset + 9];
    var footerPresent = (flags & 16) >> 4;
    if (footerPresent) return returnSize + 20;
    return returnSize + 10;
};
var $862e4a4ff1392639$export$56b6cacf09ec1126 = function getId3Offset(bytes, offset) {
    if (offset === void 0) offset = 0;
    bytes = (0, $6vzZz.toUint8)(bytes);
    if (bytes.length - offset < 10 || !(0, $6vzZz.bytesMatch)(bytes, $862e4a4ff1392639$var$ID3, {
        offset: offset
    })) return offset;
    offset += $862e4a4ff1392639$export$1d0ef9131773159b(bytes, offset); // recursive check for id3 tags as some files
    // have multiple ID3 tag sections even though
    // they should not.
    return getId3Offset(bytes, offset);
};

});

parcelRegister("bChVV", function(module, exports) {

$parcel$export(module.exports, "detectContainerForBytes", () => $87512779f8f2edc4$export$894319e75ed840c3);
$parcel$export(module.exports, "isLikelyFmp4MediaSegment", () => $87512779f8f2edc4$export$7d0b693bd7ec7827);

var $6vzZz = parcelRequire("6vzZz");

var $ftb8G = parcelRequire("ftb8G");

var $cfxK9 = parcelRequire("cfxK9");

var $bweXN = parcelRequire("bweXN");

var $hXRvC = parcelRequire("hXRvC");
var $87512779f8f2edc4$var$CONSTANTS = {
    // "webm" string literal in hex
    'webm': (0, $6vzZz.toUint8)([
        0x77,
        0x65,
        0x62,
        0x6d
    ]),
    // "matroska" string literal in hex
    'matroska': (0, $6vzZz.toUint8)([
        0x6d,
        0x61,
        0x74,
        0x72,
        0x6f,
        0x73,
        0x6b,
        0x61
    ]),
    // "fLaC" string literal in hex
    'flac': (0, $6vzZz.toUint8)([
        0x66,
        0x4c,
        0x61,
        0x43
    ]),
    // "OggS" string literal in hex
    'ogg': (0, $6vzZz.toUint8)([
        0x4f,
        0x67,
        0x67,
        0x53
    ]),
    // ac-3 sync byte, also works for ec-3 as that is simply a codec
    // of ac-3
    'ac3': (0, $6vzZz.toUint8)([
        0x0b,
        0x77
    ]),
    // "RIFF" string literal in hex used for wav and avi
    'riff': (0, $6vzZz.toUint8)([
        0x52,
        0x49,
        0x46,
        0x46
    ]),
    // "AVI" string literal in hex
    'avi': (0, $6vzZz.toUint8)([
        0x41,
        0x56,
        0x49
    ]),
    // "WAVE" string literal in hex
    'wav': (0, $6vzZz.toUint8)([
        0x57,
        0x41,
        0x56,
        0x45
    ]),
    // "ftyp3g" string literal in hex
    '3gp': (0, $6vzZz.toUint8)([
        0x66,
        0x74,
        0x79,
        0x70,
        0x33,
        0x67
    ]),
    // "ftyp" string literal in hex
    'mp4': (0, $6vzZz.toUint8)([
        0x66,
        0x74,
        0x79,
        0x70
    ]),
    // "styp" string literal in hex
    'fmp4': (0, $6vzZz.toUint8)([
        0x73,
        0x74,
        0x79,
        0x70
    ]),
    // "ftypqt" string literal in hex
    'mov': (0, $6vzZz.toUint8)([
        0x66,
        0x74,
        0x79,
        0x70,
        0x71,
        0x74
    ]),
    // moov string literal in hex
    'moov': (0, $6vzZz.toUint8)([
        0x6D,
        0x6F,
        0x6F,
        0x76
    ]),
    // moof string literal in hex
    'moof': (0, $6vzZz.toUint8)([
        0x6D,
        0x6F,
        0x6F,
        0x66
    ])
};
var $87512779f8f2edc4$var$_isLikely = {
    aac: function aac(bytes) {
        var offset = (0, $bweXN.getId3Offset)(bytes);
        return (0, $6vzZz.bytesMatch)(bytes, [
            0xFF,
            0x10
        ], {
            offset: offset,
            mask: [
                0xFF,
                0x16
            ]
        });
    },
    mp3: function mp3(bytes) {
        var offset = (0, $bweXN.getId3Offset)(bytes);
        return (0, $6vzZz.bytesMatch)(bytes, [
            0xFF,
            0x02
        ], {
            offset: offset,
            mask: [
                0xFF,
                0x06
            ]
        });
    },
    webm: function webm(bytes) {
        var docType = (0, $cfxK9.findEbml)(bytes, [
            (0, $cfxK9.EBML_TAGS).EBML,
            (0, $cfxK9.EBML_TAGS).DocType
        ])[0]; // check if DocType EBML tag is webm
        return (0, $6vzZz.bytesMatch)(docType, $87512779f8f2edc4$var$CONSTANTS.webm);
    },
    mkv: function mkv(bytes) {
        var docType = (0, $cfxK9.findEbml)(bytes, [
            (0, $cfxK9.EBML_TAGS).EBML,
            (0, $cfxK9.EBML_TAGS).DocType
        ])[0]; // check if DocType EBML tag is matroska
        return (0, $6vzZz.bytesMatch)(docType, $87512779f8f2edc4$var$CONSTANTS.matroska);
    },
    mp4: function mp4(bytes) {
        // if this file is another base media file format, it is not mp4
        if ($87512779f8f2edc4$var$_isLikely['3gp'](bytes) || $87512779f8f2edc4$var$_isLikely.mov(bytes)) return false;
         // if this file starts with a ftyp or styp box its mp4
        if ((0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.mp4, {
            offset: 4
        }) || (0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.fmp4, {
            offset: 4
        })) return true;
         // if this file starts with a moof/moov box its mp4
        if ((0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.moof, {
            offset: 4
        }) || (0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.moov, {
            offset: 4
        })) return true;
    },
    mov: function mov(bytes) {
        return (0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.mov, {
            offset: 4
        });
    },
    '3gp': function gp(bytes) {
        return (0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS['3gp'], {
            offset: 4
        });
    },
    ac3: function ac3(bytes) {
        var offset = (0, $bweXN.getId3Offset)(bytes);
        return (0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.ac3, {
            offset: offset
        });
    },
    ts: function ts(bytes) {
        if (bytes.length < 189 && bytes.length >= 1) return bytes[0] === 0x47;
        var i = 0; // check the first 376 bytes for two matching sync bytes
        while(i + 188 < bytes.length && i < 188){
            if (bytes[i] === 0x47 && bytes[i + 188] === 0x47) return true;
            i += 1;
        }
        return false;
    },
    flac: function flac(bytes) {
        var offset = (0, $bweXN.getId3Offset)(bytes);
        return (0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.flac, {
            offset: offset
        });
    },
    ogg: function ogg(bytes) {
        return (0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.ogg);
    },
    avi: function avi(bytes) {
        return (0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.riff) && (0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.avi, {
            offset: 8
        });
    },
    wav: function wav(bytes) {
        return (0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.riff) && (0, $6vzZz.bytesMatch)(bytes, $87512779f8f2edc4$var$CONSTANTS.wav, {
            offset: 8
        });
    },
    'h264': function h264(bytes) {
        // find seq_parameter_set_rbsp
        return (0, $hXRvC.findH264Nal)(bytes, 7, 3).length;
    },
    'h265': function h265(bytes) {
        // find video_parameter_set_rbsp or seq_parameter_set_rbsp
        return (0, $hXRvC.findH265Nal)(bytes, [
            32,
            33
        ], 3).length;
    }
}; // get all the isLikely functions
// but make sure 'ts' is above h264 and h265
// but below everything else as it is the least specific
var $87512779f8f2edc4$var$isLikelyTypes = Object.keys($87512779f8f2edc4$var$_isLikely) // remove ts, h264, h265
.filter(function(t) {
    return t !== 'ts' && t !== 'h264' && t !== 'h265';
}) // add it back to the bottom
.concat([
    'ts',
    'h264',
    'h265'
]); // make sure we are dealing with uint8 data.
$87512779f8f2edc4$var$isLikelyTypes.forEach(function(type) {
    var isLikelyFn = $87512779f8f2edc4$var$_isLikely[type];
    $87512779f8f2edc4$var$_isLikely[type] = function(bytes) {
        return isLikelyFn((0, $6vzZz.toUint8)(bytes));
    };
}); // export after wrapping
var $87512779f8f2edc4$export$4d8d080fd201ee1b = $87512779f8f2edc4$var$_isLikely; // A useful list of file signatures can be found here
var $87512779f8f2edc4$export$894319e75ed840c3 = function detectContainerForBytes(bytes) {
    bytes = (0, $6vzZz.toUint8)(bytes);
    for(var i = 0; i < $87512779f8f2edc4$var$isLikelyTypes.length; i++){
        var type = $87512779f8f2edc4$var$isLikelyTypes[i];
        if ($87512779f8f2edc4$export$4d8d080fd201ee1b[type](bytes)) return type;
    }
    return '';
}; // fmp4 is not a container
var $87512779f8f2edc4$export$7d0b693bd7ec7827 = function isLikelyFmp4MediaSegment(bytes) {
    return (0, $ftb8G.findBox)(bytes, [
        'moof'
    ]).length > 0;
};

});
parcelRegister("ftb8G", function(module, exports) {

$parcel$export(module.exports, "findBox", () => $b432346f74fe917b$export$d81d43b46e2012ef);

var $6vzZz = parcelRequire("6vzZz");

var $90IyT = parcelRequire("90IyT");

var $5YwPB = parcelRequire("5YwPB");
var $b432346f74fe917b$var$normalizePath = function normalizePath(path) {
    if (typeof path === 'string') return (0, $6vzZz.stringToBytes)(path);
    if (typeof path === 'number') return path;
    return path;
};
var $b432346f74fe917b$var$normalizePaths = function normalizePaths(paths) {
    if (!Array.isArray(paths)) return [
        $b432346f74fe917b$var$normalizePath(paths)
    ];
    return paths.map(function(p) {
        return $b432346f74fe917b$var$normalizePath(p);
    });
};
var $b432346f74fe917b$var$DESCRIPTORS;
var $b432346f74fe917b$export$fe4700066a34ac73 = function parseDescriptors(bytes) {
    bytes = (0, $6vzZz.toUint8)(bytes);
    var results = [];
    var i = 0;
    while(bytes.length > i){
        var tag = bytes[i];
        var size = 0;
        var headerSize = 0; // tag
        headerSize++;
        var byte = bytes[headerSize]; // first byte
        headerSize++;
        while(byte & 0x80){
            size = (byte & 0x7F) << 7;
            byte = bytes[headerSize];
            headerSize++;
        }
        size += byte & 0x7F;
        for(var z = 0; z < $b432346f74fe917b$var$DESCRIPTORS.length; z++){
            var _DESCRIPTORS$z = $b432346f74fe917b$var$DESCRIPTORS[z], id = _DESCRIPTORS$z.id, parser = _DESCRIPTORS$z.parser;
            if (tag === id) {
                results.push(parser(bytes.subarray(headerSize, headerSize + size)));
                break;
            }
        }
        i += size + headerSize;
    }
    return results;
};
$b432346f74fe917b$var$DESCRIPTORS = [
    {
        id: 0x03,
        parser: function parser(bytes) {
            var desc = {
                tag: 0x03,
                id: bytes[0] << 8 | bytes[1],
                flags: bytes[2],
                size: 3,
                dependsOnEsId: 0,
                ocrEsId: 0,
                descriptors: [],
                url: ''
            }; // depends on es id
            if (desc.flags & 0x80) {
                desc.dependsOnEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
                desc.size += 2;
            } // url
            if (desc.flags & 0x40) {
                var len = bytes[desc.size];
                desc.url = (0, $6vzZz.bytesToString)(bytes.subarray(desc.size + 1, desc.size + 1 + len));
                desc.size += len;
            } // ocr es id
            if (desc.flags & 0x20) {
                desc.ocrEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
                desc.size += 2;
            }
            desc.descriptors = $b432346f74fe917b$export$fe4700066a34ac73(bytes.subarray(desc.size)) || [];
            return desc;
        }
    },
    {
        id: 0x04,
        parser: function parser(bytes) {
            // DecoderConfigDescriptor
            var desc = {
                tag: 0x04,
                oti: bytes[0],
                streamType: bytes[1],
                bufferSize: bytes[2] << 16 | bytes[3] << 8 | bytes[4],
                maxBitrate: bytes[5] << 24 | bytes[6] << 16 | bytes[7] << 8 | bytes[8],
                avgBitrate: bytes[9] << 24 | bytes[10] << 16 | bytes[11] << 8 | bytes[12],
                descriptors: $b432346f74fe917b$export$fe4700066a34ac73(bytes.subarray(13))
            };
            return desc;
        }
    },
    {
        id: 0x05,
        parser: function parser(bytes) {
            // DecoderSpecificInfo
            return {
                tag: 0x05,
                bytes: bytes
            };
        }
    },
    {
        id: 0x06,
        parser: function parser(bytes) {
            // SLConfigDescriptor
            return {
                tag: 0x06,
                bytes: bytes
            };
        }
    }
];
var $b432346f74fe917b$export$d81d43b46e2012ef = function findBox(bytes, paths, complete) {
    if (complete === void 0) complete = false;
    paths = $b432346f74fe917b$var$normalizePaths(paths);
    bytes = (0, $6vzZz.toUint8)(bytes);
    var results = [];
    if (!paths.length) // short-circuit the search for empty paths
    return results;
    var i = 0;
    while(i < bytes.length){
        var size = (bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]) >>> 0;
        var type = bytes.subarray(i + 4, i + 8); // invalid box format.
        if (size === 0) break;
        var end = i + size;
        if (end > bytes.length) {
            // this box is bigger than the number of bytes we have
            // and complete is set, we cannot find any more boxes.
            if (complete) break;
            end = bytes.length;
        }
        var data = bytes.subarray(i + 8, end);
        if ((0, $6vzZz.bytesMatch)(type, paths[0])) {
            if (paths.length === 1) // this is the end of the path and we've found the box we were
            // looking for
            results.push(data);
            else // recursively search for the next box along the path
            results.push.apply(results, findBox(data, paths.slice(1), complete));
        }
        i = end;
    } // we've finished searching all of bytes
    return results;
};
var $b432346f74fe917b$export$610b5b08fd0ffeb4 = function findNamedBox(bytes, name) {
    name = $b432346f74fe917b$var$normalizePath(name);
    if (!name.length) // short-circuit the search for empty paths
    return bytes.subarray(bytes.length);
    var i = 0;
    while(i < bytes.length){
        if ((0, $6vzZz.bytesMatch)(bytes.subarray(i, i + name.length), name)) {
            var size = (bytes[i - 4] << 24 | bytes[i - 3] << 16 | bytes[i - 2] << 8 | bytes[i - 1]) >>> 0;
            var end = size > 1 ? i + size : bytes.byteLength;
            return bytes.subarray(i + 4, end);
        }
        i++;
    } // we've finished searching all of bytes
    return bytes.subarray(bytes.length);
};
var $b432346f74fe917b$var$parseSamples = function parseSamples(data, entrySize, parseEntry) {
    if (entrySize === void 0) entrySize = 4;
    if (parseEntry === void 0) parseEntry = function parseEntry(d) {
        return (0, $6vzZz.bytesToNumber)(d);
    };
    var entries = [];
    if (!data || !data.length) return entries;
    var entryCount = (0, $6vzZz.bytesToNumber)(data.subarray(4, 8));
    for(var i = 8; entryCount; i += entrySize, entryCount--)entries.push(parseEntry(data.subarray(i, i + entrySize)));
    return entries;
};
var $b432346f74fe917b$export$78870b2844ff6386 = function buildFrameTable(stbl, timescale) {
    var keySamples = $b432346f74fe917b$var$parseSamples($b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
        'stss'
    ])[0]);
    var chunkOffsets = $b432346f74fe917b$var$parseSamples($b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
        'stco'
    ])[0]);
    var timeToSamples = $b432346f74fe917b$var$parseSamples($b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
        'stts'
    ])[0], 8, function(entry) {
        return {
            sampleCount: (0, $6vzZz.bytesToNumber)(entry.subarray(0, 4)),
            sampleDelta: (0, $6vzZz.bytesToNumber)(entry.subarray(4, 8))
        };
    });
    var samplesToChunks = $b432346f74fe917b$var$parseSamples($b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
        'stsc'
    ])[0], 12, function(entry) {
        return {
            firstChunk: (0, $6vzZz.bytesToNumber)(entry.subarray(0, 4)),
            samplesPerChunk: (0, $6vzZz.bytesToNumber)(entry.subarray(4, 8)),
            sampleDescriptionIndex: (0, $6vzZz.bytesToNumber)(entry.subarray(8, 12))
        };
    });
    var stsz = $b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
        'stsz'
    ])[0]; // stsz starts with a 4 byte sampleSize which we don't need
    var sampleSizes = $b432346f74fe917b$var$parseSamples(stsz && stsz.length && stsz.subarray(4) || null);
    var frames = [];
    for(var chunkIndex = 0; chunkIndex < chunkOffsets.length; chunkIndex++){
        var samplesInChunk = void 0;
        for(var i = 0; i < samplesToChunks.length; i++){
            var sampleToChunk = samplesToChunks[i];
            var isThisOne = chunkIndex + 1 >= sampleToChunk.firstChunk && (i + 1 >= samplesToChunks.length || chunkIndex + 1 < samplesToChunks[i + 1].firstChunk);
            if (isThisOne) {
                samplesInChunk = sampleToChunk.samplesPerChunk;
                break;
            }
        }
        var chunkOffset = chunkOffsets[chunkIndex];
        for(var _i = 0; _i < samplesInChunk; _i++){
            var frameEnd = sampleSizes[frames.length]; // if we don't have key samples every frame is a keyframe
            var keyframe = !keySamples.length;
            if (keySamples.length && keySamples.indexOf(frames.length + 1) !== -1) keyframe = true;
            var frame = {
                keyframe: keyframe,
                start: chunkOffset,
                end: chunkOffset + frameEnd
            };
            for(var k = 0; k < timeToSamples.length; k++){
                var _timeToSamples$k = timeToSamples[k], sampleCount = _timeToSamples$k.sampleCount, sampleDelta = _timeToSamples$k.sampleDelta;
                if (frames.length <= sampleCount) {
                    // ms to ns
                    var lastTimestamp = frames.length ? frames[frames.length - 1].timestamp : 0;
                    frame.timestamp = lastTimestamp + sampleDelta / timescale * 1000;
                    frame.duration = sampleDelta;
                    break;
                }
            }
            frames.push(frame);
            chunkOffset += frameEnd;
        }
    }
    return frames;
};
var $b432346f74fe917b$export$56fdd13a804135bf = function addSampleDescription(track, bytes) {
    var codec = (0, $6vzZz.bytesToString)(bytes.subarray(0, 4));
    if (track.type === 'video') {
        track.info = track.info || {};
        track.info.width = bytes[28] << 8 | bytes[29];
        track.info.height = bytes[30] << 8 | bytes[31];
    } else if (track.type === 'audio') {
        track.info = track.info || {};
        track.info.channels = bytes[20] << 8 | bytes[21];
        track.info.bitDepth = bytes[22] << 8 | bytes[23];
        track.info.sampleRate = bytes[28] << 8 | bytes[29];
    }
    if (codec === 'avc1') {
        var avcC = $b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, 'avcC'); // AVCDecoderConfigurationRecord
        codec += "." + (0, $90IyT.getAvcCodec)(avcC);
        track.info.avcC = avcC; // TODO: do we need to parse all this?
    /* {
      configurationVersion: avcC[0],
      profile: avcC[1],
      profileCompatibility: avcC[2],
      level: avcC[3],
      lengthSizeMinusOne: avcC[4] & 0x3
    };
     let spsNalUnitCount = avcC[5] & 0x1F;
    const spsNalUnits = track.info.avc.spsNalUnits = [];
     // past spsNalUnitCount
    let offset = 6;
     while (spsNalUnitCount--) {
      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
       spsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
       offset += nalLen + 2;
    }
    let ppsNalUnitCount = avcC[offset];
    const ppsNalUnits = track.info.avc.ppsNalUnits = [];
     // past ppsNalUnitCount
    offset += 1;
     while (ppsNalUnitCount--) {
      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
       ppsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
       offset += nalLen + 2;
    }*/ // HEVCDecoderConfigurationRecord
    } else if (codec === 'hvc1' || codec === 'hev1') codec += "." + (0, $90IyT.getHvcCodec)($b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, 'hvcC'));
    else if (codec === 'mp4a' || codec === 'mp4v') {
        var esds = $b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, 'esds');
        var esDescriptor = $b432346f74fe917b$export$fe4700066a34ac73(esds.subarray(4))[0];
        var decoderConfig = esDescriptor && esDescriptor.descriptors.filter(function(_ref) {
            var tag = _ref.tag;
            return tag === 0x04;
        })[0];
        if (decoderConfig) {
            // most codecs do not have a further '.'
            // such as 0xa5 for ac-3 and 0xa6 for e-ac-3
            codec += '.' + (0, $6vzZz.toHexString)(decoderConfig.oti);
            if (decoderConfig.oti === 0x40) codec += '.' + (decoderConfig.descriptors[0].bytes[0] >> 3).toString();
            else if (decoderConfig.oti === 0x20) codec += '.' + decoderConfig.descriptors[0].bytes[4].toString();
            else if (decoderConfig.oti === 0xdd) codec = 'vorbis';
        } else if (track.type === 'audio') codec += '.40.2';
        else codec += '.20.9';
    } else if (codec === 'av01') // AV1DecoderConfigurationRecord
    codec += "." + (0, $90IyT.getAv1Codec)($b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, 'av1C'));
    else if (codec === 'vp09') {
        // VPCodecConfigurationRecord
        var vpcC = $b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, 'vpcC'); // https://www.webmproject.org/vp9/mp4/
        var profile = vpcC[0];
        var level = vpcC[1];
        var bitDepth = vpcC[2] >> 4;
        var chromaSubsampling = (vpcC[2] & 0x0F) >> 1;
        var videoFullRangeFlag = (vpcC[2] & 0x0F) >> 3;
        var colourPrimaries = vpcC[3];
        var transferCharacteristics = vpcC[4];
        var matrixCoefficients = vpcC[5];
        codec += "." + (0, $6vzZz.padStart)(profile, 2, '0');
        codec += "." + (0, $6vzZz.padStart)(level, 2, '0');
        codec += "." + (0, $6vzZz.padStart)(bitDepth, 2, '0');
        codec += "." + (0, $6vzZz.padStart)(chromaSubsampling, 2, '0');
        codec += "." + (0, $6vzZz.padStart)(colourPrimaries, 2, '0');
        codec += "." + (0, $6vzZz.padStart)(transferCharacteristics, 2, '0');
        codec += "." + (0, $6vzZz.padStart)(matrixCoefficients, 2, '0');
        codec += "." + (0, $6vzZz.padStart)(videoFullRangeFlag, 2, '0');
    } else if (codec === 'theo') codec = 'theora';
    else if (codec === 'spex') codec = 'speex';
    else if (codec === '.mp3') codec = 'mp4a.40.34';
    else if (codec === 'msVo') codec = 'vorbis';
    else if (codec === 'Opus') {
        codec = 'opus';
        var dOps = $b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, 'dOps');
        track.info.opus = (0, $5YwPB.parseOpusHead)(dOps); // TODO: should this go into the webm code??
        // Firefox requires a codecDelay for opus playback
        // see https://bugzilla.mozilla.org/show_bug.cgi?id=1276238
        track.info.codecDelay = 6500000;
    } else codec = codec.toLowerCase();
    /* eslint-enable */ // flac, ac-3, ec-3, opus
    track.codec = codec;
};
var $b432346f74fe917b$export$b9400b1cdedffc2a = function parseTracks(bytes, frameTable) {
    if (frameTable === void 0) frameTable = true;
    bytes = (0, $6vzZz.toUint8)(bytes);
    var traks = $b432346f74fe917b$export$d81d43b46e2012ef(bytes, [
        'moov',
        'trak'
    ], true);
    var tracks = [];
    traks.forEach(function(trak) {
        var track = {
            bytes: trak
        };
        var mdia = $b432346f74fe917b$export$d81d43b46e2012ef(trak, [
            'mdia'
        ])[0];
        var hdlr = $b432346f74fe917b$export$d81d43b46e2012ef(mdia, [
            'hdlr'
        ])[0];
        var trakType = (0, $6vzZz.bytesToString)(hdlr.subarray(8, 12));
        if (trakType === 'soun') track.type = 'audio';
        else if (trakType === 'vide') track.type = 'video';
        else track.type = trakType;
        var tkhd = $b432346f74fe917b$export$d81d43b46e2012ef(trak, [
            'tkhd'
        ])[0];
        if (tkhd) {
            var view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
            var tkhdVersion = view.getUint8(0);
            track.number = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
        }
        var mdhd = $b432346f74fe917b$export$d81d43b46e2012ef(mdia, [
            'mdhd'
        ])[0];
        if (mdhd) {
            // mdhd is a FullBox, meaning it will have its own version as the first byte
            var version = mdhd[0];
            var index = version === 0 ? 12 : 20;
            track.timescale = (mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]) >>> 0;
        }
        var stbl = $b432346f74fe917b$export$d81d43b46e2012ef(mdia, [
            'minf',
            'stbl'
        ])[0];
        var stsd = $b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
            'stsd'
        ])[0];
        var descriptionCount = (0, $6vzZz.bytesToNumber)(stsd.subarray(4, 8));
        var offset = 8; // add codec and codec info
        while(descriptionCount--){
            var len = (0, $6vzZz.bytesToNumber)(stsd.subarray(offset, offset + 4));
            var sampleDescriptor = stsd.subarray(offset + 4, offset + 4 + len);
            $b432346f74fe917b$export$56fdd13a804135bf(track, sampleDescriptor);
            offset += 4 + len;
        }
        if (frameTable) track.frameTable = $b432346f74fe917b$export$78870b2844ff6386(stbl, track.timescale);
         // codec has no sub parameters
        tracks.push(track);
    });
    return tracks;
};
var $b432346f74fe917b$export$bd2f7582ee199747 = function parseMediaInfo(bytes) {
    var mvhd = $b432346f74fe917b$export$d81d43b46e2012ef(bytes, [
        'moov',
        'mvhd'
    ], true)[0];
    if (!mvhd || !mvhd.length) return;
    var info = {}; // ms to ns
    // mvhd v1 has 8 byte duration and other fields too
    if (mvhd[0] === 1) {
        info.timestampScale = (0, $6vzZz.bytesToNumber)(mvhd.subarray(20, 24));
        info.duration = (0, $6vzZz.bytesToNumber)(mvhd.subarray(24, 32));
    } else {
        info.timestampScale = (0, $6vzZz.bytesToNumber)(mvhd.subarray(12, 16));
        info.duration = (0, $6vzZz.bytesToNumber)(mvhd.subarray(16, 20));
    }
    info.bytes = mvhd;
    return info;
};

});
parcelRegister("90IyT", function(module, exports) {

$parcel$export(module.exports, "getAv1Codec", () => $68f6ae2afedf5ec2$export$5ff37217be0e6718);
$parcel$export(module.exports, "getAvcCodec", () => $68f6ae2afedf5ec2$export$f316fb16efba7de9);
$parcel$export(module.exports, "getHvcCodec", () => $68f6ae2afedf5ec2$export$57f4fb41d46b44d9);

var $6vzZz = parcelRequire("6vzZz");
var $68f6ae2afedf5ec2$export$5ff37217be0e6718 = function getAv1Codec(bytes) {
    var codec = '';
    var profile = bytes[1] >>> 3;
    var level = bytes[1] & 0x1F;
    var tier = bytes[2] >>> 7;
    var highBitDepth = (bytes[2] & 0x40) >> 6;
    var twelveBit = (bytes[2] & 0x20) >> 5;
    var monochrome = (bytes[2] & 0x10) >> 4;
    var chromaSubsamplingX = (bytes[2] & 0x08) >> 3;
    var chromaSubsamplingY = (bytes[2] & 0x04) >> 2;
    var chromaSamplePosition = bytes[2] & 0x03;
    codec += profile + "." + (0, $6vzZz.padStart)(level, 2, '0');
    if (tier === 0) codec += 'M';
    else if (tier === 1) codec += 'H';
    var bitDepth;
    if (profile === 2 && highBitDepth) bitDepth = twelveBit ? 12 : 10;
    else bitDepth = highBitDepth ? 10 : 8;
    codec += "." + (0, $6vzZz.padStart)(bitDepth, 2, '0'); // TODO: can we parse color range??
    codec += "." + monochrome;
    codec += "." + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition;
    return codec;
};
var $68f6ae2afedf5ec2$export$f316fb16efba7de9 = function getAvcCodec(bytes) {
    var profileId = (0, $6vzZz.toHexString)(bytes[1]);
    var constraintFlags = (0, $6vzZz.toHexString)(bytes[2] & 0xFC);
    var levelId = (0, $6vzZz.toHexString)(bytes[3]);
    return "" + profileId + constraintFlags + levelId;
};
var $68f6ae2afedf5ec2$export$57f4fb41d46b44d9 = function getHvcCodec(bytes) {
    var codec = '';
    var profileSpace = bytes[1] >> 6;
    var profileId = bytes[1] & 0x1F;
    var tierFlag = (bytes[1] & 0x20) >> 5;
    var profileCompat = bytes.subarray(2, 6);
    var constraintIds = bytes.subarray(6, 12);
    var levelId = bytes[12];
    if (profileSpace === 1) codec += 'A';
    else if (profileSpace === 2) codec += 'B';
    else if (profileSpace === 3) codec += 'C';
    codec += profileId + "."; // ffmpeg does this in big endian
    var profileCompatVal = parseInt((0, $6vzZz.toBinaryString)(profileCompat).split('').reverse().join(''), 2); // apple does this in little endian...
    if (profileCompatVal > 255) profileCompatVal = parseInt((0, $6vzZz.toBinaryString)(profileCompat), 2);
    codec += profileCompatVal.toString(16) + ".";
    if (tierFlag === 0) codec += 'L';
    else codec += 'H';
    codec += levelId;
    var constraints = '';
    for(var i = 0; i < constraintIds.length; i++){
        var v = constraintIds[i];
        if (v) {
            if (constraints) constraints += '.';
            constraints += v.toString(16);
        }
    }
    if (constraints) codec += "." + constraints;
    return codec;
};

});

parcelRegister("5YwPB", function(module, exports) {

$parcel$export(module.exports, "parseOpusHead", () => $459c05fa11483ba1$export$162487c51ffd8212);
var $459c05fa11483ba1$export$bbdb118c36f58091 = new Uint8Array([
    0x4f,
    0x70,
    0x75,
    0x73,
    0x48,
    0x65,
    0x61,
    0x64
]); // https://wiki.xiph.org/OggOpus
var $459c05fa11483ba1$export$162487c51ffd8212 = function parseOpusHead(bytes) {
    var view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    var version = view.getUint8(0); // version 0, from mp4, does not use littleEndian.
    var littleEndian = version !== 0;
    var config = {
        version: version,
        channels: view.getUint8(1),
        preSkip: view.getUint16(2, littleEndian),
        sampleRate: view.getUint32(4, littleEndian),
        outputGain: view.getUint16(8, littleEndian),
        channelMappingFamily: view.getUint8(10)
    };
    if (config.channelMappingFamily > 0 && bytes.length > 10) {
        config.streamCount = view.getUint8(11);
        config.twoChannelStreamCount = view.getUint8(12);
        config.channelMapping = [];
        for(var c = 0; c < config.channels; c++)config.channelMapping.push(view.getUint8(13 + c));
    }
    return config;
};
var $459c05fa11483ba1$export$57dc6f8263af01df = function setOpusHead(config) {
    var size = config.channelMappingFamily <= 0 ? 11 : 12 + config.channels;
    var view = new DataView(new ArrayBuffer(size));
    var littleEndian = config.version !== 0;
    view.setUint8(0, config.version);
    view.setUint8(1, config.channels);
    view.setUint16(2, config.preSkip, littleEndian);
    view.setUint32(4, config.sampleRate, littleEndian);
    view.setUint16(8, config.outputGain, littleEndian);
    view.setUint8(10, config.channelMappingFamily);
    if (config.channelMappingFamily > 0) {
        view.setUint8(11, config.streamCount);
        config.channelMapping.foreach(function(cm, i) {
            view.setUint8(12 + i, cm);
        });
    }
    return new Uint8Array(view.buffer);
};

});


parcelRegister("cfxK9", function(module, exports) {

$parcel$export(module.exports, "EBML_TAGS", () => $024d2dab5c6dc55e$export$3dc3c695a37e4653);
$parcel$export(module.exports, "findEbml", () => $024d2dab5c6dc55e$export$826a5b7de63531e6);

var $6vzZz = parcelRequire("6vzZz");

var $90IyT = parcelRequire("90IyT");
var $024d2dab5c6dc55e$export$3dc3c695a37e4653 = {
    EBML: (0, $6vzZz.toUint8)([
        0x1A,
        0x45,
        0xDF,
        0xA3
    ]),
    DocType: (0, $6vzZz.toUint8)([
        0x42,
        0x82
    ]),
    Segment: (0, $6vzZz.toUint8)([
        0x18,
        0x53,
        0x80,
        0x67
    ]),
    SegmentInfo: (0, $6vzZz.toUint8)([
        0x15,
        0x49,
        0xA9,
        0x66
    ]),
    Tracks: (0, $6vzZz.toUint8)([
        0x16,
        0x54,
        0xAE,
        0x6B
    ]),
    Track: (0, $6vzZz.toUint8)([
        0xAE
    ]),
    TrackNumber: (0, $6vzZz.toUint8)([
        0xd7
    ]),
    DefaultDuration: (0, $6vzZz.toUint8)([
        0x23,
        0xe3,
        0x83
    ]),
    TrackEntry: (0, $6vzZz.toUint8)([
        0xAE
    ]),
    TrackType: (0, $6vzZz.toUint8)([
        0x83
    ]),
    FlagDefault: (0, $6vzZz.toUint8)([
        0x88
    ]),
    CodecID: (0, $6vzZz.toUint8)([
        0x86
    ]),
    CodecPrivate: (0, $6vzZz.toUint8)([
        0x63,
        0xA2
    ]),
    VideoTrack: (0, $6vzZz.toUint8)([
        0xe0
    ]),
    AudioTrack: (0, $6vzZz.toUint8)([
        0xe1
    ]),
    // Not used yet, but will be used for live webm/mkv
    // see https://www.matroska.org/technical/basics.html#block-structure
    // see https://www.matroska.org/technical/basics.html#simpleblock-structure
    Cluster: (0, $6vzZz.toUint8)([
        0x1F,
        0x43,
        0xB6,
        0x75
    ]),
    Timestamp: (0, $6vzZz.toUint8)([
        0xE7
    ]),
    TimestampScale: (0, $6vzZz.toUint8)([
        0x2A,
        0xD7,
        0xB1
    ]),
    BlockGroup: (0, $6vzZz.toUint8)([
        0xA0
    ]),
    BlockDuration: (0, $6vzZz.toUint8)([
        0x9B
    ]),
    Block: (0, $6vzZz.toUint8)([
        0xA1
    ]),
    SimpleBlock: (0, $6vzZz.toUint8)([
        0xA3
    ])
};
/**
 * This is a simple table to determine the length
 * of things in ebml. The length is one based (starts at 1,
 * rather than zero) and for every zero bit before a one bit
 * we add one to length. We also need this table because in some
 * case we have to xor all the length bits from another value.
 */ var $024d2dab5c6dc55e$var$LENGTH_TABLE = [
    128,
    64,
    32,
    16,
    8,
    4,
    2,
    1
];
var $024d2dab5c6dc55e$var$getLength = function getLength(byte) {
    var len = 1;
    for(var i = 0; i < $024d2dab5c6dc55e$var$LENGTH_TABLE.length; i++){
        if (byte & $024d2dab5c6dc55e$var$LENGTH_TABLE[i]) break;
        len++;
    }
    return len;
}; // length in ebml is stored in the first 4 to 8 bits
// of the first byte. 4 for the id length and 8 for the
// data size length. Length is measured by converting the number to binary
// then 1 + the number of zeros before a 1 is encountered starting
// from the left.
var $024d2dab5c6dc55e$var$getvint = function getvint(bytes, offset, removeLength, signed) {
    if (removeLength === void 0) removeLength = true;
    if (signed === void 0) signed = false;
    var length = $024d2dab5c6dc55e$var$getLength(bytes[offset]);
    var valueBytes = bytes.subarray(offset, offset + length); // NOTE that we do **not** subarray here because we need to copy these bytes
    // as they will be modified below to remove the dataSizeLen bits and we do not
    // want to modify the original data. normally we could just call slice on
    // uint8array but ie 11 does not support that...
    if (removeLength) {
        valueBytes = Array.prototype.slice.call(bytes, offset, offset + length);
        valueBytes[0] ^= $024d2dab5c6dc55e$var$LENGTH_TABLE[length - 1];
    }
    return {
        length: length,
        value: (0, $6vzZz.bytesToNumber)(valueBytes, {
            signed: signed
        }),
        bytes: valueBytes
    };
};
var $024d2dab5c6dc55e$var$normalizePath = function normalizePath(path) {
    if (typeof path === 'string') return path.match(/.{1,2}/g).map(function(p) {
        return normalizePath(p);
    });
    if (typeof path === 'number') return (0, $6vzZz.numberToBytes)(path);
    return path;
};
var $024d2dab5c6dc55e$var$normalizePaths = function normalizePaths(paths) {
    if (!Array.isArray(paths)) return [
        $024d2dab5c6dc55e$var$normalizePath(paths)
    ];
    return paths.map(function(p) {
        return $024d2dab5c6dc55e$var$normalizePath(p);
    });
};
var $024d2dab5c6dc55e$var$getInfinityDataSize = function getInfinityDataSize(id, bytes, offset) {
    if (offset >= bytes.length) return bytes.length;
    var innerid = $024d2dab5c6dc55e$var$getvint(bytes, offset, false);
    if ((0, $6vzZz.bytesMatch)(id.bytes, innerid.bytes)) return offset;
    var dataHeader = $024d2dab5c6dc55e$var$getvint(bytes, offset + innerid.length);
    return getInfinityDataSize(id, bytes, offset + dataHeader.length + dataHeader.value + innerid.length);
};
var $024d2dab5c6dc55e$export$826a5b7de63531e6 = function findEbml(bytes, paths) {
    paths = $024d2dab5c6dc55e$var$normalizePaths(paths);
    bytes = (0, $6vzZz.toUint8)(bytes);
    var results = [];
    if (!paths.length) return results;
    var i = 0;
    while(i < bytes.length){
        var id = $024d2dab5c6dc55e$var$getvint(bytes, i, false);
        var dataHeader = $024d2dab5c6dc55e$var$getvint(bytes, i + id.length);
        var dataStart = i + id.length + dataHeader.length; // dataSize is unknown or this is a live stream
        if (dataHeader.value === 0x7f) {
            dataHeader.value = $024d2dab5c6dc55e$var$getInfinityDataSize(id, bytes, dataStart);
            if (dataHeader.value !== bytes.length) dataHeader.value -= dataStart;
        }
        var dataEnd = dataStart + dataHeader.value > bytes.length ? bytes.length : dataStart + dataHeader.value;
        var data = bytes.subarray(dataStart, dataEnd);
        if ((0, $6vzZz.bytesMatch)(paths[0], id.bytes)) {
            if (paths.length === 1) // this is the end of the paths and we've found the tag we were
            // looking for
            results.push(data);
            else // recursively search for the next tag inside of the data
            // of this one
            results = results.concat(findEbml(data, paths.slice(1)));
        }
        var totalLength = id.length + dataHeader.length + data.length; // move past this tag entirely, we are not looking for it
        i += totalLength;
    }
    return results;
}; // see https://www.matroska.org/technical/basics.html#block-structure
var $024d2dab5c6dc55e$export$cd5299e345c81b3 = function decodeBlock(block, type, timestampScale, clusterTimestamp) {
    var duration;
    if (type === 'group') {
        duration = $024d2dab5c6dc55e$export$826a5b7de63531e6(block, [
            $024d2dab5c6dc55e$export$3dc3c695a37e4653.BlockDuration
        ])[0];
        if (duration) {
            duration = (0, $6vzZz.bytesToNumber)(duration);
            duration = 1 / timestampScale * duration * timestampScale / 1000;
        }
        block = $024d2dab5c6dc55e$export$826a5b7de63531e6(block, [
            $024d2dab5c6dc55e$export$3dc3c695a37e4653.Block
        ])[0];
        type = 'block'; // treat data as a block after this point
    }
    var dv = new DataView(block.buffer, block.byteOffset, block.byteLength);
    var trackNumber = $024d2dab5c6dc55e$var$getvint(block, 0);
    var timestamp = dv.getInt16(trackNumber.length, false);
    var flags = block[trackNumber.length + 2];
    var data = block.subarray(trackNumber.length + 3); // pts/dts in seconds
    var ptsdts = 1 / timestampScale * (clusterTimestamp + timestamp) * timestampScale / 1000; // return the frame
    var parsed = {
        duration: duration,
        trackNumber: trackNumber.value,
        keyframe: type === 'simple' && flags >> 7 === 1,
        invisible: (flags & 0x08) >> 3 === 1,
        lacing: (flags & 0x06) >> 1,
        discardable: type === 'simple' && (flags & 0x01) === 1,
        frames: [],
        pts: ptsdts,
        dts: ptsdts,
        timestamp: timestamp
    };
    if (!parsed.lacing) {
        parsed.frames.push(data);
        return parsed;
    }
    var numberOfFrames = data[0] + 1;
    var frameSizes = [];
    var offset = 1; // Fixed
    if (parsed.lacing === 2) {
        var sizeOfFrame = (data.length - offset) / numberOfFrames;
        for(var i = 0; i < numberOfFrames; i++)frameSizes.push(sizeOfFrame);
    } // xiph
    if (parsed.lacing === 1) for(var _i = 0; _i < numberOfFrames - 1; _i++){
        var size = 0;
        do {
            size += data[offset];
            offset++;
        }while (data[offset - 1] === 0xFF);
        frameSizes.push(size);
    }
     // ebml
    if (parsed.lacing === 3) {
        // first vint is unsinged
        // after that vints are singed and
        // based on a compounding size
        var _size = 0;
        for(var _i2 = 0; _i2 < numberOfFrames - 1; _i2++){
            var vint = _i2 === 0 ? $024d2dab5c6dc55e$var$getvint(data, offset) : $024d2dab5c6dc55e$var$getvint(data, offset, true, true);
            _size += vint.value;
            frameSizes.push(_size);
            offset += vint.length;
        }
    }
    frameSizes.forEach(function(size) {
        parsed.frames.push(data.subarray(offset, offset + size));
        offset += size;
    });
    return parsed;
}; // VP9 Codec Feature Metadata (CodecPrivate)
// https://www.webmproject.org/docs/container/
var $024d2dab5c6dc55e$var$parseVp9Private = function parseVp9Private(bytes) {
    var i = 0;
    var params = {};
    while(i < bytes.length){
        var id = bytes[i] & 0x7f;
        var len = bytes[i + 1];
        var val = void 0;
        if (len === 1) val = bytes[i + 2];
        else val = bytes.subarray(i + 2, i + 2 + len);
        if (id === 1) params.profile = val;
        else if (id === 2) params.level = val;
        else if (id === 3) params.bitDepth = val;
        else if (id === 4) params.chromaSubsampling = val;
        else params[id] = val;
        i += 2 + len;
    }
    return params;
};
var $024d2dab5c6dc55e$export$b9400b1cdedffc2a = function parseTracks(bytes) {
    bytes = (0, $6vzZz.toUint8)(bytes);
    var decodedTracks = [];
    var tracks = $024d2dab5c6dc55e$export$826a5b7de63531e6(bytes, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Segment,
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Tracks,
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Track
    ]);
    if (!tracks.length) tracks = $024d2dab5c6dc55e$export$826a5b7de63531e6(bytes, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Tracks,
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Track
    ]);
    if (!tracks.length) tracks = $024d2dab5c6dc55e$export$826a5b7de63531e6(bytes, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Track
    ]);
    if (!tracks.length) return decodedTracks;
    tracks.forEach(function(track) {
        var trackType = $024d2dab5c6dc55e$export$826a5b7de63531e6(track, $024d2dab5c6dc55e$export$3dc3c695a37e4653.TrackType)[0];
        if (!trackType || !trackType.length) return;
         // 1 is video, 2 is audio, 17 is subtitle
        // other values are unimportant in this context
        if (trackType[0] === 1) trackType = 'video';
        else if (trackType[0] === 2) trackType = 'audio';
        else if (trackType[0] === 17) trackType = 'subtitle';
        else return;
         // todo parse language
        var decodedTrack = {
            rawCodec: (0, $6vzZz.bytesToString)($024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                $024d2dab5c6dc55e$export$3dc3c695a37e4653.CodecID
            ])[0]),
            type: trackType,
            codecPrivate: $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                $024d2dab5c6dc55e$export$3dc3c695a37e4653.CodecPrivate
            ])[0],
            number: (0, $6vzZz.bytesToNumber)($024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                $024d2dab5c6dc55e$export$3dc3c695a37e4653.TrackNumber
            ])[0]),
            defaultDuration: (0, $6vzZz.bytesToNumber)($024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                $024d2dab5c6dc55e$export$3dc3c695a37e4653.DefaultDuration
            ])[0]),
            default: $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                $024d2dab5c6dc55e$export$3dc3c695a37e4653.FlagDefault
            ])[0],
            rawData: track
        };
        var codec = '';
        if (/V_MPEG4\/ISO\/AVC/.test(decodedTrack.rawCodec)) codec = "avc1." + (0, $90IyT.getAvcCodec)(decodedTrack.codecPrivate);
        else if (/V_MPEGH\/ISO\/HEVC/.test(decodedTrack.rawCodec)) codec = "hev1." + (0, $90IyT.getHvcCodec)(decodedTrack.codecPrivate);
        else if (/V_MPEG4\/ISO\/ASP/.test(decodedTrack.rawCodec)) {
            if (decodedTrack.codecPrivate) codec = 'mp4v.20.' + decodedTrack.codecPrivate[4].toString();
            else codec = 'mp4v.20.9';
        } else if (/^V_THEORA/.test(decodedTrack.rawCodec)) codec = 'theora';
        else if (/^V_VP8/.test(decodedTrack.rawCodec)) codec = 'vp8';
        else if (/^V_VP9/.test(decodedTrack.rawCodec)) {
            if (decodedTrack.codecPrivate) {
                var _parseVp9Private = $024d2dab5c6dc55e$var$parseVp9Private(decodedTrack.codecPrivate), profile = _parseVp9Private.profile, level = _parseVp9Private.level, bitDepth = _parseVp9Private.bitDepth, chromaSubsampling = _parseVp9Private.chromaSubsampling;
                codec = 'vp09.';
                codec += (0, $6vzZz.padStart)(profile, 2, '0') + ".";
                codec += (0, $6vzZz.padStart)(level, 2, '0') + ".";
                codec += (0, $6vzZz.padStart)(bitDepth, 2, '0') + ".";
                codec += "" + (0, $6vzZz.padStart)(chromaSubsampling, 2, '0'); // Video -> Colour -> Ebml name
                var matrixCoefficients = $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xB1
                    ]
                ])[0] || [];
                var videoFullRangeFlag = $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xB9
                    ]
                ])[0] || [];
                var transferCharacteristics = $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xBA
                    ]
                ])[0] || [];
                var colourPrimaries = $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xBB
                    ]
                ])[0] || []; // if we find any optional codec parameter specify them all.
                if (matrixCoefficients.length || videoFullRangeFlag.length || transferCharacteristics.length || colourPrimaries.length) {
                    codec += "." + (0, $6vzZz.padStart)(colourPrimaries[0], 2, '0');
                    codec += "." + (0, $6vzZz.padStart)(transferCharacteristics[0], 2, '0');
                    codec += "." + (0, $6vzZz.padStart)(matrixCoefficients[0], 2, '0');
                    codec += "." + (0, $6vzZz.padStart)(videoFullRangeFlag[0], 2, '0');
                }
            } else codec = 'vp9';
        } else if (/^V_AV1/.test(decodedTrack.rawCodec)) codec = "av01." + (0, $90IyT.getAv1Codec)(decodedTrack.codecPrivate);
        else if (/A_ALAC/.test(decodedTrack.rawCodec)) codec = 'alac';
        else if (/A_MPEG\/L2/.test(decodedTrack.rawCodec)) codec = 'mp2';
        else if (/A_MPEG\/L3/.test(decodedTrack.rawCodec)) codec = 'mp3';
        else if (/^A_AAC/.test(decodedTrack.rawCodec)) {
            if (decodedTrack.codecPrivate) codec = 'mp4a.40.' + (decodedTrack.codecPrivate[0] >>> 3).toString();
            else codec = 'mp4a.40.2';
        } else if (/^A_AC3/.test(decodedTrack.rawCodec)) codec = 'ac-3';
        else if (/^A_PCM/.test(decodedTrack.rawCodec)) codec = 'pcm';
        else if (/^A_MS\/ACM/.test(decodedTrack.rawCodec)) codec = 'speex';
        else if (/^A_EAC3/.test(decodedTrack.rawCodec)) codec = 'ec-3';
        else if (/^A_VORBIS/.test(decodedTrack.rawCodec)) codec = 'vorbis';
        else if (/^A_FLAC/.test(decodedTrack.rawCodec)) codec = 'flac';
        else if (/^A_OPUS/.test(decodedTrack.rawCodec)) codec = 'opus';
        decodedTrack.codec = codec;
        decodedTracks.push(decodedTrack);
    });
    return decodedTracks.sort(function(a, b) {
        return a.number - b.number;
    });
};
var $024d2dab5c6dc55e$export$4c0e6fff2d4abe18 = function parseData(data, tracks) {
    var allBlocks = [];
    var segment = $024d2dab5c6dc55e$export$826a5b7de63531e6(data, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Segment
    ])[0];
    var timestampScale = $024d2dab5c6dc55e$export$826a5b7de63531e6(segment, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.SegmentInfo,
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.TimestampScale
    ])[0]; // in nanoseconds, defaults to 1ms
    if (timestampScale && timestampScale.length) timestampScale = (0, $6vzZz.bytesToNumber)(timestampScale);
    else timestampScale = 1000000;
    var clusters = $024d2dab5c6dc55e$export$826a5b7de63531e6(segment, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Cluster
    ]);
    if (!tracks) tracks = $024d2dab5c6dc55e$export$b9400b1cdedffc2a(segment);
    clusters.forEach(function(cluster, ci) {
        var simpleBlocks = $024d2dab5c6dc55e$export$826a5b7de63531e6(cluster, [
            $024d2dab5c6dc55e$export$3dc3c695a37e4653.SimpleBlock
        ]).map(function(b) {
            return {
                type: 'simple',
                data: b
            };
        });
        var blockGroups = $024d2dab5c6dc55e$export$826a5b7de63531e6(cluster, [
            $024d2dab5c6dc55e$export$3dc3c695a37e4653.BlockGroup
        ]).map(function(b) {
            return {
                type: 'group',
                data: b
            };
        });
        var timestamp = $024d2dab5c6dc55e$export$826a5b7de63531e6(cluster, [
            $024d2dab5c6dc55e$export$3dc3c695a37e4653.Timestamp
        ])[0] || 0;
        if (timestamp && timestamp.length) timestamp = (0, $6vzZz.bytesToNumber)(timestamp);
         // get all blocks then sort them into the correct order
        var blocks = simpleBlocks.concat(blockGroups).sort(function(a, b) {
            return a.data.byteOffset - b.data.byteOffset;
        });
        blocks.forEach(function(block, bi) {
            var decoded = $024d2dab5c6dc55e$export$cd5299e345c81b3(block.data, block.type, timestampScale, timestamp);
            allBlocks.push(decoded);
        });
    });
    return {
        tracks: tracks,
        blocks: allBlocks
    };
};

});

parcelRegister("hXRvC", function(module, exports) {

$parcel$export(module.exports, "findH264Nal", () => $d1417422e6d698b2$export$d9a366c79c59ccda);
$parcel$export(module.exports, "findH265Nal", () => $d1417422e6d698b2$export$4b55988b6a40a3f0);

var $6vzZz = parcelRequire("6vzZz");
var $d1417422e6d698b2$export$c685721194c7e8f3 = (0, $6vzZz.toUint8)([
    0x00,
    0x00,
    0x00,
    0x01
]);
var $d1417422e6d698b2$export$5e56cd062936486 = (0, $6vzZz.toUint8)([
    0x00,
    0x00,
    0x01
]);
var $d1417422e6d698b2$export$c6449e11a0e55652 = (0, $6vzZz.toUint8)([
    0x00,
    0x00,
    0x03
]);
var $d1417422e6d698b2$export$1a44f7c1c8cc8def = function discardEmulationPreventionBytes(bytes) {
    var positions = [];
    var i = 1; // Find all `Emulation Prevention Bytes`
    while(i < bytes.length - 2){
        if ((0, $6vzZz.bytesMatch)(bytes.subarray(i, i + 3), $d1417422e6d698b2$export$c6449e11a0e55652)) {
            positions.push(i + 2);
            i++;
        }
        i++;
    } // If no Emulation Prevention Bytes were found just return the original
    // array
    if (positions.length === 0) return bytes;
     // Create a new array to hold the NAL unit data
    var newLength = bytes.length - positions.length;
    var newData = new Uint8Array(newLength);
    var sourceIndex = 0;
    for(i = 0; i < newLength; sourceIndex++, i++){
        if (sourceIndex === positions[0]) {
            // Skip this byte
            sourceIndex++; // Remove this position index
            positions.shift();
        }
        newData[i] = bytes[sourceIndex];
    }
    return newData;
};
var $d1417422e6d698b2$export$17fd5d00213a3829 = function findNal(bytes, dataType, types, nalLimit) {
    if (nalLimit === void 0) nalLimit = Infinity;
    bytes = (0, $6vzZz.toUint8)(bytes);
    types = [].concat(types);
    var i = 0;
    var nalStart;
    var nalsFound = 0; // keep searching until:
    // we reach the end of bytes
    // we reach the maximum number of nals they want to seach
    // NOTE: that we disregard nalLimit when we have found the start
    // of the nal we want so that we can find the end of the nal we want.
    while(i < bytes.length && (nalsFound < nalLimit || nalStart)){
        var nalOffset = void 0;
        if ((0, $6vzZz.bytesMatch)(bytes.subarray(i), $d1417422e6d698b2$export$c685721194c7e8f3)) nalOffset = 4;
        else if ((0, $6vzZz.bytesMatch)(bytes.subarray(i), $d1417422e6d698b2$export$5e56cd062936486)) nalOffset = 3;
         // we are unsynced,
        // find the next nal unit
        if (!nalOffset) {
            i++;
            continue;
        }
        nalsFound++;
        if (nalStart) return $d1417422e6d698b2$export$1a44f7c1c8cc8def(bytes.subarray(nalStart, i));
        var nalType = void 0;
        if (dataType === 'h264') nalType = bytes[i + nalOffset] & 0x1f;
        else if (dataType === 'h265') nalType = bytes[i + nalOffset] >> 1 & 0x3f;
        if (types.indexOf(nalType) !== -1) nalStart = i + nalOffset;
         // nal header is 1 length for h264, and 2 for h265
        i += nalOffset + (dataType === 'h264' ? 1 : 2);
    }
    return bytes.subarray(0, 0);
};
var $d1417422e6d698b2$export$d9a366c79c59ccda = function findH264Nal(bytes, type, nalLimit) {
    return $d1417422e6d698b2$export$17fd5d00213a3829(bytes, 'h264', type, nalLimit);
};
var $d1417422e6d698b2$export$4b55988b6a40a3f0 = function findH265Nal(bytes, type, nalLimit) {
    return $d1417422e6d698b2$export$17fd5d00213a3829(bytes, 'h265', type, nalLimit);
};

});


parcelRegister("3CkWK", function(module, exports) {
/**
 * mux.js
 *
 * Copyright (c) Brightcove
 * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
 */ var $2a252b448d50d133$var$ONE_SECOND_IN_TS = 90000, $2a252b448d50d133$var$secondsToVideoTs, $2a252b448d50d133$var$secondsToAudioTs, $2a252b448d50d133$var$videoTsToSeconds, $2a252b448d50d133$var$audioTsToSeconds, $2a252b448d50d133$var$audioTsToVideoTs, $2a252b448d50d133$var$videoTsToAudioTs, $2a252b448d50d133$var$metadataTsToSeconds;
$2a252b448d50d133$var$secondsToVideoTs = function(seconds) {
    return seconds * $2a252b448d50d133$var$ONE_SECOND_IN_TS;
};
$2a252b448d50d133$var$secondsToAudioTs = function(seconds, sampleRate) {
    return seconds * sampleRate;
};
$2a252b448d50d133$var$videoTsToSeconds = function(timestamp) {
    return timestamp / $2a252b448d50d133$var$ONE_SECOND_IN_TS;
};
$2a252b448d50d133$var$audioTsToSeconds = function(timestamp, sampleRate) {
    return timestamp / sampleRate;
};
$2a252b448d50d133$var$audioTsToVideoTs = function(timestamp, sampleRate) {
    return $2a252b448d50d133$var$secondsToVideoTs($2a252b448d50d133$var$audioTsToSeconds(timestamp, sampleRate));
};
$2a252b448d50d133$var$videoTsToAudioTs = function(timestamp, sampleRate) {
    return $2a252b448d50d133$var$secondsToAudioTs($2a252b448d50d133$var$videoTsToSeconds(timestamp), sampleRate);
};
/**
 * Adjust ID3 tag or caption timing information by the timeline pts values
 * (if keepOriginalTimestamps is false) and convert to seconds
 */ $2a252b448d50d133$var$metadataTsToSeconds = function(timestamp, timelineStartPts, keepOriginalTimestamps) {
    return $2a252b448d50d133$var$videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
};
module.exports = {
    ONE_SECOND_IN_TS: $2a252b448d50d133$var$ONE_SECOND_IN_TS,
    secondsToVideoTs: $2a252b448d50d133$var$secondsToVideoTs,
    secondsToAudioTs: $2a252b448d50d133$var$secondsToAudioTs,
    videoTsToSeconds: $2a252b448d50d133$var$videoTsToSeconds,
    audioTsToSeconds: $2a252b448d50d133$var$audioTsToSeconds,
    audioTsToVideoTs: $2a252b448d50d133$var$audioTsToVideoTs,
    videoTsToAudioTs: $2a252b448d50d133$var$videoTsToAudioTs,
    metadataTsToSeconds: $2a252b448d50d133$var$metadataTsToSeconds
};

});


/**
 * Anime.js - ESM minified bundle
 * @version v4.2.2
 * @license MIT
 * @copyright 2025 - Julian Garnier
 */ const $754ef84e366f6443$var$t = "undefined" != typeof window, $754ef84e366f6443$var$e = $754ef84e366f6443$var$t ? window : null, $754ef84e366f6443$var$s = $754ef84e366f6443$var$t ? document : null, $754ef84e366f6443$var$i = {
    OBJECT: 0,
    ATTRIBUTE: 1,
    CSS: 2,
    TRANSFORM: 3,
    CSS_VAR: 4
}, $754ef84e366f6443$var$r = {
    NUMBER: 0,
    UNIT: 1,
    COLOR: 2,
    COMPLEX: 3
}, $754ef84e366f6443$var$n = {
    NONE: 0,
    AUTO: 1,
    FORCE: 2
}, $754ef84e366f6443$var$o = {
    replace: 0,
    none: 1,
    blend: 2
}, $754ef84e366f6443$var$a = Symbol(), $754ef84e366f6443$var$h = Symbol(), $754ef84e366f6443$var$l = Symbol(), $754ef84e366f6443$var$c = Symbol(), $754ef84e366f6443$var$d = Symbol(), $754ef84e366f6443$var$u = Symbol(), $754ef84e366f6443$var$p = 1e-11, $754ef84e366f6443$var$m = 1e12, $754ef84e366f6443$var$f = 1e3, $754ef84e366f6443$var$g = 120, $754ef84e366f6443$var$_ = "", $754ef84e366f6443$var$y = "var(", $754ef84e366f6443$var$v = (()=>{
    const t = new Map;
    return t.set("x", "translateX"), t.set("y", "translateY"), t.set("z", "translateZ"), t;
})(), $754ef84e366f6443$var$b = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "matrix",
    "matrix3d",
    "perspective"
], $754ef84e366f6443$var$T = $754ef84e366f6443$var$b.reduce((t, e)=>({
        ...t,
        [e]: e + "("
    }), {}), $754ef84e366f6443$var$S = ()=>{}, $754ef84e366f6443$var$w = /(^#([\da-f]{3}){1,2}$)|(^#([\da-f]{4}){1,2}$)/i, $754ef84e366f6443$var$x = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i, $754ef84e366f6443$var$C = /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(-?\d+|-?\d*.\d+)\s*\)/i, $754ef84e366f6443$var$E = /hsl\(\s*(-?\d+|-?\d*.\d+)\s*,\s*(-?\d+|-?\d*.\d+)%\s*,\s*(-?\d+|-?\d*.\d+)%\s*\)/i, $754ef84e366f6443$var$k = /hsla\(\s*(-?\d+|-?\d*.\d+)\s*,\s*(-?\d+|-?\d*.\d+)%\s*,\s*(-?\d+|-?\d*.\d+)%\s*,\s*(-?\d+|-?\d*.\d+)\s*\)/i, $754ef84e366f6443$var$$ = /[-+]?\d*\.?\d+(?:e[-+]?\d)?/gi, $754ef84e366f6443$var$B = /^([-+]?\d*\.?\d+(?:e[-+]?\d+)?)([a-z]+|%)$/i, $754ef84e366f6443$var$O = /([a-z])([A-Z])/g, $754ef84e366f6443$var$N = /(\w+)(\([^)]+\)+)/g, $754ef84e366f6443$var$R = /(\*=|\+=|-=)/, $754ef84e366f6443$var$D = /var\(\s*(--[\w-]+)(?:\s*,\s*([^)]+))?\s*\)/, $754ef84e366f6443$var$L = {
    id: null,
    keyframes: null,
    playbackEase: null,
    playbackRate: 1,
    frameRate: $754ef84e366f6443$var$g,
    loop: 0,
    reversed: !1,
    alternate: !1,
    autoplay: !0,
    persist: !1,
    duration: $754ef84e366f6443$var$f,
    delay: 0,
    loopDelay: 0,
    ease: "out(2)",
    composition: $754ef84e366f6443$var$o.replace,
    modifier: (t)=>t,
    onBegin: $754ef84e366f6443$var$S,
    onBeforeUpdate: $754ef84e366f6443$var$S,
    onUpdate: $754ef84e366f6443$var$S,
    onLoop: $754ef84e366f6443$var$S,
    onPause: $754ef84e366f6443$var$S,
    onComplete: $754ef84e366f6443$var$S,
    onRender: $754ef84e366f6443$var$S
}, $754ef84e366f6443$var$A = {
    current: null,
    root: $754ef84e366f6443$var$s
}, $754ef84e366f6443$var$F = {
    defaults: $754ef84e366f6443$var$L,
    precision: 4,
    timeScale: 1,
    tickThreshold: 200
}, $754ef84e366f6443$var$M = {
    version: "4.2.2",
    engine: null
};
$754ef84e366f6443$var$t && ($754ef84e366f6443$var$e.AnimeJS || ($754ef84e366f6443$var$e.AnimeJS = []), $754ef84e366f6443$var$e.AnimeJS.push($754ef84e366f6443$var$M));
const $754ef84e366f6443$var$P = (t)=>t.replace($754ef84e366f6443$var$O, "$1-$2").toLowerCase(), $754ef84e366f6443$var$I = (t, e)=>0 === t.indexOf(e), $754ef84e366f6443$var$z = Date.now, $754ef84e366f6443$var$U = Array.isArray, $754ef84e366f6443$var$X = (t)=>t && t.constructor === Object, $754ef84e366f6443$var$Y = (t)=>"number" == typeof t && !isNaN(t), $754ef84e366f6443$var$V = (t)=>"string" == typeof t, $754ef84e366f6443$var$W = (t)=>"function" == typeof t, $754ef84e366f6443$var$H = (t)=>void 0 === t, $754ef84e366f6443$var$q = (t)=>$754ef84e366f6443$var$H(t) || null === t, $754ef84e366f6443$var$j = (e)=>$754ef84e366f6443$var$t && e instanceof SVGElement, $754ef84e366f6443$var$G = (t)=>$754ef84e366f6443$var$w.test(t), $754ef84e366f6443$var$Q = (t)=>$754ef84e366f6443$var$I(t, "rgb"), $754ef84e366f6443$var$J = (t)=>$754ef84e366f6443$var$I(t, "hsl"), $754ef84e366f6443$var$Z = (t)=>$754ef84e366f6443$var$G(t) || $754ef84e366f6443$var$Q(t) || $754ef84e366f6443$var$J(t), $754ef84e366f6443$var$K = (t)=>!$754ef84e366f6443$var$F.defaults.hasOwnProperty(t), $754ef84e366f6443$var$tt = [
    "opacity",
    "rotate",
    "overflow",
    "color"
], $754ef84e366f6443$var$et = (t, e)=>{
    if ($754ef84e366f6443$var$tt.includes(e)) return !1;
    if (t.getAttribute(e) || e in t) {
        if ("scale" === e) {
            const e = t.parentNode;
            return e && "filter" === e.tagName;
        }
        return !0;
    }
}, $754ef84e366f6443$var$st = (t)=>$754ef84e366f6443$var$V(t) ? parseFloat(t) : t, $754ef84e366f6443$var$it = Math.pow, $754ef84e366f6443$var$rt = Math.sqrt, $754ef84e366f6443$var$nt = Math.sin, $754ef84e366f6443$var$ot = Math.cos, $754ef84e366f6443$var$at = Math.abs, $754ef84e366f6443$var$ht = Math.exp, $754ef84e366f6443$var$lt = Math.ceil, $754ef84e366f6443$var$ct = Math.floor, $754ef84e366f6443$var$dt = Math.asin, $754ef84e366f6443$var$ut = Math.max, $754ef84e366f6443$var$pt = Math.atan2, $754ef84e366f6443$var$mt = Math.PI, $754ef84e366f6443$var$ft = Math.round, $754ef84e366f6443$var$gt = (t, e, s)=>t < e ? e : t > s ? s : t, $754ef84e366f6443$var$_t = {}, $754ef84e366f6443$var$yt = (t, e)=>{
    if (e < 0) return t;
    if (!e) return $754ef84e366f6443$var$ft(t);
    let s = $754ef84e366f6443$var$_t[e];
    return s || (s = $754ef84e366f6443$var$_t[e] = 10 ** e), $754ef84e366f6443$var$ft(t * s) / s;
}, $754ef84e366f6443$var$vt = (t, e)=>$754ef84e366f6443$var$U(e) ? e.reduce((e, s)=>$754ef84e366f6443$var$at(s - t) < $754ef84e366f6443$var$at(e - t) ? s : e) : e ? $754ef84e366f6443$var$ft(t / e) * e : t, $754ef84e366f6443$var$bt = (t, e, s)=>t + (e - t) * s, $754ef84e366f6443$var$Tt = (t)=>t === 1 / 0 ? $754ef84e366f6443$var$m : t === -1 / 0 ? -$754ef84e366f6443$var$m : t, $754ef84e366f6443$var$St = (t)=>t <= $754ef84e366f6443$var$p ? $754ef84e366f6443$var$p : $754ef84e366f6443$var$Tt($754ef84e366f6443$var$yt(t, 11)), $754ef84e366f6443$var$wt = (t)=>$754ef84e366f6443$var$U(t) ? [
        ...t
    ] : t, $754ef84e366f6443$var$xt = (t, e)=>{
    const s = {
        ...t
    };
    for(let i in e){
        const r = t[i];
        s[i] = $754ef84e366f6443$var$H(r) ? e[i] : r;
    }
    return s;
}, $754ef84e366f6443$var$Ct = (t, e, s, i = "_prev", r = "_next")=>{
    let n = t._head, o = r;
    for(s && (n = t._tail, o = i); n;){
        const t = n[o];
        e(n), n = t;
    }
}, $754ef84e366f6443$var$Et = (t, e, s = "_prev", i = "_next")=>{
    const r = e[s], n = e[i];
    r ? r[i] = n : t._head = n, n ? n[s] = r : t._tail = r, e[s] = null, e[i] = null;
}, $754ef84e366f6443$var$kt = (t, e, s, i = "_prev", r = "_next")=>{
    let n = t._tail;
    for(; n && s && s(n, e);)n = n[i];
    const o = n ? n[r] : t._head;
    n ? n[r] = e : t._head = e, o ? o[i] = e : t._tail = e, e[i] = n, e[r] = o;
}, $754ef84e366f6443$var$$t = (t, e, s)=>{
    const i = t.style.transform;
    let r;
    if (i) {
        const n = t[$754ef84e366f6443$var$c];
        let o;
        for(; o = $754ef84e366f6443$var$N.exec(i);){
            const t = o[1], i = o[2].slice(1, -1);
            n[t] = i, t === e && (r = i, s && (s[e] = i));
        }
    }
    return i && !$754ef84e366f6443$var$H(r) ? r : $754ef84e366f6443$var$I(e, "scale") ? "1" : $754ef84e366f6443$var$I(e, "rotate") || $754ef84e366f6443$var$I(e, "skew") ? "0deg" : "0px";
}, $754ef84e366f6443$var$Bt = (t)=>{
    const e = $754ef84e366f6443$var$x.exec(t) || $754ef84e366f6443$var$C.exec(t), s = $754ef84e366f6443$var$H(e[4]) ? 1 : +e[4];
    return [
        +e[1],
        +e[2],
        +e[3],
        s
    ];
}, $754ef84e366f6443$var$Ot = (t)=>{
    const e = t.length, s = 4 === e || 5 === e;
    return [
        +("0x" + t[1] + t[s ? 1 : 2]),
        +("0x" + t[s ? 2 : 3] + t[s ? 2 : 4]),
        +("0x" + t[s ? 3 : 5] + t[s ? 3 : 6]),
        5 === e || 9 === e ? +(+("0x" + t[s ? 4 : 7] + t[s ? 4 : 8]) / 255).toFixed(3) : 1
    ];
}, $754ef84e366f6443$var$Nt = (t, e, s)=>(s < 0 && (s += 1), s > 1 && (s -= 1), s < 1 / 6 ? t + 6 * (e - t) * s : s < .5 ? e : s < 2 / 3 ? t + (e - t) * (2 / 3 - s) * 6 : t), $754ef84e366f6443$var$Rt = (t)=>{
    const e = $754ef84e366f6443$var$E.exec(t) || $754ef84e366f6443$var$k.exec(t), s = +e[1] / 360, i = +e[2] / 100, r = +e[3] / 100, n = $754ef84e366f6443$var$H(e[4]) ? 1 : +e[4];
    let o, a, h;
    if (0 === i) o = a = h = r;
    else {
        const t = r < .5 ? r * (1 + i) : r + i - r * i, e = 2 * r - t;
        o = $754ef84e366f6443$var$yt(255 * $754ef84e366f6443$var$Nt(e, t, s + 1 / 3), 0), a = $754ef84e366f6443$var$yt(255 * $754ef84e366f6443$var$Nt(e, t, s), 0), h = $754ef84e366f6443$var$yt(255 * $754ef84e366f6443$var$Nt(e, t, s - 1 / 3), 0);
    }
    return [
        o,
        a,
        h,
        n
    ];
}, $754ef84e366f6443$var$Dt = (t)=>$754ef84e366f6443$var$Q(t) ? $754ef84e366f6443$var$Bt(t) : $754ef84e366f6443$var$G(t) ? $754ef84e366f6443$var$Ot(t) : $754ef84e366f6443$var$J(t) ? $754ef84e366f6443$var$Rt(t) : [
        0,
        0,
        0,
        1
    ], $754ef84e366f6443$var$Lt = (t, e)=>$754ef84e366f6443$var$H(t) ? e : t, $754ef84e366f6443$var$At = (t, e, s, i, r)=>{
    let n;
    if ($754ef84e366f6443$var$W(t)) n = ()=>{
        const r = t(e, s, i);
        return isNaN(+r) ? r || 0 : +r;
    };
    else {
        if (!$754ef84e366f6443$var$V(t) || !$754ef84e366f6443$var$I(t, $754ef84e366f6443$var$y)) return t;
        n = ()=>{
            const s = t.match($754ef84e366f6443$var$D), i = s[1], r = s[2];
            let n = getComputedStyle(e)?.getPropertyValue(i);
            return n && n.trim() !== $754ef84e366f6443$var$_ || !r || (n = r.trim()), n || 0;
        };
    }
    return r && (r.func = n), n();
}, $754ef84e366f6443$var$Ft = (t, e)=>t[$754ef84e366f6443$var$h] ? t[$754ef84e366f6443$var$l] && $754ef84e366f6443$var$et(t, e) ? $754ef84e366f6443$var$i.ATTRIBUTE : $754ef84e366f6443$var$b.includes(e) || $754ef84e366f6443$var$v.get(e) ? $754ef84e366f6443$var$i.TRANSFORM : $754ef84e366f6443$var$I(e, "--") ? $754ef84e366f6443$var$i.CSS_VAR : e in t.style ? $754ef84e366f6443$var$i.CSS : e in t ? $754ef84e366f6443$var$i.OBJECT : $754ef84e366f6443$var$i.ATTRIBUTE : $754ef84e366f6443$var$i.OBJECT, $754ef84e366f6443$var$Mt = (t, e, s)=>{
    const i = t.style[e];
    i && s && (s[e] = i);
    const r = i || getComputedStyle(t[$754ef84e366f6443$var$u] || t).getPropertyValue(e);
    return "auto" === r ? "0" : r;
}, $754ef84e366f6443$var$Pt = (t, e, s, r)=>{
    const n = $754ef84e366f6443$var$H(s) ? $754ef84e366f6443$var$Ft(t, e) : s;
    return n === $754ef84e366f6443$var$i.OBJECT ? t[e] || 0 : n === $754ef84e366f6443$var$i.ATTRIBUTE ? t.getAttribute(e) : n === $754ef84e366f6443$var$i.TRANSFORM ? $754ef84e366f6443$var$$t(t, e, r) : n === $754ef84e366f6443$var$i.CSS_VAR ? $754ef84e366f6443$var$Mt(t, e, r).trimStart() : $754ef84e366f6443$var$Mt(t, e, r);
}, $754ef84e366f6443$var$It = (t, e, s)=>"-" === s ? t - e : "+" === s ? t + e : t * e, $754ef84e366f6443$var$zt = ()=>({
        t: $754ef84e366f6443$var$r.NUMBER,
        n: 0,
        u: null,
        o: null,
        d: null,
        s: null
    }), $754ef84e366f6443$var$Ut = (t, e)=>{
    if (e.t = $754ef84e366f6443$var$r.NUMBER, e.n = 0, e.u = null, e.o = null, e.d = null, e.s = null, !t) return e;
    const s = +t;
    if (isNaN(s)) {
        let s = t;
        "=" === s[1] && (e.o = s[0], s = s.slice(2));
        const i = !s.includes(" ") && $754ef84e366f6443$var$B.exec(s);
        if (i) return e.t = $754ef84e366f6443$var$r.UNIT, e.n = +i[1], e.u = i[2], e;
        if (e.o) return e.n = +s, e;
        if ($754ef84e366f6443$var$Z(s)) return e.t = $754ef84e366f6443$var$r.COLOR, e.d = $754ef84e366f6443$var$Dt(s), e;
        {
            const t = s.match($754ef84e366f6443$var$$);
            return e.t = $754ef84e366f6443$var$r.COMPLEX, e.d = t ? t.map(Number) : [], e.s = s.split($754ef84e366f6443$var$$) || [], e;
        }
    }
    return e.n = s, e;
}, $754ef84e366f6443$var$Xt = (t, e)=>(e.t = t._valueType, e.n = t._toNumber, e.u = t._unit, e.o = null, e.d = $754ef84e366f6443$var$wt(t._toNumbers), e.s = $754ef84e366f6443$var$wt(t._strings), e), $754ef84e366f6443$var$Yt = $754ef84e366f6443$var$zt(), $754ef84e366f6443$var$Vt = (t, e, s, a, h)=>{
    const l = t.parent, d = t.duration, u = t.completed, m = t.iterationDuration, f = t.iterationCount, g = t._currentIteration, y = t._loopDelay, v = t._reversed, b = t._alternate, S = t._hasChildren, w = t._delay, x = t._currentTime, C = w + m, E = e - w, k = $754ef84e366f6443$var$gt(x, -w, d), $ = $754ef84e366f6443$var$gt(E, -w, d), B = E - x, O = $ > 0, N = $ >= d, R = d <= $754ef84e366f6443$var$p, D = h === $754ef84e366f6443$var$n.FORCE;
    let L = 0, A = E, M = 0;
    if (f > 1) {
        const e = ~~($ / (m + (N ? 0 : y)));
        t._currentIteration = $754ef84e366f6443$var$gt(e, 0, f), N && t._currentIteration--, L = t._currentIteration % 2, A = $ % (m + y) || 0;
    }
    const P = v ^ (b && L), I = t._ease;
    let z = N ? P ? 0 : d : P ? m - A : A;
    I && (z = m * I(z / m) || 0);
    const U = (l ? l.backwards : E < x) ? !P : !!P;
    if (t._currentTime = E, t._iterationTime = z, t.backwards = U, O && !t.began ? (t.began = !0, s || l && (U || !l.began) || t.onBegin(t)) : E <= 0 && (t.began = !1), s || S || !O || t._currentIteration === g || t.onLoop(t), D || h === $754ef84e366f6443$var$n.AUTO && (e >= w && e <= C || e <= w && k > w || e >= C && k !== d) || z >= C && k !== d || z <= w && k > 0 || e <= k && k === d && u || N && !u && R) {
        if (O && (t.computeDeltaTime(k), s || t.onBeforeUpdate(t)), !S) {
            const e = D || (U ? -1 * B : B) >= $754ef84e366f6443$var$F.tickThreshold, n = t._offset + (l ? l._offset : 0) + w + z;
            let h, d, u, p, m = t._head, f = 0;
            for(; m;){
                const t = m._composition, s = m._currentTime, l = m._changeDuration, g = m._absoluteStartTime + m._changeDuration, y = m._nextRep, v = m._prevRep, b = t !== $754ef84e366f6443$var$o.none;
                if ((e || (s !== l || n <= g + (y ? y._delay : 0)) && (0 !== s || n >= m._absoluteStartTime)) && (!b || !m._isOverridden && (!m._isOverlapped || n <= g) && (!y || y._isOverridden || n <= y._absoluteStartTime) && (!v || v._isOverridden || n >= v._absoluteStartTime + v._changeDuration + m._delay))) {
                    const e = m._currentTime = $754ef84e366f6443$var$gt(z - m._startTime, 0, l), s = m._ease(e / m._updateDuration), n = m._modifier, g = m._valueType, _ = m._tweenType, y = _ === $754ef84e366f6443$var$i.OBJECT, v = g === $754ef84e366f6443$var$r.NUMBER, T = v && y || 0 === s || 1 === s ? -1 : $754ef84e366f6443$var$F.precision;
                    let S, w;
                    if (v) S = w = n($754ef84e366f6443$var$yt($754ef84e366f6443$var$bt(m._fromNumber, m._toNumber, s), T));
                    else if (g === $754ef84e366f6443$var$r.UNIT) w = n($754ef84e366f6443$var$yt($754ef84e366f6443$var$bt(m._fromNumber, m._toNumber, s), T)), S = `${w}${m._unit}`;
                    else if (g === $754ef84e366f6443$var$r.COLOR) {
                        const t = m._fromNumbers, e = m._toNumbers, i = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(n($754ef84e366f6443$var$bt(t[0], e[0], s)), 0, 255), 0), r = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(n($754ef84e366f6443$var$bt(t[1], e[1], s)), 0, 255), 0), o = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(n($754ef84e366f6443$var$bt(t[2], e[2], s)), 0, 255), 0), a = $754ef84e366f6443$var$gt(n($754ef84e366f6443$var$yt($754ef84e366f6443$var$bt(t[3], e[3], s), T)), 0, 1);
                        if (S = `rgba(${i},${r},${o},${a})`, b) {
                            const t = m._numbers;
                            t[0] = i, t[1] = r, t[2] = o, t[3] = a;
                        }
                    } else if (g === $754ef84e366f6443$var$r.COMPLEX) {
                        S = m._strings[0];
                        for(let t = 0, e = m._toNumbers.length; t < e; t++){
                            const e = n($754ef84e366f6443$var$yt($754ef84e366f6443$var$bt(m._fromNumbers[t], m._toNumbers[t], s), T)), i = m._strings[t + 1];
                            S += `${i ? e + i : e}`, b && (m._numbers[t] = e);
                        }
                    }
                    if (b && (m._number = w), a || t === $754ef84e366f6443$var$o.blend) m._value = S;
                    else {
                        const t = m.property;
                        h = m.target, y ? h[t] = S : _ === $754ef84e366f6443$var$i.ATTRIBUTE ? h.setAttribute(t, S) : (d = h.style, _ === $754ef84e366f6443$var$i.TRANSFORM ? (h !== u && (u = h, p = h[$754ef84e366f6443$var$c]), p[t] = S, f = 1) : _ === $754ef84e366f6443$var$i.CSS ? d[t] = S : _ === $754ef84e366f6443$var$i.CSS_VAR && d.setProperty(t, S)), O && (M = 1);
                    }
                }
                if (f && m._renderTransforms) {
                    let t = $754ef84e366f6443$var$_;
                    for(let e in p)t += `${$754ef84e366f6443$var$T[e]}${p[e]}) `;
                    d.transform = t, f = 0;
                }
                m = m._next;
            }
            !s && M && t.onRender(t);
        }
        !s && O && t.onUpdate(t);
    }
    return l && R ? !s && (l.began && !U && E > 0 && !u || U && E <= $754ef84e366f6443$var$p && u) && (t.onComplete(t), t.completed = !U) : O && N ? f === 1 / 0 ? t._startTime += t.duration : t._currentIteration >= f - 1 && (t.paused = !0, u || S || (t.completed = !0, s || l && (U || !l.began) || (t.onComplete(t), t._resolve(t)))) : t.completed = !1, M;
}, $754ef84e366f6443$var$Wt = (t, e, s, i, r)=>{
    const o = t._currentIteration;
    if ($754ef84e366f6443$var$Vt(t, e, s, i, r), t._hasChildren) {
        const a = t, h = a.backwards, l = i ? e : a._iterationTime, c = $754ef84e366f6443$var$z();
        let d = 0, u = !0;
        if (!i && a._currentIteration !== o) {
            const t = a.iterationDuration;
            $754ef84e366f6443$var$Ct(a, (e)=>{
                if (h) {
                    const i = e.duration, r = e._offset + e._delay;
                    s || !(i <= $754ef84e366f6443$var$p) || r && r + i !== t || e.onComplete(e);
                } else !e.completed && !e.backwards && e._currentTime < e.iterationDuration && $754ef84e366f6443$var$Vt(e, t, s, 1, $754ef84e366f6443$var$n.FORCE), e.began = !1, e.completed = !1;
            }), s || a.onLoop(a);
        }
        $754ef84e366f6443$var$Ct(a, (t)=>{
            const e = $754ef84e366f6443$var$yt((l - t._offset) * t._speed, 12), n = t._fps < a._fps ? t.requestTick(c) : r;
            d += $754ef84e366f6443$var$Vt(t, e, s, i, n), !t.completed && u && (u = !1);
        }, h), !s && d && a.onRender(a), (u || h) && a._currentTime >= a.duration && (a.paused = !0, a.completed || (a.completed = !0, s || (a.onComplete(a), a._resolve(a))));
    }
}, $754ef84e366f6443$var$Ht = {}, $754ef84e366f6443$var$qt = (t, e, s)=>{
    if (s === $754ef84e366f6443$var$i.TRANSFORM) return $754ef84e366f6443$var$v.get(t) || t;
    if (s === $754ef84e366f6443$var$i.CSS || s === $754ef84e366f6443$var$i.ATTRIBUTE && $754ef84e366f6443$var$j(e) && t in e.style) {
        const e = $754ef84e366f6443$var$Ht[t];
        if (e) return e;
        {
            const e = t ? $754ef84e366f6443$var$P(t) : t;
            return $754ef84e366f6443$var$Ht[t] = e, e;
        }
    }
    return t;
}, $754ef84e366f6443$export$a631c64f18a23a10 = (t)=>{
    if (t._hasChildren) $754ef84e366f6443$var$Ct(t, $754ef84e366f6443$export$a631c64f18a23a10, !0);
    else {
        const e = t;
        e.pause(), $754ef84e366f6443$var$Ct(e, (t)=>{
            const s = t.property, r = t.target;
            if (r[$754ef84e366f6443$var$h]) {
                const n = r.style, o = t._inlineValue, a = $754ef84e366f6443$var$q(o) || o === $754ef84e366f6443$var$_;
                if (t._tweenType === $754ef84e366f6443$var$i.TRANSFORM) {
                    const e = r[$754ef84e366f6443$var$c];
                    if (a ? delete e[s] : e[s] = o, t._renderTransforms) {
                        if (Object.keys(e).length) {
                            let t = $754ef84e366f6443$var$_;
                            for(let s in e)t += $754ef84e366f6443$var$T[s] + e[s] + ") ";
                            n.transform = t;
                        } else n.removeProperty("transform");
                    }
                } else a ? n.removeProperty($754ef84e366f6443$var$P(s)) : n[s] = o;
                e._tail === t && e.targets.forEach((t)=>{
                    t.getAttribute && t.getAttribute("style") === $754ef84e366f6443$var$_ && t.removeAttribute("style");
                });
            }
        });
    }
    return t;
};
class $754ef84e366f6443$var$Gt {
    constructor(t = 0){
        this.deltaTime = 0, this._currentTime = t, this._elapsedTime = t, this._startTime = t, this._lastTime = t, this._scheduledTime = 0, this._frameDuration = $754ef84e366f6443$var$yt($754ef84e366f6443$var$f / $754ef84e366f6443$var$g, 0), this._fps = $754ef84e366f6443$var$g, this._speed = 1, this._hasChildren = !1, this._head = null, this._tail = null;
    }
    get fps() {
        return this._fps;
    }
    set fps(t) {
        const e = this._frameDuration, s = +t, i = s < $754ef84e366f6443$var$p ? $754ef84e366f6443$var$p : s, r = $754ef84e366f6443$var$yt($754ef84e366f6443$var$f / i, 0);
        this._fps = i, this._frameDuration = r, this._scheduledTime += r - e;
    }
    get speed() {
        return this._speed;
    }
    set speed(t) {
        const e = +t;
        this._speed = e < $754ef84e366f6443$var$p ? $754ef84e366f6443$var$p : e;
    }
    requestTick(t) {
        const e = this._scheduledTime, s = this._elapsedTime;
        if (this._elapsedTime += t - s, s < e) return $754ef84e366f6443$var$n.NONE;
        const i = this._frameDuration, r = s - e;
        return this._scheduledTime += r < i ? i : r, $754ef84e366f6443$var$n.AUTO;
    }
    computeDeltaTime(t) {
        const e = t - this._lastTime;
        return this.deltaTime = e, this._lastTime = t, e;
    }
}
const $754ef84e366f6443$var$Qt = {
    animation: null,
    update: $754ef84e366f6443$var$S
}, $754ef84e366f6443$var$Jt = (t)=>{
    let e = $754ef84e366f6443$var$Qt.animation;
    return e || (e = {
        duration: $754ef84e366f6443$var$p,
        computeDeltaTime: $754ef84e366f6443$var$S,
        _offset: 0,
        _delay: 0,
        _head: null,
        _tail: null
    }, $754ef84e366f6443$var$Qt.animation = e, $754ef84e366f6443$var$Qt.update = ()=>{
        t.forEach((t)=>{
            for(let e in t){
                const s = t[e], i = s._head;
                if (i) {
                    const t = i._valueType, e = t === $754ef84e366f6443$var$r.COMPLEX || t === $754ef84e366f6443$var$r.COLOR ? $754ef84e366f6443$var$wt(i._fromNumbers) : null;
                    let n = i._fromNumber, o = s._tail;
                    for(; o && o !== i;){
                        if (e) for(let t = 0, s = o._numbers.length; t < s; t++)e[t] += o._numbers[t];
                        else n += o._number;
                        o = o._prevAdd;
                    }
                    i._toNumber = n, i._toNumbers = e;
                }
            }
        }), $754ef84e366f6443$var$Vt(e, 1, 1, 0, $754ef84e366f6443$var$n.FORCE);
    }), e;
}, $754ef84e366f6443$var$Zt = (()=>$754ef84e366f6443$var$t ? requestAnimationFrame : setImmediate)(), $754ef84e366f6443$var$Kt = (()=>$754ef84e366f6443$var$t ? cancelAnimationFrame : clearImmediate)();
class $754ef84e366f6443$var$te extends $754ef84e366f6443$var$Gt {
    constructor(t){
        super(t), this.useDefaultMainLoop = !0, this.pauseOnDocumentHidden = !0, this.defaults = $754ef84e366f6443$var$L, this.paused = !0, this.reqId = 0;
    }
    update() {
        const t = this._currentTime = $754ef84e366f6443$var$z();
        if (this.requestTick(t)) {
            this.computeDeltaTime(t);
            const e = this._speed, s = this._fps;
            let i = this._head;
            for(; i;){
                const r = i._next;
                i.paused ? ($754ef84e366f6443$var$Et(this, i), this._hasChildren = !!this._tail, i._running = !1, i.completed && !i._cancelled && i.cancel()) : $754ef84e366f6443$var$Wt(i, (t - i._startTime) * i._speed * e, 0, 0, i._fps < s ? i.requestTick(t) : $754ef84e366f6443$var$n.AUTO), i = r;
            }
            $754ef84e366f6443$var$Qt.update();
        }
    }
    wake() {
        return this.useDefaultMainLoop && !this.reqId && (this.requestTick($754ef84e366f6443$var$z()), this.reqId = $754ef84e366f6443$var$Zt($754ef84e366f6443$var$se)), this;
    }
    pause() {
        if (this.reqId) return this.paused = !0, $754ef84e366f6443$var$ie();
    }
    resume() {
        if (this.paused) return this.paused = !1, $754ef84e366f6443$var$Ct(this, (t)=>t.resetTime()), this.wake();
    }
    get speed() {
        return this._speed * (1 === $754ef84e366f6443$var$F.timeScale ? 1 : $754ef84e366f6443$var$f);
    }
    set speed(t) {
        this._speed = t * $754ef84e366f6443$var$F.timeScale, $754ef84e366f6443$var$Ct(this, (t)=>t.speed = t._speed);
    }
    get timeUnit() {
        return 1 === $754ef84e366f6443$var$F.timeScale ? "ms" : "s";
    }
    set timeUnit(t) {
        const e = "s" === t, s = e ? .001 : 1;
        if ($754ef84e366f6443$var$F.timeScale !== s) {
            $754ef84e366f6443$var$F.timeScale = s, $754ef84e366f6443$var$F.tickThreshold = 200 * s;
            const t = e ? .001 : $754ef84e366f6443$var$f;
            this.defaults.duration *= t, this._speed *= t;
        }
    }
    get precision() {
        return $754ef84e366f6443$var$F.precision;
    }
    set precision(t) {
        $754ef84e366f6443$var$F.precision = t;
    }
}
const $754ef84e366f6443$export$d3c662a6136faebb = (()=>{
    const e = new $754ef84e366f6443$var$te($754ef84e366f6443$var$z());
    return $754ef84e366f6443$var$t && ($754ef84e366f6443$var$M.engine = e, $754ef84e366f6443$var$s.addEventListener("visibilitychange", ()=>{
        e.pauseOnDocumentHidden && ($754ef84e366f6443$var$s.hidden ? e.pause() : e.resume());
    })), e;
})(), $754ef84e366f6443$var$se = ()=>{
    $754ef84e366f6443$export$d3c662a6136faebb._head ? ($754ef84e366f6443$export$d3c662a6136faebb.reqId = $754ef84e366f6443$var$Zt($754ef84e366f6443$var$se), $754ef84e366f6443$export$d3c662a6136faebb.update()) : $754ef84e366f6443$export$d3c662a6136faebb.reqId = 0;
}, $754ef84e366f6443$var$ie = ()=>($754ef84e366f6443$var$Kt($754ef84e366f6443$export$d3c662a6136faebb.reqId), $754ef84e366f6443$export$d3c662a6136faebb.reqId = 0, $754ef84e366f6443$export$d3c662a6136faebb), $754ef84e366f6443$var$re = {
    _rep: new WeakMap,
    _add: new Map
}, $754ef84e366f6443$var$ne = (t, e, s = "_rep")=>{
    const i = $754ef84e366f6443$var$re[s];
    let r = i.get(t);
    return r || (r = {}, i.set(t, r)), r[e] ? r[e] : r[e] = {
        _head: null,
        _tail: null
    };
}, $754ef84e366f6443$var$oe = (t, e)=>t._isOverridden || t._absoluteStartTime > e._absoluteStartTime, $754ef84e366f6443$var$ae = (t)=>{
    t._isOverlapped = 1, t._isOverridden = 1, t._changeDuration = $754ef84e366f6443$var$p, t._currentTime = $754ef84e366f6443$var$p;
}, $754ef84e366f6443$var$he = (t, e)=>{
    const s = t._composition;
    if (s === $754ef84e366f6443$var$o.replace) {
        const s = t._absoluteStartTime;
        $754ef84e366f6443$var$kt(e, t, $754ef84e366f6443$var$oe, "_prevRep", "_nextRep");
        const i = t._prevRep;
        if (i) {
            const e = i.parent, r = i._absoluteStartTime + i._changeDuration;
            if (t.parent.id !== e.id && e.iterationCount > 1 && r + (e.duration - e.iterationDuration) > s) {
                $754ef84e366f6443$var$ae(i);
                let t = i._prevRep;
                for(; t && t.parent.id === e.id;)$754ef84e366f6443$var$ae(t), t = t._prevRep;
            }
            const n = s - t._delay;
            if (r > n) {
                const t = i._startTime, e = r - (t + i._updateDuration), s = $754ef84e366f6443$var$yt(n - e - t, 12);
                i._changeDuration = s, i._currentTime = s, i._isOverlapped = 1, s < $754ef84e366f6443$var$p && $754ef84e366f6443$var$ae(i);
            }
            let o = !0;
            if ($754ef84e366f6443$var$Ct(e, (t)=>{
                t._isOverlapped || (o = !1);
            }), o) {
                const t = e.parent;
                if (t) {
                    let s = !0;
                    $754ef84e366f6443$var$Ct(t, (t)=>{
                        t !== e && $754ef84e366f6443$var$Ct(t, (t)=>{
                            t._isOverlapped || (s = !1);
                        });
                    }), s && t.cancel();
                } else e.cancel();
            }
        }
    } else if (s === $754ef84e366f6443$var$o.blend) {
        const e = $754ef84e366f6443$var$ne(t.target, t.property, "_add"), s = $754ef84e366f6443$var$Jt($754ef84e366f6443$var$re._add);
        let i = e._head;
        i || (i = {
            ...t
        }, i._composition = $754ef84e366f6443$var$o.replace, i._updateDuration = $754ef84e366f6443$var$p, i._startTime = 0, i._numbers = $754ef84e366f6443$var$wt(t._fromNumbers), i._number = 0, i._next = null, i._prev = null, $754ef84e366f6443$var$kt(e, i), $754ef84e366f6443$var$kt(s, i));
        const r = t._toNumber;
        if (t._fromNumber = i._fromNumber - r, t._toNumber = 0, t._numbers = $754ef84e366f6443$var$wt(t._fromNumbers), t._number = 0, i._fromNumber = r, t._toNumbers) {
            const e = $754ef84e366f6443$var$wt(t._toNumbers);
            e && e.forEach((e, s)=>{
                t._fromNumbers[s] = i._fromNumbers[s] - e, t._toNumbers[s] = 0;
            }), i._fromNumbers = e;
        }
        $754ef84e366f6443$var$kt(e, t, null, "_prevAdd", "_nextAdd");
    }
    return t;
}, $754ef84e366f6443$var$le = (t)=>{
    const e = t._composition;
    if (e !== $754ef84e366f6443$var$o.none) {
        const s = t.target, i = t.property, r = $754ef84e366f6443$var$re._rep.get(s)[i];
        if ($754ef84e366f6443$var$Et(r, t, "_prevRep", "_nextRep"), e === $754ef84e366f6443$var$o.blend) {
            const e = $754ef84e366f6443$var$re._add, r = e.get(s);
            if (!r) return;
            const n = r[i], o = $754ef84e366f6443$var$Qt.animation;
            $754ef84e366f6443$var$Et(n, t, "_prevAdd", "_nextAdd");
            const a = n._head;
            if (a && a === n._tail) {
                $754ef84e366f6443$var$Et(n, a, "_prevAdd", "_nextAdd"), $754ef84e366f6443$var$Et(o, a);
                let t = !0;
                for(let e in r)if (r[e]._head) {
                    t = !1;
                    break;
                }
                t && e.delete(s);
            }
        }
    }
    return t;
}, $754ef84e366f6443$var$ce = (t, e, s)=>{
    let r = !1;
    return $754ef84e366f6443$var$Ct(e, (n)=>{
        const o = n.target;
        if (t.includes(o)) {
            const t = n.property, a = n._tweenType, h = $754ef84e366f6443$var$qt(s, o, a);
            (!h || h && h === t) && (n.parent._tail === n && n._tweenType === $754ef84e366f6443$var$i.TRANSFORM && n._prev && n._prev._tweenType === $754ef84e366f6443$var$i.TRANSFORM && (n._prev._renderTransforms = 1), $754ef84e366f6443$var$Et(e, n), $754ef84e366f6443$var$le(n), r = !0);
        }
    }, !0), r;
}, $754ef84e366f6443$var$de = (t, e, s)=>{
    const i = e || $754ef84e366f6443$export$d3c662a6136faebb;
    let r;
    if (i._hasChildren) {
        let e = 0;
        $754ef84e366f6443$var$Ct(i, (n)=>{
            if (!n._hasChildren) {
                if (r = $754ef84e366f6443$var$ce(t, n, s), r && !n._head) n.cancel(), $754ef84e366f6443$var$Et(i, n);
                else {
                    const t = n._offset + n._delay + n.duration;
                    t > e && (e = t);
                }
            }
            n._head ? $754ef84e366f6443$var$de(t, n, s) : n._hasChildren = !1;
        }, !0), $754ef84e366f6443$var$H(i.iterationDuration) || (i.iterationDuration = e);
    } else r = $754ef84e366f6443$var$ce(t, i, s);
    r && !i._head && (i._hasChildren = !1, i.cancel && i.cancel());
}, $754ef84e366f6443$var$ue = (t)=>(t.paused = !0, t.began = !1, t.completed = !1, t), $754ef84e366f6443$var$pe = (t)=>t._cancelled ? (t._hasChildren ? $754ef84e366f6443$var$Ct(t, $754ef84e366f6443$var$pe) : $754ef84e366f6443$var$Ct(t, (t)=>{
        t._composition !== $754ef84e366f6443$var$o.none && $754ef84e366f6443$var$he(t, $754ef84e366f6443$var$ne(t.target, t.property));
    }), t._cancelled = 0, t) : t;
let $754ef84e366f6443$var$me = 0;
class $754ef84e366f6443$export$c57e9b2d8b9e4de extends $754ef84e366f6443$var$Gt {
    constructor(t = {}, e = null, s = 0){
        super(0);
        const { id: i, delay: r, duration: n, reversed: o, alternate: a, loop: h, loopDelay: l, autoplay: c, frameRate: d, playbackRate: u, onComplete: m, onLoop: f, onPause: g, onBegin: _, onBeforeUpdate: y, onUpdate: v } = t;
        $754ef84e366f6443$var$A.current && $754ef84e366f6443$var$A.current.register(this);
        const b = e ? 0 : $754ef84e366f6443$export$d3c662a6136faebb._elapsedTime, T = e ? e.defaults : $754ef84e366f6443$var$F.defaults, w = $754ef84e366f6443$var$W(r) || $754ef84e366f6443$var$H(r) ? T.delay : +r, x = $754ef84e366f6443$var$W(n) || $754ef84e366f6443$var$H(n) ? 1 / 0 : +n, C = $754ef84e366f6443$var$Lt(h, T.loop), E = $754ef84e366f6443$var$Lt(l, T.loopDelay), k = !0 === C || C === 1 / 0 || C < 0 ? 1 / 0 : C + 1;
        let $ = 0;
        e ? $ = s : ($754ef84e366f6443$export$d3c662a6136faebb.reqId || $754ef84e366f6443$export$d3c662a6136faebb.requestTick($754ef84e366f6443$var$z()), $ = ($754ef84e366f6443$export$d3c662a6136faebb._elapsedTime - $754ef84e366f6443$export$d3c662a6136faebb._startTime) * $754ef84e366f6443$var$F.timeScale), this.id = $754ef84e366f6443$var$H(i) ? ++$754ef84e366f6443$var$me : i, this.parent = e, this.duration = $754ef84e366f6443$var$Tt((x + E) * k - E) || $754ef84e366f6443$var$p, this.backwards = !1, this.paused = !0, this.began = !1, this.completed = !1, this.onBegin = _ || T.onBegin, this.onBeforeUpdate = y || T.onBeforeUpdate, this.onUpdate = v || T.onUpdate, this.onLoop = f || T.onLoop, this.onPause = g || T.onPause, this.onComplete = m || T.onComplete, this.iterationDuration = x, this.iterationCount = k, this._autoplay = !e && $754ef84e366f6443$var$Lt(c, T.autoplay), this._offset = $, this._delay = w, this._loopDelay = E, this._iterationTime = 0, this._currentIteration = 0, this._resolve = $754ef84e366f6443$var$S, this._running = !1, this._reversed = +$754ef84e366f6443$var$Lt(o, T.reversed), this._reverse = this._reversed, this._cancelled = 0, this._alternate = $754ef84e366f6443$var$Lt(a, T.alternate), this._prev = null, this._next = null, this._elapsedTime = b, this._startTime = b, this._lastTime = b, this._fps = $754ef84e366f6443$var$Lt(d, T.frameRate), this._speed = $754ef84e366f6443$var$Lt(u, T.playbackRate);
    }
    get cancelled() {
        return !!this._cancelled;
    }
    set cancelled(t) {
        t ? this.cancel() : this.reset(!0).play();
    }
    get currentTime() {
        return $754ef84e366f6443$var$gt($754ef84e366f6443$var$yt(this._currentTime, $754ef84e366f6443$var$F.precision), -this._delay, this.duration);
    }
    set currentTime(t) {
        const e = this.paused;
        this.pause().seek(+t), e || this.resume();
    }
    get iterationCurrentTime() {
        return $754ef84e366f6443$var$yt(this._iterationTime, $754ef84e366f6443$var$F.precision);
    }
    set iterationCurrentTime(t) {
        this.currentTime = this.iterationDuration * this._currentIteration + t;
    }
    get progress() {
        return $754ef84e366f6443$var$gt($754ef84e366f6443$var$yt(this._currentTime / this.duration, 10), 0, 1);
    }
    set progress(t) {
        this.currentTime = this.duration * t;
    }
    get iterationProgress() {
        return $754ef84e366f6443$var$gt($754ef84e366f6443$var$yt(this._iterationTime / this.iterationDuration, 10), 0, 1);
    }
    set iterationProgress(t) {
        const e = this.iterationDuration;
        this.currentTime = e * this._currentIteration + e * t;
    }
    get currentIteration() {
        return this._currentIteration;
    }
    set currentIteration(t) {
        this.currentTime = this.iterationDuration * $754ef84e366f6443$var$gt(+t, 0, this.iterationCount - 1);
    }
    get reversed() {
        return !!this._reversed;
    }
    set reversed(t) {
        t ? this.reverse() : this.play();
    }
    get speed() {
        return super.speed;
    }
    set speed(t) {
        super.speed = t, this.resetTime();
    }
    reset(t = !1) {
        return $754ef84e366f6443$var$pe(this), this._reversed && !this._reverse && (this.reversed = !1), this._iterationTime = this.iterationDuration, $754ef84e366f6443$var$Wt(this, 0, 1, ~~t, $754ef84e366f6443$var$n.FORCE), $754ef84e366f6443$var$ue(this), this._hasChildren && $754ef84e366f6443$var$Ct(this, $754ef84e366f6443$var$ue), this;
    }
    init(t = !1) {
        this.fps = this._fps, this.speed = this._speed, !t && this._hasChildren && $754ef84e366f6443$var$Wt(this, this.duration, 1, ~~t, $754ef84e366f6443$var$n.FORCE), this.reset(t);
        const e = this._autoplay;
        return !0 === e ? this.resume() : e && !$754ef84e366f6443$var$H(e.linked) && e.link(this), this;
    }
    resetTime() {
        const t = 1 / (this._speed * $754ef84e366f6443$export$d3c662a6136faebb._speed);
        return this._startTime = $754ef84e366f6443$var$z() - (this._currentTime + this._delay) * t, this;
    }
    pause() {
        return this.paused || (this.paused = !0, this.onPause(this)), this;
    }
    resume() {
        return this.paused ? (this.paused = !1, this.duration <= $754ef84e366f6443$var$p && !this._hasChildren ? $754ef84e366f6443$var$Wt(this, $754ef84e366f6443$var$p, 0, 0, $754ef84e366f6443$var$n.FORCE) : (this._running || ($754ef84e366f6443$var$kt($754ef84e366f6443$export$d3c662a6136faebb, this), $754ef84e366f6443$export$d3c662a6136faebb._hasChildren = !0, this._running = !0), this.resetTime(), this._startTime -= 12, $754ef84e366f6443$export$d3c662a6136faebb.wake()), this) : this;
    }
    restart() {
        return this.reset().resume();
    }
    seek(t, e = 0, s = 0) {
        $754ef84e366f6443$var$pe(this), this.completed = !1;
        const i = this.paused;
        return this.paused = !0, $754ef84e366f6443$var$Wt(this, t + this._delay, ~~e, ~~s, $754ef84e366f6443$var$n.AUTO), i ? this : this.resume();
    }
    alternate() {
        const t = this._reversed, e = this.iterationCount, s = this.iterationDuration, i = e === 1 / 0 ? $754ef84e366f6443$var$ct($754ef84e366f6443$var$m / s) : e;
        return this._reversed = +(!this._alternate || i % 2 ? !t : t), e === 1 / 0 ? this.iterationProgress = this._reversed ? 1 - this.iterationProgress : this.iterationProgress : this.seek(s * i - this._currentTime), this.resetTime(), this;
    }
    play() {
        return this._reversed && this.alternate(), this.resume();
    }
    reverse() {
        return this._reversed || this.alternate(), this.resume();
    }
    cancel() {
        return this._hasChildren ? $754ef84e366f6443$var$Ct(this, (t)=>t.cancel(), !0) : $754ef84e366f6443$var$Ct(this, $754ef84e366f6443$var$le), this._cancelled = 1, this.pause();
    }
    stretch(t) {
        const e = this.duration, s = $754ef84e366f6443$var$St(t);
        if (e === s) return this;
        const i = t / e, r = t <= $754ef84e366f6443$var$p;
        return this.duration = r ? $754ef84e366f6443$var$p : s, this.iterationDuration = r ? $754ef84e366f6443$var$p : $754ef84e366f6443$var$St(this.iterationDuration * i), this._offset *= i, this._delay *= i, this._loopDelay *= i, this;
    }
    revert() {
        $754ef84e366f6443$var$Wt(this, 0, 1, 0, $754ef84e366f6443$var$n.AUTO);
        const t = this._autoplay;
        return t && t.linked && t.linked === this && t.revert(), this.cancel();
    }
    complete() {
        return this.seek(this.duration).cancel();
    }
    then(t = $754ef84e366f6443$var$S) {
        const e = this.then, s = ()=>{
            this.then = null, t(this), this.then = e, this._resolve = $754ef84e366f6443$var$S;
        };
        return new Promise((t)=>(this._resolve = ()=>t(s()), this.completed && this._resolve(), this));
    }
}
const $754ef84e366f6443$export$250a6b1c8e5f96e1 = (t)=>new $754ef84e366f6443$export$c57e9b2d8b9e4de(t, null, 0).init();
function $754ef84e366f6443$var$_e(t) {
    const e = $754ef84e366f6443$var$V(t) ? $754ef84e366f6443$var$A.root.querySelectorAll(t) : t;
    if (e instanceof NodeList || e instanceof HTMLCollection) return e;
}
function $754ef84e366f6443$var$ye(e) {
    if ($754ef84e366f6443$var$q(e)) return [];
    if (!$754ef84e366f6443$var$t) return $754ef84e366f6443$var$U(e) && e.flat(1 / 0) || [
        e
    ];
    if ($754ef84e366f6443$var$U(e)) {
        const t = e.flat(1 / 0), s = [];
        for(let e = 0, i = t.length; e < i; e++){
            const i = t[e];
            if (!$754ef84e366f6443$var$q(i)) {
                const t = $754ef84e366f6443$var$_e(i);
                if (t) for(let e = 0, i = t.length; e < i; e++){
                    const i = t[e];
                    if (!$754ef84e366f6443$var$q(i)) {
                        let t = !1;
                        for(let e = 0, r = s.length; e < r; e++)if (s[e] === i) {
                            t = !0;
                            break;
                        }
                        t || s.push(i);
                    }
                }
                else {
                    let t = !1;
                    for(let e = 0, r = s.length; e < r; e++)if (s[e] === i) {
                        t = !0;
                        break;
                    }
                    t || s.push(i);
                }
            }
        }
        return s;
    }
    const s = $754ef84e366f6443$var$_e(e);
    return s ? Array.from(s) : [
        e
    ];
}
function $754ef84e366f6443$export$3d8c2f653ac9d0b9(t) {
    const e = $754ef84e366f6443$var$ye(t), s = e.length;
    if (s) for(let t = 0; t < s; t++){
        const s = e[t];
        if (!s[$754ef84e366f6443$var$a]) {
            s[$754ef84e366f6443$var$a] = !0;
            const t = $754ef84e366f6443$var$j(s);
            (s.nodeType || t) && (s[$754ef84e366f6443$var$h] = !0, s[$754ef84e366f6443$var$l] = t, s[$754ef84e366f6443$var$c] = {});
        }
    }
    return e;
}
const $754ef84e366f6443$var$be = {
    deg: 1,
    rad: 180 / $754ef84e366f6443$var$mt,
    turn: 360
}, $754ef84e366f6443$var$Te = {}, $754ef84e366f6443$var$Se = (t, e, i, n = !1)=>{
    const o = e.u, a = e.n;
    if (e.t === $754ef84e366f6443$var$r.UNIT && o === i) return e;
    const h = a + o + i, l = $754ef84e366f6443$var$Te[h];
    if ($754ef84e366f6443$var$H(l) || n) {
        let r;
        if (o in $754ef84e366f6443$var$be) r = a * $754ef84e366f6443$var$be[o] / $754ef84e366f6443$var$be[i];
        else {
            const e = 100, n = t.cloneNode(), h = t.parentNode, l = h && h !== $754ef84e366f6443$var$s ? h : $754ef84e366f6443$var$s.body;
            l.appendChild(n);
            const c = n.style;
            c.width = e + o;
            const d = n.offsetWidth || e;
            c.width = e + i;
            const u = d / (n.offsetWidth || e);
            l.removeChild(n), r = u * a;
        }
        e.n = r, $754ef84e366f6443$var$Te[h] = r;
    } else e.n = l;
    return e.t, e.u = i, e;
}, $754ef84e366f6443$var$we = (t)=>t, $754ef84e366f6443$var$xe = (t = 1.68)=>(e)=>$754ef84e366f6443$var$it(e, +t), $754ef84e366f6443$var$Ce = {
    in: (t)=>(e)=>t(e),
    out: (t)=>(e)=>1 - t(1 - e),
    inOut: (t)=>(e)=>e < .5 ? t(2 * e) / 2 : 1 - t(-2 * e + 2) / 2,
    outIn: (t)=>(e)=>e < .5 ? (1 - t(1 - 2 * e)) / 2 : (t(2 * e - 1) + 1) / 2
}, $754ef84e366f6443$var$Ee = $754ef84e366f6443$var$mt / 2, $754ef84e366f6443$var$ke = 2 * $754ef84e366f6443$var$mt, $754ef84e366f6443$var$$e = {
    [$754ef84e366f6443$var$_]: $754ef84e366f6443$var$xe,
    Quad: $754ef84e366f6443$var$xe(2),
    Cubic: $754ef84e366f6443$var$xe(3),
    Quart: $754ef84e366f6443$var$xe(4),
    Quint: $754ef84e366f6443$var$xe(5),
    Sine: (t)=>1 - $754ef84e366f6443$var$ot(t * $754ef84e366f6443$var$Ee),
    Circ: (t)=>1 - $754ef84e366f6443$var$rt(1 - t * t),
    Expo: (t)=>t ? $754ef84e366f6443$var$it(2, 10 * t - 10) : 0,
    Bounce: (t)=>{
        let e, s = 4;
        for(; t < ((e = $754ef84e366f6443$var$it(2, --s)) - 1) / 11;);
        return 1 / $754ef84e366f6443$var$it(4, 3 - s) - 7.5625 * $754ef84e366f6443$var$it((3 * e - 2) / 22 - t, 2);
    },
    Back: (t = 1.7)=>(e)=>(+t + 1) * e * e * e - +t * e * e,
    Elastic: (t = 1, e = .3)=>{
        const s = $754ef84e366f6443$var$gt(+t, 1, 10), i = $754ef84e366f6443$var$gt(+e, $754ef84e366f6443$var$p, 2), r = i / $754ef84e366f6443$var$ke * $754ef84e366f6443$var$dt(1 / s), n = $754ef84e366f6443$var$ke / i;
        return (t)=>0 === t || 1 === t ? t : -s * $754ef84e366f6443$var$it(2, -10 * (1 - t)) * $754ef84e366f6443$var$nt((1 - t - r) * n);
    }
}, $754ef84e366f6443$export$4e31f8f121cad154 = (()=>{
    const t = {
        linear: $754ef84e366f6443$var$we,
        none: $754ef84e366f6443$var$we
    };
    for(let e in $754ef84e366f6443$var$Ce)for(let s in $754ef84e366f6443$var$$e){
        const i = $754ef84e366f6443$var$$e[s], r = $754ef84e366f6443$var$Ce[e];
        t[e + s] = s === $754ef84e366f6443$var$_ || "Back" === s || "Elastic" === s ? (t, e)=>r(i(t, e)) : r(i);
    }
    return t;
})(), $754ef84e366f6443$var$Oe = {
    linear: $754ef84e366f6443$var$we,
    none: $754ef84e366f6443$var$we
}, $754ef84e366f6443$var$Ne = (t)=>{
    if ($754ef84e366f6443$var$Oe[t]) return $754ef84e366f6443$var$Oe[t];
    if (t.indexOf("(") <= -1) {
        const e = $754ef84e366f6443$var$Ce[t] || t.includes("Back") || t.includes("Elastic") ? $754ef84e366f6443$export$4e31f8f121cad154[t]() : $754ef84e366f6443$export$4e31f8f121cad154[t];
        return e ? $754ef84e366f6443$var$Oe[t] = e : $754ef84e366f6443$var$we;
    }
    {
        const e = t.slice(0, -1).split("("), s = $754ef84e366f6443$export$4e31f8f121cad154[e[0]];
        return s ? $754ef84e366f6443$var$Oe[t] = s(...e[1].split(",")) : $754ef84e366f6443$var$we;
    }
}, $754ef84e366f6443$var$Re = [
    "steps(",
    "irregular(",
    "linear(",
    "cubicBezier("
], $754ef84e366f6443$var$De = (t)=>{
    if ($754ef84e366f6443$var$V(t)) {
        for(let e = 0, s = $754ef84e366f6443$var$Re.length; e < s; e++)if ($754ef84e366f6443$var$I(t, $754ef84e366f6443$var$Re[e])) return console.warn(`String syntax for \`ease: "${t}"\` has been removed from the core and replaced by importing and passing the easing function directly: \`ease: ${t}\``), $754ef84e366f6443$var$we;
    }
    return $754ef84e366f6443$var$W(t) ? t : $754ef84e366f6443$var$V(t) ? $754ef84e366f6443$var$Ne(t) : $754ef84e366f6443$var$we;
}, $754ef84e366f6443$var$Le = $754ef84e366f6443$var$zt(), $754ef84e366f6443$var$Ae = $754ef84e366f6443$var$zt(), $754ef84e366f6443$var$Fe = {}, $754ef84e366f6443$var$Me = {
    func: null
}, $754ef84e366f6443$var$Pe = [
    null
], $754ef84e366f6443$var$Ie = [
    null,
    null
], $754ef84e366f6443$var$ze = {
    to: null
};
let $754ef84e366f6443$var$Ue, $754ef84e366f6443$var$Xe, $754ef84e366f6443$var$Ye = 0;
const $754ef84e366f6443$var$Ve = (t, e)=>{
    const s = {};
    if ($754ef84e366f6443$var$U(t)) {
        const e = [].concat(...t.map((t)=>Object.keys(t))).filter($754ef84e366f6443$var$K);
        for(let i = 0, r = e.length; i < r; i++){
            const r = e[i], n = t.map((t)=>{
                const e = {};
                for(let s in t){
                    const i = t[s];
                    $754ef84e366f6443$var$K(s) ? s === r && (e.to = i) : e[s] = i;
                }
                return e;
            });
            s[r] = n;
        }
    } else {
        const i = $754ef84e366f6443$var$Lt(e.duration, $754ef84e366f6443$var$F.defaults.duration), r = Object.keys(t).map((e)=>({
                o: parseFloat(e) / 100,
                p: t[e]
            })).sort((t, e)=>t.o - e.o);
        r.forEach((t)=>{
            const e = t.o, r = t.p;
            for(let t in r)if ($754ef84e366f6443$var$K(t)) {
                let n = s[t];
                n || (n = s[t] = []);
                const o = e * i;
                let a = n.length, h = n[a - 1];
                const l = {
                    to: r[t]
                };
                let c = 0;
                for(let t = 0; t < a; t++)c += n[t].duration;
                1 === a && (l.from = h.to), r.ease && (l.ease = r.ease), l.duration = o - (a ? c : 0), n.push(l);
            }
            return t;
        });
        for(let t in s){
            const e = s[t];
            let i;
            for(let t = 0, s = e.length; t < s; t++){
                const s = e[t], r = s.ease;
                s.ease = i || void 0, i = r;
            }
            e[0].duration || e.shift();
        }
    }
    return s;
};
class $754ef84e366f6443$export$3394f837405475c7 extends $754ef84e366f6443$export$c57e9b2d8b9e4de {
    constructor(t, e, s, n, a = !1, h = 0, l = 0){
        super(e, s, n);
        const c = $754ef84e366f6443$export$3d8c2f653ac9d0b9(t), d = c.length, u = e.keyframes, m = u ? $754ef84e366f6443$var$xt($754ef84e366f6443$var$Ve(u, e), e) : e, { delay: g, duration: _, ease: y, playbackEase: v, modifier: b, composition: T, onRender: S } = m, w = s ? s.defaults : $754ef84e366f6443$var$F.defaults, x = $754ef84e366f6443$var$Lt(v, w.playbackEase), C = x ? $754ef84e366f6443$var$De(x) : null, E = !$754ef84e366f6443$var$H(y) && !$754ef84e366f6443$var$H(y.ease), k = E ? y.ease : $754ef84e366f6443$var$Lt(y, C ? "linear" : w.ease), $ = E ? y.settlingDuration : $754ef84e366f6443$var$Lt(_, w.duration), B = $754ef84e366f6443$var$Lt(g, w.delay), O = b || w.modifier, N = $754ef84e366f6443$var$H(T) && d >= $754ef84e366f6443$var$f ? $754ef84e366f6443$var$o.none : $754ef84e366f6443$var$H(T) ? w.composition : T, R = this._offset + (s ? s._offset : 0);
        E && (y.parent = this);
        let D = NaN, L = NaN, A = 0, M = 0;
        for(let t = 0; t < d; t++){
            const e = c[t], n = h || t, u = l || d;
            let f = NaN, g = NaN;
            for(let t in m)if ($754ef84e366f6443$var$K(t)) {
                const h = $754ef84e366f6443$var$Ft(e, t), l = $754ef84e366f6443$var$qt(t, e, h);
                let c = m[t];
                const d = $754ef84e366f6443$var$U(c);
                if (a && !d && ($754ef84e366f6443$var$Ie[0] = c, $754ef84e366f6443$var$Ie[1] = c, c = $754ef84e366f6443$var$Ie), d) {
                    const t = c.length, e = !$754ef84e366f6443$var$X(c[0]);
                    2 === t && e ? ($754ef84e366f6443$var$ze.to = c, $754ef84e366f6443$var$Pe[0] = $754ef84e366f6443$var$ze, $754ef84e366f6443$var$Ue = $754ef84e366f6443$var$Pe) : t > 2 && e ? ($754ef84e366f6443$var$Ue = [], c.forEach((t, e)=>{
                        e ? 1 === e ? ($754ef84e366f6443$var$Ie[1] = t, $754ef84e366f6443$var$Ue.push($754ef84e366f6443$var$Ie)) : $754ef84e366f6443$var$Ue.push(t) : $754ef84e366f6443$var$Ie[0] = t;
                    })) : $754ef84e366f6443$var$Ue = c;
                } else $754ef84e366f6443$var$Pe[0] = c, $754ef84e366f6443$var$Ue = $754ef84e366f6443$var$Pe;
                let _ = null, y = null, v = NaN, b = 0, T = 0;
                for(let t = $754ef84e366f6443$var$Ue.length; T < t; T++){
                    const i = $754ef84e366f6443$var$Ue[T];
                    $754ef84e366f6443$var$X(i) ? $754ef84e366f6443$var$Xe = i : ($754ef84e366f6443$var$ze.to = i, $754ef84e366f6443$var$Xe = $754ef84e366f6443$var$ze), $754ef84e366f6443$var$Me.func = null;
                    const a = $754ef84e366f6443$var$At($754ef84e366f6443$var$Xe.to, e, n, u, $754ef84e366f6443$var$Me);
                    let c;
                    $754ef84e366f6443$var$X(a) && !$754ef84e366f6443$var$H(a.to) ? ($754ef84e366f6443$var$Xe = a, c = a.to) : c = a;
                    const d = $754ef84e366f6443$var$At($754ef84e366f6443$var$Xe.from, e, n, u), m = $754ef84e366f6443$var$Xe.ease, f = !$754ef84e366f6443$var$H(m) && !$754ef84e366f6443$var$H(m.ease), g = f ? m.ease : m || k, S = f ? m.settlingDuration : $754ef84e366f6443$var$At($754ef84e366f6443$var$Lt($754ef84e366f6443$var$Xe.duration, t > 1 ? $754ef84e366f6443$var$At($, e, n, u) / t : $), e, n, u), w = $754ef84e366f6443$var$At($754ef84e366f6443$var$Lt($754ef84e366f6443$var$Xe.delay, T ? 0 : B), e, n, u), x = $754ef84e366f6443$var$At($754ef84e366f6443$var$Lt($754ef84e366f6443$var$Xe.composition, N), e, n, u), C = $754ef84e366f6443$var$Y(x) ? x : $754ef84e366f6443$var$o[x], E = $754ef84e366f6443$var$Xe.modifier || O, D = !$754ef84e366f6443$var$H(d), L = !$754ef84e366f6443$var$H(c), F = $754ef84e366f6443$var$U(c), P = F || D && L, I = y ? b + w : w, z = $754ef84e366f6443$var$yt(R + I, 12);
                    M || !D && !F || (M = 1);
                    let V = y;
                    if (C !== $754ef84e366f6443$var$o.none) {
                        _ || (_ = $754ef84e366f6443$var$ne(e, l));
                        let t = _._head;
                        for(; t && !t._isOverridden && t._absoluteStartTime <= z;)if (V = t, t = t._nextRep, t && t._absoluteStartTime >= z) for(; t;)$754ef84e366f6443$var$ae(t), t = t._nextRep;
                    }
                    if (P ? ($754ef84e366f6443$var$Ut(F ? $754ef84e366f6443$var$At(c[0], e, n, u) : d, $754ef84e366f6443$var$Le), $754ef84e366f6443$var$Ut(F ? $754ef84e366f6443$var$At(c[1], e, n, u, $754ef84e366f6443$var$Me) : c, $754ef84e366f6443$var$Ae), $754ef84e366f6443$var$Le.t === $754ef84e366f6443$var$r.NUMBER && (V ? V._valueType === $754ef84e366f6443$var$r.UNIT && ($754ef84e366f6443$var$Le.t = $754ef84e366f6443$var$r.UNIT, $754ef84e366f6443$var$Le.u = V._unit) : ($754ef84e366f6443$var$Ut($754ef84e366f6443$var$Pt(e, l, h, $754ef84e366f6443$var$Fe), $754ef84e366f6443$var$Yt), $754ef84e366f6443$var$Yt.t === $754ef84e366f6443$var$r.UNIT && ($754ef84e366f6443$var$Le.t = $754ef84e366f6443$var$r.UNIT, $754ef84e366f6443$var$Le.u = $754ef84e366f6443$var$Yt.u)))) : (L ? $754ef84e366f6443$var$Ut(c, $754ef84e366f6443$var$Ae) : y ? $754ef84e366f6443$var$Xt(y, $754ef84e366f6443$var$Ae) : $754ef84e366f6443$var$Ut(s && V && V.parent.parent === s ? V._value : $754ef84e366f6443$var$Pt(e, l, h, $754ef84e366f6443$var$Fe), $754ef84e366f6443$var$Ae), D ? $754ef84e366f6443$var$Ut(d, $754ef84e366f6443$var$Le) : y ? $754ef84e366f6443$var$Xt(y, $754ef84e366f6443$var$Le) : $754ef84e366f6443$var$Ut(s && V && V.parent.parent === s ? V._value : $754ef84e366f6443$var$Pt(e, l, h, $754ef84e366f6443$var$Fe), $754ef84e366f6443$var$Le)), $754ef84e366f6443$var$Le.o && ($754ef84e366f6443$var$Le.n = $754ef84e366f6443$var$It(V ? V._toNumber : $754ef84e366f6443$var$Ut($754ef84e366f6443$var$Pt(e, l, h, $754ef84e366f6443$var$Fe), $754ef84e366f6443$var$Yt).n, $754ef84e366f6443$var$Le.n, $754ef84e366f6443$var$Le.o)), $754ef84e366f6443$var$Ae.o && ($754ef84e366f6443$var$Ae.n = $754ef84e366f6443$var$It($754ef84e366f6443$var$Le.n, $754ef84e366f6443$var$Ae.n, $754ef84e366f6443$var$Ae.o)), $754ef84e366f6443$var$Le.t !== $754ef84e366f6443$var$Ae.t) {
                        if ($754ef84e366f6443$var$Le.t === $754ef84e366f6443$var$r.COMPLEX || $754ef84e366f6443$var$Ae.t === $754ef84e366f6443$var$r.COMPLEX) {
                            const t = $754ef84e366f6443$var$Le.t === $754ef84e366f6443$var$r.COMPLEX ? $754ef84e366f6443$var$Le : $754ef84e366f6443$var$Ae, e = $754ef84e366f6443$var$Le.t === $754ef84e366f6443$var$r.COMPLEX ? $754ef84e366f6443$var$Ae : $754ef84e366f6443$var$Le;
                            e.t = $754ef84e366f6443$var$r.COMPLEX, e.s = $754ef84e366f6443$var$wt(t.s), e.d = t.d.map(()=>e.n);
                        } else if ($754ef84e366f6443$var$Le.t === $754ef84e366f6443$var$r.UNIT || $754ef84e366f6443$var$Ae.t === $754ef84e366f6443$var$r.UNIT) {
                            const t = $754ef84e366f6443$var$Le.t === $754ef84e366f6443$var$r.UNIT ? $754ef84e366f6443$var$Le : $754ef84e366f6443$var$Ae, e = $754ef84e366f6443$var$Le.t === $754ef84e366f6443$var$r.UNIT ? $754ef84e366f6443$var$Ae : $754ef84e366f6443$var$Le;
                            e.t = $754ef84e366f6443$var$r.UNIT, e.u = t.u;
                        } else if ($754ef84e366f6443$var$Le.t === $754ef84e366f6443$var$r.COLOR || $754ef84e366f6443$var$Ae.t === $754ef84e366f6443$var$r.COLOR) {
                            const t = $754ef84e366f6443$var$Le.t === $754ef84e366f6443$var$r.COLOR ? $754ef84e366f6443$var$Le : $754ef84e366f6443$var$Ae, e = $754ef84e366f6443$var$Le.t === $754ef84e366f6443$var$r.COLOR ? $754ef84e366f6443$var$Ae : $754ef84e366f6443$var$Le;
                            e.t = $754ef84e366f6443$var$r.COLOR, e.s = t.s, e.d = [
                                0,
                                0,
                                0,
                                1
                            ];
                        }
                    }
                    if ($754ef84e366f6443$var$Le.u !== $754ef84e366f6443$var$Ae.u) {
                        let t = $754ef84e366f6443$var$Ae.u ? $754ef84e366f6443$var$Le : $754ef84e366f6443$var$Ae;
                        t = $754ef84e366f6443$var$Se(e, t, $754ef84e366f6443$var$Ae.u ? $754ef84e366f6443$var$Ae.u : $754ef84e366f6443$var$Le.u, !1);
                    }
                    if ($754ef84e366f6443$var$Ae.d && $754ef84e366f6443$var$Le.d && $754ef84e366f6443$var$Ae.d.length !== $754ef84e366f6443$var$Le.d.length) {
                        const t = $754ef84e366f6443$var$Le.d.length > $754ef84e366f6443$var$Ae.d.length ? $754ef84e366f6443$var$Le : $754ef84e366f6443$var$Ae, e = t === $754ef84e366f6443$var$Le ? $754ef84e366f6443$var$Ae : $754ef84e366f6443$var$Le;
                        e.d = t.d.map((t, s)=>$754ef84e366f6443$var$H(e.d[s]) ? 0 : e.d[s]), e.s = $754ef84e366f6443$var$wt(t.s);
                    }
                    const W = $754ef84e366f6443$var$yt(+S || $754ef84e366f6443$var$p, 12);
                    let j = $754ef84e366f6443$var$Fe[l];
                    $754ef84e366f6443$var$q(j) || ($754ef84e366f6443$var$Fe[l] = null);
                    const G = {
                        parent: this,
                        id: $754ef84e366f6443$var$Ye++,
                        property: l,
                        target: e,
                        _value: null,
                        _func: $754ef84e366f6443$var$Me.func,
                        _ease: $754ef84e366f6443$var$De(g),
                        _fromNumbers: $754ef84e366f6443$var$wt($754ef84e366f6443$var$Le.d),
                        _toNumbers: $754ef84e366f6443$var$wt($754ef84e366f6443$var$Ae.d),
                        _strings: $754ef84e366f6443$var$wt($754ef84e366f6443$var$Ae.s),
                        _fromNumber: $754ef84e366f6443$var$Le.n,
                        _toNumber: $754ef84e366f6443$var$Ae.n,
                        _numbers: $754ef84e366f6443$var$wt($754ef84e366f6443$var$Le.d),
                        _number: $754ef84e366f6443$var$Le.n,
                        _unit: $754ef84e366f6443$var$Ae.u,
                        _modifier: E,
                        _currentTime: 0,
                        _startTime: I,
                        _delay: +w,
                        _updateDuration: W,
                        _changeDuration: W,
                        _absoluteStartTime: z,
                        _tweenType: h,
                        _valueType: $754ef84e366f6443$var$Ae.t,
                        _composition: C,
                        _isOverlapped: 0,
                        _isOverridden: 0,
                        _renderTransforms: 0,
                        _inlineValue: j,
                        _prevRep: null,
                        _nextRep: null,
                        _prevAdd: null,
                        _nextAdd: null,
                        _prev: null,
                        _next: null
                    };
                    C !== $754ef84e366f6443$var$o.none && $754ef84e366f6443$var$he(G, _), isNaN(v) && (v = G._startTime), b = $754ef84e366f6443$var$yt(I + W, 12), y = G, A++, $754ef84e366f6443$var$kt(this, G);
                }
                (isNaN(L) || v < L) && (L = v), (isNaN(D) || b > D) && (D = b), h === $754ef84e366f6443$var$i.TRANSFORM && (f = A - T, g = A);
            }
            if (!isNaN(f)) {
                let t = 0;
                $754ef84e366f6443$var$Ct(this, (e)=>{
                    t >= f && t < g && (e._renderTransforms = 1, e._composition === $754ef84e366f6443$var$o.blend && $754ef84e366f6443$var$Ct($754ef84e366f6443$var$Qt.animation, (t)=>{
                        t.id === e.id && (t._renderTransforms = 1);
                    })), t++;
                });
            }
        }
        d || console.warn("No target found. Make sure the element you're trying to animate is accessible before creating your animation."), L ? ($754ef84e366f6443$var$Ct(this, (t)=>{
            t._startTime - t._delay || (t._delay -= L), t._startTime -= L;
        }), D -= L) : L = 0, D || (D = $754ef84e366f6443$var$p, this.iterationCount = 0), this.targets = c, this.duration = D === $754ef84e366f6443$var$p ? $754ef84e366f6443$var$p : $754ef84e366f6443$var$Tt((D + this._loopDelay) * this.iterationCount - this._loopDelay) || $754ef84e366f6443$var$p, this.onRender = S || w.onRender, this._ease = C, this._delay = L, this.iterationDuration = D, !this._autoplay && M && this.onRender(this);
    }
    stretch(t) {
        const e = this.duration;
        if (e === $754ef84e366f6443$var$St(t)) return this;
        const s = t / e;
        return $754ef84e366f6443$var$Ct(this, (t)=>{
            t._updateDuration = $754ef84e366f6443$var$St(t._updateDuration * s), t._changeDuration = $754ef84e366f6443$var$St(t._changeDuration * s), t._currentTime *= s, t._startTime *= s, t._absoluteStartTime *= s;
        }), super.stretch(t);
    }
    refresh() {
        return $754ef84e366f6443$var$Ct(this, (t)=>{
            const e = t._func;
            if (e) {
                const s = $754ef84e366f6443$var$Pt(t.target, t.property, t._tweenType);
                $754ef84e366f6443$var$Ut(s, $754ef84e366f6443$var$Yt), $754ef84e366f6443$var$Ut(e(), $754ef84e366f6443$var$Ae), t._fromNumbers = $754ef84e366f6443$var$wt($754ef84e366f6443$var$Yt.d), t._fromNumber = $754ef84e366f6443$var$Yt.n, t._toNumbers = $754ef84e366f6443$var$wt($754ef84e366f6443$var$Ae.d), t._strings = $754ef84e366f6443$var$wt($754ef84e366f6443$var$Ae.s), t._toNumber = $754ef84e366f6443$var$Ae.o ? $754ef84e366f6443$var$It($754ef84e366f6443$var$Yt.n, $754ef84e366f6443$var$Ae.n, $754ef84e366f6443$var$Ae.o) : $754ef84e366f6443$var$Ae.n;
            }
        }), this.duration === $754ef84e366f6443$var$p && this.restart(), this;
    }
    revert() {
        return super.revert(), $754ef84e366f6443$export$a631c64f18a23a10(this);
    }
    then(t) {
        return super.then(t);
    }
}
const $754ef84e366f6443$export$e3607ec2d7a891c4 = (t, e)=>new $754ef84e366f6443$export$3394f837405475c7(t, e, null, 0, !1).init(), $754ef84e366f6443$var$qe = {
    _head: null,
    _tail: null
}, $754ef84e366f6443$var$je = (t, e, s)=>{
    let i, r = $754ef84e366f6443$var$qe._head;
    for(; r;){
        const n = r._next, o = r.$el === t, a = !e || r.property === e, h = !s || r.parent === s;
        if (o && a && h) {
            i = r.animation;
            try {
                i.commitStyles();
            } catch  {}
            i.cancel(), $754ef84e366f6443$var$Et($754ef84e366f6443$var$qe, r);
            const t = r.parent;
            t && (t._completed++, t.animations.length === t._completed && (t.completed = !0, t.paused = !0, t.muteCallbacks || (t.onComplete(t), t._resolve(t))));
        }
        r = n;
    }
    return i;
}, $754ef84e366f6443$var$Ge = (t, e, s, i, r)=>{
    const n = e.animate(i, r), o = r.delay + +r.duration * r.iterations;
    n.playbackRate = t._speed, t.paused && n.pause(), t.duration < o && (t.duration = o, t.controlAnimation = n), t.animations.push(n), $754ef84e366f6443$var$je(e, s), $754ef84e366f6443$var$kt($754ef84e366f6443$var$qe, {
        parent: t,
        animation: n,
        $el: e,
        property: s,
        _next: null,
        _prev: null
    });
    const a = ()=>{
        $754ef84e366f6443$var$je(e, s, t);
    };
    return n.oncancel = a, n.onremove = a, t.persist || (n.onfinish = a), n;
};
function $754ef84e366f6443$export$3988ae62b71be9a3(t, e, s) {
    const i = $754ef84e366f6443$export$3d8c2f653ac9d0b9(t);
    if (!i.length) return;
    const [n] = i, o = $754ef84e366f6443$var$Ft(n, e), a = $754ef84e366f6443$var$qt(e, n, o);
    let h = $754ef84e366f6443$var$Pt(n, a);
    if ($754ef84e366f6443$var$H(s)) return h;
    if ($754ef84e366f6443$var$Ut(h, $754ef84e366f6443$var$Yt), $754ef84e366f6443$var$Yt.t === $754ef84e366f6443$var$r.NUMBER || $754ef84e366f6443$var$Yt.t === $754ef84e366f6443$var$r.UNIT) {
        if (!1 === s) return $754ef84e366f6443$var$Yt.n;
        {
            const t = $754ef84e366f6443$var$Se(n, $754ef84e366f6443$var$Yt, s, !1);
            return `${$754ef84e366f6443$var$yt(t.n, $754ef84e366f6443$var$F.precision)}${t.u}`;
        }
    }
}
const $754ef84e366f6443$export$adaa4cf7ef1b65be = (t, e)=>{
    if (!$754ef84e366f6443$var$H(e)) return e.duration = $754ef84e366f6443$var$p, e.composition = $754ef84e366f6443$var$Lt(e.composition, $754ef84e366f6443$var$o.none), new $754ef84e366f6443$export$3394f837405475c7(t, e, null, 0, !0).resume();
}, $754ef84e366f6443$export$cd7f480d6b8286c3 = (t, e, s)=>{
    const i = $754ef84e366f6443$var$ye(t);
    for(let t = 0, r = i.length; t < r; t++)$754ef84e366f6443$var$je(i[t], s, e && e.controlAnimation && e);
    return $754ef84e366f6443$var$de(i, e, s), i;
}, $754ef84e366f6443$var$Ke = (t, e)=>{
    if ($754ef84e366f6443$var$I(e, "<")) {
        const s = "<" === e[1], i = t._tail, r = i ? i._offset + i._delay : 0;
        return s ? r : r + i.duration;
    }
}, $754ef84e366f6443$var$ts = (t, e)=>{
    let s = t.iterationDuration;
    if (s === $754ef84e366f6443$var$p && (s = 0), $754ef84e366f6443$var$H(e)) return s;
    if ($754ef84e366f6443$var$Y(+e)) return +e;
    const i = e, r = t ? t.labels : null, n = !$754ef84e366f6443$var$q(r), o = $754ef84e366f6443$var$Ke(t, i), a = !$754ef84e366f6443$var$H(o), h = $754ef84e366f6443$var$R.exec(i);
    if (h) {
        const t = h[0], e = i.split(t), l = n && e[0] ? r[e[0]] : s, c = a ? o : n ? l : s, d = +e[1];
        return $754ef84e366f6443$var$It(c, d, t[0]);
    }
    return a ? o : n ? $754ef84e366f6443$var$H(r[i]) ? s : r[i] : s;
};
function $754ef84e366f6443$var$es(t) {
    return $754ef84e366f6443$var$Tt((t.iterationDuration + t._loopDelay) * t.iterationCount - t._loopDelay) || $754ef84e366f6443$var$p;
}
function $754ef84e366f6443$var$ss(t, e, s, i, r, o) {
    const a = $754ef84e366f6443$var$Y(t.duration) && t.duration <= $754ef84e366f6443$var$p ? s - $754ef84e366f6443$var$p : s;
    $754ef84e366f6443$var$Wt(e, a, 1, 1, $754ef84e366f6443$var$n.AUTO);
    const h = i ? new $754ef84e366f6443$export$3394f837405475c7(i, t, e, a, !1, r, o) : new $754ef84e366f6443$export$c57e9b2d8b9e4de(t, e, a);
    return h.init(!0), $754ef84e366f6443$var$kt(e, h), $754ef84e366f6443$var$Ct(e, (t)=>{
        const s = t._offset + t._delay + t.duration;
        s > e.iterationDuration && (e.iterationDuration = s);
    }), e.duration = $754ef84e366f6443$var$es(e), e;
}
class $754ef84e366f6443$export$e6a97ba2cae5bb94 extends $754ef84e366f6443$export$c57e9b2d8b9e4de {
    constructor(t = {}){
        super(t, null, 0), this.duration = 0, this.labels = {};
        const e = t.defaults, s = $754ef84e366f6443$var$F.defaults;
        this.defaults = e ? $754ef84e366f6443$var$xt(e, s) : s, this.onRender = t.onRender || s.onRender;
        const i = $754ef84e366f6443$var$Lt(t.playbackEase, s.playbackEase);
        this._ease = i ? $754ef84e366f6443$var$De(i) : null, this.iterationDuration = 0;
    }
    add(t, e, s) {
        const i = $754ef84e366f6443$var$X(e), r = $754ef84e366f6443$var$X(t);
        if (i || r) {
            if (this._hasChildren = !0, i) {
                const i = e;
                if ($754ef84e366f6443$var$W(s)) {
                    const e = s, r = $754ef84e366f6443$var$ye(t), n = this.duration, o = this.iterationDuration, a = i.id;
                    let h = 0;
                    const l = r.length;
                    r.forEach((t)=>{
                        const s = {
                            ...i
                        };
                        this.duration = n, this.iterationDuration = o, $754ef84e366f6443$var$H(a) || (s.id = a + "-" + h), $754ef84e366f6443$var$ss(s, this, $754ef84e366f6443$var$ts(this, e(t, h, l, this)), t, h, l), h++;
                    });
                } else $754ef84e366f6443$var$ss(i, this, $754ef84e366f6443$var$ts(this, s), t);
            } else $754ef84e366f6443$var$ss(t, this, $754ef84e366f6443$var$ts(this, e));
            return this.init(!0);
        }
    }
    sync(t, e) {
        if ($754ef84e366f6443$var$H(t) || t && $754ef84e366f6443$var$H(t.pause)) return this;
        t.pause();
        const s = +(t.effect ? t.effect.getTiming().duration : t.duration);
        return this.add(t, {
            currentTime: [
                0,
                s
            ],
            duration: s,
            ease: "linear"
        }, e);
    }
    set(t, e, s) {
        return $754ef84e366f6443$var$H(e) ? this : (e.duration = $754ef84e366f6443$var$p, e.composition = $754ef84e366f6443$var$o.replace, this.add(t, e, s));
    }
    call(t, e) {
        return $754ef84e366f6443$var$H(t) || t && !$754ef84e366f6443$var$W(t) ? this : this.add({
            duration: 0,
            onComplete: ()=>t(this)
        }, e);
    }
    label(t, e) {
        return $754ef84e366f6443$var$H(t) || t && !$754ef84e366f6443$var$V(t) || (this.labels[t] = $754ef84e366f6443$var$ts(this, e)), this;
    }
    remove(t, e) {
        return $754ef84e366f6443$var$de($754ef84e366f6443$var$ye(t), this, e), this;
    }
    stretch(t) {
        const e = this.duration;
        if (e === $754ef84e366f6443$var$St(t)) return this;
        const s = t / e, i = this.labels;
        $754ef84e366f6443$var$Ct(this, (t)=>t.stretch(t.duration * s));
        for(let t in i)i[t] *= s;
        return super.stretch(t);
    }
    refresh() {
        return $754ef84e366f6443$var$Ct(this, (t)=>{
            t.refresh && t.refresh();
        }), this;
    }
    revert() {
        return super.revert(), $754ef84e366f6443$var$Ct(this, (t)=>t.revert, !0), $754ef84e366f6443$export$a631c64f18a23a10(this);
    }
    then(t) {
        return super.then(t);
    }
}
const $754ef84e366f6443$export$69aa7a9850b8f065 = (t)=>new $754ef84e366f6443$export$e6a97ba2cae5bb94(t).init();
class $754ef84e366f6443$export$8d0d04e6da868f4 {
    constructor(t, e){
        $754ef84e366f6443$var$A.current && $754ef84e366f6443$var$A.current.register(this);
        const s = ()=>{
            if (this.callbacks.completed) return;
            let t = !0;
            for(let e in this.animations)if (!this.animations[e].paused && t) {
                t = !1;
                break;
            }
            t && this.callbacks.complete();
        }, i = {
            onBegin: ()=>{
                this.callbacks.completed && this.callbacks.reset(), this.callbacks.play();
            },
            onComplete: s,
            onPause: s
        }, r = {
            v: 1,
            autoplay: !1
        }, n = {};
        if (this.targets = [], this.animations = {}, this.callbacks = null, !$754ef84e366f6443$var$H(t) && !$754ef84e366f6443$var$H(e)) {
            for(let t in e){
                const s = e[t];
                $754ef84e366f6443$var$K(t) ? n[t] = s : $754ef84e366f6443$var$I(t, "on") ? r[t] = s : i[t] = s;
            }
            this.callbacks = new $754ef84e366f6443$export$3394f837405475c7({
                v: 0
            }, r);
            for(let e in n){
                const s = n[e], r = $754ef84e366f6443$var$X(s);
                let a = {}, h = "+=0";
                if (r) {
                    const t = s.unit;
                    $754ef84e366f6443$var$V(t) && (h += t);
                } else a.duration = s;
                a[e] = r ? $754ef84e366f6443$var$xt({
                    to: h
                }, s) : h;
                const l = $754ef84e366f6443$var$xt(i, a);
                l.composition = $754ef84e366f6443$var$o.replace, l.autoplay = !1;
                const c = this.animations[e] = new $754ef84e366f6443$export$3394f837405475c7(t, l, null, 0, !1).init();
                this.targets.length || this.targets.push(...c.targets), this[e] = (t, e, s)=>{
                    const i = c._head;
                    if ($754ef84e366f6443$var$H(t) && i) {
                        const t = i._numbers;
                        return t && t.length ? t : i._modifier(i._number);
                    }
                    return $754ef84e366f6443$var$Ct(c, (e)=>{
                        if ($754ef84e366f6443$var$U(t)) for(let s = 0, i = t.length; s < i; s++)$754ef84e366f6443$var$H(e._numbers[s]) || (e._fromNumbers[s] = e._modifier(e._numbers[s]), e._toNumbers[s] = t[s]);
                        else e._fromNumber = e._modifier(e._number), e._toNumber = t;
                        $754ef84e366f6443$var$H(s) || (e._ease = $754ef84e366f6443$var$De(s)), e._currentTime = 0;
                    }), $754ef84e366f6443$var$H(e) || c.stretch(e), c.reset(!0).resume(), this;
                };
            }
        }
    }
    revert() {
        for(let t in this.animations)this[t] = $754ef84e366f6443$var$S, this.animations[t].revert();
        return this.animations = {}, this.targets.length = 0, this.callbacks && this.callbacks.revert(), this;
    }
}
const $754ef84e366f6443$export$aab66fdce933d6f8 = (t, e)=>new $754ef84e366f6443$export$8d0d04e6da868f4(t, e), $754ef84e366f6443$var$as = (t, e)=>(+t).toFixed(e), $754ef84e366f6443$var$hs = (t, e, s)=>`${t}`.padStart(e, s), $754ef84e366f6443$var$ls = (t, e, s)=>`${t}`.padEnd(e, s), $754ef84e366f6443$var$cs = (t, e, s)=>((t - e) % (s - e) + (s - e)) % (s - e) + e, $754ef84e366f6443$var$ds = (t, e, s, i, r)=>i + (t - e) / (s - e) * (r - i), $754ef84e366f6443$var$us = (t)=>t * Math.PI / 180, $754ef84e366f6443$var$ps = (t)=>180 * t / Math.PI, $754ef84e366f6443$var$ms = (t, e, s, i)=>i ? 1 === i ? e : $754ef84e366f6443$var$bt(t, e, 1 - Math.exp(-i * s * .1)) : t;
var $754ef84e366f6443$var$fs = Object.freeze({
    __proto__: null,
    clamp: $754ef84e366f6443$var$gt,
    damp: $754ef84e366f6443$var$ms,
    degToRad: $754ef84e366f6443$var$us,
    lerp: $754ef84e366f6443$var$bt,
    mapRange: $754ef84e366f6443$var$ds,
    padEnd: $754ef84e366f6443$var$ls,
    padStart: $754ef84e366f6443$var$hs,
    radToDeg: $754ef84e366f6443$var$ps,
    round: $754ef84e366f6443$var$yt,
    roundPad: $754ef84e366f6443$var$as,
    snap: $754ef84e366f6443$var$vt,
    wrap: $754ef84e366f6443$var$cs
});
const $754ef84e366f6443$var$gs = 10 * $754ef84e366f6443$var$f;
class $754ef84e366f6443$export$a500e5b516cedfc {
    constructor(t = {}){
        const e = !$754ef84e366f6443$var$H(t.bounce) || !$754ef84e366f6443$var$H(t.duration);
        this.timeStep = .02, this.restThreshold = 5e-4, this.restDuration = 200, this.maxDuration = 6e4, this.maxRestSteps = this.restDuration / this.timeStep / $754ef84e366f6443$var$f, this.maxIterations = this.maxDuration / this.timeStep / $754ef84e366f6443$var$f, this.bn = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t.bounce, .5), -1, 1), this.pd = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t.duration, 628), 10 * $754ef84e366f6443$var$F.timeScale, $754ef84e366f6443$var$gs * $754ef84e366f6443$var$F.timeScale), this.m = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t.mass, 1), 1, $754ef84e366f6443$var$gs), this.s = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t.stiffness, 100), $754ef84e366f6443$var$p, $754ef84e366f6443$var$gs), this.d = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t.damping, 10), $754ef84e366f6443$var$p, $754ef84e366f6443$var$gs), this.v = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t.velocity, 0), -10000, $754ef84e366f6443$var$gs), this.w0 = 0, this.zeta = 0, this.wd = 0, this.b = 0, this.completed = !1, this.solverDuration = 0, this.settlingDuration = 0, this.parent = null, this.onComplete = t.onComplete || $754ef84e366f6443$var$S, e && this.calculateSDFromBD(), this.compute(), this.ease = (t)=>{
            const e = t * this.settlingDuration, s = this.completed, i = this.pd;
            return e >= i && !s && (this.completed = !0, this.onComplete(this.parent)), e < i && s && (this.completed = !1), 0 === t || 1 === t ? t : this.solve(t * this.solverDuration);
        };
    }
    solve(t) {
        const { zeta: e, w0: s, wd: i, b: r } = this;
        let n = t;
        return n = e < 1 ? $754ef84e366f6443$var$ht(-n * e * s) * (1 * $754ef84e366f6443$var$ot(i * n) + r * $754ef84e366f6443$var$nt(i * n)) : 1 === e ? (1 + r * n) * $754ef84e366f6443$var$ht(-n * s) : ((1 + r) * $754ef84e366f6443$var$ht((-e * s + i) * n) + (1 - r) * $754ef84e366f6443$var$ht((-e * s - i) * n)) / 2, 1 - n;
    }
    calculateSDFromBD() {
        const t = 1 === $754ef84e366f6443$var$F.timeScale ? this.pd / $754ef84e366f6443$var$f : this.pd;
        this.m = 1, this.v = 0, this.s = $754ef84e366f6443$var$it(2 * $754ef84e366f6443$var$mt / t, 2), this.bn >= 0 ? this.d = 4 * (1 - this.bn) * $754ef84e366f6443$var$mt / t : this.d = 4 * $754ef84e366f6443$var$mt / (t * (1 + this.bn)), this.s = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(this.s, $754ef84e366f6443$var$p, $754ef84e366f6443$var$gs), 3), this.d = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(this.d, $754ef84e366f6443$var$p, 300), 3);
    }
    calculateBDFromSD() {
        const t = 2 * $754ef84e366f6443$var$mt / $754ef84e366f6443$var$rt(this.s);
        this.pd = t * (1 === $754ef84e366f6443$var$F.timeScale ? $754ef84e366f6443$var$f : 1);
        const e = this.d / (2 * $754ef84e366f6443$var$rt(this.s));
        this.bn = e <= 1 ? 1 - this.d * t / (4 * $754ef84e366f6443$var$mt) : 4 * $754ef84e366f6443$var$mt / (this.d * t) - 1, this.bn = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(this.bn, -1, 1), 3), this.pd = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(this.pd, 10 * $754ef84e366f6443$var$F.timeScale, $754ef84e366f6443$var$gs * $754ef84e366f6443$var$F.timeScale), 3);
    }
    compute() {
        const { maxRestSteps: t, maxIterations: e, restThreshold: s, timeStep: i, m: r, d: n, s: o, v: a } = this, h = this.w0 = $754ef84e366f6443$var$gt($754ef84e366f6443$var$rt(o / r), $754ef84e366f6443$var$p, $754ef84e366f6443$var$f), l = this.zeta = n / (2 * $754ef84e366f6443$var$rt(o * r));
        l < 1 ? (this.wd = h * $754ef84e366f6443$var$rt(1 - l * l), this.b = (l * h - a) / this.wd) : 1 === l ? (this.wd = 0, this.b = -a + h) : (this.wd = h * $754ef84e366f6443$var$rt(l * l - 1), this.b = (l * h - a) / this.wd);
        let c = 0, d = 0, u = 0;
        for(; d <= t && u <= e;)$754ef84e366f6443$var$at(1 - this.solve(c)) < s ? d++ : d = 0, this.solverDuration = c, c += i, u++;
        this.settlingDuration = $754ef84e366f6443$var$yt(this.solverDuration * $754ef84e366f6443$var$f, 0) * $754ef84e366f6443$var$F.timeScale;
    }
    get bounce() {
        return this.bn;
    }
    set bounce(t) {
        this.bn = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t, 1), -1, 1), this.calculateSDFromBD(), this.compute();
    }
    get duration() {
        return this.pd;
    }
    set duration(t) {
        this.pd = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t, 1), 10 * $754ef84e366f6443$var$F.timeScale, $754ef84e366f6443$var$gs * $754ef84e366f6443$var$F.timeScale), this.calculateSDFromBD(), this.compute();
    }
    get stiffness() {
        return this.s;
    }
    set stiffness(t) {
        this.s = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t, 100), $754ef84e366f6443$var$p, $754ef84e366f6443$var$gs), this.calculateBDFromSD(), this.compute();
    }
    get damping() {
        return this.d;
    }
    set damping(t) {
        this.d = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t, 10), $754ef84e366f6443$var$p, $754ef84e366f6443$var$gs), this.calculateBDFromSD(), this.compute();
    }
    get mass() {
        return this.m;
    }
    set mass(t) {
        this.m = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t, 1), 1, $754ef84e366f6443$var$gs), this.compute();
    }
    get velocity() {
        return this.v;
    }
    set velocity(t) {
        this.v = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt(t, 0), -10000, $754ef84e366f6443$var$gs), this.compute();
    }
}
const $754ef84e366f6443$export$b36281d89752ae66 = (t)=>new $754ef84e366f6443$export$a500e5b516cedfc(t), $754ef84e366f6443$export$d1f8fcb84651afa9 = (t)=>(console.warn("createSpring() is deprecated use spring() instead"), new $754ef84e366f6443$export$a500e5b516cedfc(t)), $754ef84e366f6443$var$bs = (t)=>{
    t.cancelable && t.preventDefault();
};
class $754ef84e366f6443$var$Ts {
    constructor(t){
        this.el = t, this.zIndex = 0, this.parentElement = null, this.classList = {
            add: $754ef84e366f6443$var$S,
            remove: $754ef84e366f6443$var$S
        };
    }
    get x() {
        return this.el.x || 0;
    }
    set x(t) {
        this.el.x = t;
    }
    get y() {
        return this.el.y || 0;
    }
    set y(t) {
        this.el.y = t;
    }
    get width() {
        return this.el.width || 0;
    }
    set width(t) {
        this.el.width = t;
    }
    get height() {
        return this.el.height || 0;
    }
    set height(t) {
        this.el.height = t;
    }
    getBoundingClientRect() {
        return {
            top: this.y,
            right: this.x,
            bottom: this.y + this.height,
            left: this.x + this.width
        };
    }
}
class $754ef84e366f6443$var$Ss {
    constructor(t){
        this.$el = t, this.inlineTransforms = [], this.point = new DOMPoint, this.inversedMatrix = this.getMatrix().inverse();
    }
    normalizePoint(t, e) {
        return this.point.x = t, this.point.y = e, this.point.matrixTransform(this.inversedMatrix);
    }
    traverseUp(t) {
        let e = this.$el.parentElement, i = 0;
        for(; e && e !== $754ef84e366f6443$var$s;)t(e, i), e = e.parentElement, i++;
    }
    getMatrix() {
        const t = new DOMMatrix;
        return this.traverseUp((e)=>{
            const s = getComputedStyle(e).transform;
            if (s) {
                const e = new DOMMatrix(s);
                t.preMultiplySelf(e);
            }
        }), t;
    }
    remove() {
        this.traverseUp((t, e)=>{
            this.inlineTransforms[e] = t.style.transform, t.style.transform = "none";
        });
    }
    revert() {
        this.traverseUp((t, e)=>{
            const s = this.inlineTransforms[e];
            "" === s ? t.style.removeProperty("transform") : t.style.transform = s;
        });
    }
}
const $754ef84e366f6443$var$ws = (t, e)=>t && $754ef84e366f6443$var$W(t) ? t(e) : t;
let $754ef84e366f6443$var$xs = 0;
class $754ef84e366f6443$export$f2a139e5d18b9882 {
    constructor(t, i = {}){
        if (!t) return;
        $754ef84e366f6443$var$A.current && $754ef84e366f6443$var$A.current.register(this);
        const r = i.x, n = i.y, o = i.trigger, a = i.modifier, h = i.releaseEase, l = h && $754ef84e366f6443$var$De(h), c = !$754ef84e366f6443$var$H(h) && !$754ef84e366f6443$var$H(h.ease), d = $754ef84e366f6443$var$X(r) && !$754ef84e366f6443$var$H(r.mapTo) ? r.mapTo : "translateX", u = $754ef84e366f6443$var$X(n) && !$754ef84e366f6443$var$H(n.mapTo) ? n.mapTo : "translateY", p = $754ef84e366f6443$var$ws(i.container, this);
        this.containerArray = $754ef84e366f6443$var$U(p) ? p : null, this.$container = p && !this.containerArray ? $754ef84e366f6443$var$ye(p)[0] : $754ef84e366f6443$var$s.body, this.useWin = this.$container === $754ef84e366f6443$var$s.body, this.$scrollContainer = this.useWin ? $754ef84e366f6443$var$e : this.$container, this.$target = $754ef84e366f6443$var$X(t) ? new $754ef84e366f6443$var$Ts(t) : $754ef84e366f6443$var$ye(t)[0], this.$trigger = $754ef84e366f6443$var$ye(o || t)[0], this.fixed = "fixed" === $754ef84e366f6443$export$3988ae62b71be9a3(this.$target, "position"), this.isFinePointer = !0, this.containerPadding = [
            0,
            0,
            0,
            0
        ], this.containerFriction = 0, this.releaseContainerFriction = 0, this.snapX = 0, this.snapY = 0, this.scrollSpeed = 0, this.scrollThreshold = 0, this.dragSpeed = 0, this.dragThreshold = 3, this.maxVelocity = 0, this.minVelocity = 0, this.velocityMultiplier = 0, this.cursor = !1, this.releaseXSpring = c ? h : $754ef84e366f6443$export$b36281d89752ae66({
            mass: $754ef84e366f6443$var$Lt(i.releaseMass, 1),
            stiffness: $754ef84e366f6443$var$Lt(i.releaseStiffness, 80),
            damping: $754ef84e366f6443$var$Lt(i.releaseDamping, 20)
        }), this.releaseYSpring = c ? h : $754ef84e366f6443$export$b36281d89752ae66({
            mass: $754ef84e366f6443$var$Lt(i.releaseMass, 1),
            stiffness: $754ef84e366f6443$var$Lt(i.releaseStiffness, 80),
            damping: $754ef84e366f6443$var$Lt(i.releaseDamping, 20)
        }), this.releaseEase = l || $754ef84e366f6443$export$4e31f8f121cad154.outQuint, this.hasReleaseSpring = c, this.onGrab = i.onGrab || $754ef84e366f6443$var$S, this.onDrag = i.onDrag || $754ef84e366f6443$var$S, this.onRelease = i.onRelease || $754ef84e366f6443$var$S, this.onUpdate = i.onUpdate || $754ef84e366f6443$var$S, this.onSettle = i.onSettle || $754ef84e366f6443$var$S, this.onSnap = i.onSnap || $754ef84e366f6443$var$S, this.onResize = i.onResize || $754ef84e366f6443$var$S, this.onAfterResize = i.onAfterResize || $754ef84e366f6443$var$S, this.disabled = [
            0,
            0
        ];
        const f = {};
        if (a && (f.modifier = a), $754ef84e366f6443$var$H(r) || !0 === r) f[d] = 0;
        else if ($754ef84e366f6443$var$X(r)) {
            const t = r, e = {};
            t.modifier && (e.modifier = t.modifier), t.composition && (e.composition = t.composition), f[d] = e;
        } else !1 === r && (f[d] = 0, this.disabled[0] = 1);
        if ($754ef84e366f6443$var$H(n) || !0 === n) f[u] = 0;
        else if ($754ef84e366f6443$var$X(n)) {
            const t = n, e = {};
            t.modifier && (e.modifier = t.modifier), t.composition && (e.composition = t.composition), f[u] = e;
        } else !1 === n && (f[u] = 0, this.disabled[1] = 1);
        this.animate = new $754ef84e366f6443$export$8d0d04e6da868f4(this.$target, f), this.xProp = d, this.yProp = u, this.destX = 0, this.destY = 0, this.deltaX = 0, this.deltaY = 0, this.scroll = {
            x: 0,
            y: 0
        }, this.coords = [
            this.x,
            this.y,
            0,
            0
        ], this.snapped = [
            0,
            0
        ], this.pointer = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], this.scrollView = [
            0,
            0
        ], this.dragArea = [
            0,
            0,
            0,
            0
        ], this.containerBounds = [
            -$754ef84e366f6443$var$m,
            $754ef84e366f6443$var$m,
            $754ef84e366f6443$var$m,
            -$754ef84e366f6443$var$m
        ], this.scrollBounds = [
            0,
            0,
            0,
            0
        ], this.targetBounds = [
            0,
            0,
            0,
            0
        ], this.window = [
            0,
            0
        ], this.velocityStack = [
            0,
            0,
            0
        ], this.velocityStackIndex = 0, this.velocityTime = $754ef84e366f6443$var$z(), this.velocity = 0, this.angle = 0, this.cursorStyles = null, this.triggerStyles = null, this.bodyStyles = null, this.targetStyles = null, this.touchActionStyles = null, this.transforms = new $754ef84e366f6443$var$Ss(this.$target), this.overshootCoords = {
            x: 0,
            y: 0
        }, this.overshootTicker = new $754ef84e366f6443$export$c57e9b2d8b9e4de({
            autoplay: !1,
            onUpdate: ()=>{
                this.updated = !0, this.manual = !0, this.disabled[0] || this.animate[this.xProp](this.overshootCoords.x, 1), this.disabled[1] || this.animate[this.yProp](this.overshootCoords.y, 1);
            },
            onComplete: ()=>{
                this.manual = !1, this.disabled[0] || this.animate[this.xProp](this.overshootCoords.x, 0), this.disabled[1] || this.animate[this.yProp](this.overshootCoords.y, 0);
            }
        }, null, 0).init(), this.updateTicker = new $754ef84e366f6443$export$c57e9b2d8b9e4de({
            autoplay: !1,
            onUpdate: ()=>this.update()
        }, null, 0).init(), this.contained = !$754ef84e366f6443$var$H(p), this.manual = !1, this.grabbed = !1, this.dragged = !1, this.updated = !1, this.released = !1, this.canScroll = !1, this.enabled = !1, this.initialized = !1, this.activeProp = this.disabled[1] ? d : u, this.animate.callbacks.onRender = ()=>{
            const t = this.updated, e = !(this.grabbed && t) && this.released, s = this.x, i = this.y, r = s - this.coords[2], n = i - this.coords[3];
            this.deltaX = r, this.deltaY = n, this.coords[2] = s, this.coords[3] = i, t && (r || n) && this.onUpdate(this), e ? (this.computeVelocity(r, n), this.angle = $754ef84e366f6443$var$pt(n, r)) : this.updated = !1;
        }, this.animate.callbacks.onComplete = ()=>{
            !this.grabbed && this.released && (this.released = !1), this.manual || (this.deltaX = 0, this.deltaY = 0, this.velocity = 0, this.velocityStack[0] = 0, this.velocityStack[1] = 0, this.velocityStack[2] = 0, this.velocityStackIndex = 0, this.onSettle(this));
        }, this.resizeTicker = new $754ef84e366f6443$export$c57e9b2d8b9e4de({
            autoplay: !1,
            duration: 150 * $754ef84e366f6443$var$F.timeScale,
            onComplete: ()=>{
                this.onResize(this), this.refresh(), this.onAfterResize(this);
            }
        }).init(), this.parameters = i, this.resizeObserver = new ResizeObserver(()=>{
            this.initialized ? this.resizeTicker.restart() : this.initialized = !0;
        }), this.enable(), this.refresh(), this.resizeObserver.observe(this.$container), $754ef84e366f6443$var$X(t) || this.resizeObserver.observe(this.$target);
    }
    computeVelocity(t, e) {
        const s = this.velocityTime, i = $754ef84e366f6443$var$z(), r = i - s;
        if (r < 17) return this.velocity;
        this.velocityTime = i;
        const n = this.velocityStack, o = this.velocityMultiplier, a = this.minVelocity, h = this.maxVelocity, l = this.velocityStackIndex;
        n[l] = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt($754ef84e366f6443$var$rt(t * t + e * e) / r * o, a, h), 5);
        const c = $754ef84e366f6443$var$ut(n[0], n[1], n[2]);
        return this.velocity = c, this.velocityStackIndex = (l + 1) % 3, c;
    }
    setX(t, e = !1) {
        if (this.disabled[0]) return;
        const s = $754ef84e366f6443$var$yt(t, 5);
        return this.overshootTicker.pause(), this.manual = !0, this.updated = !e, this.destX = s, this.snapped[0] = $754ef84e366f6443$var$vt(s, this.snapX), this.animate[this.xProp](s, 0), this.manual = !1, this;
    }
    setY(t, e = !1) {
        if (this.disabled[1]) return;
        const s = $754ef84e366f6443$var$yt(t, 5);
        return this.overshootTicker.pause(), this.manual = !0, this.updated = !e, this.destY = s, this.snapped[1] = $754ef84e366f6443$var$vt(s, this.snapY), this.animate[this.yProp](s, 0), this.manual = !1, this;
    }
    get x() {
        return $754ef84e366f6443$var$yt(this.animate[this.xProp](), $754ef84e366f6443$var$F.precision);
    }
    set x(t) {
        this.setX(t, !1);
    }
    get y() {
        return $754ef84e366f6443$var$yt(this.animate[this.yProp](), $754ef84e366f6443$var$F.precision);
    }
    set y(t) {
        this.setY(t, !1);
    }
    get progressX() {
        return $754ef84e366f6443$var$ds(this.x, this.containerBounds[3], this.containerBounds[1], 0, 1);
    }
    set progressX(t) {
        this.setX($754ef84e366f6443$var$ds(t, 0, 1, this.containerBounds[3], this.containerBounds[1]), !1);
    }
    get progressY() {
        return $754ef84e366f6443$var$ds(this.y, this.containerBounds[0], this.containerBounds[2], 0, 1);
    }
    set progressY(t) {
        this.setY($754ef84e366f6443$var$ds(t, 0, 1, this.containerBounds[0], this.containerBounds[2]), !1);
    }
    updateScrollCoords() {
        const t = $754ef84e366f6443$var$yt(this.useWin ? $754ef84e366f6443$var$e.scrollX : this.$container.scrollLeft, 0), s = $754ef84e366f6443$var$yt(this.useWin ? $754ef84e366f6443$var$e.scrollY : this.$container.scrollTop, 0), [i, r, n, o] = this.containerPadding, a = this.scrollThreshold;
        this.scroll.x = t, this.scroll.y = s, this.scrollBounds[0] = s - this.targetBounds[0] + i - a, this.scrollBounds[1] = t - this.targetBounds[1] - r + a, this.scrollBounds[2] = s - this.targetBounds[2] - n + a, this.scrollBounds[3] = t - this.targetBounds[3] + o - a;
    }
    updateBoundingValues() {
        const t = this.$container;
        if (!t) return;
        const i = this.x, r = this.y, n = this.coords[2], o = this.coords[3];
        this.coords[2] = 0, this.coords[3] = 0, this.setX(0, !0), this.setY(0, !0), this.transforms.remove();
        const a = this.window[0] = $754ef84e366f6443$var$e.innerWidth, h = this.window[1] = $754ef84e366f6443$var$e.innerHeight, l = this.useWin, c = t.scrollWidth, d = t.scrollHeight, u = this.fixed, p = t.getBoundingClientRect(), [m, f, g, _] = this.containerPadding;
        this.dragArea[0] = l ? 0 : p.left, this.dragArea[1] = l ? 0 : p.top, this.scrollView[0] = l ? $754ef84e366f6443$var$gt(c, a, c) : c, this.scrollView[1] = l ? $754ef84e366f6443$var$gt(d, h, d) : d, this.updateScrollCoords();
        const { width: y, height: v, left: b, top: T, right: S, bottom: w } = t.getBoundingClientRect();
        this.dragArea[2] = $754ef84e366f6443$var$yt(l ? $754ef84e366f6443$var$gt(y, a, a) : y, 0), this.dragArea[3] = $754ef84e366f6443$var$yt(l ? $754ef84e366f6443$var$gt(v, h, h) : v, 0);
        const x = $754ef84e366f6443$export$3988ae62b71be9a3(t, "overflow"), C = "visible" === x, E = "hidden" === x;
        if (this.canScroll = !u && this.contained && (t === $754ef84e366f6443$var$s.body && C || !E && !C) && (c > this.dragArea[2] + _ - f || d > this.dragArea[3] + m - g) && (!this.containerArray || this.containerArray && !$754ef84e366f6443$var$U(this.containerArray)), this.contained) {
            const e = this.scroll.x, s = this.scroll.y, i = this.canScroll, r = this.$target.getBoundingClientRect(), n = i ? l ? 0 : t.scrollLeft : 0, o = i ? l ? 0 : t.scrollTop : 0, c = i ? this.scrollView[0] - n - y : 0, d = i ? this.scrollView[1] - o - v : 0;
            this.targetBounds[0] = $754ef84e366f6443$var$yt(r.top + s - (l ? 0 : T), 0), this.targetBounds[1] = $754ef84e366f6443$var$yt(r.right + e - (l ? a : S), 0), this.targetBounds[2] = $754ef84e366f6443$var$yt(r.bottom + s - (l ? h : w), 0), this.targetBounds[3] = $754ef84e366f6443$var$yt(r.left + e - (l ? 0 : b), 0), this.containerArray ? (this.containerBounds[0] = this.containerArray[0] + m, this.containerBounds[1] = this.containerArray[1] - f, this.containerBounds[2] = this.containerArray[2] - g, this.containerBounds[3] = this.containerArray[3] + _) : (this.containerBounds[0] = -$754ef84e366f6443$var$yt(r.top - (u ? $754ef84e366f6443$var$gt(T, 0, h) : T) + o - m, 0), this.containerBounds[1] = -$754ef84e366f6443$var$yt(r.right - (u ? $754ef84e366f6443$var$gt(S, 0, a) : S) - c + f, 0), this.containerBounds[2] = -$754ef84e366f6443$var$yt(r.bottom - (u ? $754ef84e366f6443$var$gt(w, 0, h) : w) - d + g, 0), this.containerBounds[3] = -$754ef84e366f6443$var$yt(r.left - (u ? $754ef84e366f6443$var$gt(b, 0, a) : b) + n - _, 0));
        }
        this.transforms.revert(), this.coords[2] = n, this.coords[3] = o, this.setX(i, !0), this.setY(r, !0);
    }
    isOutOfBounds(t, e, s) {
        if (!this.contained) return 0;
        const [i, r, n, o] = t, [a, h] = this.disabled, l = !a && e < o || !a && e > r, c = !h && s < i || !h && s > n;
        return l && !c ? 1 : !l && c ? 2 : l && c ? 3 : 0;
    }
    refresh() {
        const t = this.parameters, i = t.x, r = t.y, n = $754ef84e366f6443$var$ws(t.container, this), o = $754ef84e366f6443$var$ws(t.containerPadding, this) || 0, a = $754ef84e366f6443$var$U(o) ? o : [
            o,
            o,
            o,
            o
        ], h = this.x, l = this.y, c = $754ef84e366f6443$var$ws(t.cursor, this), d = {
            onHover: "grab",
            onGrab: "grabbing"
        };
        if (c) {
            const { onHover: t, onGrab: e } = c;
            t && (d.onHover = t), e && (d.onGrab = e);
        }
        const u = $754ef84e366f6443$var$ws(t.dragThreshold, this), p = {
            mouse: 3,
            touch: 7
        };
        if ($754ef84e366f6443$var$Y(u)) p.mouse = u, p.touch = u;
        else if (u) {
            const { mouse: t, touch: e } = u;
            $754ef84e366f6443$var$H(t) || (p.mouse = t), $754ef84e366f6443$var$H(e) || (p.touch = e);
        }
        this.containerArray = $754ef84e366f6443$var$U(n) ? n : null, this.$container = n && !this.containerArray ? $754ef84e366f6443$var$ye(n)[0] : $754ef84e366f6443$var$s.body, this.useWin = this.$container === $754ef84e366f6443$var$s.body, this.$scrollContainer = this.useWin ? $754ef84e366f6443$var$e : this.$container, this.isFinePointer = matchMedia("(pointer:fine)").matches, this.containerPadding = $754ef84e366f6443$var$Lt(a, [
            0,
            0,
            0,
            0
        ]), this.containerFriction = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt($754ef84e366f6443$var$ws(t.containerFriction, this), .8), 0, 1), this.releaseContainerFriction = $754ef84e366f6443$var$gt($754ef84e366f6443$var$Lt($754ef84e366f6443$var$ws(t.releaseContainerFriction, this), this.containerFriction), 0, 1), this.snapX = $754ef84e366f6443$var$ws($754ef84e366f6443$var$X(i) && !$754ef84e366f6443$var$H(i.snap) ? i.snap : t.snap, this), this.snapY = $754ef84e366f6443$var$ws($754ef84e366f6443$var$X(r) && !$754ef84e366f6443$var$H(r.snap) ? r.snap : t.snap, this), this.scrollSpeed = $754ef84e366f6443$var$Lt($754ef84e366f6443$var$ws(t.scrollSpeed, this), 1.5), this.scrollThreshold = $754ef84e366f6443$var$Lt($754ef84e366f6443$var$ws(t.scrollThreshold, this), 20), this.dragSpeed = $754ef84e366f6443$var$Lt($754ef84e366f6443$var$ws(t.dragSpeed, this), 1), this.dragThreshold = this.isFinePointer ? p.mouse : p.touch, this.minVelocity = $754ef84e366f6443$var$Lt($754ef84e366f6443$var$ws(t.minVelocity, this), 0), this.maxVelocity = $754ef84e366f6443$var$Lt($754ef84e366f6443$var$ws(t.maxVelocity, this), 50), this.velocityMultiplier = $754ef84e366f6443$var$Lt($754ef84e366f6443$var$ws(t.velocityMultiplier, this), 1), this.cursor = !1 !== c && d, this.updateBoundingValues();
        const [m, f, g, _] = this.containerBounds;
        this.setX($754ef84e366f6443$var$gt(h, _, f), !0), this.setY($754ef84e366f6443$var$gt(l, m, g), !0);
    }
    update() {
        if (this.updateScrollCoords(), this.canScroll) {
            const [t, e, s, i] = this.containerPadding, [r, n] = this.scrollView, o = this.dragArea[2], a = this.dragArea[3], h = this.scroll.x, l = this.scroll.y, c = this.$container.scrollWidth, d = this.$container.scrollHeight, u = this.useWin ? $754ef84e366f6443$var$gt(c, this.window[0], c) : c, p = this.useWin ? $754ef84e366f6443$var$gt(d, this.window[1], d) : d, m = r - u, f = n - p;
            this.dragged && m > 0 && (this.coords[0] -= m, this.scrollView[0] = u), this.dragged && f > 0 && (this.coords[1] -= f, this.scrollView[1] = p);
            const g = 10 * this.scrollSpeed, _ = this.scrollThreshold, [y, v] = this.coords, [b, T, S, w] = this.scrollBounds, x = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt((v - b + t) / _, -1, 0) * g, 0), C = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt((y - T - e) / _, 0, 1) * g, 0), E = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt((v - S - s) / _, 0, 1) * g, 0), k = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt((y - w + i) / _, -1, 0) * g, 0);
            if (x || E || k || C) {
                const [t, e] = this.disabled;
                let s = h, i = l;
                t || (s = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(h + (k || C), 0, r - o), 0), this.coords[0] -= h - s), e || (i = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(l + (x || E), 0, n - a), 0), this.coords[1] -= l - i), this.useWin ? this.$scrollContainer.scrollBy(-(h - s), -(l - i)) : this.$scrollContainer.scrollTo(s, i);
            }
        }
        const [t, e, s, i] = this.containerBounds, [r, n, o, a, h, l] = this.pointer;
        this.coords[0] += (r - h) * this.dragSpeed, this.coords[1] += (n - l) * this.dragSpeed, this.pointer[4] = r, this.pointer[5] = n;
        const [c, d] = this.coords, [u, p] = this.snapped, m = (1 - this.containerFriction) * this.dragSpeed;
        this.setX(c > e ? e + (c - e) * m : c < i ? i + (c - i) * m : c, !1), this.setY(d > s ? s + (d - s) * m : d < t ? t + (d - t) * m : d, !1), this.computeVelocity(r - h, n - l), this.angle = $754ef84e366f6443$var$pt(n - a, r - o);
        const [f, g] = this.snapped;
        (f !== u && this.snapX || g !== p && this.snapY) && this.onSnap(this);
    }
    stop() {
        this.updateTicker.pause(), this.overshootTicker.pause();
        for(let t in this.animate.animations)this.animate.animations[t].pause();
        return $754ef84e366f6443$var$de([
            this
        ], null, "x"), $754ef84e366f6443$var$de([
            this
        ], null, "y"), $754ef84e366f6443$var$de([
            this
        ], null, "progressX"), $754ef84e366f6443$var$de([
            this
        ], null, "progressY"), $754ef84e366f6443$var$de([
            this.scroll
        ]), $754ef84e366f6443$var$de([
            this.overshootCoords
        ]), this;
    }
    scrollInView(t, e = 0, s = $754ef84e366f6443$export$4e31f8f121cad154.inOutQuad) {
        this.updateScrollCoords();
        const i = this.destX, r = this.destY, n = this.scroll, o = this.scrollBounds, a = this.canScroll;
        if (!this.containerArray && this.isOutOfBounds(o, i, r)) {
            const [h, l, c, d] = o, u = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(r - h, -$754ef84e366f6443$var$m, 0), 0), p = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(i - l, 0, $754ef84e366f6443$var$m), 0), f = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(r - c, 0, $754ef84e366f6443$var$m), 0), g = $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(i - d, -$754ef84e366f6443$var$m, 0), 0);
            new $754ef84e366f6443$export$3394f837405475c7(n, {
                x: $754ef84e366f6443$var$yt(n.x + (g ? g - e : p ? p + e : 0), 0),
                y: $754ef84e366f6443$var$yt(n.y + (u ? u - e : f ? f + e : 0), 0),
                duration: $754ef84e366f6443$var$H(t) ? 350 * $754ef84e366f6443$var$F.timeScale : t,
                ease: s,
                onUpdate: ()=>{
                    this.canScroll = !1, this.$scrollContainer.scrollTo(n.x, n.y);
                }
            }).init().then(()=>{
                this.canScroll = a;
            });
        }
        return this;
    }
    handleHover() {
        this.isFinePointer && this.cursor && !this.cursorStyles && (this.cursorStyles = $754ef84e366f6443$export$adaa4cf7ef1b65be(this.$trigger, {
            cursor: this.cursor.onHover
        }));
    }
    animateInView(t, e = 0, s = $754ef84e366f6443$export$4e31f8f121cad154.inOutQuad) {
        this.stop(), this.updateBoundingValues();
        const i = this.x, r = this.y, [n, o, a, h] = this.containerPadding, l = this.scroll.y - this.targetBounds[0] + n + e, c = this.scroll.x - this.targetBounds[1] - o - e, d = this.scroll.y - this.targetBounds[2] - a - e, u = this.scroll.x - this.targetBounds[3] + h + e, p = this.isOutOfBounds([
            l,
            c,
            d,
            u
        ], i, r);
        if (p) {
            const [e, n] = this.disabled, o = $754ef84e366f6443$var$gt($754ef84e366f6443$var$vt(i, this.snapX), u, c), a = $754ef84e366f6443$var$gt($754ef84e366f6443$var$vt(r, this.snapY), l, d), h = $754ef84e366f6443$var$H(t) ? 350 * $754ef84e366f6443$var$F.timeScale : t;
            e || 1 !== p && 3 !== p || this.animate[this.xProp](o, h, s), n || 2 !== p && 3 !== p || this.animate[this.yProp](a, h, s);
        }
        return this;
    }
    handleDown(t) {
        const e = t.target;
        if (this.grabbed || "range" === e.type) return;
        t.stopPropagation(), this.grabbed = !0, this.released = !1, this.stop(), this.updateBoundingValues();
        const i = t.changedTouches, r = i ? i[0].clientX : t.clientX, n = i ? i[0].clientY : t.clientY, { x: o, y: a } = this.transforms.normalizePoint(r, n), [h, l, c, d] = this.containerBounds, u = (1 - this.containerFriction) * this.dragSpeed, p = this.x, m = this.y;
        this.coords[0] = this.coords[2] = u ? p > l ? l + (p - l) / u : p < d ? d + (p - d) / u : p : p, this.coords[1] = this.coords[3] = u ? m > c ? c + (m - c) / u : m < h ? h + (m - h) / u : m : m, this.pointer[0] = o, this.pointer[1] = a, this.pointer[2] = o, this.pointer[3] = a, this.pointer[4] = o, this.pointer[5] = a, this.pointer[6] = o, this.pointer[7] = a, this.deltaX = 0, this.deltaY = 0, this.velocity = 0, this.velocityStack[0] = 0, this.velocityStack[1] = 0, this.velocityStack[2] = 0, this.velocityStackIndex = 0, this.angle = 0, this.targetStyles && (this.targetStyles.revert(), this.targetStyles = null);
        const f = $754ef84e366f6443$export$3988ae62b71be9a3(this.$target, "zIndex", !1);
        $754ef84e366f6443$var$xs = (f > $754ef84e366f6443$var$xs ? f : $754ef84e366f6443$var$xs) + 1, this.targetStyles = $754ef84e366f6443$export$adaa4cf7ef1b65be(this.$target, {
            zIndex: $754ef84e366f6443$var$xs
        }), this.triggerStyles && (this.triggerStyles.revert(), this.triggerStyles = null), this.cursorStyles && (this.cursorStyles.revert(), this.cursorStyles = null), this.isFinePointer && this.cursor && (this.bodyStyles = $754ef84e366f6443$export$adaa4cf7ef1b65be($754ef84e366f6443$var$s.body, {
            cursor: this.cursor.onGrab
        })), this.scrollInView(100, 0, $754ef84e366f6443$export$4e31f8f121cad154.out(3)), this.onGrab(this), $754ef84e366f6443$var$s.addEventListener("touchmove", this), $754ef84e366f6443$var$s.addEventListener("touchend", this), $754ef84e366f6443$var$s.addEventListener("touchcancel", this), $754ef84e366f6443$var$s.addEventListener("mousemove", this), $754ef84e366f6443$var$s.addEventListener("mouseup", this), $754ef84e366f6443$var$s.addEventListener("selectstart", this);
    }
    handleMove(t) {
        if (!this.grabbed) return;
        const e = t.changedTouches, s = e ? e[0].clientX : t.clientX, i = e ? e[0].clientY : t.clientY, { x: r, y: n } = this.transforms.normalizePoint(s, i), o = r - this.pointer[6], a = n - this.pointer[7];
        let h = t.target, l = !1, c = !1, d = !1;
        for(; e && h && h !== this.$trigger;){
            const t = $754ef84e366f6443$export$3988ae62b71be9a3(h, "overflow-y");
            if ("hidden" !== t && "visible" !== t) {
                const { scrollTop: t, scrollHeight: e, clientHeight: s } = h;
                if (e > s) {
                    d = !0, l = t <= 3, c = t >= e - s - 3;
                    break;
                }
            }
            h = h.parentElement;
        }
        d && (!l && !c || l && a < 0 || c && a > 0) ? (this.pointer[0] = r, this.pointer[1] = n, this.pointer[2] = r, this.pointer[3] = n, this.pointer[4] = r, this.pointer[5] = n, this.pointer[6] = r, this.pointer[7] = n) : ($754ef84e366f6443$var$bs(t), this.triggerStyles || (this.triggerStyles = $754ef84e366f6443$export$adaa4cf7ef1b65be(this.$trigger, {
            pointerEvents: "none"
        })), this.$trigger.addEventListener("touchstart", $754ef84e366f6443$var$bs, {
            passive: !1
        }), this.$trigger.addEventListener("touchmove", $754ef84e366f6443$var$bs, {
            passive: !1
        }), this.$trigger.addEventListener("touchend", $754ef84e366f6443$var$bs), (this.dragged || !this.disabled[0] && $754ef84e366f6443$var$at(o) > this.dragThreshold || !this.disabled[1] && $754ef84e366f6443$var$at(a) > this.dragThreshold) && (this.updateTicker.resume(), this.pointer[2] = this.pointer[0], this.pointer[3] = this.pointer[1], this.pointer[0] = r, this.pointer[1] = n, this.dragged = !0, this.released = !1, this.onDrag(this)));
    }
    handleUp() {
        if (!this.grabbed) return;
        this.updateTicker.pause(), this.triggerStyles && (this.triggerStyles.revert(), this.triggerStyles = null), this.bodyStyles && (this.bodyStyles.revert(), this.bodyStyles = null);
        const [t, e] = this.disabled, [i, r, n, a, h, l] = this.pointer, [c, d, u, p] = this.containerBounds, [m, f] = this.snapped, g = this.releaseXSpring, _ = this.releaseYSpring, y = this.releaseEase, v = this.hasReleaseSpring, b = this.overshootCoords, T = this.x, S = this.y, w = this.computeVelocity(i - h, r - l), x = this.angle = $754ef84e366f6443$var$pt(r - a, i - n), C = 150 * w, E = (1 - this.releaseContainerFriction) * this.dragSpeed, k = T + $754ef84e366f6443$var$ot(x) * C, $ = S + $754ef84e366f6443$var$nt(x) * C, B = k > d ? d + (k - d) * E : k < p ? p + (k - p) * E : k, O = $ > u ? u + ($ - u) * E : $ < c ? c + ($ - c) * E : $, N = this.destX = $754ef84e366f6443$var$gt($754ef84e366f6443$var$yt($754ef84e366f6443$var$vt(B, this.snapX), 5), p, d), R = this.destY = $754ef84e366f6443$var$gt($754ef84e366f6443$var$yt($754ef84e366f6443$var$vt(O, this.snapY), 5), c, u), D = this.isOutOfBounds(this.containerBounds, k, $);
        let L = 0, A = 0, M = y, P = y, I = 0;
        if (b.x = T, b.y = S, !t) {
            const t = N === d ? T > d ? -1 : 1 : T < p ? -1 : 1, s = $754ef84e366f6443$var$yt(T - N, 0);
            g.velocity = e && v ? s ? C * t / $754ef84e366f6443$var$at(s) : 0 : w;
            const { ease: i, settlingDuration: r, restDuration: n } = g;
            L = T === N ? 0 : v ? r : r - n * $754ef84e366f6443$var$F.timeScale, v && (M = i), L > I && (I = L);
        }
        if (!e) {
            const e = R === u ? S > u ? -1 : 1 : S < c ? -1 : 1, s = $754ef84e366f6443$var$yt(S - R, 0);
            _.velocity = t && v ? s ? C * e / $754ef84e366f6443$var$at(s) : 0 : w;
            const { ease: i, settlingDuration: r, restDuration: n } = _;
            A = S === R ? 0 : v ? r : r - n * $754ef84e366f6443$var$F.timeScale, v && (P = i), A > I && (I = A);
        }
        if (!v && D && E && (L || A)) {
            const t = $754ef84e366f6443$var$o.blend;
            new $754ef84e366f6443$export$3394f837405475c7(b, {
                x: {
                    to: B,
                    duration: .65 * L
                },
                y: {
                    to: O,
                    duration: .65 * A
                },
                ease: y,
                composition: t
            }).init(), new $754ef84e366f6443$export$3394f837405475c7(b, {
                x: {
                    to: N,
                    duration: L
                },
                y: {
                    to: R,
                    duration: A
                },
                ease: y,
                composition: t
            }).init(), this.overshootTicker.stretch($754ef84e366f6443$var$ut(L, A)).restart();
        } else t || this.animate[this.xProp](N, L, M), e || this.animate[this.yProp](R, A, P);
        this.scrollInView(I, this.scrollThreshold, y);
        let z = !1;
        N !== m && (this.snapped[0] = N, this.snapX && (z = !0)), R !== f && this.snapY && (this.snapped[1] = R, this.snapY && (z = !0)), z && this.onSnap(this), this.grabbed = !1, this.dragged = !1, this.updated = !0, this.released = !0, this.onRelease(this), this.$trigger.removeEventListener("touchstart", $754ef84e366f6443$var$bs), this.$trigger.removeEventListener("touchmove", $754ef84e366f6443$var$bs), this.$trigger.removeEventListener("touchend", $754ef84e366f6443$var$bs), $754ef84e366f6443$var$s.removeEventListener("touchmove", this), $754ef84e366f6443$var$s.removeEventListener("touchend", this), $754ef84e366f6443$var$s.removeEventListener("touchcancel", this), $754ef84e366f6443$var$s.removeEventListener("mousemove", this), $754ef84e366f6443$var$s.removeEventListener("mouseup", this), $754ef84e366f6443$var$s.removeEventListener("selectstart", this);
    }
    reset() {
        return this.stop(), this.resizeTicker.pause(), this.grabbed = !1, this.dragged = !1, this.updated = !1, this.released = !1, this.canScroll = !1, this.setX(0, !0), this.setY(0, !0), this.coords[0] = 0, this.coords[1] = 0, this.pointer[0] = 0, this.pointer[1] = 0, this.pointer[2] = 0, this.pointer[3] = 0, this.pointer[4] = 0, this.pointer[5] = 0, this.pointer[6] = 0, this.pointer[7] = 0, this.velocity = 0, this.velocityStack[0] = 0, this.velocityStack[1] = 0, this.velocityStack[2] = 0, this.velocityStackIndex = 0, this.angle = 0, this;
    }
    enable() {
        return this.enabled || (this.enabled = !0, this.$target.classList.remove("is-disabled"), this.touchActionStyles = $754ef84e366f6443$export$adaa4cf7ef1b65be(this.$trigger, {
            touchAction: this.disabled[0] ? "pan-x" : this.disabled[1] ? "pan-y" : "none"
        }), this.$trigger.addEventListener("touchstart", this, {
            passive: !0
        }), this.$trigger.addEventListener("mousedown", this, {
            passive: !0
        }), this.$trigger.addEventListener("mouseenter", this)), this;
    }
    disable() {
        return this.enabled = !1, this.grabbed = !1, this.dragged = !1, this.updated = !1, this.released = !1, this.canScroll = !1, this.touchActionStyles.revert(), this.cursorStyles && (this.cursorStyles.revert(), this.cursorStyles = null), this.triggerStyles && (this.triggerStyles.revert(), this.triggerStyles = null), this.bodyStyles && (this.bodyStyles.revert(), this.bodyStyles = null), this.targetStyles && (this.targetStyles.revert(), this.targetStyles = null), this.$target.classList.add("is-disabled"), this.$trigger.removeEventListener("touchstart", this), this.$trigger.removeEventListener("mousedown", this), this.$trigger.removeEventListener("mouseenter", this), $754ef84e366f6443$var$s.removeEventListener("touchmove", this), $754ef84e366f6443$var$s.removeEventListener("touchend", this), $754ef84e366f6443$var$s.removeEventListener("touchcancel", this), $754ef84e366f6443$var$s.removeEventListener("mousemove", this), $754ef84e366f6443$var$s.removeEventListener("mouseup", this), $754ef84e366f6443$var$s.removeEventListener("selectstart", this), this;
    }
    revert() {
        return this.reset(), this.disable(), this.$target.classList.remove("is-disabled"), this.updateTicker.revert(), this.overshootTicker.revert(), this.resizeTicker.revert(), this.animate.revert(), this.resizeObserver.disconnect(), this;
    }
    handleEvent(t) {
        switch(t.type){
            case "mousedown":
            case "touchstart":
                this.handleDown(t);
                break;
            case "mousemove":
            case "touchmove":
                this.handleMove(t);
                break;
            case "mouseup":
            case "touchend":
            case "touchcancel":
                this.handleUp();
                break;
            case "mouseenter":
                this.handleHover();
                break;
            case "selectstart":
                $754ef84e366f6443$var$bs(t);
        }
    }
}
const $754ef84e366f6443$export$eb23a64a85f9d3d2 = (t, e)=>new $754ef84e366f6443$export$f2a139e5d18b9882(t, e), $754ef84e366f6443$export$92d6409d68f0739a = (t = $754ef84e366f6443$var$S)=>new $754ef84e366f6443$export$c57e9b2d8b9e4de({
        duration: 1 * $754ef84e366f6443$var$F.timeScale,
        onComplete: t
    }, null, 0).resume(), $754ef84e366f6443$export$2e6d4caa59927c5e = (t)=>{
    let e;
    return (...s)=>{
        let i, r, n, o;
        e && (i = e.currentIteration, r = e.iterationProgress, n = e.reversed, o = e._alternate, e.revert());
        const a = t(...s);
        return a && !$754ef84e366f6443$var$W(a) && a.revert && (e = a), $754ef84e366f6443$var$H(r) || (e.currentIteration = i, e.iterationProgress = (o && i % 2 ? !n : n) ? 1 - r : r), a || $754ef84e366f6443$var$S;
    };
};
class $754ef84e366f6443$export$775b6bb06e53a214 {
    constructor(t = {}){
        $754ef84e366f6443$var$A.current && $754ef84e366f6443$var$A.current.register(this);
        const i = t.root;
        let r = $754ef84e366f6443$var$s;
        i && (r = i.current || i.nativeElement || $754ef84e366f6443$var$ye(i)[0] || $754ef84e366f6443$var$s);
        const n = t.defaults, o = $754ef84e366f6443$var$F.defaults, a = t.mediaQueries;
        if (this.defaults = n ? $754ef84e366f6443$var$xt(n, o) : o, this.root = r, this.constructors = [], this.revertConstructors = [], this.revertibles = [], this.constructorsOnce = [], this.revertConstructorsOnce = [], this.revertiblesOnce = [], this.once = !1, this.onceIndex = 0, this.methods = {}, this.matches = {}, this.mediaQueryLists = {}, this.data = {}, a) for(let t in a){
            const s = $754ef84e366f6443$var$e.matchMedia(a[t]);
            this.mediaQueryLists[t] = s, s.addEventListener("change", this);
        }
    }
    register(t) {
        (this.once ? this.revertiblesOnce : this.revertibles).push(t);
    }
    execute(t) {
        let e = $754ef84e366f6443$var$A.current, s = $754ef84e366f6443$var$A.root, i = $754ef84e366f6443$var$F.defaults;
        $754ef84e366f6443$var$A.current = this, $754ef84e366f6443$var$A.root = this.root, $754ef84e366f6443$var$F.defaults = this.defaults;
        const r = this.mediaQueryLists;
        for(let t in r)this.matches[t] = r[t].matches;
        const n = t(this);
        return $754ef84e366f6443$var$A.current = e, $754ef84e366f6443$var$A.root = s, $754ef84e366f6443$var$F.defaults = i, n;
    }
    refresh() {
        return this.onceIndex = 0, this.execute(()=>{
            let t = this.revertibles.length, e = this.revertConstructors.length;
            for(; t--;)this.revertibles[t].revert();
            for(; e--;)this.revertConstructors[e](this);
            this.revertibles.length = 0, this.revertConstructors.length = 0, this.constructors.forEach((t)=>{
                const e = t(this);
                $754ef84e366f6443$var$W(e) && this.revertConstructors.push(e);
            });
        }), this;
    }
    add(t, e) {
        if (this.once = !1, $754ef84e366f6443$var$W(t)) {
            const e = t;
            this.constructors.push(e), this.execute(()=>{
                const t = e(this);
                $754ef84e366f6443$var$W(t) && this.revertConstructors.push(t);
            });
        } else this.methods[t] = (...t)=>this.execute(()=>e(...t));
        return this;
    }
    addOnce(t) {
        if (this.once = !0, $754ef84e366f6443$var$W(t)) {
            const e = this.onceIndex++;
            if (this.constructorsOnce[e]) return this;
            const s = t;
            this.constructorsOnce[e] = s, this.execute(()=>{
                const t = s(this);
                $754ef84e366f6443$var$W(t) && this.revertConstructorsOnce.push(t);
            });
        }
        return this;
    }
    keepTime(t) {
        this.once = !0;
        const e = this.onceIndex++, s = this.constructorsOnce[e];
        if ($754ef84e366f6443$var$W(s)) return s(this);
        const i = $754ef84e366f6443$export$2e6d4caa59927c5e(t);
        let r;
        return this.constructorsOnce[e] = i, this.execute(()=>{
            r = i(this);
        }), r;
    }
    handleEvent(t) {
        "change" === t.type && this.refresh();
    }
    revert() {
        const t = this.revertibles, e = this.revertConstructors, s = this.revertiblesOnce, i = this.revertConstructorsOnce, r = this.mediaQueryLists;
        let n = t.length, o = e.length, a = s.length, h = i.length;
        for(; n--;)t[n].revert();
        for(; o--;)e[o](this);
        for(; a--;)s[a].revert();
        for(; h--;)i[h](this);
        for(let t in r)r[t].removeEventListener("change", this);
        t.length = 0, e.length = 0, this.constructors.length = 0, s.length = 0, i.length = 0, this.constructorsOnce.length = 0, this.onceIndex = 0, this.matches = {}, this.methods = {}, this.mediaQueryLists = {}, this.data = {};
    }
}
const $754ef84e366f6443$export$41a9651decfe2bde = (t)=>new $754ef84e366f6443$export$775b6bb06e53a214(t), $754ef84e366f6443$var$Ns = ()=>{
    const t = $754ef84e366f6443$var$s.createElement("div");
    $754ef84e366f6443$var$s.body.appendChild(t), t.style.height = "100lvh";
    const e = t.offsetHeight;
    return $754ef84e366f6443$var$s.body.removeChild(t), e;
}, $754ef84e366f6443$var$Rs = (t, e)=>t && $754ef84e366f6443$var$W(t) ? t(e) : t, $754ef84e366f6443$export$9ca6c92041700e2a = new Map;
class $754ef84e366f6443$var$Ls {
    constructor(t){
        this.element = t, this.useWin = this.element === $754ef84e366f6443$var$s.body, this.winWidth = 0, this.winHeight = 0, this.width = 0, this.height = 0, this.left = 0, this.top = 0, this.scale = 1, this.zIndex = 0, this.scrollX = 0, this.scrollY = 0, this.prevScrollX = 0, this.prevScrollY = 0, this.scrollWidth = 0, this.scrollHeight = 0, this.velocity = 0, this.backwardX = !1, this.backwardY = !1, this.scrollTicker = new $754ef84e366f6443$export$c57e9b2d8b9e4de({
            autoplay: !1,
            onBegin: ()=>this.dataTimer.resume(),
            onUpdate: ()=>{
                const t = this.backwardX || this.backwardY;
                $754ef84e366f6443$var$Ct(this, (t)=>t.handleScroll(), t);
            },
            onComplete: ()=>this.dataTimer.pause()
        }).init(), this.dataTimer = new $754ef84e366f6443$export$c57e9b2d8b9e4de({
            autoplay: !1,
            frameRate: 30,
            onUpdate: (t)=>{
                const e = t.deltaTime, s = this.prevScrollX, i = this.prevScrollY, r = this.scrollX, n = this.scrollY, o = s - r, a = i - n;
                this.prevScrollX = r, this.prevScrollY = n, o && (this.backwardX = s > r), a && (this.backwardY = i > n), this.velocity = $754ef84e366f6443$var$yt(e > 0 ? Math.sqrt(o * o + a * a) / e : 0, 5);
            }
        }).init(), this.resizeTicker = new $754ef84e366f6443$export$c57e9b2d8b9e4de({
            autoplay: !1,
            duration: 250 * $754ef84e366f6443$var$F.timeScale,
            onComplete: ()=>{
                this.updateWindowBounds(), this.refreshScrollObservers(), this.handleScroll();
            }
        }).init(), this.wakeTicker = new $754ef84e366f6443$export$c57e9b2d8b9e4de({
            autoplay: !1,
            duration: 500 * $754ef84e366f6443$var$F.timeScale,
            onBegin: ()=>{
                this.scrollTicker.resume();
            },
            onComplete: ()=>{
                this.scrollTicker.pause();
            }
        }).init(), this._head = null, this._tail = null, this.updateScrollCoords(), this.updateWindowBounds(), this.updateBounds(), this.refreshScrollObservers(), this.handleScroll(), this.resizeObserver = new ResizeObserver(()=>this.resizeTicker.restart()), this.resizeObserver.observe(this.element), (this.useWin ? $754ef84e366f6443$var$e : this.element).addEventListener("scroll", this, !1);
    }
    updateScrollCoords() {
        const t = this.useWin, s = this.element;
        this.scrollX = $754ef84e366f6443$var$yt(t ? $754ef84e366f6443$var$e.scrollX : s.scrollLeft, 0), this.scrollY = $754ef84e366f6443$var$yt(t ? $754ef84e366f6443$var$e.scrollY : s.scrollTop, 0);
    }
    updateWindowBounds() {
        this.winWidth = $754ef84e366f6443$var$e.innerWidth, this.winHeight = $754ef84e366f6443$var$Ns();
    }
    updateBounds() {
        const t = getComputedStyle(this.element), e = this.element;
        let s, i;
        if (this.scrollWidth = e.scrollWidth + parseFloat(t.marginLeft) + parseFloat(t.marginRight), this.scrollHeight = e.scrollHeight + parseFloat(t.marginTop) + parseFloat(t.marginBottom), this.updateWindowBounds(), this.useWin) s = this.winWidth, i = this.winHeight;
        else {
            const t = e.getBoundingClientRect();
            s = e.clientWidth, i = e.clientHeight, this.top = t.top, this.left = t.left, this.scale = t.width ? s / t.width : t.height ? i / t.height : 1;
        }
        this.width = s, this.height = i;
    }
    refreshScrollObservers() {
        $754ef84e366f6443$var$Ct(this, (t)=>{
            t._debug && t.removeDebug();
        }), this.updateBounds(), $754ef84e366f6443$var$Ct(this, (t)=>{
            t.refresh(), t._debug && t.debug();
        });
    }
    refresh() {
        this.updateWindowBounds(), this.updateBounds(), this.refreshScrollObservers(), this.handleScroll();
    }
    handleScroll() {
        this.updateScrollCoords(), this.wakeTicker.restart();
    }
    handleEvent(t) {
        "scroll" === t.type && this.handleScroll();
    }
    revert() {
        this.scrollTicker.cancel(), this.dataTimer.cancel(), this.resizeTicker.cancel(), this.wakeTicker.cancel(), this.resizeObserver.disconnect(), (this.useWin ? $754ef84e366f6443$var$e : this.element).removeEventListener("scroll", this), $754ef84e366f6443$export$9ca6c92041700e2a.delete(this.element);
    }
}
const $754ef84e366f6443$var$As = (t)=>{
    const e = t && $754ef84e366f6443$var$ye(t)[0] || $754ef84e366f6443$var$s.body;
    let i = $754ef84e366f6443$export$9ca6c92041700e2a.get(e);
    return i || (i = new $754ef84e366f6443$var$Ls(e), $754ef84e366f6443$export$9ca6c92041700e2a.set(e, i)), i;
}, $754ef84e366f6443$var$Fs = (t, e, s, i, r)=>{
    const n = "min" === e, o = "max" === e, a = "top" === e || "left" === e || "start" === e || n ? 0 : "bottom" === e || "right" === e || "end" === e || o ? "100%" : "center" === e ? "50%" : e, { n: h, u: l } = $754ef84e366f6443$var$Ut(a, $754ef84e366f6443$var$Yt);
    let c = h;
    return "%" === l ? c = h / 100 * s : l && (c = $754ef84e366f6443$var$Se(t, $754ef84e366f6443$var$Yt, "px", !0).n), o && i < 0 && (c += i), n && r > 0 && (c += r), c;
}, $754ef84e366f6443$var$Ms = (t, e, s, i, r)=>{
    let n;
    if ($754ef84e366f6443$var$V(e)) {
        const o = $754ef84e366f6443$var$R.exec(e);
        if (o) {
            const a = o[0], h = a[0], l = e.split(a), c = "min" === l[0], d = "max" === l[0], u = $754ef84e366f6443$var$Fs(t, l[0], s, i, r), p = $754ef84e366f6443$var$Fs(t, l[1], s, i, r);
            if (c) {
                const e = $754ef84e366f6443$var$It($754ef84e366f6443$var$Fs(t, "min", s), p, h);
                n = e < u ? u : e;
            } else if (d) {
                const e = $754ef84e366f6443$var$It($754ef84e366f6443$var$Fs(t, "max", s), p, h);
                n = e > u ? u : e;
            } else n = $754ef84e366f6443$var$It(u, p, h);
        } else n = $754ef84e366f6443$var$Fs(t, e, s, i, r);
    } else n = e;
    return $754ef84e366f6443$var$yt(n, 0);
}, $754ef84e366f6443$var$Ps = (t)=>{
    let e;
    const s = t.targets;
    for(let t = 0, i = s.length; t < i; t++){
        const i = s[t];
        if (i[$754ef84e366f6443$var$h]) {
            e = i;
            break;
        }
    }
    return e;
};
let $754ef84e366f6443$var$Is = 0;
const $754ef84e366f6443$var$zs = [
    "#FF4B4B",
    "#FF971B",
    "#FFC730",
    "#F9F640",
    "#7AFF5A",
    "#18FF74",
    "#17E09B",
    "#3CFFEC",
    "#05DBE9",
    "#33B3F1",
    "#638CF9",
    "#C563FE",
    "#FF4FCF",
    "#F93F8A"
];
class $754ef84e366f6443$export$c7cad6b3e396923a {
    constructor(t = {}){
        $754ef84e366f6443$var$A.current && $754ef84e366f6443$var$A.current.register(this);
        const e = $754ef84e366f6443$var$Lt(t.sync, "play pause"), i = e ? $754ef84e366f6443$var$De(e) : null, r = e && ("linear" === e || e === $754ef84e366f6443$var$we), n = e && !(i === $754ef84e366f6443$var$we && !r), o = e && ($754ef84e366f6443$var$Y(e) || !0 === e || r), a = e && $754ef84e366f6443$var$V(e) && !n && !o, h = a ? e.split(" ").map((t)=>()=>{
                const e = this.linked;
                return e && e[t] ? e[t]() : null;
            }) : null, l = a && h.length > 2;
        this.index = $754ef84e366f6443$var$Is++, this.id = $754ef84e366f6443$var$H(t.id) ? this.index : t.id, this.container = $754ef84e366f6443$var$As(t.container), this.target = null, this.linked = null, this.repeat = null, this.horizontal = null, this.enter = null, this.leave = null, this.sync = n || o || !!h, this.syncEase = n ? i : null, this.syncSmooth = o ? !0 === e || r ? 1 : e : null, this.onSyncEnter = h && !l && h[0] ? h[0] : $754ef84e366f6443$var$S, this.onSyncLeave = h && !l && h[1] ? h[1] : $754ef84e366f6443$var$S, this.onSyncEnterForward = h && l && h[0] ? h[0] : $754ef84e366f6443$var$S, this.onSyncLeaveForward = h && l && h[1] ? h[1] : $754ef84e366f6443$var$S, this.onSyncEnterBackward = h && l && h[2] ? h[2] : $754ef84e366f6443$var$S, this.onSyncLeaveBackward = h && l && h[3] ? h[3] : $754ef84e366f6443$var$S, this.onEnter = t.onEnter || $754ef84e366f6443$var$S, this.onLeave = t.onLeave || $754ef84e366f6443$var$S, this.onEnterForward = t.onEnterForward || $754ef84e366f6443$var$S, this.onLeaveForward = t.onLeaveForward || $754ef84e366f6443$var$S, this.onEnterBackward = t.onEnterBackward || $754ef84e366f6443$var$S, this.onLeaveBackward = t.onLeaveBackward || $754ef84e366f6443$var$S, this.onUpdate = t.onUpdate || $754ef84e366f6443$var$S, this.onSyncComplete = t.onSyncComplete || $754ef84e366f6443$var$S, this.reverted = !1, this.ready = !1, this.completed = !1, this.began = !1, this.isInView = !1, this.forceEnter = !1, this.hasEntered = !1, this.offset = 0, this.offsetStart = 0, this.offsetEnd = 0, this.distance = 0, this.prevProgress = 0, this.thresholds = [
            "start",
            "end",
            "end",
            "start"
        ], this.coords = [
            0,
            0,
            0,
            0
        ], this.debugStyles = null, this.$debug = null, this._params = t, this._debug = $754ef84e366f6443$var$Lt(t.debug, !1), this._next = null, this._prev = null, $754ef84e366f6443$var$kt(this.container, this), $754ef84e366f6443$export$92d6409d68f0739a(()=>{
            if (!this.reverted) {
                if (!this.target) {
                    const e = $754ef84e366f6443$var$ye(t.target)[0];
                    this.target = e || $754ef84e366f6443$var$s.body, this.refresh();
                }
                this._debug && this.debug();
            }
        });
    }
    link(t) {
        if (t && (t.pause(), this.linked = t, $754ef84e366f6443$var$H(t) || (t.persist = !0), !this._params.target)) {
            let e;
            $754ef84e366f6443$var$H(t.targets) ? $754ef84e366f6443$var$Ct(t, (t)=>{
                t.targets && !e && (e = $754ef84e366f6443$var$Ps(t));
            }) : e = $754ef84e366f6443$var$Ps(t), this.target = e || $754ef84e366f6443$var$s.body, this.refresh();
        }
        return this;
    }
    get velocity() {
        return this.container.velocity;
    }
    get backward() {
        return this.horizontal ? this.container.backwardX : this.container.backwardY;
    }
    get scroll() {
        return this.horizontal ? this.container.scrollX : this.container.scrollY;
    }
    get progress() {
        const t = (this.scroll - this.offsetStart) / this.distance;
        return t === 1 / 0 || isNaN(t) ? 0 : $754ef84e366f6443$var$yt($754ef84e366f6443$var$gt(t, 0, 1), 6);
    }
    refresh() {
        this.ready = !0, this.reverted = !1;
        const t = this._params;
        return this.repeat = $754ef84e366f6443$var$Lt($754ef84e366f6443$var$Rs(t.repeat, this), !0), this.horizontal = "x" === $754ef84e366f6443$var$Lt($754ef84e366f6443$var$Rs(t.axis, this), "y"), this.enter = $754ef84e366f6443$var$Lt($754ef84e366f6443$var$Rs(t.enter, this), "end start"), this.leave = $754ef84e366f6443$var$Lt($754ef84e366f6443$var$Rs(t.leave, this), "start end"), this.updateBounds(), this.handleScroll(), this;
    }
    removeDebug() {
        return this.$debug && (this.$debug.parentNode.removeChild(this.$debug), this.$debug = null), this.debugStyles && (this.debugStyles.revert(), this.$debug = null), this;
    }
    debug() {
        this.removeDebug();
        const t = this.container, e = this.horizontal, i = t.element.querySelector(":scope > .animejs-onscroll-debug"), r = $754ef84e366f6443$var$s.createElement("div"), n = $754ef84e366f6443$var$s.createElement("div"), o = $754ef84e366f6443$var$s.createElement("div"), a = $754ef84e366f6443$var$zs[this.index % $754ef84e366f6443$var$zs.length], h = t.useWin, l = h ? t.winWidth : t.width, c = h ? t.winHeight : t.height, d = t.scrollWidth, u = t.scrollHeight, p = this.container.width > 360 ? 320 : 260, m = e ? 0 : 10, f = e ? 10 : 0, g = e ? 24 : p / 2, _ = e ? g : 15, y = e ? 60 : g, v = e ? y : _, b = e ? "repeat-x" : "repeat-y", T = (t)=>e ? "0px " + t + "px" : t + "px 2px", S = (t)=>`linear-gradient(${e ? 90 : 0}deg, ${t} 2px, transparent 1px)`, w = (t, e, s, i, r)=>`position:${t};left:${e}px;top:${s}px;width:${i}px;height:${r}px;`;
        r.style.cssText = `${w("absolute", m, f, e ? d : p, e ? p : u)}\n      pointer-events: none;\n      z-index: ${this.container.zIndex++};\n      display: flex;\n      flex-direction: ${e ? "column" : "row"};\n      filter: drop-shadow(0px 1px 0px rgba(0,0,0,.75));\n    `, n.style.cssText = `${w("sticky", 0, 0, e ? l : g, e ? g : c)}`, i || (n.style.cssText += `background:\n        ${S("#FFFF")}${T(g - 10)} / 100px 100px ${b},\n        ${S("#FFF8")}${T(g - 10)} / 10px 10px ${b};\n      `), o.style.cssText = `${w("relative", 0, 0, e ? d : g, e ? g : u)}`, i || (o.style.cssText += `background:\n        ${S("#FFFF")}${T(0)} / ${e ? "100px 10px" : "10px 100px"} ${b},\n        ${S("#FFF8")}${T(0)} / ${e ? "10px 0px" : "0px 10px"} ${b};\n      `);
        const x = [
            " enter: ",
            " leave: "
        ];
        this.coords.forEach((t, i)=>{
            const r = i > 1, h = (r ? 0 : this.offset) + t, m = i % 2, f = h < v, g = h > (r ? e ? l : c : e ? d : u) - v, b = (r ? m && !f : !m && !f) || g, T = $754ef84e366f6443$var$s.createElement("div"), S = $754ef84e366f6443$var$s.createElement("div"), C = e ? b ? "right" : "left" : b ? "bottom" : "top", E = b ? (e ? y : _) + (r ? e ? -1 : g ? 0 : -2 : e ? -1 : -2) : e ? 1 : 0;
            S.innerHTML = `${this.id}${x[m]}${this.thresholds[i]}`, T.style.cssText = `${w("absolute", 0, 0, y, _)}\n        display: flex;\n        flex-direction: ${e ? "column" : "row"};\n        justify-content: flex-${r ? "start" : "end"};\n        align-items: flex-${b ? "end" : "start"};\n        border-${C}: 2px solid ${a};\n      `, S.style.cssText = `\n        overflow: hidden;\n        max-width: ${p / 2 - 10}px;\n        height: ${_};\n        margin-${e ? b ? "right" : "left" : b ? "bottom" : "top"}: -2px;\n        padding: 1px;\n        font-family: ui-monospace, monospace;\n        font-size: 10px;\n        letter-spacing: -.025em;\n        line-height: 9px;\n        font-weight: 600;\n        text-align: ${e && b || !e && !r ? "right" : "left"};\n        white-space: pre;\n        text-overflow: ellipsis;\n        color: ${m ? a : "rgba(0,0,0,.75)"};\n        background-color: ${m ? "rgba(0,0,0,.65)" : a};\n        border: 2px solid ${m ? a : "transparent"};\n        border-${e ? b ? "top-left" : "top-right" : b ? "top-left" : "bottom-left"}-radius: 5px;\n        border-${e ? b ? "bottom-left" : "bottom-right" : b ? "top-right" : "bottom-right"}-radius: 5px;\n      `, T.appendChild(S);
            let k = h - E + (e ? 1 : 0);
            T.style[e ? "left" : "top"] = `${k}px`, (r ? n : o).appendChild(T);
        }), r.appendChild(n), r.appendChild(o), t.element.appendChild(r), i || r.classList.add("animejs-onscroll-debug"), this.$debug = r, "static" === $754ef84e366f6443$export$3988ae62b71be9a3(t.element, "position") && (this.debugStyles = $754ef84e366f6443$export$adaa4cf7ef1b65be(t.element, {
            position: "relative "
        }));
    }
    updateBounds() {
        let t;
        this._debug && this.removeDebug();
        const e = this.target, i = this.container, r = this.horizontal, n = this.linked;
        let o, a = e;
        for(n && (o = n.currentTime, n.seek(0, !0)), a.parentElement; a && a !== i.element && a !== $754ef84e366f6443$var$s.body;){
            const e = "sticky" === $754ef84e366f6443$export$3988ae62b71be9a3(a, "position") && $754ef84e366f6443$export$adaa4cf7ef1b65be(a, {
                position: "static"
            });
            a = a.parentElement, e && (t || (t = []), t.push(e));
        }
        const h = e.getBoundingClientRect(), l = i.scale, c = (r ? h.left + i.scrollX - i.left : h.top + i.scrollY - i.top) * l, d = (r ? h.width : h.height) * l, u = r ? i.width : i.height, p = (r ? i.scrollWidth : i.scrollHeight) - u, m = this.enter, f = this.leave;
        let g = "start", _ = "end", y = "end", v = "start";
        if ($754ef84e366f6443$var$V(m)) {
            const t = m.split(" ");
            y = t[0], g = t.length > 1 ? t[1] : g;
        } else if ($754ef84e366f6443$var$X(m)) {
            const t = m;
            $754ef84e366f6443$var$H(t.container) || (y = t.container), $754ef84e366f6443$var$H(t.target) || (g = t.target);
        } else $754ef84e366f6443$var$Y(m) && (y = m);
        if ($754ef84e366f6443$var$V(f)) {
            const t = f.split(" ");
            v = t[0], _ = t.length > 1 ? t[1] : _;
        } else if ($754ef84e366f6443$var$X(f)) {
            const t = f;
            $754ef84e366f6443$var$H(t.container) || (v = t.container), $754ef84e366f6443$var$H(t.target) || (_ = t.target);
        } else $754ef84e366f6443$var$Y(f) && (v = f);
        const b = $754ef84e366f6443$var$Ms(e, g, d), T = $754ef84e366f6443$var$Ms(e, _, d), S = b + c - u, w = T + c - p, x = $754ef84e366f6443$var$Ms(e, y, u, S, w), C = $754ef84e366f6443$var$Ms(e, v, u, S, w), E = b + c - x, k = T + c - C, $ = k - E;
        this.offset = c, this.offsetStart = E, this.offsetEnd = k, this.distance = $ <= 0 ? 0 : $, this.thresholds = [
            g,
            _,
            y,
            v
        ], this.coords = [
            b,
            T,
            x,
            C
        ], t && t.forEach((t)=>t.revert()), n && n.seek(o, !0), this._debug && this.debug();
    }
    handleScroll() {
        if (!this.ready) return;
        const t = this.linked, e = this.sync, s = this.syncEase, i = this.syncSmooth, r = t && (s || i), n = this.horizontal, o = this.container, a = this.scroll, h = a <= this.offsetStart, l = a >= this.offsetEnd, c = !h && !l, d = a === this.offsetStart || a === this.offsetEnd, u = !this.hasEntered && d, p = this._debug && this.$debug;
        let m = !1, f = !1, g = this.progress;
        if (h && this.began && (this.began = !1), g > 0 && !this.began && (this.began = !0), r) {
            const e = t.progress;
            if (i && $754ef84e366f6443$var$Y(i)) {
                if (i < 1) {
                    const t = 1e-4, s = e < g && 1 === g ? t : e > g && !g ? -t : 0;
                    g = $754ef84e366f6443$var$yt($754ef84e366f6443$var$bt(e, g, $754ef84e366f6443$var$bt(.01, .2, i)) + s, 6);
                }
            } else s && (g = s(g));
            m = g !== this.prevProgress, f = 1 === e, m && !f && i && e && o.wakeTicker.restart();
        }
        if (p) {
            const t = n ? o.scrollY : o.scrollX;
            p.style[n ? "top" : "left"] = t + 10 + "px";
        }
        (c && !this.isInView || u && !this.forceEnter && !this.hasEntered) && (c && (this.isInView = !0), this.forceEnter && this.hasEntered ? c && (this.forceEnter = !1) : (p && c && (p.style.zIndex = "" + this.container.zIndex++), this.onSyncEnter(this), this.onEnter(this), this.backward ? (this.onSyncEnterBackward(this), this.onEnterBackward(this)) : (this.onSyncEnterForward(this), this.onEnterForward(this)), this.hasEntered = !0, u && (this.forceEnter = !0))), (c || !c && this.isInView) && (m = !0), m && (r && t.seek(t.duration * g), this.onUpdate(this)), !c && this.isInView && (this.isInView = !1, this.onSyncLeave(this), this.onLeave(this), this.backward ? (this.onSyncLeaveBackward(this), this.onLeaveBackward(this)) : (this.onSyncLeaveForward(this), this.onLeaveForward(this)), e && !i && (f = !0)), g >= 1 && this.began && !this.completed && (e && f || !e) && (e && this.onSyncComplete(this), this.completed = !0, (!this.repeat && !t || !this.repeat && t && t.completed) && this.revert()), g < 1 && this.completed && (this.completed = !1), this.prevProgress = g;
    }
    revert() {
        if (this.reverted) return;
        const t = this.container;
        return $754ef84e366f6443$var$Et(t, this), t._head || t.revert(), this._debug && this.removeDebug(), this.reverted = !0, this.ready = !1, this;
    }
}
const $754ef84e366f6443$export$d4d89fd61e5416ee = (t = {})=>new $754ef84e366f6443$export$c7cad6b3e396923a(t), $754ef84e366f6443$var$Ys = (t, e, s)=>(((1 - 3 * s + 3 * e) * t + (3 * s - 6 * e)) * t + 3 * e) * t, $754ef84e366f6443$var$Vs = (t, e, s)=>{
    let i, r, n = 0, o = 1, a = 0;
    do r = n + (o - n) / 2, i = $754ef84e366f6443$var$Ys(r, e, s) - t, i > 0 ? o = r : n = r;
    while ($754ef84e366f6443$var$at(i) > 1e-7 && ++a < 100);
    return r;
}, $754ef84e366f6443$export$2c575fa1d20488bd = (t = .5, e = 0, s = .5, i = 1)=>t === e && s === i ? $754ef84e366f6443$var$we : (r)=>0 === r || 1 === r ? r : $754ef84e366f6443$var$Ys($754ef84e366f6443$var$Vs(r, t, s), e, i), $754ef84e366f6443$export$be3f796aed065412 = (t = 10, e)=>{
    const s = e ? $754ef84e366f6443$var$lt : $754ef84e366f6443$var$ct;
    return (e)=>s($754ef84e366f6443$var$gt(e, 0, 1) * t) * (1 / t);
}, $754ef84e366f6443$export$45db2fc2f15997e7 = (...t)=>{
    const e = t.length;
    if (!e) return $754ef84e366f6443$var$we;
    const s = e - 1, i = t[0], r = t[s], n = [
        0
    ], o = [
        $754ef84e366f6443$var$st(i)
    ];
    for(let e = 1; e < s; e++){
        const i = t[e], r = $754ef84e366f6443$var$V(i) ? i.trim().split(" ") : [
            i
        ], a = r[0], h = r[1];
        n.push($754ef84e366f6443$var$H(h) ? e / s : $754ef84e366f6443$var$st(h) / 100), o.push($754ef84e366f6443$var$st(a));
    }
    return o.push($754ef84e366f6443$var$st(r)), n.push(1), function(t) {
        for(let e = 1, s = n.length; e < s; e++){
            const s = n[e];
            if (t <= s) {
                const i = n[e - 1], r = o[e - 1];
                return r + (o[e] - r) * (t - i) / (s - i);
            }
        }
        return o[o.length - 1];
    };
}, $754ef84e366f6443$export$782e2f103b7661ff = (t = 10, e = 1)=>{
    const s = [
        0
    ], i = t - 1;
    for(let t = 1; t < i; t++){
        const r = s[t - 1], n = t / i, o = n * (1 - e) + (n + ((t + 1) / i - n) * Math.random()) * e;
        s.push($754ef84e366f6443$var$gt(o, r, 1));
    }
    return s.push(1), $754ef84e366f6443$export$45db2fc2f15997e7(...s);
};
var $754ef84e366f6443$export$15a0bf1b4bbacad8 = Object.freeze({
    __proto__: null,
    Spring: $754ef84e366f6443$export$a500e5b516cedfc,
    createSpring: $754ef84e366f6443$export$d1f8fcb84651afa9,
    cubicBezier: $754ef84e366f6443$export$2c575fa1d20488bd,
    eases: $754ef84e366f6443$export$4e31f8f121cad154,
    irregular: $754ef84e366f6443$export$782e2f103b7661ff,
    linear: $754ef84e366f6443$export$45db2fc2f15997e7,
    spring: $754ef84e366f6443$export$b36281d89752ae66,
    steps: $754ef84e366f6443$export$be3f796aed065412
});
const $754ef84e366f6443$var$Qs = $754ef84e366f6443$var$fs, $754ef84e366f6443$var$Js = {}, $754ef84e366f6443$var$Zs = (t, e = 0)=>(...s)=>e ? (e)=>t(...s, e) : (e)=>t(e, ...s), $754ef84e366f6443$var$Ks = (t)=>(...e)=>{
        const s = t(...e);
        return new Proxy($754ef84e366f6443$var$S, {
            apply: (t, e, [i])=>s(i),
            get: (t, e)=>$754ef84e366f6443$var$Ks((...t)=>{
                    const i = $754ef84e366f6443$var$Js[e](...t);
                    return (t)=>i(s(t));
                })
        });
    }, $754ef84e366f6443$var$ti = (t, e, s = 0)=>{
    const i = (...t)=>(t.length < e.length ? $754ef84e366f6443$var$Ks($754ef84e366f6443$var$Zs(e, s)) : e)(...t);
    return $754ef84e366f6443$var$Js[t] || ($754ef84e366f6443$var$Js[t] = i), i;
}, $754ef84e366f6443$export$cc435a8ab18fa41f = $754ef84e366f6443$var$ti("roundPad", $754ef84e366f6443$var$Qs.roundPad), $754ef84e366f6443$export$36cf564d487b5178 = $754ef84e366f6443$var$ti("padStart", $754ef84e366f6443$var$Qs.padStart), $754ef84e366f6443$export$23a07ddfce9fad49 = $754ef84e366f6443$var$ti("padEnd", $754ef84e366f6443$var$Qs.padEnd), $754ef84e366f6443$export$4997ffc0176396a6 = $754ef84e366f6443$var$ti("wrap", $754ef84e366f6443$var$Qs.wrap), $754ef84e366f6443$export$f65a7599bbc6b121 = $754ef84e366f6443$var$ti("mapRange", $754ef84e366f6443$var$Qs.mapRange), $754ef84e366f6443$export$e6bfdeff8bfc94f9 = $754ef84e366f6443$var$ti("degToRad", $754ef84e366f6443$var$Qs.degToRad), $754ef84e366f6443$export$54390e3b44c4a9cb = $754ef84e366f6443$var$ti("radToDeg", $754ef84e366f6443$var$Qs.radToDeg), $754ef84e366f6443$export$51a0620f7a28532b = $754ef84e366f6443$var$ti("snap", $754ef84e366f6443$var$Qs.snap), $754ef84e366f6443$export$7d15b64cf5a3a4c4 = $754ef84e366f6443$var$ti("clamp", $754ef84e366f6443$var$Qs.clamp), $754ef84e366f6443$export$2077e0241d6afd3c = $754ef84e366f6443$var$ti("round", $754ef84e366f6443$var$Qs.round), $754ef84e366f6443$export$3a89f8d6f6bf6c9f = $754ef84e366f6443$var$ti("lerp", $754ef84e366f6443$var$Qs.lerp, 1), $754ef84e366f6443$export$f81c1cb84e35b185 = $754ef84e366f6443$var$ti("damp", $754ef84e366f6443$var$Qs.damp, 1), $754ef84e366f6443$export$4385e60b38654f68 = (t = 0, e = 1, s = 0)=>{
    const i = 10 ** s;
    return Math.floor((Math.random() * (e - t + 1 / i) + t) * i) / i;
};
let $754ef84e366f6443$var$mi = 0;
const $754ef84e366f6443$export$7f4f77f59a323cea = (t, e = 0, s = 1, i = 0)=>{
    let r = void 0 === t ? $754ef84e366f6443$var$mi++ : t;
    return (t = e, n = s, o = i)=>{
        r += 1831565813, r = Math.imul(r ^ r >>> 15, 1 | r), r ^= r + Math.imul(r ^ r >>> 7, 61 | r);
        const a = 10 ** o;
        return Math.floor((((r ^ r >>> 14) >>> 0) / 4294967296 * (n - t + 1 / a) + t) * a) / a;
    };
}, $754ef84e366f6443$export$b019216379c7128c = (t)=>t[$754ef84e366f6443$export$4385e60b38654f68(0, t.length - 1)], $754ef84e366f6443$export$448332262467e042 = (t)=>{
    let e, s, i = t.length;
    for(; i;)s = $754ef84e366f6443$export$4385e60b38654f68(0, --i), e = t[i], t[i] = t[s], t[s] = e;
    return t;
}, $754ef84e366f6443$export$ef0b4d89074db4d0 = (t, e = {})=>{
    let s = [], i = 0;
    const r = e.from, n = e.reversed, o = e.ease, a = !$754ef84e366f6443$var$H(o), h = a && !$754ef84e366f6443$var$H(o.ease) ? o.ease : a ? $754ef84e366f6443$var$De(o) : null, l = e.grid, c = e.axis, d = e.total, u = $754ef84e366f6443$var$H(r) || 0 === r || "first" === r, p = "center" === r, m = "last" === r, f = "random" === r, g = $754ef84e366f6443$var$U(t), y = e.use, v = $754ef84e366f6443$var$st(g ? t[0] : t), b = g ? $754ef84e366f6443$var$st(t[1]) : 0, T = $754ef84e366f6443$var$B.exec((g ? t[1] : t) + $754ef84e366f6443$var$_), S = e.start || 0 + (g ? v : 0);
    let w = u ? 0 : $754ef84e366f6443$var$Y(r) ? r : 0;
    return (t, r, o, a)=>{
        const [u] = $754ef84e366f6443$export$3d8c2f653ac9d0b9(t), _ = $754ef84e366f6443$var$H(d) ? o : d, x = !$754ef84e366f6443$var$H(y) && ($754ef84e366f6443$var$W(y) ? y(u, r, _) : $754ef84e366f6443$var$Pt(u, y)), C = $754ef84e366f6443$var$Y(x) || $754ef84e366f6443$var$V(x) && $754ef84e366f6443$var$Y(+x) ? +x : r;
        if (p && (w = (_ - 1) / 2), m && (w = _ - 1), !s.length) {
            for(let t = 0; t < _; t++){
                if (l) {
                    const e = p ? (l[0] - 1) / 2 : w % l[0], i = p ? (l[1] - 1) / 2 : $754ef84e366f6443$var$ct(w / l[0]), r = e - t % l[0], n = i - $754ef84e366f6443$var$ct(t / l[0]);
                    let o = $754ef84e366f6443$var$rt(r * r + n * n);
                    "x" === c && (o = -r), "y" === c && (o = -n), s.push(o);
                } else s.push($754ef84e366f6443$var$at(w - t));
                i = $754ef84e366f6443$var$ut(...s);
            }
            h && (s = s.map((t)=>h(t / i) * i)), n && (s = s.map((t)=>c ? t < 0 ? -1 * t : -t : $754ef84e366f6443$var$at(i - t))), f && (s = $754ef84e366f6443$export$448332262467e042(s));
        }
        const E = g ? (b - v) / i : v;
        let k = (a ? $754ef84e366f6443$var$ts(a, $754ef84e366f6443$var$H(e.start) ? a.iterationDuration : S) : S) + (E * $754ef84e366f6443$var$yt(s[C], 2) || 0);
        return e.modifier && (k = e.modifier(k)), T && (k = `${k}${T[2]}`), k;
    };
};
var $754ef84e366f6443$export$eab97d15b1788b8d = Object.freeze({
    __proto__: null,
    $: $754ef84e366f6443$export$3d8c2f653ac9d0b9,
    clamp: $754ef84e366f6443$export$7d15b64cf5a3a4c4,
    cleanInlineStyles: $754ef84e366f6443$export$a631c64f18a23a10,
    createSeededRandom: $754ef84e366f6443$export$7f4f77f59a323cea,
    damp: $754ef84e366f6443$export$f81c1cb84e35b185,
    degToRad: $754ef84e366f6443$export$e6bfdeff8bfc94f9,
    get: $754ef84e366f6443$export$3988ae62b71be9a3,
    keepTime: $754ef84e366f6443$export$2e6d4caa59927c5e,
    lerp: $754ef84e366f6443$export$3a89f8d6f6bf6c9f,
    mapRange: $754ef84e366f6443$export$f65a7599bbc6b121,
    padEnd: $754ef84e366f6443$export$23a07ddfce9fad49,
    padStart: $754ef84e366f6443$export$36cf564d487b5178,
    radToDeg: $754ef84e366f6443$export$54390e3b44c4a9cb,
    random: $754ef84e366f6443$export$4385e60b38654f68,
    randomPick: $754ef84e366f6443$export$b019216379c7128c,
    remove: $754ef84e366f6443$export$cd7f480d6b8286c3,
    round: $754ef84e366f6443$export$2077e0241d6afd3c,
    roundPad: $754ef84e366f6443$export$cc435a8ab18fa41f,
    set: $754ef84e366f6443$export$adaa4cf7ef1b65be,
    shuffle: $754ef84e366f6443$export$448332262467e042,
    snap: $754ef84e366f6443$export$51a0620f7a28532b,
    stagger: $754ef84e366f6443$export$ef0b4d89074db4d0,
    sync: $754ef84e366f6443$export$92d6409d68f0739a,
    wrap: $754ef84e366f6443$export$4997ffc0176396a6
});
const $754ef84e366f6443$var$bi = (t)=>{
    const e = $754ef84e366f6443$var$ye(t)[0];
    return e && $754ef84e366f6443$var$j(e) ? e : console.warn(`${t} is not a valid SVGGeometryElement`);
}, $754ef84e366f6443$var$Ti = (t, e, s, i, r)=>{
    const n = s + i, o = r ? Math.max(0, Math.min(n, e)) : (n % e + e) % e;
    return t.getPointAtLength(o);
}, $754ef84e366f6443$var$Si = (t, e, s = 0)=>(i)=>{
        const r = +t.getTotalLength(), n = i[$754ef84e366f6443$var$l], o = t.getCTM(), a = 0 === s;
        return {
            from: 0,
            to: r,
            modifier: (i)=>{
                const h = i + s * r;
                if ("a" === e) {
                    const e = $754ef84e366f6443$var$Ti(t, r, h, -1, a), s = $754ef84e366f6443$var$Ti(t, r, h, 1, a);
                    return 180 * $754ef84e366f6443$var$pt(s.y - e.y, s.x - e.x) / $754ef84e366f6443$var$mt;
                }
                {
                    const s = $754ef84e366f6443$var$Ti(t, r, h, 0, a);
                    return "x" === e ? n || !o ? s.x : s.x * o.a + s.y * o.c + o.e : n || !o ? s.y : s.x * o.b + s.y * o.d + o.f;
                }
            }
        };
    }, $754ef84e366f6443$export$6bf0713642051d71 = (t, e = 0)=>{
    const s = $754ef84e366f6443$var$bi(t);
    if (s) return {
        translateX: $754ef84e366f6443$var$Si(s, "x", e),
        translateY: $754ef84e366f6443$var$Si(s, "y", e),
        rotate: $754ef84e366f6443$var$Si(s, "a", e)
    };
}, $754ef84e366f6443$var$xi = (t)=>{
    let e = 1;
    if (t && t.getCTM) {
        const s = t.getCTM();
        s && (e = ($754ef84e366f6443$var$rt(s.a * s.a + s.b * s.b) + $754ef84e366f6443$var$rt(s.c * s.c + s.d * s.d)) / 2);
    }
    return e;
}, $754ef84e366f6443$var$Ci = (t, e, s)=>{
    const i = $754ef84e366f6443$var$f, r = getComputedStyle(t), n = r.strokeLinecap, o = "non-scaling-stroke" === r.vectorEffect ? t : null;
    let a = n;
    const h = new Proxy(t, {
        get (t, e) {
            const s = t[e];
            return e === $754ef84e366f6443$var$u ? t : "setAttribute" === e ? (...e)=>{
                if ("draw" === e[0]) {
                    const s = e[1].split(" "), r = +s[0], h = +s[1], l = $754ef84e366f6443$var$xi(o), c = -1000 * r * l, d = h * i * l + c, u = i * l + (0 === r && 1 === h || 1 === r && 0 === h ? 0 : 10 * l) - d;
                    if ("butt" !== n) {
                        const e = r === h ? "butt" : n;
                        a !== e && (t.style.strokeLinecap = `${e}`, a = e);
                    }
                    t.setAttribute("stroke-dashoffset", `${c}`), t.setAttribute("stroke-dasharray", `${d} ${u}`);
                }
                return Reflect.apply(s, t, e);
            } : $754ef84e366f6443$var$W(s) ? (...e)=>Reflect.apply(s, t, e) : s;
        }
    });
    return "1000" !== t.getAttribute("pathLength") && (t.setAttribute("pathLength", "1000"), h.setAttribute("draw", `${e} ${s}`)), h;
}, $754ef84e366f6443$export$a595dc50edfbb6fe = (t, e = 0, s = 0)=>$754ef84e366f6443$var$ye(t).map((t)=>$754ef84e366f6443$var$Ci(t, e, s)), $754ef84e366f6443$export$e7ab4ae6a89334a9 = (t, e = .33)=>(s)=>{
        if (!(s.tagName || "").toLowerCase().match(/^(path|polygon|polyline)$/)) throw new Error(`Can't morph a <${s.tagName}> SVG element. Use <path>, <polygon> or <polyline>.`);
        const i = $754ef84e366f6443$var$bi(t);
        if (!i) throw new Error("Can't morph to an invalid target. 'path2' must resolve to an existing <path>, <polygon> or <polyline> SVG element.");
        if (!(i.tagName || "").toLowerCase().match(/^(path|polygon|polyline)$/)) throw new Error(`Can't morph a <${i.tagName}> SVG element. Use <path>, <polygon> or <polyline>.`);
        const r = "path" === s.tagName, n = r ? " " : ",", o = s[$754ef84e366f6443$var$d];
        o && s.setAttribute(r ? "d" : "points", o);
        let a = "", h = "";
        if (e) {
            const t = s.getTotalLength(), o = i.getTotalLength(), l = Math.max(Math.ceil(t * e), Math.ceil(o * e));
            for(let e = 0; e < l; e++){
                const c = e / (l - 1), d = s.getPointAtLength(t * c), u = i.getPointAtLength(o * c), p = r ? 0 === e ? "M" : "L" : "";
                a += p + $754ef84e366f6443$var$yt(d.x, 3) + n + d.y + " ", h += p + $754ef84e366f6443$var$yt(u.x, 3) + n + u.y + " ";
            }
        } else a = s.getAttribute(r ? "d" : "points"), h = i.getAttribute(r ? "d" : "points");
        return s[$754ef84e366f6443$var$d] = h, [
            a,
            h
        ];
    };
var $754ef84e366f6443$export$7ed1367e7fa1ad68 = Object.freeze({
    __proto__: null,
    createDrawable: $754ef84e366f6443$export$a595dc50edfbb6fe,
    createMotionPath: $754ef84e366f6443$export$6bf0713642051d71,
    morphTo: $754ef84e366f6443$export$e7ab4ae6a89334a9
});
const $754ef84e366f6443$var$Bi = "undefined" != typeof Intl && Intl.Segmenter, $754ef84e366f6443$var$Oi = /\{value\}/g, $754ef84e366f6443$var$Ni = /\{i\}/g, $754ef84e366f6443$var$Ri = /(\s+)/, $754ef84e366f6443$var$Di = /^\s+$/, $754ef84e366f6443$var$Li = "line", $754ef84e366f6443$var$Ai = "word", $754ef84e366f6443$var$Fi = "char", $754ef84e366f6443$var$Mi = "data-line";
let $754ef84e366f6443$var$Pi = null, $754ef84e366f6443$var$Ii = null, $754ef84e366f6443$var$zi = null;
const $754ef84e366f6443$var$Ui = (t)=>t.isWordLike || " " === t.segment || $754ef84e366f6443$var$Y(+t.segment), $754ef84e366f6443$var$Xi = (t)=>t.setAttribute("aria-hidden", "true"), $754ef84e366f6443$var$Yi = (t, e)=>[
        ...t.querySelectorAll(`[data-${e}]:not([data-${e}] [data-${e}])`)
    ], $754ef84e366f6443$var$Vi = {
    line: "#00D672",
    word: "#FF4B4B",
    char: "#5A87FF"
}, $754ef84e366f6443$var$Wi = (t)=>{
    if (!t.childElementCount && !t.textContent.trim()) {
        const e = t.parentElement;
        t.remove(), e && $754ef84e366f6443$var$Wi(e);
    }
}, $754ef84e366f6443$var$Hi = (t, e, s)=>{
    const i = t.getAttribute($754ef84e366f6443$var$Mi);
    (null !== i && +i !== e || "BR" === t.tagName) && s.add(t);
    let r = t.childElementCount;
    for(; r--;)$754ef84e366f6443$var$Hi(t.children[r], e, s);
    return s;
}, $754ef84e366f6443$var$qi = (t, e = {})=>{
    let s = "";
    const i = $754ef84e366f6443$var$V(e.class) ? ` class="${e.class}"` : "", r = $754ef84e366f6443$var$Lt(e.clone, !1), n = $754ef84e366f6443$var$Lt(e.wrap, !1), o = n ? !0 === n ? "clip" : n : !!r && "clip";
    return n && (s += `<span${o ? ` style="overflow:${o};"` : ""}>`), s += `<span${i}${r ? ' style="position:relative;"' : ""} data-${t}="{i}">`, r ? (s += "<span>{value}</span>", s += `<span inert style="position:absolute;top:${"top" === r ? "-100%" : "bottom" === r ? "100%" : "0"};left:${"left" === r ? "-100%" : "right" === r ? "100%" : "0"};white-space:nowrap;">{value}</span>`) : s += "{value}", s += "</span>", n && (s += "</span>"), s;
}, $754ef84e366f6443$var$ji = (t, e, s, i, r, n, o, a, h)=>{
    const l = r === $754ef84e366f6443$var$Li, c = r === $754ef84e366f6443$var$Fi, d = `_${r}_`, u = $754ef84e366f6443$var$W(t) ? t(s) : t, p = l ? "block" : "inline-block";
    $754ef84e366f6443$var$zi.innerHTML = u.replace($754ef84e366f6443$var$Oi, `<i class="${d}"></i>`).replace($754ef84e366f6443$var$Ni, `${c ? h : l ? o : a}`);
    const m = $754ef84e366f6443$var$zi.content, f = m.firstElementChild, g = m.querySelector(`[data-${r}]`) || f, _ = m.querySelectorAll(`i.${d}`), y = _.length;
    if (y) {
        f.style.display = p, g.style.display = p, g.setAttribute($754ef84e366f6443$var$Mi, `${o}`), l || (g.setAttribute("data-word", `${a}`), c && g.setAttribute("data-char", `${h}`));
        let t = y;
        for(; t--;){
            const e = _[t], i = e.parentElement;
            i.style.display = p, l ? i.innerHTML = s.innerHTML : i.replaceChild(s.cloneNode(!0), e);
        }
        e.push(g), i.appendChild(m);
    } else console.warn('The expression "{value}" is missing from the provided template.');
    return n && (f.style.outline = `1px dotted ${$754ef84e366f6443$var$Vi[r]}`), f;
};
class $754ef84e366f6443$export$d267c32dfbb2bb04 {
    constructor(e, i = {}){
        $754ef84e366f6443$var$Pi || ($754ef84e366f6443$var$Pi = $754ef84e366f6443$var$Bi ? new $754ef84e366f6443$var$Bi([], {
            granularity: $754ef84e366f6443$var$Ai
        }) : {
            segment: (t)=>{
                const e = [], s = t.split($754ef84e366f6443$var$Ri);
                for(let t = 0, i = s.length; t < i; t++){
                    const i = s[t];
                    e.push({
                        segment: i,
                        isWordLike: !$754ef84e366f6443$var$Di.test(i)
                    });
                }
                return e;
            }
        }), $754ef84e366f6443$var$Ii || ($754ef84e366f6443$var$Ii = $754ef84e366f6443$var$Bi ? new $754ef84e366f6443$var$Bi([], {
            granularity: "grapheme"
        }) : {
            segment: (t)=>[
                    ...t
                ].map((t)=>({
                        segment: t
                    }))
        }), !$754ef84e366f6443$var$zi && $754ef84e366f6443$var$t && ($754ef84e366f6443$var$zi = $754ef84e366f6443$var$s.createElement("template")), $754ef84e366f6443$var$A.current && $754ef84e366f6443$var$A.current.register(this);
        const { words: r, chars: n, lines: o, accessible: a, includeSpaces: h, debug: l } = i, c = (e = $754ef84e366f6443$var$U(e) ? e[0] : e) && e.nodeType ? e : ($754ef84e366f6443$var$_e(e) || [])[0], d = !0 === o ? {} : o, u = !0 === r || $754ef84e366f6443$var$H(r) ? {} : r, p = !0 === n ? {} : n;
        this.debug = $754ef84e366f6443$var$Lt(l, !1), this.includeSpaces = $754ef84e366f6443$var$Lt(h, !1), this.accessible = $754ef84e366f6443$var$Lt(a, !0), this.linesOnly = d && !u && !p, this.lineTemplate = $754ef84e366f6443$var$X(d) ? $754ef84e366f6443$var$qi($754ef84e366f6443$var$Li, d) : d, this.wordTemplate = $754ef84e366f6443$var$X(u) || this.linesOnly ? $754ef84e366f6443$var$qi($754ef84e366f6443$var$Ai, u) : u, this.charTemplate = $754ef84e366f6443$var$X(p) ? $754ef84e366f6443$var$qi($754ef84e366f6443$var$Fi, p) : p, this.$target = c, this.html = c && c.innerHTML, this.lines = [], this.words = [], this.chars = [], this.effects = [], this.effectsCleanups = [], this.cache = null, this.ready = !1, this.width = 0, this.resizeTimeout = null;
        const m = ()=>this.html && (d || u || p) && this.split();
        this.resizeObserver = new ResizeObserver(()=>{
            clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(()=>{
                const t = c.offsetWidth;
                t !== this.width && (this.width = t, m());
            }, 150);
        }), this.lineTemplate && !this.ready ? $754ef84e366f6443$var$s.fonts.ready.then(m) : m(), c ? this.resizeObserver.observe(c) : console.warn("No Text Splitter target found.");
    }
    addEffect(t) {
        if (!$754ef84e366f6443$var$W(t)) return console.warn("Effect must return a function.");
        const e = $754ef84e366f6443$export$2e6d4caa59927c5e(t);
        return this.effects.push(e), this.ready && (this.effectsCleanups[this.effects.length - 1] = e(this)), this;
    }
    revert() {
        return clearTimeout(this.resizeTimeout), this.lines.length = this.words.length = this.chars.length = 0, this.resizeObserver.disconnect(), this.effectsCleanups.forEach((t)=>$754ef84e366f6443$var$W(t) ? t(this) : t.revert && t.revert()), this.$target.innerHTML = this.html, this;
    }
    splitNode(t) {
        const e = this.wordTemplate, i = this.charTemplate, r = this.includeSpaces, n = this.debug, o = t.nodeType;
        if (3 === o) {
            const o = t.nodeValue;
            if (o.trim()) {
                const a = [], h = this.words, l = this.chars, c = $754ef84e366f6443$var$Pi.segment(o), d = $754ef84e366f6443$var$s.createDocumentFragment();
                let u = null;
                for (const t of c){
                    const e = t.segment, s = $754ef84e366f6443$var$Ui(t);
                    if (!u || s && u && $754ef84e366f6443$var$Ui(u)) a.push(e);
                    else {
                        const t = a.length - 1;
                        a[t].includes(" ") || e.includes(" ") ? a.push(e) : a[t] += e;
                    }
                    u = t;
                }
                for(let t = 0, o = a.length; t < o; t++){
                    const o = a[t];
                    if (o.trim()) {
                        const c = a[t + 1], u = r && c && !c.trim(), p = o, m = i ? $754ef84e366f6443$var$Ii.segment(p) : null, f = i ? $754ef84e366f6443$var$s.createDocumentFragment() : $754ef84e366f6443$var$s.createTextNode(u ? o + "\xa0" : o);
                        if (i) {
                            const t = [
                                ...m
                            ];
                            for(let e = 0, r = t.length; e < r; e++){
                                const o = t[e], a = e === r - 1 && u ? o.segment + "\xa0" : o.segment, c = $754ef84e366f6443$var$s.createTextNode(a);
                                $754ef84e366f6443$var$ji(i, l, c, f, $754ef84e366f6443$var$Fi, n, -1, h.length, l.length);
                            }
                        }
                        e ? $754ef84e366f6443$var$ji(e, h, f, d, $754ef84e366f6443$var$Ai, n, -1, h.length, l.length) : i ? d.appendChild(f) : d.appendChild($754ef84e366f6443$var$s.createTextNode(o)), u && t++;
                    } else {
                        if (t && r) continue;
                        d.appendChild($754ef84e366f6443$var$s.createTextNode(o));
                    }
                }
                t.parentNode.replaceChild(d, t);
            }
        } else if (1 === o) {
            const e = [
                ...t.childNodes
            ];
            for(let t = 0, s = e.length; t < s; t++)this.splitNode(e[t]);
        }
    }
    split(t = !1) {
        const e = this.$target, i = !!this.cache && !t, r = this.lineTemplate, n = this.wordTemplate, o = this.charTemplate, a = "loading" !== $754ef84e366f6443$var$s.fonts.status, h = r && a;
        this.ready = !r || a, (h || t) && this.effectsCleanups.forEach((t)=>$754ef84e366f6443$var$W(t) && t(this)), i || (t && (e.innerHTML = this.html, this.words.length = this.chars.length = 0), this.splitNode(e), this.cache = e.innerHTML), h && (i && (e.innerHTML = this.cache), this.lines.length = 0, n && (this.words = $754ef84e366f6443$var$Yi(e, $754ef84e366f6443$var$Ai))), o && (h || n) && (this.chars = $754ef84e366f6443$var$Yi(e, $754ef84e366f6443$var$Fi));
        const l = this.words.length ? this.words : this.chars;
        let c, d = 0;
        for(let t = 0, e = l.length; t < e; t++){
            const e = l[t], { top: s, height: i } = e.getBoundingClientRect();
            c && s - c > .5 * i && d++, e.setAttribute($754ef84e366f6443$var$Mi, `${d}`);
            const r = e.querySelectorAll(`[${$754ef84e366f6443$var$Mi}]`);
            let n = r.length;
            for(; n--;)r[n].setAttribute($754ef84e366f6443$var$Mi, `${d}`);
            c = s;
        }
        if (h) {
            const t = $754ef84e366f6443$var$s.createDocumentFragment(), i = new Set, a = [];
            for(let t = 0; t < d + 1; t++){
                const s = e.cloneNode(!0);
                $754ef84e366f6443$var$Hi(s, t, new Set).forEach((t)=>{
                    const e = t.parentElement;
                    e && i.add(e), t.remove();
                }), a.push(s);
            }
            i.forEach($754ef84e366f6443$var$Wi);
            for(let e = 0, s = a.length; e < s; e++)$754ef84e366f6443$var$ji(r, this.lines, a[e], t, $754ef84e366f6443$var$Li, this.debug, e);
            e.innerHTML = "", e.appendChild(t), n && (this.words = $754ef84e366f6443$var$Yi(e, $754ef84e366f6443$var$Ai)), o && (this.chars = $754ef84e366f6443$var$Yi(e, $754ef84e366f6443$var$Fi));
        }
        if (this.linesOnly) {
            const t = this.words;
            let e = t.length;
            for(; e--;){
                const s = t[e];
                s.replaceWith(s.textContent);
            }
            t.length = 0;
        }
        if (this.accessible && (h || !i)) {
            const t = $754ef84e366f6443$var$s.createElement("span");
            t.style.cssText = "position:absolute;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);width:1px;height:1px;white-space:nowrap;", t.innerHTML = this.html, e.insertBefore(t, e.firstChild), this.lines.forEach($754ef84e366f6443$var$Xi), this.words.forEach($754ef84e366f6443$var$Xi), this.chars.forEach($754ef84e366f6443$var$Xi);
        }
        return this.width = e.offsetWidth, (h || t) && this.effects.forEach((t, e)=>this.effectsCleanups[e] = t(this)), this;
    }
    refresh() {
        this.split(!0);
    }
}
const $754ef84e366f6443$export$2878cc467c8be8fe = (t, e)=>new $754ef84e366f6443$export$d267c32dfbb2bb04(t, e), $754ef84e366f6443$export$65980d18b75784e2 = (t, e)=>(console.warn("text.split() is deprecated, import splitText() directly, or text.splitText()"), new $754ef84e366f6443$export$d267c32dfbb2bb04(t, e));
var $754ef84e366f6443$export$6f093cfa640b7166 = Object.freeze({
    __proto__: null,
    TextSplitter: $754ef84e366f6443$export$d267c32dfbb2bb04,
    split: $754ef84e366f6443$export$65980d18b75784e2,
    splitText: $754ef84e366f6443$export$2878cc467c8be8fe
});
const $754ef84e366f6443$var$Ki = (t, e = 100)=>{
    const s = [];
    for(let i = 0; i <= e; i++)s.push($754ef84e366f6443$var$yt(t(i / e), 4));
    return `linear(${s.join(", ")})`;
}, $754ef84e366f6443$var$tr = {}, $754ef84e366f6443$var$er = (t)=>{
    let e = $754ef84e366f6443$var$tr[t];
    if (e) return e;
    if (e = "linear", $754ef84e366f6443$var$V(t)) {
        if ($754ef84e366f6443$var$I(t, "linear") || $754ef84e366f6443$var$I(t, "cubic-") || $754ef84e366f6443$var$I(t, "steps") || $754ef84e366f6443$var$I(t, "ease")) e = t;
        else if ($754ef84e366f6443$var$I(t, "cubicB")) e = $754ef84e366f6443$var$P(t);
        else {
            const s = $754ef84e366f6443$var$Ne(t);
            $754ef84e366f6443$var$W(s) && (e = s === $754ef84e366f6443$var$we ? "linear" : $754ef84e366f6443$var$Ki(s));
        }
        $754ef84e366f6443$var$tr[t] = e;
    } else if ($754ef84e366f6443$var$W(t)) {
        const s = $754ef84e366f6443$var$Ki(t);
        s && (e = s);
    } else t.ease && (e = $754ef84e366f6443$var$Ki(t.ease));
    return e;
}, $754ef84e366f6443$var$sr = [
    "x",
    "y",
    "z"
], $754ef84e366f6443$var$ir = [
    "perspective",
    "width",
    "height",
    "margin",
    "padding",
    "top",
    "right",
    "bottom",
    "left",
    "borderWidth",
    "fontSize",
    "borderRadius",
    ...$754ef84e366f6443$var$sr
], $754ef84e366f6443$var$rr = (()=>[
        ...$754ef84e366f6443$var$sr,
        ...$754ef84e366f6443$var$b.filter((t)=>[
                "X",
                "Y",
                "Z"
            ].some((e)=>t.endsWith(e)))
    ])();
let $754ef84e366f6443$var$nr = null;
const $754ef84e366f6443$var$or = (t, e, s, i, r)=>{
    let n = $754ef84e366f6443$var$V(e) ? e : $754ef84e366f6443$var$At(e, s, i, r);
    return $754ef84e366f6443$var$Y(n) ? $754ef84e366f6443$var$ir.includes(t) || $754ef84e366f6443$var$I(t, "translate") ? `${n}px` : $754ef84e366f6443$var$I(t, "rotate") || $754ef84e366f6443$var$I(t, "skew") ? `${n}deg` : `${n}` : n;
}, $754ef84e366f6443$var$ar = (t, e, s, i, r, n)=>{
    let o = "0";
    const a = $754ef84e366f6443$var$H(i) ? getComputedStyle(t)[e] : $754ef84e366f6443$var$or(e, i, t, r, n);
    return o = $754ef84e366f6443$var$H(s) ? $754ef84e366f6443$var$U(i) ? i.map((s)=>$754ef84e366f6443$var$or(e, s, t, r, n)) : a : [
        $754ef84e366f6443$var$or(e, s, t, r, n),
        a
    ], o;
};
class $754ef84e366f6443$export$bd52015f763d6a7c {
    constructor(e, s){
        $754ef84e366f6443$var$A.current && $754ef84e366f6443$var$A.current.register(this), $754ef84e366f6443$var$q($754ef84e366f6443$var$nr) && (!$754ef84e366f6443$var$t || !$754ef84e366f6443$var$H(CSS) && Object.hasOwnProperty.call(CSS, "registerProperty") ? ($754ef84e366f6443$var$b.forEach((t)=>{
            const e = $754ef84e366f6443$var$I(t, "skew"), s = $754ef84e366f6443$var$I(t, "scale"), i = $754ef84e366f6443$var$I(t, "rotate"), r = $754ef84e366f6443$var$I(t, "translate"), n = i || e, o = n ? "<angle>" : s ? "<number>" : r ? "<length-percentage>" : "*";
            try {
                CSS.registerProperty({
                    name: "--" + t,
                    syntax: o,
                    inherits: !1,
                    initialValue: r ? "0px" : n ? "0deg" : s ? "1" : "0"
                });
            } catch  {}
        }), $754ef84e366f6443$var$nr = !0) : $754ef84e366f6443$var$nr = !1);
        const i = $754ef84e366f6443$export$3d8c2f653ac9d0b9(e), r = i.length;
        r || console.warn("No target found. Make sure the element you're trying to animate is accessible before creating your animation.");
        const n = $754ef84e366f6443$var$Lt(s.ease, $754ef84e366f6443$var$er($754ef84e366f6443$var$F.defaults.ease)), o = n.ease && n, a = $754ef84e366f6443$var$Lt(s.autoplay, $754ef84e366f6443$var$F.defaults.autoplay), h = !(!a || !a.link) && a, l = s.alternate && !0 === s.alternate, d = s.reversed && !0 === s.reversed, u = $754ef84e366f6443$var$Lt(s.loop, $754ef84e366f6443$var$F.defaults.loop), p = !0 === u || u === 1 / 0 ? 1 / 0 : $754ef84e366f6443$var$Y(u) ? u + 1 : 1, m = l ? d ? "alternate-reverse" : "alternate" : d ? "reverse" : "normal", g = $754ef84e366f6443$var$er(n), y = 1 === $754ef84e366f6443$var$F.timeScale ? 1 : $754ef84e366f6443$var$f;
        this.targets = i, this.animations = [], this.controlAnimation = null, this.onComplete = s.onComplete || $754ef84e366f6443$var$F.defaults.onComplete, this.duration = 0, this.muteCallbacks = !1, this.completed = !1, this.paused = !a || !1 !== h, this.reversed = d, this.persist = $754ef84e366f6443$var$Lt(s.persist, $754ef84e366f6443$var$F.defaults.persist), this.autoplay = a, this._speed = $754ef84e366f6443$var$Lt(s.playbackRate, $754ef84e366f6443$var$F.defaults.playbackRate), this._resolve = $754ef84e366f6443$var$S, this._completed = 0, this._inlineStyles = [], i.forEach((t, e)=>{
            const i = t[$754ef84e366f6443$var$c], a = $754ef84e366f6443$var$rr.some((t)=>s.hasOwnProperty(t)), h = t.style, l = this._inlineStyles[e] = {}, d = (o ? o.settlingDuration : $754ef84e366f6443$var$At($754ef84e366f6443$var$Lt(s.duration, $754ef84e366f6443$var$F.defaults.duration), t, e, r)) * y, u = $754ef84e366f6443$var$At($754ef84e366f6443$var$Lt(s.delay, $754ef84e366f6443$var$F.defaults.delay), t, e, r) * y, f = $754ef84e366f6443$var$Lt(s.composition, "replace");
            for(let o in s){
                if (!$754ef84e366f6443$var$K(o)) continue;
                const c = {}, _ = {
                    iterations: p,
                    direction: m,
                    fill: "both",
                    easing: g,
                    duration: d,
                    delay: u,
                    composite: f
                }, T = s[o], S = !!a && ($754ef84e366f6443$var$b.includes(o) ? o : $754ef84e366f6443$var$v.get(o)), w = S ? "transform" : o;
                let x;
                if (l[w] || (l[w] = h[w]), $754ef84e366f6443$var$X(T)) {
                    const s = T, a = $754ef84e366f6443$var$Lt(s.ease, n), l = a.ease && a, p = s.to, m = s.from;
                    if (_.duration = (l ? l.settlingDuration : $754ef84e366f6443$var$At($754ef84e366f6443$var$Lt(s.duration, d), t, e, r)) * y, _.delay = $754ef84e366f6443$var$At($754ef84e366f6443$var$Lt(s.delay, u), t, e, r) * y, _.composite = $754ef84e366f6443$var$Lt(s.composition, f), _.easing = $754ef84e366f6443$var$er(a), x = $754ef84e366f6443$var$ar(t, o, m, p, e, r), S ? (c[`--${S}`] = x, i[S] = x) : c[o] = $754ef84e366f6443$var$ar(t, o, m, p, e, r), $754ef84e366f6443$var$Ge(this, t, o, c, _), !$754ef84e366f6443$var$H(m)) {
                        if (S) {
                            const t = `--${S}`;
                            h.setProperty(t, c[t][0]);
                        } else h[o] = c[o][0];
                    }
                } else x = $754ef84e366f6443$var$U(T) ? T.map((s)=>$754ef84e366f6443$var$or(o, s, t, e, r)) : $754ef84e366f6443$var$or(o, T, t, e, r), S ? (c[`--${S}`] = x, i[S] = x) : c[o] = x, $754ef84e366f6443$var$Ge(this, t, o, c, _);
            }
            if (a) {
                let t = $754ef84e366f6443$var$_;
                for(let e in i)t += `${$754ef84e366f6443$var$T[e]}var(--${e})) `;
                h.transform = t;
            }
        }), h && this.autoplay.link(this);
    }
    forEach(t) {
        const e = $754ef84e366f6443$var$V(t) ? (e)=>e[t]() : t;
        return this.animations.forEach(e), this;
    }
    get speed() {
        return this._speed;
    }
    set speed(t) {
        this._speed = +t, this.forEach((e)=>e.playbackRate = t);
    }
    get currentTime() {
        const t = this.controlAnimation, e = $754ef84e366f6443$var$F.timeScale;
        return this.completed ? this.duration : t ? +t.currentTime * (1 === e ? 1 : e) : 0;
    }
    set currentTime(t) {
        const e = t * (1 === $754ef84e366f6443$var$F.timeScale ? 1 : $754ef84e366f6443$var$f);
        this.forEach((t)=>{
            !this.persist && e >= this.duration && t.play(), t.currentTime = e;
        });
    }
    get progress() {
        return this.currentTime / this.duration;
    }
    set progress(t) {
        this.forEach((e)=>e.currentTime = t * this.duration || 0);
    }
    resume() {
        return this.paused ? (this.paused = !1, this.forEach("play")) : this;
    }
    pause() {
        return this.paused ? this : (this.paused = !0, this.forEach("pause"));
    }
    alternate() {
        return this.reversed = !this.reversed, this.forEach("reverse"), this.paused && this.forEach("pause"), this;
    }
    play() {
        return this.reversed && this.alternate(), this.resume();
    }
    reverse() {
        return this.reversed || this.alternate(), this.resume();
    }
    seek(t, e = !1) {
        return e && (this.muteCallbacks = !0), t < this.duration && (this.completed = !1), this.currentTime = t, this.muteCallbacks = !1, this.paused && this.pause(), this;
    }
    restart() {
        return this.completed = !1, this.seek(0, !0).resume();
    }
    commitStyles() {
        return this.forEach("commitStyles");
    }
    complete() {
        return this.seek(this.duration);
    }
    cancel() {
        return this.muteCallbacks = !0, this.commitStyles().forEach("cancel");
    }
    revert() {
        return this.cancel().targets.forEach((t, e)=>{
            const s = t.style, i = this._inlineStyles[e];
            for(let t in i){
                const e = i[t];
                $754ef84e366f6443$var$H(e) || e === $754ef84e366f6443$var$_ ? s.removeProperty($754ef84e366f6443$var$P(t)) : s[t] = e;
            }
            t.getAttribute("style") === $754ef84e366f6443$var$_ && t.removeAttribute("style");
        }), this;
    }
    then(t = $754ef84e366f6443$var$S) {
        const e = this.then, s = ()=>{
            this.then = null, t(this), this.then = e, this._resolve = $754ef84e366f6443$var$S;
        };
        return new Promise((t)=>(this._resolve = ()=>t(s()), this.completed && this._resolve(), this));
    }
}
const $754ef84e366f6443$export$faed09ee618cb0cd = {
    animate: (t, e)=>new $754ef84e366f6443$export$bd52015f763d6a7c(t, e),
    convertEase: $754ef84e366f6443$var$Ki
};



var $hqDLR = parcelRequire("hqDLR");
var $3109557b1311d94a$exports = {};

/* The MIT License (MIT)

Copyright (c) 2014-2015 Benoit Tremblay <trembl.ben@gmail.com>

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */ /*global define, YT*/ (function(root, factory) {
    var videojs = (parcelRequire("hqDLR"));
    $3109557b1311d94a$exports = factory(videojs.default || videojs);
})($3109557b1311d94a$exports, function(videojs) {
    'use strict';
    var _isOnMobile = videojs.browser.IS_IOS || videojs.browser.IS_NATIVE_ANDROID;
    var Tech = videojs.getTech('Tech');
    class Youtube extends Tech {
        constructor(options, ready){
            super(options, ready);
            this.setPoster(options.poster);
            this.setSrc(this.options_.source, true);
            // Set the vjs-youtube class to the player
            // Parent is not set yet so we have to wait a tick
            this.setTimeout((function() {
                if (this.el_) {
                    this.el_.parentNode.className += ' vjs-youtube';
                    if (_isOnMobile) this.el_.parentNode.className += ' vjs-youtube-mobile';
                    if (Youtube.isApiReady) this.initYTPlayer();
                    else Youtube.apiReadyQueue.push(this);
                }
            }).bind(this));
        }
        dispose() {
            if (this.ytPlayer) {
                //Dispose of the YouTube Player
                if (this.ytPlayer.stopVideo) this.ytPlayer.stopVideo();
                if (this.ytPlayer.destroy) this.ytPlayer.destroy();
            } else {
                //YouTube API hasn't finished loading or the player is already disposed
                var index = Youtube.apiReadyQueue.indexOf(this);
                if (index !== -1) Youtube.apiReadyQueue.splice(index, 1);
            }
            this.ytPlayer = null;
            this.el_.parentNode.className = this.el_.parentNode.className.replace(' vjs-youtube', '').replace(' vjs-youtube-mobile', '');
            this.el_.parentNode.removeChild(this.el_);
            //Needs to be called after the YouTube player is destroyed, otherwise there will be a null reference exception
            Tech.prototype.dispose.call(this);
        }
        createEl() {
            var div = document.createElement('div');
            div.setAttribute('id', this.options_.techId);
            div.setAttribute('style', 'width:100%;height:100%;top:0;left:0;position:absolute');
            div.setAttribute('class', 'vjs-tech');
            var divWrapper = document.createElement('div');
            divWrapper.appendChild(div);
            if (!_isOnMobile && !this.options_.ytControls) {
                var divBlocker = document.createElement('div');
                divBlocker.setAttribute('class', 'vjs-iframe-blocker');
                divBlocker.setAttribute('style', 'position:absolute;top:0;left:0;width:100%;height:100%');
                // In case the blocker is still there and we want to pause
                divBlocker.onclick = (function() {
                    this.pause();
                }).bind(this);
                divWrapper.appendChild(divBlocker);
            }
            return divWrapper;
        }
        initYTPlayer() {
            var playerVars = {
                controls: 0,
                modestbranding: 1,
                rel: 0,
                showinfo: 0,
                loop: this.options_.loop ? 1 : 0
            };
            // Let the user set any YouTube parameter
            // https://developers.google.com/youtube/player_parameters?playerVersion=HTML5#Parameters
            // To use YouTube controls, you must use ytControls instead
            // To use the loop or autoplay, use the video.js settings
            if (typeof this.options_.autohide !== 'undefined') playerVars.autohide = this.options_.autohide;
            if (typeof this.options_['cc_load_policy'] !== 'undefined') playerVars['cc_load_policy'] = this.options_['cc_load_policy'];
            if (typeof this.options_.ytControls !== 'undefined') playerVars.controls = this.options_.ytControls;
            if (typeof this.options_.disablekb !== 'undefined') playerVars.disablekb = this.options_.disablekb;
            if (typeof this.options_.color !== 'undefined') playerVars.color = this.options_.color;
            if (!playerVars.controls) // Let video.js handle the fullscreen unless it is the YouTube native controls
            playerVars.fs = 0;
            else if (typeof this.options_.fs !== 'undefined') playerVars.fs = this.options_.fs;
            if (this.options_.source.src.indexOf('end=') !== -1) {
                var srcEndTime = this.options_.source.src.match(/end=([0-9]*)/);
                this.options_.end = parseInt(srcEndTime[1]);
            }
            if (typeof this.options_.end !== 'undefined') playerVars.end = this.options_.end;
            if (typeof this.options_.hl !== 'undefined') playerVars.hl = this.options_.hl;
            else if (typeof this.options_.language !== 'undefined') // Set the YouTube player on the same language than video.js
            playerVars.hl = this.options_.language.substr(0, 2);
            if (typeof this.options_['iv_load_policy'] !== 'undefined') playerVars['iv_load_policy'] = this.options_['iv_load_policy'];
            if (typeof this.options_.list !== 'undefined') playerVars.list = this.options_.list;
            else if (this.url && typeof this.url.listId !== 'undefined') playerVars.list = this.url.listId;
            if (typeof this.options_.listType !== 'undefined') playerVars.listType = this.options_.listType;
            if (typeof this.options_.modestbranding !== 'undefined') playerVars.modestbranding = this.options_.modestbranding;
            if (typeof this.options_.playlist !== 'undefined') playerVars.playlist = this.options_.playlist;
            if (typeof this.options_.playsinline !== 'undefined') playerVars.playsinline = this.options_.playsinline;
            if (typeof this.options_.rel !== 'undefined') playerVars.rel = this.options_.rel;
            if (typeof this.options_.showinfo !== 'undefined') playerVars.showinfo = this.options_.showinfo;
            if (this.options_.source.src.indexOf('start=') !== -1) {
                var srcStartTime = this.options_.source.src.match(/start=([0-9]*)/);
                this.options_.start = parseInt(srcStartTime[1]);
            }
            if (typeof this.options_.start !== 'undefined') playerVars.start = this.options_.start;
            if (typeof this.options_.theme !== 'undefined') playerVars.theme = this.options_.theme;
            // Allow undocumented options to be passed along via customVars
            if (typeof this.options_.customVars !== 'undefined') {
                var customVars = this.options_.customVars;
                Object.keys(customVars).forEach(function(key) {
                    playerVars[key] = customVars[key];
                });
            }
            this.activeVideoId = this.url ? this.url.videoId : null;
            this.activeList = playerVars.list;
            var playerConfig = {
                videoId: this.activeVideoId,
                playerVars: playerVars,
                events: {
                    onReady: this.onPlayerReady.bind(this),
                    onPlaybackQualityChange: this.onPlayerPlaybackQualityChange.bind(this),
                    onPlaybackRateChange: this.onPlayerPlaybackRateChange.bind(this),
                    onStateChange: this.onPlayerStateChange.bind(this),
                    onVolumeChange: this.onPlayerVolumeChange.bind(this),
                    onError: this.onPlayerError.bind(this)
                }
            };
            if (typeof this.options_.enablePrivacyEnhancedMode !== 'undefined' && this.options_.enablePrivacyEnhancedMode) playerConfig.host = 'https://www.youtube-nocookie.com';
            this.ytPlayer = new YT.Player(this.options_.techId, playerConfig);
        }
        onPlayerReady() {
            if (this.options_.muted) this.ytPlayer.mute();
            var playbackRates = this.ytPlayer.getAvailablePlaybackRates();
            if (playbackRates.length > 1) this.featuresPlaybackRate = true;
            this.playerReady_ = true;
            this.triggerReady();
            if (this.playOnReady) this.play();
            else if (this.cueOnReady) {
                this.cueVideoById_(this.url.videoId);
                this.activeVideoId = this.url.videoId;
            }
        }
        onPlayerPlaybackQualityChange() {}
        onPlayerPlaybackRateChange() {
            this.trigger('ratechange');
        }
        onPlayerStateChange(e) {
            var state = e.data;
            if (state === this.lastState || this.errorNumber) return;
            this.lastState = state;
            switch(state){
                case -1:
                    this.trigger('loadstart');
                    this.trigger('loadedmetadata');
                    this.trigger('durationchange');
                    this.trigger('ratechange');
                    break;
                case YT.PlayerState.ENDED:
                    this.trigger('ended');
                    break;
                case YT.PlayerState.PLAYING:
                    this.trigger('timeupdate');
                    this.trigger('durationchange');
                    this.trigger('playing');
                    this.trigger('play');
                    if (this.isSeeking) this.onSeeked();
                    break;
                case YT.PlayerState.PAUSED:
                    this.trigger('canplay');
                    if (this.isSeeking) this.onSeeked();
                    else this.trigger('pause');
                    break;
                case YT.PlayerState.BUFFERING:
                    this.player_.trigger('timeupdate');
                    this.player_.trigger('waiting');
                    break;
            }
        }
        onPlayerVolumeChange() {
            this.trigger('volumechange');
        }
        onPlayerError(e) {
            this.errorNumber = e.data;
            this.trigger('pause');
            this.trigger('error');
        }
        error() {
            var code = 1000 + this.errorNumber; // as smaller codes are reserved
            switch(this.errorNumber){
                case 5:
                    return {
                        code: code,
                        message: 'Error while trying to play the video'
                    };
                case 2:
                case 100:
                    return {
                        code: code,
                        message: 'Unable to find the video'
                    };
                case 101:
                case 150:
                    return {
                        code: code,
                        message: 'Playback on other Websites has been disabled by the video owner.'
                    };
            }
            return {
                code: code,
                message: 'YouTube unknown error (' + this.errorNumber + ')'
            };
        }
        loadVideoById_(id) {
            var options = {
                videoId: id
            };
            if (this.options_.start) options.startSeconds = this.options_.start;
            if (this.options_.end) options.endSeconds = this.options_.end;
            this.ytPlayer.loadVideoById(options);
        }
        cueVideoById_(id) {
            var options = {
                videoId: id
            };
            if (this.options_.start) options.startSeconds = this.options_.start;
            if (this.options_.end) options.endSeconds = this.options_.end;
            this.ytPlayer.cueVideoById(options);
        }
        src(src) {
            if (src) this.setSrc({
                src: src
            });
            return this.source;
        }
        poster() {
            // You can't start programmaticlly a video with a mobile
            // through the iframe so we hide the poster and the play button (with CSS)
            if (_isOnMobile) return null;
            return this.poster_;
        }
        setPoster(poster) {
            this.poster_ = poster;
        }
        setSrc(source) {
            if (!source || !source.src) return;
            delete this.errorNumber;
            this.source = source;
            this.url = Youtube.parseUrl(source.src);
            if (!this.options_.poster) {
                if (this.url.videoId) {
                    // Set the low resolution first
                    this.poster_ = 'https://img.youtube.com/vi/' + this.url.videoId + '/0.jpg';
                    this.trigger('posterchange');
                    // Check if their is a high res
                    this.checkHighResPoster();
                }
            }
            if (this.options_.autoplay && !_isOnMobile) {
                if (this.isReady_) this.play();
                else this.playOnReady = true;
            } else if (this.activeVideoId !== this.url.videoId) {
                if (this.isReady_) {
                    this.cueVideoById_(this.url.videoId);
                    this.activeVideoId = this.url.videoId;
                } else this.cueOnReady = true;
            }
        }
        autoplay() {
            return this.options_.autoplay;
        }
        setAutoplay(val) {
            this.options_.autoplay = val;
        }
        loop() {
            return this.options_.loop;
        }
        setLoop(val) {
            this.options_.loop = val;
        }
        play() {
            if (!this.url || !this.url.videoId) return;
            this.wasPausedBeforeSeek = false;
            if (this.isReady_) {
                if (this.url.listId) {
                    if (this.activeList === this.url.listId) this.ytPlayer.playVideo();
                    else {
                        this.ytPlayer.loadPlaylist(this.url.listId);
                        this.activeList = this.url.listId;
                    }
                }
                if (this.activeVideoId === this.url.videoId) this.ytPlayer.playVideo();
                else {
                    this.loadVideoById_(this.url.videoId);
                    this.activeVideoId = this.url.videoId;
                }
            } else {
                this.trigger('waiting');
                this.playOnReady = true;
            }
        }
        pause() {
            if (this.ytPlayer) this.ytPlayer.pauseVideo();
        }
        paused() {
            return this.ytPlayer ? this.lastState !== YT.PlayerState.PLAYING && this.lastState !== YT.PlayerState.BUFFERING : true;
        }
        currentTime() {
            return this.ytPlayer ? this.ytPlayer.getCurrentTime() : 0;
        }
        setCurrentTime(seconds) {
            if (this.lastState === YT.PlayerState.PAUSED) this.timeBeforeSeek = this.currentTime();
            if (!this.isSeeking) this.wasPausedBeforeSeek = this.paused();
            this.ytPlayer.seekTo(seconds, true);
            this.trigger('timeupdate');
            this.trigger('seeking');
            this.isSeeking = true;
            // A seek event during pause does not return an event to trigger a seeked event,
            // so run an interval timer to look for the currentTime to change
            if (this.lastState === YT.PlayerState.PAUSED && this.timeBeforeSeek !== seconds) {
                clearInterval(this.checkSeekedInPauseInterval);
                this.checkSeekedInPauseInterval = setInterval((function() {
                    if (this.lastState !== YT.PlayerState.PAUSED || !this.isSeeking) // If something changed while we were waiting for the currentTime to change,
                    //  clear the interval timer
                    clearInterval(this.checkSeekedInPauseInterval);
                    else if (this.currentTime() !== this.timeBeforeSeek) {
                        this.trigger('timeupdate');
                        this.onSeeked();
                    }
                }).bind(this), 250);
            }
        }
        seeking() {
            return this.isSeeking;
        }
        seekable() {
            if (!this.ytPlayer) return videojs.createTimeRange();
            return videojs.createTimeRange(0, this.ytPlayer.getDuration());
        }
        onSeeked() {
            clearInterval(this.checkSeekedInPauseInterval);
            this.isSeeking = false;
            if (this.wasPausedBeforeSeek) this.pause();
            this.trigger('seeked');
        }
        playbackRate() {
            return this.ytPlayer ? this.ytPlayer.getPlaybackRate() : 1;
        }
        setPlaybackRate(suggestedRate) {
            if (!this.ytPlayer) return;
            this.ytPlayer.setPlaybackRate(suggestedRate);
        }
        duration() {
            return this.ytPlayer ? this.ytPlayer.getDuration() : 0;
        }
        currentSrc() {
            return this.source && this.source.src;
        }
        ended() {
            return this.ytPlayer ? this.lastState === YT.PlayerState.ENDED : false;
        }
        volume() {
            return this.ytPlayer ? this.ytPlayer.getVolume() / 100.0 : 1;
        }
        setVolume(percentAsDecimal) {
            if (!this.ytPlayer) return;
            this.ytPlayer.setVolume(percentAsDecimal * 100.0);
        }
        muted() {
            return this.ytPlayer ? this.ytPlayer.isMuted() : false;
        }
        setMuted(mute) {
            if (!this.ytPlayer) return;
            else this.muted(true);
            if (mute) this.ytPlayer.mute();
            else this.ytPlayer.unMute();
            this.setTimeout(function() {
                this.trigger('volumechange');
            }, 50);
        }
        buffered() {
            if (!this.ytPlayer || !this.ytPlayer.getVideoLoadedFraction) return videojs.createTimeRange();
            var bufferedEnd = this.ytPlayer.getVideoLoadedFraction() * this.ytPlayer.getDuration();
            return videojs.createTimeRange(0, bufferedEnd);
        }
        // TODO: Can we really do something with this on YouTUbe?
        preload() {}
        load() {}
        reset() {}
        networkState() {
            if (!this.ytPlayer) return 0; //NETWORK_EMPTY
            switch(this.ytPlayer.getPlayerState()){
                case -1:
                    return 0; //NETWORK_EMPTY
                case 3:
                    return 2; //NETWORK_LOADING
                default:
                    return 1; //NETWORK_IDLE
            }
        }
        readyState() {
            if (!this.ytPlayer) return 0; //HAVE_NOTHING
            switch(this.ytPlayer.getPlayerState()){
                case -1:
                    return 0; //HAVE_NOTHING
                case 5:
                    return 1; //HAVE_METADATA
                case 3:
                    return 2; //HAVE_CURRENT_DATA
                default:
                    return 4; //HAVE_ENOUGH_DATA
            }
        }
        supportsFullScreen() {
            return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
        }
        // Tries to get the highest resolution thumbnail available for the video
        checkHighResPoster() {
            var uri = 'https://img.youtube.com/vi/' + this.url.videoId + '/maxresdefault.jpg';
            try {
                var image = new Image();
                image.onload = (function() {
                    // Onload may still be called if YouTube returns the 120x90 error thumbnail
                    if ('naturalHeight' in image) {
                        if (image.naturalHeight <= 90 || image.naturalWidth <= 120) return;
                    } else if (image.height <= 90 || image.width <= 120) return;
                    this.poster_ = uri;
                    this.trigger('posterchange');
                }).bind(this);
                image.onerror = function() {};
                image.src = uri;
            } catch (e) {}
        }
    }
    Youtube.isSupported = function() {
        return true;
    };
    Youtube.canPlaySource = function(e) {
        return Youtube.canPlayType(e.type);
    };
    Youtube.canPlayType = function(e) {
        return e === 'video/youtube';
    };
    Youtube.parseUrl = function(url) {
        var result = {
            videoId: null
        };
        var regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = url.match(regex);
        if (match && match[2].length === 11) result.videoId = match[2];
        var regPlaylist = /[?&]list=([^#\&\?]+)/;
        match = url.match(regPlaylist);
        if (match && match[1]) result.listId = match[1];
        return result;
    };
    function apiLoaded() {
        YT.ready(function() {
            Youtube.isApiReady = true;
            for(var i = 0; i < Youtube.apiReadyQueue.length; ++i)Youtube.apiReadyQueue[i].initYTPlayer();
        });
    }
    function loadScript(src, callback) {
        var loaded = false;
        var tag = document.createElement('script');
        var firstScriptTag = document.getElementsByTagName('script')[0];
        if (!firstScriptTag) // when loaded in jest without jsdom setup it doesn't get any element.
        // In jest it doesn't really make sense to do anything, because no one is watching youtube in jest
        return;
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        tag.onload = function() {
            if (!loaded) {
                loaded = true;
                callback();
            }
        };
        tag.onreadystatechange = function() {
            if (!loaded && (this.readyState === 'complete' || this.readyState === 'loaded')) {
                loaded = true;
                callback();
            }
        };
        tag.src = src;
    }
    function injectCss() {
        var css = ".vjs-youtube .vjs-iframe-blocker { display: none; }.vjs-youtube.vjs-user-inactive .vjs-iframe-blocker { display: block; }.vjs-youtube .vjs-poster { background-size: cover; }.vjs-youtube-mobile .vjs-big-play-button { display: none; }";
        var head = document.head || document.getElementsByTagName('head')[0];
        var style = document.createElement('style');
        style.type = 'text/css';
        if (style.styleSheet) style.styleSheet.cssText = css;
        else style.appendChild(document.createTextNode(css));
        head.appendChild(style);
    }
    Youtube.apiReadyQueue = [];
    if (typeof document !== 'undefined') {
        loadScript('https://www.youtube.com/iframe_api', apiLoaded);
        injectCss();
    }
    // Older versions of VJS5 doesn't have the registerTech function
    if (typeof videojs.registerTech !== 'undefined') videojs.registerTech('Youtube', Youtube);
    else videojs.registerComponent('Youtube', Youtube);
});


/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ /**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $4a792688e08e5cd7$export$3545e07a80636437 = "181", $4a792688e08e5cd7$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
}, $4a792688e08e5cd7$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
}, $4a792688e08e5cd7$export$3237e1f2c1ea1f44 = 0, $4a792688e08e5cd7$export$b9a7b4fc5cb15f9b = 1, $4a792688e08e5cd7$export$b8058bcc7037d3f3 = 2, $4a792688e08e5cd7$export$f24be24dcddeac0d = 3, $4a792688e08e5cd7$export$346307dbae2b7447 = 0, $4a792688e08e5cd7$export$5813f879eee7cd88 = 1, $4a792688e08e5cd7$export$a47c4b43a1be34f0 = 2, $4a792688e08e5cd7$export$896ae1ade6c829c4 = 3, $4a792688e08e5cd7$export$2ede184fc2998901 = 0, $4a792688e08e5cd7$export$d9f0486e75b5ace = 1, $4a792688e08e5cd7$export$3b296b6f144d5b03 = 2, $4a792688e08e5cd7$export$63b8d6b580fc65ba = 0, $4a792688e08e5cd7$export$5b29a26d96ee6af0 = 1, $4a792688e08e5cd7$export$777d8f9551c2216b = 2, $4a792688e08e5cd7$export$cdfa06f868e2e467 = 3, $4a792688e08e5cd7$export$4138e1c684b46a20 = 4, $4a792688e08e5cd7$export$eda4864c68df1fa2 = 5, $4a792688e08e5cd7$export$20183a0484ce21a0 = 100, $4a792688e08e5cd7$export$73e0df5177988548 = 101, $4a792688e08e5cd7$export$28e582859cbec660 = 102, $4a792688e08e5cd7$export$c8c1508da8d0600c = 103, $4a792688e08e5cd7$export$99948c02fb51055f = 104, $4a792688e08e5cd7$export$2110f05edf778d3d = 200, $4a792688e08e5cd7$export$8805bad65e24940e = 201, $4a792688e08e5cd7$export$7fbe15b28d28cf52 = 202, $4a792688e08e5cd7$export$947829af9f2c17f6 = 203, $4a792688e08e5cd7$export$d5773124e86cf28c = 204, $4a792688e08e5cd7$export$11d468cc7f19e971 = 205, $4a792688e08e5cd7$export$a78aed1ca2a87192 = 206, $4a792688e08e5cd7$export$5d0fe17fd8773bac = 207, $4a792688e08e5cd7$export$ef5f2dd8ffac5574 = 208, $4a792688e08e5cd7$export$56b85b2686ab16 = 209, $4a792688e08e5cd7$export$c05e2a1fc8609506 = 210, $4a792688e08e5cd7$export$7dd8f434fd59075 = 211, $4a792688e08e5cd7$export$99c8d898a9afbcee = 212, $4a792688e08e5cd7$export$310cd2be38d13b56 = 213, $4a792688e08e5cd7$export$db77b8fbcf45dbf4 = 214, $4a792688e08e5cd7$export$69025ce147cee220 = 0, $4a792688e08e5cd7$export$7182eb52ea3b3f04 = 1, $4a792688e08e5cd7$export$eedccec66ab7ebe = 2, $4a792688e08e5cd7$export$296f78a0b892f81a = 3, $4a792688e08e5cd7$export$a60d398fc7b7590e = 4, $4a792688e08e5cd7$export$7d7234c1240a1fc4 = 5, $4a792688e08e5cd7$export$c5e2c52991f30937 = 6, $4a792688e08e5cd7$export$2f843afa843d8916 = 7, $4a792688e08e5cd7$export$e50ac29801f1774d = 0, $4a792688e08e5cd7$export$9f9d94f963c85479 = 1, $4a792688e08e5cd7$export$e641dc52bc3494aa = 2, $4a792688e08e5cd7$export$9fcb6b4294603b2 = 0, $4a792688e08e5cd7$export$98f52c2a46c598ca = 1, $4a792688e08e5cd7$export$74b25e54b3bcd548 = 2, $4a792688e08e5cd7$export$932b3dd283d4a366 = 3, $4a792688e08e5cd7$export$a0d98fe6d7e4af64 = 4, $4a792688e08e5cd7$export$2c7b09c1e9abfb5e = 5, $4a792688e08e5cd7$export$212d53a513a325b2 = 6, $4a792688e08e5cd7$export$f2863e1668a8e317 = 7, $4a792688e08e5cd7$export$2595a3798997538 = "attached", $4a792688e08e5cd7$export$d7e7dc2e114517a0 = "detached", $4a792688e08e5cd7$export$1beec6768cbb3d2d = 300, $4a792688e08e5cd7$export$8759762a6477f2c4 = 301, $4a792688e08e5cd7$export$dc59f8aed047f61d = 302, $4a792688e08e5cd7$export$d64030b316d3b087 = 303, $4a792688e08e5cd7$export$ee99d97d46898098 = 304, $4a792688e08e5cd7$export$dbf3e70ff37af79 = 306, $4a792688e08e5cd7$export$533346c8e8dac0f5 = 1e3, $4a792688e08e5cd7$export$9d9334239a5a5e06 = 1001, $4a792688e08e5cd7$export$c7e7c00b14f51a4f = 1002, $4a792688e08e5cd7$export$727aa5ec3fe39bf0 = 1003, $4a792688e08e5cd7$export$d129e38cf6feaa8c = 1004, $4a792688e08e5cd7$export$14a4936464a36496 = 1004, $4a792688e08e5cd7$export$d2327c1afe5bfdf2 = 1005, $4a792688e08e5cd7$export$cbc5b7f5647595d8 = 1005, $4a792688e08e5cd7$export$8a72f490b25c56c8 = 1006, $4a792688e08e5cd7$export$19a719f377145a13 = 1007, $4a792688e08e5cd7$export$dbe96bee3fe9dbf0 = 1007, $4a792688e08e5cd7$export$5d8599b6a933fb1b = 1008, $4a792688e08e5cd7$export$90d80f1e3506775f = 1008, $4a792688e08e5cd7$export$2e8ce08d3f6f5e10 = 1009, $4a792688e08e5cd7$export$545fce0311a9796a = 1010, $4a792688e08e5cd7$export$88572337f312435f = 1011, $4a792688e08e5cd7$export$c63dc51868b06a9d = 1012, $4a792688e08e5cd7$export$5c612977753abe2 = 1013, $4a792688e08e5cd7$export$c3c7fc4518ebba96 = 1014, $4a792688e08e5cd7$export$f6d331659b644596 = 1015, $4a792688e08e5cd7$export$2697304443f382bc = 1016, $4a792688e08e5cd7$export$b3969b01faf587f2 = 1017, $4a792688e08e5cd7$export$18886f8ae33e90de = 1018, $4a792688e08e5cd7$export$6c8ea339bfab1301 = 1020, $4a792688e08e5cd7$export$5a4c329b7e2092d3 = 35902, $4a792688e08e5cd7$export$f240f067f72abe41 = 35899, $4a792688e08e5cd7$export$988473390501ed4b = 1021, $4a792688e08e5cd7$export$7c67423a5ee6f5eb = 1022, $4a792688e08e5cd7$export$3f8bb04b555a363c = 1023, $4a792688e08e5cd7$export$c1b6b5136be58045 = 1026, $4a792688e08e5cd7$export$1e113ac2d0905829 = 1027, $4a792688e08e5cd7$export$4e041a7967d15c4b = 1028, $4a792688e08e5cd7$export$aa92e870a709d190 = 1029, $4a792688e08e5cd7$export$6cdf0b461c7ce8a0 = 1030, $4a792688e08e5cd7$export$1ba1c45f9f77d4d7 = 1031, $4a792688e08e5cd7$export$d1fd40c11bfa798e = 1032, $4a792688e08e5cd7$export$c200e7d26f592f21 = 1033, $4a792688e08e5cd7$export$21d1799c6d552fc0 = 33776, $4a792688e08e5cd7$export$afa304c3e981b668 = 33777, $4a792688e08e5cd7$export$d2a1a68024a3e56c = 33778, $4a792688e08e5cd7$export$9a79c424327dacf9 = 33779, $4a792688e08e5cd7$export$19ada9bbb1af3573 = 35840, $4a792688e08e5cd7$export$d0f0355bb3d948e4 = 35841, $4a792688e08e5cd7$export$b82296714358084c = 35842, $4a792688e08e5cd7$export$b71692456c47b6c3 = 35843, $4a792688e08e5cd7$export$6ab91af2d757aee7 = 36196, $4a792688e08e5cd7$export$7800993ef8106a6a = 37492, $4a792688e08e5cd7$export$23ed8300a860e7d8 = 37496, $4a792688e08e5cd7$export$dc5570b4a2b92d48 = 37808, $4a792688e08e5cd7$export$68880cd325f8b2fb = 37809, $4a792688e08e5cd7$export$7d2c0be323373d95 = 37810, $4a792688e08e5cd7$export$22b52da301fc3a3e = 37811, $4a792688e08e5cd7$export$c009e2cb4a66485e = 37812, $4a792688e08e5cd7$export$118fff5afa255b63 = 37813, $4a792688e08e5cd7$export$120713c829ae0667 = 37814, $4a792688e08e5cd7$export$c79eeabbf53313e9 = 37815, $4a792688e08e5cd7$export$443cf6567cdd6424 = 37816, $4a792688e08e5cd7$export$6573984fc9840780 = 37817, $4a792688e08e5cd7$export$e7aee563f30091de = 37818, $4a792688e08e5cd7$export$2eb8634622ddeab7 = 37819, $4a792688e08e5cd7$export$202b1ce7b5d25742 = 37820, $4a792688e08e5cd7$export$18ab77abd087e467 = 37821, $4a792688e08e5cd7$export$ce40b115e188bc81 = 36492, $4a792688e08e5cd7$export$d279c5c4bac5121e = 36494, $4a792688e08e5cd7$export$cde52d17225fdbd3 = 36495, $4a792688e08e5cd7$export$b1688df4c4c21670 = 36283, $4a792688e08e5cd7$export$fc15e5d8261eed58 = 36284, $4a792688e08e5cd7$export$d220f6ade8463a0f = 36285, $4a792688e08e5cd7$export$768646d09dc1b6ef = 36286, $4a792688e08e5cd7$export$d62fdc9d1b1cccad = 2200, $4a792688e08e5cd7$export$dfaf4422ce096e29 = 2201, $4a792688e08e5cd7$export$f8f6f2041b78e210 = 2202, $4a792688e08e5cd7$export$995b32462a65e855 = 2300, $4a792688e08e5cd7$export$30fac1aace31cf4d = 2301, $4a792688e08e5cd7$export$198b11ff4c72bb30 = 2302, $4a792688e08e5cd7$export$7f795934b84ab523 = 2400, $4a792688e08e5cd7$export$24a4ccb5099273b5 = 2401, $4a792688e08e5cd7$export$8e8c3ecdcd8e1fee = 2402, $4a792688e08e5cd7$export$bcfbbdcf8de7f8cd = 2500, $4a792688e08e5cd7$export$d875e029ef558d3 = 2501, $4a792688e08e5cd7$export$4c28c87c2dc84758 = 0, $4a792688e08e5cd7$export$b23a071aa286eb29 = 1, $4a792688e08e5cd7$export$f0d8293634f88842 = 2, $4a792688e08e5cd7$export$deeb383078690b50 = 3200, $4a792688e08e5cd7$export$8f910f4c4f73df11 = 3201, $4a792688e08e5cd7$export$be2e2ddbc3983173 = 3202, $4a792688e08e5cd7$export$1a54198784742f80 = 3203, $4a792688e08e5cd7$export$2852a58ebdac27b8 = 0, $4a792688e08e5cd7$export$9990ad26f9db5b2c = 1, $4a792688e08e5cd7$export$bfcb490c2dd3db51 = "", $4a792688e08e5cd7$export$561f394b24edfcaa = "srgb", $4a792688e08e5cd7$export$42429b3acfb233a4 = "srgb-linear", $4a792688e08e5cd7$export$f197347d588c1b4a = "linear", $4a792688e08e5cd7$export$8d0a61916cc26abb = "srgb", $4a792688e08e5cd7$export$69433f11f42d5527 = 0, $4a792688e08e5cd7$export$9f542ae4b5baca34 = 7680, $4a792688e08e5cd7$export$8a4f28336ef203d3 = 7681, $4a792688e08e5cd7$export$2928c0231297c036 = 7682, $4a792688e08e5cd7$export$c0e9611c8a15f9a8 = 7683, $4a792688e08e5cd7$export$9c2c08927385dcc4 = 34055, $4a792688e08e5cd7$export$7c74ea00fa1315e6 = 34056, $4a792688e08e5cd7$export$22e2e5726612443 = 5386, $4a792688e08e5cd7$export$1343870698229224 = 512, $4a792688e08e5cd7$export$8e1d8ed281997fa6 = 513, $4a792688e08e5cd7$export$55648a1cde8329a7 = 514, $4a792688e08e5cd7$export$2dff107857e6aca2 = 515, $4a792688e08e5cd7$export$6f93765ab2f451a2 = 516, $4a792688e08e5cd7$export$6f3fb2d2440f2b76 = 517, $4a792688e08e5cd7$export$4119cf7b4c98fd5a = 518, $4a792688e08e5cd7$export$14cf96713ddd97a8 = 519, $4a792688e08e5cd7$export$d9e2d19a747baaab = 512, $4a792688e08e5cd7$export$36bcf49c713b3eb7 = 513, $4a792688e08e5cd7$export$66f28d946fc6a0d5 = 514, $4a792688e08e5cd7$export$64eea11eb407ddf1 = 515, $4a792688e08e5cd7$export$155af022118f3a38 = 516, $4a792688e08e5cd7$export$67ab95dde6bed156 = 517, $4a792688e08e5cd7$export$1cdcb70d53d65f61 = 518, $4a792688e08e5cd7$export$187b73a3e352c145 = 519, $4a792688e08e5cd7$export$763e8360f4d7f77d = 35044, $4a792688e08e5cd7$export$8505d14ac8546ca = 35048, $4a792688e08e5cd7$export$721e63549e51d81e = 35040, $4a792688e08e5cd7$export$415731dc4f48e299 = 35045, $4a792688e08e5cd7$export$9e809946455f13bc = 35049, $4a792688e08e5cd7$export$2ed9499a35b5f832 = 35041, $4a792688e08e5cd7$export$32ab2503ea19469a = 35046, $4a792688e08e5cd7$export$ab4022c2c3f86315 = 35050, $4a792688e08e5cd7$export$ba7f1db36a76a970 = 35042, $4a792688e08e5cd7$export$43600cc67fabd9f = "100", $4a792688e08e5cd7$export$f63012db5506e7dd = "300 es", $4a792688e08e5cd7$export$5a0e9190d10875d3 = 2e3, $4a792688e08e5cd7$export$cc83beedcb9be9ac = 2001, $4a792688e08e5cd7$export$f97db56e2b647801 = {
    COMPUTE: "compute",
    RENDER: "render"
}, $4a792688e08e5cd7$export$ff3764a6b1cf3544 = {
    PERSPECTIVE: "perspective",
    LINEAR: "linear",
    FLAT: "flat"
}, $4a792688e08e5cd7$export$599d2e4c2d7b2a01 = {
    NORMAL: "normal",
    CENTROID: "centroid",
    SAMPLE: "sample",
    FIRST: "first",
    EITHER: "either"
};
function $4a792688e08e5cd7$export$bc6f937da07eae17(t) {
    for(let e = t.length - 1; e >= 0; --e)if (t[e] >= 65535) return !0;
    return !1;
}
const $4a792688e08e5cd7$var$ji = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $4a792688e08e5cd7$var$Di(t, e) {
    return new $4a792688e08e5cd7$var$ji[t](e);
}
function $4a792688e08e5cd7$export$7094a064528c7fee(t) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", t);
}
function $4a792688e08e5cd7$export$1033a2df66368859() {
    const t = $4a792688e08e5cd7$export$7094a064528c7fee("canvas");
    return t.style.display = "block", t;
}
const $4a792688e08e5cd7$var$qi = {};
let $4a792688e08e5cd7$var$Ji = null;
function $4a792688e08e5cd7$export$702823ffb42fb3aa(t) {
    $4a792688e08e5cd7$var$Ji = t;
}
function $4a792688e08e5cd7$export$fa86edd994bb169f() {
    return $4a792688e08e5cd7$var$Ji;
}
function $4a792688e08e5cd7$export$bef1f36f5486a6a3(...t) {
    const e = "THREE." + t.shift();
    $4a792688e08e5cd7$var$Ji ? $4a792688e08e5cd7$var$Ji("log", e, ...t) : console.log(e, ...t);
}
function $4a792688e08e5cd7$export$c106dd0671a0fc2d(...t) {
    const e = "THREE." + t.shift();
    $4a792688e08e5cd7$var$Ji ? $4a792688e08e5cd7$var$Ji("warn", e, ...t) : console.warn(e, ...t);
}
function $4a792688e08e5cd7$export$a3bc9b8ed74fc(...t) {
    const e = "THREE." + t.shift();
    $4a792688e08e5cd7$var$Ji ? $4a792688e08e5cd7$var$Ji("error", e, ...t) : console.error(e, ...t);
}
function $4a792688e08e5cd7$export$5b28268982f175ba(...t) {
    const e = t.join(" ");
    e in $4a792688e08e5cd7$var$qi || ($4a792688e08e5cd7$var$qi[e] = !0, $4a792688e08e5cd7$export$c106dd0671a0fc2d(...t));
}
function $4a792688e08e5cd7$export$d43f91ebeafb2c7(t, e, i) {
    return new Promise(function(s, r) {
        setTimeout(function n() {
            switch(t.clientWaitSync(e, t.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case t.WAIT_FAILED:
                    r();
                    break;
                case t.TIMEOUT_EXPIRED:
                    setTimeout(n, i);
                    break;
                default:
                    s();
            }
        }, i);
    });
}
class $4a792688e08e5cd7$export$ec8b666c5fe2c75a {
    addEventListener(t, e) {
        void 0 === this._listeners && (this._listeners = {});
        const i = this._listeners;
        void 0 === i[t] && (i[t] = []), -1 === i[t].indexOf(e) && i[t].push(e);
    }
    hasEventListener(t, e) {
        const i = this._listeners;
        return void 0 !== i && void 0 !== i[t] && -1 !== i[t].indexOf(e);
    }
    removeEventListener(t, e) {
        const i = this._listeners;
        if (void 0 === i) return;
        const s = i[t];
        if (void 0 !== s) {
            const t = s.indexOf(e);
            -1 !== t && s.splice(t, 1);
        }
    }
    dispatchEvent(t) {
        const e = this._listeners;
        if (void 0 === e) return;
        const i = e[t.type];
        if (void 0 !== i) {
            t.target = this;
            const e = i.slice(0);
            for(let i = 0, s = e.length; i < s; i++)e[i].call(this, t);
            t.target = null;
        }
    }
}
const $4a792688e08e5cd7$var$ts = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $4a792688e08e5cd7$var$es = 1234567;
const $4a792688e08e5cd7$var$is = Math.PI / 180, $4a792688e08e5cd7$export$914076c8150813e5 = 180 / Math.PI;
function $4a792688e08e5cd7$var$rs() {
    const t = 4294967295 * Math.random() | 0, e = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0, s = 4294967295 * Math.random() | 0;
    return ($4a792688e08e5cd7$var$ts[255 & t] + $4a792688e08e5cd7$var$ts[t >> 8 & 255] + $4a792688e08e5cd7$var$ts[t >> 16 & 255] + $4a792688e08e5cd7$var$ts[t >> 24 & 255] + "-" + $4a792688e08e5cd7$var$ts[255 & e] + $4a792688e08e5cd7$var$ts[e >> 8 & 255] + "-" + $4a792688e08e5cd7$var$ts[e >> 16 & 15 | 64] + $4a792688e08e5cd7$var$ts[e >> 24 & 255] + "-" + $4a792688e08e5cd7$var$ts[63 & i | 128] + $4a792688e08e5cd7$var$ts[i >> 8 & 255] + "-" + $4a792688e08e5cd7$var$ts[i >> 16 & 255] + $4a792688e08e5cd7$var$ts[i >> 24 & 255] + $4a792688e08e5cd7$var$ts[255 & s] + $4a792688e08e5cd7$var$ts[s >> 8 & 255] + $4a792688e08e5cd7$var$ts[s >> 16 & 255] + $4a792688e08e5cd7$var$ts[s >> 24 & 255]).toLowerCase();
}
function $4a792688e08e5cd7$var$ns(t, e, i) {
    return Math.max(e, Math.min(i, t));
}
function $4a792688e08e5cd7$var$as(t, e) {
    return (t % e + e) % e;
}
function $4a792688e08e5cd7$var$os(t, e, i) {
    return (1 - i) * t + i * e;
}
function $4a792688e08e5cd7$var$hs(t, e) {
    switch(e.constructor){
        case Float32Array:
            return t;
        case Uint32Array:
            return t / 4294967295;
        case Uint16Array:
            return t / 65535;
        case Uint8Array:
            return t / 255;
        case Int32Array:
            return Math.max(t / 2147483647, -1);
        case Int16Array:
            return Math.max(t / 32767, -1);
        case Int8Array:
            return Math.max(t / 127, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $4a792688e08e5cd7$var$ls(t, e) {
    switch(e.constructor){
        case Float32Array:
            return t;
        case Uint32Array:
            return Math.round(4294967295 * t);
        case Uint16Array:
            return Math.round(65535 * t);
        case Uint8Array:
            return Math.round(255 * t);
        case Int32Array:
            return Math.round(2147483647 * t);
        case Int16Array:
            return Math.round(32767 * t);
        case Int8Array:
            return Math.round(127 * t);
        default:
            throw new Error("Invalid component type.");
    }
}
const $4a792688e08e5cd7$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $4a792688e08e5cd7$var$is,
    RAD2DEG: $4a792688e08e5cd7$export$914076c8150813e5,
    generateUUID: $4a792688e08e5cd7$var$rs,
    clamp: $4a792688e08e5cd7$var$ns,
    euclideanModulo: $4a792688e08e5cd7$var$as,
    mapLinear: function(t, e, i, s, r) {
        return s + (t - e) * (r - s) / (i - e);
    },
    inverseLerp: function(t, e, i) {
        return t !== e ? (i - t) / (e - t) : 0;
    },
    lerp: $4a792688e08e5cd7$var$os,
    damp: function(t, e, i, s) {
        return $4a792688e08e5cd7$var$os(t, e, 1 - Math.exp(-i * s));
    },
    pingpong: function(t, e = 1) {
        return e - Math.abs($4a792688e08e5cd7$var$as(t, 2 * e) - e);
    },
    smoothstep: function(t, e, i) {
        return t <= e ? 0 : t >= i ? 1 : (t = (t - e) / (i - e)) * t * (3 - 2 * t);
    },
    smootherstep: function(t, e, i) {
        return t <= e ? 0 : t >= i ? 1 : (t = (t - e) / (i - e)) * t * t * (t * (6 * t - 15) + 10);
    },
    randInt: function(t, e) {
        return t + Math.floor(Math.random() * (e - t + 1));
    },
    randFloat: function(t, e) {
        return t + Math.random() * (e - t);
    },
    randFloatSpread: function(t) {
        return t * (.5 - Math.random());
    },
    seededRandom: function(t) {
        void 0 !== t && ($4a792688e08e5cd7$var$es = t);
        let e = $4a792688e08e5cd7$var$es += 1831565813;
        return e = Math.imul(e ^ e >>> 15, 1 | e), e ^= e + Math.imul(e ^ e >>> 7, 61 | e), ((e ^ e >>> 14) >>> 0) / 4294967296;
    },
    degToRad: function(t) {
        return t * $4a792688e08e5cd7$var$is;
    },
    radToDeg: function(t) {
        return t * $4a792688e08e5cd7$export$914076c8150813e5;
    },
    isPowerOfTwo: function(t) {
        return !(t & t - 1) && 0 !== t;
    },
    ceilPowerOfTwo: function(t) {
        return Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
    },
    floorPowerOfTwo: function(t) {
        return Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
    },
    setQuaternionFromProperEuler: function(t, e, i, s, r) {
        const n = Math.cos, a = Math.sin, o = n(i / 2), h = a(i / 2), l = n((e + s) / 2), c = a((e + s) / 2), u = n((e - s) / 2), d = a((e - s) / 2), p = n((s - e) / 2), m = a((s - e) / 2);
        switch(r){
            case "XYX":
                t.set(o * c, h * u, h * d, o * l);
                break;
            case "YZY":
                t.set(h * d, o * c, h * u, o * l);
                break;
            case "ZXZ":
                t.set(h * u, h * d, o * c, o * l);
                break;
            case "XZX":
                t.set(o * c, h * m, h * p, o * l);
                break;
            case "YXY":
                t.set(h * p, o * c, h * m, o * l);
                break;
            case "ZYZ":
                t.set(h * m, h * p, o * c, o * l);
                break;
            default:
                $4a792688e08e5cd7$export$c106dd0671a0fc2d("MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + r);
        }
    },
    normalize: $4a792688e08e5cd7$var$ls,
    denormalize: $4a792688e08e5cd7$var$hs
};
class $4a792688e08e5cd7$export$c977b3e384af9ae1 {
    constructor(t = 0, e = 0){
        $4a792688e08e5cd7$export$c977b3e384af9ae1.prototype.isVector2 = !0, this.x = t, this.y = e;
    }
    get width() {
        return this.x;
    }
    set width(t) {
        this.x = t;
    }
    get height() {
        return this.y;
    }
    set height(t) {
        this.y = t;
    }
    set(t, e) {
        return this.x = t, this.y = e, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this;
    }
    divide(t) {
        return this.x /= t.x, this.y /= t.y, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    applyMatrix3(t) {
        const e = this.x, i = this.y, s = t.elements;
        return this.x = s[0] * e + s[3] * i + s[6], this.y = s[1] * e + s[4] * i + s[7], this;
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
    }
    clamp(t, e) {
        return this.x = $4a792688e08e5cd7$var$ns(this.x, t.x, e.x), this.y = $4a792688e08e5cd7$var$ns(this.y, t.y, e.y), this;
    }
    clampScalar(t, e) {
        return this.x = $4a792688e08e5cd7$var$ns(this.x, t, e), this.y = $4a792688e08e5cd7$var$ns(this.y, t, e), this;
    }
    clampLength(t, e) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($4a792688e08e5cd7$var$ns(i, t, e));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y;
    }
    cross(t) {
        return this.x * t.y - this.y * t.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    angleTo(t) {
        const e = Math.sqrt(this.lengthSq() * t.lengthSq());
        if (0 === e) return Math.PI / 2;
        const i = this.dot(t) / e;
        return Math.acos($4a792688e08e5cd7$var$ns(i, -1, 1));
    }
    distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
    }
    distanceToSquared(t) {
        const e = this.x - t.x, i = this.y - t.y;
        return e * e + i * i;
    }
    manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
    }
    lerpVectors(t, e, i) {
        return this.x = t.x + (e.x - t.x) * i, this.y = t.y + (e.y - t.y) * i, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this;
    }
    rotateAround(t, e) {
        const i = Math.cos(e), s = Math.sin(e), r = this.x - t.x, n = this.y - t.y;
        return this.x = r * i - n * s + t.x, this.y = r * s + n * i + t.y, this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y;
    }
}
class $4a792688e08e5cd7$export$23d6a54f0bbc85a3 {
    constructor(t = 0, e = 0, i = 0, s = 1){
        this.isQuaternion = !0, this._x = t, this._y = e, this._z = i, this._w = s;
    }
    static slerpFlat(t, e, i, s, r, n, a) {
        let o = i[s + 0], h = i[s + 1], l = i[s + 2], c = i[s + 3], u = r[n + 0], d = r[n + 1], p = r[n + 2], m = r[n + 3];
        if (a <= 0) return t[e + 0] = o, t[e + 1] = h, t[e + 2] = l, void (t[e + 3] = c);
        if (a >= 1) return t[e + 0] = u, t[e + 1] = d, t[e + 2] = p, void (t[e + 3] = m);
        if (c !== m || o !== u || h !== d || l !== p) {
            let t = o * u + h * d + l * p + c * m;
            t < 0 && (u = -u, d = -d, p = -p, m = -m, t = -t);
            let e = 1 - a;
            if (t < .9995) {
                const i = Math.acos(t), s = Math.sin(i);
                e = Math.sin(e * i) / s, o = o * e + u * (a = Math.sin(a * i) / s), h = h * e + d * a, l = l * e + p * a, c = c * e + m * a;
            } else {
                o = o * e + u * a, h = h * e + d * a, l = l * e + p * a, c = c * e + m * a;
                const t = 1 / Math.sqrt(o * o + h * h + l * l + c * c);
                o *= t, h *= t, l *= t, c *= t;
            }
        }
        t[e] = o, t[e + 1] = h, t[e + 2] = l, t[e + 3] = c;
    }
    static multiplyQuaternionsFlat(t, e, i, s, r, n) {
        const a = i[s], o = i[s + 1], h = i[s + 2], l = i[s + 3], c = r[n], u = r[n + 1], d = r[n + 2], p = r[n + 3];
        return t[e] = a * p + l * c + o * d - h * u, t[e + 1] = o * p + l * u + h * c - a * d, t[e + 2] = h * p + l * d + a * u - o * c, t[e + 3] = l * p - a * c - o * u - h * d, t;
    }
    get x() {
        return this._x;
    }
    set x(t) {
        this._x = t, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t) {
        this._y = t, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t) {
        this._z = t, this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(t) {
        this._w = t, this._onChangeCallback();
    }
    set(t, e, i, s) {
        return this._x = t, this._y = e, this._z = i, this._w = s, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(t) {
        return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
    }
    setFromEuler(t, e = !0) {
        const i = t._x, s = t._y, r = t._z, n = t._order, a = Math.cos, o = Math.sin, h = a(i / 2), l = a(s / 2), c = a(r / 2), u = o(i / 2), d = o(s / 2), p = o(r / 2);
        switch(n){
            case "XYZ":
                this._x = u * l * c + h * d * p, this._y = h * d * c - u * l * p, this._z = h * l * p + u * d * c, this._w = h * l * c - u * d * p;
                break;
            case "YXZ":
                this._x = u * l * c + h * d * p, this._y = h * d * c - u * l * p, this._z = h * l * p - u * d * c, this._w = h * l * c + u * d * p;
                break;
            case "ZXY":
                this._x = u * l * c - h * d * p, this._y = h * d * c + u * l * p, this._z = h * l * p + u * d * c, this._w = h * l * c - u * d * p;
                break;
            case "ZYX":
                this._x = u * l * c - h * d * p, this._y = h * d * c + u * l * p, this._z = h * l * p - u * d * c, this._w = h * l * c + u * d * p;
                break;
            case "YZX":
                this._x = u * l * c + h * d * p, this._y = h * d * c + u * l * p, this._z = h * l * p - u * d * c, this._w = h * l * c - u * d * p;
                break;
            case "XZY":
                this._x = u * l * c - h * d * p, this._y = h * d * c - u * l * p, this._z = h * l * p + u * d * c, this._w = h * l * c + u * d * p;
                break;
            default:
                $4a792688e08e5cd7$export$c106dd0671a0fc2d("Quaternion: .setFromEuler() encountered an unknown order: " + n);
        }
        return !0 === e && this._onChangeCallback(), this;
    }
    setFromAxisAngle(t, e) {
        const i = e / 2, s = Math.sin(i);
        return this._x = t.x * s, this._y = t.y * s, this._z = t.z * s, this._w = Math.cos(i), this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t) {
        const e = t.elements, i = e[0], s = e[4], r = e[8], n = e[1], a = e[5], o = e[9], h = e[2], l = e[6], c = e[10], u = i + a + c;
        if (u > 0) {
            const t = .5 / Math.sqrt(u + 1);
            this._w = .25 / t, this._x = (l - o) * t, this._y = (r - h) * t, this._z = (n - s) * t;
        } else if (i > a && i > c) {
            const t = 2 * Math.sqrt(1 + i - a - c);
            this._w = (l - o) / t, this._x = .25 * t, this._y = (s + n) / t, this._z = (r + h) / t;
        } else if (a > c) {
            const t = 2 * Math.sqrt(1 + a - i - c);
            this._w = (r - h) / t, this._x = (s + n) / t, this._y = .25 * t, this._z = (o + l) / t;
        } else {
            const t = 2 * Math.sqrt(1 + c - i - a);
            this._w = (n - s) / t, this._x = (r + h) / t, this._y = (o + l) / t, this._z = .25 * t;
        }
        return this._onChangeCallback(), this;
    }
    setFromUnitVectors(t, e) {
        let i = t.dot(e) + 1;
        return i < 1e-8 ? (i = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = i) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = i)) : (this._x = t.y * e.z - t.z * e.y, this._y = t.z * e.x - t.x * e.z, this._z = t.x * e.y - t.y * e.x, this._w = i), this.normalize();
    }
    angleTo(t) {
        return 2 * Math.acos(Math.abs($4a792688e08e5cd7$var$ns(this.dot(t), -1, 1)));
    }
    rotateTowards(t, e) {
        const i = this.angleTo(t);
        if (0 === i) return this;
        const s = Math.min(1, e / i);
        return this.slerp(t, s), this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        return this.conjugate();
    }
    conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
    dot(t) {
        return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let t = this.length();
        return 0 === t ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
    }
    multiply(t) {
        return this.multiplyQuaternions(this, t);
    }
    premultiply(t) {
        return this.multiplyQuaternions(t, this);
    }
    multiplyQuaternions(t, e) {
        const i = t._x, s = t._y, r = t._z, n = t._w, a = e._x, o = e._y, h = e._z, l = e._w;
        return this._x = i * l + n * a + s * h - r * o, this._y = s * l + n * o + r * a - i * h, this._z = r * l + n * h + i * o - s * a, this._w = n * l - i * a - s * o - r * h, this._onChangeCallback(), this;
    }
    slerp(t, e) {
        if (e <= 0) return this;
        if (e >= 1) return this.copy(t);
        let i = t._x, s = t._y, r = t._z, n = t._w, a = this.dot(t);
        a < 0 && (i = -i, s = -s, r = -r, n = -n, a = -a);
        let o = 1 - e;
        if (a < .9995) {
            const t = Math.acos(a), h = Math.sin(t);
            o = Math.sin(o * t) / h, e = Math.sin(e * t) / h, this._x = this._x * o + i * e, this._y = this._y * o + s * e, this._z = this._z * o + r * e, this._w = this._w * o + n * e, this._onChangeCallback();
        } else this._x = this._x * o + i * e, this._y = this._y * o + s * e, this._z = this._z * o + r * e, this._w = this._w * o + n * e, this.normalize();
        return this;
    }
    slerpQuaternions(t, e, i) {
        return this.copy(t).slerp(e, i);
    }
    random() {
        const t = 2 * Math.PI * Math.random(), e = 2 * Math.PI * Math.random(), i = Math.random(), s = Math.sqrt(1 - i), r = Math.sqrt(i);
        return this.set(s * Math.sin(t), s * Math.cos(t), r * Math.sin(e), r * Math.cos(e));
    }
    equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
    }
    fromArray(t, e = 0) {
        return this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this._onChangeCallback(), this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
    }
    fromBufferAttribute(t, e) {
        return this._x = t.getX(e), this._y = t.getY(e), this._z = t.getZ(e), this._w = t.getW(e), this._onChangeCallback(), this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(t) {
        return this._onChangeCallback = t, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._w;
    }
}
class $4a792688e08e5cd7$export$64b5c384219d3699 {
    constructor(t = 0, e = 0, i = 0){
        $4a792688e08e5cd7$export$64b5c384219d3699.prototype.isVector3 = !0, this.x = t, this.y = e, this.z = i;
    }
    set(t, e, i) {
        return void 0 === i && (i = this.z), this.x = t, this.y = e, this.z = i, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setZ(t) {
        return this.z = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this.z += t.z, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this.z -= t.z, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this.z *= t.z, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this;
    }
    multiplyVectors(t, e) {
        return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
    }
    applyEuler(t) {
        return this.applyQuaternion($4a792688e08e5cd7$var$ys.setFromEuler(t));
    }
    applyAxisAngle(t, e) {
        return this.applyQuaternion($4a792688e08e5cd7$var$ys.setFromAxisAngle(t, e));
    }
    applyMatrix3(t) {
        const e = this.x, i = this.y, s = this.z, r = t.elements;
        return this.x = r[0] * e + r[3] * i + r[6] * s, this.y = r[1] * e + r[4] * i + r[7] * s, this.z = r[2] * e + r[5] * i + r[8] * s, this;
    }
    applyNormalMatrix(t) {
        return this.applyMatrix3(t).normalize();
    }
    applyMatrix4(t) {
        const e = this.x, i = this.y, s = this.z, r = t.elements, n = 1 / (r[3] * e + r[7] * i + r[11] * s + r[15]);
        return this.x = (r[0] * e + r[4] * i + r[8] * s + r[12]) * n, this.y = (r[1] * e + r[5] * i + r[9] * s + r[13]) * n, this.z = (r[2] * e + r[6] * i + r[10] * s + r[14]) * n, this;
    }
    applyQuaternion(t) {
        const e = this.x, i = this.y, s = this.z, r = t.x, n = t.y, a = t.z, o = t.w, h = 2 * (n * s - a * i), l = 2 * (a * e - r * s), c = 2 * (r * i - n * e);
        return this.x = e + o * h + n * c - a * l, this.y = i + o * l + a * h - r * c, this.z = s + o * c + r * l - n * h, this;
    }
    project(t) {
        return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
    }
    unproject(t) {
        return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
    }
    transformDirection(t) {
        const e = this.x, i = this.y, s = this.z, r = t.elements;
        return this.x = r[0] * e + r[4] * i + r[8] * s, this.y = r[1] * e + r[5] * i + r[9] * s, this.z = r[2] * e + r[6] * i + r[10] * s, this.normalize();
    }
    divide(t) {
        return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
    }
    clamp(t, e) {
        return this.x = $4a792688e08e5cd7$var$ns(this.x, t.x, e.x), this.y = $4a792688e08e5cd7$var$ns(this.y, t.y, e.y), this.z = $4a792688e08e5cd7$var$ns(this.z, t.z, e.z), this;
    }
    clampScalar(t, e) {
        return this.x = $4a792688e08e5cd7$var$ns(this.x, t, e), this.y = $4a792688e08e5cd7$var$ns(this.y, t, e), this.z = $4a792688e08e5cd7$var$ns(this.z, t, e), this;
    }
    clampLength(t, e) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($4a792688e08e5cd7$var$ns(i, t, e));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
    }
    lerpVectors(t, e, i) {
        return this.x = t.x + (e.x - t.x) * i, this.y = t.y + (e.y - t.y) * i, this.z = t.z + (e.z - t.z) * i, this;
    }
    cross(t) {
        return this.crossVectors(this, t);
    }
    crossVectors(t, e) {
        const i = t.x, s = t.y, r = t.z, n = e.x, a = e.y, o = e.z;
        return this.x = s * o - r * a, this.y = r * n - i * o, this.z = i * a - s * n, this;
    }
    projectOnVector(t) {
        const e = t.lengthSq();
        if (0 === e) return this.set(0, 0, 0);
        const i = t.dot(this) / e;
        return this.copy(t).multiplyScalar(i);
    }
    projectOnPlane(t) {
        return $4a792688e08e5cd7$var$ms.copy(this).projectOnVector(t), this.sub($4a792688e08e5cd7$var$ms);
    }
    reflect(t) {
        return this.sub($4a792688e08e5cd7$var$ms.copy(t).multiplyScalar(2 * this.dot(t)));
    }
    angleTo(t) {
        const e = Math.sqrt(this.lengthSq() * t.lengthSq());
        if (0 === e) return Math.PI / 2;
        const i = this.dot(t) / e;
        return Math.acos($4a792688e08e5cd7$var$ns(i, -1, 1));
    }
    distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
    }
    distanceToSquared(t) {
        const e = this.x - t.x, i = this.y - t.y, s = this.z - t.z;
        return e * e + i * i + s * s;
    }
    manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
    }
    setFromSpherical(t) {
        return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
    }
    setFromSphericalCoords(t, e, i) {
        const s = Math.sin(e) * t;
        return this.x = s * Math.sin(i), this.y = Math.cos(e) * t, this.z = s * Math.cos(i), this;
    }
    setFromCylindrical(t) {
        return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
    }
    setFromCylindricalCoords(t, e, i) {
        return this.x = t * Math.sin(e), this.y = i, this.z = t * Math.cos(e), this;
    }
    setFromMatrixPosition(t) {
        const e = t.elements;
        return this.x = e[12], this.y = e[13], this.z = e[14], this;
    }
    setFromMatrixScale(t) {
        const e = this.setFromMatrixColumn(t, 0).length(), i = this.setFromMatrixColumn(t, 1).length(), s = this.setFromMatrixColumn(t, 2).length();
        return this.x = e, this.y = i, this.z = s, this;
    }
    setFromMatrixColumn(t, e) {
        return this.fromArray(t.elements, 4 * e);
    }
    setFromMatrix3Column(t, e) {
        return this.fromArray(t.elements, 3 * e);
    }
    setFromEuler(t) {
        return this.x = t._x, this.y = t._y, this.z = t._z, this;
    }
    setFromColor(t) {
        return this.x = t.r, this.y = t.g, this.z = t.b, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
    randomDirection() {
        const t = Math.random() * Math.PI * 2, e = 2 * Math.random() - 1, i = Math.sqrt(1 - e * e);
        return this.x = i * Math.cos(t), this.y = e, this.z = i * Math.sin(t), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z;
    }
}
const $4a792688e08e5cd7$var$ms = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$ys = new $4a792688e08e5cd7$export$23d6a54f0bbc85a3;
class $4a792688e08e5cd7$export$8ff26dafa08918 {
    constructor(t, e, i, s, r, n, a, o, h){
        $4a792688e08e5cd7$export$8ff26dafa08918.prototype.isMatrix3 = !0, this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], void 0 !== t && this.set(t, e, i, s, r, n, a, o, h);
    }
    set(t, e, i, s, r, n, a, o, h) {
        const l = this.elements;
        return l[0] = t, l[1] = s, l[2] = a, l[3] = e, l[4] = r, l[5] = o, l[6] = i, l[7] = n, l[8] = h, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
    copy(t) {
        const e = this.elements, i = t.elements;
        return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], this;
    }
    extractBasis(t, e, i) {
        return t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), i.setFromMatrix3Column(this, 2), this;
    }
    setFromMatrix4(t) {
        const e = t.elements;
        return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
    }
    multiply(t) {
        return this.multiplyMatrices(this, t);
    }
    premultiply(t) {
        return this.multiplyMatrices(t, this);
    }
    multiplyMatrices(t, e) {
        const i = t.elements, s = e.elements, r = this.elements, n = i[0], a = i[3], o = i[6], h = i[1], l = i[4], c = i[7], u = i[2], d = i[5], p = i[8], m = s[0], y = s[3], g = s[6], f = s[1], x = s[4], b = s[7], v = s[2], w = s[5], M = s[8];
        return r[0] = n * m + a * f + o * v, r[3] = n * y + a * x + o * w, r[6] = n * g + a * b + o * M, r[1] = h * m + l * f + c * v, r[4] = h * y + l * x + c * w, r[7] = h * g + l * b + c * M, r[2] = u * m + d * f + p * v, r[5] = u * y + d * x + p * w, r[8] = u * g + d * b + p * M, this;
    }
    multiplyScalar(t) {
        const e = this.elements;
        return e[0] *= t, e[3] *= t, e[6] *= t, e[1] *= t, e[4] *= t, e[7] *= t, e[2] *= t, e[5] *= t, e[8] *= t, this;
    }
    determinant() {
        const t = this.elements, e = t[0], i = t[1], s = t[2], r = t[3], n = t[4], a = t[5], o = t[6], h = t[7], l = t[8];
        return e * n * l - e * a * h - i * r * l + i * a * o + s * r * h - s * n * o;
    }
    invert() {
        const t = this.elements, e = t[0], i = t[1], s = t[2], r = t[3], n = t[4], a = t[5], o = t[6], h = t[7], l = t[8], c = l * n - a * h, u = a * o - l * r, d = h * r - n * o, p = e * c + i * u + s * d;
        if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const m = 1 / p;
        return t[0] = c * m, t[1] = (s * h - l * i) * m, t[2] = (a * i - s * n) * m, t[3] = u * m, t[4] = (l * e - s * o) * m, t[5] = (s * r - a * e) * m, t[6] = d * m, t[7] = (i * o - h * e) * m, t[8] = (n * e - i * r) * m, this;
    }
    transpose() {
        let t;
        const e = this.elements;
        return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
    }
    getNormalMatrix(t) {
        return this.setFromMatrix4(t).invert().transpose();
    }
    transposeIntoArray(t) {
        const e = this.elements;
        return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
    }
    setUvTransform(t, e, i, s, r, n, a) {
        const o = Math.cos(r), h = Math.sin(r);
        return this.set(i * o, i * h, -i * (o * n + h * a) + n + t, -s * h, s * o, -s * (-h * n + o * a) + a + e, 0, 0, 1), this;
    }
    scale(t, e) {
        return this.premultiply($4a792688e08e5cd7$var$fs.makeScale(t, e)), this;
    }
    rotate(t) {
        return this.premultiply($4a792688e08e5cd7$var$fs.makeRotation(-t)), this;
    }
    translate(t, e) {
        return this.premultiply($4a792688e08e5cd7$var$fs.makeTranslation(t, e)), this;
    }
    makeTranslation(t, e) {
        return t.isVector2 ? this.set(1, 0, t.x, 0, 1, t.y, 0, 0, 1) : this.set(1, 0, t, 0, 1, e, 0, 0, 1), this;
    }
    makeRotation(t) {
        const e = Math.cos(t), i = Math.sin(t);
        return this.set(e, -i, 0, i, e, 0, 0, 0, 1), this;
    }
    makeScale(t, e) {
        return this.set(t, 0, 0, 0, e, 0, 0, 0, 1), this;
    }
    equals(t) {
        const e = this.elements, i = t.elements;
        for(let t = 0; t < 9; t++)if (e[t] !== i[t]) return !1;
        return !0;
    }
    fromArray(t, e = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = t[i + e];
        return this;
    }
    toArray(t = [], e = 0) {
        const i = this.elements;
        return t[e] = i[0], t[e + 1] = i[1], t[e + 2] = i[2], t[e + 3] = i[3], t[e + 4] = i[4], t[e + 5] = i[5], t[e + 6] = i[6], t[e + 7] = i[7], t[e + 8] = i[8], t;
    }
    clone() {
        return (new this.constructor).fromArray(this.elements);
    }
}
const $4a792688e08e5cd7$var$fs = new $4a792688e08e5cd7$export$8ff26dafa08918, $4a792688e08e5cd7$var$xs = (new $4a792688e08e5cd7$export$8ff26dafa08918).set(.4123908, .3575843, .1804808, .212639, .7151687, .0721923, .0193308, .1191948, .9505322), $4a792688e08e5cd7$var$bs = (new $4a792688e08e5cd7$export$8ff26dafa08918).set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, .0415551, .0556301, -0.203977, 1.0569715);
function $4a792688e08e5cd7$var$vs() {
    const t = {
        enabled: !0,
        workingColorSpace: $4a792688e08e5cd7$export$42429b3acfb233a4,
        spaces: {},
        convert: function(t, e, i) {
            return !1 !== this.enabled && e !== i && e && i ? (this.spaces[e].transfer === $4a792688e08e5cd7$export$8d0a61916cc26abb && (t.r = $4a792688e08e5cd7$var$Ms(t.r), t.g = $4a792688e08e5cd7$var$Ms(t.g), t.b = $4a792688e08e5cd7$var$Ms(t.b)), this.spaces[e].primaries !== this.spaces[i].primaries && (t.applyMatrix3(this.spaces[e].toXYZ), t.applyMatrix3(this.spaces[i].fromXYZ)), this.spaces[i].transfer === $4a792688e08e5cd7$export$8d0a61916cc26abb && (t.r = $4a792688e08e5cd7$var$Ss(t.r), t.g = $4a792688e08e5cd7$var$Ss(t.g), t.b = $4a792688e08e5cd7$var$Ss(t.b)), t) : t;
        },
        workingToColorSpace: function(t, e) {
            return this.convert(t, this.workingColorSpace, e);
        },
        colorSpaceToWorking: function(t, e) {
            return this.convert(t, e, this.workingColorSpace);
        },
        getPrimaries: function(t) {
            return this.spaces[t].primaries;
        },
        getTransfer: function(t) {
            return "" === t ? $4a792688e08e5cd7$export$f197347d588c1b4a : this.spaces[t].transfer;
        },
        getToneMappingMode: function(t) {
            return this.spaces[t].outputColorSpaceConfig.toneMappingMode || "standard";
        },
        getLuminanceCoefficients: function(t, e = this.workingColorSpace) {
            return t.fromArray(this.spaces[e].luminanceCoefficients);
        },
        define: function(t) {
            Object.assign(this.spaces, t);
        },
        _getMatrix: function(t, e, i) {
            return t.copy(this.spaces[e].toXYZ).multiply(this.spaces[i].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(t) {
            return this.spaces[t].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(t = this.workingColorSpace) {
            return this.spaces[t].workingColorSpaceConfig.unpackColorSpace;
        },
        fromWorkingColorSpace: function(e, i) {
            return $4a792688e08e5cd7$export$5b28268982f175ba("ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), t.workingToColorSpace(e, i);
        },
        toWorkingColorSpace: function(e, i) {
            return $4a792688e08e5cd7$export$5b28268982f175ba("ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), t.colorSpaceToWorking(e, i);
        }
    }, e = [
        .64,
        .33,
        .3,
        .6,
        .15,
        .06
    ], i = [
        .2126,
        .7152,
        .0722
    ], s = [
        .3127,
        .329
    ];
    return t.define({
        [$4a792688e08e5cd7$export$42429b3acfb233a4]: {
            primaries: e,
            whitePoint: s,
            transfer: $4a792688e08e5cd7$export$f197347d588c1b4a,
            toXYZ: $4a792688e08e5cd7$var$xs,
            fromXYZ: $4a792688e08e5cd7$var$bs,
            luminanceCoefficients: i,
            workingColorSpaceConfig: {
                unpackColorSpace: $4a792688e08e5cd7$export$561f394b24edfcaa
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $4a792688e08e5cd7$export$561f394b24edfcaa
            }
        },
        [$4a792688e08e5cd7$export$561f394b24edfcaa]: {
            primaries: e,
            whitePoint: s,
            transfer: $4a792688e08e5cd7$export$8d0a61916cc26abb,
            toXYZ: $4a792688e08e5cd7$var$xs,
            fromXYZ: $4a792688e08e5cd7$var$bs,
            luminanceCoefficients: i,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $4a792688e08e5cd7$export$561f394b24edfcaa
            }
        }
    }), t;
}
const $4a792688e08e5cd7$export$5e6fd513f44698c = $4a792688e08e5cd7$var$vs();
function $4a792688e08e5cd7$var$Ms(t) {
    return t < .04045 ? .0773993808 * t : Math.pow(.9478672986 * t + .0521327014, 2.4);
}
function $4a792688e08e5cd7$var$Ss(t) {
    return t < .0031308 ? 12.92 * t : 1.055 * Math.pow(t, .41666) - .055;
}
let $4a792688e08e5cd7$var$_s;
class $4a792688e08e5cd7$export$698882cf06df44aa {
    static getDataURL(t, e = "image/png") {
        if (/^data:/i.test(t.src)) return t.src;
        if ("undefined" == typeof HTMLCanvasElement) return t.src;
        let i;
        if (t instanceof HTMLCanvasElement) i = t;
        else {
            void 0 === $4a792688e08e5cd7$var$_s && ($4a792688e08e5cd7$var$_s = $4a792688e08e5cd7$export$7094a064528c7fee("canvas")), $4a792688e08e5cd7$var$_s.width = t.width, $4a792688e08e5cd7$var$_s.height = t.height;
            const e = $4a792688e08e5cd7$var$_s.getContext("2d");
            t instanceof ImageData ? e.putImageData(t, 0, 0) : e.drawImage(t, 0, 0, t.width, t.height), i = $4a792688e08e5cd7$var$_s;
        }
        return i.toDataURL(e);
    }
    static sRGBToLinear(t) {
        if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) {
            const e = $4a792688e08e5cd7$export$7094a064528c7fee("canvas");
            e.width = t.width, e.height = t.height;
            const i = e.getContext("2d");
            i.drawImage(t, 0, 0, t.width, t.height);
            const s = i.getImageData(0, 0, t.width, t.height), r = s.data;
            for(let t = 0; t < r.length; t++)r[t] = 255 * $4a792688e08e5cd7$var$Ms(r[t] / 255);
            return i.putImageData(s, 0, 0), e;
        }
        if (t.data) {
            const e = t.data.slice(0);
            for(let t = 0; t < e.length; t++)e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[t] = Math.floor(255 * $4a792688e08e5cd7$var$Ms(e[t] / 255)) : e[t] = $4a792688e08e5cd7$var$Ms(e[t]);
            return {
                data: e,
                width: t.width,
                height: t.height
            };
        }
        return $4a792688e08e5cd7$export$c106dd0671a0fc2d("ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t;
    }
}
let $4a792688e08e5cd7$var$Ts = 0;
class $4a792688e08e5cd7$export$1d2df86270c81ecb {
    constructor(t = null){
        this.isSource = !0, Object.defineProperty(this, "id", {
            value: $4a792688e08e5cd7$var$Ts++
        }), this.uuid = $4a792688e08e5cd7$var$rs(), this.data = t, this.dataReady = !0, this.version = 0;
    }
    getSize(t) {
        const e = this.data;
        return "undefined" != typeof HTMLVideoElement && e instanceof HTMLVideoElement ? t.set(e.videoWidth, e.videoHeight, 0) : e instanceof VideoFrame ? t.set(e.displayHeight, e.displayWidth, 0) : null !== e ? t.set(e.width, e.height, e.depth || 0) : t.set(0, 0, 0), t;
    }
    set needsUpdate(t) {
        !0 === t && this.version++;
    }
    toJSON(t) {
        const e = void 0 === t || "string" == typeof t;
        if (!e && void 0 !== t.images[this.uuid]) return t.images[this.uuid];
        const i = {
            uuid: this.uuid,
            url: ""
        }, s = this.data;
        if (null !== s) {
            let t;
            if (Array.isArray(s)) {
                t = [];
                for(let e = 0, i = s.length; e < i; e++)s[e].isDataTexture ? t.push($4a792688e08e5cd7$var$Cs(s[e].image)) : t.push($4a792688e08e5cd7$var$Cs(s[e]));
            } else t = $4a792688e08e5cd7$var$Cs(s);
            i.url = t;
        }
        return e || (t.images[this.uuid] = i), i;
    }
}
function $4a792688e08e5cd7$var$Cs(t) {
    return "undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap ? $4a792688e08e5cd7$export$698882cf06df44aa.getDataURL(t) : t.data ? {
        data: Array.from(t.data),
        width: t.width,
        height: t.height,
        type: t.data.constructor.name
    } : ($4a792688e08e5cd7$export$c106dd0671a0fc2d("Texture: Unable to serialize Texture."), {});
}
let $4a792688e08e5cd7$var$Is = 0;
const $4a792688e08e5cd7$var$Bs = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$5431306cf43de24a extends $4a792688e08e5cd7$export$ec8b666c5fe2c75a {
    constructor(t = $4a792688e08e5cd7$export$5431306cf43de24a.DEFAULT_IMAGE, e = $4a792688e08e5cd7$export$5431306cf43de24a.DEFAULT_MAPPING, i = 1001, s = 1001, r = 1006, n = 1008, a = 1023, o = 1009, h = $4a792688e08e5cd7$export$5431306cf43de24a.DEFAULT_ANISOTROPY, l = ""){
        super(), this.isTexture = !0, Object.defineProperty(this, "id", {
            value: $4a792688e08e5cd7$var$Is++
        }), this.uuid = $4a792688e08e5cd7$var$rs(), this.name = "", this.source = new $4a792688e08e5cd7$export$1d2df86270c81ecb(t), this.mipmaps = [], this.mapping = e, this.channel = 0, this.wrapS = i, this.wrapT = s, this.magFilter = r, this.minFilter = n, this.anisotropy = h, this.format = a, this.internalFormat = null, this.type = o, this.offset = new $4a792688e08e5cd7$export$c977b3e384af9ae1(0, 0), this.repeat = new $4a792688e08e5cd7$export$c977b3e384af9ae1(1, 1), this.center = new $4a792688e08e5cd7$export$c977b3e384af9ae1(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new $4a792688e08e5cd7$export$8ff26dafa08918, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = l, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(t && t.depth && t.depth > 1), this.pmremVersion = 0;
    }
    get width() {
        return this.source.getSize($4a792688e08e5cd7$var$Bs).x;
    }
    get height() {
        return this.source.getSize($4a792688e08e5cd7$var$Bs).y;
    }
    get depth() {
        return this.source.getSize($4a792688e08e5cd7$var$Bs).z;
    }
    get image() {
        return this.source.data;
    }
    set image(t = null) {
        this.source.data = t;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    addUpdateRange(t, e) {
        this.updateRanges.push({
            start: t,
            count: e
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t) {
        return this.name = t.name, this.source = t.source, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.channel = t.channel, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.colorSpace = t.colorSpace, this.renderTarget = t.renderTarget, this.isRenderTargetTexture = t.isRenderTargetTexture, this.isArrayTexture = t.isArrayTexture, this.userData = JSON.parse(JSON.stringify(t.userData)), this.needsUpdate = !0, this;
    }
    setValues(t) {
        for(const e in t){
            const i = t[e];
            if (void 0 === i) {
                $4a792688e08e5cd7$export$c106dd0671a0fc2d(`Texture.setValues(): parameter '${e}' has value of undefined.`);
                continue;
            }
            const s = this[e];
            void 0 !== s ? s && i && s.isVector2 && i.isVector2 || s && i && s.isVector3 && i.isVector3 || s && i && s.isMatrix3 && i.isMatrix3 ? s.copy(i) : this[e] = i : $4a792688e08e5cd7$export$c106dd0671a0fc2d(`Texture.setValues(): property '${e}' does not exist.`);
        }
    }
    toJSON(t) {
        const e = void 0 === t || "string" == typeof t;
        if (!e && void 0 !== t.textures[this.uuid]) return t.textures[this.uuid];
        const i = {
            metadata: {
                version: 4.7,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(t).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        return Object.keys(this.userData).length > 0 && (i.userData = this.userData), e || (t.textures[this.uuid] = i), i;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(t) {
        if (this.mapping !== $4a792688e08e5cd7$export$1beec6768cbb3d2d) return t;
        if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1) switch(this.wrapS){
            case $4a792688e08e5cd7$export$533346c8e8dac0f5:
                t.x = t.x - Math.floor(t.x);
                break;
            case $4a792688e08e5cd7$export$9d9334239a5a5e06:
                t.x = t.x < 0 ? 0 : 1;
                break;
            case $4a792688e08e5cd7$export$c7e7c00b14f51a4f:
                1 === Math.abs(Math.floor(t.x) % 2) ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
        }
        if (t.y < 0 || t.y > 1) switch(this.wrapT){
            case $4a792688e08e5cd7$export$533346c8e8dac0f5:
                t.y = t.y - Math.floor(t.y);
                break;
            case $4a792688e08e5cd7$export$9d9334239a5a5e06:
                t.y = t.y < 0 ? 0 : 1;
                break;
            case $4a792688e08e5cd7$export$c7e7c00b14f51a4f:
                1 === Math.abs(Math.floor(t.y) % 2) ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
        }
        return this.flipY && (t.y = 1 - t.y), t;
    }
    set needsUpdate(t) {
        !0 === t && (this.version++, this.source.needsUpdate = !0);
    }
    set needsPMREMUpdate(t) {
        !0 === t && this.pmremVersion++;
    }
}
$4a792688e08e5cd7$export$5431306cf43de24a.DEFAULT_IMAGE = null, $4a792688e08e5cd7$export$5431306cf43de24a.DEFAULT_MAPPING = $4a792688e08e5cd7$export$1beec6768cbb3d2d, $4a792688e08e5cd7$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $4a792688e08e5cd7$export$fa7daccca11cdbe3 {
    constructor(t = 0, e = 0, i = 0, s = 1){
        $4a792688e08e5cd7$export$fa7daccca11cdbe3.prototype.isVector4 = !0, this.x = t, this.y = e, this.z = i, this.w = s;
    }
    get width() {
        return this.z;
    }
    set width(t) {
        this.z = t;
    }
    get height() {
        return this.w;
    }
    set height(t) {
        this.w = t;
    }
    set(t, e, i, s) {
        return this.x = t, this.y = e, this.z = i, this.w = s, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this.w = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setZ(t) {
        return this.z = t, this;
    }
    setW(t) {
        return this.w = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            case 3:
                this.w = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this.w = void 0 !== t.w ? t.w : 1, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this.w += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
    }
    applyMatrix4(t) {
        const e = this.x, i = this.y, s = this.z, r = this.w, n = t.elements;
        return this.x = n[0] * e + n[4] * i + n[8] * s + n[12] * r, this.y = n[1] * e + n[5] * i + n[9] * s + n[13] * r, this.z = n[2] * e + n[6] * i + n[10] * s + n[14] * r, this.w = n[3] * e + n[7] * i + n[11] * s + n[15] * r, this;
    }
    divide(t) {
        return this.x /= t.x, this.y /= t.y, this.z /= t.z, this.w /= t.w, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    setAxisAngleFromQuaternion(t) {
        this.w = 2 * Math.acos(t.w);
        const e = Math.sqrt(1 - t.w * t.w);
        return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
    }
    setAxisAngleFromRotationMatrix(t) {
        let e, i, s, r;
        const n = .01, a = .1, o = t.elements, h = o[0], l = o[4], c = o[8], u = o[1], d = o[5], p = o[9], m = o[2], y = o[6], g = o[10];
        if (Math.abs(l - u) < n && Math.abs(c - m) < n && Math.abs(p - y) < n) {
            if (Math.abs(l + u) < a && Math.abs(c + m) < a && Math.abs(p + y) < a && Math.abs(h + d + g - 3) < a) return this.set(1, 0, 0, 0), this;
            e = Math.PI;
            const t = (h + 1) / 2, o = (d + 1) / 2, f = (g + 1) / 2, x = (l + u) / 4, b = (c + m) / 4, v = (p + y) / 4;
            return t > o && t > f ? t < n ? (i = 0, s = .707106781, r = .707106781) : (i = Math.sqrt(t), s = x / i, r = b / i) : o > f ? o < n ? (i = .707106781, s = 0, r = .707106781) : (s = Math.sqrt(o), i = x / s, r = v / s) : f < n ? (i = .707106781, s = .707106781, r = 0) : (r = Math.sqrt(f), i = b / r, s = v / r), this.set(i, s, r, e), this;
        }
        let f = Math.sqrt((y - p) * (y - p) + (c - m) * (c - m) + (u - l) * (u - l));
        return Math.abs(f) < .001 && (f = 1), this.x = (y - p) / f, this.y = (c - m) / f, this.z = (u - l) / f, this.w = Math.acos((h + d + g - 1) / 2), this;
    }
    setFromMatrixPosition(t) {
        const e = t.elements;
        return this.x = e[12], this.y = e[13], this.z = e[14], this.w = e[15], this;
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
    }
    clamp(t, e) {
        return this.x = $4a792688e08e5cd7$var$ns(this.x, t.x, e.x), this.y = $4a792688e08e5cd7$var$ns(this.y, t.y, e.y), this.z = $4a792688e08e5cd7$var$ns(this.z, t.z, e.z), this.w = $4a792688e08e5cd7$var$ns(this.w, t.w, e.w), this;
    }
    clampScalar(t, e) {
        return this.x = $4a792688e08e5cd7$var$ns(this.x, t, e), this.y = $4a792688e08e5cd7$var$ns(this.y, t, e), this.z = $4a792688e08e5cd7$var$ns(this.z, t, e), this.w = $4a792688e08e5cd7$var$ns(this.w, t, e), this;
    }
    clampLength(t, e) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($4a792688e08e5cd7$var$ns(i, t, e));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
    }
    lerpVectors(t, e, i) {
        return this.x = t.x + (e.x - t.x) * i, this.y = t.y + (e.y - t.y) * i, this.z = t.z + (e.z - t.z) * i, this.w = t.w + (e.w - t.w) * i, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z, yield this.w;
    }
}
class $4a792688e08e5cd7$export$efcb1f8bf367cbfb extends $4a792688e08e5cd7$export$ec8b666c5fe2c75a {
    constructor(t = 1, e = 1, i = {}){
        super(), i = Object.assign({
            generateMipmaps: !1,
            internalFormat: null,
            minFilter: $4a792688e08e5cd7$export$8a72f490b25c56c8,
            depthBuffer: !0,
            stencilBuffer: !1,
            resolveDepthBuffer: !0,
            resolveStencilBuffer: !0,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: !1
        }, i), this.isRenderTarget = !0, this.width = t, this.height = e, this.depth = i.depth, this.scissor = new $4a792688e08e5cd7$export$fa7daccca11cdbe3(0, 0, t, e), this.scissorTest = !1, this.viewport = new $4a792688e08e5cd7$export$fa7daccca11cdbe3(0, 0, t, e);
        const s = {
            width: t,
            height: e,
            depth: i.depth
        }, r = new $4a792688e08e5cd7$export$5431306cf43de24a(s);
        this.textures = [];
        const n = i.count;
        for(let t = 0; t < n; t++)this.textures[t] = r.clone(), this.textures[t].isRenderTargetTexture = !0, this.textures[t].renderTarget = this;
        this._setTextureOptions(i), this.depthBuffer = i.depthBuffer, this.stencilBuffer = i.stencilBuffer, this.resolveDepthBuffer = i.resolveDepthBuffer, this.resolveStencilBuffer = i.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = i.depthTexture, this.samples = i.samples, this.multiview = i.multiview;
    }
    _setTextureOptions(t = {}) {
        const e = {
            minFilter: $4a792688e08e5cd7$export$8a72f490b25c56c8,
            generateMipmaps: !1,
            flipY: !1,
            internalFormat: null
        };
        void 0 !== t.mapping && (e.mapping = t.mapping), void 0 !== t.wrapS && (e.wrapS = t.wrapS), void 0 !== t.wrapT && (e.wrapT = t.wrapT), void 0 !== t.wrapR && (e.wrapR = t.wrapR), void 0 !== t.magFilter && (e.magFilter = t.magFilter), void 0 !== t.minFilter && (e.minFilter = t.minFilter), void 0 !== t.format && (e.format = t.format), void 0 !== t.type && (e.type = t.type), void 0 !== t.anisotropy && (e.anisotropy = t.anisotropy), void 0 !== t.colorSpace && (e.colorSpace = t.colorSpace), void 0 !== t.flipY && (e.flipY = t.flipY), void 0 !== t.generateMipmaps && (e.generateMipmaps = t.generateMipmaps), void 0 !== t.internalFormat && (e.internalFormat = t.internalFormat);
        for(let t = 0; t < this.textures.length; t++)this.textures[t].setValues(e);
    }
    get texture() {
        return this.textures[0];
    }
    set texture(t) {
        this.textures[0] = t;
    }
    set depthTexture(t) {
        null !== this._depthTexture && (this._depthTexture.renderTarget = null), null !== t && (t.renderTarget = this), this._depthTexture = t;
    }
    get depthTexture() {
        return this._depthTexture;
    }
    setSize(t, e, i = 1) {
        if (this.width !== t || this.height !== e || this.depth !== i) {
            this.width = t, this.height = e, this.depth = i;
            for(let s = 0, r = this.textures.length; s < r; s++)this.textures[s].image.width = t, this.textures[s].image.height = e, this.textures[s].image.depth = i, !0 !== this.textures[s].isData3DTexture && (this.textures[s].isArrayTexture = this.textures[s].image.depth > 1);
            this.dispose();
        }
        this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t) {
        this.width = t.width, this.height = t.height, this.depth = t.depth, this.scissor.copy(t.scissor), this.scissorTest = t.scissorTest, this.viewport.copy(t.viewport), this.textures.length = 0;
        for(let e = 0, i = t.textures.length; e < i; e++){
            this.textures[e] = t.textures[e].clone(), this.textures[e].isRenderTargetTexture = !0, this.textures[e].renderTarget = this;
            const i = Object.assign({}, t.textures[e].image);
            this.textures[e].source = new $4a792688e08e5cd7$export$1d2df86270c81ecb(i);
        }
        return this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, this.resolveDepthBuffer = t.resolveDepthBuffer, this.resolveStencilBuffer = t.resolveStencilBuffer, null !== t.depthTexture && (this.depthTexture = t.depthTexture.clone()), this.samples = t.samples, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $4a792688e08e5cd7$export$3c052beb2e51e23f extends $4a792688e08e5cd7$export$efcb1f8bf367cbfb {
    constructor(t = 1, e = 1, i = {}){
        super(t, e, i), this.isWebGLRenderTarget = !0;
    }
}
class $4a792688e08e5cd7$export$dfac6c8e811406a3 extends $4a792688e08e5cd7$export$5431306cf43de24a {
    constructor(t = null, e = 1, i = 1, s = 1){
        super(null), this.isDataArrayTexture = !0, this.image = {
            data: t,
            width: e,
            height: i,
            depth: s
        }, this.magFilter = $4a792688e08e5cd7$export$727aa5ec3fe39bf0, this.minFilter = $4a792688e08e5cd7$export$727aa5ec3fe39bf0, this.wrapR = $4a792688e08e5cd7$export$9d9334239a5a5e06, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = new Set;
    }
    addLayerUpdate(t) {
        this.layerUpdates.add(t);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $4a792688e08e5cd7$export$c77a02c11ed180c7 extends $4a792688e08e5cd7$export$3c052beb2e51e23f {
    constructor(t = 1, e = 1, i = 1, s = {}){
        super(t, e, s), this.isWebGLArrayRenderTarget = !0, this.depth = i, this.texture = new $4a792688e08e5cd7$export$dfac6c8e811406a3(null, t, e, i), this._setTextureOptions(s), this.texture.isRenderTargetTexture = !0;
    }
}
class $4a792688e08e5cd7$export$d7a3086320f856db extends $4a792688e08e5cd7$export$5431306cf43de24a {
    constructor(t = null, e = 1, i = 1, s = 1){
        super(null), this.isData3DTexture = !0, this.image = {
            data: t,
            width: e,
            height: i,
            depth: s
        }, this.magFilter = $4a792688e08e5cd7$export$727aa5ec3fe39bf0, this.minFilter = $4a792688e08e5cd7$export$727aa5ec3fe39bf0, this.wrapR = $4a792688e08e5cd7$export$9d9334239a5a5e06, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
class $4a792688e08e5cd7$export$7ee06591009639df extends $4a792688e08e5cd7$export$3c052beb2e51e23f {
    constructor(t = 1, e = 1, i = 1, s = {}){
        super(t, e, s), this.isWebGL3DRenderTarget = !0, this.depth = i, this.texture = new $4a792688e08e5cd7$export$d7a3086320f856db(null, t, e, i), this._setTextureOptions(s), this.texture.isRenderTargetTexture = !0;
    }
}
class $4a792688e08e5cd7$export$6f7d5a9418ab2aa3 {
    constructor(t = new $4a792688e08e5cd7$export$64b5c384219d3699(1 / 0, 1 / 0, 1 / 0), e = new $4a792688e08e5cd7$export$64b5c384219d3699(-1 / 0, -1 / 0, -1 / 0)){
        this.isBox3 = !0, this.min = t, this.max = e;
    }
    set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
    }
    setFromArray(t) {
        this.makeEmpty();
        for(let e = 0, i = t.length; e < i; e += 3)this.expandByPoint($4a792688e08e5cd7$var$Ds.fromArray(t, e));
        return this;
    }
    setFromBufferAttribute(t) {
        this.makeEmpty();
        for(let e = 0, i = t.count; e < i; e++)this.expandByPoint($4a792688e08e5cd7$var$Ds.fromBufferAttribute(t, e));
        return this;
    }
    setFromPoints(t) {
        this.makeEmpty();
        for(let e = 0, i = t.length; e < i; e++)this.expandByPoint(t[e]);
        return this;
    }
    setFromCenterAndSize(t, e) {
        const i = $4a792688e08e5cd7$var$Ds.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(i), this.max.copy(t).add(i), this;
    }
    setFromObject(t, e = !1) {
        return this.makeEmpty(), this.expandByObject(t, e);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
    }
    expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
    }
    expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
    }
    expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
    expandByObject(t, e = !1) {
        t.updateWorldMatrix(!1, !1);
        const i = t.geometry;
        if (void 0 !== i) {
            const s = i.getAttribute("position");
            if (!0 === e && void 0 !== s && !0 !== t.isInstancedMesh) for(let e = 0, i = s.count; e < i; e++)!0 === t.isMesh ? t.getVertexPosition(e, $4a792688e08e5cd7$var$Ds) : $4a792688e08e5cd7$var$Ds.fromBufferAttribute(s, e), $4a792688e08e5cd7$var$Ds.applyMatrix4(t.matrixWorld), this.expandByPoint($4a792688e08e5cd7$var$Ds);
            else void 0 !== t.boundingBox ? (null === t.boundingBox && t.computeBoundingBox(), $4a792688e08e5cd7$var$Ws.copy(t.boundingBox)) : (null === i.boundingBox && i.computeBoundingBox(), $4a792688e08e5cd7$var$Ws.copy(i.boundingBox)), $4a792688e08e5cd7$var$Ws.applyMatrix4(t.matrixWorld), this.union($4a792688e08e5cd7$var$Ws);
        }
        const s = t.children;
        for(let t = 0, i = s.length; t < i; t++)this.expandByObject(s[t], e);
        return this;
    }
    containsPoint(t) {
        return t.x >= this.min.x && t.x <= this.max.x && t.y >= this.min.y && t.y <= this.max.y && t.z >= this.min.z && t.z <= this.max.z;
    }
    containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
    }
    getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y), (t.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(t) {
        return t.max.x >= this.min.x && t.min.x <= this.max.x && t.max.y >= this.min.y && t.min.y <= this.max.y && t.max.z >= this.min.z && t.min.z <= this.max.z;
    }
    intersectsSphere(t) {
        return this.clampPoint(t.center, $4a792688e08e5cd7$var$Ds), $4a792688e08e5cd7$var$Ds.distanceToSquared(t.center) <= t.radius * t.radius;
    }
    intersectsPlane(t) {
        let e, i;
        return t.normal.x > 0 ? (e = t.normal.x * this.min.x, i = t.normal.x * this.max.x) : (e = t.normal.x * this.max.x, i = t.normal.x * this.min.x), t.normal.y > 0 ? (e += t.normal.y * this.min.y, i += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, i += t.normal.y * this.min.y), t.normal.z > 0 ? (e += t.normal.z * this.min.z, i += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, i += t.normal.z * this.min.z), e <= -t.constant && i >= -t.constant;
    }
    intersectsTriangle(t) {
        if (this.isEmpty()) return !1;
        this.getCenter($4a792688e08e5cd7$var$Hs), $4a792688e08e5cd7$var$Gs.subVectors(this.max, $4a792688e08e5cd7$var$Hs), $4a792688e08e5cd7$var$Us.subVectors(t.a, $4a792688e08e5cd7$var$Hs), $4a792688e08e5cd7$var$qs.subVectors(t.b, $4a792688e08e5cd7$var$Hs), $4a792688e08e5cd7$var$Js.subVectors(t.c, $4a792688e08e5cd7$var$Hs), $4a792688e08e5cd7$var$Xs.subVectors($4a792688e08e5cd7$var$qs, $4a792688e08e5cd7$var$Us), $4a792688e08e5cd7$var$Ys.subVectors($4a792688e08e5cd7$var$Js, $4a792688e08e5cd7$var$qs), $4a792688e08e5cd7$var$Zs.subVectors($4a792688e08e5cd7$var$Us, $4a792688e08e5cd7$var$Js);
        let e = [
            0,
            -$4a792688e08e5cd7$var$Xs.z,
            $4a792688e08e5cd7$var$Xs.y,
            0,
            -$4a792688e08e5cd7$var$Ys.z,
            $4a792688e08e5cd7$var$Ys.y,
            0,
            -$4a792688e08e5cd7$var$Zs.z,
            $4a792688e08e5cd7$var$Zs.y,
            $4a792688e08e5cd7$var$Xs.z,
            0,
            -$4a792688e08e5cd7$var$Xs.x,
            $4a792688e08e5cd7$var$Ys.z,
            0,
            -$4a792688e08e5cd7$var$Ys.x,
            $4a792688e08e5cd7$var$Zs.z,
            0,
            -$4a792688e08e5cd7$var$Zs.x,
            -$4a792688e08e5cd7$var$Xs.y,
            $4a792688e08e5cd7$var$Xs.x,
            0,
            -$4a792688e08e5cd7$var$Ys.y,
            $4a792688e08e5cd7$var$Ys.x,
            0,
            -$4a792688e08e5cd7$var$Zs.y,
            $4a792688e08e5cd7$var$Zs.x,
            0
        ];
        return !!$4a792688e08e5cd7$var$Ks(e, $4a792688e08e5cd7$var$Us, $4a792688e08e5cd7$var$qs, $4a792688e08e5cd7$var$Js, $4a792688e08e5cd7$var$Gs) && (e = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], !!$4a792688e08e5cd7$var$Ks(e, $4a792688e08e5cd7$var$Us, $4a792688e08e5cd7$var$qs, $4a792688e08e5cd7$var$Js, $4a792688e08e5cd7$var$Gs) && ($4a792688e08e5cd7$var$$s.crossVectors($4a792688e08e5cd7$var$Xs, $4a792688e08e5cd7$var$Ys), e = [
            $4a792688e08e5cd7$var$$s.x,
            $4a792688e08e5cd7$var$$s.y,
            $4a792688e08e5cd7$var$$s.z
        ], $4a792688e08e5cd7$var$Ks(e, $4a792688e08e5cd7$var$Us, $4a792688e08e5cd7$var$qs, $4a792688e08e5cd7$var$Js, $4a792688e08e5cd7$var$Gs)));
    }
    clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
    }
    distanceToPoint(t) {
        return this.clampPoint(t, $4a792688e08e5cd7$var$Ds).distanceTo(t);
    }
    getBoundingSphere(t) {
        return this.isEmpty() ? t.makeEmpty() : (this.getCenter(t.center), t.radius = .5 * this.getSize($4a792688e08e5cd7$var$Ds).length()), t;
    }
    intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
    }
    applyMatrix4(t) {
        return this.isEmpty() || ($4a792688e08e5cd7$var$js[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), $4a792688e08e5cd7$var$js[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), $4a792688e08e5cd7$var$js[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), $4a792688e08e5cd7$var$js[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), $4a792688e08e5cd7$var$js[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), $4a792688e08e5cd7$var$js[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), $4a792688e08e5cd7$var$js[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), $4a792688e08e5cd7$var$js[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints($4a792688e08e5cd7$var$js)), this;
    }
    translate(t) {
        return this.min.add(t), this.max.add(t), this;
    }
    equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
    }
    toJSON() {
        return {
            min: this.min.toArray(),
            max: this.max.toArray()
        };
    }
    fromJSON(t) {
        return this.min.fromArray(t.min), this.max.fromArray(t.max), this;
    }
}
const $4a792688e08e5cd7$var$js = [
    new $4a792688e08e5cd7$export$64b5c384219d3699,
    new $4a792688e08e5cd7$export$64b5c384219d3699,
    new $4a792688e08e5cd7$export$64b5c384219d3699,
    new $4a792688e08e5cd7$export$64b5c384219d3699,
    new $4a792688e08e5cd7$export$64b5c384219d3699,
    new $4a792688e08e5cd7$export$64b5c384219d3699,
    new $4a792688e08e5cd7$export$64b5c384219d3699,
    new $4a792688e08e5cd7$export$64b5c384219d3699
], $4a792688e08e5cd7$var$Ds = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Ws = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3, $4a792688e08e5cd7$var$Us = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$qs = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Js = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Xs = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Ys = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Zs = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Hs = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Gs = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$$s = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Qs = new $4a792688e08e5cd7$export$64b5c384219d3699;
function $4a792688e08e5cd7$var$Ks(t, e, i, s, r) {
    for(let n = 0, a = t.length - 3; n <= a; n += 3){
        $4a792688e08e5cd7$var$Qs.fromArray(t, n);
        const a = r.x * Math.abs($4a792688e08e5cd7$var$Qs.x) + r.y * Math.abs($4a792688e08e5cd7$var$Qs.y) + r.z * Math.abs($4a792688e08e5cd7$var$Qs.z), o = e.dot($4a792688e08e5cd7$var$Qs), h = i.dot($4a792688e08e5cd7$var$Qs), l = s.dot($4a792688e08e5cd7$var$Qs);
        if (Math.max(-Math.max(o, h, l), Math.min(o, h, l)) > a) return !1;
    }
    return !0;
}
const $4a792688e08e5cd7$var$tr = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3, $4a792688e08e5cd7$var$er = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$ir = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$805e8b72413ccaba {
    constructor(t = new $4a792688e08e5cd7$export$64b5c384219d3699, e = -1){
        this.isSphere = !0, this.center = t, this.radius = e;
    }
    set(t, e) {
        return this.center.copy(t), this.radius = e, this;
    }
    setFromPoints(t, e) {
        const i = this.center;
        void 0 !== e ? i.copy(e) : $4a792688e08e5cd7$var$tr.setFromPoints(t).getCenter(i);
        let s = 0;
        for(let e = 0, r = t.length; e < r; e++)s = Math.max(s, i.distanceToSquared(t[e]));
        return this.radius = Math.sqrt(s), this;
    }
    copy(t) {
        return this.center.copy(t.center), this.radius = t.radius, this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        return this.center.set(0, 0, 0), this.radius = -1, this;
    }
    containsPoint(t) {
        return t.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(t) {
        return t.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(t) {
        const e = this.radius + t.radius;
        return t.center.distanceToSquared(this.center) <= e * e;
    }
    intersectsBox(t) {
        return t.intersectsSphere(this);
    }
    intersectsPlane(t) {
        return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(t, e) {
        const i = this.center.distanceToSquared(t);
        return e.copy(t), i > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
    }
    getBoundingBox(t) {
        return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
    }
    applyMatrix4(t) {
        return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
    }
    translate(t) {
        return this.center.add(t), this;
    }
    expandByPoint(t) {
        if (this.isEmpty()) return this.center.copy(t), this.radius = 0, this;
        $4a792688e08e5cd7$var$er.subVectors(t, this.center);
        const e = $4a792688e08e5cd7$var$er.lengthSq();
        if (e > this.radius * this.radius) {
            const t = Math.sqrt(e), i = .5 * (t - this.radius);
            this.center.addScaledVector($4a792688e08e5cd7$var$er, i / t), this.radius += i;
        }
        return this;
    }
    union(t) {
        return t.isEmpty() ? this : this.isEmpty() ? (this.copy(t), this) : (!0 === this.center.equals(t.center) ? this.radius = Math.max(this.radius, t.radius) : ($4a792688e08e5cd7$var$ir.subVectors(t.center, this.center).setLength(t.radius), this.expandByPoint($4a792688e08e5cd7$var$er.copy(t.center).add($4a792688e08e5cd7$var$ir)), this.expandByPoint($4a792688e08e5cd7$var$er.copy(t.center).sub($4a792688e08e5cd7$var$ir))), this);
    }
    equals(t) {
        return t.center.equals(this.center) && t.radius === this.radius;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    toJSON() {
        return {
            radius: this.radius,
            center: this.center.toArray()
        };
    }
    fromJSON(t) {
        return this.radius = t.radius, this.center.fromArray(t.center), this;
    }
}
const $4a792688e08e5cd7$var$rr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$nr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$ar = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$or = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$hr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$lr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$cr = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$a186db52eed6d40e {
    constructor(t = new $4a792688e08e5cd7$export$64b5c384219d3699, e = new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0, -1)){
        this.origin = t, this.direction = e;
    }
    set(t, e) {
        return this.origin.copy(t), this.direction.copy(e), this;
    }
    copy(t) {
        return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
    }
    at(t, e) {
        return e.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(t) {
        return this.direction.copy(t).sub(this.origin).normalize(), this;
    }
    recast(t) {
        return this.origin.copy(this.at(t, $4a792688e08e5cd7$var$rr)), this;
    }
    closestPointToPoint(t, e) {
        e.subVectors(t, this.origin);
        const i = e.dot(this.direction);
        return i < 0 ? e.copy(this.origin) : e.copy(this.origin).addScaledVector(this.direction, i);
    }
    distanceToPoint(t) {
        return Math.sqrt(this.distanceSqToPoint(t));
    }
    distanceSqToPoint(t) {
        const e = $4a792688e08e5cd7$var$rr.subVectors(t, this.origin).dot(this.direction);
        return e < 0 ? this.origin.distanceToSquared(t) : ($4a792688e08e5cd7$var$rr.copy(this.origin).addScaledVector(this.direction, e), $4a792688e08e5cd7$var$rr.distanceToSquared(t));
    }
    distanceSqToSegment(t, e, i, s) {
        $4a792688e08e5cd7$var$nr.copy(t).add(e).multiplyScalar(.5), $4a792688e08e5cd7$var$ar.copy(e).sub(t).normalize(), $4a792688e08e5cd7$var$or.copy(this.origin).sub($4a792688e08e5cd7$var$nr);
        const r = .5 * t.distanceTo(e), n = -this.direction.dot($4a792688e08e5cd7$var$ar), a = $4a792688e08e5cd7$var$or.dot(this.direction), o = -$4a792688e08e5cd7$var$or.dot($4a792688e08e5cd7$var$ar), h = $4a792688e08e5cd7$var$or.lengthSq(), l = Math.abs(1 - n * n);
        let c, u, d, p;
        if (l > 0) {
            if (c = n * o - a, u = n * a - o, p = r * l, c >= 0) {
                if (u >= -p) {
                    if (u <= p) {
                        const t = 1 / l;
                        c *= t, u *= t, d = c * (c + n * u + 2 * a) + u * (n * c + u + 2 * o) + h;
                    } else u = r, c = Math.max(0, -(n * u + a)), d = -c * c + u * (u + 2 * o) + h;
                } else u = -r, c = Math.max(0, -(n * u + a)), d = -c * c + u * (u + 2 * o) + h;
            } else u <= -p ? (c = Math.max(0, -(-n * r + a)), u = c > 0 ? -r : Math.min(Math.max(-r, -o), r), d = -c * c + u * (u + 2 * o) + h) : u <= p ? (c = 0, u = Math.min(Math.max(-r, -o), r), d = u * (u + 2 * o) + h) : (c = Math.max(0, -(n * r + a)), u = c > 0 ? r : Math.min(Math.max(-r, -o), r), d = -c * c + u * (u + 2 * o) + h);
        } else u = n > 0 ? -r : r, c = Math.max(0, -(n * u + a)), d = -c * c + u * (u + 2 * o) + h;
        return i && i.copy(this.origin).addScaledVector(this.direction, c), s && s.copy($4a792688e08e5cd7$var$nr).addScaledVector($4a792688e08e5cd7$var$ar, u), d;
    }
    intersectSphere(t, e) {
        $4a792688e08e5cd7$var$rr.subVectors(t.center, this.origin);
        const i = $4a792688e08e5cd7$var$rr.dot(this.direction), s = $4a792688e08e5cd7$var$rr.dot($4a792688e08e5cd7$var$rr) - i * i, r = t.radius * t.radius;
        if (s > r) return null;
        const n = Math.sqrt(r - s), a = i - n, o = i + n;
        return o < 0 ? null : a < 0 ? this.at(o, e) : this.at(a, e);
    }
    intersectsSphere(t) {
        return !(t.radius < 0) && this.distanceSqToPoint(t.center) <= t.radius * t.radius;
    }
    distanceToPlane(t) {
        const e = t.normal.dot(this.direction);
        if (0 === e) return 0 === t.distanceToPoint(this.origin) ? 0 : null;
        const i = -(this.origin.dot(t.normal) + t.constant) / e;
        return i >= 0 ? i : null;
    }
    intersectPlane(t, e) {
        const i = this.distanceToPlane(t);
        return null === i ? null : this.at(i, e);
    }
    intersectsPlane(t) {
        const e = t.distanceToPoint(this.origin);
        if (0 === e) return !0;
        return t.normal.dot(this.direction) * e < 0;
    }
    intersectBox(t, e) {
        let i, s, r, n, a, o;
        const h = 1 / this.direction.x, l = 1 / this.direction.y, c = 1 / this.direction.z, u = this.origin;
        return h >= 0 ? (i = (t.min.x - u.x) * h, s = (t.max.x - u.x) * h) : (i = (t.max.x - u.x) * h, s = (t.min.x - u.x) * h), l >= 0 ? (r = (t.min.y - u.y) * l, n = (t.max.y - u.y) * l) : (r = (t.max.y - u.y) * l, n = (t.min.y - u.y) * l), i > n || r > s ? null : ((r > i || isNaN(i)) && (i = r), (n < s || isNaN(s)) && (s = n), c >= 0 ? (a = (t.min.z - u.z) * c, o = (t.max.z - u.z) * c) : (a = (t.max.z - u.z) * c, o = (t.min.z - u.z) * c), i > o || a > s ? null : ((a > i || i != i) && (i = a), (o < s || s != s) && (s = o), s < 0 ? null : this.at(i >= 0 ? i : s, e)));
    }
    intersectsBox(t) {
        return null !== this.intersectBox(t, $4a792688e08e5cd7$var$rr);
    }
    intersectTriangle(t, e, i, s, r) {
        $4a792688e08e5cd7$var$hr.subVectors(e, t), $4a792688e08e5cd7$var$lr.subVectors(i, t), $4a792688e08e5cd7$var$cr.crossVectors($4a792688e08e5cd7$var$hr, $4a792688e08e5cd7$var$lr);
        let n, a = this.direction.dot($4a792688e08e5cd7$var$cr);
        if (a > 0) {
            if (s) return null;
            n = 1;
        } else {
            if (!(a < 0)) return null;
            n = -1, a = -a;
        }
        $4a792688e08e5cd7$var$or.subVectors(this.origin, t);
        const o = n * this.direction.dot($4a792688e08e5cd7$var$lr.crossVectors($4a792688e08e5cd7$var$or, $4a792688e08e5cd7$var$lr));
        if (o < 0) return null;
        const h = n * this.direction.dot($4a792688e08e5cd7$var$hr.cross($4a792688e08e5cd7$var$or));
        if (h < 0) return null;
        if (o + h > a) return null;
        const l = -n * $4a792688e08e5cd7$var$or.dot($4a792688e08e5cd7$var$cr);
        return l < 0 ? null : this.at(l / a, r);
    }
    applyMatrix4(t) {
        return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
    }
    equals(t) {
        return t.origin.equals(this.origin) && t.direction.equals(this.direction);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
class $4a792688e08e5cd7$export$2ae72fc923e5eb5 {
    constructor(t, e, i, s, r, n, a, o, h, l, c, u, d, p, m, y){
        $4a792688e08e5cd7$export$2ae72fc923e5eb5.prototype.isMatrix4 = !0, this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ], void 0 !== t && this.set(t, e, i, s, r, n, a, o, h, l, c, u, d, p, m, y);
    }
    set(t, e, i, s, r, n, a, o, h, l, c, u, d, p, m, y) {
        const g = this.elements;
        return g[0] = t, g[4] = e, g[8] = i, g[12] = s, g[1] = r, g[5] = n, g[9] = a, g[13] = o, g[2] = h, g[6] = l, g[10] = c, g[14] = u, g[3] = d, g[7] = p, g[11] = m, g[15] = y, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    clone() {
        return (new $4a792688e08e5cd7$export$2ae72fc923e5eb5).fromArray(this.elements);
    }
    copy(t) {
        const e = this.elements, i = t.elements;
        return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], e[9] = i[9], e[10] = i[10], e[11] = i[11], e[12] = i[12], e[13] = i[13], e[14] = i[14], e[15] = i[15], this;
    }
    copyPosition(t) {
        const e = this.elements, i = t.elements;
        return e[12] = i[12], e[13] = i[13], e[14] = i[14], this;
    }
    setFromMatrix3(t) {
        const e = t.elements;
        return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
    }
    extractBasis(t, e, i) {
        return t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), i.setFromMatrixColumn(this, 2), this;
    }
    makeBasis(t, e, i) {
        return this.set(t.x, e.x, i.x, 0, t.y, e.y, i.y, 0, t.z, e.z, i.z, 0, 0, 0, 0, 1), this;
    }
    extractRotation(t) {
        const e = this.elements, i = t.elements, s = 1 / $4a792688e08e5cd7$var$pr.setFromMatrixColumn(t, 0).length(), r = 1 / $4a792688e08e5cd7$var$pr.setFromMatrixColumn(t, 1).length(), n = 1 / $4a792688e08e5cd7$var$pr.setFromMatrixColumn(t, 2).length();
        return e[0] = i[0] * s, e[1] = i[1] * s, e[2] = i[2] * s, e[3] = 0, e[4] = i[4] * r, e[5] = i[5] * r, e[6] = i[6] * r, e[7] = 0, e[8] = i[8] * n, e[9] = i[9] * n, e[10] = i[10] * n, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromEuler(t) {
        const e = this.elements, i = t.x, s = t.y, r = t.z, n = Math.cos(i), a = Math.sin(i), o = Math.cos(s), h = Math.sin(s), l = Math.cos(r), c = Math.sin(r);
        if ("XYZ" === t.order) {
            const t = n * l, i = n * c, s = a * l, r = a * c;
            e[0] = o * l, e[4] = -o * c, e[8] = h, e[1] = i + s * h, e[5] = t - r * h, e[9] = -a * o, e[2] = r - t * h, e[6] = s + i * h, e[10] = n * o;
        } else if ("YXZ" === t.order) {
            const t = o * l, i = o * c, s = h * l, r = h * c;
            e[0] = t + r * a, e[4] = s * a - i, e[8] = n * h, e[1] = n * c, e[5] = n * l, e[9] = -a, e[2] = i * a - s, e[6] = r + t * a, e[10] = n * o;
        } else if ("ZXY" === t.order) {
            const t = o * l, i = o * c, s = h * l, r = h * c;
            e[0] = t - r * a, e[4] = -n * c, e[8] = s + i * a, e[1] = i + s * a, e[5] = n * l, e[9] = r - t * a, e[2] = -n * h, e[6] = a, e[10] = n * o;
        } else if ("ZYX" === t.order) {
            const t = n * l, i = n * c, s = a * l, r = a * c;
            e[0] = o * l, e[4] = s * h - i, e[8] = t * h + r, e[1] = o * c, e[5] = r * h + t, e[9] = i * h - s, e[2] = -h, e[6] = a * o, e[10] = n * o;
        } else if ("YZX" === t.order) {
            const t = n * o, i = n * h, s = a * o, r = a * h;
            e[0] = o * l, e[4] = r - t * c, e[8] = s * c + i, e[1] = c, e[5] = n * l, e[9] = -a * l, e[2] = -h * l, e[6] = i * c + s, e[10] = t - r * c;
        } else if ("XZY" === t.order) {
            const t = n * o, i = n * h, s = a * o, r = a * h;
            e[0] = o * l, e[4] = -c, e[8] = h * l, e[1] = t * c + r, e[5] = n * l, e[9] = i * c - s, e[2] = s * c - i, e[6] = a * l, e[10] = r * c + t;
        }
        return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromQuaternion(t) {
        return this.compose($4a792688e08e5cd7$var$yr, t, $4a792688e08e5cd7$var$gr);
    }
    lookAt(t, e, i) {
        const s = this.elements;
        return $4a792688e08e5cd7$var$br.subVectors(t, e), 0 === $4a792688e08e5cd7$var$br.lengthSq() && ($4a792688e08e5cd7$var$br.z = 1), $4a792688e08e5cd7$var$br.normalize(), $4a792688e08e5cd7$var$fr.crossVectors(i, $4a792688e08e5cd7$var$br), 0 === $4a792688e08e5cd7$var$fr.lengthSq() && (1 === Math.abs(i.z) ? $4a792688e08e5cd7$var$br.x += 1e-4 : $4a792688e08e5cd7$var$br.z += 1e-4, $4a792688e08e5cd7$var$br.normalize(), $4a792688e08e5cd7$var$fr.crossVectors(i, $4a792688e08e5cd7$var$br)), $4a792688e08e5cd7$var$fr.normalize(), $4a792688e08e5cd7$var$xr.crossVectors($4a792688e08e5cd7$var$br, $4a792688e08e5cd7$var$fr), s[0] = $4a792688e08e5cd7$var$fr.x, s[4] = $4a792688e08e5cd7$var$xr.x, s[8] = $4a792688e08e5cd7$var$br.x, s[1] = $4a792688e08e5cd7$var$fr.y, s[5] = $4a792688e08e5cd7$var$xr.y, s[9] = $4a792688e08e5cd7$var$br.y, s[2] = $4a792688e08e5cd7$var$fr.z, s[6] = $4a792688e08e5cd7$var$xr.z, s[10] = $4a792688e08e5cd7$var$br.z, this;
    }
    multiply(t) {
        return this.multiplyMatrices(this, t);
    }
    premultiply(t) {
        return this.multiplyMatrices(t, this);
    }
    multiplyMatrices(t, e) {
        const i = t.elements, s = e.elements, r = this.elements, n = i[0], a = i[4], o = i[8], h = i[12], l = i[1], c = i[5], u = i[9], d = i[13], p = i[2], m = i[6], y = i[10], g = i[14], f = i[3], x = i[7], b = i[11], v = i[15], w = s[0], M = s[4], S = s[8], _ = s[12], A = s[1], T = s[5], z = s[9], C = s[13], I = s[2], B = s[6], k = s[10], P = s[14], O = s[3], R = s[7], N = s[11], V = s[15];
        return r[0] = n * w + a * A + o * I + h * O, r[4] = n * M + a * T + o * B + h * R, r[8] = n * S + a * z + o * k + h * N, r[12] = n * _ + a * C + o * P + h * V, r[1] = l * w + c * A + u * I + d * O, r[5] = l * M + c * T + u * B + d * R, r[9] = l * S + c * z + u * k + d * N, r[13] = l * _ + c * C + u * P + d * V, r[2] = p * w + m * A + y * I + g * O, r[6] = p * M + m * T + y * B + g * R, r[10] = p * S + m * z + y * k + g * N, r[14] = p * _ + m * C + y * P + g * V, r[3] = f * w + x * A + b * I + v * O, r[7] = f * M + x * T + b * B + v * R, r[11] = f * S + x * z + b * k + v * N, r[15] = f * _ + x * C + b * P + v * V, this;
    }
    multiplyScalar(t) {
        const e = this.elements;
        return e[0] *= t, e[4] *= t, e[8] *= t, e[12] *= t, e[1] *= t, e[5] *= t, e[9] *= t, e[13] *= t, e[2] *= t, e[6] *= t, e[10] *= t, e[14] *= t, e[3] *= t, e[7] *= t, e[11] *= t, e[15] *= t, this;
    }
    determinant() {
        const t = this.elements, e = t[0], i = t[4], s = t[8], r = t[12], n = t[1], a = t[5], o = t[9], h = t[13], l = t[2], c = t[6], u = t[10], d = t[14];
        return t[3] * (+r * o * c - s * h * c - r * a * u + i * h * u + s * a * d - i * o * d) + t[7] * (+e * o * d - e * h * u + r * n * u - s * n * d + s * h * l - r * o * l) + t[11] * (+e * h * c - e * a * d - r * n * c + i * n * d + r * a * l - i * h * l) + t[15] * (-s * a * l - e * o * c + e * a * u + s * n * c - i * n * u + i * o * l);
    }
    transpose() {
        const t = this.elements;
        let e;
        return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
    }
    setPosition(t, e, i) {
        const s = this.elements;
        return t.isVector3 ? (s[12] = t.x, s[13] = t.y, s[14] = t.z) : (s[12] = t, s[13] = e, s[14] = i), this;
    }
    invert() {
        const t = this.elements, e = t[0], i = t[1], s = t[2], r = t[3], n = t[4], a = t[5], o = t[6], h = t[7], l = t[8], c = t[9], u = t[10], d = t[11], p = t[12], m = t[13], y = t[14], g = t[15], f = c * y * h - m * u * h + m * o * d - a * y * d - c * o * g + a * u * g, x = p * u * h - l * y * h - p * o * d + n * y * d + l * o * g - n * u * g, b = l * m * h - p * c * h + p * a * d - n * m * d - l * a * g + n * c * g, v = p * c * o - l * m * o - p * a * u + n * m * u + l * a * y - n * c * y, w = e * f + i * x + s * b + r * v;
        if (0 === w) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const M = 1 / w;
        return t[0] = f * M, t[1] = (m * u * r - c * y * r - m * s * d + i * y * d + c * s * g - i * u * g) * M, t[2] = (a * y * r - m * o * r + m * s * h - i * y * h - a * s * g + i * o * g) * M, t[3] = (c * o * r - a * u * r - c * s * h + i * u * h + a * s * d - i * o * d) * M, t[4] = x * M, t[5] = (l * y * r - p * u * r + p * s * d - e * y * d - l * s * g + e * u * g) * M, t[6] = (p * o * r - n * y * r - p * s * h + e * y * h + n * s * g - e * o * g) * M, t[7] = (n * u * r - l * o * r + l * s * h - e * u * h - n * s * d + e * o * d) * M, t[8] = b * M, t[9] = (p * c * r - l * m * r - p * i * d + e * m * d + l * i * g - e * c * g) * M, t[10] = (n * m * r - p * a * r + p * i * h - e * m * h - n * i * g + e * a * g) * M, t[11] = (l * a * r - n * c * r - l * i * h + e * c * h + n * i * d - e * a * d) * M, t[12] = v * M, t[13] = (l * m * s - p * c * s + p * i * u - e * m * u - l * i * y + e * c * y) * M, t[14] = (p * a * s - n * m * s - p * i * o + e * m * o + n * i * y - e * a * y) * M, t[15] = (n * c * s - l * a * s + l * i * o - e * c * o - n * i * u + e * a * u) * M, this;
    }
    scale(t) {
        const e = this.elements, i = t.x, s = t.y, r = t.z;
        return e[0] *= i, e[4] *= s, e[8] *= r, e[1] *= i, e[5] *= s, e[9] *= r, e[2] *= i, e[6] *= s, e[10] *= r, e[3] *= i, e[7] *= s, e[11] *= r, this;
    }
    getMaxScaleOnAxis() {
        const t = this.elements, e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2], i = t[4] * t[4] + t[5] * t[5] + t[6] * t[6], s = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
        return Math.sqrt(Math.max(e, i, s));
    }
    makeTranslation(t, e, i) {
        return t.isVector3 ? this.set(1, 0, 0, t.x, 0, 1, 0, t.y, 0, 0, 1, t.z, 0, 0, 0, 1) : this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, i, 0, 0, 0, 1), this;
    }
    makeRotationX(t) {
        const e = Math.cos(t), i = Math.sin(t);
        return this.set(1, 0, 0, 0, 0, e, -i, 0, 0, i, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationY(t) {
        const e = Math.cos(t), i = Math.sin(t);
        return this.set(e, 0, i, 0, 0, 1, 0, 0, -i, 0, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationZ(t) {
        const e = Math.cos(t), i = Math.sin(t);
        return this.set(e, -i, 0, 0, i, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    makeRotationAxis(t, e) {
        const i = Math.cos(e), s = Math.sin(e), r = 1 - i, n = t.x, a = t.y, o = t.z, h = r * n, l = r * a;
        return this.set(h * n + i, h * a - s * o, h * o + s * a, 0, h * a + s * o, l * a + i, l * o - s * n, 0, h * o - s * a, l * o + s * n, r * o * o + i, 0, 0, 0, 0, 1), this;
    }
    makeScale(t, e, i) {
        return this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this;
    }
    makeShear(t, e, i, s, r, n) {
        return this.set(1, i, r, 0, t, 1, n, 0, e, s, 1, 0, 0, 0, 0, 1), this;
    }
    compose(t, e, i) {
        const s = this.elements, r = e._x, n = e._y, a = e._z, o = e._w, h = r + r, l = n + n, c = a + a, u = r * h, d = r * l, p = r * c, m = n * l, y = n * c, g = a * c, f = o * h, x = o * l, b = o * c, v = i.x, w = i.y, M = i.z;
        return s[0] = (1 - (m + g)) * v, s[1] = (d + b) * v, s[2] = (p - x) * v, s[3] = 0, s[4] = (d - b) * w, s[5] = (1 - (u + g)) * w, s[6] = (y + f) * w, s[7] = 0, s[8] = (p + x) * M, s[9] = (y - f) * M, s[10] = (1 - (u + m)) * M, s[11] = 0, s[12] = t.x, s[13] = t.y, s[14] = t.z, s[15] = 1, this;
    }
    decompose(t, e, i) {
        const s = this.elements;
        let r = $4a792688e08e5cd7$var$pr.set(s[0], s[1], s[2]).length();
        const n = $4a792688e08e5cd7$var$pr.set(s[4], s[5], s[6]).length(), a = $4a792688e08e5cd7$var$pr.set(s[8], s[9], s[10]).length();
        this.determinant() < 0 && (r = -r), t.x = s[12], t.y = s[13], t.z = s[14], $4a792688e08e5cd7$var$mr.copy(this);
        const o = 1 / r, h = 1 / n, l = 1 / a;
        return $4a792688e08e5cd7$var$mr.elements[0] *= o, $4a792688e08e5cd7$var$mr.elements[1] *= o, $4a792688e08e5cd7$var$mr.elements[2] *= o, $4a792688e08e5cd7$var$mr.elements[4] *= h, $4a792688e08e5cd7$var$mr.elements[5] *= h, $4a792688e08e5cd7$var$mr.elements[6] *= h, $4a792688e08e5cd7$var$mr.elements[8] *= l, $4a792688e08e5cd7$var$mr.elements[9] *= l, $4a792688e08e5cd7$var$mr.elements[10] *= l, e.setFromRotationMatrix($4a792688e08e5cd7$var$mr), i.x = r, i.y = n, i.z = a, this;
    }
    makePerspective(t, e, i, s, r, n, a = 2e3, o = !1) {
        const h = this.elements, l = 2 * r / (e - t), c = 2 * r / (i - s), u = (e + t) / (e - t), d = (i + s) / (i - s);
        let p, m;
        if (o) p = r / (n - r), m = n * r / (n - r);
        else if (a === $4a792688e08e5cd7$export$5a0e9190d10875d3) p = -(n + r) / (n - r), m = -2 * n * r / (n - r);
        else {
            if (a !== $4a792688e08e5cd7$export$cc83beedcb9be9ac) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + a);
            p = -n / (n - r), m = -n * r / (n - r);
        }
        return h[0] = l, h[4] = 0, h[8] = u, h[12] = 0, h[1] = 0, h[5] = c, h[9] = d, h[13] = 0, h[2] = 0, h[6] = 0, h[10] = p, h[14] = m, h[3] = 0, h[7] = 0, h[11] = -1, h[15] = 0, this;
    }
    makeOrthographic(t, e, i, s, r, n, a = 2e3, o = !1) {
        const h = this.elements, l = 2 / (e - t), c = 2 / (i - s), u = -(e + t) / (e - t), d = -(i + s) / (i - s);
        let p, m;
        if (o) p = 1 / (n - r), m = n / (n - r);
        else if (a === $4a792688e08e5cd7$export$5a0e9190d10875d3) p = -2 / (n - r), m = -(n + r) / (n - r);
        else {
            if (a !== $4a792688e08e5cd7$export$cc83beedcb9be9ac) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + a);
            p = -1 / (n - r), m = -r / (n - r);
        }
        return h[0] = l, h[4] = 0, h[8] = 0, h[12] = u, h[1] = 0, h[5] = c, h[9] = 0, h[13] = d, h[2] = 0, h[6] = 0, h[10] = p, h[14] = m, h[3] = 0, h[7] = 0, h[11] = 0, h[15] = 1, this;
    }
    equals(t) {
        const e = this.elements, i = t.elements;
        for(let t = 0; t < 16; t++)if (e[t] !== i[t]) return !1;
        return !0;
    }
    fromArray(t, e = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = t[i + e];
        return this;
    }
    toArray(t = [], e = 0) {
        const i = this.elements;
        return t[e] = i[0], t[e + 1] = i[1], t[e + 2] = i[2], t[e + 3] = i[3], t[e + 4] = i[4], t[e + 5] = i[5], t[e + 6] = i[6], t[e + 7] = i[7], t[e + 8] = i[8], t[e + 9] = i[9], t[e + 10] = i[10], t[e + 11] = i[11], t[e + 12] = i[12], t[e + 13] = i[13], t[e + 14] = i[14], t[e + 15] = i[15], t;
    }
}
const $4a792688e08e5cd7$var$pr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$mr = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$yr = new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0, 0), $4a792688e08e5cd7$var$gr = new $4a792688e08e5cd7$export$64b5c384219d3699(1, 1, 1), $4a792688e08e5cd7$var$fr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$xr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$br = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$vr = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$wr = new $4a792688e08e5cd7$export$23d6a54f0bbc85a3;
class $4a792688e08e5cd7$export$d93cc409a0768c5f {
    constructor(t = 0, e = 0, i = 0, s = $4a792688e08e5cd7$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = !0, this._x = t, this._y = e, this._z = i, this._order = s;
    }
    get x() {
        return this._x;
    }
    set x(t) {
        this._x = t, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t) {
        this._y = t, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t) {
        this._z = t, this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(t) {
        this._order = t, this._onChangeCallback();
    }
    set(t, e, i, s = this._order) {
        return this._x = t, this._y = e, this._z = i, this._order = s, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(t) {
        return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t, e = this._order, i = !0) {
        const s = t.elements, r = s[0], n = s[4], a = s[8], o = s[1], h = s[5], l = s[9], c = s[2], u = s[6], d = s[10];
        switch(e){
            case "XYZ":
                this._y = Math.asin($4a792688e08e5cd7$var$ns(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(-l, d), this._z = Math.atan2(-n, r)) : (this._x = Math.atan2(u, h), this._z = 0);
                break;
            case "YXZ":
                this._x = Math.asin(-$4a792688e08e5cd7$var$ns(l, -1, 1)), Math.abs(l) < .9999999 ? (this._y = Math.atan2(a, d), this._z = Math.atan2(o, h)) : (this._y = Math.atan2(-c, r), this._z = 0);
                break;
            case "ZXY":
                this._x = Math.asin($4a792688e08e5cd7$var$ns(u, -1, 1)), Math.abs(u) < .9999999 ? (this._y = Math.atan2(-c, d), this._z = Math.atan2(-n, h)) : (this._y = 0, this._z = Math.atan2(o, r));
                break;
            case "ZYX":
                this._y = Math.asin(-$4a792688e08e5cd7$var$ns(c, -1, 1)), Math.abs(c) < .9999999 ? (this._x = Math.atan2(u, d), this._z = Math.atan2(o, r)) : (this._x = 0, this._z = Math.atan2(-n, h));
                break;
            case "YZX":
                this._z = Math.asin($4a792688e08e5cd7$var$ns(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-l, h), this._y = Math.atan2(-c, r)) : (this._x = 0, this._y = Math.atan2(a, d));
                break;
            case "XZY":
                this._z = Math.asin(-$4a792688e08e5cd7$var$ns(n, -1, 1)), Math.abs(n) < .9999999 ? (this._x = Math.atan2(u, h), this._y = Math.atan2(a, r)) : (this._x = Math.atan2(-l, d), this._y = 0);
                break;
            default:
                $4a792688e08e5cd7$export$c106dd0671a0fc2d("Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
        }
        return this._order = e, !0 === i && this._onChangeCallback(), this;
    }
    setFromQuaternion(t, e, i) {
        return $4a792688e08e5cd7$var$vr.makeRotationFromQuaternion(t), this.setFromRotationMatrix($4a792688e08e5cd7$var$vr, e, i);
    }
    setFromVector3(t, e = this._order) {
        return this.set(t.x, t.y, t.z, e);
    }
    reorder(t) {
        return $4a792688e08e5cd7$var$wr.setFromEuler(this), this.setFromQuaternion($4a792688e08e5cd7$var$wr, t);
    }
    equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
    }
    fromArray(t) {
        return this._x = t[0], this._y = t[1], this._z = t[2], void 0 !== t[3] && (this._order = t[3]), this._onChangeCallback(), this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._order, t;
    }
    _onChange(t) {
        return this._onChangeCallback = t, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._order;
    }
}
$4a792688e08e5cd7$export$d93cc409a0768c5f.DEFAULT_ORDER = "XYZ";
class $4a792688e08e5cd7$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(t) {
        this.mask = 1 << t >>> 0;
    }
    enable(t) {
        this.mask |= 1 << t;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(t) {
        this.mask ^= 1 << t;
    }
    disable(t) {
        this.mask &= ~(1 << t);
    }
    disableAll() {
        this.mask = 0;
    }
    test(t) {
        return 0 !== (this.mask & t.mask);
    }
    isEnabled(t) {
        return !!(this.mask & 1 << t);
    }
}
let $4a792688e08e5cd7$var$_r = 0;
const $4a792688e08e5cd7$var$Ar = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Tr = new $4a792688e08e5cd7$export$23d6a54f0bbc85a3, $4a792688e08e5cd7$var$zr = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$Cr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Ir = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Br = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$kr = new $4a792688e08e5cd7$export$23d6a54f0bbc85a3, $4a792688e08e5cd7$var$Pr = new $4a792688e08e5cd7$export$64b5c384219d3699(1, 0, 0), $4a792688e08e5cd7$var$Or = new $4a792688e08e5cd7$export$64b5c384219d3699(0, 1, 0), $4a792688e08e5cd7$var$Rr = new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0, 1), $4a792688e08e5cd7$var$Nr = {
    type: "added"
}, $4a792688e08e5cd7$var$Vr = {
    type: "removed"
}, $4a792688e08e5cd7$var$Fr = {
    type: "childadded",
    child: null
}, $4a792688e08e5cd7$var$Lr = {
    type: "childremoved",
    child: null
};
class $4a792688e08e5cd7$export$e4dd07dff30cc924 extends $4a792688e08e5cd7$export$ec8b666c5fe2c75a {
    constructor(){
        super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
            value: $4a792688e08e5cd7$var$_r++
        }), this.uuid = $4a792688e08e5cd7$var$rs(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = $4a792688e08e5cd7$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const t = new $4a792688e08e5cd7$export$64b5c384219d3699, e = new $4a792688e08e5cd7$export$d93cc409a0768c5f, i = new $4a792688e08e5cd7$export$23d6a54f0bbc85a3, s = new $4a792688e08e5cd7$export$64b5c384219d3699(1, 1, 1);
        e._onChange(function() {
            i.setFromEuler(e, !1);
        }), i._onChange(function() {
            e.setFromQuaternion(i, void 0, !1);
        }), Object.defineProperties(this, {
            position: {
                configurable: !0,
                enumerable: !0,
                value: t
            },
            rotation: {
                configurable: !0,
                enumerable: !0,
                value: e
            },
            quaternion: {
                configurable: !0,
                enumerable: !0,
                value: i
            },
            scale: {
                configurable: !0,
                enumerable: !0,
                value: s
            },
            modelViewMatrix: {
                value: new $4a792688e08e5cd7$export$2ae72fc923e5eb5
            },
            normalMatrix: {
                value: new $4a792688e08e5cd7$export$8ff26dafa08918
            }
        }), this.matrix = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, this.matrixWorld = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, this.matrixAutoUpdate = $4a792688e08e5cd7$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = $4a792688e08e5cd7$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new $4a792688e08e5cd7$export$89312ce47c0ca777, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.userData = {};
    }
    onBeforeShadow() {}
    onAfterShadow() {}
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(t) {
        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(t) {
        return this.quaternion.premultiply(t), this;
    }
    setRotationFromAxisAngle(t, e) {
        this.quaternion.setFromAxisAngle(t, e);
    }
    setRotationFromEuler(t) {
        this.quaternion.setFromEuler(t, !0);
    }
    setRotationFromMatrix(t) {
        this.quaternion.setFromRotationMatrix(t);
    }
    setRotationFromQuaternion(t) {
        this.quaternion.copy(t);
    }
    rotateOnAxis(t, e) {
        return $4a792688e08e5cd7$var$Tr.setFromAxisAngle(t, e), this.quaternion.multiply($4a792688e08e5cd7$var$Tr), this;
    }
    rotateOnWorldAxis(t, e) {
        return $4a792688e08e5cd7$var$Tr.setFromAxisAngle(t, e), this.quaternion.premultiply($4a792688e08e5cd7$var$Tr), this;
    }
    rotateX(t) {
        return this.rotateOnAxis($4a792688e08e5cd7$var$Pr, t);
    }
    rotateY(t) {
        return this.rotateOnAxis($4a792688e08e5cd7$var$Or, t);
    }
    rotateZ(t) {
        return this.rotateOnAxis($4a792688e08e5cd7$var$Rr, t);
    }
    translateOnAxis(t, e) {
        return $4a792688e08e5cd7$var$Ar.copy(t).applyQuaternion(this.quaternion), this.position.add($4a792688e08e5cd7$var$Ar.multiplyScalar(e)), this;
    }
    translateX(t) {
        return this.translateOnAxis($4a792688e08e5cd7$var$Pr, t);
    }
    translateY(t) {
        return this.translateOnAxis($4a792688e08e5cd7$var$Or, t);
    }
    translateZ(t) {
        return this.translateOnAxis($4a792688e08e5cd7$var$Rr, t);
    }
    localToWorld(t) {
        return this.updateWorldMatrix(!0, !1), t.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(t) {
        return this.updateWorldMatrix(!0, !1), t.applyMatrix4($4a792688e08e5cd7$var$zr.copy(this.matrixWorld).invert());
    }
    lookAt(t, e, i) {
        t.isVector3 ? $4a792688e08e5cd7$var$Cr.copy(t) : $4a792688e08e5cd7$var$Cr.set(t, e, i);
        const s = this.parent;
        this.updateWorldMatrix(!0, !1), $4a792688e08e5cd7$var$Ir.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? $4a792688e08e5cd7$var$zr.lookAt($4a792688e08e5cd7$var$Ir, $4a792688e08e5cd7$var$Cr, this.up) : $4a792688e08e5cd7$var$zr.lookAt($4a792688e08e5cd7$var$Cr, $4a792688e08e5cd7$var$Ir, this.up), this.quaternion.setFromRotationMatrix($4a792688e08e5cd7$var$zr), s && ($4a792688e08e5cd7$var$zr.extractRotation(s.matrixWorld), $4a792688e08e5cd7$var$Tr.setFromRotationMatrix($4a792688e08e5cd7$var$zr), this.quaternion.premultiply($4a792688e08e5cd7$var$Tr.invert()));
    }
    add(t) {
        if (arguments.length > 1) {
            for(let t = 0; t < arguments.length; t++)this.add(arguments[t]);
            return this;
        }
        return t === this ? ($4a792688e08e5cd7$export$a3bc9b8ed74fc("Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (t.removeFromParent(), t.parent = this, this.children.push(t), t.dispatchEvent($4a792688e08e5cd7$var$Nr), $4a792688e08e5cd7$var$Fr.child = t, this.dispatchEvent($4a792688e08e5cd7$var$Fr), $4a792688e08e5cd7$var$Fr.child = null) : $4a792688e08e5cd7$export$a3bc9b8ed74fc("Object3D.add: object not an instance of THREE.Object3D.", t), this);
    }
    remove(t) {
        if (arguments.length > 1) {
            for(let t = 0; t < arguments.length; t++)this.remove(arguments[t]);
            return this;
        }
        const e = this.children.indexOf(t);
        return -1 !== e && (t.parent = null, this.children.splice(e, 1), t.dispatchEvent($4a792688e08e5cd7$var$Vr), $4a792688e08e5cd7$var$Lr.child = t, this.dispatchEvent($4a792688e08e5cd7$var$Lr), $4a792688e08e5cd7$var$Lr.child = null), this;
    }
    removeFromParent() {
        const t = this.parent;
        return null !== t && t.remove(this), this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(t) {
        return this.updateWorldMatrix(!0, !1), $4a792688e08e5cd7$var$zr.copy(this.matrixWorld).invert(), null !== t.parent && (t.parent.updateWorldMatrix(!0, !1), $4a792688e08e5cd7$var$zr.multiply(t.parent.matrixWorld)), t.applyMatrix4($4a792688e08e5cd7$var$zr), t.removeFromParent(), t.parent = this, this.children.push(t), t.updateWorldMatrix(!1, !0), t.dispatchEvent($4a792688e08e5cd7$var$Nr), $4a792688e08e5cd7$var$Fr.child = t, this.dispatchEvent($4a792688e08e5cd7$var$Fr), $4a792688e08e5cd7$var$Fr.child = null, this;
    }
    getObjectById(t) {
        return this.getObjectByProperty("id", t);
    }
    getObjectByName(t) {
        return this.getObjectByProperty("name", t);
    }
    getObjectByProperty(t, e) {
        if (this[t] === e) return this;
        for(let i = 0, s = this.children.length; i < s; i++){
            const s = this.children[i].getObjectByProperty(t, e);
            if (void 0 !== s) return s;
        }
    }
    getObjectsByProperty(t, e, i = []) {
        this[t] === e && i.push(this);
        const s = this.children;
        for(let r = 0, n = s.length; r < n; r++)s[r].getObjectsByProperty(t, e, i);
        return i;
    }
    getWorldPosition(t) {
        return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($4a792688e08e5cd7$var$Ir, t, $4a792688e08e5cd7$var$Br), t;
    }
    getWorldScale(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($4a792688e08e5cd7$var$Ir, $4a792688e08e5cd7$var$kr, t), t;
    }
    getWorldDirection(t) {
        this.updateWorldMatrix(!0, !1);
        const e = this.matrixWorld.elements;
        return t.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(t) {
        t(this);
        const e = this.children;
        for(let i = 0, s = e.length; i < s; i++)e[i].traverse(t);
    }
    traverseVisible(t) {
        if (!1 === this.visible) return;
        t(this);
        const e = this.children;
        for(let i = 0, s = e.length; i < s; i++)e[i].traverseVisible(t);
    }
    traverseAncestors(t) {
        const e = this.parent;
        null !== e && (t(e), e.traverseAncestors(t));
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }
    updateMatrixWorld(t) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (!0 === this.matrixWorldAutoUpdate && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, t = !0);
        const e = this.children;
        for(let i = 0, s = e.length; i < s; i++)e[i].updateMatrixWorld(t);
    }
    updateWorldMatrix(t, e) {
        const i = this.parent;
        if (!0 === t && null !== i && i.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), !0 === this.matrixWorldAutoUpdate && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), !0 === e) {
            const t = this.children;
            for(let e = 0, i = t.length; e < i; e++)t[e].updateWorldMatrix(!1, !0);
        }
    }
    toJSON(t) {
        const e = void 0 === t || "string" == typeof t, i = {};
        e && (t = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {}
        }, i.metadata = {
            version: 4.7,
            type: "Object",
            generator: "Object3D.toJSON"
        });
        const s = {};
        function r(e, i) {
            return void 0 === e[i.uuid] && (e[i.uuid] = i.toJSON(t)), i.uuid;
        }
        if (s.uuid = this.uuid, s.type = this.type, "" !== this.name && (s.name = this.name), !0 === this.castShadow && (s.castShadow = !0), !0 === this.receiveShadow && (s.receiveShadow = !0), !1 === this.visible && (s.visible = !1), !1 === this.frustumCulled && (s.frustumCulled = !1), 0 !== this.renderOrder && (s.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (s.userData = this.userData), s.layers = this.layers.mask, s.matrix = this.matrix.toArray(), s.up = this.up.toArray(), !1 === this.matrixAutoUpdate && (s.matrixAutoUpdate = !1), this.isInstancedMesh && (s.type = "InstancedMesh", s.count = this.count, s.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (s.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (s.type = "BatchedMesh", s.perObjectFrustumCulled = this.perObjectFrustumCulled, s.sortObjects = this.sortObjects, s.drawRanges = this._drawRanges, s.reservedRanges = this._reservedRanges, s.geometryInfo = this._geometryInfo.map((t)=>({
                ...t,
                boundingBox: t.boundingBox ? t.boundingBox.toJSON() : void 0,
                boundingSphere: t.boundingSphere ? t.boundingSphere.toJSON() : void 0
            })), s.instanceInfo = this._instanceInfo.map((t)=>({
                ...t
            })), s.availableInstanceIds = this._availableInstanceIds.slice(), s.availableGeometryIds = this._availableGeometryIds.slice(), s.nextIndexStart = this._nextIndexStart, s.nextVertexStart = this._nextVertexStart, s.geometryCount = this._geometryCount, s.maxInstanceCount = this._maxInstanceCount, s.maxVertexCount = this._maxVertexCount, s.maxIndexCount = this._maxIndexCount, s.geometryInitialized = this._geometryInitialized, s.matricesTexture = this._matricesTexture.toJSON(t), s.indirectTexture = this._indirectTexture.toJSON(t), null !== this._colorsTexture && (s.colorsTexture = this._colorsTexture.toJSON(t)), null !== this.boundingSphere && (s.boundingSphere = this.boundingSphere.toJSON()), null !== this.boundingBox && (s.boundingBox = this.boundingBox.toJSON())), this.isScene) this.background && (this.background.isColor ? s.background = this.background.toJSON() : this.background.isTexture && (s.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && !0 !== this.environment.isRenderTargetTexture && (s.environment = this.environment.toJSON(t).uuid);
        else if (this.isMesh || this.isLine || this.isPoints) {
            s.geometry = r(t.geometries, this.geometry);
            const e = this.geometry.parameters;
            if (void 0 !== e && void 0 !== e.shapes) {
                const i = e.shapes;
                if (Array.isArray(i)) for(let e = 0, s = i.length; e < s; e++){
                    const s = i[e];
                    r(t.shapes, s);
                }
                else r(t.shapes, i);
            }
        }
        if (this.isSkinnedMesh && (s.bindMode = this.bindMode, s.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (r(t.skeletons, this.skeleton), s.skeleton = this.skeleton.uuid)), void 0 !== this.material) {
            if (Array.isArray(this.material)) {
                const e = [];
                for(let i = 0, s = this.material.length; i < s; i++)e.push(r(t.materials, this.material[i]));
                s.material = e;
            } else s.material = r(t.materials, this.material);
        }
        if (this.children.length > 0) {
            s.children = [];
            for(let e = 0; e < this.children.length; e++)s.children.push(this.children[e].toJSON(t).object);
        }
        if (this.animations.length > 0) {
            s.animations = [];
            for(let e = 0; e < this.animations.length; e++){
                const i = this.animations[e];
                s.animations.push(r(t.animations, i));
            }
        }
        if (e) {
            const e = n(t.geometries), s = n(t.materials), r = n(t.textures), a = n(t.images), o = n(t.shapes), h = n(t.skeletons), l = n(t.animations), c = n(t.nodes);
            e.length > 0 && (i.geometries = e), s.length > 0 && (i.materials = s), r.length > 0 && (i.textures = r), a.length > 0 && (i.images = a), o.length > 0 && (i.shapes = o), h.length > 0 && (i.skeletons = h), l.length > 0 && (i.animations = l), c.length > 0 && (i.nodes = c);
        }
        return i.object = s, i;
        function n(t) {
            const e = [];
            for(const i in t){
                const s = t[i];
                delete s.metadata, e.push(s);
            }
            return e;
        }
    }
    clone(t) {
        return (new this.constructor).copy(this, t);
    }
    copy(t, e = !0) {
        if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldAutoUpdate = t.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.animations = t.animations.slice(), this.userData = JSON.parse(JSON.stringify(t.userData)), !0 === e) for(let e = 0; e < t.children.length; e++){
            const i = t.children[e];
            this.add(i.clone());
        }
        return this;
    }
}
$4a792688e08e5cd7$export$e4dd07dff30cc924.DEFAULT_UP = new $4a792688e08e5cd7$export$64b5c384219d3699(0, 1, 0), $4a792688e08e5cd7$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = !0, $4a792688e08e5cd7$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const $4a792688e08e5cd7$var$jr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Dr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Wr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Ur = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$qr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Jr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Xr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Yr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Zr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Hr = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Gr = new $4a792688e08e5cd7$export$fa7daccca11cdbe3, $4a792688e08e5cd7$var$$r = new $4a792688e08e5cd7$export$fa7daccca11cdbe3, $4a792688e08e5cd7$var$Qr = new $4a792688e08e5cd7$export$fa7daccca11cdbe3;
class $4a792688e08e5cd7$export$5a465592bfe74b48 {
    constructor(t = new $4a792688e08e5cd7$export$64b5c384219d3699, e = new $4a792688e08e5cd7$export$64b5c384219d3699, i = new $4a792688e08e5cd7$export$64b5c384219d3699){
        this.a = t, this.b = e, this.c = i;
    }
    static getNormal(t, e, i, s) {
        s.subVectors(i, e), $4a792688e08e5cd7$var$jr.subVectors(t, e), s.cross($4a792688e08e5cd7$var$jr);
        const r = s.lengthSq();
        return r > 0 ? s.multiplyScalar(1 / Math.sqrt(r)) : s.set(0, 0, 0);
    }
    static getBarycoord(t, e, i, s, r) {
        $4a792688e08e5cd7$var$jr.subVectors(s, e), $4a792688e08e5cd7$var$Dr.subVectors(i, e), $4a792688e08e5cd7$var$Wr.subVectors(t, e);
        const n = $4a792688e08e5cd7$var$jr.dot($4a792688e08e5cd7$var$jr), a = $4a792688e08e5cd7$var$jr.dot($4a792688e08e5cd7$var$Dr), o = $4a792688e08e5cd7$var$jr.dot($4a792688e08e5cd7$var$Wr), h = $4a792688e08e5cd7$var$Dr.dot($4a792688e08e5cd7$var$Dr), l = $4a792688e08e5cd7$var$Dr.dot($4a792688e08e5cd7$var$Wr), c = n * h - a * a;
        if (0 === c) return r.set(0, 0, 0), null;
        const u = 1 / c, d = (h * o - a * l) * u, p = (n * l - a * o) * u;
        return r.set(1 - d - p, p, d);
    }
    static containsPoint(t, e, i, s) {
        return null !== this.getBarycoord(t, e, i, s, $4a792688e08e5cd7$var$Ur) && $4a792688e08e5cd7$var$Ur.x >= 0 && $4a792688e08e5cd7$var$Ur.y >= 0 && $4a792688e08e5cd7$var$Ur.x + $4a792688e08e5cd7$var$Ur.y <= 1;
    }
    static getInterpolation(t, e, i, s, r, n, a, o) {
        return null === this.getBarycoord(t, e, i, s, $4a792688e08e5cd7$var$Ur) ? (o.x = 0, o.y = 0, "z" in o && (o.z = 0), "w" in o && (o.w = 0), null) : (o.setScalar(0), o.addScaledVector(r, $4a792688e08e5cd7$var$Ur.x), o.addScaledVector(n, $4a792688e08e5cd7$var$Ur.y), o.addScaledVector(a, $4a792688e08e5cd7$var$Ur.z), o);
    }
    static getInterpolatedAttribute(t, e, i, s, r, n) {
        return $4a792688e08e5cd7$var$Gr.setScalar(0), $4a792688e08e5cd7$var$$r.setScalar(0), $4a792688e08e5cd7$var$Qr.setScalar(0), $4a792688e08e5cd7$var$Gr.fromBufferAttribute(t, e), $4a792688e08e5cd7$var$$r.fromBufferAttribute(t, i), $4a792688e08e5cd7$var$Qr.fromBufferAttribute(t, s), n.setScalar(0), n.addScaledVector($4a792688e08e5cd7$var$Gr, r.x), n.addScaledVector($4a792688e08e5cd7$var$$r, r.y), n.addScaledVector($4a792688e08e5cd7$var$Qr, r.z), n;
    }
    static isFrontFacing(t, e, i, s) {
        return $4a792688e08e5cd7$var$jr.subVectors(i, e), $4a792688e08e5cd7$var$Dr.subVectors(t, e), $4a792688e08e5cd7$var$jr.cross($4a792688e08e5cd7$var$Dr).dot(s) < 0;
    }
    set(t, e, i) {
        return this.a.copy(t), this.b.copy(e), this.c.copy(i), this;
    }
    setFromPointsAndIndices(t, e, i, s) {
        return this.a.copy(t[e]), this.b.copy(t[i]), this.c.copy(t[s]), this;
    }
    setFromAttributeAndIndices(t, e, i, s) {
        return this.a.fromBufferAttribute(t, e), this.b.fromBufferAttribute(t, i), this.c.fromBufferAttribute(t, s), this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t) {
        return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
    }
    getArea() {
        return $4a792688e08e5cd7$var$jr.subVectors(this.c, this.b), $4a792688e08e5cd7$var$Dr.subVectors(this.a, this.b), .5 * $4a792688e08e5cd7$var$jr.cross($4a792688e08e5cd7$var$Dr).length();
    }
    getMidpoint(t) {
        return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(t) {
        return $4a792688e08e5cd7$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, t);
    }
    getPlane(t) {
        return t.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(t, e) {
        return $4a792688e08e5cd7$export$5a465592bfe74b48.getBarycoord(t, this.a, this.b, this.c, e);
    }
    getInterpolation(t, e, i, s, r) {
        return $4a792688e08e5cd7$export$5a465592bfe74b48.getInterpolation(t, this.a, this.b, this.c, e, i, s, r);
    }
    containsPoint(t) {
        return $4a792688e08e5cd7$export$5a465592bfe74b48.containsPoint(t, this.a, this.b, this.c);
    }
    isFrontFacing(t) {
        return $4a792688e08e5cd7$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, t);
    }
    intersectsBox(t) {
        return t.intersectsTriangle(this);
    }
    closestPointToPoint(t, e) {
        const i = this.a, s = this.b, r = this.c;
        let n, a;
        $4a792688e08e5cd7$var$qr.subVectors(s, i), $4a792688e08e5cd7$var$Jr.subVectors(r, i), $4a792688e08e5cd7$var$Yr.subVectors(t, i);
        const o = $4a792688e08e5cd7$var$qr.dot($4a792688e08e5cd7$var$Yr), h = $4a792688e08e5cd7$var$Jr.dot($4a792688e08e5cd7$var$Yr);
        if (o <= 0 && h <= 0) return e.copy(i);
        $4a792688e08e5cd7$var$Zr.subVectors(t, s);
        const l = $4a792688e08e5cd7$var$qr.dot($4a792688e08e5cd7$var$Zr), c = $4a792688e08e5cd7$var$Jr.dot($4a792688e08e5cd7$var$Zr);
        if (l >= 0 && c <= l) return e.copy(s);
        const u = o * c - l * h;
        if (u <= 0 && o >= 0 && l <= 0) return n = o / (o - l), e.copy(i).addScaledVector($4a792688e08e5cd7$var$qr, n);
        $4a792688e08e5cd7$var$Hr.subVectors(t, r);
        const d = $4a792688e08e5cd7$var$qr.dot($4a792688e08e5cd7$var$Hr), p = $4a792688e08e5cd7$var$Jr.dot($4a792688e08e5cd7$var$Hr);
        if (p >= 0 && d <= p) return e.copy(r);
        const m = d * h - o * p;
        if (m <= 0 && h >= 0 && p <= 0) return a = h / (h - p), e.copy(i).addScaledVector($4a792688e08e5cd7$var$Jr, a);
        const y = l * p - d * c;
        if (y <= 0 && c - l >= 0 && d - p >= 0) return $4a792688e08e5cd7$var$Xr.subVectors(r, s), a = (c - l) / (c - l + (d - p)), e.copy(s).addScaledVector($4a792688e08e5cd7$var$Xr, a);
        const g = 1 / (y + m + u);
        return n = m * g, a = u * g, e.copy(i).addScaledVector($4a792688e08e5cd7$var$qr, n).addScaledVector($4a792688e08e5cd7$var$Jr, a);
    }
    equals(t) {
        return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
    }
}
const $4a792688e08e5cd7$var$tn = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
}, $4a792688e08e5cd7$var$en = {
    h: 0,
    s: 0,
    l: 0
}, $4a792688e08e5cd7$var$sn = {
    h: 0,
    s: 0,
    l: 0
};
function $4a792688e08e5cd7$var$rn(t, e, i) {
    return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? t + 6 * (e - t) * i : i < .5 ? e : i < 2 / 3 ? t + 6 * (e - t) * (2 / 3 - i) : t;
}
class $4a792688e08e5cd7$export$892596cec99bc70e {
    constructor(t, e, i){
        return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(t, e, i);
    }
    set(t, e, i) {
        if (void 0 === e && void 0 === i) {
            const e = t;
            e && e.isColor ? this.copy(e) : "number" == typeof e ? this.setHex(e) : "string" == typeof e && this.setStyle(e);
        } else this.setRGB(t, e, i);
        return this;
    }
    setScalar(t) {
        return this.r = t, this.g = t, this.b = t, this;
    }
    setHex(t, e = $4a792688e08e5cd7$export$561f394b24edfcaa) {
        return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (255 & t) / 255, $4a792688e08e5cd7$export$5e6fd513f44698c.colorSpaceToWorking(this, e), this;
    }
    setRGB(t, e, i, s = $4a792688e08e5cd7$export$5e6fd513f44698c.workingColorSpace) {
        return this.r = t, this.g = e, this.b = i, $4a792688e08e5cd7$export$5e6fd513f44698c.colorSpaceToWorking(this, s), this;
    }
    setHSL(t, e, i, s = $4a792688e08e5cd7$export$5e6fd513f44698c.workingColorSpace) {
        if (t = $4a792688e08e5cd7$var$as(t, 1), e = $4a792688e08e5cd7$var$ns(e, 0, 1), i = $4a792688e08e5cd7$var$ns(i, 0, 1), 0 === e) this.r = this.g = this.b = i;
        else {
            const s = i <= .5 ? i * (1 + e) : i + e - i * e, r = 2 * i - s;
            this.r = $4a792688e08e5cd7$var$rn(r, s, t + 1 / 3), this.g = $4a792688e08e5cd7$var$rn(r, s, t), this.b = $4a792688e08e5cd7$var$rn(r, s, t - 1 / 3);
        }
        return $4a792688e08e5cd7$export$5e6fd513f44698c.colorSpaceToWorking(this, s), this;
    }
    setStyle(t, e = $4a792688e08e5cd7$export$561f394b24edfcaa) {
        function i(e) {
            void 0 !== e && parseFloat(e) < 1 && $4a792688e08e5cd7$export$c106dd0671a0fc2d("Color: Alpha component of " + t + " will be ignored.");
        }
        let s;
        if (s = /^(\w+)\(([^\)]*)\)/.exec(t)) {
            let r;
            const n = s[1], a = s[2];
            switch(n){
                case "rgb":
                case "rgba":
                    if (r = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return i(r[4]), this.setRGB(Math.min(255, parseInt(r[1], 10)) / 255, Math.min(255, parseInt(r[2], 10)) / 255, Math.min(255, parseInt(r[3], 10)) / 255, e);
                    if (r = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return i(r[4]), this.setRGB(Math.min(100, parseInt(r[1], 10)) / 100, Math.min(100, parseInt(r[2], 10)) / 100, Math.min(100, parseInt(r[3], 10)) / 100, e);
                    break;
                case "hsl":
                case "hsla":
                    if (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return i(r[4]), this.setHSL(parseFloat(r[1]) / 360, parseFloat(r[2]) / 100, parseFloat(r[3]) / 100, e);
                    break;
                default:
                    $4a792688e08e5cd7$export$c106dd0671a0fc2d("Color: Unknown color model " + t);
            }
        } else if (s = /^\#([A-Fa-f\d]+)$/.exec(t)) {
            const i = s[1], r = i.length;
            if (3 === r) return this.setRGB(parseInt(i.charAt(0), 16) / 15, parseInt(i.charAt(1), 16) / 15, parseInt(i.charAt(2), 16) / 15, e);
            if (6 === r) return this.setHex(parseInt(i, 16), e);
            $4a792688e08e5cd7$export$c106dd0671a0fc2d("Color: Invalid hex color " + t);
        } else if (t && t.length > 0) return this.setColorName(t, e);
        return this;
    }
    setColorName(t, e = $4a792688e08e5cd7$export$561f394b24edfcaa) {
        const i = $4a792688e08e5cd7$var$tn[t.toLowerCase()];
        return void 0 !== i ? this.setHex(i, e) : $4a792688e08e5cd7$export$c106dd0671a0fc2d("Color: Unknown color " + t), this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(t) {
        return this.r = t.r, this.g = t.g, this.b = t.b, this;
    }
    copySRGBToLinear(t) {
        return this.r = $4a792688e08e5cd7$var$Ms(t.r), this.g = $4a792688e08e5cd7$var$Ms(t.g), this.b = $4a792688e08e5cd7$var$Ms(t.b), this;
    }
    copyLinearToSRGB(t) {
        return this.r = $4a792688e08e5cd7$var$Ss(t.r), this.g = $4a792688e08e5cd7$var$Ss(t.g), this.b = $4a792688e08e5cd7$var$Ss(t.b), this;
    }
    convertSRGBToLinear() {
        return this.copySRGBToLinear(this), this;
    }
    convertLinearToSRGB() {
        return this.copyLinearToSRGB(this), this;
    }
    getHex(t = $4a792688e08e5cd7$export$561f394b24edfcaa) {
        return $4a792688e08e5cd7$export$5e6fd513f44698c.workingToColorSpace($4a792688e08e5cd7$var$an.copy(this), t), 65536 * Math.round($4a792688e08e5cd7$var$ns(255 * $4a792688e08e5cd7$var$an.r, 0, 255)) + 256 * Math.round($4a792688e08e5cd7$var$ns(255 * $4a792688e08e5cd7$var$an.g, 0, 255)) + Math.round($4a792688e08e5cd7$var$ns(255 * $4a792688e08e5cd7$var$an.b, 0, 255));
    }
    getHexString(t = $4a792688e08e5cd7$export$561f394b24edfcaa) {
        return ("000000" + this.getHex(t).toString(16)).slice(-6);
    }
    getHSL(t, e = $4a792688e08e5cd7$export$5e6fd513f44698c.workingColorSpace) {
        $4a792688e08e5cd7$export$5e6fd513f44698c.workingToColorSpace($4a792688e08e5cd7$var$an.copy(this), e);
        const i = $4a792688e08e5cd7$var$an.r, s = $4a792688e08e5cd7$var$an.g, r = $4a792688e08e5cd7$var$an.b, n = Math.max(i, s, r), a = Math.min(i, s, r);
        let o, h;
        const l = (a + n) / 2;
        if (a === n) o = 0, h = 0;
        else {
            const t = n - a;
            switch(h = l <= .5 ? t / (n + a) : t / (2 - n - a), n){
                case i:
                    o = (s - r) / t + (s < r ? 6 : 0);
                    break;
                case s:
                    o = (r - i) / t + 2;
                    break;
                case r:
                    o = (i - s) / t + 4;
            }
            o /= 6;
        }
        return t.h = o, t.s = h, t.l = l, t;
    }
    getRGB(t, e = $4a792688e08e5cd7$export$5e6fd513f44698c.workingColorSpace) {
        return $4a792688e08e5cd7$export$5e6fd513f44698c.workingToColorSpace($4a792688e08e5cd7$var$an.copy(this), e), t.r = $4a792688e08e5cd7$var$an.r, t.g = $4a792688e08e5cd7$var$an.g, t.b = $4a792688e08e5cd7$var$an.b, t;
    }
    getStyle(t = $4a792688e08e5cd7$export$561f394b24edfcaa) {
        $4a792688e08e5cd7$export$5e6fd513f44698c.workingToColorSpace($4a792688e08e5cd7$var$an.copy(this), t);
        const e = $4a792688e08e5cd7$var$an.r, i = $4a792688e08e5cd7$var$an.g, s = $4a792688e08e5cd7$var$an.b;
        return t !== $4a792688e08e5cd7$export$561f394b24edfcaa ? `color(${t} ${e.toFixed(3)} ${i.toFixed(3)} ${s.toFixed(3)})` : `rgb(${Math.round(255 * e)},${Math.round(255 * i)},${Math.round(255 * s)})`;
    }
    offsetHSL(t, e, i) {
        return this.getHSL($4a792688e08e5cd7$var$en), this.setHSL($4a792688e08e5cd7$var$en.h + t, $4a792688e08e5cd7$var$en.s + e, $4a792688e08e5cd7$var$en.l + i);
    }
    add(t) {
        return this.r += t.r, this.g += t.g, this.b += t.b, this;
    }
    addColors(t, e) {
        return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
    }
    addScalar(t) {
        return this.r += t, this.g += t, this.b += t, this;
    }
    sub(t) {
        return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
    }
    multiply(t) {
        return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
    }
    multiplyScalar(t) {
        return this.r *= t, this.g *= t, this.b *= t, this;
    }
    lerp(t, e) {
        return this.r += (t.r - this.r) * e, this.g += (t.g - this.g) * e, this.b += (t.b - this.b) * e, this;
    }
    lerpColors(t, e, i) {
        return this.r = t.r + (e.r - t.r) * i, this.g = t.g + (e.g - t.g) * i, this.b = t.b + (e.b - t.b) * i, this;
    }
    lerpHSL(t, e) {
        this.getHSL($4a792688e08e5cd7$var$en), t.getHSL($4a792688e08e5cd7$var$sn);
        const i = $4a792688e08e5cd7$var$os($4a792688e08e5cd7$var$en.h, $4a792688e08e5cd7$var$sn.h, e), s = $4a792688e08e5cd7$var$os($4a792688e08e5cd7$var$en.s, $4a792688e08e5cd7$var$sn.s, e), r = $4a792688e08e5cd7$var$os($4a792688e08e5cd7$var$en.l, $4a792688e08e5cd7$var$sn.l, e);
        return this.setHSL(i, s, r), this;
    }
    setFromVector3(t) {
        return this.r = t.x, this.g = t.y, this.b = t.z, this;
    }
    applyMatrix3(t) {
        const e = this.r, i = this.g, s = this.b, r = t.elements;
        return this.r = r[0] * e + r[3] * i + r[6] * s, this.g = r[1] * e + r[4] * i + r[7] * s, this.b = r[2] * e + r[5] * i + r[8] * s, this;
    }
    equals(t) {
        return t.r === this.r && t.g === this.g && t.b === this.b;
    }
    fromArray(t, e = 0) {
        return this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t;
    }
    fromBufferAttribute(t, e) {
        return this.r = t.getX(e), this.g = t.getY(e), this.b = t.getZ(e), this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r, yield this.g, yield this.b;
    }
}
const $4a792688e08e5cd7$var$an = new $4a792688e08e5cd7$export$892596cec99bc70e;
$4a792688e08e5cd7$export$892596cec99bc70e.NAMES = $4a792688e08e5cd7$var$tn;
let $4a792688e08e5cd7$var$on = 0;
class $4a792688e08e5cd7$export$a2d8b23205c25948 extends $4a792688e08e5cd7$export$ec8b666c5fe2c75a {
    constructor(){
        super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
            value: $4a792688e08e5cd7$var$on++
        }), this.uuid = $4a792688e08e5cd7$var$rs(), this.name = "", this.type = "Material", this.blending = 1, this.side = 0, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = 204, this.blendDst = 205, this.blendEquation = 100, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new $4a792688e08e5cd7$export$892596cec99bc70e(0, 0, 0), this.blendAlpha = 0, this.depthFunc = 3, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = 519, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = $4a792688e08e5cd7$export$9f542ae4b5baca34, this.stencilZFail = $4a792688e08e5cd7$export$9f542ae4b5baca34, this.stencilZPass = $4a792688e08e5cd7$export$9f542ae4b5baca34, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(t) {
        this._alphaTest > 0 != t > 0 && this.version++, this._alphaTest = t;
    }
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(t) {
        if (void 0 !== t) for(const e in t){
            const i = t[e];
            if (void 0 === i) {
                $4a792688e08e5cd7$export$c106dd0671a0fc2d(`Material: parameter '${e}' has value of undefined.`);
                continue;
            }
            const s = this[e];
            void 0 !== s ? s && s.isColor ? s.set(i) : s && s.isVector3 && i && i.isVector3 ? s.copy(i) : this[e] = i : $4a792688e08e5cd7$export$c106dd0671a0fc2d(`Material: '${e}' is not a property of THREE.${this.type}.`);
        }
    }
    toJSON(t) {
        const e = void 0 === t || "string" == typeof t;
        e && (t = {
            textures: {},
            images: {}
        });
        const i = {
            metadata: {
                version: 4.7,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        function s(t) {
            const e = [];
            for(const i in t){
                const s = t[i];
                delete s.metadata, e.push(s);
            }
            return e;
        }
        if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), this.color && this.color.isColor && (i.color = this.color.getHex()), void 0 !== this.roughness && (i.roughness = this.roughness), void 0 !== this.metalness && (i.metalness = this.metalness), void 0 !== this.sheen && (i.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (i.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (i.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (i.emissive = this.emissive.getHex()), void 0 !== this.emissiveIntensity && 1 !== this.emissiveIntensity && (i.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (i.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (i.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (i.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (i.shininess = this.shininess), void 0 !== this.clearcoat && (i.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (i.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (i.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (i.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (i.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, i.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.sheenColorMap && this.sheenColorMap.isTexture && (i.sheenColorMap = this.sheenColorMap.toJSON(t).uuid), this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture && (i.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(t).uuid), void 0 !== this.dispersion && (i.dispersion = this.dispersion), void 0 !== this.iridescence && (i.iridescence = this.iridescence), void 0 !== this.iridescenceIOR && (i.iridescenceIOR = this.iridescenceIOR), void 0 !== this.iridescenceThicknessRange && (i.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (i.iridescenceMap = this.iridescenceMap.toJSON(t).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (i.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t).uuid), void 0 !== this.anisotropy && (i.anisotropy = this.anisotropy), void 0 !== this.anisotropyRotation && (i.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (i.anisotropyMap = this.anisotropyMap.toJSON(t).uuid), this.map && this.map.isTexture && (i.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (i.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (i.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (i.lightMap = this.lightMap.toJSON(t).uuid, i.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (i.aoMap = this.aoMap.toJSON(t).uuid, i.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (i.bumpMap = this.bumpMap.toJSON(t).uuid, i.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (i.normalMap = this.normalMap.toJSON(t).uuid, i.normalMapType = this.normalMapType, i.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (i.displacementMap = this.displacementMap.toJSON(t).uuid, i.displacementScale = this.displacementScale, i.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (i.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (i.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (i.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (i.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (i.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularColorMap && this.specularColorMap.isTexture && (i.specularColorMap = this.specularColorMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (i.envMap = this.envMap.toJSON(t).uuid, void 0 !== this.combine && (i.combine = this.combine)), void 0 !== this.envMapRotation && (i.envMapRotation = this.envMapRotation.toArray()), void 0 !== this.envMapIntensity && (i.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (i.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (i.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (i.gradientMap = this.gradientMap.toJSON(t).uuid), void 0 !== this.transmission && (i.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (i.transmissionMap = this.transmissionMap.toJSON(t).uuid), void 0 !== this.thickness && (i.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (i.thicknessMap = this.thicknessMap.toJSON(t).uuid), void 0 !== this.attenuationDistance && this.attenuationDistance !== 1 / 0 && (i.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (i.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (i.size = this.size), null !== this.shadowSide && (i.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (i.sizeAttenuation = this.sizeAttenuation), 1 !== this.blending && (i.blending = this.blending), 0 !== this.side && (i.side = this.side), !0 === this.vertexColors && (i.vertexColors = !0), this.opacity < 1 && (i.opacity = this.opacity), !0 === this.transparent && (i.transparent = !0), 204 !== this.blendSrc && (i.blendSrc = this.blendSrc), 205 !== this.blendDst && (i.blendDst = this.blendDst), 100 !== this.blendEquation && (i.blendEquation = this.blendEquation), null !== this.blendSrcAlpha && (i.blendSrcAlpha = this.blendSrcAlpha), null !== this.blendDstAlpha && (i.blendDstAlpha = this.blendDstAlpha), null !== this.blendEquationAlpha && (i.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (i.blendColor = this.blendColor.getHex()), 0 !== this.blendAlpha && (i.blendAlpha = this.blendAlpha), 3 !== this.depthFunc && (i.depthFunc = this.depthFunc), !1 === this.depthTest && (i.depthTest = this.depthTest), !1 === this.depthWrite && (i.depthWrite = this.depthWrite), !1 === this.colorWrite && (i.colorWrite = this.colorWrite), 255 !== this.stencilWriteMask && (i.stencilWriteMask = this.stencilWriteMask), 519 !== this.stencilFunc && (i.stencilFunc = this.stencilFunc), 0 !== this.stencilRef && (i.stencilRef = this.stencilRef), 255 !== this.stencilFuncMask && (i.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== $4a792688e08e5cd7$export$9f542ae4b5baca34 && (i.stencilFail = this.stencilFail), this.stencilZFail !== $4a792688e08e5cd7$export$9f542ae4b5baca34 && (i.stencilZFail = this.stencilZFail), this.stencilZPass !== $4a792688e08e5cd7$export$9f542ae4b5baca34 && (i.stencilZPass = this.stencilZPass), !0 === this.stencilWrite && (i.stencilWrite = this.stencilWrite), void 0 !== this.rotation && 0 !== this.rotation && (i.rotation = this.rotation), !0 === this.polygonOffset && (i.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (i.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (i.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (i.linewidth = this.linewidth), void 0 !== this.dashSize && (i.dashSize = this.dashSize), void 0 !== this.gapSize && (i.gapSize = this.gapSize), void 0 !== this.scale && (i.scale = this.scale), !0 === this.dithering && (i.dithering = !0), this.alphaTest > 0 && (i.alphaTest = this.alphaTest), !0 === this.alphaHash && (i.alphaHash = !0), !0 === this.alphaToCoverage && (i.alphaToCoverage = !0), !0 === this.premultipliedAlpha && (i.premultipliedAlpha = !0), !0 === this.forceSinglePass && (i.forceSinglePass = !0), !0 === this.wireframe && (i.wireframe = !0), this.wireframeLinewidth > 1 && (i.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (i.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (i.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (i.flatShading = !0), !1 === this.visible && (i.visible = !1), !1 === this.toneMapped && (i.toneMapped = !1), !1 === this.fog && (i.fog = !1), Object.keys(this.userData).length > 0 && (i.userData = this.userData), e) {
            const e = s(t.textures), r = s(t.images);
            e.length > 0 && (i.textures = e), r.length > 0 && (i.images = r);
        }
        return i;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t) {
        this.name = t.name, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.blendColor.copy(t.blendColor), this.blendAlpha = t.blendAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
        const e = t.clippingPlanes;
        let i = null;
        if (null !== e) {
            const t = e.length;
            i = new Array(t);
            for(let s = 0; s !== t; ++s)i[s] = e[s].clone();
        }
        return this.clippingPlanes = i, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaHash = t.alphaHash, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.forceSinglePass = t.forceSinglePass, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(t) {
        !0 === t && this.version++;
    }
}
class $4a792688e08e5cd7$export$55cbcc9b622fe1f5 extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $4a792688e08e5cd7$export$d93cc409a0768c5f, this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapRotation.copy(t.envMapRotation), this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.fog = t.fog, this;
    }
}
const $4a792688e08e5cd7$var$cn = $4a792688e08e5cd7$var$un();
function $4a792688e08e5cd7$var$un() {
    const t = new ArrayBuffer(4), e = new Float32Array(t), i = new Uint32Array(t), s = new Uint32Array(512), r = new Uint32Array(512);
    for(let t = 0; t < 256; ++t){
        const e = t - 127;
        e < -27 ? (s[t] = 0, s[256 | t] = 32768, r[t] = 24, r[256 | t] = 24) : e < -14 ? (s[t] = 1024 >> -e - 14, s[256 | t] = 1024 >> -e - 14 | 32768, r[t] = -e - 1, r[256 | t] = -e - 1) : e <= 15 ? (s[t] = e + 15 << 10, s[256 | t] = e + 15 << 10 | 32768, r[t] = 13, r[256 | t] = 13) : e < 128 ? (s[t] = 31744, s[256 | t] = 64512, r[t] = 24, r[256 | t] = 24) : (s[t] = 31744, s[256 | t] = 64512, r[t] = 13, r[256 | t] = 13);
    }
    const n = new Uint32Array(2048), a = new Uint32Array(64), o = new Uint32Array(64);
    for(let t = 1; t < 1024; ++t){
        let e = t << 13, i = 0;
        for(; !(8388608 & e);)e <<= 1, i -= 8388608;
        e &= -8388609, i += 947912704, n[t] = e | i;
    }
    for(let t = 1024; t < 2048; ++t)n[t] = 939524096 + (t - 1024 << 13);
    for(let t = 1; t < 31; ++t)a[t] = t << 23;
    a[31] = 1199570944, a[32] = 2147483648;
    for(let t = 33; t < 63; ++t)a[t] = 2147483648 + (t - 32 << 23);
    a[63] = 3347054592;
    for(let t = 1; t < 64; ++t)32 !== t && (o[t] = 1024);
    return {
        floatView: e,
        uint32View: i,
        baseTable: s,
        shiftTable: r,
        mantissaTable: n,
        exponentTable: a,
        offsetTable: o
    };
}
function $4a792688e08e5cd7$var$dn(t) {
    Math.abs(t) > 65504 && $4a792688e08e5cd7$export$c106dd0671a0fc2d("DataUtils.toHalfFloat(): Value out of range."), t = $4a792688e08e5cd7$var$ns(t, -65504, 65504), $4a792688e08e5cd7$var$cn.floatView[0] = t;
    const e = $4a792688e08e5cd7$var$cn.uint32View[0], i = e >> 23 & 511;
    return $4a792688e08e5cd7$var$cn.baseTable[i] + ((8388607 & e) >> $4a792688e08e5cd7$var$cn.shiftTable[i]);
}
function $4a792688e08e5cd7$var$pn(t) {
    const e = t >> 10;
    return $4a792688e08e5cd7$var$cn.uint32View[0] = $4a792688e08e5cd7$var$cn.mantissaTable[$4a792688e08e5cd7$var$cn.offsetTable[e] + (1023 & t)] + $4a792688e08e5cd7$var$cn.exponentTable[e], $4a792688e08e5cd7$var$cn.floatView[0];
}
class $4a792688e08e5cd7$export$11ce8b759162cc80 {
    static toHalfFloat(t) {
        return $4a792688e08e5cd7$var$dn(t);
    }
    static fromHalfFloat(t) {
        return $4a792688e08e5cd7$var$pn(t);
    }
}
const $4a792688e08e5cd7$var$yn = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$gn = new $4a792688e08e5cd7$export$c977b3e384af9ae1;
let $4a792688e08e5cd7$var$fn = 0;
class $4a792688e08e5cd7$export$8dea267bd6bde117 {
    constructor(t, e, i = !1){
        if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = !0, Object.defineProperty(this, "id", {
            value: $4a792688e08e5cd7$var$fn++
        }), this.name = "", this.array = t, this.itemSize = e, this.count = void 0 !== t ? t.length / e : 0, this.normalized = i, this.usage = $4a792688e08e5cd7$export$763e8360f4d7f77d, this.updateRanges = [], this.gpuType = $4a792688e08e5cd7$export$f6d331659b644596, this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(t) {
        !0 === t && this.version++;
    }
    setUsage(t) {
        return this.usage = t, this;
    }
    addUpdateRange(t, e) {
        this.updateRanges.push({
            start: t,
            count: e
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(t) {
        return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this.gpuType = t.gpuType, this;
    }
    copyAt(t, e, i) {
        t *= this.itemSize, i *= e.itemSize;
        for(let s = 0, r = this.itemSize; s < r; s++)this.array[t + s] = e.array[i + s];
        return this;
    }
    copyArray(t) {
        return this.array.set(t), this;
    }
    applyMatrix3(t) {
        if (2 === this.itemSize) for(let e = 0, i = this.count; e < i; e++)$4a792688e08e5cd7$var$gn.fromBufferAttribute(this, e), $4a792688e08e5cd7$var$gn.applyMatrix3(t), this.setXY(e, $4a792688e08e5cd7$var$gn.x, $4a792688e08e5cd7$var$gn.y);
        else if (3 === this.itemSize) for(let e = 0, i = this.count; e < i; e++)$4a792688e08e5cd7$var$yn.fromBufferAttribute(this, e), $4a792688e08e5cd7$var$yn.applyMatrix3(t), this.setXYZ(e, $4a792688e08e5cd7$var$yn.x, $4a792688e08e5cd7$var$yn.y, $4a792688e08e5cd7$var$yn.z);
        return this;
    }
    applyMatrix4(t) {
        for(let e = 0, i = this.count; e < i; e++)$4a792688e08e5cd7$var$yn.fromBufferAttribute(this, e), $4a792688e08e5cd7$var$yn.applyMatrix4(t), this.setXYZ(e, $4a792688e08e5cd7$var$yn.x, $4a792688e08e5cd7$var$yn.y, $4a792688e08e5cd7$var$yn.z);
        return this;
    }
    applyNormalMatrix(t) {
        for(let e = 0, i = this.count; e < i; e++)$4a792688e08e5cd7$var$yn.fromBufferAttribute(this, e), $4a792688e08e5cd7$var$yn.applyNormalMatrix(t), this.setXYZ(e, $4a792688e08e5cd7$var$yn.x, $4a792688e08e5cd7$var$yn.y, $4a792688e08e5cd7$var$yn.z);
        return this;
    }
    transformDirection(t) {
        for(let e = 0, i = this.count; e < i; e++)$4a792688e08e5cd7$var$yn.fromBufferAttribute(this, e), $4a792688e08e5cd7$var$yn.transformDirection(t), this.setXYZ(e, $4a792688e08e5cd7$var$yn.x, $4a792688e08e5cd7$var$yn.y, $4a792688e08e5cd7$var$yn.z);
        return this;
    }
    set(t, e = 0) {
        return this.array.set(t, e), this;
    }
    getComponent(t, e) {
        let i = this.array[t * this.itemSize + e];
        return this.normalized && (i = $4a792688e08e5cd7$var$hs(i, this.array)), i;
    }
    setComponent(t, e, i) {
        return this.normalized && (i = $4a792688e08e5cd7$var$ls(i, this.array)), this.array[t * this.itemSize + e] = i, this;
    }
    getX(t) {
        let e = this.array[t * this.itemSize];
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    setX(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.array[t * this.itemSize] = e, this;
    }
    getY(t) {
        let e = this.array[t * this.itemSize + 1];
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    setY(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.array[t * this.itemSize + 1] = e, this;
    }
    getZ(t) {
        let e = this.array[t * this.itemSize + 2];
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    setZ(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.array[t * this.itemSize + 2] = e, this;
    }
    getW(t) {
        let e = this.array[t * this.itemSize + 3];
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    setW(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.array[t * this.itemSize + 3] = e, this;
    }
    setXY(t, e, i) {
        return t *= this.itemSize, this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array), i = $4a792688e08e5cd7$var$ls(i, this.array)), this.array[t + 0] = e, this.array[t + 1] = i, this;
    }
    setXYZ(t, e, i, s) {
        return t *= this.itemSize, this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array), i = $4a792688e08e5cd7$var$ls(i, this.array), s = $4a792688e08e5cd7$var$ls(s, this.array)), this.array[t + 0] = e, this.array[t + 1] = i, this.array[t + 2] = s, this;
    }
    setXYZW(t, e, i, s, r) {
        return t *= this.itemSize, this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array), i = $4a792688e08e5cd7$var$ls(i, this.array), s = $4a792688e08e5cd7$var$ls(s, this.array), r = $4a792688e08e5cd7$var$ls(r, this.array)), this.array[t + 0] = e, this.array[t + 1] = i, this.array[t + 2] = s, this.array[t + 3] = r, this;
    }
    onUpload(t) {
        return this.onUploadCallback = t, this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const t = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        return "" !== this.name && (t.name = this.name), this.usage !== $4a792688e08e5cd7$export$763e8360f4d7f77d && (t.usage = this.usage), t;
    }
}
class $4a792688e08e5cd7$export$f9ff2d6a20248cbf extends $4a792688e08e5cd7$export$8dea267bd6bde117 {
    constructor(t, e, i){
        super(new Int8Array(t), e, i);
    }
}
class $4a792688e08e5cd7$export$cacc90cf35d11cdd extends $4a792688e08e5cd7$export$8dea267bd6bde117 {
    constructor(t, e, i){
        super(new Uint8Array(t), e, i);
    }
}
class $4a792688e08e5cd7$export$baaa85a1a812c157 extends $4a792688e08e5cd7$export$8dea267bd6bde117 {
    constructor(t, e, i){
        super(new Uint8ClampedArray(t), e, i);
    }
}
class $4a792688e08e5cd7$export$2b755a102ccdcefe extends $4a792688e08e5cd7$export$8dea267bd6bde117 {
    constructor(t, e, i){
        super(new Int16Array(t), e, i);
    }
}
class $4a792688e08e5cd7$export$640a853f68025f2e extends $4a792688e08e5cd7$export$8dea267bd6bde117 {
    constructor(t, e, i){
        super(new Uint16Array(t), e, i);
    }
}
class $4a792688e08e5cd7$export$46b369aed2968a0a extends $4a792688e08e5cd7$export$8dea267bd6bde117 {
    constructor(t, e, i){
        super(new Int32Array(t), e, i);
    }
}
class $4a792688e08e5cd7$export$7eb8c9fa25cd5bd6 extends $4a792688e08e5cd7$export$8dea267bd6bde117 {
    constructor(t, e, i){
        super(new Uint32Array(t), e, i);
    }
}
class $4a792688e08e5cd7$export$dbd3698c64958d69 extends $4a792688e08e5cd7$export$8dea267bd6bde117 {
    constructor(t, e, i){
        super(new Uint16Array(t), e, i), this.isFloat16BufferAttribute = !0;
    }
    getX(t) {
        let e = $4a792688e08e5cd7$var$pn(this.array[t * this.itemSize]);
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    setX(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.array[t * this.itemSize] = $4a792688e08e5cd7$var$dn(e), this;
    }
    getY(t) {
        let e = $4a792688e08e5cd7$var$pn(this.array[t * this.itemSize + 1]);
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    setY(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.array[t * this.itemSize + 1] = $4a792688e08e5cd7$var$dn(e), this;
    }
    getZ(t) {
        let e = $4a792688e08e5cd7$var$pn(this.array[t * this.itemSize + 2]);
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    setZ(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.array[t * this.itemSize + 2] = $4a792688e08e5cd7$var$dn(e), this;
    }
    getW(t) {
        let e = $4a792688e08e5cd7$var$pn(this.array[t * this.itemSize + 3]);
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    setW(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.array[t * this.itemSize + 3] = $4a792688e08e5cd7$var$dn(e), this;
    }
    setXY(t, e, i) {
        return t *= this.itemSize, this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array), i = $4a792688e08e5cd7$var$ls(i, this.array)), this.array[t + 0] = $4a792688e08e5cd7$var$dn(e), this.array[t + 1] = $4a792688e08e5cd7$var$dn(i), this;
    }
    setXYZ(t, e, i, s) {
        return t *= this.itemSize, this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array), i = $4a792688e08e5cd7$var$ls(i, this.array), s = $4a792688e08e5cd7$var$ls(s, this.array)), this.array[t + 0] = $4a792688e08e5cd7$var$dn(e), this.array[t + 1] = $4a792688e08e5cd7$var$dn(i), this.array[t + 2] = $4a792688e08e5cd7$var$dn(s), this;
    }
    setXYZW(t, e, i, s, r) {
        return t *= this.itemSize, this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array), i = $4a792688e08e5cd7$var$ls(i, this.array), s = $4a792688e08e5cd7$var$ls(s, this.array), r = $4a792688e08e5cd7$var$ls(r, this.array)), this.array[t + 0] = $4a792688e08e5cd7$var$dn(e), this.array[t + 1] = $4a792688e08e5cd7$var$dn(i), this.array[t + 2] = $4a792688e08e5cd7$var$dn(s), this.array[t + 3] = $4a792688e08e5cd7$var$dn(r), this;
    }
}
class $4a792688e08e5cd7$export$cbe7a62641830ebd extends $4a792688e08e5cd7$export$8dea267bd6bde117 {
    constructor(t, e, i){
        super(new Float32Array(t), e, i);
    }
}
let $4a792688e08e5cd7$var$Cn = 0;
const $4a792688e08e5cd7$var$In = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$Bn = new $4a792688e08e5cd7$export$e4dd07dff30cc924, $4a792688e08e5cd7$var$kn = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Pn = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3, $4a792688e08e5cd7$var$On = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3, $4a792688e08e5cd7$var$Rn = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$b7be63a67df8959 extends $4a792688e08e5cd7$export$ec8b666c5fe2c75a {
    constructor(){
        super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
            value: $4a792688e08e5cd7$var$Cn++
        }), this.uuid = $4a792688e08e5cd7$var$rs(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
            start: 0,
            count: 1 / 0
        }, this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(t) {
        return Array.isArray(t) ? this.index = new ($4a792688e08e5cd7$export$bc6f937da07eae17(t) ? $4a792688e08e5cd7$export$7eb8c9fa25cd5bd6 : $4a792688e08e5cd7$export$640a853f68025f2e)(t, 1) : this.index = t, this;
    }
    setIndirect(t) {
        return this.indirect = t, this;
    }
    getIndirect() {
        return this.indirect;
    }
    getAttribute(t) {
        return this.attributes[t];
    }
    setAttribute(t, e) {
        return this.attributes[t] = e, this;
    }
    deleteAttribute(t) {
        return delete this.attributes[t], this;
    }
    hasAttribute(t) {
        return void 0 !== this.attributes[t];
    }
    addGroup(t, e, i = 0) {
        this.groups.push({
            start: t,
            count: e,
            materialIndex: i
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(t, e) {
        this.drawRange.start = t, this.drawRange.count = e;
    }
    applyMatrix4(t) {
        const e = this.attributes.position;
        void 0 !== e && (e.applyMatrix4(t), e.needsUpdate = !0);
        const i = this.attributes.normal;
        if (void 0 !== i) {
            const e = (new $4a792688e08e5cd7$export$8ff26dafa08918).getNormalMatrix(t);
            i.applyNormalMatrix(e), i.needsUpdate = !0;
        }
        const s = this.attributes.tangent;
        return void 0 !== s && (s.transformDirection(t), s.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
    }
    applyQuaternion(t) {
        return $4a792688e08e5cd7$var$In.makeRotationFromQuaternion(t), this.applyMatrix4($4a792688e08e5cd7$var$In), this;
    }
    rotateX(t) {
        return $4a792688e08e5cd7$var$In.makeRotationX(t), this.applyMatrix4($4a792688e08e5cd7$var$In), this;
    }
    rotateY(t) {
        return $4a792688e08e5cd7$var$In.makeRotationY(t), this.applyMatrix4($4a792688e08e5cd7$var$In), this;
    }
    rotateZ(t) {
        return $4a792688e08e5cd7$var$In.makeRotationZ(t), this.applyMatrix4($4a792688e08e5cd7$var$In), this;
    }
    translate(t, e, i) {
        return $4a792688e08e5cd7$var$In.makeTranslation(t, e, i), this.applyMatrix4($4a792688e08e5cd7$var$In), this;
    }
    scale(t, e, i) {
        return $4a792688e08e5cd7$var$In.makeScale(t, e, i), this.applyMatrix4($4a792688e08e5cd7$var$In), this;
    }
    lookAt(t) {
        return $4a792688e08e5cd7$var$Bn.lookAt(t), $4a792688e08e5cd7$var$Bn.updateMatrix(), this.applyMatrix4($4a792688e08e5cd7$var$Bn.matrix), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter($4a792688e08e5cd7$var$kn).negate(), this.translate($4a792688e08e5cd7$var$kn.x, $4a792688e08e5cd7$var$kn.y, $4a792688e08e5cd7$var$kn.z), this;
    }
    setFromPoints(t) {
        const e = this.getAttribute("position");
        if (void 0 === e) {
            const e = [];
            for(let i = 0, s = t.length; i < s; i++){
                const s = t[i];
                e.push(s.x, s.y, s.z || 0);
            }
            this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(e, 3));
        } else {
            const i = Math.min(t.length, e.count);
            for(let s = 0; s < i; s++){
                const i = t[s];
                e.setXYZ(s, i.x, i.y, i.z || 0);
            }
            t.length > e.count && $4a792688e08e5cd7$export$c106dd0671a0fc2d("BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), e.needsUpdate = !0;
        }
        return this;
    }
    computeBoundingBox() {
        null === this.boundingBox && (this.boundingBox = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3);
        const t = this.attributes.position, e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) return $4a792688e08e5cd7$export$a3bc9b8ed74fc("BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), void this.boundingBox.set(new $4a792688e08e5cd7$export$64b5c384219d3699(-1 / 0, -1 / 0, -1 / 0), new $4a792688e08e5cd7$export$64b5c384219d3699(1 / 0, 1 / 0, 1 / 0));
        if (void 0 !== t) {
            if (this.boundingBox.setFromBufferAttribute(t), e) for(let t = 0, i = e.length; t < i; t++){
                const i = e[t];
                $4a792688e08e5cd7$var$Pn.setFromBufferAttribute(i), this.morphTargetsRelative ? ($4a792688e08e5cd7$var$Rn.addVectors(this.boundingBox.min, $4a792688e08e5cd7$var$Pn.min), this.boundingBox.expandByPoint($4a792688e08e5cd7$var$Rn), $4a792688e08e5cd7$var$Rn.addVectors(this.boundingBox.max, $4a792688e08e5cd7$var$Pn.max), this.boundingBox.expandByPoint($4a792688e08e5cd7$var$Rn)) : (this.boundingBox.expandByPoint($4a792688e08e5cd7$var$Pn.min), this.boundingBox.expandByPoint($4a792688e08e5cd7$var$Pn.max));
            }
        } else this.boundingBox.makeEmpty();
        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && $4a792688e08e5cd7$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        null === this.boundingSphere && (this.boundingSphere = new $4a792688e08e5cd7$export$805e8b72413ccaba);
        const t = this.attributes.position, e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) return $4a792688e08e5cd7$export$a3bc9b8ed74fc("BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), void this.boundingSphere.set(new $4a792688e08e5cd7$export$64b5c384219d3699, 1 / 0);
        if (t) {
            const i = this.boundingSphere.center;
            if ($4a792688e08e5cd7$var$Pn.setFromBufferAttribute(t), e) for(let t = 0, i = e.length; t < i; t++){
                const i = e[t];
                $4a792688e08e5cd7$var$On.setFromBufferAttribute(i), this.morphTargetsRelative ? ($4a792688e08e5cd7$var$Rn.addVectors($4a792688e08e5cd7$var$Pn.min, $4a792688e08e5cd7$var$On.min), $4a792688e08e5cd7$var$Pn.expandByPoint($4a792688e08e5cd7$var$Rn), $4a792688e08e5cd7$var$Rn.addVectors($4a792688e08e5cd7$var$Pn.max, $4a792688e08e5cd7$var$On.max), $4a792688e08e5cd7$var$Pn.expandByPoint($4a792688e08e5cd7$var$Rn)) : ($4a792688e08e5cd7$var$Pn.expandByPoint($4a792688e08e5cd7$var$On.min), $4a792688e08e5cd7$var$Pn.expandByPoint($4a792688e08e5cd7$var$On.max));
            }
            $4a792688e08e5cd7$var$Pn.getCenter(i);
            let s = 0;
            for(let e = 0, r = t.count; e < r; e++)$4a792688e08e5cd7$var$Rn.fromBufferAttribute(t, e), s = Math.max(s, i.distanceToSquared($4a792688e08e5cd7$var$Rn));
            if (e) for(let r = 0, n = e.length; r < n; r++){
                const n = e[r], a = this.morphTargetsRelative;
                for(let e = 0, r = n.count; e < r; e++)$4a792688e08e5cd7$var$Rn.fromBufferAttribute(n, e), a && ($4a792688e08e5cd7$var$kn.fromBufferAttribute(t, e), $4a792688e08e5cd7$var$Rn.add($4a792688e08e5cd7$var$kn)), s = Math.max(s, i.distanceToSquared($4a792688e08e5cd7$var$Rn));
            }
            this.boundingSphere.radius = Math.sqrt(s), isNaN(this.boundingSphere.radius) && $4a792688e08e5cd7$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const t = this.index, e = this.attributes;
        if (null === t || void 0 === e.position || void 0 === e.normal || void 0 === e.uv) return void $4a792688e08e5cd7$export$a3bc9b8ed74fc("BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
        const i = e.position, s = e.normal, r = e.uv;
        !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new $4a792688e08e5cd7$export$8dea267bd6bde117(new Float32Array(4 * i.count), 4));
        const n = this.getAttribute("tangent"), a = [], o = [];
        for(let t = 0; t < i.count; t++)a[t] = new $4a792688e08e5cd7$export$64b5c384219d3699, o[t] = new $4a792688e08e5cd7$export$64b5c384219d3699;
        const h = new $4a792688e08e5cd7$export$64b5c384219d3699, l = new $4a792688e08e5cd7$export$64b5c384219d3699, c = new $4a792688e08e5cd7$export$64b5c384219d3699, u = new $4a792688e08e5cd7$export$c977b3e384af9ae1, d = new $4a792688e08e5cd7$export$c977b3e384af9ae1, p = new $4a792688e08e5cd7$export$c977b3e384af9ae1, m = new $4a792688e08e5cd7$export$64b5c384219d3699, y = new $4a792688e08e5cd7$export$64b5c384219d3699;
        function g(t, e, s) {
            h.fromBufferAttribute(i, t), l.fromBufferAttribute(i, e), c.fromBufferAttribute(i, s), u.fromBufferAttribute(r, t), d.fromBufferAttribute(r, e), p.fromBufferAttribute(r, s), l.sub(h), c.sub(h), d.sub(u), p.sub(u);
            const n = 1 / (d.x * p.y - p.x * d.y);
            isFinite(n) && (m.copy(l).multiplyScalar(p.y).addScaledVector(c, -d.y).multiplyScalar(n), y.copy(c).multiplyScalar(d.x).addScaledVector(l, -p.x).multiplyScalar(n), a[t].add(m), a[e].add(m), a[s].add(m), o[t].add(y), o[e].add(y), o[s].add(y));
        }
        let f = this.groups;
        0 === f.length && (f = [
            {
                start: 0,
                count: t.count
            }
        ]);
        for(let e = 0, i = f.length; e < i; ++e){
            const i = f[e], s = i.start;
            for(let e = s, r = s + i.count; e < r; e += 3)g(t.getX(e + 0), t.getX(e + 1), t.getX(e + 2));
        }
        const x = new $4a792688e08e5cd7$export$64b5c384219d3699, b = new $4a792688e08e5cd7$export$64b5c384219d3699, v = new $4a792688e08e5cd7$export$64b5c384219d3699, w = new $4a792688e08e5cd7$export$64b5c384219d3699;
        function M(t) {
            v.fromBufferAttribute(s, t), w.copy(v);
            const e = a[t];
            x.copy(e), x.sub(v.multiplyScalar(v.dot(e))).normalize(), b.crossVectors(w, e);
            const i = b.dot(o[t]) < 0 ? -1 : 1;
            n.setXYZW(t, x.x, x.y, x.z, i);
        }
        for(let e = 0, i = f.length; e < i; ++e){
            const i = f[e], s = i.start;
            for(let e = s, r = s + i.count; e < r; e += 3)M(t.getX(e + 0)), M(t.getX(e + 1)), M(t.getX(e + 2));
        }
    }
    computeVertexNormals() {
        const t = this.index, e = this.getAttribute("position");
        if (void 0 !== e) {
            let i = this.getAttribute("normal");
            if (void 0 === i) i = new $4a792688e08e5cd7$export$8dea267bd6bde117(new Float32Array(3 * e.count), 3), this.setAttribute("normal", i);
            else for(let t = 0, e = i.count; t < e; t++)i.setXYZ(t, 0, 0, 0);
            const s = new $4a792688e08e5cd7$export$64b5c384219d3699, r = new $4a792688e08e5cd7$export$64b5c384219d3699, n = new $4a792688e08e5cd7$export$64b5c384219d3699, a = new $4a792688e08e5cd7$export$64b5c384219d3699, o = new $4a792688e08e5cd7$export$64b5c384219d3699, h = new $4a792688e08e5cd7$export$64b5c384219d3699, l = new $4a792688e08e5cd7$export$64b5c384219d3699, c = new $4a792688e08e5cd7$export$64b5c384219d3699;
            if (t) for(let u = 0, d = t.count; u < d; u += 3){
                const d = t.getX(u + 0), p = t.getX(u + 1), m = t.getX(u + 2);
                s.fromBufferAttribute(e, d), r.fromBufferAttribute(e, p), n.fromBufferAttribute(e, m), l.subVectors(n, r), c.subVectors(s, r), l.cross(c), a.fromBufferAttribute(i, d), o.fromBufferAttribute(i, p), h.fromBufferAttribute(i, m), a.add(l), o.add(l), h.add(l), i.setXYZ(d, a.x, a.y, a.z), i.setXYZ(p, o.x, o.y, o.z), i.setXYZ(m, h.x, h.y, h.z);
            }
            else for(let t = 0, a = e.count; t < a; t += 3)s.fromBufferAttribute(e, t + 0), r.fromBufferAttribute(e, t + 1), n.fromBufferAttribute(e, t + 2), l.subVectors(n, r), c.subVectors(s, r), l.cross(c), i.setXYZ(t + 0, l.x, l.y, l.z), i.setXYZ(t + 1, l.x, l.y, l.z), i.setXYZ(t + 2, l.x, l.y, l.z);
            this.normalizeNormals(), i.needsUpdate = !0;
        }
    }
    normalizeNormals() {
        const t = this.attributes.normal;
        for(let e = 0, i = t.count; e < i; e++)$4a792688e08e5cd7$var$Rn.fromBufferAttribute(t, e), $4a792688e08e5cd7$var$Rn.normalize(), t.setXYZ(e, $4a792688e08e5cd7$var$Rn.x, $4a792688e08e5cd7$var$Rn.y, $4a792688e08e5cd7$var$Rn.z);
    }
    toNonIndexed() {
        function t(t, e) {
            const i = t.array, s = t.itemSize, r = t.normalized, n = new i.constructor(e.length * s);
            let a = 0, o = 0;
            for(let r = 0, h = e.length; r < h; r++){
                a = t.isInterleavedBufferAttribute ? e[r] * t.data.stride + t.offset : e[r] * s;
                for(let t = 0; t < s; t++)n[o++] = i[a++];
            }
            return new $4a792688e08e5cd7$export$8dea267bd6bde117(n, s, r);
        }
        if (null === this.index) return $4a792688e08e5cd7$export$c106dd0671a0fc2d("BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
        const e = new $4a792688e08e5cd7$export$b7be63a67df8959, i = this.index.array, s = this.attributes;
        for(const r in s){
            const n = t(s[r], i);
            e.setAttribute(r, n);
        }
        const r = this.morphAttributes;
        for(const s in r){
            const n = [], a = r[s];
            for(let e = 0, s = a.length; e < s; e++){
                const s = t(a[e], i);
                n.push(s);
            }
            e.morphAttributes[s] = n;
        }
        e.morphTargetsRelative = this.morphTargetsRelative;
        const n = this.groups;
        for(let t = 0, i = n.length; t < i; t++){
            const i = n[t];
            e.addGroup(i.start, i.count, i.materialIndex);
        }
        return e;
    }
    toJSON() {
        const t = {
            metadata: {
                version: 4.7,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        if (t.uuid = this.uuid, t.type = this.type, "" !== this.name && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), void 0 !== this.parameters) {
            const e = this.parameters;
            for(const i in e)void 0 !== e[i] && (t[i] = e[i]);
            return t;
        }
        t.data = {
            attributes: {}
        };
        const e = this.index;
        null !== e && (t.data.index = {
            type: e.array.constructor.name,
            array: Array.prototype.slice.call(e.array)
        });
        const i = this.attributes;
        for(const e in i){
            const s = i[e];
            t.data.attributes[e] = s.toJSON(t.data);
        }
        const s = {};
        let r = !1;
        for(const e in this.morphAttributes){
            const i = this.morphAttributes[e], n = [];
            for(let e = 0, s = i.length; e < s; e++){
                const s = i[e];
                n.push(s.toJSON(t.data));
            }
            n.length > 0 && (s[e] = n, r = !0);
        }
        r && (t.data.morphAttributes = s, t.data.morphTargetsRelative = this.morphTargetsRelative);
        const n = this.groups;
        n.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(n)));
        const a = this.boundingSphere;
        return null !== a && (t.data.boundingSphere = a.toJSON()), t;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t) {
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
        const e = {};
        this.name = t.name;
        const i = t.index;
        null !== i && this.setIndex(i.clone());
        const s = t.attributes;
        for(const t in s){
            const i = s[t];
            this.setAttribute(t, i.clone(e));
        }
        const r = t.morphAttributes;
        for(const t in r){
            const i = [], s = r[t];
            for(let t = 0, r = s.length; t < r; t++)i.push(s[t].clone(e));
            this.morphAttributes[t] = i;
        }
        this.morphTargetsRelative = t.morphTargetsRelative;
        const n = t.groups;
        for(let t = 0, e = n.length; t < e; t++){
            const e = n[t];
            this.addGroup(e.start, e.count, e.materialIndex);
        }
        const a = t.boundingBox;
        null !== a && (this.boundingBox = a.clone());
        const o = t.boundingSphere;
        return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $4a792688e08e5cd7$var$Vn = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$Fn = new $4a792688e08e5cd7$export$a186db52eed6d40e, $4a792688e08e5cd7$var$Ln = new $4a792688e08e5cd7$export$805e8b72413ccaba, $4a792688e08e5cd7$var$En = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$jn = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Dn = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Wn = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Un = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$qn = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Jn = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Xn = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$e176487c05830cc5 extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(t = new $4a792688e08e5cd7$export$b7be63a67df8959, e = new $4a792688e08e5cd7$export$55cbcc9b622fe1f5){
        super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t, this.material = e, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
    }
    copy(t, e) {
        return super.copy(t, e), void 0 !== t.morphTargetInfluences && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), void 0 !== t.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = Array.isArray(t.material) ? t.material.slice() : t.material, this.geometry = t.geometry, this;
    }
    updateMorphTargets() {
        const t = this.geometry.morphAttributes, e = Object.keys(t);
        if (e.length > 0) {
            const i = t[e[0]];
            if (void 0 !== i) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let t = 0, e = i.length; t < e; t++){
                    const e = i[t].name || String(t);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t;
                }
            }
        }
    }
    getVertexPosition(t, e) {
        const i = this.geometry, s = i.attributes.position, r = i.morphAttributes.position, n = i.morphTargetsRelative;
        e.fromBufferAttribute(s, t);
        const a = this.morphTargetInfluences;
        if (r && a) {
            $4a792688e08e5cd7$var$qn.set(0, 0, 0);
            for(let i = 0, s = r.length; i < s; i++){
                const s = a[i], o = r[i];
                0 !== s && ($4a792688e08e5cd7$var$Un.fromBufferAttribute(o, t), n ? $4a792688e08e5cd7$var$qn.addScaledVector($4a792688e08e5cd7$var$Un, s) : $4a792688e08e5cd7$var$qn.addScaledVector($4a792688e08e5cd7$var$Un.sub(e), s));
            }
            e.add($4a792688e08e5cd7$var$qn);
        }
        return e;
    }
    raycast(t, e) {
        const i = this.geometry, s = this.material, r = this.matrixWorld;
        if (void 0 !== s) {
            if (null === i.boundingSphere && i.computeBoundingSphere(), $4a792688e08e5cd7$var$Ln.copy(i.boundingSphere), $4a792688e08e5cd7$var$Ln.applyMatrix4(r), $4a792688e08e5cd7$var$Fn.copy(t.ray).recast(t.near), !1 === $4a792688e08e5cd7$var$Ln.containsPoint($4a792688e08e5cd7$var$Fn.origin)) {
                if (null === $4a792688e08e5cd7$var$Fn.intersectSphere($4a792688e08e5cd7$var$Ln, $4a792688e08e5cd7$var$En)) return;
                if ($4a792688e08e5cd7$var$Fn.origin.distanceToSquared($4a792688e08e5cd7$var$En) > (t.far - t.near) ** 2) return;
            }
            $4a792688e08e5cd7$var$Vn.copy(r).invert(), $4a792688e08e5cd7$var$Fn.copy(t.ray).applyMatrix4($4a792688e08e5cd7$var$Vn), null !== i.boundingBox && !1 === $4a792688e08e5cd7$var$Fn.intersectsBox(i.boundingBox) || this._computeIntersections(t, e, $4a792688e08e5cd7$var$Fn);
        }
    }
    _computeIntersections(t, e, i) {
        let s;
        const r = this.geometry, n = this.material, a = r.index, o = r.attributes.position, h = r.attributes.uv, l = r.attributes.uv1, c = r.attributes.normal, u = r.groups, d = r.drawRange;
        if (null !== a) {
            if (Array.isArray(n)) for(let r = 0, o = u.length; r < o; r++){
                const o = u[r], p = n[o.materialIndex];
                for(let r = Math.max(o.start, d.start), n = Math.min(a.count, Math.min(o.start + o.count, d.start + d.count)); r < n; r += 3)s = $4a792688e08e5cd7$var$Zn(this, p, t, i, h, l, c, a.getX(r), a.getX(r + 1), a.getX(r + 2)), s && (s.faceIndex = Math.floor(r / 3), s.face.materialIndex = o.materialIndex, e.push(s));
            }
            else for(let r = Math.max(0, d.start), o = Math.min(a.count, d.start + d.count); r < o; r += 3)s = $4a792688e08e5cd7$var$Zn(this, n, t, i, h, l, c, a.getX(r), a.getX(r + 1), a.getX(r + 2)), s && (s.faceIndex = Math.floor(r / 3), e.push(s));
        } else if (void 0 !== o) {
            if (Array.isArray(n)) for(let r = 0, a = u.length; r < a; r++){
                const a = u[r], p = n[a.materialIndex];
                for(let r = Math.max(a.start, d.start), n = Math.min(o.count, Math.min(a.start + a.count, d.start + d.count)); r < n; r += 3)s = $4a792688e08e5cd7$var$Zn(this, p, t, i, h, l, c, r, r + 1, r + 2), s && (s.faceIndex = Math.floor(r / 3), s.face.materialIndex = a.materialIndex, e.push(s));
            }
            else for(let r = Math.max(0, d.start), a = Math.min(o.count, d.start + d.count); r < a; r += 3)s = $4a792688e08e5cd7$var$Zn(this, n, t, i, h, l, c, r, r + 1, r + 2), s && (s.faceIndex = Math.floor(r / 3), e.push(s));
        }
    }
}
function $4a792688e08e5cd7$var$Zn(t, e, i, s, r, n, a, o, h, l) {
    t.getVertexPosition(o, $4a792688e08e5cd7$var$jn), t.getVertexPosition(h, $4a792688e08e5cd7$var$Dn), t.getVertexPosition(l, $4a792688e08e5cd7$var$Wn);
    const c = function(t, e, i, s, r, n, a, o) {
        let h;
        if (h = 1 === e.side ? s.intersectTriangle(a, n, r, !0, o) : s.intersectTriangle(r, n, a, 0 === e.side, o), null === h) return null;
        $4a792688e08e5cd7$var$Xn.copy(o), $4a792688e08e5cd7$var$Xn.applyMatrix4(t.matrixWorld);
        const l = i.ray.origin.distanceTo($4a792688e08e5cd7$var$Xn);
        return l < i.near || l > i.far ? null : {
            distance: l,
            point: $4a792688e08e5cd7$var$Xn.clone(),
            object: t
        };
    }(t, e, i, s, $4a792688e08e5cd7$var$jn, $4a792688e08e5cd7$var$Dn, $4a792688e08e5cd7$var$Wn, $4a792688e08e5cd7$var$Jn);
    if (c) {
        const t = new $4a792688e08e5cd7$export$64b5c384219d3699;
        $4a792688e08e5cd7$export$5a465592bfe74b48.getBarycoord($4a792688e08e5cd7$var$Jn, $4a792688e08e5cd7$var$jn, $4a792688e08e5cd7$var$Dn, $4a792688e08e5cd7$var$Wn, t), r && (c.uv = $4a792688e08e5cd7$export$5a465592bfe74b48.getInterpolatedAttribute(r, o, h, l, t, new $4a792688e08e5cd7$export$c977b3e384af9ae1)), n && (c.uv1 = $4a792688e08e5cd7$export$5a465592bfe74b48.getInterpolatedAttribute(n, o, h, l, t, new $4a792688e08e5cd7$export$c977b3e384af9ae1)), a && (c.normal = $4a792688e08e5cd7$export$5a465592bfe74b48.getInterpolatedAttribute(a, o, h, l, t, new $4a792688e08e5cd7$export$64b5c384219d3699), c.normal.dot(s.direction) > 0 && c.normal.multiplyScalar(-1));
        const e = {
            a: o,
            b: h,
            c: l,
            normal: new $4a792688e08e5cd7$export$64b5c384219d3699,
            materialIndex: 0
        };
        $4a792688e08e5cd7$export$5a465592bfe74b48.getNormal($4a792688e08e5cd7$var$jn, $4a792688e08e5cd7$var$Dn, $4a792688e08e5cd7$var$Wn, e.normal), c.face = e, c.barycoord = t;
    }
    return c;
}
class $4a792688e08e5cd7$export$33e43285f7406bd5 extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = 1, e = 1, i = 1, s = 1, r = 1, n = 1){
        super(), this.type = "BoxGeometry", this.parameters = {
            width: t,
            height: e,
            depth: i,
            widthSegments: s,
            heightSegments: r,
            depthSegments: n
        };
        const a = this;
        s = Math.floor(s), r = Math.floor(r), n = Math.floor(n);
        const o = [], h = [], l = [], c = [];
        let u = 0, d = 0;
        function p(t, e, i, s, r, n, p, m, y, g, f) {
            const x = n / y, b = p / g, v = n / 2, w = p / 2, M = m / 2, S = y + 1, _ = g + 1;
            let A = 0, T = 0;
            const z = new $4a792688e08e5cd7$export$64b5c384219d3699;
            for(let n = 0; n < _; n++){
                const a = n * b - w;
                for(let o = 0; o < S; o++){
                    const u = o * x - v;
                    z[t] = u * s, z[e] = a * r, z[i] = M, h.push(z.x, z.y, z.z), z[t] = 0, z[e] = 0, z[i] = m > 0 ? 1 : -1, l.push(z.x, z.y, z.z), c.push(o / y), c.push(1 - n / g), A += 1;
                }
            }
            for(let t = 0; t < g; t++)for(let e = 0; e < y; e++){
                const i = u + e + S * t, s = u + e + S * (t + 1), r = u + (e + 1) + S * (t + 1), n = u + (e + 1) + S * t;
                o.push(i, s, n), o.push(s, r, n), T += 6;
            }
            a.addGroup(d, T, f), d += T, u += A;
        }
        p("z", "y", "x", -1, -1, i, e, t, n, r, 0), p("z", "y", "x", 1, -1, i, e, -t, n, r, 1), p("x", "z", "y", 1, 1, t, i, e, s, n, 2), p("x", "z", "y", 1, -1, t, i, -e, s, n, 3), p("x", "y", "z", 1, -1, t, e, i, s, r, 4), p("x", "y", "z", -1, -1, t, e, -i, s, r, 5), this.setIndex(o), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(h, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(l, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(c, 2));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$33e43285f7406bd5(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
    }
}
function $4a792688e08e5cd7$export$acda854380553452(t) {
    const e = {};
    for(const i in t){
        e[i] = {};
        for(const s in t[i]){
            const r = t[i][s];
            r && (r.isColor || r.isMatrix3 || r.isMatrix4 || r.isVector2 || r.isVector3 || r.isVector4 || r.isTexture || r.isQuaternion) ? r.isRenderTargetTexture ? ($4a792688e08e5cd7$export$c106dd0671a0fc2d("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[i][s] = null) : e[i][s] = r.clone() : Array.isArray(r) ? e[i][s] = r.slice() : e[i][s] = r;
        }
    }
    return e;
}
function $4a792688e08e5cd7$export$8916ce6879271f43(t) {
    const e = {};
    for(let i = 0; i < t.length; i++){
        const s = $4a792688e08e5cd7$export$acda854380553452(t[i]);
        for(const t in s)e[t] = s[t];
    }
    return e;
}
function $4a792688e08e5cd7$export$a630742c640528c1(t) {
    const e = t.getRenderTarget();
    return null === e ? t.outputColorSpace : !0 === e.isXRRenderTarget ? e.texture.colorSpace : $4a792688e08e5cd7$export$5e6fd513f44698c.workingColorSpace;
}
const $4a792688e08e5cd7$export$d8ecdf8615bfea69 = {
    clone: $4a792688e08e5cd7$export$acda854380553452,
    merge: $4a792688e08e5cd7$export$8916ce6879271f43
};
class $4a792688e08e5cd7$export$83c7d75d550a8b0d extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
            clipCullDistance: !1,
            multiDraw: !1
        }, this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv1: [
                0,
                0
            ]
        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== t && this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = $4a792688e08e5cd7$export$acda854380553452(t.uniforms), this.uniformsGroups = function(t) {
            const e = [];
            for(let i = 0; i < t.length; i++)e.push(t[i].clone());
            return e;
        }(t.uniformsGroups), this.defines = Object.assign({}, t.defines), this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.fog = t.fog, this.lights = t.lights, this.clipping = t.clipping, this.extensions = Object.assign({}, t.extensions), this.glslVersion = t.glslVersion, this;
    }
    toJSON(t) {
        const e = super.toJSON(t);
        e.glslVersion = this.glslVersion, e.uniforms = {};
        for(const i in this.uniforms){
            const s = this.uniforms[i].value;
            s && s.isTexture ? e.uniforms[i] = {
                type: "t",
                value: s.toJSON(t).uuid
            } : s && s.isColor ? e.uniforms[i] = {
                type: "c",
                value: s.getHex()
            } : s && s.isVector2 ? e.uniforms[i] = {
                type: "v2",
                value: s.toArray()
            } : s && s.isVector3 ? e.uniforms[i] = {
                type: "v3",
                value: s.toArray()
            } : s && s.isVector4 ? e.uniforms[i] = {
                type: "v4",
                value: s.toArray()
            } : s && s.isMatrix3 ? e.uniforms[i] = {
                type: "m3",
                value: s.toArray()
            } : s && s.isMatrix4 ? e.uniforms[i] = {
                type: "m4",
                value: s.toArray()
            } : e.uniforms[i] = {
                value: s
            };
        }
        Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader, e.lights = this.lights, e.clipping = this.clipping;
        const i = {};
        for(const t in this.extensions)!0 === this.extensions[t] && (i[t] = !0);
        return Object.keys(i).length > 0 && (e.extensions = i), e;
    }
}
class $4a792688e08e5cd7$export$79f141de891a5fed extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(){
        super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, this.projectionMatrix = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, this.projectionMatrixInverse = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, this.coordinateSystem = $4a792688e08e5cd7$export$5a0e9190d10875d3, this._reversedDepth = !1;
    }
    get reversedDepth() {
        return this._reversedDepth;
    }
    copy(t, e) {
        return super.copy(t, e), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this.projectionMatrixInverse.copy(t.projectionMatrixInverse), this.coordinateSystem = t.coordinateSystem, this;
    }
    getWorldDirection(t) {
        return super.getWorldDirection(t).negate();
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(t, e) {
        super.updateWorldMatrix(t, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
const $4a792688e08e5cd7$var$ia = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$sa = new $4a792688e08e5cd7$export$c977b3e384af9ae1, $4a792688e08e5cd7$var$ra = new $4a792688e08e5cd7$export$c977b3e384af9ae1;
class $4a792688e08e5cd7$export$74e4ae24825f68d7 extends $4a792688e08e5cd7$export$79f141de891a5fed {
    constructor(t = 50, e = 1, i = .1, s = 2e3){
        super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = t, this.zoom = 1, this.near = i, this.far = s, this.focus = 10, this.aspect = e, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
    }
    copy(t, e) {
        return super.copy(t, e), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = null === t.view ? null : Object.assign({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
    }
    setFocalLength(t) {
        const e = .5 * this.getFilmHeight() / t;
        this.fov = 2 * $4a792688e08e5cd7$export$914076c8150813e5 * Math.atan(e), this.updateProjectionMatrix();
    }
    getFocalLength() {
        const t = Math.tan(.5 * $4a792688e08e5cd7$var$is * this.fov);
        return .5 * this.getFilmHeight() / t;
    }
    getEffectiveFOV() {
        return 2 * $4a792688e08e5cd7$export$914076c8150813e5 * Math.atan(Math.tan(.5 * $4a792688e08e5cd7$var$is * this.fov) / this.zoom);
    }
    getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    getViewBounds(t, e, i) {
        $4a792688e08e5cd7$var$ia.set(-1, -1, .5).applyMatrix4(this.projectionMatrixInverse), e.set($4a792688e08e5cd7$var$ia.x, $4a792688e08e5cd7$var$ia.y).multiplyScalar(-t / $4a792688e08e5cd7$var$ia.z), $4a792688e08e5cd7$var$ia.set(1, 1, .5).applyMatrix4(this.projectionMatrixInverse), i.set($4a792688e08e5cd7$var$ia.x, $4a792688e08e5cd7$var$ia.y).multiplyScalar(-t / $4a792688e08e5cd7$var$ia.z);
    }
    getViewSize(t, e) {
        return this.getViewBounds(t, $4a792688e08e5cd7$var$sa, $4a792688e08e5cd7$var$ra), e.subVectors($4a792688e08e5cd7$var$ra, $4a792688e08e5cd7$var$sa);
    }
    setViewOffset(t, e, i, s, r, n) {
        this.aspect = t / e, null === this.view && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = i, this.view.offsetY = s, this.view.width = r, this.view.height = n, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const t = this.near;
        let e = t * Math.tan(.5 * $4a792688e08e5cd7$var$is * this.fov) / this.zoom, i = 2 * e, s = this.aspect * i, r = -0.5 * s;
        const n = this.view;
        if (null !== this.view && this.view.enabled) {
            const t = n.fullWidth, a = n.fullHeight;
            r += n.offsetX * s / t, e -= n.offsetY * i / a, s *= n.width / t, i *= n.height / a;
        }
        const a = this.filmOffset;
        0 !== a && (r += t * a / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + s, e, e - i, t, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t) {
        const e = super.toJSON(t);
        return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, null !== this.view && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
    }
}
const $4a792688e08e5cd7$var$aa = -90;
class $4a792688e08e5cd7$export$d0cdd0bd804995de extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(t, e, i){
        super(), this.type = "CubeCamera", this.renderTarget = i, this.coordinateSystem = null, this.activeMipmapLevel = 0;
        const s = new $4a792688e08e5cd7$export$74e4ae24825f68d7($4a792688e08e5cd7$var$aa, 1, t, e);
        s.layers = this.layers, this.add(s);
        const r = new $4a792688e08e5cd7$export$74e4ae24825f68d7($4a792688e08e5cd7$var$aa, 1, t, e);
        r.layers = this.layers, this.add(r);
        const n = new $4a792688e08e5cd7$export$74e4ae24825f68d7($4a792688e08e5cd7$var$aa, 1, t, e);
        n.layers = this.layers, this.add(n);
        const a = new $4a792688e08e5cd7$export$74e4ae24825f68d7($4a792688e08e5cd7$var$aa, 1, t, e);
        a.layers = this.layers, this.add(a);
        const o = new $4a792688e08e5cd7$export$74e4ae24825f68d7($4a792688e08e5cd7$var$aa, 1, t, e);
        o.layers = this.layers, this.add(o);
        const h = new $4a792688e08e5cd7$export$74e4ae24825f68d7($4a792688e08e5cd7$var$aa, 1, t, e);
        h.layers = this.layers, this.add(h);
    }
    updateCoordinateSystem() {
        const t = this.coordinateSystem, e = this.children.concat(), [i, s, r, n, a, o] = e;
        for (const t of e)this.remove(t);
        if (t === $4a792688e08e5cd7$export$5a0e9190d10875d3) i.up.set(0, 1, 0), i.lookAt(1, 0, 0), s.up.set(0, 1, 0), s.lookAt(-1, 0, 0), r.up.set(0, 0, -1), r.lookAt(0, 1, 0), n.up.set(0, 0, 1), n.lookAt(0, -1, 0), a.up.set(0, 1, 0), a.lookAt(0, 0, 1), o.up.set(0, 1, 0), o.lookAt(0, 0, -1);
        else {
            if (t !== $4a792688e08e5cd7$export$cc83beedcb9be9ac) throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + t);
            i.up.set(0, -1, 0), i.lookAt(-1, 0, 0), s.up.set(0, -1, 0), s.lookAt(1, 0, 0), r.up.set(0, 0, 1), r.lookAt(0, 1, 0), n.up.set(0, 0, -1), n.lookAt(0, -1, 0), a.up.set(0, -1, 0), a.lookAt(0, 0, 1), o.up.set(0, -1, 0), o.lookAt(0, 0, -1);
        }
        for (const t of e)this.add(t), t.updateMatrixWorld();
    }
    update(t, e) {
        null === this.parent && this.updateMatrixWorld();
        const { renderTarget: i, activeMipmapLevel: s } = this;
        this.coordinateSystem !== t.coordinateSystem && (this.coordinateSystem = t.coordinateSystem, this.updateCoordinateSystem());
        const [r, n, a, o, h, l] = this.children, c = t.getRenderTarget(), u = t.getActiveCubeFace(), d = t.getActiveMipmapLevel(), p = t.xr.enabled;
        t.xr.enabled = !1;
        const m = i.texture.generateMipmaps;
        i.texture.generateMipmaps = !1, t.setRenderTarget(i, 0, s), t.render(e, r), t.setRenderTarget(i, 1, s), t.render(e, n), t.setRenderTarget(i, 2, s), t.render(e, a), t.setRenderTarget(i, 3, s), t.render(e, o), t.setRenderTarget(i, 4, s), t.render(e, h), i.texture.generateMipmaps = m, t.setRenderTarget(i, 5, s), t.render(e, l), t.setRenderTarget(c, u, d), t.xr.enabled = p, i.texture.needsPMREMUpdate = !0;
    }
}
class $4a792688e08e5cd7$export$ee2e5a18258a4049 extends $4a792688e08e5cd7$export$5431306cf43de24a {
    constructor(t = [], e = 301, i, s, r, n, a, o, h, l){
        super(t, e, i, s, r, n, a, o, h, l), this.isCubeTexture = !0, this.flipY = !1;
    }
    get images() {
        return this.image;
    }
    set images(t) {
        this.image = t;
    }
}
class $4a792688e08e5cd7$export$ac386671d651941e extends $4a792688e08e5cd7$export$3c052beb2e51e23f {
    constructor(t = 1, e = {}){
        super(t, t, e), this.isWebGLCubeRenderTarget = !0;
        const i = {
            width: t,
            height: t,
            depth: 1
        }, s = [
            i,
            i,
            i,
            i,
            i,
            i
        ];
        this.texture = new $4a792688e08e5cd7$export$ee2e5a18258a4049(s), this._setTextureOptions(e), this.texture.isRenderTargetTexture = !0;
    }
    fromEquirectangularTexture(t, e) {
        this.texture.type = e.type, this.texture.colorSpace = e.colorSpace, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
        const i = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
            fragmentShader: "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t"
        }, s = new $4a792688e08e5cd7$export$33e43285f7406bd5(5, 5, 5), r = new $4a792688e08e5cd7$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $4a792688e08e5cd7$export$acda854380553452(i.uniforms),
            vertexShader: i.vertexShader,
            fragmentShader: i.fragmentShader,
            side: 1,
            blending: 0
        });
        r.uniforms.tEquirect.value = e;
        const n = new $4a792688e08e5cd7$export$e176487c05830cc5(s, r), a = e.minFilter;
        e.minFilter === $4a792688e08e5cd7$export$5d8599b6a933fb1b && (e.minFilter = $4a792688e08e5cd7$export$8a72f490b25c56c8);
        return new $4a792688e08e5cd7$export$d0cdd0bd804995de(1, 10, this).update(t, n), e.minFilter = a, n.geometry.dispose(), n.material.dispose(), this;
    }
    clear(t, e = !0, i = !0, s = !0) {
        const r = t.getRenderTarget();
        for(let r = 0; r < 6; r++)t.setRenderTarget(this, r), t.clear(e, i, s);
        t.setRenderTarget(r);
    }
}
class $4a792688e08e5cd7$export$eb2fcfdbd7ba97d4 extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(){
        super(), this.isGroup = !0, this.type = "Group";
    }
}
const $4a792688e08e5cd7$var$ua = {
    type: "move"
};
class $4a792688e08e5cd7$export$cb626c57dcc48b9f {
    constructor(){
        this._targetRay = null, this._grip = null, this._hand = null;
    }
    getHandSpace() {
        return null === this._hand && (this._hand = new $4a792688e08e5cd7$export$eb2fcfdbd7ba97d4, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
            pinching: !1
        }), this._hand;
    }
    getTargetRaySpace() {
        return null === this._targetRay && (this._targetRay = new $4a792688e08e5cd7$export$eb2fcfdbd7ba97d4, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new $4a792688e08e5cd7$export$64b5c384219d3699, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new $4a792688e08e5cd7$export$64b5c384219d3699), this._targetRay;
    }
    getGripSpace() {
        return null === this._grip && (this._grip = new $4a792688e08e5cd7$export$eb2fcfdbd7ba97d4, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new $4a792688e08e5cd7$export$64b5c384219d3699, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new $4a792688e08e5cd7$export$64b5c384219d3699), this._grip;
    }
    dispatchEvent(t) {
        return null !== this._targetRay && this._targetRay.dispatchEvent(t), null !== this._grip && this._grip.dispatchEvent(t), null !== this._hand && this._hand.dispatchEvent(t), this;
    }
    connect(t) {
        if (t && t.hand) {
            const e = this._hand;
            if (e) for (const i of t.hand.values())this._getHandJoint(e, i);
        }
        return this.dispatchEvent({
            type: "connected",
            data: t
        }), this;
    }
    disconnect(t) {
        return this.dispatchEvent({
            type: "disconnected",
            data: t
        }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
    }
    update(t, e, i) {
        let s = null, r = null, n = null;
        const a = this._targetRay, o = this._grip, h = this._hand;
        if (t && "visible-blurred" !== e.session.visibilityState) {
            if (h && t.hand) {
                n = !0;
                for (const s of t.hand.values()){
                    const t = e.getJointPose(s, i), r = this._getHandJoint(h, s);
                    null !== t && (r.matrix.fromArray(t.transform.matrix), r.matrix.decompose(r.position, r.rotation, r.scale), r.matrixWorldNeedsUpdate = !0, r.jointRadius = t.radius), r.visible = null !== t;
                }
                const s = h.joints["index-finger-tip"], r = h.joints["thumb-tip"], a = s.position.distanceTo(r.position), o = .02, l = .005;
                h.inputState.pinching && a > o + l ? (h.inputState.pinching = !1, this.dispatchEvent({
                    type: "pinchend",
                    handedness: t.handedness,
                    target: this
                })) : !h.inputState.pinching && a <= o - l && (h.inputState.pinching = !0, this.dispatchEvent({
                    type: "pinchstart",
                    handedness: t.handedness,
                    target: this
                }));
            } else null !== o && t.gripSpace && (r = e.getPose(t.gripSpace, i), null !== r && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1));
            null !== a && (s = e.getPose(t.targetRaySpace, i), null === s && null !== r && (s = r), null !== s && (a.matrix.fromArray(s.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), a.matrixWorldNeedsUpdate = !0, s.linearVelocity ? (a.hasLinearVelocity = !0, a.linearVelocity.copy(s.linearVelocity)) : a.hasLinearVelocity = !1, s.angularVelocity ? (a.hasAngularVelocity = !0, a.angularVelocity.copy(s.angularVelocity)) : a.hasAngularVelocity = !1, this.dispatchEvent($4a792688e08e5cd7$var$ua)));
        }
        return null !== a && (a.visible = null !== s), null !== o && (o.visible = null !== r), null !== h && (h.visible = null !== n), this;
    }
    _getHandJoint(t, e) {
        if (void 0 === t.joints[e.jointName]) {
            const i = new $4a792688e08e5cd7$export$eb2fcfdbd7ba97d4;
            i.matrixAutoUpdate = !1, i.visible = !1, t.joints[e.jointName] = i, t.add(i);
        }
        return t.joints[e.jointName];
    }
}
class $4a792688e08e5cd7$export$6f1519f023b8d0f6 {
    constructor(t, e = 25e-5){
        this.isFogExp2 = !0, this.name = "", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(t), this.density = e;
    }
    clone() {
        return new $4a792688e08e5cd7$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $4a792688e08e5cd7$export$3c890837b09508d4 {
    constructor(t, e = 1, i = 1e3){
        this.isFog = !0, this.name = "", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(t), this.near = e, this.far = i;
    }
    clone() {
        return new $4a792688e08e5cd7$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $4a792688e08e5cd7$export$38af1803e3442a7f extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(){
        super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new $4a792688e08e5cd7$export$d93cc409a0768c5f, this.environmentIntensity = 1, this.environmentRotation = new $4a792688e08e5cd7$export$d93cc409a0768c5f, this.overrideMaterial = null, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(t, e) {
        return super.copy(t, e), null !== t.background && (this.background = t.background.clone()), null !== t.environment && (this.environment = t.environment.clone()), null !== t.fog && (this.fog = t.fog.clone()), this.backgroundBlurriness = t.backgroundBlurriness, this.backgroundIntensity = t.backgroundIntensity, this.backgroundRotation.copy(t.backgroundRotation), this.environmentIntensity = t.environmentIntensity, this.environmentRotation.copy(t.environmentRotation), null !== t.overrideMaterial && (this.overrideMaterial = t.overrideMaterial.clone()), this.matrixAutoUpdate = t.matrixAutoUpdate, this;
    }
    toJSON(t) {
        const e = super.toJSON(t);
        return null !== this.fog && (e.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (e.object.backgroundBlurriness = this.backgroundBlurriness), 1 !== this.backgroundIntensity && (e.object.backgroundIntensity = this.backgroundIntensity), e.object.backgroundRotation = this.backgroundRotation.toArray(), 1 !== this.environmentIntensity && (e.object.environmentIntensity = this.environmentIntensity), e.object.environmentRotation = this.environmentRotation.toArray(), e;
    }
}
class $4a792688e08e5cd7$export$3d5cd879f108f53f {
    constructor(t, e){
        this.isInterleavedBuffer = !0, this.array = t, this.stride = e, this.count = void 0 !== t ? t.length / e : 0, this.usage = $4a792688e08e5cd7$export$763e8360f4d7f77d, this.updateRanges = [], this.version = 0, this.uuid = $4a792688e08e5cd7$var$rs();
    }
    onUploadCallback() {}
    set needsUpdate(t) {
        !0 === t && this.version++;
    }
    setUsage(t) {
        return this.usage = t, this;
    }
    addUpdateRange(t, e) {
        this.updateRanges.push({
            start: t,
            count: e
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(t) {
        return this.array = new t.array.constructor(t.array), this.count = t.count, this.stride = t.stride, this.usage = t.usage, this;
    }
    copyAt(t, e, i) {
        t *= this.stride, i *= e.stride;
        for(let s = 0, r = this.stride; s < r; s++)this.array[t + s] = e.array[i + s];
        return this;
    }
    set(t, e = 0) {
        return this.array.set(t, e), this;
    }
    clone(t) {
        void 0 === t.arrayBuffers && (t.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = $4a792688e08e5cd7$var$rs()), void 0 === t.arrayBuffers[this.array.buffer._uuid] && (t.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
        const e = new this.array.constructor(t.arrayBuffers[this.array.buffer._uuid]), i = new this.constructor(e, this.stride);
        return i.setUsage(this.usage), i;
    }
    onUpload(t) {
        return this.onUploadCallback = t, this;
    }
    toJSON(t) {
        return void 0 === t.arrayBuffers && (t.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = $4a792688e08e5cd7$var$rs()), void 0 === t.arrayBuffers[this.array.buffer._uuid] && (t.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $4a792688e08e5cd7$var$fa = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$920b6d07334599c7 {
    constructor(t, e, i, s = !1){
        this.isInterleavedBufferAttribute = !0, this.name = "", this.data = t, this.itemSize = e, this.offset = i, this.normalized = s;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(t) {
        this.data.needsUpdate = t;
    }
    applyMatrix4(t) {
        for(let e = 0, i = this.data.count; e < i; e++)$4a792688e08e5cd7$var$fa.fromBufferAttribute(this, e), $4a792688e08e5cd7$var$fa.applyMatrix4(t), this.setXYZ(e, $4a792688e08e5cd7$var$fa.x, $4a792688e08e5cd7$var$fa.y, $4a792688e08e5cd7$var$fa.z);
        return this;
    }
    applyNormalMatrix(t) {
        for(let e = 0, i = this.count; e < i; e++)$4a792688e08e5cd7$var$fa.fromBufferAttribute(this, e), $4a792688e08e5cd7$var$fa.applyNormalMatrix(t), this.setXYZ(e, $4a792688e08e5cd7$var$fa.x, $4a792688e08e5cd7$var$fa.y, $4a792688e08e5cd7$var$fa.z);
        return this;
    }
    transformDirection(t) {
        for(let e = 0, i = this.count; e < i; e++)$4a792688e08e5cd7$var$fa.fromBufferAttribute(this, e), $4a792688e08e5cd7$var$fa.transformDirection(t), this.setXYZ(e, $4a792688e08e5cd7$var$fa.x, $4a792688e08e5cd7$var$fa.y, $4a792688e08e5cd7$var$fa.z);
        return this;
    }
    getComponent(t, e) {
        let i = this.array[t * this.data.stride + this.offset + e];
        return this.normalized && (i = $4a792688e08e5cd7$var$hs(i, this.array)), i;
    }
    setComponent(t, e, i) {
        return this.normalized && (i = $4a792688e08e5cd7$var$ls(i, this.array)), this.data.array[t * this.data.stride + this.offset + e] = i, this;
    }
    setX(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.data.array[t * this.data.stride + this.offset] = e, this;
    }
    setY(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.data.array[t * this.data.stride + this.offset + 1] = e, this;
    }
    setZ(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.data.array[t * this.data.stride + this.offset + 2] = e, this;
    }
    setW(t, e) {
        return this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array)), this.data.array[t * this.data.stride + this.offset + 3] = e, this;
    }
    getX(t) {
        let e = this.data.array[t * this.data.stride + this.offset];
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    getY(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 1];
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    getZ(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 2];
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    getW(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 3];
        return this.normalized && (e = $4a792688e08e5cd7$var$hs(e, this.array)), e;
    }
    setXY(t, e, i) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array), i = $4a792688e08e5cd7$var$ls(i, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = i, this;
    }
    setXYZ(t, e, i, s) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array), i = $4a792688e08e5cd7$var$ls(i, this.array), s = $4a792688e08e5cd7$var$ls(s, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = i, this.data.array[t + 2] = s, this;
    }
    setXYZW(t, e, i, s, r) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = $4a792688e08e5cd7$var$ls(e, this.array), i = $4a792688e08e5cd7$var$ls(i, this.array), s = $4a792688e08e5cd7$var$ls(s, this.array), r = $4a792688e08e5cd7$var$ls(r, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = i, this.data.array[t + 2] = s, this.data.array[t + 3] = r, this;
    }
    clone(t) {
        if (void 0 === t) {
            $4a792688e08e5cd7$export$bef1f36f5486a6a3("InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            const t = [];
            for(let e = 0; e < this.count; e++){
                const i = e * this.data.stride + this.offset;
                for(let e = 0; e < this.itemSize; e++)t.push(this.data.array[i + e]);
            }
            return new $4a792688e08e5cd7$export$8dea267bd6bde117(new this.array.constructor(t), this.itemSize, this.normalized);
        }
        return void 0 === t.interleavedBuffers && (t.interleavedBuffers = {}), void 0 === t.interleavedBuffers[this.data.uuid] && (t.interleavedBuffers[this.data.uuid] = this.data.clone(t)), new $4a792688e08e5cd7$export$920b6d07334599c7(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
    toJSON(t) {
        if (void 0 === t) {
            $4a792688e08e5cd7$export$bef1f36f5486a6a3("InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            const t = [];
            for(let e = 0; e < this.count; e++){
                const i = e * this.data.stride + this.offset;
                for(let e = 0; e < this.itemSize; e++)t.push(this.data.array[i + e]);
            }
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: t,
                normalized: this.normalized
            };
        }
        return void 0 === t.interleavedBuffers && (t.interleavedBuffers = {}), void 0 === t.interleavedBuffers[this.data.uuid] && (t.interleavedBuffers[this.data.uuid] = this.data.toJSON(t)), {
            isInterleavedBufferAttribute: !0,
            itemSize: this.itemSize,
            data: this.data.uuid,
            offset: this.offset,
            normalized: this.normalized
        };
    }
}
class $4a792688e08e5cd7$export$5ec7dd1c6994bf8e extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.map = t.map, this.alphaMap = t.alphaMap, this.rotation = t.rotation, this.sizeAttenuation = t.sizeAttenuation, this.fog = t.fog, this;
    }
}
let $4a792688e08e5cd7$var$va;
const $4a792688e08e5cd7$var$wa = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Ma = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Sa = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$_a = new $4a792688e08e5cd7$export$c977b3e384af9ae1, $4a792688e08e5cd7$var$Aa = new $4a792688e08e5cd7$export$c977b3e384af9ae1, $4a792688e08e5cd7$var$Ta = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$za = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Ca = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Ia = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Ba = new $4a792688e08e5cd7$export$c977b3e384af9ae1, $4a792688e08e5cd7$var$ka = new $4a792688e08e5cd7$export$c977b3e384af9ae1, $4a792688e08e5cd7$var$Pa = new $4a792688e08e5cd7$export$c977b3e384af9ae1;
class $4a792688e08e5cd7$export$3075603db8e6204c extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(t = new $4a792688e08e5cd7$export$5ec7dd1c6994bf8e){
        if (super(), this.isSprite = !0, this.type = "Sprite", void 0 === $4a792688e08e5cd7$var$va) {
            $4a792688e08e5cd7$var$va = new $4a792688e08e5cd7$export$b7be63a67df8959;
            const t = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                .5,
                -0.5,
                0,
                1,
                0,
                .5,
                .5,
                0,
                1,
                1,
                -0.5,
                .5,
                0,
                0,
                1
            ]), e = new $4a792688e08e5cd7$export$3d5cd879f108f53f(t, 5);
            $4a792688e08e5cd7$var$va.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]), $4a792688e08e5cd7$var$va.setAttribute("position", new $4a792688e08e5cd7$export$920b6d07334599c7(e, 3, 0, !1)), $4a792688e08e5cd7$var$va.setAttribute("uv", new $4a792688e08e5cd7$export$920b6d07334599c7(e, 2, 3, !1));
        }
        this.geometry = $4a792688e08e5cd7$var$va, this.material = t, this.center = new $4a792688e08e5cd7$export$c977b3e384af9ae1(.5, .5), this.count = 1;
    }
    raycast(t, e) {
        null === t.camera && $4a792688e08e5cd7$export$a3bc9b8ed74fc('Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), $4a792688e08e5cd7$var$Ma.setFromMatrixScale(this.matrixWorld), $4a792688e08e5cd7$var$Ta.copy(t.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(t.camera.matrixWorldInverse, this.matrixWorld), $4a792688e08e5cd7$var$Sa.setFromMatrixPosition(this.modelViewMatrix), t.camera.isPerspectiveCamera && !1 === this.material.sizeAttenuation && $4a792688e08e5cd7$var$Ma.multiplyScalar(-$4a792688e08e5cd7$var$Sa.z);
        const i = this.material.rotation;
        let s, r;
        0 !== i && (r = Math.cos(i), s = Math.sin(i));
        const n = this.center;
        $4a792688e08e5cd7$var$Ra($4a792688e08e5cd7$var$za.set(-0.5, -0.5, 0), $4a792688e08e5cd7$var$Sa, n, $4a792688e08e5cd7$var$Ma, s, r), $4a792688e08e5cd7$var$Ra($4a792688e08e5cd7$var$Ca.set(.5, -0.5, 0), $4a792688e08e5cd7$var$Sa, n, $4a792688e08e5cd7$var$Ma, s, r), $4a792688e08e5cd7$var$Ra($4a792688e08e5cd7$var$Ia.set(.5, .5, 0), $4a792688e08e5cd7$var$Sa, n, $4a792688e08e5cd7$var$Ma, s, r), $4a792688e08e5cd7$var$Ba.set(0, 0), $4a792688e08e5cd7$var$ka.set(1, 0), $4a792688e08e5cd7$var$Pa.set(1, 1);
        let a = t.ray.intersectTriangle($4a792688e08e5cd7$var$za, $4a792688e08e5cd7$var$Ca, $4a792688e08e5cd7$var$Ia, !1, $4a792688e08e5cd7$var$wa);
        if (null === a && ($4a792688e08e5cd7$var$Ra($4a792688e08e5cd7$var$Ca.set(-0.5, .5, 0), $4a792688e08e5cd7$var$Sa, n, $4a792688e08e5cd7$var$Ma, s, r), $4a792688e08e5cd7$var$ka.set(0, 1), a = t.ray.intersectTriangle($4a792688e08e5cd7$var$za, $4a792688e08e5cd7$var$Ia, $4a792688e08e5cd7$var$Ca, !1, $4a792688e08e5cd7$var$wa), null === a)) return;
        const o = t.ray.origin.distanceTo($4a792688e08e5cd7$var$wa);
        o < t.near || o > t.far || e.push({
            distance: o,
            point: $4a792688e08e5cd7$var$wa.clone(),
            uv: $4a792688e08e5cd7$export$5a465592bfe74b48.getInterpolation($4a792688e08e5cd7$var$wa, $4a792688e08e5cd7$var$za, $4a792688e08e5cd7$var$Ca, $4a792688e08e5cd7$var$Ia, $4a792688e08e5cd7$var$Ba, $4a792688e08e5cd7$var$ka, $4a792688e08e5cd7$var$Pa, new $4a792688e08e5cd7$export$c977b3e384af9ae1),
            face: null,
            object: this
        });
    }
    copy(t, e) {
        return super.copy(t, e), void 0 !== t.center && this.center.copy(t.center), this.material = t.material, this;
    }
}
function $4a792688e08e5cd7$var$Ra(t, e, i, s, r, n) {
    $4a792688e08e5cd7$var$_a.subVectors(t, i).addScalar(.5).multiply(s), void 0 !== r ? ($4a792688e08e5cd7$var$Aa.x = n * $4a792688e08e5cd7$var$_a.x - r * $4a792688e08e5cd7$var$_a.y, $4a792688e08e5cd7$var$Aa.y = r * $4a792688e08e5cd7$var$_a.x + n * $4a792688e08e5cd7$var$_a.y) : $4a792688e08e5cd7$var$Aa.copy($4a792688e08e5cd7$var$_a), t.copy(e), t.x += $4a792688e08e5cd7$var$Aa.x, t.y += $4a792688e08e5cd7$var$Aa.y, t.applyMatrix4($4a792688e08e5cd7$var$Ta);
}
const $4a792688e08e5cd7$var$Na = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Va = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$112e7237be0c5f30 extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(){
        super(), this.isLOD = !0, this._currentLevel = 0, this.type = "LOD", Object.defineProperties(this, {
            levels: {
                enumerable: !0,
                value: []
            }
        }), this.autoUpdate = !0;
    }
    copy(t) {
        super.copy(t, !1);
        const e = t.levels;
        for(let t = 0, i = e.length; t < i; t++){
            const i = e[t];
            this.addLevel(i.object.clone(), i.distance, i.hysteresis);
        }
        return this.autoUpdate = t.autoUpdate, this;
    }
    addLevel(t, e = 0, i = 0) {
        e = Math.abs(e);
        const s = this.levels;
        let r;
        for(r = 0; r < s.length && !(e < s[r].distance); r++);
        return s.splice(r, 0, {
            distance: e,
            hysteresis: i,
            object: t
        }), this.add(t), this;
    }
    removeLevel(t) {
        const e = this.levels;
        for(let i = 0; i < e.length; i++)if (e[i].distance === t) {
            const t = e.splice(i, 1);
            return this.remove(t[0].object), !0;
        }
        return !1;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(t) {
        const e = this.levels;
        if (e.length > 0) {
            let i, s;
            for(i = 1, s = e.length; i < s; i++){
                let s = e[i].distance;
                if (e[i].object.visible && (s -= s * e[i].hysteresis), t < s) break;
            }
            return e[i - 1].object;
        }
        return null;
    }
    raycast(t, e) {
        if (this.levels.length > 0) {
            $4a792688e08e5cd7$var$Na.setFromMatrixPosition(this.matrixWorld);
            const i = t.ray.origin.distanceTo($4a792688e08e5cd7$var$Na);
            this.getObjectForDistance(i).raycast(t, e);
        }
    }
    update(t) {
        const e = this.levels;
        if (e.length > 1) {
            $4a792688e08e5cd7$var$Na.setFromMatrixPosition(t.matrixWorld), $4a792688e08e5cd7$var$Va.setFromMatrixPosition(this.matrixWorld);
            const i = $4a792688e08e5cd7$var$Na.distanceTo($4a792688e08e5cd7$var$Va) / t.zoom;
            let s, r;
            for(e[0].object.visible = !0, s = 1, r = e.length; s < r; s++){
                let t = e[s].distance;
                if (e[s].object.visible && (t -= t * e[s].hysteresis), !(i >= t)) break;
                e[s - 1].object.visible = !1, e[s].object.visible = !0;
            }
            for(this._currentLevel = s - 1; s < r; s++)e[s].object.visible = !1;
        }
    }
    toJSON(t) {
        const e = super.toJSON(t);
        !1 === this.autoUpdate && (e.object.autoUpdate = !1), e.object.levels = [];
        const i = this.levels;
        for(let t = 0, s = i.length; t < s; t++){
            const s = i[t];
            e.object.levels.push({
                object: s.object.uuid,
                distance: s.distance,
                hysteresis: s.hysteresis
            });
        }
        return e;
    }
}
const $4a792688e08e5cd7$var$La = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Ea = new $4a792688e08e5cd7$export$fa7daccca11cdbe3, $4a792688e08e5cd7$var$ja = new $4a792688e08e5cd7$export$fa7daccca11cdbe3, $4a792688e08e5cd7$var$Da = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Wa = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$Ua = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$qa = new $4a792688e08e5cd7$export$805e8b72413ccaba, $4a792688e08e5cd7$var$Ja = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$Xa = new $4a792688e08e5cd7$export$a186db52eed6d40e;
class $4a792688e08e5cd7$export$b303577035157ecf extends $4a792688e08e5cd7$export$e176487c05830cc5 {
    constructor(t, e){
        super(t, e), this.isSkinnedMesh = !0, this.type = "SkinnedMesh", this.bindMode = $4a792688e08e5cd7$export$2595a3798997538, this.bindMatrix = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, this.bindMatrixInverse = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, this.boundingBox = null, this.boundingSphere = null;
    }
    computeBoundingBox() {
        const t = this.geometry;
        null === this.boundingBox && (this.boundingBox = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3), this.boundingBox.makeEmpty();
        const e = t.getAttribute("position");
        for(let t = 0; t < e.count; t++)this.getVertexPosition(t, $4a792688e08e5cd7$var$Ua), this.boundingBox.expandByPoint($4a792688e08e5cd7$var$Ua);
    }
    computeBoundingSphere() {
        const t = this.geometry;
        null === this.boundingSphere && (this.boundingSphere = new $4a792688e08e5cd7$export$805e8b72413ccaba), this.boundingSphere.makeEmpty();
        const e = t.getAttribute("position");
        for(let t = 0; t < e.count; t++)this.getVertexPosition(t, $4a792688e08e5cd7$var$Ua), this.boundingSphere.expandByPoint($4a792688e08e5cd7$var$Ua);
    }
    copy(t, e) {
        return super.copy(t, e), this.bindMode = t.bindMode, this.bindMatrix.copy(t.bindMatrix), this.bindMatrixInverse.copy(t.bindMatrixInverse), this.skeleton = t.skeleton, null !== t.boundingBox && (this.boundingBox = t.boundingBox.clone()), null !== t.boundingSphere && (this.boundingSphere = t.boundingSphere.clone()), this;
    }
    raycast(t, e) {
        const i = this.material, s = this.matrixWorld;
        void 0 !== i && (null === this.boundingSphere && this.computeBoundingSphere(), $4a792688e08e5cd7$var$qa.copy(this.boundingSphere), $4a792688e08e5cd7$var$qa.applyMatrix4(s), !1 !== t.ray.intersectsSphere($4a792688e08e5cd7$var$qa) && ($4a792688e08e5cd7$var$Ja.copy(s).invert(), $4a792688e08e5cd7$var$Xa.copy(t.ray).applyMatrix4($4a792688e08e5cd7$var$Ja), null !== this.boundingBox && !1 === $4a792688e08e5cd7$var$Xa.intersectsBox(this.boundingBox) || this._computeIntersections(t, e, $4a792688e08e5cd7$var$Xa)));
    }
    getVertexPosition(t, e) {
        return super.getVertexPosition(t, e), this.applyBoneTransform(t, e), e;
    }
    bind(t, e) {
        this.skeleton = t, void 0 === e && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), e = this.matrixWorld), this.bindMatrix.copy(e), this.bindMatrixInverse.copy(e).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const t = new $4a792688e08e5cd7$export$fa7daccca11cdbe3, e = this.geometry.attributes.skinWeight;
        for(let i = 0, s = e.count; i < s; i++){
            t.fromBufferAttribute(e, i);
            const s = 1 / t.manhattanLength();
            s !== 1 / 0 ? t.multiplyScalar(s) : t.set(1, 0, 0, 0), e.setXYZW(i, t.x, t.y, t.z, t.w);
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.bindMode === $4a792688e08e5cd7$export$2595a3798997538 ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === $4a792688e08e5cd7$export$d7e7dc2e114517a0 ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : $4a792688e08e5cd7$export$c106dd0671a0fc2d("SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    applyBoneTransform(t, e) {
        const i = this.skeleton, s = this.geometry;
        $4a792688e08e5cd7$var$Ea.fromBufferAttribute(s.attributes.skinIndex, t), $4a792688e08e5cd7$var$ja.fromBufferAttribute(s.attributes.skinWeight, t), $4a792688e08e5cd7$var$La.copy(e).applyMatrix4(this.bindMatrix), e.set(0, 0, 0);
        for(let t = 0; t < 4; t++){
            const s = $4a792688e08e5cd7$var$ja.getComponent(t);
            if (0 !== s) {
                const r = $4a792688e08e5cd7$var$Ea.getComponent(t);
                $4a792688e08e5cd7$var$Wa.multiplyMatrices(i.bones[r].matrixWorld, i.boneInverses[r]), e.addScaledVector($4a792688e08e5cd7$var$Da.copy($4a792688e08e5cd7$var$La).applyMatrix4($4a792688e08e5cd7$var$Wa), s);
            }
        }
        return e.applyMatrix4(this.bindMatrixInverse);
    }
}
class $4a792688e08e5cd7$export$b127726e56765aa4 extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(){
        super(), this.isBone = !0, this.type = "Bone";
    }
}
class $4a792688e08e5cd7$export$b691f601014eabe1 extends $4a792688e08e5cd7$export$5431306cf43de24a {
    constructor(t = null, e = 1, i = 1, s, r, n, a, o, h = 1003, l = 1003, c, u){
        super(null, n, a, o, h, l, s, r, c, u), this.isDataTexture = !0, this.image = {
            data: t,
            width: e,
            height: i
        }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
const $4a792688e08e5cd7$var$Ga = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$$a = new $4a792688e08e5cd7$export$2ae72fc923e5eb5;
class $4a792688e08e5cd7$export$8f31e4c4a37b8e9c {
    constructor(t = [], e = []){
        this.uuid = $4a792688e08e5cd7$var$rs(), this.bones = t.slice(0), this.boneInverses = e, this.boneMatrices = null, this.boneTexture = null, this.init();
    }
    init() {
        const t = this.bones, e = this.boneInverses;
        if (this.boneMatrices = new Float32Array(16 * t.length), 0 === e.length) this.calculateInverses();
        else if (t.length !== e.length) {
            $4a792688e08e5cd7$export$c106dd0671a0fc2d("Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
            for(let t = 0, e = this.bones.length; t < e; t++)this.boneInverses.push(new $4a792688e08e5cd7$export$2ae72fc923e5eb5);
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let t = 0, e = this.bones.length; t < e; t++){
            const e = new $4a792688e08e5cd7$export$2ae72fc923e5eb5;
            this.bones[t] && e.copy(this.bones[t].matrixWorld).invert(), this.boneInverses.push(e);
        }
    }
    pose() {
        for(let t = 0, e = this.bones.length; t < e; t++){
            const e = this.bones[t];
            e && e.matrixWorld.copy(this.boneInverses[t]).invert();
        }
        for(let t = 0, e = this.bones.length; t < e; t++){
            const e = this.bones[t];
            e && (e.parent && e.parent.isBone ? (e.matrix.copy(e.parent.matrixWorld).invert(), e.matrix.multiply(e.matrixWorld)) : e.matrix.copy(e.matrixWorld), e.matrix.decompose(e.position, e.quaternion, e.scale));
        }
    }
    update() {
        const t = this.bones, e = this.boneInverses, i = this.boneMatrices, s = this.boneTexture;
        for(let s = 0, r = t.length; s < r; s++){
            const r = t[s] ? t[s].matrixWorld : $4a792688e08e5cd7$var$$a;
            $4a792688e08e5cd7$var$Ga.multiplyMatrices(r, e[s]), $4a792688e08e5cd7$var$Ga.toArray(i, 16 * s);
        }
        null !== s && (s.needsUpdate = !0);
    }
    clone() {
        return new $4a792688e08e5cd7$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        let t = Math.sqrt(4 * this.bones.length);
        t = 4 * Math.ceil(t / 4), t = Math.max(t, 4);
        const e = new Float32Array(t * t * 4);
        e.set(this.boneMatrices);
        const i = new $4a792688e08e5cd7$export$b691f601014eabe1(e, t, t, $4a792688e08e5cd7$export$3f8bb04b555a363c, $4a792688e08e5cd7$export$f6d331659b644596);
        return i.needsUpdate = !0, this.boneMatrices = e, this.boneTexture = i, this;
    }
    getBoneByName(t) {
        for(let e = 0, i = this.bones.length; e < i; e++){
            const i = this.bones[e];
            if (i.name === t) return i;
        }
    }
    dispose() {
        null !== this.boneTexture && (this.boneTexture.dispose(), this.boneTexture = null);
    }
    fromJSON(t, e) {
        this.uuid = t.uuid;
        for(let i = 0, s = t.bones.length; i < s; i++){
            const s = t.bones[i];
            let r = e[s];
            void 0 === r && ($4a792688e08e5cd7$export$c106dd0671a0fc2d("Skeleton: No bone found with UUID:", s), r = new $4a792688e08e5cd7$export$b127726e56765aa4), this.bones.push(r), this.boneInverses.push((new $4a792688e08e5cd7$export$2ae72fc923e5eb5).fromArray(t.boneInverses[i]));
        }
        return this.init(), this;
    }
    toJSON() {
        const t = {
            metadata: {
                version: 4.7,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        t.uuid = this.uuid;
        const e = this.bones, i = this.boneInverses;
        for(let s = 0, r = e.length; s < r; s++){
            const r = e[s];
            t.bones.push(r.uuid);
            const n = i[s];
            t.boneInverses.push(n.toArray());
        }
        return t;
    }
}
class $4a792688e08e5cd7$export$32ea87a8b54d744a extends $4a792688e08e5cd7$export$8dea267bd6bde117 {
    constructor(t, e, i, s = 1){
        super(t, e, i), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = s;
    }
    copy(t) {
        return super.copy(t), this.meshPerAttribute = t.meshPerAttribute, this;
    }
    toJSON() {
        const t = super.toJSON();
        return t.meshPerAttribute = this.meshPerAttribute, t.isInstancedBufferAttribute = !0, t;
    }
}
const $4a792688e08e5cd7$var$to = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$eo = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$io = [], $4a792688e08e5cd7$var$so = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3, $4a792688e08e5cd7$var$ro = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$no = new $4a792688e08e5cd7$export$e176487c05830cc5, $4a792688e08e5cd7$var$ao = new $4a792688e08e5cd7$export$805e8b72413ccaba;
class $4a792688e08e5cd7$export$f3c979c331175ad7 extends $4a792688e08e5cd7$export$e176487c05830cc5 {
    constructor(t, e, i){
        super(t, e), this.isInstancedMesh = !0, this.instanceMatrix = new $4a792688e08e5cd7$export$32ea87a8b54d744a(new Float32Array(16 * i), 16), this.instanceColor = null, this.morphTexture = null, this.count = i, this.boundingBox = null, this.boundingSphere = null;
        for(let t = 0; t < i; t++)this.setMatrixAt(t, $4a792688e08e5cd7$var$ro);
    }
    computeBoundingBox() {
        const t = this.geometry, e = this.count;
        null === this.boundingBox && (this.boundingBox = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3), null === t.boundingBox && t.computeBoundingBox(), this.boundingBox.makeEmpty();
        for(let i = 0; i < e; i++)this.getMatrixAt(i, $4a792688e08e5cd7$var$to), $4a792688e08e5cd7$var$so.copy(t.boundingBox).applyMatrix4($4a792688e08e5cd7$var$to), this.boundingBox.union($4a792688e08e5cd7$var$so);
    }
    computeBoundingSphere() {
        const t = this.geometry, e = this.count;
        null === this.boundingSphere && (this.boundingSphere = new $4a792688e08e5cd7$export$805e8b72413ccaba), null === t.boundingSphere && t.computeBoundingSphere(), this.boundingSphere.makeEmpty();
        for(let i = 0; i < e; i++)this.getMatrixAt(i, $4a792688e08e5cd7$var$to), $4a792688e08e5cd7$var$ao.copy(t.boundingSphere).applyMatrix4($4a792688e08e5cd7$var$to), this.boundingSphere.union($4a792688e08e5cd7$var$ao);
    }
    copy(t, e) {
        return super.copy(t, e), this.instanceMatrix.copy(t.instanceMatrix), null !== t.morphTexture && (this.morphTexture = t.morphTexture.clone()), null !== t.instanceColor && (this.instanceColor = t.instanceColor.clone()), this.count = t.count, null !== t.boundingBox && (this.boundingBox = t.boundingBox.clone()), null !== t.boundingSphere && (this.boundingSphere = t.boundingSphere.clone()), this;
    }
    getColorAt(t, e) {
        e.fromArray(this.instanceColor.array, 3 * t);
    }
    getMatrixAt(t, e) {
        e.fromArray(this.instanceMatrix.array, 16 * t);
    }
    getMorphAt(t, e) {
        const i = e.morphTargetInfluences, s = this.morphTexture.source.data.data, r = t * (i.length + 1) + 1;
        for(let t = 0; t < i.length; t++)i[t] = s[r + t];
    }
    raycast(t, e) {
        const i = this.matrixWorld, s = this.count;
        if ($4a792688e08e5cd7$var$no.geometry = this.geometry, $4a792688e08e5cd7$var$no.material = this.material, void 0 !== $4a792688e08e5cd7$var$no.material && (null === this.boundingSphere && this.computeBoundingSphere(), $4a792688e08e5cd7$var$ao.copy(this.boundingSphere), $4a792688e08e5cd7$var$ao.applyMatrix4(i), !1 !== t.ray.intersectsSphere($4a792688e08e5cd7$var$ao))) for(let r = 0; r < s; r++){
            this.getMatrixAt(r, $4a792688e08e5cd7$var$to), $4a792688e08e5cd7$var$eo.multiplyMatrices(i, $4a792688e08e5cd7$var$to), $4a792688e08e5cd7$var$no.matrixWorld = $4a792688e08e5cd7$var$eo, $4a792688e08e5cd7$var$no.raycast(t, $4a792688e08e5cd7$var$io);
            for(let t = 0, i = $4a792688e08e5cd7$var$io.length; t < i; t++){
                const i = $4a792688e08e5cd7$var$io[t];
                i.instanceId = r, i.object = this, e.push(i);
            }
            $4a792688e08e5cd7$var$io.length = 0;
        }
    }
    setColorAt(t, e) {
        null === this.instanceColor && (this.instanceColor = new $4a792688e08e5cd7$export$32ea87a8b54d744a(new Float32Array(3 * this.instanceMatrix.count).fill(1), 3)), e.toArray(this.instanceColor.array, 3 * t);
    }
    setMatrixAt(t, e) {
        e.toArray(this.instanceMatrix.array, 16 * t);
    }
    setMorphAt(t, e) {
        const i = e.morphTargetInfluences, s = i.length + 1;
        null === this.morphTexture && (this.morphTexture = new $4a792688e08e5cd7$export$b691f601014eabe1(new Float32Array(s * this.count), s, this.count, $4a792688e08e5cd7$export$4e041a7967d15c4b, $4a792688e08e5cd7$export$f6d331659b644596));
        const r = this.morphTexture.source.data.data;
        let n = 0;
        for(let t = 0; t < i.length; t++)n += i[t];
        const a = this.geometry.morphTargetsRelative ? 1 : 1 - n, o = s * t;
        r[o] = a, r.set(i, o + 1);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        }), null !== this.morphTexture && (this.morphTexture.dispose(), this.morphTexture = null);
    }
}
const $4a792688e08e5cd7$var$ho = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$lo = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$co = new $4a792688e08e5cd7$export$8ff26dafa08918;
class $4a792688e08e5cd7$export$7ff5ac152ef991b0 {
    constructor(t = new $4a792688e08e5cd7$export$64b5c384219d3699(1, 0, 0), e = 0){
        this.isPlane = !0, this.normal = t, this.constant = e;
    }
    set(t, e) {
        return this.normal.copy(t), this.constant = e, this;
    }
    setComponents(t, e, i, s) {
        return this.normal.set(t, e, i), this.constant = s, this;
    }
    setFromNormalAndCoplanarPoint(t, e) {
        return this.normal.copy(t), this.constant = -e.dot(this.normal), this;
    }
    setFromCoplanarPoints(t, e, i) {
        const s = $4a792688e08e5cd7$var$ho.subVectors(i, e).cross($4a792688e08e5cd7$var$lo.subVectors(t, e)).normalize();
        return this.setFromNormalAndCoplanarPoint(s, t), this;
    }
    copy(t) {
        return this.normal.copy(t.normal), this.constant = t.constant, this;
    }
    normalize() {
        const t = 1 / this.normal.length();
        return this.normal.multiplyScalar(t), this.constant *= t, this;
    }
    negate() {
        return this.constant *= -1, this.normal.negate(), this;
    }
    distanceToPoint(t) {
        return this.normal.dot(t) + this.constant;
    }
    distanceToSphere(t) {
        return this.distanceToPoint(t.center) - t.radius;
    }
    projectPoint(t, e) {
        return e.copy(t).addScaledVector(this.normal, -this.distanceToPoint(t));
    }
    intersectLine(t, e) {
        const i = t.delta($4a792688e08e5cd7$var$ho), s = this.normal.dot(i);
        if (0 === s) return 0 === this.distanceToPoint(t.start) ? e.copy(t.start) : null;
        const r = -(t.start.dot(this.normal) + this.constant) / s;
        return r < 0 || r > 1 ? null : e.copy(t.start).addScaledVector(i, r);
    }
    intersectsLine(t) {
        const e = this.distanceToPoint(t.start), i = this.distanceToPoint(t.end);
        return e < 0 && i > 0 || i < 0 && e > 0;
    }
    intersectsBox(t) {
        return t.intersectsPlane(this);
    }
    intersectsSphere(t) {
        return t.intersectsPlane(this);
    }
    coplanarPoint(t) {
        return t.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(t, e) {
        const i = e || $4a792688e08e5cd7$var$co.getNormalMatrix(t), s = this.coplanarPoint($4a792688e08e5cd7$var$ho).applyMatrix4(t), r = this.normal.applyMatrix3(i).normalize();
        return this.constant = -s.dot(r), this;
    }
    translate(t) {
        return this.constant -= t.dot(this.normal), this;
    }
    equals(t) {
        return t.normal.equals(this.normal) && t.constant === this.constant;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
const $4a792688e08e5cd7$var$po = new $4a792688e08e5cd7$export$805e8b72413ccaba, $4a792688e08e5cd7$var$mo = new $4a792688e08e5cd7$export$c977b3e384af9ae1(.5, .5), $4a792688e08e5cd7$var$yo = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$35efe6f4c85463d2 {
    constructor(t = new $4a792688e08e5cd7$export$7ff5ac152ef991b0, e = new $4a792688e08e5cd7$export$7ff5ac152ef991b0, i = new $4a792688e08e5cd7$export$7ff5ac152ef991b0, s = new $4a792688e08e5cd7$export$7ff5ac152ef991b0, r = new $4a792688e08e5cd7$export$7ff5ac152ef991b0, n = new $4a792688e08e5cd7$export$7ff5ac152ef991b0){
        this.planes = [
            t,
            e,
            i,
            s,
            r,
            n
        ];
    }
    set(t, e, i, s, r, n) {
        const a = this.planes;
        return a[0].copy(t), a[1].copy(e), a[2].copy(i), a[3].copy(s), a[4].copy(r), a[5].copy(n), this;
    }
    copy(t) {
        const e = this.planes;
        for(let i = 0; i < 6; i++)e[i].copy(t.planes[i]);
        return this;
    }
    setFromProjectionMatrix(t, e = 2e3, i = !1) {
        const s = this.planes, r = t.elements, n = r[0], a = r[1], o = r[2], h = r[3], l = r[4], c = r[5], u = r[6], d = r[7], p = r[8], m = r[9], y = r[10], g = r[11], f = r[12], x = r[13], b = r[14], v = r[15];
        if (s[0].setComponents(h - n, d - l, g - p, v - f).normalize(), s[1].setComponents(h + n, d + l, g + p, v + f).normalize(), s[2].setComponents(h + a, d + c, g + m, v + x).normalize(), s[3].setComponents(h - a, d - c, g - m, v - x).normalize(), i) s[4].setComponents(o, u, y, b).normalize(), s[5].setComponents(h - o, d - u, g - y, v - b).normalize();
        else if (s[4].setComponents(h - o, d - u, g - y, v - b).normalize(), e === $4a792688e08e5cd7$export$5a0e9190d10875d3) s[5].setComponents(h + o, d + u, g + y, v + b).normalize();
        else {
            if (e !== $4a792688e08e5cd7$export$cc83beedcb9be9ac) throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + e);
            s[5].setComponents(o, u, y, b).normalize();
        }
        return this;
    }
    intersectsObject(t) {
        if (void 0 !== t.boundingSphere) null === t.boundingSphere && t.computeBoundingSphere(), $4a792688e08e5cd7$var$po.copy(t.boundingSphere).applyMatrix4(t.matrixWorld);
        else {
            const e = t.geometry;
            null === e.boundingSphere && e.computeBoundingSphere(), $4a792688e08e5cd7$var$po.copy(e.boundingSphere).applyMatrix4(t.matrixWorld);
        }
        return this.intersectsSphere($4a792688e08e5cd7$var$po);
    }
    intersectsSprite(t) {
        $4a792688e08e5cd7$var$po.center.set(0, 0, 0);
        const e = $4a792688e08e5cd7$var$mo.distanceTo(t.center);
        return $4a792688e08e5cd7$var$po.radius = .7071067811865476 + e, $4a792688e08e5cd7$var$po.applyMatrix4(t.matrixWorld), this.intersectsSphere($4a792688e08e5cd7$var$po);
    }
    intersectsSphere(t) {
        const e = this.planes, i = t.center, s = -t.radius;
        for(let t = 0; t < 6; t++){
            if (e[t].distanceToPoint(i) < s) return !1;
        }
        return !0;
    }
    intersectsBox(t) {
        const e = this.planes;
        for(let i = 0; i < 6; i++){
            const s = e[i];
            if ($4a792688e08e5cd7$var$yo.x = s.normal.x > 0 ? t.max.x : t.min.x, $4a792688e08e5cd7$var$yo.y = s.normal.y > 0 ? t.max.y : t.min.y, $4a792688e08e5cd7$var$yo.z = s.normal.z > 0 ? t.max.z : t.min.z, s.distanceToPoint($4a792688e08e5cd7$var$yo) < 0) return !1;
        }
        return !0;
    }
    containsPoint(t) {
        const e = this.planes;
        for(let i = 0; i < 6; i++)if (e[i].distanceToPoint(t) < 0) return !1;
        return !0;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
const $4a792688e08e5cd7$var$fo = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$xo = new $4a792688e08e5cd7$export$35efe6f4c85463d2;
class $4a792688e08e5cd7$export$2d7d04327620499c {
    constructor(){
        this.coordinateSystem = $4a792688e08e5cd7$export$5a0e9190d10875d3;
    }
    intersectsObject(t, e) {
        if (!e.isArrayCamera || 0 === e.cameras.length) return !1;
        for(let i = 0; i < e.cameras.length; i++){
            const s = e.cameras[i];
            if ($4a792688e08e5cd7$var$fo.multiplyMatrices(s.projectionMatrix, s.matrixWorldInverse), $4a792688e08e5cd7$var$xo.setFromProjectionMatrix($4a792688e08e5cd7$var$fo, s.coordinateSystem, s.reversedDepth), $4a792688e08e5cd7$var$xo.intersectsObject(t)) return !0;
        }
        return !1;
    }
    intersectsSprite(t, e) {
        if (!e || !e.cameras || 0 === e.cameras.length) return !1;
        for(let i = 0; i < e.cameras.length; i++){
            const s = e.cameras[i];
            if ($4a792688e08e5cd7$var$fo.multiplyMatrices(s.projectionMatrix, s.matrixWorldInverse), $4a792688e08e5cd7$var$xo.setFromProjectionMatrix($4a792688e08e5cd7$var$fo, s.coordinateSystem, s.reversedDepth), $4a792688e08e5cd7$var$xo.intersectsSprite(t)) return !0;
        }
        return !1;
    }
    intersectsSphere(t, e) {
        if (!e || !e.cameras || 0 === e.cameras.length) return !1;
        for(let i = 0; i < e.cameras.length; i++){
            const s = e.cameras[i];
            if ($4a792688e08e5cd7$var$fo.multiplyMatrices(s.projectionMatrix, s.matrixWorldInverse), $4a792688e08e5cd7$var$xo.setFromProjectionMatrix($4a792688e08e5cd7$var$fo, s.coordinateSystem, s.reversedDepth), $4a792688e08e5cd7$var$xo.intersectsSphere(t)) return !0;
        }
        return !1;
    }
    intersectsBox(t, e) {
        if (!e || !e.cameras || 0 === e.cameras.length) return !1;
        for(let i = 0; i < e.cameras.length; i++){
            const s = e.cameras[i];
            if ($4a792688e08e5cd7$var$fo.multiplyMatrices(s.projectionMatrix, s.matrixWorldInverse), $4a792688e08e5cd7$var$xo.setFromProjectionMatrix($4a792688e08e5cd7$var$fo, s.coordinateSystem, s.reversedDepth), $4a792688e08e5cd7$var$xo.intersectsBox(t)) return !0;
        }
        return !1;
    }
    containsPoint(t, e) {
        if (!e || !e.cameras || 0 === e.cameras.length) return !1;
        for(let i = 0; i < e.cameras.length; i++){
            const s = e.cameras[i];
            if ($4a792688e08e5cd7$var$fo.multiplyMatrices(s.projectionMatrix, s.matrixWorldInverse), $4a792688e08e5cd7$var$xo.setFromProjectionMatrix($4a792688e08e5cd7$var$fo, s.coordinateSystem, s.reversedDepth), $4a792688e08e5cd7$var$xo.containsPoint(t)) return !0;
        }
        return !1;
    }
    clone() {
        return new $4a792688e08e5cd7$export$2d7d04327620499c;
    }
}
function $4a792688e08e5cd7$var$vo(t, e) {
    return t - e;
}
function $4a792688e08e5cd7$var$wo(t, e) {
    return t.z - e.z;
}
function $4a792688e08e5cd7$var$Mo(t, e) {
    return e.z - t.z;
}
class $4a792688e08e5cd7$var$So {
    constructor(){
        this.index = 0, this.pool = [], this.list = [];
    }
    push(t, e, i, s) {
        const r = this.pool, n = this.list;
        this.index >= r.length && r.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const a = r[this.index];
        n.push(a), this.index++, a.start = t, a.count = e, a.z = i, a.index = s;
    }
    reset() {
        this.list.length = 0, this.index = 0;
    }
}
const $4a792688e08e5cd7$var$_o = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$Ao = new $4a792688e08e5cd7$export$892596cec99bc70e(1, 1, 1), $4a792688e08e5cd7$var$To = new $4a792688e08e5cd7$export$35efe6f4c85463d2, $4a792688e08e5cd7$var$zo = new $4a792688e08e5cd7$export$2d7d04327620499c, $4a792688e08e5cd7$var$Co = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3, $4a792688e08e5cd7$var$Io = new $4a792688e08e5cd7$export$805e8b72413ccaba, $4a792688e08e5cd7$var$Bo = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$ko = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Po = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Oo = new $4a792688e08e5cd7$var$So, $4a792688e08e5cd7$var$Ro = new $4a792688e08e5cd7$export$e176487c05830cc5, $4a792688e08e5cd7$var$No = [];
function $4a792688e08e5cd7$var$Vo(t, e, i = 0) {
    const s = e.itemSize;
    if (t.isInterleavedBufferAttribute || t.array.constructor !== e.array.constructor) {
        const r = t.count;
        for(let n = 0; n < r; n++)for(let r = 0; r < s; r++)e.setComponent(n + i, r, t.getComponent(n, r));
    } else e.array.set(t.array, i * s);
    e.needsUpdate = !0;
}
function $4a792688e08e5cd7$var$Fo(t, e) {
    if (t.constructor !== e.constructor) {
        const i = Math.min(t.length, e.length);
        for(let s = 0; s < i; s++)e[s] = t[s];
    } else {
        const i = Math.min(t.length, e.length);
        e.set(new t.constructor(t.buffer, 0, i));
    }
}
class $4a792688e08e5cd7$export$6e01c5ee52ed8f7b extends $4a792688e08e5cd7$export$e176487c05830cc5 {
    constructor(t, e, i = 2 * e, s){
        super(new $4a792688e08e5cd7$export$b7be63a67df8959, s), this.isBatchedMesh = !0, this.perObjectFrustumCulled = !0, this.sortObjects = !0, this.boundingBox = null, this.boundingSphere = null, this.customSort = null, this._instanceInfo = [], this._geometryInfo = [], this._availableInstanceIds = [], this._availableGeometryIds = [], this._nextIndexStart = 0, this._nextVertexStart = 0, this._geometryCount = 0, this._visibilityChanged = !0, this._geometryInitialized = !1, this._maxInstanceCount = t, this._maxVertexCount = e, this._maxIndexCount = i, this._multiDrawCounts = new Int32Array(t), this._multiDrawStarts = new Int32Array(t), this._multiDrawCount = 0, this._multiDrawInstances = null, this._matricesTexture = null, this._indirectTexture = null, this._colorsTexture = null, this._initMatricesTexture(), this._initIndirectTexture();
    }
    get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    _initMatricesTexture() {
        let t = Math.sqrt(4 * this._maxInstanceCount);
        t = 4 * Math.ceil(t / 4), t = Math.max(t, 4);
        const e = new Float32Array(t * t * 4), i = new $4a792688e08e5cd7$export$b691f601014eabe1(e, t, t, $4a792688e08e5cd7$export$3f8bb04b555a363c, $4a792688e08e5cd7$export$f6d331659b644596);
        this._matricesTexture = i;
    }
    _initIndirectTexture() {
        let t = Math.sqrt(this._maxInstanceCount);
        t = Math.ceil(t);
        const e = new Uint32Array(t * t), i = new $4a792688e08e5cd7$export$b691f601014eabe1(e, t, t, $4a792688e08e5cd7$export$aa92e870a709d190, $4a792688e08e5cd7$export$c3c7fc4518ebba96);
        this._indirectTexture = i;
    }
    _initColorsTexture() {
        let t = Math.sqrt(this._maxInstanceCount);
        t = Math.ceil(t);
        const e = new Float32Array(t * t * 4).fill(1), i = new $4a792688e08e5cd7$export$b691f601014eabe1(e, t, t, $4a792688e08e5cd7$export$3f8bb04b555a363c, $4a792688e08e5cd7$export$f6d331659b644596);
        i.colorSpace = $4a792688e08e5cd7$export$5e6fd513f44698c.workingColorSpace, this._colorsTexture = i;
    }
    _initializeGeometry(t) {
        const e = this.geometry, i = this._maxVertexCount, s = this._maxIndexCount;
        if (!1 === this._geometryInitialized) {
            for(const s in t.attributes){
                const r = t.getAttribute(s), { array: n, itemSize: a, normalized: o } = r, h = new n.constructor(i * a), l = new $4a792688e08e5cd7$export$8dea267bd6bde117(h, a, o);
                e.setAttribute(s, l);
            }
            if (null !== t.getIndex()) {
                const t = i > 65535 ? new Uint32Array(s) : new Uint16Array(s);
                e.setIndex(new $4a792688e08e5cd7$export$8dea267bd6bde117(t, 1));
            }
            this._geometryInitialized = !0;
        }
    }
    _validateGeometry(t) {
        const e = this.geometry;
        if (Boolean(t.getIndex()) !== Boolean(e.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
        for(const i in e.attributes){
            if (!t.hasAttribute(i)) throw new Error(`THREE.BatchedMesh: Added geometry missing "${i}". All geometries must have consistent attributes.`);
            const s = t.getAttribute(i), r = e.getAttribute(i);
            if (s.itemSize !== r.itemSize || s.normalized !== r.normalized) throw new Error("THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.");
        }
    }
    validateInstanceId(t) {
        const e = this._instanceInfo;
        if (t < 0 || t >= e.length || !1 === e[t].active) throw new Error(`THREE.BatchedMesh: Invalid instanceId ${t}. Instance is either out of range or has been deleted.`);
    }
    validateGeometryId(t) {
        const e = this._geometryInfo;
        if (t < 0 || t >= e.length || !1 === e[t].active) throw new Error(`THREE.BatchedMesh: Invalid geometryId ${t}. Geometry is either out of range or has been deleted.`);
    }
    setCustomSort(t) {
        return this.customSort = t, this;
    }
    computeBoundingBox() {
        null === this.boundingBox && (this.boundingBox = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3);
        const t = this.boundingBox, e = this._instanceInfo;
        t.makeEmpty();
        for(let i = 0, s = e.length; i < s; i++){
            if (!1 === e[i].active) continue;
            const s = e[i].geometryIndex;
            this.getMatrixAt(i, $4a792688e08e5cd7$var$_o), this.getBoundingBoxAt(s, $4a792688e08e5cd7$var$Co).applyMatrix4($4a792688e08e5cd7$var$_o), t.union($4a792688e08e5cd7$var$Co);
        }
    }
    computeBoundingSphere() {
        null === this.boundingSphere && (this.boundingSphere = new $4a792688e08e5cd7$export$805e8b72413ccaba);
        const t = this.boundingSphere, e = this._instanceInfo;
        t.makeEmpty();
        for(let i = 0, s = e.length; i < s; i++){
            if (!1 === e[i].active) continue;
            const s = e[i].geometryIndex;
            this.getMatrixAt(i, $4a792688e08e5cd7$var$_o), this.getBoundingSphereAt(s, $4a792688e08e5cd7$var$Io).applyMatrix4($4a792688e08e5cd7$var$_o), t.union($4a792688e08e5cd7$var$Io);
        }
    }
    addInstance(t) {
        if (this._instanceInfo.length >= this.maxInstanceCount && 0 === this._availableInstanceIds.length) throw new Error("THREE.BatchedMesh: Maximum item count reached.");
        const e = {
            visible: !0,
            active: !0,
            geometryIndex: t
        };
        let i = null;
        this._availableInstanceIds.length > 0 ? (this._availableInstanceIds.sort($4a792688e08e5cd7$var$vo), i = this._availableInstanceIds.shift(), this._instanceInfo[i] = e) : (i = this._instanceInfo.length, this._instanceInfo.push(e));
        const s = this._matricesTexture;
        $4a792688e08e5cd7$var$_o.identity().toArray(s.image.data, 16 * i), s.needsUpdate = !0;
        const r = this._colorsTexture;
        return r && ($4a792688e08e5cd7$var$Ao.toArray(r.image.data, 4 * i), r.needsUpdate = !0), this._visibilityChanged = !0, i;
    }
    addGeometry(t, e = -1, i = -1) {
        this._initializeGeometry(t), this._validateGeometry(t);
        const s = {
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            start: -1,
            count: -1,
            boundingBox: null,
            boundingSphere: null,
            active: !0
        }, r = this._geometryInfo;
        s.vertexStart = this._nextVertexStart, s.reservedVertexCount = -1 === e ? t.getAttribute("position").count : e;
        const n = t.getIndex();
        if (null !== n && (s.indexStart = this._nextIndexStart, s.reservedIndexCount = -1 === i ? n.count : i), -1 !== s.indexStart && s.indexStart + s.reservedIndexCount > this._maxIndexCount || s.vertexStart + s.reservedVertexCount > this._maxVertexCount) throw new Error("THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.");
        let a;
        return this._availableGeometryIds.length > 0 ? (this._availableGeometryIds.sort($4a792688e08e5cd7$var$vo), a = this._availableGeometryIds.shift(), r[a] = s) : (a = this._geometryCount, this._geometryCount++, r.push(s)), this.setGeometryAt(a, t), this._nextIndexStart = s.indexStart + s.reservedIndexCount, this._nextVertexStart = s.vertexStart + s.reservedVertexCount, a;
    }
    setGeometryAt(t, e) {
        if (t >= this._geometryCount) throw new Error("THREE.BatchedMesh: Maximum geometry count reached.");
        this._validateGeometry(e);
        const i = this.geometry, s = null !== i.getIndex(), r = i.getIndex(), n = e.getIndex(), a = this._geometryInfo[t];
        if (s && n.count > a.reservedIndexCount || e.attributes.position.count > a.reservedVertexCount) throw new Error("THREE.BatchedMesh: Reserved space not large enough for provided geometry.");
        const o = a.vertexStart, h = a.reservedVertexCount;
        a.vertexCount = e.getAttribute("position").count;
        for(const t in i.attributes){
            const s = e.getAttribute(t), r = i.getAttribute(t);
            $4a792688e08e5cd7$var$Vo(s, r, o);
            const n = s.itemSize;
            for(let t = s.count, e = h; t < e; t++){
                const e = o + t;
                for(let t = 0; t < n; t++)r.setComponent(e, t, 0);
            }
            r.needsUpdate = !0, r.addUpdateRange(o * n, h * n);
        }
        if (s) {
            const t = a.indexStart, i = a.reservedIndexCount;
            a.indexCount = e.getIndex().count;
            for(let e = 0; e < n.count; e++)r.setX(t + e, o + n.getX(e));
            for(let e = n.count, s = i; e < s; e++)r.setX(t + e, o);
            r.needsUpdate = !0, r.addUpdateRange(t, a.reservedIndexCount);
        }
        return a.start = s ? a.indexStart : a.vertexStart, a.count = s ? a.indexCount : a.vertexCount, a.boundingBox = null, null !== e.boundingBox && (a.boundingBox = e.boundingBox.clone()), a.boundingSphere = null, null !== e.boundingSphere && (a.boundingSphere = e.boundingSphere.clone()), this._visibilityChanged = !0, t;
    }
    deleteGeometry(t) {
        const e = this._geometryInfo;
        if (t >= e.length || !1 === e[t].active) return this;
        const i = this._instanceInfo;
        for(let e = 0, s = i.length; e < s; e++)i[e].active && i[e].geometryIndex === t && this.deleteInstance(e);
        return e[t].active = !1, this._availableGeometryIds.push(t), this._visibilityChanged = !0, this;
    }
    deleteInstance(t) {
        return this.validateInstanceId(t), this._instanceInfo[t].active = !1, this._availableInstanceIds.push(t), this._visibilityChanged = !0, this;
    }
    optimize() {
        let t = 0, e = 0;
        const i = this._geometryInfo, s = i.map((t, e)=>e).sort((t, e)=>i[t].vertexStart - i[e].vertexStart), r = this.geometry;
        for(let n = 0, a = i.length; n < a; n++){
            const a = s[n], o = i[a];
            if (!1 !== o.active) {
                if (null !== r.index) {
                    if (o.indexStart !== e) {
                        const { indexStart: i, vertexStart: s, reservedIndexCount: n } = o, a = r.index, h = a.array, l = t - s;
                        for(let t = i; t < i + n; t++)h[t] = h[t] + l;
                        a.array.copyWithin(e, i, i + n), a.addUpdateRange(e, n), o.indexStart = e;
                    }
                    e += o.reservedIndexCount;
                }
                if (o.vertexStart !== t) {
                    const { vertexStart: e, reservedVertexCount: i } = o, s = r.attributes;
                    for(const r in s){
                        const n = s[r], { array: a, itemSize: o } = n;
                        a.copyWithin(t * o, e * o, (e + i) * o), n.addUpdateRange(t * o, i * o);
                    }
                    o.vertexStart = t;
                }
                t += o.reservedVertexCount, o.start = r.index ? o.indexStart : o.vertexStart, this._nextIndexStart = r.index ? o.indexStart + o.reservedIndexCount : 0, this._nextVertexStart = o.vertexStart + o.reservedVertexCount;
            }
        }
        return this;
    }
    getBoundingBoxAt(t, e) {
        if (t >= this._geometryCount) return null;
        const i = this.geometry, s = this._geometryInfo[t];
        if (null === s.boundingBox) {
            const t = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3, e = i.index, r = i.attributes.position;
            for(let i = s.start, n = s.start + s.count; i < n; i++){
                let s = i;
                e && (s = e.getX(s)), t.expandByPoint($4a792688e08e5cd7$var$Bo.fromBufferAttribute(r, s));
            }
            s.boundingBox = t;
        }
        return e.copy(s.boundingBox), e;
    }
    getBoundingSphereAt(t, e) {
        if (t >= this._geometryCount) return null;
        const i = this.geometry, s = this._geometryInfo[t];
        if (null === s.boundingSphere) {
            const e = new $4a792688e08e5cd7$export$805e8b72413ccaba;
            this.getBoundingBoxAt(t, $4a792688e08e5cd7$var$Co), $4a792688e08e5cd7$var$Co.getCenter(e.center);
            const r = i.index, n = i.attributes.position;
            let a = 0;
            for(let t = s.start, i = s.start + s.count; t < i; t++){
                let i = t;
                r && (i = r.getX(i)), $4a792688e08e5cd7$var$Bo.fromBufferAttribute(n, i), a = Math.max(a, e.center.distanceToSquared($4a792688e08e5cd7$var$Bo));
            }
            e.radius = Math.sqrt(a), s.boundingSphere = e;
        }
        return e.copy(s.boundingSphere), e;
    }
    setMatrixAt(t, e) {
        this.validateInstanceId(t);
        const i = this._matricesTexture, s = this._matricesTexture.image.data;
        return e.toArray(s, 16 * t), i.needsUpdate = !0, this;
    }
    getMatrixAt(t, e) {
        return this.validateInstanceId(t), e.fromArray(this._matricesTexture.image.data, 16 * t);
    }
    setColorAt(t, e) {
        return this.validateInstanceId(t), null === this._colorsTexture && this._initColorsTexture(), e.toArray(this._colorsTexture.image.data, 4 * t), this._colorsTexture.needsUpdate = !0, this;
    }
    getColorAt(t, e) {
        return this.validateInstanceId(t), e.fromArray(this._colorsTexture.image.data, 4 * t);
    }
    setVisibleAt(t, e) {
        return this.validateInstanceId(t), this._instanceInfo[t].visible === e || (this._instanceInfo[t].visible = e, this._visibilityChanged = !0), this;
    }
    getVisibleAt(t) {
        return this.validateInstanceId(t), this._instanceInfo[t].visible;
    }
    setGeometryIdAt(t, e) {
        return this.validateInstanceId(t), this.validateGeometryId(e), this._instanceInfo[t].geometryIndex = e, this;
    }
    getGeometryIdAt(t) {
        return this.validateInstanceId(t), this._instanceInfo[t].geometryIndex;
    }
    getGeometryRangeAt(t, e = {}) {
        this.validateGeometryId(t);
        const i = this._geometryInfo[t];
        return e.vertexStart = i.vertexStart, e.vertexCount = i.vertexCount, e.reservedVertexCount = i.reservedVertexCount, e.indexStart = i.indexStart, e.indexCount = i.indexCount, e.reservedIndexCount = i.reservedIndexCount, e.start = i.start, e.count = i.count, e;
    }
    setInstanceCount(t) {
        const e = this._availableInstanceIds, i = this._instanceInfo;
        for(e.sort($4a792688e08e5cd7$var$vo); e[e.length - 1] === i.length - 1;)i.pop(), e.pop();
        if (t < i.length) throw new Error(`BatchedMesh: Instance ids outside the range ${t} are being used. Cannot shrink instance count.`);
        const s = new Int32Array(t), r = new Int32Array(t);
        $4a792688e08e5cd7$var$Fo(this._multiDrawCounts, s), $4a792688e08e5cd7$var$Fo(this._multiDrawStarts, r), this._multiDrawCounts = s, this._multiDrawStarts = r, this._maxInstanceCount = t;
        const n = this._indirectTexture, a = this._matricesTexture, o = this._colorsTexture;
        n.dispose(), this._initIndirectTexture(), $4a792688e08e5cd7$var$Fo(n.image.data, this._indirectTexture.image.data), a.dispose(), this._initMatricesTexture(), $4a792688e08e5cd7$var$Fo(a.image.data, this._matricesTexture.image.data), o && (o.dispose(), this._initColorsTexture(), $4a792688e08e5cd7$var$Fo(o.image.data, this._colorsTexture.image.data));
    }
    setGeometrySize(t, e) {
        const i = [
            ...this._geometryInfo
        ].filter((t)=>t.active);
        if (Math.max(...i.map((t)=>t.vertexStart + t.reservedVertexCount)) > t) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${e}. Cannot shrink further.`);
        if (this.geometry.index) {
            if (Math.max(...i.map((t)=>t.indexStart + t.reservedIndexCount)) > e) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${e}. Cannot shrink further.`);
        }
        const s = this.geometry;
        s.dispose(), this._maxVertexCount = t, this._maxIndexCount = e, this._geometryInitialized && (this._geometryInitialized = !1, this.geometry = new $4a792688e08e5cd7$export$b7be63a67df8959, this._initializeGeometry(s));
        const r = this.geometry;
        s.index && $4a792688e08e5cd7$var$Fo(s.index.array, r.index.array);
        for(const t in s.attributes)$4a792688e08e5cd7$var$Fo(s.attributes[t].array, r.attributes[t].array);
    }
    raycast(t, e) {
        const i = this._instanceInfo, s = this._geometryInfo, r = this.matrixWorld, n = this.geometry;
        $4a792688e08e5cd7$var$Ro.material = this.material, $4a792688e08e5cd7$var$Ro.geometry.index = n.index, $4a792688e08e5cd7$var$Ro.geometry.attributes = n.attributes, null === $4a792688e08e5cd7$var$Ro.geometry.boundingBox && ($4a792688e08e5cd7$var$Ro.geometry.boundingBox = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3), null === $4a792688e08e5cd7$var$Ro.geometry.boundingSphere && ($4a792688e08e5cd7$var$Ro.geometry.boundingSphere = new $4a792688e08e5cd7$export$805e8b72413ccaba);
        for(let n = 0, a = i.length; n < a; n++){
            if (!i[n].visible || !i[n].active) continue;
            const a = i[n].geometryIndex, o = s[a];
            $4a792688e08e5cd7$var$Ro.geometry.setDrawRange(o.start, o.count), this.getMatrixAt(n, $4a792688e08e5cd7$var$Ro.matrixWorld).premultiply(r), this.getBoundingBoxAt(a, $4a792688e08e5cd7$var$Ro.geometry.boundingBox), this.getBoundingSphereAt(a, $4a792688e08e5cd7$var$Ro.geometry.boundingSphere), $4a792688e08e5cd7$var$Ro.raycast(t, $4a792688e08e5cd7$var$No);
            for(let t = 0, i = $4a792688e08e5cd7$var$No.length; t < i; t++){
                const i = $4a792688e08e5cd7$var$No[t];
                i.object = this, i.batchId = n, e.push(i);
            }
            $4a792688e08e5cd7$var$No.length = 0;
        }
        $4a792688e08e5cd7$var$Ro.material = null, $4a792688e08e5cd7$var$Ro.geometry.index = null, $4a792688e08e5cd7$var$Ro.geometry.attributes = {}, $4a792688e08e5cd7$var$Ro.geometry.setDrawRange(0, 1 / 0);
    }
    copy(t) {
        return super.copy(t), this.geometry = t.geometry.clone(), this.perObjectFrustumCulled = t.perObjectFrustumCulled, this.sortObjects = t.sortObjects, this.boundingBox = null !== t.boundingBox ? t.boundingBox.clone() : null, this.boundingSphere = null !== t.boundingSphere ? t.boundingSphere.clone() : null, this._geometryInfo = t._geometryInfo.map((t)=>({
                ...t,
                boundingBox: null !== t.boundingBox ? t.boundingBox.clone() : null,
                boundingSphere: null !== t.boundingSphere ? t.boundingSphere.clone() : null
            })), this._instanceInfo = t._instanceInfo.map((t)=>({
                ...t
            })), this._availableInstanceIds = t._availableInstanceIds.slice(), this._availableGeometryIds = t._availableGeometryIds.slice(), this._nextIndexStart = t._nextIndexStart, this._nextVertexStart = t._nextVertexStart, this._geometryCount = t._geometryCount, this._maxInstanceCount = t._maxInstanceCount, this._maxVertexCount = t._maxVertexCount, this._maxIndexCount = t._maxIndexCount, this._geometryInitialized = t._geometryInitialized, this._multiDrawCounts = t._multiDrawCounts.slice(), this._multiDrawStarts = t._multiDrawStarts.slice(), this._indirectTexture = t._indirectTexture.clone(), this._indirectTexture.image.data = this._indirectTexture.image.data.slice(), this._matricesTexture = t._matricesTexture.clone(), this._matricesTexture.image.data = this._matricesTexture.image.data.slice(), null !== this._colorsTexture && (this._colorsTexture = t._colorsTexture.clone(), this._colorsTexture.image.data = this._colorsTexture.image.data.slice()), this;
    }
    dispose() {
        this.geometry.dispose(), this._matricesTexture.dispose(), this._matricesTexture = null, this._indirectTexture.dispose(), this._indirectTexture = null, null !== this._colorsTexture && (this._colorsTexture.dispose(), this._colorsTexture = null);
    }
    onBeforeRender(t, e, i, s, r) {
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        const n = s.getIndex(), a = null === n ? 1 : n.array.BYTES_PER_ELEMENT, o = this._instanceInfo, h = this._multiDrawStarts, l = this._multiDrawCounts, c = this._geometryInfo, u = this.perObjectFrustumCulled, d = this._indirectTexture, p = d.image.data, m = i.isArrayCamera ? $4a792688e08e5cd7$var$zo : $4a792688e08e5cd7$var$To;
        u && !i.isArrayCamera && ($4a792688e08e5cd7$var$_o.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse).multiply(this.matrixWorld), $4a792688e08e5cd7$var$To.setFromProjectionMatrix($4a792688e08e5cd7$var$_o, i.coordinateSystem, i.reversedDepth));
        let y = 0;
        if (this.sortObjects) {
            $4a792688e08e5cd7$var$_o.copy(this.matrixWorld).invert(), $4a792688e08e5cd7$var$Bo.setFromMatrixPosition(i.matrixWorld).applyMatrix4($4a792688e08e5cd7$var$_o), $4a792688e08e5cd7$var$ko.set(0, 0, -1).transformDirection(i.matrixWorld).transformDirection($4a792688e08e5cd7$var$_o);
            for(let t = 0, e = o.length; t < e; t++)if (o[t].visible && o[t].active) {
                const e = o[t].geometryIndex;
                this.getMatrixAt(t, $4a792688e08e5cd7$var$_o), this.getBoundingSphereAt(e, $4a792688e08e5cd7$var$Io).applyMatrix4($4a792688e08e5cd7$var$_o);
                let s = !1;
                if (u && (s = !m.intersectsSphere($4a792688e08e5cd7$var$Io, i)), !s) {
                    const i = c[e], s = $4a792688e08e5cd7$var$Po.subVectors($4a792688e08e5cd7$var$Io.center, $4a792688e08e5cd7$var$Bo).dot($4a792688e08e5cd7$var$ko);
                    $4a792688e08e5cd7$var$Oo.push(i.start, i.count, s, t);
                }
            }
            const t = $4a792688e08e5cd7$var$Oo.list, e = this.customSort;
            null === e ? t.sort(r.transparent ? $4a792688e08e5cd7$var$Mo : $4a792688e08e5cd7$var$wo) : e.call(this, t, i);
            for(let e = 0, i = t.length; e < i; e++){
                const i = t[e];
                h[y] = i.start * a, l[y] = i.count, p[y] = i.index, y++;
            }
            $4a792688e08e5cd7$var$Oo.reset();
        } else for(let t = 0, e = o.length; t < e; t++)if (o[t].visible && o[t].active) {
            const e = o[t].geometryIndex;
            let s = !1;
            if (u && (this.getMatrixAt(t, $4a792688e08e5cd7$var$_o), this.getBoundingSphereAt(e, $4a792688e08e5cd7$var$Io).applyMatrix4($4a792688e08e5cd7$var$_o), s = !m.intersectsSphere($4a792688e08e5cd7$var$Io, i)), !s) {
                const i = c[e];
                h[y] = i.start * a, l[y] = i.count, p[y] = t, y++;
            }
        }
        d.needsUpdate = !0, this._multiDrawCount = y, this._visibilityChanged = !1;
    }
    onBeforeShadow(t, e, i, s, r, n) {
        this.onBeforeRender(t, null, s, r, n);
    }
}
class $4a792688e08e5cd7$export$fbaaa33907730a0c extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.map = t.map, this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this.fog = t.fog, this;
    }
}
const $4a792688e08e5cd7$var$jo = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Do = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Wo = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$Uo = new $4a792688e08e5cd7$export$a186db52eed6d40e, $4a792688e08e5cd7$var$qo = new $4a792688e08e5cd7$export$805e8b72413ccaba, $4a792688e08e5cd7$var$Jo = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Xo = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$17d680238e50603e extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(t = new $4a792688e08e5cd7$export$b7be63a67df8959, e = new $4a792688e08e5cd7$export$fbaaa33907730a0c){
        super(), this.isLine = !0, this.type = "Line", this.geometry = t, this.material = e, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
    }
    copy(t, e) {
        return super.copy(t, e), this.material = Array.isArray(t.material) ? t.material.slice() : t.material, this.geometry = t.geometry, this;
    }
    computeLineDistances() {
        const t = this.geometry;
        if (null === t.index) {
            const e = t.attributes.position, i = [
                0
            ];
            for(let t = 1, s = e.count; t < s; t++)$4a792688e08e5cd7$var$jo.fromBufferAttribute(e, t - 1), $4a792688e08e5cd7$var$Do.fromBufferAttribute(e, t), i[t] = i[t - 1], i[t] += $4a792688e08e5cd7$var$jo.distanceTo($4a792688e08e5cd7$var$Do);
            t.setAttribute("lineDistance", new $4a792688e08e5cd7$export$cbe7a62641830ebd(i, 1));
        } else $4a792688e08e5cd7$export$c106dd0671a0fc2d("Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(t, e) {
        const i = this.geometry, s = this.matrixWorld, r = t.params.Line.threshold, n = i.drawRange;
        if (null === i.boundingSphere && i.computeBoundingSphere(), $4a792688e08e5cd7$var$qo.copy(i.boundingSphere), $4a792688e08e5cd7$var$qo.applyMatrix4(s), $4a792688e08e5cd7$var$qo.radius += r, !1 === t.ray.intersectsSphere($4a792688e08e5cd7$var$qo)) return;
        $4a792688e08e5cd7$var$Wo.copy(s).invert(), $4a792688e08e5cd7$var$Uo.copy(t.ray).applyMatrix4($4a792688e08e5cd7$var$Wo);
        const a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = a * a, h = this.isLineSegments ? 2 : 1, l = i.index, c = i.attributes.position;
        if (null !== l) {
            const i = Math.max(0, n.start), s = Math.min(l.count, n.start + n.count);
            for(let r = i, n = s - 1; r < n; r += h){
                const i = l.getX(r), s = l.getX(r + 1), n = $4a792688e08e5cd7$var$Zo(this, t, $4a792688e08e5cd7$var$Uo, o, i, s, r);
                n && e.push(n);
            }
            if (this.isLineLoop) {
                const r = l.getX(s - 1), n = l.getX(i), a = $4a792688e08e5cd7$var$Zo(this, t, $4a792688e08e5cd7$var$Uo, o, r, n, s - 1);
                a && e.push(a);
            }
        } else {
            const i = Math.max(0, n.start), s = Math.min(c.count, n.start + n.count);
            for(let r = i, n = s - 1; r < n; r += h){
                const i = $4a792688e08e5cd7$var$Zo(this, t, $4a792688e08e5cd7$var$Uo, o, r, r + 1, r);
                i && e.push(i);
            }
            if (this.isLineLoop) {
                const r = $4a792688e08e5cd7$var$Zo(this, t, $4a792688e08e5cd7$var$Uo, o, s - 1, i, s - 1);
                r && e.push(r);
            }
        }
    }
    updateMorphTargets() {
        const t = this.geometry.morphAttributes, e = Object.keys(t);
        if (e.length > 0) {
            const i = t[e[0]];
            if (void 0 !== i) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let t = 0, e = i.length; t < e; t++){
                    const e = i[t].name || String(t);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t;
                }
            }
        }
    }
}
function $4a792688e08e5cd7$var$Zo(t, e, i, s, r, n, a) {
    const o = t.geometry.attributes.position;
    $4a792688e08e5cd7$var$jo.fromBufferAttribute(o, r), $4a792688e08e5cd7$var$Do.fromBufferAttribute(o, n);
    if (i.distanceSqToSegment($4a792688e08e5cd7$var$jo, $4a792688e08e5cd7$var$Do, $4a792688e08e5cd7$var$Jo, $4a792688e08e5cd7$var$Xo) > s) return;
    $4a792688e08e5cd7$var$Jo.applyMatrix4(t.matrixWorld);
    const h = e.ray.origin.distanceTo($4a792688e08e5cd7$var$Jo);
    return h < e.near || h > e.far ? void 0 : {
        distance: h,
        point: $4a792688e08e5cd7$var$Xo.clone().applyMatrix4(t.matrixWorld),
        index: a,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: t
    };
}
const $4a792688e08e5cd7$var$Ho = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Go = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$ff1ed10fedfdd604 extends $4a792688e08e5cd7$export$17d680238e50603e {
    constructor(t, e){
        super(t, e), this.isLineSegments = !0, this.type = "LineSegments";
    }
    computeLineDistances() {
        const t = this.geometry;
        if (null === t.index) {
            const e = t.attributes.position, i = [];
            for(let t = 0, s = e.count; t < s; t += 2)$4a792688e08e5cd7$var$Ho.fromBufferAttribute(e, t), $4a792688e08e5cd7$var$Go.fromBufferAttribute(e, t + 1), i[t] = 0 === t ? 0 : i[t - 1], i[t + 1] = i[t] + $4a792688e08e5cd7$var$Ho.distanceTo($4a792688e08e5cd7$var$Go);
            t.setAttribute("lineDistance", new $4a792688e08e5cd7$export$cbe7a62641830ebd(i, 1));
        } else $4a792688e08e5cd7$export$c106dd0671a0fc2d("LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $4a792688e08e5cd7$export$f85a24d745e4f17d extends $4a792688e08e5cd7$export$17d680238e50603e {
    constructor(t, e){
        super(t, e), this.isLineLoop = !0, this.type = "LineLoop";
    }
}
class $4a792688e08e5cd7$export$a178c45366ce5d6b extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.map = t.map, this.alphaMap = t.alphaMap, this.size = t.size, this.sizeAttenuation = t.sizeAttenuation, this.fog = t.fog, this;
    }
}
const $4a792688e08e5cd7$var$th = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$eh = new $4a792688e08e5cd7$export$a186db52eed6d40e, $4a792688e08e5cd7$var$ih = new $4a792688e08e5cd7$export$805e8b72413ccaba, $4a792688e08e5cd7$var$sh = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$1c787534cb11aa3e extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(t = new $4a792688e08e5cd7$export$b7be63a67df8959, e = new $4a792688e08e5cd7$export$a178c45366ce5d6b){
        super(), this.isPoints = !0, this.type = "Points", this.geometry = t, this.material = e, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
    }
    copy(t, e) {
        return super.copy(t, e), this.material = Array.isArray(t.material) ? t.material.slice() : t.material, this.geometry = t.geometry, this;
    }
    raycast(t, e) {
        const i = this.geometry, s = this.matrixWorld, r = t.params.Points.threshold, n = i.drawRange;
        if (null === i.boundingSphere && i.computeBoundingSphere(), $4a792688e08e5cd7$var$ih.copy(i.boundingSphere), $4a792688e08e5cd7$var$ih.applyMatrix4(s), $4a792688e08e5cd7$var$ih.radius += r, !1 === t.ray.intersectsSphere($4a792688e08e5cd7$var$ih)) return;
        $4a792688e08e5cd7$var$th.copy(s).invert(), $4a792688e08e5cd7$var$eh.copy(t.ray).applyMatrix4($4a792688e08e5cd7$var$th);
        const a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = a * a, h = i.index, l = i.attributes.position;
        if (null !== h) for(let i = Math.max(0, n.start), r = Math.min(h.count, n.start + n.count); i < r; i++){
            const r = h.getX(i);
            $4a792688e08e5cd7$var$sh.fromBufferAttribute(l, r), $4a792688e08e5cd7$var$nh($4a792688e08e5cd7$var$sh, r, o, s, t, e, this);
        }
        else for(let i = Math.max(0, n.start), r = Math.min(l.count, n.start + n.count); i < r; i++)$4a792688e08e5cd7$var$sh.fromBufferAttribute(l, i), $4a792688e08e5cd7$var$nh($4a792688e08e5cd7$var$sh, i, o, s, t, e, this);
    }
    updateMorphTargets() {
        const t = this.geometry.morphAttributes, e = Object.keys(t);
        if (e.length > 0) {
            const i = t[e[0]];
            if (void 0 !== i) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let t = 0, e = i.length; t < e; t++){
                    const e = i[t].name || String(t);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t;
                }
            }
        }
    }
}
function $4a792688e08e5cd7$var$nh(t, e, i, s, r, n, a) {
    const o = $4a792688e08e5cd7$var$eh.distanceSqToPoint(t);
    if (o < i) {
        const i = new $4a792688e08e5cd7$export$64b5c384219d3699;
        $4a792688e08e5cd7$var$eh.closestPointToPoint(t, i), i.applyMatrix4(s);
        const h = r.ray.origin.distanceTo(i);
        if (h < r.near || h > r.far) return;
        n.push({
            distance: h,
            distanceToRay: Math.sqrt(o),
            point: i,
            index: e,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: a
        });
    }
}
class $4a792688e08e5cd7$export$6e09d1edf8d5a25c extends $4a792688e08e5cd7$export$5431306cf43de24a {
    constructor(t, e, i, s, r = 1006, n = 1006, a, o, h){
        super(t, e, i, s, r, n, a, o, h), this.isVideoTexture = !0, this.generateMipmaps = !1, this._requestVideoFrameCallbackId = 0;
        const l = this;
        "requestVideoFrameCallback" in t && (this._requestVideoFrameCallbackId = t.requestVideoFrameCallback(function e() {
            l.needsUpdate = !0, l._requestVideoFrameCallbackId = t.requestVideoFrameCallback(e);
        }));
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const t = this.image;
        !1 === "requestVideoFrameCallback" in t && t.readyState >= t.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
    }
    dispose() {
        0 !== this._requestVideoFrameCallbackId && (this.source.data.cancelVideoFrameCallback(this._requestVideoFrameCallbackId), this._requestVideoFrameCallbackId = 0), super.dispose();
    }
}
class $4a792688e08e5cd7$export$68498d200b825382 extends $4a792688e08e5cd7$export$6e09d1edf8d5a25c {
    constructor(t, e, i, s, r, n, a, o){
        super({}, t, e, i, s, r, n, a, o), this.isVideoFrameTexture = !0;
    }
    update() {}
    clone() {
        return (new this.constructor).copy(this);
    }
    setFrame(t) {
        this.image = t, this.needsUpdate = !0;
    }
}
class $4a792688e08e5cd7$export$9270d786f73ce6fe extends $4a792688e08e5cd7$export$5431306cf43de24a {
    constructor(t, e){
        super({
            width: t,
            height: e
        }), this.isFramebufferTexture = !0, this.magFilter = $4a792688e08e5cd7$export$727aa5ec3fe39bf0, this.minFilter = $4a792688e08e5cd7$export$727aa5ec3fe39bf0, this.generateMipmaps = !1, this.needsUpdate = !0;
    }
}
class $4a792688e08e5cd7$export$3466bac9141a5cc4 extends $4a792688e08e5cd7$export$5431306cf43de24a {
    constructor(t, e, i, s, r, n, a, o, h, l, c, u){
        super(null, n, a, o, h, l, s, r, c, u), this.isCompressedTexture = !0, this.image = {
            width: e,
            height: i
        }, this.mipmaps = t, this.flipY = !1, this.generateMipmaps = !1;
    }
}
class $4a792688e08e5cd7$export$5fe6b8e34b274fcb extends $4a792688e08e5cd7$export$3466bac9141a5cc4 {
    constructor(t, e, i, s, r, n){
        super(t, e, i, r, n), this.isCompressedArrayTexture = !0, this.image.depth = s, this.wrapR = $4a792688e08e5cd7$export$9d9334239a5a5e06, this.layerUpdates = new Set;
    }
    addLayerUpdate(t) {
        this.layerUpdates.add(t);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $4a792688e08e5cd7$export$d80173634de65bff extends $4a792688e08e5cd7$export$3466bac9141a5cc4 {
    constructor(t, e, i){
        super(void 0, t[0].width, t[0].height, e, i, $4a792688e08e5cd7$export$8759762a6477f2c4), this.isCompressedCubeTexture = !0, this.isCubeTexture = !0, this.image = t;
    }
}
class $4a792688e08e5cd7$export$f7189e49152d1c13 extends $4a792688e08e5cd7$export$5431306cf43de24a {
    constructor(t, e, i, s, r, n, a, o, h){
        super(t, e, i, s, r, n, a, o, h), this.isCanvasTexture = !0, this.needsUpdate = !0;
    }
}
class $4a792688e08e5cd7$export$fc830aa069cc8c2f extends $4a792688e08e5cd7$export$5431306cf43de24a {
    constructor(t, e, i = 1014, s, r, n, a = 1003, o = 1003, h, l = 1026, c = 1){
        if (l !== $4a792688e08e5cd7$export$c1b6b5136be58045 && 1027 !== l) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        super({
            width: t,
            height: e,
            depth: c
        }, s, r, n, a, o, l, i, h), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
    }
    copy(t) {
        return super.copy(t), this.source = new $4a792688e08e5cd7$export$1d2df86270c81ecb(Object.assign({}, t.image)), this.compareFunction = t.compareFunction, this;
    }
    toJSON(t) {
        const e = super.toJSON(t);
        return null !== this.compareFunction && (e.compareFunction = this.compareFunction), e;
    }
}
class $4a792688e08e5cd7$export$cd10147cacf16ab2 extends $4a792688e08e5cd7$export$5431306cf43de24a {
    constructor(t = null){
        super(), this.sourceTexture = t, this.isExternalTexture = !0;
    }
    copy(t) {
        return super.copy(t), this.sourceTexture = t.sourceTexture, this;
    }
}
class $4a792688e08e5cd7$export$41680e8551036033 extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = 1, e = 1, i = 4, s = 8, r = 1){
        super(), this.type = "CapsuleGeometry", this.parameters = {
            radius: t,
            height: e,
            capSegments: i,
            radialSegments: s,
            heightSegments: r
        }, e = Math.max(0, e), i = Math.max(1, Math.floor(i)), s = Math.max(3, Math.floor(s)), r = Math.max(1, Math.floor(r));
        const n = [], a = [], o = [], h = [], l = e / 2, c = Math.PI / 2 * t, u = e, d = 2 * c + u, p = 2 * i + r, m = s + 1, y = new $4a792688e08e5cd7$export$64b5c384219d3699, g = new $4a792688e08e5cd7$export$64b5c384219d3699;
        for(let f = 0; f <= p; f++){
            let x = 0, b = 0, v = 0, w = 0;
            if (f <= i) {
                const e = f / i, s = e * Math.PI / 2;
                b = -l - t * Math.cos(s), v = t * Math.sin(s), w = -t * Math.cos(s), x = e * c;
            } else if (f <= i + r) {
                const s = (f - i) / r;
                b = s * e - l, v = t, w = 0, x = c + s * u;
            } else {
                const e = (f - i - r) / i, s = e * Math.PI / 2;
                b = l + t * Math.sin(s), v = t * Math.cos(s), w = t * Math.sin(s), x = c + u + e * c;
            }
            const M = Math.max(0, Math.min(1, x / d));
            let S = 0;
            0 === f ? S = .5 / s : f === p && (S = -0.5 / s);
            for(let t = 0; t <= s; t++){
                const e = t / s, i = e * Math.PI * 2, r = Math.sin(i), n = Math.cos(i);
                g.x = -v * n, g.y = b, g.z = v * r, a.push(g.x, g.y, g.z), y.set(-v * n, w, v * r), y.normalize(), o.push(y.x, y.y, y.z), h.push(e + S, M);
            }
            if (f > 0) {
                const t = (f - 1) * m;
                for(let e = 0; e < s; e++){
                    const i = t + e, s = t + e + 1, r = f * m + e, a = f * m + e + 1;
                    n.push(i, s, r), n.push(s, a, r);
                }
            }
        }
        this.setIndex(n), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(a, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(o, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(h, 2));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$41680e8551036033(t.radius, t.height, t.capSegments, t.radialSegments, t.heightSegments);
    }
}
class $4a792688e08e5cd7$export$d5c0e8d607467193 extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = 1, e = 32, i = 0, s = 2 * Math.PI){
        super(), this.type = "CircleGeometry", this.parameters = {
            radius: t,
            segments: e,
            thetaStart: i,
            thetaLength: s
        }, e = Math.max(3, e);
        const r = [], n = [], a = [], o = [], h = new $4a792688e08e5cd7$export$64b5c384219d3699, l = new $4a792688e08e5cd7$export$c977b3e384af9ae1;
        n.push(0, 0, 0), a.push(0, 0, 1), o.push(.5, .5);
        for(let r = 0, c = 3; r <= e; r++, c += 3){
            const u = i + r / e * s;
            h.x = t * Math.cos(u), h.y = t * Math.sin(u), n.push(h.x, h.y, h.z), a.push(0, 0, 1), l.x = (n[c] / t + 1) / 2, l.y = (n[c + 1] / t + 1) / 2, o.push(l.x, l.y);
        }
        for(let t = 1; t <= e; t++)r.push(t, t + 1, 0);
        this.setIndex(r), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(n, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(a, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(o, 2));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$d5c0e8d607467193(t.radius, t.segments, t.thetaStart, t.thetaLength);
    }
}
class $4a792688e08e5cd7$export$68f745719dbe5198 extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = 1, e = 1, i = 1, s = 32, r = 1, n = !1, a = 0, o = 2 * Math.PI){
        super(), this.type = "CylinderGeometry", this.parameters = {
            radiusTop: t,
            radiusBottom: e,
            height: i,
            radialSegments: s,
            heightSegments: r,
            openEnded: n,
            thetaStart: a,
            thetaLength: o
        };
        const h = this;
        s = Math.floor(s), r = Math.floor(r);
        const l = [], c = [], u = [], d = [];
        let p = 0;
        const m = [], y = i / 2;
        let g = 0;
        function f(i) {
            const r = p, n = new $4a792688e08e5cd7$export$c977b3e384af9ae1, m = new $4a792688e08e5cd7$export$64b5c384219d3699;
            let f = 0;
            const x = !0 === i ? t : e, b = !0 === i ? 1 : -1;
            for(let t = 1; t <= s; t++)c.push(0, y * b, 0), u.push(0, b, 0), d.push(.5, .5), p++;
            const v = p;
            for(let t = 0; t <= s; t++){
                const e = t / s * o + a, i = Math.cos(e), r = Math.sin(e);
                m.x = x * r, m.y = y * b, m.z = x * i, c.push(m.x, m.y, m.z), u.push(0, b, 0), n.x = .5 * i + .5, n.y = .5 * r * b + .5, d.push(n.x, n.y), p++;
            }
            for(let t = 0; t < s; t++){
                const e = r + t, s = v + t;
                !0 === i ? l.push(s, s + 1, e) : l.push(s + 1, s, e), f += 3;
            }
            h.addGroup(g, f, !0 === i ? 1 : 2), g += f;
        }
        !function() {
            const n = new $4a792688e08e5cd7$export$64b5c384219d3699, f = new $4a792688e08e5cd7$export$64b5c384219d3699;
            let x = 0;
            const b = (e - t) / i;
            for(let h = 0; h <= r; h++){
                const l = [], g = h / r, x = g * (e - t) + t;
                for(let t = 0; t <= s; t++){
                    const e = t / s, r = e * o + a, h = Math.sin(r), m = Math.cos(r);
                    f.x = x * h, f.y = -g * i + y, f.z = x * m, c.push(f.x, f.y, f.z), n.set(h, b, m).normalize(), u.push(n.x, n.y, n.z), d.push(e, 1 - g), l.push(p++);
                }
                m.push(l);
            }
            for(let i = 0; i < s; i++)for(let s = 0; s < r; s++){
                const n = m[s][i], a = m[s + 1][i], o = m[s + 1][i + 1], h = m[s][i + 1];
                (t > 0 || 0 !== s) && (l.push(n, a, h), x += 3), (e > 0 || s !== r - 1) && (l.push(a, o, h), x += 3);
            }
            h.addGroup(g, x, 0), g += x;
        }(), !1 === n && (t > 0 && f(!0), e > 0 && f(!1)), this.setIndex(l), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(c, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(u, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(d, 2));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$68f745719dbe5198(t.radiusTop, t.radiusBottom, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
    }
}
class $4a792688e08e5cd7$export$a7a48974f285c9b3 extends $4a792688e08e5cd7$export$68f745719dbe5198 {
    constructor(t = 1, e = 1, i = 32, s = 1, r = !1, n = 0, a = 2 * Math.PI){
        super(0, t, e, i, s, r, n, a), this.type = "ConeGeometry", this.parameters = {
            radius: t,
            height: e,
            radialSegments: i,
            heightSegments: s,
            openEnded: r,
            thetaStart: n,
            thetaLength: a
        };
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$a7a48974f285c9b3(t.radius, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
    }
}
class $4a792688e08e5cd7$export$60e57a7d3f20ff65 extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = [], e = [], i = 1, s = 0){
        super(), this.type = "PolyhedronGeometry", this.parameters = {
            vertices: t,
            indices: e,
            radius: i,
            detail: s
        };
        const r = [], n = [];
        function a(t, e, i, s) {
            const r = s + 1, n = [];
            for(let s = 0; s <= r; s++){
                n[s] = [];
                const a = t.clone().lerp(i, s / r), o = e.clone().lerp(i, s / r), h = r - s;
                for(let t = 0; t <= h; t++)n[s][t] = 0 === t && s === r ? a : a.clone().lerp(o, t / h);
            }
            for(let t = 0; t < r; t++)for(let e = 0; e < 2 * (r - t) - 1; e++){
                const i = Math.floor(e / 2);
                e % 2 == 0 ? (o(n[t][i + 1]), o(n[t + 1][i]), o(n[t][i])) : (o(n[t][i + 1]), o(n[t + 1][i + 1]), o(n[t + 1][i]));
            }
        }
        function o(t) {
            r.push(t.x, t.y, t.z);
        }
        function h(e, i) {
            const s = 3 * e;
            i.x = t[s + 0], i.y = t[s + 1], i.z = t[s + 2];
        }
        function l(t, e, i, s) {
            s < 0 && 1 === t.x && (n[e] = t.x - 1), 0 === i.x && 0 === i.z && (n[e] = s / 2 / Math.PI + .5);
        }
        function c(t) {
            return Math.atan2(t.z, -t.x);
        }
        function u(t) {
            return Math.atan2(-t.y, Math.sqrt(t.x * t.x + t.z * t.z));
        }
        !function(t) {
            const i = new $4a792688e08e5cd7$export$64b5c384219d3699, s = new $4a792688e08e5cd7$export$64b5c384219d3699, r = new $4a792688e08e5cd7$export$64b5c384219d3699;
            for(let n = 0; n < e.length; n += 3)h(e[n + 0], i), h(e[n + 1], s), h(e[n + 2], r), a(i, s, r, t);
        }(s), function(t) {
            const e = new $4a792688e08e5cd7$export$64b5c384219d3699;
            for(let i = 0; i < r.length; i += 3)e.x = r[i + 0], e.y = r[i + 1], e.z = r[i + 2], e.normalize().multiplyScalar(t), r[i + 0] = e.x, r[i + 1] = e.y, r[i + 2] = e.z;
        }(i), function() {
            const t = new $4a792688e08e5cd7$export$64b5c384219d3699;
            for(let e = 0; e < r.length; e += 3){
                t.x = r[e + 0], t.y = r[e + 1], t.z = r[e + 2];
                const i = c(t) / 2 / Math.PI + .5, s = u(t) / Math.PI + .5;
                n.push(i, 1 - s);
            }
            (function() {
                const t = new $4a792688e08e5cd7$export$64b5c384219d3699, e = new $4a792688e08e5cd7$export$64b5c384219d3699, i = new $4a792688e08e5cd7$export$64b5c384219d3699, s = new $4a792688e08e5cd7$export$64b5c384219d3699, a = new $4a792688e08e5cd7$export$c977b3e384af9ae1, o = new $4a792688e08e5cd7$export$c977b3e384af9ae1, h = new $4a792688e08e5cd7$export$c977b3e384af9ae1;
                for(let u = 0, d = 0; u < r.length; u += 9, d += 6){
                    t.set(r[u + 0], r[u + 1], r[u + 2]), e.set(r[u + 3], r[u + 4], r[u + 5]), i.set(r[u + 6], r[u + 7], r[u + 8]), a.set(n[d + 0], n[d + 1]), o.set(n[d + 2], n[d + 3]), h.set(n[d + 4], n[d + 5]), s.copy(t).add(e).add(i).divideScalar(3);
                    const p = c(s);
                    l(a, d + 0, t, p), l(o, d + 2, e, p), l(h, d + 4, i, p);
                }
            })(), function() {
                for(let t = 0; t < n.length; t += 6){
                    const e = n[t + 0], i = n[t + 2], s = n[t + 4], r = Math.max(e, i, s), a = Math.min(e, i, s);
                    r > .9 && a < .1 && (e < .2 && (n[t + 0] += 1), i < .2 && (n[t + 2] += 1), s < .2 && (n[t + 4] += 1));
                }
            }();
        }(), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(r, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(r.slice(), 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(n, 2)), 0 === s ? this.computeVertexNormals() : this.normalizeNormals();
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$60e57a7d3f20ff65(t.vertices, t.indices, t.radius, t.details);
    }
}
class $4a792688e08e5cd7$export$c0babfeb8708fc9c extends $4a792688e08e5cd7$export$60e57a7d3f20ff65 {
    constructor(t = 1, e = 0){
        const i = (1 + Math.sqrt(5)) / 2, s = 1 / i;
        super([
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -s,
            -i,
            0,
            -s,
            i,
            0,
            s,
            -i,
            0,
            s,
            i,
            -s,
            -i,
            0,
            -s,
            i,
            0,
            s,
            -i,
            0,
            s,
            i,
            0,
            -i,
            0,
            -s,
            i,
            0,
            -s,
            -i,
            0,
            s,
            i,
            0,
            s
        ], [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ], t, e), this.type = "DodecahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$c0babfeb8708fc9c(t.radius, t.detail);
    }
}
const $4a792688e08e5cd7$var$wh = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Mh = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Sh = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$_h = new $4a792688e08e5cd7$export$5a465592bfe74b48;
class $4a792688e08e5cd7$export$4730b1542707547f extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = null, e = 1){
        if (super(), this.type = "EdgesGeometry", this.parameters = {
            geometry: t,
            thresholdAngle: e
        }, null !== t) {
            const i = 4, s = Math.pow(10, i), r = Math.cos($4a792688e08e5cd7$var$is * e), n = t.getIndex(), a = t.getAttribute("position"), o = n ? n.count : a.count, h = [
                0,
                0,
                0
            ], l = [
                "a",
                "b",
                "c"
            ], c = new Array(3), u = {}, d = [];
            for(let t = 0; t < o; t += 3){
                n ? (h[0] = n.getX(t), h[1] = n.getX(t + 1), h[2] = n.getX(t + 2)) : (h[0] = t, h[1] = t + 1, h[2] = t + 2);
                const { a: e, b: i, c: o } = $4a792688e08e5cd7$var$_h;
                if (e.fromBufferAttribute(a, h[0]), i.fromBufferAttribute(a, h[1]), o.fromBufferAttribute(a, h[2]), $4a792688e08e5cd7$var$_h.getNormal($4a792688e08e5cd7$var$Sh), c[0] = `${Math.round(e.x * s)},${Math.round(e.y * s)},${Math.round(e.z * s)}`, c[1] = `${Math.round(i.x * s)},${Math.round(i.y * s)},${Math.round(i.z * s)}`, c[2] = `${Math.round(o.x * s)},${Math.round(o.y * s)},${Math.round(o.z * s)}`, c[0] !== c[1] && c[1] !== c[2] && c[2] !== c[0]) for(let t = 0; t < 3; t++){
                    const e = (t + 1) % 3, i = c[t], s = c[e], n = $4a792688e08e5cd7$var$_h[l[t]], a = $4a792688e08e5cd7$var$_h[l[e]], o = `${i}_${s}`, p = `${s}_${i}`;
                    p in u && u[p] ? ($4a792688e08e5cd7$var$Sh.dot(u[p].normal) <= r && (d.push(n.x, n.y, n.z), d.push(a.x, a.y, a.z)), u[p] = null) : o in u || (u[o] = {
                        index0: h[t],
                        index1: h[e],
                        normal: $4a792688e08e5cd7$var$Sh.clone()
                    });
                }
            }
            for(const t in u)if (u[t]) {
                const { index0: e, index1: i } = u[t];
                $4a792688e08e5cd7$var$wh.fromBufferAttribute(a, e), $4a792688e08e5cd7$var$Mh.fromBufferAttribute(a, i), d.push($4a792688e08e5cd7$var$wh.x, $4a792688e08e5cd7$var$wh.y, $4a792688e08e5cd7$var$wh.z), d.push($4a792688e08e5cd7$var$Mh.x, $4a792688e08e5cd7$var$Mh.y, $4a792688e08e5cd7$var$Mh.z);
            }
            this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(d, 3));
        }
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
}
class $4a792688e08e5cd7$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve", this.arcLengthDivisions = 200, this.needsUpdate = !1, this.cacheArcLengths = null;
    }
    getPoint() {
        $4a792688e08e5cd7$export$c106dd0671a0fc2d("Curve: .getPoint() not implemented.");
    }
    getPointAt(t, e) {
        const i = this.getUtoTmapping(t);
        return this.getPoint(i, e);
    }
    getPoints(t = 5) {
        const e = [];
        for(let i = 0; i <= t; i++)e.push(this.getPoint(i / t));
        return e;
    }
    getSpacedPoints(t = 5) {
        const e = [];
        for(let i = 0; i <= t; i++)e.push(this.getPointAt(i / t));
        return e;
    }
    getLength() {
        const t = this.getLengths();
        return t[t.length - 1];
    }
    getLengths(t = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === t + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = !1;
        const e = [];
        let i, s = this.getPoint(0), r = 0;
        e.push(0);
        for(let n = 1; n <= t; n++)i = this.getPoint(n / t), r += i.distanceTo(s), e.push(r), s = i;
        return this.cacheArcLengths = e, e;
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.getLengths();
    }
    getUtoTmapping(t, e = null) {
        const i = this.getLengths();
        let s = 0;
        const r = i.length;
        let n;
        n = e || t * i[r - 1];
        let a, o = 0, h = r - 1;
        for(; o <= h;)if (s = Math.floor(o + (h - o) / 2), a = i[s] - n, a < 0) o = s + 1;
        else {
            if (!(a > 0)) {
                h = s;
                break;
            }
            h = s - 1;
        }
        if (s = h, i[s] === n) return s / (r - 1);
        const l = i[s];
        return (s + (n - l) / (i[s + 1] - l)) / (r - 1);
    }
    getTangent(t, e) {
        const i = 1e-4;
        let s = t - i, r = t + i;
        s < 0 && (s = 0), r > 1 && (r = 1);
        const n = this.getPoint(s), a = this.getPoint(r), o = e || (n.isVector2 ? new $4a792688e08e5cd7$export$c977b3e384af9ae1 : new $4a792688e08e5cd7$export$64b5c384219d3699);
        return o.copy(a).sub(n).normalize(), o;
    }
    getTangentAt(t, e) {
        const i = this.getUtoTmapping(t);
        return this.getTangent(i, e);
    }
    computeFrenetFrames(t, e = !1) {
        const i = new $4a792688e08e5cd7$export$64b5c384219d3699, s = [], r = [], n = [], a = new $4a792688e08e5cd7$export$64b5c384219d3699, o = new $4a792688e08e5cd7$export$2ae72fc923e5eb5;
        for(let e = 0; e <= t; e++){
            const i = e / t;
            s[e] = this.getTangentAt(i, new $4a792688e08e5cd7$export$64b5c384219d3699);
        }
        r[0] = new $4a792688e08e5cd7$export$64b5c384219d3699, n[0] = new $4a792688e08e5cd7$export$64b5c384219d3699;
        let h = Number.MAX_VALUE;
        const l = Math.abs(s[0].x), c = Math.abs(s[0].y), u = Math.abs(s[0].z);
        l <= h && (h = l, i.set(1, 0, 0)), c <= h && (h = c, i.set(0, 1, 0)), u <= h && i.set(0, 0, 1), a.crossVectors(s[0], i).normalize(), r[0].crossVectors(s[0], a), n[0].crossVectors(s[0], r[0]);
        for(let e = 1; e <= t; e++){
            if (r[e] = r[e - 1].clone(), n[e] = n[e - 1].clone(), a.crossVectors(s[e - 1], s[e]), a.length() > Number.EPSILON) {
                a.normalize();
                const t = Math.acos($4a792688e08e5cd7$var$ns(s[e - 1].dot(s[e]), -1, 1));
                r[e].applyMatrix4(o.makeRotationAxis(a, t));
            }
            n[e].crossVectors(s[e], r[e]);
        }
        if (!0 === e) {
            let e = Math.acos($4a792688e08e5cd7$var$ns(r[0].dot(r[t]), -1, 1));
            e /= t, s[0].dot(a.crossVectors(r[0], r[t])) > 0 && (e = -e);
            for(let i = 1; i <= t; i++)r[i].applyMatrix4(o.makeRotationAxis(s[i], e * i)), n[i].crossVectors(s[i], r[i]);
        }
        return {
            tangents: s,
            normals: r,
            binormals: n
        };
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
    toJSON() {
        const t = {
            metadata: {
                version: 4.7,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        return t.arcLengthDivisions = this.arcLengthDivisions, t.type = this.type, t;
    }
    fromJSON(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
}
class $4a792688e08e5cd7$export$3f87a931616cde04 extends $4a792688e08e5cd7$export$b0e83c3ef8d2db1 {
    constructor(t = 0, e = 0, i = 1, s = 1, r = 0, n = 2 * Math.PI, a = !1, o = 0){
        super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = t, this.aY = e, this.xRadius = i, this.yRadius = s, this.aStartAngle = r, this.aEndAngle = n, this.aClockwise = a, this.aRotation = o;
    }
    getPoint(t, e = new $4a792688e08e5cd7$export$c977b3e384af9ae1) {
        const i = e, s = 2 * Math.PI;
        let r = this.aEndAngle - this.aStartAngle;
        const n = Math.abs(r) < Number.EPSILON;
        for(; r < 0;)r += s;
        for(; r > s;)r -= s;
        r < Number.EPSILON && (r = n ? 0 : s), !0 !== this.aClockwise || n || (r === s ? r = -s : r -= s);
        const a = this.aStartAngle + t * r;
        let o = this.aX + this.xRadius * Math.cos(a), h = this.aY + this.yRadius * Math.sin(a);
        if (0 !== this.aRotation) {
            const t = Math.cos(this.aRotation), e = Math.sin(this.aRotation), i = o - this.aX, s = h - this.aY;
            o = i * t - s * e + this.aX, h = i * e + s * t + this.aY;
        }
        return i.set(o, h);
    }
    copy(t) {
        return super.copy(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
    toJSON() {
        const t = super.toJSON();
        return t.aX = this.aX, t.aY = this.aY, t.xRadius = this.xRadius, t.yRadius = this.yRadius, t.aStartAngle = this.aStartAngle, t.aEndAngle = this.aEndAngle, t.aClockwise = this.aClockwise, t.aRotation = this.aRotation, t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
}
class $4a792688e08e5cd7$export$b1eedc9aab6300e8 extends $4a792688e08e5cd7$export$3f87a931616cde04 {
    constructor(t, e, i, s, r, n){
        super(t, e, i, i, s, r, n), this.isArcCurve = !0, this.type = "ArcCurve";
    }
}
function $4a792688e08e5cd7$var$Ih() {
    let t = 0, e = 0, i = 0, s = 0;
    function r(r, n, a, o) {
        t = r, e = a, i = -3 * r + 3 * n - 2 * a - o, s = 2 * r - 2 * n + a + o;
    }
    return {
        initCatmullRom: function(t, e, i, s, n) {
            r(e, i, n * (i - t), n * (s - e));
        },
        initNonuniformCatmullRom: function(t, e, i, s, n, a, o) {
            let h = (e - t) / n - (i - t) / (n + a) + (i - e) / a, l = (i - e) / a - (s - e) / (a + o) + (s - i) / o;
            h *= a, l *= a, r(e, i, h, l);
        },
        calc: function(r) {
            const n = r * r;
            return t + e * r + i * n + s * (n * r);
        }
    };
}
const $4a792688e08e5cd7$var$Bh = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$kh = new $4a792688e08e5cd7$var$Ih, $4a792688e08e5cd7$var$Ph = new $4a792688e08e5cd7$var$Ih, $4a792688e08e5cd7$var$Oh = new $4a792688e08e5cd7$var$Ih;
class $4a792688e08e5cd7$export$b9146b27c24b744c extends $4a792688e08e5cd7$export$b0e83c3ef8d2db1 {
    constructor(t = [], e = !1, i = "centripetal", s = .5){
        super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = t, this.closed = e, this.curveType = i, this.tension = s;
    }
    getPoint(t, e = new $4a792688e08e5cd7$export$64b5c384219d3699) {
        const i = e, s = this.points, r = s.length, n = (r - (this.closed ? 0 : 1)) * t;
        let a, o, h = Math.floor(n), l = n - h;
        this.closed ? h += h > 0 ? 0 : (Math.floor(Math.abs(h) / r) + 1) * r : 0 === l && h === r - 1 && (h = r - 2, l = 1), this.closed || h > 0 ? a = s[(h - 1) % r] : ($4a792688e08e5cd7$var$Bh.subVectors(s[0], s[1]).add(s[0]), a = $4a792688e08e5cd7$var$Bh);
        const c = s[h % r], u = s[(h + 1) % r];
        if (this.closed || h + 2 < r ? o = s[(h + 2) % r] : ($4a792688e08e5cd7$var$Bh.subVectors(s[r - 1], s[r - 2]).add(s[r - 1]), o = $4a792688e08e5cd7$var$Bh), "centripetal" === this.curveType || "chordal" === this.curveType) {
            const t = "chordal" === this.curveType ? .5 : .25;
            let e = Math.pow(a.distanceToSquared(c), t), i = Math.pow(c.distanceToSquared(u), t), s = Math.pow(u.distanceToSquared(o), t);
            i < 1e-4 && (i = 1), e < 1e-4 && (e = i), s < 1e-4 && (s = i), $4a792688e08e5cd7$var$kh.initNonuniformCatmullRom(a.x, c.x, u.x, o.x, e, i, s), $4a792688e08e5cd7$var$Ph.initNonuniformCatmullRom(a.y, c.y, u.y, o.y, e, i, s), $4a792688e08e5cd7$var$Oh.initNonuniformCatmullRom(a.z, c.z, u.z, o.z, e, i, s);
        } else "catmullrom" === this.curveType && ($4a792688e08e5cd7$var$kh.initCatmullRom(a.x, c.x, u.x, o.x, this.tension), $4a792688e08e5cd7$var$Ph.initCatmullRom(a.y, c.y, u.y, o.y, this.tension), $4a792688e08e5cd7$var$Oh.initCatmullRom(a.z, c.z, u.z, o.z, this.tension));
        return i.set($4a792688e08e5cd7$var$kh.calc(l), $4a792688e08e5cd7$var$Ph.calc(l), $4a792688e08e5cd7$var$Oh.calc(l)), i;
    }
    copy(t) {
        super.copy(t), this.points = [];
        for(let e = 0, i = t.points.length; e < i; e++){
            const i = t.points[e];
            this.points.push(i.clone());
        }
        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
    toJSON() {
        const t = super.toJSON();
        t.points = [];
        for(let e = 0, i = this.points.length; e < i; e++){
            const i = this.points[e];
            t.points.push(i.toArray());
        }
        return t.closed = this.closed, t.curveType = this.curveType, t.tension = this.tension, t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.points = [];
        for(let e = 0, i = t.points.length; e < i; e++){
            const i = t.points[e];
            this.points.push((new $4a792688e08e5cd7$export$64b5c384219d3699).fromArray(i));
        }
        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
}
function $4a792688e08e5cd7$var$Nh(t, e, i, s, r) {
    const n = .5 * (s - e), a = .5 * (r - i), o = t * t;
    return (2 * i - 2 * s + n + a) * (t * o) + (-3 * i + 3 * s - 2 * n - a) * o + n * t + i;
}
function $4a792688e08e5cd7$var$Vh(t, e, i, s) {
    return function(t, e) {
        const i = 1 - t;
        return i * i * e;
    }(t, e) + function(t, e) {
        return 2 * (1 - t) * t * e;
    }(t, i) + function(t, e) {
        return t * t * e;
    }(t, s);
}
function $4a792688e08e5cd7$var$Fh(t, e, i, s, r) {
    return function(t, e) {
        const i = 1 - t;
        return i * i * i * e;
    }(t, e) + function(t, e) {
        const i = 1 - t;
        return 3 * i * i * t * e;
    }(t, i) + function(t, e) {
        return 3 * (1 - t) * t * t * e;
    }(t, s) + function(t, e) {
        return t * t * t * e;
    }(t, r);
}
class $4a792688e08e5cd7$export$e36650d36468bb39 extends $4a792688e08e5cd7$export$b0e83c3ef8d2db1 {
    constructor(t = new $4a792688e08e5cd7$export$c977b3e384af9ae1, e = new $4a792688e08e5cd7$export$c977b3e384af9ae1, i = new $4a792688e08e5cd7$export$c977b3e384af9ae1, s = new $4a792688e08e5cd7$export$c977b3e384af9ae1){
        super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = t, this.v1 = e, this.v2 = i, this.v3 = s;
    }
    getPoint(t, e = new $4a792688e08e5cd7$export$c977b3e384af9ae1) {
        const i = e, s = this.v0, r = this.v1, n = this.v2, a = this.v3;
        return i.set($4a792688e08e5cd7$var$Fh(t, s.x, r.x, n.x, a.x), $4a792688e08e5cd7$var$Fh(t, s.y, r.y, n.y, a.y)), i;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
    toJSON() {
        const t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
}
class $4a792688e08e5cd7$export$13d5f1c9525f246c extends $4a792688e08e5cd7$export$b0e83c3ef8d2db1 {
    constructor(t = new $4a792688e08e5cd7$export$64b5c384219d3699, e = new $4a792688e08e5cd7$export$64b5c384219d3699, i = new $4a792688e08e5cd7$export$64b5c384219d3699, s = new $4a792688e08e5cd7$export$64b5c384219d3699){
        super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = i, this.v3 = s;
    }
    getPoint(t, e = new $4a792688e08e5cd7$export$64b5c384219d3699) {
        const i = e, s = this.v0, r = this.v1, n = this.v2, a = this.v3;
        return i.set($4a792688e08e5cd7$var$Fh(t, s.x, r.x, n.x, a.x), $4a792688e08e5cd7$var$Fh(t, s.y, r.y, n.y, a.y), $4a792688e08e5cd7$var$Fh(t, s.z, r.z, n.z, a.z)), i;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
    toJSON() {
        const t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
}
class $4a792688e08e5cd7$export$ab2e07e76531a47e extends $4a792688e08e5cd7$export$b0e83c3ef8d2db1 {
    constructor(t = new $4a792688e08e5cd7$export$c977b3e384af9ae1, e = new $4a792688e08e5cd7$export$c977b3e384af9ae1){
        super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = t, this.v2 = e;
    }
    getPoint(t, e = new $4a792688e08e5cd7$export$c977b3e384af9ae1) {
        const i = e;
        return 1 === t ? i.copy(this.v2) : (i.copy(this.v2).sub(this.v1), i.multiplyScalar(t).add(this.v1)), i;
    }
    getPointAt(t, e) {
        return this.getPoint(t, e);
    }
    getTangent(t, e = new $4a792688e08e5cd7$export$c977b3e384af9ae1) {
        return e.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(t, e) {
        return this.getTangent(t, e);
    }
    copy(t) {
        return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        const t = super.toJSON();
        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}
class $4a792688e08e5cd7$export$1fdfd9d9cf487600 extends $4a792688e08e5cd7$export$b0e83c3ef8d2db1 {
    constructor(t = new $4a792688e08e5cd7$export$64b5c384219d3699, e = new $4a792688e08e5cd7$export$64b5c384219d3699){
        super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = t, this.v2 = e;
    }
    getPoint(t, e = new $4a792688e08e5cd7$export$64b5c384219d3699) {
        const i = e;
        return 1 === t ? i.copy(this.v2) : (i.copy(this.v2).sub(this.v1), i.multiplyScalar(t).add(this.v1)), i;
    }
    getPointAt(t, e) {
        return this.getPoint(t, e);
    }
    getTangent(t, e = new $4a792688e08e5cd7$export$64b5c384219d3699) {
        return e.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(t, e) {
        return this.getTangent(t, e);
    }
    copy(t) {
        return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        const t = super.toJSON();
        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}
class $4a792688e08e5cd7$export$5938c4ee491a43ad extends $4a792688e08e5cd7$export$b0e83c3ef8d2db1 {
    constructor(t = new $4a792688e08e5cd7$export$c977b3e384af9ae1, e = new $4a792688e08e5cd7$export$c977b3e384af9ae1, i = new $4a792688e08e5cd7$export$c977b3e384af9ae1){
        super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = t, this.v1 = e, this.v2 = i;
    }
    getPoint(t, e = new $4a792688e08e5cd7$export$c977b3e384af9ae1) {
        const i = e, s = this.v0, r = this.v1, n = this.v2;
        return i.set($4a792688e08e5cd7$var$Vh(t, s.x, r.x, n.x), $4a792688e08e5cd7$var$Vh(t, s.y, r.y, n.y)), i;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        const t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}
class $4a792688e08e5cd7$export$bf3f4c7e459f90fc extends $4a792688e08e5cd7$export$b0e83c3ef8d2db1 {
    constructor(t = new $4a792688e08e5cd7$export$64b5c384219d3699, e = new $4a792688e08e5cd7$export$64b5c384219d3699, i = new $4a792688e08e5cd7$export$64b5c384219d3699){
        super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = i;
    }
    getPoint(t, e = new $4a792688e08e5cd7$export$64b5c384219d3699) {
        const i = e, s = this.v0, r = this.v1, n = this.v2;
        return i.set($4a792688e08e5cd7$var$Vh(t, s.x, r.x, n.x), $4a792688e08e5cd7$var$Vh(t, s.y, r.y, n.y), $4a792688e08e5cd7$var$Vh(t, s.z, r.z, n.z)), i;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        const t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}
class $4a792688e08e5cd7$export$d3bdd77da77afc1b extends $4a792688e08e5cd7$export$b0e83c3ef8d2db1 {
    constructor(t = []){
        super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = t;
    }
    getPoint(t, e = new $4a792688e08e5cd7$export$c977b3e384af9ae1) {
        const i = e, s = this.points, r = (s.length - 1) * t, n = Math.floor(r), a = r - n, o = s[0 === n ? n : n - 1], h = s[n], l = s[n > s.length - 2 ? s.length - 1 : n + 1], c = s[n > s.length - 3 ? s.length - 1 : n + 2];
        return i.set($4a792688e08e5cd7$var$Nh(a, o.x, h.x, l.x, c.x), $4a792688e08e5cd7$var$Nh(a, o.y, h.y, l.y, c.y)), i;
    }
    copy(t) {
        super.copy(t), this.points = [];
        for(let e = 0, i = t.points.length; e < i; e++){
            const i = t.points[e];
            this.points.push(i.clone());
        }
        return this;
    }
    toJSON() {
        const t = super.toJSON();
        t.points = [];
        for(let e = 0, i = this.points.length; e < i; e++){
            const i = this.points[e];
            t.points.push(i.toArray());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.points = [];
        for(let e = 0, i = t.points.length; e < i; e++){
            const i = t.points[e];
            this.points.push((new $4a792688e08e5cd7$export$c977b3e384af9ae1).fromArray(i));
        }
        return this;
    }
}
var $4a792688e08e5cd7$var$Jh = Object.freeze({
    __proto__: null,
    ArcCurve: $4a792688e08e5cd7$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $4a792688e08e5cd7$export$b9146b27c24b744c,
    CubicBezierCurve: $4a792688e08e5cd7$export$e36650d36468bb39,
    CubicBezierCurve3: $4a792688e08e5cd7$export$13d5f1c9525f246c,
    EllipseCurve: $4a792688e08e5cd7$export$3f87a931616cde04,
    LineCurve: $4a792688e08e5cd7$export$ab2e07e76531a47e,
    LineCurve3: $4a792688e08e5cd7$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $4a792688e08e5cd7$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $4a792688e08e5cd7$export$bf3f4c7e459f90fc,
    SplineCurve: $4a792688e08e5cd7$export$d3bdd77da77afc1b
});
class $4a792688e08e5cd7$export$4aaf9b66af1bbf2c extends $4a792688e08e5cd7$export$b0e83c3ef8d2db1 {
    constructor(){
        super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
    }
    add(t) {
        this.curves.push(t);
    }
    closePath() {
        const t = this.curves[0].getPoint(0), e = this.curves[this.curves.length - 1].getPoint(1);
        if (!t.equals(e)) {
            const i = !0 === t.isVector2 ? "LineCurve" : "LineCurve3";
            this.curves.push(new $4a792688e08e5cd7$var$Jh[i](e, t));
        }
        return this;
    }
    getPoint(t, e) {
        const i = t * this.getLength(), s = this.getCurveLengths();
        let r = 0;
        for(; r < s.length;){
            if (s[r] >= i) {
                const t = s[r] - i, n = this.curves[r], a = n.getLength(), o = 0 === a ? 0 : 1 - t / a;
                return n.getPointAt(o, e);
            }
            r++;
        }
        return null;
    }
    getLength() {
        const t = this.getCurveLengths();
        return t[t.length - 1];
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
    }
    getCurveLengths() {
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        const t = [];
        let e = 0;
        for(let i = 0, s = this.curves.length; i < s; i++)e += this.curves[i].getLength(), t.push(e);
        return this.cacheLengths = t, t;
    }
    getSpacedPoints(t = 40) {
        const e = [];
        for(let i = 0; i <= t; i++)e.push(this.getPoint(i / t));
        return this.autoClose && e.push(e[0]), e;
    }
    getPoints(t = 12) {
        const e = [];
        let i;
        for(let s = 0, r = this.curves; s < r.length; s++){
            const n = r[s], a = n.isEllipseCurve ? 2 * t : n.isLineCurve || n.isLineCurve3 ? 1 : n.isSplineCurve ? t * n.points.length : t, o = n.getPoints(a);
            for(let t = 0; t < o.length; t++){
                const s = o[t];
                i && i.equals(s) || (e.push(s), i = s);
            }
        }
        return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
    copy(t) {
        super.copy(t), this.curves = [];
        for(let e = 0, i = t.curves.length; e < i; e++){
            const i = t.curves[e];
            this.curves.push(i.clone());
        }
        return this.autoClose = t.autoClose, this;
    }
    toJSON() {
        const t = super.toJSON();
        t.autoClose = this.autoClose, t.curves = [];
        for(let e = 0, i = this.curves.length; e < i; e++){
            const i = this.curves[e];
            t.curves.push(i.toJSON());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.autoClose = t.autoClose, this.curves = [];
        for(let e = 0, i = t.curves.length; e < i; e++){
            const i = t.curves[e];
            this.curves.push((new $4a792688e08e5cd7$var$Jh[i.type]).fromJSON(i));
        }
        return this;
    }
}
class $4a792688e08e5cd7$export$4b2950bdac9b6ee9 extends $4a792688e08e5cd7$export$4aaf9b66af1bbf2c {
    constructor(t){
        super(), this.type = "Path", this.currentPoint = new $4a792688e08e5cd7$export$c977b3e384af9ae1, t && this.setFromPoints(t);
    }
    setFromPoints(t) {
        this.moveTo(t[0].x, t[0].y);
        for(let e = 1, i = t.length; e < i; e++)this.lineTo(t[e].x, t[e].y);
        return this;
    }
    moveTo(t, e) {
        return this.currentPoint.set(t, e), this;
    }
    lineTo(t, e) {
        const i = new $4a792688e08e5cd7$export$ab2e07e76531a47e(this.currentPoint.clone(), new $4a792688e08e5cd7$export$c977b3e384af9ae1(t, e));
        return this.curves.push(i), this.currentPoint.set(t, e), this;
    }
    quadraticCurveTo(t, e, i, s) {
        const r = new $4a792688e08e5cd7$export$5938c4ee491a43ad(this.currentPoint.clone(), new $4a792688e08e5cd7$export$c977b3e384af9ae1(t, e), new $4a792688e08e5cd7$export$c977b3e384af9ae1(i, s));
        return this.curves.push(r), this.currentPoint.set(i, s), this;
    }
    bezierCurveTo(t, e, i, s, r, n) {
        const a = new $4a792688e08e5cd7$export$e36650d36468bb39(this.currentPoint.clone(), new $4a792688e08e5cd7$export$c977b3e384af9ae1(t, e), new $4a792688e08e5cd7$export$c977b3e384af9ae1(i, s), new $4a792688e08e5cd7$export$c977b3e384af9ae1(r, n));
        return this.curves.push(a), this.currentPoint.set(r, n), this;
    }
    splineThru(t) {
        const e = [
            this.currentPoint.clone()
        ].concat(t), i = new $4a792688e08e5cd7$export$d3bdd77da77afc1b(e);
        return this.curves.push(i), this.currentPoint.copy(t[t.length - 1]), this;
    }
    arc(t, e, i, s, r, n) {
        const a = this.currentPoint.x, o = this.currentPoint.y;
        return this.absarc(t + a, e + o, i, s, r, n), this;
    }
    absarc(t, e, i, s, r, n) {
        return this.absellipse(t, e, i, i, s, r, n), this;
    }
    ellipse(t, e, i, s, r, n, a, o) {
        const h = this.currentPoint.x, l = this.currentPoint.y;
        return this.absellipse(t + h, e + l, i, s, r, n, a, o), this;
    }
    absellipse(t, e, i, s, r, n, a, o) {
        const h = new $4a792688e08e5cd7$export$3f87a931616cde04(t, e, i, s, r, n, a, o);
        if (this.curves.length > 0) {
            const t = h.getPoint(0);
            t.equals(this.currentPoint) || this.lineTo(t.x, t.y);
        }
        this.curves.push(h);
        const l = h.getPoint(1);
        return this.currentPoint.copy(l), this;
    }
    copy(t) {
        return super.copy(t), this.currentPoint.copy(t.currentPoint), this;
    }
    toJSON() {
        const t = super.toJSON();
        return t.currentPoint = this.currentPoint.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.currentPoint.fromArray(t.currentPoint), this;
    }
}
class $4a792688e08e5cd7$export$6428a7f2611ef1fa extends $4a792688e08e5cd7$export$4b2950bdac9b6ee9 {
    constructor(t){
        super(t), this.uuid = $4a792688e08e5cd7$var$rs(), this.type = "Shape", this.holes = [];
    }
    getPointsHoles(t) {
        const e = [];
        for(let i = 0, s = this.holes.length; i < s; i++)e[i] = this.holes[i].getPoints(t);
        return e;
    }
    extractPoints(t) {
        return {
            shape: this.getPoints(t),
            holes: this.getPointsHoles(t)
        };
    }
    copy(t) {
        super.copy(t), this.holes = [];
        for(let e = 0, i = t.holes.length; e < i; e++){
            const i = t.holes[e];
            this.holes.push(i.clone());
        }
        return this;
    }
    toJSON() {
        const t = super.toJSON();
        t.uuid = this.uuid, t.holes = [];
        for(let e = 0, i = this.holes.length; e < i; e++){
            const i = this.holes[e];
            t.holes.push(i.toJSON());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.uuid = t.uuid, this.holes = [];
        for(let e = 0, i = t.holes.length; e < i; e++){
            const i = t.holes[e];
            this.holes.push((new $4a792688e08e5cd7$export$4b2950bdac9b6ee9).fromJSON(i));
        }
        return this;
    }
}
function $4a792688e08e5cd7$var$Hh(t, e, i = 2) {
    const s = e && e.length, r = s ? e[0] * i : t.length;
    let n = $4a792688e08e5cd7$var$Gh(t, 0, r, i, !0);
    const a = [];
    if (!n || n.next === n.prev) return a;
    let o, h, l;
    if (s && (n = function(t, e, i, s) {
        const r = [];
        for(let i = 0, n = e.length; i < n; i++){
            const a = $4a792688e08e5cd7$var$Gh(t, e[i] * s, i < n - 1 ? e[i + 1] * s : t.length, s, !1);
            a === a.next && (a.steiner = !0), r.push($4a792688e08e5cd7$var$ol(a));
        }
        r.sort($4a792688e08e5cd7$var$sl);
        for(let t = 0; t < r.length; t++)i = $4a792688e08e5cd7$var$rl(r[t], i);
        return i;
    }(t, e, n, i)), t.length > 80 * i) {
        o = t[0], h = t[1];
        let e = o, s = h;
        for(let n = i; n < r; n += i){
            const i = t[n], r = t[n + 1];
            i < o && (o = i), r < h && (h = r), i > e && (e = i), r > s && (s = r);
        }
        l = Math.max(e - o, s - h), l = 0 !== l ? 32767 / l : 0;
    }
    return $4a792688e08e5cd7$var$Qh(n, a, i, o, h, l, 0), a;
}
function $4a792688e08e5cd7$var$Gh(t, e, i, s, r) {
    let n;
    if (r === function(t, e, i, s) {
        let r = 0;
        for(let n = e, a = i - s; n < i; n += s)r += (t[a] - t[n]) * (t[n + 1] + t[a + 1]), a = n;
        return r;
    }(t, e, i, s) > 0) for(let r = e; r < i; r += s)n = $4a792688e08e5cd7$var$xl(r / s | 0, t[r], t[r + 1], n);
    else for(let r = i - s; r >= e; r -= s)n = $4a792688e08e5cd7$var$xl(r / s | 0, t[r], t[r + 1], n);
    return n && $4a792688e08e5cd7$var$dl(n, n.next) && ($4a792688e08e5cd7$var$bl(n), n = n.next), n;
}
function $4a792688e08e5cd7$var$$h(t, e) {
    if (!t) return t;
    e || (e = t);
    let i, s = t;
    do if (i = !1, s.steiner || !$4a792688e08e5cd7$var$dl(s, s.next) && 0 !== $4a792688e08e5cd7$var$ul(s.prev, s, s.next)) s = s.next;
    else {
        if ($4a792688e08e5cd7$var$bl(s), s = e = s.prev, s === s.next) break;
        i = !0;
    }
    while (i || s !== e);
    return e;
}
function $4a792688e08e5cd7$var$Qh(t, e, i, s, r, n, a) {
    if (!t) return;
    !a && n && function(t, e, i, s) {
        let r = t;
        do 0 === r.z && (r.z = $4a792688e08e5cd7$var$al(r.x, r.y, e, i, s)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
        while (r !== t);
        r.prevZ.nextZ = null, r.prevZ = null, function(t) {
            let e, i = 1;
            do {
                let s, r = t;
                t = null;
                let n = null;
                for(e = 0; r;){
                    e++;
                    let a = r, o = 0;
                    for(let t = 0; t < i && (o++, a = a.nextZ, a); t++);
                    let h = i;
                    for(; o > 0 || h > 0 && a;)0 !== o && (0 === h || !a || r.z <= a.z) ? (s = r, r = r.nextZ, o--) : (s = a, a = a.nextZ, h--), n ? n.nextZ = s : t = s, s.prevZ = n, n = s;
                    r = a;
                }
                n.nextZ = null, i *= 2;
            }while (e > 1);
        }(r);
    }(t, s, r, n);
    let o = t;
    for(; t.prev !== t.next;){
        const h = t.prev, l = t.next;
        if (n ? $4a792688e08e5cd7$var$tl(t, s, r, n) : $4a792688e08e5cd7$var$Kh(t)) e.push(h.i, t.i, l.i), $4a792688e08e5cd7$var$bl(t), t = l.next, o = l.next;
        else if ((t = l) === o) {
            a ? 1 === a ? $4a792688e08e5cd7$var$Qh(t = $4a792688e08e5cd7$var$el($4a792688e08e5cd7$var$$h(t), e), e, i, s, r, n, 2) : 2 === a && $4a792688e08e5cd7$var$il(t, e, i, s, r, n) : $4a792688e08e5cd7$var$Qh($4a792688e08e5cd7$var$$h(t), e, i, s, r, n, 1);
            break;
        }
    }
}
function $4a792688e08e5cd7$var$Kh(t) {
    const e = t.prev, i = t, s = t.next;
    if ($4a792688e08e5cd7$var$ul(e, i, s) >= 0) return !1;
    const r = e.x, n = i.x, a = s.x, o = e.y, h = i.y, l = s.y, c = Math.min(r, n, a), u = Math.min(o, h, l), d = Math.max(r, n, a), p = Math.max(o, h, l);
    let m = s.next;
    for(; m !== e;){
        if (m.x >= c && m.x <= d && m.y >= u && m.y <= p && $4a792688e08e5cd7$var$ll(r, o, n, h, a, l, m.x, m.y) && $4a792688e08e5cd7$var$ul(m.prev, m, m.next) >= 0) return !1;
        m = m.next;
    }
    return !0;
}
function $4a792688e08e5cd7$var$tl(t, e, i, s) {
    const r = t.prev, n = t, a = t.next;
    if ($4a792688e08e5cd7$var$ul(r, n, a) >= 0) return !1;
    const o = r.x, h = n.x, l = a.x, c = r.y, u = n.y, d = a.y, p = Math.min(o, h, l), m = Math.min(c, u, d), y = Math.max(o, h, l), g = Math.max(c, u, d), f = $4a792688e08e5cd7$var$al(p, m, e, i, s), x = $4a792688e08e5cd7$var$al(y, g, e, i, s);
    let b = t.prevZ, v = t.nextZ;
    for(; b && b.z >= f && v && v.z <= x;){
        if (b.x >= p && b.x <= y && b.y >= m && b.y <= g && b !== r && b !== a && $4a792688e08e5cd7$var$ll(o, c, h, u, l, d, b.x, b.y) && $4a792688e08e5cd7$var$ul(b.prev, b, b.next) >= 0) return !1;
        if (b = b.prevZ, v.x >= p && v.x <= y && v.y >= m && v.y <= g && v !== r && v !== a && $4a792688e08e5cd7$var$ll(o, c, h, u, l, d, v.x, v.y) && $4a792688e08e5cd7$var$ul(v.prev, v, v.next) >= 0) return !1;
        v = v.nextZ;
    }
    for(; b && b.z >= f;){
        if (b.x >= p && b.x <= y && b.y >= m && b.y <= g && b !== r && b !== a && $4a792688e08e5cd7$var$ll(o, c, h, u, l, d, b.x, b.y) && $4a792688e08e5cd7$var$ul(b.prev, b, b.next) >= 0) return !1;
        b = b.prevZ;
    }
    for(; v && v.z <= x;){
        if (v.x >= p && v.x <= y && v.y >= m && v.y <= g && v !== r && v !== a && $4a792688e08e5cd7$var$ll(o, c, h, u, l, d, v.x, v.y) && $4a792688e08e5cd7$var$ul(v.prev, v, v.next) >= 0) return !1;
        v = v.nextZ;
    }
    return !0;
}
function $4a792688e08e5cd7$var$el(t, e) {
    let i = t;
    do {
        const s = i.prev, r = i.next.next;
        !$4a792688e08e5cd7$var$dl(s, r) && $4a792688e08e5cd7$var$pl(s, i, i.next, r) && $4a792688e08e5cd7$var$gl(s, r) && $4a792688e08e5cd7$var$gl(r, s) && (e.push(s.i, i.i, r.i), $4a792688e08e5cd7$var$bl(i), $4a792688e08e5cd7$var$bl(i.next), i = t = r), i = i.next;
    }while (i !== t);
    return $4a792688e08e5cd7$var$$h(i);
}
function $4a792688e08e5cd7$var$il(t, e, i, s, r, n) {
    let a = t;
    do {
        let t = a.next.next;
        for(; t !== a.prev;){
            if (a.i !== t.i && $4a792688e08e5cd7$var$cl(a, t)) {
                let o = $4a792688e08e5cd7$var$fl(a, t);
                return a = $4a792688e08e5cd7$var$$h(a, a.next), o = $4a792688e08e5cd7$var$$h(o, o.next), $4a792688e08e5cd7$var$Qh(a, e, i, s, r, n, 0), void $4a792688e08e5cd7$var$Qh(o, e, i, s, r, n, 0);
            }
            t = t.next;
        }
        a = a.next;
    }while (a !== t);
}
function $4a792688e08e5cd7$var$sl(t, e) {
    let i = t.x - e.x;
    if (0 === i && (i = t.y - e.y, 0 === i)) i = (t.next.y - t.y) / (t.next.x - t.x) - (e.next.y - e.y) / (e.next.x - e.x);
    return i;
}
function $4a792688e08e5cd7$var$rl(t, e) {
    const i = function(t, e) {
        let i = e;
        const s = t.x, r = t.y;
        let n, a = -1 / 0;
        if ($4a792688e08e5cd7$var$dl(t, i)) return i;
        do {
            if ($4a792688e08e5cd7$var$dl(t, i.next)) return i.next;
            if (r <= i.y && r >= i.next.y && i.next.y !== i.y) {
                const t = i.x + (r - i.y) * (i.next.x - i.x) / (i.next.y - i.y);
                if (t <= s && t > a && (a = t, n = i.x < i.next.x ? i : i.next, t === s)) return n;
            }
            i = i.next;
        }while (i !== e);
        if (!n) return null;
        const o = n, h = n.x, l = n.y;
        let c = 1 / 0;
        i = n;
        do {
            if (s >= i.x && i.x >= h && s !== i.x && $4a792688e08e5cd7$var$hl(r < l ? s : a, r, h, l, r < l ? a : s, r, i.x, i.y)) {
                const e = Math.abs(r - i.y) / (s - i.x);
                $4a792688e08e5cd7$var$gl(i, t) && (e < c || e === c && (i.x > n.x || i.x === n.x && $4a792688e08e5cd7$var$nl(n, i))) && (n = i, c = e);
            }
            i = i.next;
        }while (i !== o);
        return n;
    }(t, e);
    if (!i) return e;
    const s = $4a792688e08e5cd7$var$fl(i, t);
    return $4a792688e08e5cd7$var$$h(s, s.next), $4a792688e08e5cd7$var$$h(i, i.next);
}
function $4a792688e08e5cd7$var$nl(t, e) {
    return $4a792688e08e5cd7$var$ul(t.prev, t, e.prev) < 0 && $4a792688e08e5cd7$var$ul(e.next, t, t.next) < 0;
}
function $4a792688e08e5cd7$var$al(t, e, i, s, r) {
    return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - i) * r | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - s) * r | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
}
function $4a792688e08e5cd7$var$ol(t) {
    let e = t, i = t;
    do (e.x < i.x || e.x === i.x && e.y < i.y) && (i = e), e = e.next;
    while (e !== t);
    return i;
}
function $4a792688e08e5cd7$var$hl(t, e, i, s, r, n, a, o) {
    return (r - a) * (e - o) >= (t - a) * (n - o) && (t - a) * (s - o) >= (i - a) * (e - o) && (i - a) * (n - o) >= (r - a) * (s - o);
}
function $4a792688e08e5cd7$var$ll(t, e, i, s, r, n, a, o) {
    return !(t === a && e === o) && $4a792688e08e5cd7$var$hl(t, e, i, s, r, n, a, o);
}
function $4a792688e08e5cd7$var$cl(t, e) {
    return t.next.i !== e.i && t.prev.i !== e.i && !function(t, e) {
        let i = t;
        do {
            if (i.i !== t.i && i.next.i !== t.i && i.i !== e.i && i.next.i !== e.i && $4a792688e08e5cd7$var$pl(i, i.next, t, e)) return !0;
            i = i.next;
        }while (i !== t);
        return !1;
    }(t, e) && ($4a792688e08e5cd7$var$gl(t, e) && $4a792688e08e5cd7$var$gl(e, t) && function(t, e) {
        let i = t, s = !1;
        const r = (t.x + e.x) / 2, n = (t.y + e.y) / 2;
        do i.y > n != i.next.y > n && i.next.y !== i.y && r < (i.next.x - i.x) * (n - i.y) / (i.next.y - i.y) + i.x && (s = !s), i = i.next;
        while (i !== t);
        return s;
    }(t, e) && ($4a792688e08e5cd7$var$ul(t.prev, t, e.prev) || $4a792688e08e5cd7$var$ul(t, e.prev, e)) || $4a792688e08e5cd7$var$dl(t, e) && $4a792688e08e5cd7$var$ul(t.prev, t, t.next) > 0 && $4a792688e08e5cd7$var$ul(e.prev, e, e.next) > 0);
}
function $4a792688e08e5cd7$var$ul(t, e, i) {
    return (e.y - t.y) * (i.x - e.x) - (e.x - t.x) * (i.y - e.y);
}
function $4a792688e08e5cd7$var$dl(t, e) {
    return t.x === e.x && t.y === e.y;
}
function $4a792688e08e5cd7$var$pl(t, e, i, s) {
    const r = $4a792688e08e5cd7$var$yl($4a792688e08e5cd7$var$ul(t, e, i)), n = $4a792688e08e5cd7$var$yl($4a792688e08e5cd7$var$ul(t, e, s)), a = $4a792688e08e5cd7$var$yl($4a792688e08e5cd7$var$ul(i, s, t)), o = $4a792688e08e5cd7$var$yl($4a792688e08e5cd7$var$ul(i, s, e));
    return r !== n && a !== o || !(0 !== r || !$4a792688e08e5cd7$var$ml(t, i, e)) || !(0 !== n || !$4a792688e08e5cd7$var$ml(t, s, e)) || !(0 !== a || !$4a792688e08e5cd7$var$ml(i, t, s)) || !(0 !== o || !$4a792688e08e5cd7$var$ml(i, e, s));
}
function $4a792688e08e5cd7$var$ml(t, e, i) {
    return e.x <= Math.max(t.x, i.x) && e.x >= Math.min(t.x, i.x) && e.y <= Math.max(t.y, i.y) && e.y >= Math.min(t.y, i.y);
}
function $4a792688e08e5cd7$var$yl(t) {
    return t > 0 ? 1 : t < 0 ? -1 : 0;
}
function $4a792688e08e5cd7$var$gl(t, e) {
    return $4a792688e08e5cd7$var$ul(t.prev, t, t.next) < 0 ? $4a792688e08e5cd7$var$ul(t, e, t.next) >= 0 && $4a792688e08e5cd7$var$ul(t, t.prev, e) >= 0 : $4a792688e08e5cd7$var$ul(t, e, t.prev) < 0 || $4a792688e08e5cd7$var$ul(t, t.next, e) < 0;
}
function $4a792688e08e5cd7$var$fl(t, e) {
    const i = $4a792688e08e5cd7$var$vl(t.i, t.x, t.y), s = $4a792688e08e5cd7$var$vl(e.i, e.x, e.y), r = t.next, n = e.prev;
    return t.next = e, e.prev = t, i.next = r, r.prev = i, s.next = i, i.prev = s, n.next = s, s.prev = n, s;
}
function $4a792688e08e5cd7$var$xl(t, e, i, s) {
    const r = $4a792688e08e5cd7$var$vl(t, e, i);
    return s ? (r.next = s.next, r.prev = s, s.next.prev = r, s.next = r) : (r.prev = r, r.next = r), r;
}
function $4a792688e08e5cd7$var$bl(t) {
    t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
}
function $4a792688e08e5cd7$var$vl(t, e, i) {
    return {
        i: t,
        x: e,
        y: i,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: !1
    };
}
class $4a792688e08e5cd7$var$wl {
    static triangulate(t, e, i = 2) {
        return $4a792688e08e5cd7$var$Hh(t, e, i);
    }
}
class $4a792688e08e5cd7$export$96bdf6d9c66d7ba8 {
    static area(t) {
        const e = t.length;
        let i = 0;
        for(let s = e - 1, r = 0; r < e; s = r++)i += t[s].x * t[r].y - t[r].x * t[s].y;
        return .5 * i;
    }
    static isClockWise(t) {
        return $4a792688e08e5cd7$export$96bdf6d9c66d7ba8.area(t) < 0;
    }
    static triangulateShape(t, e) {
        const i = [], s = [], r = [];
        $4a792688e08e5cd7$var$Sl(t), $4a792688e08e5cd7$var$_l(i, t);
        let n = t.length;
        e.forEach($4a792688e08e5cd7$var$Sl);
        for(let t = 0; t < e.length; t++)s.push(n), n += e[t].length, $4a792688e08e5cd7$var$_l(i, e[t]);
        const a = $4a792688e08e5cd7$var$wl.triangulate(i, s);
        for(let t = 0; t < a.length; t += 3)r.push(a.slice(t, t + 3));
        return r;
    }
}
function $4a792688e08e5cd7$var$Sl(t) {
    const e = t.length;
    e > 2 && t[e - 1].equals(t[0]) && t.pop();
}
function $4a792688e08e5cd7$var$_l(t, e) {
    for(let i = 0; i < e.length; i++)t.push(e[i].x), t.push(e[i].y);
}
class $4a792688e08e5cd7$export$598697a1efa63ca7 extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = new $4a792688e08e5cd7$export$6428a7f2611ef1fa([
        new $4a792688e08e5cd7$export$c977b3e384af9ae1(.5, .5),
        new $4a792688e08e5cd7$export$c977b3e384af9ae1(-0.5, .5),
        new $4a792688e08e5cd7$export$c977b3e384af9ae1(-0.5, -0.5),
        new $4a792688e08e5cd7$export$c977b3e384af9ae1(.5, -0.5)
    ]), e = {}){
        super(), this.type = "ExtrudeGeometry", this.parameters = {
            shapes: t,
            options: e
        }, t = Array.isArray(t) ? t : [
            t
        ];
        const i = this, s = [], r = [];
        for(let e = 0, i = t.length; e < i; e++)n(t[e]);
        function n(t) {
            const n = [], a = void 0 !== e.curveSegments ? e.curveSegments : 12, o = void 0 !== e.steps ? e.steps : 1, h = void 0 !== e.depth ? e.depth : 1;
            let l = void 0 === e.bevelEnabled || e.bevelEnabled, c = void 0 !== e.bevelThickness ? e.bevelThickness : .2, u = void 0 !== e.bevelSize ? e.bevelSize : c - .1, d = void 0 !== e.bevelOffset ? e.bevelOffset : 0, p = void 0 !== e.bevelSegments ? e.bevelSegments : 3;
            const m = e.extrudePath, y = void 0 !== e.UVGenerator ? e.UVGenerator : $4a792688e08e5cd7$var$Tl;
            let g, f, x, b, v, w = !1;
            m && (g = m.getSpacedPoints(o), w = !0, l = !1, f = m.computeFrenetFrames(o, !1), x = new $4a792688e08e5cd7$export$64b5c384219d3699, b = new $4a792688e08e5cd7$export$64b5c384219d3699, v = new $4a792688e08e5cd7$export$64b5c384219d3699), l || (p = 0, c = 0, u = 0, d = 0);
            const M = t.extractPoints(a);
            let S = M.shape;
            const _ = M.holes;
            if (!$4a792688e08e5cd7$export$96bdf6d9c66d7ba8.isClockWise(S)) {
                S = S.reverse();
                for(let t = 0, e = _.length; t < e; t++){
                    const e = _[t];
                    $4a792688e08e5cd7$export$96bdf6d9c66d7ba8.isClockWise(e) && (_[t] = e.reverse());
                }
            }
            function A(t) {
                const e = 1e-10 * 1e-10;
                let i = t[0];
                for(let s = 1; s <= t.length; s++){
                    const r = s % t.length, n = t[r], a = n.x - i.x, o = n.y - i.y, h = a * a + o * o, l = Math.max(Math.abs(n.x), Math.abs(n.y), Math.abs(i.x), Math.abs(i.y));
                    h <= e * l * l ? (t.splice(r, 1), s--) : i = n;
                }
            }
            A(S), _.forEach(A);
            const T = _.length, z = S;
            for(let t = 0; t < T; t++){
                const e = _[t];
                S = S.concat(e);
            }
            function C(t, e, i) {
                return e || $4a792688e08e5cd7$export$a3bc9b8ed74fc("ExtrudeGeometry: vec does not exist"), t.clone().addScaledVector(e, i);
            }
            const I = S.length;
            function B(t, e, i) {
                let s, r, n;
                const a = t.x - e.x, o = t.y - e.y, h = i.x - t.x, l = i.y - t.y, c = a * a + o * o, u = a * l - o * h;
                if (Math.abs(u) > Number.EPSILON) {
                    const u = Math.sqrt(c), d = Math.sqrt(h * h + l * l), p = e.x - o / u, m = e.y + a / u, y = ((i.x - l / d - p) * l - (i.y + h / d - m) * h) / (a * l - o * h);
                    s = p + a * y - t.x, r = m + o * y - t.y;
                    const g = s * s + r * r;
                    if (g <= 2) return new $4a792688e08e5cd7$export$c977b3e384af9ae1(s, r);
                    n = Math.sqrt(g / 2);
                } else {
                    let t = !1;
                    a > Number.EPSILON ? h > Number.EPSILON && (t = !0) : a < -Number.EPSILON ? h < -Number.EPSILON && (t = !0) : Math.sign(o) === Math.sign(l) && (t = !0), t ? (s = -o, r = a, n = Math.sqrt(c)) : (s = a, r = o, n = Math.sqrt(c / 2));
                }
                return new $4a792688e08e5cd7$export$c977b3e384af9ae1(s / n, r / n);
            }
            const k = [];
            for(let t = 0, e = z.length, i = e - 1, s = t + 1; t < e; t++, i++, s++)i === e && (i = 0), s === e && (s = 0), k[t] = B(z[t], z[i], z[s]);
            const P = [];
            let O, R, N = k.concat();
            for(let t = 0, e = T; t < e; t++){
                const e = _[t];
                O = [];
                for(let t = 0, i = e.length, s = i - 1, r = t + 1; t < i; t++, s++, r++)s === i && (s = 0), r === i && (r = 0), O[t] = B(e[t], e[s], e[r]);
                P.push(O), N = N.concat(O);
            }
            if (0 === p) R = $4a792688e08e5cd7$export$96bdf6d9c66d7ba8.triangulateShape(z, _);
            else {
                const t = [], e = [];
                for(let i = 0; i < p; i++){
                    const s = i / p, r = c * Math.cos(s * Math.PI / 2), n = u * Math.sin(s * Math.PI / 2) + d;
                    for(let e = 0, i = z.length; e < i; e++){
                        const i = C(z[e], k[e], n);
                        E(i.x, i.y, -r), 0 === s && t.push(i);
                    }
                    for(let t = 0, i = T; t < i; t++){
                        const i = _[t];
                        O = P[t];
                        const a = [];
                        for(let t = 0, e = i.length; t < e; t++){
                            const e = C(i[t], O[t], n);
                            E(e.x, e.y, -r), 0 === s && a.push(e);
                        }
                        0 === s && e.push(a);
                    }
                }
                R = $4a792688e08e5cd7$export$96bdf6d9c66d7ba8.triangulateShape(t, e);
            }
            const V = R.length, F = u + d;
            for(let t = 0; t < I; t++){
                const e = l ? C(S[t], N[t], F) : S[t];
                w ? (b.copy(f.normals[0]).multiplyScalar(e.x), x.copy(f.binormals[0]).multiplyScalar(e.y), v.copy(g[0]).add(b).add(x), E(v.x, v.y, v.z)) : E(e.x, e.y, 0);
            }
            for(let t = 1; t <= o; t++)for(let e = 0; e < I; e++){
                const i = l ? C(S[e], N[e], F) : S[e];
                w ? (b.copy(f.normals[t]).multiplyScalar(i.x), x.copy(f.binormals[t]).multiplyScalar(i.y), v.copy(g[t]).add(b).add(x), E(v.x, v.y, v.z)) : E(i.x, i.y, h / o * t);
            }
            for(let t = p - 1; t >= 0; t--){
                const e = t / p, i = c * Math.cos(e * Math.PI / 2), s = u * Math.sin(e * Math.PI / 2) + d;
                for(let t = 0, e = z.length; t < e; t++){
                    const e = C(z[t], k[t], s);
                    E(e.x, e.y, h + i);
                }
                for(let t = 0, e = _.length; t < e; t++){
                    const e = _[t];
                    O = P[t];
                    for(let t = 0, r = e.length; t < r; t++){
                        const r = C(e[t], O[t], s);
                        w ? E(r.x, r.y + g[o - 1].y, g[o - 1].x + i) : E(r.x, r.y, h + i);
                    }
                }
            }
            function L(t, e) {
                let i = t.length;
                for(; --i >= 0;){
                    const s = i;
                    let r = i - 1;
                    r < 0 && (r = t.length - 1);
                    for(let t = 0, i = o + 2 * p; t < i; t++){
                        const i = I * t, n = I * (t + 1);
                        D(e + s + i, e + r + i, e + r + n, e + s + n);
                    }
                }
            }
            function E(t, e, i) {
                n.push(t), n.push(e), n.push(i);
            }
            function j(t, e, r) {
                W(t), W(e), W(r);
                const n = s.length / 3, a = y.generateTopUV(i, s, n - 3, n - 2, n - 1);
                U(a[0]), U(a[1]), U(a[2]);
            }
            function D(t, e, r, n) {
                W(t), W(e), W(n), W(e), W(r), W(n);
                const a = s.length / 3, o = y.generateSideWallUV(i, s, a - 6, a - 3, a - 2, a - 1);
                U(o[0]), U(o[1]), U(o[3]), U(o[1]), U(o[2]), U(o[3]);
            }
            function W(t) {
                s.push(n[3 * t + 0]), s.push(n[3 * t + 1]), s.push(n[3 * t + 2]);
            }
            function U(t) {
                r.push(t.x), r.push(t.y);
            }
            !function() {
                const t = s.length / 3;
                if (l) {
                    let t = 0, e = I * t;
                    for(let t = 0; t < V; t++){
                        const i = R[t];
                        j(i[2] + e, i[1] + e, i[0] + e);
                    }
                    t = o + 2 * p, e = I * t;
                    for(let t = 0; t < V; t++){
                        const i = R[t];
                        j(i[0] + e, i[1] + e, i[2] + e);
                    }
                } else {
                    for(let t = 0; t < V; t++){
                        const e = R[t];
                        j(e[2], e[1], e[0]);
                    }
                    for(let t = 0; t < V; t++){
                        const e = R[t];
                        j(e[0] + I * o, e[1] + I * o, e[2] + I * o);
                    }
                }
                i.addGroup(t, s.length / 3 - t, 0);
            }(), function() {
                const t = s.length / 3;
                let e = 0;
                L(z, e), e += z.length;
                for(let t = 0, i = _.length; t < i; t++){
                    const i = _[t];
                    L(i, e), e += i.length;
                }
                i.addGroup(t, s.length / 3 - t, 1);
            }();
        }
        this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(s, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(r, 2)), this.computeVertexNormals();
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    toJSON() {
        const t = super.toJSON();
        return function(t, e, i) {
            if (i.shapes = [], Array.isArray(t)) for(let e = 0, s = t.length; e < s; e++){
                const s = t[e];
                i.shapes.push(s.uuid);
            }
            else i.shapes.push(t.uuid);
            i.options = Object.assign({}, e), void 0 !== e.extrudePath && (i.options.extrudePath = e.extrudePath.toJSON());
            return i;
        }(this.parameters.shapes, this.parameters.options, t);
    }
    static fromJSON(t, e) {
        const i = [];
        for(let s = 0, r = t.shapes.length; s < r; s++){
            const r = e[t.shapes[s]];
            i.push(r);
        }
        const s = t.options.extrudePath;
        return void 0 !== s && (t.options.extrudePath = (new $4a792688e08e5cd7$var$Jh[s.type]).fromJSON(s)), new $4a792688e08e5cd7$export$598697a1efa63ca7(i, t.options);
    }
}
const $4a792688e08e5cd7$var$Tl = {
    generateTopUV: function(t, e, i, s, r) {
        const n = e[3 * i], a = e[3 * i + 1], o = e[3 * s], h = e[3 * s + 1], l = e[3 * r], c = e[3 * r + 1];
        return [
            new $4a792688e08e5cd7$export$c977b3e384af9ae1(n, a),
            new $4a792688e08e5cd7$export$c977b3e384af9ae1(o, h),
            new $4a792688e08e5cd7$export$c977b3e384af9ae1(l, c)
        ];
    },
    generateSideWallUV: function(t, e, i, s, r, n) {
        const a = e[3 * i], o = e[3 * i + 1], h = e[3 * i + 2], l = e[3 * s], c = e[3 * s + 1], u = e[3 * s + 2], d = e[3 * r], p = e[3 * r + 1], m = e[3 * r + 2], y = e[3 * n], g = e[3 * n + 1], f = e[3 * n + 2];
        return Math.abs(o - c) < Math.abs(a - l) ? [
            new $4a792688e08e5cd7$export$c977b3e384af9ae1(a, 1 - h),
            new $4a792688e08e5cd7$export$c977b3e384af9ae1(l, 1 - u),
            new $4a792688e08e5cd7$export$c977b3e384af9ae1(d, 1 - m),
            new $4a792688e08e5cd7$export$c977b3e384af9ae1(y, 1 - f)
        ] : [
            new $4a792688e08e5cd7$export$c977b3e384af9ae1(o, 1 - h),
            new $4a792688e08e5cd7$export$c977b3e384af9ae1(c, 1 - u),
            new $4a792688e08e5cd7$export$c977b3e384af9ae1(p, 1 - m),
            new $4a792688e08e5cd7$export$c977b3e384af9ae1(g, 1 - f)
        ];
    }
};
class $4a792688e08e5cd7$export$9567cc828c9535da extends $4a792688e08e5cd7$export$60e57a7d3f20ff65 {
    constructor(t = 1, e = 0){
        const i = (1 + Math.sqrt(5)) / 2;
        super([
            -1,
            i,
            0,
            1,
            i,
            0,
            -1,
            -i,
            0,
            1,
            -i,
            0,
            0,
            -1,
            i,
            0,
            1,
            i,
            0,
            -1,
            -i,
            0,
            1,
            -i,
            i,
            0,
            -1,
            i,
            0,
            1,
            -i,
            0,
            -1,
            -i,
            0,
            1
        ], [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ], t, e), this.type = "IcosahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$9567cc828c9535da(t.radius, t.detail);
    }
}
class $4a792688e08e5cd7$export$6d839803fcd1882c extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = [
        new $4a792688e08e5cd7$export$c977b3e384af9ae1(0, -0.5),
        new $4a792688e08e5cd7$export$c977b3e384af9ae1(.5, 0),
        new $4a792688e08e5cd7$export$c977b3e384af9ae1(0, .5)
    ], e = 12, i = 0, s = 2 * Math.PI){
        super(), this.type = "LatheGeometry", this.parameters = {
            points: t,
            segments: e,
            phiStart: i,
            phiLength: s
        }, e = Math.floor(e), s = $4a792688e08e5cd7$var$ns(s, 0, 2 * Math.PI);
        const r = [], n = [], a = [], o = [], h = [], l = 1 / e, c = new $4a792688e08e5cd7$export$64b5c384219d3699, u = new $4a792688e08e5cd7$export$c977b3e384af9ae1, d = new $4a792688e08e5cd7$export$64b5c384219d3699, p = new $4a792688e08e5cd7$export$64b5c384219d3699, m = new $4a792688e08e5cd7$export$64b5c384219d3699;
        let y = 0, g = 0;
        for(let e = 0; e <= t.length - 1; e++)switch(e){
            case 0:
                y = t[e + 1].x - t[e].x, g = t[e + 1].y - t[e].y, d.x = 1 * g, d.y = -y, d.z = 0 * g, m.copy(d), d.normalize(), o.push(d.x, d.y, d.z);
                break;
            case t.length - 1:
                o.push(m.x, m.y, m.z);
                break;
            default:
                y = t[e + 1].x - t[e].x, g = t[e + 1].y - t[e].y, d.x = 1 * g, d.y = -y, d.z = 0 * g, p.copy(d), d.x += m.x, d.y += m.y, d.z += m.z, d.normalize(), o.push(d.x, d.y, d.z), m.copy(p);
        }
        for(let r = 0; r <= e; r++){
            const d = i + r * l * s, p = Math.sin(d), m = Math.cos(d);
            for(let i = 0; i <= t.length - 1; i++){
                c.x = t[i].x * p, c.y = t[i].y, c.z = t[i].x * m, n.push(c.x, c.y, c.z), u.x = r / e, u.y = i / (t.length - 1), a.push(u.x, u.y);
                const s = o[3 * i + 0] * p, l = o[3 * i + 1], d = o[3 * i + 0] * m;
                h.push(s, l, d);
            }
        }
        for(let i = 0; i < e; i++)for(let e = 0; e < t.length - 1; e++){
            const s = e + i * t.length, n = s, a = s + t.length, o = s + t.length + 1, h = s + 1;
            r.push(n, a, h), r.push(o, h, a);
        }
        this.setIndex(r), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(n, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(a, 2)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(h, 3));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$6d839803fcd1882c(t.points, t.segments, t.phiStart, t.phiLength);
    }
}
class $4a792688e08e5cd7$export$1954e2b809fe361e extends $4a792688e08e5cd7$export$60e57a7d3f20ff65 {
    constructor(t = 1, e = 0){
        super([
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ], [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ], t, e), this.type = "OctahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$1954e2b809fe361e(t.radius, t.detail);
    }
}
class $4a792688e08e5cd7$export$967d831af31f69ce extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = 1, e = 1, i = 1, s = 1){
        super(), this.type = "PlaneGeometry", this.parameters = {
            width: t,
            height: e,
            widthSegments: i,
            heightSegments: s
        };
        const r = t / 2, n = e / 2, a = Math.floor(i), o = Math.floor(s), h = a + 1, l = o + 1, c = t / a, u = e / o, d = [], p = [], m = [], y = [];
        for(let t = 0; t < l; t++){
            const e = t * u - n;
            for(let i = 0; i < h; i++){
                const s = i * c - r;
                p.push(s, -e, 0), m.push(0, 0, 1), y.push(i / a), y.push(1 - t / o);
            }
        }
        for(let t = 0; t < o; t++)for(let e = 0; e < a; e++){
            const i = e + h * t, s = e + h * (t + 1), r = e + 1 + h * (t + 1), n = e + 1 + h * t;
            d.push(i, s, n), d.push(s, r, n);
        }
        this.setIndex(d), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(p, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(m, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(y, 2));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$967d831af31f69ce(t.width, t.height, t.widthSegments, t.heightSegments);
    }
}
class $4a792688e08e5cd7$export$68cb731f50f614af extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = .5, e = 1, i = 32, s = 1, r = 0, n = 2 * Math.PI){
        super(), this.type = "RingGeometry", this.parameters = {
            innerRadius: t,
            outerRadius: e,
            thetaSegments: i,
            phiSegments: s,
            thetaStart: r,
            thetaLength: n
        }, i = Math.max(3, i);
        const a = [], o = [], h = [], l = [];
        let c = t;
        const u = (e - t) / (s = Math.max(1, s)), d = new $4a792688e08e5cd7$export$64b5c384219d3699, p = new $4a792688e08e5cd7$export$c977b3e384af9ae1;
        for(let t = 0; t <= s; t++){
            for(let t = 0; t <= i; t++){
                const s = r + t / i * n;
                d.x = c * Math.cos(s), d.y = c * Math.sin(s), o.push(d.x, d.y, d.z), h.push(0, 0, 1), p.x = (d.x / e + 1) / 2, p.y = (d.y / e + 1) / 2, l.push(p.x, p.y);
            }
            c += u;
        }
        for(let t = 0; t < s; t++){
            const e = t * (i + 1);
            for(let t = 0; t < i; t++){
                const s = t + e, r = s, n = s + i + 1, o = s + i + 2, h = s + 1;
                a.push(r, n, h), a.push(n, o, h);
            }
        }
        this.setIndex(a), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(o, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(h, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(l, 2));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$68cb731f50f614af(t.innerRadius, t.outerRadius, t.thetaSegments, t.phiSegments, t.thetaStart, t.thetaLength);
    }
}
class $4a792688e08e5cd7$export$57a29a1c803e9065 extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = new $4a792688e08e5cd7$export$6428a7f2611ef1fa([
        new $4a792688e08e5cd7$export$c977b3e384af9ae1(0, .5),
        new $4a792688e08e5cd7$export$c977b3e384af9ae1(-0.5, -0.5),
        new $4a792688e08e5cd7$export$c977b3e384af9ae1(.5, -0.5)
    ]), e = 12){
        super(), this.type = "ShapeGeometry", this.parameters = {
            shapes: t,
            curveSegments: e
        };
        const i = [], s = [], r = [], n = [];
        let a = 0, o = 0;
        if (!1 === Array.isArray(t)) h(t);
        else for(let e = 0; e < t.length; e++)h(t[e]), this.addGroup(a, o, e), a += o, o = 0;
        function h(t) {
            const a = s.length / 3, h = t.extractPoints(e);
            let l = h.shape;
            const c = h.holes;
            !1 === $4a792688e08e5cd7$export$96bdf6d9c66d7ba8.isClockWise(l) && (l = l.reverse());
            for(let t = 0, e = c.length; t < e; t++){
                const e = c[t];
                !0 === $4a792688e08e5cd7$export$96bdf6d9c66d7ba8.isClockWise(e) && (c[t] = e.reverse());
            }
            const u = $4a792688e08e5cd7$export$96bdf6d9c66d7ba8.triangulateShape(l, c);
            for(let t = 0, e = c.length; t < e; t++){
                const e = c[t];
                l = l.concat(e);
            }
            for(let t = 0, e = l.length; t < e; t++){
                const e = l[t];
                s.push(e.x, e.y, 0), r.push(0, 0, 1), n.push(e.x, e.y);
            }
            for(let t = 0, e = u.length; t < e; t++){
                const e = u[t], s = e[0] + a, r = e[1] + a, n = e[2] + a;
                i.push(s, r, n), o += 3;
            }
        }
        this.setIndex(i), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(s, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(r, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(n, 2));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    toJSON() {
        const t = super.toJSON();
        return function(t, e) {
            if (e.shapes = [], Array.isArray(t)) for(let i = 0, s = t.length; i < s; i++){
                const s = t[i];
                e.shapes.push(s.uuid);
            }
            else e.shapes.push(t.uuid);
            return e;
        }(this.parameters.shapes, t);
    }
    static fromJSON(t, e) {
        const i = [];
        for(let s = 0, r = t.shapes.length; s < r; s++){
            const r = e[t.shapes[s]];
            i.push(r);
        }
        return new $4a792688e08e5cd7$export$57a29a1c803e9065(i, t.curveSegments);
    }
}
class $4a792688e08e5cd7$export$1b417fc3b307a251 extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = 1, e = 32, i = 16, s = 0, r = 2 * Math.PI, n = 0, a = Math.PI){
        super(), this.type = "SphereGeometry", this.parameters = {
            radius: t,
            widthSegments: e,
            heightSegments: i,
            phiStart: s,
            phiLength: r,
            thetaStart: n,
            thetaLength: a
        }, e = Math.max(3, Math.floor(e)), i = Math.max(2, Math.floor(i));
        const o = Math.min(n + a, Math.PI);
        let h = 0;
        const l = [], c = new $4a792688e08e5cd7$export$64b5c384219d3699, u = new $4a792688e08e5cd7$export$64b5c384219d3699, d = [], p = [], m = [], y = [];
        for(let d = 0; d <= i; d++){
            const g = [], f = d / i;
            let x = 0;
            0 === d && 0 === n ? x = .5 / e : d === i && o === Math.PI && (x = -0.5 / e);
            for(let i = 0; i <= e; i++){
                const o = i / e;
                c.x = -t * Math.cos(s + o * r) * Math.sin(n + f * a), c.y = t * Math.cos(n + f * a), c.z = t * Math.sin(s + o * r) * Math.sin(n + f * a), p.push(c.x, c.y, c.z), u.copy(c).normalize(), m.push(u.x, u.y, u.z), y.push(o + x, 1 - f), g.push(h++);
            }
            l.push(g);
        }
        for(let t = 0; t < i; t++)for(let s = 0; s < e; s++){
            const e = l[t][s + 1], r = l[t][s], a = l[t + 1][s], h = l[t + 1][s + 1];
            (0 !== t || n > 0) && d.push(e, r, h), (t !== i - 1 || o < Math.PI) && d.push(r, a, h);
        }
        this.setIndex(d), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(p, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(m, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(y, 2));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$1b417fc3b307a251(t.radius, t.widthSegments, t.heightSegments, t.phiStart, t.phiLength, t.thetaStart, t.thetaLength);
    }
}
class $4a792688e08e5cd7$export$fb3f7adc68bd6e02 extends $4a792688e08e5cd7$export$60e57a7d3f20ff65 {
    constructor(t = 1, e = 0){
        super([
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ], [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ], t, e), this.type = "TetrahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$fb3f7adc68bd6e02(t.radius, t.detail);
    }
}
class $4a792688e08e5cd7$export$a2312a2a1fa56495 extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = 1, e = .4, i = 12, s = 48, r = 2 * Math.PI){
        super(), this.type = "TorusGeometry", this.parameters = {
            radius: t,
            tube: e,
            radialSegments: i,
            tubularSegments: s,
            arc: r
        }, i = Math.floor(i), s = Math.floor(s);
        const n = [], a = [], o = [], h = [], l = new $4a792688e08e5cd7$export$64b5c384219d3699, c = new $4a792688e08e5cd7$export$64b5c384219d3699, u = new $4a792688e08e5cd7$export$64b5c384219d3699;
        for(let n = 0; n <= i; n++)for(let d = 0; d <= s; d++){
            const p = d / s * r, m = n / i * Math.PI * 2;
            c.x = (t + e * Math.cos(m)) * Math.cos(p), c.y = (t + e * Math.cos(m)) * Math.sin(p), c.z = e * Math.sin(m), a.push(c.x, c.y, c.z), l.x = t * Math.cos(p), l.y = t * Math.sin(p), u.subVectors(c, l).normalize(), o.push(u.x, u.y, u.z), h.push(d / s), h.push(n / i);
        }
        for(let t = 1; t <= i; t++)for(let e = 1; e <= s; e++){
            const i = (s + 1) * t + e - 1, r = (s + 1) * (t - 1) + e - 1, a = (s + 1) * (t - 1) + e, o = (s + 1) * t + e;
            n.push(i, r, o), n.push(r, a, o);
        }
        this.setIndex(n), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(a, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(o, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(h, 2));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$a2312a2a1fa56495(t.radius, t.tube, t.radialSegments, t.tubularSegments, t.arc);
    }
}
class $4a792688e08e5cd7$export$77e9bfadfb9ab8c8 extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = 1, e = .4, i = 64, s = 8, r = 2, n = 3){
        super(), this.type = "TorusKnotGeometry", this.parameters = {
            radius: t,
            tube: e,
            tubularSegments: i,
            radialSegments: s,
            p: r,
            q: n
        }, i = Math.floor(i), s = Math.floor(s);
        const a = [], o = [], h = [], l = [], c = new $4a792688e08e5cd7$export$64b5c384219d3699, u = new $4a792688e08e5cd7$export$64b5c384219d3699, d = new $4a792688e08e5cd7$export$64b5c384219d3699, p = new $4a792688e08e5cd7$export$64b5c384219d3699, m = new $4a792688e08e5cd7$export$64b5c384219d3699, y = new $4a792688e08e5cd7$export$64b5c384219d3699, g = new $4a792688e08e5cd7$export$64b5c384219d3699;
        for(let a = 0; a <= i; ++a){
            const x = a / i * r * Math.PI * 2;
            f(x, r, n, t, d), f(x + .01, r, n, t, p), y.subVectors(p, d), g.addVectors(p, d), m.crossVectors(y, g), g.crossVectors(m, y), m.normalize(), g.normalize();
            for(let t = 0; t <= s; ++t){
                const r = t / s * Math.PI * 2, n = -e * Math.cos(r), p = e * Math.sin(r);
                c.x = d.x + (n * g.x + p * m.x), c.y = d.y + (n * g.y + p * m.y), c.z = d.z + (n * g.z + p * m.z), o.push(c.x, c.y, c.z), u.subVectors(c, d).normalize(), h.push(u.x, u.y, u.z), l.push(a / i), l.push(t / s);
            }
        }
        for(let t = 1; t <= i; t++)for(let e = 1; e <= s; e++){
            const i = (s + 1) * (t - 1) + (e - 1), r = (s + 1) * t + (e - 1), n = (s + 1) * t + e, o = (s + 1) * (t - 1) + e;
            a.push(i, r, o), a.push(r, n, o);
        }
        function f(t, e, i, s, r) {
            const n = Math.cos(t), a = Math.sin(t), o = i / e * t, h = Math.cos(o);
            r.x = s * (2 + h) * .5 * n, r.y = s * (2 + h) * a * .5, r.z = s * Math.sin(o) * .5;
        }
        this.setIndex(a), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(o, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(h, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(l, 2));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$77e9bfadfb9ab8c8(t.radius, t.tube, t.tubularSegments, t.radialSegments, t.p, t.q);
    }
}
class $4a792688e08e5cd7$export$7897d9d48904490c extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = new $4a792688e08e5cd7$export$bf3f4c7e459f90fc(new $4a792688e08e5cd7$export$64b5c384219d3699(-1, -1, 0), new $4a792688e08e5cd7$export$64b5c384219d3699(-1, 1, 0), new $4a792688e08e5cd7$export$64b5c384219d3699(1, 1, 0)), e = 64, i = 1, s = 8, r = !1){
        super(), this.type = "TubeGeometry", this.parameters = {
            path: t,
            tubularSegments: e,
            radius: i,
            radialSegments: s,
            closed: r
        };
        const n = t.computeFrenetFrames(e, r);
        this.tangents = n.tangents, this.normals = n.normals, this.binormals = n.binormals;
        const a = new $4a792688e08e5cd7$export$64b5c384219d3699, o = new $4a792688e08e5cd7$export$64b5c384219d3699, h = new $4a792688e08e5cd7$export$c977b3e384af9ae1;
        let l = new $4a792688e08e5cd7$export$64b5c384219d3699;
        const c = [], u = [], d = [], p = [];
        function m(r) {
            l = t.getPointAt(r / e, l);
            const h = n.normals[r], d = n.binormals[r];
            for(let t = 0; t <= s; t++){
                const e = t / s * Math.PI * 2, r = Math.sin(e), n = -Math.cos(e);
                o.x = n * h.x + r * d.x, o.y = n * h.y + r * d.y, o.z = n * h.z + r * d.z, o.normalize(), u.push(o.x, o.y, o.z), a.x = l.x + i * o.x, a.y = l.y + i * o.y, a.z = l.z + i * o.z, c.push(a.x, a.y, a.z);
            }
        }
        !function() {
            for(let t = 0; t < e; t++)m(t);
            m(!1 === r ? e : 0), function() {
                for(let t = 0; t <= e; t++)for(let i = 0; i <= s; i++)h.x = t / e, h.y = i / s, d.push(h.x, h.y);
            }(), function() {
                for(let t = 1; t <= e; t++)for(let e = 1; e <= s; e++){
                    const i = (s + 1) * (t - 1) + (e - 1), r = (s + 1) * t + (e - 1), n = (s + 1) * t + e, a = (s + 1) * (t - 1) + e;
                    p.push(i, r, a), p.push(r, n, a);
                }
            }();
        }(), this.setIndex(p), this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(c, 3)), this.setAttribute("normal", new $4a792688e08e5cd7$export$cbe7a62641830ebd(u, 3)), this.setAttribute("uv", new $4a792688e08e5cd7$export$cbe7a62641830ebd(d, 2));
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
    toJSON() {
        const t = super.toJSON();
        return t.path = this.parameters.path.toJSON(), t;
    }
    static fromJSON(t) {
        return new $4a792688e08e5cd7$export$7897d9d48904490c((new $4a792688e08e5cd7$var$Jh[t.path.type]).fromJSON(t.path), t.tubularSegments, t.radius, t.radialSegments, t.closed);
    }
}
class $4a792688e08e5cd7$export$4b739da06d24892b extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(t = null){
        if (super(), this.type = "WireframeGeometry", this.parameters = {
            geometry: t
        }, null !== t) {
            const e = [], i = new Set, s = new $4a792688e08e5cd7$export$64b5c384219d3699, r = new $4a792688e08e5cd7$export$64b5c384219d3699;
            if (null !== t.index) {
                const n = t.attributes.position, a = t.index;
                let o = t.groups;
                0 === o.length && (o = [
                    {
                        start: 0,
                        count: a.count,
                        materialIndex: 0
                    }
                ]);
                for(let t = 0, h = o.length; t < h; ++t){
                    const h = o[t], l = h.start;
                    for(let t = l, o = l + h.count; t < o; t += 3)for(let o = 0; o < 3; o++){
                        const h = a.getX(t + o), l = a.getX(t + (o + 1) % 3);
                        s.fromBufferAttribute(n, h), r.fromBufferAttribute(n, l), !0 === $4a792688e08e5cd7$var$El(s, r, i) && (e.push(s.x, s.y, s.z), e.push(r.x, r.y, r.z));
                    }
                }
            } else {
                const n = t.attributes.position;
                for(let t = 0, a = n.count / 3; t < a; t++)for(let a = 0; a < 3; a++){
                    const o = 3 * t + a, h = 3 * t + (a + 1) % 3;
                    s.fromBufferAttribute(n, o), r.fromBufferAttribute(n, h), !0 === $4a792688e08e5cd7$var$El(s, r, i) && (e.push(s.x, s.y, s.z), e.push(r.x, r.y, r.z));
                }
            }
            this.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(e, 3));
        }
    }
    copy(t) {
        return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
    }
}
function $4a792688e08e5cd7$var$El(t, e, i) {
    const s = `${t.x},${t.y},${t.z}-${e.x},${e.y},${e.z}`, r = `${e.x},${e.y},${e.z}-${t.x},${t.y},${t.z}`;
    return !0 !== i.has(s) && !0 !== i.has(r) && (i.add(s), i.add(r), !0);
}
var $4a792688e08e5cd7$var$jl = Object.freeze({
    __proto__: null,
    BoxGeometry: $4a792688e08e5cd7$export$33e43285f7406bd5,
    CapsuleGeometry: $4a792688e08e5cd7$export$41680e8551036033,
    CircleGeometry: $4a792688e08e5cd7$export$d5c0e8d607467193,
    ConeGeometry: $4a792688e08e5cd7$export$a7a48974f285c9b3,
    CylinderGeometry: $4a792688e08e5cd7$export$68f745719dbe5198,
    DodecahedronGeometry: $4a792688e08e5cd7$export$c0babfeb8708fc9c,
    EdgesGeometry: $4a792688e08e5cd7$export$4730b1542707547f,
    ExtrudeGeometry: $4a792688e08e5cd7$export$598697a1efa63ca7,
    IcosahedronGeometry: $4a792688e08e5cd7$export$9567cc828c9535da,
    LatheGeometry: $4a792688e08e5cd7$export$6d839803fcd1882c,
    OctahedronGeometry: $4a792688e08e5cd7$export$1954e2b809fe361e,
    PlaneGeometry: $4a792688e08e5cd7$export$967d831af31f69ce,
    PolyhedronGeometry: $4a792688e08e5cd7$export$60e57a7d3f20ff65,
    RingGeometry: $4a792688e08e5cd7$export$68cb731f50f614af,
    ShapeGeometry: $4a792688e08e5cd7$export$57a29a1c803e9065,
    SphereGeometry: $4a792688e08e5cd7$export$1b417fc3b307a251,
    TetrahedronGeometry: $4a792688e08e5cd7$export$fb3f7adc68bd6e02,
    TorusGeometry: $4a792688e08e5cd7$export$a2312a2a1fa56495,
    TorusKnotGeometry: $4a792688e08e5cd7$export$77e9bfadfb9ab8c8,
    TubeGeometry: $4a792688e08e5cd7$export$7897d9d48904490c,
    WireframeGeometry: $4a792688e08e5cd7$export$4b739da06d24892b
});
class $4a792688e08e5cd7$export$e8564da406055a3 extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isShadowMaterial = !0, this.type = "ShadowMaterial", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(0), this.transparent = !0, this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.fog = t.fog, this;
    }
}
class $4a792688e08e5cd7$export$21c421a2e1df9d22 extends $4a792688e08e5cd7$export$83c7d75d550a8b0d {
    constructor(t){
        super(t), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
    }
}
class $4a792688e08e5cd7$export$f2980790215acccd extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isMeshStandardMaterial = !0, this.type = "MeshStandardMaterial", this.defines = {
            STANDARD: ""
        }, this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $4a792688e08e5cd7$export$892596cec99bc70e(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new $4a792688e08e5cd7$export$c977b3e384af9ae1(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $4a792688e08e5cd7$export$d93cc409a0768c5f, this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.defines = {
            STANDARD: ""
        }, this.color.copy(t.color), this.roughness = t.roughness, this.metalness = t.metalness, this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.roughnessMap = t.roughnessMap, this.metalnessMap = t.metalnessMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapRotation.copy(t.envMapRotation), this.envMapIntensity = t.envMapIntensity, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this.fog = t.fog, this;
    }
}
class $4a792688e08e5cd7$export$28d04986c4269c9f extends $4a792688e08e5cd7$export$f2980790215acccd {
    constructor(t){
        super(), this.isMeshPhysicalMaterial = !0, this.defines = {
            STANDARD: "",
            PHYSICAL: ""
        }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new $4a792688e08e5cd7$export$c977b3e384af9ae1(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $4a792688e08e5cd7$var$ns(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(t) {
                this.ior = (1 + .4 * t) / (1 - .4 * t);
            }
        }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [
            100,
            400
        ], this.iridescenceThicknessMap = null, this.sheenColor = new $4a792688e08e5cd7$export$892596cec99bc70e(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new $4a792688e08e5cd7$export$892596cec99bc70e(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new $4a792688e08e5cd7$export$892596cec99bc70e(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._dispersion = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(t);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(t) {
        this._anisotropy > 0 != t > 0 && this.version++, this._anisotropy = t;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(t) {
        this._clearcoat > 0 != t > 0 && this.version++, this._clearcoat = t;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(t) {
        this._iridescence > 0 != t > 0 && this.version++, this._iridescence = t;
    }
    get dispersion() {
        return this._dispersion;
    }
    set dispersion(t) {
        this._dispersion > 0 != t > 0 && this.version++, this._dispersion = t;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(t) {
        this._sheen > 0 != t > 0 && this.version++, this._sheen = t;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(t) {
        this._transmission > 0 != t > 0 && this.version++, this._transmission = t;
    }
    copy(t) {
        return super.copy(t), this.defines = {
            STANDARD: "",
            PHYSICAL: ""
        }, this.anisotropy = t.anisotropy, this.anisotropyRotation = t.anisotropyRotation, this.anisotropyMap = t.anisotropyMap, this.clearcoat = t.clearcoat, this.clearcoatMap = t.clearcoatMap, this.clearcoatRoughness = t.clearcoatRoughness, this.clearcoatRoughnessMap = t.clearcoatRoughnessMap, this.clearcoatNormalMap = t.clearcoatNormalMap, this.clearcoatNormalScale.copy(t.clearcoatNormalScale), this.dispersion = t.dispersion, this.ior = t.ior, this.iridescence = t.iridescence, this.iridescenceMap = t.iridescenceMap, this.iridescenceIOR = t.iridescenceIOR, this.iridescenceThicknessRange = [
            ...t.iridescenceThicknessRange
        ], this.iridescenceThicknessMap = t.iridescenceThicknessMap, this.sheen = t.sheen, this.sheenColor.copy(t.sheenColor), this.sheenColorMap = t.sheenColorMap, this.sheenRoughness = t.sheenRoughness, this.sheenRoughnessMap = t.sheenRoughnessMap, this.transmission = t.transmission, this.transmissionMap = t.transmissionMap, this.thickness = t.thickness, this.thicknessMap = t.thicknessMap, this.attenuationDistance = t.attenuationDistance, this.attenuationColor.copy(t.attenuationColor), this.specularIntensity = t.specularIntensity, this.specularIntensityMap = t.specularIntensityMap, this.specularColor.copy(t.specularColor), this.specularColorMap = t.specularColorMap, this;
    }
}
class $4a792688e08e5cd7$export$24c72f71cbaf0678 extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(16777215), this.specular = new $4a792688e08e5cd7$export$892596cec99bc70e(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $4a792688e08e5cd7$export$892596cec99bc70e(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new $4a792688e08e5cd7$export$c977b3e384af9ae1(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $4a792688e08e5cd7$export$d93cc409a0768c5f, this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.specular.copy(t.specular), this.shininess = t.shininess, this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapRotation.copy(t.envMapRotation), this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this.fog = t.fog, this;
    }
}
class $4a792688e08e5cd7$export$df893cf97e765622 extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isMeshToonMaterial = !0, this.defines = {
            TOON: ""
        }, this.type = "MeshToonMaterial", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(16777215), this.map = null, this.gradientMap = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $4a792688e08e5cd7$export$892596cec99bc70e(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new $4a792688e08e5cd7$export$c977b3e384af9ae1(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.map = t.map, this.gradientMap = t.gradientMap, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.alphaMap = t.alphaMap, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.fog = t.fog, this;
    }
}
class $4a792688e08e5cd7$export$bfe8c0a091f41ae7 extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isMeshNormalMaterial = !0, this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new $4a792688e08e5cd7$export$c977b3e384af9ae1(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.flatShading = t.flatShading, this;
    }
}
class $4a792688e08e5cd7$export$5023a9a8114806b8 extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $4a792688e08e5cd7$export$892596cec99bc70e(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new $4a792688e08e5cd7$export$c977b3e384af9ae1(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $4a792688e08e5cd7$export$d93cc409a0768c5f, this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapRotation.copy(t.envMapRotation), this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this.fog = t.fog, this;
    }
}
class $4a792688e08e5cd7$export$2698c22ec13825db extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = 3200, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.depthPacking = t.depthPacking, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this;
    }
}
class $4a792688e08e5cd7$export$33e187ed002f2a19 extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this;
    }
}
class $4a792688e08e5cd7$export$6f5fef6235ec12ee extends $4a792688e08e5cd7$export$a2d8b23205c25948 {
    constructor(t){
        super(), this.isMeshMatcapMaterial = !0, this.defines = {
            MATCAP: ""
        }, this.type = "MeshMatcapMaterial", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(16777215), this.matcap = null, this.map = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new $4a792688e08e5cd7$export$c977b3e384af9ae1(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.defines = {
            MATCAP: ""
        }, this.color.copy(t.color), this.matcap = t.matcap, this.map = t.map, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.alphaMap = t.alphaMap, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.flatShading = t.flatShading, this.fog = t.fog, this;
    }
}
class $4a792688e08e5cd7$export$327886a3efaeaebe extends $4a792688e08e5cd7$export$fbaaa33907730a0c {
    constructor(t){
        super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.scale = t.scale, this.dashSize = t.dashSize, this.gapSize = t.gapSize, this;
    }
}
function $4a792688e08e5cd7$var$Kl(t, e) {
    return t && t.constructor !== e ? "number" == typeof e.BYTES_PER_ELEMENT ? new e(t) : Array.prototype.slice.call(t) : t;
}
function $4a792688e08e5cd7$var$tc(t) {
    return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function $4a792688e08e5cd7$var$ec(t) {
    const e = t.length, i = new Array(e);
    for(let t = 0; t !== e; ++t)i[t] = t;
    return i.sort(function(e, i) {
        return t[e] - t[i];
    }), i;
}
function $4a792688e08e5cd7$var$ic(t, e, i) {
    const s = t.length, r = new t.constructor(s);
    for(let n = 0, a = 0; a !== s; ++n){
        const s = i[n] * e;
        for(let i = 0; i !== e; ++i)r[a++] = t[s + i];
    }
    return r;
}
function $4a792688e08e5cd7$var$sc(t, e, i, s) {
    let r = 1, n = t[0];
    for(; void 0 !== n && void 0 === n[s];)n = t[r++];
    if (void 0 === n) return;
    let a = n[s];
    if (void 0 !== a) {
        if (Array.isArray(a)) do a = n[s], void 0 !== a && (e.push(n.time), i.push(...a)), n = t[r++];
        while (void 0 !== n);
        else if (void 0 !== a.toArray) do a = n[s], void 0 !== a && (e.push(n.time), a.toArray(i, i.length)), n = t[r++];
        while (void 0 !== n);
        else do a = n[s], void 0 !== a && (e.push(n.time), i.push(a)), n = t[r++];
        while (void 0 !== n);
    }
}
class $4a792688e08e5cd7$export$7ee8caa573e71ad1 {
    static convertArray(t, e) {
        return $4a792688e08e5cd7$var$Kl(t, e);
    }
    static isTypedArray(t) {
        return $4a792688e08e5cd7$var$tc(t);
    }
    static getKeyframeOrder(t) {
        return $4a792688e08e5cd7$var$ec(t);
    }
    static sortedArray(t, e, i) {
        return $4a792688e08e5cd7$var$ic(t, e, i);
    }
    static flattenJSON(t, e, i, s) {
        $4a792688e08e5cd7$var$sc(t, e, i, s);
    }
    static subclip(t, e, i, s, r = 30) {
        return function(t, e, i, s, r = 30) {
            const n = t.clone();
            n.name = e;
            const a = [];
            for(let t = 0; t < n.tracks.length; ++t){
                const e = n.tracks[t], o = e.getValueSize(), h = [], l = [];
                for(let t = 0; t < e.times.length; ++t){
                    const n = e.times[t] * r;
                    if (!(n < i || n >= s)) {
                        h.push(e.times[t]);
                        for(let i = 0; i < o; ++i)l.push(e.values[t * o + i]);
                    }
                }
                0 !== h.length && (e.times = $4a792688e08e5cd7$var$Kl(h, e.times.constructor), e.values = $4a792688e08e5cd7$var$Kl(l, e.values.constructor), a.push(e));
            }
            n.tracks = a;
            let o = 1 / 0;
            for(let t = 0; t < n.tracks.length; ++t)o > n.tracks[t].times[0] && (o = n.tracks[t].times[0]);
            for(let t = 0; t < n.tracks.length; ++t)n.tracks[t].shift(-1 * o);
            return n.resetDuration(), n;
        }(t, e, i, s, r);
    }
    static makeClipAdditive(t, e = 0, i = t, s = 30) {
        return function(t, e = 0, i = t, s = 30) {
            s <= 0 && (s = 30);
            const r = i.tracks.length, n = e / s;
            for(let e = 0; e < r; ++e){
                const s = i.tracks[e], r = s.ValueTypeName;
                if ("bool" === r || "string" === r) continue;
                const a = t.tracks.find(function(t) {
                    return t.name === s.name && t.ValueTypeName === r;
                });
                if (void 0 === a) continue;
                let o = 0;
                const h = s.getValueSize();
                s.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (o = h / 3);
                let l = 0;
                const c = a.getValueSize();
                a.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (l = c / 3);
                const u = s.times.length - 1;
                let d;
                if (n <= s.times[0]) {
                    const t = o, e = h - o;
                    d = s.values.slice(t, e);
                } else if (n >= s.times[u]) {
                    const t = u * h + o, e = t + h - o;
                    d = s.values.slice(t, e);
                } else {
                    const t = s.createInterpolant(), e = o, i = h - o;
                    t.evaluate(n), d = t.resultBuffer.slice(e, i);
                }
                "quaternion" === r && (new $4a792688e08e5cd7$export$23d6a54f0bbc85a3).fromArray(d).normalize().conjugate().toArray(d);
                const p = a.times.length;
                for(let t = 0; t < p; ++t){
                    const e = t * c + l;
                    if ("quaternion" === r) $4a792688e08e5cd7$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(a.values, e, d, 0, a.values, e);
                    else {
                        const t = c - 2 * l;
                        for(let i = 0; i < t; ++i)a.values[e + i] -= d[i];
                    }
                }
            }
            return t.blendMode = $4a792688e08e5cd7$export$d875e029ef558d3, t;
        }(t, e, i, s);
    }
}
class $4a792688e08e5cd7$export$b558baee9c0f72d3 {
    constructor(t, e, i, s){
        this.parameterPositions = t, this._cachedIndex = 0, this.resultBuffer = void 0 !== s ? s : new e.constructor(i), this.sampleValues = e, this.valueSize = i, this.settings = null, this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const e = this.parameterPositions;
        let i = this._cachedIndex, s = e[i], r = e[i - 1];
        t: {
            e: {
                let n;
                i: {
                    s: if (!(t < s)) {
                        for(let n = i + 2;;){
                            if (void 0 === s) {
                                if (t < r) break s;
                                return i = e.length, this._cachedIndex = i, this.copySampleValue_(i - 1);
                            }
                            if (i === n) break;
                            if (r = s, s = e[++i], t < s) break e;
                        }
                        n = e.length;
                        break i;
                    }
                    if (!(t >= r)) {
                        const a = e[1];
                        t < a && (i = 2, r = a);
                        for(let n = i - 2;;){
                            if (void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                            if (i === n) break;
                            if (s = r, r = e[--i - 1], t >= r) break e;
                        }
                        n = i, i = 0;
                        break i;
                    }
                    break t;
                }
                for(; i < n;){
                    const s = i + n >>> 1;
                    t < e[s] ? n = s : i = s + 1;
                }
                if (s = e[i], r = e[i - 1], void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                if (void 0 === s) return i = e.length, this._cachedIndex = i, this.copySampleValue_(i - 1);
            }
            this._cachedIndex = i, this.intervalChanged_(i, r, s);
        }
        return this.interpolate_(i, r, t, s);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(t) {
        const e = this.resultBuffer, i = this.sampleValues, s = this.valueSize, r = t * s;
        for(let t = 0; t !== s; ++t)e[t] = i[r + t];
        return e;
    }
    interpolate_() {
        throw new Error("call to abstract method");
    }
    intervalChanged_() {}
}
class $4a792688e08e5cd7$export$3646682e7a3959 extends $4a792688e08e5cd7$export$b558baee9c0f72d3 {
    constructor(t, e, i, s){
        super(t, e, i, s), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
            endingStart: $4a792688e08e5cd7$export$7f795934b84ab523,
            endingEnd: $4a792688e08e5cd7$export$7f795934b84ab523
        };
    }
    intervalChanged_(t, e, i) {
        const s = this.parameterPositions;
        let r = t - 2, n = t + 1, a = s[r], o = s[n];
        if (void 0 === a) switch(this.getSettings_().endingStart){
            case $4a792688e08e5cd7$export$24a4ccb5099273b5:
                r = t, a = 2 * e - i;
                break;
            case $4a792688e08e5cd7$export$8e8c3ecdcd8e1fee:
                r = s.length - 2, a = e + s[r] - s[r + 1];
                break;
            default:
                r = t, a = i;
        }
        if (void 0 === o) switch(this.getSettings_().endingEnd){
            case $4a792688e08e5cd7$export$24a4ccb5099273b5:
                n = t, o = 2 * i - e;
                break;
            case $4a792688e08e5cd7$export$8e8c3ecdcd8e1fee:
                n = 1, o = i + s[1] - s[0];
                break;
            default:
                n = t - 1, o = e;
        }
        const h = .5 * (i - e), l = this.valueSize;
        this._weightPrev = h / (e - a), this._weightNext = h / (o - i), this._offsetPrev = r * l, this._offsetNext = n * l;
    }
    interpolate_(t, e, i, s) {
        const r = this.resultBuffer, n = this.sampleValues, a = this.valueSize, o = t * a, h = o - a, l = this._offsetPrev, c = this._offsetNext, u = this._weightPrev, d = this._weightNext, p = (i - e) / (s - e), m = p * p, y = m * p, g = -u * y + 2 * u * m - u * p, f = (1 + u) * y + (-1.5 - 2 * u) * m + (-0.5 + u) * p + 1, x = (-1 - d) * y + (1.5 + d) * m + .5 * p, b = d * y - d * m;
        for(let t = 0; t !== a; ++t)r[t] = g * n[l + t] + f * n[h + t] + x * n[o + t] + b * n[c + t];
        return r;
    }
}
class $4a792688e08e5cd7$export$a8e6009059f51e1a extends $4a792688e08e5cd7$export$b558baee9c0f72d3 {
    constructor(t, e, i, s){
        super(t, e, i, s);
    }
    interpolate_(t, e, i, s) {
        const r = this.resultBuffer, n = this.sampleValues, a = this.valueSize, o = t * a, h = o - a, l = (i - e) / (s - e), c = 1 - l;
        for(let t = 0; t !== a; ++t)r[t] = n[h + t] * c + n[o + t] * l;
        return r;
    }
}
class $4a792688e08e5cd7$export$fb9758ef7ef8d5cc extends $4a792688e08e5cd7$export$b558baee9c0f72d3 {
    constructor(t, e, i, s){
        super(t, e, i, s);
    }
    interpolate_(t) {
        return this.copySampleValue_(t - 1);
    }
}
class $4a792688e08e5cd7$export$b0e479f45b7006d6 {
    constructor(t, e, i, s){
        if (void 0 === t) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (void 0 === e || 0 === e.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t);
        this.name = t, this.times = $4a792688e08e5cd7$var$Kl(e, this.TimeBufferType), this.values = $4a792688e08e5cd7$var$Kl(i, this.ValueBufferType), this.setInterpolation(s || this.DefaultInterpolation);
    }
    static toJSON(t) {
        const e = t.constructor;
        let i;
        if (e.toJSON !== this.toJSON) i = e.toJSON(t);
        else {
            i = {
                name: t.name,
                times: $4a792688e08e5cd7$var$Kl(t.times, Array),
                values: $4a792688e08e5cd7$var$Kl(t.values, Array)
            };
            const e = t.getInterpolation();
            e !== t.DefaultInterpolation && (i.interpolation = e);
        }
        return i.type = t.ValueTypeName, i;
    }
    InterpolantFactoryMethodDiscrete(t) {
        return new $4a792688e08e5cd7$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), t);
    }
    InterpolantFactoryMethodLinear(t) {
        return new $4a792688e08e5cd7$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), t);
    }
    InterpolantFactoryMethodSmooth(t) {
        return new $4a792688e08e5cd7$export$3646682e7a3959(this.times, this.values, this.getValueSize(), t);
    }
    setInterpolation(t) {
        let e;
        switch(t){
            case $4a792688e08e5cd7$export$995b32462a65e855:
                e = this.InterpolantFactoryMethodDiscrete;
                break;
            case $4a792688e08e5cd7$export$30fac1aace31cf4d:
                e = this.InterpolantFactoryMethodLinear;
                break;
            case $4a792688e08e5cd7$export$198b11ff4c72bb30:
                e = this.InterpolantFactoryMethodSmooth;
        }
        if (void 0 === e) {
            const e = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (void 0 === this.createInterpolant) {
                if (t === this.DefaultInterpolation) throw new Error(e);
                this.setInterpolation(this.DefaultInterpolation);
            }
            return $4a792688e08e5cd7$export$c106dd0671a0fc2d("KeyframeTrack:", e), this;
        }
        return this.createInterpolant = e, this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $4a792688e08e5cd7$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $4a792688e08e5cd7$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $4a792688e08e5cd7$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    shift(t) {
        if (0 !== t) {
            const e = this.times;
            for(let i = 0, s = e.length; i !== s; ++i)e[i] += t;
        }
        return this;
    }
    scale(t) {
        if (1 !== t) {
            const e = this.times;
            for(let i = 0, s = e.length; i !== s; ++i)e[i] *= t;
        }
        return this;
    }
    trim(t, e) {
        const i = this.times, s = i.length;
        let r = 0, n = s - 1;
        for(; r !== s && i[r] < t;)++r;
        for(; -1 !== n && i[n] > e;)--n;
        if (++n, 0 !== r || n !== s) {
            r >= n && (n = Math.max(n, 1), r = n - 1);
            const t = this.getValueSize();
            this.times = i.slice(r, n), this.values = this.values.slice(r * t, n * t);
        }
        return this;
    }
    validate() {
        let t = !0;
        const e = this.getValueSize();
        e - Math.floor(e) !== 0 && ($4a792688e08e5cd7$export$a3bc9b8ed74fc("KeyframeTrack: Invalid value size in track.", this), t = !1);
        const i = this.times, s = this.values, r = i.length;
        0 === r && ($4a792688e08e5cd7$export$a3bc9b8ed74fc("KeyframeTrack: Track is empty.", this), t = !1);
        let n = null;
        for(let e = 0; e !== r; e++){
            const s = i[e];
            if ("number" == typeof s && isNaN(s)) {
                $4a792688e08e5cd7$export$a3bc9b8ed74fc("KeyframeTrack: Time is not a valid number.", this, e, s), t = !1;
                break;
            }
            if (null !== n && n > s) {
                $4a792688e08e5cd7$export$a3bc9b8ed74fc("KeyframeTrack: Out of order keys.", this, e, s, n), t = !1;
                break;
            }
            n = s;
        }
        if (void 0 !== s && $4a792688e08e5cd7$var$tc(s)) for(let e = 0, i = s.length; e !== i; ++e){
            const i = s[e];
            if (isNaN(i)) {
                $4a792688e08e5cd7$export$a3bc9b8ed74fc("KeyframeTrack: Value is not a valid number.", this, e, i), t = !1;
                break;
            }
        }
        return t;
    }
    optimize() {
        const t = this.times.slice(), e = this.values.slice(), i = this.getValueSize(), s = this.getInterpolation() === $4a792688e08e5cd7$export$198b11ff4c72bb30, r = t.length - 1;
        let n = 1;
        for(let a = 1; a < r; ++a){
            let r = !1;
            const o = t[a];
            if (o !== t[a + 1] && (1 !== a || o !== t[0])) {
                if (s) r = !0;
                else {
                    const t = a * i, s = t - i, n = t + i;
                    for(let a = 0; a !== i; ++a){
                        const i = e[t + a];
                        if (i !== e[s + a] || i !== e[n + a]) {
                            r = !0;
                            break;
                        }
                    }
                }
            }
            if (r) {
                if (a !== n) {
                    t[n] = t[a];
                    const s = a * i, r = n * i;
                    for(let t = 0; t !== i; ++t)e[r + t] = e[s + t];
                }
                ++n;
            }
        }
        if (r > 0) {
            t[n] = t[r];
            for(let t = r * i, s = n * i, a = 0; a !== i; ++a)e[s + a] = e[t + a];
            ++n;
        }
        return n !== t.length ? (this.times = t.slice(0, n), this.values = e.slice(0, n * i)) : (this.times = t, this.values = e), this;
    }
    clone() {
        const t = this.times.slice(), e = this.values.slice(), i = new this.constructor(this.name, t, e);
        return i.createInterpolant = this.createInterpolant, i;
    }
}
$4a792688e08e5cd7$export$b0e479f45b7006d6.prototype.ValueTypeName = "", $4a792688e08e5cd7$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array, $4a792688e08e5cd7$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array, $4a792688e08e5cd7$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $4a792688e08e5cd7$export$30fac1aace31cf4d;
class $4a792688e08e5cd7$export$d3a344b98cf0b775 extends $4a792688e08e5cd7$export$b0e479f45b7006d6 {
    constructor(t, e, i){
        super(t, e, i);
    }
}
$4a792688e08e5cd7$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool", $4a792688e08e5cd7$export$d3a344b98cf0b775.prototype.ValueBufferType = Array, $4a792688e08e5cd7$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $4a792688e08e5cd7$export$995b32462a65e855, $4a792688e08e5cd7$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = void 0, $4a792688e08e5cd7$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = void 0;
class $4a792688e08e5cd7$export$83444c5d885347d8 extends $4a792688e08e5cd7$export$b0e479f45b7006d6 {
    constructor(t, e, i, s){
        super(t, e, i, s);
    }
}
$4a792688e08e5cd7$export$83444c5d885347d8.prototype.ValueTypeName = "color";
class $4a792688e08e5cd7$export$d45f0d1a4d9a9314 extends $4a792688e08e5cd7$export$b0e479f45b7006d6 {
    constructor(t, e, i, s){
        super(t, e, i, s);
    }
}
$4a792688e08e5cd7$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
class $4a792688e08e5cd7$export$2db1cfb7923d931e extends $4a792688e08e5cd7$export$b558baee9c0f72d3 {
    constructor(t, e, i, s){
        super(t, e, i, s);
    }
    interpolate_(t, e, i, s) {
        const r = this.resultBuffer, n = this.sampleValues, a = this.valueSize, o = (i - e) / (s - e);
        let h = t * a;
        for(let t = h + a; h !== t; h += 4)$4a792688e08e5cd7$export$23d6a54f0bbc85a3.slerpFlat(r, 0, n, h - a, n, h, o);
        return r;
    }
}
class $4a792688e08e5cd7$export$b8043f12b5aafbd7 extends $4a792688e08e5cd7$export$b0e479f45b7006d6 {
    constructor(t, e, i, s){
        super(t, e, i, s);
    }
    InterpolantFactoryMethodLinear(t) {
        return new $4a792688e08e5cd7$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), t);
    }
}
$4a792688e08e5cd7$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion", $4a792688e08e5cd7$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = void 0;
class $4a792688e08e5cd7$export$6ce41d4f3a8df9cd extends $4a792688e08e5cd7$export$b0e479f45b7006d6 {
    constructor(t, e, i){
        super(t, e, i);
    }
}
$4a792688e08e5cd7$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string", $4a792688e08e5cd7$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array, $4a792688e08e5cd7$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $4a792688e08e5cd7$export$995b32462a65e855, $4a792688e08e5cd7$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = void 0, $4a792688e08e5cd7$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = void 0;
class $4a792688e08e5cd7$export$5ce2dcb4cc9f2bff extends $4a792688e08e5cd7$export$b0e479f45b7006d6 {
    constructor(t, e, i, s){
        super(t, e, i, s);
    }
}
$4a792688e08e5cd7$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $4a792688e08e5cd7$export$d942c706bf23829c {
    constructor(t = "", e = -1, i = [], s = 2500){
        this.name = t, this.tracks = i, this.duration = e, this.blendMode = s, this.uuid = $4a792688e08e5cd7$var$rs(), this.userData = {}, this.duration < 0 && this.resetDuration();
    }
    static parse(t) {
        const e = [], i = t.tracks, s = 1 / (t.fps || 1);
        for(let t = 0, r = i.length; t !== r; ++t)e.push($4a792688e08e5cd7$var$xc(i[t]).scale(s));
        const r = new this(t.name, t.duration, e, t.blendMode);
        return r.uuid = t.uuid, r.userData = JSON.parse(t.userData || "{}"), r;
    }
    static toJSON(t) {
        const e = [], i = t.tracks, s = {
            name: t.name,
            duration: t.duration,
            tracks: e,
            uuid: t.uuid,
            blendMode: t.blendMode,
            userData: JSON.stringify(t.userData)
        };
        for(let t = 0, s = i.length; t !== s; ++t)e.push($4a792688e08e5cd7$export$b0e479f45b7006d6.toJSON(i[t]));
        return s;
    }
    static CreateFromMorphTargetSequence(t, e, i, s) {
        const r = e.length, n = [];
        for(let t = 0; t < r; t++){
            let a = [], o = [];
            a.push((t + r - 1) % r, t, (t + 1) % r), o.push(0, 1, 0);
            const h = $4a792688e08e5cd7$var$ec(a);
            a = $4a792688e08e5cd7$var$ic(a, 1, h), o = $4a792688e08e5cd7$var$ic(o, 1, h), s || 0 !== a[0] || (a.push(r), o.push(o[0])), n.push(new $4a792688e08e5cd7$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + e[t].name + "]", a, o).scale(1 / i));
        }
        return new this(t, -1, n);
    }
    static findByName(t, e) {
        let i = t;
        if (!Array.isArray(t)) {
            const e = t;
            i = e.geometry && e.geometry.animations || e.animations;
        }
        for(let t = 0; t < i.length; t++)if (i[t].name === e) return i[t];
        return null;
    }
    static CreateClipsFromMorphTargetSequences(t, e, i) {
        const s = {}, r = /^([\w-]*?)([\d]+)$/;
        for(let e = 0, i = t.length; e < i; e++){
            const i = t[e], n = i.name.match(r);
            if (n && n.length > 1) {
                const t = n[1];
                let e = s[t];
                e || (s[t] = e = []), e.push(i);
            }
        }
        const n = [];
        for(const t in s)n.push(this.CreateFromMorphTargetSequence(t, s[t], e, i));
        return n;
    }
    static parseAnimation(t, e) {
        if ($4a792688e08e5cd7$export$c106dd0671a0fc2d("AnimationClip: parseAnimation() is deprecated and will be removed with r185"), !t) return $4a792688e08e5cd7$export$a3bc9b8ed74fc("AnimationClip: No animation in JSONLoader data."), null;
        const i = function(t, e, i, s, r) {
            if (0 !== i.length) {
                const n = [], a = [];
                $4a792688e08e5cd7$var$sc(i, n, a, s), 0 !== n.length && r.push(new t(e, n, a));
            }
        }, s = [], r = t.name || "default", n = t.fps || 30, a = t.blendMode;
        let o = t.length || -1;
        const h = t.hierarchy || [];
        for(let t = 0; t < h.length; t++){
            const r = h[t].keys;
            if (r && 0 !== r.length) {
                if (r[0].morphTargets) {
                    const t = {};
                    let e;
                    for(e = 0; e < r.length; e++)if (r[e].morphTargets) for(let i = 0; i < r[e].morphTargets.length; i++)t[r[e].morphTargets[i]] = -1;
                    for(const i in t){
                        const t = [], n = [];
                        for(let s = 0; s !== r[e].morphTargets.length; ++s){
                            const s = r[e];
                            t.push(s.time), n.push(s.morphTarget === i ? 1 : 0);
                        }
                        s.push(new $4a792688e08e5cd7$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + i + "]", t, n));
                    }
                    o = t.length * n;
                } else {
                    const n = ".bones[" + e[t].name + "]";
                    i($4a792688e08e5cd7$export$5ce2dcb4cc9f2bff, n + ".position", r, "pos", s), i($4a792688e08e5cd7$export$b8043f12b5aafbd7, n + ".quaternion", r, "rot", s), i($4a792688e08e5cd7$export$5ce2dcb4cc9f2bff, n + ".scale", r, "scl", s);
                }
            }
        }
        if (0 === s.length) return null;
        return new this(r, o, s, a);
    }
    resetDuration() {
        let t = 0;
        for(let e = 0, i = this.tracks.length; e !== i; ++e){
            const i = this.tracks[e];
            t = Math.max(t, i.times[i.times.length - 1]);
        }
        return this.duration = t, this;
    }
    trim() {
        for(let t = 0; t < this.tracks.length; t++)this.tracks[t].trim(0, this.duration);
        return this;
    }
    validate() {
        let t = !0;
        for(let e = 0; e < this.tracks.length; e++)t = t && this.tracks[e].validate();
        return t;
    }
    optimize() {
        for(let t = 0; t < this.tracks.length; t++)this.tracks[t].optimize();
        return this;
    }
    clone() {
        const t = [];
        for(let e = 0; e < this.tracks.length; e++)t.push(this.tracks[e].clone());
        const e = new this.constructor(this.name, this.duration, t, this.blendMode);
        return e.userData = JSON.parse(JSON.stringify(this.userData)), e;
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $4a792688e08e5cd7$var$xc(t) {
    if (void 0 === t.type) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const e = function(t) {
        switch(t.toLowerCase()){
            case "scalar":
            case "double":
            case "float":
            case "number":
            case "integer":
                return $4a792688e08e5cd7$export$d45f0d1a4d9a9314;
            case "vector":
            case "vector2":
            case "vector3":
            case "vector4":
                return $4a792688e08e5cd7$export$5ce2dcb4cc9f2bff;
            case "color":
                return $4a792688e08e5cd7$export$83444c5d885347d8;
            case "quaternion":
                return $4a792688e08e5cd7$export$b8043f12b5aafbd7;
            case "bool":
            case "boolean":
                return $4a792688e08e5cd7$export$d3a344b98cf0b775;
            case "string":
                return $4a792688e08e5cd7$export$6ce41d4f3a8df9cd;
        }
        throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + t);
    }(t.type);
    if (void 0 === t.times) {
        const e = [], i = [];
        $4a792688e08e5cd7$var$sc(t.keys, e, i, "value"), t.times = e, t.values = i;
    }
    return void 0 !== e.parse ? e.parse(t) : new e(t.name, t.times, t.values, t.interpolation);
}
const $4a792688e08e5cd7$export$94affb487e701bf2 = {
    enabled: !1,
    files: {},
    add: function(t, e) {
        !1 !== this.enabled && (this.files[t] = e);
    },
    get: function(t) {
        if (!1 !== this.enabled) return this.files[t];
    },
    remove: function(t) {
        delete this.files[t];
    },
    clear: function() {
        this.files = {};
    }
};
class $4a792688e08e5cd7$export$99cc795e99919eed {
    constructor(t, e, i){
        const s = this;
        let r, n = !1, a = 0, o = 0;
        const h = [];
        this.onStart = void 0, this.onLoad = t, this.onProgress = e, this.onError = i, this._abortController = null, this.itemStart = function(t) {
            o++, !1 === n && void 0 !== s.onStart && s.onStart(t, a, o), n = !0;
        }, this.itemEnd = function(t) {
            a++, void 0 !== s.onProgress && s.onProgress(t, a, o), a === o && (n = !1, void 0 !== s.onLoad && s.onLoad());
        }, this.itemError = function(t) {
            void 0 !== s.onError && s.onError(t);
        }, this.resolveURL = function(t) {
            return r ? r(t) : t;
        }, this.setURLModifier = function(t) {
            return r = t, this;
        }, this.addHandler = function(t, e) {
            return h.push(t, e), this;
        }, this.removeHandler = function(t) {
            const e = h.indexOf(t);
            return -1 !== e && h.splice(e, 2), this;
        }, this.getHandler = function(t) {
            for(let e = 0, i = h.length; e < i; e += 2){
                const i = h[e], s = h[e + 1];
                if (i.global && (i.lastIndex = 0), i.test(t)) return s;
            }
            return null;
        }, this.abort = function() {
            return this.abortController.abort(), this._abortController = null, this;
        };
    }
    get abortController() {
        return this._abortController || (this._abortController = new AbortController), this._abortController;
    }
}
const $4a792688e08e5cd7$export$b033c3f9a95c6a16 = new $4a792688e08e5cd7$export$99cc795e99919eed;
class $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        this.manager = void 0 !== t ? t : $4a792688e08e5cd7$export$b033c3f9a95c6a16, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
    }
    load() {}
    loadAsync(t, e) {
        const i = this;
        return new Promise(function(s, r) {
            i.load(t, s, e, r);
        });
    }
    parse() {}
    setCrossOrigin(t) {
        return this.crossOrigin = t, this;
    }
    setWithCredentials(t) {
        return this.withCredentials = t, this;
    }
    setPath(t) {
        return this.path = t, this;
    }
    setResourcePath(t) {
        return this.resourcePath = t, this;
    }
    setRequestHeader(t) {
        return this.requestHeader = t, this;
    }
    abort() {
        return this;
    }
}
$4a792688e08e5cd7$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const $4a792688e08e5cd7$var$Sc = {};
class $4a792688e08e5cd7$var$_c extends Error {
    constructor(t, e){
        super(t), this.response = e;
    }
}
class $4a792688e08e5cd7$export$98435a25b5cf7b2b extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t), this.mimeType = "", this.responseType = "", this._abortController = new AbortController;
    }
    load(t, e, i, s) {
        void 0 === t && (t = ""), void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
        const r = $4a792688e08e5cd7$export$94affb487e701bf2.get(`file:${t}`);
        if (void 0 !== r) return this.manager.itemStart(t), setTimeout(()=>{
            e && e(r), this.manager.itemEnd(t);
        }, 0), r;
        if (void 0 !== $4a792688e08e5cd7$var$Sc[t]) return void $4a792688e08e5cd7$var$Sc[t].push({
            onLoad: e,
            onProgress: i,
            onError: s
        });
        $4a792688e08e5cd7$var$Sc[t] = [], $4a792688e08e5cd7$var$Sc[t].push({
            onLoad: e,
            onProgress: i,
            onError: s
        });
        const n = new Request(t, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin",
            signal: "function" == typeof AbortSignal.any ? AbortSignal.any([
                this._abortController.signal,
                this.manager.abortController.signal
            ]) : this._abortController.signal
        }), a = this.mimeType, o = this.responseType;
        fetch(n).then((e)=>{
            if (200 === e.status || 0 === e.status) {
                if (0 === e.status && $4a792688e08e5cd7$export$c106dd0671a0fc2d("FileLoader: HTTP Status 0 received."), "undefined" == typeof ReadableStream || void 0 === e.body || void 0 === e.body.getReader) return e;
                const i = $4a792688e08e5cd7$var$Sc[t], s = e.body.getReader(), r = e.headers.get("X-File-Size") || e.headers.get("Content-Length"), n = r ? parseInt(r) : 0, a = 0 !== n;
                let o = 0;
                const h = new ReadableStream({
                    start (t) {
                        !function e() {
                            s.read().then(({ done: s, value: r })=>{
                                if (s) t.close();
                                else {
                                    o += r.byteLength;
                                    const s = new ProgressEvent("progress", {
                                        lengthComputable: a,
                                        loaded: o,
                                        total: n
                                    });
                                    for(let t = 0, e = i.length; t < e; t++){
                                        const e = i[t];
                                        e.onProgress && e.onProgress(s);
                                    }
                                    t.enqueue(r), e();
                                }
                            }, (e)=>{
                                t.error(e);
                            });
                        }();
                    }
                });
                return new Response(h);
            }
            throw new $4a792688e08e5cd7$var$_c(`fetch for "${e.url}" responded with ${e.status}: ${e.statusText}`, e);
        }).then((t)=>{
            switch(o){
                case "arraybuffer":
                    return t.arrayBuffer();
                case "blob":
                    return t.blob();
                case "document":
                    return t.text().then((t)=>(new DOMParser).parseFromString(t, a));
                case "json":
                    return t.json();
                default:
                    if ("" === a) return t.text();
                    {
                        const e = /charset="?([^;"\s]*)"?/i.exec(a), i = e && e[1] ? e[1].toLowerCase() : void 0, s = new TextDecoder(i);
                        return t.arrayBuffer().then((t)=>s.decode(t));
                    }
            }
        }).then((e)=>{
            $4a792688e08e5cd7$export$94affb487e701bf2.add(`file:${t}`, e);
            const i = $4a792688e08e5cd7$var$Sc[t];
            delete $4a792688e08e5cd7$var$Sc[t];
            for(let t = 0, s = i.length; t < s; t++){
                const s = i[t];
                s.onLoad && s.onLoad(e);
            }
        }).catch((e)=>{
            const i = $4a792688e08e5cd7$var$Sc[t];
            if (void 0 === i) throw this.manager.itemError(t), e;
            delete $4a792688e08e5cd7$var$Sc[t];
            for(let t = 0, s = i.length; t < s; t++){
                const s = i[t];
                s.onError && s.onError(e);
            }
            this.manager.itemError(t);
        }).finally(()=>{
            this.manager.itemEnd(t);
        }), this.manager.itemStart(t);
    }
    setResponseType(t) {
        return this.responseType = t, this;
    }
    setMimeType(t) {
        return this.mimeType = t, this;
    }
    abort() {
        return this._abortController.abort(), this._abortController = new AbortController, this;
    }
}
class $4a792688e08e5cd7$export$29711c7e14f61db extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t);
    }
    load(t, e, i, s) {
        const r = this, n = new $4a792688e08e5cd7$export$98435a25b5cf7b2b(this.manager);
        n.setPath(this.path), n.setRequestHeader(this.requestHeader), n.setWithCredentials(this.withCredentials), n.load(t, function(i) {
            try {
                e(r.parse(JSON.parse(i)));
            } catch (e) {
                s ? s(e) : $4a792688e08e5cd7$export$a3bc9b8ed74fc(e), r.manager.itemError(t);
            }
        }, i, s);
    }
    parse(t) {
        const e = [];
        for(let i = 0; i < t.length; i++){
            const s = $4a792688e08e5cd7$export$d942c706bf23829c.parse(t[i]);
            e.push(s);
        }
        return e;
    }
}
class $4a792688e08e5cd7$export$bd73ce947a280350 extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t);
    }
    load(t, e, i, s) {
        const r = this, n = [], a = new $4a792688e08e5cd7$export$3466bac9141a5cc4, o = new $4a792688e08e5cd7$export$98435a25b5cf7b2b(this.manager);
        o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(r.withCredentials);
        let h = 0;
        function l(l) {
            o.load(t[l], function(t) {
                const i = r.parse(t, !0);
                n[l] = {
                    width: i.width,
                    height: i.height,
                    format: i.format,
                    mipmaps: i.mipmaps
                }, h += 1, 6 === h && (1 === i.mipmapCount && (a.minFilter = $4a792688e08e5cd7$export$8a72f490b25c56c8), a.image = n, a.format = i.format, a.needsUpdate = !0, e && e(a));
            }, i, s);
        }
        if (Array.isArray(t)) for(let e = 0, i = t.length; e < i; ++e)l(e);
        else o.load(t, function(t) {
            const i = r.parse(t, !0);
            if (i.isCubemap) {
                const t = i.mipmaps.length / i.mipmapCount;
                for(let e = 0; e < t; e++){
                    n[e] = {
                        mipmaps: []
                    };
                    for(let t = 0; t < i.mipmapCount; t++)n[e].mipmaps.push(i.mipmaps[e * i.mipmapCount + t]), n[e].format = i.format, n[e].width = i.width, n[e].height = i.height;
                }
                a.image = n;
            } else a.image.width = i.width, a.image.height = i.height, a.mipmaps = i.mipmaps;
            1 === i.mipmapCount && (a.minFilter = $4a792688e08e5cd7$export$8a72f490b25c56c8), a.format = i.format, a.needsUpdate = !0, e && e(a);
        }, i, s);
        return a;
    }
}
const $4a792688e08e5cd7$var$Cc = new WeakMap;
class $4a792688e08e5cd7$export$8905ce1c7a2464a1 extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t);
    }
    load(t, e, i, s) {
        void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
        const r = this, n = $4a792688e08e5cd7$export$94affb487e701bf2.get(`image:${t}`);
        if (void 0 !== n) {
            if (!0 === n.complete) r.manager.itemStart(t), setTimeout(function() {
                e && e(n), r.manager.itemEnd(t);
            }, 0);
            else {
                let t = $4a792688e08e5cd7$var$Cc.get(n);
                void 0 === t && (t = [], $4a792688e08e5cd7$var$Cc.set(n, t)), t.push({
                    onLoad: e,
                    onError: s
                });
            }
            return n;
        }
        const a = $4a792688e08e5cd7$export$7094a064528c7fee("img");
        function o() {
            l(), e && e(this);
            const i = $4a792688e08e5cd7$var$Cc.get(this) || [];
            for(let t = 0; t < i.length; t++){
                const e = i[t];
                e.onLoad && e.onLoad(this);
            }
            $4a792688e08e5cd7$var$Cc.delete(this), r.manager.itemEnd(t);
        }
        function h(e) {
            l(), s && s(e), $4a792688e08e5cd7$export$94affb487e701bf2.remove(`image:${t}`);
            const i = $4a792688e08e5cd7$var$Cc.get(this) || [];
            for(let t = 0; t < i.length; t++){
                const s = i[t];
                s.onError && s.onError(e);
            }
            $4a792688e08e5cd7$var$Cc.delete(this), r.manager.itemError(t), r.manager.itemEnd(t);
        }
        function l() {
            a.removeEventListener("load", o, !1), a.removeEventListener("error", h, !1);
        }
        return a.addEventListener("load", o, !1), a.addEventListener("error", h, !1), "data:" !== t.slice(0, 5) && void 0 !== this.crossOrigin && (a.crossOrigin = this.crossOrigin), $4a792688e08e5cd7$export$94affb487e701bf2.add(`image:${t}`, a), r.manager.itemStart(t), a.src = t, a;
    }
}
class $4a792688e08e5cd7$export$2ec114afc2cf6308 extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t);
    }
    load(t, e, i, s) {
        const r = new $4a792688e08e5cd7$export$ee2e5a18258a4049;
        r.colorSpace = $4a792688e08e5cd7$export$561f394b24edfcaa;
        const n = new $4a792688e08e5cd7$export$8905ce1c7a2464a1(this.manager);
        n.setCrossOrigin(this.crossOrigin), n.setPath(this.path);
        let a = 0;
        function o(i) {
            n.load(t[i], function(t) {
                r.images[i] = t, a++, 6 === a && (r.needsUpdate = !0, e && e(r));
            }, void 0, s);
        }
        for(let e = 0; e < t.length; ++e)o(e);
        return r;
    }
}
class $4a792688e08e5cd7$export$792d8a18f2c55855 extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t);
    }
    load(t, e, i, s) {
        const r = this, n = new $4a792688e08e5cd7$export$b691f601014eabe1, a = new $4a792688e08e5cd7$export$98435a25b5cf7b2b(this.manager);
        return a.setResponseType("arraybuffer"), a.setRequestHeader(this.requestHeader), a.setPath(this.path), a.setWithCredentials(r.withCredentials), a.load(t, function(t) {
            let i;
            try {
                i = r.parse(t);
            } catch (t) {
                if (void 0 === s) return void t(t);
                s(t);
            }
            void 0 !== i.image ? n.image = i.image : void 0 !== i.data && (n.image.width = i.width, n.image.height = i.height, n.image.data = i.data), n.wrapS = void 0 !== i.wrapS ? i.wrapS : $4a792688e08e5cd7$export$9d9334239a5a5e06, n.wrapT = void 0 !== i.wrapT ? i.wrapT : $4a792688e08e5cd7$export$9d9334239a5a5e06, n.magFilter = void 0 !== i.magFilter ? i.magFilter : $4a792688e08e5cd7$export$8a72f490b25c56c8, n.minFilter = void 0 !== i.minFilter ? i.minFilter : $4a792688e08e5cd7$export$8a72f490b25c56c8, n.anisotropy = void 0 !== i.anisotropy ? i.anisotropy : 1, void 0 !== i.colorSpace && (n.colorSpace = i.colorSpace), void 0 !== i.flipY && (n.flipY = i.flipY), void 0 !== i.format && (n.format = i.format), void 0 !== i.type && (n.type = i.type), void 0 !== i.mipmaps && (n.mipmaps = i.mipmaps, n.minFilter = $4a792688e08e5cd7$export$5d8599b6a933fb1b), 1 === i.mipmapCount && (n.minFilter = $4a792688e08e5cd7$export$8a72f490b25c56c8), void 0 !== i.generateMipmaps && (n.generateMipmaps = i.generateMipmaps), n.needsUpdate = !0, e && e(n, i);
        }, i, s), n;
    }
}
class $4a792688e08e5cd7$export$fd1bfc71f64c538c extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t);
    }
    load(t, e, i, s) {
        const r = new $4a792688e08e5cd7$export$5431306cf43de24a, n = new $4a792688e08e5cd7$export$8905ce1c7a2464a1(this.manager);
        return n.setCrossOrigin(this.crossOrigin), n.setPath(this.path), n.load(t, function(t) {
            r.image = t, r.needsUpdate = !0, void 0 !== e && e(r);
        }, i, s), r;
    }
}
class $4a792688e08e5cd7$export$6ecadb6ed240d696 extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(t, e = 1){
        super(), this.isLight = !0, this.type = "Light", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e(t), this.intensity = e;
    }
    dispose() {}
    copy(t, e) {
        return super.copy(t, e), this.color.copy(t.color), this.intensity = t.intensity, this;
    }
    toJSON(t) {
        const e = super.toJSON(t);
        return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, void 0 !== this.groundColor && (e.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (e.object.distance = this.distance), void 0 !== this.angle && (e.object.angle = this.angle), void 0 !== this.decay && (e.object.decay = this.decay), void 0 !== this.penumbra && (e.object.penumbra = this.penumbra), void 0 !== this.shadow && (e.object.shadow = this.shadow.toJSON()), void 0 !== this.target && (e.object.target = this.target.uuid), e;
    }
}
class $4a792688e08e5cd7$export$8d474f55edbb9624 extends $4a792688e08e5cd7$export$6ecadb6ed240d696 {
    constructor(t, e, i){
        super(t, i), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy($4a792688e08e5cd7$export$e4dd07dff30cc924.DEFAULT_UP), this.updateMatrix(), this.groundColor = new $4a792688e08e5cd7$export$892596cec99bc70e(e);
    }
    copy(t, e) {
        return super.copy(t, e), this.groundColor.copy(t.groundColor), this;
    }
}
const $4a792688e08e5cd7$var$Nc = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$Vc = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Fc = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$var$Lc {
    constructor(t){
        this.camera = t, this.intensity = 1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new $4a792688e08e5cd7$export$c977b3e384af9ae1(512, 512), this.mapType = $4a792688e08e5cd7$export$2e8ce08d3f6f5e10, this.map = null, this.mapPass = null, this.matrix = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new $4a792688e08e5cd7$export$35efe6f4c85463d2, this._frameExtents = new $4a792688e08e5cd7$export$c977b3e384af9ae1(1, 1), this._viewportCount = 1, this._viewports = [
            new $4a792688e08e5cd7$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(t) {
        const e = this.camera, i = this.matrix;
        $4a792688e08e5cd7$var$Vc.setFromMatrixPosition(t.matrixWorld), e.position.copy($4a792688e08e5cd7$var$Vc), $4a792688e08e5cd7$var$Fc.setFromMatrixPosition(t.target.matrixWorld), e.lookAt($4a792688e08e5cd7$var$Fc), e.updateMatrixWorld(), $4a792688e08e5cd7$var$Nc.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix($4a792688e08e5cd7$var$Nc, e.coordinateSystem, e.reversedDepth), e.reversedDepth ? i.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, 1, 0, 0, 0, 0, 1) : i.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), i.multiply($4a792688e08e5cd7$var$Nc);
    }
    getViewport(t) {
        return this._viewports[t];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
    }
    copy(t) {
        return this.camera = t.camera.clone(), this.intensity = t.intensity, this.bias = t.bias, this.radius = t.radius, this.autoUpdate = t.autoUpdate, this.needsUpdate = t.needsUpdate, this.normalBias = t.normalBias, this.blurSamples = t.blurSamples, this.mapSize.copy(t.mapSize), this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    toJSON() {
        const t = {};
        return 1 !== this.intensity && (t.intensity = this.intensity), 0 !== this.bias && (t.bias = this.bias), 0 !== this.normalBias && (t.normalBias = this.normalBias), 1 !== this.radius && (t.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (t.mapSize = this.mapSize.toArray()), t.camera = this.camera.toJSON(!1).object, delete t.camera.matrix, t;
    }
}
class $4a792688e08e5cd7$var$Ec extends $4a792688e08e5cd7$var$Lc {
    constructor(){
        super(new $4a792688e08e5cd7$export$74e4ae24825f68d7(50, 1, .5, 500)), this.isSpotLightShadow = !0, this.focus = 1, this.aspect = 1;
    }
    updateMatrices(t) {
        const e = this.camera, i = 2 * $4a792688e08e5cd7$export$914076c8150813e5 * t.angle * this.focus, s = this.mapSize.width / this.mapSize.height * this.aspect, r = t.distance || e.far;
        i === e.fov && s === e.aspect && r === e.far || (e.fov = i, e.aspect = s, e.far = r, e.updateProjectionMatrix()), super.updateMatrices(t);
    }
    copy(t) {
        return super.copy(t), this.focus = t.focus, this;
    }
}
class $4a792688e08e5cd7$export$81495cbb73897362 extends $4a792688e08e5cd7$export$6ecadb6ed240d696 {
    constructor(t, e, i = 0, s = Math.PI / 3, r = 0, n = 2){
        super(t, e), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy($4a792688e08e5cd7$export$e4dd07dff30cc924.DEFAULT_UP), this.updateMatrix(), this.target = new $4a792688e08e5cd7$export$e4dd07dff30cc924, this.distance = i, this.angle = s, this.penumbra = r, this.decay = n, this.map = null, this.shadow = new $4a792688e08e5cd7$var$Ec;
    }
    get power() {
        return this.intensity * Math.PI;
    }
    set power(t) {
        this.intensity = t / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t, e) {
        return super.copy(t, e), this.distance = t.distance, this.angle = t.angle, this.penumbra = t.penumbra, this.decay = t.decay, this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
}
const $4a792688e08e5cd7$var$Dc = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$Wc = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Uc = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$var$qc extends $4a792688e08e5cd7$var$Lc {
    constructor(){
        super(new $4a792688e08e5cd7$export$74e4ae24825f68d7(90, 1, .5, 500)), this.isPointLightShadow = !0, this._frameExtents = new $4a792688e08e5cd7$export$c977b3e384af9ae1(4, 2), this._viewportCount = 6, this._viewports = [
            new $4a792688e08e5cd7$export$fa7daccca11cdbe3(2, 1, 1, 1),
            new $4a792688e08e5cd7$export$fa7daccca11cdbe3(0, 1, 1, 1),
            new $4a792688e08e5cd7$export$fa7daccca11cdbe3(3, 1, 1, 1),
            new $4a792688e08e5cd7$export$fa7daccca11cdbe3(1, 1, 1, 1),
            new $4a792688e08e5cd7$export$fa7daccca11cdbe3(3, 0, 1, 1),
            new $4a792688e08e5cd7$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ], this._cubeDirections = [
            new $4a792688e08e5cd7$export$64b5c384219d3699(1, 0, 0),
            new $4a792688e08e5cd7$export$64b5c384219d3699(-1, 0, 0),
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0, 1),
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0, -1),
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, 1, 0),
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, -1, 0)
        ], this._cubeUps = [
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, 1, 0),
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, 1, 0),
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, 1, 0),
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, 1, 0),
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0, 1),
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(t, e = 0) {
        const i = this.camera, s = this.matrix, r = t.distance || i.far;
        r !== i.far && (i.far = r, i.updateProjectionMatrix()), $4a792688e08e5cd7$var$Wc.setFromMatrixPosition(t.matrixWorld), i.position.copy($4a792688e08e5cd7$var$Wc), $4a792688e08e5cd7$var$Uc.copy(i.position), $4a792688e08e5cd7$var$Uc.add(this._cubeDirections[e]), i.up.copy(this._cubeUps[e]), i.lookAt($4a792688e08e5cd7$var$Uc), i.updateMatrixWorld(), s.makeTranslation(-$4a792688e08e5cd7$var$Wc.x, -$4a792688e08e5cd7$var$Wc.y, -$4a792688e08e5cd7$var$Wc.z), $4a792688e08e5cd7$var$Dc.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse), this._frustum.setFromProjectionMatrix($4a792688e08e5cd7$var$Dc, i.coordinateSystem, i.reversedDepth);
    }
}
class $4a792688e08e5cd7$export$4c9c1cb3f0b6f455 extends $4a792688e08e5cd7$export$6ecadb6ed240d696 {
    constructor(t, e, i = 0, s = 2){
        super(t, e), this.isPointLight = !0, this.type = "PointLight", this.distance = i, this.decay = s, this.shadow = new $4a792688e08e5cd7$var$qc;
    }
    get power() {
        return 4 * this.intensity * Math.PI;
    }
    set power(t) {
        this.intensity = t / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t, e) {
        return super.copy(t, e), this.distance = t.distance, this.decay = t.decay, this.shadow = t.shadow.clone(), this;
    }
}
class $4a792688e08e5cd7$export$9ebf355ee4ed261b extends $4a792688e08e5cd7$export$79f141de891a5fed {
    constructor(t = -1, e = 1, i = 1, s = -1, r = .1, n = 2e3){
        super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t, this.right = e, this.top = i, this.bottom = s, this.near = r, this.far = n, this.updateProjectionMatrix();
    }
    copy(t, e) {
        return super.copy(t, e), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = null === t.view ? null : Object.assign({}, t.view), this;
    }
    setViewOffset(t, e, i, s, r, n) {
        null === this.view && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = i, this.view.offsetY = s, this.view.width = r, this.view.height = n, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const t = (this.right - this.left) / (2 * this.zoom), e = (this.top - this.bottom) / (2 * this.zoom), i = (this.right + this.left) / 2, s = (this.top + this.bottom) / 2;
        let r = i - t, n = i + t, a = s + e, o = s - e;
        if (null !== this.view && this.view.enabled) {
            const t = (this.right - this.left) / this.view.fullWidth / this.zoom, e = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            r += t * this.view.offsetX, n = r + t * this.view.width, a -= e * this.view.offsetY, o = a - e * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(r, n, a, o, this.near, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t) {
        const e = super.toJSON(t);
        return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, null !== this.view && (e.object.view = Object.assign({}, this.view)), e;
    }
}
class $4a792688e08e5cd7$var$Yc extends $4a792688e08e5cd7$var$Lc {
    constructor(){
        super(new $4a792688e08e5cd7$export$9ebf355ee4ed261b(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
    }
}
class $4a792688e08e5cd7$export$3fea33cc9972c868 extends $4a792688e08e5cd7$export$6ecadb6ed240d696 {
    constructor(t, e){
        super(t, e), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy($4a792688e08e5cd7$export$e4dd07dff30cc924.DEFAULT_UP), this.updateMatrix(), this.target = new $4a792688e08e5cd7$export$e4dd07dff30cc924, this.shadow = new $4a792688e08e5cd7$var$Yc;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t) {
        return super.copy(t), this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
}
class $4a792688e08e5cd7$export$af279bfef9ec2c96 extends $4a792688e08e5cd7$export$6ecadb6ed240d696 {
    constructor(t, e){
        super(t, e), this.isAmbientLight = !0, this.type = "AmbientLight";
    }
}
class $4a792688e08e5cd7$export$61db2d908bbd2429 extends $4a792688e08e5cd7$export$6ecadb6ed240d696 {
    constructor(t, e, i = 10, s = 10){
        super(t, e), this.isRectAreaLight = !0, this.type = "RectAreaLight", this.width = i, this.height = s;
    }
    get power() {
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(t) {
        this.intensity = t / (this.width * this.height * Math.PI);
    }
    copy(t) {
        return super.copy(t), this.width = t.width, this.height = t.height, this;
    }
    toJSON(t) {
        const e = super.toJSON(t);
        return e.object.width = this.width, e.object.height = this.height, e;
    }
}
class $4a792688e08e5cd7$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = !0, this.coefficients = [];
        for(let t = 0; t < 9; t++)this.coefficients.push(new $4a792688e08e5cd7$export$64b5c384219d3699);
    }
    set(t) {
        for(let e = 0; e < 9; e++)this.coefficients[e].copy(t[e]);
        return this;
    }
    zero() {
        for(let t = 0; t < 9; t++)this.coefficients[t].set(0, 0, 0);
        return this;
    }
    getAt(t, e) {
        const i = t.x, s = t.y, r = t.z, n = this.coefficients;
        return e.copy(n[0]).multiplyScalar(.282095), e.addScaledVector(n[1], .488603 * s), e.addScaledVector(n[2], .488603 * r), e.addScaledVector(n[3], .488603 * i), e.addScaledVector(n[4], i * s * 1.092548), e.addScaledVector(n[5], s * r * 1.092548), e.addScaledVector(n[6], .315392 * (3 * r * r - 1)), e.addScaledVector(n[7], i * r * 1.092548), e.addScaledVector(n[8], .546274 * (i * i - s * s)), e;
    }
    getIrradianceAt(t, e) {
        const i = t.x, s = t.y, r = t.z, n = this.coefficients;
        return e.copy(n[0]).multiplyScalar(.886227), e.addScaledVector(n[1], 1.023328 * s), e.addScaledVector(n[2], 1.023328 * r), e.addScaledVector(n[3], 1.023328 * i), e.addScaledVector(n[4], .858086 * i * s), e.addScaledVector(n[5], .858086 * s * r), e.addScaledVector(n[6], .743125 * r * r - .247708), e.addScaledVector(n[7], .858086 * i * r), e.addScaledVector(n[8], .429043 * (i * i - s * s)), e;
    }
    add(t) {
        for(let e = 0; e < 9; e++)this.coefficients[e].add(t.coefficients[e]);
        return this;
    }
    addScaledSH(t, e) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(t.coefficients[i], e);
        return this;
    }
    scale(t) {
        for(let e = 0; e < 9; e++)this.coefficients[e].multiplyScalar(t);
        return this;
    }
    lerp(t, e) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(t.coefficients[i], e);
        return this;
    }
    equals(t) {
        for(let e = 0; e < 9; e++)if (!this.coefficients[e].equals(t.coefficients[e])) return !1;
        return !0;
    }
    copy(t) {
        return this.set(t.coefficients);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    fromArray(t, e = 0) {
        const i = this.coefficients;
        for(let s = 0; s < 9; s++)i[s].fromArray(t, e + 3 * s);
        return this;
    }
    toArray(t = [], e = 0) {
        const i = this.coefficients;
        for(let s = 0; s < 9; s++)i[s].toArray(t, e + 3 * s);
        return t;
    }
    static getBasisAt(t, e) {
        const i = t.x, s = t.y, r = t.z;
        e[0] = .282095, e[1] = .488603 * s, e[2] = .488603 * r, e[3] = .488603 * i, e[4] = 1.092548 * i * s, e[5] = 1.092548 * s * r, e[6] = .315392 * (3 * r * r - 1), e[7] = 1.092548 * i * r, e[8] = .546274 * (i * i - s * s);
    }
}
class $4a792688e08e5cd7$export$e7ef036e309b38d2 extends $4a792688e08e5cd7$export$6ecadb6ed240d696 {
    constructor(t = new $4a792688e08e5cd7$export$ba61ce607e1f405a, e = 1){
        super(void 0, e), this.isLightProbe = !0, this.sh = t;
    }
    copy(t) {
        return super.copy(t), this.sh.copy(t.sh), this;
    }
    fromJSON(t) {
        return this.intensity = t.intensity, this.sh.fromArray(t.sh), this;
    }
    toJSON(t) {
        const e = super.toJSON(t);
        return e.object.sh = this.sh.toArray(), e;
    }
}
class $4a792688e08e5cd7$export$3bd6d323353dcf96 extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t), this.textures = {};
    }
    load(t, e, i, s) {
        const r = this, n = new $4a792688e08e5cd7$export$98435a25b5cf7b2b(r.manager);
        n.setPath(r.path), n.setRequestHeader(r.requestHeader), n.setWithCredentials(r.withCredentials), n.load(t, function(i) {
            try {
                e(r.parse(JSON.parse(i)));
            } catch (e) {
                s ? s(e) : $4a792688e08e5cd7$export$a3bc9b8ed74fc(e), r.manager.itemError(t);
            }
        }, i, s);
    }
    parse(t) {
        const e = this.textures;
        function i(t) {
            return void 0 === e[t] && $4a792688e08e5cd7$export$c106dd0671a0fc2d("MaterialLoader: Undefined texture", t), e[t];
        }
        const s = this.createMaterialFromType(t.type);
        if (void 0 !== t.uuid && (s.uuid = t.uuid), void 0 !== t.name && (s.name = t.name), void 0 !== t.color && void 0 !== s.color && s.color.setHex(t.color), void 0 !== t.roughness && (s.roughness = t.roughness), void 0 !== t.metalness && (s.metalness = t.metalness), void 0 !== t.sheen && (s.sheen = t.sheen), void 0 !== t.sheenColor && (s.sheenColor = (new $4a792688e08e5cd7$export$892596cec99bc70e).setHex(t.sheenColor)), void 0 !== t.sheenRoughness && (s.sheenRoughness = t.sheenRoughness), void 0 !== t.emissive && void 0 !== s.emissive && s.emissive.setHex(t.emissive), void 0 !== t.specular && void 0 !== s.specular && s.specular.setHex(t.specular), void 0 !== t.specularIntensity && (s.specularIntensity = t.specularIntensity), void 0 !== t.specularColor && void 0 !== s.specularColor && s.specularColor.setHex(t.specularColor), void 0 !== t.shininess && (s.shininess = t.shininess), void 0 !== t.clearcoat && (s.clearcoat = t.clearcoat), void 0 !== t.clearcoatRoughness && (s.clearcoatRoughness = t.clearcoatRoughness), void 0 !== t.dispersion && (s.dispersion = t.dispersion), void 0 !== t.iridescence && (s.iridescence = t.iridescence), void 0 !== t.iridescenceIOR && (s.iridescenceIOR = t.iridescenceIOR), void 0 !== t.iridescenceThicknessRange && (s.iridescenceThicknessRange = t.iridescenceThicknessRange), void 0 !== t.transmission && (s.transmission = t.transmission), void 0 !== t.thickness && (s.thickness = t.thickness), void 0 !== t.attenuationDistance && (s.attenuationDistance = t.attenuationDistance), void 0 !== t.attenuationColor && void 0 !== s.attenuationColor && s.attenuationColor.setHex(t.attenuationColor), void 0 !== t.anisotropy && (s.anisotropy = t.anisotropy), void 0 !== t.anisotropyRotation && (s.anisotropyRotation = t.anisotropyRotation), void 0 !== t.fog && (s.fog = t.fog), void 0 !== t.flatShading && (s.flatShading = t.flatShading), void 0 !== t.blending && (s.blending = t.blending), void 0 !== t.combine && (s.combine = t.combine), void 0 !== t.side && (s.side = t.side), void 0 !== t.shadowSide && (s.shadowSide = t.shadowSide), void 0 !== t.opacity && (s.opacity = t.opacity), void 0 !== t.transparent && (s.transparent = t.transparent), void 0 !== t.alphaTest && (s.alphaTest = t.alphaTest), void 0 !== t.alphaHash && (s.alphaHash = t.alphaHash), void 0 !== t.depthFunc && (s.depthFunc = t.depthFunc), void 0 !== t.depthTest && (s.depthTest = t.depthTest), void 0 !== t.depthWrite && (s.depthWrite = t.depthWrite), void 0 !== t.colorWrite && (s.colorWrite = t.colorWrite), void 0 !== t.blendSrc && (s.blendSrc = t.blendSrc), void 0 !== t.blendDst && (s.blendDst = t.blendDst), void 0 !== t.blendEquation && (s.blendEquation = t.blendEquation), void 0 !== t.blendSrcAlpha && (s.blendSrcAlpha = t.blendSrcAlpha), void 0 !== t.blendDstAlpha && (s.blendDstAlpha = t.blendDstAlpha), void 0 !== t.blendEquationAlpha && (s.blendEquationAlpha = t.blendEquationAlpha), void 0 !== t.blendColor && void 0 !== s.blendColor && s.blendColor.setHex(t.blendColor), void 0 !== t.blendAlpha && (s.blendAlpha = t.blendAlpha), void 0 !== t.stencilWriteMask && (s.stencilWriteMask = t.stencilWriteMask), void 0 !== t.stencilFunc && (s.stencilFunc = t.stencilFunc), void 0 !== t.stencilRef && (s.stencilRef = t.stencilRef), void 0 !== t.stencilFuncMask && (s.stencilFuncMask = t.stencilFuncMask), void 0 !== t.stencilFail && (s.stencilFail = t.stencilFail), void 0 !== t.stencilZFail && (s.stencilZFail = t.stencilZFail), void 0 !== t.stencilZPass && (s.stencilZPass = t.stencilZPass), void 0 !== t.stencilWrite && (s.stencilWrite = t.stencilWrite), void 0 !== t.wireframe && (s.wireframe = t.wireframe), void 0 !== t.wireframeLinewidth && (s.wireframeLinewidth = t.wireframeLinewidth), void 0 !== t.wireframeLinecap && (s.wireframeLinecap = t.wireframeLinecap), void 0 !== t.wireframeLinejoin && (s.wireframeLinejoin = t.wireframeLinejoin), void 0 !== t.rotation && (s.rotation = t.rotation), void 0 !== t.linewidth && (s.linewidth = t.linewidth), void 0 !== t.dashSize && (s.dashSize = t.dashSize), void 0 !== t.gapSize && (s.gapSize = t.gapSize), void 0 !== t.scale && (s.scale = t.scale), void 0 !== t.polygonOffset && (s.polygonOffset = t.polygonOffset), void 0 !== t.polygonOffsetFactor && (s.polygonOffsetFactor = t.polygonOffsetFactor), void 0 !== t.polygonOffsetUnits && (s.polygonOffsetUnits = t.polygonOffsetUnits), void 0 !== t.dithering && (s.dithering = t.dithering), void 0 !== t.alphaToCoverage && (s.alphaToCoverage = t.alphaToCoverage), void 0 !== t.premultipliedAlpha && (s.premultipliedAlpha = t.premultipliedAlpha), void 0 !== t.forceSinglePass && (s.forceSinglePass = t.forceSinglePass), void 0 !== t.visible && (s.visible = t.visible), void 0 !== t.toneMapped && (s.toneMapped = t.toneMapped), void 0 !== t.userData && (s.userData = t.userData), void 0 !== t.vertexColors && ("number" == typeof t.vertexColors ? s.vertexColors = t.vertexColors > 0 : s.vertexColors = t.vertexColors), void 0 !== t.uniforms) for(const e in t.uniforms){
            const r = t.uniforms[e];
            switch(s.uniforms[e] = {}, r.type){
                case "t":
                    s.uniforms[e].value = i(r.value);
                    break;
                case "c":
                    s.uniforms[e].value = (new $4a792688e08e5cd7$export$892596cec99bc70e).setHex(r.value);
                    break;
                case "v2":
                    s.uniforms[e].value = (new $4a792688e08e5cd7$export$c977b3e384af9ae1).fromArray(r.value);
                    break;
                case "v3":
                    s.uniforms[e].value = (new $4a792688e08e5cd7$export$64b5c384219d3699).fromArray(r.value);
                    break;
                case "v4":
                    s.uniforms[e].value = (new $4a792688e08e5cd7$export$fa7daccca11cdbe3).fromArray(r.value);
                    break;
                case "m3":
                    s.uniforms[e].value = (new $4a792688e08e5cd7$export$8ff26dafa08918).fromArray(r.value);
                    break;
                case "m4":
                    s.uniforms[e].value = (new $4a792688e08e5cd7$export$2ae72fc923e5eb5).fromArray(r.value);
                    break;
                default:
                    s.uniforms[e].value = r.value;
            }
        }
        if (void 0 !== t.defines && (s.defines = t.defines), void 0 !== t.vertexShader && (s.vertexShader = t.vertexShader), void 0 !== t.fragmentShader && (s.fragmentShader = t.fragmentShader), void 0 !== t.glslVersion && (s.glslVersion = t.glslVersion), void 0 !== t.extensions) for(const e in t.extensions)s.extensions[e] = t.extensions[e];
        if (void 0 !== t.lights && (s.lights = t.lights), void 0 !== t.clipping && (s.clipping = t.clipping), void 0 !== t.size && (s.size = t.size), void 0 !== t.sizeAttenuation && (s.sizeAttenuation = t.sizeAttenuation), void 0 !== t.map && (s.map = i(t.map)), void 0 !== t.matcap && (s.matcap = i(t.matcap)), void 0 !== t.alphaMap && (s.alphaMap = i(t.alphaMap)), void 0 !== t.bumpMap && (s.bumpMap = i(t.bumpMap)), void 0 !== t.bumpScale && (s.bumpScale = t.bumpScale), void 0 !== t.normalMap && (s.normalMap = i(t.normalMap)), void 0 !== t.normalMapType && (s.normalMapType = t.normalMapType), void 0 !== t.normalScale) {
            let e = t.normalScale;
            !1 === Array.isArray(e) && (e = [
                e,
                e
            ]), s.normalScale = (new $4a792688e08e5cd7$export$c977b3e384af9ae1).fromArray(e);
        }
        return void 0 !== t.displacementMap && (s.displacementMap = i(t.displacementMap)), void 0 !== t.displacementScale && (s.displacementScale = t.displacementScale), void 0 !== t.displacementBias && (s.displacementBias = t.displacementBias), void 0 !== t.roughnessMap && (s.roughnessMap = i(t.roughnessMap)), void 0 !== t.metalnessMap && (s.metalnessMap = i(t.metalnessMap)), void 0 !== t.emissiveMap && (s.emissiveMap = i(t.emissiveMap)), void 0 !== t.emissiveIntensity && (s.emissiveIntensity = t.emissiveIntensity), void 0 !== t.specularMap && (s.specularMap = i(t.specularMap)), void 0 !== t.specularIntensityMap && (s.specularIntensityMap = i(t.specularIntensityMap)), void 0 !== t.specularColorMap && (s.specularColorMap = i(t.specularColorMap)), void 0 !== t.envMap && (s.envMap = i(t.envMap)), void 0 !== t.envMapRotation && s.envMapRotation.fromArray(t.envMapRotation), void 0 !== t.envMapIntensity && (s.envMapIntensity = t.envMapIntensity), void 0 !== t.reflectivity && (s.reflectivity = t.reflectivity), void 0 !== t.refractionRatio && (s.refractionRatio = t.refractionRatio), void 0 !== t.lightMap && (s.lightMap = i(t.lightMap)), void 0 !== t.lightMapIntensity && (s.lightMapIntensity = t.lightMapIntensity), void 0 !== t.aoMap && (s.aoMap = i(t.aoMap)), void 0 !== t.aoMapIntensity && (s.aoMapIntensity = t.aoMapIntensity), void 0 !== t.gradientMap && (s.gradientMap = i(t.gradientMap)), void 0 !== t.clearcoatMap && (s.clearcoatMap = i(t.clearcoatMap)), void 0 !== t.clearcoatRoughnessMap && (s.clearcoatRoughnessMap = i(t.clearcoatRoughnessMap)), void 0 !== t.clearcoatNormalMap && (s.clearcoatNormalMap = i(t.clearcoatNormalMap)), void 0 !== t.clearcoatNormalScale && (s.clearcoatNormalScale = (new $4a792688e08e5cd7$export$c977b3e384af9ae1).fromArray(t.clearcoatNormalScale)), void 0 !== t.iridescenceMap && (s.iridescenceMap = i(t.iridescenceMap)), void 0 !== t.iridescenceThicknessMap && (s.iridescenceThicknessMap = i(t.iridescenceThicknessMap)), void 0 !== t.transmissionMap && (s.transmissionMap = i(t.transmissionMap)), void 0 !== t.thicknessMap && (s.thicknessMap = i(t.thicknessMap)), void 0 !== t.anisotropyMap && (s.anisotropyMap = i(t.anisotropyMap)), void 0 !== t.sheenColorMap && (s.sheenColorMap = i(t.sheenColorMap)), void 0 !== t.sheenRoughnessMap && (s.sheenRoughnessMap = i(t.sheenRoughnessMap)), s;
    }
    setTextures(t) {
        return this.textures = t, this;
    }
    createMaterialFromType(t) {
        return $4a792688e08e5cd7$export$3bd6d323353dcf96.createMaterialFromType(t);
    }
    static createMaterialFromType(t) {
        return new ({
            ShadowMaterial: $4a792688e08e5cd7$export$e8564da406055a3,
            SpriteMaterial: $4a792688e08e5cd7$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $4a792688e08e5cd7$export$21c421a2e1df9d22,
            ShaderMaterial: $4a792688e08e5cd7$export$83c7d75d550a8b0d,
            PointsMaterial: $4a792688e08e5cd7$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $4a792688e08e5cd7$export$28d04986c4269c9f,
            MeshStandardMaterial: $4a792688e08e5cd7$export$f2980790215acccd,
            MeshPhongMaterial: $4a792688e08e5cd7$export$24c72f71cbaf0678,
            MeshToonMaterial: $4a792688e08e5cd7$export$df893cf97e765622,
            MeshNormalMaterial: $4a792688e08e5cd7$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $4a792688e08e5cd7$export$5023a9a8114806b8,
            MeshDepthMaterial: $4a792688e08e5cd7$export$2698c22ec13825db,
            MeshDistanceMaterial: $4a792688e08e5cd7$export$33e187ed002f2a19,
            MeshBasicMaterial: $4a792688e08e5cd7$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $4a792688e08e5cd7$export$6f5fef6235ec12ee,
            LineDashedMaterial: $4a792688e08e5cd7$export$327886a3efaeaebe,
            LineBasicMaterial: $4a792688e08e5cd7$export$fbaaa33907730a0c,
            Material: $4a792688e08e5cd7$export$a2d8b23205c25948
        })[t];
    }
}
class $4a792688e08e5cd7$export$b5d2dc08d867e41a {
    static extractUrlBase(t) {
        const e = t.lastIndexOf("/");
        return -1 === e ? "./" : t.slice(0, e + 1);
    }
    static resolveURL(t, e) {
        return "string" != typeof t || "" === t ? "" : (/^https?:\/\//i.test(e) && /^\//.test(t) && (e = e.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(t) || /^data:.*,.*$/i.test(t) || /^blob:.*$/i.test(t) ? t : e + t);
    }
}
class $4a792688e08e5cd7$export$231f009cbe414146 extends $4a792688e08e5cd7$export$b7be63a67df8959 {
    constructor(){
        super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
    }
    copy(t) {
        return super.copy(t), this.instanceCount = t.instanceCount, this;
    }
    toJSON() {
        const t = super.toJSON();
        return t.instanceCount = this.instanceCount, t.isInstancedBufferGeometry = !0, t;
    }
}
class $4a792688e08e5cd7$export$dc275bb96327833a extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t);
    }
    load(t, e, i, s) {
        const r = this, n = new $4a792688e08e5cd7$export$98435a25b5cf7b2b(r.manager);
        n.setPath(r.path), n.setRequestHeader(r.requestHeader), n.setWithCredentials(r.withCredentials), n.load(t, function(i) {
            try {
                e(r.parse(JSON.parse(i)));
            } catch (e) {
                s ? s(e) : $4a792688e08e5cd7$export$a3bc9b8ed74fc(e), r.manager.itemError(t);
            }
        }, i, s);
    }
    parse(t) {
        const e = {}, i = {};
        function s(t, s) {
            if (void 0 !== e[s]) return e[s];
            const r = t.interleavedBuffers[s], n = function(t, e) {
                if (void 0 !== i[e]) return i[e];
                const s = t.arrayBuffers, r = s[e], n = new Uint32Array(r).buffer;
                return i[e] = n, n;
            }(t, r.buffer), a = $4a792688e08e5cd7$var$Di(r.type, n), o = new $4a792688e08e5cd7$export$3d5cd879f108f53f(a, r.stride);
            return o.uuid = r.uuid, e[s] = o, o;
        }
        const r = t.isInstancedBufferGeometry ? new $4a792688e08e5cd7$export$231f009cbe414146 : new $4a792688e08e5cd7$export$b7be63a67df8959, n = t.data.index;
        if (void 0 !== n) {
            const t = $4a792688e08e5cd7$var$Di(n.type, n.array);
            r.setIndex(new $4a792688e08e5cd7$export$8dea267bd6bde117(t, 1));
        }
        const a = t.data.attributes;
        for(const e in a){
            const i = a[e];
            let n;
            if (i.isInterleavedBufferAttribute) {
                const e = s(t.data, i.data);
                n = new $4a792688e08e5cd7$export$920b6d07334599c7(e, i.itemSize, i.offset, i.normalized);
            } else {
                const t = $4a792688e08e5cd7$var$Di(i.type, i.array);
                n = new (i.isInstancedBufferAttribute ? $4a792688e08e5cd7$export$32ea87a8b54d744a : $4a792688e08e5cd7$export$8dea267bd6bde117)(t, i.itemSize, i.normalized);
            }
            void 0 !== i.name && (n.name = i.name), void 0 !== i.usage && n.setUsage(i.usage), r.setAttribute(e, n);
        }
        const o = t.data.morphAttributes;
        if (o) for(const e in o){
            const i = o[e], n = [];
            for(let e = 0, r = i.length; e < r; e++){
                const r = i[e];
                let a;
                if (r.isInterleavedBufferAttribute) {
                    const e = s(t.data, r.data);
                    a = new $4a792688e08e5cd7$export$920b6d07334599c7(e, r.itemSize, r.offset, r.normalized);
                } else {
                    const t = $4a792688e08e5cd7$var$Di(r.type, r.array);
                    a = new $4a792688e08e5cd7$export$8dea267bd6bde117(t, r.itemSize, r.normalized);
                }
                void 0 !== r.name && (a.name = r.name), n.push(a);
            }
            r.morphAttributes[e] = n;
        }
        t.data.morphTargetsRelative && (r.morphTargetsRelative = !0);
        const h = t.data.groups || t.data.drawcalls || t.data.offsets;
        if (void 0 !== h) for(let t = 0, e = h.length; t !== e; ++t){
            const e = h[t];
            r.addGroup(e.start, e.count, e.materialIndex);
        }
        const l = t.data.boundingSphere;
        return void 0 !== l && (r.boundingSphere = (new $4a792688e08e5cd7$export$805e8b72413ccaba).fromJSON(l)), t.name && (r.name = t.name), t.userData && (r.userData = t.userData), r;
    }
}
class $4a792688e08e5cd7$export$40110c8505c5ad19 extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t);
    }
    load(t, e, i, s) {
        const r = this, n = "" === this.path ? $4a792688e08e5cd7$export$b5d2dc08d867e41a.extractUrlBase(t) : this.path;
        this.resourcePath = this.resourcePath || n;
        const a = new $4a792688e08e5cd7$export$98435a25b5cf7b2b(this.manager);
        a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(t, function(i) {
            let n = null;
            try {
                n = JSON.parse(i);
            } catch (e) {
                return void 0 !== s && s(e), void e("ObjectLoader: Can't parse " + t + ".", e.message);
            }
            const a = n.metadata;
            if (void 0 === a || void 0 === a.type || "geometry" === a.type.toLowerCase()) return void 0 !== s && s(new Error("THREE.ObjectLoader: Can't load " + t)), void $4a792688e08e5cd7$export$a3bc9b8ed74fc("ObjectLoader: Can't load " + t);
            r.parse(n, e);
        }, i, s);
    }
    async loadAsync(t, e) {
        const i = "" === this.path ? $4a792688e08e5cd7$export$b5d2dc08d867e41a.extractUrlBase(t) : this.path;
        this.resourcePath = this.resourcePath || i;
        const s = new $4a792688e08e5cd7$export$98435a25b5cf7b2b(this.manager);
        s.setPath(this.path), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials);
        const r = await s.loadAsync(t, e), n = JSON.parse(r), a = n.metadata;
        if (void 0 === a || void 0 === a.type || "geometry" === a.type.toLowerCase()) throw new Error("THREE.ObjectLoader: Can't load " + t);
        return await this.parseAsync(n);
    }
    parse(t, e) {
        const i = this.parseAnimations(t.animations), s = this.parseShapes(t.shapes), r = this.parseGeometries(t.geometries, s), n = this.parseImages(t.images, function() {
            void 0 !== e && e(h);
        }), a = this.parseTextures(t.textures, n), o = this.parseMaterials(t.materials, a), h = this.parseObject(t.object, r, o, a, i), l = this.parseSkeletons(t.skeletons, h);
        if (this.bindSkeletons(h, l), this.bindLightTargets(h), void 0 !== e) {
            let t = !1;
            for(const e in n)if (n[e].data instanceof HTMLImageElement) {
                t = !0;
                break;
            }
            !1 === t && e(h);
        }
        return h;
    }
    async parseAsync(t) {
        const e = this.parseAnimations(t.animations), i = this.parseShapes(t.shapes), s = this.parseGeometries(t.geometries, i), r = await this.parseImagesAsync(t.images), n = this.parseTextures(t.textures, r), a = this.parseMaterials(t.materials, n), o = this.parseObject(t.object, s, a, n, e), h = this.parseSkeletons(t.skeletons, o);
        return this.bindSkeletons(o, h), this.bindLightTargets(o), o;
    }
    parseShapes(t) {
        const e = {};
        if (void 0 !== t) for(let i = 0, s = t.length; i < s; i++){
            const s = (new $4a792688e08e5cd7$export$6428a7f2611ef1fa).fromJSON(t[i]);
            e[s.uuid] = s;
        }
        return e;
    }
    parseSkeletons(t, e) {
        const i = {}, s = {};
        if (e.traverse(function(t) {
            t.isBone && (s[t.uuid] = t);
        }), void 0 !== t) for(let e = 0, r = t.length; e < r; e++){
            const r = (new $4a792688e08e5cd7$export$8f31e4c4a37b8e9c).fromJSON(t[e], s);
            i[r.uuid] = r;
        }
        return i;
    }
    parseGeometries(t, e) {
        const i = {};
        if (void 0 !== t) {
            const s = new $4a792688e08e5cd7$export$dc275bb96327833a;
            for(let r = 0, n = t.length; r < n; r++){
                let n;
                const a = t[r];
                switch(a.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        n = s.parse(a);
                        break;
                    default:
                        a.type in $4a792688e08e5cd7$var$jl ? n = $4a792688e08e5cd7$var$jl[a.type].fromJSON(a, e) : $4a792688e08e5cd7$export$c106dd0671a0fc2d(`ObjectLoader: Unsupported geometry type "${a.type}"`);
                }
                n.uuid = a.uuid, void 0 !== a.name && (n.name = a.name), void 0 !== a.userData && (n.userData = a.userData), i[a.uuid] = n;
            }
        }
        return i;
    }
    parseMaterials(t, e) {
        const i = {}, s = {};
        if (void 0 !== t) {
            const r = new $4a792688e08e5cd7$export$3bd6d323353dcf96;
            r.setTextures(e);
            for(let e = 0, n = t.length; e < n; e++){
                const n = t[e];
                void 0 === i[n.uuid] && (i[n.uuid] = r.parse(n)), s[n.uuid] = i[n.uuid];
            }
        }
        return s;
    }
    parseAnimations(t) {
        const e = {};
        if (void 0 !== t) for(let i = 0; i < t.length; i++){
            const s = t[i], r = $4a792688e08e5cd7$export$d942c706bf23829c.parse(s);
            e[r.uuid] = r;
        }
        return e;
    }
    parseImages(t, e) {
        const i = this, s = {};
        let r;
        function n(t) {
            if ("string" == typeof t) {
                const e = t;
                return function(t) {
                    return i.manager.itemStart(t), r.load(t, function() {
                        i.manager.itemEnd(t);
                    }, void 0, function() {
                        i.manager.itemError(t), i.manager.itemEnd(t);
                    });
                }(/^(\/\/)|([a-z]+:(\/\/)?)/i.test(e) ? e : i.resourcePath + e);
            }
            return t.data ? {
                data: $4a792688e08e5cd7$var$Di(t.type, t.data),
                width: t.width,
                height: t.height
            } : null;
        }
        if (void 0 !== t && t.length > 0) {
            const i = new $4a792688e08e5cd7$export$99cc795e99919eed(e);
            r = new $4a792688e08e5cd7$export$8905ce1c7a2464a1(i), r.setCrossOrigin(this.crossOrigin);
            for(let e = 0, i = t.length; e < i; e++){
                const i = t[e], r = i.url;
                if (Array.isArray(r)) {
                    const t = [];
                    for(let e = 0, i = r.length; e < i; e++){
                        const i = n(r[e]);
                        null !== i && (i instanceof HTMLImageElement ? t.push(i) : t.push(new $4a792688e08e5cd7$export$b691f601014eabe1(i.data, i.width, i.height)));
                    }
                    s[i.uuid] = new $4a792688e08e5cd7$export$1d2df86270c81ecb(t);
                } else {
                    const t = n(i.url);
                    s[i.uuid] = new $4a792688e08e5cd7$export$1d2df86270c81ecb(t);
                }
            }
        }
        return s;
    }
    async parseImagesAsync(t) {
        const e = this, i = {};
        let s;
        async function r(t) {
            if ("string" == typeof t) {
                const i = t, r = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(i) ? i : e.resourcePath + i;
                return await s.loadAsync(r);
            }
            return t.data ? {
                data: $4a792688e08e5cd7$var$Di(t.type, t.data),
                width: t.width,
                height: t.height
            } : null;
        }
        if (void 0 !== t && t.length > 0) {
            s = new $4a792688e08e5cd7$export$8905ce1c7a2464a1(this.manager), s.setCrossOrigin(this.crossOrigin);
            for(let e = 0, s = t.length; e < s; e++){
                const s = t[e], n = s.url;
                if (Array.isArray(n)) {
                    const t = [];
                    for(let e = 0, i = n.length; e < i; e++){
                        const i = n[e], s = await r(i);
                        null !== s && (s instanceof HTMLImageElement ? t.push(s) : t.push(new $4a792688e08e5cd7$export$b691f601014eabe1(s.data, s.width, s.height)));
                    }
                    i[s.uuid] = new $4a792688e08e5cd7$export$1d2df86270c81ecb(t);
                } else {
                    const t = await r(s.url);
                    i[s.uuid] = new $4a792688e08e5cd7$export$1d2df86270c81ecb(t);
                }
            }
        }
        return i;
    }
    parseTextures(t, e) {
        function i(t, e) {
            return "number" == typeof t ? t : ($4a792688e08e5cd7$export$c106dd0671a0fc2d("ObjectLoader.parseTexture: Constant should be in numeric form.", t), e[t]);
        }
        const s = {};
        if (void 0 !== t) for(let r = 0, n = t.length; r < n; r++){
            const n = t[r];
            void 0 === n.image && $4a792688e08e5cd7$export$c106dd0671a0fc2d('ObjectLoader: No "image" specified for', n.uuid), void 0 === e[n.image] && $4a792688e08e5cd7$export$c106dd0671a0fc2d("ObjectLoader: Undefined image", n.image);
            const a = e[n.image], o = a.data;
            let h;
            Array.isArray(o) ? (h = new $4a792688e08e5cd7$export$ee2e5a18258a4049, 6 === o.length && (h.needsUpdate = !0)) : (h = o && o.data ? new $4a792688e08e5cd7$export$b691f601014eabe1 : new $4a792688e08e5cd7$export$5431306cf43de24a, o && (h.needsUpdate = !0)), h.source = a, h.uuid = n.uuid, void 0 !== n.name && (h.name = n.name), void 0 !== n.mapping && (h.mapping = i(n.mapping, $4a792688e08e5cd7$var$ru)), void 0 !== n.channel && (h.channel = n.channel), void 0 !== n.offset && h.offset.fromArray(n.offset), void 0 !== n.repeat && h.repeat.fromArray(n.repeat), void 0 !== n.center && h.center.fromArray(n.center), void 0 !== n.rotation && (h.rotation = n.rotation), void 0 !== n.wrap && (h.wrapS = i(n.wrap[0], $4a792688e08e5cd7$var$nu), h.wrapT = i(n.wrap[1], $4a792688e08e5cd7$var$nu)), void 0 !== n.format && (h.format = n.format), void 0 !== n.internalFormat && (h.internalFormat = n.internalFormat), void 0 !== n.type && (h.type = n.type), void 0 !== n.colorSpace && (h.colorSpace = n.colorSpace), void 0 !== n.minFilter && (h.minFilter = i(n.minFilter, $4a792688e08e5cd7$var$au)), void 0 !== n.magFilter && (h.magFilter = i(n.magFilter, $4a792688e08e5cd7$var$au)), void 0 !== n.anisotropy && (h.anisotropy = n.anisotropy), void 0 !== n.flipY && (h.flipY = n.flipY), void 0 !== n.generateMipmaps && (h.generateMipmaps = n.generateMipmaps), void 0 !== n.premultiplyAlpha && (h.premultiplyAlpha = n.premultiplyAlpha), void 0 !== n.unpackAlignment && (h.unpackAlignment = n.unpackAlignment), void 0 !== n.compareFunction && (h.compareFunction = n.compareFunction), void 0 !== n.userData && (h.userData = n.userData), s[n.uuid] = h;
        }
        return s;
    }
    parseObject(t, e, i, s, r) {
        let n, a, o;
        function h(t) {
            return void 0 === e[t] && $4a792688e08e5cd7$export$c106dd0671a0fc2d("ObjectLoader: Undefined geometry", t), e[t];
        }
        function l(t) {
            if (void 0 !== t) {
                if (Array.isArray(t)) {
                    const e = [];
                    for(let s = 0, r = t.length; s < r; s++){
                        const r = t[s];
                        void 0 === i[r] && $4a792688e08e5cd7$export$c106dd0671a0fc2d("ObjectLoader: Undefined material", r), e.push(i[r]);
                    }
                    return e;
                }
                return void 0 === i[t] && $4a792688e08e5cd7$export$c106dd0671a0fc2d("ObjectLoader: Undefined material", t), i[t];
            }
        }
        function c(t) {
            return void 0 === s[t] && $4a792688e08e5cd7$export$c106dd0671a0fc2d("ObjectLoader: Undefined texture", t), s[t];
        }
        switch(t.type){
            case "Scene":
                n = new $4a792688e08e5cd7$export$38af1803e3442a7f, void 0 !== t.background && (Number.isInteger(t.background) ? n.background = new $4a792688e08e5cd7$export$892596cec99bc70e(t.background) : n.background = c(t.background)), void 0 !== t.environment && (n.environment = c(t.environment)), void 0 !== t.fog && ("Fog" === t.fog.type ? n.fog = new $4a792688e08e5cd7$export$3c890837b09508d4(t.fog.color, t.fog.near, t.fog.far) : "FogExp2" === t.fog.type && (n.fog = new $4a792688e08e5cd7$export$6f1519f023b8d0f6(t.fog.color, t.fog.density)), "" !== t.fog.name && (n.fog.name = t.fog.name)), void 0 !== t.backgroundBlurriness && (n.backgroundBlurriness = t.backgroundBlurriness), void 0 !== t.backgroundIntensity && (n.backgroundIntensity = t.backgroundIntensity), void 0 !== t.backgroundRotation && n.backgroundRotation.fromArray(t.backgroundRotation), void 0 !== t.environmentIntensity && (n.environmentIntensity = t.environmentIntensity), void 0 !== t.environmentRotation && n.environmentRotation.fromArray(t.environmentRotation);
                break;
            case "PerspectiveCamera":
                n = new $4a792688e08e5cd7$export$74e4ae24825f68d7(t.fov, t.aspect, t.near, t.far), void 0 !== t.focus && (n.focus = t.focus), void 0 !== t.zoom && (n.zoom = t.zoom), void 0 !== t.filmGauge && (n.filmGauge = t.filmGauge), void 0 !== t.filmOffset && (n.filmOffset = t.filmOffset), void 0 !== t.view && (n.view = Object.assign({}, t.view));
                break;
            case "OrthographicCamera":
                n = new $4a792688e08e5cd7$export$9ebf355ee4ed261b(t.left, t.right, t.top, t.bottom, t.near, t.far), void 0 !== t.zoom && (n.zoom = t.zoom), void 0 !== t.view && (n.view = Object.assign({}, t.view));
                break;
            case "AmbientLight":
                n = new $4a792688e08e5cd7$export$af279bfef9ec2c96(t.color, t.intensity);
                break;
            case "DirectionalLight":
                n = new $4a792688e08e5cd7$export$3fea33cc9972c868(t.color, t.intensity), n.target = t.target || "";
                break;
            case "PointLight":
                n = new $4a792688e08e5cd7$export$4c9c1cb3f0b6f455(t.color, t.intensity, t.distance, t.decay);
                break;
            case "RectAreaLight":
                n = new $4a792688e08e5cd7$export$61db2d908bbd2429(t.color, t.intensity, t.width, t.height);
                break;
            case "SpotLight":
                n = new $4a792688e08e5cd7$export$81495cbb73897362(t.color, t.intensity, t.distance, t.angle, t.penumbra, t.decay), n.target = t.target || "";
                break;
            case "HemisphereLight":
                n = new $4a792688e08e5cd7$export$8d474f55edbb9624(t.color, t.groundColor, t.intensity);
                break;
            case "LightProbe":
                n = (new $4a792688e08e5cd7$export$e7ef036e309b38d2).fromJSON(t);
                break;
            case "SkinnedMesh":
                a = h(t.geometry), o = l(t.material), n = new $4a792688e08e5cd7$export$b303577035157ecf(a, o), void 0 !== t.bindMode && (n.bindMode = t.bindMode), void 0 !== t.bindMatrix && n.bindMatrix.fromArray(t.bindMatrix), void 0 !== t.skeleton && (n.skeleton = t.skeleton);
                break;
            case "Mesh":
                a = h(t.geometry), o = l(t.material), n = new $4a792688e08e5cd7$export$e176487c05830cc5(a, o);
                break;
            case "InstancedMesh":
                a = h(t.geometry), o = l(t.material);
                const e1 = t.count, i1 = t.instanceMatrix, s1 = t.instanceColor;
                n = new $4a792688e08e5cd7$export$f3c979c331175ad7(a, o, e1), n.instanceMatrix = new $4a792688e08e5cd7$export$32ea87a8b54d744a(new Float32Array(i1.array), 16), void 0 !== s1 && (n.instanceColor = new $4a792688e08e5cd7$export$32ea87a8b54d744a(new Float32Array(s1.array), s1.itemSize));
                break;
            case "BatchedMesh":
                a = h(t.geometry), o = l(t.material), n = new $4a792688e08e5cd7$export$6e01c5ee52ed8f7b(t.maxInstanceCount, t.maxVertexCount, t.maxIndexCount, o), n.geometry = a, n.perObjectFrustumCulled = t.perObjectFrustumCulled, n.sortObjects = t.sortObjects, n._drawRanges = t.drawRanges, n._reservedRanges = t.reservedRanges, n._geometryInfo = t.geometryInfo.map((t)=>{
                    let e = null, i = null;
                    return void 0 !== t.boundingBox && (e = (new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3).fromJSON(t.boundingBox)), void 0 !== t.boundingSphere && (i = (new $4a792688e08e5cd7$export$805e8b72413ccaba).fromJSON(t.boundingSphere)), {
                        ...t,
                        boundingBox: e,
                        boundingSphere: i
                    };
                }), n._instanceInfo = t.instanceInfo, n._availableInstanceIds = t._availableInstanceIds, n._availableGeometryIds = t._availableGeometryIds, n._nextIndexStart = t.nextIndexStart, n._nextVertexStart = t.nextVertexStart, n._geometryCount = t.geometryCount, n._maxInstanceCount = t.maxInstanceCount, n._maxVertexCount = t.maxVertexCount, n._maxIndexCount = t.maxIndexCount, n._geometryInitialized = t.geometryInitialized, n._matricesTexture = c(t.matricesTexture.uuid), n._indirectTexture = c(t.indirectTexture.uuid), void 0 !== t.colorsTexture && (n._colorsTexture = c(t.colorsTexture.uuid)), void 0 !== t.boundingSphere && (n.boundingSphere = (new $4a792688e08e5cd7$export$805e8b72413ccaba).fromJSON(t.boundingSphere)), void 0 !== t.boundingBox && (n.boundingBox = (new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3).fromJSON(t.boundingBox));
                break;
            case "LOD":
                n = new $4a792688e08e5cd7$export$112e7237be0c5f30;
                break;
            case "Line":
                n = new $4a792688e08e5cd7$export$17d680238e50603e(h(t.geometry), l(t.material));
                break;
            case "LineLoop":
                n = new $4a792688e08e5cd7$export$f85a24d745e4f17d(h(t.geometry), l(t.material));
                break;
            case "LineSegments":
                n = new $4a792688e08e5cd7$export$ff1ed10fedfdd604(h(t.geometry), l(t.material));
                break;
            case "PointCloud":
            case "Points":
                n = new $4a792688e08e5cd7$export$1c787534cb11aa3e(h(t.geometry), l(t.material));
                break;
            case "Sprite":
                n = new $4a792688e08e5cd7$export$3075603db8e6204c(l(t.material));
                break;
            case "Group":
                n = new $4a792688e08e5cd7$export$eb2fcfdbd7ba97d4;
                break;
            case "Bone":
                n = new $4a792688e08e5cd7$export$b127726e56765aa4;
                break;
            default:
                n = new $4a792688e08e5cd7$export$e4dd07dff30cc924;
        }
        if (n.uuid = t.uuid, void 0 !== t.name && (n.name = t.name), void 0 !== t.matrix ? (n.matrix.fromArray(t.matrix), void 0 !== t.matrixAutoUpdate && (n.matrixAutoUpdate = t.matrixAutoUpdate), n.matrixAutoUpdate && n.matrix.decompose(n.position, n.quaternion, n.scale)) : (void 0 !== t.position && n.position.fromArray(t.position), void 0 !== t.rotation && n.rotation.fromArray(t.rotation), void 0 !== t.quaternion && n.quaternion.fromArray(t.quaternion), void 0 !== t.scale && n.scale.fromArray(t.scale)), void 0 !== t.up && n.up.fromArray(t.up), void 0 !== t.castShadow && (n.castShadow = t.castShadow), void 0 !== t.receiveShadow && (n.receiveShadow = t.receiveShadow), t.shadow && (void 0 !== t.shadow.intensity && (n.shadow.intensity = t.shadow.intensity), void 0 !== t.shadow.bias && (n.shadow.bias = t.shadow.bias), void 0 !== t.shadow.normalBias && (n.shadow.normalBias = t.shadow.normalBias), void 0 !== t.shadow.radius && (n.shadow.radius = t.shadow.radius), void 0 !== t.shadow.mapSize && n.shadow.mapSize.fromArray(t.shadow.mapSize), void 0 !== t.shadow.camera && (n.shadow.camera = this.parseObject(t.shadow.camera))), void 0 !== t.visible && (n.visible = t.visible), void 0 !== t.frustumCulled && (n.frustumCulled = t.frustumCulled), void 0 !== t.renderOrder && (n.renderOrder = t.renderOrder), void 0 !== t.userData && (n.userData = t.userData), void 0 !== t.layers && (n.layers.mask = t.layers), void 0 !== t.children) {
            const a = t.children;
            for(let t = 0; t < a.length; t++)n.add(this.parseObject(a[t], e, i, s, r));
        }
        if (void 0 !== t.animations) {
            const e = t.animations;
            for(let t = 0; t < e.length; t++){
                const i = e[t];
                n.animations.push(r[i]);
            }
        }
        if ("LOD" === t.type) {
            void 0 !== t.autoUpdate && (n.autoUpdate = t.autoUpdate);
            const e = t.levels;
            for(let t = 0; t < e.length; t++){
                const i = e[t], s = n.getObjectByProperty("uuid", i.object);
                void 0 !== s && n.addLevel(s, i.distance, i.hysteresis);
            }
        }
        return n;
    }
    bindSkeletons(t, e) {
        0 !== Object.keys(e).length && t.traverse(function(t) {
            if (!0 === t.isSkinnedMesh && void 0 !== t.skeleton) {
                const i = e[t.skeleton];
                void 0 === i ? $4a792688e08e5cd7$export$c106dd0671a0fc2d("ObjectLoader: No skeleton found with UUID:", t.skeleton) : t.bind(i, t.bindMatrix);
            }
        });
    }
    bindLightTargets(t) {
        t.traverse(function(e) {
            if (e.isDirectionalLight || e.isSpotLight) {
                const i = e.target, s = t.getObjectByProperty("uuid", i);
                e.target = void 0 !== s ? s : new $4a792688e08e5cd7$export$e4dd07dff30cc924;
            }
        });
    }
}
const $4a792688e08e5cd7$var$ru = {
    UVMapping: $4a792688e08e5cd7$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $4a792688e08e5cd7$export$8759762a6477f2c4,
    CubeRefractionMapping: 302,
    EquirectangularReflectionMapping: 303,
    EquirectangularRefractionMapping: 304,
    CubeUVReflectionMapping: 306
}, $4a792688e08e5cd7$var$nu = {
    RepeatWrapping: $4a792688e08e5cd7$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $4a792688e08e5cd7$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $4a792688e08e5cd7$export$c7e7c00b14f51a4f
}, $4a792688e08e5cd7$var$au = {
    NearestFilter: $4a792688e08e5cd7$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: 1004,
    NearestMipmapLinearFilter: 1005,
    LinearFilter: $4a792688e08e5cd7$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: 1007,
    LinearMipmapLinearFilter: $4a792688e08e5cd7$export$5d8599b6a933fb1b
}, $4a792688e08e5cd7$var$ou = new WeakMap;
class $4a792688e08e5cd7$export$52286b55c4a9b51f extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t), this.isImageBitmapLoader = !0, "undefined" == typeof createImageBitmap && $4a792688e08e5cd7$export$c106dd0671a0fc2d("ImageBitmapLoader: createImageBitmap() not supported."), "undefined" == typeof fetch && $4a792688e08e5cd7$export$c106dd0671a0fc2d("ImageBitmapLoader: fetch() not supported."), this.options = {
            premultiplyAlpha: "none"
        }, this._abortController = new AbortController;
    }
    setOptions(t) {
        return this.options = t, this;
    }
    load(t, e, i, s) {
        void 0 === t && (t = ""), void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
        const r = this, n = $4a792688e08e5cd7$export$94affb487e701bf2.get(`image-bitmap:${t}`);
        if (void 0 !== n) return r.manager.itemStart(t), n.then ? void n.then((i)=>{
            if (!0 !== $4a792688e08e5cd7$var$ou.has(n)) return e && e(i), r.manager.itemEnd(t), i;
            s && s($4a792688e08e5cd7$var$ou.get(n)), r.manager.itemError(t), r.manager.itemEnd(t);
        }) : (setTimeout(function() {
            e && e(n), r.manager.itemEnd(t);
        }, 0), n);
        const a = {};
        a.credentials = "anonymous" === this.crossOrigin ? "same-origin" : "include", a.headers = this.requestHeader, a.signal = "function" == typeof AbortSignal.any ? AbortSignal.any([
            this._abortController.signal,
            this.manager.abortController.signal
        ]) : this._abortController.signal;
        const o = fetch(t, a).then(function(t) {
            return t.blob();
        }).then(function(t) {
            return createImageBitmap(t, Object.assign(r.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(i) {
            return $4a792688e08e5cd7$export$94affb487e701bf2.add(`image-bitmap:${t}`, i), e && e(i), r.manager.itemEnd(t), i;
        }).catch(function(e) {
            s && s(e), $4a792688e08e5cd7$var$ou.set(o, e), $4a792688e08e5cd7$export$94affb487e701bf2.remove(`image-bitmap:${t}`), r.manager.itemError(t), r.manager.itemEnd(t);
        });
        $4a792688e08e5cd7$export$94affb487e701bf2.add(`image-bitmap:${t}`, o), r.manager.itemStart(t);
    }
    abort() {
        return this._abortController.abort(), this._abortController = new AbortController, this;
    }
}
let $4a792688e08e5cd7$var$lu;
class $4a792688e08e5cd7$export$fcbc63750ec2a81f {
    static getContext() {
        return void 0 === $4a792688e08e5cd7$var$lu && ($4a792688e08e5cd7$var$lu = new (window.AudioContext || window.webkitAudioContext)), $4a792688e08e5cd7$var$lu;
    }
    static setContext(t) {
        $4a792688e08e5cd7$var$lu = t;
    }
}
class $4a792688e08e5cd7$export$d8d5fccfbf47714e extends $4a792688e08e5cd7$export$3b0d6d7590275603 {
    constructor(t){
        super(t);
    }
    load(t, e, i, s) {
        const r = this, n = new $4a792688e08e5cd7$export$98435a25b5cf7b2b(this.manager);
        function a(e) {
            s ? s(e) : $4a792688e08e5cd7$export$a3bc9b8ed74fc(e), r.manager.itemError(t);
        }
        n.setResponseType("arraybuffer"), n.setPath(this.path), n.setRequestHeader(this.requestHeader), n.setWithCredentials(this.withCredentials), n.load(t, function(t) {
            try {
                const i = t.slice(0);
                $4a792688e08e5cd7$export$fcbc63750ec2a81f.getContext().decodeAudioData(i, function(t) {
                    e(t);
                }).catch(a);
            } catch (t) {
                a(t);
            }
        }, i, s);
    }
}
const $4a792688e08e5cd7$var$du = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$pu = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$mu = new $4a792688e08e5cd7$export$2ae72fc923e5eb5;
class $4a792688e08e5cd7$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera", this.aspect = 1, this.eyeSep = .064, this.cameraL = new $4a792688e08e5cd7$export$74e4ae24825f68d7, this.cameraL.layers.enable(1), this.cameraL.matrixAutoUpdate = !1, this.cameraR = new $4a792688e08e5cd7$export$74e4ae24825f68d7, this.cameraR.layers.enable(2), this.cameraR.matrixAutoUpdate = !1, this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(t) {
        const e = this._cache;
        if (e.focus !== t.focus || e.fov !== t.fov || e.aspect !== t.aspect * this.aspect || e.near !== t.near || e.far !== t.far || e.zoom !== t.zoom || e.eyeSep !== this.eyeSep) {
            e.focus = t.focus, e.fov = t.fov, e.aspect = t.aspect * this.aspect, e.near = t.near, e.far = t.far, e.zoom = t.zoom, e.eyeSep = this.eyeSep, $4a792688e08e5cd7$var$mu.copy(t.projectionMatrix);
            const i = e.eyeSep / 2, s = i * e.near / e.focus, r = e.near * Math.tan($4a792688e08e5cd7$var$is * e.fov * .5) / e.zoom;
            let n, a;
            $4a792688e08e5cd7$var$pu.elements[12] = -i, $4a792688e08e5cd7$var$du.elements[12] = i, n = -r * e.aspect + s, a = r * e.aspect + s, $4a792688e08e5cd7$var$mu.elements[0] = 2 * e.near / (a - n), $4a792688e08e5cd7$var$mu.elements[8] = (a + n) / (a - n), this.cameraL.projectionMatrix.copy($4a792688e08e5cd7$var$mu), n = -r * e.aspect - s, a = r * e.aspect - s, $4a792688e08e5cd7$var$mu.elements[0] = 2 * e.near / (a - n), $4a792688e08e5cd7$var$mu.elements[8] = (a + n) / (a - n), this.cameraR.projectionMatrix.copy($4a792688e08e5cd7$var$mu);
        }
        this.cameraL.matrixWorld.copy(t.matrixWorld).multiply($4a792688e08e5cd7$var$pu), this.cameraR.matrixWorld.copy(t.matrixWorld).multiply($4a792688e08e5cd7$var$du);
    }
}
class $4a792688e08e5cd7$export$56b937d9e5581166 extends $4a792688e08e5cd7$export$74e4ae24825f68d7 {
    constructor(t = []){
        super(), this.isArrayCamera = !0, this.isMultiViewCamera = !1, this.cameras = t;
    }
}
class $4a792688e08e5cd7$export$9735c82c4bae3302 {
    constructor(t = !0){
        this.autoStart = t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
    }
    start() {
        this.startTime = performance.now(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
    }
    stop() {
        this.getElapsedTime(), this.running = !1, this.autoStart = !1;
    }
    getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
    }
    getDelta() {
        let t = 0;
        if (this.autoStart && !this.running) return this.start(), 0;
        if (this.running) {
            const e = performance.now();
            t = (e - this.oldTime) / 1e3, this.oldTime = e, this.elapsedTime += t;
        }
        return t;
    }
}
const $4a792688e08e5cd7$var$xu = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$bu = new $4a792688e08e5cd7$export$23d6a54f0bbc85a3, $4a792688e08e5cd7$var$vu = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$wu = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Mu = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$8a1b810c6fde8951 extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(){
        super(), this.type = "AudioListener", this.context = $4a792688e08e5cd7$export$fcbc63750ec2a81f.getContext(), this.gain = this.context.createGain(), this.gain.connect(this.context.destination), this.filter = null, this.timeDelta = 0, this._clock = new $4a792688e08e5cd7$export$9735c82c4bae3302;
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        return null !== this.filter && (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination), this.gain.connect(this.context.destination), this.filter = null), this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(t) {
        return null !== this.filter ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination)) : this.gain.disconnect(this.context.destination), this.filter = t, this.gain.connect(this.filter), this.filter.connect(this.context.destination), this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(t) {
        return this.gain.gain.setTargetAtTime(t, this.context.currentTime, .01), this;
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t);
        const e = this.context.listener;
        if (this.timeDelta = this._clock.getDelta(), this.matrixWorld.decompose($4a792688e08e5cd7$var$xu, $4a792688e08e5cd7$var$bu, $4a792688e08e5cd7$var$vu), $4a792688e08e5cd7$var$wu.set(0, 0, -1).applyQuaternion($4a792688e08e5cd7$var$bu), $4a792688e08e5cd7$var$Mu.set(0, 1, 0).applyQuaternion($4a792688e08e5cd7$var$bu), e.positionX) {
            const t = this.context.currentTime + this.timeDelta;
            e.positionX.linearRampToValueAtTime($4a792688e08e5cd7$var$xu.x, t), e.positionY.linearRampToValueAtTime($4a792688e08e5cd7$var$xu.y, t), e.positionZ.linearRampToValueAtTime($4a792688e08e5cd7$var$xu.z, t), e.forwardX.linearRampToValueAtTime($4a792688e08e5cd7$var$wu.x, t), e.forwardY.linearRampToValueAtTime($4a792688e08e5cd7$var$wu.y, t), e.forwardZ.linearRampToValueAtTime($4a792688e08e5cd7$var$wu.z, t), e.upX.linearRampToValueAtTime($4a792688e08e5cd7$var$Mu.x, t), e.upY.linearRampToValueAtTime($4a792688e08e5cd7$var$Mu.y, t), e.upZ.linearRampToValueAtTime($4a792688e08e5cd7$var$Mu.z, t);
        } else e.setPosition($4a792688e08e5cd7$var$xu.x, $4a792688e08e5cd7$var$xu.y, $4a792688e08e5cd7$var$xu.z), e.setOrientation($4a792688e08e5cd7$var$wu.x, $4a792688e08e5cd7$var$wu.y, $4a792688e08e5cd7$var$wu.z, $4a792688e08e5cd7$var$Mu.x, $4a792688e08e5cd7$var$Mu.y, $4a792688e08e5cd7$var$Mu.z);
    }
}
class $4a792688e08e5cd7$export$153755f98d9861de extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(t){
        super(), this.type = "Audio", this.listener = t, this.context = t.context, this.gain = this.context.createGain(), this.gain.connect(t.getInput()), this.autoplay = !1, this.buffer = null, this.detune = 0, this.loop = !1, this.loopStart = 0, this.loopEnd = 0, this.offset = 0, this.duration = void 0, this.playbackRate = 1, this.isPlaying = !1, this.hasPlaybackControl = !0, this.source = null, this.sourceType = "empty", this._startedAt = 0, this._progress = 0, this._connected = !1, this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(t) {
        return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = t, this.connect(), this;
    }
    setMediaElementSource(t) {
        return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(t), this.connect(), this;
    }
    setMediaStreamSource(t) {
        return this.hasPlaybackControl = !1, this.sourceType = "mediaStreamNode", this.source = this.context.createMediaStreamSource(t), this.connect(), this;
    }
    setBuffer(t) {
        return this.buffer = t, this.sourceType = "buffer", this.autoplay && this.play(), this;
    }
    play(t = 0) {
        if (!0 === this.isPlaying) return void $4a792688e08e5cd7$export$c106dd0671a0fc2d("Audio: Audio is already playing.");
        if (!1 === this.hasPlaybackControl) return void $4a792688e08e5cd7$export$c106dd0671a0fc2d("Audio: this Audio has no playback control.");
        this._startedAt = this.context.currentTime + t;
        const e = this.context.createBufferSource();
        return e.buffer = this.buffer, e.loop = this.loop, e.loopStart = this.loopStart, e.loopEnd = this.loopEnd, e.onended = this.onEnded.bind(this), e.start(this._startedAt, this._progress + this.offset, this.duration), this.isPlaying = !0, this.source = e, this.setDetune(this.detune), this.setPlaybackRate(this.playbackRate), this.connect();
    }
    pause() {
        if (!1 !== this.hasPlaybackControl) return !0 === this.isPlaying && (this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate, !0 === this.loop && (this._progress = this._progress % (this.duration || this.buffer.duration)), this.source.stop(), this.source.onended = null, this.isPlaying = !1), this;
        $4a792688e08e5cd7$export$c106dd0671a0fc2d("Audio: this Audio has no playback control.");
    }
    stop(t = 0) {
        if (!1 !== this.hasPlaybackControl) return this._progress = 0, null !== this.source && (this.source.stop(this.context.currentTime + t), this.source.onended = null), this.isPlaying = !1, this;
        $4a792688e08e5cd7$export$c106dd0671a0fc2d("Audio: this Audio has no playback control.");
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let t = 1, e = this.filters.length; t < e; t++)this.filters[t - 1].connect(this.filters[t]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        return this._connected = !0, this;
    }
    disconnect() {
        if (!1 !== this._connected) {
            if (this.filters.length > 0) {
                this.source.disconnect(this.filters[0]);
                for(let t = 1, e = this.filters.length; t < e; t++)this.filters[t - 1].disconnect(this.filters[t]);
                this.filters[this.filters.length - 1].disconnect(this.getOutput());
            } else this.source.disconnect(this.getOutput());
            return this._connected = !1, this;
        }
    }
    getFilters() {
        return this.filters;
    }
    setFilters(t) {
        return t || (t = []), !0 === this._connected ? (this.disconnect(), this.filters = t.slice(), this.connect()) : this.filters = t.slice(), this;
    }
    setDetune(t) {
        return this.detune = t, !0 === this.isPlaying && void 0 !== this.source.detune && this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, .01), this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(t) {
        return this.setFilters(t ? [
            t
        ] : []);
    }
    setPlaybackRate(t) {
        if (!1 !== this.hasPlaybackControl) return this.playbackRate = t, !0 === this.isPlaying && this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, .01), this;
        $4a792688e08e5cd7$export$c106dd0671a0fc2d("Audio: this Audio has no playback control.");
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = !1, this._progress = 0;
    }
    getLoop() {
        return !1 === this.hasPlaybackControl ? ($4a792688e08e5cd7$export$c106dd0671a0fc2d("Audio: this Audio has no playback control."), !1) : this.loop;
    }
    setLoop(t) {
        if (!1 !== this.hasPlaybackControl) return this.loop = t, !0 === this.isPlaying && (this.source.loop = this.loop), this;
        $4a792688e08e5cd7$export$c106dd0671a0fc2d("Audio: this Audio has no playback control.");
    }
    setLoopStart(t) {
        return this.loopStart = t, this;
    }
    setLoopEnd(t) {
        return this.loopEnd = t, this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(t) {
        return this.gain.gain.setTargetAtTime(t, this.context.currentTime, .01), this;
    }
    copy(t, e) {
        return super.copy(t, e), "buffer" !== t.sourceType ? ($4a792688e08e5cd7$export$c106dd0671a0fc2d("Audio: Audio source type cannot be copied."), this) : (this.autoplay = t.autoplay, this.buffer = t.buffer, this.detune = t.detune, this.loop = t.loop, this.loopStart = t.loopStart, this.loopEnd = t.loopEnd, this.offset = t.offset, this.duration = t.duration, this.playbackRate = t.playbackRate, this.hasPlaybackControl = t.hasPlaybackControl, this.sourceType = t.sourceType, this.filters = t.filters.slice(), this);
    }
    clone(t) {
        return new this.constructor(this.listener).copy(this, t);
    }
}
const $4a792688e08e5cd7$var$Au = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Tu = new $4a792688e08e5cd7$export$23d6a54f0bbc85a3, $4a792688e08e5cd7$var$zu = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Cu = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$4b3e397ef1832507 extends $4a792688e08e5cd7$export$153755f98d9861de {
    constructor(t){
        super(t), this.panner = this.context.createPanner(), this.panner.panningModel = "HRTF", this.panner.connect(this.gain);
    }
    connect() {
        return super.connect(), this.panner.connect(this.gain), this;
    }
    disconnect() {
        return super.disconnect(), this.panner.disconnect(this.gain), this;
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(t) {
        return this.panner.refDistance = t, this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(t) {
        return this.panner.rolloffFactor = t, this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(t) {
        return this.panner.distanceModel = t, this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(t) {
        return this.panner.maxDistance = t, this;
    }
    setDirectionalCone(t, e, i) {
        return this.panner.coneInnerAngle = t, this.panner.coneOuterAngle = e, this.panner.coneOuterGain = i, this;
    }
    updateMatrixWorld(t) {
        if (super.updateMatrixWorld(t), !0 === this.hasPlaybackControl && !1 === this.isPlaying) return;
        this.matrixWorld.decompose($4a792688e08e5cd7$var$Au, $4a792688e08e5cd7$var$Tu, $4a792688e08e5cd7$var$zu), $4a792688e08e5cd7$var$Cu.set(0, 0, 1).applyQuaternion($4a792688e08e5cd7$var$Tu);
        const e = this.panner;
        if (e.positionX) {
            const t = this.context.currentTime + this.listener.timeDelta;
            e.positionX.linearRampToValueAtTime($4a792688e08e5cd7$var$Au.x, t), e.positionY.linearRampToValueAtTime($4a792688e08e5cd7$var$Au.y, t), e.positionZ.linearRampToValueAtTime($4a792688e08e5cd7$var$Au.z, t), e.orientationX.linearRampToValueAtTime($4a792688e08e5cd7$var$Cu.x, t), e.orientationY.linearRampToValueAtTime($4a792688e08e5cd7$var$Cu.y, t), e.orientationZ.linearRampToValueAtTime($4a792688e08e5cd7$var$Cu.z, t);
        } else e.setPosition($4a792688e08e5cd7$var$Au.x, $4a792688e08e5cd7$var$Au.y, $4a792688e08e5cd7$var$Au.z), e.setOrientation($4a792688e08e5cd7$var$Cu.x, $4a792688e08e5cd7$var$Cu.y, $4a792688e08e5cd7$var$Cu.z);
    }
}
class $4a792688e08e5cd7$export$d47da1ef3d382827 {
    constructor(t, e = 2048){
        this.analyser = t.context.createAnalyser(), this.analyser.fftSize = e, this.data = new Uint8Array(this.analyser.frequencyBinCount), t.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        return this.analyser.getByteFrequencyData(this.data), this.data;
    }
    getAverageFrequency() {
        let t = 0;
        const e = this.getFrequencyData();
        for(let i = 0; i < e.length; i++)t += e[i];
        return t / e.length;
    }
}
class $4a792688e08e5cd7$export$dfe0af1ca1acb78a {
    constructor(t, e, i){
        let s, r, n;
        switch(this.binding = t, this.valueSize = i, e){
            case "quaternion":
                s = this._slerp, r = this._slerpAdditive, n = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(6 * i), this._workIndex = 5;
                break;
            case "string":
            case "bool":
                s = this._select, r = this._select, n = this._setAdditiveIdentityOther, this.buffer = new Array(5 * i);
                break;
            default:
                s = this._lerp, r = this._lerpAdditive, n = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(5 * i);
        }
        this._mixBufferRegion = s, this._mixBufferRegionAdditive = r, this._setIdentity = n, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
    }
    accumulate(t, e) {
        const i = this.buffer, s = this.valueSize, r = t * s + s;
        let n = this.cumulativeWeight;
        if (0 === n) {
            for(let t = 0; t !== s; ++t)i[r + t] = i[t];
            n = e;
        } else {
            n += e;
            const t = e / n;
            this._mixBufferRegion(i, r, 0, t, s);
        }
        this.cumulativeWeight = n;
    }
    accumulateAdditive(t) {
        const e = this.buffer, i = this.valueSize, s = i * this._addIndex;
        0 === this.cumulativeWeightAdditive && this._setIdentity(), this._mixBufferRegionAdditive(e, s, 0, t, i), this.cumulativeWeightAdditive += t;
    }
    apply(t) {
        const e = this.valueSize, i = this.buffer, s = t * e + e, r = this.cumulativeWeight, n = this.cumulativeWeightAdditive, a = this.binding;
        if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
            const t = e * this._origIndex;
            this._mixBufferRegion(i, s, t, 1 - r, e);
        }
        n > 0 && this._mixBufferRegionAdditive(i, s, this._addIndex * e, 1, e);
        for(let t = e, r = e + e; t !== r; ++t)if (i[t] !== i[t + e]) {
            a.setValue(i, s);
            break;
        }
    }
    saveOriginalState() {
        const t = this.binding, e = this.buffer, i = this.valueSize, s = i * this._origIndex;
        t.getValue(e, s);
        for(let t = i, r = s; t !== r; ++t)e[t] = e[s + t % i];
        this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
    }
    restoreOriginalState() {
        const t = 3 * this.valueSize;
        this.binding.setValue(this.buffer, t);
    }
    _setAdditiveIdentityNumeric() {
        const t = this._addIndex * this.valueSize, e = t + this.valueSize;
        for(let i = t; i < e; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const t = this._origIndex * this.valueSize, e = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[e + i] = this.buffer[t + i];
    }
    _select(t, e, i, s, r) {
        if (s >= .5) for(let s = 0; s !== r; ++s)t[e + s] = t[i + s];
    }
    _slerp(t, e, i, s) {
        $4a792688e08e5cd7$export$23d6a54f0bbc85a3.slerpFlat(t, e, t, e, t, i, s);
    }
    _slerpAdditive(t, e, i, s, r) {
        const n = this._workIndex * r;
        $4a792688e08e5cd7$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(t, n, t, e, t, i), $4a792688e08e5cd7$export$23d6a54f0bbc85a3.slerpFlat(t, e, t, e, t, n, s);
    }
    _lerp(t, e, i, s, r) {
        const n = 1 - s;
        for(let a = 0; a !== r; ++a){
            const r = e + a;
            t[r] = t[r] * n + t[i + a] * s;
        }
    }
    _lerpAdditive(t, e, i, s, r) {
        for(let n = 0; n !== r; ++n){
            const r = e + n;
            t[r] = t[r] + t[i + n] * s;
        }
    }
}
const $4a792688e08e5cd7$var$Pu = "\\[\\]\\.:\\/", $4a792688e08e5cd7$var$Ou = new RegExp("[" + $4a792688e08e5cd7$var$Pu + "]", "g"), $4a792688e08e5cd7$var$Ru = "[^" + $4a792688e08e5cd7$var$Pu + "]", $4a792688e08e5cd7$var$Nu = "[^" + $4a792688e08e5cd7$var$Pu.replace("\\.", "") + "]", $4a792688e08e5cd7$var$Vu = new RegExp("^" + /((?:WC+[\/:])*)/.source.replace("WC", $4a792688e08e5cd7$var$Ru) + /(WCOD+)?/.source.replace("WCOD", $4a792688e08e5cd7$var$Nu) + /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $4a792688e08e5cd7$var$Ru) + /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $4a792688e08e5cd7$var$Ru) + "$"), $4a792688e08e5cd7$var$Fu = [
    "material",
    "materials",
    "bones",
    "map"
];
class $4a792688e08e5cd7$export$7bf70fcf9f891893 {
    constructor(t, e, i){
        this.path = e, this.parsedPath = i || $4a792688e08e5cd7$export$7bf70fcf9f891893.parseTrackName(e), this.node = $4a792688e08e5cd7$export$7bf70fcf9f891893.findNode(t, this.parsedPath.nodeName), this.rootNode = t, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
    static create(t, e, i) {
        return t && t.isAnimationObjectGroup ? new $4a792688e08e5cd7$export$7bf70fcf9f891893.Composite(t, e, i) : new $4a792688e08e5cd7$export$7bf70fcf9f891893(t, e, i);
    }
    static sanitizeNodeName(t) {
        return t.replace(/\s/g, "_").replace($4a792688e08e5cd7$var$Ou, "");
    }
    static parseTrackName(t) {
        const e = $4a792688e08e5cd7$var$Vu.exec(t);
        if (null === e) throw new Error("PropertyBinding: Cannot parse trackName: " + t);
        const i = {
            nodeName: e[2],
            objectName: e[3],
            objectIndex: e[4],
            propertyName: e[5],
            propertyIndex: e[6]
        }, s = i.nodeName && i.nodeName.lastIndexOf(".");
        if (void 0 !== s && -1 !== s) {
            const t = i.nodeName.substring(s + 1);
            -1 !== $4a792688e08e5cd7$var$Fu.indexOf(t) && (i.nodeName = i.nodeName.substring(0, s), i.objectName = t);
        }
        if (null === i.propertyName || 0 === i.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t);
        return i;
    }
    static findNode(t, e) {
        if (void 0 === e || "" === e || "." === e || -1 === e || e === t.name || e === t.uuid) return t;
        if (t.skeleton) {
            const i = t.skeleton.getBoneByName(e);
            if (void 0 !== i) return i;
        }
        if (t.children) {
            const i = function(t) {
                for(let s = 0; s < t.length; s++){
                    const r = t[s];
                    if (r.name === e || r.uuid === e) return r;
                    const n = i(r.children);
                    if (n) return n;
                }
                return null;
            }, s = i(t.children);
            if (s) return s;
        }
        return null;
    }
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    _getValue_direct(t, e) {
        t[e] = this.targetObject[this.propertyName];
    }
    _getValue_array(t, e) {
        const i = this.resolvedProperty;
        for(let s = 0, r = i.length; s !== r; ++s)t[e++] = i[s];
    }
    _getValue_arrayElement(t, e) {
        t[e] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(t, e) {
        this.resolvedProperty.toArray(t, e);
    }
    _setValue_direct(t, e) {
        this.targetObject[this.propertyName] = t[e];
    }
    _setValue_direct_setNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_array(t, e) {
        const i = this.resolvedProperty;
        for(let s = 0, r = i.length; s !== r; ++s)i[s] = t[e++];
    }
    _setValue_array_setNeedsUpdate(t, e) {
        const i = this.resolvedProperty;
        for(let s = 0, r = i.length; s !== r; ++s)i[s] = t[e++];
        this.targetObject.needsUpdate = !0;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(t, e) {
        const i = this.resolvedProperty;
        for(let s = 0, r = i.length; s !== r; ++s)i[s] = t[e++];
        this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_arrayElement(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e];
    }
    _setValue_arrayElement_setNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_fromArray(t, e) {
        this.resolvedProperty.fromArray(t, e);
    }
    _setValue_fromArray_setNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.needsUpdate = !0;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _getValue_unbound(t, e) {
        this.bind(), this.getValue(t, e);
    }
    _setValue_unbound(t, e) {
        this.bind(), this.setValue(t, e);
    }
    bind() {
        let t = this.node;
        const e = this.parsedPath, i = e.objectName, s = e.propertyName;
        let r = e.propertyIndex;
        if (t || (t = $4a792688e08e5cd7$export$7bf70fcf9f891893.findNode(this.rootNode, e.nodeName), this.node = t), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t) return void $4a792688e08e5cd7$export$c106dd0671a0fc2d("PropertyBinding: No target node found for track: " + this.path + ".");
        if (i) {
            let s = e.objectIndex;
            switch(i){
                case "materials":
                    if (!t.material) return void $4a792688e08e5cd7$export$a3bc9b8ed74fc("PropertyBinding: Can not bind to material as node does not have a material.", this);
                    if (!t.material.materials) return void $4a792688e08e5cd7$export$a3bc9b8ed74fc("PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                    t = t.material.materials;
                    break;
                case "bones":
                    if (!t.skeleton) return void $4a792688e08e5cd7$export$a3bc9b8ed74fc("PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                    t = t.skeleton.bones;
                    for(let e = 0; e < t.length; e++)if (t[e].name === s) {
                        s = e;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in t) {
                        t = t.map;
                        break;
                    }
                    if (!t.material) return void $4a792688e08e5cd7$export$a3bc9b8ed74fc("PropertyBinding: Can not bind to material as node does not have a material.", this);
                    if (!t.material.map) return void $4a792688e08e5cd7$export$a3bc9b8ed74fc("PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                    t = t.material.map;
                    break;
                default:
                    if (void 0 === t[i]) return void $4a792688e08e5cd7$export$a3bc9b8ed74fc("PropertyBinding: Can not bind to objectName of node undefined.", this);
                    t = t[i];
            }
            if (void 0 !== s) {
                if (void 0 === t[s]) return void $4a792688e08e5cd7$export$a3bc9b8ed74fc("PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
                t = t[s];
            }
        }
        const n = t[s];
        if (void 0 === n) return void $4a792688e08e5cd7$export$a3bc9b8ed74fc("PropertyBinding: Trying to update property for track: " + e.nodeName + "." + s + " but it wasn't found.", t);
        let a = this.Versioning.None;
        this.targetObject = t, !0 === t.isMaterial ? a = this.Versioning.NeedsUpdate : !0 === t.isObject3D && (a = this.Versioning.MatrixWorldNeedsUpdate);
        let o = this.BindingType.Direct;
        if (void 0 !== r) {
            if ("morphTargetInfluences" === s) {
                if (!t.geometry) return void $4a792688e08e5cd7$export$a3bc9b8ed74fc("PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                if (!t.geometry.morphAttributes) return void $4a792688e08e5cd7$export$a3bc9b8ed74fc("PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                void 0 !== t.morphTargetDictionary[r] && (r = t.morphTargetDictionary[r]);
            }
            o = this.BindingType.ArrayElement, this.resolvedProperty = n, this.propertyIndex = r;
        } else void 0 !== n.fromArray && void 0 !== n.toArray ? (o = this.BindingType.HasFromToArray, this.resolvedProperty = n) : Array.isArray(n) ? (o = this.BindingType.EntireArray, this.resolvedProperty = n) : this.propertyName = s;
        this.getValue = this.GetterByBindingType[o], this.setValue = this.SetterByBindingTypeAndVersioning[o][a];
    }
    unbind() {
        this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
}
$4a792688e08e5cd7$export$7bf70fcf9f891893.Composite = class {
    constructor(t, e, i){
        const s = i || $4a792688e08e5cd7$export$7bf70fcf9f891893.parseTrackName(e);
        this._targetGroup = t, this._bindings = t.subscribe_(e, s);
    }
    getValue(t, e) {
        this.bind();
        const i = this._targetGroup.nCachedObjects_, s = this._bindings[i];
        void 0 !== s && s.getValue(t, e);
    }
    setValue(t, e) {
        const i = this._bindings;
        for(let s = this._targetGroup.nCachedObjects_, r = i.length; s !== r; ++s)i[s].setValue(t, e);
    }
    bind() {
        const t = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, i = t.length; e !== i; ++e)t[e].bind();
    }
    unbind() {
        const t = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, i = t.length; e !== i; ++e)t[e].unbind();
    }
}, $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
}, $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
}, $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._getValue_direct,
    $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._getValue_array,
    $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._getValue_toArray
], $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_direct,
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_array,
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $4a792688e08e5cd7$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
class $4a792688e08e5cd7$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = !0, this.uuid = $4a792688e08e5cd7$var$rs(), this._objects = Array.prototype.slice.call(arguments), this.nCachedObjects_ = 0;
        const t = {};
        this._indicesByUUID = t;
        for(let e = 0, i = arguments.length; e !== i; ++e)t[arguments[e].uuid] = e;
        this._paths = [], this._parsedPaths = [], this._bindings = [], this._bindingsIndicesByPath = {};
        const e = this;
        this.stats = {
            objects: {
                get total () {
                    return e._objects.length;
                },
                get inUse () {
                    return this.total - e.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return e._bindings.length;
            }
        };
    }
    add() {
        const t = this._objects, e = this._indicesByUUID, i = this._paths, s = this._parsedPaths, r = this._bindings, n = r.length;
        let a, o = t.length, h = this.nCachedObjects_;
        for(let l = 0, c = arguments.length; l !== c; ++l){
            const c = arguments[l], u = c.uuid;
            let d = e[u];
            if (void 0 === d) {
                d = o++, e[u] = d, t.push(c);
                for(let t = 0, e = n; t !== e; ++t)r[t].push(new $4a792688e08e5cd7$export$7bf70fcf9f891893(c, i[t], s[t]));
            } else if (d < h) {
                a = t[d];
                const o = --h, l = t[o];
                e[l.uuid] = d, t[d] = l, e[u] = o, t[o] = c;
                for(let t = 0, e = n; t !== e; ++t){
                    const e = r[t], n = e[o];
                    let a = e[d];
                    e[d] = n, void 0 === a && (a = new $4a792688e08e5cd7$export$7bf70fcf9f891893(c, i[t], s[t])), e[o] = a;
                }
            } else t[d] !== a && $4a792688e08e5cd7$export$a3bc9b8ed74fc("AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
        }
        this.nCachedObjects_ = h;
    }
    remove() {
        const t = this._objects, e = this._indicesByUUID, i = this._bindings, s = i.length;
        let r = this.nCachedObjects_;
        for(let n = 0, a = arguments.length; n !== a; ++n){
            const a = arguments[n], o = a.uuid, h = e[o];
            if (void 0 !== h && h >= r) {
                const n = r++, l = t[n];
                e[l.uuid] = h, t[h] = l, e[o] = n, t[n] = a;
                for(let t = 0, e = s; t !== e; ++t){
                    const e = i[t], s = e[n], r = e[h];
                    e[h] = s, e[n] = r;
                }
            }
        }
        this.nCachedObjects_ = r;
    }
    uncache() {
        const t = this._objects, e = this._indicesByUUID, i = this._bindings, s = i.length;
        let r = this.nCachedObjects_, n = t.length;
        for(let a = 0, o = arguments.length; a !== o; ++a){
            const o = arguments[a].uuid, h = e[o];
            if (void 0 !== h) {
                if (delete e[o], h < r) {
                    const a = --r, o = t[a], l = --n, c = t[l];
                    e[o.uuid] = h, t[h] = o, e[c.uuid] = a, t[a] = c, t.pop();
                    for(let t = 0, e = s; t !== e; ++t){
                        const e = i[t], s = e[a], r = e[l];
                        e[h] = s, e[a] = r, e.pop();
                    }
                } else {
                    const r = --n, a = t[r];
                    r > 0 && (e[a.uuid] = h), t[h] = a, t.pop();
                    for(let t = 0, e = s; t !== e; ++t){
                        const e = i[t];
                        e[h] = e[r], e.pop();
                    }
                }
            }
        }
        this.nCachedObjects_ = r;
    }
    subscribe_(t, e) {
        const i = this._bindingsIndicesByPath;
        let s = i[t];
        const r = this._bindings;
        if (void 0 !== s) return r[s];
        const n = this._paths, a = this._parsedPaths, o = this._objects, h = o.length, l = this.nCachedObjects_, c = new Array(h);
        s = r.length, i[t] = s, n.push(t), a.push(e), r.push(c);
        for(let i = l, s = o.length; i !== s; ++i){
            const s = o[i];
            c[i] = new $4a792688e08e5cd7$export$7bf70fcf9f891893(s, t, e);
        }
        return c;
    }
    unsubscribe_(t) {
        const e = this._bindingsIndicesByPath, i = e[t];
        if (void 0 !== i) {
            const s = this._paths, r = this._parsedPaths, n = this._bindings, a = n.length - 1, o = n[a];
            e[t[a]] = i, n[i] = o, n.pop(), r[i] = r[a], r.pop(), s[i] = s[a], s.pop();
        }
    }
}
class $4a792688e08e5cd7$export$6946940a69e799e {
    constructor(t, e, i = null, s = e.blendMode){
        this._mixer = t, this._clip = e, this._localRoot = i, this.blendMode = s;
        const r = e.tracks, n = r.length, a = new Array(n), o = {
            endingStart: $4a792688e08e5cd7$export$7f795934b84ab523,
            endingEnd: $4a792688e08e5cd7$export$7f795934b84ab523
        };
        for(let t = 0; t !== n; ++t){
            const e = r[t].createInterpolant(null);
            a[t] = e, e.settings = o;
        }
        this._interpolantSettings = o, this._interpolants = a, this._propertyBindings = new Array(n), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = 2201, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
    }
    play() {
        return this._mixer._activateAction(this), this;
    }
    stop() {
        return this._mixer._deactivateAction(this), this.reset();
    }
    reset() {
        return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
    }
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(t) {
        return this._startTime = t, this;
    }
    setLoop(t, e) {
        return this.loop = t, this.repetitions = e, this;
    }
    setEffectiveWeight(t) {
        return this.weight = t, this._effectiveWeight = this.enabled ? t : 0, this.stopFading();
    }
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(t) {
        return this._scheduleFading(t, 0, 1);
    }
    fadeOut(t) {
        return this._scheduleFading(t, 1, 0);
    }
    crossFadeFrom(t, e, i = !1) {
        if (t.fadeOut(e), this.fadeIn(e), !0 === i) {
            const i = this._clip.duration, s = t._clip.duration, r = s / i, n = i / s;
            t.warp(1, r, e), this.warp(n, 1, e);
        }
        return this;
    }
    crossFadeTo(t, e, i = !1) {
        return t.crossFadeFrom(this, e, i);
    }
    stopFading() {
        const t = this._weightInterpolant;
        return null !== t && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
    setEffectiveTimeScale(t) {
        return this.timeScale = t, this._effectiveTimeScale = this.paused ? 0 : t, this.stopWarping();
    }
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(t) {
        return this.timeScale = this._clip.duration / t, this.stopWarping();
    }
    syncWith(t) {
        return this.time = t.time, this.timeScale = t.timeScale, this.stopWarping();
    }
    halt(t) {
        return this.warp(this._effectiveTimeScale, 0, t);
    }
    warp(t, e, i) {
        const s = this._mixer, r = s.time, n = this.timeScale;
        let a = this._timeScaleInterpolant;
        null === a && (a = s._lendControlInterpolant(), this._timeScaleInterpolant = a);
        const o = a.parameterPositions, h = a.sampleValues;
        return o[0] = r, o[1] = r + i, h[0] = t / n, h[1] = e / n, this;
    }
    stopWarping() {
        const t = this._timeScaleInterpolant;
        return null !== t && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    _update(t, e, i, s) {
        if (!this.enabled) return void this._updateWeight(t);
        const r = this._startTime;
        if (null !== r) {
            const s = (t - r) * i;
            s < 0 || 0 === i ? e = 0 : (this._startTime = null, e = i * s);
        }
        e *= this._updateTimeScale(t);
        const n = this._updateTime(e), a = this._updateWeight(t);
        if (a > 0) {
            const t = this._interpolants, e = this._propertyBindings;
            if (this.blendMode === $4a792688e08e5cd7$export$d875e029ef558d3) for(let i = 0, s = t.length; i !== s; ++i)t[i].evaluate(n), e[i].accumulateAdditive(a);
            else for(let i = 0, r = t.length; i !== r; ++i)t[i].evaluate(n), e[i].accumulate(s, a);
        }
    }
    _updateWeight(t) {
        let e = 0;
        if (this.enabled) {
            e = this.weight;
            const i = this._weightInterpolant;
            if (null !== i) {
                const s = i.evaluate(t)[0];
                e *= s, t > i.parameterPositions[1] && (this.stopFading(), 0 === s && (this.enabled = !1));
            }
        }
        return this._effectiveWeight = e, e;
    }
    _updateTimeScale(t) {
        let e = 0;
        if (!this.paused) {
            e = this.timeScale;
            const i = this._timeScaleInterpolant;
            if (null !== i) e *= i.evaluate(t)[0], t > i.parameterPositions[1] && (this.stopWarping(), 0 === e ? this.paused = !0 : this.timeScale = e);
        }
        return this._effectiveTimeScale = e, e;
    }
    _updateTime(t) {
        const e = this._clip.duration, i = this.loop;
        let s = this.time + t, r = this._loopCount;
        const n = 2202 === i;
        if (0 === t) return -1 === r || !n || 1 & ~r ? s : e - s;
        if (2200 === i) {
            -1 === r && (this._loopCount = 0, this._setEndings(!0, !0, !1));
            t: {
                if (s >= e) s = e;
                else {
                    if (!(s < 0)) {
                        this.time = s;
                        break t;
                    }
                    s = 0;
                }
                this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = s, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: t < 0 ? -1 : 1
                });
            }
        } else {
            if (-1 === r && (t >= 0 ? (r = 0, this._setEndings(!0, 0 === this.repetitions, n)) : this._setEndings(0 === this.repetitions, !0, n)), s >= e || s < 0) {
                const i = Math.floor(s / e);
                s -= e * i, r += Math.abs(i);
                const a = this.repetitions - r;
                if (a <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, s = t > 0 ? e : 0, this.time = s, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: t > 0 ? 1 : -1
                });
                else {
                    if (1 === a) {
                        const e = t < 0;
                        this._setEndings(e, !e, n);
                    } else this._setEndings(!1, !1, n);
                    this._loopCount = r, this.time = s, this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: i
                    });
                }
            } else this.time = s;
            if (n && !(1 & ~r)) return e - s;
        }
        return s;
    }
    _setEndings(t, e, i) {
        const s = this._interpolantSettings;
        i ? (s.endingStart = $4a792688e08e5cd7$export$24a4ccb5099273b5, s.endingEnd = $4a792688e08e5cd7$export$24a4ccb5099273b5) : (s.endingStart = t ? this.zeroSlopeAtStart ? $4a792688e08e5cd7$export$24a4ccb5099273b5 : $4a792688e08e5cd7$export$7f795934b84ab523 : $4a792688e08e5cd7$export$8e8c3ecdcd8e1fee, s.endingEnd = e ? this.zeroSlopeAtEnd ? $4a792688e08e5cd7$export$24a4ccb5099273b5 : $4a792688e08e5cd7$export$7f795934b84ab523 : $4a792688e08e5cd7$export$8e8c3ecdcd8e1fee);
    }
    _scheduleFading(t, e, i) {
        const s = this._mixer, r = s.time;
        let n = this._weightInterpolant;
        null === n && (n = s._lendControlInterpolant(), this._weightInterpolant = n);
        const a = n.parameterPositions, o = n.sampleValues;
        return a[0] = r, o[0] = e, a[1] = r + t, o[1] = i, this;
    }
}
const $4a792688e08e5cd7$var$Du = new Float32Array(1);
class $4a792688e08e5cd7$export$fbd77e5aefaa0102 extends $4a792688e08e5cd7$export$ec8b666c5fe2c75a {
    constructor(t){
        super(), this._root = t, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
    }
    _bindAction(t, e) {
        const i = t._localRoot || this._root, s = t._clip.tracks, r = s.length, n = t._propertyBindings, a = t._interpolants, o = i.uuid, h = this._bindingsByRootAndName;
        let l = h[o];
        void 0 === l && (l = {}, h[o] = l);
        for(let t = 0; t !== r; ++t){
            const r = s[t], h = r.name;
            let c = l[h];
            if (void 0 !== c) ++c.referenceCount, n[t] = c;
            else {
                if (c = n[t], void 0 !== c) {
                    null === c._cacheIndex && (++c.referenceCount, this._addInactiveBinding(c, o, h));
                    continue;
                }
                const s = e && e._propertyBindings[t].binding.parsedPath;
                c = new $4a792688e08e5cd7$export$dfe0af1ca1acb78a($4a792688e08e5cd7$export$7bf70fcf9f891893.create(i, h, s), r.ValueTypeName, r.getValueSize()), ++c.referenceCount, this._addInactiveBinding(c, o, h), n[t] = c;
            }
            a[t].resultBuffer = c.buffer;
        }
    }
    _activateAction(t) {
        if (!this._isActiveAction(t)) {
            if (null === t._cacheIndex) {
                const e = (t._localRoot || this._root).uuid, i = t._clip.uuid, s = this._actionsByClip[i];
                this._bindAction(t, s && s.knownActions[0]), this._addInactiveAction(t, i, e);
            }
            const e = t._propertyBindings;
            for(let t = 0, i = e.length; t !== i; ++t){
                const i = e[t];
                0 === i.useCount++ && (this._lendBinding(i), i.saveOriginalState());
            }
            this._lendAction(t);
        }
    }
    _deactivateAction(t) {
        if (this._isActiveAction(t)) {
            const e = t._propertyBindings;
            for(let t = 0, i = e.length; t !== i; ++t){
                const i = e[t];
                0 === --i.useCount && (i.restoreOriginalState(), this._takeBackBinding(i));
            }
            this._takeBackAction(t);
        }
    }
    _initMemoryManager() {
        this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
        const t = this;
        this.stats = {
            actions: {
                get total () {
                    return t._actions.length;
                },
                get inUse () {
                    return t._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return t._bindings.length;
                },
                get inUse () {
                    return t._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return t._controlInterpolants.length;
                },
                get inUse () {
                    return t._nActiveControlInterpolants;
                }
            }
        };
    }
    _isActiveAction(t) {
        const e = t._cacheIndex;
        return null !== e && e < this._nActiveActions;
    }
    _addInactiveAction(t, e, i) {
        const s = this._actions, r = this._actionsByClip;
        let n = r[e];
        if (void 0 === n) n = {
            knownActions: [
                t
            ],
            actionByRoot: {}
        }, t._byClipCacheIndex = 0, r[e] = n;
        else {
            const e = n.knownActions;
            t._byClipCacheIndex = e.length, e.push(t);
        }
        t._cacheIndex = s.length, s.push(t), n.actionByRoot[i] = t;
    }
    _removeInactiveAction(t) {
        const e = this._actions, i = e[e.length - 1], s = t._cacheIndex;
        i._cacheIndex = s, e[s] = i, e.pop(), t._cacheIndex = null;
        const r = t._clip.uuid, n = this._actionsByClip, a = n[r], o = a.knownActions, h = o[o.length - 1], l = t._byClipCacheIndex;
        h._byClipCacheIndex = l, o[l] = h, o.pop(), t._byClipCacheIndex = null;
        delete a.actionByRoot[(t._localRoot || this._root).uuid], 0 === o.length && delete n[r], this._removeInactiveBindingsForAction(t);
    }
    _removeInactiveBindingsForAction(t) {
        const e = t._propertyBindings;
        for(let t = 0, i = e.length; t !== i; ++t){
            const i = e[t];
            0 === --i.referenceCount && this._removeInactiveBinding(i);
        }
    }
    _lendAction(t) {
        const e = this._actions, i = t._cacheIndex, s = this._nActiveActions++, r = e[s];
        t._cacheIndex = s, e[s] = t, r._cacheIndex = i, e[i] = r;
    }
    _takeBackAction(t) {
        const e = this._actions, i = t._cacheIndex, s = --this._nActiveActions, r = e[s];
        t._cacheIndex = s, e[s] = t, r._cacheIndex = i, e[i] = r;
    }
    _addInactiveBinding(t, e, i) {
        const s = this._bindingsByRootAndName, r = this._bindings;
        let n = s[e];
        void 0 === n && (n = {}, s[e] = n), n[i] = t, t._cacheIndex = r.length, r.push(t);
    }
    _removeInactiveBinding(t) {
        const e = this._bindings, i = t.binding, s = i.rootNode.uuid, r = i.path, n = this._bindingsByRootAndName, a = n[s], o = e[e.length - 1], h = t._cacheIndex;
        o._cacheIndex = h, e[h] = o, e.pop(), delete a[r], 0 === Object.keys(a).length && delete n[s];
    }
    _lendBinding(t) {
        const e = this._bindings, i = t._cacheIndex, s = this._nActiveBindings++, r = e[s];
        t._cacheIndex = s, e[s] = t, r._cacheIndex = i, e[i] = r;
    }
    _takeBackBinding(t) {
        const e = this._bindings, i = t._cacheIndex, s = --this._nActiveBindings, r = e[s];
        t._cacheIndex = s, e[s] = t, r._cacheIndex = i, e[i] = r;
    }
    _lendControlInterpolant() {
        const t = this._controlInterpolants, e = this._nActiveControlInterpolants++;
        let i = t[e];
        return void 0 === i && (i = new $4a792688e08e5cd7$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $4a792688e08e5cd7$var$Du), i.__cacheIndex = e, t[e] = i), i;
    }
    _takeBackControlInterpolant(t) {
        const e = this._controlInterpolants, i = t.__cacheIndex, s = --this._nActiveControlInterpolants, r = e[s];
        t.__cacheIndex = s, e[s] = t, r.__cacheIndex = i, e[i] = r;
    }
    clipAction(t, e, i) {
        const s = e || this._root, r = s.uuid;
        let n = "string" == typeof t ? $4a792688e08e5cd7$export$d942c706bf23829c.findByName(s, t) : t;
        const a = null !== n ? n.uuid : t, o = this._actionsByClip[a];
        let h = null;
        if (void 0 === i && (i = null !== n ? n.blendMode : $4a792688e08e5cd7$export$bcfbbdcf8de7f8cd), void 0 !== o) {
            const t = o.actionByRoot[r];
            if (void 0 !== t && t.blendMode === i) return t;
            h = o.knownActions[0], null === n && (n = h._clip);
        }
        if (null === n) return null;
        const l = new $4a792688e08e5cd7$export$6946940a69e799e(this, n, e, i);
        return this._bindAction(l, h), this._addInactiveAction(l, a, r), l;
    }
    existingAction(t, e) {
        const i = e || this._root, s = i.uuid, r = "string" == typeof t ? $4a792688e08e5cd7$export$d942c706bf23829c.findByName(i, t) : t, n = r ? r.uuid : t, a = this._actionsByClip[n];
        return void 0 !== a && a.actionByRoot[s] || null;
    }
    stopAllAction() {
        const t = this._actions;
        for(let e = this._nActiveActions - 1; e >= 0; --e)t[e].stop();
        return this;
    }
    update(t) {
        t *= this.timeScale;
        const e = this._actions, i = this._nActiveActions, s = this.time += t, r = Math.sign(t), n = this._accuIndex ^= 1;
        for(let a = 0; a !== i; ++a)e[a]._update(s, t, r, n);
        const a = this._bindings, o = this._nActiveBindings;
        for(let t = 0; t !== o; ++t)a[t].apply(n);
        return this;
    }
    setTime(t) {
        this.time = 0;
        for(let t = 0; t < this._actions.length; t++)this._actions[t].time = 0;
        return this.update(t);
    }
    getRoot() {
        return this._root;
    }
    uncacheClip(t) {
        const e = this._actions, i = t.uuid, s = this._actionsByClip, r = s[i];
        if (void 0 !== r) {
            const t = r.knownActions;
            for(let i = 0, s = t.length; i !== s; ++i){
                const s = t[i];
                this._deactivateAction(s);
                const r = s._cacheIndex, n = e[e.length - 1];
                s._cacheIndex = null, s._byClipCacheIndex = null, n._cacheIndex = r, e[r] = n, e.pop(), this._removeInactiveBindingsForAction(s);
            }
            delete s[i];
        }
    }
    uncacheRoot(t) {
        const e = t.uuid, i = this._actionsByClip;
        for(const t in i){
            const s = i[t].actionByRoot[e];
            void 0 !== s && (this._deactivateAction(s), this._removeInactiveAction(s));
        }
        const s = this._bindingsByRootAndName[e];
        if (void 0 !== s) for(const t in s){
            const e = s[t];
            e.restoreOriginalState(), this._removeInactiveBinding(e);
        }
    }
    uncacheAction(t, e) {
        const i = this.existingAction(t, e);
        null !== i && (this._deactivateAction(i), this._removeInactiveAction(i));
    }
}
class $4a792688e08e5cd7$export$6b116d2fdfef087c extends $4a792688e08e5cd7$export$efcb1f8bf367cbfb {
    constructor(t = 1, e = 1, i = 1, s = {}){
        super(t, e, s), this.isRenderTarget3D = !0, this.depth = i, this.texture = new $4a792688e08e5cd7$export$d7a3086320f856db(null, t, e, i), this._setTextureOptions(s), this.texture.isRenderTargetTexture = !0;
    }
}
class $4a792688e08e5cd7$export$2947cebfe91c02f8 {
    constructor(t){
        this.value = t;
    }
    clone() {
        return new $4a792688e08e5cd7$export$2947cebfe91c02f8(void 0 === this.value.clone ? this.value : this.value.clone());
    }
}
let $4a792688e08e5cd7$var$Ju = 0;
class $4a792688e08e5cd7$export$c412d5ffe1f79209 extends $4a792688e08e5cd7$export$ec8b666c5fe2c75a {
    constructor(){
        super(), this.isUniformsGroup = !0, Object.defineProperty(this, "id", {
            value: $4a792688e08e5cd7$var$Ju++
        }), this.name = "", this.usage = $4a792688e08e5cd7$export$763e8360f4d7f77d, this.uniforms = [];
    }
    add(t) {
        return this.uniforms.push(t), this;
    }
    remove(t) {
        const e = this.uniforms.indexOf(t);
        return -1 !== e && this.uniforms.splice(e, 1), this;
    }
    setName(t) {
        return this.name = t, this;
    }
    setUsage(t) {
        return this.usage = t, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    copy(t) {
        this.name = t.name, this.usage = t.usage;
        const e = t.uniforms;
        this.uniforms.length = 0;
        for(let t = 0, i = e.length; t < i; t++){
            const i = Array.isArray(e[t]) ? e[t] : [
                e[t]
            ];
            for(let t = 0; t < i.length; t++)this.uniforms.push(i[t].clone());
        }
        return this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
class $4a792688e08e5cd7$export$25ec0e1af1389358 extends $4a792688e08e5cd7$export$3d5cd879f108f53f {
    constructor(t, e, i = 1){
        super(t, e), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = i;
    }
    copy(t) {
        return super.copy(t), this.meshPerAttribute = t.meshPerAttribute, this;
    }
    clone(t) {
        const e = super.clone(t);
        return e.meshPerAttribute = this.meshPerAttribute, e;
    }
    toJSON(t) {
        const e = super.toJSON(t);
        return e.isInstancedInterleavedBuffer = !0, e.meshPerAttribute = this.meshPerAttribute, e;
    }
}
class $4a792688e08e5cd7$export$6b7339ae8dbddf73 {
    constructor(t, e, i, s, r, n = !1){
        this.isGLBufferAttribute = !0, this.name = "", this.buffer = t, this.type = e, this.itemSize = i, this.elementSize = s, this.count = r, this.normalized = n, this.version = 0;
    }
    set needsUpdate(t) {
        !0 === t && this.version++;
    }
    setBuffer(t) {
        return this.buffer = t, this;
    }
    setType(t, e) {
        return this.type = t, this.elementSize = e, this;
    }
    setItemSize(t) {
        return this.itemSize = t, this;
    }
    setCount(t) {
        return this.count = t, this;
    }
}
const $4a792688e08e5cd7$var$Hu = new $4a792688e08e5cd7$export$2ae72fc923e5eb5;
class $4a792688e08e5cd7$export$8b7aaceff00bd2f {
    constructor(t, e, i = 0, s = 1 / 0){
        this.ray = new $4a792688e08e5cd7$export$a186db52eed6d40e(t, e), this.near = i, this.far = s, this.camera = null, this.layers = new $4a792688e08e5cd7$export$89312ce47c0ca777, this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(t, e) {
        this.ray.set(t, e);
    }
    setFromCamera(t, e) {
        e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : $4a792688e08e5cd7$export$a3bc9b8ed74fc("Raycaster: Unsupported camera type: " + e.type);
    }
    setFromXRController(t) {
        return $4a792688e08e5cd7$var$Hu.identity().extractRotation(t.matrixWorld), this.ray.origin.setFromMatrixPosition(t.matrixWorld), this.ray.direction.set(0, 0, -1).applyMatrix4($4a792688e08e5cd7$var$Hu), this;
    }
    intersectObject(t, e = !0, i = []) {
        return $4a792688e08e5cd7$var$Qu(t, this, i, e), i.sort($4a792688e08e5cd7$var$$u), i;
    }
    intersectObjects(t, e = !0, i = []) {
        for(let s = 0, r = t.length; s < r; s++)$4a792688e08e5cd7$var$Qu(t[s], this, i, e);
        return i.sort($4a792688e08e5cd7$var$$u), i;
    }
}
function $4a792688e08e5cd7$var$$u(t, e) {
    return t.distance - e.distance;
}
function $4a792688e08e5cd7$var$Qu(t, e, i, s) {
    let r = !0;
    if (t.layers.test(e.layers)) !1 === t.raycast(e, i) && (r = !1);
    if (!0 === r && !0 === s) {
        const s = t.children;
        for(let t = 0, r = s.length; t < r; t++)$4a792688e08e5cd7$var$Qu(s[t], e, i, !0);
    }
}
class $4a792688e08e5cd7$export$c57e9b2d8b9e4de {
    constructor(){
        this._previousTime = 0, this._currentTime = 0, this._startTime = performance.now(), this._delta = 0, this._elapsed = 0, this._timescale = 1, this._document = null, this._pageVisibilityHandler = null;
    }
    connect(t) {
        this._document = t, void 0 !== t.hidden && (this._pageVisibilityHandler = $4a792688e08e5cd7$var$td.bind(this), t.addEventListener("visibilitychange", this._pageVisibilityHandler, !1));
    }
    disconnect() {
        null !== this._pageVisibilityHandler && (this._document.removeEventListener("visibilitychange", this._pageVisibilityHandler), this._pageVisibilityHandler = null), this._document = null;
    }
    getDelta() {
        return this._delta / 1e3;
    }
    getElapsed() {
        return this._elapsed / 1e3;
    }
    getTimescale() {
        return this._timescale;
    }
    setTimescale(t) {
        return this._timescale = t, this;
    }
    reset() {
        return this._currentTime = performance.now() - this._startTime, this;
    }
    dispose() {
        this.disconnect();
    }
    update(t) {
        return null !== this._pageVisibilityHandler && !0 === this._document.hidden ? this._delta = 0 : (this._previousTime = this._currentTime, this._currentTime = (void 0 !== t ? t : performance.now()) - this._startTime, this._delta = (this._currentTime - this._previousTime) * this._timescale, this._elapsed += this._delta), this;
    }
}
function $4a792688e08e5cd7$var$td() {
    !1 === this._document.hidden && this.reset();
}
class $4a792688e08e5cd7$export$d712cd887b4a00f7 {
    constructor(t = 1, e = 0, i = 0){
        this.radius = t, this.phi = e, this.theta = i;
    }
    set(t, e, i) {
        return this.radius = t, this.phi = e, this.theta = i, this;
    }
    copy(t) {
        return this.radius = t.radius, this.phi = t.phi, this.theta = t.theta, this;
    }
    makeSafe() {
        const t = 1e-6;
        return this.phi = $4a792688e08e5cd7$var$ns(this.phi, t, Math.PI - t), this;
    }
    setFromVector3(t) {
        return this.setFromCartesianCoords(t.x, t.y, t.z);
    }
    setFromCartesianCoords(t, e, i) {
        return this.radius = Math.sqrt(t * t + e * e + i * i), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t, i), this.phi = Math.acos($4a792688e08e5cd7$var$ns(e / this.radius, -1, 1))), this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
class $4a792688e08e5cd7$export$287165bb2177f4fd {
    constructor(t = 1, e = 0, i = 0){
        this.radius = t, this.theta = e, this.y = i;
    }
    set(t, e, i) {
        return this.radius = t, this.theta = e, this.y = i, this;
    }
    copy(t) {
        return this.radius = t.radius, this.theta = t.theta, this.y = t.y, this;
    }
    setFromVector3(t) {
        return this.setFromCartesianCoords(t.x, t.y, t.z);
    }
    setFromCartesianCoords(t, e, i) {
        return this.radius = Math.sqrt(t * t + i * i), this.theta = Math.atan2(t, i), this.y = e, this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
class $4a792688e08e5cd7$export$cbcc6560bf79fb38 {
    constructor(t, e, i, s){
        $4a792688e08e5cd7$export$cbcc6560bf79fb38.prototype.isMatrix2 = !0, this.elements = [
            1,
            0,
            0,
            1
        ], void 0 !== t && this.set(t, e, i, s);
    }
    identity() {
        return this.set(1, 0, 0, 1), this;
    }
    fromArray(t, e = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = t[i + e];
        return this;
    }
    set(t, e, i, s) {
        const r = this.elements;
        return r[0] = t, r[2] = e, r[1] = i, r[3] = s, this;
    }
}
const $4a792688e08e5cd7$var$rd = new $4a792688e08e5cd7$export$c977b3e384af9ae1;
class $4a792688e08e5cd7$export$60f553fa130f08b0 {
    constructor(t = new $4a792688e08e5cd7$export$c977b3e384af9ae1(1 / 0, 1 / 0), e = new $4a792688e08e5cd7$export$c977b3e384af9ae1(-1 / 0, -1 / 0)){
        this.isBox2 = !0, this.min = t, this.max = e;
    }
    set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
    }
    setFromPoints(t) {
        this.makeEmpty();
        for(let e = 0, i = t.length; e < i; e++)this.expandByPoint(t[e]);
        return this;
    }
    setFromCenterAndSize(t, e) {
        const i = $4a792688e08e5cd7$var$rd.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(i), this.max.copy(t).add(i), this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(t) {
        return this.isEmpty() ? t.set(0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t) {
        return this.isEmpty() ? t.set(0, 0) : t.subVectors(this.max, this.min);
    }
    expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
    }
    expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
    }
    expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
    containsPoint(t) {
        return t.x >= this.min.x && t.x <= this.max.x && t.y >= this.min.y && t.y <= this.max.y;
    }
    containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y;
    }
    getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(t) {
        return t.max.x >= this.min.x && t.min.x <= this.max.x && t.max.y >= this.min.y && t.min.y <= this.max.y;
    }
    clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
    }
    distanceToPoint(t) {
        return this.clampPoint(t, $4a792688e08e5cd7$var$rd).distanceTo(t);
    }
    intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
    }
    translate(t) {
        return this.min.add(t), this.max.add(t), this;
    }
    equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
    }
}
const $4a792688e08e5cd7$var$ad = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$od = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$hd = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$ld = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$cd = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$ud = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$dd = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$e0ba6359f1954fd3 {
    constructor(t = new $4a792688e08e5cd7$export$64b5c384219d3699, e = new $4a792688e08e5cd7$export$64b5c384219d3699){
        this.start = t, this.end = e;
    }
    set(t, e) {
        return this.start.copy(t), this.end.copy(e), this;
    }
    copy(t) {
        return this.start.copy(t.start), this.end.copy(t.end), this;
    }
    getCenter(t) {
        return t.addVectors(this.start, this.end).multiplyScalar(.5);
    }
    delta(t) {
        return t.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, e) {
        return this.delta(e).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(t, e) {
        $4a792688e08e5cd7$var$ad.subVectors(t, this.start), $4a792688e08e5cd7$var$od.subVectors(this.end, this.start);
        const i = $4a792688e08e5cd7$var$od.dot($4a792688e08e5cd7$var$od);
        let s = $4a792688e08e5cd7$var$od.dot($4a792688e08e5cd7$var$ad) / i;
        return e && (s = $4a792688e08e5cd7$var$ns(s, 0, 1)), s;
    }
    closestPointToPoint(t, e, i) {
        const s = this.closestPointToPointParameter(t, e);
        return this.delta(i).multiplyScalar(s).add(this.start);
    }
    distanceSqToLine3(t, e = $4a792688e08e5cd7$var$ud, i = $4a792688e08e5cd7$var$dd) {
        const s = 1e-8 * 1e-8;
        let r, n;
        const a = this.start, o = t.start, h = this.end, l = t.end;
        $4a792688e08e5cd7$var$hd.subVectors(h, a), $4a792688e08e5cd7$var$ld.subVectors(l, o), $4a792688e08e5cd7$var$cd.subVectors(a, o);
        const c = $4a792688e08e5cd7$var$hd.dot($4a792688e08e5cd7$var$hd), u = $4a792688e08e5cd7$var$ld.dot($4a792688e08e5cd7$var$ld), d = $4a792688e08e5cd7$var$ld.dot($4a792688e08e5cd7$var$cd);
        if (c <= s && u <= s) return e.copy(a), i.copy(o), e.sub(i), e.dot(e);
        if (c <= s) r = 0, n = d / u, n = $4a792688e08e5cd7$var$ns(n, 0, 1);
        else {
            const t = $4a792688e08e5cd7$var$hd.dot($4a792688e08e5cd7$var$cd);
            if (u <= s) n = 0, r = $4a792688e08e5cd7$var$ns(-t / c, 0, 1);
            else {
                const e = $4a792688e08e5cd7$var$hd.dot($4a792688e08e5cd7$var$ld), i = c * u - e * e;
                r = 0 !== i ? $4a792688e08e5cd7$var$ns((e * d - t * u) / i, 0, 1) : 0, n = (e * r + d) / u, n < 0 ? (n = 0, r = $4a792688e08e5cd7$var$ns(-t / c, 0, 1)) : n > 1 && (n = 1, r = $4a792688e08e5cd7$var$ns((e - t) / c, 0, 1));
            }
        }
        return e.copy(a).add($4a792688e08e5cd7$var$hd.multiplyScalar(r)), i.copy(o).add($4a792688e08e5cd7$var$ld.multiplyScalar(n)), e.sub(i), e.dot(e);
    }
    applyMatrix4(t) {
        return this.start.applyMatrix4(t), this.end.applyMatrix4(t), this;
    }
    equals(t) {
        return t.start.equals(this.start) && t.end.equals(this.end);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
const $4a792688e08e5cd7$var$md = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$4b14638ffdd81e68 extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(t, e){
        super(), this.light = t, this.matrixAutoUpdate = !1, this.color = e, this.type = "SpotLightHelper";
        const i = new $4a792688e08e5cd7$export$b7be63a67df8959, s = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let t = 0, e = 1, i = 32; t < i; t++, e++){
            const r = t / i * Math.PI * 2, n = e / i * Math.PI * 2;
            s.push(Math.cos(r), Math.sin(r), 1, Math.cos(n), Math.sin(n), 1);
        }
        i.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(s, 3));
        const r = new $4a792688e08e5cd7$export$fbaaa33907730a0c({
            fog: !1,
            toneMapped: !1
        });
        this.cone = new $4a792688e08e5cd7$export$ff1ed10fedfdd604(i, r), this.add(this.cone), this.update();
    }
    dispose() {
        this.cone.geometry.dispose(), this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), this.parent ? (this.parent.updateWorldMatrix(!0), this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld)) : this.matrix.copy(this.light.matrixWorld), this.matrixWorld.copy(this.light.matrixWorld);
        const t = this.light.distance ? this.light.distance : 1e3, e = t * Math.tan(this.light.angle);
        this.cone.scale.set(e, e, t), $4a792688e08e5cd7$var$md.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt($4a792688e08e5cd7$var$md), void 0 !== this.color ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
    }
}
const $4a792688e08e5cd7$var$gd = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$fd = new $4a792688e08e5cd7$export$2ae72fc923e5eb5, $4a792688e08e5cd7$var$xd = new $4a792688e08e5cd7$export$2ae72fc923e5eb5;
class $4a792688e08e5cd7$export$5277df3c9e732259 extends $4a792688e08e5cd7$export$ff1ed10fedfdd604 {
    constructor(t){
        const e = $4a792688e08e5cd7$var$vd(t), i = new $4a792688e08e5cd7$export$b7be63a67df8959, s = [], r = [];
        for(let t = 0; t < e.length; t++){
            const i = e[t];
            i.parent && i.parent.isBone && (s.push(0, 0, 0), s.push(0, 0, 0), r.push(0, 0, 0), r.push(0, 0, 0));
        }
        i.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(s, 3)), i.setAttribute("color", new $4a792688e08e5cd7$export$cbe7a62641830ebd(r, 3));
        super(i, new $4a792688e08e5cd7$export$fbaaa33907730a0c({
            vertexColors: !0,
            depthTest: !1,
            depthWrite: !1,
            toneMapped: !1,
            transparent: !0
        })), this.isSkeletonHelper = !0, this.type = "SkeletonHelper", this.root = t, this.bones = e, this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1;
        const n = new $4a792688e08e5cd7$export$892596cec99bc70e(255), a = new $4a792688e08e5cd7$export$892596cec99bc70e(65280);
        this.setColors(n, a);
    }
    updateMatrixWorld(t) {
        const e = this.bones, i = this.geometry, s = i.getAttribute("position");
        $4a792688e08e5cd7$var$xd.copy(this.root.matrixWorld).invert();
        for(let t = 0, i = 0; t < e.length; t++){
            const r = e[t];
            r.parent && r.parent.isBone && ($4a792688e08e5cd7$var$fd.multiplyMatrices($4a792688e08e5cd7$var$xd, r.matrixWorld), $4a792688e08e5cd7$var$gd.setFromMatrixPosition($4a792688e08e5cd7$var$fd), s.setXYZ(i, $4a792688e08e5cd7$var$gd.x, $4a792688e08e5cd7$var$gd.y, $4a792688e08e5cd7$var$gd.z), $4a792688e08e5cd7$var$fd.multiplyMatrices($4a792688e08e5cd7$var$xd, r.parent.matrixWorld), $4a792688e08e5cd7$var$gd.setFromMatrixPosition($4a792688e08e5cd7$var$fd), s.setXYZ(i + 1, $4a792688e08e5cd7$var$gd.x, $4a792688e08e5cd7$var$gd.y, $4a792688e08e5cd7$var$gd.z), i += 2);
        }
        i.getAttribute("position").needsUpdate = !0, super.updateMatrixWorld(t);
    }
    setColors(t, e) {
        const i = this.geometry.getAttribute("color");
        for(let s = 0; s < i.count; s += 2)i.setXYZ(s, t.r, t.g, t.b), i.setXYZ(s + 1, e.r, e.g, e.b);
        return i.needsUpdate = !0, this;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
function $4a792688e08e5cd7$var$vd(t) {
    const e = [];
    !0 === t.isBone && e.push(t);
    for(let i = 0; i < t.children.length; i++)e.push(...$4a792688e08e5cd7$var$vd(t.children[i]));
    return e;
}
class $4a792688e08e5cd7$export$9a9291685b9e4023 extends $4a792688e08e5cd7$export$e176487c05830cc5 {
    constructor(t, e, i){
        super(new $4a792688e08e5cd7$export$1b417fc3b307a251(e, 4, 2), new $4a792688e08e5cd7$export$55cbcc9b622fe1f5({
            wireframe: !0,
            fog: !1,
            toneMapped: !1
        })), this.light = t, this.color = i, this.type = "PointLightHelper", this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), void 0 !== this.color ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
    }
}
const $4a792688e08e5cd7$var$Md = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Sd = new $4a792688e08e5cd7$export$892596cec99bc70e, $4a792688e08e5cd7$var$_d = new $4a792688e08e5cd7$export$892596cec99bc70e;
class $4a792688e08e5cd7$export$8dca15f13f4f8172 extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(t, e, i){
        super(), this.light = t, this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.color = i, this.type = "HemisphereLightHelper";
        const s = new $4a792688e08e5cd7$export$1954e2b809fe361e(e);
        s.rotateY(.5 * Math.PI), this.material = new $4a792688e08e5cd7$export$55cbcc9b622fe1f5({
            wireframe: !0,
            fog: !1,
            toneMapped: !1
        }), void 0 === this.color && (this.material.vertexColors = !0);
        const r = s.getAttribute("position"), n = new Float32Array(3 * r.count);
        s.setAttribute("color", new $4a792688e08e5cd7$export$8dea267bd6bde117(n, 3)), this.add(new $4a792688e08e5cd7$export$e176487c05830cc5(s, this.material)), this.update();
    }
    dispose() {
        this.children[0].geometry.dispose(), this.children[0].material.dispose();
    }
    update() {
        const t = this.children[0];
        if (void 0 !== this.color) this.material.color.set(this.color);
        else {
            const e = t.geometry.getAttribute("color");
            $4a792688e08e5cd7$var$Sd.copy(this.light.color), $4a792688e08e5cd7$var$_d.copy(this.light.groundColor);
            for(let t = 0, i = e.count; t < i; t++){
                const s = t < i / 2 ? $4a792688e08e5cd7$var$Sd : $4a792688e08e5cd7$var$_d;
                e.setXYZ(t, s.r, s.g, s.b);
            }
            e.needsUpdate = !0;
        }
        this.light.updateWorldMatrix(!0, !1), t.lookAt($4a792688e08e5cd7$var$Md.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $4a792688e08e5cd7$export$3875d39926561055 extends $4a792688e08e5cd7$export$ff1ed10fedfdd604 {
    constructor(t = 10, e = 10, i = 4473924, s = 8947848){
        i = new $4a792688e08e5cd7$export$892596cec99bc70e(i), s = new $4a792688e08e5cd7$export$892596cec99bc70e(s);
        const r = e / 2, n = t / e, a = t / 2, o = [], h = [];
        for(let t = 0, l = 0, c = -a; t <= e; t++, c += n){
            o.push(-a, 0, c, a, 0, c), o.push(c, 0, -a, c, 0, a);
            const e = t === r ? i : s;
            e.toArray(h, l), l += 3, e.toArray(h, l), l += 3, e.toArray(h, l), l += 3, e.toArray(h, l), l += 3;
        }
        const l = new $4a792688e08e5cd7$export$b7be63a67df8959;
        l.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(o, 3)), l.setAttribute("color", new $4a792688e08e5cd7$export$cbe7a62641830ebd(h, 3));
        super(l, new $4a792688e08e5cd7$export$fbaaa33907730a0c({
            vertexColors: !0,
            toneMapped: !1
        })), this.type = "GridHelper";
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
class $4a792688e08e5cd7$export$361430a10f533cd3 extends $4a792688e08e5cd7$export$ff1ed10fedfdd604 {
    constructor(t = 10, e = 16, i = 8, s = 64, r = 4473924, n = 8947848){
        r = new $4a792688e08e5cd7$export$892596cec99bc70e(r), n = new $4a792688e08e5cd7$export$892596cec99bc70e(n);
        const a = [], o = [];
        if (e > 1) for(let i = 0; i < e; i++){
            const s = i / e * (2 * Math.PI), h = Math.sin(s) * t, l = Math.cos(s) * t;
            a.push(0, 0, 0), a.push(h, 0, l);
            const c = 1 & i ? r : n;
            o.push(c.r, c.g, c.b), o.push(c.r, c.g, c.b);
        }
        for(let e = 0; e < i; e++){
            const h = 1 & e ? r : n, l = t - t / i * e;
            for(let t = 0; t < s; t++){
                let e = t / s * (2 * Math.PI), i = Math.sin(e) * l, r = Math.cos(e) * l;
                a.push(i, 0, r), o.push(h.r, h.g, h.b), e = (t + 1) / s * (2 * Math.PI), i = Math.sin(e) * l, r = Math.cos(e) * l, a.push(i, 0, r), o.push(h.r, h.g, h.b);
            }
        }
        const h = new $4a792688e08e5cd7$export$b7be63a67df8959;
        h.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(a, 3)), h.setAttribute("color", new $4a792688e08e5cd7$export$cbe7a62641830ebd(o, 3));
        super(h, new $4a792688e08e5cd7$export$fbaaa33907730a0c({
            vertexColors: !0,
            toneMapped: !1
        })), this.type = "PolarGridHelper";
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
const $4a792688e08e5cd7$var$Cd = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Id = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Bd = new $4a792688e08e5cd7$export$64b5c384219d3699;
class $4a792688e08e5cd7$export$f8e434dc14203e7d extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(t, e, i){
        super(), this.light = t, this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.color = i, this.type = "DirectionalLightHelper", void 0 === e && (e = 1);
        let s = new $4a792688e08e5cd7$export$b7be63a67df8959;
        s.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd([
            -e,
            e,
            0,
            e,
            e,
            0,
            e,
            -e,
            0,
            -e,
            -e,
            0,
            -e,
            e,
            0
        ], 3));
        const r = new $4a792688e08e5cd7$export$fbaaa33907730a0c({
            fog: !1,
            toneMapped: !1
        });
        this.lightPlane = new $4a792688e08e5cd7$export$17d680238e50603e(s, r), this.add(this.lightPlane), s = new $4a792688e08e5cd7$export$b7be63a67df8959, s.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3)), this.targetLine = new $4a792688e08e5cd7$export$17d680238e50603e(s, r), this.add(this.targetLine), this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), $4a792688e08e5cd7$var$Cd.setFromMatrixPosition(this.light.matrixWorld), $4a792688e08e5cd7$var$Id.setFromMatrixPosition(this.light.target.matrixWorld), $4a792688e08e5cd7$var$Bd.subVectors($4a792688e08e5cd7$var$Id, $4a792688e08e5cd7$var$Cd), this.lightPlane.lookAt($4a792688e08e5cd7$var$Id), void 0 !== this.color ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt($4a792688e08e5cd7$var$Id), this.targetLine.scale.z = $4a792688e08e5cd7$var$Bd.length();
    }
}
const $4a792688e08e5cd7$var$Pd = new $4a792688e08e5cd7$export$64b5c384219d3699, $4a792688e08e5cd7$var$Od = new $4a792688e08e5cd7$export$79f141de891a5fed;
class $4a792688e08e5cd7$export$ed8e93f853cd795 extends $4a792688e08e5cd7$export$ff1ed10fedfdd604 {
    constructor(t){
        const e = new $4a792688e08e5cd7$export$b7be63a67df8959, i = new $4a792688e08e5cd7$export$fbaaa33907730a0c({
            color: 16777215,
            vertexColors: !0,
            toneMapped: !1
        }), s = [], r = [], n = {};
        function a(t, e) {
            o(t), o(e);
        }
        function o(t) {
            s.push(0, 0, 0), r.push(0, 0, 0), void 0 === n[t] && (n[t] = []), n[t].push(s.length / 3 - 1);
        }
        a("n1", "n2"), a("n2", "n4"), a("n4", "n3"), a("n3", "n1"), a("f1", "f2"), a("f2", "f4"), a("f4", "f3"), a("f3", "f1"), a("n1", "f1"), a("n2", "f2"), a("n3", "f3"), a("n4", "f4"), a("p", "n1"), a("p", "n2"), a("p", "n3"), a("p", "n4"), a("u1", "u2"), a("u2", "u3"), a("u3", "u1"), a("c", "t"), a("p", "c"), a("cn1", "cn2"), a("cn3", "cn4"), a("cf1", "cf2"), a("cf3", "cf4"), e.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(s, 3)), e.setAttribute("color", new $4a792688e08e5cd7$export$cbe7a62641830ebd(r, 3)), super(e, i), this.type = "CameraHelper", this.camera = t, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = n, this.update();
        const h = new $4a792688e08e5cd7$export$892596cec99bc70e(16755200), l = new $4a792688e08e5cd7$export$892596cec99bc70e(16711680), c = new $4a792688e08e5cd7$export$892596cec99bc70e(43775), u = new $4a792688e08e5cd7$export$892596cec99bc70e(16777215), d = new $4a792688e08e5cd7$export$892596cec99bc70e(3355443);
        this.setColors(h, l, c, u, d);
    }
    setColors(t, e, i, s, r) {
        const n = this.geometry.getAttribute("color");
        return n.setXYZ(0, t.r, t.g, t.b), n.setXYZ(1, t.r, t.g, t.b), n.setXYZ(2, t.r, t.g, t.b), n.setXYZ(3, t.r, t.g, t.b), n.setXYZ(4, t.r, t.g, t.b), n.setXYZ(5, t.r, t.g, t.b), n.setXYZ(6, t.r, t.g, t.b), n.setXYZ(7, t.r, t.g, t.b), n.setXYZ(8, t.r, t.g, t.b), n.setXYZ(9, t.r, t.g, t.b), n.setXYZ(10, t.r, t.g, t.b), n.setXYZ(11, t.r, t.g, t.b), n.setXYZ(12, t.r, t.g, t.b), n.setXYZ(13, t.r, t.g, t.b), n.setXYZ(14, t.r, t.g, t.b), n.setXYZ(15, t.r, t.g, t.b), n.setXYZ(16, t.r, t.g, t.b), n.setXYZ(17, t.r, t.g, t.b), n.setXYZ(18, t.r, t.g, t.b), n.setXYZ(19, t.r, t.g, t.b), n.setXYZ(20, t.r, t.g, t.b), n.setXYZ(21, t.r, t.g, t.b), n.setXYZ(22, t.r, t.g, t.b), n.setXYZ(23, t.r, t.g, t.b), n.setXYZ(24, e.r, e.g, e.b), n.setXYZ(25, e.r, e.g, e.b), n.setXYZ(26, e.r, e.g, e.b), n.setXYZ(27, e.r, e.g, e.b), n.setXYZ(28, e.r, e.g, e.b), n.setXYZ(29, e.r, e.g, e.b), n.setXYZ(30, e.r, e.g, e.b), n.setXYZ(31, e.r, e.g, e.b), n.setXYZ(32, i.r, i.g, i.b), n.setXYZ(33, i.r, i.g, i.b), n.setXYZ(34, i.r, i.g, i.b), n.setXYZ(35, i.r, i.g, i.b), n.setXYZ(36, i.r, i.g, i.b), n.setXYZ(37, i.r, i.g, i.b), n.setXYZ(38, s.r, s.g, s.b), n.setXYZ(39, s.r, s.g, s.b), n.setXYZ(40, r.r, r.g, r.b), n.setXYZ(41, r.r, r.g, r.b), n.setXYZ(42, r.r, r.g, r.b), n.setXYZ(43, r.r, r.g, r.b), n.setXYZ(44, r.r, r.g, r.b), n.setXYZ(45, r.r, r.g, r.b), n.setXYZ(46, r.r, r.g, r.b), n.setXYZ(47, r.r, r.g, r.b), n.setXYZ(48, r.r, r.g, r.b), n.setXYZ(49, r.r, r.g, r.b), n.needsUpdate = !0, this;
    }
    update() {
        const t = this.geometry, e = this.pointMap;
        let i, s;
        if ($4a792688e08e5cd7$var$Od.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), !0 === this.camera.reversedDepth) i = 1, s = 0;
        else if (this.camera.coordinateSystem === $4a792688e08e5cd7$export$5a0e9190d10875d3) i = -1, s = 1;
        else {
            if (this.camera.coordinateSystem !== $4a792688e08e5cd7$export$cc83beedcb9be9ac) throw new Error("THREE.CameraHelper.update(): Invalid coordinate system: " + this.camera.coordinateSystem);
            i = 0, s = 1;
        }
        $4a792688e08e5cd7$var$Nd("c", e, t, $4a792688e08e5cd7$var$Od, 0, 0, i), $4a792688e08e5cd7$var$Nd("t", e, t, $4a792688e08e5cd7$var$Od, 0, 0, s), $4a792688e08e5cd7$var$Nd("n1", e, t, $4a792688e08e5cd7$var$Od, -1, -1, i), $4a792688e08e5cd7$var$Nd("n2", e, t, $4a792688e08e5cd7$var$Od, 1, -1, i), $4a792688e08e5cd7$var$Nd("n3", e, t, $4a792688e08e5cd7$var$Od, -1, 1, i), $4a792688e08e5cd7$var$Nd("n4", e, t, $4a792688e08e5cd7$var$Od, 1, 1, i), $4a792688e08e5cd7$var$Nd("f1", e, t, $4a792688e08e5cd7$var$Od, -1, -1, s), $4a792688e08e5cd7$var$Nd("f2", e, t, $4a792688e08e5cd7$var$Od, 1, -1, s), $4a792688e08e5cd7$var$Nd("f3", e, t, $4a792688e08e5cd7$var$Od, -1, 1, s), $4a792688e08e5cd7$var$Nd("f4", e, t, $4a792688e08e5cd7$var$Od, 1, 1, s), $4a792688e08e5cd7$var$Nd("u1", e, t, $4a792688e08e5cd7$var$Od, .7, 1.1, i), $4a792688e08e5cd7$var$Nd("u2", e, t, $4a792688e08e5cd7$var$Od, -0.7, 1.1, i), $4a792688e08e5cd7$var$Nd("u3", e, t, $4a792688e08e5cd7$var$Od, 0, 2, i), $4a792688e08e5cd7$var$Nd("cf1", e, t, $4a792688e08e5cd7$var$Od, -1, 0, s), $4a792688e08e5cd7$var$Nd("cf2", e, t, $4a792688e08e5cd7$var$Od, 1, 0, s), $4a792688e08e5cd7$var$Nd("cf3", e, t, $4a792688e08e5cd7$var$Od, 0, -1, s), $4a792688e08e5cd7$var$Nd("cf4", e, t, $4a792688e08e5cd7$var$Od, 0, 1, s), $4a792688e08e5cd7$var$Nd("cn1", e, t, $4a792688e08e5cd7$var$Od, -1, 0, i), $4a792688e08e5cd7$var$Nd("cn2", e, t, $4a792688e08e5cd7$var$Od, 1, 0, i), $4a792688e08e5cd7$var$Nd("cn3", e, t, $4a792688e08e5cd7$var$Od, 0, -1, i), $4a792688e08e5cd7$var$Nd("cn4", e, t, $4a792688e08e5cd7$var$Od, 0, 1, i), t.getAttribute("position").needsUpdate = !0;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
function $4a792688e08e5cd7$var$Nd(t, e, i, s, r, n, a) {
    $4a792688e08e5cd7$var$Pd.set(r, n, a).unproject(s);
    const o = e[t];
    if (void 0 !== o) {
        const t = i.getAttribute("position");
        for(let e = 0, i = o.length; e < i; e++)t.setXYZ(o[e], $4a792688e08e5cd7$var$Pd.x, $4a792688e08e5cd7$var$Pd.y, $4a792688e08e5cd7$var$Pd.z);
    }
}
const $4a792688e08e5cd7$var$Vd = new $4a792688e08e5cd7$export$6f7d5a9418ab2aa3;
class $4a792688e08e5cd7$export$38a664cc862a6a9d extends $4a792688e08e5cd7$export$ff1ed10fedfdd604 {
    constructor(t, e = 16776960){
        const i = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]), s = new Float32Array(24), r = new $4a792688e08e5cd7$export$b7be63a67df8959;
        r.setIndex(new $4a792688e08e5cd7$export$8dea267bd6bde117(i, 1)), r.setAttribute("position", new $4a792688e08e5cd7$export$8dea267bd6bde117(s, 3)), super(r, new $4a792688e08e5cd7$export$fbaaa33907730a0c({
            color: e,
            toneMapped: !1
        })), this.object = t, this.type = "BoxHelper", this.matrixAutoUpdate = !1, this.update();
    }
    update() {
        if (void 0 !== this.object && $4a792688e08e5cd7$var$Vd.setFromObject(this.object), $4a792688e08e5cd7$var$Vd.isEmpty()) return;
        const t = $4a792688e08e5cd7$var$Vd.min, e = $4a792688e08e5cd7$var$Vd.max, i = this.geometry.attributes.position, s = i.array;
        s[0] = e.x, s[1] = e.y, s[2] = e.z, s[3] = t.x, s[4] = e.y, s[5] = e.z, s[6] = t.x, s[7] = t.y, s[8] = e.z, s[9] = e.x, s[10] = t.y, s[11] = e.z, s[12] = e.x, s[13] = e.y, s[14] = t.z, s[15] = t.x, s[16] = e.y, s[17] = t.z, s[18] = t.x, s[19] = t.y, s[20] = t.z, s[21] = e.x, s[22] = t.y, s[23] = t.z, i.needsUpdate = !0, this.geometry.computeBoundingSphere();
    }
    setFromObject(t) {
        return this.object = t, this.update(), this;
    }
    copy(t, e) {
        return super.copy(t, e), this.object = t.object, this;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
class $4a792688e08e5cd7$export$ce39f4bb96c9a290 extends $4a792688e08e5cd7$export$ff1ed10fedfdd604 {
    constructor(t, e = 16776960){
        const i = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]), s = new $4a792688e08e5cd7$export$b7be63a67df8959;
        s.setIndex(new $4a792688e08e5cd7$export$8dea267bd6bde117(i, 1)), s.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd([
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ], 3)), super(s, new $4a792688e08e5cd7$export$fbaaa33907730a0c({
            color: e,
            toneMapped: !1
        })), this.box = t, this.type = "Box3Helper", this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(t) {
        const e = this.box;
        e.isEmpty() || (e.getCenter(this.position), e.getSize(this.scale), this.scale.multiplyScalar(.5), super.updateMatrixWorld(t));
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
class $4a792688e08e5cd7$export$a34fe8156c66e5d7 extends $4a792688e08e5cd7$export$17d680238e50603e {
    constructor(t, e = 1, i = 16776960){
        const s = i, r = new $4a792688e08e5cd7$export$b7be63a67df8959;
        r.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd([
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ], 3)), r.computeBoundingSphere(), super(r, new $4a792688e08e5cd7$export$fbaaa33907730a0c({
            color: s,
            toneMapped: !1
        })), this.type = "PlaneHelper", this.plane = t, this.size = e;
        const n = new $4a792688e08e5cd7$export$b7be63a67df8959;
        n.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd([
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ], 3)), n.computeBoundingSphere(), this.add(new $4a792688e08e5cd7$export$e176487c05830cc5(n, new $4a792688e08e5cd7$export$55cbcc9b622fe1f5({
            color: s,
            opacity: .2,
            transparent: !0,
            depthWrite: !1,
            toneMapped: !1
        })));
    }
    updateMatrixWorld(t) {
        this.position.set(0, 0, 0), this.scale.set(.5 * this.size, .5 * this.size, 1), this.lookAt(this.plane.normal), this.translateZ(-this.plane.constant), super.updateMatrixWorld(t);
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose(), this.children[0].geometry.dispose(), this.children[0].material.dispose();
    }
}
const $4a792688e08e5cd7$var$jd = new $4a792688e08e5cd7$export$64b5c384219d3699;
let $4a792688e08e5cd7$var$Dd, $4a792688e08e5cd7$var$Wd;
class $4a792688e08e5cd7$export$a3008e7bd8d2cbe7 extends $4a792688e08e5cd7$export$e4dd07dff30cc924 {
    constructor(t = new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0, 1), e = new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0, 0), i = 1, s = 16776960, r = .2 * i, n = .2 * r){
        super(), this.type = "ArrowHelper", void 0 === $4a792688e08e5cd7$var$Dd && ($4a792688e08e5cd7$var$Dd = new $4a792688e08e5cd7$export$b7be63a67df8959, $4a792688e08e5cd7$var$Dd.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            1,
            0
        ], 3)), $4a792688e08e5cd7$var$Wd = new $4a792688e08e5cd7$export$a7a48974f285c9b3(.5, 1, 5, 1), $4a792688e08e5cd7$var$Wd.translate(0, -0.5, 0)), this.position.copy(e), this.line = new $4a792688e08e5cd7$export$17d680238e50603e($4a792688e08e5cd7$var$Dd, new $4a792688e08e5cd7$export$fbaaa33907730a0c({
            color: s,
            toneMapped: !1
        })), this.line.matrixAutoUpdate = !1, this.add(this.line), this.cone = new $4a792688e08e5cd7$export$e176487c05830cc5($4a792688e08e5cd7$var$Wd, new $4a792688e08e5cd7$export$55cbcc9b622fe1f5({
            color: s,
            toneMapped: !1
        })), this.cone.matrixAutoUpdate = !1, this.add(this.cone), this.setDirection(t), this.setLength(i, r, n);
    }
    setDirection(t) {
        if (t.y > .99999) this.quaternion.set(0, 0, 0, 1);
        else if (t.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $4a792688e08e5cd7$var$jd.set(t.z, 0, -t.x).normalize();
            const e = Math.acos(t.y);
            this.quaternion.setFromAxisAngle($4a792688e08e5cd7$var$jd, e);
        }
    }
    setLength(t, e = .2 * t, i = .2 * e) {
        this.line.scale.set(1, Math.max(1e-4, t - e), 1), this.line.updateMatrix(), this.cone.scale.set(i, e, i), this.cone.position.y = t, this.cone.updateMatrix();
    }
    setColor(t) {
        this.line.material.color.set(t), this.cone.material.color.set(t);
    }
    copy(t) {
        return super.copy(t, !1), this.line.copy(t.line), this.cone.copy(t.cone), this;
    }
    dispose() {
        this.line.geometry.dispose(), this.line.material.dispose(), this.cone.geometry.dispose(), this.cone.material.dispose();
    }
}
class $4a792688e08e5cd7$export$6c8303f35b8578fd extends $4a792688e08e5cd7$export$ff1ed10fedfdd604 {
    constructor(t = 1){
        const e = [
            0,
            0,
            0,
            t,
            0,
            0,
            0,
            0,
            0,
            0,
            t,
            0,
            0,
            0,
            0,
            0,
            0,
            t
        ], i = new $4a792688e08e5cd7$export$b7be63a67df8959;
        i.setAttribute("position", new $4a792688e08e5cd7$export$cbe7a62641830ebd(e, 3)), i.setAttribute("color", new $4a792688e08e5cd7$export$cbe7a62641830ebd([
            1,
            0,
            0,
            1,
            .6,
            0,
            0,
            1,
            0,
            .6,
            1,
            0,
            0,
            0,
            1,
            0,
            .6,
            1
        ], 3));
        super(i, new $4a792688e08e5cd7$export$fbaaa33907730a0c({
            vertexColors: !0,
            toneMapped: !1
        })), this.type = "AxesHelper";
    }
    setColors(t, e, i) {
        const s = new $4a792688e08e5cd7$export$892596cec99bc70e, r = this.geometry.attributes.color.array;
        return s.set(t), s.toArray(r, 0), s.toArray(r, 3), s.set(e), s.toArray(r, 6), s.toArray(r, 9), s.set(i), s.toArray(r, 12), s.toArray(r, 15), this.geometry.attributes.color.needsUpdate = !0, this;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
class $4a792688e08e5cd7$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath", this.color = new $4a792688e08e5cd7$export$892596cec99bc70e, this.subPaths = [], this.currentPath = null;
    }
    moveTo(t, e) {
        return this.currentPath = new $4a792688e08e5cd7$export$4b2950bdac9b6ee9, this.subPaths.push(this.currentPath), this.currentPath.moveTo(t, e), this;
    }
    lineTo(t, e) {
        return this.currentPath.lineTo(t, e), this;
    }
    quadraticCurveTo(t, e, i, s) {
        return this.currentPath.quadraticCurveTo(t, e, i, s), this;
    }
    bezierCurveTo(t, e, i, s, r, n) {
        return this.currentPath.bezierCurveTo(t, e, i, s, r, n), this;
    }
    splineThru(t) {
        return this.currentPath.splineThru(t), this;
    }
    toShapes(t) {
        function e(t, e) {
            const i = e.length;
            let s = !1;
            for(let r = i - 1, n = 0; n < i; r = n++){
                let i = e[r], a = e[n], o = a.x - i.x, h = a.y - i.y;
                if (Math.abs(h) > Number.EPSILON) {
                    if (h < 0 && (i = e[n], o = -o, a = e[r], h = -h), t.y < i.y || t.y > a.y) continue;
                    if (t.y === i.y) {
                        if (t.x === i.x) return !0;
                    } else {
                        const e = h * (t.x - i.x) - o * (t.y - i.y);
                        if (0 === e) return !0;
                        if (e < 0) continue;
                        s = !s;
                    }
                } else {
                    if (t.y !== i.y) continue;
                    if (a.x <= t.x && t.x <= i.x || i.x <= t.x && t.x <= a.x) return !0;
                }
            }
            return s;
        }
        const i = $4a792688e08e5cd7$export$96bdf6d9c66d7ba8.isClockWise, s = this.subPaths;
        if (0 === s.length) return [];
        let r, n, a;
        const o = [];
        if (1 === s.length) return n = s[0], a = new $4a792688e08e5cd7$export$6428a7f2611ef1fa, a.curves = n.curves, o.push(a), o;
        let h = !i(s[0].getPoints());
        h = t ? !h : h;
        const l = [], c = [];
        let u, d, p = [], m = 0;
        c[m] = void 0, p[m] = [];
        for(let e = 0, a = s.length; e < a; e++)n = s[e], u = n.getPoints(), r = i(u), r = t ? !r : r, r ? (!h && c[m] && m++, c[m] = {
            s: new $4a792688e08e5cd7$export$6428a7f2611ef1fa,
            p: u
        }, c[m].s.curves = n.curves, h && m++, p[m] = []) : p[m].push({
            h: n,
            p: u[0]
        });
        if (!c[0]) return function(t) {
            const e = [];
            for(let i = 0, s = t.length; i < s; i++){
                const s = t[i], r = new $4a792688e08e5cd7$export$6428a7f2611ef1fa;
                r.curves = s.curves, e.push(r);
            }
            return e;
        }(s);
        if (c.length > 1) {
            let t = !1, i = 0;
            for(let t = 0, e = c.length; t < e; t++)l[t] = [];
            for(let s = 0, r = c.length; s < r; s++){
                const r = p[s];
                for(let n = 0; n < r.length; n++){
                    const a = r[n];
                    let o = !0;
                    for(let r = 0; r < c.length; r++)e(a.p, c[r].p) && (s !== r && i++, o ? (o = !1, l[r].push(a)) : t = !0);
                    o && l[s].push(a);
                }
            }
            i > 0 && !1 === t && (p = l);
        }
        for(let t = 0, e = c.length; t < e; t++){
            a = c[t].s, o.push(a), d = p[t];
            for(let t = 0, e = d.length; t < e; t++)a.holes.push(d[t].h);
        }
        return o;
    }
}
class $4a792688e08e5cd7$export$c7c44baae9d9f25f extends $4a792688e08e5cd7$export$ec8b666c5fe2c75a {
    constructor(t, e = null){
        super(), this.object = t, this.domElement = e, this.enabled = !0, this.state = -1, this.keys = {}, this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        }, this.touches = {
            ONE: null,
            TWO: null
        };
    }
    connect(t) {
        void 0 !== t ? (null !== this.domElement && this.disconnect(), this.domElement = t) : $4a792688e08e5cd7$export$c106dd0671a0fc2d("Controls: connect() now requires an element.");
    }
    disconnect() {}
    dispose() {}
    update() {}
}
function $4a792688e08e5cd7$export$cc8c3b705bb8e6e2(t, e, i, s) {
    const r = function(t) {
        switch(t){
            case $4a792688e08e5cd7$export$2e8ce08d3f6f5e10:
            case $4a792688e08e5cd7$export$545fce0311a9796a:
                return {
                    byteLength: 1,
                    components: 1
                };
            case $4a792688e08e5cd7$export$c63dc51868b06a9d:
            case $4a792688e08e5cd7$export$88572337f312435f:
            case $4a792688e08e5cd7$export$2697304443f382bc:
                return {
                    byteLength: 2,
                    components: 1
                };
            case $4a792688e08e5cd7$export$b3969b01faf587f2:
            case $4a792688e08e5cd7$export$18886f8ae33e90de:
                return {
                    byteLength: 2,
                    components: 4
                };
            case $4a792688e08e5cd7$export$c3c7fc4518ebba96:
            case $4a792688e08e5cd7$export$5c612977753abe2:
            case $4a792688e08e5cd7$export$f6d331659b644596:
                return {
                    byteLength: 4,
                    components: 1
                };
            case $4a792688e08e5cd7$export$5a4c329b7e2092d3:
            case $4a792688e08e5cd7$export$f240f067f72abe41:
                return {
                    byteLength: 4,
                    components: 3
                };
        }
        throw new Error(`Unknown texture type ${t}.`);
    }(s);
    switch(i){
        case 1021:
            return t * e;
        case $4a792688e08e5cd7$export$4e041a7967d15c4b:
        case $4a792688e08e5cd7$export$aa92e870a709d190:
            return t * e / r.components * r.byteLength;
        case 1030:
        case 1031:
            return t * e * 2 / r.components * r.byteLength;
        case 1022:
            return t * e * 3 / r.components * r.byteLength;
        case $4a792688e08e5cd7$export$3f8bb04b555a363c:
        case 1033:
            return t * e * 4 / r.components * r.byteLength;
        case 33776:
        case 33777:
            return Math.floor((t + 3) / 4) * Math.floor((e + 3) / 4) * 8;
        case 33778:
        case 33779:
            return Math.floor((t + 3) / 4) * Math.floor((e + 3) / 4) * 16;
        case 35841:
        case 35843:
            return Math.max(t, 16) * Math.max(e, 8) / 4;
        case 35840:
        case 35842:
            return Math.max(t, 8) * Math.max(e, 8) / 2;
        case 36196:
        case 37492:
            return Math.floor((t + 3) / 4) * Math.floor((e + 3) / 4) * 8;
        case 37496:
        case 37808:
            return Math.floor((t + 3) / 4) * Math.floor((e + 3) / 4) * 16;
        case 37809:
            return Math.floor((t + 4) / 5) * Math.floor((e + 3) / 4) * 16;
        case 37810:
            return Math.floor((t + 4) / 5) * Math.floor((e + 4) / 5) * 16;
        case 37811:
            return Math.floor((t + 5) / 6) * Math.floor((e + 4) / 5) * 16;
        case 37812:
            return Math.floor((t + 5) / 6) * Math.floor((e + 5) / 6) * 16;
        case 37813:
            return Math.floor((t + 7) / 8) * Math.floor((e + 4) / 5) * 16;
        case 37814:
            return Math.floor((t + 7) / 8) * Math.floor((e + 5) / 6) * 16;
        case 37815:
            return Math.floor((t + 7) / 8) * Math.floor((e + 7) / 8) * 16;
        case 37816:
            return Math.floor((t + 9) / 10) * Math.floor((e + 4) / 5) * 16;
        case 37817:
            return Math.floor((t + 9) / 10) * Math.floor((e + 5) / 6) * 16;
        case 37818:
            return Math.floor((t + 9) / 10) * Math.floor((e + 7) / 8) * 16;
        case 37819:
            return Math.floor((t + 9) / 10) * Math.floor((e + 9) / 10) * 16;
        case 37820:
            return Math.floor((t + 11) / 12) * Math.floor((e + 9) / 10) * 16;
        case 37821:
            return Math.floor((t + 11) / 12) * Math.floor((e + 11) / 12) * 16;
        case 36492:
        case 36494:
        case 36495:
            return Math.ceil(t / 4) * Math.ceil(e / 4) * 16;
        case 36283:
        case 36284:
            return Math.ceil(t / 4) * Math.ceil(e / 4) * 8;
        case 36285:
        case 36286:
            return Math.ceil(t / 4) * Math.ceil(e / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${i} format.`);
}
class $4a792688e08e5cd7$export$ec276d39f33d4b7 {
    static contain(t, e) {
        return function(t, e) {
            const i = t.image && t.image.width ? t.image.width / t.image.height : 1;
            return i > e ? (t.repeat.x = 1, t.repeat.y = i / e, t.offset.x = 0, t.offset.y = (1 - t.repeat.y) / 2) : (t.repeat.x = e / i, t.repeat.y = 1, t.offset.x = (1 - t.repeat.x) / 2, t.offset.y = 0), t;
        }(t, e);
    }
    static cover(t, e) {
        return function(t, e) {
            const i = t.image && t.image.width ? t.image.width / t.image.height : 1;
            return i > e ? (t.repeat.x = e / i, t.repeat.y = 1, t.offset.x = (1 - t.repeat.x) / 2, t.offset.y = 0) : (t.repeat.x = 1, t.repeat.y = i / e, t.offset.x = 0, t.offset.y = (1 - t.repeat.y) / 2), t;
        }(t, e);
    }
    static fill(t) {
        return function(t) {
            return t.repeat.x = 1, t.repeat.y = 1, t.offset.x = 0, t.offset.y = 0, t;
        }(t);
    }
    static getByteLength(t, e, i, s) {
        return $4a792688e08e5cd7$export$cc8c3b705bb8e6e2(t, e, i, s);
    }
}
"undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $4a792688e08e5cd7$export$3545e07a80636437
    }
})), "undefined" != typeof window && (window.__THREE__ ? $4a792688e08e5cd7$export$c106dd0671a0fc2d("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = $4a792688e08e5cd7$export$3545e07a80636437);



function $5292c45f2b641b96$var$Dn() {
    let e = null, t = !1, n = null, i = null;
    function r(t, a) {
        n(t, a), i = e.requestAnimationFrame(r);
    }
    return {
        start: function() {
            !0 !== t && null !== n && (i = e.requestAnimationFrame(r), t = !0);
        },
        stop: function() {
            e.cancelAnimationFrame(i), t = !1;
        },
        setAnimationLoop: function(e) {
            n = e;
        },
        setContext: function(t) {
            e = t;
        }
    };
}
function $5292c45f2b641b96$var$wn(e) {
    const t = new WeakMap;
    return {
        get: function(e) {
            return e.isInterleavedBufferAttribute && (e = e.data), t.get(e);
        },
        remove: function(n) {
            n.isInterleavedBufferAttribute && (n = n.data);
            const i = t.get(n);
            i && (e.deleteBuffer(i.buffer), t.delete(n));
        },
        update: function(n, i) {
            if (n.isInterleavedBufferAttribute && (n = n.data), n.isGLBufferAttribute) {
                const e = t.get(n);
                return void ((!e || e.version < n.version) && t.set(n, {
                    buffer: n.buffer,
                    type: n.type,
                    bytesPerElement: n.elementSize,
                    version: n.version
                }));
            }
            const r = t.get(n);
            if (void 0 === r) t.set(n, function(t, n) {
                const i = t.array, r = t.usage, a = i.byteLength, o = e.createBuffer();
                let s;
                if (e.bindBuffer(n, o), e.bufferData(n, i, r), t.onUploadCallback(), i instanceof Float32Array) s = e.FLOAT;
                else if ("undefined" != typeof Float16Array && i instanceof Float16Array) s = e.HALF_FLOAT;
                else if (i instanceof Uint16Array) s = t.isFloat16BufferAttribute ? e.HALF_FLOAT : e.UNSIGNED_SHORT;
                else if (i instanceof Int16Array) s = e.SHORT;
                else if (i instanceof Uint32Array) s = e.UNSIGNED_INT;
                else if (i instanceof Int32Array) s = e.INT;
                else if (i instanceof Int8Array) s = e.BYTE;
                else if (i instanceof Uint8Array) s = e.UNSIGNED_BYTE;
                else {
                    if (!(i instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + i);
                    s = e.UNSIGNED_BYTE;
                }
                return {
                    buffer: o,
                    type: s,
                    bytesPerElement: i.BYTES_PER_ELEMENT,
                    version: t.version,
                    size: a
                };
            }(n, i));
            else if (r.version < n.version) {
                if (r.size !== n.array.byteLength) throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
                !function(t, n, i) {
                    const r = n.array, a = n.updateRanges;
                    if (e.bindBuffer(i, t), 0 === a.length) e.bufferSubData(i, 0, r);
                    else {
                        a.sort((e, t)=>e.start - t.start);
                        let t = 0;
                        for(let e = 1; e < a.length; e++){
                            const n = a[t], i = a[e];
                            i.start <= n.start + n.count + 1 ? n.count = Math.max(n.count, i.start + i.count - n.start) : (++t, a[t] = i);
                        }
                        a.length = t + 1;
                        for(let t = 0, n = a.length; t < n; t++){
                            const n = a[t];
                            e.bufferSubData(i, n.start * r.BYTES_PER_ELEMENT, r, n.start, n.count);
                        }
                        n.clearUpdateRanges();
                    }
                    n.onUploadCallback();
                }(r.buffer, n, i), r.version = n.version;
            }
        }
    };
}
const $5292c45f2b641b96$export$955f9f2e84c43c8b = {
    alphahash_fragment: "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
    alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif",
    alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
    alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
    alphatest_fragment: "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif",
    alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif",
    aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif",
    aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
    batching_pars_vertex: "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif",
    batching_vertex: "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif",
    begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif",
    beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif",
    bsdfs: "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated",
    iridescence_fragment: "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif",
    bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif",
    clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif",
    clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
    clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif",
    clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif",
    color_fragment: "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif",
    color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif",
    color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif",
    color_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif",
    common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
    cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif",
    defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif",
    displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif",
    displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
    emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
    emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif",
    colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
    colorspace_pars_fragment: "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}",
    envmap_fragment: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif",
    envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n#endif",
    envmap_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif",
    envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif",
    envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif",
    envmap_vertex: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif",
    fog_vertex: "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif",
    fog_pars_vertex: "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif",
    fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
    fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif",
    gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}",
    lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
    lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
    lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert",
    lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif",
    lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
    lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon",
    lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
    lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong",
    lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif",
    lights_physical_pars_fragment: "uniform sampler2D dfgLUT;\nstruct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 uv = vec2( roughness, dotNV );\n\treturn texture2D( dfgLUT, uv ).rg;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nvec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 dfgV = DFGApprox( vec3(0.0, 0.0, 1.0), vec3(sqrt(1.0 - dotNV * dotNV), 0.0, dotNV), material.roughness );\n\tvec2 dfgL = DFGApprox( vec3(0.0, 0.0, 1.0), vec3(sqrt(1.0 - dotNL * dotNL), 0.0, dotNL), material.roughness );\n\tvec3 FssEss_V = material.specularColor * dfgV.x + material.specularF90 * dfgV.y;\n\tvec3 FssEss_L = material.specularColor * dfgL.x + material.specularF90 * dfgL.y;\n\tfloat Ess_V = dfgV.x + dfgV.y;\n\tfloat Ess_L = dfgL.x + dfgL.y;\n\tfloat Ems_V = 1.0 - Ess_V;\n\tfloat Ems_L = 1.0 - Ess_L;\n\tvec3 Favg = material.specularColor + ( 1.0 - material.specularColor ) * 0.047619;\n\tvec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg * Favg + EPSILON );\n\tfloat compensationFactor = Ems_V * Ems_L;\n\tvec3 multiScatter = Fms * compensationFactor;\n\treturn singleScatter + multiScatter;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
    lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
    lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif",
    lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
    logdepthbuf_fragment: "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
    logdepthbuf_pars_fragment: "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
    logdepthbuf_pars_vertex: "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
    logdepthbuf_vertex: "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif",
    map_fragment: "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif",
    map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif",
    map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
    map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
    metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif",
    metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
    morphinstance_vertex: "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif",
    morphcolor_vertex: "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif",
    morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif",
    morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif",
    morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif",
    normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
    normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
    normal_pars_fragment: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
    normal_pars_vertex: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
    normal_vertex: "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif",
    normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif",
    clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
    clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
    clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif",
    iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif",
    opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
    packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}",
    premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif",
    project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
    dithering_fragment: "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
    dithering_pars_fragment: "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif",
    roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif",
    roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
    shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\tfloat depth = unpackRGBAToDepth( texture2D( depths, uv ) );\n\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\treturn step( depth, compare );\n\t\t#else\n\t\t\treturn step( compare, depth );\n\t\t#endif\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow( sampler2D shadow, vec2 uv, float compare ) {\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\tfloat hard_shadow = step( distribution.x, compare );\n\t\t#else\n\t\t\tfloat hard_shadow = step( compare, distribution.x );\n\t\t#endif\n\t\tif ( hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif",
    shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif",
    shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif",
    shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}",
    skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
    skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif",
    skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
    skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif",
    specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
    specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
    tonemapping_fragment: "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
    tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
    transmission_fragment: "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
    transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif",
    uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
    uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
    uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
    worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif",
    background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
    background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
    backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
    cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    depth_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}",
    depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\tfloat fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n\t#else\n\t\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n\t#endif\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}",
    distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}",
    distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}",
    equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}",
    equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
    linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    meshbasic_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}",
    meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}",
    meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}",
    meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}",
    meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}",
    meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}",
    points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    shadow_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}",
    sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
    sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}"
}, $5292c45f2b641b96$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(16777215)
        },
        opacity: {
            value: 1
        },
        map: {
            value: null
        },
        mapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: .98
        },
        dfgLUT: {
            value: null
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        },
        normalScale: {
            value: new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 25e-5
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2e3
        },
        fogColor: {
            value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(16777215)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(16777215)
        },
        opacity: {
            value: 1
        },
        size: {
            value: 1
        },
        scale: {
            value: 1
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        }
    },
    sprite: {
        diffuse: {
            value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(16777215)
        },
        opacity: {
            value: 1
        },
        center: {
            value: new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1)(.5, .5)
        },
        rotation: {
            value: 0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
        },
        alphaTest: {
            value: 0
        }
    }
}, $5292c45f2b641b96$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.common,
            $5292c45f2b641b96$export$6643083551874bf5.specularmap,
            $5292c45f2b641b96$export$6643083551874bf5.envmap,
            $5292c45f2b641b96$export$6643083551874bf5.aomap,
            $5292c45f2b641b96$export$6643083551874bf5.lightmap,
            $5292c45f2b641b96$export$6643083551874bf5.fog
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.common,
            $5292c45f2b641b96$export$6643083551874bf5.specularmap,
            $5292c45f2b641b96$export$6643083551874bf5.envmap,
            $5292c45f2b641b96$export$6643083551874bf5.aomap,
            $5292c45f2b641b96$export$6643083551874bf5.lightmap,
            $5292c45f2b641b96$export$6643083551874bf5.emissivemap,
            $5292c45f2b641b96$export$6643083551874bf5.bumpmap,
            $5292c45f2b641b96$export$6643083551874bf5.normalmap,
            $5292c45f2b641b96$export$6643083551874bf5.displacementmap,
            $5292c45f2b641b96$export$6643083551874bf5.fog,
            $5292c45f2b641b96$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0)
                }
            }
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.common,
            $5292c45f2b641b96$export$6643083551874bf5.specularmap,
            $5292c45f2b641b96$export$6643083551874bf5.envmap,
            $5292c45f2b641b96$export$6643083551874bf5.aomap,
            $5292c45f2b641b96$export$6643083551874bf5.lightmap,
            $5292c45f2b641b96$export$6643083551874bf5.emissivemap,
            $5292c45f2b641b96$export$6643083551874bf5.bumpmap,
            $5292c45f2b641b96$export$6643083551874bf5.normalmap,
            $5292c45f2b641b96$export$6643083551874bf5.displacementmap,
            $5292c45f2b641b96$export$6643083551874bf5.fog,
            $5292c45f2b641b96$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0)
                },
                specular: {
                    value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(1118481)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.common,
            $5292c45f2b641b96$export$6643083551874bf5.envmap,
            $5292c45f2b641b96$export$6643083551874bf5.aomap,
            $5292c45f2b641b96$export$6643083551874bf5.lightmap,
            $5292c45f2b641b96$export$6643083551874bf5.emissivemap,
            $5292c45f2b641b96$export$6643083551874bf5.bumpmap,
            $5292c45f2b641b96$export$6643083551874bf5.normalmap,
            $5292c45f2b641b96$export$6643083551874bf5.displacementmap,
            $5292c45f2b641b96$export$6643083551874bf5.roughnessmap,
            $5292c45f2b641b96$export$6643083551874bf5.metalnessmap,
            $5292c45f2b641b96$export$6643083551874bf5.fog,
            $5292c45f2b641b96$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0)
                },
                roughness: {
                    value: 1
                },
                metalness: {
                    value: 0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.common,
            $5292c45f2b641b96$export$6643083551874bf5.aomap,
            $5292c45f2b641b96$export$6643083551874bf5.lightmap,
            $5292c45f2b641b96$export$6643083551874bf5.emissivemap,
            $5292c45f2b641b96$export$6643083551874bf5.bumpmap,
            $5292c45f2b641b96$export$6643083551874bf5.normalmap,
            $5292c45f2b641b96$export$6643083551874bf5.displacementmap,
            $5292c45f2b641b96$export$6643083551874bf5.gradientmap,
            $5292c45f2b641b96$export$6643083551874bf5.fog,
            $5292c45f2b641b96$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0)
                }
            }
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.common,
            $5292c45f2b641b96$export$6643083551874bf5.bumpmap,
            $5292c45f2b641b96$export$6643083551874bf5.normalmap,
            $5292c45f2b641b96$export$6643083551874bf5.displacementmap,
            $5292c45f2b641b96$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.points,
            $5292c45f2b641b96$export$6643083551874bf5.fog
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.common,
            $5292c45f2b641b96$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.common,
            $5292c45f2b641b96$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.common,
            $5292c45f2b641b96$export$6643083551874bf5.bumpmap,
            $5292c45f2b641b96$export$6643083551874bf5.normalmap,
            $5292c45f2b641b96$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.sprite,
            $5292c45f2b641b96$export$6643083551874bf5.fog
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            }
        },
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1
            }
        },
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.common,
            $5292c45f2b641b96$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: new (0, $4a792688e08e5cd7$export$64b5c384219d3699)
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1e3
                }
            }
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
            $5292c45f2b641b96$export$6643083551874bf5.lights,
            $5292c45f2b641b96$export$6643083551874bf5.fog,
            {
                color: {
                    value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0)
                },
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.shadow_frag
    }
};
$5292c45f2b641b96$export$bee4a7d47f8f5014.physical = {
    uniforms: (0, $4a792688e08e5cd7$export$8916ce6879271f43)([
        $5292c45f2b641b96$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            clearcoatNormalScale: {
                value: new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            transmissionSamplerSize: {
                value: new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1)
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0)
            },
            specularColor: {
                value: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            },
            anisotropyVector: {
                value: new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1)
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: new (0, $4a792688e08e5cd7$export$8ff26dafa08918)
            }
        }
    ]),
    vertexShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $5292c45f2b641b96$export$955f9f2e84c43c8b.meshphysical_frag
};
const $5292c45f2b641b96$var$On = {
    r: 0,
    b: 0,
    g: 0
}, $5292c45f2b641b96$var$Fn = new (0, $4a792688e08e5cd7$export$d93cc409a0768c5f), $5292c45f2b641b96$var$Bn = new (0, $4a792688e08e5cd7$export$2ae72fc923e5eb5);
function $5292c45f2b641b96$var$Gn(e, t, i, r, u, f, v) {
    const E = new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0);
    let S, T, M = !0 === f ? 0 : 1, x = null, A = 0, R = null;
    function b(e) {
        let n = !0 === e.isScene ? e.background : null;
        if (n && n.isTexture) n = (e.backgroundBlurriness > 0 ? i : t).get(n);
        return n;
    }
    function C(t, n) {
        t.getRGB($5292c45f2b641b96$var$On, (0, $4a792688e08e5cd7$export$a630742c640528c1)(e)), r.buffers.color.setClear($5292c45f2b641b96$var$On.r, $5292c45f2b641b96$var$On.g, $5292c45f2b641b96$var$On.b, n, v);
    }
    return {
        getClearColor: function() {
            return E;
        },
        setClearColor: function(e, t = 1) {
            E.set(e), M = t, C(E, M);
        },
        getClearAlpha: function() {
            return M;
        },
        setClearAlpha: function(e) {
            M = e, C(E, M);
        },
        render: function(t) {
            let n = !1;
            const i = b(t);
            null === i ? C(E, M) : i && i.isColor && (C(i, 1), n = !0);
            const a = e.xr.getEnvironmentBlendMode();
            "additive" === a ? r.buffers.color.setClear(0, 0, 0, 1, v) : "alpha-blend" === a && r.buffers.color.setClear(0, 0, 0, 0, v), (e.autoClear || n) && (r.buffers.depth.setTest(!0), r.buffers.depth.setMask(!0), r.buffers.color.setMask(!0), e.clear(e.autoClearColor, e.autoClearDepth, e.autoClearStencil));
        },
        addToRenderList: function(t, n) {
            const i = b(n);
            i && (i.isCubeTexture || i.mapping === (0, $4a792688e08e5cd7$export$dbf3e70ff37af79)) ? (void 0 === T && (T = new (0, $4a792688e08e5cd7$export$e176487c05830cc5)(new (0, $4a792688e08e5cd7$export$33e43285f7406bd5)(1, 1, 1), new (0, $4a792688e08e5cd7$export$83c7d75d550a8b0d)({
                name: "BackgroundCubeMaterial",
                uniforms: (0, $4a792688e08e5cd7$export$acda854380553452)($5292c45f2b641b96$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                vertexShader: $5292c45f2b641b96$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                fragmentShader: $5292c45f2b641b96$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                side: (0, $4a792688e08e5cd7$export$d9f0486e75b5ace),
                depthTest: !1,
                depthWrite: !1,
                fog: !1,
                allowOverride: !1
            })), T.geometry.deleteAttribute("normal"), T.geometry.deleteAttribute("uv"), T.onBeforeRender = function(e, t, n) {
                this.matrixWorld.copyPosition(n.matrixWorld);
            }, Object.defineProperty(T.material, "envMap", {
                get: function() {
                    return this.uniforms.envMap.value;
                }
            }), u.update(T)), $5292c45f2b641b96$var$Fn.copy(n.backgroundRotation), $5292c45f2b641b96$var$Fn.x *= -1, $5292c45f2b641b96$var$Fn.y *= -1, $5292c45f2b641b96$var$Fn.z *= -1, i.isCubeTexture && !1 === i.isRenderTargetTexture && ($5292c45f2b641b96$var$Fn.y *= -1, $5292c45f2b641b96$var$Fn.z *= -1), T.material.uniforms.envMap.value = i, T.material.uniforms.flipEnvMap.value = i.isCubeTexture && !1 === i.isRenderTargetTexture ? -1 : 1, T.material.uniforms.backgroundBlurriness.value = n.backgroundBlurriness, T.material.uniforms.backgroundIntensity.value = n.backgroundIntensity, T.material.uniforms.backgroundRotation.value.setFromMatrix4($5292c45f2b641b96$var$Bn.makeRotationFromEuler($5292c45f2b641b96$var$Fn)), T.material.toneMapped = (0, $4a792688e08e5cd7$export$5e6fd513f44698c).getTransfer(i.colorSpace) !== (0, $4a792688e08e5cd7$export$8d0a61916cc26abb), x === i && A === i.version && R === e.toneMapping || (T.material.needsUpdate = !0, x = i, A = i.version, R = e.toneMapping), T.layers.enableAll(), t.unshift(T, T.geometry, T.material, 0, 0, null)) : i && i.isTexture && (void 0 === S && (S = new (0, $4a792688e08e5cd7$export$e176487c05830cc5)(new (0, $4a792688e08e5cd7$export$967d831af31f69ce)(2, 2), new (0, $4a792688e08e5cd7$export$83c7d75d550a8b0d)({
                name: "BackgroundMaterial",
                uniforms: (0, $4a792688e08e5cd7$export$acda854380553452)($5292c45f2b641b96$export$bee4a7d47f8f5014.background.uniforms),
                vertexShader: $5292c45f2b641b96$export$bee4a7d47f8f5014.background.vertexShader,
                fragmentShader: $5292c45f2b641b96$export$bee4a7d47f8f5014.background.fragmentShader,
                side: (0, $4a792688e08e5cd7$export$2ede184fc2998901),
                depthTest: !1,
                depthWrite: !1,
                fog: !1,
                allowOverride: !1
            })), S.geometry.deleteAttribute("normal"), Object.defineProperty(S.material, "map", {
                get: function() {
                    return this.uniforms.t2D.value;
                }
            }), u.update(S)), S.material.uniforms.t2D.value = i, S.material.uniforms.backgroundIntensity.value = n.backgroundIntensity, S.material.toneMapped = (0, $4a792688e08e5cd7$export$5e6fd513f44698c).getTransfer(i.colorSpace) !== (0, $4a792688e08e5cd7$export$8d0a61916cc26abb), !0 === i.matrixAutoUpdate && i.updateMatrix(), S.material.uniforms.uvTransform.value.copy(i.matrix), x === i && A === i.version && R === e.toneMapping || (S.material.needsUpdate = !0, x = i, A = i.version, R = e.toneMapping), S.layers.enableAll(), t.unshift(S, S.geometry, S.material, 0, 0, null));
        },
        dispose: function() {
            void 0 !== T && (T.geometry.dispose(), T.material.dispose(), T = void 0), void 0 !== S && (S.geometry.dispose(), S.material.dispose(), S = void 0);
        }
    };
}
function $5292c45f2b641b96$var$Hn(e, t) {
    const n = e.getParameter(e.MAX_VERTEX_ATTRIBS), i = {}, r = c(null);
    let a = r, o = !1;
    function s(t) {
        return e.bindVertexArray(t);
    }
    function l(t) {
        return e.deleteVertexArray(t);
    }
    function c(e) {
        const t = [], i = [], r = [];
        for(let e = 0; e < n; e++)t[e] = 0, i[e] = 0, r[e] = 0;
        return {
            geometry: null,
            program: null,
            wireframe: !1,
            newAttributes: t,
            enabledAttributes: i,
            attributeDivisors: r,
            object: e,
            attributes: {},
            index: null
        };
    }
    function d() {
        const e = a.newAttributes;
        for(let t = 0, n = e.length; t < n; t++)e[t] = 0;
    }
    function u(e) {
        f(e, 0);
    }
    function f(t, n) {
        const i = a.newAttributes, r = a.enabledAttributes, o = a.attributeDivisors;
        i[t] = 1, 0 === r[t] && (e.enableVertexAttribArray(t), r[t] = 1), o[t] !== n && (e.vertexAttribDivisor(t, n), o[t] = n);
    }
    function p() {
        const t = a.newAttributes, n = a.enabledAttributes;
        for(let i = 0, r = n.length; i < r; i++)n[i] !== t[i] && (e.disableVertexAttribArray(i), n[i] = 0);
    }
    function m(t, n, i, r, a, o, s) {
        !0 === s ? e.vertexAttribIPointer(t, n, i, a, o) : e.vertexAttribPointer(t, n, i, r, a, o);
    }
    function h() {
        _(), o = !0, a !== r && (a = r, s(a.object));
    }
    function _() {
        r.geometry = null, r.program = null, r.wireframe = !1;
    }
    return {
        setup: function(n, r, l, h, _) {
            let g = !1;
            const E = function(t, n, r) {
                const a = !0 === r.wireframe;
                let o = i[t.id];
                void 0 === o && (o = {}, i[t.id] = o);
                let s = o[n.id];
                void 0 === s && (s = {}, o[n.id] = s);
                let l = s[a];
                void 0 === l && (l = c(e.createVertexArray()), s[a] = l);
                return l;
            }(h, l, r);
            a !== E && (a = E, s(a.object)), g = function(e, t, n, i) {
                const r = a.attributes, o = t.attributes;
                let s = 0;
                const l = n.getAttributes();
                for(const t in l)if (l[t].location >= 0) {
                    const n = r[t];
                    let i = o[t];
                    if (void 0 === i && ("instanceMatrix" === t && e.instanceMatrix && (i = e.instanceMatrix), "instanceColor" === t && e.instanceColor && (i = e.instanceColor)), void 0 === n) return !0;
                    if (n.attribute !== i) return !0;
                    if (i && n.data !== i.data) return !0;
                    s++;
                }
                return a.attributesNum !== s || a.index !== i;
            }(n, h, l, _), g && function(e, t, n, i) {
                const r = {}, o = t.attributes;
                let s = 0;
                const l = n.getAttributes();
                for(const t in l)if (l[t].location >= 0) {
                    let n = o[t];
                    void 0 === n && ("instanceMatrix" === t && e.instanceMatrix && (n = e.instanceMatrix), "instanceColor" === t && e.instanceColor && (n = e.instanceColor));
                    const i = {};
                    i.attribute = n, n && n.data && (i.data = n.data), r[t] = i, s++;
                }
                a.attributes = r, a.attributesNum = s, a.index = i;
            }(n, h, l, _), null !== _ && t.update(_, e.ELEMENT_ARRAY_BUFFER), (g || o) && (o = !1, function(n, i, r, a) {
                d();
                const o = a.attributes, s = r.getAttributes(), l = i.defaultAttributeValues;
                for(const i in s){
                    const r = s[i];
                    if (r.location >= 0) {
                        let s = o[i];
                        if (void 0 === s && ("instanceMatrix" === i && n.instanceMatrix && (s = n.instanceMatrix), "instanceColor" === i && n.instanceColor && (s = n.instanceColor)), void 0 !== s) {
                            const i = s.normalized, o = s.itemSize, l = t.get(s);
                            if (void 0 === l) continue;
                            const c = l.buffer, d = l.type, p = l.bytesPerElement, h = d === e.INT || d === e.UNSIGNED_INT || s.gpuType === (0, $4a792688e08e5cd7$export$5c612977753abe2);
                            if (s.isInterleavedBufferAttribute) {
                                const t = s.data, l = t.stride, _ = s.offset;
                                if (t.isInstancedInterleavedBuffer) {
                                    for(let e = 0; e < r.locationSize; e++)f(r.location + e, t.meshPerAttribute);
                                    !0 !== n.isInstancedMesh && void 0 === a._maxInstanceCount && (a._maxInstanceCount = t.meshPerAttribute * t.count);
                                } else for(let e = 0; e < r.locationSize; e++)u(r.location + e);
                                e.bindBuffer(e.ARRAY_BUFFER, c);
                                for(let e = 0; e < r.locationSize; e++)m(r.location + e, o / r.locationSize, d, i, l * p, (_ + o / r.locationSize * e) * p, h);
                            } else {
                                if (s.isInstancedBufferAttribute) {
                                    for(let e = 0; e < r.locationSize; e++)f(r.location + e, s.meshPerAttribute);
                                    !0 !== n.isInstancedMesh && void 0 === a._maxInstanceCount && (a._maxInstanceCount = s.meshPerAttribute * s.count);
                                } else for(let e = 0; e < r.locationSize; e++)u(r.location + e);
                                e.bindBuffer(e.ARRAY_BUFFER, c);
                                for(let e = 0; e < r.locationSize; e++)m(r.location + e, o / r.locationSize, d, i, o * p, o / r.locationSize * e * p, h);
                            }
                        } else if (void 0 !== l) {
                            const t = l[i];
                            if (void 0 !== t) switch(t.length){
                                case 2:
                                    e.vertexAttrib2fv(r.location, t);
                                    break;
                                case 3:
                                    e.vertexAttrib3fv(r.location, t);
                                    break;
                                case 4:
                                    e.vertexAttrib4fv(r.location, t);
                                    break;
                                default:
                                    e.vertexAttrib1fv(r.location, t);
                            }
                        }
                    }
                }
                p();
            }(n, r, l, h), null !== _ && e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, t.get(_).buffer));
        },
        reset: h,
        resetDefaultState: _,
        dispose: function() {
            h();
            for(const e in i){
                const t = i[e];
                for(const e in t){
                    const n = t[e];
                    for(const e in n)l(n[e].object), delete n[e];
                    delete t[e];
                }
                delete i[e];
            }
        },
        releaseStatesOfGeometry: function(e) {
            if (void 0 === i[e.id]) return;
            const t = i[e.id];
            for(const e in t){
                const n = t[e];
                for(const e in n)l(n[e].object), delete n[e];
                delete t[e];
            }
            delete i[e.id];
        },
        releaseStatesOfProgram: function(e) {
            for(const t in i){
                const n = i[t];
                if (void 0 === n[e.id]) continue;
                const r = n[e.id];
                for(const e in r)l(r[e].object), delete r[e];
                delete n[e.id];
            }
        },
        initAttributes: d,
        enableAttribute: u,
        disableUnusedAttributes: p
    };
}
function $5292c45f2b641b96$var$Vn(e, t, n) {
    let i;
    function r(t, r, a) {
        0 !== a && (e.drawArraysInstanced(i, t, r, a), n.update(r, i, a));
    }
    this.setMode = function(e) {
        i = e;
    }, this.render = function(t, r) {
        e.drawArrays(i, t, r), n.update(r, i, 1);
    }, this.renderInstances = r, this.renderMultiDraw = function(e, r, a) {
        if (0 === a) return;
        t.get("WEBGL_multi_draw").multiDrawArraysWEBGL(i, e, 0, r, 0, a);
        let o = 0;
        for(let e = 0; e < a; e++)o += r[e];
        n.update(o, i, 1);
    }, this.renderMultiDrawInstances = function(e, a, o, s) {
        if (0 === o) return;
        const l = t.get("WEBGL_multi_draw");
        if (null === l) for(let t = 0; t < e.length; t++)r(e[t], a[t], s[t]);
        else {
            l.multiDrawArraysInstancedWEBGL(i, e, 0, a, 0, s, 0, o);
            let t = 0;
            for(let e = 0; e < o; e++)t += a[e] * s[e];
            n.update(t, i, 1);
        }
    };
}
function $5292c45f2b641b96$var$zn(e, t, n, i) {
    let r;
    function a(t) {
        if ("highp" === t) {
            if (e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).precision > 0) return "highp";
            t = "mediump";
        }
        return "mediump" === t && e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
    }
    let o = void 0 !== n.precision ? n.precision : "highp";
    const s = a(o);
    s !== o && ((0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer:", o, "not supported, using", s, "instead."), o = s);
    const l = !0 === n.logarithmicDepthBuffer, c = !0 === n.reversedDepthBuffer && t.has("EXT_clip_control"), d = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS), u = e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    return {
        isWebGL2: !0,
        getMaxAnisotropy: function() {
            if (void 0 !== r) return r;
            if (!0 === t.has("EXT_texture_filter_anisotropic")) {
                const n = t.get("EXT_texture_filter_anisotropic");
                r = e.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
            } else r = 0;
            return r;
        },
        getMaxPrecision: a,
        textureFormatReadable: function(t) {
            return t === (0, $4a792688e08e5cd7$export$3f8bb04b555a363c) || i.convert(t) === e.getParameter(e.IMPLEMENTATION_COLOR_READ_FORMAT);
        },
        textureTypeReadable: function(n) {
            const r = n === (0, $4a792688e08e5cd7$export$2697304443f382bc) && (t.has("EXT_color_buffer_half_float") || t.has("EXT_color_buffer_float"));
            return !(n !== (0, $4a792688e08e5cd7$export$2e8ce08d3f6f5e10) && i.convert(n) !== e.getParameter(e.IMPLEMENTATION_COLOR_READ_TYPE) && n !== (0, $4a792688e08e5cd7$export$f6d331659b644596) && !r);
        },
        precision: o,
        logarithmicDepthBuffer: l,
        reversedDepthBuffer: c,
        maxTextures: d,
        maxVertexTextures: u,
        maxTextureSize: e.getParameter(e.MAX_TEXTURE_SIZE),
        maxCubemapSize: e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE),
        maxAttributes: e.getParameter(e.MAX_VERTEX_ATTRIBS),
        maxVertexUniforms: e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS),
        maxVaryings: e.getParameter(e.MAX_VARYING_VECTORS),
        maxFragmentUniforms: e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS),
        vertexTextures: u > 0,
        maxSamples: e.getParameter(e.MAX_SAMPLES)
    };
}
function $5292c45f2b641b96$var$kn(t) {
    const n = this;
    let i = null, r = 0, a = !1, o = !1;
    const s = new (0, $4a792688e08e5cd7$export$7ff5ac152ef991b0), l = new (0, $4a792688e08e5cd7$export$8ff26dafa08918), c = {
        value: null,
        needsUpdate: !1
    };
    function d(e, t, i, r) {
        const a = null !== e ? e.length : 0;
        let o = null;
        if (0 !== a) {
            if (o = c.value, !0 !== r || null === o) {
                const n = i + 4 * a, r = t.matrixWorldInverse;
                l.getNormalMatrix(r), (null === o || o.length < n) && (o = new Float32Array(n));
                for(let t = 0, n = i; t !== a; ++t, n += 4)s.copy(e[t]).applyMatrix4(r, l), s.normal.toArray(o, n), o[n + 3] = s.constant;
            }
            c.value = o, c.needsUpdate = !0;
        }
        return n.numPlanes = a, n.numIntersection = 0, o;
    }
    this.uniform = c, this.numPlanes = 0, this.numIntersection = 0, this.init = function(e, t) {
        const n = 0 !== e.length || t || 0 !== r || a;
        return a = t, r = e.length, n;
    }, this.beginShadows = function() {
        o = !0, d(null);
    }, this.endShadows = function() {
        o = !1;
    }, this.setGlobalState = function(e, t) {
        i = d(e, t, 0);
    }, this.setState = function(e, s, l) {
        const u = e.clippingPlanes, f = e.clipIntersection, p = e.clipShadows, m = t.get(e);
        if (!a || null === u || 0 === u.length || o && !p) o ? d(null) : function() {
            c.value !== i && (c.value = i, c.needsUpdate = r > 0);
            n.numPlanes = r, n.numIntersection = 0;
        }();
        else {
            const e = o ? 0 : r, t = 4 * e;
            let n = m.clippingState || null;
            c.value = n, n = d(u, s, t, l);
            for(let e = 0; e !== t; ++e)n[e] = i[e];
            m.clippingState = n, this.numIntersection = f ? this.numPlanes : 0, this.numPlanes += e;
        }
    };
}
function $5292c45f2b641b96$var$Wn(e) {
    let t = new WeakMap;
    function n(e, t) {
        return t === (0, $4a792688e08e5cd7$export$d64030b316d3b087) ? e.mapping = (0, $4a792688e08e5cd7$export$8759762a6477f2c4) : t === (0, $4a792688e08e5cd7$export$ee99d97d46898098) && (e.mapping = (0, $4a792688e08e5cd7$export$dc59f8aed047f61d)), e;
    }
    function i(e) {
        const n = e.target;
        n.removeEventListener("dispose", i);
        const r = t.get(n);
        void 0 !== r && (t.delete(n), r.dispose());
    }
    return {
        get: function(r) {
            if (r && r.isTexture) {
                const a = r.mapping;
                if (a === (0, $4a792688e08e5cd7$export$d64030b316d3b087) || a === (0, $4a792688e08e5cd7$export$ee99d97d46898098)) {
                    if (t.has(r)) return n(t.get(r).texture, r.mapping);
                    {
                        const a = r.image;
                        if (a && a.height > 0) {
                            const o = new (0, $4a792688e08e5cd7$export$ac386671d651941e)(a.height);
                            return o.fromEquirectangularTexture(e, r), t.set(r, o), r.addEventListener("dispose", i), n(o.texture, r.mapping);
                        }
                        return null;
                    }
                }
            }
            return r;
        },
        dispose: function() {
            t = new WeakMap;
        }
    };
}
const $5292c45f2b641b96$var$Xn = [
    .125,
    .215,
    .35,
    .446,
    .526,
    .582
], $5292c45f2b641b96$var$Yn = 20, $5292c45f2b641b96$var$Kn = new (0, $4a792688e08e5cd7$export$9ebf355ee4ed261b), $5292c45f2b641b96$var$qn = new (0, $4a792688e08e5cd7$export$892596cec99bc70e);
let $5292c45f2b641b96$var$jn = null, $5292c45f2b641b96$var$Zn = 0, $5292c45f2b641b96$var$$n = 0, $5292c45f2b641b96$var$Qn = !1;
const $5292c45f2b641b96$var$Jn = new (0, $4a792688e08e5cd7$export$64b5c384219d3699);
class $5292c45f2b641b96$export$6add42717753e221 {
    constructor(e){
        this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._sizeLods = [], this._sigmas = [], this._lodMeshes = [], this._backgroundBox = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._blurMaterial = null, this._ggxMaterial = null;
    }
    fromScene(e, t = 0, n = .1, i = 100, r = {}) {
        const { size: a = 256, position: o = $5292c45f2b641b96$var$Jn } = r;
        $5292c45f2b641b96$var$jn = this._renderer.getRenderTarget(), $5292c45f2b641b96$var$Zn = this._renderer.getActiveCubeFace(), $5292c45f2b641b96$var$$n = this._renderer.getActiveMipmapLevel(), $5292c45f2b641b96$var$Qn = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(a);
        const s = this._allocateTargets();
        return s.depthBuffer = !0, this._sceneToCubeUV(e, n, i, s, o), t > 0 && this._blur(s, 0, 0, t), this._applyPMREM(s), this._cleanup(s), s;
    }
    fromEquirectangular(e, t = null) {
        return this._fromTexture(e, t);
    }
    fromCubemap(e, t = null) {
        return this._fromTexture(e, t);
    }
    compileCubemapShader() {
        null === this._cubemapMaterial && (this._cubemapMaterial = $5292c45f2b641b96$var$ri(), this._compileMaterial(this._cubemapMaterial));
    }
    compileEquirectangularShader() {
        null === this._equirectMaterial && (this._equirectMaterial = $5292c45f2b641b96$var$ii(), this._compileMaterial(this._equirectMaterial));
    }
    dispose() {
        this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose(), null !== this._backgroundBox && (this._backgroundBox.geometry.dispose(), this._backgroundBox.material.dispose());
    }
    _setSize(e) {
        this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._ggxMaterial && this._ggxMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
        for(let e = 0; e < this._lodMeshes.length; e++)this._lodMeshes[e].geometry.dispose();
    }
    _cleanup(e) {
        this._renderer.setRenderTarget($5292c45f2b641b96$var$jn, $5292c45f2b641b96$var$Zn, $5292c45f2b641b96$var$$n), this._renderer.xr.enabled = $5292c45f2b641b96$var$Qn, e.scissorTest = !1, $5292c45f2b641b96$var$ni(e, 0, 0, e.width, e.height);
    }
    _fromTexture(e, t) {
        e.mapping === (0, $4a792688e08e5cd7$export$8759762a6477f2c4) || e.mapping === (0, $4a792688e08e5cd7$export$dc59f8aed047f61d) ? this._setSize(0 === e.image.length ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), $5292c45f2b641b96$var$jn = this._renderer.getRenderTarget(), $5292c45f2b641b96$var$Zn = this._renderer.getActiveCubeFace(), $5292c45f2b641b96$var$$n = this._renderer.getActiveMipmapLevel(), $5292c45f2b641b96$var$Qn = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
        const n = t || this._allocateTargets();
        return this._textureToCubeUV(e, n), this._applyPMREM(n), this._cleanup(n), n;
    }
    _allocateTargets() {
        const e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, n = {
            magFilter: (0, $4a792688e08e5cd7$export$8a72f490b25c56c8),
            minFilter: (0, $4a792688e08e5cd7$export$8a72f490b25c56c8),
            generateMipmaps: !1,
            type: (0, $4a792688e08e5cd7$export$2697304443f382bc),
            format: (0, $4a792688e08e5cd7$export$3f8bb04b555a363c),
            colorSpace: (0, $4a792688e08e5cd7$export$42429b3acfb233a4),
            depthBuffer: !1
        }, i = $5292c45f2b641b96$var$ti(e, t, n);
        if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== t) {
            null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = $5292c45f2b641b96$var$ti(e, t, n);
            const { _lodMax: i } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = function(e) {
                const t = [], n = [], i = [];
                let r = e;
                const a = e - 4 + 1 + $5292c45f2b641b96$var$Xn.length;
                for(let s = 0; s < a; s++){
                    const a = Math.pow(2, r);
                    t.push(a);
                    let l = 1 / a;
                    s > e - 4 ? l = $5292c45f2b641b96$var$Xn[s - e + 4 - 1] : 0 === s && (l = 0), n.push(l);
                    const c = 1 / (a - 2), d = -c, u = 1 + c, f = [
                        d,
                        d,
                        u,
                        d,
                        u,
                        u,
                        d,
                        d,
                        u,
                        u,
                        d,
                        u
                    ], p = 6, m = 6, h = 3, _ = 2, g = 1, v = new Float32Array(h * m * p), E = new Float32Array(_ * m * p), S = new Float32Array(g * m * p);
                    for(let e = 0; e < p; e++){
                        const t = e % 3 * 2 / 3 - 1, n = e > 2 ? 0 : -1, i = [
                            t,
                            n,
                            0,
                            t + 2 / 3,
                            n,
                            0,
                            t + 2 / 3,
                            n + 1,
                            0,
                            t,
                            n,
                            0,
                            t + 2 / 3,
                            n + 1,
                            0,
                            t,
                            n + 1,
                            0
                        ];
                        v.set(i, h * m * e), E.set(f, _ * m * e);
                        const r = [
                            e,
                            e,
                            e,
                            e,
                            e,
                            e
                        ];
                        S.set(r, g * m * e);
                    }
                    const T = new (0, $4a792688e08e5cd7$export$b7be63a67df8959);
                    T.setAttribute("position", new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(v, h)), T.setAttribute("uv", new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(E, _)), T.setAttribute("faceIndex", new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(S, g)), i.push(new (0, $4a792688e08e5cd7$export$e176487c05830cc5)(T, null)), r > 4 && r--;
                }
                return {
                    lodMeshes: i,
                    sizeLods: t,
                    sigmas: n
                };
            }(i)), this._blurMaterial = function(e, t, n) {
                const i = new Float32Array($5292c45f2b641b96$var$Yn), a = new (0, $4a792688e08e5cd7$export$64b5c384219d3699)(0, 1, 0), o = new (0, $4a792688e08e5cd7$export$83c7d75d550a8b0d)({
                    name: "SphericalGaussianBlur",
                    defines: {
                        n: $5292c45f2b641b96$var$Yn,
                        CUBEUV_TEXEL_WIDTH: 1 / t,
                        CUBEUV_TEXEL_HEIGHT: 1 / n,
                        CUBEUV_MAX_MIP: `${e}.0`
                    },
                    uniforms: {
                        envMap: {
                            value: null
                        },
                        samples: {
                            value: 1
                        },
                        weights: {
                            value: i
                        },
                        latitudinal: {
                            value: !1
                        },
                        dTheta: {
                            value: 0
                        },
                        mipInt: {
                            value: 0
                        },
                        poleAxis: {
                            value: a
                        }
                    },
                    vertexShader: $5292c45f2b641b96$var$ai(),
                    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t",
                    blending: (0, $4a792688e08e5cd7$export$63b8d6b580fc65ba),
                    depthTest: !1,
                    depthWrite: !1
                });
                return o;
            }(i, e, t), this._ggxMaterial = function(e, t, n) {
                const i = new (0, $4a792688e08e5cd7$export$83c7d75d550a8b0d)({
                    name: "PMREMGGXConvolution",
                    defines: {
                        GGX_SAMPLES: 256,
                        CUBEUV_TEXEL_WIDTH: 1 / t,
                        CUBEUV_TEXEL_HEIGHT: 1 / n,
                        CUBEUV_MAX_MIP: `${e}.0`
                    },
                    uniforms: {
                        envMap: {
                            value: null
                        },
                        roughness: {
                            value: 0
                        },
                        mipInt: {
                            value: 0
                        }
                    },
                    vertexShader: $5292c45f2b641b96$var$ai(),
                    fragmentShader: '\n\n\t\t\tprecision highp float;\n\t\t\tprecision highp int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform float roughness;\n\t\t\tuniform float mipInt;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\t#define PI 3.14159265359\n\n\t\t\t// Van der Corput radical inverse\n\t\t\tfloat radicalInverse_VdC(uint bits) {\n\t\t\t\tbits = (bits << 16u) | (bits >> 16u);\n\t\t\t\tbits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);\n\t\t\t\tbits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);\n\t\t\t\tbits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);\n\t\t\t\tbits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);\n\t\t\t\treturn float(bits) * 2.3283064365386963e-10; // / 0x100000000\n\t\t\t}\n\n\t\t\t// Hammersley sequence\n\t\t\tvec2 hammersley(uint i, uint N) {\n\t\t\t\treturn vec2(float(i) / float(N), radicalInverse_VdC(i));\n\t\t\t}\n\n\t\t\t// GGX VNDF importance sampling (Eric Heitz 2018)\n\t\t\t// "Sampling the GGX Distribution of Visible Normals"\n\t\t\t// https://jcgt.org/published/0007/04/01/\n\t\t\tvec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {\n\t\t\t\tfloat alpha = roughness * roughness;\n\n\t\t\t\t// Section 3.2: Transform view direction to hemisphere configuration\n\t\t\t\tvec3 Vh = normalize(vec3(alpha * V.x, alpha * V.y, V.z));\n\n\t\t\t\t// Section 4.1: Orthonormal basis\n\t\t\t\tfloat lensq = Vh.x * Vh.x + Vh.y * Vh.y;\n\t\t\t\tvec3 T1 = lensq > 0.0 ? vec3(-Vh.y, Vh.x, 0.0) / sqrt(lensq) : vec3(1.0, 0.0, 0.0);\n\t\t\t\tvec3 T2 = cross(Vh, T1);\n\n\t\t\t\t// Section 4.2: Parameterization of projected area\n\t\t\t\tfloat r = sqrt(Xi.x);\n\t\t\t\tfloat phi = 2.0 * PI * Xi.y;\n\t\t\t\tfloat t1 = r * cos(phi);\n\t\t\t\tfloat t2 = r * sin(phi);\n\t\t\t\tfloat s = 0.5 * (1.0 + Vh.z);\n\t\t\t\tt2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;\n\n\t\t\t\t// Section 4.3: Reprojection onto hemisphere\n\t\t\t\tvec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * Vh;\n\n\t\t\t\t// Section 3.4: Transform back to ellipsoid configuration\n\t\t\t\treturn normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));\n\t\t\t}\n\n\t\t\tvoid main() {\n\t\t\t\tvec3 N = normalize(vOutputDirection);\n\t\t\t\tvec3 V = N; // Assume view direction equals normal for pre-filtering\n\n\t\t\t\tvec3 prefilteredColor = vec3(0.0);\n\t\t\t\tfloat totalWeight = 0.0;\n\n\t\t\t\t// For very low roughness, just sample the environment directly\n\t\t\t\tif (roughness < 0.001) {\n\t\t\t\t\tgl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\t// Tangent space basis for VNDF sampling\n\t\t\t\tvec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);\n\t\t\t\tvec3 tangent = normalize(cross(up, N));\n\t\t\t\tvec3 bitangent = cross(N, tangent);\n\n\t\t\t\tfor(uint i = 0u; i < uint(GGX_SAMPLES); i++) {\n\t\t\t\t\tvec2 Xi = hammersley(i, uint(GGX_SAMPLES));\n\n\t\t\t\t\t// For PMREM, V = N, so in tangent space V is always (0, 0, 1)\n\t\t\t\t\tvec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);\n\n\t\t\t\t\t// Transform H back to world space\n\t\t\t\t\tvec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);\n\t\t\t\t\tvec3 L = normalize(2.0 * dot(V, H) * H - V);\n\n\t\t\t\t\tfloat NdotL = max(dot(N, L), 0.0);\n\n\t\t\t\t\tif(NdotL > 0.0) {\n\t\t\t\t\t\t// Sample environment at fixed mip level\n\t\t\t\t\t\t// VNDF importance sampling handles the distribution filtering\n\t\t\t\t\t\tvec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);\n\n\t\t\t\t\t\t// Weight by NdotL for the split-sum approximation\n\t\t\t\t\t\t// VNDF PDF naturally accounts for the visible microfacet distribution\n\t\t\t\t\t\tprefilteredColor += sampleColor * NdotL;\n\t\t\t\t\t\ttotalWeight += NdotL;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tif (totalWeight > 0.0) {\n\t\t\t\t\tprefilteredColor = prefilteredColor / totalWeight;\n\t\t\t\t}\n\n\t\t\t\tgl_FragColor = vec4(prefilteredColor, 1.0);\n\t\t\t}\n\t\t',
                    blending: (0, $4a792688e08e5cd7$export$63b8d6b580fc65ba),
                    depthTest: !1,
                    depthWrite: !1
                });
                return i;
            }(i, e, t);
        }
        return i;
    }
    _compileMaterial(e) {
        const t = new (0, $4a792688e08e5cd7$export$e176487c05830cc5)(new (0, $4a792688e08e5cd7$export$b7be63a67df8959), e);
        this._renderer.compile(t, $5292c45f2b641b96$var$Kn);
    }
    _sceneToCubeUV(e, t, n, i, r) {
        const a = new (0, $4a792688e08e5cd7$export$74e4ae24825f68d7)(90, 1, t, n), l = [
            1,
            -1,
            1,
            1,
            1,
            1
        ], d = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ], u = this._renderer, f = u.autoClear, p = u.toneMapping;
        u.getClearColor($5292c45f2b641b96$var$qn), u.toneMapping = (0, $4a792688e08e5cd7$export$9fcb6b4294603b2), u.autoClear = !1;
        u.state.buffers.depth.getReversed() && (u.setRenderTarget(i), u.clearDepth(), u.setRenderTarget(null)), null === this._backgroundBox && (this._backgroundBox = new (0, $4a792688e08e5cd7$export$e176487c05830cc5)(new (0, $4a792688e08e5cd7$export$33e43285f7406bd5), new (0, $4a792688e08e5cd7$export$55cbcc9b622fe1f5)({
            name: "PMREM.Background",
            side: (0, $4a792688e08e5cd7$export$d9f0486e75b5ace),
            depthWrite: !1,
            depthTest: !1
        })));
        const m = this._backgroundBox, h = m.material;
        let _ = !1;
        const g = e.background;
        g ? g.isColor && (h.color.copy(g), e.background = null, _ = !0) : (h.color.copy($5292c45f2b641b96$var$qn), _ = !0);
        for(let t = 0; t < 6; t++){
            const n = t % 3;
            0 === n ? (a.up.set(0, l[t], 0), a.position.set(r.x, r.y, r.z), a.lookAt(r.x + d[t], r.y, r.z)) : 1 === n ? (a.up.set(0, 0, l[t]), a.position.set(r.x, r.y, r.z), a.lookAt(r.x, r.y + d[t], r.z)) : (a.up.set(0, l[t], 0), a.position.set(r.x, r.y, r.z), a.lookAt(r.x, r.y, r.z + d[t]));
            const o = this._cubeSize;
            $5292c45f2b641b96$var$ni(i, n * o, t > 2 ? o : 0, o, o), u.setRenderTarget(i), _ && u.render(m, a), u.render(e, a);
        }
        u.toneMapping = p, u.autoClear = f, e.background = g;
    }
    _textureToCubeUV(e, t) {
        const n = this._renderer, i = e.mapping === (0, $4a792688e08e5cd7$export$8759762a6477f2c4) || e.mapping === (0, $4a792688e08e5cd7$export$dc59f8aed047f61d);
        i ? (null === this._cubemapMaterial && (this._cubemapMaterial = $5292c45f2b641b96$var$ri()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === e.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = $5292c45f2b641b96$var$ii());
        const r = i ? this._cubemapMaterial : this._equirectMaterial, a = this._lodMeshes[0];
        a.material = r;
        r.uniforms.envMap.value = e;
        const o = this._cubeSize;
        $5292c45f2b641b96$var$ni(t, 0, 0, 3 * o, 2 * o), n.setRenderTarget(t), n.render(a, $5292c45f2b641b96$var$Kn);
    }
    _applyPMREM(e) {
        const t = this._renderer, n = t.autoClear;
        t.autoClear = !1;
        const i = this._lodMeshes.length;
        for(let t = 1; t < i; t++)this._applyGGXFilter(e, t - 1, t);
        t.autoClear = n;
    }
    _applyGGXFilter(e, t, n) {
        const i = this._renderer, r = this._pingPongRenderTarget, a = this._ggxMaterial, o = this._lodMeshes[n];
        o.material = a;
        const s = a.uniforms, l = n / (this._lodMeshes.length - 1), c = t / (this._lodMeshes.length - 1), d = Math.sqrt(l * l - c * c) * (.05 + .95 * l), { _lodMax: u } = this, f = this._sizeLods[n], p = 3 * f * (n > u - 4 ? n - u + 4 : 0), m = 4 * (this._cubeSize - f);
        s.envMap.value = e.texture, s.roughness.value = d, s.mipInt.value = u - t, $5292c45f2b641b96$var$ni(r, p, m, 3 * f, 2 * f), i.setRenderTarget(r), i.render(o, $5292c45f2b641b96$var$Kn), s.envMap.value = r.texture, s.roughness.value = 0, s.mipInt.value = u - n, $5292c45f2b641b96$var$ni(e, p, m, 3 * f, 2 * f), i.setRenderTarget(e), i.render(o, $5292c45f2b641b96$var$Kn);
    }
    _blur(e, t, n, i, r) {
        const a = this._pingPongRenderTarget;
        this._halfBlur(e, a, t, n, i, "latitudinal", r), this._halfBlur(a, e, n, n, i, "longitudinal", r);
    }
    _halfBlur(e, t, n, i, r, a, o) {
        const s = this._renderer, l = this._blurMaterial;
        "latitudinal" !== a && "longitudinal" !== a && (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("blur direction must be either latitudinal or longitudinal!");
        const c = this._lodMeshes[i];
        c.material = l;
        const d = l.uniforms, u = this._sizeLods[n] - 1, f = isFinite(r) ? Math.PI / (2 * u) : 2 * Math.PI / 39, p = r / f, m = isFinite(r) ? 1 + Math.floor(3 * p) : $5292c45f2b641b96$var$Yn;
        m > $5292c45f2b641b96$var$Yn && (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)(`sigmaRadians, ${r}, is too large and will clip, as it requested ${m} samples when the maximum is set to 20`);
        const h = [];
        let _ = 0;
        for(let e = 0; e < $5292c45f2b641b96$var$Yn; ++e){
            const t = e / p, n = Math.exp(-t * t / 2);
            h.push(n), 0 === e ? _ += n : e < m && (_ += 2 * n);
        }
        for(let e = 0; e < h.length; e++)h[e] = h[e] / _;
        d.envMap.value = e.texture, d.samples.value = m, d.weights.value = h, d.latitudinal.value = "latitudinal" === a, o && (d.poleAxis.value = o);
        const { _lodMax: g } = this;
        d.dTheta.value = f, d.mipInt.value = g - n;
        const v = this._sizeLods[i];
        $5292c45f2b641b96$var$ni(t, 3 * v * (i > g - 4 ? i - g + 4 : 0), 4 * (this._cubeSize - v), 3 * v, 2 * v), s.setRenderTarget(t), s.render(c, $5292c45f2b641b96$var$Kn);
    }
}
function $5292c45f2b641b96$var$ti(e, t, n) {
    const i = new (0, $4a792688e08e5cd7$export$3c052beb2e51e23f)(e, t, n);
    return i.texture.mapping = (0, $4a792688e08e5cd7$export$dbf3e70ff37af79), i.texture.name = "PMREM.cubeUv", i.scissorTest = !0, i;
}
function $5292c45f2b641b96$var$ni(e, t, n, i, r) {
    e.viewport.set(t, n, i, r), e.scissor.set(t, n, i, r);
}
function $5292c45f2b641b96$var$ii() {
    return new (0, $4a792688e08e5cd7$export$83c7d75d550a8b0d)({
        name: "EquirectangularToCubeUV",
        uniforms: {
            envMap: {
                value: null
            }
        },
        vertexShader: $5292c45f2b641b96$var$ai(),
        fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t",
        blending: (0, $4a792688e08e5cd7$export$63b8d6b580fc65ba),
        depthTest: !1,
        depthWrite: !1
    });
}
function $5292c45f2b641b96$var$ri() {
    return new (0, $4a792688e08e5cd7$export$83c7d75d550a8b0d)({
        name: "CubemapToCubeUV",
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            }
        },
        vertexShader: $5292c45f2b641b96$var$ai(),
        fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t",
        blending: (0, $4a792688e08e5cd7$export$63b8d6b580fc65ba),
        depthTest: !1,
        depthWrite: !1
    });
}
function $5292c45f2b641b96$var$ai() {
    return "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t";
}
function $5292c45f2b641b96$var$oi(e) {
    let t = new WeakMap, n = null;
    function i(e) {
        const n = e.target;
        n.removeEventListener("dispose", i);
        const r = t.get(n);
        void 0 !== r && (t.delete(n), r.dispose());
    }
    return {
        get: function(r) {
            if (r && r.isTexture) {
                const a = r.mapping, o = a === (0, $4a792688e08e5cd7$export$d64030b316d3b087) || a === (0, $4a792688e08e5cd7$export$ee99d97d46898098), s = a === (0, $4a792688e08e5cd7$export$8759762a6477f2c4) || a === (0, $4a792688e08e5cd7$export$dc59f8aed047f61d);
                if (o || s) {
                    let a = t.get(r);
                    const l = void 0 !== a ? a.texture.pmremVersion : 0;
                    if (r.isRenderTargetTexture && r.pmremVersion !== l) return null === n && (n = new $5292c45f2b641b96$export$6add42717753e221(e)), a = o ? n.fromEquirectangular(r, a) : n.fromCubemap(r, a), a.texture.pmremVersion = r.pmremVersion, t.set(r, a), a.texture;
                    if (void 0 !== a) return a.texture;
                    {
                        const l = r.image;
                        return o && l && l.height > 0 || s && l && function(e) {
                            let t = 0;
                            const n = 6;
                            for(let i = 0; i < n; i++)void 0 !== e[i] && t++;
                            return t === n;
                        }(l) ? (null === n && (n = new $5292c45f2b641b96$export$6add42717753e221(e)), a = o ? n.fromEquirectangular(r) : n.fromCubemap(r), a.texture.pmremVersion = r.pmremVersion, t.set(r, a), r.addEventListener("dispose", i), a.texture) : null;
                    }
                }
            }
            return r;
        },
        dispose: function() {
            t = new WeakMap, null !== n && (n.dispose(), n = null);
        }
    };
}
function $5292c45f2b641b96$var$si(e) {
    const t = {};
    function n(n) {
        if (void 0 !== t[n]) return t[n];
        const i = e.getExtension(n);
        return t[n] = i, i;
    }
    return {
        has: function(e) {
            return null !== n(e);
        },
        init: function() {
            n("EXT_color_buffer_float"), n("WEBGL_clip_cull_distance"), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture"), n("WEBGL_render_shared_exponent");
        },
        get: function(e) {
            const t = n(e);
            return null === t && (0, $4a792688e08e5cd7$export$5b28268982f175ba)("WebGLRenderer: " + e + " extension not supported."), t;
        }
    };
}
function $5292c45f2b641b96$var$li(e, t, n, i) {
    const r = {}, a = new WeakMap;
    function o(e) {
        const s = e.target;
        null !== s.index && t.remove(s.index);
        for(const e in s.attributes)t.remove(s.attributes[e]);
        s.removeEventListener("dispose", o), delete r[s.id];
        const l = a.get(s);
        l && (t.remove(l), a.delete(s)), i.releaseStatesOfGeometry(s), !0 === s.isInstancedBufferGeometry && delete s._maxInstanceCount, n.memory.geometries--;
    }
    function s(e) {
        const n = [], i = e.index, r = e.attributes.position;
        let o = 0;
        if (null !== i) {
            const e = i.array;
            o = i.version;
            for(let t = 0, i = e.length; t < i; t += 3){
                const i = e[t + 0], r = e[t + 1], a = e[t + 2];
                n.push(i, r, r, a, a, i);
            }
        } else {
            if (void 0 === r) return;
            {
                const e = r.array;
                o = r.version;
                for(let t = 0, i = e.length / 3 - 1; t < i; t += 3){
                    const e = t + 0, i = t + 1, r = t + 2;
                    n.push(e, i, i, r, r, e);
                }
            }
        }
        const s = new ((0, $4a792688e08e5cd7$export$bc6f937da07eae17)(n) ? (0, $4a792688e08e5cd7$export$7eb8c9fa25cd5bd6) : (0, $4a792688e08e5cd7$export$640a853f68025f2e))(n, 1);
        s.version = o;
        const l = a.get(e);
        l && t.remove(l), a.set(e, s);
    }
    return {
        get: function(e, t) {
            return !0 === r[t.id] || (t.addEventListener("dispose", o), r[t.id] = !0, n.memory.geometries++), t;
        },
        update: function(n) {
            const i = n.attributes;
            for(const n in i)t.update(i[n], e.ARRAY_BUFFER);
        },
        getWireframeAttribute: function(e) {
            const t = a.get(e);
            if (t) {
                const n = e.index;
                null !== n && t.version < n.version && s(e);
            } else s(e);
            return a.get(e);
        }
    };
}
function $5292c45f2b641b96$var$ci(e, t, n) {
    let i, r, a;
    function o(t, o, s) {
        0 !== s && (e.drawElementsInstanced(i, o, r, t * a, s), n.update(o, i, s));
    }
    this.setMode = function(e) {
        i = e;
    }, this.setIndex = function(e) {
        r = e.type, a = e.bytesPerElement;
    }, this.render = function(t, o) {
        e.drawElements(i, o, r, t * a), n.update(o, i, 1);
    }, this.renderInstances = o, this.renderMultiDraw = function(e, a, o) {
        if (0 === o) return;
        t.get("WEBGL_multi_draw").multiDrawElementsWEBGL(i, a, 0, r, e, 0, o);
        let s = 0;
        for(let e = 0; e < o; e++)s += a[e];
        n.update(s, i, 1);
    }, this.renderMultiDrawInstances = function(e, s, l, c) {
        if (0 === l) return;
        const d = t.get("WEBGL_multi_draw");
        if (null === d) for(let t = 0; t < e.length; t++)o(e[t] / a, s[t], c[t]);
        else {
            d.multiDrawElementsInstancedWEBGL(i, s, 0, r, e, 0, c, 0, l);
            let t = 0;
            for(let e = 0; e < l; e++)t += s[e] * c[e];
            n.update(t, i, 1);
        }
    };
}
function $5292c45f2b641b96$var$di(e) {
    const t = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    return {
        memory: {
            geometries: 0,
            textures: 0
        },
        render: t,
        programs: null,
        autoReset: !0,
        reset: function() {
            t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
        },
        update: function(n, i, r) {
            switch(t.calls++, i){
                case e.TRIANGLES:
                    t.triangles += r * (n / 3);
                    break;
                case e.LINES:
                    t.lines += r * (n / 2);
                    break;
                case e.LINE_STRIP:
                    t.lines += r * (n - 1);
                    break;
                case e.LINE_LOOP:
                    t.lines += r * n;
                    break;
                case e.POINTS:
                    t.points += r * n;
                    break;
                default:
                    (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLInfo: Unknown draw mode:", i);
            }
        }
    };
}
function $5292c45f2b641b96$var$ui(e, n, i) {
    const r = new WeakMap, a = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3);
    return {
        update: function(o, s, l) {
            const c = o.morphTargetInfluences, d = s.morphAttributes.position || s.morphAttributes.normal || s.morphAttributes.color, u = void 0 !== d ? d.length : 0;
            let f = r.get(s);
            if (void 0 === f || f.count !== u) {
                void 0 !== f && f.texture.dispose();
                const p = void 0 !== s.morphAttributes.position, m = void 0 !== s.morphAttributes.normal, h = void 0 !== s.morphAttributes.color, _ = s.morphAttributes.position || [], g = s.morphAttributes.normal || [], v = s.morphAttributes.color || [];
                let E = 0;
                !0 === p && (E = 1), !0 === m && (E = 2), !0 === h && (E = 3);
                let S = s.attributes.position.count * E, T = 1;
                S > n.maxTextureSize && (T = Math.ceil(S / n.maxTextureSize), S = n.maxTextureSize);
                const x = new Float32Array(S * T * 4 * u), A = new (0, $4a792688e08e5cd7$export$dfac6c8e811406a3)(x, S, T, u);
                A.type = (0, $4a792688e08e5cd7$export$f6d331659b644596), A.needsUpdate = !0;
                const R = 4 * E;
                for(let C = 0; C < u; C++){
                    const L = _[C], P = g[C], U = v[C], D = S * T * 4 * C;
                    for(let w = 0; w < L.count; w++){
                        const y = w * R;
                        !0 === p && (a.fromBufferAttribute(L, w), x[D + y + 0] = a.x, x[D + y + 1] = a.y, x[D + y + 2] = a.z, x[D + y + 3] = 0), !0 === m && (a.fromBufferAttribute(P, w), x[D + y + 4] = a.x, x[D + y + 5] = a.y, x[D + y + 6] = a.z, x[D + y + 7] = 0), !0 === h && (a.fromBufferAttribute(U, w), x[D + y + 8] = a.x, x[D + y + 9] = a.y, x[D + y + 10] = a.z, x[D + y + 11] = 4 === U.itemSize ? a.w : 1);
                    }
                }
                function b() {
                    A.dispose(), r.delete(s), s.removeEventListener("dispose", b);
                }
                f = {
                    count: u,
                    texture: A,
                    size: new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1)(S, T)
                }, r.set(s, f), s.addEventListener("dispose", b);
            }
            if (!0 === o.isInstancedMesh && null !== o.morphTexture) l.getUniforms().setValue(e, "morphTexture", o.morphTexture, i);
            else {
                let I = 0;
                for(let O = 0; O < c.length; O++)I += c[O];
                const N = s.morphTargetsRelative ? 1 : 1 - I;
                l.getUniforms().setValue(e, "morphTargetBaseInfluence", N), l.getUniforms().setValue(e, "morphTargetInfluences", c);
            }
            l.getUniforms().setValue(e, "morphTargetsTexture", f.texture, i), l.getUniforms().setValue(e, "morphTargetsTextureSize", f.size);
        }
    };
}
function $5292c45f2b641b96$var$fi(e, t, n, i) {
    let r = new WeakMap;
    function a(e) {
        const t = e.target;
        t.removeEventListener("dispose", a), n.remove(t.instanceMatrix), null !== t.instanceColor && n.remove(t.instanceColor);
    }
    return {
        update: function(o) {
            const s = i.render.frame, l = o.geometry, c = t.get(o, l);
            if (r.get(c) !== s && (t.update(c), r.set(c, s)), o.isInstancedMesh && (!1 === o.hasEventListener("dispose", a) && o.addEventListener("dispose", a), r.get(o) !== s && (n.update(o.instanceMatrix, e.ARRAY_BUFFER), null !== o.instanceColor && n.update(o.instanceColor, e.ARRAY_BUFFER), r.set(o, s))), o.isSkinnedMesh) {
                const e = o.skeleton;
                r.get(e) !== s && (e.update(), r.set(e, s));
            }
            return c;
        },
        dispose: function() {
            r = new WeakMap;
        }
    };
}
const $5292c45f2b641b96$var$pi = new (0, $4a792688e08e5cd7$export$5431306cf43de24a), $5292c45f2b641b96$var$mi = new (0, $4a792688e08e5cd7$export$fc830aa069cc8c2f)(1, 1), $5292c45f2b641b96$var$hi = new (0, $4a792688e08e5cd7$export$dfac6c8e811406a3), $5292c45f2b641b96$var$_i = new (0, $4a792688e08e5cd7$export$d7a3086320f856db), $5292c45f2b641b96$var$gi = new (0, $4a792688e08e5cd7$export$ee2e5a18258a4049), $5292c45f2b641b96$var$vi = [], $5292c45f2b641b96$var$Ei = [], $5292c45f2b641b96$var$Si = new Float32Array(16), $5292c45f2b641b96$var$Ti = new Float32Array(9), $5292c45f2b641b96$var$Mi = new Float32Array(4);
function $5292c45f2b641b96$var$xi(e, t, n) {
    const i = e[0];
    if (i <= 0 || i > 0) return e;
    const r = t * n;
    let a = $5292c45f2b641b96$var$vi[r];
    if (void 0 === a && (a = new Float32Array(r), $5292c45f2b641b96$var$vi[r] = a), 0 !== t) {
        i.toArray(a, 0);
        for(let i = 1, r = 0; i !== t; ++i)r += n, e[i].toArray(a, r);
    }
    return a;
}
function $5292c45f2b641b96$var$Ai(e, t) {
    if (e.length !== t.length) return !1;
    for(let n = 0, i = e.length; n < i; n++)if (e[n] !== t[n]) return !1;
    return !0;
}
function $5292c45f2b641b96$var$Ri(e, t) {
    for(let n = 0, i = t.length; n < i; n++)e[n] = t[n];
}
function $5292c45f2b641b96$var$bi(e, t) {
    let n = $5292c45f2b641b96$var$Ei[t];
    void 0 === n && (n = new Int32Array(t), $5292c45f2b641b96$var$Ei[t] = n);
    for(let i = 0; i !== t; ++i)n[i] = e.allocateTextureUnit();
    return n;
}
function $5292c45f2b641b96$var$Ci(e, t) {
    const n = this.cache;
    n[0] !== t && (e.uniform1f(this.addr, t), n[0] = t);
}
function $5292c45f2b641b96$var$Li(e, t) {
    const n = this.cache;
    if (void 0 !== t.x) n[0] === t.x && n[1] === t.y || (e.uniform2f(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
    else {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniform2fv(this.addr, t), $5292c45f2b641b96$var$Ri(n, t);
    }
}
function $5292c45f2b641b96$var$Pi(e, t) {
    const n = this.cache;
    if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z || (e.uniform3f(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
    else if (void 0 !== t.r) n[0] === t.r && n[1] === t.g && n[2] === t.b || (e.uniform3f(this.addr, t.r, t.g, t.b), n[0] = t.r, n[1] = t.g, n[2] = t.b);
    else {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniform3fv(this.addr, t), $5292c45f2b641b96$var$Ri(n, t);
    }
}
function $5292c45f2b641b96$var$Ui(e, t) {
    const n = this.cache;
    if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w || (e.uniform4f(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
    else {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniform4fv(this.addr, t), $5292c45f2b641b96$var$Ri(n, t);
    }
}
function $5292c45f2b641b96$var$Di(e, t) {
    const n = this.cache, i = t.elements;
    if (void 0 === i) {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniformMatrix2fv(this.addr, !1, t), $5292c45f2b641b96$var$Ri(n, t);
    } else {
        if ($5292c45f2b641b96$var$Ai(n, i)) return;
        $5292c45f2b641b96$var$Mi.set(i), e.uniformMatrix2fv(this.addr, !1, $5292c45f2b641b96$var$Mi), $5292c45f2b641b96$var$Ri(n, i);
    }
}
function $5292c45f2b641b96$var$wi(e, t) {
    const n = this.cache, i = t.elements;
    if (void 0 === i) {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniformMatrix3fv(this.addr, !1, t), $5292c45f2b641b96$var$Ri(n, t);
    } else {
        if ($5292c45f2b641b96$var$Ai(n, i)) return;
        $5292c45f2b641b96$var$Ti.set(i), e.uniformMatrix3fv(this.addr, !1, $5292c45f2b641b96$var$Ti), $5292c45f2b641b96$var$Ri(n, i);
    }
}
function $5292c45f2b641b96$var$yi(e, t) {
    const n = this.cache, i = t.elements;
    if (void 0 === i) {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniformMatrix4fv(this.addr, !1, t), $5292c45f2b641b96$var$Ri(n, t);
    } else {
        if ($5292c45f2b641b96$var$Ai(n, i)) return;
        $5292c45f2b641b96$var$Si.set(i), e.uniformMatrix4fv(this.addr, !1, $5292c45f2b641b96$var$Si), $5292c45f2b641b96$var$Ri(n, i);
    }
}
function $5292c45f2b641b96$var$Ii(e, t) {
    const n = this.cache;
    n[0] !== t && (e.uniform1i(this.addr, t), n[0] = t);
}
function $5292c45f2b641b96$var$Ni(e, t) {
    const n = this.cache;
    if (void 0 !== t.x) n[0] === t.x && n[1] === t.y || (e.uniform2i(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
    else {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniform2iv(this.addr, t), $5292c45f2b641b96$var$Ri(n, t);
    }
}
function $5292c45f2b641b96$var$Oi(e, t) {
    const n = this.cache;
    if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z || (e.uniform3i(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
    else {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniform3iv(this.addr, t), $5292c45f2b641b96$var$Ri(n, t);
    }
}
function $5292c45f2b641b96$var$Fi(e, t) {
    const n = this.cache;
    if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w || (e.uniform4i(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
    else {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniform4iv(this.addr, t), $5292c45f2b641b96$var$Ri(n, t);
    }
}
function $5292c45f2b641b96$var$Bi(e, t) {
    const n = this.cache;
    n[0] !== t && (e.uniform1ui(this.addr, t), n[0] = t);
}
function $5292c45f2b641b96$var$Gi(e, t) {
    const n = this.cache;
    if (void 0 !== t.x) n[0] === t.x && n[1] === t.y || (e.uniform2ui(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
    else {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniform2uiv(this.addr, t), $5292c45f2b641b96$var$Ri(n, t);
    }
}
function $5292c45f2b641b96$var$Hi(e, t) {
    const n = this.cache;
    if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z || (e.uniform3ui(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
    else {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniform3uiv(this.addr, t), $5292c45f2b641b96$var$Ri(n, t);
    }
}
function $5292c45f2b641b96$var$Vi(e, t) {
    const n = this.cache;
    if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w || (e.uniform4ui(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
    else {
        if ($5292c45f2b641b96$var$Ai(n, t)) return;
        e.uniform4uiv(this.addr, t), $5292c45f2b641b96$var$Ri(n, t);
    }
}
function $5292c45f2b641b96$var$zi(e, t, n) {
    const i = this.cache, r = n.allocateTextureUnit();
    let a;
    i[0] !== r && (e.uniform1i(this.addr, r), i[0] = r), this.type === e.SAMPLER_2D_SHADOW ? ($5292c45f2b641b96$var$mi.compareFunction = (0, $4a792688e08e5cd7$export$64eea11eb407ddf1), a = $5292c45f2b641b96$var$mi) : a = $5292c45f2b641b96$var$pi, n.setTexture2D(t || a, r);
}
function $5292c45f2b641b96$var$ki(e, t, n) {
    const i = this.cache, r = n.allocateTextureUnit();
    i[0] !== r && (e.uniform1i(this.addr, r), i[0] = r), n.setTexture3D(t || $5292c45f2b641b96$var$_i, r);
}
function $5292c45f2b641b96$var$Wi(e, t, n) {
    const i = this.cache, r = n.allocateTextureUnit();
    i[0] !== r && (e.uniform1i(this.addr, r), i[0] = r), n.setTextureCube(t || $5292c45f2b641b96$var$gi, r);
}
function $5292c45f2b641b96$var$Xi(e, t, n) {
    const i = this.cache, r = n.allocateTextureUnit();
    i[0] !== r && (e.uniform1i(this.addr, r), i[0] = r), n.setTexture2DArray(t || $5292c45f2b641b96$var$hi, r);
}
function $5292c45f2b641b96$var$Yi(e, t) {
    e.uniform1fv(this.addr, t);
}
function $5292c45f2b641b96$var$Ki(e, t) {
    const n = $5292c45f2b641b96$var$xi(t, this.size, 2);
    e.uniform2fv(this.addr, n);
}
function $5292c45f2b641b96$var$qi(e, t) {
    const n = $5292c45f2b641b96$var$xi(t, this.size, 3);
    e.uniform3fv(this.addr, n);
}
function $5292c45f2b641b96$var$ji(e, t) {
    const n = $5292c45f2b641b96$var$xi(t, this.size, 4);
    e.uniform4fv(this.addr, n);
}
function $5292c45f2b641b96$var$Zi(e, t) {
    const n = $5292c45f2b641b96$var$xi(t, this.size, 4);
    e.uniformMatrix2fv(this.addr, !1, n);
}
function $5292c45f2b641b96$var$$i(e, t) {
    const n = $5292c45f2b641b96$var$xi(t, this.size, 9);
    e.uniformMatrix3fv(this.addr, !1, n);
}
function $5292c45f2b641b96$var$Qi(e, t) {
    const n = $5292c45f2b641b96$var$xi(t, this.size, 16);
    e.uniformMatrix4fv(this.addr, !1, n);
}
function $5292c45f2b641b96$var$Ji(e, t) {
    e.uniform1iv(this.addr, t);
}
function $5292c45f2b641b96$var$er(e, t) {
    e.uniform2iv(this.addr, t);
}
function $5292c45f2b641b96$var$tr(e, t) {
    e.uniform3iv(this.addr, t);
}
function $5292c45f2b641b96$var$nr(e, t) {
    e.uniform4iv(this.addr, t);
}
function $5292c45f2b641b96$var$ir(e, t) {
    e.uniform1uiv(this.addr, t);
}
function $5292c45f2b641b96$var$rr(e, t) {
    e.uniform2uiv(this.addr, t);
}
function $5292c45f2b641b96$var$ar(e, t) {
    e.uniform3uiv(this.addr, t);
}
function $5292c45f2b641b96$var$or(e, t) {
    e.uniform4uiv(this.addr, t);
}
function $5292c45f2b641b96$var$sr(e, t, n) {
    const i = this.cache, r = t.length, a = $5292c45f2b641b96$var$bi(n, r);
    $5292c45f2b641b96$var$Ai(i, a) || (e.uniform1iv(this.addr, a), $5292c45f2b641b96$var$Ri(i, a));
    for(let e = 0; e !== r; ++e)n.setTexture2D(t[e] || $5292c45f2b641b96$var$pi, a[e]);
}
function $5292c45f2b641b96$var$lr(e, t, n) {
    const i = this.cache, r = t.length, a = $5292c45f2b641b96$var$bi(n, r);
    $5292c45f2b641b96$var$Ai(i, a) || (e.uniform1iv(this.addr, a), $5292c45f2b641b96$var$Ri(i, a));
    for(let e = 0; e !== r; ++e)n.setTexture3D(t[e] || $5292c45f2b641b96$var$_i, a[e]);
}
function $5292c45f2b641b96$var$cr(e, t, n) {
    const i = this.cache, r = t.length, a = $5292c45f2b641b96$var$bi(n, r);
    $5292c45f2b641b96$var$Ai(i, a) || (e.uniform1iv(this.addr, a), $5292c45f2b641b96$var$Ri(i, a));
    for(let e = 0; e !== r; ++e)n.setTextureCube(t[e] || $5292c45f2b641b96$var$gi, a[e]);
}
function $5292c45f2b641b96$var$dr(e, t, n) {
    const i = this.cache, r = t.length, a = $5292c45f2b641b96$var$bi(n, r);
    $5292c45f2b641b96$var$Ai(i, a) || (e.uniform1iv(this.addr, a), $5292c45f2b641b96$var$Ri(i, a));
    for(let e = 0; e !== r; ++e)n.setTexture2DArray(t[e] || $5292c45f2b641b96$var$hi, a[e]);
}
class $5292c45f2b641b96$var$ur {
    constructor(e, t, n){
        this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.setValue = function(e) {
            switch(e){
                case 5126:
                    return $5292c45f2b641b96$var$Ci;
                case 35664:
                    return $5292c45f2b641b96$var$Li;
                case 35665:
                    return $5292c45f2b641b96$var$Pi;
                case 35666:
                    return $5292c45f2b641b96$var$Ui;
                case 35674:
                    return $5292c45f2b641b96$var$Di;
                case 35675:
                    return $5292c45f2b641b96$var$wi;
                case 35676:
                    return $5292c45f2b641b96$var$yi;
                case 5124:
                case 35670:
                    return $5292c45f2b641b96$var$Ii;
                case 35667:
                case 35671:
                    return $5292c45f2b641b96$var$Ni;
                case 35668:
                case 35672:
                    return $5292c45f2b641b96$var$Oi;
                case 35669:
                case 35673:
                    return $5292c45f2b641b96$var$Fi;
                case 5125:
                    return $5292c45f2b641b96$var$Bi;
                case 36294:
                    return $5292c45f2b641b96$var$Gi;
                case 36295:
                    return $5292c45f2b641b96$var$Hi;
                case 36296:
                    return $5292c45f2b641b96$var$Vi;
                case 35678:
                case 36198:
                case 36298:
                case 36306:
                case 35682:
                    return $5292c45f2b641b96$var$zi;
                case 35679:
                case 36299:
                case 36307:
                    return $5292c45f2b641b96$var$ki;
                case 35680:
                case 36300:
                case 36308:
                case 36293:
                    return $5292c45f2b641b96$var$Wi;
                case 36289:
                case 36303:
                case 36311:
                case 36292:
                    return $5292c45f2b641b96$var$Xi;
            }
        }(t.type);
    }
}
class $5292c45f2b641b96$var$fr {
    constructor(e, t, n){
        this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.size = t.size, this.setValue = function(e) {
            switch(e){
                case 5126:
                    return $5292c45f2b641b96$var$Yi;
                case 35664:
                    return $5292c45f2b641b96$var$Ki;
                case 35665:
                    return $5292c45f2b641b96$var$qi;
                case 35666:
                    return $5292c45f2b641b96$var$ji;
                case 35674:
                    return $5292c45f2b641b96$var$Zi;
                case 35675:
                    return $5292c45f2b641b96$var$$i;
                case 35676:
                    return $5292c45f2b641b96$var$Qi;
                case 5124:
                case 35670:
                    return $5292c45f2b641b96$var$Ji;
                case 35667:
                case 35671:
                    return $5292c45f2b641b96$var$er;
                case 35668:
                case 35672:
                    return $5292c45f2b641b96$var$tr;
                case 35669:
                case 35673:
                    return $5292c45f2b641b96$var$nr;
                case 5125:
                    return $5292c45f2b641b96$var$ir;
                case 36294:
                    return $5292c45f2b641b96$var$rr;
                case 36295:
                    return $5292c45f2b641b96$var$ar;
                case 36296:
                    return $5292c45f2b641b96$var$or;
                case 35678:
                case 36198:
                case 36298:
                case 36306:
                case 35682:
                    return $5292c45f2b641b96$var$sr;
                case 35679:
                case 36299:
                case 36307:
                    return $5292c45f2b641b96$var$lr;
                case 35680:
                case 36300:
                case 36308:
                case 36293:
                    return $5292c45f2b641b96$var$cr;
                case 36289:
                case 36303:
                case 36311:
                case 36292:
                    return $5292c45f2b641b96$var$dr;
            }
        }(t.type);
    }
}
class $5292c45f2b641b96$var$pr {
    constructor(e){
        this.id = e, this.seq = [], this.map = {};
    }
    setValue(e, t, n) {
        const i = this.seq;
        for(let r = 0, a = i.length; r !== a; ++r){
            const a = i[r];
            a.setValue(e, t[a.id], n);
        }
    }
}
const $5292c45f2b641b96$var$mr = /(\w+)(\])?(\[|\.)?/g;
function $5292c45f2b641b96$var$hr(e, t) {
    e.seq.push(t), e.map[t.id] = t;
}
function $5292c45f2b641b96$var$_r(e, t, n) {
    const i = e.name, r = i.length;
    for($5292c45f2b641b96$var$mr.lastIndex = 0;;){
        const a = $5292c45f2b641b96$var$mr.exec(i), o = $5292c45f2b641b96$var$mr.lastIndex;
        let s = a[1];
        const l = "]" === a[2], c = a[3];
        if (l && (s |= 0), void 0 === c || "[" === c && o + 2 === r) {
            $5292c45f2b641b96$var$hr(n, void 0 === c ? new $5292c45f2b641b96$var$ur(s, e, t) : new $5292c45f2b641b96$var$fr(s, e, t));
            break;
        }
        {
            let e = n.map[s];
            void 0 === e && (e = new $5292c45f2b641b96$var$pr(s), $5292c45f2b641b96$var$hr(n, e)), n = e;
        }
    }
}
class $5292c45f2b641b96$var$gr {
    constructor(e, t){
        this.seq = [], this.map = {};
        const n = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const n = e.getActiveUniform(t, i);
            $5292c45f2b641b96$var$_r(n, e.getUniformLocation(t, n.name), this);
        }
    }
    setValue(e, t, n, i) {
        const r = this.map[t];
        void 0 !== r && r.setValue(e, n, i);
    }
    setOptional(e, t, n) {
        const i = t[n];
        void 0 !== i && this.setValue(e, n, i);
    }
    static upload(e, t, n, i) {
        for(let r = 0, a = t.length; r !== a; ++r){
            const a = t[r], o = n[a.id];
            !1 !== o.needsUpdate && a.setValue(e, o.value, i);
        }
    }
    static seqWithValue(e, t) {
        const n = [];
        for(let i = 0, r = e.length; i !== r; ++i){
            const r = e[i];
            r.id in t && n.push(r);
        }
        return n;
    }
}
function $5292c45f2b641b96$var$vr(e, t, n) {
    const i = e.createShader(t);
    return e.shaderSource(i, n), e.compileShader(i), i;
}
let $5292c45f2b641b96$var$Er = 0;
const $5292c45f2b641b96$var$Sr = new (0, $4a792688e08e5cd7$export$8ff26dafa08918);
function $5292c45f2b641b96$var$Tr(e, t, n) {
    const i = e.getShaderParameter(t, e.COMPILE_STATUS), r = (e.getShaderInfoLog(t) || "").trim();
    if (i && "" === r) return "";
    const a = /ERROR: 0:(\d+)/.exec(r);
    if (a) {
        const i = parseInt(a[1]);
        return n.toUpperCase() + "\n\n" + r + "\n\n" + function(e, t) {
            const n = e.split("\n"), i = [], r = Math.max(t - 6, 0), a = Math.min(t + 6, n.length);
            for(let e = r; e < a; e++){
                const r = e + 1;
                i.push(`${r === t ? ">" : " "} ${r}: ${n[e]}`);
            }
            return i.join("\n");
        }(e.getShaderSource(t), i);
    }
    return r;
}
function $5292c45f2b641b96$var$Mr(e, t) {
    const n = function(e) {
        (0, $4a792688e08e5cd7$export$5e6fd513f44698c)._getMatrix($5292c45f2b641b96$var$Sr, (0, $4a792688e08e5cd7$export$5e6fd513f44698c).workingColorSpace, e);
        const t = `mat3( ${$5292c45f2b641b96$var$Sr.elements.map((e)=>e.toFixed(4))} )`;
        switch((0, $4a792688e08e5cd7$export$5e6fd513f44698c).getTransfer(e)){
            case 0, $4a792688e08e5cd7$export$f197347d588c1b4a:
                return [
                    t,
                    "LinearTransferOETF"
                ];
            case 0, $4a792688e08e5cd7$export$8d0a61916cc26abb:
                return [
                    t,
                    "sRGBTransferOETF"
                ];
            default:
                return (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLProgram: Unsupported color space: ", e), [
                    t,
                    "LinearTransferOETF"
                ];
        }
    }(t);
    return [
        `vec4 ${e}( vec4 value ) {`,
        `\treturn ${n[1]}( vec4( value.rgb * ${n[0]}, value.a ) );`,
        "}"
    ].join("\n");
}
function $5292c45f2b641b96$var$xr(e, t) {
    let n;
    switch(t){
        case 0, $4a792688e08e5cd7$export$98f52c2a46c598ca:
            n = "Linear";
            break;
        case 0, $4a792688e08e5cd7$export$74b25e54b3bcd548:
            n = "Reinhard";
            break;
        case 0, $4a792688e08e5cd7$export$932b3dd283d4a366:
            n = "Cineon";
            break;
        case 0, $4a792688e08e5cd7$export$a0d98fe6d7e4af64:
            n = "ACESFilmic";
            break;
        case 0, $4a792688e08e5cd7$export$212d53a513a325b2:
            n = "AgX";
            break;
        case 0, $4a792688e08e5cd7$export$f2863e1668a8e317:
            n = "Neutral";
            break;
        case 0, $4a792688e08e5cd7$export$2c7b09c1e9abfb5e:
            n = "Custom";
            break;
        default:
            (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLProgram: Unsupported toneMapping:", t), n = "Linear";
    }
    return "vec3 " + e + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
}
const $5292c45f2b641b96$var$Ar = new (0, $4a792688e08e5cd7$export$64b5c384219d3699);
function $5292c45f2b641b96$var$Rr() {
    (0, $4a792688e08e5cd7$export$5e6fd513f44698c).getLuminanceCoefficients($5292c45f2b641b96$var$Ar);
    return [
        "float luminance( const in vec3 rgb ) {",
        `\tconst vec3 weights = vec3( ${$5292c45f2b641b96$var$Ar.x.toFixed(4)}, ${$5292c45f2b641b96$var$Ar.y.toFixed(4)}, ${$5292c45f2b641b96$var$Ar.z.toFixed(4)} );`,
        "\treturn dot( weights, rgb );",
        "}"
    ].join("\n");
}
function $5292c45f2b641b96$var$br(e) {
    return "" !== e;
}
function $5292c45f2b641b96$var$Cr(e, t) {
    const n = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
    return e.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, n).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
}
function $5292c45f2b641b96$var$Lr(e, t) {
    return e.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
}
const $5292c45f2b641b96$var$Pr = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $5292c45f2b641b96$var$Ur(e) {
    return e.replace($5292c45f2b641b96$var$Pr, $5292c45f2b641b96$var$wr);
}
const $5292c45f2b641b96$var$Dr = new Map;
function $5292c45f2b641b96$var$wr(e, t) {
    let n = $5292c45f2b641b96$export$955f9f2e84c43c8b[t];
    if (void 0 === n) {
        const e = $5292c45f2b641b96$var$Dr.get(t);
        if (void 0 === e) throw new Error("Can not resolve #include <" + t + ">");
        n = $5292c45f2b641b96$export$955f9f2e84c43c8b[e], (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)('WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', t, e);
    }
    return $5292c45f2b641b96$var$Ur(n);
}
const $5292c45f2b641b96$var$yr = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $5292c45f2b641b96$var$Ir(e) {
    return e.replace($5292c45f2b641b96$var$yr, $5292c45f2b641b96$var$Nr);
}
function $5292c45f2b641b96$var$Nr(e, t, n, i) {
    let r = "";
    for(let e = parseInt(t); e < parseInt(n); e++)r += i.replace(/\[\s*i\s*\]/g, "[ " + e + " ]").replace(/UNROLLED_LOOP_INDEX/g, e);
    return r;
}
function $5292c45f2b641b96$var$Or(e) {
    let t = `precision ${e.precision} float;\n\tprecision ${e.precision} int;\n\tprecision ${e.precision} sampler2D;\n\tprecision ${e.precision} samplerCube;\n\tprecision ${e.precision} sampler3D;\n\tprecision ${e.precision} sampler2DArray;\n\tprecision ${e.precision} sampler2DShadow;\n\tprecision ${e.precision} samplerCubeShadow;\n\tprecision ${e.precision} sampler2DArrayShadow;\n\tprecision ${e.precision} isampler2D;\n\tprecision ${e.precision} isampler3D;\n\tprecision ${e.precision} isamplerCube;\n\tprecision ${e.precision} isampler2DArray;\n\tprecision ${e.precision} usampler2D;\n\tprecision ${e.precision} usampler3D;\n\tprecision ${e.precision} usamplerCube;\n\tprecision ${e.precision} usampler2DArray;\n\t`;
    return "highp" === e.precision ? t += "\n#define HIGH_PRECISION" : "mediump" === e.precision ? t += "\n#define MEDIUM_PRECISION" : "lowp" === e.precision && (t += "\n#define LOW_PRECISION"), t;
}
function $5292c45f2b641b96$var$Fr(e, t, n, i) {
    const r = e.getContext(), o = n.defines;
    let s = n.vertexShader, l = n.fragmentShader;
    const c = function(e) {
        let t = "SHADOWMAP_TYPE_BASIC";
        return e.shadowMapType === (0, $4a792688e08e5cd7$export$5813f879eee7cd88) ? t = "SHADOWMAP_TYPE_PCF" : e.shadowMapType === (0, $4a792688e08e5cd7$export$a47c4b43a1be34f0) ? t = "SHADOWMAP_TYPE_PCF_SOFT" : e.shadowMapType === (0, $4a792688e08e5cd7$export$896ae1ade6c829c4) && (t = "SHADOWMAP_TYPE_VSM"), t;
    }(n), d = function(e) {
        let t = "ENVMAP_TYPE_CUBE";
        if (e.envMap) switch(e.envMapMode){
            case 0, $4a792688e08e5cd7$export$8759762a6477f2c4:
            case 0, $4a792688e08e5cd7$export$dc59f8aed047f61d:
                t = "ENVMAP_TYPE_CUBE";
                break;
            case 0, $4a792688e08e5cd7$export$dbf3e70ff37af79:
                t = "ENVMAP_TYPE_CUBE_UV";
        }
        return t;
    }(n), u = function(e) {
        let t = "ENVMAP_MODE_REFLECTION";
        e.envMap && e.envMapMode === (0, $4a792688e08e5cd7$export$dc59f8aed047f61d) && (t = "ENVMAP_MODE_REFRACTION");
        return t;
    }(n), f = function(e) {
        let t = "ENVMAP_BLENDING_NONE";
        if (e.envMap) switch(e.combine){
            case 0, $4a792688e08e5cd7$export$e50ac29801f1774d:
                t = "ENVMAP_BLENDING_MULTIPLY";
                break;
            case 0, $4a792688e08e5cd7$export$9f9d94f963c85479:
                t = "ENVMAP_BLENDING_MIX";
                break;
            case 0, $4a792688e08e5cd7$export$e641dc52bc3494aa:
                t = "ENVMAP_BLENDING_ADD";
        }
        return t;
    }(n), p = function(e) {
        const t = e.envMapCubeUVHeight;
        if (null === t) return null;
        const n = Math.log2(t) - 2, i = 1 / t;
        return {
            texelWidth: 1 / (3 * Math.max(Math.pow(2, n), 112)),
            texelHeight: i,
            maxMip: n
        };
    }(n), m = function(e) {
        return [
            e.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
            e.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
        ].filter($5292c45f2b641b96$var$br).join("\n");
    }(n), h = function(e) {
        const t = [];
        for(const n in e){
            const i = e[n];
            !1 !== i && t.push("#define " + n + " " + i);
        }
        return t.join("\n");
    }(o), _ = r.createProgram();
    let g, v, S = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";
    n.isRawShaderMaterial ? (g = [
        "#define SHADER_TYPE " + n.shaderType,
        "#define SHADER_NAME " + n.shaderName,
        h
    ].filter($5292c45f2b641b96$var$br).join("\n"), g.length > 0 && (g += "\n"), v = [
        "#define SHADER_TYPE " + n.shaderType,
        "#define SHADER_NAME " + n.shaderName,
        h
    ].filter($5292c45f2b641b96$var$br).join("\n"), v.length > 0 && (v += "\n")) : (g = [
        $5292c45f2b641b96$var$Or(n),
        "#define SHADER_TYPE " + n.shaderType,
        "#define SHADER_NAME " + n.shaderName,
        h,
        n.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
        n.batching ? "#define USE_BATCHING" : "",
        n.batchingColor ? "#define USE_BATCHING_COLOR" : "",
        n.instancing ? "#define USE_INSTANCING" : "",
        n.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        n.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
        n.useFog && n.fog ? "#define USE_FOG" : "",
        n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
        n.map ? "#define USE_MAP" : "",
        n.envMap ? "#define USE_ENVMAP" : "",
        n.envMap ? "#define " + u : "",
        n.lightMap ? "#define USE_LIGHTMAP" : "",
        n.aoMap ? "#define USE_AOMAP" : "",
        n.bumpMap ? "#define USE_BUMPMAP" : "",
        n.normalMap ? "#define USE_NORMALMAP" : "",
        n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        n.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
        n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        n.anisotropy ? "#define USE_ANISOTROPY" : "",
        n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        n.specularMap ? "#define USE_SPECULARMAP" : "",
        n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        n.metalnessMap ? "#define USE_METALNESSMAP" : "",
        n.alphaMap ? "#define USE_ALPHAMAP" : "",
        n.alphaHash ? "#define USE_ALPHAHASH" : "",
        n.transmission ? "#define USE_TRANSMISSION" : "",
        n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        n.mapUv ? "#define MAP_UV " + n.mapUv : "",
        n.alphaMapUv ? "#define ALPHAMAP_UV " + n.alphaMapUv : "",
        n.lightMapUv ? "#define LIGHTMAP_UV " + n.lightMapUv : "",
        n.aoMapUv ? "#define AOMAP_UV " + n.aoMapUv : "",
        n.emissiveMapUv ? "#define EMISSIVEMAP_UV " + n.emissiveMapUv : "",
        n.bumpMapUv ? "#define BUMPMAP_UV " + n.bumpMapUv : "",
        n.normalMapUv ? "#define NORMALMAP_UV " + n.normalMapUv : "",
        n.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + n.displacementMapUv : "",
        n.metalnessMapUv ? "#define METALNESSMAP_UV " + n.metalnessMapUv : "",
        n.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + n.roughnessMapUv : "",
        n.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + n.anisotropyMapUv : "",
        n.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + n.clearcoatMapUv : "",
        n.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + n.clearcoatNormalMapUv : "",
        n.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + n.clearcoatRoughnessMapUv : "",
        n.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + n.iridescenceMapUv : "",
        n.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + n.iridescenceThicknessMapUv : "",
        n.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + n.sheenColorMapUv : "",
        n.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + n.sheenRoughnessMapUv : "",
        n.specularMapUv ? "#define SPECULARMAP_UV " + n.specularMapUv : "",
        n.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + n.specularColorMapUv : "",
        n.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + n.specularIntensityMapUv : "",
        n.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + n.transmissionMapUv : "",
        n.thicknessMapUv ? "#define THICKNESSMAP_UV " + n.thicknessMapUv : "",
        n.vertexTangents && !1 === n.flatShading ? "#define USE_TANGENT" : "",
        n.vertexColors ? "#define USE_COLOR" : "",
        n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        n.vertexUv1s ? "#define USE_UV1" : "",
        n.vertexUv2s ? "#define USE_UV2" : "",
        n.vertexUv3s ? "#define USE_UV3" : "",
        n.pointsUvs ? "#define USE_POINTS_UV" : "",
        n.flatShading ? "#define FLAT_SHADED" : "",
        n.skinning ? "#define USE_SKINNING" : "",
        n.morphTargets ? "#define USE_MORPHTARGETS" : "",
        n.morphNormals && !1 === n.flatShading ? "#define USE_MORPHNORMALS" : "",
        n.morphColors ? "#define USE_MORPHCOLORS" : "",
        n.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "",
        n.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "",
        n.doubleSided ? "#define DOUBLE_SIDED" : "",
        n.flipSided ? "#define FLIP_SIDED" : "",
        n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        n.shadowMapEnabled ? "#define " + c : "",
        n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        n.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
        n.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "\tattribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "\tattribute vec3 instanceColor;",
        "#endif",
        "#ifdef USE_INSTANCING_MORPH",
        "\tuniform sampler2D morphTexture;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_UV1",
        "\tattribute vec2 uv1;",
        "#endif",
        "#ifdef USE_UV2",
        "\tattribute vec2 uv2;",
        "#endif",
        "#ifdef USE_UV3",
        "\tattribute vec2 uv3;",
        "#endif",
        "#ifdef USE_TANGENT",
        "\tattribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "\tattribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "\tattribute vec3 color;",
        "#endif",
        "#ifdef USE_SKINNING",
        "\tattribute vec4 skinIndex;",
        "\tattribute vec4 skinWeight;",
        "#endif",
        "\n"
    ].filter($5292c45f2b641b96$var$br).join("\n"), v = [
        $5292c45f2b641b96$var$Or(n),
        "#define SHADER_TYPE " + n.shaderType,
        "#define SHADER_NAME " + n.shaderName,
        h,
        n.useFog && n.fog ? "#define USE_FOG" : "",
        n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
        n.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
        n.map ? "#define USE_MAP" : "",
        n.matcap ? "#define USE_MATCAP" : "",
        n.envMap ? "#define USE_ENVMAP" : "",
        n.envMap ? "#define " + d : "",
        n.envMap ? "#define " + u : "",
        n.envMap ? "#define " + f : "",
        p ? "#define CUBEUV_TEXEL_WIDTH " + p.texelWidth : "",
        p ? "#define CUBEUV_TEXEL_HEIGHT " + p.texelHeight : "",
        p ? "#define CUBEUV_MAX_MIP " + p.maxMip + ".0" : "",
        n.lightMap ? "#define USE_LIGHTMAP" : "",
        n.aoMap ? "#define USE_AOMAP" : "",
        n.bumpMap ? "#define USE_BUMPMAP" : "",
        n.normalMap ? "#define USE_NORMALMAP" : "",
        n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        n.anisotropy ? "#define USE_ANISOTROPY" : "",
        n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        n.clearcoat ? "#define USE_CLEARCOAT" : "",
        n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        n.dispersion ? "#define USE_DISPERSION" : "",
        n.iridescence ? "#define USE_IRIDESCENCE" : "",
        n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        n.specularMap ? "#define USE_SPECULARMAP" : "",
        n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        n.metalnessMap ? "#define USE_METALNESSMAP" : "",
        n.alphaMap ? "#define USE_ALPHAMAP" : "",
        n.alphaTest ? "#define USE_ALPHATEST" : "",
        n.alphaHash ? "#define USE_ALPHAHASH" : "",
        n.sheen ? "#define USE_SHEEN" : "",
        n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        n.transmission ? "#define USE_TRANSMISSION" : "",
        n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        n.vertexTangents && !1 === n.flatShading ? "#define USE_TANGENT" : "",
        n.vertexColors || n.instancingColor || n.batchingColor ? "#define USE_COLOR" : "",
        n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        n.vertexUv1s ? "#define USE_UV1" : "",
        n.vertexUv2s ? "#define USE_UV2" : "",
        n.vertexUv3s ? "#define USE_UV3" : "",
        n.pointsUvs ? "#define USE_POINTS_UV" : "",
        n.gradientMap ? "#define USE_GRADIENTMAP" : "",
        n.flatShading ? "#define FLAT_SHADED" : "",
        n.doubleSided ? "#define DOUBLE_SIDED" : "",
        n.flipSided ? "#define FLIP_SIDED" : "",
        n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        n.shadowMapEnabled ? "#define " + c : "",
        n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        n.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        n.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
        n.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
        n.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        n.toneMapping !== (0, $4a792688e08e5cd7$export$9fcb6b4294603b2) ? "#define TONE_MAPPING" : "",
        n.toneMapping !== (0, $4a792688e08e5cd7$export$9fcb6b4294603b2) ? $5292c45f2b641b96$export$955f9f2e84c43c8b.tonemapping_pars_fragment : "",
        n.toneMapping !== (0, $4a792688e08e5cd7$export$9fcb6b4294603b2) ? $5292c45f2b641b96$var$xr("toneMapping", n.toneMapping) : "",
        n.dithering ? "#define DITHERING" : "",
        n.opaque ? "#define OPAQUE" : "",
        $5292c45f2b641b96$export$955f9f2e84c43c8b.colorspace_pars_fragment,
        $5292c45f2b641b96$var$Mr("linearToOutputTexel", n.outputColorSpace),
        $5292c45f2b641b96$var$Rr(),
        n.useDepthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "",
        "\n"
    ].filter($5292c45f2b641b96$var$br).join("\n")), s = $5292c45f2b641b96$var$Ur(s), s = $5292c45f2b641b96$var$Cr(s, n), s = $5292c45f2b641b96$var$Lr(s, n), l = $5292c45f2b641b96$var$Ur(l), l = $5292c45f2b641b96$var$Cr(l, n), l = $5292c45f2b641b96$var$Lr(l, n), s = $5292c45f2b641b96$var$Ir(s), l = $5292c45f2b641b96$var$Ir(l), !0 !== n.isRawShaderMaterial && (S = "#version 300 es\n", g = [
        m,
        "#define attribute in",
        "#define varying out",
        "#define texture2D texture"
    ].join("\n") + "\n" + g, v = [
        "#define varying in",
        n.glslVersion === (0, $4a792688e08e5cd7$export$f63012db5506e7dd) ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
        n.glslVersion === (0, $4a792688e08e5cd7$export$f63012db5506e7dd) ? "" : "#define gl_FragColor pc_fragColor",
        "#define gl_FragDepthEXT gl_FragDepth",
        "#define texture2D texture",
        "#define textureCube texture",
        "#define texture2DProj textureProj",
        "#define texture2DLodEXT textureLod",
        "#define texture2DProjLodEXT textureProjLod",
        "#define textureCubeLodEXT textureLod",
        "#define texture2DGradEXT textureGrad",
        "#define texture2DProjGradEXT textureProjGrad",
        "#define textureCubeGradEXT textureGrad"
    ].join("\n") + "\n" + v);
    const T = S + g + s, M = S + v + l, x = $5292c45f2b641b96$var$vr(r, r.VERTEX_SHADER, T), A = $5292c45f2b641b96$var$vr(r, r.FRAGMENT_SHADER, M);
    function R(t) {
        if (e.debug.checkShaderErrors) {
            const n = r.getProgramInfoLog(_) || "", i = r.getShaderInfoLog(x) || "", a = r.getShaderInfoLog(A) || "", o = n.trim(), s = i.trim(), l = a.trim();
            let c = !0, d = !0;
            if (!1 === r.getProgramParameter(_, r.LINK_STATUS)) {
                if (c = !1, "function" == typeof e.debug.onShaderError) e.debug.onShaderError(r, _, x, A);
                else {
                    const e = $5292c45f2b641b96$var$Tr(r, x, "vertex"), n = $5292c45f2b641b96$var$Tr(r, A, "fragment");
                    (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("THREE.WebGLProgram: Shader Error " + r.getError() + " - VALIDATE_STATUS " + r.getProgramParameter(_, r.VALIDATE_STATUS) + "\n\nMaterial Name: " + t.name + "\nMaterial Type: " + t.type + "\n\nProgram Info Log: " + o + "\n" + e + "\n" + n);
                }
            } else "" !== o ? (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLProgram: Program Info Log:", o) : "" !== s && "" !== l || (d = !1);
            d && (t.diagnostics = {
                runnable: c,
                programLog: o,
                vertexShader: {
                    log: s,
                    prefix: g
                },
                fragmentShader: {
                    log: l,
                    prefix: v
                }
            });
        }
        r.deleteShader(x), r.deleteShader(A), b = new $5292c45f2b641b96$var$gr(r, _), C = function(e, t) {
            const n = {}, i = e.getProgramParameter(t, e.ACTIVE_ATTRIBUTES);
            for(let r = 0; r < i; r++){
                const i = e.getActiveAttrib(t, r), a = i.name;
                let o = 1;
                i.type === e.FLOAT_MAT2 && (o = 2), i.type === e.FLOAT_MAT3 && (o = 3), i.type === e.FLOAT_MAT4 && (o = 4), n[a] = {
                    type: i.type,
                    location: e.getAttribLocation(t, a),
                    locationSize: o
                };
            }
            return n;
        }(r, _);
    }
    let b, C;
    r.attachShader(_, x), r.attachShader(_, A), void 0 !== n.index0AttributeName ? r.bindAttribLocation(_, 0, n.index0AttributeName) : !0 === n.morphTargets && r.bindAttribLocation(_, 0, "position"), r.linkProgram(_), this.getUniforms = function() {
        return void 0 === b && R(this), b;
    }, this.getAttributes = function() {
        return void 0 === C && R(this), C;
    };
    let U = !1 === n.rendererExtensionParallelShaderCompile;
    return this.isReady = function() {
        return !1 === U && (U = r.getProgramParameter(_, 37297)), U;
    }, this.destroy = function() {
        i.releaseStatesOfProgram(this), r.deleteProgram(_), this.program = void 0;
    }, this.type = n.shaderType, this.name = n.shaderName, this.id = $5292c45f2b641b96$var$Er++, this.cacheKey = t, this.usedTimes = 1, this.program = _, this.vertexShader = x, this.fragmentShader = A, this;
}
let $5292c45f2b641b96$var$Br = 0;
class $5292c45f2b641b96$var$Gr {
    constructor(){
        this.shaderCache = new Map, this.materialCache = new Map;
    }
    update(e) {
        const t = e.vertexShader, n = e.fragmentShader, i = this._getShaderStage(t), r = this._getShaderStage(n), a = this._getShaderCacheForMaterial(e);
        return !1 === a.has(i) && (a.add(i), i.usedTimes++), !1 === a.has(r) && (a.add(r), r.usedTimes++), this;
    }
    remove(e) {
        const t = this.materialCache.get(e);
        for (const e of t)e.usedTimes--, 0 === e.usedTimes && this.shaderCache.delete(e.code);
        return this.materialCache.delete(e), this;
    }
    getVertexShaderID(e) {
        return this._getShaderStage(e.vertexShader).id;
    }
    getFragmentShaderID(e) {
        return this._getShaderStage(e.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear(), this.materialCache.clear();
    }
    _getShaderCacheForMaterial(e) {
        const t = this.materialCache;
        let n = t.get(e);
        return void 0 === n && (n = new Set, t.set(e, n)), n;
    }
    _getShaderStage(e) {
        const t = this.shaderCache;
        let n = t.get(e);
        return void 0 === n && (n = new $5292c45f2b641b96$var$Hr(e), t.set(e, n)), n;
    }
}
class $5292c45f2b641b96$var$Hr {
    constructor(e){
        this.id = $5292c45f2b641b96$var$Br++, this.code = e, this.usedTimes = 0;
    }
}
function $5292c45f2b641b96$var$Vr(e, t, n, i, r, o, s) {
    const l = new (0, $4a792688e08e5cd7$export$89312ce47c0ca777), d = new $5292c45f2b641b96$var$Gr, u = new Set, f = [], h = r.logarithmicDepthBuffer, _ = r.vertexTextures;
    let g = r.precision;
    const v = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function S(e) {
        return u.add(e), 0 === e ? "uv" : `uv${e}`;
    }
    return {
        getParameters: function(o, l, f, T, M) {
            const x = T.fog, A = M.geometry, R = o.isMeshStandardMaterial ? T.environment : null, b = (o.isMeshStandardMaterial ? n : t).get(o.envMap || R), C = b && b.mapping === (0, $4a792688e08e5cd7$export$dbf3e70ff37af79) ? b.image.height : null, L = v[o.type];
            null !== o.precision && (g = r.getMaxPrecision(o.precision), g !== o.precision && (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLProgram.getParameters:", o.precision, "not supported, using", g, "instead."));
            const P = A.morphAttributes.position || A.morphAttributes.normal || A.morphAttributes.color, U = void 0 !== P ? P.length : 0;
            let D, w, I, N, O = 0;
            if (void 0 !== A.morphAttributes.position && (O = 1), void 0 !== A.morphAttributes.normal && (O = 2), void 0 !== A.morphAttributes.color && (O = 3), L) {
                const e = $5292c45f2b641b96$export$bee4a7d47f8f5014[L];
                D = e.vertexShader, w = e.fragmentShader;
            } else D = o.vertexShader, w = o.fragmentShader, d.update(o), I = d.getVertexShaderID(o), N = d.getFragmentShaderID(o);
            const F = e.getRenderTarget(), B = e.state.buffers.depth.getReversed(), H = !0 === M.isInstancedMesh, V = !0 === M.isBatchedMesh, z = !!o.map, k = !!o.matcap, W = !!b, X = !!o.aoMap, Y = !!o.lightMap, K = !!o.bumpMap, q = !!o.normalMap, j = !!o.displacementMap, Z = !!o.emissiveMap, $ = !!o.metalnessMap, Q = !!o.roughnessMap, J = o.anisotropy > 0, ee = o.clearcoat > 0, te = o.dispersion > 0, ne = o.iridescence > 0, ie = o.sheen > 0, re = o.transmission > 0, ae = J && !!o.anisotropyMap, oe = ee && !!o.clearcoatMap, se = ee && !!o.clearcoatNormalMap, le = ee && !!o.clearcoatRoughnessMap, ce = ne && !!o.iridescenceMap, de = ne && !!o.iridescenceThicknessMap, ue = ie && !!o.sheenColorMap, fe = ie && !!o.sheenRoughnessMap, pe = !!o.specularMap, ve = !!o.specularColorMap, Ee = !!o.specularIntensityMap, Se = re && !!o.transmissionMap, Te = re && !!o.thicknessMap, Me = !!o.gradientMap, xe = !!o.alphaMap, Ae = o.alphaTest > 0, Re = !!o.alphaHash, be = !!o.extensions;
            let Ce = (0, $4a792688e08e5cd7$export$9fcb6b4294603b2);
            o.toneMapped && (null !== F && !0 !== F.isXRRenderTarget || (Ce = e.toneMapping));
            const Le = {
                shaderID: L,
                shaderType: o.type,
                shaderName: o.name,
                vertexShader: D,
                fragmentShader: w,
                defines: o.defines,
                customVertexShaderID: I,
                customFragmentShaderID: N,
                isRawShaderMaterial: !0 === o.isRawShaderMaterial,
                glslVersion: o.glslVersion,
                precision: g,
                batching: V,
                batchingColor: V && null !== M._colorsTexture,
                instancing: H,
                instancingColor: H && null !== M.instanceColor,
                instancingMorph: H && null !== M.morphTexture,
                supportsVertexTextures: _,
                outputColorSpace: null === F ? e.outputColorSpace : !0 === F.isXRRenderTarget ? F.texture.colorSpace : (0, $4a792688e08e5cd7$export$42429b3acfb233a4),
                alphaToCoverage: !!o.alphaToCoverage,
                map: z,
                matcap: k,
                envMap: W,
                envMapMode: W && b.mapping,
                envMapCubeUVHeight: C,
                aoMap: X,
                lightMap: Y,
                bumpMap: K,
                normalMap: q,
                displacementMap: _ && j,
                emissiveMap: Z,
                normalMapObjectSpace: q && o.normalMapType === (0, $4a792688e08e5cd7$export$9990ad26f9db5b2c),
                normalMapTangentSpace: q && o.normalMapType === (0, $4a792688e08e5cd7$export$2852a58ebdac27b8),
                metalnessMap: $,
                roughnessMap: Q,
                anisotropy: J,
                anisotropyMap: ae,
                clearcoat: ee,
                clearcoatMap: oe,
                clearcoatNormalMap: se,
                clearcoatRoughnessMap: le,
                dispersion: te,
                iridescence: ne,
                iridescenceMap: ce,
                iridescenceThicknessMap: de,
                sheen: ie,
                sheenColorMap: ue,
                sheenRoughnessMap: fe,
                specularMap: pe,
                specularColorMap: ve,
                specularIntensityMap: Ee,
                transmission: re,
                transmissionMap: Se,
                thicknessMap: Te,
                gradientMap: Me,
                opaque: !1 === o.transparent && o.blending === (0, $4a792688e08e5cd7$export$5b29a26d96ee6af0) && !1 === o.alphaToCoverage,
                alphaMap: xe,
                alphaTest: Ae,
                alphaHash: Re,
                combine: o.combine,
                mapUv: z && S(o.map.channel),
                aoMapUv: X && S(o.aoMap.channel),
                lightMapUv: Y && S(o.lightMap.channel),
                bumpMapUv: K && S(o.bumpMap.channel),
                normalMapUv: q && S(o.normalMap.channel),
                displacementMapUv: j && S(o.displacementMap.channel),
                emissiveMapUv: Z && S(o.emissiveMap.channel),
                metalnessMapUv: $ && S(o.metalnessMap.channel),
                roughnessMapUv: Q && S(o.roughnessMap.channel),
                anisotropyMapUv: ae && S(o.anisotropyMap.channel),
                clearcoatMapUv: oe && S(o.clearcoatMap.channel),
                clearcoatNormalMapUv: se && S(o.clearcoatNormalMap.channel),
                clearcoatRoughnessMapUv: le && S(o.clearcoatRoughnessMap.channel),
                iridescenceMapUv: ce && S(o.iridescenceMap.channel),
                iridescenceThicknessMapUv: de && S(o.iridescenceThicknessMap.channel),
                sheenColorMapUv: ue && S(o.sheenColorMap.channel),
                sheenRoughnessMapUv: fe && S(o.sheenRoughnessMap.channel),
                specularMapUv: pe && S(o.specularMap.channel),
                specularColorMapUv: ve && S(o.specularColorMap.channel),
                specularIntensityMapUv: Ee && S(o.specularIntensityMap.channel),
                transmissionMapUv: Se && S(o.transmissionMap.channel),
                thicknessMapUv: Te && S(o.thicknessMap.channel),
                alphaMapUv: xe && S(o.alphaMap.channel),
                vertexTangents: !!A.attributes.tangent && (q || J),
                vertexColors: o.vertexColors,
                vertexAlphas: !0 === o.vertexColors && !!A.attributes.color && 4 === A.attributes.color.itemSize,
                pointsUvs: !0 === M.isPoints && !!A.attributes.uv && (z || xe),
                fog: !!x,
                useFog: !0 === o.fog,
                fogExp2: !!x && x.isFogExp2,
                flatShading: !0 === o.flatShading && !1 === o.wireframe,
                sizeAttenuation: !0 === o.sizeAttenuation,
                logarithmicDepthBuffer: h,
                reversedDepthBuffer: B,
                skinning: !0 === M.isSkinnedMesh,
                morphTargets: void 0 !== A.morphAttributes.position,
                morphNormals: void 0 !== A.morphAttributes.normal,
                morphColors: void 0 !== A.morphAttributes.color,
                morphTargetsCount: U,
                morphTextureStride: O,
                numDirLights: l.directional.length,
                numPointLights: l.point.length,
                numSpotLights: l.spot.length,
                numSpotLightMaps: l.spotLightMap.length,
                numRectAreaLights: l.rectArea.length,
                numHemiLights: l.hemi.length,
                numDirLightShadows: l.directionalShadowMap.length,
                numPointLightShadows: l.pointShadowMap.length,
                numSpotLightShadows: l.spotShadowMap.length,
                numSpotLightShadowsWithMaps: l.numSpotLightShadowsWithMaps,
                numLightProbes: l.numLightProbes,
                numClippingPlanes: s.numPlanes,
                numClipIntersection: s.numIntersection,
                dithering: o.dithering,
                shadowMapEnabled: e.shadowMap.enabled && f.length > 0,
                shadowMapType: e.shadowMap.type,
                toneMapping: Ce,
                decodeVideoTexture: z && !0 === o.map.isVideoTexture && (0, $4a792688e08e5cd7$export$5e6fd513f44698c).getTransfer(o.map.colorSpace) === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb),
                decodeVideoTextureEmissive: Z && !0 === o.emissiveMap.isVideoTexture && (0, $4a792688e08e5cd7$export$5e6fd513f44698c).getTransfer(o.emissiveMap.colorSpace) === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb),
                premultipliedAlpha: o.premultipliedAlpha,
                doubleSided: o.side === (0, $4a792688e08e5cd7$export$3b296b6f144d5b03),
                flipSided: o.side === (0, $4a792688e08e5cd7$export$d9f0486e75b5ace),
                useDepthPacking: o.depthPacking >= 0,
                depthPacking: o.depthPacking || 0,
                index0AttributeName: o.index0AttributeName,
                extensionClipCullDistance: be && !0 === o.extensions.clipCullDistance && i.has("WEBGL_clip_cull_distance"),
                extensionMultiDraw: (be && !0 === o.extensions.multiDraw || V) && i.has("WEBGL_multi_draw"),
                rendererExtensionParallelShaderCompile: i.has("KHR_parallel_shader_compile"),
                customProgramCacheKey: o.customProgramCacheKey()
            };
            return Le.vertexUv1s = u.has(1), Le.vertexUv2s = u.has(2), Le.vertexUv3s = u.has(3), u.clear(), Le;
        },
        getProgramCacheKey: function(t) {
            const n = [];
            if (t.shaderID ? n.push(t.shaderID) : (n.push(t.customVertexShaderID), n.push(t.customFragmentShaderID)), void 0 !== t.defines) for(const e in t.defines)n.push(e), n.push(t.defines[e]);
            return !1 === t.isRawShaderMaterial && (!function(e, t) {
                e.push(t.precision), e.push(t.outputColorSpace), e.push(t.envMapMode), e.push(t.envMapCubeUVHeight), e.push(t.mapUv), e.push(t.alphaMapUv), e.push(t.lightMapUv), e.push(t.aoMapUv), e.push(t.bumpMapUv), e.push(t.normalMapUv), e.push(t.displacementMapUv), e.push(t.emissiveMapUv), e.push(t.metalnessMapUv), e.push(t.roughnessMapUv), e.push(t.anisotropyMapUv), e.push(t.clearcoatMapUv), e.push(t.clearcoatNormalMapUv), e.push(t.clearcoatRoughnessMapUv), e.push(t.iridescenceMapUv), e.push(t.iridescenceThicknessMapUv), e.push(t.sheenColorMapUv), e.push(t.sheenRoughnessMapUv), e.push(t.specularMapUv), e.push(t.specularColorMapUv), e.push(t.specularIntensityMapUv), e.push(t.transmissionMapUv), e.push(t.thicknessMapUv), e.push(t.combine), e.push(t.fogExp2), e.push(t.sizeAttenuation), e.push(t.morphTargetsCount), e.push(t.morphAttributeCount), e.push(t.numDirLights), e.push(t.numPointLights), e.push(t.numSpotLights), e.push(t.numSpotLightMaps), e.push(t.numHemiLights), e.push(t.numRectAreaLights), e.push(t.numDirLightShadows), e.push(t.numPointLightShadows), e.push(t.numSpotLightShadows), e.push(t.numSpotLightShadowsWithMaps), e.push(t.numLightProbes), e.push(t.shadowMapType), e.push(t.toneMapping), e.push(t.numClippingPlanes), e.push(t.numClipIntersection), e.push(t.depthPacking);
            }(n, t), function(e, t) {
                l.disableAll(), t.supportsVertexTextures && l.enable(0);
                t.instancing && l.enable(1);
                t.instancingColor && l.enable(2);
                t.instancingMorph && l.enable(3);
                t.matcap && l.enable(4);
                t.envMap && l.enable(5);
                t.normalMapObjectSpace && l.enable(6);
                t.normalMapTangentSpace && l.enable(7);
                t.clearcoat && l.enable(8);
                t.iridescence && l.enable(9);
                t.alphaTest && l.enable(10);
                t.vertexColors && l.enable(11);
                t.vertexAlphas && l.enable(12);
                t.vertexUv1s && l.enable(13);
                t.vertexUv2s && l.enable(14);
                t.vertexUv3s && l.enable(15);
                t.vertexTangents && l.enable(16);
                t.anisotropy && l.enable(17);
                t.alphaHash && l.enable(18);
                t.batching && l.enable(19);
                t.dispersion && l.enable(20);
                t.batchingColor && l.enable(21);
                t.gradientMap && l.enable(22);
                e.push(l.mask), l.disableAll(), t.fog && l.enable(0);
                t.useFog && l.enable(1);
                t.flatShading && l.enable(2);
                t.logarithmicDepthBuffer && l.enable(3);
                t.reversedDepthBuffer && l.enable(4);
                t.skinning && l.enable(5);
                t.morphTargets && l.enable(6);
                t.morphNormals && l.enable(7);
                t.morphColors && l.enable(8);
                t.premultipliedAlpha && l.enable(9);
                t.shadowMapEnabled && l.enable(10);
                t.doubleSided && l.enable(11);
                t.flipSided && l.enable(12);
                t.useDepthPacking && l.enable(13);
                t.dithering && l.enable(14);
                t.transmission && l.enable(15);
                t.sheen && l.enable(16);
                t.opaque && l.enable(17);
                t.pointsUvs && l.enable(18);
                t.decodeVideoTexture && l.enable(19);
                t.decodeVideoTextureEmissive && l.enable(20);
                t.alphaToCoverage && l.enable(21);
                e.push(l.mask);
            }(n, t), n.push(e.outputColorSpace)), n.push(t.customProgramCacheKey), n.join();
        },
        getUniforms: function(e) {
            const t = v[e.type];
            let n;
            if (t) {
                const e = $5292c45f2b641b96$export$bee4a7d47f8f5014[t];
                n = (0, $4a792688e08e5cd7$export$d8ecdf8615bfea69).clone(e.uniforms);
            } else n = e.uniforms;
            return n;
        },
        acquireProgram: function(t, n) {
            let i;
            for(let e = 0, t = f.length; e < t; e++){
                const t = f[e];
                if (t.cacheKey === n) {
                    i = t, ++i.usedTimes;
                    break;
                }
            }
            return void 0 === i && (i = new $5292c45f2b641b96$var$Fr(e, n, t, o), f.push(i)), i;
        },
        releaseProgram: function(e) {
            if (0 === --e.usedTimes) {
                const t = f.indexOf(e);
                f[t] = f[f.length - 1], f.pop(), e.destroy();
            }
        },
        releaseShaderCache: function(e) {
            d.remove(e);
        },
        programs: f,
        dispose: function() {
            d.dispose();
        }
    };
}
function $5292c45f2b641b96$var$zr() {
    let e = new WeakMap;
    return {
        has: function(t) {
            return e.has(t);
        },
        get: function(t) {
            let n = e.get(t);
            return void 0 === n && (n = {}, e.set(t, n)), n;
        },
        remove: function(t) {
            e.delete(t);
        },
        update: function(t, n, i) {
            e.get(t)[n] = i;
        },
        dispose: function() {
            e = new WeakMap;
        }
    };
}
function $5292c45f2b641b96$var$kr(e, t) {
    return e.groupOrder !== t.groupOrder ? e.groupOrder - t.groupOrder : e.renderOrder !== t.renderOrder ? e.renderOrder - t.renderOrder : e.material.id !== t.material.id ? e.material.id - t.material.id : e.z !== t.z ? e.z - t.z : e.id - t.id;
}
function $5292c45f2b641b96$var$Wr(e, t) {
    return e.groupOrder !== t.groupOrder ? e.groupOrder - t.groupOrder : e.renderOrder !== t.renderOrder ? e.renderOrder - t.renderOrder : e.z !== t.z ? t.z - e.z : e.id - t.id;
}
function $5292c45f2b641b96$var$Xr() {
    const e = [];
    let t = 0;
    const n = [], i = [], r = [];
    function a(n, i, r, a, o, s) {
        let l = e[t];
        return void 0 === l ? (l = {
            id: n.id,
            object: n,
            geometry: i,
            material: r,
            groupOrder: a,
            renderOrder: n.renderOrder,
            z: o,
            group: s
        }, e[t] = l) : (l.id = n.id, l.object = n, l.geometry = i, l.material = r, l.groupOrder = a, l.renderOrder = n.renderOrder, l.z = o, l.group = s), t++, l;
    }
    return {
        opaque: n,
        transmissive: i,
        transparent: r,
        init: function() {
            t = 0, n.length = 0, i.length = 0, r.length = 0;
        },
        push: function(e, t, o, s, l, c) {
            const d = a(e, t, o, s, l, c);
            o.transmission > 0 ? i.push(d) : !0 === o.transparent ? r.push(d) : n.push(d);
        },
        unshift: function(e, t, o, s, l, c) {
            const d = a(e, t, o, s, l, c);
            o.transmission > 0 ? i.unshift(d) : !0 === o.transparent ? r.unshift(d) : n.unshift(d);
        },
        finish: function() {
            for(let n = t, i = e.length; n < i; n++){
                const t = e[n];
                if (null === t.id) break;
                t.id = null, t.object = null, t.geometry = null, t.material = null, t.group = null;
            }
        },
        sort: function(e, t) {
            n.length > 1 && n.sort(e || $5292c45f2b641b96$var$kr), i.length > 1 && i.sort(t || $5292c45f2b641b96$var$Wr), r.length > 1 && r.sort(t || $5292c45f2b641b96$var$Wr);
        }
    };
}
function $5292c45f2b641b96$var$Yr() {
    let e = new WeakMap;
    return {
        get: function(t, n) {
            const i = e.get(t);
            let r;
            return void 0 === i ? (r = new $5292c45f2b641b96$var$Xr, e.set(t, [
                r
            ])) : n >= i.length ? (r = new $5292c45f2b641b96$var$Xr, i.push(r)) : r = i[n], r;
        },
        dispose: function() {
            e = new WeakMap;
        }
    };
}
function $5292c45f2b641b96$var$Kr() {
    const e = {};
    return {
        get: function(t) {
            if (void 0 !== e[t.id]) return e[t.id];
            let i;
            switch(t.type){
                case "DirectionalLight":
                    i = {
                        direction: new (0, $4a792688e08e5cd7$export$64b5c384219d3699),
                        color: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)
                    };
                    break;
                case "SpotLight":
                    i = {
                        position: new (0, $4a792688e08e5cd7$export$64b5c384219d3699),
                        direction: new (0, $4a792688e08e5cd7$export$64b5c384219d3699),
                        color: new (0, $4a792688e08e5cd7$export$892596cec99bc70e),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    i = {
                        position: new (0, $4a792688e08e5cd7$export$64b5c384219d3699),
                        color: new (0, $4a792688e08e5cd7$export$892596cec99bc70e),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    i = {
                        direction: new (0, $4a792688e08e5cd7$export$64b5c384219d3699),
                        skyColor: new (0, $4a792688e08e5cd7$export$892596cec99bc70e),
                        groundColor: new (0, $4a792688e08e5cd7$export$892596cec99bc70e)
                    };
                    break;
                case "RectAreaLight":
                    i = {
                        color: new (0, $4a792688e08e5cd7$export$892596cec99bc70e),
                        position: new (0, $4a792688e08e5cd7$export$64b5c384219d3699),
                        halfWidth: new (0, $4a792688e08e5cd7$export$64b5c384219d3699),
                        halfHeight: new (0, $4a792688e08e5cd7$export$64b5c384219d3699)
                    };
            }
            return e[t.id] = i, i;
        }
    };
}
let $5292c45f2b641b96$var$qr = 0;
function $5292c45f2b641b96$var$jr(e, t) {
    return (t.castShadow ? 2 : 0) - (e.castShadow ? 2 : 0) + (t.map ? 1 : 0) - (e.map ? 1 : 0);
}
function $5292c45f2b641b96$var$Zr(e) {
    const n = new $5292c45f2b641b96$var$Kr, i = function() {
        const e = {};
        return {
            get: function(n) {
                if (void 0 !== e[n.id]) return e[n.id];
                let i;
                switch(n.type){
                    case "DirectionalLight":
                    case "SpotLight":
                        i = {
                            shadowIntensity: 1,
                            shadowBias: 0,
                            shadowNormalBias: 0,
                            shadowRadius: 1,
                            shadowMapSize: new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1)
                        };
                        break;
                    case "PointLight":
                        i = {
                            shadowIntensity: 1,
                            shadowBias: 0,
                            shadowNormalBias: 0,
                            shadowRadius: 1,
                            shadowMapSize: new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1),
                            shadowCameraNear: 1,
                            shadowCameraFar: 1e3
                        };
                }
                return e[n.id] = i, i;
            }
        };
    }(), a = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let e = 0; e < 9; e++)a.probe.push(new (0, $4a792688e08e5cd7$export$64b5c384219d3699));
    const o = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), s = new (0, $4a792688e08e5cd7$export$2ae72fc923e5eb5), l = new (0, $4a792688e08e5cd7$export$2ae72fc923e5eb5);
    return {
        setup: function(t) {
            let r = 0, o = 0, s = 0;
            for(let e = 0; e < 9; e++)a.probe[e].set(0, 0, 0);
            let l = 0, c = 0, d = 0, u = 0, f = 0, p = 0, m = 0, h = 0, _ = 0, g = 0, v = 0;
            t.sort($5292c45f2b641b96$var$jr);
            for(let e = 0, E = t.length; e < E; e++){
                const E = t[e], S = E.color, T = E.intensity, M = E.distance, x = E.shadow && E.shadow.map ? E.shadow.map.texture : null;
                if (E.isAmbientLight) r += S.r * T, o += S.g * T, s += S.b * T;
                else if (E.isLightProbe) {
                    for(let e = 0; e < 9; e++)a.probe[e].addScaledVector(E.sh.coefficients[e], T);
                    v++;
                } else if (E.isDirectionalLight) {
                    const e = n.get(E);
                    if (e.color.copy(E.color).multiplyScalar(E.intensity), E.castShadow) {
                        const e = E.shadow, t = i.get(E);
                        t.shadowIntensity = e.intensity, t.shadowBias = e.bias, t.shadowNormalBias = e.normalBias, t.shadowRadius = e.radius, t.shadowMapSize = e.mapSize, a.directionalShadow[l] = t, a.directionalShadowMap[l] = x, a.directionalShadowMatrix[l] = E.shadow.matrix, p++;
                    }
                    a.directional[l] = e, l++;
                } else if (E.isSpotLight) {
                    const e = n.get(E);
                    e.position.setFromMatrixPosition(E.matrixWorld), e.color.copy(S).multiplyScalar(T), e.distance = M, e.coneCos = Math.cos(E.angle), e.penumbraCos = Math.cos(E.angle * (1 - E.penumbra)), e.decay = E.decay, a.spot[d] = e;
                    const t = E.shadow;
                    if (E.map && (a.spotLightMap[_] = E.map, _++, t.updateMatrices(E), E.castShadow && g++), a.spotLightMatrix[d] = t.matrix, E.castShadow) {
                        const e = i.get(E);
                        e.shadowIntensity = t.intensity, e.shadowBias = t.bias, e.shadowNormalBias = t.normalBias, e.shadowRadius = t.radius, e.shadowMapSize = t.mapSize, a.spotShadow[d] = e, a.spotShadowMap[d] = x, h++;
                    }
                    d++;
                } else if (E.isRectAreaLight) {
                    const e = n.get(E);
                    e.color.copy(S).multiplyScalar(T), e.halfWidth.set(.5 * E.width, 0, 0), e.halfHeight.set(0, .5 * E.height, 0), a.rectArea[u] = e, u++;
                } else if (E.isPointLight) {
                    const e = n.get(E);
                    if (e.color.copy(E.color).multiplyScalar(E.intensity), e.distance = E.distance, e.decay = E.decay, E.castShadow) {
                        const e = E.shadow, t = i.get(E);
                        t.shadowIntensity = e.intensity, t.shadowBias = e.bias, t.shadowNormalBias = e.normalBias, t.shadowRadius = e.radius, t.shadowMapSize = e.mapSize, t.shadowCameraNear = e.camera.near, t.shadowCameraFar = e.camera.far, a.pointShadow[c] = t, a.pointShadowMap[c] = x, a.pointShadowMatrix[c] = E.shadow.matrix, m++;
                    }
                    a.point[c] = e, c++;
                } else if (E.isHemisphereLight) {
                    const e = n.get(E);
                    e.skyColor.copy(E.color).multiplyScalar(T), e.groundColor.copy(E.groundColor).multiplyScalar(T), a.hemi[f] = e, f++;
                }
            }
            u > 0 && (!0 === e.has("OES_texture_float_linear") ? (a.rectAreaLTC1 = $5292c45f2b641b96$export$6643083551874bf5.LTC_FLOAT_1, a.rectAreaLTC2 = $5292c45f2b641b96$export$6643083551874bf5.LTC_FLOAT_2) : (a.rectAreaLTC1 = $5292c45f2b641b96$export$6643083551874bf5.LTC_HALF_1, a.rectAreaLTC2 = $5292c45f2b641b96$export$6643083551874bf5.LTC_HALF_2)), a.ambient[0] = r, a.ambient[1] = o, a.ambient[2] = s;
            const E = a.hash;
            E.directionalLength === l && E.pointLength === c && E.spotLength === d && E.rectAreaLength === u && E.hemiLength === f && E.numDirectionalShadows === p && E.numPointShadows === m && E.numSpotShadows === h && E.numSpotMaps === _ && E.numLightProbes === v || (a.directional.length = l, a.spot.length = d, a.rectArea.length = u, a.point.length = c, a.hemi.length = f, a.directionalShadow.length = p, a.directionalShadowMap.length = p, a.pointShadow.length = m, a.pointShadowMap.length = m, a.spotShadow.length = h, a.spotShadowMap.length = h, a.directionalShadowMatrix.length = p, a.pointShadowMatrix.length = m, a.spotLightMatrix.length = h + _ - g, a.spotLightMap.length = _, a.numSpotLightShadowsWithMaps = g, a.numLightProbes = v, E.directionalLength = l, E.pointLength = c, E.spotLength = d, E.rectAreaLength = u, E.hemiLength = f, E.numDirectionalShadows = p, E.numPointShadows = m, E.numSpotShadows = h, E.numSpotMaps = _, E.numLightProbes = v, a.version = $5292c45f2b641b96$var$qr++);
        },
        setupView: function(e, t) {
            let n = 0, i = 0, r = 0, c = 0, d = 0;
            const u = t.matrixWorldInverse;
            for(let t = 0, f = e.length; t < f; t++){
                const f = e[t];
                if (f.isDirectionalLight) {
                    const e = a.directional[n];
                    e.direction.setFromMatrixPosition(f.matrixWorld), o.setFromMatrixPosition(f.target.matrixWorld), e.direction.sub(o), e.direction.transformDirection(u), n++;
                } else if (f.isSpotLight) {
                    const e = a.spot[r];
                    e.position.setFromMatrixPosition(f.matrixWorld), e.position.applyMatrix4(u), e.direction.setFromMatrixPosition(f.matrixWorld), o.setFromMatrixPosition(f.target.matrixWorld), e.direction.sub(o), e.direction.transformDirection(u), r++;
                } else if (f.isRectAreaLight) {
                    const e = a.rectArea[c];
                    e.position.setFromMatrixPosition(f.matrixWorld), e.position.applyMatrix4(u), l.identity(), s.copy(f.matrixWorld), s.premultiply(u), l.extractRotation(s), e.halfWidth.set(.5 * f.width, 0, 0), e.halfHeight.set(0, .5 * f.height, 0), e.halfWidth.applyMatrix4(l), e.halfHeight.applyMatrix4(l), c++;
                } else if (f.isPointLight) {
                    const e = a.point[i];
                    e.position.setFromMatrixPosition(f.matrixWorld), e.position.applyMatrix4(u), i++;
                } else if (f.isHemisphereLight) {
                    const e = a.hemi[d];
                    e.direction.setFromMatrixPosition(f.matrixWorld), e.direction.transformDirection(u), d++;
                }
            }
        },
        state: a
    };
}
function $5292c45f2b641b96$var$$r(e) {
    const t = new $5292c45f2b641b96$var$Zr(e), n = [], i = [];
    const r = {
        lightsArray: n,
        shadowsArray: i,
        camera: null,
        lights: t,
        transmissionRenderTarget: {}
    };
    return {
        init: function(e) {
            r.camera = e, n.length = 0, i.length = 0;
        },
        state: r,
        setupLights: function() {
            t.setup(n);
        },
        setupLightsView: function(e) {
            t.setupView(n, e);
        },
        pushLight: function(e) {
            n.push(e);
        },
        pushShadow: function(e) {
            i.push(e);
        }
    };
}
function $5292c45f2b641b96$var$Qr(e) {
    let t = new WeakMap;
    return {
        get: function(n, i = 0) {
            const r = t.get(n);
            let a;
            return void 0 === r ? (a = new $5292c45f2b641b96$var$$r(e), t.set(n, [
                a
            ])) : i >= r.length ? (a = new $5292c45f2b641b96$var$$r(e), r.push(a)) : a = r[i], a;
        },
        dispose: function() {
            t = new WeakMap;
        }
    };
}
function $5292c45f2b641b96$var$Jr(e, n, i) {
    let r = new (0, $4a792688e08e5cd7$export$35efe6f4c85463d2);
    const a = new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1), s = new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1), d = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3), u = new (0, $4a792688e08e5cd7$export$2698c22ec13825db)({
        depthPacking: (0, $4a792688e08e5cd7$export$8f910f4c4f73df11)
    }), f = new (0, $4a792688e08e5cd7$export$33e187ed002f2a19), p = {}, m = i.maxTextureSize, h = {
        [(0, $4a792688e08e5cd7$export$2ede184fc2998901)]: (0, $4a792688e08e5cd7$export$d9f0486e75b5ace),
        [(0, $4a792688e08e5cd7$export$d9f0486e75b5ace)]: (0, $4a792688e08e5cd7$export$2ede184fc2998901),
        [(0, $4a792688e08e5cd7$export$3b296b6f144d5b03)]: (0, $4a792688e08e5cd7$export$3b296b6f144d5b03)
    }, g = new (0, $4a792688e08e5cd7$export$83c7d75d550a8b0d)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1)
            },
            radius: {
                value: 4
            }
        },
        vertexShader: "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}",
        fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
    }), v = g.clone();
    v.defines.HORIZONTAL_PASS = 1;
    const S = new (0, $4a792688e08e5cd7$export$b7be63a67df8959);
    S.setAttribute("position", new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(new Float32Array([
        -1,
        -1,
        .5,
        3,
        -1,
        .5,
        -1,
        3,
        .5
    ]), 3));
    const T = new (0, $4a792688e08e5cd7$export$e176487c05830cc5)(S, g), M = this;
    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = (0, $4a792688e08e5cd7$export$5813f879eee7cd88);
    let x = this.type;
    function A(t, i) {
        const r = n.update(T);
        g.defines.VSM_SAMPLES !== t.blurSamples && (g.defines.VSM_SAMPLES = t.blurSamples, v.defines.VSM_SAMPLES = t.blurSamples, g.needsUpdate = !0, v.needsUpdate = !0), null === t.mapPass && (t.mapPass = new (0, $4a792688e08e5cd7$export$3c052beb2e51e23f)(a.x, a.y)), g.uniforms.shadow_pass.value = t.map.texture, g.uniforms.resolution.value = t.mapSize, g.uniforms.radius.value = t.radius, e.setRenderTarget(t.mapPass), e.clear(), e.renderBufferDirect(i, null, r, g, T, null), v.uniforms.shadow_pass.value = t.mapPass.texture, v.uniforms.resolution.value = t.mapSize, v.uniforms.radius.value = t.radius, e.setRenderTarget(t.map), e.clear(), e.renderBufferDirect(i, null, r, v, T, null);
    }
    function R(t, n, i, r) {
        let a = null;
        const o = !0 === i.isPointLight ? t.customDistanceMaterial : t.customDepthMaterial;
        if (void 0 !== o) a = o;
        else if (a = !0 === i.isPointLight ? f : u, e.localClippingEnabled && !0 === n.clipShadows && Array.isArray(n.clippingPlanes) && 0 !== n.clippingPlanes.length || n.displacementMap && 0 !== n.displacementScale || n.alphaMap && n.alphaTest > 0 || n.map && n.alphaTest > 0 || !0 === n.alphaToCoverage) {
            const e = a.uuid, t = n.uuid;
            let i = p[e];
            void 0 === i && (i = {}, p[e] = i);
            let r = i[t];
            void 0 === r && (r = a.clone(), i[t] = r, n.addEventListener("dispose", C)), a = r;
        }
        if (a.visible = n.visible, a.wireframe = n.wireframe, a.side = r === (0, $4a792688e08e5cd7$export$896ae1ade6c829c4) ? null !== n.shadowSide ? n.shadowSide : n.side : null !== n.shadowSide ? n.shadowSide : h[n.side], a.alphaMap = n.alphaMap, a.alphaTest = !0 === n.alphaToCoverage ? .5 : n.alphaTest, a.map = n.map, a.clipShadows = n.clipShadows, a.clippingPlanes = n.clippingPlanes, a.clipIntersection = n.clipIntersection, a.displacementMap = n.displacementMap, a.displacementScale = n.displacementScale, a.displacementBias = n.displacementBias, a.wireframeLinewidth = n.wireframeLinewidth, a.linewidth = n.linewidth, !0 === i.isPointLight && !0 === a.isMeshDistanceMaterial) e.properties.get(a).light = i;
        return a;
    }
    function b(t, i, a, o, s) {
        if (!1 === t.visible) return;
        if (t.layers.test(i.layers) && (t.isMesh || t.isLine || t.isPoints) && (t.castShadow || t.receiveShadow && s === (0, $4a792688e08e5cd7$export$896ae1ade6c829c4)) && (!t.frustumCulled || r.intersectsObject(t))) {
            t.modelViewMatrix.multiplyMatrices(a.matrixWorldInverse, t.matrixWorld);
            const r = n.update(t), l = t.material;
            if (Array.isArray(l)) {
                const n = r.groups;
                for(let c = 0, d = n.length; c < d; c++){
                    const d = n[c], u = l[d.materialIndex];
                    if (u && u.visible) {
                        const n = R(t, u, o, s);
                        t.onBeforeShadow(e, t, i, a, r, n, d), e.renderBufferDirect(a, null, r, n, t, d), t.onAfterShadow(e, t, i, a, r, n, d);
                    }
                }
            } else if (l.visible) {
                const n = R(t, l, o, s);
                t.onBeforeShadow(e, t, i, a, r, n, null), e.renderBufferDirect(a, null, r, n, t, null), t.onAfterShadow(e, t, i, a, r, n, null);
            }
        }
        const l = t.children;
        for(let e = 0, t = l.length; e < t; e++)b(l[e], i, a, o, s);
    }
    function C(e) {
        e.target.removeEventListener("dispose", C);
        for(const t in p){
            const n = p[t], i = e.target.uuid;
            if (i in n) n[i].dispose(), delete n[i];
        }
    }
    this.render = function(t, n, i) {
        if (!1 === M.enabled) return;
        if (!1 === M.autoUpdate && !1 === M.needsUpdate) return;
        if (0 === t.length) return;
        const o = e.getRenderTarget(), l = e.getActiveCubeFace(), c = e.getActiveMipmapLevel(), u = e.state;
        u.setBlending((0, $4a792688e08e5cd7$export$63b8d6b580fc65ba)), !0 === u.buffers.depth.getReversed() ? u.buffers.color.setClear(0, 0, 0, 0) : u.buffers.color.setClear(1, 1, 1, 1), u.buffers.depth.setTest(!0), u.setScissorTest(!1);
        const f = x !== (0, $4a792688e08e5cd7$export$896ae1ade6c829c4) && this.type === (0, $4a792688e08e5cd7$export$896ae1ade6c829c4), p = x === (0, $4a792688e08e5cd7$export$896ae1ade6c829c4) && this.type !== (0, $4a792688e08e5cd7$export$896ae1ade6c829c4);
        for(let o = 0, l = t.length; o < l; o++){
            const l = t[o], c = l.shadow;
            if (void 0 === c) {
                (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLShadowMap:", l, "has no shadow.");
                continue;
            }
            if (!1 === c.autoUpdate && !1 === c.needsUpdate) continue;
            a.copy(c.mapSize);
            const h = c.getFrameExtents();
            if (a.multiply(h), s.copy(c.mapSize), (a.x > m || a.y > m) && (a.x > m && (s.x = Math.floor(m / h.x), a.x = s.x * h.x, c.mapSize.x = s.x), a.y > m && (s.y = Math.floor(m / h.y), a.y = s.y * h.y, c.mapSize.y = s.y)), null === c.map || !0 === f || !0 === p) {
                const e = this.type !== (0, $4a792688e08e5cd7$export$896ae1ade6c829c4) ? {
                    minFilter: (0, $4a792688e08e5cd7$export$727aa5ec3fe39bf0),
                    magFilter: (0, $4a792688e08e5cd7$export$727aa5ec3fe39bf0)
                } : {};
                null !== c.map && c.map.dispose(), c.map = new (0, $4a792688e08e5cd7$export$3c052beb2e51e23f)(a.x, a.y, e), c.map.texture.name = l.name + ".shadowMap", c.camera.updateProjectionMatrix();
            }
            e.setRenderTarget(c.map), e.clear();
            const _ = c.getViewportCount();
            for(let e = 0; e < _; e++){
                const t = c.getViewport(e);
                d.set(s.x * t.x, s.y * t.y, s.x * t.z, s.y * t.w), u.viewport(d), c.updateMatrices(l, e), r = c.getFrustum(), b(n, i, c.camera, l, this.type);
            }
            !0 !== c.isPointLightShadow && this.type === (0, $4a792688e08e5cd7$export$896ae1ade6c829c4) && A(c, i), c.needsUpdate = !1;
        }
        x = this.type, M.needsUpdate = !1, e.setRenderTarget(o, l, c);
    };
}
const $5292c45f2b641b96$var$ea = {
    [(0, $4a792688e08e5cd7$export$69025ce147cee220)]: (0, $4a792688e08e5cd7$export$7182eb52ea3b3f04),
    [(0, $4a792688e08e5cd7$export$eedccec66ab7ebe)]: (0, $4a792688e08e5cd7$export$c5e2c52991f30937),
    [(0, $4a792688e08e5cd7$export$a60d398fc7b7590e)]: (0, $4a792688e08e5cd7$export$2f843afa843d8916),
    [(0, $4a792688e08e5cd7$export$296f78a0b892f81a)]: (0, $4a792688e08e5cd7$export$7d7234c1240a1fc4),
    [(0, $4a792688e08e5cd7$export$7182eb52ea3b3f04)]: (0, $4a792688e08e5cd7$export$69025ce147cee220),
    [(0, $4a792688e08e5cd7$export$c5e2c52991f30937)]: (0, $4a792688e08e5cd7$export$eedccec66ab7ebe),
    [(0, $4a792688e08e5cd7$export$2f843afa843d8916)]: (0, $4a792688e08e5cd7$export$a60d398fc7b7590e),
    [(0, $4a792688e08e5cd7$export$7d7234c1240a1fc4)]: (0, $4a792688e08e5cd7$export$296f78a0b892f81a)
};
function $5292c45f2b641b96$var$ta(e, t) {
    const i = new function() {
        let t = !1;
        const n = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3);
        let i = null;
        const r = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3)(0, 0, 0, 0);
        return {
            setMask: function(n) {
                i === n || t || (e.colorMask(n, n, n, n), i = n);
            },
            setLocked: function(e) {
                t = e;
            },
            setClear: function(t, i, a, o, s) {
                !0 === s && (t *= o, i *= o, a *= o), n.set(t, i, a, o), !1 === r.equals(n) && (e.clearColor(t, i, a, o), r.copy(n));
            },
            reset: function() {
                t = !1, i = null, r.set(-1, 0, 0, 0);
            }
        };
    }, r = new function() {
        let n = !1, i = !1, r = null, a = null, o = null;
        return {
            setReversed: function(e) {
                if (i !== e) {
                    const n = t.get("EXT_clip_control");
                    e ? n.clipControlEXT(n.LOWER_LEFT_EXT, n.ZERO_TO_ONE_EXT) : n.clipControlEXT(n.LOWER_LEFT_EXT, n.NEGATIVE_ONE_TO_ONE_EXT), i = e;
                    const r = o;
                    o = null, this.setClear(r);
                }
            },
            getReversed: function() {
                return i;
            },
            setTest: function(t) {
                t ? W(e.DEPTH_TEST) : Y(e.DEPTH_TEST);
            },
            setMask: function(t) {
                r === t || n || (e.depthMask(t), r = t);
            },
            setFunc: function(t) {
                if (i && (t = $5292c45f2b641b96$var$ea[t]), a !== t) {
                    switch(t){
                        case 0, $4a792688e08e5cd7$export$69025ce147cee220:
                            e.depthFunc(e.NEVER);
                            break;
                        case 0, $4a792688e08e5cd7$export$7182eb52ea3b3f04:
                            e.depthFunc(e.ALWAYS);
                            break;
                        case 0, $4a792688e08e5cd7$export$eedccec66ab7ebe:
                            e.depthFunc(e.LESS);
                            break;
                        case 0, $4a792688e08e5cd7$export$296f78a0b892f81a:
                            e.depthFunc(e.LEQUAL);
                            break;
                        case 0, $4a792688e08e5cd7$export$a60d398fc7b7590e:
                            e.depthFunc(e.EQUAL);
                            break;
                        case 0, $4a792688e08e5cd7$export$7d7234c1240a1fc4:
                            e.depthFunc(e.GEQUAL);
                            break;
                        case 0, $4a792688e08e5cd7$export$c5e2c52991f30937:
                            e.depthFunc(e.GREATER);
                            break;
                        case 0, $4a792688e08e5cd7$export$2f843afa843d8916:
                            e.depthFunc(e.NOTEQUAL);
                            break;
                        default:
                            e.depthFunc(e.LEQUAL);
                    }
                    a = t;
                }
            },
            setLocked: function(e) {
                n = e;
            },
            setClear: function(t) {
                o !== t && (i && (t = 1 - t), e.clearDepth(t), o = t);
            },
            reset: function() {
                n = !1, r = null, a = null, o = null, i = !1;
            }
        };
    }, a = new function() {
        let t = !1, n = null, i = null, r = null, a = null, o = null, s = null, l = null, c = null;
        return {
            setTest: function(n) {
                t || (n ? W(e.STENCIL_TEST) : Y(e.STENCIL_TEST));
            },
            setMask: function(i) {
                n === i || t || (e.stencilMask(i), n = i);
            },
            setFunc: function(t, n, o) {
                i === t && r === n && a === o || (e.stencilFunc(t, n, o), i = t, r = n, a = o);
            },
            setOp: function(t, n, i) {
                o === t && s === n && l === i || (e.stencilOp(t, n, i), o = t, s = n, l = i);
            },
            setLocked: function(e) {
                t = e;
            },
            setClear: function(t) {
                c !== t && (e.clearStencil(t), c = t);
            },
            reset: function() {
                t = !1, n = null, i = null, r = null, a = null, o = null, s = null, l = null, c = null;
            }
        };
    }, o = new WeakMap, s = new WeakMap;
    let l = {}, d = {}, u = new WeakMap, f = [], p = null, m = !1, h = null, _ = null, g = null, v = null, E = null, S = null, T = null, M = new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0, 0, 0), x = 0, A = !1, R = null, b = null, C = null, L = null, P = null;
    const U = e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let D = !1, w = 0;
    const y = e.getParameter(e.VERSION);
    -1 !== y.indexOf("WebGL") ? (w = parseFloat(/^WebGL (\d)/.exec(y)[1]), D = w >= 1) : -1 !== y.indexOf("OpenGL ES") && (w = parseFloat(/^OpenGL ES (\d)/.exec(y)[1]), D = w >= 2);
    let I = null, F = {};
    const B = e.getParameter(e.SCISSOR_BOX), G = e.getParameter(e.VIEWPORT), H = (new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3)).fromArray(B), V = (new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3)).fromArray(G);
    function z(t, n, i, r) {
        const a = new Uint8Array(4), o = e.createTexture();
        e.bindTexture(t, o), e.texParameteri(t, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(t, e.TEXTURE_MAG_FILTER, e.NEAREST);
        for(let o = 0; o < i; o++)t === e.TEXTURE_3D || t === e.TEXTURE_2D_ARRAY ? e.texImage3D(n, 0, e.RGBA, 1, 1, r, 0, e.RGBA, e.UNSIGNED_BYTE, a) : e.texImage2D(n + o, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, a);
        return o;
    }
    const k = {};
    function W(t) {
        !0 !== l[t] && (e.enable(t), l[t] = !0);
    }
    function Y(t) {
        !1 !== l[t] && (e.disable(t), l[t] = !1);
    }
    k[e.TEXTURE_2D] = z(e.TEXTURE_2D, e.TEXTURE_2D, 1), k[e.TEXTURE_CUBE_MAP] = z(e.TEXTURE_CUBE_MAP, e.TEXTURE_CUBE_MAP_POSITIVE_X, 6), k[e.TEXTURE_2D_ARRAY] = z(e.TEXTURE_2D_ARRAY, e.TEXTURE_2D_ARRAY, 1, 1), k[e.TEXTURE_3D] = z(e.TEXTURE_3D, e.TEXTURE_3D, 1, 1), i.setClear(0, 0, 0, 1), r.setClear(1), a.setClear(0), W(e.DEPTH_TEST), r.setFunc((0, $4a792688e08e5cd7$export$296f78a0b892f81a)), Z(!1), $((0, $4a792688e08e5cd7$export$b9a7b4fc5cb15f9b)), W(e.CULL_FACE), j((0, $4a792688e08e5cd7$export$63b8d6b580fc65ba));
    const K = {
        [(0, $4a792688e08e5cd7$export$20183a0484ce21a0)]: e.FUNC_ADD,
        [(0, $4a792688e08e5cd7$export$73e0df5177988548)]: e.FUNC_SUBTRACT,
        [(0, $4a792688e08e5cd7$export$28e582859cbec660)]: e.FUNC_REVERSE_SUBTRACT
    };
    K[0, $4a792688e08e5cd7$export$c8c1508da8d0600c] = e.MIN, K[0, $4a792688e08e5cd7$export$99948c02fb51055f] = e.MAX;
    const q = {
        [(0, $4a792688e08e5cd7$export$2110f05edf778d3d)]: e.ZERO,
        [(0, $4a792688e08e5cd7$export$8805bad65e24940e)]: e.ONE,
        [(0, $4a792688e08e5cd7$export$7fbe15b28d28cf52)]: e.SRC_COLOR,
        [(0, $4a792688e08e5cd7$export$d5773124e86cf28c)]: e.SRC_ALPHA,
        [(0, $4a792688e08e5cd7$export$c05e2a1fc8609506)]: e.SRC_ALPHA_SATURATE,
        [(0, $4a792688e08e5cd7$export$ef5f2dd8ffac5574)]: e.DST_COLOR,
        [(0, $4a792688e08e5cd7$export$a78aed1ca2a87192)]: e.DST_ALPHA,
        [(0, $4a792688e08e5cd7$export$947829af9f2c17f6)]: e.ONE_MINUS_SRC_COLOR,
        [(0, $4a792688e08e5cd7$export$11d468cc7f19e971)]: e.ONE_MINUS_SRC_ALPHA,
        [(0, $4a792688e08e5cd7$export$56b85b2686ab16)]: e.ONE_MINUS_DST_COLOR,
        [(0, $4a792688e08e5cd7$export$5d0fe17fd8773bac)]: e.ONE_MINUS_DST_ALPHA,
        [(0, $4a792688e08e5cd7$export$7dd8f434fd59075)]: e.CONSTANT_COLOR,
        [(0, $4a792688e08e5cd7$export$99c8d898a9afbcee)]: e.ONE_MINUS_CONSTANT_COLOR,
        [(0, $4a792688e08e5cd7$export$310cd2be38d13b56)]: e.CONSTANT_ALPHA,
        [(0, $4a792688e08e5cd7$export$db77b8fbcf45dbf4)]: e.ONE_MINUS_CONSTANT_ALPHA
    };
    function j(t, n, i, r, a, o, s, l, c, d) {
        if (t !== (0, $4a792688e08e5cd7$export$63b8d6b580fc65ba)) {
            if (!1 === m && (W(e.BLEND), m = !0), t === (0, $4a792688e08e5cd7$export$eda4864c68df1fa2)) a = a || n, o = o || i, s = s || r, n === _ && a === E || (e.blendEquationSeparate(K[n], K[a]), _ = n, E = a), i === g && r === v && o === S && s === T || (e.blendFuncSeparate(q[i], q[r], q[o], q[s]), g = i, v = r, S = o, T = s), !1 !== l.equals(M) && c === x || (e.blendColor(l.r, l.g, l.b, c), M.copy(l), x = c), h = t, A = !1;
            else if (t !== h || d !== A) {
                if (_ === (0, $4a792688e08e5cd7$export$20183a0484ce21a0) && E === (0, $4a792688e08e5cd7$export$20183a0484ce21a0) || (e.blendEquation(e.FUNC_ADD), _ = (0, $4a792688e08e5cd7$export$20183a0484ce21a0), E = (0, $4a792688e08e5cd7$export$20183a0484ce21a0)), d) switch(t){
                    case 0, $4a792688e08e5cd7$export$5b29a26d96ee6af0:
                        e.blendFuncSeparate(e.ONE, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $4a792688e08e5cd7$export$777d8f9551c2216b:
                        e.blendFunc(e.ONE, e.ONE);
                        break;
                    case 0, $4a792688e08e5cd7$export$cdfa06f868e2e467:
                        e.blendFuncSeparate(e.ZERO, e.ONE_MINUS_SRC_COLOR, e.ZERO, e.ONE);
                        break;
                    case 0, $4a792688e08e5cd7$export$4138e1c684b46a20:
                        e.blendFuncSeparate(e.DST_COLOR, e.ONE_MINUS_SRC_ALPHA, e.ZERO, e.ONE);
                        break;
                    default:
                        (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLState: Invalid blending: ", t);
                }
                else switch(t){
                    case 0, $4a792688e08e5cd7$export$5b29a26d96ee6af0:
                        e.blendFuncSeparate(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $4a792688e08e5cd7$export$777d8f9551c2216b:
                        e.blendFuncSeparate(e.SRC_ALPHA, e.ONE, e.ONE, e.ONE);
                        break;
                    case 0, $4a792688e08e5cd7$export$cdfa06f868e2e467:
                        (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
                        break;
                    case 0, $4a792688e08e5cd7$export$4138e1c684b46a20:
                        (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
                        break;
                    default:
                        (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLState: Invalid blending: ", t);
                }
                g = null, v = null, S = null, T = null, M.set(0, 0, 0), x = 0, h = t, A = d;
            }
        } else !0 === m && (Y(e.BLEND), m = !1);
    }
    function Z(t) {
        R !== t && (t ? e.frontFace(e.CW) : e.frontFace(e.CCW), R = t);
    }
    function $(t) {
        t !== (0, $4a792688e08e5cd7$export$3237e1f2c1ea1f44) ? (W(e.CULL_FACE), t !== b && (t === (0, $4a792688e08e5cd7$export$b9a7b4fc5cb15f9b) ? e.cullFace(e.BACK) : t === (0, $4a792688e08e5cd7$export$b8058bcc7037d3f3) ? e.cullFace(e.FRONT) : e.cullFace(e.FRONT_AND_BACK))) : Y(e.CULL_FACE), b = t;
    }
    function Q(t, n, i) {
        t ? (W(e.POLYGON_OFFSET_FILL), L === n && P === i || (e.polygonOffset(n, i), L = n, P = i)) : Y(e.POLYGON_OFFSET_FILL);
    }
    return {
        buffers: {
            color: i,
            depth: r,
            stencil: a
        },
        enable: W,
        disable: Y,
        bindFramebuffer: function(t, n) {
            return d[t] !== n && (e.bindFramebuffer(t, n), d[t] = n, t === e.DRAW_FRAMEBUFFER && (d[e.FRAMEBUFFER] = n), t === e.FRAMEBUFFER && (d[e.DRAW_FRAMEBUFFER] = n), !0);
        },
        drawBuffers: function(t, n) {
            let i = f, r = !1;
            if (t) {
                i = u.get(n), void 0 === i && (i = [], u.set(n, i));
                const a = t.textures;
                if (i.length !== a.length || i[0] !== e.COLOR_ATTACHMENT0) {
                    for(let t = 0, n = a.length; t < n; t++)i[t] = e.COLOR_ATTACHMENT0 + t;
                    i.length = a.length, r = !0;
                }
            } else i[0] !== e.BACK && (i[0] = e.BACK, r = !0);
            r && e.drawBuffers(i);
        },
        useProgram: function(t) {
            return p !== t && (e.useProgram(t), p = t, !0);
        },
        setBlending: j,
        setMaterial: function(t, n) {
            t.side === (0, $4a792688e08e5cd7$export$3b296b6f144d5b03) ? Y(e.CULL_FACE) : W(e.CULL_FACE);
            let o = t.side === (0, $4a792688e08e5cd7$export$d9f0486e75b5ace);
            n && (o = !o), Z(o), t.blending === (0, $4a792688e08e5cd7$export$5b29a26d96ee6af0) && !1 === t.transparent ? j((0, $4a792688e08e5cd7$export$63b8d6b580fc65ba)) : j(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.blendColor, t.blendAlpha, t.premultipliedAlpha), r.setFunc(t.depthFunc), r.setTest(t.depthTest), r.setMask(t.depthWrite), i.setMask(t.colorWrite);
            const s = t.stencilWrite;
            a.setTest(s), s && (a.setMask(t.stencilWriteMask), a.setFunc(t.stencilFunc, t.stencilRef, t.stencilFuncMask), a.setOp(t.stencilFail, t.stencilZFail, t.stencilZPass)), Q(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits), !0 === t.alphaToCoverage ? W(e.SAMPLE_ALPHA_TO_COVERAGE) : Y(e.SAMPLE_ALPHA_TO_COVERAGE);
        },
        setFlipSided: Z,
        setCullFace: $,
        setLineWidth: function(t) {
            t !== C && (D && e.lineWidth(t), C = t);
        },
        setPolygonOffset: Q,
        setScissorTest: function(t) {
            t ? W(e.SCISSOR_TEST) : Y(e.SCISSOR_TEST);
        },
        activeTexture: function(t) {
            void 0 === t && (t = e.TEXTURE0 + U - 1), I !== t && (e.activeTexture(t), I = t);
        },
        bindTexture: function(t, n, i) {
            void 0 === i && (i = null === I ? e.TEXTURE0 + U - 1 : I);
            let r = F[i];
            void 0 === r && (r = {
                type: void 0,
                texture: void 0
            }, F[i] = r), r.type === t && r.texture === n || (I !== i && (e.activeTexture(i), I = i), e.bindTexture(t, n || k[t]), r.type = t, r.texture = n);
        },
        unbindTexture: function() {
            const t = F[I];
            void 0 !== t && void 0 !== t.type && (e.bindTexture(t.type, null), t.type = void 0, t.texture = void 0);
        },
        compressedTexImage2D: function() {
            try {
                e.compressedTexImage2D(...arguments);
            } catch (e) {
                e("WebGLState:", e);
            }
        },
        compressedTexImage3D: function() {
            try {
                e.compressedTexImage3D(...arguments);
            } catch (e) {
                e("WebGLState:", e);
            }
        },
        texImage2D: function() {
            try {
                e.texImage2D(...arguments);
            } catch (e) {
                e("WebGLState:", e);
            }
        },
        texImage3D: function() {
            try {
                e.texImage3D(...arguments);
            } catch (e) {
                e("WebGLState:", e);
            }
        },
        updateUBOMapping: function(t, n) {
            let i = s.get(n);
            void 0 === i && (i = new WeakMap, s.set(n, i));
            let r = i.get(t);
            void 0 === r && (r = e.getUniformBlockIndex(n, t.name), i.set(t, r));
        },
        uniformBlockBinding: function(t, n) {
            const i = s.get(n).get(t);
            o.get(n) !== i && (e.uniformBlockBinding(n, i, t.__bindingPointIndex), o.set(n, i));
        },
        texStorage2D: function() {
            try {
                e.texStorage2D(...arguments);
            } catch (e) {
                e("WebGLState:", e);
            }
        },
        texStorage3D: function() {
            try {
                e.texStorage3D(...arguments);
            } catch (e) {
                e("WebGLState:", e);
            }
        },
        texSubImage2D: function() {
            try {
                e.texSubImage2D(...arguments);
            } catch (e) {
                e("WebGLState:", e);
            }
        },
        texSubImage3D: function() {
            try {
                e.texSubImage3D(...arguments);
            } catch (e) {
                e("WebGLState:", e);
            }
        },
        compressedTexSubImage2D: function() {
            try {
                e.compressedTexSubImage2D(...arguments);
            } catch (e) {
                e("WebGLState:", e);
            }
        },
        compressedTexSubImage3D: function() {
            try {
                e.compressedTexSubImage3D(...arguments);
            } catch (e) {
                e("WebGLState:", e);
            }
        },
        scissor: function(t) {
            !1 === H.equals(t) && (e.scissor(t.x, t.y, t.z, t.w), H.copy(t));
        },
        viewport: function(t) {
            !1 === V.equals(t) && (e.viewport(t.x, t.y, t.z, t.w), V.copy(t));
        },
        reset: function() {
            e.disable(e.BLEND), e.disable(e.CULL_FACE), e.disable(e.DEPTH_TEST), e.disable(e.POLYGON_OFFSET_FILL), e.disable(e.SCISSOR_TEST), e.disable(e.STENCIL_TEST), e.disable(e.SAMPLE_ALPHA_TO_COVERAGE), e.blendEquation(e.FUNC_ADD), e.blendFunc(e.ONE, e.ZERO), e.blendFuncSeparate(e.ONE, e.ZERO, e.ONE, e.ZERO), e.blendColor(0, 0, 0, 0), e.colorMask(!0, !0, !0, !0), e.clearColor(0, 0, 0, 0), e.depthMask(!0), e.depthFunc(e.LESS), r.setReversed(!1), e.clearDepth(1), e.stencilMask(4294967295), e.stencilFunc(e.ALWAYS, 0, 4294967295), e.stencilOp(e.KEEP, e.KEEP, e.KEEP), e.clearStencil(0), e.cullFace(e.BACK), e.frontFace(e.CCW), e.polygonOffset(0, 0), e.activeTexture(e.TEXTURE0), e.bindFramebuffer(e.FRAMEBUFFER, null), e.bindFramebuffer(e.DRAW_FRAMEBUFFER, null), e.bindFramebuffer(e.READ_FRAMEBUFFER, null), e.useProgram(null), e.lineWidth(1), e.scissor(0, 0, e.canvas.width, e.canvas.height), e.viewport(0, 0, e.canvas.width, e.canvas.height), l = {}, I = null, F = {}, d = {}, u = new WeakMap, f = [], p = null, m = !1, h = null, _ = null, g = null, v = null, E = null, S = null, T = null, M = new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0, 0, 0), x = 0, A = !1, R = null, b = null, C = null, L = null, P = null, H.set(0, 0, e.canvas.width, e.canvas.height), V.set(0, 0, e.canvas.width, e.canvas.height), i.reset(), r.reset(), a.reset();
        }
    };
}
function $5292c45f2b641b96$var$na(e, n, i, r, a, o, s) {
    const l = n.has("WEBGL_multisampled_render_to_texture") ? n.get("WEBGL_multisampled_render_to_texture") : null, c = "undefined" != typeof navigator && /OculusBrowser/g.test(navigator.userAgent), d = new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1), u = new WeakMap;
    let f;
    const h = new WeakMap;
    let _ = !1;
    try {
        _ = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
    } catch (e) {}
    function g(e, t) {
        return _ ? new OffscreenCanvas(e, t) : (0, $4a792688e08e5cd7$export$7094a064528c7fee)("canvas");
    }
    function v(e, t, n) {
        let i = 1;
        const r = ee(e);
        if ((r.width > n || r.height > n) && (i = n / Math.max(r.width, r.height)), i < 1) {
            if ("undefined" != typeof HTMLImageElement && e instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e instanceof ImageBitmap || "undefined" != typeof VideoFrame && e instanceof VideoFrame) {
                const n = Math.floor(i * r.width), a = Math.floor(i * r.height);
                void 0 === f && (f = g(n, a));
                const o = t ? g(n, a) : f;
                o.width = n, o.height = a;
                return o.getContext("2d").drawImage(e, 0, 0, n, a), (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Texture has been resized from (" + r.width + "x" + r.height + ") to (" + n + "x" + a + ")."), o;
            }
            return "data" in e && (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Image in DataTexture is too big (" + r.width + "x" + r.height + ")."), e;
        }
        return e;
    }
    function S(e) {
        return e.generateMipmaps;
    }
    function A(t) {
        e.generateMipmap(t);
    }
    function R(t) {
        return t.isWebGLCubeRenderTarget ? e.TEXTURE_CUBE_MAP : t.isWebGL3DRenderTarget ? e.TEXTURE_3D : t.isWebGLArrayRenderTarget || t.isCompressedArrayTexture ? e.TEXTURE_2D_ARRAY : e.TEXTURE_2D;
    }
    function b(t, i, r, a, o = !1) {
        if (null !== t) {
            if (void 0 !== e[t]) return e[t];
            (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Attempt to use non-existing WebGL internal format '" + t + "'");
        }
        let s = i;
        if (i === e.RED && (r === e.FLOAT && (s = e.R32F), r === e.HALF_FLOAT && (s = e.R16F), r === e.UNSIGNED_BYTE && (s = e.R8)), i === e.RED_INTEGER && (r === e.UNSIGNED_BYTE && (s = e.R8UI), r === e.UNSIGNED_SHORT && (s = e.R16UI), r === e.UNSIGNED_INT && (s = e.R32UI), r === e.BYTE && (s = e.R8I), r === e.SHORT && (s = e.R16I), r === e.INT && (s = e.R32I)), i === e.RG && (r === e.FLOAT && (s = e.RG32F), r === e.HALF_FLOAT && (s = e.RG16F), r === e.UNSIGNED_BYTE && (s = e.RG8)), i === e.RG_INTEGER && (r === e.UNSIGNED_BYTE && (s = e.RG8UI), r === e.UNSIGNED_SHORT && (s = e.RG16UI), r === e.UNSIGNED_INT && (s = e.RG32UI), r === e.BYTE && (s = e.RG8I), r === e.SHORT && (s = e.RG16I), r === e.INT && (s = e.RG32I)), i === e.RGB_INTEGER && (r === e.UNSIGNED_BYTE && (s = e.RGB8UI), r === e.UNSIGNED_SHORT && (s = e.RGB16UI), r === e.UNSIGNED_INT && (s = e.RGB32UI), r === e.BYTE && (s = e.RGB8I), r === e.SHORT && (s = e.RGB16I), r === e.INT && (s = e.RGB32I)), i === e.RGBA_INTEGER && (r === e.UNSIGNED_BYTE && (s = e.RGBA8UI), r === e.UNSIGNED_SHORT && (s = e.RGBA16UI), r === e.UNSIGNED_INT && (s = e.RGBA32UI), r === e.BYTE && (s = e.RGBA8I), r === e.SHORT && (s = e.RGBA16I), r === e.INT && (s = e.RGBA32I)), i === e.RGB && (r === e.UNSIGNED_INT_5_9_9_9_REV && (s = e.RGB9_E5), r === e.UNSIGNED_INT_10F_11F_11F_REV && (s = e.R11F_G11F_B10F)), i === e.RGBA) {
            const t = o ? (0, $4a792688e08e5cd7$export$f197347d588c1b4a) : (0, $4a792688e08e5cd7$export$5e6fd513f44698c).getTransfer(a);
            r === e.FLOAT && (s = e.RGBA32F), r === e.HALF_FLOAT && (s = e.RGBA16F), r === e.UNSIGNED_BYTE && (s = t === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? e.SRGB8_ALPHA8 : e.RGBA8), r === e.UNSIGNED_SHORT_4_4_4_4 && (s = e.RGBA4), r === e.UNSIGNED_SHORT_5_5_5_1 && (s = e.RGB5_A1);
        }
        return s !== e.R16F && s !== e.R32F && s !== e.RG16F && s !== e.RG32F && s !== e.RGBA16F && s !== e.RGBA32F || n.get("EXT_color_buffer_float"), s;
    }
    function C(t, n) {
        let i;
        return t ? null === n || n === (0, $4a792688e08e5cd7$export$c3c7fc4518ebba96) || n === (0, $4a792688e08e5cd7$export$6c8ea339bfab1301) ? i = e.DEPTH24_STENCIL8 : n === (0, $4a792688e08e5cd7$export$f6d331659b644596) ? i = e.DEPTH32F_STENCIL8 : n === (0, $4a792688e08e5cd7$export$c63dc51868b06a9d) && (i = e.DEPTH24_STENCIL8, (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : null === n || n === (0, $4a792688e08e5cd7$export$c3c7fc4518ebba96) || n === (0, $4a792688e08e5cd7$export$6c8ea339bfab1301) ? i = e.DEPTH_COMPONENT24 : n === (0, $4a792688e08e5cd7$export$f6d331659b644596) ? i = e.DEPTH_COMPONENT32F : n === (0, $4a792688e08e5cd7$export$c63dc51868b06a9d) && (i = e.DEPTH_COMPONENT16), i;
    }
    function L(e, t) {
        return !0 === S(e) || e.isFramebufferTexture && e.minFilter !== (0, $4a792688e08e5cd7$export$727aa5ec3fe39bf0) && e.minFilter !== (0, $4a792688e08e5cd7$export$8a72f490b25c56c8) ? Math.log2(Math.max(t.width, t.height)) + 1 : void 0 !== e.mipmaps && e.mipmaps.length > 0 ? e.mipmaps.length : e.isCompressedTexture && Array.isArray(e.image) ? t.mipmaps.length : 1;
    }
    function P(e) {
        const t = e.target;
        t.removeEventListener("dispose", P), function(e) {
            const t = r.get(e);
            if (void 0 === t.__webglInit) return;
            const n = e.source, i = h.get(n);
            if (i) {
                const r = i[t.__cacheKey];
                r.usedTimes--, 0 === r.usedTimes && D(e), 0 === Object.keys(i).length && h.delete(n);
            }
            r.remove(e);
        }(t), t.isVideoTexture && u.delete(t);
    }
    function U(t) {
        const n = t.target;
        n.removeEventListener("dispose", U), function(t) {
            const n = r.get(t);
            t.depthTexture && (t.depthTexture.dispose(), r.remove(t.depthTexture));
            if (t.isWebGLCubeRenderTarget) for(let t = 0; t < 6; t++){
                if (Array.isArray(n.__webglFramebuffer[t])) for(let i = 0; i < n.__webglFramebuffer[t].length; i++)e.deleteFramebuffer(n.__webglFramebuffer[t][i]);
                else e.deleteFramebuffer(n.__webglFramebuffer[t]);
                n.__webglDepthbuffer && e.deleteRenderbuffer(n.__webglDepthbuffer[t]);
            }
            else {
                if (Array.isArray(n.__webglFramebuffer)) for(let t = 0; t < n.__webglFramebuffer.length; t++)e.deleteFramebuffer(n.__webglFramebuffer[t]);
                else e.deleteFramebuffer(n.__webglFramebuffer);
                if (n.__webglDepthbuffer && e.deleteRenderbuffer(n.__webglDepthbuffer), n.__webglMultisampledFramebuffer && e.deleteFramebuffer(n.__webglMultisampledFramebuffer), n.__webglColorRenderbuffer) for(let t = 0; t < n.__webglColorRenderbuffer.length; t++)n.__webglColorRenderbuffer[t] && e.deleteRenderbuffer(n.__webglColorRenderbuffer[t]);
                n.__webglDepthRenderbuffer && e.deleteRenderbuffer(n.__webglDepthRenderbuffer);
            }
            const i = t.textures;
            for(let t = 0, n = i.length; t < n; t++){
                const n = r.get(i[t]);
                n.__webglTexture && (e.deleteTexture(n.__webglTexture), s.memory.textures--), r.remove(i[t]);
            }
            r.remove(t);
        }(n);
    }
    function D(t) {
        const n = r.get(t);
        e.deleteTexture(n.__webglTexture);
        const i = t.source;
        delete h.get(i)[n.__cacheKey], s.memory.textures--;
    }
    let w = 0;
    function y(t, n) {
        const a = r.get(t);
        if (t.isVideoTexture && function(e) {
            const t = s.render.frame;
            u.get(e) !== t && (u.set(e, t), e.update());
        }(t), !1 === t.isRenderTargetTexture && !0 !== t.isExternalTexture && t.version > 0 && a.__version !== t.version) {
            const e = t.image;
            if (null === e) (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Texture marked for update but no image data found.");
            else {
                if (!1 !== e.complete) return void k(a, t, n);
                (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Texture marked for update but image is incomplete");
            }
        } else t.isExternalTexture && (a.__webglTexture = t.sourceTexture ? t.sourceTexture : null);
        i.bindTexture(e.TEXTURE_2D, a.__webglTexture, e.TEXTURE0 + n);
    }
    const I = {
        [(0, $4a792688e08e5cd7$export$533346c8e8dac0f5)]: e.REPEAT,
        [(0, $4a792688e08e5cd7$export$9d9334239a5a5e06)]: e.CLAMP_TO_EDGE,
        [(0, $4a792688e08e5cd7$export$c7e7c00b14f51a4f)]: e.MIRRORED_REPEAT
    }, O = {
        [(0, $4a792688e08e5cd7$export$727aa5ec3fe39bf0)]: e.NEAREST,
        [(0, $4a792688e08e5cd7$export$d129e38cf6feaa8c)]: e.NEAREST_MIPMAP_NEAREST,
        [(0, $4a792688e08e5cd7$export$d2327c1afe5bfdf2)]: e.NEAREST_MIPMAP_LINEAR,
        [(0, $4a792688e08e5cd7$export$8a72f490b25c56c8)]: e.LINEAR,
        [(0, $4a792688e08e5cd7$export$19a719f377145a13)]: e.LINEAR_MIPMAP_NEAREST,
        [(0, $4a792688e08e5cd7$export$5d8599b6a933fb1b)]: e.LINEAR_MIPMAP_LINEAR
    }, F = {
        [(0, $4a792688e08e5cd7$export$d9e2d19a747baaab)]: e.NEVER,
        [(0, $4a792688e08e5cd7$export$187b73a3e352c145)]: e.ALWAYS,
        [(0, $4a792688e08e5cd7$export$36bcf49c713b3eb7)]: e.LESS,
        [(0, $4a792688e08e5cd7$export$64eea11eb407ddf1)]: e.LEQUAL,
        [(0, $4a792688e08e5cd7$export$66f28d946fc6a0d5)]: e.EQUAL,
        [(0, $4a792688e08e5cd7$export$1cdcb70d53d65f61)]: e.GEQUAL,
        [(0, $4a792688e08e5cd7$export$155af022118f3a38)]: e.GREATER,
        [(0, $4a792688e08e5cd7$export$67ab95dde6bed156)]: e.NOTEQUAL
    };
    function B(t, i) {
        if (i.type !== (0, $4a792688e08e5cd7$export$f6d331659b644596) || !1 !== n.has("OES_texture_float_linear") || i.magFilter !== (0, $4a792688e08e5cd7$export$8a72f490b25c56c8) && i.magFilter !== (0, $4a792688e08e5cd7$export$19a719f377145a13) && i.magFilter !== (0, $4a792688e08e5cd7$export$d2327c1afe5bfdf2) && i.magFilter !== (0, $4a792688e08e5cd7$export$5d8599b6a933fb1b) && i.minFilter !== (0, $4a792688e08e5cd7$export$8a72f490b25c56c8) && i.minFilter !== (0, $4a792688e08e5cd7$export$19a719f377145a13) && i.minFilter !== (0, $4a792688e08e5cd7$export$d2327c1afe5bfdf2) && i.minFilter !== (0, $4a792688e08e5cd7$export$5d8599b6a933fb1b) || (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), e.texParameteri(t, e.TEXTURE_WRAP_S, I[i.wrapS]), e.texParameteri(t, e.TEXTURE_WRAP_T, I[i.wrapT]), t !== e.TEXTURE_3D && t !== e.TEXTURE_2D_ARRAY || e.texParameteri(t, e.TEXTURE_WRAP_R, I[i.wrapR]), e.texParameteri(t, e.TEXTURE_MAG_FILTER, O[i.magFilter]), e.texParameteri(t, e.TEXTURE_MIN_FILTER, O[i.minFilter]), i.compareFunction && (e.texParameteri(t, e.TEXTURE_COMPARE_MODE, e.COMPARE_REF_TO_TEXTURE), e.texParameteri(t, e.TEXTURE_COMPARE_FUNC, F[i.compareFunction])), !0 === n.has("EXT_texture_filter_anisotropic")) {
            if (i.magFilter === (0, $4a792688e08e5cd7$export$727aa5ec3fe39bf0)) return;
            if (i.minFilter !== (0, $4a792688e08e5cd7$export$d2327c1afe5bfdf2) && i.minFilter !== (0, $4a792688e08e5cd7$export$5d8599b6a933fb1b)) return;
            if (i.type === (0, $4a792688e08e5cd7$export$f6d331659b644596) && !1 === n.has("OES_texture_float_linear")) return;
            if (i.anisotropy > 1 || r.get(i).__currentAnisotropy) {
                const o = n.get("EXT_texture_filter_anisotropic");
                e.texParameterf(t, o.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(i.anisotropy, a.getMaxAnisotropy())), r.get(i).__currentAnisotropy = i.anisotropy;
            }
        }
    }
    function V(t, n) {
        let i = !1;
        void 0 === t.__webglInit && (t.__webglInit = !0, n.addEventListener("dispose", P));
        const r = n.source;
        let a = h.get(r);
        void 0 === a && (a = {}, h.set(r, a));
        const o = function(e) {
            const t = [];
            return t.push(e.wrapS), t.push(e.wrapT), t.push(e.wrapR || 0), t.push(e.magFilter), t.push(e.minFilter), t.push(e.anisotropy), t.push(e.internalFormat), t.push(e.format), t.push(e.type), t.push(e.generateMipmaps), t.push(e.premultiplyAlpha), t.push(e.flipY), t.push(e.unpackAlignment), t.push(e.colorSpace), t.join();
        }(n);
        if (o !== t.__cacheKey) {
            void 0 === a[o] && (a[o] = {
                texture: e.createTexture(),
                usedTimes: 0
            }, s.memory.textures++, i = !0), a[o].usedTimes++;
            const r = a[t.__cacheKey];
            void 0 !== r && (a[t.__cacheKey].usedTimes--, 0 === r.usedTimes && D(n)), t.__cacheKey = o, t.__webglTexture = a[o].texture;
        }
        return i;
    }
    function z(e, t, n) {
        return Math.floor(Math.floor(e / n) / t);
    }
    function k(t, n, s) {
        let l = e.TEXTURE_2D;
        (n.isDataArrayTexture || n.isCompressedArrayTexture) && (l = e.TEXTURE_2D_ARRAY), n.isData3DTexture && (l = e.TEXTURE_3D);
        const c = V(t, n), d = n.source;
        i.bindTexture(l, t.__webglTexture, e.TEXTURE0 + s);
        const u = r.get(d);
        if (d.version !== u.__version || !0 === c) {
            i.activeTexture(e.TEXTURE0 + s);
            const t = (0, $4a792688e08e5cd7$export$5e6fd513f44698c).getPrimaries((0, $4a792688e08e5cd7$export$5e6fd513f44698c).workingColorSpace), r = n.colorSpace === (0, $4a792688e08e5cd7$export$bfcb490c2dd3db51) ? null : (0, $4a792688e08e5cd7$export$5e6fd513f44698c).getPrimaries(n.colorSpace), f = n.colorSpace === (0, $4a792688e08e5cd7$export$bfcb490c2dd3db51) || t === r ? e.NONE : e.BROWSER_DEFAULT_WEBGL;
            e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, n.flipY), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.premultiplyAlpha), e.pixelStorei(e.UNPACK_ALIGNMENT, n.unpackAlignment), e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, f);
            let m = v(n.image, !1, a.maxTextureSize);
            m = J(n, m);
            const h = o.convert(n.format, n.colorSpace), _ = o.convert(n.type);
            let g, T = b(n.internalFormat, h, _, n.colorSpace, n.isVideoTexture);
            B(l, n);
            const M = n.mipmaps, R = !0 !== n.isVideoTexture, P = void 0 === u.__version || !0 === c, U = d.dataReady, D = L(n, m);
            if (n.isDepthTexture) T = C(n.format === (0, $4a792688e08e5cd7$export$1e113ac2d0905829), n.type), P && (R ? i.texStorage2D(e.TEXTURE_2D, 1, T, m.width, m.height) : i.texImage2D(e.TEXTURE_2D, 0, T, m.width, m.height, 0, h, _, null));
            else if (n.isDataTexture) {
                if (M.length > 0) {
                    R && P && i.texStorage2D(e.TEXTURE_2D, D, T, M[0].width, M[0].height);
                    for(let t = 0, n = M.length; t < n; t++)g = M[t], R ? U && i.texSubImage2D(e.TEXTURE_2D, t, 0, 0, g.width, g.height, h, _, g.data) : i.texImage2D(e.TEXTURE_2D, t, T, g.width, g.height, 0, h, _, g.data);
                    n.generateMipmaps = !1;
                } else R ? (P && i.texStorage2D(e.TEXTURE_2D, D, T, m.width, m.height), U && function(t, n, r, a) {
                    const o = t.updateRanges;
                    if (0 === o.length) i.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, n.width, n.height, r, a, n.data);
                    else {
                        o.sort((e, t)=>e.start - t.start);
                        let s = 0;
                        for(let e = 1; e < o.length; e++){
                            const t = o[s], i = o[e], r = t.start + t.count, a = z(i.start, n.width, 4), l = z(t.start, n.width, 4);
                            i.start <= r + 1 && a === l && z(i.start + i.count - 1, n.width, 4) === a ? t.count = Math.max(t.count, i.start + i.count - t.start) : (++s, o[s] = i);
                        }
                        o.length = s + 1;
                        const l = e.getParameter(e.UNPACK_ROW_LENGTH), c = e.getParameter(e.UNPACK_SKIP_PIXELS), d = e.getParameter(e.UNPACK_SKIP_ROWS);
                        e.pixelStorei(e.UNPACK_ROW_LENGTH, n.width);
                        for(let t = 0, s = o.length; t < s; t++){
                            const s = o[t], l = Math.floor(s.start / 4), c = Math.ceil(s.count / 4), d = l % n.width, u = Math.floor(l / n.width), f = c, p = 1;
                            e.pixelStorei(e.UNPACK_SKIP_PIXELS, d), e.pixelStorei(e.UNPACK_SKIP_ROWS, u), i.texSubImage2D(e.TEXTURE_2D, 0, d, u, f, p, r, a, n.data);
                        }
                        t.clearUpdateRanges(), e.pixelStorei(e.UNPACK_ROW_LENGTH, l), e.pixelStorei(e.UNPACK_SKIP_PIXELS, c), e.pixelStorei(e.UNPACK_SKIP_ROWS, d);
                    }
                }(n, m, h, _)) : i.texImage2D(e.TEXTURE_2D, 0, T, m.width, m.height, 0, h, _, m.data);
            } else if (n.isCompressedTexture) {
                if (n.isCompressedArrayTexture) {
                    R && P && i.texStorage3D(e.TEXTURE_2D_ARRAY, D, T, M[0].width, M[0].height, m.depth);
                    for(let t = 0, r = M.length; t < r; t++)if (g = M[t], n.format !== (0, $4a792688e08e5cd7$export$3f8bb04b555a363c)) {
                        if (null !== h) {
                            if (R) {
                                if (U) {
                                    if (n.layerUpdates.size > 0) {
                                        const r = (0, $4a792688e08e5cd7$export$cc8c3b705bb8e6e2)(g.width, g.height, n.format, n.type);
                                        for (const a of n.layerUpdates){
                                            const n = g.data.subarray(a * r / g.data.BYTES_PER_ELEMENT, (a + 1) * r / g.data.BYTES_PER_ELEMENT);
                                            i.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY, t, 0, 0, a, g.width, g.height, 1, h, n);
                                        }
                                        n.clearLayerUpdates();
                                    } else i.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY, t, 0, 0, 0, g.width, g.height, m.depth, h, g.data);
                                }
                            } else i.compressedTexImage3D(e.TEXTURE_2D_ARRAY, t, T, g.width, g.height, m.depth, 0, g.data, 0, 0);
                        } else (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                    } else R ? U && i.texSubImage3D(e.TEXTURE_2D_ARRAY, t, 0, 0, 0, g.width, g.height, m.depth, h, _, g.data) : i.texImage3D(e.TEXTURE_2D_ARRAY, t, T, g.width, g.height, m.depth, 0, h, _, g.data);
                } else {
                    R && P && i.texStorage2D(e.TEXTURE_2D, D, T, M[0].width, M[0].height);
                    for(let t = 0, r = M.length; t < r; t++)g = M[t], n.format !== (0, $4a792688e08e5cd7$export$3f8bb04b555a363c) ? null !== h ? R ? U && i.compressedTexSubImage2D(e.TEXTURE_2D, t, 0, 0, g.width, g.height, h, g.data) : i.compressedTexImage2D(e.TEXTURE_2D, t, T, g.width, g.height, 0, g.data) : (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : R ? U && i.texSubImage2D(e.TEXTURE_2D, t, 0, 0, g.width, g.height, h, _, g.data) : i.texImage2D(e.TEXTURE_2D, t, T, g.width, g.height, 0, h, _, g.data);
                }
            } else if (n.isDataArrayTexture) {
                if (R) {
                    if (P && i.texStorage3D(e.TEXTURE_2D_ARRAY, D, T, m.width, m.height, m.depth), U) {
                        if (n.layerUpdates.size > 0) {
                            const t = (0, $4a792688e08e5cd7$export$cc8c3b705bb8e6e2)(m.width, m.height, n.format, n.type);
                            for (const r of n.layerUpdates){
                                const n = m.data.subarray(r * t / m.data.BYTES_PER_ELEMENT, (r + 1) * t / m.data.BYTES_PER_ELEMENT);
                                i.texSubImage3D(e.TEXTURE_2D_ARRAY, 0, 0, 0, r, m.width, m.height, 1, h, _, n);
                            }
                            n.clearLayerUpdates();
                        } else i.texSubImage3D(e.TEXTURE_2D_ARRAY, 0, 0, 0, 0, m.width, m.height, m.depth, h, _, m.data);
                    }
                } else i.texImage3D(e.TEXTURE_2D_ARRAY, 0, T, m.width, m.height, m.depth, 0, h, _, m.data);
            } else if (n.isData3DTexture) R ? (P && i.texStorage3D(e.TEXTURE_3D, D, T, m.width, m.height, m.depth), U && i.texSubImage3D(e.TEXTURE_3D, 0, 0, 0, 0, m.width, m.height, m.depth, h, _, m.data)) : i.texImage3D(e.TEXTURE_3D, 0, T, m.width, m.height, m.depth, 0, h, _, m.data);
            else if (n.isFramebufferTexture) {
                if (P) {
                    if (R) i.texStorage2D(e.TEXTURE_2D, D, T, m.width, m.height);
                    else {
                        let t = m.width, n = m.height;
                        for(let r = 0; r < D; r++)i.texImage2D(e.TEXTURE_2D, r, T, t, n, 0, h, _, null), t >>= 1, n >>= 1;
                    }
                }
            } else if (M.length > 0) {
                if (R && P) {
                    const t = ee(M[0]);
                    i.texStorage2D(e.TEXTURE_2D, D, T, t.width, t.height);
                }
                for(let t = 0, n = M.length; t < n; t++)g = M[t], R ? U && i.texSubImage2D(e.TEXTURE_2D, t, 0, 0, h, _, g) : i.texImage2D(e.TEXTURE_2D, t, T, h, _, g);
                n.generateMipmaps = !1;
            } else if (R) {
                if (P) {
                    const t = ee(m);
                    i.texStorage2D(e.TEXTURE_2D, D, T, t.width, t.height);
                }
                U && i.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, h, _, m);
            } else i.texImage2D(e.TEXTURE_2D, 0, T, h, _, m);
            S(n) && A(l), u.__version = d.version, n.onUpdate && n.onUpdate(n);
        }
        t.__version = n.version;
    }
    function W(t, n, a, s, c, d) {
        const u = o.convert(a.format, a.colorSpace), f = o.convert(a.type), p = b(a.internalFormat, u, f, a.colorSpace), m = r.get(n), h = r.get(a);
        if (h.__renderTarget = n, !m.__hasExternalTextures) {
            const t = Math.max(1, n.width >> d), r = Math.max(1, n.height >> d);
            c === e.TEXTURE_3D || c === e.TEXTURE_2D_ARRAY ? i.texImage3D(c, d, p, t, r, n.depth, 0, u, f, null) : i.texImage2D(c, d, p, t, r, 0, u, f, null);
        }
        i.bindFramebuffer(e.FRAMEBUFFER, t), Q(n) ? l.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, s, c, h.__webglTexture, 0, $(n)) : (c === e.TEXTURE_2D || c >= e.TEXTURE_CUBE_MAP_POSITIVE_X && c <= e.TEXTURE_CUBE_MAP_NEGATIVE_Z) && e.framebufferTexture2D(e.FRAMEBUFFER, s, c, h.__webglTexture, d), i.bindFramebuffer(e.FRAMEBUFFER, null);
    }
    function X(t, n, i) {
        if (e.bindRenderbuffer(e.RENDERBUFFER, t), n.depthBuffer) {
            const r = n.depthTexture, a = r && r.isDepthTexture ? r.type : null, o = C(n.stencilBuffer, a), s = n.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, c = $(n);
            Q(n) ? l.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, c, o, n.width, n.height) : i ? e.renderbufferStorageMultisample(e.RENDERBUFFER, c, o, n.width, n.height) : e.renderbufferStorage(e.RENDERBUFFER, o, n.width, n.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, s, e.RENDERBUFFER, t);
        } else {
            const t = n.textures;
            for(let r = 0; r < t.length; r++){
                const a = t[r], s = o.convert(a.format, a.colorSpace), c = o.convert(a.type), d = b(a.internalFormat, s, c, a.colorSpace), u = $(n);
                i && !1 === Q(n) ? e.renderbufferStorageMultisample(e.RENDERBUFFER, u, d, n.width, n.height) : Q(n) ? l.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, u, d, n.width, n.height) : e.renderbufferStorage(e.RENDERBUFFER, d, n.width, n.height);
            }
        }
        e.bindRenderbuffer(e.RENDERBUFFER, null);
    }
    function Y(t, n) {
        if (n && n.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
        if (i.bindFramebuffer(e.FRAMEBUFFER, t), !n.depthTexture || !n.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        const a = r.get(n.depthTexture);
        a.__renderTarget = n, a.__webglTexture && n.depthTexture.image.width === n.width && n.depthTexture.image.height === n.height || (n.depthTexture.image.width = n.width, n.depthTexture.image.height = n.height, n.depthTexture.needsUpdate = !0), y(n.depthTexture, 0);
        const o = a.__webglTexture, s = $(n);
        if (n.depthTexture.format === (0, $4a792688e08e5cd7$export$c1b6b5136be58045)) Q(n) ? l.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.TEXTURE_2D, o, 0, s) : e.framebufferTexture2D(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.TEXTURE_2D, o, 0);
        else {
            if (n.depthTexture.format !== (0, $4a792688e08e5cd7$export$1e113ac2d0905829)) throw new Error("Unknown depthTexture format");
            Q(n) ? l.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.TEXTURE_2D, o, 0, s) : e.framebufferTexture2D(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.TEXTURE_2D, o, 0);
        }
    }
    function K(t) {
        const n = r.get(t), a = !0 === t.isWebGLCubeRenderTarget;
        if (n.__boundDepthTexture !== t.depthTexture) {
            const e = t.depthTexture;
            if (n.__depthDisposeCallback && n.__depthDisposeCallback(), e) {
                const t = ()=>{
                    delete n.__boundDepthTexture, delete n.__depthDisposeCallback, e.removeEventListener("dispose", t);
                };
                e.addEventListener("dispose", t), n.__depthDisposeCallback = t;
            }
            n.__boundDepthTexture = e;
        }
        if (t.depthTexture && !n.__autoAllocateDepthBuffer) {
            if (a) throw new Error("target.depthTexture not supported in Cube render targets");
            const e = t.texture.mipmaps;
            e && e.length > 0 ? Y(n.__webglFramebuffer[0], t) : Y(n.__webglFramebuffer, t);
        } else if (a) {
            n.__webglDepthbuffer = [];
            for(let r = 0; r < 6; r++)if (i.bindFramebuffer(e.FRAMEBUFFER, n.__webglFramebuffer[r]), void 0 === n.__webglDepthbuffer[r]) n.__webglDepthbuffer[r] = e.createRenderbuffer(), X(n.__webglDepthbuffer[r], t, !1);
            else {
                const i = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, a = n.__webglDepthbuffer[r];
                e.bindRenderbuffer(e.RENDERBUFFER, a), e.framebufferRenderbuffer(e.FRAMEBUFFER, i, e.RENDERBUFFER, a);
            }
        } else {
            const r = t.texture.mipmaps;
            if (r && r.length > 0 ? i.bindFramebuffer(e.FRAMEBUFFER, n.__webglFramebuffer[0]) : i.bindFramebuffer(e.FRAMEBUFFER, n.__webglFramebuffer), void 0 === n.__webglDepthbuffer) n.__webglDepthbuffer = e.createRenderbuffer(), X(n.__webglDepthbuffer, t, !1);
            else {
                const i = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, r = n.__webglDepthbuffer;
                e.bindRenderbuffer(e.RENDERBUFFER, r), e.framebufferRenderbuffer(e.FRAMEBUFFER, i, e.RENDERBUFFER, r);
            }
        }
        i.bindFramebuffer(e.FRAMEBUFFER, null);
    }
    const q = [], Z = [];
    function $(e) {
        return Math.min(a.maxSamples, e.samples);
    }
    function Q(e) {
        const t = r.get(e);
        return e.samples > 0 && !0 === n.has("WEBGL_multisampled_render_to_texture") && !1 !== t.__useRenderToTexture;
    }
    function J(e, t) {
        const n = e.colorSpace, i = e.format, r = e.type;
        return !0 === e.isCompressedTexture || !0 === e.isVideoTexture || n !== (0, $4a792688e08e5cd7$export$42429b3acfb233a4) && n !== (0, $4a792688e08e5cd7$export$bfcb490c2dd3db51) && ((0, $4a792688e08e5cd7$export$5e6fd513f44698c).getTransfer(n) === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? i === (0, $4a792688e08e5cd7$export$3f8bb04b555a363c) && r === (0, $4a792688e08e5cd7$export$2e8ce08d3f6f5e10) || (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLTextures: Unsupported texture color space:", n)), t;
    }
    function ee(e) {
        return "undefined" != typeof HTMLImageElement && e instanceof HTMLImageElement ? (d.width = e.naturalWidth || e.width, d.height = e.naturalHeight || e.height) : "undefined" != typeof VideoFrame && e instanceof VideoFrame ? (d.width = e.displayWidth, d.height = e.displayHeight) : (d.width = e.width, d.height = e.height), d;
    }
    this.allocateTextureUnit = function() {
        const e = w;
        return e >= a.maxTextures && (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLTextures: Trying to use " + e + " texture units while this GPU supports only " + a.maxTextures), w += 1, e;
    }, this.resetTextureUnits = function() {
        w = 0;
    }, this.setTexture2D = y, this.setTexture2DArray = function(t, n) {
        const a = r.get(t);
        !1 === t.isRenderTargetTexture && t.version > 0 && a.__version !== t.version ? k(a, t, n) : (t.isExternalTexture && (a.__webglTexture = t.sourceTexture ? t.sourceTexture : null), i.bindTexture(e.TEXTURE_2D_ARRAY, a.__webglTexture, e.TEXTURE0 + n));
    }, this.setTexture3D = function(t, n) {
        const a = r.get(t);
        !1 === t.isRenderTargetTexture && t.version > 0 && a.__version !== t.version ? k(a, t, n) : i.bindTexture(e.TEXTURE_3D, a.__webglTexture, e.TEXTURE0 + n);
    }, this.setTextureCube = function(t, n) {
        const s = r.get(t);
        t.version > 0 && s.__version !== t.version ? function(t, n, s) {
            if (6 !== n.image.length) return;
            const l = V(t, n), c = n.source;
            i.bindTexture(e.TEXTURE_CUBE_MAP, t.__webglTexture, e.TEXTURE0 + s);
            const d = r.get(c);
            if (c.version !== d.__version || !0 === l) {
                i.activeTexture(e.TEXTURE0 + s);
                const t = (0, $4a792688e08e5cd7$export$5e6fd513f44698c).getPrimaries((0, $4a792688e08e5cd7$export$5e6fd513f44698c).workingColorSpace), r = n.colorSpace === (0, $4a792688e08e5cd7$export$bfcb490c2dd3db51) ? null : (0, $4a792688e08e5cd7$export$5e6fd513f44698c).getPrimaries(n.colorSpace), u = n.colorSpace === (0, $4a792688e08e5cd7$export$bfcb490c2dd3db51) || t === r ? e.NONE : e.BROWSER_DEFAULT_WEBGL;
                e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, n.flipY), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.premultiplyAlpha), e.pixelStorei(e.UNPACK_ALIGNMENT, n.unpackAlignment), e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, u);
                const f = n.isCompressedTexture || n.image[0].isCompressedTexture, m = n.image[0] && n.image[0].isDataTexture, h = [];
                for(let e = 0; e < 6; e++)h[e] = f || m ? m ? n.image[e].image : n.image[e] : v(n.image[e], !0, a.maxCubemapSize), h[e] = J(n, h[e]);
                const _ = h[0], g = o.convert(n.format, n.colorSpace), T = o.convert(n.type), M = b(n.internalFormat, g, T, n.colorSpace), R = !0 !== n.isVideoTexture, C = void 0 === d.__version || !0 === l, P = c.dataReady;
                let U, D = L(n, _);
                if (B(e.TEXTURE_CUBE_MAP, n), f) {
                    R && C && i.texStorage2D(e.TEXTURE_CUBE_MAP, D, M, _.width, _.height);
                    for(let t = 0; t < 6; t++){
                        U = h[t].mipmaps;
                        for(let r = 0; r < U.length; r++){
                            const a = U[r];
                            n.format !== (0, $4a792688e08e5cd7$export$3f8bb04b555a363c) ? null !== g ? R ? P && i.compressedTexSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, 0, 0, a.width, a.height, g, a.data) : i.compressedTexImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, M, a.width, a.height, 0, a.data) : (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : R ? P && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, 0, 0, a.width, a.height, g, T, a.data) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, r, M, a.width, a.height, 0, g, T, a.data);
                        }
                    }
                } else {
                    if (U = n.mipmaps, R && C) {
                        U.length > 0 && D++;
                        const t = ee(h[0]);
                        i.texStorage2D(e.TEXTURE_CUBE_MAP, D, M, t.width, t.height);
                    }
                    for(let t = 0; t < 6; t++)if (m) {
                        R ? P && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, h[t].width, h[t].height, g, T, h[t].data) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, M, h[t].width, h[t].height, 0, g, T, h[t].data);
                        for(let n = 0; n < U.length; n++){
                            const r = U[n].image[t].image;
                            R ? P && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, 0, 0, r.width, r.height, g, T, r.data) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, M, r.width, r.height, 0, g, T, r.data);
                        }
                    } else {
                        R ? P && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, g, T, h[t]) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, M, g, T, h[t]);
                        for(let n = 0; n < U.length; n++){
                            const r = U[n];
                            R ? P && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, 0, 0, g, T, r.image[t]) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, M, g, T, r.image[t]);
                        }
                    }
                }
                S(n) && A(e.TEXTURE_CUBE_MAP), d.__version = c.version, n.onUpdate && n.onUpdate(n);
            }
            t.__version = n.version;
        }(s, t, n) : i.bindTexture(e.TEXTURE_CUBE_MAP, s.__webglTexture, e.TEXTURE0 + n);
    }, this.rebindTextures = function(t, n, i) {
        const a = r.get(t);
        void 0 !== n && W(a.__webglFramebuffer, t, t.texture, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, 0), void 0 !== i && K(t);
    }, this.setupRenderTarget = function(t) {
        const n = t.texture, a = r.get(t), l = r.get(n);
        t.addEventListener("dispose", U);
        const c = t.textures, d = !0 === t.isWebGLCubeRenderTarget, u = c.length > 1;
        if (u || (void 0 === l.__webglTexture && (l.__webglTexture = e.createTexture()), l.__version = n.version, s.memory.textures++), d) {
            a.__webglFramebuffer = [];
            for(let t = 0; t < 6; t++)if (n.mipmaps && n.mipmaps.length > 0) {
                a.__webglFramebuffer[t] = [];
                for(let i = 0; i < n.mipmaps.length; i++)a.__webglFramebuffer[t][i] = e.createFramebuffer();
            } else a.__webglFramebuffer[t] = e.createFramebuffer();
        } else {
            if (n.mipmaps && n.mipmaps.length > 0) {
                a.__webglFramebuffer = [];
                for(let t = 0; t < n.mipmaps.length; t++)a.__webglFramebuffer[t] = e.createFramebuffer();
            } else a.__webglFramebuffer = e.createFramebuffer();
            if (u) for(let t = 0, n = c.length; t < n; t++){
                const n = r.get(c[t]);
                void 0 === n.__webglTexture && (n.__webglTexture = e.createTexture(), s.memory.textures++);
            }
            if (t.samples > 0 && !1 === Q(t)) {
                a.__webglMultisampledFramebuffer = e.createFramebuffer(), a.__webglColorRenderbuffer = [], i.bindFramebuffer(e.FRAMEBUFFER, a.__webglMultisampledFramebuffer);
                for(let n = 0; n < c.length; n++){
                    const i = c[n];
                    a.__webglColorRenderbuffer[n] = e.createRenderbuffer(), e.bindRenderbuffer(e.RENDERBUFFER, a.__webglColorRenderbuffer[n]);
                    const r = o.convert(i.format, i.colorSpace), s = o.convert(i.type), l = b(i.internalFormat, r, s, i.colorSpace, !0 === t.isXRRenderTarget), d = $(t);
                    e.renderbufferStorageMultisample(e.RENDERBUFFER, d, l, t.width, t.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + n, e.RENDERBUFFER, a.__webglColorRenderbuffer[n]);
                }
                e.bindRenderbuffer(e.RENDERBUFFER, null), t.depthBuffer && (a.__webglDepthRenderbuffer = e.createRenderbuffer(), X(a.__webglDepthRenderbuffer, t, !0)), i.bindFramebuffer(e.FRAMEBUFFER, null);
            }
        }
        if (d) {
            i.bindTexture(e.TEXTURE_CUBE_MAP, l.__webglTexture), B(e.TEXTURE_CUBE_MAP, n);
            for(let i = 0; i < 6; i++)if (n.mipmaps && n.mipmaps.length > 0) for(let r = 0; r < n.mipmaps.length; r++)W(a.__webglFramebuffer[i][r], t, n, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + i, r);
            else W(a.__webglFramebuffer[i], t, n, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            S(n) && A(e.TEXTURE_CUBE_MAP), i.unbindTexture();
        } else if (u) {
            for(let n = 0, o = c.length; n < o; n++){
                const o = c[n], s = r.get(o);
                let l = e.TEXTURE_2D;
                (t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) && (l = t.isWebGL3DRenderTarget ? e.TEXTURE_3D : e.TEXTURE_2D_ARRAY), i.bindTexture(l, s.__webglTexture), B(l, o), W(a.__webglFramebuffer, t, o, e.COLOR_ATTACHMENT0 + n, l, 0), S(o) && A(l);
            }
            i.unbindTexture();
        } else {
            let r = e.TEXTURE_2D;
            if ((t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) && (r = t.isWebGL3DRenderTarget ? e.TEXTURE_3D : e.TEXTURE_2D_ARRAY), i.bindTexture(r, l.__webglTexture), B(r, n), n.mipmaps && n.mipmaps.length > 0) for(let i = 0; i < n.mipmaps.length; i++)W(a.__webglFramebuffer[i], t, n, e.COLOR_ATTACHMENT0, r, i);
            else W(a.__webglFramebuffer, t, n, e.COLOR_ATTACHMENT0, r, 0);
            S(n) && A(r), i.unbindTexture();
        }
        t.depthBuffer && K(t);
    }, this.updateRenderTargetMipmap = function(e) {
        const t = e.textures;
        for(let n = 0, a = t.length; n < a; n++){
            const a = t[n];
            if (S(a)) {
                const t = R(e), n = r.get(a).__webglTexture;
                i.bindTexture(t, n), A(t), i.unbindTexture();
            }
        }
    }, this.updateMultisampleRenderTarget = function(t) {
        if (t.samples > 0) {
            if (!1 === Q(t)) {
                const n = t.textures, a = t.width, o = t.height;
                let s = e.COLOR_BUFFER_BIT;
                const l = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, d = r.get(t), u = n.length > 1;
                if (u) for(let t = 0; t < n.length; t++)i.bindFramebuffer(e.FRAMEBUFFER, d.__webglMultisampledFramebuffer), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.RENDERBUFFER, null), i.bindFramebuffer(e.FRAMEBUFFER, d.__webglFramebuffer), e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.TEXTURE_2D, null, 0);
                i.bindFramebuffer(e.READ_FRAMEBUFFER, d.__webglMultisampledFramebuffer);
                const f = t.texture.mipmaps;
                f && f.length > 0 ? i.bindFramebuffer(e.DRAW_FRAMEBUFFER, d.__webglFramebuffer[0]) : i.bindFramebuffer(e.DRAW_FRAMEBUFFER, d.__webglFramebuffer);
                for(let i = 0; i < n.length; i++){
                    if (t.resolveDepthBuffer && (t.depthBuffer && (s |= e.DEPTH_BUFFER_BIT), t.stencilBuffer && t.resolveStencilBuffer && (s |= e.STENCIL_BUFFER_BIT)), u) {
                        e.framebufferRenderbuffer(e.READ_FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.RENDERBUFFER, d.__webglColorRenderbuffer[i]);
                        const t = r.get(n[i]).__webglTexture;
                        e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0);
                    }
                    e.blitFramebuffer(0, 0, a, o, 0, 0, a, o, s, e.NEAREST), !0 === c && (q.length = 0, Z.length = 0, q.push(e.COLOR_ATTACHMENT0 + i), t.depthBuffer && !1 === t.resolveDepthBuffer && (q.push(l), Z.push(l), e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, Z)), e.invalidateFramebuffer(e.READ_FRAMEBUFFER, q));
                }
                if (i.bindFramebuffer(e.READ_FRAMEBUFFER, null), i.bindFramebuffer(e.DRAW_FRAMEBUFFER, null), u) for(let t = 0; t < n.length; t++){
                    i.bindFramebuffer(e.FRAMEBUFFER, d.__webglMultisampledFramebuffer), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.RENDERBUFFER, d.__webglColorRenderbuffer[t]);
                    const a = r.get(n[t]).__webglTexture;
                    i.bindFramebuffer(e.FRAMEBUFFER, d.__webglFramebuffer), e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0 + t, e.TEXTURE_2D, a, 0);
                }
                i.bindFramebuffer(e.DRAW_FRAMEBUFFER, d.__webglMultisampledFramebuffer);
            } else if (t.depthBuffer && !1 === t.resolveDepthBuffer && c) {
                const n = t.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
                e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, [
                    n
                ]);
            }
        }
    }, this.setupDepthRenderbuffer = K, this.setupFrameBufferTexture = W, this.useMultisampledRTT = Q;
}
function $5292c45f2b641b96$export$ddaebcad857649a8(e, t) {
    return {
        convert: function(n, i = (0, $4a792688e08e5cd7$export$bfcb490c2dd3db51)) {
            let r;
            const a = (0, $4a792688e08e5cd7$export$5e6fd513f44698c).getTransfer(i);
            if (n === (0, $4a792688e08e5cd7$export$2e8ce08d3f6f5e10)) return e.UNSIGNED_BYTE;
            if (n === (0, $4a792688e08e5cd7$export$b3969b01faf587f2)) return e.UNSIGNED_SHORT_4_4_4_4;
            if (n === (0, $4a792688e08e5cd7$export$18886f8ae33e90de)) return e.UNSIGNED_SHORT_5_5_5_1;
            if (n === (0, $4a792688e08e5cd7$export$5a4c329b7e2092d3)) return e.UNSIGNED_INT_5_9_9_9_REV;
            if (n === (0, $4a792688e08e5cd7$export$f240f067f72abe41)) return e.UNSIGNED_INT_10F_11F_11F_REV;
            if (n === (0, $4a792688e08e5cd7$export$545fce0311a9796a)) return e.BYTE;
            if (n === (0, $4a792688e08e5cd7$export$88572337f312435f)) return e.SHORT;
            if (n === (0, $4a792688e08e5cd7$export$c63dc51868b06a9d)) return e.UNSIGNED_SHORT;
            if (n === (0, $4a792688e08e5cd7$export$5c612977753abe2)) return e.INT;
            if (n === (0, $4a792688e08e5cd7$export$c3c7fc4518ebba96)) return e.UNSIGNED_INT;
            if (n === (0, $4a792688e08e5cd7$export$f6d331659b644596)) return e.FLOAT;
            if (n === (0, $4a792688e08e5cd7$export$2697304443f382bc)) return e.HALF_FLOAT;
            if (n === (0, $4a792688e08e5cd7$export$988473390501ed4b)) return e.ALPHA;
            if (n === (0, $4a792688e08e5cd7$export$7c67423a5ee6f5eb)) return e.RGB;
            if (n === (0, $4a792688e08e5cd7$export$3f8bb04b555a363c)) return e.RGBA;
            if (n === (0, $4a792688e08e5cd7$export$c1b6b5136be58045)) return e.DEPTH_COMPONENT;
            if (n === (0, $4a792688e08e5cd7$export$1e113ac2d0905829)) return e.DEPTH_STENCIL;
            if (n === (0, $4a792688e08e5cd7$export$4e041a7967d15c4b)) return e.RED;
            if (n === (0, $4a792688e08e5cd7$export$aa92e870a709d190)) return e.RED_INTEGER;
            if (n === (0, $4a792688e08e5cd7$export$6cdf0b461c7ce8a0)) return e.RG;
            if (n === (0, $4a792688e08e5cd7$export$1ba1c45f9f77d4d7)) return e.RG_INTEGER;
            if (n === (0, $4a792688e08e5cd7$export$c200e7d26f592f21)) return e.RGBA_INTEGER;
            if (n === (0, $4a792688e08e5cd7$export$21d1799c6d552fc0) || n === (0, $4a792688e08e5cd7$export$afa304c3e981b668) || n === (0, $4a792688e08e5cd7$export$d2a1a68024a3e56c) || n === (0, $4a792688e08e5cd7$export$9a79c424327dacf9)) {
                if (a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb)) {
                    if (r = t.get("WEBGL_compressed_texture_s3tc_srgb"), null === r) return null;
                    if (n === (0, $4a792688e08e5cd7$export$21d1799c6d552fc0)) return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (n === (0, $4a792688e08e5cd7$export$afa304c3e981b668)) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (n === (0, $4a792688e08e5cd7$export$d2a1a68024a3e56c)) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (n === (0, $4a792688e08e5cd7$export$9a79c424327dacf9)) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else {
                    if (r = t.get("WEBGL_compressed_texture_s3tc"), null === r) return null;
                    if (n === (0, $4a792688e08e5cd7$export$21d1799c6d552fc0)) return r.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (n === (0, $4a792688e08e5cd7$export$afa304c3e981b668)) return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (n === (0, $4a792688e08e5cd7$export$d2a1a68024a3e56c)) return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (n === (0, $4a792688e08e5cd7$export$9a79c424327dacf9)) return r.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                }
            }
            if (n === (0, $4a792688e08e5cd7$export$19ada9bbb1af3573) || n === (0, $4a792688e08e5cd7$export$d0f0355bb3d948e4) || n === (0, $4a792688e08e5cd7$export$b82296714358084c) || n === (0, $4a792688e08e5cd7$export$b71692456c47b6c3)) {
                if (r = t.get("WEBGL_compressed_texture_pvrtc"), null === r) return null;
                if (n === (0, $4a792688e08e5cd7$export$19ada9bbb1af3573)) return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (n === (0, $4a792688e08e5cd7$export$d0f0355bb3d948e4)) return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (n === (0, $4a792688e08e5cd7$export$b82296714358084c)) return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (n === (0, $4a792688e08e5cd7$export$b71692456c47b6c3)) return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            }
            if (n === (0, $4a792688e08e5cd7$export$6ab91af2d757aee7) || n === (0, $4a792688e08e5cd7$export$7800993ef8106a6a) || n === (0, $4a792688e08e5cd7$export$23ed8300a860e7d8)) {
                if (r = t.get("WEBGL_compressed_texture_etc"), null === r) return null;
                if (n === (0, $4a792688e08e5cd7$export$6ab91af2d757aee7) || n === (0, $4a792688e08e5cd7$export$7800993ef8106a6a)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ETC2 : r.COMPRESSED_RGB8_ETC2;
                if (n === (0, $4a792688e08e5cd7$export$23ed8300a860e7d8)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : r.COMPRESSED_RGBA8_ETC2_EAC;
            }
            if (n === (0, $4a792688e08e5cd7$export$dc5570b4a2b92d48) || n === (0, $4a792688e08e5cd7$export$68880cd325f8b2fb) || n === (0, $4a792688e08e5cd7$export$7d2c0be323373d95) || n === (0, $4a792688e08e5cd7$export$22b52da301fc3a3e) || n === (0, $4a792688e08e5cd7$export$c009e2cb4a66485e) || n === (0, $4a792688e08e5cd7$export$118fff5afa255b63) || n === (0, $4a792688e08e5cd7$export$120713c829ae0667) || n === (0, $4a792688e08e5cd7$export$c79eeabbf53313e9) || n === (0, $4a792688e08e5cd7$export$443cf6567cdd6424) || n === (0, $4a792688e08e5cd7$export$6573984fc9840780) || n === (0, $4a792688e08e5cd7$export$e7aee563f30091de) || n === (0, $4a792688e08e5cd7$export$2eb8634622ddeab7) || n === (0, $4a792688e08e5cd7$export$202b1ce7b5d25742) || n === (0, $4a792688e08e5cd7$export$18ab77abd087e467)) {
                if (r = t.get("WEBGL_compressed_texture_astc"), null === r) return null;
                if (n === (0, $4a792688e08e5cd7$export$dc5570b4a2b92d48)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : r.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (n === (0, $4a792688e08e5cd7$export$68880cd325f8b2fb)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : r.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (n === (0, $4a792688e08e5cd7$export$7d2c0be323373d95)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : r.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (n === (0, $4a792688e08e5cd7$export$22b52da301fc3a3e)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : r.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (n === (0, $4a792688e08e5cd7$export$c009e2cb4a66485e)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : r.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (n === (0, $4a792688e08e5cd7$export$118fff5afa255b63)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : r.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (n === (0, $4a792688e08e5cd7$export$120713c829ae0667)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : r.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (n === (0, $4a792688e08e5cd7$export$c79eeabbf53313e9)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : r.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (n === (0, $4a792688e08e5cd7$export$443cf6567cdd6424)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : r.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (n === (0, $4a792688e08e5cd7$export$6573984fc9840780)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : r.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (n === (0, $4a792688e08e5cd7$export$e7aee563f30091de)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : r.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (n === (0, $4a792688e08e5cd7$export$2eb8634622ddeab7)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : r.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (n === (0, $4a792688e08e5cd7$export$202b1ce7b5d25742)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : r.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (n === (0, $4a792688e08e5cd7$export$18ab77abd087e467)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : r.COMPRESSED_RGBA_ASTC_12x12_KHR;
            }
            if (n === (0, $4a792688e08e5cd7$export$ce40b115e188bc81) || n === (0, $4a792688e08e5cd7$export$d279c5c4bac5121e) || n === (0, $4a792688e08e5cd7$export$cde52d17225fdbd3)) {
                if (r = t.get("EXT_texture_compression_bptc"), null === r) return null;
                if (n === (0, $4a792688e08e5cd7$export$ce40b115e188bc81)) return a === (0, $4a792688e08e5cd7$export$8d0a61916cc26abb) ? r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : r.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (n === (0, $4a792688e08e5cd7$export$d279c5c4bac5121e)) return r.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (n === (0, $4a792688e08e5cd7$export$cde52d17225fdbd3)) return r.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            }
            if (n === (0, $4a792688e08e5cd7$export$b1688df4c4c21670) || n === (0, $4a792688e08e5cd7$export$fc15e5d8261eed58) || n === (0, $4a792688e08e5cd7$export$d220f6ade8463a0f) || n === (0, $4a792688e08e5cd7$export$768646d09dc1b6ef)) {
                if (r = t.get("EXT_texture_compression_rgtc"), null === r) return null;
                if (n === (0, $4a792688e08e5cd7$export$b1688df4c4c21670)) return r.COMPRESSED_RED_RGTC1_EXT;
                if (n === (0, $4a792688e08e5cd7$export$fc15e5d8261eed58)) return r.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (n === (0, $4a792688e08e5cd7$export$d220f6ade8463a0f)) return r.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (n === (0, $4a792688e08e5cd7$export$768646d09dc1b6ef)) return r.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            }
            return n === (0, $4a792688e08e5cd7$export$6c8ea339bfab1301) ? e.UNSIGNED_INT_24_8 : void 0 !== e[n] ? e[n] : null;
        }
    };
}
class $5292c45f2b641b96$var$ra {
    constructor(){
        this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
    }
    init(e, t) {
        if (null === this.texture) {
            const n = new (0, $4a792688e08e5cd7$export$cd10147cacf16ab2)(e.texture);
            e.depthNear === t.depthNear && e.depthFar === t.depthFar || (this.depthNear = e.depthNear, this.depthFar = e.depthFar), this.texture = n;
        }
    }
    getMesh(e) {
        if (null !== this.texture && null === this.mesh) {
            const t = e.cameras[0].viewport, n = new (0, $4a792688e08e5cd7$export$83c7d75d550a8b0d)({
                vertexShader: "\nvoid main() {\n\n\tgl_Position = vec4( position, 1.0 );\n\n}",
                fragmentShader: "\nuniform sampler2DArray depthColor;\nuniform float depthWidth;\nuniform float depthHeight;\n\nvoid main() {\n\n\tvec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );\n\n\tif ( coord.x >= 1.0 ) {\n\n\t\tgl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;\n\n\t} else {\n\n\t\tgl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;\n\n\t}\n\n}",
                uniforms: {
                    depthColor: {
                        value: this.texture
                    },
                    depthWidth: {
                        value: t.z
                    },
                    depthHeight: {
                        value: t.w
                    }
                }
            });
            this.mesh = new (0, $4a792688e08e5cd7$export$e176487c05830cc5)(new (0, $4a792688e08e5cd7$export$967d831af31f69ce)(20, 20), n);
        }
        return this.mesh;
    }
    reset() {
        this.texture = null, this.mesh = null;
    }
    getDepthTexture() {
        return this.texture;
    }
}
class $5292c45f2b641b96$var$aa extends (0, $4a792688e08e5cd7$export$ec8b666c5fe2c75a) {
    constructor(e, n){
        super();
        const i = this;
        let a = null, o = 1, s = null, l = "local-floor", c = 1, d = null, u = null, f = null, p = null, m = null, h = null;
        const _ = "undefined" != typeof XRWebGLBinding, g = new $5292c45f2b641b96$var$ra, v = {}, S = n.getContextAttributes();
        let M = null, A = null;
        const R = [], b = [], C = new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1);
        let L = null;
        const P = new (0, $4a792688e08e5cd7$export$74e4ae24825f68d7);
        P.viewport = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3);
        const U = new (0, $4a792688e08e5cd7$export$74e4ae24825f68d7);
        U.viewport = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3);
        const D = [
            P,
            U
        ], y = new (0, $4a792688e08e5cd7$export$56b937d9e5581166);
        let I = null, N = null;
        function O(e) {
            const t = b.indexOf(e.inputSource);
            if (-1 === t) return;
            const n = R[t];
            void 0 !== n && (n.update(e.inputSource, e.frame, d || s), n.dispatchEvent({
                type: e.type,
                data: e.inputSource
            }));
        }
        function B() {
            a.removeEventListener("select", O), a.removeEventListener("selectstart", O), a.removeEventListener("selectend", O), a.removeEventListener("squeeze", O), a.removeEventListener("squeezestart", O), a.removeEventListener("squeezeend", O), a.removeEventListener("end", B), a.removeEventListener("inputsourceschange", G);
            for(let e = 0; e < R.length; e++){
                const t = b[e];
                null !== t && (b[e] = null, R[e].disconnect(t));
            }
            I = null, N = null, g.reset();
            for(const e in v)delete v[e];
            e.setRenderTarget(M), m = null, p = null, f = null, a = null, A = null, W.stop(), i.isPresenting = !1, e.setPixelRatio(L), e.setSize(C.width, C.height, !1), i.dispatchEvent({
                type: "sessionend"
            });
        }
        function G(e) {
            for(let t = 0; t < e.removed.length; t++){
                const n = e.removed[t], i = b.indexOf(n);
                i >= 0 && (b[i] = null, R[i].disconnect(n));
            }
            for(let t = 0; t < e.added.length; t++){
                const n = e.added[t];
                let i = b.indexOf(n);
                if (-1 === i) {
                    for(let e = 0; e < R.length; e++){
                        if (e >= b.length) {
                            b.push(n), i = e;
                            break;
                        }
                        if (null === b[e]) {
                            b[e] = n, i = e;
                            break;
                        }
                    }
                    if (-1 === i) break;
                }
                const r = R[i];
                r && r.connect(n);
            }
        }
        this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(e) {
            let t = R[e];
            return void 0 === t && (t = new (0, $4a792688e08e5cd7$export$cb626c57dcc48b9f), R[e] = t), t.getTargetRaySpace();
        }, this.getControllerGrip = function(e) {
            let t = R[e];
            return void 0 === t && (t = new (0, $4a792688e08e5cd7$export$cb626c57dcc48b9f), R[e] = t), t.getGripSpace();
        }, this.getHand = function(e) {
            let t = R[e];
            return void 0 === t && (t = new (0, $4a792688e08e5cd7$export$cb626c57dcc48b9f), R[e] = t), t.getHandSpace();
        }, this.setFramebufferScaleFactor = function(e) {
            o = e, !0 === i.isPresenting && (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebXRManager: Cannot change framebuffer scale while presenting.");
        }, this.setReferenceSpaceType = function(e) {
            l = e, !0 === i.isPresenting && (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebXRManager: Cannot change reference space type while presenting.");
        }, this.getReferenceSpace = function() {
            return d || s;
        }, this.setReferenceSpace = function(e) {
            d = e;
        }, this.getBaseLayer = function() {
            return null !== p ? p : m;
        }, this.getBinding = function() {
            return null === f && _ && (f = new XRWebGLBinding(a, n)), f;
        }, this.getFrame = function() {
            return h;
        }, this.getSession = function() {
            return a;
        }, this.setSession = async function(t) {
            if (a = t, null !== a) {
                M = e.getRenderTarget(), a.addEventListener("select", O), a.addEventListener("selectstart", O), a.addEventListener("selectend", O), a.addEventListener("squeeze", O), a.addEventListener("squeezestart", O), a.addEventListener("squeezeend", O), a.addEventListener("end", B), a.addEventListener("inputsourceschange", G), !0 !== S.xrCompatible && await n.makeXRCompatible(), L = e.getPixelRatio(), e.getSize(C);
                if (_ && "createProjectionLayer" in XRWebGLBinding.prototype) {
                    let t = null, i = null, r = null;
                    S.depth && (r = S.stencil ? n.DEPTH24_STENCIL8 : n.DEPTH_COMPONENT24, t = S.stencil ? (0, $4a792688e08e5cd7$export$1e113ac2d0905829) : (0, $4a792688e08e5cd7$export$c1b6b5136be58045), i = S.stencil ? (0, $4a792688e08e5cd7$export$6c8ea339bfab1301) : (0, $4a792688e08e5cd7$export$c3c7fc4518ebba96));
                    const s = {
                        colorFormat: n.RGBA8,
                        depthFormat: r,
                        scaleFactor: o
                    };
                    f = this.getBinding(), p = f.createProjectionLayer(s), a.updateRenderState({
                        layers: [
                            p
                        ]
                    }), e.setPixelRatio(1), e.setSize(p.textureWidth, p.textureHeight, !1), A = new (0, $4a792688e08e5cd7$export$3c052beb2e51e23f)(p.textureWidth, p.textureHeight, {
                        format: (0, $4a792688e08e5cd7$export$3f8bb04b555a363c),
                        type: (0, $4a792688e08e5cd7$export$2e8ce08d3f6f5e10),
                        depthTexture: new (0, $4a792688e08e5cd7$export$fc830aa069cc8c2f)(p.textureWidth, p.textureHeight, i, void 0, void 0, void 0, void 0, void 0, void 0, t),
                        stencilBuffer: S.stencil,
                        colorSpace: e.outputColorSpace,
                        samples: S.antialias ? 4 : 0,
                        resolveDepthBuffer: !1 === p.ignoreDepthValues,
                        resolveStencilBuffer: !1 === p.ignoreDepthValues
                    });
                } else {
                    const t = {
                        antialias: S.antialias,
                        alpha: !0,
                        depth: S.depth,
                        stencil: S.stencil,
                        framebufferScaleFactor: o
                    };
                    m = new XRWebGLLayer(a, n, t), a.updateRenderState({
                        baseLayer: m
                    }), e.setPixelRatio(1), e.setSize(m.framebufferWidth, m.framebufferHeight, !1), A = new (0, $4a792688e08e5cd7$export$3c052beb2e51e23f)(m.framebufferWidth, m.framebufferHeight, {
                        format: (0, $4a792688e08e5cd7$export$3f8bb04b555a363c),
                        type: (0, $4a792688e08e5cd7$export$2e8ce08d3f6f5e10),
                        colorSpace: e.outputColorSpace,
                        stencilBuffer: S.stencil,
                        resolveDepthBuffer: !1 === m.ignoreDepthValues,
                        resolveStencilBuffer: !1 === m.ignoreDepthValues
                    });
                }
                A.isXRRenderTarget = !0, this.setFoveation(c), d = null, s = await a.requestReferenceSpace(l), W.setContext(a), W.start(), i.isPresenting = !0, i.dispatchEvent({
                    type: "sessionstart"
                });
            }
        }, this.getEnvironmentBlendMode = function() {
            if (null !== a) return a.environmentBlendMode;
        }, this.getDepthTexture = function() {
            return g.getDepthTexture();
        };
        const H = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), V = new (0, $4a792688e08e5cd7$export$64b5c384219d3699);
        function z(e, t) {
            null === t ? e.matrixWorld.copy(e.matrix) : e.matrixWorld.multiplyMatrices(t.matrixWorld, e.matrix), e.matrixWorldInverse.copy(e.matrixWorld).invert();
        }
        this.updateCamera = function(e) {
            if (null === a) return;
            let t = e.near, n = e.far;
            null !== g.texture && (g.depthNear > 0 && (t = g.depthNear), g.depthFar > 0 && (n = g.depthFar)), y.near = U.near = P.near = t, y.far = U.far = P.far = n, I === y.near && N === y.far || (a.updateRenderState({
                depthNear: y.near,
                depthFar: y.far
            }), I = y.near, N = y.far), y.layers.mask = 6 | e.layers.mask, P.layers.mask = 3 & y.layers.mask, U.layers.mask = 5 & y.layers.mask;
            const i = e.parent, r = y.cameras;
            z(y, i);
            for(let e = 0; e < r.length; e++)z(r[e], i);
            2 === r.length ? function(e, t, n) {
                H.setFromMatrixPosition(t.matrixWorld), V.setFromMatrixPosition(n.matrixWorld);
                const i = H.distanceTo(V), r = t.projectionMatrix.elements, a = n.projectionMatrix.elements, o = r[14] / (r[10] - 1), s = r[14] / (r[10] + 1), l = (r[9] + 1) / r[5], c = (r[9] - 1) / r[5], d = (r[8] - 1) / r[0], u = (a[8] + 1) / a[0], f = o * d, p = o * u, m = i / (-d + u), h = m * -d;
                if (t.matrixWorld.decompose(e.position, e.quaternion, e.scale), e.translateX(h), e.translateZ(m), e.matrixWorld.compose(e.position, e.quaternion, e.scale), e.matrixWorldInverse.copy(e.matrixWorld).invert(), -1 === r[10]) e.projectionMatrix.copy(t.projectionMatrix), e.projectionMatrixInverse.copy(t.projectionMatrixInverse);
                else {
                    const t = o + m, n = s + m, r = f - h, a = p + (i - h), d = l * s / n * t, u = c * s / n * t;
                    e.projectionMatrix.makePerspective(r, a, d, u, t, n), e.projectionMatrixInverse.copy(e.projectionMatrix).invert();
                }
            }(y, P, U) : y.projectionMatrix.copy(P.projectionMatrix), function(e, t, n) {
                null === n ? e.matrix.copy(t.matrixWorld) : (e.matrix.copy(n.matrixWorld), e.matrix.invert(), e.matrix.multiply(t.matrixWorld));
                e.matrix.decompose(e.position, e.quaternion, e.scale), e.updateMatrixWorld(!0), e.projectionMatrix.copy(t.projectionMatrix), e.projectionMatrixInverse.copy(t.projectionMatrixInverse), e.isPerspectiveCamera && (e.fov = 2 * (0, $4a792688e08e5cd7$export$914076c8150813e5) * Math.atan(1 / e.projectionMatrix.elements[5]), e.zoom = 1);
            }(e, y, i);
        }, this.getCamera = function() {
            return y;
        }, this.getFoveation = function() {
            if (null !== p || null !== m) return c;
        }, this.setFoveation = function(e) {
            c = e, null !== p && (p.fixedFoveation = e), null !== m && void 0 !== m.fixedFoveation && (m.fixedFoveation = e);
        }, this.hasDepthSensing = function() {
            return null !== g.texture;
        }, this.getDepthSensingMesh = function() {
            return g.getMesh(y);
        }, this.getCameraTexture = function(e) {
            return v[e];
        };
        let k = null;
        const W = new $5292c45f2b641b96$var$Dn;
        W.setAnimationLoop(function(t, n) {
            if (u = n.getViewerPose(d || s), h = n, null !== u) {
                const t = u.views;
                null !== m && (e.setRenderTargetFramebuffer(A, m.framebuffer), e.setRenderTarget(A));
                let n = !1;
                t.length !== y.cameras.length && (y.cameras.length = 0, n = !0);
                for(let i = 0; i < t.length; i++){
                    const r = t[i];
                    let a = null;
                    if (null !== m) a = m.getViewport(r);
                    else {
                        const t = f.getViewSubImage(p, r);
                        a = t.viewport, 0 === i && (e.setRenderTargetTextures(A, t.colorTexture, t.depthStencilTexture), e.setRenderTarget(A));
                    }
                    let o = D[i];
                    void 0 === o && (o = new (0, $4a792688e08e5cd7$export$74e4ae24825f68d7), o.layers.enable(i), o.viewport = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3), D[i] = o), o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.quaternion, o.scale), o.projectionMatrix.fromArray(r.projectionMatrix), o.projectionMatrixInverse.copy(o.projectionMatrix).invert(), o.viewport.set(a.x, a.y, a.width, a.height), 0 === i && (y.matrix.copy(o.matrix), y.matrix.decompose(y.position, y.quaternion, y.scale)), !0 === n && y.cameras.push(o);
                }
                const r = a.enabledFeatures;
                if (r && r.includes("depth-sensing") && "gpu-optimized" == a.depthUsage && _) {
                    f = i.getBinding();
                    const e = f.getDepthInformation(t[0]);
                    e && e.isValid && e.texture && g.init(e, a.renderState);
                }
                if (r && r.includes("camera-access") && _) {
                    e.state.unbindTexture(), f = i.getBinding();
                    for(let e = 0; e < t.length; e++){
                        const n = t[e].camera;
                        if (n) {
                            let e = v[n];
                            e || (e = new (0, $4a792688e08e5cd7$export$cd10147cacf16ab2), v[n] = e);
                            const t = f.getCameraImage(n);
                            e.sourceTexture = t;
                        }
                    }
                }
            }
            for(let e = 0; e < R.length; e++){
                const t = b[e], i = R[e];
                null !== t && void 0 !== i && i.update(t, n, d || s);
            }
            k && k(t, n), n.detectedPlanes && i.dispatchEvent({
                type: "planesdetected",
                data: n
            }), h = null;
        }), this.setAnimationLoop = function(e) {
            k = e;
        }, this.dispose = function() {};
    }
}
const $5292c45f2b641b96$var$oa = new (0, $4a792688e08e5cd7$export$d93cc409a0768c5f), $5292c45f2b641b96$var$sa = new (0, $4a792688e08e5cd7$export$2ae72fc923e5eb5);
function $5292c45f2b641b96$var$la(e, t) {
    function n(e, t) {
        !0 === e.matrixAutoUpdate && e.updateMatrix(), t.value.copy(e.matrix);
    }
    function i(e, i) {
        e.opacity.value = i.opacity, i.color && e.diffuse.value.copy(i.color), i.emissive && e.emissive.value.copy(i.emissive).multiplyScalar(i.emissiveIntensity), i.map && (e.map.value = i.map, n(i.map, e.mapTransform)), i.alphaMap && (e.alphaMap.value = i.alphaMap, n(i.alphaMap, e.alphaMapTransform)), i.bumpMap && (e.bumpMap.value = i.bumpMap, n(i.bumpMap, e.bumpMapTransform), e.bumpScale.value = i.bumpScale, i.side === (0, $4a792688e08e5cd7$export$d9f0486e75b5ace) && (e.bumpScale.value *= -1)), i.normalMap && (e.normalMap.value = i.normalMap, n(i.normalMap, e.normalMapTransform), e.normalScale.value.copy(i.normalScale), i.side === (0, $4a792688e08e5cd7$export$d9f0486e75b5ace) && e.normalScale.value.negate()), i.displacementMap && (e.displacementMap.value = i.displacementMap, n(i.displacementMap, e.displacementMapTransform), e.displacementScale.value = i.displacementScale, e.displacementBias.value = i.displacementBias), i.emissiveMap && (e.emissiveMap.value = i.emissiveMap, n(i.emissiveMap, e.emissiveMapTransform)), i.specularMap && (e.specularMap.value = i.specularMap, n(i.specularMap, e.specularMapTransform)), i.alphaTest > 0 && (e.alphaTest.value = i.alphaTest);
        const r = t.get(i), a = r.envMap, o = r.envMapRotation;
        a && (e.envMap.value = a, $5292c45f2b641b96$var$oa.copy(o), $5292c45f2b641b96$var$oa.x *= -1, $5292c45f2b641b96$var$oa.y *= -1, $5292c45f2b641b96$var$oa.z *= -1, a.isCubeTexture && !1 === a.isRenderTargetTexture && ($5292c45f2b641b96$var$oa.y *= -1, $5292c45f2b641b96$var$oa.z *= -1), e.envMapRotation.value.setFromMatrix4($5292c45f2b641b96$var$sa.makeRotationFromEuler($5292c45f2b641b96$var$oa)), e.flipEnvMap.value = a.isCubeTexture && !1 === a.isRenderTargetTexture ? -1 : 1, e.reflectivity.value = i.reflectivity, e.ior.value = i.ior, e.refractionRatio.value = i.refractionRatio), i.lightMap && (e.lightMap.value = i.lightMap, e.lightMapIntensity.value = i.lightMapIntensity, n(i.lightMap, e.lightMapTransform)), i.aoMap && (e.aoMap.value = i.aoMap, e.aoMapIntensity.value = i.aoMapIntensity, n(i.aoMap, e.aoMapTransform));
    }
    return {
        refreshFogUniforms: function(t, n) {
            n.color.getRGB(t.fogColor.value, (0, $4a792688e08e5cd7$export$a630742c640528c1)(e)), n.isFog ? (t.fogNear.value = n.near, t.fogFar.value = n.far) : n.isFogExp2 && (t.fogDensity.value = n.density);
        },
        refreshMaterialUniforms: function(e, r, a, o, s) {
            r.isMeshBasicMaterial || r.isMeshLambertMaterial ? i(e, r) : r.isMeshToonMaterial ? (i(e, r), function(e, t) {
                t.gradientMap && (e.gradientMap.value = t.gradientMap);
            }(e, r)) : r.isMeshPhongMaterial ? (i(e, r), function(e, t) {
                e.specular.value.copy(t.specular), e.shininess.value = Math.max(t.shininess, 1e-4);
            }(e, r)) : r.isMeshStandardMaterial ? (i(e, r), function(e, t) {
                e.metalness.value = t.metalness, t.metalnessMap && (e.metalnessMap.value = t.metalnessMap, n(t.metalnessMap, e.metalnessMapTransform));
                e.roughness.value = t.roughness, t.roughnessMap && (e.roughnessMap.value = t.roughnessMap, n(t.roughnessMap, e.roughnessMapTransform));
                t.envMap && (e.envMapIntensity.value = t.envMapIntensity);
            }(e, r), r.isMeshPhysicalMaterial && function(e, t, i) {
                e.ior.value = t.ior, t.sheen > 0 && (e.sheenColor.value.copy(t.sheenColor).multiplyScalar(t.sheen), e.sheenRoughness.value = t.sheenRoughness, t.sheenColorMap && (e.sheenColorMap.value = t.sheenColorMap, n(t.sheenColorMap, e.sheenColorMapTransform)), t.sheenRoughnessMap && (e.sheenRoughnessMap.value = t.sheenRoughnessMap, n(t.sheenRoughnessMap, e.sheenRoughnessMapTransform)));
                t.clearcoat > 0 && (e.clearcoat.value = t.clearcoat, e.clearcoatRoughness.value = t.clearcoatRoughness, t.clearcoatMap && (e.clearcoatMap.value = t.clearcoatMap, n(t.clearcoatMap, e.clearcoatMapTransform)), t.clearcoatRoughnessMap && (e.clearcoatRoughnessMap.value = t.clearcoatRoughnessMap, n(t.clearcoatRoughnessMap, e.clearcoatRoughnessMapTransform)), t.clearcoatNormalMap && (e.clearcoatNormalMap.value = t.clearcoatNormalMap, n(t.clearcoatNormalMap, e.clearcoatNormalMapTransform), e.clearcoatNormalScale.value.copy(t.clearcoatNormalScale), t.side === (0, $4a792688e08e5cd7$export$d9f0486e75b5ace) && e.clearcoatNormalScale.value.negate()));
                t.dispersion > 0 && (e.dispersion.value = t.dispersion);
                t.iridescence > 0 && (e.iridescence.value = t.iridescence, e.iridescenceIOR.value = t.iridescenceIOR, e.iridescenceThicknessMinimum.value = t.iridescenceThicknessRange[0], e.iridescenceThicknessMaximum.value = t.iridescenceThicknessRange[1], t.iridescenceMap && (e.iridescenceMap.value = t.iridescenceMap, n(t.iridescenceMap, e.iridescenceMapTransform)), t.iridescenceThicknessMap && (e.iridescenceThicknessMap.value = t.iridescenceThicknessMap, n(t.iridescenceThicknessMap, e.iridescenceThicknessMapTransform)));
                t.transmission > 0 && (e.transmission.value = t.transmission, e.transmissionSamplerMap.value = i.texture, e.transmissionSamplerSize.value.set(i.width, i.height), t.transmissionMap && (e.transmissionMap.value = t.transmissionMap, n(t.transmissionMap, e.transmissionMapTransform)), e.thickness.value = t.thickness, t.thicknessMap && (e.thicknessMap.value = t.thicknessMap, n(t.thicknessMap, e.thicknessMapTransform)), e.attenuationDistance.value = t.attenuationDistance, e.attenuationColor.value.copy(t.attenuationColor));
                t.anisotropy > 0 && (e.anisotropyVector.value.set(t.anisotropy * Math.cos(t.anisotropyRotation), t.anisotropy * Math.sin(t.anisotropyRotation)), t.anisotropyMap && (e.anisotropyMap.value = t.anisotropyMap, n(t.anisotropyMap, e.anisotropyMapTransform)));
                e.specularIntensity.value = t.specularIntensity, e.specularColor.value.copy(t.specularColor), t.specularColorMap && (e.specularColorMap.value = t.specularColorMap, n(t.specularColorMap, e.specularColorMapTransform));
                t.specularIntensityMap && (e.specularIntensityMap.value = t.specularIntensityMap, n(t.specularIntensityMap, e.specularIntensityMapTransform));
            }(e, r, s)) : r.isMeshMatcapMaterial ? (i(e, r), function(e, t) {
                t.matcap && (e.matcap.value = t.matcap);
            }(e, r)) : r.isMeshDepthMaterial ? i(e, r) : r.isMeshDistanceMaterial ? (i(e, r), function(e, n) {
                const i = t.get(n).light;
                e.referencePosition.value.setFromMatrixPosition(i.matrixWorld), e.nearDistance.value = i.shadow.camera.near, e.farDistance.value = i.shadow.camera.far;
            }(e, r)) : r.isMeshNormalMaterial ? i(e, r) : r.isLineBasicMaterial ? (function(e, t) {
                e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, t.map && (e.map.value = t.map, n(t.map, e.mapTransform));
            }(e, r), r.isLineDashedMaterial && function(e, t) {
                e.dashSize.value = t.dashSize, e.totalSize.value = t.dashSize + t.gapSize, e.scale.value = t.scale;
            }(e, r)) : r.isPointsMaterial ? function(e, t, i, r) {
                e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, e.size.value = t.size * i, e.scale.value = .5 * r, t.map && (e.map.value = t.map, n(t.map, e.uvTransform));
                t.alphaMap && (e.alphaMap.value = t.alphaMap, n(t.alphaMap, e.alphaMapTransform));
                t.alphaTest > 0 && (e.alphaTest.value = t.alphaTest);
            }(e, r, a, o) : r.isSpriteMaterial ? function(e, t) {
                e.diffuse.value.copy(t.color), e.opacity.value = t.opacity, e.rotation.value = t.rotation, t.map && (e.map.value = t.map, n(t.map, e.mapTransform));
                t.alphaMap && (e.alphaMap.value = t.alphaMap, n(t.alphaMap, e.alphaMapTransform));
                t.alphaTest > 0 && (e.alphaTest.value = t.alphaTest);
            }(e, r) : r.isShadowMaterial ? (e.color.value.copy(r.color), e.opacity.value = r.opacity) : r.isShaderMaterial && (r.uniformsNeedUpdate = !1);
        }
    };
}
function $5292c45f2b641b96$var$ca(e, t, n, i) {
    let r = {}, a = {}, o = [];
    const s = e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS);
    function l(e, t, n, i) {
        const r = e.value, a = t + "_" + n;
        if (void 0 === i[a]) return i[a] = "number" == typeof r || "boolean" == typeof r ? r : r.clone(), !0;
        {
            const e = i[a];
            if ("number" == typeof r || "boolean" == typeof r) {
                if (e !== r) return i[a] = r, !0;
            } else if (!1 === e.equals(r)) return e.copy(r), !0;
        }
        return !1;
    }
    function c(e) {
        const t = {
            boundary: 0,
            storage: 0
        };
        return "number" == typeof e || "boolean" == typeof e ? (t.boundary = 4, t.storage = 4) : e.isVector2 ? (t.boundary = 8, t.storage = 8) : e.isVector3 || e.isColor ? (t.boundary = 16, t.storage = 12) : e.isVector4 ? (t.boundary = 16, t.storage = 16) : e.isMatrix3 ? (t.boundary = 48, t.storage = 48) : e.isMatrix4 ? (t.boundary = 64, t.storage = 64) : e.isTexture ? (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Texture samplers can not be part of an uniforms group.") : (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Unsupported uniform value type.", e), t;
    }
    function d(t) {
        const n = t.target;
        n.removeEventListener("dispose", d);
        const i = o.indexOf(n.__bindingPointIndex);
        o.splice(i, 1), e.deleteBuffer(r[n.id]), delete r[n.id], delete a[n.id];
    }
    return {
        bind: function(e, t) {
            const n = t.program;
            i.uniformBlockBinding(e, n);
        },
        update: function(n, u) {
            let f = r[n.id];
            void 0 === f && (!function(e) {
                const t = e.uniforms;
                let n = 0;
                const i = 16;
                for(let e = 0, r = t.length; e < r; e++){
                    const r = Array.isArray(t[e]) ? t[e] : [
                        t[e]
                    ];
                    for(let e = 0, t = r.length; e < t; e++){
                        const t = r[e], a = Array.isArray(t.value) ? t.value : [
                            t.value
                        ];
                        for(let e = 0, r = a.length; e < r; e++){
                            const r = c(a[e]), o = n % i, s = o % r.boundary, l = o + s;
                            n += s, 0 !== l && i - l < r.storage && (n += i - l), t.__data = new Float32Array(r.storage / Float32Array.BYTES_PER_ELEMENT), t.__offset = n, n += r.storage;
                        }
                    }
                }
                const r = n % i;
                r > 0 && (n += i - r);
                e.__size = n, e.__cache = {};
            }(n), f = function(t) {
                const n = function() {
                    for(let e = 0; e < s; e++)if (-1 === o.indexOf(e)) return o.push(e), e;
                    return (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
                }();
                t.__bindingPointIndex = n;
                const i = e.createBuffer(), r = t.__size, a = t.usage;
                return e.bindBuffer(e.UNIFORM_BUFFER, i), e.bufferData(e.UNIFORM_BUFFER, r, a), e.bindBuffer(e.UNIFORM_BUFFER, null), e.bindBufferBase(e.UNIFORM_BUFFER, n, i), i;
            }(n), r[n.id] = f, n.addEventListener("dispose", d));
            const p = u.program;
            i.updateUBOMapping(n, p);
            const m = t.render.frame;
            a[n.id] !== m && (!function(t) {
                const n = r[t.id], i = t.uniforms, a = t.__cache;
                e.bindBuffer(e.UNIFORM_BUFFER, n);
                for(let t = 0, n = i.length; t < n; t++){
                    const n = Array.isArray(i[t]) ? i[t] : [
                        i[t]
                    ];
                    for(let i = 0, r = n.length; i < r; i++){
                        const r = n[i];
                        if (!0 === l(r, t, i, a)) {
                            const t = r.__offset, n = Array.isArray(r.value) ? r.value : [
                                r.value
                            ];
                            let i = 0;
                            for(let a = 0; a < n.length; a++){
                                const o = n[a], s = c(o);
                                "number" == typeof o || "boolean" == typeof o ? (r.__data[0] = o, e.bufferSubData(e.UNIFORM_BUFFER, t + i, r.__data)) : o.isMatrix3 ? (r.__data[0] = o.elements[0], r.__data[1] = o.elements[1], r.__data[2] = o.elements[2], r.__data[3] = 0, r.__data[4] = o.elements[3], r.__data[5] = o.elements[4], r.__data[6] = o.elements[5], r.__data[7] = 0, r.__data[8] = o.elements[6], r.__data[9] = o.elements[7], r.__data[10] = o.elements[8], r.__data[11] = 0) : (o.toArray(r.__data, i), i += s.storage / Float32Array.BYTES_PER_ELEMENT);
                            }
                            e.bufferSubData(e.UNIFORM_BUFFER, t, r.__data);
                        }
                    }
                }
                e.bindBuffer(e.UNIFORM_BUFFER, null);
            }(n), a[n.id] = m);
        },
        dispose: function() {
            for(const t in r)e.deleteBuffer(r[t]);
            o = [], r = {}, a = {};
        }
    };
}
const $5292c45f2b641b96$var$da = new Uint16Array([
    11481,
    15204,
    11534,
    15171,
    11808,
    15015,
    12385,
    14843,
    12894,
    14716,
    13396,
    14600,
    13693,
    14483,
    13976,
    14366,
    14237,
    14171,
    14405,
    13961,
    14511,
    13770,
    14605,
    13598,
    14687,
    13444,
    14760,
    13305,
    14822,
    13066,
    14876,
    12857,
    14923,
    12675,
    14963,
    12517,
    14997,
    12379,
    15025,
    12230,
    15049,
    12023,
    15070,
    11843,
    15086,
    11687,
    15100,
    11551,
    15111,
    11433,
    15120,
    11330,
    15127,
    11217,
    15132,
    11060,
    15135,
    10922,
    15138,
    10801,
    15139,
    10695,
    15139,
    10600,
    13012,
    14923,
    13020,
    14917,
    13064,
    14886,
    13176,
    14800,
    13349,
    14666,
    13513,
    14526,
    13724,
    14398,
    13960,
    14230,
    14200,
    14020,
    14383,
    13827,
    14488,
    13651,
    14583,
    13491,
    14667,
    13348,
    14740,
    13132,
    14803,
    12908,
    14856,
    12713,
    14901,
    12542,
    14938,
    12394,
    14968,
    12241,
    14992,
    12017,
    15010,
    11822,
    15024,
    11654,
    15034,
    11507,
    15041,
    11380,
    15044,
    11269,
    15044,
    11081,
    15042,
    10913,
    15037,
    10764,
    15031,
    10635,
    15023,
    10520,
    15014,
    10419,
    15003,
    10330,
    13657,
    14676,
    13658,
    14673,
    13670,
    14660,
    13698,
    14622,
    13750,
    14547,
    13834,
    14442,
    13956,
    14317,
    14112,
    14093,
    14291,
    13889,
    14407,
    13704,
    14499,
    13538,
    14586,
    13389,
    14664,
    13201,
    14733,
    12966,
    14792,
    12758,
    14842,
    12577,
    14882,
    12418,
    14915,
    12272,
    14940,
    12033,
    14959,
    11826,
    14972,
    11646,
    14980,
    11490,
    14983,
    11355,
    14983,
    11212,
    14979,
    11008,
    14971,
    10830,
    14961,
    10675,
    14950,
    10540,
    14936,
    10420,
    14923,
    10315,
    14909,
    10204,
    14894,
    10041,
    14089,
    14460,
    14090,
    14459,
    14096,
    14452,
    14112,
    14431,
    14141,
    14388,
    14186,
    14305,
    14252,
    14130,
    14341,
    13941,
    14399,
    13756,
    14467,
    13585,
    14539,
    13430,
    14610,
    13272,
    14677,
    13026,
    14737,
    12808,
    14790,
    12617,
    14833,
    12449,
    14869,
    12303,
    14896,
    12065,
    14916,
    11845,
    14929,
    11655,
    14937,
    11490,
    14939,
    11347,
    14936,
    11184,
    14930,
    10970,
    14921,
    10783,
    14912,
    10621,
    14900,
    10480,
    14885,
    10356,
    14867,
    10247,
    14848,
    10062,
    14827,
    9894,
    14805,
    9745,
    14400,
    14208,
    14400,
    14206,
    14402,
    14198,
    14406,
    14174,
    14415,
    14122,
    14427,
    14035,
    14444,
    13913,
    14469,
    13767,
    14504,
    13613,
    14548,
    13463,
    14598,
    13324,
    14651,
    13082,
    14704,
    12858,
    14752,
    12658,
    14795,
    12483,
    14831,
    12330,
    14860,
    12106,
    14881,
    11875,
    14895,
    11675,
    14903,
    11501,
    14905,
    11351,
    14903,
    11178,
    14900,
    10953,
    14892,
    10757,
    14880,
    10589,
    14865,
    10442,
    14847,
    10313,
    14827,
    10162,
    14805,
    9965,
    14782,
    9792,
    14757,
    9642,
    14731,
    9507,
    14562,
    13883,
    14562,
    13883,
    14563,
    13877,
    14566,
    13862,
    14570,
    13830,
    14576,
    13773,
    14584,
    13689,
    14595,
    13582,
    14613,
    13461,
    14637,
    13336,
    14668,
    13120,
    14704,
    12897,
    14741,
    12695,
    14776,
    12516,
    14808,
    12358,
    14835,
    12150,
    14856,
    11910,
    14870,
    11701,
    14878,
    11519,
    14882,
    11361,
    14884,
    11187,
    14880,
    10951,
    14871,
    10748,
    14858,
    10572,
    14842,
    10418,
    14823,
    10286,
    14801,
    10099,
    14777,
    9897,
    14751,
    9722,
    14725,
    9567,
    14696,
    9430,
    14666,
    9309,
    14702,
    13604,
    14702,
    13604,
    14702,
    13600,
    14703,
    13591,
    14705,
    13570,
    14707,
    13533,
    14709,
    13477,
    14712,
    13400,
    14718,
    13305,
    14727,
    13106,
    14743,
    12907,
    14762,
    12716,
    14784,
    12539,
    14807,
    12380,
    14827,
    12190,
    14844,
    11943,
    14855,
    11727,
    14863,
    11539,
    14870,
    11376,
    14871,
    11204,
    14868,
    10960,
    14858,
    10748,
    14845,
    10565,
    14829,
    10406,
    14809,
    10269,
    14786,
    10058,
    14761,
    9852,
    14734,
    9671,
    14705,
    9512,
    14674,
    9374,
    14641,
    9253,
    14608,
    9076,
    14821,
    13366,
    14821,
    13365,
    14821,
    13364,
    14821,
    13358,
    14821,
    13344,
    14821,
    13320,
    14819,
    13252,
    14817,
    13145,
    14815,
    13011,
    14814,
    12858,
    14817,
    12698,
    14823,
    12539,
    14832,
    12389,
    14841,
    12214,
    14850,
    11968,
    14856,
    11750,
    14861,
    11558,
    14866,
    11390,
    14867,
    11226,
    14862,
    10972,
    14853,
    10754,
    14840,
    10565,
    14823,
    10401,
    14803,
    10259,
    14780,
    10032,
    14754,
    9820,
    14725,
    9635,
    14694,
    9473,
    14661,
    9333,
    14627,
    9203,
    14593,
    8988,
    14557,
    8798,
    14923,
    13014,
    14922,
    13014,
    14922,
    13012,
    14922,
    13004,
    14920,
    12987,
    14919,
    12957,
    14915,
    12907,
    14909,
    12834,
    14902,
    12738,
    14894,
    12623,
    14888,
    12498,
    14883,
    12370,
    14880,
    12203,
    14878,
    11970,
    14875,
    11759,
    14873,
    11569,
    14874,
    11401,
    14872,
    11243,
    14865,
    10986,
    14855,
    10762,
    14842,
    10568,
    14825,
    10401,
    14804,
    10255,
    14781,
    10017,
    14754,
    9799,
    14725,
    9611,
    14692,
    9445,
    14658,
    9301,
    14623,
    9139,
    14587,
    8920,
    14548,
    8729,
    14509,
    8562,
    15008,
    12672,
    15008,
    12672,
    15008,
    12671,
    15007,
    12667,
    15005,
    12656,
    15001,
    12637,
    14997,
    12605,
    14989,
    12556,
    14978,
    12490,
    14966,
    12407,
    14953,
    12313,
    14940,
    12136,
    14927,
    11934,
    14914,
    11742,
    14903,
    11563,
    14896,
    11401,
    14889,
    11247,
    14879,
    10992,
    14866,
    10767,
    14851,
    10570,
    14833,
    10400,
    14812,
    10252,
    14789,
    10007,
    14761,
    9784,
    14731,
    9592,
    14698,
    9424,
    14663,
    9279,
    14627,
    9088,
    14588,
    8868,
    14548,
    8676,
    14508,
    8508,
    14467,
    8360,
    15080,
    12386,
    15080,
    12386,
    15079,
    12385,
    15078,
    12383,
    15076,
    12378,
    15072,
    12367,
    15066,
    12347,
    15057,
    12315,
    15045,
    12253,
    15030,
    12138,
    15012,
    11998,
    14993,
    11845,
    14972,
    11685,
    14951,
    11530,
    14935,
    11383,
    14920,
    11228,
    14904,
    10981,
    14887,
    10762,
    14870,
    10567,
    14850,
    10397,
    14827,
    10248,
    14803,
    9997,
    14774,
    9771,
    14743,
    9578,
    14710,
    9407,
    14674,
    9259,
    14637,
    9048,
    14596,
    8826,
    14555,
    8632,
    14514,
    8464,
    14471,
    8317,
    14427,
    8182,
    15139,
    12008,
    15139,
    12008,
    15138,
    12008,
    15137,
    12007,
    15135,
    12003,
    15130,
    11990,
    15124,
    11969,
    15115,
    11929,
    15102,
    11872,
    15086,
    11794,
    15064,
    11693,
    15041,
    11581,
    15013,
    11459,
    14987,
    11336,
    14966,
    11170,
    14944,
    10944,
    14921,
    10738,
    14898,
    10552,
    14875,
    10387,
    14850,
    10239,
    14824,
    9983,
    14794,
    9758,
    14762,
    9563,
    14728,
    9392,
    14692,
    9244,
    14653,
    9014,
    14611,
    8791,
    14569,
    8597,
    14526,
    8427,
    14481,
    8281,
    14436,
    8110,
    14391,
    7885,
    15188,
    11617,
    15188,
    11617,
    15187,
    11617,
    15186,
    11618,
    15183,
    11617,
    15179,
    11612,
    15173,
    11601,
    15163,
    11581,
    15150,
    11546,
    15133,
    11495,
    15110,
    11427,
    15083,
    11346,
    15051,
    11246,
    15024,
    11057,
    14996,
    10868,
    14967,
    10687,
    14938,
    10517,
    14911,
    10362,
    14882,
    10206,
    14853,
    9956,
    14821,
    9737,
    14787,
    9543,
    14752,
    9375,
    14715,
    9228,
    14675,
    8980,
    14632,
    8760,
    14589,
    8565,
    14544,
    8395,
    14498,
    8248,
    14451,
    8049,
    14404,
    7824,
    14357,
    7630,
    15228,
    11298,
    15228,
    11298,
    15227,
    11299,
    15226,
    11301,
    15223,
    11303,
    15219,
    11302,
    15213,
    11299,
    15204,
    11290,
    15191,
    11271,
    15174,
    11217,
    15150,
    11129,
    15119,
    11015,
    15087,
    10886,
    15057,
    10744,
    15024,
    10599,
    14990,
    10455,
    14957,
    10318,
    14924,
    10143,
    14891,
    9911,
    14856,
    9701,
    14820,
    9516,
    14782,
    9352,
    14744,
    9200,
    14703,
    8946,
    14659,
    8725,
    14615,
    8533,
    14568,
    8366,
    14521,
    8220,
    14472,
    7992,
    14423,
    7770,
    14374,
    7578,
    14315,
    7408,
    15260,
    10819,
    15260,
    10819,
    15259,
    10822,
    15258,
    10826,
    15256,
    10832,
    15251,
    10836,
    15246,
    10841,
    15237,
    10838,
    15225,
    10821,
    15207,
    10788,
    15183,
    10734,
    15151,
    10660,
    15120,
    10571,
    15087,
    10469,
    15049,
    10359,
    15012,
    10249,
    14974,
    10041,
    14937,
    9837,
    14900,
    9647,
    14860,
    9475,
    14820,
    9320,
    14779,
    9147,
    14736,
    8902,
    14691,
    8688,
    14646,
    8499,
    14598,
    8335,
    14549,
    8189,
    14499,
    7940,
    14448,
    7720,
    14397,
    7529,
    14347,
    7363,
    14256,
    7218,
    15285,
    10410,
    15285,
    10411,
    15285,
    10413,
    15284,
    10418,
    15282,
    10425,
    15278,
    10434,
    15272,
    10442,
    15264,
    10449,
    15252,
    10445,
    15235,
    10433,
    15210,
    10403,
    15179,
    10358,
    15149,
    10301,
    15113,
    10218,
    15073,
    10059,
    15033,
    9894,
    14991,
    9726,
    14951,
    9565,
    14909,
    9413,
    14865,
    9273,
    14822,
    9073,
    14777,
    8845,
    14730,
    8641,
    14682,
    8459,
    14633,
    8300,
    14583,
    8129,
    14531,
    7883,
    14479,
    7670,
    14426,
    7482,
    14373,
    7321,
    14305,
    7176,
    14201,
    6939,
    15305,
    9939,
    15305,
    9940,
    15305,
    9945,
    15304,
    9955,
    15302,
    9967,
    15298,
    9989,
    15293,
    10010,
    15286,
    10033,
    15274,
    10044,
    15258,
    10045,
    15233,
    10022,
    15205,
    9975,
    15174,
    9903,
    15136,
    9808,
    15095,
    9697,
    15053,
    9578,
    15009,
    9451,
    14965,
    9327,
    14918,
    9198,
    14871,
    8973,
    14825,
    8766,
    14775,
    8579,
    14725,
    8408,
    14675,
    8259,
    14622,
    8058,
    14569,
    7821,
    14515,
    7615,
    14460,
    7435,
    14405,
    7276,
    14350,
    7108,
    14256,
    6866,
    14149,
    6653,
    15321,
    9444,
    15321,
    9445,
    15321,
    9448,
    15320,
    9458,
    15317,
    9470,
    15314,
    9490,
    15310,
    9515,
    15302,
    9540,
    15292,
    9562,
    15276,
    9579,
    15251,
    9577,
    15226,
    9559,
    15195,
    9519,
    15156,
    9463,
    15116,
    9389,
    15071,
    9304,
    15025,
    9208,
    14978,
    9023,
    14927,
    8838,
    14878,
    8661,
    14827,
    8496,
    14774,
    8344,
    14722,
    8206,
    14667,
    7973,
    14612,
    7749,
    14556,
    7555,
    14499,
    7382,
    14443,
    7229,
    14385,
    7025,
    14322,
    6791,
    14210,
    6588,
    14100,
    6409,
    15333,
    8920,
    15333,
    8921,
    15332,
    8927,
    15332,
    8943,
    15329,
    8965,
    15326,
    9002,
    15322,
    9048,
    15316,
    9106,
    15307,
    9162,
    15291,
    9204,
    15267,
    9221,
    15244,
    9221,
    15212,
    9196,
    15175,
    9134,
    15133,
    9043,
    15088,
    8930,
    15040,
    8801,
    14990,
    8665,
    14938,
    8526,
    14886,
    8391,
    14830,
    8261,
    14775,
    8087,
    14719,
    7866,
    14661,
    7664,
    14603,
    7482,
    14544,
    7322,
    14485,
    7178,
    14426,
    6936,
    14367,
    6713,
    14281,
    6517,
    14166,
    6348,
    14054,
    6198,
    15341,
    8360,
    15341,
    8361,
    15341,
    8366,
    15341,
    8379,
    15339,
    8399,
    15336,
    8431,
    15332,
    8473,
    15326,
    8527,
    15318,
    8585,
    15302,
    8632,
    15281,
    8670,
    15258,
    8690,
    15227,
    8690,
    15191,
    8664,
    15149,
    8612,
    15104,
    8543,
    15055,
    8456,
    15001,
    8360,
    14948,
    8259,
    14892,
    8122,
    14834,
    7923,
    14776,
    7734,
    14716,
    7558,
    14656,
    7397,
    14595,
    7250,
    14534,
    7070,
    14472,
    6835,
    14410,
    6628,
    14350,
    6443,
    14243,
    6283,
    14125,
    6135,
    14010,
    5889,
    15348,
    7715,
    15348,
    7717,
    15348,
    7725,
    15347,
    7745,
    15345,
    7780,
    15343,
    7836,
    15339,
    7905,
    15334,
    8e3,
    15326,
    8103,
    15310,
    8193,
    15293,
    8239,
    15270,
    8270,
    15240,
    8287,
    15204,
    8283,
    15163,
    8260,
    15118,
    8223,
    15067,
    8143,
    15014,
    8014,
    14958,
    7873,
    14899,
    7723,
    14839,
    7573,
    14778,
    7430,
    14715,
    7293,
    14652,
    7164,
    14588,
    6931,
    14524,
    6720,
    14460,
    6531,
    14396,
    6362,
    14330,
    6210,
    14207,
    6015,
    14086,
    5781,
    13969,
    5576,
    15352,
    7114,
    15352,
    7116,
    15352,
    7128,
    15352,
    7159,
    15350,
    7195,
    15348,
    7237,
    15345,
    7299,
    15340,
    7374,
    15332,
    7457,
    15317,
    7544,
    15301,
    7633,
    15280,
    7703,
    15251,
    7754,
    15216,
    7775,
    15176,
    7767,
    15131,
    7733,
    15079,
    7670,
    15026,
    7588,
    14967,
    7492,
    14906,
    7387,
    14844,
    7278,
    14779,
    7171,
    14714,
    6965,
    14648,
    6770,
    14581,
    6587,
    14515,
    6420,
    14448,
    6269,
    14382,
    6123,
    14299,
    5881,
    14172,
    5665,
    14049,
    5477,
    13929,
    5310,
    15355,
    6329,
    15355,
    6330,
    15355,
    6339,
    15355,
    6362,
    15353,
    6410,
    15351,
    6472,
    15349,
    6572,
    15344,
    6688,
    15337,
    6835,
    15323,
    6985,
    15309,
    7142,
    15287,
    7220,
    15260,
    7277,
    15226,
    7310,
    15188,
    7326,
    15142,
    7318,
    15090,
    7285,
    15036,
    7239,
    14976,
    7177,
    14914,
    7045,
    14849,
    6892,
    14782,
    6736,
    14714,
    6581,
    14645,
    6433,
    14576,
    6293,
    14506,
    6164,
    14438,
    5946,
    14369,
    5733,
    14270,
    5540,
    14140,
    5369,
    14014,
    5216,
    13892,
    5043,
    15357,
    5483,
    15357,
    5484,
    15357,
    5496,
    15357,
    5528,
    15356,
    5597,
    15354,
    5692,
    15351,
    5835,
    15347,
    6011,
    15339,
    6195,
    15328,
    6317,
    15314,
    6446,
    15293,
    6566,
    15268,
    6668,
    15235,
    6746,
    15197,
    6796,
    15152,
    6811,
    15101,
    6790,
    15046,
    6748,
    14985,
    6673,
    14921,
    6583,
    14854,
    6479,
    14785,
    6371,
    14714,
    6259,
    14643,
    6149,
    14571,
    5946,
    14499,
    5750,
    14428,
    5567,
    14358,
    5401,
    14242,
    5250,
    14109,
    5111,
    13980,
    4870,
    13856,
    4657,
    15359,
    4555,
    15359,
    4557,
    15358,
    4573,
    15358,
    4633,
    15357,
    4715,
    15355,
    4841,
    15353,
    5061,
    15349,
    5216,
    15342,
    5391,
    15331,
    5577,
    15318,
    5770,
    15299,
    5967,
    15274,
    6150,
    15243,
    6223,
    15206,
    6280,
    15161,
    6310,
    15111,
    6317,
    15055,
    6300,
    14994,
    6262,
    14928,
    6208,
    14860,
    6141,
    14788,
    5994,
    14715,
    5838,
    14641,
    5684,
    14566,
    5529,
    14492,
    5384,
    14418,
    5247,
    14346,
    5121,
    14216,
    4892,
    14079,
    4682,
    13948,
    4496,
    13822,
    4330,
    15359,
    3498,
    15359,
    3501,
    15359,
    3520,
    15359,
    3598,
    15358,
    3719,
    15356,
    3860,
    15355,
    4137,
    15351,
    4305,
    15344,
    4563,
    15334,
    4809,
    15321,
    5116,
    15303,
    5273,
    15280,
    5418,
    15250,
    5547,
    15214,
    5653,
    15170,
    5722,
    15120,
    5761,
    15064,
    5763,
    15002,
    5733,
    14935,
    5673,
    14865,
    5597,
    14792,
    5504,
    14716,
    5400,
    14640,
    5294,
    14563,
    5185,
    14486,
    5041,
    14410,
    4841,
    14335,
    4655,
    14191,
    4482,
    14051,
    4325,
    13918,
    4183,
    13790,
    4012,
    15360,
    2282,
    15360,
    2285,
    15360,
    2306,
    15360,
    2401,
    15359,
    2547,
    15357,
    2748,
    15355,
    3103,
    15352,
    3349,
    15345,
    3675,
    15336,
    4020,
    15324,
    4272,
    15307,
    4496,
    15285,
    4716,
    15255,
    4908,
    15220,
    5086,
    15178,
    5170,
    15128,
    5214,
    15072,
    5234,
    15010,
    5231,
    14943,
    5206,
    14871,
    5166,
    14796,
    5102,
    14718,
    4971,
    14639,
    4833,
    14559,
    4687,
    14480,
    4541,
    14402,
    4401,
    14315,
    4268,
    14167,
    4142,
    14025,
    3958,
    13888,
    3747,
    13759,
    3556,
    15360,
    923,
    15360,
    925,
    15360,
    946,
    15360,
    1052,
    15359,
    1214,
    15357,
    1494,
    15356,
    1892,
    15352,
    2274,
    15346,
    2663,
    15338,
    3099,
    15326,
    3393,
    15309,
    3679,
    15288,
    3980,
    15260,
    4183,
    15226,
    4325,
    15185,
    4437,
    15136,
    4517,
    15080,
    4570,
    15018,
    4591,
    14950,
    4581,
    14877,
    4545,
    14800,
    4485,
    14720,
    4411,
    14638,
    4325,
    14556,
    4231,
    14475,
    4136,
    14395,
    3988,
    14297,
    3803,
    14145,
    3628,
    13999,
    3465,
    13861,
    3314,
    13729,
    3177,
    15360,
    263,
    15360,
    264,
    15360,
    272,
    15360,
    325,
    15359,
    407,
    15358,
    548,
    15356,
    780,
    15352,
    1144,
    15347,
    1580,
    15339,
    2099,
    15328,
    2425,
    15312,
    2795,
    15292,
    3133,
    15264,
    3329,
    15232,
    3517,
    15191,
    3689,
    15143,
    3819,
    15088,
    3923,
    15025,
    3978,
    14956,
    3999,
    14882,
    3979,
    14804,
    3931,
    14722,
    3855,
    14639,
    3756,
    14554,
    3645,
    14470,
    3529,
    14388,
    3409,
    14279,
    3289,
    14124,
    3173,
    13975,
    3055,
    13834,
    2848,
    13701,
    2658,
    15360,
    49,
    15360,
    49,
    15360,
    52,
    15360,
    75,
    15359,
    111,
    15358,
    201,
    15356,
    283,
    15353,
    519,
    15348,
    726,
    15340,
    1045,
    15329,
    1415,
    15314,
    1795,
    15295,
    2173,
    15269,
    2410,
    15237,
    2649,
    15197,
    2866,
    15150,
    3054,
    15095,
    3140,
    15032,
    3196,
    14963,
    3228,
    14888,
    3236,
    14808,
    3224,
    14725,
    3191,
    14639,
    3146,
    14553,
    3088,
    14466,
    2976,
    14382,
    2836,
    14262,
    2692,
    14103,
    2549,
    13952,
    2409,
    13808,
    2278,
    13674,
    2154,
    15360,
    4,
    15360,
    4,
    15360,
    4,
    15360,
    13,
    15359,
    33,
    15358,
    59,
    15357,
    112,
    15353,
    199,
    15348,
    302,
    15341,
    456,
    15331,
    628,
    15316,
    827,
    15297,
    1082,
    15272,
    1332,
    15241,
    1601,
    15202,
    1851,
    15156,
    2069,
    15101,
    2172,
    15039,
    2256,
    14970,
    2314,
    14894,
    2348,
    14813,
    2358,
    14728,
    2344,
    14640,
    2311,
    14551,
    2263,
    14463,
    2203,
    14376,
    2133,
    14247,
    2059,
    14084,
    1915,
    13930,
    1761,
    13784,
    1609,
    13648,
    1464,
    15360,
    0,
    15360,
    0,
    15360,
    0,
    15360,
    3,
    15359,
    18,
    15358,
    26,
    15357,
    53,
    15354,
    80,
    15348,
    97,
    15341,
    165,
    15332,
    238,
    15318,
    326,
    15299,
    427,
    15275,
    529,
    15245,
    654,
    15207,
    771,
    15161,
    885,
    15108,
    994,
    15046,
    1089,
    14976,
    1170,
    14900,
    1229,
    14817,
    1266,
    14731,
    1284,
    14641,
    1282,
    14550,
    1260,
    14460,
    1223,
    14370,
    1174,
    14232,
    1116,
    14066,
    1050,
    13909,
    981,
    13761,
    910,
    13623,
    839
]);
let $5292c45f2b641b96$var$ua = null;
class $5292c45f2b641b96$export$f6cc00ef28d7cf97 {
    constructor(e = {}){
        const { canvas: t = (0, $4a792688e08e5cd7$export$1033a2df66368859)(), context: i = null, depth: a = !0, stencil: o = !1, alpha: s = !1, antialias: l = !1, premultipliedAlpha: d = !0, preserveDrawingBuffer: u = !1, powerPreference: m = "default", failIfMajorPerformanceCaveat: h = !1, reversedDepthBuffer: g = !1 } = e;
        let v;
        if (this.isWebGLRenderer = !0, null !== i) {
            if ("undefined" != typeof WebGLRenderingContext && i instanceof WebGLRenderingContext) throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
            v = i.getContextAttributes().alpha;
        } else v = s;
        const M = new Set([
            (0, $4a792688e08e5cd7$export$c200e7d26f592f21),
            (0, $4a792688e08e5cd7$export$1ba1c45f9f77d4d7),
            (0, $4a792688e08e5cd7$export$aa92e870a709d190)
        ]), x = new Set([
            (0, $4a792688e08e5cd7$export$2e8ce08d3f6f5e10),
            (0, $4a792688e08e5cd7$export$c3c7fc4518ebba96),
            (0, $4a792688e08e5cd7$export$c63dc51868b06a9d),
            (0, $4a792688e08e5cd7$export$6c8ea339bfab1301),
            (0, $4a792688e08e5cd7$export$b3969b01faf587f2),
            (0, $4a792688e08e5cd7$export$18886f8ae33e90de)
        ]), A = new Uint32Array(4), R = new Int32Array(4);
        let b = null, C = null;
        const L = [], P = [];
        this.domElement = t, this.debug = {
            checkShaderErrors: !0,
            onShaderError: null
        }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = (0, $4a792688e08e5cd7$export$9fcb6b4294603b2), this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
        const U = this;
        let D = !1;
        this._outputColorSpace = (0, $4a792688e08e5cd7$export$561f394b24edfcaa);
        let w = 0, I = 0, O = null, B = -1, z = null;
        const k = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3), W = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3);
        let Y = null;
        const K = new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0);
        let q = 0, j = t.width, Z = t.height, $ = 1, Q = null, J = null;
        const ee = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3)(0, 0, j, Z), te = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3)(0, 0, j, Z);
        let ne = !1;
        const ie = new (0, $4a792688e08e5cd7$export$35efe6f4c85463d2);
        let re = !1, ae = !1;
        const oe = new (0, $4a792688e08e5cd7$export$2ae72fc923e5eb5), se = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), le = new (0, $4a792688e08e5cd7$export$fa7daccca11cdbe3), ce = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: !0
        };
        let de = !1;
        function ue() {
            return null === O ? $ : 1;
        }
        let fe, pe, he, _e, ge, ve, Se, Te, Me, xe, Ae, Re, be, Ce, Le, Pe, Ue, De, we, ye, Ie, Ne, Oe, Fe, Be = i;
        function Ge(e, n) {
            return t.getContext(e, n);
        }
        try {
            const e = {
                alpha: !0,
                depth: a,
                stencil: o,
                antialias: l,
                premultipliedAlpha: d,
                preserveDrawingBuffer: u,
                powerPreference: m,
                failIfMajorPerformanceCaveat: h
            };
            if ("setAttribute" in t && t.setAttribute("data-engine", `three.js r${(0, $4a792688e08e5cd7$export$3545e07a80636437)}`), t.addEventListener("webglcontextlost", ze, !1), t.addEventListener("webglcontextrestored", ke, !1), t.addEventListener("webglcontextcreationerror", We, !1), null === Be) {
                const t = "webgl2";
                if (Be = Ge(t, e), null === Be) throw Ge(t) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
            }
        } catch (e) {
            throw e("WebGLRenderer: " + e.message), e;
        }
        function He() {
            fe = new $5292c45f2b641b96$var$si(Be), fe.init(), Ne = new $5292c45f2b641b96$export$ddaebcad857649a8(Be, fe), pe = new $5292c45f2b641b96$var$zn(Be, fe, e, Ne), he = new $5292c45f2b641b96$var$ta(Be, fe), pe.reversedDepthBuffer && g && he.buffers.depth.setReversed(!0), _e = new $5292c45f2b641b96$var$di(Be), ge = new $5292c45f2b641b96$var$zr, ve = new $5292c45f2b641b96$var$na(Be, fe, he, ge, pe, Ne, _e), Se = new $5292c45f2b641b96$var$Wn(U), Te = new $5292c45f2b641b96$var$oi(U), Me = new $5292c45f2b641b96$var$wn(Be), Oe = new $5292c45f2b641b96$var$Hn(Be, Me), xe = new $5292c45f2b641b96$var$li(Be, Me, _e, Oe), Ae = new $5292c45f2b641b96$var$fi(Be, xe, Me, _e), we = new $5292c45f2b641b96$var$ui(Be, pe, ve), Pe = new $5292c45f2b641b96$var$kn(ge), Re = new $5292c45f2b641b96$var$Vr(U, Se, Te, fe, pe, Oe, Pe), be = new $5292c45f2b641b96$var$la(U, ge), Ce = new $5292c45f2b641b96$var$Yr, Le = new $5292c45f2b641b96$var$Qr(fe), De = new $5292c45f2b641b96$var$Gn(U, Se, Te, he, Ae, v, d), Ue = new $5292c45f2b641b96$var$Jr(U, Ae, pe), Fe = new $5292c45f2b641b96$var$ca(Be, _e, pe, he), ye = new $5292c45f2b641b96$var$Vn(Be, fe, _e), Ie = new $5292c45f2b641b96$var$ci(Be, fe, _e), _e.programs = Re.programs, U.capabilities = pe, U.extensions = fe, U.properties = ge, U.renderLists = Ce, U.shadowMap = Ue, U.state = he, U.info = _e;
        }
        He();
        const Ve = new $5292c45f2b641b96$var$aa(U, Be);
        function ze(e) {
            e.preventDefault(), (0, $4a792688e08e5cd7$export$bef1f36f5486a6a3)("WebGLRenderer: Context Lost."), D = !0;
        }
        function ke() {
            (0, $4a792688e08e5cd7$export$bef1f36f5486a6a3)("WebGLRenderer: Context Restored."), D = !1;
            const e = _e.autoReset, t = Ue.enabled, n = Ue.autoUpdate, i = Ue.needsUpdate, r = Ue.type;
            He(), _e.autoReset = e, Ue.enabled = t, Ue.autoUpdate = n, Ue.needsUpdate = i, Ue.type = r;
        }
        function We(e) {
            (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLRenderer: A WebGL context could not be created. Reason: ", e.statusMessage);
        }
        function Xe(e) {
            const t = e.target;
            t.removeEventListener("dispose", Xe), function(e) {
                (function(e) {
                    const t = ge.get(e).programs;
                    void 0 !== t && (t.forEach(function(e) {
                        Re.releaseProgram(e);
                    }), e.isShaderMaterial && Re.releaseShaderCache(e));
                })(e), ge.remove(e);
            }(t);
        }
        function Ye(e, t, n) {
            !0 === e.transparent && e.side === (0, $4a792688e08e5cd7$export$3b296b6f144d5b03) && !1 === e.forceSinglePass ? (e.side = (0, $4a792688e08e5cd7$export$d9f0486e75b5ace), e.needsUpdate = !0, nt(e, t, n), e.side = (0, $4a792688e08e5cd7$export$2ede184fc2998901), e.needsUpdate = !0, nt(e, t, n), e.side = (0, $4a792688e08e5cd7$export$3b296b6f144d5b03)) : nt(e, t, n);
        }
        this.xr = Ve, this.getContext = function() {
            return Be;
        }, this.getContextAttributes = function() {
            return Be.getContextAttributes();
        }, this.forceContextLoss = function() {
            const e = fe.get("WEBGL_lose_context");
            e && e.loseContext();
        }, this.forceContextRestore = function() {
            const e = fe.get("WEBGL_lose_context");
            e && e.restoreContext();
        }, this.getPixelRatio = function() {
            return $;
        }, this.setPixelRatio = function(e) {
            void 0 !== e && ($ = e, this.setSize(j, Z, !1));
        }, this.getSize = function(e) {
            return e.set(j, Z);
        }, this.setSize = function(e, n, i = !0) {
            Ve.isPresenting ? (0, $4a792688e08e5cd7$export$c106dd0671a0fc2d)("WebGLRenderer: Can't change size while VR device is presenting.") : (j = e, Z = n, t.width = Math.floor(e * $), t.height = Math.floor(n * $), !0 === i && (t.style.width = e + "px", t.style.height = n + "px"), this.setViewport(0, 0, e, n));
        }, this.getDrawingBufferSize = function(e) {
            return e.set(j * $, Z * $).floor();
        }, this.setDrawingBufferSize = function(e, n, i) {
            j = e, Z = n, $ = i, t.width = Math.floor(e * i), t.height = Math.floor(n * i), this.setViewport(0, 0, e, n);
        }, this.getCurrentViewport = function(e) {
            return e.copy(k);
        }, this.getViewport = function(e) {
            return e.copy(ee);
        }, this.setViewport = function(e, t, n, i) {
            e.isVector4 ? ee.set(e.x, e.y, e.z, e.w) : ee.set(e, t, n, i), he.viewport(k.copy(ee).multiplyScalar($).round());
        }, this.getScissor = function(e) {
            return e.copy(te);
        }, this.setScissor = function(e, t, n, i) {
            e.isVector4 ? te.set(e.x, e.y, e.z, e.w) : te.set(e, t, n, i), he.scissor(W.copy(te).multiplyScalar($).round());
        }, this.getScissorTest = function() {
            return ne;
        }, this.setScissorTest = function(e) {
            he.setScissorTest(ne = e);
        }, this.setOpaqueSort = function(e) {
            Q = e;
        }, this.setTransparentSort = function(e) {
            J = e;
        }, this.getClearColor = function(e) {
            return e.copy(De.getClearColor());
        }, this.setClearColor = function() {
            De.setClearColor(...arguments);
        }, this.getClearAlpha = function() {
            return De.getClearAlpha();
        }, this.setClearAlpha = function() {
            De.setClearAlpha(...arguments);
        }, this.clear = function(e = !0, t = !0, n = !0) {
            let i = 0;
            if (e) {
                let e = !1;
                if (null !== O) {
                    const t = O.texture.format;
                    e = M.has(t);
                }
                if (e) {
                    const e = O.texture.type, t = x.has(e), n = De.getClearColor(), i = De.getClearAlpha(), r = n.r, a = n.g, o = n.b;
                    t ? (A[0] = r, A[1] = a, A[2] = o, A[3] = i, Be.clearBufferuiv(Be.COLOR, 0, A)) : (R[0] = r, R[1] = a, R[2] = o, R[3] = i, Be.clearBufferiv(Be.COLOR, 0, R));
                } else i |= Be.COLOR_BUFFER_BIT;
            }
            t && (i |= Be.DEPTH_BUFFER_BIT), n && (i |= Be.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), Be.clear(i);
        }, this.clearColor = function() {
            this.clear(!0, !1, !1);
        }, this.clearDepth = function() {
            this.clear(!1, !0, !1);
        }, this.clearStencil = function() {
            this.clear(!1, !1, !0);
        }, this.dispose = function() {
            t.removeEventListener("webglcontextlost", ze, !1), t.removeEventListener("webglcontextrestored", ke, !1), t.removeEventListener("webglcontextcreationerror", We, !1), De.dispose(), Ce.dispose(), Le.dispose(), ge.dispose(), Se.dispose(), Te.dispose(), Ae.dispose(), Oe.dispose(), Fe.dispose(), Re.dispose(), Ve.dispose(), Ve.removeEventListener("sessionstart", qe), Ve.removeEventListener("sessionend", je), Ze.stop();
        }, this.renderBufferDirect = function(e, t, n, i, r, a) {
            null === t && (t = ce);
            const o = r.isMesh && r.matrixWorld.determinant() < 0, s = function(e, t, n, i, r) {
                !0 !== t.isScene && (t = ce);
                ve.resetTextureUnits();
                const a = t.fog, o = i.isMeshStandardMaterial ? t.environment : null, s = null === O ? U.outputColorSpace : !0 === O.isXRRenderTarget ? O.texture.colorSpace : (0, $4a792688e08e5cd7$export$42429b3acfb233a4), l = (i.isMeshStandardMaterial ? Te : Se).get(i.envMap || o), c = !0 === i.vertexColors && !!n.attributes.color && 4 === n.attributes.color.itemSize, d = !!n.attributes.tangent && (!!i.normalMap || i.anisotropy > 0), u = !!n.morphAttributes.position, f = !!n.morphAttributes.normal, p = !!n.morphAttributes.color;
                let m = (0, $4a792688e08e5cd7$export$9fcb6b4294603b2);
                i.toneMapped && (null !== O && !0 !== O.isXRRenderTarget || (m = U.toneMapping));
                const h = n.morphAttributes.position || n.morphAttributes.normal || n.morphAttributes.color, _ = void 0 !== h ? h.length : 0, g = ge.get(i), v = C.state.lights;
                if (!0 === re && (!0 === ae || e !== z)) {
                    const t = e === z && i.id === B;
                    Pe.setState(i, e, t);
                }
                let E = !1;
                i.version === g.__version ? g.needsLights && g.lightsStateVersion !== v.state.version || g.outputColorSpace !== s || r.isBatchedMesh && !1 === g.batching ? E = !0 : r.isBatchedMesh || !0 !== g.batching ? r.isBatchedMesh && !0 === g.batchingColor && null === r.colorTexture || r.isBatchedMesh && !1 === g.batchingColor && null !== r.colorTexture || r.isInstancedMesh && !1 === g.instancing ? E = !0 : r.isInstancedMesh || !0 !== g.instancing ? r.isSkinnedMesh && !1 === g.skinning ? E = !0 : r.isSkinnedMesh || !0 !== g.skinning ? r.isInstancedMesh && !0 === g.instancingColor && null === r.instanceColor || r.isInstancedMesh && !1 === g.instancingColor && null !== r.instanceColor || r.isInstancedMesh && !0 === g.instancingMorph && null === r.morphTexture || r.isInstancedMesh && !1 === g.instancingMorph && null !== r.morphTexture || g.envMap !== l || !0 === i.fog && g.fog !== a ? E = !0 : void 0 === g.numClippingPlanes || g.numClippingPlanes === Pe.numPlanes && g.numIntersection === Pe.numIntersection ? (g.vertexAlphas !== c || g.vertexTangents !== d || g.morphTargets !== u || g.morphNormals !== f || g.morphColors !== p || g.toneMapping !== m || g.morphTargetsCount !== _) && (E = !0) : E = !0 : E = !0 : E = !0 : E = !0 : (E = !0, g.__version = i.version);
                let T = g.currentProgram;
                !0 === E && (T = nt(i, t, r));
                let M = !1, x = !1, A = !1;
                const R = T.getUniforms(), b = g.uniforms;
                he.useProgram(T.program) && (M = !0, x = !0, A = !0);
                i.id !== B && (B = i.id, x = !0);
                if (M || z !== e) {
                    he.buffers.depth.getReversed() && !0 !== e.reversedDepth && (e._reversedDepth = !0, e.updateProjectionMatrix()), R.setValue(Be, "projectionMatrix", e.projectionMatrix), R.setValue(Be, "viewMatrix", e.matrixWorldInverse);
                    const t = R.map.cameraPosition;
                    void 0 !== t && t.setValue(Be, se.setFromMatrixPosition(e.matrixWorld)), pe.logarithmicDepthBuffer && R.setValue(Be, "logDepthBufFC", 2 / (Math.log(e.far + 1) / Math.LN2)), (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial) && R.setValue(Be, "isOrthographic", !0 === e.isOrthographicCamera), z !== e && (z = e, x = !0, A = !0);
                }
                if (r.isSkinnedMesh) {
                    R.setOptional(Be, r, "bindMatrix"), R.setOptional(Be, r, "bindMatrixInverse");
                    const e = r.skeleton;
                    e && (null === e.boneTexture && e.computeBoneTexture(), R.setValue(Be, "boneTexture", e.boneTexture, ve));
                }
                r.isBatchedMesh && (R.setOptional(Be, r, "batchingTexture"), R.setValue(Be, "batchingTexture", r._matricesTexture, ve), R.setOptional(Be, r, "batchingIdTexture"), R.setValue(Be, "batchingIdTexture", r._indirectTexture, ve), R.setOptional(Be, r, "batchingColorTexture"), null !== r._colorsTexture && R.setValue(Be, "batchingColorTexture", r._colorsTexture, ve));
                const L = n.morphAttributes;
                void 0 === L.position && void 0 === L.normal && void 0 === L.color || we.update(r, n, T);
                (x || g.receiveShadow !== r.receiveShadow) && (g.receiveShadow = r.receiveShadow, R.setValue(Be, "receiveShadow", r.receiveShadow));
                i.isMeshGouraudMaterial && null !== i.envMap && (b.envMap.value = l, b.flipEnvMap.value = l.isCubeTexture && !1 === l.isRenderTargetTexture ? -1 : 1);
                i.isMeshStandardMaterial && null === i.envMap && null !== t.environment && (b.envMapIntensity.value = t.environmentIntensity);
                void 0 !== b.dfgLUT && (b.dfgLUT.value = (null === $5292c45f2b641b96$var$ua && ($5292c45f2b641b96$var$ua = new (0, $4a792688e08e5cd7$export$b691f601014eabe1)($5292c45f2b641b96$var$da, 32, 32, (0, $4a792688e08e5cd7$export$6cdf0b461c7ce8a0), (0, $4a792688e08e5cd7$export$2697304443f382bc)), $5292c45f2b641b96$var$ua.minFilter = (0, $4a792688e08e5cd7$export$8a72f490b25c56c8), $5292c45f2b641b96$var$ua.magFilter = (0, $4a792688e08e5cd7$export$8a72f490b25c56c8), $5292c45f2b641b96$var$ua.wrapS = (0, $4a792688e08e5cd7$export$9d9334239a5a5e06), $5292c45f2b641b96$var$ua.wrapT = (0, $4a792688e08e5cd7$export$9d9334239a5a5e06), $5292c45f2b641b96$var$ua.generateMipmaps = !1, $5292c45f2b641b96$var$ua.needsUpdate = !0), $5292c45f2b641b96$var$ua));
                x && (R.setValue(Be, "toneMappingExposure", U.toneMappingExposure), g.needsLights && (D = A, (P = b).ambientLightColor.needsUpdate = D, P.lightProbe.needsUpdate = D, P.directionalLights.needsUpdate = D, P.directionalLightShadows.needsUpdate = D, P.pointLights.needsUpdate = D, P.pointLightShadows.needsUpdate = D, P.spotLights.needsUpdate = D, P.spotLightShadows.needsUpdate = D, P.rectAreaLights.needsUpdate = D, P.hemisphereLights.needsUpdate = D), a && !0 === i.fog && be.refreshFogUniforms(b, a), be.refreshMaterialUniforms(b, i, $, Z, C.state.transmissionRenderTarget[e.id]), $5292c45f2b641b96$var$gr.upload(Be, it(g), b, ve));
                var P, D;
                i.isShaderMaterial && !0 === i.uniformsNeedUpdate && ($5292c45f2b641b96$var$gr.upload(Be, it(g), b, ve), i.uniformsNeedUpdate = !1);
                i.isSpriteMaterial && R.setValue(Be, "center", r.center);
                if (R.setValue(Be, "modelViewMatrix", r.modelViewMatrix), R.setValue(Be, "normalMatrix", r.normalMatrix), R.setValue(Be, "modelMatrix", r.matrixWorld), i.isShaderMaterial || i.isRawShaderMaterial) {
                    const e = i.uniformsGroups;
                    for(let t = 0, n = e.length; t < n; t++){
                        const n = e[t];
                        Fe.update(n, T), Fe.bind(n, T);
                    }
                }
                return T;
            }(e, t, n, i, r);
            he.setMaterial(i, o);
            let l = n.index, c = 1;
            if (!0 === i.wireframe) {
                if (l = xe.getWireframeAttribute(n), void 0 === l) return;
                c = 2;
            }
            const d = n.drawRange, u = n.attributes.position;
            let f = d.start * c, p = (d.start + d.count) * c;
            null !== a && (f = Math.max(f, a.start * c), p = Math.min(p, (a.start + a.count) * c)), null !== l ? (f = Math.max(f, 0), p = Math.min(p, l.count)) : null != u && (f = Math.max(f, 0), p = Math.min(p, u.count));
            const m = p - f;
            if (m < 0 || m === 1 / 0) return;
            let h;
            Oe.setup(r, i, s, n, l);
            let _ = ye;
            if (null !== l && (h = Me.get(l), _ = Ie, _.setIndex(h)), r.isMesh) !0 === i.wireframe ? (he.setLineWidth(i.wireframeLinewidth * ue()), _.setMode(Be.LINES)) : _.setMode(Be.TRIANGLES);
            else if (r.isLine) {
                let e = i.linewidth;
                void 0 === e && (e = 1), he.setLineWidth(e * ue()), r.isLineSegments ? _.setMode(Be.LINES) : r.isLineLoop ? _.setMode(Be.LINE_LOOP) : _.setMode(Be.LINE_STRIP);
            } else r.isPoints ? _.setMode(Be.POINTS) : r.isSprite && _.setMode(Be.TRIANGLES);
            if (r.isBatchedMesh) {
                if (null !== r._multiDrawInstances) (0, $4a792688e08e5cd7$export$5b28268982f175ba)("WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection."), _.renderMultiDrawInstances(r._multiDrawStarts, r._multiDrawCounts, r._multiDrawCount, r._multiDrawInstances);
                else if (fe.get("WEBGL_multi_draw")) _.renderMultiDraw(r._multiDrawStarts, r._multiDrawCounts, r._multiDrawCount);
                else {
                    const e = r._multiDrawStarts, t = r._multiDrawCounts, n = r._multiDrawCount, a = l ? Me.get(l).bytesPerElement : 1, o = ge.get(i).currentProgram.getUniforms();
                    for(let i = 0; i < n; i++)o.setValue(Be, "_gl_DrawID", i), _.render(e[i] / a, t[i]);
                }
            } else if (r.isInstancedMesh) _.renderInstances(f, m, r.count);
            else if (n.isInstancedBufferGeometry) {
                const e = void 0 !== n._maxInstanceCount ? n._maxInstanceCount : 1 / 0, t = Math.min(n.instanceCount, e);
                _.renderInstances(f, m, t);
            } else _.render(f, m);
        }, this.compile = function(e, t, n = null) {
            null === n && (n = e), C = Le.get(n), C.init(t), P.push(C), n.traverseVisible(function(e) {
                e.isLight && e.layers.test(t.layers) && (C.pushLight(e), e.castShadow && C.pushShadow(e));
            }), e !== n && e.traverseVisible(function(e) {
                e.isLight && e.layers.test(t.layers) && (C.pushLight(e), e.castShadow && C.pushShadow(e));
            }), C.setupLights();
            const i = new Set;
            return e.traverse(function(e) {
                if (!(e.isMesh || e.isPoints || e.isLine || e.isSprite)) return;
                const t = e.material;
                if (t) {
                    if (Array.isArray(t)) for(let r = 0; r < t.length; r++){
                        const a = t[r];
                        Ye(a, n, e), i.add(a);
                    }
                    else Ye(t, n, e), i.add(t);
                }
            }), C = P.pop(), i;
        }, this.compileAsync = function(e, t, n = null) {
            const i = this.compile(e, t, n);
            return new Promise((t)=>{
                function n() {
                    i.forEach(function(e) {
                        ge.get(e).currentProgram.isReady() && i.delete(e);
                    }), 0 !== i.size ? setTimeout(n, 10) : t(e);
                }
                null !== fe.get("KHR_parallel_shader_compile") ? n() : setTimeout(n, 10);
            });
        };
        let Ke = null;
        function qe() {
            Ze.stop();
        }
        function je() {
            Ze.start();
        }
        const Ze = new $5292c45f2b641b96$var$Dn;
        function $e(e, t, n, i) {
            if (!1 === e.visible) return;
            if (e.layers.test(t.layers)) {
                if (e.isGroup) n = e.renderOrder;
                else if (e.isLOD) !0 === e.autoUpdate && e.update(t);
                else if (e.isLight) C.pushLight(e), e.castShadow && C.pushShadow(e);
                else if (e.isSprite) {
                    if (!e.frustumCulled || ie.intersectsSprite(e)) {
                        i && le.setFromMatrixPosition(e.matrixWorld).applyMatrix4(oe);
                        const t = Ae.update(e), r = e.material;
                        r.visible && b.push(e, t, r, n, le.z, null);
                    }
                } else if ((e.isMesh || e.isLine || e.isPoints) && (!e.frustumCulled || ie.intersectsObject(e))) {
                    const t = Ae.update(e), r = e.material;
                    if (i && (void 0 !== e.boundingSphere ? (null === e.boundingSphere && e.computeBoundingSphere(), le.copy(e.boundingSphere.center)) : (null === t.boundingSphere && t.computeBoundingSphere(), le.copy(t.boundingSphere.center)), le.applyMatrix4(e.matrixWorld).applyMatrix4(oe)), Array.isArray(r)) {
                        const i = t.groups;
                        for(let a = 0, o = i.length; a < o; a++){
                            const o = i[a], s = r[o.materialIndex];
                            s && s.visible && b.push(e, t, s, n, le.z, o);
                        }
                    } else r.visible && b.push(e, t, r, n, le.z, null);
                }
            }
            const r = e.children;
            for(let e = 0, a = r.length; e < a; e++)$e(r[e], t, n, i);
        }
        function Qe(e, t, n, i) {
            const { opaque: r, transmissive: a, transparent: o } = e;
            C.setupLightsView(n), !0 === re && Pe.setGlobalState(U.clippingPlanes, n), i && he.viewport(k.copy(i)), r.length > 0 && et(r, t, n), a.length > 0 && et(a, t, n), o.length > 0 && et(o, t, n), he.buffers.depth.setTest(!0), he.buffers.depth.setMask(!0), he.buffers.color.setMask(!0), he.setPolygonOffset(!1);
        }
        function Je(e, t, n, i) {
            if (null !== (!0 === n.isScene ? n.overrideMaterial : null)) return;
            void 0 === C.state.transmissionRenderTarget[i.id] && (C.state.transmissionRenderTarget[i.id] = new (0, $4a792688e08e5cd7$export$3c052beb2e51e23f)(1, 1, {
                generateMipmaps: !0,
                type: fe.has("EXT_color_buffer_half_float") || fe.has("EXT_color_buffer_float") ? (0, $4a792688e08e5cd7$export$2697304443f382bc) : (0, $4a792688e08e5cd7$export$2e8ce08d3f6f5e10),
                minFilter: (0, $4a792688e08e5cd7$export$5d8599b6a933fb1b),
                samples: 4,
                stencilBuffer: o,
                resolveDepthBuffer: !1,
                resolveStencilBuffer: !1,
                colorSpace: (0, $4a792688e08e5cd7$export$5e6fd513f44698c).workingColorSpace
            }));
            const r = C.state.transmissionRenderTarget[i.id], a = i.viewport || k;
            r.setSize(a.z * U.transmissionResolutionScale, a.w * U.transmissionResolutionScale);
            const s = U.getRenderTarget(), l = U.getActiveCubeFace(), d = U.getActiveMipmapLevel();
            U.setRenderTarget(r), U.getClearColor(K), q = U.getClearAlpha(), q < 1 && U.setClearColor(16777215, .5), U.clear(), de && De.render(n);
            const u = U.toneMapping;
            U.toneMapping = (0, $4a792688e08e5cd7$export$9fcb6b4294603b2);
            const f = i.viewport;
            if (void 0 !== i.viewport && (i.viewport = void 0), C.setupLightsView(i), !0 === re && Pe.setGlobalState(U.clippingPlanes, i), et(e, n, i), ve.updateMultisampleRenderTarget(r), ve.updateRenderTargetMipmap(r), !1 === fe.has("WEBGL_multisampled_render_to_texture")) {
                let e = !1;
                for(let r = 0, a = t.length; r < a; r++){
                    const a = t[r], { object: o, geometry: s, material: l, group: d } = a;
                    if (l.side === (0, $4a792688e08e5cd7$export$3b296b6f144d5b03) && o.layers.test(i.layers)) {
                        const t = l.side;
                        l.side = (0, $4a792688e08e5cd7$export$d9f0486e75b5ace), l.needsUpdate = !0, tt(o, n, i, s, l, d), l.side = t, l.needsUpdate = !0, e = !0;
                    }
                }
                !0 === e && (ve.updateMultisampleRenderTarget(r), ve.updateRenderTargetMipmap(r));
            }
            U.setRenderTarget(s, l, d), U.setClearColor(K, q), void 0 !== f && (i.viewport = f), U.toneMapping = u;
        }
        function et(e, t, n) {
            const i = !0 === t.isScene ? t.overrideMaterial : null;
            for(let r = 0, a = e.length; r < a; r++){
                const a = e[r], { object: o, geometry: s, group: l } = a;
                let c = a.material;
                !0 === c.allowOverride && null !== i && (c = i), o.layers.test(n.layers) && tt(o, t, n, s, c, l);
            }
        }
        function tt(e, t, n, i, r, a) {
            e.onBeforeRender(U, t, n, i, r, a), e.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, e.matrixWorld), e.normalMatrix.getNormalMatrix(e.modelViewMatrix), r.onBeforeRender(U, t, n, i, e, a), !0 === r.transparent && r.side === (0, $4a792688e08e5cd7$export$3b296b6f144d5b03) && !1 === r.forceSinglePass ? (r.side = (0, $4a792688e08e5cd7$export$d9f0486e75b5ace), r.needsUpdate = !0, U.renderBufferDirect(n, t, i, r, e, a), r.side = (0, $4a792688e08e5cd7$export$2ede184fc2998901), r.needsUpdate = !0, U.renderBufferDirect(n, t, i, r, e, a), r.side = (0, $4a792688e08e5cd7$export$3b296b6f144d5b03)) : U.renderBufferDirect(n, t, i, r, e, a), e.onAfterRender(U, t, n, i, r, a);
        }
        function nt(e, t, n) {
            !0 !== t.isScene && (t = ce);
            const i = ge.get(e), r = C.state.lights, a = C.state.shadowsArray, o = r.state.version, s = Re.getParameters(e, r.state, a, t, n), l = Re.getProgramCacheKey(s);
            let c = i.programs;
            i.environment = e.isMeshStandardMaterial ? t.environment : null, i.fog = t.fog, i.envMap = (e.isMeshStandardMaterial ? Te : Se).get(e.envMap || i.environment), i.envMapRotation = null !== i.environment && null === e.envMap ? t.environmentRotation : e.envMapRotation, void 0 === c && (e.addEventListener("dispose", Xe), c = new Map, i.programs = c);
            let d = c.get(l);
            if (void 0 !== d) {
                if (i.currentProgram === d && i.lightsStateVersion === o) return rt(e, s), d;
            } else s.uniforms = Re.getUniforms(e), e.onBeforeCompile(s, U), d = Re.acquireProgram(s, l), c.set(l, d), i.uniforms = s.uniforms;
            const u = i.uniforms;
            return (e.isShaderMaterial || e.isRawShaderMaterial) && !0 !== e.clipping || (u.clippingPlanes = Pe.uniform), rt(e, s), i.needsLights = function(e) {
                return e.isMeshLambertMaterial || e.isMeshToonMaterial || e.isMeshPhongMaterial || e.isMeshStandardMaterial || e.isShadowMaterial || e.isShaderMaterial && !0 === e.lights;
            }(e), i.lightsStateVersion = o, i.needsLights && (u.ambientLightColor.value = r.state.ambient, u.lightProbe.value = r.state.probe, u.directionalLights.value = r.state.directional, u.directionalLightShadows.value = r.state.directionalShadow, u.spotLights.value = r.state.spot, u.spotLightShadows.value = r.state.spotShadow, u.rectAreaLights.value = r.state.rectArea, u.ltc_1.value = r.state.rectAreaLTC1, u.ltc_2.value = r.state.rectAreaLTC2, u.pointLights.value = r.state.point, u.pointLightShadows.value = r.state.pointShadow, u.hemisphereLights.value = r.state.hemi, u.directionalShadowMap.value = r.state.directionalShadowMap, u.directionalShadowMatrix.value = r.state.directionalShadowMatrix, u.spotShadowMap.value = r.state.spotShadowMap, u.spotLightMatrix.value = r.state.spotLightMatrix, u.spotLightMap.value = r.state.spotLightMap, u.pointShadowMap.value = r.state.pointShadowMap, u.pointShadowMatrix.value = r.state.pointShadowMatrix), i.currentProgram = d, i.uniformsList = null, d;
        }
        function it(e) {
            if (null === e.uniformsList) {
                const t = e.currentProgram.getUniforms();
                e.uniformsList = $5292c45f2b641b96$var$gr.seqWithValue(t.seq, e.uniforms);
            }
            return e.uniformsList;
        }
        function rt(e, t) {
            const n = ge.get(e);
            n.outputColorSpace = t.outputColorSpace, n.batching = t.batching, n.batchingColor = t.batchingColor, n.instancing = t.instancing, n.instancingColor = t.instancingColor, n.instancingMorph = t.instancingMorph, n.skinning = t.skinning, n.morphTargets = t.morphTargets, n.morphNormals = t.morphNormals, n.morphColors = t.morphColors, n.morphTargetsCount = t.morphTargetsCount, n.numClippingPlanes = t.numClippingPlanes, n.numIntersection = t.numClipIntersection, n.vertexAlphas = t.vertexAlphas, n.vertexTangents = t.vertexTangents, n.toneMapping = t.toneMapping;
        }
        Ze.setAnimationLoop(function(e) {
            Ke && Ke(e);
        }), "undefined" != typeof self && Ze.setContext(self), this.setAnimationLoop = function(e) {
            Ke = e, Ve.setAnimationLoop(e), null === e ? Ze.stop() : Ze.start();
        }, Ve.addEventListener("sessionstart", qe), Ve.addEventListener("sessionend", je), this.render = function(e, t) {
            if (void 0 !== t && !0 !== t.isCamera) return void (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            if (!0 === D) return;
            if (!0 === e.matrixWorldAutoUpdate && e.updateMatrixWorld(), null === t.parent && !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), !0 === Ve.enabled && !0 === Ve.isPresenting && (!0 === Ve.cameraAutoUpdate && Ve.updateCamera(t), t = Ve.getCamera()), !0 === e.isScene && e.onBeforeRender(U, e, t, O), C = Le.get(e, P.length), C.init(t), P.push(C), oe.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), ie.setFromProjectionMatrix(oe, (0, $4a792688e08e5cd7$export$5a0e9190d10875d3), t.reversedDepth), ae = this.localClippingEnabled, re = Pe.init(this.clippingPlanes, ae), b = Ce.get(e, L.length), b.init(), L.push(b), !0 === Ve.enabled && !0 === Ve.isPresenting) {
                const e = U.xr.getDepthSensingMesh();
                null !== e && $e(e, t, -1 / 0, U.sortObjects);
            }
            $e(e, t, 0, U.sortObjects), b.finish(), !0 === U.sortObjects && b.sort(Q, J), de = !1 === Ve.enabled || !1 === Ve.isPresenting || !1 === Ve.hasDepthSensing(), de && De.addToRenderList(b, e), this.info.render.frame++, !0 === re && Pe.beginShadows();
            const n = C.state.shadowsArray;
            Ue.render(n, e, t), !0 === re && Pe.endShadows(), !0 === this.info.autoReset && this.info.reset();
            const i = b.opaque, r = b.transmissive;
            if (C.setupLights(), t.isArrayCamera) {
                const n = t.cameras;
                if (r.length > 0) for(let t = 0, a = n.length; t < a; t++)Je(i, r, e, n[t]);
                de && De.render(e);
                for(let t = 0, i = n.length; t < i; t++){
                    const i = n[t];
                    Qe(b, e, i, i.viewport);
                }
            } else r.length > 0 && Je(i, r, e, t), de && De.render(e), Qe(b, e, t);
            null !== O && 0 === I && (ve.updateMultisampleRenderTarget(O), ve.updateRenderTargetMipmap(O)), !0 === e.isScene && e.onAfterRender(U, e, t), Oe.resetDefaultState(), B = -1, z = null, P.pop(), P.length > 0 ? (C = P[P.length - 1], !0 === re && Pe.setGlobalState(U.clippingPlanes, C.state.camera)) : C = null, L.pop(), b = L.length > 0 ? L[L.length - 1] : null;
        }, this.getActiveCubeFace = function() {
            return w;
        }, this.getActiveMipmapLevel = function() {
            return I;
        }, this.getRenderTarget = function() {
            return O;
        }, this.setRenderTargetTextures = function(e, t, n) {
            const i = ge.get(e);
            i.__autoAllocateDepthBuffer = !1 === e.resolveDepthBuffer, !1 === i.__autoAllocateDepthBuffer && (i.__useRenderToTexture = !1), ge.get(e.texture).__webglTexture = t, ge.get(e.depthTexture).__webglTexture = i.__autoAllocateDepthBuffer ? void 0 : n, i.__hasExternalTextures = !0;
        }, this.setRenderTargetFramebuffer = function(e, t) {
            const n = ge.get(e);
            n.__webglFramebuffer = t, n.__useDefaultFramebuffer = void 0 === t;
        };
        const at = Be.createFramebuffer();
        this.setRenderTarget = function(e, t = 0, n = 0) {
            O = e, w = t, I = n;
            let i = !0, r = null, a = !1, o = !1;
            if (e) {
                const s = ge.get(e);
                if (void 0 !== s.__useDefaultFramebuffer) he.bindFramebuffer(Be.FRAMEBUFFER, null), i = !1;
                else if (void 0 === s.__webglFramebuffer) ve.setupRenderTarget(e);
                else if (s.__hasExternalTextures) ve.rebindTextures(e, ge.get(e.texture).__webglTexture, ge.get(e.depthTexture).__webglTexture);
                else if (e.depthBuffer) {
                    const t = e.depthTexture;
                    if (s.__boundDepthTexture !== t) {
                        if (null !== t && ge.has(t) && (e.width !== t.image.width || e.height !== t.image.height)) throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
                        ve.setupDepthRenderbuffer(e);
                    }
                }
                const l = e.texture;
                (l.isData3DTexture || l.isDataArrayTexture || l.isCompressedArrayTexture) && (o = !0);
                const c = ge.get(e).__webglFramebuffer;
                e.isWebGLCubeRenderTarget ? (r = Array.isArray(c[t]) ? c[t][n] : c[t], a = !0) : r = e.samples > 0 && !1 === ve.useMultisampledRTT(e) ? ge.get(e).__webglMultisampledFramebuffer : Array.isArray(c) ? c[n] : c, k.copy(e.viewport), W.copy(e.scissor), Y = e.scissorTest;
            } else k.copy(ee).multiplyScalar($).floor(), W.copy(te).multiplyScalar($).floor(), Y = ne;
            0 !== n && (r = at);
            if (he.bindFramebuffer(Be.FRAMEBUFFER, r) && i && he.drawBuffers(e, r), he.viewport(k), he.scissor(W), he.setScissorTest(Y), a) {
                const i = ge.get(e.texture);
                Be.framebufferTexture2D(Be.FRAMEBUFFER, Be.COLOR_ATTACHMENT0, Be.TEXTURE_CUBE_MAP_POSITIVE_X + t, i.__webglTexture, n);
            } else if (o) {
                const i = t;
                for(let t = 0; t < e.textures.length; t++){
                    const r = ge.get(e.textures[t]);
                    Be.framebufferTextureLayer(Be.FRAMEBUFFER, Be.COLOR_ATTACHMENT0 + t, r.__webglTexture, n, i);
                }
            } else if (null !== e && 0 !== n) {
                const t = ge.get(e.texture);
                Be.framebufferTexture2D(Be.FRAMEBUFFER, Be.COLOR_ATTACHMENT0, Be.TEXTURE_2D, t.__webglTexture, n);
            }
            B = -1;
        }, this.readRenderTargetPixels = function(e, t, n, i, r, a, o, s = 0) {
            if (!e || !e.isWebGLRenderTarget) return void (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            let l = ge.get(e).__webglFramebuffer;
            if (e.isWebGLCubeRenderTarget && void 0 !== o && (l = l[o]), l) {
                he.bindFramebuffer(Be.FRAMEBUFFER, l);
                try {
                    const o = e.textures[s], l = o.format, c = o.type;
                    if (!pe.textureFormatReadable(l)) return void (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    if (!pe.textureTypeReadable(c)) return void (0, $4a792688e08e5cd7$export$a3bc9b8ed74fc)("WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    t >= 0 && t <= e.width - i && n >= 0 && n <= e.height - r && (e.textures.length > 1 && Be.readBuffer(Be.COLOR_ATTACHMENT0 + s), Be.readPixels(t, n, i, r, Ne.convert(l), Ne.convert(c), a));
                } finally{
                    const e = null !== O ? ge.get(O).__webglFramebuffer : null;
                    he.bindFramebuffer(Be.FRAMEBUFFER, e);
                }
            }
        }, this.readRenderTargetPixelsAsync = async function(e, t, n, i, r, a, o, s = 0) {
            if (!e || !e.isWebGLRenderTarget) throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            let l = ge.get(e).__webglFramebuffer;
            if (e.isWebGLCubeRenderTarget && void 0 !== o && (l = l[o]), l) {
                if (t >= 0 && t <= e.width - i && n >= 0 && n <= e.height - r) {
                    he.bindFramebuffer(Be.FRAMEBUFFER, l);
                    const o = e.textures[s], c = o.format, d = o.type;
                    if (!pe.textureFormatReadable(c)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
                    if (!pe.textureTypeReadable(d)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
                    const u = Be.createBuffer();
                    Be.bindBuffer(Be.PIXEL_PACK_BUFFER, u), Be.bufferData(Be.PIXEL_PACK_BUFFER, a.byteLength, Be.STREAM_READ), e.textures.length > 1 && Be.readBuffer(Be.COLOR_ATTACHMENT0 + s), Be.readPixels(t, n, i, r, Ne.convert(c), Ne.convert(d), 0);
                    const f = null !== O ? ge.get(O).__webglFramebuffer : null;
                    he.bindFramebuffer(Be.FRAMEBUFFER, f);
                    const p = Be.fenceSync(Be.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    return Be.flush(), await (0, $4a792688e08e5cd7$export$d43f91ebeafb2c7)(Be, p, 4), Be.bindBuffer(Be.PIXEL_PACK_BUFFER, u), Be.getBufferSubData(Be.PIXEL_PACK_BUFFER, 0, a), Be.deleteBuffer(u), Be.deleteSync(p), a;
                }
                throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
            }
        }, this.copyFramebufferToTexture = function(e, t = null, n = 0) {
            const i = Math.pow(2, -n), r = Math.floor(e.image.width * i), a = Math.floor(e.image.height * i), o = null !== t ? t.x : 0, s = null !== t ? t.y : 0;
            ve.setTexture2D(e, 0), Be.copyTexSubImage2D(Be.TEXTURE_2D, n, 0, 0, o, s, r, a), he.unbindTexture();
        };
        const st = Be.createFramebuffer(), ct = Be.createFramebuffer();
        this.copyTextureToTexture = function(e, t, n = null, i = null, r = 0, a = null) {
            let o, s, l, c, d, u, f, p, m;
            null === a && (0 !== r ? ((0, $4a792688e08e5cd7$export$5b28268982f175ba)("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels."), a = r, r = 0) : a = 0);
            const h = e.isCompressedTexture ? e.mipmaps[a] : e.image;
            if (null !== n) o = n.max.x - n.min.x, s = n.max.y - n.min.y, l = n.isBox3 ? n.max.z - n.min.z : 1, c = n.min.x, d = n.min.y, u = n.isBox3 ? n.min.z : 0;
            else {
                const t = Math.pow(2, -r);
                o = Math.floor(h.width * t), s = Math.floor(h.height * t), l = e.isDataArrayTexture ? h.depth : e.isData3DTexture ? Math.floor(h.depth * t) : 1, c = 0, d = 0, u = 0;
            }
            null !== i ? (f = i.x, p = i.y, m = i.z) : (f = 0, p = 0, m = 0);
            const _ = Ne.convert(t.format), g = Ne.convert(t.type);
            let v;
            t.isData3DTexture ? (ve.setTexture3D(t, 0), v = Be.TEXTURE_3D) : t.isDataArrayTexture || t.isCompressedArrayTexture ? (ve.setTexture2DArray(t, 0), v = Be.TEXTURE_2D_ARRAY) : (ve.setTexture2D(t, 0), v = Be.TEXTURE_2D), Be.pixelStorei(Be.UNPACK_FLIP_Y_WEBGL, t.flipY), Be.pixelStorei(Be.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha), Be.pixelStorei(Be.UNPACK_ALIGNMENT, t.unpackAlignment);
            const E = Be.getParameter(Be.UNPACK_ROW_LENGTH), S = Be.getParameter(Be.UNPACK_IMAGE_HEIGHT), T = Be.getParameter(Be.UNPACK_SKIP_PIXELS), M = Be.getParameter(Be.UNPACK_SKIP_ROWS), x = Be.getParameter(Be.UNPACK_SKIP_IMAGES);
            Be.pixelStorei(Be.UNPACK_ROW_LENGTH, h.width), Be.pixelStorei(Be.UNPACK_IMAGE_HEIGHT, h.height), Be.pixelStorei(Be.UNPACK_SKIP_PIXELS, c), Be.pixelStorei(Be.UNPACK_SKIP_ROWS, d), Be.pixelStorei(Be.UNPACK_SKIP_IMAGES, u);
            const A = e.isDataArrayTexture || e.isData3DTexture, R = t.isDataArrayTexture || t.isData3DTexture;
            if (e.isDepthTexture) {
                const n = ge.get(e), i = ge.get(t), h = ge.get(n.__renderTarget), _ = ge.get(i.__renderTarget);
                he.bindFramebuffer(Be.READ_FRAMEBUFFER, h.__webglFramebuffer), he.bindFramebuffer(Be.DRAW_FRAMEBUFFER, _.__webglFramebuffer);
                for(let n = 0; n < l; n++)A && (Be.framebufferTextureLayer(Be.READ_FRAMEBUFFER, Be.COLOR_ATTACHMENT0, ge.get(e).__webglTexture, r, u + n), Be.framebufferTextureLayer(Be.DRAW_FRAMEBUFFER, Be.COLOR_ATTACHMENT0, ge.get(t).__webglTexture, a, m + n)), Be.blitFramebuffer(c, d, o, s, f, p, o, s, Be.DEPTH_BUFFER_BIT, Be.NEAREST);
                he.bindFramebuffer(Be.READ_FRAMEBUFFER, null), he.bindFramebuffer(Be.DRAW_FRAMEBUFFER, null);
            } else if (0 !== r || e.isRenderTargetTexture || ge.has(e)) {
                const n = ge.get(e), i = ge.get(t);
                he.bindFramebuffer(Be.READ_FRAMEBUFFER, st), he.bindFramebuffer(Be.DRAW_FRAMEBUFFER, ct);
                for(let e = 0; e < l; e++)A ? Be.framebufferTextureLayer(Be.READ_FRAMEBUFFER, Be.COLOR_ATTACHMENT0, n.__webglTexture, r, u + e) : Be.framebufferTexture2D(Be.READ_FRAMEBUFFER, Be.COLOR_ATTACHMENT0, Be.TEXTURE_2D, n.__webglTexture, r), R ? Be.framebufferTextureLayer(Be.DRAW_FRAMEBUFFER, Be.COLOR_ATTACHMENT0, i.__webglTexture, a, m + e) : Be.framebufferTexture2D(Be.DRAW_FRAMEBUFFER, Be.COLOR_ATTACHMENT0, Be.TEXTURE_2D, i.__webglTexture, a), 0 !== r ? Be.blitFramebuffer(c, d, o, s, f, p, o, s, Be.COLOR_BUFFER_BIT, Be.NEAREST) : R ? Be.copyTexSubImage3D(v, a, f, p, m + e, c, d, o, s) : Be.copyTexSubImage2D(v, a, f, p, c, d, o, s);
                he.bindFramebuffer(Be.READ_FRAMEBUFFER, null), he.bindFramebuffer(Be.DRAW_FRAMEBUFFER, null);
            } else R ? e.isDataTexture || e.isData3DTexture ? Be.texSubImage3D(v, a, f, p, m, o, s, l, _, g, h.data) : t.isCompressedArrayTexture ? Be.compressedTexSubImage3D(v, a, f, p, m, o, s, l, _, h.data) : Be.texSubImage3D(v, a, f, p, m, o, s, l, _, g, h) : e.isDataTexture ? Be.texSubImage2D(Be.TEXTURE_2D, a, f, p, o, s, _, g, h.data) : e.isCompressedTexture ? Be.compressedTexSubImage2D(Be.TEXTURE_2D, a, f, p, h.width, h.height, _, h.data) : Be.texSubImage2D(Be.TEXTURE_2D, a, f, p, o, s, _, g, h);
            Be.pixelStorei(Be.UNPACK_ROW_LENGTH, E), Be.pixelStorei(Be.UNPACK_IMAGE_HEIGHT, S), Be.pixelStorei(Be.UNPACK_SKIP_PIXELS, T), Be.pixelStorei(Be.UNPACK_SKIP_ROWS, M), Be.pixelStorei(Be.UNPACK_SKIP_IMAGES, x), 0 === a && t.generateMipmaps && Be.generateMipmap(v), he.unbindTexture();
        }, this.initRenderTarget = function(e) {
            void 0 === ge.get(e).__webglFramebuffer && ve.setupRenderTarget(e);
        }, this.initTexture = function(e) {
            e.isCubeTexture ? ve.setTextureCube(e, 0) : e.isData3DTexture ? ve.setTexture3D(e, 0) : e.isDataArrayTexture || e.isCompressedArrayTexture ? ve.setTexture2DArray(e, 0) : ve.setTexture2D(e, 0), he.unbindTexture();
        }, this.resetState = function() {
            w = 0, I = 0, O = null, he.reset(), Oe.reset();
        }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    get coordinateSystem() {
        return 0, $4a792688e08e5cd7$export$5a0e9190d10875d3;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(e) {
        this._outputColorSpace = e;
        const t = this.getContext();
        t.drawingBufferColorSpace = (0, $4a792688e08e5cd7$export$5e6fd513f44698c)._getDrawingBufferColorSpace(e), t.unpackColorSpace = (0, $4a792688e08e5cd7$export$5e6fd513f44698c)._getUnpackColorSpace();
    }
}


/**
 * Minified by jsDelivr using Terser v5.39.0.
 * Original file: /npm/three@0.181.2/examples/jsm/loaders/GLTFLoader.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */ 
/**
 * Minified by jsDelivr using Terser v5.39.0.
 * Original file: /npm/three@0.181.2/examples/jsm/utils/BufferGeometryUtils.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */ 
function $3f15025bddcabebe$export$676e3e70c930f774(e, t, r = !0) {
    if (!t || !t.isReady) throw new Error("BufferGeometryUtils: Initialized MikkTSpace library required.");
    if (!e.hasAttribute("position") || !e.hasAttribute("normal") || !e.hasAttribute("uv")) throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
    function o(e) {
        if (e.normalized || e.isInterleavedBufferAttribute) {
            const t = new Float32Array(e.count * e.itemSize);
            for(let r = 0, o = 0; r < e.count; r++)t[o++] = e.getX(r), t[o++] = e.getY(r), e.itemSize > 2 && (t[o++] = e.getZ(r));
            return t;
        }
        return e.array instanceof Float32Array ? e.array : new Float32Array(e.array);
    }
    const n = e.index ? e.toNonIndexed() : e, i = t.generateTangents(o(n.attributes.position), o(n.attributes.normal), o(n.attributes.uv));
    if (r) for(let e = 3; e < i.length; e += 4)i[e] *= -1;
    return n.setAttribute("tangent", new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(i, 4)), e !== n && e.copy(n), e;
}
function $3f15025bddcabebe$export$f06f69b3bf41d25c(e, t = !1) {
    const r = null !== e[0].index, o = new Set(Object.keys(e[0].attributes)), n = new Set(Object.keys(e[0].morphAttributes)), i = {}, s = {}, u = e[0].morphTargetsRelative, a = new (0, $4a792688e08e5cd7$export$b7be63a67df8959);
    let l = 0;
    for(let f = 0; f < e.length; ++f){
        const c = e[f];
        let m = 0;
        if (r !== (null !== c.index)) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."), null;
        for(const e in c.attributes){
            if (!o.has(e)) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + '. All geometries must have compatible attributes; make sure "' + e + '" attribute exists among all geometries, or in none of them.'), null;
            void 0 === i[e] && (i[e] = []), i[e].push(c.attributes[e]), m++;
        }
        if (m !== o.size) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + ". Make sure all geometries have the same number of attributes."), null;
        if (u !== c.morphTargetsRelative) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + ". .morphTargetsRelative must be consistent throughout all geometries."), null;
        for(const e in c.morphAttributes){
            if (!n.has(e)) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + ".  .morphAttributes must be consistent throughout all geometries."), null;
            void 0 === s[e] && (s[e] = []), s[e].push(c.morphAttributes[e]);
        }
        if (t) {
            let e;
            if (r) e = c.index.count;
            else {
                if (void 0 === c.attributes.position) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + ". The geometry must have either an index or a position attribute"), null;
                e = c.attributes.position.count;
            }
            a.addGroup(l, e, f), l += e;
        }
    }
    if (r) {
        let t = 0;
        const r = [];
        for(let o = 0; o < e.length; ++o){
            const n = e[o].index;
            for(let e = 0; e < n.count; ++e)r.push(n.getX(e) + t);
            t += e[o].attributes.position.count;
        }
        a.setIndex(r);
    }
    for(const e in i){
        const t = $3f15025bddcabebe$export$9f98db6234c4bd78(i[e]);
        if (!t) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + e + " attribute."), null;
        a.setAttribute(e, t);
    }
    for(const e in s){
        const t = s[e][0].length;
        if (0 === t) break;
        a.morphAttributes = a.morphAttributes || {}, a.morphAttributes[e] = [];
        for(let r = 0; r < t; ++r){
            const t = [];
            for(let o = 0; o < s[e].length; ++o)t.push(s[e][o][r]);
            const o = $3f15025bddcabebe$export$9f98db6234c4bd78(t);
            if (!o) return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + e + " morphAttribute."), null;
            a.morphAttributes[e].push(o);
        }
    }
    return a;
}
function $3f15025bddcabebe$export$9f98db6234c4bd78(e) {
    let t, r, o, n = -1, i = 0;
    for(let s = 0; s < e.length; ++s){
        const u = e[s];
        if (void 0 === t && (t = u.array.constructor), t !== u.array.constructor) return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."), null;
        if (void 0 === r && (r = u.itemSize), r !== u.itemSize) return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."), null;
        if (void 0 === o && (o = u.normalized), o !== u.normalized) return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."), null;
        if (-1 === n && (n = u.gpuType), n !== u.gpuType) return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes."), null;
        i += u.count * r;
    }
    const s = new t(i), u = new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(s, r, o);
    let a = 0;
    for(let t = 0; t < e.length; ++t){
        const o = e[t];
        if (o.isInterleavedBufferAttribute) {
            const e = a / r;
            for(let t = 0, n = o.count; t < n; t++)for(let n = 0; n < r; n++){
                const r = o.getComponent(t, n);
                u.setComponent(t + e, n, r);
            }
        } else s.set(o.array, a);
        a += o.count * r;
    }
    return void 0 !== n && (u.gpuType = n), u;
}
function $3f15025bddcabebe$export$4848639a9adff548(e) {
    return e.isInstancedInterleavedBufferAttribute || e.isInterleavedBufferAttribute ? $3f15025bddcabebe$export$4b7aa2f2134b7e19(e) : e.isInstancedBufferAttribute ? (new (0, $4a792688e08e5cd7$export$32ea87a8b54d744a)).copy(e) : (new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)).copy(e);
}
function $3f15025bddcabebe$export$308f9509e428a845(e) {
    let t, r = 0, o = 0;
    for(let n = 0, i = e.length; n < i; ++n){
        const i = e[n];
        if (void 0 === t && (t = i.array.constructor), t !== i.array.constructor) return console.error("AttributeBuffers of different types cannot be interleaved"), null;
        r += i.array.length, o += i.itemSize;
    }
    const n = new (0, $4a792688e08e5cd7$export$3d5cd879f108f53f)(new t(r), o);
    let i = 0;
    const s = [], u = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ], a = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let t = 0, r = e.length; t < r; t++){
        const r = e[t], o = r.itemSize, l = r.count, f = new (0, $4a792688e08e5cd7$export$920b6d07334599c7)(n, o, i, r.normalized);
        s.push(f), i += o;
        for(let e = 0; e < l; e++)for(let t = 0; t < o; t++)f[a[t]](e, r[u[t]](e));
    }
    return s;
}
function $3f15025bddcabebe$export$4b7aa2f2134b7e19(e) {
    const t = e.data.array.constructor, r = e.count, o = e.itemSize, n = e.normalized, i = new t(r * o);
    let s;
    s = e.isInstancedInterleavedBufferAttribute ? new (0, $4a792688e08e5cd7$export$32ea87a8b54d744a)(i, o, n, e.meshPerAttribute) : new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(i, o, n);
    for(let t = 0; t < r; t++)s.setX(t, e.getX(t)), o >= 2 && s.setY(t, e.getY(t)), o >= 3 && s.setZ(t, e.getZ(t)), o >= 4 && s.setW(t, e.getW(t));
    return s;
}
function $3f15025bddcabebe$export$e7413b17bfaaa80b(e) {
    const t = e.attributes, r = e.morphTargets, o = new Map;
    for(const e in t){
        const r = t[e];
        r.isInterleavedBufferAttribute && (o.has(r) || o.set(r, $3f15025bddcabebe$export$4b7aa2f2134b7e19(r)), t[e] = o.get(r));
    }
    for(const e in r){
        const t = r[e];
        t.isInterleavedBufferAttribute && (o.has(t) || o.set(t, $3f15025bddcabebe$export$4b7aa2f2134b7e19(t)), r[e] = o.get(t));
    }
}
function $3f15025bddcabebe$export$35bee7999e19754d(e) {
    let t = 0;
    for(const r in e.attributes){
        const o = e.getAttribute(r);
        t += o.count * o.itemSize * o.array.BYTES_PER_ELEMENT;
    }
    const r = e.getIndex();
    return t += r ? r.count * r.itemSize * r.array.BYTES_PER_ELEMENT : 0, t;
}
function $3f15025bddcabebe$export$e36bb98c4c944f9(e, t = 1e-4) {
    t = Math.max(t, Number.EPSILON);
    const r = {}, o = e.getIndex(), n = e.getAttribute("position"), i = o ? o.count : n.count;
    let s = 0;
    const u = Object.keys(e.attributes), a = {}, l = {}, f = [], c = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ], m = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let t = 0, r = u.length; t < r; t++){
        const r = u[t], o = e.attributes[r];
        a[r] = new o.constructor(new o.array.constructor(o.count * o.itemSize), o.itemSize, o.normalized);
        const n = e.morphAttributes[r];
        n && (l[r] || (l[r] = []), n.forEach((e, t)=>{
            const o = new e.array.constructor(e.count * e.itemSize);
            l[r][t] = new e.constructor(o, e.itemSize, e.normalized);
        }));
    }
    const g = .5 * t, d = Math.log10(1 / t), b = Math.pow(10, d), h = g * b;
    for(let t = 0; t < i; t++){
        const n = o ? o.getX(t) : t;
        let i = "";
        for(let t = 0, r = u.length; t < r; t++){
            const r = u[t], o = e.getAttribute(r), s = o.itemSize;
            for(let e = 0; e < s; e++)i += ~~(o[c[e]](n) * b + h) + ",";
        }
        if (i in r) f.push(r[i]);
        else {
            for(let t = 0, r = u.length; t < r; t++){
                const r = u[t], o = e.getAttribute(r), i = e.morphAttributes[r], f = o.itemSize, g = a[r], d = l[r];
                for(let e = 0; e < f; e++){
                    const t = c[e], r = m[e];
                    if (g[r](s, o[t](n)), i) for(let e = 0, o = i.length; e < o; e++)d[e][r](s, i[e][t](n));
                }
            }
            r[i] = s, f.push(s), s++;
        }
    }
    const p = e.clone();
    for(const t in e.attributes){
        const e = a[t];
        if (p.setAttribute(t, new e.constructor(e.array.slice(0, s * e.itemSize), e.itemSize, e.normalized)), t in l) for(let e = 0; e < l[t].length; e++){
            const r = l[t][e];
            p.morphAttributes[t][e] = new r.constructor(r.array.slice(0, s * r.itemSize), r.itemSize, r.normalized);
        }
    }
    return p.setIndex(f), p;
}
function $3f15025bddcabebe$export$5492ca6e5c0c7aa0(e, t) {
    if (t === (0, $4a792688e08e5cd7$export$4c28c87c2dc84758)) return console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles."), e;
    if (t === (0, $4a792688e08e5cd7$export$f0d8293634f88842) || t === (0, $4a792688e08e5cd7$export$b23a071aa286eb29)) {
        let r = e.getIndex();
        if (null === r) {
            const t = [], o = e.getAttribute("position");
            if (void 0 === o) return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), e;
            for(let e = 0; e < o.count; e++)t.push(e);
            e.setIndex(t), r = e.getIndex();
        }
        const o = r.count - 2, n = [];
        if (t === (0, $4a792688e08e5cd7$export$f0d8293634f88842)) for(let e = 1; e <= o; e++)n.push(r.getX(0)), n.push(r.getX(e)), n.push(r.getX(e + 1));
        else for(let e = 0; e < o; e++)e % 2 == 0 ? (n.push(r.getX(e)), n.push(r.getX(e + 1)), n.push(r.getX(e + 2))) : (n.push(r.getX(e + 2)), n.push(r.getX(e + 1)), n.push(r.getX(e)));
        n.length / 3 !== o && console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        const i = e.clone();
        return i.setIndex(n), i.clearGroups(), i;
    }
    return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", t), e;
}
function $3f15025bddcabebe$export$29e54e2e4ab904e7(e) {
    const t = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), r = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), o = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), n = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), i = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), s = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), u = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), a = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), l = new (0, $4a792688e08e5cd7$export$64b5c384219d3699);
    function f(e, f, c, m, g, d, b, h) {
        t.fromBufferAttribute(f, g), r.fromBufferAttribute(f, d), o.fromBufferAttribute(f, b);
        const p = e.morphTargetInfluences;
        if (c && p) {
            u.set(0, 0, 0), a.set(0, 0, 0), l.set(0, 0, 0);
            for(let e = 0, f = c.length; e < f; e++){
                const f = p[e], h = c[e];
                0 !== f && (n.fromBufferAttribute(h, g), i.fromBufferAttribute(h, d), s.fromBufferAttribute(h, b), m ? (u.addScaledVector(n, f), a.addScaledVector(i, f), l.addScaledVector(s, f)) : (u.addScaledVector(n.sub(t), f), a.addScaledVector(i.sub(r), f), l.addScaledVector(s.sub(o), f)));
            }
            t.add(u), r.add(a), o.add(l);
        }
        e.isSkinnedMesh && (e.applyBoneTransform(g, t), e.applyBoneTransform(d, r), e.applyBoneTransform(b, o)), h[3 * g + 0] = t.x, h[3 * g + 1] = t.y, h[3 * g + 2] = t.z, h[3 * d + 0] = r.x, h[3 * d + 1] = r.y, h[3 * d + 2] = r.z, h[3 * b + 0] = o.x, h[3 * b + 1] = o.y, h[3 * b + 2] = o.z;
    }
    const c = e.geometry, m = e.material;
    let g, d, b;
    const h = c.index, p = c.attributes.position, A = c.morphAttributes.position, y = c.morphTargetsRelative, w = c.attributes.normal, B = c.morphAttributes.position, T = c.groups, x = c.drawRange;
    let E, z, v, I, G, S, M;
    const V = new Float32Array(p.count * p.itemSize), X = new Float32Array(w.count * w.itemSize);
    if (null !== h) {
        if (Array.isArray(m)) for(E = 0, v = T.length; E < v; E++)for(G = T[E], S = Math.max(G.start, x.start), M = Math.min(G.start + G.count, x.start + x.count), z = S, I = M; z < I; z += 3)g = h.getX(z), d = h.getX(z + 1), b = h.getX(z + 2), f(e, p, A, y, g, d, b, V), f(e, w, B, y, g, d, b, X);
        else for(S = Math.max(0, x.start), M = Math.min(h.count, x.start + x.count), E = S, v = M; E < v; E += 3)g = h.getX(E), d = h.getX(E + 1), b = h.getX(E + 2), f(e, p, A, y, g, d, b, V), f(e, w, B, y, g, d, b, X);
    } else if (Array.isArray(m)) for(E = 0, v = T.length; E < v; E++)for(G = T[E], S = Math.max(G.start, x.start), M = Math.min(G.start + G.count, x.start + x.count), z = S, I = M; z < I; z += 3)g = z, d = z + 1, b = z + 2, f(e, p, A, y, g, d, b, V), f(e, w, B, y, g, d, b, X);
    else for(S = Math.max(0, x.start), M = Math.min(p.count, x.start + x.count), E = S, v = M; E < v; E += 3)g = E, d = E + 1, b = E + 2, f(e, p, A, y, g, d, b, V), f(e, w, B, y, g, d, b, X);
    return {
        positionAttribute: p,
        normalAttribute: w,
        morphedPositionAttribute: new (0, $4a792688e08e5cd7$export$cbe7a62641830ebd)(V, 3),
        morphedNormalAttribute: new (0, $4a792688e08e5cd7$export$cbe7a62641830ebd)(X, 3)
    };
}
function $3f15025bddcabebe$export$8babbf41197098b1(e) {
    if (0 === e.groups.length) return console.warn("THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge."), e;
    let t = e.groups;
    if (t = t.sort((e, t)=>e.materialIndex !== t.materialIndex ? e.materialIndex - t.materialIndex : e.start - t.start), null === e.getIndex()) {
        const t = e.getAttribute("position"), r = [];
        for(let e = 0; e < t.count; e += 3)r.push(e, e + 1, e + 2);
        e.setIndex(r);
    }
    const r = e.getIndex(), o = [];
    for(let e = 0; e < t.length; e++){
        const n = t[e], i = n.start, s = i + n.count;
        for(let e = i; e < s; e++)o.push(r.getX(e));
    }
    e.dispose(), e.setIndex(o);
    let n = 0;
    for(let e = 0; e < t.length; e++){
        const r = t[e];
        r.start = n, n += r.count;
    }
    let i = t[0];
    e.groups = [
        i
    ];
    for(let r = 1; r < t.length; r++){
        const o = t[r];
        i.materialIndex === o.materialIndex ? i.count += o.count : (i = o, e.groups.push(i));
    }
    return e;
}
function $3f15025bddcabebe$export$b525764477fc001f(e, t = Math.PI / 3) {
    const r = Math.cos(t), o = 100 * (1 + 1e-10), n = [
        new (0, $4a792688e08e5cd7$export$64b5c384219d3699),
        new (0, $4a792688e08e5cd7$export$64b5c384219d3699),
        new (0, $4a792688e08e5cd7$export$64b5c384219d3699)
    ], i = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), s = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), u = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), a = new (0, $4a792688e08e5cd7$export$64b5c384219d3699);
    function l(e) {
        return `${~~(e.x * o)},${~~(e.y * o)},${~~(e.z * o)}`;
    }
    const f = e.index ? e.toNonIndexed() : e, c = f.attributes.position, m = {};
    for(let e = 0, t = c.count / 3; e < t; e++){
        const t = 3 * e, r = n[0].fromBufferAttribute(c, t + 0), o = n[1].fromBufferAttribute(c, t + 1), u = n[2].fromBufferAttribute(c, t + 2);
        i.subVectors(u, o), s.subVectors(r, o);
        const a = (new (0, $4a792688e08e5cd7$export$64b5c384219d3699)).crossVectors(i, s).normalize();
        for(let e = 0; e < 3; e++){
            const t = l(n[e]);
            t in m || (m[t] = []), m[t].push(a);
        }
    }
    const g = new Float32Array(3 * c.count), d = new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(g, 3, !1);
    for(let e = 0, t = c.count / 3; e < t; e++){
        const t = 3 * e, o = n[0].fromBufferAttribute(c, t + 0), f = n[1].fromBufferAttribute(c, t + 1), g = n[2].fromBufferAttribute(c, t + 2);
        i.subVectors(g, f), s.subVectors(o, f), u.crossVectors(i, s).normalize();
        for(let e = 0; e < 3; e++){
            const o = m[l(n[e])];
            a.set(0, 0, 0);
            for(let e = 0, t = o.length; e < t; e++){
                const t = o[e];
                u.dot(t) > r && a.add(t);
            }
            a.normalize(), d.setXYZ(t + e, a.x, a.y, a.z);
        }
    }
    return f.setAttribute("normal", d), f;
}
 //# sourceMappingURL=/sm/fdcf4ab9562692f158792067eb4e485ec28ab9bd270a556a6a63828cad0cacb9.map


class $fa36f6c1e44235b5$export$aa93f11e7884f0f4 extends (0, $4a792688e08e5cd7$export$3b0d6d7590275603) {
    constructor(e){
        super(e), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMaterialsClearcoatExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMaterialsDispersionExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFTextureBasisUExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFTextureWebPExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFTextureAVIFExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMaterialsSheenExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMaterialsTransmissionExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMaterialsVolumeExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMaterialsIorExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMaterialsEmissiveStrengthExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMaterialsSpecularExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMaterialsIridescenceExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMaterialsAnisotropyExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMaterialsBumpExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFLightsExtension(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMeshoptCompression(e);
        }), this.register(function(e) {
            return new $fa36f6c1e44235b5$var$GLTFMeshGpuInstancing(e);
        });
    }
    load(e, t, s, n) {
        const r = this;
        let i;
        if ("" !== this.resourcePath) i = this.resourcePath;
        else if ("" !== this.path) {
            const t = (0, $4a792688e08e5cd7$export$b5d2dc08d867e41a).extractUrlBase(e);
            i = (0, $4a792688e08e5cd7$export$b5d2dc08d867e41a).resolveURL(t, this.path);
        } else i = (0, $4a792688e08e5cd7$export$b5d2dc08d867e41a).extractUrlBase(e);
        this.manager.itemStart(e);
        const o = function(t) {
            n ? n(t) : console.error(t), r.manager.itemError(e), r.manager.itemEnd(e);
        }, a = new (0, $4a792688e08e5cd7$export$98435a25b5cf7b2b)(this.manager);
        a.setPath(this.path), a.setResponseType("arraybuffer"), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(e, function(s) {
            try {
                r.parse(s, i, function(s) {
                    t(s), r.manager.itemEnd(e);
                }, o);
            } catch (e) {
                o(e);
            }
        }, s, o);
    }
    setDRACOLoader(e) {
        return this.dracoLoader = e, this;
    }
    setKTX2Loader(e) {
        return this.ktx2Loader = e, this;
    }
    setMeshoptDecoder(e) {
        return this.meshoptDecoder = e, this;
    }
    register(e) {
        return -1 === this.pluginCallbacks.indexOf(e) && this.pluginCallbacks.push(e), this;
    }
    unregister(e) {
        return -1 !== this.pluginCallbacks.indexOf(e) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e), 1), this;
    }
    parse(e, t, s, n) {
        let r;
        const i = {}, o = {}, a = new TextDecoder;
        if ("string" == typeof e) r = JSON.parse(e);
        else if (e instanceof ArrayBuffer) {
            if (a.decode(new Uint8Array(e, 0, 4)) === $fa36f6c1e44235b5$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    i[$fa36f6c1e44235b5$var$EXTENSIONS.KHR_BINARY_GLTF] = new $fa36f6c1e44235b5$var$GLTFBinaryExtension(e);
                } catch (e) {
                    return void (n && n(e));
                }
                r = JSON.parse(i[$fa36f6c1e44235b5$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else r = JSON.parse(a.decode(e));
        } else r = e;
        if (void 0 === r.asset || r.asset.version[0] < 2) return void (n && n(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.")));
        const c = new $fa36f6c1e44235b5$var$GLTFParser(r, {
            path: t || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        c.fileLoader.setRequestHeader(this.requestHeader);
        for(let e = 0; e < this.pluginCallbacks.length; e++){
            const t = this.pluginCallbacks[e](c);
            t.name || console.error("THREE.GLTFLoader: Invalid plugin found: missing name"), o[t.name] = t, i[t.name] = !0;
        }
        if (r.extensionsUsed) for(let e = 0; e < r.extensionsUsed.length; ++e){
            const t = r.extensionsUsed[e], s = r.extensionsRequired || [];
            switch(t){
                case $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    i[t] = new $fa36f6c1e44235b5$var$GLTFMaterialsUnlitExtension;
                    break;
                case $fa36f6c1e44235b5$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    i[t] = new $fa36f6c1e44235b5$var$GLTFDracoMeshCompressionExtension(r, this.dracoLoader);
                    break;
                case $fa36f6c1e44235b5$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    i[t] = new $fa36f6c1e44235b5$var$GLTFTextureTransformExtension;
                    break;
                case $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    i[t] = new $fa36f6c1e44235b5$var$GLTFMeshQuantizationExtension;
                    break;
                default:
                    s.indexOf(t) >= 0 && void 0 === o[t] && console.warn('THREE.GLTFLoader: Unknown extension "' + t + '".');
            }
        }
        c.setExtensions(i), c.setPlugins(o), c.parse(s, n);
    }
    parseAsync(e, t) {
        const s = this;
        return new Promise(function(n, r) {
            s.parse(e, t, n, r);
        });
    }
}
function $fa36f6c1e44235b5$var$GLTFRegistry() {
    let e = {};
    return {
        get: function(t) {
            return e[t];
        },
        add: function(t, s) {
            e[t] = s;
        },
        remove: function(t) {
            delete e[t];
        },
        removeAll: function() {
            e = {};
        }
    };
}
const $fa36f6c1e44235b5$var$EXTENSIONS = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
    KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
    EXT_MATERIALS_BUMP: "EXT_materials_bump",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_TEXTURE_AVIF: "EXT_texture_avif",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
    EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class $fa36f6c1e44235b5$var$GLTFLightsExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL, this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const e = this.parser, t = this.parser.json.nodes || [];
        for(let s = 0, n = t.length; s < n; s++){
            const n = t[s];
            n.extensions && n.extensions[this.name] && void 0 !== n.extensions[this.name].light && e._addNodeRef(this.cache, n.extensions[this.name].light);
        }
    }
    _loadLight(e) {
        const t = this.parser, s = "light:" + e;
        let n = t.cache.get(s);
        if (n) return n;
        const r = t.json, i = ((r.extensions && r.extensions[this.name] || {}).lights || [])[e];
        let o;
        const a = new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(16777215);
        void 0 !== i.color && a.setRGB(i.color[0], i.color[1], i.color[2], (0, $4a792688e08e5cd7$export$42429b3acfb233a4));
        const c = void 0 !== i.range ? i.range : 0;
        switch(i.type){
            case "directional":
                o = new (0, $4a792688e08e5cd7$export$3fea33cc9972c868)(a), o.target.position.set(0, 0, -1), o.add(o.target);
                break;
            case "point":
                o = new (0, $4a792688e08e5cd7$export$4c9c1cb3f0b6f455)(a), o.distance = c;
                break;
            case "spot":
                o = new (0, $4a792688e08e5cd7$export$81495cbb73897362)(a), o.distance = c, i.spot = i.spot || {}, i.spot.innerConeAngle = void 0 !== i.spot.innerConeAngle ? i.spot.innerConeAngle : 0, i.spot.outerConeAngle = void 0 !== i.spot.outerConeAngle ? i.spot.outerConeAngle : Math.PI / 4, o.angle = i.spot.outerConeAngle, o.penumbra = 1 - i.spot.innerConeAngle / i.spot.outerConeAngle, o.target.position.set(0, 0, -1), o.add(o.target);
                break;
            default:
                throw new Error("THREE.GLTFLoader: Unexpected light type: " + i.type);
        }
        return o.position.set(0, 0, 0), $fa36f6c1e44235b5$var$assignExtrasToUserData(o, i), void 0 !== i.intensity && (o.intensity = i.intensity), o.name = t.createUniqueName(i.name || "light_" + e), n = Promise.resolve(o), t.cache.add(s, n), n;
    }
    getDependency(e, t) {
        if ("light" === e) return this._loadLight(t);
    }
    createNodeAttachment(e) {
        const t = this, s = this.parser, n = s.json.nodes[e], r = (n.extensions && n.extensions[this.name] || {}).light;
        return void 0 === r ? null : this._loadLight(r).then(function(e) {
            return s._getNodeRef(t.cache, r, e);
        });
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $4a792688e08e5cd7$export$55cbcc9b622fe1f5;
    }
    extendParams(e, t, s) {
        const n = [];
        e.color = new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(1, 1, 1), e.opacity = 1;
        const r = t.pbrMetallicRoughness;
        if (r) {
            if (Array.isArray(r.baseColorFactor)) {
                const t = r.baseColorFactor;
                e.color.setRGB(t[0], t[1], t[2], (0, $4a792688e08e5cd7$export$42429b3acfb233a4)), e.opacity = t[3];
            }
            void 0 !== r.baseColorTexture && n.push(s.assignTexture(e, "map", r.baseColorTexture, (0, $4a792688e08e5cd7$export$561f394b24edfcaa)));
        }
        return Promise.all(n);
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsEmissiveStrengthExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(e, t) {
        const s = this.parser.json.materials[e];
        if (!s.extensions || !s.extensions[this.name]) return Promise.resolve();
        const n = s.extensions[this.name].emissiveStrength;
        return void 0 !== n && (t.emissiveIntensity = n), Promise.resolve();
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsClearcoatExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(e) {
        const t = this.parser.json.materials[e];
        return t.extensions && t.extensions[this.name] ? (0, $4a792688e08e5cd7$export$28d04986c4269c9f) : null;
    }
    extendMaterialParams(e, t) {
        const s = this.parser, n = s.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const r = [], i = n.extensions[this.name];
        if (void 0 !== i.clearcoatFactor && (t.clearcoat = i.clearcoatFactor), void 0 !== i.clearcoatTexture && r.push(s.assignTexture(t, "clearcoatMap", i.clearcoatTexture)), void 0 !== i.clearcoatRoughnessFactor && (t.clearcoatRoughness = i.clearcoatRoughnessFactor), void 0 !== i.clearcoatRoughnessTexture && r.push(s.assignTexture(t, "clearcoatRoughnessMap", i.clearcoatRoughnessTexture)), void 0 !== i.clearcoatNormalTexture && (r.push(s.assignTexture(t, "clearcoatNormalMap", i.clearcoatNormalTexture)), void 0 !== i.clearcoatNormalTexture.scale)) {
            const e = i.clearcoatNormalTexture.scale;
            t.clearcoatNormalScale = new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1)(e, e);
        }
        return Promise.all(r);
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsDispersionExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_DISPERSION;
    }
    getMaterialType(e) {
        const t = this.parser.json.materials[e];
        return t.extensions && t.extensions[this.name] ? (0, $4a792688e08e5cd7$export$28d04986c4269c9f) : null;
    }
    extendMaterialParams(e, t) {
        const s = this.parser.json.materials[e];
        if (!s.extensions || !s.extensions[this.name]) return Promise.resolve();
        const n = s.extensions[this.name];
        return t.dispersion = void 0 !== n.dispersion ? n.dispersion : 0, Promise.resolve();
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsIridescenceExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(e) {
        const t = this.parser.json.materials[e];
        return t.extensions && t.extensions[this.name] ? (0, $4a792688e08e5cd7$export$28d04986c4269c9f) : null;
    }
    extendMaterialParams(e, t) {
        const s = this.parser, n = s.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const r = [], i = n.extensions[this.name];
        return void 0 !== i.iridescenceFactor && (t.iridescence = i.iridescenceFactor), void 0 !== i.iridescenceTexture && r.push(s.assignTexture(t, "iridescenceMap", i.iridescenceTexture)), void 0 !== i.iridescenceIor && (t.iridescenceIOR = i.iridescenceIor), void 0 === t.iridescenceThicknessRange && (t.iridescenceThicknessRange = [
            100,
            400
        ]), void 0 !== i.iridescenceThicknessMinimum && (t.iridescenceThicknessRange[0] = i.iridescenceThicknessMinimum), void 0 !== i.iridescenceThicknessMaximum && (t.iridescenceThicknessRange[1] = i.iridescenceThicknessMaximum), void 0 !== i.iridescenceThicknessTexture && r.push(s.assignTexture(t, "iridescenceThicknessMap", i.iridescenceThicknessTexture)), Promise.all(r);
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsSheenExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(e) {
        const t = this.parser.json.materials[e];
        return t.extensions && t.extensions[this.name] ? (0, $4a792688e08e5cd7$export$28d04986c4269c9f) : null;
    }
    extendMaterialParams(e, t) {
        const s = this.parser, n = s.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const r = [];
        t.sheenColor = new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(0, 0, 0), t.sheenRoughness = 0, t.sheen = 1;
        const i = n.extensions[this.name];
        if (void 0 !== i.sheenColorFactor) {
            const e = i.sheenColorFactor;
            t.sheenColor.setRGB(e[0], e[1], e[2], (0, $4a792688e08e5cd7$export$42429b3acfb233a4));
        }
        return void 0 !== i.sheenRoughnessFactor && (t.sheenRoughness = i.sheenRoughnessFactor), void 0 !== i.sheenColorTexture && r.push(s.assignTexture(t, "sheenColorMap", i.sheenColorTexture, (0, $4a792688e08e5cd7$export$561f394b24edfcaa))), void 0 !== i.sheenRoughnessTexture && r.push(s.assignTexture(t, "sheenRoughnessMap", i.sheenRoughnessTexture)), Promise.all(r);
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsTransmissionExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(e) {
        const t = this.parser.json.materials[e];
        return t.extensions && t.extensions[this.name] ? (0, $4a792688e08e5cd7$export$28d04986c4269c9f) : null;
    }
    extendMaterialParams(e, t) {
        const s = this.parser, n = s.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const r = [], i = n.extensions[this.name];
        return void 0 !== i.transmissionFactor && (t.transmission = i.transmissionFactor), void 0 !== i.transmissionTexture && r.push(s.assignTexture(t, "transmissionMap", i.transmissionTexture)), Promise.all(r);
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsVolumeExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(e) {
        const t = this.parser.json.materials[e];
        return t.extensions && t.extensions[this.name] ? (0, $4a792688e08e5cd7$export$28d04986c4269c9f) : null;
    }
    extendMaterialParams(e, t) {
        const s = this.parser, n = s.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const r = [], i = n.extensions[this.name];
        t.thickness = void 0 !== i.thicknessFactor ? i.thicknessFactor : 0, void 0 !== i.thicknessTexture && r.push(s.assignTexture(t, "thicknessMap", i.thicknessTexture)), t.attenuationDistance = i.attenuationDistance || 1 / 0;
        const o = i.attenuationColor || [
            1,
            1,
            1
        ];
        return t.attenuationColor = (new (0, $4a792688e08e5cd7$export$892596cec99bc70e)).setRGB(o[0], o[1], o[2], (0, $4a792688e08e5cd7$export$42429b3acfb233a4)), Promise.all(r);
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsIorExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(e) {
        const t = this.parser.json.materials[e];
        return t.extensions && t.extensions[this.name] ? (0, $4a792688e08e5cd7$export$28d04986c4269c9f) : null;
    }
    extendMaterialParams(e, t) {
        const s = this.parser.json.materials[e];
        if (!s.extensions || !s.extensions[this.name]) return Promise.resolve();
        const n = s.extensions[this.name];
        return t.ior = void 0 !== n.ior ? n.ior : 1.5, Promise.resolve();
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsSpecularExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(e) {
        const t = this.parser.json.materials[e];
        return t.extensions && t.extensions[this.name] ? (0, $4a792688e08e5cd7$export$28d04986c4269c9f) : null;
    }
    extendMaterialParams(e, t) {
        const s = this.parser, n = s.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const r = [], i = n.extensions[this.name];
        t.specularIntensity = void 0 !== i.specularFactor ? i.specularFactor : 1, void 0 !== i.specularTexture && r.push(s.assignTexture(t, "specularIntensityMap", i.specularTexture));
        const o = i.specularColorFactor || [
            1,
            1,
            1
        ];
        return t.specularColor = (new (0, $4a792688e08e5cd7$export$892596cec99bc70e)).setRGB(o[0], o[1], o[2], (0, $4a792688e08e5cd7$export$42429b3acfb233a4)), void 0 !== i.specularColorTexture && r.push(s.assignTexture(t, "specularColorMap", i.specularColorTexture, (0, $4a792688e08e5cd7$export$561f394b24edfcaa))), Promise.all(r);
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsBumpExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.EXT_MATERIALS_BUMP;
    }
    getMaterialType(e) {
        const t = this.parser.json.materials[e];
        return t.extensions && t.extensions[this.name] ? (0, $4a792688e08e5cd7$export$28d04986c4269c9f) : null;
    }
    extendMaterialParams(e, t) {
        const s = this.parser, n = s.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const r = [], i = n.extensions[this.name];
        return t.bumpScale = void 0 !== i.bumpFactor ? i.bumpFactor : 1, void 0 !== i.bumpTexture && r.push(s.assignTexture(t, "bumpMap", i.bumpTexture)), Promise.all(r);
    }
}
class $fa36f6c1e44235b5$var$GLTFMaterialsAnisotropyExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(e) {
        const t = this.parser.json.materials[e];
        return t.extensions && t.extensions[this.name] ? (0, $4a792688e08e5cd7$export$28d04986c4269c9f) : null;
    }
    extendMaterialParams(e, t) {
        const s = this.parser, n = s.json.materials[e];
        if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
        const r = [], i = n.extensions[this.name];
        return void 0 !== i.anisotropyStrength && (t.anisotropy = i.anisotropyStrength), void 0 !== i.anisotropyRotation && (t.anisotropyRotation = i.anisotropyRotation), void 0 !== i.anisotropyTexture && r.push(s.assignTexture(t, "anisotropyMap", i.anisotropyTexture)), Promise.all(r);
    }
}
class $fa36f6c1e44235b5$var$GLTFTextureBasisUExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(e) {
        const t = this.parser, s = t.json, n = s.textures[e];
        if (!n.extensions || !n.extensions[this.name]) return null;
        const r = n.extensions[this.name], i = t.options.ktx2Loader;
        if (!i) {
            if (s.extensionsRequired && s.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
            return null;
        }
        return t.loadTextureImage(e, r.source, i);
    }
}
class $fa36f6c1e44235b5$var$GLTFTextureWebPExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.EXT_TEXTURE_WEBP;
    }
    loadTexture(e) {
        const t = this.name, s = this.parser, n = s.json, r = n.textures[e];
        if (!r.extensions || !r.extensions[t]) return null;
        const i = r.extensions[t], o = n.images[i.source];
        let a = s.textureLoader;
        if (o.uri) {
            const e = s.options.manager.getHandler(o.uri);
            null !== e && (a = e);
        }
        return s.loadTextureImage(e, i.source, a);
    }
}
class $fa36f6c1e44235b5$var$GLTFTextureAVIFExtension {
    constructor(e){
        this.parser = e, this.name = $fa36f6c1e44235b5$var$EXTENSIONS.EXT_TEXTURE_AVIF;
    }
    loadTexture(e) {
        const t = this.name, s = this.parser, n = s.json, r = n.textures[e];
        if (!r.extensions || !r.extensions[t]) return null;
        const i = r.extensions[t], o = n.images[i.source];
        let a = s.textureLoader;
        if (o.uri) {
            const e = s.options.manager.getHandler(o.uri);
            null !== e && (a = e);
        }
        return s.loadTextureImage(e, i.source, a);
    }
}
class $fa36f6c1e44235b5$var$GLTFMeshoptCompression {
    constructor(e){
        this.name = $fa36f6c1e44235b5$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION, this.parser = e;
    }
    loadBufferView(e) {
        const t = this.parser.json, s = t.bufferViews[e];
        if (s.extensions && s.extensions[this.name]) {
            const e = s.extensions[this.name], n = this.parser.getDependency("buffer", e.buffer), r = this.parser.options.meshoptDecoder;
            if (!r || !r.supported) {
                if (t.extensionsRequired && t.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                return null;
            }
            return n.then(function(t) {
                const s = e.byteOffset || 0, n = e.byteLength || 0, i = e.count, o = e.byteStride, a = new Uint8Array(t, s, n);
                return r.decodeGltfBufferAsync ? r.decodeGltfBufferAsync(i, o, a, e.mode, e.filter).then(function(e) {
                    return e.buffer;
                }) : r.ready.then(function() {
                    const t = new ArrayBuffer(i * o);
                    return r.decodeGltfBuffer(new Uint8Array(t), i, o, a, e.mode, e.filter), t;
                });
            });
        }
        return null;
    }
}
class $fa36f6c1e44235b5$var$GLTFMeshGpuInstancing {
    constructor(e){
        this.name = $fa36f6c1e44235b5$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING, this.parser = e;
    }
    createNodeMesh(e) {
        const t = this.parser.json, s = t.nodes[e];
        if (!s.extensions || !s.extensions[this.name] || void 0 === s.mesh) return null;
        const n = t.meshes[s.mesh];
        for (const e of n.primitives)if (e.mode !== $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.TRIANGLES && e.mode !== $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && e.mode !== $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.TRIANGLE_FAN && void 0 !== e.mode) return null;
        const r = s.extensions[this.name].attributes, i = [], o = {};
        for(const e in r)i.push(this.parser.getDependency("accessor", r[e]).then((t)=>(o[e] = t, o[e])));
        return i.length < 1 ? null : (i.push(this.parser.createNodeMesh(e)), Promise.all(i).then((e)=>{
            const t = e.pop(), s = t.isGroup ? t.children : [
                t
            ], n = e[0].count, r = [];
            for (const e of s){
                const t = new (0, $4a792688e08e5cd7$export$2ae72fc923e5eb5), s = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), i = new (0, $4a792688e08e5cd7$export$23d6a54f0bbc85a3), a = new (0, $4a792688e08e5cd7$export$64b5c384219d3699)(1, 1, 1), c = new (0, $4a792688e08e5cd7$export$f3c979c331175ad7)(e.geometry, e.material, n);
                for(let e = 0; e < n; e++)o.TRANSLATION && s.fromBufferAttribute(o.TRANSLATION, e), o.ROTATION && i.fromBufferAttribute(o.ROTATION, e), o.SCALE && a.fromBufferAttribute(o.SCALE, e), c.setMatrixAt(e, t.compose(s, i, a));
                for(const t in o)if ("_COLOR_0" === t) {
                    const e = o[t];
                    c.instanceColor = new (0, $4a792688e08e5cd7$export$32ea87a8b54d744a)(e.array, e.itemSize, e.normalized);
                } else "TRANSLATION" !== t && "ROTATION" !== t && "SCALE" !== t && e.geometry.setAttribute(t, o[t]);
                (0, $4a792688e08e5cd7$export$e4dd07dff30cc924).prototype.copy.call(c, e), this.parser.assignFinalMaterial(c), r.push(c);
            }
            return t.isGroup ? (t.clear(), t.add(...r), t) : r[0];
        }));
    }
}
const $fa36f6c1e44235b5$var$BINARY_EXTENSION_HEADER_MAGIC = "glTF", $fa36f6c1e44235b5$var$BINARY_EXTENSION_HEADER_LENGTH = 12, $fa36f6c1e44235b5$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 1313821514,
    BIN: 5130562
};
class $fa36f6c1e44235b5$var$GLTFBinaryExtension {
    constructor(e){
        this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_BINARY_GLTF, this.content = null, this.body = null;
        const t = new DataView(e, 0, 12), s = new TextDecoder;
        if (this.header = {
            magic: s.decode(new Uint8Array(e.slice(0, 4))),
            version: t.getUint32(4, !0),
            length: t.getUint32(8, !0)
        }, this.header.magic !== $fa36f6c1e44235b5$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
        if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
        const n = this.header.length - 12, r = new DataView(e, 12);
        let i = 0;
        for(; i < n;){
            const t = r.getUint32(i, !0);
            i += 4;
            const n = r.getUint32(i, !0);
            if (i += 4, n === $fa36f6c1e44235b5$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const n = new Uint8Array(e, 12 + i, t);
                this.content = s.decode(n);
            } else if (n === $fa36f6c1e44235b5$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const s = 12 + i;
                this.body = e.slice(s, s + t);
            }
            i += t;
        }
        if (null === this.content) throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
}
class $fa36f6c1e44235b5$var$GLTFDracoMeshCompressionExtension {
    constructor(e, t){
        if (!t) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
        this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION, this.json = e, this.dracoLoader = t, this.dracoLoader.preload();
    }
    decodePrimitive(e, t) {
        const s = this.json, n = this.dracoLoader, r = e.extensions[this.name].bufferView, i = e.extensions[this.name].attributes, o = {}, a = {}, c = {};
        for(const e in i){
            const t = $fa36f6c1e44235b5$var$ATTRIBUTES[e] || e.toLowerCase();
            o[t] = i[e];
        }
        for(const t in e.attributes){
            const n = $fa36f6c1e44235b5$var$ATTRIBUTES[t] || t.toLowerCase();
            if (void 0 !== i[t]) {
                const r = s.accessors[e.attributes[t]], i = $fa36f6c1e44235b5$var$WEBGL_COMPONENT_TYPES[r.componentType];
                c[n] = i.name, a[n] = !0 === r.normalized;
            }
        }
        return t.getDependency("bufferView", r).then(function(e) {
            return new Promise(function(t, s) {
                n.decodeDracoFile(e, function(e) {
                    for(const t in e.attributes){
                        const s = e.attributes[t], n = a[t];
                        void 0 !== n && (s.normalized = n);
                    }
                    t(e);
                }, o, c, (0, $4a792688e08e5cd7$export$42429b3acfb233a4), s);
            });
        });
    }
}
class $fa36f6c1e44235b5$var$GLTFTextureTransformExtension {
    constructor(){
        this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(e, t) {
        return void 0 !== t.texCoord && t.texCoord !== e.channel || void 0 !== t.offset || void 0 !== t.rotation || void 0 !== t.scale ? (e = e.clone(), void 0 !== t.texCoord && (e.channel = t.texCoord), void 0 !== t.offset && e.offset.fromArray(t.offset), void 0 !== t.rotation && (e.rotation = t.rotation), void 0 !== t.scale && e.repeat.fromArray(t.scale), e.needsUpdate = !0, e) : e;
    }
}
class $fa36f6c1e44235b5$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $fa36f6c1e44235b5$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
class $fa36f6c1e44235b5$var$GLTFCubicSplineInterpolant extends (0, $4a792688e08e5cd7$export$b558baee9c0f72d3) {
    constructor(e, t, s, n){
        super(e, t, s, n);
    }
    copySampleValue_(e) {
        const t = this.resultBuffer, s = this.sampleValues, n = this.valueSize, r = e * n * 3 + n;
        for(let e = 0; e !== n; e++)t[e] = s[r + e];
        return t;
    }
    interpolate_(e, t, s, n) {
        const r = this.resultBuffer, i = this.sampleValues, o = this.valueSize, a = 2 * o, c = 3 * o, l = n - t, u = (s - t) / l, h = u * u, d = h * u, m = e * c, p = m - c, T = -2 * d + 3 * h, f = d - h, E = 1 - T, g = f - h + u;
        for(let e = 0; e !== o; e++){
            const t = i[p + e + o], s = i[p + e + a] * l, n = i[m + e + o], c = i[m + e] * l;
            r[e] = E * t + g * s + T * n + f * c;
        }
        return r;
    }
}
const $fa36f6c1e44235b5$var$_quaternion = new (0, $4a792688e08e5cd7$export$23d6a54f0bbc85a3);
class $fa36f6c1e44235b5$var$GLTFCubicSplineQuaternionInterpolant extends $fa36f6c1e44235b5$var$GLTFCubicSplineInterpolant {
    interpolate_(e, t, s, n) {
        const r = super.interpolate_(e, t, s, n);
        return $fa36f6c1e44235b5$var$_quaternion.fromArray(r).normalize().toArray(r), r;
    }
}
const $fa36f6c1e44235b5$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
}, $fa36f6c1e44235b5$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
}, $fa36f6c1e44235b5$var$WEBGL_FILTERS = {
    9728: (0, $4a792688e08e5cd7$export$727aa5ec3fe39bf0),
    9729: (0, $4a792688e08e5cd7$export$8a72f490b25c56c8),
    9984: (0, $4a792688e08e5cd7$export$d129e38cf6feaa8c),
    9985: (0, $4a792688e08e5cd7$export$19a719f377145a13),
    9986: (0, $4a792688e08e5cd7$export$d2327c1afe5bfdf2),
    9987: (0, $4a792688e08e5cd7$export$5d8599b6a933fb1b)
}, $fa36f6c1e44235b5$var$WEBGL_WRAPPINGS = {
    33071: (0, $4a792688e08e5cd7$export$9d9334239a5a5e06),
    33648: (0, $4a792688e08e5cd7$export$c7e7c00b14f51a4f),
    10497: (0, $4a792688e08e5cd7$export$533346c8e8dac0f5)
}, $fa36f6c1e44235b5$var$WEBGL_TYPE_SIZES = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16
}, $fa36f6c1e44235b5$var$ATTRIBUTES = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv1",
    TEXCOORD_2: "uv2",
    TEXCOORD_3: "uv3",
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
}, $fa36f6c1e44235b5$var$PATH_PROPERTIES = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
}, $fa36f6c1e44235b5$var$INTERPOLATION = {
    CUBICSPLINE: void 0,
    LINEAR: (0, $4a792688e08e5cd7$export$30fac1aace31cf4d),
    STEP: (0, $4a792688e08e5cd7$export$995b32462a65e855)
}, $fa36f6c1e44235b5$var$ALPHA_MODES = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND"
};
function $fa36f6c1e44235b5$var$createDefaultMaterial(e) {
    return void 0 === e.DefaultMaterial && (e.DefaultMaterial = new (0, $4a792688e08e5cd7$export$f2980790215acccd)({
        color: 16777215,
        emissive: 0,
        metalness: 1,
        roughness: 1,
        transparent: !1,
        depthTest: !0,
        side: (0, $4a792688e08e5cd7$export$2ede184fc2998901)
    })), e.DefaultMaterial;
}
function $fa36f6c1e44235b5$var$addUnknownExtensionsToUserData(e, t, s) {
    for(const n in s.extensions)void 0 === e[n] && (t.userData.gltfExtensions = t.userData.gltfExtensions || {}, t.userData.gltfExtensions[n] = s.extensions[n]);
}
function $fa36f6c1e44235b5$var$assignExtrasToUserData(e, t) {
    void 0 !== t.extras && ("object" == typeof t.extras ? Object.assign(e.userData, t.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + t.extras));
}
function $fa36f6c1e44235b5$var$addMorphTargets(e, t, s) {
    let n = !1, r = !1, i = !1;
    for(let e = 0, s = t.length; e < s; e++){
        const s = t[e];
        if (void 0 !== s.POSITION && (n = !0), void 0 !== s.NORMAL && (r = !0), void 0 !== s.COLOR_0 && (i = !0), n && r && i) break;
    }
    if (!n && !r && !i) return Promise.resolve(e);
    const o = [], a = [], c = [];
    for(let l = 0, u = t.length; l < u; l++){
        const u = t[l];
        if (n) {
            const t = void 0 !== u.POSITION ? s.getDependency("accessor", u.POSITION) : e.attributes.position;
            o.push(t);
        }
        if (r) {
            const t = void 0 !== u.NORMAL ? s.getDependency("accessor", u.NORMAL) : e.attributes.normal;
            a.push(t);
        }
        if (i) {
            const t = void 0 !== u.COLOR_0 ? s.getDependency("accessor", u.COLOR_0) : e.attributes.color;
            c.push(t);
        }
    }
    return Promise.all([
        Promise.all(o),
        Promise.all(a),
        Promise.all(c)
    ]).then(function(t) {
        const s = t[0], o = t[1], a = t[2];
        return n && (e.morphAttributes.position = s), r && (e.morphAttributes.normal = o), i && (e.morphAttributes.color = a), e.morphTargetsRelative = !0, e;
    });
}
function $fa36f6c1e44235b5$var$updateMorphTargets(e, t) {
    if (e.updateMorphTargets(), void 0 !== t.weights) for(let s = 0, n = t.weights.length; s < n; s++)e.morphTargetInfluences[s] = t.weights[s];
    if (t.extras && Array.isArray(t.extras.targetNames)) {
        const s = t.extras.targetNames;
        if (e.morphTargetInfluences.length === s.length) {
            e.morphTargetDictionary = {};
            for(let t = 0, n = s.length; t < n; t++)e.morphTargetDictionary[s[t]] = t;
        } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
}
function $fa36f6c1e44235b5$var$createPrimitiveKey(e) {
    let t;
    const s = e.extensions && e.extensions[$fa36f6c1e44235b5$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (t = s ? "draco:" + s.bufferView + ":" + s.indices + ":" + $fa36f6c1e44235b5$var$createAttributesKey(s.attributes) : e.indices + ":" + $fa36f6c1e44235b5$var$createAttributesKey(e.attributes) + ":" + e.mode, void 0 !== e.targets) for(let s = 0, n = e.targets.length; s < n; s++)t += ":" + $fa36f6c1e44235b5$var$createAttributesKey(e.targets[s]);
    return t;
}
function $fa36f6c1e44235b5$var$createAttributesKey(e) {
    let t = "";
    const s = Object.keys(e).sort();
    for(let n = 0, r = s.length; n < r; n++)t += s[n] + ":" + e[s[n]] + ";";
    return t;
}
function $fa36f6c1e44235b5$var$getNormalizedComponentScale(e) {
    switch(e){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
}
function $fa36f6c1e44235b5$var$getImageURIMimeType(e) {
    return e.search(/\.jpe?g($|\?)/i) > 0 || 0 === e.search(/^data\:image\/jpeg/) ? "image/jpeg" : e.search(/\.webp($|\?)/i) > 0 || 0 === e.search(/^data\:image\/webp/) ? "image/webp" : e.search(/\.ktx2($|\?)/i) > 0 || 0 === e.search(/^data\:image\/ktx2/) ? "image/ktx2" : "image/png";
}
const $fa36f6c1e44235b5$var$_identityMatrix = new (0, $4a792688e08e5cd7$export$2ae72fc923e5eb5);
class $fa36f6c1e44235b5$var$GLTFParser {
    constructor(e = {}, t = {}){
        this.json = e, this.extensions = {}, this.plugins = {}, this.options = t, this.cache = new $fa36f6c1e44235b5$var$GLTFRegistry, this.associations = new Map, this.primitiveCache = {}, this.nodeCache = {}, this.meshCache = {
            refs: {},
            uses: {}
        }, this.cameraCache = {
            refs: {},
            uses: {}
        }, this.lightCache = {
            refs: {},
            uses: {}
        }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
        let s = !1, n = -1, r = !1, i = -1;
        if ("undefined" != typeof navigator) {
            const e = navigator.userAgent;
            s = !0 === /^((?!chrome|android).)*safari/i.test(e);
            const t = e.match(/Version\/(\d+)/);
            n = s && t ? parseInt(t[1], 10) : -1, r = e.indexOf("Firefox") > -1, i = r ? e.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        "undefined" == typeof createImageBitmap || s && n < 17 || r && i < 98 ? this.textureLoader = new (0, $4a792688e08e5cd7$export$fd1bfc71f64c538c)(this.options.manager) : this.textureLoader = new (0, $4a792688e08e5cd7$export$52286b55c4a9b51f)(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new (0, $4a792688e08e5cd7$export$98435a25b5cf7b2b)(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), "use-credentials" === this.options.crossOrigin && this.fileLoader.setWithCredentials(!0);
    }
    setExtensions(e) {
        this.extensions = e;
    }
    setPlugins(e) {
        this.plugins = e;
    }
    parse(e, t) {
        const s = this, n = this.json, r = this.extensions;
        this.cache.removeAll(), this.nodeCache = {}, this._invokeAll(function(e) {
            return e._markDefs && e._markDefs();
        }), Promise.all(this._invokeAll(function(e) {
            return e.beforeRoot && e.beforeRoot();
        })).then(function() {
            return Promise.all([
                s.getDependencies("scene"),
                s.getDependencies("animation"),
                s.getDependencies("camera")
            ]);
        }).then(function(t) {
            const i = {
                scene: t[0][n.scene || 0],
                scenes: t[0],
                animations: t[1],
                cameras: t[2],
                asset: n.asset,
                parser: s,
                userData: {}
            };
            return $fa36f6c1e44235b5$var$addUnknownExtensionsToUserData(r, i, n), $fa36f6c1e44235b5$var$assignExtrasToUserData(i, n), Promise.all(s._invokeAll(function(e) {
                return e.afterRoot && e.afterRoot(i);
            })).then(function() {
                for (const e of i.scenes)e.updateMatrixWorld();
                e(i);
            });
        }).catch(t);
    }
    _markDefs() {
        const e = this.json.nodes || [], t = this.json.skins || [], s = this.json.meshes || [];
        for(let s = 0, n = t.length; s < n; s++){
            const n = t[s].joints;
            for(let t = 0, s = n.length; t < s; t++)e[n[t]].isBone = !0;
        }
        for(let t = 0, n = e.length; t < n; t++){
            const n = e[t];
            void 0 !== n.mesh && (this._addNodeRef(this.meshCache, n.mesh), void 0 !== n.skin && (s[n.mesh].isSkinnedMesh = !0)), void 0 !== n.camera && this._addNodeRef(this.cameraCache, n.camera);
        }
    }
    _addNodeRef(e, t) {
        void 0 !== t && (void 0 === e.refs[t] && (e.refs[t] = e.uses[t] = 0), e.refs[t]++);
    }
    _getNodeRef(e, t, s) {
        if (e.refs[t] <= 1) return s;
        const n = s.clone(), r = (e, t)=>{
            const s = this.associations.get(e);
            null != s && this.associations.set(t, s);
            for (const [s, n] of e.children.entries())r(n, t.children[s]);
        };
        return r(s, n), n.name += "_instance_" + e.uses[t]++, n;
    }
    _invokeOne(e) {
        const t = Object.values(this.plugins);
        t.push(this);
        for(let s = 0; s < t.length; s++){
            const n = e(t[s]);
            if (n) return n;
        }
        return null;
    }
    _invokeAll(e) {
        const t = Object.values(this.plugins);
        t.unshift(this);
        const s = [];
        for(let n = 0; n < t.length; n++){
            const r = e(t[n]);
            r && s.push(r);
        }
        return s;
    }
    getDependency(e, t) {
        const s = e + ":" + t;
        let n = this.cache.get(s);
        if (!n) {
            switch(e){
                case "scene":
                    n = this.loadScene(t);
                    break;
                case "node":
                    n = this._invokeOne(function(e) {
                        return e.loadNode && e.loadNode(t);
                    });
                    break;
                case "mesh":
                    n = this._invokeOne(function(e) {
                        return e.loadMesh && e.loadMesh(t);
                    });
                    break;
                case "accessor":
                    n = this.loadAccessor(t);
                    break;
                case "bufferView":
                    n = this._invokeOne(function(e) {
                        return e.loadBufferView && e.loadBufferView(t);
                    });
                    break;
                case "buffer":
                    n = this.loadBuffer(t);
                    break;
                case "material":
                    n = this._invokeOne(function(e) {
                        return e.loadMaterial && e.loadMaterial(t);
                    });
                    break;
                case "texture":
                    n = this._invokeOne(function(e) {
                        return e.loadTexture && e.loadTexture(t);
                    });
                    break;
                case "skin":
                    n = this.loadSkin(t);
                    break;
                case "animation":
                    n = this._invokeOne(function(e) {
                        return e.loadAnimation && e.loadAnimation(t);
                    });
                    break;
                case "camera":
                    n = this.loadCamera(t);
                    break;
                default:
                    if (n = this._invokeOne(function(s) {
                        return s != this && s.getDependency && s.getDependency(e, t);
                    }), !n) throw new Error("Unknown type: " + e);
            }
            this.cache.add(s, n);
        }
        return n;
    }
    getDependencies(e) {
        let t = this.cache.get(e);
        if (!t) {
            const s = this, n = this.json[e + ("mesh" === e ? "es" : "s")] || [];
            t = Promise.all(n.map(function(t, n) {
                return s.getDependency(e, n);
            })), this.cache.add(e, t);
        }
        return t;
    }
    loadBuffer(e) {
        const t = this.json.buffers[e], s = this.fileLoader;
        if (t.type && "arraybuffer" !== t.type) throw new Error("THREE.GLTFLoader: " + t.type + " buffer type is not supported.");
        if (void 0 === t.uri && 0 === e) return Promise.resolve(this.extensions[$fa36f6c1e44235b5$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const n = this.options;
        return new Promise(function(e, r) {
            s.load((0, $4a792688e08e5cd7$export$b5d2dc08d867e41a).resolveURL(t.uri, n.path), e, void 0, function() {
                r(new Error('THREE.GLTFLoader: Failed to load buffer "' + t.uri + '".'));
            });
        });
    }
    loadBufferView(e) {
        const t = this.json.bufferViews[e];
        return this.getDependency("buffer", t.buffer).then(function(e) {
            const s = t.byteLength || 0, n = t.byteOffset || 0;
            return e.slice(n, n + s);
        });
    }
    loadAccessor(e) {
        const t = this, s = this.json, n = this.json.accessors[e];
        if (void 0 === n.bufferView && void 0 === n.sparse) {
            const e = $fa36f6c1e44235b5$var$WEBGL_TYPE_SIZES[n.type], t = $fa36f6c1e44235b5$var$WEBGL_COMPONENT_TYPES[n.componentType], s = !0 === n.normalized, r = new t(n.count * e);
            return Promise.resolve(new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(r, e, s));
        }
        const r = [];
        return void 0 !== n.bufferView ? r.push(this.getDependency("bufferView", n.bufferView)) : r.push(null), void 0 !== n.sparse && (r.push(this.getDependency("bufferView", n.sparse.indices.bufferView)), r.push(this.getDependency("bufferView", n.sparse.values.bufferView))), Promise.all(r).then(function(e) {
            const r = e[0], i = $fa36f6c1e44235b5$var$WEBGL_TYPE_SIZES[n.type], o = $fa36f6c1e44235b5$var$WEBGL_COMPONENT_TYPES[n.componentType], a = o.BYTES_PER_ELEMENT, c = a * i, l = n.byteOffset || 0, u = void 0 !== n.bufferView ? s.bufferViews[n.bufferView].byteStride : void 0, h = !0 === n.normalized;
            let d, m;
            if (u && u !== c) {
                const e = Math.floor(l / u), s = "InterleavedBuffer:" + n.bufferView + ":" + n.componentType + ":" + e + ":" + n.count;
                let c = t.cache.get(s);
                c || (d = new o(r, e * u, n.count * u / a), c = new (0, $4a792688e08e5cd7$export$3d5cd879f108f53f)(d, u / a), t.cache.add(s, c)), m = new (0, $4a792688e08e5cd7$export$920b6d07334599c7)(c, i, l % u / a, h);
            } else d = null === r ? new o(n.count * i) : new o(r, l, n.count * i), m = new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(d, i, h);
            if (void 0 !== n.sparse) {
                const t = $fa36f6c1e44235b5$var$WEBGL_TYPE_SIZES.SCALAR, s = $fa36f6c1e44235b5$var$WEBGL_COMPONENT_TYPES[n.sparse.indices.componentType], a = n.sparse.indices.byteOffset || 0, c = n.sparse.values.byteOffset || 0, l = new s(e[1], a, n.sparse.count * t), u = new o(e[2], c, n.sparse.count * i);
                null !== r && (m = new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(m.array.slice(), m.itemSize, m.normalized)), m.normalized = !1;
                for(let e = 0, t = l.length; e < t; e++){
                    const t = l[e];
                    if (m.setX(t, u[e * i]), i >= 2 && m.setY(t, u[e * i + 1]), i >= 3 && m.setZ(t, u[e * i + 2]), i >= 4 && m.setW(t, u[e * i + 3]), i >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                }
                m.normalized = h;
            }
            return m;
        });
    }
    loadTexture(e) {
        const t = this.json, s = this.options, n = t.textures[e].source, r = t.images[n];
        let i = this.textureLoader;
        if (r.uri) {
            const e = s.manager.getHandler(r.uri);
            null !== e && (i = e);
        }
        return this.loadTextureImage(e, n, i);
    }
    loadTextureImage(e, t, s) {
        const n = this, r = this.json, i = r.textures[e], o = r.images[t], a = (o.uri || o.bufferView) + ":" + i.sampler;
        if (this.textureCache[a]) return this.textureCache[a];
        const c = this.loadImageSource(t, s).then(function(t) {
            t.flipY = !1, t.name = i.name || o.name || "", "" === t.name && "string" == typeof o.uri && !1 === o.uri.startsWith("data:image/") && (t.name = o.uri);
            const s = (r.samplers || {})[i.sampler] || {};
            return t.magFilter = $fa36f6c1e44235b5$var$WEBGL_FILTERS[s.magFilter] || (0, $4a792688e08e5cd7$export$8a72f490b25c56c8), t.minFilter = $fa36f6c1e44235b5$var$WEBGL_FILTERS[s.minFilter] || (0, $4a792688e08e5cd7$export$5d8599b6a933fb1b), t.wrapS = $fa36f6c1e44235b5$var$WEBGL_WRAPPINGS[s.wrapS] || (0, $4a792688e08e5cd7$export$533346c8e8dac0f5), t.wrapT = $fa36f6c1e44235b5$var$WEBGL_WRAPPINGS[s.wrapT] || (0, $4a792688e08e5cd7$export$533346c8e8dac0f5), t.generateMipmaps = !t.isCompressedTexture && t.minFilter !== (0, $4a792688e08e5cd7$export$727aa5ec3fe39bf0) && t.minFilter !== (0, $4a792688e08e5cd7$export$8a72f490b25c56c8), n.associations.set(t, {
                textures: e
            }), t;
        }).catch(function() {
            return null;
        });
        return this.textureCache[a] = c, c;
    }
    loadImageSource(e, t) {
        const s = this, n = this.json, r = this.options;
        if (void 0 !== this.sourceCache[e]) return this.sourceCache[e].then((e)=>e.clone());
        const i = n.images[e], o = self.URL || self.webkitURL;
        let a = i.uri || "", c = !1;
        if (void 0 !== i.bufferView) a = s.getDependency("bufferView", i.bufferView).then(function(e) {
            c = !0;
            const t = new Blob([
                e
            ], {
                type: i.mimeType
            });
            return a = o.createObjectURL(t), a;
        });
        else if (void 0 === i.uri) throw new Error("THREE.GLTFLoader: Image " + e + " is missing URI and bufferView");
        const l = Promise.resolve(a).then(function(e) {
            return new Promise(function(s, n) {
                let i = s;
                !0 === t.isImageBitmapLoader && (i = function(e) {
                    const t = new (0, $4a792688e08e5cd7$export$5431306cf43de24a)(e);
                    t.needsUpdate = !0, s(t);
                }), t.load((0, $4a792688e08e5cd7$export$b5d2dc08d867e41a).resolveURL(e, r.path), i, void 0, n);
            });
        }).then(function(e) {
            return !0 === c && o.revokeObjectURL(a), $fa36f6c1e44235b5$var$assignExtrasToUserData(e, i), e.userData.mimeType = i.mimeType || $fa36f6c1e44235b5$var$getImageURIMimeType(i.uri), e;
        }).catch(function(e) {
            throw console.error("THREE.GLTFLoader: Couldn't load texture", a), e;
        });
        return this.sourceCache[e] = l, l;
    }
    assignTexture(e, t, s, n) {
        const r = this;
        return this.getDependency("texture", s.index).then(function(i) {
            if (!i) return null;
            if (void 0 !== s.texCoord && s.texCoord > 0 && ((i = i.clone()).channel = s.texCoord), r.extensions[$fa36f6c1e44235b5$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const e = void 0 !== s.extensions ? s.extensions[$fa36f6c1e44235b5$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : void 0;
                if (e) {
                    const t = r.associations.get(i);
                    i = r.extensions[$fa36f6c1e44235b5$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(i, e), r.associations.set(i, t);
                }
            }
            return void 0 !== n && (i.colorSpace = n), e[t] = i, i;
        });
    }
    assignFinalMaterial(e) {
        const t = e.geometry;
        let s = e.material;
        const n = void 0 === t.attributes.tangent, r = void 0 !== t.attributes.color, i = void 0 === t.attributes.normal;
        if (e.isPoints) {
            const e = "PointsMaterial:" + s.uuid;
            let t = this.cache.get(e);
            t || (t = new (0, $4a792688e08e5cd7$export$a178c45366ce5d6b), (0, $4a792688e08e5cd7$export$a2d8b23205c25948).prototype.copy.call(t, s), t.color.copy(s.color), t.map = s.map, t.sizeAttenuation = !1, this.cache.add(e, t)), s = t;
        } else if (e.isLine) {
            const e = "LineBasicMaterial:" + s.uuid;
            let t = this.cache.get(e);
            t || (t = new (0, $4a792688e08e5cd7$export$fbaaa33907730a0c), (0, $4a792688e08e5cd7$export$a2d8b23205c25948).prototype.copy.call(t, s), t.color.copy(s.color), t.map = s.map, this.cache.add(e, t)), s = t;
        }
        if (n || r || i) {
            let e = "ClonedMaterial:" + s.uuid + ":";
            n && (e += "derivative-tangents:"), r && (e += "vertex-colors:"), i && (e += "flat-shading:");
            let t = this.cache.get(e);
            t || (t = s.clone(), r && (t.vertexColors = !0), i && (t.flatShading = !0), n && (t.normalScale && (t.normalScale.y *= -1), t.clearcoatNormalScale && (t.clearcoatNormalScale.y *= -1)), this.cache.add(e, t), this.associations.set(t, this.associations.get(s))), s = t;
        }
        e.material = s;
    }
    getMaterialType() {
        return 0, $4a792688e08e5cd7$export$f2980790215acccd;
    }
    loadMaterial(e) {
        const t = this, s = this.json, n = this.extensions, r = s.materials[e];
        let i;
        const o = {}, a = [];
        if ((r.extensions || {})[$fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const e = n[$fa36f6c1e44235b5$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            i = e.getMaterialType(), a.push(e.extendParams(o, r, t));
        } else {
            const s = r.pbrMetallicRoughness || {};
            if (o.color = new (0, $4a792688e08e5cd7$export$892596cec99bc70e)(1, 1, 1), o.opacity = 1, Array.isArray(s.baseColorFactor)) {
                const e = s.baseColorFactor;
                o.color.setRGB(e[0], e[1], e[2], (0, $4a792688e08e5cd7$export$42429b3acfb233a4)), o.opacity = e[3];
            }
            void 0 !== s.baseColorTexture && a.push(t.assignTexture(o, "map", s.baseColorTexture, (0, $4a792688e08e5cd7$export$561f394b24edfcaa))), o.metalness = void 0 !== s.metallicFactor ? s.metallicFactor : 1, o.roughness = void 0 !== s.roughnessFactor ? s.roughnessFactor : 1, void 0 !== s.metallicRoughnessTexture && (a.push(t.assignTexture(o, "metalnessMap", s.metallicRoughnessTexture)), a.push(t.assignTexture(o, "roughnessMap", s.metallicRoughnessTexture))), i = this._invokeOne(function(t) {
                return t.getMaterialType && t.getMaterialType(e);
            }), a.push(Promise.all(this._invokeAll(function(t) {
                return t.extendMaterialParams && t.extendMaterialParams(e, o);
            })));
        }
        !0 === r.doubleSided && (o.side = (0, $4a792688e08e5cd7$export$3b296b6f144d5b03));
        const c = r.alphaMode || $fa36f6c1e44235b5$var$ALPHA_MODES.OPAQUE;
        if (c === $fa36f6c1e44235b5$var$ALPHA_MODES.BLEND ? (o.transparent = !0, o.depthWrite = !1) : (o.transparent = !1, c === $fa36f6c1e44235b5$var$ALPHA_MODES.MASK && (o.alphaTest = void 0 !== r.alphaCutoff ? r.alphaCutoff : .5)), void 0 !== r.normalTexture && i !== (0, $4a792688e08e5cd7$export$55cbcc9b622fe1f5) && (a.push(t.assignTexture(o, "normalMap", r.normalTexture)), o.normalScale = new (0, $4a792688e08e5cd7$export$c977b3e384af9ae1)(1, 1), void 0 !== r.normalTexture.scale)) {
            const e = r.normalTexture.scale;
            o.normalScale.set(e, e);
        }
        if (void 0 !== r.occlusionTexture && i !== (0, $4a792688e08e5cd7$export$55cbcc9b622fe1f5) && (a.push(t.assignTexture(o, "aoMap", r.occlusionTexture)), void 0 !== r.occlusionTexture.strength && (o.aoMapIntensity = r.occlusionTexture.strength)), void 0 !== r.emissiveFactor && i !== (0, $4a792688e08e5cd7$export$55cbcc9b622fe1f5)) {
            const e = r.emissiveFactor;
            o.emissive = (new (0, $4a792688e08e5cd7$export$892596cec99bc70e)).setRGB(e[0], e[1], e[2], (0, $4a792688e08e5cd7$export$42429b3acfb233a4));
        }
        return void 0 !== r.emissiveTexture && i !== (0, $4a792688e08e5cd7$export$55cbcc9b622fe1f5) && a.push(t.assignTexture(o, "emissiveMap", r.emissiveTexture, (0, $4a792688e08e5cd7$export$561f394b24edfcaa))), Promise.all(a).then(function() {
            const s = new i(o);
            return r.name && (s.name = r.name), $fa36f6c1e44235b5$var$assignExtrasToUserData(s, r), t.associations.set(s, {
                materials: e
            }), r.extensions && $fa36f6c1e44235b5$var$addUnknownExtensionsToUserData(n, s, r), s;
        });
    }
    createUniqueName(e) {
        const t = (0, $4a792688e08e5cd7$export$7bf70fcf9f891893).sanitizeNodeName(e || "");
        return t in this.nodeNamesUsed ? t + "_" + ++this.nodeNamesUsed[t] : (this.nodeNamesUsed[t] = 0, t);
    }
    loadGeometries(e) {
        const t = this, s = this.extensions, n = this.primitiveCache;
        function r(e) {
            return s[$fa36f6c1e44235b5$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(e, t).then(function(s) {
                return $fa36f6c1e44235b5$var$addPrimitiveAttributes(s, e, t);
            });
        }
        const i = [];
        for(let s = 0, o = e.length; s < o; s++){
            const o = e[s], a = $fa36f6c1e44235b5$var$createPrimitiveKey(o), c = n[a];
            if (c) i.push(c.promise);
            else {
                let e;
                e = o.extensions && o.extensions[$fa36f6c1e44235b5$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION] ? r(o) : $fa36f6c1e44235b5$var$addPrimitiveAttributes(new (0, $4a792688e08e5cd7$export$b7be63a67df8959), o, t), n[a] = {
                    primitive: o,
                    promise: e
                }, i.push(e);
            }
        }
        return Promise.all(i);
    }
    loadMesh(e) {
        const t = this, s = this.json, n = this.extensions, r = s.meshes[e], i = r.primitives, o = [];
        for(let e = 0, t = i.length; e < t; e++){
            const t = void 0 === i[e].material ? $fa36f6c1e44235b5$var$createDefaultMaterial(this.cache) : this.getDependency("material", i[e].material);
            o.push(t);
        }
        return o.push(t.loadGeometries(i)), Promise.all(o).then(function(s) {
            const o = s.slice(0, s.length - 1), a = s[s.length - 1], c = [];
            for(let s = 0, l = a.length; s < l; s++){
                const l = a[s], u = i[s];
                let h;
                const d = o[s];
                if (u.mode === $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.TRIANGLES || u.mode === $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || u.mode === $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.TRIANGLE_FAN || void 0 === u.mode) h = !0 === r.isSkinnedMesh ? new (0, $4a792688e08e5cd7$export$b303577035157ecf)(l, d) : new (0, $4a792688e08e5cd7$export$e176487c05830cc5)(l, d), !0 === h.isSkinnedMesh && h.normalizeSkinWeights(), u.mode === $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.TRIANGLE_STRIP ? h.geometry = (0, $3f15025bddcabebe$export$5492ca6e5c0c7aa0)(h.geometry, (0, $4a792688e08e5cd7$export$b23a071aa286eb29)) : u.mode === $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.TRIANGLE_FAN && (h.geometry = (0, $3f15025bddcabebe$export$5492ca6e5c0c7aa0)(h.geometry, (0, $4a792688e08e5cd7$export$f0d8293634f88842)));
                else if (u.mode === $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.LINES) h = new (0, $4a792688e08e5cd7$export$ff1ed10fedfdd604)(l, d);
                else if (u.mode === $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.LINE_STRIP) h = new (0, $4a792688e08e5cd7$export$17d680238e50603e)(l, d);
                else if (u.mode === $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.LINE_LOOP) h = new (0, $4a792688e08e5cd7$export$f85a24d745e4f17d)(l, d);
                else {
                    if (u.mode !== $fa36f6c1e44235b5$var$WEBGL_CONSTANTS.POINTS) throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + u.mode);
                    h = new (0, $4a792688e08e5cd7$export$1c787534cb11aa3e)(l, d);
                }
                Object.keys(h.geometry.morphAttributes).length > 0 && $fa36f6c1e44235b5$var$updateMorphTargets(h, r), h.name = t.createUniqueName(r.name || "mesh_" + e), $fa36f6c1e44235b5$var$assignExtrasToUserData(h, r), u.extensions && $fa36f6c1e44235b5$var$addUnknownExtensionsToUserData(n, h, u), t.assignFinalMaterial(h), c.push(h);
            }
            for(let s = 0, n = c.length; s < n; s++)t.associations.set(c[s], {
                meshes: e,
                primitives: s
            });
            if (1 === c.length) return r.extensions && $fa36f6c1e44235b5$var$addUnknownExtensionsToUserData(n, c[0], r), c[0];
            const l = new (0, $4a792688e08e5cd7$export$eb2fcfdbd7ba97d4);
            r.extensions && $fa36f6c1e44235b5$var$addUnknownExtensionsToUserData(n, l, r), t.associations.set(l, {
                meshes: e
            });
            for(let e = 0, t = c.length; e < t; e++)l.add(c[e]);
            return l;
        });
    }
    loadCamera(e) {
        let t;
        const s = this.json.cameras[e], n = s[s.type];
        if (n) return "perspective" === s.type ? t = new (0, $4a792688e08e5cd7$export$74e4ae24825f68d7)((0, $4a792688e08e5cd7$export$6a7ef315a0d1ef07).radToDeg(n.yfov), n.aspectRatio || 1, n.znear || 1, n.zfar || 2e6) : "orthographic" === s.type && (t = new (0, $4a792688e08e5cd7$export$9ebf355ee4ed261b)(-n.xmag, n.xmag, n.ymag, -n.ymag, n.znear, n.zfar)), s.name && (t.name = this.createUniqueName(s.name)), $fa36f6c1e44235b5$var$assignExtrasToUserData(t, s), Promise.resolve(t);
        console.warn("THREE.GLTFLoader: Missing camera parameters.");
    }
    loadSkin(e) {
        const t = this.json.skins[e], s = [];
        for(let e = 0, n = t.joints.length; e < n; e++)s.push(this._loadNodeShallow(t.joints[e]));
        return void 0 !== t.inverseBindMatrices ? s.push(this.getDependency("accessor", t.inverseBindMatrices)) : s.push(null), Promise.all(s).then(function(e) {
            const s = e.pop(), n = e, r = [], i = [];
            for(let e = 0, o = n.length; e < o; e++){
                const o = n[e];
                if (o) {
                    r.push(o);
                    const t = new (0, $4a792688e08e5cd7$export$2ae72fc923e5eb5);
                    null !== s && t.fromArray(s.array, 16 * e), i.push(t);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', t.joints[e]);
            }
            return new (0, $4a792688e08e5cd7$export$8f31e4c4a37b8e9c)(r, i);
        });
    }
    loadAnimation(e) {
        const t = this.json, s = this, n = t.animations[e], r = n.name ? n.name : "animation_" + e, i = [], o = [], a = [], c = [], l = [];
        for(let e = 0, t = n.channels.length; e < t; e++){
            const t = n.channels[e], s = n.samplers[t.sampler], r = t.target, u = r.node, h = void 0 !== n.parameters ? n.parameters[s.input] : s.input, d = void 0 !== n.parameters ? n.parameters[s.output] : s.output;
            void 0 !== r.node && (i.push(this.getDependency("node", u)), o.push(this.getDependency("accessor", h)), a.push(this.getDependency("accessor", d)), c.push(s), l.push(r));
        }
        return Promise.all([
            Promise.all(i),
            Promise.all(o),
            Promise.all(a),
            Promise.all(c),
            Promise.all(l)
        ]).then(function(e) {
            const t = e[0], i = e[1], o = e[2], a = e[3], c = e[4], l = [];
            for(let e = 0, n = t.length; e < n; e++){
                const n = t[e], r = i[e], u = o[e], h = a[e], d = c[e];
                if (void 0 === n) continue;
                n.updateMatrix && n.updateMatrix();
                const m = s._createAnimationTracks(n, r, u, h, d);
                if (m) for(let e = 0; e < m.length; e++)l.push(m[e]);
            }
            const u = new (0, $4a792688e08e5cd7$export$d942c706bf23829c)(r, void 0, l);
            return $fa36f6c1e44235b5$var$assignExtrasToUserData(u, n), u;
        });
    }
    createNodeMesh(e) {
        const t = this.json, s = this, n = t.nodes[e];
        return void 0 === n.mesh ? null : s.getDependency("mesh", n.mesh).then(function(e) {
            const t = s._getNodeRef(s.meshCache, n.mesh, e);
            return void 0 !== n.weights && t.traverse(function(e) {
                if (e.isMesh) for(let t = 0, s = n.weights.length; t < s; t++)e.morphTargetInfluences[t] = n.weights[t];
            }), t;
        });
    }
    loadNode(e) {
        const t = this, s = this.json.nodes[e], n = t._loadNodeShallow(e), r = [], i = s.children || [];
        for(let e = 0, s = i.length; e < s; e++)r.push(t.getDependency("node", i[e]));
        const o = void 0 === s.skin ? Promise.resolve(null) : t.getDependency("skin", s.skin);
        return Promise.all([
            n,
            Promise.all(r),
            o
        ]).then(function(e) {
            const t = e[0], s = e[1], n = e[2];
            null !== n && t.traverse(function(e) {
                e.isSkinnedMesh && e.bind(n, $fa36f6c1e44235b5$var$_identityMatrix);
            });
            for(let e = 0, n = s.length; e < n; e++)t.add(s[e]);
            return t;
        });
    }
    _loadNodeShallow(e) {
        const t = this.json, s = this.extensions, n = this;
        if (void 0 !== this.nodeCache[e]) return this.nodeCache[e];
        const r = t.nodes[e], i = r.name ? n.createUniqueName(r.name) : "", o = [], a = n._invokeOne(function(t) {
            return t.createNodeMesh && t.createNodeMesh(e);
        });
        return a && o.push(a), void 0 !== r.camera && o.push(n.getDependency("camera", r.camera).then(function(e) {
            return n._getNodeRef(n.cameraCache, r.camera, e);
        })), n._invokeAll(function(t) {
            return t.createNodeAttachment && t.createNodeAttachment(e);
        }).forEach(function(e) {
            o.push(e);
        }), this.nodeCache[e] = Promise.all(o).then(function(t) {
            let o;
            if (o = !0 === r.isBone ? new (0, $4a792688e08e5cd7$export$b127726e56765aa4) : t.length > 1 ? new (0, $4a792688e08e5cd7$export$eb2fcfdbd7ba97d4) : 1 === t.length ? t[0] : new (0, $4a792688e08e5cd7$export$e4dd07dff30cc924), o !== t[0]) for(let e = 0, s = t.length; e < s; e++)o.add(t[e]);
            if (r.name && (o.userData.name = r.name, o.name = i), $fa36f6c1e44235b5$var$assignExtrasToUserData(o, r), r.extensions && $fa36f6c1e44235b5$var$addUnknownExtensionsToUserData(s, o, r), void 0 !== r.matrix) {
                const e = new (0, $4a792688e08e5cd7$export$2ae72fc923e5eb5);
                e.fromArray(r.matrix), o.applyMatrix4(e);
            } else void 0 !== r.translation && o.position.fromArray(r.translation), void 0 !== r.rotation && o.quaternion.fromArray(r.rotation), void 0 !== r.scale && o.scale.fromArray(r.scale);
            if (n.associations.has(o)) {
                if (void 0 !== r.mesh && n.meshCache.refs[r.mesh] > 1) {
                    const e = n.associations.get(o);
                    n.associations.set(o, {
                        ...e
                    });
                }
            } else n.associations.set(o, {});
            return n.associations.get(o).nodes = e, o;
        }), this.nodeCache[e];
    }
    loadScene(e) {
        const t = this.extensions, s = this.json.scenes[e], n = this, r = new (0, $4a792688e08e5cd7$export$eb2fcfdbd7ba97d4);
        s.name && (r.name = n.createUniqueName(s.name)), $fa36f6c1e44235b5$var$assignExtrasToUserData(r, s), s.extensions && $fa36f6c1e44235b5$var$addUnknownExtensionsToUserData(t, r, s);
        const i = s.nodes || [], o = [];
        for(let e = 0, t = i.length; e < t; e++)o.push(n.getDependency("node", i[e]));
        return Promise.all(o).then(function(e) {
            for(let t = 0, s = e.length; t < s; t++)r.add(e[t]);
            return n.associations = ((e)=>{
                const t = new Map;
                for (const [e, s] of n.associations)(e instanceof (0, $4a792688e08e5cd7$export$a2d8b23205c25948) || e instanceof (0, $4a792688e08e5cd7$export$5431306cf43de24a)) && t.set(e, s);
                return e.traverse((e)=>{
                    const s = n.associations.get(e);
                    null != s && t.set(e, s);
                }), t;
            })(r), r;
        });
    }
    _createAnimationTracks(e, t, s, n, r) {
        const i = [], o = e.name ? e.name : e.uuid, a = [];
        let c;
        switch($fa36f6c1e44235b5$var$PATH_PROPERTIES[r.path] === $fa36f6c1e44235b5$var$PATH_PROPERTIES.weights ? e.traverse(function(e) {
            e.morphTargetInfluences && a.push(e.name ? e.name : e.uuid);
        }) : a.push(o), $fa36f6c1e44235b5$var$PATH_PROPERTIES[r.path]){
            case $fa36f6c1e44235b5$var$PATH_PROPERTIES.weights:
                c = (0, $4a792688e08e5cd7$export$d45f0d1a4d9a9314);
                break;
            case $fa36f6c1e44235b5$var$PATH_PROPERTIES.rotation:
                c = (0, $4a792688e08e5cd7$export$b8043f12b5aafbd7);
                break;
            case $fa36f6c1e44235b5$var$PATH_PROPERTIES.translation:
            case $fa36f6c1e44235b5$var$PATH_PROPERTIES.scale:
                c = (0, $4a792688e08e5cd7$export$5ce2dcb4cc9f2bff);
                break;
            default:
                if (1 === s.itemSize) c = (0, $4a792688e08e5cd7$export$d45f0d1a4d9a9314);
                else c = (0, $4a792688e08e5cd7$export$5ce2dcb4cc9f2bff);
        }
        const l = void 0 !== n.interpolation ? $fa36f6c1e44235b5$var$INTERPOLATION[n.interpolation] : (0, $4a792688e08e5cd7$export$30fac1aace31cf4d), u = this._getArrayFromAccessor(s);
        for(let e = 0, s = a.length; e < s; e++){
            const s = new c(a[e] + "." + $fa36f6c1e44235b5$var$PATH_PROPERTIES[r.path], t.array, u, l);
            "CUBICSPLINE" === n.interpolation && this._createCubicSplineTrackInterpolant(s), i.push(s);
        }
        return i;
    }
    _getArrayFromAccessor(e) {
        let t = e.array;
        if (e.normalized) {
            const e = $fa36f6c1e44235b5$var$getNormalizedComponentScale(t.constructor), s = new Float32Array(t.length);
            for(let n = 0, r = t.length; n < r; n++)s[n] = t[n] * e;
            t = s;
        }
        return t;
    }
    _createCubicSplineTrackInterpolant(e) {
        e.createInterpolant = function(e) {
            return new (this instanceof (0, $4a792688e08e5cd7$export$b8043f12b5aafbd7) ? $fa36f6c1e44235b5$var$GLTFCubicSplineQuaternionInterpolant : $fa36f6c1e44235b5$var$GLTFCubicSplineInterpolant)(this.times, this.values, this.getValueSize() / 3, e);
        }, e.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0;
    }
}
function $fa36f6c1e44235b5$var$computeBounds(e, t, s) {
    const n = t.attributes, r = new (0, $4a792688e08e5cd7$export$6f7d5a9418ab2aa3);
    if (void 0 === n.POSITION) return;
    {
        const e = s.json.accessors[n.POSITION], t = e.min, i = e.max;
        if (void 0 === t || void 0 === i) return void console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
        if (r.set(new (0, $4a792688e08e5cd7$export$64b5c384219d3699)(t[0], t[1], t[2]), new (0, $4a792688e08e5cd7$export$64b5c384219d3699)(i[0], i[1], i[2])), e.normalized) {
            const t = $fa36f6c1e44235b5$var$getNormalizedComponentScale($fa36f6c1e44235b5$var$WEBGL_COMPONENT_TYPES[e.componentType]);
            r.min.multiplyScalar(t), r.max.multiplyScalar(t);
        }
    }
    const i = t.targets;
    if (void 0 !== i) {
        const e = new (0, $4a792688e08e5cd7$export$64b5c384219d3699), t = new (0, $4a792688e08e5cd7$export$64b5c384219d3699);
        for(let n = 0, r = i.length; n < r; n++){
            const r = i[n];
            if (void 0 !== r.POSITION) {
                const n = s.json.accessors[r.POSITION], i = n.min, o = n.max;
                if (void 0 !== i && void 0 !== o) {
                    if (t.setX(Math.max(Math.abs(i[0]), Math.abs(o[0]))), t.setY(Math.max(Math.abs(i[1]), Math.abs(o[1]))), t.setZ(Math.max(Math.abs(i[2]), Math.abs(o[2]))), n.normalized) {
                        const e = $fa36f6c1e44235b5$var$getNormalizedComponentScale($fa36f6c1e44235b5$var$WEBGL_COMPONENT_TYPES[n.componentType]);
                        t.multiplyScalar(e);
                    }
                    e.max(t);
                } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            }
        }
        r.expandByVector(e);
    }
    e.boundingBox = r;
    const o = new (0, $4a792688e08e5cd7$export$805e8b72413ccaba);
    r.getCenter(o.center), o.radius = r.min.distanceTo(r.max) / 2, e.boundingSphere = o;
}
function $fa36f6c1e44235b5$var$addPrimitiveAttributes(e, t, s) {
    const n = t.attributes, r = [];
    function i(t, n) {
        return s.getDependency("accessor", t).then(function(t) {
            e.setAttribute(n, t);
        });
    }
    for(const t in n){
        const s = $fa36f6c1e44235b5$var$ATTRIBUTES[t] || t.toLowerCase();
        s in e.attributes || r.push(i(n[t], s));
    }
    if (void 0 !== t.indices && !e.index) {
        const n = s.getDependency("accessor", t.indices).then(function(t) {
            e.setIndex(t);
        });
        r.push(n);
    }
    return (0, $4a792688e08e5cd7$export$5e6fd513f44698c).workingColorSpace !== (0, $4a792688e08e5cd7$export$42429b3acfb233a4) && "COLOR_0" in n && console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${(0, $4a792688e08e5cd7$export$5e6fd513f44698c).workingColorSpace}" not supported.`), $fa36f6c1e44235b5$var$assignExtrasToUserData(e, t), $fa36f6c1e44235b5$var$computeBounds(e, t, s), Promise.all(r).then(function() {
        return void 0 !== t.targets ? $fa36f6c1e44235b5$var$addMorphTargets(e, t.targets, s) : e;
    });
}
 //# sourceMappingURL=/sm/0c836b0e3c3cdd4ad9909d49525e5caa707550b1f59de95f6add8c34c5c50219.map


/**
 * Minified by jsDelivr using Terser v5.39.0.
 * Original file: /npm/three@0.181.2/examples/jsm/loaders/DRACOLoader.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */ 
const $b717453e1584735e$var$_taskCache = new WeakMap;
class $b717453e1584735e$export$45c25de53be259ac extends (0, $4a792688e08e5cd7$export$3b0d6d7590275603) {
    constructor(e){
        super(e), this.decoderPath = "", this.decoderConfig = {}, this.decoderBinary = null, this.decoderPending = null, this.workerLimit = 4, this.workerPool = [], this.workerNextTaskID = 1, this.workerSourceURL = "", this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        }, this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(e) {
        return this.decoderPath = e, this;
    }
    setDecoderConfig(e) {
        return this.decoderConfig = e, this;
    }
    setWorkerLimit(e) {
        return this.workerLimit = e, this;
    }
    load(e, t, r, o) {
        const s = new (0, $4a792688e08e5cd7$export$98435a25b5cf7b2b)(this.manager);
        s.setPath(this.path), s.setResponseType("arraybuffer"), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(e, (e)=>{
            this.parse(e, t, o);
        }, r, o);
    }
    parse(e, t, r = ()=>{}) {
        this.decodeDracoFile(e, t, null, null, (0, $4a792688e08e5cd7$export$561f394b24edfcaa), r).catch(r);
    }
    decodeDracoFile(e, t, r, o, s = (0, $4a792688e08e5cd7$export$42429b3acfb233a4), a = ()=>{}) {
        const n = {
            attributeIDs: r || this.defaultAttributeIDs,
            attributeTypes: o || this.defaultAttributeTypes,
            useUniqueIDs: !!r,
            vertexColorSpace: s
        };
        return this.decodeGeometry(e, n).then(t).catch(a);
    }
    decodeGeometry(e, t) {
        const r = JSON.stringify(t);
        if ($b717453e1584735e$var$_taskCache.has(e)) {
            const t = $b717453e1584735e$var$_taskCache.get(e);
            if (t.key === r) return t.promise;
            if (0 === e.byteLength) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        let o;
        const s = this.workerNextTaskID++, a = e.byteLength, n = this._getWorker(s, a).then((r)=>(o = r, new Promise((r, a)=>{
                o._callbacks[s] = {
                    resolve: r,
                    reject: a
                }, o.postMessage({
                    type: "decode",
                    id: s,
                    taskConfig: t,
                    buffer: e
                }, [
                    e
                ]);
            }))).then((e)=>this._createGeometry(e.geometry));
        return n.catch(()=>!0).then(()=>{
            o && s && this._releaseTask(o, s);
        }), $b717453e1584735e$var$_taskCache.set(e, {
            key: r,
            promise: n
        }), n;
    }
    _createGeometry(e) {
        const t = new (0, $4a792688e08e5cd7$export$b7be63a67df8959);
        e.index && t.setIndex(new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(e.index.array, 1));
        for(let r = 0; r < e.attributes.length; r++){
            const { name: o, array: s, itemSize: a, stride: n, vertexColorSpace: i } = e.attributes[r];
            let c;
            if (a === n) c = new (0, $4a792688e08e5cd7$export$8dea267bd6bde117)(s, a);
            else {
                const e = new (0, $4a792688e08e5cd7$export$3d5cd879f108f53f)(s, n);
                c = new (0, $4a792688e08e5cd7$export$920b6d07334599c7)(e, a, 0);
            }
            "color" === o && (this._assignVertexColorSpace(c, i), c.normalized = s instanceof Float32Array == !1), t.setAttribute(o, c);
        }
        return t;
    }
    _assignVertexColorSpace(e, t) {
        if (t !== (0, $4a792688e08e5cd7$export$561f394b24edfcaa)) return;
        const r = new (0, $4a792688e08e5cd7$export$892596cec99bc70e);
        for(let t = 0, o = e.count; t < o; t++)r.fromBufferAttribute(e, t), (0, $4a792688e08e5cd7$export$5e6fd513f44698c).colorSpaceToWorking(r, (0, $4a792688e08e5cd7$export$561f394b24edfcaa)), e.setXYZ(t, r.r, r.g, r.b);
    }
    _loadLibrary(e, t) {
        const r = new (0, $4a792688e08e5cd7$export$98435a25b5cf7b2b)(this.manager);
        return r.setPath(this.decoderPath), r.setResponseType(t), r.setWithCredentials(this.withCredentials), new Promise((t, o)=>{
            r.load(e, t, void 0, o);
        });
    }
    preload() {
        return this._initDecoder(), this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        const e = "object" != typeof WebAssembly || "js" === this.decoderConfig.type, t = [];
        return e ? t.push(this._loadLibrary("draco_decoder.js", "text")) : (t.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), t.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(t).then((t)=>{
            const r = t[0];
            e || (this.decoderConfig.wasmBinary = t[1]);
            const o = $b717453e1584735e$var$DRACOWorker.toString(), s = [
                "/* draco decoder */",
                r,
                "",
                "/* worker */",
                o.substring(o.indexOf("{") + 1, o.lastIndexOf("}"))
            ].join("\n");
            this.workerSourceURL = URL.createObjectURL(new Blob([
                s
            ]));
        }), this.decoderPending;
    }
    _getWorker(e, t) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                const e = new Worker(this.workerSourceURL);
                e._callbacks = {}, e._taskCosts = {}, e._taskLoad = 0, e.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                }), e.onmessage = function(t) {
                    const r = t.data;
                    switch(r.type){
                        case "decode":
                            e._callbacks[r.id].resolve(r);
                            break;
                        case "error":
                            e._callbacks[r.id].reject(r);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + r.type + '"');
                    }
                }, this.workerPool.push(e);
            } else this.workerPool.sort(function(e, t) {
                return e._taskLoad > t._taskLoad ? -1 : 1;
            });
            const r = this.workerPool[this.workerPool.length - 1];
            return r._taskCosts[e] = t, r._taskLoad += t, r;
        });
    }
    _releaseTask(e, t) {
        e._taskLoad -= e._taskCosts[t], delete e._callbacks[t], delete e._taskCosts[t];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((e)=>e._taskLoad));
    }
    dispose() {
        for(let e = 0; e < this.workerPool.length; ++e)this.workerPool[e].terminate();
        return this.workerPool.length = 0, "" !== this.workerSourceURL && URL.revokeObjectURL(this.workerSourceURL), this;
    }
}
function $b717453e1584735e$var$DRACOWorker() {
    let e, t;
    function r(e, t, r, o, s, a) {
        const n = r.num_points(), i = a.num_components(), c = function(e, t) {
            switch(t){
                case Float32Array:
                    return e.DT_FLOAT32;
                case Int8Array:
                    return e.DT_INT8;
                case Int16Array:
                    return e.DT_INT16;
                case Int32Array:
                    return e.DT_INT32;
                case Uint8Array:
                    return e.DT_UINT8;
                case Uint16Array:
                    return e.DT_UINT16;
                case Uint32Array:
                    return e.DT_UINT32;
            }
        }(e, s), d = i * s.BYTES_PER_ELEMENT, l = 4 * Math.ceil(d / 4), u = l / s.BYTES_PER_ELEMENT, h = n * d, f = n * l, y = e._malloc(h);
        t.GetAttributeDataArrayForAllPoints(r, a, c, h, y);
        const _ = new s(e.HEAPF32.buffer, y, h / s.BYTES_PER_ELEMENT);
        let p;
        if (d === l) p = _.slice();
        else {
            p = new s(f / s.BYTES_PER_ELEMENT);
            let e = 0;
            for(let t = 0, r = _.length; t < r; t++){
                for(let r = 0; r < i; r++)p[e + r] = _[t * i + r];
                e += u;
            }
        }
        return e._free(y), {
            name: o,
            count: n,
            itemSize: i,
            array: p,
            stride: u
        };
    }
    onmessage = function(o) {
        const s = o.data;
        switch(s.type){
            case "init":
                e = s.decoderConfig, t = new Promise(function(t) {
                    e.onModuleLoaded = function(e) {
                        t({
                            draco: e
                        });
                    }, DracoDecoderModule(e);
                });
                break;
            case "decode":
                const o1 = s.buffer, a = s.taskConfig;
                t.then((e)=>{
                    const t = e.draco, n = new t.Decoder;
                    try {
                        const e = function(e, t, o, s) {
                            const a = s.attributeIDs, n = s.attributeTypes;
                            let i, c;
                            const d = t.GetEncodedGeometryType(o);
                            if (d === e.TRIANGULAR_MESH) i = new e.Mesh, c = t.DecodeArrayToMesh(o, o.byteLength, i);
                            else {
                                if (d !== e.POINT_CLOUD) throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
                                i = new e.PointCloud, c = t.DecodeArrayToPointCloud(o, o.byteLength, i);
                            }
                            if (!c.ok() || 0 === i.ptr) throw new Error("THREE.DRACOLoader: Decoding failed: " + c.error_msg());
                            const l = {
                                index: null,
                                attributes: []
                            };
                            for(const o in a){
                                const c = self[n[o]];
                                let d, u;
                                if (s.useUniqueIDs) u = a[o], d = t.GetAttributeByUniqueId(i, u);
                                else {
                                    if (u = t.GetAttributeId(i, e[a[o]]), -1 === u) continue;
                                    d = t.GetAttribute(i, u);
                                }
                                const h = r(e, t, i, o, c, d);
                                "color" === o && (h.vertexColorSpace = s.vertexColorSpace), l.attributes.push(h);
                            }
                            d === e.TRIANGULAR_MESH && (l.index = function(e, t, r) {
                                const o = r.num_faces(), s = 3 * o, a = 4 * s, n = e._malloc(a);
                                t.GetTrianglesUInt32Array(r, a, n);
                                const i = new Uint32Array(e.HEAPF32.buffer, n, s).slice();
                                return e._free(n), {
                                    array: i,
                                    itemSize: 1
                                };
                            }(e, t, i));
                            return e.destroy(i), l;
                        }(t, n, new Int8Array(o1), a), i = e.attributes.map((e)=>e.array.buffer);
                        e.index && i.push(e.index.array.buffer), self.postMessage({
                            type: "decode",
                            id: s.id,
                            geometry: e
                        }, i);
                    } catch (e) {
                        console.error(e), self.postMessage({
                            type: "error",
                            id: s.id,
                            error: e.message
                        });
                    } finally{
                        t.destroy(n);
                    }
                });
        }
    };
}
 //# sourceMappingURL=/sm/97a9e673ebdc81ff160e01413ebafa42644cf2d1f203633cf03c3d8aaa588ff9.map


var $0a06c4d6833722ed$exports = {};
/**
 * MapLibre GL JS
 * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v5.13.0/LICENSE.txt
 */ (function(global, factory) {
    $0a06c4d6833722ed$exports = factory();
})($0a06c4d6833722ed$exports, function() {
    'use strict';
    /* eslint-disable */ var maplibregl = {};
    var modules = {};
    function define(moduleName, _dependencies, moduleFactory) {
        modules[moduleName] = moduleFactory;
        // to get the list of modules see generated dist/maplibre-gl-dev.js file (look for `define(` calls)
        if (moduleName !== 'index') return;
        // we assume that when an index module is initializing then other modules are loaded already
        var workerBundleString = 'var sharedModule = {}; (' + modules.shared + ')(sharedModule); (' + modules.worker + ')(sharedModule);';
        var sharedModule = {};
        // the order of arguments of a module factory depends on rollup (it decides who is whose dependency)
        // to check the correct order, see dist/maplibre-gl-dev.js file (look for `define(` calls)
        // we assume that for our 3 chunks it will generate 3 modules and their order is predefined like the following
        modules.shared(sharedModule);
        modules.index(maplibregl, sharedModule);
        if (typeof window !== 'undefined') maplibregl.setWorkerUrl(window.URL.createObjectURL(new Blob([
            workerBundleString
        ], {
            type: 'text/javascript'
        })));
        return maplibregl;
    }
    define("shared", [
        "exports"
    ], function(e1) {
        "use strict";
        function t(e1, t, r, n) {
            return new (r || (r = Promise))(function(i, s) {
                function o(e1) {
                    try {
                        l(n.next(e1));
                    } catch (e1) {
                        s(e1);
                    }
                }
                function a(e1) {
                    try {
                        l(n.throw(e1));
                    } catch (e1) {
                        s(e1);
                    }
                }
                function l(e1) {
                    var t;
                    e1.done ? i(e1.value) : (t = e1.value, t instanceof r ? t : new r(function(e1) {
                        e1(t);
                    })).then(o, a);
                }
                l((n = n.apply(e1, t || [])).next());
            });
        }
        function r(e1, t) {
            this.x = e1, this.y = t;
        }
        function n(e1) {
            return e1 && e1.__esModule && Object.prototype.hasOwnProperty.call(e1, "default") ? e1.default : e1;
        }
        var i, s;
        "function" == typeof SuppressedError && SuppressedError, r.prototype = {
            clone () {
                return new r(this.x, this.y);
            },
            add (e1) {
                return this.clone()._add(e1);
            },
            sub (e1) {
                return this.clone()._sub(e1);
            },
            multByPoint (e1) {
                return this.clone()._multByPoint(e1);
            },
            divByPoint (e1) {
                return this.clone()._divByPoint(e1);
            },
            mult (e1) {
                return this.clone()._mult(e1);
            },
            div (e1) {
                return this.clone()._div(e1);
            },
            rotate (e1) {
                return this.clone()._rotate(e1);
            },
            rotateAround (e1, t) {
                return this.clone()._rotateAround(e1, t);
            },
            matMult (e1) {
                return this.clone()._matMult(e1);
            },
            unit () {
                return this.clone()._unit();
            },
            perp () {
                return this.clone()._perp();
            },
            round () {
                return this.clone()._round();
            },
            mag () {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals (e1) {
                return this.x === e1.x && this.y === e1.y;
            },
            dist (e1) {
                return Math.sqrt(this.distSqr(e1));
            },
            distSqr (e1) {
                const t = e1.x - this.x, r = e1.y - this.y;
                return t * t + r * r;
            },
            angle () {
                return Math.atan2(this.y, this.x);
            },
            angleTo (e1) {
                return Math.atan2(this.y - e1.y, this.x - e1.x);
            },
            angleWith (e1) {
                return this.angleWithSep(e1.x, e1.y);
            },
            angleWithSep (e1, t) {
                return Math.atan2(this.x * t - this.y * e1, this.x * e1 + this.y * t);
            },
            _matMult (e1) {
                const t = e1[2] * this.x + e1[3] * this.y;
                return this.x = e1[0] * this.x + e1[1] * this.y, this.y = t, this;
            },
            _add (e1) {
                return this.x += e1.x, this.y += e1.y, this;
            },
            _sub (e1) {
                return this.x -= e1.x, this.y -= e1.y, this;
            },
            _mult (e1) {
                return this.x *= e1, this.y *= e1, this;
            },
            _div (e1) {
                return this.x /= e1, this.y /= e1, this;
            },
            _multByPoint (e1) {
                return this.x *= e1.x, this.y *= e1.y, this;
            },
            _divByPoint (e1) {
                return this.x /= e1.x, this.y /= e1.y, this;
            },
            _unit () {
                return this._div(this.mag()), this;
            },
            _perp () {
                const e1 = this.y;
                return this.y = this.x, this.x = -e1, this;
            },
            _rotate (e1) {
                const t = Math.cos(e1), r = Math.sin(e1), n = r * this.x + t * this.y;
                return this.x = t * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround (e1, t) {
                const r = Math.cos(e1), n = Math.sin(e1), i = t.y + n * (this.x - t.x) + r * (this.y - t.y);
                return this.x = t.x + r * (this.x - t.x) - n * (this.y - t.y), this.y = i, this;
            },
            _round () {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            },
            constructor: r
        }, r.convert = function(e1) {
            if (e1 instanceof r) return e1;
            if (Array.isArray(e1)) return new r(+e1[0], +e1[1]);
            if (void 0 !== e1.x && void 0 !== e1.y) return new r(+e1.x, +e1.y);
            throw new Error("Expected [x, y] or {x, y} point format");
        };
        var o = function() {
            if (s) return i;
            function e1(e1, t, r, n) {
                this.cx = 3 * e1, this.bx = 3 * (r - e1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * t, this.by = 3 * (n - t) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = e1, this.p1y = t, this.p2x = r, this.p2y = n;
            }
            return s = 1, i = e1, e1.prototype = {
                sampleCurveX: function(e1) {
                    return ((this.ax * e1 + this.bx) * e1 + this.cx) * e1;
                },
                sampleCurveY: function(e1) {
                    return ((this.ay * e1 + this.by) * e1 + this.cy) * e1;
                },
                sampleCurveDerivativeX: function(e1) {
                    return (3 * this.ax * e1 + 2 * this.bx) * e1 + this.cx;
                },
                solveCurveX: function(e1, t) {
                    if (void 0 === t && (t = 1e-6), e1 < 0) return 0;
                    if (e1 > 1) return 1;
                    for(var r = e1, n = 0; n < 8; n++){
                        var i = this.sampleCurveX(r) - e1;
                        if (Math.abs(i) < t) return r;
                        var s = this.sampleCurveDerivativeX(r);
                        if (Math.abs(s) < 1e-6) break;
                        r -= i / s;
                    }
                    var o = 0, a = 1;
                    for(r = e1, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - e1) < t)); n++)e1 > i ? o = r : a = r, r = .5 * (a - o) + o;
                    return r;
                },
                solve: function(e1, t) {
                    return this.sampleCurveY(this.solveCurveX(e1, t));
                }
            }, i;
        }(), a = n(o);
        let l, u;
        function c() {
            return null == l && (l = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), l;
        }
        function h() {
            if (null == u && (u = !1, c())) {
                const e1 = 5, t = new OffscreenCanvas(e1, e1).getContext("2d", {
                    willReadFrequently: !0
                });
                if (t) {
                    for(let r = 0; r < e1 * e1; r++){
                        const n = 4 * r;
                        t.fillStyle = `rgb(${n},${n + 1},${n + 2})`, t.fillRect(r % e1, Math.floor(r / e1), 1, 1);
                    }
                    const r = t.getImageData(0, 0, e1, e1).data;
                    for(let t = 0; t < e1 * e1 * 4; t++)if (t % 4 != 3 && r[t] !== t) {
                        u = !0;
                        break;
                    }
                }
            }
            return u || !1;
        }
        var p = 1e-6, f = "undefined" != typeof Float32Array ? Float32Array : Array;
        function d() {
            var e1 = new f(9);
            return f != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0), e1[0] = 1, e1[4] = 1, e1[8] = 1, e1;
        }
        function y(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        function m() {
            var e1 = new f(3);
            return f != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1;
        }
        function g(e1) {
            var t = e1[0], r = e1[1], n = e1[2];
            return Math.sqrt(t * t + r * r + n * n);
        }
        function x(e1, t, r) {
            var n = new f(3);
            return n[0] = e1, n[1] = t, n[2] = r, n;
        }
        function v(e1, t, r) {
            return e1[0] = t[0] + r[0], e1[1] = t[1] + r[1], e1[2] = t[2] + r[2], e1;
        }
        function b(e1, t, r) {
            return e1[0] = t[0] * r, e1[1] = t[1] * r, e1[2] = t[2] * r, e1;
        }
        function w(e1, t, r) {
            var n = t[0], i = t[1], s = t[2], o = r[0], a = r[1], l = r[2];
            return e1[0] = i * l - s * a, e1[1] = s * o - n * l, e1[2] = n * a - i * o, e1;
        }
        var _, S = g;
        function A(e1, t, r) {
            var n = t[0], i = t[1], s = t[2], o = t[3];
            return e1[0] = r[0] * n + r[4] * i + r[8] * s + r[12] * o, e1[1] = r[1] * n + r[5] * i + r[9] * s + r[13] * o, e1[2] = r[2] * n + r[6] * i + r[10] * s + r[14] * o, e1[3] = r[3] * n + r[7] * i + r[11] * s + r[15] * o, e1;
        }
        function T() {
            var e1 = new f(4);
            return f != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1[3] = 1, e1;
        }
        function I(e1, t, r, n) {
            var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "zyx", s = Math.PI / 360;
            t *= s, n *= s, r *= s;
            var o = Math.sin(t), a = Math.cos(t), l = Math.sin(r), u = Math.cos(r), c = Math.sin(n), h = Math.cos(n);
            switch(i){
                case "xyz":
                    e1[0] = o * u * h + a * l * c, e1[1] = a * l * h - o * u * c, e1[2] = a * u * c + o * l * h, e1[3] = a * u * h - o * l * c;
                    break;
                case "xzy":
                    e1[0] = o * u * h - a * l * c, e1[1] = a * l * h - o * u * c, e1[2] = a * u * c + o * l * h, e1[3] = a * u * h + o * l * c;
                    break;
                case "yxz":
                    e1[0] = o * u * h + a * l * c, e1[1] = a * l * h - o * u * c, e1[2] = a * u * c - o * l * h, e1[3] = a * u * h + o * l * c;
                    break;
                case "yzx":
                    e1[0] = o * u * h + a * l * c, e1[1] = a * l * h + o * u * c, e1[2] = a * u * c - o * l * h, e1[3] = a * u * h - o * l * c;
                    break;
                case "zxy":
                    e1[0] = o * u * h - a * l * c, e1[1] = a * l * h + o * u * c, e1[2] = a * u * c + o * l * h, e1[3] = a * u * h - o * l * c;
                    break;
                case "zyx":
                    e1[0] = o * u * h - a * l * c, e1[1] = a * l * h + o * u * c, e1[2] = a * u * c - o * l * h, e1[3] = a * u * h + o * l * c;
                    break;
                default:
                    throw new Error("Unknown angle order " + i);
            }
            return e1;
        }
        function E() {
            var e1 = new f(2);
            return f != Float32Array && (e1[0] = 0, e1[1] = 0), e1;
        }
        function M(e1, t) {
            var r = new f(2);
            return r[0] = e1, r[1] = t, r;
        }
        m(), _ = new f(4), f != Float32Array && (_[0] = 0, _[1] = 0, _[2] = 0, _[3] = 0), m(), x(1, 0, 0), x(0, 1, 0), T(), T(), d(), E();
        const k = 8192;
        function F(e1, t, r) {
            return t * (k / (e1.tileSize * Math.pow(2, r - e1.tileID.overscaledZ)));
        }
        function D(e1, t) {
            return (e1 % t + t) % t;
        }
        function P(e1, t, r) {
            return e1 * (1 - r) + t * r;
        }
        function B(e1) {
            if (e1 <= 0) return 0;
            if (e1 >= 1) return 1;
            const t = e1 * e1, r = t * e1;
            return 4 * (e1 < .5 ? r : 3 * (e1 - t) + r - .75);
        }
        function z(e1, t, r, n) {
            const i = new a(e1, t, r, n);
            return (e1)=>i.solve(e1);
        }
        const V = z(.25, .1, .25, 1);
        function C(e1, t, r) {
            return Math.min(r, Math.max(t, e1));
        }
        function L(e1, t, r) {
            const n = r - t, i = ((e1 - t) % n + n) % n + t;
            return i === t ? r : i;
        }
        function O(e1, ...t) {
            for (const r of t)for(const t in r)e1[t] = r[t];
            return e1;
        }
        let R = 1;
        function N(e1, t, r) {
            const n = {};
            for(const r in e1)n[r] = t.call(this, e1[r], r, e1);
            return n;
        }
        function $(e1, t, r) {
            const n = {};
            for(const r in e1)t.call(this, e1[r], r, e1) && (n[r] = e1[r]);
            return n;
        }
        function U(e1) {
            return Array.isArray(e1) ? e1.map(U) : "object" == typeof e1 && e1 ? N(e1, U) : e1;
        }
        const q = {};
        function j(e1) {
            q[e1] || ("undefined" != typeof console && console.warn(e1), q[e1] = !0);
        }
        function G(e1, t, r) {
            return (r.y - e1.y) * (t.x - e1.x) > (t.y - e1.y) * (r.x - e1.x);
        }
        function X(e1) {
            return "undefined" != typeof WorkerGlobalScope && void 0 !== e1 && e1 instanceof WorkerGlobalScope;
        }
        let Y = null;
        function Z(e1) {
            return "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap;
        }
        const H = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        function K(e1, r, n, i, s) {
            return t(this, void 0, void 0, function*() {
                if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                const t = new VideoFrame(e1, {
                    timestamp: 0
                });
                try {
                    const o = null == t ? void 0 : t.format;
                    if (!o || !o.startsWith("BGR") && !o.startsWith("RGB")) throw new Error(`Unrecognized format ${o}`);
                    const a = o.startsWith("BGR"), l = new Uint8ClampedArray(i * s * 4);
                    if (yield t.copyTo(l, function(e1, t, r, n, i) {
                        const s = 4 * Math.max(-t, 0), o = (Math.max(0, r) - r) * n * 4 + s, a = 4 * n, l = Math.max(0, t), u = Math.max(0, r);
                        return {
                            rect: {
                                x: l,
                                y: u,
                                width: Math.min(e1.width, t + n) - l,
                                height: Math.min(e1.height, r + i) - u
                            },
                            layout: [
                                {
                                    offset: o,
                                    stride: a
                                }
                            ]
                        };
                    }(e1, r, n, i, s)), a) for(let e1 = 0; e1 < l.length; e1 += 4){
                        const t = l[e1];
                        l[e1] = l[e1 + 2], l[e1 + 2] = t;
                    }
                    return l;
                } finally{
                    t.close();
                }
            });
        }
        let W, J;
        function Q(e1, t, r, n) {
            return e1.addEventListener(t, r, n), {
                unsubscribe: ()=>{
                    e1.removeEventListener(t, r, n);
                }
            };
        }
        function ee(e1) {
            return e1 * Math.PI / 180;
        }
        function te(e1) {
            return e1 / Math.PI * 180;
        }
        const re = {
            touchstart: !0,
            touchmove: !0,
            touchmoveWindow: !0,
            touchend: !0,
            touchcancel: !0
        }, ne = {
            dblclick: !0,
            click: !0,
            mouseover: !0,
            mouseout: !0,
            mousedown: !0,
            mousemove: !0,
            mousemoveWindow: !0,
            mouseup: !0,
            mouseupWindow: !0,
            contextmenu: !0,
            wheel: !0
        }, ie = "AbortError";
        function se() {
            return new Error(ie);
        }
        const oe = {
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
            MAX_TILE_CACHE_ZOOM_LEVELS: 5,
            REGISTERED_PROTOCOLS: {},
            WORKER_URL: ""
        };
        function ae(e1) {
            return oe.REGISTERED_PROTOCOLS[e1.substring(0, e1.indexOf("://"))];
        }
        const le = "global-dispatcher";
        class ue extends Error {
            constructor(e1, t, r, n){
                super(`AJAXError: ${t} (${e1}): ${r}`), this.status = e1, this.statusText = t, this.url = r, this.body = n;
            }
        }
        const ce = ()=>X(self) ? self.worker && self.worker.referrer : ("blob:" === window.location.protocol ? window.parent : window).location.href, he = function(e1, r) {
            if (/:\/\//.test(e1.url) && !/^https?:|^file:/.test(e1.url)) {
                const t = ae(e1.url);
                if (t) return t(e1, r);
                if (X(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                    type: "GR",
                    data: e1,
                    targetMapId: le
                }, r);
            }
            if (!(/^file:/.test(n = e1.url) || /^file:/.test(ce()) && !/^\w+:/.test(n))) {
                if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return function(e1, r) {
                    return t(this, void 0, void 0, function*() {
                        const t = new Request(e1.url, {
                            method: e1.method || "GET",
                            body: e1.body,
                            credentials: e1.credentials,
                            headers: e1.headers,
                            cache: e1.cache,
                            referrer: ce(),
                            signal: r.signal
                        });
                        let n, i;
                        "json" !== e1.type || t.headers.has("Accept") || t.headers.set("Accept", "application/json");
                        try {
                            n = yield fetch(t);
                        } catch (t) {
                            throw new ue(0, t.message, e1.url, new Blob);
                        }
                        if (!n.ok) {
                            const t = yield n.blob();
                            throw new ue(n.status, n.statusText, e1.url, t);
                        }
                        i = "arrayBuffer" === e1.type || "image" === e1.type ? n.arrayBuffer() : "json" === e1.type ? n.json() : n.text();
                        const s = yield i;
                        if (r.signal.aborted) throw se();
                        return {
                            data: s,
                            cacheControl: n.headers.get("Cache-Control"),
                            expires: n.headers.get("Expires")
                        };
                    });
                }(e1, r);
                if (X(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                    type: "GR",
                    data: e1,
                    mustQueue: !0,
                    targetMapId: le
                }, r);
            }
            var n;
            return function(e1, t) {
                return new Promise((r, n)=>{
                    var i;
                    const s = new XMLHttpRequest;
                    s.open(e1.method || "GET", e1.url, !0), "arrayBuffer" !== e1.type && "image" !== e1.type || (s.responseType = "arraybuffer");
                    for(const t in e1.headers)s.setRequestHeader(t, e1.headers[t]);
                    "json" === e1.type && (s.responseType = "text", (null === (i = e1.headers) || void 0 === i ? void 0 : i.Accept) || s.setRequestHeader("Accept", "application/json")), s.withCredentials = "include" === e1.credentials, s.onerror = ()=>{
                        n(new Error(s.statusText));
                    }, s.onload = ()=>{
                        if (!t.signal.aborted) {
                            if ((s.status >= 200 && s.status < 300 || 0 === s.status) && null !== s.response) {
                                let t = s.response;
                                if ("json" === e1.type) try {
                                    t = JSON.parse(s.response);
                                } catch (e1) {
                                    return void n(e1);
                                }
                                r({
                                    data: t,
                                    cacheControl: s.getResponseHeader("Cache-Control"),
                                    expires: s.getResponseHeader("Expires")
                                });
                            } else {
                                const t = new Blob([
                                    s.response
                                ], {
                                    type: s.getResponseHeader("Content-Type")
                                });
                                n(new ue(s.status, s.statusText, e1.url, t));
                            }
                        }
                    }, t.signal.addEventListener("abort", ()=>{
                        s.abort(), n(se());
                    }), s.send(e1.body);
                });
            }(e1, r);
        };
        function pe(e1) {
            if (!e1 || e1.indexOf("://") <= 0 || 0 === e1.indexOf("data:image/") || 0 === e1.indexOf("blob:")) return !0;
            const t = new URL(e1), r = window.location;
            return t.protocol === r.protocol && t.host === r.host;
        }
        function fe(e1, t, r) {
            r[e1] && -1 !== r[e1].indexOf(t) || (r[e1] = r[e1] || [], r[e1].push(t));
        }
        function de(e1, t, r) {
            if (r && r[e1]) {
                const n = r[e1].indexOf(t);
                -1 !== n && r[e1].splice(n, 1);
            }
        }
        class ye {
            constructor(e1, t = {}){
                O(this, t), this.type = e1;
            }
        }
        class me extends ye {
            constructor(e1, t = {}){
                super("error", O({
                    error: e1
                }, t));
            }
        }
        class ge {
            on(e1, t) {
                return this._listeners = this._listeners || {}, fe(e1, t, this._listeners), {
                    unsubscribe: ()=>{
                        this.off(e1, t);
                    }
                };
            }
            off(e1, t) {
                return de(e1, t, this._listeners), de(e1, t, this._oneTimeListeners), this;
            }
            once(e1, t) {
                return t ? (this._oneTimeListeners = this._oneTimeListeners || {}, fe(e1, t, this._oneTimeListeners), this) : new Promise((t)=>this.once(e1, t));
            }
            fire(e1, t) {
                "string" == typeof e1 && (e1 = new ye(e1, t || {}));
                const r = e1.type;
                if (this.listens(r)) {
                    e1.target = this;
                    const t = this._listeners && this._listeners[r] ? this._listeners[r].slice() : [];
                    for (const r of t)r.call(this, e1);
                    const n = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : [];
                    for (const t of n)de(r, t, this._oneTimeListeners), t.call(this, e1);
                    const i = this._eventedParent;
                    i && (O(e1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(e1));
                } else e1 instanceof me && console.error(e1.error);
                return this;
            }
            listens(e1) {
                return this._listeners && this._listeners[e1] && this._listeners[e1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[e1] && this._oneTimeListeners[e1].length > 0 || this._eventedParent && this._eventedParent.listens(e1);
            }
            setEventedParent(e1, t) {
                return this._eventedParent = e1, this._eventedParentData = t, this;
            }
        }
        var xe = {
            $version: 8,
            $root: {
                version: {
                    required: !0,
                    type: "enum",
                    values: [
                        8
                    ]
                },
                name: {
                    type: "string"
                },
                metadata: {
                    type: "*"
                },
                center: {
                    type: "array",
                    value: "number"
                },
                centerAltitude: {
                    type: "number"
                },
                zoom: {
                    type: "number"
                },
                bearing: {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees"
                },
                pitch: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                roll: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                state: {
                    type: "state",
                    default: {}
                },
                light: {
                    type: "light"
                },
                sky: {
                    type: "sky"
                },
                projection: {
                    type: "projection"
                },
                terrain: {
                    type: "terrain"
                },
                sources: {
                    required: !0,
                    type: "sources"
                },
                sprite: {
                    type: "sprite"
                },
                glyphs: {
                    type: "string"
                },
                "font-faces": {
                    type: "array",
                    value: "fontFaces"
                },
                transition: {
                    type: "transition"
                },
                layers: {
                    required: !0,
                    type: "array",
                    value: "layer"
                }
            },
            sources: {
                "*": {
                    type: "source"
                }
            },
            source: [
                "source_vector",
                "source_raster",
                "source_raster_dem",
                "source_geojson",
                "source_video",
                "source_image"
            ],
            source_vector: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        vector: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                attribution: {
                    type: "string"
                },
                promoteId: {
                    type: "promoteId"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                encoding: {
                    type: "enum",
                    values: {
                        mvt: {},
                        mlt: {}
                    },
                    default: "mvt"
                },
                "*": {
                    type: "*"
                }
            },
            source_raster: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        raster: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                attribution: {
                    type: "string"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster_dem: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        "raster-dem": {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                attribution: {
                    type: "string"
                },
                encoding: {
                    type: "enum",
                    values: {
                        terrarium: {},
                        mapbox: {},
                        custom: {}
                    },
                    default: "mapbox"
                },
                redFactor: {
                    type: "number",
                    default: 1
                },
                blueFactor: {
                    type: "number",
                    default: 1
                },
                greenFactor: {
                    type: "number",
                    default: 1
                },
                baseShift: {
                    type: "number",
                    default: 0
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_geojson: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        geojson: {}
                    }
                },
                data: {
                    required: !0,
                    type: "*"
                },
                maxzoom: {
                    type: "number",
                    default: 18
                },
                attribution: {
                    type: "string"
                },
                buffer: {
                    type: "number",
                    default: 128,
                    maximum: 512,
                    minimum: 0
                },
                filter: {
                    type: "*"
                },
                tolerance: {
                    type: "number",
                    default: .375
                },
                cluster: {
                    type: "boolean",
                    default: !1
                },
                clusterRadius: {
                    type: "number",
                    default: 50,
                    minimum: 0
                },
                clusterMaxZoom: {
                    type: "number"
                },
                clusterMinPoints: {
                    type: "number"
                },
                clusterProperties: {
                    type: "*"
                },
                lineMetrics: {
                    type: "boolean",
                    default: !1
                },
                generateId: {
                    type: "boolean",
                    default: !1
                },
                promoteId: {
                    type: "promoteId"
                }
            },
            source_video: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        video: {}
                    }
                },
                urls: {
                    required: !0,
                    type: "array",
                    value: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            source_image: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        image: {}
                    }
                },
                url: {
                    required: !0,
                    type: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            layer: {
                id: {
                    type: "string",
                    required: !0
                },
                type: {
                    type: "enum",
                    values: {
                        fill: {},
                        line: {},
                        symbol: {},
                        circle: {},
                        heatmap: {},
                        "fill-extrusion": {},
                        raster: {},
                        hillshade: {},
                        "color-relief": {},
                        background: {}
                    },
                    required: !0
                },
                metadata: {
                    type: "*"
                },
                source: {
                    type: "string"
                },
                "source-layer": {
                    type: "string"
                },
                minzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                maxzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                filter: {
                    type: "filter"
                },
                layout: {
                    type: "layout"
                },
                paint: {
                    type: "paint"
                }
            },
            layout: [
                "layout_fill",
                "layout_line",
                "layout_circle",
                "layout_heatmap",
                "layout_fill-extrusion",
                "layout_symbol",
                "layout_raster",
                "layout_hillshade",
                "layout_color-relief",
                "layout_background"
            ],
            layout_background: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_fill: {
                "fill-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_circle: {
                "circle-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_heatmap: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            "layout_fill-extrusion": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_line: {
                "line-cap": {
                    type: "enum",
                    values: {
                        butt: {},
                        round: {},
                        square: {}
                    },
                    default: "butt",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-join": {
                    type: "enum",
                    values: {
                        bevel: {},
                        round: {},
                        miter: {}
                    },
                    default: "miter",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-miter-limit": {
                    type: "number",
                    default: 2,
                    requires: [
                        {
                            "line-join": "miter"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-round-limit": {
                    type: "number",
                    default: 1.05,
                    requires: [
                        {
                            "line-join": "round"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_symbol: {
                "symbol-placement": {
                    type: "enum",
                    values: {
                        point: {},
                        line: {},
                        "line-center": {}
                    },
                    default: "point",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-spacing": {
                    type: "number",
                    default: 250,
                    minimum: 1,
                    units: "pixels",
                    requires: [
                        {
                            "symbol-placement": "line"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-avoid-edges": {
                    type: "boolean",
                    default: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "symbol-z-order": {
                    type: "enum",
                    values: {
                        auto: {},
                        "viewport-y": {},
                        source: {}
                    },
                    default: "auto",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "!": "icon-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-size": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    units: "factor of the original icon size",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-text-fit": {
                    type: "enum",
                    values: {
                        none: {},
                        width: {},
                        height: {},
                        both: {}
                    },
                    default: "none",
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-text-fit-padding": {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        0,
                        0,
                        0,
                        0
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image",
                        "text-field",
                        {
                            "icon-text-fit": [
                                "both",
                                "width",
                                "height"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-image": {
                    type: "resolvedImage",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-padding": {
                    type: "padding",
                    default: [
                        2
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-keep-upright": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "icon-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-offset": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        "viewport-glyph": {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-field": {
                    type: "formatted",
                    default: "",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-font": {
                    type: "array",
                    value: "string",
                    default: [
                        "Open Sans Regular",
                        "Arial Unicode MS Regular"
                    ],
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-size": {
                    type: "number",
                    default: 16,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-width": {
                    type: "number",
                    default: 10,
                    minimum: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-line-height": {
                    type: "number",
                    default: 1.2,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-letter-spacing": {
                    type: "number",
                    default: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-justify": {
                    type: "enum",
                    values: {
                        auto: {},
                        left: {},
                        center: {},
                        right: {}
                    },
                    default: "center",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-radial-offset": {
                    type: "number",
                    units: "ems",
                    default: 0,
                    requires: [
                        "text-field"
                    ],
                    "property-type": "data-driven",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    }
                },
                "text-variable-anchor": {
                    type: "array",
                    value: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-variable-anchor-offset": {
                    type: "variableAnchorOffsetCollection",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "text-field",
                        {
                            "!": "text-variable-anchor"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-angle": {
                    type: "number",
                    default: 45,
                    units: "degrees",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-writing-mode": {
                    type: "array",
                    value: "enum",
                    values: {
                        horizontal: {},
                        vertical: {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-keep-upright": {
                    type: "boolean",
                    default: !0,
                    requires: [
                        "text-field",
                        {
                            "text-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-transform": {
                    type: "enum",
                    values: {
                        none: {},
                        uppercase: {},
                        lowercase: {}
                    },
                    default: "none",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-offset": {
                    type: "array",
                    value: "number",
                    units: "ems",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "text-field",
                        {
                            "!": "text-radial-offset"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        {
                            "!": "text-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_raster: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_hillshade: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            "layout_color-relief": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            filter: {
                type: "array",
                value: "*"
            },
            filter_operator: {
                type: "enum",
                values: {
                    "==": {},
                    "!=": {},
                    ">": {},
                    ">=": {},
                    "<": {},
                    "<=": {},
                    in: {},
                    "!in": {},
                    all: {},
                    any: {},
                    none: {},
                    has: {},
                    "!has": {}
                }
            },
            geometry_type: {
                type: "enum",
                values: {
                    Point: {},
                    LineString: {},
                    Polygon: {}
                }
            },
            function: {
                expression: {
                    type: "expression"
                },
                stops: {
                    type: "array",
                    value: "function_stop"
                },
                base: {
                    type: "number",
                    default: 1,
                    minimum: 0
                },
                property: {
                    type: "string",
                    default: "$zoom"
                },
                type: {
                    type: "enum",
                    values: {
                        identity: {},
                        exponential: {},
                        interval: {},
                        categorical: {}
                    },
                    default: "exponential"
                },
                colorSpace: {
                    type: "enum",
                    values: {
                        rgb: {},
                        lab: {},
                        hcl: {}
                    },
                    default: "rgb"
                },
                default: {
                    type: "*",
                    required: !1
                }
            },
            function_stop: {
                type: "array",
                minimum: 0,
                maximum: 24,
                value: [
                    "number",
                    "color"
                ],
                length: 2
            },
            expression: {
                type: "array",
                value: "*",
                minimum: 1
            },
            light: {
                anchor: {
                    type: "enum",
                    default: "viewport",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                position: {
                    type: "array",
                    default: [
                        1.15,
                        210,
                        30
                    ],
                    length: 3,
                    value: "number",
                    "property-type": "data-constant",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                color: {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                intensity: {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            sky: {
                "sky-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#88C6FC",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "horizon-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "fog-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "fog-ground-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "horizon-fog-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "sky-horizon-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "atmosphere-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            terrain: {
                source: {
                    type: "string",
                    required: !0
                },
                exaggeration: {
                    type: "number",
                    minimum: 0,
                    default: 1
                }
            },
            projection: {
                type: {
                    type: "projectionDefinition",
                    default: "mercator",
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                }
            },
            paint: [
                "paint_fill",
                "paint_line",
                "paint_circle",
                "paint_heatmap",
                "paint_fill-extrusion",
                "paint_symbol",
                "paint_raster",
                "paint_hillshade",
                "paint_color-relief",
                "paint_background"
            ],
            paint_fill: {
                "fill-antialias": {
                    type: "boolean",
                    default: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-outline-color": {
                    type: "color",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        },
                        {
                            "fill-antialias": !0
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                }
            },
            "paint_fill-extrusion": {
                "fill-extrusion-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-extrusion-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-extrusion-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "fill-extrusion-height": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-base": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    requires: [
                        "fill-extrusion-height"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-vertical-gradient": {
                    type: "boolean",
                    default: !0,
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_line: {
                "line-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "line-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-width": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-gap-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-offset": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-dasharray": {
                    type: "array",
                    value: "number",
                    minimum: 0,
                    transition: !0,
                    units: "line widths",
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-gradient": {
                    type: "color",
                    transition: !1,
                    requires: [
                        {
                            "!": "line-dasharray"
                        },
                        {
                            "!": "line-pattern"
                        },
                        {
                            source: "geojson",
                            has: {
                                lineMetrics: !0
                            }
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "line-progress"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_circle: {
                "circle-radius": {
                    type: "number",
                    default: 5,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-blur": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "circle-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-scale": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-stroke-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                }
            },
            paint_heatmap: {
                "heatmap-radius": {
                    type: "number",
                    default: 30,
                    minimum: 1,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-weight": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-intensity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "heatmap-color": {
                    type: "color",
                    default: [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        "rgba(0, 0, 255, 0)",
                        .1,
                        "royalblue",
                        .3,
                        "cyan",
                        .5,
                        "lime",
                        .7,
                        "yellow",
                        1,
                        "red"
                    ],
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "heatmap-density"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                "heatmap-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_symbol: {
                "icon-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "icon-image",
                        "icon-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    overridable: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "text-field",
                        "text-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_raster: {
                "raster-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-hue-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    transition: !0,
                    units: "degrees",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-min": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-max": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-saturation": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-contrast": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-resampling": {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-fade-duration": {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    transition: !1,
                    units: "milliseconds",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_hillshade: {
                "hillshade-illumination-direction": {
                    type: "numberArray",
                    default: 335,
                    minimum: 0,
                    maximum: 359,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-altitude": {
                    type: "numberArray",
                    default: 45,
                    minimum: 0,
                    maximum: 90,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-exaggeration": {
                    type: "number",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-shadow-color": {
                    type: "colorArray",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-highlight-color": {
                    type: "colorArray",
                    default: "#FFFFFF",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-accent-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-method": {
                    type: "enum",
                    values: {
                        standard: {},
                        basic: {},
                        combined: {},
                        igor: {},
                        multidirectional: {}
                    },
                    default: "standard",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            "paint_color-relief": {
                "color-relief-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "color-relief-color": {
                    type: "color",
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "elevation"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_background: {
                "background-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "background-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "background-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "background-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            transition: {
                duration: {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    units: "milliseconds"
                },
                delay: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "milliseconds"
                }
            },
            "property-type": {
                "data-driven": {
                    type: "property-type"
                },
                "cross-faded": {
                    type: "property-type"
                },
                "cross-faded-data-driven": {
                    type: "property-type"
                },
                "color-ramp": {
                    type: "property-type"
                },
                "data-constant": {
                    type: "property-type"
                },
                constant: {
                    type: "property-type"
                }
            },
            promoteId: {
                "*": {
                    type: "string"
                }
            }
        };
        const ve = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ];
        function be(e1, t) {
            const r = {};
            for(const t in e1)"ref" !== t && (r[t] = e1[t]);
            return ve.forEach((e1)=>{
                e1 in t && (r[e1] = t[e1]);
            }), r;
        }
        function we(e1, t) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(t) || e1.length !== t.length) return !1;
                for(let r = 0; r < e1.length; r++)if (!we(e1[r], t[r])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== t) {
                if ("object" != typeof t) return !1;
                if (Object.keys(e1).length !== Object.keys(t).length) return !1;
                for(const r in e1)if (!we(e1[r], t[r])) return !1;
                return !0;
            }
            return e1 === t;
        }
        function _e(e1, t) {
            e1.push(t);
        }
        function Se(e1, t, r) {
            _e(r, {
                command: "addSource",
                args: [
                    e1,
                    t[e1]
                ]
            });
        }
        function Ae(e1, t, r) {
            _e(t, {
                command: "removeSource",
                args: [
                    e1
                ]
            }), r[e1] = !0;
        }
        function Te(e1, t, r, n) {
            Ae(e1, r, n), Se(e1, t, r);
        }
        function Ie(e1, t, r) {
            let n;
            for(n in e1[r])if (Object.prototype.hasOwnProperty.call(e1[r], n) && "data" !== n && !we(e1[r][n], t[r][n])) return !1;
            for(n in t[r])if (Object.prototype.hasOwnProperty.call(t[r], n) && "data" !== n && !we(e1[r][n], t[r][n])) return !1;
            return !0;
        }
        function Ee(e1, t, r, n, i, s) {
            e1 = e1 || {}, t = t || {};
            for(const o in e1)Object.prototype.hasOwnProperty.call(e1, o) && (we(e1[o], t[o]) || r.push({
                command: s,
                args: [
                    n,
                    o,
                    t[o],
                    i
                ]
            }));
            for(const o in t)Object.prototype.hasOwnProperty.call(t, o) && !Object.prototype.hasOwnProperty.call(e1, o) && (we(e1[o], t[o]) || r.push({
                command: s,
                args: [
                    n,
                    o,
                    t[o],
                    i
                ]
            }));
        }
        function Me(e1) {
            return e1.id;
        }
        function ke(e1, t) {
            return e1[t.id] = t, e1;
        }
        class Fe {
            constructor(e1, t, r, n){
                this.message = (e1 ? `${e1}: ` : "") + r, n && (this.identifier = n), null != t && t.__line__ && (this.line = t.__line__);
            }
        }
        function De(e1, ...t) {
            for (const r of t)for(const t in r)e1[t] = r[t];
            return e1;
        }
        class Pe extends Error {
            constructor(e1, t){
                super(t), this.message = t, this.key = e1;
            }
        }
        class Be {
            constructor(e1, t = []){
                this.parent = e1, this.bindings = {};
                for (const [e1, r] of t)this.bindings[e1] = r;
            }
            concat(e1) {
                return new Be(this, e1);
            }
            get(e1) {
                if (this.bindings[e1]) return this.bindings[e1];
                if (this.parent) return this.parent.get(e1);
                throw new Error(`${e1} not found in scope.`);
            }
            has(e1) {
                return !!this.bindings[e1] || !!this.parent && this.parent.has(e1);
            }
        }
        const ze = {
            kind: "null"
        }, Ve = {
            kind: "number"
        }, Ce = {
            kind: "string"
        }, Le = {
            kind: "boolean"
        }, Oe = {
            kind: "color"
        }, Re = {
            kind: "projectionDefinition"
        }, Ne = {
            kind: "object"
        }, $e = {
            kind: "value"
        }, Ue = {
            kind: "collator"
        }, qe = {
            kind: "formatted"
        }, je = {
            kind: "padding"
        }, Ge = {
            kind: "colorArray"
        }, Xe = {
            kind: "numberArray"
        }, Ye = {
            kind: "resolvedImage"
        }, Ze = {
            kind: "variableAnchorOffsetCollection"
        };
        function He(e1, t) {
            return {
                kind: "array",
                itemType: e1,
                N: t
            };
        }
        function Ke(e1) {
            if ("array" === e1.kind) {
                const t = Ke(e1.itemType);
                return "number" == typeof e1.N ? `array<${t}, ${e1.N}>` : "value" === e1.itemType.kind ? "array" : `array<${t}>`;
            }
            return e1.kind;
        }
        const We = [
            ze,
            Ve,
            Ce,
            Le,
            Oe,
            Re,
            qe,
            Ne,
            He($e),
            je,
            Xe,
            Ge,
            Ye,
            Ze
        ];
        function Je(e1, t) {
            if ("error" === t.kind) return null;
            if ("array" === e1.kind) {
                if ("array" === t.kind && (0 === t.N && "value" === t.itemType.kind || !Je(e1.itemType, t.itemType)) && ("number" != typeof e1.N || e1.N === t.N)) return null;
            } else {
                if (e1.kind === t.kind) return null;
                if ("value" === e1.kind) {
                    for (const e1 of We)if (!Je(e1, t)) return null;
                }
            }
            return `Expected ${Ke(e1)} but found ${Ke(t)} instead.`;
        }
        function Qe(e1, t) {
            return t.some((t)=>t.kind === e1.kind);
        }
        function et(e1, t) {
            return t.some((t)=>"null" === t ? null === e1 : "array" === t ? Array.isArray(e1) : "object" === t ? e1 && !Array.isArray(e1) && "object" == typeof e1 : t === typeof e1);
        }
        function tt(e1, t) {
            return "array" === e1.kind && "array" === t.kind ? e1.itemType.kind === t.itemType.kind && "number" == typeof e1.N : e1.kind === t.kind;
        }
        const rt = .96422, nt = .82521, it = 4 / 29, st = 6 / 29, ot = 3 * st * st, at = st * st * st, lt = Math.PI / 180, ut = 180 / Math.PI;
        function ct(e1) {
            return (e1 %= 360) < 0 && (e1 += 360), e1;
        }
        function ht([e1, t, r, n]) {
            let i, s;
            const o = ft((.2225045 * (e1 = pt(e1)) + .7168786 * (t = pt(t)) + .0606169 * (r = pt(r))) / 1);
            e1 === t && t === r ? i = s = o : (i = ft((.4360747 * e1 + .3850649 * t + .1430804 * r) / rt), s = ft((.0139322 * e1 + .0971045 * t + .7141733 * r) / nt));
            const a = 116 * o - 16;
            return [
                a < 0 ? 0 : a,
                500 * (i - o),
                200 * (o - s),
                n
            ];
        }
        function pt(e1) {
            return e1 <= .04045 ? e1 / 12.92 : Math.pow((e1 + .055) / 1.055, 2.4);
        }
        function ft(e1) {
            return e1 > at ? Math.pow(e1, 1 / 3) : e1 / ot + it;
        }
        function dt([e1, t, r, n]) {
            let i = (e1 + 16) / 116, s = isNaN(t) ? i : i + t / 500, o = isNaN(r) ? i : i - r / 200;
            return i = 1 * mt(i), s = rt * mt(s), o = nt * mt(o), [
                yt(3.1338561 * s - 1.6168667 * i - .4906146 * o),
                yt(-0.9787684 * s + 1.9161415 * i + .033454 * o),
                yt(.0719453 * s - .2289914 * i + 1.4052427 * o),
                n
            ];
        }
        function yt(e1) {
            return (e1 = e1 <= .00304 ? 12.92 * e1 : 1.055 * Math.pow(e1, 1 / 2.4) - .055) < 0 ? 0 : e1 > 1 ? 1 : e1;
        }
        function mt(e1) {
            return e1 > st ? e1 * e1 * e1 : ot * (e1 - it);
        }
        const gt = Object.hasOwn || function(e1, t) {
            return Object.prototype.hasOwnProperty.call(e1, t);
        };
        function xt(e1, t) {
            return gt(e1, t) ? e1[t] : void 0;
        }
        function vt(e1) {
            return parseInt(e1.padEnd(2, e1), 16) / 255;
        }
        function bt(e1, t) {
            return wt(t ? e1 / 100 : e1, 0, 1);
        }
        function wt(e1, t, r) {
            return Math.min(Math.max(t, e1), r);
        }
        function _t(e1) {
            return !e1.some(Number.isNaN);
        }
        const St = {
            aliceblue: [
                240,
                248,
                255
            ],
            antiquewhite: [
                250,
                235,
                215
            ],
            aqua: [
                0,
                255,
                255
            ],
            aquamarine: [
                127,
                255,
                212
            ],
            azure: [
                240,
                255,
                255
            ],
            beige: [
                245,
                245,
                220
            ],
            bisque: [
                255,
                228,
                196
            ],
            black: [
                0,
                0,
                0
            ],
            blanchedalmond: [
                255,
                235,
                205
            ],
            blue: [
                0,
                0,
                255
            ],
            blueviolet: [
                138,
                43,
                226
            ],
            brown: [
                165,
                42,
                42
            ],
            burlywood: [
                222,
                184,
                135
            ],
            cadetblue: [
                95,
                158,
                160
            ],
            chartreuse: [
                127,
                255,
                0
            ],
            chocolate: [
                210,
                105,
                30
            ],
            coral: [
                255,
                127,
                80
            ],
            cornflowerblue: [
                100,
                149,
                237
            ],
            cornsilk: [
                255,
                248,
                220
            ],
            crimson: [
                220,
                20,
                60
            ],
            cyan: [
                0,
                255,
                255
            ],
            darkblue: [
                0,
                0,
                139
            ],
            darkcyan: [
                0,
                139,
                139
            ],
            darkgoldenrod: [
                184,
                134,
                11
            ],
            darkgray: [
                169,
                169,
                169
            ],
            darkgreen: [
                0,
                100,
                0
            ],
            darkgrey: [
                169,
                169,
                169
            ],
            darkkhaki: [
                189,
                183,
                107
            ],
            darkmagenta: [
                139,
                0,
                139
            ],
            darkolivegreen: [
                85,
                107,
                47
            ],
            darkorange: [
                255,
                140,
                0
            ],
            darkorchid: [
                153,
                50,
                204
            ],
            darkred: [
                139,
                0,
                0
            ],
            darksalmon: [
                233,
                150,
                122
            ],
            darkseagreen: [
                143,
                188,
                143
            ],
            darkslateblue: [
                72,
                61,
                139
            ],
            darkslategray: [
                47,
                79,
                79
            ],
            darkslategrey: [
                47,
                79,
                79
            ],
            darkturquoise: [
                0,
                206,
                209
            ],
            darkviolet: [
                148,
                0,
                211
            ],
            deeppink: [
                255,
                20,
                147
            ],
            deepskyblue: [
                0,
                191,
                255
            ],
            dimgray: [
                105,
                105,
                105
            ],
            dimgrey: [
                105,
                105,
                105
            ],
            dodgerblue: [
                30,
                144,
                255
            ],
            firebrick: [
                178,
                34,
                34
            ],
            floralwhite: [
                255,
                250,
                240
            ],
            forestgreen: [
                34,
                139,
                34
            ],
            fuchsia: [
                255,
                0,
                255
            ],
            gainsboro: [
                220,
                220,
                220
            ],
            ghostwhite: [
                248,
                248,
                255
            ],
            gold: [
                255,
                215,
                0
            ],
            goldenrod: [
                218,
                165,
                32
            ],
            gray: [
                128,
                128,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            greenyellow: [
                173,
                255,
                47
            ],
            grey: [
                128,
                128,
                128
            ],
            honeydew: [
                240,
                255,
                240
            ],
            hotpink: [
                255,
                105,
                180
            ],
            indianred: [
                205,
                92,
                92
            ],
            indigo: [
                75,
                0,
                130
            ],
            ivory: [
                255,
                255,
                240
            ],
            khaki: [
                240,
                230,
                140
            ],
            lavender: [
                230,
                230,
                250
            ],
            lavenderblush: [
                255,
                240,
                245
            ],
            lawngreen: [
                124,
                252,
                0
            ],
            lemonchiffon: [
                255,
                250,
                205
            ],
            lightblue: [
                173,
                216,
                230
            ],
            lightcoral: [
                240,
                128,
                128
            ],
            lightcyan: [
                224,
                255,
                255
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210
            ],
            lightgray: [
                211,
                211,
                211
            ],
            lightgreen: [
                144,
                238,
                144
            ],
            lightgrey: [
                211,
                211,
                211
            ],
            lightpink: [
                255,
                182,
                193
            ],
            lightsalmon: [
                255,
                160,
                122
            ],
            lightseagreen: [
                32,
                178,
                170
            ],
            lightskyblue: [
                135,
                206,
                250
            ],
            lightslategray: [
                119,
                136,
                153
            ],
            lightslategrey: [
                119,
                136,
                153
            ],
            lightsteelblue: [
                176,
                196,
                222
            ],
            lightyellow: [
                255,
                255,
                224
            ],
            lime: [
                0,
                255,
                0
            ],
            limegreen: [
                50,
                205,
                50
            ],
            linen: [
                250,
                240,
                230
            ],
            magenta: [
                255,
                0,
                255
            ],
            maroon: [
                128,
                0,
                0
            ],
            mediumaquamarine: [
                102,
                205,
                170
            ],
            mediumblue: [
                0,
                0,
                205
            ],
            mediumorchid: [
                186,
                85,
                211
            ],
            mediumpurple: [
                147,
                112,
                219
            ],
            mediumseagreen: [
                60,
                179,
                113
            ],
            mediumslateblue: [
                123,
                104,
                238
            ],
            mediumspringgreen: [
                0,
                250,
                154
            ],
            mediumturquoise: [
                72,
                209,
                204
            ],
            mediumvioletred: [
                199,
                21,
                133
            ],
            midnightblue: [
                25,
                25,
                112
            ],
            mintcream: [
                245,
                255,
                250
            ],
            mistyrose: [
                255,
                228,
                225
            ],
            moccasin: [
                255,
                228,
                181
            ],
            navajowhite: [
                255,
                222,
                173
            ],
            navy: [
                0,
                0,
                128
            ],
            oldlace: [
                253,
                245,
                230
            ],
            olive: [
                128,
                128,
                0
            ],
            olivedrab: [
                107,
                142,
                35
            ],
            orange: [
                255,
                165,
                0
            ],
            orangered: [
                255,
                69,
                0
            ],
            orchid: [
                218,
                112,
                214
            ],
            palegoldenrod: [
                238,
                232,
                170
            ],
            palegreen: [
                152,
                251,
                152
            ],
            paleturquoise: [
                175,
                238,
                238
            ],
            palevioletred: [
                219,
                112,
                147
            ],
            papayawhip: [
                255,
                239,
                213
            ],
            peachpuff: [
                255,
                218,
                185
            ],
            peru: [
                205,
                133,
                63
            ],
            pink: [
                255,
                192,
                203
            ],
            plum: [
                221,
                160,
                221
            ],
            powderblue: [
                176,
                224,
                230
            ],
            purple: [
                128,
                0,
                128
            ],
            rebeccapurple: [
                102,
                51,
                153
            ],
            red: [
                255,
                0,
                0
            ],
            rosybrown: [
                188,
                143,
                143
            ],
            royalblue: [
                65,
                105,
                225
            ],
            saddlebrown: [
                139,
                69,
                19
            ],
            salmon: [
                250,
                128,
                114
            ],
            sandybrown: [
                244,
                164,
                96
            ],
            seagreen: [
                46,
                139,
                87
            ],
            seashell: [
                255,
                245,
                238
            ],
            sienna: [
                160,
                82,
                45
            ],
            silver: [
                192,
                192,
                192
            ],
            skyblue: [
                135,
                206,
                235
            ],
            slateblue: [
                106,
                90,
                205
            ],
            slategray: [
                112,
                128,
                144
            ],
            slategrey: [
                112,
                128,
                144
            ],
            snow: [
                255,
                250,
                250
            ],
            springgreen: [
                0,
                255,
                127
            ],
            steelblue: [
                70,
                130,
                180
            ],
            tan: [
                210,
                180,
                140
            ],
            teal: [
                0,
                128,
                128
            ],
            thistle: [
                216,
                191,
                216
            ],
            tomato: [
                255,
                99,
                71
            ],
            turquoise: [
                64,
                224,
                208
            ],
            violet: [
                238,
                130,
                238
            ],
            wheat: [
                245,
                222,
                179
            ],
            white: [
                255,
                255,
                255
            ],
            whitesmoke: [
                245,
                245,
                245
            ],
            yellow: [
                255,
                255,
                0
            ],
            yellowgreen: [
                154,
                205,
                50
            ]
        };
        function At(e1, t, r) {
            return e1 + r * (t - e1);
        }
        function Tt(e1, t, r) {
            return e1.map((e1, n)=>At(e1, t[n], r));
        }
        class It {
            constructor(e1, t, r, n = 1, i = !0){
                this.r = e1, this.g = t, this.b = r, this.a = n, i || (this.r *= n, this.g *= n, this.b *= n, n || this.overwriteGetter("rgb", [
                    e1,
                    t,
                    r,
                    n
                ]));
            }
            static parse(e1) {
                if (e1 instanceof It) return e1;
                if ("string" != typeof e1) return;
                const t = function(e1) {
                    if ("transparent" === (e1 = e1.toLowerCase().trim())) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    const t = xt(St, e1);
                    if (t) {
                        const [e1, r, n] = t;
                        return [
                            e1 / 255,
                            r / 255,
                            n / 255,
                            1
                        ];
                    }
                    if (e1.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(e1)) {
                        const t = e1.length < 6 ? 1 : 2;
                        let r = 1;
                        return [
                            vt(e1.slice(r, r += t)),
                            vt(e1.slice(r, r += t)),
                            vt(e1.slice(r, r += t)),
                            vt(e1.slice(r, r + t) || "ff")
                        ];
                    }
                    if (e1.startsWith("rgb")) {
                        const t = e1.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                        if (t) {
                            const [e1, r, n, i, s, o, a, l, u, c, h, p] = t, f = [
                                i || " ",
                                a || " ",
                                c
                            ].join("");
                            if ("  " === f || "  /" === f || ",," === f || ",,," === f) {
                                const e1 = [
                                    n,
                                    o,
                                    u
                                ].join(""), t = "%%%" === e1 ? 100 : "" === e1 ? 255 : 0;
                                if (t) {
                                    const e1 = [
                                        wt(+r / t, 0, 1),
                                        wt(+s / t, 0, 1),
                                        wt(+l / t, 0, 1),
                                        h ? bt(+h, p) : 1
                                    ];
                                    if (_t(e1)) return e1;
                                }
                            }
                            return;
                        }
                    }
                    const r = e1.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                    if (r) {
                        const [e1, t, n, i, s, o, a, l, u] = r, c = [
                            n || " ",
                            s || " ",
                            a
                        ].join("");
                        if ("  " === c || "  /" === c || ",," === c || ",,," === c) {
                            const e1 = [
                                +t,
                                wt(+i, 0, 100),
                                wt(+o, 0, 100),
                                l ? bt(+l, u) : 1
                            ];
                            if (_t(e1)) return function([e1, t, r, n]) {
                                function i(n) {
                                    const i = (n + e1 / 30) % 12, s = t * Math.min(r, 1 - r);
                                    return r - s * Math.max(-1, Math.min(i - 3, 9 - i, 1));
                                }
                                return e1 = ct(e1), t /= 100, r /= 100, [
                                    i(0),
                                    i(8),
                                    i(4),
                                    n
                                ];
                            }(e1);
                        }
                    }
                }(e1);
                return t ? new It(...t, !1) : void 0;
            }
            get rgb() {
                const { r: e1, g: t, b: r, a: n } = this, i = n || 1 / 0;
                return this.overwriteGetter("rgb", [
                    e1 / i,
                    t / i,
                    r / i,
                    n
                ]);
            }
            get hcl() {
                return this.overwriteGetter("hcl", function(e1) {
                    const [t, r, n, i] = ht(e1), s = Math.sqrt(r * r + n * n);
                    return [
                        Math.round(1e4 * s) ? ct(Math.atan2(n, r) * ut) : NaN,
                        s,
                        t,
                        i
                    ];
                }(this.rgb));
            }
            get lab() {
                return this.overwriteGetter("lab", ht(this.rgb));
            }
            overwriteGetter(e1, t) {
                return Object.defineProperty(this, e1, {
                    value: t
                }), t;
            }
            toString() {
                const [e1, t, r, n] = this.rgb;
                return `rgba(${[
                    e1,
                    t,
                    r
                ].map((e1)=>Math.round(255 * e1)).join(",")},${n})`;
            }
            static interpolate(e1, t, r, n = "rgb") {
                switch(n){
                    case "rgb":
                        {
                            const [n, i, s, o] = Tt(e1.rgb, t.rgb, r);
                            return new It(n, i, s, o, !1);
                        }
                    case "hcl":
                        {
                            const [n, i, s, o] = e1.hcl, [a, l, u, c] = t.hcl;
                            let h, p;
                            if (isNaN(n) || isNaN(a)) isNaN(n) ? isNaN(a) ? h = NaN : (h = a, 1 !== s && 0 !== s || (p = l)) : (h = n, 1 !== u && 0 !== u || (p = i));
                            else {
                                let e1 = a - n;
                                a > n && e1 > 180 ? e1 -= 360 : a < n && n - a > 180 && (e1 += 360), h = n + r * e1;
                            }
                            const [f, d, y, m] = function([e1, t, r, n]) {
                                return e1 = isNaN(e1) ? 0 : e1 * lt, dt([
                                    r,
                                    Math.cos(e1) * t,
                                    Math.sin(e1) * t,
                                    n
                                ]);
                            }([
                                h,
                                null != p ? p : At(i, l, r),
                                At(s, u, r),
                                At(o, c, r)
                            ]);
                            return new It(f, d, y, m, !1);
                        }
                    case "lab":
                        {
                            const [n, i, s, o] = dt(Tt(e1.lab, t.lab, r));
                            return new It(n, i, s, o, !1);
                        }
                }
            }
        }
        It.black = new It(0, 0, 0, 1), It.white = new It(1, 1, 1, 1), It.transparent = new It(0, 0, 0, 0), It.red = new It(1, 0, 0, 1);
        class Et {
            constructor(e1, t, r){
                this.sensitivity = e1 ? t ? "variant" : "case" : t ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(e1, t) {
                return this.collator.compare(e1, t);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        const Mt = [
            "bottom",
            "center",
            "top"
        ];
        class kt {
            constructor(e1, t, r, n, i, s){
                this.text = e1, this.image = t, this.scale = r, this.fontStack = n, this.textColor = i, this.verticalAlign = s;
            }
        }
        class Ft {
            constructor(e1){
                this.sections = e1;
            }
            static fromString(e1) {
                return new Ft([
                    new kt(e1, null, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((e1)=>0 !== e1.text.length || e1.image && 0 !== e1.image.name.length);
            }
            static factory(e1) {
                return e1 instanceof Ft ? e1 : Ft.fromString(e1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((e1)=>e1.text).join("");
            }
        }
        class Dt {
            constructor(e1){
                this.values = e1.slice();
            }
            static parse(e1) {
                if (e1 instanceof Dt) return e1;
                if ("number" == typeof e1) return new Dt([
                    e1,
                    e1,
                    e1,
                    e1
                ]);
                if (Array.isArray(e1) && !(e1.length < 1 || e1.length > 4)) {
                    for (const t of e1)if ("number" != typeof t) return;
                    switch(e1.length){
                        case 1:
                            e1 = [
                                e1[0],
                                e1[0],
                                e1[0],
                                e1[0]
                            ];
                            break;
                        case 2:
                            e1 = [
                                e1[0],
                                e1[1],
                                e1[0],
                                e1[1]
                            ];
                            break;
                        case 3:
                            e1 = [
                                e1[0],
                                e1[1],
                                e1[2],
                                e1[1]
                            ];
                    }
                    return new Dt(e1);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
            static interpolate(e1, t, r) {
                return new Dt(Tt(e1.values, t.values, r));
            }
        }
        class Pt {
            constructor(e1){
                this.values = e1.slice();
            }
            static parse(e1) {
                if (e1 instanceof Pt) return e1;
                if ("number" == typeof e1) return new Pt([
                    e1
                ]);
                if (Array.isArray(e1)) {
                    for (const t of e1)if ("number" != typeof t) return;
                    return new Pt(e1);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
            static interpolate(e1, t, r) {
                return new Pt(Tt(e1.values, t.values, r));
            }
        }
        class Bt {
            constructor(e1){
                this.values = e1.slice();
            }
            static parse(e1) {
                if (e1 instanceof Bt) return e1;
                if ("string" == typeof e1) {
                    const t = It.parse(e1);
                    if (!t) return;
                    return new Bt([
                        t
                    ]);
                }
                if (!Array.isArray(e1)) return;
                const t = [];
                for (const r of e1){
                    if ("string" != typeof r) return;
                    const e1 = It.parse(r);
                    if (!e1) return;
                    t.push(e1);
                }
                return new Bt(t);
            }
            toString() {
                return JSON.stringify(this.values);
            }
            static interpolate(e1, t, r, n = "rgb") {
                const i = [];
                if (e1.values.length != t.values.length) throw new Error(`colorArray: Arrays have mismatched length (${e1.values.length} vs. ${t.values.length}), cannot interpolate.`);
                for(let s = 0; s < e1.values.length; s++)i.push(It.interpolate(e1.values[s], t.values[s], r, n));
                return new Bt(i);
            }
        }
        class zt extends Error {
            constructor(e1){
                super(e1), this.name = "RuntimeError";
            }
            toJSON() {
                return this.message;
            }
        }
        const Vt = new Set([
            "center",
            "left",
            "right",
            "top",
            "bottom",
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ]);
        class Ct {
            constructor(e1){
                this.values = e1.slice();
            }
            static parse(e1) {
                if (e1 instanceof Ct) return e1;
                if (Array.isArray(e1) && !(e1.length < 1) && e1.length % 2 == 0) {
                    for(let t = 0; t < e1.length; t += 2){
                        const r = e1[t], n = e1[t + 1];
                        if ("string" != typeof r || !Vt.has(r)) return;
                        if (!Array.isArray(n) || 2 !== n.length || "number" != typeof n[0] || "number" != typeof n[1]) return;
                    }
                    return new Ct(e1);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
            static interpolate(e1, t, r) {
                const n = e1.values, i = t.values;
                if (n.length !== i.length) throw new zt(`Cannot interpolate values of different length. from: ${e1.toString()}, to: ${t.toString()}`);
                const s = [];
                for(let e1 = 0; e1 < n.length; e1 += 2){
                    if (n[e1] !== i[e1]) throw new zt(`Cannot interpolate values containing mismatched anchors. from[${e1}]: ${n[e1]}, to[${e1}]: ${i[e1]}`);
                    s.push(n[e1]);
                    const [t, o] = n[e1 + 1], [a, l] = i[e1 + 1];
                    s.push([
                        At(t, a, r),
                        At(o, l, r)
                    ]);
                }
                return new Ct(s);
            }
        }
        class Lt {
            constructor(e1){
                this.name = e1.name, this.available = e1.available;
            }
            toString() {
                return this.name;
            }
            static fromString(e1) {
                return e1 ? new Lt({
                    name: e1,
                    available: !1
                }) : null;
            }
        }
        class Ot {
            constructor(e1, t, r){
                this.from = e1, this.to = t, this.transition = r;
            }
            static interpolate(e1, t, r) {
                return new Ot(e1, t, r);
            }
            static parse(e1) {
                return e1 instanceof Ot ? e1 : Array.isArray(e1) && 3 === e1.length && "string" == typeof e1[0] && "string" == typeof e1[1] && "number" == typeof e1[2] ? new Ot(e1[0], e1[1], e1[2]) : "object" == typeof e1 && "string" == typeof e1.from && "string" == typeof e1.to && "number" == typeof e1.transition ? new Ot(e1.from, e1.to, e1.transition) : "string" == typeof e1 ? new Ot(e1, e1, 1) : void 0;
            }
        }
        function Rt(e1, t, r, n) {
            return "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                e1,
                t,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                e1,
                t,
                r,
                n
            ] : [
                e1,
                t,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function Nt(e1) {
            if (null === e1 || "string" == typeof e1 || "boolean" == typeof e1 || "number" == typeof e1 || e1 instanceof Ot || e1 instanceof It || e1 instanceof Et || e1 instanceof Ft || e1 instanceof Dt || e1 instanceof Pt || e1 instanceof Bt || e1 instanceof Ct || e1 instanceof Lt) return !0;
            if (Array.isArray(e1)) {
                for (const t of e1)if (!Nt(t)) return !1;
                return !0;
            }
            if ("object" == typeof e1) {
                for(const t in e1)if (!Nt(e1[t])) return !1;
                return !0;
            }
            return !1;
        }
        function $t(e1) {
            if (null === e1) return ze;
            if ("string" == typeof e1) return Ce;
            if ("boolean" == typeof e1) return Le;
            if ("number" == typeof e1) return Ve;
            if (e1 instanceof It) return Oe;
            if (e1 instanceof Ot) return Re;
            if (e1 instanceof Et) return Ue;
            if (e1 instanceof Ft) return qe;
            if (e1 instanceof Dt) return je;
            if (e1 instanceof Pt) return Xe;
            if (e1 instanceof Bt) return Ge;
            if (e1 instanceof Ct) return Ze;
            if (e1 instanceof Lt) return Ye;
            if (Array.isArray(e1)) {
                const t = e1.length;
                let r;
                for (const t of e1){
                    const e1 = $t(t);
                    if (r) {
                        if (r === e1) continue;
                        r = $e;
                        break;
                    }
                    r = e1;
                }
                return He(r || $e, t);
            }
            return Ne;
        }
        function Ut(e1) {
            const t = typeof e1;
            return null === e1 ? "" : "string" === t || "number" === t || "boolean" === t ? String(e1) : e1 instanceof It || e1 instanceof Ot || e1 instanceof Ft || e1 instanceof Dt || e1 instanceof Pt || e1 instanceof Bt || e1 instanceof Ct || e1 instanceof Lt ? e1.toString() : JSON.stringify(e1);
        }
        class qt {
            constructor(e1, t){
                this.type = e1, this.value = t;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`'literal' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (!Nt(e1[1])) return t.error("invalid value");
                const r = e1[1];
                let n = $t(r);
                const i = t.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new qt(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        const jt = {
            string: Ce,
            number: Ve,
            boolean: Le,
            object: Ne
        };
        class Gt {
            constructor(e1, t){
                this.type = e1, this.args = t;
            }
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected at least one argument.");
                let r, n = 1;
                const i = e1[0];
                if ("array" === i) {
                    let i, s;
                    if (e1.length > 2) {
                        const r = e1[1];
                        if ("string" != typeof r || !(r in jt) || "object" === r) return t.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = jt[r], n++;
                    } else i = $e;
                    if (e1.length > 3) {
                        if (null !== e1[2] && ("number" != typeof e1[2] || e1[2] < 0 || e1[2] !== Math.floor(e1[2]))) return t.error('The length argument to "array" must be a positive integer literal', 2);
                        s = e1[2], n++;
                    }
                    r = He(i, s);
                } else {
                    if (!jt[i]) throw new Error(`Types doesn't contain name = ${i}`);
                    r = jt[i];
                }
                const s = [];
                for(; n < e1.length; n++){
                    const r = t.parse(e1[n], n, $e);
                    if (!r) return null;
                    s.push(r);
                }
                return new Gt(r, s);
            }
            evaluate(e1) {
                for(let t = 0; t < this.args.length; t++){
                    const r = this.args[t].evaluate(e1);
                    if (!Je(this.type, $t(r))) return r;
                    if (t === this.args.length - 1) throw new zt(`Expected value to be of type ${Ke(this.type)}, but found ${Ke($t(r))} instead.`);
                }
                throw new Error;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
        }
        const Xt = {
            "to-boolean": Le,
            "to-color": Oe,
            "to-number": Ve,
            "to-string": Ce
        };
        class Yt {
            constructor(e1, t){
                this.type = e1, this.args = t;
            }
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected at least one argument.");
                const r = e1[0];
                if (!Xt[r]) throw new Error(`Can't parse ${r} as it is not part of the known types`);
                if (("to-boolean" === r || "to-string" === r) && 2 !== e1.length) return t.error("Expected one argument.");
                const n = Xt[r], i = [];
                for(let r = 1; r < e1.length; r++){
                    const n = t.parse(e1[r], r, $e);
                    if (!n) return null;
                    i.push(n);
                }
                return new Yt(n, i);
            }
            evaluate(e1) {
                switch(this.type.kind){
                    case "boolean":
                        return Boolean(this.args[0].evaluate(e1));
                    case "color":
                        {
                            let t, r;
                            for (const n of this.args){
                                if (t = n.evaluate(e1), r = null, t instanceof It) return t;
                                if ("string" == typeof t) {
                                    const r = e1.parseColor(t);
                                    if (r) return r;
                                } else if (Array.isArray(t) && (r = t.length < 3 || t.length > 4 ? `Invalid rgba value ${JSON.stringify(t)}: expected an array containing either three or four numeric values.` : Rt(t[0], t[1], t[2], t[3]), !r)) return new It(t[0] / 255, t[1] / 255, t[2] / 255, t[3]);
                            }
                            throw new zt(r || `Could not parse color from value '${"string" == typeof t ? t : JSON.stringify(t)}'`);
                        }
                    case "padding":
                        {
                            let t;
                            for (const r of this.args){
                                t = r.evaluate(e1);
                                const n = Dt.parse(t);
                                if (n) return n;
                            }
                            throw new zt(`Could not parse padding from value '${"string" == typeof t ? t : JSON.stringify(t)}'`);
                        }
                    case "numberArray":
                        {
                            let t;
                            for (const r of this.args){
                                t = r.evaluate(e1);
                                const n = Pt.parse(t);
                                if (n) return n;
                            }
                            throw new zt(`Could not parse numberArray from value '${"string" == typeof t ? t : JSON.stringify(t)}'`);
                        }
                    case "colorArray":
                        {
                            let t;
                            for (const r of this.args){
                                t = r.evaluate(e1);
                                const n = Bt.parse(t);
                                if (n) return n;
                            }
                            throw new zt(`Could not parse colorArray from value '${"string" == typeof t ? t : JSON.stringify(t)}'`);
                        }
                    case "variableAnchorOffsetCollection":
                        {
                            let t;
                            for (const r of this.args){
                                t = r.evaluate(e1);
                                const n = Ct.parse(t);
                                if (n) return n;
                            }
                            throw new zt(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof t ? t : JSON.stringify(t)}'`);
                        }
                    case "number":
                        {
                            let t = null;
                            for (const r of this.args){
                                if (t = r.evaluate(e1), null === t) return 0;
                                const n = Number(t);
                                if (!isNaN(n)) return n;
                            }
                            throw new zt(`Could not convert ${JSON.stringify(t)} to number.`);
                        }
                    case "formatted":
                        return Ft.fromString(Ut(this.args[0].evaluate(e1)));
                    case "resolvedImage":
                        return Lt.fromString(Ut(this.args[0].evaluate(e1)));
                    case "projectionDefinition":
                        return this.args[0].evaluate(e1);
                    default:
                        return Ut(this.args[0].evaluate(e1));
                }
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
        }
        const Zt = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class Ht {
            constructor(){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = new Map, this.availableImages = null, this.canonical = null;
            }
            id() {
                return this.feature && "id" in this.feature ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? Zt[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            parseColor(e1) {
                let t = this._parseColorCache.get(e1);
                return t || (t = It.parse(e1), this._parseColorCache.set(e1, t)), t;
            }
        }
        class Kt {
            constructor(e1, t, r = [], n, i = new Be, s = []){
                this.registry = e1, this.path = r, this.key = r.map((e1)=>`[${e1}]`).join(""), this.scope = i, this.errors = s, this.expectedType = n, this._isConstant = t;
            }
            parse(e1, t, r, n, i = {}) {
                return t ? this.concat(t, r, n)._parse(e1, i) : this._parse(e1, i);
            }
            _parse(e1, t) {
                function r(e1, t, r) {
                    return "assert" === r ? new Gt(t, [
                        e1
                    ]) : "coerce" === r ? new Yt(t, [
                        e1
                    ]) : e1;
                }
                if (null !== e1 && "string" != typeof e1 && "boolean" != typeof e1 && "number" != typeof e1 || (e1 = [
                    "literal",
                    e1
                ]), Array.isArray(e1)) {
                    if (0 === e1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = e1[0];
                    if ("string" != typeof n) return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                    const i = this.registry[n];
                    if (i) {
                        let n = i.parse(e1, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const e1 = this.expectedType, i = n.type;
                            if ("string" !== e1.kind && "number" !== e1.kind && "boolean" !== e1.kind && "object" !== e1.kind && "array" !== e1.kind || "value" !== i.kind) {
                                if ("projectionDefinition" === e1.kind && [
                                    "string",
                                    "array"
                                ].includes(i.kind) || [
                                    "color",
                                    "formatted",
                                    "resolvedImage"
                                ].includes(e1.kind) && [
                                    "value",
                                    "string"
                                ].includes(i.kind) || [
                                    "padding",
                                    "numberArray"
                                ].includes(e1.kind) && [
                                    "value",
                                    "number",
                                    "array"
                                ].includes(i.kind) || "colorArray" === e1.kind && [
                                    "value",
                                    "string",
                                    "array"
                                ].includes(i.kind) || "variableAnchorOffsetCollection" === e1.kind && [
                                    "value",
                                    "array"
                                ].includes(i.kind)) n = r(n, e1, t.typeAnnotation || "coerce");
                                else if (this.checkSubtype(e1, i)) return null;
                            } else n = r(n, e1, t.typeAnnotation || "assert");
                        }
                        if (!(n instanceof qt) && "resolvedImage" !== n.type.kind && this._isConstant(n)) {
                            const e1 = new Ht;
                            try {
                                n = new qt(n.type, n.evaluate(e1));
                            } catch (e1) {
                                return this.error(e1.message), null;
                            }
                        }
                        return n;
                    }
                    return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
                }
                return this.error(void 0 === e1 ? "'undefined' value invalid. Use null instead." : "object" == typeof e1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof e1} instead.`);
            }
            concat(e1, t, r) {
                const n = "number" == typeof e1 ? this.path.concat(e1) : this.path, i = r ? this.scope.concat(r) : this.scope;
                return new Kt(this.registry, this._isConstant, n, t || null, i, this.errors);
            }
            error(e1, ...t) {
                const r = `${this.key}${t.map((e1)=>`[${e1}]`).join("")}`;
                this.errors.push(new Pe(r, e1));
            }
            checkSubtype(e1, t) {
                const r = Je(e1, t);
                return r && this.error(r), r;
            }
        }
        class Wt {
            constructor(e1, t){
                this.type = t.type, this.bindings = [].concat(e1), this.result = t;
            }
            evaluate(e1) {
                return this.result.evaluate(e1);
            }
            eachChild(e1) {
                for (const t of this.bindings)e1(t[1]);
                e1(this.result);
            }
            static parse(e1, t) {
                if (e1.length < 4) return t.error(`Expected at least 3 arguments, but found ${e1.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < e1.length - 1; n += 2){
                    const i = e1[n];
                    if ("string" != typeof i) return t.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return t.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const s = t.parse(e1[n + 1], n + 1);
                    if (!s) return null;
                    r.push([
                        i,
                        s
                    ]);
                }
                const n = t.parse(e1[e1.length - 1], e1.length - 1, t.expectedType, r);
                return n ? new Wt(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
        }
        class Jt {
            constructor(e1, t){
                this.type = t.type, this.name = e1, this.boundExpression = t;
            }
            static parse(e1, t) {
                if (2 !== e1.length || "string" != typeof e1[1]) return t.error("'var' expression requires exactly one string literal argument.");
                const r = e1[1];
                return t.scope.has(r) ? new Jt(r, t.scope.get(r)) : t.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(e1) {
                return this.boundExpression.evaluate(e1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
        }
        class Qt {
            constructor(e1, t, r){
                this.type = e1, this.index = t, this.input = r;
            }
            static parse(e1, t) {
                if (3 !== e1.length) return t.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const r = t.parse(e1[1], 1, Ve), n = t.parse(e1[2], 2, He(t.expectedType || $e));
                return r && n ? new Qt(n.type.itemType, r, n) : null;
            }
            evaluate(e1) {
                const t = this.index.evaluate(e1), r = this.input.evaluate(e1);
                if (t < 0) throw new zt(`Array index out of bounds: ${t} < 0.`);
                if (t >= r.length) throw new zt(`Array index out of bounds: ${t} > ${r.length - 1}.`);
                if (t !== Math.floor(t)) throw new zt(`Array index must be an integer, but found ${t} instead.`);
                return r[t];
            }
            eachChild(e1) {
                e1(this.index), e1(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class er {
            constructor(e1, t){
                this.type = Le, this.needle = e1, this.haystack = t;
            }
            static parse(e1, t) {
                if (3 !== e1.length) return t.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const r = t.parse(e1[1], 1, $e), n = t.parse(e1[2], 2, $e);
                return r && n ? Qe(r.type, [
                    Le,
                    Ce,
                    Ve,
                    ze,
                    $e
                ]) ? new er(r, n) : t.error(`Expected first argument to be of type boolean, string, number or null, but found ${Ke(r.type)} instead`) : null;
            }
            evaluate(e1) {
                const t = this.needle.evaluate(e1), r = this.haystack.evaluate(e1);
                if (!r) return !1;
                if (!et(t, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new zt(`Expected first argument to be of type boolean, string, number or null, but found ${Ke($t(t))} instead.`);
                if (!et(r, [
                    "string",
                    "array"
                ])) throw new zt(`Expected second argument to be of type array or string, but found ${Ke($t(r))} instead.`);
                return r.indexOf(t) >= 0;
            }
            eachChild(e1) {
                e1(this.needle), e1(this.haystack);
            }
            outputDefined() {
                return !0;
            }
        }
        class tr {
            constructor(e1, t, r){
                this.type = Ve, this.needle = e1, this.haystack = t, this.fromIndex = r;
            }
            static parse(e1, t) {
                if (e1.length <= 2 || e1.length >= 5) return t.error(`Expected 2 or 3 arguments, but found ${e1.length - 1} instead.`);
                const r = t.parse(e1[1], 1, $e), n = t.parse(e1[2], 2, $e);
                if (!r || !n) return null;
                if (!Qe(r.type, [
                    Le,
                    Ce,
                    Ve,
                    ze,
                    $e
                ])) return t.error(`Expected first argument to be of type boolean, string, number or null, but found ${Ke(r.type)} instead`);
                if (4 === e1.length) {
                    const i = t.parse(e1[3], 3, Ve);
                    return i ? new tr(r, n, i) : null;
                }
                return new tr(r, n);
            }
            evaluate(e1) {
                const t = this.needle.evaluate(e1), r = this.haystack.evaluate(e1);
                if (!et(t, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new zt(`Expected first argument to be of type boolean, string, number or null, but found ${Ke($t(t))} instead.`);
                let n;
                if (this.fromIndex && (n = this.fromIndex.evaluate(e1)), et(r, [
                    "string"
                ])) {
                    const e1 = r.indexOf(t, n);
                    return -1 === e1 ? -1 : [
                        ...r.slice(0, e1)
                    ].length;
                }
                if (et(r, [
                    "array"
                ])) return r.indexOf(t, n);
                throw new zt(`Expected second argument to be of type array or string, but found ${Ke($t(r))} instead.`);
            }
            eachChild(e1) {
                e1(this.needle), e1(this.haystack), this.fromIndex && e1(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        class rr {
            constructor(e1, t, r, n, i, s){
                this.inputType = e1, this.type = t, this.input = r, this.cases = n, this.outputs = i, this.otherwise = s;
            }
            static parse(e1, t) {
                if (e1.length < 5) return t.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if (e1.length % 2 != 1) return t.error("Expected an even number of arguments.");
                let r, n;
                t.expectedType && "value" !== t.expectedType.kind && (n = t.expectedType);
                const i = {}, s = [];
                for(let o = 2; o < e1.length - 1; o += 2){
                    let a = e1[o];
                    const l = e1[o + 1];
                    Array.isArray(a) || (a = [
                        a
                    ]);
                    const u = t.concat(o);
                    if (0 === a.length) return u.error("Expected at least one branch label.");
                    for (const e1 of a){
                        if ("number" != typeof e1 && "string" != typeof e1) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof e1 && Math.abs(e1) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof e1 && Math.floor(e1) !== e1) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, $t(e1))) return null;
                        } else r = $t(e1);
                        if (void 0 !== i[String(e1)]) return u.error("Branch labels must be unique.");
                        i[String(e1)] = s.length;
                    }
                    const c = t.parse(l, o, n);
                    if (!c) return null;
                    n = n || c.type, s.push(c);
                }
                const o = t.parse(e1[1], 1, $e);
                if (!o) return null;
                const a = t.parse(e1[e1.length - 1], e1.length - 1, n);
                return a ? "value" !== o.type.kind && t.concat(1).checkSubtype(r, o.type) ? null : new rr(r, n, o, i, s, a) : null;
            }
            evaluate(e1) {
                const t = this.input.evaluate(e1);
                return ($t(t) === this.inputType && this.outputs[this.cases[t]] || this.otherwise).evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input), this.outputs.forEach(e1), e1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class nr {
            constructor(e1, t, r){
                this.type = e1, this.branches = t, this.otherwise = r;
            }
            static parse(e1, t) {
                if (e1.length < 4) return t.error(`Expected at least 3 arguments, but found only ${e1.length - 1}.`);
                if (e1.length % 2 != 0) return t.error("Expected an odd number of arguments.");
                let r;
                t.expectedType && "value" !== t.expectedType.kind && (r = t.expectedType);
                const n = [];
                for(let i = 1; i < e1.length - 1; i += 2){
                    const s = t.parse(e1[i], i, Le);
                    if (!s) return null;
                    const o = t.parse(e1[i + 1], i + 1, r);
                    if (!o) return null;
                    n.push([
                        s,
                        o
                    ]), r = r || o.type;
                }
                const i = t.parse(e1[e1.length - 1], e1.length - 1, r);
                if (!i) return null;
                if (!r) throw new Error("Can't infer output type");
                return new nr(r, n, i);
            }
            evaluate(e1) {
                for (const [t, r] of this.branches)if (t.evaluate(e1)) return r.evaluate(e1);
                return this.otherwise.evaluate(e1);
            }
            eachChild(e1) {
                for (const [t, r] of this.branches)e1(t), e1(r);
                e1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([e1, t])=>t.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class ir {
            constructor(e1, t, r, n){
                this.type = e1, this.input = t, this.beginIndex = r, this.endIndex = n;
            }
            static parse(e1, t) {
                if (e1.length <= 2 || e1.length >= 5) return t.error(`Expected 2 or 3 arguments, but found ${e1.length - 1} instead.`);
                const r = t.parse(e1[1], 1, $e), n = t.parse(e1[2], 2, Ve);
                if (!r || !n) return null;
                if (!Qe(r.type, [
                    He($e),
                    Ce,
                    $e
                ])) return t.error(`Expected first argument to be of type array or string, but found ${Ke(r.type)} instead`);
                if (4 === e1.length) {
                    const i = t.parse(e1[3], 3, Ve);
                    return i ? new ir(r.type, r, n, i) : null;
                }
                return new ir(r.type, r, n);
            }
            evaluate(e1) {
                const t = this.input.evaluate(e1), r = this.beginIndex.evaluate(e1);
                let n;
                if (this.endIndex && (n = this.endIndex.evaluate(e1)), et(t, [
                    "string"
                ])) return [
                    ...t
                ].slice(r, n).join("");
                if (et(t, [
                    "array"
                ])) return t.slice(r, n);
                throw new zt(`Expected first argument to be of type array or string, but found ${Ke($t(t))} instead.`);
            }
            eachChild(e1) {
                e1(this.input), e1(this.beginIndex), this.endIndex && e1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        function sr(e1, t) {
            const r = e1.length - 1;
            let n, i, s = 0, o = r, a = 0;
            for(; s <= o;)if (a = Math.floor((s + o) / 2), n = e1[a], i = e1[a + 1], n <= t) {
                if (a === r || t < i) return a;
                s = a + 1;
            } else {
                if (!(n > t)) throw new zt("Input is not a number.");
                o = a - 1;
            }
            return 0;
        }
        class or {
            constructor(e1, t, r){
                this.type = e1, this.input = t, this.labels = [], this.outputs = [];
                for (const [e1, t] of r)this.labels.push(e1), this.outputs.push(t);
            }
            static parse(e1, t) {
                if (e1.length - 1 < 4) return t.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if ((e1.length - 1) % 2 != 0) return t.error("Expected an even number of arguments.");
                const r = t.parse(e1[1], 1, Ve);
                if (!r) return null;
                const n = [];
                let i = null;
                t.expectedType && "value" !== t.expectedType.kind && (i = t.expectedType);
                for(let r = 1; r < e1.length; r += 2){
                    const s = 1 === r ? -1 / 0 : e1[r], o = e1[r + 1], a = r, l = r + 1;
                    if ("number" != typeof s) return t.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', a);
                    if (n.length && n[n.length - 1][0] >= s) return t.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', a);
                    const u = t.parse(o, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        s,
                        u
                    ]);
                }
                return new or(i, r, n);
            }
            evaluate(e1) {
                const t = this.labels, r = this.outputs;
                if (1 === t.length) return r[0].evaluate(e1);
                const n = this.input.evaluate(e1);
                if (n <= t[0]) return r[0].evaluate(e1);
                const i = t.length;
                return n >= t[i - 1] ? r[i - 1].evaluate(e1) : r[sr(t, n)].evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input);
                for (const t of this.outputs)e1(t);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
        }
        function ar(e1) {
            return e1 && e1.__esModule && Object.prototype.hasOwnProperty.call(e1, "default") ? e1.default : e1;
        }
        var lr, ur, cr = function() {
            if (ur) return lr;
            function e1(e1, t, r, n) {
                this.cx = 3 * e1, this.bx = 3 * (r - e1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * t, this.by = 3 * (n - t) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = e1, this.p1y = t, this.p2x = r, this.p2y = n;
            }
            return ur = 1, lr = e1, e1.prototype = {
                sampleCurveX: function(e1) {
                    return ((this.ax * e1 + this.bx) * e1 + this.cx) * e1;
                },
                sampleCurveY: function(e1) {
                    return ((this.ay * e1 + this.by) * e1 + this.cy) * e1;
                },
                sampleCurveDerivativeX: function(e1) {
                    return (3 * this.ax * e1 + 2 * this.bx) * e1 + this.cx;
                },
                solveCurveX: function(e1, t) {
                    if (void 0 === t && (t = 1e-6), e1 < 0) return 0;
                    if (e1 > 1) return 1;
                    for(var r = e1, n = 0; n < 8; n++){
                        var i = this.sampleCurveX(r) - e1;
                        if (Math.abs(i) < t) return r;
                        var s = this.sampleCurveDerivativeX(r);
                        if (Math.abs(s) < 1e-6) break;
                        r -= i / s;
                    }
                    var o = 0, a = 1;
                    for(r = e1, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - e1) < t)); n++)e1 > i ? o = r : a = r, r = .5 * (a - o) + o;
                    return r;
                },
                solve: function(e1, t) {
                    return this.sampleCurveY(this.solveCurveX(e1, t));
                }
            }, lr;
        }(), hr = ar(cr);
        class pr {
            constructor(e1, t, r, n, i){
                this.type = e1, this.operator = t, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [e1, t] of i)this.labels.push(e1), this.outputs.push(t);
            }
            static interpolationFactor(e1, t, r, n) {
                let i = 0;
                if ("exponential" === e1.name) i = fr(t, e1.base, r, n);
                else if ("linear" === e1.name) i = fr(t, 1, r, n);
                else if ("cubic-bezier" === e1.name) {
                    const s = e1.controlPoints;
                    i = new hr(s[0], s[1], s[2], s[3]).solve(fr(t, 1, r, n));
                }
                return i;
            }
            static parse(e1, t) {
                let [r, n, i, ...s] = e1;
                if (!Array.isArray(n) || 0 === n.length) return t.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const e1 = n[1];
                    if ("number" != typeof e1) return t.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: e1
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return t.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const e1 = n.slice(1);
                        if (4 !== e1.length || e1.some((e1)=>"number" != typeof e1 || e1 < 0 || e1 > 1)) return t.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: e1
                        };
                    }
                }
                if (e1.length - 1 < 4) return t.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if ((e1.length - 1) % 2 != 0) return t.error("Expected an even number of arguments.");
                if (i = t.parse(i, 2, Ve), !i) return null;
                const o = [];
                let a = null;
                "interpolate-hcl" !== r && "interpolate-lab" !== r || t.expectedType == Ge ? t.expectedType && "value" !== t.expectedType.kind && (a = t.expectedType) : a = Oe;
                for(let e1 = 0; e1 < s.length; e1 += 2){
                    const r = s[e1], n = s[e1 + 1], i = e1 + 3, l = e1 + 4;
                    if ("number" != typeof r) return t.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (o.length && o[o.length - 1][0] >= r) return t.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = t.parse(n, l, a);
                    if (!u) return null;
                    a = a || u.type, o.push([
                        r,
                        u
                    ]);
                }
                return tt(a, Ve) || tt(a, Re) || tt(a, Oe) || tt(a, je) || tt(a, Xe) || tt(a, Ge) || tt(a, Ze) || tt(a, He(Ve)) ? new pr(a, r, n, i, o) : t.error(`Type ${Ke(a)} is not interpolatable.`);
            }
            evaluate(e1) {
                const t = this.labels, r = this.outputs;
                if (1 === t.length) return r[0].evaluate(e1);
                const n = this.input.evaluate(e1);
                if (n <= t[0]) return r[0].evaluate(e1);
                const i = t.length;
                if (n >= t[i - 1]) return r[i - 1].evaluate(e1);
                const s = sr(t, n), o = pr.interpolationFactor(this.interpolation, n, t[s], t[s + 1]), a = r[s].evaluate(e1), l = r[s + 1].evaluate(e1);
                switch(this.operator){
                    case "interpolate":
                        switch(this.type.kind){
                            case "number":
                                return At(a, l, o);
                            case "color":
                                return It.interpolate(a, l, o);
                            case "padding":
                                return Dt.interpolate(a, l, o);
                            case "colorArray":
                                return Bt.interpolate(a, l, o);
                            case "numberArray":
                                return Pt.interpolate(a, l, o);
                            case "variableAnchorOffsetCollection":
                                return Ct.interpolate(a, l, o);
                            case "array":
                                return Tt(a, l, o);
                            case "projectionDefinition":
                                return Ot.interpolate(a, l, o);
                        }
                    case "interpolate-hcl":
                        switch(this.type.kind){
                            case "color":
                                return It.interpolate(a, l, o, "hcl");
                            case "colorArray":
                                return Bt.interpolate(a, l, o, "hcl");
                        }
                    case "interpolate-lab":
                        switch(this.type.kind){
                            case "color":
                                return It.interpolate(a, l, o, "lab");
                            case "colorArray":
                                return Bt.interpolate(a, l, o, "lab");
                        }
                }
            }
            eachChild(e1) {
                e1(this.input);
                for (const t of this.outputs)e1(t);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
        }
        function fr(e1, t, r, n) {
            const i = n - r, s = e1 - r;
            return 0 === i ? 0 : 1 === t ? s / i : (Math.pow(t, s) - 1) / (Math.pow(t, i) - 1);
        }
        const dr = {
            color: It.interpolate,
            number: At,
            padding: Dt.interpolate,
            numberArray: Pt.interpolate,
            colorArray: Bt.interpolate,
            variableAnchorOffsetCollection: Ct.interpolate,
            array: Tt
        };
        class yr {
            constructor(e1, t){
                this.type = e1, this.args = t;
            }
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected at least one argument.");
                let r = null;
                const n = t.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of e1.slice(1)){
                    const e1 = t.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!e1) return null;
                    r = r || e1.type, i.push(e1);
                }
                if (!r) throw new Error("No output type");
                const s = n && i.some((e1)=>Je(n, e1.type));
                return new yr(s ? $e : r, i);
            }
            evaluate(e1) {
                let t, r = null, n = 0;
                for (const i of this.args)if (n++, r = i.evaluate(e1), r && r instanceof Lt && !r.available && (t || (t = r.name), r = null, n === this.args.length && (r = t)), null !== r) break;
                return r;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
        }
        function mr(e1, t) {
            return "==" === e1 || "!=" === e1 ? "boolean" === t.kind || "string" === t.kind || "number" === t.kind || "null" === t.kind || "value" === t.kind : "string" === t.kind || "number" === t.kind || "value" === t.kind;
        }
        function gr(e1, t, r, n) {
            return 0 === n.compare(t, r);
        }
        function xr(e1, t, r) {
            const n = "==" !== e1 && "!=" !== e1;
            return class i {
                constructor(e1, t, r){
                    this.type = Le, this.lhs = e1, this.rhs = t, this.collator = r, this.hasUntypedArgument = "value" === e1.type.kind || "value" === t.type.kind;
                }
                static parse(e1, t) {
                    if (3 !== e1.length && 4 !== e1.length) return t.error("Expected two or three arguments.");
                    const r = e1[0];
                    let s = t.parse(e1[1], 1, $e);
                    if (!s) return null;
                    if (!mr(r, s.type)) return t.concat(1).error(`"${r}" comparisons are not supported for type '${Ke(s.type)}'.`);
                    let o = t.parse(e1[2], 2, $e);
                    if (!o) return null;
                    if (!mr(r, o.type)) return t.concat(2).error(`"${r}" comparisons are not supported for type '${Ke(o.type)}'.`);
                    if (s.type.kind !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return t.error(`Cannot compare types '${Ke(s.type)}' and '${Ke(o.type)}'.`);
                    n && ("value" === s.type.kind && "value" !== o.type.kind ? s = new Gt(o.type, [
                        s
                    ]) : "value" !== s.type.kind && "value" === o.type.kind && (o = new Gt(s.type, [
                        o
                    ])));
                    let a = null;
                    if (4 === e1.length) {
                        if ("string" !== s.type.kind && "string" !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return t.error("Cannot use collator to compare non-string types.");
                        if (a = t.parse(e1[3], 3, Ue), !a) return null;
                    }
                    return new i(s, o, a);
                }
                evaluate(i) {
                    const s = this.lhs.evaluate(i), o = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const t = $t(s), r = $t(o);
                        if (t.kind !== r.kind || "string" !== t.kind && "number" !== t.kind) throw new zt(`Expected arguments for "${e1}" to be (string, string) or (number, number), but found (${t.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const e1 = $t(s), r = $t(o);
                        if ("string" !== e1.kind || "string" !== r.kind) return t(i, s, o);
                    }
                    return this.collator ? r(i, s, o, this.collator.evaluate(i)) : t(i, s, o);
                }
                eachChild(e1) {
                    e1(this.lhs), e1(this.rhs), this.collator && e1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
            };
        }
        const vr = xr("==", function(e1, t, r) {
            return t === r;
        }, gr), br = xr("!=", function(e1, t, r) {
            return t !== r;
        }, function(e1, t, r, n) {
            return !gr(0, t, r, n);
        }), wr = xr("<", function(e1, t, r) {
            return t < r;
        }, function(e1, t, r, n) {
            return n.compare(t, r) < 0;
        }), _r = xr(">", function(e1, t, r) {
            return t > r;
        }, function(e1, t, r, n) {
            return n.compare(t, r) > 0;
        }), Sr = xr("<=", function(e1, t, r) {
            return t <= r;
        }, function(e1, t, r, n) {
            return n.compare(t, r) <= 0;
        }), Ar = xr(">=", function(e1, t, r) {
            return t >= r;
        }, function(e1, t, r, n) {
            return n.compare(t, r) >= 0;
        });
        class Tr {
            constructor(e1, t, r){
                this.type = Ue, this.locale = r, this.caseSensitive = e1, this.diacriticSensitive = t;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error("Expected one argument.");
                const r = e1[1];
                if ("object" != typeof r || Array.isArray(r)) return t.error("Collator options argument must be an object.");
                const n = t.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, Le);
                if (!n) return null;
                const i = t.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, Le);
                if (!i) return null;
                let s = null;
                return r.locale && (s = t.parse(r.locale, 1, Ce), !s) ? null : new Tr(n, i, s);
            }
            evaluate(e1) {
                return new Et(this.caseSensitive.evaluate(e1), this.diacriticSensitive.evaluate(e1), this.locale ? this.locale.evaluate(e1) : null);
            }
            eachChild(e1) {
                e1(this.caseSensitive), e1(this.diacriticSensitive), this.locale && e1(this.locale);
            }
            outputDefined() {
                return !1;
            }
        }
        class Ir {
            constructor(e1, t, r, n, i){
                this.type = Ce, this.number = e1, this.locale = t, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
            }
            static parse(e1, t) {
                if (3 !== e1.length) return t.error("Expected two arguments.");
                const r = t.parse(e1[1], 1, Ve);
                if (!r) return null;
                const n = e1[2];
                if ("object" != typeof n || Array.isArray(n)) return t.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = t.parse(n.locale, 1, Ce), !i)) return null;
                let s = null;
                if (n.currency && (s = t.parse(n.currency, 1, Ce), !s)) return null;
                let o = null;
                if (n["min-fraction-digits"] && (o = t.parse(n["min-fraction-digits"], 1, Ve), !o)) return null;
                let a = null;
                return n["max-fraction-digits"] && (a = t.parse(n["max-fraction-digits"], 1, Ve), !a) ? null : new Ir(r, i, s, o, a);
            }
            evaluate(e1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e1) : [], {
                    style: this.currency ? "currency" : "decimal",
                    currency: this.currency ? this.currency.evaluate(e1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e1) : void 0
                }).format(this.number.evaluate(e1));
            }
            eachChild(e1) {
                e1(this.number), this.locale && e1(this.locale), this.currency && e1(this.currency), this.minFractionDigits && e1(this.minFractionDigits), this.maxFractionDigits && e1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
        }
        class Er {
            constructor(e1){
                this.type = qe, this.sections = e1;
            }
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected at least one argument.");
                const r = e1[1];
                if (!Array.isArray(r) && "object" == typeof r) return t.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= e1.length - 1; ++r){
                    const s = e1[r];
                    if (i && "object" == typeof s && !Array.isArray(s)) {
                        i = !1;
                        let e1 = null;
                        if (s["font-scale"] && (e1 = t.parse(s["font-scale"], 1, Ve), !e1)) return null;
                        let r = null;
                        if (s["text-font"] && (r = t.parse(s["text-font"], 1, He(Ce)), !r)) return null;
                        let o = null;
                        if (s["text-color"] && (o = t.parse(s["text-color"], 1, Oe), !o)) return null;
                        let a = null;
                        if (s["vertical-align"]) {
                            if ("string" == typeof s["vertical-align"] && !Mt.includes(s["vertical-align"])) return t.error(`'vertical-align' must be one of: 'bottom', 'center', 'top' but found '${s["vertical-align"]}' instead.`);
                            if (a = t.parse(s["vertical-align"], 1, Ce), !a) return null;
                        }
                        const l = n[n.length - 1];
                        l.scale = e1, l.font = r, l.textColor = o, l.verticalAlign = a;
                    } else {
                        const s = t.parse(e1[r], 1, $e);
                        if (!s) return null;
                        const o = s.type.kind;
                        if ("string" !== o && "value" !== o && "null" !== o && "resolvedImage" !== o) return t.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: s,
                            scale: null,
                            font: null,
                            textColor: null,
                            verticalAlign: null
                        });
                    }
                }
                return new Er(n);
            }
            evaluate(e1) {
                return new Ft(this.sections.map((t)=>{
                    const r = t.content.evaluate(e1);
                    return $t(r) === Ye ? new kt("", r, null, null, null, t.verticalAlign ? t.verticalAlign.evaluate(e1) : null) : new kt(Ut(r), null, t.scale ? t.scale.evaluate(e1) : null, t.font ? t.font.evaluate(e1).join(",") : null, t.textColor ? t.textColor.evaluate(e1) : null, t.verticalAlign ? t.verticalAlign.evaluate(e1) : null);
                }));
            }
            eachChild(e1) {
                for (const t of this.sections)e1(t.content), t.scale && e1(t.scale), t.font && e1(t.font), t.textColor && e1(t.textColor), t.verticalAlign && e1(t.verticalAlign);
            }
            outputDefined() {
                return !1;
            }
        }
        class Mr {
            constructor(e1){
                this.type = Ye, this.input = e1;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error("Expected two arguments.");
                const r = t.parse(e1[1], 1, Ce);
                return r ? new Mr(r) : t.error("No image name provided.");
            }
            evaluate(e1) {
                const t = this.input.evaluate(e1), r = Lt.fromString(t);
                return r && e1.availableImages && (r.available = e1.availableImages.indexOf(t) > -1), r;
            }
            eachChild(e1) {
                e1(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class kr {
            constructor(e1){
                this.type = Ve, this.input = e1;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`Expected 1 argument, but found ${e1.length - 1} instead.`);
                const r = t.parse(e1[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? t.error(`Expected argument of type string or array, but found ${Ke(r.type)} instead.`) : new kr(r) : null;
            }
            evaluate(e1) {
                const t = this.input.evaluate(e1);
                if ("string" == typeof t) return [
                    ...t
                ].length;
                if (Array.isArray(t)) return t.length;
                throw new zt(`Expected value to be of type string or array, but found ${Ke($t(t))} instead.`);
            }
            eachChild(e1) {
                e1(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        const Fr = 8192;
        function Dr(e1, t) {
            const r = (180 + e1[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1[1] * Math.PI / 360))) / 360, i = Math.pow(2, t.z);
            return [
                Math.round(r * i * Fr),
                Math.round(n * i * Fr)
            ];
        }
        function Pr(e1, t) {
            const r = Math.pow(2, t.z);
            var n, i;
            return [
                (i = (e1[0] / Fr + t.x) / r, 360 * i - 180),
                (n = (e1[1] / Fr + t.y) / r, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * n) * Math.PI / 180)) - 90)
            ];
        }
        function Br(e1, t) {
            e1[0] = Math.min(e1[0], t[0]), e1[1] = Math.min(e1[1], t[1]), e1[2] = Math.max(e1[2], t[0]), e1[3] = Math.max(e1[3], t[1]);
        }
        function zr(e1, t) {
            return !(e1[0] <= t[0] || e1[2] >= t[2] || e1[1] <= t[1] || e1[3] >= t[3]);
        }
        function Vr(e1, t, r) {
            const n = e1[0] - t[0], i = e1[1] - t[1], s = e1[0] - r[0], o = e1[1] - r[1];
            return n * o - s * i == 0 && n * s <= 0 && i * o <= 0;
        }
        function Cr(e1, t, r, n) {
            var i, s;
            return 0 != (i = [
                n[0] - r[0],
                n[1] - r[1]
            ])[0] * (s = [
                t[0] - e1[0],
                t[1] - e1[1]
            ])[1] - i[1] * s[0] && !(!Ur(e1, t, r, n) || !Ur(r, n, e1, t));
        }
        function Lr(e1, t, r) {
            for (const n of r)for(let r = 0; r < n.length - 1; ++r)if (Cr(e1, t, n[r], n[r + 1])) return !0;
            return !1;
        }
        function Or(e1, t, r = !1) {
            let n = !1;
            for (const a of t)for(let t = 0; t < a.length - 1; t++){
                if (Vr(e1, a[t], a[t + 1])) return r;
                (s = a[t])[1] > (i = e1)[1] != (o = a[t + 1])[1] > i[1] && i[0] < (o[0] - s[0]) * (i[1] - s[1]) / (o[1] - s[1]) + s[0] && (n = !n);
            }
            var i, s, o;
            return n;
        }
        function Rr(e1, t) {
            for (const r of t)if (Or(e1, r)) return !0;
            return !1;
        }
        function Nr(e1, t) {
            for (const r of e1)if (!Or(r, t)) return !1;
            for(let r = 0; r < e1.length - 1; ++r)if (Lr(e1[r], e1[r + 1], t)) return !1;
            return !0;
        }
        function $r(e1, t) {
            for (const r of t)if (Nr(e1, r)) return !0;
            return !1;
        }
        function Ur(e1, t, r, n) {
            const i = n[0] - r[0], s = n[1] - r[1], o = (e1[0] - r[0]) * s - i * (e1[1] - r[1]), a = (t[0] - r[0]) * s - i * (t[1] - r[1]);
            return o > 0 && a < 0 || o < 0 && a > 0;
        }
        function qr(e1, t, r) {
            const n = [];
            for(let i = 0; i < e1.length; i++){
                const s = [];
                for(let n = 0; n < e1[i].length; n++){
                    const o = Dr(e1[i][n], r);
                    Br(t, o), s.push(o);
                }
                n.push(s);
            }
            return n;
        }
        function jr(e1, t, r) {
            const n = [];
            for(let i = 0; i < e1.length; i++){
                const s = qr(e1[i], t, r);
                n.push(s);
            }
            return n;
        }
        function Gr(e1, t, r, n) {
            if (e1[0] < r[0] || e1[0] > r[2]) {
                const t = .5 * n;
                let i = e1[0] - r[0] > t ? -n : r[0] - e1[0] > t ? n : 0;
                0 === i && (i = e1[0] - r[2] > t ? -n : r[2] - e1[0] > t ? n : 0), e1[0] += i;
            }
            Br(t, e1);
        }
        function Xr(e1, t, r, n) {
            const i = Math.pow(2, n.z) * Fr, s = [
                n.x * Fr,
                n.y * Fr
            ], o = [];
            for (const n of e1)for (const e1 of n){
                const n = [
                    e1.x + s[0],
                    e1.y + s[1]
                ];
                Gr(n, t, r, i), o.push(n);
            }
            return o;
        }
        function Yr(e1, t, r, n) {
            const i = Math.pow(2, n.z) * Fr, s = [
                n.x * Fr,
                n.y * Fr
            ], o = [];
            for (const r of e1){
                const e1 = [];
                for (const n of r){
                    const r = [
                        n.x + s[0],
                        n.y + s[1]
                    ];
                    Br(t, r), e1.push(r);
                }
                o.push(e1);
            }
            if (t[2] - t[0] <= i / 2) {
                (a = t)[0] = a[1] = 1 / 0, a[2] = a[3] = -1 / 0;
                for (const e1 of o)for (const n of e1)Gr(n, t, r, i);
            }
            var a;
            return o;
        }
        class Zr {
            constructor(e1, t){
                this.type = Le, this.geojson = e1, this.geometries = t;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`'within' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (Nt(e1[1])) {
                    const t = e1[1];
                    if ("FeatureCollection" === t.type) {
                        const e1 = [];
                        for (const r of t.features){
                            const { type: t, coordinates: n } = r.geometry;
                            "Polygon" === t && e1.push(n), "MultiPolygon" === t && e1.push(...n);
                        }
                        if (e1.length) return new Zr(t, {
                            type: "MultiPolygon",
                            coordinates: e1
                        });
                    } else if ("Feature" === t.type) {
                        const e1 = t.geometry.type;
                        if ("Polygon" === e1 || "MultiPolygon" === e1) return new Zr(t, t.geometry);
                    } else if ("Polygon" === t.type || "MultiPolygon" === t.type) return new Zr(t, t);
                }
                return t.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(e1) {
                if (null != e1.geometry() && null != e1.canonicalID()) {
                    if ("Point" === e1.geometryType()) return function(e1, t) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = e1.canonicalID();
                        if ("Polygon" === t.type) {
                            const s = qr(t.coordinates, n, i), o = Xr(e1.geometry(), r, n, i);
                            if (!zr(r, n)) return !1;
                            for (const e1 of o)if (!Or(e1, s)) return !1;
                        }
                        if ("MultiPolygon" === t.type) {
                            const s = jr(t.coordinates, n, i), o = Xr(e1.geometry(), r, n, i);
                            if (!zr(r, n)) return !1;
                            for (const e1 of o)if (!Rr(e1, s)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                    if ("LineString" === e1.geometryType()) return function(e1, t) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = e1.canonicalID();
                        if ("Polygon" === t.type) {
                            const s = qr(t.coordinates, n, i), o = Yr(e1.geometry(), r, n, i);
                            if (!zr(r, n)) return !1;
                            for (const e1 of o)if (!Nr(e1, s)) return !1;
                        }
                        if ("MultiPolygon" === t.type) {
                            const s = jr(t.coordinates, n, i), o = Yr(e1.geometry(), r, n, i);
                            if (!zr(r, n)) return !1;
                            for (const e1 of o)if (!$r(e1, s)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        let Hr = class {
            constructor(e1 = [], t = (e1, t)=>e1 < t ? -1 : e1 > t ? 1 : 0){
                if (this.data = e1, this.length = this.data.length, this.compare = t, this.length > 0) for(let e1 = (this.length >> 1) - 1; e1 >= 0; e1--)this._down(e1);
            }
            push(e1) {
                this.data.push(e1), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const e1 = this.data[0], t = this.data.pop();
                return --this.length > 0 && (this.data[0] = t, this._down(0)), e1;
            }
            peek() {
                return this.data[0];
            }
            _up(e1) {
                const { data: t, compare: r } = this, n = t[e1];
                for(; e1 > 0;){
                    const i = e1 - 1 >> 1, s = t[i];
                    if (r(n, s) >= 0) break;
                    t[e1] = s, e1 = i;
                }
                t[e1] = n;
            }
            _down(e1) {
                const { data: t, compare: r } = this, n = this.length >> 1, i = t[e1];
                for(; e1 < n;){
                    let n = 1 + (e1 << 1);
                    const s = n + 1;
                    if (s < this.length && r(t[s], t[n]) < 0 && (n = s), r(t[n], i) >= 0) break;
                    t[e1] = t[n], e1 = n;
                }
                t[e1] = i;
            }
        };
        function Kr(e1, t, r = 0, n = e1.length - 1, i = Jr) {
            for(; n > r;){
                if (n - r > 600) {
                    const s = n - r + 1, o = t - r + 1, a = Math.log(s), l = .5 * Math.exp(2 * a / 3), u = .5 * Math.sqrt(a * l * (s - l) / s) * (o - s / 2 < 0 ? -1 : 1);
                    Kr(e1, t, Math.max(r, Math.floor(t - o * l / s + u)), Math.min(n, Math.floor(t + (s - o) * l / s + u)), i);
                }
                const s = e1[t];
                let o = r, a = n;
                for(Wr(e1, r, t), i(e1[n], s) > 0 && Wr(e1, r, n); o < a;){
                    for(Wr(e1, o, a), o++, a--; i(e1[o], s) < 0;)o++;
                    for(; i(e1[a], s) > 0;)a--;
                }
                0 === i(e1[r], s) ? Wr(e1, r, a) : (a++, Wr(e1, a, n)), a <= t && (r = a + 1), t <= a && (n = a - 1);
            }
        }
        function Wr(e1, t, r) {
            const n = e1[t];
            e1[t] = e1[r], e1[r] = n;
        }
        function Jr(e1, t) {
            return e1 < t ? -1 : e1 > t ? 1 : 0;
        }
        function Qr(e1, t) {
            if (e1.length <= 1) return [
                e1
            ];
            const r = [];
            let n, i;
            for (const t of e1){
                const e1 = tn(t);
                0 !== e1 && (t.area = Math.abs(e1), void 0 === i && (i = e1 < 0), i === e1 < 0 ? (n && r.push(n), n = [
                    t
                ]) : n.push(t));
            }
            if (n && r.push(n), t > 1) for(let e1 = 0; e1 < r.length; e1++)r[e1].length <= t || (Kr(r[e1], t, 1, r[e1].length - 1, en), r[e1] = r[e1].slice(0, t));
            return r;
        }
        function en(e1, t) {
            return t.area - e1.area;
        }
        function tn(e1) {
            let t = 0;
            for(let r, n, i = 0, s = e1.length, o = s - 1; i < s; o = i++)r = e1[i], n = e1[o], t += (n.x - r.x) * (r.y + n.y);
            return t;
        }
        const rn = 1 / 298.257223563, nn = rn * (2 - rn), sn = Math.PI / 180;
        class on {
            constructor(e1){
                const t = 6378.137 * sn * 1e3, r = Math.cos(e1 * sn), n = 1 / (1 - nn * (1 - r * r)), i = Math.sqrt(n);
                this.kx = t * i * r, this.ky = t * i * n * (1 - nn);
            }
            distance(e1, t) {
                const r = this.wrap(e1[0] - t[0]) * this.kx, n = (e1[1] - t[1]) * this.ky;
                return Math.sqrt(r * r + n * n);
            }
            pointOnLine(e1, t) {
                let r, n, i, s, o = 1 / 0;
                for(let a = 0; a < e1.length - 1; a++){
                    let l = e1[a][0], u = e1[a][1], c = this.wrap(e1[a + 1][0] - l) * this.kx, h = (e1[a + 1][1] - u) * this.ky, p = 0;
                    0 === c && 0 === h || (p = (this.wrap(t[0] - l) * this.kx * c + (t[1] - u) * this.ky * h) / (c * c + h * h), p > 1 ? (l = e1[a + 1][0], u = e1[a + 1][1]) : p > 0 && (l += c / this.kx * p, u += h / this.ky * p)), c = this.wrap(t[0] - l) * this.kx, h = (t[1] - u) * this.ky;
                    const f = c * c + h * h;
                    f < o && (o = f, r = l, n = u, i = a, s = p);
                }
                return {
                    point: [
                        r,
                        n
                    ],
                    index: i,
                    t: Math.max(0, Math.min(1, s))
                };
            }
            wrap(e1) {
                for(; e1 < -180;)e1 += 360;
                for(; e1 > 180;)e1 -= 360;
                return e1;
            }
        }
        function an(e1, t) {
            return t[0] - e1[0];
        }
        function ln(e1) {
            return e1[1] - e1[0] + 1;
        }
        function un(e1, t) {
            return e1[1] >= e1[0] && e1[1] < t;
        }
        function cn(e1, t) {
            if (e1[0] > e1[1]) return [
                null,
                null
            ];
            const r = ln(e1);
            if (t) {
                if (2 === r) return [
                    e1,
                    null
                ];
                const t = Math.floor(r / 2);
                return [
                    [
                        e1[0],
                        e1[0] + t
                    ],
                    [
                        e1[0] + t,
                        e1[1]
                    ]
                ];
            }
            if (1 === r) return [
                e1,
                null
            ];
            const n = Math.floor(r / 2) - 1;
            return [
                [
                    e1[0],
                    e1[0] + n
                ],
                [
                    e1[0] + n + 1,
                    e1[1]
                ]
            ];
        }
        function hn(e1, t) {
            if (!un(t, e1.length)) return [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            const r = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let n = t[0]; n <= t[1]; ++n)Br(r, e1[n]);
            return r;
        }
        function pn(e1) {
            const t = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for (const r of e1)for (const e1 of r)Br(t, e1);
            return t;
        }
        function fn(e1) {
            return e1[0] !== -1 / 0 && e1[1] !== -1 / 0 && e1[2] !== 1 / 0 && e1[3] !== 1 / 0;
        }
        function dn(e1, t, r) {
            if (!fn(e1) || !fn(t)) return NaN;
            let n = 0, i = 0;
            return e1[2] < t[0] && (n = t[0] - e1[2]), e1[0] > t[2] && (n = e1[0] - t[2]), e1[1] > t[3] && (i = e1[1] - t[3]), e1[3] < t[1] && (i = t[1] - e1[3]), r.distance([
                0,
                0
            ], [
                n,
                i
            ]);
        }
        function yn(e1, t, r) {
            const n = r.pointOnLine(t, e1);
            return r.distance(e1, n.point);
        }
        function mn(e1, t, r, n, i) {
            const s = Math.min(yn(e1, [
                r,
                n
            ], i), yn(t, [
                r,
                n
            ], i)), o = Math.min(yn(r, [
                e1,
                t
            ], i), yn(n, [
                e1,
                t
            ], i));
            return Math.min(s, o);
        }
        function gn(e1, t, r, n, i) {
            if (!un(t, e1.length) || !un(n, r.length)) return 1 / 0;
            let s = 1 / 0;
            for(let o = t[0]; o < t[1]; ++o){
                const t = e1[o], a = e1[o + 1];
                for(let e1 = n[0]; e1 < n[1]; ++e1){
                    const n = r[e1], o = r[e1 + 1];
                    if (Cr(t, a, n, o)) return 0;
                    s = Math.min(s, mn(t, a, n, o, i));
                }
            }
            return s;
        }
        function xn(e1, t, r, n, i) {
            if (!un(t, e1.length) || !un(n, r.length)) return NaN;
            let s = 1 / 0;
            for(let o = t[0]; o <= t[1]; ++o)for(let t = n[0]; t <= n[1]; ++t)if (s = Math.min(s, i.distance(e1[o], r[t])), 0 === s) return s;
            return s;
        }
        function vn(e1, t, r) {
            if (Or(e1, t, !0)) return 0;
            let n = 1 / 0;
            for (const i of t){
                const t = i[0], s = i[i.length - 1];
                if (t !== s && (n = Math.min(n, yn(e1, [
                    s,
                    t
                ], r)), 0 === n)) return n;
                const o = r.pointOnLine(i, e1);
                if (n = Math.min(n, r.distance(e1, o.point)), 0 === n) return n;
            }
            return n;
        }
        function bn(e1, t, r, n) {
            if (!un(t, e1.length)) return NaN;
            for(let n = t[0]; n <= t[1]; ++n)if (Or(e1[n], r, !0)) return 0;
            let i = 1 / 0;
            for(let s = t[0]; s < t[1]; ++s){
                const t = e1[s], o = e1[s + 1];
                for (const e1 of r)for(let r = 0, s = e1.length, a = s - 1; r < s; a = r++){
                    const s = e1[a], l = e1[r];
                    if (Cr(t, o, s, l)) return 0;
                    i = Math.min(i, mn(t, o, s, l, n));
                }
            }
            return i;
        }
        function wn(e1, t) {
            for (const r of e1)for (const e1 of r)if (Or(e1, t, !0)) return !0;
            return !1;
        }
        function _n(e1, t, r, n = 1 / 0) {
            const i = pn(e1), s = pn(t);
            if (n !== 1 / 0 && dn(i, s, r) >= n) return n;
            if (zr(i, s)) {
                if (wn(e1, t)) return 0;
            } else if (wn(t, e1)) return 0;
            let o = 1 / 0;
            for (const n of e1)for(let e1 = 0, i = n.length, s = i - 1; e1 < i; s = e1++){
                const i = n[s], a = n[e1];
                for (const e1 of t)for(let t = 0, n = e1.length, s = n - 1; t < n; s = t++){
                    const n = e1[s], l = e1[t];
                    if (Cr(i, a, n, l)) return 0;
                    o = Math.min(o, mn(i, a, n, l, r));
                }
            }
            return o;
        }
        function Sn(e1, t, r, n, i, s) {
            if (!s) return;
            const o = dn(hn(n, s), i, r);
            o < t && e1.push([
                o,
                s,
                [
                    0,
                    0
                ]
            ]);
        }
        function An(e1, t, r, n, i, s, o) {
            if (!s || !o) return;
            const a = dn(hn(n, s), hn(i, o), r);
            a < t && e1.push([
                a,
                s,
                o
            ]);
        }
        function Tn(e1, t, r, n, i = 1 / 0) {
            let s = Math.min(n.distance(e1[0], r[0][0]), i);
            if (0 === s) return s;
            const o = new Hr([
                [
                    0,
                    [
                        0,
                        e1.length - 1
                    ],
                    [
                        0,
                        0
                    ]
                ]
            ], an), a = pn(r);
            for(; o.length > 0;){
                const i = o.pop();
                if (i[0] >= s) continue;
                const l = i[1], u = t ? 50 : 100;
                if (ln(l) <= u) {
                    if (!un(l, e1.length)) return NaN;
                    if (t) {
                        const t = bn(e1, l, r, n);
                        if (isNaN(t) || 0 === t) return t;
                        s = Math.min(s, t);
                    } else for(let t = l[0]; t <= l[1]; ++t){
                        const i = vn(e1[t], r, n);
                        if (s = Math.min(s, i), 0 === s) return 0;
                    }
                } else {
                    const r = cn(l, t);
                    Sn(o, s, n, e1, a, r[0]), Sn(o, s, n, e1, a, r[1]);
                }
            }
            return s;
        }
        function In(e1, t, r, n, i, s = 1 / 0) {
            let o = Math.min(s, i.distance(e1[0], r[0]));
            if (0 === o) return o;
            const a = new Hr([
                [
                    0,
                    [
                        0,
                        e1.length - 1
                    ],
                    [
                        0,
                        r.length - 1
                    ]
                ]
            ], an);
            for(; a.length > 0;){
                const s = a.pop();
                if (s[0] >= o) continue;
                const l = s[1], u = s[2], c = t ? 50 : 100, h = n ? 50 : 100;
                if (ln(l) <= c && ln(u) <= h) {
                    if (!un(l, e1.length) && un(u, r.length)) return NaN;
                    let s;
                    if (t && n) s = gn(e1, l, r, u, i), o = Math.min(o, s);
                    else if (t && !n) {
                        const t = e1.slice(l[0], l[1] + 1);
                        for(let e1 = u[0]; e1 <= u[1]; ++e1)if (s = yn(r[e1], t, i), o = Math.min(o, s), 0 === o) return o;
                    } else if (!t && n) {
                        const t = r.slice(u[0], u[1] + 1);
                        for(let r = l[0]; r <= l[1]; ++r)if (s = yn(e1[r], t, i), o = Math.min(o, s), 0 === o) return o;
                    } else s = xn(e1, l, r, u, i), o = Math.min(o, s);
                } else {
                    const s = cn(l, t), c = cn(u, n);
                    An(a, o, i, e1, r, s[0], c[0]), An(a, o, i, e1, r, s[0], c[1]), An(a, o, i, e1, r, s[1], c[0]), An(a, o, i, e1, r, s[1], c[1]);
                }
            }
            return o;
        }
        function En(e1) {
            return "MultiPolygon" === e1.type ? e1.coordinates.map((e1)=>({
                    type: "Polygon",
                    coordinates: e1
                })) : "MultiLineString" === e1.type ? e1.coordinates.map((e1)=>({
                    type: "LineString",
                    coordinates: e1
                })) : "MultiPoint" === e1.type ? e1.coordinates.map((e1)=>({
                    type: "Point",
                    coordinates: e1
                })) : [
                e1
            ];
        }
        class Mn {
            constructor(e1, t){
                this.type = Ve, this.geojson = e1, this.geometries = t;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`'distance' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (Nt(e1[1])) {
                    const t = e1[1];
                    if ("FeatureCollection" === t.type) return new Mn(t, t.features.map((e1)=>En(e1.geometry)).flat());
                    if ("Feature" === t.type) return new Mn(t, En(t.geometry));
                    if ("type" in t && "coordinates" in t) return new Mn(t, En(t));
                }
                return t.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(e1) {
                if (null != e1.geometry() && null != e1.canonicalID()) {
                    if ("Point" === e1.geometryType()) return function(e1, t) {
                        const r = e1.geometry(), n = r.flat().map((t)=>Pr([
                                t.x,
                                t.y
                            ], e1.canonical));
                        if (0 === r.length) return NaN;
                        const i = new on(n[0][1]);
                        let s = 1 / 0;
                        for (const e1 of t){
                            switch(e1.type){
                                case "Point":
                                    s = Math.min(s, In(n, !1, [
                                        e1.coordinates
                                    ], !1, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, In(n, !1, e1.coordinates, !0, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, Tn(n, !1, e1.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(e1, this.geometries);
                    if ("LineString" === e1.geometryType()) return function(e1, t) {
                        const r = e1.geometry(), n = r.flat().map((t)=>Pr([
                                t.x,
                                t.y
                            ], e1.canonical));
                        if (0 === r.length) return NaN;
                        const i = new on(n[0][1]);
                        let s = 1 / 0;
                        for (const e1 of t){
                            switch(e1.type){
                                case "Point":
                                    s = Math.min(s, In(n, !0, [
                                        e1.coordinates
                                    ], !1, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, In(n, !0, e1.coordinates, !0, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, Tn(n, !0, e1.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(e1, this.geometries);
                    if ("Polygon" === e1.geometryType()) return function(e1, t) {
                        const r = e1.geometry();
                        if (0 === r.length || 0 === r[0].length) return NaN;
                        const n = Qr(r, 0).map((t)=>t.map((t)=>t.map((t)=>Pr([
                                        t.x,
                                        t.y
                                    ], e1.canonical)))), i = new on(n[0][0][0][1]);
                        let s = 1 / 0;
                        for (const e1 of t)for (const t of n){
                            switch(e1.type){
                                case "Point":
                                    s = Math.min(s, Tn([
                                        e1.coordinates
                                    ], !1, t, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, Tn(e1.coordinates, !0, t, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, _n(t, e1.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(e1, this.geometries);
                }
                return NaN;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        class kn {
            constructor(e1){
                this.type = $e, this.key = e1;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`Expected 1 argument, but found ${e1.length - 1} instead.`);
                const r = e1[1];
                return null == r ? t.error("Global state property must be defined.") : "string" != typeof r ? t.error(`Global state property must be string, but found ${typeof e1[1]} instead.`) : new kn(r);
            }
            evaluate(e1) {
                var t;
                const r = null === (t = e1.globals) || void 0 === t ? void 0 : t.globalState;
                return r && 0 !== Object.keys(r).length ? xt(r, this.key) : null;
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
        }
        const Fn = {
            "==": vr,
            "!=": br,
            ">": _r,
            "<": wr,
            ">=": Ar,
            "<=": Sr,
            array: Gt,
            at: Qt,
            boolean: Gt,
            case: nr,
            coalesce: yr,
            collator: Tr,
            format: Er,
            image: Mr,
            in: er,
            "index-of": tr,
            interpolate: pr,
            "interpolate-hcl": pr,
            "interpolate-lab": pr,
            length: kr,
            let: Wt,
            literal: qt,
            match: rr,
            number: Gt,
            "number-format": Ir,
            object: Gt,
            slice: ir,
            step: or,
            string: Gt,
            "to-boolean": Yt,
            "to-color": Yt,
            "to-number": Yt,
            "to-string": Yt,
            var: Jt,
            within: Zr,
            distance: Mn,
            "global-state": kn
        };
        class Dn {
            constructor(e1, t, r, n){
                this.name = e1, this.type = t, this._evaluate = r, this.args = n;
            }
            evaluate(e1) {
                return this._evaluate(e1, this.args);
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return !1;
            }
            static parse(e1, t) {
                const r = e1[0], n = Dn.definitions[r];
                if (!n) return t.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, s = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, o = s.filter(([t])=>!Array.isArray(t) || t.length === e1.length - 1);
                let a = null;
                for (const [n, s] of o){
                    a = new Kt(t.registry, Cn, t.path, null, t.scope);
                    const o = [];
                    let l = !1;
                    for(let t = 1; t < e1.length; t++){
                        const r = e1[t], i = Array.isArray(n) ? n[t - 1] : n.type, s = a.parse(r, 1 + o.length, i);
                        if (!s) {
                            l = !0;
                            break;
                        }
                        o.push(s);
                    }
                    if (!l) {
                        if (Array.isArray(n) && n.length !== o.length) a.error(`Expected ${n.length} arguments, but found ${o.length} instead.`);
                        else {
                            for(let e1 = 0; e1 < o.length; e1++){
                                const t = Array.isArray(n) ? n[e1] : n.type, r = o[e1];
                                a.concat(e1 + 1).checkSubtype(t, r.type);
                            }
                            if (0 === a.errors.length) return new Dn(r, i, s, o);
                        }
                    }
                }
                if (1 === o.length) t.errors.push(...a.errors);
                else {
                    const r = (o.length ? o : s).map(([e1])=>{
                        var t;
                        return t = e1, Array.isArray(t) ? `(${t.map(Ke).join(", ")})` : `(${Ke(t.type)}...)`;
                    }).join(" | "), n = [];
                    for(let r = 1; r < e1.length; r++){
                        const i = t.parse(e1[r], 1 + n.length);
                        if (!i) return null;
                        n.push(Ke(i.type));
                    }
                    t.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(e1, t) {
                Dn.definitions = t;
                for(const r in t)e1[r] = Dn;
            }
        }
        function Pn(e1, [t, r, n, i]) {
            t = t.evaluate(e1), r = r.evaluate(e1), n = n.evaluate(e1);
            const s = i ? i.evaluate(e1) : 1, o = Rt(t, r, n, s);
            if (o) throw new zt(o);
            return new It(t / 255, r / 255, n / 255, s, !1);
        }
        function Bn(e1, t) {
            return e1 in t;
        }
        function zn(e1, t) {
            const r = t[e1];
            return void 0 === r ? null : r;
        }
        function Vn(e1) {
            return {
                type: e1
            };
        }
        function Cn(e1) {
            if (e1 instanceof Jt) return Cn(e1.boundExpression);
            if (e1 instanceof Dn && "error" === e1.name) return !1;
            if (e1 instanceof Tr) return !1;
            if (e1 instanceof Zr) return !1;
            if (e1 instanceof Mn) return !1;
            if (e1 instanceof kn) return !1;
            const t = e1 instanceof Yt || e1 instanceof Gt;
            let r = !0;
            return e1.eachChild((e1)=>{
                r = t ? r && Cn(e1) : r && e1 instanceof qt;
            }), !!r && Ln(e1) && Rn(e1, [
                "zoom",
                "heatmap-density",
                "elevation",
                "line-progress",
                "accumulated",
                "is-supported-script"
            ]);
        }
        function Ln(e1) {
            if (e1 instanceof Dn) {
                if ("get" === e1.name && 1 === e1.args.length) return !1;
                if ("feature-state" === e1.name) return !1;
                if ("has" === e1.name && 1 === e1.args.length) return !1;
                if ("properties" === e1.name || "geometry-type" === e1.name || "id" === e1.name) return !1;
                if (/^filter-/.test(e1.name)) return !1;
            }
            if (e1 instanceof Zr) return !1;
            if (e1 instanceof Mn) return !1;
            let t = !0;
            return e1.eachChild((e1)=>{
                t && !Ln(e1) && (t = !1);
            }), t;
        }
        function On(e1) {
            if (e1 instanceof Dn && "feature-state" === e1.name) return !1;
            let t = !0;
            return e1.eachChild((e1)=>{
                t && !On(e1) && (t = !1);
            }), t;
        }
        function Rn(e1, t) {
            if (e1 instanceof Dn && t.indexOf(e1.name) >= 0) return !1;
            let r = !0;
            return e1.eachChild((e1)=>{
                r && !Rn(e1, t) && (r = !1);
            }), r;
        }
        function Nn(e1) {
            return {
                result: "success",
                value: e1
            };
        }
        function $n(e1) {
            return {
                result: "error",
                value: e1
            };
        }
        function Un(e1) {
            return "data-driven" === e1["property-type"] || "cross-faded-data-driven" === e1["property-type"];
        }
        function qn(e1) {
            return !!e1.expression && e1.expression.parameters.indexOf("zoom") > -1;
        }
        function jn(e1) {
            return !!e1.expression && e1.expression.interpolated;
        }
        function Gn(e1) {
            return e1 instanceof Number ? "number" : e1 instanceof String ? "string" : e1 instanceof Boolean ? "boolean" : Array.isArray(e1) ? "array" : null === e1 ? "null" : typeof e1;
        }
        function Xn(e1) {
            return "object" == typeof e1 && null !== e1 && !Array.isArray(e1) && $t(e1) === Ne;
        }
        function Yn(e1) {
            return e1;
        }
        function Zn(e1, t) {
            const r = e1.stops && "object" == typeof e1.stops[0][0], n = r || !(r || void 0 !== e1.property), i = e1.type || (jn(t) ? "exponential" : "interval"), s = function(e1) {
                switch(e1.type){
                    case "color":
                        return It.parse;
                    case "padding":
                        return Dt.parse;
                    case "numberArray":
                        return Pt.parse;
                    case "colorArray":
                        return Bt.parse;
                    default:
                        return null;
                }
            }(t);
            if (s && ((e1 = De({}, e1)).stops && (e1.stops = e1.stops.map((e1)=>[
                    e1[0],
                    s(e1[1])
                ])), e1.default = s(e1.default ? e1.default : t.default)), e1.colorSpace && "rgb" !== (o = e1.colorSpace) && "hcl" !== o && "lab" !== o) throw new Error(`Unknown color space: "${e1.colorSpace}"`);
            var o;
            const a = function(e1) {
                switch(e1){
                    case "exponential":
                        return Jn;
                    case "interval":
                        return Wn;
                    case "categorical":
                        return Kn;
                    case "identity":
                        return Qn;
                    default:
                        throw new Error(`Unknown function type "${e1}"`);
                }
            }(i);
            let l, u;
            if ("categorical" === i) {
                l = Object.create(null);
                for (const t of e1.stops)l[t[0]] = t[1];
                u = typeof e1.stops[0][0];
            }
            if (r) {
                const r = {}, n = [];
                for(let t = 0; t < e1.stops.length; t++){
                    const i = e1.stops[t], s = i[0].zoom;
                    void 0 === r[s] && (r[s] = {
                        zoom: s,
                        type: e1.type,
                        property: e1.property,
                        default: e1.default,
                        stops: []
                    }, n.push(s)), r[s].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const e1 of n)i.push([
                    r[e1].zoom,
                    Zn(r[e1], t)
                ]);
                const s = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: s,
                    interpolationFactor: pr.interpolationFactor.bind(void 0, s),
                    zoomStops: i.map((e1)=>e1[0]),
                    evaluate: ({ zoom: r }, n)=>Jn({
                            stops: i,
                            base: e1.base
                        }, t, r).evaluate(r, n)
                };
            }
            if (n) {
                const r = "exponential" === i ? {
                    name: "exponential",
                    base: void 0 !== e1.base ? e1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: pr.interpolationFactor.bind(void 0, r),
                    zoomStops: e1.stops.map((e1)=>e1[0]),
                    evaluate: ({ zoom: r })=>a(e1, t, r, l, u)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[e1.property] : void 0;
                    return void 0 === i ? Hn(e1.default, t.default) : a(e1, t, i, l, u);
                }
            };
        }
        function Hn(e1, t, r) {
            return void 0 !== e1 ? e1 : void 0 !== t ? t : void 0 !== r ? r : void 0;
        }
        function Kn(e1, t, r, n, i) {
            return Hn(typeof r === i ? n[r] : void 0, e1.default, t.default);
        }
        function Wn(e1, t, r) {
            if ("number" !== Gn(r)) return Hn(e1.default, t.default);
            const n = e1.stops.length;
            if (1 === n) return e1.stops[0][1];
            if (r <= e1.stops[0][0]) return e1.stops[0][1];
            if (r >= e1.stops[n - 1][0]) return e1.stops[n - 1][1];
            const i = sr(e1.stops.map((e1)=>e1[0]), r);
            return e1.stops[i][1];
        }
        function Jn(e1, t, r) {
            const n = void 0 !== e1.base ? e1.base : 1;
            if ("number" !== Gn(r)) return Hn(e1.default, t.default);
            const i = e1.stops.length;
            if (1 === i) return e1.stops[0][1];
            if (r <= e1.stops[0][0]) return e1.stops[0][1];
            if (r >= e1.stops[i - 1][0]) return e1.stops[i - 1][1];
            const s = sr(e1.stops.map((e1)=>e1[0]), r), o = function(e1, t, r, n) {
                const i = n - r, s = e1 - r;
                return 0 === i ? 0 : 1 === t ? s / i : (Math.pow(t, s) - 1) / (Math.pow(t, i) - 1);
            }(r, n, e1.stops[s][0], e1.stops[s + 1][0]), a = e1.stops[s][1], l = e1.stops[s + 1][1], u = dr[t.type] || Yn;
            return "function" == typeof a.evaluate ? {
                evaluate (...t) {
                    const r = a.evaluate.apply(void 0, t), n = l.evaluate.apply(void 0, t);
                    if (void 0 !== r && void 0 !== n) return u(r, n, o, e1.colorSpace);
                }
            } : u(a, l, o, e1.colorSpace);
        }
        function Qn(e1, t, r) {
            switch(t.type){
                case "color":
                    r = It.parse(r);
                    break;
                case "formatted":
                    r = Ft.fromString(r.toString());
                    break;
                case "resolvedImage":
                    r = Lt.fromString(r.toString());
                    break;
                case "padding":
                    r = Dt.parse(r);
                    break;
                case "colorArray":
                    r = Bt.parse(r);
                    break;
                case "numberArray":
                    r = Pt.parse(r);
                    break;
                default:
                    Gn(r) === t.type || "enum" === t.type && t.values[r] || (r = void 0);
            }
            return Hn(r, e1.default, t.default);
        }
        Dn.register(Fn, {
            error: [
                {
                    kind: "error"
                },
                [
                    Ce
                ],
                (e1, [t])=>{
                    throw new zt(t.evaluate(e1));
                }
            ],
            typeof: [
                Ce,
                [
                    $e
                ],
                (e1, [t])=>Ke($t(t.evaluate(e1)))
            ],
            "to-rgba": [
                He(Ve, 4),
                [
                    Oe
                ],
                (e1, [t])=>{
                    const [r, n, i, s] = t.evaluate(e1).rgb;
                    return [
                        255 * r,
                        255 * n,
                        255 * i,
                        s
                    ];
                }
            ],
            rgb: [
                Oe,
                [
                    Ve,
                    Ve,
                    Ve
                ],
                Pn
            ],
            rgba: [
                Oe,
                [
                    Ve,
                    Ve,
                    Ve,
                    Ve
                ],
                Pn
            ],
            has: {
                type: Le,
                overloads: [
                    [
                        [
                            Ce
                        ],
                        (e1, [t])=>Bn(t.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            Ce,
                            Ne
                        ],
                        (e1, [t, r])=>Bn(t.evaluate(e1), r.evaluate(e1))
                    ]
                ]
            },
            get: {
                type: $e,
                overloads: [
                    [
                        [
                            Ce
                        ],
                        (e1, [t])=>zn(t.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            Ce,
                            Ne
                        ],
                        (e1, [t, r])=>zn(t.evaluate(e1), r.evaluate(e1))
                    ]
                ]
            },
            "feature-state": [
                $e,
                [
                    Ce
                ],
                (e1, [t])=>zn(t.evaluate(e1), e1.featureState || {})
            ],
            properties: [
                Ne,
                [],
                (e1)=>e1.properties()
            ],
            "geometry-type": [
                Ce,
                [],
                (e1)=>e1.geometryType()
            ],
            id: [
                $e,
                [],
                (e1)=>e1.id()
            ],
            zoom: [
                Ve,
                [],
                (e1)=>e1.globals.zoom
            ],
            "heatmap-density": [
                Ve,
                [],
                (e1)=>e1.globals.heatmapDensity || 0
            ],
            elevation: [
                Ve,
                [],
                (e1)=>e1.globals.elevation || 0
            ],
            "line-progress": [
                Ve,
                [],
                (e1)=>e1.globals.lineProgress || 0
            ],
            accumulated: [
                $e,
                [],
                (e1)=>void 0 === e1.globals.accumulated ? null : e1.globals.accumulated
            ],
            "+": [
                Ve,
                Vn(Ve),
                (e1, t)=>{
                    let r = 0;
                    for (const n of t)r += n.evaluate(e1);
                    return r;
                }
            ],
            "*": [
                Ve,
                Vn(Ve),
                (e1, t)=>{
                    let r = 1;
                    for (const n of t)r *= n.evaluate(e1);
                    return r;
                }
            ],
            "-": {
                type: Ve,
                overloads: [
                    [
                        [
                            Ve,
                            Ve
                        ],
                        (e1, [t, r])=>t.evaluate(e1) - r.evaluate(e1)
                    ],
                    [
                        [
                            Ve
                        ],
                        (e1, [t])=>-t.evaluate(e1)
                    ]
                ]
            },
            "/": [
                Ve,
                [
                    Ve,
                    Ve
                ],
                (e1, [t, r])=>t.evaluate(e1) / r.evaluate(e1)
            ],
            "%": [
                Ve,
                [
                    Ve,
                    Ve
                ],
                (e1, [t, r])=>t.evaluate(e1) % r.evaluate(e1)
            ],
            ln2: [
                Ve,
                [],
                ()=>Math.LN2
            ],
            pi: [
                Ve,
                [],
                ()=>Math.PI
            ],
            e: [
                Ve,
                [],
                ()=>Math.E
            ],
            "^": [
                Ve,
                [
                    Ve,
                    Ve
                ],
                (e1, [t, r])=>Math.pow(t.evaluate(e1), r.evaluate(e1))
            ],
            sqrt: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.sqrt(t.evaluate(e1))
            ],
            log10: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.log(t.evaluate(e1)) / Math.LN10
            ],
            ln: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.log(t.evaluate(e1))
            ],
            log2: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.log(t.evaluate(e1)) / Math.LN2
            ],
            sin: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.sin(t.evaluate(e1))
            ],
            cos: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.cos(t.evaluate(e1))
            ],
            tan: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.tan(t.evaluate(e1))
            ],
            asin: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.asin(t.evaluate(e1))
            ],
            acos: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.acos(t.evaluate(e1))
            ],
            atan: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.atan(t.evaluate(e1))
            ],
            min: [
                Ve,
                Vn(Ve),
                (e1, t)=>Math.min(...t.map((t)=>t.evaluate(e1)))
            ],
            max: [
                Ve,
                Vn(Ve),
                (e1, t)=>Math.max(...t.map((t)=>t.evaluate(e1)))
            ],
            abs: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.abs(t.evaluate(e1))
            ],
            round: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>{
                    const r = t.evaluate(e1);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.floor(t.evaluate(e1))
            ],
            ceil: [
                Ve,
                [
                    Ve
                ],
                (e1, [t])=>Math.ceil(t.evaluate(e1))
            ],
            "filter-==": [
                Le,
                [
                    Ce,
                    $e
                ],
                (e1, [t, r])=>e1.properties()[t.value] === r.value
            ],
            "filter-id-==": [
                Le,
                [
                    $e
                ],
                (e1, [t])=>e1.id() === t.value
            ],
            "filter-type-==": [
                Le,
                [
                    Ce
                ],
                (e1, [t])=>e1.geometryType() === t.value
            ],
            "filter-<": [
                Le,
                [
                    Ce,
                    $e
                ],
                (e1, [t, r])=>{
                    const n = e1.properties()[t.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                Le,
                [
                    $e
                ],
                (e1, [t])=>{
                    const r = e1.id(), n = t.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                Le,
                [
                    Ce,
                    $e
                ],
                (e1, [t, r])=>{
                    const n = e1.properties()[t.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                Le,
                [
                    $e
                ],
                (e1, [t])=>{
                    const r = e1.id(), n = t.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                Le,
                [
                    Ce,
                    $e
                ],
                (e1, [t, r])=>{
                    const n = e1.properties()[t.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                Le,
                [
                    $e
                ],
                (e1, [t])=>{
                    const r = e1.id(), n = t.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                Le,
                [
                    Ce,
                    $e
                ],
                (e1, [t, r])=>{
                    const n = e1.properties()[t.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                Le,
                [
                    $e
                ],
                (e1, [t])=>{
                    const r = e1.id(), n = t.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                Le,
                [
                    $e
                ],
                (e1, [t])=>t.value in e1.properties()
            ],
            "filter-has-id": [
                Le,
                [],
                (e1)=>null !== e1.id() && void 0 !== e1.id()
            ],
            "filter-type-in": [
                Le,
                [
                    He(Ce)
                ],
                (e1, [t])=>t.value.indexOf(e1.geometryType()) >= 0
            ],
            "filter-id-in": [
                Le,
                [
                    He($e)
                ],
                (e1, [t])=>t.value.indexOf(e1.id()) >= 0
            ],
            "filter-in-small": [
                Le,
                [
                    Ce,
                    He($e)
                ],
                (e1, [t, r])=>r.value.indexOf(e1.properties()[t.value]) >= 0
            ],
            "filter-in-large": [
                Le,
                [
                    Ce,
                    He($e)
                ],
                (e1, [t, r])=>(function(e1, t, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (t[i] === e1) return !0;
                            t[i] > e1 ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(e1.properties()[t.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: Le,
                overloads: [
                    [
                        [
                            Le,
                            Le
                        ],
                        (e1, [t, r])=>t.evaluate(e1) && r.evaluate(e1)
                    ],
                    [
                        Vn(Le),
                        (e1, t)=>{
                            for (const r of t)if (!r.evaluate(e1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: Le,
                overloads: [
                    [
                        [
                            Le,
                            Le
                        ],
                        (e1, [t, r])=>t.evaluate(e1) || r.evaluate(e1)
                    ],
                    [
                        Vn(Le),
                        (e1, t)=>{
                            for (const r of t)if (r.evaluate(e1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                Le,
                [
                    Le
                ],
                (e1, [t])=>!t.evaluate(e1)
            ],
            "is-supported-script": [
                Le,
                [
                    Ce
                ],
                (e1, [t])=>{
                    const r = e1.globals && e1.globals.isSupportedScript;
                    return !r || r(t.evaluate(e1));
                }
            ],
            upcase: [
                Ce,
                [
                    Ce
                ],
                (e1, [t])=>t.evaluate(e1).toUpperCase()
            ],
            downcase: [
                Ce,
                [
                    Ce
                ],
                (e1, [t])=>t.evaluate(e1).toLowerCase()
            ],
            concat: [
                Ce,
                Vn($e),
                (e1, t)=>t.map((t)=>Ut(t.evaluate(e1))).join("")
            ],
            "resolved-locale": [
                Ce,
                [
                    Ue
                ],
                (e1, [t])=>t.evaluate(e1).resolvedLocale()
            ]
        });
        class ei {
            constructor(e1, t, r){
                this.expression = e1, this._warningHistory = {}, this._evaluator = new Ht, this._defaultValue = t ? function(e1) {
                    if ("color" === e1.type && Xn(e1.default)) return new It(0, 0, 0, 0);
                    switch(e1.type){
                        case "color":
                            return It.parse(e1.default) || null;
                        case "padding":
                            return Dt.parse(e1.default) || null;
                        case "numberArray":
                            return Pt.parse(e1.default) || null;
                        case "colorArray":
                            return Bt.parse(e1.default) || null;
                        case "variableAnchorOffsetCollection":
                            return Ct.parse(e1.default) || null;
                        case "projectionDefinition":
                            return Ot.parse(e1.default) || null;
                        default:
                            return void 0 === e1.default ? null : e1.default;
                    }
                }(t) : null, this._enumValues = t && "enum" === t.type ? t.values : null, this._globalState = r;
            }
            evaluateWithoutErrorHandling(e1, t, r, n, i, s) {
                return this._globalState && (e1 = ui(e1, this._globalState)), this._evaluator.globals = e1, this._evaluator.feature = t, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this.expression.evaluate(this._evaluator);
            }
            evaluate(e1, t, r, n, i, s) {
                this._globalState && (e1 = ui(e1, this._globalState)), this._evaluator.globals = e1, this._evaluator.feature = t || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null;
                try {
                    const e1 = this.expression.evaluate(this._evaluator);
                    if (null == e1 || "number" == typeof e1 && e1 != e1) return this._defaultValue;
                    if (this._enumValues && !(e1 in this._enumValues)) throw new zt(`Expected value to be one of ${Object.keys(this._enumValues).map((e1)=>JSON.stringify(e1)).join(", ")}, but found ${JSON.stringify(e1)} instead.`);
                    return e1;
                } catch (e1) {
                    return this._warningHistory[e1.message] || (this._warningHistory[e1.message] = !0, "undefined" != typeof console && console.warn(e1.message)), this._defaultValue;
                }
            }
        }
        function ti(e1) {
            return Array.isArray(e1) && e1.length > 0 && "string" == typeof e1[0] && e1[0] in Fn;
        }
        function ri(e1, t, r) {
            const n = new Kt(Fn, Cn, [], t ? function(e1) {
                const t = {
                    color: Oe,
                    string: Ce,
                    number: Ve,
                    enum: Ce,
                    boolean: Le,
                    formatted: qe,
                    padding: je,
                    numberArray: Xe,
                    colorArray: Ge,
                    projectionDefinition: Re,
                    resolvedImage: Ye,
                    variableAnchorOffsetCollection: Ze
                };
                return "array" === e1.type ? He(t[e1.value] || $e, e1.length) : t[e1.type];
            }(t) : void 0), i = n.parse(e1, void 0, void 0, void 0, t && "string" === t.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return i ? Nn(new ei(i, t, r)) : $n(n.errors);
        }
        class ni {
            constructor(e1, t, r){
                this.kind = e1, this._styleExpression = t, this.isStateDependent = "constant" !== e1 && !On(t.expression), this.globalStateRefs = li(t.expression), this._globalState = r;
            }
            evaluateWithoutErrorHandling(e1, t, r, n, i, s) {
                return this._globalState && (e1 = ui(e1, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(e1, t, r, n, i, s);
            }
            evaluate(e1, t, r, n, i, s) {
                return this._globalState && (e1 = ui(e1, this._globalState)), this._styleExpression.evaluate(e1, t, r, n, i, s);
            }
        }
        class ii {
            constructor(e1, t, r, n, i){
                this.kind = e1, this.zoomStops = r, this._styleExpression = t, this.isStateDependent = "camera" !== e1 && !On(t.expression), this.globalStateRefs = li(t.expression), this.interpolationType = n, this._globalState = i;
            }
            evaluateWithoutErrorHandling(e1, t, r, n, i, s) {
                return this._globalState && (e1 = ui(e1, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(e1, t, r, n, i, s);
            }
            evaluate(e1, t, r, n, i, s) {
                return this._globalState && (e1 = ui(e1, this._globalState)), this._styleExpression.evaluate(e1, t, r, n, i, s);
            }
            interpolationFactor(e1, t, r) {
                return this.interpolationType ? pr.interpolationFactor(this.interpolationType, e1, t, r) : 0;
            }
        }
        function si(e1, t, r) {
            const n = ri(e1, t, r);
            if ("error" === n.result) return n;
            const i = n.value.expression, s = Ln(i);
            if (!s && !Un(t)) return $n([
                new Pe("", "data expressions not supported")
            ]);
            const o = Rn(i, [
                "zoom"
            ]);
            if (!o && !qn(t)) return $n([
                new Pe("", "zoom expressions not supported")
            ]);
            const a = ai(i);
            return a || o ? a instanceof Pe ? $n([
                a
            ]) : a instanceof pr && !jn(t) ? $n([
                new Pe("", '"interpolate" expressions cannot be used with this property')
            ]) : Nn(a ? new ii(s ? "camera" : "composite", n.value, a.labels, a instanceof pr ? a.interpolation : void 0, r) : new ni(s ? "constant" : "source", n.value, r)) : $n([
                new Pe("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        class oi {
            constructor(e1, t){
                this._parameters = e1, this._specification = t, De(this, Zn(this._parameters, this._specification));
            }
            static deserialize(e1) {
                return new oi(e1._parameters, e1._specification);
            }
            static serialize(e1) {
                return {
                    _parameters: e1._parameters,
                    _specification: e1._specification
                };
            }
        }
        function ai(e1) {
            let t = null;
            if (e1 instanceof Wt) t = ai(e1.result);
            else if (e1 instanceof yr) {
                for (const r of e1.args)if (t = ai(r), t) break;
            } else (e1 instanceof or || e1 instanceof pr) && e1.input instanceof Dn && "zoom" === e1.input.name && (t = e1);
            return t instanceof Pe || e1.eachChild((e1)=>{
                const r = ai(e1);
                r instanceof Pe ? t = r : !t && r ? t = new Pe("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : t && r && t !== r && (t = new Pe("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), t;
        }
        function li(e1, t = new Set) {
            return e1 instanceof kn && t.add(e1.key), e1.eachChild((e1)=>{
                li(e1, t);
            }), t;
        }
        function ui(e1, t) {
            const { zoom: r, heatmapDensity: n, elevation: i, lineProgress: s, isSupportedScript: o, accumulated: a } = null != e1 ? e1 : {};
            return {
                zoom: r,
                heatmapDensity: n,
                elevation: i,
                lineProgress: s,
                isSupportedScript: o,
                accumulated: a,
                globalState: t
            };
        }
        function ci(e1) {
            if (!0 === e1 || !1 === e1) return !0;
            if (!Array.isArray(e1) || 0 === e1.length) return !1;
            switch(e1[0]){
                case "has":
                    return e1.length >= 2 && "$id" !== e1[1] && "$type" !== e1[1];
                case "in":
                    return e1.length >= 3 && ("string" != typeof e1[1] || Array.isArray(e1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== e1.length || Array.isArray(e1[1]) || Array.isArray(e1[2]);
                case "any":
                case "all":
                    for (const t of e1.slice(1))if (!ci(t) && "boolean" != typeof t) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        const hi = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        };
        function pi(e1, t) {
            if (null == e1) return {
                filter: ()=>!0,
                needGeometry: !1,
                getGlobalStateRefs: ()=>new Set
            };
            ci(e1) || (e1 = yi(e1));
            const r = ri(e1, hi, t);
            if ("error" === r.result) throw new Error(r.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
            return {
                filter: (e1, t, n)=>r.value.evaluate(e1, t, {}, n),
                needGeometry: di(e1),
                getGlobalStateRefs: ()=>li(r.value.expression)
            };
        }
        function fi(e1, t) {
            return e1 < t ? -1 : e1 > t ? 1 : 0;
        }
        function di(e1) {
            if (!Array.isArray(e1)) return !1;
            if ("within" === e1[0] || "distance" === e1[0]) return !0;
            for(let t = 1; t < e1.length; t++)if (di(e1[t])) return !0;
            return !1;
        }
        function yi(e1) {
            if (!e1) return !0;
            const t = e1[0];
            var r;
            return e1.length <= 1 ? "any" !== t : "==" === t ? mi(e1[1], e1[2], "==") : "!=" === t ? vi(mi(e1[1], e1[2], "==")) : "<" === t || ">" === t || "<=" === t || ">=" === t ? mi(e1[1], e1[2], t) : "any" === t ? (r = e1.slice(1), [
                "any"
            ].concat(r.map(yi))) : "all" === t ? [
                "all"
            ].concat(e1.slice(1).map(yi)) : "none" === t ? [
                "all"
            ].concat(e1.slice(1).map(yi).map(vi)) : "in" === t ? gi(e1[1], e1.slice(2)) : "!in" === t ? vi(gi(e1[1], e1.slice(2))) : "has" === t ? xi(e1[1]) : "!has" !== t || vi(xi(e1[1]));
        }
        function mi(e1, t, r) {
            switch(e1){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        t
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        t
                    ];
                default:
                    return [
                        `filter-${r}`,
                        e1,
                        t
                    ];
            }
        }
        function gi(e1, t) {
            if (0 === t.length) return !1;
            switch(e1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            t
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            t
                        ]
                    ];
                default:
                    return t.length > 200 && !t.some((e1)=>typeof e1 != typeof t[0]) ? [
                        "filter-in-large",
                        e1,
                        [
                            "literal",
                            t.sort(fi)
                        ]
                    ] : [
                        "filter-in-small",
                        e1,
                        [
                            "literal",
                            t
                        ]
                    ];
            }
        }
        function xi(e1) {
            switch(e1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        e1
                    ];
            }
        }
        function vi(e1) {
            return [
                "!",
                e1
            ];
        }
        function bi(e1) {
            const t = typeof e1;
            if ("number" === t || "boolean" === t || "string" === t || null == e1) return JSON.stringify(e1);
            if (Array.isArray(e1)) {
                let t = "[";
                for (const r of e1)t += `${bi(r)},`;
                return `${t}]`;
            }
            const r = Object.keys(e1).sort();
            let n = "{";
            for(let t = 0; t < r.length; t++)n += `${JSON.stringify(r[t])}:${bi(e1[r[t]])},`;
            return `${n}}`;
        }
        function wi(e1) {
            let t = "";
            for (const r of ve)t += `/${bi(e1[r])}`;
            return t;
        }
        function _i(e1) {
            const t = e1.value;
            return t ? [
                new Fe(e1.key, t, "constants have been deprecated as of v8")
            ] : [];
        }
        function Si(e1) {
            return e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean ? e1.valueOf() : e1;
        }
        function Ai(e1) {
            if (Array.isArray(e1)) return e1.map(Ai);
            if (e1 instanceof Object && !(e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean)) {
                const t = {};
                for(const r in e1)t[r] = Ai(e1[r]);
                return t;
            }
            return Si(e1);
        }
        function Ti(e1) {
            const t = e1.key, r = e1.value, n = e1.valueSpec || {}, i = e1.objectElementValidators || {}, s = e1.style, o = e1.styleSpec, a = e1.validateSpec;
            let l = [];
            const u = Gn(r);
            if ("object" !== u) return [
                new Fe(t, r, `object expected, ${u} found`)
            ];
            for(const e1 in r){
                const u = e1.split(".")[0], c = xt(n, u) || n["*"];
                let h;
                if (xt(i, u)) h = i[u];
                else if (xt(n, u)) h = a;
                else if (i["*"]) h = i["*"];
                else {
                    if (!n["*"]) {
                        l.push(new Fe(t, r[e1], `unknown property "${e1}"`));
                        continue;
                    }
                    h = a;
                }
                l = l.concat(h({
                    key: (t ? `${t}.` : t) + e1,
                    value: r[e1],
                    valueSpec: c,
                    style: s,
                    styleSpec: o,
                    object: r,
                    objectKey: e1,
                    validateSpec: a
                }, r));
            }
            for(const e1 in n)i[e1] || n[e1].required && void 0 === n[e1].default && void 0 === r[e1] && l.push(new Fe(t, r, `missing required property "${e1}"`));
            return l;
        }
        function Ii(e1) {
            const t = e1.value, r = e1.valueSpec, n = e1.style, i = e1.styleSpec, s = e1.key, o = e1.arrayElementValidator || e1.validateSpec;
            if ("array" !== Gn(t)) return [
                new Fe(s, t, `array expected, ${Gn(t)} found`)
            ];
            if (r.length && t.length !== r.length) return [
                new Fe(s, t, `array length ${r.length} expected, length ${t.length} found`)
            ];
            if (r["min-length"] && t.length < r["min-length"]) return [
                new Fe(s, t, `array length at least ${r["min-length"]} expected, length ${t.length} found`)
            ];
            let a = {
                type: r.value,
                values: r.values
            };
            i.$version < 7 && (a.function = r.function), "object" === Gn(r.value) && (a = r.value);
            let l = [];
            for(let r = 0; r < t.length; r++)l = l.concat(o({
                array: t,
                arrayIndex: r,
                value: t[r],
                valueSpec: a,
                validateSpec: e1.validateSpec,
                style: n,
                styleSpec: i,
                key: `${s}[${r}]`
            }));
            return l;
        }
        function Ei(e1) {
            const t = e1.key, r = e1.value, n = e1.valueSpec;
            let i = Gn(r);
            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                new Fe(t, r, `number expected, ${i} found`)
            ] : "minimum" in n && r < n.minimum ? [
                new Fe(t, r, `${r} is less than the minimum value ${n.minimum}`)
            ] : "maximum" in n && r > n.maximum ? [
                new Fe(t, r, `${r} is greater than the maximum value ${n.maximum}`)
            ] : [];
        }
        function Mi(e1) {
            const t = e1.valueSpec, r = Si(e1.value.type);
            let n, i, s, o = {};
            const a = "categorical" !== r && void 0 === e1.value.property, l = !a, u = "array" === Gn(e1.value.stops) && "array" === Gn(e1.value.stops[0]) && "object" === Gn(e1.value.stops[0][0]), c = Ti({
                key: e1.key,
                value: e1.value,
                valueSpec: e1.styleSpec.function,
                validateSpec: e1.validateSpec,
                style: e1.style,
                styleSpec: e1.styleSpec,
                objectElementValidators: {
                    stops: function(e1) {
                        if ("identity" === r) return [
                            new Fe(e1.key, e1.value, 'identity function may not have a "stops" property')
                        ];
                        let t = [];
                        const n = e1.value;
                        return t = t.concat(Ii({
                            key: e1.key,
                            value: n,
                            valueSpec: e1.valueSpec,
                            validateSpec: e1.validateSpec,
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            arrayElementValidator: h
                        })), "array" === Gn(n) && 0 === n.length && t.push(new Fe(e1.key, n, "array must have at least one stop")), t;
                    },
                    default: function(e1) {
                        return e1.validateSpec({
                            key: e1.key,
                            value: e1.value,
                            valueSpec: t,
                            validateSpec: e1.validateSpec,
                            style: e1.style,
                            styleSpec: e1.styleSpec
                        });
                    }
                }
            });
            return "identity" === r && a && c.push(new Fe(e1.key, e1.value, 'missing required property "property"')), "identity" === r || e1.value.stops || c.push(new Fe(e1.key, e1.value, 'missing required property "stops"')), "exponential" === r && e1.valueSpec.expression && !jn(e1.valueSpec) && c.push(new Fe(e1.key, e1.value, "exponential functions not supported")), e1.styleSpec.$version >= 8 && (l && !Un(e1.valueSpec) ? c.push(new Fe(e1.key, e1.value, "property functions not supported")) : a && !qn(e1.valueSpec) && c.push(new Fe(e1.key, e1.value, "zoom functions not supported"))), "categorical" !== r && !u || void 0 !== e1.value.property || c.push(new Fe(e1.key, e1.value, '"property" property is required')), c;
            function h(e1) {
                let r = [];
                const n = e1.value, a = e1.key;
                if ("array" !== Gn(n)) return [
                    new Fe(a, n, `array expected, ${Gn(n)} found`)
                ];
                if (2 !== n.length) return [
                    new Fe(a, n, `array length 2 expected, length ${n.length} found`)
                ];
                if (u) {
                    if ("object" !== Gn(n[0])) return [
                        new Fe(a, n, `object expected, ${Gn(n[0])} found`)
                    ];
                    if (void 0 === n[0].zoom) return [
                        new Fe(a, n, "object stop key must have zoom")
                    ];
                    if (void 0 === n[0].value) return [
                        new Fe(a, n, "object stop key must have value")
                    ];
                    if (s && s > Si(n[0].zoom)) return [
                        new Fe(a, n[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    Si(n[0].zoom) !== s && (s = Si(n[0].zoom), i = void 0, o = {}), r = r.concat(Ti({
                        key: `${a}[0]`,
                        value: n[0],
                        valueSpec: {
                            zoom: {}
                        },
                        validateSpec: e1.validateSpec,
                        style: e1.style,
                        styleSpec: e1.styleSpec,
                        objectElementValidators: {
                            zoom: Ei,
                            value: p
                        }
                    }));
                } else r = r.concat(p({
                    key: `${a}[0]`,
                    value: n[0],
                    validateSpec: e1.validateSpec,
                    style: e1.style,
                    styleSpec: e1.styleSpec
                }, n));
                return ti(Ai(n[1])) ? r.concat([
                    new Fe(`${a}[1]`, n[1], "expressions are not allowed in function stops.")
                ]) : r.concat(e1.validateSpec({
                    key: `${a}[1]`,
                    value: n[1],
                    valueSpec: t,
                    validateSpec: e1.validateSpec,
                    style: e1.style,
                    styleSpec: e1.styleSpec
                }));
            }
            function p(e1, s) {
                const a = Gn(e1.value), l = Si(e1.value), u = null !== e1.value ? e1.value : s;
                if (n) {
                    if (a !== n) return [
                        new Fe(e1.key, u, `${a} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = a;
                if ("number" !== a && "string" !== a && "boolean" !== a) return [
                    new Fe(e1.key, u, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== a && "categorical" !== r) {
                    let n = `number expected, ${a} found`;
                    return Un(t) && void 0 === r && (n += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new Fe(e1.key, u, n)
                    ];
                }
                return "categorical" !== r || "number" !== a || isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === a && void 0 !== i && l < i ? [
                    new Fe(e1.key, u, "stop domain values must appear in ascending order")
                ] : (i = l, "categorical" === r && l in o ? [
                    new Fe(e1.key, u, "stop domain values must be unique")
                ] : (o[l] = !0, [])) : [
                    new Fe(e1.key, u, `integer expected, found ${l}`)
                ];
            }
        }
        function ki(e1) {
            const t = ("property" === e1.expressionContext ? si : ri)(Ai(e1.value), e1.valueSpec);
            if ("error" === t.result) return t.value.map((t)=>new Fe(`${e1.key}${t.key}`, e1.value, t.message));
            const r = t.value.expression || t.value._styleExpression.expression;
            if ("property" === e1.expressionContext && "text-font" === e1.propertyKey && !r.outputDefined()) return [
                new Fe(e1.key, e1.value, `Invalid data expression for "${e1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === e1.expressionContext && "layout" === e1.propertyType && !On(r)) return [
                new Fe(e1.key, e1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === e1.expressionContext && !On(r)) return [
                new Fe(e1.key, e1.value, '"feature-state" data expressions are not supported with filters.')
            ];
            if (e1.expressionContext && 0 === e1.expressionContext.indexOf("cluster")) {
                if (!Rn(r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new Fe(e1.key, e1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === e1.expressionContext && !Ln(r)) return [
                    new Fe(e1.key, e1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function Fi(e1) {
            const t = e1.key, r = e1.value, n = Gn(r);
            return "string" !== n ? [
                new Fe(t, r, `color expected, ${n} found`)
            ] : It.parse(String(r)) ? [] : [
                new Fe(t, r, `color expected, "${r}" found`)
            ];
        }
        function Di(e1) {
            const t = e1.key, r = e1.value, n = e1.valueSpec, i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(Si(r)) && i.push(new Fe(t, r, `expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)) : -1 === Object.keys(n.values).indexOf(Si(r)) && i.push(new Fe(t, r, `expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)), i;
        }
        function Pi(e1) {
            return ci(Ai(e1.value)) ? ki(De({}, e1, {
                expressionContext: "filter",
                valueSpec: {
                    value: "boolean"
                }
            })) : Bi(e1);
        }
        function Bi(e1) {
            const t = e1.value, r = e1.key;
            if ("array" !== Gn(t)) return [
                new Fe(r, t, `array expected, ${Gn(t)} found`)
            ];
            const n = e1.styleSpec;
            let i, s = [];
            if (t.length < 1) return [
                new Fe(r, t, "filter array must have at least 1 element")
            ];
            switch(s = s.concat(Di({
                key: `${r}[0]`,
                value: t[0],
                valueSpec: n.filter_operator,
                style: e1.style,
                styleSpec: e1.styleSpec
            })), Si(t[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    t.length >= 2 && "$type" === Si(t[1]) && s.push(new Fe(r, t, `"$type" cannot be use with operator "${t[0]}"`));
                case "==":
                case "!=":
                    3 !== t.length && s.push(new Fe(r, t, `filter array for operator "${t[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    t.length >= 2 && (i = Gn(t[1]), "string" !== i && s.push(new Fe(`${r}[1]`, t[1], `string expected, ${i} found`)));
                    for(let o = 2; o < t.length; o++)i = Gn(t[o]), "$type" === Si(t[1]) ? s = s.concat(Di({
                        key: `${r}[${o}]`,
                        value: t[o],
                        valueSpec: n.geometry_type,
                        style: e1.style,
                        styleSpec: e1.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && s.push(new Fe(`${r}[${o}]`, t[o], `string, number, or boolean expected, ${i} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let n = 1; n < t.length; n++)s = s.concat(Bi({
                        key: `${r}[${n}]`,
                        value: t[n],
                        style: e1.style,
                        styleSpec: e1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    i = Gn(t[1]), 2 !== t.length ? s.push(new Fe(r, t, `filter array for "${t[0]}" operator must have 2 elements`)) : "string" !== i && s.push(new Fe(`${r}[1]`, t[1], `string expected, ${i} found`));
            }
            return s;
        }
        function zi(e1, t) {
            const r = e1.key, n = e1.validateSpec, i = e1.style, s = e1.styleSpec, o = e1.value, a = e1.objectKey, l = s[`${t}_${e1.layerType}`];
            if (!l) return [];
            const u = a.match(/^(.*)-transition$/);
            if ("paint" === t && u && l[u[1]] && l[u[1]].transition) return n({
                key: r,
                value: o,
                valueSpec: s.transition,
                style: i,
                styleSpec: s
            });
            const c = e1.valueSpec || l[a];
            if (!c) return [
                new Fe(r, o, `unknown property "${a}"`)
            ];
            let h;
            if ("string" === Gn(o) && Un(c) && !c.tokens && (h = /^{([^}]+)}$/.exec(o))) return [
                new Fe(r, o, `"${a}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(h[1])} }\`.`)
            ];
            const p = [];
            return "symbol" === e1.layerType && "text-font" === a && Xn(Ai(o)) && "identity" === Si(o.type) && p.push(new Fe(r, o, '"text-font" does not support identity functions')), p.concat(n({
                key: e1.key,
                value: o,
                valueSpec: c,
                style: i,
                styleSpec: s,
                expressionContext: "property",
                propertyType: t,
                propertyKey: a
            }));
        }
        function Vi(e1) {
            return zi(e1, "paint");
        }
        function Ci(e1) {
            return zi(e1, "layout");
        }
        function Li(e1) {
            let t = [];
            const r = e1.value, n = e1.key, i = e1.style, s = e1.styleSpec;
            if ("object" !== Gn(r)) return [
                new Fe(n, r, `object expected, ${Gn(r)} found`)
            ];
            r.type || r.ref || t.push(new Fe(n, r, 'either "type" or "ref" is required'));
            let o = Si(r.type);
            const a = Si(r.ref);
            if (r.id) {
                const s = Si(r.id);
                for(let o = 0; o < e1.arrayIndex; o++){
                    const e1 = i.layers[o];
                    Si(e1.id) === s && t.push(new Fe(n, r.id, `duplicate layer id "${r.id}", previously used at line ${e1.id.__line__}`));
                }
            }
            if ("ref" in r) {
                let e1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((e1)=>{
                    e1 in r && t.push(new Fe(n, r[e1], `"${e1}" is prohibited for ref layers`));
                }), i.layers.forEach((t)=>{
                    Si(t.id) === a && (e1 = t);
                }), e1 ? e1.ref ? t.push(new Fe(n, r.ref, "ref cannot reference another ref layer")) : o = Si(e1.type) : t.push(new Fe(n, r.ref, `ref layer "${a}" not found`));
            } else if ("background" !== o) {
                if (r.source) {
                    const e1 = i.sources && i.sources[r.source], s = e1 && Si(e1.type);
                    e1 ? "vector" === s && "raster" === o ? t.push(new Fe(n, r.source, `layer "${r.id}" requires a raster source`)) : "raster-dem" !== s && "hillshade" === o || "raster-dem" !== s && "color-relief" === o ? t.push(new Fe(n, r.source, `layer "${r.id}" requires a raster-dem source`)) : "raster" === s && "raster" !== o ? t.push(new Fe(n, r.source, `layer "${r.id}" requires a vector source`)) : "vector" !== s || r["source-layer"] ? "raster-dem" === s && "hillshade" !== o && "color-relief" !== o ? t.push(new Fe(n, r.source, "raster-dem source can only be used with layer type 'hillshade' or 'color-relief'.")) : "line" !== o || !r.paint || !r.paint["line-gradient"] || "geojson" === s && e1.lineMetrics || t.push(new Fe(n, r, `layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : t.push(new Fe(n, r, `layer "${r.id}" must specify a "source-layer"`)) : t.push(new Fe(n, r.source, `source "${r.source}" not found`));
                } else t.push(new Fe(n, r, 'missing required property "source"'));
            }
            return t = t.concat(Ti({
                key: n,
                value: r,
                valueSpec: s.layer,
                style: e1.style,
                styleSpec: e1.styleSpec,
                validateSpec: e1.validateSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>e1.validateSpec({
                            key: `${n}.type`,
                            value: r.type,
                            valueSpec: s.layer.type,
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            validateSpec: e1.validateSpec,
                            object: r,
                            objectKey: "type"
                        }),
                    filter: Pi,
                    layout: (e1)=>Ti({
                            layer: r,
                            key: e1.key,
                            value: e1.value,
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            validateSpec: e1.validateSpec,
                            objectElementValidators: {
                                "*": (e1)=>Ci(De({
                                        layerType: o
                                    }, e1))
                            }
                        }),
                    paint: (e1)=>Ti({
                            layer: r,
                            key: e1.key,
                            value: e1.value,
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            validateSpec: e1.validateSpec,
                            objectElementValidators: {
                                "*": (e1)=>Vi(De({
                                        layerType: o
                                    }, e1))
                            }
                        })
                }
            })), t;
        }
        function Oi(e1) {
            const t = e1.value, r = e1.key, n = Gn(t);
            return "string" !== n ? [
                new Fe(r, t, `string expected, ${n} found`)
            ] : [];
        }
        const Ri = {
            promoteId: function({ key: e1, value: t }) {
                if ("string" === Gn(t)) return Oi({
                    key: e1,
                    value: t
                });
                {
                    const r = [];
                    for(const n in t)r.push(...Oi({
                        key: `${e1}.${n}`,
                        value: t[n]
                    }));
                    return r;
                }
            }
        };
        function Ni(e1) {
            const t = e1.value, r = e1.key, n = e1.styleSpec, i = e1.style, s = e1.validateSpec;
            if (!t.type) return [
                new Fe(r, t, '"type" is required')
            ];
            const o = Si(t.type);
            let a;
            switch(o){
                case "vector":
                case "raster":
                    return a = Ti({
                        key: r,
                        value: t,
                        valueSpec: n[`source_${o.replace("-", "_")}`],
                        style: e1.style,
                        styleSpec: n,
                        objectElementValidators: Ri,
                        validateSpec: s
                    }), a;
                case "raster-dem":
                    return a = function(e1) {
                        var t;
                        const r = null !== (t = e1.sourceName) && void 0 !== t ? t : "", n = e1.value, i = e1.styleSpec, s = i.source_raster_dem, o = e1.style;
                        let a = [];
                        const l = Gn(n);
                        if (void 0 === n) return a;
                        if ("object" !== l) return a.push(new Fe("source_raster_dem", n, `object expected, ${l} found`)), a;
                        const u = "custom" === Si(n.encoding), c = [
                            "redFactor",
                            "greenFactor",
                            "blueFactor",
                            "baseShift"
                        ], h = e1.value.encoding ? `"${e1.value.encoding}"` : "Default";
                        for(const t in n)!u && c.includes(t) ? a.push(new Fe(t, n[t], `In "${r}": "${t}" is only valid when "encoding" is set to "custom". ${h} encoding found`)) : s[t] ? a = a.concat(e1.validateSpec({
                            key: t,
                            value: n[t],
                            valueSpec: s[t],
                            validateSpec: e1.validateSpec,
                            style: o,
                            styleSpec: i
                        })) : a.push(new Fe(t, n[t], `unknown property "${t}"`));
                        return a;
                    }({
                        sourceName: r,
                        value: t,
                        style: e1.style,
                        styleSpec: n,
                        validateSpec: s
                    }), a;
                case "geojson":
                    if (a = Ti({
                        key: r,
                        value: t,
                        valueSpec: n.source_geojson,
                        style: i,
                        styleSpec: n,
                        validateSpec: s,
                        objectElementValidators: Ri
                    }), t.cluster) for(const e1 in t.clusterProperties){
                        const [n, i] = t.clusterProperties[e1], s = "string" == typeof n ? [
                            n,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                e1
                            ]
                        ] : n;
                        a.push(...ki({
                            key: `${r}.${e1}.map`,
                            value: i,
                            expressionContext: "cluster-map"
                        })), a.push(...ki({
                            key: `${r}.${e1}.reduce`,
                            value: s,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return a;
                case "video":
                    return Ti({
                        key: r,
                        value: t,
                        valueSpec: n.source_video,
                        style: i,
                        validateSpec: s,
                        styleSpec: n
                    });
                case "image":
                    return Ti({
                        key: r,
                        value: t,
                        valueSpec: n.source_image,
                        style: i,
                        validateSpec: s,
                        styleSpec: n
                    });
                case "canvas":
                    return [
                        new Fe(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return Di({
                        key: `${r}.type`,
                        value: t.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        }
                    });
            }
        }
        function $i(e1) {
            const t = e1.value, r = e1.styleSpec, n = r.light, i = e1.style;
            let s = [];
            const o = Gn(t);
            if (void 0 === t) return s;
            if ("object" !== o) return s = s.concat([
                new Fe("light", t, `object expected, ${o} found`)
            ]), s;
            for(const o in t){
                const a = o.match(/^(.*)-transition$/);
                s = s.concat(a && n[a[1]] && n[a[1]].transition ? e1.validateSpec({
                    key: o,
                    value: t[o],
                    valueSpec: r.transition,
                    validateSpec: e1.validateSpec,
                    style: i,
                    styleSpec: r
                }) : n[o] ? e1.validateSpec({
                    key: o,
                    value: t[o],
                    valueSpec: n[o],
                    validateSpec: e1.validateSpec,
                    style: i,
                    styleSpec: r
                }) : [
                    new Fe(o, t[o], `unknown property "${o}"`)
                ]);
            }
            return s;
        }
        function Ui(e1) {
            const t = e1.value, r = e1.styleSpec, n = r.sky, i = e1.style, s = Gn(t);
            if (void 0 === t) return [];
            if ("object" !== s) return [
                new Fe("sky", t, `object expected, ${s} found`)
            ];
            let o = [];
            for(const s in t)o = o.concat(n[s] ? e1.validateSpec({
                key: s,
                value: t[s],
                valueSpec: n[s],
                style: i,
                styleSpec: r
            }) : [
                new Fe(s, t[s], `unknown property "${s}"`)
            ]);
            return o;
        }
        function qi(e1) {
            const t = e1.value, r = e1.styleSpec, n = r.terrain, i = e1.style;
            let s = [];
            const o = Gn(t);
            if (void 0 === t) return s;
            if ("object" !== o) return s = s.concat([
                new Fe("terrain", t, `object expected, ${o} found`)
            ]), s;
            for(const o in t)s = s.concat(n[o] ? e1.validateSpec({
                key: o,
                value: t[o],
                valueSpec: n[o],
                validateSpec: e1.validateSpec,
                style: i,
                styleSpec: r
            }) : [
                new Fe(o, t[o], `unknown property "${o}"`)
            ]);
            return s;
        }
        function ji(e1) {
            let t = [];
            const r = e1.value, n = e1.key;
            if (Array.isArray(r)) {
                const i = [], s = [];
                for(const o in r)r[o].id && i.includes(r[o].id) && t.push(new Fe(n, r, `all the sprites' ids must be unique, but ${r[o].id} is duplicated`)), i.push(r[o].id), r[o].url && s.includes(r[o].url) && t.push(new Fe(n, r, `all the sprites' URLs must be unique, but ${r[o].url} is duplicated`)), s.push(r[o].url), t = t.concat(Ti({
                    key: `${n}[${o}]`,
                    value: r[o],
                    valueSpec: {
                        id: {
                            type: "string",
                            required: !0
                        },
                        url: {
                            type: "string",
                            required: !0
                        }
                    },
                    validateSpec: e1.validateSpec
                }));
                return t;
            }
            return Oi({
                key: n,
                value: r
            });
        }
        function Gi(e1) {
            var t;
            return t = e1.value, Boolean(t) && t.constructor === Object ? [] : [
                new Fe(e1.key, e1.value, `object expected, ${Gn(e1.value)} found`)
            ];
        }
        const Xi = {
            "*": ()=>[],
            array: Ii,
            boolean: function(e1) {
                const t = e1.value, r = e1.key, n = Gn(t);
                return "boolean" !== n ? [
                    new Fe(r, t, `boolean expected, ${n} found`)
                ] : [];
            },
            number: Ei,
            color: Fi,
            constants: _i,
            enum: Di,
            filter: Pi,
            function: Mi,
            layer: Li,
            object: Ti,
            source: Ni,
            light: $i,
            sky: Ui,
            terrain: qi,
            projection: function(e1) {
                const t = e1.value, r = e1.styleSpec, n = r.projection, i = e1.style, s = Gn(t);
                if (void 0 === t) return [];
                if ("object" !== s) return [
                    new Fe("projection", t, `object expected, ${s} found`)
                ];
                let o = [];
                for(const s in t)o = o.concat(n[s] ? e1.validateSpec({
                    key: s,
                    value: t[s],
                    valueSpec: n[s],
                    style: i,
                    styleSpec: r
                }) : [
                    new Fe(s, t[s], `unknown property "${s}"`)
                ]);
                return o;
            },
            projectionDefinition: function(e1) {
                const t = e1.key;
                let r = e1.value;
                r = r instanceof String ? r.valueOf() : r;
                const n = Gn(r);
                return "array" !== n || function(e1) {
                    return Array.isArray(e1) && 3 === e1.length && "string" == typeof e1[0] && "string" == typeof e1[1] && "number" == typeof e1[2];
                }(r) || function(e1) {
                    return !![
                        "interpolate",
                        "step",
                        "literal"
                    ].includes(e1[0]);
                }(r) ? [
                    "array",
                    "string"
                ].includes(n) ? [] : [
                    new Fe(t, r, `projection expected, invalid type "${n}" found`)
                ] : [
                    new Fe(t, r, `projection expected, invalid array ${JSON.stringify(r)} found`)
                ];
            },
            string: Oi,
            formatted: function(e1) {
                return 0 === Oi(e1).length ? [] : ki(e1);
            },
            resolvedImage: function(e1) {
                return 0 === Oi(e1).length ? [] : ki(e1);
            },
            padding: function(e1) {
                const t = e1.key, r = e1.value;
                if ("array" === Gn(r)) {
                    if (r.length < 1 || r.length > 4) return [
                        new Fe(t, r, `padding requires 1 to 4 values; ${r.length} values found`)
                    ];
                    const n = {
                        type: "number"
                    };
                    let i = [];
                    for(let s = 0; s < r.length; s++)i = i.concat(e1.validateSpec({
                        key: `${t}[${s}]`,
                        value: r[s],
                        validateSpec: e1.validateSpec,
                        valueSpec: n
                    }));
                    return i;
                }
                return Ei({
                    key: t,
                    value: r,
                    valueSpec: {}
                });
            },
            numberArray: function(e1) {
                const t = e1.key, r = e1.value;
                if ("array" === Gn(r)) {
                    const n = {
                        type: "number"
                    };
                    if (r.length < 1) return [
                        new Fe(t, r, "array length at least 1 expected, length 0 found")
                    ];
                    let i = [];
                    for(let s = 0; s < r.length; s++)i = i.concat(e1.validateSpec({
                        key: `${t}[${s}]`,
                        value: r[s],
                        validateSpec: e1.validateSpec,
                        valueSpec: n
                    }));
                    return i;
                }
                return Ei({
                    key: t,
                    value: r,
                    valueSpec: {}
                });
            },
            colorArray: function(e1) {
                const t = e1.key, r = e1.value;
                if ("array" === Gn(r)) {
                    if (r.length < 1) return [
                        new Fe(t, r, "array length at least 1 expected, length 0 found")
                    ];
                    let e1 = [];
                    for(let n = 0; n < r.length; n++)e1 = e1.concat(Fi({
                        key: `${t}[${n}]`,
                        value: r[n]
                    }));
                    return e1;
                }
                return Fi({
                    key: t,
                    value: r
                });
            },
            variableAnchorOffsetCollection: function(e1) {
                const t = e1.key, r = e1.value, n = Gn(r), i = e1.styleSpec;
                if ("array" !== n || r.length < 1 || r.length % 2 != 0) return [
                    new Fe(t, r, "variableAnchorOffsetCollection requires a non-empty array of even length")
                ];
                let s = [];
                for(let n = 0; n < r.length; n += 2)s = s.concat(Di({
                    key: `${t}[${n}]`,
                    value: r[n],
                    valueSpec: i.layout_symbol["text-anchor"]
                })), s = s.concat(Ii({
                    key: `${t}[${n + 1}]`,
                    value: r[n + 1],
                    valueSpec: {
                        length: 2,
                        value: "number"
                    },
                    validateSpec: e1.validateSpec,
                    style: e1.style,
                    styleSpec: i
                }));
                return s;
            },
            sprite: ji,
            state: Gi
        };
        function Yi(e1) {
            const t = e1.value, r = e1.valueSpec, n = e1.styleSpec;
            return e1.validateSpec = Yi, r.expression && Xn(Si(t)) ? Mi(e1) : r.expression && ti(Ai(t)) ? ki(e1) : r.type && Xi[r.type] ? Xi[r.type](e1) : Ti(De({}, e1, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function Zi(e1) {
            const t = e1.value, r = e1.key, n = Oi(e1);
            return n.length || (-1 === t.indexOf("{fontstack}") && n.push(new Fe(r, t, '"glyphs" url must include a "{fontstack}" token')), -1 === t.indexOf("{range}") && n.push(new Fe(r, t, '"glyphs" url must include a "{range}" token'))), n;
        }
        function Hi(e1, t = xe) {
            let r = [];
            return r = r.concat(Yi({
                key: "",
                value: e1,
                valueSpec: t.$root,
                styleSpec: t,
                style: e1,
                validateSpec: Yi,
                objectElementValidators: {
                    glyphs: Zi,
                    "*": ()=>[]
                }
            })), e1.constants && (r = r.concat(_i({
                key: "constants",
                value: e1.constants
            }))), Wi(r);
        }
        function Ki(e1) {
            return function(t) {
                return e1(Object.assign({}, t, {
                    validateSpec: Yi
                }));
            };
        }
        function Wi(e1) {
            return [].concat(e1).sort((e1, t)=>e1.line - t.line);
        }
        function Ji(e1) {
            return function(...t) {
                return Wi(e1.apply(this, t));
            };
        }
        Hi.source = Ji(Ki(Ni)), Hi.sprite = Ji(Ki(ji)), Hi.glyphs = Ji(Ki(Zi)), Hi.light = Ji(Ki($i)), Hi.sky = Ji(Ki(Ui)), Hi.terrain = Ji(Ki(qi)), Hi.state = Ji(Ki(Gi)), Hi.layer = Ji(Ki(Li)), Hi.filter = Ji(Ki(Pi)), Hi.paintProperty = Ji(Ki(Vi)), Hi.layoutProperty = Ji(Ki(Ci));
        const Qi = xe, es = Hi, ts = es.light, rs = es.sky, ns = es.paintProperty, is = es.layoutProperty;
        function ss(e1, t) {
            let r = !1;
            if (t && t.length) for (const n of t)e1.fire(new me(new Error(n.message))), r = !0;
            return r;
        }
        class os {
            constructor(e1, t, r){
                const n = this.cells = [];
                if (e1 instanceof ArrayBuffer) {
                    this.arrayBuffer = e1;
                    const i = new Int32Array(this.arrayBuffer);
                    e1 = i[0], this.d = (t = i[1]) + 2 * (r = i[2]);
                    for(let e1 = 0; e1 < this.d * this.d; e1++){
                        const t = i[3 + e1], r = i[3 + e1 + 1];
                        n.push(t === r ? null : i.subarray(t, r));
                    }
                    const s = i[3 + n.length + 1];
                    this.keys = i.subarray(i[3 + n.length], s), this.bboxes = i.subarray(s), this.insert = this._insertReadonly;
                } else {
                    this.d = t + 2 * r;
                    for(let e1 = 0; e1 < this.d * this.d; e1++)n.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = t, this.extent = e1, this.padding = r, this.scale = t / e1, this.uid = 0;
                const i = r / t * e1;
                this.min = -i, this.max = e1 + i;
            }
            insert(e1, t, r, n, i) {
                this._forEachCell(t, r, n, i, this._insertCell, this.uid++, void 0, void 0), this.keys.push(e1), this.bboxes.push(t), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }
            _insertReadonly() {
                throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
            }
            _insertCell(e1, t, r, n, i, s) {
                this.cells[i].push(s);
            }
            query(e1, t, r, n, i) {
                const s = this.min, o = this.max;
                if (e1 <= s && t <= s && o <= r && o <= n && !i) return Array.prototype.slice.call(this.keys);
                {
                    const s = [];
                    return this._forEachCell(e1, t, r, n, this._queryCell, s, {}, i), s;
                }
            }
            _queryCell(e1, t, r, n, i, s, o, a) {
                const l = this.cells[i];
                if (null !== l) {
                    const i = this.keys, u = this.bboxes;
                    for(let c = 0; c < l.length; c++){
                        const h = l[c];
                        if (void 0 === o[h]) {
                            const l = 4 * h;
                            (a ? a(u[l + 0], u[l + 1], u[l + 2], u[l + 3]) : e1 <= u[l + 2] && t <= u[l + 3] && r >= u[l + 0] && n >= u[l + 1]) ? (o[h] = !0, s.push(i[h])) : o[h] = !1;
                        }
                    }
                }
            }
            _forEachCell(e1, t, r, n, i, s, o, a) {
                const l = this._convertToCellCoord(e1), u = this._convertToCellCoord(t), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n);
                for(let p = l; p <= c; p++)for(let l = u; l <= h; l++){
                    const u = this.d * l + p;
                    if ((!a || a(this._convertFromCellCoord(p), this._convertFromCellCoord(l), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(l + 1))) && i.call(this, e1, t, r, n, u, s, o, a)) return;
                }
            }
            _convertFromCellCoord(e1) {
                return (e1 - this.padding) / this.scale;
            }
            _convertToCellCoord(e1) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(e1 * this.scale) + this.padding));
            }
            toArrayBuffer() {
                if (this.arrayBuffer) return this.arrayBuffer;
                const e1 = this.cells, t = 3 + this.cells.length + 1 + 1;
                let r = 0;
                for(let e1 = 0; e1 < this.cells.length; e1++)r += this.cells[e1].length;
                const n = new Int32Array(t + r + this.keys.length + this.bboxes.length);
                n[0] = this.extent, n[1] = this.n, n[2] = this.padding;
                let i = t;
                for(let t = 0; t < e1.length; t++){
                    const r = e1[t];
                    n[3 + t] = i, n.set(r, i), i += r.length;
                }
                return n[3 + e1.length] = i, n.set(this.keys, i), i += this.keys.length, n[3 + e1.length + 1] = i, n.set(this.bboxes, i), i += this.bboxes.length, n.buffer;
            }
            static serialize(e1, t) {
                const r = e1.toArrayBuffer();
                return t && t.push(r), {
                    buffer: r
                };
            }
            static deserialize(e1) {
                return new os(e1.buffer);
            }
        }
        const as = {};
        function ls(e1, t, r = {}) {
            if (as[e1]) throw new Error(`${e1} is already registered.`);
            Object.defineProperty(t, "_classRegistryKey", {
                value: e1,
                writeable: !1
            }), as[e1] = {
                klass: t,
                omit: r.omit || [],
                shallow: r.shallow || []
            };
        }
        ls("Object", Object), ls("Set", Set), ls("TransferableGridIndex", os), ls("Color", It), ls("Error", Error), ls("AJAXError", ue), ls("ResolvedImage", Lt), ls("StylePropertyFunction", oi), ls("StyleExpression", ei, {
            omit: [
                "_evaluator"
            ]
        }), ls("ZoomDependentExpression", ii), ls("ZoomConstantExpression", ni), ls("CompoundExpression", Dn, {
            omit: [
                "_evaluate"
            ]
        });
        for(const e1 in Fn)Fn[e1]._classRegistryKey || ls(`Expression_${e1}`, Fn[e1]);
        function us(e1) {
            return e1 && "undefined" != typeof ArrayBuffer && (e1 instanceof ArrayBuffer || e1.constructor && "ArrayBuffer" === e1.constructor.name);
        }
        function cs(e1) {
            return e1.$name || e1.constructor._classRegistryKey;
        }
        function hs(e1) {
            return !function(e1) {
                if (null === e1 || "object" != typeof e1) return !1;
                const t = cs(e1);
                return !(!t || "Object" === t);
            }(e1) && (null == e1 || "boolean" == typeof e1 || "number" == typeof e1 || "string" == typeof e1 || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String || e1 instanceof Date || e1 instanceof RegExp || e1 instanceof Blob || e1 instanceof Error || us(e1) || Z(e1) || ArrayBuffer.isView(e1) || e1 instanceof ImageData);
        }
        function ps(e1, t) {
            if (hs(e1)) return (us(e1) || Z(e1)) && t && t.push(e1), ArrayBuffer.isView(e1) && t && t.push(e1.buffer), e1 instanceof ImageData && t && t.push(e1.data.buffer), e1;
            if (Array.isArray(e1)) {
                const r = [];
                for (const n of e1)r.push(ps(n, t));
                return r;
            }
            if ("object" != typeof e1) throw new Error("can't serialize object of type " + typeof e1);
            const r = cs(e1);
            if (!r) throw new Error(`can't serialize object of unregistered class ${e1.constructor.name}`);
            if (!as[r]) throw new Error(`${r} is not registered.`);
            const { klass: n } = as[r], i = n.serialize ? n.serialize(e1, t) : {};
            if (n.serialize) {
                if (t && i === t[t.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
            } else {
                for(const n in e1){
                    if (!e1.hasOwnProperty(n)) continue;
                    if (as[r].omit.indexOf(n) >= 0) continue;
                    const s = e1[n];
                    i[n] = as[r].shallow.indexOf(n) >= 0 ? s : ps(s, t);
                }
                e1 instanceof Error && (i.message = e1.message);
            }
            if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
            return "Object" !== r && (i.$name = r), i;
        }
        function fs(e1) {
            if (hs(e1)) return e1;
            if (Array.isArray(e1)) return e1.map(fs);
            if ("object" != typeof e1) throw new Error("can't deserialize object of type " + typeof e1);
            const t = cs(e1) || "Object";
            if (!as[t]) throw new Error(`can't deserialize unregistered class ${t}`);
            const { klass: r } = as[t];
            if (!r) throw new Error(`can't deserialize unregistered class ${t}`);
            if (r.deserialize) return r.deserialize(e1);
            const n = Object.create(r.prototype);
            for (const r of Object.keys(e1)){
                if ("$name" === r) continue;
                const i = e1[r];
                n[r] = as[t].shallow.indexOf(r) >= 0 ? i : fs(i);
            }
            return n;
        }
        class ds {
            constructor(){
                this.first = !0;
            }
            update(e1, t) {
                const r = Math.floor(e1);
                return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = e1, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = t) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = t), e1 !== this.lastZoom && (this.lastZoom = e1, this.lastFloorZoom = r, !0));
            }
        }
        function ys(e1) {
            return /[\u02EA\u02EB\u2E80-\u2FDF\u2FF0-\u303F\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FD-\u30FF\u3105-\u312F\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(e1));
        }
        function ms(e1) {
            return /[\u02EA\u02EB\u1100-\u11FF\u1400-\u167F\u18B0-\u18F5\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u3007\u3012\u3013\u3020-\u302F\u3031-\u303F\u3041-\u3096\u309D-\u30FB\u30FD-\u30FF\u3105-\u312F\u3131-\u318E\u3190-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE48\uFE50-\uFE57\uFE5F-\uFE62\uFE67-\uFE6F\uFF00-\uFF07\uFF0A-\uFF0C\uFF0E-\uFF19\uFF1F-\uFF3A\uFF3C\uFF3E\uFF40-\uFF5A\uFFE0-\uFFE2\uFFE4-\uFFE7]|\uD802[\uDD80-\uDD9F]|\uD805[\uDD80-\uDDFF]|\uD806[\uDE00-\uDEBF]|\uD811[\uDC00-\uDE7F]|\uD81B[\uDFE0-\uDFE4\uDFF0-\uDFF6]|[\uD81C-\uD822\uD83D\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD30-\uDEFB]|\uD833[\uDEC0-\uDFCF]|\uD834[\uDC00-\uDDFF\uDEE0-\uDF7F]|\uD836[\uDC00-\uDEAF]|\uD83C[\uDC00-\uDE00\uDF00-\uDFFF]|\uD83E[\uDD00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(e1));
        }
        function gs(e1) {
            return /\s/u.test(String.fromCodePoint(e1));
        }
        function xs(e1) {
            for (const t of e1)if (ms(t.codePointAt(0))) return !0;
            return !1;
        }
        function vs(e1) {
            for (const t of e1)if (!_s(t.codePointAt(0))) return !1;
            return !0;
        }
        function bs(e1) {
            const t = e1.map((e1)=>{
                try {
                    return new RegExp(`\\p{sc=${e1}}`, "u").source;
                } catch (e1) {
                    return null;
                }
            }).filter((e1)=>e1);
            return new RegExp(t.join("|"), "u");
        }
        const ws = bs([
            "Arab",
            "Dupl",
            "Mong",
            "Ougr",
            "Syrc"
        ]);
        function _s(e1) {
            return !ws.test(String.fromCodePoint(e1));
        }
        function Ss(e1) {
            var t;
            return !(ms(e1) || (t = e1, /[\xA7\xA9\xAE\xB1\xBC-\xBE\xD7\xF7\u2016\u2020\u2021\u2030\u2031\u203B\u203C\u2042\u2047-\u2049\u2051\u2100-\u218F\u221E\u2234\u2235\u2300-\u2307\u230C-\u231F\u2324-\u2328\u232B\u237D-\u239A\u23BE-\u23CD\u23CF\u23D1-\u23DB\u23E2-\u2422\u2424-\u24FF\u25A0-\u2619\u2620-\u2767\u2776-\u2793\u2B12-\u2B2F\u2B50-\u2B59\u2BB8-\u2BEB\u3000-\u303F\u30A0-\u30FF\uE000-\uF8FF\uFE30-\uFE6F\uFF00-\uFFEF\uFFFC\uFFFD]|[\uDB80-\uDBFF][\uDC00-\uDFFF]/gim.test(String.fromCodePoint(t))));
        }
        const As = bs([
            "Adlm",
            "Arab",
            "Armi",
            "Avst",
            "Chrs",
            "Cprt",
            "Egyp",
            "Elym",
            "Gara",
            "Hatr",
            "Hebr",
            "Hung",
            "Khar",
            "Lydi",
            "Mand",
            "Mani",
            "Mend",
            "Merc",
            "Mero",
            "Narb",
            "Nbat",
            "Nkoo",
            "Orkh",
            "Palm",
            "Phli",
            "Phlp",
            "Phnx",
            "Prti",
            "Rohg",
            "Samr",
            "Sarb",
            "Sogo",
            "Syrc",
            "Thaa",
            "Todr",
            "Yezi"
        ]);
        function Ts(e1) {
            return As.test(String.fromCodePoint(e1));
        }
        function Is(e1, t) {
            return !(!t && Ts(e1) || /[\u0900-\u0DFF\u0F00-\u109F\u1780-\u17FF]/gim.test(String.fromCodePoint(e1)));
        }
        function Es(e1) {
            for (const t of e1)if (Ts(t.codePointAt(0))) return !0;
            return !1;
        }
        const Ms = new class {
            constructor(){
                this.TIMEOUT = 5e3, this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null, this.loadScriptResolve = ()=>{};
            }
            setState(e1) {
                this.pluginStatus = e1.pluginStatus, this.pluginURL = e1.pluginURL;
            }
            getState() {
                return {
                    pluginStatus: this.pluginStatus,
                    pluginURL: this.pluginURL
                };
            }
            setMethods(e1) {
                if (Ms.isParsed()) throw new Error("RTL text plugin already registered.");
                this.applyArabicShaping = e1.applyArabicShaping, this.processBidirectionalText = e1.processBidirectionalText, this.processStyledBidirectionalText = e1.processStyledBidirectionalText, this.loadScriptResolve();
            }
            isParsed() {
                return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
            }
            getRTLTextPluginStatus() {
                return this.pluginStatus;
            }
            syncState(e1, r) {
                return t(this, void 0, void 0, function*() {
                    if (this.isParsed()) return this.getState();
                    if ("loading" !== e1.pluginStatus) return this.setState(e1), e1;
                    const t = e1.pluginURL, n = new Promise((e1)=>{
                        this.loadScriptResolve = e1;
                    });
                    r(t);
                    const i = new Promise((e1)=>setTimeout(()=>e1(), this.TIMEOUT));
                    if (yield Promise.race([
                        n,
                        i
                    ]), this.isParsed()) {
                        const e1 = {
                            pluginStatus: "loaded",
                            pluginURL: t
                        };
                        return this.setState(e1), e1;
                    }
                    throw this.setState({
                        pluginStatus: "error",
                        pluginURL: ""
                    }), new Error(`RTL Text Plugin failed to import scripts from ${t}`);
                });
            }
        };
        class ks {
            constructor(e1, t){
                this.isSupportedScript = Fs, this.zoom = e1, t ? (this.now = t.now || 0, this.fadeDuration = t.fadeDuration || 0, this.zoomHistory = t.zoomHistory || new ds, this.transition = t.transition || {}) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new ds, this.transition = {});
            }
            crossFadingFactor() {
                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
            }
            getCrossfadeParameters() {
                const e1 = this.zoom, t = e1 - Math.floor(e1), r = this.crossFadingFactor();
                return e1 > this.zoomHistory.lastIntegerZoom ? {
                    fromScale: 2,
                    toScale: 1,
                    t: t + (1 - t) * r
                } : {
                    fromScale: .5,
                    toScale: 1,
                    t: 1 - (1 - r) * t
                };
            }
        }
        function Fs(e1) {
            return function(e1, t) {
                for (const r of e1)if (!Is(r.codePointAt(0), t)) return !1;
                return !0;
            }(e1, "loaded" === Ms.getRTLTextPluginStatus());
        }
        const Ds = "-transition";
        class Ps {
            constructor(e1, t, r){
                this.property = e1, this.value = t, this.expression = function(e1, t, r) {
                    if (Xn(e1)) return new oi(e1, t);
                    if (ti(e1)) {
                        const n = si(e1, t, r);
                        if ("error" === n.result) throw new Error(n.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                        return n.value;
                    }
                    {
                        let r = e1;
                        return "color" === t.type && "string" == typeof e1 ? r = It.parse(e1) : "padding" !== t.type || "number" != typeof e1 && !Array.isArray(e1) ? "numberArray" !== t.type || "number" != typeof e1 && !Array.isArray(e1) ? "colorArray" !== t.type || "string" != typeof e1 && !Array.isArray(e1) ? "variableAnchorOffsetCollection" === t.type && Array.isArray(e1) ? r = Ct.parse(e1) : "projectionDefinition" === t.type && "string" == typeof e1 && (r = Ot.parse(e1)) : r = Bt.parse(e1) : r = Pt.parse(e1) : r = Dt.parse(e1), {
                            globalStateRefs: new Set,
                            _globalState: null,
                            kind: "constant",
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === t ? e1.specification.default : t, e1.specification, r);
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            getGlobalStateRefs() {
                return this.expression.globalStateRefs || new Set;
            }
            possiblyEvaluate(e1, t, r) {
                return this.property.possiblyEvaluate(this, e1, t, r);
            }
        }
        class Bs {
            constructor(e1, t){
                this.property = e1, this.value = new Ps(e1, void 0, t);
            }
            transitioned(e1, t) {
                return new Vs(this.property, this.value, t, O({}, e1.transition, this.transition), e1.now);
            }
            untransitioned() {
                return new Vs(this.property, this.value, null, {}, 0);
            }
        }
        class zs {
            constructor(e1, t){
                this._properties = e1, this._values = Object.create(e1.defaultTransitionablePropertyValues), this._globalState = t;
            }
            getValue(e1) {
                return U(this._values[e1].value.value);
            }
            setValue(e1, t) {
                Object.prototype.hasOwnProperty.call(this._values, e1) || (this._values[e1] = new Bs(this._values[e1].property, this._globalState)), this._values[e1].value = new Ps(this._values[e1].property, null === t ? void 0 : U(t), this._globalState);
            }
            getTransition(e1) {
                return U(this._values[e1].transition);
            }
            setTransition(e1, t) {
                Object.prototype.hasOwnProperty.call(this._values, e1) || (this._values[e1] = new Bs(this._values[e1].property, this._globalState)), this._values[e1].transition = U(t) || void 0;
            }
            serialize() {
                const e1 = {};
                for (const t of Object.keys(this._values)){
                    const r = this.getValue(t);
                    void 0 !== r && (e1[t] = r);
                    const n = this.getTransition(t);
                    void 0 !== n && (e1[`${t}${Ds}`] = n);
                }
                return e1;
            }
            transitioned(e1, t) {
                const r = new Cs(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(e1, t._values[n]);
                return r;
            }
            untransitioned() {
                const e1 = new Cs(this._properties);
                for (const t of Object.keys(this._values))e1._values[t] = this._values[t].untransitioned();
                return e1;
            }
        }
        class Vs {
            constructor(e1, t, r, n, i){
                this.property = e1, this.value = t, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, e1.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            possiblyEvaluate(e1, t, r) {
                const n = e1.now || 0, i = this.value.possiblyEvaluate(e1, t, r), s = this.prior;
                if (s) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return s.possiblyEvaluate(e1, t, r);
                    {
                        const o = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(s.possiblyEvaluate(e1, t, r), i, B(o));
                    }
                }
                return i;
            }
        }
        class Cs {
            constructor(e1){
                this._properties = e1, this._values = Object.create(e1.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(e1, t, r) {
                const n = new Rs(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(e1, t, r);
                return n;
            }
            hasTransition() {
                for (const e1 of Object.keys(this._values))if (this._values[e1].prior) return !0;
                return !1;
            }
        }
        class Ls {
            constructor(e1, t){
                this._properties = e1, this._values = Object.create(e1.defaultPropertyValues), this._globalState = t;
            }
            hasValue(e1) {
                return void 0 !== this._values[e1].value;
            }
            getValue(e1) {
                return U(this._values[e1].value);
            }
            setValue(e1, t) {
                this._values[e1] = new Ps(this._values[e1].property, null === t ? void 0 : U(t), this._globalState);
            }
            serialize() {
                const e1 = {};
                for (const t of Object.keys(this._values)){
                    const r = this.getValue(t);
                    void 0 !== r && (e1[t] = r);
                }
                return e1;
            }
            possiblyEvaluate(e1, t, r) {
                const n = new Rs(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(e1, t, r);
                return n;
            }
        }
        class Os {
            constructor(e1, t, r){
                this.property = e1, this.value = t, this.parameters = r;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(e1) {
                return "constant" === this.value.kind ? this.value.value : e1;
            }
            evaluate(e1, t, r, n) {
                return this.property.evaluate(this.value, this.parameters, e1, t, r, n);
            }
        }
        class Rs {
            constructor(e1){
                this._properties = e1, this._values = Object.create(e1.defaultPossiblyEvaluatedValues);
            }
            get(e1) {
                return this._values[e1];
            }
        }
        class Ns {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t) {
                if (e1.isDataDriven()) throw new Error("Value should not be data driven");
                return e1.expression.evaluate(t);
            }
            interpolate(e1, t, r) {
                const n = dr[this.specification.type];
                return n ? n(e1, t, r) : e1;
            }
        }
        class $s {
            constructor(e1, t){
                this.specification = e1, this.overrides = t;
            }
            possiblyEvaluate(e1, t, r, n) {
                return new Os(this, "constant" === e1.expression.kind || "camera" === e1.expression.kind ? {
                    kind: "constant",
                    value: e1.expression.evaluate(t, null, {}, r, n)
                } : e1.expression, t);
            }
            interpolate(e1, t, r) {
                if ("constant" !== e1.value.kind || "constant" !== t.value.kind) return e1;
                if (void 0 === e1.value.value || void 0 === t.value.value) return new Os(this, {
                    kind: "constant",
                    value: void 0
                }, e1.parameters);
                const n = dr[this.specification.type];
                if (n) {
                    const i = n(e1.value.value, t.value.value, r);
                    return new Os(this, {
                        kind: "constant",
                        value: i
                    }, e1.parameters);
                }
                return e1;
            }
            evaluate(e1, t, r, n, i, s) {
                return "constant" === e1.kind ? e1.value : e1.evaluate(t, r, n, i, s);
            }
        }
        class Us extends $s {
            possiblyEvaluate(e1, t, r, n) {
                if (void 0 === e1.value) return new Os(this, {
                    kind: "constant",
                    value: void 0
                }, t);
                if ("constant" === e1.expression.kind) {
                    const i = e1.expression.evaluate(t, null, {}, r, n), s = "resolvedImage" === e1.property.specification.type && "string" != typeof i ? i.name : i, o = this._calculate(s, s, s, t);
                    return new Os(this, {
                        kind: "constant",
                        value: o
                    }, t);
                }
                if ("camera" === e1.expression.kind) {
                    const r = this._calculate(e1.expression.evaluate({
                        zoom: t.zoom - 1
                    }), e1.expression.evaluate({
                        zoom: t.zoom
                    }), e1.expression.evaluate({
                        zoom: t.zoom + 1
                    }), t);
                    return new Os(this, {
                        kind: "constant",
                        value: r
                    }, t);
                }
                return new Os(this, e1.expression, t);
            }
            evaluate(e1, t, r, n, i, s) {
                if ("source" === e1.kind) {
                    const o = e1.evaluate(t, r, n, i, s);
                    return this._calculate(o, o, o, t);
                }
                return "composite" === e1.kind ? this._calculate(e1.evaluate({
                    zoom: Math.floor(t.zoom) - 1
                }, r, n), e1.evaluate({
                    zoom: Math.floor(t.zoom)
                }, r, n), e1.evaluate({
                    zoom: Math.floor(t.zoom) + 1
                }, r, n), t) : e1.value;
            }
            _calculate(e1, t, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: e1,
                    to: t
                } : {
                    from: r,
                    to: t
                };
            }
            interpolate(e1) {
                return e1;
            }
        }
        class qs {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t, r, n) {
                if (void 0 !== e1.value) {
                    if ("constant" === e1.expression.kind) {
                        const i = e1.expression.evaluate(t, null, {}, r, n);
                        return this._calculate(i, i, i, t);
                    }
                    return this._calculate(e1.expression.evaluate(new ks(Math.floor(t.zoom - 1), t)), e1.expression.evaluate(new ks(Math.floor(t.zoom), t)), e1.expression.evaluate(new ks(Math.floor(t.zoom + 1), t)), t);
                }
            }
            _calculate(e1, t, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: e1,
                    to: t
                } : {
                    from: r,
                    to: t
                };
            }
            interpolate(e1) {
                return e1;
            }
        }
        class js {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t, r, n) {
                return !!e1.expression.evaluate(t, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
        }
        class Gs {
            constructor(e1){
                this.properties = e1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                for(const t in e1){
                    const r = e1[t];
                    r.specification.overridable && this.overridableProperties.push(t);
                    const n = this.defaultPropertyValues[t] = new Ps(r, void 0, void 0), i = this.defaultTransitionablePropertyValues[t] = new Bs(r, void 0);
                    this.defaultTransitioningPropertyValues[t] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[t] = n.possiblyEvaluate({});
                }
            }
        }
        ls("DataDrivenProperty", $s), ls("DataConstantProperty", Ns), ls("CrossFadedDataDrivenProperty", Us), ls("CrossFadedProperty", qs), ls("ColorRampProperty", js);
        class Xs extends ge {
            constructor(e1, t, r){
                if (super(), this.id = e1.id, this.type = e1.type, this._globalState = r, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    getGlobalStateRefs: ()=>new Set
                }, "custom" !== e1.type && (this.metadata = e1.metadata, this.minzoom = e1.minzoom, this.maxzoom = e1.maxzoom, "background" !== e1.type && (this.source = e1.source, this.sourceLayer = e1["source-layer"], this.filter = e1.filter, this._featureFilter = pi(e1.filter, r)), t.layout && (this._unevaluatedLayout = new Ls(t.layout, r)), t.paint)) {
                    this._transitionablePaint = new zs(t.paint, r);
                    for(const t in e1.paint)this.setPaintProperty(t, e1.paint[t], {
                        validate: !1
                    });
                    for(const t in e1.layout)this.setLayoutProperty(t, e1.layout[t], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Rs(t.paint);
                }
            }
            setFilter(e1) {
                this.filter = e1, this._featureFilter = pi(e1, this._globalState);
            }
            getCrossfadeParameters() {
                return this._crossfadeParameters;
            }
            getLayoutProperty(e1) {
                return "visibility" === e1 ? this.visibility : this._unevaluatedLayout.getValue(e1);
            }
            getLayoutAffectingGlobalStateRefs() {
                const e1 = new Set;
                if (this._unevaluatedLayout) for(const t in this._unevaluatedLayout._values){
                    const r = this._unevaluatedLayout._values[t];
                    for (const t of r.getGlobalStateRefs())e1.add(t);
                }
                for (const t of this._featureFilter.getGlobalStateRefs())e1.add(t);
                return e1;
            }
            getPaintAffectingGlobalStateRefs() {
                var e1;
                const t = new globalThis.Map;
                if (this._transitionablePaint) for(const r in this._transitionablePaint._values){
                    const n = this._transitionablePaint._values[r].value;
                    for (const i of n.getGlobalStateRefs()){
                        const s = null !== (e1 = t.get(i)) && void 0 !== e1 ? e1 : [];
                        s.push({
                            name: r,
                            value: n.value
                        }), t.set(i, s);
                    }
                }
                return t;
            }
            setLayoutProperty(e1, t, r = {}) {
                null != t && this._validate(is, `layers.${this.id}.layout.${e1}`, e1, t, r) || ("visibility" !== e1 ? this._unevaluatedLayout.setValue(e1, t) : this.visibility = t);
            }
            getPaintProperty(e1) {
                return e1.endsWith(Ds) ? this._transitionablePaint.getTransition(e1.slice(0, -11)) : this._transitionablePaint.getValue(e1);
            }
            setPaintProperty(e1, t, r = {}) {
                if (null != t && this._validate(ns, `layers.${this.id}.paint.${e1}`, e1, t, r)) return !1;
                if (e1.endsWith(Ds)) return this._transitionablePaint.setTransition(e1.slice(0, -11), t || void 0), !1;
                {
                    const r = this._transitionablePaint._values[e1], n = "cross-faded-data-driven" === r.property.specification["property-type"], i = r.value.isDataDriven(), s = r.value;
                    this._transitionablePaint.setValue(e1, t), this._handleSpecialPaintPropertyUpdate(e1);
                    const o = this._transitionablePaint._values[e1].value;
                    return o.isDataDriven() || i || n || this._handleOverridablePaintPropertyUpdate(e1, s, o);
                }
            }
            _handleSpecialPaintPropertyUpdate(e1) {}
            _handleOverridablePaintPropertyUpdate(e1, t, r) {
                return !1;
            }
            isHidden(e1, t = !1) {
                return !!(this.minzoom && e1 < (t ? Math.floor(this.minzoom) : this.minzoom)) || !!(this.maxzoom && e1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(e1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(e1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(e1, t) {
                e1.getCrossfadeParameters && (this._crossfadeParameters = e1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(e1, void 0, t)), this.paint = this._transitioningPaint.possiblyEvaluate(e1, void 0, t);
            }
            serialize() {
                const e1 = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return this.visibility && (e1.layout = e1.layout || {}, e1.layout.visibility = this.visibility), $(e1, (e1, t)=>!(void 0 === e1 || "layout" === t && !Object.keys(e1).length || "paint" === t && !Object.keys(e1).length));
            }
            _validate(e1, t, r, n, i = {}) {
                return (!i || !1 !== i.validate) && ss(this, e1.call(es, {
                    key: t,
                    layerType: this.type,
                    objectKey: r,
                    value: n,
                    styleSpec: xe,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            resize() {}
            isStateDependent() {
                for(const e1 in this.paint._values){
                    const t = this.paint.get(e1);
                    if (t instanceof Os && Un(t.property.specification) && ("source" === t.value.kind || "composite" === t.value.kind) && t.value.isStateDependent) return !0;
                }
                return !1;
            }
        }
        let Ys;
        var Zs = {
            get paint () {
                return Ys = Ys || new Gs({
                    "raster-opacity": new Ns(xe.paint_raster["raster-opacity"]),
                    "raster-hue-rotate": new Ns(xe.paint_raster["raster-hue-rotate"]),
                    "raster-brightness-min": new Ns(xe.paint_raster["raster-brightness-min"]),
                    "raster-brightness-max": new Ns(xe.paint_raster["raster-brightness-max"]),
                    "raster-saturation": new Ns(xe.paint_raster["raster-saturation"]),
                    "raster-contrast": new Ns(xe.paint_raster["raster-contrast"]),
                    "raster-resampling": new Ns(xe.paint_raster["raster-resampling"]),
                    "raster-fade-duration": new Ns(xe.paint_raster["raster-fade-duration"])
                });
            }
        };
        class Hs extends Xs {
            constructor(e1, t){
                super(e1, Zs, t);
            }
        }
        const Ks = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class Ws {
            constructor(e1, t){
                this._structArray = e1, this._pos1 = t * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class Js {
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
            static serialize(e1, t) {
                return e1._trim(), t && (e1.isTransferred = !0, t.push(e1.arrayBuffer)), {
                    length: e1.length,
                    arrayBuffer: e1.arrayBuffer
                };
            }
            static deserialize(e1) {
                const t = Object.create(this.prototype);
                return t.arrayBuffer = e1.arrayBuffer, t.length = e1.length, t.capacity = e1.arrayBuffer.byteLength / t.bytesPerElement, t._refreshViews(), t;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(e1) {
                this.reserve(e1), this.length = e1;
            }
            reserve(e1) {
                if (e1 > this.capacity) {
                    this.capacity = Math.max(e1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const t = this.uint8;
                    this._refreshViews(), t && this.uint8.set(t);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
        }
        function Qs(e1, t = 1) {
            let r = 0, n = 0;
            return {
                members: e1.map((e1)=>{
                    const i = Ks[e1.type].BYTES_PER_ELEMENT, s = r = eo(r, Math.max(t, i)), o = e1.components || 1;
                    return n = Math.max(n, i), r += i * o, {
                        name: e1.name,
                        type: e1.type,
                        components: o,
                        offset: s
                    };
                }),
                size: eo(r, Math.max(n, t)),
                alignment: t
            };
        }
        function eo(e1, t) {
            return Math.ceil(e1 / t) * t;
        }
        class to extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t);
            }
            emplace(e1, t, r) {
                const n = 2 * e1;
                return this.int16[n + 0] = t, this.int16[n + 1] = r, e1;
            }
        }
        to.prototype.bytesPerElement = 4, ls("StructArrayLayout2i4", to);
        class ro extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, r);
            }
            emplace(e1, t, r, n) {
                const i = 3 * e1;
                return this.int16[i + 0] = t, this.int16[i + 1] = r, this.int16[i + 2] = n, e1;
            }
        }
        ro.prototype.bytesPerElement = 6, ls("StructArrayLayout3i6", ro);
        class no extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t, r, n);
            }
            emplace(e1, t, r, n, i) {
                const s = 4 * e1;
                return this.int16[s + 0] = t, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, e1;
            }
        }
        no.prototype.bytesPerElement = 8, ls("StructArrayLayout4i8", no);
        class io extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, r, n, i, s);
            }
            emplace(e1, t, r, n, i, s, o) {
                const a = 6 * e1;
                return this.int16[a + 0] = t, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, this.int16[a + 4] = s, this.int16[a + 5] = o, e1;
            }
        }
        io.prototype.bytesPerElement = 12, ls("StructArrayLayout2i4i12", io);
        class so extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, r, n, i, s);
            }
            emplace(e1, t, r, n, i, s, o) {
                const a = 4 * e1, l = 8 * e1;
                return this.int16[a + 0] = t, this.int16[a + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = s, this.uint8[l + 7] = o, e1;
            }
        }
        so.prototype.bytesPerElement = 8, ls("StructArrayLayout2i4ub8", so);
        class oo extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t);
            }
            emplace(e1, t, r) {
                const n = 2 * e1;
                return this.float32[n + 0] = t, this.float32[n + 1] = r, e1;
            }
        }
        oo.prototype.bytesPerElement = 8, ls("StructArrayLayout2f8", oo);
        class ao extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n, i, s, o, a, l, u) {
                const c = this.length;
                return this.resize(c + 1), this.emplace(c, e1, t, r, n, i, s, o, a, l, u);
            }
            emplace(e1, t, r, n, i, s, o, a, l, u, c) {
                const h = 10 * e1;
                return this.uint16[h + 0] = t, this.uint16[h + 1] = r, this.uint16[h + 2] = n, this.uint16[h + 3] = i, this.uint16[h + 4] = s, this.uint16[h + 5] = o, this.uint16[h + 6] = a, this.uint16[h + 7] = l, this.uint16[h + 8] = u, this.uint16[h + 9] = c, e1;
            }
        }
        ao.prototype.bytesPerElement = 20, ls("StructArrayLayout10ui20", ao);
        class lo extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n, i, s, o, a) {
                const l = this.length;
                return this.resize(l + 1), this.emplace(l, e1, t, r, n, i, s, o, a);
            }
            emplace(e1, t, r, n, i, s, o, a, l) {
                const u = 8 * e1;
                return this.uint16[u + 0] = t, this.uint16[u + 1] = r, this.uint16[u + 2] = n, this.uint16[u + 3] = i, this.uint16[u + 4] = s, this.uint16[u + 5] = o, this.uint16[u + 6] = a, this.uint16[u + 7] = l, e1;
            }
        }
        lo.prototype.bytesPerElement = 16, ls("StructArrayLayout8ui16", lo);
        class uo extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n, i, s, o, a, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, e1, t, r, n, i, s, o, a, l, u, c, h);
            }
            emplace(e1, t, r, n, i, s, o, a, l, u, c, h, p) {
                const f = 12 * e1;
                return this.int16[f + 0] = t, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = s, this.uint16[f + 5] = o, this.uint16[f + 6] = a, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, e1;
            }
        }
        uo.prototype.bytesPerElement = 24, ls("StructArrayLayout4i4ui4i24", uo);
        class co extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, r);
            }
            emplace(e1, t, r, n) {
                const i = 3 * e1;
                return this.float32[i + 0] = t, this.float32[i + 1] = r, this.float32[i + 2] = n, e1;
            }
        }
        co.prototype.bytesPerElement = 12, ls("StructArrayLayout3f12", co);
        class ho extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t = this.length;
                return this.resize(t + 1), this.emplace(t, e1);
            }
            emplace(e1, t) {
                return this.uint32[1 * e1 + 0] = t, e1;
            }
        }
        ho.prototype.bytesPerElement = 4, ls("StructArrayLayout1ul4", ho);
        class po extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n, i, s, o, a, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, e1, t, r, n, i, s, o, a, l);
            }
            emplace(e1, t, r, n, i, s, o, a, l, u) {
                const c = 10 * e1, h = 5 * e1;
                return this.int16[c + 0] = t, this.int16[c + 1] = r, this.int16[c + 2] = n, this.int16[c + 3] = i, this.int16[c + 4] = s, this.int16[c + 5] = o, this.uint32[h + 3] = a, this.uint16[c + 8] = l, this.uint16[c + 9] = u, e1;
            }
        }
        po.prototype.bytesPerElement = 20, ls("StructArrayLayout6i1ul2ui20", po);
        class fo extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, r, n, i, s);
            }
            emplace(e1, t, r, n, i, s, o) {
                const a = 6 * e1;
                return this.int16[a + 0] = t, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, this.int16[a + 4] = s, this.int16[a + 5] = o, e1;
            }
        }
        fo.prototype.bytesPerElement = 12, ls("StructArrayLayout2i2i2i12", fo);
        class yo extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t, r, n, i);
            }
            emplace(e1, t, r, n, i, s) {
                const o = 4 * e1, a = 8 * e1;
                return this.float32[o + 0] = t, this.float32[o + 1] = r, this.float32[o + 2] = n, this.int16[a + 6] = i, this.int16[a + 7] = s, e1;
            }
        }
        yo.prototype.bytesPerElement = 16, ls("StructArrayLayout2f1f2i16", yo);
        class mo extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, r, n, i, s);
            }
            emplace(e1, t, r, n, i, s, o) {
                const a = 16 * e1, l = 4 * e1, u = 8 * e1;
                return this.uint8[a + 0] = t, this.uint8[a + 1] = r, this.float32[l + 1] = n, this.float32[l + 2] = i, this.int16[u + 6] = s, this.int16[u + 7] = o, e1;
            }
        }
        mo.prototype.bytesPerElement = 16, ls("StructArrayLayout2ub2f2i16", mo);
        class go extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, r);
            }
            emplace(e1, t, r, n) {
                const i = 3 * e1;
                return this.uint16[i + 0] = t, this.uint16[i + 1] = r, this.uint16[i + 2] = n, e1;
            }
        }
        go.prototype.bytesPerElement = 6, ls("StructArrayLayout3ui6", go);
        class xo extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n, i, s, o, a, l, u, c, h, p, f, d, y, m) {
                const g = this.length;
                return this.resize(g + 1), this.emplace(g, e1, t, r, n, i, s, o, a, l, u, c, h, p, f, d, y, m);
            }
            emplace(e1, t, r, n, i, s, o, a, l, u, c, h, p, f, d, y, m, g) {
                const x = 24 * e1, v = 12 * e1, b = 48 * e1;
                return this.int16[x + 0] = t, this.int16[x + 1] = r, this.uint16[x + 2] = n, this.uint16[x + 3] = i, this.uint32[v + 2] = s, this.uint32[v + 3] = o, this.uint32[v + 4] = a, this.uint16[x + 10] = l, this.uint16[x + 11] = u, this.uint16[x + 12] = c, this.float32[v + 7] = h, this.float32[v + 8] = p, this.uint8[b + 36] = f, this.uint8[b + 37] = d, this.uint8[b + 38] = y, this.uint32[v + 10] = m, this.int16[x + 22] = g, e1;
            }
        }
        xo.prototype.bytesPerElement = 48, ls("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", xo);
        class vo extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n, i, s, o, a, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, T, I, E) {
                const M = this.length;
                return this.resize(M + 1), this.emplace(M, e1, t, r, n, i, s, o, a, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, T, I, E);
            }
            emplace(e1, t, r, n, i, s, o, a, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, T, I, E, M) {
                const k = 32 * e1, F = 16 * e1;
                return this.int16[k + 0] = t, this.int16[k + 1] = r, this.int16[k + 2] = n, this.int16[k + 3] = i, this.int16[k + 4] = s, this.int16[k + 5] = o, this.int16[k + 6] = a, this.int16[k + 7] = l, this.uint16[k + 8] = u, this.uint16[k + 9] = c, this.uint16[k + 10] = h, this.uint16[k + 11] = p, this.uint16[k + 12] = f, this.uint16[k + 13] = d, this.uint16[k + 14] = y, this.uint16[k + 15] = m, this.uint16[k + 16] = g, this.uint16[k + 17] = x, this.uint16[k + 18] = v, this.uint16[k + 19] = b, this.uint16[k + 20] = w, this.uint16[k + 21] = _, this.uint16[k + 22] = S, this.uint32[F + 12] = A, this.float32[F + 13] = T, this.float32[F + 14] = I, this.uint16[k + 30] = E, this.uint16[k + 31] = M, e1;
            }
        }
        vo.prototype.bytesPerElement = 64, ls("StructArrayLayout8i15ui1ul2f2ui64", vo);
        class bo extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t = this.length;
                return this.resize(t + 1), this.emplace(t, e1);
            }
            emplace(e1, t) {
                return this.float32[1 * e1 + 0] = t, e1;
            }
        }
        bo.prototype.bytesPerElement = 4, ls("StructArrayLayout1f4", bo);
        class wo extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, r);
            }
            emplace(e1, t, r, n) {
                const i = 3 * e1;
                return this.uint16[6 * e1 + 0] = t, this.float32[i + 1] = r, this.float32[i + 2] = n, e1;
            }
        }
        wo.prototype.bytesPerElement = 12, ls("StructArrayLayout1ui2f12", wo);
        class _o extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, r);
            }
            emplace(e1, t, r, n) {
                const i = 4 * e1;
                return this.uint32[2 * e1 + 0] = t, this.uint16[i + 2] = r, this.uint16[i + 3] = n, e1;
            }
        }
        _o.prototype.bytesPerElement = 8, ls("StructArrayLayout1ul2ui8", _o);
        class So extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t);
            }
            emplace(e1, t, r) {
                const n = 2 * e1;
                return this.uint16[n + 0] = t, this.uint16[n + 1] = r, e1;
            }
        }
        So.prototype.bytesPerElement = 4, ls("StructArrayLayout2ui4", So);
        class Ao extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t = this.length;
                return this.resize(t + 1), this.emplace(t, e1);
            }
            emplace(e1, t) {
                return this.uint16[1 * e1 + 0] = t, e1;
            }
        }
        Ao.prototype.bytesPerElement = 2, ls("StructArrayLayout1ui2", Ao);
        class To extends Js {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t, r, n);
            }
            emplace(e1, t, r, n, i) {
                const s = 4 * e1;
                return this.float32[s + 0] = t, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, e1;
            }
        }
        To.prototype.bytesPerElement = 16, ls("StructArrayLayout4f16", To);
        class Io extends Ws {
            get anchorPointX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorPointY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get x1() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get y1() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get x2() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get y2() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get anchorPoint() {
                return new r(this.anchorPointX, this.anchorPointY);
            }
        }
        Io.prototype.size = 20;
        class Eo extends po {
            get(e1) {
                return new Io(this, e1);
            }
        }
        ls("CollisionBoxArray", Eo);
        class Mo extends Ws {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 2];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 4];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 7];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 8];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 36];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 37];
            }
            set placedOrientation(e1) {
                this._structArray.uint8[this._pos1 + 37] = e1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 38];
            }
            set hidden(e1) {
                this._structArray.uint8[this._pos1 + 38] = e1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 10];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 10] = e1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 22];
            }
        }
        Mo.prototype.size = 48;
        class ko extends xo {
            get(e1) {
                return new Mo(this, e1);
            }
        }
        ls("PlacedSymbolArray", ko);
        class Fo extends Ws {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 12];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 12] = e1;
            }
            get textBoxScale() {
                return this._structArray.float32[this._pos4 + 13];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 14];
            }
            get textAnchorOffsetStartIndex() {
                return this._structArray.uint16[this._pos2 + 30];
            }
            get textAnchorOffsetEndIndex() {
                return this._structArray.uint16[this._pos2 + 31];
            }
        }
        Fo.prototype.size = 64;
        class Do extends vo {
            get(e1) {
                return new Fo(this, e1);
            }
        }
        ls("SymbolInstanceArray", Do);
        class Po extends bo {
            getoffsetX(e1) {
                return this.float32[1 * e1 + 0];
            }
        }
        ls("GlyphOffsetArray", Po);
        class Bo extends ro {
            getx(e1) {
                return this.int16[3 * e1 + 0];
            }
            gety(e1) {
                return this.int16[3 * e1 + 1];
            }
            gettileUnitDistanceFromAnchor(e1) {
                return this.int16[3 * e1 + 2];
            }
        }
        ls("SymbolLineVertexArray", Bo);
        class zo extends Ws {
            get textAnchor() {
                return this._structArray.uint16[this._pos2 + 0];
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 2];
            }
        }
        zo.prototype.size = 12;
        class Vo extends wo {
            get(e1) {
                return new zo(this, e1);
            }
        }
        ls("TextAnchorOffsetArray", Vo);
        class Co extends Ws {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
        }
        Co.prototype.size = 8;
        class Lo extends _o {
            get(e1) {
                return new Co(this, e1);
            }
        }
        ls("FeatureIndexArray", Lo);
        class Oo extends to {
        }
        class Ro extends to {
        }
        class No extends to {
        }
        class $o extends io {
        }
        class Uo extends so {
        }
        class qo extends oo {
        }
        class jo extends ao {
        }
        class Go extends lo {
        }
        class Xo extends uo {
        }
        class Yo extends co {
        }
        class Zo extends ho {
        }
        class Ho extends fo {
        }
        class Ko extends mo {
        }
        class Wo extends go {
        }
        class Jo extends So {
        }
        const Qo = Qs([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: ea } = Qo;
        class ta {
            constructor(e1 = []){
                this._forceNewSegmentOnNextPrepare = !1, this.segments = e1;
            }
            prepareSegment(e1, t, r, n) {
                const i = this.segments[this.segments.length - 1];
                return e1 > ta.MAX_VERTEX_ARRAY_LENGTH && j(`Max vertices per segment is ${ta.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${e1}. Consider using the \`fillLargeMeshArrays\` function if you require meshes with more than ${ta.MAX_VERTEX_ARRAY_LENGTH} vertices.`), this._forceNewSegmentOnNextPrepare || !i || i.vertexLength + e1 > ta.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n ? this.createNewSegment(t, r, n) : i;
            }
            createNewSegment(e1, t, r) {
                const n = {
                    vertexOffset: e1.length,
                    primitiveOffset: t.length,
                    vertexLength: 0,
                    primitiveLength: 0,
                    vaos: {}
                };
                return void 0 !== r && (n.sortKey = r), this._forceNewSegmentOnNextPrepare = !1, this.segments.push(n), n;
            }
            getOrCreateLatestSegment(e1, t, r) {
                return this.prepareSegment(0, e1, t, r);
            }
            forceNewSegmentOnNextPrepare() {
                this._forceNewSegmentOnNextPrepare = !0;
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const e1 of this.segments)for(const t in e1.vaos)e1.vaos[t].destroy();
            }
            static simpleSegment(e1, t, r, n) {
                return new ta([
                    {
                        vertexOffset: e1,
                        primitiveOffset: t,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function ra(e1, t) {
            return 256 * (e1 = C(Math.floor(e1), 0, 255)) + C(Math.floor(t), 0, 255);
        }
        ta.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, ls("SegmentVector", ta);
        const na = Qs([
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            }
        ]), ia = Qs([
            {
                name: "a_dasharray_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_dasharray_to",
                components: 4,
                type: "Uint16"
            }
        ]);
        var sa, oa, aa, la = {
            exports: {}
        }, ua = {
            exports: {}
        }, ca = {
            exports: {}
        }, ha = function() {
            if (aa) return la.exports;
            aa = 1;
            var e1 = (sa || (sa = 1, ua.exports = function(e1, t) {
                var r, n, i, s, o, a, l, u;
                for(n = e1.length - (r = 3 & e1.length), i = t, o = 3432918353, a = 461845907, u = 0; u < n;)l = 255 & e1.charCodeAt(u) | (255 & e1.charCodeAt(++u)) << 8 | (255 & e1.charCodeAt(++u)) << 16 | (255 & e1.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s >>> 16) & 65535) << 16);
                switch(l = 0, r){
                    case 3:
                        l ^= (255 & e1.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & e1.charCodeAt(u + 1)) << 8;
                    case 1:
                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & e1.charCodeAt(u))) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295;
                }
                return i ^= e1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            }), ua.exports), t = (oa || (oa = 1, ca.exports = function(e1, t) {
                for(var r, n = e1.length, i = t ^ n, s = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & e1.charCodeAt(s) | (255 & e1.charCodeAt(++s)) << 8 | (255 & e1.charCodeAt(++s)) << 16 | (255 & e1.charCodeAt(++s)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++s;
                switch(n){
                    case 3:
                        i ^= (255 & e1.charCodeAt(s + 2)) << 16;
                    case 2:
                        i ^= (255 & e1.charCodeAt(s + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & e1.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            }), ca.exports);
            return la.exports = e1, la.exports.murmur3 = e1, la.exports.murmur2 = t, la.exports;
        }(), pa = n(ha);
        class fa {
            constructor(){
                this.ids = [], this.positions = [], this.indexed = !1;
            }
            add(e1, t, r, n) {
                this.ids.push(da(e1)), this.positions.push(t, r, n);
            }
            getPositions(e1) {
                if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                const t = da(e1);
                let r = 0, n = this.ids.length - 1;
                for(; r < n;){
                    const e1 = r + n >> 1;
                    this.ids[e1] >= t ? n = e1 : r = e1 + 1;
                }
                const i = [];
                for(; this.ids[r] === t;)i.push({
                    index: this.positions[3 * r],
                    start: this.positions[3 * r + 1],
                    end: this.positions[3 * r + 2]
                }), r++;
                return i;
            }
            static serialize(e1, t) {
                const r = new Float64Array(e1.ids), n = new Uint32Array(e1.positions);
                return ya(r, n, 0, r.length - 1), t && t.push(r.buffer, n.buffer), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(e1) {
                const t = new fa;
                return t.ids = e1.ids, t.positions = e1.positions, t.indexed = !0, t;
            }
        }
        function da(e1) {
            const t = +e1;
            return !isNaN(t) && t <= Number.MAX_SAFE_INTEGER ? t : pa(String(e1));
        }
        function ya(e1, t, r, n) {
            for(; r < n;){
                const i = e1[r + n >> 1];
                let s = r - 1, o = n + 1;
                for(;;){
                    do s++;
                    while (e1[s] < i);
                    do o--;
                    while (e1[o] > i);
                    if (s >= o) break;
                    ma(e1, s, o), ma(t, 3 * s, 3 * o), ma(t, 3 * s + 1, 3 * o + 1), ma(t, 3 * s + 2, 3 * o + 2);
                }
                o - r < n - o ? (ya(e1, t, r, o), r = o + 1) : (ya(e1, t, o + 1, n), n = o);
            }
        }
        function ma(e1, t, r) {
            const n = e1[t];
            e1[t] = e1[r], e1[r] = n;
        }
        ls("FeaturePositionMap", fa);
        class ga {
            constructor(e1, t){
                this.gl = e1.gl, this.location = t;
            }
        }
        class xa extends ga {
            constructor(e1, t){
                super(e1, t), this.current = 0;
            }
            set(e1) {
                this.current !== e1 && (this.current = e1, this.gl.uniform1f(this.location, e1));
            }
        }
        class va extends ga {
            constructor(e1, t){
                super(e1, t), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(e1) {
                e1[0] === this.current[0] && e1[1] === this.current[1] && e1[2] === this.current[2] && e1[3] === this.current[3] || (this.current = e1, this.gl.uniform4f(this.location, e1[0], e1[1], e1[2], e1[3]));
            }
        }
        class ba extends ga {
            constructor(e1, t){
                super(e1, t), this.current = It.transparent;
            }
            set(e1) {
                e1.r === this.current.r && e1.g === this.current.g && e1.b === this.current.b && e1.a === this.current.a || (this.current = e1, this.gl.uniform4f(this.location, e1.r, e1.g, e1.b, e1.a));
            }
        }
        const wa = new Float32Array(16);
        function _a(e1) {
            return [
                ra(255 * e1.r, 255 * e1.g),
                ra(255 * e1.b, 255 * e1.a)
            ];
        }
        class Sa {
            constructor(e1, t, r){
                this.value = e1, this.uniformNames = t.map((e1)=>`u_${e1}`), this.type = r;
            }
            setUniform(e1, t, r) {
                e1.set(r.constantOr(this.value));
            }
            getBinding(e1, t, r) {
                return "color" === this.type ? new ba(e1, t) : new xa(e1, t);
            }
        }
        class Aa {
            constructor(e1, t){
                this.uniformNames = t.map((e1)=>`u_${e1}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
            }
            setConstantPatternPositions(e1, t) {
                this.pixelRatioFrom = t.pixelRatio, this.pixelRatioTo = e1.pixelRatio, this.patternFrom = t.tlbr, this.patternTo = e1.tlbr;
            }
            setConstantDashPositions(e1, t) {
                this.dashTo = [
                    0,
                    e1.y,
                    e1.height,
                    e1.width
                ], this.dashFrom = [
                    0,
                    t.y,
                    t.height,
                    t.width
                ];
            }
            setUniform(e1, t, r, n) {
                let i = null;
                "u_pattern_to" === n ? i = this.patternTo : "u_pattern_from" === n ? i = this.patternFrom : "u_dasharray_to" === n ? i = this.dashTo : "u_dasharray_from" === n ? i = this.dashFrom : "u_pixel_ratio_to" === n ? i = this.pixelRatioTo : "u_pixel_ratio_from" === n && (i = this.pixelRatioFrom), null !== i && e1.set(i);
            }
            getBinding(e1, t, r) {
                return "u_pattern" === r.substr(0, 9) || "u_dasharray_" === r.substr(0, 12) ? new va(e1, t) : new xa(e1, t);
            }
        }
        class Ta {
            constructor(e1, t, r, n){
                this.expression = e1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = t.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(e1, t, r) {
                const n = this.paintVertexArray.length, i = this.expression.evaluate(new ks(0, r), t, {}, r.canonical, [], r.formattedSection);
                this.paintVertexArray.resize(e1), this._setPaintValue(n, e1, i);
            }
            updatePaintArray(e1, t, r, n, i) {
                const s = this.expression.evaluate(new ks(0, i), r, n);
                this._setPaintValue(e1, t, s);
            }
            _setPaintValue(e1, t, r) {
                if ("color" === this.type) {
                    const n = _a(r);
                    for(let r = e1; r < t; r++)this.paintVertexArray.emplace(r, n[0], n[1]);
                } else {
                    for(let n = e1; n < t; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class Ia {
            constructor(e1, t, r, n, i, s){
                this.expression = e1, this.uniformNames = t.map((e1)=>`u_${e1}_t`), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = t.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new s;
            }
            populatePaintArray(e1, t, r) {
                const n = this.expression.evaluate(new ks(this.zoom, r), t, {}, r.canonical, [], r.formattedSection), i = this.expression.evaluate(new ks(this.zoom + 1, r), t, {}, r.canonical, [], r.formattedSection), s = this.paintVertexArray.length;
                this.paintVertexArray.resize(e1), this._setPaintValue(s, e1, n, i);
            }
            updatePaintArray(e1, t, r, n, i) {
                const s = this.expression.evaluate(new ks(this.zoom, i), r, n), o = this.expression.evaluate(new ks(this.zoom + 1, i), r, n);
                this._setPaintValue(e1, t, s, o);
            }
            _setPaintValue(e1, t, r, n) {
                if ("color" === this.type) {
                    const i = _a(r), s = _a(n);
                    for(let r = e1; r < t; r++)this.paintVertexArray.emplace(r, i[0], i[1], s[0], s[1]);
                } else {
                    for(let i = e1; i < t; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(e1, t) {
                const r = this.useIntegerZoom ? Math.floor(t.zoom) : t.zoom, n = C(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
                e1.set(n);
            }
            getBinding(e1, t, r) {
                return new xa(e1, t);
            }
        }
        class Ea {
            constructor(e1, t, r, n, i, s){
                this.expression = e1, this.type = t, this.useIntegerZoom = r, this.zoom = n, this.layerId = s, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
            }
            populatePaintArray(e1, t, r) {
                const n = this.zoomInPaintVertexArray.length;
                this.zoomInPaintVertexArray.resize(e1), this.zoomOutPaintVertexArray.resize(e1), this._setPaintValues(n, e1, this.getPositionIds(t), r);
            }
            updatePaintArray(e1, t, r, n, i) {
                this._setPaintValues(e1, t, this.getPositionIds(r), i);
            }
            _setPaintValues(e1, t, r, n) {
                const i = this.getPositions(n);
                if (!i || !r) return;
                const s = i[r.min], o = i[r.mid], a = i[r.max];
                if (s && o && a) for(let r = e1; r < t; r++)this.emplace(this.zoomInPaintVertexArray, r, o, s), this.emplace(this.zoomOutPaintVertexArray, r, o, a);
            }
            upload(e1) {
                if (this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer) {
                    const t = this.getVertexAttributes();
                    this.zoomInPaintVertexBuffer = e1.createVertexBuffer(this.zoomInPaintVertexArray, t, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = e1.createVertexBuffer(this.zoomOutPaintVertexArray, t, this.expression.isStateDependent);
                }
            }
            destroy() {
                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
            }
        }
        class Ma extends Ea {
            getPositions(e1) {
                return e1.imagePositions;
            }
            getPositionIds(e1) {
                return e1.patterns && e1.patterns[this.layerId];
            }
            getVertexAttributes() {
                return na.members;
            }
            emplace(e1, t, r, n) {
                e1.emplace(t, r.tlbr[0], r.tlbr[1], r.tlbr[2], r.tlbr[3], n.tlbr[0], n.tlbr[1], n.tlbr[2], n.tlbr[3], r.pixelRatio, n.pixelRatio);
            }
        }
        class ka extends Ea {
            getPositions(e1) {
                return e1.dashPositions;
            }
            getPositionIds(e1) {
                return e1.dashes && e1.dashes[this.layerId];
            }
            getVertexAttributes() {
                return ia.members;
            }
            emplace(e1, t, r, n) {
                e1.emplace(t, 0, r.y, r.height, r.width, 0, n.y, n.height, n.width);
            }
        }
        class Fa {
            constructor(e1, t, r){
                this.binders = {}, this._buffers = [];
                const n = [];
                for(const i in e1.paint._values){
                    if (!r(i)) continue;
                    const s = e1.paint.get(i);
                    if (!(s instanceof Os && Un(s.property.specification))) continue;
                    const o = Pa(i, e1.type), a = s.value, l = s.property.specification.type, u = s.property.useIntegerZoom, c = s.property.specification["property-type"], h = "cross-faded" === c || "cross-faded-data-driven" === c;
                    if ("constant" === a.kind) this.binders[i] = h ? new Aa(a.value, o) : new Sa(a.value, o, l), n.push(`/u_${i}`);
                    else if ("source" === a.kind || h) {
                        const r = Ba(i, l, "source");
                        this.binders[i] = h ? "line-dasharray" === i ? new ka(a, l, u, t, r, e1.id) : new Ma(a, l, u, t, r, e1.id) : new Ta(a, o, l, r), n.push(`/a_${i}`);
                    } else {
                        const e1 = Ba(i, l, "composite");
                        this.binders[i] = new Ia(a, o, l, u, t, e1), n.push(`/z_${i}`);
                    }
                }
                this.cacheKey = n.sort().join("");
            }
            getMaxValue(e1) {
                const t = this.binders[e1];
                return t instanceof Ta || t instanceof Ia ? t.maxValue : 0;
            }
            populatePaintArrays(e1, t, r) {
                for(const n in this.binders){
                    const i = this.binders[n];
                    (i instanceof Ta || i instanceof Ia || i instanceof Ea) && i.populatePaintArray(e1, t, r);
                }
            }
            setConstantPatternPositions(e1, t) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof Aa && n.setConstantPatternPositions(e1, t);
                }
            }
            setConstantDashPositions(e1, t) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof Aa && n.setConstantDashPositions(e1, t);
                }
            }
            updatePaintArrays(e1, t, r, n, i) {
                let s = !1;
                for(const o in e1){
                    const a = t.getPositions(o);
                    for (const t of a){
                        const a = r.feature(t.index);
                        for(const r in this.binders){
                            const l = this.binders[r];
                            if ((l instanceof Ta || l instanceof Ia || l instanceof Ea) && !0 === l.expression.isStateDependent) {
                                const u = n.paint.get(r);
                                l.expression = u.value, l.updatePaintArray(t.start, t.end, a, e1[o], i), s = !0;
                            }
                        }
                    }
                }
                return s;
            }
            defines() {
                const e1 = [];
                for(const t in this.binders){
                    const r = this.binders[t];
                    (r instanceof Sa || r instanceof Aa) && e1.push(...r.uniformNames.map((e1)=>`#define HAS_UNIFORM_${e1}`));
                }
                return e1;
            }
            getBinderAttributes() {
                const e1 = [];
                for(const t in this.binders){
                    const r = this.binders[t];
                    if (r instanceof Ta || r instanceof Ia) for(let t = 0; t < r.paintVertexAttributes.length; t++)e1.push(r.paintVertexAttributes[t].name);
                    else if (r instanceof Ea) {
                        const t = r.getVertexAttributes();
                        for (const r of t)e1.push(r.name);
                    }
                }
                return e1;
            }
            getBinderUniforms() {
                const e1 = [];
                for(const t in this.binders){
                    const r = this.binders[t];
                    if (r instanceof Sa || r instanceof Aa || r instanceof Ia) for (const t of r.uniformNames)e1.push(t);
                }
                return e1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(e1, t) {
                const r = [];
                for(const n in this.binders){
                    const i = this.binders[n];
                    if (i instanceof Sa || i instanceof Aa || i instanceof Ia) {
                        for (const s of i.uniformNames)if (t[s]) {
                            const o = i.getBinding(e1, t[s], s);
                            r.push({
                                name: s,
                                property: n,
                                binding: o
                            });
                        }
                    }
                }
                return r;
            }
            setUniforms(e1, t, r, n) {
                for (const { name: e1, property: i, binding: s } of t)this.binders[i].setUniform(s, n, r.get(i), e1);
            }
            updatePaintBuffers(e1) {
                this._buffers = [];
                for(const t in this.binders){
                    const r = this.binders[t];
                    if (e1 && r instanceof Ea) {
                        const t = 2 === e1.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                        t && this._buffers.push(t);
                    } else (r instanceof Ta || r instanceof Ia) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
                }
            }
            upload(e1) {
                for(const t in this.binders){
                    const r = this.binders[t];
                    (r instanceof Ta || r instanceof Ia || r instanceof Ea) && r.upload(e1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const e1 in this.binders){
                    const t = this.binders[e1];
                    (t instanceof Ta || t instanceof Ia || t instanceof Ea) && t.destroy();
                }
            }
        }
        class Da {
            constructor(e1, t, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of e1)this.programConfigurations[n.id] = new Fa(n, t, r);
                this.needsUpload = !1, this._featureMap = new fa, this._bufferOffset = 0;
            }
            populatePaintArrays(e1, t, r, n) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(e1, t, n);
                void 0 !== t.id && this._featureMap.add(t.id, r, this._bufferOffset, e1), this._bufferOffset = e1, this.needsUpload = !0;
            }
            updatePaintArrays(e1, t, r, n) {
                for (const i of r)this.needsUpload = this.programConfigurations[i.id].updatePaintArrays(e1, this._featureMap, t, i, n) || this.needsUpload;
            }
            get(e1) {
                return this.programConfigurations[e1];
            }
            upload(e1) {
                if (this.needsUpload) {
                    for(const t in this.programConfigurations)this.programConfigurations[t].upload(e1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const e1 in this.programConfigurations)this.programConfigurations[e1].destroy();
            }
        }
        function Pa(e1, t) {
            return ({
                "text-opacity": [
                    "opacity"
                ],
                "icon-opacity": [
                    "opacity"
                ],
                "text-color": [
                    "fill_color"
                ],
                "icon-color": [
                    "fill_color"
                ],
                "text-halo-color": [
                    "halo_color"
                ],
                "icon-halo-color": [
                    "halo_color"
                ],
                "text-halo-blur": [
                    "halo_blur"
                ],
                "icon-halo-blur": [
                    "halo_blur"
                ],
                "text-halo-width": [
                    "halo_width"
                ],
                "icon-halo-width": [
                    "halo_width"
                ],
                "line-gap-width": [
                    "gapwidth"
                ],
                "line-dasharray": [
                    "dasharray_to",
                    "dasharray_from"
                ],
                "line-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-extrusion-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ]
            })[e1] || [
                e1.replace(`${t}-`, "").replace(/-/g, "_")
            ];
        }
        function Ba(e1, t, r) {
            const n = {
                color: {
                    source: oo,
                    composite: To
                },
                number: {
                    source: bo,
                    composite: oo
                }
            }, i = function(e1) {
                return ({
                    "line-pattern": {
                        source: jo,
                        composite: jo
                    },
                    "fill-pattern": {
                        source: jo,
                        composite: jo
                    },
                    "fill-extrusion-pattern": {
                        source: jo,
                        composite: jo
                    },
                    "line-dasharray": {
                        source: Go,
                        composite: Go
                    }
                })[e1];
            }(e1);
            return i && i[r] || n[t][r];
        }
        ls("ConstantBinder", Sa), ls("CrossFadedConstantBinder", Aa), ls("SourceExpressionBinder", Ta), ls("CrossFadedPatternBinder", Ma), ls("CrossFadedDasharrayBinder", ka), ls("CompositeExpressionBinder", Ia), ls("ProgramConfiguration", Fa, {
            omit: [
                "_buffers"
            ]
        }), ls("ProgramConfigurationSet", Da);
        const za = Math.pow(2, 14) - 1, Va = -za - 1;
        function Ca(e1) {
            const t = k / e1.extent, r = e1.loadGeometry();
            for(let e1 = 0; e1 < r.length; e1++){
                const n = r[e1];
                for(let e1 = 0; e1 < n.length; e1++){
                    const r = n[e1], i = Math.round(r.x * t), s = Math.round(r.y * t);
                    r.x = C(i, Va, za), r.y = C(s, Va, za), (i < r.x || i > r.x + 1 || s < r.y || s > r.y + 1) && j("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                }
            }
            return r;
        }
        function La(e1, t) {
            return {
                type: e1.type,
                id: e1.id,
                properties: e1.properties,
                geometry: t ? Ca(e1) : []
            };
        }
        const Oa = -32768;
        function Ra(e1, t, r, n, i) {
            e1.emplaceBack(Oa + 8 * t + n, Oa + 8 * r + i);
        }
        class Na {
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.id), this.index = e1.index, this.hasDependencies = !1, this.layoutVertexArray = new Ro, this.indexArray = new Wo, this.segments = new ta, this.programConfigurations = new Da(e1.layers, e1.zoom), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
            }
            populate(e1, t, r) {
                const n = this.layers[0], i = [];
                let s = null, o = !1, a = "heatmap" === n.type;
                if ("circle" === n.type) {
                    const e1 = n;
                    s = e1.layout.get("circle-sort-key"), o = !s.isConstant(), a = a || "map" === e1.paint.get("circle-pitch-alignment");
                }
                const l = a ? t.subdivisionGranularity.circle : 1;
                for (const { feature: t, id: n, index: a, sourceLayerIndex: l } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, u = La(t, e1);
                    if (!this.layers[0]._featureFilter.filter(new ks(this.zoom), u, r)) continue;
                    const c = o ? s.evaluate(u, {}, r) : void 0, h = {
                        id: n,
                        properties: t.properties,
                        type: t.type,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: e1 ? u.geometry : Ca(t),
                        patterns: {},
                        sortKey: c
                    };
                    i.push(h);
                }
                o && i.sort((e1, t)=>e1.sortKey - t.sortKey);
                for (const n of i){
                    const { geometry: i, index: s, sourceLayerIndex: o } = n, a = e1[s].feature;
                    this.addFeature(n, i, s, r, l), t.featureIndex.insert(a, i, s, o, this.index);
                }
            }
            update(e1, t, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e1, t, this.stateDependentLayers, {
                    imagePositions: r
                });
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, ea), this.indexBuffer = e1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(e1, t, r, n, i = 1) {
                let s;
                switch(i){
                    case 1:
                        s = [
                            0,
                            7
                        ];
                        break;
                    case 3:
                        s = [
                            0,
                            2,
                            5,
                            7
                        ];
                        break;
                    case 5:
                        s = [
                            0,
                            1,
                            3,
                            4,
                            6,
                            7
                        ];
                        break;
                    case 7:
                        s = [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7
                        ];
                        break;
                    default:
                        throw new Error(`Invalid circle bucket granularity: ${i}; valid values are 1, 3, 5, 7.`);
                }
                const o = s.length;
                for (const r of t)for (const t of r){
                    const r = t.x, n = t.y;
                    if (r < 0 || r >= k || n < 0 || n >= k) continue;
                    const i = this.segments.prepareSegment(o * o, this.layoutVertexArray, this.indexArray, e1.sortKey), a = i.vertexLength;
                    for(let e1 = 0; e1 < o; e1++)for(let t = 0; t < o; t++)Ra(this.layoutVertexArray, r, n, s[t], s[e1]);
                    for(let e1 = 0; e1 < o - 1; e1++)for(let t = 0; t < o - 1; t++){
                        const r = a + e1 * o + t, n = a + (e1 + 1) * o + t;
                        this.indexArray.emplaceBack(r, n + 1, r + 1), this.indexArray.emplaceBack(r, n, n + 1);
                    }
                    i.vertexLength += o * o, i.primitiveLength += (o - 1) * (o - 1) * 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, r, {
                    imagePositions: {},
                    canonical: n
                });
            }
        }
        function $a(e1, t) {
            for(let r = 0; r < e1.length; r++)if (Ka(t, e1[r])) return !0;
            for(let r = 0; r < t.length; r++)if (Ka(e1, t[r])) return !0;
            return !!Ga(e1, t);
        }
        function Ua(e1, t, r) {
            return !!Ka(e1, t) || !!Ya(t, e1, r);
        }
        function qa(e1, t) {
            if (1 === e1.length) return Ha(t, e1[0]);
            for(let r = 0; r < t.length; r++){
                const n = t[r];
                for(let t = 0; t < n.length; t++)if (Ka(e1, n[t])) return !0;
            }
            for(let r = 0; r < e1.length; r++)if (Ha(t, e1[r])) return !0;
            for(let r = 0; r < t.length; r++)if (Ga(e1, t[r])) return !0;
            return !1;
        }
        function ja(e1, t, r) {
            if (e1.length > 1) {
                if (Ga(e1, t)) return !0;
                for(let n = 0; n < t.length; n++)if (Ya(t[n], e1, r)) return !0;
            }
            for(let n = 0; n < e1.length; n++)if (Ya(e1[n], t, r)) return !0;
            return !1;
        }
        function Ga(e1, t) {
            if (0 === e1.length || 0 === t.length) return !1;
            for(let r = 0; r < e1.length - 1; r++){
                const n = e1[r], i = e1[r + 1];
                for(let e1 = 0; e1 < t.length - 1; e1++)if (Xa(n, i, t[e1], t[e1 + 1])) return !0;
            }
            return !1;
        }
        function Xa(e1, t, r, n) {
            return G(e1, r, n) !== G(t, r, n) && G(e1, t, r) !== G(e1, t, n);
        }
        function Ya(e1, t, r) {
            const n = r * r;
            if (1 === t.length) return e1.distSqr(t[0]) < n;
            for(let r = 1; r < t.length; r++)if (Za(e1, t[r - 1], t[r]) < n) return !0;
            return !1;
        }
        function Za(e1, t, r) {
            const n = t.distSqr(r);
            if (0 === n) return e1.distSqr(t);
            const i = ((e1.x - t.x) * (r.x - t.x) + (e1.y - t.y) * (r.y - t.y)) / n;
            return e1.distSqr(i < 0 ? t : i > 1 ? r : r.sub(t)._mult(i)._add(t));
        }
        function Ha(e1, t) {
            let r, n, i, s = !1;
            for(let o = 0; o < e1.length; o++){
                r = e1[o];
                for(let e1 = 0, o = r.length - 1; e1 < r.length; o = e1++)n = r[e1], i = r[o], n.y > t.y != i.y > t.y && t.x < (i.x - n.x) * (t.y - n.y) / (i.y - n.y) + n.x && (s = !s);
            }
            return s;
        }
        function Ka(e1, t) {
            let r = !1;
            for(let n = 0, i = e1.length - 1; n < e1.length; i = n++){
                const s = e1[n], o = e1[i];
                s.y > t.y != o.y > t.y && t.x < (o.x - s.x) * (t.y - s.y) / (o.y - s.y) + s.x && (r = !r);
            }
            return r;
        }
        function Wa(e1, t, r) {
            const n = r[0], i = r[2];
            if (e1.x < n.x && t.x < n.x || e1.x > i.x && t.x > i.x || e1.y < n.y && t.y < n.y || e1.y > i.y && t.y > i.y) return !1;
            const s = G(e1, t, r[0]);
            return s !== G(e1, t, r[1]) || s !== G(e1, t, r[2]) || s !== G(e1, t, r[3]);
        }
        function Ja(e1, t, r) {
            const n = t.paint.get(e1).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(t.id).getMaxValue(e1);
        }
        function Qa(e1) {
            return Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]);
        }
        function el(e1, t, n, i, s) {
            if (!t[0] && !t[1]) return e1;
            const o = r.convert(t)._mult(s);
            "viewport" === n && o._rotate(-i);
            const a = [];
            for(let t = 0; t < e1.length; t++)a.push(e1[t].sub(o));
            return a;
        }
        function tl({ queryGeometry: e1, size: t }, r) {
            return Ua(e1, r, t);
        }
        function rl({ queryGeometry: e1, size: t, transform: r, unwrappedTileID: n, getElevation: i }, s) {
            return Ua(e1, s, t * (r.projectTileCoordinates(s.x, s.y, n, i).signedDistanceFromCamera / r.cameraToCenterDistance));
        }
        function nl({ queryGeometry: e1, size: t, transform: r, unwrappedTileID: n, getElevation: i }, s) {
            const o = r.projectTileCoordinates(s.x, s.y, n, i).signedDistanceFromCamera, a = t * (r.cameraToCenterDistance / o);
            return Ua(e1, ol(s, r, n, i), a);
        }
        function il({ queryGeometry: e1, size: t, transform: r, unwrappedTileID: n, getElevation: i }, s) {
            return Ua(e1, ol(s, r, n, i), t);
        }
        function sl({ queryGeometry: e1, size: t, transform: r, unwrappedTileID: n, getElevation: i, pitchAlignment: s = "map", pitchScale: o = "map" }, a) {
            const l = "map" === s ? "map" === o ? tl : rl : "map" === o ? nl : il, u = {
                queryGeometry: e1,
                size: t,
                transform: r,
                unwrappedTileID: n,
                getElevation: i
            };
            for (const e1 of a)for (const t of e1)if (l(u, t)) return !0;
            return !1;
        }
        function ol(e1, t, n, i) {
            const s = t.projectTileCoordinates(e1.x, e1.y, n, i).point;
            return new r((.5 * s.x + .5) * t.width, (.5 * -s.y + .5) * t.height);
        }
        let al, ll;
        ls("CircleBucket", Na, {
            omit: [
                "layers"
            ]
        });
        var ul = {
            get paint () {
                return ll = ll || new Gs({
                    "circle-radius": new $s(xe.paint_circle["circle-radius"]),
                    "circle-color": new $s(xe.paint_circle["circle-color"]),
                    "circle-blur": new $s(xe.paint_circle["circle-blur"]),
                    "circle-opacity": new $s(xe.paint_circle["circle-opacity"]),
                    "circle-translate": new Ns(xe.paint_circle["circle-translate"]),
                    "circle-translate-anchor": new Ns(xe.paint_circle["circle-translate-anchor"]),
                    "circle-pitch-scale": new Ns(xe.paint_circle["circle-pitch-scale"]),
                    "circle-pitch-alignment": new Ns(xe.paint_circle["circle-pitch-alignment"]),
                    "circle-stroke-width": new $s(xe.paint_circle["circle-stroke-width"]),
                    "circle-stroke-color": new $s(xe.paint_circle["circle-stroke-color"]),
                    "circle-stroke-opacity": new $s(xe.paint_circle["circle-stroke-opacity"])
                });
            },
            get layout () {
                return al = al || new Gs({
                    "circle-sort-key": new $s(xe.layout_circle["circle-sort-key"])
                });
            }
        };
        class cl extends Xs {
            constructor(e1, t){
                super(e1, ul, t);
            }
            createBucket(e1) {
                return new Na(e1);
            }
            queryRadius(e1) {
                const t = e1;
                return Ja("circle-radius", this, t) + Ja("circle-stroke-width", this, t) + Qa(this.paint.get("circle-translate"));
            }
            queryIntersectsFeature({ queryGeometry: e1, feature: t, featureState: r, geometry: n, transform: i, pixelsToTileUnits: s, unwrappedTileID: o, getElevation: a }) {
                const l = el(e1, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), -i.bearingInRadians, s), u = this.paint.get("circle-radius").evaluate(t, r) + this.paint.get("circle-stroke-width").evaluate(t, r), c = this.paint.get("circle-pitch-scale"), h = this.paint.get("circle-pitch-alignment");
                let p, f;
                return "map" === h ? (p = l, f = u * s) : (p = function(e1, t, r, n) {
                    return e1.map((e1)=>ol(e1, t, r, n));
                }(l, i, o, a), f = u), sl({
                    queryGeometry: p,
                    size: f,
                    transform: i,
                    unwrappedTileID: o,
                    getElevation: a,
                    pitchAlignment: h,
                    pitchScale: c
                }, n);
            }
        }
        class hl extends Na {
        }
        let pl;
        ls("HeatmapBucket", hl, {
            omit: [
                "layers"
            ]
        });
        var fl = {
            get paint () {
                return pl = pl || new Gs({
                    "heatmap-radius": new $s(xe.paint_heatmap["heatmap-radius"]),
                    "heatmap-weight": new $s(xe.paint_heatmap["heatmap-weight"]),
                    "heatmap-intensity": new Ns(xe.paint_heatmap["heatmap-intensity"]),
                    "heatmap-color": new js(xe.paint_heatmap["heatmap-color"]),
                    "heatmap-opacity": new Ns(xe.paint_heatmap["heatmap-opacity"])
                });
            }
        };
        function dl(e1, { width: t, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== t * r * n) throw new RangeError(`mismatched image size. expected: ${i.length} but got: ${t * r * n}`);
            } else i = new Uint8Array(t * r * n);
            return e1.width = t, e1.height = r, e1.data = i, e1;
        }
        function yl(e1, { width: t, height: r }, n) {
            if (t === e1.width && r === e1.height) return;
            const i = dl({}, {
                width: t,
                height: r
            }, n);
            ml(e1, i, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(e1.width, t),
                height: Math.min(e1.height, r)
            }, n), e1.width = t, e1.height = r, e1.data = i.data;
        }
        function ml(e1, t, r, n, i, s) {
            if (0 === i.width || 0 === i.height) return t;
            if (i.width > e1.width || i.height > e1.height || r.x > e1.width - i.width || r.y > e1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > t.width || i.height > t.height || n.x > t.width - i.width || n.y > t.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const o = e1.data, a = t.data;
            if (o === a) throw new Error("srcData equals dstData, so image is already copied");
            for(let l = 0; l < i.height; l++){
                const u = ((r.y + l) * e1.width + r.x) * s, c = ((n.y + l) * t.width + n.x) * s;
                for(let e1 = 0; e1 < i.width * s; e1++)a[c + e1] = o[u + e1];
            }
            return t;
        }
        class gl {
            constructor(e1, t){
                dl(this, e1, 1, t);
            }
            resize(e1) {
                yl(this, e1, 1);
            }
            clone() {
                return new gl({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t, r, n, i) {
                ml(e1, t, r, n, i, 1);
            }
        }
        class xl {
            constructor(e1, t){
                dl(this, e1, 4, t);
            }
            resize(e1) {
                yl(this, e1, 4);
            }
            replace(e1, t) {
                t ? this.data.set(e1) : this.data = e1 instanceof Uint8ClampedArray ? new Uint8Array(e1.buffer) : e1;
            }
            clone() {
                return new xl({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t, r, n, i) {
                ml(e1, t, r, n, i, 4);
            }
            setPixel(e1, t, r) {
                const n = 4 * (e1 * this.width + t);
                this.data[n + 0] = Math.round(255 * r.r / r.a), this.data[n + 1] = Math.round(255 * r.g / r.a), this.data[n + 2] = Math.round(255 * r.b / r.a), this.data[n + 3] = Math.round(255 * r.a);
            }
        }
        function vl(e1) {
            const t = {}, r = e1.resolution || 256, n = e1.clips ? e1.clips.length : 1, i = e1.image || new xl({
                width: r,
                height: n
            });
            if (Math.log(r) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${r}`);
            const s = (n, s, o)=>{
                t[e1.evaluationKey] = o;
                const a = e1.expression.evaluate(t);
                i.setPixel(n / 4 / r, s / 4, a);
            };
            if (e1.clips) for(let t = 0, i = 0; t < n; ++t, i += 4 * r)for(let n = 0, o = 0; n < r; n++, o += 4){
                const a = n / (r - 1), { start: l, end: u } = e1.clips[t];
                s(i, o, l * (1 - a) + u * a);
            }
            else for(let e1 = 0, t = 0; e1 < r; e1++, t += 4)s(0, t, e1 / (r - 1));
            return i;
        }
        ls("AlphaImage", gl), ls("RGBAImage", xl);
        const bl = "big-fb";
        class wl extends Xs {
            createBucket(e1) {
                return new hl(e1);
            }
            constructor(e1, t){
                super(e1, fl, t), this.heatmapFbos = new Map, this._updateColorRamp();
            }
            _handleSpecialPaintPropertyUpdate(e1) {
                "heatmap-color" === e1 && this._updateColorRamp();
            }
            _updateColorRamp() {
                this.colorRamp = vl({
                    expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                    evaluationKey: "heatmapDensity",
                    image: this.colorRamp
                }), this.colorRampTexture = null;
            }
            resize() {
                this.heatmapFbos.has(bl) && this.heatmapFbos.delete(bl);
            }
            queryRadius(e1) {
                return Ja("heatmap-radius", this, e1);
            }
            queryIntersectsFeature({ queryGeometry: e1, feature: t, featureState: r, geometry: n, transform: i, pixelsToTileUnits: s, unwrappedTileID: o, getElevation: a }) {
                return sl({
                    queryGeometry: e1,
                    size: this.paint.get("heatmap-radius").evaluate(t, r) * s,
                    transform: i,
                    unwrappedTileID: o,
                    getElevation: a
                }, n);
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
            }
        }
        let _l;
        var Sl = {
            get paint () {
                return _l = _l || new Gs({
                    "hillshade-illumination-direction": new Ns(xe.paint_hillshade["hillshade-illumination-direction"]),
                    "hillshade-illumination-altitude": new Ns(xe.paint_hillshade["hillshade-illumination-altitude"]),
                    "hillshade-illumination-anchor": new Ns(xe.paint_hillshade["hillshade-illumination-anchor"]),
                    "hillshade-exaggeration": new Ns(xe.paint_hillshade["hillshade-exaggeration"]),
                    "hillshade-shadow-color": new Ns(xe.paint_hillshade["hillshade-shadow-color"]),
                    "hillshade-highlight-color": new Ns(xe.paint_hillshade["hillshade-highlight-color"]),
                    "hillshade-accent-color": new Ns(xe.paint_hillshade["hillshade-accent-color"]),
                    "hillshade-method": new Ns(xe.paint_hillshade["hillshade-method"])
                });
            }
        };
        class Al extends Xs {
            constructor(e1, t){
                super(e1, Sl, t), this.recalculate({
                    zoom: 0,
                    zoomHistory: {}
                }, void 0);
            }
            getIlluminationProperties() {
                let e1 = this.paint.get("hillshade-illumination-direction").values, t = this.paint.get("hillshade-illumination-altitude").values, r = this.paint.get("hillshade-highlight-color").values, n = this.paint.get("hillshade-shadow-color").values;
                const i = Math.max(e1.length, t.length, r.length, n.length);
                e1 = e1.concat(Array(i - e1.length).fill(e1.at(-1))), t = t.concat(Array(i - t.length).fill(t.at(-1))), r = r.concat(Array(i - r.length).fill(r.at(-1))), n = n.concat(Array(i - n.length).fill(n.at(-1)));
                const s = t.map(ee);
                return {
                    directionRadians: e1.map(ee),
                    altitudeRadians: s,
                    shadowColor: n,
                    highlightColor: r
                };
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
            }
        }
        let Tl;
        var Il = {
            get paint () {
                return Tl = Tl || new Gs({
                    "color-relief-opacity": new Ns(xe["paint_color-relief"]["color-relief-opacity"]),
                    "color-relief-color": new js(xe["paint_color-relief"]["color-relief-color"])
                });
            }
        };
        class El {
            constructor(e1, t, r, n){
                this.context = e1, this.format = r, this.texture = e1.gl.createTexture(), this.update(t, n);
            }
            update(e1, t, r) {
                const { width: n, height: i } = e1, s = !(this.size && this.size[0] === n && this.size[1] === i || r), { context: o } = this, { gl: a } = o;
                if (this.useMipmap = Boolean(t && t.useMipmap), a.bindTexture(a.TEXTURE_2D, this.texture), o.pixelStoreUnpackFlipY.set(!1), o.pixelStoreUnpack.set(1), o.pixelStoreUnpackPremultiplyAlpha.set(this.format === a.RGBA && (!t || !1 !== t.premultiply)), s) this.size = [
                    n,
                    i
                ], e1 instanceof HTMLImageElement || e1 instanceof HTMLCanvasElement || e1 instanceof HTMLVideoElement || e1 instanceof ImageData || Z(e1) ? a.texImage2D(a.TEXTURE_2D, 0, this.format, this.format, a.UNSIGNED_BYTE, e1) : a.texImage2D(a.TEXTURE_2D, 0, this.format, n, i, 0, this.format, a.UNSIGNED_BYTE, e1.data);
                else {
                    const { x: t, y: s } = r || {
                        x: 0,
                        y: 0
                    };
                    e1 instanceof HTMLImageElement || e1 instanceof HTMLCanvasElement || e1 instanceof HTMLVideoElement || e1 instanceof ImageData || Z(e1) ? a.texSubImage2D(a.TEXTURE_2D, 0, t, s, a.RGBA, a.UNSIGNED_BYTE, e1) : a.texSubImage2D(a.TEXTURE_2D, 0, t, s, n, i, a.RGBA, a.UNSIGNED_BYTE, e1.data);
                }
                this.useMipmap && this.isSizePowerOfTwo() && a.generateMipmap(a.TEXTURE_2D), o.pixelStoreUnpackFlipY.setDefault(), o.pixelStoreUnpack.setDefault(), o.pixelStoreUnpackPremultiplyAlpha.setDefault();
            }
            bind(e1, t, r) {
                const { context: n } = this, { gl: i } = n;
                i.bindTexture(i.TEXTURE_2D, this.texture), r !== i.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (r = i.LINEAR), e1 !== this.filter && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, e1), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, r || e1), this.filter = e1), t !== this.wrap && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, t), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, t), this.wrap = t);
            }
            isSizePowerOfTwo() {
                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
            }
            destroy() {
                const { gl: e1 } = this.context;
                e1.deleteTexture(this.texture), this.texture = null;
            }
        }
        class Ml {
            constructor(e1, t, r, n = 1, i = 1, s = 1, o = 0){
                if (this.uid = e1, t.height !== t.width) throw new RangeError("DEM tiles must be square");
                if (r && ![
                    "mapbox",
                    "terrarium",
                    "custom"
                ].includes(r)) return void j(`"${r}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                this.stride = t.height;
                const a = this.dim = t.height - 2;
                switch(this.data = new Uint32Array(t.data.buffer), r){
                    case "terrarium":
                        this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                        break;
                    case "custom":
                        this.redFactor = n, this.greenFactor = i, this.blueFactor = s, this.baseShift = o;
                        break;
                    default:
                        this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                }
                for(let e1 = 0; e1 < a; e1++)this.data[this._idx(-1, e1)] = this.data[this._idx(0, e1)], this.data[this._idx(a, e1)] = this.data[this._idx(a - 1, e1)], this.data[this._idx(e1, -1)] = this.data[this._idx(e1, 0)], this.data[this._idx(e1, a)] = this.data[this._idx(e1, a - 1)];
                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(a, -1)] = this.data[this._idx(a - 1, 0)], this.data[this._idx(-1, a)] = this.data[this._idx(0, a - 1)], this.data[this._idx(a, a)] = this.data[this._idx(a - 1, a - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                for(let e1 = 0; e1 < a; e1++)for(let t = 0; t < a; t++){
                    const r = this.get(e1, t);
                    r > this.max && (this.max = r), r < this.min && (this.min = r);
                }
            }
            get(e1, t) {
                const r = new Uint8Array(this.data.buffer), n = 4 * this._idx(e1, t);
                return this.unpack(r[n], r[n + 1], r[n + 2]);
            }
            getUnpackVector() {
                return [
                    this.redFactor,
                    this.greenFactor,
                    this.blueFactor,
                    this.baseShift
                ];
            }
            _idx(e1, t) {
                if (e1 < -1 || e1 >= this.dim + 1 || t < -1 || t >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (t + 1) * this.stride + (e1 + 1);
            }
            unpack(e1, t, r) {
                return e1 * this.redFactor + t * this.greenFactor + r * this.blueFactor - this.baseShift;
            }
            pack(e1) {
                return kl(e1, this.getUnpackVector());
            }
            getPixels() {
                return new xl({
                    width: this.stride,
                    height: this.stride
                }, new Uint8Array(this.data.buffer));
            }
            backfillBorder(e1, t, r) {
                if (this.dim !== e1.dim) throw new Error("dem dimension mismatch");
                let n = t * this.dim, i = t * this.dim + this.dim, s = r * this.dim, o = r * this.dim + this.dim;
                switch(t){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        s = o - 1;
                        break;
                    case 1:
                        o = s + 1;
                }
                const a = -t * this.dim, l = -r * this.dim;
                for(let t = s; t < o; t++)for(let r = n; r < i; r++)this.data[this._idx(r, t)] = e1.data[this._idx(r + a, t + l)];
            }
        }
        function kl(e1, t) {
            const r = t[0], n = t[1], i = t[2], s = t[3], o = Math.min(r, n, i), a = Math.round((e1 + s) / o);
            return {
                r: Math.floor(a * o / r) % 256,
                g: Math.floor(a * o / n) % 256,
                b: Math.floor(a * o / i) % 256
            };
        }
        ls("DEMData", Ml);
        class Fl extends Xs {
            constructor(e1, t){
                super(e1, Il, t);
            }
            _createColorRamp(e1) {
                const t = {
                    elevationStops: [],
                    colorStops: []
                }, r = this._transitionablePaint._values["color-relief-color"].value.expression;
                if (r instanceof ni && r._styleExpression.expression instanceof pr) {
                    this.colorRampExpression = r;
                    const e1 = r._styleExpression.expression;
                    t.elevationStops = e1.labels, t.colorStops = [];
                    for (const r of t.elevationStops)t.colorStops.push(e1.evaluate({
                        globals: {
                            elevation: r
                        }
                    }));
                }
                if (t.elevationStops.length < 1 && (t.elevationStops = [
                    0
                ], t.colorStops = [
                    It.transparent
                ]), t.elevationStops.length < 2 && (t.elevationStops.push(t.elevationStops[0] + 1), t.colorStops.push(t.colorStops[0])), t.elevationStops.length <= e1) return t;
                const n = {
                    elevationStops: [],
                    colorStops: []
                }, i = (t.elevationStops.length - 1) / (e1 - 1);
                for(let e1 = 0; e1 < t.elevationStops.length - .5; e1 += i)n.elevationStops.push(t.elevationStops[Math.round(e1)]), n.colorStops.push(t.colorStops[Math.round(e1)]);
                return j(`Too many colors in specification of ${this.id} color-relief layer, may not render properly. Max possible colors: ${e1}, provided: ${t.elevationStops.length}`), n;
            }
            _colorRampChanged() {
                return this.colorRampExpression != this._transitionablePaint._values["color-relief-color"].value.expression;
            }
            getColorRampTextures(e1, t, r) {
                if (this.colorRampTextures && !this._colorRampChanged()) return this.colorRampTextures;
                const n = this._createColorRamp(t), i = new xl({
                    width: n.colorStops.length,
                    height: 1
                }), s = new xl({
                    width: n.colorStops.length,
                    height: 1
                });
                for(let e1 = 0; e1 < n.elevationStops.length; e1++){
                    const t = kl(n.elevationStops[e1], r);
                    s.setPixel(0, e1, new It(t.r / 255, t.g / 255, t.b / 255, 1)), i.setPixel(0, e1, n.colorStops[e1]);
                }
                return this.colorRampTextures = {
                    elevationTexture: new El(e1, s, e1.gl.RGBA),
                    colorTexture: new El(e1, i, e1.gl.RGBA)
                }, this.colorRampTextures;
            }
            hasOffscreenPass() {
                return "none" !== this.visibility && !!this.colorRampTextures;
            }
        }
        const Dl = Qs([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Pl } = Dl;
        function Bl(e1, t, r) {
            const n = r.patternDependencies;
            let i = !1;
            for (const r of t){
                const t = r.paint.get(`${e1}-pattern`);
                t.isConstant() || (i = !0);
                const s = t.constantOr(null);
                s && (i = !0, n[s.to] = !0, n[s.from] = !0);
            }
            return i;
        }
        function zl(e1, t, r, n, i) {
            const { zoom: s } = n, o = i.patternDependencies;
            for (const n of t){
                const t = n.paint.get(`${e1}-pattern`).value;
                if ("constant" !== t.kind) {
                    let e1 = t.evaluate({
                        zoom: s - 1
                    }, r, {}, i.availableImages), a = t.evaluate({
                        zoom: s
                    }, r, {}, i.availableImages), l = t.evaluate({
                        zoom: s + 1
                    }, r, {}, i.availableImages);
                    e1 = e1 && e1.name ? e1.name : e1, a = a && a.name ? a.name : a, l = l && l.name ? l.name : l, o[e1] = !0, o[a] = !0, o[l] = !0, r.patterns[n.id] = {
                        min: e1,
                        mid: a,
                        max: l
                    };
                }
            }
            return r;
        }
        function Vl(e1, t, r, n, i) {
            let s;
            if (i === function(e1, t, r, n) {
                let i = 0;
                for(let s = t, o = r - n; s < r; s += n)i += (e1[o] - e1[s]) * (e1[s + 1] + e1[o + 1]), o = s;
                return i;
            }(e1, t, r, n) > 0) for(let i = t; i < r; i += n)s = nu(i / n | 0, e1[i], e1[i + 1], s);
            else for(let i = r - n; i >= t; i -= n)s = nu(i / n | 0, e1[i], e1[i + 1], s);
            return s && Wl(s, s.next) && (iu(s), s = s.next), s;
        }
        function Cl(e1, t) {
            if (!e1) return e1;
            t || (t = e1);
            let r, n = e1;
            do if (r = !1, n.steiner || !Wl(n, n.next) && 0 !== Kl(n.prev, n, n.next)) n = n.next;
            else {
                if (iu(n), n = t = n.prev, n === n.next) break;
                r = !0;
            }
            while (r || n !== t);
            return t;
        }
        function Ll(e1, t, r, n, i, s, o) {
            if (!e1) return;
            !o && s && function(e1, t, r, n) {
                let i = e1;
                do 0 === i.z && (i.z = Gl(i.x, i.y, t, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                while (i !== e1);
                i.prevZ.nextZ = null, i.prevZ = null, function(e1) {
                    let t, r = 1;
                    do {
                        let n, i = e1;
                        e1 = null;
                        let s = null;
                        for(t = 0; i;){
                            t++;
                            let o = i, a = 0;
                            for(let e1 = 0; e1 < r && (a++, o = o.nextZ, o); e1++);
                            let l = r;
                            for(; a > 0 || l > 0 && o;)0 !== a && (0 === l || !o || i.z <= o.z) ? (n = i, i = i.nextZ, a--) : (n = o, o = o.nextZ, l--), s ? s.nextZ = n : e1 = n, n.prevZ = s, s = n;
                            i = o;
                        }
                        s.nextZ = null, r *= 2;
                    }while (t > 1);
                }(i);
            }(e1, n, i, s);
            let a = e1;
            for(; e1.prev !== e1.next;){
                const l = e1.prev, u = e1.next;
                if (s ? Rl(e1, n, i, s) : Ol(e1)) t.push(l.i, e1.i, u.i), iu(e1), e1 = u.next, a = u.next;
                else if ((e1 = u) === a) {
                    o ? 1 === o ? Ll(e1 = Nl(Cl(e1), t), t, r, n, i, s, 2) : 2 === o && $l(e1, t, r, n, i, s) : Ll(Cl(e1), t, r, n, i, s, 1);
                    break;
                }
            }
        }
        function Ol(e1) {
            const t = e1.prev, r = e1, n = e1.next;
            if (Kl(t, r, n) >= 0) return !1;
            const i = t.x, s = r.x, o = n.x, a = t.y, l = r.y, u = n.y, c = Math.min(i, s, o), h = Math.min(a, l, u), p = Math.max(i, s, o), f = Math.max(a, l, u);
            let d = n.next;
            for(; d !== t;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && Zl(i, a, s, l, o, u, d.x, d.y) && Kl(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function Rl(e1, t, r, n) {
            const i = e1.prev, s = e1, o = e1.next;
            if (Kl(i, s, o) >= 0) return !1;
            const a = i.x, l = s.x, u = o.x, c = i.y, h = s.y, p = o.y, f = Math.min(a, l, u), d = Math.min(c, h, p), y = Math.max(a, l, u), m = Math.max(c, h, p), g = Gl(f, d, t, r, n), x = Gl(y, m, t, r, n);
            let v = e1.prevZ, b = e1.nextZ;
            for(; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== o && Zl(a, c, l, h, u, p, v.x, v.y) && Kl(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== o && Zl(a, c, l, h, u, p, b.x, b.y) && Kl(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== o && Zl(a, c, l, h, u, p, v.x, v.y) && Kl(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== o && Zl(a, c, l, h, u, p, b.x, b.y) && Kl(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function Nl(e1, t) {
            let r = e1;
            do {
                const n = r.prev, i = r.next.next;
                !Wl(n, i) && Jl(n, r, r.next, i) && tu(n, i) && tu(i, n) && (t.push(n.i, r.i, i.i), iu(r), iu(r.next), r = e1 = i), r = r.next;
            }while (r !== e1);
            return Cl(r);
        }
        function $l(e1, t, r, n, i, s) {
            let o = e1;
            do {
                let e1 = o.next.next;
                for(; e1 !== o.prev;){
                    if (o.i !== e1.i && Hl(o, e1)) {
                        let a = ru(o, e1);
                        return o = Cl(o, o.next), a = Cl(a, a.next), Ll(o, t, r, n, i, s, 0), void Ll(a, t, r, n, i, s, 0);
                    }
                    e1 = e1.next;
                }
                o = o.next;
            }while (o !== e1);
        }
        function Ul(e1, t) {
            let r = e1.x - t.x;
            return 0 === r && (r = e1.y - t.y, 0 === r) && (r = (e1.next.y - e1.y) / (e1.next.x - e1.x) - (t.next.y - t.y) / (t.next.x - t.x)), r;
        }
        function ql(e1, t) {
            const r = function(e1, t) {
                let r = t;
                const n = e1.x, i = e1.y;
                let s, o = -1 / 0;
                if (Wl(e1, r)) return r;
                do {
                    if (Wl(e1, r.next)) return r.next;
                    if (i <= r.y && i >= r.next.y && r.next.y !== r.y) {
                        const e1 = r.x + (i - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (e1 <= n && e1 > o && (o = e1, s = r.x < r.next.x ? r : r.next, e1 === n)) return s;
                    }
                    r = r.next;
                }while (r !== t);
                if (!s) return null;
                const a = s, l = s.x, u = s.y;
                let c = 1 / 0;
                r = s;
                do {
                    if (n >= r.x && r.x >= l && n !== r.x && Yl(i < u ? n : o, i, l, u, i < u ? o : n, i, r.x, r.y)) {
                        const t = Math.abs(i - r.y) / (n - r.x);
                        tu(r, e1) && (t < c || t === c && (r.x > s.x || r.x === s.x && jl(s, r))) && (s = r, c = t);
                    }
                    r = r.next;
                }while (r !== a);
                return s;
            }(e1, t);
            if (!r) return t;
            const n = ru(r, e1);
            return Cl(n, n.next), Cl(r, r.next);
        }
        function jl(e1, t) {
            return Kl(e1.prev, e1, t.prev) < 0 && Kl(t.next, e1, e1.next) < 0;
        }
        function Gl(e1, t, r, n, i) {
            return (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - r) * i | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - n) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
        }
        function Xl(e1) {
            let t = e1, r = e1;
            do (t.x < r.x || t.x === r.x && t.y < r.y) && (r = t), t = t.next;
            while (t !== e1);
            return r;
        }
        function Yl(e1, t, r, n, i, s, o, a) {
            return (i - o) * (t - a) >= (e1 - o) * (s - a) && (e1 - o) * (n - a) >= (r - o) * (t - a) && (r - o) * (s - a) >= (i - o) * (n - a);
        }
        function Zl(e1, t, r, n, i, s, o, a) {
            return !(e1 === o && t === a) && Yl(e1, t, r, n, i, s, o, a);
        }
        function Hl(e1, t) {
            return e1.next.i !== t.i && e1.prev.i !== t.i && !function(e1, t) {
                let r = e1;
                do {
                    if (r.i !== e1.i && r.next.i !== e1.i && r.i !== t.i && r.next.i !== t.i && Jl(r, r.next, e1, t)) return !0;
                    r = r.next;
                }while (r !== e1);
                return !1;
            }(e1, t) && (tu(e1, t) && tu(t, e1) && function(e1, t) {
                let r = e1, n = !1;
                const i = (e1.x + t.x) / 2, s = (e1.y + t.y) / 2;
                do r.y > s != r.next.y > s && r.next.y !== r.y && i < (r.next.x - r.x) * (s - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== e1);
                return n;
            }(e1, t) && (Kl(e1.prev, e1, t.prev) || Kl(e1, t.prev, t)) || Wl(e1, t) && Kl(e1.prev, e1, e1.next) > 0 && Kl(t.prev, t, t.next) > 0);
        }
        function Kl(e1, t, r) {
            return (t.y - e1.y) * (r.x - t.x) - (t.x - e1.x) * (r.y - t.y);
        }
        function Wl(e1, t) {
            return e1.x === t.x && e1.y === t.y;
        }
        function Jl(e1, t, r, n) {
            const i = eu(Kl(e1, t, r)), s = eu(Kl(e1, t, n)), o = eu(Kl(r, n, e1)), a = eu(Kl(r, n, t));
            return i !== s && o !== a || !(0 !== i || !Ql(e1, r, t)) || !(0 !== s || !Ql(e1, n, t)) || !(0 !== o || !Ql(r, e1, n)) || !(0 !== a || !Ql(r, t, n));
        }
        function Ql(e1, t, r) {
            return t.x <= Math.max(e1.x, r.x) && t.x >= Math.min(e1.x, r.x) && t.y <= Math.max(e1.y, r.y) && t.y >= Math.min(e1.y, r.y);
        }
        function eu(e1) {
            return e1 > 0 ? 1 : e1 < 0 ? -1 : 0;
        }
        function tu(e1, t) {
            return Kl(e1.prev, e1, e1.next) < 0 ? Kl(e1, t, e1.next) >= 0 && Kl(e1, e1.prev, t) >= 0 : Kl(e1, t, e1.prev) < 0 || Kl(e1, e1.next, t) < 0;
        }
        function ru(e1, t) {
            const r = su(e1.i, e1.x, e1.y), n = su(t.i, t.x, t.y), i = e1.next, s = t.prev;
            return e1.next = t, t.prev = e1, r.next = i, i.prev = r, n.next = r, r.prev = n, s.next = n, n.prev = s, n;
        }
        function nu(e1, t, r, n) {
            const i = su(e1, t, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function iu(e1) {
            e1.next.prev = e1.prev, e1.prev.next = e1.next, e1.prevZ && (e1.prevZ.nextZ = e1.nextZ), e1.nextZ && (e1.nextZ.prevZ = e1.prevZ);
        }
        function su(e1, t, r) {
            return {
                i: e1,
                x: t,
                y: r,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        class ou {
            constructor(e1, t){
                if (t > e1) throw new Error("Min granularity must not be greater than base granularity.");
                this._baseZoomGranularity = e1, this._minGranularity = t;
            }
            getGranularityForZoomLevel(e1) {
                return Math.max(Math.floor(this._baseZoomGranularity / (1 << e1)), this._minGranularity, 1);
            }
        }
        class au {
            constructor(e1){
                this.fill = e1.fill, this.line = e1.line, this.tile = e1.tile, this.stencil = e1.stencil, this.circle = e1.circle;
            }
        }
        au.noSubdivision = new au({
            fill: new ou(0, 0),
            line: new ou(0, 0),
            tile: new ou(0, 0),
            stencil: new ou(0, 0),
            circle: 1
        }), ls("SubdivisionGranularityExpression", ou), ls("SubdivisionGranularitySetting", au);
        const lu = -32768, uu = 32767;
        class cu {
            constructor(e1, t){
                this._vertexBuffer = [], this._vertexDictionary = new Map, this._used = !1, this._granularity = e1, this._granularityCellSize = k / e1, this._canonical = t;
            }
            _getKey(e1, t) {
                return (e1 += 32768) << 16 | t + 32768;
            }
            _vertexToIndex(e1, t) {
                if (e1 < -32768 || t < -32768 || e1 > 32767 || t > 32767) throw new Error("Vertex coordinates are out of signed 16 bit integer range.");
                const r = 0 | Math.round(e1), n = 0 | Math.round(t), i = this._getKey(r, n);
                if (this._vertexDictionary.has(i)) return this._vertexDictionary.get(i);
                const s = this._vertexBuffer.length / 2;
                return this._vertexDictionary.set(i, s), this._vertexBuffer.push(r, n), s;
            }
            _subdivideTrianglesScanline(e1) {
                if (this._granularity < 2) return function(e1, t) {
                    const r = [];
                    for(let n = 0; n < t.length; n += 3){
                        const i = t[n], s = t[n + 1], o = t[n + 2], a = e1[2 * i], l = e1[2 * i + 1];
                        (e1[2 * s] - a) * (e1[2 * o + 1] - l) - (e1[2 * s + 1] - l) * (e1[2 * o] - a) > 0 ? (r.push(i), r.push(o), r.push(s)) : (r.push(i), r.push(s), r.push(o));
                    }
                    return r;
                }(this._vertexBuffer, e1);
                const t = [], r = e1.length;
                for(let n = 0; n < r; n += 3){
                    const r = [
                        e1[n + 0],
                        e1[n + 1],
                        e1[n + 2]
                    ], i = [
                        this._vertexBuffer[2 * e1[n + 0] + 0],
                        this._vertexBuffer[2 * e1[n + 0] + 1],
                        this._vertexBuffer[2 * e1[n + 1] + 0],
                        this._vertexBuffer[2 * e1[n + 1] + 1],
                        this._vertexBuffer[2 * e1[n + 2] + 0],
                        this._vertexBuffer[2 * e1[n + 2] + 1]
                    ];
                    let s = 1 / 0, o = 1 / 0, a = -1 / 0, l = -1 / 0;
                    for(let e1 = 0; e1 < 3; e1++){
                        const t = i[2 * e1], r = i[2 * e1 + 1];
                        s = Math.min(s, t), a = Math.max(a, t), o = Math.min(o, r), l = Math.max(l, r);
                    }
                    if (s === a || o === l) continue;
                    const u = Math.floor(s / this._granularityCellSize), c = Math.ceil(a / this._granularityCellSize), h = Math.floor(o / this._granularityCellSize), p = Math.ceil(l / this._granularityCellSize);
                    if (u !== c || h !== p) for(let e1 = h; e1 < p; e1++){
                        const n = this._scanlineGenerateVertexRingForCellRow(e1, i, r);
                        fu(this._vertexBuffer, n, t);
                    }
                    else t.push(...r);
                }
                return t;
            }
            _scanlineGenerateVertexRingForCellRow(e1, t, r) {
                const n = e1 * this._granularityCellSize, i = n + this._granularityCellSize, s = [];
                for(let e1 = 0; e1 < 3; e1++){
                    const o = t[2 * e1], a = t[2 * e1 + 1], l = t[2 * (e1 + 1) % 6], u = t[(2 * (e1 + 1) + 1) % 6], c = t[2 * (e1 + 2) % 6], h = t[(2 * (e1 + 2) + 1) % 6], p = l - o, f = u - a, d = 0 === p, y = 0 === f, m = (n - a) / f, g = (i - a) / f, x = Math.min(m, g), v = Math.max(m, g);
                    if (!y && (x >= 1 || v <= 0) || y && (a < n || a > i)) {
                        u >= n && u <= i && s.push(r[(e1 + 1) % 3]);
                        continue;
                    }
                    !y && x > 0 && s.push(this._vertexToIndex(o + p * x, a + f * x));
                    const b = o + p * Math.max(x, 0), w = o + p * Math.min(v, 1);
                    d || this._generateIntraEdgeVertices(s, o, a, l, u, b, w), !y && v < 1 && s.push(this._vertexToIndex(o + p * v, a + f * v)), (y || u >= n && u <= i) && s.push(r[(e1 + 1) % 3]), !y && (u <= n || u >= i) && this._generateInterEdgeVertices(s, o, a, l, u, c, h, w, n, i);
                }
                return s;
            }
            _generateIntraEdgeVertices(e1, t, r, n, i, s, o) {
                const a = n - t, l = i - r, u = 0 === l, c = u ? Math.min(t, n) : Math.min(s, o), h = u ? Math.max(t, n) : Math.max(s, o), p = Math.floor(c / this._granularityCellSize) + 1, f = Math.ceil(h / this._granularityCellSize) - 1;
                if (u ? t < n : s < o) for(let n = p; n <= f; n++){
                    const i = n * this._granularityCellSize;
                    e1.push(this._vertexToIndex(i, r + l * (i - t) / a));
                }
                else for(let n = f; n >= p; n--){
                    const i = n * this._granularityCellSize;
                    e1.push(this._vertexToIndex(i, r + l * (i - t) / a));
                }
            }
            _generateInterEdgeVertices(e1, t, r, n, i, s, o, a, l, u) {
                const c = i - r, h = s - n, p = o - i, f = (l - i) / p, d = (u - i) / p, y = Math.min(f, d), m = Math.max(f, d), g = n + h * y;
                let x = Math.floor(Math.min(g, a) / this._granularityCellSize) + 1, v = Math.ceil(Math.max(g, a) / this._granularityCellSize) - 1, b = a < g;
                const w = 0 === p;
                if (w && (o === l || o === u)) return;
                if (w || y >= 1 || m <= 0) {
                    const e1 = r - o, n = s + (t - s) * Math.min((l - o) / e1, (u - o) / e1);
                    x = Math.floor(Math.min(n, a) / this._granularityCellSize) + 1, v = Math.ceil(Math.max(n, a) / this._granularityCellSize) - 1, b = a < n;
                }
                const _ = c > 0 ? u : l;
                if (b) for(let t = x; t <= v; t++)e1.push(this._vertexToIndex(t * this._granularityCellSize, _));
                else for(let t = v; t >= x; t--)e1.push(this._vertexToIndex(t * this._granularityCellSize, _));
            }
            _generateOutline(e1) {
                const t = [];
                for (const r of e1){
                    const e1 = pu(r, this._granularity, !0), n = this._pointArrayToIndices(e1), i = [];
                    for(let e1 = 1; e1 < n.length; e1++)i.push(n[e1 - 1]), i.push(n[e1]);
                    t.push(i);
                }
                return t;
            }
            _handlePoles(e1) {
                let t = !1, r = !1;
                this._canonical && (0 === this._canonical.y && (t = !0), this._canonical.y === (1 << this._canonical.z) - 1 && (r = !0)), (t || r) && this._fillPoles(e1, t, r);
            }
            _ensureNoPoleVertices() {
                const e1 = this._vertexBuffer;
                for(let t = 0; t < e1.length; t += 2){
                    const r = e1[t + 1];
                    r === lu && (e1[t + 1] = -32767), r === uu && (e1[t + 1] = 32766);
                }
            }
            _generatePoleQuad(e1, t, r, n, i, s) {
                n > i != (s === lu) ? (e1.push(t), e1.push(r), e1.push(this._vertexToIndex(n, s)), e1.push(r), e1.push(this._vertexToIndex(i, s)), e1.push(this._vertexToIndex(n, s))) : (e1.push(r), e1.push(t), e1.push(this._vertexToIndex(n, s)), e1.push(this._vertexToIndex(i, s)), e1.push(r), e1.push(this._vertexToIndex(n, s)));
            }
            _fillPoles(e1, t, r) {
                const n = this._vertexBuffer, i = k, s = e1.length;
                for(let o = 2; o < s; o += 3){
                    const s = e1[o - 2], a = e1[o - 1], l = e1[o], u = n[2 * s], c = n[2 * s + 1], h = n[2 * a], p = n[2 * a + 1], f = n[2 * l], d = n[2 * l + 1];
                    t && (0 === c && 0 === p && this._generatePoleQuad(e1, s, a, u, h, lu), 0 === p && 0 === d && this._generatePoleQuad(e1, a, l, h, f, lu), 0 === d && 0 === c && this._generatePoleQuad(e1, l, s, f, u, lu)), r && (c === i && p === i && this._generatePoleQuad(e1, s, a, u, h, uu), p === i && d === i && this._generatePoleQuad(e1, a, l, h, f, uu), d === i && c === i && this._generatePoleQuad(e1, l, s, f, u, uu));
                }
            }
            _initializeVertices(e1) {
                for(let t = 0; t < e1.length; t += 2)this._vertexToIndex(e1[t], e1[t + 1]);
            }
            subdividePolygonInternal(e1, t) {
                if (this._used) throw new Error("Subdivision: multiple use not allowed.");
                this._used = !0;
                const { flattened: r, holeIndices: n } = function(e1) {
                    const t = [], r = [];
                    for (const n of e1)if (0 !== n.length) {
                        n !== e1[0] && t.push(r.length / 2);
                        for(let e1 = 0; e1 < n.length; e1++)r.push(n[e1].x), r.push(n[e1].y);
                    }
                    return {
                        flattened: r,
                        holeIndices: t
                    };
                }(e1);
                let i;
                this._initializeVertices(r);
                try {
                    const e1 = function(e1, t, r = 2) {
                        const n = t && t.length, i = n ? t[0] * r : e1.length;
                        let s = Vl(e1, 0, i, r, !0);
                        const o = [];
                        if (!s || s.next === s.prev) return o;
                        let a, l, u;
                        if (n && (s = function(e1, t, r, n) {
                            const i = [];
                            for(let r = 0, s = t.length; r < s; r++){
                                const o = Vl(e1, t[r] * n, r < s - 1 ? t[r + 1] * n : e1.length, n, !1);
                                o === o.next && (o.steiner = !0), i.push(Xl(o));
                            }
                            i.sort(Ul);
                            for(let e1 = 0; e1 < i.length; e1++)r = ql(i[e1], r);
                            return r;
                        }(e1, t, s, r)), e1.length > 80 * r) {
                            a = e1[0], l = e1[1];
                            let t = a, n = l;
                            for(let s = r; s < i; s += r){
                                const r = e1[s], i = e1[s + 1];
                                r < a && (a = r), i < l && (l = i), r > t && (t = r), i > n && (n = i);
                            }
                            u = Math.max(t - a, n - l), u = 0 !== u ? 32767 / u : 0;
                        }
                        return Ll(s, o, r, a, l, u, 0), o;
                    }(r, n), t = this._convertIndices(r, e1);
                    i = this._subdivideTrianglesScanline(t);
                } catch (e1) {
                    console.error(e1);
                }
                let s = [];
                return t && (s = this._generateOutline(e1)), this._ensureNoPoleVertices(), this._handlePoles(i), {
                    verticesFlattened: this._vertexBuffer,
                    indicesTriangles: i,
                    indicesLineList: s
                };
            }
            _convertIndices(e1, t) {
                const r = [];
                for(let n = 0; n < t.length; n++)r.push(this._vertexToIndex(e1[2 * t[n]], e1[2 * t[n] + 1]));
                return r;
            }
            _pointArrayToIndices(e1) {
                const t = [];
                for(let r = 0; r < e1.length; r++){
                    const n = e1[r];
                    t.push(this._vertexToIndex(n.x, n.y));
                }
                return t;
            }
        }
        function hu(e1, t, r, n = !0) {
            return new cu(r, t).subdividePolygonInternal(e1, n);
        }
        function pu(e1, t, n = !1) {
            if (!e1 || e1.length < 1) return [];
            if (e1.length < 2) return [];
            const i = e1[0], s = e1[e1.length - 1], o = n && (i.x !== s.x || i.y !== s.y);
            if (t < 2) return o ? [
                ...e1,
                e1[0]
            ] : [
                ...e1
            ];
            const a = Math.floor(k / t), l = [];
            l.push(new r(e1[0].x, e1[0].y));
            const u = e1.length, c = o ? u : u - 1;
            for(let t = 0; t < c; t++){
                const n = e1[t], i = t < u - 1 ? e1[t + 1] : e1[0], s = n.x, o = n.y, c = i.x, h = i.y, p = s !== c, f = o !== h;
                if (!p && !f) continue;
                const d = c - s, y = h - o, m = Math.abs(d), g = Math.abs(y);
                let x = s, v = o;
                for(;;){
                    const e1 = d > 0 ? (Math.floor(x / a) + 1) * a : (Math.ceil(x / a) - 1) * a, t = y > 0 ? (Math.floor(v / a) + 1) * a : (Math.ceil(v / a) - 1) * a, n = Math.abs(x - e1), i = Math.abs(v - t), s = Math.abs(x - c), o = Math.abs(v - h), u = p ? n / m : Number.POSITIVE_INFINITY, b = f ? i / g : Number.POSITIVE_INFINITY;
                    if ((s <= n || !p) && (o <= i || !f)) break;
                    if (u < b && p || !f) {
                        x = e1, v += y * u;
                        const t = new r(x, Math.round(v));
                        l[l.length - 1].x === t.x && l[l.length - 1].y === t.y || l.push(t);
                    } else {
                        x += d * b, v = t;
                        const e1 = new r(Math.round(x), v);
                        l[l.length - 1].x === e1.x && l[l.length - 1].y === e1.y || l.push(e1);
                    }
                }
                const b = new r(c, h);
                l[l.length - 1].x === b.x && l[l.length - 1].y === b.y || l.push(b);
            }
            return l;
        }
        function fu(e1, t, r) {
            if (0 === t.length) throw new Error("Subdivision vertex ring is empty.");
            let n = 0, i = e1[2 * t[0]];
            for(let r = 1; r < t.length; r++){
                const s = e1[2 * t[r]];
                s < i && (i = s, n = r);
            }
            const s = t.length;
            let o = n, a = (o + 1) % s;
            for(;;){
                const n = o - 1 >= 0 ? o - 1 : s - 1, i = (a + 1) % s, l = e1[2 * t[n]], u = e1[2 * t[i]], c = e1[2 * t[o]], h = e1[2 * t[o] + 1], p = e1[2 * t[a] + 1];
                let f = !1;
                if (l < u) f = !0;
                else if (l > u) f = !1;
                else {
                    const r = p - h, s = -(e1[2 * t[a]] - c), o = h < p ? 1 : -1;
                    ((l - c) * r + (e1[2 * t[n] + 1] - h) * s) * o > ((u - c) * r + (e1[2 * t[i] + 1] - h) * s) * o && (f = !0);
                }
                if (f) {
                    const e1 = t[n], i = t[o], l = t[a];
                    e1 !== i && e1 !== l && i !== l && r.push(l, i, e1), o--, o < 0 && (o = s - 1);
                } else {
                    const e1 = t[i], n = t[o], l = t[a];
                    e1 !== n && e1 !== l && n !== l && r.push(l, n, e1), a++, a >= s && (a = 0);
                }
                if (n === i) break;
            }
        }
        function du(e1, t, r, n, i, s, o, a, l) {
            const u = i.length / 2, c = o && a && l;
            if (u < ta.MAX_VERTEX_ARRAY_LENGTH) {
                const h = t.prepareSegment(u, r, n), p = h.vertexLength;
                for(let e1 = 0; e1 < s.length; e1 += 3)n.emplaceBack(p + s[e1], p + s[e1 + 1], p + s[e1 + 2]);
                let f, d;
                h.vertexLength += u, h.primitiveLength += s.length / 3, c && (d = o.prepareSegment(u, r, a), f = d.vertexLength, d.vertexLength += u);
                for(let t = 0; t < i.length; t += 2)e1(i[t], i[t + 1]);
                if (c) for(let e1 = 0; e1 < l.length; e1++){
                    const t = l[e1];
                    for(let e1 = 1; e1 < t.length; e1 += 2)a.emplaceBack(f + t[e1 - 1], f + t[e1]);
                    d.primitiveLength += t.length / 2;
                }
            } else !function(e1, t, r, n, i, s) {
                const o = [];
                for(let e1 = 0; e1 < n.length / 2; e1++)o.push(-1);
                const a = {
                    count: 0
                };
                let l = 0, u = e1.getOrCreateLatestSegment(t, r), c = u.vertexLength;
                for(let h = 2; h < i.length; h += 3){
                    const p = i[h - 2], f = i[h - 1], d = i[h];
                    let y = o[p] < l, m = o[f] < l, g = o[d] < l;
                    u.vertexLength + ((y ? 1 : 0) + (m ? 1 : 0) + (g ? 1 : 0)) > ta.MAX_VERTEX_ARRAY_LENGTH && (u = e1.createNewSegment(t, r), l = a.count, y = !0, m = !0, g = !0, c = 0);
                    const x = yu(o, n, s, a, p, y, u), v = yu(o, n, s, a, f, m, u), b = yu(o, n, s, a, d, g, u);
                    r.emplaceBack(c + x - l, c + v - l, c + b - l), u.primitiveLength++;
                }
            }(t, r, n, i, s, e1), c && function(e1, t, r, n, i, s) {
                const o = [];
                for(let e1 = 0; e1 < n.length / 2; e1++)o.push(-1);
                const a = {
                    count: 0
                };
                let l = 0, u = e1.getOrCreateLatestSegment(t, r), c = u.vertexLength;
                for(let h = 0; h < i.length; h++){
                    const p = i[h];
                    for(let f = 1; f < i[h].length; f += 2){
                        const i = p[f - 1], h = p[f];
                        let d = o[i] < l, y = o[h] < l;
                        u.vertexLength + ((d ? 1 : 0) + (y ? 1 : 0)) > ta.MAX_VERTEX_ARRAY_LENGTH && (u = e1.createNewSegment(t, r), l = a.count, d = !0, y = !0, c = 0);
                        const m = yu(o, n, s, a, i, d, u), g = yu(o, n, s, a, h, y, u);
                        r.emplaceBack(c + m - l, c + g - l), u.primitiveLength++;
                    }
                }
            }(o, r, a, i, l, e1), t.forceNewSegmentOnNextPrepare(), null == o || o.forceNewSegmentOnNextPrepare();
        }
        function yu(e1, t, r, n, i, s, o) {
            if (s) {
                const s = n.count;
                return r(t[2 * i], t[2 * i + 1]), e1[i] = n.count, n.count++, o.vertexLength++, s;
            }
            return e1[i];
        }
        class mu {
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.id), this.index = e1.index, this.hasDependencies = !1, this.patternFeatures = [], this.layoutVertexArray = new No, this.indexArray = new Wo, this.indexArray2 = new Jo, this.programConfigurations = new Da(e1.layers, e1.zoom), this.segments = new ta, this.segments2 = new ta, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
            }
            populate(e1, t, r) {
                this.hasDependencies = Bl("fill", this.layers, t);
                const n = this.layers[0].layout.get("fill-sort-key"), i = !n.isConstant(), s = [];
                for (const { feature: o, id: a, index: l, sourceLayerIndex: u } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = La(o, e1);
                    if (!this.layers[0]._featureFilter.filter(new ks(this.zoom), c, r)) continue;
                    const h = i ? n.evaluate(c, {}, r, t.availableImages) : void 0, p = {
                        id: a,
                        properties: o.properties,
                        type: o.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: e1 ? c.geometry : Ca(o),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(p);
                }
                i && s.sort((e1, t)=>e1.sortKey - t.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: o } = n;
                    if (this.hasDependencies) {
                        const e1 = zl("fill", this.layers, n, {
                            zoom: this.zoom
                        }, t);
                        this.patternFeatures.push(e1);
                    } else this.addFeature(n, i, s, r, {}, t.subdivisionGranularity);
                    t.featureIndex.insert(e1[s].feature, i, s, o, this.index);
                }
            }
            update(e1, t, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e1, t, this.stateDependentLayers, {
                    imagePositions: r
                });
            }
            addFeatures(e1, t, r) {
                for (const n of this.patternFeatures)this.addFeature(n, n.geometry, n.index, t, r, e1.subdivisionGranularity);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, Pl), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.indexBuffer2 = e1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(e1, t, r, n, i, s) {
                for (const e1 of Qr(t, 500)){
                    const t = hu(e1, n, s.fill.getGranularityForZoomLevel(n.z)), r = this.layoutVertexArray;
                    du((e1, t)=>{
                        r.emplaceBack(e1, t);
                    }, this.segments, this.layoutVertexArray, this.indexArray, t.verticesFlattened, t.indicesTriangles, this.segments2, this.indexArray2, t.indicesLineList);
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, r, {
                    imagePositions: i,
                    canonical: n
                });
            }
        }
        let gu, xu;
        ls("FillBucket", mu, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var vu = {
            get paint () {
                return xu = xu || new Gs({
                    "fill-antialias": new Ns(xe.paint_fill["fill-antialias"]),
                    "fill-opacity": new $s(xe.paint_fill["fill-opacity"]),
                    "fill-color": new $s(xe.paint_fill["fill-color"]),
                    "fill-outline-color": new $s(xe.paint_fill["fill-outline-color"]),
                    "fill-translate": new Ns(xe.paint_fill["fill-translate"]),
                    "fill-translate-anchor": new Ns(xe.paint_fill["fill-translate-anchor"]),
                    "fill-pattern": new Us(xe.paint_fill["fill-pattern"])
                });
            },
            get layout () {
                return gu = gu || new Gs({
                    "fill-sort-key": new $s(xe.layout_fill["fill-sort-key"])
                });
            }
        };
        class bu extends Xs {
            constructor(e1, t){
                super(e1, vu, t);
            }
            recalculate(e1, t) {
                super.recalculate(e1, t);
                const r = this.paint._values["fill-outline-color"];
                "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
            }
            createBucket(e1) {
                return new mu(e1);
            }
            queryRadius() {
                return Qa(this.paint.get("fill-translate"));
            }
            queryIntersectsFeature({ queryGeometry: e1, geometry: t, transform: r, pixelsToTileUnits: n }) {
                return qa(el(e1, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), -r.bearingInRadians, n), t);
            }
            isTileClipped() {
                return !0;
            }
        }
        const wu = Qs([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_normal_ed",
                components: 4,
                type: "Int16"
            }
        ], 4), _u = Qs([
            {
                name: "a_centroid",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Su } = wu;
        class Au {
            constructor(e1, t, r, n, i){
                this.properties = {}, this.extent = r, this.type = 0, this.id = void 0, this._pbf = e1, this._geometry = -1, this._keys = n, this._values = i, e1.readFields(Tu, this, t);
            }
            loadGeometry() {
                const e1 = this._pbf;
                e1.pos = this._geometry;
                const t = e1.readVarint() + e1.pos, n = [];
                let i, s = 1, o = 0, a = 0, l = 0;
                for(; e1.pos < t;){
                    if (o <= 0) {
                        const t = e1.readVarint();
                        s = 7 & t, o = t >> 3;
                    }
                    if (o--, 1 === s || 2 === s) a += e1.readSVarint(), l += e1.readSVarint(), 1 === s && (i && n.push(i), i = []), i && i.push(new r(a, l));
                    else {
                        if (7 !== s) throw new Error(`unknown command ${s}`);
                        i && i.push(i[0].clone());
                    }
                }
                return i && n.push(i), n;
            }
            bbox() {
                const e1 = this._pbf;
                e1.pos = this._geometry;
                const t = e1.readVarint() + e1.pos;
                let r = 1, n = 0, i = 0, s = 0, o = 1 / 0, a = -1 / 0, l = 1 / 0, u = -1 / 0;
                for(; e1.pos < t;){
                    if (n <= 0) {
                        const t = e1.readVarint();
                        r = 7 & t, n = t >> 3;
                    }
                    if (n--, 1 === r || 2 === r) i += e1.readSVarint(), s += e1.readSVarint(), i < o && (o = i), i > a && (a = i), s < l && (l = s), s > u && (u = s);
                    else if (7 !== r) throw new Error(`unknown command ${r}`);
                }
                return [
                    o,
                    l,
                    a,
                    u
                ];
            }
            toGeoJSON(e1, t, r) {
                const n = this.extent * Math.pow(2, r), i = this.extent * e1, s = this.extent * t, o = this.loadGeometry();
                function a(e1) {
                    return [
                        360 * (e1.x + i) / n - 180,
                        360 / Math.PI * Math.atan(Math.exp((1 - 2 * (e1.y + s) / n) * Math.PI)) - 90
                    ];
                }
                function l(e1) {
                    return e1.map(a);
                }
                let u;
                if (1 === this.type) {
                    const e1 = [];
                    for (const t of o)e1.push(t[0]);
                    const t = l(e1);
                    u = 1 === e1.length ? {
                        type: "Point",
                        coordinates: t[0]
                    } : {
                        type: "MultiPoint",
                        coordinates: t
                    };
                } else if (2 === this.type) {
                    const e1 = o.map(l);
                    u = 1 === e1.length ? {
                        type: "LineString",
                        coordinates: e1[0]
                    } : {
                        type: "MultiLineString",
                        coordinates: e1
                    };
                } else {
                    if (3 !== this.type) throw new Error("unknown feature type");
                    {
                        const e1 = function(e1) {
                            const t = e1.length;
                            if (t <= 1) return [
                                e1
                            ];
                            const r = [];
                            let n, i;
                            for(let s = 0; s < t; s++){
                                const t = Iu(e1[s]);
                                0 !== t && (void 0 === i && (i = t < 0), i === t < 0 ? (n && r.push(n), n = [
                                    e1[s]
                                ]) : n && n.push(e1[s]));
                            }
                            return n && r.push(n), r;
                        }(o), t = [];
                        for (const r of e1)t.push(r.map(l));
                        u = 1 === t.length ? {
                            type: "Polygon",
                            coordinates: t[0]
                        } : {
                            type: "MultiPolygon",
                            coordinates: t
                        };
                    }
                }
                const c = {
                    type: "Feature",
                    geometry: u,
                    properties: this.properties
                };
                return null != this.id && (c.id = this.id), c;
            }
        }
        function Tu(e1, t, r) {
            1 === e1 ? t.id = r.readVarint() : 2 === e1 ? function(e1, t) {
                const r = e1.readVarint() + e1.pos;
                for(; e1.pos < r;){
                    const r = t._keys[e1.readVarint()], n = t._values[e1.readVarint()];
                    t.properties[r] = n;
                }
            }(r, t) : 3 === e1 ? t.type = r.readVarint() : 4 === e1 && (t._geometry = r.pos);
        }
        function Iu(e1) {
            let t = 0;
            for(let r, n, i = 0, s = e1.length, o = s - 1; i < s; o = i++)r = e1[i], n = e1[o], t += (n.x - r.x) * (r.y + n.y);
            return t;
        }
        Au.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class Eu {
            constructor(e1, t){
                this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = e1, this._keys = [], this._values = [], this._features = [], e1.readFields(Mu, this, t), this.length = this._features.length;
            }
            feature(e1) {
                if (e1 < 0 || e1 >= this._features.length) throw new Error("feature index out of bounds");
                this._pbf.pos = this._features[e1];
                const t = this._pbf.readVarint() + this._pbf.pos;
                return new Au(this._pbf, t, this.extent, this._keys, this._values);
            }
        }
        function Mu(e1, t, r) {
            15 === e1 ? t.version = r.readVarint() : 1 === e1 ? t.name = r.readString() : 5 === e1 ? t.extent = r.readVarint() : 2 === e1 ? t._features.push(r.pos) : 3 === e1 ? t._keys.push(r.readString()) : 4 === e1 && t._values.push(function(e1) {
                let t = null;
                const r = e1.readVarint() + e1.pos;
                for(; e1.pos < r;){
                    const r = e1.readVarint() >> 3;
                    t = 1 === r ? e1.readString() : 2 === r ? e1.readFloat() : 3 === r ? e1.readDouble() : 4 === r ? e1.readVarint64() : 5 === r ? e1.readVarint() : 6 === r ? e1.readSVarint() : 7 === r ? e1.readBoolean() : null;
                }
                if (null == t) throw new Error("unknown feature value");
                return t;
            }(r));
        }
        class ku {
            constructor(e1, t){
                this.layers = e1.readFields(Fu, {}, t);
            }
        }
        function Fu(e1, t, r) {
            if (3 === e1) {
                const e1 = new Eu(r, r.readVarint() + r.pos);
                e1.length && (t[e1.name] = e1);
            }
        }
        const Du = Math.pow(2, 13);
        function Pu(e1, t, r, n, i, s, o, a) {
            e1.emplaceBack(t, r, 2 * Math.floor(n * Du) + o, i * Du * 2, s * Du * 2, Math.round(a));
        }
        class Bu {
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.id), this.index = e1.index, this.hasDependencies = !1, this.layoutVertexArray = new $o, this.centroidVertexArray = new Oo, this.indexArray = new Wo, this.programConfigurations = new Da(e1.layers, e1.zoom), this.segments = new ta, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
            }
            populate(e1, t, r) {
                this.features = [], this.hasDependencies = Bl("fill-extrusion", this.layers, t);
                for (const { feature: n, id: i, index: s, sourceLayerIndex: o } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, a = La(n, e1);
                    if (!this.layers[0]._featureFilter.filter(new ks(this.zoom), a, r)) continue;
                    const l = {
                        id: i,
                        sourceLayerIndex: o,
                        index: s,
                        geometry: e1 ? a.geometry : Ca(n),
                        properties: n.properties,
                        type: n.type,
                        patterns: {}
                    };
                    this.hasDependencies ? this.features.push(zl("fill-extrusion", this.layers, l, {
                        zoom: this.zoom
                    }, t)) : this.addFeature(l, l.geometry, s, r, {}, t.subdivisionGranularity), t.featureIndex.insert(n, l.geometry, s, o, this.index, !0);
                }
            }
            addFeatures(e1, t, r) {
                for (const n of this.features){
                    const { geometry: i } = n;
                    this.addFeature(n, i, n.index, t, r, e1.subdivisionGranularity);
                }
            }
            update(e1, t, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e1, t, this.stateDependentLayers, {
                    imagePositions: r
                });
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, Su), this.centroidVertexBuffer = e1.createVertexBuffer(this.centroidVertexArray, _u.members, !0), this.indexBuffer = e1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
            }
            addFeature(e1, t, r, n, i, s) {
                for (const r of Qr(t, 500)){
                    const t = {
                        x: 0,
                        y: 0,
                        sampleCount: 0
                    }, i = this.layoutVertexArray.length;
                    this.processPolygon(t, n, e1, r, s);
                    const o = this.layoutVertexArray.length - i, a = Math.floor(t.x / t.sampleCount), l = Math.floor(t.y / t.sampleCount);
                    for(let e1 = 0; e1 < o; e1++)this.centroidVertexArray.emplaceBack(a, l);
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, r, {
                    imagePositions: i,
                    canonical: n
                });
            }
            processPolygon(e1, t, r, n, i) {
                if (n.length < 1) return;
                if (Cu(n[0])) return;
                for (const t of n)0 !== t.length && zu(e1, t);
                const s = {
                    segment: this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray)
                }, o = i.fill.getGranularityForZoomLevel(t.z), a = "Polygon" === Au.types[r.type];
                for (const e1 of n){
                    if (0 === e1.length) continue;
                    if (Cu(e1)) continue;
                    const t = pu(e1, o, a);
                    this._generateSideFaces(t, s);
                }
                if (!a) return;
                const l = hu(n, t, o, !1), u = this.layoutVertexArray;
                du((e1, t)=>{
                    Pu(u, e1, t, 0, 0, 1, 1, 0);
                }, this.segments, this.layoutVertexArray, this.indexArray, l.verticesFlattened, l.indicesTriangles);
            }
            _generateSideFaces(e1, t) {
                let r = 0;
                for(let n = 1; n < e1.length; n++){
                    const i = e1[n], s = e1[n - 1];
                    if (Vu(i, s)) continue;
                    t.segment.vertexLength + 4 > ta.MAX_VERTEX_ARRAY_LENGTH && (t.segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                    const o = i.sub(s)._perp()._unit(), a = s.dist(i);
                    r + a > 32768 && (r = 0), Pu(this.layoutVertexArray, i.x, i.y, o.x, o.y, 0, 0, r), Pu(this.layoutVertexArray, i.x, i.y, o.x, o.y, 0, 1, r), r += a, Pu(this.layoutVertexArray, s.x, s.y, o.x, o.y, 0, 0, r), Pu(this.layoutVertexArray, s.x, s.y, o.x, o.y, 0, 1, r);
                    const l = t.segment.vertexLength;
                    this.indexArray.emplaceBack(l, l + 2, l + 1), this.indexArray.emplaceBack(l + 1, l + 2, l + 3), t.segment.vertexLength += 4, t.segment.primitiveLength += 2;
                }
            }
        }
        function zu(e1, t) {
            for(let r = 0; r < t.length; r++){
                const n = t[r];
                r === t.length - 1 && t[0].x === n.x && t[0].y === n.y || (e1.x += n.x, e1.y += n.y, e1.sampleCount++);
            }
        }
        function Vu(e1, t) {
            return e1.x === t.x && (e1.x < 0 || e1.x > k) || e1.y === t.y && (e1.y < 0 || e1.y > k);
        }
        function Cu(e1) {
            return e1.every((e1)=>e1.x < 0) || e1.every((e1)=>e1.x > k) || e1.every((e1)=>e1.y < 0) || e1.every((e1)=>e1.y > k);
        }
        let Lu;
        ls("FillExtrusionBucket", Bu, {
            omit: [
                "layers",
                "features"
            ]
        });
        var Ou = {
            get paint () {
                return Lu = Lu || new Gs({
                    "fill-extrusion-opacity": new Ns(xe["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                    "fill-extrusion-color": new $s(xe["paint_fill-extrusion"]["fill-extrusion-color"]),
                    "fill-extrusion-translate": new Ns(xe["paint_fill-extrusion"]["fill-extrusion-translate"]),
                    "fill-extrusion-translate-anchor": new Ns(xe["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                    "fill-extrusion-pattern": new Us(xe["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                    "fill-extrusion-height": new $s(xe["paint_fill-extrusion"]["fill-extrusion-height"]),
                    "fill-extrusion-base": new $s(xe["paint_fill-extrusion"]["fill-extrusion-base"]),
                    "fill-extrusion-vertical-gradient": new Ns(xe["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                });
            }
        };
        class Ru extends Xs {
            constructor(e1, t){
                super(e1, Ou, t);
            }
            createBucket(e1) {
                return new Bu(e1);
            }
            queryRadius() {
                return Qa(this.paint.get("fill-extrusion-translate"));
            }
            is3D() {
                return !0;
            }
            queryIntersectsFeature({ queryGeometry: e1, feature: t, featureState: n, geometry: i, transform: s, pixelsToTileUnits: o, pixelPosMatrix: a }) {
                const l = el(e1, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), -s.bearingInRadians, o), u = this.paint.get("fill-extrusion-height").evaluate(t, n), c = this.paint.get("fill-extrusion-base").evaluate(t, n), h = function(e1, t) {
                    const n = [];
                    for (const i of e1){
                        const e1 = [
                            i.x,
                            i.y,
                            0,
                            1
                        ];
                        A(e1, e1, t), n.push(new r(e1[0] / e1[3], e1[1] / e1[3]));
                    }
                    return n;
                }(l, a), p = function(e1, t, n, i) {
                    const s = [], o = [], a = i[8] * t, l = i[9] * t, u = i[10] * t, c = i[11] * t, h = i[8] * n, p = i[9] * n, f = i[10] * n, d = i[11] * n;
                    for (const t of e1){
                        const e1 = [], n = [];
                        for (const s of t){
                            const t = s.x, o = s.y, y = i[0] * t + i[4] * o + i[12], m = i[1] * t + i[5] * o + i[13], g = i[2] * t + i[6] * o + i[14], x = i[3] * t + i[7] * o + i[15], v = g + u, b = x + c, w = y + h, _ = m + p, S = g + f, A = x + d, T = new r((y + a) / b, (m + l) / b);
                            T.z = v / b, e1.push(T);
                            const I = new r(w / A, _ / A);
                            I.z = S / A, n.push(I);
                        }
                        s.push(e1), o.push(n);
                    }
                    return [
                        s,
                        o
                    ];
                }(i, c, u, a);
                return function(e1, t, r) {
                    let n = 1 / 0;
                    qa(r, t) && (n = $u(r, t[0]));
                    for(let i = 0; i < t.length; i++){
                        const s = t[i], o = e1[i];
                        for(let e1 = 0; e1 < s.length - 1; e1++){
                            const t = s[e1], i = [
                                t,
                                s[e1 + 1],
                                o[e1 + 1],
                                o[e1],
                                t
                            ];
                            $a(r, i) && (n = Math.min(n, $u(r, i)));
                        }
                    }
                    return n !== 1 / 0 && n;
                }(p[0], p[1], h);
            }
        }
        function Nu(e1, t) {
            return e1.x * t.x + e1.y * t.y;
        }
        function $u(e1, t) {
            if (1 === e1.length) {
                let r = 0;
                const n = t[r++];
                let i;
                for(; !i || n.equals(i);)if (i = t[r++], !i) return 1 / 0;
                for(; r < t.length; r++){
                    const s = t[r], o = e1[0], a = i.sub(n), l = s.sub(n), u = o.sub(n), c = Nu(a, a), h = Nu(a, l), p = Nu(l, l), f = Nu(u, a), d = Nu(u, l), y = c * p - h * h, m = (p * f - h * d) / y, g = (c * d - h * f) / y, x = n.z * (1 - m - g) + i.z * m + s.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let e1 = 1 / 0;
                for (const r of t)e1 = Math.min(e1, r.z);
                return e1;
            }
        }
        const Uu = Qs([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            }
        ], 4), { members: qu } = Uu, ju = Qs([
            {
                name: "a_uv_x",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_split_index",
                components: 1,
                type: "Float32"
            }
        ]), { members: Gu } = ju, Xu = Math.cos(Math.PI / 180 * 37.5), Yu = Math.pow(2, 14) / .5;
        class Zu {
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.id), this.index = e1.index, this.hasDependencies = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((e1)=>{
                    this.gradients[e1.id] = {};
                }), this.layoutVertexArray = new Uo, this.layoutVertexArray2 = new qo, this.indexArray = new Wo, this.programConfigurations = new Da(e1.layers, e1.zoom), this.segments = new ta, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
            }
            populate(e1, t, r) {
                this.hasDependencies = Bl("line", this.layers, t) || this.hasLineDasharray(this.layers);
                const n = this.layers[0].layout.get("line-sort-key"), i = !n.isConstant(), s = [];
                for (const { feature: t, id: o, index: a, sourceLayerIndex: l } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, u = La(t, e1);
                    if (!this.layers[0]._featureFilter.filter(new ks(this.zoom), u, r)) continue;
                    const c = i ? n.evaluate(u, {}, r) : void 0, h = {
                        id: o,
                        properties: t.properties,
                        type: t.type,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: e1 ? u.geometry : Ca(t),
                        patterns: {},
                        dashes: {},
                        sortKey: c
                    };
                    s.push(h);
                }
                i && s.sort((e1, t)=>e1.sortKey - t.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: o } = n;
                    this.hasDependencies ? (Bl("line", this.layers, t) ? zl("line", this.layers, n, {
                        zoom: this.zoom
                    }, t) : this.hasLineDasharray(this.layers) && this.addLineDashDependencies(this.layers, n, this.zoom, t), this.patternFeatures.push(n)) : this.addFeature(n, i, s, r, {}, {}, t.subdivisionGranularity), t.featureIndex.insert(e1[s].feature, i, s, o, this.index);
                }
            }
            update(e1, t, r, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e1, t, this.stateDependentLayers, {
                    imagePositions: r,
                    dashPositions: n
                });
            }
            addFeatures(e1, t, r, n) {
                for (const i of this.patternFeatures)this.addFeature(i, i.geometry, i.index, t, r, n, e1.subdivisionGranularity);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = e1.createVertexBuffer(this.layoutVertexArray2, Gu)), this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, qu), this.indexBuffer = e1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(e1) {
                if (e1.properties && Object.prototype.hasOwnProperty.call(e1.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(e1.properties, "mapbox_clip_end")) return {
                    start: +e1.properties.mapbox_clip_start,
                    end: +e1.properties.mapbox_clip_end
                };
            }
            addFeature(e1, t, r, n, i, s, o) {
                const a = this.layers[0].layout, l = a.get("line-join").evaluate(e1, {}), u = a.get("line-cap"), c = a.get("line-miter-limit"), h = a.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(e1);
                for (const r of t)this.addLine(r, e1, l, u, c, h, n, o);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, r, {
                    imagePositions: i,
                    dashPositions: s,
                    canonical: n
                });
            }
            addLine(e1, t, r, n, i, s, o, a) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, e1 = pu(e1, o ? a.line.getGranularityForZoomLevel(o.z) : 1), this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let t = 0; t < e1.length - 1; t++)this.totalDistance += e1[t].dist(e1[t + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const l = "Polygon" === Au.types[t.type];
                let u = e1.length;
                for(; u >= 2 && e1[u - 1].equals(e1[u - 2]);)u--;
                let c = 0;
                for(; c < u - 1 && e1[c].equals(e1[c + 1]);)c++;
                if (u < (l ? 3 : 2)) return;
                "bevel" === r && (i = 1.05);
                const h = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, p = this.segments.prepareSegment(10 * u, this.layoutVertexArray, this.indexArray);
                let f, d, y, m, g;
                this.e1 = this.e2 = -1, l && (f = e1[u - 2], g = e1[c].sub(f)._unit()._perp());
                for(let t = c; t < u; t++){
                    if (y = t === u - 1 ? l ? e1[c + 1] : void 0 : e1[t + 1], y && e1[t].equals(y)) continue;
                    g && (m = g), f && (d = f), f = e1[t], g = y ? y.sub(f)._unit()._perp() : m, m = m || g;
                    let o = m.add(g);
                    0 === o.x && 0 === o.y || o._unit();
                    const a = m.x * g.x + m.y * g.y, x = o.x * g.x + o.y * g.y, v = 0 !== x ? 1 / x : 1 / 0, b = 2 * Math.sqrt(2 - 2 * x), w = x < Xu && d && y, _ = m.x * g.y - m.y * g.x > 0;
                    if (w && t > c) {
                        const e1 = f.dist(d);
                        if (e1 > 2 * h) {
                            const t = f.sub(f.sub(d)._mult(h / e1)._round());
                            this.updateDistance(d, t), this.addCurrentVertex(t, m, 0, 0, p), d = t;
                        }
                    }
                    const S = d && y;
                    let A = S ? r : l ? "butt" : n;
                    if (S && "round" === A && (v < s ? A = "miter" : v <= 2 && (A = "fakeround")), "miter" === A && v > i && (A = "bevel"), "bevel" === A && (v > 2 && (A = "flipbevel"), v < i && (A = "miter")), d && this.updateDistance(d, f), "miter" === A) o._mult(v), this.addCurrentVertex(f, o, 0, 0, p);
                    else if ("flipbevel" === A) {
                        if (v > 100) o = g.mult(-1);
                        else {
                            const e1 = v * m.add(g).mag() / m.sub(g).mag();
                            o._perp()._mult(e1 * (_ ? -1 : 1));
                        }
                        this.addCurrentVertex(f, o, 0, 0, p), this.addCurrentVertex(f, o.mult(-1), 0, 0, p);
                    } else if ("bevel" === A || "fakeround" === A) {
                        const e1 = -Math.sqrt(v * v - 1), t = _ ? e1 : 0, r = _ ? 0 : e1;
                        if (d && this.addCurrentVertex(f, m, t, r, p), "fakeround" === A) {
                            const e1 = Math.round(180 * b / Math.PI / 20);
                            for(let t = 1; t < e1; t++){
                                let r = t / e1;
                                if (.5 !== r) {
                                    const e1 = r - .5;
                                    r += r * e1 * (r - 1) * ((1.0904 + a * (a * (3.55645 - 1.43519 * a) - 3.2452)) * e1 * e1 + (.848013 + a * (.215638 * a - 1.06021)));
                                }
                                const n = g.sub(m)._mult(r)._add(m)._unit()._mult(_ ? -1 : 1);
                                this.addHalfVertex(f, n.x, n.y, !1, _, 0, p);
                            }
                        }
                        y && this.addCurrentVertex(f, g, -t, -r, p);
                    } else if ("butt" === A) this.addCurrentVertex(f, o, 0, 0, p);
                    else if ("square" === A) {
                        const e1 = d ? 1 : -1;
                        this.addCurrentVertex(f, o, e1, e1, p);
                    } else "round" === A && (d && (this.addCurrentVertex(f, m, 0, 0, p), this.addCurrentVertex(f, m, 1, 1, p, !0)), y && (this.addCurrentVertex(f, g, -1, -1, p, !0), this.addCurrentVertex(f, g, 0, 0, p)));
                    if (w && t < u - 1) {
                        const e1 = f.dist(y);
                        if (e1 > 2 * h) {
                            const t = f.add(y.sub(f)._mult(h / e1)._round());
                            this.updateDistance(f, t), this.addCurrentVertex(t, g, 0, 0, p), f = t;
                        }
                    }
                }
            }
            addCurrentVertex(e1, t, r, n, i, s = !1) {
                const o = t.y * n - t.x, a = -t.y - t.x * n;
                this.addHalfVertex(e1, t.x + t.y * r, t.y - t.x * r, s, !1, r, i), this.addHalfVertex(e1, o, a, s, !0, -n, i), this.distance > Yu / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(e1, t, r, n, i, s));
            }
            addHalfVertex({ x: e1, y: t }, r, n, i, s, o, a) {
                const l = .5 * (this.lineClips ? this.scaledDistance * (Yu - 1) : this.scaledDistance);
                this.layoutVertexArray.emplaceBack((e1 << 1) + (i ? 1 : 0), (t << 1) + (s ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === o ? 0 : o < 0 ? -1 : 1) | (63 & l) << 2, l >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                const u = a.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, u, this.e2), a.primitiveLength++), s ? this.e2 = u : this.e1 = u;
            }
            updateScaledDistance() {
                this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
            }
            updateDistance(e1, t) {
                this.distance += e1.dist(t), this.updateScaledDistance();
            }
            hasLineDasharray(e1) {
                for (const t of e1){
                    const e1 = t.paint.get("line-dasharray");
                    if (e1 && !e1.isConstant()) return !0;
                }
                return !1;
            }
            addLineDashDependencies(e1, t, r, n) {
                for (const i of e1){
                    const e1 = i.paint.get("line-dasharray");
                    if (!e1 || "constant" === e1.value.kind) continue;
                    const s = "round" === i.layout.get("line-cap"), o = {
                        dasharray: e1.value.evaluate({
                            zoom: r - 1
                        }, t, {}),
                        round: s
                    }, a = {
                        dasharray: e1.value.evaluate({
                            zoom: r
                        }, t, {}),
                        round: s
                    }, l = {
                        dasharray: e1.value.evaluate({
                            zoom: r + 1
                        }, t, {}),
                        round: s
                    }, u = `${o.dasharray.join(",")},${o.round}`, c = `${a.dasharray.join(",")},${a.round}`, h = `${l.dasharray.join(",")},${l.round}`;
                    n.dashDependencies[u] = o, n.dashDependencies[c] = a, n.dashDependencies[h] = l, t.dashes[i.id] = {
                        min: u,
                        mid: c,
                        max: h
                    };
                }
            }
        }
        let Hu, Ku;
        ls("LineBucket", Zu, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var Wu = {
            get paint () {
                return Ku = Ku || new Gs({
                    "line-opacity": new $s(xe.paint_line["line-opacity"]),
                    "line-color": new $s(xe.paint_line["line-color"]),
                    "line-translate": new Ns(xe.paint_line["line-translate"]),
                    "line-translate-anchor": new Ns(xe.paint_line["line-translate-anchor"]),
                    "line-width": new $s(xe.paint_line["line-width"]),
                    "line-gap-width": new $s(xe.paint_line["line-gap-width"]),
                    "line-offset": new $s(xe.paint_line["line-offset"]),
                    "line-blur": new $s(xe.paint_line["line-blur"]),
                    "line-dasharray": new Us(xe.paint_line["line-dasharray"]),
                    "line-pattern": new Us(xe.paint_line["line-pattern"]),
                    "line-gradient": new js(xe.paint_line["line-gradient"])
                });
            },
            get layout () {
                return Hu = Hu || new Gs({
                    "line-cap": new Ns(xe.layout_line["line-cap"]),
                    "line-join": new $s(xe.layout_line["line-join"]),
                    "line-miter-limit": new Ns(xe.layout_line["line-miter-limit"]),
                    "line-round-limit": new Ns(xe.layout_line["line-round-limit"]),
                    "line-sort-key": new $s(xe.layout_line["line-sort-key"])
                });
            }
        };
        class Ju extends $s {
            possiblyEvaluate(e1, t) {
                return t = new ks(Math.floor(t.zoom), {
                    now: t.now,
                    fadeDuration: t.fadeDuration,
                    zoomHistory: t.zoomHistory,
                    transition: t.transition
                }), super.possiblyEvaluate(e1, t);
            }
            evaluate(e1, t, r, n) {
                return t = O({}, t, {
                    zoom: Math.floor(t.zoom)
                }), super.evaluate(e1, t, r, n);
            }
        }
        let Qu;
        class ec extends Xs {
            constructor(e1, t){
                super(e1, Wu, t), this.gradientVersion = 0, Qu || (Qu = new Ju(Wu.paint.properties["line-width"].specification), Qu.useIntegerZoom = !0);
            }
            _handleSpecialPaintPropertyUpdate(e1) {
                if ("line-gradient" === e1) {
                    const e1 = this.gradientExpression();
                    this.stepInterpolant = !!function(e1) {
                        return void 0 !== e1._styleExpression;
                    }(e1) && e1._styleExpression.expression instanceof or, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                }
            }
            gradientExpression() {
                return this._transitionablePaint._values["line-gradient"].value.expression;
            }
            recalculate(e1, t) {
                super.recalculate(e1, t), this.paint._values["line-floorwidth"] = Qu.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e1);
            }
            createBucket(e1) {
                return new Zu(e1);
            }
            queryRadius(e1) {
                const t = e1, r = tc(Ja("line-width", this, t), Ja("line-gap-width", this, t)), n = Ja("line-offset", this, t);
                return r / 2 + Math.abs(n) + Qa(this.paint.get("line-translate"));
            }
            queryIntersectsFeature({ queryGeometry: e1, feature: t, featureState: n, geometry: i, transform: s, pixelsToTileUnits: o }) {
                const a = el(e1, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), -s.bearingInRadians, o), l = o / 2 * tc(this.paint.get("line-width").evaluate(t, n), this.paint.get("line-gap-width").evaluate(t, n)), u = this.paint.get("line-offset").evaluate(t, n);
                return u && (i = function(e1, t) {
                    const n = [];
                    for(let i = 0; i < e1.length; i++){
                        const s = e1[i], o = [];
                        for(let e1 = 0; e1 < s.length; e1++){
                            const n = s[e1 - 1], i = s[e1], a = s[e1 + 1], l = 0 === e1 ? new r(0, 0) : i.sub(n)._unit()._perp(), u = e1 === s.length - 1 ? new r(0, 0) : a.sub(i)._unit()._perp(), c = l._add(u)._unit(), h = c.x * u.x + c.y * u.y;
                            0 !== h && c._mult(1 / h), o.push(c._mult(t)._add(i));
                        }
                        n.push(o);
                    }
                    return n;
                }(i, u * o)), function(e1, t, r) {
                    for(let n = 0; n < t.length; n++){
                        const i = t[n];
                        if (e1.length >= 3) {
                            for(let t = 0; t < i.length; t++)if (Ka(e1, i[t])) return !0;
                        }
                        if (ja(e1, i, r)) return !0;
                    }
                    return !1;
                }(a, i, l);
            }
            isTileClipped() {
                return !0;
            }
        }
        function tc(e1, t) {
            return t > 0 ? t + 2 * e1 : e1;
        }
        const rc = Qs([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), nc = Qs([
            {
                name: "a_projected_pos",
                components: 3,
                type: "Float32"
            }
        ], 4);
        Qs([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const ic = Qs([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_box_real",
                components: 2,
                type: "Int16"
            }
        ]);
        Qs([
            {
                type: "Int16",
                name: "anchorPointX"
            },
            {
                type: "Int16",
                name: "anchorPointY"
            },
            {
                type: "Int16",
                name: "x1"
            },
            {
                type: "Int16",
                name: "y1"
            },
            {
                type: "Int16",
                name: "x2"
            },
            {
                type: "Int16",
                name: "y2"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const sc = Qs([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), oc = Qs([
            {
                name: "a_pos",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        function ac(e1, t, r) {
            return e1.sections.forEach((e1)=>{
                e1.text = function(e1, t, r) {
                    const n = t.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? e1 = e1.toLocaleUpperCase() : "lowercase" === n && (e1 = e1.toLocaleLowerCase()), Ms.applyArabicShaping && (e1 = Ms.applyArabicShaping(e1)), e1;
                }(e1.text, t, r);
            }), e1;
        }
        Qs([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Qs([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            }
        ]), Qs([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                name: "textBoxScale"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetStartIndex"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetEndIndex"
            }
        ]), Qs([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Qs([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]), Qs([
            {
                type: "Uint16",
                name: "textAnchor"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            }
        ]);
        var lc = 24;
        const uc = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u22EF": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        }, cc = {
            10: !0,
            32: !0,
            38: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        }, hc = {
            40: !0
        };
        function pc(e1, t, r, n, i, s) {
            if ("fontStack" in t) {
                const n = r[t.fontStack], s = n && n[e1];
                return s ? s.metrics.advance * t.scale + i : 0;
            }
            {
                const e1 = n[t.imageName];
                return e1 ? e1.displaySize[0] * t.scale * lc / s + i : 0;
            }
        }
        function fc(e1, t, r, n) {
            const i = Math.pow(e1 - t, 2);
            return n ? e1 < t ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function dc(e1, t, r) {
            let n = 0;
            return 10 === e1 && (n -= 1e4), r && (n += 150), 40 !== e1 && 65288 !== e1 || (n += 50), 41 !== t && 65289 !== t || (n += 50), n;
        }
        function yc(e1, t, r, n, i, s) {
            let o = null, a = fc(t, r, i, s);
            for (const e1 of n){
                const n = fc(t - e1.x, r, i, s) + e1.badness;
                n <= a && (o = e1, a = n);
            }
            return {
                index: e1,
                x: t,
                priorBreak: o,
                badness: a
            };
        }
        function mc(e1) {
            return e1 ? mc(e1.priorBreak).concat(e1.index) : [];
        }
        class gc {
            constructor(e1 = "", t = [], r = []){
                this.text = e1, this.sections = t, this.sectionIndex = r, this.imageSectionID = null;
            }
            static fromFeature(e1, t) {
                const r = new gc;
                for(let n = 0; n < e1.sections.length; n++){
                    const i = e1.sections[n];
                    i.image ? r.addImageSection(i) : r.addTextSection(i, t);
                }
                return r;
            }
            length() {
                return [
                    ...this.text
                ].length;
            }
            getSection(e1) {
                return this.sections[this.sectionIndex[e1]];
            }
            getSectionIndex(e1) {
                return this.sectionIndex[e1];
            }
            verticalizePunctuation() {
                this.text = function(e1) {
                    let t = "", r = {
                        premature: !0,
                        value: void 0
                    };
                    const n = e1[Symbol.iterator]();
                    let i = n.next();
                    const s = e1[Symbol.iterator]();
                    s.next();
                    let o = s.next();
                    for(; !i.done;)t += !o.done && Ss(o.value.codePointAt(0)) && !uc[o.value] || !r.premature && Ss(r.value.codePointAt(0)) && !uc[r.value] || !uc[i.value] ? i.value : uc[i.value], r = {
                        value: i.value,
                        premature: !1
                    }, i = n.next(), o = s.next();
                    return t;
                }(this.text);
            }
            hasZeroWidthSpaces() {
                return this.text.includes("\u200B");
            }
            trim() {
                const e1 = this.text.match(/^\s*/), t = e1 ? e1[0].length : 0, r = this.text.match(/\S\s*$/), n = r ? r[0].length - 1 : 0;
                this.text = this.text.substring(t, this.text.length - n), this.sectionIndex = this.sectionIndex.slice(t, this.sectionIndex.length - n);
            }
            substring(e1, t) {
                const r = [
                    ...this.text
                ].slice(e1, t).join(""), n = this.sectionIndex.slice(e1, t);
                return new gc(r, this.sections, n);
            }
            toCodeUnitIndex(e1) {
                return [
                    ...this.text
                ].slice(0, e1).join("").length;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((e1, t)=>Math.max(e1, this.sections[t].scale), 0);
            }
            getMaxImageSize(e1) {
                let t = 0, r = 0;
                for(let n = 0; n < this.length(); n++){
                    const i = this.getSection(n);
                    if ("imageName" in i) {
                        const n = e1[i.imageName];
                        if (!n) continue;
                        const s = n.displaySize;
                        t = Math.max(t, s[0]), r = Math.max(r, s[1]);
                    }
                }
                return {
                    maxImageWidth: t,
                    maxImageHeight: r
                };
            }
            addTextSection(e1, t) {
                this.text += e1.text, this.sections.push({
                    scale: e1.scale || 1,
                    verticalAlign: e1.verticalAlign || "bottom",
                    fontStack: e1.fontStack || t
                });
                const r = this.sections.length - 1;
                this.sectionIndex.push(...[
                    ...e1.text
                ].map(()=>r));
            }
            addImageSection(e1) {
                const t = e1.image ? e1.image.name : "";
                if (0 === t.length) return void j("Can't add FormattedSection with an empty image.");
                const r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCharCode(r), this.sections.push({
                    scale: 1,
                    verticalAlign: e1.verticalAlign || "bottom",
                    imageName: t
                }), this.sectionIndex.push(this.sections.length - 1)) : j("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
            determineLineBreaks(e1, t, r, n, i) {
                const s = [], o = this.determineAverageLineWidth(e1, t, r, n, i), a = this.hasZeroWidthSpaces();
                let l = 0, u = 0;
                const c = this.text[Symbol.iterator]();
                let h = c.next();
                const p = this.text[Symbol.iterator]();
                p.next();
                let f = p.next();
                const d = this.text[Symbol.iterator]();
                d.next(), d.next();
                let y = d.next();
                for(; !h.done;){
                    const t = this.getSection(u), m = h.value.codePointAt(0);
                    if (gs(m) || (l += pc(m, t, r, n, e1, i)), !f.done) {
                        const e1 = ys(m), r = f.value.codePointAt(0);
                        (cc[m] || e1 || "imageName" in t || !y.done && hc[r]) && s.push(yc(u + 1, l, o, s, dc(m, r, e1 && a), !1));
                    }
                    u++, h = c.next(), f = p.next(), y = d.next();
                }
                return mc(yc(this.length(), l, o, s, 0, !0));
            }
            determineAverageLineWidth(e1, t, r, n, i) {
                let s = 0, o = 0;
                for (const t of this.text){
                    const a = this.getSection(o);
                    s += pc(t.codePointAt(0), a, r, n, e1, i), o++;
                }
                return s / Math.max(1, Math.ceil(s / t));
            }
        }
        const xc = 4294967296, vc = 1 / xc, bc = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
        class wc {
            constructor(e1 = new Uint8Array(16)){
                this.buf = ArrayBuffer.isView(e1) ? e1 : new Uint8Array(e1), this.dataView = new DataView(this.buf.buffer), this.pos = 0, this.type = 0, this.length = this.buf.length;
            }
            readFields(e1, t, r = this.length) {
                for(; this.pos < r;){
                    const r = this.readVarint(), n = r >> 3, i = this.pos;
                    this.type = 7 & r, e1(n, t, this), this.pos === i && this.skip(r);
                }
                return t;
            }
            readMessage(e1, t) {
                return this.readFields(e1, t, this.readVarint() + this.pos);
            }
            readFixed32() {
                const e1 = this.dataView.getUint32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readSFixed32() {
                const e1 = this.dataView.getInt32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readFixed64() {
                const e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * xc;
                return this.pos += 8, e1;
            }
            readSFixed64() {
                const e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * xc;
                return this.pos += 8, e1;
            }
            readFloat() {
                const e1 = this.dataView.getFloat32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readDouble() {
                const e1 = this.dataView.getFloat64(this.pos, !0);
                return this.pos += 8, e1;
            }
            readVarint(e1) {
                const t = this.buf;
                let r, n;
                return n = t[this.pos++], r = 127 & n, n < 128 ? r : (n = t[this.pos++], r |= (127 & n) << 7, n < 128 ? r : (n = t[this.pos++], r |= (127 & n) << 14, n < 128 ? r : (n = t[this.pos++], r |= (127 & n) << 21, n < 128 ? r : (n = t[this.pos], r |= (15 & n) << 28, function(e1, t, r) {
                    const n = r.buf;
                    let i, s;
                    if (s = n[r.pos++], i = (112 & s) >> 4, s < 128) return _c(e1, i, t);
                    if (s = n[r.pos++], i |= (127 & s) << 3, s < 128) return _c(e1, i, t);
                    if (s = n[r.pos++], i |= (127 & s) << 10, s < 128) return _c(e1, i, t);
                    if (s = n[r.pos++], i |= (127 & s) << 17, s < 128) return _c(e1, i, t);
                    if (s = n[r.pos++], i |= (127 & s) << 24, s < 128) return _c(e1, i, t);
                    if (s = n[r.pos++], i |= (1 & s) << 31, s < 128) return _c(e1, i, t);
                    throw new Error("Expected varint not more than 10 bytes");
                }(r, e1, this)))));
            }
            readVarint64() {
                return this.readVarint(!0);
            }
            readSVarint() {
                const e1 = this.readVarint();
                return e1 % 2 == 1 ? (e1 + 1) / -2 : e1 / 2;
            }
            readBoolean() {
                return Boolean(this.readVarint());
            }
            readString() {
                const e1 = this.readVarint() + this.pos, t = this.pos;
                return this.pos = e1, e1 - t >= 12 && bc ? bc.decode(this.buf.subarray(t, e1)) : function(e1, t, r) {
                    let n = "", i = t;
                    for(; i < r;){
                        const t = e1[i];
                        let s, o, a, l = null, u = t > 239 ? 4 : t > 223 ? 3 : t > 191 ? 2 : 1;
                        if (i + u > r) break;
                        1 === u ? t < 128 && (l = t) : 2 === u ? (s = e1[i + 1], 128 == (192 & s) && (l = (31 & t) << 6 | 63 & s, l <= 127 && (l = null))) : 3 === u ? (s = e1[i + 1], o = e1[i + 2], 128 == (192 & s) && 128 == (192 & o) && (l = (15 & t) << 12 | (63 & s) << 6 | 63 & o, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === u && (s = e1[i + 1], o = e1[i + 2], a = e1[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & t) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, u = 1) : l > 65535 && (l -= 65536, n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n += String.fromCharCode(l), i += u;
                    }
                    return n;
                }(this.buf, t, e1);
            }
            readBytes() {
                const e1 = this.readVarint() + this.pos, t = this.buf.subarray(this.pos, e1);
                return this.pos = e1, t;
            }
            readPackedVarint(e1 = [], t) {
                const r = this.readPackedEnd();
                for(; this.pos < r;)e1.push(this.readVarint(t));
                return e1;
            }
            readPackedSVarint(e1 = []) {
                const t = this.readPackedEnd();
                for(; this.pos < t;)e1.push(this.readSVarint());
                return e1;
            }
            readPackedBoolean(e1 = []) {
                const t = this.readPackedEnd();
                for(; this.pos < t;)e1.push(this.readBoolean());
                return e1;
            }
            readPackedFloat(e1 = []) {
                const t = this.readPackedEnd();
                for(; this.pos < t;)e1.push(this.readFloat());
                return e1;
            }
            readPackedDouble(e1 = []) {
                const t = this.readPackedEnd();
                for(; this.pos < t;)e1.push(this.readDouble());
                return e1;
            }
            readPackedFixed32(e1 = []) {
                const t = this.readPackedEnd();
                for(; this.pos < t;)e1.push(this.readFixed32());
                return e1;
            }
            readPackedSFixed32(e1 = []) {
                const t = this.readPackedEnd();
                for(; this.pos < t;)e1.push(this.readSFixed32());
                return e1;
            }
            readPackedFixed64(e1 = []) {
                const t = this.readPackedEnd();
                for(; this.pos < t;)e1.push(this.readFixed64());
                return e1;
            }
            readPackedSFixed64(e1 = []) {
                const t = this.readPackedEnd();
                for(; this.pos < t;)e1.push(this.readSFixed64());
                return e1;
            }
            readPackedEnd() {
                return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
            }
            skip(e1) {
                const t = 7 & e1;
                if (0 === t) for(; this.buf[this.pos++] > 127;);
                else if (2 === t) this.pos = this.readVarint() + this.pos;
                else if (5 === t) this.pos += 4;
                else {
                    if (1 !== t) throw new Error(`Unimplemented type: ${t}`);
                    this.pos += 8;
                }
            }
            writeTag(e1, t) {
                this.writeVarint(e1 << 3 | t);
            }
            realloc(e1) {
                let t = this.length || 16;
                for(; t < this.pos + e1;)t *= 2;
                if (t !== this.length) {
                    const e1 = new Uint8Array(t);
                    e1.set(this.buf), this.buf = e1, this.dataView = new DataView(e1.buffer), this.length = t;
                }
            }
            finish() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            }
            writeFixed32(e1) {
                this.realloc(4), this.dataView.setInt32(this.pos, e1, !0), this.pos += 4;
            }
            writeSFixed32(e1) {
                this.realloc(4), this.dataView.setInt32(this.pos, e1, !0), this.pos += 4;
            }
            writeFixed64(e1) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & e1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e1 * vc), !0), this.pos += 8;
            }
            writeSFixed64(e1) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & e1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e1 * vc), !0), this.pos += 8;
            }
            writeVarint(e1) {
                (e1 = +e1 || 0) > 268435455 || e1 < 0 ? function(e1, t) {
                    let r, n;
                    if (e1 >= 0 ? (r = e1 % 4294967296 | 0, n = e1 / 4294967296 | 0) : (r = ~(-e1 % 4294967296), n = ~(-e1 / 4294967296), 4294967295 ^ r ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), e1 >= 0x10000000000000000 || e1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    t.realloc(10), function(e1, t, r) {
                        r.buf[r.pos++] = 127 & e1 | 128, e1 >>>= 7, r.buf[r.pos++] = 127 & e1 | 128, e1 >>>= 7, r.buf[r.pos++] = 127 & e1 | 128, e1 >>>= 7, r.buf[r.pos++] = 127 & e1 | 128, r.buf[r.pos] = 127 & (e1 >>>= 7);
                    }(r, 0, t), function(e1, t) {
                        const r = (7 & e1) << 4;
                        t.buf[t.pos++] |= r | ((e1 >>>= 3) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1)))));
                    }(n, t);
                }(e1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & e1 | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = e1 >>> 7 & 127))));
            }
            writeSVarint(e1) {
                this.writeVarint(e1 < 0 ? 2 * -e1 - 1 : 2 * e1);
            }
            writeBoolean(e1) {
                this.writeVarint(+e1);
            }
            writeString(e1) {
                e1 = String(e1), this.realloc(4 * e1.length), this.pos++;
                const t = this.pos;
                this.pos = function(e1, t, r) {
                    for(let n, i, s = 0; s < t.length; s++){
                        if (n = t.charCodeAt(s), n > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || s + 1 === t.length ? (e1[r++] = 239, e1[r++] = 191, e1[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                e1[r++] = 239, e1[r++] = 191, e1[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (e1[r++] = 239, e1[r++] = 191, e1[r++] = 189, i = null);
                        n < 128 ? e1[r++] = n : (n < 2048 ? e1[r++] = n >> 6 | 192 : (n < 65536 ? e1[r++] = n >> 12 | 224 : (e1[r++] = n >> 18 | 240, e1[r++] = n >> 12 & 63 | 128), e1[r++] = n >> 6 & 63 | 128), e1[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, e1, this.pos);
                const r = this.pos - t;
                r >= 128 && Sc(t, r, this), this.pos = t - 1, this.writeVarint(r), this.pos += r;
            }
            writeFloat(e1) {
                this.realloc(4), this.dataView.setFloat32(this.pos, e1, !0), this.pos += 4;
            }
            writeDouble(e1) {
                this.realloc(8), this.dataView.setFloat64(this.pos, e1, !0), this.pos += 8;
            }
            writeBytes(e1) {
                const t = e1.length;
                this.writeVarint(t), this.realloc(t);
                for(let r = 0; r < t; r++)this.buf[this.pos++] = e1[r];
            }
            writeRawMessage(e1, t) {
                this.pos++;
                const r = this.pos;
                e1(t, this);
                const n = this.pos - r;
                n >= 128 && Sc(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            }
            writeMessage(e1, t, r) {
                this.writeTag(e1, 2), this.writeRawMessage(t, r);
            }
            writePackedVarint(e1, t) {
                t.length && this.writeMessage(e1, Ac, t);
            }
            writePackedSVarint(e1, t) {
                t.length && this.writeMessage(e1, Tc, t);
            }
            writePackedBoolean(e1, t) {
                t.length && this.writeMessage(e1, Mc, t);
            }
            writePackedFloat(e1, t) {
                t.length && this.writeMessage(e1, Ic, t);
            }
            writePackedDouble(e1, t) {
                t.length && this.writeMessage(e1, Ec, t);
            }
            writePackedFixed32(e1, t) {
                t.length && this.writeMessage(e1, kc, t);
            }
            writePackedSFixed32(e1, t) {
                t.length && this.writeMessage(e1, Fc, t);
            }
            writePackedFixed64(e1, t) {
                t.length && this.writeMessage(e1, Dc, t);
            }
            writePackedSFixed64(e1, t) {
                t.length && this.writeMessage(e1, Pc, t);
            }
            writeBytesField(e1, t) {
                this.writeTag(e1, 2), this.writeBytes(t);
            }
            writeFixed32Field(e1, t) {
                this.writeTag(e1, 5), this.writeFixed32(t);
            }
            writeSFixed32Field(e1, t) {
                this.writeTag(e1, 5), this.writeSFixed32(t);
            }
            writeFixed64Field(e1, t) {
                this.writeTag(e1, 1), this.writeFixed64(t);
            }
            writeSFixed64Field(e1, t) {
                this.writeTag(e1, 1), this.writeSFixed64(t);
            }
            writeVarintField(e1, t) {
                this.writeTag(e1, 0), this.writeVarint(t);
            }
            writeSVarintField(e1, t) {
                this.writeTag(e1, 0), this.writeSVarint(t);
            }
            writeStringField(e1, t) {
                this.writeTag(e1, 2), this.writeString(t);
            }
            writeFloatField(e1, t) {
                this.writeTag(e1, 5), this.writeFloat(t);
            }
            writeDoubleField(e1, t) {
                this.writeTag(e1, 1), this.writeDouble(t);
            }
            writeBooleanField(e1, t) {
                this.writeVarintField(e1, +t);
            }
        }
        function _c(e1, t, r) {
            return r ? 4294967296 * t + (e1 >>> 0) : 4294967296 * (t >>> 0) + (e1 >>> 0);
        }
        function Sc(e1, t, r) {
            const n = t <= 16383 ? 1 : t <= 2097151 ? 2 : t <= 268435455 ? 3 : Math.floor(Math.log(t) / (7 * Math.LN2));
            r.realloc(n);
            for(let t = r.pos - 1; t >= e1; t--)r.buf[t + n] = r.buf[t];
        }
        function Ac(e1, t) {
            for(let r = 0; r < e1.length; r++)t.writeVarint(e1[r]);
        }
        function Tc(e1, t) {
            for(let r = 0; r < e1.length; r++)t.writeSVarint(e1[r]);
        }
        function Ic(e1, t) {
            for(let r = 0; r < e1.length; r++)t.writeFloat(e1[r]);
        }
        function Ec(e1, t) {
            for(let r = 0; r < e1.length; r++)t.writeDouble(e1[r]);
        }
        function Mc(e1, t) {
            for(let r = 0; r < e1.length; r++)t.writeBoolean(e1[r]);
        }
        function kc(e1, t) {
            for(let r = 0; r < e1.length; r++)t.writeFixed32(e1[r]);
        }
        function Fc(e1, t) {
            for(let r = 0; r < e1.length; r++)t.writeSFixed32(e1[r]);
        }
        function Dc(e1, t) {
            for(let r = 0; r < e1.length; r++)t.writeFixed64(e1[r]);
        }
        function Pc(e1, t) {
            for(let r = 0; r < e1.length; r++)t.writeSFixed64(e1[r]);
        }
        function Bc(e1, t, r) {
            1 === e1 && r.readMessage(zc, t);
        }
        function zc(e1, t, r) {
            if (3 === e1) {
                const { id: e1, bitmap: n, width: i, height: s, left: o, top: a, advance: l } = r.readMessage(Vc, {});
                t.push({
                    id: e1,
                    bitmap: new gl({
                        width: i + 6,
                        height: s + 6
                    }, n),
                    metrics: {
                        width: i,
                        height: s,
                        left: o,
                        top: a,
                        advance: l
                    }
                });
            }
        }
        function Vc(e1, t, r) {
            1 === e1 ? t.id = r.readVarint() : 2 === e1 ? t.bitmap = r.readBytes() : 3 === e1 ? t.width = r.readVarint() : 4 === e1 ? t.height = r.readVarint() : 5 === e1 ? t.left = r.readSVarint() : 6 === e1 ? t.top = r.readSVarint() : 7 === e1 && (t.advance = r.readVarint());
        }
        function Cc(e1) {
            let t = 0, r = 0;
            for (const n of e1)t += n.w * n.h, r = Math.max(r, n.w);
            e1.sort((e1, t)=>t.h - e1.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(t / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, s = 0;
            for (const t of e1)for(let e1 = n.length - 1; e1 >= 0; e1--){
                const r = n[e1];
                if (!(t.w > r.w || t.h > r.h)) {
                    if (t.x = r.x, t.y = r.y, s = Math.max(s, t.y + t.h), i = Math.max(i, t.x + t.w), t.w === r.w && t.h === r.h) {
                        const t = n.pop();
                        t && e1 < n.length && (n[e1] = t);
                    } else t.h === r.h ? (r.x += t.w, r.w -= t.w) : t.w === r.w ? (r.y += t.h, r.h -= t.h) : (n.push({
                        x: r.x + t.w,
                        y: r.y,
                        w: r.w - t.w,
                        h: t.h
                    }), r.y += t.h, r.h -= t.h);
                    break;
                }
            }
            return {
                w: i,
                h: s,
                fill: t / (i * s) || 0
            };
        }
        class Lc {
            constructor(e1, { pixelRatio: t, version: r, stretchX: n, stretchY: i, content: s, textFitWidth: o, textFitHeight: a }){
                this.paddedRect = e1, this.pixelRatio = t, this.stretchX = n, this.stretchY = i, this.content = s, this.version = r, this.textFitWidth = o, this.textFitHeight = a;
            }
            get tl() {
                return [
                    this.paddedRect.x + 1,
                    this.paddedRect.y + 1
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - 1,
                    this.paddedRect.y + this.paddedRect.h - 1
                ];
            }
            get tlbr() {
                return this.tl.concat(this.br);
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2) / this.pixelRatio,
                    (this.paddedRect.h - 2) / this.pixelRatio
                ];
            }
        }
        class Oc {
            constructor(e1, t){
                const r = {}, n = {};
                this.haveRenderCallbacks = [];
                const i = [];
                this.addImages(e1, r, i), this.addImages(t, n, i);
                const { w: s, h: o } = Cc(i), a = new xl({
                    width: s || 1,
                    height: o || 1
                });
                for(const t in e1){
                    const n = e1[t], i = r[t].paddedRect;
                    xl.copy(n.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + 1,
                        y: i.y + 1
                    }, n.data);
                }
                for(const e1 in t){
                    const r = t[e1], i = n[e1].paddedRect, s = i.x + 1, o = i.y + 1, l = r.data.width, u = r.data.height;
                    xl.copy(r.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: o
                    }, r.data), xl.copy(r.data, a, {
                        x: 0,
                        y: u - 1
                    }, {
                        x: s,
                        y: o - 1
                    }, {
                        width: l,
                        height: 1
                    }), xl.copy(r.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: o + u
                    }, {
                        width: l,
                        height: 1
                    }), xl.copy(r.data, a, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: s - 1,
                        y: o
                    }, {
                        width: 1,
                        height: u
                    }), xl.copy(r.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + l,
                        y: o
                    }, {
                        width: 1,
                        height: u
                    });
                }
                this.image = a, this.iconPositions = r, this.patternPositions = n;
            }
            addImages(e1, t, r) {
                for(const n in e1){
                    const i = e1[n], s = {
                        x: 0,
                        y: 0,
                        w: i.data.width + 2,
                        h: i.data.height + 2
                    };
                    r.push(s), t[n] = new Lc(s, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                }
            }
            patchUpdatedImages(e1, t) {
                e1.dispatchRenderCallbacks(this.haveRenderCallbacks);
                for(const r in e1.updatedImages)this.patchUpdatedImage(this.iconPositions[r], e1.getImage(r), t), this.patchUpdatedImage(this.patternPositions[r], e1.getImage(r), t);
            }
            patchUpdatedImage(e1, t, r) {
                if (!e1 || !t) return;
                if (e1.version === t.version) return;
                e1.version = t.version;
                const [n, i] = e1.tl;
                r.update(t.data, void 0, {
                    x: n,
                    y: i
                });
            }
        }
        var Rc;
        function Nc(t, r, n, i, s, o, a, l, u, c, h, p, f, d, y) {
            const m = gc.fromFeature(t, s);
            let g;
            p === e1.ay.vertical && m.verticalizePunctuation();
            let x = m.determineLineBreaks(c, o, r, i, d);
            const { processBidirectionalText: v, processStyledBidirectionalText: b } = Ms;
            if (v && 1 === m.sections.length) {
                g = [], x = x.map((e1)=>m.toCodeUnitIndex(e1));
                const e1 = v(m.toString(), x);
                for (const t of e1){
                    const e1 = [
                        ...t
                    ].map(()=>0);
                    g.push(new gc(t, m.sections, e1));
                }
            } else if (b) {
                g = [], x = x.map((e1)=>m.toCodeUnitIndex(e1));
                let e1 = 0;
                const t = [];
                for (const r of m.text)t.push(...Array(r.length).fill(m.sectionIndex[e1])), e1++;
                const r = b(m.text, t, x);
                for (const e1 of r){
                    const t = [];
                    let r = "";
                    for (const n of e1[0])t.push(e1[1][r.length]), r += n;
                    g.push(new gc(e1[0], m.sections, t));
                }
            } else g = function(e1, t) {
                const r = [];
                let n = 0;
                for (const i of t)r.push(e1.substring(n, i)), n = i;
                return n < e1.length() && r.push(e1.substring(n, e1.length())), r;
            }(m, x);
            const w = [], _ = {
                positionedLines: w,
                text: m.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: p,
                iconsInText: !1,
                verticalizable: !1
            };
            return function(e1, t, r, n, i, s, o, a, l, u, c, h) {
                let p = 0, f = 0, d = 0, y = 0;
                const m = "right" === a ? 1 : "left" === a ? 0 : .5, g = lc / h;
                let x = 0;
                for (const o of i){
                    o.trim();
                    const i = o.getMaxScale(), a = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    e1.positionedLines[x] = a;
                    const h = a.positionedGlyphs;
                    let v = 0;
                    if (!o.length()) {
                        f += s, ++x;
                        continue;
                    }
                    const b = Uc(n, o, g);
                    let w = 0;
                    for (const s of o.text){
                        const a = o.getSection(w), d = s.codePointAt(0), y = jc(l, c, d), m = {
                            glyph: d,
                            imageName: null,
                            x: p,
                            y: f + -17,
                            vertical: y,
                            scale: 1,
                            fontStack: "",
                            sectionIndex: o.getSectionIndex(w),
                            metrics: null,
                            rect: null
                        };
                        let x;
                        if ("fontStack" in a) {
                            if (x = Gc(a, d, y, b, t, r), !x) continue;
                            m.fontStack = a.fontStack;
                        } else {
                            if (e1.iconsInText = !0, a.scale *= g, x = Xc(a, y, i, b, n), !x) continue;
                            v = Math.max(v, x.imageOffset), m.imageName = a.imageName;
                        }
                        const { rect: _, metrics: S, baselineOffset: A } = x;
                        m.y += A, m.scale = a.scale, m.metrics = S, m.rect = _, h.push(m), y ? (e1.verticalizable = !0, p += ("imageName" in a ? S.advance : lc) * a.scale + u) : p += S.advance * a.scale + u, w++;
                    }
                    0 !== h.length && (d = Math.max(p - u, d), Yc(h, 0, h.length - 1, m)), p = 0, a.lineOffset = Math.max(v, (i - 1) * lc);
                    const _ = s * i + v;
                    f += _, y = Math.max(_, y), ++x;
                }
                const { horizontalAlign: v, verticalAlign: b } = $c(o);
                (function(e1, t, r, n, i, s, o, a, l) {
                    const u = (t - r) * i;
                    let c = 0;
                    c = s !== o ? -a * n - -17 : -n * l * o + .5 * o;
                    for (const t of e1)for (const e1 of t.positionedGlyphs)e1.x += u, e1.y += c;
                })(e1.positionedLines, m, v, b, d, y, s, f, i.length), e1.top += -b * f, e1.bottom = e1.top + f, e1.left += -v * d, e1.right = e1.left + d;
            }(_, r, n, i, g, a, l, u, p, c, f, y), !function(e1) {
                for (const t of e1)if (0 !== t.positionedGlyphs.length) return !1;
                return !0;
            }(w) && _;
        }
        function $c(e1) {
            let t = .5, r = .5;
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    t = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    t = 0;
            }
            switch(e1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: t,
                verticalAlign: r
            };
        }
        function Uc(e1, t, r) {
            const n = t.getMaxScale() * lc, { maxImageWidth: i, maxImageHeight: s } = t.getMaxImageSize(e1), o = Math.max(n, s * r);
            return {
                verticalLineContentWidth: Math.max(n, i * r),
                horizontalLineContentHeight: o
            };
        }
        function qc(e1) {
            switch(e1){
                case "top":
                    return 0;
                case "center":
                    return .5;
                default:
                    return 1;
            }
        }
        function jc(t, r, n) {
            var i;
            return !(t === e1.ay.horizontal || !r && !ms(n) || r && (gs(n) || (i = n, /\p{sc=Arab}/u.test(String.fromCodePoint(i)))));
        }
        function Gc(e1, t, r, n, i, s) {
            const o = s[e1.fontStack], a = function(e1, t, r, n) {
                if (e1 && e1.rect) return e1;
                const i = t[r.fontStack], s = i && i[n];
                return s ? {
                    rect: null,
                    metrics: s.metrics
                } : null;
            }(o && o[t], i, e1, t);
            if (null === a) return null;
            let l;
            if (r) l = n.verticalLineContentWidth - e1.scale * lc;
            else {
                const t = qc(e1.verticalAlign);
                l = (n.horizontalLineContentHeight - e1.scale * lc) * t;
            }
            return {
                rect: a.rect,
                metrics: a.metrics,
                baselineOffset: l
            };
        }
        function Xc(e1, t, r, n, i) {
            const s = i[e1.imageName];
            if (!s) return null;
            const o = s.paddedRect, a = s.displaySize, l = {
                width: a[0],
                height: a[1],
                left: 1,
                top: -3,
                advance: t ? a[1] : a[0]
            };
            let u;
            if (t) u = n.verticalLineContentWidth - a[1] * e1.scale;
            else {
                const t = qc(e1.verticalAlign);
                u = (n.horizontalLineContentHeight - a[1] * e1.scale) * t;
            }
            return {
                rect: o,
                metrics: l,
                baselineOffset: u,
                imageOffset: (t ? a[0] : a[1]) * e1.scale - lc * r
            };
        }
        function Yc(e1, t, r, n) {
            if (0 === n) return;
            const i = e1[r], s = (e1[r].x + i.metrics.advance * i.scale) * n;
            for(let n = t; n <= r; n++)e1[n].x -= s;
        }
        function Zc(e1, t, r) {
            const { horizontalAlign: n, verticalAlign: i } = $c(r), s = t[0] - e1.displaySize[0] * n, o = t[1] - e1.displaySize[1] * i;
            return {
                image: e1,
                top: o,
                bottom: o + e1.displaySize[1],
                left: s,
                right: s + e1.displaySize[0]
            };
        }
        function Hc(e1) {
            var t, r;
            let n = e1.left, i = e1.top, s = e1.right - n, o = e1.bottom - i;
            const a = null !== (t = e1.image.textFitWidth) && void 0 !== t ? t : "stretchOrShrink", l = null !== (r = e1.image.textFitHeight) && void 0 !== r ? r : "stretchOrShrink", u = (e1.image.content[2] - e1.image.content[0]) / (e1.image.content[3] - e1.image.content[1]);
            if ("proportional" === l) {
                if ("stretchOnly" === a && s / o < u || "proportional" === a) {
                    const e1 = Math.ceil(o * u);
                    n *= e1 / s, s = e1;
                }
            } else if ("proportional" === a && "stretchOnly" === l && 0 !== u && s / o > u) {
                const e1 = Math.ceil(s / u);
                i *= e1 / o, o = e1;
            }
            return {
                x1: n,
                y1: i,
                x2: n + s,
                y2: i + o
            };
        }
        function Kc(e1, t, r, n, i, s) {
            const o = e1.image;
            let a;
            if (o.content) {
                const e1 = o.content, t = o.pixelRatio || 1;
                a = [
                    e1[0] / t,
                    e1[1] / t,
                    o.displaySize[0] - e1[2] / t,
                    o.displaySize[1] - e1[3] / t
                ];
            }
            const l = t.left * s, u = t.right * s;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - o.displaySize[0]) / 2, h = f + o.displaySize[0]);
            const d = t.top * s, y = t.bottom * s;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + y + n[2]) : (c = i[1] + (d + y - o.displaySize[1]) / 2, p = c + o.displaySize[1]), {
                image: o,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: a
            };
        }
        ls("ImagePosition", Lc), ls("ImageAtlas", Oc), e1.ay = void 0, (Rc = e1.ay || (e1.ay = {}))[Rc.none = 0] = "none", Rc[Rc.horizontal = 1] = "horizontal", Rc[Rc.vertical = 2] = "vertical", Rc[Rc.horizontalOnly = 3] = "horizontalOnly";
        const Wc = 128, Jc = 32640;
        function Qc(e1, t) {
            const { expression: r } = t;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new ks(e1 + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: t, interpolationType: n } = r;
                let i = 0;
                for(; i < t.length && t[i] <= e1;)i++;
                i = Math.max(0, i - 1);
                let s = i;
                for(; s < t.length && t[s] < e1 + 1;)s++;
                s = Math.min(t.length - 1, s);
                const o = t[i], a = t[s];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: o,
                    maxZoom: a,
                    interpolationType: n
                } : {
                    kind: "camera",
                    minZoom: o,
                    maxZoom: a,
                    minSize: r.evaluate(new ks(o)),
                    maxSize: r.evaluate(new ks(a)),
                    interpolationType: n
                };
            }
        }
        function eh(e1, t, r) {
            let n = "never";
            const i = e1.get(t);
            return i ? n = i : e1.get(r) && (n = "always"), n;
        }
        const th = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function rh(e1, t, r, n, i, s, o, a, l, u, c, h, p) {
            const f = a ? Math.min(Jc, Math.round(a[0])) : 0, d = a ? Math.min(Jc, Math.round(a[1])) : 0;
            e1.emplaceBack(t, r, Math.round(32 * n), Math.round(32 * i), s, o, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function nh(e1, t, r) {
            e1.emplaceBack(t.x, t.y, r), e1.emplaceBack(t.x, t.y, r), e1.emplaceBack(t.x, t.y, r), e1.emplaceBack(t.x, t.y, r);
        }
        function ih(e1) {
            for (const t of e1.sections)if (Es(t.text)) return !0;
            return !1;
        }
        class sh {
            constructor(e1){
                this.layoutVertexArray = new Xo, this.indexArray = new Wo, this.programConfigurations = e1, this.segments = new ta, this.dynamicLayoutVertexArray = new Yo, this.opacityVertexArray = new Zo, this.hasVisibleVertices = !1, this.placedSymbolArray = new ko;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
            }
            upload(e1, t, r, n) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, rc.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray, t), this.dynamicLayoutVertexBuffer = e1.createVertexBuffer(this.dynamicLayoutVertexArray, nc.members, !0), this.opacityVertexBuffer = e1.createVertexBuffer(this.opacityVertexArray, th, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(e1));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
            }
        }
        ls("SymbolBuffers", sh);
        class oh {
            constructor(e1, t, r){
                this.layoutVertexArray = new e1, this.layoutAttributes = t, this.indexArray = new r, this.segments = new ta, this.collisionVertexArray = new Ko;
            }
            upload(e1) {
                this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = e1.createVertexBuffer(this.collisionVertexArray, ic.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
            }
        }
        ls("CollisionBuffers", oh);
        class ah {
            constructor(t){
                this.collisionBoxArray = t.collisionBoxArray, this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((e1)=>e1.id), this.index = t.index, this.pixelRatio = t.pixelRatio, this.sourceLayerIndex = t.sourceLayerIndex, this.hasDependencies = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [];
                const r = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = Qc(this.zoom, r["text-size"]), this.iconSizeData = Qc(this.zoom, r["icon-size"]);
                const n = this.layers[0].layout, i = n.get("symbol-sort-key"), s = n.get("symbol-z-order");
                this.canOverlap = "never" !== eh(n, "text-overlap", "text-allow-overlap") || "never" !== eh(n, "icon-overlap", "icon-allow-overlap") || n.get("text-ignore-placement") || n.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== s && !i.isConstant(), this.sortFeaturesByY = ("viewport-y" === s || "auto" === s && !this.sortFeaturesByKey) && this.canOverlap, "point" === n.get("symbol-placement") && (this.writingModes = n.get("text-writing-mode").map((t)=>e1.ay[t])), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.sourceID = t.sourceID;
            }
            createArrays() {
                this.text = new sh(new Da(this.layers, this.zoom, (e1)=>/^text/.test(e1))), this.icon = new sh(new Da(this.layers, this.zoom, (e1)=>/^icon/.test(e1))), this.glyphOffsetArray = new Po, this.lineVertexArray = new Bo, this.symbolInstances = new Do, this.textAnchorOffsets = new Vo;
            }
            calculateGlyphDependencies(e1, t, r, n, i) {
                for (const s of e1)if (t[s.codePointAt(0)] = !0, (r || n) && i) {
                    const e1 = uc[s];
                    e1 && (t[e1.codePointAt(0)] = !0);
                }
            }
            populate(t, r, n) {
                const i = this.layers[0], s = i.layout, o = s.get("text-font"), a = s.get("text-field"), l = s.get("icon-image"), u = ("constant" !== a.value.kind || a.value.value instanceof Ft && !a.value.value.isEmpty() || a.value.value.toString().length > 0) && ("constant" !== o.value.kind || o.value.value.length > 0), c = "constant" !== l.value.kind || !!l.value.value || Object.keys(l.parameters).length > 0, h = s.get("symbol-sort-key");
                if (this.features = [], !u && !c) return;
                const p = r.iconDependencies, f = r.glyphDependencies, d = r.availableImages, y = new ks(this.zoom);
                for (const { feature: r, id: a, index: l, sourceLayerIndex: m } of t){
                    const t = i._featureFilter.needGeometry, g = La(r, t);
                    if (!i._featureFilter.filter(y, g, n)) continue;
                    let x, v;
                    if (t || (g.geometry = Ca(r)), u) {
                        const e1 = i.getValueAndResolveTokens("text-field", g, n, d), t = Ft.factory(e1), r = this.hasRTLText = this.hasRTLText || ih(t);
                        (!r || "unavailable" === Ms.getRTLTextPluginStatus() || r && Ms.isParsed()) && (x = ac(t, i, g));
                    }
                    if (c) {
                        const e1 = i.getValueAndResolveTokens("icon-image", g, n, d);
                        v = e1 instanceof Lt ? e1 : Lt.fromString(e1);
                    }
                    if (!x && !v) continue;
                    const b = this.sortFeaturesByKey ? h.evaluate(g, {}, n) : void 0;
                    if (this.features.push({
                        id: a,
                        text: x,
                        icon: v,
                        index: l,
                        sourceLayerIndex: m,
                        geometry: g.geometry,
                        properties: r.properties,
                        type: Au.types[r.type],
                        sortKey: b
                    }), v && (p[v.name] = !0), x) {
                        const t = o.evaluate(g, {}, n).join(","), r = "viewport" !== s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(e1.ay.vertical) >= 0;
                        for (const e1 of x.sections)if (e1.image) p[e1.image.name] = !0;
                        else {
                            const n = xs(x.toString()), i = e1.fontStack || t, s = f[i] = f[i] || {};
                            this.calculateGlyphDependencies(e1.text, s, r, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === s.get("symbol-placement") && (this.features = function(e1) {
                    const t = {}, r = {}, n = [];
                    let i = 0;
                    function s(t) {
                        n.push(e1[t]), i++;
                    }
                    function o(e1, t, i) {
                        const s = r[e1];
                        return delete r[e1], r[t] = s, n[s].geometry[0].pop(), n[s].geometry[0] = n[s].geometry[0].concat(i[0]), s;
                    }
                    function a(e1, r, i) {
                        const s = t[r];
                        return delete t[r], t[e1] = s, n[s].geometry[0].shift(), n[s].geometry[0] = i[0].concat(n[s].geometry[0]), s;
                    }
                    function l(e1, t, r) {
                        const n = r ? t[0][t[0].length - 1] : t[0][0];
                        return `${e1}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < e1.length; u++){
                        const c = e1[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            s(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in t && r[f] !== t[d]) {
                            const e1 = a(f, d, h), i = o(f, d, n[e1].geometry);
                            delete t[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[e1].geometry = null;
                        } else f in r ? o(f, d, h) : d in t ? a(f, d, h) : (s(u), t[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((e1)=>e1.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((e1, t)=>e1.sortKey - t.sortKey);
            }
            update(e1, t, r) {
                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(e1, t, this.layers, {
                    imagePositions: r
                }), this.icon.programConfigurations.updatePaintArrays(e1, t, this.layers, {
                    imagePositions: r
                }));
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(e1) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(e1), this.iconCollisionBox.upload(e1)), this.text.upload(e1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(e1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(e1, t) {
                const r = this.lineVertexArray.length;
                if (void 0 !== e1.segment) {
                    let r = e1.dist(t[e1.segment + 1]), n = e1.dist(t[e1.segment]);
                    const i = {};
                    for(let n = e1.segment + 1; n < t.length; n++)i[n] = {
                        x: t[n].x,
                        y: t[n].y,
                        tileUnitDistanceFromAnchor: r
                    }, n < t.length - 1 && (r += t[n + 1].dist(t[n]));
                    for(let r = e1.segment || 0; r >= 0; r--)i[r] = {
                        x: t[r].x,
                        y: t[r].y,
                        tileUnitDistanceFromAnchor: n
                    }, r > 0 && (n += t[r - 1].dist(t[r]));
                    for(let e1 = 0; e1 < t.length; e1++){
                        const t = i[e1];
                        this.lineVertexArray.emplaceBack(t.x, t.y, t.tileUnitDistanceFromAnchor);
                    }
                }
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(t, r, n, i, s, o, a, l, u, c, h, p) {
                const f = t.indexArray, d = t.layoutVertexArray, y = t.segments.prepareSegment(4 * r.length, d, f, this.canOverlap ? o.sortKey : void 0), m = this.glyphOffsetArray.length, g = y.vertexLength, x = this.allowVerticalPlacement && a === e1.ay.vertical ? Math.PI / 2 : 0, v = o.text && o.text.sections;
                for(let e1 = 0; e1 < r.length; e1++){
                    const { tl: i, tr: s, bl: a, br: u, tex: c, pixelOffsetTL: h, pixelOffsetBR: m, minFontScaleX: g, minFontScaleY: b, glyphOffset: w, isSDF: _, sectionIndex: S } = r[e1], A = y.vertexLength, T = w[1];
                    rh(d, l.x, l.y, i.x, T + i.y, c.x, c.y, n, _, h.x, h.y, g, b), rh(d, l.x, l.y, s.x, T + s.y, c.x + c.w, c.y, n, _, m.x, h.y, g, b), rh(d, l.x, l.y, a.x, T + a.y, c.x, c.y + c.h, n, _, h.x, m.y, g, b), rh(d, l.x, l.y, u.x, T + u.y, c.x + c.w, c.y + c.h, n, _, m.x, m.y, g, b), nh(t.dynamicLayoutVertexArray, l, x), f.emplaceBack(A, A + 2, A + 1), f.emplaceBack(A + 1, A + 2, A + 3), y.vertexLength += 4, y.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(w[0]), e1 !== r.length - 1 && S === r[e1 + 1].sectionIndex || t.programConfigurations.populatePaintArrays(d.length, o, o.index, {
                        imagePositions: {},
                        canonical: p,
                        formattedSection: v && v[S]
                    });
                }
                t.placedSymbolArray.emplaceBack(l.x, l.y, m, this.glyphOffsetArray.length - m, g, u, c, l.segment, n ? n[0] : 0, n ? n[1] : 0, i[0], i[1], a, 0, !1, 0, h);
            }
            _addCollisionDebugVertex(e1, t, r, n, i, s) {
                return t.emplaceBack(0, 0), e1.emplaceBack(r.x, r.y, n, i, Math.round(s.x), Math.round(s.y));
            }
            addCollisionDebugVertices(e1, t, n, i, s, o, a) {
                const l = s.segments.prepareSegment(4, s.layoutVertexArray, s.indexArray), u = l.vertexLength, c = s.layoutVertexArray, h = s.collisionVertexArray, p = a.anchorX, f = a.anchorY;
                this._addCollisionDebugVertex(c, h, o, p, f, new r(e1, t)), this._addCollisionDebugVertex(c, h, o, p, f, new r(n, t)), this._addCollisionDebugVertex(c, h, o, p, f, new r(n, i)), this._addCollisionDebugVertex(c, h, o, p, f, new r(e1, i)), l.vertexLength += 4;
                const d = s.indexArray;
                d.emplaceBack(u, u + 1), d.emplaceBack(u + 1, u + 2), d.emplaceBack(u + 2, u + 3), d.emplaceBack(u + 3, u), l.primitiveLength += 4;
            }
            addDebugCollisionBoxes(e1, t, r, n) {
                for(let i = e1; i < t; i++){
                    const e1 = this.collisionBoxArray.get(i);
                    this.addCollisionDebugVertices(e1.x1, e1.y1, e1.x2, e1.y2, n ? this.textCollisionBox : this.iconCollisionBox, e1.anchorPoint, r);
                }
            }
            generateCollisionDebugBuffers() {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new oh(Ho, sc.members, Jo), this.iconCollisionBox = new oh(Ho, sc.members, Jo);
                for(let e1 = 0; e1 < this.symbolInstances.length; e1++){
                    const t = this.symbolInstances.get(e1);
                    this.addDebugCollisionBoxes(t.textBoxStartIndex, t.textBoxEndIndex, t, !0), this.addDebugCollisionBoxes(t.verticalTextBoxStartIndex, t.verticalTextBoxEndIndex, t, !0), this.addDebugCollisionBoxes(t.iconBoxStartIndex, t.iconBoxEndIndex, t, !1), this.addDebugCollisionBoxes(t.verticalIconBoxStartIndex, t.verticalIconBoxEndIndex, t, !1);
                }
            }
            _deserializeCollisionBoxesForSymbol(e1, t, r, n, i, s, o, a, l) {
                const u = {};
                for(let n = t; n < r; n++){
                    const t = e1.get(n);
                    u.textBox = {
                        x1: t.x1,
                        y1: t.y1,
                        x2: t.x2,
                        y2: t.y2,
                        anchorPointX: t.anchorPointX,
                        anchorPointY: t.anchorPointY
                    }, u.textFeatureIndex = t.featureIndex;
                    break;
                }
                for(let t = n; t < i; t++){
                    const r = e1.get(t);
                    u.verticalTextBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalTextFeatureIndex = r.featureIndex;
                    break;
                }
                for(let t = s; t < o; t++){
                    const r = e1.get(t);
                    u.iconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.iconFeatureIndex = r.featureIndex;
                    break;
                }
                for(let t = a; t < l; t++){
                    const r = e1.get(t);
                    u.verticalIconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalIconFeatureIndex = r.featureIndex;
                    break;
                }
                return u;
            }
            deserializeCollisionBoxes(e1) {
                this.collisionArrays = [];
                for(let t = 0; t < this.symbolInstances.length; t++){
                    const r = this.symbolInstances.get(t);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(e1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            addIndicesForPlacedSymbol(e1, t) {
                const r = e1.placedSymbolArray.get(t), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let t = r.vertexStartIndex; t < n; t += 4)e1.indexArray.emplaceBack(t, t + 2, t + 1), e1.indexArray.emplaceBack(t + 1, t + 2, t + 3);
            }
            getSortedSymbolIndexes(e1) {
                if (this.sortedAngle === e1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const t = Math.sin(e1), r = Math.cos(e1), n = [], i = [], s = [];
                for(let e1 = 0; e1 < this.symbolInstances.length; ++e1){
                    s.push(e1);
                    const o = this.symbolInstances.get(e1);
                    n.push(0 | Math.round(t * o.anchorX + r * o.anchorY)), i.push(o.featureIndex);
                }
                return s.sort((e1, t)=>n[e1] - n[t] || i[t] - i[e1]), s;
            }
            addToSortKeyRanges(e1, t) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === t ? r.symbolInstanceEnd = e1 + 1 : this.sortKeyRanges.push({
                    sortKey: t,
                    symbolInstanceStart: e1,
                    symbolInstanceEnd: e1 + 1
                });
            }
            sortFeatures(e1) {
                if (this.sortFeaturesByY && this.sortedAngle !== e1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(e1), this.sortedAngle = e1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const e1 of this.symbolInstanceIndexes){
                        const t = this.symbolInstances.get(e1);
                        this.featureSortOrder.push(t.featureIndex), [
                            t.rightJustifiedTextSymbolIndex,
                            t.centerJustifiedTextSymbolIndex,
                            t.leftJustifiedTextSymbolIndex
                        ].forEach((e1, t, r)=>{
                            e1 >= 0 && r.indexOf(e1) === t && this.addIndicesForPlacedSymbol(this.text, e1);
                        }), t.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, t.verticalPlacedTextSymbolIndex), t.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, t.placedIconSymbolIndex), t.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, t.verticalPlacedIconSymbolIndex);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
        }
        let lh, uh;
        ls("SymbolBucket", ah, {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), ah.MAX_GLYPHS = 65535, ah.addDynamicAttributes = nh;
        var ch = {
            get paint () {
                return uh = uh || new Gs({
                    "icon-opacity": new $s(xe.paint_symbol["icon-opacity"]),
                    "icon-color": new $s(xe.paint_symbol["icon-color"]),
                    "icon-halo-color": new $s(xe.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new $s(xe.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new $s(xe.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new Ns(xe.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new Ns(xe.paint_symbol["icon-translate-anchor"]),
                    "text-opacity": new $s(xe.paint_symbol["text-opacity"]),
                    "text-color": new $s(xe.paint_symbol["text-color"], {
                        runtimeType: Oe,
                        getOverride: (e1)=>e1.textColor,
                        hasOverride: (e1)=>!!e1.textColor
                    }),
                    "text-halo-color": new $s(xe.paint_symbol["text-halo-color"]),
                    "text-halo-width": new $s(xe.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new $s(xe.paint_symbol["text-halo-blur"]),
                    "text-translate": new Ns(xe.paint_symbol["text-translate"]),
                    "text-translate-anchor": new Ns(xe.paint_symbol["text-translate-anchor"])
                });
            },
            get layout () {
                return lh = lh || new Gs({
                    "symbol-placement": new Ns(xe.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new Ns(xe.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new Ns(xe.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new $s(xe.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new Ns(xe.layout_symbol["symbol-z-order"]),
                    "icon-allow-overlap": new Ns(xe.layout_symbol["icon-allow-overlap"]),
                    "icon-overlap": new Ns(xe.layout_symbol["icon-overlap"]),
                    "icon-ignore-placement": new Ns(xe.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new Ns(xe.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new Ns(xe.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new $s(xe.layout_symbol["icon-size"]),
                    "icon-text-fit": new Ns(xe.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new Ns(xe.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new $s(xe.layout_symbol["icon-image"]),
                    "icon-rotate": new $s(xe.layout_symbol["icon-rotate"]),
                    "icon-padding": new $s(xe.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new Ns(xe.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new $s(xe.layout_symbol["icon-offset"]),
                    "icon-anchor": new $s(xe.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new Ns(xe.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new Ns(xe.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new Ns(xe.layout_symbol["text-rotation-alignment"]),
                    "text-field": new $s(xe.layout_symbol["text-field"]),
                    "text-font": new $s(xe.layout_symbol["text-font"]),
                    "text-size": new $s(xe.layout_symbol["text-size"]),
                    "text-max-width": new $s(xe.layout_symbol["text-max-width"]),
                    "text-line-height": new Ns(xe.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new $s(xe.layout_symbol["text-letter-spacing"]),
                    "text-justify": new $s(xe.layout_symbol["text-justify"]),
                    "text-radial-offset": new $s(xe.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new Ns(xe.layout_symbol["text-variable-anchor"]),
                    "text-variable-anchor-offset": new $s(xe.layout_symbol["text-variable-anchor-offset"]),
                    "text-anchor": new $s(xe.layout_symbol["text-anchor"]),
                    "text-max-angle": new Ns(xe.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new Ns(xe.layout_symbol["text-writing-mode"]),
                    "text-rotate": new $s(xe.layout_symbol["text-rotate"]),
                    "text-padding": new Ns(xe.layout_symbol["text-padding"]),
                    "text-keep-upright": new Ns(xe.layout_symbol["text-keep-upright"]),
                    "text-transform": new $s(xe.layout_symbol["text-transform"]),
                    "text-offset": new $s(xe.layout_symbol["text-offset"]),
                    "text-allow-overlap": new Ns(xe.layout_symbol["text-allow-overlap"]),
                    "text-overlap": new Ns(xe.layout_symbol["text-overlap"]),
                    "text-ignore-placement": new Ns(xe.layout_symbol["text-ignore-placement"]),
                    "text-optional": new Ns(xe.layout_symbol["text-optional"])
                });
            }
        };
        class hh {
            constructor(e1){
                if (void 0 === e1.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                this.type = e1.property.overrides ? e1.property.overrides.runtimeType : ze, this.defaultValue = e1;
            }
            evaluate(e1) {
                if (e1.formattedSection) {
                    const t = this.defaultValue.property.overrides;
                    if (t && t.hasOverride(e1.formattedSection)) return t.getOverride(e1.formattedSection);
                }
                return e1.feature && e1.featureState ? this.defaultValue.evaluate(e1.feature, e1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(e1) {
                this.defaultValue.isConstant() || e1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        ls("FormatSectionOverride", hh, {
            omit: [
                "defaultValue"
            ]
        });
        class ph extends Xs {
            constructor(e1, t){
                super(e1, ch, t);
            }
            recalculate(e1, t) {
                if (super.recalculate(e1, t), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                    const e1 = this.layout.get("text-writing-mode");
                    if (e1) {
                        const t = [];
                        for (const r of e1)t.indexOf(r) < 0 && t.push(r);
                        this.layout._values["text-writing-mode"] = t;
                    } else this.layout._values["text-writing-mode"] = [
                        "horizontal"
                    ];
                }
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(e1, t, r, n) {
                const i = this.layout.get(e1).evaluate(t, {}, r, n), s = this._unevaluatedLayout._values[e1];
                return s.isDataDriven() || ti(s.value) || !i ? i : function(e1, t) {
                    return t.replace(/{([^{}]+)}/g, (t, r)=>e1 && r in e1 ? String(e1[r]) : "");
                }(t.properties, i);
            }
            createBucket(e1) {
                return new ah(e1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                throw new Error("Should take a different path in FeatureIndex");
            }
            _setPaintOverrides() {
                for (const e1 of ch.paint.overridableProperties){
                    if (!ph.hasPaintOverride(this.layout, e1)) continue;
                    const t = this.paint.get(e1), r = new hh(t), n = new ei(r, t.property.specification);
                    let i = null;
                    i = "constant" === t.value.kind || "source" === t.value.kind ? new ni("source", n) : new ii("composite", n, t.value.zoomStops), this.paint._values[e1] = new Os(t.property, i, t.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(e1, t, r) {
                return !(!this.layout || t.isDataDriven() || r.isDataDriven()) && ph.hasPaintOverride(this.layout, e1);
            }
            static hasPaintOverride(e1, t) {
                const r = e1.get("text-field"), n = ch.paint.properties[t];
                let i = !1;
                const s = (e1)=>{
                    for (const t of e1)if (n.overrides && n.overrides.hasOverride(t)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Ft) s(r.value.value.sections);
                else if ("source" === r.value.kind || "composite" === r.value.kind) {
                    const e1 = (t)=>{
                        i || (t instanceof qt && $t(t.value) === qe ? s(t.value.sections) : t instanceof Er ? s(t.sections) : t.eachChild(e1));
                    }, t = r.value;
                    t._styleExpression && e1(t._styleExpression.expression);
                }
                return i;
            }
        }
        let fh;
        var dh = {
            get paint () {
                return fh = fh || new Gs({
                    "background-color": new Ns(xe.paint_background["background-color"]),
                    "background-pattern": new qs(xe.paint_background["background-pattern"]),
                    "background-opacity": new Ns(xe.paint_background["background-opacity"])
                });
            }
        };
        class yh extends Xs {
            constructor(e1, t){
                super(e1, dh, t);
            }
        }
        class mh extends Xs {
            constructor(e1, t){
                super(e1, {}, t), this.onAdd = (e1)=>{
                    this.implementation.onAdd && this.implementation.onAdd(e1, e1.painter.context.gl);
                }, this.onRemove = (e1)=>{
                    this.implementation.onRemove && this.implementation.onRemove(e1, e1.painter.context.gl);
                }, this.implementation = e1;
            }
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {
                throw new Error("Custom layers cannot be serialized");
            }
        }
        class gh {
            constructor(e1){
                this._methodToThrottle = e1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._methodToThrottle();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._methodToThrottle();
                }, 0));
            }
            remove() {
                delete this._channel, this._methodToThrottle = ()=>{};
            }
        }
        const xh = {
            once: !0
        }, vh = 6371008.8;
        class bh {
            constructor(e1, t){
                if (isNaN(e1) || isNaN(t)) throw new Error(`Invalid LngLat object: (${e1}, ${t})`);
                if (this.lng = +e1, this.lat = +t, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new bh(L(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(e1) {
                const t = Math.PI / 180, r = this.lat * t, n = e1.lat * t, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((e1.lng - this.lng) * t);
                return vh * Math.acos(Math.min(i, 1));
            }
            static convert(e1) {
                if (e1 instanceof bh) return e1;
                if (Array.isArray(e1) && (2 === e1.length || 3 === e1.length)) return new bh(Number(e1[0]), Number(e1[1]));
                if (!Array.isArray(e1) && "object" == typeof e1 && null !== e1) return new bh(Number("lng" in e1 ? e1.lng : e1.lon), Number(e1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        const wh = 2 * Math.PI * vh;
        function _h(e1) {
            return wh * Math.cos(e1 * Math.PI / 180);
        }
        function Sh(e1) {
            return (180 + e1) / 360;
        }
        function Ah(e1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1 * Math.PI / 360))) / 360;
        }
        function Th(e1, t) {
            return e1 / _h(t);
        }
        function Ih(e1) {
            return 360 * e1 - 180;
        }
        function Eh(e1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * e1) * Math.PI / 180)) - 90;
        }
        function Mh(e1, t) {
            return e1 * _h(Eh(t));
        }
        class kh {
            constructor(e1, t, r = 0){
                this.x = +e1, this.y = +t, this.z = +r;
            }
            static fromLngLat(e1, t = 0) {
                const r = bh.convert(e1);
                return new kh(Sh(r.lng), Ah(r.lat), Th(t, r.lat));
            }
            toLngLat() {
                return new bh(Ih(this.x), Eh(this.y));
            }
            toAltitude() {
                return Mh(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                var e1;
                return 1 / wh * (e1 = Eh(this.y), 1 / Math.cos(e1 * Math.PI / 180));
            }
        }
        function Fh(e1, t, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                e1 * n - 2 * Math.PI * 6378137 / 2,
                t * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        class Dh {
            constructor(e1, t, r){
                if (!function(e1, t, r) {
                    return !(e1 < 0 || e1 > 25 || r < 0 || r >= Math.pow(2, e1) || t < 0 || t >= Math.pow(2, e1));
                }(e1, t, r)) throw new Error(`x=${t}, y=${r}, z=${e1} outside of bounds. 0<=x<${Math.pow(2, e1)}, 0<=y<${Math.pow(2, e1)} 0<=z<=25 `);
                this.z = e1, this.x = t, this.y = r, this.key = zh(0, e1, e1, t, r);
            }
            equals(e1) {
                return this.z === e1.z && this.x === e1.x && this.y === e1.y;
            }
            url(e1, t, r) {
                const n = (s = this.y, o = this.z, a = Fh(256 * (i = this.x), 256 * (s = Math.pow(2, o) - s - 1), o), l = Fh(256 * (i + 1), 256 * (s + 1), o), a[0] + "," + a[1] + "," + l[0] + "," + l[1]);
                var i, s, o, a, l;
                const u = function(e1, t, r) {
                    let n, i = "";
                    for(let s = e1; s > 0; s--)n = 1 << s - 1, i += (t & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return e1[(this.x + this.y) % e1.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === r ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, t > 1 ? "@2x" : "").replace(/{quadkey}/g, u).replace(/{bbox-epsg-3857}/g, n);
            }
            isChildOf(e1) {
                const t = this.z - e1.z;
                return t > 0 && e1.x === this.x >> t && e1.y === this.y >> t;
            }
            getTilePoint(e1) {
                const t = Math.pow(2, this.z);
                return new r((e1.x * t - this.x) * k, (e1.y * t - this.y) * k);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class Ph {
            constructor(e1, t){
                this.wrap = e1, this.canonical = t, this.key = zh(e1, t.z, t.z, t.x, t.y);
            }
        }
        class Bh {
            constructor(e1, t, r, n, i){
                if (this.terrainRttPosMatrix32f = null, e1 < r) throw new Error(`overscaledZ should be >= z; overscaledZ = ${e1}; z = ${r}`);
                this.overscaledZ = e1, this.wrap = t, this.canonical = new Dh(r, +n, +i), this.key = zh(t, e1, r, n, i);
            }
            clone() {
                return new Bh(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            equals(e1) {
                return this.overscaledZ === e1.overscaledZ && this.wrap === e1.wrap && this.canonical.equals(e1.canonical);
            }
            scaledTo(e1) {
                if (e1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${e1}; overscaledZ = ${this.overscaledZ}`);
                const t = this.canonical.z - e1;
                return e1 > this.canonical.z ? new Bh(e1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Bh(e1, this.wrap, e1, this.canonical.x >> t, this.canonical.y >> t);
            }
            isOverscaled() {
                return this.overscaledZ > this.canonical.z;
            }
            calculateScaledKey(e1, t) {
                if (e1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${e1}; overscaledZ = ${this.overscaledZ}`);
                const r = this.canonical.z - e1;
                return e1 > this.canonical.z ? zh(this.wrap * +t, e1, this.canonical.z, this.canonical.x, this.canonical.y) : zh(this.wrap * +t, e1, e1, this.canonical.x >> r, this.canonical.y >> r);
            }
            isChildOf(e1) {
                if (e1.wrap !== this.wrap) return !1;
                if (this.overscaledZ - e1.overscaledZ <= 0) return !1;
                if (0 === e1.overscaledZ) return this.overscaledZ > 0;
                const t = this.canonical.z - e1.canonical.z;
                return !(t < 0) && e1.canonical.x === this.canonical.x >> t && e1.canonical.y === this.canonical.y >> t;
            }
            children(e1) {
                if (this.overscaledZ >= e1) return [
                    new Bh(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const t = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new Bh(t, this.wrap, t, r, n),
                    new Bh(t, this.wrap, t, r + 1, n),
                    new Bh(t, this.wrap, t, r, n + 1),
                    new Bh(t, this.wrap, t, r + 1, n + 1)
                ];
            }
            isLessThan(e1) {
                return this.wrap < e1.wrap || !(this.wrap > e1.wrap) && (this.overscaledZ < e1.overscaledZ || !(this.overscaledZ > e1.overscaledZ) && (this.canonical.x < e1.canonical.x || !(this.canonical.x > e1.canonical.x) && this.canonical.y < e1.canonical.y));
            }
            wrapped() {
                return new Bh(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(e1) {
                return new Bh(this.overscaledZ, e1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new Ph(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
            getTilePoint(e1) {
                return this.canonical.getTilePoint(new kh(e1.x - this.wrap, e1.y));
            }
        }
        function zh(e1, t, r, n, i) {
            (e1 *= 2) < 0 && (e1 = -1 * e1 - 1);
            const s = 1 << r;
            return (s * s * e1 + s * i + n).toString(36) + r.toString(36) + t.toString(36);
        }
        function Vh(e1, t) {
            return t ? e1.properties[t] : e1.id;
        }
        function Ch(e1, t) {
            const r = {
                id: e1.id
            };
            if (t.removeAllProperties && (delete e1.removeProperties, delete e1.addOrUpdateProperties, delete t.removeProperties), t.removeProperties) for (const r of t.removeProperties){
                const t = e1.addOrUpdateProperties.findIndex((e1)=>e1.key === r);
                t > -1 && e1.addOrUpdateProperties.splice(t, 1);
            }
            return (e1.removeAllProperties || t.removeAllProperties) && (r.removeAllProperties = !0), (e1.removeProperties || t.removeProperties) && (r.removeProperties = [
                ...e1.removeProperties || [],
                ...t.removeProperties || []
            ]), (e1.addOrUpdateProperties || t.addOrUpdateProperties) && (r.addOrUpdateProperties = [
                ...e1.addOrUpdateProperties || [],
                ...t.addOrUpdateProperties || []
            ]), (e1.newGeometry || t.newGeometry) && (r.newGeometry = t.newGeometry || e1.newGeometry), r;
        }
        function Lh(e1) {
            var t, r;
            if (!e1) return {};
            const n = {};
            return n.removeAll = e1.removeAll, n.remove = new Set(e1.remove || []), n.add = new Map(null === (t = e1.add) || void 0 === t ? void 0 : t.map((e1)=>[
                    e1.id,
                    e1
                ])), n.update = new Map(null === (r = e1.update) || void 0 === r ? void 0 : r.map((e1)=>[
                    e1.id,
                    e1
                ])), n;
        }
        ls("CanonicalTileID", Dh), ls("OverscaledTileID", Bh, {
            omit: [
                "terrainRttPosMatrix32f"
            ]
        });
        class Oh {
            constructor(e1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let t = 0; t < e1.length; t++){
                    const r = e1[t];
                    this._stringToNumber[r] = t, this._numberToString[t] = r;
                }
            }
            encode(e1) {
                return this._stringToNumber[e1];
            }
            decode(e1) {
                if (e1 >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${e1} can't be >= this._numberToString.length ${this._numberToString.length}`);
                return this._numberToString[e1];
            }
        }
        class Rh {
            constructor(e1, t, r, n, i){
                this.type = "Feature", this._vectorTileFeature = e1, e1._z = t, e1._x = r, e1._y = n, this.properties = e1.properties, this.id = i;
            }
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
            }
            set geometry(e1) {
                this._geometry = e1;
            }
            toJSON() {
                const e1 = {
                    geometry: this.geometry
                };
                for(const t in this)"_geometry" !== t && "_vectorTileFeature" !== t && (e1[t] = this[t]);
                return e1;
            }
        }
        class Nh {
            _name;
            dataBuffer;
            nullabilityBuffer;
            _size;
            constructor(e1, t, r){
                this._name = e1, this.dataBuffer = t, "number" == typeof r ? this._size = r : (this.nullabilityBuffer = r, this._size = r.size());
            }
            getValue(e1) {
                return this.nullabilityBuffer && !this.nullabilityBuffer.get(e1) ? null : this.getValueFromBuffer(e1);
            }
            has(e1) {
                return this.nullabilityBuffer && this.nullabilityBuffer.get(e1) || !this.nullabilityBuffer;
            }
            get name() {
                return this._name;
            }
            get size() {
                return this._size;
            }
        }
        class $h extends Nh {
        }
        class Uh extends $h {
            getValueFromBuffer(e1) {
                return this.dataBuffer[e1];
            }
        }
        class qh extends $h {
            getValueFromBuffer(e1) {
                return this.dataBuffer[e1];
            }
        }
        class jh extends Nh {
            delta;
            constructor(e1, t, r, n){
                super(e1, t, n), this.delta = r;
            }
        }
        class Gh extends jh {
            constructor(e1, t, r, n){
                super(e1, Int32Array.of(t), r, n);
            }
            getValueFromBuffer(e1) {
                return this.dataBuffer[0] + e1 * this.delta;
            }
        }
        class Xh extends Nh {
            constructor(e1, t, r){
                super(e1, Int32Array.of(t), r);
            }
            getValueFromBuffer(e1) {
                return this.dataBuffer[0];
            }
        }
        class Yh {
            _name;
            _geometryVector;
            _idVector;
            _propertyVectors;
            _extent;
            propertyVectorsMap;
            constructor(e1, t, r, n, i = 4096){
                this._name = e1, this._geometryVector = t, this._idVector = r, this._propertyVectors = n, this._extent = i;
            }
            get name() {
                return this._name;
            }
            get idVector() {
                return this._idVector;
            }
            get geometryVector() {
                return this._geometryVector;
            }
            get propertyVectors() {
                return this._propertyVectors;
            }
            getPropertyVector(e1) {
                return this.propertyVectorsMap || (this.propertyVectorsMap = new Map(this._propertyVectors.map((e1)=>[
                        e1.name,
                        e1
                    ]))), this.propertyVectorsMap.get(e1);
            }
            *[Symbol.iterator]() {
                const e1 = this.geometryVector[Symbol.iterator]();
                let t = 0;
                for(; t < this.numFeatures;){
                    let r;
                    this.idVector && (r = this.containsMaxSaveIntegerValues(this.idVector) ? Number(this.idVector.getValue(t)) : this.idVector.getValue(t));
                    const n = e1?.next().value, i = {};
                    for (const e1 of this.propertyVectors){
                        if (!e1) continue;
                        const r = e1.name, n = e1.getValue(t);
                        null !== n && (i[r] = n);
                    }
                    t++, yield {
                        id: r,
                        geometry: n,
                        properties: i
                    };
                }
            }
            get numFeatures() {
                return this.geometryVector.numGeometries;
            }
            get extent() {
                return this._extent;
            }
            getFeatures() {
                const e1 = [], t = this.geometryVector.getGeometries();
                for(let r = 0; r < this.numFeatures; r++){
                    let n;
                    this.idVector && (n = this.containsMaxSaveIntegerValues(this.idVector) ? Number(this.idVector.getValue(r)) : this.idVector.getValue(r));
                    const i = {
                        coordinates: t[r],
                        type: this.geometryVector.geometryType(r)
                    }, s = {};
                    for (const e1 of this.propertyVectors){
                        if (!e1) continue;
                        const t = e1.name, n = e1.getValue(r);
                        null !== n && (s[t] = n);
                    }
                    e1.push({
                        id: n,
                        geometry: i,
                        properties: s
                    });
                }
                return e1;
            }
            containsMaxSaveIntegerValues(e1) {
                return e1 instanceof Uh || e1 instanceof Xh && e1 instanceof Gh || e1 instanceof qh;
            }
        }
        class Zh {
            value;
            constructor(e1){
                this.value = e1;
            }
            get() {
                return this.value;
            }
            set(e1) {
                this.value = e1;
            }
            increment() {
                return this.value++;
            }
            add(e1) {
                this.value += e1;
            }
        }
        var Hh, Kh, Wh, Jh, Qh, ep, tp, rp, np, ip;
        !function(e1) {
            e1.PRESENT = "PRESENT", e1.DATA = "DATA", e1.OFFSET = "OFFSET", e1.LENGTH = "LENGTH";
        }(Hh || (Hh = {}));
        class sp {
            _dictionaryType;
            _offsetType;
            _lengthType;
            constructor(e1, t, r){
                this._dictionaryType = e1, this._offsetType = t, this._lengthType = r;
            }
            get dictionaryType() {
                return this._dictionaryType;
            }
            get offsetType() {
                return this._offsetType;
            }
            get lengthType() {
                return this._lengthType;
            }
        }
        function op(e1, t, r) {
            const n = new Int32Array(r);
            let i = 0, s = t.get();
            for(let t = 0; t < n.length; t++){
                let t = e1[s++], r = 127 & t;
                t < 128 || (t = e1[s++], r |= (127 & t) << 7, t < 128 || (t = e1[s++], r |= (127 & t) << 14, t < 128 || (t = e1[s++], r |= (127 & t) << 21, t < 128 || (t = e1[s++], r |= (15 & t) << 28)))), n[i++] = r;
            }
            return t.set(s), n;
        }
        function ap(e1, t, r) {
            const n = new BigInt64Array(r);
            for(let r = 0; r < n.length; r++)n[r] = pp(e1, t);
            return n;
        }
        function lp(e1, t) {
            let r, n;
            return n = e1[t.get()], t.increment(), r = 127 & n, n < 128 ? r : (n = e1[t.get()], t.increment(), r |= (127 & n) << 7, n < 128 ? r : (n = e1[t.get()], t.increment(), r |= (127 & n) << 14, n < 128 ? r : (n = e1[t.get()], t.increment(), r |= (127 & n) << 21, n < 128 ? r : (n = e1[t.get()], r |= (15 & n) << 28, function(e1, t, r) {
                let n, i;
                if (i = t[r.get()], r.increment(), n = (112 & i) >> 4, i < 128) return 4294967296 * n + (e1 >>> 0);
                if (i = t[r.get()], r.increment(), n |= (127 & i) << 3, i < 128) return 4294967296 * n + (e1 >>> 0);
                if (i = t[r.get()], r.increment(), n |= (127 & i) << 10, i < 128) return 4294967296 * n + (e1 >>> 0);
                if (i = t[r.get()], r.increment(), n |= (127 & i) << 17, i < 128) return 4294967296 * n + (e1 >>> 0);
                if (i = t[r.get()], r.increment(), n |= (127 & i) << 24, i < 128) return 4294967296 * n + (e1 >>> 0);
                if (i = t[r.get()], r.increment(), n |= (1 & i) << 31, i < 128) return 4294967296 * n + (e1 >>> 0);
                throw new Error("Expected varint not more than 10 bytes");
            }(r, e1, t)))));
        }
        function up(e1, t, r, n) {
            throw new Error("FastPFor is not implemented yet.");
        }
        function cp(e1) {
            return e1 >>> 1 ^ -(1 & e1);
        }
        function hp(e1) {
            return e1 >> 1n ^ -(1n & e1);
        }
        function pp(e1, t) {
            let r = 0n, n = 0, i = t.get();
            for(; i < e1.length;){
                const t = e1[i++];
                if (r |= BigInt(127 & t) << BigInt(n), !(128 & t)) break;
                if (n += 7, n >= 64) throw new Error("Varint too long");
            }
            return t.set(i), r;
        }
        function fp(e1, t, r) {
            const n = new Int32Array(r);
            let i = 0;
            for(let r = 0; r < t; r++){
                const s = e1[r];
                n.fill(e1[r + t], i, i + s), i += s;
            }
            return n;
        }
        function dp(e1, t, r) {
            const n = new BigInt64Array(r);
            let i = 0;
            for(let r = 0; r < t; r++){
                const s = Number(e1[r]);
                n.fill(e1[r + t], i, i + s), i += s;
            }
            return n;
        }
        function yp(e1, t, r) {
            const n = new Float64Array(r);
            let i = 0;
            for(let r = 0; r < t; r++){
                const s = e1[r];
                n.fill(e1[r + t], i, i + s), i += s;
            }
            return n;
        }
        function mp(e1) {
            const t = e1.length / 4 * 4;
            let r = 1;
            if (t >= 4) for(let n = e1[0]; r < t - 4; r += 4)n = e1[r] += n, n = e1[r + 1] += n, n = e1[r + 2] += n, n = e1[r + 3] += n;
            for(; r != e1.length;)e1[r] += e1[r - 1], ++r;
        }
        function gp(e1) {
            e1[0] = e1[0] >>> 1 ^ -(1 & e1[0]), e1[1] = e1[1] >>> 1 ^ -(1 & e1[1]);
            const t = e1.length / 4 * 4;
            let r = 2;
            if (t >= 4) for(; r < t - 4; r += 4){
                const t = e1[r], n = e1[r + 1], i = e1[r + 2], s = e1[r + 3];
                e1[r] = (t >>> 1 ^ -(1 & t)) + e1[r - 2], e1[r + 1] = (n >>> 1 ^ -(1 & n)) + e1[r - 1], e1[r + 2] = (i >>> 1 ^ -(1 & i)) + e1[r], e1[r + 3] = (s >>> 1 ^ -(1 & s)) + e1[r + 1];
            }
            for(; r != e1.length; r += 2)e1[r] = (e1[r] >>> 1 ^ -(1 & e1[r])) + e1[r - 2], e1[r + 1] = (e1[r + 1] >>> 1 ^ -(1 & e1[r + 1])) + e1[r - 1];
        }
        function xp(e1, t, r) {
            return Math.min(r, Math.max(t, e1));
        }
        !function(e1) {
            e1.NONE = "NONE", e1.DELTA = "DELTA", e1.COMPONENTWISE_DELTA = "COMPONENTWISE_DELTA", e1.RLE = "RLE", e1.MORTON = "MORTON", e1.PDE = "PDE";
        }(Kh || (Kh = {})), function(e1) {
            e1.NONE = "NONE", e1.FAST_PFOR = "FAST_PFOR", e1.VARINT = "VARINT", e1.ALP = "ALP";
        }(Wh || (Wh = {})), function(e1) {
            e1.NONE = "NONE", e1.SINGLE = "SINGLE", e1.SHARED = "SHARED", e1.VERTEX = "VERTEX", e1.MORTON = "MORTON", e1.FSST = "FSST";
        }(Jh || (Jh = {})), function(e1) {
            e1.VERTEX = "VERTEX", e1.INDEX = "INDEX", e1.STRING = "STRING", e1.KEY = "KEY";
        }(Qh || (Qh = {})), function(e1) {
            e1.VAR_BINARY = "VAR_BINARY", e1.GEOMETRIES = "GEOMETRIES", e1.PARTS = "PARTS", e1.RINGS = "RINGS", e1.TRIANGLES = "TRIANGLES", e1.SYMBOL = "SYMBOL", e1.DICTIONARY = "DICTIONARY";
        }(ep || (ep = {}));
        class vp {
            _physicalStreamType;
            _logicalStreamType;
            _logicalLevelTechnique1;
            _logicalLevelTechnique2;
            _physicalLevelTechnique;
            _numValues;
            _byteLength;
            constructor(e1, t, r, n, i, s, o){
                this._physicalStreamType = e1, this._logicalStreamType = t, this._logicalLevelTechnique1 = r, this._logicalLevelTechnique2 = n, this._physicalLevelTechnique = i, this._numValues = s, this._byteLength = o;
            }
            static decode(e1, t) {
                const r = e1[t.get()], n = Object.values(Hh)[r >> 4];
                let i = null;
                switch(n){
                    case Hh.DATA:
                        i = new sp(Object.values(Jh)[15 & r]);
                        break;
                    case Hh.OFFSET:
                        i = new sp(null, Object.values(Qh)[15 & r]);
                        break;
                    case Hh.LENGTH:
                        i = new sp(null, null, Object.values(ep)[15 & r]);
                }
                t.increment();
                const s = e1[t.get()], o = Object.values(Kh)[s >> 5], a = Object.values(Kh)[s >> 2 & 7], l = Object.values(Wh)[3 & s];
                t.increment();
                const u = op(e1, t, 2);
                return new vp(n, i, o, a, l, u[0], u[1]);
            }
            get physicalStreamType() {
                return this._physicalStreamType;
            }
            get logicalStreamType() {
                return this._logicalStreamType;
            }
            get logicalLevelTechnique1() {
                return this._logicalLevelTechnique1;
            }
            get logicalLevelTechnique2() {
                return this._logicalLevelTechnique2;
            }
            get physicalLevelTechnique() {
                return this._physicalLevelTechnique;
            }
            get numValues() {
                return this._numValues;
            }
            get byteLength() {
                return this._byteLength;
            }
            getDecompressedCount() {
                return this._numValues;
            }
        }
        class bp extends vp {
            num_bits;
            coordinate_shift;
            constructor(e1, t, r, n, i, s, o, a, l){
                super(e1, t, r, n, i, s, o), this.num_bits = a, this.coordinate_shift = l;
            }
            static decode(e1, t) {
                const r = vp.decode(e1, t), n = op(e1, t, 2);
                return new bp(r.physicalStreamType, r.logicalStreamType, r.logicalLevelTechnique1, r.logicalLevelTechnique2, r.physicalLevelTechnique, r.numValues, r.byteLength, n[0], n[1]);
            }
            static decodePartial(e1, t, r) {
                const n = op(t, r, 2);
                return new bp(e1.physicalStreamType, e1.logicalStreamType, e1.logicalLevelTechnique1, e1.logicalLevelTechnique2, e1.physicalLevelTechnique, e1.numValues, e1.byteLength, n[0], n[1]);
            }
            numBits() {
                return this.num_bits;
            }
            coordinateShift() {
                return this.coordinate_shift;
            }
        }
        class wp extends vp {
            _runs;
            _numRleValues;
            constructor(e1, t, r, n, i, s, o, a, l){
                super(e1, t, r, n, i, s, o), this._runs = a, this._numRleValues = l;
            }
            static decode(e1, t) {
                const r = vp.decode(e1, t), n = op(e1, t, 2);
                return new wp(r.physicalStreamType, r.logicalStreamType, r.logicalLevelTechnique1, r.logicalLevelTechnique2, r.physicalLevelTechnique, r.numValues, r.byteLength, n[0], n[1]);
            }
            static decodePartial(e1, t, r) {
                const n = op(t, r, 2);
                return new wp(e1.physicalStreamType, e1.logicalStreamType, e1.logicalLevelTechnique1, e1.logicalLevelTechnique2, e1.physicalLevelTechnique, e1.numValues, e1.byteLength, n[0], n[1]);
            }
            get runs() {
                return this._runs;
            }
            get numRleValues() {
                return this._numRleValues;
            }
            getDecompressedCount() {
                return this._numRleValues;
            }
        }
        class _p {
            static decode(e1, t) {
                const r = vp.decode(e1, t);
                return r.logicalLevelTechnique1 === Kh.MORTON ? bp.decodePartial(r, e1, t) : Kh.RLE !== r.logicalLevelTechnique1 && Kh.RLE !== r.logicalLevelTechnique2 || Wh.NONE === r.physicalLevelTechnique ? r : wp.decodePartial(r, e1, t);
            }
        }
        !function(e1) {
            e1[e1.FLAT = 0] = "FLAT", e1[e1.CONST = 1] = "CONST", e1[e1.SEQUENCE = 2] = "SEQUENCE", e1[e1.DICTIONARY = 3] = "DICTIONARY", e1[e1.FSST_DICTIONARY = 4] = "FSST_DICTIONARY";
        }(tp || (tp = {}));
        class Sp {
            values;
            _size;
            constructor(e1, t){
                this.values = e1, this._size = t;
            }
            get(e1) {
                const t = Math.floor(e1 / 8);
                return 1 == (this.values[t] >> e1 % 8 & 1);
            }
            set(e1, t) {
                const r = Math.floor(e1 / 8);
                this.values[r] = this.values[r] | (t ? 1 : 0) << e1 % 8;
            }
            getInt(e1) {
                const t = Math.floor(e1 / 8);
                return this.values[t] >> e1 % 8 & 1;
            }
            size() {
                return this._size;
            }
            getBuffer() {
                return this.values;
            }
        }
        class Ap {
            constructor(){}
            static decodeIntStream(e1, t, r, n, i) {
                const s = Ap.decodePhysicalLevelTechnique(e1, t, r);
                return this.decodeIntBuffer(s, r, n, i);
            }
            static decodeLengthStreamToOffsetBuffer(e1, t, r) {
                const n = Ap.decodePhysicalLevelTechnique(e1, t, r);
                return this.decodeLengthToOffsetBuffer(n, r);
            }
            static decodePhysicalLevelTechnique(e1, t, r) {
                const n = r.physicalLevelTechnique;
                if (n === Wh.FAST_PFOR) return up();
                if (n === Wh.VARINT) return op(e1, t, r.numValues);
                if (n === Wh.NONE) {
                    const n = t.get();
                    t.add(r.byteLength);
                    const i = e1.subarray(n, t.get());
                    return new Int32Array(i);
                }
                throw new Error("Specified physicalLevelTechnique is not supported (yet).");
            }
            static decodeConstIntStream(e1, t, r, n) {
                const i = Ap.decodePhysicalLevelTechnique(e1, t, r);
                if (1 === i.length) {
                    const e1 = i[0];
                    return n ? cp(e1) : e1;
                }
                return n ? function(e1) {
                    return cp(e1[1]);
                }(i) : function(e1) {
                    return e1[1];
                }(i);
            }
            static decodeSequenceIntStream(e1, t, r) {
                return function(e1) {
                    if (2 == e1.length) {
                        const t = cp(e1[1]);
                        return [
                            t,
                            t
                        ];
                    }
                    return [
                        cp(e1[2]),
                        cp(e1[3])
                    ];
                }(Ap.decodePhysicalLevelTechnique(e1, t, r));
            }
            static decodeSequenceLongStream(e1, t, r) {
                return function(e1) {
                    if (2 == e1.length) {
                        const t = hp(e1[1]);
                        return [
                            t,
                            t
                        ];
                    }
                    return [
                        hp(e1[2]),
                        hp(e1[3])
                    ];
                }(ap(e1, t, r.numValues));
            }
            static decodeLongStream(e1, t, r, n) {
                const i = ap(e1, t, r.numValues);
                return this.decodeLongBuffer(i, r, n);
            }
            static decodeLongFloat64Stream(e1, t, r, n) {
                const i = function(e1, t, r) {
                    const n = new Float64Array(t);
                    for(let i = 0; i < t; i++)n[i] = lp(e1, r);
                    return n;
                }(e1, r.numValues, t);
                return this.decodeFloat64Buffer(i, r, n);
            }
            static decodeConstLongStream(e1, t, r, n) {
                const i = ap(e1, t, r.numValues);
                if (1 === i.length) {
                    const e1 = i[0];
                    return n ? hp(e1) : e1;
                }
                return n ? function(e1) {
                    return hp(e1[1]);
                }(i) : function(e1) {
                    return e1[1];
                }(i);
            }
            static decodeIntBuffer(e1, t, r, n) {
                switch(t.logicalLevelTechnique1){
                    case Kh.DELTA:
                        return t.logicalLevelTechnique2 === Kh.RLE ? function(e1, t, r) {
                            const n = new Int32Array(r);
                            let i = 0, s = 0;
                            for(let r = 0; r < t; r++){
                                const o = e1[r], a = cp(e1[r + t]);
                                for(let e1 = 0; e1 < o; e1++)s += a, n[i++] = s;
                            }
                            return n;
                        }(e1, t.runs, t.numRleValues) : (function(e1) {
                            e1[0] = e1[0] >>> 1 ^ -(1 & e1[0]);
                            const t = e1.length / 4 * 4;
                            let r = 1;
                            if (t >= 4) for(; r < t - 4; r += 4){
                                const t = e1[r], n = e1[r + 1], i = e1[r + 2], s = e1[r + 3];
                                e1[r] = (t >>> 1 ^ -(1 & t)) + e1[r - 1], e1[r + 1] = (n >>> 1 ^ -(1 & n)) + e1[r], e1[r + 2] = (i >>> 1 ^ -(1 & i)) + e1[r + 1], e1[r + 3] = (s >>> 1 ^ -(1 & s)) + e1[r + 2];
                            }
                            for(; r != e1.length; ++r)e1[r] = (e1[r] >>> 1 ^ -(1 & e1[r])) + e1[r - 1];
                        }(e1), e1);
                    case Kh.RLE:
                        return function(e1, t, r) {
                            return r ? function(e1, t, r) {
                                const n = new Int32Array(r);
                                let i = 0;
                                for(let r = 0; r < t; r++){
                                    const s = e1[r];
                                    let o = e1[r + t];
                                    o = o >>> 1 ^ -(1 & o), n.fill(o, i, i + s), i += s;
                                }
                                return n;
                            }(e1, t.runs, t.numRleValues) : fp(e1, t.runs, t.numRleValues);
                        }(e1, t, r);
                    case Kh.MORTON:
                        return mp(e1), e1;
                    case Kh.COMPONENTWISE_DELTA:
                        return n ? (function(e1, t, r, n) {
                            let i = e1[0] >>> 1 ^ -(1 & e1[0]), s = e1[1] >>> 1 ^ -(1 & e1[1]);
                            e1[0] = xp(Math.round(i * t), r, n), e1[1] = xp(Math.round(s * t), r, n);
                            const o = e1.length / 16;
                            let a = 2;
                            if (o >= 4) for(; a < o - 4; a += 4){
                                const o = e1[a], l = e1[a + 1], u = (o >>> 1 ^ -(1 & o)) + i, c = (l >>> 1 ^ -(1 & l)) + s;
                                e1[a] = xp(Math.round(u * t), r, n), e1[a + 1] = xp(Math.round(c * t), r, n);
                                const h = e1[a + 2], p = e1[a + 3];
                                i = (h >>> 1 ^ -(1 & h)) + u, s = (p >>> 1 ^ -(1 & p)) + c, e1[a + 2] = xp(Math.round(i * t), r, n), e1[a + 3] = xp(Math.round(s * t), r, n);
                            }
                            for(; a != e1.length; a += 2)i += e1[a] >>> 1 ^ -(1 & e1[a]), s += e1[a + 1] >>> 1 ^ -(1 & e1[a + 1]), e1[a] = xp(Math.round(i * t), r, n), e1[a + 1] = xp(Math.round(s * t), r, n);
                        }(e1, n.scale, n.min, n.max), e1) : (gp(e1), e1);
                    case Kh.NONE:
                        return r && function(e1) {
                            for(let t = 0; t < e1.length; t++){
                                const r = e1[t];
                                e1[t] = r >>> 1 ^ -(1 & r);
                            }
                        }(e1), e1;
                    default:
                        throw new Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
                }
            }
            static decodeLongBuffer(e1, t, r) {
                switch(t.logicalLevelTechnique1){
                    case Kh.DELTA:
                        return t.logicalLevelTechnique2 === Kh.RLE ? function(e1, t, r) {
                            const n = new BigInt64Array(r);
                            let i = 0, s = 0n;
                            for(let r = 0; r < t; r++){
                                const o = Number(e1[r]), a = hp(e1[r + t]);
                                for(let e1 = 0; e1 < o; e1++)s += a, n[i++] = s;
                            }
                            return n;
                        }(e1, t.runs, t.numRleValues) : (function(e1) {
                            e1[0] = e1[0] >> 1n ^ -(1n & e1[0]);
                            const t = e1.length / 4 * 4;
                            let r = 1;
                            if (t >= 4) for(; r < t - 4; r += 4){
                                const t = e1[r], n = e1[r + 1], i = e1[r + 2], s = e1[r + 3];
                                e1[r] = (t >> 1n ^ -(1n & t)) + e1[r - 1], e1[r + 1] = (n >> 1n ^ -(1n & n)) + e1[r], e1[r + 2] = (i >> 1n ^ -(1n & i)) + e1[r + 1], e1[r + 3] = (s >> 1n ^ -(1n & s)) + e1[r + 2];
                            }
                            for(; r != e1.length; ++r)e1[r] = (e1[r] >> 1n ^ -(1n & e1[r])) + e1[r - 1];
                        }(e1), e1);
                    case Kh.RLE:
                        return function(e1, t, r) {
                            return r ? function(e1, t, r) {
                                const n = new BigInt64Array(r);
                                let i = 0;
                                for(let r = 0; r < t; r++){
                                    const s = Number(e1[r]);
                                    let o = e1[r + t];
                                    o = o >> 1n ^ -(1n & o), n.fill(o, i, i + s), i += s;
                                }
                                return n;
                            }(e1, t.runs, t.numRleValues) : dp(e1, t.runs, t.numRleValues);
                        }(e1, t, r);
                    case Kh.NONE:
                        return r && function(e1) {
                            for(let t = 0; t < e1.length; t++){
                                const r = e1[t];
                                e1[t] = r >> 1n ^ -(1n & r);
                            }
                        }(e1), e1;
                    default:
                        throw new Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
                }
            }
            static decodeFloat64Buffer(e1, t, r) {
                switch(t.logicalLevelTechnique1){
                    case Kh.DELTA:
                        return t.logicalLevelTechnique2 === Kh.RLE && (e1 = yp(e1, t.runs, t.numRleValues)), function(e1) {
                            e1[0] = e1[0] % 2 == 1 ? (e1[0] + 1) / -2 : e1[0] / 2;
                            const t = e1.length / 4 * 4;
                            let r = 1;
                            if (t >= 4) for(; r < t - 4; r += 4){
                                const t = e1[r], n = e1[r + 1], i = e1[r + 2], s = e1[r + 3];
                                e1[r] = (t % 2 == 1 ? (t + 1) / -2 : t / 2) + e1[r - 1], e1[r + 1] = (n % 2 == 1 ? (n + 1) / -2 : n / 2) + e1[r], e1[r + 2] = (i % 2 == 1 ? (i + 1) / -2 : i / 2) + e1[r + 1], e1[r + 3] = (s % 2 == 1 ? (s + 1) / -2 : s / 2) + e1[r + 2];
                            }
                            for(; r != e1.length; ++r)e1[r] = (e1[r] % 2 == 1 ? (e1[r] + 1) / -2 : e1[r] / 2) + e1[r - 1];
                        }(e1), e1;
                    case Kh.RLE:
                        return function(e1, t, r) {
                            return r ? function(e1, t, r) {
                                const n = new Float64Array(r);
                                let i = 0;
                                for(let r = 0; r < t; r++){
                                    const s = e1[r];
                                    let o = e1[r + t];
                                    o = o % 2 == 1 ? (o + 1) / -2 : o / 2, n.fill(o, i, i + s), i += s;
                                }
                                return n;
                            }(e1, t.runs, t.numRleValues) : yp(e1, t.runs, t.numRleValues);
                        }(e1, t, r);
                    case Kh.NONE:
                        return r && function(e1) {
                            for(let t = 0; t < e1.length; t++){
                                const r = e1[t];
                                e1[t] = r % 2 == 1 ? (r + 1) / -2 : r / 2;
                            }
                        }(e1), e1;
                    default:
                        throw new Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
                }
            }
            static decodeLengthToOffsetBuffer(e1, t) {
                if (t.logicalLevelTechnique1 === Kh.DELTA && t.logicalLevelTechnique2 === Kh.NONE) return function(e1) {
                    const t = new Int32Array(e1.length + 1);
                    t[0] = 0, t[1] = cp(e1[0]);
                    let r = t[1], n = 2;
                    for(; n != t.length; ++n){
                        const i = e1[n - 1];
                        r += i >>> 1 ^ -(1 & i), t[n] = t[n - 1] + r;
                    }
                    return t;
                }(e1);
                if (t.logicalLevelTechnique1 === Kh.RLE && t.logicalLevelTechnique2 === Kh.NONE) return function(e1, t, r) {
                    const n = new Int32Array(r + 1);
                    n[0] = 0;
                    let i = 1, s = n[0];
                    for(let r = 0; r < t; r++){
                        const o = e1[r], a = e1[r + t];
                        for(let e1 = i; e1 < i + o; e1++)n[e1] = a + s, s = n[e1];
                        i += o;
                    }
                    return n;
                }(e1, t.runs, t.numRleValues);
                if (t.logicalLevelTechnique1 === Kh.NONE && t.logicalLevelTechnique2 === Kh.NONE) {
                    !function(e1) {
                        let t = 0;
                        for(let r = 0; r < e1.length; r++)e1[r] += t, t = e1[r];
                    }(e1);
                    const r = new Int32Array(t.numValues + 1);
                    return r[0] = 0, r.set(e1, 1), r;
                }
                if (t.logicalLevelTechnique1 === Kh.DELTA && t.logicalLevelTechnique2 === Kh.RLE) {
                    const r = function(e1, t, r) {
                        const n = new Int32Array(r + 1);
                        n[0] = 0;
                        let i = 1, s = n[0];
                        for(let r = 0; r < t; r++){
                            const o = e1[r];
                            let a = e1[r + t];
                            a = a >>> 1 ^ -(1 & a);
                            for(let e1 = i; e1 < i + o; e1++)n[e1] = a + s, s = n[e1];
                            i += o;
                        }
                        return n;
                    }(e1, t.runs, t.numRleValues);
                    return mp(r), r;
                }
                throw new Error("Only delta encoding is supported for transforming length to offset streams yet.");
            }
            static decodeNullableIntStream(e1, t, r, n, i) {
                const s = r.physicalLevelTechnique === Wh.FAST_PFOR ? up() : op(e1, t, r.numValues);
                return this.decodeNullableIntBuffer(s, r, n, i);
            }
            static decodeNullableLongStream(e1, t, r, n, i) {
                const s = ap(e1, t, r.numValues);
                return this.decodeNullableLongBuffer(s, r, n, i);
            }
            static decodeNullableIntBuffer(e1, t, r, n) {
                switch(t.logicalLevelTechnique1){
                    case Kh.DELTA:
                        return t.logicalLevelTechnique2 === Kh.RLE && (e1 = fp(e1, t.runs, t.numRleValues)), function(e1, t) {
                            const r = new Int32Array(e1.size());
                            let n = 0;
                            e1.get(0) ? (r[0] = e1.get(0) ? t[0] >>> 1 ^ -(1 & t[0]) : 0, n = 1) : r[0] = 0;
                            let i = 1;
                            for(; i != r.length; ++i)r[i] = e1.get(i) ? r[i - 1] + (t[n] >>> 1 ^ -(1 & t[n++])) : r[i - 1];
                            return r;
                        }(n, e1);
                    case Kh.RLE:
                        return function(e1, t, r, n) {
                            const i = t;
                            return r ? function(e1, t, r) {
                                const n = new Int32Array(e1.size());
                                let i = 0;
                                for(let s = 0; s < r; s++){
                                    const o = t[s];
                                    let a = t[s + r];
                                    a = a >>> 1 ^ -(1 & a);
                                    for(let t = i; t < i + o; t++)e1.get(t) ? n[t] = a : (n[t] = 0, i++);
                                    i += o;
                                }
                                return n;
                            }(n, e1, i.runs) : function(e1, t, r) {
                                const n = new Int32Array(e1.size());
                                let i = 0;
                                for(let s = 0; s < r; s++){
                                    const o = t[s], a = t[s + r];
                                    for(let t = i; t < i + o; t++)e1.get(t) ? n[t] = a : (n[t] = 0, i++);
                                    i += o;
                                }
                                return n;
                            }(n, e1, i.runs);
                        }(e1, t, r, n);
                    case Kh.MORTON:
                        return mp(e1), e1;
                    case Kh.COMPONENTWISE_DELTA:
                        return gp(e1), e1;
                    case Kh.NONE:
                        return e1 = r ? function(e1, t) {
                            const r = new Int32Array(e1.size());
                            let n = 0, i = 0;
                            for(; i != r.length; ++i)if (e1.get(i)) {
                                const e1 = t[n++];
                                r[i] = e1 >>> 1 ^ -(1 & e1);
                            } else r[i] = 0;
                            return r;
                        }(n, e1) : function(e1, t) {
                            const r = new Int32Array(e1.size());
                            let n = 0, i = 0;
                            for(; i != r.length; ++i)r[i] = e1.get(i) ? t[n++] : 0;
                            return r;
                        }(n, e1), e1;
                    default:
                        throw new Error("The specified Logical level technique is not supported");
                }
            }
            static decodeNullableLongBuffer(e1, t, r, n) {
                switch(t.logicalLevelTechnique1){
                    case Kh.DELTA:
                        return t.logicalLevelTechnique2 === Kh.RLE && (e1 = dp(e1, t.runs, t.numRleValues)), function(e1, t) {
                            const r = new BigInt64Array(e1.size());
                            let n = 0;
                            e1.get(0) ? (r[0] = e1.get(0) ? t[0] >> 1n ^ -(1n & t[0]) : 0n, n = 1) : r[0] = 0n;
                            let i = 1;
                            for(; i != r.length; ++i)r[i] = e1.get(i) ? r[i - 1] + (t[n] >> 1n ^ -(1n & t[n++])) : r[i - 1];
                            return r;
                        }(n, e1);
                    case Kh.RLE:
                        return function(e1, t, r, n) {
                            const i = t;
                            return r ? function(e1, t, r) {
                                const n = new BigInt64Array(e1.size());
                                let i = 0;
                                for(let s = 0; s < r; s++){
                                    const o = Number(t[s]);
                                    let a = t[s + r];
                                    a = a >> 1n ^ -(1n & a);
                                    for(let t = i; t < i + o; t++)e1.get(t) ? n[t] = a : (n[t] = 0n, i++);
                                    i += o;
                                }
                                return n;
                            }(n, e1, i.runs) : function(e1, t, r) {
                                const n = new BigInt64Array(e1.size());
                                let i = 0;
                                for(let s = 0; s < r; s++){
                                    const o = Number(t[s]), a = t[s + r];
                                    for(let t = i; t < i + o; t++)e1.get(t) ? n[t] = a : (n[t] = 0n, i++);
                                    i += o;
                                }
                                return n;
                            }(n, e1, i.runs);
                        }(e1, t, r, n);
                    case Kh.NONE:
                        return e1 = r ? function(e1, t) {
                            const r = new BigInt64Array(e1.size());
                            let n = 0, i = 0;
                            for(; i != r.length; ++i)if (e1.get(i)) {
                                const e1 = t[n++];
                                r[i] = e1 >> 1n ^ -(1n & e1);
                            } else r[i] = 0n;
                            return r;
                        }(n, e1) : function(e1, t) {
                            const r = new BigInt64Array(e1.size());
                            let n = 0, i = 0;
                            for(; i != r.length; ++i)r[i] = e1.get(i) ? t[n++] : 0n;
                            return r;
                        }(n, e1), e1;
                    default:
                        throw new Error("The specified Logical level technique is not supported");
                }
            }
            static getVectorType(e1, t, r, n) {
                const i = e1.logicalLevelTechnique1;
                if (i === Kh.RLE) return 1 === e1.runs ? tp.CONST : tp.FLAT;
                const s = t instanceof Sp ? t.size() : t;
                if (i === Kh.DELTA && e1.logicalLevelTechnique2 === Kh.RLE) {
                    const t = e1.runs, i = 2;
                    if (e1.numRleValues !== s) return tp.FLAT;
                    if (1 === t) return tp.SEQUENCE;
                    if (2 === t) {
                        const t = n.get();
                        let s;
                        if (e1.physicalLevelTechnique === Wh.VARINT) s = op(r, n, 4);
                        else {
                            const e1 = n.get();
                            s = new Int32Array(r.buffer, r.byteOffset + e1, 4);
                        }
                        if (n.set(t), s[2] === i && s[3] === i) return tp.SEQUENCE;
                    }
                }
                return 1 === e1.numValues ? tp.CONST : tp.FLAT;
            }
        }
        class Tp extends $h {
            getValueFromBuffer(e1) {
                return this.dataBuffer[e1];
            }
        }
        class Ip extends jh {
            constructor(e1, t, r, n){
                super(e1, BigInt64Array.of(t), r, n);
            }
            getValueFromBuffer(e1) {
                return this.dataBuffer[0] + BigInt(e1) * this.delta;
            }
        }
        class Ep {
            _geometryOffsets;
            _partOffsets;
            _ringOffsets;
            constructor(e1, t, r){
                this._geometryOffsets = e1, this._partOffsets = t, this._ringOffsets = r;
            }
            get geometryOffsets() {
                return this._geometryOffsets;
            }
            get partOffsets() {
                return this._partOffsets;
            }
            get ringOffsets() {
                return this._ringOffsets;
            }
        }
        class Mp {
            tileExtent;
            _numBits;
            _coordinateShift;
            minBound;
            maxBound;
            constructor(e1, t){
                this._coordinateShift = e1 < 0 ? Math.abs(e1) : 0, this.tileExtent = t + this._coordinateShift, this._numBits = Math.ceil(Math.log2(this.tileExtent)), this.minBound = e1, this.maxBound = t;
            }
            validateCoordinates(e1) {
                if (e1.x < this.minBound || e1.y < this.minBound || e1.x > this.maxBound || e1.y > this.maxBound) throw new Error("The specified tile buffer size is currently not supported.");
            }
            numBits() {
                return this._numBits;
            }
            coordinateShift() {
                return this._coordinateShift;
            }
        }
        class kp extends Mp {
            encode(e1) {
                this.validateCoordinates(e1);
                const t = e1.x + this._coordinateShift, r = e1.y + this._coordinateShift;
                let n = 0;
                for(let e1 = 0; e1 < this._numBits; e1++)n |= (t & 1 << e1) << e1 | (r & 1 << e1) << e1 + 1;
                return n;
            }
            decode(e1) {
                return {
                    x: this.decodeMorton(e1) - this._coordinateShift,
                    y: this.decodeMorton(e1 >> 1) - this._coordinateShift
                };
            }
            decodeMorton(e1) {
                let t = 0;
                for(let r = 0; r < this._numBits; r++)t |= (e1 & 1 << 2 * r) >> r;
                return t;
            }
            static decode(e1, t, r) {
                return {
                    x: kp.decodeMorton(e1, t) - r,
                    y: kp.decodeMorton(e1 >> 1, t) - r
                };
            }
            static decodeMorton(e1, t) {
                let r = 0;
                for(let n = 0; n < t; n++)r |= (e1 & 1 << 2 * n) >> n;
                return r;
            }
        }
        !function(e1) {
            e1[e1.POINT = 0] = "POINT", e1[e1.LINESTRING = 1] = "LINESTRING", e1[e1.POLYGON = 2] = "POLYGON", e1[e1.MULTIPOINT = 3] = "MULTIPOINT", e1[e1.MULTILINESTRING = 4] = "MULTILINESTRING", e1[e1.MULTIPOLYGON = 5] = "MULTIPOLYGON";
        }(rp || (rp = {})), function(e1) {
            e1[e1.POINT = 0] = "POINT", e1[e1.LINESTRING = 1] = "LINESTRING", e1[e1.POLYGON = 2] = "POLYGON";
        }(np || (np = {})), function(e1) {
            e1[e1.MORTON = 0] = "MORTON", e1[e1.VEC_2 = 1] = "VEC_2", e1[e1.VEC_3 = 2] = "VEC_3";
        }(ip || (ip = {}));
        class Fp {
            createPoint(e1) {
                return [
                    [
                        e1
                    ]
                ];
            }
            createMultiPoint(e1) {
                return e1.map((e1)=>[
                        e1
                    ]);
            }
            createLineString(e1) {
                return [
                    e1
                ];
            }
            createMultiLineString(e1) {
                return e1;
            }
            createPolygon(e1, t) {
                return [
                    e1,
                    ...t
                ];
            }
            createMultiPolygon(e1) {
                return e1.flat();
            }
        }
        function Dp(e1) {
            const t = new Array(e1.numGeometries);
            let n = 1, i = 1, s = 1, o = 0;
            const a = new Fp;
            let l = 0, u = 0;
            const c = e1.mortonSettings, h = e1.topologyVector, p = h.geometryOffsets, f = h.partOffsets, d = h.ringOffsets, y = e1.vertexOffsets, m = e1.containsPolygonGeometry(), g = e1.vertexBuffer;
            for(let h = 0; h < e1.numGeometries; h++){
                const x = e1.geometryType(h);
                if (x === rp.POINT) {
                    if (y && 0 !== y.length) {
                        if (e1.vertexBufferType === ip.VEC_2) {
                            const e1 = 2 * y[u++], n = new r(g[e1], g[e1 + 1]);
                            t[o++] = a.createPoint(n);
                        } else {
                            const e1 = y[u++], n = kp.decode(g[e1], c.numBits, c.coordinateShift), i = new r(n.x, n.y);
                            t[o++] = a.createPoint(i);
                        }
                    } else {
                        const e1 = new r(g[l++], g[l++]);
                        t[o++] = a.createPoint(e1);
                    }
                    p && s++, f && n++, d && i++;
                } else if (x === rp.MULTIPOINT) {
                    const e1 = p[s] - p[s - 1];
                    s++;
                    const n = new Array(e1);
                    if (y && 0 !== y.length) {
                        for(let t = 0; t < e1; t++){
                            const e1 = 2 * y[u++];
                            n[t] = new r(g[e1], g[e1 + 1]);
                        }
                        t[o++] = a.createMultiPoint(n);
                    } else {
                        for(let t = 0; t < e1; t++){
                            const e1 = g[l++], i = g[l++];
                            n[t] = new r(e1, i);
                        }
                        t[o++] = a.createMultiPoint(n);
                    }
                } else if (x === rp.LINESTRING) {
                    let r, h = 0;
                    m ? (h = d[i] - d[i - 1], i++) : h = f[n] - f[n - 1], n++, y && 0 !== y.length ? (r = e1.vertexBufferType === ip.VEC_2 ? Cp(g, y, u, h, !1) : Lp(g, y, u, h, !1, c), u += h) : (r = Vp(g, l, h, !1), l += 2 * h), t[o++] = a.createLineString(r), p && s++;
                } else if (x === rp.POLYGON) {
                    const r = f[n] - f[n - 1];
                    n++;
                    const h = new Array(r - 1);
                    let m = d[i] - d[i - 1];
                    if (i++, y && 0 !== y.length) {
                        const r = e1.vertexBufferType === ip.VEC_2 ? Bp(g, y, u, m) : zp(g, y, u, m, 0, c);
                        u += m;
                        for(let t = 0; t < h.length; t++)m = d[i] - d[i - 1], i++, h[t] = e1.vertexBufferType === ip.VEC_2 ? Bp(g, y, u, m) : zp(g, y, u, m, 0, c), u += m;
                        t[o++] = a.createPolygon(r, h);
                    } else {
                        const e1 = Pp(g, l, m);
                        l += 2 * m;
                        for(let e1 = 0; e1 < h.length; e1++)m = d[i] - d[i - 1], i++, h[e1] = Pp(g, l, m), l += 2 * m;
                        t[o++] = a.createPolygon(e1, h);
                    }
                    p && s++;
                } else if (x === rp.MULTILINESTRING) {
                    const r = p[s] - p[s - 1];
                    s++;
                    const h = new Array(r);
                    if (y && 0 !== y.length) {
                        for(let t = 0; t < r; t++){
                            let r = 0;
                            m ? (r = d[i] - d[i - 1], i++) : r = f[n] - f[n - 1], n++;
                            const s = e1.vertexBufferType === ip.VEC_2 ? Cp(g, y, u, r, !1) : Lp(g, y, u, r, !1, c);
                            h[t] = s, u += r;
                        }
                        t[o++] = a.createMultiLineString(h);
                    } else {
                        for(let e1 = 0; e1 < r; e1++){
                            let t = 0;
                            m ? (t = d[i] - d[i - 1], i++) : t = f[n] - f[n - 1], n++, h[e1] = Vp(g, l, t, !1), l += 2 * t;
                        }
                        t[o++] = a.createMultiLineString(h);
                    }
                } else {
                    if (x !== rp.MULTIPOLYGON) throw new Error("The specified geometry type is currently not supported.");
                    {
                        const r = p[s] - p[s - 1];
                        s++;
                        const h = new Array(r);
                        let m = 0;
                        if (y && 0 !== y.length) {
                            for(let t = 0; t < r; t++){
                                const r = f[n] - f[n - 1];
                                n++;
                                const s = new Array(r - 1);
                                m = d[i] - d[i - 1], i++;
                                const o = e1.vertexBufferType === ip.VEC_2 ? Bp(g, y, u, m) : zp(g, y, u, m, 0, c);
                                u += m;
                                for(let t = 0; t < s.length; t++)m = d[i] - d[i - 1], i++, s[t] = e1.vertexBufferType === ip.VEC_2 ? Bp(g, y, u, m) : zp(g, y, u, m, 0, c), u += m;
                                h[t] = a.createPolygon(o, s);
                            }
                            t[o++] = a.createMultiPolygon(h);
                        } else {
                            for(let e1 = 0; e1 < r; e1++){
                                const t = f[n] - f[n - 1];
                                n++;
                                const r = new Array(t - 1);
                                m = d[i] - d[i - 1], i++;
                                const s = Pp(g, l, m);
                                l += 2 * m;
                                for(let e1 = 0; e1 < r.length; e1++){
                                    const t = d[i] - d[i - 1];
                                    i++, r[e1] = Pp(g, l, t), l += 2 * t;
                                }
                                h[e1] = a.createPolygon(s, r);
                            }
                            t[o++] = a.createMultiPolygon(h);
                        }
                    }
                }
            }
            return t;
        }
        function Pp(e1, t, r) {
            return Vp(e1, t, r, !0);
        }
        function Bp(e1, t, r, n) {
            return Cp(e1, t, r, n, !0);
        }
        function zp(e1, t, r, n, i, s) {
            return Lp(e1, t, r, n, !0, s);
        }
        function Vp(e1, t, n, i) {
            const s = new Array(i ? n + 1 : n);
            for(let i = 0; i < 2 * n; i += 2)s[i / 2] = new r(e1[t + i], e1[t + i + 1]);
            return i && (s[s.length - 1] = s[0]), s;
        }
        function Cp(e1, t, n, i, s) {
            const o = new Array(s ? i + 1 : i);
            for(let s = 0; s < 2 * i; s += 2){
                const i = 2 * t[n + s / 2];
                o[s / 2] = new r(e1[i], e1[i + 1]);
            }
            return s && (o[o.length - 1] = o[0]), o;
        }
        function Lp(e1, t, n, i, s, o) {
            const a = new Array(s ? i + 1 : i);
            for(let s = 0; s < i; s++){
                const i = kp.decode(e1[t[n + s]], o.numBits, o.coordinateShift);
                a[s] = new r(i.x, i.y);
            }
            return s && (a[a.length - 1] = a[0]), a;
        }
        class Op {
            _vertexBufferType;
            _topologyVector;
            _vertexOffsets;
            _vertexBuffer;
            _mortonSettings;
            constructor(e1, t, r, n, i){
                this._vertexBufferType = e1, this._topologyVector = t, this._vertexOffsets = r, this._vertexBuffer = n, this._mortonSettings = i;
            }
            get vertexBufferType() {
                return this._vertexBufferType;
            }
            get topologyVector() {
                return this._topologyVector;
            }
            get vertexOffsets() {
                return this._vertexOffsets;
            }
            get vertexBuffer() {
                return this._vertexBuffer;
            }
            *[Symbol.iterator]() {
                const e1 = Dp(this);
                let t = 0;
                for(; t < this.numGeometries;)yield {
                    coordinates: e1[t],
                    type: this.geometryType(t)
                }, t++;
            }
            getSimpleEncodedVertex(e1) {
                const t = this.vertexOffsets ? 2 * this.vertexOffsets[e1] : 2 * e1;
                return [
                    this.vertexBuffer[t],
                    this.vertexBuffer[t + 1]
                ];
            }
            getVertex(e1) {
                if (this.vertexOffsets && this.mortonSettings) {
                    const t = kp.decode(this.vertexBuffer[this.vertexOffsets[e1]], this.mortonSettings.numBits, this.mortonSettings.coordinateShift);
                    return [
                        t.x,
                        t.y
                    ];
                }
                const t = this.vertexOffsets ? 2 * this.vertexOffsets[e1] : 2 * e1;
                return [
                    this.vertexBuffer[t],
                    this.vertexBuffer[t + 1]
                ];
            }
            getGeometries() {
                return Dp(this);
            }
            get mortonSettings() {
                return this._mortonSettings;
            }
        }
        class Rp extends Op {
            _numGeometries;
            _geometryType;
            constructor(e1, t, r, n, i, s, o){
                super(r, n, i, s, o), this._numGeometries = e1, this._geometryType = t;
            }
            static createMortonEncoded(e1, t, r, n, i, s) {
                return new Rp(e1, t, ip.MORTON, r, n, i, s);
            }
            static create(e1, t, r, n, i) {
                return new Rp(e1, t, ip.VEC_2, r, n, i);
            }
            geometryType(e1) {
                return this._geometryType;
            }
            get numGeometries() {
                return this._numGeometries;
            }
            containsPolygonGeometry() {
                return this._geometryType === rp.POLYGON || this._geometryType === rp.MULTIPOLYGON;
            }
            containsSingleGeometryType() {
                return !0;
            }
        }
        class Np extends Op {
            _geometryTypes;
            constructor(e1, t, r, n, i, s){
                super(e1, r, n, i, s), this._geometryTypes = t;
            }
            static createMortonEncoded(e1, t, r, n, i) {
                return new Np(ip.MORTON, e1, t, r, n, i);
            }
            static create(e1, t, r, n) {
                return new Np(ip.VEC_2, e1, t, r, n);
            }
            geometryType(e1) {
                return this._geometryTypes[e1];
            }
            get numGeometries() {
                return this._geometryTypes.length;
            }
            containsPolygonGeometry() {
                for(let e1 = 0; e1 < this.numGeometries; e1++)if (this.geometryType(e1) === rp.POLYGON || this.geometryType(e1) === rp.MULTIPOLYGON) return !0;
                return !1;
            }
            containsSingleGeometryType() {
                return !1;
            }
        }
        class $p {
            _triangleOffsets;
            _indexBuffer;
            _vertexBuffer;
            _topologyVector;
            constructor(e1, t, r, n){
                this._triangleOffsets = e1, this._indexBuffer = t, this._vertexBuffer = r, this._topologyVector = n;
            }
            get triangleOffsets() {
                return this._triangleOffsets;
            }
            get indexBuffer() {
                return this._indexBuffer;
            }
            get vertexBuffer() {
                return this._vertexBuffer;
            }
            get topologyVector() {
                return this._topologyVector;
            }
            getGeometries() {
                if (!this._topologyVector) throw new Error("Cannot convert GpuVector to coordinates without topology information");
                const e1 = new Array(this.numGeometries), t = this._topologyVector, n = t.partOffsets, i = t.ringOffsets, s = t.geometryOffsets;
                let o = 0, a = 1, l = 1, u = 1;
                for(let t = 0; t < this.numGeometries; t++)switch(this.geometryType(t)){
                    case rp.POLYGON:
                        {
                            const c = n[a] - n[a - 1];
                            a++;
                            const h = [];
                            for(let e1 = 0; e1 < c; e1++){
                                const e1 = i[l] - i[l - 1];
                                l++;
                                const t = [];
                                for(let n = 0; n < e1; n++){
                                    const e1 = this._vertexBuffer[o++], n = this._vertexBuffer[o++];
                                    t.push(new r(e1, n));
                                }
                                t.length > 0 && t.push(t[0]), h.push(t);
                            }
                            e1[t] = h, s && u++;
                        }
                        break;
                    case rp.MULTIPOLYGON:
                        {
                            const c = s[u] - s[u - 1];
                            u++;
                            const h = [];
                            for(let e1 = 0; e1 < c; e1++){
                                const e1 = n[a] - n[a - 1];
                                a++;
                                for(let t = 0; t < e1; t++){
                                    const e1 = i[l] - i[l - 1];
                                    l++;
                                    const t = [];
                                    for(let n = 0; n < e1; n++){
                                        const e1 = this._vertexBuffer[o++], n = this._vertexBuffer[o++];
                                        t.push(new r(e1, n));
                                    }
                                    t.length > 0 && t.push(t[0]), h.push(t);
                                }
                            }
                            e1[t] = h;
                        }
                }
                return e1;
            }
            [Symbol.iterator]() {
                return null;
            }
        }
        class Up extends $p {
            _numGeometries;
            _geometryType;
            constructor(e1, t, r, n, i, s){
                super(r, n, i, s), this._numGeometries = e1, this._geometryType = t;
            }
            static create(e1, t, r, n, i, s) {
                return new Up(e1, t, r, n, i, s);
            }
            geometryType(e1) {
                return this._geometryType;
            }
            get numGeometries() {
                return this._numGeometries;
            }
            containsSingleGeometryType() {
                return !0;
            }
        }
        class qp extends $p {
            _geometryTypes;
            constructor(e1, t, r, n, i){
                super(t, r, n, i), this._geometryTypes = e1;
            }
            static create(e1, t, r, n, i) {
                return new qp(e1, t, r, n, i);
            }
            geometryType(e1) {
                return this._geometryTypes[e1];
            }
            get numGeometries() {
                return this._geometryTypes.length;
            }
            containsSingleGeometryType() {
                return !1;
            }
        }
        function jp(e1, t, r, n, i) {
            const s = _p.decode(e1, r);
            let o = null, a = null, l = null, u = null, c = null, h = null, p = null, f = null;
            if (Ap.getVectorType(s, n, e1, r) === tp.CONST) {
                const d = Ap.decodeConstIntStream(e1, r, s, !1);
                for(let n = 0; n < t - 1; n++){
                    const t = _p.decode(e1, r);
                    switch(t.physicalStreamType){
                        case Hh.LENGTH:
                            switch(t.logicalStreamType.lengthType){
                                case ep.GEOMETRIES:
                                    o = Ap.decodeLengthStreamToOffsetBuffer(e1, r, t);
                                    break;
                                case ep.PARTS:
                                    a = Ap.decodeLengthStreamToOffsetBuffer(e1, r, t);
                                    break;
                                case ep.RINGS:
                                    l = Ap.decodeLengthStreamToOffsetBuffer(e1, r, t);
                                    break;
                                case ep.TRIANGLES:
                                    p = Ap.decodeLengthStreamToOffsetBuffer(e1, r, t);
                            }
                            break;
                        case Hh.OFFSET:
                            switch(t.logicalStreamType.offsetType){
                                case Qh.VERTEX:
                                    u = Ap.decodeIntStream(e1, r, t, !1);
                                    break;
                                case Qh.INDEX:
                                    f = Ap.decodeIntStream(e1, r, t, !1);
                            }
                            break;
                        case Hh.DATA:
                            if (Jh.VERTEX === t.logicalStreamType.dictionaryType) c = Ap.decodeIntStream(e1, r, t, !0, i);
                            else {
                                const n = t;
                                h = {
                                    numBits: n.numBits(),
                                    coordinateShift: n.coordinateShift()
                                }, c = Ap.decodeIntStream(e1, r, t, !1, i);
                            }
                    }
                }
                if (null !== f) {
                    if (null != o || null != a) {
                        const e1 = new Ep(o, a, l);
                        return Up.create(n, d, p, f, c, e1);
                    }
                    return Up.create(n, d, p, f, c);
                }
                return null === h ? Rp.create(n, d, new Ep(o, a, l), u, c) : Rp.createMortonEncoded(n, d, new Ep(o, a, l), u, c, h);
            }
            const d = Ap.decodeIntStream(e1, r, s, !1);
            for(let n = 0; n < t - 1; n++){
                const t = _p.decode(e1, r);
                switch(t.physicalStreamType){
                    case Hh.LENGTH:
                        switch(t.logicalStreamType.lengthType){
                            case ep.GEOMETRIES:
                                o = Ap.decodeIntStream(e1, r, t, !1);
                                break;
                            case ep.PARTS:
                                a = Ap.decodeIntStream(e1, r, t, !1);
                                break;
                            case ep.RINGS:
                                l = Ap.decodeIntStream(e1, r, t, !1);
                                break;
                            case ep.TRIANGLES:
                                p = Ap.decodeLengthStreamToOffsetBuffer(e1, r, t);
                        }
                        break;
                    case Hh.OFFSET:
                        switch(t.logicalStreamType.offsetType){
                            case Qh.VERTEX:
                                u = Ap.decodeIntStream(e1, r, t, !1);
                                break;
                            case Qh.INDEX:
                                f = Ap.decodeIntStream(e1, r, t, !1);
                        }
                        break;
                    case Hh.DATA:
                        if (Jh.VERTEX === t.logicalStreamType.dictionaryType) c = Ap.decodeIntStream(e1, r, t, !0, i);
                        else {
                            const n = t;
                            h = {
                                numBits: n.numBits(),
                                coordinateShift: n.coordinateShift()
                            }, c = Ap.decodeIntStream(e1, r, t, !1, i);
                        }
                }
            }
            return null !== f && null === a ? qp.create(d, p, f, c) : (null !== o ? (o = Gp(d, o, 2), null !== a && null !== l ? (a = Xp(d, o, a, !1), l = function(e1, t, r, n) {
                const i = new Int32Array(r[r.length - 1] + 1);
                let s = 0;
                i[0] = s;
                let o = 1, a = 1, l = 0;
                for(let u = 0; u < e1.length; u++){
                    const c = e1[u], h = t[u + 1] - t[u];
                    if (0 !== c && 3 !== c) for(let e1 = 0; e1 < h; e1++){
                        const e1 = r[o] - r[o - 1];
                        o++;
                        for(let t = 0; t < e1; t++)s = i[a++] = s + n[l++];
                    }
                    else for(let e1 = 0; e1 < h; e1++)i[a++] = ++s, o++;
                }
                return i;
            }(d, o, a, l)) : null !== a && (a = function(e1, t, r) {
                const n = new Int32Array(t[t.length - 1] + 1);
                let i = 0;
                n[0] = i;
                let s = 1, o = 0;
                for(let a = 0; a < e1.length; a++){
                    const l = e1[a], u = t[a + 1] - t[a];
                    if (4 === l || 1 === l) for(let e1 = 0; e1 < u; e1++)i = n[s++] = i + r[o++];
                    else for(let e1 = 0; e1 < u; e1++)n[s++] = ++i;
                }
                return n;
            }(d, o, a))) : null !== a && null !== l ? (a = Gp(d, a, 1), l = Xp(d, a, l, !0)) : null !== a && (a = Gp(d, a, 0)), null !== f ? qp.create(d, p, f, c, new Ep(o, a, l)) : null === h ? Np.create(d, new Ep(o, a, l), u, c) : Np.createMortonEncoded(d, new Ep(o, a, l), u, c, h));
        }
        function Gp(e1, t, r) {
            const n = new Int32Array(e1.length + 1);
            let i = 0;
            n[0] = i;
            let s = 0;
            for(let o = 0; o < e1.length; o++)i = n[o + 1] = i + (e1[o] > r ? t[s++] : 1);
            return n;
        }
        function Xp(e1, t, r, n) {
            const i = new Int32Array(t[t.length - 1] + 1);
            let s = 0;
            i[0] = s;
            let o = 1, a = 0;
            for(let l = 0; l < e1.length; l++){
                const u = e1[l], c = t[l + 1] - t[l];
                if (5 === u || 2 === u || n && (4 === u || 1 === u)) for(let e1 = 0; e1 < c; e1++)s = i[o++] = s + r[a++];
                else for(let e1 = 0; e1 < c; e1++)i[o++] = ++s;
            }
            return i;
        }
        class Yp extends Nh {
            dataVector;
            constructor(e1, t, r){
                super(e1, t.getBuffer(), r), this.dataVector = t;
            }
            getValueFromBuffer(e1) {
                return this.dataVector.get(e1);
            }
        }
        class Zp extends $h {
            getValueFromBuffer(e1) {
                return this.dataBuffer[e1];
            }
        }
        class Hp extends Nh {
            constructor(e1, t, r){
                super(e1, BigInt64Array.of(t), r);
            }
            getValueFromBuffer(e1) {
                return this.dataBuffer[0];
            }
        }
        function Kp(e1, t, r) {
            for(let n = 0; n < e1; n++){
                const e1 = _p.decode(t, r);
                r.add(e1.byteLength);
            }
        }
        function Wp(e1, t, r) {
            return Jp(e1, Math.ceil(t / 8), r);
        }
        function Jp(e1, t, r) {
            const n = new Uint8Array(t);
            let i = 0;
            for(; i < t;){
                const t = e1[r.increment()];
                if (t <= 127) {
                    const s = t + 3, o = e1[r.increment()], a = i + s;
                    n.fill(o, i, a), i = a;
                } else {
                    const s = 256 - t;
                    for(let t = 0; t < s; t++)n[i++] = e1[r.increment()];
                }
            }
            return n;
        }
        const Qp = new TextDecoder;
        function ef(e1, t, r) {
            return r - t >= 12 ? Qp.decode(e1.subarray(t, r)) : function(e1, t, r) {
                let n = "", i = t;
                for(; i < r;){
                    const t = e1[i];
                    let s, o, a, l = null, u = t > 239 ? 4 : t > 223 ? 3 : t > 191 ? 2 : 1;
                    if (i + u > r) break;
                    1 === u ? t < 128 && (l = t) : 2 === u ? (s = e1[i + 1], 128 == (192 & s) && (l = (31 & t) << 6 | 63 & s, l <= 127 && (l = null))) : 3 === u ? (s = e1[i + 1], o = e1[i + 2], 128 == (192 & s) && 128 == (192 & o) && (l = (15 & t) << 12 | (63 & s) << 6 | 63 & o, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === u && (s = e1[i + 1], o = e1[i + 2], a = e1[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & t) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, u = 1) : l > 65535 && (l -= 65536, n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n += String.fromCharCode(l), i += u;
                }
                return n;
            }(e1, t, r);
        }
        class tf extends Nh {
            offsetBuffer;
            constructor(e1, t, r, n){
                super(e1, r, n), this.offsetBuffer = t;
            }
        }
        class rf extends tf {
            textEncoder;
            constructor(e1, t, r, n){
                super(e1, t, r, n ?? t.length - 1), this.textEncoder = new TextEncoder;
            }
            getValueFromBuffer(e1) {
                return ef(this.dataBuffer, this.offsetBuffer[e1], this.offsetBuffer[e1 + 1]);
            }
        }
        class nf extends tf {
            indexBuffer;
            textEncoder;
            constructor(e1, t, r, n, i){
                super(e1, r, n, i ?? t.length), this.indexBuffer = t, this.indexBuffer = t, this.textEncoder = new TextEncoder;
            }
            getValueFromBuffer(e1) {
                const t = this.indexBuffer[e1];
                return ef(this.dataBuffer, this.offsetBuffer[t], this.offsetBuffer[t + 1]);
            }
        }
        class sf extends tf {
            indexBuffer;
            symbolOffsetBuffer;
            symbolTableBuffer;
            textEncoder;
            symbolLengthBuffer;
            lengthBuffer;
            decodedDictionary;
            constructor(e1, t, r, n, i, s, o){
                super(e1, r, n, o), this.indexBuffer = t, this.symbolOffsetBuffer = i, this.symbolTableBuffer = s, this.textEncoder = new TextEncoder;
            }
            getValueFromBuffer(e1) {
                null == this.decodedDictionary && (null == this.symbolLengthBuffer && (this.symbolLengthBuffer = this.offsetToLengthBuffer(this.symbolOffsetBuffer), this.lengthBuffer = this.offsetToLengthBuffer(this.offsetBuffer)), this.decodedDictionary = function(e1, t, r) {
                    const n = [], i = new Array(t.length).fill(0);
                    for(let e1 = 1; e1 < t.length; e1++)i[e1] = i[e1 - 1] + t[e1 - 1];
                    for(let s = 0; s < r.length; s++)if (255 === r[s]) n.push(r[++s]);
                    else {
                        const o = t[r[s]], a = i[r[s]];
                        for(let t = 0; t < o; t++)n.push(e1[a + t]);
                    }
                    return new Uint8Array(n);
                }(this.symbolTableBuffer, this.symbolLengthBuffer, this.dataBuffer));
                const t = this.indexBuffer[e1];
                return ef(this.decodedDictionary, this.offsetBuffer[t], this.offsetBuffer[t + 1]);
            }
            offsetToLengthBuffer(e1) {
                const t = new Uint32Array(e1.length - 1);
                let r = e1[0];
                for(let n = 1; n < e1.length; n++){
                    const i = e1[n];
                    t[n - 1] = i - r, r = i;
                }
                return t;
            }
        }
        class of {
            static ROOT_COLUMN_NAME = "default";
            static NESTED_COLUMN_SEPARATOR = ":";
            constructor(){}
            static decode(e1, t, r, n, i) {
                let s = null, o = null, a = null, l = null, u = null, c = null, h = null, p = null;
                for(let e1 = 0; e1 < n; e1++){
                    const e1 = _p.decode(t, r);
                    if (0 !== e1.byteLength) switch(e1.physicalStreamType){
                        case Hh.PRESENT:
                            {
                                const n = Wp(t, e1.numValues, r);
                                c = new Sp(n, e1.numValues);
                                break;
                            }
                        case Hh.OFFSET:
                            o = null != i || null != c ? Ap.decodeNullableIntStream(t, r, e1, !1, i ?? c) : Ap.decodeIntStream(t, r, e1, !1);
                            break;
                        case Hh.LENGTH:
                            {
                                const n = Ap.decodeLengthStreamToOffsetBuffer(t, r, e1);
                                ep.DICTIONARY === e1.logicalStreamType.lengthType ? s = n : ep.SYMBOL === e1.logicalStreamType.lengthType ? l = n : h = n;
                                break;
                            }
                        case Hh.DATA:
                            {
                                const n = t.subarray(r.get(), r.get() + e1.byteLength);
                                r.add(e1.byteLength);
                                const i = e1.logicalStreamType.dictionaryType;
                                Jh.FSST === i ? u = n : Jh.SINGLE === i || Jh.SHARED === i ? a = n : Jh.NONE === i && (p = n);
                                break;
                            }
                    }
                }
                return this.decodeFsstDictionaryVector(e1, u, o, s, a, l, i ?? c) ?? this.decodeDictionaryVector(e1, a, o, s, i ?? c) ?? this.decodePlainStringVector(e1, h, p, o, i ?? c);
            }
            static decodeFsstDictionaryVector(e1, t, r, n, i, s, o) {
                return t ? new sf(e1, r, n, i, s, t, o) : null;
            }
            static decodeDictionaryVector(e1, t, r, n, i) {
                return t ? i ? new nf(e1, r, n, t, i) : new nf(e1, r, n, t) : null;
            }
            static decodePlainStringVector(e1, t, r, n, i) {
                if (!t || !r) return null;
                if (n) return i ? new nf(e1, n, t, r, i) : new nf(e1, n, t, r);
                if (i && i.size() !== t.length - 1) {
                    const n = new Int32Array(i.size());
                    let s = 0;
                    for(let e1 = 0; e1 < i.size(); e1++)n[e1] = i.get(e1) ? s++ : 0;
                    return new nf(e1, n, t, r, i);
                }
                return i ? new rf(e1, t, r, i) : new rf(e1, t, r);
            }
            static decodeSharedDictionary(e1, t, r, n, i) {
                let s = null, o = null, a = null, l = null, u = !1;
                for(; !u;){
                    const r = _p.decode(e1, t);
                    switch(r.physicalStreamType){
                        case Hh.LENGTH:
                            ep.DICTIONARY === r.logicalStreamType.lengthType ? s = Ap.decodeLengthStreamToOffsetBuffer(e1, t, r) : a = Ap.decodeLengthStreamToOffsetBuffer(e1, t, r);
                            break;
                        case Hh.DATA:
                            Jh.SINGLE === r.logicalStreamType.dictionaryType || Jh.SHARED === r.logicalStreamType.dictionaryType ? (o = e1.subarray(t.get(), t.get() + r.byteLength), u = !0) : l = e1.subarray(t.get(), t.get() + r.byteLength), t.add(r.byteLength);
                    }
                }
                const c = r.complexType.children, h = [];
                let p = 0;
                for (const u of c){
                    const c = op(e1, t, 1)[0];
                    if (0 == c) continue;
                    const f = `${r.name}${u.name === of.ROOT_COLUMN_NAME ? "" : of.NESTED_COLUMN_SEPARATOR + u.name}`;
                    if (i && !i.has(f)) {
                        Kp(c, e1, t);
                        continue;
                    }
                    if (2 !== c || "scalarField" !== u.type || 9 !== u.scalarField.physicalType) throw new Error("Currently only optional string fields are implemented for a struct.");
                    const d = _p.decode(e1, t), y = Wp(e1, d.numValues, t), m = _p.decode(e1, t), g = (m instanceof wp ? m.numRleValues : m.numValues) !== n ? Ap.decodeNullableIntStream(e1, t, m, !1, new Sp(y, d.numValues)) : Ap.decodeIntStream(e1, t, m, !1);
                    h[p++] = l ? new sf(f, g, s, o, a, l, new Sp(y, d.numValues)) : new nf(f, g, s, o, new Sp(y, d.numValues));
                }
                return h;
            }
        }
        function af(e1, t, r, n, i, s) {
            return "scalarType" === r.type ? function(e1, t, r, n, i, s) {
                let o = null, a = 0;
                if (0 === e1) return null;
                if (s.nullable) {
                    const e1 = _p.decode(t, r);
                    a = e1.numValues;
                    const n = r.get(), i = Wp(t, a, r);
                    r.set(n + e1.byteLength), o = new Sp(i, e1.numValues);
                }
                const l = o ?? n;
                switch(i.physicalType){
                    case 4:
                    case 3:
                        return function(e1, t, r, n, i) {
                            const s = _p.decode(e1, t), o = Ap.getVectorType(s, i, e1, t), a = 3 === n.physicalType;
                            if (o === tp.FLAT) {
                                const n = lf(i) ? Ap.decodeNullableIntStream(e1, t, s, a, i) : Ap.decodeIntStream(e1, t, s, a);
                                return new Uh(r.name, n, i);
                            }
                            if (o === tp.SEQUENCE) {
                                const n = Ap.decodeSequenceIntStream(e1, t, s);
                                return new Gh(r.name, n[0], n[1], s.numRleValues);
                            }
                            {
                                const n = Ap.decodeConstIntStream(e1, t, s, a);
                                return new Xh(r.name, n, i);
                            }
                        }(t, r, s, i, l);
                    case 9:
                        return of.decode(s.name, t, r, s.nullable ? e1 - 1 : e1, o);
                    case 0:
                        return function(e1, t, r, n, i) {
                            const s = _p.decode(e1, t), o = s.numValues, a = t.get(), l = lf(i) ? function(e1, t, r, n) {
                                const i = Jp(e1, Math.ceil(t / 8), r), s = new Sp(i, t), o = n.size(), a = new Sp(new Uint8Array(o), o);
                                let l = 0;
                                for(let e1 = 0; e1 < n.size(); e1++){
                                    const t = !!n.get(e1) && s.get(l++);
                                    a.set(e1, t);
                                }
                                return a.getBuffer();
                            }(e1, o, t, i) : Wp(e1, o, t);
                            t.set(a + s.byteLength);
                            const u = new Sp(l, o);
                            return new Yp(r.name, u, i);
                        }(t, r, s, 0, l);
                    case 6:
                    case 5:
                        return function(e1, t, r, n, i) {
                            const s = _p.decode(e1, t), o = Ap.getVectorType(s, n, e1, t), a = 5 === i.physicalType;
                            if (o === tp.FLAT) {
                                const i = lf(n) ? Ap.decodeNullableLongStream(e1, t, s, a, n) : Ap.decodeLongStream(e1, t, s, a);
                                return new Tp(r.name, i, n);
                            }
                            if (o === tp.SEQUENCE) {
                                const n = Ap.decodeSequenceLongStream(e1, t, s);
                                return new Ip(r.name, n[0], n[1], s.numRleValues);
                            }
                            {
                                const i = Ap.decodeConstLongStream(e1, t, s, a);
                                return new Hp(r.name, i, n);
                            }
                        }(t, r, s, l, i);
                    case 7:
                        return function(e1, t, r, n) {
                            const i = _p.decode(e1, t), s = lf(n) ? function(e1, t, r, n) {
                                const i = t.get(), s = i + n * Float32Array.BYTES_PER_ELEMENT, o = new Uint8Array(e1.subarray(i, s)).buffer, a = new Float32Array(o);
                                t.set(s);
                                const l = r.size(), u = new Float32Array(l);
                                let c = 0;
                                for(let e1 = 0; e1 < l; e1++)u[e1] = r.get(e1) ? a[c++] : 0;
                                return u;
                            }(e1, t, n, i.numValues) : function(e1, t, r) {
                                const n = t.get(), i = n + r * Float32Array.BYTES_PER_ELEMENT, s = new Uint8Array(e1.subarray(n, i)).buffer, o = new Float32Array(s);
                                return t.set(i), o;
                            }(e1, t, i.numValues);
                            return new Zp(r.name, s, n);
                        }(t, r, s, l);
                    case 8:
                        return function(e1, t, r, n) {
                            const i = _p.decode(e1, t), s = lf(n) ? function(e1, t, r, n) {
                                const i = t.get(), s = i + n * Float64Array.BYTES_PER_ELEMENT, o = new Uint8Array(e1.subarray(i, s)).buffer, a = new Float64Array(o);
                                t.set(s);
                                const l = r.size(), u = new Float64Array(l);
                                let c = 0;
                                for(let e1 = 0; e1 < l; e1++)u[e1] = r.get(e1) ? a[c++] : 0;
                                return u;
                            }(e1, t, n, i.numValues) : function(e1, t, r) {
                                const n = t.get(), i = n + r * Float64Array.BYTES_PER_ELEMENT, s = new Uint8Array(e1.subarray(n, i)).buffer, o = new Float64Array(s);
                                return t.set(i), o;
                            }(e1, t, i.numValues);
                            return new qh(r.name, s, n);
                        }(t, r, s, l);
                    default:
                        throw new Error(`The specified data type for the field is currently not supported: ${i}`);
                }
            }(n, e1, t, i, r.scalarType, r) : 1 != n ? null : of.decodeSharedDictionary(e1, t, r, i, s);
        }
        function lf(e1) {
            return e1 instanceof Sp;
        }
        class uf {
            static decodeColumnType(e1) {
                switch(e1){
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        {
                            const t = {};
                            t.nullable = !!(1 & e1), t.columnScope = 0;
                            const r = {};
                            return r.physicalType = e1 > 1 ? 6 : 4, r.type = "physicalType", t.scalarType = r, t.type = "scalarType", t;
                        }
                    case 4:
                        {
                            const e1 = {
                                nullable: !1,
                                columnScope: 0
                            }, t = {
                                type: "physicalType",
                                physicalType: 0
                            };
                            return e1.type = "complexType", e1.complexType = t, e1;
                        }
                    case 30:
                        {
                            const e1 = {
                                nullable: !1,
                                columnScope: 0
                            }, t = {
                                type: "physicalType",
                                physicalType: 1
                            };
                            return e1.type = "complexType", e1.complexType = t, e1;
                        }
                    default:
                        return this.mapScalarType(e1);
                }
            }
            static columnTypeHasName(e1) {
                return e1 >= 10;
            }
            static columnTypeHasChildren(e1) {
                return 30 === e1;
            }
            static hasStreamCount(e1) {
                if ("id" === e1.name) return !1;
                if ("scalarType" === e1.type) {
                    const t = e1.scalarType;
                    if ("physicalType" === t.type) switch(t.physicalType){
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        default:
                            return !1;
                        case 9:
                            return !0;
                    }
                    else if ("logicalType" === t.type) return !1;
                } else if ("complexType" === e1.type) {
                    const t = e1.complexType;
                    if ("physicalType" === t.type) switch(t.physicalType){
                        case 0:
                        case 1:
                            return !0;
                        default:
                            return !1;
                    }
                }
                return console.warn("Unexpected column type in hasStreamCount", e1), !1;
            }
            static mapScalarType(e1) {
                let t = null;
                switch(e1){
                    case 10:
                    case 11:
                        t = 0;
                        break;
                    case 12:
                    case 13:
                        t = 1;
                        break;
                    case 14:
                    case 15:
                        t = 2;
                        break;
                    case 16:
                    case 17:
                        t = 3;
                        break;
                    case 18:
                    case 19:
                        t = 4;
                        break;
                    case 20:
                    case 21:
                        t = 5;
                        break;
                    case 22:
                    case 23:
                        t = 6;
                        break;
                    case 24:
                    case 25:
                        t = 7;
                        break;
                    case 26:
                    case 27:
                        t = 8;
                        break;
                    case 28:
                    case 29:
                        t = 9;
                        break;
                    default:
                        return null;
                }
                const r = {};
                r.nullable = !!(1 & e1), r.columnScope = 0;
                const n = {
                    type: "physicalType"
                };
                return n.physicalType = t, r.type = "scalarType", r.scalarType = n, r;
            }
        }
        const cf = new TextDecoder;
        function hf(e1, t) {
            const r = op(e1, t, 1)[0];
            if (0 === r) return "";
            const n = t.get(), i = e1.subarray(n, n + r);
            return t.add(r), cf.decode(i);
        }
        function pf(e1, t) {
            const r = op(e1, t, 1)[0] >>> 0, n = !!(4 & r), i = !!(2 & r), s = op(e1, t, 1)[0] >>> 0, o = {};
            if (1 & r && (o.nullable = !0), i) {
                const i = {};
                if (n ? (i.type = "logicalType", i.logicalType = s) : (i.type = "physicalType", i.physicalType = s), 8 & r) {
                    const r = op(e1, t, 1)[0] >>> 0;
                    i.children = new Array(r);
                    for(let n = 0; n < r; n++)i.children[n] = pf(e1, t);
                }
                o.type = "complexField", o.complexField = i;
            } else {
                const e1 = {};
                n ? (e1.type = "logicalType", e1.logicalType = s) : (e1.type = "physicalType", e1.physicalType = s), o.type = "scalarField", o.scalarField = e1;
            }
            return o;
        }
        function ff(e1, t) {
            const r = op(e1, t, 1)[0] >>> 0, n = uf.decodeColumnType(r);
            if (!n) throw new Error(`Unsupported column type code: ${r}`);
            if (uf.columnTypeHasName(r) ? n.name = hf(e1, t) : r >= 0 && r <= 3 ? n.name = "id" : 4 === r && (n.name = "geometry"), uf.columnTypeHasChildren(r)) {
                const r = op(e1, t, 1)[0] >>> 0, i = n.complexType;
                i.children = new Array(r);
                for(let n = 0; n < r; n++)i.children[n] = pf(e1, t);
            }
            return n;
        }
        function df(e1, t) {
            const r = {
                featureTables: []
            }, n = {};
            n.name = hf(e1, t);
            const i = op(e1, t, 1)[0] >>> 0, s = op(e1, t, 1)[0] >>> 0;
            n.columns = new Array(s);
            for(let r = 0; r < s; r++)n.columns[r] = ff(e1, t);
            return r.featureTables.push(n), [
                r,
                i
            ];
        }
        function yf(e1, t, r, n, i, s, o = !1) {
            const a = t.scalarType.physicalType, l = Ap.getVectorType(i, s, e1, r);
            if (4 === a) switch(l){
                case tp.FLAT:
                    {
                        const t = Ap.decodeIntStream(e1, r, i, !1);
                        return new Uh(n, t, s);
                    }
                case tp.SEQUENCE:
                    {
                        const t = Ap.decodeSequenceIntStream(e1, r, i);
                        return new Gh(n, t[0], t[1], i.numRleValues);
                    }
                case tp.CONST:
                    {
                        const t = Ap.decodeConstIntStream(e1, r, i, !1);
                        return new Xh(n, t, s);
                    }
            }
            else switch(l){
                case tp.FLAT:
                    {
                        if (o) {
                            const t = Ap.decodeLongFloat64Stream(e1, r, i, !1);
                            return new qh(n, t, s);
                        }
                        const t = Ap.decodeLongStream(e1, r, i, !1);
                        return new Tp(n, t, s);
                    }
                case tp.SEQUENCE:
                    {
                        const t = Ap.decodeSequenceLongStream(e1, r, i);
                        return new Ip(n, t[0], t[1], i.numRleValues);
                    }
                case tp.CONST:
                    {
                        const t = Ap.decodeConstLongStream(e1, r, i, !1);
                        return new Hp(n, t, s);
                    }
            }
            throw new Error("Vector type not supported for id column.");
        }
        class mf {
            constructor(e1, t){
                var r;
                switch(this._featureData = e1, this.properties = this._featureData.properties || {}, null === (r = this._featureData.geometry) || void 0 === r ? void 0 : r.type){
                    case rp.POINT:
                    case rp.MULTIPOINT:
                        this.type = 1;
                        break;
                    case rp.LINESTRING:
                    case rp.MULTILINESTRING:
                        this.type = 2;
                        break;
                    case rp.POLYGON:
                    case rp.MULTIPOLYGON:
                        this.type = 3;
                        break;
                    default:
                        this.type = 0;
                }
                this.extent = t, this.id = Number(this._featureData.id);
            }
            projectPoint(e1, t, r, n) {
                return [
                    360 * (e1.x + t) / n - 180,
                    360 / Math.PI * Math.atan(Math.exp((1 - 2 * (e1.y + r) / n) * Math.PI)) - 90
                ];
            }
            projectLine(e1, t, r, n) {
                return e1.map((e1)=>this.projectPoint(e1, t, r, n));
            }
            toGeoJSON(e1, t, r) {
                const n = this.extent * Math.pow(2, r), i = this.extent * e1, s = this.extent * t, o = this.loadGeometry();
                let a;
                switch(this.type){
                    case 1:
                        {
                            const e1 = [];
                            for (const t of o)e1.push(t[0]);
                            const t = this.projectLine(e1, i, s, n);
                            a = 1 === e1.length ? {
                                type: "Point",
                                coordinates: t[0]
                            } : {
                                type: "MultiPoint",
                                coordinates: t
                            };
                            break;
                        }
                    case 2:
                        {
                            const e1 = o.map((e1)=>this.projectLine(e1, i, s, n));
                            a = 1 === e1.length ? {
                                type: "LineString",
                                coordinates: e1[0]
                            } : {
                                type: "MultiLineString",
                                coordinates: e1
                            };
                            break;
                        }
                    case 3:
                        {
                            const e1 = Qr(o), t = [];
                            for (const r of e1)t.push(r.map((e1)=>this.projectLine(e1, i, s, n)));
                            a = 1 === t.length ? {
                                type: "Polygon",
                                coordinates: t[0]
                            } : {
                                type: "MultiPolygon",
                                coordinates: t
                            };
                            break;
                        }
                    default:
                        throw new Error(`unknown feature type: ${this.type}`);
                }
                const l = {
                    type: "Feature",
                    geometry: a,
                    properties: this.properties
                };
                return null != this.id && (l.id = this.id), l;
            }
            loadGeometry() {
                const e1 = [];
                for (const t of this._featureData.geometry.coordinates){
                    const n = [];
                    for (const e1 of t)n.push(new r(e1.x, e1.y));
                    e1.push(n);
                }
                return e1;
            }
            bbox() {
                return [
                    0,
                    0,
                    0,
                    0
                ];
            }
        }
        class gf {
            constructor(e1){
                this.features = [], this.featureTable = e1, this.name = e1.name, this.extent = e1.extent, this.version = 2, this.features = e1.getFeatures(), this.length = this.features.length;
            }
            feature(e1) {
                return new mf(this.features[e1], this.extent);
            }
        }
        class xf {
            constructor(e1){
                this.layers = {};
                const t = function(e1, t, r = !0) {
                    const n = new Zh(0), i = [];
                    for(; n.get() < e1.length;){
                        const s = op(e1, n, 1)[0] >>> 0, o = n.get() + s;
                        if (o > e1.length) throw new Error(`Block overruns tile: ${o} > ${e1.length}`);
                        if (1 != op(e1, n, 1)[0] >>> 0) {
                            n.set(o);
                            continue;
                        }
                        const a = df(e1, n), l = a[1], u = a[0].featureTables[0];
                        let c = null, h = null;
                        const p = [];
                        let f = 0;
                        for (const i of u.columns){
                            const s = i.name;
                            if ("id" === s) {
                                let t = null;
                                if (i.nullable) {
                                    const r = _p.decode(e1, n), i = n.get(), s = Wp(e1, r.numValues, n);
                                    n.set(i + r.byteLength), t = new Sp(s, r.numValues);
                                }
                                const o = _p.decode(e1, n);
                                f = o.getDecompressedCount(), c = yf(e1, i, n, s, o, t ?? f, r);
                            } else if ("geometry" === s) {
                                const r = op(e1, n, 1)[0];
                                if (0 === f) {
                                    const t = n.get();
                                    f = _p.decode(e1, n).getDecompressedCount(), n.set(t);
                                }
                                h = jp(e1, r, n, f, t);
                            } else {
                                const t = uf.hasStreamCount(i) ? op(e1, n, 1)[0] : 1;
                                if (0 === t && "scalarType" === i.type) continue;
                                const r = af(e1, n, i, t, f, void 0);
                                r && (Array.isArray(r) ? p.push(...r) : p.push(r));
                            }
                        }
                        const d = new Yh(u.name, h, c, p, l);
                        i.push(d), n.set(o);
                    }
                    return i;
                }(new Uint8Array(e1));
                this.layers = t.reduce((e1, t)=>Object.assign(Object.assign({}, e1), {
                        [t.name]: new gf(t)
                    }), {});
            }
        }
        class vf {
            constructor(){
                this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0;
            }
            extend(e1) {
                return this.minX = Math.min(this.minX, e1.x), this.minY = Math.min(this.minY, e1.y), this.maxX = Math.max(this.maxX, e1.x), this.maxY = Math.max(this.maxY, e1.y), this;
            }
            expandBy(e1) {
                return this.minX -= e1, this.minY -= e1, this.maxX += e1, this.maxY += e1, (this.minX > this.maxX || this.minY > this.maxY) && (this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0), this;
            }
            shrinkBy(e1) {
                return this.expandBy(-e1);
            }
            map(e1) {
                const t = new vf;
                return t.extend(e1(new r(this.minX, this.minY))), t.extend(e1(new r(this.maxX, this.minY))), t.extend(e1(new r(this.minX, this.maxY))), t.extend(e1(new r(this.maxX, this.maxY))), t;
            }
            static fromPoints(e1) {
                const t = new vf;
                for (const r of e1)t.extend(r);
                return t;
            }
            contains(e1) {
                return e1.x >= this.minX && e1.x <= this.maxX && e1.y >= this.minY && e1.y <= this.maxY;
            }
            empty() {
                return this.minX > this.maxX;
            }
            width() {
                return this.maxX - this.minX;
            }
            height() {
                return this.maxY - this.minY;
            }
            covers(e1) {
                return !this.empty() && !e1.empty() && e1.minX >= this.minX && e1.maxX <= this.maxX && e1.minY >= this.minY && e1.maxY <= this.maxY;
            }
            intersects(e1) {
                return !this.empty() && !e1.empty() && e1.minX <= this.maxX && e1.maxX >= this.minX && e1.minY <= this.maxY && e1.maxY >= this.minY;
            }
        }
        const bf = "_geojsonTileLayer";
        class wf {
            constructor(e1, t){
                this.tileID = e1, this.x = e1.canonical.x, this.y = e1.canonical.y, this.z = e1.canonical.z, this.grid = new os(k, 16, 0), this.grid3D = new os(k, 16, 0), this.featureIndexArray = new Lo, this.promoteId = t;
            }
            insert(e1, t, r, n, i, s) {
                const o = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i);
                const a = s ? this.grid3D : this.grid;
                for(let e1 = 0; e1 < t.length; e1++){
                    const r = t[e1], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let e1 = 0; e1 < r.length; e1++){
                        const t = r[e1];
                        n[0] = Math.min(n[0], t.x), n[1] = Math.min(n[1], t.y), n[2] = Math.max(n[2], t.x), n[3] = Math.max(n[3], t.y);
                    }
                    n[0] < k && n[1] < k && n[2] >= 0 && n[3] >= 0 && a.insert(o, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                return this.vtLayers || (this.vtLayers = "mlt" !== this.encoding ? new ku(new wc(this.rawTileData)).layers : new xf(this.rawTileData).layers, this.sourceLayerCoder = new Oh(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                    bf
                ])), this.vtLayers;
            }
            query(e1, t, n, i) {
                this.loadVTLayers();
                const s = e1.params, o = k / e1.tileSize / e1.scale, a = pi(s.filter, s.globalState), l = e1.queryGeometry, u = e1.queryPadding * o, c = vf.fromPoints(l), h = this.grid.query(c.minX - u, c.minY - u, c.maxX + u, c.maxY + u), p = vf.fromPoints(e1.cameraQueryGeometry).expandBy(u), f = this.grid3D.query(p.minX, p.minY, p.maxX, p.maxY, (t, n, i, s)=>(function(e1, t, n, i, s) {
                        for (const r of e1)if (t <= r.x && n <= r.y && i >= r.x && s >= r.y) return !0;
                        const o = [
                            new r(t, n),
                            new r(t, s),
                            new r(i, s),
                            new r(i, n)
                        ];
                        if (e1.length > 2) {
                            for (const t of o)if (Ka(e1, t)) return !0;
                        }
                        for(let t = 0; t < e1.length - 1; t++)if (Wa(e1[t], e1[t + 1], o)) return !0;
                        return !1;
                    })(e1.cameraQueryGeometry, t - u, n - u, i + u, s + u));
                for (const e1 of f)h.push(e1);
                h.sort(Sf);
                const d = {};
                let y;
                for(let r = 0; r < h.length; r++){
                    const u = h[r];
                    if (u === y) continue;
                    y = u;
                    const c = this.featureIndexArray.get(u);
                    let p = null;
                    this.loadMatchingFeature(d, c.bucketIndex, c.sourceLayerIndex, c.featureIndex, a, s.layers, s.availableImages, t, n, i, (t, r, n)=>(p || (p = Ca(t)), r.queryIntersectsFeature({
                            queryGeometry: l,
                            feature: t,
                            featureState: n,
                            geometry: p,
                            zoom: this.z,
                            transform: e1.transform,
                            pixelsToTileUnits: o,
                            pixelPosMatrix: e1.pixelPosMatrix,
                            unwrappedTileID: this.tileID.toUnwrapped(),
                            getElevation: e1.getElevation
                        })));
                }
                return d;
            }
            loadMatchingFeature(e1, t, r, n, i, s, o, a, l, u, c) {
                const h = this.bucketLayerIDs[t];
                if (s && !h.some((e1)=>s.has(e1))) return;
                const p = this.sourceLayerCoder.decode(r), f = this.vtLayers[p].feature(n);
                if (i.needGeometry) {
                    const e1 = La(f, !0);
                    if (!i.filter(new ks(this.tileID.overscaledZ), e1, this.tileID.canonical)) return;
                } else if (!i.filter(new ks(this.tileID.overscaledZ), f)) return;
                const d = this.getId(f, p);
                for(let t = 0; t < h.length; t++){
                    const r = h[t];
                    if (s && !s.has(r)) continue;
                    const i = a[r];
                    if (!i) continue;
                    let p = {};
                    d && u && (p = u.getState(i.sourceLayer || bf, d));
                    const y = O({}, l[r]);
                    y.paint = _f(y.paint, i.paint, f, p, o), y.layout = _f(y.layout, i.layout, f, p, o);
                    const m = !c || c(f, i, p);
                    if (!m) continue;
                    const g = new Rh(f, this.z, this.x, this.y, d);
                    g.layer = y;
                    let x = e1[r];
                    void 0 === x && (x = e1[r] = []), x.push({
                        featureIndex: n,
                        feature: g,
                        intersectionZ: m
                    });
                }
            }
            lookupSymbolFeatures(e1, t, r, n, i, s, o, a) {
                const l = {};
                this.loadVTLayers();
                const u = pi(i.filterSpec, i.globalState);
                for (const i of e1)this.loadMatchingFeature(l, r, n, i, u, s, o, a, t);
                return l;
            }
            hasLayer(e1) {
                for (const t of this.bucketLayerIDs)for (const r of t)if (e1 === r) return !0;
                return !1;
            }
            getId(e1, t) {
                var r;
                let n = e1.id;
                return this.promoteId && (n = e1.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[t]], "boolean" == typeof n && (n = Number(n)), void 0 === n && (null === (r = e1.properties) || void 0 === r ? void 0 : r.cluster) && this.promoteId && (n = Number(e1.properties.cluster_id))), n;
            }
        }
        function _f(e1, t, r, n, i) {
            return N(e1, (e1, s)=>{
                const o = t instanceof Rs ? t.get(s) : null;
                return o && o.evaluate ? o.evaluate(r, n, i) : o;
            });
        }
        function Sf(e1, t) {
            return t - e1;
        }
        function Af(e1, t, n, i, s) {
            const o = [];
            for(let a = 0; a < e1.length; a++){
                const l = e1[a];
                let u;
                for(let e1 = 0; e1 < l.length - 1; e1++){
                    let a = l[e1], c = l[e1 + 1];
                    a.x < t && c.x < t || (a.x < t ? a = new r(t, a.y + (t - a.x) / (c.x - a.x) * (c.y - a.y))._round() : c.x < t && (c = new r(t, a.y + (t - a.x) / (c.x - a.x) * (c.y - a.y))._round()), a.y < n && c.y < n || (a.y < n ? a = new r(a.x + (n - a.y) / (c.y - a.y) * (c.x - a.x), n)._round() : c.y < n && (c = new r(a.x + (n - a.y) / (c.y - a.y) * (c.x - a.x), n)._round()), a.x >= i && c.x >= i || (a.x >= i ? a = new r(i, a.y + (i - a.x) / (c.x - a.x) * (c.y - a.y))._round() : c.x >= i && (c = new r(i, a.y + (i - a.x) / (c.x - a.x) * (c.y - a.y))._round()), a.y >= s && c.y >= s || (a.y >= s ? a = new r(a.x + (s - a.y) / (c.y - a.y) * (c.x - a.x), s)._round() : c.y >= s && (c = new r(a.x + (s - a.y) / (c.y - a.y) * (c.x - a.x), s)._round()), u && a.equals(u[u.length - 1]) || (u = [
                        a
                    ], o.push(u)), u.push(c)))));
                }
            }
            return o;
        }
        function Tf(e1, t, r, n, i) {
            switch(t){
                case 1:
                    return function(e1, t, r, n) {
                        const i = [];
                        for (const s of e1)for (const e1 of s){
                            const s = 0 === n ? e1.x : e1.y;
                            s >= t && s <= r && i.push([
                                e1
                            ]);
                        }
                        return i;
                    }(e1, r, n, i);
                case 2:
                    return Ef(e1, r, n, i, !1);
                case 3:
                    return Ef(e1, r, n, i, !0);
            }
            return [];
        }
        function If(e1, t, n, i, s) {
            const o = 0 === i ? Mf : kf;
            let a = [];
            const l = [];
            for(let r = 0; r < e1.length - 1; r++){
                const u = e1[r], c = e1[r + 1], h = 0 === i ? u.x : u.y, p = 0 === i ? c.x : c.y;
                let f = !1;
                h < t ? p > t && a.push(o(u, c, t)) : h > n ? p < n && a.push(o(u, c, n)) : a.push(u), p < t && h >= t && (a.push(o(u, c, t)), f = !0), p > n && h <= n && (a.push(o(u, c, n)), f = !0), !s && f && (l.push(a), a = []);
            }
            const u = e1.length - 1, c = 0 === i ? e1[u].x : e1[u].y;
            return c >= t && c <= n && a.push(e1[u]), s && a.length > 0 && !a[0].equals(a[a.length - 1]) && a.push(new r(a[0].x, a[0].y)), a.length > 0 && l.push(a), l;
        }
        function Ef(e1, t, r, n, i) {
            const s = [];
            for (const o of e1){
                const e1 = If(o, t, r, n, i);
                e1.length > 0 && s.push(...e1);
            }
            return s;
        }
        function Mf(e1, t, n) {
            return new r(n, e1.y + (n - e1.x) / (t.x - e1.x) * (t.y - e1.y));
        }
        function kf(e1, t, n) {
            return new r(e1.x + (n - e1.y) / (t.y - e1.y) * (t.x - e1.x), n);
        }
        ls("FeatureIndex", wf, {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        class Ff extends r {
            constructor(e1, t, r, n){
                super(e1, t), this.angle = r, void 0 !== n && (this.segment = n);
            }
            clone() {
                return new Ff(this.x, this.y, this.angle, this.segment);
            }
        }
        function Df(e1, t, r, n, i) {
            if (void 0 === t.segment || 0 === r) return !0;
            let s = t, o = t.segment + 1, a = 0;
            for(; a > -r / 2;){
                if (o--, o < 0) return !1;
                a -= e1[o].dist(s), s = e1[o];
            }
            a += e1[o].dist(e1[o + 1]), o++;
            const l = [];
            let u = 0;
            for(; a < r / 2;){
                const t = e1[o], r = e1[o + 1];
                if (!r) return !1;
                let s = e1[o - 1].angleTo(t) - t.angleTo(r);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: a,
                    angleDelta: s
                }), u += s; a - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                o++, a += t.dist(r);
            }
            return !0;
        }
        function Pf(e1) {
            let t = 0;
            for(let r = 0; r < e1.length - 1; r++)t += e1[r].dist(e1[r + 1]);
            return t;
        }
        function Bf(e1, t, r) {
            return e1 ? .6 * t * r : 0;
        }
        function zf(e1, t) {
            return Math.max(e1 ? e1.right - e1.left : 0, t ? t.right - t.left : 0);
        }
        function Vf(e1, t, r, n, i, s) {
            const o = Bf(r, i, s), a = zf(r, n) * s;
            let l = 0;
            const u = Pf(e1) / 2;
            for(let r = 0; r < e1.length - 1; r++){
                const n = e1[r], i = e1[r + 1], s = n.dist(i);
                if (l + s > u) {
                    const c = (u - l) / s, h = dr.number(n.x, i.x, c), p = dr.number(n.y, i.y, c), f = new Ff(h, p, i.angleTo(n), r);
                    return f._round(), !o || Df(e1, f, a, o, t) ? f : void 0;
                }
                l += s;
            }
        }
        function Cf(e1, t, r, n, i, s, o, a, l) {
            const u = Bf(n, s, o), c = zf(n, i), h = c * o, p = 0 === e1[0].x || e1[0].x === l || 0 === e1[0].y || e1[0].y === l;
            return t - h < t / 4 && (t = h + t / 4), Lf(e1, p ? t / 2 * a % t : (c / 2 + 2 * s) * o * a % t, t, u, r, h, p, !1, l);
        }
        function Lf(e1, t, r, n, i, s, o, a, l) {
            const u = s / 2, c = Pf(e1);
            let h = 0, p = t - r, f = [];
            for(let t = 0; t < e1.length - 1; t++){
                const o = e1[t], a = e1[t + 1], d = o.dist(a), y = a.angleTo(o);
                for(; p + r < h + d;){
                    p += r;
                    const m = (p - h) / d, g = dr.number(o.x, a.x, m), x = dr.number(o.y, a.y, m);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new Ff(g, x, y, t);
                        r._round(), n && !Df(e1, r, s, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return a || f.length || o || (f = Lf(e1, h / 2, r, n, i, s, o, !0, l)), f;
        }
        function Of(e1, t, n, i) {
            const s = [], o = e1.image, a = o.pixelRatio, l = o.paddedRect.w - 2, u = o.paddedRect.h - 2;
            let c = {
                x1: e1.left,
                y1: e1.top,
                x2: e1.right,
                y2: e1.bottom
            };
            const h = o.stretchX || [
                [
                    0,
                    l
                ]
            ], p = o.stretchY || [
                [
                    0,
                    u
                ]
            ], f = (e1, t)=>e1 + t[1] - t[0], d = h.reduce(f, 0), y = p.reduce(f, 0), m = l - d, g = u - y;
            let x = 0, v = d, b = 0, w = y, _ = 0, S = m, A = 0, T = g;
            if (o.content && i) {
                const t = o.content, r = t[2] - t[0], n = t[3] - t[1];
                (o.textFitWidth || o.textFitHeight) && (c = Hc(e1)), x = Rf(h, 0, t[0]), b = Rf(p, 0, t[1]), v = Rf(h, t[0], t[2]), w = Rf(p, t[1], t[3]), _ = t[0] - x, A = t[1] - b, S = r - v, T = n - w;
            }
            const I = c.x1, E = c.y1, M = c.x2 - I, k = c.y2 - E, F = (e1, i, s, l)=>{
                const u = $f(e1.stretch - x, v, M, I), c = Uf(e1.fixed - _, S, e1.stretch, d), h = $f(i.stretch - b, w, k, E), p = Uf(i.fixed - A, T, i.stretch, y), f = $f(s.stretch - x, v, M, I), m = Uf(s.fixed - _, S, s.stretch, d), g = $f(l.stretch - b, w, k, E), F = Uf(l.fixed - A, T, l.stretch, y), D = new r(u, h), P = new r(f, h), B = new r(f, g), z = new r(u, g), V = new r(c / a, p / a), C = new r(m / a, F / a), L = t * Math.PI / 180;
                if (L) {
                    const e1 = Math.sin(L), t = Math.cos(L), r = [
                        t,
                        -e1,
                        e1,
                        t
                    ];
                    D._matMult(r), P._matMult(r), z._matMult(r), B._matMult(r);
                }
                const O = e1.stretch + e1.fixed, R = i.stretch + i.fixed;
                return {
                    tl: D,
                    tr: P,
                    bl: z,
                    br: B,
                    tex: {
                        x: o.paddedRect.x + 1 + O,
                        y: o.paddedRect.y + 1 + R,
                        w: s.stretch + s.fixed - O,
                        h: l.stretch + l.fixed - R
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: V,
                    pixelOffsetBR: C,
                    minFontScaleX: S / a / M,
                    minFontScaleY: T / a / k,
                    isSDF: n
                };
            };
            if (i && (o.stretchX || o.stretchY)) {
                const e1 = Nf(h, m, d), t = Nf(p, g, y);
                for(let r = 0; r < e1.length - 1; r++){
                    const n = e1[r], i = e1[r + 1];
                    for(let e1 = 0; e1 < t.length - 1; e1++)s.push(F(n, t[e1], i, t[e1 + 1]));
                }
            } else s.push(F({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return s;
        }
        function Rf(e1, t, r) {
            let n = 0;
            for (const i of e1)n += Math.max(t, Math.min(r, i[1])) - Math.max(t, Math.min(r, i[0]));
            return n;
        }
        function Nf(e1, t, r) {
            const n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            for (const [t, r] of e1){
                const e1 = n[n.length - 1];
                n.push({
                    fixed: t - e1.stretch,
                    stretch: e1.stretch
                }), n.push({
                    fixed: t - e1.stretch,
                    stretch: e1.stretch + (r - t)
                });
            }
            return n.push({
                fixed: t + 1,
                stretch: r
            }), n;
        }
        function $f(e1, t, r, n) {
            return e1 / t * r + n;
        }
        function Uf(e1, t, r, n) {
            return e1 - t * r / n;
        }
        ls("Anchor", Ff);
        class qf {
            constructor(e1, t, n, i, s, o, a, l, u, c){
                var h;
                if (this.boxStartIndex = e1.length, u) {
                    let e1 = o.top, t = o.bottom;
                    const r = o.collisionPadding;
                    r && (e1 -= r[1], t += r[3]);
                    let n = t - e1;
                    n > 0 && (n = Math.max(10, n), this.circleDiameter = n);
                } else {
                    const u = (null === (h = o.image) || void 0 === h ? void 0 : h.content) && (o.image.textFitWidth || o.image.textFitHeight) ? Hc(o) : {
                        x1: o.left,
                        y1: o.top,
                        x2: o.right,
                        y2: o.bottom
                    };
                    u.y1 = u.y1 * a - l[0], u.y2 = u.y2 * a + l[2], u.x1 = u.x1 * a - l[3], u.x2 = u.x2 * a + l[1];
                    const p = o.collisionPadding;
                    if (p && (u.x1 -= p[0] * a, u.y1 -= p[1] * a, u.x2 += p[2] * a, u.y2 += p[3] * a), c) {
                        const e1 = new r(u.x1, u.y1), t = new r(u.x2, u.y1), n = new r(u.x1, u.y2), i = new r(u.x2, u.y2), s = c * Math.PI / 180;
                        e1._rotate(s), t._rotate(s), n._rotate(s), i._rotate(s), u.x1 = Math.min(e1.x, t.x, n.x, i.x), u.x2 = Math.max(e1.x, t.x, n.x, i.x), u.y1 = Math.min(e1.y, t.y, n.y, i.y), u.y2 = Math.max(e1.y, t.y, n.y, i.y);
                    }
                    e1.emplaceBack(t.x, t.y, u.x1, u.y1, u.x2, u.y2, n, i, s);
                }
                this.boxEndIndex = e1.length;
            }
        }
        class jf {
            constructor(e1 = [], t = (e1, t)=>e1 < t ? -1 : e1 > t ? 1 : 0){
                if (this.data = e1, this.length = this.data.length, this.compare = t, this.length > 0) for(let e1 = (this.length >> 1) - 1; e1 >= 0; e1--)this._down(e1);
            }
            push(e1) {
                this.data.push(e1), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const e1 = this.data[0], t = this.data.pop();
                return --this.length > 0 && (this.data[0] = t, this._down(0)), e1;
            }
            peek() {
                return this.data[0];
            }
            _up(e1) {
                const { data: t, compare: r } = this, n = t[e1];
                for(; e1 > 0;){
                    const i = e1 - 1 >> 1, s = t[i];
                    if (r(n, s) >= 0) break;
                    t[e1] = s, e1 = i;
                }
                t[e1] = n;
            }
            _down(e1) {
                const { data: t, compare: r } = this, n = this.length >> 1, i = t[e1];
                for(; e1 < n;){
                    let n = 1 + (e1 << 1);
                    const s = n + 1;
                    if (s < this.length && r(t[s], t[n]) < 0 && (n = s), r(t[n], i) >= 0) break;
                    t[e1] = t[n], e1 = n;
                }
                t[e1] = i;
            }
        }
        function Gf(e1, t = 1, n = !1) {
            const i = vf.fromPoints(e1[0]), s = Math.min(i.width(), i.height());
            let o = s / 2;
            const a = new jf([], Xf), { minX: l, minY: u, maxX: c, maxY: h } = i;
            if (0 === s) return new r(l, u);
            for(let t = l; t < c; t += s)for(let r = u; r < h; r += s)a.push(new Yf(t + o, r + o, o, e1));
            let p = function(e1) {
                let t = 0, r = 0, n = 0;
                const i = e1[0];
                for(let e1 = 0, s = i.length, o = s - 1; e1 < s; o = e1++){
                    const s = i[e1], a = i[o], l = s.x * a.y - a.x * s.y;
                    r += (s.x + a.x) * l, n += (s.y + a.y) * l, t += 3 * l;
                }
                return new Yf(r / t, n / t, 0, e1);
            }(e1), f = a.length;
            for(; a.length;){
                const r = a.pop();
                (r.d > p.d || !p.d) && (p = r, n && console.log("found best %d after %d probes", Math.round(1e4 * r.d) / 1e4, f)), r.max - p.d <= t || (o = r.h / 2, a.push(new Yf(r.p.x - o, r.p.y - o, o, e1)), a.push(new Yf(r.p.x + o, r.p.y - o, o, e1)), a.push(new Yf(r.p.x - o, r.p.y + o, o, e1)), a.push(new Yf(r.p.x + o, r.p.y + o, o, e1)), f += 4);
            }
            return n && (console.log(`num probes: ${f}`), console.log(`best distance: ${p.d}`)), p.p;
        }
        function Xf(e1, t) {
            return t.max - e1.max;
        }
        function Yf(e1, t, n, i) {
            this.p = new r(e1, t), this.h = n, this.d = function(e1, t) {
                let r = !1, n = 1 / 0;
                for(let i = 0; i < t.length; i++){
                    const s = t[i];
                    for(let t = 0, i = s.length, o = i - 1; t < i; o = t++){
                        const i = s[t], a = s[o];
                        i.y > e1.y != a.y > e1.y && e1.x < (a.x - i.x) * (e1.y - i.y) / (a.y - i.y) + i.x && (r = !r), n = Math.min(n, Za(e1, i, a));
                    }
                }
                return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, i), this.max = this.d + this.h * Math.SQRT2;
        }
        var Zf;
        e1.aO = void 0, (Zf = e1.aO || (e1.aO = {}))[Zf.center = 1] = "center", Zf[Zf.left = 2] = "left", Zf[Zf.right = 3] = "right", Zf[Zf.top = 4] = "top", Zf[Zf.bottom = 5] = "bottom", Zf[Zf["top-left"] = 6] = "top-left", Zf[Zf["top-right"] = 7] = "top-right", Zf[Zf["bottom-left"] = 8] = "bottom-left", Zf[Zf["bottom-right"] = 9] = "bottom-right";
        const Hf = Number.POSITIVE_INFINITY;
        function Kf(e1, t) {
            return t[1] !== Hf ? function(e1, t, r) {
                let n = 0, i = 0;
                switch(t = Math.abs(t), r = Math.abs(r), e1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -t;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = t;
                }
                return [
                    n,
                    i
                ];
            }(e1, t[0], t[1]) : function(e1, t) {
                let r = 0, n = 0;
                t < 0 && (t = 0);
                const i = t / Math.SQRT2;
                switch(e1){
                    case "top-right":
                    case "top-left":
                        n = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = 7 - i;
                        break;
                    case "bottom":
                        n = 7 - t;
                        break;
                    case "top":
                        n = t - 7;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = t;
                        break;
                    case "right":
                        r = -t;
                }
                return [
                    r,
                    n
                ];
            }(e1, t[0]);
        }
        function Wf(e1, t, r) {
            var n;
            const i = e1.layout, s = null === (n = i.get("text-variable-anchor-offset")) || void 0 === n ? void 0 : n.evaluate(t, {}, r);
            if (s) {
                const e1 = s.values, t = [];
                for(let r = 0; r < e1.length; r += 2){
                    const n = t[r] = e1[r], i = e1[r + 1].map((e1)=>e1 * lc);
                    n.startsWith("top") ? i[1] -= 7 : n.startsWith("bottom") && (i[1] += 7), t[r + 1] = i;
                }
                return new Ct(t);
            }
            const o = i.get("text-variable-anchor");
            if (o) {
                let n;
                n = void 0 !== e1._unevaluatedLayout.getValue("text-radial-offset") ? [
                    i.get("text-radial-offset").evaluate(t, {}, r) * lc,
                    Hf
                ] : i.get("text-offset").evaluate(t, {}, r).map((e1)=>e1 * lc);
                const s = [];
                for (const e1 of o)s.push(e1, Kf(e1, n));
                return new Ct(s);
            }
            return null;
        }
        function Jf(e1) {
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function Qf(t, r, n, i, s, o, a, l, u, c, h, p) {
            let f = o.textMaxSize.evaluate(r, {});
            void 0 === f && (f = a);
            const d = t.layers[0].layout, y = d.get("icon-offset").evaluate(r, {}, h), m = td(n.horizontal), g = a / 24, x = t.tilePixelRatio * g, v = t.tilePixelRatio * f / 24, b = t.tilePixelRatio * l, w = t.tilePixelRatio * d.get("symbol-spacing"), _ = d.get("text-padding") * t.tilePixelRatio, S = function(e1, t, r, n = 1) {
                const i = e1.get("icon-padding").evaluate(t, {}, r), s = i && i.values;
                return [
                    s[0] * n,
                    s[1] * n,
                    s[2] * n,
                    s[3] * n
                ];
            }(d, r, h, t.tilePixelRatio), A = d.get("text-max-angle") / 180 * Math.PI, T = "viewport" !== d.get("text-rotation-alignment") && "point" !== d.get("symbol-placement"), I = "map" === d.get("icon-rotation-alignment") && "point" !== d.get("symbol-placement"), E = d.get("symbol-placement"), M = w / 2, F = d.get("icon-text-fit");
            let D;
            i && "none" !== F && (t.allowVerticalPlacement && n.vertical && (D = Kc(i, n.vertical, F, d.get("icon-text-fit-padding"), y, g)), m && (i = Kc(i, m, F, d.get("icon-text-fit-padding"), y, g)));
            const P = h ? p.line.getGranularityForZoomLevel(h.z) : 1, B = (l, p)=>{
                p.x < 0 || p.x >= k || p.y < 0 || p.y >= k || function(t, r, n, i, s, o, a, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, T) {
                    const I = t.addToLineVertexArray(r, n);
                    let E, M, k, F, D = 0, P = 0, B = 0, z = 0, V = -1, C = -1;
                    const L = {};
                    let O = pa("");
                    if (t.allowVerticalPlacement && i.vertical) {
                        const e1 = l.layout.get("text-rotate").evaluate(w, {}, A) + 90;
                        k = new qf(u, r, c, h, p, i.vertical, f, d, y, e1), a && (F = new qf(u, r, c, h, p, a, g, x, y, e1));
                    }
                    if (s) {
                        const n = l.layout.get("icon-rotate").evaluate(w, {}), i = "none" !== l.layout.get("icon-text-fit"), o = Of(s, n, S, i), f = a ? Of(a, n, S, i) : void 0;
                        M = new qf(u, r, c, h, p, s, g, x, !1, n), D = 4 * o.length;
                        const d = t.iconSizeData;
                        let y = null;
                        "source" === d.kind ? (y = [
                            Wc * l.layout.get("icon-size").evaluate(w, {})
                        ], y[0] > Jc && j(`${t.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : "composite" === d.kind && (y = [
                            Wc * _.compositeIconSizes[0].evaluate(w, {}, A),
                            Wc * _.compositeIconSizes[1].evaluate(w, {}, A)
                        ], (y[0] > Jc || y[1] > Jc) && j(`${t.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), t.addSymbols(t.icon, o, y, b, v, w, e1.ay.none, r, I.lineStartIndex, I.lineLength, -1, A), V = t.icon.placedSymbolArray.length - 1, f && (P = 4 * f.length, t.addSymbols(t.icon, f, y, b, v, w, e1.ay.vertical, r, I.lineStartIndex, I.lineLength, -1, A), C = t.icon.placedSymbolArray.length - 1);
                    }
                    const R = Object.keys(i.horizontal);
                    for (const n of R){
                        const s = i.horizontal[n];
                        if (!E) {
                            O = pa(s.text);
                            const e1 = l.layout.get("text-rotate").evaluate(w, {}, A);
                            E = new qf(u, r, c, h, p, s, f, d, y, e1);
                        }
                        const a = 1 === s.positionedLines.length;
                        if (B += ed(t, r, s, o, l, y, w, m, I, i.vertical ? e1.ay.horizontal : e1.ay.horizontalOnly, a ? R : [
                            n
                        ], L, V, _, A), a) break;
                    }
                    i.vertical && (z += ed(t, r, i.vertical, o, l, y, w, m, I, e1.ay.vertical, [
                        "vertical"
                    ], L, C, _, A));
                    const N = E ? E.boxStartIndex : t.collisionBoxArray.length, $ = E ? E.boxEndIndex : t.collisionBoxArray.length, U = k ? k.boxStartIndex : t.collisionBoxArray.length, q = k ? k.boxEndIndex : t.collisionBoxArray.length, G = M ? M.boxStartIndex : t.collisionBoxArray.length, X = M ? M.boxEndIndex : t.collisionBoxArray.length, Y = F ? F.boxStartIndex : t.collisionBoxArray.length, Z = F ? F.boxEndIndex : t.collisionBoxArray.length;
                    let H = -1;
                    const K = (e1, t)=>e1 && e1.circleDiameter ? Math.max(e1.circleDiameter, t) : t;
                    H = K(E, H), H = K(k, H), H = K(M, H), H = K(F, H);
                    const W = H > -1 ? 1 : 0;
                    W && (H *= T / lc), t.glyphOffsetArray.length >= ah.MAX_GLYPHS && j("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== w.sortKey && t.addToSortKeyRanges(t.symbolInstances.length, w.sortKey);
                    const J = Wf(l, w, A), [Q, ee] = function(t, r) {
                        const n = t.length, i = null == r ? void 0 : r.values;
                        if ((null == i ? void 0 : i.length) > 0) for(let r = 0; r < i.length; r += 2){
                            const n = i[r + 1];
                            t.emplaceBack(e1.aO[i[r]], n[0], n[1]);
                        }
                        return [
                            n,
                            t.length
                        ];
                    }(t.textAnchorOffsets, J);
                    t.symbolInstances.emplaceBack(r.x, r.y, L.right >= 0 ? L.right : -1, L.center >= 0 ? L.center : -1, L.left >= 0 ? L.left : -1, L.vertical || -1, V, C, O, N, $, U, q, G, X, Y, Z, c, B, z, D, P, W, 0, f, H, Q, ee);
                }(t, p, l, n, i, s, D, t.layers[0], t.collisionBoxArray, r.index, r.sourceLayerIndex, t.index, x, [
                    _,
                    _,
                    _,
                    _
                ], T, u, b, S, I, y, r, o, c, h, a);
            };
            if ("line" === E) for (const e1 of Af(r.geometry, 0, 0, k, k)){
                const r = pu(e1, P), s = Cf(r, w, A, n.vertical || m, i, 24, v, t.overscaling, k);
                for (const e1 of s)m && rd(t, m.text, M, e1) || B(r, e1);
            }
            else if ("line-center" === E) {
                for (const e1 of r.geometry)if (e1.length > 1) {
                    const t = pu(e1, P), r = Vf(t, A, n.vertical || m, i, 24, v);
                    r && B(t, r);
                }
            } else if ("Polygon" === r.type) for (const e1 of Qr(r.geometry, 0)){
                const t = Gf(e1, 16);
                B(pu(e1[0], P, !0), new Ff(t.x, t.y, 0));
            }
            else if ("LineString" === r.type) for (const e1 of r.geometry){
                const t = pu(e1, P);
                B(t, new Ff(t[0].x, t[0].y, 0));
            }
            else if ("Point" === r.type) for (const e1 of r.geometry)for (const t of e1)B([
                t
            ], new Ff(t.x, t.y, 0));
        }
        function ed(e1, t, n, i, s, o, a, l, u, c, h, p, f, d, y) {
            const m = function(e1, t, n, i, s, o, a, l) {
                const u = i.layout.get("text-rotate").evaluate(o, {}) * Math.PI / 180, c = [];
                for (const e1 of t.positionedLines)for (const i of e1.positionedGlyphs){
                    if (!i.rect) continue;
                    const o = i.rect || {};
                    let h = 4, p = !0, f = 1, d = 0;
                    const y = (s || l) && i.vertical, m = i.metrics.advance * i.scale / 2;
                    if (l && t.verticalizable && (d = e1.lineOffset / 2 - (i.imageName ? -(lc - i.metrics.width * i.scale) / 2 : (i.scale - 1) * lc)), i.imageName) {
                        const e1 = a[i.imageName];
                        p = e1.sdf, f = e1.pixelRatio, h = 1 / f;
                    }
                    const g = s ? [
                        i.x + m,
                        i.y
                    ] : [
                        0,
                        0
                    ];
                    let x = s ? [
                        0,
                        0
                    ] : [
                        i.x + m + n[0],
                        i.y + n[1] - d
                    ], v = [
                        0,
                        0
                    ];
                    y && (v = x, x = [
                        0,
                        0
                    ]);
                    const b = i.metrics.isDoubleResolution ? 2 : 1, w = (i.metrics.left - h) * i.scale - m + x[0], _ = (-i.metrics.top - h) * i.scale + x[1], S = w + o.w / b * i.scale / f, A = _ + o.h / b * i.scale / f, T = new r(w, _), I = new r(S, _), E = new r(w, A), M = new r(S, A);
                    if (y) {
                        const e1 = new r(-m, m - -17), t = -Math.PI / 2, n = 12 - m, s = new r(22 - n, -(i.imageName ? n : 0)), o = new r(...v);
                        T._rotateAround(t, e1)._add(s)._add(o), I._rotateAround(t, e1)._add(s)._add(o), E._rotateAround(t, e1)._add(s)._add(o), M._rotateAround(t, e1)._add(s)._add(o);
                    }
                    if (u) {
                        const e1 = Math.sin(u), t = Math.cos(u), r = [
                            t,
                            -e1,
                            e1,
                            t
                        ];
                        T._matMult(r), I._matMult(r), E._matMult(r), M._matMult(r);
                    }
                    const k = new r(0, 0), F = new r(0, 0);
                    c.push({
                        tl: T,
                        tr: I,
                        bl: E,
                        br: M,
                        tex: o,
                        writingMode: t.writingMode,
                        glyphOffset: g,
                        sectionIndex: i.sectionIndex,
                        isSDF: p,
                        pixelOffsetTL: k,
                        pixelOffsetBR: F,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
                return c;
            }(0, n, l, s, o, a, i, e1.allowVerticalPlacement), g = e1.textSizeData;
            let x = null;
            "source" === g.kind ? (x = [
                Wc * s.layout.get("text-size").evaluate(a, {})
            ], x[0] > Jc && j(`${e1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : "composite" === g.kind && (x = [
                Wc * d.compositeTextSizes[0].evaluate(a, {}, y),
                Wc * d.compositeTextSizes[1].evaluate(a, {}, y)
            ], (x[0] > Jc || x[1] > Jc) && j(`${e1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), e1.addSymbols(e1.text, m, x, l, o, a, c, t, u.lineStartIndex, u.lineLength, f, y);
            for (const t of h)p[t] = e1.text.placedSymbolArray.length - 1;
            return 4 * m.length;
        }
        function td(e1) {
            for(const t in e1)return e1[t];
            return null;
        }
        function rd(e1, t, r, n) {
            const i = e1.compareText;
            if (t in i) {
                const e1 = i[t];
                for(let t = e1.length - 1; t >= 0; t--)if (n.dist(e1[t]) < r) return !0;
            } else i[t] = [];
            return i[t].push(n), !1;
        }
        const nd = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class id {
            static from(e1) {
                if (!(e1 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [t, r] = new Uint8Array(e1, 0, 2);
                if (219 !== t) throw new Error("Data does not appear to be in a KDBush format.");
                const n = r >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const i = nd[15 & r];
                if (!i) throw new Error("Unrecognized array type.");
                const [s] = new Uint16Array(e1, 2, 1), [o] = new Uint32Array(e1, 4, 1);
                return new id(o, s, i, e1);
            }
            constructor(e1, t = 64, r = Float64Array, n){
                if (isNaN(e1) || e1 < 0) throw new Error(`Unpexpected numItems value: ${e1}.`);
                this.numItems = +e1, this.nodeSize = Math.min(Math.max(+t, 2), 65535), this.ArrayType = r, this.IndexArrayType = e1 < 65536 ? Uint16Array : Uint32Array;
                const i = nd.indexOf(this.ArrayType), s = 2 * e1 * this.ArrayType.BYTES_PER_ELEMENT, o = e1 * this.IndexArrayType.BYTES_PER_ELEMENT, a = (8 - o % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, e1), this.coords = new this.ArrayType(this.data, 8 + o + a, 2 * e1), this._pos = 2 * e1, this._finished = !0) : (this.data = new ArrayBuffer(8 + s + o + a), this.ids = new this.IndexArrayType(this.data, 8, e1), this.coords = new this.ArrayType(this.data, 8 + o + a, 2 * e1), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = t, new Uint32Array(this.data, 4, 1)[0] = e1);
            }
            add(e1, t) {
                const r = this._pos >> 1;
                return this.ids[r] = r, this.coords[this._pos++] = e1, this.coords[this._pos++] = t, r;
            }
            finish() {
                const e1 = this._pos >> 1;
                if (e1 !== this.numItems) throw new Error(`Added ${e1} items when expected ${this.numItems}.`);
                return sd(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(e1, t, r, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: s, nodeSize: o } = this, a = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; a.length;){
                    const u = a.pop() || 0, c = a.pop() || 0, h = a.pop() || 0;
                    if (c - h <= o) {
                        for(let o = h; o <= c; o++){
                            const a = s[2 * o], u = s[2 * o + 1];
                            a >= e1 && a <= r && u >= t && u <= n && l.push(i[o]);
                        }
                        continue;
                    }
                    const p = h + c >> 1, f = s[2 * p], d = s[2 * p + 1];
                    f >= e1 && f <= r && d >= t && d <= n && l.push(i[p]), (0 === u ? e1 <= f : t <= d) && (a.push(h), a.push(p - 1), a.push(1 - u)), (0 === u ? r >= f : n >= d) && (a.push(p + 1), a.push(c), a.push(1 - u));
                }
                return l;
            }
            within(e1, t, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: i, nodeSize: s } = this, o = [
                    0,
                    n.length - 1,
                    0
                ], a = [], l = r * r;
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= s) {
                        for(let r = h; r <= c; r++)ud(i[2 * r], i[2 * r + 1], e1, t) <= l && a.push(n[r]);
                        continue;
                    }
                    const p = h + c >> 1, f = i[2 * p], d = i[2 * p + 1];
                    ud(f, d, e1, t) <= l && a.push(n[p]), (0 === u ? e1 - r <= f : t - r <= d) && (o.push(h), o.push(p - 1), o.push(1 - u)), (0 === u ? e1 + r >= f : t + r >= d) && (o.push(p + 1), o.push(c), o.push(1 - u));
                }
                return a;
            }
        }
        function sd(e1, t, r, n, i, s) {
            if (i - n <= r) return;
            const o = n + i >> 1;
            od(e1, t, o, n, i, s), sd(e1, t, r, n, o - 1, 1 - s), sd(e1, t, r, o + 1, i, 1 - s);
        }
        function od(e1, t, r, n, i, s) {
            for(; i > n;){
                if (i - n > 600) {
                    const o = i - n + 1, a = r - n + 1, l = Math.log(o), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (o - u) / o) * (a - o / 2 < 0 ? -1 : 1);
                    od(e1, t, r, Math.max(n, Math.floor(r - a * u / o + c)), Math.min(i, Math.floor(r + (o - a) * u / o + c)), s);
                }
                const o = t[2 * r + s];
                let a = n, l = i;
                for(ad(e1, t, n, r), t[2 * i + s] > o && ad(e1, t, n, i); a < l;){
                    for(ad(e1, t, a, l), a++, l--; t[2 * a + s] < o;)a++;
                    for(; t[2 * l + s] > o;)l--;
                }
                t[2 * n + s] === o ? ad(e1, t, n, l) : (l++, ad(e1, t, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
            }
        }
        function ad(e1, t, r, n) {
            ld(e1, r, n), ld(t, 2 * r, 2 * n), ld(t, 2 * r + 1, 2 * n + 1);
        }
        function ld(e1, t, r) {
            const n = e1[t];
            e1[t] = e1[r], e1[r] = n;
        }
        function ud(e1, t, r, n) {
            const i = e1 - r, s = t - n;
            return i * i + s * s;
        }
        var cd;
        e1.cG = void 0, (cd = e1.cG || (e1.cG = {})).create = "create", cd.load = "load", cd.fullLoad = "fullLoad";
        let hd = null, pd = [];
        const fd = 1e3 / 60, dd = "loadTime", yd = "fullLoadTime", md = {
            mark (e1) {
                performance.mark(e1);
            },
            frame (e1) {
                const t = e1;
                null != hd && pd.push(t - hd), hd = t;
            },
            clearMetrics () {
                hd = null, pd = [], performance.clearMeasures(dd), performance.clearMeasures(yd);
                for(const t in e1.cG)performance.clearMarks(e1.cG[t]);
            },
            getPerformanceMetrics () {
                performance.measure(dd, e1.cG.create, e1.cG.load), performance.measure(yd, e1.cG.create, e1.cG.fullLoad);
                const t = performance.getEntriesByName(dd)[0].duration, r = performance.getEntriesByName(yd)[0].duration, n = pd.length, i = 1 / (pd.reduce((e1, t)=>e1 + t, 0) / n / 1e3), s = pd.filter((e1)=>e1 > fd).reduce((e1, t)=>e1 + (t - fd) / fd, 0);
                return {
                    loadTime: t,
                    fullLoadTime: r,
                    fps: i,
                    percentDroppedFrames: s / (n + s) * 100,
                    totalFrames: n
                };
            }
        };
        e1.$ = h, e1.A = f, e1.B = ss, e1.C = es, e1.D = Ns, e1.E = ge, e1.F = function([e1, t, r]) {
            return t += 90, t *= Math.PI / 180, r *= Math.PI / 180, {
                x: e1 * Math.cos(t) * Math.sin(r),
                y: e1 * Math.sin(t) * Math.sin(r),
                z: e1 * Math.cos(r)
            };
        }, e1.G = dr, e1.H = ks, e1.I = Lc, e1.J = rs, e1.K = function(e1) {
            if (null == Y) {
                const t = e1.navigator ? e1.navigator.userAgent : null;
                Y = !!e1.safari || !(!t || !(/\b(iPad|iPhone|iPod)\b/.test(t) || t.match("Safari") && !t.match("Chrome")));
            }
            return Y;
        }, e1.L = class {
            constructor(e1, t){
                this.target = e1, this.mapId = t, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new gh(()=>this.process()), this.subscription = Q(this.target, "message", (e1)=>this.receive(e1), !1), this.globalScope = X(self) ? e1 : window;
            }
            registerMessageHandler(e1, t) {
                this.messageHandlers[e1] = t;
            }
            unregisterMessageHandler(e1) {
                delete this.messageHandlers[e1];
            }
            sendAsync(e1, t) {
                return new Promise((r, n)=>{
                    const i = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), s = t ? Q(t.signal, "abort", ()=>{
                        null == s || s.unsubscribe(), delete this.resolveRejects[i];
                        const t = {
                            id: i,
                            type: "<cancel>",
                            origin: location.origin,
                            targetMapId: e1.targetMapId,
                            sourceMapId: this.mapId
                        };
                        this.target.postMessage(t);
                    }, xh) : null;
                    this.resolveRejects[i] = {
                        resolve: (e1)=>{
                            null == s || s.unsubscribe(), r(e1);
                        },
                        reject: (e1)=>{
                            null == s || s.unsubscribe(), n(e1);
                        }
                    };
                    const o = [], a = Object.assign(Object.assign({}, e1), {
                        id: i,
                        sourceMapId: this.mapId,
                        origin: location.origin,
                        data: ps(e1.data, o)
                    });
                    this.target.postMessage(a, {
                        transfer: o
                    });
                });
            }
            receive(e1) {
                const t = e1.data, r = t.id;
                if (!("file://" !== t.origin && "file://" !== location.origin && "resource://android" !== t.origin && "resource://android" !== location.origin && t.origin !== location.origin || t.targetMapId && this.mapId !== t.targetMapId)) {
                    if ("<cancel>" === t.type) {
                        delete this.tasks[r];
                        const e1 = this.abortControllers[r];
                        return delete this.abortControllers[r], void (e1 && e1.abort());
                    }
                    if (X(self) || t.mustQueue) return this.tasks[r] = t, this.taskQueue.push(r), void this.invoker.trigger();
                    this.processTask(r, t);
                }
            }
            process() {
                if (0 === this.taskQueue.length) return;
                const e1 = this.taskQueue.shift(), t = this.tasks[e1];
                delete this.tasks[e1], this.taskQueue.length > 0 && this.invoker.trigger(), t && this.processTask(e1, t);
            }
            processTask(e1, r) {
                return t(this, void 0, void 0, function*() {
                    if ("<response>" === r.type) {
                        const t = this.resolveRejects[e1];
                        if (delete this.resolveRejects[e1], !t) return;
                        return void (r.error ? t.reject(fs(r.error)) : t.resolve(fs(r.data)));
                    }
                    if (!this.messageHandlers[r.type]) return void this.completeTask(e1, new Error(`Could not find a registered handler for ${r.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(", ")}`));
                    const t = fs(r.data), n = new AbortController;
                    this.abortControllers[e1] = n;
                    try {
                        const i = yield this.messageHandlers[r.type](r.sourceMapId, t, n);
                        this.completeTask(e1, null, i);
                    } catch (t) {
                        this.completeTask(e1, t);
                    }
                });
            }
            completeTask(e1, t, r) {
                const n = [];
                delete this.abortControllers[e1];
                const i = {
                    id: e1,
                    type: "<response>",
                    sourceMapId: this.mapId,
                    origin: location.origin,
                    error: t ? ps(t) : null,
                    data: ps(r, n)
                };
                this.target.postMessage(i, {
                    transfer: n
                });
            }
            remove() {
                this.invoker.remove(), this.subscription.unsubscribe();
            }
        }, e1.M = le, e1.N = function() {
            var e1 = new f(16);
            return f != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0), e1[0] = 1, e1[5] = 1, e1[10] = 1, e1[15] = 1, e1;
        }, e1.O = function(e1, t, r) {
            var n, i, s, o, a, l, u, c, h, p, f, d, y = r[0], m = r[1], g = r[2];
            return t === e1 ? (e1[12] = t[0] * y + t[4] * m + t[8] * g + t[12], e1[13] = t[1] * y + t[5] * m + t[9] * g + t[13], e1[14] = t[2] * y + t[6] * m + t[10] * g + t[14], e1[15] = t[3] * y + t[7] * m + t[11] * g + t[15]) : (i = t[1], s = t[2], o = t[3], a = t[4], l = t[5], u = t[6], c = t[7], h = t[8], p = t[9], f = t[10], d = t[11], e1[0] = n = t[0], e1[1] = i, e1[2] = s, e1[3] = o, e1[4] = a, e1[5] = l, e1[6] = u, e1[7] = c, e1[8] = h, e1[9] = p, e1[10] = f, e1[11] = d, e1[12] = n * y + a * m + h * g + t[12], e1[13] = i * y + l * m + p * g + t[13], e1[14] = s * y + u * m + f * g + t[14], e1[15] = o * y + c * m + d * g + t[15]), e1;
        }, e1.P = r, e1.Q = function(e1, t, r) {
            var n = r[0], i = r[1], s = r[2];
            return e1[0] = t[0] * n, e1[1] = t[1] * n, e1[2] = t[2] * n, e1[3] = t[3] * n, e1[4] = t[4] * i, e1[5] = t[5] * i, e1[6] = t[6] * i, e1[7] = t[7] * i, e1[8] = t[8] * s, e1[9] = t[9] * s, e1[10] = t[10] * s, e1[11] = t[11] * s, e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15], e1;
        }, e1.R = xl, e1.S = function(e1, t, r) {
            var n = t[0], i = t[1], s = t[2], o = t[3], a = t[4], l = t[5], u = t[6], c = t[7], h = t[8], p = t[9], f = t[10], d = t[11], y = t[12], m = t[13], g = t[14], x = t[15], v = r[0], b = r[1], w = r[2], _ = r[3];
            return e1[0] = v * n + b * a + w * h + _ * y, e1[1] = v * i + b * l + w * p + _ * m, e1[2] = v * s + b * u + w * f + _ * g, e1[3] = v * o + b * c + w * d + _ * x, e1[4] = (v = r[4]) * n + (b = r[5]) * a + (w = r[6]) * h + (_ = r[7]) * y, e1[5] = v * i + b * l + w * p + _ * m, e1[6] = v * s + b * u + w * f + _ * g, e1[7] = v * o + b * c + w * d + _ * x, e1[8] = (v = r[8]) * n + (b = r[9]) * a + (w = r[10]) * h + (_ = r[11]) * y, e1[9] = v * i + b * l + w * p + _ * m, e1[10] = v * s + b * u + w * f + _ * g, e1[11] = v * o + b * c + w * d + _ * x, e1[12] = (v = r[12]) * n + (b = r[13]) * a + (w = r[14]) * h + (_ = r[15]) * y, e1[13] = v * i + b * l + w * p + _ * m, e1[14] = v * s + b * u + w * f + _ * g, e1[15] = v * o + b * c + w * d + _ * x, e1;
        }, e1.T = El, e1.U = function(e1, t) {
            const r = {};
            for(let n = 0; n < t.length; n++){
                const i = t[n];
                i in e1 && (r[i] = e1[i]);
            }
            return r;
        }, e1.V = bh, e1.W = L, e1.X = Ah, e1.Y = Sh, e1.Z = c, e1._ = t, e1.a = oe, e1.a$ = v, e1.a0 = K, e1.a1 = Bh, e1.a2 = Ih, e1.a3 = Eh, e1.a4 = k, e1.a5 = function(e1, t, r) {
            if (!e1) return t || {};
            if (!t) return e1 || {};
            const n = Lh(e1), i = Lh(t);
            !function(e1, t) {
                t.removeAll && (e1.add.clear(), e1.update.clear(), e1.remove.clear(), t.remove.clear());
                for (const r of t.remove)e1.add.delete(r), e1.update.delete(r);
                for (const [r, n] of t.update){
                    const i = e1.update.get(r);
                    i && (t.update.set(r, Ch(i, n)), e1.update.delete(r));
                }
            }(n, i);
            const s = {};
            if ((n.removeAll || i.removeAll) && (s.removeAll = !0), s.remove = new Set([
                ...n.remove,
                ...i.remove
            ]), s.add = new Map([
                ...n.add,
                ...i.add
            ]), s.update = new Map([
                ...n.update,
                ...i.update
            ]), s.remove.size && s.add.size) for (const e1 of s.add.keys())s.remove.delete(e1);
            return function(e1) {
                const t = {};
                return e1.removeAll && (t.removeAll = e1.removeAll), e1.remove && (t.remove = Array.from(e1.remove)), e1.add && (t.add = Array.from(e1.add.values())), e1.update && (t.update = Array.from(e1.update.values())), t;
            }(s);
        }, e1.a6 = function(e1, t) {
            if (null == e1) return !0;
            if ("Feature" === e1.type) return null != Vh(e1, t);
            if ("FeatureCollection" === e1.type) {
                const r = new Set;
                for (const n of e1.features){
                    const e1 = Vh(n, t);
                    if (null == e1) return !1;
                    if (r.has(e1)) return !1;
                    r.add(e1);
                }
                return !0;
            }
            return !1;
        }, e1.a7 = function(e1, t) {
            const r = new Map;
            if (null == e1) ;
            else if ("Feature" === e1.type) r.set(Vh(e1, t), e1);
            else for (const n of e1.features)r.set(Vh(n, t), n);
            return r;
        }, e1.a8 = function(e1, t, r) {
            var n, i;
            if (t.removeAll) e1.clear();
            else if (t.remove) for (const r of t.remove)e1.delete(r);
            if (t.add) for (const n of t.add){
                const t = Vh(n, r);
                null != t && e1.set(t, n);
            }
            if (t.update) for (const r of t.update){
                let t = e1.get(r.id);
                if (!t) continue;
                const s = !!r.newGeometry, o = r.removeAllProperties || (null === (n = r.removeProperties) || void 0 === n ? void 0 : n.length) > 0 || (null === (i = r.addOrUpdateProperties) || void 0 === i ? void 0 : i.length) > 0;
                if ((s || o) && (t = Object.assign({}, t), e1.set(r.id, t), s && (t.geometry = r.newGeometry), o)) {
                    if (t.properties = r.removeAllProperties ? {} : Object.assign({}, t.properties || {}), r.removeProperties) for (const e1 of r.removeProperties)delete t.properties[e1];
                    if (r.addOrUpdateProperties) for (const { key: e1, value: n } of r.addOrUpdateProperties)t.properties[e1] = n;
                }
            }
        }, e1.a9 = bf, e1.aA = function(e1, t) {
            var r = t[0], n = t[1], i = t[2], s = t[3], o = t[4], a = t[5], l = t[6], u = t[7], c = t[8], h = t[9], p = t[10], f = t[11], d = t[12], y = t[13], m = t[14], g = t[15], x = r * a - n * o, v = r * l - i * o, b = r * u - s * o, w = n * l - i * a, _ = n * u - s * a, S = i * u - s * l, A = c * y - h * d, T = c * m - p * d, I = c * g - f * d, E = h * m - p * y, M = h * g - f * y, k = p * g - f * m, F = x * k - v * M + b * E + w * I - _ * T + S * A;
            return F ? (e1[0] = (a * k - l * M + u * E) * (F = 1 / F), e1[1] = (i * M - n * k - s * E) * F, e1[2] = (y * S - m * _ + g * w) * F, e1[3] = (p * _ - h * S - f * w) * F, e1[4] = (l * I - o * k - u * T) * F, e1[5] = (r * k - i * I + s * T) * F, e1[6] = (m * b - d * S - g * v) * F, e1[7] = (c * S - p * b + f * v) * F, e1[8] = (o * M - a * I + u * A) * F, e1[9] = (n * I - r * M - s * A) * F, e1[10] = (d * _ - y * b + g * x) * F, e1[11] = (h * b - c * _ - f * x) * F, e1[12] = (a * T - o * E - l * A) * F, e1[13] = (r * E - n * T + i * A) * F, e1[14] = (y * v - d * w - m * x) * F, e1[15] = (c * w - h * v + p * x) * F, e1) : null;
        }, e1.aB = E, e1.aC = function(e1) {
            var t = e1[0], r = e1[1];
            return Math.sqrt(t * t + r * r);
        }, e1.aD = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1;
        }, e1.aE = function(e1, t, r) {
            return e1[0] = t[0] * r, e1[1] = t[1] * r, e1;
        }, e1.aF = nh, e1.aG = A, e1.aH = function(e1, t, n, i) {
            const s = t.y - e1.y, o = t.x - e1.x, a = i.y - n.y, l = i.x - n.x, u = a * o - l * s;
            if (0 === u) return null;
            const c = (l * (e1.y - n.y) - a * (e1.x - n.x)) / u;
            return new r(e1.x + c * o, e1.y + c * s);
        }, e1.aI = Af, e1.aJ = $a, e1.aK = function(e1) {
            let t = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const s of e1)t = Math.min(t, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            return [
                t,
                r,
                n,
                i
            ];
        }, e1.aL = lc, e1.aM = F, e1.aN = function(e1, t, r, n, i = !1) {
            if (!r[0] && !r[1]) return [
                0,
                0
            ];
            const s = i ? "map" === n ? -e1.bearingInRadians : 0 : "viewport" === n ? e1.bearingInRadians : 0;
            if (s) {
                const e1 = Math.sin(s), t = Math.cos(s);
                r = [
                    r[0] * t - r[1] * e1,
                    r[0] * e1 + r[1] * t
                ];
            }
            return [
                i ? r[0] : F(t, r[0], e1.zoom),
                i ? r[1] : F(t, r[1], e1.zoom)
            ];
        }, e1.aP = eh, e1.aQ = Jf, e1.aR = $c, e1.aS = id, e1.aT = Qs, e1.aU = au, e1.aV = Oo, e1.aW = ta, e1.aX = Wo, e1.aY = te, e1.aZ = Mh, e1.a_ = b, e1.aa = kh, e1.ab = vf, e1.ac = 25, e1.ad = Dh, e1.ae = (e1)=>{
            const t = window.document.createElement("video");
            return t.muted = !0, new Promise((r)=>{
                t.onloadstart = ()=>{
                    r(t);
                };
                for (const r of e1){
                    const e1 = window.document.createElement("source");
                    pe(r) || (t.crossOrigin = "Anonymous"), e1.src = r, t.appendChild(e1);
                }
            });
        }, e1.af = Fe, e1.ag = function() {
            return R++;
        }, e1.ah = Eo, e1.ai = ah, e1.aj = pi, e1.ak = La, e1.al = Rh, e1.am = function(e1) {
            const t = {};
            if (e1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (e1, r, n, i)=>{
                const s = n || i;
                return t[r] = !s || s.toLowerCase(), "";
            }), t["max-age"]) {
                const e1 = parseInt(t["max-age"], 10);
                isNaN(e1) ? delete t["max-age"] : t["max-age"] = e1;
            }
            return t;
        }, e1.an = C, e1.ao = 85.051129, e1.ap = ee, e1.aq = function(e1) {
            return Math.pow(2, e1);
        }, e1.ar = y, e1.as = Th, e1.at = function(e1) {
            return Math.log(e1) / Math.LN2;
        }, e1.au = function(e1) {
            var t = e1[0], r = e1[1];
            return t * t + r * r;
        }, e1.av = class {
            constructor(e1, t){
                this.max = e1, this.onRemove = t, this.reset();
            }
            reset() {
                for(const e1 in this.data)for (const t of this.data[e1])t.timeout && clearTimeout(t.timeout), this.onRemove(t.value);
                return this.data = {}, this.order = [], this;
            }
            add(e1, t, r) {
                const n = e1.wrapped().key;
                void 0 === this.data[n] && (this.data[n] = []);
                const i = {
                    value: t,
                    timeout: void 0
                };
                if (void 0 !== r && (i.timeout = setTimeout(()=>{
                    this.remove(e1, i);
                }, r)), this.data[n].push(i), this.order.push(n), this.order.length > this.max) {
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            has(e1) {
                return e1.wrapped().key in this.data;
            }
            getAndRemove(e1) {
                return this.has(e1) ? this._getAndRemoveByKey(e1.wrapped().key) : null;
            }
            _getAndRemoveByKey(e1) {
                const t = this.data[e1].shift();
                return t.timeout && clearTimeout(t.timeout), 0 === this.data[e1].length && delete this.data[e1], this.order.splice(this.order.indexOf(e1), 1), t.value;
            }
            getByKey(e1) {
                const t = this.data[e1];
                return t ? t[0].value : null;
            }
            get(e1) {
                return this.has(e1) ? this.data[e1.wrapped().key][0].value : null;
            }
            remove(e1, t) {
                if (!this.has(e1)) return this;
                const r = e1.wrapped().key, n = void 0 === t ? 0 : this.data[r].indexOf(t), i = this.data[r][n];
                return this.data[r].splice(n, 1), i.timeout && clearTimeout(i.timeout), 0 === this.data[r].length && delete this.data[r], this.onRemove(i.value), this.order.splice(this.order.indexOf(r), 1), this;
            }
            setMaxSize(e1) {
                for(this.max = e1; this.order.length > this.max;){
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            filter(e1) {
                const t = [];
                for(const r in this.data)for (const n of this.data[r])e1(n.value) || t.push(n);
                for (const e1 of t)this.remove(e1.value.tileID, e1);
            }
        }, e1.aw = function(e1) {
            if (!e1.length) return new Set;
            const t = Math.max(...e1.map((e1)=>e1.canonical.z));
            let r = 1 / 0, n = -1 / 0, i = 1 / 0, s = -1 / 0;
            const o = [];
            for (const a of e1){
                const { x: e1, y: l, z: u } = a.canonical, c = Math.pow(2, t - u), h = e1 * c, p = l * c;
                o.push({
                    id: a,
                    x: h,
                    y: p
                }), h < r && (r = h), h > n && (n = h), p < i && (i = p), p > s && (s = p);
            }
            const a = new Set;
            for (const e1 of o)e1.x !== r && e1.x !== n && e1.y !== i && e1.y !== s || a.add(e1.id);
            return a;
        }, e1.ax = function(e1, t) {
            let r = 0, n = 0;
            if ("constant" === e1.kind) n = e1.layoutSize;
            else if ("source" !== e1.kind) {
                const { interpolationType: i, minZoom: s, maxZoom: o } = e1, a = i ? C(pr.interpolationFactor(i, t, s, o), 0, 1) : 0;
                "camera" === e1.kind ? n = dr.number(e1.minSize, e1.maxSize, a) : r = a;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }, e1.az = function(e1, { uSize: t, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === e1.kind ? n / Wc : "composite" === e1.kind ? dr.number(n / Wc, i / Wc, r) : t;
        }, e1.b = Z, e1.b$ = class extends ga {
            constructor(e1, t){
                super(e1, t), this.current = wa;
            }
            set(e1) {
                if (e1[12] !== this.current[12] || e1[0] !== this.current[0]) return this.current = e1, void this.gl.uniformMatrix4fv(this.location, !1, e1);
                for(let t = 1; t < 16; t++)if (e1[t] !== this.current[t]) {
                    this.current = e1, this.gl.uniformMatrix4fv(this.location, !1, e1);
                    break;
                }
            }
        }, e1.b0 = function(e1) {
            var t = new f(3);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t;
        }, e1.b1 = function(e1, t, r) {
            return e1[0] = t[0] - r[0], e1[1] = t[1] - r[1], e1[2] = t[2] - r[2], e1;
        }, e1.b2 = function(e1, t) {
            var r = t[0], n = t[1], i = t[2], s = r * r + n * n + i * i;
            return s > 0 && (s = 1 / Math.sqrt(s)), e1[0] = t[0] * s, e1[1] = t[1] * s, e1[2] = t[2] * s, e1;
        }, e1.b3 = w, e1.b4 = function(e1, t) {
            return e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2];
        }, e1.b5 = function(e1, t, r) {
            return e1[0] = t[0] * r[0], e1[1] = t[1] * r[1], e1[2] = t[2] * r[2], e1[3] = t[3] * r[3], e1;
        }, e1.b6 = g, e1.b7 = function(e1, t, r) {
            const n = t[0] * r[0] + t[1] * r[1] + t[2] * r[2];
            return 0 === n ? null : (-(e1[0] * r[0] + e1[1] * r[1] + e1[2] * r[2]) - r[3]) / n;
        }, e1.b8 = S, e1.b9 = function(e1, t, r) {
            return e1[0] = t[0] * r, e1[1] = t[1] * r, e1[2] = t[2] * r, e1[3] = t[3] * r, e1;
        }, e1.bA = I, e1.bB = function(e1, t, r) {
            var n = r[0], i = r[1], s = r[2], o = r[3], a = t[0], l = t[1], u = t[2], c = i * u - s * l, h = s * a - n * u, p = n * l - i * a;
            return e1[0] = a + o * (c += c) + i * (p += p) - s * (h += h), e1[1] = l + o * h + s * c - n * p, e1[2] = u + o * p + n * h - i * c, e1;
        }, e1.bC = function(e1, t, r) {
            const n = (i = [
                e1[0],
                e1[1],
                e1[2],
                t[0],
                t[1],
                t[2],
                r[0],
                r[1],
                r[2]
            ])[0] * ((c = i[8]) * (o = i[4]) - (a = i[5]) * (u = i[7])) + i[1] * (-c * (s = i[3]) + a * (l = i[6])) + i[2] * (u * s - o * l);
            var i, s, o, a, l, u, c;
            if (0 === n) return null;
            const h = w([], [
                t[0],
                t[1],
                t[2]
            ], [
                r[0],
                r[1],
                r[2]
            ]), p = w([], [
                r[0],
                r[1],
                r[2]
            ], [
                e1[0],
                e1[1],
                e1[2]
            ]), f = w([], [
                e1[0],
                e1[1],
                e1[2]
            ], [
                t[0],
                t[1],
                t[2]
            ]), d = b([], h, -e1[3]);
            return v(d, d, b([], p, -t[3])), v(d, d, b([], f, -r[3])), b(d, d, 1 / n), d;
        }, e1.bD = vh, e1.bE = function() {
            return new Float64Array(4);
        }, e1.bF = function(e1, t, r, n) {
            var i = [], s = [];
            return i[0] = t[0] - r[0], i[1] = t[1] - r[1], i[2] = t[2] - r[2], s[0] = i[0] * Math.cos(n) - i[1] * Math.sin(n), s[1] = i[0] * Math.sin(n) + i[1] * Math.cos(n), s[2] = i[2], e1[0] = s[0] + r[0], e1[1] = s[1] + r[1], e1[2] = s[2] + r[2], e1;
        }, e1.bG = function(e1, t, r, n) {
            var i = [], s = [];
            return i[0] = t[0] - r[0], i[1] = t[1] - r[1], i[2] = t[2] - r[2], s[0] = i[0], s[1] = i[1] * Math.cos(n) - i[2] * Math.sin(n), s[2] = i[1] * Math.sin(n) + i[2] * Math.cos(n), e1[0] = s[0] + r[0], e1[1] = s[1] + r[1], e1[2] = s[2] + r[2], e1;
        }, e1.bH = function(e1, t, r, n) {
            var i = [], s = [];
            return i[0] = t[0] - r[0], i[1] = t[1] - r[1], i[2] = t[2] - r[2], s[0] = i[2] * Math.sin(n) + i[0] * Math.cos(n), s[1] = i[1], s[2] = i[2] * Math.cos(n) - i[0] * Math.sin(n), e1[0] = s[0] + r[0], e1[1] = s[1] + r[1], e1[2] = s[2] + r[2], e1;
        }, e1.bI = function(e1, t, r) {
            var n = Math.sin(r), i = Math.cos(r), s = t[0], o = t[1], a = t[2], l = t[3], u = t[8], c = t[9], h = t[10], p = t[11];
            return t !== e1 && (e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[0] = s * i - u * n, e1[1] = o * i - c * n, e1[2] = a * i - h * n, e1[3] = l * i - p * n, e1[8] = s * n + u * i, e1[9] = o * n + c * i, e1[10] = a * n + h * i, e1[11] = l * n + p * i, e1;
        }, e1.bJ = function(e1, t) {
            const r = D(e1, 360), n = D(t, 360), i = n - r, s = n > r ? i - 360 : i + 360;
            return Math.abs(i) < Math.abs(s) ? i : s;
        }, e1.bK = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1;
        }, e1.bL = function(e1, t, r, n) {
            const i = Math.sqrt(e1 * e1 + t * t), s = Math.sqrt(r * r + n * n);
            e1 /= i, t /= i, r /= s, n /= s;
            const o = Math.acos(e1 * r + t * n);
            return -t * r + e1 * n > 0 ? o : -o;
        }, e1.bM = function(e1, t) {
            const r = D(e1, 2 * Math.PI), n = D(t, 2 * Math.PI);
            return Math.min(Math.abs(r - n), Math.abs(r - n + 2 * Math.PI), Math.abs(r - n - 2 * Math.PI));
        }, e1.bN = function() {
            const e1 = {}, t = xe.$version;
            for(const r in xe.$root){
                const n = xe.$root[r];
                if (n.required) {
                    let i = null;
                    i = "version" === r ? t : "array" === n.type ? [] : {}, null != i && (e1[r] = i);
                }
            }
            return e1;
        }, e1.bO = ce, e1.bP = ds, e1.bQ = function e1(t, r) {
            if (Array.isArray(t)) {
                if (!Array.isArray(r) || t.length !== r.length) return !1;
                for(let n = 0; n < t.length; n++)if (!e1(t[n], r[n])) return !1;
                return !0;
            }
            if ("object" == typeof t && null !== t && null !== r) {
                if ("object" != typeof r) return !1;
                if (Object.keys(t).length !== Object.keys(r).length) return !1;
                for(const n in t)if (!e1(t[n], r[n])) return !1;
                return !0;
            }
            return t === r;
        }, e1.bR = function(e1) {
            e1 = e1.slice();
            const t = Object.create(null);
            for(let r = 0; r < e1.length; r++)t[e1[r].id] = e1[r];
            for(let r = 0; r < e1.length; r++)"ref" in e1[r] && (e1[r] = be(e1[r], t[e1[r].ref]));
            return e1;
        }, e1.bS = function(e1, t) {
            if ("custom" === e1.type) return new mh(e1, t);
            switch(e1.type){
                case "background":
                    return new yh(e1, t);
                case "circle":
                    return new cl(e1, t);
                case "color-relief":
                    return new Fl(e1, t);
                case "fill":
                    return new bu(e1, t);
                case "fill-extrusion":
                    return new Ru(e1, t);
                case "heatmap":
                    return new wl(e1, t);
                case "hillshade":
                    return new Al(e1, t);
                case "line":
                    return new ec(e1, t);
                case "raster":
                    return new Hs(e1, t);
                case "symbol":
                    return new ph(e1, t);
            }
        }, e1.bT = (e1)=>"raster" === e1.type, e1.bU = U, e1.bV = function(e1, t) {
            if (!e1) return [
                {
                    command: "setStyle",
                    args: [
                        t
                    ]
                }
            ];
            let r = [];
            try {
                if (!we(e1.version, t.version)) return [
                    {
                        command: "setStyle",
                        args: [
                            t
                        ]
                    }
                ];
                we(e1.center, t.center) || r.push({
                    command: "setCenter",
                    args: [
                        t.center
                    ]
                }), we(e1.state, t.state) || r.push({
                    command: "setGlobalState",
                    args: [
                        t.state
                    ]
                }), we(e1.centerAltitude, t.centerAltitude) || r.push({
                    command: "setCenterAltitude",
                    args: [
                        t.centerAltitude
                    ]
                }), we(e1.zoom, t.zoom) || r.push({
                    command: "setZoom",
                    args: [
                        t.zoom
                    ]
                }), we(e1.bearing, t.bearing) || r.push({
                    command: "setBearing",
                    args: [
                        t.bearing
                    ]
                }), we(e1.pitch, t.pitch) || r.push({
                    command: "setPitch",
                    args: [
                        t.pitch
                    ]
                }), we(e1.roll, t.roll) || r.push({
                    command: "setRoll",
                    args: [
                        t.roll
                    ]
                }), we(e1.sprite, t.sprite) || r.push({
                    command: "setSprite",
                    args: [
                        t.sprite
                    ]
                }), we(e1.glyphs, t.glyphs) || r.push({
                    command: "setGlyphs",
                    args: [
                        t.glyphs
                    ]
                }), we(e1.transition, t.transition) || r.push({
                    command: "setTransition",
                    args: [
                        t.transition
                    ]
                }), we(e1.light, t.light) || r.push({
                    command: "setLight",
                    args: [
                        t.light
                    ]
                }), we(e1.terrain, t.terrain) || r.push({
                    command: "setTerrain",
                    args: [
                        t.terrain
                    ]
                }), we(e1.sky, t.sky) || r.push({
                    command: "setSky",
                    args: [
                        t.sky
                    ]
                }), we(e1.projection, t.projection) || r.push({
                    command: "setProjection",
                    args: [
                        t.projection
                    ]
                });
                const n = {}, i = [];
                !function(e1, t, r, n) {
                    let i;
                    for(i in t = t || {}, e1 = e1 || {})Object.prototype.hasOwnProperty.call(e1, i) && (Object.prototype.hasOwnProperty.call(t, i) || Ae(i, r, n));
                    for(i in t)Object.prototype.hasOwnProperty.call(t, i) && (Object.prototype.hasOwnProperty.call(e1, i) ? we(e1[i], t[i]) || ("geojson" === e1[i].type && "geojson" === t[i].type && Ie(e1, t, i) ? _e(r, {
                        command: "setGeoJSONSourceData",
                        args: [
                            i,
                            t[i].data
                        ]
                    }) : Te(i, t, r, n)) : Se(i, t, r));
                }(e1.sources, t.sources, i, n);
                const s = [];
                e1.layers && e1.layers.forEach((e1)=>{
                    "source" in e1 && n[e1.source] ? r.push({
                        command: "removeLayer",
                        args: [
                            e1.id
                        ]
                    }) : s.push(e1);
                }), r = r.concat(i), function(e1, t, r) {
                    t = t || [];
                    const n = (e1 = e1 || []).map(Me), i = t.map(Me), s = e1.reduce(ke, {}), o = t.reduce(ke, {}), a = n.slice(), l = Object.create(null);
                    let u, c, h, p, f;
                    for(let e1 = 0, t = 0; e1 < n.length; e1++)u = n[e1], Object.prototype.hasOwnProperty.call(o, u) ? t++ : (_e(r, {
                        command: "removeLayer",
                        args: [
                            u
                        ]
                    }), a.splice(a.indexOf(u, t), 1));
                    for(let e1 = 0, t = 0; e1 < i.length; e1++)u = i[i.length - 1 - e1], a[a.length - 1 - e1] !== u && (Object.prototype.hasOwnProperty.call(s, u) ? (_e(r, {
                        command: "removeLayer",
                        args: [
                            u
                        ]
                    }), a.splice(a.lastIndexOf(u, a.length - t), 1)) : t++, p = a[a.length - e1], _e(r, {
                        command: "addLayer",
                        args: [
                            o[u],
                            p
                        ]
                    }), a.splice(a.length - e1, 0, u), l[u] = !0);
                    for(let e1 = 0; e1 < i.length; e1++)if (u = i[e1], c = s[u], h = o[u], !l[u] && !we(c, h)) {
                        if (we(c.source, h.source) && we(c["source-layer"], h["source-layer"]) && we(c.type, h.type)) {
                            for(f in Ee(c.layout, h.layout, r, u, null, "setLayoutProperty"), Ee(c.paint, h.paint, r, u, null, "setPaintProperty"), we(c.filter, h.filter) || _e(r, {
                                command: "setFilter",
                                args: [
                                    u,
                                    h.filter
                                ]
                            }), we(c.minzoom, h.minzoom) && we(c.maxzoom, h.maxzoom) || _e(r, {
                                command: "setLayerZoomRange",
                                args: [
                                    u,
                                    h.minzoom,
                                    h.maxzoom
                                ]
                            }), c)Object.prototype.hasOwnProperty.call(c, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? Ee(c[f], h[f], r, u, f.slice(6), "setPaintProperty") : we(c[f], h[f]) || _e(r, {
                                command: "setLayerProperty",
                                args: [
                                    u,
                                    f,
                                    h[f]
                                ]
                            }));
                            for(f in h)Object.prototype.hasOwnProperty.call(h, f) && !Object.prototype.hasOwnProperty.call(c, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? Ee(c[f], h[f], r, u, f.slice(6), "setPaintProperty") : we(c[f], h[f]) || _e(r, {
                                command: "setLayerProperty",
                                args: [
                                    u,
                                    f,
                                    h[f]
                                ]
                            }));
                        } else _e(r, {
                            command: "removeLayer",
                            args: [
                                u
                            ]
                        }), p = a[a.lastIndexOf(u) + 1], _e(r, {
                            command: "addLayer",
                            args: [
                                h,
                                p
                            ]
                        });
                    }
                }(s, t.layers, r);
            } catch (e1) {
                console.warn("Unable to compute style diff:", e1), r = [
                    {
                        command: "setStyle",
                        args: [
                            t
                        ]
                    }
                ];
            }
            return r;
        }, e1.bW = function(e1) {
            const t = [], r = e1.id;
            return void 0 === r && t.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === e1.render && t.push({
                message: `layers.${r}: missing required method "render"`
            }), e1.renderingMode && "2d" !== e1.renderingMode && "3d" !== e1.renderingMode && t.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), t;
        }, e1.bX = N, e1.bY = $, e1.bZ = class extends ga {
            constructor(e1, t){
                super(e1, t), this.current = 0;
            }
            set(e1) {
                this.current !== e1 && (this.current = e1, this.gl.uniform1i(this.location, e1));
            }
        }, e1.b_ = ba, e1.ba = function(e1, t) {
            return e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2] + e1[3];
        }, e1.bb = Ph, e1.bc = zh, e1.bd = function(e1, t, r, n, i) {
            var s = 1 / Math.tan(t / 2);
            if (e1[0] = s / r, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = s, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[15] = 0, null != i && i !== 1 / 0) {
                var o = 1 / (n - i);
                e1[10] = (i + n) * o, e1[14] = 2 * i * n * o;
            } else e1[10] = -1, e1[14] = -2 * n;
            return e1;
        }, e1.be = function(e1) {
            var t = new f(16);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t[8] = e1[8], t[9] = e1[9], t[10] = e1[10], t[11] = e1[11], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15], t;
        }, e1.bf = function(e1, t, r) {
            var n = Math.sin(r), i = Math.cos(r), s = t[0], o = t[1], a = t[2], l = t[3], u = t[4], c = t[5], h = t[6], p = t[7];
            return t !== e1 && (e1[8] = t[8], e1[9] = t[9], e1[10] = t[10], e1[11] = t[11], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[0] = s * i + u * n, e1[1] = o * i + c * n, e1[2] = a * i + h * n, e1[3] = l * i + p * n, e1[4] = u * i - s * n, e1[5] = c * i - o * n, e1[6] = h * i - a * n, e1[7] = p * i - l * n, e1;
        }, e1.bg = function(e1, t, r) {
            var n = Math.sin(r), i = Math.cos(r), s = t[4], o = t[5], a = t[6], l = t[7], u = t[8], c = t[9], h = t[10], p = t[11];
            return t !== e1 && (e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[4] = s * i + u * n, e1[5] = o * i + c * n, e1[6] = a * i + h * n, e1[7] = l * i + p * n, e1[8] = u * i - s * n, e1[9] = c * i - o * n, e1[10] = h * i - a * n, e1[11] = p * i - l * n, e1;
        }, e1.bh = function() {
            const e1 = new Float32Array(16);
            return y(e1), e1;
        }, e1.bi = function() {
            const e1 = new Float64Array(16);
            return y(e1), e1;
        }, e1.bj = function() {
            return new Float64Array(16);
        }, e1.bk = function(e1, t, r) {
            const n = new Float64Array(4);
            return I(n, e1, t - 90, r), n;
        }, e1.bl = function(e1, t, r, n) {
            var i, s, o, a, l, u = t[0], c = t[1], h = t[2], f = t[3], d = r[0], y = r[1], m = r[2], g = r[3];
            return (s = u * d + c * y + h * m + f * g) < 0 && (s = -s, d = -d, y = -y, m = -m, g = -g), 1 - s > p ? (i = Math.acos(s), o = Math.sin(i), a = Math.sin((1 - n) * i) / o, l = Math.sin(n * i) / o) : (a = 1 - n, l = n), e1[0] = a * u + l * d, e1[1] = a * c + l * y, e1[2] = a * h + l * m, e1[3] = a * f + l * g, e1;
        }, e1.bm = function(e1) {
            const t = new Float64Array(9);
            var r, n, i, s, o, a, l, u, c, h, p, f, d, y, m, g, x, v;
            h = (i = (n = e1)[0]) * (l = i + i), p = (s = n[1]) * l, d = (o = n[2]) * l, y = o * (u = s + s), g = (a = n[3]) * l, x = a * u, v = a * (c = o + o), (r = t)[0] = 1 - (f = s * u) - (m = o * c), r[3] = p - v, r[6] = d + x, r[1] = p + v, r[4] = 1 - h - m, r[7] = y - g, r[2] = d - x, r[5] = y + g, r[8] = 1 - h - f;
            const b = te(-Math.asin(C(t[2], -1, 1)));
            let w, _;
            return Math.hypot(t[5], t[8]) < .001 ? (w = 0, _ = -te(Math.atan2(t[3], t[4]))) : (w = te(0 === t[5] && 0 === t[8] ? 0 : Math.atan2(t[5], t[8])), _ = te(0 === t[1] && 0 === t[0] ? 0 : Math.atan2(t[1], t[0]))), {
                roll: w,
                pitch: b + 90,
                bearing: _
            };
        }, e1.bn = function(e1, t) {
            return e1.roll == t.roll && e1.pitch == t.pitch && e1.bearing == t.bearing;
        }, e1.bo = It, e1.bp = xa, e1.bq = lu, e1.br = uu, e1.bs = ou, e1.bt = P, e1.bu = B, e1.bv = Ot, e1.bw = function(e1, t, r, n, i) {
            return P(n, i, C((e1 - t) / (r - t), 0, 1));
        }, e1.bx = D, e1.by = function() {
            return new Float64Array(3);
        }, e1.bz = function(e1, t, r, n) {
            return e1[0] = t[0] + r[0] * n, e1[1] = t[1] + r[1] * n, e1[2] = t[2] + r[2] * n, e1;
        }, e1.c = se, e1.c$ = class {
            constructor(e1){
                this._marks = {
                    start: [
                        e1.url,
                        "start"
                    ].join("#"),
                    end: [
                        e1.url,
                        "end"
                    ].join("#"),
                    measure: e1.url.toString()
                }, performance.mark(this._marks.start);
            }
            finish() {
                performance.mark(this._marks.end);
                let e1 = performance.getEntriesByName(this._marks.measure);
                return 0 === e1.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), e1 = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), e1;
            }
        }, e1.c0 = va, e1.c1 = class extends ga {
            constructor(e1, t){
                super(e1, t), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(e1) {
                e1[0] === this.current[0] && e1[1] === this.current[1] && e1[2] === this.current[2] || (this.current = e1, this.gl.uniform3f(this.location, e1[0], e1[1], e1[2]));
            }
        }, e1.c2 = class extends ga {
            constructor(e1, t){
                super(e1, t), this.current = [
                    0,
                    0
                ];
            }
            set(e1) {
                e1[0] === this.current[0] && e1[1] === this.current[1] || (this.current = e1, this.gl.uniform2f(this.location, e1[0], e1[1]));
            }
        }, e1.c3 = d, e1.c4 = function(e1, t) {
            var r = Math.sin(t), n = Math.cos(t);
            return e1[0] = n, e1[1] = r, e1[2] = 0, e1[3] = -r, e1[4] = n, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 1, e1;
        }, e1.c5 = function(e1, t, r) {
            var n = t[0], i = t[1], s = t[2];
            return e1[0] = n * r[0] + i * r[3] + s * r[6], e1[1] = n * r[1] + i * r[4] + s * r[7], e1[2] = n * r[2] + i * r[5] + s * r[8], e1;
        }, e1.c6 = function(e1, t, r, n, i, s, o) {
            var a = 1 / (t - r), l = 1 / (n - i), u = 1 / (s - o);
            return e1[0] = -2 * a, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = -2 * l, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 2 * u, e1[11] = 0, e1[12] = (t + r) * a, e1[13] = (i + n) * l, e1[14] = (o + s) * u, e1[15] = 1, e1;
        }, e1.c7 = class extends ga {
            constructor(e1, t){
                super(e1, t), this.current = new Array;
            }
            set(e1) {
                if (e1 != this.current) {
                    this.current = e1;
                    const t = new Float32Array(4 * e1.length);
                    for(let r = 0; r < e1.length; r++)t[4 * r] = e1[r].r, t[4 * r + 1] = e1[r].g, t[4 * r + 2] = e1[r].b, t[4 * r + 3] = e1[r].a;
                    this.gl.uniform4fv(this.location, t);
                }
            }
        }, e1.c8 = class extends ga {
            constructor(e1, t){
                super(e1, t), this.current = new Array;
            }
            set(e1) {
                if (e1 != this.current) {
                    this.current = e1;
                    const t = new Float32Array(e1);
                    this.gl.uniform1fv(this.location, t);
                }
            }
        }, e1.c9 = class extends yo {
        }, e1.cA = function(e1) {
            return re[e1] || ne[e1];
        }, e1.cB = function(e1, t, r) {
            var n = t[0], i = t[1];
            return e1[0] = r[0] * n + r[4] * i + r[12], e1[1] = r[1] * n + r[5] * i + r[13], e1;
        }, e1.cC = function(e1, t) {
            const { x: r, y: n } = kh.fromLngLat(t);
            return !(e1 < 0 || e1 > 25 || n < 0 || n >= 1 || r < 0 || r >= 1);
        }, e1.cD = function(e1, t) {
            return e1[0] = t[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = t[1], e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = t[2], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, e1.cE = class extends ro {
        }, e1.cF = md, e1.cH = function(e1) {
            return e1.message === ie;
        }, e1.cI = ue, e1.cJ = function(e1, t) {
            oe.REGISTERED_PROTOCOLS[e1] = t;
        }, e1.cK = function(e1) {
            delete oe.REGISTERED_PROTOCOLS[e1];
        }, e1.cL = function(e1, t) {
            const r = {};
            for(let n = 0; n < e1.length; n++){
                const i = t && t[e1[n].id] || wi(e1[n]);
                t && (t[e1[n].id] = i);
                let s = r[i];
                s || (s = r[i] = []), s.push(e1[n]);
            }
            const n = [];
            for(const e1 in r)n.push(r[e1]);
            return n;
        }, e1.cM = ls, e1.cN = Oh, e1.cO = wf, e1.cP = Oc, e1.cQ = function(t) {
            t.bucket.createArrays(), t.bucket.tilePixelRatio = k / (512 * t.bucket.overscaling), t.bucket.compareText = {}, t.bucket.iconsNeedLinear = !1;
            const r = t.bucket.layers[0], n = r.layout, i = r._unevaluatedLayout._values, s = {
                layoutIconSize: i["icon-size"].possiblyEvaluate(new ks(t.bucket.zoom + 1), t.canonical),
                layoutTextSize: i["text-size"].possiblyEvaluate(new ks(t.bucket.zoom + 1), t.canonical),
                textMaxSize: i["text-size"].possiblyEvaluate(new ks(18))
            };
            if ("composite" === t.bucket.textSizeData.kind) {
                const { minZoom: e1, maxZoom: r } = t.bucket.textSizeData;
                s.compositeTextSizes = [
                    i["text-size"].possiblyEvaluate(new ks(e1), t.canonical),
                    i["text-size"].possiblyEvaluate(new ks(r), t.canonical)
                ];
            }
            if ("composite" === t.bucket.iconSizeData.kind) {
                const { minZoom: e1, maxZoom: r } = t.bucket.iconSizeData;
                s.compositeIconSizes = [
                    i["icon-size"].possiblyEvaluate(new ks(e1), t.canonical),
                    i["icon-size"].possiblyEvaluate(new ks(r), t.canonical)
                ];
            }
            const o = n.get("text-line-height") * lc, a = "viewport" !== n.get("text-rotation-alignment") && "point" !== n.get("symbol-placement"), l = n.get("text-keep-upright"), u = n.get("text-size");
            for (const i of t.bucket.features){
                const c = n.get("text-font").evaluate(i, {}, t.canonical).join(","), h = u.evaluate(i, {}, t.canonical), p = s.layoutTextSize.evaluate(i, {}, t.canonical), f = s.layoutIconSize.evaluate(i, {}, t.canonical), d = {
                    horizontal: {},
                    vertical: void 0
                }, y = i.text;
                let m, g = [
                    0,
                    0
                ];
                if (y) {
                    const s = y.toString(), u = n.get("text-letter-spacing").evaluate(i, {}, t.canonical) * lc, f = vs(s) ? u : 0, m = n.get("text-anchor").evaluate(i, {}, t.canonical), x = Wf(r, i, t.canonical);
                    if (!x) {
                        const e1 = n.get("text-radial-offset").evaluate(i, {}, t.canonical);
                        g = e1 ? Kf(m, [
                            e1 * lc,
                            Hf
                        ]) : n.get("text-offset").evaluate(i, {}, t.canonical).map((e1)=>e1 * lc);
                    }
                    let v = a ? "center" : n.get("text-justify").evaluate(i, {}, t.canonical);
                    const b = "point" === n.get("symbol-placement") ? n.get("text-max-width").evaluate(i, {}, t.canonical) * lc : 1 / 0, w = ()=>{
                        t.bucket.allowVerticalPlacement && xs(s) && (d.vertical = Nc(y, t.glyphMap, t.glyphPositions, t.imagePositions, c, b, o, m, "left", f, g, e1.ay.vertical, !0, p, h));
                    };
                    if (!a && x) {
                        const r = new Set;
                        if ("auto" === v) for(let e1 = 0; e1 < x.values.length; e1 += 2)r.add(Jf(x.values[e1]));
                        else r.add(v);
                        let n = !1;
                        for (const i of r)if (!d.horizontal[i]) {
                            if (n) d.horizontal[i] = d.horizontal[0];
                            else {
                                const r = Nc(y, t.glyphMap, t.glyphPositions, t.imagePositions, c, b, o, "center", i, f, g, e1.ay.horizontal, !1, p, h);
                                r && (d.horizontal[i] = r, n = 1 === r.positionedLines.length);
                            }
                        }
                        w();
                    } else {
                        "auto" === v && (v = Jf(m));
                        const r = Nc(y, t.glyphMap, t.glyphPositions, t.imagePositions, c, b, o, m, v, f, g, e1.ay.horizontal, !1, p, h);
                        r && (d.horizontal[v] = r), w(), xs(s) && a && l && (d.vertical = Nc(y, t.glyphMap, t.glyphPositions, t.imagePositions, c, b, o, m, v, f, g, e1.ay.vertical, !1, p, h));
                    }
                }
                let x = !1;
                if (i.icon && i.icon.name) {
                    const e1 = t.imageMap[i.icon.name];
                    e1 && (m = Zc(t.imagePositions[i.icon.name], n.get("icon-offset").evaluate(i, {}, t.canonical), n.get("icon-anchor").evaluate(i, {}, t.canonical)), x = !!e1.sdf, void 0 === t.bucket.sdfIcons ? t.bucket.sdfIcons = x : t.bucket.sdfIcons !== x && j("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (e1.pixelRatio !== t.bucket.pixelRatio || 0 !== n.get("icon-rotate").constantOr(1)) && (t.bucket.iconsNeedLinear = !0));
                }
                const v = td(d.horizontal) || d.vertical;
                t.bucket.iconsInText = !!v && v.iconsInText, (v || m) && Qf(t.bucket, i, d, m, t.imageMap, s, p, f, g, x, t.canonical, t.subdivisionGranularity);
            }
            t.showCollisionBoxes && t.bucket.generateCollisionDebugBuffers();
        }, e1.cR = mu, e1.cS = Bu, e1.cT = Zu, e1.cU = Eu, e1.cV = wc, e1.cW = Au, e1.cX = function(e1, t, r, n, i, s) {
            let o = Tf(e1, t, r, i, 0);
            return o = Tf(o, t, n, s, 1), o;
        }, e1.cY = class {
            constructor(e1){
                this.maxEntries = e1, this.map = new Map;
            }
            get(e1) {
                const t = this.map.get(e1);
                return void 0 !== t && (this.map.delete(e1), this.map.set(e1, t)), t;
            }
            set(e1, t) {
                if (this.map.has(e1)) this.map.delete(e1);
                else if (this.map.size >= this.maxEntries) {
                    const e1 = this.map.keys().next().value;
                    this.map.delete(e1);
                }
                this.map.set(e1, t);
            }
            clear() {
                this.map.clear();
            }
        }, e1.cZ = ku, e1.c_ = xf, e1.ca = oc, e1.cb = class extends go {
        }, e1.cc = bl, e1.cd = function(e1) {
            return e1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(e1) / Math.LN2));
        }, e1.ce = vl, e1.cf = function(e1, t, r) {
            var n = t[0], i = t[1], s = t[2], o = r[3] * n + r[7] * i + r[11] * s + r[15];
            return e1[0] = (r[0] * n + r[4] * i + r[8] * s + r[12]) / (o = o || 1), e1[1] = (r[1] * n + r[5] * i + r[9] * s + r[13]) / o, e1[2] = (r[2] * n + r[6] * i + r[10] * s + r[14]) / o, e1;
        }, e1.cg = class extends no {
        }, e1.ch = class extends Ao {
        }, e1.ci = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && e1[4] === t[4] && e1[5] === t[5] && e1[6] === t[6] && e1[7] === t[7] && e1[8] === t[8] && e1[9] === t[9] && e1[10] === t[10] && e1[11] === t[11] && e1[12] === t[12] && e1[13] === t[13] && e1[14] === t[14] && e1[15] === t[15];
        }, e1.cj = function(e1, t) {
            var r = e1[0], n = e1[1], i = e1[2], s = e1[3], o = e1[4], a = e1[5], l = e1[6], u = e1[7], c = e1[8], h = e1[9], f = e1[10], d = e1[11], y = e1[12], m = e1[13], g = e1[14], x = e1[15], v = t[0], b = t[1], w = t[2], _ = t[3], S = t[4], A = t[5], T = t[6], I = t[7], E = t[8], M = t[9], k = t[10], F = t[11], D = t[12], P = t[13], B = t[14], z = t[15];
            return Math.abs(r - v) <= p * Math.max(1, Math.abs(r), Math.abs(v)) && Math.abs(n - b) <= p * Math.max(1, Math.abs(n), Math.abs(b)) && Math.abs(i - w) <= p * Math.max(1, Math.abs(i), Math.abs(w)) && Math.abs(s - _) <= p * Math.max(1, Math.abs(s), Math.abs(_)) && Math.abs(o - S) <= p * Math.max(1, Math.abs(o), Math.abs(S)) && Math.abs(a - A) <= p * Math.max(1, Math.abs(a), Math.abs(A)) && Math.abs(l - T) <= p * Math.max(1, Math.abs(l), Math.abs(T)) && Math.abs(u - I) <= p * Math.max(1, Math.abs(u), Math.abs(I)) && Math.abs(c - E) <= p * Math.max(1, Math.abs(c), Math.abs(E)) && Math.abs(h - M) <= p * Math.max(1, Math.abs(h), Math.abs(M)) && Math.abs(f - k) <= p * Math.max(1, Math.abs(f), Math.abs(k)) && Math.abs(d - F) <= p * Math.max(1, Math.abs(d), Math.abs(F)) && Math.abs(y - D) <= p * Math.max(1, Math.abs(y), Math.abs(D)) && Math.abs(m - P) <= p * Math.max(1, Math.abs(m), Math.abs(P)) && Math.abs(g - B) <= p * Math.max(1, Math.abs(g), Math.abs(B)) && Math.abs(x - z) <= p * Math.max(1, Math.abs(x), Math.abs(z));
        }, e1.ck = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1[8] = t[8], e1[9] = t[9], e1[10] = t[10], e1[11] = t[11], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15], e1;
        }, e1.cl = (e1)=>"symbol" === e1.type, e1.cm = (e1)=>"circle" === e1.type, e1.cn = (e1)=>"heatmap" === e1.type, e1.co = (e1)=>"line" === e1.type, e1.cp = (e1)=>"fill" === e1.type, e1.cq = (e1)=>"fill-extrusion" === e1.type, e1.cr = (e1)=>"hillshade" === e1.type, e1.cs = (e1)=>"color-relief" === e1.type, e1.ct = (e1)=>"background" === e1.type, e1.cu = (e1)=>"custom" === e1.type, e1.cv = z, e1.cw = function(e1, t, r) {
            const n = M(t.x - r.x, t.y - r.y), i = M(e1.x - r.x, e1.y - r.y);
            var s, o;
            return te(Math.atan2(n[0] * i[1] - n[1] * i[0], (s = n)[0] * (o = i)[0] + s[1] * o[1]));
        }, e1.cx = V, e1.cy = function(e1, t) {
            return ne[t] && (e1 instanceof MouseEvent || e1 instanceof WheelEvent);
        }, e1.cz = function(e1, t) {
            return re[t] && "touches" in e1;
        }, e1.d = pe, e1.d0 = function(e1, r, n, i, s) {
            return t(this, void 0, void 0, function*() {
                if (h()) try {
                    return yield K(e1, r, n, i, s);
                } catch (e1) {}
                return function(e1, t, r, n, i) {
                    const s = e1.width, o = e1.height;
                    W && J || (W = new OffscreenCanvas(s, o), J = W.getContext("2d", {
                        willReadFrequently: !0
                    })), W.width = s, W.height = o, J.drawImage(e1, 0, 0, s, o);
                    const a = J.getImageData(t, r, n, i);
                    return J.clearRect(0, 0, s, o), a.data;
                }(e1, r, n, i, s);
            });
        }, e1.d1 = Ml, e1.d2 = n, e1.d3 = ri, e1.d4 = Ms, e1.e = O, e1.f = (e1)=>t(void 0, void 0, void 0, function*() {
                if (0 === e1.byteLength) return createImageBitmap(new ImageData(1, 1));
                const t = new Blob([
                    new Uint8Array(e1)
                ], {
                    type: "image/png"
                });
                try {
                    return createImageBitmap(t);
                } catch (e1) {
                    throw new Error(`Could not load image because of ${e1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
                }
            }), e1.g = ae, e1.h = (e1)=>new Promise((t, r)=>{
                const n = new Image;
                n.onload = ()=>{
                    t(n), URL.revokeObjectURL(n.src), n.onload = null, window.requestAnimationFrame(()=>{
                        n.src = H;
                    });
                }, n.onerror = ()=>r(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                const i = new Blob([
                    new Uint8Array(e1)
                ], {
                    type: "image/png"
                });
                n.src = e1.byteLength ? URL.createObjectURL(i) : H;
            }), e1.i = X, e1.j = (e1, t)=>he(O(e1, {
                type: "json"
            }), t), e1.k = me, e1.l = ye, e1.m = he, e1.n = (e1, t)=>he(O(e1, {
                type: "arrayBuffer"
            }), t), e1.o = function(e1) {
            return new wc(e1).readFields(Bc, []);
        }, e1.p = Cc, e1.q = function(e1) {
            return /[\u02EA\u02EB\u1100-\u11FF\u2E80-\u2FDF\u3000-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(e1));
        }, e1.r = gl, e1.s = Q, e1.t = Gs, e1.u = xe, e1.v = Qi, e1.w = j, e1.x = zs, e1.y = ts, e1.z = Ds;
    });
    define("worker", [
        "./shared"
    ], function(e1) {
        "use strict";
        class t {
            constructor(e1, t){
                this.keyCache = {}, e1 && this.replace(e1, t);
            }
            replace(e1, t) {
                this._layerConfigs = {}, this._layers = {}, this.update(e1, [], t);
            }
            update(t, i, o) {
                for (const i of t){
                    this._layerConfigs[i.id] = i;
                    const t = this._layers[i.id] = e1.bS(i, o);
                    t._featureFilter = e1.aj(t.filter, o), this.keyCache[i.id] && delete this.keyCache[i.id];
                }
                for (const e1 of i)delete this.keyCache[e1], delete this._layerConfigs[e1], delete this._layers[e1];
                this.familiesBySource = {};
                const s = e1.cL(Object.values(this._layerConfigs), this.keyCache);
                for (const t of s){
                    const i = t.map((e1)=>this._layers[e1.id]), o = i[0];
                    if ("none" === o.visibility) continue;
                    const s = o.source || "";
                    let n = this.familiesBySource[s];
                    n || (n = this.familiesBySource[s] = {});
                    const r = o.sourceLayer || e1.a9;
                    let a = n[r];
                    a || (a = n[r] = []), a.push(i);
                }
            }
        }
        class i {
            constructor(t){
                const i = {}, o = [];
                for(const e1 in t){
                    const s = t[e1], n = i[e1] = {};
                    for(const e1 in s){
                        const t = s[+e1];
                        if (!t || 0 === t.bitmap.width || 0 === t.bitmap.height) continue;
                        const i = {
                            x: 0,
                            y: 0,
                            w: t.bitmap.width + 2,
                            h: t.bitmap.height + 2
                        };
                        o.push(i), n[e1] = {
                            rect: i,
                            metrics: t.metrics
                        };
                    }
                }
                const { w: s, h: n } = e1.p(o), r = new e1.r({
                    width: s || 1,
                    height: n || 1
                });
                for(const o in t){
                    const s = t[o];
                    for(const t in s){
                        const n = s[+t];
                        if (!n || 0 === n.bitmap.width || 0 === n.bitmap.height) continue;
                        const a = i[o][t].rect;
                        e1.r.copy(n.bitmap, r, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + 1,
                            y: a.y + 1
                        }, n.bitmap);
                    }
                }
                this.image = r, this.positions = i;
            }
        }
        e1.cM("GlyphAtlas", i);
        class o {
            constructor(t){
                this.tileID = new e1.a1(t.tileID.overscaledZ, t.tileID.wrap, t.tileID.canonical.z, t.tileID.canonical.x, t.tileID.canonical.y), this.uid = t.uid, this.zoom = t.zoom, this.pixelRatio = t.pixelRatio, this.tileSize = t.tileSize, this.source = t.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t.showCollisionBoxes, this.collectResourceTiming = !!t.collectResourceTiming, this.returnDependencies = !!t.returnDependencies, this.promoteId = t.promoteId, this.inFlightDependencies = [];
            }
            parse(t, o, n, r, a) {
                return e1._(this, void 0, void 0, function*() {
                    this.status = "parsing", this.data = t, this.collisionBoxArray = new e1.ah;
                    const l = new e1.cN(Object.keys(t.layers).sort()), c = new e1.cO(this.tileID, this.promoteId);
                    c.bucketLayerIDs = [];
                    const h = {}, u = {
                        featureIndex: c,
                        iconDependencies: {},
                        patternDependencies: {},
                        glyphDependencies: {},
                        dashDependencies: {},
                        availableImages: n,
                        subdivisionGranularity: a
                    }, d = o.familiesBySource[this.source];
                    for(const i in d){
                        const o = t.layers[i];
                        if (!o) continue;
                        1 === o.version && e1.w(`Vector tile source "${this.source}" layer "${i}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                        const r = l.encode(i), a = [];
                        for(let e1 = 0; e1 < o.length; e1++){
                            const t = o.feature(e1), s = c.getId(t, i);
                            a.push({
                                feature: t,
                                id: s,
                                index: e1,
                                sourceLayerIndex: r
                            });
                        }
                        for (const t of d[i]){
                            const i = t[0];
                            i.source !== this.source && e1.w(`layer.source = ${i.source} does not equal this.source = ${this.source}`), i.isHidden(this.zoom, !0) || (s(t, this.zoom, n), (h[i.id] = i.createBucket({
                                index: c.bucketLayerIDs.length,
                                layers: t,
                                zoom: this.zoom,
                                pixelRatio: this.pixelRatio,
                                overscaling: this.overscaling,
                                collisionBoxArray: this.collisionBoxArray,
                                sourceLayerIndex: r,
                                sourceID: this.source
                            })).populate(a, u, this.tileID.canonical), c.bucketLayerIDs.push(t.map((e1)=>e1.id)));
                        }
                    }
                    const f = e1.bX(u.glyphDependencies, (e1)=>Object.keys(e1).map(Number));
                    this.inFlightDependencies.forEach((e1)=>null == e1 ? void 0 : e1.abort()), this.inFlightDependencies = [];
                    let g = Promise.resolve({});
                    if (Object.keys(f).length) {
                        const e1 = new AbortController;
                        this.inFlightDependencies.push(e1), g = r.sendAsync({
                            type: "GG",
                            data: {
                                stacks: f,
                                source: this.source,
                                tileID: this.tileID,
                                type: "glyphs"
                            }
                        }, e1);
                    }
                    const p = Object.keys(u.iconDependencies);
                    let m = Promise.resolve({});
                    if (p.length) {
                        const e1 = new AbortController;
                        this.inFlightDependencies.push(e1), m = r.sendAsync({
                            type: "GI",
                            data: {
                                icons: p,
                                source: this.source,
                                tileID: this.tileID,
                                type: "icons"
                            }
                        }, e1);
                    }
                    const y = Object.keys(u.patternDependencies);
                    let v = Promise.resolve({});
                    if (y.length) {
                        const e1 = new AbortController;
                        this.inFlightDependencies.push(e1), v = r.sendAsync({
                            type: "GI",
                            data: {
                                icons: y,
                                source: this.source,
                                tileID: this.tileID,
                                type: "patterns"
                            }
                        }, e1);
                    }
                    const w = u.dashDependencies;
                    let x = Promise.resolve({});
                    if (Object.keys(w).length) {
                        const e1 = new AbortController;
                        this.inFlightDependencies.push(e1), x = r.sendAsync({
                            type: "GDA",
                            data: {
                                dashes: w
                            }
                        }, e1);
                    }
                    const [_, S, b, M] = yield Promise.all([
                        g,
                        m,
                        v,
                        x
                    ]), I = new i(_), P = new e1.cP(S, b);
                    for(const t in h){
                        const i = h[t];
                        i instanceof e1.ai ? (s(i.layers, this.zoom, n), e1.cQ({
                            bucket: i,
                            glyphMap: _,
                            glyphPositions: I.positions,
                            imageMap: S,
                            imagePositions: P.iconPositions,
                            showCollisionBoxes: this.showCollisionBoxes,
                            canonical: this.tileID.canonical,
                            subdivisionGranularity: u.subdivisionGranularity
                        })) : i.hasDependencies && (i instanceof e1.cR || i instanceof e1.cS || i instanceof e1.cT) && (s(i.layers, this.zoom, n), i.addFeatures(u, this.tileID.canonical, P.patternPositions, M));
                    }
                    return this.status = "done", {
                        buckets: Object.values(h).filter((e1)=>!e1.isEmpty()),
                        featureIndex: c,
                        collisionBoxArray: this.collisionBoxArray,
                        glyphAtlasImage: I.image,
                        imageAtlas: P,
                        dashPositions: M,
                        glyphMap: this.returnDependencies ? _ : null,
                        iconMap: this.returnDependencies ? S : null,
                        glyphPositions: this.returnDependencies ? I.positions : null
                    };
                });
            }
        }
        function s(t, i, o) {
            const s = new e1.H(i);
            for (const e1 of t)e1.recalculate(s, o);
        }
        class n extends e1.cW {
            constructor(t, i){
                super(new e1.cV, 0, i, [], []), this.feature = t, this.type = t.type, this.properties = t.tags ? t.tags : {}, "id" in t && ("string" == typeof t.id ? this.id = parseInt(t.id, 10) : "number" != typeof t.id || isNaN(t.id) || (this.id = t.id));
            }
            loadGeometry() {
                const t = [], i = 1 === this.feature.type ? [
                    this.feature.geometry
                ] : this.feature.geometry;
                for (const o of i){
                    const i = [];
                    for (const t of o)i.push(new e1.P(t[0], t[1]));
                    t.push(i);
                }
                return t;
            }
        }
        class r extends e1.cU {
            constructor(t, i){
                super(new e1.cV), this.layers = {
                    _geojsonTileLayer: this
                }, this.name = "_geojsonTileLayer", this.version = i ? i.version : 1, this.extent = i ? i.extent : 4096, this.length = t.length, this.features = t;
            }
            feature(e1) {
                return new n(this.features[e1], this.extent);
            }
        }
        function a(e1, t) {
            t.writeVarintField(15, e1.version || 1), t.writeStringField(1, e1.name || ""), t.writeVarintField(5, e1.extent || 4096);
            const i = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(let o = 0; o < e1.length; o++)i.feature = e1.feature(o), t.writeMessage(2, l, i);
            const o = i.keys;
            for (const e1 of o)t.writeStringField(3, e1);
            const s = i.values;
            for (const e1 of s)t.writeMessage(4, f, e1);
        }
        function l(e1, t) {
            if (!e1.feature) return;
            const i = e1.feature;
            void 0 !== i.id && t.writeVarintField(1, i.id), t.writeMessage(2, c, e1), t.writeVarintField(3, i.type), t.writeMessage(4, d, i);
        }
        function c(e1, t) {
            for(const i in e1.feature?.properties){
                let o = e1.feature.properties[i], s = e1.keycache[i];
                if (null === o) continue;
                void 0 === s && (e1.keys.push(i), s = e1.keys.length - 1, e1.keycache[i] = s), t.writeVarint(s), "string" != typeof o && "boolean" != typeof o && "number" != typeof o && (o = JSON.stringify(o));
                const n = typeof o + ":" + o;
                let r = e1.valuecache[n];
                void 0 === r && (e1.values.push(o), r = e1.values.length - 1, e1.valuecache[n] = r), t.writeVarint(r);
            }
        }
        function h(e1, t) {
            return (t << 3) + (7 & e1);
        }
        function u(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function d(e1, t) {
            const i = e1.loadGeometry(), o = e1.type;
            let s = 0, n = 0;
            for (const r of i){
                let i = 1;
                1 === o && (i = r.length), t.writeVarint(h(1, i));
                const a = 3 === o ? r.length - 1 : r.length;
                for(let e1 = 0; e1 < a; e1++){
                    1 === e1 && 1 !== o && t.writeVarint(h(2, a - 1));
                    const i = r[e1].x - s, l = r[e1].y - n;
                    t.writeVarint(u(i)), t.writeVarint(u(l)), s += i, n += l;
                }
                3 === e1.type && t.writeVarint(h(7, 1));
            }
        }
        function f(e1, t) {
            const i = typeof e1;
            "string" === i ? t.writeStringField(1, e1) : "boolean" === i ? t.writeBooleanField(7, e1) : "number" === i && (e1 % 1 != 0 ? t.writeDoubleField(3, e1) : e1 < 0 ? t.writeSVarintField(6, e1) : t.writeVarintField(5, e1));
        }
        class g extends e1.cW {
            constructor(t, i, o, s, n){
                super(new e1.cV, 0, n, [], []), this.type = t, this.properties = o || {}, this.extent = n, this.pointsArray = i, this.id = s;
            }
            loadGeometry() {
                return this.pointsArray.map((t)=>t.map((t)=>new e1.P(t.x, t.y)));
            }
        }
        class p extends e1.cU {
            constructor(t, i, o){
                super(new e1.cV), this.version = 2, this._myFeatures = t, this.name = i, this.length = t.length, this.extent = o;
            }
            feature(e1) {
                return this._myFeatures[e1];
            }
        }
        class m {
            constructor(){
                this.layers = {};
            }
            addLayer(e1) {
                this.layers[e1.name] = e1;
            }
        }
        function y(t) {
            let i = function(t) {
                const i = new e1.cV;
                return function(e1, t) {
                    for(const i in e1.layers)t.writeMessage(3, a, e1.layers[i]);
                }(t, i), i.finish();
            }(t);
            return 0 === i.byteOffset && i.byteLength === i.buffer.byteLength || (i = new Uint8Array(i)), {
                vectorTile: t,
                rawData: i.buffer
            };
        }
        function v(t, i, o) {
            const { extent: s } = t, n = Math.pow(2, o.z - i.z), r = (o.x - i.x * n) * s, a = (o.y - i.y * n) * s, l = [];
            for(let i = 0; i < t.length; i++){
                const o = t.feature(i);
                let c = o.loadGeometry();
                for (const e1 of c)for (const t of e1)t.x = t.x * n - r, t.y = t.y * n - a;
                const h = 128;
                c = e1.cX(c, o.type, -h, -h, s + h, s + h), 0 !== c.length && l.push(new g(o.type, c, o.properties, o.id, s));
            }
            return new p(l, t.name, s);
        }
        class w {
            constructor(t, i, o){
                this.actor = t, this.layerIndex = i, this.availableImages = o, this.fetching = {}, this.loading = {}, this.loaded = {}, this.overzoomedTileResultCache = new e1.cY(1e3);
            }
            loadVectorTile(t, i) {
                return e1._(this, void 0, void 0, function*() {
                    const o = yield e1.n(t.request, i);
                    try {
                        return {
                            vectorTile: "mlt" !== t.encoding ? new e1.cZ(new e1.cV(o.data)) : new e1.c_(o.data),
                            rawData: o.data,
                            cacheControl: o.cacheControl,
                            expires: o.expires
                        };
                    } catch (e1) {
                        const i = new Uint8Array(o.data);
                        let s = `Unable to parse the tile at ${t.request.url}, `;
                        throw s += 31 === i[0] && 139 === i[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${e1.message}`, new Error(s);
                    }
                });
            }
            loadTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    const { uid: i, overzoomParameters: s } = t;
                    s && (t.request = s.overzoomRequest);
                    const n = !!(t && t.request && t.request.collectResourceTiming) && new e1.c$(t.request), r = new o(t);
                    this.loading[i] = r;
                    const a = new AbortController;
                    r.abort = a;
                    try {
                        const o = yield this.loadVectorTile(t, a);
                        if (delete this.loading[i], !o) return null;
                        if (s) {
                            const e1 = this._getOverzoomTile(t, o.vectorTile);
                            o.rawData = e1.rawData, o.vectorTile = e1.vectorTile;
                        }
                        const l = o.rawData, c = {};
                        o.expires && (c.expires = o.expires), o.cacheControl && (c.cacheControl = o.cacheControl);
                        const h = {};
                        if (n) {
                            const e1 = n.finish();
                            e1 && (h.resourceTiming = JSON.parse(JSON.stringify(e1)));
                        }
                        r.vectorTile = o.vectorTile;
                        const u = r.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, t.subdivisionGranularity);
                        this.loaded[i] = r, this.fetching[i] = {
                            rawTileData: l,
                            cacheControl: c,
                            resourceTiming: h
                        };
                        try {
                            const i = yield u;
                            return e1.e({
                                rawTileData: l.slice(0),
                                encoding: t.encoding
                            }, i, c, h);
                        } finally{
                            delete this.fetching[i];
                        }
                    } catch (e1) {
                        throw delete this.loading[i], r.status = "done", this.loaded[i] = r, e1;
                    }
                });
            }
            _getOverzoomTile(e1, t) {
                const { tileID: i, source: o, overzoomParameters: s } = e1, { maxZoomTileID: n } = s, r = `${n.key}_${i.key}`, a = this.overzoomedTileResultCache.get(r);
                if (a) return a;
                const l = new m, c = this.layerIndex.familiesBySource[o];
                for(const e1 in c){
                    const o = t.layers[e1];
                    if (!o) continue;
                    const s = v(o, n, i.canonical);
                    s.length > 0 && l.addLayer(s);
                }
                const h = y(l);
                return this.overzoomedTileResultCache.set(r, h), h;
            }
            reloadTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    const i = t.uid;
                    if (!this.loaded || !this.loaded[i]) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                    const o = this.loaded[i];
                    if (o.showCollisionBoxes = t.showCollisionBoxes, "parsing" === o.status) {
                        const s = yield o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, t.subdivisionGranularity);
                        let n;
                        if (this.fetching[i]) {
                            const { rawTileData: o, cacheControl: r, resourceTiming: a } = this.fetching[i];
                            delete this.fetching[i], n = e1.e({
                                rawTileData: o.slice(0),
                                encoding: t.encoding
                            }, s, r, a);
                        } else n = s;
                        return n;
                    }
                    if ("done" === o.status && o.vectorTile) return o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, t.subdivisionGranularity);
                });
            }
            abortTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    const e1 = this.loading, i = t.uid;
                    e1 && e1[i] && e1[i].abort && (e1[i].abort.abort(), delete e1[i]);
                });
            }
            removeTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    this.loaded && this.loaded[t.uid] && delete this.loaded[t.uid];
                });
            }
        }
        class x {
            constructor(){
                this.loaded = {};
            }
            loadTile(t) {
                return e1._(this, void 0, void 0, function*() {
                    const { uid: i, encoding: o, rawImageData: s, redFactor: n, greenFactor: r, blueFactor: a, baseShift: l } = t, c = s.width + 2, h = s.height + 2, u = e1.b(s) ? new e1.R({
                        width: c,
                        height: h
                    }, (yield e1.d0(s, -1, -1, c, h))) : s, d = new e1.d1(i, u, o, n, r, a, l);
                    return this.loaded = this.loaded || {}, this.loaded[i] = d, d;
                });
            }
            removeTile(e1) {
                const t = this.loaded, i = e1.uid;
                t && t[i] && delete t[i];
            }
        }
        var _, S, b = function() {
            if (S) return _;
            function e1(e1, i) {
                if (0 !== e1.length) {
                    t(e1[0], i);
                    for(var o = 1; o < e1.length; o++)t(e1[o], !i);
                }
            }
            function t(e1, t) {
                for(var i = 0, o = 0, s = 0, n = e1.length, r = n - 1; s < n; r = s++){
                    var a = (e1[s][0] - e1[r][0]) * (e1[r][1] + e1[s][1]), l = i + a;
                    o += Math.abs(i) >= Math.abs(a) ? i - l + a : a - l + i, i = l;
                }
                i + o >= 0 != !!t && e1.reverse();
            }
            return S = 1, _ = function t(i, o) {
                var s, n = i && i.type;
                if ("FeatureCollection" === n) for(s = 0; s < i.features.length; s++)t(i.features[s], o);
                else if ("GeometryCollection" === n) for(s = 0; s < i.geometries.length; s++)t(i.geometries[s], o);
                else if ("Feature" === n) t(i.geometry, o);
                else if ("Polygon" === n) e1(i.coordinates, o);
                else if ("MultiPolygon" === n) for(s = 0; s < i.coordinates.length; s++)e1(i.coordinates[s], o);
                return i;
            };
        }(), M = e1.d2(b);
        const I = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e1)=>e1
        }, P = Math.fround || (k = new Float32Array(1), (e1)=>(k[0] = +e1, k[0]));
        var k;
        class D {
            constructor(e1){
                this.options = Object.assign(Object.create(I), e1), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e1) {
                const { log: t, minZoom: i, maxZoom: o } = this.options;
                t && console.time("total time");
                const s = `prepare ${e1.length} points`;
                t && console.time(s), this.points = e1;
                const n = [];
                for(let t = 0; t < e1.length; t++){
                    const i = e1[t];
                    if (!i.geometry) continue;
                    const [o, s] = i.geometry.coordinates, r = P(L(o)), a = P(O(s));
                    n.push(r, a, 1 / 0, t, -1, 1), this.options.reduce && n.push(0);
                }
                let r = this.trees[o + 1] = this._createTree(n);
                t && console.timeEnd(s);
                for(let e1 = o; e1 >= i; e1--){
                    const i = +Date.now();
                    r = this.trees[e1] = this._createTree(this._cluster(r, e1)), t && console.log("z%d: %d clusters in %dms", e1, r.numItems, +Date.now() - i);
                }
                return t && console.timeEnd("total time"), this;
            }
            getClusters(e1, t) {
                let i = ((e1[0] + 180) % 360 + 360) % 360 - 180;
                const o = Math.max(-90, Math.min(90, e1[1]));
                let s = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
                const n = Math.max(-90, Math.min(90, e1[3]));
                if (e1[2] - e1[0] >= 360) i = -180, s = 180;
                else if (i > s) {
                    const e1 = this.getClusters([
                        i,
                        o,
                        180,
                        n
                    ], t), r = this.getClusters([
                        -180,
                        o,
                        s,
                        n
                    ], t);
                    return e1.concat(r);
                }
                const r = this.trees[this._limitZoom(t)], a = r.range(L(i), O(n), L(s), O(o)), l = r.data, c = [];
                for (const e1 of a){
                    const t = this.stride * e1;
                    c.push(l[t + 5] > 1 ? T(l, t, this.clusterProps) : this.points[l[t + 3]]);
                }
                return c;
            }
            getChildren(e1) {
                const t = this._getOriginId(e1), i = this._getOriginZoom(e1), o = "No cluster with the specified id.", s = this.trees[i];
                if (!s) throw new Error(o);
                const n = s.data;
                if (t * this.stride >= n.length) throw new Error(o);
                const r = this.options.radius / (this.options.extent * Math.pow(2, i - 1)), a = s.within(n[t * this.stride], n[t * this.stride + 1], r), l = [];
                for (const t of a){
                    const i = t * this.stride;
                    n[i + 4] === e1 && l.push(n[i + 5] > 1 ? T(n, i, this.clusterProps) : this.points[n[i + 3]]);
                }
                if (0 === l.length) throw new Error(o);
                return l;
            }
            getLeaves(e1, t, i) {
                const o = [];
                return this._appendLeaves(o, e1, t = t || 10, i = i || 0, 0), o;
            }
            getTile(e1, t, i) {
                const o = this.trees[this._limitZoom(e1)], s = Math.pow(2, e1), { extent: n, radius: r } = this.options, a = r / n, l = (i - a) / s, c = (i + 1 + a) / s, h = {
                    features: []
                };
                return this._addTileFeatures(o.range((t - a) / s, l, (t + 1 + a) / s, c), o.data, t, i, s, h), 0 === t && this._addTileFeatures(o.range(1 - a / s, l, 1, c), o.data, s, i, s, h), t === s - 1 && this._addTileFeatures(o.range(0, l, a / s, c), o.data, -1, i, s, h), h.features.length ? h : null;
            }
            getClusterExpansionZoom(e1) {
                let t = this._getOriginZoom(e1) - 1;
                for(; t <= this.options.maxZoom;){
                    const i = this.getChildren(e1);
                    if (t++, 1 !== i.length) break;
                    e1 = i[0].properties.cluster_id;
                }
                return t;
            }
            _appendLeaves(e1, t, i, o, s) {
                const n = this.getChildren(t);
                for (const t of n){
                    const n = t.properties;
                    if (n && n.cluster ? s + n.point_count <= o ? s += n.point_count : s = this._appendLeaves(e1, n.cluster_id, i, o, s) : s < o ? s++ : e1.push(t), e1.length === i) break;
                }
                return s;
            }
            _createTree(t) {
                const i = new e1.aS(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e1 = 0; e1 < t.length; e1 += this.stride)i.add(t[e1], t[e1 + 1]);
                return i.finish(), i.data = t, i;
            }
            _addTileFeatures(e1, t, i, o, s, n) {
                for (const r of e1){
                    const e1 = r * this.stride, a = t[e1 + 5] > 1;
                    let l, c, h;
                    if (a) l = C(t, e1, this.clusterProps), c = t[e1], h = t[e1 + 1];
                    else {
                        const i = this.points[t[e1 + 3]];
                        l = i.properties;
                        const [o, s] = i.geometry.coordinates;
                        c = L(o), h = O(s);
                    }
                    const u = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * s - i)),
                                Math.round(this.options.extent * (h * s - o))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t[e1 + 3] : this.points[t[e1 + 3]].id, void 0 !== d && (u.id = d), n.features.push(u);
                }
            }
            _limitZoom(e1) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e1), this.options.maxZoom + 1));
            }
            _cluster(e1, t) {
                const { radius: i, extent: o, reduce: s, minPoints: n } = this.options, r = i / (o * Math.pow(2, t)), a = e1.data, l = [], c = this.stride;
                for(let i = 0; i < a.length; i += c){
                    if (a[i + 2] <= t) continue;
                    a[i + 2] = t;
                    const o = a[i], h = a[i + 1], u = e1.within(a[i], a[i + 1], r), d = a[i + 5];
                    let f = d;
                    for (const e1 of u){
                        const i = e1 * c;
                        a[i + 2] > t && (f += a[i + 5]);
                    }
                    if (f > d && f >= n) {
                        let e1, n = o * d, r = h * d, g = -1;
                        const p = (i / c << 5) + (t + 1) + this.points.length;
                        for (const o of u){
                            const l = o * c;
                            if (a[l + 2] <= t) continue;
                            a[l + 2] = t;
                            const h = a[l + 5];
                            n += a[l] * h, r += a[l + 1] * h, a[l + 4] = p, s && (e1 || (e1 = this._map(a, i, !0), g = this.clusterProps.length, this.clusterProps.push(e1)), s(e1, this._map(a, l)));
                        }
                        a[i + 4] = p, l.push(n / f, r / f, 1 / 0, p, -1, f), s && l.push(g);
                    } else {
                        for(let e1 = 0; e1 < c; e1++)l.push(a[i + e1]);
                        if (f > 1) for (const e1 of u){
                            const i = e1 * c;
                            if (!(a[i + 2] <= t)) {
                                a[i + 2] = t;
                                for(let e1 = 0; e1 < c; e1++)l.push(a[i + e1]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e1) {
                return e1 - this.points.length >> 5;
            }
            _getOriginZoom(e1) {
                return (e1 - this.points.length) % 32;
            }
            _map(e1, t, i) {
                if (e1[t + 5] > 1) {
                    const o = this.clusterProps[e1[t + 6]];
                    return i ? Object.assign({}, o) : o;
                }
                const o = this.points[e1[t + 3]].properties, s = this.options.map(o);
                return i && s === o ? Object.assign({}, s) : s;
            }
        }
        function T(e1, t, i) {
            var o;
            return {
                type: "Feature",
                id: e1[t + 3],
                properties: C(e1, t, i),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (o = e1[t], 360 * (o - .5)),
                        F(e1[t + 1])
                    ]
                }
            };
        }
        function C(e1, t, i) {
            const o = e1[t + 5], s = o >= 1e4 ? `${Math.round(o / 1e3)}k` : o >= 1e3 ? Math.round(o / 100) / 10 + "k" : o, n = e1[t + 6], r = -1 === n ? {} : Object.assign({}, i[n]);
            return Object.assign(r, {
                cluster: !0,
                cluster_id: e1[t + 3],
                point_count: o,
                point_count_abbreviated: s
            });
        }
        function L(e1) {
            return e1 / 360 + .5;
        }
        function O(e1) {
            const t = Math.sin(e1 * Math.PI / 180), i = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return i < 0 ? 0 : i > 1 ? 1 : i;
        }
        function F(e1) {
            const t = (180 - 360 * e1) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
        }
        function z(e1, t, i, o) {
            let s = o;
            const n = t + (i - t >> 1);
            let r, a = i - t;
            const l = e1[t], c = e1[t + 1], h = e1[i], u = e1[i + 1];
            for(let o = t + 3; o < i; o += 3){
                const t = G(e1[o], e1[o + 1], l, c, h, u);
                if (t > s) r = o, s = t;
                else if (t === s) {
                    const e1 = Math.abs(o - n);
                    e1 < a && (r = o, a = e1);
                }
            }
            s > o && (r - t > 3 && z(e1, t, r, o), e1[r + 2] = s, i - r > 3 && z(e1, r, i, o));
        }
        function G(e1, t, i, o, s, n) {
            let r = s - i, a = n - o;
            if (0 !== r || 0 !== a) {
                const l = ((e1 - i) * r + (t - o) * a) / (r * r + a * a);
                l > 1 ? (i = s, o = n) : l > 0 && (i += r * l, o += a * l);
            }
            return r = e1 - i, a = t - o, r * r + a * a;
        }
        function A(e1, t, i, o) {
            const s = {
                id: null == e1 ? null : e1,
                type: t,
                geometry: i,
                tags: o,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            if ("Point" === t || "MultiPoint" === t || "LineString" === t) Z(s, i);
            else if ("Polygon" === t) Z(s, i[0]);
            else if ("MultiLineString" === t) for (const e1 of i)Z(s, e1);
            else if ("MultiPolygon" === t) for (const e1 of i)Z(s, e1[0]);
            return s;
        }
        function Z(e1, t) {
            for(let i = 0; i < t.length; i += 3)e1.minX = Math.min(e1.minX, t[i]), e1.minY = Math.min(e1.minY, t[i + 1]), e1.maxX = Math.max(e1.maxX, t[i]), e1.maxY = Math.max(e1.maxY, t[i + 1]);
        }
        function N(e1, t, i, o) {
            if (!t.geometry) return;
            const s = t.geometry.coordinates;
            if (s && 0 === s.length) return;
            const n = t.geometry.type, r = Math.pow(i.tolerance / ((1 << i.maxZoom) * i.extent), 2);
            let a = [], l = t.id;
            if (i.promoteId ? l = t.properties[i.promoteId] : i.generateId && (l = o || 0), "Point" === n) R(s, a);
            else if ("MultiPoint" === n) for (const e1 of s)R(e1, a);
            else if ("LineString" === n) j(s, a, r, !1);
            else if ("MultiLineString" === n) {
                if (i.lineMetrics) {
                    for (const i of s)a = [], j(i, a, r, !1), e1.push(A(l, "LineString", a, t.properties));
                    return;
                }
                E(s, a, r, !1);
            } else if ("Polygon" === n) E(s, a, r, !0);
            else {
                if ("MultiPolygon" !== n) {
                    if ("GeometryCollection" === n) {
                        for (const s of t.geometry.geometries)N(e1, {
                            id: l,
                            geometry: s,
                            properties: t.properties
                        }, i, o);
                        return;
                    }
                    throw new Error("Input data is not a valid GeoJSON object.");
                }
                for (const e1 of s){
                    const t = [];
                    E(e1, t, r, !0), a.push(t);
                }
            }
            e1.push(A(l, n, a, t.properties));
        }
        function R(e1, t) {
            t.push(W(e1[0]), J(e1[1]), 0);
        }
        function j(e1, t, i, o) {
            let s, n, r = 0;
            for(let i = 0; i < e1.length; i++){
                const a = W(e1[i][0]), l = J(e1[i][1]);
                t.push(a, l, 0), i > 0 && (r += o ? (s * l - a * n) / 2 : Math.sqrt(Math.pow(a - s, 2) + Math.pow(l - n, 2))), s = a, n = l;
            }
            const a = t.length - 3;
            t[2] = 1, z(t, 0, a, i), t[a + 2] = 1, t.size = Math.abs(r), t.start = 0, t.end = t.size;
        }
        function E(e1, t, i, o) {
            for(let s = 0; s < e1.length; s++){
                const n = [];
                j(e1[s], n, i, o), t.push(n);
            }
        }
        function W(e1) {
            return e1 / 360 + .5;
        }
        function J(e1) {
            const t = Math.sin(e1 * Math.PI / 180), i = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return i < 0 ? 0 : i > 1 ? 1 : i;
        }
        function Y(e1, t, i, o, s, n, r, a) {
            if (o /= t, n >= (i /= t) && r < o) return e1;
            if (r < i || n >= o) return null;
            const l = [];
            for (const t of e1){
                const e1 = t.geometry;
                let n = t.type;
                const r = 0 === s ? t.minX : t.minY, c = 0 === s ? t.maxX : t.maxY;
                if (r >= i && c < o) {
                    l.push(t);
                    continue;
                }
                if (c < i || r >= o) continue;
                let h = [];
                if ("Point" === n || "MultiPoint" === n) V(e1, h, i, o, s);
                else if ("LineString" === n) H(e1, h, i, o, s, !1, a.lineMetrics);
                else if ("MultiLineString" === n) X(e1, h, i, o, s, !1);
                else if ("Polygon" === n) X(e1, h, i, o, s, !0);
                else if ("MultiPolygon" === n) for (const t of e1){
                    const e1 = [];
                    X(t, e1, i, o, s, !0), e1.length && h.push(e1);
                }
                if (h.length) {
                    if (a.lineMetrics && "LineString" === n) {
                        for (const e1 of h)l.push(A(t.id, n, e1, t.tags));
                        continue;
                    }
                    "LineString" !== n && "MultiLineString" !== n || (1 === h.length ? (n = "LineString", h = h[0]) : n = "MultiLineString"), "Point" !== n && "MultiPoint" !== n || (n = 3 === h.length ? "Point" : "MultiPoint"), l.push(A(t.id, n, h, t.tags));
                }
            }
            return l.length ? l : null;
        }
        function V(e1, t, i, o, s) {
            for(let n = 0; n < e1.length; n += 3){
                const r = e1[n + s];
                r >= i && r <= o && B(t, e1[n], e1[n + 1], e1[n + 2]);
            }
        }
        function H(e1, t, i, o, s, n, r) {
            let a = q(e1);
            const l = 0 === s ? $ : U;
            let c, h, u = e1.start;
            for(let d = 0; d < e1.length - 3; d += 3){
                const f = e1[d], g = e1[d + 1], p = e1[d + 2], m = e1[d + 3], y = e1[d + 4], v = 0 === s ? f : g, w = 0 === s ? m : y;
                let x = !1;
                r && (c = Math.sqrt(Math.pow(f - m, 2) + Math.pow(g - y, 2))), v < i ? w > i && (h = l(a, f, g, m, y, i), r && (a.start = u + c * h)) : v > o ? w < o && (h = l(a, f, g, m, y, o), r && (a.start = u + c * h)) : B(a, f, g, p), w < i && v >= i && (h = l(a, f, g, m, y, i), x = !0), w > o && v <= o && (h = l(a, f, g, m, y, o), x = !0), !n && x && (r && (a.end = u + c * h), t.push(a), a = q(e1)), r && (u += c);
            }
            let d = e1.length - 3;
            const f = e1[d], g = e1[d + 1], p = 0 === s ? f : g;
            p >= i && p <= o && B(a, f, g, e1[d + 2]), d = a.length - 3, n && d >= 3 && (a[d] !== a[0] || a[d + 1] !== a[1]) && B(a, a[0], a[1], a[2]), a.length && t.push(a);
        }
        function q(e1) {
            const t = [];
            return t.size = e1.size, t.start = e1.start, t.end = e1.end, t;
        }
        function X(e1, t, i, o, s, n) {
            for (const r of e1)H(r, t, i, o, s, n, !1);
        }
        function B(e1, t, i, o) {
            e1.push(t, i, o);
        }
        function $(e1, t, i, o, s, n) {
            const r = (n - t) / (o - t);
            return B(e1, n, i + (s - i) * r, 1), r;
        }
        function U(e1, t, i, o, s, n) {
            const r = (n - i) / (s - i);
            return B(e1, t + (o - t) * r, n, 1), r;
        }
        function K(e1, t) {
            const i = [];
            for(let o = 0; o < e1.length; o++){
                const s = e1[o], n = s.type;
                let r;
                if ("Point" === n || "MultiPoint" === n || "LineString" === n) r = Q(s.geometry, t);
                else if ("MultiLineString" === n || "Polygon" === n) {
                    r = [];
                    for (const e1 of s.geometry)r.push(Q(e1, t));
                } else if ("MultiPolygon" === n) {
                    r = [];
                    for (const e1 of s.geometry){
                        const i = [];
                        for (const o of e1)i.push(Q(o, t));
                        r.push(i);
                    }
                }
                i.push(A(s.id, n, r, s.tags));
            }
            return i;
        }
        function Q(e1, t) {
            const i = [];
            i.size = e1.size, void 0 !== e1.start && (i.start = e1.start, i.end = e1.end);
            for(let o = 0; o < e1.length; o += 3)i.push(e1[o] + t, e1[o + 1], e1[o + 2]);
            return i;
        }
        function ee(e1, t) {
            if (e1.transformed) return e1;
            const i = 1 << e1.z, o = e1.x, s = e1.y;
            for (const n of e1.features){
                const e1 = n.geometry, r = n.type;
                if (n.geometry = [], 1 === r) for(let r = 0; r < e1.length; r += 2)n.geometry.push(te(e1[r], e1[r + 1], t, i, o, s));
                else for(let r = 0; r < e1.length; r++){
                    const a = [];
                    for(let n = 0; n < e1[r].length; n += 2)a.push(te(e1[r][n], e1[r][n + 1], t, i, o, s));
                    n.geometry.push(a);
                }
            }
            return e1.transformed = !0, e1;
        }
        function te(e1, t, i, o, s, n) {
            return [
                Math.round(i * (e1 * o - s)),
                Math.round(i * (t * o - n))
            ];
        }
        function ie(e1, t, i, o, s) {
            const n = t === s.maxZoom ? 0 : s.tolerance / ((1 << t) * s.extent), r = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: e1.length,
                source: null,
                x: i,
                y: o,
                z: t,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            };
            for (const t of e1)oe(r, t, n, s);
            return r;
        }
        function oe(e1, t, i, o) {
            const s = t.geometry, n = t.type, r = [];
            if (e1.minX = Math.min(e1.minX, t.minX), e1.minY = Math.min(e1.minY, t.minY), e1.maxX = Math.max(e1.maxX, t.maxX), e1.maxY = Math.max(e1.maxY, t.maxY), "Point" === n || "MultiPoint" === n) for(let t = 0; t < s.length; t += 3)r.push(s[t], s[t + 1]), e1.numPoints++, e1.numSimplified++;
            else if ("LineString" === n) se(r, s, e1, i, !1, !1);
            else if ("MultiLineString" === n || "Polygon" === n) for(let t = 0; t < s.length; t++)se(r, s[t], e1, i, "Polygon" === n, 0 === t);
            else if ("MultiPolygon" === n) for(let t = 0; t < s.length; t++){
                const o = s[t];
                for(let t = 0; t < o.length; t++)se(r, o[t], e1, i, !0, 0 === t);
            }
            if (r.length) {
                let i = t.tags || null;
                if ("LineString" === n && o.lineMetrics) {
                    i = {};
                    for(const e1 in t.tags)i[e1] = t.tags[e1];
                    i.mapbox_clip_start = s.start / s.size, i.mapbox_clip_end = s.end / s.size;
                }
                const a = {
                    geometry: r,
                    type: "Polygon" === n || "MultiPolygon" === n ? 3 : "LineString" === n || "MultiLineString" === n ? 2 : 1,
                    tags: i
                };
                null !== t.id && (a.id = t.id), e1.features.push(a);
            }
        }
        function se(e1, t, i, o, s, n) {
            const r = o * o;
            if (o > 0 && t.size < (s ? r : o)) return void (i.numPoints += t.length / 3);
            const a = [];
            for(let e1 = 0; e1 < t.length; e1 += 3)(0 === o || t[e1 + 2] > r) && (i.numSimplified++, a.push(t[e1], t[e1 + 1])), i.numPoints++;
            s && function(e1, t) {
                let i = 0;
                for(let t = 0, o = e1.length, s = o - 2; t < o; s = t, t += 2)i += (e1[t] - e1[s]) * (e1[t + 1] + e1[s + 1]);
                if (i > 0 === t) for(let t = 0, i = e1.length; t < i / 2; t += 2){
                    const o = e1[t], s = e1[t + 1];
                    e1[t] = e1[i - 2 - t], e1[t + 1] = e1[i - 1 - t], e1[i - 2 - t] = o, e1[i - 1 - t] = s;
                }
            }(a, n), e1.push(a);
        }
        const ne = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        };
        class re {
            constructor(e1, t){
                const i = (t = this.options = function(e1, t) {
                    for(const i in t)e1[i] = t[i];
                    return e1;
                }(Object.create(ne), t)).debug;
                if (i && console.time("preprocess data"), t.maxZoom < 0 || t.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t.promoteId && t.generateId) throw new Error("promoteId and generateId cannot be used together.");
                let o = function(e1, t) {
                    const i = [];
                    if ("FeatureCollection" === e1.type) for(let o = 0; o < e1.features.length; o++)N(i, e1.features[o], t, o);
                    else N(i, "Feature" === e1.type ? e1 : {
                        geometry: e1
                    }, t);
                    return i;
                }(e1, t);
                this.tiles = {}, this.tileCoords = [], i && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t.indexMaxZoom, t.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), o = function(e1, t) {
                    const i = t.buffer / t.extent;
                    let o = e1;
                    const s = Y(e1, 1, -1 - i, i, 0, -1, 2, t), n = Y(e1, 1, 1 - i, 2 + i, 0, -1, 2, t);
                    return (s || n) && (o = Y(e1, 1, -i, 1 + i, 0, -1, 2, t) || [], s && (o = K(s, 1).concat(o)), n && (o = o.concat(K(n, -1)))), o;
                }(o, t), o.length && this.splitTile(o, 0, 0, 0), i && (o.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            splitTile(e1, t, i, o, s, n, r) {
                const a = [
                    e1,
                    t,
                    i,
                    o
                ], l = this.options, c = l.debug;
                for(; a.length;){
                    o = a.pop(), i = a.pop(), t = a.pop(), e1 = a.pop();
                    const h = 1 << t, u = ae(t, i, o);
                    let d = this.tiles[u];
                    if (!d && (c > 1 && console.time("creation"), d = this.tiles[u] = ie(e1, t, i, o, l), this.tileCoords.push({
                        z: t,
                        x: i,
                        y: o
                    }), c)) {
                        c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t, i, o, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                        const e1 = `z${t}`;
                        this.stats[e1] = (this.stats[e1] || 0) + 1, this.total++;
                    }
                    if (d.source = e1, null == s) {
                        if (t === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                    } else {
                        if (t === l.maxZoom || t === s) continue;
                        if (null != s) {
                            const e1 = s - t;
                            if (i !== n >> e1 || o !== r >> e1) continue;
                        }
                    }
                    if (d.source = null, 0 === e1.length) continue;
                    c > 1 && console.time("clipping");
                    const f = .5 * l.buffer / l.extent, g = .5 - f, p = .5 + f, m = 1 + f;
                    let y = null, v = null, w = null, x = null, _ = Y(e1, h, i - f, i + p, 0, d.minX, d.maxX, l), S = Y(e1, h, i + g, i + m, 0, d.minX, d.maxX, l);
                    e1 = null, _ && (y = Y(_, h, o - f, o + p, 1, d.minY, d.maxY, l), v = Y(_, h, o + g, o + m, 1, d.minY, d.maxY, l), _ = null), S && (w = Y(S, h, o - f, o + p, 1, d.minY, d.maxY, l), x = Y(S, h, o + g, o + m, 1, d.minY, d.maxY, l), S = null), c > 1 && console.timeEnd("clipping"), a.push(y || [], t + 1, 2 * i, 2 * o), a.push(v || [], t + 1, 2 * i, 2 * o + 1), a.push(w || [], t + 1, 2 * i + 1, 2 * o), a.push(x || [], t + 1, 2 * i + 1, 2 * o + 1);
                }
            }
            getTile(e1, t, i) {
                e1 = +e1, t = +t, i = +i;
                const o = this.options, { extent: s, debug: n } = o;
                if (e1 < 0 || e1 > 24) return null;
                const r = 1 << e1, a = ae(e1, t = t + r & r - 1, i);
                if (this.tiles[a]) return ee(this.tiles[a], s);
                n > 1 && console.log("drilling down to z%d-%d-%d", e1, t, i);
                let l, c = e1, h = t, u = i;
                for(; !l && c > 0;)c--, h >>= 1, u >>= 1, l = this.tiles[ae(c, h, u)];
                return l && l.source ? (n > 1 && (console.log("found parent tile z%d-%d-%d", c, h, u), console.time("drilling down")), this.splitTile(l.source, c, h, u, e1, t, i), n > 1 && console.timeEnd("drilling down"), this.tiles[a] ? ee(this.tiles[a], s) : null) : null;
            }
        }
        function ae(e1, t, i) {
            return 32 * ((1 << e1) * i + t) + e1;
        }
        class le extends w {
            constructor(e1, t, i, o = ce){
                super(e1, t, i), this._dataUpdateable = new Map, this._createGeoJSONIndex = o;
            }
            loadVectorTile(t, i) {
                return e1._(this, void 0, void 0, function*() {
                    const i = t.tileID.canonical;
                    if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
                    const o = this._geoJSONIndex.getTile(i.z, i.x, i.y);
                    return o ? y(new r(o.features, {
                        version: 2,
                        extent: e1.a4
                    })) : null;
                });
            }
            loadData(t) {
                return e1._(this, void 0, void 0, function*() {
                    var i;
                    null === (i = this._pendingRequest) || void 0 === i || i.abort();
                    const o = this._startPerformance(t);
                    this._pendingRequest = new AbortController;
                    try {
                        (!this._pendingData || t.request || t.data || t.dataDiff) && (this._pendingData = this.loadAndProcessGeoJSON(t, this._pendingRequest));
                        const i = yield this._pendingData;
                        this._geoJSONIndex = this._createGeoJSONIndex(i, t), this.loaded = {};
                        const s = t.dataDiff && e1.a6(i) ? {
                            applyDiff: !0
                        } : {
                            data: i
                        };
                        return this._finishPerformance(o, t, s), s;
                    } catch (t) {
                        if (delete this._pendingRequest, e1.cH(t)) return {
                            abandoned: !0
                        };
                        throw t;
                    }
                });
            }
            _startPerformance(t) {
                var i;
                if (null === (i = null == t ? void 0 : t.request) || void 0 === i ? void 0 : i.collectResourceTiming) return new e1.c$(t.request);
            }
            _finishPerformance(e1, t, i) {
                if (!e1) return;
                const o = e1.finish();
                o && (i.resourceTiming = {}, i.resourceTiming[t.source] = JSON.parse(JSON.stringify(o)));
            }
            getData() {
                return e1._(this, void 0, void 0, function*() {
                    return this._pendingData;
                });
            }
            reloadTile(e1) {
                const t = this.loaded;
                return t && t[e1.uid] ? super.reloadTile(e1) : this.loadTile(e1);
            }
            loadAndProcessGeoJSON(t, i) {
                return e1._(this, void 0, void 0, function*() {
                    let e1;
                    if (t.request ? e1 = yield this.loadGeoJSONFromUrl(t.request, t.promoteId, i) : t.data ? e1 = this._loadGeoJSONFromObject(t.data, t.promoteId) : t.dataDiff && (e1 = this._loadGeoJSONFromDiff(t.dataDiff, t.promoteId, t.source)), delete this._pendingRequest, "object" != typeof e1) throw new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`);
                    return M(e1, !0), t.filter && (e1 = this._filterGeoJSON(e1, t.filter)), e1;
                });
            }
            loadGeoJSONFromUrl(t, i, o) {
                return e1._(this, void 0, void 0, function*() {
                    const s = yield e1.j(t, o);
                    return this._dataUpdateable = e1.a6(s.data, i) ? e1.a7(s.data, i) : void 0, s.data;
                });
            }
            _loadGeoJSONFromObject(t, i) {
                return this._dataUpdateable = e1.a6(t, i) ? e1.a7(t, i) : void 0, t;
            }
            _loadGeoJSONFromDiff(t, i, o) {
                if (!this._dataUpdateable) throw new Error(`Cannot update existing geojson data in ${o}`);
                e1.a8(this._dataUpdateable, t, i);
                const s = Array.from(this._dataUpdateable.values());
                return this._toFeatureCollection(s);
            }
            _filterGeoJSON(t, i) {
                const o = e1.d3(i, {
                    type: "boolean",
                    "property-type": "data-driven",
                    overridable: !1,
                    transition: !1
                });
                if ("error" === o.result) throw new Error(o.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                const s = t.features.filter((e1)=>o.value.evaluate({
                        zoom: 0
                    }, e1));
                return this._toFeatureCollection(s);
            }
            _toFeatureCollection(e1) {
                return {
                    type: "FeatureCollection",
                    features: e1
                };
            }
            removeSource(t) {
                return e1._(this, void 0, void 0, function*() {
                    this._pendingRequest && this._pendingRequest.abort();
                });
            }
            getClusterExpansionZoom(e1) {
                return this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId);
            }
            getClusterChildren(e1) {
                return this._geoJSONIndex.getChildren(e1.clusterId);
            }
            getClusterLeaves(e1) {
                return this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset);
            }
        }
        function ce(t, i) {
            return i.cluster ? new D(function({ superclusterOptions: t, clusterProperties: i }) {
                if (!i || !t) return t;
                const o = {}, s = {}, n = {
                    accumulated: null,
                    zoom: 0
                }, r = {
                    properties: null
                }, a = Object.keys(i);
                for (const t of a){
                    const [n, r] = i[t], a = e1.d3(r), l = e1.d3("string" == typeof n ? [
                        n,
                        [
                            "accumulated"
                        ],
                        [
                            "get",
                            t
                        ]
                    ] : n);
                    o[t] = a.value, s[t] = l.value;
                }
                return t.map = (e1)=>{
                    r.properties = e1;
                    const t = {};
                    for (const e1 of a)t[e1] = o[e1].evaluate(n, r);
                    return t;
                }, t.reduce = (e1, t)=>{
                    r.properties = t;
                    for (const t of a)n.accumulated = e1[t], e1[t] = s[t].evaluate(n, r);
                }, t;
            }(i)).load(t.features) : function(e1, t) {
                return new re(e1, t);
            }(t, i.geojsonVtOptions);
        }
        class he {
            constructor(t){
                this.self = t, this.actor = new e1.L(t), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.globalStates = new Map, this.self.registerWorkerSource = (e1, t)=>{
                    if (this.externalWorkerSourceTypes[e1]) throw new Error(`Worker source with name "${e1}" already registered.`);
                    this.externalWorkerSourceTypes[e1] = t;
                }, this.self.addProtocol = e1.cJ, this.self.removeProtocol = e1.cK, this.self.registerRTLTextPlugin = (t)=>{
                    e1.d4.setMethods(t);
                }, this.actor.registerMessageHandler("LDT", (e1, t)=>this._getDEMWorkerSource(e1, t.source).loadTile(t)), this.actor.registerMessageHandler("RDT", (t, i)=>e1._(this, void 0, void 0, function*() {
                        this._getDEMWorkerSource(t, i.source).removeTile(i);
                    })), this.actor.registerMessageHandler("GCEZ", (t, i)=>e1._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, i.type, i.source).getClusterExpansionZoom(i);
                    })), this.actor.registerMessageHandler("GCC", (t, i)=>e1._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, i.type, i.source).getClusterChildren(i);
                    })), this.actor.registerMessageHandler("GCL", (t, i)=>e1._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, i.type, i.source).getClusterLeaves(i);
                    })), this.actor.registerMessageHandler("LD", (e1, t)=>this._getWorkerSource(e1, t.type, t.source).loadData(t)), this.actor.registerMessageHandler("GD", (e1, t)=>this._getWorkerSource(e1, t.type, t.source).getData()), this.actor.registerMessageHandler("LT", (e1, t)=>this._getWorkerSource(e1, t.type, t.source).loadTile(t)), this.actor.registerMessageHandler("RT", (e1, t)=>this._getWorkerSource(e1, t.type, t.source).reloadTile(t)), this.actor.registerMessageHandler("AT", (e1, t)=>this._getWorkerSource(e1, t.type, t.source).abortTile(t)), this.actor.registerMessageHandler("RMT", (e1, t)=>this._getWorkerSource(e1, t.type, t.source).removeTile(t)), this.actor.registerMessageHandler("RS", (t, i)=>e1._(this, void 0, void 0, function*() {
                        if (!this.workerSources[t] || !this.workerSources[t][i.type] || !this.workerSources[t][i.type][i.source]) return;
                        const e1 = this.workerSources[t][i.type][i.source];
                        delete this.workerSources[t][i.type][i.source], void 0 !== e1.removeSource && e1.removeSource(i);
                    })), this.actor.registerMessageHandler("RM", (t)=>e1._(this, void 0, void 0, function*() {
                        delete this.layerIndexes[t], delete this.availableImages[t], delete this.workerSources[t], delete this.demWorkerSources[t], this.globalStates.delete(t);
                    })), this.actor.registerMessageHandler("SR", (t, i)=>e1._(this, void 0, void 0, function*() {
                        this.referrer = i;
                    })), this.actor.registerMessageHandler("SRPS", (e1, t)=>this._syncRTLPluginState(e1, t)), this.actor.registerMessageHandler("IS", (t, i)=>e1._(this, void 0, void 0, function*() {
                        this.self.importScripts(i);
                    })), this.actor.registerMessageHandler("SI", (e1, t)=>this._setImages(e1, t)), this.actor.registerMessageHandler("UL", (t, i)=>e1._(this, void 0, void 0, function*() {
                        this._getLayerIndex(t).update(i.layers, i.removedIds, this._getGlobalState(t));
                    })), this.actor.registerMessageHandler("UGS", (t, i)=>e1._(this, void 0, void 0, function*() {
                        const e1 = this._getGlobalState(t);
                        for(const t in i)e1[t] = i[t];
                    })), this.actor.registerMessageHandler("SL", (t, i)=>e1._(this, void 0, void 0, function*() {
                        this._getLayerIndex(t).replace(i, this._getGlobalState(t));
                    }));
            }
            _getGlobalState(e1) {
                let t = this.globalStates.get(e1);
                return t || (t = {}, this.globalStates.set(e1, t)), t;
            }
            _setImages(t, i) {
                return e1._(this, void 0, void 0, function*() {
                    this.availableImages[t] = i;
                    for(const e1 in this.workerSources[t]){
                        const o = this.workerSources[t][e1];
                        for(const e1 in o)o[e1].availableImages = i;
                    }
                });
            }
            _syncRTLPluginState(t, i) {
                return e1._(this, void 0, void 0, function*() {
                    return yield e1.d4.syncState(i, this.self.importScripts);
                });
            }
            _getAvailableImages(e1) {
                let t = this.availableImages[e1];
                return t || (t = []), t;
            }
            _getLayerIndex(e1) {
                let i = this.layerIndexes[e1];
                return i || (i = this.layerIndexes[e1] = new t), i;
            }
            _getWorkerSource(e1, t, i) {
                if (this.workerSources[e1] || (this.workerSources[e1] = {}), this.workerSources[e1][t] || (this.workerSources[e1][t] = {}), !this.workerSources[e1][t][i]) {
                    const o = {
                        sendAsync: (t, i)=>(t.targetMapId = e1, this.actor.sendAsync(t, i))
                    };
                    switch(t){
                        case "vector":
                            this.workerSources[e1][t][i] = new w(o, this._getLayerIndex(e1), this._getAvailableImages(e1));
                            break;
                        case "geojson":
                            this.workerSources[e1][t][i] = new le(o, this._getLayerIndex(e1), this._getAvailableImages(e1));
                            break;
                        default:
                            this.workerSources[e1][t][i] = new this.externalWorkerSourceTypes[t](o, this._getLayerIndex(e1), this._getAvailableImages(e1));
                    }
                }
                return this.workerSources[e1][t][i];
            }
            _getDEMWorkerSource(e1, t) {
                return this.demWorkerSources[e1] || (this.demWorkerSources[e1] = {}), this.demWorkerSources[e1][t] || (this.demWorkerSources[e1][t] = new x), this.demWorkerSources[e1][t];
            }
        }
        return e1.i(self) && (self.worker = new he(self)), he;
    });
    define("index", [
        "exports",
        "./shared"
    ], function(e1, t) {
        "use strict";
        var i = "5.13.0";
        function a() {
            var e1 = new t.A(4);
            return t.A != Float32Array && (e1[1] = 0, e1[2] = 0), e1[0] = 1, e1[3] = 1, e1;
        }
        let r, o, s;
        const n = {
            frame (e1, i, a) {
                const r = requestAnimationFrame((e1)=>{
                    o(), i(e1);
                }), { unsubscribe: o } = t.s(e1.signal, "abort", ()=>{
                    o(), cancelAnimationFrame(r), a(t.c());
                }, !1);
            },
            frameAsync (e1) {
                return new Promise((t, i)=>{
                    this.frame(e1, t, i);
                });
            },
            getImageData (e1, t = 0) {
                return this.getImageCanvasContext(e1).getImageData(-t, -t, e1.width + 2 * t, e1.height + 2 * t);
            },
            getImageCanvasContext (e1) {
                const t = window.document.createElement("canvas"), i = t.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!i) throw new Error("failed to create canvas 2d context");
                return t.width = e1.width, t.height = e1.height, i.drawImage(e1, 0, 0, e1.width, e1.height), i;
            },
            resolveURL: (e1)=>(r || (r = document.createElement("a")), r.href = e1, r.href),
            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
            get prefersReducedMotion () {
                return void 0 !== s ? s : !!matchMedia && (null == o && (o = matchMedia("(prefers-reduced-motion: reduce)")), o.matches);
            },
            set prefersReducedMotion (e){
                s = e;
            }
        }, l = new class {
            constructor(){
                this._realTime = "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date), this._frozenAt = null;
            }
            getCurrentTime() {
                return null !== this._frozenAt ? this._frozenAt : this._realTime();
            }
            setNow(e1) {
                this._frozenAt = e1;
            }
            restoreNow() {
                this._frozenAt = null;
            }
            isFrozen() {
                return null !== this._frozenAt;
            }
        };
        function c() {
            return l.getCurrentTime();
        }
        class h {
            static testProp(e1) {
                if (!h.docStyle) return e1[0];
                for(let t = 0; t < e1.length; t++)if (e1[t] in h.docStyle) return e1[t];
                return e1[0];
            }
            static create(e1, t, i) {
                const a = window.document.createElement(e1);
                return void 0 !== t && (a.className = t), i && i.appendChild(a), a;
            }
            static createNS(e1, t) {
                return window.document.createElementNS(e1, t);
            }
            static disableDrag() {
                h.docStyle && h.selectProp && (h.userSelect = h.docStyle[h.selectProp], h.docStyle[h.selectProp] = "none");
            }
            static enableDrag() {
                h.docStyle && h.selectProp && (h.docStyle[h.selectProp] = h.userSelect);
            }
            static setTransform(e1, t) {
                e1.style[h.transformProp] = t;
            }
            static addEventListener(e1, t, i, a = {}) {
                e1.addEventListener(t, i, "passive" in a ? a : a.capture);
            }
            static removeEventListener(e1, t, i, a = {}) {
                e1.removeEventListener(t, i, "passive" in a ? a : a.capture);
            }
            static suppressClickInternal(e1) {
                e1.preventDefault(), e1.stopPropagation(), window.removeEventListener("click", h.suppressClickInternal, !0);
            }
            static suppressClick() {
                window.addEventListener("click", h.suppressClickInternal, !0), window.setTimeout(()=>{
                    window.removeEventListener("click", h.suppressClickInternal, !0);
                }, 0);
            }
            static getScale(e1) {
                const t = e1.getBoundingClientRect();
                return {
                    x: t.width / e1.offsetWidth || 1,
                    y: t.height / e1.offsetHeight || 1,
                    boundingClientRect: t
                };
            }
            static getPoint(e1, i, a) {
                const r = i.boundingClientRect;
                return new t.P((a.clientX - r.left) / i.x - e1.clientLeft, (a.clientY - r.top) / i.y - e1.clientTop);
            }
            static mousePos(e1, t) {
                const i = h.getScale(e1);
                return h.getPoint(e1, i, t);
            }
            static touchPos(e1, t) {
                const i = [], a = h.getScale(e1);
                for(let r = 0; r < t.length; r++)i.push(h.getPoint(e1, a, t[r]));
                return i;
            }
            static mouseButton(e1) {
                return e1.button;
            }
            static remove(e1) {
                e1.parentNode && e1.parentNode.removeChild(e1);
            }
            static sanitize(e1) {
                const t = (new DOMParser).parseFromString(e1, "text/html").body || document.createElement("body"), i = t.querySelectorAll("script");
                for (const e1 of i)e1.remove();
                return h.clean(t), t.innerHTML;
            }
            static isPossiblyDangerous(e1, t) {
                const i = t.replace(/\s+/g, "").toLowerCase();
                return !(![
                    "src",
                    "href",
                    "xlink:href"
                ].includes(e1) || !i.includes("javascript:") && !i.includes("data:")) || !!e1.startsWith("on") || void 0;
            }
            static clean(e1) {
                const t = e1.children;
                for (const e1 of t)h.removeAttributes(e1), h.clean(e1);
            }
            static removeAttributes(e1) {
                for (const { name: t, value: i } of e1.attributes)h.isPossiblyDangerous(t, i) && e1.removeAttribute(t);
            }
        }
        h.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, h.selectProp = h.testProp([
            "userSelect",
            "MozUserSelect",
            "WebkitUserSelect",
            "msUserSelect"
        ]), h.transformProp = h.testProp([
            "transform",
            "WebkitTransform"
        ]);
        const u = {
            supported: !1,
            testSupport: function(e1) {
                !p && _ && (m ? f(e1) : d = e1);
            }
        };
        let d, _, p = !1, m = !1;
        function f(e1) {
            const t = e1.createTexture();
            e1.bindTexture(e1.TEXTURE_2D, t);
            try {
                if (e1.texImage2D(e1.TEXTURE_2D, 0, e1.RGBA, e1.RGBA, e1.UNSIGNED_BYTE, _), e1.isContextLost()) return;
                u.supported = !0;
            } catch (e1) {}
            e1.deleteTexture(t), p = !0;
        }
        var g;
        "undefined" != typeof document && (_ = document.createElement("img"), _.onload = ()=>{
            d && f(d), d = null, m = !0;
        }, _.onerror = ()=>{
            p = !0, d = null;
        }, _.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(e1) {
            let i, a, r, o;
            e1.resetRequestQueue = ()=>{
                i = [], a = 0, r = 0, o = {};
            }, e1.addThrottleControl = (e1)=>{
                const t = r++;
                return o[t] = e1, t;
            }, e1.removeThrottleControl = (e1)=>{
                delete o[e1], n();
            }, e1.getImage = (e1, a, r = !0)=>new Promise((o, s)=>{
                    u.supported && (e1.headers || (e1.headers = {}), e1.headers.accept = "image/webp,*/*"), t.e(e1, {
                        type: "image"
                    }), i.push({
                        abortController: a,
                        requestParameters: e1,
                        supportImageRefresh: r,
                        state: "queued",
                        onError: (e1)=>{
                            s(e1);
                        },
                        onSuccess: (e1)=>{
                            o(e1);
                        }
                    }), n();
                });
            const s = (e1)=>t._(this, void 0, void 0, function*() {
                    e1.state = "running";
                    const { requestParameters: i, supportImageRefresh: r, onError: o, onSuccess: s, abortController: c } = e1, h = !1 === r && !t.i(self) && !t.g(i.url) && (!i.headers || Object.keys(i.headers).reduce((e1, t)=>e1 && "accept" === t, !0));
                    a++;
                    const u = h ? l(i, c) : t.m(i, c);
                    try {
                        const i = yield u;
                        delete e1.abortController, e1.state = "completed", i.data instanceof HTMLImageElement || t.b(i.data) ? s(i) : i.data && s({
                            data: yield (d = i.data, "function" == typeof createImageBitmap ? t.f(d) : t.h(d)),
                            cacheControl: i.cacheControl,
                            expires: i.expires
                        });
                    } catch (t) {
                        delete e1.abortController, o(t);
                    } finally{
                        a--, n();
                    }
                    var d;
                }), n = ()=>{
                const e1 = (()=>{
                    for (const e1 of Object.keys(o))if (o[e1]()) return !0;
                    return !1;
                })() ? t.a.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : t.a.MAX_PARALLEL_IMAGE_REQUESTS;
                for(let t = a; t < e1 && i.length > 0; t++){
                    const e1 = i.shift();
                    e1.abortController.signal.aborted ? t-- : s(e1);
                }
            }, l = (e1, i)=>new Promise((a, r)=>{
                    const o = new Image, s = e1.url, n = e1.credentials;
                    n && "include" === n ? o.crossOrigin = "use-credentials" : (n && "same-origin" === n || !t.d(s)) && (o.crossOrigin = "anonymous"), i.signal.addEventListener("abort", ()=>{
                        o.src = "", r(t.c());
                    }), o.fetchPriority = "high", o.onload = ()=>{
                        o.onerror = o.onload = null, a({
                            data: o
                        });
                    }, o.onerror = ()=>{
                        o.onerror = o.onload = null, i.signal.aborted || r(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    }, o.src = s;
                });
        }(g || (g = {})), g.resetRequestQueue();
        class v {
            constructor(e1){
                this._transformRequestFn = null != e1 ? e1 : null;
            }
            transformRequest(e1, t) {
                return this._transformRequestFn && this._transformRequestFn(e1, t) || {
                    url: e1
                };
            }
            setTransformRequest(e1) {
                this._transformRequestFn = e1;
            }
        }
        function x(e1) {
            const t = [];
            if ("string" == typeof e1) t.push({
                id: "default",
                url: e1
            });
            else if (e1 && e1.length > 0) {
                const i = [];
                for (const { id: a, url: r } of e1){
                    const e1 = `${a}${r}`;
                    -1 === i.indexOf(e1) && (i.push(e1), t.push({
                        id: a,
                        url: r
                    }));
                }
            }
            return t;
        }
        function b(e1, t, i) {
            try {
                const a = new URL(e1);
                return a.pathname += `${t}${i}`, a.toString();
            } catch (t) {
                throw new Error(`Invalid sprite URL "${e1}", must be absolute. Modify style specification directly or use TransformStyleFunction to correct the issue dynamically`);
            }
        }
        function y(e1) {
            const { userImage: t } = e1;
            return !!(t && t.render && t.render()) && (e1.data.replace(new Uint8Array(t.data.buffer)), !0);
        }
        class w extends t.E {
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t.R({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            destroy() {
                this.atlasTexture && (this.atlasTexture.destroy(), this.atlasTexture = null);
                for (const e1 of Object.keys(this.images))this.removeImage(e1);
                this.patterns = {}, this.atlasImage = new t.R({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            isLoaded() {
                return this.loaded;
            }
            setLoaded(e1) {
                if (this.loaded !== e1 && (this.loaded = e1, e1)) {
                    for (const { ids: e1, promiseResolve: t } of this.requestors)t(this._getImagesForIds(e1));
                    this.requestors = [];
                }
            }
            getImage(e1) {
                const i = this.images[e1];
                if (i && !i.data && i.spriteData) {
                    const e1 = i.spriteData;
                    i.data = new t.R({
                        width: e1.width,
                        height: e1.height
                    }, e1.context.getImageData(e1.x, e1.y, e1.width, e1.height).data), i.spriteData = null;
                }
                return i;
            }
            addImage(e1, t) {
                if (this.images[e1]) throw new Error(`Image id ${e1} already exist, use updateImage instead`);
                this._validate(e1, t) && (this.images[e1] = t);
            }
            _validate(e1, i) {
                let a = !0;
                const r = i.data || i.spriteData;
                return this._validateStretch(i.stretchX, r && r.width) || (this.fire(new t.k(new Error(`Image "${e1}" has invalid "stretchX" value`))), a = !1), this._validateStretch(i.stretchY, r && r.height) || (this.fire(new t.k(new Error(`Image "${e1}" has invalid "stretchY" value`))), a = !1), this._validateContent(i.content, i) || (this.fire(new t.k(new Error(`Image "${e1}" has invalid "content" value`))), a = !1), a;
            }
            _validateStretch(e1, t) {
                if (!e1) return !0;
                let i = 0;
                for (const a of e1){
                    if (a[0] < i || a[1] < a[0] || t < a[1]) return !1;
                    i = a[1];
                }
                return !0;
            }
            _validateContent(e1, t) {
                if (!e1) return !0;
                if (4 !== e1.length) return !1;
                const i = t.spriteData, a = i && i.width || t.data.width, r = i && i.height || t.data.height;
                return !(e1[0] < 0 || a < e1[0] || e1[1] < 0 || r < e1[1] || e1[2] < 0 || a < e1[2] || e1[3] < 0 || r < e1[3] || e1[2] < e1[0] || e1[3] < e1[1]);
            }
            updateImage(e1, t, i = !0) {
                const a = this.getImage(e1);
                if (i && (a.data.width !== t.data.width || a.data.height !== t.data.height)) throw new Error(`size mismatch between old image (${a.data.width}x${a.data.height}) and new image (${t.data.width}x${t.data.height}).`);
                t.version = a.version + 1, this.images[e1] = t, this.updatedImages[e1] = !0;
            }
            removeImage(e1) {
                const t = this.images[e1];
                delete this.images[e1], delete this.patterns[e1], t.userImage && t.userImage.onRemove && t.userImage.onRemove();
            }
            listImages() {
                return Object.keys(this.images);
            }
            getImages(e1) {
                return new Promise((t, i)=>{
                    let a = !0;
                    if (!this.isLoaded()) for (const t of e1)this.images[t] || (a = !1);
                    this.isLoaded() || a ? t(this._getImagesForIds(e1)) : this.requestors.push({
                        ids: e1,
                        promiseResolve: t
                    });
                });
            }
            _getImagesForIds(e1) {
                const i = {};
                for (const a of e1){
                    let e1 = this.getImage(a);
                    e1 || (this.fire(new t.l("styleimagemissing", {
                        id: a
                    })), e1 = this.getImage(a)), e1 ? i[a] = {
                        data: e1.data.clone(),
                        pixelRatio: e1.pixelRatio,
                        sdf: e1.sdf,
                        version: e1.version,
                        stretchX: e1.stretchX,
                        stretchY: e1.stretchY,
                        content: e1.content,
                        textFitWidth: e1.textFitWidth,
                        textFitHeight: e1.textFitHeight,
                        hasRenderCallback: Boolean(e1.userImage && e1.userImage.render)
                    } : t.w(`Image "${a}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                return i;
            }
            getPixelSize() {
                const { width: e1, height: t } = this.atlasImage;
                return {
                    width: e1,
                    height: t
                };
            }
            getPattern(e1) {
                const i = this.patterns[e1], a = this.getImage(e1);
                if (!a) return null;
                if (i && i.position.version === a.version) return i.position;
                if (i) i.position.version = a.version;
                else {
                    const i = {
                        w: a.data.width + 2,
                        h: a.data.height + 2,
                        x: 0,
                        y: 0
                    }, r = new t.I(i, a);
                    this.patterns[e1] = {
                        bin: i,
                        position: r
                    };
                }
                return this._updatePatternAtlas(), this.patterns[e1].position;
            }
            bind(e1) {
                const i = e1.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new t.T(e1, this.atlasImage, i.RGBA), this.atlasTexture.bind(i.LINEAR, i.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas() {
                const e1 = [];
                for(const t in this.patterns)e1.push(this.patterns[t].bin);
                const { w: i, h: a } = t.p(e1), r = this.atlasImage;
                r.resize({
                    width: i || 1,
                    height: a || 1
                });
                for(const e1 in this.patterns){
                    const { bin: i } = this.patterns[e1], a = i.x + 1, o = i.y + 1, s = this.getImage(e1).data, n = s.width, l = s.height;
                    t.R.copy(s, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: o
                    }, {
                        width: n,
                        height: l
                    }), t.R.copy(s, r, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: a,
                        y: o - 1
                    }, {
                        width: n,
                        height: 1
                    }), t.R.copy(s, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: o + l
                    }, {
                        width: n,
                        height: 1
                    }), t.R.copy(s, r, {
                        x: n - 1,
                        y: 0
                    }, {
                        x: a - 1,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    }), t.R.copy(s, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: a + n,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                this.callbackDispatchedThisFrame = {};
            }
            dispatchRenderCallbacks(e1) {
                for (const i of e1){
                    if (this.callbackDispatchedThisFrame[i]) continue;
                    this.callbackDispatchedThisFrame[i] = !0;
                    const e1 = this.getImage(i);
                    e1 || t.w(`Image with ID: "${i}" was not found`), y(e1) && this.updateImage(i, e1);
                }
            }
            cloneImages() {
                const e1 = {};
                for(const t in this.images){
                    const i = this.images[t];
                    e1[t] = Object.assign(Object.assign({}, i), {
                        data: i.data ? i.data.clone() : null
                    });
                }
                return e1;
            }
        }
        const T = 1e20;
        function P(e1, t, i, a, r, o, s, n, l) {
            for(let c = t; c < t + a; c++)C(e1, i * o + c, o, r, s, n, l);
            for(let c = i; c < i + r; c++)C(e1, c * o + t, 1, a, s, n, l);
        }
        function C(e1, t, i, a, r, o, s) {
            o[0] = 0, s[0] = -T, s[1] = T, r[0] = e1[t];
            for(let n = 1, l = 0, c = 0; n < a; n++){
                r[n] = e1[t + n * i];
                const a = n * n;
                do {
                    const e1 = o[l];
                    c = (r[n] - r[e1] + a - e1 * e1) / (n - e1) / 2;
                }while (c <= s[l] && --l > -1);
                l++, o[l] = n, s[l] = c, s[l + 1] = T;
            }
            for(let n = 0, l = 0; n < a; n++){
                for(; s[l + 1] < n;)l++;
                const a = o[l], c = n - a;
                e1[t + n * i] = r[a] + c * c;
            }
        }
        const M = t.v.layout_symbol["text-font"].default.join(",");
        class I {
            constructor(e1, t, i){
                this.requestManager = e1, this.localIdeographFontFamily = t, this.entries = {}, this.lang = i;
            }
            setURL(e1) {
                this.url = e1;
            }
            getGlyphs(e1) {
                return t._(this, void 0, void 0, function*() {
                    const t = [];
                    for(const i in e1)for (const a of e1[i])t.push(this._getAndCacheGlyphsPromise(i, a));
                    const i = yield Promise.all(t), a = {};
                    for (const { stack: e1, id: t, glyph: r } of i)a[e1] || (a[e1] = {}), a[e1][t] = r && {
                        id: r.id,
                        bitmap: r.bitmap.clone(),
                        metrics: r.metrics
                    };
                    return a;
                });
            }
            _getAndCacheGlyphsPromise(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    let t = this.entries[e1];
                    t || (t = this.entries[e1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {}
                    });
                    let a = t.glyphs[i];
                    return void 0 !== a ? {
                        stack: e1,
                        id: i,
                        glyph: a
                    } : !this.url || this._charUsesLocalIdeographFontFamily(i) ? (a = t.glyphs[i] = this._drawGlyph(t, e1, i), {
                        stack: e1,
                        id: i,
                        glyph: a
                    }) : yield this._downloadAndCacheRangePromise(e1, i);
                });
            }
            _downloadAndCacheRangePromise(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    const t = this.entries[e1], a = Math.floor(i / 256);
                    if (t.ranges[a]) return {
                        stack: e1,
                        id: i,
                        glyph: null
                    };
                    if (!t.requests[a]) {
                        const i = I.loadGlyphRange(e1, a, this.url, this.requestManager);
                        t.requests[a] = i;
                    }
                    try {
                        const r = yield t.requests[a];
                        for(const e1 in r)t.glyphs[+e1] = r[+e1];
                        return t.ranges[a] = !0, {
                            stack: e1,
                            id: i,
                            glyph: r[i] || null
                        };
                    } catch (r) {
                        const o = t.glyphs[i] = this._drawGlyph(t, e1, i);
                        return this._warnOnMissingGlyphRange(o, a, i, r), {
                            stack: e1,
                            id: i,
                            glyph: o
                        };
                    }
                });
            }
            _warnOnMissingGlyphRange(e1, i, a, r) {
                const o = 256 * i, s = o + 255, n = a.toString(16).padStart(4, "0").toUpperCase();
                t.w(`Unable to load glyph range ${i}, ${o}-${s}. Rendering codepoint U+${n} locally instead. ${r}`);
            }
            _charUsesLocalIdeographFontFamily(e1) {
                return !!this.localIdeographFontFamily && t.q(e1);
            }
            _drawGlyph(e1, i, a) {
                const r = i === M && "" !== this.localIdeographFontFamily && this._charUsesLocalIdeographFontFamily(a), o = r ? "ideographTinySDF" : "tinySDF";
                e1[o] || (e1[o] = this._createTinySDF(r ? this.localIdeographFontFamily : i));
                const s = e1[o].draw(String.fromCodePoint(a));
                return {
                    id: a,
                    bitmap: new t.r({
                        width: s.width || 60,
                        height: s.height || 60
                    }, s.data),
                    metrics: {
                        width: s.glyphWidth / 2 || 24,
                        height: s.glyphHeight / 2 || 24,
                        left: s.glyphLeft / 2 + .5 || 0,
                        top: s.glyphTop / 2 - 27.5 || -8,
                        advance: s.glyphAdvance / 2 || 24,
                        isDoubleResolution: !0
                    }
                };
            }
            _createTinySDF(e1) {
                const t = e1 ? e1.split(",") : [];
                t.push("sans-serif");
                const i = t.map((e1)=>/[-\w]+/.test(e1) ? e1 : `'${CSS.escape(e1)}'`).join(",");
                return new I.TinySDF({
                    fontSize: 48,
                    buffer: 6,
                    radius: 16,
                    cutoff: .25,
                    fontFamily: i,
                    fontWeight: this._fontWeight(t[0]),
                    fontStyle: this._fontStyle(t[0]),
                    lang: this.lang
                });
            }
            _fontStyle(e1) {
                return /italic/i.test(e1) ? "italic" : /oblique/i.test(e1) ? "oblique" : "normal";
            }
            _fontWeight(e1) {
                const t = {
                    thin: 100,
                    hairline: 100,
                    "extra light": 200,
                    "ultra light": 200,
                    light: 300,
                    normal: 400,
                    regular: 400,
                    medium: 500,
                    semibold: 600,
                    demibold: 600,
                    bold: 700,
                    "extra bold": 800,
                    "ultra bold": 800,
                    black: 900,
                    heavy: 900,
                    "extra black": 950,
                    "ultra black": 950
                };
                let i;
                for (const [a, r] of Object.entries(t))new RegExp(`\\b${a}\\b`, "i").test(e1) && (i = `${r}`);
                return i;
            }
            destroy() {
                for(const e1 in this.entries){
                    const t = this.entries[e1];
                    t.tinySDF && (t.tinySDF = null), t.ideographTinySDF && (t.ideographTinySDF = null), t.glyphs = {}, t.requests = {}, t.ranges = {};
                }
                this.entries = {};
            }
        }
        I.loadGlyphRange = function(e1, i, a, r) {
            return t._(this, void 0, void 0, function*() {
                const o = 256 * i, s = o + 255, n = r.transformRequest(a.replace("{fontstack}", e1).replace("{range}", `${o}-${s}`), "Glyphs"), l = yield t.n(n, new AbortController);
                if (!l || !l.data) throw new Error(`Could not load glyph range. range: ${i}, ${o}-${s}`);
                const c = {};
                for (const e1 of t.o(l.data))c[e1.id] = e1;
                return c;
            });
        }, I.TinySDF = class {
            constructor({ fontSize: e1 = 24, buffer: t = 3, radius: i = 8, cutoff: a = .25, fontFamily: r = "sans-serif", fontWeight: o = "normal", fontStyle: s = "normal", lang: n = null } = {}){
                this.buffer = t, this.cutoff = a, this.radius = i, this.lang = n;
                const l = this.size = e1 + 4 * t, c = this._createCanvas(l), h = this.ctx = c.getContext("2d", {
                    willReadFrequently: !0
                });
                h.font = `${s} ${o} ${e1}px ${r}`, h.textBaseline = "alphabetic", h.textAlign = "left", h.fillStyle = "black", this.gridOuter = new Float64Array(l * l), this.gridInner = new Float64Array(l * l), this.f = new Float64Array(l), this.z = new Float64Array(l + 1), this.v = new Uint16Array(l);
            }
            _createCanvas(e1) {
                const t = document.createElement("canvas");
                return t.width = t.height = e1, t;
            }
            draw(e1) {
                const { width: t, actualBoundingBoxAscent: i, actualBoundingBoxDescent: a, actualBoundingBoxLeft: r, actualBoundingBoxRight: o } = this.ctx.measureText(e1), s = Math.ceil(i), n = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(o - r))), l = Math.min(this.size - this.buffer, s + Math.ceil(a)), c = n + 2 * this.buffer, h = l + 2 * this.buffer, u = Math.max(c * h, 0), d = new Uint8ClampedArray(u), _ = {
                    data: d,
                    width: c,
                    height: h,
                    glyphWidth: n,
                    glyphHeight: l,
                    glyphTop: s,
                    glyphLeft: 0,
                    glyphAdvance: t
                };
                if (0 === n || 0 === l) return _;
                const { ctx: p, buffer: m, gridInner: f, gridOuter: g } = this;
                this.lang && (p.lang = this.lang), p.clearRect(m, m, n, l), p.fillText(e1, m, m + s);
                const v = p.getImageData(m, m, n, l);
                g.fill(T, 0, u), f.fill(0, 0, u);
                for(let e1 = 0; e1 < l; e1++)for(let t = 0; t < n; t++){
                    const i = v.data[4 * (e1 * n + t) + 3] / 255;
                    if (0 === i) continue;
                    const a = (e1 + m) * c + t + m;
                    if (1 === i) g[a] = 0, f[a] = T;
                    else {
                        const e1 = .5 - i;
                        g[a] = e1 > 0 ? e1 * e1 : 0, f[a] = e1 < 0 ? e1 * e1 : 0;
                    }
                }
                P(g, 0, 0, c, h, c, this.f, this.v, this.z), P(f, m, m, n, l, c, this.f, this.v, this.z);
                for(let e1 = 0; e1 < u; e1++){
                    const t = Math.sqrt(g[e1]) - Math.sqrt(f[e1]);
                    d[e1] = Math.round(255 - 255 * (t / this.radius + this.cutoff));
                }
                return _;
            }
        };
        class E {
            constructor(){
                this.specification = t.u.light.position;
            }
            possiblyEvaluate(e1, i) {
                return t.F(e1.expression.evaluate(i));
            }
            interpolate(e1, i, a) {
                return {
                    x: t.G.number(e1.x, i.x, a),
                    y: t.G.number(e1.y, i.y, a),
                    z: t.G.number(e1.z, i.z, a)
                };
            }
        }
        let S;
        class R extends t.E {
            constructor(e1){
                super(), S = S || new t.t({
                    anchor: new t.D(t.u.light.anchor),
                    position: new E,
                    color: new t.D(t.u.light.color),
                    intensity: new t.D(t.u.light.intensity)
                }), this._transitionable = new t.x(S, void 0), this.setLight(e1), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e1, i = {}) {
                if (!this._validate(t.y, e1, i)) for(const i in e1){
                    const a = e1[i];
                    i.endsWith(t.z) ? this._transitionable.setTransition(i.slice(0, -t.z.length), a) : this._transitionable.setValue(i, a);
                }
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(e1, i, a) {
                return (!a || !1 !== a.validate) && t.B(this, e1.call(t.C, {
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t.u
                }));
            }
        }
        const D = new t.t({
            "sky-color": new t.D(t.u.sky["sky-color"]),
            "horizon-color": new t.D(t.u.sky["horizon-color"]),
            "fog-color": new t.D(t.u.sky["fog-color"]),
            "fog-ground-blend": new t.D(t.u.sky["fog-ground-blend"]),
            "horizon-fog-blend": new t.D(t.u.sky["horizon-fog-blend"]),
            "sky-horizon-blend": new t.D(t.u.sky["sky-horizon-blend"]),
            "atmosphere-blend": new t.D(t.u.sky["atmosphere-blend"])
        });
        class z extends t.E {
            constructor(e1){
                super(), this._transitionable = new t.x(D, void 0), this.setSky(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new t.H(0));
            }
            setSky(e1, i = {}) {
                if (!this._validate(t.J, e1, i)) {
                    e1 || (e1 = {
                        "sky-color": "transparent",
                        "horizon-color": "transparent",
                        "fog-color": "transparent",
                        "fog-ground-blend": 1,
                        "atmosphere-blend": 0
                    });
                    for(const i in e1){
                        const a = e1[i];
                        i.endsWith(t.z) ? this._transitionable.setTransition(i.slice(0, -t.z.length), a) : this._transitionable.setValue(i, a);
                    }
                }
            }
            getSky() {
                return this._transitionable.serialize();
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(e1, i, a = {}) {
                return !1 !== (null == a ? void 0 : a.validate) && t.B(this, e1.call(t.C, t.e({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t.u
                })));
            }
            calculateFogBlendOpacity(e1) {
                return e1 < 60 ? 0 : e1 < 70 ? (e1 - 60) / 10 : 1;
            }
        }
        class A {
            constructor(e1, t){
                this.width = e1, this.height = t, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
            }
            getDash(e1, t) {
                const i = e1.join(",") + String(t);
                return this.dashEntry[i] || (this.dashEntry[i] = this.addDash(e1, t)), this.dashEntry[i];
            }
            getDashRanges(e1, t, i) {
                const a = [];
                let r = e1.length % 2 == 1 ? -e1[e1.length - 1] * i : 0, o = e1[0] * i, s = !0;
                a.push({
                    left: r,
                    right: o,
                    isDash: s,
                    zeroLength: 0 === e1[0]
                });
                let n = e1[0];
                for(let t = 1; t < e1.length; t++){
                    s = !s;
                    const l = e1[t];
                    r = n * i, n += l, o = n * i, a.push({
                        left: r,
                        right: o,
                        isDash: s,
                        zeroLength: 0 === l
                    });
                }
                return a;
            }
            addRoundDash(e1, t, i) {
                const a = t / 2;
                for(let t = -i; t <= i; t++){
                    const r = this.width * (this.nextRow + i + t);
                    let o = 0, s = e1[o];
                    for(let n = 0; n < this.width; n++){
                        n / s.right > 1 && (s = e1[++o]);
                        const l = Math.abs(n - s.left), c = Math.abs(n - s.right), h = Math.min(l, c);
                        let u;
                        const d = t / i * (a + 1);
                        if (s.isDash) {
                            const e1 = a - Math.abs(d);
                            u = Math.sqrt(h * h + e1 * e1);
                        } else u = a - Math.sqrt(h * h + d * d);
                        this.data[r + n] = Math.max(0, Math.min(255, u + 128));
                    }
                }
            }
            addRegularDash(e1) {
                for(let t = e1.length - 1; t >= 0; --t){
                    const i = e1[t], a = e1[t + 1];
                    i.zeroLength ? e1.splice(t, 1) : a && a.isDash === i.isDash && (a.left = i.left, e1.splice(t, 1));
                }
                const t = e1[0], i = e1[e1.length - 1];
                t.isDash === i.isDash && (t.left = i.left - this.width, i.right = t.right + this.width);
                const a = this.width * this.nextRow;
                let r = 0, o = e1[r];
                for(let t = 0; t < this.width; t++){
                    t / o.right > 1 && (o = e1[++r]);
                    const i = Math.abs(t - o.left), s = Math.abs(t - o.right), n = Math.min(i, s);
                    this.data[a + t] = Math.max(0, Math.min(255, (o.isDash ? n : -n) + 128));
                }
            }
            addDash(e1, i) {
                const a = i ? 7 : 0, r = 2 * a + 1;
                if (this.nextRow + r > this.height) return t.w("LineAtlas out of space"), null;
                let o = 0;
                for(let t = 0; t < e1.length; t++)o += e1[t];
                if (0 !== o) {
                    const t = this.width / o, r = this.getDashRanges(e1, this.width, t);
                    i ? this.addRoundDash(r, t, a) : this.addRegularDash(r);
                }
                const s = {
                    y: this.nextRow + a,
                    height: 2 * a,
                    width: o
                };
                return this.nextRow += r, this.dirty = !0, s;
            }
            bind(e1) {
                const t = e1.gl;
                this.texture ? (t.bindTexture(t.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, this.width, this.height, t.ALPHA, t.UNSIGNED_BYTE, this.data))) : (this.texture = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this.texture), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texImage2D(t.TEXTURE_2D, 0, t.ALPHA, this.width, this.height, 0, t.ALPHA, t.UNSIGNED_BYTE, this.data));
            }
        }
        const L = "maplibre_preloaded_worker_pool";
        class k {
            constructor(){
                this.active = {};
            }
            acquire(e1) {
                if (!this.workers) for(this.workers = []; this.workers.length < k.workerCount;)this.workers.push(new Worker(t.a.WORKER_URL));
                return this.active[e1] = !0, this.workers.slice();
            }
            release(e1) {
                delete this.active[e1], 0 === this.numActive() && (this.workers.forEach((e1)=>{
                    e1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[L];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        const F = Math.floor(n.hardwareConcurrency / 2);
        let B, O;
        function j() {
            return B || (B = new k), B;
        }
        k.workerCount = t.K(globalThis) ? Math.max(Math.min(F, 3), 1) : 1;
        class N {
            constructor(e1, i){
                this.workerPool = e1, this.actors = [], this.currentActor = 0, this.id = i;
                const a = this.workerPool.acquire(i);
                for(let e1 = 0; e1 < a.length; e1++){
                    const r = new t.L(a[e1], i);
                    r.name = `Worker ${e1}`, this.actors.push(r);
                }
                if (!this.actors.length) throw new Error("No actors found");
            }
            broadcast(e1, t) {
                const i = [];
                for (const a of this.actors)i.push(a.sendAsync({
                    type: e1,
                    data: t
                }));
                return Promise.all(i);
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove(e1 = !0) {
                this.actors.forEach((e1)=>{
                    e1.remove();
                }), this.actors = [], e1 && this.workerPool.release(this.id);
            }
            registerMessageHandler(e1, t) {
                for (const i of this.actors)i.registerMessageHandler(e1, t);
            }
            unregisterMessageHandler(e1) {
                for (const t of this.actors)t.unregisterMessageHandler(e1);
            }
        }
        function Z() {
            return O || (O = new N(j(), t.M), O.registerMessageHandler("GR", (e1, i, a)=>t.m(i, a))), O;
        }
        function G(e1, i) {
            const a = t.N();
            return t.O(a, a, [
                1,
                1,
                0
            ]), t.Q(a, a, [
                .5 * e1.width,
                .5 * e1.height,
                1
            ]), e1.calculatePosMatrix ? t.S(a, a, e1.calculatePosMatrix(i.toUnwrapped())) : a;
        }
        function U(e1, t, i, a, r, o, s) {
            var n;
            const l = function(e1, t, i) {
                if (e1) for (const a of e1){
                    const e1 = t[a];
                    if (e1 && e1.source === i && "fill-extrusion" === e1.type) return !0;
                }
                else for(const e1 in t){
                    const a = t[e1];
                    if (a.source === i && "fill-extrusion" === a.type) return !0;
                }
                return !1;
            }(null !== (n = null == r ? void 0 : r.layers) && void 0 !== n ? n : null, t, e1.id), c = o.maxPitchScaleFactor(), h = e1.tilesIn(a, c, l);
            h.sort(V);
            const u = [];
            for (const a of h)u.push({
                wrappedTileID: a.tileID.wrapped().key,
                queryResults: a.tile.queryRenderedFeatures(t, i, e1.getState(), a.queryGeometry, a.cameraQueryGeometry, a.scale, r, o, c, G(o, a.tileID), s ? (e1, t)=>s(a.tileID, e1, t) : void 0)
            });
            return function(e1, t) {
                for(const i in e1)for (const a of e1[i])q(a, t);
                return e1;
            }(function(e1) {
                const t = {}, i = {};
                for (const a of e1){
                    const e1 = a.queryResults, r = a.wrappedTileID, o = i[r] = i[r] || {};
                    for(const i in e1){
                        const a = e1[i], r = o[i] = o[i] || {}, s = t[i] = t[i] || [];
                        for (const e1 of a)r[e1.featureIndex] || (r[e1.featureIndex] = !0, s.push(e1));
                    }
                }
                return t;
            }(u), e1);
        }
        function V(e1, t) {
            const i = e1.tileID, a = t.tileID;
            return i.overscaledZ - a.overscaledZ || i.canonical.y - a.canonical.y || i.wrap - a.wrap || i.canonical.x - a.canonical.x;
        }
        function q(e1, t) {
            const i = e1.feature, a = t.getFeatureState(i.layer["source-layer"], i.id);
            i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = a;
        }
        function W(e1, i, a) {
            return t._(this, void 0, void 0, function*() {
                let r = e1;
                if (e1.url ? r = (yield t.j(i.transformRequest(e1.url, "Source"), a)).data : yield n.frameAsync(a), !r) return null;
                const o = t.U(t.e(r, e1), [
                    "tiles",
                    "minzoom",
                    "maxzoom",
                    "attribution",
                    "bounds",
                    "scheme",
                    "tileSize",
                    "encoding"
                ]);
                return "vector_layers" in r && r.vector_layers && (o.vectorLayerIds = r.vector_layers.map((e1)=>e1.id)), o;
            });
        }
        class $ {
            constructor(e1, t){
                e1 && (t ? this.setSouthWest(e1).setNorthEast(t) : Array.isArray(e1) && (4 === e1.length ? this.setSouthWest([
                    e1[0],
                    e1[1]
                ]).setNorthEast([
                    e1[2],
                    e1[3]
                ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1])));
            }
            setNorthEast(e1) {
                return this._ne = e1 instanceof t.V ? new t.V(e1.lng, e1.lat) : t.V.convert(e1), this;
            }
            setSouthWest(e1) {
                return this._sw = e1 instanceof t.V ? new t.V(e1.lng, e1.lat) : t.V.convert(e1), this;
            }
            extend(e1) {
                const i = this._sw, a = this._ne;
                let r, o;
                if (e1 instanceof t.V) r = e1, o = e1;
                else {
                    if (!(e1 instanceof $)) return Array.isArray(e1) ? 4 === e1.length || e1.every(Array.isArray) ? this.extend($.convert(e1)) : this.extend(t.V.convert(e1)) : e1 && ("lng" in e1 || "lon" in e1) && "lat" in e1 ? this.extend(t.V.convert(e1)) : this;
                    if (r = e1._sw, o = e1._ne, !r || !o) return this;
                }
                return i || a ? (i.lng = Math.min(r.lng, i.lng), i.lat = Math.min(r.lat, i.lat), a.lng = Math.max(o.lng, a.lng), a.lat = Math.max(o.lat, a.lat)) : (this._sw = new t.V(r.lng, r.lat), this._ne = new t.V(o.lng, o.lat)), this;
            }
            getCenter() {
                return new t.V((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new t.V(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new t.V(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e1) {
                const { lng: i, lat: a } = t.V.convert(e1);
                let r = this._sw.lng <= i && i <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (r = this._sw.lng >= i && i >= this._ne.lng), this._sw.lat <= a && a <= this._ne.lat && r;
            }
            intersects(e1) {
                if ((e1 = $.convert(e1)).getNorth() < this.getSouth() || e1.getSouth() > this.getNorth()) return !1;
                const i = t.W(this.getWest(), -180, 180), a = t.W(this.getEast(), -180, 180), r = t.W(e1.getWest(), -180, 180), o = t.W(e1.getEast(), -180, 180), s = i > a, n = r > o;
                return !(!s || !n) || (s ? o >= i || r <= a : n ? a >= r || i <= o : !(r > a || o < i));
            }
            static convert(e1) {
                return e1 instanceof $ ? e1 : e1 ? new $(e1) : e1;
            }
            static fromLngLat(e1, i = 0) {
                const a = 360 * i / 40075017, r = a / Math.cos(Math.PI / 180 * e1.lat);
                return new $(new t.V(e1.lng - r, e1.lat - a), new t.V(e1.lng + r, e1.lat + a));
            }
            adjustAntiMeridian() {
                const e1 = new t.V(this._sw.lng, this._sw.lat), i = new t.V(this._ne.lng, this._ne.lat);
                return new $(e1, e1.lng > i.lng ? new t.V(i.lng + 360, i.lat) : i);
            }
        }
        class H {
            constructor(e1, t, i){
                this.bounds = $.convert(this.validateBounds(e1)), this.minzoom = t || 0, this.maxzoom = i || 24;
            }
            validateBounds(e1) {
                return Array.isArray(e1) && 4 === e1.length ? [
                    Math.max(-180, e1[0]),
                    Math.max(-90, e1[1]),
                    Math.min(180, e1[2]),
                    Math.min(90, e1[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(e1) {
                const i = Math.pow(2, e1.z), a = Math.floor(t.Y(this.bounds.getWest()) * i), r = Math.floor(t.X(this.bounds.getNorth()) * i), o = Math.ceil(t.Y(this.bounds.getEast()) * i), s = Math.ceil(t.X(this.bounds.getSouth()) * i);
                return e1.x >= a && e1.x < o && e1.y >= r && e1.y < s;
            }
        }
        class X extends t.E {
            constructor(e1, i, a, r){
                if (super(), this.id = e1, this.dispatcher = a, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t.e(this, t.U(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId",
                    "encoding"
                ])), this._options = t.e({
                    type: "vector"
                }, i), this._collectResourceTiming = i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(r);
            }
            load() {
                return t._(this, void 0, void 0, function*() {
                    this._loaded = !1, this.fire(new t.l("dataloading", {
                        dataType: "source"
                    })), this._tileJSONRequest = new AbortController;
                    try {
                        const e1 = yield W(this._options, this.map._requestManager, this._tileJSONRequest);
                        this._tileJSONRequest = null, this._loaded = !0, this.map.style.tileManagers[this.id].clearTiles(), e1 && (t.e(this, e1), e1.bounds && (this.tileBounds = new H(e1.bounds, this.minzoom, this.maxzoom)), this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        })));
                    } catch (e1) {
                        this._tileJSONRequest = null, this._loaded = !0, this.fire(new t.k(e1));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            setSourceProperty(e1) {
                this._tileJSONRequest && this._tileJSONRequest.abort(), e1(), this.load();
            }
            setTiles(e1) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = e1;
                }), this;
            }
            setUrl(e1) {
                return this.setSourceProperty(()=>{
                    this.url = e1, this._options.url = e1;
                }), this;
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
            }
            serialize() {
                return t.e({}, this._options);
            }
            loadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    const t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), i = {
                        request: this.map._requestManager.transformRequest(t, "Tile"),
                        uid: e1.uid,
                        tileID: e1.tileID,
                        zoom: e1.tileID.overscaledZ,
                        tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        pixelRatio: this.map.getPixelRatio(),
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        subdivisionGranularity: this.map.style.projection.subdivisionGranularity,
                        encoding: this.encoding,
                        overzoomParameters: this._getOverzoomParameters(e1)
                    };
                    i.request.collectResourceTiming = this._collectResourceTiming;
                    let a = "RT";
                    if (e1.actor && "expired" !== e1.state) {
                        if ("loading" === e1.state) return new Promise((t, i)=>{
                            e1.reloadPromise = {
                                resolve: t,
                                reject: i
                            };
                        });
                    } else e1.actor = this.dispatcher.getActor(), a = "LT";
                    e1.abortController = new AbortController;
                    try {
                        const t = yield e1.actor.sendAsync({
                            type: a,
                            data: i
                        }, e1.abortController);
                        if (delete e1.abortController, e1.aborted) return;
                        this._afterTileLoadWorkerResponse(e1, t);
                    } catch (t) {
                        if (delete e1.abortController, e1.aborted) return;
                        if (t && 404 !== t.status) throw t;
                        this._afterTileLoadWorkerResponse(e1, null);
                    }
                });
            }
            _getOverzoomParameters(e1) {
                if (e1.tileID.canonical.z <= this.maxzoom) return;
                if (void 0 === this.map._zoomLevelsToOverscale) return;
                const t = e1.tileID.scaledTo(this.maxzoom).canonical, i = t.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                return {
                    maxZoomTileID: t,
                    overzoomRequest: this.map._requestManager.transformRequest(i, "Tile")
                };
            }
            _afterTileLoadWorkerResponse(e1, t) {
                if (t && t.resourceTiming && (e1.resourceTiming = t.resourceTiming), t && this.map._refreshExpiredTiles && e1.setExpiryData(t), e1.loadVectorData(t, this.map.painter), e1.reloadPromise) {
                    const t = e1.reloadPromise;
                    e1.reloadPromise = null, this.loadTile(e1).then(t.resolve).catch(t.reject);
                }
            }
            abortTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.actor && (yield e1.actor.sendAsync({
                        type: "AT",
                        data: {
                            uid: e1.uid,
                            type: this.type,
                            source: this.id
                        }
                    }));
                });
            }
            unloadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.unloadVectorData(), e1.actor && (yield e1.actor.sendAsync({
                        type: "RMT",
                        data: {
                            uid: e1.uid,
                            type: this.type,
                            source: this.id
                        }
                    }));
                });
            }
            hasTransition() {
                return !1;
            }
        }
        class K extends t.E {
            constructor(e1, i, a, r){
                super(), this.id = e1, this.dispatcher = a, this.setEventedParent(r), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t.e({
                    type: "raster"
                }, i), t.e(this, t.U(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load() {
                return t._(this, arguments, void 0, function*(e1 = !1) {
                    this._loaded = !1, this.fire(new t.l("dataloading", {
                        dataType: "source"
                    })), this._tileJSONRequest = new AbortController;
                    try {
                        const i = yield W(this._options, this.map._requestManager, this._tileJSONRequest);
                        this._tileJSONRequest = null, this._loaded = !0, i && (t.e(this, i), i.bounds && (this.tileBounds = new H(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "content",
                            sourceDataChanged: e1
                        })));
                    } catch (e1) {
                        this._tileJSONRequest = null, this._loaded = !0, this.fire(new t.k(e1));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
            }
            setSourceProperty(e1) {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null), e1(), this.load(!0);
            }
            setTiles(e1) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = e1;
                }), this;
            }
            setUrl(e1) {
                return this.setSourceProperty(()=>{
                    this.url = e1, this._options.url = e1;
                }), this;
            }
            serialize() {
                return t.e({}, this._options);
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            loadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    const i = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                    e1.abortController = new AbortController;
                    try {
                        const a = yield g.getImage(this.map._requestManager.transformRequest(i, "Tile"), e1.abortController, this.map._refreshExpiredTiles);
                        if (delete e1.abortController, e1.aborted) return void (e1.state = "unloaded");
                        if (a && a.data) {
                            this.map._refreshExpiredTiles && (a.cacheControl || a.expires) && e1.setExpiryData({
                                cacheControl: a.cacheControl,
                                expires: a.expires
                            });
                            const i = this.map.painter.context, r = i.gl, o = a.data;
                            e1.texture = this.map.painter.getTileTexture(o.width), e1.texture ? e1.texture.update(o, {
                                useMipmap: !0
                            }) : (e1.texture = new t.T(i, o, r.RGBA, {
                                useMipmap: !0
                            }), e1.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE, r.LINEAR_MIPMAP_NEAREST)), e1.state = "loaded";
                        }
                    } catch (t) {
                        if (delete e1.abortController, e1.aborted) e1.state = "unloaded";
                        else if (t) throw e1.state = "errored", t;
                    }
                });
            }
            abortTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.abortController && (e1.abortController.abort(), delete e1.abortController);
                });
            }
            unloadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.texture && this.map.painter.saveTileTexture(e1.texture);
                });
            }
            hasTransition() {
                return !1;
            }
        }
        class Y extends K {
            constructor(e1, i, a, r){
                super(e1, i, a, r), this.type = "raster-dem", this.maxzoom = 22, this._options = t.e({
                    type: "raster-dem"
                }, i), this.encoding = i.encoding || "mapbox", this.redFactor = i.redFactor, this.greenFactor = i.greenFactor, this.blueFactor = i.blueFactor, this.baseShift = i.baseShift;
            }
            loadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    const i = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), a = this.map._requestManager.transformRequest(i, "Tile");
                    e1.neighboringTiles = this._getNeighboringTiles(e1.tileID), e1.abortController = new AbortController;
                    try {
                        const i = yield g.getImage(a, e1.abortController, this.map._refreshExpiredTiles);
                        if (delete e1.abortController, e1.aborted) return void (e1.state = "unloaded");
                        if (i && i.data) {
                            const a = i.data;
                            this.map._refreshExpiredTiles && (i.cacheControl || i.expires) && e1.setExpiryData({
                                cacheControl: i.cacheControl,
                                expires: i.expires
                            });
                            const r = t.b(a) && t.Z() ? a : yield this.readImageNow(a), o = {
                                type: this.type,
                                uid: e1.uid,
                                source: this.id,
                                rawImageData: r,
                                encoding: this.encoding,
                                redFactor: this.redFactor,
                                greenFactor: this.greenFactor,
                                blueFactor: this.blueFactor,
                                baseShift: this.baseShift
                            };
                            if (!e1.actor || "expired" === e1.state) {
                                e1.actor = this.dispatcher.getActor();
                                const t = yield e1.actor.sendAsync({
                                    type: "LDT",
                                    data: o
                                });
                                e1.dem = t, e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.state = "loaded";
                            }
                        }
                    } catch (t) {
                        if (delete e1.abortController, e1.aborted) e1.state = "unloaded";
                        else if (t) throw e1.state = "errored", t;
                    }
                });
            }
            readImageNow(e1) {
                return t._(this, void 0, void 0, function*() {
                    if ("undefined" != typeof VideoFrame && t.$()) {
                        const i = e1.width + 2, a = e1.height + 2;
                        try {
                            return new t.R({
                                width: i,
                                height: a
                            }, (yield t.a0(e1, -1, -1, i, a)));
                        } catch (e1) {}
                    }
                    return n.getImageData(e1, 1);
                });
            }
            _getNeighboringTiles(e1) {
                const i = e1.canonical, a = Math.pow(2, i.z), r = (i.x - 1 + a) % a, o = 0 === i.x ? e1.wrap - 1 : e1.wrap, s = (i.x + 1 + a) % a, n = i.x + 1 === a ? e1.wrap + 1 : e1.wrap, l = {};
                return l[new t.a1(e1.overscaledZ, o, i.z, r, i.y).key] = {
                    backfilled: !1
                }, l[new t.a1(e1.overscaledZ, n, i.z, s, i.y).key] = {
                    backfilled: !1
                }, i.y > 0 && (l[new t.a1(e1.overscaledZ, o, i.z, r, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t.a1(e1.overscaledZ, e1.wrap, i.z, i.x, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t.a1(e1.overscaledZ, n, i.z, s, i.y - 1).key] = {
                    backfilled: !1
                }), i.y + 1 < a && (l[new t.a1(e1.overscaledZ, o, i.z, r, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t.a1(e1.overscaledZ, e1.wrap, i.z, i.x, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t.a1(e1.overscaledZ, n, i.z, s, i.y + 1).key] = {
                    backfilled: !1
                }), l;
            }
            unloadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.demTexture && this.map.painter.saveTileTexture(e1.demTexture), e1.fbo && (e1.fbo.destroy(), delete e1.fbo), e1.dem && delete e1.dem, delete e1.neighboringTiles, e1.state = "unloaded", e1.actor && (yield e1.actor.sendAsync({
                        type: "RDT",
                        data: {
                            type: this.type,
                            uid: e1.uid,
                            source: this.id
                        }
                    }));
                });
            }
        }
        function Q(e1) {
            return "GeometryCollection" === e1.type ? e1.geometries.map((e1)=>e1.coordinates).flat(1 / 0) : e1.coordinates.flat(1 / 0);
        }
        function J(e1) {
            const t = new $;
            let i;
            switch(e1.type){
                case "FeatureCollection":
                    i = e1.features.map((e1)=>Q(e1.geometry)).flat(1 / 0);
                    break;
                case "Feature":
                    i = Q(e1.geometry);
                    break;
                default:
                    i = Q(e1);
            }
            if (0 == i.length) return t;
            for(let e1 = 0; e1 < i.length - 1; e1 += 2)t.extend([
                i[e1],
                i[e1 + 1]
            ]);
            return t;
        }
        class ee extends t.E {
            constructor(e1, i, a, r){
                super(), this.id = e1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._isUpdatingWorker = !1, this._pendingWorkerUpdate = {
                    data: i.data
                }, this.actor = a.getActor(), this.setEventedParent(r), this._data = "string" == typeof i.data ? {
                    url: i.data
                } : {
                    geojson: i.data
                }, this._options = t.e({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId, void 0 !== i.clusterMaxZoom && this.maxzoom <= i.clusterMaxZoom && t.w(`The maxzoom value "${this.maxzoom}" is expected to be greater than the clusterMaxZoom value "${i.clusterMaxZoom}".`), this.workerOptions = t.e({
                    source: this.id,
                    cluster: i.cluster || !1,
                    geojsonVtOptions: {
                        buffer: this._pixelsToTileUnits(void 0 !== i.buffer ? i.buffer : 128),
                        tolerance: this._pixelsToTileUnits(void 0 !== i.tolerance ? i.tolerance : .375),
                        extent: t.a4,
                        maxZoom: this.maxzoom,
                        lineMetrics: i.lineMetrics || !1,
                        generateId: i.generateId || !1
                    },
                    superclusterOptions: {
                        maxZoom: this._getClusterMaxZoom(i.clusterMaxZoom),
                        minPoints: Math.max(2, i.clusterMinPoints || 2),
                        extent: t.a4,
                        radius: this._pixelsToTileUnits(i.clusterRadius || 50),
                        log: !1,
                        generateId: i.generateId || !1
                    },
                    clusterProperties: i.clusterProperties,
                    filter: i.filter
                }, i.workerOptions), "string" == typeof this.promoteId && (this.workerOptions.promoteId = this.promoteId);
            }
            _hasPendingWorkerUpdate() {
                return void 0 !== this._pendingWorkerUpdate.data || void 0 !== this._pendingWorkerUpdate.diff || this._pendingWorkerUpdate.optionsChanged;
            }
            _pixelsToTileUnits(e1) {
                return e1 * (t.a4 / this.tileSize);
            }
            _getClusterMaxZoom(e1) {
                const i = e1 ? Math.round(e1) : this.maxzoom - 1;
                return Number.isInteger(e1) || void 0 === e1 || t.w(`Integer expected for option 'clusterMaxZoom': provided value "${e1}" rounded to "${i}"`), i;
            }
            load() {
                return t._(this, void 0, void 0, function*() {
                    yield this._updateWorkerData();
                });
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            setData(e1, t) {
                this._data = "string" == typeof e1 ? {
                    url: e1
                } : {
                    geojson: e1
                }, this._pendingWorkerUpdate = {
                    data: e1
                };
                const i = this._updateWorkerData();
                return t ? i : this;
            }
            updateData(e1, i) {
                this._pendingWorkerUpdate.diff = t.a5(this._pendingWorkerUpdate.diff, e1);
                const a = this._updateWorkerData();
                return i ? a : this;
            }
            getData() {
                return t._(this, void 0, void 0, function*() {
                    const e1 = t.e({
                        type: this.type
                    }, this.workerOptions);
                    return this.actor.sendAsync({
                        type: "GD",
                        data: e1
                    });
                });
            }
            getBounds() {
                return t._(this, void 0, void 0, function*() {
                    return J((yield this.getData()));
                });
            }
            setClusterOptions(e1) {
                return this.workerOptions.cluster = e1.cluster, void 0 !== e1.clusterRadius && (this.workerOptions.superclusterOptions.radius = this._pixelsToTileUnits(e1.clusterRadius)), void 0 !== e1.clusterMaxZoom && (this.workerOptions.superclusterOptions.maxZoom = this._getClusterMaxZoom(e1.clusterMaxZoom)), this._pendingWorkerUpdate.optionsChanged = !0, this._updateWorkerData(), this;
            }
            getClusterExpansionZoom(e1) {
                return this.actor.sendAsync({
                    type: "GCEZ",
                    data: {
                        type: this.type,
                        clusterId: e1,
                        source: this.id
                    }
                });
            }
            getClusterChildren(e1) {
                return this.actor.sendAsync({
                    type: "GCC",
                    data: {
                        type: this.type,
                        clusterId: e1,
                        source: this.id
                    }
                });
            }
            getClusterLeaves(e1, t, i) {
                return this.actor.sendAsync({
                    type: "GCL",
                    data: {
                        type: this.type,
                        source: this.id,
                        clusterId: e1,
                        limit: t,
                        offset: i
                    }
                });
            }
            _updateWorkerData() {
                return t._(this, void 0, void 0, function*() {
                    if (this._isUpdatingWorker) return;
                    if (!this._hasPendingWorkerUpdate()) return void t.w(`No pending worker updates for GeoJSONSource ${this.id}.`);
                    const { data: e1, diff: i } = this._pendingWorkerUpdate, a = t.e({
                        type: this.type
                    }, this.workerOptions);
                    e1 ? ("string" == typeof e1 ? (a.request = this.map._requestManager.transformRequest(n.resolveURL(e1), "Source"), a.request.collectResourceTiming = this._collectResourceTiming) : a.data = e1, this._pendingWorkerUpdate.data = void 0) : i && (a.dataDiff = i, this._pendingWorkerUpdate.diff = void 0), this._pendingWorkerUpdate.optionsChanged = void 0, this._isUpdatingWorker = !0, this.fire(new t.l("dataloading", {
                        dataType: "source"
                    }));
                    try {
                        const e1 = yield this.actor.sendAsync({
                            type: "LD",
                            data: a
                        });
                        if (this._isUpdatingWorker = !1, this._removed || e1.abandoned) return void this.fire(new t.l("dataabort", {
                            dataType: "source"
                        }));
                        e1.applyDiff ? this._applyDiff(i) : this._data = {
                            geojson: e1.data
                        };
                        let r = null;
                        e1.resourceTiming && e1.resourceTiming[this.id] && (r = e1.resourceTiming[this.id].slice(0));
                        const o = {
                            dataType: "source"
                        };
                        this._collectResourceTiming && r && r.length > 0 && t.e(o, {
                            resourceTiming: r
                        }), this.fire(new t.l("data", Object.assign(Object.assign({}, o), {
                            sourceDataType: "metadata"
                        }))), this.fire(new t.l("data", Object.assign(Object.assign({}, o), {
                            sourceDataType: "content",
                            shouldReloadTileOptions: this._getShouldReloadTileOptions(i)
                        })));
                    } catch (e1) {
                        if (this._isUpdatingWorker = !1, this._removed) return void this.fire(new t.l("dataabort", {
                            dataType: "source"
                        }));
                        this.fire(new t.k(e1));
                    } finally{
                        this._hasPendingWorkerUpdate() && this._updateWorkerData();
                    }
                });
            }
            _applyDiff(e1) {
                const i = "string" == typeof this.promoteId ? this.promoteId : void 0;
                this._data.url || this._data.updateable || !t.a6(this._data.geojson, i) || (this._data = {
                    updateable: t.a7(this._data.geojson, i)
                }), e1 && this._data.updateable ? t.a8(this._data.updateable, e1, i) : t.w("Cannot apply GeoJSONSource#updateData due to internal error");
            }
            _getShouldReloadTileOptions(e1) {
                if (this._options.cluster || !e1 || e1.removeAll) return;
                const { add: i = [], update: a = [], remove: r = [] } = e1 || {}, o = new Set([
                    ...a.map((e1)=>e1.id),
                    ...r
                ]);
                for (const e1 of o.values())if ("number" != typeof e1 && null == this.promoteId) return void t.w(`GeoJSONSource "${this.id}": updateData is slower when using string GeoJSON feature IDs (e.g. "${e1}"). Consider using promoteId or numeric IDs for better performance.`);
                return {
                    nextBounds: [
                        ...a.map((e1)=>e1.newGeometry),
                        ...i.map((e1)=>e1.geometry)
                    ].filter(Boolean).map((e1)=>J(e1)),
                    prevIds: o
                };
            }
            shouldReloadTile(e1, { nextBounds: i, prevIds: a }) {
                if (!e1.latestFeatureIndex) return "unloaded" !== e1.state;
                const r = e1.latestFeatureIndex.loadVTLayers();
                for(let i = 0; i < e1.latestFeatureIndex.featureIndexArray.length; i++){
                    const o = e1.latestFeatureIndex.featureIndexArray.get(i), s = r[t.a9].feature(o.featureIndex), n = e1.latestFeatureIndex.getId(s, t.a9);
                    if (a.has(n)) return !0;
                }
                const { buffer: o, extent: s } = this.workerOptions.geojsonVtOptions, n = function({ x: e1, y: i, z: a }, r = 0) {
                    const o = t.a2((e1 - r) / Math.pow(2, a)), s = t.a3((i + 1 + r) / Math.pow(2, a)), n = t.a2((e1 + 1 + r) / Math.pow(2, a)), l = t.a3((i - r) / Math.pow(2, a));
                    return new $([
                        o,
                        s
                    ], [
                        n,
                        l
                    ]);
                }(e1.tileID.canonical, o / s);
                for (const e1 of i)if (n.intersects(e1)) return !0;
                return !1;
            }
            loaded() {
                return !this._isUpdatingWorker && !this._hasPendingWorkerUpdate();
            }
            loadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    const t = e1.actor ? "RT" : "LT";
                    e1.actor = this.actor;
                    const i = {
                        type: this.type,
                        uid: e1.uid,
                        tileID: e1.tileID,
                        zoom: e1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        pixelRatio: this.map.getPixelRatio(),
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        subdivisionGranularity: this.map.style.projection.subdivisionGranularity
                    };
                    e1.abortController = new AbortController;
                    const a = yield this.actor.sendAsync({
                        type: t,
                        data: i
                    }, e1.abortController);
                    delete e1.abortController, e1.unloadVectorData(), e1.aborted || e1.loadVectorData(a, this.map.painter, "RT" === t);
                });
            }
            abortTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.aborted = !0;
                });
            }
            unloadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    e1.unloadVectorData(), yield this.actor.sendAsync({
                        type: "RMT",
                        data: {
                            uid: e1.uid,
                            type: this.type,
                            source: this.id
                        }
                    });
                });
            }
            onRemove() {
                this._removed = !0, this.actor.sendAsync({
                    type: "RS",
                    data: {
                        type: this.type,
                        source: this.id
                    }
                });
            }
            serialize() {
                return t.e({}, this._options, {
                    type: this.type,
                    data: this._data.updateable ? {
                        type: "FeatureCollection",
                        features: Array.from(this._data.updateable.values())
                    } : this._data.url || this._data.geojson
                });
            }
            hasTransition() {
                return !1;
            }
        }
        class te extends t.E {
            constructor(e1, t, i, a){
                super(), this.flippedWindingOrder = !1, this.id = e1, this.dispatcher = i, this.coordinates = t.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(a), this.options = t;
            }
            load(e1) {
                return t._(this, void 0, void 0, function*() {
                    this._loaded = !1, this.fire(new t.l("dataloading", {
                        dataType: "source"
                    })), this.url = this.options.url, this._request = new AbortController;
                    try {
                        const t = yield g.getImage(this.map._requestManager.transformRequest(this.url, "Image"), this._request);
                        this._request = null, this._loaded = !0, t && t.data && (this.image = t.data, e1 && (this.coordinates = e1), this._finishLoading());
                    } catch (e1) {
                        this._request = null, this._loaded = !0, this.fire(new t.k(e1));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(e1) {
                return e1.url ? (this._request && (this._request.abort(), this._request = null), this.options.url = e1.url, this.load(e1.coordinates).finally(()=>{
                    this.texture = null;
                }), this) : this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new t.l("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove() {
                this._request && (this._request.abort(), this._request = null);
            }
            setCoordinates(e1) {
                this.coordinates = e1;
                const i = e1.map(t.aa.fromLngLat);
                var a;
                return this.tileID = function(e1) {
                    const i = t.ab.fromPoints(e1), a = i.width(), r = i.height(), o = Math.max(a, r), s = Math.max(0, Math.floor(-Math.log(o) / Math.LN2)), n = Math.pow(2, s);
                    return new t.ad(s, Math.floor((i.minX + i.maxX) / 2 * n), Math.floor((i.minY + i.maxY) / 2 * n));
                }(i), this.terrainTileRanges = this._getOverlappingTileRanges(i), this.minzoom = this.maxzoom = this.tileID.z, this.tileCoords = i.map((e1)=>this.tileID.getTilePoint(e1)._round()), this.flippedWindingOrder = ((a = this.tileCoords)[1].x - a[0].x) * (a[2].y - a[0].y) - (a[1].y - a[0].y) * (a[2].x - a[0].x) < 0, this.fire(new t.l("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || !this.image) return;
                const e1 = this.map.painter.context, i = e1.gl;
                this.texture || (this.texture = new t.T(e1, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                let a = !1;
                for(const e1 in this.tiles){
                    const t = this.tiles[e1];
                    "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, a = !0);
                }
                a && this.fire(new t.l("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            loadTile(e1) {
                return t._(this, void 0, void 0, function*() {
                    this.tileID && this.tileID.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}) : e1.state = "errored";
                });
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            _getOverlappingTileRanges(e1) {
                const { minX: i, minY: a, maxX: r, maxY: o } = t.ab.fromPoints(e1), s = {};
                for(let e1 = 0; e1 <= t.ac; e1++){
                    const t = Math.pow(2, e1), n = Math.floor(i * t), l = Math.floor(a * t), c = Math.floor(r * t), h = Math.floor(o * t);
                    s[e1] = {
                        minTileX: n,
                        minTileY: l,
                        maxTileX: c,
                        maxTileY: h
                    };
                }
                return s;
            }
        }
        class ie extends te {
            constructor(e1, t, i, a){
                super(e1, t, i, a), this.roundZoom = !0, this.type = "video", this.options = t;
            }
            load() {
                return t._(this, void 0, void 0, function*() {
                    this._loaded = !1;
                    const e1 = this.options;
                    this.urls = [];
                    for (const t of e1.urls)this.urls.push(this.map._requestManager.transformRequest(t, "Source").url);
                    try {
                        const e1 = yield t.ae(this.urls);
                        if (this._loaded = !0, !e1) return;
                        this.video = e1, this.video.loop = !0, this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading();
                    } catch (e1) {
                        this.fire(new t.k(e1));
                    }
                });
            }
            pause() {
                this.video && this.video.pause();
            }
            play() {
                this.video && this.video.play();
            }
            seek(e1) {
                if (this.video) {
                    const i = this.video.seekable;
                    e1 < i.start(0) || e1 > i.end(0) ? this.fire(new t.k(new t.af(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = e1;
                }
            }
            getVideo() {
                return this.video;
            }
            onAdd(e1) {
                this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                const e1 = this.map.painter.context, i = e1.gl;
                this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new t.T(e1, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                let a = !1;
                for(const e1 in this.tiles){
                    const t = this.tiles[e1];
                    "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, a = !0);
                }
                a && this.fire(new t.l("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            serialize() {
                return {
                    type: "video",
                    urls: this.urls,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this.video && !this.video.paused;
            }
        }
        class ae extends te {
            constructor(e1, i, a, r){
                super(e1, i, a, r), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e1)=>!Array.isArray(e1) || 2 !== e1.length || e1.some((e1)=>"number" != typeof e1)) || this.fire(new t.k(new t.af(`sources.${e1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t.k(new t.af(`sources.${e1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new t.k(new t.af(`sources.${e1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new t.k(new t.af(`sources.${e1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t.k(new t.af(`sources.${e1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
            }
            load() {
                return t._(this, void 0, void 0, function*() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t.k(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                });
            }
            getCanvas() {
                return this.canvas;
            }
            onAdd(e1) {
                this.map = e1, this.load(), this.canvas && this.animate && this.play();
            }
            onRemove() {
                this.pause();
            }
            prepare() {
                let e1 = !1;
                if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), this._hasInvalidDimensions()) return;
                if (0 === Object.keys(this.tiles).length) return;
                const i = this.map.painter.context, a = i.gl;
                this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
                    premultiply: !0
                }) : this.texture = new t.T(i, this.canvas, a.RGBA, {
                    premultiply: !0
                });
                let r = !1;
                for(const e1 in this.tiles){
                    const t = this.tiles[e1];
                    "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, r = !0);
                }
                r && this.fire(new t.l("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            serialize() {
                return {
                    type: "canvas",
                    animate: this.animate,
                    canvas: this.options.canvas,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this._playing;
            }
            _hasInvalidDimensions() {
                for (const e1 of [
                    this.canvas.width,
                    this.canvas.height
                ])if (isNaN(e1) || e1 <= 0) return !0;
                return !1;
            }
        }
        const re = {}, oe = (e1)=>{
            switch(e1){
                case "geojson":
                    return ee;
                case "image":
                    return te;
                case "raster":
                    return K;
                case "raster-dem":
                    return Y;
                case "vector":
                    return X;
                case "video":
                    return ie;
                case "canvas":
                    return ae;
            }
            return re[e1];
        }, se = "RTLPluginLoaded";
        class ne extends t.E {
            constructor(){
                super(...arguments), this.status = "unavailable", this.url = null, this.dispatcher = Z();
            }
            _syncState(e1) {
                return this.status = e1, this.dispatcher.broadcast("SRPS", {
                    pluginStatus: e1,
                    pluginURL: this.url
                }).catch((e1)=>{
                    throw this.status = "error", e1;
                });
            }
            getRTLTextPluginStatus() {
                return this.status;
            }
            clearRTLTextPlugin() {
                this.status = "unavailable", this.url = null;
            }
            setRTLTextPlugin(e1) {
                return t._(this, arguments, void 0, function*(e1, t = !1) {
                    if (this.url) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                    if (this.url = n.resolveURL(e1), !this.url) throw new Error(`requested url ${e1} is invalid`);
                    if ("unavailable" === this.status) {
                        if (!t) return this._requestImport();
                        this.status = "deferred", this._syncState(this.status);
                    } else if ("requested" === this.status) return this._requestImport();
                });
            }
            _requestImport() {
                return t._(this, void 0, void 0, function*() {
                    yield this._syncState("loading"), this.status = "loaded", this.fire(new t.l(se));
                });
            }
            lazyLoad() {
                "unavailable" === this.status ? this.status = "requested" : "deferred" === this.status && this._requestImport();
            }
        }
        let le = null;
        function ce() {
            return le || (le = new ne), le;
        }
        var he, ue;
        !function(e1) {
            e1[e1.Base = 0] = "Base", e1[e1.Parent = 1] = "Parent";
        }(he || (he = {})), function(e1) {
            e1[e1.Departing = 0] = "Departing", e1[e1.Incoming = 1] = "Incoming";
        }(ue || (ue = {}));
        class de {
            constructor(e1, i){
                this.timeAdded = 0, this.fadeEndTime = 0, this.fadeOpacity = 1, this.tileID = e1, this.uid = t.ag(), this.uses = 0, this.tileSize = i, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
            }
            isRenderable(e1) {
                return this.hasData() && (!this.fadeEndTime || this.fadeOpacity > 0) && (e1 || !this.holdingForSymbolFade());
            }
            setCrossFadeLogic({ fadingRole: e1, fadingDirection: t, fadingParentID: i, fadeEndTime: a }) {
                this.resetFadeLogic(), this.fadingRole = e1, this.fadingDirection = t, this.fadingParentID = i, this.fadeEndTime = a;
            }
            setSelfFadeLogic(e1) {
                this.resetFadeLogic(), this.selfFading = !0, this.fadeEndTime = e1;
            }
            resetFadeLogic() {
                this.fadingRole = null, this.fadingDirection = null, this.fadingParentID = null, this.selfFading = !1, this.timeAdded = c(), this.fadeEndTime = 0, this.fadeOpacity = 1;
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            clearTextures(e1) {
                this.demTexture && e1.saveTileTexture(this.demTexture), this.demTexture = null;
            }
            loadVectorData(e1, i, a) {
                if (this.hasData() && this.unloadVectorData(), this.state = "loaded", e1) {
                    e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestFeatureIndex.rawTileData = e1.rawTileData, this.latestFeatureIndex.encoding = e1.encoding) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData, this.latestFeatureIndex.encoding = this.latestEncoding)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = function(e1, t) {
                        const i = {};
                        if (!t) return i;
                        for (const a of e1){
                            const e1 = a.layerIds.map((e1)=>t.getLayer(e1)).filter(Boolean);
                            if (0 !== e1.length) {
                                a.layers = e1, a.stateDependentLayerIds && (a.stateDependentLayers = a.stateDependentLayerIds.map((t)=>e1.filter((e1)=>e1.id === t)[0]));
                                for (const t of e1)i[t.id] = a;
                            }
                        }
                        return i;
                    }(e1.buckets, null == i ? void 0 : i.style), this.hasSymbolBuckets = !1;
                    for(const e1 in this.buckets){
                        const i = this.buckets[e1];
                        if (i instanceof t.ai) {
                            if (this.hasSymbolBuckets = !0, !a) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const e1 in this.buckets){
                        const i = this.buckets[e1];
                        if (i instanceof t.ai && i.hasRTLText) {
                            this.hasRTLText = !0, ce().lazyLoad();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const e1 in this.buckets){
                        const t = this.buckets[e1];
                        this.queryPadding = Math.max(this.queryPadding, i.style.getLayer(e1).queryRadius(t));
                    }
                    e1.imageAtlas && (this.imageAtlas = e1.imageAtlas), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage), this.dashPositions = e1.dashPositions;
                } else this.collisionBoxArray = new t.ah;
            }
            unloadVectorData() {
                for(const e1 in this.buckets)this.buckets[e1].destroy();
                this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.dashPositions && (this.dashPositions = null), this.latestFeatureIndex = null, this.state = "unloaded";
            }
            getBucket(e1) {
                return this.buckets[e1.id];
            }
            upload(e1) {
                for(const t in this.buckets){
                    const i = this.buckets[t];
                    i.uploadPending() && i.upload(e1);
                }
                const i = e1.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new t.T(e1, this.imageAtlas.image, i.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new t.T(e1, this.glyphAtlasImage, i.ALPHA), this.glyphAtlasImage = null);
            }
            prepare(e1) {
                this.imageAtlas && this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture);
            }
            queryRenderedFeatures(e1, t, i, a, r, o, s, n, l, c, h) {
                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                    queryGeometry: a,
                    cameraQueryGeometry: r,
                    scale: o,
                    tileSize: this.tileSize,
                    pixelPosMatrix: c,
                    transform: n,
                    params: s,
                    queryPadding: this.queryPadding * l,
                    getElevation: h
                }, e1, t, i) : {};
            }
            querySourceFeatures(e1, i) {
                const a = this.latestFeatureIndex;
                if (!a || !a.rawTileData) return;
                const r = a.loadVTLayers(), o = i && i.sourceLayer ? i.sourceLayer : "", s = r[t.a9] || r[o];
                if (!s) return;
                const n = t.aj(null == i ? void 0 : i.filter, null == i ? void 0 : i.globalState), { z: l, x: c, y: h } = this.tileID.canonical, u = {
                    z: l,
                    x: c,
                    y: h
                };
                for(let i = 0; i < s.length; i++){
                    const r = s.feature(i);
                    if (n.needGeometry) {
                        const e1 = t.ak(r, !0);
                        if (!n.filter(new t.H(this.tileID.overscaledZ), e1, this.tileID.canonical)) continue;
                    } else if (!n.filter(new t.H(this.tileID.overscaledZ), r)) continue;
                    const d = a.getId(r, o), _ = new t.al(r, l, c, h, d);
                    _.tile = u, e1.push(_);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(e1) {
                const i = this.expirationTime;
                if (e1.cacheControl) {
                    const i = t.am(e1.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
                if (this.expirationTime) {
                    const e1 = Date.now();
                    let t = !1;
                    if (this.expirationTime > e1) t = !1;
                    else if (i) {
                        if (this.expirationTime < i) t = !0;
                        else {
                            const a = this.expirationTime - i;
                            a ? this.expirationTime = e1 + Math.max(a, 3e4) : t = !0;
                        }
                    } else t = !0;
                    t ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(e1, i) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(e1).length) return;
                const a = this.latestFeatureIndex.loadVTLayers();
                for(const r in this.buckets){
                    if (!i.style.hasLayer(r)) continue;
                    const o = this.buckets[r], s = o.layers[0].sourceLayer || t.a9, n = a[s], l = e1[s];
                    if (!n || !l || 0 === Object.keys(l).length) continue;
                    o.update(l, n, this.imageAtlas && this.imageAtlas.patternPositions || {}, this.dashPositions || {});
                    const c = i && i.style && i.style.getLayer(r);
                    c && (this.queryPadding = Math.max(this.queryPadding, c.queryRadius(o)));
                }
            }
            holdingForSymbolFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < c();
            }
            clearSymbolFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setSymbolHoldDuration(e1) {
                this.symbolFadeHoldUntil = c() + e1;
            }
            setDependencies(e1, t) {
                const i = {};
                for (const e1 of t)i[e1] = !0;
                this.dependencies[e1] = i;
            }
            hasDependency(e1, t) {
                for (const i of e1){
                    const e1 = this.dependencies[i];
                    if (e1) {
                        for (const i of t)if (e1[i]) return !0;
                    }
                }
                return !1;
            }
        }
        class _e {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(e1, i, a) {
                const r = String(i);
                if (this.stateChanges[e1] = this.stateChanges[e1] || {}, this.stateChanges[e1][r] = this.stateChanges[e1][r] || {}, t.e(this.stateChanges[e1][r], a), null === this.deletedStates[e1]) {
                    this.deletedStates[e1] = {};
                    for(const t in this.state[e1])t !== r && (this.deletedStates[e1][t] = null);
                } else if (this.deletedStates[e1] && null === this.deletedStates[e1][r]) {
                    this.deletedStates[e1][r] = {};
                    for(const t in this.state[e1][r])a[t] || (this.deletedStates[e1][r][t] = null);
                } else for(const t in a)this.deletedStates[e1] && this.deletedStates[e1][r] && null === this.deletedStates[e1][r][t] && delete this.deletedStates[e1][r][t];
            }
            removeFeatureState(e1, t, i) {
                if (null === this.deletedStates[e1]) return;
                const a = String(t);
                if (this.deletedStates[e1] = this.deletedStates[e1] || {}, i && void 0 !== t) null !== this.deletedStates[e1][a] && (this.deletedStates[e1][a] = this.deletedStates[e1][a] || {}, this.deletedStates[e1][a][i] = null);
                else if (void 0 !== t) {
                    if (this.stateChanges[e1] && this.stateChanges[e1][a]) for(i in this.deletedStates[e1][a] = {}, this.stateChanges[e1][a])this.deletedStates[e1][a][i] = null;
                    else this.deletedStates[e1][a] = null;
                } else this.deletedStates[e1] = null;
            }
            getState(e1, i) {
                const a = String(i), r = t.e({}, (this.state[e1] || {})[a], (this.stateChanges[e1] || {})[a]);
                if (null === this.deletedStates[e1]) return {};
                if (this.deletedStates[e1]) {
                    const t = this.deletedStates[e1][i];
                    if (null === t) return {};
                    for(const e1 in t)delete r[e1];
                }
                return r;
            }
            initializeTileState(e1, t) {
                e1.setFeatureState(this.state, t);
            }
            coalesceChanges(e1, i) {
                const a = {};
                for(const e1 in this.stateChanges){
                    this.state[e1] = this.state[e1] || {};
                    const i = {};
                    for(const a in this.stateChanges[e1])this.state[e1][a] || (this.state[e1][a] = {}), t.e(this.state[e1][a], this.stateChanges[e1][a]), i[a] = this.state[e1][a];
                    a[e1] = i;
                }
                for(const e1 in this.deletedStates){
                    this.state[e1] = this.state[e1] || {};
                    const i = {};
                    if (null === this.deletedStates[e1]) for(const t in this.state[e1])i[t] = {}, this.state[e1][t] = {};
                    else for(const t in this.deletedStates[e1]){
                        if (null === this.deletedStates[e1][t]) this.state[e1][t] = {};
                        else for (const i of Object.keys(this.deletedStates[e1][t]))delete this.state[e1][t][i];
                        i[t] = this.state[e1][t];
                    }
                    a[e1] = a[e1] || {}, t.e(a[e1], i);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(a).length) for(const t in e1)e1[t].setFeatureState(a, i);
            }
        }
        const pe = 89.25;
        function me(e1, i) {
            const a = t.an(i.lat, -t.ao, t.ao);
            return new t.P(t.Y(i.lng) * e1, t.X(a) * e1);
        }
        function fe(e1, i) {
            return new t.aa(i.x / e1, i.y / e1).toLngLat();
        }
        function ge(e1) {
            return e1.cameraToCenterDistance * Math.min(.85 * Math.tan(t.ap(90 - e1.pitch)), Math.tan(t.ap(pe - e1.pitch)));
        }
        function ve(e1, i) {
            const a = e1.canonical, r = i / t.aq(a.z), o = a.x + Math.pow(2, a.z) * e1.wrap, s = t.ar(new Float64Array(16));
            return t.O(s, s, [
                o * r,
                a.y * r,
                0
            ]), t.Q(s, s, [
                r / t.a4,
                r / t.a4,
                1
            ]), s;
        }
        function xe(e1, i, a, r, o) {
            const s = t.aa.fromLngLat(e1, i), n = o * t.as(1, e1.lat), l = n * Math.cos(t.ap(a)), c = Math.sqrt(n * n - l * l), h = c * Math.sin(t.ap(-r)), u = c * Math.cos(t.ap(-r));
            return new t.aa(s.x + h, s.y + u, s.z + l);
        }
        function be(e1, t, i) {
            const a = t.intersectsFrustum(e1);
            if (!i || 0 === a) return a;
            const r = t.intersectsPlane(i);
            return 0 === r ? 0 : 2 === a && 2 === r ? 2 : 1;
        }
        function ye(e1, t, i) {
            let a = 0;
            const r = (i - t) / 10;
            for(let o = 0; o < 10; o++)a += r * Math.pow(Math.cos(t + (o + .5) / 10 * (i - t)), e1);
            return a;
        }
        function we(e1, i) {
            return function(a, r, o, s, n) {
                const l = 2 * ((e1 - 1) / t.at(Math.cos(t.ap(pe - n)) / Math.cos(t.ap(pe))) - 1), c = Math.acos(o / s), h = 2 * ye(l - 1, 0, t.ap(n / 2)), u = Math.min(t.ap(pe), c + t.ap(n / 2)), d = ye(l - 1, Math.min(u, c - t.ap(n / 2)), u), _ = Math.atan(r / o), p = Math.hypot(r, o);
                let m = a;
                return m += t.at(s / p / Math.max(.5, Math.cos(t.ap(n / 2)))), m += l * t.at(Math.cos(_)) / 2, m -= t.at(Math.max(1, d / h / i)) / 2, m;
            };
        }
        const Te = we(9.314, 3);
        function Pe(e1, i) {
            const a = (i.roundZoom ? Math.round : Math.floor)(e1.zoom + t.at(e1.tileSize / i.tileSize));
            return Math.max(0, a);
        }
        function Ce(e1, i) {
            const a = e1.getCameraFrustum(), r = e1.getClippingPlane(), o = e1.screenPointToMercatorCoordinate(e1.getCameraPoint()), s = t.aa.fromLngLat(e1.center, e1.elevation);
            o.z = s.z + Math.cos(e1.pitchInRadians) * e1.cameraToCenterDistance / e1.worldSize;
            const n = e1.getCoveringTilesDetailsProvider(), l = n.allowVariableZoom(e1, i), c = Pe(e1, i), h = i.minzoom || 0, u = void 0 !== i.maxzoom ? i.maxzoom : e1.maxZoom, d = Math.min(Math.max(0, c), u), _ = Math.pow(2, d), p = [
                _ * o.x,
                _ * o.y,
                0
            ], m = [
                _ * s.x,
                _ * s.y,
                0
            ], f = Math.hypot(s.x - o.x, s.y - o.y), g = Math.abs(s.z - o.z), v = Math.hypot(f, g), x = (e1)=>({
                    zoom: 0,
                    x: 0,
                    y: 0,
                    wrap: e1,
                    fullyVisible: !1
                }), b = [], y = [];
            if (e1.renderWorldCopies && n.allowWorldCopies()) for(let e1 = 1; e1 <= 3; e1++)b.push(x(-e1)), b.push(x(e1));
            for(b.push(x(0)); b.length > 0;){
                const _ = b.pop(), f = _.x, x = _.y;
                let w = _.fullyVisible;
                const T = {
                    x: f,
                    y: x,
                    z: _.zoom
                }, P = n.getTileBoundingVolume(T, _.wrap, e1.elevation, i);
                if (!w) {
                    const e1 = be(a, P, r);
                    if (0 === e1) continue;
                    w = 2 === e1;
                }
                const C = n.distanceToTile2d(o.x, o.y, T, P);
                let M = c;
                l && (M = (i.calculateTileZoom || Te)(e1.zoom + t.at(e1.tileSize / i.tileSize), C, g, v, e1.fov)), M = (i.roundZoom ? Math.round : Math.floor)(M), M = Math.max(0, M);
                const I = Math.min(M, u);
                if (_.wrap = n.getWrap(s, T, _.wrap), _.zoom >= I) {
                    if (_.zoom < h) continue;
                    const e1 = d - _.zoom, a = p[0] - .5 - (f << e1), r = p[1] - .5 - (x << e1), o = i.reparseOverscaled ? Math.max(_.zoom, M) : _.zoom;
                    y.push({
                        tileID: new t.a1(_.zoom === u ? o : _.zoom, _.wrap, _.zoom, f, x),
                        distanceSq: t.au([
                            m[0] - .5 - f,
                            m[1] - .5 - x
                        ]),
                        tileDistanceToCamera: Math.sqrt(a * a + r * r)
                    });
                } else for(let e1 = 0; e1 < 4; e1++)b.push({
                    zoom: _.zoom + 1,
                    x: (f << 1) + e1 % 2,
                    y: (x << 1) + (e1 >> 1),
                    wrap: _.wrap,
                    fullyVisible: w
                });
            }
            return y.sort((e1, t)=>e1.distanceSq - t.distanceSq).map((e1)=>e1.tileID);
        }
        const Me = t.ab.fromPoints([
            new t.P(0, 0),
            new t.P(t.a4, t.a4)
        ]);
        class Ie extends t.E {
            constructor(e1, i, a){
                super(), this.id = e1, this.dispatcher = a, this.on("data", (e1)=>this._dataHandler(e1)), this.on("dataloading", ()=>{
                    this._sourceErrored = !1;
                }), this.on("error", ()=>{
                    this._sourceErrored = this._source.loaded();
                }), this._source = ((e1, t, i, a)=>{
                    const r = new (oe(t.type))(e1, t, i, a);
                    if (r.id !== e1) throw new Error(`Expected Source id to be ${e1} instead of ${r.id}`);
                    return r;
                })(e1, i, a, this), this._tiles = {}, this._cache = new t.av(0, (e1)=>this._unloadTile(e1)), this._timers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._rasterFadeDuration = 0, this._maxFadingAncestorLevels = 5, this._state = new _e, this._didEmitContent = !1, this._updated = !1;
            }
            onAdd(e1) {
                this.map = e1, this._maxTileCacheSize = e1 ? e1._maxTileCacheSize : null, this._maxTileCacheZoomLevels = e1 ? e1._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(e1);
            }
            onRemove(e1) {
                this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(e1);
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
                if (!this._updated) return !1;
                for(const e1 in this._tiles){
                    const t = this._tiles[e1];
                    if ("loaded" !== t.state && "errored" !== t.state) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            getState() {
                return this._state;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e1 = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e1 && this.reload(), this.transform && this.update(this.transform, this.terrain);
            }
            _loadTile(e1, i, a) {
                return t._(this, void 0, void 0, function*() {
                    try {
                        yield this._source.loadTile(e1), this._tileLoaded(e1, i, a);
                    } catch (i) {
                        e1.state = "errored", 404 !== i.status ? this._source.fire(new t.k(i, {
                            tile: e1
                        })) : this.update(this.transform, this.terrain);
                    }
                });
            }
            _unloadTile(e1) {
                this._source.unloadTile && this._source.unloadTile(e1);
            }
            _abortTile(e1) {
                this._source.abortTile && this._source.abortTile(e1), this._source.fire(new t.l("dataabort", {
                    tile: e1,
                    coord: e1.tileID,
                    dataType: "source"
                }));
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e1) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const t in this._tiles){
                    const i = this._tiles[t];
                    i.upload(e1), i.prepare(this.map.style.imageManager);
                }
            }
            getIds() {
                return Object.values(this._tiles).map((e1)=>e1.tileID).sort(Ee).map((e1)=>e1.key);
            }
            getRenderableIds(e1) {
                const i = [];
                for(const t in this._tiles)this._isIdRenderable(t, e1) && i.push(this._tiles[t]);
                return e1 ? i.sort((e1, i)=>{
                    const a = e1.tileID, r = i.tileID, o = new t.P(a.canonical.x, a.canonical.y)._rotate(-this.transform.bearingInRadians), s = new t.P(r.canonical.x, r.canonical.y)._rotate(-this.transform.bearingInRadians);
                    return a.overscaledZ - r.overscaledZ || s.y - o.y || s.x - o.x;
                }).map((e1)=>e1.tileID.key) : i.map((e1)=>e1.tileID).sort(Ee).map((e1)=>e1.key);
            }
            hasRenderableParent(e1) {
                const t = e1.overscaledZ - 1;
                if (t >= this._source.minzoom) {
                    const i = this.getLoadedTile(e1.scaledTo(t));
                    if (i) return this._isIdRenderable(i.tileID.key);
                }
                return !1;
            }
            _isIdRenderable(e1, t = !1) {
                var i;
                return null === (i = this._tiles[e1]) || void 0 === i ? void 0 : i.isRenderable(t);
            }
            reload(e1, t) {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const i in this._tiles)t && this._source.shouldReloadTile && !this._source.shouldReloadTile(this._tiles[i], t) || (e1 ? this._reloadTile(i, "expired") : "errored" !== this._tiles[i].state && this._reloadTile(i, "reloading"));
                }
            }
            _reloadTile(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    const t = this._tiles[e1];
                    t && ("loading" !== t.state && (t.state = i), yield this._loadTile(t, e1, i));
                });
            }
            _tileLoaded(e1, i, a) {
                e1.timeAdded = c(), e1.selfFading && (e1.fadeEndTime = e1.timeAdded + this._rasterFadeDuration), "expired" === a && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, e1), "raster-dem" === this.getSource().type && e1.dem && this._backfillDEM(e1), this._state.initializeTileState(e1, this.map ? this.map.painter : null), e1.aborted || this._source.fire(new t.l("data", {
                    dataType: "source",
                    tile: e1,
                    coord: e1.tileID
                }));
            }
            _backfillDEM(e1) {
                const t = this.getRenderableIds();
                for(let a = 0; a < t.length; a++){
                    const r = t[a];
                    if (e1.neighboringTiles && e1.neighboringTiles[r]) {
                        const t = this.getTileByID(r);
                        i(e1, t), i(t, e1);
                    }
                }
                function i(e1, t) {
                    e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0;
                    let i = t.tileID.canonical.x - e1.tileID.canonical.x;
                    const a = t.tileID.canonical.y - e1.tileID.canonical.y, r = Math.pow(2, e1.tileID.canonical.z), o = t.tileID.key;
                    0 === i && 0 === a || Math.abs(a) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + r) ? i += r : 1 === Math.abs(i - r) && (i -= r)), t.dem && e1.dem && (e1.dem.backfillBorder(t.dem, i, a), e1.neighboringTiles && e1.neighboringTiles[o] && (e1.neighboringTiles[o].backfilled = !0)));
                }
            }
            getTile(e1) {
                return this.getTileByID(e1.key);
            }
            getTileByID(e1) {
                return this._tiles[e1];
            }
            _retainLoadedChildren(e1, t) {
                const i = this._getLoadedDescendents(t), a = new Set;
                for (const r of t){
                    const t = i[r.key];
                    if (!(null == t ? void 0 : t.length)) {
                        a.add(r);
                        continue;
                    }
                    const o = r.overscaledZ + Ie.maxOverzooming, s = t.filter((e1)=>e1.tileID.overscaledZ <= o);
                    if (!s.length) {
                        a.add(r);
                        continue;
                    }
                    const n = Math.min(...s.map((e1)=>e1.tileID.overscaledZ)), l = s.filter((e1)=>e1.tileID.overscaledZ === n).map((e1)=>e1.tileID);
                    for (const t of l)e1[t.key] = t;
                    this._areDescendentsComplete(l, n, r.overscaledZ) || a.add(r);
                }
                return a;
            }
            _getLoadedDescendents(e1) {
                var t;
                const i = {};
                for(const a in this._tiles){
                    const r = this._tiles[a];
                    if (r.hasData()) for (const a of e1)r.tileID.isChildOf(a) && (i[t = a.key] || (i[t] = [])).push(r);
                }
                return i;
            }
            _areDescendentsComplete(e1, t, i) {
                return 1 === e1.length && e1[0].isOverscaled() ? e1[0].overscaledZ === t : Math.pow(4, t - i) === e1.length;
            }
            getLoadedTile(e1) {
                const t = this._tiles[e1.key];
                return (null == t ? void 0 : t.hasData()) ? t : null;
            }
            updateCacheSize(e1) {
                const i = Math.ceil(e1.width / this._source.tileSize) + 1, a = Math.ceil(e1.height / this._source.tileSize) + 1, r = Math.floor(i * a * (null === this._maxTileCacheZoomLevels ? t.a.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), o = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, r) : r;
                this._cache.setMaxSize(o);
            }
            handleWrapJump(e1) {
                const t = Math.round((e1 - (void 0 === this._prevLng ? e1 : this._prevLng)) / 360);
                if (this._prevLng = e1, t) {
                    const e1 = {};
                    for(const i in this._tiles){
                        const a = this._tiles[i];
                        a.tileID = a.tileID.unwrapTo(a.tileID.wrap + t), e1[a.tileID.key] = a;
                    }
                    this._tiles = e1, this._resetTileReloadTimers();
                }
            }
            update(e1, i) {
                if (!this._sourceLoaded || this._paused) return;
                let a;
                this.transform = e1, this.terrain = i, this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng), this.used || this.usedForTerrain ? this._source.tileID ? a = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map((e1)=>new t.a1(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y)) : (a = Ce(e1, {
                    tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: "vector" === this._source.type && void 0 !== this.map._zoomLevelsToOverscale ? e1.maxZoom - this.map._zoomLevelsToOverscale : this._source.maxzoom,
                    roundZoom: !this.usedForTerrain && this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled,
                    terrain: i,
                    calculateTileZoom: this._source.calculateTileZoom
                }), this._source.hasTile && (a = a.filter((e1)=>this._source.hasTile(e1)))) : a = [], this.usedForTerrain && (a = this._addTerrainIdealTiles(a));
                const r = 0 === a.length && !this._updated && this._didEmitContent;
                this._updated = !0, r && this.fire(new t.l("data", {
                    sourceDataType: "idle",
                    dataType: "source",
                    sourceId: this.id
                }));
                const o = Pe(e1, this._source), s = this._updateRetainedTiles(a, o), n = Se(this._source.type);
                n && this._rasterFadeDuration > 0 && !i && this._updateFadingTiles(a, s), n ? this._cleanUpRasterTiles(s) : this._cleanUpVectorTiles(s);
            }
            _cleanUpRasterTiles(e1) {
                for(const t in this._tiles)e1[t] || this._removeTile(t);
            }
            _cleanUpVectorTiles(e1) {
                for(const t in this._tiles){
                    const i = this._tiles[t];
                    e1[t] ? i.clearSymbolFadeHold() : i.hasSymbolBuckets ? i.holdingForSymbolFade() ? i.symbolFadeFinished() && this._removeTile(t) : i.setSymbolHoldDuration(this.map._fadeDuration) : this._removeTile(t);
                }
            }
            _addTerrainIdealTiles(e1) {
                const t = [];
                for (const i of e1)if (i.canonical.z > this._source.minzoom) {
                    const e1 = i.scaledTo(i.canonical.z - 1);
                    t.push(e1);
                    const a = i.scaledTo(Math.max(this._source.minzoom, Math.min(i.canonical.z, 5)));
                    t.push(a);
                }
                return e1.concat(t);
            }
            releaseSymbolFadeTiles() {
                for(const e1 in this._tiles)this._tiles[e1].holdingForSymbolFade() && this._removeTile(e1);
            }
            _updateRetainedTiles(e1, t) {
                var i;
                const a = new Set;
                for (const t of e1)this._addTile(t).hasData() || a.add(t);
                const r = e1.reduce((e1, t)=>(e1[t.key] = t, e1), {}), o = this._retainLoadedChildren(r, a), s = {}, n = Math.max(t - Ie.maxUnderzooming, this._source.minzoom);
                for (const e1 of o){
                    let t = this._tiles[e1.key], a = null == t ? void 0 : t.wasRequested();
                    for(let o = e1.overscaledZ - 1; o >= n; --o){
                        const n = e1.scaledTo(o);
                        if (s[n.key]) break;
                        if (s[n.key] = !0, t = this.getTile(n), !t && a && (t = this._addTile(n)), t) {
                            const e1 = t.hasData();
                            if ((e1 || !(null === (i = this.map) || void 0 === i ? void 0 : i.cancelPendingTileRequestsWhileZooming) || a) && (r[n.key] = n), a = t.wasRequested(), e1) break;
                        }
                    }
                }
                return r;
            }
            _updateFadingTiles(e1, i) {
                const a = c(), r = t.aw(e1);
                for (const t of e1){
                    const e1 = this._tiles[t.key];
                    e1.fadingDirection !== ue.Departing && 0 !== e1.fadeOpacity || e1.resetFadeLogic(), this._updateFadingAncestor(e1, i, a) || this._updateFadingDescendents(e1, i, a) || this._updateFadingEdge(e1, r, a) || e1.resetFadeLogic();
                }
            }
            _updateFadingAncestor(e1, t, i) {
                if (!e1.hasData()) return !1;
                const { tileID: a, fadingRole: r, fadingDirection: o, fadingParentID: s } = e1;
                if (r === he.Base && o === ue.Incoming && s) return t[s.key] = s, !0;
                const n = Math.max(a.overscaledZ - this._maxFadingAncestorLevels, this._source.minzoom);
                for(let r = a.overscaledZ - 1; r >= n; r--){
                    const o = a.scaledTo(r), s = this.getLoadedTile(o);
                    if (s) return e1.setCrossFadeLogic({
                        fadingRole: he.Base,
                        fadingDirection: ue.Incoming,
                        fadingParentID: s.tileID,
                        fadeEndTime: i + this._rasterFadeDuration
                    }), s.setCrossFadeLogic({
                        fadingRole: he.Parent,
                        fadingDirection: ue.Departing,
                        fadeEndTime: i + this._rasterFadeDuration
                    }), t[o.key] = o, !0;
                }
                return !1;
            }
            _updateFadingDescendents(e1, t, i) {
                if (!e1.hasData()) return !1;
                const a = e1.tileID.children(this._source.maxzoom);
                let r = this._updateFadingChildren(e1, a, t, i);
                if (r) return !0;
                for (const o of a){
                    const a = o.children(this._source.maxzoom);
                    this._updateFadingChildren(e1, a, t, i) && (r = !0);
                }
                return r;
            }
            _updateFadingChildren(e1, t, i, a) {
                if (t[0].overscaledZ >= this._source.maxzoom) return !1;
                let r = !1;
                for (const o of t){
                    const t = this.getLoadedTile(o);
                    if (!t) continue;
                    const { fadingRole: s, fadingDirection: n, fadingParentID: l } = t;
                    s === he.Base && n === ue.Departing && l || (t.setCrossFadeLogic({
                        fadingRole: he.Base,
                        fadingDirection: ue.Departing,
                        fadingParentID: e1.tileID,
                        fadeEndTime: a + this._rasterFadeDuration
                    }), e1.setCrossFadeLogic({
                        fadingRole: he.Parent,
                        fadingDirection: ue.Incoming,
                        fadeEndTime: a + this._rasterFadeDuration
                    })), i[o.key] = o, r = !0;
                }
                return r;
            }
            _updateFadingEdge(e1, t, i) {
                const a = e1.tileID;
                return !!e1.selfFading || !e1.hasData() && !!t.has(a) && (e1.setSelfFadeLogic(i + this._rasterFadeDuration), !0);
            }
            _addTile(e1) {
                let i = this._tiles[e1.key];
                if (i) return i;
                i = this._cache.getAndRemove(e1), i && (i.resetFadeLogic(), this._setTileReloadTimer(e1.key, i), i.tileID = e1, this._state.initializeTileState(i, this.map ? this.map.painter : null));
                const a = i;
                return i || (i = new de(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(i, e1.key, i.state)), i.uses++, this._tiles[e1.key] = i, a || this._source.fire(new t.l("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(e1, t) {
                this._clearTileReloadTimer(e1);
                const i = t.getExpiryTimeout();
                i && (this._timers[e1] = setTimeout(()=>{
                    this._reloadTile(e1, "expired"), delete this._timers[e1];
                }, i));
            }
            _clearTileReloadTimer(e1) {
                const t = this._timers[e1];
                t && (clearTimeout(t), delete this._timers[e1]);
            }
            _resetTileReloadTimers() {
                for(const e1 in this._timers)clearTimeout(this._timers[e1]), delete this._timers[e1];
                for(const e1 in this._tiles)this._setTileReloadTimer(e1, this._tiles[e1]);
            }
            refreshTiles(e1) {
                for(const t in this._tiles)(this._isIdRenderable(t) || "errored" == this._tiles[t].state) && e1.some((e1)=>e1.equals(this._tiles[t].tileID.canonical)) && this._reloadTile(t, "expired");
            }
            _removeTile(e1) {
                const t = this._tiles[e1];
                t && (t.uses--, delete this._tiles[e1], this._clearTileReloadTimer(e1), t.uses > 0 || (t.hasData() && "reloading" !== t.state ? this._cache.add(t.tileID, t, t.getExpiryTimeout()) : (t.aborted = !0, this._abortTile(t), this._unloadTile(t))));
            }
            _dataHandler(e1) {
                "source" === e1.dataType && ("metadata" !== e1.sourceDataType ? "content" === e1.sourceDataType && this._sourceLoaded && !this._paused && (this.reload(e1.sourceDataChanged, e1.shouldReloadTileOptions), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0) : this._sourceLoaded = !0);
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const e1 in this._tiles)this._removeTile(e1);
                this._cache.reset();
            }
            tilesIn(e1, i, a) {
                const r = [], o = this.transform;
                if (!o) return r;
                const s = o.getCoveringTilesDetailsProvider().allowWorldCopies(), n = a ? o.getCameraQueryGeometry(e1) : e1, l = (e1)=>o.screenPointToMercatorCoordinate(e1, this.terrain), c = this.transformBbox(e1, l, !s), h = this.transformBbox(n, l, !s), u = this.getIds(), d = t.ab.fromPoints(h);
                for(let e1 = 0; e1 < u.length; e1++){
                    const a = this._tiles[u[e1]];
                    if (a.holdingForSymbolFade()) continue;
                    const n = s ? [
                        a.tileID
                    ] : [
                        a.tileID.unwrapTo(-1),
                        a.tileID.unwrapTo(0)
                    ], l = Math.pow(2, o.zoom - a.tileID.overscaledZ), _ = i * a.queryPadding * t.a4 / a.tileSize / l;
                    for (const e1 of n){
                        const i = d.map((i)=>e1.getTilePoint(new t.aa(i.x, i.y)));
                        if (i.expandBy(_), i.intersects(Me)) {
                            const t = c.map((t)=>e1.getTilePoint(t)), i = h.map((t)=>e1.getTilePoint(t));
                            r.push({
                                tile: a,
                                tileID: s ? e1 : e1.unwrapTo(0),
                                queryGeometry: t,
                                cameraQueryGeometry: i,
                                scale: l
                            });
                        }
                    }
                }
                return r;
            }
            transformBbox(e1, i, a) {
                let r = e1.map(i);
                if (a) {
                    const a = t.ab.fromPoints(e1);
                    a.shrinkBy(.001 * Math.min(a.width(), a.height()));
                    const o = a.map(i);
                    t.ab.fromPoints(r).covers(o) || (r = r.map((e1)=>e1.x > .5 ? new t.aa(e1.x - 1, e1.y, e1.z) : e1));
                }
                return r;
            }
            getVisibleCoordinates(e1) {
                const t = this.getRenderableIds(e1).map((e1)=>this._tiles[e1].tileID);
                return this.transform && this.transform.populateCache(t), t;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (Se(this._source.type) && this._rasterFadeDuration > 0) {
                    const e1 = c();
                    for(const t in this._tiles)if (this._tiles[t].fadeEndTime >= e1) return !0;
                }
                return !1;
            }
            setRasterFadeDuration(e1) {
                this._rasterFadeDuration = e1;
            }
            setFeatureState(e1, i, a) {
                this._state.updateState(e1 = e1 || t.a9, i, a);
            }
            removeFeatureState(e1, i, a) {
                this._state.removeFeatureState(e1 = e1 || t.a9, i, a);
            }
            getFeatureState(e1, i) {
                return this._state.getState(e1 = e1 || t.a9, i);
            }
            setDependencies(e1, t, i) {
                const a = this._tiles[e1];
                a && a.setDependencies(t, i);
            }
            reloadTilesForDependencies(e1, t) {
                for(const i in this._tiles)this._tiles[i].hasDependency(e1, t) && this._reloadTile(i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(e1, t));
            }
        }
        function Ee(e1, t) {
            const i = Math.abs(2 * e1.wrap) - +(e1.wrap < 0), a = Math.abs(2 * t.wrap) - +(t.wrap < 0);
            return e1.overscaledZ - t.overscaledZ || a - i || t.canonical.y - e1.canonical.y || t.canonical.x - e1.canonical.x;
        }
        function Se(e1) {
            return "raster" === e1 || "image" === e1 || "video" === e1;
        }
        Ie.maxUnderzooming = 10, Ie.maxOverzooming = 3;
        class Re {
            constructor(e1, t){
                this.reset(e1, t);
            }
            reset(e1, t) {
                this.points = e1 || [], this._distances = [
                    0
                ];
                for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(e1) {
                if (1 === this.points.length) return this.points[0];
                e1 = t.an(e1, 0, 1);
                let i = 1, a = this._distances[i];
                const r = e1 * this.paddedLength + this.padding;
                for(; a < r && i < this._distances.length;)a = this._distances[++i];
                const o = i - 1, s = this._distances[o], n = a - s, l = n > 0 ? (r - s) / n : 0;
                return this.points[o].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        function De(e1, t) {
            let i = !0;
            return "always" === e1 || "never" !== e1 && "never" !== t || (i = !1), i;
        }
        class ze {
            constructor(e1, t, i){
                const a = this.boxCells = [], r = this.circleCells = [];
                this.xCellCount = Math.ceil(e1 / i), this.yCellCount = Math.ceil(t / i);
                for(let e1 = 0; e1 < this.xCellCount * this.yCellCount; e1++)a.push([]), r.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e1, t, i, a, r) {
                this._forEachCell(t, i, a, r, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t), this.bboxes.push(i), this.bboxes.push(a), this.bboxes.push(r);
            }
            insertCircle(e1, t, i, a) {
                this._forEachCell(t - a, i - a, t + a, i + a, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t), this.circles.push(i), this.circles.push(a);
            }
            _insertBoxCell(e1, t, i, a, r, o) {
                this.boxCells[r].push(o);
            }
            _insertCircleCell(e1, t, i, a, r, o) {
                this.circleCells[r].push(o);
            }
            _query(e1, t, i, a, r, o, s) {
                if (i < 0 || e1 > this.width || a < 0 || t > this.height) return [];
                const n = [];
                if (e1 <= 0 && t <= 0 && this.width <= i && this.height <= a) {
                    if (r) return [
                        {
                            key: null,
                            x1: e1,
                            y1: t,
                            x2: i,
                            y2: a
                        }
                    ];
                    for(let e1 = 0; e1 < this.boxKeys.length; e1++)n.push({
                        key: this.boxKeys[e1],
                        x1: this.bboxes[4 * e1],
                        y1: this.bboxes[4 * e1 + 1],
                        x2: this.bboxes[4 * e1 + 2],
                        y2: this.bboxes[4 * e1 + 3]
                    });
                    for(let e1 = 0; e1 < this.circleKeys.length; e1++){
                        const t = this.circles[3 * e1], i = this.circles[3 * e1 + 1], a = this.circles[3 * e1 + 2];
                        n.push({
                            key: this.circleKeys[e1],
                            x1: t - a,
                            y1: i - a,
                            x2: t + a,
                            y2: i + a
                        });
                    }
                } else this._forEachCell(e1, t, i, a, this._queryCell, n, {
                    hitTest: r,
                    overlapMode: o,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, s);
                return n;
            }
            query(e1, t, i, a) {
                return this._query(e1, t, i, a, !1, null);
            }
            hitTest(e1, t, i, a, r, o) {
                return this._query(e1, t, i, a, !0, r, o).length > 0;
            }
            hitTestCircle(e1, t, i, a, r) {
                const o = e1 - i, s = e1 + i, n = t - i, l = t + i;
                if (s < 0 || o > this.width || l < 0 || n > this.height) return !1;
                const c = [];
                return this._forEachCell(o, n, s, l, this._queryCellCircle, c, {
                    hitTest: !0,
                    overlapMode: a,
                    circle: {
                        x: e1,
                        y: t,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r), c.length > 0;
            }
            _queryCell(e1, t, i, a, r, o, s, n) {
                const { seenUids: l, hitTest: c, overlapMode: h } = s, u = this.boxCells[r];
                if (null !== u) {
                    const r = this.bboxes;
                    for (const s of u)if (!l.box[s]) {
                        l.box[s] = !0;
                        const u = 4 * s, d = this.boxKeys[s];
                        if (e1 <= r[u + 2] && t <= r[u + 3] && i >= r[u + 0] && a >= r[u + 1] && (!n || n(d)) && (!c || !De(h, d.overlapMode)) && (o.push({
                            key: d,
                            x1: r[u],
                            y1: r[u + 1],
                            x2: r[u + 2],
                            y2: r[u + 3]
                        }), c)) return !0;
                    }
                }
                const d = this.circleCells[r];
                if (null !== d) {
                    const r = this.circles;
                    for (const s of d)if (!l.circle[s]) {
                        l.circle[s] = !0;
                        const u = 3 * s, d = this.circleKeys[s];
                        if (this._circleAndRectCollide(r[u], r[u + 1], r[u + 2], e1, t, i, a) && (!n || n(d)) && (!c || !De(h, d.overlapMode))) {
                            const e1 = r[u], t = r[u + 1], i = r[u + 2];
                            if (o.push({
                                key: d,
                                x1: e1 - i,
                                y1: t - i,
                                x2: e1 + i,
                                y2: t + i
                            }), c) return !0;
                        }
                    }
                }
                return !1;
            }
            _queryCellCircle(e1, t, i, a, r, o, s, n) {
                const { circle: l, seenUids: c, overlapMode: h } = s, u = this.boxCells[r];
                if (null !== u) {
                    const e1 = this.bboxes;
                    for (const t of u)if (!c.box[t]) {
                        c.box[t] = !0;
                        const i = 4 * t, a = this.boxKeys[t];
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e1[i + 0], e1[i + 1], e1[i + 2], e1[i + 3]) && (!n || n(a)) && !De(h, a.overlapMode)) return o.push(!0), !0;
                    }
                }
                const d = this.circleCells[r];
                if (null !== d) {
                    const e1 = this.circles;
                    for (const t of d)if (!c.circle[t]) {
                        c.circle[t] = !0;
                        const i = 3 * t, a = this.circleKeys[t];
                        if (this._circlesCollide(e1[i], e1[i + 1], e1[i + 2], l.x, l.y, l.radius) && (!n || n(a)) && !De(h, a.overlapMode)) return o.push(!0), !0;
                    }
                }
            }
            _forEachCell(e1, t, i, a, r, o, s, n) {
                const l = this._convertToXCellCoord(e1), c = this._convertToYCellCoord(t), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(a);
                for(let d = l; d <= h; d++)for(let l = c; l <= u; l++)if (r.call(this, e1, t, i, a, this.xCellCount * l + d, o, s, n)) return;
            }
            _convertToXCellCoord(e1) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
            }
            _convertToYCellCoord(e1) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
            }
            _circlesCollide(e1, t, i, a, r, o) {
                const s = a - e1, n = r - t, l = i + o;
                return l * l > s * s + n * n;
            }
            _circleAndRectCollide(e1, t, i, a, r, o, s) {
                const n = (o - a) / 2, l = Math.abs(e1 - (a + n));
                if (l > n + i) return !1;
                const c = (s - r) / 2, h = Math.abs(t - (r + c));
                if (h > c + i) return !1;
                if (l <= n || h <= c) return !0;
                const u = l - n, d = h - c;
                return u * u + d * d <= i * i;
            }
        }
        function Ae(e1, i, r) {
            const o = t.N();
            if (!e1) {
                const { vecSouth: e1, vecEast: t } = ke(i), r = a();
                r[0] = t[0], r[1] = t[1], r[2] = e1[0], r[3] = e1[1], s = r, (d = (l = (n = r)[0]) * (u = n[3]) - (h = n[2]) * (c = n[1])) && (s[0] = u * (d = 1 / d), s[1] = -c * d, s[2] = -h * d, s[3] = l * d), o[0] = r[0], o[1] = r[1], o[4] = r[2], o[5] = r[3];
            }
            var s, n, l, c, h, u, d;
            return t.Q(o, o, [
                1 / r,
                1 / r,
                1
            ]), o;
        }
        function Le(e1, i, a, r) {
            if (e1) {
                const e1 = t.N();
                if (!i) {
                    const { vecSouth: t, vecEast: i } = ke(a);
                    e1[0] = i[0], e1[1] = i[1], e1[4] = t[0], e1[5] = t[1];
                }
                return t.Q(e1, e1, [
                    r,
                    r,
                    1
                ]), e1;
            }
            return a.pixelsToClipSpaceMatrix;
        }
        function ke(e1) {
            const i = Math.cos(e1.rollInRadians), a = Math.sin(e1.rollInRadians), r = Math.cos(e1.pitchInRadians), o = Math.cos(e1.bearingInRadians), s = Math.sin(e1.bearingInRadians), n = t.aB();
            n[0] = -o * r * a - s * i, n[1] = -s * r * a + o * i;
            const l = t.aC(n);
            l < 1e-9 ? t.aD(n) : t.aE(n, n, 1 / l);
            const c = t.aB();
            c[0] = o * r * i - s * a, c[1] = s * r * i + o * a;
            const h = t.aC(c);
            return h < 1e-9 ? t.aD(c) : t.aE(c, c, 1 / h), {
                vecEast: c,
                vecSouth: n
            };
        }
        function Fe(e1, i, a, r) {
            let o;
            r ? (o = [
                e1,
                i,
                r(e1, i),
                1
            ], t.aG(o, o, a)) : (o = [
                e1,
                i,
                0,
                1
            ], Je(o, o, a));
            const s = o[3];
            return {
                point: new t.P(o[0] / s, o[1] / s),
                signedDistanceFromCamera: s,
                isOccluded: !1
            };
        }
        function Be(e1, t) {
            return .5 + e1 / t * .5;
        }
        function Oe(e1, t) {
            return e1.x >= -t[0] && e1.x <= t[0] && e1.y >= -t[1] && e1.y <= t[1];
        }
        function je(e1, i, a, r, o, s, n, l, c, h, u, d, _) {
            const p = a ? e1.textSizeData : e1.iconSizeData, m = t.ax(p, i.transform.zoom), f = [
                256 / i.width * 2 + 1,
                256 / i.height * 2 + 1
            ], g = a ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
            g.clear();
            const v = e1.lineVertexArray, x = a ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, b = i.transform.width / i.transform.height;
            let y = !1;
            for(let a = 0; a < x.length; a++){
                const w = x.get(a);
                if (w.hidden || w.writingMode === t.ay.vertical && !y) {
                    Qe(w.numGlyphs, g);
                    continue;
                }
                y = !1;
                const T = new t.P(w.anchorX, w.anchorY), P = {
                    getElevation: _,
                    pitchedLabelPlaneMatrix: r,
                    lineVertexArray: v,
                    pitchWithMap: s,
                    projectionCache: {
                        projections: {},
                        offsets: {},
                        cachedAnchorPoint: void 0,
                        anyProjectionOccluded: !1
                    },
                    transform: i.transform,
                    tileAnchorPoint: T,
                    unwrappedTileID: c,
                    width: h,
                    height: u,
                    translation: d
                }, C = $e(w.anchorX, w.anchorY, P);
                if (!Oe(C.point, f)) {
                    Qe(w.numGlyphs, g);
                    continue;
                }
                const M = Be(i.transform.cameraToCenterDistance, C.signedDistanceFromCamera), I = t.az(p, m, w), E = s ? I * i.transform.getPitchedTextCorrection(w.anchorX, w.anchorY, c) / M : I * M, S = Ge({
                    projectionContext: P,
                    pitchedLabelPlaneMatrixInverse: o,
                    symbol: w,
                    fontSize: E,
                    flip: !1,
                    keepUpright: n,
                    glyphOffsetArray: e1.glyphOffsetArray,
                    dynamicLayoutVertexArray: g,
                    aspectRatio: b,
                    rotateToLine: l
                });
                y = S.useVertical, (S.notEnoughRoom || y || S.needsFlipping && Ge({
                    projectionContext: P,
                    pitchedLabelPlaneMatrixInverse: o,
                    symbol: w,
                    fontSize: E,
                    flip: !0,
                    keepUpright: n,
                    glyphOffsetArray: e1.glyphOffsetArray,
                    dynamicLayoutVertexArray: g,
                    aspectRatio: b,
                    rotateToLine: l
                }).notEnoughRoom) && Qe(w.numGlyphs, g);
            }
            a ? e1.text.dynamicLayoutVertexBuffer.updateData(g) : e1.icon.dynamicLayoutVertexBuffer.updateData(g);
        }
        function Ne(e1, t, i, a, r, o, s, n) {
            const l = o.glyphStartIndex + o.numGlyphs, c = o.lineStartIndex, h = o.lineStartIndex + o.lineLength, u = t.getoffsetX(o.glyphStartIndex), d = t.getoffsetX(l - 1), _ = Ke(e1 * u, i, a, r, o.segment, c, h, n, s);
            if (!_) return null;
            const p = Ke(e1 * d, i, a, r, o.segment, c, h, n, s);
            return p ? n.projectionCache.anyProjectionOccluded ? null : {
                first: _,
                last: p
            } : null;
        }
        function Ze(e1, i, a, r) {
            return e1 === t.ay.horizontal && Math.abs(a.y - i.y) > Math.abs(a.x - i.x) * r ? {
                useVertical: !0
            } : (e1 === t.ay.vertical ? i.y < a.y : i.x > a.x) ? {
                needsFlipping: !0
            } : null;
        }
        function Ge(e1) {
            const { projectionContext: i, pitchedLabelPlaneMatrixInverse: a, symbol: r, fontSize: o, flip: s, keepUpright: n, glyphOffsetArray: l, dynamicLayoutVertexArray: c, aspectRatio: h, rotateToLine: u } = e1, d = o / 24, _ = r.lineOffsetX * d, p = r.lineOffsetY * d;
            let m;
            if (r.numGlyphs > 1) {
                const e1 = r.glyphStartIndex + r.numGlyphs, t = r.lineStartIndex, o = r.lineStartIndex + r.lineLength, c = Ne(d, l, _, p, s, r, u, i);
                if (!c) return {
                    notEnoughRoom: !0
                };
                const f = We(c.first.point.x, c.first.point.y, i, a), g = We(c.last.point.x, c.last.point.y, i, a);
                if (n && !s) {
                    const e1 = Ze(r.writingMode, f, g, h);
                    if (e1) return e1;
                }
                m = [
                    c.first
                ];
                for(let a = r.glyphStartIndex + 1; a < e1 - 1; a++){
                    const e1 = Ke(d * l.getoffsetX(a), _, p, s, r.segment, t, o, i, u);
                    if (!e1) return {
                        notEnoughRoom: !0
                    };
                    m.push(e1);
                }
                m.push(c.last);
            } else {
                if (n && !s) {
                    const e1 = qe(i.tileAnchorPoint.x, i.tileAnchorPoint.y, i).point, o = r.lineStartIndex + r.segment + 1, s = new t.P(i.lineVertexArray.getx(o), i.lineVertexArray.gety(o)), n = qe(s.x, s.y, i), l = n.signedDistanceFromCamera > 0 ? n.point : Ue(i.tileAnchorPoint, s, e1, 1, i), c = We(e1.x, e1.y, i, a), u = We(l.x, l.y, i, a), d = Ze(r.writingMode, c, u, h);
                    if (d) return d;
                }
                const e1 = Ke(d * l.getoffsetX(r.glyphStartIndex), _, p, s, r.segment, r.lineStartIndex, r.lineStartIndex + r.lineLength, i, u);
                if (!e1 || i.projectionCache.anyProjectionOccluded) return {
                    notEnoughRoom: !0
                };
                m = [
                    e1
                ];
            }
            for (const e1 of m)t.aF(c, e1.point, e1.angle);
            return {};
        }
        function Ue(e1, t, i, a, r) {
            const o = e1.add(e1.sub(t)._unit()), s = qe(o.x, o.y, r).point, n = i.sub(s);
            return i.add(n._mult(a / n.mag()));
        }
        function Ve(e1, i, a) {
            const r = i.projectionCache;
            if (r.projections[e1]) return r.projections[e1];
            const o = new t.P(i.lineVertexArray.getx(e1), i.lineVertexArray.gety(e1)), s = qe(o.x, o.y, i);
            if (s.signedDistanceFromCamera > 0) return r.projections[e1] = s.point, r.anyProjectionOccluded = r.anyProjectionOccluded || s.isOccluded, s.point;
            const n = e1 - a.direction;
            return Ue(0 === a.distanceFromAnchor ? i.tileAnchorPoint : new t.P(i.lineVertexArray.getx(n), i.lineVertexArray.gety(n)), o, a.previousVertex, a.absOffsetX - a.distanceFromAnchor + 1, i);
        }
        function qe(e1, t, i) {
            const a = e1 + i.translation[0], r = t + i.translation[1];
            let o;
            return i.pitchWithMap ? (o = Fe(a, r, i.pitchedLabelPlaneMatrix, i.getElevation), o.isOccluded = !1) : (o = i.transform.projectTileCoordinates(a, r, i.unwrappedTileID, i.getElevation), o.point.x = (.5 * o.point.x + .5) * i.width, o.point.y = (.5 * -o.point.y + .5) * i.height), o;
        }
        function We(e1, i, a, r) {
            if (a.pitchWithMap) {
                const o = [
                    e1,
                    i,
                    0,
                    1
                ];
                return t.aG(o, o, r), a.transform.projectTileCoordinates(o[0] / o[3], o[1] / o[3], a.unwrappedTileID, a.getElevation).point;
            }
            return {
                x: e1 / a.width * 2 - 1,
                y: 1 - i / a.height * 2
            };
        }
        function $e(e1, t, i) {
            return i.transform.projectTileCoordinates(e1, t, i.unwrappedTileID, i.getElevation);
        }
        function He(e1, t, i) {
            return e1._unit()._perp()._mult(t * i);
        }
        function Xe(e1, i, a, r, o, s, n, l, c) {
            if (l.projectionCache.offsets[e1]) return l.projectionCache.offsets[e1];
            const h = a.add(i);
            if (e1 + c.direction < r || e1 + c.direction >= o) return l.projectionCache.offsets[e1] = h, h;
            const u = Ve(e1 + c.direction, l, c), d = He(u.sub(a), n, c.direction), _ = a.add(d), p = u.add(d);
            return l.projectionCache.offsets[e1] = t.aH(s, h, _, p) || h, l.projectionCache.offsets[e1];
        }
        function Ke(e1, t, i, a, r, o, s, n, l) {
            const c = a ? e1 - t : e1 + t;
            let h = c > 0 ? 1 : -1, u = 0;
            a && (h *= -1, u = Math.PI), h < 0 && (u += Math.PI);
            let d, _ = h > 0 ? o + r : o + r + 1;
            n.projectionCache.cachedAnchorPoint ? d = n.projectionCache.cachedAnchorPoint : (d = qe(n.tileAnchorPoint.x, n.tileAnchorPoint.y, n).point, n.projectionCache.cachedAnchorPoint = d);
            let p, m, f = d, g = d, v = 0, x = 0;
            const b = Math.abs(c), y = [];
            let w;
            for(; v + x <= b;){
                if (_ += h, _ < o || _ >= s) return null;
                v += x, g = f, m = p;
                const e1 = {
                    absOffsetX: b,
                    direction: h,
                    distanceFromAnchor: v,
                    previousVertex: g
                };
                if (f = Ve(_, n, e1), 0 === i) y.push(g), w = f.sub(g);
                else {
                    let t;
                    const a = f.sub(g);
                    t = 0 === a.mag() ? He(Ve(_ + h, n, e1).sub(f), i, h) : He(a, i, h), m || (m = g.add(t)), p = Xe(_, t, f, o, s, m, i, n, e1), y.push(m), w = p.sub(m);
                }
                x = w.mag();
            }
            const T = w._mult((b - v) / x)._add(m || g), P = u + Math.atan2(f.y - g.y, f.x - g.x);
            return y.push(T), {
                point: T,
                angle: l ? P : 0,
                path: y
            };
        }
        const Ye = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function Qe(e1, t) {
            for(let i = 0; i < e1; i++){
                const e1 = t.length;
                t.resize(e1 + 4), t.float32.set(Ye, 3 * e1);
            }
        }
        function Je(e1, t, i) {
            const a = t[0], r = t[1];
            return e1[0] = i[0] * a + i[4] * r + i[12], e1[1] = i[1] * a + i[5] * r + i[13], e1[3] = i[3] * a + i[7] * r + i[15], e1;
        }
        const et = 100;
        class tt {
            constructor(e1, t = new ze(e1.width + 200, e1.height + 200, 25), i = new ze(e1.width + 200, e1.height + 200, 25)){
                this.transform = e1, this.grid = t, this.ignoredGrid = i, this.pitchFactor = Math.cos(e1.pitch * Math.PI / 180) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + et, this.screenBottomBoundary = e1.height + et, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.perspectiveRatioCutoff = .6;
            }
            placeCollisionBox(e1, t, i, a, r, o, s, n, l, c, h, u) {
                const d = this.projectAndGetPerspectiveRatio(e1.anchorPointX + n[0], e1.anchorPointY + n[1], r, c, u), _ = i * d.perspectiveRatio;
                let p;
                if (o || s) p = this._projectCollisionBox(e1, _, a, r, o, s, n, d, c, h, u);
                else {
                    const t = d.x + (h ? h.x * _ : 0), i = d.y + (h ? h.y * _ : 0);
                    p = {
                        allPointsOccluded: !1,
                        box: [
                            t + e1.x1 * _,
                            i + e1.y1 * _,
                            t + e1.x2 * _,
                            i + e1.y2 * _
                        ]
                    };
                }
                const [m, f, g, v] = p.box, x = o ? p.allPointsOccluded : d.isOccluded;
                let b = x;
                return b || (b = d.perspectiveRatio < this.perspectiveRatioCutoff), b || (b = !this.isInsideGrid(m, f, g, v)), b || "always" !== t && this.grid.hitTest(m, f, g, v, t, l) ? {
                    box: [
                        m,
                        f,
                        g,
                        v
                    ],
                    placeable: !1,
                    offscreen: !1,
                    occluded: x
                } : {
                    box: [
                        m,
                        f,
                        g,
                        v
                    ],
                    placeable: !0,
                    offscreen: this.isOffscreen(m, f, g, v),
                    occluded: x
                };
            }
            placeCollisionCircles(e1, i, a, r, o, s, n, l, c, h, u, d, _, p) {
                const m = [], f = new t.P(i.anchorX, i.anchorY), g = this.getPerspectiveRatio(f.x, f.y, s, p), v = (c ? o * this.transform.getPitchedTextCorrection(i.anchorX, i.anchorY, s) / g : o * g) / t.aL, x = {
                    getElevation: p,
                    pitchedLabelPlaneMatrix: n,
                    lineVertexArray: a,
                    pitchWithMap: c,
                    projectionCache: {
                        projections: {},
                        offsets: {},
                        cachedAnchorPoint: void 0,
                        anyProjectionOccluded: !1
                    },
                    transform: this.transform,
                    tileAnchorPoint: f,
                    unwrappedTileID: s,
                    width: this.transform.width,
                    height: this.transform.height,
                    translation: _
                }, b = Ne(v, r, i.lineOffsetX * v, i.lineOffsetY * v, !1, i, !1, x);
                let y = !1, w = !1, T = !0;
                if (b) {
                    const i = .5 * u * g + d, a = new t.P(-100, -100), r = new t.P(this.screenRightBoundary, this.screenBottomBoundary), o = new Re, s = b.first, n = b.last;
                    let _ = [];
                    for(let e1 = s.path.length - 1; e1 >= 1; e1--)_.push(s.path[e1]);
                    for(let e1 = 1; e1 < n.path.length; e1++)_.push(n.path[e1]);
                    const p = 2.5 * i;
                    if (c) {
                        const e1 = this.projectPathToScreenSpace(_, x);
                        _ = e1.some((e1)=>e1.signedDistanceFromCamera <= 0) ? [] : e1.map((e1)=>e1.point);
                    }
                    let f = [];
                    if (_.length > 0) {
                        const e1 = _[0].clone(), i = _[0].clone();
                        for(let t = 1; t < _.length; t++)e1.x = Math.min(e1.x, _[t].x), e1.y = Math.min(e1.y, _[t].y), i.x = Math.max(i.x, _[t].x), i.y = Math.max(i.y, _[t].y);
                        f = e1.x >= a.x && i.x <= r.x && e1.y >= a.y && i.y <= r.y ? [
                            _
                        ] : i.x < a.x || e1.x > r.x || i.y < a.y || e1.y > r.y ? [] : t.aI([
                            _
                        ], a.x, a.y, r.x, r.y);
                    }
                    for (const t of f){
                        o.reset(t, .25 * i);
                        let a = 0;
                        a = o.length <= .5 * i ? 1 : Math.ceil(o.paddedLength / p) + 1;
                        for(let t = 0; t < a; t++){
                            const r = t / Math.max(a - 1, 1), s = o.lerp(r), n = s.x + et, c = s.y + et;
                            m.push(n, c, i, 0);
                            const u = n - i, d = c - i, _ = n + i, p = c + i;
                            if (T = T && this.isOffscreen(u, d, _, p), w = w || this.isInsideGrid(u, d, _, p), "always" !== e1 && this.grid.hitTestCircle(n, c, i, e1, h) && (y = !0, !l)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: y
                            };
                        }
                    }
                }
                return {
                    circles: !l && y || !w || g < this.perspectiveRatioCutoff ? [] : m,
                    offscreen: T,
                    collisionDetected: y
                };
            }
            projectPathToScreenSpace(e1, i) {
                const a = function(e1, i) {
                    const a = t.N();
                    return t.aA(a, i.pitchedLabelPlaneMatrix), e1.map((e1)=>{
                        const t = Fe(e1.x, e1.y, a, i.getElevation), r = i.transform.projectTileCoordinates(t.point.x, t.point.y, i.unwrappedTileID, i.getElevation);
                        return r.point.x = (.5 * r.point.x + .5) * i.width, r.point.y = (.5 * -r.point.y + .5) * i.height, r;
                    });
                }(e1, i);
                return function(e1) {
                    let t = 0, i = 0, a = 0, r = 0;
                    for(let o = 0; o < e1.length; o++)e1[o].isOccluded ? (a = o + 1, r = 0) : (r++, r > i && (i = r, t = a));
                    return e1.slice(t, t + i);
                }(a);
            }
            queryRenderedSymbols(e1) {
                if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [], a = new t.ab;
                for (const r of e1){
                    const e1 = new t.P(r.x + et, r.y + et);
                    a.extend(e1), i.push(e1);
                }
                const { minX: r, minY: o, maxX: s, maxY: n } = a, l = this.grid.query(r, o, s, n).concat(this.ignoredGrid.query(r, o, s, n)), c = {}, h = {};
                for (const e1 of l){
                    const a = e1.key;
                    if (void 0 === c[a.bucketInstanceId] && (c[a.bucketInstanceId] = {}), c[a.bucketInstanceId][a.featureIndex]) continue;
                    const r = [
                        new t.P(e1.x1, e1.y1),
                        new t.P(e1.x2, e1.y1),
                        new t.P(e1.x2, e1.y2),
                        new t.P(e1.x1, e1.y2)
                    ];
                    t.aJ(i, r) && (c[a.bucketInstanceId][a.featureIndex] = !0, void 0 === h[a.bucketInstanceId] && (h[a.bucketInstanceId] = []), h[a.bucketInstanceId].push(a.featureIndex));
                }
                return h;
            }
            insertCollisionBox(e1, t, i, a, r, o) {
                (i ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: a,
                    featureIndex: r,
                    collisionGroupID: o,
                    overlapMode: t
                }, e1[0], e1[1], e1[2], e1[3]);
            }
            insertCollisionCircles(e1, t, i, a, r, o) {
                const s = i ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: a,
                    featureIndex: r,
                    collisionGroupID: o,
                    overlapMode: t
                };
                for(let t = 0; t < e1.length; t += 4)s.insertCircle(n, e1[t], e1[t + 1], e1[t + 2]);
            }
            projectAndGetPerspectiveRatio(e1, i, a, r, o) {
                if (o) {
                    let a;
                    r ? (a = [
                        e1,
                        i,
                        r(e1, i),
                        1
                    ], t.aG(a, a, o)) : (a = [
                        e1,
                        i,
                        0,
                        1
                    ], Je(a, a, o));
                    const s = a[3];
                    return {
                        x: (a[0] / s + 1) / 2 * this.transform.width + et,
                        y: (-a[1] / s + 1) / 2 * this.transform.height + et,
                        perspectiveRatio: .5 + this.transform.cameraToCenterDistance / s * .5,
                        isOccluded: !1,
                        signedDistanceFromCamera: s
                    };
                }
                {
                    const t = this.transform.projectTileCoordinates(e1, i, a, r);
                    return {
                        x: (t.point.x + 1) / 2 * this.transform.width + et,
                        y: (1 - t.point.y) / 2 * this.transform.height + et,
                        perspectiveRatio: .5 + this.transform.cameraToCenterDistance / t.signedDistanceFromCamera * .5,
                        isOccluded: t.isOccluded,
                        signedDistanceFromCamera: t.signedDistanceFromCamera
                    };
                }
            }
            getPerspectiveRatio(e1, t, i, a) {
                const r = this.transform.projectTileCoordinates(e1, t, i, a);
                return .5 + this.transform.cameraToCenterDistance / r.signedDistanceFromCamera * .5;
            }
            isOffscreen(e1, t, i, a) {
                return i < et || e1 >= this.screenRightBoundary || a < et || t > this.screenBottomBoundary;
            }
            isInsideGrid(e1, t, i, a) {
                return i >= 0 && e1 < this.gridRightBoundary && a >= 0 && t < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const e1 = t.ar([]);
                return t.O(e1, e1, [
                    -100,
                    -100,
                    0
                ]), e1;
            }
            _projectCollisionBox(e1, i, a, r, o, s, n, l, c, h, u) {
                let d = 1, _ = 0, p = 0, m = 1;
                const f = e1.anchorPointX + n[0], g = e1.anchorPointY + n[1];
                if (s && !o) {
                    const e1 = this.projectAndGetPerspectiveRatio(f + 1, g, r, c, u), t = e1.x - l.x, i = Math.atan((e1.y - l.y) / t) + (t < 0 ? Math.PI : 0), a = Math.sin(i), o = Math.cos(i);
                    d = o, _ = a, p = -a, m = o;
                } else if (!s && o) {
                    const e1 = ke(this.transform);
                    d = e1.vecEast[0], _ = e1.vecEast[1], p = e1.vecSouth[0], m = e1.vecSouth[1];
                }
                let v = l.x, x = l.y, b = i;
                o && (v = f, x = g, b = Math.pow(2, -(this.transform.zoom - a.overscaledZ)), b *= this.transform.getPitchedTextCorrection(f, g, r), h || (b *= t.an(.5 + l.signedDistanceFromCamera / this.transform.cameraToCenterDistance * .5, 0, 4))), h && (v += d * h.x * b + p * h.y * b, x += _ * h.x * b + m * h.y * b);
                const y = e1.x1 * b, w = e1.x2 * b, T = (y + w) / 2, P = e1.y1 * b, C = e1.y2 * b, M = (P + C) / 2, I = [
                    {
                        offsetX: y,
                        offsetY: P
                    },
                    {
                        offsetX: T,
                        offsetY: P
                    },
                    {
                        offsetX: w,
                        offsetY: P
                    },
                    {
                        offsetX: w,
                        offsetY: M
                    },
                    {
                        offsetX: w,
                        offsetY: C
                    },
                    {
                        offsetX: T,
                        offsetY: C
                    },
                    {
                        offsetX: y,
                        offsetY: C
                    },
                    {
                        offsetX: y,
                        offsetY: M
                    }
                ];
                let E = [];
                for (const { offsetX: e1, offsetY: i } of I)E.push(new t.P(v + d * e1 + p * i, x + _ * e1 + m * i));
                let S = !1;
                if (o) {
                    const e1 = E.map((e1)=>this.projectAndGetPerspectiveRatio(e1.x, e1.y, r, c, u));
                    S = e1.some((e1)=>!e1.isOccluded), E = e1.map((e1)=>new t.P(e1.x, e1.y));
                } else S = !0;
                return {
                    box: t.aK(E),
                    allPointsOccluded: !S
                };
            }
        }
        class it {
            constructor(e1, t, i, a){
                this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t : -t))) : a && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class at {
            constructor(e1, t, i, a, r){
                this.text = new it(e1 ? e1.text : null, t, i, r), this.icon = new it(e1 ? e1.icon : null, t, a, r);
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class rt {
            constructor(e1, t, i){
                this.text = e1, this.icon = t, this.skipFade = i;
            }
        }
        class ot {
            constructor(e1, t, i, a, r){
                this.bucketInstanceId = e1, this.featureIndex = t, this.sourceLayerIndex = i, this.bucketIndex = a, this.tileID = r;
            }
        }
        class st {
            constructor(e1){
                this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e1) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e1]) {
                    const t = ++this.maxGroupID;
                    this.collisionGroups[e1] = {
                        ID: t,
                        predicate: (e1)=>e1.collisionGroupID === t
                    };
                }
                return this.collisionGroups[e1];
            }
        }
        function nt(e1, i, a, r, o) {
            const { horizontalAlign: s, verticalAlign: n } = t.aR(e1);
            return new t.P(-(s - .5) * i + r[0] * o, -(n - .5) * a + r[1] * o);
        }
        class lt {
            constructor(e1, t, i, a, r){
                this.transform = e1.clone(), this.terrain = t, this.collisionIndex = new tt(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = i, this.retainedQueryData = {}, this.collisionGroups = new st(a), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = r, r && (r.prevPlacement = void 0), this.placedOrientations = {};
            }
            _getTerrainElevationFunc(e1) {
                const t = this.terrain;
                return t ? (i, a)=>t.getElevation(e1, i, a) : null;
            }
            getBucketParts(e1, i, a, r) {
                const o = a.getBucket(i), s = a.latestFeatureIndex;
                if (!o || !s || i.id !== o.layerIds[0]) return;
                const n = a.collisionBoxArray, l = o.layers[0].layout, c = o.layers[0].paint, h = Math.pow(2, this.transform.zoom - a.tileID.overscaledZ), u = a.tileSize / t.a4, d = a.tileID.toUnwrapped(), _ = "map" === l.get("text-rotation-alignment"), p = t.aM(a, 1, this.transform.zoom), m = t.aN(this.collisionIndex.transform, a, c.get("text-translate"), c.get("text-translate-anchor")), f = t.aN(this.collisionIndex.transform, a, c.get("icon-translate"), c.get("icon-translate-anchor")), g = Ae(_, this.transform, p);
                this.retainedQueryData[o.bucketInstanceId] = new ot(o.bucketInstanceId, s, o.sourceLayerIndex, o.index, a.tileID);
                const v = {
                    bucket: o,
                    layout: l,
                    translationText: m,
                    translationIcon: f,
                    unwrappedTileID: d,
                    pitchedLabelPlaneMatrix: g,
                    scale: h,
                    textPixelRatio: u,
                    holdingForFade: a.holdingForSymbolFade(),
                    collisionBoxArray: n,
                    partiallyEvaluatedTextSize: t.ax(o.textSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(o.sourceID)
                };
                if (r) for (const t of o.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: a, symbolInstanceEnd: r } = t;
                    e1.push({
                        sortKey: i,
                        symbolInstanceStart: a,
                        symbolInstanceEnd: r,
                        parameters: v
                    });
                }
                else e1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: o.symbolInstances.length,
                    parameters: v
                });
            }
            attemptAnchorPlacement(e1, i, a, r, o, s, n, l, c, h, u, d, _, p, m, f, g, v, x, b) {
                const y = t.aO[e1.textAnchor], w = [
                    e1.textOffset0,
                    e1.textOffset1
                ], T = nt(y, a, r, w, o), P = this.collisionIndex.placeCollisionBox(i, d, l, c, h, n, s, f, u.predicate, x, T, b);
                if ((!v || this.collisionIndex.placeCollisionBox(v, d, l, c, h, n, s, g, u.predicate, x, T, b).placeable) && P.placeable) {
                    let e1;
                    if (this.prevPlacement && this.prevPlacement.variableOffsets[_.crossTileID] && this.prevPlacement.placements[_.crossTileID] && this.prevPlacement.placements[_.crossTileID].text && (e1 = this.prevPlacement.variableOffsets[_.crossTileID].anchor), 0 === _.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    return this.variableOffsets[_.crossTileID] = {
                        textOffset: w,
                        width: a,
                        height: r,
                        anchor: y,
                        textBoxScale: o,
                        prevAnchor: e1
                    }, this.markUsedJustification(p, y, _, m), p.allowVerticalPlacement && (this.markUsedOrientation(p, m, _), this.placedOrientations[_.crossTileID] = m), {
                        shift: T,
                        placedGlyphBoxes: P
                    };
                }
            }
            placeLayerBucketPart(e1, i, a) {
                const { bucket: r, layout: o, translationText: s, translationIcon: n, unwrappedTileID: l, pitchedLabelPlaneMatrix: c, textPixelRatio: h, holdingForFade: u, collisionBoxArray: d, partiallyEvaluatedTextSize: _, collisionGroup: p } = e1.parameters, m = o.get("text-optional"), f = o.get("icon-optional"), g = t.aP(o, "text-overlap", "text-allow-overlap"), v = "always" === g, x = t.aP(o, "icon-overlap", "icon-allow-overlap"), b = "always" === x, y = "map" === o.get("text-rotation-alignment"), w = "map" === o.get("text-pitch-alignment"), T = "none" !== o.get("icon-text-fit"), P = "viewport-y" === o.get("symbol-z-order"), C = v && (b || !r.hasIconData() || f), M = b && (v || !r.hasTextData() || m);
                !r.collisionArrays && d && r.deserializeCollisionBoxes(d);
                const I = this.retainedQueryData[r.bucketInstanceId].tileID, E = this._getTerrainElevationFunc(I), S = this.transform.getFastPathSimpleProjectionMatrix(I), R = (e1, d, b)=>{
                    var P, R;
                    if (i[e1.crossTileID]) return;
                    if (u) return void (this.placements[e1.crossTileID] = new rt(!1, !1, !1));
                    let D = !1, z = !1, A = !0, L = null, k = {
                        box: null,
                        placeable: !1,
                        offscreen: null,
                        occluded: !1
                    }, F = {
                        placeable: !1
                    }, B = null, O = null, j = null, N = 0, Z = 0, G = 0;
                    d.textFeatureIndex ? N = d.textFeatureIndex : e1.useRuntimeCollisionCircles && (N = e1.featureIndex), d.verticalTextFeatureIndex && (Z = d.verticalTextFeatureIndex);
                    const U = d.textBox;
                    if (U) {
                        const i = (i)=>{
                            let a = t.ay.horizontal;
                            if (r.allowVerticalPlacement && !i && this.prevPlacement) {
                                const t = this.prevPlacement.placedOrientations[e1.crossTileID];
                                t && (this.placedOrientations[e1.crossTileID] = t, a = t, this.markUsedOrientation(r, a, e1));
                            }
                            return a;
                        }, o = (i, a)=>{
                            if (r.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && d.verticalTextBox) {
                                for (const e1 of r.writingModes)if (e1 === t.ay.vertical ? (k = a(), F = k) : k = i(), k && k.placeable) break;
                            } else k = i();
                        }, c = e1.textAnchorOffsetStartIndex, u = e1.textAnchorOffsetEndIndex;
                        if (u === c) {
                            const a = (t, i)=>{
                                const a = this.collisionIndex.placeCollisionBox(t, g, h, I, l, w, y, s, p.predicate, E, void 0, S);
                                return a && a.placeable && (this.markUsedOrientation(r, i, e1), this.placedOrientations[e1.crossTileID] = i), a;
                            };
                            o(()=>a(U, t.ay.horizontal), ()=>{
                                const i = d.verticalTextBox;
                                return r.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && i ? a(i, t.ay.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), i(k && k.placeable);
                        } else {
                            let _ = t.aO[null === (R = null === (P = this.prevPlacement) || void 0 === P ? void 0 : P.variableOffsets[e1.crossTileID]) || void 0 === R ? void 0 : R.anchor];
                            const m = (t, i, o)=>{
                                const d = t.x2 - t.x1, m = t.y2 - t.y1, f = e1.textBoxScale, v = T && "never" === x ? i : null;
                                let b = null, P = "never" === g ? 1 : 2, C = "never";
                                _ && P++;
                                for(let i = 0; i < P; i++){
                                    for(let i = c; i < u; i++){
                                        const a = r.textAnchorOffsets.get(i);
                                        if (_ && a.textAnchor !== _) continue;
                                        const c = this.attemptAnchorPlacement(a, t, d, m, f, y, w, h, I, l, p, C, e1, r, o, s, n, v, E);
                                        if (c && (b = c.placedGlyphBoxes, b && b.placeable)) return D = !0, L = c.shift, b;
                                    }
                                    _ ? _ = null : C = g;
                                }
                                return a && !b && (b = {
                                    box: this.collisionIndex.placeCollisionBox(U, "always", h, I, l, w, y, s, p.predicate, E, void 0, S).box,
                                    offscreen: !1,
                                    placeable: !1,
                                    occluded: !1
                                }), b;
                            };
                            o(()=>m(U, d.iconBox, t.ay.horizontal), ()=>{
                                const i = d.verticalTextBox;
                                return r.allowVerticalPlacement && (!k || !k.placeable) && e1.numVerticalGlyphVertices > 0 && i ? m(i, d.verticalIconBox, t.ay.vertical) : {
                                    box: null,
                                    occluded: !0,
                                    offscreen: null
                                };
                            }), k && (D = k.placeable, A = k.offscreen);
                            const f = i(k && k.placeable);
                            if (!D && this.prevPlacement) {
                                const t = this.prevPlacement.variableOffsets[e1.crossTileID];
                                t && (this.variableOffsets[e1.crossTileID] = t, this.markUsedJustification(r, t.anchor, e1, f));
                            }
                        }
                    }
                    if (B = k, D = B && B.placeable, A = B && B.offscreen, e1.useRuntimeCollisionCircles && e1.centerJustifiedTextSymbolIndex >= 0) {
                        const i = r.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), n = t.az(r.textSizeData, _, i), h = o.get("text-padding");
                        O = this.collisionIndex.placeCollisionCircles(g, i, r.lineVertexArray, r.glyphOffsetArray, n, l, c, a, w, p.predicate, e1.collisionCircleDiameter, h, s, E), O.circles.length && O.collisionDetected && !a && t.w("Collisions detected, but collision boxes are not shown"), D = v || O.circles.length > 0 && !O.collisionDetected, A = A && O.offscreen;
                    }
                    if (d.iconFeatureIndex && (G = d.iconFeatureIndex), d.iconBox) {
                        const e1 = (e1)=>this.collisionIndex.placeCollisionBox(e1, x, h, I, l, w, y, n, p.predicate, E, T && L ? L : void 0, S);
                        F && F.placeable && d.verticalIconBox ? (j = e1(d.verticalIconBox), z = j.placeable) : (j = e1(d.iconBox), z = j.placeable), A = A && j.offscreen;
                    }
                    const V = m || 0 === e1.numHorizontalGlyphVertices && 0 === e1.numVerticalGlyphVertices, q = f || 0 === e1.numIconVertices;
                    V || q ? q ? V || (z = z && D) : D = z && D : z = D = z && D;
                    const W = z && j.placeable;
                    if (D && B.placeable && this.collisionIndex.insertCollisionBox(B.box, g, o.get("text-ignore-placement"), r.bucketInstanceId, F && F.placeable && Z ? Z : N, p.ID), W && this.collisionIndex.insertCollisionBox(j.box, x, o.get("icon-ignore-placement"), r.bucketInstanceId, G, p.ID), O && D && this.collisionIndex.insertCollisionCircles(O.circles, g, o.get("text-ignore-placement"), r.bucketInstanceId, N, p.ID), a && this.storeCollisionData(r.bucketInstanceId, b, d, B, j, O), 0 === e1.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    if (0 === r.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                    this.placements[e1.crossTileID] = new rt((D || C) && !(null == B ? void 0 : B.occluded), (z || M) && !(null == j ? void 0 : j.occluded), A || r.justReloaded), i[e1.crossTileID] = !0;
                };
                if (P) {
                    if (0 !== e1.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                    const t = r.getSortedSymbolIndexes(-this.transform.bearingInRadians);
                    for(let e1 = t.length - 1; e1 >= 0; --e1){
                        const i = t[e1];
                        R(r.symbolInstances.get(i), r.collisionArrays[i], i);
                    }
                } else for(let t = e1.symbolInstanceStart; t < e1.symbolInstanceEnd; t++)R(r.symbolInstances.get(t), r.collisionArrays[t], t);
                r.justReloaded = !1;
            }
            storeCollisionData(e1, t, i, a, r, o) {
                if (i.textBox || i.iconBox) {
                    let o, s;
                    this.collisionBoxArrays.has(e1) ? o = this.collisionBoxArrays.get(e1) : (o = new Map, this.collisionBoxArrays.set(e1, o)), o.has(t) ? s = o.get(t) : (s = {
                        text: null,
                        icon: null
                    }, o.set(t, s)), i.textBox && (s.text = a.box), i.iconBox && (s.icon = r.box);
                }
                if (o) {
                    let t = this.collisionCircleArrays[e1];
                    void 0 === t && (t = this.collisionCircleArrays[e1] = []);
                    for(let e1 = 0; e1 < o.circles.length; e1 += 4)t.push(o.circles[e1 + 0] - et), t.push(o.circles[e1 + 1] - et), t.push(o.circles[e1 + 2]), t.push(o.collisionDetected ? 1 : 0);
                }
            }
            markUsedJustification(e1, i, a, r) {
                let o;
                o = r === t.ay.vertical ? a.verticalPlacedTextSymbolIndex : ({
                    left: a.leftJustifiedTextSymbolIndex,
                    center: a.centerJustifiedTextSymbolIndex,
                    right: a.rightJustifiedTextSymbolIndex
                })[t.aQ(i)];
                const s = [
                    a.leftJustifiedTextSymbolIndex,
                    a.centerJustifiedTextSymbolIndex,
                    a.rightJustifiedTextSymbolIndex,
                    a.verticalPlacedTextSymbolIndex
                ];
                for (const t of s)t >= 0 && (e1.text.placedSymbolArray.get(t).crossTileID = o >= 0 && t !== o ? 0 : a.crossTileID);
            }
            markUsedOrientation(e1, i, a) {
                const r = i === t.ay.horizontal || i === t.ay.horizontalOnly ? i : 0, o = i === t.ay.vertical ? i : 0, s = [
                    a.leftJustifiedTextSymbolIndex,
                    a.centerJustifiedTextSymbolIndex,
                    a.rightJustifiedTextSymbolIndex
                ];
                for (const t of s)e1.text.placedSymbolArray.get(t).placedOrientation = r;
                a.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).placedOrientation = o);
            }
            commit(e1) {
                this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t ? t.zoomAdjustment(this.transform.zoom) : 0;
                const a = t ? t.symbolFadeChange(e1) : 1, r = t ? t.opacities : {}, o = t ? t.variableOffsets : {}, s = t ? t.placedOrientations : {};
                for(const e1 in this.placements){
                    const t = this.placements[e1], o = r[e1];
                    o ? (this.opacities[e1] = new at(o, a, t.text, t.icon), i = i || t.text !== o.text.placed || t.icon !== o.icon.placed) : (this.opacities[e1] = new at(null, a, t.text, t.icon, t.skipFade), i = i || t.text || t.icon);
                }
                for(const e1 in r){
                    const t = r[e1];
                    if (!this.opacities[e1]) {
                        const r = new at(t, a, !1, !1);
                        r.isHidden() || (this.opacities[e1] = r, i = i || t.text.placed || t.icon.placed);
                    }
                }
                for(const e1 in o)this.variableOffsets[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.variableOffsets[e1] = o[e1]);
                for(const e1 in s)this.placedOrientations[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.placedOrientations[e1] = s[e1]);
                if (t && void 0 === t.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                i ? this.lastPlacementChangeTime = e1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t ? t.lastPlacementChangeTime : e1);
            }
            updateLayerOpacities(e1, t) {
                const i = {};
                for (const a of t){
                    const t = a.getBucket(e1);
                    t && a.latestFeatureIndex && e1.id === t.layerIds[0] && this.updateBucketOpacities(t, a.tileID, i, a.collisionBoxArray);
                }
            }
            updateBucketOpacities(e1, i, a, r) {
                e1.hasTextData() && (e1.text.opacityVertexArray.clear(), e1.text.hasVisibleVertices = !1), e1.hasIconData() && (e1.icon.opacityVertexArray.clear(), e1.icon.hasVisibleVertices = !1), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
                const o = e1.layers[0], s = o.layout, n = new at(null, 0, !1, !1, !0), l = s.get("text-allow-overlap"), c = s.get("icon-allow-overlap"), h = o._unevaluatedLayout.hasValue("text-variable-anchor") || o._unevaluatedLayout.hasValue("text-variable-anchor-offset"), u = "map" === s.get("text-rotation-alignment"), d = "map" === s.get("text-pitch-alignment"), _ = "none" !== s.get("icon-text-fit"), p = new at(null, 0, l && (c || !e1.hasIconData() || s.get("icon-optional")), c && (l || !e1.hasTextData() || s.get("text-optional")), !0);
                !e1.collisionArrays && r && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(r);
                const m = (e1, t, i)=>{
                    for(let a = 0; a < t / 4; a++)e1.opacityVertexArray.emplaceBack(i);
                    e1.hasVisibleVertices = e1.hasVisibleVertices || i !== vt;
                }, f = this.collisionBoxArrays.get(e1.bucketInstanceId);
                for(let i = 0; i < e1.symbolInstances.length; i++){
                    const r = e1.symbolInstances.get(i), { numHorizontalGlyphVertices: o, numVerticalGlyphVertices: s, crossTileID: l } = r;
                    let c = this.opacities[l];
                    a[l] ? c = n : c || (c = p, this.opacities[l] = c), a[l] = !0;
                    const g = r.numIconVertices > 0, v = this.placedOrientations[r.crossTileID], x = v === t.ay.vertical, b = v === t.ay.horizontal || v === t.ay.horizontalOnly;
                    if (o > 0 || s > 0) {
                        const t = gt(c.text);
                        m(e1.text, o, x ? vt : t), m(e1.text, s, b ? vt : t);
                        const i = c.text.isHidden();
                        [
                            r.rightJustifiedTextSymbolIndex,
                            r.centerJustifiedTextSymbolIndex,
                            r.leftJustifiedTextSymbolIndex
                        ].forEach((t)=>{
                            t >= 0 && (e1.text.placedSymbolArray.get(t).hidden = i || x ? 1 : 0);
                        }), r.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(r.verticalPlacedTextSymbolIndex).hidden = i || b ? 1 : 0);
                        const a = this.variableOffsets[r.crossTileID];
                        a && this.markUsedJustification(e1, a.anchor, r, v);
                        const n = this.placedOrientations[r.crossTileID];
                        n && (this.markUsedJustification(e1, "left", r, n), this.markUsedOrientation(e1, n, r));
                    }
                    if (g) {
                        const t = gt(c.icon), i = !(_ && r.verticalPlacedIconSymbolIndex && x);
                        r.placedIconSymbolIndex >= 0 && (m(e1.icon, r.numIconVertices, i ? t : vt), e1.icon.placedSymbolArray.get(r.placedIconSymbolIndex).hidden = c.icon.isHidden()), r.verticalPlacedIconSymbolIndex >= 0 && (m(e1.icon, r.numVerticalIconVertices, i ? vt : t), e1.icon.placedSymbolArray.get(r.verticalPlacedIconSymbolIndex).hidden = c.icon.isHidden());
                    }
                    const y = f && f.has(i) ? f.get(i) : {
                        text: null,
                        icon: null
                    };
                    if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                        const a = e1.collisionArrays[i];
                        if (a) {
                            let i = new t.P(0, 0);
                            if (a.textBox || a.verticalTextBox) {
                                let t = !0;
                                if (h) {
                                    const e1 = this.variableOffsets[l];
                                    e1 ? (i = nt(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textBoxScale), u && i._rotate(d ? -this.transform.bearingInRadians : this.transform.bearingInRadians)) : t = !1;
                                }
                                if (a.textBox || a.verticalTextBox) {
                                    let r;
                                    a.textBox && (r = x), a.verticalTextBox && (r = b), ct(e1.textCollisionBox.collisionVertexArray, c.text.placed, !t || r, y.text, i.x, i.y);
                                }
                            }
                            if (a.iconBox || a.verticalIconBox) {
                                const t = Boolean(!b && a.verticalIconBox);
                                let r;
                                a.iconBox && (r = t), a.verticalIconBox && (r = !t), ct(e1.iconCollisionBox.collisionVertexArray, c.icon.placed, r, y.icon, _ ? i.x : 0, _ ? i.y : 0);
                            }
                        }
                    }
                }
                if (e1.sortFeatures(-this.transform.bearingInRadians), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.text.opacityVertexArray.length !== e1.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${e1.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e1.text.layoutVertexArray.length}) / 4`);
                if (e1.icon.opacityVertexArray.length !== e1.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${e1.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e1.icon.layoutVertexArray.length}) / 4`);
                e1.bucketInstanceId in this.collisionCircleArrays && (e1.collisionCircleArray = this.collisionCircleArrays[e1.bucketInstanceId], delete this.collisionCircleArrays[e1.bucketInstanceId]);
            }
            symbolFadeChange(e1) {
                return 0 === this.fadeDuration ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e1) {
                return Math.max(0, (this.transform.zoom - e1) / 1.5);
            }
            hasTransitions(e1) {
                return this.stale || e1 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e1, t) {
                const i = this.zoomAtLastRecencyCheck === t ? 1 - this.zoomAdjustment(t) : 1;
                return this.zoomAtLastRecencyCheck = t, this.commitTime + this.fadeDuration * i > e1;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function ct(e1, t, i, a, r, o) {
            a && 0 !== a.length || (a = [
                0,
                0,
                0,
                0
            ]);
            const s = a[0] - et, n = a[1] - et, l = a[2] - et, c = a[3] - et;
            e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, o || 0, s, n), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, o || 0, l, n), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, o || 0, l, c), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, o || 0, s, c);
        }
        const ht = Math.pow(2, 25), ut = Math.pow(2, 24), dt = Math.pow(2, 17), _t = Math.pow(2, 16), pt = Math.pow(2, 9), mt = Math.pow(2, 8), ft = Math.pow(2, 1);
        function gt(e1) {
            if (0 === e1.opacity && !e1.placed) return 0;
            if (1 === e1.opacity && e1.placed) return 4294967295;
            const t = e1.placed ? 1 : 0, i = Math.floor(127 * e1.opacity);
            return i * ht + t * ut + i * dt + t * _t + i * pt + t * mt + i * ft + t;
        }
        const vt = 0;
        class xt {
            constructor(e1){
                this._sortAcrossTiles = "viewport-y" !== e1.layout.get("symbol-z-order") && !e1.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
            }
            continuePlacement(e1, t, i, a, r) {
                const o = this._bucketParts;
                for(; this._currentTileIndex < e1.length;)if (t.getBucketParts(o, a, e1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, r()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, o.sort((e1, t)=>e1.sortKey - t.sortKey)); this._currentPartIndex < o.length;)if (t.placeLayerBucketPart(o[this._currentPartIndex], this._seenCrossTileIDs, i), this._currentPartIndex++, r()) return !0;
                return !1;
            }
        }
        class bt {
            constructor(e1, t, i, a, r, o, s, n){
                this.placement = new lt(e1, t, o, s, n), this._currentPlacementIndex = i.length - 1, this._forceFullPlacement = a, this._showCollisionBoxes = r, this._done = !1;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(e1, t, i) {
                const a = c(), r = ()=>!this._forceFullPlacement && c() - a > 2;
                for(; this._currentPlacementIndex >= 0;){
                    const a = t[e1[this._currentPlacementIndex]], o = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === a.type && (!a.minzoom || a.minzoom <= o) && (!a.maxzoom || a.maxzoom > o)) {
                        if (this._inProgressLayer || (this._inProgressLayer = new xt(a)), this._inProgressLayer.continuePlacement(i[a.source], this.placement, this._showCollisionBoxes, a, r)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(e1) {
                return this.placement.commit(e1), this.placement;
            }
        }
        const yt = 512 / t.a4 / 2;
        class wt {
            constructor(e1, i, a){
                this.tileID = e1, this.bucketInstanceId = a, this._symbolsByKey = {};
                const r = new Map;
                for(let e1 = 0; e1 < i.length; e1++){
                    const t = i.get(e1), a = t.key, o = r.get(a);
                    o ? o.push(t) : r.set(a, [
                        t
                    ]);
                }
                for (const [e1, i] of r){
                    const a = {
                        positions: i.map((e1)=>({
                                x: Math.floor(e1.anchorX * yt),
                                y: Math.floor(e1.anchorY * yt)
                            })),
                        crossTileIDs: i.map((e1)=>e1.crossTileID)
                    };
                    if (a.positions.length > 128) {
                        const e1 = new t.aS(a.positions.length, 16, Uint16Array);
                        for (const { x: t, y: i } of a.positions)e1.add(t, i);
                        e1.finish(), delete a.positions, a.index = e1;
                    }
                    this._symbolsByKey[e1] = a;
                }
            }
            getScaledCoordinates(e1, i) {
                const { x: a, y: r, z: o } = this.tileID.canonical, { x: s, y: n, z: l } = i.canonical, c = yt / Math.pow(2, l - o), h = (n * t.a4 + e1.anchorY) * c, u = r * t.a4 * yt;
                return {
                    x: Math.floor((s * t.a4 + e1.anchorX) * c - a * t.a4 * yt),
                    y: Math.floor(h - u)
                };
            }
            findMatches(e1, t, i) {
                const a = this.tileID.canonical.z < t.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - t.canonical.z);
                for(let r = 0; r < e1.length; r++){
                    const o = e1.get(r);
                    if (o.crossTileID) continue;
                    const s = this._symbolsByKey[o.key];
                    if (!s) continue;
                    const n = this.getScaledCoordinates(o, t);
                    if (s.index) {
                        const e1 = s.index.range(n.x - a, n.y - a, n.x + a, n.y + a).sort();
                        for (const t of e1){
                            const e1 = s.crossTileIDs[t];
                            if (!i[e1]) {
                                i[e1] = !0, o.crossTileID = e1;
                                break;
                            }
                        }
                    } else if (s.positions) for(let e1 = 0; e1 < s.positions.length; e1++){
                        const t = s.positions[e1], r = s.crossTileIDs[e1];
                        if (Math.abs(t.x - n.x) <= a && Math.abs(t.y - n.y) <= a && !i[r]) {
                            i[r] = !0, o.crossTileID = r;
                            break;
                        }
                    }
                }
            }
            getCrossTileIDsLists() {
                return Object.values(this._symbolsByKey).map(({ crossTileIDs: e1 })=>e1);
            }
        }
        class Tt {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class Pt {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(e1) {
                const t = Math.round((e1 - this.lng) / 360);
                if (0 !== t) for(const e1 in this.indexes){
                    const i = this.indexes[e1], a = {};
                    for(const e1 in i){
                        const r = i[e1];
                        r.tileID = r.tileID.unwrapTo(r.tileID.wrap + t), a[r.tileID.key] = r;
                    }
                    this.indexes[e1] = a;
                }
                this.lng = e1;
            }
            addBucket(e1, t, i) {
                if (this.indexes[e1.overscaledZ] && this.indexes[e1.overscaledZ][e1.key]) {
                    if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
                }
                for(let e1 = 0; e1 < t.symbolInstances.length; e1++)t.symbolInstances.get(e1).crossTileID = 0;
                this.usedCrossTileIDs[e1.overscaledZ] || (this.usedCrossTileIDs[e1.overscaledZ] = {});
                const a = this.usedCrossTileIDs[e1.overscaledZ];
                for(const i in this.indexes){
                    const r = this.indexes[i];
                    if (Number(i) > e1.overscaledZ) for(const i in r){
                        const o = r[i];
                        o.tileID.isChildOf(e1) && o.findMatches(t.symbolInstances, e1, a);
                    }
                    else {
                        const o = r[e1.scaledTo(Number(i)).key];
                        o && o.findMatches(t.symbolInstances, e1, a);
                    }
                }
                for(let e1 = 0; e1 < t.symbolInstances.length; e1++){
                    const r = t.symbolInstances.get(e1);
                    r.crossTileID || (r.crossTileID = i.generate(), a[r.crossTileID] = !0);
                }
                return void 0 === this.indexes[e1.overscaledZ] && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new wt(e1, t.symbolInstances, t.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e1, t) {
                for (const i of t.getCrossTileIDsLists())for (const t of i)delete this.usedCrossTileIDs[e1][t];
            }
            removeStaleBuckets(e1) {
                let t = !1;
                for(const i in this.indexes){
                    const a = this.indexes[i];
                    for(const r in a)e1[a[r].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, a[r]), delete a[r], t = !0);
                }
                return t;
            }
        }
        class Ct {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Tt, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(e1, t, i) {
                let a = this.layerIndexes[e1.id];
                void 0 === a && (a = this.layerIndexes[e1.id] = new Pt);
                let r = !1;
                const o = {};
                a.handleWrapJump(i);
                for (const i of t){
                    const t = i.getBucket(e1);
                    t && e1.id === t.layerIds[0] && (t.bucketInstanceId || (t.bucketInstanceId = ++this.maxBucketInstanceId), a.addBucket(i.tileID, t, this.crossTileIDs) && (r = !0), o[t.bucketInstanceId] = !0);
                }
                return a.removeStaleBuckets(o) && (r = !0), r;
            }
            pruneUnusedLayers(e1) {
                const t = {};
                e1.forEach((e1)=>{
                    t[e1] = !0;
                });
                for(const e1 in this.layerIndexes)t[e1] || delete this.layerIndexes[e1];
            }
        }
        var Mt = "void main() {fragColor=vec4(1.0);}";
        const It = {
            prelude: Et("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nout highp vec4 fragColor;", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}mat3 rotationMatrixFromAxisAngle(vec3 u,float angle) {float c=cos(angle);float s=sin(angle);float c2=1.0-c;return mat3(u.x*u.x*c2+      c,u.x*u.y*c2-u.z*s,u.x*u.z*c2+u.y*s,u.y*u.x*c2+u.z*s,u.y*u.y*c2+    c,u.y*u.z*c2-u.x*s,u.z*u.x*c2-u.y*s,u.z*u.y*c2+u.x*s,u.z*u.z*c2+    c\n);}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\n#ifdef GLOBE\nif ((pos.y <-32767.5) || (pos.y > 32766.5)) {return 0.0;}\n#endif\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}const float PI=3.141592653589793;uniform mat4 u_projection_matrix;"),
            projectionMercator: Et("", "float projectLineThickness(float tileY) {return 1.0;}float projectCircleRadius(float tileY) {return 1.0;}vec4 projectTile(vec2 p) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);return result;}vec4 projectTile(vec2 p,vec2 rawPos) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);if (rawPos.y <-32767.5 || rawPos.y > 32766.5) {result.z=-10000000.0;}return result;}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_projection_matrix*vec4(posInTile,elevation,1.0);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {return projectTileWithElevation(posInTile,elevation);}"),
            projectionGlobe: Et("", "#define GLOBE_RADIUS 6371008.8\nuniform highp vec4 u_projection_tile_mercator_coords;uniform highp vec4 u_projection_clipping_plane;uniform highp float u_projection_transition;uniform mat4 u_projection_fallback_matrix;vec3 globeRotateVector(vec3 vec,vec2 angles) {vec3 axisRight=vec3(vec.z,0.0,-vec.x);vec3 axisUp=cross(axisRight,vec);axisRight=normalize(axisRight);axisUp=normalize(axisUp);vec2 t=tan(angles);return normalize(vec+axisRight*t.x+axisUp*t.y);}mat3 globeGetRotationMatrix(vec3 spherePos) {vec3 axisRight=vec3(spherePos.z,0.0,-spherePos.x);vec3 axisDown=cross(axisRight,spherePos);axisRight=normalize(axisRight);axisDown=normalize(axisDown);return mat3(axisRight,axisDown,spherePos\n);}float circumferenceRatioAtTileY(float tileY) {float mercator_pos_y=u_projection_tile_mercator_coords.y+u_projection_tile_mercator_coords.w*tileY;float spherical_y=2.0*atan(exp(PI-(mercator_pos_y*PI*2.0)))-PI*0.5;return cos(spherical_y);}float projectLineThickness(float tileY) {float thickness=1.0/circumferenceRatioAtTileY(tileY); \nif (u_projection_transition < 0.999) {return mix(1.0,thickness,u_projection_transition);} else {return thickness;}}vec3 projectToSphere(vec2 translatedPos,vec2 rawPos) {vec2 mercator_pos=u_projection_tile_mercator_coords.xy+u_projection_tile_mercator_coords.zw*translatedPos;vec2 spherical;spherical.x=mercator_pos.x*PI*2.0+PI;spherical.y=2.0*atan(exp(PI-(mercator_pos.y*PI*2.0)))-PI*0.5;float len=cos(spherical.y);vec3 pos=vec3(sin(spherical.x)*len,sin(spherical.y),cos(spherical.x)*len\n);if (rawPos.y <-32767.5) {pos=vec3(0.0,1.0,0.0);}if (rawPos.y > 32766.5) {pos=vec3(0.0,-1.0,0.0);}return pos;}vec3 projectToSphere(vec2 posInTile) {return projectToSphere(posInTile,vec2(0.0,0.0));}float globeComputeClippingZ(vec3 spherePos) {return (1.0-(dot(spherePos,u_projection_clipping_plane.xyz)+u_projection_clipping_plane.w));}vec4 interpolateProjection(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);globePosition.z=globeComputeClippingZ(elevatedPos)*globePosition.w;if (u_projection_transition > 0.999) {return globePosition;}vec4 flatPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);const float z_globeness_threshold=0.2;vec4 result=globePosition;result.z=mix(0.0,globePosition.z,clamp((u_projection_transition-z_globeness_threshold)/(1.0-z_globeness_threshold),0.0,1.0));result.xyw=mix(flatPosition.xyw,globePosition.xyw,u_projection_transition);if ((posInTile.y <-32767.5) || (posInTile.y > 32766.5)) {result=globePosition;const float poles_hidden_anim_percentage=0.02;result.z=mix(globePosition.z,100.0,pow(max((1.0-u_projection_transition)/poles_hidden_anim_percentage,0.0),8.0));}return result;}vec4 interpolateProjectionFor3D(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);if (u_projection_transition > 0.999) {return globePosition;}vec4 fallbackPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);return mix(fallbackPosition,globePosition,u_projection_transition);}vec4 projectTile(vec2 posInTile) {return interpolateProjection(posInTile,projectToSphere(posInTile),0.0);}vec4 projectTile(vec2 posInTile,vec2 rawPos) {return interpolateProjection(posInTile,projectToSphere(posInTile,rawPos),0.0);}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return interpolateProjection(posInTile,projectToSphere(posInTile),elevation);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {vec3 spherePos=projectToSphere(posInTile,posInTile);return interpolateProjectionFor3D(posInTile,spherePos,elevation);}"),
            background: Et("uniform vec4 u_color;uniform float u_opacity;void main() {fragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
            backgroundPattern: Et("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;void main() {gl_Position=projectTile(a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
            circle: Et("in vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));fragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);const float epsilon=0.5/255.0;if (fragColor.r < epsilon && fragColor.g < epsilon && fragColor.b < epsilon && fragColor.a < epsilon) {discard;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_globe_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;uniform vec2 u_translate;in vec2 a_pos;out vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 pos_raw=a_pos+32768.0;vec2 extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);vec2 circle_center=floor(pos_raw/8.0)+u_translate;float ele=get_elevation(circle_center);v_visibility=calculate_visibility(projectTileWithElevation(circle_center,ele));if (u_pitch_with_map) {\n#ifdef GLOBE\nvec3 center_vector=projectToSphere(circle_center);\n#endif\nfloat angle_scale=u_globe_extrude_scale;vec2 corner_position=circle_center;if (u_scale_with_map) {angle_scale*=(radius+stroke_width);corner_position+=extrude*u_extrude_scale*(radius+stroke_width);} else {\n#ifdef GLOBE\nvec4 projected_center=interpolateProjection(circle_center,center_vector,ele);\n#else\nvec4 projected_center=projectTileWithElevation(circle_center,ele);\n#endif\ncorner_position+=extrude*u_extrude_scale*(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);angle_scale*=(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);}\n#ifdef GLOBE\nvec2 angles=extrude*angle_scale;vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(corner_position,corner_vector,ele);\n#else\ngl_Position=projectTileWithElevation(corner_position,ele);\n#endif\n} else {gl_Position=projectTileWithElevation(circle_center,ele);if (gl_Position.z/gl_Position.w > 1.0) {gl_Position.xy=vec2(10000.0);}if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
            clippingMask: Et(Mt, "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
            heatmap: Et("uniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);fragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;uniform highp float u_globe_extrude_scale;in vec2 a_pos;out vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 pos_raw=a_pos+32768.0;vec2 unscaled_extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 circle_center=floor(pos_raw/8.0);\n#ifdef GLOBE\nvec2 angles=v_extrude*radius*u_globe_extrude_scale;vec3 center_vector=projectToSphere(circle_center);vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(circle_center+extrude,corner_vector,0.0);\n#else\ngl_Position=projectTileFor3D(circle_center+extrude,get_elevation(circle_center));\n#endif\n}"),
            heatmapTexture: Et("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));fragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
            collisionBox: Et("in float v_placed;in float v_notUsed;void main() {float alpha=0.5;fragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {fragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {fragColor*=.1;}}", "in vec2 a_anchor_pos;in vec2 a_placed;in vec2 a_box_real;uniform vec2 u_pixel_extrude_scale;out float v_placed;out float v_notUsed;void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
            collisionCircle: Et("in float v_radius;in vec2 v_extrude;in float v_collision;void main() {float alpha=0.5;float stroke_radius=0.9;float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);fragColor=color*alpha*opacity_t;}", "in vec2 a_pos;in float a_radius;in vec2 a_flags;uniform vec2 u_viewport_size;out float v_radius;out vec2 v_extrude;out float v_collision;void main() {float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_collision=collision;gl_Position=vec4((a_pos/u_viewport_size*2.0-1.0)*vec2(1.0,-1.0),0.0,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            colorRelief: Et("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;uniform vec4 u_unpack;uniform sampler2D u_elevation_stops;uniform sampler2D u_color_stops;uniform int u_color_ramp_size;uniform float u_opacity;in vec2 v_pos;float getElevation(vec2 coord) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}float getElevationStop(int stop) {float x=(float(stop)+0.5)/float(u_color_ramp_size);vec4 data=texture(u_elevation_stops,vec2(x,0))*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {float el=getElevation(v_pos);int r=(u_color_ramp_size-1);int l=0;float el_l=getElevationStop(l);float el_r=getElevationStop(r);while(r-l > 1){int m=(r+l)/2;float el_m=getElevationStop(m);if(el < el_m){r=m;el_r=el_m;}else\n{l=m;el_l=el_m;}}float x=(float(l)+(el-el_l)/(el_r-el_l)+0.5)/float(u_color_ramp_size);fragColor=u_opacity*texture(u_color_stops,vec2(x,0));\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_dimension;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_pos/8192.0)*scale+epsilon;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
            debug: Et("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);fragColor=mix(u_color,overlay_color,overlay_color.a);}", "in vec2 a_pos;out vec2 v_uv;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=projectTileWithElevation(a_pos*u_overlay_scale,get_elevation(a_pos));}"),
            depth: Et(Mt, "in vec2 a_pos;void main() {\n#ifdef GLOBE\ngl_Position=projectTileFor3D(a_pos,0.0);\n#else\ngl_Position=u_projection_matrix*vec4(a_pos,0.0,1.0);\n#endif\n}"),
            fill: Et("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nfragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_fill_translate;in vec2 a_pos;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);}"),
            fillOutline: Et("in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=outline_color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
            fillOutlinePattern: Et("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;in vec2 v_pos_a;in vec2 v_pos_b;in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
            fillPattern: Et("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
            fillExtrusion: Et("in vec4 v_color;void main() {fragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\nout vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nfloat colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;vec3 normalForLighting=normal/16384.0;float directional=clamp(dot(normalForLighting,u_lightpos),0.0,1.0);\n#ifdef GLOBE\nmat3 rotMatrix=globeGetRotationMatrix(spherePos);normalForLighting=rotMatrix*normalForLighting;directional=mix(directional,clamp(dot(normalForLighting,u_lightpos_globe),0.0,1.0),u_projection_transition);\n#endif\ndirectional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
            fillExtrusionPattern: Et("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;in vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);fragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\n#ifdef GLOBE\nout vec3 v_sphere_pos;\n#endif\nout vec2 v_pos_a;out vec2 v_pos_b;out vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);v_sphere_pos=elevatedPos;gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nvec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,elevation*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
            hillshadePrepare: Et("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {vec2 epsilon=1.0/u_dimension;float tileSize=u_dimension.x-2.0;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))*tileSize/pow(2.0,exaggeration+(28.2562-u_zoom));fragColor=clamp(vec4(deriv.x/8.0+0.5,deriv.y/8.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: Et("uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform float u_exaggeration;uniform vec4 u_accent;uniform int u_method;uniform float u_altitudes[NUM_ILLUMINATION_SOURCES];uniform float u_azimuths[NUM_ILLUMINATION_SOURCES];uniform vec4 u_shadows[NUM_ILLUMINATION_SOURCES];uniform vec4 u_highlights[NUM_ILLUMINATION_SOURCES];\n#define PI 3.141592653589793\n#define STANDARD 0\n#define COMBINED 1\n#define IGOR 2\n#define MULTIDIRECTIONAL 3\n#define BASIC 4\nfloat get_aspect(vec2 deriv){return deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);}void igor_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float aspect=get_aspect(deriv);float azimuth=u_azimuths[0]+PI;float slope_stength=atan(length(deriv))*2.0/PI;float aspect_strength=1.0-abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);float shadow_strength=slope_stength*aspect_strength;float highlight_strength=slope_stength*(1.0-aspect_strength);fragColor=u_shadows[0]*shadow_strength+u_highlights[0]*highlight_strength;}void standard_hillshade(vec2 deriv){float azimuth=u_azimuths[0]+PI;float slope=atan(0.625*length(deriv));float aspect=get_aspect(deriv);float intensity=u_exaggeration;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadows[0],u_highlights[0],shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);fragColor=accent_color*(1.0-shade_color.a)+shade_color;}void basic_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor=u_highlights[0]*(2.0*shade-1.0);}else\n{fragColor=u_shadows[0]*(1.0-2.0*shade);}}void multidirectional_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;fragColor=vec4(0,0,0,0);for(int i=0; i < NUM_ILLUMINATION_SOURCES; i++){float cos_alt=cos(u_altitudes[i]);float sin_alt=sin(u_altitudes[i]);float cos_az=-cos(u_azimuths[i]);float sin_az=-sin(u_azimuths[i]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor+=u_highlights[i]*(2.0*shade-1.0)/float(NUM_ILLUMINATION_SOURCES);}else\n{fragColor+=u_shadows[i]*(1.0-2.0*shade)/float(NUM_ILLUMINATION_SOURCES);}}}void combined_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=acos((sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv)));cang=clamp(cang,0.0,PI/2.0);float shade=cang*atan(length(deriv))*4.0/PI/PI;float highlight=(PI/2.0-cang)*atan(length(deriv))*4.0/PI/PI;fragColor=u_shadows[0]*shade+u_highlights[0]*highlight;}void main() {vec4 pixel=texture(u_image,v_pos);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));vec2 deriv=((pixel.rg*8.0)-4.0)/scaleFactor;if (u_method==BASIC) {basic_hillshade(deriv);} else if (u_method==COMBINED) {combined_hillshade(deriv);} else if (u_method==IGOR) {igor_hillshade(deriv);} else if (u_method==MULTIDIRECTIONAL) {multidirectional_hillshade(deriv);} else if (u_method==STANDARD) {standard_hillshade(deriv);} else {standard_hillshade(deriv);}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);v_pos=a_pos/8192.0;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
            line: Et("uniform lowp float u_device_pixel_ratio;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp float v_linesofar;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            lineGradient: Et("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            linePattern: Et("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture(u_image,pos_a),texture(u_image,pos_b),u_fade);fragColor=color*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
            lineSDF: Et("uniform lowp float u_device_pixel_ratio;uniform lowp float u_lineatlas_width;uniform sampler2D u_image;uniform float u_mix;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture(u_image,v_tex_a).a;float sdfdist_b=texture(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0/u_device_pixel_ratio)/min(dasharray_from.w,dasharray_to.w);alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;out vec2 v_width2;out vec2 v_tex_a;out vec2 v_tex_b;out float v_gamma_scale;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"),
            lineGradientSDF: Et("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform sampler2D u_image_dash;uniform float u_mix;uniform lowp float u_lineatlas_width;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);float sdfdist_a=texture(u_image_dash,v_tex_a).a;float sdfdist_b=texture(u_image_dash,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0)/min(dasharray_from.w,dasharray_to.w);float dash_alpha=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*dash_alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;out vec2 v_tex_a;out vec2 v_tex_b;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;float texel_height=1.0/u_image_height;float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"),
            raster: Et("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;in vec2 v_pos0;in vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture(u_image0,v_pos0);vec4 color1=texture(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);fragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;uniform vec4 u_coords_top;uniform vec4 u_coords_bottom;in vec2 a_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {vec2 fractionalPos=a_pos/8192.0;vec2 position=mix(mix(u_coords_top.xy,u_coords_top.zw,fractionalPos.x),mix(u_coords_bottom.xy,u_coords_bottom.zw,fractionalPos.x),fractionalPos.y);gl_Position=projectTile(position,position);v_pos0=((fractionalPos-0.5)/u_buffer_scale)+0.5;\n#ifdef GLOBE\nif (a_pos.y <-32767.5) {v_pos0.y=0.0;}if (a_pos.y > 32766.5) {v_pos0.y=1.0;}\n#endif\nv_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
            symbolIcon: Et("uniform sampler2D u_texture;in vec2 v_tex;in float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;fragColor=texture(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_tex;out float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"),
            symbolSDF: Et("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;in vec2 v_data0;in vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_data0;out vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
            symbolTextAndIcon: Et("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;in vec4 v_data0;in vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;fragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec4 v_data0;out vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map && !u_is_along_line) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"),
            terrain: Et("uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;uniform bool u_is_globe_mode;in vec2 v_texture_pos;in float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture(u_texture,vec2(v_texture_pos.x,1.0-v_texture_pos.y));if (!u_is_globe_mode && v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);fragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {fragColor=surface_color;}}", "in vec3 a_pos3d;uniform mat4 u_fog_matrix;uniform float u_ele_delta;out vec2 v_texture_pos;out float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,get_elevation(a_pos3d.xy)-ele_delta);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}"),
            terrainDepth: Et("in float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {fragColor=pack(v_depth);}", "in vec3 a_pos3d;uniform float u_ele_delta;out float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);v_depth=gl_Position.z/gl_Position.w;}"),
            terrainCoords: Et("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;in vec2 v_texture_pos;void main() {vec4 rgba=texture(u_texture,v_texture_pos);fragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", "in vec3 a_pos3d;uniform float u_ele_delta;out vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);}"),
            projectionErrorMeasurement: Et("in vec4 v_output_error_encoded;void main() {fragColor=v_output_error_encoded;}", "in vec2 a_pos;uniform highp float u_input;uniform highp float u_output_expected;out vec4 v_output_error_encoded;void main() {float real_output=2.0*atan(exp(PI-(u_input*PI*2.0)))-PI*0.5;float error=real_output-u_output_expected;float abs_error=abs(error)*128.0;v_output_error_encoded.x=min(floor(abs_error*256.0),255.0)/255.0;abs_error-=v_output_error_encoded.x;v_output_error_encoded.y=min(floor(abs_error*65536.0),255.0)/255.0;abs_error-=v_output_error_encoded.x/255.0;v_output_error_encoded.z=min(floor(abs_error*16777216.0),255.0)/255.0;v_output_error_encoded.w=error >=0.0 ? 1.0 : 0.0;gl_Position=vec4(a_pos,0.0,1.0);}"),
            atmosphere: Et("in vec3 view_direction;uniform vec3 u_sun_pos;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;/**Shader use from https:*Made some change to adapt to MapLibre Globe geometry*/const float PI=3.141592653589793;const int iSteps=5;const int jSteps=3;/*radius of the planet*/const float EARTH_RADIUS=6371e3;/*radius of the atmosphere*/const float ATMOS_RADIUS=6471e3;vec2 rsi(vec3 r0,vec3 rd,float sr) {float a=dot(rd,rd);float b=2.0*dot(rd,r0);float c=dot(r0,r0)-(sr*sr);float d=(b*b)-4.0*a*c;if (d < 0.0) return vec2(1e5,-1e5);return vec2((-b-sqrt(d))/(2.0*a),(-b+sqrt(d))/(2.0*a));}vec4 atmosphere(vec3 r,vec3 r0,vec3 pSun,float iSun,float rPlanet,float rAtmos,vec3 kRlh,float kMie,float shRlh,float shMie,float g) {pSun=normalize(pSun);r=normalize(r);vec2 p=rsi(r0,r,rAtmos);if (p.x > p.y) {return vec4(0.0,0.0,0.0,1.0);}if (p.x < 0.0) {p.x=0.0;}vec3 pos=r0+r*p.x;vec2 p2=rsi(r0,r,rPlanet);if (p2.x <=p2.y && p2.x > 0.0) {p.y=min(p.y,p2.x);}float iStepSize=(p.y-p.x)/float(iSteps);float iTime=p.x+iStepSize*0.5;vec3 totalRlh=vec3(0,0,0);vec3 totalMie=vec3(0,0,0);float iOdRlh=0.0;float iOdMie=0.0;float mu=dot(r,pSun);float mumu=mu*mu;float gg=g*g;float pRlh=3.0/(16.0*PI)*(1.0+mumu);float pMie=3.0/(8.0*PI)*((1.0-gg)*(mumu+1.0))/(pow(1.0+gg-2.0*mu*g,1.5)*(2.0+gg));for (int i=0; i < iSteps; i++) {vec3 iPos=r0+r*iTime;float iHeight=length(iPos)-rPlanet;float odStepRlh=exp(-iHeight/shRlh)*iStepSize;float odStepMie=exp(-iHeight/shMie)*iStepSize;iOdRlh+=odStepRlh;iOdMie+=odStepMie;float jStepSize=rsi(iPos,pSun,rAtmos).y/float(jSteps);float jTime=jStepSize*0.5;float jOdRlh=0.0;float jOdMie=0.0;for (int j=0; j < jSteps; j++) {vec3 jPos=iPos+pSun*jTime;float jHeight=length(jPos)-rPlanet;jOdRlh+=exp(-jHeight/shRlh)*jStepSize;jOdMie+=exp(-jHeight/shMie)*jStepSize;jTime+=jStepSize;}vec3 attn=exp(-(kMie*(iOdMie+jOdMie)+kRlh*(iOdRlh+jOdRlh)));totalRlh+=odStepRlh*attn;totalMie+=odStepMie*attn;iTime+=iStepSize;}float opacity=exp(-(length(kRlh)*length(totalRlh)+kMie*length(totalMie)));vec3 color=iSun*(pRlh*kRlh*totalRlh+pMie*kMie*totalMie);return vec4(color,opacity);}void main() {vec3 scale_camera_pos=-u_globe_position*EARTH_RADIUS/u_globe_radius;vec4 color=atmosphere(normalize(view_direction),scale_camera_pos,u_sun_pos,22.0,EARTH_RADIUS,ATMOS_RADIUS,vec3(5.5e-6,13.0e-6,22.4e-6),21e-6,8e3,1.2e3,0.758\n);color.rgb=1.0-exp(-1.0*color.rgb);color=pow(color,vec4(1.0/2.2));fragColor=vec4(color.rgb,1.0-color.a)*u_atmosphere_blend;}", "in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 view_direction;void main() {view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,0.0,1.0);}"),
            sky: Et("uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform vec2 u_horizon;uniform vec2 u_horizon_normal;uniform float u_sky_horizon_blend;uniform float u_sky_blend;void main() {float x=gl_FragCoord.x;float y=gl_FragCoord.y;float blend=(y-u_horizon.y)*u_horizon_normal.y+(x-u_horizon.x)*u_horizon_normal.x;if (blend > 0.0) {if (blend < u_sky_horizon_blend) {fragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {fragColor=u_sky_color;}}fragColor=mix(fragColor,vec4(vec3(0.0),0.0),u_sky_blend);}", "in vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}")
        };
        function Et(e1, t) {
            const i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, a = t.match(/in ([\w]+) ([\w]+)/g), r = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o = t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), s = o ? o.concat(r) : r, n = {};
            return {
                fragmentSource: e1 = e1.replace(i, (e1, t, i, a, r)=>(n[r] = !0, "define" === t ? `\n#ifndef HAS_UNIFORM_u_${r}\nin ${i} ${a} ${r};\n#else\nuniform ${i} ${a} u_${r};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${r}\n    ${i} ${a} ${r} = u_${r};\n#endif\n`)),
                vertexSource: t = t.replace(i, (e1, t, i, a, r)=>{
                    const o = "float" === a ? "vec2" : "vec4", s = r.match(/color/) ? "color" : o;
                    return n[r] ? "define" === t ? `\n#ifndef HAS_UNIFORM_u_${r}\nuniform lowp float u_${r}_t;\nin ${i} ${o} a_${r};\nout ${i} ${a} ${r};\n#else\nuniform ${i} ${a} u_${r};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${r}\n    ${r} = a_${r};\n#else\n    ${i} ${a} ${r} = u_${r};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${r}\n    ${r} = unpack_mix_${s}(a_${r}, u_${r}_t);\n#else\n    ${i} ${a} ${r} = u_${r};\n#endif\n` : "define" === t ? `\n#ifndef HAS_UNIFORM_u_${r}\nuniform lowp float u_${r}_t;\nin ${i} ${o} a_${r};\n#else\nuniform ${i} ${a} u_${r};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${r}\n    ${i} ${a} ${r} = a_${r};\n#else\n    ${i} ${a} ${r} = u_${r};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${r}\n    ${i} ${a} ${r} = unpack_mix_${s}(a_${r}, u_${r}_t);\n#else\n    ${i} ${a} ${r} = u_${r};\n#endif\n`;
                }),
                staticAttributes: a,
                staticUniforms: s
            };
        }
        class St {
            constructor(e1, t, i){
                this.vertexBuffer = e1, this.indexBuffer = t, this.segments = i;
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
            }
        }
        var Rt = t.aT([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        const Dt = "#define PROJECTION_MERCATOR", zt = "mercator";
        class At {
            constructor(){
                this._cachedMesh = null;
            }
            get name() {
                return "mercator";
            }
            get useSubdivision() {
                return !1;
            }
            get shaderVariantName() {
                return zt;
            }
            get shaderDefine() {
                return Dt;
            }
            get shaderPreludeCode() {
                return It.projectionMercator;
            }
            get vertexShaderPreludeCode() {
                return It.projectionMercator.vertexSource;
            }
            get subdivisionGranularity() {
                return t.aU.noSubdivision;
            }
            get useGlobeControls() {
                return !1;
            }
            get transitionState() {
                return 0;
            }
            get latitudeErrorCorrectionRadians() {
                return 0;
            }
            destroy() {}
            updateGPUdependent(e1) {}
            getMeshFromTileID(e1, i, a, r, o) {
                if (this._cachedMesh) return this._cachedMesh;
                const s = new t.aV;
                s.emplaceBack(0, 0), s.emplaceBack(t.a4, 0), s.emplaceBack(0, t.a4), s.emplaceBack(t.a4, t.a4);
                const n = e1.createVertexBuffer(s, Rt.members), l = t.aW.simpleSegment(0, 0, 4, 2), c = new t.aX;
                c.emplaceBack(1, 0, 2), c.emplaceBack(1, 2, 3);
                const h = e1.createIndexBuffer(c);
                return this._cachedMesh = new St(n, h, l), this._cachedMesh;
            }
            recalculate() {}
            hasTransition() {
                return !1;
            }
            setErrorQueryLatitudeDegrees(e1) {}
        }
        class Lt {
            constructor(e1 = 0, t = 0, i = 0, a = 0){
                if (isNaN(e1) || e1 < 0 || isNaN(t) || t < 0 || isNaN(i) || i < 0 || isNaN(a) || a < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e1, this.bottom = t, this.left = i, this.right = a;
            }
            interpolate(e1, i, a) {
                return null != i.top && null != e1.top && (this.top = t.G.number(e1.top, i.top, a)), null != i.bottom && null != e1.bottom && (this.bottom = t.G.number(e1.bottom, i.bottom, a)), null != i.left && null != e1.left && (this.left = t.G.number(e1.left, i.left, a)), null != i.right && null != e1.right && (this.right = t.G.number(e1.right, i.right, a)), this;
            }
            getCenter(e1, i) {
                const a = t.an((this.left + e1 - this.right) / 2, 0, e1), r = t.an((this.top + i - this.bottom) / 2, 0, i);
                return new t.P(a, r);
            }
            equals(e1) {
                return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
            }
            clone() {
                return new Lt(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        function kt(e1, t) {
            if (!e1.renderWorldCopies || e1.lngRange) return;
            const i = t.lng - e1.center.lng;
            t.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
        }
        function Ft(e1) {
            return Math.max(0, Math.floor(e1));
        }
        class Bt {
            constructor(e1, i){
                var a;
                this.applyConstrain = (e1, t)=>null !== this._constrainOverride ? this._constrainOverride(e1, t) : this._callbacks.defaultConstrain(e1, t), this._callbacks = e1, this._tileSize = 512, this._renderWorldCopies = void 0 === (null == i ? void 0 : i.renderWorldCopies) || !!(null == i ? void 0 : i.renderWorldCopies), this._minZoom = (null == i ? void 0 : i.minZoom) || 0, this._maxZoom = (null == i ? void 0 : i.maxZoom) || 22, this._minPitch = null == (null == i ? void 0 : i.minPitch) ? 0 : null == i ? void 0 : i.minPitch, this._maxPitch = null == (null == i ? void 0 : i.maxPitch) ? 60 : null == i ? void 0 : i.maxPitch, this._constrainOverride = null !== (a = null == i ? void 0 : i.constrainOverride) && void 0 !== a ? a : null, this.setMaxBounds(), this._width = 0, this._height = 0, this._center = new t.V(0, 0), this._elevation = 0, this._zoom = 0, this._tileZoom = Ft(this._zoom), this._scale = t.aq(this._zoom), this._bearingInRadians = 0, this._fovInRadians = .6435011087932844, this._pitchInRadians = 0, this._rollInRadians = 0, this._unmodified = !0, this._edgeInsets = new Lt, this._minElevationForCurrentTile = 0, this._autoCalculateNearFarZ = !0;
            }
            apply(e1, i, a) {
                this._constrainOverride = e1.constrainOverride, this._latRange = e1.latRange, this._lngRange = e1.lngRange, this._width = e1.width, this._height = e1.height, this._center = e1.center, this._elevation = e1.elevation, this._minElevationForCurrentTile = e1.minElevationForCurrentTile, this._zoom = e1.zoom, this._tileZoom = Ft(this._zoom), this._scale = t.aq(this._zoom), this._bearingInRadians = e1.bearingInRadians, this._fovInRadians = e1.fovInRadians, this._pitchInRadians = e1.pitchInRadians, this._rollInRadians = e1.rollInRadians, this._unmodified = e1.unmodified, this._edgeInsets = new Lt(e1.padding.top, e1.padding.bottom, e1.padding.left, e1.padding.right), this._minZoom = e1.minZoom, this._maxZoom = e1.maxZoom, this._minPitch = e1.minPitch, this._maxPitch = e1.maxPitch, this._renderWorldCopies = e1.renderWorldCopies, this._cameraToCenterDistance = e1.cameraToCenterDistance, this._nearZ = e1.nearZ, this._farZ = e1.farZ, this._autoCalculateNearFarZ = !a && e1.autoCalculateNearFarZ, i && this.constrainInternal(), this._calcMatrices();
            }
            get pixelsToClipSpaceMatrix() {
                return this._pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._clipSpaceToPixelsMatrix;
            }
            get minElevationForCurrentTile() {
                return this._minElevationForCurrentTile;
            }
            setMinElevationForCurrentTile(e1) {
                this._minElevationForCurrentTile = e1;
            }
            get tileSize() {
                return this._tileSize;
            }
            get tileZoom() {
                return this._tileZoom;
            }
            get scale() {
                return this._scale;
            }
            get width() {
                return this._width;
            }
            get height() {
                return this._height;
            }
            get bearingInRadians() {
                return this._bearingInRadians;
            }
            get lngRange() {
                return this._lngRange;
            }
            get latRange() {
                return this._latRange;
            }
            get pixelsToGLUnits() {
                return this._pixelsToGLUnits;
            }
            get minZoom() {
                return this._minZoom;
            }
            setMinZoom(e1) {
                this._minZoom !== e1 && (this._minZoom = e1, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            setMaxZoom(e1) {
                this._maxZoom !== e1 && (this._maxZoom = e1, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
            }
            get minPitch() {
                return this._minPitch;
            }
            setMinPitch(e1) {
                this._minPitch !== e1 && (this._minPitch = e1, this.setPitch(Math.max(this.pitch, e1)));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            setMaxPitch(e1) {
                this._maxPitch !== e1 && (this._maxPitch = e1, this.setPitch(Math.min(this.pitch, e1)));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies;
            }
            setRenderWorldCopies(e1) {
                void 0 === e1 ? e1 = !0 : null === e1 && (e1 = !1), this._renderWorldCopies = e1;
            }
            get constrainOverride() {
                return this._constrainOverride;
            }
            setConstrainOverride(e1) {
                void 0 === e1 && (e1 = null), this._constrainOverride !== e1 && (this._constrainOverride = e1, this.constrainInternal(), this._calcMatrices());
            }
            get worldSize() {
                return this._tileSize * this._scale;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new t.P(this._width, this._height);
            }
            get bearing() {
                return this._bearingInRadians / Math.PI * 180;
            }
            setBearing(e1) {
                const i = t.W(e1, -180, 180) * Math.PI / 180;
                var r, o, s, n, l, c, h, u, d;
                this._bearingInRadians !== i && (this._unmodified = !1, this._bearingInRadians = i, this._calcMatrices(), this._rotationMatrix = a(), r = this._rotationMatrix, s = -this._bearingInRadians, n = (o = this._rotationMatrix)[0], l = o[1], c = o[2], h = o[3], u = Math.sin(s), d = Math.cos(s), r[0] = n * d + c * u, r[1] = l * d + h * u, r[2] = n * -u + c * d, r[3] = l * -u + h * d);
            }
            get rotationMatrix() {
                return this._rotationMatrix;
            }
            get pitchInRadians() {
                return this._pitchInRadians;
            }
            get pitch() {
                return this._pitchInRadians / Math.PI * 180;
            }
            setPitch(e1) {
                const i = t.an(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitchInRadians !== i && (this._unmodified = !1, this._pitchInRadians = i, this._calcMatrices());
            }
            get rollInRadians() {
                return this._rollInRadians;
            }
            get roll() {
                return this._rollInRadians / Math.PI * 180;
            }
            setRoll(e1) {
                const t = e1 / 180 * Math.PI;
                this._rollInRadians !== t && (this._unmodified = !1, this._rollInRadians = t, this._calcMatrices());
            }
            get fovInRadians() {
                return this._fovInRadians;
            }
            get fov() {
                return t.aY(this._fovInRadians);
            }
            setFov(e1) {
                e1 = t.an(e1, .1, 150), this.fov !== e1 && (this._unmodified = !1, this._fovInRadians = t.ap(e1), this._calcMatrices());
            }
            get zoom() {
                return this._zoom;
            }
            setZoom(e1) {
                const i = this.applyConstrain(this._center, e1).zoom;
                this._zoom !== i && (this._unmodified = !1, this._zoom = i, this._tileZoom = Math.max(0, Math.floor(i)), this._scale = t.aq(i), this.constrainInternal(), this._calcMatrices());
            }
            get center() {
                return this._center;
            }
            setCenter(e1) {
                e1.lat === this._center.lat && e1.lng === this._center.lng || (this._unmodified = !1, this._center = e1, this.constrainInternal(), this._calcMatrices());
            }
            get elevation() {
                return this._elevation;
            }
            setElevation(e1) {
                e1 !== this._elevation && (this._elevation = e1, this.constrainInternal(), this._calcMatrices());
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            setPadding(e1) {
                this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this._width, this._height);
            }
            get pixelsPerMeter() {
                return this._pixelPerMeter;
            }
            get unmodified() {
                return this._unmodified;
            }
            get cameraToCenterDistance() {
                return this._cameraToCenterDistance;
            }
            get nearZ() {
                return this._nearZ;
            }
            get farZ() {
                return this._farZ;
            }
            get autoCalculateNearFarZ() {
                return this._autoCalculateNearFarZ;
            }
            overrideNearFarZ(e1, t) {
                this._autoCalculateNearFarZ = !1, this._nearZ = e1, this._farZ = t, this._calcMatrices();
            }
            clearNearFarZOverride() {
                this._autoCalculateNearFarZ = !0, this._calcMatrices();
            }
            isPaddingEqual(e1) {
                return this._edgeInsets.equals(e1);
            }
            interpolatePadding(e1, t, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e1, t, i), this.constrainInternal(), this._calcMatrices();
            }
            resize(e1, t, i = !0) {
                this._width = e1, this._height = t, i && this.constrainInternal(), this._calcMatrices();
            }
            getMaxBounds() {
                return this._latRange && 2 === this._latRange.length && this._lngRange && 2 === this._lngRange.length ? new $([
                    this._lngRange[0],
                    this._latRange[0]
                ], [
                    this._lngRange[1],
                    this._latRange[1]
                ]) : null;
            }
            setMaxBounds(e1) {
                e1 ? (this._lngRange = [
                    e1.getWest(),
                    e1.getEast()
                ], this._latRange = [
                    e1.getSouth(),
                    e1.getNorth()
                ], this.constrainInternal()) : (this._lngRange = null, this._latRange = [
                    -t.ao,
                    t.ao
                ]);
            }
            getCameraQueryGeometry(e1, i) {
                if (1 === i.length) return [
                    i[0],
                    e1
                ];
                {
                    const { minX: a, minY: r, maxX: o, maxY: s } = t.ab.fromPoints(i).extend(e1);
                    return [
                        new t.P(a, r),
                        new t.P(o, r),
                        new t.P(o, s),
                        new t.P(a, s),
                        new t.P(a, r)
                    ];
                }
            }
            constrainInternal() {
                if (!this.center || !this._width || !this._height || this._constraining) return;
                this._constraining = !0;
                const e1 = this._unmodified, { center: t, zoom: i } = this.applyConstrain(this.center, this.zoom);
                this.setCenter(t), this.setZoom(i), this._unmodified = e1, this._constraining = !1;
            }
            _calcMatrices() {
                if (this._width && this._height) {
                    this._pixelsToGLUnits = [
                        2 / this._width,
                        -2 / this._height
                    ];
                    let e1 = t.ar(new Float64Array(16));
                    t.Q(e1, e1, [
                        this._width / 2,
                        -this._height / 2,
                        1
                    ]), t.O(e1, e1, [
                        1,
                        -1,
                        0
                    ]), this._clipSpaceToPixelsMatrix = e1, e1 = t.ar(new Float64Array(16)), t.Q(e1, e1, [
                        1,
                        -1,
                        1
                    ]), t.O(e1, e1, [
                        -1,
                        -1,
                        0
                    ]), t.Q(e1, e1, [
                        2 / this._width,
                        2 / this._height,
                        1
                    ]), this._pixelsToClipSpaceMatrix = e1, this._cameraToCenterDistance = .5 / Math.tan(this.fovInRadians / 2) * this._height;
                }
                this._callbacks.calcMatrices();
            }
            calculateCenterFromCameraLngLatAlt(e1, i, a, r) {
                const o = void 0 !== a ? a : this.bearing, s = r = void 0 !== r ? r : this.pitch, n = t.aa.fromLngLat(e1, i), l = -Math.cos(t.ap(s)), c = Math.sin(t.ap(s)), h = c * Math.sin(t.ap(o)), u = -c * Math.cos(t.ap(o));
                let d = this.elevation;
                const _ = i - d;
                let p;
                l * _ >= 0 || Math.abs(l) < .1 ? (p = 1e4, d = i + p * l) : p = -_ / l;
                let m, f, g = t.aZ(1, n.y), v = 0;
                do {
                    if (v += 1, v > 10) break;
                    f = p / g, m = new t.aa(n.x + h * f, n.y + u * f), g = 1 / m.meterInMercatorCoordinateUnits();
                }while (Math.abs(p - f * g) > 1e-12);
                return {
                    center: m.toLngLat(),
                    elevation: d,
                    zoom: t.at(this.height / 2 / Math.tan(this.fovInRadians / 2) / f / this.tileSize)
                };
            }
            recalculateZoomAndCenter(e1) {
                if (this.elevation - e1 == 0) return;
                const i = t.as(1, this.center.lat) * this.worldSize, a = this.cameraToCenterDistance / i, r = t.aa.fromLngLat(this.center, this.elevation), o = xe(this.center, this.elevation, this.pitch, this.bearing, a);
                this._elevation = e1;
                const s = this.calculateCenterFromCameraLngLatAlt(o.toLngLat(), t.aZ(o.z, r.y), this.bearing, this.pitch);
                this._elevation = s.elevation, this._center = s.center, this.setZoom(s.zoom);
            }
            getCameraPoint() {
                const e1 = Math.tan(this.pitchInRadians) * (this.cameraToCenterDistance || 1);
                return this.centerPoint.add(new t.P(e1 * Math.sin(this.rollInRadians), e1 * Math.cos(this.rollInRadians)));
            }
            getCameraAltitude() {
                return Math.cos(this.pitchInRadians) * this._cameraToCenterDistance / this._pixelPerMeter + this.elevation;
            }
            getCameraLngLat() {
                const e1 = t.as(1, this.center.lat) * this.worldSize;
                return xe(this.center, this.elevation, this.pitch, this.bearing, this.cameraToCenterDistance / e1).toLngLat();
            }
            getMercatorTileCoordinates(e1) {
                if (!e1) return [
                    0,
                    0,
                    1,
                    1
                ];
                const i = e1.canonical.z >= 0 ? 1 << e1.canonical.z : Math.pow(2, e1.canonical.z);
                return [
                    e1.canonical.x / i,
                    e1.canonical.y / i,
                    1 / i / t.a4,
                    1 / i / t.a4
                ];
            }
        }
        class Ot {
            constructor(e1, i){
                this.min = e1, this.max = i, this.center = t.a_([], t.a$([], this.min, this.max), .5);
            }
            quadrant(e1) {
                const i = [
                    e1 % 2 == 0,
                    e1 < 2
                ], a = t.b0(this.min), r = t.b0(this.max);
                for(let e1 = 0; e1 < i.length; e1++)a[e1] = i[e1] ? this.min[e1] : this.center[e1], r[e1] = i[e1] ? this.center[e1] : this.max[e1];
                return r[2] = this.max[2], new Ot(a, r);
            }
            distanceX(e1) {
                return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
            }
            distanceY(e1) {
                return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
            }
            intersectsFrustum(e1) {
                let t = !0;
                for(let i = 0; i < e1.planes.length; i++){
                    const a = this.intersectsPlane(e1.planes[i]);
                    if (0 === a) return 0;
                    1 === a && (t = !1);
                }
                return t ? 2 : e1.aabb.min[0] > this.max[0] || e1.aabb.min[1] > this.max[1] || e1.aabb.min[2] > this.max[2] || e1.aabb.max[0] < this.min[0] || e1.aabb.max[1] < this.min[1] || e1.aabb.max[2] < this.min[2] ? 0 : 1;
            }
            intersectsPlane(e1) {
                let t = e1[3], i = e1[3];
                for(let a = 0; a < 3; a++)e1[a] > 0 ? (t += e1[a] * this.min[a], i += e1[a] * this.max[a]) : (i += e1[a] * this.min[a], t += e1[a] * this.max[a]);
                return t >= 0 ? 2 : i < 0 ? 0 : 1;
            }
        }
        class jt {
            distanceToTile2d(e1, t, i, a) {
                const r = a.distanceX([
                    e1,
                    t
                ]), o = a.distanceY([
                    e1,
                    t
                ]);
                return Math.hypot(r, o);
            }
            getWrap(e1, t, i) {
                return i;
            }
            getTileBoundingVolume(e1, i, a, r) {
                var o, s;
                let n = 0, l = 0;
                if (null == r ? void 0 : r.terrain) {
                    const c = new t.a1(e1.z, i, e1.z, e1.x, e1.y), h = r.terrain.getMinMaxElevation(c);
                    n = null !== (o = h.minElevation) && void 0 !== o ? o : Math.min(0, a), l = null !== (s = h.maxElevation) && void 0 !== s ? s : Math.max(0, a);
                }
                const c = 1 << e1.z;
                return new Ot([
                    i + e1.x / c,
                    e1.y / c,
                    n
                ], [
                    i + (e1.x + 1) / c,
                    (e1.y + 1) / c,
                    l
                ]);
            }
            allowVariableZoom(e1, i) {
                const a = e1.fov * (Math.abs(Math.cos(e1.rollInRadians)) * e1.height + Math.abs(Math.sin(e1.rollInRadians)) * e1.width) / e1.height, r = t.an(78.5 - a / 2, 0, 60);
                return !!i.terrain || e1.pitch > r;
            }
            allowWorldCopies() {
                return !0;
            }
            prepareNextFrame() {}
        }
        class Nt {
            constructor(e1, t, i){
                this.points = e1, this.planes = t, this.aabb = i;
            }
            static fromInvProjectionMatrix(e1, i = 1, a = 0, r, o) {
                const s = o ? [
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ] : [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ], n = Math.pow(2, a), l = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((a)=>(function(e1, i, a, r) {
                        const o = t.aG([], e1, i), s = 1 / o[3] / a * r;
                        return t.b5(o, o, [
                            s,
                            s,
                            1 / o[3],
                            s
                        ]);
                    })(a, e1, i, n));
                r && function(e1, i, a, r) {
                    const o = r ? 4 : 0, s = r ? 0 : 4;
                    let n = 0;
                    const l = [], c = [];
                    for(let i = 0; i < 4; i++){
                        const a = t.b1([], e1[i + s], e1[i + o]), r = t.b6(a);
                        t.a_(a, a, 1 / r), l.push(r), c.push(a);
                    }
                    for(let i = 0; i < 4; i++){
                        const r = t.b7(e1[i + o], c[i], a);
                        n = null !== r && r >= 0 ? Math.max(n, r) : Math.max(n, l[i]);
                    }
                    const h = function(e1, i) {
                        const a = t.b1([], e1[i[0]], e1[i[1]]), r = t.b1([], e1[i[2]], e1[i[1]]), o = [
                            0,
                            0,
                            0,
                            0
                        ];
                        return t.b2(o, t.b3([], a, r)), o[3] = -t.b4(o, e1[i[0]]), o;
                    }(e1, i), u = function(e1, i) {
                        const a = t.b8(e1), r = t.b9([], e1, 1 / a), o = t.b1([], i, t.a_([], r, t.b4(i, r))), s = t.b8(o);
                        if (s > 0) {
                            const e1 = Math.sqrt(1 - r[3] * r[3]), a = t.a_([], r, -r[3]), n = t.a$([], a, t.a_([], o, e1 / s));
                            return t.ba(i, n);
                        }
                        return null;
                    }(a, h);
                    if (null !== u) {
                        const e1 = u / t.b4(c[0], h);
                        n = Math.min(n, e1);
                    }
                    for(let t = 0; t < 4; t++){
                        const i = Math.min(n, l[t]);
                        e1[t + s] = [
                            e1[t + o][0] + c[t][0] * i,
                            e1[t + o][1] + c[t][1] * i,
                            e1[t + o][2] + c[t][2] * i,
                            1
                        ];
                    }
                }(l, s[0], r, o);
                const c = s.map((e1)=>{
                    const i = t.b1([], l[e1[0]], l[e1[1]]), a = t.b1([], l[e1[2]], l[e1[1]]), r = t.b2([], t.b3([], i, a)), o = -t.b4(r, l[e1[1]]);
                    return r.concat(o);
                }), h = [
                    Number.POSITIVE_INFINITY,
                    Number.POSITIVE_INFINITY,
                    Number.POSITIVE_INFINITY
                ], u = [
                    Number.NEGATIVE_INFINITY,
                    Number.NEGATIVE_INFINITY,
                    Number.NEGATIVE_INFINITY
                ];
                for (const e1 of l)for(let t = 0; t < 3; t++)h[t] = Math.min(h[t], e1[t]), u[t] = Math.max(u[t], e1[t]);
                return new Nt(l, c, new Ot(h, u));
            }
        }
        class Zt {
            get pixelsToClipSpaceMatrix() {
                return this._helper.pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._helper.clipSpaceToPixelsMatrix;
            }
            get pixelsToGLUnits() {
                return this._helper.pixelsToGLUnits;
            }
            get centerOffset() {
                return this._helper.centerOffset;
            }
            get size() {
                return this._helper.size;
            }
            get rotationMatrix() {
                return this._helper.rotationMatrix;
            }
            get centerPoint() {
                return this._helper.centerPoint;
            }
            get pixelsPerMeter() {
                return this._helper.pixelsPerMeter;
            }
            setMinZoom(e1) {
                this._helper.setMinZoom(e1);
            }
            setMaxZoom(e1) {
                this._helper.setMaxZoom(e1);
            }
            setMinPitch(e1) {
                this._helper.setMinPitch(e1);
            }
            setMaxPitch(e1) {
                this._helper.setMaxPitch(e1);
            }
            setRenderWorldCopies(e1) {
                this._helper.setRenderWorldCopies(e1);
            }
            setBearing(e1) {
                this._helper.setBearing(e1);
            }
            setPitch(e1) {
                this._helper.setPitch(e1);
            }
            setRoll(e1) {
                this._helper.setRoll(e1);
            }
            setFov(e1) {
                this._helper.setFov(e1);
            }
            setZoom(e1) {
                this._helper.setZoom(e1);
            }
            setCenter(e1) {
                this._helper.setCenter(e1);
            }
            setElevation(e1) {
                this._helper.setElevation(e1);
            }
            setMinElevationForCurrentTile(e1) {
                this._helper.setMinElevationForCurrentTile(e1);
            }
            setPadding(e1) {
                this._helper.setPadding(e1);
            }
            interpolatePadding(e1, t, i) {
                return this._helper.interpolatePadding(e1, t, i);
            }
            isPaddingEqual(e1) {
                return this._helper.isPaddingEqual(e1);
            }
            resize(e1, t, i = !0) {
                this._helper.resize(e1, t, i);
            }
            getMaxBounds() {
                return this._helper.getMaxBounds();
            }
            setMaxBounds(e1) {
                this._helper.setMaxBounds(e1);
            }
            setConstrainOverride(e1) {
                this._helper.setConstrainOverride(e1);
            }
            overrideNearFarZ(e1, t) {
                this._helper.overrideNearFarZ(e1, t);
            }
            clearNearFarZOverride() {
                this._helper.clearNearFarZOverride();
            }
            getCameraQueryGeometry(e1) {
                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
            }
            get tileSize() {
                return this._helper.tileSize;
            }
            get tileZoom() {
                return this._helper.tileZoom;
            }
            get scale() {
                return this._helper.scale;
            }
            get worldSize() {
                return this._helper.worldSize;
            }
            get width() {
                return this._helper.width;
            }
            get height() {
                return this._helper.height;
            }
            get lngRange() {
                return this._helper.lngRange;
            }
            get latRange() {
                return this._helper.latRange;
            }
            get minZoom() {
                return this._helper.minZoom;
            }
            get maxZoom() {
                return this._helper.maxZoom;
            }
            get zoom() {
                return this._helper.zoom;
            }
            get center() {
                return this._helper.center;
            }
            get minPitch() {
                return this._helper.minPitch;
            }
            get maxPitch() {
                return this._helper.maxPitch;
            }
            get pitch() {
                return this._helper.pitch;
            }
            get pitchInRadians() {
                return this._helper.pitchInRadians;
            }
            get roll() {
                return this._helper.roll;
            }
            get rollInRadians() {
                return this._helper.rollInRadians;
            }
            get bearing() {
                return this._helper.bearing;
            }
            get bearingInRadians() {
                return this._helper.bearingInRadians;
            }
            get fov() {
                return this._helper.fov;
            }
            get fovInRadians() {
                return this._helper.fovInRadians;
            }
            get elevation() {
                return this._helper.elevation;
            }
            get minElevationForCurrentTile() {
                return this._helper.minElevationForCurrentTile;
            }
            get padding() {
                return this._helper.padding;
            }
            get unmodified() {
                return this._helper.unmodified;
            }
            get renderWorldCopies() {
                return this._helper.renderWorldCopies;
            }
            get cameraToCenterDistance() {
                return this._helper.cameraToCenterDistance;
            }
            get constrainOverride() {
                return this._helper.constrainOverride;
            }
            get nearZ() {
                return this._helper.nearZ;
            }
            get farZ() {
                return this._helper.farZ;
            }
            get autoCalculateNearFarZ() {
                return this._helper.autoCalculateNearFarZ;
            }
            setTransitionState(e1, t) {}
            constructor(e1){
                this._posMatrixCache = new Map, this._alignedPosMatrixCache = new Map, this._fogMatrixCacheF32 = new Map, this.defaultConstrain = (e1, i)=>{
                    i = t.an(+i, this.minZoom, this.maxZoom);
                    const a = {
                        center: new t.V(e1.lng, e1.lat),
                        zoom: i
                    };
                    let r = this._helper._lngRange;
                    if (!this._helper._renderWorldCopies && null === r) {
                        const e1 = 180 - 1e-10;
                        r = [
                            -e1,
                            e1
                        ];
                    }
                    const o = this.tileSize * t.aq(a.zoom);
                    let s = 0, n = o, l = 0, c = o, h = 0, u = 0;
                    const { x: d, y: _ } = this.size;
                    if (this._helper._latRange) {
                        const e1 = this._helper._latRange;
                        s = t.X(e1[1]) * o, n = t.X(e1[0]) * o, n - s < _ && (h = _ / (n - s));
                    }
                    r && (l = t.W(t.Y(r[0]) * o, 0, o), c = t.W(t.Y(r[1]) * o, 0, o), c < l && (c += o), c - l < d && (u = d / (c - l)));
                    const { x: p, y: m } = me(o, e1);
                    let f, g;
                    const v = Math.max(u || 0, h || 0);
                    if (v) {
                        const e1 = new t.P(u ? (c + l) / 2 : p, h ? (n + s) / 2 : m);
                        return a.center = fe(o, e1).wrap(), a.zoom += t.at(v), a;
                    }
                    if (this._helper._latRange) {
                        const e1 = _ / 2;
                        m - e1 < s && (g = s + e1), m + e1 > n && (g = n - e1);
                    }
                    if (r) {
                        const e1 = (l + c) / 2;
                        let i = p;
                        this._helper._renderWorldCopies && (i = t.W(p, e1 - o / 2, e1 + o / 2));
                        const a = d / 2;
                        i - a < l && (f = l + a), i + a > c && (f = c - a);
                    }
                    if (void 0 !== f || void 0 !== g) {
                        const e1 = new t.P(null != f ? f : p, null != g ? g : m);
                        a.center = fe(o, e1).wrap();
                    }
                    return a;
                }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new Bt({
                    calcMatrices: ()=>{
                        this._calcMatrices();
                    },
                    defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
                }, e1), this._coveringTilesDetailsProvider = new jt;
            }
            clone() {
                const e1 = new Zt;
                return e1.apply(this), e1;
            }
            apply(e1, t, i) {
                this._helper.apply(e1, t, i);
            }
            get cameraPosition() {
                return this._cameraPosition;
            }
            get projectionMatrix() {
                return this._projectionMatrix;
            }
            get modelViewProjectionMatrix() {
                return this._viewProjMatrix;
            }
            get inverseProjectionMatrix() {
                return this._invProjMatrix;
            }
            get mercatorMatrix() {
                return this._mercatorMatrix;
            }
            getVisibleUnwrappedCoordinates(e1) {
                const i = [
                    new t.bb(0, e1)
                ];
                if (this._helper._renderWorldCopies) {
                    const a = this.screenPointToMercatorCoordinate(new t.P(0, 0)), r = this.screenPointToMercatorCoordinate(new t.P(this._helper._width, 0)), o = this.screenPointToMercatorCoordinate(new t.P(this._helper._width, this._helper._height)), s = this.screenPointToMercatorCoordinate(new t.P(0, this._helper._height)), n = Math.floor(Math.min(a.x, r.x, o.x, s.x)), l = Math.floor(Math.max(a.x, r.x, o.x, s.x)), c = 1;
                    for(let a = n - c; a <= l + c; a++)0 !== a && i.push(new t.bb(a, e1));
                }
                return i;
            }
            getCameraFrustum() {
                return Nt.fromInvProjectionMatrix(this._invViewProjMatrix, this.worldSize);
            }
            getClippingPlane() {
                return null;
            }
            getCoveringTilesDetailsProvider() {
                return this._coveringTilesDetailsProvider;
            }
            recalculateZoomAndCenter(e1) {
                const t = this.screenPointToLocation(this.centerPoint, e1), i = e1 ? e1.getElevationForLngLatZoom(t, this._helper._tileZoom) : 0;
                this._helper.recalculateZoomAndCenter(i);
            }
            setLocationAtPoint(e1, i) {
                const a = t.as(this.elevation, this.center.lat), r = this.screenPointToMercatorCoordinateAtZ(i, a), o = this.screenPointToMercatorCoordinateAtZ(this.centerPoint, a), s = t.aa.fromLngLat(e1), n = new t.aa(s.x - (r.x - o.x), s.y - (r.y - o.y));
                this.setCenter(null == n ? void 0 : n.toLngLat()), this._helper._renderWorldCopies && this.setCenter(this.center.wrap());
            }
            locationToScreenPoint(e1, i) {
                return i ? this.coordinatePoint(t.aa.fromLngLat(e1), i.getElevationForLngLatZoom(e1, this._helper._tileZoom), this._pixelMatrix3D) : this.coordinatePoint(t.aa.fromLngLat(e1));
            }
            screenPointToLocation(e1, t) {
                var i;
                return null === (i = this.screenPointToMercatorCoordinate(e1, t)) || void 0 === i ? void 0 : i.toLngLat();
            }
            screenPointToMercatorCoordinate(e1, t) {
                if (t) {
                    const i = t.pointCoordinate(e1);
                    if (null != i) return i;
                }
                return this.screenPointToMercatorCoordinateAtZ(e1);
            }
            screenPointToMercatorCoordinateAtZ(e1, i) {
                const a = i || 0, r = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], o = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                t.aG(r, r, this._pixelMatrixInverse), t.aG(o, o, this._pixelMatrixInverse);
                const s = r[3], n = o[3], l = r[1] / s, c = o[1] / n, h = r[2] / s, u = o[2] / n, d = h === u ? 0 : (a - h) / (u - h);
                return new t.aa(t.G.number(r[0] / s, o[0] / n, d) / this.worldSize, t.G.number(l, c, d) / this.worldSize, a);
            }
            coordinatePoint(e1, i = 0, a = this._pixelMatrix) {
                const r = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    i,
                    1
                ];
                return t.aG(r, r, a), new t.P(r[0] / r[3], r[1] / r[3]);
            }
            getBounds() {
                const e1 = Math.max(0, this._helper._height / 2 - ge(this));
                return (new $).extend(this.screenPointToLocation(new t.P(0, e1))).extend(this.screenPointToLocation(new t.P(this._helper._width, e1))).extend(this.screenPointToLocation(new t.P(this._helper._width, this._helper._height))).extend(this.screenPointToLocation(new t.P(0, this._helper._height)));
            }
            isPointOnMapSurface(e1, t) {
                return t ? null != t.pointCoordinate(e1) : e1.y > this.height / 2 - ge(this);
            }
            calculatePosMatrix(e1, i = !1, a) {
                var r;
                const o = null !== (r = e1.key) && void 0 !== r ? r : t.bc(e1.wrap, e1.canonical.z, e1.canonical.z, e1.canonical.x, e1.canonical.y), s = i ? this._alignedPosMatrixCache : this._posMatrixCache;
                if (s.has(o)) {
                    const e1 = s.get(o);
                    return a ? e1.f32 : e1.f64;
                }
                const n = ve(e1, this.worldSize);
                t.S(n, i ? this._alignedProjMatrix : this._viewProjMatrix, n);
                const l = {
                    f64: n,
                    f32: new Float32Array(n)
                };
                return s.set(o, l), a ? l.f32 : l.f64;
            }
            calculateFogMatrix(e1) {
                const i = e1.key, a = this._fogMatrixCacheF32;
                if (a.has(i)) return a.get(i);
                const r = ve(e1, this.worldSize);
                return t.S(r, this._fogMatrix, r), a.set(i, new Float32Array(r)), a.get(i);
            }
            calculateCenterFromCameraLngLatAlt(e1, t, i, a) {
                return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, a);
            }
            _calculateNearFarZIfNeeded(e1, i, a) {
                if (!this._helper.autoCalculateNearFarZ) return;
                const r = Math.min(this.elevation, this.minElevationForCurrentTile, this.getCameraAltitude() - 100), o = e1 - r * this._helper._pixelPerMeter / Math.cos(i), s = r < 0 ? o : e1, n = Math.PI / 2 + this.pitchInRadians, l = t.ap(this.fov) * (Math.abs(Math.cos(t.ap(this.roll))) * this.height + Math.abs(Math.sin(t.ap(this.roll))) * this.width) / this.height * (.5 + a.y / this.height), c = Math.sin(l) * s / Math.sin(t.an(Math.PI - n - l, .01, Math.PI - .01)), h = ge(this), u = Math.atan(h / this._helper.cameraToCenterDistance), d = t.ap(.75), _ = u > d ? 2 * u * (.5 + a.y / (2 * h)) : d, p = Math.sin(_) * s / Math.sin(t.an(Math.PI - n - _, .01, Math.PI - .01)), m = Math.min(c, p);
                this._helper._farZ = 1.01 * (Math.cos(Math.PI / 2 - i) * m + s), this._helper._nearZ = this._helper._height / 50;
            }
            _calcMatrices() {
                if (!this._helper._height) return;
                const e1 = this.centerOffset, i = me(this.worldSize, this.center), a = i.x, r = i.y;
                this._helper._pixelPerMeter = t.as(1, this.center.lat) * this.worldSize;
                const o = t.ap(Math.min(this.pitch, pe)), s = Math.max(this._helper.cameraToCenterDistance / 2, this._helper.cameraToCenterDistance + this._helper._elevation * this._helper._pixelPerMeter / Math.cos(o));
                let n;
                this._calculateNearFarZIfNeeded(s, o, e1), n = new Float64Array(16), t.bd(n, this.fovInRadians, this._helper._width / this._helper._height, this._helper._nearZ, this._helper._farZ), this._invProjMatrix = new Float64Array(16), t.aA(this._invProjMatrix, n), n[8] = 2 * -e1.x / this._helper._width, n[9] = 2 * e1.y / this._helper._height, this._projectionMatrix = t.be(n), t.Q(n, n, [
                    1,
                    -1,
                    1
                ]), t.O(n, n, [
                    0,
                    0,
                    -this._helper.cameraToCenterDistance
                ]), t.bf(n, n, -this.rollInRadians), t.bg(n, n, this.pitchInRadians), t.bf(n, n, -this.bearingInRadians), t.O(n, n, [
                    -a,
                    -r,
                    0
                ]), this._mercatorMatrix = t.Q([], n, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize
                ]), t.Q(n, n, [
                    1,
                    1,
                    this._helper._pixelPerMeter
                ]), this._pixelMatrix = t.S(new Float64Array(16), this.clipSpaceToPixelsMatrix, n), t.O(n, n, [
                    0,
                    0,
                    -this.elevation
                ]), this._viewProjMatrix = n, this._invViewProjMatrix = t.aA([], n);
                const l = [
                    0,
                    0,
                    -1,
                    1
                ];
                t.aG(l, l, this._invViewProjMatrix), this._cameraPosition = [
                    l[0] / l[3],
                    l[1] / l[3],
                    l[2] / l[3]
                ], this._fogMatrix = new Float64Array(16), t.bd(this._fogMatrix, this.fovInRadians, this.width / this.height, s, this._helper._farZ), this._fogMatrix[8] = 2 * -e1.x / this.width, this._fogMatrix[9] = 2 * e1.y / this.height, t.Q(this._fogMatrix, this._fogMatrix, [
                    1,
                    -1,
                    1
                ]), t.O(this._fogMatrix, this._fogMatrix, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t.bf(this._fogMatrix, this._fogMatrix, -this.rollInRadians), t.bg(this._fogMatrix, this._fogMatrix, this.pitchInRadians), t.bf(this._fogMatrix, this._fogMatrix, -this.bearingInRadians), t.O(this._fogMatrix, this._fogMatrix, [
                    -a,
                    -r,
                    0
                ]), t.Q(this._fogMatrix, this._fogMatrix, [
                    1,
                    1,
                    this._helper._pixelPerMeter
                ]), t.O(this._fogMatrix, this._fogMatrix, [
                    0,
                    0,
                    -this.elevation
                ]), this._pixelMatrix3D = t.S(new Float64Array(16), this.clipSpaceToPixelsMatrix, n);
                const c = this._helper._width % 2 / 2, h = this._helper._height % 2 / 2, u = Math.cos(this.bearingInRadians), d = Math.sin(-this.bearingInRadians), _ = a - Math.round(a) + u * c + d * h, p = r - Math.round(r) + u * h + d * c, m = new Float64Array(n);
                if (t.O(m, m, [
                    _ > .5 ? _ - 1 : _,
                    p > .5 ? p - 1 : p,
                    0
                ]), this._alignedProjMatrix = m, n = t.aA(new Float64Array(16), this._pixelMatrix), !n) throw new Error("failed to invert matrix");
                this._pixelMatrixInverse = n, this._clearMatrixCaches();
            }
            _clearMatrixCaches() {
                this._posMatrixCache.clear(), this._alignedPosMatrixCache.clear(), this._fogMatrixCacheF32.clear();
            }
            maxPitchScaleFactor() {
                if (!this._pixelMatrixInverse) return 1;
                const e1 = this.screenPointToMercatorCoordinate(new t.P(0, 0)), i = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    0,
                    1
                ];
                return t.aG(i, i, this._pixelMatrix)[3] / this._helper.cameraToCenterDistance;
            }
            getCameraPoint() {
                return this._helper.getCameraPoint();
            }
            getCameraAltitude() {
                return this._helper.getCameraAltitude();
            }
            getCameraLngLat() {
                const e1 = t.as(1, this.center.lat) * this.worldSize;
                return xe(this.center, this.elevation, this.pitch, this.bearing, this._helper.cameraToCenterDistance / e1).toLngLat();
            }
            lngLatToCameraDepth(e1, i) {
                const a = t.aa.fromLngLat(e1), r = [
                    a.x * this.worldSize,
                    a.y * this.worldSize,
                    i,
                    1
                ];
                return t.aG(r, r, this._viewProjMatrix), r[2] / r[3];
            }
            getProjectionData(e1) {
                const { overscaledTileID: i, aligned: a, applyTerrainMatrix: r } = e1, o = this._helper.getMercatorTileCoordinates(i), s = i ? this.calculatePosMatrix(i, a, !0) : null;
                let n;
                return n = i && i.terrainRttPosMatrix32f && r ? i.terrainRttPosMatrix32f : s || t.bh(), {
                    mainMatrix: n,
                    tileMercatorCoords: o,
                    clippingPlane: [
                        0,
                        0,
                        0,
                        0
                    ],
                    projectionTransition: 0,
                    fallbackMatrix: n
                };
            }
            isLocationOccluded(e1) {
                return !1;
            }
            getPixelScale() {
                return 1;
            }
            getCircleRadiusCorrection() {
                return 1;
            }
            getPitchedTextCorrection(e1, t, i) {
                return 1;
            }
            transformLightDirection(e1) {
                return t.b0(e1);
            }
            getRayDirectionFromPixel(e1) {
                throw new Error("Not implemented.");
            }
            projectTileCoordinates(e1, i, a, r) {
                const o = this.calculatePosMatrix(a);
                let s;
                r ? (s = [
                    e1,
                    i,
                    r(e1, i),
                    1
                ], t.aG(s, s, o)) : (s = [
                    e1,
                    i,
                    0,
                    1
                ], Je(s, s, o));
                const n = s[3];
                return {
                    point: new t.P(s[0] / n, s[1] / n),
                    signedDistanceFromCamera: n,
                    isOccluded: !1
                };
            }
            populateCache(e1) {
                for (const t of e1)this.calculatePosMatrix(t);
            }
            getMatrixForModel(e1, i) {
                const a = t.aa.fromLngLat(e1, i), r = a.meterInMercatorCoordinateUnits(), o = t.bi();
                return t.O(o, o, [
                    a.x,
                    a.y,
                    a.z
                ]), t.bf(o, o, Math.PI), t.bg(o, o, Math.PI / 2), t.Q(o, o, [
                    -r,
                    r,
                    r
                ]), o;
            }
            getProjectionDataForCustomLayer(e1 = !0) {
                const i = new t.a1(0, 0, 0, 0, 0), a = this.getProjectionData({
                    overscaledTileID: i,
                    applyGlobeMatrix: e1
                }), r = ve(i, this.worldSize);
                t.S(r, this._viewProjMatrix, r), a.tileMercatorCoords = [
                    0,
                    0,
                    1,
                    1
                ];
                const o = [
                    t.a4,
                    t.a4,
                    this.worldSize / this._helper.pixelsPerMeter
                ], s = t.bj();
                return t.Q(s, r, o), a.fallbackMatrix = s, a.mainMatrix = s, a;
            }
            getFastPathSimpleProjectionMatrix(e1) {
                return this.calculatePosMatrix(e1);
            }
        }
        function Gt() {
            t.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
        }
        function Ut(e1) {
            if (e1.useSlerp) {
                if (e1.k < 1) {
                    const i = t.bk(e1.startEulerAngles.roll, e1.startEulerAngles.pitch, e1.startEulerAngles.bearing), a = t.bk(e1.endEulerAngles.roll, e1.endEulerAngles.pitch, e1.endEulerAngles.bearing), r = new Float64Array(4);
                    t.bl(r, i, a, e1.k);
                    const o = t.bm(r);
                    e1.tr.setRoll(o.roll), e1.tr.setPitch(o.pitch), e1.tr.setBearing(o.bearing);
                } else e1.tr.setRoll(e1.endEulerAngles.roll), e1.tr.setPitch(e1.endEulerAngles.pitch), e1.tr.setBearing(e1.endEulerAngles.bearing);
            } else e1.tr.setRoll(t.G.number(e1.startEulerAngles.roll, e1.endEulerAngles.roll, e1.k)), e1.tr.setPitch(t.G.number(e1.startEulerAngles.pitch, e1.endEulerAngles.pitch, e1.k)), e1.tr.setBearing(t.G.number(e1.startEulerAngles.bearing, e1.endEulerAngles.bearing, e1.k));
        }
        function Vt(e1, i, a, r, o) {
            const s = o.padding, n = me(o.worldSize, a.getNorthWest()), l = me(o.worldSize, a.getNorthEast()), c = me(o.worldSize, a.getSouthEast()), h = me(o.worldSize, a.getSouthWest()), u = t.ap(-r), d = n.rotate(u), _ = l.rotate(u), p = c.rotate(u), m = h.rotate(u), f = new t.P(Math.max(d.x, _.x, m.x, p.x), Math.max(d.y, _.y, m.y, p.y)), g = new t.P(Math.min(d.x, _.x, m.x, p.x), Math.min(d.y, _.y, m.y, p.y)), v = f.sub(g), x = (o.width - (s.left + s.right + i.left + i.right)) / v.x, b = (o.height - (s.top + s.bottom + i.top + i.bottom)) / v.y;
            if (b < 0 || x < 0) return void Gt();
            const y = Math.min(t.at(o.scale * Math.min(x, b)), e1.maxZoom), w = t.P.convert(e1.offset), T = new t.P((i.left - i.right) / 2, (i.top - i.bottom) / 2).rotate(t.ap(r)), P = w.add(T).mult(o.scale / t.aq(y));
            return {
                center: fe(o.worldSize, n.add(c).div(2).sub(P)),
                zoom: y,
                bearing: r
            };
        }
        class qt {
            get useGlobeControls() {
                return !1;
            }
            handlePanInertia(e1, t) {
                const i = e1.mag(), a = Math.abs(ge(t));
                return {
                    easingOffset: e1.mult(Math.min(.75 * a / i, 1)),
                    easingCenter: t.center
                };
            }
            handleMapControlsRollPitchBearingZoom(e1, t) {
                e1.bearingDelta && t.setBearing(t.bearing + e1.bearingDelta), e1.pitchDelta && t.setPitch(t.pitch + e1.pitchDelta), e1.rollDelta && t.setRoll(t.roll + e1.rollDelta), e1.zoomDelta && t.setZoom(t.zoom + e1.zoomDelta);
            }
            handleMapControlsPan(e1, t, i) {
                e1.around.distSqr(t.centerPoint) < .01 || t.setLocationAtPoint(i, e1.around);
            }
            cameraForBoxAndBearing(e1, t, i, a, r) {
                return Vt(e1, t, i, a, r);
            }
            handleJumpToCenterZoom(e1, i) {
                e1.zoom !== (void 0 !== i.zoom ? +i.zoom : e1.zoom) && e1.setZoom(+i.zoom), void 0 !== i.center && e1.setCenter(t.V.convert(i.center));
            }
            handleEaseTo(e1, i) {
                const a = e1.zoom, r = e1.padding, o = {
                    roll: e1.roll,
                    pitch: e1.pitch,
                    bearing: e1.bearing
                }, s = {
                    roll: void 0 === i.roll ? e1.roll : i.roll,
                    pitch: void 0 === i.pitch ? e1.pitch : i.pitch,
                    bearing: void 0 === i.bearing ? e1.bearing : i.bearing
                }, n = void 0 !== i.zoom, l = !e1.isPaddingEqual(i.padding);
                let c = !1;
                const h = n ? +i.zoom : e1.zoom;
                let u = e1.centerPoint.add(i.offsetAsPoint);
                const d = e1.screenPointToLocation(u), { center: _, zoom: p } = e1.applyConstrain(t.V.convert(i.center || d), null != h ? h : a);
                kt(e1, _);
                const m = me(e1.worldSize, d), f = me(e1.worldSize, _).sub(m), g = t.aq(p - a);
                return c = p !== a, {
                    easeFunc: (n)=>{
                        if (c && e1.setZoom(t.G.number(a, p, n)), t.bn(o, s) || Ut({
                            startEulerAngles: o,
                            endEulerAngles: s,
                            tr: e1,
                            k: n,
                            useSlerp: o.roll != s.roll
                        }), l && (e1.interpolatePadding(r, i.padding, n), u = e1.centerPoint.add(i.offsetAsPoint)), i.around) e1.setLocationAtPoint(i.around, i.aroundPoint);
                        else {
                            const i = t.aq(e1.zoom - a), r = p > a ? Math.min(2, g) : Math.max(.5, g), o = Math.pow(r, 1 - n), s = fe(e1.worldSize, m.add(f.mult(n * o)).mult(i));
                            e1.setLocationAtPoint(e1.renderWorldCopies ? s.wrap() : s, u);
                        }
                    },
                    isZooming: c,
                    elevationCenter: _
                };
            }
            handleFlyTo(e1, i) {
                const a = void 0 !== i.zoom, r = e1.zoom, o = e1.applyConstrain(t.V.convert(i.center || i.locationAtOffset), a ? +i.zoom : r), s = o.center, n = o.zoom;
                kt(e1, s);
                const l = me(e1.worldSize, i.locationAtOffset), c = me(e1.worldSize, s).sub(l), h = c.mag(), u = t.aq(n - r);
                let d;
                if (void 0 !== i.minZoom) {
                    const a = Math.min(+i.minZoom, r, n), o = e1.applyConstrain(s, a).zoom;
                    d = t.aq(o - r);
                }
                return {
                    easeFunc: (i, a, o, h)=>{
                        e1.setZoom(1 === i ? n : r + t.at(a));
                        const u = 1 === i ? s : fe(e1.worldSize, l.add(c.mult(o)).mult(a));
                        e1.setLocationAtPoint(e1.renderWorldCopies ? u.wrap() : u, h);
                    },
                    scaleOfZoom: u,
                    targetCenter: s,
                    scaleOfMinZoom: d,
                    pixelPathLength: h
                };
            }
        }
        class Wt {
            constructor(e1, t, i){
                this.blendFunction = e1, this.blendColor = t, this.mask = i;
            }
        }
        Wt.Replace = [
            1,
            0
        ], Wt.disabled = new Wt(Wt.Replace, t.bo.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Wt.unblended = new Wt(Wt.Replace, t.bo.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Wt.alphaBlended = new Wt([
            1,
            771
        ], t.bo.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        const $t = 2305;
        class Ht {
            constructor(e1, t, i){
                this.enable = e1, this.mode = t, this.frontFace = i;
            }
        }
        Ht.disabled = new Ht(!1, 1029, $t), Ht.backCCW = new Ht(!0, 1029, $t), Ht.frontCCW = new Ht(!0, 1028, $t);
        class Xt {
            constructor(e1, t, i){
                this.func = e1, this.mask = t, this.range = i;
            }
        }
        Xt.ReadOnly = !1, Xt.ReadWrite = !0, Xt.disabled = new Xt(519, Xt.ReadOnly, [
            0,
            1
        ]);
        const Kt = 7680;
        class Yt {
            constructor(e1, t, i, a, r, o){
                this.test = e1, this.ref = t, this.mask = i, this.fail = a, this.depthFail = r, this.pass = o;
            }
        }
        Yt.disabled = new Yt({
            func: 519,
            mask: 0
        }, 0, 0, Kt, Kt, Kt);
        const Qt = new WeakMap;
        function Jt(e1) {
            var t;
            if (Qt.has(e1)) return Qt.get(e1);
            {
                const i = null === (t = e1.getParameter(e1.VERSION)) || void 0 === t ? void 0 : t.startsWith("WebGL 2.0");
                return Qt.set(e1, i), i;
            }
        }
        class ei {
            get awaitingQuery() {
                return !!this._readbackQueue;
            }
            constructor(e1){
                this._readbackWaitFrames = 4, this._measureWaitFrames = 6, this._texWidth = 1, this._texHeight = 1, this._measuredError = 0, this._updateCount = 0, this._lastReadbackFrame = -1000, this._readbackQueue = null, this._cachedRenderContext = e1;
                const i = e1.context, a = i.gl;
                this._texFormat = a.RGBA, this._texType = a.UNSIGNED_BYTE;
                const r = new t.aV;
                r.emplaceBack(-1, -1), r.emplaceBack(2, -1), r.emplaceBack(-1, 2);
                const o = new t.aX;
                o.emplaceBack(0, 1, 2), this._fullscreenTriangle = new St(i.createVertexBuffer(r, Rt.members), i.createIndexBuffer(o), t.aW.simpleSegment(0, 0, r.length, o.length)), this._resultBuffer = new Uint8Array(4), i.activeTexture.set(a.TEXTURE1);
                const s = a.createTexture();
                a.bindTexture(a.TEXTURE_2D, s), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.NEAREST), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, a.NEAREST), a.texImage2D(a.TEXTURE_2D, 0, this._texFormat, this._texWidth, this._texHeight, 0, this._texFormat, this._texType, null), this._fbo = i.createFramebuffer(this._texWidth, this._texHeight, !1, !1), this._fbo.colorAttachment.set(s), Jt(a) && (this._pbo = a.createBuffer(), a.bindBuffer(a.PIXEL_PACK_BUFFER, this._pbo), a.bufferData(a.PIXEL_PACK_BUFFER, 4, a.STREAM_READ), a.bindBuffer(a.PIXEL_PACK_BUFFER, null));
            }
            destroy() {
                const e1 = this._cachedRenderContext.context.gl;
                this._fullscreenTriangle.destroy(), this._fbo.destroy(), e1.deleteBuffer(this._pbo), this._fullscreenTriangle = null, this._fbo = null, this._pbo = null, this._resultBuffer = null;
            }
            updateErrorLoop(e1, t) {
                const i = this._updateCount;
                return this._readbackQueue ? i >= this._readbackQueue.frameNumberIssued + this._readbackWaitFrames && this._tryReadback() : i >= this._lastReadbackFrame + this._measureWaitFrames && this._renderErrorTexture(e1, t), this._updateCount++, this._measuredError;
            }
            _bindFramebuffer() {
                const e1 = this._cachedRenderContext.context, t = e1.gl;
                e1.activeTexture.set(t.TEXTURE1), t.bindTexture(t.TEXTURE_2D, this._fbo.colorAttachment.get()), e1.bindFramebuffer.set(this._fbo.framebuffer);
            }
            _renderErrorTexture(e1, i) {
                const a = this._cachedRenderContext.context, r = a.gl;
                if (this._bindFramebuffer(), a.viewport.set([
                    0,
                    0,
                    this._texWidth,
                    this._texHeight
                ]), a.clear({
                    color: t.bo.transparent
                }), this._cachedRenderContext.useProgram("projectionErrorMeasurement").draw(a, r.TRIANGLES, Xt.disabled, Yt.disabled, Wt.unblended, Ht.disabled, ((e1, t)=>({
                        u_input: e1,
                        u_output_expected: t
                    }))(e1, i), null, null, "$clipping", this._fullscreenTriangle.vertexBuffer, this._fullscreenTriangle.indexBuffer, this._fullscreenTriangle.segments), this._pbo && Jt(r)) {
                    r.bindBuffer(r.PIXEL_PACK_BUFFER, this._pbo), r.readBuffer(r.COLOR_ATTACHMENT0), r.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, 0), r.bindBuffer(r.PIXEL_PACK_BUFFER, null);
                    const e1 = r.fenceSync(r.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    r.flush(), this._readbackQueue = {
                        frameNumberIssued: this._updateCount,
                        sync: e1
                    };
                } else this._readbackQueue = {
                    frameNumberIssued: this._updateCount,
                    sync: null
                };
            }
            _tryReadback() {
                const e1 = this._cachedRenderContext.context.gl;
                if (this._pbo && this._readbackQueue && Jt(e1)) {
                    const i = e1.clientWaitSync(this._readbackQueue.sync, 0, 0);
                    if (i === e1.WAIT_FAILED) return t.w("WebGL2 clientWaitSync failed."), this._readbackQueue = null, void (this._lastReadbackFrame = this._updateCount);
                    if (i === e1.TIMEOUT_EXPIRED) return;
                    e1.bindBuffer(e1.PIXEL_PACK_BUFFER, this._pbo), e1.getBufferSubData(e1.PIXEL_PACK_BUFFER, 0, this._resultBuffer, 0, 4), e1.bindBuffer(e1.PIXEL_PACK_BUFFER, null);
                } else this._bindFramebuffer(), e1.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, this._resultBuffer);
                this._readbackQueue = null, this._measuredError = ei._parseRGBA8float(this._resultBuffer), this._lastReadbackFrame = this._updateCount;
            }
            static _parseRGBA8float(e1) {
                let t = 0;
                return t += e1[0] / 256, t += e1[1] / 65536, t += e1[2] / 16777216, e1[3] < 127 && (t = -t), t / 128;
            }
        }
        const ti = t.a4 / 128;
        function ii(e1, i) {
            const a = void 0 !== e1.granularity ? Math.max(e1.granularity, 1) : 1, r = a + (e1.generateBorders ? 2 : 0), o = a + (e1.extendToNorthPole || e1.generateBorders ? 1 : 0) + (e1.extendToSouthPole || e1.generateBorders ? 1 : 0), s = r + 1, n = o + 1, l = e1.generateBorders ? -1 : 0, c = e1.generateBorders || e1.extendToNorthPole ? -1 : 0, h = a + (e1.generateBorders ? 1 : 0), u = a + (e1.generateBorders || e1.extendToSouthPole ? 1 : 0), d = s * n, _ = r * o * 6, p = s * n > 65536;
            if (p && "16bit" === i) throw new Error("Granularity is too large and meshes would not fit inside 16 bit vertex indices.");
            const m = p || "32bit" === i, f = new Int16Array(2 * d);
            let g = 0;
            for(let i = c; i <= u; i++)for(let r = l; r <= h; r++){
                let o = r / a * t.a4;
                -1 === r && (o = -ti), r === a + 1 && (o = t.a4 + ti);
                let s = i / a * t.a4;
                -1 === i && (s = e1.extendToNorthPole ? t.bq : -ti), i === a + 1 && (s = e1.extendToSouthPole ? t.br : t.a4 + ti), f[g++] = o, f[g++] = s;
            }
            const v = m ? new Uint32Array(_) : new Uint16Array(_);
            let x = 0;
            for(let e1 = 0; e1 < o; e1++)for(let t = 0; t < r; t++){
                const i = t + 1 + e1 * s, a = t + (e1 + 1) * s, r = t + 1 + (e1 + 1) * s;
                v[x++] = t + e1 * s, v[x++] = a, v[x++] = i, v[x++] = i, v[x++] = a, v[x++] = r;
            }
            return {
                vertices: f.buffer.slice(0),
                indices: v.buffer.slice(0),
                uses32bitIndices: m
            };
        }
        const ai = new t.aU({
            fill: new t.bs(128, 2),
            line: new t.bs(512, 0),
            tile: new t.bs(128, 32),
            stencil: new t.bs(128, 1),
            circle: 3
        });
        class ri {
            constructor(){
                this._tileMeshCache = {}, this._errorCorrectionUsable = 0, this._errorMeasurementLastValue = 0, this._errorCorrectionPreviousValue = 0, this._errorMeasurementLastChangeTime = -1000;
            }
            get name() {
                return "vertical-perspective";
            }
            get transitionState() {
                return 1;
            }
            get useSubdivision() {
                return !0;
            }
            get shaderVariantName() {
                return "globe";
            }
            get shaderDefine() {
                return "#define GLOBE";
            }
            get shaderPreludeCode() {
                return It.projectionGlobe;
            }
            get vertexShaderPreludeCode() {
                return It.projectionMercator.vertexSource;
            }
            get subdivisionGranularity() {
                return ai;
            }
            get useGlobeControls() {
                return !0;
            }
            get latitudeErrorCorrectionRadians() {
                return this._errorCorrectionUsable;
            }
            destroy() {
                this._errorMeasurement && this._errorMeasurement.destroy();
            }
            updateGPUdependent(e1) {
                this._errorMeasurement || (this._errorMeasurement = new ei(e1));
                const i = t.X(this._errorQueryLatitudeDegrees), a = 2 * Math.atan(Math.exp(Math.PI - i * Math.PI * 2)) - .5 * Math.PI, r = this._errorMeasurement.updateErrorLoop(i, a), o = c();
                r !== this._errorMeasurementLastValue && (this._errorCorrectionPreviousValue = this._errorCorrectionUsable, this._errorMeasurementLastValue = r, this._errorMeasurementLastChangeTime = o);
                const s = Math.min(Math.max((o - this._errorMeasurementLastChangeTime) / 1e3 / .5, 0), 1);
                this._errorCorrectionUsable = t.bt(this._errorCorrectionPreviousValue, -this._errorMeasurementLastValue, t.bu(s));
            }
            _getMeshKey(e1) {
                return `${e1.granularity.toString(36)}_${e1.generateBorders ? "b" : ""}${e1.extendToNorthPole ? "n" : ""}${e1.extendToSouthPole ? "s" : ""}`;
            }
            getMeshFromTileID(e1, t, i, a, r) {
                const o = ("stencil" === r ? ai.stencil : ai.tile).getGranularityForZoomLevel(t.z);
                return this._getMesh(e1, {
                    granularity: o,
                    generateBorders: i,
                    extendToNorthPole: 0 === t.y && a,
                    extendToSouthPole: t.y === (1 << t.z) - 1 && a
                });
            }
            _getMesh(e1, i) {
                const a = this._getMeshKey(i);
                if (a in this._tileMeshCache) return this._tileMeshCache[a];
                const r = function(e1, i) {
                    const a = ii(i, "16bit"), r = t.aV.deserialize({
                        arrayBuffer: a.vertices,
                        length: a.vertices.byteLength / 2 / 2
                    }), o = t.aX.deserialize({
                        arrayBuffer: a.indices,
                        length: a.indices.byteLength / 2 / 3
                    });
                    return new St(e1.createVertexBuffer(r, Rt.members), e1.createIndexBuffer(o), t.aW.simpleSegment(0, 0, r.length, o.length));
                }(e1, i);
                return this._tileMeshCache[a] = r, r;
            }
            recalculate(e1) {}
            hasTransition() {
                const e1 = c();
                let t = !1;
                return t = t || (e1 - this._errorMeasurementLastChangeTime) / 1e3 < .7, t = t || this._errorMeasurement && this._errorMeasurement.awaitingQuery, t;
            }
            setErrorQueryLatitudeDegrees(e1) {
                this._errorQueryLatitudeDegrees = e1;
            }
        }
        const oi = new t.t({
            type: new t.D(t.u.projection.type)
        });
        class si extends t.E {
            constructor(e1){
                super(), this._transitionable = new t.x(oi, void 0), this.setProjection(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new t.H(0)), this._mercatorProjection = new At, this._verticalPerspectiveProjection = new ri;
            }
            get transitionState() {
                const e1 = this.properties.get("type");
                if ("string" == typeof e1 && "mercator" === e1) return 0;
                if ("string" == typeof e1 && "vertical-perspective" === e1) return 1;
                if (e1 instanceof t.bv) {
                    if ("vertical-perspective" === e1.from && "mercator" === e1.to) return 1 - e1.transition;
                    if ("mercator" === e1.from && "vertical-perspective" === e1.to) return e1.transition;
                }
                return 1;
            }
            get useGlobeRendering() {
                return this.transitionState > 0;
            }
            get latitudeErrorCorrectionRadians() {
                return this._verticalPerspectiveProjection.latitudeErrorCorrectionRadians;
            }
            get currentProjection() {
                return this.useGlobeRendering ? this._verticalPerspectiveProjection : this._mercatorProjection;
            }
            get name() {
                return "globe";
            }
            get useSubdivision() {
                return this.currentProjection.useSubdivision;
            }
            get shaderVariantName() {
                return this.currentProjection.shaderVariantName;
            }
            get shaderDefine() {
                return this.currentProjection.shaderDefine;
            }
            get shaderPreludeCode() {
                return this.currentProjection.shaderPreludeCode;
            }
            get vertexShaderPreludeCode() {
                return this.currentProjection.vertexShaderPreludeCode;
            }
            get subdivisionGranularity() {
                return this.currentProjection.subdivisionGranularity;
            }
            get useGlobeControls() {
                return this.transitionState > 0;
            }
            destroy() {
                this._mercatorProjection.destroy(), this._verticalPerspectiveProjection.destroy();
            }
            updateGPUdependent(e1) {
                this._mercatorProjection.updateGPUdependent(e1), this._verticalPerspectiveProjection.updateGPUdependent(e1);
            }
            getMeshFromTileID(e1, t, i, a, r) {
                return this.currentProjection.getMeshFromTileID(e1, t, i, a, r);
            }
            setProjection(e1) {
                this._transitionable.setValue("type", (null == e1 ? void 0 : e1.type) || "mercator");
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition() || this.currentProjection.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            setErrorQueryLatitudeDegrees(e1) {
                this._verticalPerspectiveProjection.setErrorQueryLatitudeDegrees(e1), this._mercatorProjection.setErrorQueryLatitudeDegrees(e1);
            }
        }
        function ni(e1) {
            const t = hi(e1.worldSize, e1.center.lat);
            return 2 * Math.PI * t;
        }
        function li(e1, i, a, r, o) {
            const s = 1 / (1 << o), n = i / t.a4 * s + r * s, l = t.bx((e1 / t.a4 * s + a * s) * Math.PI * 2 + Math.PI, 2 * Math.PI), c = 2 * Math.atan(Math.exp(Math.PI - n * Math.PI * 2)) - .5 * Math.PI, h = Math.cos(c), u = new Float64Array(3);
            return u[0] = Math.sin(l) * h, u[1] = Math.sin(c), u[2] = Math.cos(l) * h, u;
        }
        function ci(e1) {
            return function(e1, t) {
                const i = Math.cos(t), a = new Float64Array(3);
                return a[0] = Math.sin(e1) * i, a[1] = Math.sin(t), a[2] = Math.cos(e1) * i, a;
            }(e1.lng * Math.PI / 180, e1.lat * Math.PI / 180);
        }
        function hi(e1, t) {
            return e1 / (2 * Math.PI) / Math.cos(t * Math.PI / 180);
        }
        function ui(e1) {
            const i = Math.asin(e1[1]) / Math.PI * 180, a = Math.sqrt(e1[0] * e1[0] + e1[2] * e1[2]);
            if (a > 1e-6) {
                const r = e1[0] / a, o = Math.acos(e1[2] / a), s = (r > 0 ? o : -o) / Math.PI * 180;
                return new t.V(t.W(s, -180, 180), i);
            }
            return new t.V(0, i);
        }
        function di(e1) {
            return Math.cos(e1 * Math.PI / 180);
        }
        function _i(e1, i) {
            const a = di(e1), r = di(i);
            return t.at(r / a);
        }
        function pi(e1, i) {
            const a = e1.rotate(i.bearingInRadians), r = i.zoom + _i(i.center.lat, 0), o = t.bt(1 / di(i.center.lat), 1 / di(Math.min(Math.abs(i.center.lat), 60)), t.bw(r, 7, 3, 0, 1)), s = 360 / ni({
                worldSize: i.worldSize,
                center: {
                    lat: i.center.lat
                }
            });
            return new t.V(i.center.lng - a.x * s * o, t.an(i.center.lat + a.y * s, -t.ao, t.ao));
        }
        function mi(e1) {
            const t = .5 * e1, i = Math.sin(t), a = Math.cos(t);
            return Math.log(i + a) - Math.log(a - i);
        }
        function fi(e1, i, a, r) {
            const o = e1.lat + a * r;
            if (Math.abs(a) > 1) {
                const s = (Math.sign(e1.lat + a) !== Math.sign(e1.lat) ? -Math.abs(e1.lat) : Math.abs(e1.lat)) * Math.PI / 180, n = Math.abs(e1.lat + a) * Math.PI / 180, l = mi(s + r * (n - s)), c = mi(s), h = mi(n);
                return new t.V(e1.lng + i * ((l - c) / (h - c)), o);
            }
            return new t.V(e1.lng + i * r, o);
        }
        class gi {
            constructor(e1){
                this._cachePrevious = new Map, this._cache = new Map, this._hadAnyChanges = !1, this._boundingVolumeFactory = e1;
            }
            swapBuffers() {
                if (!this._hadAnyChanges) return;
                const e1 = this._cachePrevious;
                this._cachePrevious = this._cache, this._cache = e1, this._cache.clear(), this._hadAnyChanges = !1;
            }
            getTileBoundingVolume(e1, t, i, a) {
                const r = `${e1.z}_${e1.x}_${e1.y}_${(null == a ? void 0 : a.terrain) ? "t" : ""}`, o = this._cache.get(r);
                if (o) return o;
                const s = this._cachePrevious.get(r);
                if (s) return this._cache.set(r, s), s;
                const n = this._boundingVolumeFactory(e1, t, i, a);
                return this._cache.set(r, n), this._hadAnyChanges = !0, n;
            }
        }
        class vi {
            constructor(e1, t, i, a){
                this.min = i, this.max = a, this.points = e1, this.planes = t;
            }
            static fromAabb(e1, t) {
                const i = [];
                for(let a = 0; a < 8; a++)i.push([
                    1 & ~a ? e1[0] : t[0],
                    1 == (a >> 1 & 1) ? t[1] : e1[1],
                    1 == (a >> 2 & 1) ? t[2] : e1[2]
                ]);
                return new vi(i, [
                    [
                        -1,
                        0,
                        0,
                        t[0]
                    ],
                    [
                        1,
                        0,
                        0,
                        -e1[0]
                    ],
                    [
                        0,
                        -1,
                        0,
                        t[1]
                    ],
                    [
                        0,
                        1,
                        0,
                        -e1[1]
                    ],
                    [
                        0,
                        0,
                        -1,
                        t[2]
                    ],
                    [
                        0,
                        0,
                        1,
                        -e1[2]
                    ]
                ], e1, t);
            }
            static fromCenterSizeAngles(e1, i, a) {
                const r = t.bA([], a[0], a[1], a[2]), o = t.bB([], [
                    i[0],
                    0,
                    0
                ], r), s = t.bB([], [
                    0,
                    i[1],
                    0
                ], r), n = t.bB([], [
                    0,
                    0,
                    i[2]
                ], r), l = [
                    ...e1
                ], c = [
                    ...e1
                ];
                for(let t = 0; t < 8; t++)for(let i = 0; i < 3; i++){
                    const a = e1[i] + o[i] * (1 & ~t ? -1 : 1) + s[i] * (1 == (t >> 1 & 1) ? 1 : -1) + n[i] * (1 == (t >> 2 & 1) ? 1 : -1);
                    l[i] = Math.min(l[i], a), c[i] = Math.max(c[i], a);
                }
                const h = [];
                for(let i = 0; i < 8; i++){
                    const a = [
                        ...e1
                    ];
                    t.a$(a, a, t.a_([], o, 1 & ~i ? -1 : 1)), t.a$(a, a, t.a_([], s, 1 == (i >> 1 & 1) ? 1 : -1)), t.a$(a, a, t.a_([], n, 1 == (i >> 2 & 1) ? 1 : -1)), h.push(a);
                }
                return new vi(h, [
                    [
                        ...o,
                        -t.b4(o, h[0])
                    ],
                    [
                        ...s,
                        -t.b4(s, h[0])
                    ],
                    [
                        ...n,
                        -t.b4(n, h[0])
                    ],
                    [
                        -o[0],
                        -o[1],
                        -o[2],
                        -t.b4(o, h[7])
                    ],
                    [
                        -s[0],
                        -s[1],
                        -s[2],
                        -t.b4(s, h[7])
                    ],
                    [
                        -n[0],
                        -n[1],
                        -n[2],
                        -t.b4(n, h[7])
                    ]
                ], l, c);
            }
            intersectsFrustum(e1) {
                let t = !0;
                const i = this.points.length, a = this.planes.length, r = e1.planes.length, o = e1.points.length;
                for(let a = 0; a < r; a++){
                    const r = e1.planes[a];
                    let o = 0;
                    for(let e1 = 0; e1 < i; e1++){
                        const t = this.points[e1];
                        r[0] * t[0] + r[1] * t[1] + r[2] * t[2] + r[3] >= 0 && o++;
                    }
                    if (0 === o) return 0;
                    o < i && (t = !1);
                }
                if (t) return 2;
                for(let t = 0; t < a; t++){
                    const i = this.planes[t];
                    let a = 0;
                    for(let t = 0; t < o; t++){
                        const r = e1.points[t];
                        i[0] * r[0] + i[1] * r[1] + i[2] * r[2] + i[3] >= 0 && a++;
                    }
                    if (0 === a) return 0;
                }
                return 1;
            }
            intersectsPlane(e1) {
                const t = this.points.length;
                let i = 0;
                for(let a = 0; a < t; a++){
                    const t = this.points[a];
                    e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2] + e1[3] >= 0 && i++;
                }
                return i === t ? 2 : 0 === i ? 0 : 1;
            }
        }
        function xi(e1, t, i) {
            const a = e1 - t;
            return a < 0 ? -a : Math.max(0, a - i);
        }
        function bi(e1, t, i, a, r) {
            const o = e1 - i;
            let s;
            return s = o < 0 ? Math.min(-o, 1 + o - r) : o > 1 ? Math.min(Math.max(o - r, 0), 1 - o) : 0, Math.max(s, xi(t, a, r));
        }
        class yi {
            constructor(){
                this._boundingVolumeCache = new gi(this._computeTileBoundingVolume);
            }
            prepareNextFrame() {
                this._boundingVolumeCache.swapBuffers();
            }
            distanceToTile2d(e1, t, i, a) {
                const r = 1 << i.z, o = 1 / r, s = i.x / r, n = i.y / r;
                let l = 2;
                return l = Math.min(l, bi(e1, t, s, n, o)), l = Math.min(l, bi(e1, t, s + .5, -n - o, o)), l = Math.min(l, bi(e1, t, s + .5, 2 - n - o, o)), l;
            }
            getWrap(e1, t, i) {
                const a = 1 << t.z, r = 1 / a, o = t.x / a, s = xi(e1.x, o, r), n = xi(e1.x, o - 1, r), l = xi(e1.x, o + 1, r), c = Math.min(s, n, l);
                return c === l ? 1 : c === n ? -1 : 0;
            }
            allowVariableZoom(e1, t) {
                return Pe(e1, t) > 4;
            }
            allowWorldCopies() {
                return !1;
            }
            getTileBoundingVolume(e1, t, i, a) {
                return this._boundingVolumeCache.getTileBoundingVolume(e1, t, i, a);
            }
            _computeTileBoundingVolume(e1, i, a, r) {
                var o, s;
                let n = 0, l = 0;
                if (null == r ? void 0 : r.terrain) {
                    const c = new t.a1(e1.z, i, e1.z, e1.x, e1.y), h = r.terrain.getMinMaxElevation(c);
                    n = null !== (o = h.minElevation) && void 0 !== o ? o : Math.min(0, a), l = null !== (s = h.maxElevation) && void 0 !== s ? s : Math.max(0, a);
                }
                if (n /= t.bD, l /= t.bD, n += 1, l += 1, e1.z <= 0) return vi.fromAabb([
                    -l,
                    -l,
                    -l
                ], [
                    l,
                    l,
                    l
                ]);
                if (1 === e1.z) return vi.fromAabb([
                    0 === e1.x ? -l : 0,
                    0 === e1.y ? 0 : -l,
                    -l
                ], [
                    0 === e1.x ? 0 : l,
                    0 === e1.y ? l : 0,
                    l
                ]);
                {
                    const i = [
                        li(0, 0, e1.x, e1.y, e1.z),
                        li(t.a4, 0, e1.x, e1.y, e1.z),
                        li(t.a4, t.a4, e1.x, e1.y, e1.z),
                        li(0, t.a4, e1.x, e1.y, e1.z)
                    ], a = [];
                    for (const e1 of i)a.push(t.a_([], e1, l));
                    if (l !== n) for (const e1 of i)a.push(t.a_([], e1, n));
                    0 === e1.y && a.push([
                        0,
                        1,
                        0
                    ]), e1.y === (1 << e1.z) - 1 && a.push([
                        0,
                        -1,
                        0
                    ]);
                    const r = [
                        1,
                        1,
                        1
                    ], o = [
                        -1,
                        -1,
                        -1
                    ];
                    for (const e1 of a)for(let t = 0; t < 3; t++)r[t] = Math.min(r[t], e1[t]), o[t] = Math.max(o[t], e1[t]);
                    const s = li(t.a4 / 2, t.a4 / 2, e1.x, e1.y, e1.z), c = t.b3([], [
                        0,
                        1,
                        0
                    ], s);
                    t.b2(c, c);
                    const h = t.b3([], s, c);
                    t.b2(h, h);
                    const u = t.b3([], i[2], i[1]);
                    t.b2(u, u);
                    const d = t.b3([], i[0], i[3]);
                    t.b2(d, d), a.push(t.a_([], s, l)), e1.y >= (1 << e1.z) / 2 && a.push(t.a_([], li(t.a4 / 2, 0, e1.x, e1.y, e1.z), l)), e1.y < (1 << e1.z) / 2 && a.push(t.a_([], li(t.a4 / 2, t.a4, e1.x, e1.y, e1.z), l));
                    const _ = wi(s, a), p = wi(h, a), m = [
                        -s[0],
                        -s[1],
                        -s[2],
                        _.max
                    ], f = [
                        s[0],
                        s[1],
                        s[2],
                        -_.min
                    ], g = [
                        -h[0],
                        -h[1],
                        -h[2],
                        p.max
                    ], v = [
                        h[0],
                        h[1],
                        h[2],
                        -p.min
                    ], x = [
                        ...u,
                        0
                    ], b = [
                        ...d,
                        0
                    ], y = [];
                    return 0 === e1.y ? y.push(t.bC(b, x, m), t.bC(b, x, f)) : y.push(t.bC(g, x, m), t.bC(g, x, f), t.bC(g, b, m), t.bC(g, b, f)), e1.y === (1 << e1.z) - 1 ? y.push(t.bC(b, x, m), t.bC(b, x, f)) : y.push(t.bC(v, x, m), t.bC(v, x, f), t.bC(v, b, m), t.bC(v, b, f)), new vi(y, [
                        m,
                        f,
                        g,
                        v,
                        x,
                        b
                    ], r, o);
                }
            }
        }
        function wi(e1, i) {
            let a = 1 / 0, r = -1 / 0;
            for (const o of i){
                const i = t.b4(e1, o);
                a = Math.min(a, i), r = Math.max(r, i);
            }
            return {
                min: a,
                max: r
            };
        }
        class Ti {
            get pixelsToClipSpaceMatrix() {
                return this._helper.pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._helper.clipSpaceToPixelsMatrix;
            }
            get pixelsToGLUnits() {
                return this._helper.pixelsToGLUnits;
            }
            get centerOffset() {
                return this._helper.centerOffset;
            }
            get size() {
                return this._helper.size;
            }
            get rotationMatrix() {
                return this._helper.rotationMatrix;
            }
            get centerPoint() {
                return this._helper.centerPoint;
            }
            get pixelsPerMeter() {
                return this._helper.pixelsPerMeter;
            }
            setMinZoom(e1) {
                this._helper.setMinZoom(e1);
            }
            setMaxZoom(e1) {
                this._helper.setMaxZoom(e1);
            }
            setMinPitch(e1) {
                this._helper.setMinPitch(e1);
            }
            setMaxPitch(e1) {
                this._helper.setMaxPitch(e1);
            }
            setRenderWorldCopies(e1) {
                this._helper.setRenderWorldCopies(e1);
            }
            setBearing(e1) {
                this._helper.setBearing(e1);
            }
            setPitch(e1) {
                this._helper.setPitch(e1);
            }
            setRoll(e1) {
                this._helper.setRoll(e1);
            }
            setFov(e1) {
                this._helper.setFov(e1);
            }
            setZoom(e1) {
                this._helper.setZoom(e1);
            }
            setCenter(e1) {
                this._helper.setCenter(e1);
            }
            setElevation(e1) {
                this._helper.setElevation(e1);
            }
            setMinElevationForCurrentTile(e1) {
                this._helper.setMinElevationForCurrentTile(e1);
            }
            setPadding(e1) {
                this._helper.setPadding(e1);
            }
            interpolatePadding(e1, t, i) {
                return this._helper.interpolatePadding(e1, t, i);
            }
            isPaddingEqual(e1) {
                return this._helper.isPaddingEqual(e1);
            }
            resize(e1, t) {
                this._helper.resize(e1, t);
            }
            getMaxBounds() {
                return this._helper.getMaxBounds();
            }
            setMaxBounds(e1) {
                this._helper.setMaxBounds(e1);
            }
            setConstrainOverride(e1) {
                this._helper.setConstrainOverride(e1);
            }
            overrideNearFarZ(e1, t) {
                this._helper.overrideNearFarZ(e1, t);
            }
            clearNearFarZOverride() {
                this._helper.clearNearFarZOverride();
            }
            getCameraQueryGeometry(e1) {
                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
            }
            get tileSize() {
                return this._helper.tileSize;
            }
            get tileZoom() {
                return this._helper.tileZoom;
            }
            get scale() {
                return this._helper.scale;
            }
            get worldSize() {
                return this._helper.worldSize;
            }
            get width() {
                return this._helper.width;
            }
            get height() {
                return this._helper.height;
            }
            get lngRange() {
                return this._helper.lngRange;
            }
            get latRange() {
                return this._helper.latRange;
            }
            get minZoom() {
                return this._helper.minZoom;
            }
            get maxZoom() {
                return this._helper.maxZoom;
            }
            get zoom() {
                return this._helper.zoom;
            }
            get center() {
                return this._helper.center;
            }
            get minPitch() {
                return this._helper.minPitch;
            }
            get maxPitch() {
                return this._helper.maxPitch;
            }
            get pitch() {
                return this._helper.pitch;
            }
            get pitchInRadians() {
                return this._helper.pitchInRadians;
            }
            get roll() {
                return this._helper.roll;
            }
            get rollInRadians() {
                return this._helper.rollInRadians;
            }
            get bearing() {
                return this._helper.bearing;
            }
            get bearingInRadians() {
                return this._helper.bearingInRadians;
            }
            get fov() {
                return this._helper.fov;
            }
            get fovInRadians() {
                return this._helper.fovInRadians;
            }
            get elevation() {
                return this._helper.elevation;
            }
            get minElevationForCurrentTile() {
                return this._helper.minElevationForCurrentTile;
            }
            get padding() {
                return this._helper.padding;
            }
            get unmodified() {
                return this._helper.unmodified;
            }
            get renderWorldCopies() {
                return this._helper.renderWorldCopies;
            }
            get constrainOverride() {
                return this._helper.constrainOverride;
            }
            get nearZ() {
                return this._helper.nearZ;
            }
            get farZ() {
                return this._helper.farZ;
            }
            get autoCalculateNearFarZ() {
                return this._helper.autoCalculateNearFarZ;
            }
            setTransitionState(e1) {}
            constructor(e1){
                this._cachedClippingPlane = t.bE(), this._projectionMatrix = t.bi(), this._globeViewProjMatrix32f = t.bh(), this._globeViewProjMatrixNoCorrection = t.bi(), this._globeViewProjMatrixNoCorrectionInverted = t.bi(), this._globeProjMatrixInverted = t.bi(), this._cameraPosition = t.by(), this._globeLatitudeErrorCorrectionRadians = 0, this.defaultConstrain = (e1, i)=>{
                    const a = t.an(e1.lat, -t.ao, t.ao), r = t.an(+i, this.minZoom + _i(0, a), this.maxZoom);
                    return {
                        center: new t.V(e1.lng, a),
                        zoom: r
                    };
                }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new Bt({
                    calcMatrices: ()=>{
                        this._calcMatrices();
                    },
                    defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
                }, e1), this._coveringTilesDetailsProvider = new yi;
            }
            clone() {
                const e1 = new Ti;
                return e1.apply(this), e1;
            }
            apply(e1, t) {
                this._globeLatitudeErrorCorrectionRadians = t || 0, this._helper.apply(e1);
            }
            get projectionMatrix() {
                return this._projectionMatrix;
            }
            get modelViewProjectionMatrix() {
                return this._globeViewProjMatrixNoCorrection;
            }
            get inverseProjectionMatrix() {
                return this._globeProjMatrixInverted;
            }
            get cameraPosition() {
                const e1 = t.by();
                return e1[0] = this._cameraPosition[0], e1[1] = this._cameraPosition[1], e1[2] = this._cameraPosition[2], e1;
            }
            get cameraToCenterDistance() {
                return this._helper.cameraToCenterDistance;
            }
            getProjectionData(e1) {
                const { overscaledTileID: t, applyGlobeMatrix: i } = e1, a = this._helper.getMercatorTileCoordinates(t);
                return {
                    mainMatrix: this._globeViewProjMatrix32f,
                    tileMercatorCoords: a,
                    clippingPlane: this._cachedClippingPlane,
                    projectionTransition: i ? 1 : 0,
                    fallbackMatrix: this._globeViewProjMatrix32f
                };
            }
            _computeClippingPlane(e1) {
                const i = this.pitchInRadians, a = this.cameraToCenterDistance / e1, r = Math.sin(i) * a, o = Math.cos(i) * a + 1, s = 1 / Math.sqrt(r * r + o * o) * 1;
                let n = -r, l = o;
                const c = Math.sqrt(n * n + l * l);
                n /= c, l /= c;
                const h = [
                    0,
                    n,
                    l
                ];
                t.bF(h, h, [
                    0,
                    0,
                    0
                ], -this.bearingInRadians), t.bG(h, h, [
                    0,
                    0,
                    0
                ], -1 * this.center.lat * Math.PI / 180), t.bH(h, h, [
                    0,
                    0,
                    0
                ], this.center.lng * Math.PI / 180);
                const u = 1 / t.b6(h);
                return t.a_(h, h, u), [
                    ...h,
                    -s * u
                ];
            }
            isLocationOccluded(e1) {
                return !this.isSurfacePointVisible(ci(e1));
            }
            transformLightDirection(e1) {
                const i = this._helper._center.lng * Math.PI / 180, a = this._helper._center.lat * Math.PI / 180, r = Math.cos(a), o = [
                    Math.sin(i) * r,
                    Math.sin(a),
                    Math.cos(i) * r
                ], s = [
                    o[2],
                    0,
                    -o[0]
                ], n = [
                    0,
                    0,
                    0
                ];
                t.b3(n, s, o), t.b2(s, s), t.b2(n, n);
                const l = [
                    0,
                    0,
                    0
                ];
                return t.b2(l, [
                    s[0] * e1[0] + n[0] * e1[1] + o[0] * e1[2],
                    s[1] * e1[0] + n[1] * e1[1] + o[1] * e1[2],
                    s[2] * e1[0] + n[2] * e1[1] + o[2] * e1[2]
                ]), l;
            }
            getPixelScale() {
                return 1 / Math.cos(this._helper._center.lat * Math.PI / 180);
            }
            getCircleRadiusCorrection() {
                return Math.cos(this._helper._center.lat * Math.PI / 180);
            }
            getPitchedTextCorrection(e1, i, a) {
                const r = function(e1, i, a) {
                    const r = 1 / (1 << a.z);
                    return new t.aa(e1 / t.a4 * r + a.x * r, i / t.a4 * r + a.y * r);
                }(e1, i, a.canonical), o = (s = r.y, [
                    t.bx(r.x * Math.PI * 2 + Math.PI, 2 * Math.PI),
                    2 * Math.atan(Math.exp(Math.PI - s * Math.PI * 2)) - .5 * Math.PI
                ]);
                var s;
                return this.getCircleRadiusCorrection() / Math.cos(o[1]);
            }
            projectTileCoordinates(e1, i, a, r) {
                const o = a.canonical, s = li(e1, i, o.x, o.y, o.z), n = 1 + (r ? r(e1, i) : 0) / t.bD, l = [
                    s[0] * n,
                    s[1] * n,
                    s[2] * n,
                    1
                ];
                t.aG(l, l, this._globeViewProjMatrixNoCorrection);
                const c = this._cachedClippingPlane, h = c[0] * s[0] + c[1] * s[1] + c[2] * s[2] + c[3] < 0;
                return {
                    point: new t.P(l[0] / l[3], l[1] / l[3]),
                    signedDistanceFromCamera: l[3],
                    isOccluded: h
                };
            }
            _calcMatrices() {
                if (!this._helper._width || !this._helper._height) return;
                const e1 = hi(this.worldSize, this.center.lat), i = t.bj(), a = t.bj();
                this._helper.autoCalculateNearFarZ && (this._helper._nearZ = .5, this._helper._farZ = this.cameraToCenterDistance + 2 * e1), t.bd(i, this.fovInRadians, this.width / this.height, this._helper._nearZ, this._helper._farZ);
                const r = this.centerOffset;
                i[8] = 2 * -r.x / this._helper._width, i[9] = 2 * r.y / this._helper._height, this._projectionMatrix = t.be(i), this._globeProjMatrixInverted = t.bj(), t.aA(this._globeProjMatrixInverted, i), t.O(i, i, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t.bf(i, i, this.rollInRadians), t.bg(i, i, -this.pitchInRadians), t.bf(i, i, this.bearingInRadians), t.O(i, i, [
                    0,
                    0,
                    -e1
                ]);
                const o = t.by();
                o[0] = e1, o[1] = e1, o[2] = e1, t.bg(a, i, this.center.lat * Math.PI / 180), t.bI(a, a, -this.center.lng * Math.PI / 180), t.Q(a, a, o), this._globeViewProjMatrixNoCorrection = a, t.bg(i, i, this.center.lat * Math.PI / 180 - this._globeLatitudeErrorCorrectionRadians), t.bI(i, i, -this.center.lng * Math.PI / 180), t.Q(i, i, o), this._globeViewProjMatrix32f = new Float32Array(i), this._globeViewProjMatrixNoCorrectionInverted = t.bj(), t.aA(this._globeViewProjMatrixNoCorrectionInverted, a);
                const s = t.by();
                this._cameraPosition = t.by(), this._cameraPosition[2] = this.cameraToCenterDistance / e1, t.bF(this._cameraPosition, this._cameraPosition, s, -this.rollInRadians), t.bG(this._cameraPosition, this._cameraPosition, s, this.pitchInRadians), t.bF(this._cameraPosition, this._cameraPosition, s, -this.bearingInRadians), t.a$(this._cameraPosition, this._cameraPosition, [
                    0,
                    0,
                    1
                ]), t.bG(this._cameraPosition, this._cameraPosition, s, -this.center.lat * Math.PI / 180), t.bH(this._cameraPosition, this._cameraPosition, s, this.center.lng * Math.PI / 180), this._cachedClippingPlane = this._computeClippingPlane(e1);
                const n = t.be(this._globeViewProjMatrixNoCorrectionInverted);
                t.Q(n, n, [
                    1,
                    1,
                    -1
                ]), this._cachedFrustum = Nt.fromInvProjectionMatrix(n, 1, 0, this._cachedClippingPlane, !0);
            }
            calculateFogMatrix(e1) {
                t.w("calculateFogMatrix is not supported on globe projection.");
                const i = t.bj();
                return t.ar(i), i;
            }
            getVisibleUnwrappedCoordinates(e1) {
                return [
                    new t.bb(0, e1)
                ];
            }
            getCameraFrustum() {
                return this._cachedFrustum;
            }
            getClippingPlane() {
                return this._cachedClippingPlane;
            }
            getCoveringTilesDetailsProvider() {
                return this._coveringTilesDetailsProvider;
            }
            recalculateZoomAndCenter(e1) {
                e1 && t.w("terrain is not fully supported on vertical perspective projection."), this._helper.recalculateZoomAndCenter(0);
            }
            maxPitchScaleFactor() {
                return 1;
            }
            getCameraPoint() {
                return this._helper.getCameraPoint();
            }
            getCameraAltitude() {
                return this._helper.getCameraAltitude();
            }
            getCameraLngLat() {
                return this._helper.getCameraLngLat();
            }
            lngLatToCameraDepth(e1, i) {
                if (!this._globeViewProjMatrixNoCorrection) return 1;
                const a = ci(e1);
                t.a_(a, a, 1 + i / t.bD);
                const r = t.bE();
                return t.aG(r, [
                    a[0],
                    a[1],
                    a[2],
                    1
                ], this._globeViewProjMatrixNoCorrection), r[2] / r[3];
            }
            populateCache(e1) {}
            getBounds() {
                const e1 = .5 * this.width, i = .5 * this.height, a = [
                    new t.P(0, 0),
                    new t.P(e1, 0),
                    new t.P(this.width, 0),
                    new t.P(this.width, i),
                    new t.P(this.width, this.height),
                    new t.P(e1, this.height),
                    new t.P(0, this.height),
                    new t.P(0, i)
                ], r = [];
                for (const e1 of a)r.push(this.unprojectScreenPoint(e1));
                let o = 0, s = 0, n = 0, l = 0;
                const c = this.center;
                for (const e1 of r){
                    const i = t.bJ(c.lng, e1.lng), a = t.bJ(c.lat, e1.lat);
                    i < s && (s = i), i > o && (o = i), a < l && (l = a), a > n && (n = a);
                }
                const h = [
                    c.lng + s,
                    c.lat + l,
                    c.lng + o,
                    c.lat + n
                ];
                return this.isSurfacePointOnScreen([
                    0,
                    1,
                    0
                ]) && (h[3] = 90, h[0] = -180, h[2] = 180), this.isSurfacePointOnScreen([
                    0,
                    -1,
                    0
                ]) && (h[1] = -90, h[0] = -180, h[2] = 180), new $(h);
            }
            calculateCenterFromCameraLngLatAlt(e1, t, i, a) {
                return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, a);
            }
            setLocationAtPoint(e1, i) {
                const a = ci(this.unprojectScreenPoint(i)), r = ci(e1), o = t.by();
                t.bK(o);
                const s = t.by();
                t.bH(s, a, o, -this.center.lng * Math.PI / 180), t.bG(s, s, o, this.center.lat * Math.PI / 180);
                const n = r[0] * r[0] + r[2] * r[2], l = s[0] * s[0];
                if (n < l) return;
                const c = Math.sqrt(n - l), h = -c, u = t.bL(r[0], r[2], s[0], c), d = t.bL(r[0], r[2], s[0], h), _ = t.by();
                t.bH(_, r, o, -u);
                const p = t.bL(_[1], _[2], s[1], s[2]), m = t.by();
                t.bH(m, r, o, -d);
                const f = t.bL(m[1], m[2], s[1], s[2]), g = .5 * Math.PI, v = p >= -g && p <= g, x = f >= -g && f <= g;
                let b, y;
                if (v && x) {
                    const e1 = this.center.lng * Math.PI / 180, i = this.center.lat * Math.PI / 180;
                    t.bM(u, e1) + t.bM(p, i) < t.bM(d, e1) + t.bM(f, i) ? (b = u, y = p) : (b = d, y = f);
                } else if (v) b = u, y = p;
                else {
                    if (!x) return;
                    b = d, y = f;
                }
                const w = b / Math.PI * 180, T = y / Math.PI * 180, P = this.center.lat;
                this.setCenter(new t.V(w, t.an(T, -90, 90))), this.setZoom(this.zoom + _i(P, this.center.lat));
            }
            locationToScreenPoint(e1, i) {
                const a = ci(e1);
                if (i) {
                    const r = i.getElevationForLngLatZoom(e1, this._helper._tileZoom);
                    t.a_(a, a, 1 + r / t.bD);
                }
                return this._projectSurfacePointToScreen(a);
            }
            _projectSurfacePointToScreen(e1) {
                const i = t.bE();
                return t.aG(i, [
                    ...e1,
                    1
                ], this._globeViewProjMatrixNoCorrection), i[0] /= i[3], i[1] /= i[3], new t.P((.5 * i[0] + .5) * this.width, (.5 * -i[1] + .5) * this.height);
            }
            screenPointToMercatorCoordinate(e1, i) {
                if (i) {
                    const t = i.pointCoordinate(e1);
                    if (t) return t;
                }
                return t.aa.fromLngLat(this.unprojectScreenPoint(e1));
            }
            screenPointToLocation(e1, t) {
                var i;
                return null === (i = this.screenPointToMercatorCoordinate(e1, t)) || void 0 === i ? void 0 : i.toLngLat();
            }
            isPointOnMapSurface(e1, t) {
                const i = this._cameraPosition, a = this.getRayDirectionFromPixel(e1);
                return !!this.rayPlanetIntersection(i, a);
            }
            getRayDirectionFromPixel(e1) {
                const i = t.bE();
                i[0] = e1.x / this.width * 2 - 1, i[1] = -1 * (e1.y / this.height * 2 - 1), i[2] = 1, i[3] = 1, t.aG(i, i, this._globeViewProjMatrixNoCorrectionInverted), i[0] /= i[3], i[1] /= i[3], i[2] /= i[3];
                const a = t.by();
                a[0] = i[0] - this._cameraPosition[0], a[1] = i[1] - this._cameraPosition[1], a[2] = i[2] - this._cameraPosition[2];
                const r = t.by();
                return t.b2(r, a), r;
            }
            isSurfacePointVisible(e1) {
                const t = this._cachedClippingPlane;
                return t[0] * e1[0] + t[1] * e1[1] + t[2] * e1[2] + t[3] >= 0;
            }
            isSurfacePointOnScreen(e1) {
                if (!this.isSurfacePointVisible(e1)) return !1;
                const i = t.bE();
                return t.aG(i, [
                    ...e1,
                    1
                ], this._globeViewProjMatrixNoCorrection), i[0] /= i[3], i[1] /= i[3], i[2] /= i[3], i[0] > -1 && i[0] < 1 && i[1] > -1 && i[1] < 1 && i[2] > -1 && i[2] < 1;
            }
            rayPlanetIntersection(e1, i) {
                const a = t.b4(e1, i), r = t.by(), o = t.by();
                t.a_(o, i, a), t.b1(r, e1, o);
                const s = 1 - t.b4(r, r);
                if (s < 0) return null;
                const n = t.b4(e1, e1) - 1, l = -a + (a < 0 ? 1 : -1) * Math.sqrt(s), c = n / l, h = l;
                return {
                    tMin: Math.min(c, h),
                    tMax: Math.max(c, h)
                };
            }
            unprojectScreenPoint(e1) {
                const i = this._cameraPosition, a = this.getRayDirectionFromPixel(e1), r = this.rayPlanetIntersection(i, a);
                if (r) {
                    const e1 = t.by();
                    t.a$(e1, i, [
                        a[0] * r.tMin,
                        a[1] * r.tMin,
                        a[2] * r.tMin
                    ]);
                    const o = t.by();
                    return t.b2(o, e1), ui(o);
                }
                const o = this._cachedClippingPlane, s = o[0] * a[0] + o[1] * a[1] + o[2] * a[2], n = -t.ba(o, i) / s, l = t.by();
                if (n > 0) t.a$(l, i, [
                    a[0] * n,
                    a[1] * n,
                    a[2] * n
                ]);
                else {
                    const e1 = t.by();
                    t.a$(e1, i, [
                        2 * a[0],
                        2 * a[1],
                        2 * a[2]
                    ]);
                    const r = t.ba(this._cachedClippingPlane, e1);
                    t.b1(l, e1, [
                        this._cachedClippingPlane[0] * r,
                        this._cachedClippingPlane[1] * r,
                        this._cachedClippingPlane[2] * r
                    ]);
                }
                const c = function(e1) {
                    const i = t.by();
                    return i[0] = e1[0] * -e1[3], i[1] = e1[1] * -e1[3], i[2] = e1[2] * -e1[3], {
                        center: i,
                        radius: Math.sqrt(1 - e1[3] * e1[3])
                    };
                }(o);
                return ui(function(e1, i, a) {
                    const r = t.by();
                    t.b1(r, a, e1);
                    const o = t.by();
                    return t.bz(o, e1, r, i / t.b8(r)), o;
                }(c.center, c.radius, l));
            }
            getMatrixForModel(e1, i) {
                const a = t.V.convert(e1), r = 1 / t.bD, o = t.bi();
                return t.bI(o, o, a.lng / 180 * Math.PI), t.bg(o, o, -a.lat / 180 * Math.PI), t.O(o, o, [
                    0,
                    0,
                    1 + i / t.bD
                ]), t.bg(o, o, .5 * Math.PI), t.Q(o, o, [
                    r,
                    r,
                    r
                ]), o;
            }
            getProjectionDataForCustomLayer(e1 = !0) {
                const i = this.getProjectionData({
                    overscaledTileID: new t.a1(0, 0, 0, 0, 0),
                    applyGlobeMatrix: e1
                });
                return i.tileMercatorCoords = [
                    0,
                    0,
                    1,
                    1
                ], i;
            }
            getFastPathSimpleProjectionMatrix(e1) {}
        }
        class Pi {
            get pixelsToClipSpaceMatrix() {
                return this._helper.pixelsToClipSpaceMatrix;
            }
            get clipSpaceToPixelsMatrix() {
                return this._helper.clipSpaceToPixelsMatrix;
            }
            get pixelsToGLUnits() {
                return this._helper.pixelsToGLUnits;
            }
            get centerOffset() {
                return this._helper.centerOffset;
            }
            get size() {
                return this._helper.size;
            }
            get rotationMatrix() {
                return this._helper.rotationMatrix;
            }
            get centerPoint() {
                return this._helper.centerPoint;
            }
            get pixelsPerMeter() {
                return this._helper.pixelsPerMeter;
            }
            setMinZoom(e1) {
                this._helper.setMinZoom(e1);
            }
            setMaxZoom(e1) {
                this._helper.setMaxZoom(e1);
            }
            setMinPitch(e1) {
                this._helper.setMinPitch(e1);
            }
            setMaxPitch(e1) {
                this._helper.setMaxPitch(e1);
            }
            setRenderWorldCopies(e1) {
                this._helper.setRenderWorldCopies(e1);
            }
            setBearing(e1) {
                this._helper.setBearing(e1);
            }
            setPitch(e1) {
                this._helper.setPitch(e1);
            }
            setRoll(e1) {
                this._helper.setRoll(e1);
            }
            setFov(e1) {
                this._helper.setFov(e1);
            }
            setZoom(e1) {
                this._helper.setZoom(e1);
            }
            setCenter(e1) {
                this._helper.setCenter(e1);
            }
            setElevation(e1) {
                this._helper.setElevation(e1);
            }
            setMinElevationForCurrentTile(e1) {
                this._helper.setMinElevationForCurrentTile(e1);
            }
            setPadding(e1) {
                this._helper.setPadding(e1);
            }
            interpolatePadding(e1, t, i) {
                return this._helper.interpolatePadding(e1, t, i);
            }
            isPaddingEqual(e1) {
                return this._helper.isPaddingEqual(e1);
            }
            resize(e1, t, i = !0) {
                this._helper.resize(e1, t, i);
            }
            getMaxBounds() {
                return this._helper.getMaxBounds();
            }
            setMaxBounds(e1) {
                this._helper.setMaxBounds(e1);
            }
            setConstrainOverride(e1) {
                this._helper.setConstrainOverride(e1);
            }
            overrideNearFarZ(e1, t) {
                this._helper.overrideNearFarZ(e1, t);
            }
            clearNearFarZOverride() {
                this._helper.clearNearFarZOverride();
            }
            getCameraQueryGeometry(e1) {
                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
            }
            get tileSize() {
                return this._helper.tileSize;
            }
            get tileZoom() {
                return this._helper.tileZoom;
            }
            get scale() {
                return this._helper.scale;
            }
            get worldSize() {
                return this._helper.worldSize;
            }
            get width() {
                return this._helper.width;
            }
            get height() {
                return this._helper.height;
            }
            get lngRange() {
                return this._helper.lngRange;
            }
            get latRange() {
                return this._helper.latRange;
            }
            get minZoom() {
                return this._helper.minZoom;
            }
            get maxZoom() {
                return this._helper.maxZoom;
            }
            get zoom() {
                return this._helper.zoom;
            }
            get center() {
                return this._helper.center;
            }
            get minPitch() {
                return this._helper.minPitch;
            }
            get maxPitch() {
                return this._helper.maxPitch;
            }
            get pitch() {
                return this._helper.pitch;
            }
            get pitchInRadians() {
                return this._helper.pitchInRadians;
            }
            get roll() {
                return this._helper.roll;
            }
            get rollInRadians() {
                return this._helper.rollInRadians;
            }
            get bearing() {
                return this._helper.bearing;
            }
            get bearingInRadians() {
                return this._helper.bearingInRadians;
            }
            get fov() {
                return this._helper.fov;
            }
            get fovInRadians() {
                return this._helper.fovInRadians;
            }
            get elevation() {
                return this._helper.elevation;
            }
            get minElevationForCurrentTile() {
                return this._helper.minElevationForCurrentTile;
            }
            get padding() {
                return this._helper.padding;
            }
            get unmodified() {
                return this._helper.unmodified;
            }
            get renderWorldCopies() {
                return this._helper.renderWorldCopies;
            }
            get cameraToCenterDistance() {
                return this._helper.cameraToCenterDistance;
            }
            get constrainOverride() {
                return this._helper.constrainOverride;
            }
            get nearZ() {
                return this._helper.nearZ;
            }
            get farZ() {
                return this._helper.farZ;
            }
            get autoCalculateNearFarZ() {
                return this._helper.autoCalculateNearFarZ;
            }
            get isGlobeRendering() {
                return this._globeness > 0;
            }
            setTransitionState(e1, t) {
                this._globeness = e1, this._globeLatitudeErrorCorrectionRadians = t, this._calcMatrices(), this._verticalPerspectiveTransform.getCoveringTilesDetailsProvider().prepareNextFrame(), this._mercatorTransform.getCoveringTilesDetailsProvider().prepareNextFrame();
            }
            get currentTransform() {
                return this.isGlobeRendering ? this._verticalPerspectiveTransform : this._mercatorTransform;
            }
            constructor(e1){
                this._globeLatitudeErrorCorrectionRadians = 0, this._globeness = 1, this.defaultConstrain = (e1, t)=>this.currentTransform.defaultConstrain(e1, t), this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new Bt({
                    calcMatrices: ()=>{
                        this._calcMatrices();
                    },
                    defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
                }, e1), this._globeness = 1, this._mercatorTransform = new Zt, this._verticalPerspectiveTransform = new Ti;
            }
            clone() {
                const e1 = new Pi;
                return e1._globeness = this._globeness, e1._globeLatitudeErrorCorrectionRadians = this._globeLatitudeErrorCorrectionRadians, e1.apply(this), e1;
            }
            apply(e1) {
                this._helper.apply(e1), this._mercatorTransform.apply(this), this._verticalPerspectiveTransform.apply(this, this._globeLatitudeErrorCorrectionRadians);
            }
            get projectionMatrix() {
                return this.currentTransform.projectionMatrix;
            }
            get modelViewProjectionMatrix() {
                return this.currentTransform.modelViewProjectionMatrix;
            }
            get inverseProjectionMatrix() {
                return this.currentTransform.inverseProjectionMatrix;
            }
            get cameraPosition() {
                return this.currentTransform.cameraPosition;
            }
            getProjectionData(e1) {
                const t = this._mercatorTransform.getProjectionData(e1), i = this._verticalPerspectiveTransform.getProjectionData(e1);
                return {
                    mainMatrix: this.isGlobeRendering ? i.mainMatrix : t.mainMatrix,
                    clippingPlane: i.clippingPlane,
                    tileMercatorCoords: i.tileMercatorCoords,
                    projectionTransition: e1.applyGlobeMatrix ? this._globeness : 0,
                    fallbackMatrix: t.fallbackMatrix
                };
            }
            isLocationOccluded(e1) {
                return this.currentTransform.isLocationOccluded(e1);
            }
            transformLightDirection(e1) {
                return this.currentTransform.transformLightDirection(e1);
            }
            getPixelScale() {
                return t.bt(this._mercatorTransform.getPixelScale(), this._verticalPerspectiveTransform.getPixelScale(), this._globeness);
            }
            getCircleRadiusCorrection() {
                return t.bt(this._mercatorTransform.getCircleRadiusCorrection(), this._verticalPerspectiveTransform.getCircleRadiusCorrection(), this._globeness);
            }
            getPitchedTextCorrection(e1, i, a) {
                const r = this._mercatorTransform.getPitchedTextCorrection(e1, i, a), o = this._verticalPerspectiveTransform.getPitchedTextCorrection(e1, i, a);
                return t.bt(r, o, this._globeness);
            }
            projectTileCoordinates(e1, t, i, a) {
                return this.currentTransform.projectTileCoordinates(e1, t, i, a);
            }
            _calcMatrices() {
                this._helper._width && this._helper._height && (this._verticalPerspectiveTransform.apply(this, this._globeLatitudeErrorCorrectionRadians), this._helper._nearZ = this._verticalPerspectiveTransform.nearZ, this._helper._farZ = this._verticalPerspectiveTransform.farZ, this._mercatorTransform.apply(this, !0, this.isGlobeRendering), this._helper._nearZ = this._mercatorTransform.nearZ, this._helper._farZ = this._mercatorTransform.farZ);
            }
            calculateFogMatrix(e1) {
                return this.currentTransform.calculateFogMatrix(e1);
            }
            getVisibleUnwrappedCoordinates(e1) {
                return this.currentTransform.getVisibleUnwrappedCoordinates(e1);
            }
            getCameraFrustum() {
                return this.currentTransform.getCameraFrustum();
            }
            getClippingPlane() {
                return this.currentTransform.getClippingPlane();
            }
            getCoveringTilesDetailsProvider() {
                return this.currentTransform.getCoveringTilesDetailsProvider();
            }
            recalculateZoomAndCenter(e1) {
                this._mercatorTransform.recalculateZoomAndCenter(e1), this._verticalPerspectiveTransform.recalculateZoomAndCenter(e1);
            }
            maxPitchScaleFactor() {
                return this._mercatorTransform.maxPitchScaleFactor();
            }
            getCameraPoint() {
                return this._helper.getCameraPoint();
            }
            getCameraAltitude() {
                return this._helper.getCameraAltitude();
            }
            getCameraLngLat() {
                return this._helper.getCameraLngLat();
            }
            lngLatToCameraDepth(e1, t) {
                return this.currentTransform.lngLatToCameraDepth(e1, t);
            }
            populateCache(e1) {
                this._mercatorTransform.populateCache(e1), this._verticalPerspectiveTransform.populateCache(e1);
            }
            getBounds() {
                return this.currentTransform.getBounds();
            }
            calculateCenterFromCameraLngLatAlt(e1, t, i, a) {
                return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, a);
            }
            setLocationAtPoint(e1, t) {
                if (!this.isGlobeRendering) return this._mercatorTransform.setLocationAtPoint(e1, t), void this.apply(this._mercatorTransform);
                this._verticalPerspectiveTransform.setLocationAtPoint(e1, t), this.apply(this._verticalPerspectiveTransform);
            }
            locationToScreenPoint(e1, t) {
                return this.currentTransform.locationToScreenPoint(e1, t);
            }
            screenPointToMercatorCoordinate(e1, t) {
                return this.currentTransform.screenPointToMercatorCoordinate(e1, t);
            }
            screenPointToLocation(e1, t) {
                return this.currentTransform.screenPointToLocation(e1, t);
            }
            isPointOnMapSurface(e1, t) {
                return this.currentTransform.isPointOnMapSurface(e1, t);
            }
            getRayDirectionFromPixel(e1) {
                return this._verticalPerspectiveTransform.getRayDirectionFromPixel(e1);
            }
            getMatrixForModel(e1, t) {
                return this.currentTransform.getMatrixForModel(e1, t);
            }
            getProjectionDataForCustomLayer(e1 = !0) {
                const t = this._mercatorTransform.getProjectionDataForCustomLayer(e1);
                if (!this.isGlobeRendering) return t;
                const i = this._verticalPerspectiveTransform.getProjectionDataForCustomLayer(e1);
                return i.fallbackMatrix = t.mainMatrix, i;
            }
            getFastPathSimpleProjectionMatrix(e1) {
                return this.currentTransform.getFastPathSimpleProjectionMatrix(e1);
            }
        }
        class Ci {
            get useGlobeControls() {
                return !0;
            }
            handlePanInertia(e1, i) {
                const a = pi(e1, i);
                return Math.abs(a.lng - i.center.lng) > 180 && (a.lng = i.center.lng + 179.5 * Math.sign(a.lng - i.center.lng)), {
                    easingCenter: a,
                    easingOffset: new t.P(0, 0)
                };
            }
            handleMapControlsRollPitchBearingZoom(e1, i) {
                const a = e1.around, r = i.screenPointToLocation(a);
                e1.bearingDelta && i.setBearing(i.bearing + e1.bearingDelta), e1.pitchDelta && i.setPitch(i.pitch + e1.pitchDelta), e1.rollDelta && i.setRoll(i.roll + e1.rollDelta);
                const o = i.zoom;
                e1.zoomDelta && i.setZoom(i.zoom + e1.zoomDelta);
                const s = i.zoom - o;
                if (0 === s) return;
                const n = t.bJ(i.center.lng, r.lng), l = n / (Math.abs(n / 180) + 1), c = t.bJ(i.center.lat, r.lat), h = i.getRayDirectionFromPixel(a), u = i.cameraPosition, d = -1 * t.b4(u, h), _ = t.by();
                t.a$(_, u, [
                    h[0] * d,
                    h[1] * d,
                    h[2] * d
                ]);
                const p = t.b6(_) - 1, m = Math.exp(.5 * -Math.max(p - .3, 0)), f = hi(i.worldSize, i.center.lat) / Math.min(i.width, i.height), g = t.bw(f, .9, .5, 1, .25), v = (1 - t.aq(-s)) * Math.min(m, g), x = i.center.lat, b = i.zoom, y = new t.V(i.center.lng + l * v, t.an(i.center.lat + c * v, -t.ao, t.ao));
                i.setLocationAtPoint(r, a);
                const w = i.center, T = t.bw(Math.abs(n), 45, 85, 0, 1), P = t.bw(f, .75, .35, 0, 1), C = Math.pow(Math.max(T, P), .25), M = t.bJ(w.lng, y.lng), I = t.bJ(w.lat, y.lat);
                i.setCenter(new t.V(w.lng + M * C, w.lat + I * C).wrap()), i.setZoom(b + _i(x, i.center.lat));
            }
            handleMapControlsPan(e1, t, i) {
                if (!e1.panDelta) return;
                const a = t.center.lat, r = t.zoom;
                t.setCenter(pi(e1.panDelta, t).wrap()), t.setZoom(r + _i(a, t.center.lat));
            }
            cameraForBoxAndBearing(e1, i, a, r, o) {
                const s = Vt(e1, i, a, r, o), n = i.left / o.width * 2 - 1, l = (o.width - i.right) / o.width * 2 - 1, c = i.top / o.height * -2 + 1, h = (o.height - i.bottom) / o.height * -2 + 1, u = t.bJ(a.getWest(), a.getEast()) < 0, d = u ? a.getEast() : a.getWest(), _ = u ? a.getWest() : a.getEast(), p = Math.max(a.getNorth(), a.getSouth()), m = Math.min(a.getNorth(), a.getSouth()), f = d + .5 * t.bJ(d, _), g = p + .5 * t.bJ(p, m), v = o.clone();
                v.setCenter(s.center), v.setBearing(s.bearing), v.setPitch(0), v.setRoll(0), v.setZoom(s.zoom);
                const x = v.modelViewProjectionMatrix, b = [
                    ci(a.getNorthWest()),
                    ci(a.getNorthEast()),
                    ci(a.getSouthWest()),
                    ci(a.getSouthEast()),
                    ci(new t.V(_, g)),
                    ci(new t.V(d, g)),
                    ci(new t.V(f, p)),
                    ci(new t.V(f, m))
                ], y = ci(s.center);
                let w = Number.POSITIVE_INFINITY;
                for (const e1 of b)n < 0 && (w = Ci.getLesserNonNegativeNonNull(w, Ci.solveVectorScale(e1, y, x, "x", n))), l > 0 && (w = Ci.getLesserNonNegativeNonNull(w, Ci.solveVectorScale(e1, y, x, "x", l))), c > 0 && (w = Ci.getLesserNonNegativeNonNull(w, Ci.solveVectorScale(e1, y, x, "y", c))), h < 0 && (w = Ci.getLesserNonNegativeNonNull(w, Ci.solveVectorScale(e1, y, x, "y", h)));
                if (Number.isFinite(w) && 0 !== w) return s.zoom = v.zoom + t.at(w), s;
                Gt();
            }
            handleJumpToCenterZoom(e1, i) {
                const a = e1.center.lat, r = e1.applyConstrain(i.center ? t.V.convert(i.center) : e1.center, e1.zoom).center;
                e1.setCenter(r.wrap());
                const o = void 0 !== i.zoom ? +i.zoom : e1.zoom + _i(a, r.lat);
                e1.zoom !== o && e1.setZoom(o);
            }
            handleEaseTo(e1, i) {
                const a = e1.zoom, r = e1.center, o = e1.padding, s = {
                    roll: e1.roll,
                    pitch: e1.pitch,
                    bearing: e1.bearing
                }, n = {
                    roll: void 0 === i.roll ? e1.roll : i.roll,
                    pitch: void 0 === i.pitch ? e1.pitch : i.pitch,
                    bearing: void 0 === i.bearing ? e1.bearing : i.bearing
                }, l = void 0 !== i.zoom, c = !e1.isPaddingEqual(i.padding);
                let h = !1;
                const u = i.center ? t.V.convert(i.center) : r, d = e1.applyConstrain(u, a).center;
                kt(e1, d);
                const _ = e1.clone();
                _.setCenter(d), _.setZoom(l ? +i.zoom : a + _i(r.lat, u.lat)), _.setBearing(i.bearing);
                const p = new t.P(t.an(e1.centerPoint.x + i.offsetAsPoint.x, 0, e1.width), t.an(e1.centerPoint.y + i.offsetAsPoint.y, 0, e1.height));
                _.setLocationAtPoint(d, p);
                const m = (i.offset && i.offsetAsPoint.mag()) > 0 ? _.center : d, f = l ? +i.zoom : a + _i(r.lat, m.lat), g = a + _i(r.lat, 0), v = f + _i(m.lat, 0), x = t.bJ(r.lng, m.lng), b = t.bJ(r.lat, m.lat), y = t.aq(v - g);
                return h = f !== a, {
                    easeFunc: (a)=>{
                        if (t.bn(s, n) || Ut({
                            startEulerAngles: s,
                            endEulerAngles: n,
                            tr: e1,
                            k: a,
                            useSlerp: s.roll != n.roll
                        }), c && e1.interpolatePadding(o, i.padding, a), i.around) t.w("Easing around a point is not supported under globe projection."), e1.setLocationAtPoint(i.around, i.aroundPoint);
                        else {
                            const t = v > g ? Math.min(2, y) : Math.max(.5, y), i = Math.pow(t, 1 - a), o = fi(r, x, b, a * i);
                            e1.setCenter(o.wrap());
                        }
                        if (h) {
                            const i = t.G.number(g, v, a) + _i(0, e1.center.lat);
                            e1.setZoom(i);
                        }
                    },
                    isZooming: h,
                    elevationCenter: m
                };
            }
            handleFlyTo(e1, i) {
                const a = void 0 !== i.zoom, r = e1.center, o = e1.zoom, s = e1.padding, n = !e1.isPaddingEqual(i.padding), l = e1.applyConstrain(t.V.convert(i.center || i.locationAtOffset), o).center, c = a ? +i.zoom : e1.zoom + _i(e1.center.lat, l.lat), h = e1.clone();
                h.setCenter(l), h.setZoom(c), h.setBearing(i.bearing);
                const u = new t.P(t.an(e1.centerPoint.x + i.offsetAsPoint.x, 0, e1.width), t.an(e1.centerPoint.y + i.offsetAsPoint.y, 0, e1.height));
                h.setLocationAtPoint(l, u);
                const d = h.center;
                kt(e1, d);
                const _ = function(e1, i, a) {
                    const r = ci(i), o = ci(a), s = t.b4(r, o), n = Math.acos(s), l = ni(e1);
                    return n / (2 * Math.PI) * l;
                }(e1, r, d), p = o + _i(r.lat, 0), m = c + _i(d.lat, 0), f = t.aq(m - p);
                let g;
                if ("number" == typeof i.minZoom) {
                    const a = +i.minZoom + _i(d.lat, 0), r = Math.min(a, p, m) + _i(0, d.lat), o = e1.applyConstrain(d, r).zoom + _i(d.lat, 0);
                    g = t.aq(o - p);
                }
                const v = t.bJ(r.lng, d.lng), x = t.bJ(r.lat, d.lat);
                return {
                    easeFunc: (a, o, l, h)=>{
                        const u = fi(r, v, x, l);
                        n && e1.interpolatePadding(s, i.padding, a);
                        const _ = 1 === a ? d : u;
                        e1.setCenter(_.wrap());
                        const m = p + t.at(o);
                        e1.setZoom(1 === a ? c : m + _i(0, _.lat));
                    },
                    scaleOfZoom: f,
                    targetCenter: d,
                    scaleOfMinZoom: g,
                    pixelPathLength: _
                };
            }
            static solveVectorScale(e1, t, i, a, r) {
                const o = "x" === a ? [
                    i[0],
                    i[4],
                    i[8],
                    i[12]
                ] : [
                    i[1],
                    i[5],
                    i[9],
                    i[13]
                ], s = [
                    i[3],
                    i[7],
                    i[11],
                    i[15]
                ], n = e1[0] * o[0] + e1[1] * o[1] + e1[2] * o[2], l = e1[0] * s[0] + e1[1] * s[1] + e1[2] * s[2], c = t[0] * o[0] + t[1] * o[1] + t[2] * o[2], h = t[0] * s[0] + t[1] * s[1] + t[2] * s[2];
                return c + r * l === n + r * h || s[3] * (n - c) + o[3] * (h - l) + n * h == c * l ? null : (c + o[3] - r * h - r * s[3]) / (c - n - r * h + r * l);
            }
            static getLesserNonNegativeNonNull(e1, t) {
                return null !== t && t >= 0 && t < e1 ? t : e1;
            }
        }
        class Mi {
            constructor(e1){
                this._globe = e1, this._mercatorCameraHelper = new qt, this._verticalPerspectiveCameraHelper = new Ci;
            }
            get useGlobeControls() {
                return this._globe.useGlobeRendering;
            }
            get currentHelper() {
                return this.useGlobeControls ? this._verticalPerspectiveCameraHelper : this._mercatorCameraHelper;
            }
            handlePanInertia(e1, t) {
                return this.currentHelper.handlePanInertia(e1, t);
            }
            handleMapControlsRollPitchBearingZoom(e1, t) {
                return this.currentHelper.handleMapControlsRollPitchBearingZoom(e1, t);
            }
            handleMapControlsPan(e1, t, i) {
                this.currentHelper.handleMapControlsPan(e1, t, i);
            }
            cameraForBoxAndBearing(e1, t, i, a, r) {
                return this.currentHelper.cameraForBoxAndBearing(e1, t, i, a, r);
            }
            handleJumpToCenterZoom(e1, t) {
                this.currentHelper.handleJumpToCenterZoom(e1, t);
            }
            handleEaseTo(e1, t) {
                return this.currentHelper.handleEaseTo(e1, t);
            }
            handleFlyTo(e1, t) {
                return this.currentHelper.handleFlyTo(e1, t);
            }
        }
        const Ii = (e1, i)=>t.B(e1, i && i.filter((e1)=>"source.canvas" !== e1.identifier)), Ei = t.bN();
        class Si extends t.E {
            constructor(e1, i = {}){
                var a, r;
                super(), this._rtlPluginLoaded = ()=>{
                    for(const e1 in this.tileManagers){
                        const t = this.tileManagers[e1].getSource().type;
                        "vector" !== t && "geojson" !== t || this.tileManagers[e1].reload();
                    }
                }, this.map = e1, this.dispatcher = new N(j(), e1._getMapId()), this.dispatcher.registerMessageHandler("GG", (e1, t)=>this.getGlyphs(e1, t)), this.dispatcher.registerMessageHandler("GI", (e1, t)=>this.getImages(e1, t)), this.dispatcher.registerMessageHandler("GDA", (e1, t)=>this.getDashes(e1, t)), this.imageManager = new w, this.imageManager.setEventedParent(this);
                const o = (null === (a = e1._container) || void 0 === a ? void 0 : a.lang) || "undefined" != typeof document && (null === (r = document.documentElement) || void 0 === r ? void 0 : r.lang) || void 0;
                this.glyphManager = new I(e1._requestManager, i.localIdeographFontFamily, o), this.lineAtlas = new A(256, 512), this.crossTileSymbolIndex = new Ct, this._setInitialValues(), this._resetUpdates(), this.dispatcher.broadcast("SR", t.bO()), ce().on(se, this._rtlPluginLoaded), this.on("data", (e1)=>{
                    if ("source" !== e1.dataType || "metadata" !== e1.sourceDataType) return;
                    const t = this.tileManagers[e1.sourceId];
                    if (!t) return;
                    const i = t.getSource();
                    if (i && i.vectorLayerIds) for(const e1 in this._layers){
                        const t = this._layers[e1];
                        t.source === i.id && this._validateLayer(t);
                    }
                });
            }
            _setInitialValues() {
                var e1;
                this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.tileManagers = {}, this.zoomHistory = new t.bP, this._availableImages = [], this._globalState = {}, this._serializedLayers = {}, this.stylesheet = null, this.light = null, this.sky = null, this.projection && (this.projection.destroy(), delete this.projection), this._loaded = !1, this._changed = !1, this._updatedLayers = {}, this._updatedSources = {}, this._changedImages = {}, this._glyphsDidChange = !1, this._updatedPaintProps = {}, this._layerOrderChanged = !1, this.crossTileSymbolIndex = new ((null === (e1 = this.crossTileSymbolIndex) || void 0 === e1 ? void 0 : e1.constructor) || Object), this.pauseablePlacement = void 0, this.placement = void 0, this.z = 0;
            }
            setGlobalStateProperty(e1, i) {
                var a, r, o;
                this._checkLoaded();
                const s = null === i ? null !== (o = null === (r = null === (a = this.stylesheet.state) || void 0 === a ? void 0 : a[e1]) || void 0 === r ? void 0 : r.default) && void 0 !== o ? o : null : i;
                if (t.bQ(s, this._globalState[e1])) return this;
                this._globalState[e1] = s, this._applyGlobalStateChanges([
                    e1
                ]);
            }
            getGlobalState() {
                return this._globalState;
            }
            setGlobalState(e1) {
                this._checkLoaded();
                const i = [];
                for(const a in e1)!t.bQ(this._globalState[a], e1[a].default) && (i.push(a), this._globalState[a] = e1[a].default);
                this._applyGlobalStateChanges(i);
            }
            _applyGlobalStateChanges(e1) {
                if (0 === e1.length) return;
                const t = new Set, i = {};
                for (const a of e1){
                    i[a] = this._globalState[a];
                    for(const e1 in this._layers){
                        const i = this._layers[e1], r = i.getLayoutAffectingGlobalStateRefs(), o = i.getPaintAffectingGlobalStateRefs();
                        if (r.has(a) && t.add(i.source), o.has(a)) for (const { name: e1, value: t } of o.get(a))this._updatePaintProperty(i, e1, t);
                    }
                }
                this.dispatcher.broadcast("UGS", i);
                for(const e1 in this.tileManagers)t.has(e1) && (this._reloadSource(e1), this._changed = !0);
            }
            loadURL(e1, i = {}, a) {
                this.fire(new t.l("dataloading", {
                    dataType: "style"
                })), i.validate = "boolean" != typeof i.validate || i.validate;
                const r = this.map._requestManager.transformRequest(e1, "Style");
                this._loadStyleRequest = new AbortController;
                const o = this._loadStyleRequest;
                t.j(r, this._loadStyleRequest).then((e1)=>{
                    this._loadStyleRequest = null, this._load(e1.data, i, a);
                }).catch((e1)=>{
                    this._loadStyleRequest = null, e1 && !o.signal.aborted && this.fire(new t.k(e1));
                });
            }
            loadJSON(e1, i = {}, a) {
                this.fire(new t.l("dataloading", {
                    dataType: "style"
                })), this._frameRequest = new AbortController, n.frameAsync(this._frameRequest).then(()=>{
                    this._frameRequest = null, i.validate = !1 !== i.validate, this._load(e1, i, a);
                }).catch(()=>{});
            }
            loadEmpty() {
                this.fire(new t.l("dataloading", {
                    dataType: "style"
                })), this._load(Ei, {
                    validate: !1
                });
            }
            _load(e1, i, a) {
                var r, o;
                let s = i.transformStyle ? i.transformStyle(a, e1) : e1;
                if (!i.validate || !Ii(this, t.C(s))) {
                    s = Object.assign({}, s), this._loaded = !0, this.stylesheet = s;
                    for(const e1 in s.sources)this.addSource(e1, s.sources[e1], {
                        validate: !1
                    });
                    s.sprite ? this._loadSprite(s.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(s.glyphs), this._createLayers(), this.light = new R(this.stylesheet.light), this._setProjectionInternal((null === (r = this.stylesheet.projection) || void 0 === r ? void 0 : r.type) || "mercator"), this.sky = new z(this.stylesheet.sky), this.map.setTerrain(null !== (o = this.stylesheet.terrain) && void 0 !== o ? o : null), this.fire(new t.l("data", {
                        dataType: "style"
                    })), this.fire(new t.l("style.load"));
                }
            }
            _createLayers() {
                var e1, i, a;
                const r = t.bR(this.stylesheet.layers);
                this.setGlobalState(null !== (e1 = this.stylesheet.state) && void 0 !== e1 ? e1 : null), this.dispatcher.broadcast("SL", r), this._order = r.map((e1)=>e1.id), this._layers = {}, this._serializedLayers = null;
                for (const e1 of r){
                    const r = t.bS(e1, this._globalState);
                    if (r.setEventedParent(this, {
                        layer: {
                            id: e1.id
                        }
                    }), this._layers[e1.id] = r, t.bT(r) && this.tileManagers[r.source]) {
                        const t = null !== (a = null === (i = e1.paint) || void 0 === i ? void 0 : i["raster-fade-duration"]) && void 0 !== a ? a : r.paint.get("raster-fade-duration");
                        this.tileManagers[r.source].setRasterFadeDuration(t);
                    }
                }
            }
            _loadSprite(e1, i = !1, a) {
                let r;
                this.imageManager.setLoaded(!1), this._spriteRequest = new AbortController, (function(e1, i, a, r) {
                    return t._(this, void 0, void 0, function*() {
                        const o = x(e1), s = a > 1 ? "@2x" : "", l = {}, c = {};
                        for (const { id: e1, url: a } of o){
                            const o = i.transformRequest(b(a, s, ".json"), "SpriteJSON");
                            l[e1] = t.j(o, r);
                            const n = i.transformRequest(b(a, s, ".png"), "SpriteImage");
                            c[e1] = g.getImage(n, r);
                        }
                        return yield Promise.all([
                            ...Object.values(l),
                            ...Object.values(c)
                        ]), function(e1, i) {
                            return t._(this, void 0, void 0, function*() {
                                const t = {};
                                for(const a in e1){
                                    t[a] = {};
                                    const r = n.getImageCanvasContext((yield i[a]).data), o = (yield e1[a]).data;
                                    for(const e1 in o){
                                        const { width: i, height: s, x: n, y: l, sdf: c, pixelRatio: h, stretchX: u, stretchY: d, content: _, textFitWidth: p, textFitHeight: m } = o[e1];
                                        t[a][e1] = {
                                            data: null,
                                            pixelRatio: h,
                                            sdf: c,
                                            stretchX: u,
                                            stretchY: d,
                                            content: _,
                                            textFitWidth: p,
                                            textFitHeight: m,
                                            spriteData: {
                                                width: i,
                                                height: s,
                                                x: n,
                                                y: l,
                                                context: r
                                            }
                                        };
                                    }
                                }
                                return t;
                            });
                        }(l, c);
                    });
                })(e1, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then((e1)=>{
                    if (this._spriteRequest = null, e1) for(const t in e1){
                        this._spritesImagesIds[t] = [];
                        const a = this._spritesImagesIds[t] ? this._spritesImagesIds[t].filter((t)=>!(t in e1)) : [];
                        for (const e1 of a)this.imageManager.removeImage(e1), this._changedImages[e1] = !0;
                        for(const a in e1[t]){
                            const r = "default" === t ? a : `${t}:${a}`;
                            this._spritesImagesIds[t].push(r), r in this.imageManager.images ? this.imageManager.updateImage(r, e1[t][a], !1) : this.imageManager.addImage(r, e1[t][a]), i && (this._changedImages[r] = !0);
                        }
                    }
                }).catch((e1)=>{
                    this._spriteRequest = null, r = e1, this.fire(new t.k(r));
                }).finally(()=>{
                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), i && (this._changed = !0), this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", {
                        dataType: "style"
                    })), a && a(r);
                });
            }
            _unloadSprite() {
                for (const e1 of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(e1), this._changedImages[e1] = !0;
                this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", {
                    dataType: "style"
                }));
            }
            _validateLayer(e1) {
                const i = this.tileManagers[e1.source];
                if (!i) return;
                const a = e1.sourceLayer;
                if (!a) return;
                const r = i.getSource();
                ("geojson" === r.type || r.vectorLayerIds && -1 === r.vectorLayerIds.indexOf(a)) && this.fire(new t.k(new Error(`Source layer "${a}" does not exist on source "${r.id}" as specified by style layer "${e1.id}".`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(const e1 in this.tileManagers)if (!this.tileManagers[e1].loaded()) return !1;
                return !!this.imageManager.isLoaded();
            }
            _serializeByIds(e1, i = !1) {
                const a = this._serializedAllLayers();
                if (!e1 || 0 === e1.length) return Object.values(i ? t.bU(a) : a);
                const r = [];
                for (const o of e1)if (a[o]) {
                    const e1 = i ? t.bU(a[o]) : a[o];
                    r.push(e1);
                }
                return r;
            }
            _serializedAllLayers() {
                let e1 = this._serializedLayers;
                if (e1) return e1;
                e1 = this._serializedLayers = {};
                const t = Object.keys(this._layers);
                for (const i of t){
                    const t = this._layers[i];
                    "custom" !== t.type && (e1[i] = t.serialize());
                }
                return e1;
            }
            hasTransitions() {
                var e1, t, i;
                if (null === (e1 = this.light) || void 0 === e1 ? void 0 : e1.hasTransition()) return !0;
                if (null === (t = this.sky) || void 0 === t ? void 0 : t.hasTransition()) return !0;
                if (null === (i = this.projection) || void 0 === i ? void 0 : i.hasTransition()) return !0;
                for(const e1 in this.tileManagers)if (this.tileManagers[e1].hasTransition()) return !0;
                for(const e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                return !1;
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading.");
            }
            update(e1) {
                if (!this._loaded) return;
                const i = this._changed;
                if (i) {
                    const t = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                    (t.length || i.length) && this._updateWorkerLayers(t, i);
                    for(const e1 in this._updatedSources){
                        const t = this._updatedSources[e1];
                        if ("reload" === t) this._reloadSource(e1);
                        else {
                            if ("clear" !== t) throw new Error(`Invalid action ${t}`);
                            this._clearSource(e1);
                        }
                    }
                    this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                    for(const t in this._updatedPaintProps)this._layers[t].updateTransitions(e1);
                    this.light.updateTransitions(e1), this.sky.updateTransitions(e1), this._resetUpdates();
                }
                const a = {};
                for(const e1 in this.tileManagers){
                    const t = this.tileManagers[e1];
                    a[e1] = t.used, t.used = !1;
                }
                for (const t of this._order){
                    const i = this._layers[t];
                    i.recalculate(e1, this._availableImages), !i.isHidden(e1.zoom) && i.source && (this.tileManagers[i.source].used = !0);
                }
                for(const e1 in a){
                    const i = this.tileManagers[e1];
                    !!a[e1] != !!i.used && i.fire(new t.l("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: e1
                    }));
                }
                this.light.recalculate(e1), this.sky.recalculate(e1), this.projection.recalculate(e1), this.z = e1.zoom, i && this.fire(new t.l("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const e1 = Object.keys(this._changedImages);
                if (e1.length) {
                    for(const t in this.tileManagers)this.tileManagers[t].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e1);
                    this._changedImages = {};
                }
            }
            _updateTilesForChangedGlyphs() {
                if (this._glyphsDidChange) {
                    for(const e1 in this.tileManagers)this.tileManagers[e1].reloadTilesForDependencies([
                        "glyphs"
                    ], [
                        ""
                    ]);
                    this._glyphsDidChange = !1;
                }
            }
            _updateWorkerLayers(e1, t) {
                this.dispatcher.broadcast("UL", {
                    layers: this._serializeByIds(e1, !1),
                    removedIds: t
                });
            }
            _resetUpdates() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
            }
            setState(e1, i = {}) {
                var a;
                this._checkLoaded();
                const r = this.serialize();
                if (e1 = i.transformStyle ? i.transformStyle(r, e1) : e1, (null === (a = i.validate) || void 0 === a || a) && Ii(this, t.C(e1))) return !1;
                (e1 = t.bU(e1)).layers = t.bR(e1.layers);
                const o = t.bV(r, e1), s = this._getOperationsToPerform(o);
                if (s.unimplemented.length > 0) throw new Error(`Unimplemented: ${s.unimplemented.join(", ")}.`);
                if (0 === s.operations.length) return !1;
                for (const e1 of s.operations)e1();
                return this.stylesheet = e1, this._serializedLayers = null, !0;
            }
            _getOperationsToPerform(e1) {
                const t = [], i = [];
                for (const a of e1)switch(a.command){
                    case "setCenter":
                    case "setZoom":
                    case "setBearing":
                    case "setPitch":
                    case "setRoll":
                        continue;
                    case "addLayer":
                        t.push(()=>this.addLayer.apply(this, a.args));
                        break;
                    case "removeLayer":
                        t.push(()=>this.removeLayer.apply(this, a.args));
                        break;
                    case "setPaintProperty":
                        t.push(()=>this.setPaintProperty.apply(this, a.args));
                        break;
                    case "setLayoutProperty":
                        t.push(()=>this.setLayoutProperty.apply(this, a.args));
                        break;
                    case "setFilter":
                        t.push(()=>this.setFilter.apply(this, a.args));
                        break;
                    case "addSource":
                        t.push(()=>this.addSource.apply(this, a.args));
                        break;
                    case "removeSource":
                        t.push(()=>this.removeSource.apply(this, a.args));
                        break;
                    case "setLayerZoomRange":
                        t.push(()=>this.setLayerZoomRange.apply(this, a.args));
                        break;
                    case "setLight":
                        t.push(()=>this.setLight.apply(this, a.args));
                        break;
                    case "setGeoJSONSourceData":
                        t.push(()=>this.setGeoJSONSourceData.apply(this, a.args));
                        break;
                    case "setGlyphs":
                        t.push(()=>this.setGlyphs.apply(this, a.args));
                        break;
                    case "setSprite":
                        t.push(()=>this.setSprite.apply(this, a.args));
                        break;
                    case "setTerrain":
                        t.push(()=>this.map.setTerrain.apply(this, a.args));
                        break;
                    case "setSky":
                        t.push(()=>this.setSky.apply(this, a.args));
                        break;
                    case "setProjection":
                        this.setProjection.apply(this, a.args);
                        break;
                    case "setGlobalState":
                        t.push(()=>this.setGlobalState.apply(this, a.args));
                        break;
                    case "setTransition":
                        t.push(()=>{});
                        break;
                    default:
                        i.push(a.command);
                }
                return {
                    operations: t,
                    unimplemented: i
                };
            }
            addImage(e1, i) {
                if (this.getImage(e1)) return this.fire(new t.k(new Error(`An image named "${e1}" already exists.`)));
                this.imageManager.addImage(e1, i), this._afterImageUpdated(e1);
            }
            updateImage(e1, t) {
                this.imageManager.updateImage(e1, t);
            }
            getImage(e1) {
                return this.imageManager.getImage(e1);
            }
            removeImage(e1) {
                if (!this.getImage(e1)) return this.fire(new t.k(new Error(`An image named "${e1}" does not exist.`)));
                this.imageManager.removeImage(e1), this._afterImageUpdated(e1);
            }
            _afterImageUpdated(e1) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[e1] = !0, this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this.imageManager.listImages();
            }
            addSource(e1, i, a = {}) {
                if (this._checkLoaded(), void 0 !== this.tileManagers[e1]) throw new Error(`Source "${e1}" already exists.`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(t.C.source, `sources.${e1}`, i, null, a)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const r = this.tileManagers[e1] = new Ie(e1, i, this.dispatcher);
                r.style = this, r.setEventedParent(this, ()=>({
                        isSourceLoaded: r.loaded(),
                        source: r.serialize(),
                        sourceId: e1
                    })), r.onAdd(this.map), this._changed = !0;
            }
            removeSource(e1) {
                if (this._checkLoaded(), void 0 === this.tileManagers[e1]) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === e1) return this.fire(new t.k(new Error(`Source "${e1}" cannot be removed while layer "${i}" is using it.`)));
                const i = this.tileManagers[e1];
                delete this.tileManagers[e1], delete this._updatedSources[e1], i.fire(new t.l("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: e1
                })), i.setEventedParent(null), i.onRemove(this.map), this._changed = !0;
            }
            setGeoJSONSourceData(e1, t) {
                if (this._checkLoaded(), void 0 === this.tileManagers[e1]) throw new Error(`There is no source with this ID=${e1}`);
                const i = this.tileManagers[e1].getSource();
                if ("geojson" !== i.type) throw new Error(`geojsonSource.type is ${i.type}, which is !== 'geojson`);
                i.setData(t), this._changed = !0;
            }
            getSource(e1) {
                return this.tileManagers[e1] && this.tileManagers[e1].getSource();
            }
            addLayer(e1, i, a = {}) {
                this._checkLoaded();
                const r = e1.id;
                if (this.getLayer(r)) return void this.fire(new t.k(new Error(`Layer "${r}" already exists on this map.`)));
                let o;
                if ("custom" === e1.type) {
                    if (Ii(this, t.bW(e1))) return;
                    o = t.bS(e1, this._globalState);
                } else {
                    if ("source" in e1 && "object" == typeof e1.source && (this.addSource(r, e1.source), e1 = t.bU(e1), e1 = t.e(e1, {
                        source: r
                    })), this._validate(t.C.layer, `layers.${r}`, e1, {
                        arrayIndex: -1
                    }, a)) return;
                    o = t.bS(e1, this._globalState), this._validateLayer(o), o.setEventedParent(this, {
                        layer: {
                            id: r
                        }
                    });
                }
                const s = i ? this._order.indexOf(i) : this._order.length;
                if (i && -1 === s) this.fire(new t.k(new Error(`Cannot add layer "${r}" before non-existing layer "${i}".`)));
                else {
                    if (this._order.splice(s, 0, r), this._layerOrderChanged = !0, this._layers[r] = o, this._removedLayers[r] && o.source && "custom" !== o.type) {
                        const e1 = this._removedLayers[r];
                        delete this._removedLayers[r], e1.type !== o.type ? this._updatedSources[o.source] = "clear" : (this._updatedSources[o.source] = "reload", this.tileManagers[o.source].pause());
                    }
                    this._updateLayer(o), o.onAdd && o.onAdd(this.map);
                }
            }
            moveLayer(e1, i) {
                if (this._checkLoaded(), this._changed = !0, !this._layers[e1]) return void this.fire(new t.k(new Error(`The layer '${e1}' does not exist in the map's style and cannot be moved.`)));
                if (e1 === i) return;
                const a = this._order.indexOf(e1);
                this._order.splice(a, 1);
                const r = i ? this._order.indexOf(i) : this._order.length;
                i && -1 === r ? this.fire(new t.k(new Error(`Cannot move layer "${e1}" before non-existing layer "${i}".`))) : (this._order.splice(r, 0, e1), this._layerOrderChanged = !0);
            }
            removeLayer(e1) {
                this._checkLoaded();
                const i = this._layers[e1];
                if (!i) return void this.fire(new t.k(new Error(`Cannot remove non-existing layer "${e1}".`)));
                i.setEventedParent(null);
                const a = this._order.indexOf(e1);
                this._order.splice(a, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = i, delete this._layers[e1], this._serializedLayers && delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], i.onRemove && i.onRemove(this.map);
            }
            getLayer(e1) {
                return this._layers[e1];
            }
            getLayersOrder() {
                return [
                    ...this._order
                ];
            }
            hasLayer(e1) {
                return e1 in this._layers;
            }
            setLayerZoomRange(e1, i, a) {
                this._checkLoaded();
                const r = this.getLayer(e1);
                r ? r.minzoom === i && r.maxzoom === a || (null != i && (r.minzoom = i), null != a && (r.maxzoom = a), this._updateLayer(r)) : this.fire(new t.k(new Error(`Cannot set the zoom range of non-existing layer "${e1}".`)));
            }
            setFilter(e1, i, a = {}) {
                this._checkLoaded();
                const r = this.getLayer(e1);
                if (r) {
                    if (!t.bQ(r.filter, i)) return null == i ? (r.setFilter(void 0), void this._updateLayer(r)) : void (this._validate(t.C.filter, `layers.${r.id}.filter`, i, null, a) || (r.setFilter(t.bU(i)), this._updateLayer(r)));
                } else this.fire(new t.k(new Error(`Cannot filter non-existing layer "${e1}".`)));
            }
            getFilter(e1) {
                return t.bU(this.getLayer(e1).filter);
            }
            setLayoutProperty(e1, i, a, r = {}) {
                this._checkLoaded();
                const o = this.getLayer(e1);
                o ? t.bQ(o.getLayoutProperty(i), a) || (o.setLayoutProperty(i, a, r), this._updateLayer(o)) : this.fire(new t.k(new Error(`Cannot style non-existing layer "${e1}".`)));
            }
            getLayoutProperty(e1, i) {
                const a = this.getLayer(e1);
                if (a) return a.getLayoutProperty(i);
                this.fire(new t.k(new Error(`Cannot get style of non-existing layer "${e1}".`)));
            }
            setPaintProperty(e1, i, a, r = {}) {
                this._checkLoaded();
                const o = this.getLayer(e1);
                o ? t.bQ(o.getPaintProperty(i), a) || this._updatePaintProperty(o, i, a, r) : this.fire(new t.k(new Error(`Cannot style non-existing layer "${e1}".`)));
            }
            _updatePaintProperty(e1, i, a, r = {}) {
                e1.setPaintProperty(i, a, r) && this._updateLayer(e1), t.bT(e1) && "raster-fade-duration" === i && this.tileManagers[e1.source].setRasterFadeDuration(a), this._changed = !0, this._updatedPaintProps[e1.id] = !0, this._serializedLayers = null;
            }
            getPaintProperty(e1, t) {
                return this.getLayer(e1).getPaintProperty(t);
            }
            setFeatureState(e1, i) {
                this._checkLoaded();
                const a = e1.source, r = e1.sourceLayer, o = this.tileManagers[a];
                if (void 0 === o) return void this.fire(new t.k(new Error(`The source '${a}' does not exist in the map's style.`)));
                const s = o.getSource().type;
                "geojson" === s && r ? this.fire(new t.k(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== s || r ? (void 0 === e1.id && this.fire(new t.k(new Error("The feature id parameter must be provided."))), o.setFeatureState(r, e1.id, i)) : this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            removeFeatureState(e1, i) {
                this._checkLoaded();
                const a = e1.source, r = this.tileManagers[a];
                if (void 0 === r) return void this.fire(new t.k(new Error(`The source '${a}' does not exist in the map's style.`)));
                const o = r.getSource().type, s = "vector" === o ? e1.sourceLayer : void 0;
                "vector" !== o || s ? i && "string" != typeof e1.id && "number" != typeof e1.id ? this.fire(new t.k(new Error("A feature id is required to remove its specific state property."))) : r.removeFeatureState(s, e1.id, i) : this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            getFeatureState(e1) {
                this._checkLoaded();
                const i = e1.source, a = e1.sourceLayer, r = this.tileManagers[i];
                if (void 0 !== r) return "vector" !== r.getSource().type || a ? (void 0 === e1.id && this.fire(new t.k(new Error("The feature id parameter must be provided."))), r.getFeatureState(a, e1.id)) : void this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
                this.fire(new t.k(new Error(`The source '${i}' does not exist in the map's style.`)));
            }
            getTransition() {
                return t.e({
                    duration: 300,
                    delay: 0
                }, this.stylesheet && this.stylesheet.transition);
            }
            serialize() {
                if (!this._loaded) return;
                const e1 = t.bX(this.tileManagers, (e1)=>e1.serialize()), i = this._serializeByIds(this._order, !0), a = this.map.getTerrain() || void 0, r = this.stylesheet;
                return t.bY({
                    version: r.version,
                    name: r.name,
                    metadata: r.metadata,
                    light: r.light,
                    sky: r.sky,
                    center: r.center,
                    zoom: r.zoom,
                    bearing: r.bearing,
                    pitch: r.pitch,
                    sprite: r.sprite,
                    glyphs: r.glyphs,
                    transition: r.transition,
                    projection: r.projection,
                    sources: e1,
                    layers: i,
                    terrain: a
                }, (e1)=>void 0 !== e1);
            }
            _updateLayer(e1) {
                this._updatedLayers[e1.id] = !0, e1.source && !this._updatedSources[e1.source] && "raster" !== this.tileManagers[e1.source].getSource().type && (this._updatedSources[e1.source] = "reload", this.tileManagers[e1.source].pause()), this._serializedLayers = null, this._changed = !0;
            }
            _flattenAndSortRenderedFeatures(e1) {
                const t = (e1)=>"fill-extrusion" === this._layers[e1].type, i = {}, a = [];
                for(let r = this._order.length - 1; r >= 0; r--){
                    const o = this._order[r];
                    if (t(o)) {
                        i[o] = r;
                        for (const t of e1){
                            const e1 = t[o];
                            if (e1) for (const t of e1)a.push(t);
                        }
                    }
                }
                a.sort((e1, t)=>t.intersectionZ - e1.intersectionZ);
                const r = [];
                for(let o = this._order.length - 1; o >= 0; o--){
                    const s = this._order[o];
                    if (t(s)) for(let e1 = a.length - 1; e1 >= 0; e1--){
                        const t = a[e1].feature;
                        if (i[t.layer.id] < o) break;
                        r.push(t), a.pop();
                    }
                    else for (const t of e1){
                        const e1 = t[s];
                        if (e1) for (const t of e1)r.push(t.feature);
                    }
                }
                return r;
            }
            queryRenderedFeatures(e1, i, a) {
                i && i.filter && this._validate(t.C.filter, "queryRenderedFeatures.filter", i.filter, null, i);
                const r = {};
                if (i && i.layers) {
                    if (!(Array.isArray(i.layers) || i.layers instanceof Set)) return this.fire(new t.k(new Error("parameters.layers must be an Array or a Set of strings"))), [];
                    for (const e1 of i.layers){
                        const i = this._layers[e1];
                        if (!i) return this.fire(new t.k(new Error(`The layer '${e1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        r[i.source] = !0;
                    }
                }
                const o = [];
                i.availableImages = this._availableImages;
                const s = this._serializedAllLayers(), n = i.layers instanceof Set ? i.layers : Array.isArray(i.layers) ? new Set(i.layers) : null, l = Object.assign(Object.assign({}, i), {
                    layers: n,
                    globalState: this._globalState
                });
                for(const t in this.tileManagers)i.layers && !r[t] || o.push(U(this.tileManagers[t], this._layers, s, e1, l, a, this.map.terrain ? (e1, t, i)=>this.map.terrain.getElevation(e1, t, i) : void 0));
                return this.placement && o.push(function(e1, t, i, a, r, o, s) {
                    const n = {}, l = o.queryRenderedSymbols(a), c = [];
                    for (const e1 of Object.keys(l).map(Number))c.push(s[e1]);
                    c.sort(V);
                    for (const i of c){
                        const a = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], t, i.bucketIndex, i.sourceLayerIndex, {
                            filterSpec: r.filter,
                            globalState: r.globalState
                        }, r.layers, r.availableImages, e1);
                        for(const e1 in a){
                            const t = n[e1] = n[e1] || [], r = a[e1];
                            r.sort((e1, t)=>{
                                const a = i.featureSortOrder;
                                if (a) {
                                    const i = a.indexOf(e1.featureIndex);
                                    return a.indexOf(t.featureIndex) - i;
                                }
                                return t.featureIndex - e1.featureIndex;
                            });
                            for (const e1 of r)t.push(e1);
                        }
                    }
                    return function(e1, t, i) {
                        for(const a in e1)for (const r of e1[a])q(r, i[t[a].source]);
                        return e1;
                    }(n, e1, i);
                }(this._layers, s, this.tileManagers, e1, l, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(o);
            }
            querySourceFeatures(e1, i) {
                (null == i ? void 0 : i.filter) && this._validate(t.C.filter, "querySourceFeatures.filter", i.filter, null, i);
                const a = this.tileManagers[e1];
                return a ? function(e1, t) {
                    const i = e1.getRenderableIds().map((t)=>e1.getTileByID(t)), a = [], r = {};
                    for(let e1 = 0; e1 < i.length; e1++){
                        const o = i[e1], s = o.tileID.canonical.key;
                        r[s] || (r[s] = !0, o.querySourceFeatures(a, t));
                    }
                    return a;
                }(a, i ? Object.assign(Object.assign({}, i), {
                    globalState: this._globalState
                }) : {
                    globalState: this._globalState
                }) : [];
            }
            getLight() {
                return this.light.getLight();
            }
            setLight(e1, i = {}) {
                this._checkLoaded();
                const a = this.light.getLight();
                let r = !1;
                for(const i in e1)if (!t.bQ(e1[i], a[i])) {
                    r = !0;
                    break;
                }
                if (!r) return;
                const o = {
                    now: c(),
                    transition: t.e({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.light.setLight(e1, i), this.light.updateTransitions(o);
            }
            getProjection() {
                var e1;
                return null === (e1 = this.stylesheet) || void 0 === e1 ? void 0 : e1.projection;
            }
            setProjection(e1) {
                if (this._checkLoaded(), this.projection) {
                    if (this.projection.name === e1.type) return;
                    this.projection.destroy(), delete this.projection;
                }
                this.stylesheet.projection = e1, this._setProjectionInternal(e1.type);
            }
            getSky() {
                var e1;
                return null === (e1 = this.stylesheet) || void 0 === e1 ? void 0 : e1.sky;
            }
            setSky(e1, i = {}) {
                this._checkLoaded();
                const a = this.getSky();
                let r = !1;
                if (!e1 && !a) return;
                if (e1 && !a) r = !0;
                else if (!e1 && a) r = !0;
                else for(const i in e1)if (!t.bQ(e1[i], a[i])) {
                    r = !0;
                    break;
                }
                if (!r) return;
                const o = {
                    now: c(),
                    transition: t.e({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.stylesheet.sky = e1, this.sky.setSky(e1, i), this.sky.updateTransitions(o);
            }
            _setProjectionInternal(e1) {
                const i = function(e1, i) {
                    const a = {
                        constrainOverride: i
                    };
                    if (Array.isArray(e1)) {
                        const t = new si({
                            type: e1
                        });
                        return {
                            projection: t,
                            transform: new Pi(a),
                            cameraHelper: new Mi(t)
                        };
                    }
                    switch(e1){
                        case "mercator":
                            return {
                                projection: new At,
                                transform: new Zt(a),
                                cameraHelper: new qt
                            };
                        case "globe":
                            {
                                const e1 = new si({
                                    type: [
                                        "interpolate",
                                        [
                                            "linear"
                                        ],
                                        [
                                            "zoom"
                                        ],
                                        11,
                                        "vertical-perspective",
                                        12,
                                        "mercator"
                                    ]
                                });
                                return {
                                    projection: e1,
                                    transform: new Pi(a),
                                    cameraHelper: new Mi(e1)
                                };
                            }
                        case "vertical-perspective":
                            return {
                                projection: new ri,
                                transform: new Ti(a),
                                cameraHelper: new Ci
                            };
                        default:
                            return t.w(`Unknown projection name: ${e1}. Falling back to mercator projection.`), {
                                projection: new At,
                                transform: new Zt(a),
                                cameraHelper: new qt
                            };
                    }
                }(e1, this.map.transformConstrain);
                this.projection = i.projection, this.map.migrateProjection(i.transform, i.cameraHelper);
                for(const e1 in this.tileManagers)this.tileManagers[e1].reload();
            }
            _validate(e1, i, a, r, o = {}) {
                return (!o || !1 !== o.validate) && Ii(this, e1.call(t.C, t.e({
                    key: i,
                    style: this.serialize(),
                    value: a,
                    styleSpec: t.u
                }, r)));
            }
            _remove(e1 = !0) {
                this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null), ce().off(se, this._rtlPluginLoaded);
                for(const e1 in this._layers)this._layers[e1].setEventedParent(null);
                for(const e1 in this.tileManagers){
                    const t = this.tileManagers[e1];
                    t.setEventedParent(null), t.onRemove(this.map);
                }
                this.imageManager.setEventedParent(null), this.setEventedParent(null), e1 && this.dispatcher.broadcast("RM", void 0), this.dispatcher.remove(e1);
            }
            _clearSource(e1) {
                this.tileManagers[e1].clearTiles();
            }
            _reloadSource(e1) {
                this.tileManagers[e1].resume(), this.tileManagers[e1].reload();
            }
            _updateSources(e1) {
                for(const t in this.tileManagers)this.tileManagers[t].update(e1, this.map.terrain);
            }
            _generateCollisionBoxes() {
                for(const e1 in this.tileManagers)this._reloadSource(e1);
            }
            _updatePlacement(e1, t, i, a, r = !1) {
                let o = !1, s = !1;
                const n = {};
                for (const t of this._order){
                    const i = this._layers[t];
                    if ("symbol" !== i.type) continue;
                    if (!n[i.source]) {
                        const e1 = this.tileManagers[i.source];
                        n[i.source] = e1.getRenderableIds(!0).map((t)=>e1.getTileByID(t)).sort((e1, t)=>t.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t.tileID) ? -1 : 1));
                    }
                    const a = this.crossTileSymbolIndex.addLayer(i, n[i.source], e1.center.lng);
                    o = o || a;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((r = r || this._layerOrderChanged || 0 === i) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(c(), e1.zoom)) && (this.pauseablePlacement = new bt(e1, this.map.terrain, this._order, r, t, i, a, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, n), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(c()), s = !0), o && this.pauseablePlacement.placement.setStale()), s || o) for (const e1 of this._order){
                    const t = this._layers[e1];
                    "symbol" === t.type && this.placement.updateLayerOpacities(t, n[t.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(c());
            }
            _releaseSymbolFadeTiles() {
                for(const e1 in this.tileManagers)this.tileManagers[e1].releaseSymbolFadeTiles();
            }
            getImages(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    const e1 = yield this.imageManager.getImages(i.icons);
                    this._updateTilesForChangedImages();
                    const t = this.tileManagers[i.source];
                    return t && t.setDependencies(i.tileID.key, i.type, i.icons), e1;
                });
            }
            getGlyphs(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    const e1 = yield this.glyphManager.getGlyphs(i.stacks), t = this.tileManagers[i.source];
                    return t && t.setDependencies(i.tileID.key, i.type, [
                        ""
                    ]), e1;
                });
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs || null;
            }
            setGlyphs(e1, i = {}) {
                this._checkLoaded(), e1 && this._validate(t.C.glyphs, "glyphs", e1, null, i) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = e1, this.glyphManager.entries = {}, this.glyphManager.setURL(e1));
            }
            getDashes(e1, i) {
                return t._(this, void 0, void 0, function*() {
                    const e1 = {};
                    for (const [t, a] of Object.entries(i.dashes))e1[t] = this.lineAtlas.getDash(a.dasharray, a.round);
                    return e1;
                });
            }
            addSprite(e1, i, a = {}, r) {
                this._checkLoaded();
                const o = [
                    {
                        id: e1,
                        url: i
                    }
                ], s = [
                    ...x(this.stylesheet.sprite),
                    ...o
                ];
                this._validate(t.C.sprite, "sprite", s, null, a) || (this.stylesheet.sprite = s, this._loadSprite(o, !0, r));
            }
            removeSprite(e1) {
                this._checkLoaded();
                const i = x(this.stylesheet.sprite);
                if (i.find((t)=>t.id === e1)) {
                    if (this._spritesImagesIds[e1]) for (const t of this._spritesImagesIds[e1])this.imageManager.removeImage(t), this._changedImages[t] = !0;
                    i.splice(i.findIndex((t)=>t.id === e1), 1), this.stylesheet.sprite = i.length > 0 ? i : void 0, delete this._spritesImagesIds[e1], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", {
                        dataType: "style"
                    }));
                } else this.fire(new t.k(new Error(`Sprite "${e1}" doesn't exists on this map.`)));
            }
            getSprite() {
                return x(this.stylesheet.sprite);
            }
            setSprite(e1, i = {}, a) {
                this._checkLoaded(), e1 && this._validate(t.C.sprite, "sprite", e1, null, i) || (this.stylesheet.sprite = e1, e1 ? this._loadSprite(e1, !0, a) : (this._unloadSprite(), a && a(null)));
            }
            destroy() {
                this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null);
                for(const e1 in this.tileManagers){
                    const t = this.tileManagers[e1];
                    if (t.setEventedParent(null), t._tiles) {
                        for(const e1 in t._tiles)t._tiles[e1].unloadVectorData();
                        t._tiles = {};
                    }
                    t._cache.reset(), t.onRemove(this.map);
                }
                this.tileManagers = {}, this.imageManager && (this.imageManager.setEventedParent(null), this.imageManager.destroy(), this._availableImages = [], this._spritesImagesIds = {}), this.glyphManager && this.glyphManager.destroy();
                for(const e1 in this._layers){
                    const t = this._layers[e1];
                    t.setEventedParent(null), t.onRemove && t.onRemove(this.map);
                }
                this._setInitialValues(), this.setEventedParent(null), this.dispatcher.unregisterMessageHandler("GG"), this.dispatcher.unregisterMessageHandler("GI"), this.dispatcher.unregisterMessageHandler("GDA"), this.dispatcher.remove(!0), this._listeners = {}, this._oneTimeListeners = {};
            }
        }
        var Ri = t.aT([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class Di {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
            }
            bind(e1, t, i, a, r, o, s, n, l) {
                this.context = e1;
                let c = this.boundPaintVertexBuffers.length !== a.length;
                for(let e1 = 0; !c && e1 < a.length; e1++)this.boundPaintVertexBuffers[e1] !== a[e1] && (c = !0);
                !this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== i || c || this.boundIndexBuffer !== r || this.boundVertexOffset !== o || this.boundDynamicVertexBuffer !== s || this.boundDynamicVertexBuffer2 !== n || this.boundDynamicVertexBuffer3 !== l ? this.freshBind(t, i, a, r, o, s, n, l) : (e1.bindVertexArray.set(this.vao), s && s.bind(), r && r.dynamicDraw && r.bind(), n && n.bind(), l && l.bind());
            }
            freshBind(e1, t, i, a, r, o, s, n) {
                const l = e1.numAttributes, c = this.context, h = c.gl;
                this.vao && this.destroy(), this.vao = c.createVertexArray(), c.bindVertexArray.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = a, this.boundVertexOffset = r, this.boundDynamicVertexBuffer = o, this.boundDynamicVertexBuffer2 = s, this.boundDynamicVertexBuffer3 = n, t.enableAttributes(h, e1);
                for (const t of i)t.enableAttributes(h, e1);
                o && o.enableAttributes(h, e1), s && s.enableAttributes(h, e1), n && n.enableAttributes(h, e1), t.bind(), t.setVertexAttribPointers(h, e1, r);
                for (const t of i)t.bind(), t.setVertexAttribPointers(h, e1, r);
                o && (o.bind(), o.setVertexAttribPointers(h, e1, r)), a && a.bind(), s && (s.bind(), s.setVertexAttribPointers(h, e1, r)), n && (n.bind(), n.setVertexAttribPointers(h, e1, r)), c.currentNumAttributes = l;
            }
            destroy() {
                this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        const zi = (e1, i, a, r, o)=>({
                u_texture: 0,
                u_ele_delta: e1,
                u_fog_matrix: i,
                u_fog_color: a ? a.properties.get("fog-color") : t.bo.white,
                u_fog_ground_blend: a ? a.properties.get("fog-ground-blend") : 1,
                u_fog_ground_blend_opacity: o ? 0 : a ? a.calculateFogBlendOpacity(r) : 0,
                u_horizon_color: a ? a.properties.get("horizon-color") : t.bo.white,
                u_horizon_fog_blend: a ? a.properties.get("horizon-fog-blend") : 1,
                u_is_globe_mode: o ? 1 : 0
            }), Ai = {
            mainMatrix: "u_projection_matrix",
            tileMercatorCoords: "u_projection_tile_mercator_coords",
            clippingPlane: "u_projection_clipping_plane",
            projectionTransition: "u_projection_transition",
            fallbackMatrix: "u_projection_fallback_matrix"
        };
        function Li(e1) {
            const t = [];
            for(let i = 0; i < e1.length; i++){
                if (null === e1[i]) continue;
                const a = e1[i].split(" ");
                t.push(a.pop());
            }
            return t;
        }
        class ki {
            constructor(e1, i, a, r, o, s, n, l, c = []){
                const h = e1.gl;
                this.program = h.createProgram();
                const u = Li(i.staticAttributes), d = a ? a.getBinderAttributes() : [], _ = u.concat(d), p = It.prelude.staticUniforms ? Li(It.prelude.staticUniforms) : [], m = n.staticUniforms ? Li(n.staticUniforms) : [], f = i.staticUniforms ? Li(i.staticUniforms) : [], g = a ? a.getBinderUniforms() : [], v = p.concat(m).concat(f).concat(g), x = [];
                for (const e1 of v)x.indexOf(e1) < 0 && x.push(e1);
                const b = a ? a.defines() : [];
                Jt(h) && b.unshift("#version 300 es"), o && b.push("#define OVERDRAW_INSPECTOR;"), s && b.push("#define TERRAIN3D;"), l && b.push(l), c && b.push(...c);
                let y = b.concat(It.prelude.fragmentSource, n.fragmentSource, i.fragmentSource).join("\n"), w = b.concat(It.prelude.vertexSource, n.vertexSource, i.vertexSource).join("\n");
                Jt(h) || (y = function(e1) {
                    return e1.replace(/\bin\s/g, "varying ").replace("out highp vec4 fragColor;", "").replace(/fragColor/g, "gl_FragColor").replace(/texture\(/g, "texture2D(");
                }(y), w = function(e1) {
                    return e1.replace(/\bin\s/g, "attribute ").replace(/\bout\s/g, "varying ").replace(/texture\(/g, "texture2D(");
                }(w));
                const T = h.createShader(h.FRAGMENT_SHADER);
                if (h.isContextLost()) return void (this.failedToCreate = !0);
                if (h.shaderSource(T, y), h.compileShader(T), !h.getShaderParameter(T, h.COMPILE_STATUS)) throw new Error(`Could not compile fragment shader: ${h.getShaderInfoLog(T)}`);
                h.attachShader(this.program, T);
                const P = h.createShader(h.VERTEX_SHADER);
                if (h.isContextLost()) return void (this.failedToCreate = !0);
                if (h.shaderSource(P, w), h.compileShader(P), !h.getShaderParameter(P, h.COMPILE_STATUS)) throw new Error(`Could not compile vertex shader: ${h.getShaderInfoLog(P)}`);
                h.attachShader(this.program, P), this.attributes = {};
                const C = {};
                this.numAttributes = _.length;
                for(let e1 = 0; e1 < this.numAttributes; e1++)_[e1] && (h.bindAttribLocation(this.program, e1, _[e1]), this.attributes[_[e1]] = e1);
                if (h.linkProgram(this.program), !h.getProgramParameter(this.program, h.LINK_STATUS)) throw new Error(`Program failed to link: ${h.getProgramInfoLog(this.program)}`);
                h.deleteShader(P), h.deleteShader(T);
                for(let e1 = 0; e1 < x.length; e1++){
                    const t = x[e1];
                    if (t && !C[t]) {
                        const e1 = h.getUniformLocation(this.program, t);
                        e1 && (C[t] = e1);
                    }
                }
                this.fixedUniforms = r(e1, C), this.terrainUniforms = ((e1, i)=>({
                        u_depth: new t.bZ(e1, i.u_depth),
                        u_terrain: new t.bZ(e1, i.u_terrain),
                        u_terrain_dim: new t.bp(e1, i.u_terrain_dim),
                        u_terrain_matrix: new t.b$(e1, i.u_terrain_matrix),
                        u_terrain_unpack: new t.c0(e1, i.u_terrain_unpack),
                        u_terrain_exaggeration: new t.bp(e1, i.u_terrain_exaggeration)
                    }))(e1, C), this.projectionUniforms = ((e1, i)=>({
                        u_projection_matrix: new t.b$(e1, i.u_projection_matrix),
                        u_projection_tile_mercator_coords: new t.c0(e1, i.u_projection_tile_mercator_coords),
                        u_projection_clipping_plane: new t.c0(e1, i.u_projection_clipping_plane),
                        u_projection_transition: new t.bp(e1, i.u_projection_transition),
                        u_projection_fallback_matrix: new t.b$(e1, i.u_projection_fallback_matrix)
                    }))(e1, C), this.binderUniforms = a ? a.getUniforms(e1, C) : [];
            }
            draw(e1, t, i, a, r, o, s, n, l, c, h, u, d, _, p, m, f, g, v) {
                const x = e1.gl;
                if (this.failedToCreate) return;
                if (e1.program.set(this.program), e1.setDepthMode(i), e1.setStencilMode(a), e1.setColorMode(r), e1.setCullFace(o), n) {
                    e1.activeTexture.set(x.TEXTURE2), x.bindTexture(x.TEXTURE_2D, n.depthTexture), e1.activeTexture.set(x.TEXTURE3), x.bindTexture(x.TEXTURE_2D, n.texture);
                    for(const e1 in this.terrainUniforms)this.terrainUniforms[e1].set(n[e1]);
                }
                if (l) for(const e1 in l)this.projectionUniforms[Ai[e1]].set(l[e1]);
                if (s) for(const e1 in this.fixedUniforms)this.fixedUniforms[e1].set(s[e1]);
                m && m.setUniforms(e1, this.binderUniforms, _, {
                    zoom: p
                });
                let b = 0;
                switch(t){
                    case x.LINES:
                        b = 2;
                        break;
                    case x.TRIANGLES:
                        b = 3;
                        break;
                    case x.LINE_STRIP:
                        b = 1;
                }
                for (const i of d.get()){
                    const a = i.vaos || (i.vaos = {});
                    (a[c] || (a[c] = new Di)).bind(e1, this, h, m ? m.getPaintVertexBuffers() : [], u, i.vertexOffset, f, g, v), x.drawElements(t, i.primitiveLength * b, x.UNSIGNED_SHORT, i.primitiveOffset * b * 2);
                }
            }
        }
        function Fi(e1, i, a) {
            const r = 1 / t.aM(a, 1, i.transform.tileZoom), o = Math.pow(2, a.tileID.overscaledZ), s = a.tileSize * Math.pow(2, i.transform.tileZoom) / o, n = s * (a.tileID.canonical.x + a.tileID.wrap * o), l = s * a.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: a.imageAtlasTexture.size,
                u_scale: [
                    r,
                    e1.fromScale,
                    e1.toScale
                ],
                u_fade: e1.t,
                u_pixel_coord_upper: [
                    n >> 16,
                    l >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & n,
                    65535 & l
                ]
            };
        }
        const Bi = (e1, i, a, r)=>{
            const o = e1.style.light, s = o.properties.get("position"), n = [
                s.x,
                s.y,
                s.z
            ], l = t.c3();
            "viewport" === o.properties.get("anchor") && t.c4(l, e1.transform.bearingInRadians), t.c5(n, n, l);
            const c = e1.transform.transformLightDirection(n), h = o.properties.get("color");
            return {
                u_lightpos: n,
                u_lightpos_globe: c,
                u_lightintensity: o.properties.get("intensity"),
                u_lightcolor: [
                    h.r,
                    h.g,
                    h.b
                ],
                u_vertical_gradient: +i,
                u_opacity: a,
                u_fill_translate: r
            };
        }, Oi = (e1, i, a, r, o, s, n)=>t.e(Bi(e1, i, a, r), Fi(s, e1, n), {
                u_height_factor: -Math.pow(2, o.overscaledZ) / n.tileSize / 8
            }), ji = (e1, i, a, r)=>t.e(Fi(i, e1, a), {
                u_fill_translate: r
            }), Ni = (e1, t)=>({
                u_world: e1,
                u_fill_translate: t
            }), Zi = (e1, i, a, r, o)=>t.e(ji(e1, i, a, o), {
                u_world: r
            }), Gi = (e1, i, a, r, o)=>{
            const s = e1.transform;
            let n, l, c = 0;
            if ("map" === a.paint.get("circle-pitch-alignment")) {
                const e1 = t.aM(i, 1, s.zoom);
                n = !0, l = [
                    e1,
                    e1
                ], c = e1 / (t.a4 * Math.pow(2, i.tileID.overscaledZ)) * 2 * Math.PI * o;
            } else n = !1, l = s.pixelsToGLUnits;
            return {
                u_camera_to_center_distance: s.cameraToCenterDistance,
                u_scale_with_map: +("map" === a.paint.get("circle-pitch-scale")),
                u_pitch_with_map: +n,
                u_device_pixel_ratio: e1.pixelRatio,
                u_extrude_scale: l,
                u_globe_extrude_scale: c,
                u_translate: r
            };
        }, Ui = (e1)=>({
                u_pixel_extrude_scale: [
                    1 / e1.width,
                    1 / e1.height
                ]
            }), Vi = (e1)=>({
                u_viewport_size: [
                    e1.width,
                    e1.height
                ]
            }), qi = (e1, t = 1)=>({
                u_color: e1,
                u_overlay: 0,
                u_overlay_scale: t
            }), Wi = (e1, i, a, r)=>{
            const o = t.aM(e1, 1, i) / (t.a4 * Math.pow(2, e1.tileID.overscaledZ)) * 2 * Math.PI * r;
            return {
                u_extrude_scale: t.aM(e1, 1, i),
                u_intensity: a,
                u_globe_extrude_scale: o
            };
        }, $i = (e1, i, a, r)=>{
            const o = t.N();
            t.c6(o, 0, e1.width, e1.height, 0, 0, 1);
            const s = e1.context.gl;
            return {
                u_matrix: o,
                u_world: [
                    s.drawingBufferWidth,
                    s.drawingBufferHeight
                ],
                u_image: a,
                u_color_ramp: r,
                u_opacity: i.paint.get("heatmap-opacity")
            };
        }, Hi = (e1, t, i)=>{
            const a = i.paint.get("hillshade-accent-color");
            let r;
            switch(i.paint.get("hillshade-method")){
                case "basic":
                    r = 4;
                    break;
                case "combined":
                    r = 1;
                    break;
                case "igor":
                    r = 2;
                    break;
                case "multidirectional":
                    r = 3;
                    break;
                default:
                    r = 0;
            }
            const o = i.getIlluminationProperties();
            for(let t = 0; t < o.directionRadians.length; t++)"viewport" === i.paint.get("hillshade-illumination-anchor") && (o.directionRadians[t] += e1.transform.bearingInRadians);
            return {
                u_image: 0,
                u_latrange: Ki(0, t.tileID),
                u_exaggeration: i.paint.get("hillshade-exaggeration"),
                u_altitudes: o.altitudeRadians,
                u_azimuths: o.directionRadians,
                u_accent: a,
                u_method: r,
                u_highlights: o.highlightColor,
                u_shadows: o.shadowColor
            };
        }, Xi = (e1, i)=>{
            const a = i.stride, r = t.N();
            return t.c6(r, 0, t.a4, -t.a4, 0, 0, 1), t.O(r, r, [
                0,
                -t.a4,
                0
            ]), {
                u_matrix: r,
                u_image: 1,
                u_dimension: [
                    a,
                    a
                ],
                u_zoom: e1.overscaledZ,
                u_unpack: i.getUnpackVector()
            };
        };
        function Ki(e1, i) {
            const a = Math.pow(2, i.canonical.z), r = i.canonical.y;
            return [
                new t.aa(0, r / a).toLngLat().lat,
                new t.aa(0, (r + 1) / a).toLngLat().lat
            ];
        }
        const Yi = (e1, t, i = 0)=>({
                u_image: 0,
                u_unpack: t.getUnpackVector(),
                u_dimension: [
                    t.stride,
                    t.stride
                ],
                u_elevation_stops: 1,
                u_color_stops: 4,
                u_color_ramp_size: i,
                u_opacity: e1.paint.get("color-relief-opacity")
            }), Qi = (e1, i, a, r)=>{
            const o = e1.transform;
            return {
                u_translation: ra(e1, i, a),
                u_ratio: r / t.aM(i, 1, o.zoom),
                u_device_pixel_ratio: e1.pixelRatio,
                u_units_to_pixels: [
                    1 / o.pixelsToGLUnits[0],
                    1 / o.pixelsToGLUnits[1]
                ]
            };
        }, Ji = (e1, i, a, r, o)=>t.e(Qi(e1, i, a, r), {
                u_image: 0,
                u_image_height: o
            }), ea = (e1, i, a, r, o)=>{
            const s = e1.transform, n = aa(i, s);
            return {
                u_translation: ra(e1, i, a),
                u_texsize: i.imageAtlasTexture.size,
                u_ratio: r / t.aM(i, 1, s.zoom),
                u_device_pixel_ratio: e1.pixelRatio,
                u_image: 0,
                u_scale: [
                    n,
                    o.fromScale,
                    o.toScale
                ],
                u_fade: o.t,
                u_units_to_pixels: [
                    1 / s.pixelsToGLUnits[0],
                    1 / s.pixelsToGLUnits[1]
                ]
            };
        }, ta = (e1, i, a, r, o)=>{
            const s = aa(i, e1.transform);
            return t.e(Qi(e1, i, a, r), {
                u_tileratio: s,
                u_crossfade_from: o.fromScale,
                u_crossfade_to: o.toScale,
                u_image: 0,
                u_mix: o.t,
                u_lineatlas_width: e1.lineAtlas.width,
                u_lineatlas_height: e1.lineAtlas.height
            });
        }, ia = (e1, i, a, r, o, s)=>{
            const n = aa(i, e1.transform);
            return t.e(Qi(e1, i, a, r), {
                u_image: 0,
                u_image_height: s,
                u_tileratio: n,
                u_crossfade_from: o.fromScale,
                u_crossfade_to: o.toScale,
                u_image_dash: 1,
                u_mix: o.t,
                u_lineatlas_width: e1.lineAtlas.width,
                u_lineatlas_height: e1.lineAtlas.height
            });
        };
        function aa(e1, i) {
            return 1 / t.aM(e1, 1, i.tileZoom);
        }
        function ra(e1, i, a) {
            return t.aN(e1.transform, i, a.paint.get("line-translate"), a.paint.get("line-translate-anchor"));
        }
        const oa = (e1, t, i, a, r)=>{
            var o, s;
            return {
                u_tl_parent: e1,
                u_scale_parent: t,
                u_buffer_scale: 1,
                u_fade_t: i.mix,
                u_opacity: i.opacity * a.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: a.paint.get("raster-brightness-min"),
                u_brightness_high: a.paint.get("raster-brightness-max"),
                u_saturation_factor: (s = a.paint.get("raster-saturation"), s > 0 ? 1 - 1 / (1.001 - s) : -s),
                u_contrast_factor: (o = a.paint.get("raster-contrast"), o > 0 ? 1 / (1 - o) : 1 + o),
                u_spin_weights: sa(a.paint.get("raster-hue-rotate")),
                u_coords_top: [
                    r[0].x,
                    r[0].y,
                    r[1].x,
                    r[1].y
                ],
                u_coords_bottom: [
                    r[3].x,
                    r[3].y,
                    r[2].x,
                    r[2].y
                ]
            };
        };
        function sa(e1) {
            e1 *= Math.PI / 180;
            const t = Math.sin(e1), i = Math.cos(e1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t - i + 1) / 3,
                (Math.sqrt(3) * t - i + 1) / 3
            ];
        }
        const na = (e1, t, i, a, r, o, s, n, l, c, h, u, d)=>{
            const _ = s.transform;
            return {
                u_is_size_zoom_constant: +("constant" === e1 || "source" === e1),
                u_is_size_feature_constant: +("constant" === e1 || "camera" === e1),
                u_size_t: t ? t.uSizeT : 0,
                u_size: t ? t.uSize : 0,
                u_camera_to_center_distance: _.cameraToCenterDistance,
                u_pitch: _.pitch / 360 * 2 * Math.PI,
                u_rotate_symbol: +i,
                u_aspect_ratio: _.width / _.height,
                u_fade_change: s.options.fadeDuration ? s.symbolFadeChange : 1,
                u_label_plane_matrix: n,
                u_coord_matrix: l,
                u_is_text: +h,
                u_pitch_with_map: +a,
                u_is_along_line: r,
                u_is_variable_anchor: o,
                u_texsize: u,
                u_texture: 0,
                u_translation: c,
                u_pitched_scale: d
            };
        }, la = (e1, i, a, r, o, s, n, l, c, h, u, d, _, p)=>{
            const m = n.transform;
            return t.e(na(e1, i, a, r, o, s, n, l, c, h, u, d, p), {
                u_gamma_scale: r ? Math.cos(m.pitch * Math.PI / 180) * m.cameraToCenterDistance : 1,
                u_device_pixel_ratio: n.pixelRatio,
                u_is_halo: 1
            });
        }, ca = (e1, i, a, r, o, s, n, l, c, h, u, d, _)=>t.e(la(e1, i, a, r, o, s, n, l, c, h, !0, u, 0, _), {
                u_texsize_icon: d,
                u_texture_icon: 1
            }), ha = (e1, t)=>({
                u_opacity: e1,
                u_color: t
            }), ua = (e1, i, a, r, o)=>t.e(function(e1, i, a, r) {
                const o = a.imageManager.getPattern(e1.from.toString()), s = a.imageManager.getPattern(e1.to.toString()), { width: n, height: l } = a.imageManager.getPixelSize(), c = Math.pow(2, r.tileID.overscaledZ), h = r.tileSize * Math.pow(2, a.transform.tileZoom) / c, u = h * (r.tileID.canonical.x + r.tileID.wrap * c), d = h * r.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: o.tl,
                    u_pattern_br_a: o.br,
                    u_pattern_tl_b: s.tl,
                    u_pattern_br_b: s.br,
                    u_texsize: [
                        n,
                        l
                    ],
                    u_mix: i.t,
                    u_pattern_size_a: o.displaySize,
                    u_pattern_size_b: s.displaySize,
                    u_scale_a: i.fromScale,
                    u_scale_b: i.toScale,
                    u_tile_units_to_pixels: 1 / t.aM(r, 1, a.transform.tileZoom),
                    u_pixel_coord_upper: [
                        u >> 16,
                        d >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & u,
                        65535 & d
                    ]
                };
            }(a, o, i, r), {
                u_opacity: e1
            }), da = (e1, t)=>{}, _a = {
            fillExtrusion: (e1, i)=>({
                    u_lightpos: new t.c1(e1, i.u_lightpos),
                    u_lightpos_globe: new t.c1(e1, i.u_lightpos_globe),
                    u_lightintensity: new t.bp(e1, i.u_lightintensity),
                    u_lightcolor: new t.c1(e1, i.u_lightcolor),
                    u_vertical_gradient: new t.bp(e1, i.u_vertical_gradient),
                    u_opacity: new t.bp(e1, i.u_opacity),
                    u_fill_translate: new t.c2(e1, i.u_fill_translate)
                }),
            fillExtrusionPattern: (e1, i)=>({
                    u_lightpos: new t.c1(e1, i.u_lightpos),
                    u_lightpos_globe: new t.c1(e1, i.u_lightpos_globe),
                    u_lightintensity: new t.bp(e1, i.u_lightintensity),
                    u_lightcolor: new t.c1(e1, i.u_lightcolor),
                    u_vertical_gradient: new t.bp(e1, i.u_vertical_gradient),
                    u_height_factor: new t.bp(e1, i.u_height_factor),
                    u_opacity: new t.bp(e1, i.u_opacity),
                    u_fill_translate: new t.c2(e1, i.u_fill_translate),
                    u_image: new t.bZ(e1, i.u_image),
                    u_texsize: new t.c2(e1, i.u_texsize),
                    u_pixel_coord_upper: new t.c2(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c2(e1, i.u_pixel_coord_lower),
                    u_scale: new t.c1(e1, i.u_scale),
                    u_fade: new t.bp(e1, i.u_fade)
                }),
            fill: (e1, i)=>({
                    u_fill_translate: new t.c2(e1, i.u_fill_translate)
                }),
            fillPattern: (e1, i)=>({
                    u_image: new t.bZ(e1, i.u_image),
                    u_texsize: new t.c2(e1, i.u_texsize),
                    u_pixel_coord_upper: new t.c2(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c2(e1, i.u_pixel_coord_lower),
                    u_scale: new t.c1(e1, i.u_scale),
                    u_fade: new t.bp(e1, i.u_fade),
                    u_fill_translate: new t.c2(e1, i.u_fill_translate)
                }),
            fillOutline: (e1, i)=>({
                    u_world: new t.c2(e1, i.u_world),
                    u_fill_translate: new t.c2(e1, i.u_fill_translate)
                }),
            fillOutlinePattern: (e1, i)=>({
                    u_world: new t.c2(e1, i.u_world),
                    u_image: new t.bZ(e1, i.u_image),
                    u_texsize: new t.c2(e1, i.u_texsize),
                    u_pixel_coord_upper: new t.c2(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c2(e1, i.u_pixel_coord_lower),
                    u_scale: new t.c1(e1, i.u_scale),
                    u_fade: new t.bp(e1, i.u_fade),
                    u_fill_translate: new t.c2(e1, i.u_fill_translate)
                }),
            circle: (e1, i)=>({
                    u_camera_to_center_distance: new t.bp(e1, i.u_camera_to_center_distance),
                    u_scale_with_map: new t.bZ(e1, i.u_scale_with_map),
                    u_pitch_with_map: new t.bZ(e1, i.u_pitch_with_map),
                    u_extrude_scale: new t.c2(e1, i.u_extrude_scale),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_globe_extrude_scale: new t.bp(e1, i.u_globe_extrude_scale),
                    u_translate: new t.c2(e1, i.u_translate)
                }),
            collisionBox: (e1, i)=>({
                    u_pixel_extrude_scale: new t.c2(e1, i.u_pixel_extrude_scale)
                }),
            collisionCircle: (e1, i)=>({
                    u_viewport_size: new t.c2(e1, i.u_viewport_size)
                }),
            debug: (e1, i)=>({
                    u_color: new t.b_(e1, i.u_color),
                    u_overlay: new t.bZ(e1, i.u_overlay),
                    u_overlay_scale: new t.bp(e1, i.u_overlay_scale)
                }),
            depth: da,
            clippingMask: da,
            heatmap: (e1, i)=>({
                    u_extrude_scale: new t.bp(e1, i.u_extrude_scale),
                    u_intensity: new t.bp(e1, i.u_intensity),
                    u_globe_extrude_scale: new t.bp(e1, i.u_globe_extrude_scale)
                }),
            heatmapTexture: (e1, i)=>({
                    u_matrix: new t.b$(e1, i.u_matrix),
                    u_world: new t.c2(e1, i.u_world),
                    u_image: new t.bZ(e1, i.u_image),
                    u_color_ramp: new t.bZ(e1, i.u_color_ramp),
                    u_opacity: new t.bp(e1, i.u_opacity)
                }),
            hillshade: (e1, i)=>({
                    u_image: new t.bZ(e1, i.u_image),
                    u_latrange: new t.c2(e1, i.u_latrange),
                    u_exaggeration: new t.bp(e1, i.u_exaggeration),
                    u_altitudes: new t.c8(e1, i.u_altitudes),
                    u_azimuths: new t.c8(e1, i.u_azimuths),
                    u_accent: new t.b_(e1, i.u_accent),
                    u_method: new t.bZ(e1, i.u_method),
                    u_shadows: new t.c7(e1, i.u_shadows),
                    u_highlights: new t.c7(e1, i.u_highlights)
                }),
            hillshadePrepare: (e1, i)=>({
                    u_matrix: new t.b$(e1, i.u_matrix),
                    u_image: new t.bZ(e1, i.u_image),
                    u_dimension: new t.c2(e1, i.u_dimension),
                    u_zoom: new t.bp(e1, i.u_zoom),
                    u_unpack: new t.c0(e1, i.u_unpack)
                }),
            colorRelief: (e1, i)=>({
                    u_image: new t.bZ(e1, i.u_image),
                    u_unpack: new t.c0(e1, i.u_unpack),
                    u_dimension: new t.c2(e1, i.u_dimension),
                    u_elevation_stops: new t.bZ(e1, i.u_elevation_stops),
                    u_color_stops: new t.bZ(e1, i.u_color_stops),
                    u_color_ramp_size: new t.bZ(e1, i.u_color_ramp_size),
                    u_opacity: new t.bp(e1, i.u_opacity)
                }),
            line: (e1, i)=>({
                    u_translation: new t.c2(e1, i.u_translation),
                    u_ratio: new t.bp(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c2(e1, i.u_units_to_pixels)
                }),
            lineGradient: (e1, i)=>({
                    u_translation: new t.c2(e1, i.u_translation),
                    u_ratio: new t.bp(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c2(e1, i.u_units_to_pixels),
                    u_image: new t.bZ(e1, i.u_image),
                    u_image_height: new t.bp(e1, i.u_image_height)
                }),
            linePattern: (e1, i)=>({
                    u_translation: new t.c2(e1, i.u_translation),
                    u_texsize: new t.c2(e1, i.u_texsize),
                    u_ratio: new t.bp(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_image: new t.bZ(e1, i.u_image),
                    u_units_to_pixels: new t.c2(e1, i.u_units_to_pixels),
                    u_scale: new t.c1(e1, i.u_scale),
                    u_fade: new t.bp(e1, i.u_fade)
                }),
            lineSDF: (e1, i)=>({
                    u_translation: new t.c2(e1, i.u_translation),
                    u_ratio: new t.bp(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c2(e1, i.u_units_to_pixels),
                    u_image: new t.bZ(e1, i.u_image),
                    u_mix: new t.bp(e1, i.u_mix),
                    u_tileratio: new t.bp(e1, i.u_tileratio),
                    u_crossfade_from: new t.bp(e1, i.u_crossfade_from),
                    u_crossfade_to: new t.bp(e1, i.u_crossfade_to),
                    u_lineatlas_width: new t.bp(e1, i.u_lineatlas_width),
                    u_lineatlas_height: new t.bp(e1, i.u_lineatlas_height)
                }),
            lineGradientSDF: (e1, i)=>({
                    u_translation: new t.c2(e1, i.u_translation),
                    u_ratio: new t.bp(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c2(e1, i.u_units_to_pixels),
                    u_image: new t.bZ(e1, i.u_image),
                    u_image_height: new t.bp(e1, i.u_image_height),
                    u_tileratio: new t.bp(e1, i.u_tileratio),
                    u_crossfade_from: new t.bp(e1, i.u_crossfade_from),
                    u_crossfade_to: new t.bp(e1, i.u_crossfade_to),
                    u_image_dash: new t.bZ(e1, i.u_image_dash),
                    u_mix: new t.bp(e1, i.u_mix),
                    u_lineatlas_width: new t.bp(e1, i.u_lineatlas_width),
                    u_lineatlas_height: new t.bp(e1, i.u_lineatlas_height)
                }),
            raster: (e1, i)=>({
                    u_tl_parent: new t.c2(e1, i.u_tl_parent),
                    u_scale_parent: new t.bp(e1, i.u_scale_parent),
                    u_buffer_scale: new t.bp(e1, i.u_buffer_scale),
                    u_fade_t: new t.bp(e1, i.u_fade_t),
                    u_opacity: new t.bp(e1, i.u_opacity),
                    u_image0: new t.bZ(e1, i.u_image0),
                    u_image1: new t.bZ(e1, i.u_image1),
                    u_brightness_low: new t.bp(e1, i.u_brightness_low),
                    u_brightness_high: new t.bp(e1, i.u_brightness_high),
                    u_saturation_factor: new t.bp(e1, i.u_saturation_factor),
                    u_contrast_factor: new t.bp(e1, i.u_contrast_factor),
                    u_spin_weights: new t.c1(e1, i.u_spin_weights),
                    u_coords_top: new t.c0(e1, i.u_coords_top),
                    u_coords_bottom: new t.c0(e1, i.u_coords_bottom)
                }),
            symbolIcon: (e1, i)=>({
                    u_is_size_zoom_constant: new t.bZ(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.bZ(e1, i.u_is_size_feature_constant),
                    u_size_t: new t.bp(e1, i.u_size_t),
                    u_size: new t.bp(e1, i.u_size),
                    u_camera_to_center_distance: new t.bp(e1, i.u_camera_to_center_distance),
                    u_pitch: new t.bp(e1, i.u_pitch),
                    u_rotate_symbol: new t.bZ(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t.bp(e1, i.u_aspect_ratio),
                    u_fade_change: new t.bp(e1, i.u_fade_change),
                    u_label_plane_matrix: new t.b$(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t.b$(e1, i.u_coord_matrix),
                    u_is_text: new t.bZ(e1, i.u_is_text),
                    u_pitch_with_map: new t.bZ(e1, i.u_pitch_with_map),
                    u_is_along_line: new t.bZ(e1, i.u_is_along_line),
                    u_is_variable_anchor: new t.bZ(e1, i.u_is_variable_anchor),
                    u_texsize: new t.c2(e1, i.u_texsize),
                    u_texture: new t.bZ(e1, i.u_texture),
                    u_translation: new t.c2(e1, i.u_translation),
                    u_pitched_scale: new t.bp(e1, i.u_pitched_scale)
                }),
            symbolSDF: (e1, i)=>({
                    u_is_size_zoom_constant: new t.bZ(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.bZ(e1, i.u_is_size_feature_constant),
                    u_size_t: new t.bp(e1, i.u_size_t),
                    u_size: new t.bp(e1, i.u_size),
                    u_camera_to_center_distance: new t.bp(e1, i.u_camera_to_center_distance),
                    u_pitch: new t.bp(e1, i.u_pitch),
                    u_rotate_symbol: new t.bZ(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t.bp(e1, i.u_aspect_ratio),
                    u_fade_change: new t.bp(e1, i.u_fade_change),
                    u_label_plane_matrix: new t.b$(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t.b$(e1, i.u_coord_matrix),
                    u_is_text: new t.bZ(e1, i.u_is_text),
                    u_pitch_with_map: new t.bZ(e1, i.u_pitch_with_map),
                    u_is_along_line: new t.bZ(e1, i.u_is_along_line),
                    u_is_variable_anchor: new t.bZ(e1, i.u_is_variable_anchor),
                    u_texsize: new t.c2(e1, i.u_texsize),
                    u_texture: new t.bZ(e1, i.u_texture),
                    u_gamma_scale: new t.bp(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t.bZ(e1, i.u_is_halo),
                    u_translation: new t.c2(e1, i.u_translation),
                    u_pitched_scale: new t.bp(e1, i.u_pitched_scale)
                }),
            symbolTextAndIcon: (e1, i)=>({
                    u_is_size_zoom_constant: new t.bZ(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.bZ(e1, i.u_is_size_feature_constant),
                    u_size_t: new t.bp(e1, i.u_size_t),
                    u_size: new t.bp(e1, i.u_size),
                    u_camera_to_center_distance: new t.bp(e1, i.u_camera_to_center_distance),
                    u_pitch: new t.bp(e1, i.u_pitch),
                    u_rotate_symbol: new t.bZ(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t.bp(e1, i.u_aspect_ratio),
                    u_fade_change: new t.bp(e1, i.u_fade_change),
                    u_label_plane_matrix: new t.b$(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t.b$(e1, i.u_coord_matrix),
                    u_is_text: new t.bZ(e1, i.u_is_text),
                    u_pitch_with_map: new t.bZ(e1, i.u_pitch_with_map),
                    u_is_along_line: new t.bZ(e1, i.u_is_along_line),
                    u_is_variable_anchor: new t.bZ(e1, i.u_is_variable_anchor),
                    u_texsize: new t.c2(e1, i.u_texsize),
                    u_texsize_icon: new t.c2(e1, i.u_texsize_icon),
                    u_texture: new t.bZ(e1, i.u_texture),
                    u_texture_icon: new t.bZ(e1, i.u_texture_icon),
                    u_gamma_scale: new t.bp(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.bp(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t.bZ(e1, i.u_is_halo),
                    u_translation: new t.c2(e1, i.u_translation),
                    u_pitched_scale: new t.bp(e1, i.u_pitched_scale)
                }),
            background: (e1, i)=>({
                    u_opacity: new t.bp(e1, i.u_opacity),
                    u_color: new t.b_(e1, i.u_color)
                }),
            backgroundPattern: (e1, i)=>({
                    u_opacity: new t.bp(e1, i.u_opacity),
                    u_image: new t.bZ(e1, i.u_image),
                    u_pattern_tl_a: new t.c2(e1, i.u_pattern_tl_a),
                    u_pattern_br_a: new t.c2(e1, i.u_pattern_br_a),
                    u_pattern_tl_b: new t.c2(e1, i.u_pattern_tl_b),
                    u_pattern_br_b: new t.c2(e1, i.u_pattern_br_b),
                    u_texsize: new t.c2(e1, i.u_texsize),
                    u_mix: new t.bp(e1, i.u_mix),
                    u_pattern_size_a: new t.c2(e1, i.u_pattern_size_a),
                    u_pattern_size_b: new t.c2(e1, i.u_pattern_size_b),
                    u_scale_a: new t.bp(e1, i.u_scale_a),
                    u_scale_b: new t.bp(e1, i.u_scale_b),
                    u_pixel_coord_upper: new t.c2(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c2(e1, i.u_pixel_coord_lower),
                    u_tile_units_to_pixels: new t.bp(e1, i.u_tile_units_to_pixels)
                }),
            terrain: (e1, i)=>({
                    u_texture: new t.bZ(e1, i.u_texture),
                    u_ele_delta: new t.bp(e1, i.u_ele_delta),
                    u_fog_matrix: new t.b$(e1, i.u_fog_matrix),
                    u_fog_color: new t.b_(e1, i.u_fog_color),
                    u_fog_ground_blend: new t.bp(e1, i.u_fog_ground_blend),
                    u_fog_ground_blend_opacity: new t.bp(e1, i.u_fog_ground_blend_opacity),
                    u_horizon_color: new t.b_(e1, i.u_horizon_color),
                    u_horizon_fog_blend: new t.bp(e1, i.u_horizon_fog_blend),
                    u_is_globe_mode: new t.bp(e1, i.u_is_globe_mode)
                }),
            terrainDepth: (e1, i)=>({
                    u_ele_delta: new t.bp(e1, i.u_ele_delta)
                }),
            terrainCoords: (e1, i)=>({
                    u_texture: new t.bZ(e1, i.u_texture),
                    u_terrain_coords_id: new t.bp(e1, i.u_terrain_coords_id),
                    u_ele_delta: new t.bp(e1, i.u_ele_delta)
                }),
            projectionErrorMeasurement: (e1, i)=>({
                    u_input: new t.bp(e1, i.u_input),
                    u_output_expected: new t.bp(e1, i.u_output_expected)
                }),
            atmosphere: (e1, i)=>({
                    u_sun_pos: new t.c1(e1, i.u_sun_pos),
                    u_atmosphere_blend: new t.bp(e1, i.u_atmosphere_blend),
                    u_globe_position: new t.c1(e1, i.u_globe_position),
                    u_globe_radius: new t.bp(e1, i.u_globe_radius),
                    u_inv_proj_matrix: new t.b$(e1, i.u_inv_proj_matrix)
                }),
            sky: (e1, i)=>({
                    u_sky_color: new t.b_(e1, i.u_sky_color),
                    u_horizon_color: new t.b_(e1, i.u_horizon_color),
                    u_horizon: new t.c2(e1, i.u_horizon),
                    u_horizon_normal: new t.c2(e1, i.u_horizon_normal),
                    u_sky_horizon_blend: new t.bp(e1, i.u_sky_horizon_blend),
                    u_sky_blend: new t.bp(e1, i.u_sky_blend)
                })
        };
        class pa {
            constructor(e1, t, i){
                this.context = e1;
                const a = e1.gl;
                this.buffer = a.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), a.bufferData(a.ELEMENT_ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? a.DYNAMIC_DRAW : a.STATIC_DRAW), this.dynamicDraw || delete t.arrayBuffer;
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e1) {
                const t = this.context.gl;
                if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                this.context.unbindVAO(), this.bind(), t.bufferSubData(t.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const ma = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class fa {
            constructor(e1, t, i, a){
                this.length = t.length, this.attributes = i, this.itemSize = t.bytesPerElement, this.dynamicDraw = a, this.context = e1;
                const r = e1.gl;
                this.buffer = r.createBuffer(), e1.bindVertexBuffer.set(this.buffer), r.bufferData(r.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || delete t.arrayBuffer;
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e1) {
                if (e1.length !== this.length) throw new Error(`Length of new data is ${e1.length}, which doesn't match current length of ${this.length}`);
                const t = this.context.gl;
                this.bind(), t.bufferSubData(t.ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            enableAttributes(e1, t) {
                for(let i = 0; i < this.attributes.length; i++){
                    const a = t.attributes[this.attributes[i].name];
                    void 0 !== a && e1.enableVertexAttribArray(a);
                }
            }
            setVertexAttribPointers(e1, t, i) {
                for(let a = 0; a < this.attributes.length; a++){
                    const r = this.attributes[a], o = t.attributes[r.name];
                    void 0 !== o && e1.vertexAttribPointer(o, r.components, e1[ma[r.type]], !1, this.itemSize, r.offset + this.itemSize * (i || 0));
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        class ga {
            constructor(e1){
                this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(e1) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class va extends ga {
            getDefault() {
                return t.bo.transparent;
            }
            set(e1) {
                const t = this.current;
                (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class xa extends ga {
            getDefault() {
                return 1;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ba extends ga {
            getDefault() {
                return 0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ya extends ga {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class wa extends ga {
            getDefault() {
                return !0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Ta extends ga {
            getDefault() {
                return 255;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Pa extends ga {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e1) {
                const t = this.current;
                (e1.func !== t.func || e1.ref !== t.ref || e1.mask !== t.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
            }
        }
        class Ca extends ga {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.KEEP,
                    e1.KEEP,
                    e1.KEEP
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
            }
        }
        class Ma extends ga {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class Ia extends ga {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class Ea extends ga {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.DEPTH_TEST) : t.disable(t.DEPTH_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class Sa extends ga {
            getDefault() {
                return this.gl.LESS;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Ra extends ga {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.BLEND) : t.disable(t.BLEND), this.current = e1, this.dirty = !1;
            }
        }
        class Da extends ga {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.ONE,
                    e1.ZERO
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.blendFunc(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class za extends ga {
            getDefault() {
                return t.bo.transparent;
            }
            set(e1) {
                const t = this.current;
                (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class Aa extends ga {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.blendEquation(e1), this.current = e1, this.dirty = !1);
            }
        }
        class La extends ga {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.CULL_FACE) : t.disable(t.CULL_FACE), this.current = e1, this.dirty = !1;
            }
        }
        class ka extends ga {
            getDefault() {
                return this.gl.BACK;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Fa extends ga {
            getDefault() {
                return this.gl.CCW;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Ba extends ga {
            getDefault() {
                return null;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Oa extends ga {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ja extends ga {
            getDefault() {
                const e1 = this.gl;
                return [
                    0,
                    0,
                    e1.drawingBufferWidth,
                    e1.drawingBufferHeight
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class Na extends ga {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindFramebuffer(t.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Za extends ga {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindRenderbuffer(t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Ga extends ga {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindTexture(t.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Ua extends ga {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindBuffer(t.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Va extends ga {
            getDefault() {
                return null;
            }
            set(e1) {
                const t = this.gl;
                t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class qa extends ga {
            getDefault() {
                return null;
            }
            set(e1) {
                var t;
                if (e1 === this.current && !this.dirty) return;
                const i = this.gl;
                Jt(i) ? i.bindVertexArray(e1) : null === (t = i.getExtension("OES_vertex_array_object")) || void 0 === t || t.bindVertexArrayOES(e1), this.current = e1, this.dirty = !1;
            }
        }
        class Wa extends ga {
            getDefault() {
                return 4;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
            }
        }
        class $a extends ga {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Ha extends ga {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Xa extends ga {
            constructor(e1, t){
                super(e1), this.context = e1, this.parent = t;
            }
            getDefault() {
                return null;
            }
        }
        class Ka extends Xa {
            setDirty() {
                this.dirty = !0;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class Ya extends Xa {
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Qa extends Xa {
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        const Ja = "Framebuffer is not complete";
        class er {
            constructor(e1, t, i, a, r){
                this.context = e1, this.width = t, this.height = i;
                const o = e1.gl, s = this.framebuffer = o.createFramebuffer();
                if (this.colorAttachment = new Ka(e1, s), a) this.depthAttachment = r ? new Qa(e1, s) : new Ya(e1, s);
                else if (r) throw new Error("Stencil cannot be set without depth");
                if (o.checkFramebufferStatus(o.FRAMEBUFFER) !== o.FRAMEBUFFER_COMPLETE) throw new Error(Ja);
            }
            destroy() {
                const e1 = this.context.gl, t = this.colorAttachment.get();
                if (t && e1.deleteTexture(t), this.depthAttachment) {
                    const t = this.depthAttachment.get();
                    t && e1.deleteRenderbuffer(t);
                }
                e1.deleteFramebuffer(this.framebuffer);
            }
        }
        class tr {
            constructor(e1){
                var t, i;
                if (this.gl = e1, this.clearColor = new va(this), this.clearDepth = new xa(this), this.clearStencil = new ba(this), this.colorMask = new ya(this), this.depthMask = new wa(this), this.stencilMask = new Ta(this), this.stencilFunc = new Pa(this), this.stencilOp = new Ca(this), this.stencilTest = new Ma(this), this.depthRange = new Ia(this), this.depthTest = new Ea(this), this.depthFunc = new Sa(this), this.blend = new Ra(this), this.blendFunc = new Da(this), this.blendColor = new za(this), this.blendEquation = new Aa(this), this.cullFace = new La(this), this.cullFaceSide = new ka(this), this.frontFace = new Fa(this), this.program = new Ba(this), this.activeTexture = new Oa(this), this.viewport = new ja(this), this.bindFramebuffer = new Na(this), this.bindRenderbuffer = new Za(this), this.bindTexture = new Ga(this), this.bindVertexBuffer = new Ua(this), this.bindElementBuffer = new Va(this), this.bindVertexArray = new qa(this), this.pixelStoreUnpack = new Wa(this), this.pixelStoreUnpackPremultiplyAlpha = new $a(this), this.pixelStoreUnpackFlipY = new Ha(this), this.extTextureFilterAnisotropic = e1.getExtension("EXT_texture_filter_anisotropic") || e1.getExtension("MOZ_EXT_texture_filter_anisotropic") || e1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE), Jt(e1)) {
                    this.HALF_FLOAT = e1.HALF_FLOAT;
                    const a = e1.getExtension("EXT_color_buffer_half_float");
                    this.RGBA16F = null !== (t = e1.RGBA16F) && void 0 !== t ? t : null == a ? void 0 : a.RGBA16F_EXT, this.RGB16F = null !== (i = e1.RGB16F) && void 0 !== i ? i : null == a ? void 0 : a.RGB16F_EXT, e1.getExtension("EXT_color_buffer_float");
                } else {
                    e1.getExtension("EXT_color_buffer_half_float"), e1.getExtension("OES_texture_half_float_linear");
                    const t = e1.getExtension("OES_texture_half_float");
                    this.HALF_FLOAT = null == t ? void 0 : t.HALF_FLOAT_OES;
                }
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e1, t) {
                return new pa(this, e1, t);
            }
            createVertexBuffer(e1, t, i) {
                return new fa(this, e1, t, i);
            }
            createRenderbuffer(e1, t, i) {
                const a = this.gl, r = a.createRenderbuffer();
                return this.bindRenderbuffer.set(r), a.renderbufferStorage(a.RENDERBUFFER, e1, t, i), this.bindRenderbuffer.set(null), r;
            }
            createFramebuffer(e1, t, i, a) {
                return new er(this, e1, t, i, a);
            }
            clear({ color: e1, depth: t, stencil: i }) {
                const a = this.gl;
                let r = 0;
                e1 && (r |= a.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t && (r |= a.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t), this.depthMask.set(!0)), void 0 !== i && (r |= a.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), a.clear(r);
            }
            setCullFace(e1) {
                !1 === e1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
            }
            setDepthMode(e1) {
                e1.func !== this.gl.ALWAYS || e1.mask ? (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e1) {
                e1.test.func !== this.gl.ALWAYS || e1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
                    e1.fail,
                    e1.depthFail,
                    e1.pass
                ]), this.stencilFunc.set({
                    func: e1.test.func,
                    ref: e1.ref,
                    mask: e1.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(e1) {
                t.bQ(e1.blendFunction, Wt.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
            }
            createVertexArray() {
                var e1;
                return Jt(this.gl) ? this.gl.createVertexArray() : null === (e1 = this.gl.getExtension("OES_vertex_array_object")) || void 0 === e1 ? void 0 : e1.createVertexArrayOES();
            }
            deleteVertexArray(e1) {
                var t;
                return Jt(this.gl) ? this.gl.deleteVertexArray(e1) : null === (t = this.gl.getExtension("OES_vertex_array_object")) || void 0 === t ? void 0 : t.deleteVertexArrayOES(e1);
            }
            unbindVAO() {
                this.bindVertexArray.set(null);
            }
        }
        let ir;
        function ar(e1, i, a, r, o) {
            const s = e1.context, n = e1.transform, l = s.gl, c = e1.useProgram("collisionBox"), h = [];
            let u = 0, d = 0;
            for(let t = 0; t < r.length; t++){
                const _ = r[t], p = i.getTile(_).getBucket(a);
                if (!p) continue;
                const m = o ? p.textCollisionBox : p.iconCollisionBox, f = p.collisionCircleArray;
                f.length > 0 && (h.push({
                    circleArray: f,
                    circleOffset: d,
                    coord: _
                }), u += f.length / 4, d = u), m && c.draw(s, l.LINES, Xt.disabled, Yt.disabled, e1.colorModeForRenderPass(), Ht.disabled, Ui(e1.transform), e1.style.map.terrain && e1.style.map.terrain.getTerrainData(_), n.getProjectionData({
                    overscaledTileID: _,
                    applyGlobeMatrix: !0,
                    applyTerrainMatrix: !0
                }), a.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, null, e1.transform.zoom, null, null, m.collisionVertexBuffer);
            }
            if (!o || !h.length) return;
            const _ = e1.useProgram("collisionCircle"), p = new t.c9;
            p.resize(4 * u), p._trim();
            let m = 0;
            for (const e1 of h)for(let t = 0; t < e1.circleArray.length / 4; t++){
                const i = 4 * t, a = e1.circleArray[i + 0], r = e1.circleArray[i + 1], o = e1.circleArray[i + 2], s = e1.circleArray[i + 3];
                p.emplace(m++, a, r, o, s, 0), p.emplace(m++, a, r, o, s, 1), p.emplace(m++, a, r, o, s, 2), p.emplace(m++, a, r, o, s, 3);
            }
            (!ir || ir.length < 2 * u) && (ir = function(e1) {
                const i = 2 * e1, a = new t.cb;
                a.resize(i), a._trim();
                for(let e1 = 0; e1 < i; e1++){
                    const t = 6 * e1;
                    a.uint16[t + 0] = 4 * e1 + 0, a.uint16[t + 1] = 4 * e1 + 1, a.uint16[t + 2] = 4 * e1 + 2, a.uint16[t + 3] = 4 * e1 + 2, a.uint16[t + 4] = 4 * e1 + 3, a.uint16[t + 5] = 4 * e1 + 0;
                }
                return a;
            }(u));
            const f = s.createIndexBuffer(ir, !0), g = s.createVertexBuffer(p, t.ca.members, !0);
            for (const i of h){
                const r = Vi(e1.transform);
                _.draw(s, l.TRIANGLES, Xt.disabled, Yt.disabled, e1.colorModeForRenderPass(), Ht.disabled, r, e1.style.map.terrain && e1.style.map.terrain.getTerrainData(i.coord), null, a.id, g, f, t.aW.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
            }
            g.destroy(), f.destroy();
        }
        const rr = t.ar(new Float32Array(16));
        function or(e1, i, a, r, o, s) {
            const { horizontalAlign: n, verticalAlign: l } = t.aR(e1);
            return new t.P((-(n - .5) * i / o + r[0]) * s, (-(l - .5) * a / o + r[1]) * s);
        }
        function sr(e1, i, a, r, o, s) {
            const n = i.tileAnchorPoint.add(new t.P(i.translation[0], i.translation[1]));
            if (i.pitchWithMap) {
                let e1 = r.mult(s);
                a || (e1 = e1.rotate(-o));
                const t = n.add(e1);
                return Fe(t.x, t.y, i.pitchedLabelPlaneMatrix, i.getElevation).point;
            }
            if (a) {
                const t = qe(i.tileAnchorPoint.x + 1, i.tileAnchorPoint.y, i).point.sub(e1), a = Math.atan(t.y / t.x) + (t.x < 0 ? Math.PI : 0);
                return e1.add(r.rotate(a));
            }
            return e1.add(r);
        }
        function nr(e1, i, a, r, o, s, n, l, c, h, u, d) {
            const _ = e1.text.placedSymbolArray, p = e1.text.dynamicLayoutVertexArray, m = e1.icon.dynamicLayoutVertexArray, f = {};
            p.clear();
            for(let m = 0; m < _.length; m++){
                const g = _.get(m), v = g.hidden || !g.crossTileID || e1.allowVerticalPlacement && !g.placedOrientation ? null : r[g.crossTileID];
                if (v) {
                    const r = new t.P(g.anchorX, g.anchorY), _ = {
                        getElevation: d,
                        width: o.width,
                        height: o.height,
                        pitchedLabelPlaneMatrix: s,
                        pitchWithMap: a,
                        transform: o,
                        tileAnchorPoint: r,
                        translation: h,
                        unwrappedTileID: u
                    }, m = a ? $e(r.x, r.y, _) : qe(r.x, r.y, _), x = Be(o.cameraToCenterDistance, m.signedDistanceFromCamera);
                    let b = t.az(e1.textSizeData, l, g) * x / t.aL;
                    a && (b *= e1.tilePixelRatio / n);
                    const { width: y, height: w, anchor: T, textOffset: P, textBoxScale: C } = v, M = or(T, y, w, P, C, b), I = o.getPitchedTextCorrection(r.x + h[0], r.y + h[1], u), E = sr(m.point, _, i, M, -o.bearingInRadians, I), S = e1.allowVerticalPlacement && g.placedOrientation === t.ay.vertical ? Math.PI / 2 : 0;
                    for(let e1 = 0; e1 < g.numGlyphs; e1++)t.aF(p, E, S);
                    c && g.associatedIconIndex >= 0 && (f[g.associatedIconIndex] = {
                        shiftedAnchor: E,
                        angle: S
                    });
                } else Qe(g.numGlyphs, p);
            }
            if (c) {
                m.clear();
                const i = e1.icon.placedSymbolArray;
                for(let e1 = 0; e1 < i.length; e1++){
                    const a = i.get(e1);
                    if (a.hidden) Qe(a.numGlyphs, m);
                    else {
                        const i = f[e1];
                        if (i) for(let e1 = 0; e1 < a.numGlyphs; e1++)t.aF(m, i.shiftedAnchor, i.angle);
                        else Qe(a.numGlyphs, m);
                    }
                }
                e1.icon.dynamicLayoutVertexBuffer.updateData(m);
            }
            e1.text.dynamicLayoutVertexBuffer.updateData(p);
        }
        function lr(e1, t, i) {
            return i.iconsInText && t ? "symbolTextAndIcon" : e1 ? "symbolSDF" : "symbolIcon";
        }
        function cr(e1, i, a, r, o, s, n, l, c, h, u, d, _) {
            const p = e1.context, m = p.gl, f = e1.transform, g = "map" === l, v = "map" === c, x = "viewport" !== l && "point" !== a.layout.get("symbol-placement"), b = g && !v && !x, y = !a.layout.get("symbol-sort-key").isConstant();
            let w = !1;
            const T = e1.getDepthModeForSublayer(0, Xt.ReadOnly), P = a._unevaluatedLayout.hasValue("text-variable-anchor") || a._unevaluatedLayout.hasValue("text-variable-anchor-offset"), C = [], M = f.getCircleRadiusCorrection();
            for (const l of r){
                const r = i.getTile(l), c = r.getBucket(a);
                if (!c) continue;
                const u = o ? c.text : c.icon;
                if (!u || !u.segments.get().length || !u.hasVisibleVertices) continue;
                const d = u.programConfigurations.get(a.id), p = o || c.sdfIcons, T = o ? c.textSizeData : c.iconSizeData, I = v || 0 !== f.pitch, E = e1.useProgram(lr(p, o, c), d), S = t.ax(T, f.zoom), R = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(l);
                let D, z, A, L, k = [
                    0,
                    0
                ], F = null;
                if (o) z = r.glyphAtlasTexture, A = m.LINEAR, D = r.glyphAtlasTexture.size, c.iconsInText && (k = r.imageAtlasTexture.size, F = r.imageAtlasTexture, L = I || e1.options.rotating || e1.options.zooming || "composite" === T.kind || "camera" === T.kind ? m.LINEAR : m.NEAREST);
                else {
                    const t = 1 !== a.layout.get("icon-size").constantOr(0) || c.iconsNeedLinear;
                    z = r.imageAtlasTexture, A = p || e1.options.rotating || e1.options.zooming || t || I ? m.LINEAR : m.NEAREST, D = r.imageAtlasTexture.size;
                }
                const B = t.aM(r, 1, e1.transform.zoom), O = Ae(g, e1.transform, B), j = t.N();
                t.aA(j, O);
                const N = Le(v, g, e1.transform, B), Z = t.aN(f, r, s, n), G = f.getProjectionData({
                    overscaledTileID: l,
                    applyGlobeMatrix: !_,
                    applyTerrainMatrix: !0
                }), U = P && c.hasTextData(), V = "none" !== a.layout.get("icon-text-fit") && U && c.hasIconData();
                if (x) {
                    const t = e1.style.map.terrain ? (t, i)=>e1.style.map.terrain.getElevation(l, t, i) : null, i = "map" === a.layout.get("text-rotation-alignment");
                    je(c, e1, o, O, j, v, h, i, l.toUnwrapped(), f.width, f.height, Z, t);
                }
                const q = o && P || V, W = x || q ? rr : v ? O : e1.transform.clipSpaceToPixelsMatrix, $ = p && 0 !== a.paint.get(o ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let H;
                H = p ? c.iconsInText ? ca(T.kind, S, b, v, x, q, e1, W, N, Z, D, k, M) : la(T.kind, S, b, v, x, q, e1, W, N, Z, o, D, 0, M) : na(T.kind, S, b, v, x, q, e1, W, N, Z, o, D, M);
                const X = {
                    program: E,
                    buffers: u,
                    uniformValues: H,
                    projectionData: G,
                    atlasTexture: z,
                    atlasTextureIcon: F,
                    atlasInterpolation: A,
                    atlasInterpolationIcon: L,
                    isSDF: p,
                    hasHalo: $
                };
                if (y && c.canOverlap) {
                    w = !0;
                    const e1 = u.segments.get();
                    for (const i of e1)C.push({
                        segments: new t.aW([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: X,
                        terrainData: R
                    });
                } else C.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: X,
                    terrainData: R
                });
            }
            w && C.sort((e1, t)=>e1.sortKey - t.sortKey);
            for (const t of C){
                const i = t.state;
                if (p.activeTexture.set(m.TEXTURE0), i.atlasTexture.bind(i.atlasInterpolation, m.CLAMP_TO_EDGE), i.atlasTextureIcon && (p.activeTexture.set(m.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, m.CLAMP_TO_EDGE)), i.isSDF) {
                    const r = i.uniformValues;
                    i.hasHalo && (r.u_is_halo = 1, hr(i.buffers, t.segments, a, e1, i.program, T, u, d, r, i.projectionData, t.terrainData)), r.u_is_halo = 0;
                }
                hr(i.buffers, t.segments, a, e1, i.program, T, u, d, i.uniformValues, i.projectionData, t.terrainData);
            }
        }
        function hr(e1, t, i, a, r, o, s, n, l, c, h) {
            const u = a.context;
            r.draw(u, u.gl.TRIANGLES, o, s, n, Ht.backCCW, l, h, c, i.id, e1.layoutVertexBuffer, e1.indexBuffer, t, i.paint, a.transform.zoom, e1.programConfigurations.get(i.id), e1.dynamicLayoutVertexBuffer, e1.opacityVertexBuffer);
        }
        function ur(e1, i, a, r, o) {
            const s = e1.context, n = s.gl, l = Yt.disabled, c = new Wt([
                n.ONE,
                n.ONE
            ], t.bo.transparent, [
                !0,
                !0,
                !0,
                !0
            ]), h = i.getBucket(a);
            if (!h) return;
            const u = r.key;
            let d = a.heatmapFbos.get(u);
            d || (d = _r(s, i.tileSize, i.tileSize), a.heatmapFbos.set(u, d)), s.bindFramebuffer.set(d.framebuffer), s.viewport.set([
                0,
                0,
                i.tileSize,
                i.tileSize
            ]), s.clear({
                color: t.bo.transparent
            });
            const _ = h.programConfigurations.get(a.id), p = e1.useProgram("heatmap", _, !o), m = e1.transform.getProjectionData({
                overscaledTileID: i.tileID,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            }), f = e1.style.map.terrain.getTerrainData(r);
            p.draw(s, n.TRIANGLES, Xt.disabled, l, c, Ht.disabled, Wi(i, e1.transform.zoom, a.paint.get("heatmap-intensity"), 1), f, m, a.id, h.layoutVertexBuffer, h.indexBuffer, h.segments, a.paint, e1.transform.zoom, _);
        }
        function dr(e1, t, i, a, r) {
            const o = e1.context, s = o.gl, n = e1.transform;
            o.setColorMode(e1.colorModeForRenderPass());
            const l = pr(o, t), c = i.key, h = t.heatmapFbos.get(c);
            if (!h) return;
            o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, h.colorAttachment.get()), o.activeTexture.set(s.TEXTURE1), l.bind(s.LINEAR, s.CLAMP_TO_EDGE);
            const u = n.getProjectionData({
                overscaledTileID: i,
                applyTerrainMatrix: r,
                applyGlobeMatrix: !a
            });
            e1.useProgram("heatmapTexture").draw(o, s.TRIANGLES, Xt.disabled, Yt.disabled, e1.colorModeForRenderPass(), Ht.disabled, $i(e1, t, 0, 1), null, u, t.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments, t.paint, n.zoom), h.destroy(), t.heatmapFbos.delete(c);
        }
        function _r(e1, t, i) {
            var a, r;
            const o = e1.gl, s = o.createTexture();
            o.bindTexture(o.TEXTURE_2D, s), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.LINEAR), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, o.LINEAR);
            const n = null !== (a = e1.HALF_FLOAT) && void 0 !== a ? a : o.UNSIGNED_BYTE, l = null !== (r = e1.RGBA16F) && void 0 !== r ? r : o.RGBA;
            o.texImage2D(o.TEXTURE_2D, 0, l, t, i, 0, o.RGBA, n, null);
            const c = e1.createFramebuffer(t, i, !1, !1);
            return c.colorAttachment.set(s), c;
        }
        function pr(e1, i) {
            return i.colorRampTexture || (i.colorRampTexture = new t.T(e1, i.colorRamp, e1.gl.RGBA)), i.colorRampTexture;
        }
        function mr(e1, i, a, r, o, s, n, l) {
            let c = 256;
            if (o.stepInterpolant) {
                const r = i.getSource().maxzoom, o = n.canonical.z === r ? Math.ceil(1 << e1.transform.maxZoom - n.canonical.z) : 1;
                c = t.an(t.cd(s.maxLineLength / t.a4 * 1024 * o), 256, a.maxTextureSize);
            }
            return l.gradient = t.ce({
                expression: o.gradientExpression(),
                evaluationKey: "lineProgress",
                resolution: c,
                image: l.gradient || void 0,
                clips: s.lineClipsArray
            }), l.texture ? l.texture.update(l.gradient) : l.texture = new t.T(a, l.gradient, r.RGBA), l.version = o.gradientVersion, l.texture;
        }
        function fr(e1, t, i, a, r) {
            e1.activeTexture.set(t.TEXTURE0), i.imageAtlasTexture.bind(t.LINEAR, t.CLAMP_TO_EDGE), a.updatePaintBuffers(r);
        }
        function gr(e1, t, i, a, r, o) {
            (r || e1.lineAtlas.dirty) && (t.activeTexture.set(i.TEXTURE0), e1.lineAtlas.bind(t)), a.updatePaintBuffers(o);
        }
        function vr(e1, t, i, a, r, o, s) {
            const n = o.gradients[r.id];
            let l = n.texture;
            r.gradientVersion !== n.version && (l = mr(e1, t, i, a, r, o, s, n)), i.activeTexture.set(a.TEXTURE0), l.bind(r.stepInterpolant ? a.NEAREST : a.LINEAR, a.CLAMP_TO_EDGE);
        }
        function xr(e1, t, i, a, r, o, s, n, l) {
            const c = o.gradients[r.id];
            let h = c.texture;
            r.gradientVersion !== c.version && (h = mr(e1, t, i, a, r, o, s, c)), i.activeTexture.set(a.TEXTURE0), h.bind(r.stepInterpolant ? a.NEAREST : a.LINEAR, a.CLAMP_TO_EDGE), i.activeTexture.set(a.TEXTURE1), e1.lineAtlas.bind(i), n.updatePaintBuffers(l);
        }
        function br(e1, t, i, a, r) {
            if (!i || !a || !a.imageAtlas) return;
            const o = a.imageAtlas.patternPositions;
            let s = o[i.to.toString()], n = o[i.from.toString()];
            if (!s && n && (s = n), !n && s && (n = s), !s || !n) {
                const e1 = r.getPaintProperty(t);
                s = o[e1], n = o[e1];
            }
            s && n && e1.setConstantPatternPositions(s, n);
        }
        function yr(e1, i, a, r, o, s, n, l) {
            const c = e1.context.gl, h = "fill-pattern", u = a.paint.get(h), d = u && u.constantOr(1), _ = a.getCrossfadeParameters();
            let p, m, f, g, v;
            const x = e1.transform, b = a.paint.get("fill-translate"), y = a.paint.get("fill-translate-anchor");
            n ? (m = d && !a.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", p = c.LINES) : (m = d ? "fillPattern" : "fill", p = c.TRIANGLES);
            const w = u.constantOr(null);
            for (const u of r){
                const r = i.getTile(u);
                if (d && !r.patternsLoaded()) continue;
                const T = r.getBucket(a);
                if (!T) continue;
                const P = T.programConfigurations.get(a.id), C = e1.useProgram(m, P), M = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(u);
                d && (e1.context.activeTexture.set(c.TEXTURE0), r.imageAtlasTexture.bind(c.LINEAR, c.CLAMP_TO_EDGE), P.updatePaintBuffers(_)), br(P, h, w, r, a);
                const I = x.getProjectionData({
                    overscaledTileID: u,
                    applyGlobeMatrix: !l,
                    applyTerrainMatrix: !0
                }), E = t.aN(x, r, b, y);
                if (n) {
                    g = T.indexBuffer2, v = T.segments2;
                    const t = [
                        c.drawingBufferWidth,
                        c.drawingBufferHeight
                    ];
                    f = "fillOutlinePattern" === m && d ? Zi(e1, _, r, t, E) : Ni(t, E);
                } else g = T.indexBuffer, v = T.segments, f = d ? ji(e1, _, r, E) : {
                    u_fill_translate: E
                };
                const S = e1.stencilModeForClipping(u);
                C.draw(e1.context, p, o, S, s, Ht.backCCW, f, M, I, a.id, T.layoutVertexBuffer, g, v, a.paint, e1.transform.zoom, P);
            }
        }
        function wr(e1, i, a, r, o, s, n, l) {
            const c = e1.context, h = c.gl, u = "fill-extrusion-pattern", d = a.paint.get(u), _ = d.constantOr(1), p = a.getCrossfadeParameters(), m = a.paint.get("fill-extrusion-opacity"), f = d.constantOr(null), g = e1.transform;
            for (const d of r){
                const r = i.getTile(d), v = r.getBucket(a);
                if (!v) continue;
                const x = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(d), b = v.programConfigurations.get(a.id), y = e1.useProgram(_ ? "fillExtrusionPattern" : "fillExtrusion", b);
                _ && (e1.context.activeTexture.set(h.TEXTURE0), r.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), b.updatePaintBuffers(p));
                const w = g.getProjectionData({
                    overscaledTileID: d,
                    applyGlobeMatrix: !l,
                    applyTerrainMatrix: !0
                });
                br(b, u, f, r, a);
                const T = t.aN(g, r, a.paint.get("fill-extrusion-translate"), a.paint.get("fill-extrusion-translate-anchor")), P = a.paint.get("fill-extrusion-vertical-gradient"), C = _ ? Oi(e1, P, m, T, d, p, r) : Bi(e1, P, m, T);
                y.draw(c, c.gl.TRIANGLES, o, s, n, Ht.backCCW, C, x, w, a.id, v.layoutVertexBuffer, v.indexBuffer, v.segments, a.paint, e1.transform.zoom, b, e1.style.map.terrain && v.centroidVertexBuffer);
            }
        }
        function Tr(e1, t, i, a, r, o, s, n, l) {
            var c;
            const h = e1.style.projection, u = e1.context, d = e1.transform, _ = u.gl, p = [
                `#define NUM_ILLUMINATION_SOURCES ${i.paint.get("hillshade-highlight-color").values.length}`
            ], m = e1.useProgram("hillshade", null, !1, p), f = !e1.options.moving;
            for (const p of a){
                const a = t.getTile(p), g = a.fbo;
                if (!g) continue;
                const v = h.getMeshFromTileID(u, p.canonical, n, !0, "raster"), x = null === (c = e1.style.map.terrain) || void 0 === c ? void 0 : c.getTerrainData(p);
                u.activeTexture.set(_.TEXTURE0), _.bindTexture(_.TEXTURE_2D, g.colorAttachment.get());
                const b = d.getProjectionData({
                    overscaledTileID: p,
                    aligned: f,
                    applyGlobeMatrix: !l,
                    applyTerrainMatrix: !0
                });
                m.draw(u, _.TRIANGLES, o, r[p.overscaledZ], s, Ht.backCCW, Hi(e1, a, i), x, b, i.id, v.vertexBuffer, v.indexBuffer, v.segments);
            }
        }
        function Pr(e1, i, a, r, o, s, n, l, c) {
            var h;
            const u = e1.style.projection, d = e1.context, _ = e1.transform, p = d.gl, m = e1.useProgram("colorRelief"), f = !e1.options.moving;
            let g = !0, v = 0;
            for (const x of r){
                const r = i.getTile(x), b = r.dem;
                if (g) {
                    const e1 = p.getParameter(p.MAX_TEXTURE_SIZE), { elevationTexture: t, colorTexture: i } = a.getColorRampTextures(d, e1, b.getUnpackVector());
                    d.activeTexture.set(p.TEXTURE1), t.bind(p.NEAREST, p.CLAMP_TO_EDGE), d.activeTexture.set(p.TEXTURE4), i.bind(p.LINEAR, p.CLAMP_TO_EDGE), g = !1, v = t.size[0];
                }
                if (!b || !b.data) continue;
                const y = b.stride, w = b.getPixels();
                if (d.activeTexture.set(p.TEXTURE0), d.pixelStoreUnpackPremultiplyAlpha.set(!1), r.demTexture = r.demTexture || e1.getTileTexture(y), r.demTexture) {
                    const e1 = r.demTexture;
                    e1.update(w, {
                        premultiply: !1
                    }), e1.bind(p.LINEAR, p.CLAMP_TO_EDGE);
                } else r.demTexture = new t.T(d, w, p.RGBA, {
                    premultiply: !1
                }), r.demTexture.bind(p.LINEAR, p.CLAMP_TO_EDGE);
                const T = u.getMeshFromTileID(d, x.canonical, l, !0, "raster"), P = null === (h = e1.style.map.terrain) || void 0 === h ? void 0 : h.getTerrainData(x), C = _.getProjectionData({
                    overscaledTileID: x,
                    aligned: f,
                    applyGlobeMatrix: !c,
                    applyTerrainMatrix: !0
                });
                m.draw(d, p.TRIANGLES, s, o[x.overscaledZ], n, Ht.backCCW, Yi(a, r.dem, v), P, C, a.id, T.vertexBuffer, T.indexBuffer, T.segments);
            }
        }
        const Cr = [
            new t.P(0, 0),
            new t.P(t.a4, 0),
            new t.P(t.a4, t.a4),
            new t.P(0, t.a4)
        ];
        function Mr(e1, t, i, a, r, o, s, n, l = !1, c = !1) {
            const h = a[a.length - 1].overscaledZ, u = e1.context, d = u.gl, _ = e1.useProgram("raster"), p = e1.transform, m = e1.style.projection, f = e1.colorModeForRenderPass(), g = !e1.options.moving, v = i.paint.get("raster-opacity"), x = i.paint.get("raster-resampling"), b = i.paint.get("raster-fade-duration"), y = !!e1.style.map.terrain;
            for (const w of a){
                const a = e1.getDepthModeForSublayer(w.overscaledZ - h, 1 === v ? Xt.ReadWrite : Xt.ReadOnly, d.LESS), T = t.getTile(w), P = "nearest" === x ? d.NEAREST : d.LINEAR;
                u.activeTexture.set(d.TEXTURE0), T.texture.bind(P, d.CLAMP_TO_EDGE, d.LINEAR_MIPMAP_NEAREST), u.activeTexture.set(d.TEXTURE1);
                const { parentTile: C, parentScaleBy: M, parentTopLeft: I, fadeValues: E } = Ir(T, t, b, y);
                T.fadeOpacity = E.tileOpacity, C ? (C.fadeOpacity = E.parentTileOpacity, C.texture.bind(P, d.CLAMP_TO_EDGE, d.LINEAR_MIPMAP_NEAREST)) : T.texture.bind(P, d.CLAMP_TO_EDGE, d.LINEAR_MIPMAP_NEAREST), T.texture.useMipmap && u.extTextureFilterAnisotropic && e1.transform.pitch > 20 && d.texParameterf(d.TEXTURE_2D, u.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, u.extTextureFilterAnisotropicMax);
                const S = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(w), R = p.getProjectionData({
                    overscaledTileID: w,
                    aligned: g,
                    applyGlobeMatrix: !c,
                    applyTerrainMatrix: !0
                }), D = oa(I, M, E.fadeMix, i, n), z = m.getMeshFromTileID(u, w.canonical, o, s, "raster");
                _.draw(u, d.TRIANGLES, a, r ? r[w.overscaledZ] : Yt.disabled, f, l ? Ht.frontCCW : Ht.backCCW, D, S, R, i.id, z.vertexBuffer, z.indexBuffer, z.segments);
            }
        }
        function Ir(e1, i, a, r) {
            const o = {
                parentTile: null,
                parentScaleBy: 1,
                parentTopLeft: [
                    0,
                    0
                ],
                fadeValues: {
                    tileOpacity: 1,
                    parentTileOpacity: 1,
                    fadeMix: {
                        opacity: 1,
                        mix: 0
                    }
                }
            };
            if (0 === a || r) return o;
            if (e1.fadingParentID) {
                const r = i.getLoadedTile(e1.fadingParentID);
                if (!r) return o;
                const s = Math.pow(2, r.tileID.overscaledZ - e1.tileID.overscaledZ), n = [
                    e1.tileID.canonical.x * s % 1,
                    e1.tileID.canonical.y * s % 1
                ], l = function(e1, i, a) {
                    const r = c(), o = (r - i.timeAdded) / a, s = e1.fadingDirection === ue.Incoming, n = t.an((r - e1.timeAdded) / a, 0, 1), l = t.an(1 - o, 0, 1), h = s ? n : l;
                    return {
                        tileOpacity: h,
                        parentTileOpacity: s ? l : n,
                        fadeMix: {
                            opacity: 1,
                            mix: 1 - h
                        }
                    };
                }(e1, r, a);
                return {
                    parentTile: r,
                    parentScaleBy: s,
                    parentTopLeft: n,
                    fadeValues: l
                };
            }
            if (e1.selfFading) {
                const i = function(e1, i) {
                    const a = (c() - e1.timeAdded) / i, r = t.an(a, 0, 1);
                    return {
                        tileOpacity: r,
                        fadeMix: {
                            opacity: r,
                            mix: 0
                        }
                    };
                }(e1, a);
                return {
                    parentTile: null,
                    parentScaleBy: 1,
                    parentTopLeft: [
                        0,
                        0
                    ],
                    fadeValues: i
                };
            }
            return o;
        }
        const Er = new t.bo(1, 0, 0, 1), Sr = new t.bo(0, 1, 0, 1), Rr = new t.bo(0, 0, 1, 1), Dr = new t.bo(1, 0, 1, 1), zr = new t.bo(0, 1, 1, 1);
        function Ar(e1, t, i, a) {
            kr(e1, 0, t + i / 2, e1.transform.width, i, a);
        }
        function Lr(e1, t, i, a) {
            kr(e1, t - i / 2, 0, i, e1.transform.height, a);
        }
        function kr(e1, t, i, a, r, o) {
            const s = e1.context, n = s.gl;
            n.enable(n.SCISSOR_TEST), n.scissor(t * e1.pixelRatio, i * e1.pixelRatio, a * e1.pixelRatio, r * e1.pixelRatio), s.clear({
                color: o
            }), n.disable(n.SCISSOR_TEST);
        }
        function Fr(e1, i, a) {
            const r = e1.context, o = r.gl, s = e1.useProgram("debug"), n = Xt.disabled, l = Yt.disabled, c = e1.colorModeForRenderPass(), h = "$debug", u = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(a);
            r.activeTexture.set(o.TEXTURE0);
            const d = i.getTileByID(a.key).latestRawTileData, _ = Math.floor((d && d.byteLength || 0) / 1024), p = i.getTile(a).tileSize, m = 512 / Math.min(p, 512) * (a.overscaledZ / e1.transform.zoom) * .5;
            let f = a.canonical.toString();
            a.overscaledZ !== a.canonical.z && (f += ` => ${a.overscaledZ}`), function(e1, t) {
                e1.initDebugOverlayCanvas();
                const i = e1.debugOverlayCanvas, a = e1.context.gl, r = e1.debugOverlayCanvas.getContext("2d");
                r.clearRect(0, 0, i.width, i.height), r.shadowColor = "white", r.shadowBlur = 2, r.lineWidth = 1.5, r.strokeStyle = "white", r.textBaseline = "top", r.font = "bold 36px Open Sans, sans-serif", r.fillText(t, 5, 5), r.strokeText(t, 5, 5), e1.debugOverlayTexture.update(i), e1.debugOverlayTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
            }(e1, `${f} ${_}kB`);
            const g = e1.transform.getProjectionData({
                overscaledTileID: a,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            });
            s.draw(r, o.TRIANGLES, n, l, Wt.alphaBlended, Ht.disabled, qi(t.bo.transparent, m), null, g, h, e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments), s.draw(r, o.LINE_STRIP, n, l, c, Ht.disabled, qi(t.bo.red), u, g, h, e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
        }
        function Br(e1, t, i, a) {
            const { isRenderingGlobe: r } = a, o = e1.context, s = o.gl, n = e1.transform, l = e1.colorModeForRenderPass(), c = e1.getDepthModeFor3D(), h = e1.useProgram("terrain");
            o.bindFramebuffer.set(null), o.viewport.set([
                0,
                0,
                e1.width,
                e1.height
            ]);
            for (const a of i){
                const i = t.getTerrainMesh(a.tileID), u = e1.renderToTexture.getTexture(a), d = t.getTerrainData(a.tileID);
                o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, u.texture);
                const _ = t.getMeshFrameDelta(n.zoom), p = n.calculateFogMatrix(a.tileID.toUnwrapped()), m = zi(_, p, e1.style.sky, n.pitch, r), f = n.getProjectionData({
                    overscaledTileID: a.tileID,
                    applyTerrainMatrix: !1,
                    applyGlobeMatrix: !0
                });
                h.draw(o, s.TRIANGLES, c, Yt.disabled, l, Ht.backCCW, m, d, f, "terrain", i.vertexBuffer, i.indexBuffer, i.segments);
            }
        }
        function Or(e1, i) {
            if (!i.mesh) {
                const a = new t.aV;
                a.emplaceBack(-1, -1), a.emplaceBack(1, -1), a.emplaceBack(1, 1), a.emplaceBack(-1, 1);
                const r = new t.aX;
                r.emplaceBack(0, 1, 2), r.emplaceBack(0, 2, 3), i.mesh = new St(e1.createVertexBuffer(a, Rt.members), e1.createIndexBuffer(r), t.aW.simpleSegment(0, 0, a.length, r.length));
            }
            return i.mesh;
        }
        class jr {
            constructor(e1, i){
                this.context = new tr(e1), this.transform = i, this._tileTextures = {}, this.terrainFacilitator = {
                    dirty: !0,
                    matrix: t.ar(new Float64Array(16)),
                    renderTime: 0
                }, this.setup(), this.numSublayers = Ie.maxOverzooming + Ie.maxUnderzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Ct;
            }
            resize(e1, t, i) {
                if (this.width = Math.floor(e1 * i), this.height = Math.floor(t * i), this.pixelRatio = i, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e1 of this.style._order)this.style._layers[e1].resize();
            }
            setup() {
                const e1 = this.context, i = new t.aV;
                i.emplaceBack(0, 0), i.emplaceBack(t.a4, 0), i.emplaceBack(0, t.a4), i.emplaceBack(t.a4, t.a4), this.tileExtentBuffer = e1.createVertexBuffer(i, Rt.members), this.tileExtentSegments = t.aW.simpleSegment(0, 0, 4, 2);
                const a = new t.aV;
                a.emplaceBack(0, 0), a.emplaceBack(t.a4, 0), a.emplaceBack(0, t.a4), a.emplaceBack(t.a4, t.a4), this.debugBuffer = e1.createVertexBuffer(a, Rt.members), this.debugSegments = t.aW.simpleSegment(0, 0, 4, 5);
                const r = new t.cg;
                r.emplaceBack(0, 0, 0, 0), r.emplaceBack(t.a4, 0, t.a4, 0), r.emplaceBack(0, t.a4, 0, t.a4), r.emplaceBack(t.a4, t.a4, t.a4, t.a4), this.rasterBoundsBuffer = e1.createVertexBuffer(r, Ri.members), this.rasterBoundsSegments = t.aW.simpleSegment(0, 0, 4, 2);
                const o = new t.aV;
                o.emplaceBack(0, 0), o.emplaceBack(t.a4, 0), o.emplaceBack(0, t.a4), o.emplaceBack(t.a4, t.a4), this.rasterBoundsBufferPosOnly = e1.createVertexBuffer(o, Rt.members), this.rasterBoundsSegmentsPosOnly = t.aW.simpleSegment(0, 0, 4, 5);
                const s = new t.aV;
                s.emplaceBack(0, 0), s.emplaceBack(1, 0), s.emplaceBack(0, 1), s.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(s, Rt.members), this.viewportSegments = t.aW.simpleSegment(0, 0, 4, 2);
                const n = new t.ch;
                n.emplaceBack(0), n.emplaceBack(1), n.emplaceBack(3), n.emplaceBack(2), n.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(n);
                const l = new t.aX;
                l.emplaceBack(1, 0, 2), l.emplaceBack(1, 2, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(l);
                const c = this.context.gl;
                this.stencilClearMode = new Yt({
                    func: c.ALWAYS,
                    mask: 0
                }, 0, 255, c.ZERO, c.ZERO, c.ZERO), this.tileExtentMesh = new St(this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
            }
            clearStencil() {
                const e1 = this.context, i = e1.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0;
                const a = t.N();
                t.c6(a, 0, this.width, this.height, 0, 0, 1), t.Q(a, a, [
                    i.drawingBufferWidth,
                    i.drawingBufferHeight,
                    0
                ]);
                const r = {
                    mainMatrix: a,
                    tileMercatorCoords: [
                        0,
                        0,
                        1,
                        1
                    ],
                    clippingPlane: [
                        0,
                        0,
                        0,
                        0
                    ],
                    projectionTransition: 0,
                    fallbackMatrix: a
                };
                this.useProgram("clippingMask", null, !0).draw(e1, i.TRIANGLES, Xt.disabled, this.stencilClearMode, Wt.disabled, Ht.disabled, null, null, r, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            _renderTileClippingMasks(e1, t, i) {
                if (this.currentStencilSource === e1.source || !e1.isTileClipped() || !t || !t.length) return;
                this.currentStencilSource = e1.source, this.nextStencilID + t.length > 256 && this.clearStencil();
                const a = this.context;
                a.setColorMode(Wt.disabled), a.setDepthMode(Xt.disabled);
                const r = {};
                for (const e1 of t)r[e1.key] = this.nextStencilID++;
                this._renderTileMasks(r, t, i, !0), this._renderTileMasks(r, t, i, !1), this._tileClippingMaskIDs = r;
            }
            _renderTileMasks(e1, t, i, a) {
                const r = this.context, o = r.gl, s = this.style.projection, n = this.transform, l = this.useProgram("clippingMask");
                for (const c of t){
                    const t = e1[c.key], h = this.style.map.terrain && this.style.map.terrain.getTerrainData(c), u = s.getMeshFromTileID(this.context, c.canonical, a, !0, "stencil"), d = n.getProjectionData({
                        overscaledTileID: c,
                        applyGlobeMatrix: !i,
                        applyTerrainMatrix: !0
                    });
                    l.draw(r, o.TRIANGLES, Xt.disabled, new Yt({
                        func: o.ALWAYS,
                        mask: 0
                    }, t, 255, o.KEEP, o.KEEP, o.REPLACE), Wt.disabled, i ? Ht.disabled : Ht.backCCW, null, h, d, "$clipping", u.vertexBuffer, u.indexBuffer, u.segments);
                }
            }
            _renderTilesDepthBuffer() {
                const e1 = this.context, t = e1.gl, i = this.style.projection, a = this.transform, r = this.useProgram("depth"), o = this.getDepthModeFor3D(), s = Ce(a, {
                    tileSize: a.tileSize
                });
                for (const n of s){
                    const s = this.style.map.terrain && this.style.map.terrain.getTerrainData(n), l = i.getMeshFromTileID(this.context, n.canonical, !0, !0, "raster"), c = a.getProjectionData({
                        overscaledTileID: n,
                        applyGlobeMatrix: !0,
                        applyTerrainMatrix: !0
                    });
                    r.draw(e1, t.TRIANGLES, o, Yt.disabled, Wt.disabled, Ht.backCCW, null, s, c, "$clipping", l.vertexBuffer, l.indexBuffer, l.segments);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const e1 = this.nextStencilID++, t = this.context.gl;
                return new Yt({
                    func: t.NOTEQUAL,
                    mask: 255
                }, e1, 255, t.KEEP, t.KEEP, t.REPLACE);
            }
            stencilModeForClipping(e1) {
                const t = this.context.gl;
                return new Yt({
                    func: t.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[e1.key], 0, t.KEEP, t.KEEP, t.REPLACE);
            }
            getStencilConfigForOverlapAndUpdateStencilID(e1) {
                const t = this.context.gl, i = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), a = i[i.length - 1].overscaledZ, r = i[0].overscaledZ - a + 1;
                if (r > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + r > 256 && this.clearStencil();
                    const e1 = {};
                    for(let i = 0; i < r; i++)e1[i + a] = new Yt({
                        func: t.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, t.KEEP, t.KEEP, t.REPLACE);
                    return this.nextStencilID += r, [
                        e1,
                        i
                    ];
                }
                return [
                    {
                        [a]: Yt.disabled
                    },
                    i
                ];
            }
            stencilConfigForOverlapTwoPass(e1) {
                const t = this.context.gl, i = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), a = i[i.length - 1].overscaledZ, r = i[0].overscaledZ - a + 1;
                if (this.clearStencil(), r > 1) {
                    const e1 = {}, o = {};
                    for(let i = 0; i < r; i++)e1[i + a] = new Yt({
                        func: t.GREATER,
                        mask: 255
                    }, r + 1 + i, 255, t.KEEP, t.KEEP, t.REPLACE), o[i + a] = new Yt({
                        func: t.GREATER,
                        mask: 255
                    }, 1 + i, 255, t.KEEP, t.KEEP, t.REPLACE);
                    return this.nextStencilID = 2 * r + 1, [
                        e1,
                        o,
                        i
                    ];
                }
                return this.nextStencilID = 3, [
                    {
                        [a]: new Yt({
                            func: t.GREATER,
                            mask: 255
                        }, 2, 255, t.KEEP, t.KEEP, t.REPLACE)
                    },
                    {
                        [a]: new Yt({
                            func: t.GREATER,
                            mask: 255
                        }, 1, 255, t.KEEP, t.KEEP, t.REPLACE)
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const e1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new Wt([
                        e1.CONSTANT_COLOR,
                        e1.ONE
                    ], new t.bo(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? Wt.unblended : Wt.alphaBlended;
            }
            getDepthModeForSublayer(e1, t, i) {
                if (!this.opaquePassEnabledForLayer()) return Xt.disabled;
                const a = 1 - ((1 + this.currentLayer) * this.numSublayers + e1) * this.depthEpsilon;
                return new Xt(i || this.context.gl.LEQUAL, t, [
                    a,
                    a
                ]);
            }
            getDepthModeFor3D() {
                return new Xt(this.context.gl.LEQUAL, Xt.ReadWrite, this.depthRangeFor3D);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(e1, i) {
                var a, r;
                this.style = e1, this.options = i, this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange(c()), this.imageManager.beginFrame();
                const o = this.style._order, s = this.style.tileManagers, n = {}, l = {}, h = {}, u = {
                    isRenderingToTexture: !1,
                    isRenderingGlobe: (null === (a = e1.projection) || void 0 === a ? void 0 : a.transitionState) > 0
                };
                for(const e1 in s){
                    const t = s[e1];
                    t.used && t.prepare(this.context), n[e1] = t.getVisibleCoordinates(!1), l[e1] = n[e1].slice().reverse(), h[e1] = t.getVisibleCoordinates(!0).reverse();
                }
                this.opaquePassCutoff = 1 / 0;
                for(let e1 = 0; e1 < o.length; e1++)if (this.style._layers[o[e1]].is3D()) {
                    this.opaquePassCutoff = e1;
                    break;
                }
                this.maybeDrawDepthAndCoords(!1), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0), this.renderPass = "offscreen";
                for (const e1 of o){
                    const t = this.style._layers[e1];
                    if (!t.hasOffscreenPass() || t.isHidden(this.transform.zoom)) continue;
                    const i = l[t.source];
                    ("custom" === t.type || i.length) && this.renderLayer(this, s[t.source], t, i, u);
                }
                if (null === (r = this.style.projection) || void 0 === r || r.updateGPUdependent({
                    context: this.context,
                    useProgram: (e1)=>this.useProgram(e1)
                }), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.bindFramebuffer.set(null), this.context.clear({
                    color: i.showOverdrawInspector ? t.bo.black : t.bo.transparent,
                    depth: 1
                }), this.clearStencil(), this.style.sky && function(e1, t) {
                    const i = e1.context, a = i.gl, r = ((e1, t, i)=>{
                        const a = Math.cos(t.rollInRadians), r = Math.sin(t.rollInRadians), o = ge(t), s = t.getProjectionData({
                            overscaledTileID: null,
                            applyGlobeMatrix: !0,
                            applyTerrainMatrix: !0
                        }).projectionTransition;
                        return {
                            u_sky_color: e1.properties.get("sky-color"),
                            u_horizon_color: e1.properties.get("horizon-color"),
                            u_horizon: [
                                (t.width / 2 - o * r) * i,
                                (t.height / 2 + o * a) * i
                            ],
                            u_horizon_normal: [
                                -r,
                                a
                            ],
                            u_sky_horizon_blend: e1.properties.get("sky-horizon-blend") * t.height / 2 * i,
                            u_sky_blend: s
                        };
                    })(t, e1.style.map.transform, e1.pixelRatio), o = new Xt(a.LEQUAL, Xt.ReadWrite, [
                        0,
                        1
                    ]), s = Yt.disabled, n = e1.colorModeForRenderPass(), l = e1.useProgram("sky"), c = Or(i, t);
                    l.draw(i, a.TRIANGLES, o, s, n, Ht.disabled, r, null, void 0, "sky", c.vertexBuffer, c.indexBuffer, c.segments);
                }(this, this.style.sky), this._showOverdrawInspector = i.showOverdrawInspector, this.depthRangeFor3D = [
                    0,
                    1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
                ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = o.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const e1 = this.style._layers[o[this.currentLayer]], t = s[e1.source], i = n[e1.source];
                    this._renderTileClippingMasks(e1, i, !1), this.renderLayer(this, t, e1, i, u);
                }
                this.renderPass = "translucent";
                let d = !1;
                for(this.currentLayer = 0; this.currentLayer < o.length; this.currentLayer++){
                    const e1 = this.style._layers[o[this.currentLayer]], t = s[e1.source];
                    if (this.renderToTexture && this.renderToTexture.renderLayer(e1, u)) continue;
                    this.opaquePassEnabledForLayer() || d || (d = !0, u.isRenderingGlobe && !this.style.map.terrain && this._renderTilesDepthBuffer());
                    const i = ("symbol" === e1.type ? h : l)[e1.source];
                    this._renderTileClippingMasks(e1, n[e1.source], !!this.renderToTexture), this.renderLayer(this, t, e1, i, u);
                }
                if (u.isRenderingGlobe && function(e1, i, a) {
                    const r = e1.context, o = r.gl, s = e1.useProgram("atmosphere"), n = new Xt(o.LEQUAL, Xt.ReadOnly, [
                        0,
                        1
                    ]), l = e1.transform, c = function(e1, i) {
                        const a = e1.properties.get("position"), r = [
                            -a.x,
                            -a.y,
                            -a.z
                        ], o = t.ar(new Float64Array(16));
                        return "map" === e1.properties.get("anchor") && (t.bf(o, o, i.rollInRadians), t.bg(o, o, -i.pitchInRadians), t.bf(o, o, i.bearingInRadians), t.bg(o, o, i.center.lat * Math.PI / 180), t.bI(o, o, -i.center.lng * Math.PI / 180)), t.cf(r, r, o), r;
                    }(a, e1.transform), h = l.getProjectionData({
                        overscaledTileID: null,
                        applyGlobeMatrix: !0,
                        applyTerrainMatrix: !0
                    }), u = i.properties.get("atmosphere-blend") * h.projectionTransition;
                    if (0 === u) return;
                    const d = hi(l.worldSize, l.center.lat), _ = l.inverseProjectionMatrix, p = new Float64Array(4);
                    p[3] = 1, t.aG(p, p, l.modelViewProjectionMatrix), p[0] /= p[3], p[1] /= p[3], p[2] /= p[3], p[3] = 1, t.aG(p, p, _), p[0] /= p[3], p[1] /= p[3], p[2] /= p[3], p[3] = 1;
                    const m = ((e1, t, i, a, r)=>({
                            u_sun_pos: e1,
                            u_atmosphere_blend: t,
                            u_globe_position: i,
                            u_globe_radius: a,
                            u_inv_proj_matrix: r
                        }))(c, u, [
                        p[0],
                        p[1],
                        p[2]
                    ], d, _), f = Or(r, i);
                    s.draw(r, o.TRIANGLES, n, Yt.disabled, Wt.alphaBlended, Ht.disabled, m, null, null, "atmosphere", f.vertexBuffer, f.indexBuffer, f.segments);
                }(this, this.style.sky, this.style.light), this.options.showTileBoundaries) {
                    const e1 = function(e1, t) {
                        let i = null;
                        const a = Object.values(e1._layers).flatMap((i)=>i.source && !i.isHidden(t) ? [
                                e1.tileManagers[i.source]
                            ] : []), r = a.filter((e1)=>"vector" === e1.getSource().type), o = a.filter((e1)=>"vector" !== e1.getSource().type), s = (e1)=>{
                            (!i || i.getSource().maxzoom < e1.getSource().maxzoom) && (i = e1);
                        };
                        return r.forEach((e1)=>s(e1)), i || o.forEach((e1)=>s(e1)), i;
                    }(this.style, this.transform.zoom);
                    e1 && function(e1, t, i) {
                        for(let a = 0; a < i.length; a++)Fr(e1, t, i[a]);
                    }(this, e1, e1.getVisibleCoordinates());
                }
                this.options.showPadding && function(e1) {
                    const t = e1.transform.padding;
                    Ar(e1, e1.transform.height - (t.top || 0), 3, Er), Ar(e1, t.bottom || 0, 3, Sr), Lr(e1, t.left || 0, 3, Rr), Lr(e1, e1.transform.width - (t.right || 0), 3, Dr);
                    const i = e1.transform.centerPoint;
                    !function(e1, t, i, a) {
                        kr(e1, t - 1, i - 10, 2, 20, a), kr(e1, t - 10, i - 1, 20, 2, a);
                    }(e1, i.x, e1.transform.height - i.y, zr);
                }(this), this.context.setDefault();
            }
            maybeDrawDepthAndCoords(e1) {
                if (!this.style || !this.style.map || !this.style.map.terrain) return;
                const i = this.terrainFacilitator.matrix, a = this.transform.modelViewProjectionMatrix;
                let r = this.terrainFacilitator.dirty;
                r || (r = e1 ? !t.ci(i, a) : !t.cj(i, a)), r || (r = this.style.map.terrain.tileManager.anyTilesAfterTime(this.terrainFacilitator.renderTime)), r && (t.ck(i, a), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(e1, i) {
                    const a = e1.context, r = a.gl, o = e1.transform, s = Wt.unblended, n = new Xt(r.LEQUAL, Xt.ReadWrite, [
                        0,
                        1
                    ]), l = i.tileManager.getRenderableTiles(), c = e1.useProgram("terrainDepth");
                    a.bindFramebuffer.set(i.getFramebuffer("depth").framebuffer), a.viewport.set([
                        0,
                        0,
                        e1.width / devicePixelRatio,
                        e1.height / devicePixelRatio
                    ]), a.clear({
                        color: t.bo.transparent,
                        depth: 1
                    });
                    for (const e1 of l){
                        const t = i.getTerrainMesh(e1.tileID), l = i.getTerrainData(e1.tileID), h = o.getProjectionData({
                            overscaledTileID: e1.tileID,
                            applyTerrainMatrix: !1,
                            applyGlobeMatrix: !0
                        }), u = {
                            u_ele_delta: i.getMeshFrameDelta(o.zoom)
                        };
                        c.draw(a, r.TRIANGLES, n, Yt.disabled, s, Ht.backCCW, u, l, h, "terrain", t.vertexBuffer, t.indexBuffer, t.segments);
                    }
                    a.bindFramebuffer.set(null), a.viewport.set([
                        0,
                        0,
                        e1.width,
                        e1.height
                    ]);
                }(this, this.style.map.terrain), function(e1, i) {
                    const a = e1.context, r = a.gl, o = e1.transform, s = Wt.unblended, n = new Xt(r.LEQUAL, Xt.ReadWrite, [
                        0,
                        1
                    ]), l = i.getCoordsTexture(), c = i.tileManager.getRenderableTiles(), h = e1.useProgram("terrainCoords");
                    a.bindFramebuffer.set(i.getFramebuffer("coords").framebuffer), a.viewport.set([
                        0,
                        0,
                        e1.width / devicePixelRatio,
                        e1.height / devicePixelRatio
                    ]), a.clear({
                        color: t.bo.transparent,
                        depth: 1
                    }), i.coordsIndex = [];
                    for (const e1 of c){
                        const t = i.getTerrainMesh(e1.tileID), c = i.getTerrainData(e1.tileID);
                        a.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, l.texture);
                        const u = {
                            u_terrain_coords_id: (255 - i.coordsIndex.length) / 255,
                            u_texture: 0,
                            u_ele_delta: i.getMeshFrameDelta(o.zoom)
                        }, d = o.getProjectionData({
                            overscaledTileID: e1.tileID,
                            applyTerrainMatrix: !1,
                            applyGlobeMatrix: !0
                        });
                        h.draw(a, r.TRIANGLES, n, Yt.disabled, s, Ht.backCCW, u, c, d, "terrain", t.vertexBuffer, t.indexBuffer, t.segments), i.coordsIndex.push(e1.tileID.key);
                    }
                    a.bindFramebuffer.set(null), a.viewport.set([
                        0,
                        0,
                        e1.width,
                        e1.height
                    ]);
                }(this, this.style.map.terrain));
            }
            renderLayer(e1, i, a, r, o) {
                a.isHidden(this.transform.zoom) || ("background" === a.type || "custom" === a.type || (r || []).length) && (this.id = a.id, t.cl(a) ? function(e1, i, a, r, o, s) {
                    if ("translucent" !== e1.renderPass) return;
                    const { isRenderingToTexture: n } = s, l = Yt.disabled, c = e1.colorModeForRenderPass();
                    (a._unevaluatedLayout.hasValue("text-variable-anchor") || a._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(e1, i, a, r, o, s, n, l, c) {
                        const h = i.transform, u = i.style.map.terrain, d = "map" === o, _ = "map" === s;
                        for (const o of e1){
                            const e1 = r.getTile(o), s = e1.getBucket(a);
                            if (!s || !s.text || !s.text.segments.get().length) continue;
                            const p = t.ax(s.textSizeData, h.zoom), m = t.aM(e1, 1, i.transform.zoom), f = Ae(d, i.transform, m), g = "none" !== a.layout.get("icon-text-fit") && s.hasIconData();
                            if (p) {
                                const i = Math.pow(2, h.zoom - e1.tileID.overscaledZ), a = u ? (e1, t)=>u.getElevation(o, e1, t) : null;
                                nr(s, d, _, c, h, f, i, p, g, t.aN(h, e1, n, l), o.toUnwrapped(), a);
                            }
                        }
                    }(r, e1, a, i, a.layout.get("text-rotation-alignment"), a.layout.get("text-pitch-alignment"), a.paint.get("text-translate"), a.paint.get("text-translate-anchor"), o), 0 !== a.paint.get("icon-opacity").constantOr(1) && cr(e1, i, a, r, !1, a.paint.get("icon-translate"), a.paint.get("icon-translate-anchor"), a.layout.get("icon-rotation-alignment"), a.layout.get("icon-pitch-alignment"), a.layout.get("icon-keep-upright"), l, c, n), 0 !== a.paint.get("text-opacity").constantOr(1) && cr(e1, i, a, r, !0, a.paint.get("text-translate"), a.paint.get("text-translate-anchor"), a.layout.get("text-rotation-alignment"), a.layout.get("text-pitch-alignment"), a.layout.get("text-keep-upright"), l, c, n), i.map.showCollisionBoxes && (ar(e1, i, a, r, !0), ar(e1, i, a, r, !1));
                }(e1, i, a, r, this.style.placement.variableOffsets, o) : t.cm(a) ? function(e1, i, a, r, o) {
                    if ("translucent" !== e1.renderPass) return;
                    const { isRenderingToTexture: s } = o, n = a.paint.get("circle-opacity"), l = a.paint.get("circle-stroke-width"), c = a.paint.get("circle-stroke-opacity"), h = !a.layout.get("circle-sort-key").isConstant();
                    if (0 === n.constantOr(1) && (0 === l.constantOr(1) || 0 === c.constantOr(1))) return;
                    const u = e1.context, d = u.gl, _ = e1.transform, p = e1.getDepthModeForSublayer(0, Xt.ReadOnly), m = Yt.disabled, f = e1.colorModeForRenderPass(), g = [], v = _.getCircleRadiusCorrection();
                    for(let o = 0; o < r.length; o++){
                        const n = r[o], l = i.getTile(n), c = l.getBucket(a);
                        if (!c) continue;
                        const u = a.paint.get("circle-translate"), d = a.paint.get("circle-translate-anchor"), p = t.aN(_, l, u, d), m = c.programConfigurations.get(a.id), f = e1.useProgram("circle", m), x = c.layoutVertexBuffer, b = c.indexBuffer, y = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(n), w = {
                            programConfiguration: m,
                            program: f,
                            layoutVertexBuffer: x,
                            indexBuffer: b,
                            uniformValues: Gi(e1, l, a, p, v),
                            terrainData: y,
                            projectionData: _.getProjectionData({
                                overscaledTileID: n,
                                applyGlobeMatrix: !s,
                                applyTerrainMatrix: !0
                            })
                        };
                        if (h) {
                            const e1 = c.segments.get();
                            for (const i of e1)g.push({
                                segments: new t.aW([
                                    i
                                ]),
                                sortKey: i.sortKey,
                                state: w
                            });
                        } else g.push({
                            segments: c.segments,
                            sortKey: 0,
                            state: w
                        });
                    }
                    h && g.sort((e1, t)=>e1.sortKey - t.sortKey);
                    for (const t of g){
                        const { programConfiguration: i, program: r, layoutVertexBuffer: o, indexBuffer: s, uniformValues: n, terrainData: l, projectionData: c } = t.state;
                        r.draw(u, d.TRIANGLES, p, m, f, Ht.backCCW, n, l, c, a.id, o, s, t.segments, a.paint, e1.transform.zoom, i);
                    }
                }(e1, i, a, r, o) : t.cn(a) ? function(e1, i, a, r, o) {
                    if (0 === a.paint.get("heatmap-opacity")) return;
                    const s = e1.context, { isRenderingToTexture: n, isRenderingGlobe: l } = o;
                    if (e1.style.map.terrain) {
                        for (const t of r){
                            const r = i.getTile(t);
                            i.hasRenderableParent(t) || ("offscreen" === e1.renderPass ? ur(e1, r, a, t, l) : "translucent" === e1.renderPass && dr(e1, a, t, n, l));
                        }
                        s.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    } else "offscreen" === e1.renderPass ? function(e1, i, a, r) {
                        const o = e1.context, s = o.gl, n = e1.transform, l = Yt.disabled, c = new Wt([
                            s.ONE,
                            s.ONE
                        ], t.bo.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        (function(e1, i, a) {
                            const r = e1.gl;
                            e1.activeTexture.set(r.TEXTURE1), e1.viewport.set([
                                0,
                                0,
                                i.width / 4,
                                i.height / 4
                            ]);
                            let o = a.heatmapFbos.get(t.cc);
                            o ? (r.bindTexture(r.TEXTURE_2D, o.colorAttachment.get()), e1.bindFramebuffer.set(o.framebuffer)) : (o = _r(e1, i.width / 4, i.height / 4), a.heatmapFbos.set(t.cc, o));
                        })(o, e1, a), o.clear({
                            color: t.bo.transparent
                        });
                        for(let t = 0; t < r.length; t++){
                            const h = r[t];
                            if (i.hasRenderableParent(h)) continue;
                            const u = i.getTile(h), d = u.getBucket(a);
                            if (!d) continue;
                            const _ = d.programConfigurations.get(a.id), p = e1.useProgram("heatmap", _), m = n.getProjectionData({
                                overscaledTileID: h,
                                applyGlobeMatrix: !0,
                                applyTerrainMatrix: !1
                            }), f = n.getCircleRadiusCorrection();
                            p.draw(o, s.TRIANGLES, Xt.disabled, l, c, Ht.backCCW, Wi(u, n.zoom, a.paint.get("heatmap-intensity"), f), null, m, a.id, d.layoutVertexBuffer, d.indexBuffer, d.segments, a.paint, n.zoom, _);
                        }
                        o.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    }(e1, i, a, r) : "translucent" === e1.renderPass && function(e1, i) {
                        const a = e1.context, r = a.gl;
                        a.setColorMode(e1.colorModeForRenderPass());
                        const o = i.heatmapFbos.get(t.cc);
                        o && (a.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, o.colorAttachment.get()), a.activeTexture.set(r.TEXTURE1), pr(a, i).bind(r.LINEAR, r.CLAMP_TO_EDGE), e1.useProgram("heatmapTexture").draw(a, r.TRIANGLES, Xt.disabled, Yt.disabled, e1.colorModeForRenderPass(), Ht.disabled, $i(e1, i, 0, 1), null, null, i.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, i.paint, e1.transform.zoom));
                    }(e1, a);
                }(e1, i, a, r, o) : t.co(a) ? function(e1, t, i, a, r) {
                    if ("translucent" !== e1.renderPass) return;
                    const { isRenderingToTexture: o } = r, s = i.paint.get("line-opacity"), n = i.paint.get("line-width");
                    if (0 === s.constantOr(1) || 0 === n.constantOr(1)) return;
                    const l = e1.getDepthModeForSublayer(0, Xt.ReadOnly), c = e1.colorModeForRenderPass(), h = i.paint.get("line-dasharray"), u = h.constantOr(1), d = i.paint.get("line-pattern"), _ = d.constantOr(1), p = i.paint.get("line-gradient"), m = i.getCrossfadeParameters();
                    let f;
                    f = _ ? "linePattern" : u && p ? "lineGradientSDF" : u ? "lineSDF" : p ? "lineGradient" : "line";
                    const g = e1.context, v = g.gl, x = e1.transform;
                    let b = !0;
                    for (const r of a){
                        const a = t.getTile(r);
                        if (_ && !a.patternsLoaded()) continue;
                        const s = a.getBucket(i);
                        if (!s) continue;
                        const n = s.programConfigurations.get(i.id), y = e1.context.program.get(), w = e1.useProgram(f, n), T = b || w.program !== y, P = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(r), C = d.constantOr(null), M = h && h.constantOr(null);
                        if (C && a.imageAtlas) {
                            const e1 = a.imageAtlas, t = e1.patternPositions[C.to.toString()], i = e1.patternPositions[C.from.toString()];
                            t && i && n.setConstantPatternPositions(t, i);
                        } else if (M) {
                            const t = "round" === i.layout.get("line-cap"), a = e1.lineAtlas.getDash(M.to, t), r = e1.lineAtlas.getDash(M.from, t);
                            n.setConstantDashPositions(a, r);
                        }
                        const I = x.getProjectionData({
                            overscaledTileID: r,
                            applyGlobeMatrix: !o,
                            applyTerrainMatrix: !0
                        }), E = x.getPixelScale();
                        let S;
                        _ ? (S = ea(e1, a, i, E, m), fr(g, v, a, n, m)) : u && p ? (S = ia(e1, a, i, E, m, s.lineClipsArray.length), xr(e1, t, g, v, i, s, r, n, m)) : u ? (S = ta(e1, a, i, E, m), gr(e1, g, v, n, T, m)) : p ? (S = Ji(e1, a, i, E, s.lineClipsArray.length), vr(e1, t, g, v, i, s, r)) : S = Qi(e1, a, i, E);
                        const R = e1.stencilModeForClipping(r);
                        w.draw(g, v.TRIANGLES, l, R, c, Ht.disabled, S, P, I, i.id, s.layoutVertexBuffer, s.indexBuffer, s.segments, i.paint, e1.transform.zoom, n, s.layoutVertexBuffer2), b = !1;
                    }
                }(e1, i, a, r, o) : t.cp(a) ? function(e1, i, a, r, o) {
                    const s = a.paint.get("fill-color"), n = a.paint.get("fill-opacity");
                    if (0 === n.constantOr(1)) return;
                    const { isRenderingToTexture: l } = o, c = e1.colorModeForRenderPass(), h = a.paint.get("fill-pattern"), u = e1.opaquePassEnabledForLayer() && !h.constantOr(1) && 1 === s.constantOr(t.bo.transparent).a && 1 === n.constantOr(0) ? "opaque" : "translucent";
                    if (e1.renderPass === u) {
                        const t = e1.getDepthModeForSublayer(1, "opaque" === e1.renderPass ? Xt.ReadWrite : Xt.ReadOnly);
                        yr(e1, i, a, r, t, c, !1, l);
                    }
                    if ("translucent" === e1.renderPass && a.paint.get("fill-antialias")) {
                        const t = e1.getDepthModeForSublayer(a.getPaintProperty("fill-outline-color") ? 2 : 0, Xt.ReadOnly);
                        yr(e1, i, a, r, t, c, !0, l);
                    }
                }(e1, i, a, r, o) : t.cq(a) ? function(e1, t, i, a, r) {
                    const o = i.paint.get("fill-extrusion-opacity");
                    if (0 === o) return;
                    const { isRenderingToTexture: s } = r;
                    if ("translucent" === e1.renderPass) {
                        const r = new Xt(e1.context.gl.LEQUAL, Xt.ReadWrite, e1.depthRangeFor3D);
                        if (1 !== o || i.paint.get("fill-extrusion-pattern").constantOr(1)) wr(e1, t, i, a, r, Yt.disabled, Wt.disabled, s), wr(e1, t, i, a, r, e1.stencilModeFor3D(), e1.colorModeForRenderPass(), s);
                        else {
                            const o = e1.colorModeForRenderPass();
                            wr(e1, t, i, a, r, Yt.disabled, o, s);
                        }
                    }
                }(e1, i, a, r, o) : t.cr(a) ? function(e1, i, a, r, o) {
                    if ("offscreen" !== e1.renderPass && "translucent" !== e1.renderPass) return;
                    const { isRenderingToTexture: s } = o, n = e1.context, l = e1.style.projection.useSubdivision, c = e1.getDepthModeForSublayer(0, Xt.ReadOnly), h = e1.colorModeForRenderPass();
                    if ("offscreen" === e1.renderPass) !function(e1, i, a, r, o, s, n) {
                        const l = e1.context, c = l.gl;
                        for (const h of a){
                            const a = i.getTile(h), u = a.dem;
                            if (!u || !u.data) continue;
                            if (!a.needsHillshadePrepare) continue;
                            const d = u.dim, _ = u.stride, p = u.getPixels();
                            if (l.activeTexture.set(c.TEXTURE1), l.pixelStoreUnpackPremultiplyAlpha.set(!1), a.demTexture = a.demTexture || e1.getTileTexture(_), a.demTexture) {
                                const e1 = a.demTexture;
                                e1.update(p, {
                                    premultiply: !1
                                }), e1.bind(c.NEAREST, c.CLAMP_TO_EDGE);
                            } else a.demTexture = new t.T(l, p, c.RGBA, {
                                premultiply: !1
                            }), a.demTexture.bind(c.NEAREST, c.CLAMP_TO_EDGE);
                            l.activeTexture.set(c.TEXTURE0);
                            let m = a.fbo;
                            if (!m) {
                                const e1 = new t.T(l, {
                                    width: d,
                                    height: d,
                                    data: null
                                }, c.RGBA);
                                e1.bind(c.LINEAR, c.CLAMP_TO_EDGE), m = a.fbo = l.createFramebuffer(d, d, !0, !1), m.colorAttachment.set(e1.texture);
                            }
                            l.bindFramebuffer.set(m.framebuffer), l.viewport.set([
                                0,
                                0,
                                d,
                                d
                            ]), e1.useProgram("hillshadePrepare").draw(l, c.TRIANGLES, o, s, n, Ht.disabled, Xi(a.tileID, u), null, null, r.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), a.needsHillshadePrepare = !1;
                        }
                    }(e1, i, r, a, c, Yt.disabled, h), n.viewport.set([
                        0,
                        0,
                        e1.width,
                        e1.height
                    ]);
                    else if ("translucent" === e1.renderPass) {
                        if (l) {
                            const [t, o, n] = e1.stencilConfigForOverlapTwoPass(r);
                            Tr(e1, i, a, n, t, c, h, !1, s), Tr(e1, i, a, n, o, c, h, !0, s);
                        } else {
                            const [t, o] = e1.getStencilConfigForOverlapAndUpdateStencilID(r);
                            Tr(e1, i, a, o, t, c, h, !1, s);
                        }
                    }
                }(e1, i, a, r, o) : t.cs(a) ? function(e1, t, i, a, r) {
                    if ("translucent" !== e1.renderPass) return;
                    if (!a.length) return;
                    const { isRenderingToTexture: o } = r, s = e1.style.projection.useSubdivision, n = e1.getDepthModeForSublayer(0, Xt.ReadOnly), l = e1.colorModeForRenderPass();
                    if (s) {
                        const [r, s, c] = e1.stencilConfigForOverlapTwoPass(a);
                        Pr(e1, t, i, c, r, n, l, !1, o), Pr(e1, t, i, c, s, n, l, !0, o);
                    } else {
                        const [r, s] = e1.getStencilConfigForOverlapAndUpdateStencilID(a);
                        Pr(e1, t, i, s, r, n, l, !1, o);
                    }
                }(e1, i, a, r, o) : t.bT(a) ? function(e1, t, i, a, r) {
                    if ("translucent" !== e1.renderPass) return;
                    if (0 === i.paint.get("raster-opacity")) return;
                    if (!a.length) return;
                    const { isRenderingToTexture: o } = r, s = t.getSource(), n = e1.style.projection.useSubdivision;
                    if (s instanceof te) Mr(e1, t, i, a, null, !1, !1, s.tileCoords, s.flippedWindingOrder, o);
                    else if (n) {
                        const [r, s, n] = e1.stencilConfigForOverlapTwoPass(a);
                        Mr(e1, t, i, n, r, !1, !0, Cr, !1, o), Mr(e1, t, i, n, s, !0, !0, Cr, !1, o);
                    } else {
                        const [r, s] = e1.getStencilConfigForOverlapAndUpdateStencilID(a);
                        Mr(e1, t, i, s, r, !1, !0, Cr, !1, o);
                    }
                }(e1, i, a, r, o) : t.ct(a) ? function(e1, t, i, a, r) {
                    const o = i.paint.get("background-color"), s = i.paint.get("background-opacity");
                    if (0 === s) return;
                    const { isRenderingToTexture: n } = r, l = e1.context, c = l.gl, h = e1.style.projection, u = e1.transform, d = u.tileSize, _ = i.paint.get("background-pattern");
                    if (e1.isPatternMissing(_)) return;
                    const p = !_ && 1 === o.a && 1 === s && e1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                    if (e1.renderPass !== p) return;
                    const m = Yt.disabled, f = e1.getDepthModeForSublayer(0, "opaque" === p ? Xt.ReadWrite : Xt.ReadOnly), g = e1.colorModeForRenderPass(), v = e1.useProgram(_ ? "backgroundPattern" : "background"), x = a || Ce(u, {
                        tileSize: d,
                        terrain: e1.style.map.terrain
                    });
                    _ && (l.activeTexture.set(c.TEXTURE0), e1.imageManager.bind(e1.context));
                    const b = i.getCrossfadeParameters();
                    for (const t of x){
                        const a = u.getProjectionData({
                            overscaledTileID: t,
                            applyGlobeMatrix: !n,
                            applyTerrainMatrix: !0
                        }), r = _ ? ua(s, e1, _, {
                            tileID: t,
                            tileSize: d
                        }, b) : ha(s, o), p = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(t), x = h.getMeshFromTileID(l, t.canonical, !1, !0, "raster");
                        v.draw(l, c.TRIANGLES, f, m, g, Ht.backCCW, r, p, a, i.id, x.vertexBuffer, x.indexBuffer, x.segments);
                    }
                }(e1, 0, a, r, o) : t.cu(a) && function(e1, t, i, a) {
                    const { isRenderingGlobe: r } = a, o = e1.context, s = i.implementation, n = e1.style.projection, l = e1.transform, c = l.getProjectionDataForCustomLayer(r), h = {
                        farZ: l.farZ,
                        nearZ: l.nearZ,
                        fov: l.fov * Math.PI / 180,
                        modelViewProjectionMatrix: l.modelViewProjectionMatrix,
                        projectionMatrix: l.projectionMatrix,
                        shaderData: {
                            variantName: n.shaderVariantName,
                            vertexShaderPrelude: `const float PI = 3.141592653589793;\nuniform mat4 u_projection_matrix;\n${n.shaderPreludeCode.vertexSource}`,
                            define: n.shaderDefine
                        },
                        defaultProjectionData: c
                    }, u = s.renderingMode ? s.renderingMode : "2d";
                    if ("offscreen" === e1.renderPass) {
                        const t = s.prerender;
                        t && (e1.setCustomLayerDefaults(), o.setColorMode(e1.colorModeForRenderPass()), t.call(s, o.gl, h), o.setDirty(), e1.setBaseState());
                    } else if ("translucent" === e1.renderPass) {
                        e1.setCustomLayerDefaults(), o.setColorMode(e1.colorModeForRenderPass()), o.setStencilMode(Yt.disabled);
                        const t = "3d" === u ? e1.getDepthModeFor3D() : e1.getDepthModeForSublayer(0, Xt.ReadOnly);
                        o.setDepthMode(t), s.render(o.gl, h), o.setDirty(), e1.setBaseState(), o.bindFramebuffer.set(null);
                    }
                }(e1, 0, a, o));
            }
            saveTileTexture(e1) {
                const t = this._tileTextures[e1.size[0]];
                t ? t.push(e1) : this._tileTextures[e1.size[0]] = [
                    e1
                ];
            }
            getTileTexture(e1) {
                const t = this._tileTextures[e1];
                return t && t.length > 0 ? t.pop() : null;
            }
            isPatternMissing(e1) {
                if (!e1) return !1;
                if (!e1.from || !e1.to) return !0;
                const t = this.imageManager.getPattern(e1.from.toString()), i = this.imageManager.getPattern(e1.to.toString());
                return !t || !i;
            }
            useProgram(e1, t, i = !1, a = []) {
                this.cache = this.cache || {};
                const r = !!this.style.map.terrain, o = this.style.projection, s = i ? It.projectionMercator : o.shaderPreludeCode, n = i ? Dt : o.shaderDefine, l = e1 + (t ? t.cacheKey : "") + `/${i ? zt : o.shaderVariantName}` + (this._showOverdrawInspector ? "/overdraw" : "") + (r ? "/terrain" : "") + (a ? `/${a.join("/")}` : "");
                return this.cache[l] || (this.cache[l] = new ki(this.context, It[e1], t, _a[e1], this._showOverdrawInspector, r, s, n, a)), this.cache[l];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e1 = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e1.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new t.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                var e1, t;
                if (this._tileTextures) {
                    for(const e1 in this._tileTextures){
                        const t = this._tileTextures[e1];
                        if (t) for (const e1 of t)e1.destroy();
                    }
                    this._tileTextures = {};
                }
                if (this.tileExtentBuffer && this.tileExtentBuffer.destroy(), this.debugBuffer && this.debugBuffer.destroy(), this.rasterBoundsBuffer && this.rasterBoundsBuffer.destroy(), this.rasterBoundsBufferPosOnly && this.rasterBoundsBufferPosOnly.destroy(), this.viewportBuffer && this.viewportBuffer.destroy(), this.tileBorderIndexBuffer && this.tileBorderIndexBuffer.destroy(), this.quadTriangleIndexBuffer && this.quadTriangleIndexBuffer.destroy(), this.tileExtentMesh && (null === (e1 = this.tileExtentMesh.vertexBuffer) || void 0 === e1 || e1.destroy()), this.tileExtentMesh && (null === (t = this.tileExtentMesh.indexBuffer) || void 0 === t || t.destroy()), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this.cache) {
                    for(const e1 in this.cache){
                        const t = this.cache[e1];
                        t && t.program && this.context.gl.deleteProgram(t.program);
                    }
                    this.cache = {};
                }
                this.context && this.context.setDefault();
            }
            overLimit() {
                const { drawingBufferWidth: e1, drawingBufferHeight: t } = this.context.gl;
                return this.width !== e1 || this.height !== t;
            }
        }
        function Nr(e1, t) {
            let i, a = !1, r = null, o = null;
            const s = ()=>{
                r = null, a && (e1.apply(o, i), r = setTimeout(s, t), a = !1);
            };
            return (...e1)=>(a = !0, o = this, i = e1, r || s(), r);
        }
        class Zr {
            constructor(e1){
                this._getCurrentHash = ()=>{
                    const e1 = window.location.hash.replace("#", "");
                    if (this._hashName) {
                        let t;
                        return e1.split("&").map((e1)=>e1.split("=")).forEach((e1)=>{
                            e1[0] === this._hashName && (t = e1);
                        }), (t && t[1] || "").split("/");
                    }
                    return e1.split("/");
                }, this._onHashChange = ()=>{
                    const e1 = this._getCurrentHash();
                    if (!this._isValidHash(e1)) return !1;
                    const t = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(e1[3] || 0) : this._map.getBearing();
                    return this._map.jumpTo({
                        center: [
                            +e1[2],
                            +e1[1]
                        ],
                        zoom: +e1[0],
                        bearing: t,
                        pitch: +(e1[4] || 0)
                    }), !0;
                }, this._updateHashUnthrottled = ()=>{
                    const e1 = window.location.href.replace(/(#.*)?$/, this.getHashString());
                    window.history.replaceState(window.history.state, null, e1);
                }, this._removeHash = ()=>{
                    const e1 = this._getCurrentHash();
                    if (0 === e1.length) return;
                    const t = e1.join("/");
                    let i = t;
                    i.split("&").length > 0 && (i = i.split("&")[0]), this._hashName && (i = `${this._hashName}=${t}`);
                    let a = window.location.hash.replace(i, "");
                    a.startsWith("#&") ? a = a.slice(0, 1) + a.slice(2) : "#" === a && (a = "");
                    let r = window.location.href.replace(/(#.+)?$/, a);
                    r = r.replace("&&", "&"), window.history.replaceState(window.history.state, null, r);
                }, this._updateHash = Nr(this._updateHashUnthrottled, 300), this._hashName = e1 && encodeURIComponent(e1);
            }
            addTo(e1) {
                return this._map = e1, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
            }
            remove() {
                return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
            }
            getHashString(e1) {
                const t = this._map.getCenter(), i = Math.round(100 * this._map.getZoom()) / 100, a = Math.ceil((i * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), r = Math.pow(10, a), o = Math.round(t.lng * r) / r, s = Math.round(t.lat * r) / r, n = this._map.getBearing(), l = this._map.getPitch();
                let c = "";
                if (c += e1 ? `/${o}/${s}/${i}` : `${i}/${s}/${o}`, (n || l) && (c += "/" + Math.round(10 * n) / 10), l && (c += `/${Math.round(l)}`), this._hashName) {
                    const e1 = this._hashName;
                    let t = !1;
                    const i = window.location.hash.slice(1).split("&").map((i)=>{
                        const a = i.split("=")[0];
                        return a === e1 ? (t = !0, `${a}=${c}`) : i;
                    }).filter((e1)=>e1);
                    return t || i.push(`${e1}=${c}`), `#${i.join("&")}`;
                }
                return `#${c}`;
            }
            _isValidHash(e1) {
                if (e1.length < 3 || e1.some(isNaN)) return !1;
                try {
                    new t.V(+e1[2], +e1[1]);
                } catch (e1) {
                    return !1;
                }
                const i = +e1[0], a = +(e1[3] || 0), r = +(e1[4] || 0);
                return i >= this._map.getMinZoom() && i <= this._map.getMaxZoom() && a >= -180 && a <= 180 && r >= this._map.getMinPitch() && r <= this._map.getMaxPitch();
            }
        }
        const Gr = {
            linearity: .3,
            easing: t.cv(0, 0, .3, 1)
        }, Ur = t.e({
            deceleration: 2500,
            maxSpeed: 1400
        }, Gr), Vr = t.e({
            deceleration: 20,
            maxSpeed: 1400
        }, Gr), qr = t.e({
            deceleration: 1e3,
            maxSpeed: 360
        }, Gr), Wr = t.e({
            deceleration: 1e3,
            maxSpeed: 90
        }, Gr), $r = t.e({
            deceleration: 1e3,
            maxSpeed: 360
        }, Gr);
        class Hr {
            constructor(e1){
                this._map = e1, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(e1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: c(),
                    settings: e1
                });
            }
            _drainInertiaBuffer() {
                const e1 = this._inertiaBuffer, t = c();
                for(; e1.length > 0 && t - e1[0].time > 160;)e1.shift();
            }
            _onMoveEnd(e1) {
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    roll: 0,
                    pan: new t.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e1 } of this._inertiaBuffer)i.zoom += e1.zoomDelta || 0, i.bearing += e1.bearingDelta || 0, i.pitch += e1.pitchDelta || 0, i.roll += e1.rollDelta || 0, e1.panDelta && i.pan._add(e1.panDelta), e1.around && (i.around = e1.around), e1.pinchAround && (i.pinchAround = e1.pinchAround);
                const a = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r = {};
                if (i.pan.mag()) {
                    const o = Kr(i.pan.mag(), a, t.e({}, Ur, e1 || {})), s = i.pan.mult(o.amount / i.pan.mag()), n = this._map.cameraHelper.handlePanInertia(s, this._map.transform);
                    r.center = n.easingCenter, r.offset = n.easingOffset, Xr(r, o);
                }
                if (i.zoom) {
                    const e1 = Kr(i.zoom, a, Vr);
                    r.zoom = this._map.transform.zoom + e1.amount, Xr(r, e1);
                }
                if (i.bearing) {
                    const e1 = Kr(i.bearing, a, qr);
                    r.bearing = this._map.transform.bearing + t.an(e1.amount, -179, 179), Xr(r, e1);
                }
                if (i.pitch) {
                    const e1 = Kr(i.pitch, a, Wr);
                    r.pitch = this._map.transform.pitch + e1.amount, Xr(r, e1);
                }
                if (i.roll) {
                    const e1 = Kr(i.roll, a, $r);
                    r.roll = this._map.transform.roll + t.an(e1.amount, -179, 179), Xr(r, e1);
                }
                if (r.zoom || r.bearing) {
                    const e1 = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    r.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
                }
                return this.clear(), t.e(r, {
                    noMoveStart: !0
                });
            }
        }
        function Xr(e1, t) {
            (!e1.duration || e1.duration < t.duration) && (e1.duration = t.duration, e1.easing = t.easing);
        }
        function Kr(e1, i, a) {
            const { maxSpeed: r, linearity: o, deceleration: s } = a, n = t.an(e1 * o / (i / 1e3), -r, r), l = Math.abs(n) / (s * o);
            return {
                easing: a.easing,
                duration: 1e3 * l,
                amount: n * (l / 2)
            };
        }
        class Yr extends t.l {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, i, a, r = {}){
                a = a instanceof MouseEvent ? a : new MouseEvent(e1, a);
                const o = h.mousePos(i.getCanvas(), a), s = i.unproject(o);
                super(e1, t.e({
                    point: o,
                    lngLat: s,
                    originalEvent: a
                }, r)), this._defaultPrevented = !1, this.target = i;
            }
        }
        class Qr extends t.l {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, i, a){
                const r = "touchend" === e1 ? a.changedTouches : a.touches, o = h.touchPos(i.getCanvasContainer(), r), s = o.map((e1)=>i.unproject(e1)), n = o.reduce((e1, t, i, a)=>e1.add(t.div(a.length)), new t.P(0, 0));
                super(e1, {
                    points: o,
                    point: n,
                    lngLats: s,
                    lngLat: i.unproject(n),
                    originalEvent: a
                }), this._defaultPrevented = !1;
            }
        }
        class Jr extends t.l {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t, i){
                super(e1, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class eo {
            constructor(e1, t){
                this._map = e1, this._clickTolerance = t.clickTolerance;
            }
            reset() {
                delete this._mousedownPos;
            }
            wheel(e1) {
                return this._firePreventable(new Jr(e1.type, this._map, e1));
            }
            mousedown(e1, t) {
                return this._mousedownPos = t, this._firePreventable(new Yr(e1.type, this._map, e1));
            }
            mouseup(e1) {
                this._map.fire(new Yr(e1.type, this._map, e1));
            }
            click(e1, t) {
                this._mousedownPos && this._mousedownPos.dist(t) >= this._clickTolerance || this._map.fire(new Yr(e1.type, this._map, e1));
            }
            dblclick(e1) {
                return this._firePreventable(new Yr(e1.type, this._map, e1));
            }
            mouseover(e1) {
                this._map.fire(new Yr(e1.type, this._map, e1));
            }
            mouseout(e1) {
                this._map.fire(new Yr(e1.type, this._map, e1));
            }
            touchstart(e1) {
                return this._firePreventable(new Qr(e1.type, this._map, e1));
            }
            touchmove(e1) {
                this._map.fire(new Qr(e1.type, this._map, e1));
            }
            touchend(e1) {
                this._map.fire(new Qr(e1.type, this._map, e1));
            }
            touchcancel(e1) {
                this._map.fire(new Qr(e1.type, this._map, e1));
            }
            _firePreventable(e1) {
                if (this._map.fire(e1), e1.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class to {
            constructor(e1){
                this._map = e1;
            }
            reset() {
                this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
            }
            mousemove(e1) {
                this._map.fire(new Yr(e1.type, this._map, e1));
            }
            mousedown() {
                this._delayContextMenu = !0, this._ignoreContextMenu = !1;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Yr("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e1) {
                this._delayContextMenu ? this._contextMenuEvent = e1 : this._ignoreContextMenu || this._map.fire(new Yr(e1.type, this._map, e1)), this._map.listens("contextmenu") && e1.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class io {
            constructor(e1){
                this._map = e1;
            }
            get transform() {
                return this._map._requestedCameraState || this._map.transform;
            }
            get center() {
                return {
                    lng: this.transform.center.lng,
                    lat: this.transform.center.lat
                };
            }
            get zoom() {
                return this.transform.zoom;
            }
            get pitch() {
                return this.transform.pitch;
            }
            get bearing() {
                return this.transform.bearing;
            }
            unproject(e1) {
                return this.transform.screenPointToLocation(t.P.convert(e1), this._map.terrain);
            }
        }
        class ao {
            constructor(e1, t){
                this._map = e1, this._tr = new io(e1), this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e1, t) {
                this.isEnabled() && e1.shiftKey && 0 === e1.button && (h.disableDrag(), this._startPos = this._lastPos = t, this._active = !0);
            }
            mousemoveWindow(e1, t) {
                if (!this._active) return;
                const i = t;
                if (this._lastPos.equals(i) || !this._box && i.dist(this._startPos) < this._clickTolerance) return;
                const a = this._startPos;
                this._lastPos = i, this._box || (this._box = h.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", e1));
                const r = Math.min(a.x, i.x), o = Math.max(a.x, i.x), s = Math.min(a.y, i.y), n = Math.max(a.y, i.y);
                h.setTransform(this._box, `translate(${r}px,${s}px)`), this._box.style.width = o - r + "px", this._box.style.height = n - s + "px";
            }
            mouseupWindow(e1, i) {
                if (!this._active) return;
                if (0 !== e1.button) return;
                const a = this._startPos, r = i;
                if (this.reset(), h.suppressClick(), a.x !== r.x || a.y !== r.y) return this._map.fire(new t.l("boxzoomend", {
                    originalEvent: e1
                })), {
                    cameraAnimation: (e1)=>e1.fitScreenCoordinates(a, r, this._tr.bearing, {
                            linear: !0
                        })
                };
                this._fireEvent("boxzoomcancel", e1);
            }
            keydown(e1) {
                this._active && 27 === e1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e1));
            }
            reset() {
                this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (h.remove(this._box), this._box = null), h.enableDrag(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(e1, i) {
                return this._map.fire(new t.l(e1, {
                    originalEvent: i
                }));
            }
        }
        function ro(e1, t) {
            if (e1.length !== t.length) throw new Error(`The number of touches and points are not equal - touches ${e1.length}, points ${t.length}`);
            const i = {};
            for(let a = 0; a < e1.length; a++)i[e1[a].identifier] = t[a];
            return i;
        }
        class oo {
            constructor(e1){
                this.reset(), this.numTouches = e1.numTouches;
            }
            reset() {
                delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
            }
            touchstart(e1, i, a) {
                (this.centroid || a.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e1.timeStamp), a.length === this.numTouches && (this.centroid = function(e1) {
                    const i = new t.P(0, 0);
                    for (const t of e1)i._add(t);
                    return i.div(e1.length);
                }(i), this.touches = ro(a, i)));
            }
            touchmove(e1, t, i) {
                if (this.aborted || !this.centroid) return;
                const a = ro(i, t);
                for(const e1 in this.touches){
                    const t = a[e1];
                    (!t || t.dist(this.touches[e1]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e1, t, i) {
                if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e1 = !this.aborted && this.centroid;
                    if (this.reset(), e1) return e1;
                }
            }
        }
        class so {
            constructor(e1){
                this.singleTap = new oo(e1), this.numTaps = e1.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
            }
            touchstart(e1, t, i) {
                this.singleTap.touchstart(e1, t, i);
            }
            touchmove(e1, t, i) {
                this.singleTap.touchmove(e1, t, i);
            }
            touchend(e1, t, i) {
                const a = this.singleTap.touchend(e1, t, i);
                if (a) {
                    const t = e1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(a) < 30;
                    if (t && i || this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = a, this.count === this.numTaps) return this.reset(), a;
                }
            }
        }
        class no {
            constructor(e1){
                this._tr = new io(e1), this._zoomIn = new so({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new so({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e1, t, i) {
                this._zoomIn.touchstart(e1, t, i), this._zoomOut.touchstart(e1, t, i);
            }
            touchmove(e1, t, i) {
                this._zoomIn.touchmove(e1, t, i), this._zoomOut.touchmove(e1, t, i);
            }
            touchend(e1, t, i) {
                const a = this._zoomIn.touchend(e1, t, i), r = this._zoomOut.touchend(e1, t, i), o = this._tr;
                return a ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t)=>t.easeTo({
                            duration: 300,
                            zoom: o.zoom + 1,
                            around: o.unproject(a)
                        }, {
                            originalEvent: e1
                        })
                }) : r ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t)=>t.easeTo({
                            duration: 300,
                            zoom: o.zoom - 1,
                            around: o.unproject(r)
                        }, {
                            originalEvent: e1
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class lo {
            constructor(e1){
                this._enabled = !!e1.enable, this._moveStateManager = e1.moveStateManager, this._clickTolerance = e1.clickTolerance || 1, this._moveFunction = e1.move, this._activateOnStart = !!e1.activateOnStart, e1.assignEvents(this), this.reset();
            }
            reset(e1) {
                this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(e1);
            }
            _move(...e1) {
                const t = this._moveFunction(...e1);
                if (t.bearingDelta || t.pitchDelta || t.rollDelta || t.around || t.panDelta) return this._active = !0, t;
            }
            dragStart(e1, t) {
                this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(e1) && (this._moveStateManager.startMove(e1), this._lastPoint = Array.isArray(t) ? t[0] : t, this._activateOnStart && this._lastPoint && (this._active = !0));
            }
            dragMove(e1, t) {
                if (!this.isEnabled()) return;
                const i = this._lastPoint;
                if (!i) return;
                if (e1.preventDefault(), !this._moveStateManager.isValidMoveEvent(e1)) return void this.reset(e1);
                const a = Array.isArray(t) ? t[0] : t;
                return !this._moved && a.dist(i) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = a, this._move(i, a));
            }
            dragEnd(e1) {
                this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(e1) && (this._moved && h.suppressClick(), this.reset(e1));
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            getClickTolerance() {
                return this._clickTolerance;
            }
        }
        const co = 0, ho = 2, uo = {
            [co]: 1,
            [ho]: 2
        };
        class _o {
            constructor(e1){
                this._correctEvent = e1.checkCorrectEvent;
            }
            startMove(e1) {
                const t = h.mouseButton(e1);
                this._eventButton = t;
            }
            endMove(e1) {
                delete this._eventButton;
            }
            isValidStartEvent(e1) {
                return this._correctEvent(e1);
            }
            isValidMoveEvent(e1) {
                return !function(e1, t) {
                    const i = uo[t];
                    return void 0 === e1.buttons || (e1.buttons & i) !== i;
                }(e1, this._eventButton);
            }
            isValidEndEvent(e1) {
                return h.mouseButton(e1) === this._eventButton;
            }
        }
        class po {
            constructor(){
                this._firstTouch = void 0;
            }
            _isOneFingerTouch(e1) {
                return 1 === e1.targetTouches.length;
            }
            _isSameTouchEvent(e1) {
                return e1.targetTouches[0].identifier === this._firstTouch;
            }
            startMove(e1) {
                this._firstTouch = e1.targetTouches[0].identifier;
            }
            endMove(e1) {
                delete this._firstTouch;
            }
            isValidStartEvent(e1) {
                return this._isOneFingerTouch(e1);
            }
            isValidMoveEvent(e1) {
                return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
            }
            isValidEndEvent(e1) {
                return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
            }
        }
        class mo {
            constructor(e1 = new _o({
                checkCorrectEvent: ()=>!0
            }), t = new po){
                this.mouseMoveStateManager = e1, this.oneFingerTouchMoveStateManager = t;
            }
            _executeRelevantHandler(e1, t, i) {
                return e1 instanceof MouseEvent ? t(e1) : "undefined" != typeof TouchEvent && e1 instanceof TouchEvent ? i(e1) : void 0;
            }
            startMove(e1) {
                this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.startMove(e1), (e1)=>this.oneFingerTouchMoveStateManager.startMove(e1));
            }
            endMove(e1) {
                this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.endMove(e1), (e1)=>this.oneFingerTouchMoveStateManager.endMove(e1));
            }
            isValidStartEvent(e1) {
                return this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidStartEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidStartEvent(e1));
            }
            isValidMoveEvent(e1) {
                return this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidMoveEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidMoveEvent(e1));
            }
            isValidEndEvent(e1) {
                return this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidEndEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidEndEvent(e1));
            }
        }
        const fo = (e1)=>{
            e1.mousedown = e1.dragStart, e1.mousemoveWindow = e1.dragMove, e1.mouseup = e1.dragEnd, e1.contextmenu = (e1)=>{
                e1.preventDefault();
            };
        };
        class go {
            constructor(e1, t){
                this._clickTolerance = e1.clickTolerance || 1, this._map = t, this.reset();
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new t.P(0, 0);
            }
            _shouldBePrevented(e1) {
                return e1 < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
            }
            touchstart(e1, t, i) {
                return this._calculateTransform(e1, t, i);
            }
            touchmove(e1, t, i) {
                if (this._active) {
                    if (!this._shouldBePrevented(i.length)) return e1.preventDefault(), this._calculateTransform(e1, t, i);
                    this._map.cooperativeGestures.notifyGestureBlocked("touch_pan", e1);
                }
            }
            touchend(e1, t, i) {
                this._calculateTransform(e1, t, i), this._active && this._shouldBePrevented(i.length) && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(e1, i, a) {
                a.length > 0 && (this._active = !0);
                const r = ro(a, i), o = new t.P(0, 0), s = new t.P(0, 0);
                let n = 0;
                for(const e1 in r){
                    const t = r[e1], i = this._touches[e1];
                    i && (o._add(t), s._add(t.sub(i)), n++, r[e1] = t);
                }
                if (this._touches = r, this._shouldBePrevented(n) || !s.mag()) return;
                const l = s.div(n);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: o.div(n),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class vo {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, delete this._firstTwoTouches;
            }
            touchstart(e1, t, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t[0],
                    t[1]
                ]));
            }
            touchmove(e1, t, i) {
                if (!this._firstTwoTouches) return;
                e1.preventDefault();
                const [a, r] = this._firstTwoTouches, o = xo(i, t, a), s = xo(i, t, r);
                if (!o || !s) return;
                const n = this._aroundCenter ? null : o.add(s).div(2);
                return this._move([
                    o,
                    s
                ], n, e1);
            }
            touchend(e1, t, i) {
                if (!this._firstTwoTouches) return;
                const [a, r] = this._firstTwoTouches, o = xo(i, t, a), s = xo(i, t, r);
                o && s || (this._active && h.suppressClick(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e1) {
                this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
        }
        function xo(e1, t, i) {
            for(let a = 0; a < e1.length; a++)if (e1[a].identifier === i) return t[a];
        }
        function bo(e1, t) {
            return Math.log(e1 / t) / Math.LN2;
        }
        class yo extends vo {
            reset() {
                super.reset(), delete this._distance, delete this._startDistance;
            }
            _start(e1) {
                this._startDistance = this._distance = e1[0].dist(e1[1]);
            }
            _move(e1, t) {
                const i = this._distance;
                if (this._distance = e1[0].dist(e1[1]), this._active || !(Math.abs(bo(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: bo(this._distance, i),
                    pinchAround: t
                };
            }
        }
        function wo(e1, t) {
            return 180 * e1.angleWith(t) / Math.PI;
        }
        class To extends vo {
            reset() {
                super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
            }
            _start(e1) {
                this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
            }
            _move(e1, t, i) {
                const a = this._vector;
                if (this._vector = e1[0].sub(e1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                    bearingDelta: wo(this._vector, a),
                    pinchAround: t
                };
            }
            _isBelowThreshold(e1) {
                this._minDiameter = Math.min(this._minDiameter, e1.mag());
                const t = 25 / (Math.PI * this._minDiameter) * 360, i = wo(e1, this._startVector);
                return Math.abs(i) < t;
            }
        }
        function Po(e1) {
            return Math.abs(e1.y) > Math.abs(e1.x);
        }
        class Co extends vo {
            constructor(e1){
                super(), this._currentTouchCount = 0, this._map = e1;
            }
            reset() {
                super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
            }
            touchstart(e1, t, i) {
                super.touchstart(e1, t, i), this._currentTouchCount = i.length;
            }
            _start(e1) {
                this._lastPoints = e1, Po(e1[0].sub(e1[1])) && (this._valid = !1);
            }
            _move(e1, t, i) {
                if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
                const a = e1[0].sub(this._lastPoints[0]), r = e1[1].sub(this._lastPoints[1]);
                return this._valid = this.gestureBeginsVertically(a, r, i.timeStamp), this._valid ? (this._lastPoints = e1, this._active = !0, {
                    pitchDelta: (a.y + r.y) / 2 * -0.5
                }) : void 0;
            }
            gestureBeginsVertically(e1, t, i) {
                if (void 0 !== this._valid) return this._valid;
                const a = e1.mag() >= 2, r = t.mag() >= 2;
                if (!a && !r) return;
                if (!a || !r) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const o = e1.y > 0 == t.y > 0;
                return Po(e1) && Po(t) && o;
            }
        }
        const Mo = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class Io {
            constructor(e1){
                this._tr = new io(e1);
                const t = Mo;
                this._panStep = t.panStep, this._bearingStep = t.bearingStep, this._pitchStep = t.pitchStep, this._rotationDisabled = !1;
            }
            reset() {
                this._active = !1;
            }
            keydown(e1) {
                if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
                let t = 0, i = 0, a = 0, r = 0, o = 0;
                switch(e1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t = -1;
                        break;
                    case 37:
                        e1.shiftKey ? i = -1 : (e1.preventDefault(), r = -1);
                        break;
                    case 39:
                        e1.shiftKey ? i = 1 : (e1.preventDefault(), r = 1);
                        break;
                    case 38:
                        e1.shiftKey ? a = 1 : (e1.preventDefault(), o = -1);
                        break;
                    case 40:
                        e1.shiftKey ? a = -1 : (e1.preventDefault(), o = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, a = 0), {
                    cameraAnimation: (s)=>{
                        const n = this._tr;
                        s.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: Eo,
                            zoom: t ? Math.round(n.zoom) + t * (e1.shiftKey ? 2 : 1) : n.zoom,
                            bearing: n.bearing + i * this._bearingStep,
                            pitch: n.pitch + a * this._pitchStep,
                            offset: [
                                -r * this._panStep,
                                -o * this._panStep
                            ],
                            center: n.center
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function Eo(e1) {
            return e1 * (2 - e1);
        }
        const So = 4.000244140625, Ro = 1 / 450;
        class Do {
            constructor(e1, t){
                this._onTimeout = (e1)=>{
                    this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e1);
                }, this._map = e1, this._tr = new io(e1), this._triggerRenderFrame = t, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = Ro;
            }
            setZoomRate(e1) {
                this._defaultZoomRate = e1;
            }
            setWheelZoomRate(e1) {
                this._wheelZoomRate = e1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e1) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            _shouldBePrevented(e1) {
                return !!this._map.cooperativeGestures.isEnabled() && !(e1.ctrlKey || this._map.cooperativeGestures.isBypassed(e1));
            }
            wheel(e1) {
                if (!this.isEnabled()) return;
                if (this._shouldBePrevented(e1)) return void this._map.cooperativeGestures.notifyGestureBlocked("wheel_zoom", e1);
                let t = e1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY;
                const i = c(), a = i - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = i, 0 !== t && t % So == 0 ? this._type = "wheel" : 0 !== t && Math.abs(t) < 4 ? this._type = "trackpad" : a > 400 ? (this._type = null, this._lastValue = t, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(a * t) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, t += this._lastValue)), e1.shiftKey && t && (t /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= t, this._active || this._start(e1)), e1.preventDefault();
            }
            _start(e1) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const i = h.mousePos(this._map.getCanvas(), e1), a = this._tr;
                this._aroundPoint = this._aroundCenter ? a.transform.locationToScreenPoint(t.V.convert(a.center)) : i, this._frameId || (this._frameId = !0, this._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const e1 = this._tr.transform;
                if ("number" == typeof this._lastExpectedZoom) {
                    const t = e1.zoom - this._lastExpectedZoom;
                    "number" == typeof this._startZoom && (this._startZoom += t), "number" == typeof this._targetZoom && (this._targetZoom += t);
                }
                if (0 !== this._delta) {
                    const i = "wheel" === this._type && Math.abs(this._delta) > So ? this._wheelZoomRate : this._defaultZoomRate;
                    let a = 2 / (1 + Math.exp(-Math.abs(this._delta * i)));
                    this._delta < 0 && 0 !== a && (a = 1 / a);
                    const r = "number" != typeof this._targetZoom ? e1.scale : t.aq(this._targetZoom);
                    this._targetZoom = e1.applyConstrain(e1.getCameraLngLat(), t.at(r * a)).zoom, "wheel" === this._type && (this._startZoom = e1.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                const i = "number" != typeof this._targetZoom ? e1.zoom : this._targetZoom, a = this._startZoom, r = this._easing;
                let o, s = !1;
                if ("wheel" === this._type && a && r) {
                    const e1 = c() - this._lastWheelEventTime, n = Math.min((e1 + 5) / 200, 1), l = r(n);
                    o = t.G.number(a, i, l), n < 1 ? this._frameId || (this._frameId = !0) : s = !0;
                } else o = i, s = !0;
                return this._active = !0, s && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._lastExpectedZoom, delete this._finishTimeout;
                }, 200)), this._lastExpectedZoom = o, {
                    noInertia: !0,
                    needsRenderFrame: !s,
                    zoomDelta: o - e1.zoom,
                    around: this._aroundPoint,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(e1) {
                let i = t.cx;
                if (this._prevEase) {
                    const e1 = this._prevEase, a = (c() - e1.start) / e1.duration, r = e1.easing(a + .01) - e1.easing(a), o = .27 / Math.sqrt(r * r + 1e-4) * .01, s = Math.sqrt(.0729 - o * o);
                    i = t.cv(o, s, .25, 1);
                }
                return this._prevEase = {
                    start: c(),
                    duration: e1,
                    easing: i
                }, i;
            }
            reset() {
                this._active = !1, this._zooming = !1, delete this._targetZoom, delete this._lastExpectedZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
            }
        }
        class zo {
            constructor(e1, t){
                this._clickZoom = e1, this._tapZoom = t;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class Ao {
            constructor(e1){
                this._tr = new io(e1), this.reset();
            }
            reset() {
                this._active = !1;
            }
            dblclick(e1, t) {
                return e1.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: this._tr.zoom + (e1.shiftKey ? -1 : 1),
                            around: this._tr.unproject(t)
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Lo {
            constructor(){
                this._tap = new so({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
            }
            touchstart(e1, t, i) {
                if (!this._swipePoint) {
                    if (this._tapTime) {
                        const a = t[0], r = e1.timeStamp - this._tapTime < 500, o = this._tapPoint.dist(a) < 30;
                        r && o ? i.length > 0 && (this._swipePoint = a, this._swipeTouch = i[0].identifier) : this.reset();
                    } else this._tap.touchstart(e1, t, i);
                }
            }
            touchmove(e1, t, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const a = t[0], r = a.y - this._swipePoint.y;
                        return this._swipePoint = a, e1.preventDefault(), this._active = !0, {
                            zoomDelta: r / 128
                        };
                    }
                } else this._tap.touchmove(e1, t, i);
            }
            touchend(e1, t, i) {
                if (this._tapTime) this._swipePoint && 0 === i.length && this.reset();
                else {
                    const a = this._tap.touchend(e1, t, i);
                    a && (this._tapTime = e1.timeStamp, this._tapPoint = a);
                }
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class ko {
            constructor(e1, t, i){
                this._el = e1, this._mousePan = t, this._touchPan = i;
            }
            enable(e1) {
                this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class Fo {
            constructor(e1, t, i, a){
                this._pitchWithRotate = e1.pitchWithRotate, this._rollEnabled = e1.rollEnabled, this._mouseRotate = t, this._mousePitch = i, this._mouseRoll = a;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable(), this._rollEnabled && this._mouseRoll.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable(), this._mouseRoll.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled()) && (!this._rollEnabled || this._mouseRoll.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive() || this._mouseRoll.isActive();
            }
        }
        class Bo {
            constructor(e1, t, i, a){
                this._el = e1, this._touchZoom = t, this._touchRotate = i, this._tapDragZoom = a, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(e1) {
                this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        class Oo {
            constructor(e1, t){
                this._bypassKey = -1 !== navigator.userAgent.indexOf("Mac") ? "metaKey" : "ctrlKey", this._map = e1, this._options = t, this._enabled = !1;
            }
            isActive() {
                return !1;
            }
            reset() {}
            _setupUI() {
                if (this._container) return;
                const e1 = this._map.getCanvasContainer();
                e1.classList.add("maplibregl-cooperative-gestures"), this._container = h.create("div", "maplibregl-cooperative-gesture-screen", e1);
                let t = this._map._getUIString("CooperativeGesturesHandler.WindowsHelpText");
                "metaKey" === this._bypassKey && (t = this._map._getUIString("CooperativeGesturesHandler.MacHelpText"));
                const i = this._map._getUIString("CooperativeGesturesHandler.MobileHelpText"), a = document.createElement("div");
                a.className = "maplibregl-desktop-message", a.textContent = t, this._container.appendChild(a);
                const r = document.createElement("div");
                r.className = "maplibregl-mobile-message", r.textContent = i, this._container.appendChild(r), this._container.setAttribute("aria-hidden", "true");
            }
            _destroyUI() {
                this._container && (h.remove(this._container), this._map.getCanvasContainer().classList.remove("maplibregl-cooperative-gestures")), delete this._container;
            }
            enable() {
                this._setupUI(), this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this._destroyUI();
            }
            isEnabled() {
                return this._enabled;
            }
            isBypassed(e1) {
                return e1[this._bypassKey];
            }
            notifyGestureBlocked(e1, i) {
                this._enabled && (this._map.fire(new t.l("cooperativegestureprevented", {
                    gestureType: e1,
                    originalEvent: i
                })), this._container.classList.add("maplibregl-show"), setTimeout(()=>{
                    this._container.classList.remove("maplibregl-show");
                }, 100));
            }
        }
        const jo = (e1)=>e1.zoom || e1.drag || e1.roll || e1.pitch || e1.rotate;
        class No extends t.l {
        }
        function Zo(e1) {
            return e1.panDelta && e1.panDelta.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta || e1.rollDelta;
        }
        class Go {
            constructor(e1, i){
                this.handleWindowEvent = (e1)=>{
                    this.handleEvent(e1, `${e1.type}Window`);
                }, this.handleEvent = (e1, i)=>{
                    if ("blur" === e1.type) return void this.stop(!0);
                    this._updatingCamera = !0;
                    const a = "renderFrame" === e1.type ? void 0 : e1, r = {
                        needsRenderFrame: !1
                    }, o = {}, s = {};
                    for (const { handlerName: n, handler: l, allowed: c } of this._handlers){
                        if (!l.isEnabled()) continue;
                        let u;
                        if (this._blockedByActive(s, c, n)) l.reset();
                        else if (l[i || e1.type]) {
                            if (t.cy(e1, i || e1.type)) {
                                const t = h.mousePos(this._map.getCanvas(), e1);
                                u = l[i || e1.type](e1, t);
                            } else if (t.cz(e1, i || e1.type)) {
                                const t = this._getMapTouches(e1.touches), a = h.touchPos(this._map.getCanvas(), t);
                                u = l[i || e1.type](e1, a, t);
                            } else t.cA(i || e1.type) || (u = l[i || e1.type](e1));
                            this.mergeHandlerResult(r, o, u, n, a), u && u.needsRenderFrame && this._triggerRenderFrame();
                        }
                        (u || l.isActive()) && (s[n] = l);
                    }
                    const n = {};
                    for(const e1 in this._previousActiveHandlers)s[e1] || (n[e1] = a);
                    this._previousActiveHandlers = s, (Object.keys(n).length || Zo(r)) && (this._changes.push([
                        r,
                        o,
                        n
                    ]), this._triggerRenderFrame()), (Object.keys(s).length || Zo(r)) && this._map._stop(!0), this._updatingCamera = !1;
                    const { cameraAnimation: l } = r;
                    l && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], l(this._map));
                }, this._map = e1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Hr(e1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(i);
                const a = this._el;
                this._listeners = [
                    [
                        a,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        a,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        a,
                        "touchend",
                        void 0
                    ],
                    [
                        a,
                        "touchcancel",
                        void 0
                    ],
                    [
                        a,
                        "mousedown",
                        void 0
                    ],
                    [
                        a,
                        "mousemove",
                        void 0
                    ],
                    [
                        a,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        a,
                        "mouseover",
                        void 0
                    ],
                    [
                        a,
                        "mouseout",
                        void 0
                    ],
                    [
                        a,
                        "dblclick",
                        void 0
                    ],
                    [
                        a,
                        "click",
                        void 0
                    ],
                    [
                        a,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        a,
                        "keyup",
                        void 0
                    ],
                    [
                        a,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        a,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e1, t, i] of this._listeners)h.addEventListener(e1, t, e1 === document ? this.handleWindowEvent : this.handleEvent, i);
            }
            destroy() {
                for (const [e1, t, i] of this._listeners)h.removeEventListener(e1, t, e1 === document ? this.handleWindowEvent : this.handleEvent, i);
            }
            _addDefaultHandlers(e1) {
                const i = this._map, a = i.getCanvasContainer();
                this._add("mapEvent", new eo(i, e1));
                const r = i.boxZoom = new ao(i, e1);
                this._add("boxZoom", r), e1.interactive && e1.boxZoom && r.enable();
                const o = i.cooperativeGestures = new Oo(i, e1.cooperativeGestures);
                this._add("cooperativeGestures", o), e1.cooperativeGestures && o.enable();
                const s = new no(i), n = new Ao(i);
                i.doubleClickZoom = new zo(n, s), this._add("tapZoom", s), this._add("clickZoom", n), e1.interactive && e1.doubleClickZoom && i.doubleClickZoom.enable();
                const l = new Lo;
                this._add("tapDragZoom", l);
                const c = i.touchPitch = new Co(i);
                this._add("touchPitch", c), e1.interactive && e1.touchPitch && i.touchPitch.enable(e1.touchPitch);
                const u = ()=>i.project(i.getCenter()), d = function({ enable: e1, clickTolerance: i, aroundCenter: a = !0, minPixelCenterThreshold: r = 100, rotateDegreesPerPixelMoved: o = .8 }, s) {
                    const n = new _o({
                        checkCorrectEvent: (e1)=>0 === h.mouseButton(e1) && e1.ctrlKey || 2 === h.mouseButton(e1) && !e1.ctrlKey
                    });
                    return new lo({
                        clickTolerance: i,
                        move: (e1, i)=>{
                            const n = s();
                            if (a && Math.abs(n.y - e1.y) > r) return {
                                bearingDelta: t.cw(new t.P(e1.x, i.y), i, n)
                            };
                            let l = (i.x - e1.x) * o;
                            return a && i.y < n.y && (l = -l), {
                                bearingDelta: l
                            };
                        },
                        moveStateManager: n,
                        enable: e1,
                        assignEvents: fo
                    });
                }(e1, u), _ = function({ enable: e1, clickTolerance: t, pitchDegreesPerPixelMoved: i = -0.5 }) {
                    const a = new _o({
                        checkCorrectEvent: (e1)=>0 === h.mouseButton(e1) && e1.ctrlKey || 2 === h.mouseButton(e1)
                    });
                    return new lo({
                        clickTolerance: t,
                        move: (e1, t)=>({
                                pitchDelta: (t.y - e1.y) * i
                            }),
                        moveStateManager: a,
                        enable: e1,
                        assignEvents: fo
                    });
                }(e1), p = function({ enable: e1, clickTolerance: t, rollDegreesPerPixelMoved: i = .3 }, a) {
                    const r = new _o({
                        checkCorrectEvent: (e1)=>2 === h.mouseButton(e1) && e1.ctrlKey
                    });
                    return new lo({
                        clickTolerance: t,
                        move: (e1, t)=>{
                            const r = a();
                            let o = (t.x - e1.x) * i;
                            return t.y < r.y && (o = -o), {
                                rollDelta: o
                            };
                        },
                        moveStateManager: r,
                        enable: e1,
                        assignEvents: fo
                    });
                }(e1, u);
                i.dragRotate = new Fo(e1, d, _, p), this._add("mouseRotate", d, [
                    "mousePitch"
                ]), this._add("mousePitch", _, [
                    "mouseRotate",
                    "mouseRoll"
                ]), this._add("mouseRoll", p, [
                    "mousePitch"
                ]), e1.interactive && e1.dragRotate && i.dragRotate.enable();
                const m = function({ enable: e1, clickTolerance: t }) {
                    const i = new _o({
                        checkCorrectEvent: (e1)=>0 === h.mouseButton(e1) && !e1.ctrlKey
                    });
                    return new lo({
                        clickTolerance: t,
                        move: (e1, t)=>({
                                around: t,
                                panDelta: t.sub(e1)
                            }),
                        activateOnStart: !0,
                        moveStateManager: i,
                        enable: e1,
                        assignEvents: fo
                    });
                }(e1), f = new go(e1, i);
                i.dragPan = new ko(a, m, f), this._add("mousePan", m), this._add("touchPan", f, [
                    "touchZoom",
                    "touchRotate"
                ]), e1.interactive && e1.dragPan && i.dragPan.enable(e1.dragPan);
                const g = new To, v = new yo;
                i.touchZoomRotate = new Bo(a, v, g, l), this._add("touchRotate", g, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", v, [
                    "touchPan",
                    "touchRotate"
                ]), e1.interactive && e1.touchZoomRotate && i.touchZoomRotate.enable(e1.touchZoomRotate), this._add("blockableMapEvent", new to(i));
                const x = i.scrollZoom = new Do(i, ()=>this._triggerRenderFrame());
                this._add("scrollZoom", x, [
                    "mousePan"
                ]), e1.interactive && e1.scrollZoom && i.scrollZoom.enable(e1.scrollZoom);
                const b = i.keyboard = new Io(i);
                this._add("keyboard", b), e1.interactive && e1.keyboard && i.keyboard.enable();
            }
            _add(e1, t, i) {
                this._handlers.push({
                    handlerName: e1,
                    handler: t,
                    allowed: i
                }), this._handlersById[e1] = t;
            }
            stop(e1) {
                if (!this._updatingCamera) {
                    for (const { handler: e1 } of this._handlers)e1.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [];
                }
            }
            isActive() {
                for (const { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return Boolean(jo(this._eventsInProgress)) || this.isZooming();
            }
            _blockedByActive(e1, t, i) {
                for(const a in e1)if (a !== i && (!t || t.indexOf(a) < 0)) return !0;
                return !1;
            }
            _getMapTouches(e1) {
                const t = [];
                for (const i of e1)this._el.contains(i.target) && t.push(i);
                return t;
            }
            mergeHandlerResult(e1, i, a, r, o) {
                if (!a) return;
                t.e(e1, a);
                const s = {
                    handlerName: r,
                    originalEvent: a.originalEvent || o
                };
                void 0 !== a.zoomDelta && (i.zoom = s), void 0 !== a.panDelta && (i.drag = s), void 0 !== a.rollDelta && (i.roll = s), void 0 !== a.pitchDelta && (i.pitch = s), void 0 !== a.bearingDelta && (i.rotate = s);
            }
            _applyChanges() {
                const e1 = {}, i = {}, a = {};
                for (const [r, o, s] of this._changes)r.panDelta && (e1.panDelta = (e1.panDelta || new t.P(0, 0))._add(r.panDelta)), r.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + r.pitchDelta), r.rollDelta && (e1.rollDelta = (e1.rollDelta || 0) + r.rollDelta), void 0 !== r.around && (e1.around = r.around), void 0 !== r.pinchAround && (e1.pinchAround = r.pinchAround), r.noInertia && (e1.noInertia = r.noInertia), t.e(i, o), t.e(a, s);
                this._updateMapTransform(e1, i, a), this._changes = [];
            }
            _updateMapTransform(e1, t, i) {
                const a = this._map, r = a._getTransformForUpdate(), o = a.terrain;
                if (!(Zo(e1) || o && this._terrainMovement)) return this._fireEvents(t, i, !0);
                a._stop(!0);
                let { panDelta: s, zoomDelta: n, bearingDelta: l, pitchDelta: c, rollDelta: h, around: u, pinchAround: d } = e1;
                void 0 !== d && (u = d), u = u || a.transform.centerPoint, o && !r.isPointOnMapSurface(u) && (u = r.centerPoint);
                const _ = {
                    panDelta: s,
                    zoomDelta: n,
                    rollDelta: h,
                    pitchDelta: c,
                    bearingDelta: l,
                    around: u
                };
                this._map.cameraHelper.useGlobeControls && !r.isPointOnMapSurface(u) && (u = r.centerPoint);
                const p = u.distSqr(r.centerPoint) < .01 ? r.center : r.screenPointToLocation(s ? u.sub(s) : u);
                this._handleMapControls({
                    terrain: o,
                    tr: r,
                    deltasForHelper: _,
                    preZoomAroundLoc: p,
                    combinedEventsInProgress: t,
                    panDelta: s
                }), a._applyUpdatedTransform(r), this._map._update(), e1.noInertia || this._inertia.record(e1), this._fireEvents(t, i, !0);
            }
            _handleMapControls({ terrain: e1, tr: t, deltasForHelper: i, preZoomAroundLoc: a, combinedEventsInProgress: r, panDelta: o }) {
                const s = this._map.cameraHelper;
                if (s.handleMapControlsRollPitchBearingZoom(i, t), e1) return s.useGlobeControls ? (this._terrainMovement || !r.drag && !r.zoom || (this._terrainMovement = !0, this._map._elevationFreeze = !0), void s.handleMapControlsPan(i, t, a)) : this._terrainMovement || !r.drag && !r.zoom ? void (r.drag && this._terrainMovement && o ? t.setCenter(t.screenPointToLocation(t.centerPoint.sub(o))) : s.handleMapControlsPan(i, t, a)) : (this._terrainMovement = !0, this._map._elevationFreeze = !0, void s.handleMapControlsPan(i, t, a));
                s.handleMapControlsPan(i, t, a);
            }
            _fireEvents(e1, i, a) {
                const r = jo(this._eventsInProgress), o = jo(e1), s = {};
                for(const t in e1){
                    const { originalEvent: i } = e1[t];
                    this._eventsInProgress[t] || (s[`${t}start`] = i), this._eventsInProgress[t] = e1[t];
                }
                !r && o && this._fireEvent("movestart", o.originalEvent);
                for(const e1 in s)this._fireEvent(e1, s[e1]);
                o && this._fireEvent("move", o.originalEvent);
                for(const t in e1){
                    const { originalEvent: i } = e1[t];
                    this._fireEvent(t, i);
                }
                const l = {};
                let c;
                for(const e1 in this._eventsInProgress){
                    const { handlerName: t, originalEvent: a } = this._eventsInProgress[e1];
                    this._handlersById[t].isActive() || (delete this._eventsInProgress[e1], c = i[t] || a, l[`${e1}end`] = c);
                }
                for(const e1 in l)this._fireEvent(e1, l[e1]);
                const h = jo(this._eventsInProgress), u = (r || o) && !h;
                if (u && this._terrainMovement) {
                    this._map._elevationFreeze = !1, this._terrainMovement = !1;
                    const e1 = this._map._getTransformForUpdate();
                    this._map.getCenterClampedToGround() && e1.recalculateZoomAndCenter(this._map.terrain), this._map._applyUpdatedTransform(e1);
                }
                if (a && u) {
                    this._updatingCamera = !0;
                    const e1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e1)=>0 !== e1 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
                    !e1 || !e1.essential && n.prefersReducedMotion ? (this._map.fire(new t.l("moveend", {
                        originalEvent: c
                    })), i(this._map.getBearing()) && this._map.resetNorth()) : (i(e1.bearing || this._map.getBearing()) && (e1.bearing = 0), e1.freezeElevation = !0, this._map.easeTo(e1, {
                        originalEvent: c
                    })), this._updatingCamera = !1;
                }
            }
            _fireEvent(e1, i) {
                this._map.fire(new t.l(e1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
                    delete this._frameId, this.handleEvent(new No("renderFrame", {
                        timeStamp: e1
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        class Uo extends t.E {
            constructor(e1, t, i){
                super(), this._renderFrameCallback = ()=>{
                    const e1 = Math.min((c() - this._easeStart) / this._easeOptions.duration, 1);
                    this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                }, this._moving = !1, this._zooming = !1, this.transform = e1, this._bearingSnap = i.bearingSnap, this.cameraHelper = t, this.on("moveend", ()=>{
                    delete this._requestedCameraState;
                });
            }
            migrateProjection(e1, t) {
                e1.apply(this.transform), this.transform = e1, this.cameraHelper = t;
            }
            getCenter() {
                return new t.V(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e1, t) {
                return this.jumpTo({
                    center: e1
                }, t);
            }
            getCenterElevation() {
                return this.transform.elevation;
            }
            setCenterElevation(e1, t) {
                return this.jumpTo({
                    elevation: e1
                }, t), this;
            }
            getCenterClampedToGround() {
                return this._centerClampedToGround;
            }
            setCenterClampedToGround(e1) {
                this._centerClampedToGround = e1;
            }
            panBy(e1, i, a) {
                return e1 = t.P.convert(e1).mult(-1), this.panTo(this.transform.center, t.e({
                    offset: e1
                }, i), a);
            }
            panTo(e1, i, a) {
                return this.easeTo(t.e({
                    center: e1
                }, i), a);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e1, t) {
                return this.jumpTo({
                    zoom: e1
                }, t), this;
            }
            zoomTo(e1, i, a) {
                return this.easeTo(t.e({
                    zoom: e1
                }, i), a);
            }
            zoomIn(e1, t) {
                return this.zoomTo(this.getZoom() + 1, e1, t), this;
            }
            zoomOut(e1, t) {
                return this.zoomTo(this.getZoom() - 1, e1, t), this;
            }
            getVerticalFieldOfView() {
                return this.transform.fov;
            }
            setVerticalFieldOfView(e1, i) {
                return e1 != this.transform.fov && (this.transform.setFov(e1), this.fire(new t.l("movestart", i)).fire(new t.l("move", i)).fire(new t.l("moveend", i))), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e1, t) {
                return this.jumpTo({
                    bearing: e1
                }, t), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e1, t) {
                return this.jumpTo({
                    padding: e1
                }, t), this;
            }
            rotateTo(e1, i, a) {
                return this.easeTo(t.e({
                    bearing: e1
                }, i), a);
            }
            resetNorth(e1, i) {
                return this.rotateTo(0, t.e({
                    duration: 1e3
                }, e1), i), this;
            }
            resetNorthPitch(e1, i) {
                return this.easeTo(t.e({
                    bearing: 0,
                    pitch: 0,
                    roll: 0,
                    duration: 1e3
                }, e1), i), this;
            }
            snapToNorth(e1, t) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e1, t) {
                return this.jumpTo({
                    pitch: e1
                }, t), this;
            }
            getRoll() {
                return this.transform.roll;
            }
            setRoll(e1, t) {
                return this.jumpTo({
                    roll: e1
                }, t), this;
            }
            cameraForBounds(e1, t) {
                e1 = $.convert(e1).adjustAntiMeridian();
                const i = t && t.bearing || 0;
                return this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), i, t);
            }
            _cameraForBoxAndBearing(e1, i, a, r) {
                const o = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (r = t.e({
                    padding: o,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, r)).padding) {
                    const e1 = r.padding;
                    r.padding = {
                        top: e1,
                        bottom: e1,
                        right: e1,
                        left: e1
                    };
                }
                const s = t.e(o, r.padding);
                r.padding = s;
                const n = this.transform, l = new $(e1, i);
                return this.cameraHelper.cameraForBoxAndBearing(r, s, l, a, n);
            }
            fitBounds(e1, t, i) {
                return this._fitInternal(this.cameraForBounds(e1, t), t, i);
            }
            fitScreenCoordinates(e1, i, a, r, o) {
                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.screenPointToLocation(t.P.convert(e1)), this.transform.screenPointToLocation(t.P.convert(i)), a, r), r, o);
            }
            _fitInternal(e1, i, a) {
                return e1 ? (delete (i = t.e(e1, i)).padding, i.linear ? this.easeTo(i, a) : this.flyTo(i, a)) : this;
            }
            jumpTo(e1, i) {
                this.stop();
                const a = this._getTransformForUpdate();
                let r = !1, o = !1, s = !1;
                const n = a.zoom;
                this.cameraHelper.handleJumpToCenterZoom(a, e1);
                const l = a.zoom !== n;
                return "elevation" in e1 && a.elevation !== +e1.elevation && a.setElevation(+e1.elevation), "bearing" in e1 && a.bearing !== +e1.bearing && (r = !0, a.setBearing(+e1.bearing)), "pitch" in e1 && a.pitch !== +e1.pitch && (o = !0, a.setPitch(+e1.pitch)), "roll" in e1 && a.roll !== +e1.roll && (s = !0, a.setRoll(+e1.roll)), null == e1.padding || a.isPaddingEqual(e1.padding) || a.setPadding(e1.padding), this._applyUpdatedTransform(a), this.fire(new t.l("movestart", i)).fire(new t.l("move", i)), l && this.fire(new t.l("zoomstart", i)).fire(new t.l("zoom", i)).fire(new t.l("zoomend", i)), r && this.fire(new t.l("rotatestart", i)).fire(new t.l("rotate", i)).fire(new t.l("rotateend", i)), o && this.fire(new t.l("pitchstart", i)).fire(new t.l("pitch", i)).fire(new t.l("pitchend", i)), s && this.fire(new t.l("rollstart", i)).fire(new t.l("roll", i)).fire(new t.l("rollend", i)), this.fire(new t.l("moveend", i));
            }
            calculateCameraOptionsFromTo(e1, i, a, r = 0) {
                const o = t.aa.fromLngLat(e1, i), s = t.aa.fromLngLat(a, r), n = s.x - o.x, l = s.y - o.y, c = s.z - o.z, h = Math.hypot(n, l, c);
                if (0 === h) throw new Error("Can't calculate camera options with same From and To");
                const u = Math.hypot(n, l), d = t.at(this.transform.cameraToCenterDistance / h / this.transform.tileSize), _ = 180 * Math.atan2(n, -l) / Math.PI;
                let p = 180 * Math.acos(u / h) / Math.PI;
                return p = c < 0 ? 90 - p : 90 + p, {
                    center: s.toLngLat(),
                    elevation: r,
                    zoom: d,
                    pitch: p,
                    bearing: _
                };
            }
            calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, i, a, r) {
                const o = this.transform.calculateCenterFromCameraLngLatAlt(e1, t, i, a);
                return {
                    center: o.center,
                    elevation: o.elevation,
                    zoom: o.zoom,
                    bearing: i,
                    pitch: a,
                    roll: r
                };
            }
            easeTo(e1, i) {
                this._stop(!1, e1.easeId), (!1 === (e1 = t.e({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: t.cx
                }, e1)).animate || !e1.essential && n.prefersReducedMotion) && (e1.duration = 0);
                const a = this._getTransformForUpdate(), r = this.getBearing(), o = a.pitch, s = a.roll, l = "bearing" in e1 ? this._normalizeBearing(e1.bearing, r) : r, c = "pitch" in e1 ? +e1.pitch : o, h = "roll" in e1 ? this._normalizeBearing(e1.roll, s) : s, u = "padding" in e1 ? e1.padding : a.padding, d = t.P.convert(e1.offset);
                let _, p;
                e1.around && (_ = t.V.convert(e1.around), p = a.locationToScreenPoint(_));
                const m = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching,
                    rolling: this._rolling
                }, f = this.cameraHelper.handleEaseTo(a, {
                    bearing: l,
                    pitch: c,
                    roll: h,
                    padding: u,
                    around: _,
                    aroundPoint: p,
                    offsetAsPoint: d,
                    offset: e1.offset,
                    zoom: e1.zoom,
                    center: e1.center
                });
                return this._rotating = this._rotating || r !== l, this._pitching = this._pitching || c !== o, this._rolling = this._rolling || h !== s, this._padding = !a.isPaddingEqual(u), this._zooming = this._zooming || f.isZooming, this._easeId = e1.easeId, this._prepareEase(i, e1.noMoveStart, m), this.terrain && this._prepareElevation(f.elevationCenter), this._ease((t)=>{
                    f.easeFunc(t), this.terrain && !e1.freezeElevation && this._updateElevation(t), this._applyUpdatedTransform(a), this._fireMoveEvents(i);
                }, (t)=>{
                    this.terrain && e1.freezeElevation && this._finalizeElevation(), this._afterEase(i, t);
                }, e1), this;
            }
            _prepareEase(e1, i, a = {}) {
                this._moving = !0, i || a.moving || this.fire(new t.l("movestart", e1)), this._zooming && !a.zooming && this.fire(new t.l("zoomstart", e1)), this._rotating && !a.rotating && this.fire(new t.l("rotatestart", e1)), this._pitching && !a.pitching && this.fire(new t.l("pitchstart", e1)), this._rolling && !a.rolling && this.fire(new t.l("rollstart", e1));
            }
            _prepareElevation(e1) {
                this._elevationCenter = e1, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(e1, this.transform.tileZoom), this._elevationFreeze = !0;
            }
            _updateElevation(e1) {
                void 0 !== this._elevationStart && void 0 !== this._elevationCenter || this._prepareElevation(this.transform.center), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom));
                const i = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                if (e1 < 1 && i !== this._elevationTarget) {
                    const t = this._elevationTarget - this._elevationStart;
                    this._elevationStart += e1 * (t - (i - (t * e1 + this._elevationStart)) / (1 - e1)), this._elevationTarget = i;
                }
                this.transform.setElevation(t.G.number(this._elevationStart, this._elevationTarget, e1));
            }
            _finalizeElevation() {
                this._elevationFreeze = !1, this.getCenterClampedToGround() && this.transform.recalculateZoomAndCenter(this.terrain);
            }
            _getTransformForUpdate() {
                return this.transformCameraUpdate || this.terrain ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
            }
            _elevateCameraIfInsideTerrain(e1) {
                if (!this.terrain && e1.elevation >= 0 && e1.pitch <= 90) return {};
                const t = e1.getCameraLngLat(), i = e1.getCameraAltitude(), a = this.terrain ? this.terrain.getElevationForLngLatZoom(t, e1.zoom) : 0;
                if (i < a) {
                    const i = this.calculateCameraOptionsFromTo(t, a, e1.center, e1.elevation);
                    return {
                        pitch: i.pitch,
                        zoom: i.zoom
                    };
                }
                return {};
            }
            _applyUpdatedTransform(e1) {
                const t = [];
                if (t.push((e1)=>this._elevateCameraIfInsideTerrain(e1)), this.transformCameraUpdate && t.push((e1)=>this.transformCameraUpdate(e1)), !t.length) return;
                const i = e1.clone();
                for (const e1 of t){
                    const t = i.clone(), { center: a, zoom: r, roll: o, pitch: s, bearing: n, elevation: l } = e1(t);
                    a && t.setCenter(a), void 0 !== l && t.setElevation(l), void 0 !== r && t.setZoom(r), void 0 !== o && t.setRoll(o), void 0 !== s && t.setPitch(s), void 0 !== n && t.setBearing(n), i.apply(t);
                }
                this.transform.apply(i);
            }
            _fireMoveEvents(e1) {
                this.fire(new t.l("move", e1)), this._zooming && this.fire(new t.l("zoom", e1)), this._rotating && this.fire(new t.l("rotate", e1)), this._pitching && this.fire(new t.l("pitch", e1)), this._rolling && this.fire(new t.l("roll", e1));
            }
            _afterEase(e1, i) {
                if (this._easeId && i && this._easeId === i) return;
                delete this._easeId;
                const a = this._zooming, r = this._rotating, o = this._pitching, s = this._rolling;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._rolling = !1, this._padding = !1, a && this.fire(new t.l("zoomend", e1)), r && this.fire(new t.l("rotateend", e1)), o && this.fire(new t.l("pitchend", e1)), s && this.fire(new t.l("rollend", e1)), this.fire(new t.l("moveend", e1));
            }
            flyTo(e1, i) {
                if (!e1.essential && n.prefersReducedMotion) {
                    const a = t.U(e1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "roll",
                        "elevation",
                        "padding"
                    ]);
                    return this.jumpTo(a, i);
                }
                this.stop(), e1 = t.e({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: t.cx
                }, e1);
                const a = this._getTransformForUpdate(), r = a.bearing, o = a.pitch, s = a.roll, l = a.padding, c = "bearing" in e1 ? this._normalizeBearing(e1.bearing, r) : r, h = "pitch" in e1 ? +e1.pitch : o, u = "roll" in e1 ? this._normalizeBearing(e1.roll, s) : s, d = "padding" in e1 ? e1.padding : a.padding, _ = t.P.convert(e1.offset);
                let p = a.centerPoint.add(_);
                const m = a.screenPointToLocation(p), f = this.cameraHelper.handleFlyTo(a, {
                    bearing: c,
                    pitch: h,
                    roll: u,
                    padding: d,
                    locationAtOffset: m,
                    offsetAsPoint: _,
                    center: e1.center,
                    minZoom: e1.minZoom,
                    zoom: e1.zoom
                });
                let g = e1.curve;
                const v = Math.max(a.width, a.height), x = v / f.scaleOfZoom, b = f.pixelPathLength;
                "number" == typeof f.scaleOfMinZoom && (g = Math.sqrt(v / f.scaleOfMinZoom / b * 2));
                const y = g * g;
                function w(e1) {
                    const t = (x * x - v * v + (e1 ? -1 : 1) * y * y * b * b) / (2 * (e1 ? x : v) * y * b);
                    return Math.log(Math.sqrt(t * t + 1) - t);
                }
                function T(e1) {
                    return (Math.exp(e1) - Math.exp(-e1)) / 2;
                }
                function P(e1) {
                    return (Math.exp(e1) + Math.exp(-e1)) / 2;
                }
                const C = w(!1);
                let M = function(e1) {
                    return P(C) / P(C + g * e1);
                }, I = function(e1) {
                    var t;
                    return v * ((P(C) * (T(t = C + g * e1) / P(t)) - T(C)) / y) / b;
                }, E = (w(!0) - C) / g;
                if (Math.abs(b) < 2e-6 || !isFinite(E)) {
                    if (Math.abs(v - x) < 1e-6) return this.easeTo(e1, i);
                    const t = x < v ? -1 : 1;
                    E = Math.abs(Math.log(x / v)) / g, I = ()=>0, M = (e1)=>Math.exp(t * g * e1);
                }
                return e1.duration = "duration" in e1 ? +e1.duration : 1e3 * E / ("screenSpeed" in e1 ? +e1.screenSpeed / g : +e1.speed), e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = r !== c, this._pitching = h !== o, this._rolling = u !== s, this._padding = !a.isPaddingEqual(d), this._prepareEase(i, !1), this.terrain && this._prepareElevation(f.targetCenter), this._ease((n)=>{
                    const m = n * E, g = 1 / M(m), v = I(m);
                    this._rotating && a.setBearing(t.G.number(r, c, n)), this._pitching && a.setPitch(t.G.number(o, h, n)), this._rolling && a.setRoll(t.G.number(s, u, n)), this._padding && (a.interpolatePadding(l, d, n), p = a.centerPoint.add(_)), f.easeFunc(n, g, v, p), this.terrain && !e1.freezeElevation && this._updateElevation(n), this._applyUpdatedTransform(a), this._fireMoveEvents(i);
                }, ()=>{
                    this.terrain && e1.freezeElevation && this._finalizeElevation(), this._afterEase(i);
                }, e1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(e1, t) {
                var i;
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                    const e1 = this._onEaseEnd;
                    delete this._onEaseEnd, e1.call(this, t);
                }
                return e1 || null === (i = this.handlers) || void 0 === i || i.stop(!1), this;
            }
            _ease(e1, t, i) {
                !1 === i.animate || 0 === i.duration ? (e1(1), t()) : (this._easeStart = c(), this._easeOptions = i, this._onEaseFrame = e1, this._onEaseEnd = t, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _normalizeBearing(e1, i) {
                e1 = t.W(e1, -180, 180);
                const a = Math.abs(e1 - i);
                return Math.abs(e1 - 360 - i) < a && (e1 -= 360), Math.abs(e1 + 360 - i) < a && (e1 += 360), e1;
            }
            queryTerrainElevation(e1) {
                return this.terrain ? this.terrain.getElevationForLngLatZoom(t.V.convert(e1), this.transform.tileZoom) : null;
            }
        }
        const Vo = {
            compact: !0,
            customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>'
        };
        class qo {
            constructor(e1 = Vo){
                this._toggleAttribution = ()=>{
                    this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
                }, this._updateData = (e1)=>{
                    !e1 || "metadata" !== e1.sourceDataType && "visibility" !== e1.sourceDataType && "style" !== e1.dataType && "terrain" !== e1.type || this._updateAttributions();
                }, this._updateCompact = ()=>{
                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
                }, this._updateCompactMinimize = ()=>{
                    this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
                }, this.options = e1;
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e1) {
                return this._map = e1, this._compact = this.options.compact, this._container = h.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = h.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = h.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
            }
            onRemove() {
                h.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(e1, t) {
                const i = this._map._getUIString(`AttributionControl.${t}`);
                e1.title = i, e1.setAttribute("aria-label", i);
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e1 = [];
                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = e1.concat(this.options.customAttribution.map((e1)=>"string" != typeof e1 ? "" : e1)) : "string" == typeof this.options.customAttribution && e1.push(this.options.customAttribution)), this._map.style.stylesheet) {
                    const e1 = this._map.style.stylesheet;
                    this.styleOwner = e1.owner, this.styleId = e1.id;
                }
                const t = this._map.style.tileManagers;
                for(const i in t){
                    const a = t[i];
                    if (a.used || a.usedForTerrain) {
                        const t = a.getSource();
                        t.attribution && e1.indexOf(t.attribution) < 0 && e1.push(t.attribution);
                    }
                }
                e1 = e1.filter((e1)=>String(e1).trim()), e1.sort((e1, t)=>e1.length - t.length), e1 = e1.filter((t, i)=>{
                    for(let a = i + 1; a < e1.length; a++)if (e1[a].indexOf(t) >= 0) return !1;
                    return !0;
                });
                const i = e1.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e1.length ? (this._innerContainer.innerHTML = h.sanitize(i), this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
            }
        }
        class Wo {
            constructor(e1 = {}){
                this._updateCompact = ()=>{
                    const e1 = this._container.children;
                    if (e1.length) {
                        const t = e1[0];
                        this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && t.classList.add("maplibregl-compact") : t.classList.remove("maplibregl-compact");
                    }
                }, this.options = e1;
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(e1) {
                this._map = e1, this._compact = this.options && this.options.compact, this._container = h.create("div", "maplibregl-ctrl");
                const t = h.create("a", "maplibregl-ctrl-logo");
                return t.target = "_blank", t.rel = "noopener nofollow", t.href = "https://maplibre.org/", t.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                h.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
            }
        }
        class $o {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(e1) {
                const t = ++this._id;
                return this._queue.push({
                    callback: e1,
                    id: t,
                    cancelled: !1
                }), t;
            }
            remove(e1) {
                const t = this._currentlyRunning, i = t ? this._queue.concat(t) : this._queue;
                for (const t of i)if (t.id === e1) return void (t.cancelled = !0);
            }
            run(e1 = 0) {
                if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                const t = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t)if (!i.cancelled && (i.callback(e1), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        var Ho = t.aT([
            {
                name: "a_pos3d",
                type: "Int16",
                components: 3
            }
        ]);
        class Xo extends t.E {
            constructor(e1){
                super(), this._lastTilesetChange = c(), this.tileManager = e1, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.deltaZoom = 1, this.tileSize = e1._source.tileSize * 2 ** this.deltaZoom, e1.usedForTerrain = !0, e1.tileSize = this.tileSize;
            }
            destruct() {
                this.tileManager.usedForTerrain = !1, this.tileManager.tileSize = null;
            }
            getSource() {
                return this.tileManager._source;
            }
            update(e1, i) {
                this.tileManager.update(e1, i), this._renderableTilesKeys = [];
                const a = {};
                for (const r of Ce(e1, {
                    tileSize: this.tileSize,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    reparseOverscaled: !1,
                    terrain: i,
                    calculateTileZoom: this.tileManager._source.calculateTileZoom
                }))a[r.key] = !0, this._renderableTilesKeys.push(r.key), this._tiles[r.key] || (r.terrainRttPosMatrix32f = new Float64Array(16), t.c6(r.terrainRttPosMatrix32f, 0, t.a4, t.a4, 0, 0, 1), this._tiles[r.key] = new de(r, this.tileSize), this._lastTilesetChange = c());
                for(const e1 in this._tiles)a[e1] || delete this._tiles[e1];
            }
            freeRtt(e1) {
                for(const t in this._tiles){
                    const i = this._tiles[t];
                    (!e1 || i.tileID.equals(e1) || i.tileID.isChildOf(e1) || e1.isChildOf(i.tileID)) && (i.rtt = []);
                }
            }
            getRenderableTiles() {
                return this._renderableTilesKeys.map((e1)=>this.getTileByID(e1));
            }
            getTileByID(e1) {
                return this._tiles[e1];
            }
            getTerrainCoords(e1, t) {
                return t ? this._getTerrainCoordsForTileRanges(e1, t) : this._getTerrainCoordsForRegularTile(e1);
            }
            _getTerrainCoordsForRegularTile(e1) {
                const i = {};
                for (const a of this._renderableTilesKeys){
                    const r = this._tiles[a].tileID, o = e1.clone(), s = t.bj();
                    if (r.canonical.equals(e1.canonical)) t.c6(s, 0, t.a4, t.a4, 0, 0, 1);
                    else if (r.canonical.isChildOf(e1.canonical)) {
                        const i = r.canonical.z - e1.canonical.z, a = r.canonical.x - (r.canonical.x >> i << i), o = r.canonical.y - (r.canonical.y >> i << i), n = t.a4 >> i;
                        t.c6(s, 0, n, n, 0, 0, 1), t.O(s, s, [
                            -a * n,
                            -o * n,
                            0
                        ]);
                    } else {
                        if (!e1.canonical.isChildOf(r.canonical)) continue;
                        {
                            const i = e1.canonical.z - r.canonical.z, a = e1.canonical.x - (e1.canonical.x >> i << i), o = e1.canonical.y - (e1.canonical.y >> i << i), n = t.a4 >> i;
                            t.c6(s, 0, t.a4, t.a4, 0, 0, 1), t.O(s, s, [
                                a * n,
                                o * n,
                                0
                            ]), t.Q(s, s, [
                                1 / 2 ** i,
                                1 / 2 ** i,
                                0
                            ]);
                        }
                    }
                    o.terrainRttPosMatrix32f = new Float32Array(s), i[a] = o;
                }
                return i;
            }
            _getTerrainCoordsForTileRanges(e1, i) {
                const a = {};
                for (const r of this._renderableTilesKeys){
                    const o = this._tiles[r].tileID;
                    if (!this._isWithinTileRanges(o, i)) continue;
                    const s = e1.clone(), n = t.bj();
                    if (o.canonical.z === e1.canonical.z) {
                        const i = e1.canonical.x - o.canonical.x, a = e1.canonical.y - o.canonical.y;
                        t.c6(n, 0, t.a4, t.a4, 0, 0, 1), t.O(n, n, [
                            i * t.a4,
                            a * t.a4,
                            0
                        ]);
                    } else if (o.canonical.z > e1.canonical.z) {
                        const i = o.canonical.z - e1.canonical.z, a = o.canonical.x - (o.canonical.x >> i << i), r = o.canonical.y - (o.canonical.y >> i << i), s = e1.canonical.x - (o.canonical.x >> i), l = e1.canonical.y - (o.canonical.y >> i), c = t.a4 >> i;
                        t.c6(n, 0, c, c, 0, 0, 1), t.O(n, n, [
                            -a * c + s * t.a4,
                            -r * c + l * t.a4,
                            0
                        ]);
                    } else {
                        const i = e1.canonical.z - o.canonical.z, a = e1.canonical.x - (e1.canonical.x >> i << i), r = e1.canonical.y - (e1.canonical.y >> i << i), s = (e1.canonical.x >> i) - o.canonical.x, l = (e1.canonical.y >> i) - o.canonical.y, c = t.a4 << i;
                        t.c6(n, 0, c, c, 0, 0, 1), t.O(n, n, [
                            a * t.a4 + s * c,
                            r * t.a4 + l * c,
                            0
                        ]);
                    }
                    s.terrainRttPosMatrix32f = new Float32Array(n), a[r] = s;
                }
                return a;
            }
            getSourceTile(e1, t) {
                const i = this.tileManager._source;
                let a = e1.overscaledZ - this.deltaZoom;
                if (a > i.maxzoom && (a = i.maxzoom), a < i.minzoom) return null;
                this._sourceTileCache[e1.key] || (this._sourceTileCache[e1.key] = e1.scaledTo(a).key);
                let r = this.tileManager.getTileByID(this._sourceTileCache[e1.key]);
                if ((!r || !r.dem) && t) for(; a >= i.minzoom && (!r || !r.dem);)r = this.tileManager.getTileByID(e1.scaledTo(a--).key);
                return r;
            }
            anyTilesAfterTime(e1 = Date.now()) {
                return this._lastTilesetChange >= e1;
            }
            _isWithinTileRanges(e1, t) {
                return t[e1.canonical.z] && e1.canonical.x >= t[e1.canonical.z].minTileX && e1.canonical.x <= t[e1.canonical.z].maxTileX && e1.canonical.y >= t[e1.canonical.z].minTileY && e1.canonical.y <= t[e1.canonical.z].maxTileY;
            }
        }
        class Ko {
            constructor(e1, t, i){
                this._meshCache = {}, this.painter = e1, this.tileManager = new Xo(t), this.options = i, this.exaggeration = "number" == typeof i.exaggeration ? i.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
            }
            getDEMElevation(e1, i, a, r = t.a4) {
                var o;
                if (!(i >= 0 && i < r && a >= 0 && a < r)) return 0;
                const s = this.getTerrainData(e1), n = null === (o = s.tile) || void 0 === o ? void 0 : o.dem;
                if (!n) return 0;
                const l = t.cB([], [
                    i / r * t.a4,
                    a / r * t.a4
                ], s.u_terrain_matrix), c = [
                    l[0] * n.dim,
                    l[1] * n.dim
                ], h = Math.floor(c[0]), u = Math.floor(c[1]), d = c[0] - h, _ = c[1] - u;
                return n.get(h, u) * (1 - d) * (1 - _) + n.get(h + 1, u) * d * (1 - _) + n.get(h, u + 1) * (1 - d) * _ + n.get(h + 1, u + 1) * d * _;
            }
            getElevationForLngLatZoom(e1, i) {
                if (!t.cC(i, e1.wrap())) return 0;
                const { tileID: a, mercatorX: r, mercatorY: o } = this._getOverscaledTileIDFromLngLatZoom(e1, i);
                return this.getElevation(a, r % t.a4, o % t.a4, t.a4);
            }
            getElevation(e1, i, a, r = t.a4) {
                return this.getDEMElevation(e1, i, a, r) * this.exaggeration;
            }
            getTerrainData(e1) {
                if (!this._emptyDemTexture) {
                    const e1 = this.painter.context, i = new t.R({
                        width: 1,
                        height: 1
                    }, new Uint8Array(4));
                    this._emptyDepthTexture = new t.T(e1, i, e1.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemUnpack = [
                        0,
                        0,
                        0,
                        0
                    ], this._emptyDemTexture = new t.T(e1, new t.R({
                        width: 1,
                        height: 1
                    }), e1.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = t.ar([]);
                }
                const i = this.tileManager.getSourceTile(e1, !0);
                if (i && i.dem && (!i.demTexture || i.needsTerrainPrepare)) {
                    const e1 = this.painter.context;
                    i.demTexture = this.painter.getTileTexture(i.dem.stride), i.demTexture ? i.demTexture.update(i.dem.getPixels(), {
                        premultiply: !1
                    }) : i.demTexture = new t.T(e1, i.dem.getPixels(), e1.gl.RGBA, {
                        premultiply: !1
                    }), i.demTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), i.needsTerrainPrepare = !1;
                }
                const a = i && i + i.tileID.key + e1.key;
                if (a && !this._demMatrixCache[a]) {
                    const a = this.tileManager.getSource().maxzoom;
                    let r = e1.canonical.z - i.tileID.canonical.z;
                    e1.overscaledZ > e1.canonical.z && (e1.canonical.z >= a ? r = e1.canonical.z - a : t.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                    const o = e1.canonical.x - (e1.canonical.x >> r << r), s = e1.canonical.y - (e1.canonical.y >> r << r), n = t.cD(new Float64Array(16), [
                        1 / (t.a4 << r),
                        1 / (t.a4 << r),
                        0
                    ]);
                    t.O(n, n, [
                        o * t.a4,
                        s * t.a4,
                        0
                    ]), this._demMatrixCache[e1.key] = {
                        matrix: n,
                        coord: e1
                    };
                }
                return {
                    u_depth: 2,
                    u_terrain: 3,
                    u_terrain_dim: i && i.dem && i.dem.dim || 1,
                    u_terrain_matrix: a ? this._demMatrixCache[e1.key].matrix : this._emptyDemMatrix,
                    u_terrain_unpack: i && i.dem && i.dem.getUnpackVector() || this._emptyDemUnpack,
                    u_terrain_exaggeration: this.exaggeration,
                    texture: (i && i.demTexture || this._emptyDemTexture).texture,
                    depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                    tile: i
                };
            }
            getFramebuffer(e1) {
                const i = this.painter, a = i.width / devicePixelRatio, r = i.height / devicePixelRatio;
                return !this._fbo || this._fbo.width === a && this._fbo.height === r || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new t.T(i.context, {
                    width: a,
                    height: r,
                    data: null
                }, i.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboCoordsTexture.bind(i.context.gl.NEAREST, i.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new t.T(i.context, {
                    width: a,
                    height: r,
                    data: null
                }, i.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboDepthTexture.bind(i.context.gl.NEAREST, i.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = i.context.createFramebuffer(a, r, !0, !1), this._fbo.depthAttachment.set(i.context.createRenderbuffer(i.context.gl.DEPTH_COMPONENT16, a, r))), this._fbo.colorAttachment.set("coords" === e1 ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
            }
            getCoordsTexture() {
                const e1 = this.painter.context;
                if (this._coordsTexture) return this._coordsTexture;
                const i = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                for(let e1 = 0, t = 0; e1 < this._coordsTextureSize; e1++)for(let a = 0; a < this._coordsTextureSize; a++, t += 4)i[t + 0] = 255 & a, i[t + 1] = 255 & e1, i[t + 2] = a >> 8 << 4 | e1 >> 8, i[t + 3] = 0;
                const a = new t.R({
                    width: this._coordsTextureSize,
                    height: this._coordsTextureSize
                }, new Uint8Array(i.buffer)), r = new t.T(e1, a, e1.gl.RGBA, {
                    premultiply: !1
                });
                return r.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._coordsTexture = r, r;
            }
            pointCoordinate(e1) {
                this.painter.maybeDrawDepthAndCoords(!0);
                const i = new Uint8Array(4), a = this.painter.context, r = a.gl, o = Math.round(e1.x * this.painter.pixelRatio / devicePixelRatio), s = Math.round(e1.y * this.painter.pixelRatio / devicePixelRatio), n = Math.round(this.painter.height / devicePixelRatio);
                a.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), r.readPixels(o, n - s - 1, 1, 1, r.RGBA, r.UNSIGNED_BYTE, i), a.bindFramebuffer.set(null);
                const l = i[0] + (i[2] >> 4 << 8), c = i[1] + ((15 & i[2]) << 8), h = this.coordsIndex[255 - i[3]], u = h && this.tileManager.getTileByID(h);
                if (!u) return null;
                const d = this._coordsTextureSize, _ = (1 << u.tileID.canonical.z) * d;
                return new t.aa((u.tileID.canonical.x * d + l) / _ + u.tileID.wrap, (u.tileID.canonical.y * d + c) / _, this.getElevation(u.tileID, l, c, d));
            }
            depthAtPoint(e1) {
                const t = new Uint8Array(4), i = this.painter.context, a = i.gl;
                return i.bindFramebuffer.set(this.getFramebuffer("depth").framebuffer), a.readPixels(e1.x, this.painter.height / devicePixelRatio - e1.y - 1, 1, 1, a.RGBA, a.UNSIGNED_BYTE, t), i.bindFramebuffer.set(null), (t[0] / 16777216 + t[1] / 65536 + t[2] / 256 + t[3]) / 256;
            }
            getTerrainMesh(e1) {
                var i;
                const a = (null === (i = this.painter.style.projection) || void 0 === i ? void 0 : i.transitionState) > 0, r = a && 0 === e1.canonical.y, o = a && e1.canonical.y === (1 << e1.canonical.z) - 1, s = `m_${r ? "n" : ""}_${o ? "s" : ""}`;
                if (this._meshCache[s]) return this._meshCache[s];
                const n = this.painter.context, l = new t.cE, c = new t.aX, h = this.meshSize, u = t.a4 / h, d = h * h;
                for(let e1 = 0; e1 <= h; e1++)for(let t = 0; t <= h; t++)l.emplaceBack(t * u, e1 * u, 0);
                for(let e1 = 0; e1 < d; e1 += h + 1)for(let t = 0; t < h; t++)c.emplaceBack(t + e1, h + t + e1 + 1, h + t + e1 + 2), c.emplaceBack(t + e1, h + t + e1 + 2, t + e1 + 1);
                const _ = l.length, p = _ + (h + 1), m = (h + 1) * h, f = r ? t.bq : 0, g = r ? 0 : 1, v = o ? t.br : t.a4, x = o ? 0 : 1;
                for(let e1 = 0; e1 <= h; e1++)l.emplaceBack(e1 * u, f, g);
                for(let e1 = 0; e1 <= h; e1++)l.emplaceBack(e1 * u, v, x);
                for(let e1 = 0; e1 < h; e1++)c.emplaceBack(m + e1, p + e1, p + e1 + 1), c.emplaceBack(m + e1, p + e1 + 1, m + e1 + 1), c.emplaceBack(0 + e1, _ + e1 + 1, _ + e1), c.emplaceBack(0 + e1, 0 + e1 + 1, _ + e1 + 1);
                const b = l.length, y = b + 2 * (h + 1);
                for (const e1 of [
                    0,
                    1
                ])for(let i = 0; i <= h; i++)for (const a of [
                    0,
                    1
                ])l.emplaceBack(e1 * t.a4, i * u, a);
                for(let e1 = 0; e1 < 2 * h; e1 += 2)c.emplaceBack(b + e1, b + e1 + 1, b + e1 + 3), c.emplaceBack(b + e1, b + e1 + 3, b + e1 + 2), c.emplaceBack(y + e1, y + e1 + 3, y + e1 + 1), c.emplaceBack(y + e1, y + e1 + 2, y + e1 + 3);
                const w = new St(n.createVertexBuffer(l, Ho.members), n.createIndexBuffer(c), t.aW.simpleSegment(0, 0, l.length, c.length));
                return this._meshCache[s] = w, w;
            }
            getMeshFrameDelta(e1) {
                return 2 * Math.PI * t.bD / Math.pow(2, Math.max(e1, 0)) / 5;
            }
            getMinTileElevationForLngLatZoom(e1, t) {
                var i;
                const { tileID: a } = this._getOverscaledTileIDFromLngLatZoom(e1, t);
                return null !== (i = this.getMinMaxElevation(a).minElevation) && void 0 !== i ? i : 0;
            }
            getMinMaxElevation(e1) {
                const t = this.getTerrainData(e1).tile, i = {
                    minElevation: null,
                    maxElevation: null
                };
                return t && t.dem && (i.minElevation = t.dem.min * this.exaggeration, i.maxElevation = t.dem.max * this.exaggeration), i;
            }
            _getOverscaledTileIDFromLngLatZoom(e1, i) {
                const a = t.aa.fromLngLat(e1.wrap()), r = (1 << i) * t.a4, o = a.x * r, s = a.y * r, n = Math.floor(o / t.a4), l = Math.floor(s / t.a4);
                return {
                    tileID: new t.a1(i, 0, i, n, l),
                    mercatorX: o,
                    mercatorY: s
                };
            }
        }
        class Yo {
            constructor(e1, t, i){
                this._context = e1, this._size = t, this._tileSize = i, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
            }
            destruct() {
                for (const e1 of this._objects)e1.texture.destroy(), e1.fbo.destroy();
            }
            _createObject(e1) {
                const i = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), a = new t.T(this._context, {
                    width: this._tileSize,
                    height: this._tileSize,
                    data: null
                }, this._context.gl.RGBA);
                return a.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), this._context.extTextureFilterAnisotropic && this._context.gl.texParameterf(this._context.gl.TEXTURE_2D, this._context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this._context.extTextureFilterAnisotropicMax), i.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), i.colorAttachment.set(a.texture), {
                    id: e1,
                    fbo: i,
                    texture: a,
                    stamp: -1,
                    inUse: !1
                };
            }
            getObjectForId(e1) {
                return this._objects[e1];
            }
            useObject(e1) {
                e1.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((t)=>e1.id !== t), this._recentlyUsed.push(e1.id);
            }
            stampObject(e1) {
                e1.stamp = ++this._stamp;
            }
            getOrCreateFreeObject() {
                for (const e1 of this._recentlyUsed)if (!this._objects[e1].inUse) return this._objects[e1];
                if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                const e1 = this._createObject(this._objects.length);
                return this._objects.push(e1), e1;
            }
            freeObject(e1) {
                e1.inUse = !1;
            }
            freeAllObjects() {
                for (const e1 of this._objects)this.freeObject(e1);
            }
            isFull() {
                return !(this._objects.length < this._size) && !1 === this._objects.some((e1)=>!e1.inUse);
            }
        }
        const Qo = {
            background: !0,
            fill: !0,
            line: !0,
            raster: !0,
            hillshade: !0,
            "color-relief": !0
        };
        class Jo {
            constructor(e1, t){
                this.painter = e1, this.terrain = t, this.pool = new Yo(e1.context, 30, t.tileManager.tileSize * t.qualityFactor);
            }
            destruct() {
                this.pool.destruct();
            }
            getTexture(e1) {
                return this.pool.getObjectForId(e1.rtt[this._stacks.length - 1].id).texture;
            }
            prepareForRender(e1, t) {
                this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.tileManager.getRenderableTiles(), this._renderableLayerIds = e1._order.filter((i)=>!e1._layers[i].isHidden(t)), this._coordsAscending = {};
                for(const t in e1.tileManagers){
                    this._coordsAscending[t] = {};
                    const i = e1.tileManagers[t].getVisibleCoordinates(), a = e1.tileManagers[t].getSource(), r = a instanceof te ? a.terrainTileRanges : null;
                    for (const e1 of i){
                        const i = this.terrain.tileManager.getTerrainCoords(e1, r);
                        for(const e1 in i)this._coordsAscending[t][e1] || (this._coordsAscending[t][e1] = []), this._coordsAscending[t][e1].push(i[e1]);
                    }
                }
                this._coordsAscendingStr = {};
                for (const t of e1._order){
                    const i = e1._layers[t], a = i.source;
                    if (Qo[i.type] && !this._coordsAscendingStr[a]) {
                        this._coordsAscendingStr[a] = {};
                        for(const e1 in this._coordsAscending[a])this._coordsAscendingStr[a][e1] = this._coordsAscending[a][e1].map((e1)=>e1.key).sort().join();
                    }
                }
                for (const e1 of this._renderableTiles)for(const t in this._coordsAscendingStr){
                    const i = this._coordsAscendingStr[t][e1.tileID.key];
                    i && i !== e1.rttCoords[t] && (e1.rtt = []);
                }
            }
            renderLayer(e1, i) {
                if (e1.isHidden(this.painter.transform.zoom)) return !1;
                const a = Object.assign(Object.assign({}, i), {
                    isRenderingToTexture: !0
                }), r = e1.type, o = this.painter, s = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e1.id;
                if (Qo[r] && (this._prevType && Qo[this._prevType] || this._stacks.push([]), this._prevType = r, this._stacks[this._stacks.length - 1].push(e1.id), !s)) return !0;
                if (Qo[this._prevType] || Qo[r] && s) {
                    this._prevType = r;
                    const e1 = this._stacks.length - 1, i = this._stacks[e1] || [];
                    for (const r of this._renderableTiles){
                        if (this.pool.isFull() && (Br(this.painter, this.terrain, this._rttTiles, a), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(r), r.rtt[e1]) {
                            const t = this.pool.getObjectForId(r.rtt[e1].id);
                            if (t.stamp === r.rtt[e1].stamp) {
                                this.pool.useObject(t);
                                continue;
                            }
                        }
                        const s = this.pool.getOrCreateFreeObject();
                        this.pool.useObject(s), this.pool.stampObject(s), r.rtt[e1] = {
                            id: s.id,
                            stamp: s.stamp
                        }, o.context.bindFramebuffer.set(s.fbo.framebuffer), o.context.clear({
                            color: t.bo.transparent,
                            stencil: 0
                        }), o.currentStencilSource = void 0;
                        for(let e1 = 0; e1 < i.length; e1++){
                            const t = o.style._layers[i[e1]], n = t.source ? this._coordsAscending[t.source][r.tileID.key] : [
                                r.tileID
                            ];
                            o.context.viewport.set([
                                0,
                                0,
                                s.fbo.width,
                                s.fbo.height
                            ]), o._renderTileClippingMasks(t, n, !0), o.renderLayer(o, o.style.tileManagers[t.source], t, n, a), t.source && (r.rttCoords[t.source] = this._coordsAscendingStr[t.source][r.tileID.key]);
                        }
                    }
                    return Br(this.painter, this.terrain, this._rttTiles, a), this._rttTiles = [], this.pool.freeAllObjects(), Qo[r];
                }
                return !1;
            }
        }
        const es = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "MapLibre logo",
            "Map.Title": "Map",
            "Marker.Title": "Map marker",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "Popup.Close": "Close popup",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm",
            "GlobeControl.Enable": "Enable globe",
            "GlobeControl.Disable": "Disable globe",
            "TerrainControl.Enable": "Enable terrain",
            "TerrainControl.Disable": "Disable terrain",
            "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
            "CooperativeGesturesHandler.MacHelpText": "Use \u2318 + scroll to zoom the map",
            "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map"
        }, ts = i, is = {
            hash: !1,
            interactive: !0,
            bearingSnap: 7,
            attributionControl: Vo,
            maplibreLogo: !1,
            refreshExpiredTiles: !0,
            canvasContextAttributes: {
                antialias: !1,
                preserveDrawingBuffer: !1,
                powerPreference: "high-performance",
                failIfMajorPerformanceCaveat: !1,
                desynchronized: !1,
                contextType: void 0
            },
            scrollZoom: !0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            trackResize: !0,
            center: [
                0,
                0
            ],
            elevation: 0,
            zoom: 0,
            bearing: 0,
            pitch: 0,
            roll: 0,
            renderWorldCopies: !0,
            maxTileCacheSize: null,
            maxTileCacheZoomLevels: t.a.MAX_TILE_CACHE_ZOOM_LEVELS,
            transformRequest: null,
            transformCameraUpdate: null,
            transformConstrain: null,
            fadeDuration: 300,
            crossSourceCollisions: !0,
            clickTolerance: 3,
            localIdeographFontFamily: "sans-serif",
            pitchWithRotate: !0,
            rollEnabled: !1,
            reduceMotion: void 0,
            validateStyle: !0,
            maxCanvasSize: [
                4096,
                4096
            ],
            cancelPendingTileRequestsWhileZooming: !0,
            centerClampedToGround: !0,
            experimentalZoomLevelsToOverscale: void 0
        }, as = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1,
            visualizeRoll: !0
        };
        class rs {
            constructor(e1, i, a = !1){
                this.mousedown = (e1)=>{
                    this.startMove(e1, h.mousePos(this.element, e1)), h.addEventListener(window, "mousemove", this.mousemove), h.addEventListener(window, "mouseup", this.mouseup);
                }, this.mousemove = (e1)=>{
                    this.move(e1, h.mousePos(this.element, e1));
                }, this.mouseup = (e1)=>{
                    this._rotatePitchHandler.dragEnd(e1), this.offTemp();
                }, this.touchstart = (e1)=>{
                    1 !== e1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = h.touchPos(this.element, e1.targetTouches)[0], this.startMove(e1, this._startPos), h.addEventListener(window, "touchmove", this.touchmove, {
                        passive: !1
                    }), h.addEventListener(window, "touchend", this.touchend));
                }, this.touchmove = (e1)=>{
                    1 !== e1.targetTouches.length ? this.reset() : (this._lastPos = h.touchPos(this.element, e1.targetTouches)[0], this.move(e1, this._lastPos));
                }, this.touchend = (e1)=>{
                    0 === e1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this.reset = ()=>{
                    this._rotatePitchHandler.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this._clickTolerance = 10, this.element = i;
                const r = new mo;
                this._rotatePitchHandler = new lo({
                    clickTolerance: 3,
                    move: (e1, r)=>{
                        const o = i.getBoundingClientRect(), s = new t.P((o.bottom - o.top) / 2, (o.right - o.left) / 2);
                        return {
                            bearingDelta: t.cw(new t.P(e1.x, r.y), r, s),
                            pitchDelta: a ? -0.5 * (r.y - e1.y) : void 0
                        };
                    },
                    moveStateManager: r,
                    enable: !0,
                    assignEvents: ()=>{}
                }), this.map = e1, h.addEventListener(i, "mousedown", this.mousedown), h.addEventListener(i, "touchstart", this.touchstart, {
                    passive: !1
                }), h.addEventListener(i, "touchcancel", this.reset);
            }
            startMove(e1, t) {
                this._rotatePitchHandler.dragStart(e1, t), h.disableDrag();
            }
            move(e1, t) {
                const i = this.map, { bearingDelta: a, pitchDelta: r } = this._rotatePitchHandler.dragMove(e1, t) || {};
                a && i.setBearing(i.getBearing() + a), r && i.setPitch(i.getPitch() + r);
            }
            off() {
                const e1 = this.element;
                h.removeEventListener(e1, "mousedown", this.mousedown), h.removeEventListener(e1, "touchstart", this.touchstart, {
                    passive: !1
                }), h.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), h.removeEventListener(window, "touchend", this.touchend), h.removeEventListener(e1, "touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                h.enableDrag(), h.removeEventListener(window, "mousemove", this.mousemove), h.removeEventListener(window, "mouseup", this.mouseup), h.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), h.removeEventListener(window, "touchend", this.touchend);
            }
        }
        let os;
        function ss(e1, i, a, r = !1) {
            if (r || !a.getCoveringTilesDetailsProvider().allowWorldCopies()) return null == e1 ? void 0 : e1.wrap();
            const o = new t.V(e1.lng, e1.lat);
            if (e1 = new t.V(e1.lng, e1.lat), i) {
                const r = new t.V(e1.lng - 360, e1.lat), o = new t.V(e1.lng + 360, e1.lat), s = a.locationToScreenPoint(e1).distSqr(i);
                a.locationToScreenPoint(r).distSqr(i) < s ? e1 = r : a.locationToScreenPoint(o).distSqr(i) < s && (e1 = o);
            }
            for(; Math.abs(e1.lng - a.center.lng) > 180;){
                const t = a.locationToScreenPoint(e1);
                if (t.x >= 0 && t.y >= 0 && t.x <= a.width && t.y <= a.height) break;
                e1.lng > a.center.lng ? e1.lng -= 360 : e1.lng += 360;
            }
            return e1.lng !== o.lng && a.isPointOnMapSurface(a.locationToScreenPoint(e1)) ? e1 : o;
        }
        const ns = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        function ls(e1, t, i) {
            const a = e1.classList;
            for(const e1 in ns)a.remove(`maplibregl-${i}-anchor-${e1}`);
            a.add(`maplibregl-${i}-anchor-${t}`);
        }
        class cs extends t.E {
            constructor(e1){
                if (super(), this._onKeyPress = (e1)=>{
                    const t = e1.code, i = e1.charCode || e1.keyCode;
                    "Space" !== t && "Enter" !== t && 32 !== i && 13 !== i || this.togglePopup();
                }, this._onMapClick = (e1)=>{
                    const t = e1.originalEvent.target, i = this._element;
                    this._popup && (t === i || i.contains(t)) && this.togglePopup();
                }, this._update = (e1)=>{
                    if (!this._map) return;
                    const t = this._map.loaded() && !this._map.isMoving();
                    ("terrain" === (null == e1 ? void 0 : e1.type) || "render" === (null == e1 ? void 0 : e1.type) && !t) && this._map.once("render", this._update), this._lngLat = ss(this._lngLat, this._flatPos, this._map.transform), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map.transform.locationToScreenPoint(this._lngLat)._add(this._offset));
                    let i = "";
                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? i = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (i = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                    let a = "";
                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? a = "rotateX(0deg)" : "map" === this._pitchAlignment && (a = `rotateX(${this._map.getPitch()}deg)`), this._subpixelPositioning || e1 && "moveend" !== e1.type || (this._pos = this._pos.round()), h.setTransform(this._element, `${ns[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${a} ${i}`), n.frameAsync(new AbortController).then(()=>{
                        this._updateOpacity(e1 && "moveend" === e1.type);
                    }).catch(()=>{});
                }, this._onMove = (e1)=>{
                    if (!this._isDragging) {
                        const t = this._clickTolerance || this._map._clickTolerance;
                        this._isDragging = e1.point.dist(this._pointerdownPos) >= t;
                    }
                    this._isDragging && (this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t.l("dragstart"))), this.fire(new t.l("drag")));
                }, this._onUp = ()=>{
                    this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t.l("dragend")), this._state = "inactive";
                }, this._addDragHandler = (e1)=>{
                    this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(this._pos).add(this._offset), this._pointerdownPos = e1.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                }, this._anchor = e1 && e1.anchor || "center", this._color = e1 && e1.color || "#3FB1CE", this._scale = e1 && e1.scale || 1, this._draggable = e1 && e1.draggable || !1, this._clickTolerance = e1 && e1.clickTolerance || 0, this._subpixelPositioning = e1 && e1.subpixelPositioning || !1, this._isDragging = !1, this._state = "inactive", this._rotation = e1 && e1.rotation || 0, this._rotationAlignment = e1 && e1.rotationAlignment || "auto", this._pitchAlignment = e1 && e1.pitchAlignment && "auto" !== e1.pitchAlignment ? e1.pitchAlignment : this._rotationAlignment, this.setOpacity(null == e1 ? void 0 : e1.opacity, null == e1 ? void 0 : e1.opacityWhenCovered), e1 && e1.element) this._element = e1.element, this._offset = t.P.convert(e1 && e1.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = h.create("div");
                    const i = h.createNS("http://www.w3.org/2000/svg", "svg"), a = 41, r = 27;
                    i.setAttributeNS(null, "display", "block"), i.setAttributeNS(null, "height", `${a}px`), i.setAttributeNS(null, "width", `${r}px`), i.setAttributeNS(null, "viewBox", `0 0 ${r} ${a}`);
                    const o = h.createNS("http://www.w3.org/2000/svg", "g");
                    o.setAttributeNS(null, "stroke", "none"), o.setAttributeNS(null, "stroke-width", "1"), o.setAttributeNS(null, "fill", "none"), o.setAttributeNS(null, "fill-rule", "evenodd");
                    const s = h.createNS("http://www.w3.org/2000/svg", "g");
                    s.setAttributeNS(null, "fill-rule", "nonzero");
                    const n = h.createNS("http://www.w3.org/2000/svg", "g");
                    n.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), n.setAttributeNS(null, "fill", "#000000");
                    const l = [
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "9.5",
                            ry: "4.77275007"
                        },
                        {
                            rx: "8.5",
                            ry: "4.29549936"
                        },
                        {
                            rx: "7.5",
                            ry: "3.81822308"
                        },
                        {
                            rx: "6.5",
                            ry: "3.34094679"
                        },
                        {
                            rx: "5.5",
                            ry: "2.86367051"
                        },
                        {
                            rx: "4.5",
                            ry: "2.38636864"
                        }
                    ];
                    for (const e1 of l){
                        const t = h.createNS("http://www.w3.org/2000/svg", "ellipse");
                        t.setAttributeNS(null, "opacity", "0.04"), t.setAttributeNS(null, "cx", "10.5"), t.setAttributeNS(null, "cy", "5.80029008"), t.setAttributeNS(null, "rx", e1.rx), t.setAttributeNS(null, "ry", e1.ry), n.appendChild(t);
                    }
                    const c = h.createNS("http://www.w3.org/2000/svg", "g");
                    c.setAttributeNS(null, "fill", this._color);
                    const u = h.createNS("http://www.w3.org/2000/svg", "path");
                    u.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), c.appendChild(u);
                    const d = h.createNS("http://www.w3.org/2000/svg", "g");
                    d.setAttributeNS(null, "opacity", "0.25"), d.setAttributeNS(null, "fill", "#000000");
                    const _ = h.createNS("http://www.w3.org/2000/svg", "path");
                    _.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), d.appendChild(_);
                    const p = h.createNS("http://www.w3.org/2000/svg", "g");
                    p.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), p.setAttributeNS(null, "fill", "#FFFFFF");
                    const m = h.createNS("http://www.w3.org/2000/svg", "g");
                    m.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                    const f = h.createNS("http://www.w3.org/2000/svg", "circle");
                    f.setAttributeNS(null, "fill", "#000000"), f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "cx", "5.5"), f.setAttributeNS(null, "cy", "5.5"), f.setAttributeNS(null, "r", "5.4999962");
                    const g = h.createNS("http://www.w3.org/2000/svg", "circle");
                    g.setAttributeNS(null, "fill", "#FFFFFF"), g.setAttributeNS(null, "cx", "5.5"), g.setAttributeNS(null, "cy", "5.5"), g.setAttributeNS(null, "r", "5.4999962"), m.appendChild(f), m.appendChild(g), s.appendChild(n), s.appendChild(c), s.appendChild(d), s.appendChild(p), s.appendChild(m), i.appendChild(s), i.setAttributeNS(null, "height", a * this._scale + "px"), i.setAttributeNS(null, "width", r * this._scale + "px"), this._element.appendChild(i), this._offset = t.P.convert(e1 && e1.offset || [
                        0,
                        -14
                    ]);
                }
                if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (e1)=>{
                    e1.preventDefault();
                }), this._element.addEventListener("mousedown", (e1)=>{
                    e1.preventDefault();
                }), ls(this._element, this._anchor, "marker"), e1 && e1.className) for (const t of e1.className.split(" "))this._element.classList.add(t);
                this._popup = null;
            }
            addTo(e1) {
                return this.remove(), this._map = e1, this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", e1._getUIString("Marker.Title")), this._element.hasAttribute("role") || this._element.setAttribute("role", "button"), e1.getCanvasContainer().appendChild(this._element), e1.on("move", this._update), e1.on("moveend", this._update), e1.on("terrain", this._update), e1.on("projectiontransition", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
            }
            remove() {
                return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("terrain", this._update), this._map.off("projectiontransition", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), h.remove(this._element), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e1) {
                return this._lngLat = t.V.convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(e1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e1) {
                    if (!("offset" in e1.options)) {
                        const t = 38.1, i = 13.5, a = Math.abs(i) / Math.SQRT2;
                        e1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t
                            ],
                            "bottom-left": [
                                a,
                                -1 * (t - i + a)
                            ],
                            "bottom-right": [
                                -a,
                                -1 * (t - i + a)
                            ],
                            left: [
                                i,
                                -1 * (t - i)
                            ],
                            right: [
                                -i,
                                -1 * (t - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e1, this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                }
                return this;
            }
            setSubpixelPositioning(e1) {
                return this._subpixelPositioning = e1, this;
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e1 = this._popup;
                return this._element.style.opacity === this._opacityWhenCovered ? this : e1 ? (e1.isOpen() ? e1.remove() : (e1.setLngLat(this._lngLat), e1.addTo(this._map)), this) : this;
            }
            _updateOpacity(e1 = !1) {
                var i, a;
                const r = null === (i = this._map) || void 0 === i ? void 0 : i.terrain, o = this._map.transform.isLocationOccluded(this._lngLat);
                if (!r || o) {
                    const e1 = o ? this._opacityWhenCovered : this._opacity;
                    return void (this._element.style.opacity !== e1 && (this._element.style.opacity = e1));
                }
                if (e1) this._opacityTimeout = null;
                else {
                    if (this._opacityTimeout) return;
                    this._opacityTimeout = setTimeout(()=>{
                        this._opacityTimeout = null;
                    }, 100);
                }
                const s = this._map, n = s.terrain.depthAtPoint(this._pos), l = s.terrain.getElevationForLngLatZoom(this._lngLat, s.transform.tileZoom);
                if (s.transform.lngLatToCameraDepth(this._lngLat, l) - n < .006) return void (this._element.style.opacity = this._opacity);
                const c = -this._offset.y / s.transform.pixelsPerMeter, h = Math.sin(s.getPitch() * Math.PI / 180) * c, u = s.terrain.depthAtPoint(new t.P(this._pos.x, this._pos.y - this._offset.y)), d = s.transform.lngLatToCameraDepth(this._lngLat, l + h) - u > .006;
                (null === (a = this._popup) || void 0 === a ? void 0 : a.isOpen()) && d && this._popup.remove(), this._element.style.opacity = d ? this._opacityWhenCovered : this._opacity;
            }
            getOffset() {
                return this._offset;
            }
            setOffset(e1) {
                return this._offset = t.P.convert(e1), this._update(), this;
            }
            addClassName(e1) {
                this._element.classList.add(e1);
            }
            removeClassName(e1) {
                this._element.classList.remove(e1);
            }
            toggleClassName(e1) {
                return this._element.classList.toggle(e1);
            }
            setDraggable(e1) {
                return this._draggable = !!e1, this._map && (e1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e1) {
                return this._rotation = e1 || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e1) {
                return this._rotationAlignment = e1 || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return this._rotationAlignment;
            }
            setPitchAlignment(e1) {
                return this._pitchAlignment = e1 && "auto" !== e1 ? e1 : this._rotationAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return this._pitchAlignment;
            }
            setOpacity(e1, t) {
                return (void 0 === this._opacity || void 0 === e1 && void 0 === t) && (this._opacity = "1", this._opacityWhenCovered = "0.2"), void 0 !== e1 && (this._opacity = e1), void 0 !== t && (this._opacityWhenCovered = t), this._map && this._updateOpacity(!0), this;
            }
        }
        const hs = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
        };
        let us = 0, ds = !1;
        const _s = {
            maxWidth: 100,
            unit: "metric"
        };
        function ps(e1, t, i) {
            const a = i && i.maxWidth || 100, r = e1._container.clientHeight / 2, o = e1._container.clientWidth / 2, s = e1.unproject([
                o - a / 2,
                r
            ]), n = e1.unproject([
                o + a / 2,
                r
            ]), l = Math.round(e1.project(n).x - e1.project(s).x), c = Math.min(a, l, e1._container.clientWidth), h = s.distanceTo(n);
            if (i && "imperial" === i.unit) {
                const i = 3.2808 * h;
                i > 5280 ? ms(t, c, i / 5280, e1._getUIString("ScaleControl.Miles")) : ms(t, c, i, e1._getUIString("ScaleControl.Feet"));
            } else i && "nautical" === i.unit ? ms(t, c, h / 1852, e1._getUIString("ScaleControl.NauticalMiles")) : h >= 1e3 ? ms(t, c, h / 1e3, e1._getUIString("ScaleControl.Kilometers")) : ms(t, c, h, e1._getUIString("ScaleControl.Meters"));
        }
        function ms(e1, t, i, a) {
            const r = function(e1) {
                const t = Math.pow(10, `${Math.floor(e1)}`.length - 1);
                let i = e1 / t;
                return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e1) {
                    const t = Math.pow(10, Math.ceil(-Math.log(e1) / Math.LN10));
                    return Math.round(e1 * t) / t;
                }(i), t * i;
            }(i);
            e1.style.width = t * (r / i) + "px", e1.innerHTML = `${r}&nbsp;${a}`;
        }
        const fs = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px",
            subpixelPositioning: !1,
            locationOccludedOpacity: void 0
        }, gs = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function vs(e1) {
            if (e1) {
                if ("number" == typeof e1) {
                    const i = Math.round(Math.abs(e1) / Math.SQRT2);
                    return {
                        center: new t.P(0, 0),
                        top: new t.P(0, e1),
                        "top-left": new t.P(i, i),
                        "top-right": new t.P(-i, i),
                        bottom: new t.P(0, -e1),
                        "bottom-left": new t.P(i, -i),
                        "bottom-right": new t.P(-i, -i),
                        left: new t.P(e1, 0),
                        right: new t.P(-e1, 0)
                    };
                }
                if (e1 instanceof t.P || Array.isArray(e1)) {
                    const i = t.P.convert(e1);
                    return {
                        center: i,
                        top: i,
                        "top-left": i,
                        "top-right": i,
                        bottom: i,
                        "bottom-left": i,
                        "bottom-right": i,
                        left: i,
                        right: i
                    };
                }
                return {
                    center: t.P.convert(e1.center || [
                        0,
                        0
                    ]),
                    top: t.P.convert(e1.top || [
                        0,
                        0
                    ]),
                    "top-left": t.P.convert(e1["top-left"] || [
                        0,
                        0
                    ]),
                    "top-right": t.P.convert(e1["top-right"] || [
                        0,
                        0
                    ]),
                    bottom: t.P.convert(e1.bottom || [
                        0,
                        0
                    ]),
                    "bottom-left": t.P.convert(e1["bottom-left"] || [
                        0,
                        0
                    ]),
                    "bottom-right": t.P.convert(e1["bottom-right"] || [
                        0,
                        0
                    ]),
                    left: t.P.convert(e1.left || [
                        0,
                        0
                    ]),
                    right: t.P.convert(e1.right || [
                        0,
                        0
                    ])
                };
            }
            return vs(new t.P(0, 0));
        }
        const xs = i;
        e1.AJAXError = t.cI, e1.Event = t.l, e1.Evented = t.E, e1.LngLat = t.V, e1.MercatorCoordinate = t.aa, e1.Point = t.P, e1.addProtocol = t.cJ, e1.config = t.a, e1.removeProtocol = t.cK, e1.AttributionControl = qo, e1.BoxZoomHandler = ao, e1.CanvasSource = ae, e1.CooperativeGesturesHandler = Oo, e1.DoubleClickZoomHandler = zo, e1.DragPanHandler = ko, e1.DragRotateHandler = Fo, e1.EdgeInsets = Lt, e1.FullscreenControl = class extends t.E {
            constructor(e1 = {}){
                super(), this._onFullscreenChange = ()=>{
                    var e1;
                    let t = window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement;
                    for(; null === (e1 = null == t ? void 0 : t.shadowRoot) || void 0 === e1 ? void 0 : e1.fullscreenElement;)t = t.shadowRoot.fullscreenElement;
                    t === this._container !== this._fullscreen && this._handleFullscreenChange();
                }, this._onClickFullscreen = ()=>{
                    this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
                }, this._fullscreen = !1, e1 && e1.container && (e1.container instanceof HTMLElement ? this._container = e1.container : t.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
            }
            onAdd(e1) {
                return this._map = e1, this._container || (this._container = this._map.getContainer()), this._controlContainer = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
            }
            onRemove() {
                h.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _setupUI() {
                const e1 = this._fullscreenButton = h.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                h.create("span", "maplibregl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), e1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _updateTitle() {
                const e1 = this._getTitle();
                this._fullscreenButton.setAttribute("aria-label", e1), this._fullscreenButton.title = e1;
            }
            _getTitle() {
                return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
            }
            _isFullscreen() {
                return this._fullscreen;
            }
            _handleFullscreenChange() {
                this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new t.l("fullscreenstart")), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new t.l("fullscreenend")), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
            }
            _exitFullscreen() {
                window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
            }
            _requestFullscreen() {
                this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
            }
            _togglePseudoFullScreen() {
                this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
            }
        }, e1.GeoJSONSource = ee, e1.GeolocateControl = class extends t.E {
            constructor(e1){
                super(), this._onSuccess = (e1)=>{
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(e1)) return this._setErrorState(), this.fire(new t.l("outofmaxbounds", e1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new t.l("geolocate", e1)), this._finish();
                    }
                }, this._updateCamera = (e1)=>{
                    const i = new t.V(e1.coords.longitude, e1.coords.latitude), a = e1.coords.accuracy, r = this._map.getBearing(), o = t.e({
                        bearing: r
                    }, this.options.fitBoundsOptions), s = $.fromLngLat(i, a);
                    this._map.fitBounds(s, o, {
                        geolocateSource: !0
                    });
                }, this._updateMarker = (e1)=>{
                    if (e1) {
                        const i = new t.V(e1.coords.longitude, e1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = e1.coords.accuracy, this._updateCircleRadiusIfNeeded();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }, this._onUpdate = ()=>{
                    this._updateCircleRadiusIfNeeded();
                }, this._onError = (e1)=>{
                    if (this._map) {
                        if (1 === e1.code) {
                            this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                            const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.title = e1, this._geolocateButton.setAttribute("aria-label", e1), void 0 !== this._geolocationWatchID && this._clearWatch();
                        } else {
                            if (3 === e1.code && ds) return;
                            this._setErrorState();
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new t.l("error", e1)), this._finish();
                    }
                }, this._finish = ()=>{
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }, this._setupUI = ()=>{
                    this._map && (this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this._geolocateButton = h.create("button", "maplibregl-ctrl-geolocate", this._container), h.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", this._geolocateButton.disabled = !0);
                }, this._finishSetupUI = (e1)=>{
                    if (this._map) {
                        if (!1 === e1) {
                            t.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.title = e1, this._geolocateButton.setAttribute("aria-label", e1);
                        } else {
                            const e1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.disabled = !1, this._geolocateButton.title = e1, this._geolocateButton.setAttribute("aria-label", e1);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = h.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new cs({
                            element: this._dotElement
                        }), this._circleElement = h.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new cs({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onUpdate), this._map.on("move", this._onUpdate), this._map.on("rotate", this._onUpdate), this._map.on("pitch", this._onUpdate)), this._geolocateButton.addEventListener("click", ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (e1)=>{
                            const i = (null == e1 ? void 0 : e1[0]) instanceof ResizeObserverEntry;
                            e1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || i || this._map.isZooming() || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new t.l("trackuserlocationend")), this.fire(new t.l("userlocationlostfocus")));
                        });
                    }
                }, this.options = t.e({}, hs, e1);
            }
            onAdd(e1) {
                return this._map = e1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), (function() {
                    return t._(this, arguments, void 0, function*(e1 = !1) {
                        if (void 0 !== os && !e1) return os;
                        if (void 0 === window.navigator.permissions) return os = !!window.navigator.geolocation, os;
                        try {
                            const e1 = yield window.navigator.permissions.query({
                                name: "geolocation"
                            });
                            os = "denied" !== e1.state;
                        } catch (e1) {
                            os = !!window.navigator.geolocation;
                        }
                        return os;
                    });
                })().then((e1)=>this._finishSetupUI(e1)), this._container;
            }
            onRemove() {
                void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), h.remove(this._container), this._map.off("zoom", this._onUpdate), this._map.off("move", this._onUpdate), this._map.off("rotate", this._onUpdate), this._map.off("pitch", this._onUpdate), this._map = void 0, us = 0, ds = !1;
            }
            _isOutOfMapMaxBounds(e1) {
                const t = this._map.getMaxBounds(), i = e1.coords;
                return t && (i.longitude < t.getWest() || i.longitude > t.getEast() || i.latitude < t.getSouth() || i.latitude > t.getNorth());
            }
            _setErrorState() {
                switch(this._watchState){
                    case "WAITING_ACTIVE":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                        break;
                    case "ACTIVE_LOCK":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "BACKGROUND":
                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "ACTIVE_ERROR":
                    case "BACKGROUND_ERROR":
                    case "OFF":
                    case void 0:
                        break;
                    default:
                        throw new Error(`Unexpected watchState ${this._watchState}`);
                }
            }
            _updateCircleRadiusIfNeeded() {
                const e1 = this._userLocationDotMarker.getLngLat();
                if (!(this.options.showUserLocation && this.options.showAccuracyCircle && this._accuracy && e1)) return;
                const t = this._map.project(e1), i = this._map.unproject([
                    t.x + 100,
                    t.y
                ]), a = e1.distanceTo(i) / 100, r = 2 * this._accuracy / a;
                this._circleElement.style.width = `${r.toFixed(2)}px`, this._circleElement.style.height = `${r.toFixed(2)}px`;
            }
            trigger() {
                if (!this._setup) return t.w("Geolocate control triggered before added to a map"), !1;
                if (this.options.trackUserLocation) {
                    switch(this._watchState){
                        case "OFF":
                            this._watchState = "WAITING_ACTIVE", this.fire(new t.l("trackuserlocationstart"));
                            break;
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                        case "ACTIVE_ERROR":
                        case "BACKGROUND_ERROR":
                            us--, ds = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new t.l("trackuserlocationend"));
                            break;
                        case "BACKGROUND":
                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t.l("trackuserlocationstart")), this.fire(new t.l("userlocationfocus"));
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "ACTIVE_LOCK":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "OFF":
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                    else if (void 0 === this._geolocationWatchID) {
                        let e1;
                        this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), us++, us > 1 ? (e1 = {
                            maximumAge: 6e5,
                            timeout: 0
                        }, ds = !0) : (e1 = this.options.positionOptions, ds = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e1);
                    }
                } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                return !0;
            }
            _clearWatch() {
                window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
            }
        }, e1.GlobeControl = class {
            constructor(){
                this._toggleProjection = ()=>{
                    var e1;
                    const t = null === (e1 = this._map.getProjection()) || void 0 === e1 ? void 0 : e1.type;
                    this._map.setProjection("mercator" !== t && t ? {
                        type: "mercator"
                    } : {
                        type: "globe"
                    }), this._updateGlobeIcon();
                }, this._updateGlobeIcon = ()=>{
                    var e1;
                    this._globeButton.classList.remove("maplibregl-ctrl-globe"), this._globeButton.classList.remove("maplibregl-ctrl-globe-enabled"), "globe" === (null === (e1 = this._map.getProjection()) || void 0 === e1 ? void 0 : e1.type) ? (this._globeButton.classList.add("maplibregl-ctrl-globe-enabled"), this._globeButton.title = this._map._getUIString("GlobeControl.Disable")) : (this._globeButton.classList.add("maplibregl-ctrl-globe"), this._globeButton.title = this._map._getUIString("GlobeControl.Enable"));
                };
            }
            onAdd(e1) {
                return this._map = e1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._globeButton = h.create("button", "maplibregl-ctrl-globe", this._container), h.create("span", "maplibregl-ctrl-icon", this._globeButton).setAttribute("aria-hidden", "true"), this._globeButton.type = "button", this._globeButton.addEventListener("click", this._toggleProjection), this._updateGlobeIcon(), this._map.on("styledata", this._updateGlobeIcon), this._container;
            }
            onRemove() {
                h.remove(this._container), this._map.off("styledata", this._updateGlobeIcon), this._globeButton.removeEventListener("click", this._toggleProjection), this._map = void 0;
            }
        }, e1.Hash = Zr, e1.ImageSource = te, e1.KeyboardHandler = Io, e1.LngLatBounds = $, e1.LogoControl = Wo, e1.Map = class extends Uo {
            constructor(e1){
                var i, a;
                t.cF.mark(t.cG.create);
                const r = Object.assign(Object.assign(Object.assign({}, is), e1), {
                    canvasContextAttributes: Object.assign(Object.assign({}, is.canvasContextAttributes), e1.canvasContextAttributes)
                });
                if (null != r.minZoom && null != r.maxZoom && r.minZoom > r.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                if (null != r.minPitch && null != r.maxPitch && r.minPitch > r.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                if (null != r.minPitch && r.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (null != r.maxPitch && r.maxPitch > 180) throw new Error("maxPitch must be less than or equal to 180");
                const o = new Zt, s = new qt;
                if (void 0 !== r.minZoom && o.setMinZoom(r.minZoom), void 0 !== r.maxZoom && o.setMaxZoom(r.maxZoom), void 0 !== r.minPitch && o.setMinPitch(r.minPitch), void 0 !== r.maxPitch && o.setMaxPitch(r.maxPitch), void 0 !== r.renderWorldCopies && o.setRenderWorldCopies(r.renderWorldCopies), null !== r.transformConstrain && o.setConstrainOverride(r.transformConstrain), super(o, s, {
                    bearingSnap: r.bearingSnap
                }), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new $o, this._controls = [], this._mapId = t.ag(), this._lostContextStyle = {
                    style: null,
                    images: null
                }, this._contextLost = (e1)=>{
                    e1.preventDefault(), this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this.painter.destroy();
                    for (const e1 of Object.values(this.style._layers))if ("custom" === e1.type && console.warn(`Custom layer with id '${e1.id}' cannot be restored after WebGL context loss. You will need to re-add it manually after context restoration.`), e1._listeners) for (const [t] of Object.entries(e1._listeners))console.warn(`Custom layer with id '${e1.id}' had event listeners for event '${t}' which cannot be restored after WebGL context loss. You will need to re-add them manually after context restoration.`);
                    this._lostContextStyle = this._getStyleAndImages(), this.style.destroy(), this.style = null, this.fire(new t.l("webglcontextlost", {
                        originalEvent: e1
                    }));
                }, this._contextRestored = (e1)=>{
                    this._lostContextStyle.style && this.setStyle(this._lostContextStyle.style, {
                        diff: !1
                    }), this._lostContextStyle.images && (this.style.imageManager.images = this._lostContextStyle.images), this._setupPainter(), this.resize(), this._update(), this.fire(new t.l("webglcontextrestored", {
                        originalEvent: e1
                    }));
                }, this._onMapScroll = (e1)=>{
                    if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }, this._onWindowOnline = ()=>{
                    this._update();
                }, this._interactive = r.interactive, this._maxTileCacheSize = r.maxTileCacheSize, this._maxTileCacheZoomLevels = r.maxTileCacheZoomLevels, this._canvasContextAttributes = Object.assign({}, r.canvasContextAttributes), this._trackResize = !0 === r.trackResize, this._bearingSnap = r.bearingSnap, this._centerClampedToGround = r.centerClampedToGround, this._refreshExpiredTiles = !0 === r.refreshExpiredTiles, this._fadeDuration = r.fadeDuration, this._crossSourceCollisions = !0 === r.crossSourceCollisions, this._collectResourceTiming = !0 === r.collectResourceTiming, this._locale = Object.assign(Object.assign({}, es), r.locale), this._clickTolerance = r.clickTolerance, this._overridePixelRatio = r.pixelRatio, this._maxCanvasSize = r.maxCanvasSize, this._zoomLevelsToOverscale = r.experimentalZoomLevelsToOverscale, this.transformCameraUpdate = r.transformCameraUpdate, this.transformConstrain = r.transformConstrain, this.cancelPendingTileRequestsWhileZooming = !0 === r.cancelPendingTileRequestsWhileZooming, void 0 !== r.reduceMotion && (n.prefersReducedMotion = r.reduceMotion), this._imageQueueHandle = g.addThrottleControl(()=>this.isMoving()), this._requestManager = new v(r.transformRequest), "string" == typeof r.container) {
                    if (this._container = document.getElementById(r.container), !this._container) throw new Error(`Container '${r.container}' not found.`);
                } else {
                    if (!(r.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                    this._container = r.container;
                }
                if (r.maxBounds && this.setMaxBounds(r.maxBounds), this._setupContainer(), this._setupPainter(), this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this.on("terrain", ()=>{
                    this.painter.terrainFacilitator.dirty = !0, this._update(!0);
                }), this.once("idle", ()=>{
                    this._idleTriggered = !0;
                }), "undefined" != typeof window) {
                    addEventListener("online", this._onWindowOnline, !1);
                    let e1 = !1;
                    const t = Nr((e1)=>{
                        this._trackResize && !this._removed && (this.resize(e1), this.redraw());
                    }, 50);
                    this._resizeObserver = new ResizeObserver((i)=>{
                        e1 ? t(i) : e1 = !0;
                    }), this._resizeObserver.observe(this._container);
                }
                this.handlers = new Go(this, r), this._hash = r.hash && new Zr("string" == typeof r.hash && r.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                    center: r.center,
                    elevation: r.elevation,
                    zoom: r.zoom,
                    bearing: r.bearing,
                    pitch: r.pitch,
                    roll: r.roll
                }), r.bounds && (this.resize(), this.fitBounds(r.bounds, t.e({}, r.fitBoundsOptions, {
                    duration: 0
                }))));
                const l = "string" == typeof r.style || !("globe" === (null === (a = null === (i = r.style) || void 0 === i ? void 0 : i.projection) || void 0 === a ? void 0 : a.type));
                this.resize(null, l), this._localIdeographFontFamily = r.localIdeographFontFamily, this._validateStyle = r.validateStyle, r.style && this.setStyle(r.style, {
                    localIdeographFontFamily: r.localIdeographFontFamily
                }), r.attributionControl && this.addControl(new qo("boolean" == typeof r.attributionControl ? void 0 : r.attributionControl)), r.maplibreLogo && this.addControl(new Wo, r.logoPosition), this.on("style.load", ()=>{
                    if (l || this._resizeTransform(), this.transform.unmodified) {
                        const e1 = t.U(this.style.stylesheet, [
                            "center",
                            "zoom",
                            "bearing",
                            "pitch",
                            "roll"
                        ]);
                        this.jumpTo(e1);
                    }
                }), this.on("data", (e1)=>{
                    this._update("style" === e1.dataType), this.fire(new t.l(`${e1.dataType}data`, e1));
                }), this.on("dataloading", (e1)=>{
                    this.fire(new t.l(`${e1.dataType}dataloading`, e1));
                }), this.on("dataabort", (e1)=>{
                    this.fire(new t.l("sourcedataabort", e1));
                });
            }
            _getMapId() {
                return this._mapId;
            }
            setGlobalStateProperty(e1, t) {
                return this.style.setGlobalStateProperty(e1, t), this._update(!0);
            }
            getGlobalState() {
                return this.style.getGlobalState();
            }
            addControl(e1, i) {
                if (void 0 === i && (i = e1.getDefaultPosition ? e1.getDefaultPosition() : "top-right"), !e1 || !e1.onAdd) return this.fire(new t.k(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                const a = e1.onAdd(this);
                this._controls.push(e1);
                const r = this._controlPositions[i];
                return -1 !== i.indexOf("bottom") ? r.insertBefore(a, r.firstChild) : r.appendChild(a), this;
            }
            removeControl(e1) {
                if (!e1 || !e1.onRemove) return this.fire(new t.k(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                const i = this._controls.indexOf(e1);
                return i > -1 && this._controls.splice(i, 1), e1.onRemove(this), this;
            }
            hasControl(e1) {
                return this._controls.indexOf(e1) > -1;
            }
            coveringTiles(e1) {
                return Ce(this.transform, e1);
            }
            calculateCameraOptionsFromTo(e1, t, i, a) {
                return null == a && this.terrain && (a = this.terrain.getElevationForLngLatZoom(i, this.transform.tileZoom)), super.calculateCameraOptionsFromTo(e1, t, i, a);
            }
            resize(e1, i = !0) {
                const [a, r] = this._containerDimensions(), o = this._getClampedPixelRatio(a, r);
                if (this._resizeCanvas(a, r, o), this.painter.resize(a, r, o), this.painter.overLimit()) {
                    const e1 = this.painter.context.gl;
                    this._maxCanvasSize = [
                        e1.drawingBufferWidth,
                        e1.drawingBufferHeight
                    ];
                    const t = this._getClampedPixelRatio(a, r);
                    this._resizeCanvas(a, r, t), this.painter.resize(a, r, t);
                }
                this._resizeTransform(i);
                const s = !this._moving;
                return s && (this.stop(), this.fire(new t.l("movestart", e1)).fire(new t.l("move", e1))), this.fire(new t.l("resize", e1)), s && this.fire(new t.l("moveend", e1)), this;
            }
            _resizeTransform(e1 = !0) {
                var t;
                const [i, a] = this._containerDimensions();
                this.transform.resize(i, a, e1), null === (t = this._requestedCameraState) || void 0 === t || t.resize(i, a, e1);
            }
            _getClampedPixelRatio(e1, t) {
                const { 0: i, 1: a } = this._maxCanvasSize, r = this.getPixelRatio(), o = e1 * r, s = t * r;
                return Math.min(o > i ? i / o : 1, s > a ? a / s : 1) * r;
            }
            getPixelRatio() {
                var e1;
                return null !== (e1 = this._overridePixelRatio) && void 0 !== e1 ? e1 : devicePixelRatio;
            }
            setPixelRatio(e1) {
                this._overridePixelRatio = e1, this.resize();
            }
            getBounds() {
                return this.transform.getBounds();
            }
            getMaxBounds() {
                return this.transform.getMaxBounds();
            }
            setMaxBounds(e1) {
                return this.transform.setMaxBounds($.convert(e1)), this._update();
            }
            setMinZoom(e1) {
                if ((e1 = null == e1 ? -2 : e1) >= -2 && e1 <= this.transform.maxZoom) return this.transform.setMinZoom(e1), this._update(), this.getZoom() < e1 && this.setZoom(e1), this;
                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
            }
            getMinZoom() {
                return this.transform.minZoom;
            }
            setMaxZoom(e1) {
                if ((e1 = null == e1 ? 22 : e1) >= this.transform.minZoom) return this.transform.setMaxZoom(e1), this._update(), this.getZoom() > e1 && this.setZoom(e1), this;
                throw new Error("maxZoom must be greater than the current minZoom");
            }
            getMaxZoom() {
                return this.transform.maxZoom;
            }
            setMinPitch(e1) {
                if ((e1 = null == e1 ? 0 : e1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (e1 >= 0 && e1 <= this.transform.maxPitch) return this.transform.setMinPitch(e1), this._update(), this.getPitch() < e1 && this.setPitch(e1), this;
                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
            }
            getMinPitch() {
                return this.transform.minPitch;
            }
            setMaxPitch(e1) {
                if ((e1 = null == e1 ? 60 : e1) > 180) throw new Error("maxPitch must be less than or equal to 180");
                if (e1 >= this.transform.minPitch) return this.transform.setMaxPitch(e1), this._update(), this.getPitch() > e1 && this.setPitch(e1), this;
                throw new Error("maxPitch must be greater than the current minPitch");
            }
            getMaxPitch() {
                return this.transform.maxPitch;
            }
            getRenderWorldCopies() {
                return this.transform.renderWorldCopies;
            }
            setRenderWorldCopies(e1) {
                return this.transform.setRenderWorldCopies(e1), this._update();
            }
            setTransformConstrain(e1) {
                return this.transform.setConstrainOverride(e1), this._update();
            }
            project(e1) {
                return this.transform.locationToScreenPoint(t.V.convert(e1), this.style && this.terrain);
            }
            unproject(e1) {
                return this.transform.screenPointToLocation(t.P.convert(e1), this.terrain);
            }
            isMoving() {
                var e1;
                return this._moving || (null === (e1 = this.handlers) || void 0 === e1 ? void 0 : e1.isMoving());
            }
            isZooming() {
                var e1;
                return this._zooming || (null === (e1 = this.handlers) || void 0 === e1 ? void 0 : e1.isZooming());
            }
            isRotating() {
                var e1;
                return this._rotating || (null === (e1 = this.handlers) || void 0 === e1 ? void 0 : e1.isRotating());
            }
            _createDelegatedListener(e1, t, i) {
                if ("mouseenter" === e1 || "mouseover" === e1) {
                    let a = !1;
                    const r = (r)=>{
                        const o = t.filter((e1)=>this.getLayer(e1)), s = 0 !== o.length ? this.queryRenderedFeatures(r.point, {
                            layers: o
                        }) : [];
                        s.length ? a || (a = !0, i.call(this, new Yr(e1, this, r.originalEvent, {
                            features: s
                        }))) : a = !1;
                    };
                    return {
                        layers: t,
                        listener: i,
                        delegates: {
                            mousemove: r,
                            mouseout: ()=>{
                                a = !1;
                            }
                        }
                    };
                }
                if ("mouseleave" === e1 || "mouseout" === e1) {
                    let a = !1;
                    const r = (r)=>{
                        const o = t.filter((e1)=>this.getLayer(e1));
                        (0 !== o.length ? this.queryRenderedFeatures(r.point, {
                            layers: o
                        }) : []).length ? a = !0 : a && (a = !1, i.call(this, new Yr(e1, this, r.originalEvent)));
                    }, o = (t)=>{
                        a && (a = !1, i.call(this, new Yr(e1, this, t.originalEvent)));
                    };
                    return {
                        layers: t,
                        listener: i,
                        delegates: {
                            mousemove: r,
                            mouseout: o
                        }
                    };
                }
                {
                    const a = (e1)=>{
                        const a = t.filter((e1)=>this.getLayer(e1)), r = 0 !== a.length ? this.queryRenderedFeatures(e1.point, {
                            layers: a
                        }) : [];
                        r.length && (e1.features = r, i.call(this, e1), delete e1.features);
                    };
                    return {
                        layers: t,
                        listener: i,
                        delegates: {
                            [e1]: a
                        }
                    };
                }
            }
            _saveDelegatedListener(e1, t) {
                this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e1] = this._delegatedListeners[e1] || [], this._delegatedListeners[e1].push(t);
            }
            _removeDelegatedListener(e1, t, i) {
                if (!this._delegatedListeners || !this._delegatedListeners[e1]) return;
                const a = this._delegatedListeners[e1];
                for(let e1 = 0; e1 < a.length; e1++){
                    const r = a[e1];
                    if (r.listener === i && r.layers.length === t.length && r.layers.every((e1)=>t.includes(e1))) {
                        for(const e1 in r.delegates)this.off(e1, r.delegates[e1]);
                        return void a.splice(e1, 1);
                    }
                }
            }
            on(e1, t, i) {
                if (void 0 === i) return super.on(e1, t);
                const a = "string" == typeof t ? [
                    t
                ] : t, r = this._createDelegatedListener(e1, a, i);
                this._saveDelegatedListener(e1, r);
                for(const e1 in r.delegates)this.on(e1, r.delegates[e1]);
                return {
                    unsubscribe: ()=>{
                        this._removeDelegatedListener(e1, a, i);
                    }
                };
            }
            once(e1, t, i) {
                if (void 0 === i) return super.once(e1, t);
                const a = "string" == typeof t ? [
                    t
                ] : t, r = this._createDelegatedListener(e1, a, i);
                for(const t in r.delegates){
                    const o = r.delegates[t];
                    r.delegates[t] = (...t)=>{
                        this._removeDelegatedListener(e1, a, i), o(...t);
                    };
                }
                this._saveDelegatedListener(e1, r);
                for(const e1 in r.delegates)this.once(e1, r.delegates[e1]);
                return this;
            }
            off(e1, t, i) {
                return void 0 === i ? super.off(e1, t) : (this._removeDelegatedListener(e1, "string" == typeof t ? [
                    t
                ] : t, i), this);
            }
            queryRenderedFeatures(e1, i) {
                if (!this.style) return [];
                let a;
                const r = e1 instanceof t.P || Array.isArray(e1), o = r ? e1 : [
                    [
                        0,
                        0
                    ],
                    [
                        this.transform.width,
                        this.transform.height
                    ]
                ];
                if (i = i || (r ? {} : e1) || {}, o instanceof t.P || "number" == typeof o[0]) a = [
                    t.P.convert(o)
                ];
                else {
                    const e1 = t.P.convert(o[0]), i = t.P.convert(o[1]);
                    a = [
                        e1,
                        new t.P(i.x, e1.y),
                        i,
                        new t.P(e1.x, i.y),
                        e1
                    ];
                }
                return this.style.queryRenderedFeatures(a, i, this.transform);
            }
            querySourceFeatures(e1, t) {
                return this.style.querySourceFeatures(e1, t);
            }
            setStyle(e1, i) {
                return !1 !== (i = t.e({}, {
                    localIdeographFontFamily: this._localIdeographFontFamily,
                    validate: this._validateStyle
                }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._updateStyle(e1, i));
            }
            setTransformRequest(e1) {
                return this._requestManager.setTransformRequest(e1), this;
            }
            _getUIString(e1) {
                const t = this._locale[e1];
                if (null == t) throw new Error(`Missing UI string '${e1}'`);
                return t;
            }
            _updateStyle(e1, t) {
                var i, a;
                if (t.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(e1, t));
                const r = this.style && t.transformStyle ? this.style.serialize() : void 0;
                return this.style && (this.style.setEventedParent(null), this.style._remove(!e1)), e1 ? (this.style = new Si(this, t || {}), this.style.setEventedParent(this, {
                    style: this.style
                }), "string" == typeof e1 ? this.style.loadURL(e1, t, r) : this.style.loadJSON(e1, t, r), this) : (null === (a = null === (i = this.style) || void 0 === i ? void 0 : i.projection) || void 0 === a || a.destroy(), delete this.style, this);
            }
            _lazyInitEmptyStyle() {
                this.style || (this.style = new Si(this, {}), this.style.setEventedParent(this, {
                    style: this.style
                }), this.style.loadEmpty());
            }
            _diffStyle(e1, i) {
                if ("string" == typeof e1) {
                    const a = this._requestManager.transformRequest(e1, "Style");
                    t.j(a, new AbortController).then((e1)=>{
                        this._updateDiff(e1.data, i);
                    }).catch((e1)=>{
                        e1 && this.fire(new t.k(e1));
                    });
                } else "object" == typeof e1 && this._updateDiff(e1, i);
            }
            _updateDiff(e1, i) {
                try {
                    this.style.setState(e1, i) && this._update(!0);
                } catch (a) {
                    t.w(`Unable to perform style diff: ${a.message || a.error || a}.  Rebuilding the style from scratch.`), this._updateStyle(e1, i);
                }
            }
            getStyle() {
                if (this.style) return this.style.serialize();
            }
            _getStyleAndImages() {
                return this.style ? {
                    style: this.style.serialize(),
                    images: this.style.imageManager.cloneImages()
                } : {
                    style: null,
                    images: {}
                };
            }
            isStyleLoaded() {
                return this.style ? this.style.loaded() : t.w("There is no style added to the map.");
            }
            addSource(e1, t) {
                return this._lazyInitEmptyStyle(), this.style.addSource(e1, t), this._update(!0);
            }
            isSourceLoaded(e1) {
                const i = this.style && this.style.tileManagers[e1];
                if (void 0 !== i) return i.loaded();
                this.fire(new t.k(new Error(`There is no tile manager with ID '${e1}'`)));
            }
            setTerrain(e1) {
                if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), e1) {
                    const i = this.style.tileManagers[e1.source];
                    if (!i) throw new Error(`cannot load terrain, because there exists no source with ID: ${e1.source}`);
                    null === this.terrain && i.reload();
                    for(const i in this.style._layers){
                        const a = this.style._layers[i];
                        "hillshade" === a.type && a.source === e1.source && t.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality."), "color-relief" === a.type && a.source === e1.source && t.w("You are using the same source for a color-relief layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                    }
                    this.terrain = new Ko(this.painter, i, e1), this.painter.renderToTexture = new Jo(this.painter, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._terrainDataCallback = (t)=>{
                        var i;
                        "style" === t.dataType ? this.terrain.tileManager.freeRtt() : "source" === t.dataType && t.tile && (t.sourceId !== e1.source || this._elevationFreeze || (this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))), "image" === (null === (i = t.source) || void 0 === i ? void 0 : i.type) ? this.terrain.tileManager.freeRtt() : this.terrain.tileManager.freeRtt(t.tile.tileID));
                    }, this.style.on("data", this._terrainDataCallback);
                } else this.terrain && this.terrain.tileManager.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0);
                return this.fire(new t.l("terrain", {
                    terrain: e1
                })), this;
            }
            getTerrain() {
                var e1, t;
                return null !== (t = null === (e1 = this.terrain) || void 0 === e1 ? void 0 : e1.options) && void 0 !== t ? t : null;
            }
            areTilesLoaded() {
                const e1 = this.style && this.style.tileManagers;
                for(const t in e1){
                    const i = e1[t]._tiles;
                    for(const e1 in i){
                        const t = i[e1];
                        if ("loaded" !== t.state && "errored" !== t.state) return !1;
                    }
                }
                return !0;
            }
            removeSource(e1) {
                return this.style.removeSource(e1), this._update(!0);
            }
            getSource(e1) {
                return this.style.getSource(e1);
            }
            setSourceTileLodParams(e1, t, i) {
                if (i) {
                    const a = this.getSource(i);
                    if (!a) throw new Error(`There is no source with ID "${i}", cannot set LOD parameters`);
                    a.calculateTileZoom = we(Math.max(1, e1), Math.max(1, t));
                } else for(const i in this.style.tileManagers)this.style.tileManagers[i].getSource().calculateTileZoom = we(Math.max(1, e1), Math.max(1, t));
                return this._update(!0), this;
            }
            refreshTiles(e1, i) {
                const a = this.style.tileManagers[e1];
                if (!a) throw new Error(`There is no tile manager with ID "${e1}", cannot refresh tile`);
                void 0 === i ? a.reload(!0) : a.refreshTiles(i.map((e1)=>new t.ad(e1.z, e1.x, e1.y)));
            }
            addImage(e1, i, a = {}) {
                const { pixelRatio: r = 1, sdf: o = !1, stretchX: s, stretchY: l, content: c, textFitWidth: h, textFitHeight: u } = a;
                if (this._lazyInitEmptyStyle(), !(i instanceof HTMLImageElement || t.b(i))) {
                    if (void 0 === i.width || void 0 === i.height) return this.fire(new t.k(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    {
                        const { width: a, height: n, data: d } = i, _ = i;
                        return this.style.addImage(e1, {
                            data: new t.R({
                                width: a,
                                height: n
                            }, new Uint8Array(d)),
                            pixelRatio: r,
                            stretchX: s,
                            stretchY: l,
                            content: c,
                            textFitWidth: h,
                            textFitHeight: u,
                            sdf: o,
                            version: 0,
                            userImage: _
                        }), _.onAdd && _.onAdd(this, e1), this;
                    }
                }
                {
                    const { width: a, height: d, data: _ } = n.getImageData(i);
                    this.style.addImage(e1, {
                        data: new t.R({
                            width: a,
                            height: d
                        }, _),
                        pixelRatio: r,
                        stretchX: s,
                        stretchY: l,
                        content: c,
                        textFitWidth: h,
                        textFitHeight: u,
                        sdf: o,
                        version: 0
                    });
                }
            }
            updateImage(e1, i) {
                const a = this.style.getImage(e1);
                if (!a) return this.fire(new t.k(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                const r = i instanceof HTMLImageElement || t.b(i) ? n.getImageData(i) : i, { width: o, height: s, data: l } = r;
                if (void 0 === o || void 0 === s) return this.fire(new t.k(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                if (o !== a.data.width || s !== a.data.height) return this.fire(new t.k(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                const c = !(i instanceof HTMLImageElement || t.b(i));
                return a.data.replace(l, c), this.style.updateImage(e1, a), this;
            }
            getImage(e1) {
                return this.style.getImage(e1);
            }
            hasImage(e1) {
                return e1 ? !!this.style.getImage(e1) : (this.fire(new t.k(new Error("Missing required image id"))), !1);
            }
            removeImage(e1) {
                this.style.removeImage(e1);
            }
            loadImage(e1) {
                return g.getImage(this._requestManager.transformRequest(e1, "Image"), new AbortController);
            }
            listImages() {
                return this.style.listImages();
            }
            addLayer(e1, t) {
                return this._lazyInitEmptyStyle(), this.style.addLayer(e1, t), this._update(!0);
            }
            moveLayer(e1, t) {
                return this.style.moveLayer(e1, t), this._update(!0);
            }
            removeLayer(e1) {
                return this.style.removeLayer(e1), this._update(!0);
            }
            getLayer(e1) {
                return this.style.getLayer(e1);
            }
            getLayersOrder() {
                return this.style.getLayersOrder();
            }
            setLayerZoomRange(e1, t, i) {
                return this.style.setLayerZoomRange(e1, t, i), this._update(!0);
            }
            setFilter(e1, t, i = {}) {
                return this.style.setFilter(e1, t, i), this._update(!0);
            }
            getFilter(e1) {
                return this.style.getFilter(e1);
            }
            setPaintProperty(e1, t, i, a = {}) {
                return this.style.setPaintProperty(e1, t, i, a), this._update(!0);
            }
            getPaintProperty(e1, t) {
                return this.style.getPaintProperty(e1, t);
            }
            setLayoutProperty(e1, t, i, a = {}) {
                return this.style.setLayoutProperty(e1, t, i, a), this._update(!0);
            }
            getLayoutProperty(e1, t) {
                return this.style.getLayoutProperty(e1, t);
            }
            setGlyphs(e1, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setGlyphs(e1, t), this._update(!0);
            }
            getGlyphs() {
                return this.style.getGlyphsUrl();
            }
            addSprite(e1, t, i = {}) {
                return this._lazyInitEmptyStyle(), this.style.addSprite(e1, t, i, (e1)=>{
                    e1 || this._update(!0);
                }), this;
            }
            removeSprite(e1) {
                return this._lazyInitEmptyStyle(), this.style.removeSprite(e1), this._update(!0);
            }
            getSprite() {
                return this.style.getSprite();
            }
            setSprite(e1, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setSprite(e1, t, (e1)=>{
                    e1 || this._update(!0);
                }), this;
            }
            setLight(e1, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setLight(e1, t), this._update(!0);
            }
            getLight() {
                return this.style.getLight();
            }
            setSky(e1, t = {}) {
                return this._lazyInitEmptyStyle(), this.style.setSky(e1, t), this._update(!0);
            }
            getSky() {
                return this.style.getSky();
            }
            setFeatureState(e1, t) {
                return this.style.setFeatureState(e1, t), this._update();
            }
            removeFeatureState(e1, t) {
                return this.style.removeFeatureState(e1, t), this._update();
            }
            getFeatureState(e1) {
                return this.style.getFeatureState(e1);
            }
            getContainer() {
                return this._container;
            }
            getCanvasContainer() {
                return this._canvasContainer;
            }
            getCanvas() {
                return this._canvas;
            }
            _containerDimensions() {
                let e1 = 0, t = 0;
                return this._container && (e1 = this._container.clientWidth || 400, t = this._container.clientHeight || 300), [
                    e1,
                    t
                ];
            }
            _setupContainer() {
                const e1 = this._container;
                e1.classList.add("maplibregl-map");
                const t = this._canvasContainer = h.create("div", "maplibregl-canvas-container", e1);
                this._interactive && t.classList.add("maplibregl-interactive"), this._canvas = h.create("canvas", "maplibregl-canvas", t), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", this._interactive ? "0" : "-1"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region");
                const i = this._containerDimensions(), a = this._getClampedPixelRatio(i[0], i[1]);
                this._resizeCanvas(i[0], i[1], a);
                const r = this._controlContainer = h.create("div", "maplibregl-control-container", e1), o = this._controlPositions = {};
                [
                    "top-left",
                    "top-right",
                    "bottom-left",
                    "bottom-right"
                ].forEach((e1)=>{
                    o[e1] = h.create("div", `maplibregl-ctrl-${e1} `, r);
                }), this._container.addEventListener("scroll", this._onMapScroll, !1);
            }
            _resizeCanvas(e1, t, i) {
                this._canvas.width = Math.floor(i * e1), this._canvas.height = Math.floor(i * t), this._canvas.style.width = `${e1}px`, this._canvas.style.height = `${t}px`;
            }
            _setupPainter() {
                const e1 = Object.assign(Object.assign({}, this._canvasContextAttributes), {
                    alpha: !0,
                    depth: !0,
                    stencil: !0,
                    premultipliedAlpha: !0
                });
                let t = null;
                this._canvas.addEventListener("webglcontextcreationerror", (i)=>{
                    t = {
                        requestedAttributes: e1
                    }, i && (t.statusMessage = i.statusMessage, t.type = i.type);
                }, {
                    once: !0
                });
                let i = null;
                if (i = this._canvasContextAttributes.contextType ? this._canvas.getContext(this._canvasContextAttributes.contextType, e1) : this._canvas.getContext("webgl2", e1) || this._canvas.getContext("webgl", e1), !i) {
                    const e1 = "Failed to initialize WebGL";
                    throw t ? (t.message = e1, new Error(JSON.stringify(t))) : new Error(e1);
                }
                this.painter = new jr(i, this.transform), u.testSupport(i);
            }
            migrateProjection(e1, i) {
                super.migrateProjection(e1, i), this.painter.transform = e1, this.fire(new t.l("projectiontransition", {
                    newProjection: this.style.projection.name
                }));
            }
            loaded() {
                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
            }
            _update(e1) {
                return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
            }
            _requestRenderFrame(e1) {
                return this._update(), this._renderTaskQueue.add(e1);
            }
            _cancelRenderFrame(e1) {
                this._renderTaskQueue.remove(e1);
            }
            _render(e1) {
                var i, a, r, o, s;
                const n = this._idleTriggered ? this._fadeDuration : 0, l = (null === (i = this.style.projection) || void 0 === i ? void 0 : i.transitionState) > 0;
                if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), this._removed) return;
                let h = !1;
                if (this.style && this._styleDirty) {
                    this._styleDirty = !1;
                    const e1 = this.transform.zoom, i = c();
                    this.style.zoomHistory.update(e1, i);
                    const a = new t.H(e1, {
                        now: i,
                        fadeDuration: n,
                        zoomHistory: this.style.zoomHistory,
                        transition: this.style.getTransition()
                    }), r = a.crossFadingFactor();
                    1 === r && r === this._crossFadingFactor || (h = !0, this._crossFadingFactor = r), this.style.update(a);
                }
                const u = (null === (a = this.style.projection) || void 0 === a ? void 0 : a.transitionState) > 0 !== l;
                null === (r = this.style.projection) || void 0 === r || r.setErrorQueryLatitudeDegrees(this.transform.center.lat), this.transform.setTransitionState(null === (o = this.style.projection) || void 0 === o ? void 0 : o.transitionState, null === (s = this.style.projection) || void 0 === s ? void 0 : s.latitudeErrorCorrectionRadians), this.style && (this._sourcesDirty || u) && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.tileManager.update(this.transform, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), !this._elevationFreeze && this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0)), this._placementDirty = this.style && this.style._updatePlacement(this.transform, this.showCollisionBoxes, n, this._crossSourceCollisions, u), this.painter.render(this.style, {
                    showTileBoundaries: this.showTileBoundaries,
                    showOverdrawInspector: this._showOverdrawInspector,
                    rotating: this.isRotating(),
                    zooming: this.isZooming(),
                    moving: this.isMoving(),
                    fadeDuration: n,
                    showPadding: this.showPadding
                }), this.fire(new t.l("render")), this.loaded() && !this._loaded && (this._loaded = !0, t.cF.mark(t.cG.load), this.fire(new t.l("load"))), this.style && (this.style.hasTransitions() || h) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                const d = this._sourcesDirty || this._styleDirty || this._placementDirty;
                return d || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t.l("idle")), !this._loaded || this._fullyLoaded || d || (this._fullyLoaded = !0, t.cF.mark(t.cG.fullLoad)), this;
            }
            redraw() {
                return this.style && (this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._render(0)), this;
            }
            remove() {
                var e1;
                this._hash && this._hash.remove();
                for (const e1 of this._controls)e1.onRemove(this);
                this._controls = [], this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && removeEventListener("online", this._onWindowOnline, !1), g.removeThrottleControl(this._imageQueueHandle), null === (e1 = this._resizeObserver) || void 0 === e1 || e1.disconnect();
                const i = this.painter.context.gl.getExtension("WEBGL_lose_context");
                (null == i ? void 0 : i.loseContext) && i.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), h.remove(this._canvasContainer), h.remove(this._controlContainer), this._container.removeEventListener("scroll", this._onMapScroll, !1), this._container.classList.remove("maplibregl-map"), t.cF.clearMetrics(), this._removed = !0, this.fire(new t.l("remove"));
            }
            triggerRepaint() {
                this.style && !this._frameRequest && (this._frameRequest = new AbortController, n.frame(this._frameRequest, (e1)=>{
                    t.cF.frame(e1), this._frameRequest = null;
                    try {
                        this._render(e1);
                    } catch (e1) {
                        if (!t.cH(e1) && !function(e1) {
                            return e1.message === Ja;
                        }(e1)) throw e1;
                    }
                }, ()=>{}));
            }
            get showTileBoundaries() {
                return !!this._showTileBoundaries;
            }
            set showTileBoundaries(e1) {
                this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
            }
            get showPadding() {
                return !!this._showPadding;
            }
            set showPadding(e1) {
                this._showPadding !== e1 && (this._showPadding = e1, this._update());
            }
            get showCollisionBoxes() {
                return !!this._showCollisionBoxes;
            }
            set showCollisionBoxes(e1) {
                this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 ? this.style._generateCollisionBoxes() : this._update());
            }
            get showOverdrawInspector() {
                return !!this._showOverdrawInspector;
            }
            set showOverdrawInspector(e1) {
                this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
            }
            get repaint() {
                return !!this._repaint;
            }
            set repaint(e1) {
                this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
            }
            get vertices() {
                return !!this._vertices;
            }
            set vertices(e1) {
                this._vertices = e1, this._update();
            }
            get version() {
                return ts;
            }
            getCameraTargetElevation() {
                return this.transform.elevation;
            }
            getProjection() {
                return this.style.getProjection();
            }
            setProjection(e1) {
                return this._lazyInitEmptyStyle(), this.style.setProjection(e1), this._update(!0);
            }
        }, e1.MapMouseEvent = Yr, e1.MapTouchEvent = Qr, e1.MapWheelEvent = Jr, e1.Marker = cs, e1.NavigationControl = class {
            constructor(e1){
                this._updateZoomButtons = ()=>{
                    const e1 = this._map.getZoom(), t = e1 === this._map.getMaxZoom(), i = e1 === this._map.getMinZoom();
                    this._zoomInButton.disabled = t, this._zoomOutButton.disabled = i, this._zoomInButton.setAttribute("aria-disabled", t.toString()), this._zoomOutButton.setAttribute("aria-disabled", i.toString());
                }, this._rotateCompassArrow = ()=>{
                    this._compassIcon.style.transform = this.options.visualizePitch && this.options.visualizeRoll ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), .5)}) rotateZ(${-this._map.transform.roll}deg) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizeRoll ? `rotate(${-this._map.transform.bearing - this._map.transform.roll}deg)` : `rotate(${-this._map.transform.bearing}deg)`;
                }, this._setButtonTitle = (e1, t)=>{
                    const i = this._map._getUIString(`NavigationControl.${t}`);
                    e1.title = i, e1.setAttribute("aria-label", i);
                }, this.options = t.e({}, as, e1), this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (e1)=>this._map.zoomIn({}, {
                        originalEvent: e1
                    })), h.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (e1)=>this._map.zoomOut({}, {
                        originalEvent: e1
                    })), h.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (e1)=>{
                    this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                        originalEvent: e1
                    }) : this._map.resetNorth({}, {
                        originalEvent: e1
                    });
                }), this._compassIcon = h.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
            }
            onAdd(e1) {
                return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.on("roll", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new rs(this._map, this._compass, this.options.visualizePitch)), this._container;
            }
            onRemove() {
                h.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.off("roll", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
            }
            _createButton(e1, t) {
                const i = h.create("button", e1, this._container);
                return i.type = "button", i.addEventListener("click", t), i;
            }
        }, e1.Popup = class extends t.E {
            constructor(e1){
                super(), this._updateOpacity = ()=>{
                    void 0 !== this.options.locationOccludedOpacity && (this._container.style.opacity = this._map.transform.isLocationOccluded(this.getLngLat()) ? `${this.options.locationOccludedOpacity}` : "");
                }, this.remove = ()=>(this._content && h.remove(this._content), this._container && (h.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), this._map._canvasContainer.classList.remove("maplibregl-track-pointer"), delete this._map, this.fire(new t.l("close"))), this), this._onMouseUp = (e1)=>{
                    this._update(e1.point);
                }, this._onMouseMove = (e1)=>{
                    this._update(e1.point);
                }, this._onDrag = (e1)=>{
                    this._update(e1.point);
                }, this._update = (e1)=>{
                    if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
                    if (!this._container) {
                        if (this._container = h.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = h.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (const e1 of this.options.className.split(" "))this._container.classList.add(e1);
                        this._closeButton && this._closeButton.setAttribute("aria-label", this._map._getUIString("Popup.Close")), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
                    }
                    if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = ss(this._lngLat, this._flatPos, this._map.transform, this._trackPointer), this._trackPointer && !e1) return;
                    const t = this._flatPos = this._pos = this._trackPointer && e1 ? e1 : this._map.project(this._lngLat);
                    this._map.terrain && (this._flatPos = this._trackPointer && e1 ? e1 : this._map.transform.locationToScreenPoint(this._lngLat));
                    let i = this.options.anchor;
                    const a = vs(this.options.offset);
                    if (!i) {
                        const e1 = this._container.offsetWidth, r = this._container.offsetHeight;
                        let o;
                        o = t.y + a.bottom.y < r ? [
                            "top"
                        ] : t.y > this._map.transform.height - r ? [
                            "bottom"
                        ] : [], t.x < e1 / 2 ? o.push("left") : t.x > this._map.transform.width - e1 / 2 && o.push("right"), i = 0 === o.length ? "bottom" : o.join("-");
                    }
                    let r = t.add(a[i]);
                    this.options.subpixelPositioning || (r = r.round()), h.setTransform(this._container, `${ns[i]} translate(${r.x}px,${r.y}px)`), ls(this._container, i, "popup"), this._updateOpacity();
                }, this._onClose = ()=>{
                    this.remove();
                }, this.options = t.e(Object.create(fs), e1);
            }
            addTo(e1) {
                return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new t.l("open")), this;
            }
            isOpen() {
                return !!this._map;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e1) {
                return this._lngLat = t.V.convert(e1), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
            }
            trackPointer() {
                return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
            }
            getElement() {
                return this._container;
            }
            setText(e1) {
                return this.setDOMContent(document.createTextNode(e1));
            }
            setHTML(e1) {
                const t = document.createDocumentFragment(), i = document.createElement("body");
                let a;
                for(i.innerHTML = e1; a = i.firstChild, a;)t.appendChild(a);
                return this.setDOMContent(t);
            }
            getMaxWidth() {
                var e1;
                return null === (e1 = this._container) || void 0 === e1 ? void 0 : e1.style.maxWidth;
            }
            setMaxWidth(e1) {
                return this.options.maxWidth = e1, this._update(), this;
            }
            setDOMContent(e1) {
                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                else this._content = h.create("div", "maplibregl-popup-content", this._container);
                return this._content.appendChild(e1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
            }
            addClassName(e1) {
                return this._container && this._container.classList.add(e1), this;
            }
            removeClassName(e1) {
                return this._container && this._container.classList.remove(e1), this;
            }
            setOffset(e1) {
                return this.options.offset = e1, this._update(), this;
            }
            toggleClassName(e1) {
                if (this._container) return this._container.classList.toggle(e1);
            }
            setSubpixelPositioning(e1) {
                this.options.subpixelPositioning = e1;
            }
            _createCloseButton() {
                this.options.closeButton && (this._closeButton = h.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
            }
            _focusFirstElement() {
                if (!this.options.focusAfterOpen || !this._container) return;
                const e1 = this._container.querySelector(gs);
                e1 && e1.focus();
            }
        }, e1.RasterDEMTileSource = Y, e1.RasterTileSource = K, e1.ScaleControl = class {
            constructor(e1){
                this._onMove = ()=>{
                    ps(this._map, this._container, this.options);
                }, this.setUnit = (e1)=>{
                    this.options.unit = e1, ps(this._map, this._container, this.options);
                }, this.options = Object.assign(Object.assign({}, _s), e1);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(e1) {
                return this._map = e1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", e1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
            }
            onRemove() {
                h.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
            }
        }, e1.ScrollZoomHandler = Do, e1.Style = Si, e1.TerrainControl = class {
            constructor(e1){
                this._toggleTerrain = ()=>{
                    this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                }, this._updateTerrainIcon = ()=>{
                    this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.Disable")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.Enable"));
                }, this.options = e1;
            }
            onAdd(e1) {
                return this._map = e1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = h.create("button", "maplibregl-ctrl-terrain", this._container), h.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
            }
            onRemove() {
                h.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
            }
        }, e1.TwoFingersTouchPitchHandler = Co, e1.TwoFingersTouchRotateHandler = To, e1.TwoFingersTouchZoomHandler = yo, e1.TwoFingersTouchZoomRotateHandler = Bo, e1.VectorTileSource = X, e1.VideoSource = ie, e1.addSourceType = (e1, i)=>t._(void 0, void 0, void 0, function*() {
                if (oe(e1)) throw new Error(`A source type called "${e1}" already exists.`);
                ((e1, t)=>{
                    re[e1] = t;
                })(e1, i);
            }), e1.clearPrewarmedResources = function() {
            const e1 = B;
            e1 && (e1.isPreloaded() && 1 === e1.numActive() ? (e1.release(L), B = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, e1.createTileMesh = ii, e1.getMaxParallelImageRequests = function() {
            return t.a.MAX_PARALLEL_IMAGE_REQUESTS;
        }, e1.getRTLTextPluginStatus = function() {
            return ce().getRTLTextPluginStatus();
        }, e1.getVersion = function() {
            return xs;
        }, e1.getWorkerCount = function() {
            return k.workerCount;
        }, e1.getWorkerUrl = function() {
            return t.a.WORKER_URL;
        }, e1.importScriptInWorkers = function(e1) {
            return Z().broadcast("IS", e1);
        }, e1.isTimeFrozen = function() {
            return l.isFrozen();
        }, e1.now = c, e1.prewarm = function() {
            j().acquire(L);
        }, e1.restoreNow = function() {
            l.restoreNow();
        }, e1.setMaxParallelImageRequests = function(e1) {
            t.a.MAX_PARALLEL_IMAGE_REQUESTS = e1;
        }, e1.setNow = function(e1) {
            l.setNow(e1);
        }, e1.setRTLTextPlugin = function(e1, t) {
            return ce().setRTLTextPlugin(e1, t);
        }, e1.setWorkerCount = function(e1) {
            k.workerCount = e1;
        }, e1.setWorkerUrl = function(e1) {
            t.a.WORKER_URL = e1;
        };
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'maplibregl'
    var maplibregl$1 = maplibregl;
    return maplibregl$1;
});


var $cbb8114b66dd9fa5$var$video_player;
var $cbb8114b66dd9fa5$var$map;
var $cbb8114b66dd9fa5$var$scene_3d;
const $cbb8114b66dd9fa5$var$video_width = 1920; //player.currentWidth();
const $cbb8114b66dd9fa5$var$video_height = 1440; //player.currentHeight();
function $cbb8114b66dd9fa5$var$dimension(el) {
    let elmHeight;
    let elmMargin;
    elmHeight = el.getBoundingClientRect().height;
    elmMargin = parseFloat(document.defaultView.getComputedStyle(el, '').getPropertyValue('margin-top')) + parseFloat(document.defaultView.getComputedStyle(el, '').getPropertyValue('margin-bottom'));
    return elmHeight + elmMargin;
}
const $cbb8114b66dd9fa5$var$MAX_WIDTH_PX = 1400;
function $cbb8114b66dd9fa5$var$css_ratio_from(px) {
    return Math.min(px, px / $cbb8114b66dd9fa5$var$MAX_WIDTH_PX * window.innerWidth);
}
function $cbb8114b66dd9fa5$var$css_full_ratio_from(px) {
    let vw = px / $cbb8114b66dd9fa5$var$MAX_WIDTH_PX * 100;
    return `min(${px}px, ${vw}vw)`;
}
// Converts from degrees to radians.
function $cbb8114b66dd9fa5$var$toRadians(degrees) {
    return degrees * Math.PI / 180;
}
// Converts from radians to degrees.
function $cbb8114b66dd9fa5$var$toDegrees(radians) {
    return radians * 180 / Math.PI;
}
function $cbb8114b66dd9fa5$var$distance(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = $cbb8114b66dd9fa5$var$toRadians(lat2 - lat1); // deg2rad below
    var dLon = $cbb8114b66dd9fa5$var$toRadians(lon2 - lon1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos($cbb8114b66dd9fa5$var$toRadians(lat1)) * Math.cos($cbb8114b66dd9fa5$var$toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
}
var $8d436ee8e3121a92$exports = {};
$8d436ee8e3121a92$exports = import.meta.resolve("810YX");


var $7127cc635fef0ed6$exports = {};
$7127cc635fef0ed6$exports = import.meta.resolve("7lVQD");


var $572427e867273bf5$exports = {};
$572427e867273bf5$exports = import.meta.resolve("cb20T");


var $8e26b63165896979$exports = {};
$8e26b63165896979$exports = import.meta.resolve("lumK9");


var $d18813b0615c6c61$exports = {};
$d18813b0615c6c61$exports = import.meta.resolve("gasIx");


var $a54551de0f7cba59$exports = {};
$a54551de0f7cba59$exports = import.meta.resolve("atdX2");


var $ed40d4f4c611bc17$exports = {};
$ed40d4f4c611bc17$exports = import.meta.resolve("dOOoK");


var $0fac4dc6d1ff08df$exports = {};
$0fac4dc6d1ff08df$exports = import.meta.resolve("dHlXw");


var $a16f68d88730efb5$exports = {};
$a16f68d88730efb5$exports = import.meta.resolve("9E5Ga");


var $dfd3c79d43c93619$exports = {};
$dfd3c79d43c93619$exports = import.meta.resolve("wVS7C");


let $cbb8114b66dd9fa5$var$green_url = "https://www.youtube.com/watch?v=JAGvRcyrb80";
let $cbb8114b66dd9fa5$var$blue_url = "https://www.youtube.com/watch?v=2byvAjiwiSM";
let $cbb8114b66dd9fa5$var$red_url = "https://www.youtube.com/watch?v=FWL9A0TYLxQ";
let $cbb8114b66dd9fa5$var$black_url = "https://www.youtube.com/watch?v=DtaHLxa4t5I";
let $cbb8114b66dd9fa5$var$sharktooth_url = "https://www.youtube.com/watch?v=wzm5QHfAfK0";
let $cbb8114b66dd9fa5$var$fourcross_url = "https://www.youtube.com/watch?v=vhytQRiw9co";
let $cbb8114b66dd9fa5$var$bernard_url = "https://www.youtube.com/watch?v=VxhPMqSt4Qs";
let $cbb8114b66dd9fa5$var$remontee_url = "https://youtu.be/b2ZxgZV-L2s";
let $cbb8114b66dd9fa5$var$green_timestamp = new Date("2025-11-22T13:19:38.000Z").getTime() / 1000;
let $cbb8114b66dd9fa5$var$blue_timestamp = new Date("2025-11-22T13:43:12.000Z").getTime() / 1000;
let $cbb8114b66dd9fa5$var$red_timestamp = new Date("2025-11-22T14:19:39.000Z").getTime() / 1000;
let $cbb8114b66dd9fa5$var$black_timestamp = new Date("2025-12-09T14:22:19.000Z").getTime() / 1000;
let $cbb8114b66dd9fa5$var$sharktooth_timestamp = new Date("2025-12-09T13:06:48.000Z").getTime() / 1000;
let $cbb8114b66dd9fa5$var$fourcross_timestamp = new Date("2025-12-09T12:28:57.000Z").getTime() / 1000;
let $cbb8114b66dd9fa5$var$bernard_timestamp = new Date("2025-11-22T14:02:31.000Z").getTime() / 1000;
let $cbb8114b66dd9fa5$var$remontee_timestamp = new Date("2025-11-22T14:09:06.000Z").getTime() / 1000;
let $cbb8114b66dd9fa5$var$map_tracks = {
    "green": {
        gpx: $572427e867273bf5$exports,
        url: $cbb8114b66dd9fa5$var$green_url,
        timestamp: $cbb8114b66dd9fa5$var$green_timestamp,
        color: "rgb(39, 174, 96)",
        view: {
            center: [
                6.76060,
                47.59474
            ],
            zoom: 16.02,
            zoom_follow: 17.5,
            bearing: -82.99
        },
        view_responsive_vertical: {
            center: [
                6.7608972513043,
                47.594939113959526
            ],
            zoom: 15.927023947591296,
            bearing: -32.85309525287504
        }
    },
    "blue": {
        gpx: $8e26b63165896979$exports,
        url: $cbb8114b66dd9fa5$var$blue_url,
        timestamp: $cbb8114b66dd9fa5$var$blue_timestamp,
        color: "rgb(52, 152, 219)",
        view: {
            center: [
                6.75249,
                47.59140
            ],
            zoom: 14.7,
            zoom_follow: 17.5,
            bearing: 31.93
        },
        view_responsive_vertical: {
            center: [
                6.752228803243042,
                47.59135310352096
            ],
            zoom: 14.780748863710318,
            bearing: -25.662482714581074
        }
    },
    "red": {
        gpx: $d18813b0615c6c61$exports,
        url: $cbb8114b66dd9fa5$var$red_url,
        timestamp: $cbb8114b66dd9fa5$var$red_timestamp,
        color: "rgb(231, 76, 60)",
        view: {
            center: [
                6.75249,
                47.59140
            ],
            zoom: 14.7,
            zoom_follow: 17.5,
            bearing: 31.93
        },
        view_responsive_vertical: {
            center: [
                6.752228803243042,
                47.59135310352096
            ],
            zoom: 14.780748863710318,
            bearing: -25.662482714581074
        }
    },
    "black": {
        gpx: $a54551de0f7cba59$exports,
        url: $cbb8114b66dd9fa5$var$black_url,
        timestamp: $cbb8114b66dd9fa5$var$black_timestamp,
        color: "rgb(44, 62, 80)",
        view: {
            center: [
                6.75249,
                47.59140
            ],
            zoom: 14.7,
            zoom_follow: 17.5,
            bearing: 31.93
        },
        view_responsive_vertical: {
            center: [
                6.752228803243042,
                47.59135310352096
            ],
            zoom: 14.780748863710318,
            bearing: -25.662482714581074
        }
    },
    "sharktooth": {
        gpx: $ed40d4f4c611bc17$exports,
        url: $cbb8114b66dd9fa5$var$sharktooth_url,
        timestamp: $cbb8114b66dd9fa5$var$sharktooth_timestamp,
        color: "rgba(202, 72, 57, 1)",
        view: {
            center: [
                6.75392,
                47.59093
            ],
            zoom: 16.6,
            zoom_follow: 17.5,
            bearing: -20
        },
        view_responsive_vertical: {
            center: [
                6.75392,
                47.59082
            ],
            zoom: 16.73,
            bearing: -15
        }
    },
    "fourcross": {
        gpx: $0fac4dc6d1ff08df$exports,
        url: $cbb8114b66dd9fa5$var$fourcross_url,
        timestamp: $cbb8114b66dd9fa5$var$fourcross_timestamp,
        color: "rgb(155, 89, 182)",
        view: {
            center: [
                6.75490,
                47.59202
            ],
            zoom: 16.9,
            zoom_follow: 17.5,
            bearing: -20
        },
        view_responsive_vertical: {
            center: [
                6.75476,
                47.59210
            ],
            zoom: 16.95,
            bearing: -71.35
        }
    },
    "bernard": {
        gpx: $a16f68d88730efb5$exports,
        url: $cbb8114b66dd9fa5$var$bernard_url,
        timestamp: $cbb8114b66dd9fa5$var$bernard_timestamp,
        color: "rgb(230, 126, 34)",
        view: {
            center: [
                6.75558,
                47.59099
            ],
            zoom: 19.45,
            zoom_follow: 19.45,
            bearing: 9.46
        },
        view_responsive_vertical: {
            center: [
                6.75557,
                47.59100
            ],
            zoom: 19.43,
            bearing: -31.72
        }
    },
    "remontee": {
        gpx: $dfd3c79d43c93619$exports,
        url: $cbb8114b66dd9fa5$var$remontee_url,
        timestamp: $cbb8114b66dd9fa5$var$remontee_timestamp,
        color: "rgb(241, 196, 15)",
        view: {
            center: [
                6.75463,
                47.59165
            ],
            zoom: 16.4,
            zoom_follow: 17,
            bearing: 0.00
        },
        view_responsive_vertical: {
            center: [
                6.75431,
                47.59162
            ],
            zoom: 16.32,
            bearing: -59.02
        }
    }
};
document.addEventListener("DOMContentLoaded", ()=>{
    let video_el = document.getElementById("header-vid");
    $cbb8114b66dd9fa5$var$video_player = (0, $hqDLR.default)(video_el, {
        "controls": false,
        "autoplay": "muted",
        "preload": "auto",
        "loop": true
    });
    $cbb8114b66dd9fa5$var$resize_video($cbb8114b66dd9fa5$var$video_player);
    $cbb8114b66dd9fa5$var$video_player.ready(()=>{
        $cbb8114b66dd9fa5$var$video_player.on('timeupdate', ()=>{
            if ($cbb8114b66dd9fa5$var$video_player.currentTime() > 5) video_el.style.opacity = "1";
        });
        setTimeout(()=>{
            $cbb8114b66dd9fa5$var$video_player.currentTime(5);
            $cbb8114b66dd9fa5$var$video_player.play();
        }, 100);
        let interval = setInterval(()=>{
            if ($cbb8114b66dd9fa5$var$video_player.currentTime() > 5) {
                clearTimeout(interval);
                return;
            }
            $cbb8114b66dd9fa5$var$video_player.currentTime(5);
            $cbb8114b66dd9fa5$var$video_player.play();
        }, 1000);
    });
    let anime = document.getElementById("H2R-anime");
    setTimeout(()=>{
        anime.style.display = "flex";
        (0, $754ef84e366f6443$export$e3607ec2d7a891c4)("#H2R-anime>img", {
            scale: [
                100,
                1
            ],
            x: {
                from: (0, $754ef84e366f6443$export$ef0b4d89074db4d0)("200%", {
                    grid: [
                        3,
                        1
                    ],
                    from: 'center',
                    axis: 'x'
                }),
                to: '0%'
            },
            delay: (0, $754ef84e366f6443$export$ef0b4d89074db4d0)(300),
            ease: 'in(1.81)'
        });
        $cbb8114b66dd9fa5$var$create3Dscene();
    }, 200);
    $cbb8114b66dd9fa5$var$map = new $cbb8114b66dd9fa5$var$MapManager();
    $cbb8114b66dd9fa5$var$map.init("map", [
        6.75586,
        47.59157
    ], 14.4, true);
    let mapex = new $cbb8114b66dd9fa5$var$MapManager();
    mapex.init("map-example", [
        6.78586,
        47.56697
    ], 12.1);
    let carousels = document.getElementsByClassName("gallery-container");
    for(let i = 0; i < carousels.length; i++){
        let carousel = carousels[i];
        let left_btn = carousel.getElementsByClassName("left")[0];
        let right_btn = carousel.getElementsByClassName("right")[0];
        let gallery = carousel.getElementsByClassName("gallery")[0];
        let els = gallery.getElementsByClassName("image");
        let el_i = 0;
        let video_js_players = [];
        for(let j = 0; j < els.length; j++){
            // if tag name is video-js create videojs player
            if (els[j].tagName.toLowerCase() == "video-js") {
                let vid_player = (0, $hqDLR.default)(els[j], {
                    "controls": false,
                    "autoplay": false,
                    "preload": "auto"
                });
                video_js_players.push(vid_player);
            } else video_js_players.push(null);
            els[j].style.opacity = j == 0 ? "1" : "0";
        }
        left_btn.addEventListener("click", (e)=>{
            let next_i = el_i - 1;
            if (next_i < 0) next_i = els.length - 1;
            let last = els[el_i];
            let next = els[next_i];
            last.style.opacity = "0";
            next.style.opacity = "1";
            el_i = next_i;
            if (video_js_players[el_i]) {
                video_js_players[el_i].currentTime(0);
                video_js_players[el_i].play();
            }
        });
        right_btn.addEventListener("click", (e)=>{
            let next_i = el_i + 1;
            if (next_i >= els.length) next_i = 0;
            let last = els[el_i];
            let next = els[next_i];
            last.style.opacity = "0";
            next.style.opacity = "1";
            el_i = next_i;
            if (video_js_players[el_i]) {
                video_js_players[el_i].currentTime(0);
                video_js_players[el_i].play();
            }
        });
    }
    $cbb8114b66dd9fa5$var$resize_maps();
});
window.addEventListener("resize", (e)=>{
    $cbb8114b66dd9fa5$var$resize_video($cbb8114b66dd9fa5$var$video_player);
    $cbb8114b66dd9fa5$var$resize_maps();
    $cbb8114b66dd9fa5$var$scene_3d.resize(window.innerWidth, window.innerHeight);
});
window.addEventListener("scroll", (e)=>{
    $cbb8114b66dd9fa5$var$scene_3d.update_scroll(e);
    $cbb8114b66dd9fa5$var$update_header();
});
const $cbb8114b66dd9fa5$var$scroll_sections = [
    1.7,
    2.82,
    3.2,
    3.5,
    10
];
function $cbb8114b66dd9fa5$var$update_header() {
    $cbb8114b66dd9fa5$var$scene_3d.compute_scroll_px(1);
// let header = document.getElementById("header-nav") as HTMLElement;
// let ti = 0;
// while (scene_3d.compute_scroll_px(scroll_sections[ti]) < window.scrollY && ti < scroll_sections.length - 1){
//     ti++;
// }
// for (let i = 0; i < scroll_sections.length; i++) {
//     if (i != ti)
//         header.children[i].setAttribute("class", ``);
//     else
//         header.children[i].setAttribute("class", `highlighted`);
// }
}
function $cbb8114b66dd9fa5$var$resize_video(player) {
    let player_el = player.el();
    let header = player_el.parentElement;
    let header_width = header?.offsetWidth || 0;
    let header_height = header?.offsetHeight || 0;
    // resize video to cover header in width or height
    let header_ratio = header_width / header_height;
    let video_ratio = $cbb8114b66dd9fa5$var$video_width / $cbb8114b66dd9fa5$var$video_height;
    if (header_ratio > video_ratio) {
        let new_video_height = header_width / video_ratio;
        player_el.style.width = `${header_width}px`;
        player_el.style.height = `${new_video_height}px`;
        player.width(header_width);
        player.height(new_video_height);
    } else {
        let new_video_width = header_height * video_ratio;
        player_el.style.width = `${new_video_width}px`;
        player_el.style.height = `${header_height}px`;
        player.width(new_video_width);
        player.height(header_height);
    }
}
function $cbb8114b66dd9fa5$var$resize_maps() {
    let maps = document.getElementsByClassName("map");
    for(let i = 0; i < maps.length; i++){
        let map_el = maps[i];
        $cbb8114b66dd9fa5$var$resize_map(map_el);
    }
}
function $cbb8114b66dd9fa5$var$resize_map(map_el) {
    let parent = map_el.parentElement;
    // get map width (without scale)
    let w = getComputedStyle(map_el).width;
    let parent_width = parent.offsetWidth;
    let r = parent_width / parseFloat(w);
    map_el.style.scale = `${Math.ceil(r * 1000) / 1000}`;
}
function $cbb8114b66dd9fa5$var$create3Dscene() {
    $cbb8114b66dd9fa5$var$scene_3d = new $cbb8114b66dd9fa5$var$scene3D();
    $cbb8114b66dd9fa5$var$scene_3d.init();
    $cbb8114b66dd9fa5$var$scene_3d.resize(window.innerWidth, window.innerHeight);
    setTimeout(()=>{
        $cbb8114b66dd9fa5$var$scene_3d.resize(window.innerWidth, window.innerHeight);
    }, 500);
}
function $cbb8114b66dd9fa5$export$883528fb0afa7177(r, g, b) {
    return (r << 16) + (g << 8) + b;
}
var $f627143f365cd1ec$exports = {};
$f627143f365cd1ec$exports = import.meta.resolve("hHLac");


const $cbb8114b66dd9fa5$var$VIEW = {
    fov: 30,
    near: 0.1,
    far: 1000
};
const $cbb8114b66dd9fa5$var$WIDTH_HEIGHT = {
    width: 2.0,
    height: 1.8
};
const $cbb8114b66dd9fa5$var$FRAME_RATE = 25;
const $cbb8114b66dd9fa5$var$target = new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0.4, 0);
const $cbb8114b66dd9fa5$var$TILE_WIDTH = 300;
const $cbb8114b66dd9fa5$var$TILE_WIDTH_RESPONSIVE_VERTICAL = 0.7;
const $cbb8114b66dd9fa5$var$TILE_HEIGHT = 57;
const $cbb8114b66dd9fa5$var$TILE_HEIGHT_RESPONSIVE_VERTICAL = 110;
class $cbb8114b66dd9fa5$var$scene3D {
    init() {
        this.scene = new $4a792688e08e5cd7$export$38af1803e3442a7f();
        // this.scene.background = new THREE.Color(rgb2hex(169, 199, 201));
        this.view = new $4a792688e08e5cd7$export$74e4ae24825f68d7($cbb8114b66dd9fa5$var$VIEW.fov, window.innerWidth / window.innerHeight, $cbb8114b66dd9fa5$var$VIEW.near, $cbb8114b66dd9fa5$var$VIEW.far);
        this.view.position.x = 4;
        this.view.position.y = 0.5;
        this.view.position.z = 0;
        this.view.lookAt(0, 0.5, 0);
        // const ambientLight = new THREE.AmbientLight(0x999999); // soft white light
        // this.scene.add(ambientLight);
        const directionalLight = new $4a792688e08e5cd7$export$3fea33cc9972c868($cbb8114b66dd9fa5$export$883528fb0afa7177(252, 249, 227), 1.0);
        directionalLight.position.set(-1, 0.5, -3);
        directionalLight.castShadow = false;
        this.scene.add(directionalLight);
        const directionalLight3 = new $4a792688e08e5cd7$export$3fea33cc9972c868($cbb8114b66dd9fa5$export$883528fb0afa7177(252, 249, 227), 1.5);
        directionalLight3.position.set(3, 2, 0);
        directionalLight3.castShadow = false;
        this.scene.add(directionalLight3);
        const directionalLight2 = new $4a792688e08e5cd7$export$3fea33cc9972c868($cbb8114b66dd9fa5$export$883528fb0afa7177(96, 123, 224), 4.0);
        directionalLight2.position.set(0, -1, 1);
        directionalLight2.castShadow = false;
        this.scene.add(directionalLight2);
        this.renderer = new $5292c45f2b641b96$export$f6cc00ef28d7cf97({
            antialias: true,
            alpha: true,
            canvas: document.getElementById('threejs')
        });
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = $4a792688e08e5cd7$export$a47c4b43a1be34f0;
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.toneMapping = $4a792688e08e5cd7$export$74b25e54b3bcd548;
        this.renderer.toneMappingExposure = 1.2;
        const dracoLoader = new (0, $b717453e1584735e$export$45c25de53be259ac)();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
        const gltfLoader = new (0, $fa36f6c1e44235b5$export$aa93f11e7884f0f4)();
        gltfLoader.setDRACOLoader(dracoLoader);
        // replace bike with a cube
        this.bike = new $4a792688e08e5cd7$export$eb2fcfdbd7ba97d4();
        this.bike.position.set(0, 0.5, 0.15);
        gltfLoader.load($f627143f365cd1ec$exports, (gltf)=>{
            let pos = this.bike.position.clone();
            let scale = this.bike.scale.clone();
            this.bike = gltf.scene;
            this.bike.position.set(pos.x, pos.y, pos.z);
            this.bike.scale.set(scale.x, scale.y, scale.z);
            this.compute_geometry(this.bike);
            this.scene.add(this.bike);
            this.update_scroll();
            this.anime_ids = {}; // update
            document.getElementById("loading").style.display = "none";
        });
        setInterval(()=>{
            this.renderer.render(this.scene, this.view);
            this.update();
        }, 1000 / $cbb8114b66dd9fa5$var$FRAME_RATE);
        this.header = document.getElementById("header");
        this.svg = document.getElementById("bike-svg");
        this.tiles = document.getElementsByClassName("tile");
        this.go_to_tiles_btns = document.getElementsByClassName("tile-header-btn");
        this.forced_update = false;
        for(let i = 0; i < this.tiles.length; i++){
            let polyline = document.createElementNS("http://www.w3.org/2000/svg", "polyline");
            polyline.setAttribute("fill", "none");
            polyline.setAttribute("stroke", "#cc1d1d");
            polyline.setAttribute("stroke-width", "3");
            this.svg.appendChild(polyline);
            this.tiles_desc_hights.push(0);
            this.tiles_full_hights.push(0);
        }
        this.resize(window.innerWidth, window.innerHeight);
        document.getElementById("scroll-to-activites").addEventListener("click", (e)=>{
            this.emulate_scroll(0.728);
        });
        document.getElementById("scroll-to-activites2").addEventListener("click", (e)=>{
            this.emulate_scroll(0.728);
        });
        document.getElementById("h-accueil").addEventListener("click", (e)=>{
            e.preventDefault();
            history.pushState(null, "", "/home");
            this.emulate_scroll(0.728);
            if (this.resposive_vertical) document.getElementById("header-nav").style.display = "";
        });
        document.getElementById("scroll-to-ecole").addEventListener("click", (e)=>{
            this.emulate_scroll(1);
        });
        document.getElementById("h-ecole").addEventListener("click", (e)=>{
            e.preventDefault();
            history.pushState(null, "", "/ecole");
            this.emulate_scroll(1);
            if (this.resposive_vertical) document.getElementById("header-nav").style.display = "";
        });
        document.getElementById("scroll-to-pistes").addEventListener("click", (e)=>{
            this.emulate_scroll(2);
        });
        document.getElementById("h-pistes").addEventListener("click", (e)=>{
            e.preventDefault();
            history.pushState(null, "", "/pistes");
            this.emulate_scroll(2);
            if (this.resposive_vertical) document.getElementById("header-nav").style.display = "";
        });
        document.getElementById("scroll-to-adultes").addEventListener("click", (e)=>{
            this.emulate_scroll(3);
        });
        document.getElementById("h-adultes").addEventListener("click", (e)=>{
            e.preventDefault();
            history.pushState(null, "", "/adultes");
            this.emulate_scroll(3);
            if (this.resposive_vertical) document.getElementById("header-nav").style.display = "";
        });
        document.getElementById("h-contactes").addEventListener("click", (e)=>{
            e.preventDefault();
            history.pushState(null, "", "/contact");
            this.emulate_scroll(4);
            if (this.resposive_vertical) document.getElementById("header-nav").style.display = "";
        });
        document.getElementById("contact0").addEventListener("click", (e)=>{
            this.emulate_scroll(4);
        });
        document.getElementById("contact1").addEventListener("click", (e)=>{
            this.emulate_scroll(4);
        });
        document.getElementById("btn-green").addEventListener("click", (e)=>{
            this.toggle_track_video(e, "green");
        });
        document.getElementById("btn-blue").addEventListener("click", (e)=>{
            this.toggle_track_video(e, "blue");
        });
        document.getElementById("btn-red").addEventListener("click", (e)=>{
            this.toggle_track_video(e, "red");
        });
        document.getElementById("btn-black").addEventListener("click", (e)=>{
            this.toggle_track_video(e, "black");
        });
        document.getElementById("btn-sharktooth").addEventListener("click", (e)=>{
            this.toggle_track_video(e, "sharktooth");
        });
        document.getElementById("btn-fourcross").addEventListener("click", (e)=>{
            this.toggle_track_video(e, "fourcross");
        });
        document.getElementById("btn-bernard").addEventListener("click", (e)=>{
            this.toggle_track_video(e, "bernard");
        });
        document.getElementById("btn-remontee").addEventListener("click", (e)=>{
            this.toggle_track_video(e, "remontee");
        });
        // read the url if (/ecole) scroll to ecole, if (/pistes) scroll to pistes, if (/adultes) scroll to adultes
        if (window.location.href.indexOf("/home") > -1) this.emulate_scroll(-1);
        else if (window.location.href.indexOf("/ecole") > -1) this.emulate_scroll(2.6);
        else if (window.location.href.indexOf("/pistes") > -1) this.emulate_scroll(2.82);
        else if (window.location.href.indexOf("/adultes") > -1) this.emulate_scroll(3.2);
        else if (window.location.href.indexOf("/contact") > -1) this.emulate_scroll(3.6);
        // after 3 seconds reset the url
        setTimeout(()=>{
            history.replaceState(null, "", "/");
        }, 3000);
        document.getElementById("menu-btn").addEventListener("click", (e)=>{
            let el = document.getElementById("header-nav");
            if (el.style.display == "flex") el.style.display = "";
            else el.style.display = "flex";
        });
        this.last_scroll = window.scrollY;
    }
    static hashCode(str) {
        var hash = 0, i, chr;
        if (str.length === 0) return hash;
        for(i = 0; i < str.length; i++){
            chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0; // Convert to 32bit integer
        }
        // force between 0 and 1
        return hash / 0x7FFFFFFF;
    }
    compute_geometry(parts, origin) {
        if (origin == undefined) origin = new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0, 0);
        if (parts.children.length > 0) for(let i = 0; i < parts.children.length; i++)this.compute_geometry(parts.children[i], origin.clone().add(parts.position));
        else if (parts.children.length == 0) {
            let part = parts;
            if (part.geometry) {
                this.bike_obj_pos[part.uuid] = part.position.clone().add(origin);
                let random_seed = "TIpP";
                let x = $cbb8114b66dd9fa5$var$scene3D.hashCode(random_seed + part.name.toUpperCase() + "X");
                let y = $cbb8114b66dd9fa5$var$scene3D.hashCode(random_seed + part.name + "Y");
                let z = $cbb8114b66dd9fa5$var$scene3D.hashCode(random_seed + part.name.toLowerCase() + "Z");
                this.bike_obj_start_pos[part.uuid] = new $4a792688e08e5cd7$export$64b5c384219d3699(x, y, z).normalize().multiplyScalar(5);
                this.bike_obj_times[part.uuid] = ($cbb8114b66dd9fa5$var$scene3D.hashCode("C" + random_seed + part.name) + 1) / 2.0 / 1.3;
            }
        }
    }
    // |====================================================================================================================
    // | RESIZE
    // |====================================================================================================================
    resize_3D_scene(w, h) {
        let scale = 1;
        let width = w;
        let height = h;
        if (width < height && w < 800) {
            scale = w / 800;
            height = h / scale;
            width = 800;
        }
        if (height < width && height < 800) {
            scale = h / 800;
            width = w / scale;
            height = 800;
        }
        // get element
        this.renderer.domElement.style.transform = `scale(${scale})`;
        this.view.aspect = width / height;
        const aspect = width / height;
        const fov = this.view.fov * (Math.PI / 180);
        const fovh = 2 * Math.atan(Math.tan(fov / 2) * aspect);
        let dx = 0 + Math.abs($cbb8114b66dd9fa5$var$WIDTH_HEIGHT.width / 2 / Math.tan(fovh / 2));
        let dy = 0 + Math.abs($cbb8114b66dd9fa5$var$WIDTH_HEIGHT.height / 2 / Math.tan(fov / 2));
        let cameraZ = Math.max(dx, dy);
        this.view.position.x = cameraZ;
        this.view.updateProjectionMatrix();
        this.renderer.setSize(width, height);
        this.svg.setAttribute("width", `${w}`);
        this.svg.setAttribute("height", `${h}`);
        this.svg.setAttribute("scale", `${scale}`);
        this.svg.setAttribute("viewBox", `0 0 ${w} ${h}`);
    }
    compute_tile_heights(width, height) {
        // add 3 polylines
        this.total_tile_height = 0;
        for(let i = 0; i < this.tiles.length; i++){
            let tile = this.tiles[i];
            if (this.resposive_vertical) tile.children[1].setAttribute("style", `display: block; width: ${$cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$MAX_WIDTH_PX * $cbb8114b66dd9fa5$var$TILE_WIDTH_RESPONSIVE_VERTICAL - 20)}px;`);
            else tile.children[1].setAttribute("style", `display: block; width: ${$cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$TILE_WIDTH - 20)}px;`);
            let title_h = $cbb8114b66dd9fa5$var$dimension(tile.children[0]);
            let title_d = $cbb8114b66dd9fa5$var$dimension(tile.children[1]);
            let tille_f = 0;
            if (tile.children.length > 2) tille_f = $cbb8114b66dd9fa5$var$dimension(tile.children[2]);
            this.tiles_desc_hights[i] = title_h + title_d + $cbb8114b66dd9fa5$var$css_ratio_from(20);
            this.tiles_full_hights[i] = title_h + tille_f + $cbb8114b66dd9fa5$var$css_ratio_from(20);
            if (i > 0) this.total_tile_height += this.tiles_full_hights[i];
        }
        this.total_tile_height += $cbb8114b66dd9fa5$var$css_ratio_from(120) * (this.tiles.length - 1); // gab between tiles
        this.total_open_tile_height = this.total_tile_height;
        this.total_tile_height += $cbb8114b66dd9fa5$var$css_ratio_from(40); // padding bottom
        this.total_tile_height += document.getElementById("bike-scroller").clientHeight;
        document.getElementById("tile-scroller").style.height = `${this.total_tile_height}px`;
        document.getElementById("scroller").style.height = `${this.total_tile_height}px`;
        let bike_height = 0;
        if (width / height < $cbb8114b66dd9fa5$var$WIDTH_HEIGHT.width / $cbb8114b66dd9fa5$var$WIDTH_HEIGHT.height) bike_height = $cbb8114b66dd9fa5$var$css_ratio_from(400);
        else bike_height = height * 0.35;
        if (this.resposive_vertical) this.tile_margin_top = 0;
        else this.tile_margin_top = Math.max(height / 2.5 - $cbb8114b66dd9fa5$var$css_ratio_from(40) - bike_height, 0);
    }
    resize(width, height) {
        if (width <= 600) {
            if (this.resposive_vertical !== true) this.resposive_vertical_changed = true;
            this.resposive_vertical = true;
        } else {
            if (this.resposive_vertical !== false) this.resposive_vertical_changed = true;
            this.resposive_vertical = false;
        }
        if (this.resposive_vertical_changed) {
            if (this.resposive_vertical) {
                this.bike.position.set(0, 0.23, -0.05);
                this.bike.scale.set(1.2, 1.2, 1.2);
                this.compute_geometry(this.bike);
            } else {
                this.bike.position.set(0, 0.4, 0.15);
                this.bike.scale.set(0.9, 0.9, 0.9);
                this.compute_geometry(this.bike);
            }
            this.resposive_vertical_changed = false;
        }
        $cbb8114b66dd9fa5$var$map.setResponsiveVertical(this.resposive_vertical);
        width = $cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$MAX_WIDTH_PX);
        this.width = width;
        this.height = height;
        this.resize_3D_scene(width, height);
        this.forced_update = true;
        this.compute_tile_heights(width, height);
        this.resize_video_track_player();
    }
    // |====================================================================================================================
    // | 
    // |====================================================================================================================
    scene_coord_to_screen(pos) {
        let vector = pos.clone();
        vector.project(this.view);
        let x = (vector.x + 1) / 2 * $cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$MAX_WIDTH_PX);
        let y = (-vector.y + 1) / 2 * this.height;
        return new $4a792688e08e5cd7$export$c977b3e384af9ae1(x, y);
    }
    compute_t(start, duration) {
        let t = 0;
        if (this.t >= start && this.t < start + duration) t = (this.t - start) / duration;
        else if (this.t >= start + duration) t = 1;
        return t;
    }
    animation_need_update(start, duration, id) {
        if (this.forced_update) return true;
        if (this.last_t < start && this.t > start + duration) return true;
        if (this.last_t > start + duration && this.t < start) return true;
        if (this.t < start || this.t > start + duration) {
            if (this.anime_ids[id]) return false;
            this.anime_ids[id] = true;
        } else this.anime_ids[id] = false;
        return true;
    }
    render_bike(parts, t, origin) {
        if (origin == undefined) origin = new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0, 0);
        if (parts.children.length > 0) {
            if (t <= 0) {
                if (parts.name == "Back" || parts.name == "Front") parts.rotation.x -= 1 / 60;
                if (parts.name == "Cranck") parts.rotation.x -= 4 / 60;
                if (parts.name == "LeftPedal" || parts.name == "RightPedal") parts.rotation.x += 4 / 60;
            } else if (parts.name == "Back" || parts.name == "Front" || parts.name == "Cranck" || parts.name == "LeftPedal" || parts.name == "RightPedal") parts.rotation.x = 0;
            for(let i = 0; i < parts.children.length; i++)this.render_bike(parts.children[i], t, origin.clone().add(parts.position));
        } else if (parts.children.length == 0) {
            let part = parts;
            if (part.geometry) {
                let vx = this.bike_obj_pos[part.uuid].x;
                let vy = this.bike_obj_pos[part.uuid].y;
                let vz = this.bike_obj_pos[part.uuid].z;
                let l = Math.sqrt(vx * vx + vy * vy + vz * vz);
                vx /= l;
                vy /= l;
                vz /= l;
                let v = new $4a792688e08e5cd7$export$64b5c384219d3699(vx, vy, vz).multiplyScalar(1.0);
                // when t = this.bike_obj_times[part.uuid] -> t_before = 0
                // when t = 1.0 -> t_before = 1.0
                let t_before = Math.min(Math.max((t - this.bike_obj_times[part.uuid]) / (1.0 - this.bike_obj_times[part.uuid]), 0), 1);
                // ease t using easeOut Cubic
                let t_easing = 1 - Math.pow(1 - t_before, 1.3);
                part.position.x = this.bike_obj_pos[part.uuid].x + (v.x + this.bike_obj_start_pos[part.uuid].x) * t_easing - origin.x;
                part.position.y = this.bike_obj_pos[part.uuid].y + (v.y + this.bike_obj_start_pos[part.uuid].y) * t_easing - origin.y;
                part.position.z = this.bike_obj_pos[part.uuid].z + (v.z + this.bike_obj_start_pos[part.uuid].z) * t_easing - origin.z;
            // part.rotation.x += 1;
            }
        }
    }
    update_header() {
        if (!this.animation_need_update(-0.3, 0.3, "update_header")) return;
        let t = this.compute_t(-0.3, 0.3);
        let blur = 20 * (1 - t);
        let transparency = t;
        this.header.style.backdropFilter = `blur(${blur}px)`;
        this.header.style.backgroundColor = `rgba(41, 41, 41, ${transparency})`;
    }
    update_bike_assembly() {
        // if (!this.animation_need_update(-0.3, 0.5, "update_bike_assembly")) return;
        this.render_bike(this.bike, 1 - this.compute_t(-0.2, 0.7));
    }
    update_bike_rotation() {
        if (!this.animation_need_update(0, 0.3, "update_bike_rotation")) return;
        this.bike.rotation.y = this.compute_t(0, 0.3) * Math.PI * 1.3;
        this.bike.updateMatrixWorld();
    }
    open_line_paths(start, duration) {
        if (!this.animation_need_update(start, duration, "open_line_paths")) return;
        this.update_line_paths(start, duration);
    }
    update_line_paths(start, duration) {
        let svg_box = this.svg.getBoundingClientRect();
        let scale = parseFloat(this.svg.getAttribute("scale"));
        // set polylines path
        let bike_coords = [
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0.57, -0.4),
            new $4a792688e08e5cd7$export$64b5c384219d3699(0, 0., 0.2),
            new $4a792688e08e5cd7$export$64b5c384219d3699(-0, 0.15, 0.8)
        ];
        // transform bike coords to scene coords according to bike transform        
        for(let i = 0; i < bike_coords.length; i++)bike_coords[i].applyMatrix4(this.bike.matrixWorld);
        let line_t = this.compute_t(start, duration);
        let shift_x = (window.innerWidth - $cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$MAX_WIDTH_PX)) / 2;
        for(let i = 1; i < this.tiles.length; i++){
            let tile = this.tiles[i];
            let box = tile.getBoundingClientRect();
            let polyline = this.svg.children[i];
            let points = "";
            let start = new $4a792688e08e5cd7$export$c977b3e384af9ae1(box.left - shift_x, box.top + box.height / 2 - svg_box.top);
            if (this.resposive_vertical) {
                if (i == this.tiles.length - 1) start = new $4a792688e08e5cd7$export$c977b3e384af9ae1(box.left - shift_x + box.width / 1.3, box.top - svg_box.top);
                else if (i == 2) start = new $4a792688e08e5cd7$export$c977b3e384af9ae1(box.left - shift_x + box.width / 2, box.bottom - svg_box.top);
                else start = new $4a792688e08e5cd7$export$c977b3e384af9ae1(box.left - shift_x + $cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$TILE_HEIGHT_RESPONSIVE_VERTICAL) / 2, box.bottom - svg_box.top);
            }
            let end = this.scene_coord_to_screen(bike_coords[i - 1]);
            let mid = new $4a792688e08e5cd7$export$c977b3e384af9ae1(end.x + (end.y - start.y), end.y - (end.y - start.y));
            if (mid.x > start.x) mid = new $4a792688e08e5cd7$export$c977b3e384af9ae1(end.x, end.y + (start.y - end.y) - (end.x - start.x));
            if (mid.x < end.x) mid = new $4a792688e08e5cd7$export$c977b3e384af9ae1(end.x - (end.y - start.y), end.y - (end.y - start.y));
            if (mid.y < start.y) mid = new $4a792688e08e5cd7$export$c977b3e384af9ae1(start.x, end.y - (end.x - start.x));
            let lenght_a = start.distanceTo(mid);
            let lenght_b = mid.distanceTo(end);
            let lenght = lenght_a + lenght_b;
            let current_length = lenght * line_t;
            if (current_length < lenght_a) {
                let A = start;
                let B = new $4a792688e08e5cd7$export$c977b3e384af9ae1((mid.x - start.x) * (current_length / lenght_a) + start.x, (mid.y - start.y) * (current_length / lenght_a) + start.y);
                points += `${A.x},${A.y} `;
                points += `${B.x},${B.y} `;
            } else {
                let A = start;
                let B = mid;
                let C = new $4a792688e08e5cd7$export$c977b3e384af9ae1((end.x - mid.x) * ((current_length - lenght_a) / lenght_b) + mid.x, (end.y - mid.y) * ((current_length - lenght_a) / lenght_b) + mid.y);
                points += `${A.x},${A.y} `;
                points += `${B.x},${B.y} `;
                points += `${C.x},${C.y} `;
            }
            polyline.setAttribute("points", points);
            // set width
            polyline.setAttribute("stroke-width", `${3 * scale}`);
        }
    }
    update_line_paths_opacity(start, duration) {
        if (!this.animation_need_update(start, duration, "update_line_paths_opacity")) return;
        let t = this.compute_t(start, duration);
        this.svg.style.opacity = `${1 - t}`;
    }
    update_opacity(el, start, duration, id = "update_opacity", reverse = false) {
        if (!this.animation_need_update(start, duration, id)) return;
        let t = this.compute_t(start, duration);
        if (reverse) t = 1 - t;
        el.style.opacity = `${t}`;
    }
    update_tile_desc(tile_i, open_t, close_t, duration) {
        if (!this.animation_need_update(open_t, close_t - open_t + duration, `update_tile_desc_${tile_i}`)) return;
        let tile = this.tiles[tile_i];
        let ul = tile.querySelector(".tile-desc").getElementsByTagName("li");
        let li_d = duration / ul.length;
        let height_small;
        if (this.resposive_vertical) height_small = $cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$TILE_HEIGHT_RESPONSIVE_VERTICAL);
        else height_small = $cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$TILE_HEIGHT);
        let height_large = this.tiles_desc_hights[tile_i];
        if (this.t < close_t) {
            let t = this.compute_t(open_t, duration);
            let height = height_small + (height_large - height_small) * t;
            if (this.t < 1.7) tile.style.height = `${height}px`;
            for(let i = 0; i < ul.length; i++){
                let li = ul[i];
                t = this.compute_t(open_t + duration + li_d * i, li_d);
                li.style.opacity = `${t}`;
            }
        } else {
            let t = this.compute_t(close_t, duration);
            let height = height_large + (height_small - height_large) * t;
            if (this.t < 1.7) tile.style.height = `${height}px`;
            for(let i = 0; i < ul.length; i++){
                let li = ul[i];
                t = this.compute_t(close_t + li_d * (ul.length - 1) - li_d * i, li_d);
                li.style.opacity = `${1 - t}`;
            }
        }
        this.update_line_paths(0.1, 0.2);
    }
    open_tile(tile_i, open_t, duration) {
        if (!this.animation_need_update(open_t, duration, `open_tile_${tile_i}`)) return;
        let tile = this.tiles[tile_i];
        let height_small, width_small;
        if (this.resposive_vertical) {
            height_small = $cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$TILE_HEIGHT_RESPONSIVE_VERTICAL);
            width_small = $cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$MAX_WIDTH_PX * $cbb8114b66dd9fa5$var$TILE_WIDTH_RESPONSIVE_VERTICAL);
        } else {
            height_small = $cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$TILE_HEIGHT);
            width_small = $cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$TILE_WIDTH);
        }
        let height_large = this.tiles_full_hights[tile_i];
        let width_large = $cbb8114b66dd9fa5$var$css_ratio_from($cbb8114b66dd9fa5$var$MAX_WIDTH_PX * 0.9285) + $cbb8114b66dd9fa5$var$css_ratio_from(20); // (1400-80-20)/1400
        // opening
        if (this.t <= open_t) {
            tile.getElementsByClassName("tile-desc")[0].style.display = "block";
            tile.getElementsByClassName("tile-content")[0].style.opacity = "0";
            tile.style.width = `${width_small}px`;
            if (tile_i == 1) tile.style.marginTop = this.tile_margin_top + "px";
        } else {
            tile.getElementsByClassName("tile-desc")[0].style.display = "none";
            tile.getElementsByClassName("tile-content")[0].style.opacity = "1";
        }
        let t = this.compute_t(open_t, duration);
        let height = height_small + (height_large - height_small) * t;
        let width = width_small + (width_large - width_small) * t;
        tile.style.height = `${height}px`;
        tile.style.width = `${width}px`;
        // margin top
        if (tile_i == 1) {
            let target_margin_top = window.innerHeight * 0.4 - $cbb8114b66dd9fa5$var$css_ratio_from(40);
            let margin_top = (target_margin_top - this.tile_margin_top) * t + this.tile_margin_top;
            tile.style.marginTop = `${margin_top}px`;
        }
        this.update_line_paths(0.1, 0.2);
    }
    open_tile_gap(open_t, duration) {
        if (!this.animation_need_update(open_t, duration, "open_tile_gap")) return;
        let el = document.getElementById("tiles-container");
        let t = this.compute_t(open_t, duration);
        let gap = $cbb8114b66dd9fa5$var$css_ratio_from(20) + ($cbb8114b66dd9fa5$var$css_ratio_from(120) - $cbb8114b66dd9fa5$var$css_ratio_from(20)) * t;
        el.style.gap = `${gap}px`;
    }
    update() {
        if (this.scroll_target !== undefined) {
            let next_scroll = this.scroll_target * 0.15 + window.scrollY * 0.85;
            if (Math.abs(next_scroll - window.scrollY) > 1.0) window.scrollTo(0, next_scroll);
            else this.scroll_target = undefined;
        }
        this.update_bike_assembly();
        if (this.t === undefined) {
            this.t = this.t_target;
            this.last_t = this.t;
        } else {
            let next_t = this.t * 0.85 + this.t_target * 0.15;
            if (Math.abs(next_t - this.t) > 0.001) {
                this.last_t = this.t;
                this.t = next_t;
            } else if (!this.forced_update) return;
        }
        this.update_header();
        this.update_bike_rotation();
        if (this.t < 0.5) this.update_opacity(this.tiles[0], 0.1, 0.2, "tile0Opa");
        else this.update_opacity(this.tiles[0], 0.8, 0.2, "tile0OpaR", true);
        this.open_tile(1, 1.7, 0.2);
        this.open_tile(2, 1.8, 0.2);
        this.open_tile(3, 1.9, 0.2);
        this.update_tile_desc(0, 0.2, 0.8, 0.05);
        this.update_tile_desc(1, 0.5, 0.8, 0.05);
        this.update_tile_desc(2, 0.9, 1.2, 0.05);
        this.update_tile_desc(3, 1.3, 1.6, 0.05);
        this.open_tile_gap(1.7, 0.4);
        this.open_line_paths(0.1, 0.2);
        this.update_line_paths_opacity(1.6, 0.2);
        for(let i = 0; i < this.go_to_tiles_btns.length; i++)this.update_opacity(this.go_to_tiles_btns[i], 1.6, 0.2, `go_to_tiles_btns_${i}`, true);
        this.forced_update = false;
    }
    update_scroll(e = null) {
        if (this.scroll_target != undefined) {
            let vy = window.scrollY - this.last_scroll;
            let way = this.scroll_target - window.scrollY;
            console.log(this.last_scroll, window.scrollY, vy, way);
            if (vy > 0 != way > 0) this.scroll_target = undefined;
        }
        let rect = document.getElementById("scroller").getBoundingClientRect();
        let y = -rect.top;
        this.t_target = y / window.innerHeight;
        this.last_scroll = window.scrollY;
        return this.t_target;
    }
    compute_scroll_t(px) {
        // let rect = document.getElementById("scroller").getBoundingClientRect();
        // let top = -rect.top;
        let t = (px - window.innerHeight) / window.innerHeight;
        return t;
    }
    compute_scroll_px(t) {
        let px = (t + 1) * window.innerHeight;
        let margin = 0;
        if (this.resposive_vertical) margin = $cbb8114b66dd9fa5$var$css_ratio_from(240);
        else margin = $cbb8114b66dd9fa5$var$css_ratio_from(40); // TODO
        let page_start = this.total_tile_height - this.total_open_tile_height + window.innerHeight - margin;
        if (t >= 1) {
            const gap = $cbb8114b66dd9fa5$var$css_ratio_from(120);
            px = this.total_tile_height - this.total_open_tile_height + window.innerHeight - gap - margin;
            for(let i = 0; i < t; i++)px += this.tiles_full_hights[i] + gap;
        }
        let max_scroll = document.body.scrollHeight - window.innerHeight;
        if (px > max_scroll) px = max_scroll;
        return px;
    }
    emulate_scroll(t) {
        setTimeout(()=>{
            this.scroll_target = this.compute_scroll_px(t);
        }, 100);
    }
    async toggle_track_video(e, id) {
        let container = document.getElementById("tracks-info");
        let width_from = 600;
        let width_to = 400;
        if (this.resposive_vertical) {
            width_from = 777;
            width_to = 777;
        }
        let data = $cbb8114b66dd9fa5$var$map_tracks[id];
        if (this.track_video_id !== undefined) {
            this.track_video_player.off("timeupdate");
            let stop = false;
            if (this.track_video_id === id || data === undefined || data.gpx === undefined) {
                stop = true;
                await $cbb8114b66dd9fa5$var$map.close_track(width_to, width_from, (t)=>{
                    t = 1 - t;
                    this.track_video_container.style.width = `${t * 100}%`;
                    if (t > 0.8) this.track_video_container.style.opacity = `${(t - 0.8) / 0.2}`;
                    this.resize_video_track_player();
                });
                $cbb8114b66dd9fa5$var$map.set_map_size(undefined);
                container.scrollTop = 0;
            } else {
                width_from = width_to;
                await $cbb8114b66dd9fa5$var$map.close_track(width_from, width_to, undefined, false);
            }
            document.getElementById("btn-" + this.track_video_id).innerText = "search";
            this.track_video_player.dispose();
            this.track_video_container.remove();
            this.track_video_player = undefined;
            this.track_video_player_el = undefined;
            this.track_video_container = undefined;
            this.track_video_id = undefined;
            if (stop) return;
        }
        if (data === undefined || data.gpx === undefined) return;
        e.target.innerText = "collapse_all";
        this.track_video_id = id;
        let el_before = document.getElementById("track-" + id);
        this.track_video_container = document.createElement("div");
        this.track_video_container.setAttribute("class", "video-container");
        this.track_video_container.style.opacity = "0";
        el_before.parentNode.insertBefore(this.track_video_container, el_before.nextSibling);
        this.track_video_player_el = document.createElement("video-js");
        this.track_video_player_el.setAttribute("class", "track-vid");
        this.track_video_container.appendChild(this.track_video_player_el);
        // add play button overlay
        let play_button = document.createElement("span");
        play_button.setAttribute("class", "video-play-button material-symbols-outlined");
        play_button.innerText = "play_arrow";
        let options = {
            controls: false,
            autoplay: false,
            preload: "auto",
            techOrder: [
                "youtube"
            ],
            muted: true,
            sources: [
                {
                    type: "video/youtube",
                    src: data.url
                }
            ],
            "youtube": {
                "ytControls": 1,
                "iv_load_policy": 3,
                "playsinline": 1
            }
        };
        this.track_video_player = (0, $hqDLR.default)(this.track_video_player_el, options);
        let ended = false;
        let first_update_after_ended = true;
        // play video when ready
        this.track_video_player.ready(()=>{
            this.resize_video_track_player();
            this.track_video_player.on("timeupdate", ()=>{
                let t = this.track_video_player.currentTime();
                let gpx_t = t + $cbb8114b66dd9fa5$var$map_tracks[id].timestamp;
                if (ended) {
                    if (first_update_after_ended) {
                        // go back to start of track and stop
                        $cbb8114b66dd9fa5$var$map.view_full_track(id);
                        first_update_after_ended = false;
                    }
                } else $cbb8114b66dd9fa5$var$map.update_position_on_track(id, gpx_t);
            });
            // on pause view_full_track
            this.track_video_player.on("pause", ()=>{
                play_button.style.display = "block";
                $cbb8114b66dd9fa5$var$map.view_full_track(id);
            });
            this.track_video_player.on("play", ()=>{
                play_button.style.display = "none";
                first_update_after_ended = true;
                ended = false;
            });
            this.track_video_player.on("ended", ()=>{
                ended = true;
            });
            this.track_video_container.appendChild(play_button);
            play_button.addEventListener("click", ()=>{
                this.track_video_player.play();
                play_button.style.display = "none";
            });
        });
        $cbb8114b66dd9fa5$var$map.open_track(id, width_from, width_to, (t)=>{
            this.track_video_container.style.width = `${t * 100}%`;
            if (t > 0.8) this.track_video_container.style.opacity = `${(t - 0.8) / 0.2}`;
            this.resize_video_track_player();
        });
        // scroll to tile
        container.scrollTop = el_before.offsetTop - container.offsetTop - $cbb8114b66dd9fa5$var$css_ratio_from(10);
    }
    resize_video_track_player() {
        if (this.track_video_id === undefined) return;
        let container_width = this.track_video_container.offsetWidth;
        let content_width = this.track_video_player_el.offsetWidth;
        let scale = container_width / content_width;
        this.track_video_container.style.height = `${scale * 720}px`;
        this.track_video_player_el.style.transform = `scale(${scale})`;
    }
    constructor(){
        this.resposive_vertical_changed = false;
        this.resposive_vertical = undefined;
        this.bike = undefined;
        this.bike_obj_pos = {};
        this.bike_obj_start_pos = {};
        this.bike_obj_times = {};
        this.t = undefined;
        this.last_t = undefined;
        this.t_target = 0;
        this.scroll_target = undefined;
        this.last_scroll = undefined;
        this.tile_margin_top = 0;
        this.tiles_desc_hights = [];
        this.tiles_full_hights = [];
        this.forced_update = false;
        this.total_tile_height = 0;
        this.total_open_tile_height = 0;
        this.track_video_id = undefined;
        this.track_video_player = undefined;
        this.track_video_player_el = undefined;
        this.track_video_container = undefined;
        this.anime_ids = {};
    }
}
class $cbb8114b66dd9fa5$var$GPX {
    constructor(gpx_data){
        this.path = [];
        this.times = [];
        this.box = [
            180,
            90,
            -180,
            -90
        ]; // minx, miny, maxx, maxy
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(gpx_data, "text/xml");
        let trkpts = xmlDoc.getElementsByTagName("trkpt");
        for(let i = 0; i < trkpts.length; i++){
            let lat = parseFloat(trkpts[i].getAttribute("lat"));
            let lon = parseFloat(trkpts[i].getAttribute("lon"));
            let t = trkpts[i].getElementsByTagName("time")[0];
            this.path.push([
                lon,
                lat
            ]);
            this.times.push(new Date(t.getHTML()).getTime() / 1000);
            if (lon < this.box[0]) this.box[0] = lon;
            if (lat < this.box[1]) this.box[1] = lat;
            if (lon > this.box[2]) this.box[2] = lon;
            if (lat > this.box[3]) this.box[3] = lat;
        }
    }
    get_path() {
        return this.path;
    }
    get(i) {
        if (i < 0) i = this.path.length + i;
        return this.path[i];
    }
    get_position(t) {
        // find i before and after t
        // interpolate between
        let bi = 0;
        while(bi < this.times.length - 1 && this.times[bi + 1] < t)bi++;
        if (bi >= this.times.length - 1) return this.get(-1);
        let ai = bi + 1;
        let dt = this.times[ai] - this.times[bi];
        let ft = (t - this.times[bi]) / dt;
        let lon = this.path[bi][0] + (this.path[ai][0] - this.path[bi][0]) * ft;
        let lat = this.path[bi][1] + (this.path[ai][1] - this.path[bi][1]) * ft;
        return [
            lon,
            lat
        ];
    }
    static bearing_between(lon1, lat1, lon2, lat2) {
        let y = Math.sin($cbb8114b66dd9fa5$var$toRadians(lon2 - lon1)) * Math.cos($cbb8114b66dd9fa5$var$toRadians(lat2));
        let x = Math.cos($cbb8114b66dd9fa5$var$toRadians(lat1)) * Math.sin($cbb8114b66dd9fa5$var$toRadians(lat2)) - Math.sin($cbb8114b66dd9fa5$var$toRadians(lat1)) * Math.cos($cbb8114b66dd9fa5$var$toRadians(lat2)) * Math.cos($cbb8114b66dd9fa5$var$toRadians(lon2 - lon1));
        let bearing = $cbb8114b66dd9fa5$var$toDegrees(Math.atan2(y, x));
        return bearing;
    }
    static bearing_interpolate(bearing1, bearing2, ft) {
        let diff = bearing2 - bearing1;
        if (diff > 180) diff -= 360;
        if (diff < -180) diff += 360;
        let bearing = bearing1 + diff * ft;
        return (bearing + 360) % 360;
    }
    get_bearing(t) {
        // find i before and after t
        // interpolate between
        let bi = 0;
        while(bi < this.times.length - 1 && this.times[bi + 1] < t)bi++;
        if (bi >= this.times.length - 1) bi = this.times.length - 2;
        let ai = bi + 1;
        let lon1 = this.path[bi][0];
        let lat1 = this.path[bi][1];
        let lon2 = this.path[ai][0];
        let lat2 = this.path[ai][1];
        let bearing1 = $cbb8114b66dd9fa5$var$GPX.bearing_between(lon1, lat1, lon2, lat2);
        if (ai < this.times.length - 1) {
            let lat3 = this.path[ai + 1][1];
            let lon3 = this.path[ai + 1][0];
            let bearing2 = $cbb8114b66dd9fa5$var$GPX.bearing_between(lon2, lat2, lon3, lat3);
            let dt = this.times[ai] - this.times[bi];
            let ft = (t - this.times[bi]) / dt;
            // interpolate bearing
            return $cbb8114b66dd9fa5$var$GPX.bearing_interpolate(bearing1, bearing2, ft);
        }
        return bearing1;
    }
    get_clicked_point(lat, lon, zoom) {
        const R = 360;
        const R_Z = R / Math.pow(2, zoom);
        let closest_i = -1;
        let closest_d = Infinity;
        for(let i = 0; i < this.path.length; i++){
            let d = $cbb8114b66dd9fa5$var$distance(lat, lon, this.path[i][1], this.path[i][0]);
            if (d < closest_d) {
                closest_d = d;
                closest_i = i;
            }
        }
        if (closest_d < R_Z) return closest_i;
        return -1;
    }
    get_nearest_line(lat, lon) {
        let closest_i = -1;
        let closest_d = Infinity;
        for(let i = 0; i < this.path.length - 1; i++){
            let d = $cbb8114b66dd9fa5$var$distance(lat, lon, this.path[i][1], this.path[i][0]);
            if (d < closest_d) {
                closest_d = d;
                closest_i = i;
            }
        }
        let sibling_i = undefined;
        if (closest_i == this.path.length - 1) {
            sibling_i = closest_i - 1;
            let sibling_d = $cbb8114b66dd9fa5$var$distance(lat, lon, this.path[sibling_i][1], this.path[sibling_i][0]);
            let d = $cbb8114b66dd9fa5$var$distance(this.path[closest_i][1], this.path[closest_i][0], this.path[sibling_i][1], this.path[sibling_i][0]);
            if (sibling_d > d) return this.path.length;
            return this.path.length - 1;
        } else if (closest_i == 0) {
            sibling_i = closest_i + 1;
            let sibling_d = $cbb8114b66dd9fa5$var$distance(lat, lon, this.path[sibling_i][1], this.path[sibling_i][0]);
            let d = $cbb8114b66dd9fa5$var$distance(this.path[closest_i][1], this.path[closest_i][0], this.path[sibling_i][1], this.path[sibling_i][0]);
            if (sibling_d > d) return 0;
            return 1;
        }
        let d_prev = $cbb8114b66dd9fa5$var$distance(lat, lon, this.path[closest_i - 1][1], this.path[closest_i - 1][0]);
        let d_next = $cbb8114b66dd9fa5$var$distance(lat, lon, this.path[closest_i + 1][1], this.path[closest_i + 1][0]);
        if (d_prev < d_next) return closest_i;
        return closest_i + 1;
    }
    move_pts(i, lat, lon) {
        this.path[i] = [
            lon,
            lat
        ];
    }
    delete_pts(i) {
        this.path.splice(i, 1);
        this.times.splice(i, 1);
    }
    insert_pts(i, lat, lon) {
        // interpolate time
        let t = 0;
        if (i == 0) t = this.times[0] - 1;
        else if (i >= this.times.length) t = this.times[this.times.length - 1] + 1;
        else {
            let t0 = this.times[i - 1];
            let t1 = this.times[i];
            let d0 = $cbb8114b66dd9fa5$var$distance(lat, lon, this.path[i - 1][1], this.path[i - 1][0]);
            let d1 = $cbb8114b66dd9fa5$var$distance(lat, lon, this.path[i][1], this.path[i][0]);
            let ft = d0 / (d0 + d1);
            t = t0 + (t1 - t0) * ft;
        }
        this.path.splice(i, 0, [
            lon,
            lat
        ]);
        this.times.splice(i, 0, t);
    }
    download(name) {
        let gpx = `<?xml version="1.0" encoding="UTF-8" standalone="no" ?>
<gpx version="1.1" creator="Map Manager" xmlns="http://www.topografix.com/GPX/1/1" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd">
<trk>
<trkseg>
`;
        for(let i = 0; i < this.path.length; i++){
            let date = new Date(this.times[i] * 1000);
            let iso_date = date.toISOString();
            gpx += `<trkpt lat="${this.path[i][1]}" lon="${this.path[i][0]}">
<time>${iso_date}</time>
</trkpt>
`;
        }
        gpx += `</trkseg>
</trk>
</gpx>`;
        // download gpx file
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(gpx));
        element.setAttribute('download', `${name}.gpx`);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
}
class $cbb8114b66dd9fa5$var$MapManager {
    init(id, center, zoom, disable_interactions = false) {
        this.default_center_zoom = [
            center[0],
            center[1],
            zoom
        ];
        this.map_element = document.getElementById(id);
        this.map = new (0, $0a06c4d6833722ed$exports.Map)({
            container: id,
            style: $8d436ee8e3121a92$exports,
            center: center,
            zoom: zoom
        });
        // add event listeners for click pressed, released and move
        this.map.on('mousedown', (e)=>{
            this.mouse_down(e);
        });
        this.map.on('mouseup', (e)=>{
            this.mouse_up(e);
        });
        this.map.on('mousemove', (e)=>{
            this.mouse_move(e);
        });
        if (disable_interactions && !this.edit_gpx) {
            this.map.scrollZoom.disable();
            this.map.boxZoom.disable();
            this.map.dragRotate.disable();
            this.map.dragPan.disable();
            this.map.keyboard.disable();
            this.map.doubleClickZoom.disable();
            this.map.touchZoomRotate.disable();
        }
        // this.map.on('moveend', () => {
        //     console.log(this.map.getCenter(), this.map.getZoom(), this.map.getBearing());
        // });
        // create new layer
        this.map.on('load', async ()=>{
            if (id == "map") {
                for (let [key, value] of Object.entries($cbb8114b66dd9fa5$var$map_tracks))if (value.gpx) {
                    let gpx_content = await (await fetch(value.gpx)).text();
                    let gpx = this.add_layer(`${key}_route`, value.color, gpx_content);
                    this.add_dot_layer(`${key}_dot`, value.color);
                    this.tracks[key] = gpx;
                }
            } else {
                let examples_GPX = await (await fetch($7127cc635fef0ed6$exports)).text();
                this.add_layer("example_route", "rgb(52, 152, 219)", examples_GPX);
            }
        });
    }
    add_layer(name, color, gpx_content) {
        let gpx = new $cbb8114b66dd9fa5$var$GPX(gpx_content);
        this.map.addLayer({
            'id': name,
            'type': 'line',
            'source': {
                'type': 'geojson',
                'data': {
                    'type': 'Feature',
                    'properties': {},
                    'geometry': {
                        'type': 'LineString',
                        'coordinates': gpx.get_path()
                    }
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round'
            },
            'paint': {
                'line-color': color,
                'line-width': 4
            }
        });
        return gpx;
    }
    update_layer(name, gpx) {
        let source = this.map.getSource(name);
        source.setData({
            'type': 'Feature',
            'properties': {},
            'geometry': {
                'type': 'LineString',
                'coordinates': gpx.get_path()
            }
        });
    }
    add_dot_layer(name, color) {
        // add a circle layer that stay the same size when zooming
        // middle of the circle is white
        // outer of the circle is color
        this.map.addLayer({
            'id': name,
            'type': 'circle',
            'source': {
                'type': 'geojson',
                'data': {
                    'type': 'FeatureCollection',
                    'features': []
                }
            },
            'paint': {
                'circle-radius': 6,
                'circle-color': color,
                'circle-stroke-color': '#ffffff',
                'circle-stroke-width': 2
            }
        });
    }
    add_edit_gpx_layer(name, color, gpx) {
        // layer of dots with the path color
        this.map.addLayer({
            'id': name,
            'type': 'circle',
            'source': {
                'type': 'geojson',
                'data': {
                    'type': 'Feature',
                    'properties': {},
                    'geometry': {
                        'type': 'MultiPoint',
                        'coordinates': gpx.get_path()
                    }
                }
            },
            'paint': {
                'circle-radius': 6,
                'circle-color': color,
                'circle-stroke-color': '#ffffff',
                'circle-stroke-width': 1
            }
        });
        return gpx;
    }
    update_edit_gpx_layer(name, gpx) {
        let source = this.map.getSource(name);
        source.setData({
            'type': 'Feature',
            'properties': {},
            'geometry': {
                'type': 'MultiPoint',
                'coordinates': gpx.get_path()
            }
        });
    }
    set_dot_position(name, position) {
        let source = this.map.getSource(name);
        source.setData({
            'type': 'FeatureCollection',
            'features': [
                {
                    'type': 'Feature',
                    'properties': {},
                    'geometry': {
                        'type': 'Point',
                        'coordinates': position
                    }
                }
            ]
        });
    }
    remove_dot(name) {
        let source = this.map.getSource(name);
        source.setData({
            'type': 'FeatureCollection',
            'features': []
        });
    }
    easeTo(start_center, start_zoom, start_bearing = 0, center, zoom, bearing = 0, t) {
        this.map.jumpTo({
            center: {
                lng: start_center[0] + (center[0] - start_center[0]) * t,
                lat: start_center[1] + (center[1] - start_center[1]) * t
            },
            zoom: start_zoom + (zoom - start_zoom) * t,
            bearing: $cbb8114b66dd9fa5$var$GPX.bearing_interpolate(start_bearing, bearing, t)
        });
    }
    open_animate(duration, from_px, to_px, center, zoom, bearing = 0, on_frame) {
        let start_center = [
            this.map.getCenter().lng,
            this.map.getCenter().lat
        ];
        let start_zoom = this.map.getZoom();
        let start_bearing = this.map.getBearing();
        let promise = new Promise((resolve, reject)=>{
            let interval = undefined;
            let t = 0;
            interval = setInterval(()=>{
                t += 1000 / 30 / duration;
                if (t >= 1) {
                    t = 1;
                    this.easeTo(start_center, start_zoom, start_bearing, center, zoom, bearing, t);
                    if (from_px != to_px) this.set_map_size(from_px + (to_px - from_px) * t);
                    clearInterval(interval);
                    resolve();
                } else {
                    this.easeTo(start_center, start_zoom, start_bearing, center, zoom, bearing, t);
                    if (from_px != to_px) this.set_map_size(from_px + (to_px - from_px) * t);
                }
                if (on_frame) on_frame(t);
            }, 1000 / 30);
        });
        return promise;
    }
    open_track(id, width_from, width_to, on_frame) {
        // fit bound with padding
        this.opened_track = id;
        let v = $cbb8114b66dd9fa5$var$map_tracks[id].view;
        if (this.resposive_vertical) v = $cbb8114b66dd9fa5$var$map_tracks[id].view_responsive_vertical;
        this.open_animate(500, width_from, width_to, v.center, v.zoom, v.bearing, on_frame);
        // set line and dot layer on top
        this.map.moveLayer(`${id}_route`);
        this.map.moveLayer(`${id}_dot`);
        // increase route line width
        this.map.setPaintProperty(`${id}_route`, 'line-width', 5);
        if (this.edit_gpx) this.add_edit_gpx_layer(`${id}_edit`, $cbb8114b66dd9fa5$var$map_tracks[id].color, this.tracks[id]);
    }
    close_track(width_from = 400, width_to = 400, on_frame, recenter = true) {
        let promise;
        // if (width_from != width_to){
        if (recenter) promise = this.open_animate(500, width_from, width_to, [
            this.default_center_zoom[0],
            this.default_center_zoom[1]
        ], this.default_center_zoom[2], 0, on_frame);
        else promise = new Promise((resolve, reject)=>{
            resolve();
        });
        // remove edit layer if exists
        if (this.edit_gpx) {
            let layers = this.map.getStyle().layers;
            for(let i = 0; i < layers.length; i++)if (layers[i].id.endsWith("_edit")) {
                this.map.removeLayer(layers[i].id);
                this.map.removeSource(layers[i].id);
            }
        }
        // remove dot
        this.remove_dot(`${this.opened_track}_dot`);
        // reset line width
        this.map.setPaintProperty(`${this.opened_track}_route`, 'line-width', 4);
        this.opened_track = undefined;
        this.t_on_track = undefined;
        return promise;
    }
    update_position_on_track(id, t) {
        if (t != undefined) this.t_on_track = t;
        let gpx = this.tracks[id];
        if (gpx === undefined) return;
        let position = gpx.get_position(this.t_on_track);
        let bearing = gpx.get_bearing(this.t_on_track);
        this.set_dot_position(`${id}_dot`, position);
        if (!this.edit_gpx) this.map.easeTo({
            center: position,
            zoom: $cbb8114b66dd9fa5$var$map_tracks[id].view.zoom_follow,
            bearing: bearing,
            duration: 1000,
            easing: function(t) {
                return t;
            }
        });
    }
    view_full_track(id) {
        if (!this.edit_gpx) {
            let v = $cbb8114b66dd9fa5$var$map_tracks[id].view;
            if (this.resposive_vertical) v = $cbb8114b66dd9fa5$var$map_tracks[id].view_responsive_vertical;
            this.map.easeTo({
                ...v,
                duration: 1000,
                easing: function(t) {
                    return t;
                }
            });
        }
    }
    mouse_down(e) {
        if (!this.edit_gpx) return;
        let opened_gpx = this.tracks[this.opened_track];
        let i = opened_gpx.get_clicked_point(e.lngLat.lat, e.lngLat.lng, this.map.getZoom());
        if (i != -1) {
            if (e.originalEvent.button == 0) {
                this.edit_pts_i = i;
                e.preventDefault();
            } else if (e.originalEvent.button == 2) {
                opened_gpx.delete_pts(i);
                this.update_layer(`${this.opened_track}_route`, opened_gpx);
                this.update_edit_gpx_layer(`${this.opened_track}_edit`, opened_gpx);
                this.update_position_on_track(this.opened_track);
                e.preventDefault();
            }
        } else if (e.originalEvent.button == 2) {
            let insert_i = opened_gpx.get_nearest_line(e.lngLat.lat, e.lngLat.lng);
            opened_gpx.insert_pts(insert_i, e.lngLat.lat, e.lngLat.lng);
            this.update_layer(`${this.opened_track}_route`, opened_gpx);
            this.update_edit_gpx_layer(`${this.opened_track}_edit`, opened_gpx);
            this.update_position_on_track(this.opened_track);
        } else if (e.originalEvent.button == 1) opened_gpx.download(this.opened_track);
    }
    mouse_move(e) {
        if (this.edit_pts_i != -1) {
            // prevent map move
            e.preventDefault();
            this.tracks[this.opened_track].move_pts(this.edit_pts_i, e.lngLat.lat, e.lngLat.lng);
            this.update_layer(`${this.opened_track}_route`, this.tracks[this.opened_track]);
            this.update_edit_gpx_layer(`${this.opened_track}_edit`, this.tracks[this.opened_track]);
            this.update_position_on_track(this.opened_track);
        }
    }
    mouse_up(e) {
        this.edit_pts_i = -1;
    }
    set_map_size(w) {
        let parent = this.map_element.parentElement;
        if (w === undefined) {
            this.map_element.style.width = ``;
            this.map_element.style.scale = ``;
            parent.style.width = ``;
            $cbb8114b66dd9fa5$var$resize_map(this.map_element);
            return;
        }
        // set parent width 
        parent.style.width = `${$cbb8114b66dd9fa5$var$css_full_ratio_from(w)}`;
        let parent_width = parent.offsetWidth;
        let r = parent_width / parseFloat(w);
        this.map_element.style.width = `${w}px`;
        this.map_element.style.scale = `${Math.ceil(r * 1000) / 1000}`;
    }
    setResponsiveVertical(responsive) {
        this.resposive_vertical = responsive;
    }
    constructor(){
        this.tracks = {};
        this.opened_track = undefined;
        this.t_on_track = undefined;
        this.resposive_vertical = false;
        this.edit_gpx = false;
        this.edit_pts_i = -1;
    }
}


//# sourceMappingURL=H2R.2534bb01.js.map
